/******/ (function(modules) { // webpackBootstrap
/******/ 	// The module cache
/******/ 	var installedModules = {};
/******/
/******/ 	// The require function
/******/ 	function __webpack_require__(moduleId) {
/******/
/******/ 		// Check if module is in cache
/******/ 		if(installedModules[moduleId])
/******/ 			return installedModules[moduleId].exports;
/******/
/******/ 		// Create a new module (and put it into the cache)
/******/ 		var module = installedModules[moduleId] = {
/******/ 			exports: {},
/******/ 			id: moduleId,
/******/ 			loaded: false
/******/ 		};
/******/
/******/ 		// Execute the module function
/******/ 		modules[moduleId].call(module.exports, module, module.exports, __webpack_require__);
/******/
/******/ 		// Flag the module as loaded
/******/ 		module.loaded = true;
/******/
/******/ 		// Return the exports of the module
/******/ 		return module.exports;
/******/ 	}
/******/
/******/
/******/ 	// expose the modules object (__webpack_modules__)
/******/ 	__webpack_require__.m = modules;
/******/
/******/ 	// expose the module cache
/******/ 	__webpack_require__.c = installedModules;
/******/
/******/ 	// __webpack_public_path__
/******/ 	__webpack_require__.p = "/counting-for-dollars/";
/******/
/******/ 	// Load entry module and return exports
/******/ 	return __webpack_require__(0);
/******/ })
/************************************************************************/
/******/ ((function(modules) {
	// Check all modules for deduplicated modules
	for(var i in modules) {
		if(Object.prototype.hasOwnProperty.call(modules, i)) {
			switch(typeof modules[i]) {
			case "function": break;
			case "object":
				// Module can be created from a template
				modules[i] = (function(_m) {
					var args = _m.slice(1), fn = modules[_m[0]];
					return function (a,b,c) {
						fn.apply(this, [a,b,c].concat(args));
					};
				}(modules[i]));
				break;
			default:
				// Module is a copy of another module
				modules[i] = modules[modules[i]];
				break;
			}
		}
	}
	return modules;
}([
/* 0 */
/***/ function(module, exports, __webpack_require__) {

	__webpack_require__(555);
	module.exports = __webpack_require__(562);


/***/ },
/* 1 */
/***/ function(module, exports) {

	function _interopRequireDefault(obj) {
	  return obj && obj.__esModule ? obj : {
	    "default": obj
	  };
	}
	
	module.exports = _interopRequireDefault;

/***/ },
/* 2 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(597);
	} else {
	  module.exports = require('./cjs/react.development.js');
	}


/***/ },
/* 3 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(33);
	
	function _getRequireWildcardCache() {
	  if (typeof WeakMap !== "function") return null;
	  var cache = new WeakMap();
	
	  _getRequireWildcardCache = function _getRequireWildcardCache() {
	    return cache;
	  };
	
	  return cache;
	}
	
	function _interopRequireWildcard(obj) {
	  if (obj && obj.__esModule) {
	    return obj;
	  }
	
	  if (obj === null || _typeof(obj) !== "object" && typeof obj !== "function") {
	    return {
	      "default": obj
	    };
	  }
	
	  var cache = _getRequireWildcardCache();
	
	  if (cache && cache.has(obj)) {
	    return cache.get(obj);
	  }
	
	  var newObj = {};
	  var hasPropertyDescriptor = Object.defineProperty && Object.getOwnPropertyDescriptor;
	
	  for (var key in obj) {
	    if (Object.prototype.hasOwnProperty.call(obj, key)) {
	      var desc = hasPropertyDescriptor ? Object.getOwnPropertyDescriptor(obj, key) : null;
	
	      if (desc && (desc.get || desc.set)) {
	        Object.defineProperty(newObj, key, desc);
	      } else {
	        newObj[key] = obj[key];
	      }
	    }
	  }
	
	  newObj["default"] = obj;
	
	  if (cache) {
	    cache.set(obj, newObj);
	  }
	
	  return newObj;
	}
	
	module.exports = _interopRequireWildcard;

/***/ },
/* 4 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	if (false) {
	  var ReactIs = require('react-is');
	
	  // By explicitly using `prop-types` you are opting into new development behavior.
	  // http://fb.me/prop-types-in-prod
	  var throwOnDirectAccess = true;
	  module.exports = require('./factoryWithTypeCheckers')(ReactIs.isElement, throwOnDirectAccess);
	} else {
	  // By explicitly using `prop-types` you are opting into new production behavior.
	  // http://fb.me/prop-types-in-prod
	  module.exports = __webpack_require__(543)();
	}


/***/ },
/* 5 */
/***/ function(module, exports) {

	function _extends() {
	  module.exports = _extends = Object.assign || function (target) {
	    for (var i = 1; i < arguments.length; i++) {
	      var source = arguments[i];
	
	      for (var key in source) {
	        if (Object.prototype.hasOwnProperty.call(source, key)) {
	          target[key] = source[key];
	        }
	      }
	    }
	
	    return target;
	  };
	
	  return _extends.apply(this, arguments);
	}
	
	module.exports = _extends;

/***/ },
/* 6 */
/***/ function(module, exports, __webpack_require__) {

	var objectWithoutPropertiesLoose = __webpack_require__(110);
	
	function _objectWithoutProperties(source, excluded) {
	  if (source == null) return {};
	  var target = objectWithoutPropertiesLoose(source, excluded);
	  var key, i;
	
	  if (Object.getOwnPropertySymbols) {
	    var sourceSymbolKeys = Object.getOwnPropertySymbols(source);
	
	    for (i = 0; i < sourceSymbolKeys.length; i++) {
	      key = sourceSymbolKeys[i];
	      if (excluded.indexOf(key) >= 0) continue;
	      if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue;
	      target[key] = source[key];
	    }
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutProperties;

/***/ },
/* 7 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _styles = __webpack_require__(20);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(53));
	
	function withStyles(stylesOrCreator, options) {
	  return (0, _styles.withStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 8 */
/***/ function(module, exports) {

	function toVal(mix) {
		var k, y, str='';
		if (mix) {
			if (typeof mix === 'object') {
				if (Array.isArray(mix)) {
					for (k=0; k < mix.length; k++) {
						if (mix[k] && (y = toVal(mix[k]))) {
							str && (str += ' ');
							str += y;
						}
					}
				} else {
					for (k in mix) {
						if (mix[k] && (y = toVal(k))) {
							str && (str += ' ');
							str += y;
						}
					}
				}
			} else if (typeof mix !== 'boolean' && !mix.call) {
				str && (str += ' ');
				str += mix;
			}
		}
		return str;
	}
	
	module.exports = function () {
		var i=0, x, str='';
		while (i < arguments.length) {
			if (x = toVal(arguments[i++])) {
				str && (str += ' ');
				str += x
			}
		}
		return str;
	}


/***/ },
/* 9 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.9.6
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "chainPropTypes", {
	  enumerable: true,
	  get: function get() {
	    return _chainPropTypes.default;
	  }
	});
	Object.defineProperty(exports, "deepmerge", {
	  enumerable: true,
	  get: function get() {
	    return _deepmerge.default;
	  }
	});
	Object.defineProperty(exports, "elementAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "elementTypeAcceptingRef", {
	  enumerable: true,
	  get: function get() {
	    return _elementTypeAcceptingRef.default;
	  }
	});
	Object.defineProperty(exports, "exactProp", {
	  enumerable: true,
	  get: function get() {
	    return _exactProp.default;
	  }
	});
	Object.defineProperty(exports, "getDisplayName", {
	  enumerable: true,
	  get: function get() {
	    return _getDisplayName.default;
	  }
	});
	Object.defineProperty(exports, "ponyfillGlobal", {
	  enumerable: true,
	  get: function get() {
	    return _ponyfillGlobal.default;
	  }
	});
	Object.defineProperty(exports, "refType", {
	  enumerable: true,
	  get: function get() {
	    return _refType.default;
	  }
	});
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(96));
	
	var _deepmerge = _interopRequireDefault(__webpack_require__(495));
	
	var _elementAcceptingRef = _interopRequireDefault(__webpack_require__(496));
	
	var _elementTypeAcceptingRef = _interopRequireDefault(__webpack_require__(497));
	
	var _exactProp = _interopRequireDefault(__webpack_require__(498));
	
	var _getDisplayName = _interopRequireDefault(__webpack_require__(499));
	
	var _ponyfillGlobal = _interopRequireDefault(__webpack_require__(500));
	
	var _refType = _interopRequireDefault(__webpack_require__(501));

/***/ },
/* 10 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = capitalize;
	
	// It should to be noted that this function isn't equivalent to `text-transform: capitalize`.
	//
	// A strict capitalization should uppercase the first letter of each word a the sentence.
	// We only handle the first word.
	function capitalize(string) {
	  if (false) {
	    if (typeof string !== 'string') {
	      throw new Error('Material-UI: capitalize(string) expects a string argument.');
	    }
	  }
	
	  return string.charAt(0).toUpperCase() + string.slice(1);
	}

/***/ },
/* 11 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useForkRef;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _setRef = _interopRequireDefault(__webpack_require__(38));
	
	function useForkRef(refA, refB) {
	  /**
	   * This will create a new function if the ref props change and are defined.
	   * This means react will call the old forkRef with `null` and the new forkRef
	   * with the ref. Cleanup naturally emerges from this behavior
	   */
	  return React.useMemo(function () {
	    if (refA == null && refB == null) {
	      return null;
	    }
	
	    return function (refValue) {
	      (0, _setRef.default)(refA, refValue);
	      (0, _setRef.default)(refB, refValue);
	    };
	  }, [refA, refB]);
	}

/***/ },
/* 12 */
/***/ function(module, exports) {

	function _defineProperty(obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	}
	
	module.exports = _defineProperty;

/***/ },
/* 13 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _styles = __webpack_require__(20);
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(53));
	
	function useTheme() {
	  var theme = (0, _styles.useTheme)() || _defaultTheme.default;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useDebugValue(theme);
	  }
	
	  return theme;
	}

/***/ },
/* 14 */
/***/ function(module, exports) {

	// removed by extract-text-webpack-plugin

/***/ },
/* 15 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hexToRgb = hexToRgb;
	exports.rgbToHex = rgbToHex;
	exports.hslToRgb = hslToRgb;
	exports.decomposeColor = decomposeColor;
	exports.recomposeColor = recomposeColor;
	exports.getContrastRatio = getContrastRatio;
	exports.getLuminance = getLuminance;
	exports.emphasize = emphasize;
	exports.fade = fade;
	exports.darken = darken;
	exports.lighten = lighten;
	
	/* eslint-disable no-use-before-define */
	
	/**
	 * Returns a number whose value is limited to the given range.
	 *
	 * @param {number} value The value to be clamped
	 * @param {number} min The lower boundary of the output range
	 * @param {number} max The upper boundary of the output range
	 * @returns {number} A number in the range [min, max]
	 */
	function clamp(value) {
	  var min = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	  var max = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	
	  if (false) {
	    if (value < min || value > max) {
	      console.error("Material-UI: the value provided ".concat(value, " is out of range [").concat(min, ", ").concat(max, "]."));
	    }
	  }
	
	  return Math.min(Math.max(min, value), max);
	}
	/**
	 * Converts a color from CSS hex format to CSS rgb format.
	 *
	 * @param {string} color - Hex color, i.e. #nnn or #nnnnnn
	 * @returns {string} A CSS rgb color string
	 */
	
	
	function hexToRgb(color) {
	  color = color.substr(1);
	  var re = new RegExp(".{1,".concat(color.length / 3, "}"), 'g');
	  var colors = color.match(re);
	
	  if (colors && colors[0].length === 1) {
	    colors = colors.map(function (n) {
	      return n + n;
	    });
	  }
	
	  return colors ? "rgb(".concat(colors.map(function (n) {
	    return parseInt(n, 16);
	  }).join(', '), ")") : '';
	}
	
	function intToHex(int) {
	  var hex = int.toString(16);
	  return hex.length === 1 ? "0".concat(hex) : hex;
	}
	/**
	 * Converts a color from CSS rgb format to CSS hex format.
	 *
	 * @param {string} color - RGB color, i.e. rgb(n, n, n)
	 * @returns {string} A CSS rgb color string, i.e. #nnnnnn
	 */
	
	
	function rgbToHex(color) {
	  // Idempotent
	  if (color.indexOf('#') === 0) {
	    return color;
	  }
	
	  var _decomposeColor = decomposeColor(color),
	      values = _decomposeColor.values;
	
	  return "#".concat(values.map(function (n) {
	    return intToHex(n);
	  }).join(''));
	}
	/**
	 * Converts a color from hsl format to rgb format.
	 *
	 * @param {string} color - HSL color values
	 * @returns {string} rgb color values
	 */
	
	
	function hslToRgb(color) {
	  color = decomposeColor(color);
	  var _color = color,
	      values = _color.values;
	  var h = values[0];
	  var s = values[1] / 100;
	  var l = values[2] / 100;
	  var a = s * Math.min(l, 1 - l);
	
	  var f = function f(n) {
	    var k = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : (n + h / 30) % 12;
	    return l - a * Math.max(Math.min(k - 3, 9 - k, 1), -1);
	  };
	
	  var type = 'rgb';
	  var rgb = [Math.round(f(0) * 255), Math.round(f(8) * 255), Math.round(f(4) * 255)];
	
	  if (color.type === 'hsla') {
	    type += 'a';
	    rgb.push(values[3]);
	  }
	
	  return recomposeColor({
	    type: type,
	    values: rgb
	  });
	}
	/**
	 * Returns an object with the type and values of a color.
	 *
	 * Note: Does not support rgb % values.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {object} - A MUI color object: {type: string, values: number[]}
	 */
	
	
	function decomposeColor(color) {
	  // Idempotent
	  if (color.type) {
	    return color;
	  }
	
	  if (color.charAt(0) === '#') {
	    return decomposeColor(hexToRgb(color));
	  }
	
	  var marker = color.indexOf('(');
	  var type = color.substring(0, marker);
	
	  if (['rgb', 'rgba', 'hsl', 'hsla'].indexOf(type) === -1) {
	    throw new Error(["Material-UI: unsupported `".concat(color, "` color."), 'We support the following formats: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla().'].join('\n'));
	  }
	
	  var values = color.substring(marker + 1, color.length - 1).split(',');
	  values = values.map(function (value) {
	    return parseFloat(value);
	  });
	  return {
	    type: type,
	    values: values
	  };
	}
	/**
	 * Converts a color object with type and values to a string.
	 *
	 * @param {object} color - Decomposed color
	 * @param {string} color.type - One of: 'rgb', 'rgba', 'hsl', 'hsla'
	 * @param {array} color.values - [n,n,n] or [n,n,n,n]
	 * @returns {string} A CSS color string
	 */
	
	
	function recomposeColor(color) {
	  var type = color.type;
	  var values = color.values;
	
	  if (type.indexOf('rgb') !== -1) {
	    // Only convert the first 3 values to int (i.e. not alpha)
	    values = values.map(function (n, i) {
	      return i < 3 ? parseInt(n, 10) : n;
	    });
	  } else if (type.indexOf('hsl') !== -1) {
	    values[1] = "".concat(values[1], "%");
	    values[2] = "".concat(values[2], "%");
	  }
	
	  return "".concat(type, "(").concat(values.join(', '), ")");
	}
	/**
	 * Calculates the contrast ratio between two colors.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} foreground - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {string} background - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} A contrast ratio value in the range 0 - 21.
	 */
	
	
	function getContrastRatio(foreground, background) {
	  var lumA = getLuminance(foreground);
	  var lumB = getLuminance(background);
	  return (Math.max(lumA, lumB) + 0.05) / (Math.min(lumA, lumB) + 0.05);
	}
	/**
	 * The relative brightness of any point in a color space,
	 * normalized to 0 for darkest black and 1 for lightest white.
	 *
	 * Formula: https://www.w3.org/TR/WCAG20-TECHS/G17.html#G17-tests
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @returns {number} The relative brightness of the color in the range 0 - 1
	 */
	
	
	function getLuminance(color) {
	  color = decomposeColor(color);
	  var rgb = color.type === 'hsl' ? decomposeColor(hslToRgb(color)).values : color.values;
	  rgb = rgb.map(function (val) {
	    val /= 255; // normalized
	
	    return val <= 0.03928 ? val / 12.92 : Math.pow((val + 0.055) / 1.055, 2.4);
	  }); // Truncate at 3 digits
	
	  return Number((0.2126 * rgb[0] + 0.7152 * rgb[1] + 0.0722 * rgb[2]).toFixed(3));
	}
	/**
	 * Darken or lighten a color, depending on its luminance.
	 * Light colors are darkened, dark colors are lightened.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient=0.15 - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function emphasize(color) {
	  var coefficient = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0.15;
	  return getLuminance(color) > 0.5 ? darken(color, coefficient) : lighten(color, coefficient);
	}
	/**
	 * Set the absolute transparency of a color.
	 * Any existing alpha values are overwritten.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} value - value to set the alpha channel to in the range 0 -1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function fade(color, value) {
	  color = decomposeColor(color);
	  value = clamp(value);
	
	  if (color.type === 'rgb' || color.type === 'hsl') {
	    color.type += 'a';
	  }
	
	  color.values[3] = value;
	  return recomposeColor(color);
	}
	/**
	 * Darkens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function darken(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] *= 1 - coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] *= 1 - coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}
	/**
	 * Lightens a color.
	 *
	 * @param {string} color - CSS color, i.e. one of: #nnn, #nnnnnn, rgb(), rgba(), hsl(), hsla()
	 * @param {number} coefficient - multiplier in the range 0 - 1
	 * @returns {string} A CSS color string. Hex input values are returned as rgb
	 */
	
	
	function lighten(color, coefficient) {
	  color = decomposeColor(color);
	  coefficient = clamp(coefficient);
	
	  if (color.type.indexOf('hsl') !== -1) {
	    color.values[2] += (100 - color.values[2]) * coefficient;
	  } else if (color.type.indexOf('rgb') !== -1) {
	    for (var i = 0; i < 3; i += 1) {
	      color.values[i] += (255 - color.values[i]) * coefficient;
	    }
	  }
	
	  return recomposeColor(color);
	}

/***/ },
/* 16 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	function checkDCE() {
	  /* global __REACT_DEVTOOLS_GLOBAL_HOOK__ */
	  if (
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__ === 'undefined' ||
	    typeof __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE !== 'function'
	  ) {
	    return;
	  }
	  if (false) {
	    // This branch is unreachable because this function is only called
	    // in production, but the condition is true only in development.
	    // Therefore if the branch is still here, dead code elimination wasn't
	    // properly applied.
	    // Don't change the message. React DevTools relies on it. Also make sure
	    // this message doesn't occur elsewhere in this function, or it will cause
	    // a false positive.
	    throw new Error('^_^');
	  }
	  try {
	    // Verify that the code above has been dead code eliminated (DCE'd).
	    __REACT_DEVTOOLS_GLOBAL_HOOK__.checkDCE(checkDCE);
	  } catch (err) {
	    // DevTools shouldn't crash React, no matter what.
	    // We should still report in case we break this code.
	    console.error(err);
	  }
	}
	
	if (true) {
	  // DCE check should happen before ReactDOM bundle executes so that
	  // DevTools can report bad minification during injection.
	  checkDCE();
	  module.exports = __webpack_require__(550);
	} else {
	  module.exports = require('./cjs/react-dom.development.js');
	}


/***/ },
/* 17 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(51));
	
	/**
	 * Private module reserved for @material-ui/x packages.
	 */
	function createSvgIcon(path, displayName) {
	  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
	    return /*#__PURE__*/_react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  }));
	
	  if (false) {
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return Component;
	}

/***/ },
/* 18 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(551);
	} else {
	  module.exports = require('./cjs/react-is.development.js');
	}


/***/ },
/* 19 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(235));

/***/ },
/* 20 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.9.10
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createGenerateClassName: true,
	  createStyles: true,
	  getThemeProps: true,
	  jssPreset: true,
	  makeStyles: true,
	  mergeClasses: true,
	  ServerStyleSheets: true,
	  styled: true,
	  StylesProvider: true,
	  ThemeProvider: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true
	};
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "getThemeProps", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "mergeClasses", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _utils = __webpack_require__(9);
	
	var _createGenerateClassName = _interopRequireWildcard(__webpack_require__(92));
	
	Object.keys(_createGenerateClassName).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createGenerateClassName[key];
	    }
	  });
	});
	
	var _createStyles = _interopRequireWildcard(__webpack_require__(467));
	
	Object.keys(_createStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _createStyles[key];
	    }
	  });
	});
	
	var _getThemeProps = _interopRequireWildcard(__webpack_require__(169));
	
	Object.keys(_getThemeProps).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _getThemeProps[key];
	    }
	  });
	});
	
	var _jssPreset = _interopRequireWildcard(__webpack_require__(170));
	
	Object.keys(_jssPreset).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _jssPreset[key];
	    }
	  });
	});
	
	var _makeStyles = _interopRequireWildcard(__webpack_require__(93));
	
	Object.keys(_makeStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _makeStyles[key];
	    }
	  });
	});
	
	var _mergeClasses = _interopRequireWildcard(__webpack_require__(171));
	
	Object.keys(_mergeClasses).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _mergeClasses[key];
	    }
	  });
	});
	
	var _ServerStyleSheets = _interopRequireWildcard(__webpack_require__(461));
	
	Object.keys(_ServerStyleSheets).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ServerStyleSheets[key];
	    }
	  });
	});
	
	var _styled = _interopRequireWildcard(__webpack_require__(476));
	
	Object.keys(_styled).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styled[key];
	    }
	  });
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(91));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});
	
	var _ThemeProvider = _interopRequireWildcard(__webpack_require__(464));
	
	Object.keys(_ThemeProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ThemeProvider[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireWildcard(__webpack_require__(58));
	
	Object.keys(_useTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useTheme[key];
	    }
	  });
	});
	
	var _withStyles = _interopRequireWildcard(__webpack_require__(479));
	
	Object.keys(_withStyles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withStyles[key];
	    }
	  });
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(481));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});
	
	/* eslint-disable import/export */
	
	/* Warning if there are several instances of @material-ui/styles */
	if (false) {
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] = _utils.ponyfillGlobal['__@material-ui/styles-init__'] || 0;
	
	  if (_utils.ponyfillGlobal['__@material-ui/styles-init__'] === 1) {
	    console.warn(['It looks like there are several instances of `@material-ui/styles` initialized in this application.', 'This may cause theme propagation issues, broken class names, ' + 'specificity issues, and makes your application bigger without a good reason.', '', 'See https://material-ui.com/r/styles-instance-warning for more info.'].join('\n'));
	  }
	
	  _utils.ponyfillGlobal['__@material-ui/styles-init__'] += 1;
	}

/***/ },
/* 21 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-fetch/ v1.1.2 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(506)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-dsv'], factory) :
	(factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Dsv) { 'use strict';
	
	function responseBlob(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.blob();
	}
	
	function blob(input, init) {
	  return fetch(input, init).then(responseBlob);
	}
	
	function responseArrayBuffer(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.arrayBuffer();
	}
	
	function buffer(input, init) {
	  return fetch(input, init).then(responseArrayBuffer);
	}
	
	function responseText(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.text();
	}
	
	function text(input, init) {
	  return fetch(input, init).then(responseText);
	}
	
	function dsvParse(parse) {
	  return function(input, init, row) {
	    if (arguments.length === 2 && typeof init === "function") row = init, init = undefined;
	    return text(input, init).then(function(response) {
	      return parse(response, row);
	    });
	  };
	}
	
	function dsv(delimiter, input, init, row) {
	  if (arguments.length === 3 && typeof init === "function") row = init, init = undefined;
	  var format = d3Dsv.dsvFormat(delimiter);
	  return text(input, init).then(function(response) {
	    return format.parse(response, row);
	  });
	}
	
	var csv = dsvParse(d3Dsv.csvParse);
	var tsv = dsvParse(d3Dsv.tsvParse);
	
	function image(input, init) {
	  return new Promise(function(resolve, reject) {
	    var image = new Image;
	    for (var key in init) image[key] = init[key];
	    image.onerror = reject;
	    image.onload = function() { resolve(image); };
	    image.src = input;
	  });
	}
	
	function responseJson(response) {
	  if (!response.ok) throw new Error(response.status + " " + response.statusText);
	  return response.json();
	}
	
	function json(input, init) {
	  return fetch(input, init).then(responseJson);
	}
	
	function parser(type) {
	  return function(input, init)  {
	    return text(input, init).then(function(text$$1) {
	      return (new DOMParser).parseFromString(text$$1, type);
	    });
	  };
	}
	
	var xml = parser("application/xml");
	
	var html = parser("text/html");
	
	var svg = parser("image/svg+xml");
	
	exports.blob = blob;
	exports.buffer = buffer;
	exports.dsv = dsv;
	exports.csv = csv;
	exports.tsv = tsv;
	exports.image = image;
	exports.json = json;
	exports.text = text;
	exports.xml = xml;
	exports.html = html;
	exports.svg = svg;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 22 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithoutHoles = __webpack_require__(191);
	
	var iterableToArray = __webpack_require__(108);
	
	var nonIterableSpread = __webpack_require__(195);
	
	function _toConsumableArray(arr) {
	  return arrayWithoutHoles(arr) || iterableToArray(arr) || nonIterableSpread();
	}
	
	module.exports = _toConsumableArray;

/***/ },
/* 23 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	
	var _Paper = _interopRequireDefault(__webpack_require__(340));

/***/ },
/* 24 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	
	var _Typography = _interopRequireDefault(__webpack_require__(402));

/***/ },
/* 25 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ChartFooter = exports.ChartHeader = undefined;
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _SvgIcon = __webpack_require__(51);
	
	var _SvgIcon2 = _interopRequireDefault(_SvgIcon);
	
	var _Code = __webpack_require__(452);
	
	var _Code2 = _interopRequireDefault(_Code);
	
	var _SaveAlt = __webpack_require__(453);
	
	var _SaveAlt2 = _interopRequireDefault(_SaveAlt);
	
	var _Popover = __webpack_require__(82);
	
	var _Popover2 = _interopRequireDefault(_Popover);
	
	var _reactCsv = __webpack_require__(546);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ChartHeader = function (_Component) {
	  _inherits(ChartHeader, _Component);
	
	  function ChartHeader() {
	    _classCallCheck(this, ChartHeader);
	
	    return _possibleConstructorReturn(this, (ChartHeader.__proto__ || Object.getPrototypeOf(ChartHeader)).apply(this, arguments));
	  }
	
	  _createClass(ChartHeader, [{
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'chart-header' },
	        _react2.default.createElement(
	          'h2',
	          { className: 'chart-hed', style: { marginBottom: '1rem' } },
	          this.props.title
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'chart-subhed', style: { marginBottom: '1rem' } },
	          this.props.subhed
	        )
	      );
	    }
	  }]);
	
	  return ChartHeader;
	}(_react.Component);
	
	var ChartFooter = function (_Component2) {
	  _inherits(ChartFooter, _Component2);
	
	  function ChartFooter(props) {
	    _classCallCheck(this, ChartFooter);
	
	    var _this2 = _possibleConstructorReturn(this, (ChartFooter.__proto__ || Object.getPrototypeOf(ChartFooter)).call(this, props));
	
	    _this2.state = {
	      search: props.search ? props.search : "",
	      downloaddata: props.downloaddata,
	      anchorEl: false,
	      setAnchorEl: null,
	      open: false,
	      id: open ? 'simple-popover' : undefined
	    };
	    return _this2;
	  }
	
	  _createClass(ChartFooter, [{
	    key: 'handleDownloadData',
	    value: function handleDownloadData() {}
	  }, {
	    key: 'handleClick',
	    value: function handleClick(event) {
	      this.setState({
	        anchorEl: event.currentTarget,
	        setAnchorEl: event.currentTarget
	      });
	    }
	  }, {
	    key: 'handleClose',
	    value: function handleClose() {
	      this.setState({
	        anchorEl: null,
	        setAnchorEl: null
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var open = Boolean(this.state.anchorEl);
	      var id = open ? 'simple-popover' : undefined;
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'chart-footer' },
	        _react2.default.createElement(
	          'div',
	          { className: 'col1 credit' },
	          this.props.credit
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col2' },
	          this.props.downloaddata.length > 0 ? _react2.default.createElement(
	            _reactCsv.CSVLink,
	            {
	              data: this.props.downloaddata,
	              filename: this.props.downloadfilename + ".csv",
	              className: 'btn btn-primary',
	              target: '_blank'
	            },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                variant: 'outlined',
	                size: 'small',
	                color: 'primary'
	              },
	              _react2.default.createElement(_SaveAlt2.default, null),
	              '\xA0 Get Data'
	            )
	          ) : _react2.default.createElement(
	            'a',
	            { href: 'https://gwipp.gwu.edu/counting-dollars-2020-role-decennial-census-geographic-distribution-federal-funds', target: '_blank' },
	            _react2.default.createElement(
	              _Button2.default,
	              {
	                variant: 'outlined',
	                size: 'small',
	                color: 'primary'
	              },
	              _react2.default.createElement(_SaveAlt2.default, null),
	              '\xA0 Get Data'
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'col3' },
	          _react2.default.createElement(
	            _Button2.default,
	            {
	              variant: 'outlined',
	              size: 'small',
	              color: 'primary',
	              onClick: this.handleClick.bind(this)
	            },
	            _react2.default.createElement(_Code2.default, null),
	            '\xA0 Embed'
	          ),
	          _react2.default.createElement(
	            _Popover2.default,
	            {
	              className: 'embed-panel',
	              id: id,
	              open: open,
	              anchorEl: this.state.anchorEl,
	              onClose: this.handleClose.bind(this),
	              anchorOrigin: {
	                vertical: 'top',
	                horizontal: 'left'
	              },
	              transformOrigin: {
	                vertical: 'bottom',
	                horizontal: 'center'
	              }
	            },
	            'Use this code to embed this graphic on your own site:',
	            _react2.default.createElement(
	              'pre',
	              null,
	              '<iframe height="' + (document.body.clientHeight + 100) + '" width="100%" src="' + window.location.href.split(/[?]/)[0] + this.state.search + '" frameborder="0" allowfullscreen scrolling="no"></iframe>'
	            )
	          )
	        )
	      );
	    }
	  }]);
	
	  return ChartFooter;
	}(_react.Component);
	
	exports.ChartHeader = ChartHeader;
	exports.ChartFooter = ChartFooter;

/***/ },
/* 26 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.duration = exports.easing = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	// Follow https://material.google.com/motion/duration-easing.html#duration-easing-natural-easing-curves
	// to learn the context in which each easing should be used.
	var easing = {
	  // This is the most common easing curve.
	  easeInOut: 'cubic-bezier(0.4, 0, 0.2, 1)',
	  // Objects enter the screen at full velocity from off-screen and
	  // slowly decelerate to a resting point.
	  easeOut: 'cubic-bezier(0.0, 0, 0.2, 1)',
	  // Objects leave the screen at full velocity. They do not decelerate when off-screen.
	  easeIn: 'cubic-bezier(0.4, 0, 1, 1)',
	  // The sharp curve is used by objects that may return to the screen at any time.
	  sharp: 'cubic-bezier(0.4, 0, 0.6, 1)'
	}; // Follow https://material.io/guidelines/motion/duration-easing.html#duration-easing-common-durations
	// to learn when use what timing
	
	exports.easing = easing;
	var duration = {
	  shortest: 150,
	  shorter: 200,
	  short: 250,
	  // most basic recommended timing
	  standard: 300,
	  // this is to be used in complex animations
	  complex: 375,
	  // recommended when something is entering screen
	  enteringScreen: 225,
	  // recommended when something is leaving screen
	  leavingScreen: 195
	};
	exports.duration = duration;
	
	function formatMs(milliseconds) {
	  return "".concat(Math.round(milliseconds), "ms");
	}
	/**
	 * @param {string|Array} props
	 * @param {object} param
	 * @param {string} param.prop
	 * @param {number} param.duration
	 * @param {string} param.easing
	 * @param {number} param.delay
	 */
	
	
	var _default = {
	  easing: easing,
	  duration: duration,
	  create: function create() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : ['all'];
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$duration = options.duration,
	        durationOption = _options$duration === void 0 ? duration.standard : _options$duration,
	        _options$easing = options.easing,
	        easingOption = _options$easing === void 0 ? easing.easeInOut : _options$easing,
	        _options$delay = options.delay,
	        delay = _options$delay === void 0 ? 0 : _options$delay,
	        other = (0, _objectWithoutProperties2.default)(options, ["duration", "easing", "delay"]);
	
	    if (false) {
	      var isString = function isString(value) {
	        return typeof value === 'string';
	      };
	
	      var isNumber = function isNumber(value) {
	        return !isNaN(parseFloat(value));
	      };
	
	      if (!isString(props) && !Array.isArray(props)) {
	        console.error('Material-UI: argument "props" must be a string or Array.');
	      }
	
	      if (!isNumber(durationOption) && !isString(durationOption)) {
	        console.error("Material-UI: argument \"duration\" must be a number or a string but found ".concat(durationOption, "."));
	      }
	
	      if (!isString(easingOption)) {
	        console.error('Material-UI: argument "easing" must be a string.');
	      }
	
	      if (!isNumber(delay) && !isString(delay)) {
	        console.error('Material-UI: argument "delay" must be a number or a string.');
	      }
	
	      if (Object.keys(other).length !== 0) {
	        console.error("Material-UI: unrecognized argument(s) [".concat(Object.keys(other).join(','), "]"));
	      }
	    }
	
	    return (Array.isArray(props) ? props : [props]).map(function (animatedProp) {
	      return "".concat(animatedProp, " ").concat(typeof durationOption === 'string' ? durationOption : formatMs(durationOption), " ").concat(easingOption, " ").concat(typeof delay === 'string' ? delay : formatMs(delay));
	    }).join(',');
	  },
	  getAutoHeightDuration: function getAutoHeightDuration(height) {
	    if (!height) {
	      return 0;
	    }
	
	    var constant = height / 36; // https://www.wolframalpha.com/input/?i=(4+%2B+15+*+(x+%2F+36+)+**+0.25+%2B+(x+%2F+36)+%2F+5)+*+10
	
	    return Math.round((4 + 15 * Math.pow(constant, 0.25) + constant / 5) * 10);
	  }
	};
	exports.default = _default;

/***/ },
/* 27 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerDocument;
	
	function ownerDocument(node) {
	  return node && node.ownerDocument || document;
	}

/***/ },
/* 28 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(174));
	
	var _breakpoints = __webpack_require__(95);
	
	function getPath(obj, path) {
	  if (!path || typeof path !== 'string') {
	    return null;
	  }
	
	  return path.split('.').reduce(function (acc, item) {
	    return acc && acc[item] ? acc[item] : null;
	  }, obj);
	}
	
	function style(options) {
	  var prop = options.prop,
	      _options$cssProperty = options.cssProperty,
	      cssProperty = _options$cssProperty === void 0 ? options.prop : _options$cssProperty,
	      themeKey = options.themeKey,
	      transform = options.transform;
	
	  var fn = function fn(props) {
	    if (props[prop] == null) {
	      return null;
	    }
	
	    var propValue = props[prop];
	    var theme = props.theme;
	    var themeMapping = getPath(theme, themeKey) || {};
	
	    var styleFromPropValue = function styleFromPropValue(propValueFinal) {
	      var value;
	
	      if (typeof themeMapping === 'function') {
	        value = themeMapping(propValueFinal);
	      } else if (Array.isArray(themeMapping)) {
	        value = themeMapping[propValueFinal] || propValueFinal;
	      } else {
	        value = getPath(themeMapping, propValueFinal) || propValueFinal;
	
	        if (transform) {
	          value = transform(value);
	        }
	      }
	
	      if (cssProperty === false) {
	        return value;
	      }
	
	      return (0, _defineProperty2.default)({}, cssProperty, value);
	    };
	
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  };
	
	  fn.propTypes =  false ? (0, _defineProperty2.default)({}, prop, _responsivePropType.default) : {};
	  fn.filterProps = [prop];
	  return fn;
	}
	
	var _default = style;
	exports.default = _default;

/***/ },
/* 29 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useEventCallback;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	/**
	 * https://github.com/facebook/react/issues/14099#issuecomment-440013892
	 *
	 * @param {function} fn
	 */
	
	function useEventCallback(fn) {
	  var ref = React.useRef(fn);
	  useEnhancedEffect(function () {
	    ref.current = fn;
	  });
	  return React.useCallback(function () {
	    return (0, ref.current).apply(void 0, arguments);
	  }, []);
	}

/***/ },
/* 30 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _merge = _interopRequireDefault(__webpack_require__(69));
	
	function compose() {
	  for (var _len = arguments.length, styles = new Array(_len), _key = 0; _key < _len; _key++) {
	    styles[_key] = arguments[_key];
	  }
	
	  var fn = function fn(props) {
	    return styles.reduce(function (acc, style) {
	      var output = style(props);
	
	      if (output) {
	        return (0, _merge.default)(acc, output);
	      }
	
	      return acc;
	    }, {});
	  }; // Alternative approach that doesn't yield any performance gain.
	  // const handlers = styles.reduce((acc, style) => {
	  //   style.filterProps.forEach(prop => {
	  //     acc[prop] = style;
	  //   });
	  //   return acc;
	  // }, {});
	  // const fn = props => {
	  //   return Object.keys(props).reduce((acc, prop) => {
	  //     if (handlers[prop]) {
	  //       return merge(acc, handlers[prop](props));
	  //     }
	  //     return acc;
	  //   }, {});
	  // };
	
	
	  fn.propTypes =  false ? styles.reduce(function (acc, style) {
	    return (0, _extends2.default)(acc, style.propTypes);
	  }, {}) : {};
	  fn.filterProps = styles.reduce(function (acc, style) {
	    return acc.concat(style.filterProps);
	  }, []);
	  return fn;
	}
	
	var _default = compose;
	exports.default = _default;

/***/ },
/* 31 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-array/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  function ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	
	  function bisector(compare) {
	    if (compare.length === 1) compare = ascendingComparator(compare);
	    return {
	      left: function(a, x, lo, hi) {
	        if (lo == null) lo = 0;
	        if (hi == null) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) < 0) lo = mid + 1;
	          else hi = mid;
	        }
	        return lo;
	      },
	      right: function(a, x, lo, hi) {
	        if (lo == null) lo = 0;
	        if (hi == null) hi = a.length;
	        while (lo < hi) {
	          var mid = lo + hi >>> 1;
	          if (compare(a[mid], x) > 0) hi = mid;
	          else lo = mid + 1;
	        }
	        return lo;
	      }
	    };
	  }
	
	  function ascendingComparator(f) {
	    return function(d, x) {
	      return ascending(f(d), x);
	    };
	  }
	
	  var ascendingBisect = bisector(ascending);
	  var bisectRight = ascendingBisect.right;
	  var bisectLeft = ascendingBisect.left;
	
	  function descending(a, b) {
	    return b < a ? -1 : b > a ? 1 : b >= a ? 0 : NaN;
	  }
	
	  function number(x) {
	    return x === null ? NaN : +x;
	  }
	
	  function variance(array, f) {
	    var n = array.length,
	        m = 0,
	        a,
	        d,
	        s = 0,
	        i = -1,
	        j = 0;
	
	    if (f == null) {
	      while (++i < n) {
	        if (!isNaN(a = number(array[i]))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	
	    else {
	      while (++i < n) {
	        if (!isNaN(a = number(f(array[i], i, array)))) {
	          d = a - m;
	          m += d / ++j;
	          s += d * (a - m);
	        }
	      }
	    }
	
	    if (j > 1) return s / (j - 1);
	  }
	
	  function deviation(array, f) {
	    var v = variance(array, f);
	    return v ? Math.sqrt(v) : v;
	  }
	
	  function extent(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b,
	        c;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = c = b; break; }
	      while (++i < n) if ((b = array[i]) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = c = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null) {
	        if (a > b) a = b;
	        if (c < b) c = b;
	      }
	    }
	
	    return [a, c];
	  }
	
	  var array = Array.prototype;
	
	  var slice = array.slice;
	  var map = array.map;
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function identity(x) {
	    return x;
	  }
	
	  function range(start, stop, step) {
	    start = +start, stop = +stop, step = (n = arguments.length) < 2 ? (stop = start, start = 0, 1) : n < 3 ? 1 : +step;
	
	    var i = -1,
	        n = Math.max(0, Math.ceil((stop - start) / step)) | 0,
	        range = new Array(n);
	
	    while (++i < n) {
	      range[i] = start + i * step;
	    }
	
	    return range;
	  }
	
	  var e10 = Math.sqrt(50);
	  var e5 = Math.sqrt(10);
	  var e2 = Math.sqrt(2);
	  function ticks(start, stop, count) {
	    var step = tickStep(start, stop, count);
	    return range(
	      Math.ceil(start / step) * step,
	      Math.floor(stop / step) * step + step / 2, // inclusive
	      step
	    );
	  }
	
	  function tickStep(start, stop, count) {
	    var step0 = Math.abs(stop - start) / Math.max(0, count),
	        step1 = Math.pow(10, Math.floor(Math.log(step0) / Math.LN10)),
	        error = step0 / step1;
	    if (error >= e10) step1 *= 10;
	    else if (error >= e5) step1 *= 5;
	    else if (error >= e2) step1 *= 2;
	    return stop < start ? -step1 : step1;
	  }
	
	  function sturges(values) {
	    return Math.ceil(Math.log(values.length) / Math.LN2) + 1;
	  }
	
	  function histogram() {
	    var value = identity,
	        domain = extent,
	        threshold = sturges;
	
	    function histogram(data) {
	      var i,
	          n = data.length,
	          x,
	          values = new Array(n);
	
	      for (i = 0; i < n; ++i) {
	        values[i] = value(data[i], i, data);
	      }
	
	      var xz = domain(values),
	          x0 = xz[0],
	          x1 = xz[1],
	          tz = threshold(values, x0, x1);
	
	      // Convert number of thresholds into uniform thresholds.
	      if (!Array.isArray(tz)) tz = ticks(x0, x1, tz);
	
	      // Remove any thresholds outside the domain.
	      var m = tz.length;
	      while (tz[0] <= x0) tz.shift(), --m;
	      while (tz[m - 1] >= x1) tz.pop(), --m;
	
	      var bins = new Array(m + 1),
	          bin;
	
	      // Initialize bins.
	      for (i = 0; i <= m; ++i) {
	        bin = bins[i] = [];
	        bin.x0 = i > 0 ? tz[i - 1] : x0;
	        bin.x1 = i < m ? tz[i] : x1;
	      }
	
	      // Assign data to bins by value, ignoring any outside the domain.
	      for (i = 0; i < n; ++i) {
	        x = values[i];
	        if (x0 <= x && x <= x1) {
	          bins[bisectRight(tz, x, 0, m)].push(data[i]);
	        }
	      }
	
	      return bins;
	    }
	
	    histogram.value = function(_) {
	      return arguments.length ? (value = typeof _ === "function" ? _ : constant(_), histogram) : value;
	    };
	
	    histogram.domain = function(_) {
	      return arguments.length ? (domain = typeof _ === "function" ? _ : constant([_[0], _[1]]), histogram) : domain;
	    };
	
	    histogram.thresholds = function(_) {
	      return arguments.length ? (threshold = typeof _ === "function" ? _ : Array.isArray(_) ? constant(slice.call(_)) : constant(_), histogram) : threshold;
	    };
	
	    return histogram;
	  }
	
	  function quantile(array, p, f) {
	    if (f == null) f = number;
	    if (!(n = array.length)) return;
	    if ((p = +p) <= 0 || n < 2) return +f(array[0], 0, array);
	    if (p >= 1) return +f(array[n - 1], n - 1, array);
	    var n,
	        h = (n - 1) * p,
	        i = Math.floor(h),
	        a = +f(array[i], i, array),
	        b = +f(array[i + 1], i + 1, array);
	    return a + (b - a) * (h - i);
	  }
	
	  function freedmanDiaconis(values, min, max) {
	    values = map.call(values, number).sort(ascending);
	    return Math.ceil((max - min) / (2 * (quantile(values, 0.75) - quantile(values, 0.25)) * Math.pow(values.length, -1 / 3)));
	  }
	
	  function scott(values, min, max) {
	    return Math.ceil((max - min) / (3.5 * deviation(values) * Math.pow(values.length, -1 / 3)));
	  }
	
	  function max(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = array[i]) != null && b > a) a = b;
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b > a) a = b;
	    }
	
	    return a;
	  }
	
	  function mean(array, f) {
	    var s = 0,
	        n = array.length,
	        a,
	        i = -1,
	        j = n;
	
	    if (f == null) {
	      while (++i < n) if (!isNaN(a = number(array[i]))) s += a; else --j;
	    }
	
	    else {
	      while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) s += a; else --j;
	    }
	
	    if (j) return s / j;
	  }
	
	  function median(array, f) {
	    var numbers = [],
	        n = array.length,
	        a,
	        i = -1;
	
	    if (f == null) {
	      while (++i < n) if (!isNaN(a = number(array[i]))) numbers.push(a);
	    }
	
	    else {
	      while (++i < n) if (!isNaN(a = number(f(array[i], i, array)))) numbers.push(a);
	    }
	
	    return quantile(numbers.sort(ascending), 0.5);
	  }
	
	  function merge(arrays) {
	    var n = arrays.length,
	        m,
	        i = -1,
	        j = 0,
	        merged,
	        array;
	
	    while (++i < n) j += arrays[i].length;
	    merged = new Array(j);
	
	    while (--n >= 0) {
	      array = arrays[n];
	      m = array.length;
	      while (--m >= 0) {
	        merged[--j] = array[m];
	      }
	    }
	
	    return merged;
	  }
	
	  function min(array, f) {
	    var i = -1,
	        n = array.length,
	        a,
	        b;
	
	    if (f == null) {
	      while (++i < n) if ((b = array[i]) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = array[i]) != null && a > b) a = b;
	    }
	
	    else {
	      while (++i < n) if ((b = f(array[i], i, array)) != null && b >= b) { a = b; break; }
	      while (++i < n) if ((b = f(array[i], i, array)) != null && a > b) a = b;
	    }
	
	    return a;
	  }
	
	  function pairs(array) {
	    var i = 0, n = array.length - 1, p = array[0], pairs = new Array(n < 0 ? 0 : n);
	    while (i < n) pairs[i] = [p, p = array[++i]];
	    return pairs;
	  }
	
	  function permute(array, indexes) {
	    var i = indexes.length, permutes = new Array(i);
	    while (i--) permutes[i] = array[indexes[i]];
	    return permutes;
	  }
	
	  function scan(array, compare) {
	    if (!(n = array.length)) return;
	    var i = 0,
	        n,
	        j = 0,
	        xi,
	        xj = array[j];
	
	    if (!compare) compare = ascending;
	
	    while (++i < n) if (compare(xi = array[i], xj) < 0 || compare(xj, xj) !== 0) xj = xi, j = i;
	
	    if (compare(xj, xj) === 0) return j;
	  }
	
	  function shuffle(array, i0, i1) {
	    var m = (i1 == null ? array.length : i1) - (i0 = i0 == null ? 0 : +i0),
	        t,
	        i;
	
	    while (m) {
	      i = Math.random() * m-- | 0;
	      t = array[m + i0];
	      array[m + i0] = array[i + i0];
	      array[i + i0] = t;
	    }
	
	    return array;
	  }
	
	  function sum(array, f) {
	    var s = 0,
	        n = array.length,
	        a,
	        i = -1;
	
	    if (f == null) {
	      while (++i < n) if (a = +array[i]) s += a; // Note: zero and null are equivalent.
	    }
	
	    else {
	      while (++i < n) if (a = +f(array[i], i, array)) s += a;
	    }
	
	    return s;
	  }
	
	  function transpose(matrix) {
	    if (!(n = matrix.length)) return [];
	    for (var i = -1, m = min(matrix, length), transpose = new Array(m); ++i < m;) {
	      for (var j = -1, n, row = transpose[i] = new Array(n); ++j < n;) {
	        row[j] = matrix[j][i];
	      }
	    }
	    return transpose;
	  }
	
	  function length(d) {
	    return d.length;
	  }
	
	  function zip() {
	    return transpose(arguments);
	  }
	
	  exports.bisect = bisectRight;
	  exports.bisectRight = bisectRight;
	  exports.bisectLeft = bisectLeft;
	  exports.ascending = ascending;
	  exports.bisector = bisector;
	  exports.descending = descending;
	  exports.deviation = deviation;
	  exports.extent = extent;
	  exports.histogram = histogram;
	  exports.thresholdFreedmanDiaconis = freedmanDiaconis;
	  exports.thresholdScott = scott;
	  exports.thresholdSturges = sturges;
	  exports.max = max;
	  exports.mean = mean;
	  exports.median = median;
	  exports.merge = merge;
	  exports.min = min;
	  exports.pairs = pairs;
	  exports.permute = permute;
	  exports.quantile = quantile;
	  exports.range = range;
	  exports.scan = scan;
	  exports.shuffle = shuffle;
	  exports.sum = sum;
	  exports.ticks = ticks;
	  exports.tickStep = tickStep;
	  exports.transpose = transpose;
	  exports.variance = variance;
	  exports.zip = zip;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 32 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(105);
	
	var iterableToArrayLimit = __webpack_require__(194);
	
	var nonIterableRest = __webpack_require__(109);
	
	function _slicedToArray(arr, i) {
	  return arrayWithHoles(arr) || iterableToArrayLimit(arr, i) || nonIterableRest();
	}
	
	module.exports = _slicedToArray;

/***/ },
/* 33 */
/***/ function(module, exports) {

	function _typeof(obj) {
	  if (typeof Symbol === "function" && typeof Symbol.iterator === "symbol") {
	    module.exports = _typeof = function _typeof(obj) {
	      return typeof obj;
	    };
	  } else {
	    module.exports = _typeof = function _typeof(obj) {
	      return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj;
	    };
	  }
	
	  return _typeof(obj);
	}
	
	module.exports = _typeof;

/***/ },
/* 34 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	
	var _Button = _interopRequireDefault(__webpack_require__(234));

/***/ },
/* 35 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _Table = __webpack_require__(140);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _TableBody = __webpack_require__(141);
	
	var _TableBody2 = _interopRequireDefault(_TableBody);
	
	var _TableCell = __webpack_require__(86);
	
	var _TableCell2 = _interopRequireDefault(_TableCell);
	
	var _TableContainer = __webpack_require__(142);
	
	var _TableContainer2 = _interopRequireDefault(_TableContainer);
	
	var _TableHead = __webpack_require__(143);
	
	var _TableHead2 = _interopRequireDefault(_TableHead);
	
	var _TableRow = __webpack_require__(144);
	
	var _TableRow2 = _interopRequireDefault(_TableRow);
	
	var _Paper = __webpack_require__(23);
	
	var _Paper2 = _interopRequireDefault(_Paper);
	
	var _ArrowDropDownSharp = __webpack_require__(450);
	
	var _ArrowDropDownSharp2 = _interopRequireDefault(_ArrowDropDownSharp);
	
	var _ArrowDropUpSharp = __webpack_require__(451);
	
	var _ArrowDropUpSharp2 = _interopRequireDefault(_ArrowDropUpSharp);
	
	var _USStateNames = __webpack_require__(560);
	
	var _USStateNames2 = _interopRequireDefault(_USStateNames);
	
	var _FormatMoney = __webpack_require__(59);
	
	var _FormatMoney2 = _interopRequireDefault(_FormatMoney);
	
	var _d3Scale = __webpack_require__(71);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function colFormat(column) {
	  var scale = (0, _d3Scale.scaleOrdinal)().domain(["population", "medicaid_reimbursement_lost_per_capita", "cost_low", "cost_med", "cost_high", "risk_low", "risk_med", "risk_high", "undercount_low", "undercount_med", "undercount_high", "pop_2017", "pop_2018", "pop_change"]).range(["2015 Population", "Medicaid reimbursement per capita lost", "Cost of low undercount", "Cost of medium undercount", "Cost of high undercount", "Low risk scenario", "Medium risk scenario", "High risk scenario", "Low population miscount", "Medium population miscount", "High population miscount", "2017 Population", "2018 Population", "Population Change"]);
	
	  if (scale.domain().indexOf(column) > -1) {
	    return scale(column);
	  } else {
	    return column;
	  }
	}
	
	function cellFormatter(row, column) {
	  if (column.indexOf("Total") > -1 || column.indexOf("Funding Per Child") > -1 || column.indexOf("Per Capita") > -1 || column.indexOf("FY2017 Funding") > -1 || column.indexOf("medicaid_reimbursement_lost_per_capita") > -1) {
	    return (0, _FormatMoney2.default)(row[column]);
	  } else if (column.indexOf("cost_low") > -1 || column.indexOf("cost_med") > -1 || column.indexOf("cost_high") > -1) {
	    return (0, _FormatMoney2.default)(row[column], "posneg");
	  } else if (column.indexOf("pop_change") > -1) {
	    return (0, _FormatMoney2.default)(row[column], "addpercent");
	  } else if (column.indexOf("population") > -1 || column.indexOf("pop_") > -1 || column.indexOf("Child Population") > -1 || column.indexOf("undercount") > -1) {
	    return row[column].toLocaleString('en-US');
	  } else if (column.indexOf("Funding as % of State's Income") > -1) {
	    return (0, _FormatMoney2.default)(row[column], "income");
	  } else if (column == "Program" && row.URL !== "NA" && row.URL !== "") {
	    return _react2.default.createElement(
	      'a',
	      { target: '_blank', href: row.URL
	      },
	      row[column]
	    );
	  } else {
	    return row[column];
	  }
	}
	
	function compareValues(key) {
	  var order = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'asc';
	
	  return function innerSort(a, b) {
	    if (!a.hasOwnProperty(key) || !b.hasOwnProperty(key)) {
	      // property doesn't exist on either object
	      return 0;
	    }
	
	    var varA = typeof a[key] === 'string' ? a[key].toUpperCase() : a[key];
	    var varB = typeof b[key] === 'string' ? b[key].toUpperCase() : b[key];
	
	    var comparison = 0;
	    if (varA > varB) {
	      comparison = 1;
	    } else if (varA < varB) {
	      comparison = -1;
	    }
	    return order === 'desc' ? comparison * -1 : comparison;
	  };
	}
	
	var DataTable = function (_Component) {
	  _inherits(DataTable, _Component);
	
	  function DataTable(props) {
	    _classCallCheck(this, DataTable);
	
	    var _this = _possibleConstructorReturn(this, (DataTable.__proto__ || Object.getPrototypeOf(DataTable)).call(this, props));
	
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.state = {
	      data: _this.props.data,
	      sort: _this.props.sort,
	      sortorder: _this.props.sortorder
	    };
	    return _this;
	  }
	
	  _createClass(DataTable, [{
	    key: 'handleClick',
	    value: function handleClick(e) {
	      this.setState({
	        sort: e.target.getAttribute("value"),
	        sortorder: this.state.sortorder === "desc" ? "asc" : "desc",
	        data: this.state.data.sort(compareValues(this.state.sort, this.state.sortorder))
	      });
	    }
	  }, {
	    key: 'addArrow',
	    value: function addArrow(c) {
	      if (c == this.state.sort && this.state.sortorder == "asc") {
	        return _react2.default.createElement(_ArrowDropUpSharp2.default, { style: { verticalAlign: "bottom" } });
	      } else if (c == this.state.sort && this.state.sortorder == "desc") {
	        return _react2.default.createElement(_ArrowDropDownSharp2.default, { style: { verticalAlign: "bottom" } });
	      } else {
	        return "";
	      }
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var data = this.props.data;
	
	      data = data.sort(compareValues(this.state.sort, this.state.sortorder));
	
	      if (data.length > 0) {
	        return _react2.default.createElement(
	          _TableContainer2.default,
	          { component: _Paper2.default },
	          _react2.default.createElement(
	            _Table2.default,
	            { stickyHeader: true, size: 'small', 'aria-label': 'a dense table' },
	            _react2.default.createElement(
	              _TableHead2.default,
	              null,
	              _react2.default.createElement(
	                _TableRow2.default,
	                null,
	                data.columns.map(function (column) {
	                  return _react2.default.createElement(
	                    _TableCell2.default,
	                    {
	                      key: column,
	                      onClick: _this2.handleClick.bind(_this2),
	                      value: column,
	                      'data-sortstatus': _this2.state.sortorder },
	                    colFormat(column),
	                    _this2.addArrow(column)
	                  );
	                })
	              )
	            ),
	            _react2.default.createElement(
	              _TableBody2.default,
	              null,
	              data.map(function (row, i) {
	                return _react2.default.createElement(
	                  _TableRow2.default,
	                  { key: i },
	                  data.columns.map(function (column) {
	                    return _react2.default.createElement(
	                      _TableCell2.default,
	                      { key: column },
	                      cellFormatter(row, column, _this2.state.sort)
	                    );
	                  })
	                );
	              })
	            )
	          )
	        );
	      } else {
	        return _react2.default.createElement('span', null);
	      }
	    }
	  }]);
	
	  return DataTable;
	}(_react.Component);
	
	exports.default = DataTable;

/***/ },
/* 36 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useFormControl;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(62));
	
	function useFormControl() {
	  return React.useContext(_FormControlContext.default);
	}

/***/ },
/* 37 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = debounce;
	
	// Corresponds to 10 frames at 60 Hz.
	// A few bytes payload overhead when lodash/debounce is ~3 kB and debounce ~300 B.
	function debounce(func) {
	  var wait = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 166;
	  var timeout;
	
	  function debounced() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    // eslint-disable-next-line consistent-this
	    var that = this;
	
	    var later = function later() {
	      func.apply(that, args);
	    };
	
	    clearTimeout(timeout);
	    timeout = setTimeout(later, wait);
	  }
	
	  debounced.clear = function () {
	    clearTimeout(timeout);
	  };
	
	  return debounced;
	}

/***/ },
/* 38 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = setRef;
	
	// TODO v5: consider to make it private
	function setRef(ref, value) {
	  if (typeof ref === 'function') {
	    ref(value);
	  } else if (ref) {
	    ref.current = value;
	  }
	}

/***/ },
/* 39 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useControlled;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/* eslint-disable react-hooks/rules-of-hooks, react-hooks/exhaustive-deps */
	function useControlled(_ref) {
	  var controlled = _ref.controlled,
	      defaultProp = _ref.default,
	      name = _ref.name,
	      _ref$state = _ref.state,
	      state = _ref$state === void 0 ? 'value' : _ref$state;
	
	  var _React$useRef = React.useRef(controlled !== undefined),
	      isControlled = _React$useRef.current;
	
	  var _React$useState = React.useState(defaultProp),
	      valueState = _React$useState[0],
	      setValue = _React$useState[1];
	
	  var value = isControlled ? controlled : valueState;
	
	  if (false) {
	    React.useEffect(function () {
	      if (isControlled !== (controlled !== undefined)) {
	        console.error(["Material-UI: a component is changing the ".concat(isControlled ? '' : 'un', "controlled ").concat(state, " state of ").concat(name, " to be ").concat(isControlled ? 'un' : '', "controlled."), 'Elements should not switch from uncontrolled to controlled (or vice versa).', "Decide between using a controlled or uncontrolled ".concat(name, " ") + 'element for the lifetime of the component.', "The nature of the state is determined during the first render, it's considered controlled if the value is not `undefined`.", 'More info: https://fb.me/react-controlled-components'].join('\n'));
	      }
	    }, [controlled]);
	
	    var _React$useRef2 = React.useRef(defaultProp),
	        defaultValue = _React$useRef2.current;
	
	    React.useEffect(function () {
	      if (defaultValue !== defaultProp) {
	        console.error(["Material-UI: a component is changing the default ".concat(state, " state of an uncontrolled ").concat(name, " after being initialized. ") + "To suppress this warning opt to use a controlled ".concat(name, ".")].join('\n'));
	      }
	    }, [JSON.stringify(defaultProp)]);
	  }
	
	  var setValueIfUncontrolled = React.useCallback(function (newValue) {
	    if (!isControlled) {
	      setValue(newValue);
	    }
	  }, []);
	  return [value, setValueIfUncontrolled];
	}

/***/ },
/* 40 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(5));
	var isInBrowser = _interopDefault(__webpack_require__(178));
	var warning = _interopDefault(__webpack_require__(41));
	var _createClass = _interopDefault(__webpack_require__(60));
	var _inheritsLoose = _interopDefault(__webpack_require__(107));
	var _assertThisInitialized = _interopDefault(__webpack_require__(106));
	var _objectWithoutPropertiesLoose = _interopDefault(__webpack_require__(110));
	
	var plainObjectConstrurctor = {}.constructor;
	function cloneStyle(style) {
	  if (style == null || typeof style !== 'object') return style;
	  if (Array.isArray(style)) return style.map(cloneStyle);
	  if (style.constructor !== plainObjectConstrurctor) return style;
	  var newStyle = {};
	
	  for (var name in style) {
	    newStyle[name] = cloneStyle(style[name]);
	  }
	
	  return newStyle;
	}
	
	/**
	 * Create a rule instance.
	 */
	
	function createRule(name, decl, options) {
	  if (name === void 0) {
	    name = 'unnamed';
	  }
	
	  var jss = options.jss;
	  var declCopy = cloneStyle(decl);
	  var rule = jss.plugins.onCreateRule(name, declCopy, options);
	  if (rule) return rule; // It is an at-rule and it has no instance.
	
	  if (name[0] === '@') {
	     false ? warning(false, "[JSS] Unknown rule " + name) : void 0;
	  }
	
	  return null;
	}
	
	var join = function join(value, by) {
	  var result = '';
	
	  for (var i = 0; i < value.length; i++) {
	    // Remove !important from the value, it will be readded later.
	    if (value[i] === '!important') break;
	    if (result) result += by;
	    result += value[i];
	  }
	
	  return result;
	};
	/**
	 * Converts array values to string.
	 *
	 * `margin: [['5px', '10px']]` > `margin: 5px 10px;`
	 * `border: ['1px', '2px']` > `border: 1px, 2px;`
	 * `margin: [['5px', '10px'], '!important']` > `margin: 5px 10px !important;`
	 * `color: ['red', !important]` > `color: red !important;`
	 */
	
	
	function toCssValue(value, ignoreImportant) {
	  if (ignoreImportant === void 0) {
	    ignoreImportant = false;
	  }
	
	  if (!Array.isArray(value)) return value;
	  var cssValue = ''; // Support space separated values via `[['5px', '10px']]`.
	
	  if (Array.isArray(value[0])) {
	    for (var i = 0; i < value.length; i++) {
	      if (value[i] === '!important') break;
	      if (cssValue) cssValue += ', ';
	      cssValue += join(value[i], ' ');
	    }
	  } else cssValue = join(value, ', '); // Add !important, because it was ignored.
	
	
	  if (!ignoreImportant && value[value.length - 1] === '!important') {
	    cssValue += ' !important';
	  }
	
	  return cssValue;
	}
	
	/**
	 * Indent a string.
	 * http://jsperf.com/array-join-vs-for
	 */
	function indentStr(str, indent) {
	  var result = '';
	
	  for (var index = 0; index < indent; index++) {
	    result += '  ';
	  }
	
	  return result + str;
	}
	/**
	 * Converts a Rule to CSS string.
	 */
	
	
	function toCss(selector, style, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var result = '';
	  if (!style) return result;
	  var _options = options,
	      _options$indent = _options.indent,
	      indent = _options$indent === void 0 ? 0 : _options$indent;
	  var fallbacks = style.fallbacks;
	  if (selector) indent++; // Apply fallbacks first.
	
	  if (fallbacks) {
	    // Array syntax {fallbacks: [{prop: value}]}
	    if (Array.isArray(fallbacks)) {
	      for (var index = 0; index < fallbacks.length; index++) {
	        var fallback = fallbacks[index];
	
	        for (var prop in fallback) {
	          var value = fallback[prop];
	
	          if (value != null) {
	            if (result) result += '\n';
	            result += "" + indentStr(prop + ": " + toCssValue(value) + ";", indent);
	          }
	        }
	      }
	    } else {
	      // Object syntax {fallbacks: {prop: value}}
	      for (var _prop in fallbacks) {
	        var _value = fallbacks[_prop];
	
	        if (_value != null) {
	          if (result) result += '\n';
	          result += "" + indentStr(_prop + ": " + toCssValue(_value) + ";", indent);
	        }
	      }
	    }
	  }
	
	  for (var _prop2 in style) {
	    var _value2 = style[_prop2];
	
	    if (_value2 != null && _prop2 !== 'fallbacks') {
	      if (result) result += '\n';
	      result += "" + indentStr(_prop2 + ": " + toCssValue(_value2) + ";", indent);
	    }
	  } // Allow empty style in this case, because properties will be added dynamically.
	
	
	  if (!result && !options.allowEmpty) return result; // When rule is being stringified before selector was defined.
	
	  if (!selector) return result;
	  indent--;
	  if (result) result = "\n" + result + "\n";
	  return indentStr(selector + " {" + result, indent) + indentStr('}', indent);
	}
	
	var escapeRegex = /([[\].#*$><+~=|^:(),"'`\s])/g;
	var nativeEscape = typeof CSS !== 'undefined' && CSS.escape;
	var escape = (function (str) {
	  return nativeEscape ? nativeEscape(str) : str.replace(escapeRegex, '\\$1');
	});
	
	var BaseStyleRule =
	/*#__PURE__*/
	function () {
	  function BaseStyleRule(key, style, options) {
	    this.type = 'style';
	    this.key = void 0;
	    this.isProcessed = false;
	    this.style = void 0;
	    this.renderer = void 0;
	    this.renderable = void 0;
	    this.options = void 0;
	    var sheet = options.sheet,
	        Renderer = options.Renderer;
	    this.key = key;
	    this.options = options;
	    this.style = style;
	    if (sheet) this.renderer = sheet.renderer;else if (Renderer) this.renderer = new Renderer();
	  }
	  /**
	   * Get or set a style property.
	   */
	
	
	  var _proto = BaseStyleRule.prototype;
	
	  _proto.prop = function prop(name, value, options) {
	    // It's a getter.
	    if (value === undefined) return this.style[name]; // Don't do anything if the value has not changed.
	
	    var force = options ? options.force : false;
	    if (!force && this.style[name] === value) return this;
	    var newValue = value;
	
	    if (!options || options.process !== false) {
	      newValue = this.options.jss.plugins.onChangeValue(value, name, this);
	    }
	
	    var isEmpty = newValue == null || newValue === false;
	    var isDefined = name in this.style; // Value is empty and wasn't defined before.
	
	    if (isEmpty && !isDefined && !force) return this; // We are going to remove this value.
	
	    var remove = isEmpty && isDefined;
	    if (remove) delete this.style[name];else this.style[name] = newValue; // Renderable is defined if StyleSheet option `link` is true.
	
	    if (this.renderable && this.renderer) {
	      if (remove) this.renderer.removeProperty(this.renderable, name);else this.renderer.setProperty(this.renderable, name, newValue);
	      return this;
	    }
	
	    var sheet = this.options.sheet;
	
	    if (sheet && sheet.attached) {
	       false ? warning(false, '[JSS] Rule is not linked. Missing sheet option "link: true".') : void 0;
	    }
	
	    return this;
	  };
	
	  return BaseStyleRule;
	}();
	var StyleRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose(StyleRule, _BaseStyleRule);
	
	  function StyleRule(key, style, options) {
	    var _this;
	
	    _this = _BaseStyleRule.call(this, key, style, options) || this;
	    _this.selectorText = void 0;
	    _this.id = void 0;
	    _this.renderable = void 0;
	    var selector = options.selector,
	        scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	
	    if (selector) {
	      _this.selectorText = selector;
	    } else if (scoped !== false) {
	      _this.id = generateId(_assertThisInitialized(_assertThisInitialized(_this)), sheet);
	      _this.selectorText = "." + escape(_this.id);
	    }
	
	    return _this;
	  }
	  /**
	   * Set selector string.
	   * Attention: use this with caution. Most browsers didn't implement
	   * selectorText setter, so this may result in rerendering of entire Style Sheet.
	   */
	
	
	  var _proto2 = StyleRule.prototype;
	
	  /**
	   * Apply rule to an element inline.
	   */
	  _proto2.applyTo = function applyTo(renderable) {
	    var renderer = this.renderer;
	
	    if (renderer) {
	      var json = this.toJSON();
	
	      for (var prop in json) {
	        renderer.setProperty(renderable, prop, json[prop]);
	      }
	    }
	
	    return this;
	  }
	  /**
	   * Returns JSON representation of the rule.
	   * Fallbacks are not supported.
	   * Useful for inline styles.
	   */
	  ;
	
	  _proto2.toJSON = function toJSON() {
	    var json = {};
	
	    for (var prop in this.style) {
	      var value = this.style[prop];
	      if (typeof value !== 'object') json[prop] = value;else if (Array.isArray(value)) json[prop] = toCssValue(value);
	    }
	
	    return json;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto2.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.selectorText, this.style, opts);
	  };
	
	  _createClass(StyleRule, [{
	    key: "selector",
	    set: function set(selector) {
	      if (selector === this.selectorText) return;
	      this.selectorText = selector;
	      var renderer = this.renderer,
	          renderable = this.renderable;
	      if (!renderable || !renderer) return;
	      var hasChanged = renderer.setSelector(renderable, selector); // If selector setter is not implemented, rerender the rule.
	
	      if (!hasChanged) {
	        renderer.replaceRule(renderable, this);
	      }
	    }
	    /**
	     * Get selector string.
	     */
	    ,
	    get: function get() {
	      return this.selectorText;
	    }
	  }]);
	
	  return StyleRule;
	}(BaseStyleRule);
	var pluginStyleRule = {
	  onCreateRule: function onCreateRule(name, style, options) {
	    if (name[0] === '@' || options.parent && options.parent.type === 'keyframes') {
	      return null;
	    }
	
	    return new StyleRule(name, style, options);
	  }
	};
	
	var defaultToStringOptions = {
	  indent: 1,
	  children: true
	};
	var atRegExp = /@([\w-]+)/;
	/**
	 * Conditional rule for @media, @supports
	 */
	
	var ConditionalRule =
	/*#__PURE__*/
	function () {
	  function ConditionalRule(key, styles, options) {
	    this.type = 'conditional';
	    this.at = void 0;
	    this.key = void 0;
	    this.query = void 0;
	    this.rules = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key; // Key might contain a unique suffix in case the `name` passed by user was duplicate.
	
	    this.query = options.name;
	    var atMatch = key.match(atRegExp);
	    this.at = atMatch ? atMatch[1] : 'unknown';
	    this.options = options;
	    this.rules = new RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = ConditionalRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions;
	    }
	
	    if (options.indent == null) options.indent = defaultToStringOptions.indent;
	    if (options.children == null) options.children = defaultToStringOptions.children;
	
	    if (options.children === false) {
	      return this.query + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    return children ? this.query + " {\n" + children + "\n}" : '';
	  };
	
	  return ConditionalRule;
	}();
	var keyRegExp = /@media|@supports\s+/;
	var pluginConditionalRule = {
	  onCreateRule: function onCreateRule(key, styles, options) {
	    return keyRegExp.test(key) ? new ConditionalRule(key, styles, options) : null;
	  }
	};
	
	var defaultToStringOptions$1 = {
	  indent: 1,
	  children: true
	};
	var nameRegExp = /@keyframes\s+([\w-]+)/;
	/**
	 * Rule for @keyframes
	 */
	
	var KeyframesRule =
	/*#__PURE__*/
	function () {
	  function KeyframesRule(key, frames, options) {
	    this.type = 'keyframes';
	    this.at = '@keyframes';
	    this.key = void 0;
	    this.name = void 0;
	    this.id = void 0;
	    this.rules = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    var nameMatch = key.match(nameRegExp);
	
	    if (nameMatch && nameMatch[1]) {
	      this.name = nameMatch[1];
	    } else {
	      this.name = 'noname';
	       false ? warning(false, "[JSS] Bad keyframes name " + key) : void 0;
	    }
	
	    this.key = this.type + "-" + this.name;
	    this.options = options;
	    var scoped = options.scoped,
	        sheet = options.sheet,
	        generateId = options.generateId;
	    this.id = scoped === false ? this.name : escape(generateId(this, sheet));
	    this.rules = new RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var name in frames) {
	      this.rules.add(name, frames[name], _extends({}, options, {
	        parent: this
	      }));
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = KeyframesRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (options === void 0) {
	      options = defaultToStringOptions$1;
	    }
	
	    if (options.indent == null) options.indent = defaultToStringOptions$1.indent;
	    if (options.children == null) options.children = defaultToStringOptions$1.children;
	
	    if (options.children === false) {
	      return this.at + " " + this.id + " {}";
	    }
	
	    var children = this.rules.toString(options);
	    if (children) children = "\n" + children + "\n";
	    return this.at + " " + this.id + " {" + children + "}";
	  };
	
	  return KeyframesRule;
	}();
	var keyRegExp$1 = /@keyframes\s+/;
	var refRegExp = /\$([\w-]+)/g;
	
	var findReferencedKeyframe = function findReferencedKeyframe(val, keyframes) {
	  if (typeof val === 'string') {
	    return val.replace(refRegExp, function (match, name) {
	      if (name in keyframes) {
	        return keyframes[name];
	      }
	
	       false ? warning(false, "[JSS] Referenced keyframes rule \"" + name + "\" is not defined.") : void 0;
	      return match;
	    });
	  }
	
	  return val;
	};
	/**
	 * Replace the reference for a animation name.
	 */
	
	
	var replaceRef = function replaceRef(style, prop, keyframes) {
	  var value = style[prop];
	  var refKeyframe = findReferencedKeyframe(value, keyframes);
	
	  if (refKeyframe !== value) {
	    style[prop] = refKeyframe;
	  }
	};
	
	var plugin = {
	  onCreateRule: function onCreateRule(key, frames, options) {
	    return typeof key === 'string' && keyRegExp$1.test(key) ? new KeyframesRule(key, frames, options) : null;
	  },
	  // Animation name ref replacer.
	  onProcessStyle: function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style' || !sheet) return style;
	    if ('animation-name' in style) replaceRef(style, 'animation-name', sheet.keyframes);
	    if ('animation' in style) replaceRef(style, 'animation', sheet.keyframes);
	    return style;
	  },
	  onChangeValue: function onChangeValue(val, prop, rule) {
	    var sheet = rule.options.sheet;
	
	    if (!sheet) {
	      return val;
	    }
	
	    switch (prop) {
	      case 'animation':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      case 'animation-name':
	        return findReferencedKeyframe(val, sheet.keyframes);
	
	      default:
	        return val;
	    }
	  }
	};
	
	var KeyframeRule =
	/*#__PURE__*/
	function (_BaseStyleRule) {
	  _inheritsLoose(KeyframeRule, _BaseStyleRule);
	
	  function KeyframeRule() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _BaseStyleRule.call.apply(_BaseStyleRule, [this].concat(args)) || this;
	    _this.renderable = void 0;
	    return _this;
	  }
	
	  var _proto = KeyframeRule.prototype;
	
	  /**
	   * Generates a CSS string.
	   */
	  _proto.toString = function toString(options) {
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	    var opts = link ? _extends({}, options, {
	      allowEmpty: true
	    }) : options;
	    return toCss(this.key, this.style, opts);
	  };
	
	  return KeyframeRule;
	}(BaseStyleRule);
	var pluginKeyframeRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    if (options.parent && options.parent.type === 'keyframes') {
	      return new KeyframeRule(key, style, options);
	    }
	
	    return null;
	  }
	};
	
	var FontFaceRule =
	/*#__PURE__*/
	function () {
	  function FontFaceRule(key, style, options) {
	    this.type = 'font-face';
	    this.at = '@font-face';
	    this.key = void 0;
	    this.style = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = FontFaceRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.style)) {
	      var str = '';
	
	      for (var index = 0; index < this.style.length; index++) {
	        str += toCss(this.at, this.style[index]);
	        if (this.style[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return toCss(this.at, this.style, options);
	  };
	
	  return FontFaceRule;
	}();
	var keyRegExp$2 = /@font-face/;
	var pluginFontFaceRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return keyRegExp$2.test(key) ? new FontFaceRule(key, style, options) : null;
	  }
	};
	
	var ViewportRule =
	/*#__PURE__*/
	function () {
	  function ViewportRule(key, style, options) {
	    this.type = 'viewport';
	    this.at = '@viewport';
	    this.key = void 0;
	    this.style = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.style = style;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	
	
	  var _proto = ViewportRule.prototype;
	
	  _proto.toString = function toString(options) {
	    return toCss(this.key, this.style, options);
	  };
	
	  return ViewportRule;
	}();
	var pluginViewportRule = {
	  onCreateRule: function onCreateRule(key, style, options) {
	    return key === '@viewport' || key === '@-ms-viewport' ? new ViewportRule(key, style, options) : null;
	  }
	};
	
	var SimpleRule =
	/*#__PURE__*/
	function () {
	  function SimpleRule(key, value, options) {
	    this.type = 'simple';
	    this.key = void 0;
	    this.value = void 0;
	    this.options = void 0;
	    this.isProcessed = false;
	    this.renderable = void 0;
	    this.key = key;
	    this.value = value;
	    this.options = options;
	  }
	  /**
	   * Generates a CSS string.
	   */
	  // eslint-disable-next-line no-unused-vars
	
	
	  var _proto = SimpleRule.prototype;
	
	  _proto.toString = function toString(options) {
	    if (Array.isArray(this.value)) {
	      var str = '';
	
	      for (var index = 0; index < this.value.length; index++) {
	        str += this.key + " " + this.value[index] + ";";
	        if (this.value[index + 1]) str += '\n';
	      }
	
	      return str;
	    }
	
	    return this.key + " " + this.value + ";";
	  };
	
	  return SimpleRule;
	}();
	var keysMap = {
	  '@charset': true,
	  '@import': true,
	  '@namespace': true
	};
	var pluginSimpleRule = {
	  onCreateRule: function onCreateRule(key, value, options) {
	    return key in keysMap ? new SimpleRule(key, value, options) : null;
	  }
	};
	
	var plugins = [pluginStyleRule, pluginConditionalRule, plugin, pluginKeyframeRule, pluginFontFaceRule, pluginViewportRule, pluginSimpleRule];
	
	var defaultUpdateOptions = {
	  process: true
	};
	var forceUpdateOptions = {
	  force: true,
	  process: true
	  /**
	   * Contains rules objects and allows adding/removing etc.
	   * Is used for e.g. by `StyleSheet` or `ConditionalRule`.
	   */
	
	};
	
	var RuleList =
	/*#__PURE__*/
	function () {
	  // Rules registry for access by .get() method.
	  // It contains the same rule registered by name and by selector.
	  // Original styles object.
	  // Used to ensure correct rules order.
	  function RuleList(options) {
	    this.map = {};
	    this.raw = {};
	    this.index = [];
	    this.counter = 0;
	    this.options = void 0;
	    this.classes = void 0;
	    this.keyframes = void 0;
	    this.options = options;
	    this.classes = options.classes;
	    this.keyframes = options.keyframes;
	  }
	  /**
	   * Create and register rule.
	   *
	   * Will not render after Style Sheet was rendered the first time.
	   */
	
	
	  var _proto = RuleList.prototype;
	
	  _proto.add = function add(name, decl, ruleOptions) {
	    var _this$options = this.options,
	        parent = _this$options.parent,
	        sheet = _this$options.sheet,
	        jss = _this$options.jss,
	        Renderer = _this$options.Renderer,
	        generateId = _this$options.generateId,
	        scoped = _this$options.scoped;
	
	    var options = _extends({
	      classes: this.classes,
	      parent: parent,
	      sheet: sheet,
	      jss: jss,
	      Renderer: Renderer,
	      generateId: generateId,
	      scoped: scoped,
	      name: name
	    }, ruleOptions); // When user uses .createStyleSheet(), duplicate names are not possible, but
	    // `sheet.addRule()` opens the door for any duplicate rule name. When this happens
	    // we need to make the key unique within this RuleList instance scope.
	
	
	    var key = name;
	
	    if (name in this.raw) {
	      key = name + "-d" + this.counter++;
	    } // We need to save the original decl before creating the rule
	    // because cache plugin needs to use it as a key to return a cached rule.
	
	
	    this.raw[key] = decl;
	
	    if (key in this.classes) {
	      // E.g. rules inside of @media container
	      options.selector = "." + escape(this.classes[key]);
	    }
	
	    var rule = createRule(key, decl, options);
	    if (!rule) return null;
	    this.register(rule);
	    var index = options.index === undefined ? this.index.length : options.index;
	    this.index.splice(index, 0, rule);
	    return rule;
	  }
	  /**
	   * Get a rule.
	   */
	  ;
	
	  _proto.get = function get(name) {
	    return this.map[name];
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.remove = function remove(rule) {
	    this.unregister(rule);
	    delete this.raw[rule.key];
	    this.index.splice(this.index.indexOf(rule), 1);
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.index.indexOf(rule);
	  }
	  /**
	   * Run `onProcessRule()` plugins on every rule.
	   */
	  ;
	
	  _proto.process = function process() {
	    var plugins$$1 = this.options.jss.plugins; // We need to clone array because if we modify the index somewhere else during a loop
	    // we end up with very hard-to-track-down side effects.
	
	    this.index.slice(0).forEach(plugins$$1.onProcessRule, plugins$$1);
	  }
	  /**
	   * Register a rule in `.map`, `.classes` and `.keyframes` maps.
	   */
	  ;
	
	  _proto.register = function register(rule) {
	    this.map[rule.key] = rule;
	
	    if (rule instanceof StyleRule) {
	      this.map[rule.selector] = rule;
	      if (rule.id) this.classes[rule.key] = rule.id;
	    } else if (rule instanceof KeyframesRule && this.keyframes) {
	      this.keyframes[rule.name] = rule.id;
	    }
	  }
	  /**
	   * Unregister a rule.
	   */
	  ;
	
	  _proto.unregister = function unregister(rule) {
	    delete this.map[rule.key];
	
	    if (rule instanceof StyleRule) {
	      delete this.map[rule.selector];
	      delete this.classes[rule.key];
	    } else if (rule instanceof KeyframesRule) {
	      delete this.keyframes[rule.name];
	    }
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var name;
	    var data;
	    var options;
	
	    if (typeof (arguments.length <= 0 ? undefined : arguments[0]) === 'string') {
	      name = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe
	
	      data = arguments.length <= 1 ? undefined : arguments[1]; // $FlowFixMe
	
	      options = arguments.length <= 2 ? undefined : arguments[2];
	    } else {
	      data = arguments.length <= 0 ? undefined : arguments[0]; // $FlowFixMe
	
	      options = arguments.length <= 1 ? undefined : arguments[1];
	      name = null;
	    }
	
	    if (name) {
	      this.updateOne(this.map[name], data, options);
	    } else {
	      for (var index = 0; index < this.index.length; index++) {
	        this.updateOne(this.index[index], data, options);
	      }
	    }
	  }
	  /**
	   * Execute plugins, update rule props.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    if (options === void 0) {
	      options = defaultUpdateOptions;
	    }
	
	    var _this$options2 = this.options,
	        plugins$$1 = _this$options2.jss.plugins,
	        sheet = _this$options2.sheet; // It is a rules container like for e.g. ConditionalRule.
	
	    if (rule.rules instanceof RuleList) {
	      rule.rules.update(data, options);
	      return;
	    }
	
	    var styleRule = rule;
	    var style = styleRule.style;
	    plugins$$1.onUpdate(data, rule, sheet, options); // We rely on a new `style` ref in case it was mutated during onUpdate hook.
	
	    if (options.process && style && style !== styleRule.style) {
	      // We need to run the plugins in case new `style` relies on syntax plugins.
	      plugins$$1.onProcessStyle(styleRule.style, styleRule, sheet); // Update and add props.
	
	      for (var prop in styleRule.style) {
	        var nextValue = styleRule.style[prop];
	        var prevValue = style[prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (nextValue !== prevValue) {
	          styleRule.prop(prop, nextValue, forceUpdateOptions);
	        }
	      } // Remove props.
	
	
	      for (var _prop in style) {
	        var _nextValue = styleRule.style[_prop];
	        var _prevValue = style[_prop]; // We need to use `force: true` because `rule.style` has been updated during onUpdate hook, so `rule.prop()` will not update the CSSOM rule.
	        // We do this comparison to avoid unneeded `rule.prop()` calls, since we have the old `style` object here.
	
	        if (_nextValue == null && _nextValue !== _prevValue) {
	          styleRule.prop(_prop, null, forceUpdateOptions);
	        }
	      }
	    }
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    var str = '';
	    var sheet = this.options.sheet;
	    var link = sheet ? sheet.options.link : false;
	
	    for (var index = 0; index < this.index.length; index++) {
	      var rule = this.index[index];
	      var css = rule.toString(options); // No need to render an empty rule.
	
	      if (!css && !link) continue;
	      if (str) str += '\n';
	      str += css;
	    }
	
	    return str;
	  };
	
	  return RuleList;
	}();
	
	var StyleSheet =
	/*#__PURE__*/
	function () {
	  function StyleSheet(styles, options) {
	    this.options = void 0;
	    this.deployed = void 0;
	    this.attached = void 0;
	    this.rules = void 0;
	    this.renderer = void 0;
	    this.classes = void 0;
	    this.keyframes = void 0;
	    this.queue = void 0;
	    this.attached = false;
	    this.deployed = false;
	    this.classes = {};
	    this.keyframes = {};
	    this.options = _extends({}, options, {
	      sheet: this,
	      parent: this,
	      classes: this.classes,
	      keyframes: this.keyframes
	    });
	
	    if (options.Renderer) {
	      this.renderer = new options.Renderer(this);
	    }
	
	    this.rules = new RuleList(this.options);
	
	    for (var name in styles) {
	      this.rules.add(name, styles[name]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Attach renderable to the render tree.
	   */
	
	
	  var _proto = StyleSheet.prototype;
	
	  _proto.attach = function attach() {
	    if (this.attached) return this;
	    if (this.renderer) this.renderer.attach();
	    this.attached = true; // Order is important, because we can't use insertRule API if style element is not attached.
	
	    if (!this.deployed) this.deploy();
	    return this;
	  }
	  /**
	   * Remove renderable from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    if (!this.attached) return this;
	    if (this.renderer) this.renderer.detach();
	    this.attached = false;
	    return this;
	  }
	  /**
	   * Add a rule to the current stylesheet.
	   * Will insert a rule also after the stylesheet has been rendered first time.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, decl, options) {
	    var queue = this.queue; // Plugins can create rules.
	    // In order to preserve the right order, we need to queue all `.addRule` calls,
	    // which happen after the first `rules.add()` call.
	
	    if (this.attached && !queue) this.queue = [];
	    var rule = this.rules.add(name, decl, options);
	    if (!rule) return null;
	    this.options.jss.plugins.onProcessRule(rule);
	
	    if (this.attached) {
	      if (!this.deployed) return rule; // Don't insert rule directly if there is no stringified version yet.
	      // It will be inserted all together when .attach is called.
	
	      if (queue) queue.push(rule);else {
	        this.insertRule(rule);
	
	        if (this.queue) {
	          this.queue.forEach(this.insertRule, this);
	          this.queue = undefined;
	        }
	      }
	      return rule;
	    } // We can't add rules to a detached style node.
	    // We will redeploy the sheet once user will attach it.
	
	
	    this.deployed = false;
	    return rule;
	  }
	  /**
	   * Insert rule into the StyleSheet
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule) {
	    if (this.renderer) {
	      this.renderer.insertRule(rule);
	    }
	  }
	  /**
	   * Create and add rules.
	   * Will render also after Style Sheet was rendered the first time.
	   */
	  ;
	
	  _proto.addRules = function addRules(styles, options) {
	    var added = [];
	
	    for (var name in styles) {
	      var rule = this.addRule(name, styles[name], options);
	      if (rule) added.push(rule);
	    }
	
	    return added;
	  }
	  /**
	   * Get a rule by name.
	   */
	  ;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Delete a rule by name.
	   * Returns `true`: if rule has been deleted from the DOM.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(name) {
	    var rule = typeof name === 'object' ? name : this.rules.get(name);
	    if (!rule) return false;
	    this.rules.remove(rule);
	
	    if (this.attached && rule.renderable && this.renderer) {
	      return this.renderer.deleteRule(rule.renderable);
	    }
	
	    return true;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Deploy pure CSS string to a renderable.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    if (this.renderer) this.renderer.deploy();
	    this.deployed = true;
	    return this;
	  }
	  /**
	   * Update the function values with a new data.
	   */
	  ;
	
	  _proto.update = function update() {
	    var _this$rules;
	
	    (_this$rules = this.rules).update.apply(_this$rules, arguments);
	
	    return this;
	  }
	  /**
	   * Updates a single rule.
	   */
	  ;
	
	  _proto.updateOne = function updateOne(rule, data, options) {
	    this.rules.updateOne(rule, data, options);
	    return this;
	  }
	  /**
	   * Convert rules to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(options) {
	    return this.rules.toString(options);
	  };
	
	  return StyleSheet;
	}();
	
	var PluginsRegistry =
	/*#__PURE__*/
	function () {
	  function PluginsRegistry() {
	    this.plugins = {
	      internal: [],
	      external: []
	    };
	    this.registry = void 0;
	  }
	
	  var _proto = PluginsRegistry.prototype;
	
	  /**
	   * Call `onCreateRule` hooks and return an object if returned by a hook.
	   */
	  _proto.onCreateRule = function onCreateRule(name, decl, options) {
	    for (var i = 0; i < this.registry.onCreateRule.length; i++) {
	      var rule = this.registry.onCreateRule[i](name, decl, options);
	      if (rule) return rule;
	    }
	
	    return null;
	  }
	  /**
	   * Call `onProcessRule` hooks.
	   */
	  ;
	
	  _proto.onProcessRule = function onProcessRule(rule) {
	    if (rule.isProcessed) return;
	    var sheet = rule.options.sheet;
	
	    for (var i = 0; i < this.registry.onProcessRule.length; i++) {
	      this.registry.onProcessRule[i](rule, sheet);
	    }
	
	    if (rule.style) this.onProcessStyle(rule.style, rule, sheet);
	    rule.isProcessed = true;
	  }
	  /**
	   * Call `onProcessStyle` hooks.
	   */
	  ;
	
	  _proto.onProcessStyle = function onProcessStyle(style, rule, sheet) {
	    for (var i = 0; i < this.registry.onProcessStyle.length; i++) {
	      // $FlowFixMe
	      rule.style = this.registry.onProcessStyle[i](rule.style, rule, sheet);
	    }
	  }
	  /**
	   * Call `onProcessSheet` hooks.
	   */
	  ;
	
	  _proto.onProcessSheet = function onProcessSheet(sheet) {
	    for (var i = 0; i < this.registry.onProcessSheet.length; i++) {
	      this.registry.onProcessSheet[i](sheet);
	    }
	  }
	  /**
	   * Call `onUpdate` hooks.
	   */
	  ;
	
	  _proto.onUpdate = function onUpdate(data, rule, sheet, options) {
	    for (var i = 0; i < this.registry.onUpdate.length; i++) {
	      this.registry.onUpdate[i](data, rule, sheet, options);
	    }
	  }
	  /**
	   * Call `onChangeValue` hooks.
	   */
	  ;
	
	  _proto.onChangeValue = function onChangeValue(value, prop, rule) {
	    var processedValue = value;
	
	    for (var i = 0; i < this.registry.onChangeValue.length; i++) {
	      processedValue = this.registry.onChangeValue[i](processedValue, prop, rule);
	    }
	
	    return processedValue;
	  }
	  /**
	   * Register a plugin.
	   */
	  ;
	
	  _proto.use = function use(newPlugin, options) {
	    if (options === void 0) {
	      options = {
	        queue: 'external'
	      };
	    }
	
	    var plugins = this.plugins[options.queue]; // Avoids applying same plugin twice, at least based on ref.
	
	    if (plugins.indexOf(newPlugin) !== -1) {
	      return;
	    }
	
	    plugins.push(newPlugin);
	    this.registry = [].concat(this.plugins.external, this.plugins.internal).reduce(function (registry, plugin) {
	      for (var name in plugin) {
	        if (name in registry) {
	          registry[name].push(plugin[name]);
	        } else {
	           false ? warning(false, "[JSS] Unknown hook \"" + name + "\".") : void 0;
	        }
	      }
	
	      return registry;
	    }, {
	      onCreateRule: [],
	      onProcessRule: [],
	      onProcessStyle: [],
	      onProcessSheet: [],
	      onChangeValue: [],
	      onUpdate: []
	    });
	  };
	
	  return PluginsRegistry;
	}();
	
	/**
	 * Sheets registry to access them all at one place.
	 */
	var SheetsRegistry =
	/*#__PURE__*/
	function () {
	  function SheetsRegistry() {
	    this.registry = [];
	  }
	
	  var _proto = SheetsRegistry.prototype;
	
	  /**
	   * Register a Style Sheet.
	   */
	  _proto.add = function add(sheet) {
	    var registry = this.registry;
	    var index = sheet.options.index;
	    if (registry.indexOf(sheet) !== -1) return;
	
	    if (registry.length === 0 || index >= this.index) {
	      registry.push(sheet);
	      return;
	    } // Find a position.
	
	
	    for (var i = 0; i < registry.length; i++) {
	      if (registry[i].options.index > index) {
	        registry.splice(i, 0, sheet);
	        return;
	      }
	    }
	  }
	  /**
	   * Reset the registry.
	   */
	  ;
	
	  _proto.reset = function reset() {
	    this.registry = [];
	  }
	  /**
	   * Remove a Style Sheet.
	   */
	  ;
	
	  _proto.remove = function remove(sheet) {
	    var index = this.registry.indexOf(sheet);
	    this.registry.splice(index, 1);
	  }
	  /**
	   * Convert all attached sheets to a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString(_temp) {
	    var _ref = _temp === void 0 ? {} : _temp,
	        attached = _ref.attached,
	        options = _objectWithoutPropertiesLoose(_ref, ["attached"]);
	
	    var css = '';
	
	    for (var i = 0; i < this.registry.length; i++) {
	      var sheet = this.registry[i];
	
	      if (attached != null && sheet.attached !== attached) {
	        continue;
	      }
	
	      if (css) css += '\n';
	      css += sheet.toString(options);
	    }
	
	    return css;
	  };
	
	  _createClass(SheetsRegistry, [{
	    key: "index",
	
	    /**
	     * Current highest index number.
	     */
	    get: function get() {
	      return this.registry.length === 0 ? 0 : this.registry[this.registry.length - 1].options.index;
	    }
	  }]);
	
	  return SheetsRegistry;
	}();
	
	/**
	 * This is a global sheets registry. Only DomRenderer will add sheets to it.
	 * On the server one should use an own SheetsRegistry instance and add the
	 * sheets to it, because you need to make sure to create a new registry for
	 * each request in order to not leak sheets across requests.
	 */
	
	var sheets = new SheetsRegistry();
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var globalThis = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	var ns = '2f1acc6c3a606b082e5eef5e54414ffb';
	if (globalThis[ns] == null) globalThis[ns] = 0; // Bundle may contain multiple JSS versions at the same time. In order to identify
	// the current version with just one short number and use it for classes generation
	// we use a counter. Also it is more accurate, because user can manually reevaluate
	// the module.
	
	var moduleId = globalThis[ns]++;
	
	var maxRules = 1e10;
	
	/**
	 * Returns a function which generates unique class names based on counters.
	 * When new generator function is created, rule counter is reseted.
	 * We need to reset the rule counter for SSR for each request.
	 */
	var createGenerateId = function createGenerateId(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var ruleCounter = 0;
	  return function (rule, sheet) {
	    ruleCounter += 1;
	
	    if (ruleCounter > maxRules) {
	       false ? warning(false, "[JSS] You might have a memory leak. Rule counter is at " + ruleCounter + ".") : void 0;
	    }
	
	    var jssId = '';
	    var prefix = '';
	
	    if (sheet) {
	      if (sheet.options.classNamePrefix) {
	        prefix = sheet.options.classNamePrefix;
	      }
	
	      if (sheet.options.jss.id != null) {
	        jssId = String(sheet.options.jss.id);
	      }
	    }
	
	    if (options.minify) {
	      // Using "c" because a number can't be the first char in a class name.
	      return "" + (prefix || 'c') + moduleId + jssId + ruleCounter;
	    }
	
	    return prefix + rule.key + "-" + moduleId + (jssId ? "-" + jssId : '') + "-" + ruleCounter;
	  };
	};
	
	/**
	 * Cache the value from the first time a function is called.
	 */
	var memoize = function memoize(fn) {
	  var value;
	  return function () {
	    if (!value) value = fn();
	    return value;
	  };
	};
	/**
	 * Get a style property value.
	 */
	
	
	function getPropertyValue(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      return cssRule.attributeStyleMap.get(prop);
	    }
	
	    return cssRule.style.getPropertyValue(prop);
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return '';
	  }
	}
	/**
	 * Set a style property.
	 */
	
	
	function setProperty(cssRule, prop, value) {
	  try {
	    var cssValue = value;
	
	    if (Array.isArray(value)) {
	      cssValue = toCssValue(value, true);
	
	      if (value[value.length - 1] === '!important') {
	        cssRule.style.setProperty(prop, cssValue, 'important');
	        return true;
	      }
	    } // Support CSSTOM.
	
	
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.set(prop, cssValue);
	    } else {
	      cssRule.style.setProperty(prop, cssValue);
	    }
	  } catch (err) {
	    // IE may throw if property is unknown.
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Remove a style property.
	 */
	
	
	function removeProperty(cssRule, prop) {
	  try {
	    // Support CSSTOM.
	    if (cssRule.attributeStyleMap) {
	      cssRule.attributeStyleMap.delete(prop);
	    } else {
	      cssRule.style.removeProperty(prop);
	    }
	  } catch (err) {
	     false ? warning(false, "[JSS] DOMException \"" + err.message + "\" was thrown. Tried to remove property \"" + prop + "\".") : void 0;
	  }
	}
	/**
	 * Set the selector.
	 */
	
	
	function setSelector(cssRule, selectorText) {
	  cssRule.selectorText = selectorText; // Return false if setter was not successful.
	  // Currently works in chrome only.
	
	  return cssRule.selectorText === selectorText;
	}
	/**
	 * Gets the `head` element upon the first call and caches it.
	 * We assume it can't be null.
	 */
	
	
	var getHead = memoize(function () {
	  return document.querySelector('head');
	});
	/**
	 * Find attached sheet with an index higher than the passed one.
	 */
	
	function findHigherSheet(registry, options) {
	  for (var i = 0; i < registry.length; i++) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.index > options.index && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find attached sheet with the highest index.
	 */
	
	
	function findHighestSheet(registry, options) {
	  for (var i = registry.length - 1; i >= 0; i--) {
	    var sheet = registry[i];
	
	    if (sheet.attached && sheet.options.insertionPoint === options.insertionPoint) {
	      return sheet;
	    }
	  }
	
	  return null;
	}
	/**
	 * Find a comment with "jss" inside.
	 */
	
	
	function findCommentNode(text) {
	  var head = getHead();
	
	  for (var i = 0; i < head.childNodes.length; i++) {
	    var node = head.childNodes[i];
	
	    if (node.nodeType === 8 && node.nodeValue.trim() === text) {
	      return node;
	    }
	  }
	
	  return null;
	}
	
	/**
	 * Find a node before which we can insert the sheet.
	 */
	function findPrevNode(options) {
	  var registry = sheets.registry;
	
	  if (registry.length > 0) {
	    // Try to insert before the next higher sheet.
	    var sheet = findHigherSheet(registry, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element
	      };
	    } // Otherwise insert after the last attached.
	
	
	    sheet = findHighestSheet(registry, options);
	
	    if (sheet && sheet.renderer) {
	      return {
	        parent: sheet.renderer.element.parentNode,
	        node: sheet.renderer.element.nextSibling
	      };
	    }
	  } // Try to find a comment placeholder if registry is empty.
	
	
	  var insertionPoint = options.insertionPoint;
	
	  if (insertionPoint && typeof insertionPoint === 'string') {
	    var comment = findCommentNode(insertionPoint);
	
	    if (comment) {
	      return {
	        parent: comment.parentNode,
	        node: comment.nextSibling
	      };
	    } // If user specifies an insertion point and it can't be found in the document -
	    // bad specificity issues may appear.
	
	
	     false ? warning(false, "[JSS] Insertion point \"" + insertionPoint + "\" not found.") : void 0;
	  }
	
	  return false;
	}
	/**
	 * Insert style element into the DOM.
	 */
	
	
	function insertStyle(style, options) {
	  var insertionPoint = options.insertionPoint;
	  var nextNode = findPrevNode(options);
	
	  if (nextNode !== false && nextNode.parent) {
	    nextNode.parent.insertBefore(style, nextNode.node);
	    return;
	  } // Works with iframes and any node types.
	
	
	  if (insertionPoint && typeof insertionPoint.nodeType === 'number') {
	    // https://stackoverflow.com/questions/41328728/force-casting-in-flow
	    var insertionPointElement = insertionPoint;
	    var parentNode = insertionPointElement.parentNode;
	    if (parentNode) parentNode.insertBefore(style, insertionPointElement.nextSibling);else  false ? warning(false, '[JSS] Insertion point is not in the DOM.') : void 0;
	    return;
	  }
	
	  getHead().appendChild(style);
	}
	/**
	 * Read jss nonce setting from the page if the user has set it.
	 */
	
	
	var getNonce = memoize(function () {
	  var node = document.querySelector('meta[property="csp-nonce"]');
	  return node ? node.getAttribute('content') : null;
	});
	
	var _insertRule = function insertRule(container, rule, index) {
	  var maxIndex = container.cssRules.length; // In case previous insertion fails, passed index might be wrong
	
	  if (index === undefined || index > maxIndex) {
	    // eslint-disable-next-line no-param-reassign
	    index = maxIndex;
	  }
	
	  try {
	    if ('insertRule' in container) {
	      var c = container;
	      c.insertRule(rule, index);
	    } // Keyframes rule.
	    else if ('appendRule' in container) {
	        var _c = container;
	
	        _c.appendRule(rule);
	      }
	  } catch (err) {
	     false ? warning(false, "[JSS] " + err.message) : void 0;
	    return false;
	  }
	
	  return container.cssRules[index];
	};
	
	var createStyle = function createStyle() {
	  var el = document.createElement('style'); // Without it, IE will have a broken source order specificity if we
	  // insert rules after we insert the style tag.
	  // It seems to kick-off the source order specificity algorithm.
	
	  el.textContent = '\n';
	  return el;
	};
	
	var DomRenderer =
	/*#__PURE__*/
	function () {
	  // HTMLStyleElement needs fixing https://github.com/facebook/flow/issues/2696
	  function DomRenderer(sheet) {
	    this.getPropertyValue = getPropertyValue;
	    this.setProperty = setProperty;
	    this.removeProperty = removeProperty;
	    this.setSelector = setSelector;
	    this.element = void 0;
	    this.sheet = void 0;
	    this.hasInsertedRules = false;
	    // There is no sheet when the renderer is used from a standalone StyleRule.
	    if (sheet) sheets.add(sheet);
	    this.sheet = sheet;
	
	    var _ref = this.sheet ? this.sheet.options : {},
	        media = _ref.media,
	        meta = _ref.meta,
	        element = _ref.element;
	
	    this.element = element || createStyle();
	    this.element.setAttribute('data-jss', '');
	    if (media) this.element.setAttribute('media', media);
	    if (meta) this.element.setAttribute('data-meta', meta);
	    var nonce = getNonce();
	    if (nonce) this.element.setAttribute('nonce', nonce);
	  }
	  /**
	   * Insert style element into render tree.
	   */
	
	
	  var _proto = DomRenderer.prototype;
	
	  _proto.attach = function attach() {
	    // In the case the element node is external and it is already in the DOM.
	    if (this.element.parentNode || !this.sheet) return;
	    insertStyle(this.element, this.sheet.options); // When rules are inserted using `insertRule` API, after `sheet.detach().attach()`
	    // most browsers create a new CSSStyleSheet, except of all IEs.
	
	    var deployed = Boolean(this.sheet && this.sheet.deployed);
	
	    if (this.hasInsertedRules && deployed) {
	      this.hasInsertedRules = false;
	      this.deploy();
	    }
	  }
	  /**
	   * Remove style element from render tree.
	   */
	  ;
	
	  _proto.detach = function detach() {
	    var parentNode = this.element.parentNode;
	    if (parentNode) parentNode.removeChild(this.element);
	  }
	  /**
	   * Inject CSS string into element.
	   */
	  ;
	
	  _proto.deploy = function deploy() {
	    var sheet = this.sheet;
	    if (!sheet) return;
	
	    if (sheet.options.link) {
	      this.insertRules(sheet.rules);
	      return;
	    }
	
	    this.element.textContent = "\n" + sheet.toString() + "\n";
	  }
	  /**
	   * Insert RuleList into an element.
	   */
	  ;
	
	  _proto.insertRules = function insertRules(rules, nativeParent) {
	    for (var i = 0; i < rules.index.length; i++) {
	      this.insertRule(rules.index[i], i, nativeParent);
	    }
	  }
	  /**
	   * Insert a rule into element.
	   */
	  ;
	
	  _proto.insertRule = function insertRule(rule, index, nativeParent) {
	    if (nativeParent === void 0) {
	      nativeParent = this.element.sheet;
	    }
	
	    if (rule.rules) {
	      var parent = rule;
	      var latestNativeParent = nativeParent;
	
	      if (rule.type === 'conditional' || rule.type === 'keyframes') {
	        // We need to render the container without children first.
	        latestNativeParent = _insertRule(nativeParent, parent.toString({
	          children: false
	        }), index);
	
	        if (latestNativeParent === false) {
	          return false;
	        }
	      }
	
	      this.insertRules(parent.rules, latestNativeParent);
	      return latestNativeParent;
	    } // IE keeps the CSSStyleSheet after style node has been reattached,
	    // so we need to check if the `renderable` reference the right style sheet and not
	    // rerender those rules.
	
	
	    if (rule.renderable && rule.renderable.parentStyleSheet === this.element.sheet) {
	      return rule.renderable;
	    }
	
	    var ruleStr = rule.toString();
	    if (!ruleStr) return false;
	
	    var nativeRule = _insertRule(nativeParent, ruleStr, index);
	
	    if (nativeRule === false) {
	      return false;
	    }
	
	    this.hasInsertedRules = true;
	    rule.renderable = nativeRule;
	    return nativeRule;
	  }
	  /**
	   * Delete a rule.
	   */
	  ;
	
	  _proto.deleteRule = function deleteRule(cssRule) {
	    var sheet = this.element.sheet;
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    sheet.deleteRule(index);
	    return true;
	  }
	  /**
	   * Get index of a CSS Rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(cssRule) {
	    var cssRules = this.element.sheet.cssRules;
	
	    for (var index = 0; index < cssRules.length; index++) {
	      if (cssRule === cssRules[index]) return index;
	    }
	
	    return -1;
	  }
	  /**
	   * Generate a new CSS rule and replace the existing one.
	   *
	   * Only used for some old browsers because they can't set a selector.
	   */
	  ;
	
	  _proto.replaceRule = function replaceRule(cssRule, rule) {
	    var index = this.indexOf(cssRule);
	    if (index === -1) return false;
	    this.element.sheet.deleteRule(index);
	    return this.insertRule(rule, index);
	  }
	  /**
	   * Get all rules elements.
	   */
	  ;
	
	  _proto.getRules = function getRules() {
	    return this.element.sheet.cssRules;
	  };
	
	  return DomRenderer;
	}();
	
	var instanceCounter = 0;
	
	var Jss =
	/*#__PURE__*/
	function () {
	  function Jss(options) {
	    this.id = instanceCounter++;
	    this.version = "10.1.1";
	    this.plugins = new PluginsRegistry();
	    this.options = {
	      id: {
	        minify: false
	      },
	      createGenerateId: createGenerateId,
	      Renderer: isInBrowser ? DomRenderer : null,
	      plugins: []
	    };
	    this.generateId = createGenerateId({
	      minify: false
	    });
	
	    for (var i = 0; i < plugins.length; i++) {
	      this.plugins.use(plugins[i], {
	        queue: 'internal'
	      });
	    }
	
	    this.setup(options);
	  }
	  /**
	   * Prepares various options, applies plugins.
	   * Should not be used twice on the same instance, because there is no plugins
	   * deduplication logic.
	   */
	
	
	  var _proto = Jss.prototype;
	
	  _proto.setup = function setup(options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    if (options.createGenerateId) {
	      this.options.createGenerateId = options.createGenerateId;
	    }
	
	    if (options.id) {
	      this.options.id = _extends({}, this.options.id, options.id);
	    }
	
	    if (options.createGenerateId || options.id) {
	      this.generateId = this.options.createGenerateId(this.options.id);
	    }
	
	    if (options.insertionPoint != null) this.options.insertionPoint = options.insertionPoint;
	
	    if ('Renderer' in options) {
	      this.options.Renderer = options.Renderer;
	    } // eslint-disable-next-line prefer-spread
	
	
	    if (options.plugins) this.use.apply(this, options.plugins);
	    return this;
	  }
	  /**
	   * Create a Style Sheet.
	   */
	  ;
	
	  _proto.createStyleSheet = function createStyleSheet(styles, options) {
	    if (options === void 0) {
	      options = {};
	    }
	
	    var _options = options,
	        index = _options.index;
	
	    if (typeof index !== 'number') {
	      index = sheets.index === 0 ? 0 : sheets.index + 1;
	    }
	
	    var sheet = new StyleSheet(styles, _extends({}, options, {
	      jss: this,
	      generateId: options.generateId || this.generateId,
	      insertionPoint: this.options.insertionPoint,
	      Renderer: this.options.Renderer,
	      index: index
	    }));
	    this.plugins.onProcessSheet(sheet);
	    return sheet;
	  }
	  /**
	   * Detach the Style Sheet and remove it from the registry.
	   */
	  ;
	
	  _proto.removeStyleSheet = function removeStyleSheet(sheet) {
	    sheet.detach();
	    sheets.remove(sheet);
	    return this;
	  }
	  /**
	   * Create a rule without a Style Sheet.
	   * [Deprecated] will be removed in the next major version.
	   */
	  ;
	
	  _proto.createRule = function createRule$$1(name, style, options) {
	    if (style === void 0) {
	      style = {};
	    }
	
	    if (options === void 0) {
	      options = {};
	    }
	
	    // Enable rule without name for inline styles.
	    if (typeof name === 'object') {
	      return this.createRule(undefined, name, style);
	    }
	
	    var ruleOptions = _extends({}, options, {
	      name: name,
	      jss: this,
	      Renderer: this.options.Renderer
	    });
	
	    if (!ruleOptions.generateId) ruleOptions.generateId = this.generateId;
	    if (!ruleOptions.classes) ruleOptions.classes = {};
	    if (!ruleOptions.keyframes) ruleOptions.keyframes = {};
	
	    var rule = createRule(name, style, ruleOptions);
	
	    if (rule) this.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Register plugin. Passed function will be invoked with a rule instance.
	   */
	  ;
	
	  _proto.use = function use() {
	    var _this = this;
	
	    for (var _len = arguments.length, plugins$$1 = new Array(_len), _key = 0; _key < _len; _key++) {
	      plugins$$1[_key] = arguments[_key];
	    }
	
	    plugins$$1.forEach(function (plugin) {
	      _this.plugins.use(plugin);
	    });
	    return this;
	  };
	
	  return Jss;
	}();
	
	/**
	 * Extracts a styles object with only props that contain function values.
	 */
	function getDynamicStyles(styles) {
	  var to = null;
	
	  for (var key in styles) {
	    var value = styles[key];
	    var type = typeof value;
	
	    if (type === 'function') {
	      if (!to) to = {};
	      to[key] = value;
	    } else if (type === 'object' && value !== null && !Array.isArray(value)) {
	      var extracted = getDynamicStyles(value);
	
	      if (extracted) {
	        if (!to) to = {};
	        to[key] = extracted;
	      }
	    }
	  }
	
	  return to;
	}
	
	/**
	 * SheetsManager is like a WeakMap which is designed to count StyleSheet
	 * instances and attach/detach automatically.
	 */
	var SheetsManager =
	/*#__PURE__*/
	function () {
	  function SheetsManager() {
	    this.length = 0;
	    this.sheets = new WeakMap();
	  }
	
	  var _proto = SheetsManager.prototype;
	
	  _proto.get = function get(key) {
	    var entry = this.sheets.get(key);
	    return entry && entry.sheet;
	  };
	
	  _proto.add = function add(key, sheet) {
	    if (this.sheets.has(key)) return;
	    this.length++;
	    this.sheets.set(key, {
	      sheet: sheet,
	      refs: 0
	    });
	  };
	
	  _proto.manage = function manage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs === 0) {
	        entry.sheet.attach();
	      }
	
	      entry.refs++;
	      return entry.sheet;
	    }
	
	    warning(false, "[JSS] SheetsManager: can't find sheet to manage");
	    return undefined;
	  };
	
	  _proto.unmanage = function unmanage(key) {
	    var entry = this.sheets.get(key);
	
	    if (entry) {
	      if (entry.refs > 0) {
	        entry.refs--;
	        if (entry.refs === 0) entry.sheet.detach();
	      }
	    } else {
	      warning(false, "SheetsManager: can't find sheet to unmanage");
	    }
	  };
	
	  _createClass(SheetsManager, [{
	    key: "size",
	    get: function get() {
	      return this.length;
	    }
	  }]);
	
	  return SheetsManager;
	}();
	
	/**
	 * A better abstraction over CSS.
	 *
	 * @copyright Oleg Isonen (Slobodskoi) / Isonen 2014-present
	 * @website https://github.com/cssinjs/jss
	 * @license MIT
	 */
	
	/**
	 * Export a constant indicating if this browser has CSSTOM support.
	 * https://developers.google.com/web/updates/2018/03/cssom
	 */
	var hasCSSTOMSupport = typeof CSS !== 'undefined' && CSS && 'number' in CSS;
	/**
	 * Creates a new instance of Jss.
	 */
	
	var create = function create(options) {
	  return new Jss(options);
	};
	/**
	 * A global Jss instance.
	 */
	
	var index = create();
	
	exports.hasCSSTOMSupport = hasCSSTOMSupport;
	exports.create = create;
	exports.default = index;
	exports.getDynamicStyles = getDynamicStyles;
	exports.toCssValue = toCssValue;
	exports.createRule = createRule;
	exports.SheetsRegistry = SheetsRegistry;
	exports.SheetsManager = SheetsManager;
	exports.RuleList = RuleList;
	exports.sheets = sheets;
	exports.createGenerateId = createGenerateId;


/***/ },
/* 41 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	function warning(condition, message) {
	  if (!isProduction) {
	    if (condition) {
	      return;
	    }
	
	    var text = "Warning: " + message;
	
	    if (typeof console !== 'undefined') {
	      console.warn(text);
	    }
	
	    try {
	      throw Error(text);
	    } catch (x) {}
	  }
	}
	
	module.exports = warning;


/***/ },
/* 42 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup.default;
	  }
	});
	
	var _ButtonGroup = _interopRequireDefault(__webpack_require__(238));

/***/ },
/* 43 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = formControlState;
	
	function formControlState(_ref) {
	  var props = _ref.props,
	      states = _ref.states,
	      muiFormControl = _ref.muiFormControl;
	  return states.reduce(function (acc, state) {
	    acc[state] = props[state];
	
	    if (muiFormControl) {
	      if (typeof props[state] === 'undefined') {
	        acc[state] = muiFormControl[state];
	      }
	    }
	
	    return acc;
	  }, {});
	}

/***/ },
/* 44 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getTransitionProps = getTransitionProps;
	exports.reflow = void 0;
	
	var reflow = function reflow(node) {
	  return node.scrollTop;
	};
	
	exports.reflow = reflow;
	
	function getTransitionProps(props, options) {
	  var timeout = props.timeout,
	      _props$style = props.style,
	      style = _props$style === void 0 ? {} : _props$style;
	  return {
	    duration: style.transitionDuration || typeof timeout === 'number' ? timeout : timeout[options.mode] || 0,
	    delay: style.transitionDelay
	  };
	}

/***/ },
/* 45 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _class, _class2, _temp;
	
	/* Decorators */
	
	
	/* Utils */
	
	
	/* CSS */
	
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	var _classnames = __webpack_require__(503);
	
	var _classnames2 = _interopRequireDefault(_classnames);
	
	var _staticMethods = __webpack_require__(585);
	
	var _staticMethods2 = _interopRequireDefault(_staticMethods);
	
	var _windowListener = __webpack_require__(587);
	
	var _windowListener2 = _interopRequireDefault(_windowListener);
	
	var _customEvent = __webpack_require__(186);
	
	var _customEvent2 = _interopRequireDefault(_customEvent);
	
	var _isCapture = __webpack_require__(584);
	
	var _isCapture2 = _interopRequireDefault(_isCapture);
	
	var _getEffect = __webpack_require__(583);
	
	var _getEffect2 = _interopRequireDefault(_getEffect);
	
	var _bodyMode = __webpack_require__(582);
	
	var _bodyMode2 = _interopRequireDefault(_bodyMode);
	
	var _trackRemoval = __webpack_require__(586);
	
	var _trackRemoval2 = _interopRequireDefault(_trackRemoval);
	
	var _getPosition = __webpack_require__(590);
	
	var _getPosition2 = _interopRequireDefault(_getPosition);
	
	var _getTipContent = __webpack_require__(591);
	
	var _getTipContent2 = _interopRequireDefault(_getTipContent);
	
	var _aria = __webpack_require__(589);
	
	var _nodeListToArray = __webpack_require__(592);
	
	var _nodeListToArray2 = _interopRequireDefault(_nodeListToArray);
	
	var _style = __webpack_require__(588);
	
	var _style2 = _interopRequireDefault(_style);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var ReactTooltip = (0, _staticMethods2.default)(_class = (0, _windowListener2.default)(_class = (0, _customEvent2.default)(_class = (0, _isCapture2.default)(_class = (0, _getEffect2.default)(_class = (0, _bodyMode2.default)(_class = (0, _trackRemoval2.default)(_class = (_temp = _class2 = function (_React$Component) {
	  _inherits(ReactTooltip, _React$Component);
	
	  function ReactTooltip(props) {
	    _classCallCheck(this, ReactTooltip);
	
	    var _this = _possibleConstructorReturn(this, (ReactTooltip.__proto__ || Object.getPrototypeOf(ReactTooltip)).call(this, props));
	
	    _this.state = {
	      place: props.place || 'top', // Direction of tooltip
	      desiredPlace: props.place || 'top',
	      type: 'dark', // Color theme of tooltip
	      effect: 'float', // float or fixed
	      show: false,
	      border: false,
	      offset: {},
	      extraClass: '',
	      html: false,
	      delayHide: 0,
	      delayShow: 0,
	      event: props.event || null,
	      eventOff: props.eventOff || null,
	      currentEvent: null, // Current mouse event
	      currentTarget: null, // Current target of mouse event
	      ariaProps: (0, _aria.parseAria)(props), // aria- and role attributes
	      isEmptyTip: false,
	      disable: false,
	      possibleCustomEvents: props.possibleCustomEvents || '',
	      possibleCustomEventsOff: props.possibleCustomEventsOff || '',
	      originTooltip: null,
	      isMultiline: false
	    };
	
	    _this.bind(['showTooltip', 'updateTooltip', 'hideTooltip', 'hideTooltipOnScroll', 'getTooltipContent', 'globalRebuild', 'globalShow', 'globalHide', 'onWindowResize', 'mouseOnToolTip']);
	
	    _this.mount = true;
	    _this.delayShowLoop = null;
	    _this.delayHideLoop = null;
	    _this.delayReshow = null;
	    _this.intervalUpdateContent = null;
	    return _this;
	  }
	
	  /**
	   * For unify the bind and unbind listener
	   */
	
	
	  _createClass(ReactTooltip, [{
	    key: 'bind',
	    value: function bind(methodArray) {
	      var _this2 = this;
	
	      methodArray.forEach(function (method) {
	        _this2[method] = _this2[method].bind(_this2);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          insecure = _props.insecure,
	          resizeHide = _props.resizeHide;
	
	      if (insecure) {
	        this.setStyleHeader(); // Set the style to the <link>
	      }
	
	      this.bindListener(); // Bind listener for tooltip
	      this.bindWindowEvents(resizeHide); // Bind global event for static method
	    }
	  }, {
	    key: 'componentWillUnmount',
	    value: function componentWillUnmount() {
	      this.mount = false;
	
	      this.clearTimer();
	
	      this.unbindListener();
	      this.removeScrollListener();
	      this.unbindWindowEvents();
	    }
	
	    /**
	     * Return if the mouse is on the tooltip.
	     * @returns {boolean} true - mouse is on the tooltip
	     */
	
	  }, {
	    key: 'mouseOnToolTip',
	    value: function mouseOnToolTip() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        /* old IE or Firefox work around */
	        if (!this.tooltipRef.matches) {
	          /* old IE work around */
	          if (this.tooltipRef.msMatchesSelector) {
	            this.tooltipRef.matches = this.tooltipRef.msMatchesSelector;
	          } else {
	            /* old Firefox work around */
	            this.tooltipRef.matches = this.tooltipRef.mozMatchesSelector;
	          }
	        }
	        return this.tooltipRef.matches(':hover');
	      }
	      return false;
	    }
	    /**
	     * Pick out corresponded target elements
	     */
	
	  }, {
	    key: 'getTargetArray',
	    value: function getTargetArray(id) {
	      var targetArray = void 0;
	      if (!id) {
	        targetArray = document.querySelectorAll('[data-tip]:not([data-for])');
	      } else {
	        var escaped = id.replace(/\\/g, '\\\\').replace(/"/g, '\\"');
	        targetArray = document.querySelectorAll('[data-tip][data-for="' + escaped + '"]');
	      }
	      // targetArray is a NodeList, convert it to a real array
	      return (0, _nodeListToArray2.default)(targetArray);
	    }
	
	    /**
	     * Bind listener to the target elements
	     * These listeners used to trigger showing or hiding the tooltip
	     */
	
	  }, {
	    key: 'bindListener',
	    value: function bindListener() {
	      var _this3 = this;
	
	      var _props2 = this.props,
	          id = _props2.id,
	          globalEventOff = _props2.globalEventOff,
	          isCapture = _props2.isCapture;
	
	      var targetArray = this.getTargetArray(id);
	
	      targetArray.forEach(function (target) {
	        if (target.getAttribute('currentItem') === null) {
	          target.setAttribute('currentItem', 'false');
	        }
	        _this3.unbindBasicListener(target);
	        if (_this3.isCustomEvent(target)) {
	          _this3.customUnbindListener(target);
	        }
	      });
	
	      if (this.isBodyMode()) {
	        this.bindBodyListener(targetArray);
	      } else {
	        targetArray.forEach(function (target) {
	          var isCaptureMode = _this3.isCapture(target);
	          var effect = _this3.getEffect(target);
	          if (_this3.isCustomEvent(target)) {
	            _this3.customBindListener(target);
	            return;
	          }
	
	          target.addEventListener('mouseenter', _this3.showTooltip, isCaptureMode);
	          if (effect === 'float') {
	            target.addEventListener('mousemove', _this3.updateTooltip, isCaptureMode);
	          }
	          target.addEventListener('mouseleave', _this3.hideTooltip, isCaptureMode);
	        });
	      }
	
	      // Global event to hide tooltip
	      if (globalEventOff) {
	        window.removeEventListener(globalEventOff, this.hideTooltip);
	        window.addEventListener(globalEventOff, this.hideTooltip, isCapture);
	      }
	
	      // Track removal of targetArray elements from DOM
	      this.bindRemovalTracker();
	    }
	
	    /**
	     * Unbind listeners on target elements
	     */
	
	  }, {
	    key: 'unbindListener',
	    value: function unbindListener() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          id = _props3.id,
	          globalEventOff = _props3.globalEventOff;
	
	      if (this.isBodyMode()) {
	        this.unbindBodyListener();
	      } else {
	        var targetArray = this.getTargetArray(id);
	        targetArray.forEach(function (target) {
	          _this4.unbindBasicListener(target);
	          if (_this4.isCustomEvent(target)) _this4.customUnbindListener(target);
	        });
	      }
	
	      if (globalEventOff) window.removeEventListener(globalEventOff, this.hideTooltip);
	      this.unbindRemovalTracker();
	    }
	
	    /**
	     * Invoke this before bind listener and unmount the component
	     * it is necessary to invoke this even when binding custom event
	     * so that the tooltip can switch between custom and default listener
	     */
	
	  }, {
	    key: 'unbindBasicListener',
	    value: function unbindBasicListener(target) {
	      var isCaptureMode = this.isCapture(target);
	      target.removeEventListener('mouseenter', this.showTooltip, isCaptureMode);
	      target.removeEventListener('mousemove', this.updateTooltip, isCaptureMode);
	      target.removeEventListener('mouseleave', this.hideTooltip, isCaptureMode);
	    }
	  }, {
	    key: 'getTooltipContent',
	    value: function getTooltipContent() {
	      var _props4 = this.props,
	          getContent = _props4.getContent,
	          children = _props4.children;
	
	      // Generate tooltip content
	
	      var content = void 0;
	      if (getContent) {
	        if (Array.isArray(getContent)) {
	          content = getContent[0] && getContent[0](this.state.originTooltip);
	        } else {
	          content = getContent(this.state.originTooltip);
	        }
	      }
	
	      return (0, _getTipContent2.default)(this.state.originTooltip, children, content, this.state.isMultiline);
	    }
	  }, {
	    key: 'isEmptyTip',
	    value: function isEmptyTip(placeholder) {
	      return typeof placeholder === 'string' && placeholder === '' || placeholder === null;
	    }
	
	    /**
	     * When mouse enter, show the tooltip
	     */
	
	  }, {
	    key: 'showTooltip',
	    value: function showTooltip(e, isGlobalCall) {
	      if (isGlobalCall) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement) return;
	      }
	      // Get the tooltip content
	      // calculate in this phrase so that tip width height can be detected
	      var _props5 = this.props,
	          multiline = _props5.multiline,
	          getContent = _props5.getContent;
	
	      var originTooltip = e.currentTarget.getAttribute('data-tip');
	      var isMultiline = e.currentTarget.getAttribute('data-multiline') || multiline || false;
	
	      // If it is focus event or called by ReactTooltip.show, switch to `solid` effect
	      var switchToSolid = e instanceof window.FocusEvent || isGlobalCall;
	
	      // if it needs to skip adding hide listener to scroll
	      var scrollHide = true;
	      if (e.currentTarget.getAttribute('data-scroll-hide')) {
	        scrollHide = e.currentTarget.getAttribute('data-scroll-hide') === 'true';
	      } else if (this.props.scrollHide != null) {
	        scrollHide = this.props.scrollHide;
	      }
	
	      // Make sure the correct place is set
	      var desiredPlace = e.currentTarget.getAttribute('data-place') || this.props.place || 'top';
	      var effect = switchToSolid && 'solid' || this.getEffect(e.currentTarget);
	      var offset = e.currentTarget.getAttribute('data-offset') || this.props.offset || {};
	      var result = (0, _getPosition2.default)(e, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, e.currentTarget, this.tooltipRef, desiredPlace, desiredPlace, effect, offset);
	      }
	
	      var place = result.isNewState ? result.newState.place : desiredPlace;
	
	      // To prevent previously created timers from triggering
	      this.clearTimer();
	
	      var target = e.currentTarget;
	
	      var reshowDelay = this.state.show ? target.getAttribute('data-delay-update') || this.props.delayUpdate : 0;
	
	      var self = this;
	
	      var updateState = function updateState() {
	        self.setState({
	          originTooltip: originTooltip,
	          isMultiline: isMultiline,
	          desiredPlace: desiredPlace,
	          place: place,
	          type: target.getAttribute('data-type') || self.props.type || 'dark',
	          effect: effect,
	          offset: offset,
	          html: target.getAttribute('data-html') ? target.getAttribute('data-html') === 'true' : self.props.html || false,
	          delayShow: target.getAttribute('data-delay-show') || self.props.delayShow || 0,
	          delayHide: target.getAttribute('data-delay-hide') || self.props.delayHide || 0,
	          delayUpdate: target.getAttribute('data-delay-update') || self.props.delayUpdate || 0,
	          border: target.getAttribute('data-border') ? target.getAttribute('data-border') === 'true' : self.props.border || false,
	          extraClass: target.getAttribute('data-class') || self.props.class || self.props.className || '',
	          disable: target.getAttribute('data-tip-disable') ? target.getAttribute('data-tip-disable') === 'true' : self.props.disable || false,
	          currentTarget: target
	        }, function () {
	          if (scrollHide) self.addScrollListener(self.state.currentTarget);
	          self.updateTooltip(e);
	
	          if (getContent && Array.isArray(getContent)) {
	            self.intervalUpdateContent = setInterval(function () {
	              if (self.mount) {
	                var _getContent = self.props.getContent;
	
	                var placeholder = (0, _getTipContent2.default)(originTooltip, '', _getContent[0](), isMultiline);
	                var isEmptyTip = self.isEmptyTip(placeholder);
	                self.setState({
	                  isEmptyTip: isEmptyTip
	                });
	                self.updatePosition();
	              }
	            }, getContent[1]);
	          }
	        });
	      };
	
	      // If there is no delay call immediately, don't allow events to get in first.
	      if (reshowDelay) {
	        this.delayReshow = setTimeout(updateState, reshowDelay);
	      } else {
	        updateState();
	      }
	    }
	
	    /**
	     * When mouse hover, update tool tip
	     */
	
	  }, {
	    key: 'updateTooltip',
	    value: function updateTooltip(e) {
	      var _this5 = this;
	
	      var _state = this.state,
	          delayShow = _state.delayShow,
	          disable = _state.disable;
	      var afterShow = this.props.afterShow;
	
	      var placeholder = this.getTooltipContent();
	      var delayTime = parseInt(delayShow, 10);
	      var eventTarget = e.currentTarget || e.target;
	
	      // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	      if (this.mouseOnToolTip()) {
	        return;
	      }
	
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      var updateState = function updateState() {
	        if (Array.isArray(placeholder) && placeholder.length > 0 || placeholder) {
	          var isInvisible = !_this5.state.show;
	          _this5.setState({
	            currentEvent: e,
	            currentTarget: eventTarget,
	            show: true
	          }, function () {
	            _this5.updatePosition();
	            if (isInvisible && afterShow) afterShow(e);
	          });
	        }
	      };
	
	      clearTimeout(this.delayShowLoop);
	      if (delayShow) {
	        this.delayShowLoop = setTimeout(updateState, delayTime);
	      } else {
	        updateState();
	      }
	    }
	
	    /*
	    * If we're mousing over the tooltip remove it when we leave.
	     */
	
	  }, {
	    key: 'listenForTooltipExit',
	    value: function listenForTooltipExit() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.addEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	  }, {
	    key: 'removeListenerForTooltipExit',
	    value: function removeListenerForTooltipExit() {
	      var show = this.state.show;
	
	
	      if (show && this.tooltipRef) {
	        this.tooltipRef.removeEventListener('mouseleave', this.hideTooltip);
	      }
	    }
	
	    /**
	     * When mouse leave, hide tooltip
	     */
	
	  }, {
	    key: 'hideTooltip',
	    value: function hideTooltip(e, hasTarget) {
	      var _this6 = this;
	
	      var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : { isScroll: false };
	      var disable = this.state.disable;
	      var isScroll = options.isScroll;
	
	      var delayHide = isScroll ? 0 : this.state.delayHide;
	      var afterHide = this.props.afterHide;
	
	      var placeholder = this.getTooltipContent();
	      if (!this.mount) return;
	      if (this.isEmptyTip(placeholder) || disable) return; // if the tooltip is empty, disable the tooltip
	      if (hasTarget) {
	        // Don't trigger other elements belongs to other ReactTooltip
	        var targetArray = this.getTargetArray(this.props.id);
	        var isMyElement = targetArray.some(function (ele) {
	          return ele === e.currentTarget;
	        });
	        if (!isMyElement || !this.state.show) return;
	      }
	
	      var resetState = function resetState() {
	        var isVisible = _this6.state.show;
	        // Check if the mouse is actually over the tooltip, if so don't hide the tooltip
	        if (_this6.mouseOnToolTip()) {
	          _this6.listenForTooltipExit();
	          return;
	        }
	        _this6.removeListenerForTooltipExit();
	
	        _this6.setState({
	          show: false
	        }, function () {
	          _this6.removeScrollListener();
	          if (isVisible && afterHide) afterHide(e);
	        });
	      };
	
	      this.clearTimer();
	      if (delayHide) {
	        this.delayHideLoop = setTimeout(resetState, parseInt(delayHide, 10));
	      } else {
	        resetState();
	      }
	    }
	
	    /**
	     * When scroll, hide tooltip
	     */
	
	  }, {
	    key: 'hideTooltipOnScroll',
	    value: function hideTooltipOnScroll(event, hasTarget) {
	      this.hideTooltip(event, hasTarget, { isScroll: true });
	    }
	
	    /**
	     * Add scroll event listener when tooltip show
	     * automatically hide the tooltip when scrolling
	     */
	
	  }, {
	    key: 'addScrollListener',
	    value: function addScrollListener(currentTarget) {
	      var isCaptureMode = this.isCapture(currentTarget);
	      window.addEventListener('scroll', this.hideTooltipOnScroll, isCaptureMode);
	    }
	  }, {
	    key: 'removeScrollListener',
	    value: function removeScrollListener() {
	      window.removeEventListener('scroll', this.hideTooltipOnScroll);
	    }
	
	    // Calculation the position
	
	  }, {
	    key: 'updatePosition',
	    value: function updatePosition() {
	      var _this7 = this;
	
	      var _state2 = this.state,
	          currentEvent = _state2.currentEvent,
	          currentTarget = _state2.currentTarget,
	          place = _state2.place,
	          desiredPlace = _state2.desiredPlace,
	          effect = _state2.effect,
	          offset = _state2.offset;
	
	      var node = this.tooltipRef;
	      var result = (0, _getPosition2.default)(currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	      if (result.position && this.props.overridePosition) {
	        result.position = this.props.overridePosition(result.position, currentEvent, currentTarget, node, place, desiredPlace, effect, offset);
	      }
	
	      if (result.isNewState) {
	        // Switch to reverse placement
	        return this.setState(result.newState, function () {
	          _this7.updatePosition();
	        });
	      }
	      // Set tooltip position
	      node.style.left = result.position.left + 'px';
	      node.style.top = result.position.top + 'px';
	    }
	
	    /**
	     * Set style tag in header
	     * in this way we can insert default css
	     */
	
	  }, {
	    key: 'setStyleHeader',
	    value: function setStyleHeader() {
	      var head = document.getElementsByTagName('head')[0];
	      if (!head.querySelector('style[id="react-tooltip"]')) {
	        var tag = document.createElement('style');
	        tag.id = 'react-tooltip';
	        tag.innerHTML = _style2.default;
	        /* eslint-disable */
	        if (typeof __webpack_nonce__ !== 'undefined' && __webpack_nonce__) {
	          tag.setAttribute('nonce', __webpack_nonce__);
	        }
	        /* eslint-enable */
	        head.insertBefore(tag, head.firstChild);
	      }
	    }
	
	    /**
	     * CLear all kinds of timeout of interval
	     */
	
	  }, {
	    key: 'clearTimer',
	    value: function clearTimer() {
	      clearTimeout(this.delayShowLoop);
	      clearTimeout(this.delayHideLoop);
	      clearTimeout(this.delayReshow);
	      clearInterval(this.intervalUpdateContent);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this8 = this;
	
	      var _state3 = this.state,
	          extraClass = _state3.extraClass,
	          html = _state3.html,
	          ariaProps = _state3.ariaProps,
	          disable = _state3.disable;
	
	      var placeholder = this.getTooltipContent();
	      var isEmptyTip = this.isEmptyTip(placeholder);
	      var tooltipClass = (0, _classnames2.default)('__react_component_tooltip', { 'show': this.state.show && !disable && !isEmptyTip }, { 'border': this.state.border }, { 'place-top': this.state.place === 'top' }, { 'place-bottom': this.state.place === 'bottom' }, { 'place-left': this.state.place === 'left' }, { 'place-right': this.state.place === 'right' }, { 'type-dark': this.state.type === 'dark' }, { 'type-success': this.state.type === 'success' }, { 'type-warning': this.state.type === 'warning' }, { 'type-error': this.state.type === 'error' }, { 'type-info': this.state.type === 'info' }, { 'type-light': this.state.type === 'light' }, { 'allow_hover': this.props.delayUpdate }, { 'allow_click': this.props.clickable });
	
	      var Wrapper = this.props.wrapper;
	      if (ReactTooltip.supportedWrappers.indexOf(Wrapper) < 0) {
	        Wrapper = ReactTooltip.defaultProps.wrapper;
	      }
	      var wrapperClassName = [tooltipClass, extraClass].filter(Boolean).join(' ');
	
	      if (html) {
	        return _react2.default.createElement(Wrapper, _extends({ className: wrapperClassName,
	          id: this.props.id,
	          ref: function ref(_ref) {
	            return _this8.tooltipRef = _ref;
	          }
	        }, ariaProps, {
	          'data-id': 'tooltip',
	          dangerouslySetInnerHTML: { __html: placeholder } }));
	      } else {
	        return _react2.default.createElement(
	          Wrapper,
	          _extends({ className: wrapperClassName,
	            id: this.props.id
	          }, ariaProps, {
	            ref: function ref(_ref2) {
	              return _this8.tooltipRef = _ref2;
	            },
	            'data-id': 'tooltip' }),
	          placeholder
	        );
	      }
	    }
	  }], [{
	    key: 'getDerivedStateFromProps',
	    value: function getDerivedStateFromProps(nextProps, prevState) {
	      var ariaProps = prevState.ariaProps;
	
	      var newAriaProps = (0, _aria.parseAria)(nextProps);
	      var isChanged = Object.keys(newAriaProps).some(function (props) {
	        return newAriaProps[props] !== ariaProps[props];
	      });
	      if (!isChanged) {
	        return null;
	      }
	      return _extends({}, prevState, {
	        ariaProps: newAriaProps
	      });
	    }
	  }]);
	
	  return ReactTooltip;
	}(_react2.default.Component), _class2.propTypes = {
	  children: _propTypes2.default.any,
	  place: _propTypes2.default.string,
	  type: _propTypes2.default.string,
	  effect: _propTypes2.default.string,
	  offset: _propTypes2.default.object,
	  multiline: _propTypes2.default.bool,
	  border: _propTypes2.default.bool,
	  insecure: _propTypes2.default.bool,
	  class: _propTypes2.default.string,
	  className: _propTypes2.default.string,
	  id: _propTypes2.default.string,
	  html: _propTypes2.default.bool,
	  delayHide: _propTypes2.default.number,
	  delayUpdate: _propTypes2.default.number,
	  delayShow: _propTypes2.default.number,
	  event: _propTypes2.default.string,
	  eventOff: _propTypes2.default.string,
	  watchWindow: _propTypes2.default.bool,
	  isCapture: _propTypes2.default.bool,
	  globalEventOff: _propTypes2.default.string,
	  getContent: _propTypes2.default.any,
	  afterShow: _propTypes2.default.func,
	  afterHide: _propTypes2.default.func,
	  overridePosition: _propTypes2.default.func,
	  disable: _propTypes2.default.bool,
	  scrollHide: _propTypes2.default.bool,
	  resizeHide: _propTypes2.default.bool,
	  wrapper: _propTypes2.default.string,
	  bodyMode: _propTypes2.default.bool,
	  possibleCustomEvents: _propTypes2.default.string,
	  possibleCustomEventsOff: _propTypes2.default.string,
	  clickable: _propTypes2.default.bool
	}, _class2.defaultProps = {
	  insecure: true,
	  resizeHide: true,
	  wrapper: 'div',
	  clickable: false
	}, _class2.supportedWrappers = ['div', 'span'], _class2.displayName = 'ReactTooltip', _temp)) || _class) || _class) || _class) || _class) || _class) || _class) || _class;
	
	/* export default not fit for standalone, it will exports {default:...} */
	
	
	module.exports = ReactTooltip;

/***/ },
/* 46 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.config = exports.Transition = exports.TransitionGroup = exports.SwitchTransition = exports.ReplaceTransition = exports.CSSTransition = void 0;
	
	var _CSSTransition = _interopRequireDefault(__webpack_require__(593));
	
	exports.CSSTransition = _CSSTransition.default;
	
	var _ReplaceTransition = _interopRequireDefault(__webpack_require__(594));
	
	exports.ReplaceTransition = _ReplaceTransition.default;
	
	var _SwitchTransition = _interopRequireDefault(__webpack_require__(595));
	
	exports.SwitchTransition = _SwitchTransition.default;
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(187));
	
	exports.TransitionGroup = _TransitionGroup.default;
	
	var _Transition = _interopRequireDefault(__webpack_require__(102));
	
	exports.Transition = _Transition.default;
	
	var _config = _interopRequireDefault(__webpack_require__(188));
	
	exports.config = _config.default;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 47 */
/***/ function(module, exports) {

	module.exports = extend
	
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	
	function extend() {
	    var target = {}
	
	    for (var i = 0; i < arguments.length; i++) {
	        var source = arguments[i]
	
	        for (var key in source) {
	            if (hasOwnProperty.call(source, key)) {
	                target[key] = source[key]
	            }
	        }
	    }
	
	    return target
	}


/***/ },
/* 48 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	
	var _IconButton = _interopRequireDefault(__webpack_require__(308));

/***/ },
/* 49 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	
	var _InputBase = _interopRequireDefault(__webpack_require__(312));

/***/ },
/* 50 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var ListContext = React.createContext({});
	
	if (false) {
	  ListContext.displayName = 'ListContext';
	}
	
	var _default = ListContext;
	exports.default = _default;

/***/ },
/* 51 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(371));

/***/ },
/* 52 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var Tablelvl2Context = React.createContext();
	
	if (false) {
	  Tablelvl2Context.displayName = 'Tablelvl2Context';
	}
	
	var _default = Tablelvl2Context;
	exports.default = _default;

/***/ },
/* 53 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(160));
	
	var defaultTheme = (0, _createMuiTheme.default)();
	var _default = defaultTheme;
	exports.default = _default;

/***/ },
/* 54 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createChainedFunction;
	
	/**
	 * Safe chained function
	 *
	 * Will only create a new function if needed,
	 * otherwise will pass back existing functions or null.
	 *
	 * @param {function} functions to chain
	 * @returns {function|null}
	 */
	function createChainedFunction() {
	  for (var _len = arguments.length, funcs = new Array(_len), _key = 0; _key < _len; _key++) {
	    funcs[_key] = arguments[_key];
	  }
	
	  return funcs.reduce(function (acc, func) {
	    if (func == null) {
	      return acc;
	    }
	
	    if (false) {
	      if (typeof func !== 'function') {
	        console.error('Material-UI: invalid Argument Type, must only provide functions, undefined, or null.');
	      }
	    }
	
	    return function chainedFunction() {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      acc.apply(this, args);
	      func.apply(this, args);
	    };
	  }, function () {});
	}

/***/ },
/* 55 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = isMuiElement;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	function isMuiElement(element, muiNames) {
	  return React.isValidElement(element) && muiNames.indexOf(element.type.muiName) !== -1;
	}

/***/ },
/* 56 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ownerWindow;
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(27));
	
	function ownerWindow(node) {
	  var doc = (0, _ownerDocument.default)(node);
	  return doc.defaultView || window;
	}

/***/ },
/* 57 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.teardown = teardown;
	exports.default = useIsFocusVisible;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	// based on https://github.com/WICG/focus-visible/blob/v4.1.5/src/focus-visible.js
	var hadKeyboardEvent = true;
	var hadFocusVisibleRecently = false;
	var hadFocusVisibleRecentlyTimeout = null;
	var inputTypesWhitelist = {
	  text: true,
	  search: true,
	  url: true,
	  tel: true,
	  email: true,
	  password: true,
	  number: true,
	  date: true,
	  month: true,
	  week: true,
	  time: true,
	  datetime: true,
	  'datetime-local': true
	};
	/**
	 * Computes whether the given element should automatically trigger the
	 * `focus-visible` class being added, i.e. whether it should always match
	 * `:focus-visible` when focused.
	 * @param {Element} node
	 * @return {boolean}
	 */
	
	function focusTriggersKeyboardModality(node) {
	  var type = node.type,
	      tagName = node.tagName;
	
	  if (tagName === 'INPUT' && inputTypesWhitelist[type] && !node.readOnly) {
	    return true;
	  }
	
	  if (tagName === 'TEXTAREA' && !node.readOnly) {
	    return true;
	  }
	
	  if (node.isContentEditable) {
	    return true;
	  }
	
	  return false;
	}
	/**
	 * Keep track of our keyboard modality state with `hadKeyboardEvent`.
	 * If the most recent user interaction was via the keyboard;
	 * and the key press did not include a meta, alt/option, or control key;
	 * then the modality is keyboard. Otherwise, the modality is not keyboard.
	 * @param {KeyboardEvent} event
	 */
	
	
	function handleKeyDown(event) {
	  if (event.metaKey || event.altKey || event.ctrlKey) {
	    return;
	  }
	
	  hadKeyboardEvent = true;
	}
	/**
	 * If at any point a user clicks with a pointing device, ensure that we change
	 * the modality away from keyboard.
	 * This avoids the situation where a user presses a key on an already focused
	 * element, and then clicks on a different element, focusing it with a
	 * pointing device, while we still think we're in keyboard modality.
	 */
	
	
	function handlePointerDown() {
	  hadKeyboardEvent = false;
	}
	
	function handleVisibilityChange() {
	  if (this.visibilityState === 'hidden') {
	    // If the tab becomes active again, the browser will handle calling focus
	    // on the element (Safari actually calls it twice).
	    // If this tab change caused a blur on an element with focus-visible,
	    // re-apply the class when the user switches back to the tab.
	    if (hadFocusVisibleRecently) {
	      hadKeyboardEvent = true;
	    }
	  }
	}
	
	function prepare(doc) {
	  doc.addEventListener('keydown', handleKeyDown, true);
	  doc.addEventListener('mousedown', handlePointerDown, true);
	  doc.addEventListener('pointerdown', handlePointerDown, true);
	  doc.addEventListener('touchstart', handlePointerDown, true);
	  doc.addEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function teardown(doc) {
	  doc.removeEventListener('keydown', handleKeyDown, true);
	  doc.removeEventListener('mousedown', handlePointerDown, true);
	  doc.removeEventListener('pointerdown', handlePointerDown, true);
	  doc.removeEventListener('touchstart', handlePointerDown, true);
	  doc.removeEventListener('visibilitychange', handleVisibilityChange, true);
	}
	
	function isFocusVisible(event) {
	  var target = event.target;
	
	  try {
	    return target.matches(':focus-visible');
	  } catch (error) {} // browsers not implementing :focus-visible will throw a SyntaxError
	  // we use our own heuristic for those browsers
	  // rethrow might be better if it's not the expected error but do we really
	  // want to crash if focus-visible malfunctioned?
	  // no need for validFocusTarget check. the user does that by attaching it to
	  // focusable events only
	
	
	  return hadKeyboardEvent || focusTriggersKeyboardModality(target);
	}
	/**
	 * Should be called if a blur event is fired on a focus-visible element
	 */
	
	
	function handleBlurVisible() {
	  // To detect a tab/window switch, we look for a blur event followed
	  // rapidly by a visibility change.
	  // If we don't see a visibility change within 100ms, it's probably a
	  // regular focus change.
	  hadFocusVisibleRecently = true;
	  window.clearTimeout(hadFocusVisibleRecentlyTimeout);
	  hadFocusVisibleRecentlyTimeout = window.setTimeout(function () {
	    hadFocusVisibleRecently = false;
	  }, 100);
	}
	
	function useIsFocusVisible() {
	  var ref = React.useCallback(function (instance) {
	    var node = ReactDOM.findDOMNode(instance);
	
	    if (node != null) {
	      prepare(node.ownerDocument);
	    }
	  }, []);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useDebugValue(isFocusVisible);
	  }
	
	  return {
	    isFocusVisible: isFocusVisible,
	    onBlurVisible: handleBlurVisible,
	    ref: ref
	  };
	}

/***/ },
/* 58 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(478));

/***/ },
/* 59 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	var formatMoney = function formatMoney(value, percentify) {
	   if (percentify === "income") {
	      return Math.round(value * 1000000) / 10000 + "%";
	   } else if (percentify === "addpercent") {
	      return value.toLocaleString('en-US') + "%";
	   } else if (percentify === "rounded") {
	      var newvalue = parseFloat(value);
	      return Math.round(newvalue).toLocaleString('en-US', {
	         style: 'currency',
	         currency: 'USD',
	         minimumFractionDigits: 0,
	         maximumFractionDigits: 0
	      });
	   } else if (!isNaN(value) && value < 10000 && value > -10000) {
	      var _newvalue = parseFloat(value);
	      return (Math.round(_newvalue * 1000) / 1000).toLocaleString('en-US', {
	         style: 'currency',
	         currency: 'USD'
	      });
	   } else if (percentify === "posneg") {
	      var _newvalue2 = Math.round(parseFloat(value) * 100) / 100;
	      if (_newvalue2 > 0) {
	         return "+$" + _newvalue2.toLocaleString('en-US');
	      } else {
	         return "-$" + Math.abs(_newvalue2).toLocaleString('en-US');
	      }
	   } else if (!isNaN(value)) {
	      var _newvalue3 = parseFloat(value);
	      return "$" + _newvalue3.toLocaleString('en-US');
	   } else {
	      return value;
	   }
	};
	
	exports.default = formatMoney;

/***/ },
/* 60 */
/***/ function(module, exports) {

	function _defineProperties(target, props) {
	  for (var i = 0; i < props.length; i++) {
	    var descriptor = props[i];
	    descriptor.enumerable = descriptor.enumerable || false;
	    descriptor.configurable = true;
	    if ("value" in descriptor) descriptor.writable = true;
	    Object.defineProperty(target, descriptor.key, descriptor);
	  }
	}
	
	function _createClass(Constructor, protoProps, staticProps) {
	  if (protoProps) _defineProperties(Constructor.prototype, protoProps);
	  if (staticProps) _defineProperties(Constructor, staticProps);
	  return Constructor;
	}
	
	module.exports = _createClass;

/***/ },
/* 61 */
/***/ function(module, exports) {

	'use strict';
	
	module.exports = {
	  API_ORIGIN: 'https://api.mapbox.com',
	  EVENT_PROGRESS_DOWNLOAD: 'downloadProgress',
	  EVENT_PROGRESS_UPLOAD: 'uploadProgress',
	  EVENT_ERROR: 'error',
	  EVENT_RESPONSE: 'response',
	  ERROR_HTTP: 'HttpError',
	  ERROR_REQUEST_ABORTED: 'RequestAbortedError'
	};


/***/ },
/* 62 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.useFormControl = useFormControl;
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var FormControlContext = React.createContext();
	
	if (false) {
	  FormControlContext.displayName = 'FormControlContext';
	}
	
	function useFormControl() {
	  return React.useContext(FormControlContext);
	}
	
	var _default = FormControlContext;
	exports.default = _default;

/***/ },
/* 63 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	
	var _Grow = _interopRequireDefault(__webpack_require__(301));

/***/ },
/* 64 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	
	var _Input = _interopRequireDefault(__webpack_require__(309));

/***/ },
/* 65 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "ModalManager", {
	  enumerable: true,
	  get: function get() {
	    return _ModalManager.default;
	  }
	});
	
	var _Modal = _interopRequireDefault(__webpack_require__(333));
	
	var _ModalManager = _interopRequireDefault(__webpack_require__(128));

/***/ },
/* 66 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "capitalize", {
	  enumerable: true,
	  get: function get() {
	    return _capitalize.default;
	  }
	});
	Object.defineProperty(exports, "createChainedFunction", {
	  enumerable: true,
	  get: function get() {
	    return _deprecatedPropType.default;
	  }
	});
	Object.defineProperty(exports, "deprecatedPropType", {
	  enumerable: true,
	  get: function get() {
	    return _deprecatedPropType.default;
	  }
	});
	Object.defineProperty(exports, "createSvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _createSvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "debounce", {
	  enumerable: true,
	  get: function get() {
	    return _debounce.default;
	  }
	});
	Object.defineProperty(exports, "isMuiElement", {
	  enumerable: true,
	  get: function get() {
	    return _isMuiElement.default;
	  }
	});
	Object.defineProperty(exports, "ownerDocument", {
	  enumerable: true,
	  get: function get() {
	    return _ownerDocument.default;
	  }
	});
	Object.defineProperty(exports, "ownerWindow", {
	  enumerable: true,
	  get: function get() {
	    return _ownerWindow.default;
	  }
	});
	Object.defineProperty(exports, "requirePropFactory", {
	  enumerable: true,
	  get: function get() {
	    return _requirePropFactory.default;
	  }
	});
	Object.defineProperty(exports, "setRef", {
	  enumerable: true,
	  get: function get() {
	    return _setRef.default;
	  }
	});
	Object.defineProperty(exports, "unsupportedProp", {
	  enumerable: true,
	  get: function get() {
	    return _unsupportedProp.default;
	  }
	});
	Object.defineProperty(exports, "useControlled", {
	  enumerable: true,
	  get: function get() {
	    return _useControlled.default;
	  }
	});
	Object.defineProperty(exports, "useEventCallback", {
	  enumerable: true,
	  get: function get() {
	    return _useEventCallback.default;
	  }
	});
	Object.defineProperty(exports, "useForkRef", {
	  enumerable: true,
	  get: function get() {
	    return _useForkRef.default;
	  }
	});
	Object.defineProperty(exports, "unstable_useId", {
	  enumerable: true,
	  get: function get() {
	    return _unstable_useId.default;
	  }
	});
	Object.defineProperty(exports, "useIsFocusVisible", {
	  enumerable: true,
	  get: function get() {
	    return _useIsFocusVisible.default;
	  }
	});
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _deprecatedPropType = _interopRequireDefault(__webpack_require__(445));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	var _debounce = _interopRequireDefault(__webpack_require__(37));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(55));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(27));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(56));
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(166));
	
	var _setRef = _interopRequireDefault(__webpack_require__(38));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(67));
	
	var _useControlled = _interopRequireDefault(__webpack_require__(39));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(29));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(89));
	
	var _useIsFocusVisible = _interopRequireDefault(__webpack_require__(57));

/***/ },
/* 67 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = unsupportedProp;
	
	function unsupportedProp(props, propName, componentName, location, propFullName) {
	  if (true) {
	    return null;
	  }
	
	  var propFullNameSafe = propFullName || propName;
	
	  if (typeof props[propName] !== 'undefined') {
	    return new Error("The prop `".concat(propFullNameSafe, "` is not supported. Please remove it."));
	  }
	
	  return null;
	}

/***/ },
/* 68 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSvgIcon;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(51));
	
	function createSvgIcon(path, displayName) {
	  var Component = _react.default.memo(_react.default.forwardRef(function (props, ref) {
	    return _react.default.createElement(_SvgIcon.default, (0, _extends2.default)({
	      ref: ref
	    }, props), path);
	  }));
	
	  if (false) {
	    Component.displayName = "".concat(displayName, "Icon");
	  }
	
	  Component.muiName = _SvgIcon.default.muiName;
	  return Component;
	}

/***/ },
/* 69 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _utils = __webpack_require__(9);
	
	function merge(acc, item) {
	  if (!item) {
	    return acc;
	  }
	
	  return (0, _utils.deepmerge)(acc, item, {
	    clone: false // No need to clone deep, it's way faster.
	
	  });
	}
	
	var _default = merge;
	exports.default = _default;

/***/ },
/* 70 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-color/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function define(constructor, factory, prototype) {
	  constructor.prototype = factory.prototype = prototype;
	  prototype.constructor = constructor;
	}
	
	function extend(parent, definition) {
	  var prototype = Object.create(parent.prototype);
	  for (var key in definition) prototype[key] = definition[key];
	  return prototype;
	}
	
	function Color() {}
	
	var darker = 0.7;
	var brighter = 1 / darker;
	
	var reI = "\\s*([+-]?\\d+)\\s*",
	    reN = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)\\s*",
	    reP = "\\s*([+-]?\\d*\\.?\\d+(?:[eE][+-]?\\d+)?)%\\s*",
	    reHex = /^#([0-9a-f]{3,8})$/,
	    reRgbInteger = new RegExp("^rgb\\(" + [reI, reI, reI] + "\\)$"),
	    reRgbPercent = new RegExp("^rgb\\(" + [reP, reP, reP] + "\\)$"),
	    reRgbaInteger = new RegExp("^rgba\\(" + [reI, reI, reI, reN] + "\\)$"),
	    reRgbaPercent = new RegExp("^rgba\\(" + [reP, reP, reP, reN] + "\\)$"),
	    reHslPercent = new RegExp("^hsl\\(" + [reN, reP, reP] + "\\)$"),
	    reHslaPercent = new RegExp("^hsla\\(" + [reN, reP, reP, reN] + "\\)$");
	
	var named = {
	  aliceblue: 0xf0f8ff,
	  antiquewhite: 0xfaebd7,
	  aqua: 0x00ffff,
	  aquamarine: 0x7fffd4,
	  azure: 0xf0ffff,
	  beige: 0xf5f5dc,
	  bisque: 0xffe4c4,
	  black: 0x000000,
	  blanchedalmond: 0xffebcd,
	  blue: 0x0000ff,
	  blueviolet: 0x8a2be2,
	  brown: 0xa52a2a,
	  burlywood: 0xdeb887,
	  cadetblue: 0x5f9ea0,
	  chartreuse: 0x7fff00,
	  chocolate: 0xd2691e,
	  coral: 0xff7f50,
	  cornflowerblue: 0x6495ed,
	  cornsilk: 0xfff8dc,
	  crimson: 0xdc143c,
	  cyan: 0x00ffff,
	  darkblue: 0x00008b,
	  darkcyan: 0x008b8b,
	  darkgoldenrod: 0xb8860b,
	  darkgray: 0xa9a9a9,
	  darkgreen: 0x006400,
	  darkgrey: 0xa9a9a9,
	  darkkhaki: 0xbdb76b,
	  darkmagenta: 0x8b008b,
	  darkolivegreen: 0x556b2f,
	  darkorange: 0xff8c00,
	  darkorchid: 0x9932cc,
	  darkred: 0x8b0000,
	  darksalmon: 0xe9967a,
	  darkseagreen: 0x8fbc8f,
	  darkslateblue: 0x483d8b,
	  darkslategray: 0x2f4f4f,
	  darkslategrey: 0x2f4f4f,
	  darkturquoise: 0x00ced1,
	  darkviolet: 0x9400d3,
	  deeppink: 0xff1493,
	  deepskyblue: 0x00bfff,
	  dimgray: 0x696969,
	  dimgrey: 0x696969,
	  dodgerblue: 0x1e90ff,
	  firebrick: 0xb22222,
	  floralwhite: 0xfffaf0,
	  forestgreen: 0x228b22,
	  fuchsia: 0xff00ff,
	  gainsboro: 0xdcdcdc,
	  ghostwhite: 0xf8f8ff,
	  gold: 0xffd700,
	  goldenrod: 0xdaa520,
	  gray: 0x808080,
	  green: 0x008000,
	  greenyellow: 0xadff2f,
	  grey: 0x808080,
	  honeydew: 0xf0fff0,
	  hotpink: 0xff69b4,
	  indianred: 0xcd5c5c,
	  indigo: 0x4b0082,
	  ivory: 0xfffff0,
	  khaki: 0xf0e68c,
	  lavender: 0xe6e6fa,
	  lavenderblush: 0xfff0f5,
	  lawngreen: 0x7cfc00,
	  lemonchiffon: 0xfffacd,
	  lightblue: 0xadd8e6,
	  lightcoral: 0xf08080,
	  lightcyan: 0xe0ffff,
	  lightgoldenrodyellow: 0xfafad2,
	  lightgray: 0xd3d3d3,
	  lightgreen: 0x90ee90,
	  lightgrey: 0xd3d3d3,
	  lightpink: 0xffb6c1,
	  lightsalmon: 0xffa07a,
	  lightseagreen: 0x20b2aa,
	  lightskyblue: 0x87cefa,
	  lightslategray: 0x778899,
	  lightslategrey: 0x778899,
	  lightsteelblue: 0xb0c4de,
	  lightyellow: 0xffffe0,
	  lime: 0x00ff00,
	  limegreen: 0x32cd32,
	  linen: 0xfaf0e6,
	  magenta: 0xff00ff,
	  maroon: 0x800000,
	  mediumaquamarine: 0x66cdaa,
	  mediumblue: 0x0000cd,
	  mediumorchid: 0xba55d3,
	  mediumpurple: 0x9370db,
	  mediumseagreen: 0x3cb371,
	  mediumslateblue: 0x7b68ee,
	  mediumspringgreen: 0x00fa9a,
	  mediumturquoise: 0x48d1cc,
	  mediumvioletred: 0xc71585,
	  midnightblue: 0x191970,
	  mintcream: 0xf5fffa,
	  mistyrose: 0xffe4e1,
	  moccasin: 0xffe4b5,
	  navajowhite: 0xffdead,
	  navy: 0x000080,
	  oldlace: 0xfdf5e6,
	  olive: 0x808000,
	  olivedrab: 0x6b8e23,
	  orange: 0xffa500,
	  orangered: 0xff4500,
	  orchid: 0xda70d6,
	  palegoldenrod: 0xeee8aa,
	  palegreen: 0x98fb98,
	  paleturquoise: 0xafeeee,
	  palevioletred: 0xdb7093,
	  papayawhip: 0xffefd5,
	  peachpuff: 0xffdab9,
	  peru: 0xcd853f,
	  pink: 0xffc0cb,
	  plum: 0xdda0dd,
	  powderblue: 0xb0e0e6,
	  purple: 0x800080,
	  rebeccapurple: 0x663399,
	  red: 0xff0000,
	  rosybrown: 0xbc8f8f,
	  royalblue: 0x4169e1,
	  saddlebrown: 0x8b4513,
	  salmon: 0xfa8072,
	  sandybrown: 0xf4a460,
	  seagreen: 0x2e8b57,
	  seashell: 0xfff5ee,
	  sienna: 0xa0522d,
	  silver: 0xc0c0c0,
	  skyblue: 0x87ceeb,
	  slateblue: 0x6a5acd,
	  slategray: 0x708090,
	  slategrey: 0x708090,
	  snow: 0xfffafa,
	  springgreen: 0x00ff7f,
	  steelblue: 0x4682b4,
	  tan: 0xd2b48c,
	  teal: 0x008080,
	  thistle: 0xd8bfd8,
	  tomato: 0xff6347,
	  turquoise: 0x40e0d0,
	  violet: 0xee82ee,
	  wheat: 0xf5deb3,
	  white: 0xffffff,
	  whitesmoke: 0xf5f5f5,
	  yellow: 0xffff00,
	  yellowgreen: 0x9acd32
	};
	
	define(Color, color, {
	  copy: function(channels) {
	    return Object.assign(new this.constructor, this, channels);
	  },
	  displayable: function() {
	    return this.rgb().displayable();
	  },
	  hex: color_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: color_formatHex,
	  formatHsl: color_formatHsl,
	  formatRgb: color_formatRgb,
	  toString: color_formatRgb
	});
	
	function color_formatHex() {
	  return this.rgb().formatHex();
	}
	
	function color_formatHsl() {
	  return hslConvert(this).formatHsl();
	}
	
	function color_formatRgb() {
	  return this.rgb().formatRgb();
	}
	
	function color(format) {
	  var m, l;
	  format = (format + "").trim().toLowerCase();
	  return (m = reHex.exec(format)) ? (l = m[1].length, m = parseInt(m[1], 16), l === 6 ? rgbn(m) // #ff0000
	      : l === 3 ? new Rgb((m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), ((m & 0xf) << 4) | (m & 0xf), 1) // #f00
	      : l === 8 ? new Rgb(m >> 24 & 0xff, m >> 16 & 0xff, m >> 8 & 0xff, (m & 0xff) / 0xff) // #ff000000
	      : l === 4 ? new Rgb((m >> 12 & 0xf) | (m >> 8 & 0xf0), (m >> 8 & 0xf) | (m >> 4 & 0xf0), (m >> 4 & 0xf) | (m & 0xf0), (((m & 0xf) << 4) | (m & 0xf)) / 0xff) // #f000
	      : null) // invalid hex
	      : (m = reRgbInteger.exec(format)) ? new Rgb(m[1], m[2], m[3], 1) // rgb(255, 0, 0)
	      : (m = reRgbPercent.exec(format)) ? new Rgb(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, 1) // rgb(100%, 0%, 0%)
	      : (m = reRgbaInteger.exec(format)) ? rgba(m[1], m[2], m[3], m[4]) // rgba(255, 0, 0, 1)
	      : (m = reRgbaPercent.exec(format)) ? rgba(m[1] * 255 / 100, m[2] * 255 / 100, m[3] * 255 / 100, m[4]) // rgb(100%, 0%, 0%, 1)
	      : (m = reHslPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, 1) // hsl(120, 50%, 50%)
	      : (m = reHslaPercent.exec(format)) ? hsla(m[1], m[2] / 100, m[3] / 100, m[4]) // hsla(120, 50%, 50%, 1)
	      : named.hasOwnProperty(format) ? rgbn(named[format]) // eslint-disable-line no-prototype-builtins
	      : format === "transparent" ? new Rgb(NaN, NaN, NaN, 0)
	      : null;
	}
	
	function rgbn(n) {
	  return new Rgb(n >> 16 & 0xff, n >> 8 & 0xff, n & 0xff, 1);
	}
	
	function rgba(r, g, b, a) {
	  if (a <= 0) r = g = b = NaN;
	  return new Rgb(r, g, b, a);
	}
	
	function rgbConvert(o) {
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Rgb;
	  o = o.rgb();
	  return new Rgb(o.r, o.g, o.b, o.opacity);
	}
	
	function rgb(r, g, b, opacity) {
	  return arguments.length === 1 ? rgbConvert(r) : new Rgb(r, g, b, opacity == null ? 1 : opacity);
	}
	
	function Rgb(r, g, b, opacity) {
	  this.r = +r;
	  this.g = +g;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Rgb, rgb, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Rgb(this.r * k, this.g * k, this.b * k, this.opacity);
	  },
	  rgb: function() {
	    return this;
	  },
	  displayable: function() {
	    return (-0.5 <= this.r && this.r < 255.5)
	        && (-0.5 <= this.g && this.g < 255.5)
	        && (-0.5 <= this.b && this.b < 255.5)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  hex: rgb_formatHex, // Deprecated! Use color.formatHex.
	  formatHex: rgb_formatHex,
	  formatRgb: rgb_formatRgb,
	  toString: rgb_formatRgb
	}));
	
	function rgb_formatHex() {
	  return "#" + hex(this.r) + hex(this.g) + hex(this.b);
	}
	
	function rgb_formatRgb() {
	  var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	  return (a === 1 ? "rgb(" : "rgba(")
	      + Math.max(0, Math.min(255, Math.round(this.r) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.g) || 0)) + ", "
	      + Math.max(0, Math.min(255, Math.round(this.b) || 0))
	      + (a === 1 ? ")" : ", " + a + ")");
	}
	
	function hex(value) {
	  value = Math.max(0, Math.min(255, Math.round(value) || 0));
	  return (value < 16 ? "0" : "") + value.toString(16);
	}
	
	function hsla(h, s, l, a) {
	  if (a <= 0) h = s = l = NaN;
	  else if (l <= 0 || l >= 1) h = s = NaN;
	  else if (s <= 0) h = NaN;
	  return new Hsl(h, s, l, a);
	}
	
	function hslConvert(o) {
	  if (o instanceof Hsl) return new Hsl(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Color)) o = color(o);
	  if (!o) return new Hsl;
	  if (o instanceof Hsl) return o;
	  o = o.rgb();
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      min = Math.min(r, g, b),
	      max = Math.max(r, g, b),
	      h = NaN,
	      s = max - min,
	      l = (max + min) / 2;
	  if (s) {
	    if (r === max) h = (g - b) / s + (g < b) * 6;
	    else if (g === max) h = (b - r) / s + 2;
	    else h = (r - g) / s + 4;
	    s /= l < 0.5 ? max + min : 2 - max - min;
	    h *= 60;
	  } else {
	    s = l > 0 && l < 1 ? 0 : h;
	  }
	  return new Hsl(h, s, l, o.opacity);
	}
	
	function hsl(h, s, l, opacity) {
	  return arguments.length === 1 ? hslConvert(h) : new Hsl(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Hsl(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Hsl, hsl, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Hsl(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = this.h % 360 + (this.h < 0) * 360,
	        s = isNaN(h) || isNaN(this.s) ? 0 : this.s,
	        l = this.l,
	        m2 = l + (l < 0.5 ? l : 1 - l) * s,
	        m1 = 2 * l - m2;
	    return new Rgb(
	      hsl2rgb(h >= 240 ? h - 240 : h + 120, m1, m2),
	      hsl2rgb(h, m1, m2),
	      hsl2rgb(h < 120 ? h + 240 : h - 120, m1, m2),
	      this.opacity
	    );
	  },
	  displayable: function() {
	    return (0 <= this.s && this.s <= 1 || isNaN(this.s))
	        && (0 <= this.l && this.l <= 1)
	        && (0 <= this.opacity && this.opacity <= 1);
	  },
	  formatHsl: function() {
	    var a = this.opacity; a = isNaN(a) ? 1 : Math.max(0, Math.min(1, a));
	    return (a === 1 ? "hsl(" : "hsla(")
	        + (this.h || 0) + ", "
	        + (this.s || 0) * 100 + "%, "
	        + (this.l || 0) * 100 + "%"
	        + (a === 1 ? ")" : ", " + a + ")");
	  }
	}));
	
	/* From FvD 13.37, CSS Color Module Level 3 */
	function hsl2rgb(h, m1, m2) {
	  return (h < 60 ? m1 + (m2 - m1) * h / 60
	      : h < 180 ? m2
	      : h < 240 ? m1 + (m2 - m1) * (240 - h) / 60
	      : m1) * 255;
	}
	
	var deg2rad = Math.PI / 180;
	var rad2deg = 180 / Math.PI;
	
	// https://observablehq.com/@mbostock/lab-and-rgb
	var K = 18,
	    Xn = 0.96422,
	    Yn = 1,
	    Zn = 0.82521,
	    t0 = 4 / 29,
	    t1 = 6 / 29,
	    t2 = 3 * t1 * t1,
	    t3 = t1 * t1 * t1;
	
	function labConvert(o) {
	  if (o instanceof Lab) return new Lab(o.l, o.a, o.b, o.opacity);
	  if (o instanceof Hcl) return hcl2lab(o);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = rgb2lrgb(o.r),
	      g = rgb2lrgb(o.g),
	      b = rgb2lrgb(o.b),
	      y = xyz2lab((0.2225045 * r + 0.7168786 * g + 0.0606169 * b) / Yn), x, z;
	  if (r === g && g === b) x = z = y; else {
	    x = xyz2lab((0.4360747 * r + 0.3850649 * g + 0.1430804 * b) / Xn);
	    z = xyz2lab((0.0139322 * r + 0.0971045 * g + 0.7141733 * b) / Zn);
	  }
	  return new Lab(116 * y - 16, 500 * (x - y), 200 * (y - z), o.opacity);
	}
	
	function gray(l, opacity) {
	  return new Lab(l, 0, 0, opacity == null ? 1 : opacity);
	}
	
	function lab(l, a, b, opacity) {
	  return arguments.length === 1 ? labConvert(l) : new Lab(l, a, b, opacity == null ? 1 : opacity);
	}
	
	function Lab(l, a, b, opacity) {
	  this.l = +l;
	  this.a = +a;
	  this.b = +b;
	  this.opacity = +opacity;
	}
	
	define(Lab, lab, extend(Color, {
	  brighter: function(k) {
	    return new Lab(this.l + K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  darker: function(k) {
	    return new Lab(this.l - K * (k == null ? 1 : k), this.a, this.b, this.opacity);
	  },
	  rgb: function() {
	    var y = (this.l + 16) / 116,
	        x = isNaN(this.a) ? y : y + this.a / 500,
	        z = isNaN(this.b) ? y : y - this.b / 200;
	    x = Xn * lab2xyz(x);
	    y = Yn * lab2xyz(y);
	    z = Zn * lab2xyz(z);
	    return new Rgb(
	      lrgb2rgb( 3.1338561 * x - 1.6168667 * y - 0.4906146 * z),
	      lrgb2rgb(-0.9787684 * x + 1.9161415 * y + 0.0334540 * z),
	      lrgb2rgb( 0.0719453 * x - 0.2289914 * y + 1.4052427 * z),
	      this.opacity
	    );
	  }
	}));
	
	function xyz2lab(t) {
	  return t > t3 ? Math.pow(t, 1 / 3) : t / t2 + t0;
	}
	
	function lab2xyz(t) {
	  return t > t1 ? t * t * t : t2 * (t - t0);
	}
	
	function lrgb2rgb(x) {
	  return 255 * (x <= 0.0031308 ? 12.92 * x : 1.055 * Math.pow(x, 1 / 2.4) - 0.055);
	}
	
	function rgb2lrgb(x) {
	  return (x /= 255) <= 0.04045 ? x / 12.92 : Math.pow((x + 0.055) / 1.055, 2.4);
	}
	
	function hclConvert(o) {
	  if (o instanceof Hcl) return new Hcl(o.h, o.c, o.l, o.opacity);
	  if (!(o instanceof Lab)) o = labConvert(o);
	  if (o.a === 0 && o.b === 0) return new Hcl(NaN, 0 < o.l && o.l < 100 ? 0 : NaN, o.l, o.opacity);
	  var h = Math.atan2(o.b, o.a) * rad2deg;
	  return new Hcl(h < 0 ? h + 360 : h, Math.sqrt(o.a * o.a + o.b * o.b), o.l, o.opacity);
	}
	
	function lch(l, c, h, opacity) {
	  return arguments.length === 1 ? hclConvert(l) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function hcl(h, c, l, opacity) {
	  return arguments.length === 1 ? hclConvert(h) : new Hcl(h, c, l, opacity == null ? 1 : opacity);
	}
	
	function Hcl(h, c, l, opacity) {
	  this.h = +h;
	  this.c = +c;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	function hcl2lab(o) {
	  if (isNaN(o.h)) return new Lab(o.l, 0, 0, o.opacity);
	  var h = o.h * deg2rad;
	  return new Lab(o.l, Math.cos(h) * o.c, Math.sin(h) * o.c, o.opacity);
	}
	
	define(Hcl, hcl, extend(Color, {
	  brighter: function(k) {
	    return new Hcl(this.h, this.c, this.l + K * (k == null ? 1 : k), this.opacity);
	  },
	  darker: function(k) {
	    return new Hcl(this.h, this.c, this.l - K * (k == null ? 1 : k), this.opacity);
	  },
	  rgb: function() {
	    return hcl2lab(this).rgb();
	  }
	}));
	
	var A = -0.14861,
	    B = +1.78277,
	    C = -0.29227,
	    D = -0.90649,
	    E = +1.97294,
	    ED = E * D,
	    EB = E * B,
	    BC_DA = B * C - D * A;
	
	function cubehelixConvert(o) {
	  if (o instanceof Cubehelix) return new Cubehelix(o.h, o.s, o.l, o.opacity);
	  if (!(o instanceof Rgb)) o = rgbConvert(o);
	  var r = o.r / 255,
	      g = o.g / 255,
	      b = o.b / 255,
	      l = (BC_DA * b + ED * r - EB * g) / (BC_DA + ED - EB),
	      bl = b - l,
	      k = (E * (g - l) - C * bl) / D,
	      s = Math.sqrt(k * k + bl * bl) / (E * l * (1 - l)), // NaN if l=0 or l=1
	      h = s ? Math.atan2(k, bl) * rad2deg - 120 : NaN;
	  return new Cubehelix(h < 0 ? h + 360 : h, s, l, o.opacity);
	}
	
	function cubehelix(h, s, l, opacity) {
	  return arguments.length === 1 ? cubehelixConvert(h) : new Cubehelix(h, s, l, opacity == null ? 1 : opacity);
	}
	
	function Cubehelix(h, s, l, opacity) {
	  this.h = +h;
	  this.s = +s;
	  this.l = +l;
	  this.opacity = +opacity;
	}
	
	define(Cubehelix, cubehelix, extend(Color, {
	  brighter: function(k) {
	    k = k == null ? brighter : Math.pow(brighter, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  darker: function(k) {
	    k = k == null ? darker : Math.pow(darker, k);
	    return new Cubehelix(this.h, this.s, this.l * k, this.opacity);
	  },
	  rgb: function() {
	    var h = isNaN(this.h) ? 0 : (this.h + 120) * deg2rad,
	        l = +this.l,
	        a = isNaN(this.s) ? 0 : this.s * l * (1 - l),
	        cosh = Math.cos(h),
	        sinh = Math.sin(h);
	    return new Rgb(
	      255 * (l + a * (A * cosh + B * sinh)),
	      255 * (l + a * (C * cosh + D * sinh)),
	      255 * (l + a * (E * cosh)),
	      this.opacity
	    );
	  }
	}));
	
	exports.color = color;
	exports.cubehelix = cubehelix;
	exports.gray = gray;
	exports.hcl = hcl;
	exports.hsl = hsl;
	exports.lab = lab;
	exports.lch = lch;
	exports.rgb = rgb;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 71 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale/ Version 1.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(31), __webpack_require__(97), __webpack_require__(98), __webpack_require__(508), __webpack_require__(176), __webpack_require__(514), __webpack_require__(70)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array', 'd3-collection', 'd3-interpolate', 'd3-format', 'd3-time', 'd3-time-format', 'd3-color'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, function (exports,d3Array,d3Collection,d3Interpolate,d3Format,d3Time,d3TimeFormat,d3Color) { 'use strict';
	
	  var array = Array.prototype;
	
	  var map$1 = array.map;
	  var slice = array.slice;
	
	  var implicit = {name: "implicit"};
	
	  function ordinal(range) {
	    var index = d3Collection.map(),
	        domain = [],
	        unknown = implicit;
	
	    range = range == null ? [] : slice.call(range);
	
	    function scale(d) {
	      var key = d + "", i = index.get(key);
	      if (!i) {
	        if (unknown !== implicit) return unknown;
	        index.set(key, i = domain.push(d));
	      }
	      return range[(i - 1) % range.length];
	    }
	
	    scale.domain = function(_) {
	      if (!arguments.length) return domain.slice();
	      domain = [], index = d3Collection.map();
	      var i = -1, n = _.length, d, key;
	      while (++i < n) if (!index.has(key = (d = _[i]) + "")) index.set(key, domain.push(d));
	      return scale;
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), scale) : range.slice();
	    };
	
	    scale.unknown = function(_) {
	      return arguments.length ? (unknown = _, scale) : unknown;
	    };
	
	    scale.copy = function() {
	      return ordinal()
	          .domain(domain)
	          .range(range)
	          .unknown(unknown);
	    };
	
	    return scale;
	  }
	
	  function band() {
	    var scale = ordinal().unknown(undefined),
	        domain = scale.domain,
	        ordinalRange = scale.range,
	        range = [0, 1],
	        step,
	        bandwidth,
	        round = false,
	        paddingInner = 0,
	        paddingOuter = 0,
	        align = 0.5;
	
	    delete scale.unknown;
	
	    function rescale() {
	      var n = domain().length,
	          reverse = range[1] < range[0],
	          start = range[reverse - 0],
	          stop = range[1 - reverse];
	      step = (stop - start) / Math.max(1, n - paddingInner + paddingOuter * 2);
	      if (round) step = Math.floor(step);
	      start += (stop - start - step * (n - paddingInner)) * align;
	      bandwidth = step * (1 - paddingInner);
	      if (round) start = Math.round(start), bandwidth = Math.round(bandwidth);
	      var values = d3Array.range(n).map(function(i) { return start + step * i; });
	      return ordinalRange(reverse ? values.reverse() : values);
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain(_), rescale()) : domain();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = [+_[0], +_[1]], rescale()) : range.slice();
	    };
	
	    scale.rangeRound = function(_) {
	      return range = [+_[0], +_[1]], round = true, rescale();
	    };
	
	    scale.bandwidth = function() {
	      return bandwidth;
	    };
	
	    scale.step = function() {
	      return step;
	    };
	
	    scale.round = function(_) {
	      return arguments.length ? (round = !!_, rescale()) : round;
	    };
	
	    scale.padding = function(_) {
	      return arguments.length ? (paddingInner = paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	    };
	
	    scale.paddingInner = function(_) {
	      return arguments.length ? (paddingInner = Math.max(0, Math.min(1, _)), rescale()) : paddingInner;
	    };
	
	    scale.paddingOuter = function(_) {
	      return arguments.length ? (paddingOuter = Math.max(0, Math.min(1, _)), rescale()) : paddingOuter;
	    };
	
	    scale.align = function(_) {
	      return arguments.length ? (align = Math.max(0, Math.min(1, _)), rescale()) : align;
	    };
	
	    scale.copy = function() {
	      return band()
	          .domain(domain())
	          .range(range)
	          .round(round)
	          .paddingInner(paddingInner)
	          .paddingOuter(paddingOuter)
	          .align(align);
	    };
	
	    return rescale();
	  }
	
	  function pointish(scale) {
	    var copy = scale.copy;
	
	    scale.padding = scale.paddingOuter;
	    delete scale.paddingInner;
	    delete scale.paddingOuter;
	
	    scale.copy = function() {
	      return pointish(copy());
	    };
	
	    return scale;
	  }
	
	  function point() {
	    return pointish(band().paddingInner(1));
	  }
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  function number(x) {
	    return +x;
	  }
	
	  var unit = [0, 1];
	
	  function deinterpolate(a, b) {
	    return (b -= (a = +a))
	        ? function(x) { return (x - a) / b; }
	        : constant(b);
	  }
	
	  function deinterpolateClamp(deinterpolate) {
	    return function(a, b) {
	      var d = deinterpolate(a = +a, b = +b);
	      return function(x) { return x <= a ? 0 : x >= b ? 1 : d(x); };
	    };
	  }
	
	  function reinterpolateClamp(reinterpolate) {
	    return function(a, b) {
	      var r = reinterpolate(a = +a, b = +b);
	      return function(t) { return t <= 0 ? a : t >= 1 ? b : r(t); };
	    };
	  }
	
	  function bimap(domain, range, deinterpolate, reinterpolate) {
	    var d0 = domain[0], d1 = domain[1], r0 = range[0], r1 = range[1];
	    if (d1 < d0) d0 = deinterpolate(d1, d0), r0 = reinterpolate(r1, r0);
	    else d0 = deinterpolate(d0, d1), r0 = reinterpolate(r0, r1);
	    return function(x) { return r0(d0(x)); };
	  }
	
	  function polymap(domain, range, deinterpolate, reinterpolate) {
	    var j = Math.min(domain.length, range.length) - 1,
	        d = new Array(j),
	        r = new Array(j),
	        i = -1;
	
	    // Reverse descending domains.
	    if (domain[j] < domain[0]) {
	      domain = domain.slice().reverse();
	      range = range.slice().reverse();
	    }
	
	    while (++i < j) {
	      d[i] = deinterpolate(domain[i], domain[i + 1]);
	      r[i] = reinterpolate(range[i], range[i + 1]);
	    }
	
	    return function(x) {
	      var i = d3Array.bisect(domain, x, 1, j) - 1;
	      return r[i](d[i](x));
	    };
	  }
	
	  function copy(source, target) {
	    return target
	        .domain(source.domain())
	        .range(source.range())
	        .interpolate(source.interpolate())
	        .clamp(source.clamp());
	  }
	
	  // deinterpolate(a, b)(x) takes a domain value x in [a,b] and returns the corresponding parameter t in [0,1].
	  // reinterpolate(a, b)(t) takes a parameter t in [0,1] and returns the corresponding domain value x in [a,b].
	  function continuous(deinterpolate$$, reinterpolate) {
	    var domain = unit,
	        range = unit,
	        interpolate = d3Interpolate.interpolate,
	        clamp = false,
	        piecewise,
	        output,
	        input;
	
	    function rescale() {
	      piecewise = Math.min(domain.length, range.length) > 2 ? polymap : bimap;
	      output = input = null;
	      return scale;
	    }
	
	    function scale(x) {
	      return (output || (output = piecewise(domain, range, clamp ? deinterpolateClamp(deinterpolate$$) : deinterpolate$$, interpolate)))(+x);
	    }
	
	    scale.invert = function(y) {
	      return (input || (input = piecewise(range, domain, deinterpolate, clamp ? reinterpolateClamp(reinterpolate) : reinterpolate)))(+y);
	    };
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain = map$1.call(_, number), rescale()) : domain.slice();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	    };
	
	    scale.rangeRound = function(_) {
	      return range = slice.call(_), interpolate = d3Interpolate.interpolateRound, rescale();
	    };
	
	    scale.clamp = function(_) {
	      return arguments.length ? (clamp = !!_, rescale()) : clamp;
	    };
	
	    scale.interpolate = function(_) {
	      return arguments.length ? (interpolate = _, rescale()) : interpolate;
	    };
	
	    return rescale();
	  }
	
	  function tickFormat(domain, count, specifier) {
	    var start = domain[0],
	        stop = domain[domain.length - 1],
	        step = d3Array.tickStep(start, stop, count == null ? 10 : count),
	        precision;
	    specifier = d3Format.formatSpecifier(specifier == null ? ",f" : specifier);
	    switch (specifier.type) {
	      case "s": {
	        var value = Math.max(Math.abs(start), Math.abs(stop));
	        if (specifier.precision == null && !isNaN(precision = d3Format.precisionPrefix(step, value))) specifier.precision = precision;
	        return d3Format.formatPrefix(specifier, value);
	      }
	      case "":
	      case "e":
	      case "g":
	      case "p":
	      case "r": {
	        if (specifier.precision == null && !isNaN(precision = d3Format.precisionRound(step, Math.max(Math.abs(start), Math.abs(stop))))) specifier.precision = precision - (specifier.type === "e");
	        break;
	      }
	      case "f":
	      case "%": {
	        if (specifier.precision == null && !isNaN(precision = d3Format.precisionFixed(step))) specifier.precision = precision - (specifier.type === "%") * 2;
	        break;
	      }
	    }
	    return d3Format.format(specifier);
	  }
	
	  function linearish(scale) {
	    var domain = scale.domain;
	
	    scale.ticks = function(count) {
	      var d = domain();
	      return d3Array.ticks(d[0], d[d.length - 1], count == null ? 10 : count);
	    };
	
	    scale.tickFormat = function(count, specifier) {
	      return tickFormat(domain(), count, specifier);
	    };
	
	    scale.nice = function(count) {
	      var d = domain(),
	          i = d.length - 1,
	          n = count == null ? 10 : count,
	          start = d[0],
	          stop = d[i],
	          step = d3Array.tickStep(start, stop, n);
	
	      if (step) {
	        step = d3Array.tickStep(Math.floor(start / step) * step, Math.ceil(stop / step) * step, n);
	        d[0] = Math.floor(start / step) * step;
	        d[i] = Math.ceil(stop / step) * step;
	        domain(d);
	      }
	
	      return scale;
	    };
	
	    return scale;
	  }
	
	  function linear() {
	    var scale = continuous(deinterpolate, d3Interpolate.interpolateNumber);
	
	    scale.copy = function() {
	      return copy(scale, linear());
	    };
	
	    return linearish(scale);
	  }
	
	  function identity() {
	    var domain = [0, 1];
	
	    function scale(x) {
	      return +x;
	    }
	
	    scale.invert = scale;
	
	    scale.domain = scale.range = function(_) {
	      return arguments.length ? (domain = map$1.call(_, number), scale) : domain.slice();
	    };
	
	    scale.copy = function() {
	      return identity().domain(domain);
	    };
	
	    return linearish(scale);
	  }
	
	  function nice(domain, interval) {
	    domain = domain.slice();
	
	    var i0 = 0,
	        i1 = domain.length - 1,
	        x0 = domain[i0],
	        x1 = domain[i1],
	        t;
	
	    if (x1 < x0) {
	      t = i0, i0 = i1, i1 = t;
	      t = x0, x0 = x1, x1 = t;
	    }
	
	    domain[i0] = interval.floor(x0);
	    domain[i1] = interval.ceil(x1);
	    return domain;
	  }
	
	  function deinterpolate$1(a, b) {
	    return (b = Math.log(b / a))
	        ? function(x) { return Math.log(x / a) / b; }
	        : constant(b);
	  }
	
	  function reinterpolate(a, b) {
	    return a < 0
	        ? function(t) { return -Math.pow(-b, t) * Math.pow(-a, 1 - t); }
	        : function(t) { return Math.pow(b, t) * Math.pow(a, 1 - t); };
	  }
	
	  function pow10(x) {
	    return isFinite(x) ? +("1e" + x) : x < 0 ? 0 : x;
	  }
	
	  function powp(base) {
	    return base === 10 ? pow10
	        : base === Math.E ? Math.exp
	        : function(x) { return Math.pow(base, x); };
	  }
	
	  function logp(base) {
	    return base === Math.E ? Math.log
	        : base === 10 && Math.log10
	        || base === 2 && Math.log2
	        || (base = Math.log(base), function(x) { return Math.log(x) / base; });
	  }
	
	  function reflect(f) {
	    return function(x) {
	      return -f(-x);
	    };
	  }
	
	  function log() {
	    var scale = continuous(deinterpolate$1, reinterpolate).domain([1, 10]),
	        domain = scale.domain,
	        base = 10,
	        logs = logp(10),
	        pows = powp(10);
	
	    function rescale() {
	      logs = logp(base), pows = powp(base);
	      if (domain()[0] < 0) logs = reflect(logs), pows = reflect(pows);
	      return scale;
	    }
	
	    scale.base = function(_) {
	      return arguments.length ? (base = +_, rescale()) : base;
	    };
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain(_), rescale()) : domain();
	    };
	
	    scale.ticks = function(count) {
	      var d = domain(),
	          u = d[0],
	          v = d[d.length - 1],
	          r;
	
	      if (r = v < u) i = u, u = v, v = i;
	
	      var i = logs(u),
	          j = logs(v),
	          p,
	          k,
	          t,
	          n = count == null ? 10 : +count,
	          z = [];
	
	      if (!(base % 1) && j - i < n) {
	        i = Math.round(i) - 1, j = Math.round(j) + 1;
	        if (u > 0) for (; i < j; ++i) {
	          for (k = 1, p = pows(i); k < base; ++k) {
	            t = p * k;
	            if (t < u) continue;
	            if (t > v) break;
	            z.push(t);
	          }
	        } else for (; i < j; ++i) {
	          for (k = base - 1, p = pows(i); k >= 1; --k) {
	            t = p * k;
	            if (t < u) continue;
	            if (t > v) break;
	            z.push(t);
	          }
	        }
	      } else {
	        z = d3Array.ticks(i, j, Math.min(j - i, n)).map(pows);
	      }
	
	      return r ? z.reverse() : z;
	    };
	
	    scale.tickFormat = function(count, specifier) {
	      if (specifier == null) specifier = base === 10 ? ".0e" : ",";
	      if (typeof specifier !== "function") specifier = d3Format.format(specifier);
	      if (count === Infinity) return specifier;
	      if (count == null) count = 10;
	      var k = Math.max(1, base * count / scale.ticks().length); // TODO fast estimate?
	      return function(d) {
	        var i = d / pows(Math.round(logs(d)));
	        if (i * base < base - 0.5) i *= base;
	        return i <= k ? specifier(d) : "";
	      };
	    };
	
	    scale.nice = function() {
	      return domain(nice(domain(), {
	        floor: function(x) { return pows(Math.floor(logs(x))); },
	        ceil: function(x) { return pows(Math.ceil(logs(x))); }
	      }));
	    };
	
	    scale.copy = function() {
	      return copy(scale, log().base(base));
	    };
	
	    return scale;
	  }
	
	  function raise(x, exponent) {
	    return x < 0 ? -Math.pow(-x, exponent) : Math.pow(x, exponent);
	  }
	
	  function pow() {
	    var exponent = 1,
	        scale = continuous(deinterpolate, reinterpolate),
	        domain = scale.domain;
	
	    function deinterpolate(a, b) {
	      return (b = raise(b, exponent) - (a = raise(a, exponent)))
	          ? function(x) { return (raise(x, exponent) - a) / b; }
	          : constant(b);
	    }
	
	    function reinterpolate(a, b) {
	      b = raise(b, exponent) - (a = raise(a, exponent));
	      return function(t) { return raise(a + b * t, 1 / exponent); };
	    }
	
	    scale.exponent = function(_) {
	      return arguments.length ? (exponent = +_, domain(domain())) : exponent;
	    };
	
	    scale.copy = function() {
	      return copy(scale, pow().exponent(exponent));
	    };
	
	    return linearish(scale);
	  }
	
	  function sqrt() {
	    return pow().exponent(0.5);
	  }
	
	  function quantile$1() {
	    var domain = [],
	        range = [],
	        thresholds = [];
	
	    function rescale() {
	      var i = 0, n = Math.max(1, range.length);
	      thresholds = new Array(n - 1);
	      while (++i < n) thresholds[i - 1] = d3Array.quantile(domain, i / n);
	      return scale;
	    }
	
	    function scale(x) {
	      if (!isNaN(x = +x)) return range[d3Array.bisect(thresholds, x)];
	    }
	
	    scale.invertExtent = function(y) {
	      var i = range.indexOf(y);
	      return i < 0 ? [NaN, NaN] : [
	        i > 0 ? thresholds[i - 1] : domain[0],
	        i < thresholds.length ? thresholds[i] : domain[domain.length - 1]
	      ];
	    };
	
	    scale.domain = function(_) {
	      if (!arguments.length) return domain.slice();
	      domain = [];
	      for (var i = 0, n = _.length, d; i < n; ++i) if (d = _[i], d != null && !isNaN(d = +d)) domain.push(d);
	      domain.sort(d3Array.ascending);
	      return rescale();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), rescale()) : range.slice();
	    };
	
	    scale.quantiles = function() {
	      return thresholds.slice();
	    };
	
	    scale.copy = function() {
	      return quantile$1()
	          .domain(domain)
	          .range(range);
	    };
	
	    return scale;
	  }
	
	  function quantize() {
	    var x0 = 0,
	        x1 = 1,
	        n = 1,
	        domain = [0.5],
	        range = [0, 1];
	
	    function scale(x) {
	      if (x <= x) return range[d3Array.bisect(domain, x, 0, n)];
	    }
	
	    function rescale() {
	      var i = -1;
	      domain = new Array(n);
	      while (++i < n) domain[i] = ((i + 1) * x1 - (i - n) * x0) / (n + 1);
	      return scale;
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (x0 = +_[0], x1 = +_[1], rescale()) : [x0, x1];
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (n = (range = slice.call(_)).length - 1, rescale()) : range.slice();
	    };
	
	    scale.invertExtent = function(y) {
	      var i = range.indexOf(y);
	      return i < 0 ? [NaN, NaN]
	          : i < 1 ? [x0, domain[0]]
	          : i >= n ? [domain[n - 1], x1]
	          : [domain[i - 1], domain[i]];
	    };
	
	    scale.copy = function() {
	      return quantize()
	          .domain([x0, x1])
	          .range(range);
	    };
	
	    return linearish(scale);
	  }
	
	  function threshold() {
	    var domain = [0.5],
	        range = [0, 1],
	        n = 1;
	
	    function scale(x) {
	      if (x <= x) return range[d3Array.bisect(domain, x, 0, n)];
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (domain = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : domain.slice();
	    };
	
	    scale.range = function(_) {
	      return arguments.length ? (range = slice.call(_), n = Math.min(domain.length, range.length - 1), scale) : range.slice();
	    };
	
	    scale.invertExtent = function(y) {
	      var i = range.indexOf(y);
	      return [domain[i - 1], domain[i]];
	    };
	
	    scale.copy = function() {
	      return threshold()
	          .domain(domain)
	          .range(range);
	    };
	
	    return scale;
	  }
	
	  var durationSecond = 1000;
	  var durationMinute = durationSecond * 60;
	  var durationHour = durationMinute * 60;
	  var durationDay = durationHour * 24;
	  var durationWeek = durationDay * 7;
	  var durationMonth = durationDay * 30;
	  var durationYear = durationDay * 365;
	  function date(t) {
	    return new Date(t);
	  }
	
	  function number$1(t) {
	    return t instanceof Date ? +t : +new Date(+t);
	  }
	
	  function calendar(year, month, week, day, hour, minute, second, millisecond, format) {
	    var scale = continuous(deinterpolate, d3Interpolate.interpolateNumber),
	        invert = scale.invert,
	        domain = scale.domain;
	
	    var formatMillisecond = format(".%L"),
	        formatSecond = format(":%S"),
	        formatMinute = format("%I:%M"),
	        formatHour = format("%I %p"),
	        formatDay = format("%a %d"),
	        formatWeek = format("%b %d"),
	        formatMonth = format("%B"),
	        formatYear = format("%Y");
	
	    var tickIntervals = [
	      [second,  1,      durationSecond],
	      [second,  5,  5 * durationSecond],
	      [second, 15, 15 * durationSecond],
	      [second, 30, 30 * durationSecond],
	      [minute,  1,      durationMinute],
	      [minute,  5,  5 * durationMinute],
	      [minute, 15, 15 * durationMinute],
	      [minute, 30, 30 * durationMinute],
	      [  hour,  1,      durationHour  ],
	      [  hour,  3,  3 * durationHour  ],
	      [  hour,  6,  6 * durationHour  ],
	      [  hour, 12, 12 * durationHour  ],
	      [   day,  1,      durationDay   ],
	      [   day,  2,  2 * durationDay   ],
	      [  week,  1,      durationWeek  ],
	      [ month,  1,      durationMonth ],
	      [ month,  3,  3 * durationMonth ],
	      [  year,  1,      durationYear  ]
	    ];
	
	    function tickFormat(date) {
	      return (second(date) < date ? formatMillisecond
	          : minute(date) < date ? formatSecond
	          : hour(date) < date ? formatMinute
	          : day(date) < date ? formatHour
	          : month(date) < date ? (week(date) < date ? formatDay : formatWeek)
	          : year(date) < date ? formatMonth
	          : formatYear)(date);
	    }
	
	    function tickInterval(interval, start, stop, step) {
	      if (interval == null) interval = 10;
	
	      // If a desired tick count is specified, pick a reasonable tick interval
	      // based on the extent of the domain and a rough estimate of tick size.
	      // Otherwise, assume interval is already a time interval and use it.
	      if (typeof interval === "number") {
	        var target = Math.abs(stop - start) / interval,
	            i = d3Array.bisector(function(i) { return i[2]; }).right(tickIntervals, target);
	        if (i === tickIntervals.length) {
	          step = d3Array.tickStep(start / durationYear, stop / durationYear, interval);
	          interval = year;
	        } else if (i) {
	          i = tickIntervals[target / tickIntervals[i - 1][2] < tickIntervals[i][2] / target ? i - 1 : i];
	          step = i[1];
	          interval = i[0];
	        } else {
	          step = d3Array.tickStep(start, stop, interval);
	          interval = millisecond;
	        }
	      }
	
	      return step == null ? interval : interval.every(step);
	    }
	
	    scale.invert = function(y) {
	      return new Date(invert(y));
	    };
	
	    scale.domain = function(_) {
	      return arguments.length ? domain(map$1.call(_, number$1)) : domain().map(date);
	    };
	
	    scale.ticks = function(interval, step) {
	      var d = domain(),
	          t0 = d[0],
	          t1 = d[d.length - 1],
	          r = t1 < t0,
	          t;
	      if (r) t = t0, t0 = t1, t1 = t;
	      t = tickInterval(interval, t0, t1, step);
	      t = t ? t.range(t0, t1 + 1) : []; // inclusive stop
	      return r ? t.reverse() : t;
	    };
	
	    scale.tickFormat = function(count, specifier) {
	      return specifier == null ? tickFormat : format(specifier);
	    };
	
	    scale.nice = function(interval, step) {
	      var d = domain();
	      return (interval = tickInterval(interval, d[0], d[d.length - 1], step))
	          ? domain(nice(d, interval))
	          : scale;
	    };
	
	    scale.copy = function() {
	      return copy(scale, calendar(year, month, week, day, hour, minute, second, millisecond, format));
	    };
	
	    return scale;
	  }
	
	  function time() {
	    return calendar(d3Time.timeYear, d3Time.timeMonth, d3Time.timeWeek, d3Time.timeDay, d3Time.timeHour, d3Time.timeMinute, d3Time.timeSecond, d3Time.timeMillisecond, d3TimeFormat.timeFormat).domain([new Date(2000, 0, 1), new Date(2000, 0, 2)]);
	  }
	
	  function utcTime() {
	    return calendar(d3Time.utcYear, d3Time.utcMonth, d3Time.utcWeek, d3Time.utcDay, d3Time.utcHour, d3Time.utcMinute, d3Time.utcSecond, d3Time.utcMillisecond, d3TimeFormat.utcFormat).domain([Date.UTC(2000, 0, 1), Date.UTC(2000, 0, 2)]);
	  }
	
	  function colors(s) {
	    return s.match(/.{6}/g).map(function(x) {
	      return "#" + x;
	    });
	  }
	
	  var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	  var category20b = colors("393b795254a36b6ecf9c9ede6379398ca252b5cf6bcedb9c8c6d31bd9e39e7ba52e7cb94843c39ad494ad6616be7969c7b4173a55194ce6dbdde9ed6");
	
	  var category20c = colors("3182bd6baed69ecae1c6dbefe6550dfd8d3cfdae6bfdd0a231a35474c476a1d99bc7e9c0756bb19e9ac8bcbddcdadaeb636363969696bdbdbdd9d9d9");
	
	  var category20 = colors("1f77b4aec7e8ff7f0effbb782ca02c98df8ad62728ff98969467bdc5b0d58c564bc49c94e377c2f7b6d27f7f7fc7c7c7bcbd22dbdb8d17becf9edae5");
	
	  var cubehelix$1 = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	  var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	  var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	  var rainbow = d3Color.cubehelix();
	
	  function rainbow$1(t) {
	    if (t < 0 || t > 1) t -= Math.floor(t);
	    var ts = Math.abs(t - 0.5);
	    rainbow.h = 360 * t - 100;
	    rainbow.s = 1.5 - 1.5 * ts;
	    rainbow.l = 0.8 - 0.9 * ts;
	    return rainbow + "";
	  }
	
	  function ramp(range) {
	    var n = range.length;
	    return function(t) {
	      return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	    };
	  }
	
	  var viridis = ramp(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	  var magma = ramp(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	  var inferno = ramp(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	  var plasma = ramp(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	  function sequential(interpolator) {
	    var x0 = 0,
	        x1 = 1,
	        clamp = false;
	
	    function scale(x) {
	      var t = (x - x0) / (x1 - x0);
	      return interpolator(clamp ? Math.max(0, Math.min(1, t)) : t);
	    }
	
	    scale.domain = function(_) {
	      return arguments.length ? (x0 = +_[0], x1 = +_[1], scale) : [x0, x1];
	    };
	
	    scale.clamp = function(_) {
	      return arguments.length ? (clamp = !!_, scale) : clamp;
	    };
	
	    scale.interpolator = function(_) {
	      return arguments.length ? (interpolator = _, scale) : interpolator;
	    };
	
	    scale.copy = function() {
	      return sequential(interpolator).domain([x0, x1]).clamp(clamp);
	    };
	
	    return linearish(scale);
	  }
	
	  exports.scaleBand = band;
	  exports.scalePoint = point;
	  exports.scaleIdentity = identity;
	  exports.scaleLinear = linear;
	  exports.scaleLog = log;
	  exports.scaleOrdinal = ordinal;
	  exports.scaleImplicit = implicit;
	  exports.scalePow = pow;
	  exports.scaleSqrt = sqrt;
	  exports.scaleQuantile = quantile$1;
	  exports.scaleQuantize = quantize;
	  exports.scaleThreshold = threshold;
	  exports.scaleTime = time;
	  exports.scaleUtc = utcTime;
	  exports.schemeCategory10 = category10;
	  exports.schemeCategory20b = category20b;
	  exports.schemeCategory20c = category20c;
	  exports.schemeCategory20 = category20;
	  exports.interpolateCubehelixDefault = cubehelix$1;
	  exports.interpolateRainbow = rainbow$1;
	  exports.interpolateWarm = warm;
	  exports.interpolateCool = cool;
	  exports.interpolateViridis = viridis;
	  exports.interpolateMagma = magma;
	  exports.interpolateInferno = inferno;
	  exports.interpolatePlasma = plasma;
	  exports.scaleSequential = sequential;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 72 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.fullAgencyName = exports.bucketScale = exports.divergingColors = exports.categoricalColorsWithoutSBA = exports.categoricalColors = undefined;
	
	var _d3Scale = __webpack_require__(71);
	
	var _d3ScaleChromatic = __webpack_require__(510);
	
	var categoricalColors = (0, _d3Scale.scaleOrdinal)(["#a71930", "#574241", "#bfa5a4", "#00689d", "#009dd4", "#cf6576", "#8b8680"]).domain(["HHS", "USDA", "HUD", "DOT", "ED", "SBA", "other"]).unknown("#8b8680");
	
	var categoricalColorsWithoutSBA = (0, _d3Scale.scaleOrdinal)(["#a71930", "#574241", "#bfa5a4", "#00689d", "#009dd4", "#8b8680"]).domain(["HHS", "USDA", "HUD", "DOT", "ED", "other"]).unknown("#8b8680");
	
	var fullAgencyName = (0, _d3Scale.scaleOrdinal)().domain(["HHS", "USDA", "HUD", "DOT", "ED", "SBA", "other", "DOL", "EPA", "DOJ", "DHS", "DOI", "Treasury", "CNCS", "ARC", "VA", "DOC", "DOE", "IMLS", "DOD", "NEA", "NEH", "DRA"]).range(["Health and Human Services", "Department of Agriculture", "Housing and Urban Development", "Department of Transportation", "Education Department", "Small Business Administration", "other", "Department of Labor", "Environmental Protection Agency", "Department of Justice", "Department of Homeland Security", "Department of the Interior", "Treasury", "Corporation for National and Community Service", "Appalachian Regional Commission", "Veterans' Affairs", "Department of Commerce", "Department of Energy", "Institute of Museum and Library Services", "Department of Defense", "National Endowment for the Arts", "National Endowment for the Humanities", "Delta Regional Authority"]).unknown("");
	
	var divergingColors = (0, _d3Scale.scaleSequential)(_d3ScaleChromatic.interpolateRdYlGn);
	
	var bucketScale = (0, _d3Scale.scaleQuantile)().range(_d3ScaleChromatic.schemeRdYlGn[5]); // equal size buckets
	var quantizeScale = (0, _d3Scale.scaleQuantize)().range(_d3ScaleChromatic.schemeRdYlGn[5]); // equally spaced buckets
	
	exports.categoricalColors = categoricalColors;
	exports.categoricalColorsWithoutSBA = categoricalColorsWithoutSBA;
	exports.divergingColors = divergingColors;
	exports.bucketScale = bucketScale;
	exports.fullAgencyName = fullAgencyName;

/***/ },
/* 73 */
/***/ function(module, exports) {

	function _classCallCheck(instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	}
	
	module.exports = _classCallCheck;

/***/ },
/* 74 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(222));

/***/ },
/* 75 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	
	var _Collapse = _interopRequireDefault(__webpack_require__(257));

/***/ },
/* 76 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isHorizontal = isHorizontal;
	exports.getAnchor = getAnchor;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _Modal = _interopRequireDefault(__webpack_require__(65));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(74));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Slide = _interopRequireDefault(__webpack_require__(134));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _transitions = __webpack_require__(26);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {},
	
	    /* Styles applied to the root element if `variant="permanent or persistent"`. */
	    docked: {
	      flex: '0 0 auto'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      overflowY: 'auto',
	      display: 'flex',
	      flexDirection: 'column',
	      height: '100%',
	      flex: '1 0 auto',
	      zIndex: theme.zIndex.drawer,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      // temporary style
	      position: 'fixed',
	      top: 0,
	      // We disable the focus ring for mouse, touch and keyboard users.
	      // At some point, it would be better to keep it for keyboard users.
	      // :focus-ring CSS pseudo-class will help.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"`. */
	    paperAnchorLeft: {
	      left: 0,
	      right: 'auto'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"`. */
	    paperAnchorRight: {
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"`. */
	    paperAnchorTop: {
	      top: 0,
	      left: 0,
	      bottom: 'auto',
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"`. */
	    paperAnchorBottom: {
	      top: 'auto',
	      left: 0,
	      bottom: 0,
	      right: 0,
	      height: 'auto',
	      maxHeight: '100%'
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="left"` and `variant` is not "temporary". */
	    paperAnchorDockedLeft: {
	      borderRight: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="top"` and `variant` is not "temporary". */
	    paperAnchorDockedTop: {
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="right"` and `variant` is not "temporary". */
	    paperAnchorDockedRight: {
	      borderLeft: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Paper` component if `anchor="bottom"` and `variant` is not "temporary". */
	    paperAnchorDockedBottom: {
	      borderTop: "1px solid ".concat(theme.palette.divider)
	    },
	
	    /* Styles applied to the `Modal` component. */
	    modal: {}
	  };
	};
	
	exports.styles = styles;
	var oppositeDirection = {
	  left: 'right',
	  right: 'left',
	  top: 'down',
	  bottom: 'up'
	};
	
	function isHorizontal(anchor) {
	  return ['left', 'right'].indexOf(anchor) !== -1;
	}
	
	function getAnchor(theme, anchor) {
	  return theme.direction === 'rtl' && isHorizontal(anchor) ? oppositeDirection[anchor] : anchor;
	}
	
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The props of the [Modal](/api/modal/) component are available
	 * when `variant="temporary"` is set.
	 */
	
	var Drawer = React.forwardRef(function Drawer(props, ref) {
	  var _props$anchor = props.anchor,
	      anchorProp = _props$anchor === void 0 ? 'left' : _props$anchor,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 16 : _props$elevation,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropPropsProp = _props$ModalProps.BackdropProps,
	      ModalProps = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      _props$open = props.open,
	      open = _props$open === void 0 ? false : _props$open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      SlideProps = props.SlideProps,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "BackdropProps", "children", "classes", "className", "elevation", "ModalProps", "onClose", "open", "PaperProps", "SlideProps", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)(); // Let's assume that the Drawer will always be rendered on user space.
	  // We use this state is order to skip the appear transition during the
	  // initial mount of the component.
	
	  var mounted = React.useRef(false);
	  React.useEffect(function () {
	    mounted.current = true;
	  }, []);
	  var anchor = getAnchor(theme, anchorProp);
	  var drawer = /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: variant === 'temporary' ? elevation : 0,
	    square: true
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, classes["paperAnchor".concat((0, _capitalize.default)(anchor))], PaperProps.className, variant !== 'temporary' && classes["paperAnchorDocked".concat((0, _capitalize.default)(anchor))])
	  }), children);
	
	  if (variant === 'permanent') {
	    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), drawer);
	  }
	
	  var slidingDrawer = /*#__PURE__*/React.createElement(_Slide.default, (0, _extends2.default)({
	    in: open,
	    direction: oppositeDirection[anchor],
	    timeout: transitionDuration,
	    appear: mounted.current
	  }, SlideProps), drawer);
	
	  if (variant === 'persistent') {
	    return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.root, classes.docked, className),
	      ref: ref
	    }, other), slidingDrawer);
	  } // variant === temporary
	
	
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    BackdropProps: (0, _extends2.default)({}, BackdropProps, {}, BackdropPropsProp, {
	      transitionDuration: transitionDuration
	    }),
	    BackdropComponent: _Backdrop.default,
	    className: (0, _clsx.default)(classes.root, classes.modal, className),
	    open: open,
	    onClose: onClose,
	    ref: ref
	  }, other, ModalProps), slidingDrawer);
	});
	 false ? Drawer.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Side from which the drawer will appear.
	   */
	  anchor: _propTypes.default.oneOf(['bottom', 'left', 'right', 'top']),
	
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * The contents of the drawer.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The elevation of the drawer.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Modal`](/api/modal/) element.
	   */
	  ModalProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`Slide`](/api/slide/) element.
	   */
	  SlideProps: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDrawer',
	  flip: false
	})(Drawer);
	
	exports.default = _default;

/***/ },
/* 77 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	
	var _Fade = _interopRequireDefault(__webpack_require__(285));

/***/ },
/* 78 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(286));

/***/ },
/* 79 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "useFormControl", {
	  enumerable: true,
	  get: function get() {
	    return _useFormControl.default;
	  }
	});
	
	var _FormControl = _interopRequireDefault(__webpack_require__(287));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(36));

/***/ },
/* 80 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.hasValue = hasValue;
	exports.isFilled = isFilled;
	exports.isAdornedStart = isAdornedStart;
	
	// Supports determination of isControlled().
	// Controlled input accepts its current value as a prop.
	//
	// @see https://facebook.github.io/react/docs/forms.html#controlled-components
	// @param value
	// @returns {boolean} true if string (including '') or number (including zero)
	function hasValue(value) {
	  return value != null && !(Array.isArray(value) && value.length === 0);
	} // Determine if field is empty or filled.
	// Response determines if label is presented above field or as placeholder.
	//
	// @param obj
	// @param SSR
	// @returns {boolean} False when not present or empty string.
	//                    True when any number or string with length.
	
	
	function isFilled(obj) {
	  var SSR = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	  return obj && (hasValue(obj.value) && obj.value !== '' || SSR && hasValue(obj.defaultValue) && obj.defaultValue !== '');
	} // Determine if an Input is adorned on start.
	// It's corresponding to the left with LTR.
	//
	// @param obj
	// @returns {boolean} False when no adornments.
	//                    True when adorned at the start.
	
	
	function isAdornedStart(obj) {
	  return obj.startAdornment;
	}

/***/ },
/* 81 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(339));

/***/ },
/* 82 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	
	var _Popover = _interopRequireDefault(__webpack_require__(341));

/***/ },
/* 83 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	
	var _Popper = _interopRequireDefault(__webpack_require__(342));

/***/ },
/* 84 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	
	var _Portal = _interopRequireDefault(__webpack_require__(343));

/***/ },
/* 85 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	
	var _Select = _interopRequireDefault(__webpack_require__(351));

/***/ },
/* 86 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	
	var _TableCell = _interopRequireDefault(__webpack_require__(381));

/***/ },
/* 87 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.9.10
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  colors: true,
	  AppBar: true,
	  Avatar: true,
	  Backdrop: true,
	  Badge: true,
	  BottomNavigation: true,
	  BottomNavigationAction: true,
	  Box: true,
	  Breadcrumbs: true,
	  Button: true,
	  ButtonBase: true,
	  ButtonGroup: true,
	  Card: true,
	  CardActionArea: true,
	  CardActions: true,
	  CardContent: true,
	  CardHeader: true,
	  CardMedia: true,
	  Checkbox: true,
	  Chip: true,
	  CircularProgress: true,
	  ClickAwayListener: true,
	  Collapse: true,
	  Container: true,
	  CssBaseline: true,
	  Dialog: true,
	  DialogActions: true,
	  DialogContent: true,
	  DialogContentText: true,
	  DialogTitle: true,
	  Divider: true,
	  Drawer: true,
	  ExpansionPanel: true,
	  ExpansionPanelActions: true,
	  ExpansionPanelDetails: true,
	  ExpansionPanelSummary: true,
	  Fab: true,
	  Fade: true,
	  FilledInput: true,
	  FormControl: true,
	  FormControlLabel: true,
	  FormGroup: true,
	  FormHelperText: true,
	  FormLabel: true,
	  Grid: true,
	  GridList: true,
	  GridListTile: true,
	  GridListTileBar: true,
	  Grow: true,
	  Hidden: true,
	  Icon: true,
	  IconButton: true,
	  Input: true,
	  InputAdornment: true,
	  InputBase: true,
	  InputLabel: true,
	  LinearProgress: true,
	  Link: true,
	  List: true,
	  ListItem: true,
	  ListItemAvatar: true,
	  ListItemIcon: true,
	  ListItemSecondaryAction: true,
	  ListItemText: true,
	  ListSubheader: true,
	  Menu: true,
	  MenuItem: true,
	  MenuList: true,
	  MobileStepper: true,
	  Modal: true,
	  NativeSelect: true,
	  NoSsr: true,
	  OutlinedInput: true,
	  Paper: true,
	  Popover: true,
	  Popper: true,
	  Portal: true,
	  Radio: true,
	  RadioGroup: true,
	  RootRef: true,
	  Select: true,
	  Slide: true,
	  Slider: true,
	  Snackbar: true,
	  SnackbarContent: true,
	  Step: true,
	  StepButton: true,
	  StepConnector: true,
	  StepContent: true,
	  StepIcon: true,
	  StepLabel: true,
	  Stepper: true,
	  SvgIcon: true,
	  SwipeableDrawer: true,
	  Switch: true,
	  Tab: true,
	  Table: true,
	  TableBody: true,
	  TableCell: true,
	  TableContainer: true,
	  TableFooter: true,
	  TableHead: true,
	  TablePagination: true,
	  TableRow: true,
	  TableSortLabel: true,
	  Tabs: true,
	  TextField: true,
	  TextareaAutosize: true,
	  Toolbar: true,
	  Tooltip: true,
	  Typography: true,
	  useMediaQuery: true,
	  useScrollTrigger: true,
	  withMobileDialog: true,
	  withWidth: true,
	  Zoom: true
	};
	Object.defineProperty(exports, "AppBar", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	Object.defineProperty(exports, "Avatar", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	Object.defineProperty(exports, "Backdrop", {
	  enumerable: true,
	  get: function get() {
	    return _Backdrop.default;
	  }
	});
	Object.defineProperty(exports, "Badge", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigation", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	Object.defineProperty(exports, "BottomNavigationAction", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	Object.defineProperty(exports, "Box", {
	  enumerable: true,
	  get: function get() {
	    return _Box.default;
	  }
	});
	Object.defineProperty(exports, "Breadcrumbs", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumbs.default;
	  }
	});
	Object.defineProperty(exports, "Button", {
	  enumerable: true,
	  get: function get() {
	    return _Button.default;
	  }
	});
	Object.defineProperty(exports, "ButtonBase", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonBase.default;
	  }
	});
	Object.defineProperty(exports, "ButtonGroup", {
	  enumerable: true,
	  get: function get() {
	    return _ButtonGroup.default;
	  }
	});
	Object.defineProperty(exports, "Card", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	Object.defineProperty(exports, "CardActionArea", {
	  enumerable: true,
	  get: function get() {
	    return _CardActionArea.default;
	  }
	});
	Object.defineProperty(exports, "CardActions", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	Object.defineProperty(exports, "CardContent", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	Object.defineProperty(exports, "CardHeader", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	Object.defineProperty(exports, "CardMedia", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	Object.defineProperty(exports, "Checkbox", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	Object.defineProperty(exports, "Chip", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	Object.defineProperty(exports, "CircularProgress", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	Object.defineProperty(exports, "ClickAwayListener", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	Object.defineProperty(exports, "Collapse", {
	  enumerable: true,
	  get: function get() {
	    return _Collapse.default;
	  }
	});
	Object.defineProperty(exports, "Container", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	Object.defineProperty(exports, "CssBaseline", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	Object.defineProperty(exports, "Dialog", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	Object.defineProperty(exports, "DialogActions", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	Object.defineProperty(exports, "DialogContent", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	Object.defineProperty(exports, "DialogContentText", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	Object.defineProperty(exports, "DialogTitle", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	Object.defineProperty(exports, "Divider", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	Object.defineProperty(exports, "Drawer", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanel", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelActions", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelDetails", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	Object.defineProperty(exports, "ExpansionPanelSummary", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	Object.defineProperty(exports, "Fab", {
	  enumerable: true,
	  get: function get() {
	    return _Fab.default;
	  }
	});
	Object.defineProperty(exports, "Fade", {
	  enumerable: true,
	  get: function get() {
	    return _Fade.default;
	  }
	});
	Object.defineProperty(exports, "FilledInput", {
	  enumerable: true,
	  get: function get() {
	    return _FilledInput.default;
	  }
	});
	Object.defineProperty(exports, "FormControl", {
	  enumerable: true,
	  get: function get() {
	    return _FormControl.default;
	  }
	});
	Object.defineProperty(exports, "FormControlLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	Object.defineProperty(exports, "FormGroup", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	Object.defineProperty(exports, "FormHelperText", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	Object.defineProperty(exports, "FormLabel", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	Object.defineProperty(exports, "Grid", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	Object.defineProperty(exports, "GridList", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	Object.defineProperty(exports, "GridListTile", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	Object.defineProperty(exports, "GridListTileBar", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	Object.defineProperty(exports, "Grow", {
	  enumerable: true,
	  get: function get() {
	    return _Grow.default;
	  }
	});
	Object.defineProperty(exports, "Hidden", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	Object.defineProperty(exports, "Icon", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	Object.defineProperty(exports, "IconButton", {
	  enumerable: true,
	  get: function get() {
	    return _IconButton.default;
	  }
	});
	Object.defineProperty(exports, "Input", {
	  enumerable: true,
	  get: function get() {
	    return _Input.default;
	  }
	});
	Object.defineProperty(exports, "InputAdornment", {
	  enumerable: true,
	  get: function get() {
	    return _InputAdornment.default;
	  }
	});
	Object.defineProperty(exports, "InputBase", {
	  enumerable: true,
	  get: function get() {
	    return _InputBase.default;
	  }
	});
	Object.defineProperty(exports, "InputLabel", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	Object.defineProperty(exports, "LinearProgress", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	Object.defineProperty(exports, "Link", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	Object.defineProperty(exports, "List", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	Object.defineProperty(exports, "ListItem", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	Object.defineProperty(exports, "ListItemAvatar", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemAvatar.default;
	  }
	});
	Object.defineProperty(exports, "ListItemIcon", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	Object.defineProperty(exports, "ListItemSecondaryAction", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemSecondaryAction.default;
	  }
	});
	Object.defineProperty(exports, "ListItemText", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	Object.defineProperty(exports, "ListSubheader", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	Object.defineProperty(exports, "Menu", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	Object.defineProperty(exports, "MenuItem", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	Object.defineProperty(exports, "MenuList", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	Object.defineProperty(exports, "MobileStepper", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	Object.defineProperty(exports, "Modal", {
	  enumerable: true,
	  get: function get() {
	    return _Modal.default;
	  }
	});
	Object.defineProperty(exports, "NativeSelect", {
	  enumerable: true,
	  get: function get() {
	    return _NativeSelect.default;
	  }
	});
	Object.defineProperty(exports, "NoSsr", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	Object.defineProperty(exports, "OutlinedInput", {
	  enumerable: true,
	  get: function get() {
	    return _OutlinedInput.default;
	  }
	});
	Object.defineProperty(exports, "Paper", {
	  enumerable: true,
	  get: function get() {
	    return _Paper.default;
	  }
	});
	Object.defineProperty(exports, "Popover", {
	  enumerable: true,
	  get: function get() {
	    return _Popover.default;
	  }
	});
	Object.defineProperty(exports, "Popper", {
	  enumerable: true,
	  get: function get() {
	    return _Popper.default;
	  }
	});
	Object.defineProperty(exports, "Portal", {
	  enumerable: true,
	  get: function get() {
	    return _Portal.default;
	  }
	});
	Object.defineProperty(exports, "Radio", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	Object.defineProperty(exports, "RadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	Object.defineProperty(exports, "RootRef", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	Object.defineProperty(exports, "Select", {
	  enumerable: true,
	  get: function get() {
	    return _Select.default;
	  }
	});
	Object.defineProperty(exports, "Slide", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	Object.defineProperty(exports, "Slider", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	Object.defineProperty(exports, "Snackbar", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	Object.defineProperty(exports, "SnackbarContent", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	Object.defineProperty(exports, "Step", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	Object.defineProperty(exports, "StepButton", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	Object.defineProperty(exports, "StepConnector", {
	  enumerable: true,
	  get: function get() {
	    return _StepConnector.default;
	  }
	});
	Object.defineProperty(exports, "StepContent", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	Object.defineProperty(exports, "StepIcon", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	Object.defineProperty(exports, "StepLabel", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	Object.defineProperty(exports, "Stepper", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	Object.defineProperty(exports, "SvgIcon", {
	  enumerable: true,
	  get: function get() {
	    return _SvgIcon.default;
	  }
	});
	Object.defineProperty(exports, "SwipeableDrawer", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	Object.defineProperty(exports, "Switch", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	Object.defineProperty(exports, "Tab", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	Object.defineProperty(exports, "Table", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	Object.defineProperty(exports, "TableBody", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	Object.defineProperty(exports, "TableCell", {
	  enumerable: true,
	  get: function get() {
	    return _TableCell.default;
	  }
	});
	Object.defineProperty(exports, "TableContainer", {
	  enumerable: true,
	  get: function get() {
	    return _TableContainer.default;
	  }
	});
	Object.defineProperty(exports, "TableFooter", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	Object.defineProperty(exports, "TableHead", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	Object.defineProperty(exports, "TablePagination", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	Object.defineProperty(exports, "TableRow", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	Object.defineProperty(exports, "TableSortLabel", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	Object.defineProperty(exports, "Tabs", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	Object.defineProperty(exports, "TextField", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	Object.defineProperty(exports, "TextareaAutosize", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	Object.defineProperty(exports, "Toolbar", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	Object.defineProperty(exports, "Tooltip", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	Object.defineProperty(exports, "Typography", {
	  enumerable: true,
	  get: function get() {
	    return _Typography.default;
	  }
	});
	Object.defineProperty(exports, "useMediaQuery", {
	  enumerable: true,
	  get: function get() {
	    return _useMediaQuery.default;
	  }
	});
	Object.defineProperty(exports, "useScrollTrigger", {
	  enumerable: true,
	  get: function get() {
	    return _useScrollTrigger.default;
	  }
	});
	Object.defineProperty(exports, "withMobileDialog", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	Object.defineProperty(exports, "withWidth", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	Object.defineProperty(exports, "Zoom", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	exports.colors = void 0;
	
	var colors = _interopRequireWildcard(__webpack_require__(411));
	
	exports.colors = colors;
	
	var _styles = __webpack_require__(161);
	
	Object.keys(_styles).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _styles[key];
	    }
	  });
	});
	
	var _utils = __webpack_require__(66);
	
	Object.keys(_utils).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _utils[key];
	    }
	  });
	});
	
	var _AppBar = _interopRequireWildcard(__webpack_require__(219));
	
	Object.keys(_AppBar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _AppBar[key];
	    }
	  });
	});
	
	var _Avatar = _interopRequireWildcard(__webpack_require__(221));
	
	Object.keys(_Avatar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Avatar[key];
	    }
	  });
	});
	
	var _Backdrop = _interopRequireWildcard(__webpack_require__(74));
	
	Object.keys(_Backdrop).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Backdrop[key];
	    }
	  });
	});
	
	var _Badge = _interopRequireWildcard(__webpack_require__(224));
	
	Object.keys(_Badge).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Badge[key];
	    }
	  });
	});
	
	var _BottomNavigation = _interopRequireWildcard(__webpack_require__(226));
	
	Object.keys(_BottomNavigation).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BottomNavigation[key];
	    }
	  });
	});
	
	var _BottomNavigationAction = _interopRequireWildcard(__webpack_require__(228));
	
	Object.keys(_BottomNavigationAction).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _BottomNavigationAction[key];
	    }
	  });
	});
	
	var _Box = _interopRequireWildcard(__webpack_require__(230));
	
	Object.keys(_Box).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Box[key];
	    }
	  });
	});
	
	var _Breadcrumbs = _interopRequireWildcard(__webpack_require__(233));
	
	Object.keys(_Breadcrumbs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Breadcrumbs[key];
	    }
	  });
	});
	
	var _Button = _interopRequireWildcard(__webpack_require__(34));
	
	Object.keys(_Button).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Button[key];
	    }
	  });
	});
	
	var _ButtonBase = _interopRequireWildcard(__webpack_require__(19));
	
	Object.keys(_ButtonBase).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ButtonBase[key];
	    }
	  });
	});
	
	var _ButtonGroup = _interopRequireWildcard(__webpack_require__(42));
	
	Object.keys(_ButtonGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ButtonGroup[key];
	    }
	  });
	});
	
	var _Card = _interopRequireWildcard(__webpack_require__(240));
	
	Object.keys(_Card).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Card[key];
	    }
	  });
	});
	
	var _CardActionArea = _interopRequireWildcard(__webpack_require__(242));
	
	Object.keys(_CardActionArea).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActionArea[key];
	    }
	  });
	});
	
	var _CardActions = _interopRequireWildcard(__webpack_require__(244));
	
	Object.keys(_CardActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardActions[key];
	    }
	  });
	});
	
	var _CardContent = _interopRequireWildcard(__webpack_require__(246));
	
	Object.keys(_CardContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardContent[key];
	    }
	  });
	});
	
	var _CardHeader = _interopRequireWildcard(__webpack_require__(248));
	
	Object.keys(_CardHeader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardHeader[key];
	    }
	  });
	});
	
	var _CardMedia = _interopRequireWildcard(__webpack_require__(250));
	
	Object.keys(_CardMedia).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CardMedia[key];
	    }
	  });
	});
	
	var _Checkbox = _interopRequireWildcard(__webpack_require__(252));
	
	Object.keys(_Checkbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Checkbox[key];
	    }
	  });
	});
	
	var _Chip = _interopRequireWildcard(__webpack_require__(114));
	
	Object.keys(_Chip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Chip[key];
	    }
	  });
	});
	
	var _CircularProgress = _interopRequireWildcard(__webpack_require__(255));
	
	Object.keys(_CircularProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CircularProgress[key];
	    }
	  });
	});
	
	var _ClickAwayListener = _interopRequireWildcard(__webpack_require__(115));
	
	Object.keys(_ClickAwayListener).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ClickAwayListener[key];
	    }
	  });
	});
	
	var _Collapse = _interopRequireWildcard(__webpack_require__(75));
	
	Object.keys(_Collapse).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Collapse[key];
	    }
	  });
	});
	
	var _Container = _interopRequireWildcard(__webpack_require__(259));
	
	Object.keys(_Container).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Container[key];
	    }
	  });
	});
	
	var _CssBaseline = _interopRequireWildcard(__webpack_require__(261));
	
	Object.keys(_CssBaseline).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _CssBaseline[key];
	    }
	  });
	});
	
	var _Dialog = _interopRequireWildcard(__webpack_require__(263));
	
	Object.keys(_Dialog).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Dialog[key];
	    }
	  });
	});
	
	var _DialogActions = _interopRequireWildcard(__webpack_require__(265));
	
	Object.keys(_DialogActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogActions[key];
	    }
	  });
	});
	
	var _DialogContent = _interopRequireWildcard(__webpack_require__(267));
	
	Object.keys(_DialogContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogContent[key];
	    }
	  });
	});
	
	var _DialogContentText = _interopRequireWildcard(__webpack_require__(269));
	
	Object.keys(_DialogContentText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogContentText[key];
	    }
	  });
	});
	
	var _DialogTitle = _interopRequireWildcard(__webpack_require__(271));
	
	Object.keys(_DialogTitle).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _DialogTitle[key];
	    }
	  });
	});
	
	var _Divider = _interopRequireWildcard(__webpack_require__(273));
	
	Object.keys(_Divider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Divider[key];
	    }
	  });
	});
	
	var _Drawer = _interopRequireWildcard(__webpack_require__(274));
	
	Object.keys(_Drawer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Drawer[key];
	    }
	  });
	});
	
	var _ExpansionPanel = _interopRequireWildcard(__webpack_require__(276));
	
	Object.keys(_ExpansionPanel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanel[key];
	    }
	  });
	});
	
	var _ExpansionPanelActions = _interopRequireWildcard(__webpack_require__(278));
	
	Object.keys(_ExpansionPanelActions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelActions[key];
	    }
	  });
	});
	
	var _ExpansionPanelDetails = _interopRequireWildcard(__webpack_require__(280));
	
	Object.keys(_ExpansionPanelDetails).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelDetails[key];
	    }
	  });
	});
	
	var _ExpansionPanelSummary = _interopRequireWildcard(__webpack_require__(282));
	
	Object.keys(_ExpansionPanelSummary).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ExpansionPanelSummary[key];
	    }
	  });
	});
	
	var _Fab = _interopRequireWildcard(__webpack_require__(284));
	
	Object.keys(_Fab).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Fab[key];
	    }
	  });
	});
	
	var _Fade = _interopRequireWildcard(__webpack_require__(77));
	
	Object.keys(_Fade).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Fade[key];
	    }
	  });
	});
	
	var _FilledInput = _interopRequireWildcard(__webpack_require__(78));
	
	Object.keys(_FilledInput).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FilledInput[key];
	    }
	  });
	});
	
	var _FormControl = _interopRequireWildcard(__webpack_require__(79));
	
	Object.keys(_FormControl).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormControl[key];
	    }
	  });
	});
	
	var _FormControlLabel = _interopRequireWildcard(__webpack_require__(289));
	
	Object.keys(_FormControlLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormControlLabel[key];
	    }
	  });
	});
	
	var _FormGroup = _interopRequireWildcard(__webpack_require__(117));
	
	Object.keys(_FormGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormGroup[key];
	    }
	  });
	});
	
	var _FormHelperText = _interopRequireWildcard(__webpack_require__(118));
	
	Object.keys(_FormHelperText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormHelperText[key];
	    }
	  });
	});
	
	var _FormLabel = _interopRequireWildcard(__webpack_require__(119));
	
	Object.keys(_FormLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _FormLabel[key];
	    }
	  });
	});
	
	var _Grid = _interopRequireWildcard(__webpack_require__(294));
	
	Object.keys(_Grid).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Grid[key];
	    }
	  });
	});
	
	var _GridList = _interopRequireWildcard(__webpack_require__(296));
	
	Object.keys(_GridList).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridList[key];
	    }
	  });
	});
	
	var _GridListTile = _interopRequireWildcard(__webpack_require__(298));
	
	Object.keys(_GridListTile).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridListTile[key];
	    }
	  });
	});
	
	var _GridListTileBar = _interopRequireWildcard(__webpack_require__(300));
	
	Object.keys(_GridListTileBar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _GridListTileBar[key];
	    }
	  });
	});
	
	var _Grow = _interopRequireWildcard(__webpack_require__(63));
	
	Object.keys(_Grow).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Grow[key];
	    }
	  });
	});
	
	var _Hidden = _interopRequireWildcard(__webpack_require__(305));
	
	Object.keys(_Hidden).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Hidden[key];
	    }
	  });
	});
	
	var _Icon = _interopRequireWildcard(__webpack_require__(307));
	
	Object.keys(_Icon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Icon[key];
	    }
	  });
	});
	
	var _IconButton = _interopRequireWildcard(__webpack_require__(48));
	
	Object.keys(_IconButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _IconButton[key];
	    }
	  });
	});
	
	var _Input = _interopRequireWildcard(__webpack_require__(64));
	
	Object.keys(_Input).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Input[key];
	    }
	  });
	});
	
	var _InputAdornment = _interopRequireWildcard(__webpack_require__(311));
	
	Object.keys(_InputAdornment).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputAdornment[key];
	    }
	  });
	});
	
	var _InputBase = _interopRequireWildcard(__webpack_require__(49));
	
	Object.keys(_InputBase).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputBase[key];
	    }
	  });
	});
	
	var _InputLabel = _interopRequireWildcard(__webpack_require__(120));
	
	Object.keys(_InputLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _InputLabel[key];
	    }
	  });
	});
	
	var _LinearProgress = _interopRequireWildcard(__webpack_require__(121));
	
	Object.keys(_LinearProgress).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _LinearProgress[key];
	    }
	  });
	});
	
	var _Link = _interopRequireWildcard(__webpack_require__(316));
	
	Object.keys(_Link).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Link[key];
	    }
	  });
	});
	
	var _List = _interopRequireWildcard(__webpack_require__(122));
	
	Object.keys(_List).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _List[key];
	    }
	  });
	});
	
	var _ListItem = _interopRequireWildcard(__webpack_require__(123));
	
	Object.keys(_ListItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItem[key];
	    }
	  });
	});
	
	var _ListItemAvatar = _interopRequireWildcard(__webpack_require__(320));
	
	Object.keys(_ListItemAvatar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemAvatar[key];
	    }
	  });
	});
	
	var _ListItemIcon = _interopRequireWildcard(__webpack_require__(322));
	
	Object.keys(_ListItemIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemIcon[key];
	    }
	  });
	});
	
	var _ListItemSecondaryAction = _interopRequireWildcard(__webpack_require__(324));
	
	Object.keys(_ListItemSecondaryAction).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemSecondaryAction[key];
	    }
	  });
	});
	
	var _ListItemText = _interopRequireWildcard(__webpack_require__(326));
	
	Object.keys(_ListItemText).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListItemText[key];
	    }
	  });
	});
	
	var _ListSubheader = _interopRequireWildcard(__webpack_require__(124));
	
	Object.keys(_ListSubheader).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _ListSubheader[key];
	    }
	  });
	});
	
	var _Menu = _interopRequireWildcard(__webpack_require__(328));
	
	Object.keys(_Menu).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Menu[key];
	    }
	  });
	});
	
	var _MenuItem = _interopRequireWildcard(__webpack_require__(126));
	
	Object.keys(_MenuItem).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuItem[key];
	    }
	  });
	});
	
	var _MenuList = _interopRequireWildcard(__webpack_require__(127));
	
	Object.keys(_MenuList).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MenuList[key];
	    }
	  });
	});
	
	var _MobileStepper = _interopRequireWildcard(__webpack_require__(332));
	
	Object.keys(_MobileStepper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _MobileStepper[key];
	    }
	  });
	});
	
	var _Modal = _interopRequireWildcard(__webpack_require__(65));
	
	Object.keys(_Modal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Modal[key];
	    }
	  });
	});
	
	var _NativeSelect = _interopRequireWildcard(__webpack_require__(336));
	
	Object.keys(_NativeSelect).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _NativeSelect[key];
	    }
	  });
	});
	
	var _NoSsr = _interopRequireWildcard(__webpack_require__(131));
	
	Object.keys(_NoSsr).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _NoSsr[key];
	    }
	  });
	});
	
	var _OutlinedInput = _interopRequireWildcard(__webpack_require__(81));
	
	Object.keys(_OutlinedInput).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _OutlinedInput[key];
	    }
	  });
	});
	
	var _Paper = _interopRequireWildcard(__webpack_require__(23));
	
	Object.keys(_Paper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Paper[key];
	    }
	  });
	});
	
	var _Popover = _interopRequireWildcard(__webpack_require__(82));
	
	Object.keys(_Popover).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Popover[key];
	    }
	  });
	});
	
	var _Popper = _interopRequireWildcard(__webpack_require__(83));
	
	Object.keys(_Popper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Popper[key];
	    }
	  });
	});
	
	var _Portal = _interopRequireWildcard(__webpack_require__(84));
	
	Object.keys(_Portal).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Portal[key];
	    }
	  });
	});
	
	var _Radio = _interopRequireWildcard(__webpack_require__(346));
	
	Object.keys(_Radio).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Radio[key];
	    }
	  });
	});
	
	var _RadioGroup = _interopRequireWildcard(__webpack_require__(348));
	
	Object.keys(_RadioGroup).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _RadioGroup[key];
	    }
	  });
	});
	
	var _RootRef = _interopRequireWildcard(__webpack_require__(350));
	
	Object.keys(_RootRef).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _RootRef[key];
	    }
	  });
	});
	
	var _Select = _interopRequireWildcard(__webpack_require__(85));
	
	Object.keys(_Select).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Select[key];
	    }
	  });
	});
	
	var _Slide = _interopRequireWildcard(__webpack_require__(134));
	
	Object.keys(_Slide).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Slide[key];
	    }
	  });
	});
	
	var _Slider = _interopRequireWildcard(__webpack_require__(356));
	
	Object.keys(_Slider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Slider[key];
	    }
	  });
	});
	
	var _Snackbar = _interopRequireWildcard(__webpack_require__(358));
	
	Object.keys(_Snackbar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Snackbar[key];
	    }
	  });
	});
	
	var _SnackbarContent = _interopRequireWildcard(__webpack_require__(135));
	
	Object.keys(_SnackbarContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SnackbarContent[key];
	    }
	  });
	});
	
	var _Step = _interopRequireWildcard(__webpack_require__(361));
	
	Object.keys(_Step).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Step[key];
	    }
	  });
	});
	
	var _StepButton = _interopRequireWildcard(__webpack_require__(363));
	
	Object.keys(_StepButton).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepButton[key];
	    }
	  });
	});
	
	var _StepConnector = _interopRequireWildcard(__webpack_require__(136));
	
	Object.keys(_StepConnector).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepConnector[key];
	    }
	  });
	});
	
	var _StepContent = _interopRequireWildcard(__webpack_require__(366));
	
	Object.keys(_StepContent).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepContent[key];
	    }
	  });
	});
	
	var _StepIcon = _interopRequireWildcard(__webpack_require__(137));
	
	Object.keys(_StepIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepIcon[key];
	    }
	  });
	});
	
	var _StepLabel = _interopRequireWildcard(__webpack_require__(138));
	
	Object.keys(_StepLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StepLabel[key];
	    }
	  });
	});
	
	var _Stepper = _interopRequireWildcard(__webpack_require__(370));
	
	Object.keys(_Stepper).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Stepper[key];
	    }
	  });
	});
	
	var _SvgIcon = _interopRequireWildcard(__webpack_require__(51));
	
	Object.keys(_SvgIcon).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SvgIcon[key];
	    }
	  });
	});
	
	var _SwipeableDrawer = _interopRequireWildcard(__webpack_require__(374));
	
	Object.keys(_SwipeableDrawer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _SwipeableDrawer[key];
	    }
	  });
	});
	
	var _Switch = _interopRequireWildcard(__webpack_require__(376));
	
	Object.keys(_Switch).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Switch[key];
	    }
	  });
	});
	
	var _Tab = _interopRequireWildcard(__webpack_require__(378));
	
	Object.keys(_Tab).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tab[key];
	    }
	  });
	});
	
	var _Table = _interopRequireWildcard(__webpack_require__(140));
	
	Object.keys(_Table).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Table[key];
	    }
	  });
	});
	
	var _TableBody = _interopRequireWildcard(__webpack_require__(141));
	
	Object.keys(_TableBody).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableBody[key];
	    }
	  });
	});
	
	var _TableCell = _interopRequireWildcard(__webpack_require__(86));
	
	Object.keys(_TableCell).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableCell[key];
	    }
	  });
	});
	
	var _TableContainer = _interopRequireWildcard(__webpack_require__(142));
	
	Object.keys(_TableContainer).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableContainer[key];
	    }
	  });
	});
	
	var _TableFooter = _interopRequireWildcard(__webpack_require__(384));
	
	Object.keys(_TableFooter).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableFooter[key];
	    }
	  });
	});
	
	var _TableHead = _interopRequireWildcard(__webpack_require__(143));
	
	Object.keys(_TableHead).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableHead[key];
	    }
	  });
	});
	
	var _TablePagination = _interopRequireWildcard(__webpack_require__(388));
	
	Object.keys(_TablePagination).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TablePagination[key];
	    }
	  });
	});
	
	var _TableRow = _interopRequireWildcard(__webpack_require__(144));
	
	Object.keys(_TableRow).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableRow[key];
	    }
	  });
	});
	
	var _TableSortLabel = _interopRequireWildcard(__webpack_require__(391));
	
	Object.keys(_TableSortLabel).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TableSortLabel[key];
	    }
	  });
	});
	
	var _Tabs = _interopRequireWildcard(__webpack_require__(396));
	
	Object.keys(_Tabs).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tabs[key];
	    }
	  });
	});
	
	var _TextField = _interopRequireWildcard(__webpack_require__(145));
	
	Object.keys(_TextField).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextField[key];
	    }
	  });
	});
	
	var _TextareaAutosize = _interopRequireWildcard(__webpack_require__(146));
	
	Object.keys(_TextareaAutosize).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _TextareaAutosize[key];
	    }
	  });
	});
	
	var _Toolbar = _interopRequireWildcard(__webpack_require__(147));
	
	Object.keys(_Toolbar).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Toolbar[key];
	    }
	  });
	});
	
	var _Tooltip = _interopRequireWildcard(__webpack_require__(401));
	
	Object.keys(_Tooltip).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Tooltip[key];
	    }
	  });
	});
	
	var _Typography = _interopRequireWildcard(__webpack_require__(24));
	
	Object.keys(_Typography).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Typography[key];
	    }
	  });
	});
	
	var _useMediaQuery = _interopRequireWildcard(__webpack_require__(164));
	
	Object.keys(_useMediaQuery).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useMediaQuery[key];
	    }
	  });
	});
	
	var _useScrollTrigger = _interopRequireWildcard(__webpack_require__(443));
	
	Object.keys(_useScrollTrigger).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _useScrollTrigger[key];
	    }
	  });
	});
	
	var _withMobileDialog = _interopRequireWildcard(__webpack_require__(447));
	
	Object.keys(_withMobileDialog).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withMobileDialog[key];
	    }
	  });
	});
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(90));
	
	Object.keys(_withWidth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withWidth[key];
	    }
	  });
	});
	
	var _Zoom = _interopRequireWildcard(__webpack_require__(404));
	
	Object.keys(_Zoom).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _Zoom[key];
	    }
	  });
	});

/***/ },
/* 88 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(32));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(39));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(36));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(48));
	
	var styles = {
	  root: {
	    padding: 9
	  },
	  checked: {},
	  disabled: {},
	  input: {
	    cursor: 'inherit',
	    position: 'absolute',
	    opacity: 0,
	    width: '100%',
	    height: '100%',
	    top: 0,
	    left: 0,
	    margin: 0,
	    padding: 0,
	    zIndex: 1
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	var SwitchBase = React.forwardRef(function SwitchBase(props, ref) {
	  var autoFocus = props.autoFocus,
	      checkedProp = props.checked,
	      checkedIcon = props.checkedIcon,
	      classes = props.classes,
	      className = props.className,
	      defaultChecked = props.defaultChecked,
	      disabledProp = props.disabled,
	      icon = props.icon,
	      id = props.id,
	      inputProps = props.inputProps,
	      inputRef = props.inputRef,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      readOnly = props.readOnly,
	      required = props.required,
	      tabIndex = props.tabIndex,
	      type = props.type,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "checked", "checkedIcon", "classes", "className", "defaultChecked", "disabled", "icon", "id", "inputProps", "inputRef", "name", "onBlur", "onChange", "onFocus", "readOnly", "required", "tabIndex", "type", "value"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: checkedProp,
	    default: Boolean(defaultChecked),
	    name: 'SwitchBase',
	    state: 'checked'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      checked = _useControlled2[0],
	      setCheckedState = _useControlled2[1];
	
	  var muiFormControl = (0, _useFormControl.default)();
	
	  var handleFocus = function handleFocus(event) {
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    }
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    var newChecked = event.target.checked;
	    setCheckedState(newChecked);
	
	    if (onChange) {
	      onChange(event, newChecked);
	    }
	  };
	
	  var disabled = disabledProp;
	
	  if (muiFormControl) {
	    if (typeof disabled === 'undefined') {
	      disabled = muiFormControl.disabled;
	    }
	  }
	
	  var hasLabelFor = type === 'checkbox' || type === 'radio';
	  return /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    component: "span",
	    className: (0, _clsx.default)(classes.root, className, checked && classes.checked, disabled && classes.disabled),
	    disabled: disabled,
	    tabIndex: null,
	    role: undefined,
	    onFocus: handleFocus,
	    onBlur: handleBlur,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
	    autoFocus: autoFocus,
	    checked: checkedProp,
	    defaultChecked: defaultChecked,
	    className: classes.input,
	    disabled: disabled,
	    id: hasLabelFor && id,
	    name: name,
	    onChange: handleInputChange,
	    readOnly: readOnly,
	    ref: inputRef,
	    required: required,
	    tabIndex: tabIndex,
	    type: type,
	    value: value
	  }, inputProps)), checked ? checkedIcon : icon);
	}); // NB: If changed, please update Checkbox, Switch and Radio
	// so that the API documentation is updated.
	
	 false ? SwitchBase.propTypes = {
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node.isRequired,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /*
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The input component prop `type`.
	   */
	  type: _propTypes.default.string.isRequired,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateSwitchBase'
	})(SwitchBase);
	
	exports.default = _default;

/***/ },
/* 89 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useId;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * Private module reserved for @material-ui/x packages.
	 */
	function useId(idOverride) {
	  var _React$useState = React.useState(idOverride),
	      defaultId = _React$useState[0],
	      setDefaultId = _React$useState[1];
	
	  var id = idOverride || defaultId;
	  React.useEffect(function () {
	    if (defaultId == null) {
	      // Fallback to this default id when possible.
	      // Use the random value for client-side rendering only.
	      // We can't use it server-side.
	      setDefaultId("mui-".concat(Math.round(Math.random() * 1e5)));
	    }
	  }, [defaultId]);
	  return id;
	}

/***/ },
/* 90 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withWidth.default;
	  }
	});
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(449));
	
	Object.keys(_withWidth).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withWidth[key];
	    }
	  });
	});

/***/ },
/* 91 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StylesProvider.default;
	  }
	});
	
	var _StylesProvider = _interopRequireWildcard(__webpack_require__(462));
	
	Object.keys(_StylesProvider).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _StylesProvider[key];
	    }
	  });
	});

/***/ },
/* 92 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createGenerateClassName.default;
	  }
	});
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(465));

/***/ },
/* 93 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(473));

/***/ },
/* 94 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(18);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	TYPE_STATICS[reactIs.Memo] = MEMO_STATICS;
	
	function getStatics(component) {
	  // React v16.11 and below
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  } // React v16.12 and above
	
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 95 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.handleBreakpoints = handleBreakpoints;
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(33));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _merge = _interopRequireDefault(__webpack_require__(69));
	
	// The breakpoint **start** at this value.
	// For instance with the first breakpoint xs: [xs, sm[.
	var values = {
	  xs: 0,
	  sm: 600,
	  md: 960,
	  lg: 1280,
	  xl: 1920
	};
	var defaultBreakpoints = {
	  // Sorted ASC by size. That's important.
	  // It can't be configured as it's used statically for propTypes.
	  keys: ['xs', 'sm', 'md', 'lg', 'xl'],
	  up: function up(key) {
	    return "@media (min-width:".concat(values[key], "px)");
	  }
	};
	
	function handleBreakpoints(props, propValue, styleFromPropValue) {
	  if (false) {
	    if (!props.theme) {
	      console.error('@material-ui/system: you are calling a style function without a theme value.');
	    }
	  }
	
	  if (Array.isArray(propValue)) {
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    return propValue.reduce(function (acc, item, index) {
	      acc[themeBreakpoints.up(themeBreakpoints.keys[index])] = styleFromPropValue(propValue[index]);
	      return acc;
	    }, {});
	  }
	
	  if ((0, _typeof2.default)(propValue) === 'object') {
	    var _themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	
	    return Object.keys(propValue).reduce(function (acc, breakpoint) {
	      acc[_themeBreakpoints.up(breakpoint)] = styleFromPropValue(propValue[breakpoint]);
	      return acc;
	    }, {});
	  }
	
	  var output = styleFromPropValue(propValue);
	  return output;
	}
	
	function breakpoints(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var base = styleFunction(props);
	    var themeBreakpoints = props.theme.breakpoints || defaultBreakpoints;
	    var extended = themeBreakpoints.keys.reduce(function (acc, key) {
	      if (props[key]) {
	        acc = acc || {};
	        acc[themeBreakpoints.up(key)] = styleFunction((0, _extends2.default)({
	          theme: props.theme
	        }, props[key]));
	      }
	
	      return acc;
	    }, null);
	    return (0, _merge.default)(base, extended);
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)({}, styleFunction.propTypes, {
	    xs: _propTypes.default.object,
	    sm: _propTypes.default.object,
	    md: _propTypes.default.object,
	    lg: _propTypes.default.object,
	    xl: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['xs', 'sm', 'md', 'lg', 'xl'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	
	var _default = breakpoints;
	exports.default = _default;

/***/ },
/* 96 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = chainPropTypes;
	
	function chainPropTypes(propType1, propType2) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function validate() {
	    return propType1.apply(void 0, arguments) || propType2.apply(void 0, arguments);
	  };
	}

/***/ },
/* 97 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-collection/ v1.0.7 Copyright 2018 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(factory((global.d3 = global.d3 || {})));
	}(this, (function (exports) { 'use strict';
	
	var prefix = "$";
	
	function Map() {}
	
	Map.prototype = map.prototype = {
	  constructor: Map,
	  has: function(key) {
	    return (prefix + key) in this;
	  },
	  get: function(key) {
	    return this[prefix + key];
	  },
	  set: function(key, value) {
	    this[prefix + key] = value;
	    return this;
	  },
	  remove: function(key) {
	    var property = prefix + key;
	    return property in this && delete this[property];
	  },
	  clear: function() {
	    for (var property in this) if (property[0] === prefix) delete this[property];
	  },
	  keys: function() {
	    var keys = [];
	    for (var property in this) if (property[0] === prefix) keys.push(property.slice(1));
	    return keys;
	  },
	  values: function() {
	    var values = [];
	    for (var property in this) if (property[0] === prefix) values.push(this[property]);
	    return values;
	  },
	  entries: function() {
	    var entries = [];
	    for (var property in this) if (property[0] === prefix) entries.push({key: property.slice(1), value: this[property]});
	    return entries;
	  },
	  size: function() {
	    var size = 0;
	    for (var property in this) if (property[0] === prefix) ++size;
	    return size;
	  },
	  empty: function() {
	    for (var property in this) if (property[0] === prefix) return false;
	    return true;
	  },
	  each: function(f) {
	    for (var property in this) if (property[0] === prefix) f(this[property], property.slice(1), this);
	  }
	};
	
	function map(object, f) {
	  var map = new Map;
	
	  // Copy constructor.
	  if (object instanceof Map) object.each(function(value, key) { map.set(key, value); });
	
	  // Index array by numeric index or specified key function.
	  else if (Array.isArray(object)) {
	    var i = -1,
	        n = object.length,
	        o;
	
	    if (f == null) while (++i < n) map.set(i, object[i]);
	    else while (++i < n) map.set(f(o = object[i], i, object), o);
	  }
	
	  // Convert object to map.
	  else if (object) for (var key in object) map.set(key, object[key]);
	
	  return map;
	}
	
	function nest() {
	  var keys = [],
	      sortKeys = [],
	      sortValues,
	      rollup,
	      nest;
	
	  function apply(array, depth, createResult, setResult) {
	    if (depth >= keys.length) {
	      if (sortValues != null) array.sort(sortValues);
	      return rollup != null ? rollup(array) : array;
	    }
	
	    var i = -1,
	        n = array.length,
	        key = keys[depth++],
	        keyValue,
	        value,
	        valuesByKey = map(),
	        values,
	        result = createResult();
	
	    while (++i < n) {
	      if (values = valuesByKey.get(keyValue = key(value = array[i]) + "")) {
	        values.push(value);
	      } else {
	        valuesByKey.set(keyValue, [value]);
	      }
	    }
	
	    valuesByKey.each(function(values, key) {
	      setResult(result, key, apply(values, depth, createResult, setResult));
	    });
	
	    return result;
	  }
	
	  function entries(map$$1, depth) {
	    if (++depth > keys.length) return map$$1;
	    var array, sortKey = sortKeys[depth - 1];
	    if (rollup != null && depth >= keys.length) array = map$$1.entries();
	    else array = [], map$$1.each(function(v, k) { array.push({key: k, values: entries(v, depth)}); });
	    return sortKey != null ? array.sort(function(a, b) { return sortKey(a.key, b.key); }) : array;
	  }
	
	  return nest = {
	    object: function(array) { return apply(array, 0, createObject, setObject); },
	    map: function(array) { return apply(array, 0, createMap, setMap); },
	    entries: function(array) { return entries(apply(array, 0, createMap, setMap), 0); },
	    key: function(d) { keys.push(d); return nest; },
	    sortKeys: function(order) { sortKeys[keys.length - 1] = order; return nest; },
	    sortValues: function(order) { sortValues = order; return nest; },
	    rollup: function(f) { rollup = f; return nest; }
	  };
	}
	
	function createObject() {
	  return {};
	}
	
	function setObject(object, key, value) {
	  object[key] = value;
	}
	
	function createMap() {
	  return map();
	}
	
	function setMap(map$$1, key, value) {
	  map$$1.set(key, value);
	}
	
	function Set() {}
	
	var proto = map.prototype;
	
	Set.prototype = set.prototype = {
	  constructor: Set,
	  has: proto.has,
	  add: function(value) {
	    value += "";
	    this[prefix + value] = value;
	    return this;
	  },
	  remove: proto.remove,
	  clear: proto.clear,
	  values: proto.keys,
	  size: proto.size,
	  empty: proto.empty,
	  each: proto.each
	};
	
	function set(object, f) {
	  var set = new Set;
	
	  // Copy constructor.
	  if (object instanceof Set) object.each(function(value) { set.add(value); });
	
	  // Otherwise, assume it’s an array.
	  else if (object) {
	    var i = -1, n = object.length;
	    if (f == null) while (++i < n) set.add(object[i]);
	    else while (++i < n) set.add(f(object[i], i, object));
	  }
	
	  return set;
	}
	
	function keys(map) {
	  var keys = [];
	  for (var key in map) keys.push(key);
	  return keys;
	}
	
	function values(map) {
	  var values = [];
	  for (var key in map) values.push(map[key]);
	  return values;
	}
	
	function entries(map) {
	  var entries = [];
	  for (var key in map) entries.push({key: key, value: map[key]});
	  return entries;
	}
	
	exports.nest = nest;
	exports.set = set;
	exports.map = map;
	exports.keys = keys;
	exports.values = values;
	exports.entries = entries;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 98 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-interpolate/ v1.4.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(70)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-color'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Color) { 'use strict';
	
	function basis(t1, v0, v1, v2, v3) {
	  var t2 = t1 * t1, t3 = t2 * t1;
	  return ((1 - 3 * t1 + 3 * t2 - t3) * v0
	      + (4 - 6 * t2 + 3 * t3) * v1
	      + (1 + 3 * t1 + 3 * t2 - 3 * t3) * v2
	      + t3 * v3) / 6;
	}
	
	function basis$1(values) {
	  var n = values.length - 1;
	  return function(t) {
	    var i = t <= 0 ? (t = 0) : t >= 1 ? (t = 1, n - 1) : Math.floor(t * n),
	        v1 = values[i],
	        v2 = values[i + 1],
	        v0 = i > 0 ? values[i - 1] : 2 * v1 - v2,
	        v3 = i < n - 1 ? values[i + 2] : 2 * v2 - v1;
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function basisClosed(values) {
	  var n = values.length;
	  return function(t) {
	    var i = Math.floor(((t %= 1) < 0 ? ++t : t) * n),
	        v0 = values[(i + n - 1) % n],
	        v1 = values[i % n],
	        v2 = values[(i + 1) % n],
	        v3 = values[(i + 2) % n];
	    return basis((t - i / n) * n, v0, v1, v2, v3);
	  };
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function linear(a, d) {
	  return function(t) {
	    return a + t * d;
	  };
	}
	
	function exponential(a, b, y) {
	  return a = Math.pow(a, y), b = Math.pow(b, y) - a, y = 1 / y, function(t) {
	    return Math.pow(a + t * b, y);
	  };
	}
	
	function hue(a, b) {
	  var d = b - a;
	  return d ? linear(a, d > 180 || d < -180 ? d - 360 * Math.round(d / 360) : d) : constant(isNaN(a) ? b : a);
	}
	
	function gamma(y) {
	  return (y = +y) === 1 ? nogamma : function(a, b) {
	    return b - a ? exponential(a, b, y) : constant(isNaN(a) ? b : a);
	  };
	}
	
	function nogamma(a, b) {
	  var d = b - a;
	  return d ? linear(a, d) : constant(isNaN(a) ? b : a);
	}
	
	var rgb = (function rgbGamma(y) {
	  var color = gamma(y);
	
	  function rgb(start, end) {
	    var r = color((start = d3Color.rgb(start)).r, (end = d3Color.rgb(end)).r),
	        g = color(start.g, end.g),
	        b = color(start.b, end.b),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.r = r(t);
	      start.g = g(t);
	      start.b = b(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	
	  rgb.gamma = rgbGamma;
	
	  return rgb;
	})(1);
	
	function rgbSpline(spline) {
	  return function(colors) {
	    var n = colors.length,
	        r = new Array(n),
	        g = new Array(n),
	        b = new Array(n),
	        i, color;
	    for (i = 0; i < n; ++i) {
	      color = d3Color.rgb(colors[i]);
	      r[i] = color.r || 0;
	      g[i] = color.g || 0;
	      b[i] = color.b || 0;
	    }
	    r = spline(r);
	    g = spline(g);
	    b = spline(b);
	    color.opacity = 1;
	    return function(t) {
	      color.r = r(t);
	      color.g = g(t);
	      color.b = b(t);
	      return color + "";
	    };
	  };
	}
	
	var rgbBasis = rgbSpline(basis$1);
	var rgbBasisClosed = rgbSpline(basisClosed);
	
	function numberArray(a, b) {
	  if (!b) b = [];
	  var n = a ? Math.min(b.length, a.length) : 0,
	      c = b.slice(),
	      i;
	  return function(t) {
	    for (i = 0; i < n; ++i) c[i] = a[i] * (1 - t) + b[i] * t;
	    return c;
	  };
	}
	
	function isNumberArray(x) {
	  return ArrayBuffer.isView(x) && !(x instanceof DataView);
	}
	
	function array(a, b) {
	  return (isNumberArray(b) ? numberArray : genericArray)(a, b);
	}
	
	function genericArray(a, b) {
	  var nb = b ? b.length : 0,
	      na = a ? Math.min(nb, a.length) : 0,
	      x = new Array(na),
	      c = new Array(nb),
	      i;
	
	  for (i = 0; i < na; ++i) x[i] = value(a[i], b[i]);
	  for (; i < nb; ++i) c[i] = b[i];
	
	  return function(t) {
	    for (i = 0; i < na; ++i) c[i] = x[i](t);
	    return c;
	  };
	}
	
	function date(a, b) {
	  var d = new Date;
	  return a = +a, b = +b, function(t) {
	    return d.setTime(a * (1 - t) + b * t), d;
	  };
	}
	
	function number(a, b) {
	  return a = +a, b = +b, function(t) {
	    return a * (1 - t) + b * t;
	  };
	}
	
	function object(a, b) {
	  var i = {},
	      c = {},
	      k;
	
	  if (a === null || typeof a !== "object") a = {};
	  if (b === null || typeof b !== "object") b = {};
	
	  for (k in b) {
	    if (k in a) {
	      i[k] = value(a[k], b[k]);
	    } else {
	      c[k] = b[k];
	    }
	  }
	
	  return function(t) {
	    for (k in i) c[k] = i[k](t);
	    return c;
	  };
	}
	
	var reA = /[-+]?(?:\d+\.?\d*|\.?\d+)(?:[eE][-+]?\d+)?/g,
	    reB = new RegExp(reA.source, "g");
	
	function zero(b) {
	  return function() {
	    return b;
	  };
	}
	
	function one(b) {
	  return function(t) {
	    return b(t) + "";
	  };
	}
	
	function string(a, b) {
	  var bi = reA.lastIndex = reB.lastIndex = 0, // scan index for next number in b
	      am, // current match in a
	      bm, // current match in b
	      bs, // string preceding current number in b, if any
	      i = -1, // index in s
	      s = [], // string constants and placeholders
	      q = []; // number interpolators
	
	  // Coerce inputs to strings.
	  a = a + "", b = b + "";
	
	  // Interpolate pairs of numbers in a & b.
	  while ((am = reA.exec(a))
	      && (bm = reB.exec(b))) {
	    if ((bs = bm.index) > bi) { // a string precedes the next number in b
	      bs = b.slice(bi, bs);
	      if (s[i]) s[i] += bs; // coalesce with previous string
	      else s[++i] = bs;
	    }
	    if ((am = am[0]) === (bm = bm[0])) { // numbers in a & b match
	      if (s[i]) s[i] += bm; // coalesce with previous string
	      else s[++i] = bm;
	    } else { // interpolate non-matching numbers
	      s[++i] = null;
	      q.push({i: i, x: number(am, bm)});
	    }
	    bi = reB.lastIndex;
	  }
	
	  // Add remains of b.
	  if (bi < b.length) {
	    bs = b.slice(bi);
	    if (s[i]) s[i] += bs; // coalesce with previous string
	    else s[++i] = bs;
	  }
	
	  // Special optimization for only a single match.
	  // Otherwise, interpolate each of the numbers and rejoin the string.
	  return s.length < 2 ? (q[0]
	      ? one(q[0].x)
	      : zero(b))
	      : (b = q.length, function(t) {
	          for (var i = 0, o; i < b; ++i) s[(o = q[i]).i] = o.x(t);
	          return s.join("");
	        });
	}
	
	function value(a, b) {
	  var t = typeof b, c;
	  return b == null || t === "boolean" ? constant(b)
	      : (t === "number" ? number
	      : t === "string" ? ((c = d3Color.color(b)) ? (b = c, rgb) : string)
	      : b instanceof d3Color.color ? rgb
	      : b instanceof Date ? date
	      : isNumberArray(b) ? numberArray
	      : Array.isArray(b) ? genericArray
	      : typeof b.valueOf !== "function" && typeof b.toString !== "function" || isNaN(b) ? object
	      : number)(a, b);
	}
	
	function discrete(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	function hue$1(a, b) {
	  var i = hue(+a, +b);
	  return function(t) {
	    var x = i(t);
	    return x - 360 * Math.floor(x / 360);
	  };
	}
	
	function round(a, b) {
	  return a = +a, b = +b, function(t) {
	    return Math.round(a * (1 - t) + b * t);
	  };
	}
	
	var degrees = 180 / Math.PI;
	
	var identity = {
	  translateX: 0,
	  translateY: 0,
	  rotate: 0,
	  skewX: 0,
	  scaleX: 1,
	  scaleY: 1
	};
	
	function decompose(a, b, c, d, e, f) {
	  var scaleX, scaleY, skewX;
	  if (scaleX = Math.sqrt(a * a + b * b)) a /= scaleX, b /= scaleX;
	  if (skewX = a * c + b * d) c -= a * skewX, d -= b * skewX;
	  if (scaleY = Math.sqrt(c * c + d * d)) c /= scaleY, d /= scaleY, skewX /= scaleY;
	  if (a * d < b * c) a = -a, b = -b, skewX = -skewX, scaleX = -scaleX;
	  return {
	    translateX: e,
	    translateY: f,
	    rotate: Math.atan2(b, a) * degrees,
	    skewX: Math.atan(skewX) * degrees,
	    scaleX: scaleX,
	    scaleY: scaleY
	  };
	}
	
	var cssNode,
	    cssRoot,
	    cssView,
	    svgNode;
	
	function parseCss(value) {
	  if (value === "none") return identity;
	  if (!cssNode) cssNode = document.createElement("DIV"), cssRoot = document.documentElement, cssView = document.defaultView;
	  cssNode.style.transform = value;
	  value = cssView.getComputedStyle(cssRoot.appendChild(cssNode), null).getPropertyValue("transform");
	  cssRoot.removeChild(cssNode);
	  value = value.slice(7, -1).split(",");
	  return decompose(+value[0], +value[1], +value[2], +value[3], +value[4], +value[5]);
	}
	
	function parseSvg(value) {
	  if (value == null) return identity;
	  if (!svgNode) svgNode = document.createElementNS("http://www.w3.org/2000/svg", "g");
	  svgNode.setAttribute("transform", value);
	  if (!(value = svgNode.transform.baseVal.consolidate())) return identity;
	  value = value.matrix;
	  return decompose(value.a, value.b, value.c, value.d, value.e, value.f);
	}
	
	function interpolateTransform(parse, pxComma, pxParen, degParen) {
	
	  function pop(s) {
	    return s.length ? s.pop() + " " : "";
	  }
	
	  function translate(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push("translate(", null, pxComma, null, pxParen);
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb || yb) {
	      s.push("translate(" + xb + pxComma + yb + pxParen);
	    }
	  }
	
	  function rotate(a, b, s, q) {
	    if (a !== b) {
	      if (a - b > 180) b += 360; else if (b - a > 180) a += 360; // shortest path
	      q.push({i: s.push(pop(s) + "rotate(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "rotate(" + b + degParen);
	    }
	  }
	
	  function skewX(a, b, s, q) {
	    if (a !== b) {
	      q.push({i: s.push(pop(s) + "skewX(", null, degParen) - 2, x: number(a, b)});
	    } else if (b) {
	      s.push(pop(s) + "skewX(" + b + degParen);
	    }
	  }
	
	  function scale(xa, ya, xb, yb, s, q) {
	    if (xa !== xb || ya !== yb) {
	      var i = s.push(pop(s) + "scale(", null, ",", null, ")");
	      q.push({i: i - 4, x: number(xa, xb)}, {i: i - 2, x: number(ya, yb)});
	    } else if (xb !== 1 || yb !== 1) {
	      s.push(pop(s) + "scale(" + xb + "," + yb + ")");
	    }
	  }
	
	  return function(a, b) {
	    var s = [], // string constants and placeholders
	        q = []; // number interpolators
	    a = parse(a), b = parse(b);
	    translate(a.translateX, a.translateY, b.translateX, b.translateY, s, q);
	    rotate(a.rotate, b.rotate, s, q);
	    skewX(a.skewX, b.skewX, s, q);
	    scale(a.scaleX, a.scaleY, b.scaleX, b.scaleY, s, q);
	    a = b = null; // gc
	    return function(t) {
	      var i = -1, n = q.length, o;
	      while (++i < n) s[(o = q[i]).i] = o.x(t);
	      return s.join("");
	    };
	  };
	}
	
	var interpolateTransformCss = interpolateTransform(parseCss, "px, ", "px)", "deg)");
	var interpolateTransformSvg = interpolateTransform(parseSvg, ", ", ")", ")");
	
	var rho = Math.SQRT2,
	    rho2 = 2,
	    rho4 = 4,
	    epsilon2 = 1e-12;
	
	function cosh(x) {
	  return ((x = Math.exp(x)) + 1 / x) / 2;
	}
	
	function sinh(x) {
	  return ((x = Math.exp(x)) - 1 / x) / 2;
	}
	
	function tanh(x) {
	  return ((x = Math.exp(2 * x)) - 1) / (x + 1);
	}
	
	// p0 = [ux0, uy0, w0]
	// p1 = [ux1, uy1, w1]
	function zoom(p0, p1) {
	  var ux0 = p0[0], uy0 = p0[1], w0 = p0[2],
	      ux1 = p1[0], uy1 = p1[1], w1 = p1[2],
	      dx = ux1 - ux0,
	      dy = uy1 - uy0,
	      d2 = dx * dx + dy * dy,
	      i,
	      S;
	
	  // Special case for u0 ≅ u1.
	  if (d2 < epsilon2) {
	    S = Math.log(w1 / w0) / rho;
	    i = function(t) {
	      return [
	        ux0 + t * dx,
	        uy0 + t * dy,
	        w0 * Math.exp(rho * t * S)
	      ];
	    };
	  }
	
	  // General case.
	  else {
	    var d1 = Math.sqrt(d2),
	        b0 = (w1 * w1 - w0 * w0 + rho4 * d2) / (2 * w0 * rho2 * d1),
	        b1 = (w1 * w1 - w0 * w0 - rho4 * d2) / (2 * w1 * rho2 * d1),
	        r0 = Math.log(Math.sqrt(b0 * b0 + 1) - b0),
	        r1 = Math.log(Math.sqrt(b1 * b1 + 1) - b1);
	    S = (r1 - r0) / rho;
	    i = function(t) {
	      var s = t * S,
	          coshr0 = cosh(r0),
	          u = w0 / (rho2 * d1) * (coshr0 * tanh(rho * s + r0) - sinh(r0));
	      return [
	        ux0 + u * dx,
	        uy0 + u * dy,
	        w0 * coshr0 / cosh(rho * s + r0)
	      ];
	    };
	  }
	
	  i.duration = S * 1000;
	
	  return i;
	}
	
	function hsl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hsl(start)).h, (end = d3Color.hsl(end)).h),
	        s = nogamma(start.s, end.s),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.s = s(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hsl$1 = hsl(hue);
	var hslLong = hsl(nogamma);
	
	function lab(start, end) {
	  var l = nogamma((start = d3Color.lab(start)).l, (end = d3Color.lab(end)).l),
	      a = nogamma(start.a, end.a),
	      b = nogamma(start.b, end.b),
	      opacity = nogamma(start.opacity, end.opacity);
	  return function(t) {
	    start.l = l(t);
	    start.a = a(t);
	    start.b = b(t);
	    start.opacity = opacity(t);
	    return start + "";
	  };
	}
	
	function hcl(hue) {
	  return function(start, end) {
	    var h = hue((start = d3Color.hcl(start)).h, (end = d3Color.hcl(end)).h),
	        c = nogamma(start.c, end.c),
	        l = nogamma(start.l, end.l),
	        opacity = nogamma(start.opacity, end.opacity);
	    return function(t) {
	      start.h = h(t);
	      start.c = c(t);
	      start.l = l(t);
	      start.opacity = opacity(t);
	      return start + "";
	    };
	  }
	}
	
	var hcl$1 = hcl(hue);
	var hclLong = hcl(nogamma);
	
	function cubehelix(hue) {
	  return (function cubehelixGamma(y) {
	    y = +y;
	
	    function cubehelix(start, end) {
	      var h = hue((start = d3Color.cubehelix(start)).h, (end = d3Color.cubehelix(end)).h),
	          s = nogamma(start.s, end.s),
	          l = nogamma(start.l, end.l),
	          opacity = nogamma(start.opacity, end.opacity);
	      return function(t) {
	        start.h = h(t);
	        start.s = s(t);
	        start.l = l(Math.pow(t, y));
	        start.opacity = opacity(t);
	        return start + "";
	      };
	    }
	
	    cubehelix.gamma = cubehelixGamma;
	
	    return cubehelix;
	  })(1);
	}
	
	var cubehelix$1 = cubehelix(hue);
	var cubehelixLong = cubehelix(nogamma);
	
	function piecewise(interpolate, values) {
	  var i = 0, n = values.length - 1, v = values[0], I = new Array(n < 0 ? 0 : n);
	  while (i < n) I[i] = interpolate(v, v = values[++i]);
	  return function(t) {
	    var i = Math.max(0, Math.min(n - 1, Math.floor(t *= n)));
	    return I[i](t - i);
	  };
	}
	
	function quantize(interpolator, n) {
	  var samples = new Array(n);
	  for (var i = 0; i < n; ++i) samples[i] = interpolator(i / (n - 1));
	  return samples;
	}
	
	exports.interpolate = value;
	exports.interpolateArray = array;
	exports.interpolateBasis = basis$1;
	exports.interpolateBasisClosed = basisClosed;
	exports.interpolateCubehelix = cubehelix$1;
	exports.interpolateCubehelixLong = cubehelixLong;
	exports.interpolateDate = date;
	exports.interpolateDiscrete = discrete;
	exports.interpolateHcl = hcl$1;
	exports.interpolateHclLong = hclLong;
	exports.interpolateHsl = hsl$1;
	exports.interpolateHslLong = hslLong;
	exports.interpolateHue = hue$1;
	exports.interpolateLab = lab;
	exports.interpolateNumber = number;
	exports.interpolateNumberArray = numberArray;
	exports.interpolateObject = object;
	exports.interpolateRgb = rgb;
	exports.interpolateRgbBasis = rgbBasis;
	exports.interpolateRgbBasisClosed = rgbBasisClosed;
	exports.interpolateRound = round;
	exports.interpolateString = string;
	exports.interpolateTransformCss = interpolateTransformCss;
	exports.interpolateTransformSvg = interpolateTransformSvg;
	exports.interpolateZoom = zoom;
	exports.piecewise = piecewise;
	exports.quantize = quantize;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 99 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-selection/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var xhtml = "http://www.w3.org/1999/xhtml";
	
	  var namespaces = {
	    svg: "http://www.w3.org/2000/svg",
	    xhtml: xhtml,
	    xlink: "http://www.w3.org/1999/xlink",
	    xml: "http://www.w3.org/XML/1998/namespace",
	    xmlns: "http://www.w3.org/2000/xmlns/"
	  };
	
	  function namespace(name) {
	    var prefix = name += "", i = prefix.indexOf(":");
	    if (i >= 0 && (prefix = name.slice(0, i)) !== "xmlns") name = name.slice(i + 1);
	    return namespaces.hasOwnProperty(prefix) ? {space: namespaces[prefix], local: name} : name;
	  }
	
	  function creatorInherit(name) {
	    return function() {
	      var document = this.ownerDocument,
	          uri = this.namespaceURI;
	      return uri === xhtml && document.documentElement.namespaceURI === xhtml
	          ? document.createElement(name)
	          : document.createElementNS(uri, name);
	    };
	  }
	
	  function creatorFixed(fullname) {
	    return function() {
	      return this.ownerDocument.createElementNS(fullname.space, fullname.local);
	    };
	  }
	
	  function creator(name) {
	    var fullname = namespace(name);
	    return (fullname.local
	        ? creatorFixed
	        : creatorInherit)(fullname);
	  }
	
	  var nextId = 0;
	
	  function local() {
	    return new Local;
	  }
	
	  function Local() {
	    this._ = "@" + (++nextId).toString(36);
	  }
	
	  Local.prototype = local.prototype = {
	    constructor: Local,
	    get: function(node) {
	      var id = this._;
	      while (!(id in node)) if (!(node = node.parentNode)) return;
	      return node[id];
	    },
	    set: function(node, value) {
	      return node[this._] = value;
	    },
	    remove: function(node) {
	      return this._ in node && delete node[this._];
	    },
	    toString: function() {
	      return this._;
	    }
	  };
	
	  var matcher = function(selector) {
	    return function() {
	      return this.matches(selector);
	    };
	  };
	
	  if (typeof document !== "undefined") {
	    var element = document.documentElement;
	    if (!element.matches) {
	      var vendorMatches = element.webkitMatchesSelector
	          || element.msMatchesSelector
	          || element.mozMatchesSelector
	          || element.oMatchesSelector;
	      matcher = function(selector) {
	        return function() {
	          return vendorMatches.call(this, selector);
	        };
	      };
	    }
	  }
	
	  var matcher$1 = matcher;
	
	  var filterEvents = {};
	
	  exports.event = null;
	
	  if (typeof document !== "undefined") {
	    var element$1 = document.documentElement;
	    if (!("onmouseenter" in element$1)) {
	      filterEvents = {mouseenter: "mouseover", mouseleave: "mouseout"};
	    }
	  }
	
	  function filterContextListener(listener, index, group) {
	    listener = contextListener(listener, index, group);
	    return function(event) {
	      var related = event.relatedTarget;
	      if (!related || (related !== this && !(related.compareDocumentPosition(this) & 8))) {
	        listener.call(this, event);
	      }
	    };
	  }
	
	  function contextListener(listener, index, group) {
	    return function(event1) {
	      var event0 = exports.event; // Events can be reentrant (e.g., focus).
	      exports.event = event1;
	      try {
	        listener.call(this, this.__data__, index, group);
	      } finally {
	        exports.event = event0;
	      }
	    };
	  }
	
	  function parseTypenames(typenames) {
	    return typenames.trim().split(/^|\s+/).map(function(t) {
	      var name = "", i = t.indexOf(".");
	      if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	      return {type: t, name: name};
	    });
	  }
	
	  function onRemove(typename) {
	    return function() {
	      var on = this.__on;
	      if (!on) return;
	      for (var j = 0, i = -1, m = on.length, o; j < m; ++j) {
	        if (o = on[j], (!typename.type || o.type === typename.type) && o.name === typename.name) {
	          this.removeEventListener(o.type, o.listener, o.capture);
	        } else {
	          on[++i] = o;
	        }
	      }
	      if (++i) on.length = i;
	      else delete this.__on;
	    };
	  }
	
	  function onAdd(typename, value, capture) {
	    var wrap = filterEvents.hasOwnProperty(typename.type) ? filterContextListener : contextListener;
	    return function(d, i, group) {
	      var on = this.__on, o, listener = wrap(value, i, group);
	      if (on) for (var j = 0, m = on.length; j < m; ++j) {
	        if ((o = on[j]).type === typename.type && o.name === typename.name) {
	          this.removeEventListener(o.type, o.listener, o.capture);
	          this.addEventListener(o.type, o.listener = listener, o.capture = capture);
	          o.value = value;
	          return;
	        }
	      }
	      this.addEventListener(typename.type, listener, capture);
	      o = {type: typename.type, name: typename.name, value: value, listener: listener, capture: capture};
	      if (!on) this.__on = [o];
	      else on.push(o);
	    };
	  }
	
	  function selection_on(typename, value, capture) {
	    var typenames = parseTypenames(typename + ""), i, n = typenames.length, t;
	
	    if (arguments.length < 2) {
	      var on = this.node().__on;
	      if (on) for (var j = 0, m = on.length, o; j < m; ++j) {
	        for (i = 0, o = on[j]; i < n; ++i) {
	          if ((t = typenames[i]).type === o.type && t.name === o.name) {
	            return o.value;
	          }
	        }
	      }
	      return;
	    }
	
	    on = value ? onAdd : onRemove;
	    if (capture == null) capture = false;
	    for (i = 0; i < n; ++i) this.each(on(typenames[i], value, capture));
	    return this;
	  }
	
	  function customEvent(event1, listener, that, args) {
	    var event0 = exports.event;
	    event1.sourceEvent = exports.event;
	    exports.event = event1;
	    try {
	      return listener.apply(that, args);
	    } finally {
	      exports.event = event0;
	    }
	  }
	
	  function sourceEvent() {
	    var current = exports.event, source;
	    while (source = current.sourceEvent) current = source;
	    return current;
	  }
	
	  function point(node, event) {
	    var svg = node.ownerSVGElement || node;
	
	    if (svg.createSVGPoint) {
	      var point = svg.createSVGPoint();
	      point.x = event.clientX, point.y = event.clientY;
	      point = point.matrixTransform(node.getScreenCTM().inverse());
	      return [point.x, point.y];
	    }
	
	    var rect = node.getBoundingClientRect();
	    return [event.clientX - rect.left - node.clientLeft, event.clientY - rect.top - node.clientTop];
	  }
	
	  function mouse(node) {
	    var event = sourceEvent();
	    if (event.changedTouches) event = event.changedTouches[0];
	    return point(node, event);
	  }
	
	  function none() {}
	
	  function selector(selector) {
	    return selector == null ? none : function() {
	      return this.querySelector(selector);
	    };
	  }
	
	  function selection_select(select) {
	    if (typeof select !== "function") select = selector(select);
	
	    for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	        if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	          if ("__data__" in node) subnode.__data__ = node.__data__;
	          subgroup[i] = subnode;
	        }
	      }
	    }
	
	    return new Selection(subgroups, this._parents);
	  }
	
	  function empty() {
	    return [];
	  }
	
	  function selectorAll(selector) {
	    return selector == null ? empty : function() {
	      return this.querySelectorAll(selector);
	    };
	  }
	
	  function selection_selectAll(select) {
	    if (typeof select !== "function") select = selectorAll(select);
	
	    for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	        if (node = group[i]) {
	          subgroups.push(select.call(node, node.__data__, i, group));
	          parents.push(node);
	        }
	      }
	    }
	
	    return new Selection(subgroups, parents);
	  }
	
	  function selection_filter(match) {
	    if (typeof match !== "function") match = matcher$1(match);
	
	    for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	        if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	          subgroup.push(node);
	        }
	      }
	    }
	
	    return new Selection(subgroups, this._parents);
	  }
	
	  function sparse(update) {
	    return new Array(update.length);
	  }
	
	  function selection_enter() {
	    return new Selection(this._enter || this._groups.map(sparse), this._parents);
	  }
	
	  function EnterNode(parent, datum) {
	    this.ownerDocument = parent.ownerDocument;
	    this.namespaceURI = parent.namespaceURI;
	    this._next = null;
	    this._parent = parent;
	    this.__data__ = datum;
	  }
	
	  EnterNode.prototype = {
	    constructor: EnterNode,
	    appendChild: function(child) { return this._parent.insertBefore(child, this._next); },
	    insertBefore: function(child, next) { return this._parent.insertBefore(child, next); },
	    querySelector: function(selector) { return this._parent.querySelector(selector); },
	    querySelectorAll: function(selector) { return this._parent.querySelectorAll(selector); }
	  };
	
	  function constant(x) {
	    return function() {
	      return x;
	    };
	  }
	
	  var keyPrefix = "$"; // Protect against keys like “__proto__”.
	
	  function bindIndex(parent, group, enter, update, exit, data) {
	    var i = 0,
	        node,
	        groupLength = group.length,
	        dataLength = data.length;
	
	    // Put any non-null nodes that fit into update.
	    // Put any null nodes into enter.
	    // Put any remaining data into enter.
	    for (; i < dataLength; ++i) {
	      if (node = group[i]) {
	        node.__data__ = data[i];
	        update[i] = node;
	      } else {
	        enter[i] = new EnterNode(parent, data[i]);
	      }
	    }
	
	    // Put any non-null nodes that don’t fit into exit.
	    for (; i < groupLength; ++i) {
	      if (node = group[i]) {
	        exit[i] = node;
	      }
	    }
	  }
	
	  function bindKey(parent, group, enter, update, exit, data, key) {
	    var i,
	        node,
	        nodeByKeyValue = {},
	        groupLength = group.length,
	        dataLength = data.length,
	        keyValues = new Array(groupLength),
	        keyValue;
	
	    // Compute the key for each node.
	    // If multiple nodes have the same key, the duplicates are added to exit.
	    for (i = 0; i < groupLength; ++i) {
	      if (node = group[i]) {
	        keyValues[i] = keyValue = keyPrefix + key.call(node, node.__data__, i, group);
	        if (keyValue in nodeByKeyValue) {
	          exit[i] = node;
	        } else {
	          nodeByKeyValue[keyValue] = node;
	        }
	      }
	    }
	
	    // Compute the key for each datum.
	    // If there a node associated with this key, join and add it to update.
	    // If there is not (or the key is a duplicate), add it to enter.
	    for (i = 0; i < dataLength; ++i) {
	      keyValue = keyPrefix + key.call(parent, data[i], i, data);
	      if (node = nodeByKeyValue[keyValue]) {
	        update[i] = node;
	        node.__data__ = data[i];
	        nodeByKeyValue[keyValue] = null;
	      } else {
	        enter[i] = new EnterNode(parent, data[i]);
	      }
	    }
	
	    // Add any remaining nodes that were not bound to data to exit.
	    for (i = 0; i < groupLength; ++i) {
	      if ((node = group[i]) && (nodeByKeyValue[keyValues[i]] === node)) {
	        exit[i] = node;
	      }
	    }
	  }
	
	  function selection_data(value, key) {
	    if (!value) {
	      data = new Array(this.size()), j = -1;
	      this.each(function(d) { data[++j] = d; });
	      return data;
	    }
	
	    var bind = key ? bindKey : bindIndex,
	        parents = this._parents,
	        groups = this._groups;
	
	    if (typeof value !== "function") value = constant(value);
	
	    for (var m = groups.length, update = new Array(m), enter = new Array(m), exit = new Array(m), j = 0; j < m; ++j) {
	      var parent = parents[j],
	          group = groups[j],
	          groupLength = group.length,
	          data = value.call(parent, parent && parent.__data__, j, parents),
	          dataLength = data.length,
	          enterGroup = enter[j] = new Array(dataLength),
	          updateGroup = update[j] = new Array(dataLength),
	          exitGroup = exit[j] = new Array(groupLength);
	
	      bind(parent, group, enterGroup, updateGroup, exitGroup, data, key);
	
	      // Now connect the enter nodes to their following update node, such that
	      // appendChild can insert the materialized enter node before this node,
	      // rather than at the end of the parent node.
	      for (var i0 = 0, i1 = 0, previous, next; i0 < dataLength; ++i0) {
	        if (previous = enterGroup[i0]) {
	          if (i0 >= i1) i1 = i0 + 1;
	          while (!(next = updateGroup[i1]) && ++i1 < dataLength);
	          previous._next = next || null;
	        }
	      }
	    }
	
	    update = new Selection(update, parents);
	    update._enter = enter;
	    update._exit = exit;
	    return update;
	  }
	
	  function selection_exit() {
	    return new Selection(this._exit || this._groups.map(sparse), this._parents);
	  }
	
	  function selection_merge(selection) {
	
	    for (var groups0 = this._groups, groups1 = selection._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	      for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	        if (node = group0[i] || group1[i]) {
	          merge[i] = node;
	        }
	      }
	    }
	
	    for (; j < m0; ++j) {
	      merges[j] = groups0[j];
	    }
	
	    return new Selection(merges, this._parents);
	  }
	
	  function selection_order() {
	
	    for (var groups = this._groups, j = -1, m = groups.length; ++j < m;) {
	      for (var group = groups[j], i = group.length - 1, next = group[i], node; --i >= 0;) {
	        if (node = group[i]) {
	          if (next && next !== node.nextSibling) next.parentNode.insertBefore(node, next);
	          next = node;
	        }
	      }
	    }
	
	    return this;
	  }
	
	  function selection_sort(compare) {
	    if (!compare) compare = ascending;
	
	    function compareNode(a, b) {
	      return a && b ? compare(a.__data__, b.__data__) : !a - !b;
	    }
	
	    for (var groups = this._groups, m = groups.length, sortgroups = new Array(m), j = 0; j < m; ++j) {
	      for (var group = groups[j], n = group.length, sortgroup = sortgroups[j] = new Array(n), node, i = 0; i < n; ++i) {
	        if (node = group[i]) {
	          sortgroup[i] = node;
	        }
	      }
	      sortgroup.sort(compareNode);
	    }
	
	    return new Selection(sortgroups, this._parents).order();
	  }
	
	  function ascending(a, b) {
	    return a < b ? -1 : a > b ? 1 : a >= b ? 0 : NaN;
	  }
	
	  function selection_call() {
	    var callback = arguments[0];
	    arguments[0] = this;
	    callback.apply(null, arguments);
	    return this;
	  }
	
	  function selection_nodes() {
	    var nodes = new Array(this.size()), i = -1;
	    this.each(function() { nodes[++i] = this; });
	    return nodes;
	  }
	
	  function selection_node() {
	
	    for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	      for (var group = groups[j], i = 0, n = group.length; i < n; ++i) {
	        var node = group[i];
	        if (node) return node;
	      }
	    }
	
	    return null;
	  }
	
	  function selection_size() {
	    var size = 0;
	    this.each(function() { ++size; });
	    return size;
	  }
	
	  function selection_empty() {
	    return !this.node();
	  }
	
	  function selection_each(callback) {
	
	    for (var groups = this._groups, j = 0, m = groups.length; j < m; ++j) {
	      for (var group = groups[j], i = 0, n = group.length, node; i < n; ++i) {
	        if (node = group[i]) callback.call(node, node.__data__, i, group);
	      }
	    }
	
	    return this;
	  }
	
	  function attrRemove(name) {
	    return function() {
	      this.removeAttribute(name);
	    };
	  }
	
	  function attrRemoveNS(fullname) {
	    return function() {
	      this.removeAttributeNS(fullname.space, fullname.local);
	    };
	  }
	
	  function attrConstant(name, value) {
	    return function() {
	      this.setAttribute(name, value);
	    };
	  }
	
	  function attrConstantNS(fullname, value) {
	    return function() {
	      this.setAttributeNS(fullname.space, fullname.local, value);
	    };
	  }
	
	  function attrFunction(name, value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) this.removeAttribute(name);
	      else this.setAttribute(name, v);
	    };
	  }
	
	  function attrFunctionNS(fullname, value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) this.removeAttributeNS(fullname.space, fullname.local);
	      else this.setAttributeNS(fullname.space, fullname.local, v);
	    };
	  }
	
	  function selection_attr(name, value) {
	    var fullname = namespace(name);
	
	    if (arguments.length < 2) {
	      var node = this.node();
	      return fullname.local
	          ? node.getAttributeNS(fullname.space, fullname.local)
	          : node.getAttribute(fullname);
	    }
	
	    return this.each((value == null
	        ? (fullname.local ? attrRemoveNS : attrRemove) : (typeof value === "function"
	        ? (fullname.local ? attrFunctionNS : attrFunction)
	        : (fullname.local ? attrConstantNS : attrConstant)))(fullname, value));
	  }
	
	  function defaultView(node) {
	    return (node.ownerDocument && node.ownerDocument.defaultView) // node is a Node
	        || (node.document && node) // node is a Window
	        || node.defaultView; // node is a Document
	  }
	
	  function styleRemove(name) {
	    return function() {
	      this.style.removeProperty(name);
	    };
	  }
	
	  function styleConstant(name, value, priority) {
	    return function() {
	      this.style.setProperty(name, value, priority);
	    };
	  }
	
	  function styleFunction(name, value, priority) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) this.style.removeProperty(name);
	      else this.style.setProperty(name, v, priority);
	    };
	  }
	
	  function selection_style(name, value, priority) {
	    var node;
	    return arguments.length > 1
	        ? this.each((value == null
	              ? styleRemove : typeof value === "function"
	              ? styleFunction
	              : styleConstant)(name, value, priority == null ? "" : priority))
	        : defaultView(node = this.node())
	            .getComputedStyle(node, null)
	            .getPropertyValue(name);
	  }
	
	  function propertyRemove(name) {
	    return function() {
	      delete this[name];
	    };
	  }
	
	  function propertyConstant(name, value) {
	    return function() {
	      this[name] = value;
	    };
	  }
	
	  function propertyFunction(name, value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      if (v == null) delete this[name];
	      else this[name] = v;
	    };
	  }
	
	  function selection_property(name, value) {
	    return arguments.length > 1
	        ? this.each((value == null
	            ? propertyRemove : typeof value === "function"
	            ? propertyFunction
	            : propertyConstant)(name, value))
	        : this.node()[name];
	  }
	
	  function classArray(string) {
	    return string.trim().split(/^|\s+/);
	  }
	
	  function classList(node) {
	    return node.classList || new ClassList(node);
	  }
	
	  function ClassList(node) {
	    this._node = node;
	    this._names = classArray(node.getAttribute("class") || "");
	  }
	
	  ClassList.prototype = {
	    add: function(name) {
	      var i = this._names.indexOf(name);
	      if (i < 0) {
	        this._names.push(name);
	        this._node.setAttribute("class", this._names.join(" "));
	      }
	    },
	    remove: function(name) {
	      var i = this._names.indexOf(name);
	      if (i >= 0) {
	        this._names.splice(i, 1);
	        this._node.setAttribute("class", this._names.join(" "));
	      }
	    },
	    contains: function(name) {
	      return this._names.indexOf(name) >= 0;
	    }
	  };
	
	  function classedAdd(node, names) {
	    var list = classList(node), i = -1, n = names.length;
	    while (++i < n) list.add(names[i]);
	  }
	
	  function classedRemove(node, names) {
	    var list = classList(node), i = -1, n = names.length;
	    while (++i < n) list.remove(names[i]);
	  }
	
	  function classedTrue(names) {
	    return function() {
	      classedAdd(this, names);
	    };
	  }
	
	  function classedFalse(names) {
	    return function() {
	      classedRemove(this, names);
	    };
	  }
	
	  function classedFunction(names, value) {
	    return function() {
	      (value.apply(this, arguments) ? classedAdd : classedRemove)(this, names);
	    };
	  }
	
	  function selection_classed(name, value) {
	    var names = classArray(name + "");
	
	    if (arguments.length < 2) {
	      var list = classList(this.node()), i = -1, n = names.length;
	      while (++i < n) if (!list.contains(names[i])) return false;
	      return true;
	    }
	
	    return this.each((typeof value === "function"
	        ? classedFunction : value
	        ? classedTrue
	        : classedFalse)(names, value));
	  }
	
	  function textRemove() {
	    this.textContent = "";
	  }
	
	  function textConstant(value) {
	    return function() {
	      this.textContent = value;
	    };
	  }
	
	  function textFunction(value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      this.textContent = v == null ? "" : v;
	    };
	  }
	
	  function selection_text(value) {
	    return arguments.length
	        ? this.each(value == null
	            ? textRemove : (typeof value === "function"
	            ? textFunction
	            : textConstant)(value))
	        : this.node().textContent;
	  }
	
	  function htmlRemove() {
	    this.innerHTML = "";
	  }
	
	  function htmlConstant(value) {
	    return function() {
	      this.innerHTML = value;
	    };
	  }
	
	  function htmlFunction(value) {
	    return function() {
	      var v = value.apply(this, arguments);
	      this.innerHTML = v == null ? "" : v;
	    };
	  }
	
	  function selection_html(value) {
	    return arguments.length
	        ? this.each(value == null
	            ? htmlRemove : (typeof value === "function"
	            ? htmlFunction
	            : htmlConstant)(value))
	        : this.node().innerHTML;
	  }
	
	  function raise() {
	    if (this.nextSibling) this.parentNode.appendChild(this);
	  }
	
	  function selection_raise() {
	    return this.each(raise);
	  }
	
	  function lower() {
	    if (this.previousSibling) this.parentNode.insertBefore(this, this.parentNode.firstChild);
	  }
	
	  function selection_lower() {
	    return this.each(lower);
	  }
	
	  function selection_append(name) {
	    var create = typeof name === "function" ? name : creator(name);
	    return this.select(function() {
	      return this.appendChild(create.apply(this, arguments));
	    });
	  }
	
	  function constantNull() {
	    return null;
	  }
	
	  function selection_insert(name, before) {
	    var create = typeof name === "function" ? name : creator(name),
	        select = before == null ? constantNull : typeof before === "function" ? before : selector(before);
	    return this.select(function() {
	      return this.insertBefore(create.apply(this, arguments), select.apply(this, arguments) || null);
	    });
	  }
	
	  function remove() {
	    var parent = this.parentNode;
	    if (parent) parent.removeChild(this);
	  }
	
	  function selection_remove() {
	    return this.each(remove);
	  }
	
	  function selection_datum(value) {
	    return arguments.length
	        ? this.property("__data__", value)
	        : this.node().__data__;
	  }
	
	  function dispatchEvent(node, type, params) {
	    var window = defaultView(node),
	        event = window.CustomEvent;
	
	    if (event) {
	      event = new event(type, params);
	    } else {
	      event = window.document.createEvent("Event");
	      if (params) event.initEvent(type, params.bubbles, params.cancelable), event.detail = params.detail;
	      else event.initEvent(type, false, false);
	    }
	
	    node.dispatchEvent(event);
	  }
	
	  function dispatchConstant(type, params) {
	    return function() {
	      return dispatchEvent(this, type, params);
	    };
	  }
	
	  function dispatchFunction(type, params) {
	    return function() {
	      return dispatchEvent(this, type, params.apply(this, arguments));
	    };
	  }
	
	  function selection_dispatch(type, params) {
	    return this.each((typeof params === "function"
	        ? dispatchFunction
	        : dispatchConstant)(type, params));
	  }
	
	  var root = [null];
	
	  function Selection(groups, parents) {
	    this._groups = groups;
	    this._parents = parents;
	  }
	
	  function selection() {
	    return new Selection([[document.documentElement]], root);
	  }
	
	  Selection.prototype = selection.prototype = {
	    constructor: Selection,
	    select: selection_select,
	    selectAll: selection_selectAll,
	    filter: selection_filter,
	    data: selection_data,
	    enter: selection_enter,
	    exit: selection_exit,
	    merge: selection_merge,
	    order: selection_order,
	    sort: selection_sort,
	    call: selection_call,
	    nodes: selection_nodes,
	    node: selection_node,
	    size: selection_size,
	    empty: selection_empty,
	    each: selection_each,
	    attr: selection_attr,
	    style: selection_style,
	    property: selection_property,
	    classed: selection_classed,
	    text: selection_text,
	    html: selection_html,
	    raise: selection_raise,
	    lower: selection_lower,
	    append: selection_append,
	    insert: selection_insert,
	    remove: selection_remove,
	    datum: selection_datum,
	    on: selection_on,
	    dispatch: selection_dispatch
	  };
	
	  function select(selector) {
	    return typeof selector === "string"
	        ? new Selection([[document.querySelector(selector)]], [document.documentElement])
	        : new Selection([[selector]], root);
	  }
	
	  function selectAll(selector) {
	    return typeof selector === "string"
	        ? new Selection([document.querySelectorAll(selector)], [document.documentElement])
	        : new Selection([selector == null ? [] : selector], root);
	  }
	
	  function touch(node, touches, identifier) {
	    if (arguments.length < 3) identifier = touches, touches = sourceEvent().changedTouches;
	
	    for (var i = 0, n = touches ? touches.length : 0, touch; i < n; ++i) {
	      if ((touch = touches[i]).identifier === identifier) {
	        return point(node, touch);
	      }
	    }
	
	    return null;
	  }
	
	  function touches(node, touches) {
	    if (touches == null) touches = sourceEvent().touches;
	
	    for (var i = 0, n = touches ? touches.length : 0, points = new Array(n); i < n; ++i) {
	      points[i] = point(node, touches[i]);
	    }
	
	    return points;
	  }
	
	  exports.creator = creator;
	  exports.local = local;
	  exports.matcher = matcher$1;
	  exports.mouse = mouse;
	  exports.namespace = namespace;
	  exports.namespaces = namespaces;
	  exports.select = select;
	  exports.selectAll = selectAll;
	  exports.selection = selection;
	  exports.selector = selector;
	  exports.selectorAll = selectorAll;
	  exports.touch = touch;
	  exports.touches = touches;
	  exports.window = defaultView;
	  exports.customEvent = customEvent;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 100 */
/***/ function(module, exports) {

	/*
	object-assign
	(c) Sindre Sorhus
	@license MIT
	*/
	
	'use strict';
	/* eslint-disable no-unused-vars */
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line no-new-wrappers
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (err) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (getOwnPropertySymbols) {
				symbols = getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 101 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _ColorSchemes = __webpack_require__(72);
	
	var _FormatMoney = __webpack_require__(59);
	
	var _FormatMoney2 = _interopRequireDefault(_FormatMoney);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _states10m = __webpack_require__(183);
	
	var _states10m2 = _interopRequireDefault(_states10m);
	
	var _d3Array = __webpack_require__(31);
	
	var _d3Geo = __webpack_require__(175);
	
	var _topojsonClient = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var colorScale = _ColorSchemes.bucketScale;
	
	var StateMap = function (_Component) {
	  _inherits(StateMap, _Component);
	
	  function StateMap() {
	    _classCallCheck(this, StateMap);
	
	    return _possibleConstructorReturn(this, (StateMap.__proto__ || Object.getPrototypeOf(StateMap)).apply(this, arguments));
	  }
	
	  _createClass(StateMap, [{
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var width = (0, _d3Array.min)([900, this.props.size[0]]);
	      var fill = this.props.fill;
	      var slice = this.props.slice;
	      var dataset = this.props.data;
	
	      var topojsonData = (0, _topojsonClient.feature)(_states10m2.default, _states10m2.default.objects.states).features;
	      var projection = (0, _d3Geo.geoAlbersUsa)().scale(width * 1).translate([width / 2, 250]);
	      var pathGenerator = (0, _d3Geo.geoPath)().projection(projection);
	      function tooltipGenerator(slice, fill, d) {
	        if (slice === "total" || slice === "pop" || slice === "income") {
	          return d.properties.name + ": " + (0, _FormatMoney2.default)(d.properties[fill], slice) + " in " + fill + " in 2017.";
	        } else if (slice === "cost_low" || slice === "cost_med" || slice === "cost_high") {
	          return d.properties.name + ": " + (0, _FormatMoney2.default)(d.properties[fill], "posneg") + " in " + fill + " scenario.";
	        } else if (slice === "Funding Per Child") {
	          return d.properties.name + " received " + (0, _FormatMoney2.default)(d.properties[fill]) + " in Title I grant money per eligible child in FY2017.";
	        }
	      }
	
	      if (dataset.length > 0) {
	        var _ret = function () {
	          var _loop = function _loop(s) {
	            var statedata = dataset.find(function (e) {
	              return e.State === topojsonData[s].properties.name;
	            });
	            for (var key in statedata) {
	              if (key !== "State") {
	                topojsonData[s].properties[key] = statedata[key];
	              }
	            }
	          };
	
	          for (var s = 0; s < topojsonData.length; s++) {
	            _loop(s);
	          }
	
	          var datarange = [];
	          topojsonData.forEach(function (d) {
	            if (!isNaN(d.properties[fill])) {
	              datarange.push(d.properties[fill]);
	            }
	          });
	          colorScale.domain(datarange);
	
	          var states = topojsonData.map(function (d, i) {
	            return _react2.default.createElement('path', {
	              key: "path" + i,
	              d: pathGenerator(d),
	              'data-tip': tooltipGenerator(slice, fill, d),
	              style: {
	                fill: colorScale(d.properties[fill]),
	                stroke: "white",
	                strokeOpacity: 0.5
	              },
	              className: "states " + d.properties.name
	            });
	          });
	
	          var legend = _react2.default.createElement(
	            'g',
	            null,
	            _react2.default.createElement(
	              'defs',
	              null,
	              _react2.default.createElement(
	                'linearGradient',
	                {
	                  id: "gradient",
	                  x1: '0%',
	                  y1: '100%',
	                  x2: '100%',
	                  y2: '100%',
	                  spreadMethod: 'pad'
	                },
	                _react2.default.createElement('stop', { offset: '0%', stopColor: colorScale.range()[0], stopOpacity: '1' }),
	                _react2.default.createElement('stop', { offset: '25%', stopColor: colorScale.range()[1], stopOpacity: '1' }),
	                _react2.default.createElement('stop', { offset: '50%', stopColor: colorScale.range()[2], stopOpacity: '1' }),
	                _react2.default.createElement('stop', { offset: '75%', stopColor: colorScale.range()[3], stopOpacity: '1' }),
	                _react2.default.createElement('stop', { offset: '100%', stopColor: colorScale.range()[4], stopOpacity: '1' })
	              )
	            ),
	            _react2.default.createElement('rect', {
	              width: 300,
	              height: 20,
	              x: width / 2 - 150,
	              y: _this2.props.size[1] - 50,
	              style: { fill: 'url("#gradient")' }
	            }),
	            _react2.default.createElement(
	              'text',
	              {
	                x: width / 2 - 150,
	                y: _this2.props.size[1] - 10,
	                fontSize: '0.75rem',
	                textAnchor: 'start'
	              },
	              (0, _FormatMoney2.default)((0, _d3Array.min)(colorScale.domain()), "posneg")
	            ),
	            _react2.default.createElement(
	              'text',
	              {
	                x: width / 2 + 150,
	                y: _this2.props.size[1] - 10,
	                fontSize: '0.75rem',
	                textAnchor: 'end'
	              },
	              (0, _FormatMoney2.default)((0, _d3Array.max)(colorScale.domain()), "posneg")
	            )
	          );
	
	          return {
	            v: _react2.default.createElement(
	              'svg',
	              { width: width, height: _this2.props.size[1] },
	              states,
	              legend
	            )
	          };
	        }();
	
	        if ((typeof _ret === 'undefined' ? 'undefined' : _typeof(_ret)) === "object") return _ret.v;
	      } else {
	        var _states = topojsonData.map(function (d, i) {
	          return _react2.default.createElement('path', {
	            key: "path" + i,
	            d: pathGenerator(d),
	            style: { fill: "#ccc", stroke: "white", strokeOpacity: 0.5 },
	            className: "states " + d.properties.name
	          });
	        });
	        return _react2.default.createElement(
	          'svg',
	          { width: width, height: this.props.size[1] },
	          _states
	        );
	      }
	    }
	  }]);
	
	  return StateMap;
	}(_react.Component);
	
	exports.default = StateMap;

/***/ },
/* 102 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.EXITING = exports.ENTERED = exports.ENTERING = exports.EXITED = exports.UNMOUNTED = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(16));
	
	var _config = _interopRequireDefault(__webpack_require__(188));
	
	var _PropTypes = __webpack_require__(189);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(103));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var UNMOUNTED = 'unmounted';
	exports.UNMOUNTED = UNMOUNTED;
	var EXITED = 'exited';
	exports.EXITED = EXITED;
	var ENTERING = 'entering';
	exports.ENTERING = ENTERING;
	var ENTERED = 'entered';
	exports.ENTERED = ENTERED;
	var EXITING = 'exiting';
	/**
	 * The Transition component lets you describe a transition from one component
	 * state to another _over time_ with a simple declarative API. Most commonly
	 * it's used to animate the mounting and unmounting of a component, but can also
	 * be used to describe in-place transition states as well.
	 *
	 * ---
	 *
	 * **Note**: `Transition` is a platform-agnostic base component. If you're using
	 * transitions in CSS, you'll probably want to use
	 * [`CSSTransition`](https://reactcommunity.org/react-transition-group/css-transition)
	 * instead. It inherits all the features of `Transition`, but contains
	 * additional features necessary to play nice with CSS transitions (hence the
	 * name of the component).
	 *
	 * ---
	 *
	 * By default the `Transition` component does not alter the behavior of the
	 * component it renders, it only tracks "enter" and "exit" states for the
	 * components. It's up to you to give meaning and effect to those states. For
	 * example we can add styles to a component when it enters or exits:
	 *
	 * ```jsx
	 * import { Transition } from 'react-transition-group';
	 *
	 * const duration = 300;
	 *
	 * const defaultStyle = {
	 *   transition: `opacity ${duration}ms ease-in-out`,
	 *   opacity: 0,
	 * }
	 *
	 * const transitionStyles = {
	 *   entering: { opacity: 1 },
	 *   entered:  { opacity: 1 },
	 *   exiting:  { opacity: 0 },
	 *   exited:  { opacity: 0 },
	 * };
	 *
	 * const Fade = ({ in: inProp }) => (
	 *   <Transition in={inProp} timeout={duration}>
	 *     {state => (
	 *       <div style={{
	 *         ...defaultStyle,
	 *         ...transitionStyles[state]
	 *       }}>
	 *         I'm a fade Transition!
	 *       </div>
	 *     )}
	 *   </Transition>
	 * );
	 * ```
	 *
	 * There are 4 main states a Transition can be in:
	 *  - `'entering'`
	 *  - `'entered'`
	 *  - `'exiting'`
	 *  - `'exited'`
	 *
	 * Transition state is toggled via the `in` prop. When `true` the component
	 * begins the "Enter" stage. During this stage, the component will shift from
	 * its current transition state, to `'entering'` for the duration of the
	 * transition and then to the `'entered'` stage once it's complete. Let's take
	 * the following example (we'll use the
	 * [useState](https://reactjs.org/docs/hooks-reference.html#usestate) hook):
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <Transition in={inProp} timeout={500}>
	 *         {state => (
	 *           // ...
	 *         )}
	 *       </Transition>
	 *       <button onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the button is clicked the component will shift to the `'entering'` state
	 * and stay there for 500ms (the value of `timeout`) before it finally switches
	 * to `'entered'`.
	 *
	 * When `in` is `false` the same thing happens except the state moves from
	 * `'exiting'` to `'exited'`.
	 */
	
	exports.EXITING = EXITING;
	
	var Transition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(Transition, _React$Component);
	
	  function Transition(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	    var parentGroup = context; // In the context of a TransitionGroup all enters are really appears
	
	    var appear = parentGroup && !parentGroup.isMounting ? props.enter : props.appear;
	    var initialStatus;
	    _this.appearStatus = null;
	
	    if (props.in) {
	      if (appear) {
	        initialStatus = EXITED;
	        _this.appearStatus = ENTERING;
	      } else {
	        initialStatus = ENTERED;
	      }
	    } else {
	      if (props.unmountOnExit || props.mountOnEnter) {
	        initialStatus = UNMOUNTED;
	      } else {
	        initialStatus = EXITED;
	      }
	    }
	
	    _this.state = {
	      status: initialStatus
	    };
	    _this.nextCallback = null;
	    return _this;
	  }
	
	  Transition.getDerivedStateFromProps = function getDerivedStateFromProps(_ref, prevState) {
	    var nextIn = _ref.in;
	
	    if (nextIn && prevState.status === UNMOUNTED) {
	      return {
	        status: EXITED
	      };
	    }
	
	    return null;
	  }; // getSnapshotBeforeUpdate(prevProps) {
	  //   let nextStatus = null
	  //   if (prevProps !== this.props) {
	  //     const { status } = this.state
	  //     if (this.props.in) {
	  //       if (status !== ENTERING && status !== ENTERED) {
	  //         nextStatus = ENTERING
	  //       }
	  //     } else {
	  //       if (status === ENTERING || status === ENTERED) {
	  //         nextStatus = EXITING
	  //       }
	  //     }
	  //   }
	  //   return { nextStatus }
	  // }
	
	
	  var _proto = Transition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.updateStatus(true, this.appearStatus);
	  };
	
	  _proto.componentDidUpdate = function componentDidUpdate(prevProps) {
	    var nextStatus = null;
	
	    if (prevProps !== this.props) {
	      var status = this.state.status;
	
	      if (this.props.in) {
	        if (status !== ENTERING && status !== ENTERED) {
	          nextStatus = ENTERING;
	        }
	      } else {
	        if (status === ENTERING || status === ENTERED) {
	          nextStatus = EXITING;
	        }
	      }
	    }
	
	    this.updateStatus(false, nextStatus);
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.cancelNextCallback();
	  };
	
	  _proto.getTimeouts = function getTimeouts() {
	    var timeout = this.props.timeout;
	    var exit, enter, appear;
	    exit = enter = appear = timeout;
	
	    if (timeout != null && typeof timeout !== 'number') {
	      exit = timeout.exit;
	      enter = timeout.enter; // TODO: remove fallback for next major
	
	      appear = timeout.appear !== undefined ? timeout.appear : enter;
	    }
	
	    return {
	      exit: exit,
	      enter: enter,
	      appear: appear
	    };
	  };
	
	  _proto.updateStatus = function updateStatus(mounting, nextStatus) {
	    if (mounting === void 0) {
	      mounting = false;
	    }
	
	    if (nextStatus !== null) {
	      // nextStatus will always be ENTERING or EXITING.
	      this.cancelNextCallback();
	
	      var node = _reactDom.default.findDOMNode(this);
	
	      if (nextStatus === ENTERING) {
	        this.performEnter(node, mounting);
	      } else {
	        this.performExit(node);
	      }
	    } else if (this.props.unmountOnExit && this.state.status === EXITED) {
	      this.setState({
	        status: UNMOUNTED
	      });
	    }
	  };
	
	  _proto.performEnter = function performEnter(node, mounting) {
	    var _this2 = this;
	
	    var enter = this.props.enter;
	    var appearing = this.context ? this.context.isMounting : mounting;
	    var timeouts = this.getTimeouts();
	    var enterTimeout = appearing ? timeouts.appear : timeouts.enter; // no enter animation skip right to ENTERED
	    // if we are mounting and running this it means appear _must_ be set
	
	    if (!mounting && !enter || _config.default.disabled) {
	      this.safeSetState({
	        status: ENTERED
	      }, function () {
	        _this2.props.onEntered(node);
	      });
	      return;
	    }
	
	    this.props.onEnter(node, appearing);
	    this.safeSetState({
	      status: ENTERING
	    }, function () {
	      _this2.props.onEntering(node, appearing);
	
	      _this2.onTransitionEnd(node, enterTimeout, function () {
	        _this2.safeSetState({
	          status: ENTERED
	        }, function () {
	          _this2.props.onEntered(node, appearing);
	        });
	      });
	    });
	  };
	
	  _proto.performExit = function performExit(node) {
	    var _this3 = this;
	
	    var exit = this.props.exit;
	    var timeouts = this.getTimeouts(); // no exit animation skip right to EXITED
	
	    if (!exit || _config.default.disabled) {
	      this.safeSetState({
	        status: EXITED
	      }, function () {
	        _this3.props.onExited(node);
	      });
	      return;
	    }
	
	    this.props.onExit(node);
	    this.safeSetState({
	      status: EXITING
	    }, function () {
	      _this3.props.onExiting(node);
	
	      _this3.onTransitionEnd(node, timeouts.exit, function () {
	        _this3.safeSetState({
	          status: EXITED
	        }, function () {
	          _this3.props.onExited(node);
	        });
	      });
	    });
	  };
	
	  _proto.cancelNextCallback = function cancelNextCallback() {
	    if (this.nextCallback !== null) {
	      this.nextCallback.cancel();
	      this.nextCallback = null;
	    }
	  };
	
	  _proto.safeSetState = function safeSetState(nextState, callback) {
	    // This shouldn't be necessary, but there are weird race conditions with
	    // setState callbacks and unmounting in testing, so always make sure that
	    // we can cancel any pending setState callbacks after we unmount.
	    callback = this.setNextCallback(callback);
	    this.setState(nextState, callback);
	  };
	
	  _proto.setNextCallback = function setNextCallback(callback) {
	    var _this4 = this;
	
	    var active = true;
	
	    this.nextCallback = function (event) {
	      if (active) {
	        active = false;
	        _this4.nextCallback = null;
	        callback(event);
	      }
	    };
	
	    this.nextCallback.cancel = function () {
	      active = false;
	    };
	
	    return this.nextCallback;
	  };
	
	  _proto.onTransitionEnd = function onTransitionEnd(node, timeout, handler) {
	    this.setNextCallback(handler);
	    var doesNotHaveTimeoutOrListener = timeout == null && !this.props.addEndListener;
	
	    if (!node || doesNotHaveTimeoutOrListener) {
	      setTimeout(this.nextCallback, 0);
	      return;
	    }
	
	    if (this.props.addEndListener) {
	      this.props.addEndListener(node, this.nextCallback);
	    }
	
	    if (timeout != null) {
	      setTimeout(this.nextCallback, timeout);
	    }
	  };
	
	  _proto.render = function render() {
	    var status = this.state.status;
	
	    if (status === UNMOUNTED) {
	      return null;
	    }
	
	    var _this$props = this.props,
	        children = _this$props.children,
	        childProps = _objectWithoutPropertiesLoose(_this$props, ["children"]); // filter props for Transtition
	
	
	    delete childProps.in;
	    delete childProps.mountOnEnter;
	    delete childProps.unmountOnExit;
	    delete childProps.appear;
	    delete childProps.enter;
	    delete childProps.exit;
	    delete childProps.timeout;
	    delete childProps.addEndListener;
	    delete childProps.onEnter;
	    delete childProps.onEntering;
	    delete childProps.onEntered;
	    delete childProps.onExit;
	    delete childProps.onExiting;
	    delete childProps.onExited;
	
	    if (typeof children === 'function') {
	      // allows for nested Transitions
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, children(status, childProps));
	    }
	
	    var child = _react.default.Children.only(children);
	
	    return (// allows for nested Transitions
	      _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: null
	      }, _react.default.cloneElement(child, childProps))
	    );
	  };
	
	  return Transition;
	}(_react.default.Component);
	
	Transition.contextType = _TransitionGroupContext.default;
	Transition.propTypes =  false ? {
	  /**
	   * A `function` child can be used instead of a React element. This function is
	   * called with the current transition status (`'entering'`, `'entered'`,
	   * `'exiting'`, `'exited'`), which can be used to apply context
	   * specific props to a component.
	   *
	   * ```jsx
	   * <Transition in={this.state.in} timeout={150}>
	   *   {state => (
	   *     <MyComponent className={`fade fade-${state}`} />
	   *   )}
	   * </Transition>
	   * ```
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.func.isRequired, _propTypes.default.element.isRequired]).isRequired,
	
	  /**
	   * Show the component; triggers the enter or exit states
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * By default the child component is mounted immediately along with
	   * the parent `Transition` component. If you want to "lazy mount" the component on the
	   * first `in={true}` you can set `mountOnEnter`. After the first enter transition the component will stay
	   * mounted, even on "exited", unless you also specify `unmountOnExit`.
	   */
	  mountOnEnter: _propTypes.default.bool,
	
	  /**
	   * By default the child component stays mounted after it reaches the `'exited'` state.
	   * Set `unmountOnExit` if you'd prefer to unmount the component after it finishes exiting.
	   */
	  unmountOnExit: _propTypes.default.bool,
	
	  /**
	   * Normally a component is not transitioned if it is shown when the
	   * `<Transition>` component mounts. If you want to transition on the first
	   * mount set `appear` to `true`, and the component will transition in as soon
	   * as the `<Transition>` mounts.
	   *
	   * > **Note**: there are no special appear states like `appearing`/`appeared`, this prop
	   * > only adds an additional enter transition. However, in the
	   * > `<CSSTransition>` component that first enter transition does result in
	   * > additional `.appear-*` classes, that way you can choose to style it
	   * > differently.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * Enable or disable enter transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * Enable or disable exit transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * The duration of the transition, in milliseconds.
	   * Required unless `addEndListener` is provided.
	   *
	   * You may specify a single timeout for all transitions:
	   *
	   * ```jsx
	   * timeout={500}
	   * ```
	   *
	   * or individually:
	   *
	   * ```jsx
	   * timeout={{
	   *  appear: 500,
	   *  enter: 300,
	   *  exit: 500,
	   * }}
	   * ```
	   *
	   * - `appear` defaults to the value of `enter`
	   * - `enter` defaults to `0`
	   * - `exit` defaults to `0`
	   *
	   * @type {number | { enter?: number, exit?: number, appear?: number }}
	   */
	  timeout: function timeout(props) {
	    var pt = _PropTypes.timeoutsShape;
	    if (!props.addEndListener) pt = pt.isRequired;
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    return pt.apply(void 0, [props].concat(args));
	  },
	
	  /**
	   * Add a custom transition end trigger. Called with the transitioning
	   * DOM node and a `done` callback. Allows for more fine grained transition end
	   * logic. **Note:** Timeouts are still used as a fallback if provided.
	   *
	   * ```jsx
	   * addEndListener={(node, done) => {
	   *   // use the css transitionend event to mark the finish of a transition
	   *   node.addEventListener('transitionend', done, false);
	   * }}
	   * ```
	   */
	  addEndListener: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entering" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "entered" status is applied. An extra parameter
	   * `isAppearing` is supplied to indicate if the enter stage is occurring on the initial mount
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool) -> void
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired before the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exiting" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * Callback fired after the "exited" status is applied.
	   *
	   * @type Function(node: HtmlElement) -> void
	   */
	  onExited: _propTypes.default.func // Name the function so it is clearer in the documentation
	
	} : {};
	
	function noop() {}
	
	Transition.defaultProps = {
	  in: false,
	  mountOnEnter: false,
	  unmountOnExit: false,
	  appear: false,
	  enter: true,
	  exit: true,
	  onEnter: noop,
	  onEntering: noop,
	  onEntered: noop,
	  onExit: noop,
	  onExiting: noop,
	  onExited: noop
	};
	Transition.UNMOUNTED = 0;
	Transition.EXITED = 1;
	Transition.ENTERING = 2;
	Transition.ENTERED = 3;
	Transition.EXITING = 4;
	var _default = Transition;
	exports.default = _default;

/***/ },
/* 103 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var _default = _react.default.createContext(null);
	
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 104 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var isProduction = ("production") === 'production';
	var prefix = 'Invariant failed';
	function invariant(condition, message) {
	  if (condition) {
	    return;
	  }
	
	  if (isProduction) {
	    throw new Error(prefix);
	  } else {
	    throw new Error(prefix + ": " + (message || ''));
	  }
	}
	
	module.exports = invariant;


/***/ },
/* 105 */
/***/ function(module, exports) {

	function _arrayWithHoles(arr) {
	  if (Array.isArray(arr)) return arr;
	}
	
	module.exports = _arrayWithHoles;

/***/ },
/* 106 */
/***/ function(module, exports) {

	function _assertThisInitialized(self) {
	  if (self === void 0) {
	    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
	  }
	
	  return self;
	}
	
	module.exports = _assertThisInitialized;

/***/ },
/* 107 */
/***/ function(module, exports) {

	function _inheritsLoose(subClass, superClass) {
	  subClass.prototype = Object.create(superClass.prototype);
	  subClass.prototype.constructor = subClass;
	  subClass.__proto__ = superClass;
	}
	
	module.exports = _inheritsLoose;

/***/ },
/* 108 */
/***/ function(module, exports) {

	function _iterableToArray(iter) {
	  if (Symbol.iterator in Object(iter) || Object.prototype.toString.call(iter) === "[object Arguments]") return Array.from(iter);
	}
	
	module.exports = _iterableToArray;

/***/ },
/* 109 */
/***/ function(module, exports) {

	function _nonIterableRest() {
	  throw new TypeError("Invalid attempt to destructure non-iterable instance");
	}
	
	module.exports = _nonIterableRest;

/***/ },
/* 110 */
/***/ function(module, exports) {

	function _objectWithoutPropertiesLoose(source, excluded) {
	  if (source == null) return {};
	  var target = {};
	  var sourceKeys = Object.keys(source);
	  var key, i;
	
	  for (i = 0; i < sourceKeys.length; i++) {
	    key = sourceKeys[i];
	    if (excluded.indexOf(key) >= 0) continue;
	    target[key] = source[key];
	  }
	
	  return target;
	}
	
	module.exports = _objectWithoutPropertiesLoose;

/***/ },
/* 111 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var browser = __webpack_require__(205);
	var MapiClient = __webpack_require__(112);
	
	function BrowserClient(options) {
	  MapiClient.call(this, options);
	}
	BrowserClient.prototype = Object.create(MapiClient.prototype);
	BrowserClient.prototype.constructor = BrowserClient;
	
	BrowserClient.prototype.sendRequest = browser.browserSend;
	BrowserClient.prototype.abortRequest = browser.browserAbort;
	
	/**
	 * Create a client for the browser.
	 *
	 * @param {Object} options
	 * @param {string} options.accessToken
	 * @param {string} [options.origin]
	 * @returns {MapiClient}
	 */
	function createBrowserClient(options) {
	  return new BrowserClient(options);
	}
	
	module.exports = createBrowserClient;


/***/ },
/* 112 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var parseToken = __webpack_require__(113);
	var MapiRequest = __webpack_require__(207);
	var constants = __webpack_require__(61);
	
	/**
	 * A low-level Mapbox API client. Use it to create service clients
	 * that share the same configuration.
	 *
	 * Services and `MapiRequest`s use the underlying `MapiClient` to
	 * determine how to create, send, and abort requests in a way
	 * that is appropriate to the configuration and environment
	 * (Node or the browser).
	 *
	 * @class MapiClient
	 * @property {string} accessToken - The Mapbox access token assigned
	 *   to this client.
	 * @property {string} [origin] - The origin
	 *   to use for API requests. Defaults to https://api.mapbox.com.
	 */
	
	function MapiClient(options) {
	  if (!options || !options.accessToken) {
	    throw new Error('Cannot create a client without an access token');
	  }
	  // Try parsing the access token to determine right away if it's valid.
	  parseToken(options.accessToken);
	
	  this.accessToken = options.accessToken;
	  this.origin = options.origin || constants.API_ORIGIN;
	}
	
	MapiClient.prototype.createRequest = function createRequest(requestOptions) {
	  return new MapiRequest(this, requestOptions);
	};
	
	module.exports = MapiClient;


/***/ },
/* 113 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var base64 = __webpack_require__(502);
	
	var tokenCache = {};
	
	function parseToken(token) {
	  if (tokenCache[token]) {
	    return tokenCache[token];
	  }
	
	  var parts = token.split('.');
	  var usage = parts[0];
	  var rawPayload = parts[1];
	  if (!rawPayload) {
	    throw new Error('Invalid token');
	  }
	
	  var parsedPayload = parsePaylod(rawPayload);
	
	  var result = {
	    usage: usage,
	    user: parsedPayload.u
	  };
	  if (has(parsedPayload, 'a')) result.authorization = parsedPayload.a;
	  if (has(parsedPayload, 'exp')) result.expires = parsedPayload.exp * 1000;
	  if (has(parsedPayload, 'iat')) result.created = parsedPayload.iat * 1000;
	  if (has(parsedPayload, 'scopes')) result.scopes = parsedPayload.scopes;
	  if (has(parsedPayload, 'client')) result.client = parsedPayload.client;
	  if (has(parsedPayload, 'll')) result.lastLogin = parsedPayload.ll;
	  if (has(parsedPayload, 'iu')) result.impersonator = parsedPayload.iu;
	
	  tokenCache[token] = result;
	  return result;
	}
	
	function parsePaylod(rawPayload) {
	  try {
	    return JSON.parse(base64.decode(rawPayload));
	  } catch (parseError) {
	    throw new Error('Invalid token');
	  }
	}
	
	function has(obj, key) {
	  return Object.prototype.hasOwnProperty.call(obj, key);
	}
	
	module.exports = parseToken;


/***/ },
/* 114 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Chip.default;
	  }
	});
	
	var _Chip = _interopRequireDefault(__webpack_require__(253));

/***/ },
/* 115 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ClickAwayListener.default;
	  }
	});
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(256));

/***/ },
/* 116 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 * @type {React.Context<{} | {expanded: boolean, disabled: boolean, toggle: () => void}>}
	 */
	var ExpansionPanelContext = React.createContext({});
	
	if (false) {
	  ExpansionPanelContext.displayName = 'ExpansionPanelContext';
	}
	
	var _default = ExpansionPanelContext;
	exports.default = _default;

/***/ },
/* 117 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormGroup.default;
	  }
	});
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(290));

/***/ },
/* 118 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormHelperText.default;
	  }
	});
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(291));

/***/ },
/* 119 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormLabel.default;
	  }
	});
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(292));

/***/ },
/* 120 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputLabel.default;
	  }
	});
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(313));

/***/ },
/* 121 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _LinearProgress.default;
	  }
	});
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(314));

/***/ },
/* 122 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _List.default;
	  }
	});
	
	var _List = _interopRequireDefault(__webpack_require__(317));

/***/ },
/* 123 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItem.default;
	  }
	});
	
	var _ListItem = _interopRequireDefault(__webpack_require__(318));

/***/ },
/* 124 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListSubheader.default;
	  }
	});
	
	var _ListSubheader = _interopRequireDefault(__webpack_require__(327));

/***/ },
/* 125 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(18);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Popover = _interopRequireDefault(__webpack_require__(82));
	
	var _MenuList = _interopRequireDefault(__webpack_require__(127));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _setRef = _interopRequireDefault(__webpack_require__(38));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var RTL_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'right'
	};
	var LTR_ORIGIN = {
	  vertical: 'top',
	  horizontal: 'left'
	};
	var styles = {
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    // specZ: The maximum height of a simple menu should be one or more rows less than the view
	    // height. This ensures a tapable area outside of the simple menu with which to dismiss
	    // the menu.
	    maxHeight: 'calc(100% - 96px)',
	    // Add iOS momentum scrolling.
	    WebkitOverflowScrolling: 'touch'
	  },
	
	  /* Styles applied to the `List` component via `MenuList`. */
	  list: {
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	var Menu = React.forwardRef(function Menu(props, ref) {
	  var _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? true : _props$autoFocus,
	      children = props.children,
	      classes = props.classes,
	      _props$disableAutoFoc = props.disableAutoFocusItem,
	      disableAutoFocusItem = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$MenuListProps = props.MenuListProps,
	      MenuListProps = _props$MenuListProps === void 0 ? {} : _props$MenuListProps,
	      onClose = props.onClose,
	      onEntering = props.onEntering,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      PopoverClasses = props.PopoverClasses,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoFocus", "children", "classes", "disableAutoFocusItem", "MenuListProps", "onClose", "onEntering", "open", "PaperProps", "PopoverClasses", "transitionDuration", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var autoFocusItem = autoFocus && !disableAutoFocusItem && open;
	  var menuListActionsRef = React.useRef(null);
	  var contentAnchorRef = React.useRef(null);
	
	  var getContentAnchorEl = function getContentAnchorEl() {
	    return contentAnchorRef.current;
	  };
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (menuListActionsRef.current) {
	      menuListActionsRef.current.adjustStyleForScrollbar(element, theme);
	    }
	
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	  };
	
	  var handleListKeyDown = function handleListKeyDown(event) {
	    if (event.key === 'Tab') {
	      event.preventDefault();
	
	      if (onClose) {
	        onClose(event, 'tabKeyDown');
	      }
	    }
	  };
	  /**
	   * the index of the item should receive focus
	   * in a `variant="selectedMenu"` it's the first `selected` item
	   * otherwise it's the very first item.
	   */
	
	
	  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
	  // to check if there is a `selected` item. We're looking for the last `selected`
	  // item and use the first valid item as a fallback
	
	  React.Children.map(children, function (child, index) {
	    if (!React.isValidElement(child)) {
	      return;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (!child.props.disabled) {
	      if (variant !== "menu" && child.props.selected) {
	        activeItemIndex = index;
	      } else if (activeItemIndex === -1) {
	        activeItemIndex = index;
	      }
	    }
	  });
	  var items = React.Children.map(children, function (child, index) {
	    if (index === activeItemIndex) {
	      return React.cloneElement(child, {
	        ref: function ref(instance) {
	          // #StrictMode ready
	          contentAnchorRef.current = ReactDOM.findDOMNode(instance);
	          (0, _setRef.default)(child.ref, instance);
	        }
	      });
	    }
	
	    return child;
	  });
	  return /*#__PURE__*/React.createElement(_Popover.default, (0, _extends2.default)({
	    getContentAnchorEl: getContentAnchorEl,
	    classes: PopoverClasses,
	    onClose: onClose,
	    onEntering: handleEntering,
	    anchorOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    transformOrigin: theme.direction === 'rtl' ? RTL_ORIGIN : LTR_ORIGIN,
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      classes: (0, _extends2.default)({}, PaperProps.classes, {
	        root: classes.paper
	      })
	    }),
	    open: open,
	    ref: ref,
	    transitionDuration: transitionDuration
	  }, other), /*#__PURE__*/React.createElement(_MenuList.default, (0, _extends2.default)({
	    onKeyDown: handleListKeyDown,
	    actions: menuListActionsRef,
	    autoFocus: autoFocus && (activeItemIndex === -1 || disableAutoFocusItem),
	    autoFocusItem: autoFocusItem,
	    variant: variant
	  }, MenuListProps, {
	    className: (0, _clsx.default)(classes.list, MenuListProps.className)
	  }), items));
	});
	 false ? Menu.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The DOM element used to set the position of the menu.
	   */
	  anchorEl: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(typeof Element === 'undefined' ? Object : Element)]),
	
	  /**
	   * If `true` (Default) will focus the `[role="menu"]` if no focusable child is found. Disabled
	   * children are not focusable. If you set this prop to `false` focus will be placed
	   * on the parent modal container. This has severe accessibility implications
	   * and should only be considered if you manage focus otherwise.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Menu contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * When opening the menu will not focus the active item but the `[role="menu"]`
	   * unless `autoFocus` is also set to `false`. Not using the default means not
	   * following WAI-ARIA authoring practices. Please be considerate about possible
	   * accessibility implications.
	   */
	  disableAutoFocusItem: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`MenuList`](/api/menu-list/) element.
	   */
	  MenuListProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`, `"tabKeyDown"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the Menu exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the Menu is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the menu is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * `classes` prop applied to the [`Popover`](/api/popover/) element.
	   */
	  PopoverClasses: _propTypes.default.object,
	
	  /**
	   * The length of the transition in `ms`, or 'auto'
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenu'
	})(Menu);
	
	exports.default = _default;

/***/ },
/* 126 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuItem.default;
	  }
	});
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(329));

/***/ },
/* 127 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MenuList.default;
	  }
	});
	
	var _MenuList = _interopRequireDefault(__webpack_require__(330));

/***/ },
/* 128 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.ariaHidden = ariaHidden;
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(73));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(60));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(165));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(27));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(56));
	
	// Is a vertical scrollbar displayed?
	function isOverflowing(container) {
	  var doc = (0, _ownerDocument.default)(container);
	
	  if (doc.body === container) {
	    return (0, _ownerWindow.default)(doc).innerWidth > doc.documentElement.clientWidth;
	  }
	
	  return container.scrollHeight > container.clientHeight;
	}
	
	function ariaHidden(node, show) {
	  if (show) {
	    node.setAttribute('aria-hidden', 'true');
	  } else {
	    node.removeAttribute('aria-hidden');
	  }
	}
	
	function getPaddingRight(node) {
	  return parseInt(window.getComputedStyle(node)['padding-right'], 10) || 0;
	}
	
	function ariaHiddenSiblings(container, mountNode, currentNode) {
	  var nodesToExclude = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : [];
	  var show = arguments.length > 4 ? arguments[4] : undefined;
	  var blacklist = [mountNode, currentNode].concat((0, _toConsumableArray2.default)(nodesToExclude));
	  var blacklistTagNames = ['TEMPLATE', 'SCRIPT', 'STYLE'];
	  [].forEach.call(container.children, function (node) {
	    if (node.nodeType === 1 && blacklist.indexOf(node) === -1 && blacklistTagNames.indexOf(node.tagName) === -1) {
	      ariaHidden(node, show);
	    }
	  });
	}
	
	function findIndexOf(containerInfo, callback) {
	  var idx = -1;
	  containerInfo.some(function (item, index) {
	    if (callback(item)) {
	      idx = index;
	      return true;
	    }
	
	    return false;
	  });
	  return idx;
	}
	
	function handleContainer(containerInfo, props) {
	  var restoreStyle = [];
	  var restorePaddings = [];
	  var container = containerInfo.container;
	  var fixedNodes;
	
	  if (!props.disableScrollLock) {
	    if (isOverflowing(container)) {
	      // Compute the size before applying overflow hidden to avoid any scroll jumps.
	      var scrollbarSize = (0, _getScrollbarSize.default)();
	      restoreStyle.push({
	        value: container.style.paddingRight,
	        key: 'padding-right',
	        el: container
	      }); // Use computed style, here to get the real padding to add our scrollbar width.
	
	      container.style['padding-right'] = "".concat(getPaddingRight(container) + scrollbarSize, "px"); // .mui-fixed is a global helper.
	
	      fixedNodes = (0, _ownerDocument.default)(container).querySelectorAll('.mui-fixed');
	      [].forEach.call(fixedNodes, function (node) {
	        restorePaddings.push(node.style.paddingRight);
	        node.style.paddingRight = "".concat(getPaddingRight(node) + scrollbarSize, "px");
	      });
	    } // Improve Gatsby support
	    // https://css-tricks.com/snippets/css/force-vertical-scrollbar/
	
	
	    var parent = container.parentElement;
	    var scrollContainer = parent.nodeName === 'HTML' && window.getComputedStyle(parent)['overflow-y'] === 'scroll' ? parent : container; // Block the scroll even if no scrollbar is visible to account for mobile keyboard
	    // screensize shrink.
	
	    restoreStyle.push({
	      value: scrollContainer.style.overflow,
	      key: 'overflow',
	      el: scrollContainer
	    });
	    scrollContainer.style.overflow = 'hidden';
	  }
	
	  var restore = function restore() {
	    if (fixedNodes) {
	      [].forEach.call(fixedNodes, function (node, i) {
	        if (restorePaddings[i]) {
	          node.style.paddingRight = restorePaddings[i];
	        } else {
	          node.style.removeProperty('padding-right');
	        }
	      });
	    }
	
	    restoreStyle.forEach(function (_ref) {
	      var value = _ref.value,
	          el = _ref.el,
	          key = _ref.key;
	
	      if (value) {
	        el.style.setProperty(key, value);
	      } else {
	        el.style.removeProperty(key);
	      }
	    });
	  };
	
	  return restore;
	}
	
	function getHiddenSiblings(container) {
	  var hiddenSiblings = [];
	  [].forEach.call(container.children, function (node) {
	    if (node.getAttribute && node.getAttribute('aria-hidden') === 'true') {
	      hiddenSiblings.push(node);
	    }
	  });
	  return hiddenSiblings;
	}
	/**
	 * @ignore - do not document.
	 *
	 * Proper state management for containers and the modals in those containers.
	 * Simplified, but inspired by react-overlay's ModalManager class.
	 * Used by the Modal to ensure proper styling of containers.
	 */
	
	
	var ModalManager = /*#__PURE__*/function () {
	  function ModalManager() {
	    (0, _classCallCheck2.default)(this, ModalManager);
	    // this.modals[modalIndex] = modal
	    this.modals = []; // this.containers[containerIndex] = {
	    //   modals: [],
	    //   container,
	    //   restore: null,
	    // }
	
	    this.containers = [];
	  }
	
	  (0, _createClass2.default)(ModalManager, [{
	    key: "add",
	    value: function add(modal, container) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex !== -1) {
	        return modalIndex;
	      }
	
	      modalIndex = this.modals.length;
	      this.modals.push(modal); // If the modal we are adding is already in the DOM.
	
	      if (modal.modalRef) {
	        ariaHidden(modal.modalRef, false);
	      }
	
	      var hiddenSiblingNodes = getHiddenSiblings(container);
	      ariaHiddenSiblings(container, modal.mountNode, modal.modalRef, hiddenSiblingNodes, true);
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.container === container;
	      });
	
	      if (containerIndex !== -1) {
	        this.containers[containerIndex].modals.push(modal);
	        return modalIndex;
	      }
	
	      this.containers.push({
	        modals: [modal],
	        container: container,
	        restore: null,
	        hiddenSiblingNodes: hiddenSiblingNodes
	      });
	      return modalIndex;
	    }
	  }, {
	    key: "mount",
	    value: function mount(modal, props) {
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	
	      if (!containerInfo.restore) {
	        containerInfo.restore = handleContainer(containerInfo, props);
	      }
	    }
	  }, {
	    key: "remove",
	    value: function remove(modal) {
	      var modalIndex = this.modals.indexOf(modal);
	
	      if (modalIndex === -1) {
	        return modalIndex;
	      }
	
	      var containerIndex = findIndexOf(this.containers, function (item) {
	        return item.modals.indexOf(modal) !== -1;
	      });
	      var containerInfo = this.containers[containerIndex];
	      containerInfo.modals.splice(containerInfo.modals.indexOf(modal), 1);
	      this.modals.splice(modalIndex, 1); // If that was the last modal in a container, clean up the container.
	
	      if (containerInfo.modals.length === 0) {
	        // The modal might be closed before it had the chance to be mounted in the DOM.
	        if (containerInfo.restore) {
	          containerInfo.restore();
	        }
	
	        if (modal.modalRef) {
	          // In case the modal wasn't in the DOM yet.
	          ariaHidden(modal.modalRef, true);
	        }
	
	        ariaHiddenSiblings(containerInfo.container, modal.mountNode, modal.modalRef, containerInfo.hiddenSiblingNodes, false);
	        this.containers.splice(containerIndex, 1);
	      } else {
	        // Otherwise make sure the next top modal is visible to a screen reader.
	        var nextTop = containerInfo.modals[containerInfo.modals.length - 1]; // as soon as a modal is adding its modalRef is undefined. it can't set
	        // aria-hidden because the dom element doesn't exist either
	        // when modal was unmounted before modalRef gets null
	
	        if (nextTop.modalRef) {
	          ariaHidden(nextTop.modalRef, false);
	        }
	      }
	
	      return modalIndex;
	    }
	  }, {
	    key: "isTopModal",
	    value: function isTopModal(modal) {
	      return this.modals.length > 0 && this.modals[this.modals.length - 1] === modal;
	    }
	  }]);
	  return ModalManager;
	}();
	
	exports.default = ModalManager;

/***/ },
/* 129 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(130));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(43));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(36));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(156));
	
	var _Input = _interopRequireDefault(__webpack_require__(64));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the select component `root` class. */
	    root: {},
	
	    /* Styles applied to the select component `select` class. */
	    select: {
	      '-moz-appearance': 'none',
	      // Reset
	      '-webkit-appearance': 'none',
	      // Reset
	      // When interacting quickly, the text can end up selected.
	      // Native select can't be selected either.
	      userSelect: 'none',
	      borderRadius: 0,
	      // Reset
	      minWidth: 16,
	      // So it doesn't collapse.
	      cursor: 'pointer',
	      '&:focus': {
	        // Show that it's not an text input
	        backgroundColor: theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.05)' : 'rgba(255, 255, 255, 0.05)',
	        borderRadius: 0 // Reset Chrome style
	
	      },
	      // Remove IE 11 arrow
	      '&::-ms-expand': {
	        display: 'none'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      },
	      '&[multiple]': {
	        height: 'auto'
	      },
	      '&:not([multiple]) option, &:not([multiple]) optgroup': {
	        backgroundColor: theme.palette.background.paper
	      },
	      '&&': {
	        paddingRight: 24
	      }
	    },
	
	    /* Styles applied to the select component if `variant="filled"`. */
	    filled: {
	      '&&': {
	        paddingRight: 32
	      }
	    },
	
	    /* Styles applied to the select component if `variant="outlined"`. */
	    outlined: {
	      borderRadius: theme.shape.borderRadius,
	      '&&': {
	        paddingRight: 32
	      }
	    },
	
	    /* Styles applied to the select component `selectMenu` class. */
	    selectMenu: {
	      height: 'auto',
	      // Reset
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap',
	      overflow: 'hidden'
	    },
	
	    /* Pseudo-class applied to the select component `disabled` class. */
	    disabled: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      // We use a position absolute over a flexbox in order to forward the pointer events
	      // to the input and to support wrapping tags..
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 12px)',
	      // Center vertically
	      pointerEvents: 'none',
	      // Don't block pointer events on the select under the icon.
	      color: theme.palette.action.active,
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the icon component if the popup is open. */
	    iconOpen: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the icon component if `variant="filled"`. */
	    iconFilled: {
	      right: 7
	    },
	
	    /* Styles applied to the icon component if `variant="outlined"`. */
	    iconOutlined: {
	      right: 7
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultInput = /*#__PURE__*/React.createElement(_Input.default, null);
	/**
	 * An alternative to `<Select native />` with a much smaller bundle size footprint.
	 */
	
	var NativeSelect = React.forwardRef(function NativeSelect(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      _props$input = props.input,
	      input = _props$input === void 0 ? defaultInput : _props$input,
	      inputProps = props.inputProps,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "IconComponent", "input", "inputProps", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  return React.cloneElement(input, (0, _extends2.default)({
	    // Most of the logic is implemented in `NativeSelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: _NativeSelectInput.default,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      classes: classes,
	      IconComponent: IconComponent,
	      variant: fcs.variant,
	      type: undefined
	    }, inputProps, {}, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	 false ? NativeSelect.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * Attributes applied to the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	NativeSelect.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiNativeSelect'
	})(NativeSelect);
	
	exports.default = _default;

/***/ },
/* 130 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	/**
	 * @ignore - internal component.
	 */
	var NativeSelectInput = React.forwardRef(function NativeSelectInput(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      disabled = props.disabled,
	      IconComponent = props.IconComponent,
	      inputRef = props.inputRef,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "IconComponent", "inputRef", "variant"]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("select", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes[variant], className, disabled && classes.disabled),
	    disabled: disabled,
	    ref: inputRef || ref
	  }, other)), props.multiple ? null : /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _capitalize.default)(variant))], disabled && classes.disabled)
	  }));
	});
	 false ? NativeSelectInput.propTypes = {
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<option>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Use that prop to pass a ref to the native select element.
	   * @deprecated
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = NativeSelectInput;
	exports.default = _default;

/***/ },
/* 131 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NoSsr.default;
	  }
	});
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(337));

/***/ },
/* 132 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var RadioGroupContext = React.createContext();
	
	if (false) {
	  RadioGroupContext.displayName = 'RadioGroupContext';
	}
	
	var _default = RadioGroupContext;
	exports.default = _default;

/***/ },
/* 133 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useRadioGroup;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _RadioGroupContext = _interopRequireDefault(__webpack_require__(132));
	
	function useRadioGroup() {
	  return React.useContext(_RadioGroupContext.default);
	}

/***/ },
/* 134 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slide.default;
	  }
	});
	
	var _Slide = _interopRequireDefault(__webpack_require__(353));

/***/ },
/* 135 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SnackbarContent.default;
	  }
	});
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(359));

/***/ },
/* 136 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepConnector.default;
	  }
	});
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(364));

/***/ },
/* 137 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepIcon.default;
	  }
	});
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(367));

/***/ },
/* 138 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepLabel.default;
	  }
	});
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(368));

/***/ },
/* 139 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	/**
	 * @ignore - internal component.
	 */
	var TableContext = React.createContext();
	
	if (false) {
	  TableContext.displayName = 'TableContext';
	}
	
	var _default = TableContext;
	exports.default = _default;

/***/ },
/* 140 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Table.default;
	  }
	});
	
	var _Table = _interopRequireDefault(__webpack_require__(379));

/***/ },
/* 141 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableBody.default;
	  }
	});
	
	var _TableBody = _interopRequireDefault(__webpack_require__(380));

/***/ },
/* 142 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableContainer.default;
	  }
	});
	
	var _TableContainer = _interopRequireDefault(__webpack_require__(382));

/***/ },
/* 143 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableHead.default;
	  }
	});
	
	var _TableHead = _interopRequireDefault(__webpack_require__(385));

/***/ },
/* 144 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableRow.default;
	  }
	});
	
	var _TableRow = _interopRequireDefault(__webpack_require__(389));

/***/ },
/* 145 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextField.default;
	  }
	});
	
	var _TextField = _interopRequireDefault(__webpack_require__(397));

/***/ },
/* 146 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TextareaAutosize.default;
	  }
	});
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(398));

/***/ },
/* 147 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Toolbar.default;
	  }
	});
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(399));

/***/ },
/* 148 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blue = {
	  50: '#e3f2fd',
	  100: '#bbdefb',
	  200: '#90caf9',
	  300: '#64b5f6',
	  400: '#42a5f5',
	  500: '#2196f3',
	  600: '#1e88e5',
	  700: '#1976d2',
	  800: '#1565c0',
	  900: '#0d47a1',
	  A100: '#82b1ff',
	  A200: '#448aff',
	  A400: '#2979ff',
	  A700: '#2962ff'
	};
	var _default = blue;
	exports.default = _default;

/***/ },
/* 149 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var common = {
	  black: '#000',
	  white: '#fff'
	};
	var _default = common;
	exports.default = _default;

/***/ },
/* 150 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var green = {
	  50: '#e8f5e9',
	  100: '#c8e6c9',
	  200: '#a5d6a7',
	  300: '#81c784',
	  400: '#66bb6a',
	  500: '#4caf50',
	  600: '#43a047',
	  700: '#388e3c',
	  800: '#2e7d32',
	  900: '#1b5e20',
	  A100: '#b9f6ca',
	  A200: '#69f0ae',
	  A400: '#00e676',
	  A700: '#00c853'
	};
	var _default = green;
	exports.default = _default;

/***/ },
/* 151 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var grey = {
	  50: '#fafafa',
	  100: '#f5f5f5',
	  200: '#eeeeee',
	  300: '#e0e0e0',
	  400: '#bdbdbd',
	  500: '#9e9e9e',
	  600: '#757575',
	  700: '#616161',
	  800: '#424242',
	  900: '#212121',
	  A100: '#d5d5d5',
	  A200: '#aaaaaa',
	  A400: '#303030',
	  A700: '#616161'
	};
	var _default = grey;
	exports.default = _default;

/***/ },
/* 152 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var indigo = {
	  50: '#e8eaf6',
	  100: '#c5cae9',
	  200: '#9fa8da',
	  300: '#7986cb',
	  400: '#5c6bc0',
	  500: '#3f51b5',
	  600: '#3949ab',
	  700: '#303f9f',
	  800: '#283593',
	  900: '#1a237e',
	  A100: '#8c9eff',
	  A200: '#536dfe',
	  A400: '#3d5afe',
	  A700: '#304ffe'
	};
	var _default = indigo;
	exports.default = _default;

/***/ },
/* 153 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var orange = {
	  50: '#fff3e0',
	  100: '#ffe0b2',
	  200: '#ffcc80',
	  300: '#ffb74d',
	  400: '#ffa726',
	  500: '#ff9800',
	  600: '#fb8c00',
	  700: '#f57c00',
	  800: '#ef6c00',
	  900: '#e65100',
	  A100: '#ffd180',
	  A200: '#ffab40',
	  A400: '#ff9100',
	  A700: '#ff6d00'
	};
	var _default = orange;
	exports.default = _default;

/***/ },
/* 154 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var pink = {
	  50: '#fce4ec',
	  100: '#f8bbd0',
	  200: '#f48fb1',
	  300: '#f06292',
	  400: '#ec407a',
	  500: '#e91e63',
	  600: '#d81b60',
	  700: '#c2185b',
	  800: '#ad1457',
	  900: '#880e4f',
	  A100: '#ff80ab',
	  A200: '#ff4081',
	  A400: '#f50057',
	  A700: '#c51162'
	};
	var _default = pink;
	exports.default = _default;

/***/ },
/* 155 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var red = {
	  50: '#ffebee',
	  100: '#ffcdd2',
	  200: '#ef9a9a',
	  300: '#e57373',
	  400: '#ef5350',
	  500: '#f44336',
	  600: '#e53935',
	  700: '#d32f2f',
	  800: '#c62828',
	  900: '#b71c1c',
	  A100: '#ff8a80',
	  A200: '#ff5252',
	  A400: '#ff1744',
	  A700: '#d50000'
	};
	var _default = red;
	exports.default = _default;

/***/ },
/* 156 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 157 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M15.41 16.09l-4.58-4.59 4.58-4.59L14 5.5l-6 6 6 6z"
	}), 'KeyboardArrowLeft');
	
	exports.default = _default;

/***/ },
/* 158 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M8.59 16.34l4.58-4.59-4.58-4.59L10 5.75l6 6-6 6z"
	}), 'KeyboardArrowRight');
	
	exports.default = _default;

/***/ },
/* 159 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createBreakpoints;
	exports.keys = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	// Sorted ASC by size. That's important.
	// It can't be configured as it's used statically for propTypes.
	var keys = ['xs', 'sm', 'md', 'lg', 'xl']; // Keep in mind that @media is inclusive by the CSS specification.
	
	exports.keys = keys;
	
	function createBreakpoints(breakpoints) {
	  var _breakpoints$values = breakpoints.values,
	      values = _breakpoints$values === void 0 ? {
	    xs: 0,
	    sm: 600,
	    md: 960,
	    lg: 1280,
	    xl: 1920
	  } : _breakpoints$values,
	      _breakpoints$unit = breakpoints.unit,
	      unit = _breakpoints$unit === void 0 ? 'px' : _breakpoints$unit,
	      _breakpoints$step = breakpoints.step,
	      step = _breakpoints$step === void 0 ? 5 : _breakpoints$step,
	      other = (0, _objectWithoutProperties2.default)(breakpoints, ["values", "unit", "step"]);
	
	  function up(key) {
	    var value = typeof values[key] === 'number' ? values[key] : key;
	    return "@media (min-width:".concat(value).concat(unit, ")");
	  }
	
	  function down(key) {
	    var endIndex = keys.indexOf(key) + 1;
	    var upperbound = values[keys[endIndex]];
	
	    if (endIndex === keys.length) {
	      // xl down applies to all sizes
	      return up('xs');
	    }
	
	    var value = typeof upperbound === 'number' && endIndex > 0 ? upperbound : key;
	    return "@media (max-width:".concat(value - step / 100).concat(unit, ")");
	  }
	
	  function between(start, end) {
	    var endIndex = keys.indexOf(end);
	
	    if (endIndex === keys.length - 1) {
	      return up(start);
	    }
	
	    return "@media (min-width:".concat(typeof values[start] === 'number' ? values[start] : start).concat(unit, ") and ") + "(max-width:".concat((endIndex !== -1 && typeof values[keys[endIndex + 1]] === 'number' ? values[keys[endIndex + 1]] : end) - step / 100).concat(unit, ")");
	  }
	
	  function only(key) {
	    return between(key, key);
	  }
	
	  function width(key) {
	    return values[key];
	  }
	
	  return (0, _extends2.default)({
	    keys: keys,
	    values: values,
	    up: up,
	    down: down,
	    between: between,
	    only: only,
	    width: width
	  }, other);
	}

/***/ },
/* 160 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(9);
	
	var _createBreakpoints = _interopRequireDefault(__webpack_require__(159));
	
	var _createMixins = _interopRequireDefault(__webpack_require__(431));
	
	var _createPalette = _interopRequireDefault(__webpack_require__(432));
	
	var _createTypography = _interopRequireDefault(__webpack_require__(435));
	
	var _shadows = _interopRequireDefault(__webpack_require__(439));
	
	var _shape = _interopRequireDefault(__webpack_require__(440));
	
	var _createSpacing = _interopRequireDefault(__webpack_require__(433));
	
	var _transitions = _interopRequireDefault(__webpack_require__(26));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(163));
	
	function createMuiTheme() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpointsInput = _options$breakpoints === void 0 ? {} : _options$breakpoints,
	      _options$mixins = options.mixins,
	      mixinsInput = _options$mixins === void 0 ? {} : _options$mixins,
	      _options$palette = options.palette,
	      paletteInput = _options$palette === void 0 ? {} : _options$palette,
	      spacingInput = options.spacing,
	      _options$typography = options.typography,
	      typographyInput = _options$typography === void 0 ? {} : _options$typography,
	      other = (0, _objectWithoutProperties2.default)(options, ["breakpoints", "mixins", "palette", "spacing", "typography"]);
	  var palette = (0, _createPalette.default)(paletteInput);
	  var breakpoints = (0, _createBreakpoints.default)(breakpointsInput);
	  var spacing = (0, _createSpacing.default)(spacingInput);
	  var muiTheme = (0, _utils.deepmerge)({
	    breakpoints: breakpoints,
	    direction: 'ltr',
	    mixins: (0, _createMixins.default)(breakpoints, spacing, mixinsInput),
	    overrides: {},
	    // Inject custom styles
	    palette: palette,
	    props: {},
	    // Provide default props
	    shadows: _shadows.default,
	    typography: (0, _createTypography.default)(palette, typographyInput),
	    spacing: spacing,
	    shape: _shape.default,
	    transitions: _transitions.default,
	    zIndex: _zIndex.default
	  }, other);
	
	  for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	    args[_key - 1] = arguments[_key];
	  }
	
	  muiTheme = args.reduce(function (acc, argument) {
	    return (0, _utils.deepmerge)(acc, argument);
	  }, muiTheme);
	
	  if (false) {
	    var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected'];
	
	    var traverse = function traverse(node, parentKey) {
	      var depth = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 1;
	      var key; // eslint-disable-next-line guard-for-in, no-restricted-syntax
	
	      for (key in node) {
	        var child = node[key];
	
	        if (depth === 1) {
	          if (key.indexOf('Mui') === 0 && child) {
	            traverse(child, key, depth + 1);
	          }
	        } else if (pseudoClasses.indexOf(key) !== -1 && Object.keys(child).length > 0) {
	          if (process.env.NODE_ENV !== 'production') {
	            console.error(["Material-UI: the `".concat(parentKey, "` component increases ") + "the CSS specificity of the `".concat(key, "` internal state."), 'You can not override it like this: ', JSON.stringify(node, null, 2), '', 'Instead, you need to use the $ruleName syntax:', JSON.stringify({
	              root: (0, _defineProperty2.default)({}, "&$".concat(key), child)
	            }, null, 2), '', 'https://material-ui.com/r/pseudo-classes-guide'].join('\n'));
	          } // Remove the style to prevent global conflicts.
	
	
	          node[key] = {};
	        }
	      }
	    };
	
	    traverse(muiTheme.overrides);
	  }
	
	  return muiTheme;
	}
	
	var _default = createMuiTheme;
	exports.default = _default;

/***/ },
/* 161 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  createMuiTheme: true,
	  createStyles: true,
	  makeStyles: true,
	  responsiveFontSizes: true,
	  styled: true,
	  useTheme: true,
	  withStyles: true,
	  withTheme: true,
	  createGenerateClassName: true,
	  jssPreset: true,
	  ServerStyleSheets: true,
	  StylesProvider: true,
	  MuiThemeProvider: true,
	  ThemeProvider: true
	};
	Object.defineProperty(exports, "createMuiTheme", {
	  enumerable: true,
	  get: function get() {
	    return _createMuiTheme.default;
	  }
	});
	Object.defineProperty(exports, "createStyles", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	Object.defineProperty(exports, "makeStyles", {
	  enumerable: true,
	  get: function get() {
	    return _makeStyles.default;
	  }
	});
	Object.defineProperty(exports, "responsiveFontSizes", {
	  enumerable: true,
	  get: function get() {
	    return _responsiveFontSizes.default;
	  }
	});
	Object.defineProperty(exports, "styled", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	Object.defineProperty(exports, "useTheme", {
	  enumerable: true,
	  get: function get() {
	    return _useTheme.default;
	  }
	});
	Object.defineProperty(exports, "withStyles", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	Object.defineProperty(exports, "withTheme", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	Object.defineProperty(exports, "createGenerateClassName", {
	  enumerable: true,
	  get: function get() {
	    return _styles.createGenerateClassName;
	  }
	});
	Object.defineProperty(exports, "jssPreset", {
	  enumerable: true,
	  get: function get() {
	    return _styles.jssPreset;
	  }
	});
	Object.defineProperty(exports, "ServerStyleSheets", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ServerStyleSheets;
	  }
	});
	Object.defineProperty(exports, "StylesProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.StylesProvider;
	  }
	});
	Object.defineProperty(exports, "MuiThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	Object.defineProperty(exports, "ThemeProvider", {
	  enumerable: true,
	  get: function get() {
	    return _styles.ThemeProvider;
	  }
	});
	
	var _colorManipulator = __webpack_require__(15);
	
	Object.keys(_colorManipulator).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _colorManipulator[key];
	    }
	  });
	});
	
	var _createMuiTheme = _interopRequireDefault(__webpack_require__(160));
	
	var _createStyles = _interopRequireDefault(__webpack_require__(434));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(437));
	
	var _responsiveFontSizes = _interopRequireDefault(__webpack_require__(438));
	
	var _styled = _interopRequireDefault(__webpack_require__(162));
	
	var _transitions = __webpack_require__(26);
	
	Object.keys(_transitions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _transitions[key];
	    }
	  });
	});
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _withTheme = _interopRequireDefault(__webpack_require__(441));
	
	var _styles = __webpack_require__(20);

/***/ },
/* 162 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _styles = __webpack_require__(20);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(53));
	
	var styled = function styled(Component) {
	  var componentCreator = (0, _styles.styled)(Component);
	  return function (style, options) {
	    return componentCreator(style, (0, _extends2.default)({
	      defaultTheme: _defaultTheme.default
	    }, options));
	  };
	};
	
	var _default = styled;
	exports.default = _default;

/***/ },
/* 163 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We need to centralize the zIndex definitions as they work
	// like global values in the browser.
	var zIndex = {
	  mobileStepper: 1000,
	  speedDial: 1050,
	  appBar: 1100,
	  drawer: 1200,
	  modal: 1300,
	  snackbar: 1400,
	  tooltip: 1500
	};
	var _default = zIndex;
	exports.default = _default;

/***/ },
/* 164 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useMediaQuery.default;
	  }
	});
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(442));

/***/ },
/* 165 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getScrollbarSize;
	
	// A change of the browser zoom change the scrollbar size.
	// Credit https://github.com/twbs/bootstrap/blob/3ffe3a5d82f6f561b82ff78d82b32a7d14aed558/js/src/modal.js#L512-L519
	function getScrollbarSize() {
	  var scrollDiv = document.createElement('div');
	  scrollDiv.style.width = '99px';
	  scrollDiv.style.height = '99px';
	  scrollDiv.style.position = 'absolute';
	  scrollDiv.style.top = '-9999px';
	  scrollDiv.style.overflow = 'scroll';
	  document.body.appendChild(scrollDiv);
	  var scrollbarSize = scrollDiv.offsetWidth - scrollDiv.clientWidth;
	  document.body.removeChild(scrollDiv);
	  return scrollbarSize;
	}

/***/ },
/* 166 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = requirePropFactory;
	
	function requirePropFactory(componentNameInError) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  var requireProp = function requireProp(requiredProp) {
	    return function (props, propName, componentName, location, propFullName) {
	      var propFullNameSafe = propFullName || propName;
	
	      if (typeof props[propName] !== 'undefined' && !props[requiredProp]) {
	        return new Error("The prop `".concat(propFullNameSafe, "` of ") + "`".concat(componentNameInError, "` must be used on `").concat(requiredProp, "`."));
	      }
	
	      return null;
	    };
	  };
	
	  return requireProp;
	}

/***/ },
/* 167 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var hasSymbol = typeof Symbol === 'function' && Symbol.for;
	
	var _default = hasSymbol ? Symbol.for('mui.nested') : '__THEME_NESTED__';
	
	exports.default = _default;

/***/ },
/* 168 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// We use the same empty object to ref count the styles that don't need a theme object.
	var noopTheme = {};
	var _default = noopTheme;
	exports.default = _default;

/***/ },
/* 169 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getThemeProps.default;
	  }
	});
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(470));

/***/ },
/* 170 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _jssPreset.default;
	  }
	});
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(471));

/***/ },
/* 171 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _mergeClasses.default;
	  }
	});
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(475));

/***/ },
/* 172 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var ThemeContext = _react.default.createContext(null);
	
	if (false) {
	  ThemeContext.displayName = 'ThemeContext';
	}
	
	var _default = ThemeContext;
	exports.default = _default;

/***/ },
/* 173 */
/***/ function(module, exports, __webpack_require__) {

	/** @license Material-UI v4.9.10
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {
	  borders: true,
	  breakpoints: true,
	  compose: true,
	  css: true,
	  display: true,
	  flexbox: true,
	  grid: true,
	  palette: true,
	  positions: true,
	  shadows: true,
	  sizing: true,
	  spacing: true,
	  style: true,
	  typography: true
	};
	Object.defineProperty(exports, "borders", {
	  enumerable: true,
	  get: function get() {
	    return _borders.default;
	  }
	});
	Object.defineProperty(exports, "breakpoints", {
	  enumerable: true,
	  get: function get() {
	    return _breakpoints.default;
	  }
	});
	Object.defineProperty(exports, "compose", {
	  enumerable: true,
	  get: function get() {
	    return _compose.default;
	  }
	});
	Object.defineProperty(exports, "css", {
	  enumerable: true,
	  get: function get() {
	    return _css.default;
	  }
	});
	Object.defineProperty(exports, "display", {
	  enumerable: true,
	  get: function get() {
	    return _display.default;
	  }
	});
	Object.defineProperty(exports, "flexbox", {
	  enumerable: true,
	  get: function get() {
	    return _flexbox.default;
	  }
	});
	Object.defineProperty(exports, "grid", {
	  enumerable: true,
	  get: function get() {
	    return _grid.default;
	  }
	});
	Object.defineProperty(exports, "palette", {
	  enumerable: true,
	  get: function get() {
	    return _palette.default;
	  }
	});
	Object.defineProperty(exports, "positions", {
	  enumerable: true,
	  get: function get() {
	    return _positions.default;
	  }
	});
	Object.defineProperty(exports, "shadows", {
	  enumerable: true,
	  get: function get() {
	    return _shadows.default;
	  }
	});
	Object.defineProperty(exports, "sizing", {
	  enumerable: true,
	  get: function get() {
	    return _sizing.default;
	  }
	});
	Object.defineProperty(exports, "spacing", {
	  enumerable: true,
	  get: function get() {
	    return _spacing.default;
	  }
	});
	Object.defineProperty(exports, "style", {
	  enumerable: true,
	  get: function get() {
	    return _style.default;
	  }
	});
	Object.defineProperty(exports, "typography", {
	  enumerable: true,
	  get: function get() {
	    return _typography.default;
	  }
	});
	
	var _borders = _interopRequireWildcard(__webpack_require__(483));
	
	Object.keys(_borders).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _borders[key];
	    }
	  });
	});
	
	var _breakpoints = _interopRequireDefault(__webpack_require__(95));
	
	var _compose = _interopRequireDefault(__webpack_require__(30));
	
	var _css = _interopRequireDefault(__webpack_require__(484));
	
	var _display = _interopRequireDefault(__webpack_require__(485));
	
	var _flexbox = _interopRequireWildcard(__webpack_require__(486));
	
	Object.keys(_flexbox).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _flexbox[key];
	    }
	  });
	});
	
	var _grid = _interopRequireWildcard(__webpack_require__(487));
	
	Object.keys(_grid).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _grid[key];
	    }
	  });
	});
	
	var _palette = _interopRequireWildcard(__webpack_require__(489));
	
	Object.keys(_palette).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _palette[key];
	    }
	  });
	});
	
	var _positions = _interopRequireWildcard(__webpack_require__(490));
	
	Object.keys(_positions).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _positions[key];
	    }
	  });
	});
	
	var _shadows = _interopRequireDefault(__webpack_require__(491));
	
	var _sizing = _interopRequireWildcard(__webpack_require__(492));
	
	Object.keys(_sizing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _sizing[key];
	    }
	  });
	});
	
	var _spacing = _interopRequireWildcard(__webpack_require__(493));
	
	Object.keys(_spacing).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _spacing[key];
	    }
	  });
	});
	
	var _style = _interopRequireDefault(__webpack_require__(28));
	
	var _typography = _interopRequireWildcard(__webpack_require__(494));
	
	Object.keys(_typography).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _typography[key];
	    }
	  });
	});

/***/ },
/* 174 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var responsivePropType =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string, _propTypes.default.object, _propTypes.default.array]) : {};
	var _default = responsivePropType;
	exports.default = _default;

/***/ },
/* 175 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-geo/ Version 1.2.6. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(31)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-array'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3));
	}(this, (function (exports,d3Array) { 'use strict';
	
	// Adds floating point numbers with twice the normal precision.
	// Reference: J. R. Shewchuk, Adaptive Precision Floating-Point Arithmetic and
	// Fast Robust Geometric Predicates, Discrete & Computational Geometry 18(3)
	// 305–363 (1997).
	// Code adapted from GeographicLib by Charles F. F. Karney,
	// http://geographiclib.sourceforge.net/
	
	var adder = function() {
	  return new Adder;
	};
	
	function Adder() {
	  this.reset();
	}
	
	Adder.prototype = {
	  constructor: Adder,
	  reset: function() {
	    this.s = // rounded value
	    this.t = 0; // exact error
	  },
	  add: function(y) {
	    add(temp, y, this.t);
	    add(this, temp.s, this.s);
	    if (this.s) this.t += temp.t;
	    else this.s = temp.t;
	  },
	  valueOf: function() {
	    return this.s;
	  }
	};
	
	var temp = new Adder;
	
	function add(adder, a, b) {
	  var x = adder.s = a + b,
	      bv = x - a,
	      av = x - bv;
	  adder.t = (a - av) + (b - bv);
	}
	
	var epsilon = 1e-6;
	var epsilon2 = 1e-12;
	var pi = Math.PI;
	var halfPi = pi / 2;
	var quarterPi = pi / 4;
	var tau = pi * 2;
	
	var degrees = 180 / pi;
	var radians = pi / 180;
	
	var abs = Math.abs;
	var atan = Math.atan;
	var atan2 = Math.atan2;
	var cos = Math.cos;
	var ceil = Math.ceil;
	var exp = Math.exp;
	
	var log = Math.log;
	var pow = Math.pow;
	var sin = Math.sin;
	var sign = Math.sign || function(x) { return x > 0 ? 1 : x < 0 ? -1 : 0; };
	var sqrt = Math.sqrt;
	var tan = Math.tan;
	
	function acos(x) {
	  return x > 1 ? 0 : x < -1 ? pi : Math.acos(x);
	}
	
	function asin(x) {
	  return x > 1 ? halfPi : x < -1 ? -halfPi : Math.asin(x);
	}
	
	function haversin(x) {
	  return (x = sin(x / 2)) * x;
	}
	
	function noop() {}
	
	function streamGeometry(geometry, stream) {
	  if (geometry && streamGeometryType.hasOwnProperty(geometry.type)) {
	    streamGeometryType[geometry.type](geometry, stream);
	  }
	}
	
	var streamObjectType = {
	  Feature: function(feature, stream) {
	    streamGeometry(feature.geometry, stream);
	  },
	  FeatureCollection: function(object, stream) {
	    var features = object.features, i = -1, n = features.length;
	    while (++i < n) streamGeometry(features[i].geometry, stream);
	  }
	};
	
	var streamGeometryType = {
	  Sphere: function(object, stream) {
	    stream.sphere();
	  },
	  Point: function(object, stream) {
	    object = object.coordinates;
	    stream.point(object[0], object[1], object[2]);
	  },
	  MultiPoint: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) object = coordinates[i], stream.point(object[0], object[1], object[2]);
	  },
	  LineString: function(object, stream) {
	    streamLine(object.coordinates, stream, 0);
	  },
	  MultiLineString: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamLine(coordinates[i], stream, 0);
	  },
	  Polygon: function(object, stream) {
	    streamPolygon(object.coordinates, stream);
	  },
	  MultiPolygon: function(object, stream) {
	    var coordinates = object.coordinates, i = -1, n = coordinates.length;
	    while (++i < n) streamPolygon(coordinates[i], stream);
	  },
	  GeometryCollection: function(object, stream) {
	    var geometries = object.geometries, i = -1, n = geometries.length;
	    while (++i < n) streamGeometry(geometries[i], stream);
	  }
	};
	
	function streamLine(coordinates, stream, closed) {
	  var i = -1, n = coordinates.length - closed, coordinate;
	  stream.lineStart();
	  while (++i < n) coordinate = coordinates[i], stream.point(coordinate[0], coordinate[1], coordinate[2]);
	  stream.lineEnd();
	}
	
	function streamPolygon(coordinates, stream) {
	  var i = -1, n = coordinates.length;
	  stream.polygonStart();
	  while (++i < n) streamLine(coordinates[i], stream, 1);
	  stream.polygonEnd();
	}
	
	var geoStream = function(object, stream) {
	  if (object && streamObjectType.hasOwnProperty(object.type)) {
	    streamObjectType[object.type](object, stream);
	  } else {
	    streamGeometry(object, stream);
	  }
	};
	
	var areaRingSum = adder();
	
	var areaSum = adder();
	var lambda00;
	var phi00;
	var lambda0;
	var cosPhi0;
	var sinPhi0;
	
	var areaStream = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaRingSum.reset();
	    areaStream.lineStart = areaRingStart;
	    areaStream.lineEnd = areaRingEnd;
	  },
	  polygonEnd: function() {
	    var areaRing = +areaRingSum;
	    areaSum.add(areaRing < 0 ? tau + areaRing : areaRing);
	    this.lineStart = this.lineEnd = this.point = noop;
	  },
	  sphere: function() {
	    areaSum.add(tau);
	  }
	};
	
	function areaRingStart() {
	  areaStream.point = areaPointFirst;
	}
	
	function areaRingEnd() {
	  areaPoint(lambda00, phi00);
	}
	
	function areaPointFirst(lambda, phi) {
	  areaStream.point = areaPoint;
	  lambda00 = lambda, phi00 = phi;
	  lambda *= radians, phi *= radians;
	  lambda0 = lambda, cosPhi0 = cos(phi = phi / 2 + quarterPi), sinPhi0 = sin(phi);
	}
	
	function areaPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  phi = phi / 2 + quarterPi; // half the angular distance from south pole
	
	  // Spherical excess E for a spherical triangle with vertices: south pole,
	  // previous point, current point.  Uses a formula derived from Cagnoli’s
	  // theorem.  See Todhunter, Spherical Trig. (1871), Sec. 103, Eq. (2).
	  var dLambda = lambda - lambda0,
	      sdLambda = dLambda >= 0 ? 1 : -1,
	      adLambda = sdLambda * dLambda,
	      cosPhi = cos(phi),
	      sinPhi = sin(phi),
	      k = sinPhi0 * sinPhi,
	      u = cosPhi0 * cosPhi + k * cos(adLambda),
	      v = k * sdLambda * sin(adLambda);
	  areaRingSum.add(atan2(v, u));
	
	  // Advance the previous points.
	  lambda0 = lambda, cosPhi0 = cosPhi, sinPhi0 = sinPhi;
	}
	
	var area = function(object) {
	  areaSum.reset();
	  geoStream(object, areaStream);
	  return areaSum * 2;
	};
	
	function spherical(cartesian) {
	  return [atan2(cartesian[1], cartesian[0]), asin(cartesian[2])];
	}
	
	function cartesian(spherical) {
	  var lambda = spherical[0], phi = spherical[1], cosPhi = cos(phi);
	  return [cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi)];
	}
	
	function cartesianDot(a, b) {
	  return a[0] * b[0] + a[1] * b[1] + a[2] * b[2];
	}
	
	function cartesianCross(a, b) {
	  return [a[1] * b[2] - a[2] * b[1], a[2] * b[0] - a[0] * b[2], a[0] * b[1] - a[1] * b[0]];
	}
	
	// TODO return a
	function cartesianAddInPlace(a, b) {
	  a[0] += b[0], a[1] += b[1], a[2] += b[2];
	}
	
	function cartesianScale(vector, k) {
	  return [vector[0] * k, vector[1] * k, vector[2] * k];
	}
	
	// TODO return d
	function cartesianNormalizeInPlace(d) {
	  var l = sqrt(d[0] * d[0] + d[1] * d[1] + d[2] * d[2]);
	  d[0] /= l, d[1] /= l, d[2] /= l;
	}
	
	var lambda0$1;
	var phi0;
	var lambda1;
	var phi1;
	var lambda2;
	var lambda00$1;
	var phi00$1;
	var p0;
	var deltaSum = adder();
	var ranges;
	var range$1;
	
	var boundsStream = {
	  point: boundsPoint,
	  lineStart: boundsLineStart,
	  lineEnd: boundsLineEnd,
	  polygonStart: function() {
	    boundsStream.point = boundsRingPoint;
	    boundsStream.lineStart = boundsRingStart;
	    boundsStream.lineEnd = boundsRingEnd;
	    deltaSum.reset();
	    areaStream.polygonStart();
	  },
	  polygonEnd: function() {
	    areaStream.polygonEnd();
	    boundsStream.point = boundsPoint;
	    boundsStream.lineStart = boundsLineStart;
	    boundsStream.lineEnd = boundsLineEnd;
	    if (areaRingSum < 0) lambda0$1 = -(lambda1 = 180), phi0 = -(phi1 = 90);
	    else if (deltaSum > epsilon) phi1 = 90;
	    else if (deltaSum < -epsilon) phi0 = -90;
	    range$1[0] = lambda0$1, range$1[1] = lambda1;
	  }
	};
	
	function boundsPoint(lambda, phi) {
	  ranges.push(range$1 = [lambda0$1 = lambda, lambda1 = lambda]);
	  if (phi < phi0) phi0 = phi;
	  if (phi > phi1) phi1 = phi;
	}
	
	function linePoint(lambda, phi) {
	  var p = cartesian([lambda * radians, phi * radians]);
	  if (p0) {
	    var normal = cartesianCross(p0, p),
	        equatorial = [normal[1], -normal[0], 0],
	        inflection = cartesianCross(equatorial, normal);
	    cartesianNormalizeInPlace(inflection);
	    inflection = spherical(inflection);
	    var delta = lambda - lambda2,
	        sign$$1 = delta > 0 ? 1 : -1,
	        lambdai = inflection[0] * degrees * sign$$1,
	        phii,
	        antimeridian = abs(delta) > 180;
	    if (antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = inflection[1] * degrees;
	      if (phii > phi1) phi1 = phii;
	    } else if (lambdai = (lambdai + 360) % 360 - 180, antimeridian ^ (sign$$1 * lambda2 < lambdai && lambdai < sign$$1 * lambda)) {
	      phii = -inflection[1] * degrees;
	      if (phii < phi0) phi0 = phii;
	    } else {
	      if (phi < phi0) phi0 = phi;
	      if (phi > phi1) phi1 = phi;
	    }
	    if (antimeridian) {
	      if (lambda < lambda2) {
	        if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	      } else {
	        if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	      }
	    } else {
	      if (lambda1 >= lambda0$1) {
	        if (lambda < lambda0$1) lambda0$1 = lambda;
	        if (lambda > lambda1) lambda1 = lambda;
	      } else {
	        if (lambda > lambda2) {
	          if (angle(lambda0$1, lambda) > angle(lambda0$1, lambda1)) lambda1 = lambda;
	        } else {
	          if (angle(lambda, lambda1) > angle(lambda0$1, lambda1)) lambda0$1 = lambda;
	        }
	      }
	    }
	  } else {
	    boundsPoint(lambda, phi);
	  }
	  p0 = p, lambda2 = lambda;
	}
	
	function boundsLineStart() {
	  boundsStream.point = linePoint;
	}
	
	function boundsLineEnd() {
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  boundsStream.point = boundsPoint;
	  p0 = null;
	}
	
	function boundsRingPoint(lambda, phi) {
	  if (p0) {
	    var delta = lambda - lambda2;
	    deltaSum.add(abs(delta) > 180 ? delta + (delta > 0 ? 360 : -360) : delta);
	  } else {
	    lambda00$1 = lambda, phi00$1 = phi;
	  }
	  areaStream.point(lambda, phi);
	  linePoint(lambda, phi);
	}
	
	function boundsRingStart() {
	  areaStream.lineStart();
	}
	
	function boundsRingEnd() {
	  boundsRingPoint(lambda00$1, phi00$1);
	  areaStream.lineEnd();
	  if (abs(deltaSum) > epsilon) lambda0$1 = -(lambda1 = 180);
	  range$1[0] = lambda0$1, range$1[1] = lambda1;
	  p0 = null;
	}
	
	// Finds the left-right distance between two longitudes.
	// This is almost the same as (lambda1 - lambda0 + 360°) % 360°, except that we want
	// the distance between ±180° to be 360°.
	function angle(lambda0, lambda1) {
	  return (lambda1 -= lambda0) < 0 ? lambda1 + 360 : lambda1;
	}
	
	function rangeCompare(a, b) {
	  return a[0] - b[0];
	}
	
	function rangeContains(range$$1, x) {
	  return range$$1[0] <= range$$1[1] ? range$$1[0] <= x && x <= range$$1[1] : x < range$$1[0] || range$$1[1] < x;
	}
	
	var bounds = function(feature) {
	  var i, n, a, b, merged, deltaMax, delta;
	
	  phi1 = lambda1 = -(lambda0$1 = phi0 = Infinity);
	  ranges = [];
	  geoStream(feature, boundsStream);
	
	  // First, sort ranges by their minimum longitudes.
	  if (n = ranges.length) {
	    ranges.sort(rangeCompare);
	
	    // Then, merge any ranges that overlap.
	    for (i = 1, a = ranges[0], merged = [a]; i < n; ++i) {
	      b = ranges[i];
	      if (rangeContains(a, b[0]) || rangeContains(a, b[1])) {
	        if (angle(a[0], b[1]) > angle(a[0], a[1])) a[1] = b[1];
	        if (angle(b[0], a[1]) > angle(a[0], a[1])) a[0] = b[0];
	      } else {
	        merged.push(a = b);
	      }
	    }
	
	    // Finally, find the largest gap between the merged ranges.
	    // The final bounding box will be the inverse of this gap.
	    for (deltaMax = -Infinity, n = merged.length - 1, i = 0, a = merged[n]; i <= n; a = b, ++i) {
	      b = merged[i];
	      if ((delta = angle(a[1], b[0])) > deltaMax) deltaMax = delta, lambda0$1 = b[0], lambda1 = a[1];
	    }
	  }
	
	  ranges = range$1 = null;
	
	  return lambda0$1 === Infinity || phi0 === Infinity
	      ? [[NaN, NaN], [NaN, NaN]]
	      : [[lambda0$1, phi0], [lambda1, phi1]];
	};
	
	var W0;
	var W1;
	var X0;
	var Y0;
	var Z0;
	var X1;
	var Y1;
	var Z1;
	var X2;
	var Y2;
	var Z2;
	var lambda00$2;
	var phi00$2;
	var x0;
	var y0;
	var z0; // previous point
	
	var centroidStream = {
	  sphere: noop,
	  point: centroidPoint,
	  lineStart: centroidLineStart,
	  lineEnd: centroidLineEnd,
	  polygonStart: function() {
	    centroidStream.lineStart = centroidRingStart;
	    centroidStream.lineEnd = centroidRingEnd;
	  },
	  polygonEnd: function() {
	    centroidStream.lineStart = centroidLineStart;
	    centroidStream.lineEnd = centroidLineEnd;
	  }
	};
	
	// Arithmetic mean of Cartesian vectors.
	function centroidPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  centroidPointCartesian(cosPhi * cos(lambda), cosPhi * sin(lambda), sin(phi));
	}
	
	function centroidPointCartesian(x, y, z) {
	  ++W0;
	  X0 += (x - X0) / W0;
	  Y0 += (y - Y0) / W0;
	  Z0 += (z - Z0) / W0;
	}
	
	function centroidLineStart() {
	  centroidStream.point = centroidLinePointFirst;
	}
	
	function centroidLinePointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidStream.point = centroidLinePoint;
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLinePoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      w = atan2(sqrt((w = y0 * z - z0 * y) * w + (w = z0 * x - x0 * z) * w + (w = x0 * y - y0 * x) * w), x0 * x + y0 * y + z0 * z);
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidLineEnd() {
	  centroidStream.point = centroidPoint;
	}
	
	// See J. E. Brock, The Inertia Tensor for a Spherical Triangle,
	// J. Applied Mechanics 42, 239 (1975).
	function centroidRingStart() {
	  centroidStream.point = centroidRingPointFirst;
	}
	
	function centroidRingEnd() {
	  centroidRingPoint(lambda00$2, phi00$2);
	  centroidStream.point = centroidPoint;
	}
	
	function centroidRingPointFirst(lambda, phi) {
	  lambda00$2 = lambda, phi00$2 = phi;
	  lambda *= radians, phi *= radians;
	  centroidStream.point = centroidRingPoint;
	  var cosPhi = cos(phi);
	  x0 = cosPhi * cos(lambda);
	  y0 = cosPhi * sin(lambda);
	  z0 = sin(phi);
	  centroidPointCartesian(x0, y0, z0);
	}
	
	function centroidRingPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var cosPhi = cos(phi),
	      x = cosPhi * cos(lambda),
	      y = cosPhi * sin(lambda),
	      z = sin(phi),
	      cx = y0 * z - z0 * y,
	      cy = z0 * x - x0 * z,
	      cz = x0 * y - y0 * x,
	      m = sqrt(cx * cx + cy * cy + cz * cz),
	      u = x0 * x + y0 * y + z0 * z,
	      v = m && -acos(u) / m, // area weight
	      w = atan2(m, u); // line weight
	  X2 += v * cx;
	  Y2 += v * cy;
	  Z2 += v * cz;
	  W1 += w;
	  X1 += w * (x0 + (x0 = x));
	  Y1 += w * (y0 + (y0 = y));
	  Z1 += w * (z0 + (z0 = z));
	  centroidPointCartesian(x0, y0, z0);
	}
	
	var centroid = function(object) {
	  W0 = W1 =
	  X0 = Y0 = Z0 =
	  X1 = Y1 = Z1 =
	  X2 = Y2 = Z2 = 0;
	  geoStream(object, centroidStream);
	
	  var x = X2,
	      y = Y2,
	      z = Z2,
	      m = x * x + y * y + z * z;
	
	  // If the area-weighted ccentroid is undefined, fall back to length-weighted ccentroid.
	  if (m < epsilon2) {
	    x = X1, y = Y1, z = Z1;
	    // If the feature has zero length, fall back to arithmetic mean of point vectors.
	    if (W1 < epsilon) x = X0, y = Y0, z = Z0;
	    m = x * x + y * y + z * z;
	    // If the feature still has an undefined ccentroid, then return.
	    if (m < epsilon2) return [NaN, NaN];
	  }
	
	  return [atan2(y, x) * degrees, asin(z / sqrt(m)) * degrees];
	};
	
	var constant = function(x) {
	  return function() {
	    return x;
	  };
	};
	
	var compose = function(a, b) {
	
	  function compose(x, y) {
	    return x = a(x, y), b(x[0], x[1]);
	  }
	
	  if (a.invert && b.invert) compose.invert = function(x, y) {
	    return x = b.invert(x, y), x && a.invert(x[0], x[1]);
	  };
	
	  return compose;
	};
	
	function rotationIdentity(lambda, phi) {
	  return [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	}
	
	rotationIdentity.invert = rotationIdentity;
	
	function rotateRadians(deltaLambda, deltaPhi, deltaGamma) {
	  return (deltaLambda %= tau) ? (deltaPhi || deltaGamma ? compose(rotationLambda(deltaLambda), rotationPhiGamma(deltaPhi, deltaGamma))
	    : rotationLambda(deltaLambda))
	    : (deltaPhi || deltaGamma ? rotationPhiGamma(deltaPhi, deltaGamma)
	    : rotationIdentity);
	}
	
	function forwardRotationLambda(deltaLambda) {
	  return function(lambda, phi) {
	    return lambda += deltaLambda, [lambda > pi ? lambda - tau : lambda < -pi ? lambda + tau : lambda, phi];
	  };
	}
	
	function rotationLambda(deltaLambda) {
	  var rotation = forwardRotationLambda(deltaLambda);
	  rotation.invert = forwardRotationLambda(-deltaLambda);
	  return rotation;
	}
	
	function rotationPhiGamma(deltaPhi, deltaGamma) {
	  var cosDeltaPhi = cos(deltaPhi),
	      sinDeltaPhi = sin(deltaPhi),
	      cosDeltaGamma = cos(deltaGamma),
	      sinDeltaGamma = sin(deltaGamma);
	
	  function rotation(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaPhi + x * sinDeltaPhi;
	    return [
	      atan2(y * cosDeltaGamma - k * sinDeltaGamma, x * cosDeltaPhi - z * sinDeltaPhi),
	      asin(k * cosDeltaGamma + y * sinDeltaGamma)
	    ];
	  }
	
	  rotation.invert = function(lambda, phi) {
	    var cosPhi = cos(phi),
	        x = cos(lambda) * cosPhi,
	        y = sin(lambda) * cosPhi,
	        z = sin(phi),
	        k = z * cosDeltaGamma - y * sinDeltaGamma;
	    return [
	      atan2(y * cosDeltaGamma + z * sinDeltaGamma, x * cosDeltaPhi + k * sinDeltaPhi),
	      asin(k * cosDeltaPhi - x * sinDeltaPhi)
	    ];
	  };
	
	  return rotation;
	}
	
	var rotation = function(rotate) {
	  rotate = rotateRadians(rotate[0] * radians, rotate[1] * radians, rotate.length > 2 ? rotate[2] * radians : 0);
	
	  function forward(coordinates) {
	    coordinates = rotate(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  }
	
	  forward.invert = function(coordinates) {
	    coordinates = rotate.invert(coordinates[0] * radians, coordinates[1] * radians);
	    return coordinates[0] *= degrees, coordinates[1] *= degrees, coordinates;
	  };
	
	  return forward;
	};
	
	// Generates a circle centered at [0°, 0°], with a given radius and precision.
	function circleStream(stream, radius, delta, direction, t0, t1) {
	  if (!delta) return;
	  var cosRadius = cos(radius),
	      sinRadius = sin(radius),
	      step = direction * delta;
	  if (t0 == null) {
	    t0 = radius + direction * tau;
	    t1 = radius - step / 2;
	  } else {
	    t0 = circleRadius(cosRadius, t0);
	    t1 = circleRadius(cosRadius, t1);
	    if (direction > 0 ? t0 < t1 : t0 > t1) t0 += direction * tau;
	  }
	  for (var point, t = t0; direction > 0 ? t > t1 : t < t1; t -= step) {
	    point = spherical([cosRadius, -sinRadius * cos(t), -sinRadius * sin(t)]);
	    stream.point(point[0], point[1]);
	  }
	}
	
	// Returns the signed angle of a cartesian point relative to [cosRadius, 0, 0].
	function circleRadius(cosRadius, point) {
	  point = cartesian(point), point[0] -= cosRadius;
	  cartesianNormalizeInPlace(point);
	  var radius = acos(-point[1]);
	  return ((-point[2] < 0 ? -radius : radius) + tau - epsilon) % tau;
	}
	
	var circle = function() {
	  var center = constant([0, 0]),
	      radius = constant(90),
	      precision = constant(6),
	      ring,
	      rotate,
	      stream = {point: point};
	
	  function point(x, y) {
	    ring.push(x = rotate(x, y));
	    x[0] *= degrees, x[1] *= degrees;
	  }
	
	  function circle() {
	    var c = center.apply(this, arguments),
	        r = radius.apply(this, arguments) * radians,
	        p = precision.apply(this, arguments) * radians;
	    ring = [];
	    rotate = rotateRadians(-c[0] * radians, -c[1] * radians, 0).invert;
	    circleStream(stream, r, p, 1);
	    c = {type: "Polygon", coordinates: [ring]};
	    ring = rotate = null;
	    return c;
	  }
	
	  circle.center = function(_) {
	    return arguments.length ? (center = typeof _ === "function" ? _ : constant([+_[0], +_[1]]), circle) : center;
	  };
	
	  circle.radius = function(_) {
	    return arguments.length ? (radius = typeof _ === "function" ? _ : constant(+_), circle) : radius;
	  };
	
	  circle.precision = function(_) {
	    return arguments.length ? (precision = typeof _ === "function" ? _ : constant(+_), circle) : precision;
	  };
	
	  return circle;
	};
	
	var clipBuffer = function() {
	  var lines = [],
	      line;
	  return {
	    point: function(x, y) {
	      line.push([x, y]);
	    },
	    lineStart: function() {
	      lines.push(line = []);
	    },
	    lineEnd: noop,
	    rejoin: function() {
	      if (lines.length > 1) lines.push(lines.pop().concat(lines.shift()));
	    },
	    result: function() {
	      var result = lines;
	      lines = [];
	      line = null;
	      return result;
	    }
	  };
	};
	
	var clipLine = function(a, b, x0, y0, x1, y1) {
	  var ax = a[0],
	      ay = a[1],
	      bx = b[0],
	      by = b[1],
	      t0 = 0,
	      t1 = 1,
	      dx = bx - ax,
	      dy = by - ay,
	      r;
	
	  r = x0 - ax;
	  if (!dx && r > 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dx > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = x1 - ax;
	  if (!dx && r < 0) return;
	  r /= dx;
	  if (dx < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dx > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  r = y0 - ay;
	  if (!dy && r > 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  } else if (dy > 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  }
	
	  r = y1 - ay;
	  if (!dy && r < 0) return;
	  r /= dy;
	  if (dy < 0) {
	    if (r > t1) return;
	    if (r > t0) t0 = r;
	  } else if (dy > 0) {
	    if (r < t0) return;
	    if (r < t1) t1 = r;
	  }
	
	  if (t0 > 0) a[0] = ax + t0 * dx, a[1] = ay + t0 * dy;
	  if (t1 < 1) b[0] = ax + t1 * dx, b[1] = ay + t1 * dy;
	  return true;
	};
	
	var pointEqual = function(a, b) {
	  return abs(a[0] - b[0]) < epsilon && abs(a[1] - b[1]) < epsilon;
	};
	
	function Intersection(point, points, other, entry) {
	  this.x = point;
	  this.z = points;
	  this.o = other; // another intersection
	  this.e = entry; // is an entry?
	  this.v = false; // visited
	  this.n = this.p = null; // next & previous
	}
	
	// A generalized polygon clipping algorithm: given a polygon that has been cut
	// into its visible line segments, and rejoins the segments by interpolating
	// along the clip edge.
	var clipPolygon = function(segments, compareIntersection, startInside, interpolate, stream) {
	  var subject = [],
	      clip = [],
	      i,
	      n;
	
	  segments.forEach(function(segment) {
	    if ((n = segment.length - 1) <= 0) return;
	    var n, p0 = segment[0], p1 = segment[n], x;
	
	    // If the first and last points of a segment are coincident, then treat as a
	    // closed ring. TODO if all rings are closed, then the winding order of the
	    // exterior ring should be checked.
	    if (pointEqual(p0, p1)) {
	      stream.lineStart();
	      for (i = 0; i < n; ++i) stream.point((p0 = segment[i])[0], p0[1]);
	      stream.lineEnd();
	      return;
	    }
	
	    subject.push(x = new Intersection(p0, segment, null, true));
	    clip.push(x.o = new Intersection(p0, null, x, false));
	    subject.push(x = new Intersection(p1, segment, null, false));
	    clip.push(x.o = new Intersection(p1, null, x, true));
	  });
	
	  if (!subject.length) return;
	
	  clip.sort(compareIntersection);
	  link(subject);
	  link(clip);
	
	  for (i = 0, n = clip.length; i < n; ++i) {
	    clip[i].e = startInside = !startInside;
	  }
	
	  var start = subject[0],
	      points,
	      point;
	
	  while (1) {
	    // Find first unvisited intersection.
	    var current = start,
	        isSubject = true;
	    while (current.v) if ((current = current.n) === start) return;
	    points = current.z;
	    stream.lineStart();
	    do {
	      current.v = current.o.v = true;
	      if (current.e) {
	        if (isSubject) {
	          for (i = 0, n = points.length; i < n; ++i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.n.x, 1, stream);
	        }
	        current = current.n;
	      } else {
	        if (isSubject) {
	          points = current.p.z;
	          for (i = points.length - 1; i >= 0; --i) stream.point((point = points[i])[0], point[1]);
	        } else {
	          interpolate(current.x, current.p.x, -1, stream);
	        }
	        current = current.p;
	      }
	      current = current.o;
	      points = current.z;
	      isSubject = !isSubject;
	    } while (!current.v);
	    stream.lineEnd();
	  }
	};
	
	function link(array) {
	  if (!(n = array.length)) return;
	  var n,
	      i = 0,
	      a = array[0],
	      b;
	  while (++i < n) {
	    a.n = b = array[i];
	    b.p = a;
	    a = b;
	  }
	  a.n = b = array[0];
	  b.p = a;
	}
	
	var clipMax = 1e9;
	var clipMin = -clipMax;
	
	// TODO Use d3-polygon’s polygonContains here for the ring check?
	// TODO Eliminate duplicate buffering in clipBuffer and polygon.push?
	
	function clipExtent(x0, y0, x1, y1) {
	
	  function visible(x, y) {
	    return x0 <= x && x <= x1 && y0 <= y && y <= y1;
	  }
	
	  function interpolate(from, to, direction, stream) {
	    var a = 0, a1 = 0;
	    if (from == null
	        || (a = corner(from, direction)) !== (a1 = corner(to, direction))
	        || comparePoint(from, to) < 0 ^ direction > 0) {
	      do stream.point(a === 0 || a === 3 ? x0 : x1, a > 1 ? y1 : y0);
	      while ((a = (a + direction + 4) % 4) !== a1);
	    } else {
	      stream.point(to[0], to[1]);
	    }
	  }
	
	  function corner(p, direction) {
	    return abs(p[0] - x0) < epsilon ? direction > 0 ? 0 : 3
	        : abs(p[0] - x1) < epsilon ? direction > 0 ? 2 : 1
	        : abs(p[1] - y0) < epsilon ? direction > 0 ? 1 : 0
	        : direction > 0 ? 3 : 2; // abs(p[1] - y1) < epsilon
	  }
	
	  function compareIntersection(a, b) {
	    return comparePoint(a.x, b.x);
	  }
	
	  function comparePoint(a, b) {
	    var ca = corner(a, 1),
	        cb = corner(b, 1);
	    return ca !== cb ? ca - cb
	        : ca === 0 ? b[1] - a[1]
	        : ca === 1 ? a[0] - b[0]
	        : ca === 2 ? a[1] - b[1]
	        : b[0] - a[0];
	  }
	
	  return function(stream) {
	    var activeStream = stream,
	        bufferStream = clipBuffer(),
	        segments,
	        polygon,
	        ring,
	        x__, y__, v__, // first point
	        x_, y_, v_, // previous point
	        first,
	        clean;
	
	    var clipStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: polygonStart,
	      polygonEnd: polygonEnd
	    };
	
	    function point(x, y) {
	      if (visible(x, y)) activeStream.point(x, y);
	    }
	
	    function polygonInside() {
	      var winding = 0;
	
	      for (var i = 0, n = polygon.length; i < n; ++i) {
	        for (var ring = polygon[i], j = 1, m = ring.length, point = ring[0], a0, a1, b0 = point[0], b1 = point[1]; j < m; ++j) {
	          a0 = b0, a1 = b1, point = ring[j], b0 = point[0], b1 = point[1];
	          if (a1 <= y1) { if (b1 > y1 && (b0 - a0) * (y1 - a1) > (b1 - a1) * (x0 - a0)) ++winding; }
	          else { if (b1 <= y1 && (b0 - a0) * (y1 - a1) < (b1 - a1) * (x0 - a0)) --winding; }
	        }
	      }
	
	      return winding;
	    }
	
	    // Buffer geometry within a polygon and then clip it en masse.
	    function polygonStart() {
	      activeStream = bufferStream, segments = [], polygon = [], clean = true;
	    }
	
	    function polygonEnd() {
	      var startInside = polygonInside(),
	          cleanInside = clean && startInside,
	          visible = (segments = d3Array.merge(segments)).length;
	      if (cleanInside || visible) {
	        stream.polygonStart();
	        if (cleanInside) {
	          stream.lineStart();
	          interpolate(null, null, 1, stream);
	          stream.lineEnd();
	        }
	        if (visible) {
	          clipPolygon(segments, compareIntersection, startInside, interpolate, stream);
	        }
	        stream.polygonEnd();
	      }
	      activeStream = stream, segments = polygon = ring = null;
	    }
	
	    function lineStart() {
	      clipStream.point = linePoint;
	      if (polygon) polygon.push(ring = []);
	      first = true;
	      v_ = false;
	      x_ = y_ = NaN;
	    }
	
	    // TODO rather than special-case polygons, simply handle them separately.
	    // Ideally, coincident intersection points should be jittered to avoid
	    // clipping issues.
	    function lineEnd() {
	      if (segments) {
	        linePoint(x__, y__);
	        if (v__ && v_) bufferStream.rejoin();
	        segments.push(bufferStream.result());
	      }
	      clipStream.point = point;
	      if (v_) activeStream.lineEnd();
	    }
	
	    function linePoint(x, y) {
	      var v = visible(x, y);
	      if (polygon) ring.push([x, y]);
	      if (first) {
	        x__ = x, y__ = y, v__ = v;
	        first = false;
	        if (v) {
	          activeStream.lineStart();
	          activeStream.point(x, y);
	        }
	      } else {
	        if (v && v_) activeStream.point(x, y);
	        else {
	          var a = [x_ = Math.max(clipMin, Math.min(clipMax, x_)), y_ = Math.max(clipMin, Math.min(clipMax, y_))],
	              b = [x = Math.max(clipMin, Math.min(clipMax, x)), y = Math.max(clipMin, Math.min(clipMax, y))];
	          if (clipLine(a, b, x0, y0, x1, y1)) {
	            if (!v_) {
	              activeStream.lineStart();
	              activeStream.point(a[0], a[1]);
	            }
	            activeStream.point(b[0], b[1]);
	            if (!v) activeStream.lineEnd();
	            clean = false;
	          } else if (v) {
	            activeStream.lineStart();
	            activeStream.point(x, y);
	            clean = false;
	          }
	        }
	      }
	      x_ = x, y_ = y, v_ = v;
	    }
	
	    return clipStream;
	  };
	}
	
	var extent = function() {
	  var x0 = 0,
	      y0 = 0,
	      x1 = 960,
	      y1 = 500,
	      cache,
	      cacheStream,
	      clip;
	
	  return clip = {
	    stream: function(stream) {
	      return cache && cacheStream === stream ? cache : cache = clipExtent(x0, y0, x1, y1)(cacheStream = stream);
	    },
	    extent: function(_) {
	      return arguments.length ? (x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1], cache = cacheStream = null, clip) : [[x0, y0], [x1, y1]];
	    }
	  };
	};
	
	var lengthSum = adder();
	var lambda0$2;
	var sinPhi0$1;
	var cosPhi0$1;
	
	var lengthStream = {
	  sphere: noop,
	  point: noop,
	  lineStart: lengthLineStart,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop
	};
	
	function lengthLineStart() {
	  lengthStream.point = lengthPointFirst;
	  lengthStream.lineEnd = lengthLineEnd;
	}
	
	function lengthLineEnd() {
	  lengthStream.point = lengthStream.lineEnd = noop;
	}
	
	function lengthPointFirst(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  lambda0$2 = lambda, sinPhi0$1 = sin(phi), cosPhi0$1 = cos(phi);
	  lengthStream.point = lengthPoint;
	}
	
	function lengthPoint(lambda, phi) {
	  lambda *= radians, phi *= radians;
	  var sinPhi = sin(phi),
	      cosPhi = cos(phi),
	      delta = abs(lambda - lambda0$2),
	      cosDelta = cos(delta),
	      sinDelta = sin(delta),
	      x = cosPhi * sinDelta,
	      y = cosPhi0$1 * sinPhi - sinPhi0$1 * cosPhi * cosDelta,
	      z = sinPhi0$1 * sinPhi + cosPhi0$1 * cosPhi * cosDelta;
	  lengthSum.add(atan2(sqrt(x * x + y * y), z));
	  lambda0$2 = lambda, sinPhi0$1 = sinPhi, cosPhi0$1 = cosPhi;
	}
	
	var length = function(object) {
	  lengthSum.reset();
	  geoStream(object, lengthStream);
	  return +lengthSum;
	};
	
	var coordinates = [null, null];
	var object = {type: "LineString", coordinates: coordinates};
	
	var distance = function(a, b) {
	  coordinates[0] = a;
	  coordinates[1] = b;
	  return length(object);
	};
	
	function graticuleX(y0, y1, dy) {
	  var y = d3Array.range(y0, y1 - epsilon, dy).concat(y1);
	  return function(x) { return y.map(function(y) { return [x, y]; }); };
	}
	
	function graticuleY(x0, x1, dx) {
	  var x = d3Array.range(x0, x1 - epsilon, dx).concat(x1);
	  return function(y) { return x.map(function(x) { return [x, y]; }); };
	}
	
	var graticule = function() {
	  var x1, x0, X1, X0,
	      y1, y0, Y1, Y0,
	      dx = 10, dy = dx, DX = 90, DY = 360,
	      x, y, X, Y,
	      precision = 2.5;
	
	  function graticule() {
	    return {type: "MultiLineString", coordinates: lines()};
	  }
	
	  function lines() {
	    return d3Array.range(ceil(X0 / DX) * DX, X1, DX).map(X)
	        .concat(d3Array.range(ceil(Y0 / DY) * DY, Y1, DY).map(Y))
	        .concat(d3Array.range(ceil(x0 / dx) * dx, x1, dx).filter(function(x) { return abs(x % DX) > epsilon; }).map(x))
	        .concat(d3Array.range(ceil(y0 / dy) * dy, y1, dy).filter(function(y) { return abs(y % DY) > epsilon; }).map(y));
	  }
	
	  graticule.lines = function() {
	    return lines().map(function(coordinates) { return {type: "LineString", coordinates: coordinates}; });
	  };
	
	  graticule.outline = function() {
	    return {
	      type: "Polygon",
	      coordinates: [
	        X(X0).concat(
	        Y(Y1).slice(1),
	        X(X1).reverse().slice(1),
	        Y(Y0).reverse().slice(1))
	      ]
	    };
	  };
	
	  graticule.extent = function(_) {
	    if (!arguments.length) return graticule.extentMinor();
	    return graticule.extentMajor(_).extentMinor(_);
	  };
	
	  graticule.extentMajor = function(_) {
	    if (!arguments.length) return [[X0, Y0], [X1, Y1]];
	    X0 = +_[0][0], X1 = +_[1][0];
	    Y0 = +_[0][1], Y1 = +_[1][1];
	    if (X0 > X1) _ = X0, X0 = X1, X1 = _;
	    if (Y0 > Y1) _ = Y0, Y0 = Y1, Y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.extentMinor = function(_) {
	    if (!arguments.length) return [[x0, y0], [x1, y1]];
	    x0 = +_[0][0], x1 = +_[1][0];
	    y0 = +_[0][1], y1 = +_[1][1];
	    if (x0 > x1) _ = x0, x0 = x1, x1 = _;
	    if (y0 > y1) _ = y0, y0 = y1, y1 = _;
	    return graticule.precision(precision);
	  };
	
	  graticule.step = function(_) {
	    if (!arguments.length) return graticule.stepMinor();
	    return graticule.stepMajor(_).stepMinor(_);
	  };
	
	  graticule.stepMajor = function(_) {
	    if (!arguments.length) return [DX, DY];
	    DX = +_[0], DY = +_[1];
	    return graticule;
	  };
	
	  graticule.stepMinor = function(_) {
	    if (!arguments.length) return [dx, dy];
	    dx = +_[0], dy = +_[1];
	    return graticule;
	  };
	
	  graticule.precision = function(_) {
	    if (!arguments.length) return precision;
	    precision = +_;
	    x = graticuleX(y0, y1, 90);
	    y = graticuleY(x0, x1, precision);
	    X = graticuleX(Y0, Y1, 90);
	    Y = graticuleY(X0, X1, precision);
	    return graticule;
	  };
	
	  return graticule
	      .extentMajor([[-180, -90 + epsilon], [180, 90 - epsilon]])
	      .extentMinor([[-180, -80 - epsilon], [180, 80 + epsilon]]);
	};
	
	var interpolate = function(a, b) {
	  var x0 = a[0] * radians,
	      y0 = a[1] * radians,
	      x1 = b[0] * radians,
	      y1 = b[1] * radians,
	      cy0 = cos(y0),
	      sy0 = sin(y0),
	      cy1 = cos(y1),
	      sy1 = sin(y1),
	      kx0 = cy0 * cos(x0),
	      ky0 = cy0 * sin(x0),
	      kx1 = cy1 * cos(x1),
	      ky1 = cy1 * sin(x1),
	      d = 2 * asin(sqrt(haversin(y1 - y0) + cy0 * cy1 * haversin(x1 - x0))),
	      k = sin(d);
	
	  var interpolate = d ? function(t) {
	    var B = sin(t *= d) / k,
	        A = sin(d - t) / k,
	        x = A * kx0 + B * kx1,
	        y = A * ky0 + B * ky1,
	        z = A * sy0 + B * sy1;
	    return [
	      atan2(y, x) * degrees,
	      atan2(z, sqrt(x * x + y * y)) * degrees
	    ];
	  } : function() {
	    return [x0 * degrees, y0 * degrees];
	  };
	
	  interpolate.distance = d;
	
	  return interpolate;
	};
	
	var identity = function(x) {
	  return x;
	};
	
	var areaSum$1 = adder();
	var areaRingSum$1 = adder();
	var x00;
	var y00;
	var x0$1;
	var y0$1;
	
	var areaStream$1 = {
	  point: noop,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: function() {
	    areaStream$1.lineStart = areaRingStart$1;
	    areaStream$1.lineEnd = areaRingEnd$1;
	  },
	  polygonEnd: function() {
	    areaStream$1.lineStart = areaStream$1.lineEnd = areaStream$1.point = noop;
	    areaSum$1.add(abs(areaRingSum$1));
	    areaRingSum$1.reset();
	  },
	  result: function() {
	    var area = areaSum$1 / 2;
	    areaSum$1.reset();
	    return area;
	  }
	};
	
	function areaRingStart$1() {
	  areaStream$1.point = areaPointFirst$1;
	}
	
	function areaPointFirst$1(x, y) {
	  areaStream$1.point = areaPoint$1;
	  x00 = x0$1 = x, y00 = y0$1 = y;
	}
	
	function areaPoint$1(x, y) {
	  areaRingSum$1.add(y0$1 * x - x0$1 * y);
	  x0$1 = x, y0$1 = y;
	}
	
	function areaRingEnd$1() {
	  areaPoint$1(x00, y00);
	}
	
	var x0$2 = Infinity;
	var y0$2 = x0$2;
	var x1 = -x0$2;
	var y1 = x1;
	
	var boundsStream$1 = {
	  point: boundsPoint$1,
	  lineStart: noop,
	  lineEnd: noop,
	  polygonStart: noop,
	  polygonEnd: noop,
	  result: function() {
	    var bounds = [[x0$2, y0$2], [x1, y1]];
	    x1 = y1 = -(y0$2 = x0$2 = Infinity);
	    return bounds;
	  }
	};
	
	function boundsPoint$1(x, y) {
	  if (x < x0$2) x0$2 = x;
	  if (x > x1) x1 = x;
	  if (y < y0$2) y0$2 = y;
	  if (y > y1) y1 = y;
	}
	
	// TODO Enforce positive area for exterior, negative area for interior?
	
	var X0$1 = 0;
	var Y0$1 = 0;
	var Z0$1 = 0;
	var X1$1 = 0;
	var Y1$1 = 0;
	var Z1$1 = 0;
	var X2$1 = 0;
	var Y2$1 = 0;
	var Z2$1 = 0;
	var x00$1;
	var y00$1;
	var x0$3;
	var y0$3;
	
	var centroidStream$1 = {
	  point: centroidPoint$1,
	  lineStart: centroidLineStart$1,
	  lineEnd: centroidLineEnd$1,
	  polygonStart: function() {
	    centroidStream$1.lineStart = centroidRingStart$1;
	    centroidStream$1.lineEnd = centroidRingEnd$1;
	  },
	  polygonEnd: function() {
	    centroidStream$1.point = centroidPoint$1;
	    centroidStream$1.lineStart = centroidLineStart$1;
	    centroidStream$1.lineEnd = centroidLineEnd$1;
	  },
	  result: function() {
	    var centroid = Z2$1 ? [X2$1 / Z2$1, Y2$1 / Z2$1]
	        : Z1$1 ? [X1$1 / Z1$1, Y1$1 / Z1$1]
	        : Z0$1 ? [X0$1 / Z0$1, Y0$1 / Z0$1]
	        : [NaN, NaN];
	    X0$1 = Y0$1 = Z0$1 =
	    X1$1 = Y1$1 = Z1$1 =
	    X2$1 = Y2$1 = Z2$1 = 0;
	    return centroid;
	  }
	};
	
	function centroidPoint$1(x, y) {
	  X0$1 += x;
	  Y0$1 += y;
	  ++Z0$1;
	}
	
	function centroidLineStart$1() {
	  centroidStream$1.point = centroidPointFirstLine;
	}
	
	function centroidPointFirstLine(x, y) {
	  centroidStream$1.point = centroidPointLine;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidPointLine(x, y) {
	  var dx = x - x0$3, dy = y - y0$3, z = sqrt(dx * dx + dy * dy);
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function centroidLineEnd$1() {
	  centroidStream$1.point = centroidPoint$1;
	}
	
	function centroidRingStart$1() {
	  centroidStream$1.point = centroidPointFirstRing;
	}
	
	function centroidRingEnd$1() {
	  centroidPointRing(x00$1, y00$1);
	}
	
	function centroidPointFirstRing(x, y) {
	  centroidStream$1.point = centroidPointRing;
	  centroidPoint$1(x00$1 = x0$3 = x, y00$1 = y0$3 = y);
	}
	
	function centroidPointRing(x, y) {
	  var dx = x - x0$3,
	      dy = y - y0$3,
	      z = sqrt(dx * dx + dy * dy);
	
	  X1$1 += z * (x0$3 + x) / 2;
	  Y1$1 += z * (y0$3 + y) / 2;
	  Z1$1 += z;
	
	  z = y0$3 * x - x0$3 * y;
	  X2$1 += z * (x0$3 + x);
	  Y2$1 += z * (y0$3 + y);
	  Z2$1 += z * 3;
	  centroidPoint$1(x0$3 = x, y0$3 = y);
	}
	
	function PathContext(context) {
	  this._context = context;
	}
	
	PathContext.prototype = {
	  _radius: 4.5,
	  pointRadius: function(_) {
	    return this._radius = _, this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._context.closePath();
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._context.moveTo(x, y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._context.lineTo(x, y);
	        break;
	      }
	      default: {
	        this._context.moveTo(x + this._radius, y);
	        this._context.arc(x, y, this._radius, 0, tau);
	        break;
	      }
	    }
	  },
	  result: noop
	};
	
	function PathString() {
	  this._string = [];
	}
	
	PathString.prototype = {
	  _circle: circle$1(4.5),
	  pointRadius: function(_) {
	    return this._circle = circle$1(_), this;
	  },
	  polygonStart: function() {
	    this._line = 0;
	  },
	  polygonEnd: function() {
	    this._line = NaN;
	  },
	  lineStart: function() {
	    this._point = 0;
	  },
	  lineEnd: function() {
	    if (this._line === 0) this._string.push("Z");
	    this._point = NaN;
	  },
	  point: function(x, y) {
	    switch (this._point) {
	      case 0: {
	        this._string.push("M", x, ",", y);
	        this._point = 1;
	        break;
	      }
	      case 1: {
	        this._string.push("L", x, ",", y);
	        break;
	      }
	      default: {
	        this._string.push("M", x, ",", y, this._circle);
	        break;
	      }
	    }
	  },
	  result: function() {
	    if (this._string.length) {
	      var result = this._string.join("");
	      this._string = [];
	      return result;
	    }
	  }
	};
	
	function circle$1(radius) {
	  return "m0," + radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + -2 * radius
	      + "a" + radius + "," + radius + " 0 1,1 0," + 2 * radius
	      + "z";
	}
	
	var index = function() {
	  var pointRadius = 4.5,
	      projection,
	      projectionStream,
	      context,
	      contextStream;
	
	  function path(object) {
	    if (object) {
	      if (typeof pointRadius === "function") contextStream.pointRadius(+pointRadius.apply(this, arguments));
	      geoStream(object, projectionStream(contextStream));
	    }
	    return contextStream.result();
	  }
	
	  path.area = function(object) {
	    geoStream(object, projectionStream(areaStream$1));
	    return areaStream$1.result();
	  };
	
	  path.bounds = function(object) {
	    geoStream(object, projectionStream(boundsStream$1));
	    return boundsStream$1.result();
	  };
	
	  path.centroid = function(object) {
	    geoStream(object, projectionStream(centroidStream$1));
	    return centroidStream$1.result();
	  };
	
	  path.projection = function(_) {
	    return arguments.length ? (projectionStream = (projection = _) == null ? identity : _.stream, path) : projection;
	  };
	
	  path.context = function(_) {
	    if (!arguments.length) return context;
	    contextStream = (context = _) == null ? new PathString : new PathContext(_);
	    if (typeof pointRadius !== "function") contextStream.pointRadius(pointRadius);
	    return path;
	  };
	
	  path.pointRadius = function(_) {
	    if (!arguments.length) return pointRadius;
	    pointRadius = typeof _ === "function" ? _ : (contextStream.pointRadius(+_), +_);
	    return path;
	  };
	
	  return path.projection(null).context(null);
	};
	
	var sum = adder();
	
	var polygonContains = function(polygon, point) {
	  var lambda = point[0],
	      phi = point[1],
	      normal = [sin(lambda), -cos(lambda), 0],
	      angle = 0,
	      winding = 0;
	
	  sum.reset();
	
	  for (var i = 0, n = polygon.length; i < n; ++i) {
	    if (!(m = (ring = polygon[i]).length)) continue;
	    var ring,
	        m,
	        point0 = ring[m - 1],
	        lambda0 = point0[0],
	        phi0 = point0[1] / 2 + quarterPi,
	        sinPhi0 = sin(phi0),
	        cosPhi0 = cos(phi0);
	
	    for (var j = 0; j < m; ++j, lambda0 = lambda1, sinPhi0 = sinPhi1, cosPhi0 = cosPhi1, point0 = point1) {
	      var point1 = ring[j],
	          lambda1 = point1[0],
	          phi1 = point1[1] / 2 + quarterPi,
	          sinPhi1 = sin(phi1),
	          cosPhi1 = cos(phi1),
	          delta = lambda1 - lambda0,
	          sign$$1 = delta >= 0 ? 1 : -1,
	          absDelta = sign$$1 * delta,
	          antimeridian = absDelta > pi,
	          k = sinPhi0 * sinPhi1;
	
	      sum.add(atan2(k * sign$$1 * sin(absDelta), cosPhi0 * cosPhi1 + k * cos(absDelta)));
	      angle += antimeridian ? delta + sign$$1 * tau : delta;
	
	      // Are the longitudes either side of the point’s meridian (lambda),
	      // and are the latitudes smaller than the parallel (phi)?
	      if (antimeridian ^ lambda0 >= lambda ^ lambda1 >= lambda) {
	        var arc = cartesianCross(cartesian(point0), cartesian(point1));
	        cartesianNormalizeInPlace(arc);
	        var intersection = cartesianCross(normal, arc);
	        cartesianNormalizeInPlace(intersection);
	        var phiArc = (antimeridian ^ delta >= 0 ? -1 : 1) * asin(intersection[2]);
	        if (phi > phiArc || phi === phiArc && (arc[0] || arc[1])) {
	          winding += antimeridian ^ delta >= 0 ? 1 : -1;
	        }
	      }
	    }
	  }
	
	  // First, determine whether the South pole is inside or outside:
	  //
	  // It is inside if:
	  // * the polygon winds around it in a clockwise direction.
	  // * the polygon does not (cumulatively) wind around it, but has a negative
	  //   (counter-clockwise) area.
	  //
	  // Second, count the (signed) number of times a segment crosses a lambda
	  // from the point to the South pole.  If it is zero, then the point is the
	  // same side as the South pole.
	
	  return (angle < -epsilon || angle < epsilon && sum < -epsilon) ^ (winding & 1);
	};
	
	var clip = function(pointVisible, clipLine, interpolate, start) {
	  return function(rotate, sink) {
	    var line = clipLine(sink),
	        rotatedStart = rotate.invert(start[0], start[1]),
	        ringBuffer = clipBuffer(),
	        ringSink = clipLine(ringBuffer),
	        polygonStarted = false,
	        polygon,
	        segments,
	        ring;
	
	    var clip = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() {
	        clip.point = pointRing;
	        clip.lineStart = ringStart;
	        clip.lineEnd = ringEnd;
	        segments = [];
	        polygon = [];
	      },
	      polygonEnd: function() {
	        clip.point = point;
	        clip.lineStart = lineStart;
	        clip.lineEnd = lineEnd;
	        segments = d3Array.merge(segments);
	        var startInside = polygonContains(polygon, rotatedStart);
	        if (segments.length) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          clipPolygon(segments, compareIntersection, startInside, interpolate, sink);
	        } else if (startInside) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          interpolate(null, null, 1, sink);
	          sink.lineEnd();
	        }
	        if (polygonStarted) sink.polygonEnd(), polygonStarted = false;
	        segments = polygon = null;
	      },
	      sphere: function() {
	        sink.polygonStart();
	        sink.lineStart();
	        interpolate(null, null, 1, sink);
	        sink.lineEnd();
	        sink.polygonEnd();
	      }
	    };
	
	    function point(lambda, phi) {
	      var point = rotate(lambda, phi);
	      if (pointVisible(lambda = point[0], phi = point[1])) sink.point(lambda, phi);
	    }
	
	    function pointLine(lambda, phi) {
	      var point = rotate(lambda, phi);
	      line.point(point[0], point[1]);
	    }
	
	    function lineStart() {
	      clip.point = pointLine;
	      line.lineStart();
	    }
	
	    function lineEnd() {
	      clip.point = point;
	      line.lineEnd();
	    }
	
	    function pointRing(lambda, phi) {
	      ring.push([lambda, phi]);
	      var point = rotate(lambda, phi);
	      ringSink.point(point[0], point[1]);
	    }
	
	    function ringStart() {
	      ringSink.lineStart();
	      ring = [];
	    }
	
	    function ringEnd() {
	      pointRing(ring[0][0], ring[0][1]);
	      ringSink.lineEnd();
	
	      var clean = ringSink.clean(),
	          ringSegments = ringBuffer.result(),
	          i, n = ringSegments.length, m,
	          segment,
	          point;
	
	      ring.pop();
	      polygon.push(ring);
	      ring = null;
	
	      if (!n) return;
	
	      // No intersections.
	      if (clean & 1) {
	        segment = ringSegments[0];
	        if ((m = segment.length - 1) > 0) {
	          if (!polygonStarted) sink.polygonStart(), polygonStarted = true;
	          sink.lineStart();
	          for (i = 0; i < m; ++i) sink.point((point = segment[i])[0], point[1]);
	          sink.lineEnd();
	        }
	        return;
	      }
	
	      // Rejoin connected segments.
	      // TODO reuse ringBuffer.rejoin()?
	      if (n > 1 && clean & 2) ringSegments.push(ringSegments.pop().concat(ringSegments.shift()));
	
	      segments.push(ringSegments.filter(validSegment));
	    }
	
	    return clip;
	  };
	};
	
	function validSegment(segment) {
	  return segment.length > 1;
	}
	
	// Intersections are sorted along the clip edge. For both antimeridian cutting
	// and circle clipping, the same comparison is used.
	function compareIntersection(a, b) {
	  return ((a = a.x)[0] < 0 ? a[1] - halfPi - epsilon : halfPi - a[1])
	       - ((b = b.x)[0] < 0 ? b[1] - halfPi - epsilon : halfPi - b[1]);
	}
	
	var clipAntimeridian = clip(
	  function() { return true; },
	  clipAntimeridianLine,
	  clipAntimeridianInterpolate,
	  [-pi, -halfPi]
	);
	
	// Takes a line and cuts into visible segments. Return values: 0 - there were
	// intersections or the line was empty; 1 - no intersections; 2 - there were
	// intersections, and the first and last segments should be rejoined.
	function clipAntimeridianLine(stream) {
	  var lambda0 = NaN,
	      phi0 = NaN,
	      sign0 = NaN,
	      clean; // no intersections
	
	  return {
	    lineStart: function() {
	      stream.lineStart();
	      clean = 1;
	    },
	    point: function(lambda1, phi1) {
	      var sign1 = lambda1 > 0 ? pi : -pi,
	          delta = abs(lambda1 - lambda0);
	      if (abs(delta - pi) < epsilon) { // line crosses a pole
	        stream.point(lambda0, phi0 = (phi0 + phi1) / 2 > 0 ? halfPi : -halfPi);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        stream.point(lambda1, phi0);
	        clean = 0;
	      } else if (sign0 !== sign1 && delta >= pi) { // line crosses antimeridian
	        if (abs(lambda0 - sign0) < epsilon) lambda0 -= sign0 * epsilon; // handle degeneracies
	        if (abs(lambda1 - sign1) < epsilon) lambda1 -= sign1 * epsilon;
	        phi0 = clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1);
	        stream.point(sign0, phi0);
	        stream.lineEnd();
	        stream.lineStart();
	        stream.point(sign1, phi0);
	        clean = 0;
	      }
	      stream.point(lambda0 = lambda1, phi0 = phi1);
	      sign0 = sign1;
	    },
	    lineEnd: function() {
	      stream.lineEnd();
	      lambda0 = phi0 = NaN;
	    },
	    clean: function() {
	      return 2 - clean; // if intersections, rejoin first and last segments
	    }
	  };
	}
	
	function clipAntimeridianIntersect(lambda0, phi0, lambda1, phi1) {
	  var cosPhi0,
	      cosPhi1,
	      sinLambda0Lambda1 = sin(lambda0 - lambda1);
	  return abs(sinLambda0Lambda1) > epsilon
	      ? atan((sin(phi0) * (cosPhi1 = cos(phi1)) * sin(lambda1)
	          - sin(phi1) * (cosPhi0 = cos(phi0)) * sin(lambda0))
	          / (cosPhi0 * cosPhi1 * sinLambda0Lambda1))
	      : (phi0 + phi1) / 2;
	}
	
	function clipAntimeridianInterpolate(from, to, direction, stream) {
	  var phi;
	  if (from == null) {
	    phi = direction * halfPi;
	    stream.point(-pi, phi);
	    stream.point(0, phi);
	    stream.point(pi, phi);
	    stream.point(pi, 0);
	    stream.point(pi, -phi);
	    stream.point(0, -phi);
	    stream.point(-pi, -phi);
	    stream.point(-pi, 0);
	    stream.point(-pi, phi);
	  } else if (abs(from[0] - to[0]) > epsilon) {
	    var lambda = from[0] < to[0] ? pi : -pi;
	    phi = direction * lambda / 2;
	    stream.point(-lambda, phi);
	    stream.point(0, phi);
	    stream.point(lambda, phi);
	  } else {
	    stream.point(to[0], to[1]);
	  }
	}
	
	var clipCircle = function(radius, delta) {
	  var cr = cos(radius),
	      smallRadius = cr > 0,
	      notHemisphere = abs(cr) > epsilon; // TODO optimise for this common case
	
	  function interpolate(from, to, direction, stream) {
	    circleStream(stream, radius, delta, direction, from, to);
	  }
	
	  function visible(lambda, phi) {
	    return cos(lambda) * cos(phi) > cr;
	  }
	
	  // Takes a line and cuts into visible segments. Return values used for polygon
	  // clipping: 0 - there were intersections or the line was empty; 1 - no
	  // intersections 2 - there were intersections, and the first and last segments
	  // should be rejoined.
	  function clipLine(stream) {
	    var point0, // previous point
	        c0, // code for previous point
	        v0, // visibility of previous point
	        v00, // visibility of first point
	        clean; // no intersections
	    return {
	      lineStart: function() {
	        v00 = v0 = false;
	        clean = 1;
	      },
	      point: function(lambda, phi) {
	        var point1 = [lambda, phi],
	            point2,
	            v = visible(lambda, phi),
	            c = smallRadius
	              ? v ? 0 : code(lambda, phi)
	              : v ? code(lambda + (lambda < 0 ? pi : -pi), phi) : 0;
	        if (!point0 && (v00 = v0 = v)) stream.lineStart();
	        // Handle degeneracies.
	        // TODO ignore if not clipping polygons.
	        if (v !== v0) {
	          point2 = intersect(point0, point1);
	          if (pointEqual(point0, point2) || pointEqual(point1, point2)) {
	            point1[0] += epsilon;
	            point1[1] += epsilon;
	            v = visible(point1[0], point1[1]);
	          }
	        }
	        if (v !== v0) {
	          clean = 0;
	          if (v) {
	            // outside going in
	            stream.lineStart();
	            point2 = intersect(point1, point0);
	            stream.point(point2[0], point2[1]);
	          } else {
	            // inside going out
	            point2 = intersect(point0, point1);
	            stream.point(point2[0], point2[1]);
	            stream.lineEnd();
	          }
	          point0 = point2;
	        } else if (notHemisphere && point0 && smallRadius ^ v) {
	          var t;
	          // If the codes for two points are different, or are both zero,
	          // and there this segment intersects with the small circle.
	          if (!(c & c0) && (t = intersect(point1, point0, true))) {
	            clean = 0;
	            if (smallRadius) {
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	            } else {
	              stream.point(t[1][0], t[1][1]);
	              stream.lineEnd();
	              stream.lineStart();
	              stream.point(t[0][0], t[0][1]);
	            }
	          }
	        }
	        if (v && (!point0 || !pointEqual(point0, point1))) {
	          stream.point(point1[0], point1[1]);
	        }
	        point0 = point1, v0 = v, c0 = c;
	      },
	      lineEnd: function() {
	        if (v0) stream.lineEnd();
	        point0 = null;
	      },
	      // Rejoin first and last segments if there were intersections and the first
	      // and last points were visible.
	      clean: function() {
	        return clean | ((v00 && v0) << 1);
	      }
	    };
	  }
	
	  // Intersects the great circle between a and b with the clip circle.
	  function intersect(a, b, two) {
	    var pa = cartesian(a),
	        pb = cartesian(b);
	
	    // We have two planes, n1.p = d1 and n2.p = d2.
	    // Find intersection line p(t) = c1 n1 + c2 n2 + t (n1 ⨯ n2).
	    var n1 = [1, 0, 0], // normal
	        n2 = cartesianCross(pa, pb),
	        n2n2 = cartesianDot(n2, n2),
	        n1n2 = n2[0], // cartesianDot(n1, n2),
	        determinant = n2n2 - n1n2 * n1n2;
	
	    // Two polar points.
	    if (!determinant) return !two && a;
	
	    var c1 =  cr * n2n2 / determinant,
	        c2 = -cr * n1n2 / determinant,
	        n1xn2 = cartesianCross(n1, n2),
	        A = cartesianScale(n1, c1),
	        B = cartesianScale(n2, c2);
	    cartesianAddInPlace(A, B);
	
	    // Solve |p(t)|^2 = 1.
	    var u = n1xn2,
	        w = cartesianDot(A, u),
	        uu = cartesianDot(u, u),
	        t2 = w * w - uu * (cartesianDot(A, A) - 1);
	
	    if (t2 < 0) return;
	
	    var t = sqrt(t2),
	        q = cartesianScale(u, (-w - t) / uu);
	    cartesianAddInPlace(q, A);
	    q = spherical(q);
	
	    if (!two) return q;
	
	    // Two intersection points.
	    var lambda0 = a[0],
	        lambda1 = b[0],
	        phi0 = a[1],
	        phi1 = b[1],
	        z;
	
	    if (lambda1 < lambda0) z = lambda0, lambda0 = lambda1, lambda1 = z;
	
	    var delta = lambda1 - lambda0,
	        polar = abs(delta - pi) < epsilon,
	        meridian = polar || delta < epsilon;
	
	    if (!polar && phi1 < phi0) z = phi0, phi0 = phi1, phi1 = z;
	
	    // Check that the first point is between a and b.
	    if (meridian
	        ? polar
	          ? phi0 + phi1 > 0 ^ q[1] < (abs(q[0] - lambda0) < epsilon ? phi0 : phi1)
	          : phi0 <= q[1] && q[1] <= phi1
	        : delta > pi ^ (lambda0 <= q[0] && q[0] <= lambda1)) {
	      var q1 = cartesianScale(u, (-w + t) / uu);
	      cartesianAddInPlace(q1, A);
	      return [q, spherical(q1)];
	    }
	  }
	
	  // Generates a 4-bit vector representing the location of a point relative to
	  // the small circle's bounding box.
	  function code(lambda, phi) {
	    var r = smallRadius ? radius : pi - radius,
	        code = 0;
	    if (lambda < -r) code |= 1; // left
	    else if (lambda > r) code |= 2; // right
	    if (phi < -r) code |= 4; // below
	    else if (phi > r) code |= 8; // above
	    return code;
	  }
	
	  return clip(visible, clipLine, interpolate, smallRadius ? [0, -radius] : [-pi, radius - pi]);
	};
	
	var transform = function(prototype) {
	  return {
	    stream: transform$1(prototype)
	  };
	};
	
	function transform$1(prototype) {
	  function T() {}
	  var p = T.prototype = Object.create(Transform.prototype);
	  for (var k in prototype) p[k] = prototype[k];
	  return function(stream) {
	    var t = new T;
	    t.stream = stream;
	    return t;
	  };
	}
	
	function Transform() {}
	
	Transform.prototype = {
	  point: function(x, y) { this.stream.point(x, y); },
	  sphere: function() { this.stream.sphere(); },
	  lineStart: function() { this.stream.lineStart(); },
	  lineEnd: function() { this.stream.lineEnd(); },
	  polygonStart: function() { this.stream.polygonStart(); },
	  polygonEnd: function() { this.stream.polygonEnd(); }
	};
	
	function fit(project, extent, object) {
	  var w = extent[1][0] - extent[0][0],
	      h = extent[1][1] - extent[0][1],
	      clip = project.clipExtent && project.clipExtent();
	
	  project
	      .scale(150)
	      .translate([0, 0]);
	
	  if (clip != null) project.clipExtent(null);
	
	  geoStream(object, project.stream(boundsStream$1));
	
	  var b = boundsStream$1.result(),
	      k = Math.min(w / (b[1][0] - b[0][0]), h / (b[1][1] - b[0][1])),
	      x = +extent[0][0] + (w - k * (b[1][0] + b[0][0])) / 2,
	      y = +extent[0][1] + (h - k * (b[1][1] + b[0][1])) / 2;
	
	  if (clip != null) project.clipExtent(clip);
	
	  return project
	      .scale(k * 150)
	      .translate([x, y]);
	}
	
	function fitSize(project) {
	  return function(size, object) {
	    return fit(project, [[0, 0], size], object);
	  };
	}
	
	function fitExtent(project) {
	  return function(extent, object) {
	    return fit(project, extent, object);
	  };
	}
	
	var maxDepth = 16;
	var cosMinDistance = cos(30 * radians); // cos(minimum angular distance)
	
	var resample = function(project, delta2) {
	  return +delta2 ? resample$1(project, delta2) : resampleNone(project);
	};
	
	function resampleNone(project) {
	  return transform$1({
	    point: function(x, y) {
	      x = project(x, y);
	      this.stream.point(x[0], x[1]);
	    }
	  });
	}
	
	function resample$1(project, delta2) {
	
	  function resampleLineTo(x0, y0, lambda0, a0, b0, c0, x1, y1, lambda1, a1, b1, c1, depth, stream) {
	    var dx = x1 - x0,
	        dy = y1 - y0,
	        d2 = dx * dx + dy * dy;
	    if (d2 > 4 * delta2 && depth--) {
	      var a = a0 + a1,
	          b = b0 + b1,
	          c = c0 + c1,
	          m = sqrt(a * a + b * b + c * c),
	          phi2 = asin(c /= m),
	          lambda2 = abs(abs(c) - 1) < epsilon || abs(lambda0 - lambda1) < epsilon ? (lambda0 + lambda1) / 2 : atan2(b, a),
	          p = project(lambda2, phi2),
	          x2 = p[0],
	          y2 = p[1],
	          dx2 = x2 - x0,
	          dy2 = y2 - y0,
	          dz = dy * dx2 - dx * dy2;
	      if (dz * dz / d2 > delta2 // perpendicular projected distance
	          || abs((dx * dx2 + dy * dy2) / d2 - 0.5) > 0.3 // midpoint close to an end
	          || a0 * a1 + b0 * b1 + c0 * c1 < cosMinDistance) { // angular distance
	        resampleLineTo(x0, y0, lambda0, a0, b0, c0, x2, y2, lambda2, a /= m, b /= m, c, depth, stream);
	        stream.point(x2, y2);
	        resampleLineTo(x2, y2, lambda2, a, b, c, x1, y1, lambda1, a1, b1, c1, depth, stream);
	      }
	    }
	  }
	  return function(stream) {
	    var lambda00, x00, y00, a00, b00, c00, // first point
	        lambda0, x0, y0, a0, b0, c0; // previous point
	
	    var resampleStream = {
	      point: point,
	      lineStart: lineStart,
	      lineEnd: lineEnd,
	      polygonStart: function() { stream.polygonStart(); resampleStream.lineStart = ringStart; },
	      polygonEnd: function() { stream.polygonEnd(); resampleStream.lineStart = lineStart; }
	    };
	
	    function point(x, y) {
	      x = project(x, y);
	      stream.point(x[0], x[1]);
	    }
	
	    function lineStart() {
	      x0 = NaN;
	      resampleStream.point = linePoint;
	      stream.lineStart();
	    }
	
	    function linePoint(lambda, phi) {
	      var c = cartesian([lambda, phi]), p = project(lambda, phi);
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x0 = p[0], y0 = p[1], lambda0 = lambda, a0 = c[0], b0 = c[1], c0 = c[2], maxDepth, stream);
	      stream.point(x0, y0);
	    }
	
	    function lineEnd() {
	      resampleStream.point = point;
	      stream.lineEnd();
	    }
	
	    function ringStart() {
	      lineStart();
	      resampleStream.point = ringPoint;
	      resampleStream.lineEnd = ringEnd;
	    }
	
	    function ringPoint(lambda, phi) {
	      linePoint(lambda00 = lambda, phi), x00 = x0, y00 = y0, a00 = a0, b00 = b0, c00 = c0;
	      resampleStream.point = linePoint;
	    }
	
	    function ringEnd() {
	      resampleLineTo(x0, y0, lambda0, a0, b0, c0, x00, y00, lambda00, a00, b00, c00, maxDepth, stream);
	      resampleStream.lineEnd = lineEnd;
	      lineEnd();
	    }
	
	    return resampleStream;
	  };
	}
	
	var transformRadians = transform$1({
	  point: function(x, y) {
	    this.stream.point(x * radians, y * radians);
	  }
	});
	
	function projection(project) {
	  return projectionMutator(function() { return project; })();
	}
	
	function projectionMutator(projectAt) {
	  var project,
	      k = 150, // scale
	      x = 480, y = 250, // translate
	      dx, dy, lambda = 0, phi = 0, // center
	      deltaLambda = 0, deltaPhi = 0, deltaGamma = 0, rotate, projectRotate, // rotate
	      theta = null, preclip = clipAntimeridian, // clip angle
	      x0 = null, y0, x1, y1, postclip = identity, // clip extent
	      delta2 = 0.5, projectResample = resample(projectTransform, delta2), // precision
	      cache,
	      cacheStream;
	
	  function projection(point) {
	    point = projectRotate(point[0] * radians, point[1] * radians);
	    return [point[0] * k + dx, dy - point[1] * k];
	  }
	
	  function invert(point) {
	    point = projectRotate.invert((point[0] - dx) / k, (dy - point[1]) / k);
	    return point && [point[0] * degrees, point[1] * degrees];
	  }
	
	  function projectTransform(x, y) {
	    return x = project(x, y), [x[0] * k + dx, dy - x[1] * k];
	  }
	
	  projection.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = transformRadians(preclip(rotate, projectResample(postclip(cacheStream = stream))));
	  };
	
	  projection.clipAngle = function(_) {
	    return arguments.length ? (preclip = +_ ? clipCircle(theta = _ * radians, 6 * radians) : (theta = null, clipAntimeridian), reset()) : theta * degrees;
	  };
	
	  projection.clipExtent = function(_) {
	    return arguments.length ? (postclip = _ == null ? (x0 = y0 = x1 = y1 = null, identity) : clipExtent(x0 = +_[0][0], y0 = +_[0][1], x1 = +_[1][0], y1 = +_[1][1]), reset()) : x0 == null ? null : [[x0, y0], [x1, y1]];
	  };
	
	  projection.scale = function(_) {
	    return arguments.length ? (k = +_, recenter()) : k;
	  };
	
	  projection.translate = function(_) {
	    return arguments.length ? (x = +_[0], y = +_[1], recenter()) : [x, y];
	  };
	
	  projection.center = function(_) {
	    return arguments.length ? (lambda = _[0] % 360 * radians, phi = _[1] % 360 * radians, recenter()) : [lambda * degrees, phi * degrees];
	  };
	
	  projection.rotate = function(_) {
	    return arguments.length ? (deltaLambda = _[0] % 360 * radians, deltaPhi = _[1] % 360 * radians, deltaGamma = _.length > 2 ? _[2] % 360 * radians : 0, recenter()) : [deltaLambda * degrees, deltaPhi * degrees, deltaGamma * degrees];
	  };
	
	  projection.precision = function(_) {
	    return arguments.length ? (projectResample = resample(projectTransform, delta2 = _ * _), reset()) : sqrt(delta2);
	  };
	
	  projection.fitExtent = fitExtent(projection);
	
	  projection.fitSize = fitSize(projection);
	
	  function recenter() {
	    projectRotate = compose(rotate = rotateRadians(deltaLambda, deltaPhi, deltaGamma), project);
	    var center = project(lambda, phi);
	    dx = x - center[0] * k;
	    dy = y + center[1] * k;
	    return reset();
	  }
	
	  function reset() {
	    cache = cacheStream = null;
	    return projection;
	  }
	
	  return function() {
	    project = projectAt.apply(this, arguments);
	    projection.invert = project.invert && invert;
	    return recenter();
	  };
	}
	
	function conicProjection(projectAt) {
	  var phi0 = 0,
	      phi1 = pi / 3,
	      m = projectionMutator(projectAt),
	      p = m(phi0, phi1);
	
	  p.parallels = function(_) {
	    return arguments.length ? m(phi0 = _[0] * radians, phi1 = _[1] * radians) : [phi0 * degrees, phi1 * degrees];
	  };
	
	  return p;
	}
	
	function cylindricalEqualAreaRaw(phi0) {
	  var cosPhi0 = cos(phi0);
	
	  function forward(lambda, phi) {
	    return [lambda * cosPhi0, sin(phi) / cosPhi0];
	  }
	
	  forward.invert = function(x, y) {
	    return [x / cosPhi0, asin(y * cosPhi0)];
	  };
	
	  return forward;
	}
	
	function conicEqualAreaRaw(y0, y1) {
	  var sy0 = sin(y0), n = (sy0 + sin(y1)) / 2;
	
	  // Are the parallels symmetrical around the Equator?
	  if (abs(n) < epsilon) return cylindricalEqualAreaRaw(y0);
	
	  var c = 1 + sy0 * (2 * n - sy0), r0 = sqrt(c) / n;
	
	  function project(x, y) {
	    var r = sqrt(c - 2 * n * sin(y)) / n;
	    return [r * sin(x *= n), r0 - r * cos(x)];
	  }
	
	  project.invert = function(x, y) {
	    var r0y = r0 - y;
	    return [atan2(x, abs(r0y)) / n * sign(r0y), asin((c - (x * x + r0y * r0y) * n * n) / (2 * n))];
	  };
	
	  return project;
	}
	
	var conicEqualArea = function() {
	  return conicProjection(conicEqualAreaRaw)
	      .scale(155.424)
	      .center([0, 33.6442]);
	};
	
	var albers = function() {
	  return conicEqualArea()
	      .parallels([29.5, 45.5])
	      .scale(1070)
	      .translate([480, 250])
	      .rotate([96, 0])
	      .center([-0.6, 38.7]);
	};
	
	// The projections must have mutually exclusive clip regions on the sphere,
	// as this will avoid emitting interleaving lines and polygons.
	function multiplex(streams) {
	  var n = streams.length;
	  return {
	    point: function(x, y) { var i = -1; while (++i < n) streams[i].point(x, y); },
	    sphere: function() { var i = -1; while (++i < n) streams[i].sphere(); },
	    lineStart: function() { var i = -1; while (++i < n) streams[i].lineStart(); },
	    lineEnd: function() { var i = -1; while (++i < n) streams[i].lineEnd(); },
	    polygonStart: function() { var i = -1; while (++i < n) streams[i].polygonStart(); },
	    polygonEnd: function() { var i = -1; while (++i < n) streams[i].polygonEnd(); }
	  };
	}
	
	// A composite projection for the United States, configured by default for
	// 960×500. The projection also works quite well at 960×600 if you change the
	// scale to 1285 and adjust the translate accordingly. The set of standard
	// parallels for each region comes from USGS, which is published here:
	// http://egsc.usgs.gov/isb/pubs/MapProjections/projections.html#albers
	var albersUsa = function() {
	  var cache,
	      cacheStream,
	      lower48 = albers(), lower48Point,
	      alaska = conicEqualArea().rotate([154, 0]).center([-2, 58.5]).parallels([55, 65]), alaskaPoint, // EPSG:3338
	      hawaii = conicEqualArea().rotate([157, 0]).center([-3, 19.9]).parallels([8, 18]), hawaiiPoint, // ESRI:102007
	      point, pointStream = {point: function(x, y) { point = [x, y]; }};
	
	  function albersUsa(coordinates) {
	    var x = coordinates[0], y = coordinates[1];
	    return point = null,
	        (lower48Point.point(x, y), point)
	        || (alaskaPoint.point(x, y), point)
	        || (hawaiiPoint.point(x, y), point);
	  }
	
	  albersUsa.invert = function(coordinates) {
	    var k = lower48.scale(),
	        t = lower48.translate(),
	        x = (coordinates[0] - t[0]) / k,
	        y = (coordinates[1] - t[1]) / k;
	    return (y >= 0.120 && y < 0.234 && x >= -0.425 && x < -0.214 ? alaska
	        : y >= 0.166 && y < 0.234 && x >= -0.214 && x < -0.115 ? hawaii
	        : lower48).invert(coordinates);
	  };
	
	  albersUsa.stream = function(stream) {
	    return cache && cacheStream === stream ? cache : cache = multiplex([lower48.stream(cacheStream = stream), alaska.stream(stream), hawaii.stream(stream)]);
	  };
	
	  albersUsa.precision = function(_) {
	    if (!arguments.length) return lower48.precision();
	    lower48.precision(_), alaska.precision(_), hawaii.precision(_);
	    return reset();
	  };
	
	  albersUsa.scale = function(_) {
	    if (!arguments.length) return lower48.scale();
	    lower48.scale(_), alaska.scale(_ * 0.35), hawaii.scale(_);
	    return albersUsa.translate(lower48.translate());
	  };
	
	  albersUsa.translate = function(_) {
	    if (!arguments.length) return lower48.translate();
	    var k = lower48.scale(), x = +_[0], y = +_[1];
	
	    lower48Point = lower48
	        .translate(_)
	        .clipExtent([[x - 0.455 * k, y - 0.238 * k], [x + 0.455 * k, y + 0.238 * k]])
	        .stream(pointStream);
	
	    alaskaPoint = alaska
	        .translate([x - 0.307 * k, y + 0.201 * k])
	        .clipExtent([[x - 0.425 * k + epsilon, y + 0.120 * k + epsilon], [x - 0.214 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    hawaiiPoint = hawaii
	        .translate([x - 0.205 * k, y + 0.212 * k])
	        .clipExtent([[x - 0.214 * k + epsilon, y + 0.166 * k + epsilon], [x - 0.115 * k - epsilon, y + 0.234 * k - epsilon]])
	        .stream(pointStream);
	
	    return reset();
	  };
	
	  albersUsa.fitExtent = fitExtent(albersUsa);
	
	  albersUsa.fitSize = fitSize(albersUsa);
	
	  function reset() {
	    cache = cacheStream = null;
	    return albersUsa;
	  }
	
	  return albersUsa.scale(1070);
	};
	
	function azimuthalRaw(scale) {
	  return function(x, y) {
	    var cx = cos(x),
	        cy = cos(y),
	        k = scale(cx * cy);
	    return [
	      k * cy * sin(x),
	      k * sin(y)
	    ];
	  }
	}
	
	function azimuthalInvert(angle) {
	  return function(x, y) {
	    var z = sqrt(x * x + y * y),
	        c = angle(z),
	        sc = sin(c),
	        cc = cos(c);
	    return [
	      atan2(x * sc, z * cc),
	      asin(z && y * sc / z)
	    ];
	  }
	}
	
	var azimuthalEqualAreaRaw = azimuthalRaw(function(cxcy) {
	  return sqrt(2 / (1 + cxcy));
	});
	
	azimuthalEqualAreaRaw.invert = azimuthalInvert(function(z) {
	  return 2 * asin(z / 2);
	});
	
	var azimuthalEqualArea = function() {
	  return projection(azimuthalEqualAreaRaw)
	      .scale(124.75)
	      .clipAngle(180 - 1e-3);
	};
	
	var azimuthalEquidistantRaw = azimuthalRaw(function(c) {
	  return (c = acos(c)) && c / sin(c);
	});
	
	azimuthalEquidistantRaw.invert = azimuthalInvert(function(z) {
	  return z;
	});
	
	var azimuthalEquidistant = function() {
	  return projection(azimuthalEquidistantRaw)
	      .scale(79.4188)
	      .clipAngle(180 - 1e-3);
	};
	
	function mercatorRaw(lambda, phi) {
	  return [lambda, log(tan((halfPi + phi) / 2))];
	}
	
	mercatorRaw.invert = function(x, y) {
	  return [x, 2 * atan(exp(y)) - halfPi];
	};
	
	var mercator = function() {
	  return mercatorProjection(mercatorRaw)
	      .scale(961 / tau);
	};
	
	function mercatorProjection(project) {
	  var m = projection(project),
	      scale = m.scale,
	      translate = m.translate,
	      clipExtent = m.clipExtent,
	      clipAuto;
	
	  m.scale = function(_) {
	    return arguments.length ? (scale(_), clipAuto && m.clipExtent(null), m) : scale();
	  };
	
	  m.translate = function(_) {
	    return arguments.length ? (translate(_), clipAuto && m.clipExtent(null), m) : translate();
	  };
	
	  m.clipExtent = function(_) {
	    if (!arguments.length) return clipAuto ? null : clipExtent();
	    if (clipAuto = _ == null) {
	      var k = pi * scale(),
	          t = translate();
	      _ = [[t[0] - k, t[1] - k], [t[0] + k, t[1] + k]];
	    }
	    clipExtent(_);
	    return m;
	  };
	
	  return m.clipExtent(null);
	}
	
	function tany(y) {
	  return tan((halfPi + y) / 2);
	}
	
	function conicConformalRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : log(cy0 / cos(y1)) / log(tany(y1) / tany(y0)),
	      f = cy0 * pow(tany(y0), n) / n;
	
	  if (!n) return mercatorRaw;
	
	  function project(x, y) {
	    if (f > 0) { if (y < -halfPi + epsilon) y = -halfPi + epsilon; }
	    else { if (y > halfPi - epsilon) y = halfPi - epsilon; }
	    var r = f / pow(tany(y), n);
	    return [r * sin(n * x), f - r * cos(n * x)];
	  }
	
	  project.invert = function(x, y) {
	    var fy = f - y, r = sign(n) * sqrt(x * x + fy * fy);
	    return [atan2(x, abs(fy)) / n * sign(fy), 2 * atan(pow(f / r, 1 / n)) - halfPi];
	  };
	
	  return project;
	}
	
	var conicConformal = function() {
	  return conicProjection(conicConformalRaw)
	      .scale(109.5)
	      .parallels([30, 30]);
	};
	
	function equirectangularRaw(lambda, phi) {
	  return [lambda, phi];
	}
	
	equirectangularRaw.invert = equirectangularRaw;
	
	var equirectangular = function() {
	  return projection(equirectangularRaw)
	      .scale(152.63);
	};
	
	function conicEquidistantRaw(y0, y1) {
	  var cy0 = cos(y0),
	      n = y0 === y1 ? sin(y0) : (cy0 - cos(y1)) / (y1 - y0),
	      g = cy0 / n + y0;
	
	  if (abs(n) < epsilon) return equirectangularRaw;
	
	  function project(x, y) {
	    var gy = g - y, nx = n * x;
	    return [gy * sin(nx), g - gy * cos(nx)];
	  }
	
	  project.invert = function(x, y) {
	    var gy = g - y;
	    return [atan2(x, abs(gy)) / n * sign(gy), g - sign(n) * sqrt(x * x + gy * gy)];
	  };
	
	  return project;
	}
	
	var conicEquidistant = function() {
	  return conicProjection(conicEquidistantRaw)
	      .scale(131.154)
	      .center([0, 13.9389]);
	};
	
	function gnomonicRaw(x, y) {
	  var cy = cos(y), k = cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	gnomonicRaw.invert = azimuthalInvert(atan);
	
	var gnomonic = function() {
	  return projection(gnomonicRaw)
	      .scale(144.049)
	      .clipAngle(60);
	};
	
	function orthographicRaw(x, y) {
	  return [cos(y) * sin(x), sin(y)];
	}
	
	orthographicRaw.invert = azimuthalInvert(asin);
	
	var orthographic = function() {
	  return projection(orthographicRaw)
	      .scale(249.5)
	      .clipAngle(90 + epsilon);
	};
	
	function stereographicRaw(x, y) {
	  var cy = cos(y), k = 1 + cos(x) * cy;
	  return [cy * sin(x) / k, sin(y) / k];
	}
	
	stereographicRaw.invert = azimuthalInvert(function(z) {
	  return 2 * atan(z);
	});
	
	var stereographic = function() {
	  return projection(stereographicRaw)
	      .scale(250)
	      .clipAngle(142);
	};
	
	function transverseMercatorRaw(lambda, phi) {
	  return [log(tan((halfPi + phi) / 2)), -lambda];
	}
	
	transverseMercatorRaw.invert = function(x, y) {
	  return [-y, 2 * atan(exp(x)) - halfPi];
	};
	
	var transverseMercator = function() {
	  var m = mercatorProjection(transverseMercatorRaw),
	      center = m.center,
	      rotate = m.rotate;
	
	  m.center = function(_) {
	    return arguments.length ? center([-_[1], _[0]]) : (_ = center(), [_[1], -_[0]]);
	  };
	
	  m.rotate = function(_) {
	    return arguments.length ? rotate([_[0], _[1], _.length > 2 ? _[2] + 90 : 90]) : (_ = rotate(), [_[0], _[1], _[2] - 90]);
	  };
	
	  return rotate([0, 0, 90])
	      .scale(159.155);
	};
	
	exports.geoArea = area;
	exports.geoBounds = bounds;
	exports.geoCentroid = centroid;
	exports.geoCircle = circle;
	exports.geoClipExtent = extent;
	exports.geoDistance = distance;
	exports.geoGraticule = graticule;
	exports.geoInterpolate = interpolate;
	exports.geoLength = length;
	exports.geoPath = index;
	exports.geoAlbers = albers;
	exports.geoAlbersUsa = albersUsa;
	exports.geoAzimuthalEqualArea = azimuthalEqualArea;
	exports.geoAzimuthalEqualAreaRaw = azimuthalEqualAreaRaw;
	exports.geoAzimuthalEquidistant = azimuthalEquidistant;
	exports.geoAzimuthalEquidistantRaw = azimuthalEquidistantRaw;
	exports.geoConicConformal = conicConformal;
	exports.geoConicConformalRaw = conicConformalRaw;
	exports.geoConicEqualArea = conicEqualArea;
	exports.geoConicEqualAreaRaw = conicEqualAreaRaw;
	exports.geoConicEquidistant = conicEquidistant;
	exports.geoConicEquidistantRaw = conicEquidistantRaw;
	exports.geoEquirectangular = equirectangular;
	exports.geoEquirectangularRaw = equirectangularRaw;
	exports.geoGnomonic = gnomonic;
	exports.geoGnomonicRaw = gnomonicRaw;
	exports.geoProjection = projection;
	exports.geoProjectionMutator = projectionMutator;
	exports.geoMercator = mercator;
	exports.geoMercatorRaw = mercatorRaw;
	exports.geoOrthographic = orthographic;
	exports.geoOrthographicRaw = orthographicRaw;
	exports.geoStereographic = stereographic;
	exports.geoStereographicRaw = stereographicRaw;
	exports.geoTransverseMercator = transverseMercator;
	exports.geoTransverseMercatorRaw = transverseMercatorRaw;
	exports.geoRotation = rotation;
	exports.geoStream = geoStream;
	exports.geoTransform = transform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 176 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time/ v1.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var t0 = new Date,
	    t1 = new Date;
	
	function newInterval(floori, offseti, count, field) {
	
	  function interval(date) {
	    return floori(date = arguments.length === 0 ? new Date : new Date(+date)), date;
	  }
	
	  interval.floor = function(date) {
	    return floori(date = new Date(+date)), date;
	  };
	
	  interval.ceil = function(date) {
	    return floori(date = new Date(date - 1)), offseti(date, 1), floori(date), date;
	  };
	
	  interval.round = function(date) {
	    var d0 = interval(date),
	        d1 = interval.ceil(date);
	    return date - d0 < d1 - date ? d0 : d1;
	  };
	
	  interval.offset = function(date, step) {
	    return offseti(date = new Date(+date), step == null ? 1 : Math.floor(step)), date;
	  };
	
	  interval.range = function(start, stop, step) {
	    var range = [], previous;
	    start = interval.ceil(start);
	    step = step == null ? 1 : Math.floor(step);
	    if (!(start < stop) || !(step > 0)) return range; // also handles Invalid Date
	    do range.push(previous = new Date(+start)), offseti(start, step), floori(start);
	    while (previous < start && start < stop);
	    return range;
	  };
	
	  interval.filter = function(test) {
	    return newInterval(function(date) {
	      if (date >= date) while (floori(date), !test(date)) date.setTime(date - 1);
	    }, function(date, step) {
	      if (date >= date) {
	        if (step < 0) while (++step <= 0) {
	          while (offseti(date, -1), !test(date)) {} // eslint-disable-line no-empty
	        } else while (--step >= 0) {
	          while (offseti(date, +1), !test(date)) {} // eslint-disable-line no-empty
	        }
	      }
	    });
	  };
	
	  if (count) {
	    interval.count = function(start, end) {
	      t0.setTime(+start), t1.setTime(+end);
	      floori(t0), floori(t1);
	      return Math.floor(count(t0, t1));
	    };
	
	    interval.every = function(step) {
	      step = Math.floor(step);
	      return !isFinite(step) || !(step > 0) ? null
	          : !(step > 1) ? interval
	          : interval.filter(field
	              ? function(d) { return field(d) % step === 0; }
	              : function(d) { return interval.count(0, d) % step === 0; });
	    };
	  }
	
	  return interval;
	}
	
	var millisecond = newInterval(function() {
	  // noop
	}, function(date, step) {
	  date.setTime(+date + step);
	}, function(start, end) {
	  return end - start;
	});
	
	// An optimized implementation for this simple case.
	millisecond.every = function(k) {
	  k = Math.floor(k);
	  if (!isFinite(k) || !(k > 0)) return null;
	  if (!(k > 1)) return millisecond;
	  return newInterval(function(date) {
	    date.setTime(Math.floor(date / k) * k);
	  }, function(date, step) {
	    date.setTime(+date + step * k);
	  }, function(start, end) {
	    return (end - start) / k;
	  });
	};
	var milliseconds = millisecond.range;
	
	var durationSecond = 1e3;
	var durationMinute = 6e4;
	var durationHour = 36e5;
	var durationDay = 864e5;
	var durationWeek = 6048e5;
	
	var second = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds());
	}, function(date, step) {
	  date.setTime(+date + step * durationSecond);
	}, function(start, end) {
	  return (end - start) / durationSecond;
	}, function(date) {
	  return date.getUTCSeconds();
	});
	var seconds = second.range;
	
	var minute = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getMinutes();
	});
	var minutes = minute.range;
	
	var hour = newInterval(function(date) {
	  date.setTime(date - date.getMilliseconds() - date.getSeconds() * durationSecond - date.getMinutes() * durationMinute);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getHours();
	});
	var hours = hour.range;
	
	var day = newInterval(function(date) {
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setDate(date.getDate() + step);
	}, function(start, end) {
	  return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationDay;
	}, function(date) {
	  return date.getDate() - 1;
	});
	var days = day.range;
	
	function weekday(i) {
	  return newInterval(function(date) {
	    date.setDate(date.getDate() - (date.getDay() + 7 - i) % 7);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setDate(date.getDate() + step * 7);
	  }, function(start, end) {
	    return (end - start - (end.getTimezoneOffset() - start.getTimezoneOffset()) * durationMinute) / durationWeek;
	  });
	}
	
	var sunday = weekday(0);
	var monday = weekday(1);
	var tuesday = weekday(2);
	var wednesday = weekday(3);
	var thursday = weekday(4);
	var friday = weekday(5);
	var saturday = weekday(6);
	
	var sundays = sunday.range;
	var mondays = monday.range;
	var tuesdays = tuesday.range;
	var wednesdays = wednesday.range;
	var thursdays = thursday.range;
	var fridays = friday.range;
	var saturdays = saturday.range;
	
	var month = newInterval(function(date) {
	  date.setDate(1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setMonth(date.getMonth() + step);
	}, function(start, end) {
	  return end.getMonth() - start.getMonth() + (end.getFullYear() - start.getFullYear()) * 12;
	}, function(date) {
	  return date.getMonth();
	});
	var months = month.range;
	
	var year = newInterval(function(date) {
	  date.setMonth(0, 1);
	  date.setHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setFullYear(date.getFullYear() + step);
	}, function(start, end) {
	  return end.getFullYear() - start.getFullYear();
	}, function(date) {
	  return date.getFullYear();
	});
	
	// An optimized implementation for this simple case.
	year.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setFullYear(Math.floor(date.getFullYear() / k) * k);
	    date.setMonth(0, 1);
	    date.setHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setFullYear(date.getFullYear() + step * k);
	  });
	};
	var years = year.range;
	
	var utcMinute = newInterval(function(date) {
	  date.setUTCSeconds(0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationMinute);
	}, function(start, end) {
	  return (end - start) / durationMinute;
	}, function(date) {
	  return date.getUTCMinutes();
	});
	var utcMinutes = utcMinute.range;
	
	var utcHour = newInterval(function(date) {
	  date.setUTCMinutes(0, 0, 0);
	}, function(date, step) {
	  date.setTime(+date + step * durationHour);
	}, function(start, end) {
	  return (end - start) / durationHour;
	}, function(date) {
	  return date.getUTCHours();
	});
	var utcHours = utcHour.range;
	
	var utcDay = newInterval(function(date) {
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCDate(date.getUTCDate() + step);
	}, function(start, end) {
	  return (end - start) / durationDay;
	}, function(date) {
	  return date.getUTCDate() - 1;
	});
	var utcDays = utcDay.range;
	
	function utcWeekday(i) {
	  return newInterval(function(date) {
	    date.setUTCDate(date.getUTCDate() - (date.getUTCDay() + 7 - i) % 7);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCDate(date.getUTCDate() + step * 7);
	  }, function(start, end) {
	    return (end - start) / durationWeek;
	  });
	}
	
	var utcSunday = utcWeekday(0);
	var utcMonday = utcWeekday(1);
	var utcTuesday = utcWeekday(2);
	var utcWednesday = utcWeekday(3);
	var utcThursday = utcWeekday(4);
	var utcFriday = utcWeekday(5);
	var utcSaturday = utcWeekday(6);
	
	var utcSundays = utcSunday.range;
	var utcMondays = utcMonday.range;
	var utcTuesdays = utcTuesday.range;
	var utcWednesdays = utcWednesday.range;
	var utcThursdays = utcThursday.range;
	var utcFridays = utcFriday.range;
	var utcSaturdays = utcSaturday.range;
	
	var utcMonth = newInterval(function(date) {
	  date.setUTCDate(1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCMonth(date.getUTCMonth() + step);
	}, function(start, end) {
	  return end.getUTCMonth() - start.getUTCMonth() + (end.getUTCFullYear() - start.getUTCFullYear()) * 12;
	}, function(date) {
	  return date.getUTCMonth();
	});
	var utcMonths = utcMonth.range;
	
	var utcYear = newInterval(function(date) {
	  date.setUTCMonth(0, 1);
	  date.setUTCHours(0, 0, 0, 0);
	}, function(date, step) {
	  date.setUTCFullYear(date.getUTCFullYear() + step);
	}, function(start, end) {
	  return end.getUTCFullYear() - start.getUTCFullYear();
	}, function(date) {
	  return date.getUTCFullYear();
	});
	
	// An optimized implementation for this simple case.
	utcYear.every = function(k) {
	  return !isFinite(k = Math.floor(k)) || !(k > 0) ? null : newInterval(function(date) {
	    date.setUTCFullYear(Math.floor(date.getUTCFullYear() / k) * k);
	    date.setUTCMonth(0, 1);
	    date.setUTCHours(0, 0, 0, 0);
	  }, function(date, step) {
	    date.setUTCFullYear(date.getUTCFullYear() + step * k);
	  });
	};
	var utcYears = utcYear.range;
	
	exports.timeDay = day;
	exports.timeDays = days;
	exports.timeFriday = friday;
	exports.timeFridays = fridays;
	exports.timeHour = hour;
	exports.timeHours = hours;
	exports.timeInterval = newInterval;
	exports.timeMillisecond = millisecond;
	exports.timeMilliseconds = milliseconds;
	exports.timeMinute = minute;
	exports.timeMinutes = minutes;
	exports.timeMonday = monday;
	exports.timeMondays = mondays;
	exports.timeMonth = month;
	exports.timeMonths = months;
	exports.timeSaturday = saturday;
	exports.timeSaturdays = saturdays;
	exports.timeSecond = second;
	exports.timeSeconds = seconds;
	exports.timeSunday = sunday;
	exports.timeSundays = sundays;
	exports.timeThursday = thursday;
	exports.timeThursdays = thursdays;
	exports.timeTuesday = tuesday;
	exports.timeTuesdays = tuesdays;
	exports.timeWednesday = wednesday;
	exports.timeWednesdays = wednesdays;
	exports.timeWeek = sunday;
	exports.timeWeeks = sundays;
	exports.timeYear = year;
	exports.timeYears = years;
	exports.utcDay = utcDay;
	exports.utcDays = utcDays;
	exports.utcFriday = utcFriday;
	exports.utcFridays = utcFridays;
	exports.utcHour = utcHour;
	exports.utcHours = utcHours;
	exports.utcMillisecond = millisecond;
	exports.utcMilliseconds = milliseconds;
	exports.utcMinute = utcMinute;
	exports.utcMinutes = utcMinutes;
	exports.utcMonday = utcMonday;
	exports.utcMondays = utcMondays;
	exports.utcMonth = utcMonth;
	exports.utcMonths = utcMonths;
	exports.utcSaturday = utcSaturday;
	exports.utcSaturdays = utcSaturdays;
	exports.utcSecond = second;
	exports.utcSeconds = seconds;
	exports.utcSunday = utcSunday;
	exports.utcSundays = utcSundays;
	exports.utcThursday = utcThursday;
	exports.utcThursdays = utcThursdays;
	exports.utcTuesday = utcTuesday;
	exports.utcTuesdays = utcTuesdays;
	exports.utcWednesday = utcWednesday;
	exports.utcWednesdays = utcWednesdays;
	exports.utcWeek = utcSunday;
	exports.utcWeeks = utcSundays;
	exports.utcYear = utcYear;
	exports.utcYears = utcYears;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 177 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(525);
	} else {
	  module.exports = require('./cjs/history.js');
	}


/***/ },
/* 178 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	var isBrowser = exports.isBrowser = (typeof window === "undefined" ? "undefined" : _typeof(window)) === "object" && (typeof document === "undefined" ? "undefined" : _typeof(document)) === 'object' && document.nodeType === 9;
	
	exports.default = isBrowser;

/***/ },
/* 179 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };
	
	function _toConsumableArray(arr) { if (Array.isArray(arr)) { for (var i = 0, arr2 = Array(arr.length); i < arr.length; i++) { arr2[i] = arr[i]; } return arr2; } else { return Array.from(arr); } }
	
	var isSafari = exports.isSafari = function isSafari() {
	  return (/^((?!chrome|android).)*safari/i.test(navigator.userAgent)
	  );
	};
	
	var isJsons = exports.isJsons = function isJsons(array) {
	  return Array.isArray(array) && array.every(function (row) {
	    return (typeof row === "undefined" ? "undefined" : _typeof(row)) === 'object' && !(row instanceof Array);
	  });
	};
	
	var isArrays = exports.isArrays = function isArrays(array) {
	  return Array.isArray(array) && array.every(function (row) {
	    return Array.isArray(row);
	  });
	};
	
	var jsonsHeaders = exports.jsonsHeaders = function jsonsHeaders(array) {
	  return Array.from(array.map(function (json) {
	    return Object.keys(json);
	  }).reduce(function (a, b) {
	    return new Set([].concat(_toConsumableArray(a), _toConsumableArray(b)));
	  }, []));
	};
	
	var jsons2arrays = exports.jsons2arrays = function jsons2arrays(jsons, headers) {
	  headers = headers || jsonsHeaders(jsons);
	
	  var headerLabels = headers;
	  var headerKeys = headers;
	  if (isJsons(headers)) {
	    headerLabels = headers.map(function (header) {
	      return header.label;
	    });
	    headerKeys = headers.map(function (header) {
	      return header.key;
	    });
	  }
	
	  var data = jsons.map(function (object) {
	    return headerKeys.map(function (header) {
	      return getHeaderValue(header, object);
	    });
	  });
	  return [headerLabels].concat(_toConsumableArray(data));
	};
	
	var getHeaderValue = exports.getHeaderValue = function getHeaderValue(property, obj) {
	  var foundValue = property.replace(/\[([^\]]+)]/g, ".$1").split(".").reduce(function (o, p, i, arr) {
	    if (o[p] === undefined) {
	      arr.splice(1);
	    } else {
	      return o[p];
	    }
	  }, obj);
	
	  return foundValue === undefined ? property in obj ? obj[property] : '' : foundValue;
	};
	
	var elementOrEmpty = exports.elementOrEmpty = function elementOrEmpty(element) {
	  return element || element === 0 ? element : '';
	};
	
	var joiner = exports.joiner = function joiner(data) {
	  var separator = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : ',';
	  var enclosingCharacter = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : '"';
	
	  return data.filter(function (e) {
	    return e;
	  }).map(function (row) {
	    return row.map(function (element) {
	      return elementOrEmpty(element);
	    }).map(function (column) {
	      return "" + enclosingCharacter + column + enclosingCharacter;
	    }).join(separator);
	  }).join("\n");
	};
	
	var arrays2csv = exports.arrays2csv = function arrays2csv(data, headers, separator, enclosingCharacter) {
	  return joiner(headers ? [headers].concat(_toConsumableArray(data)) : data, separator, enclosingCharacter);
	};
	
	var jsons2csv = exports.jsons2csv = function jsons2csv(data, headers, separator, enclosingCharacter) {
	  return joiner(jsons2arrays(data, headers), separator, enclosingCharacter);
	};
	
	var string2csv = exports.string2csv = function string2csv(data, headers, separator, enclosingCharacter) {
	  return headers ? headers.join(separator) + "\n" + data : data;
	};
	
	var toCSV = exports.toCSV = function toCSV(data, headers, separator, enclosingCharacter) {
	  if (isJsons(data)) return jsons2csv(data, headers, separator, enclosingCharacter);
	  if (isArrays(data)) return arrays2csv(data, headers, separator, enclosingCharacter);
	  if (typeof data === 'string') return string2csv(data, headers, separator);
	  throw new TypeError("Data should be a \"String\", \"Array of arrays\" OR \"Array of objects\" ");
	};
	
	var buildURI = exports.buildURI = function buildURI(data, uFEFF, headers, separator, enclosingCharacter) {
	  var csv = toCSV(data, headers, separator, enclosingCharacter);
	  var type = isSafari() ? 'application/csv' : 'text/csv';
	  var blob = new Blob([uFEFF ? "\uFEFF" : '', csv], { type: type });
	  var dataURI = "data:" + type + ";charset=utf-8," + (uFEFF ? "\uFEFF" : '') + csv;
	
	  var URL = window.URL || window.webkitURL;
	
	  return typeof URL.createObjectURL === 'undefined' ? dataURI : URL.createObjectURL(blob);
	};

/***/ },
/* 180 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.PropsNotForwarded = exports.defaultProps = exports.propTypes = undefined;
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(4);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var propTypes = exports.propTypes = {
	  data: (0, _propTypes.oneOfType)([_propTypes.string, _propTypes.array]).isRequired,
	  headers: _propTypes.array,
	  target: _propTypes.string,
	  separator: _propTypes.string,
	  filename: _propTypes.string,
	  uFEFF: _propTypes.bool,
	  onClick: _propTypes.func,
	  asyncOnClick: _propTypes.bool
	};
	
	var defaultProps = exports.defaultProps = {
	  separator: ',',
	  filename: 'generatedBy_react-csv.csv',
	  uFEFF: true,
	  asyncOnClick: false
	};
	
	var PropsNotForwarded = exports.PropsNotForwarded = ['data', 'headers'];

/***/ },
/* 181 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(552);
	} else {
	  module.exports = require("./cjs/react-router-dom.js");
	}


/***/ },
/* 182 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _ColorSchemes = __webpack_require__(72);
	
	var _FormatMoney = __webpack_require__(59);
	
	var _FormatMoney2 = _interopRequireDefault(_FormatMoney);
	
	var _d3Array = __webpack_require__(31);
	
	var _d3Selection = __webpack_require__(99);
	
	var _d3Hierarchy = __webpack_require__(509);
	
	var d3 = _interopRequireWildcard(_d3Hierarchy);
	
	function _interopRequireWildcard(obj) { if (obj && obj.__esModule) { return obj; } else { var newObj = {}; if (obj != null) { for (var key in obj) { if (Object.prototype.hasOwnProperty.call(obj, key)) newObj[key] = obj[key]; } } newObj.default = obj; return newObj; } }
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	function wrap(text, width) {
	  text.each(function () {
	    var text = (0, _d3Selection.select)(this),
	        leafwidth = this.getAttribute("width") - 20,
	        words = text.text().split(/\s+/).reverse(),
	        word = void 0,
	        line = [],
	        lineNumber = 0,
	        lineHeight = 1.1,
	        // ems
	    x = text.attr("x"),
	        y = text.attr("y"),
	        dy = 1.1,
	        tspan = text.text(null).append("tspan").attr("x", x).attr("y", y).attr("dy", dy + "em");
	    while (word = words.pop()) {
	      line.push(word + " ");
	      tspan.text(line.join(" "));
	      if (tspan.node().getComputedTextLength() > leafwidth) {
	        line.pop();
	        tspan.text(line.join(" "));
	        line = [word + " "];
	        tspan = text.append("tspan").attr("x", x).attr("y", y).attr("dy", ++lineNumber * lineHeight + dy + "em").text(word);
	      }
	    }
	  });
	}
	
	var TreeMap = function (_Component) {
	  _inherits(TreeMap, _Component);
	
	  function TreeMap(props) {
	    _classCallCheck(this, TreeMap);
	
	    var _this = _possibleConstructorReturn(this, (TreeMap.__proto__ || Object.getPrototypeOf(TreeMap)).call(this, props));
	
	    _this.labelRef = _react2.default.createRef();
	    return _this;
	  }
	
	  _createClass(TreeMap, [{
	    key: 'onResize',
	    value: function onResize() {}
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      (0, _d3Selection.selectAll)("text.datalabel").call(wrap, 100);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this2 = this;
	
	      var width = (0, _d3Array.min)([900, this.props.size[0]]);
	      var height = this.props.size[1];
	      var data = this.props.data;
	      var value = this.props.value;
	      var organizer = this.props.organizer;
	      var colorScale = scalePicker(this.props.omitSBA);
	
	      function scalePicker(checker) {
	        if (checker === true) {
	          return _ColorSchemes.categoricalColorsWithoutSBA;
	        } else {
	          return _ColorSchemes.categoricalColors;
	        }
	      }
	
	      function percent(number) {
	        return Math.round(number * 1000) / 10 + "%";
	      }
	
	      var rects = void 0;
	      var textlabels = void 0;
	      var legend = void 0;
	
	      if (data.length > 0) {
	
	        var newObj = new Object();
	        newObj.values = data;
	        newObj.name = "Programs";
	
	        var root = d3.hierarchy(newObj, function (d) {
	          return d.values;
	        }).sum(function (d) {
	          return d[value];
	        });
	
	        var totalSpend = root.value;
	
	        // Then d3.treemap computes the position of each element of the hierarchy
	        d3.treemap().tile(d3.treemapBinary).size([width, height - 50]).padding(1)(root);
	
	        rects = root.leaves().map(function (d, i) {
	          return _react2.default.createElement('rect', {
	            key: i,
	            x: d.x0,
	            y: d.y0,
	            width: d.x1 - d.x0,
	            height: d.y1 - d.y0,
	            'data-tip': d.data[organizer] !== "Others" ? d.data.Program + ", " + (0, _ColorSchemes.fullAgencyName)(d.data[organizer]) + ": " + (0, _FormatMoney2.default)(d.data[value]) : d.data.Program + ": " + (0, _FormatMoney2.default)(d.data[value]),
	            fill: colorScale(d.data[organizer])
	          });
	        });
	
	        textlabels = root.leaves().filter(function (d) {
	          return !isNaN(d.data[value]) && d.x1 - d.x0 > 60 && d.y1 - d.y0 > 60 && d.data.Program.length < d.data[value] / 100000;
	        }).map(function (d, i) {
	          return _react2.default.createElement(
	            'a',
	            {
	              key: i,
	              href: d.data.URL
	            },
	            _react2.default.createElement(
	              'text',
	              {
	                ref: _this2.labelRef,
	                className: 'datalabel',
	                x: d.x0 + 5,
	                y: d.y0,
	                textAnchor: "left",
	                fontSize: d.data[value] / totalSpend * 80 + width / 150 + "px",
	                fill: "white",
	                width: d.x1 - d.x0,
	                'data-tip': d.data.Program + ", " + (0, _ColorSchemes.fullAgencyName)(d.data[organizer]) + ": " + (0, _FormatMoney2.default)(d.data[value])
	              },
	              d.data.Program + ": " + percent(d.data[value] / totalSpend)
	            )
	          );
	        });
	
	        legend = colorScale.domain().map(function (d, i) {
	          return _react2.default.createElement(
	            'g',
	            {
	              key: i,
	              transform: "translate(" + (width / 7 * i + width / 28) + "," + (_this2.props.size[1] - 45) + ")"
	            },
	            _react2.default.createElement('rect', {
	              width: width / 7 - width / 14,
	              height: 15,
	              style: { fill: colorScale(d) }
	            }),
	            _react2.default.createElement(
	              'text',
	              {
	                fontSize: width / 300 + 10 + "px",
	                transform: "translate(" + width / 28 + ",30)",
	                style: { textAnchor: "middle" }
	              },
	              d
	            )
	          );
	        });
	      }
	
	      return _react2.default.createElement(
	        'div',
	        null,
	        _react2.default.createElement(
	          'svg',
	          { ref: function ref(node) {
	              return _this2.node = node;
	            }, value: value, width: width, height: this.props.size[1] },
	          rects,
	          textlabels,
	          legend
	        )
	      );
	    }
	  }]);
	
	  return TreeMap;
	}(_react.Component);
	
	exports.default = TreeMap;

/***/ },
/* 183 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default={"type":"Topology","bbox":[-179.14733999999999,-14.552548999999999,179.77847,71.352561],"transform":{"scale":[0.003589293992939929,0.0008590596905969058],"translate":[-179.14733999999999,-14.552548999999999]},"objects":{"states":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[0]],[[1,2,3,4,5]]],"id":"01","properties":{"name":"Alabama"}},{"type":"MultiPolygon","arcs":[[[6]],[[7]],[[8]],[[9]],[[10]],[[11]],[[12]],[[13]],[[14]],[[15]],[[16]],[[17]],[[18]],[[19]],[[20]],[[21]],[[22]],[[23]],[[24]],[[25]],[[26]],[[27]],[[28]],[[29]],[[30]],[[31]],[[32]],[[33]],[[34]],[[35]],[[36]],[[37]],[[38]],[[39]],[[40]],[[41]],[[42]],[[43]],[[44]],[[45]],[[46]],[[47]],[[48]],[[49]],[[50]],[[51]],[[52]],[[53]],[[54]],[[55]],[[56]],[[57]],[[58]],[[59]],[[60]],[[61]],[[62]],[[63]],[[64]],[[65]],[[66]],[[67]],[[68]],[[69]],[[70]],[[71]],[[72]],[[73]],[[74]],[[75]],[[76]],[[77]],[[78]],[[79]],[[80]],[[81]],[[82]],[[83]],[[84]],[[85]],[[86]],[[87]],[[88]],[[89]],[[90]],[[91]],[[92]],[[93]],[[94]],[[95]],[[96]],[[97]],[[98]],[[99]],[[100]],[[101]],[[102]],[[103]],[[104]],[[105]],[[106]],[[107]],[[108]],[[109]],[[110]],[[111]],[[112]],[[113]],[[114]],[[115]],[[116]],[[117]],[[118]],[[119]],[[120]],[[121]],[[122]],[[123]],[[124]],[[125]],[[126]],[[127]],[[128]],[[129]],[[130]],[[131]],[[132]],[[133]],[[134]],[[135]],[[136]],[[137]],[[138]],[[139]],[[140]],[[141]],[[142]]],"id":"02","properties":{"name":"Alaska"}},{"type":"Polygon","arcs":[[143,144,145,146,147]],"id":"04","properties":{"name":"Arizona"}},{"type":"Polygon","arcs":[[148,149,150,151,152,153]],"id":"08","properties":{"name":"Colorado"}},{"type":"MultiPolygon","arcs":[[[154]],[[155]],[[156]],[[157]],[[158]],[[159]],[[160]],[[161]],[[162]],[[163,164,-4]]],"id":"12","properties":{"name":"Florida"}},{"type":"Polygon","arcs":[[165,166,167,168,-164,-3]],"id":"13","properties":{"name":"Georgia"}},{"type":"Polygon","arcs":[[169,170,171,172,173]],"id":"18","properties":{"name":"Indiana"}},{"type":"Polygon","arcs":[[174,175,176,-151]],"id":"20","properties":{"name":"Kansas"}},{"type":"MultiPolygon","arcs":[[[177]],[[178]],[[179]],[[180]],[[181]],[[182]],[[183]],[[184,185]]],"id":"23","properties":{"name":"Maine"}},{"type":"MultiPolygon","arcs":[[[186]],[[187]],[[188,189,190,191,192,193,194,195]]],"id":"25","properties":{"name":"Massachusetts"}},{"type":"Polygon","arcs":[[196,197,198,199,200]],"id":"27","properties":{"name":"Minnesota"}},{"type":"Polygon","arcs":[[201,202,203,204,205,206,207,208]],"id":"34","properties":{"name":"New Jersey"}},{"type":"MultiPolygon","arcs":[[[209]],[[210]],[[211,212,213,-167,214]]],"id":"37","properties":{"name":"North Carolina"}},{"type":"Polygon","arcs":[[215,-201,216,217]],"id":"38","properties":{"name":"North Dakota"}},{"type":"Polygon","arcs":[[-152,-177,218,219,220,221]],"id":"40","properties":{"name":"Oklahoma"}},{"type":"Polygon","arcs":[[222,223,-204,224,225,226,227]],"id":"42","properties":{"name":"Pennsylvania"}},{"type":"Polygon","arcs":[[228,-217,-200,229,230,231]],"id":"46","properties":{"name":"South Dakota"}},{"type":"Polygon","arcs":[[-221,232,233,234,235,236,237]],"id":"48","properties":{"name":"Texas"}},{"type":"Polygon","arcs":[[-232,238,-149,239,240,241]],"id":"56","properties":{"name":"Wyoming"}},{"type":"Polygon","arcs":[[-195,242,243,244]],"id":"09","properties":{"name":"Connecticut"}},{"type":"Polygon","arcs":[[245,246,247,248,249,250,251,-219,-176,252]],"id":"29","properties":{"name":"Missouri"}},{"type":"Polygon","arcs":[[253,-227,254,255,256]],"id":"54","properties":{"name":"West Virginia"}},{"type":"Polygon","arcs":[[257,258,259,-174,260,-247]],"id":"17","properties":{"name":"Illinois"}},{"type":"Polygon","arcs":[[-153,-222,-238,261,-147]],"id":"35","properties":{"name":"New Mexico"}},{"type":"Polygon","arcs":[[-252,262,263,264,-235,233,-233,-220]],"id":"05","properties":{"name":"Arkansas"}},{"type":"MultiPolygon","arcs":[[[265]],[[266]],[[267]],[[268]],[[269]],[[270]],[[271]],[[272]],[[273,274,275,-144,276]]],"id":"06","properties":{"name":"California"}},{"type":"MultiPolygon","arcs":[[[-209,277]],[[-225,-203,278,279]]],"id":"10","properties":{"name":"Delaware"}},{"type":"Polygon","arcs":[[280,281]],"id":"11","properties":{"name":"District of Columbia"}},{"type":"MultiPolygon","arcs":[[[282]],[[283]],[[284]],[[285]],[[286]],[[287]],[[288]],[[289]]],"id":"15","properties":{"name":"Hawaii"}},{"type":"Polygon","arcs":[[-199,290,-258,-246,291,-230]],"id":"19","properties":{"name":"Iowa"}},{"type":"MultiPolygon","arcs":[[[-261,-173,292,-257,293,294,-248]],[[295,-250]]],"id":"21","properties":{"name":"Kentucky"}},{"type":"MultiPolygon","arcs":[[[296,297]],[[298]],[[299]],[[-226,-280,300,301,302,303,-281,304,-255]]],"id":"24","properties":{"name":"Maryland"}},{"type":"MultiPolygon","arcs":[[[305]],[[306]],[[307]],[[308]],[[309]],[[310]],[[311]],[[312]],[[313]],[[314,315,-171]],[[316]],[[317,318,319,320,321,322]]],"id":"26","properties":{"name":"Michigan"}},{"type":"MultiPolygon","arcs":[[[323]],[[324]],[[325]],[[326]],[[-264,327,-6,328,329]]],"id":"28","properties":{"name":"Mississippi"}},{"type":"Polygon","arcs":[[330,-218,-229,-242,331]],"id":"30","properties":{"name":"Montana"}},{"type":"Polygon","arcs":[[332,-185,333,-190,334]],"id":"33","properties":{"name":"New Hampshire"}},{"type":"MultiPolygon","arcs":[[[335]],[[336]],[[337]],[[338,-207]],[[339]],[[340]],[[341,342,-196,-245,343,-205,-224]]],"id":"36","properties":{"name":"New York"}},{"type":"MultiPolygon","arcs":[[[344]],[[345]],[[-316,346,-228,-254,-293,-172]]],"id":"39","properties":{"name":"Ohio"}},{"type":"Polygon","arcs":[[347,348,349,274,-275,-274,350]],"id":"41","properties":{"name":"Oregon"}},{"type":"Polygon","arcs":[[-251,-296,-249,-295,351,-215,-166,-2,-328,-263]],"id":"47","properties":{"name":"Tennessee"}},{"type":"Polygon","arcs":[[352,-240,-154,-146,353]],"id":"49","properties":{"name":"Utah"}},{"type":"MultiPolygon","arcs":[[[354]],[[-302,355]],[[356,-297]],[[-256,-305,-282,-304,357,-212,-352,-294]]],"id":"51","properties":{"name":"Virginia"}},{"type":"MultiPolygon","arcs":[[[358]],[[359]],[[360]],[[361]],[[362]],[[363]],[[364]],[[365]],[[366]],[[367]],[[368,-348,369]]],"id":"53","properties":{"name":"Washington"}},{"type":"MultiPolygon","arcs":[[[370]],[[371]],[[372]],[[373]],[[374]],[[375]],[[376]],[[377]],[[378]],[[379]],[[380,-323,321,-321,319,-319,381,-259,-291,-198]]],"id":"55","properties":{"name":"Wisconsin"}},{"type":"MultiPolygon","arcs":[[[382]],[[383]],[[384]]],"id":"60","properties":{"name":"American Samoa"}},{"type":"MultiPolygon","arcs":[[[385]]],"id":"66","properties":{"name":"Guam"}},{"type":"MultiPolygon","arcs":[[[386]],[[387]],[[388]],[[389]],[[390]],[[391]],[[392]],[[393]]],"id":"69","properties":{"name":"Commonwealth of the Northern Mariana Islands"}},{"type":"Polygon","arcs":[[-231,-292,-253,-175,-150,-239]],"id":"31","properties":{"name":"Nebraska"}},{"type":"Polygon","arcs":[[-214,394,-168]],"id":"45","properties":{"name":"South Carolina"}},{"type":"MultiPolygon","arcs":[[[395]],[[396]],[[397]],[[398]],[[399]]],"id":"72","properties":{"name":"Puerto Rico"}},{"type":"MultiPolygon","arcs":[[[400]],[[401]],[[402]]],"id":"78","properties":{"name":"United States Virgin Islands"}},{"type":"Polygon","arcs":[[-369,403,-332,-241,-353,404,-349]],"id":"16","properties":{"name":"Idaho"}},{"type":"Polygon","arcs":[[-275,-350,-405,-354,-145,-276]],"id":"32","properties":{"name":"Nevada"}},{"type":"Polygon","arcs":[[405,-335,-189,-343]],"id":"50","properties":{"name":"Vermont"}},{"type":"MultiPolygon","arcs":[[[406]],[[407]],[[408]],[[409]],[[410]],[[411]],[[412]],[[-265,-330,413,-236]]],"id":"22","properties":{"name":"Louisiana"}},{"type":"MultiPolygon","arcs":[[[-192,414]],[[415]],[[416]],[[417]],[[-243,-194,418]]],"id":"44","properties":{"name":"Rhode Island"}}]},"nation":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[0]],[[164,4,328,413,236,261,147,276,350,369,403,330,215,196,380,317,381,259,169,314,346,222,341,405,332,185,333,190,414,192,418,243,343,205,338,207,277,201,278,300,355,302,357,212,394,168]],[[6]],[[7]],[[8]],[[9]],[[10]],[[11]],[[12]],[[13]],[[14]],[[15]],[[16]],[[17]],[[18]],[[19]],[[20]],[[21]],[[22]],[[23]],[[24]],[[25]],[[26]],[[27]],[[28]],[[29]],[[30]],[[31]],[[32]],[[33]],[[34]],[[35]],[[36]],[[37]],[[38]],[[39]],[[40]],[[41]],[[42]],[[43]],[[44]],[[45]],[[46]],[[47]],[[48]],[[49]],[[50]],[[51]],[[52]],[[53]],[[54]],[[55]],[[56]],[[57]],[[58]],[[59]],[[60]],[[61]],[[62]],[[63]],[[64]],[[65]],[[66]],[[67]],[[68]],[[69]],[[70]],[[71]],[[72]],[[73]],[[74]],[[75]],[[76]],[[77]],[[78]],[[79]],[[80]],[[81]],[[82]],[[83]],[[84]],[[85]],[[86]],[[87]],[[88]],[[89]],[[90]],[[91]],[[92]],[[93]],[[94]],[[95]],[[96]],[[97]],[[98]],[[99]],[[100]],[[101]],[[102]],[[103]],[[104]],[[105]],[[106]],[[107]],[[108]],[[109]],[[110]],[[111]],[[112]],[[113]],[[114]],[[115]],[[116]],[[117]],[[118]],[[119]],[[120]],[[121]],[[122]],[[123]],[[124]],[[125]],[[126]],[[127]],[[128]],[[129]],[[130]],[[131]],[[132]],[[133]],[[134]],[[135]],[[136]],[[137]],[[138]],[[139]],[[140]],[[141]],[[142]],[[154]],[[155]],[[156]],[[157]],[[158]],[[159]],[[160]],[[161]],[[162]],[[177]],[[178]],[[179]],[[180]],[[181]],[[182]],[[183]],[[186]],[[187]],[[209]],[[210]],[[265]],[[266]],[[267]],[[268]],[[269]],[[270]],[[271]],[[272]],[[282]],[[283]],[[284]],[[285]],[[286]],[[287]],[[288]],[[289]],[[297,356]],[[298]],[[299]],[[305]],[[306]],[[307]],[[308]],[[309]],[[310]],[[311]],[[312]],[[313]],[[316]],[[323]],[[324]],[[325]],[[326]],[[335]],[[336]],[[337]],[[339]],[[340]],[[344]],[[345]],[[354]],[[358]],[[359]],[[360]],[[361]],[[362]],[[363]],[[364]],[[365]],[[366]],[[367]],[[370]],[[371]],[[372]],[[373]],[[374]],[[375]],[[376]],[[377]],[[378]],[[379]],[[382]],[[383]],[[384]],[[385]],[[386]],[[387]],[[388]],[[389]],[[390]],[[391]],[[392]],[[393]],[[395]],[[396]],[[397]],[[398]],[[399]],[[400]],[[401]],[[402]],[[406]],[[407]],[[408]],[[409]],[[410]],[[411]],[[412]],[[415]],[[416]],[[417]]]}]}},"arcs":[[[25302,52136],[56,31],[1,25],[14,-40],[-9,-28],[-10,16],[-18,-2],[-20,-17],[-14,15]],[[25338,57677],[0,15],[150,-6],[63,0],[160,-13],[93,-2],[37,2],[159,-4],[61,-5]],[[26061,57664],[15,-321],[23,-443],[18,-379],[13,-294],[15,-311],[33,-713],[9,-32],[-4,-36],[13,-45],[5,-149],[10,-72],[17,-69],[3,-82],[9,-36],[-10,-117],[18,-28],[12,-40],[-10,-52],[-11,0],[2,-24],[-14,-21],[-13,-52],[3,-56],[-2,-86],[-7,-86],[-14,-72],[-3,-45],[6,-124],[-2,-44],[19,-87],[3,-120],[-7,-57],[2,-43],[-8,-80],[1,-79],[-7,-21],[5,-51],[-3,-54],[20,-91],[7,-64],[2,-61]],[[26229,53027],[-67,0],[-71,-5],[-110,-4],[-174,0],[-135,7],[-166,-2],[3,-38],[-13,-115],[2,-23],[23,-79],[3,-41],[36,-80],[3,-69],[-15,-102],[3,-55],[20,-51],[-18,-35],[-8,-82],[-9,-15],[7,-24],[-15,-26]],[[25528,52188],[-38,-35],[-40,-24],[-56,-4],[18,41],[12,-26],[35,27],[3,34],[-15,48],[-7,43],[-20,47],[-7,90],[9,74],[-3,76],[-7,48],[-20,32],[-15,-46],[2,-38],[-9,-57],[1,-41],[-6,-32],[-1,-144],[-8,-66],[-15,-4],[1,36],[-20,40],[-15,-16],[-5,23],[-18,-22]],[[25284,52292],[-3,222],[-3,357],[-6,423],[-10,773],[9,283],[21,710],[5,212],[33,1120],[6,160],[19,643],[12,362],[-16,35],[-13,85]],[[8053,88108],[6,38],[18,-11],[-20,-43],[-4,16]],[[7905,86007],[29,90],[15,-17],[-1,-46],[-28,-74],[-15,19],[0,28]],[[7695,85792],[26,-14],[-3,-36],[-23,50]],[[7642,85774],[22,-17],[-7,-33],[-14,14],[-1,36]],[[7602,85813],[20,-2],[-5,-34],[-15,36]],[[7594,84711],[8,45],[20,-13],[-8,-73],[-15,-17],[-5,58]],[[7543,85532],[12,28],[21,-40],[-33,-2],[0,14]],[[7540,87187],[29,79],[8,112],[31,-29],[-28,-64],[-9,-49],[5,-24],[-36,-25]],[[7464,85521],[14,55],[18,-28],[23,-4],[-33,-33],[-22,10]],[[7385,86976],[17,6],[5,-88],[-22,82]],[[7168,84530],[29,89],[15,6],[26,-66],[5,20],[-21,65],[6,54],[9,10],[27,-25],[21,19],[-29,54],[16,56],[29,-31],[15,4],[-14,56],[12,17],[20,-20],[14,45],[-18,6],[-13,33],[20,3],[22,67],[34,18],[-12,35],[-3,68],[27,66],[7,-31],[53,51],[7,-7],[-12,-118],[-13,-18],[-26,-103],[5,-84],[36,11],[2,69],[22,-9],[21,-71],[20,48],[12,-33],[-17,-117],[9,-22],[9,72],[27,47],[7,-25],[-3,-115],[-30,-89],[-32,23],[-11,81],[-21,-26],[13,-99],[-22,-20],[-39,13],[-16,-54],[-8,36],[2,74],[-10,2],[-9,-114],[-8,-24],[-31,-17],[2,-37],[-16,-22],[-45,-13],[-86,76],[-21,-13],[-15,29]],[[7129,86075],[41,28],[18,-43],[-5,-48],[-13,-16],[-29,-3],[-16,59],[4,23]],[[6962,82933],[31,45],[8,-48],[-37,-9],[-2,12]],[[6905,82759],[20,62],[19,20],[11,-11],[25,17],[5,-40],[19,-37],[36,16],[-2,-37],[-19,-31],[-46,-6],[-32,-13],[-32,25],[-4,35]],[[6789,83718],[20,17],[4,76],[18,75],[25,34],[5,44],[15,-8],[34,70],[33,36],[39,-15],[29,1],[0,-112],[26,-57],[4,45],[17,53],[-18,48],[6,25],[53,-14],[-3,35],[-52,44],[-19,-4],[-1,127],[31,61],[29,29],[20,-12],[22,-56],[6,-133],[15,13],[9,77],[-5,55],[35,-38],[7,47],[-37,36],[-21,58],[7,44],[17,-6],[51,-87],[9,4],[30,-41],[11,10],[-31,75],[-20,34],[-7,44],[17,0],[30,-58],[29,12],[41,-29],[7,49],[36,15],[-8,-63],[-39,-106],[-7,-83],[19,-36],[0,95],[16,43],[16,-49],[5,46],[17,32],[5,41],[14,10],[10,-31],[22,72],[17,8],[-4,-45],[28,-16],[-11,-38],[-11,20],[-18,-15],[19,-36],[-5,-49],[19,22],[11,-51],[27,1],[-24,-53],[-16,33],[-24,2],[-15,-48],[16,-9],[-8,-53],[26,-8],[-26,-89],[23,17],[13,47],[5,-35],[47,-4],[-3,-41],[-36,-78],[-13,-110],[-38,13],[-2,39],[-10,-41],[-23,42],[-17,-6],[-23,49],[-15,-13],[-24,19],[-8,-46],[27,1],[15,-17],[45,-87],[-8,-70],[-23,-52],[-11,36],[-19,-50],[-19,30],[-6,38],[-21,18],[-20,-12],[-17,-37],[29,2],[20,-49],[-38,-53],[-34,12],[-4,-20],[25,-34],[14,13],[35,1],[22,-43],[-11,-28],[-24,-8],[-34,-33],[-8,11],[-19,-29],[3,-49],[-27,-50],[-13,20],[7,34],[-23,50],[7,47],[27,62],[-8,24],[-15,-21],[-34,-105],[-3,-24],[-22,32],[-22,-10],[-5,-35],[26,-6],[10,-63],[-16,-61],[-25,-20],[1,-70],[-25,-41],[-12,13],[-23,-82],[-19,-30],[-18,21],[-31,-20],[22,116],[11,11],[26,71],[24,31],[-2,37],[-33,-23],[3,52],[22,102],[29,52],[-7,30],[-15,-45],[-34,-61],[-26,-112],[-24,-59],[-14,-11],[-5,-44],[-19,-30],[-4,84],[-26,58],[-33,27],[3,100],[-4,106],[-13,83],[-11,32],[-23,20],[-27,5],[14,30],[-15,37],[5,23]],[[6782,82633],[27,101],[51,97],[21,-4],[16,-54],[-12,-23],[-55,-73],[-29,-79],[-19,35]],[[6519,81925],[26,41],[5,38],[13,22],[8,-32],[-6,-43],[5,-68],[-7,-33],[-36,13],[-8,62]],[[6240,82171],[5,47],[14,25],[13,-59],[-13,-63],[-19,50]],[[6225,82357],[9,35],[3,-82],[-10,-1],[-2,48]],[[6080,82757],[21,48],[48,-3],[25,-54],[-35,23],[-16,-26],[-43,-6],[0,18]],[[5919,82533],[19,25],[11,-57],[-9,-11],[-21,43]],[[5642,81925],[8,64],[19,12],[27,-58],[-8,-18],[-21,37],[-25,-37]],[[5573,81984],[16,-49],[-27,12],[11,37]],[[5524,80844],[-1,36],[13,24],[20,-25],[-9,-59],[-19,-15],[-4,39]],[[5506,81836],[8,67],[10,10],[11,-62],[-29,-15]],[[5485,80904],[12,85],[-11,46],[31,-2],[4,-99],[-27,-38],[-9,8]],[[5445,80747],[10,13],[16,-42],[-1,-34],[-23,-4],[-2,67]],[[5429,81185],[17,-21],[5,49],[17,46],[5,-22],[-8,-58],[9,-13],[1,-44],[-10,-61],[13,-30],[-7,-19],[-17,22],[-2,-21],[-20,8],[-3,164]],[[5385,80755],[21,25],[11,-30],[-20,-26],[-12,31]],[[5377,81028],[9,39],[23,41],[5,-36],[-23,-38],[-9,-58],[-5,52]],[[5303,81352],[14,11],[5,-42],[-19,31]],[[5265,80882],[33,98],[15,27],[-5,18],[-22,0],[-4,76],[22,50],[27,-44],[-1,38],[-13,52],[30,-13],[18,114],[12,-23],[-2,-43],[-9,-2],[-5,-75],[12,-18],[0,33],[13,1],[-4,-60],[-11,-37],[-22,12],[-1,-45],[-28,-71],[-18,-24],[-31,-141],[-6,77]],[[5246,85264],[5,41],[14,-83],[-7,-25],[-12,67]],[[5238,81460],[22,42],[36,-14],[-1,-78],[-50,12],[-7,38]],[[5213,85252],[8,77],[5,-57],[-13,-20]],[[5096,81334],[16,74],[25,25],[18,-23],[-2,-46],[10,5],[12,47],[15,-32],[26,-26],[26,25],[7,-66],[-9,-60],[-14,40],[-22,3],[-14,23],[-3,40],[-10,-12],[0,-69],[11,-20],[11,-87],[-11,-60],[-36,35],[-10,59],[-18,-18],[-18,-90],[4,58],[-10,43],[0,104],[-4,28]],[[5033,85142],[7,131],[39,52],[21,6],[39,76],[5,-2],[-55,-273],[-22,-32],[-32,-4],[-2,46]],[[4937,81216],[27,3],[-4,-71],[-26,47],[3,21]],[[4863,81217],[10,31],[36,8],[-9,-51],[-37,-10],[0,22]],[[4804,81100],[4,51],[17,20],[25,-19],[12,-29],[35,-42],[6,-41],[-30,44],[-23,-57],[-28,74],[-11,-38],[-7,37]],[[4656,80881],[30,66],[26,-27],[0,-83],[-11,-53],[-13,-21],[-27,58],[-5,60]],[[4587,90956],[19,44],[21,16],[24,-17],[22,6],[9,-37],[-1,-50],[-75,-13],[-18,19],[-1,32]],[[4545,80324],[1,51],[68,-54],[19,-39],[26,0],[18,-28],[-20,-23],[-10,-33],[-22,40],[-17,-9],[-31,37],[-18,-29],[-22,57],[8,30]],[[4451,81463],[14,-1],[-5,-38],[-9,39]],[[3979,80040],[12,22],[16,-18],[-21,-37],[-7,33]],[[3880,79918],[22,34],[33,-11],[24,18],[5,-24],[-9,-45],[-26,-13],[-47,27],[-2,14]],[[3807,79887],[60,24],[9,-35],[-15,-32],[-13,37],[-34,-4],[-7,10]],[[3781,79848],[17,29],[7,-36],[-18,-14],[-6,21]],[[3751,80090],[13,56],[14,-15],[18,18],[12,-21],[-22,-33],[13,-48],[30,0],[1,-41],[-23,3],[-18,-79],[-23,24],[-2,78],[16,35],[-9,20],[-16,-21],[-4,24]],[[3635,79967],[5,36],[28,54],[30,-6],[3,-58],[20,6],[14,-15],[8,-44],[13,13],[-2,-41],[-26,-36],[-12,11],[-18,-45],[-6,28],[-25,1],[-17,-20],[-18,91],[3,25]],[[3608,79782],[7,15],[27,-33],[-32,-11],[-2,29]],[[3261,87028],[35,25],[57,0],[22,-20],[23,10],[9,-24],[21,10],[10,30],[-8,38],[34,68],[37,-11],[0,37],[25,46],[33,-40],[24,32],[23,9],[15,54],[19,-132],[27,-10],[29,34],[29,-20],[27,-40],[-12,-65],[11,-44],[-11,-40],[13,-11],[4,-65],[-13,-38],[21,-54],[2,-58],[21,10],[-11,-34],[2,-48],[-71,-21],[-6,-34],[-20,19],[-26,-18],[-28,-58],[8,-64],[-26,-8],[-23,71],[-38,47],[-57,-4],[-14,35],[-28,18],[-27,58],[-35,42],[-40,19],[-32,72],[-25,10],[-2,70],[-28,97]],[[3147,79003],[17,23],[22,53],[25,5],[37,40],[9,27],[28,-21],[14,19],[8,44],[22,-19],[3,72],[24,-11],[-17,106],[20,32],[8,-16],[15,18],[-18,35],[4,39],[17,23],[29,-1],[9,-68],[15,7],[-7,50],[13,31],[-53,47],[-14,-21],[-32,81],[0,46],[31,92],[42,50],[36,32],[6,-15],[23,13],[16,-63],[-16,-42],[7,-35],[17,-18],[14,53],[6,-33],[15,29],[-1,41],[18,63],[15,-58],[11,26],[20,-62],[-8,-56],[-23,-13],[-24,-70],[-40,-70],[2,-39],[34,54],[58,64],[4,22],[22,22],[7,-19],[-5,-72],[-16,-51],[-26,-34],[-6,-23],[-45,-51],[-30,-20],[12,-46],[-16,-1],[-4,-61],[-16,17],[-7,-70],[-20,25],[-4,-76],[-36,-13],[-22,30],[-10,-31],[-12,23],[-21,-37],[-6,11],[-44,-73],[-3,-31],[-23,4],[-16,-23],[-13,-60],[-28,23],[-9,-45],[-49,40],[-15,36]],[[3070,93368],[7,34],[34,50],[123,108],[63,74],[48,74],[45,56],[42,64],[84,105],[55,56],[146,167],[172,154],[133,90],[87,45],[135,15],[52,-11],[34,-31],[-41,-11],[7,-38],[-10,-71],[-31,-77],[1,-70],[12,-56],[-21,-59],[-49,-33],[-4,-20],[49,7],[42,-151],[40,-3],[36,32],[42,-1],[49,-30],[47,21],[69,15],[32,-58],[50,21],[18,-34],[52,32],[18,26],[84,-65],[18,59],[26,44],[37,150],[18,26],[40,-9],[8,-39],[32,-12],[31,27],[26,0],[-32,110],[-71,55],[-45,24],[-48,-1],[-60,-60],[13,112],[-3,83],[-62,114],[-22,91],[-26,35],[-59,14],[-8,56],[-32,90],[7,50],[27,18],[10,43],[16,-37],[24,28],[27,-89],[36,-91],[24,-10],[-19,-101],[3,-55],[28,-50],[57,-123],[53,-68],[39,18],[30,28],[9,49],[-45,2],[-10,45],[-56,70],[-53,112],[10,52],[0,60],[14,23],[1,57],[33,93],[30,-32],[22,3],[1,28],[-38,55],[-25,-8],[-28,57],[-87,-29],[-32,-37],[-34,0],[-39,-19],[-34,17],[-20,43],[-17,-16],[-21,23],[-4,-51],[-36,39],[-91,42],[-54,31],[-48,15],[-22,30],[1,98],[-22,163],[-52,216],[-20,58],[-36,62],[-91,101],[-145,228],[-21,24],[-51,87],[-50,49],[-54,37],[-51,23],[-29,35],[-19,70],[-54,84],[-45,40],[-81,41],[-42,-6],[37,40],[92,59],[20,46],[3,57],[19,76],[11,236],[-8,117],[179,-31],[68,6],[144,42],[79,28],[77,15],[77,63],[41,65],[29,30],[53,87],[81,192],[21,92],[7,79],[-2,186],[39,233],[84,183],[65,179],[37,77],[129,162],[96,-35],[69,-3],[68,40],[64,53],[93,104],[74,108],[44,86],[114,188],[33,31],[99,63],[7,-47],[55,-44],[82,-12],[68,15],[13,24],[32,-3],[61,17],[73,51],[74,85],[71,121],[36,88],[86,185],[68,76],[12,-68],[47,-38],[39,-2],[39,-20],[16,-82],[27,41],[99,-49],[15,-98],[-54,-71],[-35,-63],[-41,-4],[12,-146],[81,-15],[44,59],[-7,76],[16,8],[31,67],[23,12],[19,-48],[4,63],[-27,43],[35,55],[21,-47],[-3,65],[15,22],[71,-74],[45,-66],[13,-42],[-11,-33],[1,-109],[9,-49],[61,10],[35,-37],[16,-40],[48,62],[30,75],[112,0],[69,42],[53,-11],[40,-34],[84,-2],[61,-32],[45,-35],[9,-34],[-26,-11],[-26,-83],[-26,-30],[14,-93],[25,5],[19,-24],[45,-6],[10,-28],[69,-20],[33,9],[-17,-43],[9,-25],[-53,-26],[-8,-24],[20,-25],[89,6],[72,-41],[14,-33],[28,5],[44,86],[57,15],[24,-18],[10,34],[40,7],[29,-27],[15,-59],[42,27],[38,8],[58,83],[13,-22],[45,20],[21,-15],[34,26],[12,-30],[66,-8],[62,-72],[28,-1],[19,-24],[26,31],[24,-8],[37,-73],[0,-45],[35,-19],[41,51],[1,-63],[26,57],[81,-77],[14,-67],[24,-23],[49,1],[43,-15],[29,36],[23,-73],[48,-10],[29,45],[43,-12],[62,12],[66,-10],[49,-38],[50,-3],[17,28],[65,-95],[28,-8],[32,-54],[45,-16],[20,-30],[45,-12],[17,-26],[27,32],[66,-20],[45,77],[48,6],[9,20],[84,49],[18,24],[86,30],[42,-25],[48,32],[9,-18],[79,-73],[53,-37],[70,-80],[26,-67],[37,-11],[87,-97],[68,-40],[52,-62],[27,-47],[61,-13],[58,-45],[0,-9012],[2,-971],[-1,-889],[130,-95],[17,100],[135,-145],[81,180],[170,20],[1,-39],[-33,-272],[47,-112],[66,-76],[26,-22],[11,-116],[29,-80],[266,-580],[30,-299],[-8,-93],[22,4],[51,108],[111,158],[11,23],[68,8],[32,139],[-2,209],[30,-19],[18,19],[19,71],[-1,39],[-32,47],[45,48],[68,28],[131,158],[62,-115],[28,-88],[11,-2],[24,-70],[0,-104],[-12,-24],[1,-37],[16,-47],[-5,-42],[18,-76],[73,-38],[5,-66],[32,-73],[24,0],[29,-108],[-6,-69],[26,-20],[-6,-46],[22,-71],[114,-152],[32,-119],[46,-120],[50,-110],[-23,-49],[33,-134],[47,-140],[28,-176],[57,-182],[32,-161],[30,-111],[25,-123],[53,-180],[32,-155],[-33,-140],[89,-52],[-21,-205],[71,-81],[-8,-61],[11,-57],[7,-119],[71,14],[33,-77],[82,-115],[23,-48],[85,-47],[44,-115],[44,-33],[11,-116],[23,-15],[27,-36],[40,23],[28,-143],[-3,-90],[-20,-107],[-18,-67],[1,-60],[10,-38],[-5,-118],[12,-104],[11,-46],[6,-133],[12,-63],[-32,-100],[-24,-122],[-1,-33],[-20,-90],[-23,-77],[-37,-97],[-27,-55],[-19,-14],[3,-46],[-19,-23],[-12,40],[-1,56],[-13,24],[-1,-44],[-12,-22],[-18,18],[-13,52],[-4,108],[3,57],[-17,33],[8,103],[-9,6],[-16,56],[-6,64],[30,63],[17,63],[15,-8],[-3,75],[-11,82],[14,122],[-9,190],[-10,67],[-43,164],[-22,55],[-12,48],[-7,-34],[23,-62],[25,-85],[7,-72],[22,-90],[10,-131],[-16,-43],[-2,-79],[7,-92],[11,-62],[-9,-28],[-11,96],[-8,12],[3,-70],[-4,-74],[-36,-102],[-14,-5],[-24,49],[19,73],[11,73],[-3,38],[-25,-10],[10,-72],[-8,-42],[-33,-56],[-7,1],[-23,108],[-11,-45],[-25,54],[-17,18],[-12,50],[-28,68],[0,76],[31,31],[22,51],[-20,47],[7,75],[-9,39],[23,44],[3,24],[-18,1],[-3,74],[7,43],[-41,-17],[6,-45],[11,-16],[-1,-37],[-13,-85],[-1,-60],[-19,-73],[-18,13],[7,-93],[-10,-43],[-24,52],[-25,22],[-9,30],[-12,132],[-16,70],[21,-29],[7,75],[27,37],[12,147],[-8,102],[10,57],[6,-21],[12,42],[7,92],[-21,-11],[-4,-58],[-19,-30],[-21,-61],[13,-113],[-8,-42],[-33,3],[-12,-43],[3,-30],[-17,-14],[-7,34],[4,67],[-19,23],[-12,128],[-32,-17],[0,-48],[-28,118],[-3,123],[8,25],[25,1],[7,66],[13,49],[30,12],[16,-72],[7,63],[-15,168],[9,3],[30,-45],[4,-59],[11,-32],[6,23],[-9,77],[-22,35],[-19,48],[-3,53],[-11,13],[-12,-25],[-10,49],[-23,32],[-5,57],[12,23],[-4,64],[-22,28],[-37,66],[-13,69],[-15,33],[-13,79],[29,43],[-11,58],[-18,-47],[-19,18],[-2,-27],[-23,58],[-31,8],[-11,56],[-27,-28],[-54,76],[-8,75],[15,73],[18,-22],[33,4],[9,48],[-22,3],[-32,36],[2,35],[-18,125],[13,81],[-24,-10],[-15,19],[-16,53],[7,103],[20,2],[16,-36],[33,-24],[63,-89],[5,15],[-25,58],[-20,19],[-66,130],[-3,95],[-17,-15],[-2,-65],[-20,3],[-39,166],[-55,147],[-11,140],[9,65],[-2,52],[27,41],[-13,100],[-8,-2],[-9,-85],[-20,-30],[0,-42],[12,-22],[-13,-57],[-10,10],[-22,-20],[-25,11],[-36,34],[-7,-15],[-35,36],[-40,174],[-4,110],[-42,140],[-13,79],[19,1],[-11,174],[-19,-56],[1,-58],[-35,132],[-8,177],[-8,92],[-21,135],[-32,116],[-36,37],[-5,-16],[28,-38],[4,-41],[17,-39],[20,-131],[-15,11],[-34,140],[-22,36],[-22,10],[41,-92],[13,-85],[17,-29],[-7,-97],[9,-88],[13,-23],[-5,-24],[27,-124],[3,-55],[25,-139],[2,-32],[-14,11],[27,-204],[9,-85],[1,-69],[-12,8],[-1,-61],[12,-64],[-29,23],[-19,32],[-14,-4],[-18,43],[-15,66],[-10,84],[-22,-16],[-33,50],[-27,-37],[-50,-19],[3,81],[-25,16],[-4,19],[30,39],[-10,69],[5,53],[-28,109],[0,36],[-22,84],[13,24],[-2,90],[-19,64],[-12,10],[15,-131],[-12,-125],[-27,-5],[-42,70],[-26,30],[-15,150],[-11,-68],[-13,-22],[-44,54],[-14,-20],[-10,50],[-12,-18],[-3,-54],[45,-35],[7,7],[45,-44],[33,-66],[30,-104],[-11,-44],[-24,-44],[6,-11],[33,44],[7,30],[27,1],[7,-105],[26,-78],[16,-157],[-19,-44],[-43,-32],[-11,10],[9,47],[-18,16],[-12,-17],[7,-39],[-10,-37],[-43,22],[-11,-23],[5,-60],[-8,-35],[-29,5],[-8,78],[-36,35],[3,15],[-28,74],[-17,19],[-29,-19],[-35,70],[-16,15],[-56,107],[-51,75],[-2,50],[-30,70],[-37,64],[-5,28],[4,75],[-15,48],[-55,121],[-30,47],[-96,89],[-36,71],[-43,66],[-98,104],[-42,49],[-91,144],[-30,39],[5,29],[31,89],[24,-14],[-9,-27],[24,3],[0,43],[21,70],[-22,7],[2,77],[-14,116],[7,35],[22,41],[-5,34],[16,30],[-13,56],[-19,-51],[-2,-59],[-25,-21],[-21,-72],[-1,-49],[-107,-100],[-12,-28],[-28,-28],[-95,22],[-67,36],[-26,32],[-123,125],[-17,56],[18,-10],[34,24],[11,71],[-33,131],[3,42],[-20,-17],[-31,44],[6,-50],[45,-120],[-10,-21],[-54,-51],[-39,0],[-49,55],[-61,24],[-32,23],[-81,40],[-45,11],[-59,-4],[-63,-33],[-77,-12],[-80,-28],[-54,-48],[-39,39],[-45,-26],[-64,-120],[-46,-115],[6,65],[36,103],[62,117],[46,2],[-16,66],[-49,48],[-8,25],[-10,-82],[-26,84],[-26,30],[-17,-9],[-16,27],[-71,19],[9,28],[38,23],[-42,33],[-19,-6],[-2,25],[37,156],[-15,15],[-13,-36],[-29,-22],[-1,-57],[-20,-66],[-39,12],[-70,97],[1,31],[-26,36],[-39,26],[-41,-35],[-22,27],[13,29],[31,32],[25,74],[-14,10],[-18,-49],[-79,-93],[-29,-23],[-38,5],[1,-54],[60,27],[11,-24],[2,-53],[-17,2],[-28,-37],[-18,6],[-41,-38],[-41,-77],[-12,2],[-12,48],[47,77],[-37,-12],[-17,11],[-1,54],[23,83],[13,27],[18,2],[20,-31],[24,17],[22,41],[38,13],[57,58],[42,20],[-9,25],[-19,-2],[1,71],[-11,-49],[-19,-20],[1,30],[25,65],[1,21],[-33,-58],[-45,-47],[-19,-3],[-4,30],[63,112],[-6,38],[-29,-60],[-38,-14],[-12,26],[-15,-49],[-20,-14],[-54,13],[-10,58],[27,19],[11,-9],[18,25],[40,16],[29,28],[23,65],[-25,2],[-14,-46],[-23,-19],[-45,-2],[-18,68],[-12,3],[-17,-69],[-21,-8],[-4,59],[16,26],[17,-6],[-11,44],[-3,55],[13,34],[26,114],[96,6],[-7,38],[-91,-5],[-21,-63],[-27,-26],[-21,-77],[-31,-48],[-23,12],[20,36],[-10,113],[-12,53],[18,30],[-22,10],[-14,-23],[-1,-51],[12,-63],[-14,-63],[1,-41],[-13,-15],[-26,48],[-2,-67],[-27,-45],[-21,22],[0,52],[-11,19],[-7,-73],[-9,15],[4,129],[9,62],[-15,11],[-17,-130],[9,-111],[-4,-29],[-19,-9],[1,49],[-27,34],[-7,-46],[16,-65],[-13,-8],[-38,16],[-34,-48],[-28,9],[-5,31],[14,95],[42,151],[1,53],[49,123],[16,81],[-6,18],[-73,-211],[-1,-35],[-18,-58],[-8,8],[-8,69],[-12,-1],[-3,-81],[-11,-54],[-18,-42],[-3,-64],[-16,-68],[-21,27],[-7,-44],[24,-28],[-5,-91],[10,-8],[19,85],[37,6],[11,-22],[4,-91],[-14,-45],[-31,-32],[-22,-76],[1,-63],[21,20],[17,75],[30,44],[30,-89],[0,-44],[10,-43],[-23,-192],[-26,0],[-9,52],[-19,9],[1,-36],[-27,-44],[0,-17],[28,14],[23,-27],[61,-124],[26,-85],[-15,-77],[-13,-26],[-34,-35],[-17,16],[-14,-18],[-29,-6],[9,51],[-26,67],[9,60],[-17,63],[-16,-126],[0,-62],[-12,-41],[-19,69],[-9,-8],[-7,-59],[-18,-33],[-34,50],[-29,-40],[-15,52],[-27,-21],[-22,5],[-9,28],[24,74],[-9,14],[-27,-38],[-29,-175],[-30,-42],[-9,18],[14,55],[13,84],[-15,172],[-16,5],[-5,-28],[1,-81],[13,-53],[-10,-4],[-10,-72],[-17,11],[-8,-20],[-5,-68],[-11,-17],[4,-47],[25,-31],[-6,-74],[-27,32],[-12,127],[8,37],[-11,78],[-17,6],[6,-52],[-8,-49],[5,-196],[-5,-64],[-27,74],[-1,43],[-16,28],[-34,31],[3,-40],[24,-36],[-1,-63],[-69,-158],[-32,-91],[0,-36],[-16,-10],[-9,-86],[-12,2],[-3,70],[34,211],[0,29],[-26,-65],[-19,-111],[-12,11],[-9,142],[-13,-52],[-11,2],[16,-62],[-5,-80],[-39,0],[-8,-61],[-18,-24],[-22,-55],[7,-43],[-15,-41],[-16,-10],[0,54],[-16,36],[-13,-45],[-1,-53],[-22,-17],[-24,31],[-9,-23],[-21,38],[-7,43],[-12,-36],[-21,-27],[6,-35],[-20,0],[-5,-39],[-41,-7],[-6,76],[-22,-14],[-21,22],[3,22],[-21,8],[-3,70],[8,36],[16,18],[5,71],[32,31],[9,-11],[29,51],[33,3],[0,45],[33,21],[34,62],[31,-9],[-11,69],[22,26],[3,32],[37,102],[-13,15],[-24,-22],[-60,-109],[-30,-20],[-18,-39],[-39,16],[-43,67],[-15,40],[-5,46],[18,117],[13,45],[15,133],[27,79],[17,33],[35,99],[11,98],[0,71],[23,32],[5,156],[4,27],[-18,44],[-22,163],[39,35],[5,27],[63,27],[89,164],[92,118],[51,-161],[41,-16],[13,-27],[34,112],[30,8],[36,-45],[19,10],[63,-48],[65,-20],[30,-55],[-1,27],[-22,63],[-29,36],[-38,-14],[-51,63],[-24,-1],[-40,42],[-25,68],[-39,66],[-29,28],[18,55],[24,9],[31,124],[23,18],[8,60],[46,27],[30,45],[-32,50],[-20,4],[-43,-64],[-11,-49],[-19,-14],[-12,-70],[0,-70],[-18,-31],[-25,19],[-36,7],[-74,-17],[-26,43],[-28,16],[-14,-52],[-87,-84],[-39,-154],[-36,-12],[-19,-31],[-33,2],[-39,-63],[-48,-109],[-1,-29],[26,-124],[-2,-23],[-38,25],[-19,-18],[-30,-52],[-21,-92],[-27,-29],[-32,-74],[-6,-73],[8,-34],[19,-24],[-40,-56],[-9,-67],[-13,-4],[-28,-70],[-19,-7],[-9,28],[-25,-11],[4,-68],[16,-13],[-3,-30],[25,-42],[8,-35],[-12,-73],[-19,-47],[-7,-62],[-25,-21],[-4,-22],[-39,-2],[-15,12],[-40,-31],[-18,3],[-19,-60],[23,16],[15,-20],[15,30],[19,1],[7,-50],[-16,-116],[-19,-16],[-26,-51],[-28,37],[5,-34],[-13,-18],[-18,18],[7,35],[2,75],[-22,71],[3,-119],[-9,-55],[-18,-15],[-13,25],[-6,-35],[16,-28],[-9,-53],[-49,-10],[17,-93],[-8,-32],[-27,-21],[-10,8],[-24,-45],[-12,13],[-36,-37],[5,-26],[20,-18],[-23,-32],[-7,-43],[2,-61],[-12,-44],[-24,-35],[24,-26],[-6,-59],[10,-60],[27,63],[59,-23],[16,22],[12,-22],[15,25],[22,-78],[19,-27],[19,13],[23,-34],[18,-53],[8,-53],[15,-22],[-28,-14],[-14,-118],[-12,-39],[-30,-25],[-11,-55],[-24,-33],[-48,0],[-15,-17],[-4,-94],[-12,-33],[-27,1],[-5,-20],[10,-79],[11,-32],[-27,-36],[-20,15],[-2,-45],[20,-46],[-11,-81],[-21,-30],[-6,-33],[9,-24],[-23,0],[-14,-52],[-26,66],[-9,-7],[5,-57],[-4,-40],[-21,-3],[-12,-43],[-17,16],[0,27],[-20,-1],[-4,-39],[-22,-24],[-23,31],[-28,-17],[-35,-69],[15,-52],[-9,-51],[-40,-44],[-28,-2],[1,-53],[14,-25],[-6,-40],[-20,-16],[-36,59],[-10,30],[-20,-20],[-5,-63],[1,-69],[-26,-27],[-3,-97],[-65,-7],[-21,24],[-2,-74],[8,-71],[-20,0],[-12,37],[-21,3],[-4,-39],[-32,-27],[-39,-92],[-15,-12],[-5,-44],[13,-11],[47,64],[4,-50],[-6,-53],[-15,-7],[0,-31],[18,-38],[-10,-38],[-18,-26],[-2,-49],[-26,-44],[-8,-32],[2,-42],[-32,14],[-31,-28],[-4,-70],[-12,-12],[-19,75],[-8,-53],[-27,-42],[-11,-53],[-24,-6],[5,-50],[-17,-27],[-25,43],[-24,67],[-22,-16],[0,-51],[11,-5],[1,-36],[-29,-10],[-13,-67],[6,-32],[18,-6],[5,-52],[-36,-4],[-24,-15],[-17,77],[-51,-38],[-18,-51],[-16,-3],[-9,-49],[19,-1],[27,25],[20,-17],[6,-54],[-16,-47],[-43,44],[-23,11],[-5,-70],[-33,6],[-23,21],[-20,-33],[-27,-88],[2,-44],[47,-20],[32,-36],[-3,-29],[-32,-42],[1,-23],[18,-4],[25,31],[16,-7],[-55,-78],[-23,-63],[1,-52],[-13,50],[-10,-17],[16,-66],[-6,-50],[-7,39],[-10,-2],[-2,-53],[-25,80],[0,95],[-19,-60],[8,-73],[-4,-67],[-24,-6],[3,58],[-35,1],[-16,-80],[-25,-9],[-75,-43],[-29,-22],[-7,-22],[-3,-74],[-17,46],[5,80],[-23,-19],[10,-30],[1,-104],[-16,-71],[6,-46],[-24,-81],[-32,-30],[2,52],[24,4],[-1,40],[-10,4],[2,111],[18,72],[-29,39],[-28,12],[-13,-18],[3,-45],[-12,-21],[-13,22],[-25,-13],[-9,-82],[-35,-74],[-26,-20],[-37,28],[-6,-29],[11,-44],[-20,-81],[1,-31],[-21,-37],[-12,105],[-10,13],[-14,-37],[-11,14],[-18,-31],[31,-13],[-2,-68],[-32,-10],[-16,25],[5,39],[-13,24],[-22,-22],[-19,-90],[-61,-85],[-26,2],[-11,29],[-26,-29],[-13,4],[10,156],[29,96],[1,46],[-15,16],[-31,-2],[-24,-29],[-24,-101],[4,-129],[-40,-140],[-7,-12],[-14,-85],[-21,36],[-19,-12],[13,-65],[10,-17],[1,-56],[-25,-38],[-19,33],[0,45],[-16,15],[-13,-60],[10,-49],[-17,-47],[-14,27],[-32,-8],[-16,18],[-14,74],[32,6],[-21,47],[-8,104],[-21,56],[-11,7],[-16,-33],[-10,-65],[7,-27],[14,0],[18,-70],[-11,-46],[14,-95],[0,-52],[-22,30],[-20,-19],[3,-26],[-17,-30],[-18,-7],[-22,28],[-16,59],[4,36],[-13,56],[-21,37],[-31,-25],[-10,-56],[49,-85],[4,-31],[-50,-111],[-24,-21],[-20,-33],[16,-56],[27,2],[9,24],[22,-50],[13,-83],[-26,6],[8,34],[-17,6],[-10,-28],[-16,22],[-17,62],[-25,-39],[2,-69],[-18,-1],[-28,-50],[-23,18],[-37,10],[-45,-5],[-34,-14],[-41,-40],[-29,-71],[-4,-69],[-29,-53],[-51,-33],[-29,3],[-28,28],[-9,30],[-9,74],[-10,30],[-1,55],[8,29],[44,41],[14,25],[23,110],[19,110],[-1,29],[22,54],[14,13],[25,-46],[38,39],[25,49],[25,0],[37,81],[34,20],[36,-14],[31,5],[1,-37],[28,-72],[9,-61],[-5,-50],[27,24],[-8,52],[2,37],[30,-30],[-15,42],[2,77],[-10,109],[32,46],[26,21],[42,-15],[21,14],[10,69],[-16,4],[4,28],[18,10],[7,38],[18,-4],[26,99],[3,-32],[15,-20],[21,48],[-5,83],[-20,-9],[27,68],[64,206],[33,52],[23,62],[19,13],[27,42],[25,68],[27,14],[35,39],[37,20],[89,70],[30,-9],[10,18],[45,5],[10,-10],[-20,-27],[-1,-47],[14,-2],[-3,-49],[-29,-18],[-3,-85],[38,-98],[11,22],[27,-39],[4,19],[-29,53],[-3,85],[-6,32],[26,-28],[57,3],[7,-86],[23,7],[26,-36],[7,22],[-14,40],[27,15],[-56,89],[-32,36],[1,58],[-16,-7],[39,166],[15,123],[11,56],[23,44],[36,96],[18,13],[40,74],[30,81],[82,96],[41,74],[35,39],[68,106],[17,42],[29,-68],[19,-14],[31,19],[8,59],[-13,47],[-2,46],[15,122],[29,108],[41,130],[24,62],[22,37],[40,41],[21,52],[22,87],[14,15],[26,62],[30,25],[8,-74],[18,-15],[4,41],[-10,105],[-23,-2],[-6,34],[2,95],[9,59],[25,409],[14,42],[38,16],[12,53],[-20,-9],[-34,77],[-3,62],[9,97],[20,106],[27,33],[29,101],[49,102],[4,57],[19,93],[-5,45],[13,33],[-3,43],[13,38],[-20,0],[-11,-32],[0,-38],[-21,-53],[-28,-31],[-38,-27],[-21,-31],[-29,-22],[-5,-21],[-41,-28],[-44,-61],[-79,-73],[-26,5],[-28,53],[-5,73],[-20,49],[-40,38],[2,46],[11,17],[9,167],[-12,-3],[-25,-101],[-41,-54],[-6,-58],[5,-58],[-8,-37],[-14,-12],[-3,-32],[9,-80],[16,-91],[19,-76],[-26,-87],[-28,-21],[-42,32],[-39,161],[-47,208],[-26,73],[-23,42],[-31,13],[16,65],[-16,44],[-25,-9],[-6,-87],[-15,7],[1,-65],[-29,-30],[-24,79],[3,26],[-19,19],[-11,-30],[-16,6],[-1,59],[-22,-18],[-25,61],[18,47],[-17,89],[-44,-52],[-46,-72],[-31,-62],[-20,-95],[-13,57],[-36,-33],[-94,-124],[-10,-41],[0,-49],[-41,-38],[-8,-26],[-22,-10],[-15,-44],[-20,-15],[-4,55],[-29,45],[-54,-20],[-29,33],[49,47],[15,-39],[18,12],[5,50],[25,77],[3,60],[-8,85],[1,81],[-16,74],[5,21],[-16,20],[-29,97],[-20,139],[29,128],[21,23],[24,79],[24,26],[-15,77],[-18,44],[-15,64],[-10,107],[-50,162],[-3,74],[-25,67],[-10,63],[-30,85],[-10,44],[-22,9],[-11,-37],[-2,-74],[6,-37],[-8,-56],[-12,-21],[-27,-10],[-18,21],[-19,-54],[-36,-29],[-50,-68],[-73,-48],[-88,-28],[-75,10],[-51,38],[-13,32],[-13,99],[23,18],[-18,69],[-54,62],[-32,108],[-5,34],[-33,51],[-18,62],[-42,8],[-31,42],[-47,110],[23,32],[24,55],[-2,36],[-24,6],[-38,-54],[-48,10],[-16,51],[11,32],[32,1],[57,128],[10,-4],[17,45],[-16,34],[-4,41],[32,24],[-27,7],[5,70],[27,78],[-17,3],[-18,-48],[-40,42],[-6,40],[22,49],[27,-6],[19,23],[0,45],[-17,-21],[-30,32],[-16,54],[2,23],[-20,7],[-13,35],[-10,-14],[-12,-99],[-14,-6],[-38,16],[-10,21],[-10,66],[1,129],[-11,19],[-43,10],[-18,37],[-10,98],[42,44],[6,38],[-17,46],[-30,31],[-45,-27],[0,-46],[-21,23],[-9,88],[8,147],[6,11],[-2,-107],[92,47],[0,19],[-35,20],[-20,28],[-24,82],[2,18],[36,19],[55,-8],[33,25],[-29,134],[-4,46],[3,84],[21,77],[101,278],[4,29],[27,77],[29,61],[5,70],[18,67],[21,34],[19,-4],[9,23],[-11,115],[26,188],[18,70],[38,61],[-18,24],[4,22],[58,133],[60,46],[48,11],[42,-45],[43,-11],[32,-84],[24,-6],[6,-26],[54,-88],[73,24],[61,124],[4,47],[44,29],[63,172],[23,89],[23,39],[-9,58],[14,5],[28,-28],[22,-5],[13,-77],[52,0],[45,20],[26,-20],[77,28],[48,38],[9,51],[56,128],[38,135],[0,71],[-12,81],[-23,95],[-17,121],[-1,118],[-5,52],[-71,157],[-9,32],[-41,28],[-27,1],[10,97],[27,33],[14,-25],[35,-20],[51,7],[-10,45],[31,10],[41,81],[2,114],[-42,122],[-47,68],[-25,48],[-1,-32],[-27,-48],[-20,-86],[-42,-30],[-42,42],[-59,-93],[-81,-34],[-18,-71],[-85,-103],[-21,-70],[-5,-99],[-44,-70],[-4,93],[-15,110],[-23,50],[-28,-3],[4,34],[-32,46],[-9,36],[-38,-60],[16,-45],[21,-7],[16,-39],[24,11],[2,-48],[-22,-81],[-19,-11],[-22,82],[-55,76],[-41,33],[-64,13],[-41,-27],[-27,12],[-52,3],[-45,-22],[-108,-112],[-58,-17],[-111,74],[-94,45],[-47,14],[-88,40],[-49,79],[-20,96],[1,74],[20,36],[-6,64],[-28,63],[-45,56],[-1,59],[-46,64],[-10,56],[39,-33],[33,3],[9,27],[24,15],[16,32],[-3,55],[35,61],[-38,63],[-19,9],[-29,-16],[-39,15],[-64,52],[-104,21],[-49,52],[-38,63],[-55,60],[-46,30],[-15,93]],[[2812,78476],[27,27],[-1,59],[18,0],[10,36],[0,57],[21,33],[5,57],[-10,16],[11,87],[46,106],[16,-26],[27,16],[28,-3],[-9,65],[-12,5],[9,77],[-6,26],[18,76],[40,67],[54,37],[29,-53],[31,1],[2,-23],[-21,-74],[5,-60],[-55,-95],[-65,-72],[-19,-66],[-1,-36],[-28,-81],[-15,-58],[-25,-10],[-28,-71],[-15,-17],[-4,-51],[-15,21],[-27,-49],[-54,-69],[13,45]],[[2752,78371],[29,49],[-1,-45],[-26,-25],[-2,21]],[[2615,78610],[4,50],[19,16],[4,-44],[-9,-45],[-12,-8],[-6,31]],[[2607,82847],[50,-13],[29,5],[10,-14],[-27,-68],[-23,4],[-9,46],[-20,10],[-10,30]],[[2611,78728],[8,-39],[-15,13],[7,26]],[[2547,78457],[17,17],[23,-3],[-2,19],[27,23],[19,-10],[10,-25],[-17,-105],[-30,50],[-25,-29],[-19,14],[-3,49]],[[2517,78521],[8,26],[23,-16],[1,-31],[-14,-31],[-13,16],[-5,36]],[[2497,78313],[4,72],[33,-18],[-7,-57],[-30,3]],[[2431,83489],[9,43],[22,15],[12,-10],[29,22],[-2,-56],[-32,-62],[-5,31],[-33,17]],[[2316,78170],[5,42],[40,72],[31,-27],[1,-27],[-13,-58],[-19,2],[-17,-26],[-15,-48],[-15,21],[2,49]],[[2228,78152],[9,-32],[-16,2],[7,30]],[[2183,78046],[17,42],[16,-37],[-12,-55],[-19,-1],[-2,51]],[[2036,90914],[2,37],[25,87],[-3,75],[8,18],[-5,57],[21,3],[8,-42],[-4,-48],[12,-34],[64,-57],[77,-48],[55,-20],[58,87],[58,58],[58,-14],[29,-69],[23,-15],[15,-104],[-2,-38],[53,-56],[56,-14],[22,-32],[9,-35],[36,-20],[88,-20],[14,6],[102,-55],[-27,-131],[-22,-43],[-51,35],[-43,-1],[-50,-29],[-44,-89],[-10,-61],[1,-53],[-20,-46],[-30,22],[3,24],[-26,119],[-32,62],[-50,60],[-39,-5],[-11,69],[-17,55],[-54,80],[-86,69],[-65,11],[-47,-44],[-18,-58],[-36,-34],[-28,33],[-49,36],[-24,83],[-7,56],[3,73]],[[1818,77819],[15,59],[33,49],[12,-2],[27,-39],[-1,-41],[-28,-51],[-32,-27],[-22,-1],[-4,53]],[[1695,87369],[6,69],[25,52],[11,-3],[-4,-58],[12,-54],[33,-70],[48,-63],[22,-14],[25,13],[57,-94],[-21,-19],[-9,37],[-51,8],[-26,-17],[-33,46],[-58,136],[-37,31]],[[1687,87598],[8,-5],[5,-84],[-20,42],[7,47]],[[1421,77626],[35,0],[33,-31],[9,30],[14,-2],[33,27],[25,-1],[-6,-28],[10,-29],[8,15],[31,-24],[23,16],[10,-11],[32,11],[5,-12],[41,-7],[-25,-23],[-16,6],[-14,-22],[-44,-1],[-22,-35],[-8,16],[-16,-19],[-19,4],[-18,25],[-52,3],[-9,-15],[-29,19],[-10,49],[-11,-1],[-10,40]],[[1064,77503],[55,37],[11,-28],[25,50],[3,-22],[19,38],[5,29],[18,-29],[27,8],[8,34],[6,-24],[35,37],[1,42],[44,10],[-13,41],[43,-5],[13,34],[-1,36],[-32,7],[-23,29],[5,26],[21,-16],[12,36],[-2,39],[38,46],[33,-32],[22,-76],[1,-31],[-21,-85],[-34,8],[-4,-43],[33,-79],[-3,-24],[-15,21],[-17,-10],[-4,-27],[-16,-4],[-20,23],[-19,-95],[-25,31],[-64,-55],[-13,29],[-29,12],[-23,-6],[-13,-35],[-22,-8],[-33,6],[-32,25]],[[1013,77451],[17,17],[7,-29],[-22,-4],[-2,16]],[[1005,77685],[16,-19],[-11,-12],[-5,31]],[[949,77433],[5,9],[40,-3],[1,-26],[-19,3],[-22,-24],[-5,41]],[[890,77452],[11,14],[28,-1],[15,-90],[-16,5],[-17,49],[-21,23]],[[821,77563],[14,45],[26,-9],[23,-80],[-20,-38],[15,-56],[-13,-34],[-18,-2],[-18,22],[3,57],[-7,2],[-8,77],[3,16]],[[811,77269],[5,56],[12,10],[10,-27],[19,10],[-12,22],[34,30],[10,-23],[-2,-55],[-23,0],[13,-52],[-29,29],[2,-40],[-12,12],[-5,-39],[-7,45],[-15,22]],[[601,77040],[11,67],[15,16],[7,36],[-13,66],[4,27],[32,7],[7,59],[-13,69],[10,45],[15,4],[18,-20],[19,59],[9,-14],[3,-74],[-20,-29],[-2,-50],[13,-20],[19,4],[31,26],[30,5],[7,-64],[-7,-88],[-15,-12],[-36,18],[-13,-52],[-18,-12],[-13,-41],[-23,31],[-6,-25],[6,-48],[-11,17],[-13,-26],[-4,55],[-14,29],[-19,-108],[-14,11],[-2,32]],[[469,77371],[13,9],[2,-26],[-14,-17],[-1,34]],[[402,77131],[18,33],[24,-17],[26,34],[50,39],[21,43],[2,128],[12,16],[16,-10],[15,-44],[-26,-98],[5,-86],[-7,-38],[-33,-31],[-36,61],[-27,-33],[-40,-10],[-1,-43],[-10,5],[-9,51]],[[257,77332],[8,29],[29,17],[39,-5],[11,-42],[-2,-30],[19,-32],[15,17],[18,-17],[33,34],[-10,-40],[-41,-32],[-12,-71],[4,-31],[-12,-31],[-8,16],[-9,-44],[8,-57],[-8,-5],[-9,56],[-14,-24],[-16,48],[-13,8],[4,28],[41,25],[-3,64],[-20,1],[-13,34],[-39,66],[0,18]],[[130,77016],[32,-12],[-3,-18],[-27,7],[-2,23]],[[81,76979],[27,-17],[7,-23],[-25,5],[-9,35]],[[77,77233],[14,52],[20,-35],[0,-61],[-19,-10],[-15,54]],[[43,76751],[8,25],[10,-22],[5,-50],[-12,-2],[-10,-32],[-1,81]],[[3,76640],[12,18],[6,-59],[-18,-25],[0,66]],[[99917,77451],[12,-2],[12,35],[26,14],[31,-61],[-9,-68],[-24,-42],[-12,-5],[-25,29],[-11,29],[0,71]],[[99678,77049],[5,24],[26,-29],[19,3],[27,-24],[4,-31],[24,-42],[27,-78],[25,-26],[11,-57],[44,-11],[21,-33],[-18,-19],[-9,14],[-29,-16],[-15,41],[-41,72],[-30,101],[-30,43],[-17,-8],[-22,25],[-22,51]],[[99628,77446],[9,11],[20,-16],[11,-33],[-14,-49],[-10,-4],[-16,91]],[[99570,77271],[19,-7],[21,-67],[-22,15],[-18,59]],[[99530,77510],[7,22],[17,-22],[3,-34],[-17,-20],[-10,54]],[[99282,77351],[24,27],[15,50],[39,26],[6,63],[16,96],[11,18],[20,-52],[-12,-32],[-8,-57],[-20,-53],[21,-18],[0,-35],[-13,-10],[-42,17],[-17,-31],[-4,-70],[-11,2],[-25,40],[0,19]],[[98911,77903],[26,-13],[-18,-27],[-8,40]],[[98408,78327],[22,-8],[3,-26],[-24,15],[-1,19]],[[98376,78346],[14,-8],[0,-29],[-14,37]],[[98352,78374],[20,-27],[-12,-2],[-8,29]],[[98210,77943],[6,31],[19,27],[23,-6],[26,67],[41,5],[-17,-40],[-5,-37],[10,-104],[-21,0],[-17,52],[-35,-19],[-30,24]],[[97960,78551],[47,86],[33,11],[100,-20],[29,-63],[24,-15],[35,-94],[2,-18],[-35,-8],[-21,38],[-17,-71],[-9,-13],[-38,15],[-26,-41],[-27,32],[-12,40],[-3,63],[-32,56],[-35,-24],[-15,26]],[[13347,81071],[9,23],[10,-28],[-5,-52],[-16,34],[2,23]],[[13279,80906],[61,56],[7,-80],[13,-14],[-20,-68],[-24,-1],[-33,63],[-4,44]],[[13241,80901],[26,65],[8,-25],[-26,-58],[-8,18]],[[13234,81005],[16,62],[-2,43],[13,20],[-14,43],[-2,70],[5,39],[11,9],[19,-32],[5,-35],[13,-7],[17,-40],[0,-165],[-9,-34],[-27,-2],[-13,32],[-23,-36],[-9,33]],[[13172,81388],[4,66],[6,1],[52,-135],[-12,-28],[-1,-68],[-15,-111],[-23,74],[-9,113],[-2,88]],[[12999,82714],[4,48],[9,-30],[-13,-18]],[[12979,82569],[2,29],[21,40],[21,-38],[-1,-22],[-24,-37],[-19,28]],[[12954,82690],[20,33],[17,52],[-5,-50],[-18,-75],[-14,40]],[[12888,80934],[18,6],[-4,-53],[-14,47]],[[12850,82395],[7,53],[10,-24],[22,-97],[10,-68],[-13,-15],[-21,61],[-9,4],[-6,86]],[[12838,82543],[18,86],[21,30],[30,-20],[24,22],[28,-42],[4,-36],[-18,-53],[6,-82],[-16,-19],[-44,-22],[-23,65],[-24,29],[-6,42]],[[12768,81460],[21,27],[-2,-46],[-16,-11],[-3,30]],[[12700,80811],[9,0],[10,-128],[-15,29],[-4,99]],[[12674,81692],[9,23],[1,61],[20,-30],[1,-32],[-22,-72],[-9,50]],[[12659,81749],[12,9],[-1,-36],[-11,27]],[[12637,81497],[8,92],[8,25],[32,-9],[10,-16],[-2,-35],[-16,-42],[8,-16],[20,40],[5,43],[13,-19],[19,68],[19,-2],[16,-39],[-5,-60],[-15,-35],[-19,15],[-13,-35],[17,-22],[-2,-37],[-22,-21],[-22,-50],[-9,-97],[-23,78],[17,61],[-1,78],[-29,51],[-14,-16]],[[12629,82086],[11,22],[24,102],[28,10],[11,20],[-22,13],[-1,47],[15,-22],[9,34],[-36,62],[14,29],[-10,86],[23,49],[45,-24],[71,-17],[24,-82],[11,-73],[-5,-69],[14,-6],[13,-68],[17,-48],[17,5],[57,-119],[12,-52],[33,-111],[3,-126],[29,-29],[8,-82],[8,-32],[31,-50],[13,-58],[-10,-6],[-19,46],[-75,98],[-3,-31],[-23,-74],[11,-8],[14,47],[8,-19],[23,10],[5,-37],[20,-13],[10,-29],[-38,-14],[8,-36],[32,21],[14,-52],[16,-14],[11,-87],[8,-9],[-12,-49],[-20,9],[2,-32],[22,-22],[11,8],[3,46],[14,36],[9,-21],[5,-91],[-15,-34],[4,-36],[-22,-94],[-29,-40],[18,-23],[27,59],[15,-10],[0,-203],[7,-72],[-20,-105],[-37,-9],[-26,48],[-14,-19],[-17,38],[-1,37],[-38,-2],[17,53],[27,-10],[1,39],[-19,42],[-19,13],[-35,78],[9,38],[10,115],[-15,9],[-11,-58],[7,101],[8,28],[-11,39],[-5,-55],[-27,-21],[14,-103],[-18,-58],[-47,56],[-4,35],[17,58],[-18,100],[-20,-5],[-10,50],[-21,3],[12,-78],[18,-65],[6,-72],[-7,-36],[15,-17],[20,-145],[24,-26],[-4,58],[24,18],[28,-65],[4,-124],[-14,-16],[-18,74],[-7,-7],[23,-170],[-29,0],[-26,32],[-2,60],[-20,40],[-49,177],[-10,22],[-2,84],[-12,10],[-8,61],[29,8],[-27,33],[3,119],[-33,-28],[-10,26],[-18,-19],[-9,42],[6,84],[33,30],[11,-63],[17,20],[-13,29],[6,39],[14,20],[14,-14],[22,44],[-29,96],[14,12],[-16,32],[4,66],[-24,-21],[-49,87],[-4,28],[16,-1],[-9,50],[3,35],[-27,18],[6,-57],[-10,-13],[-32,39],[-16,58],[12,52],[28,14],[37,-54],[28,35],[-17,67],[-18,16],[-12,-20],[-9,17],[8,30],[-2,42],[7,63],[-5,16],[-13,-47],[-27,-65],[-22,-33],[-23,38],[-5,45]],[[12611,83642],[15,25],[14,-33],[-27,-31],[-2,39]],[[12594,82026],[14,28],[11,-6],[4,-52],[-8,-48],[-10,3],[-11,75]],[[12476,82024],[28,22],[1,-43],[31,33],[8,75],[7,-2],[-9,-101],[-22,-24],[-20,-56],[-18,17],[8,30],[-14,49]],[[12463,83115],[17,52],[16,17],[7,33],[33,-1],[1,26],[28,-40],[11,-83],[18,-54],[31,-2],[9,-21],[10,26],[-29,44],[-13,80],[-2,55],[-35,79],[11,53],[34,26],[51,-37],[25,-9],[47,-44],[31,-20],[7,14],[57,-11],[30,-74],[14,-82],[3,-56],[9,-23],[23,-11],[16,-48],[5,-46],[33,-52],[9,-64],[15,-34],[-31,-38],[-20,-42],[-26,-24],[-16,16],[-31,4],[-43,24],[5,-48],[-23,-51],[-40,25],[-19,29],[-12,-47],[-15,-20],[-25,-2],[-17,15],[-3,87],[-11,32],[-30,-64],[13,-29],[-2,-90],[-23,-3],[-2,-31],[10,-51],[-11,-51],[-2,-62],[-17,-50],[4,-39],[-9,-64],[-10,-11],[-25,15],[-14,-103],[-15,19],[-12,52],[-7,63],[-1,109],[-10,87],[2,75],[14,48],[-3,57],[15,101],[-12,28],[-22,-1],[5,77],[-20,56],[-8,75],[2,43],[-5,91]],[[12311,84926],[43,-96],[7,-47],[14,-9],[8,-130],[19,1],[21,38],[11,-23],[20,-2],[21,-29],[54,13],[-3,-89],[25,-75],[2,-52],[21,-52],[14,-87],[17,-55],[2,-142],[21,-60],[4,-65],[-9,-2],[-5,47],[-38,120],[-10,115],[-19,37],[-9,53],[-21,0],[26,-101],[4,-34],[-13,-23],[35,-121],[23,-49],[-2,-62],[24,-113],[-19,6],[15,-102],[0,-27],[-25,-62],[-20,26],[-17,-1],[4,-34],[-21,-104],[-38,-83],[-24,-25],[-2,-33],[-31,-65],[-29,3],[-9,89],[-4,135],[21,80],[15,23],[-16,31],[-1,69],[14,6],[12,-39],[6,23],[-40,141],[-1,58],[-18,60],[-5,82],[-11,43],[8,125],[-12,81],[-3,95],[-11,91],[4,44],[-20,93],[-17,45],[-9,77],[-6,101],[3,42]],[[12292,85061],[35,-45],[27,-125],[-10,-5],[-22,115],[-23,19],[-7,41]],[[12202,85643],[15,-71],[0,-46],[-10,29],[-5,88]],[[12106,83714],[16,11],[1,26],[28,65],[-4,68],[36,64],[18,-12],[25,-85],[15,10],[18,-58],[23,-24],[38,4],[22,-14],[12,-79],[-2,-49],[-20,35],[-19,-2],[-1,-22],[21,-25],[11,-46],[29,-278],[-1,-71],[12,-56],[0,-58],[18,-142],[5,-107],[-5,-112],[-11,1],[8,-81],[3,-240],[-9,-111],[-11,6],[-28,70],[-10,86],[-21,59],[-40,212],[4,48],[22,23],[-18,30],[-26,-31],[-14,88],[-11,-15],[-17,42],[-12,55],[2,34],[-14,-22],[-10,24],[-30,2],[-19,96],[19,3],[10,-29],[10,13],[-3,105],[19,53],[6,38],[-39,86],[24,63],[-4,22],[14,35],[4,53],[-33,16],[-21,-28],[-14,79],[-26,72]],[[12097,84881],[16,18],[19,-7],[16,-52],[-29,-6],[-22,47]],[[12062,83572],[4,48],[-3,66],[25,9],[34,-62],[15,-74],[12,-19],[17,30],[23,-10],[-16,-82],[-24,-14],[-27,-161],[-12,6],[-40,-30],[-9,8],[3,102],[25,47],[1,50],[-22,4],[2,29],[-13,31],[5,22]],[[11978,85151],[9,14],[7,-59],[-16,45]],[[11978,84786],[30,41],[3,-53],[-16,-19],[-17,31]],[[11861,84371],[5,174],[16,33],[8,-9],[29,60],[3,51],[-12,92],[32,-2],[0,-54],[12,-60],[28,61],[29,-6],[17,-20],[17,49],[36,50],[14,-55],[41,-30],[25,-53],[-12,-78],[-31,-76],[4,-49],[12,-5],[8,60],[32,108],[15,12],[34,-55],[46,-10],[11,-32],[29,-16],[15,-79],[-4,-67],[-22,-44],[-37,49],[-10,-8],[12,-40],[18,-18],[33,-75],[-21,-29],[-25,-2],[4,-28],[21,-13],[23,24],[7,-95],[14,-69],[12,-143],[-14,-42],[-42,-11],[-17,12],[-44,95],[-65,99],[-27,50],[-22,-26],[-9,29],[-4,-32],[30,-55],[22,-8],[-21,-31],[6,-25],[0,-72],[-9,-50],[-31,-87],[-51,47],[-1,38],[-42,85],[-20,90],[-12,-38],[-19,43],[-10,79],[4,25],[-18,86],[2,24],[-16,57],[-26,30],[-7,49],[-25,36]],[[9331,87212],[28,-14],[12,-44],[-27,-9],[-13,67]],[[9232,87245],[16,14],[58,-26],[-3,-31],[-21,-10],[-50,53]],[[8867,87809],[26,35],[27,3],[15,-16],[-18,-53],[-50,31]],[[8817,87545],[4,86],[28,16],[21,-89],[-11,-44],[-37,-10],[-5,41]],[[8816,87079],[2,14],[43,47],[1,-36],[-40,-59],[-6,34]],[[8698,86532],[8,21],[3,71],[23,12],[-3,42],[21,54],[16,7],[-3,41],[30,34],[9,30],[43,75],[22,118],[27,44],[-3,40],[10,71],[27,34],[4,-43],[24,2],[-17,-51],[9,-17],[24,28],[8,-22],[-11,-37],[-62,-118],[-49,-129],[-8,-80],[-33,-60],[30,-57],[-19,-42],[-23,-8],[-22,15],[-17,-57],[-9,6],[-45,-47],[-14,23]],[[8692,87068],[44,270],[11,-41],[12,13],[-4,66],[44,84],[0,-54],[-12,-32],[-3,-82],[-20,-37],[20,-42],[-24,-97],[2,-46],[-17,-104],[-24,45],[-3,25],[-25,7],[-1,25]],[[8672,87628],[15,31],[17,-19],[17,-48],[-24,-45],[-25,81]],[[17950,55027],[5,31],[24,-13],[25,26],[-2,40],[18,63],[1,79],[-15,136],[-16,8],[-7,-13],[-13,25],[-3,-17],[-14,68],[7,67],[2,142],[-15,41],[9,65],[-8,51],[19,9],[28,138],[9,24],[-4,46],[4,110],[8,12],[-2,74],[-7,64],[1,51],[6,6],[-2,55],[-7,20],[28,116],[0,69],[8,28],[23,29],[10,40],[17,21],[1,19],[25,65],[-1,49],[-11,54],[-14,19],[-31,100],[-13,7],[2,58],[-26,239],[-23,63],[-7,69],[-16,57],[1,147]],[[17974,57684],[6,95],[-10,22],[21,43],[0,72],[-9,178],[-6,65],[-11,47],[-4,58],[6,36],[0,103],[-9,38],[3,39],[-7,31],[3,51],[-5,59],[4,56],[9,24],[-10,31],[-12,97],[4,43],[-7,80],[25,31],[9,29],[5,-14],[12,25],[17,-1],[2,-25],[24,19],[13,-3],[18,-71],[-2,-28],[21,-51],[24,11],[24,183],[5,15],[1,230],[-2,272],[0,437]],[[18136,60011],[200,0],[222,0],[313,1],[97,1],[160,2],[6,-7],[235,0],[162,1]],[[19531,60009],[0,-1691],[-1,-237],[1,-30],[0,-925],[-1,-608],[1,-145],[-1,-113],[0,-2847]],[[19530,53413],[-64,2],[-201,-1],[-128,-1],[-172,0],[-359,476],[-212,269],[-102,136],[-368,471],[5,66],[-5,17],[1,60],[8,16],[17,103]],[[19530,64667],[242,0],[154,2],[327,0],[66,-5],[137,-1],[242,1],[7,2],[217,2]],[[20922,64668],[282,1],[135,0],[140,0],[0,-1163]],[[21479,63506],[1,-381],[0,-434],[1,-193],[0,-1270],[1,-137],[0,-1089]],[[21482,60002],[-183,3],[-22,5],[-62,1]],[[21215,60011],[-204,-3],[-169,-5],[-184,0],[-34,2],[-301,-1],[-186,-2],[-2,9],[-152,-1],[-230,-1],[-222,0]],[[19531,60009],[0,583],[1,36],[0,738],[-5,129],[0,517],[2,216],[0,1857],[1,46],[0,536]],[[27414,45876],[14,60],[5,-33],[-14,-44],[-5,17]],[[27386,45813],[9,39],[11,4],[-5,-33],[-15,-10]],[[27310,45701],[52,90],[6,-30],[-45,-80],[-13,20]],[[27118,45540],[19,106],[20,46],[25,43],[3,23],[36,66],[38,-67],[4,-52],[14,-43],[-4,-11],[-40,-48],[-3,27],[-27,-5],[-3,-24],[-46,-73],[-36,-15],[0,27]],[[27062,45510],[39,24],[-10,-43],[-17,-14],[-13,8],[1,25]],[[27020,45533],[6,35],[12,-10],[-5,-41],[-13,16]],[[26992,48019],[5,-18],[19,-211],[8,-28],[17,-26],[7,17],[14,-21],[-14,-31],[-9,-1],[-21,50],[-7,28],[-13,115],[-6,76],[0,50]],[[26806,45614],[15,13],[4,-23],[-20,-10],[1,20]],[[26322,51623],[29,47],[0,-29],[-16,-37],[-11,-6],[-2,25]],[[26229,53027],[6,-79],[11,-52],[2,-83],[6,-75],[14,-48],[136,-25],[261,-56],[206,-51],[135,-34],[-5,-14],[2,-57],[7,-26],[-3,-71],[11,-76],[37,13],[0,75],[6,47],[3,119],[-12,91],[4,60],[-1,49],[8,16],[-4,24],[12,-8],[9,59],[15,-7],[7,-33],[17,-3],[18,-28],[7,-25],[33,-19],[17,-18],[14,15],[13,-19]],[[27221,52688],[4,-13],[-4,-113],[3,-92],[-4,-22],[10,-25],[4,-95],[1,-113],[23,-389],[13,-129],[0,-51],[28,-302],[32,-288],[29,-229],[65,-412],[38,-200],[4,-63],[10,-83],[-18,-57],[-4,-54],[-1,-87],[5,-130],[6,-96],[16,-145],[35,-269],[15,-166],[5,-84],[5,-29],[11,-140],[17,-152],[9,-66],[6,-94],[13,-109],[17,-258],[-1,-235],[-7,-175],[-5,-210],[-3,-37],[-8,-286],[0,-169],[-3,-80],[-7,-81],[0,-44],[-6,23],[3,51],[-5,20],[-16,-25],[-10,-102],[-6,-17],[-1,-64],[-8,-40],[-2,-78],[5,-33],[-2,-46],[6,-16],[-8,-53],[-8,-13],[-1,-49],[21,39],[25,194],[7,41],[0,-41],[-8,-83],[-34,-222],[-9,-82],[-25,-93],[-34,-139],[-24,-66],[-3,12],[34,122],[14,40],[7,53],[3,81],[5,32],[-6,23],[-9,-11],[-7,26],[-6,-18],[-34,-22],[-14,-41],[-9,-6],[-18,45],[-18,-13],[-7,-41],[-27,-18],[-23,-6],[-17,52],[-8,68],[2,79],[6,60],[6,-3],[-2,49],[-12,97],[-11,47],[2,34],[-8,62],[-11,32],[-5,85],[-6,18],[-11,-15],[-9,101],[-24,31],[-1,16],[-21,38],[-21,55],[-11,-13],[-8,-39],[-16,126],[-15,148],[-5,173],[-7,109],[-7,57],[-28,113],[-11,9],[-1,52],[-12,23],[0,-64],[-14,-11],[-1,66],[-8,113],[-12,51],[3,24],[13,-3],[9,-39],[11,159],[-2,86],[-8,14],[0,40],[8,10],[-4,31],[-12,-4],[-5,-33],[-11,-11],[8,-148],[-9,-20],[-20,-11],[-5,-50],[0,75],[-6,50],[-17,94],[-26,177],[-9,94],[-19,140],[-27,149],[-14,56],[-4,58],[-10,61],[10,-19],[1,-30],[15,30],[10,72],[12,28],[13,98],[13,34],[-2,23],[14,26],[11,84],[-5,75],[-22,21],[5,-113],[-22,30],[6,34],[-1,65],[-5,39],[-38,71],[1,-65],[-11,-28],[11,-37],[16,-6],[11,-110],[-10,-42],[0,-62],[-4,-27],[-21,-6],[-3,-32],[7,-38],[-9,-30],[-4,40],[2,83],[-14,85],[-9,26],[-8,58],[6,182],[-5,66],[-4,164],[9,1],[0,-93],[4,-89],[9,-7],[-4,153],[9,37],[1,41],[8,44],[0,38],[7,50],[0,39],[9,47],[1,91],[5,83],[-6,66],[2,56],[-13,29],[4,42],[-9,109],[12,64],[-21,110],[3,31],[-8,55],[-10,3],[5,33],[-1,49],[-7,13],[-47,23],[-9,-51],[-7,-4],[-9,100],[3,45],[-14,32],[-12,9],[-2,63],[-7,58],[-11,45],[-15,6],[-5,44],[-24,48],[0,111],[-4,67],[-12,7],[-10,38],[-13,17],[-13,61],[0,42],[-9,35],[-5,51],[-14,44],[-28,62],[-40,72],[-26,75],[-11,-2],[-26,-33],[-31,29],[-1,-35],[-26,-69],[9,-99],[-3,-28],[-10,-7],[-15,15],[-5,26],[-24,-22],[-31,-73],[-65,-132],[-6,2],[7,44],[-10,12],[-7,-39],[-15,-41],[-36,1],[13,-49],[2,-38],[16,-22],[30,53],[29,40],[27,84],[3,-13],[-24,-82],[-28,-43],[-35,-66],[-12,-14],[-10,33],[-16,22],[-23,51],[-19,7],[-17,-28],[-13,94],[-5,119],[8,42],[0,-105],[6,-91],[7,-22],[10,39],[1,97],[-17,105],[-18,60],[-17,13],[-15,40],[-16,71],[-27,47],[-22,69],[-41,95],[-47,76],[-58,70],[-31,20],[-62,18],[-33,-5],[-47,-25],[-65,-49],[-32,-15],[-7,10],[-63,-51]],[[26061,57664],[39,-2],[136,6],[183,1]],[[26419,57669],[196,-2],[-1,6],[143,10]],[[26757,57683],[-3,-72],[-31,-68],[-26,-105],[1,-36],[-8,-26],[3,-64],[30,-82],[17,-7],[23,-104],[23,-51],[28,16],[8,-12],[8,-64],[3,-64],[12,-30],[3,-50],[11,-52],[0,-51],[7,-68],[12,-24],[8,-67],[14,-48],[11,-101],[9,-1],[19,-72],[29,-52],[29,-98],[4,-61],[9,-41],[1,-40],[13,-38],[12,-2],[17,-37],[18,-93],[15,-26],[4,-24],[-7,-43],[4,-39],[-4,-32],[28,-82],[-4,-30],[13,-42],[11,5],[-2,-41],[8,-45],[27,-55],[9,1],[16,-58],[19,-43],[-5,-67],[12,-64],[2,-49],[9,-15],[0,-85],[4,-32],[-5,-45],[6,-8],[4,-48],[-5,-41],[12,-48],[25,-26],[0,-23],[23,-81],[-4,-34],[15,-105],[4,4],[6,-76],[-10,-44],[11,-67],[-4,-26],[5,-62],[21,-34],[11,17],[22,-71],[9,-4]],[[27376,54230],[12,-12],[-5,-64],[-14,-29],[-10,15],[-6,-48],[10,-8],[-16,-60],[-21,23],[-3,-56],[11,-11],[-9,-59],[-17,-54],[-17,13],[-3,-16],[12,-33],[8,5],[-1,-84],[-7,-62],[-28,-26],[0,-22],[17,10],[6,-24],[-23,-131],[-6,-91],[7,-13],[-5,-30],[-5,-97],[-13,-22],[-8,-59],[-9,-3],[0,-71],[-7,-69],[-7,2],[-12,-44],[13,-24],[11,24],[1,-81],[-16,-161],[5,-70]],[[25527,65491],[15,-41],[12,20],[7,-15],[-6,-40],[27,-23],[29,1],[28,25],[52,75],[31,59]],[[25722,65552],[90,-1],[198,-1],[187,1],[87,1],[0,-75]],[[26284,65477],[1,-242],[0,-1380],[-3,-437],[0,-441],[-2,-278],[0,-238]],[[26280,62461],[-19,-45],[-2,-20],[16,-71],[2,-31],[-11,-38],[3,-37],[17,-7],[4,-25],[-13,-46],[6,-44],[-22,3],[-16,-23],[-9,5],[-35,-63],[-14,-39],[-19,10],[-10,43],[-26,-7],[-16,7],[-12,-33],[4,-125],[6,-71],[-16,-40],[-7,-44],[-30,-34],[-19,-161],[-19,-39],[-14,24],[-10,-13],[-6,-63],[-16,-72],[1,-87],[-5,-70],[-8,-24],[-23,-18],[-4,-36],[-13,58],[-22,1],[-26,55],[-1,94],[-21,67],[-8,-2],[1,-34],[13,-12],[-1,-25],[-13,-2],[-8,-29],[-8,23],[-9,-29],[9,-17],[-6,-42],[-18,-9],[-2,-94],[5,-38],[-23,-9],[-2,-63],[-11,-29],[-7,24],[5,51],[-10,10],[-10,-25],[-10,22],[-12,89],[-17,-2],[-14,-52],[-29,-27],[-10,-30],[-5,-97],[-7,-27],[-11,-3],[-8,62],[-18,13],[-22,57],[-22,44],[-20,6],[-14,-37],[-14,19],[-6,49],[-8,6],[-7,-66],[11,-64],[-13,-40],[-11,3],[3,56],[-5,30],[-42,-31],[-11,52],[-9,4],[-10,-40],[10,-91],[-12,-47],[-23,32]],[[25386,60941],[-11,2],[-4,34],[12,-9],[-16,92],[24,-8],[-15,29],[15,67],[1,60],[-8,26],[19,19],[2,38],[-12,-19],[22,73],[-14,60],[-4,59],[9,-10],[9,68],[5,-35],[7,41],[8,-33],[13,102],[8,9],[13,84],[-2,38],[24,42],[0,66],[9,83],[7,32],[14,12],[14,76],[-1,42],[-15,94],[11,111],[-18,40],[1,79],[-16,55],[-3,73],[19,60],[-9,50],[2,60],[6,32],[13,9],[0,347],[-1,0],[0,397],[1,12],[0,294],[1,247],[0,1196],[1,254]],[[21479,63506],[257,-1],[104,0],[263,-1],[273,1],[163,0],[279,-1],[263,-1],[144,0],[133,0]],[[23358,63503],[16,-60],[13,-11],[1,-43],[13,6],[5,-36],[26,-14],[8,41],[24,-13],[-4,-28],[7,-33],[11,-11],[-4,-42],[-9,-1],[3,-36],[12,16],[-1,-49],[-10,-6],[-13,24],[-5,-75],[-15,-19],[-7,-41],[2,-41],[-17,-24],[1,-48],[15,-41],[1,-29],[16,-31],[12,-61],[14,0],[5,-21],[-9,-25],[6,-79],[18,-52],[-3,-28],[15,-13],[5,-31],[14,-11],[9,16],[5,-31],[20,-3],[-5,-41],[0,-444],[-1,-120],[0,-696],[-1,-52],[0,-779],[-1,-97],[0,-281]],[[23550,60009],[-249,1],[-196,-1],[-169,0],[-218,0],[-208,-1],[-258,2],[-103,0],[-154,3],[-149,-4],[-209,-4],[-155,-3]],[[30863,68384],[14,7],[-7,-35],[-7,28]],[[30827,68345],[7,83],[6,-34],[19,-55],[-15,-45],[-5,34],[-12,17]],[[30819,68560],[3,42],[11,-71],[-14,29]],[[30732,68434],[14,2],[3,-41],[-17,39]],[[30712,67988],[8,37],[1,-75],[-9,38]],[[30703,68290],[8,41],[25,45],[11,-50],[-9,-8],[14,-78],[-11,-39],[-18,-13],[-12,24],[5,25],[-3,50],[-10,3]],[[30697,68452],[13,68],[2,64],[9,25],[6,-26],[-9,-35],[1,-36],[-8,-70],[-10,-29],[-4,39]],[[30213,67064],[-35,81],[0,69],[6,42],[-41,128],[-9,53],[8,101],[-4,10],[6,88],[-6,23],[-5,313],[0,89],[-11,861],[-15,757]],[[30107,69679],[21,15],[0,33],[25,-41],[-1,-38],[7,-43],[11,-15],[13,85],[2,86],[-6,28],[12,36],[8,-3],[12,-44],[21,-9],[1,39],[-24,83],[-1,32],[22,107],[14,27],[11,43],[8,-1],[15,41],[24,38],[-9,71],[21,66],[23,45],[5,56],[-7,28],[-14,0],[0,66],[10,38],[-8,14],[15,51],[5,46],[-15,44],[16,115],[8,18],[-1,37],[17,32],[14,59],[11,8],[17,324],[215,890],[13,-3],[27,-38],[11,4],[-3,-58],[1,-141],[4,-18],[37,-73],[25,43],[26,30],[28,2],[11,52],[30,11],[25,-12],[0,62],[16,23],[25,-6],[23,-36],[4,-32],[33,-68],[36,-132],[0,-15],[28,-51],[0,-545],[3,-693],[-1,-71],[9,-30],[-15,-39],[14,-70],[-15,-34],[1,-136],[23,-18],[3,20],[10,-57],[19,-28],[30,-23],[14,19],[8,-62],[1,-56],[-13,8],[-11,-22],[7,-68],[16,-63],[-9,-73],[-10,-41],[23,-116],[0,-23],[18,-40],[13,28],[1,46],[18,-30],[19,-3],[13,-56],[6,-51],[-8,-14],[10,-32],[12,-98],[15,-38],[1,-118],[-12,-50],[-10,2],[-4,-32],[-32,-113],[-24,-25],[4,-22],[-15,-8],[6,42],[-4,85],[-27,-30],[12,-58],[-12,-43],[-11,13],[-13,-58],[-13,18],[-10,-12],[2,-35],[16,-40],[-22,-57],[-13,46],[-6,57],[-13,-10],[-3,-38],[-8,3],[-7,59],[-7,-62],[-9,-14],[-8,-74],[-7,19],[-6,-48],[-4,42],[-20,-51],[-5,27],[-12,-92],[-16,39],[0,36],[-10,-21],[-11,9],[2,-66],[-16,-71],[11,-33],[-35,-16],[-23,32],[-16,107],[6,29],[22,27],[-9,45],[-13,-35],[2,44],[-10,-3],[1,-68],[-5,0],[0,64],[-24,-56],[5,-35],[-6,-43],[14,-67],[-3,-45],[-23,-77],[9,-11],[-12,-31],[11,-56],[-5,-69],[-16,-10],[-3,85],[6,4],[-3,55],[-17,45],[-4,64],[15,51],[-19,40],[6,26],[-10,10],[-18,-21],[1,113],[11,44],[1,50],[-7,14],[-7,-46],[-14,-40],[-11,33],[-7,-32],[-15,-4],[14,-81],[-3,-48],[-12,-23],[-10,-71],[-4,-72],[-13,-78],[19,-30],[-13,-28],[10,-57],[-10,-38],[-27,4],[-13,-72],[-15,-1],[-2,-58],[-11,-9],[0,52],[7,37],[-9,15],[-3,-30],[-12,-13],[5,65],[-18,-9],[1,-52],[-16,-37],[-5,-50],[-12,51],[-2,-47],[-15,-32],[-12,26],[-3,-66],[-13,51],[-13,-92],[-23,-27],[-5,-19],[-5,83],[-16,5],[-15,-42],[-5,-39],[-20,4],[-7,-49],[-20,4],[-10,-49],[-3,-50],[5,-29],[-8,-32],[-13,29],[-22,-31],[-9,-46],[6,-67],[-8,-43],[-10,-15],[3,-33],[-14,-24],[-14,4],[-10,-25],[-11,-98],[5,-19],[-14,-80],[1,-22],[-14,-74],[-9,-13]],[[30332,65028],[13,-24],[29,5],[18,17],[12,70],[16,-105],[-1,-30],[-10,-16],[-33,4],[-41,60],[-3,19]],[[30177,65078],[18,0],[19,90],[27,60],[11,-15],[7,-70],[15,-27],[10,40],[-1,-84],[-41,1],[-31,-9],[-18,-47],[-16,61]],[[29500,66699],[224,-22]],[[29724,66677],[199,-23],[126,-12],[10,46],[21,1],[-1,62],[15,36],[19,-18],[9,62],[36,32],[15,-30],[8,13]],[[30181,66846],[2,-72],[9,-136],[25,-47],[12,42],[14,-34],[-16,-90],[-23,-7],[-38,-35],[12,-50],[-18,-50],[-7,9],[-5,-59],[-4,41],[-11,-53],[11,-74],[-13,10],[-5,-28],[8,-26],[-5,-27],[14,-14],[6,36],[14,8],[9,-47],[24,-28],[12,-42],[2,-46],[21,-93],[-1,-50],[-7,-39],[-12,-5],[3,-24],[21,-51],[12,8],[8,-24],[8,-83],[-5,-50],[13,-48],[23,-35],[34,-12],[9,-23],[19,44],[19,8],[27,33],[6,25],[-1,79],[-6,61],[-13,-31],[0,97],[-5,55],[-15,34],[-9,-7],[-5,-39],[-11,59],[13,11],[21,-18],[23,-58],[18,-123],[9,-119],[2,-137],[-15,-129],[-2,-44],[-7,9],[12,112],[-7,23],[-26,-5],[-43,-40],[-30,8],[-7,-28],[-17,-7],[-15,-62],[-33,-10],[-34,-66],[-16,-47],[-21,-28],[-23,-15],[6,26],[35,34],[16,47],[24,49],[5,40],[-2,117],[6,41],[-26,26],[0,-59],[-7,14],[-4,-50],[-14,3],[2,-32],[-31,-11],[-7,-49],[2,-44],[-6,-29],[-25,-23],[-12,17],[-10,-14]],[[30097,65246],[-3,189],[-18,18]],[[30076,65453],[-8,41]],[[30068,65494],[-10,48],[-19,33],[-5,56],[2,81],[-12,-6],[0,147],[-116,-13]],[[29908,65840],[-1,18],[-202,13],[-22,-4],[-42,6],[-3,-39],[-14,-6],[1,45],[-54,3],[-118,14],[-15,-1]],[[29438,65889],[-6,42],[34,395],[34,373]],[[22823,73980],[83,-1],[266,0],[229,-1],[0,449],[27,-37],[28,20],[29,-53],[8,-35],[14,-202],[7,-25],[18,-251],[-6,-69],[4,-54],[14,-43],[29,-45],[24,-12],[8,19],[44,-11],[11,-58],[61,-7],[48,-21],[8,-66],[-3,-49],[6,-12],[42,2],[5,15],[22,-2],[23,20],[-1,48],[33,46],[39,18],[9,-22],[53,0],[72,-98],[26,4],[1,-49],[-19,-7],[-4,-37],[16,-31],[41,13],[15,-54],[-6,-34],[6,-49],[24,-127],[25,27],[-8,84],[13,45],[15,-11],[42,16],[16,-44],[-2,-65],[17,-41],[14,9],[9,-36],[41,-9],[5,-67],[-4,-31],[20,-21],[23,13],[-3,-75],[22,28],[14,-22],[19,24],[34,17],[46,113],[17,13],[13,32],[25,30],[14,-13],[0,-67],[17,-17],[-6,-26],[10,-48],[16,-3],[35,29],[6,-29],[25,15],[26,-18],[19,13],[48,8],[29,-28],[9,-66],[34,-53],[15,35],[20,9],[13,-20],[23,6],[11,-18],[25,22],[-27,-56],[-10,20],[-4,-34],[-17,-15],[-26,-58],[-37,-34],[-14,-37],[-52,-44],[-48,-54],[-15,-6],[-42,-45],[-4,-14],[-51,-77],[-37,-79],[-72,-183],[-17,-69],[-55,-178],[-26,-72],[-26,-41],[-26,-88],[-11,-11],[-28,-83],[-10,-10],[-61,-134],[-9,-25],[8,-50],[14,-46]],[[24276,71309],[-21,50],[-14,-11],[-3,-29],[-16,-14],[9,-19],[-11,-43],[-22,16],[0,-685],[-10,-10],[-6,-59],[-24,7],[-10,-56],[-14,13],[-8,-38],[-25,-23],[-20,-47],[-20,-148],[-22,-49],[-7,-114],[1,-53],[21,-21],[10,9],[14,-32],[-1,-31],[23,-85],[-1,-50],[-15,-47],[1,-29],[-17,-49],[2,-91],[-4,-32],[6,-91],[-16,-58],[11,-34],[-2,-65],[6,-41],[-7,-42],[3,-75],[-12,-80],[5,-36],[16,-27],[31,-87],[-1,-24],[14,-16],[9,-44],[50,-9],[12,-17],[10,-78],[14,-38],[50,-51],[22,-39],[14,-40],[0,-53],[8,-15],[5,-84],[17,-45],[27,-41],[3,-29],[36,-90],[39,-29],[15,-55],[30,-136],[9,-75],[-8,-113],[2,-71],[10,-37],[-4,-44],[8,-53]],[[24498,67577],[-204,0],[-224,0],[-116,-1],[-223,0],[-180,1],[-313,0],[-199,0]],[[23039,67577],[0,1215],[1,101],[-1,302],[0,479],[-10,65],[-36,59],[-18,4],[-14,55],[-9,73],[-26,98],[5,46],[25,62],[22,39],[12,63],[14,46],[4,128]],[[23008,70412],[-4,106],[6,37],[-11,188],[-1,129],[-13,27],[-20,98],[-5,49],[-4,119],[-11,57],[-2,39],[5,68],[-6,112],[5,17],[6,117],[-6,-11],[-11,51],[1,171],[-5,92],[-2,114],[3,50],[-7,103],[1,217],[-5,3],[-7,89],[-11,92],[-8,17],[-11,101],[-3,58],[-11,34],[-5,121],[-16,101],[-3,110],[7,53],[-8,93],[3,52],[-1,107],[-7,59],[7,76],[9,24],[3,62],[-15,80],[-8,124],[-6,24],[-11,98],[3,40]],[[28860,63072],[14,65]],[[28874,63137],[9,32],[5,61],[12,42]],[[28900,63272],[17,44],[38,25],[25,45],[0,69],[16,25],[7,33],[34,72],[18,15],[12,51],[10,-8],[17,39],[-14,71],[-20,41],[-7,52],[-21,54],[-7,68],[-25,19],[-4,45],[2,95],[-10,37],[-17,-5],[-9,14],[-2,83],[7,30],[-8,22],[9,100],[11,-5],[23,113],[-24,120],[13,48],[18,29],[16,56],[-4,24],[17,35],[11,49],[14,124],[22,69],[16,13]],[[29101,65083],[88,-173],[132,-246],[3,-19],[-20,-187],[-12,-65],[-4,-65],[-6,-22]],[[29282,64306],[-7,-34]],[[29275,64272],[-37,-35],[-4,-84],[-9,-16],[-3,-50]],[[29222,64087],[0,-43],[19,-28],[16,18],[24,-44],[14,-9],[4,44],[4,-90],[-3,-107],[-14,-182],[-13,-247],[-5,-173],[-40,-241],[-11,-48],[-9,-9],[3,-32],[-10,-55],[-20,-63],[-1,-19],[-31,-55],[-32,-108],[-21,-118],[-22,-149],[-20,-60],[-19,-14],[-11,14],[6,88],[15,97],[3,69],[-21,37],[-18,4],[-6,25],[-18,-3],[-7,-36],[-9,24],[-2,47],[-18,37],[-3,30],[-10,-12],[-15,68],[-7,-8],[-18,58],[-10,56],[-19,25],[6,140],[-12,29]],[[28861,63044],[-1,28]],[[28814,58772],[18,-19],[12,-74],[1,-47],[-15,9],[2,45],[-18,86]],[[28734,57762],[8,60],[8,0],[47,86],[15,12],[14,33],[12,2],[16,35],[13,10],[5,74],[11,252],[0,54],[-8,95],[-6,105],[3,-2],[11,-106],[5,-95],[-3,-136],[-15,-286],[-24,-8],[-50,-64],[-43,-78],[-19,-43]],[[27156,59531],[84,-16],[55,-3],[95,-15],[37,4],[114,-21],[48,-2],[170,-2],[279,0],[74,4],[264,0],[106,-1],[0,10],[31,-2],[120,0],[142,0]],[[28775,59487],[2,-58],[17,-245],[16,-158],[23,-156],[35,-271],[-9,14],[-18,146],[-14,80],[-13,11],[-9,174],[-16,155],[-8,23],[3,39],[-5,89],[-10,30],[-4,48],[-25,13],[-1,40],[-13,-20],[6,-61],[16,-48],[11,10],[0,-67],[15,-135],[9,-61],[-1,-26],[11,-75],[0,-47],[-19,64],[1,37],[-13,61],[-3,38],[-12,12],[6,-38],[-3,-28],[14,-39],[-31,25],[-32,118],[-15,12],[19,-97],[10,-17],[6,-52],[-9,-23],[-24,-14],[-21,71],[7,-63],[10,-27],[-7,-14],[-31,45],[-13,5],[-5,29],[-18,24],[23,-73],[21,-23],[-7,-19],[-24,-8],[-13,-62],[-16,-22],[-17,1],[-8,31],[-20,12],[-12,121],[0,61],[12,78],[-5,13],[-14,-76],[-2,-76],[8,-94],[11,-77],[-5,-42],[8,-34],[40,10],[37,47],[9,-49],[13,6],[13,30],[26,24],[32,-1],[14,-41],[0,-43],[-14,-78],[3,-55],[2,-164],[9,5],[7,115],[3,150],[14,40],[-6,33],[14,20],[25,-21],[16,-94],[7,-65],[-4,-52],[7,-98],[-8,-25],[4,-54],[-13,-54],[-17,-10],[-6,18],[-10,-16],[-6,-40],[-10,-9],[-3,-43],[-7,-11],[-7,-71],[-13,-15],[-3,-46],[-17,-25],[-3,-24],[-26,25],[-29,-4],[-26,18],[-5,25],[-10,-14],[-15,45],[-13,115],[31,3],[5,45],[-28,-25],[-12,11],[-9,-33],[9,-57],[6,-86],[-7,0],[-29,47],[-14,-10],[-20,34],[-31,30],[-23,48],[-1,-29],[17,-61],[21,-5],[63,-102],[46,-28],[8,-31],[1,-40],[-7,-56],[-13,-54],[1,-28],[-9,-53],[-15,-42],[-50,-112],[-50,112],[1,-65],[24,-55],[36,-43],[36,80],[13,2],[27,30],[4,62],[11,-14],[3,-66],[8,-31],[18,-5],[-9,75],[20,-29],[2,-85],[-17,-75],[-18,-13],[0,-34],[-11,-20],[-14,-84],[-7,-71],[-17,20],[1,80],[-10,19],[1,-82],[-16,-7],[42,-64],[23,123],[33,120],[24,75],[47,176],[8,-21],[-28,-83],[-26,-96],[-22,-62],[-21,-78],[-18,-82],[-21,-115],[-3,-32],[-4,67],[-35,55],[-39,1],[-60,-38],[-29,-33],[-20,-32],[-32,-81],[-39,-75],[-26,-63],[-37,-113],[-14,-55],[-25,-128],[-14,-111],[-10,-112],[-9,-69],[-4,-69],[-13,7],[-3,34],[-21,21],[-23,9],[-28,-2],[-30,-12],[-35,-42],[-8,-17]],[[28030,56345],[-93,330],[-104,362],[-31,116],[-88,302],[-61,1],[-74,7],[-178,10],[4,135],[-42,199],[-30,-73],[-5,21],[7,48],[-2,53],[-55,13],[-105,16],[-188,29],[-23,-20],[-5,39],[-12,-52],[-7,9],[-20,-27],[-6,5],[-29,-47],[-28,-60],[-7,21],[-91,-99]],[[26419,57669],[9,275],[22,48],[3,-26],[28,4],[22,63],[-5,57],[9,25],[-4,44],[17,62],[13,15],[8,48],[16,8],[15,45],[80,7],[11,50],[22,32],[5,26],[10,-7],[16,48],[4,35],[16,4],[8,40],[21,29],[24,-18],[26,115],[-3,63],[10,30],[15,-36],[20,98],[33,70],[10,-40],[-5,-70],[15,-20],[28,62],[15,93],[15,35],[17,21],[12,-5],[9,33],[19,-12],[4,-50],[15,0],[14,28],[33,200],[21,53],[11,12],[8,-23],[17,0],[-10,74],[7,65],[6,12],[-4,80],[9,60]],[[20923,73979],[188,-1],[322,0],[212,0],[92,0],[193,1],[160,-1],[135,0],[141,1],[256,1],[201,0]],[[23008,70412],[-210,-1],[-186,1],[-119,1],[-252,4],[-192,2],[-179,2],[-253,1],[-123,0],[-292,1],[-173,0],[-105,0]],[[20924,70423],[0,2828],[-1,17],[0,711]],[[23550,60009],[0,-581]],[[23550,59428],[6,-130],[7,-206],[6,-127],[14,-355],[4,-82],[15,-387],[-2,-319],[-3,-261],[-1,-235],[-2,-170],[-2,-417],[-5,-642]],[[23587,56097],[-9,-25],[-19,73],[-16,-13],[-1,23],[-17,-1],[-18,79],[-15,-16],[-12,5],[-21,78],[-7,58],[-22,2],[-23,85],[-27,28],[-7,-68],[-11,-32],[-13,-7],[-34,4],[0,15],[-21,-7],[-7,61],[-10,3],[-24,-52],[-20,3],[1,-45],[-13,9],[-9,-31],[-29,61],[-1,-30],[-30,-29],[-15,13],[1,-20],[-14,8],[-8,-90],[-14,-14],[-19,19],[-7,-81],[-12,-3],[-1,22],[-17,79],[-21,-6],[-8,57],[-11,-4],[-16,30],[12,58],[-25,16],[-8,-86],[-18,-9],[-4,42],[-13,14],[-6,-33],[-9,25],[-6,95],[-5,11],[-14,-27],[-6,15],[3,-73],[-16,-57],[-13,19],[11,-42],[-13,-22],[3,-64],[-11,-31],[-11,14],[-12,94],[10,30],[-2,66],[-9,28],[-10,-19],[-2,-42],[-13,19],[-9,-7],[-11,-64],[-20,5],[-5,30],[1,63],[-12,19],[-16,-27],[-11,25],[3,41],[-19,42],[-9,-3],[-12,-58],[-29,-92],[-12,-9],[-16,34],[-9,3],[4,65],[-5,-1],[7,60],[-7,20],[-13,-14],[-19,11],[-10,91],[8,35],[-4,50],[-17,-47],[-20,22],[-15,0],[-19,28],[-11,-40],[-3,-44],[-20,-26],[-24,96],[-21,23],[-12,-37],[-21,4],[-13,26],[-13,3],[-17,24],[-19,46],[-16,-27],[-9,15],[-12,-11],[-2,20],[-18,-3],[-5,140],[-18,56],[4,22],[-16,5],[-18,57],[-4,-92],[-12,-4],[-22,47],[-17,2],[-6,-49],[-30,15],[-24,78],[-37,143],[-20,-19],[0,2257],[-123,0],[-179,0],[-150,0],[-175,1],[-210,0]],[[21214,59429],[1,119],[0,463]],[[27478,65805],[48,61],[45,74],[9,24],[10,60],[13,3],[3,-28],[36,72],[47,74]],[[27689,66145],[0,-314],[1,-2],[247,-1],[77,3],[167,-2],[243,1],[105,3],[111,-4],[169,-1],[107,2],[14,-59],[5,4],[8,-100],[15,4],[27,-34],[10,-49],[-8,-32],[14,-21],[2,-159],[-8,-12],[25,-113],[1,-34],[11,5],[15,-33],[-2,-18],[25,3],[3,-22],[16,8],[-1,-30],[13,-55]],[[28900,63272],[-23,37],[-22,6],[-24,-20],[-15,-34],[-20,-82]],[[28796,63179],[-217,-1],[-118,-1],[-151,0],[-236,3],[-305,-2]],[[27769,63178],[-167,0],[-124,0],[0,1068]],[[27478,64246],[0,1559]],[[20920,69320],[5,4],[0,872],[-1,227]],[[23039,67577],[-40,0],[5,-22],[-7,-37],[22,-64],[-1,-110],[-14,-5],[8,-52],[-3,-31],[24,-3],[2,-83],[9,-35],[-7,-66],[-14,-16],[5,-56],[-8,-28],[6,-21],[-12,-46],[0,-80],[-11,-16],[-3,-52],[-11,-26],[1,-76],[15,-27],[17,-60],[10,-87],[-4,-45],[13,-31]],[[23041,66402],[-17,-7],[-5,30],[-24,-5],[-7,53],[-21,66],[7,52],[-11,16],[-21,3],[-1,40],[-28,35],[-12,-17],[-8,48],[-43,13],[-5,28],[-18,20],[-1,38],[-25,25],[-15,-14],[-15,13],[-7,-23],[-18,14],[-16,-13],[-16,11],[-18,-17],[-25,9],[-20,21],[-8,-11],[-9,-74],[-12,-29],[-19,-9],[-31,69],[-36,62],[-58,85],[-9,59],[-112,0],[-186,-1],[-153,1],[-214,-1],[-206,-2],[-62,4],[-178,0],[-143,1],[-293,1]],[[20922,66996],[0,345],[-1,8],[0,1828],[-1,143]],[[23587,56097],[8,8],[0,-54],[11,-25],[9,6],[-2,-36],[10,-9],[5,27],[8,-18],[3,29],[21,-27],[11,46],[12,-17],[5,-30],[6,21],[16,-22]],[[23710,55996],[0,0]],[[23710,55996],[1,-11],[0,-608]],[[23711,55377],[0,-1196],[8,-12],[11,-72],[18,-31],[9,-83],[15,-55],[-2,-34],[8,-56],[-7,-42],[3,-45],[-7,-28],[6,-51],[9,-32],[13,-6],[3,-35],[-6,-27],[14,-36],[-1,-32],[8,-15],[3,-49],[-6,-53],[12,-47],[6,2],[6,-113],[19,12],[-6,-102],[8,-31],[2,-54],[-13,-21],[-1,-33],[12,-55],[-9,-22],[-3,-38],[4,-63],[-9,-33],[-9,-63],[-3,-73],[-12,-25],[-2,-68],[-14,-30],[-3,-40],[7,-24],[5,-91],[-13,-51],[-6,-74],[16,-52],[1,-53],[-5,-39],[9,-79],[-12,-70],[9,-19],[-11,-51],[-14,-39],[-7,-78],[-13,-74],[-17,-45],[-2,-25],[9,-30],[17,-94]],[[23768,51502],[0,-14],[-46,3],[-37,-40],[-128,-208],[-28,-61],[-10,-54],[-15,7],[22,71],[9,47],[13,-1],[9,19],[8,46],[9,-16],[11,8],[-15,55],[-54,-54],[-8,26],[17,90],[4,80],[0,74],[-12,5],[-5,23],[-17,-29],[-10,-41],[-4,-50],[-15,-24],[-6,46],[-18,-45],[-2,-35],[9,-32],[-10,-50],[10,-55],[20,-17],[-6,-54],[11,-20],[2,-78],[-2,-67],[-8,-31],[-9,10],[-19,-71],[-22,-65],[-3,26],[-13,-8],[-2,-88],[6,-26],[13,44],[26,65],[3,19],[32,99],[15,23],[0,45],[26,-15],[-20,-61],[-62,-153],[-24,-69],[-4,-25],[-32,-91],[-40,-143],[-15,-8],[-69,-146],[-35,-80],[-53,-89],[-61,-112],[-34,-87],[-13,-42],[-15,-74],[-53,-111],[-24,-68],[-47,-155],[-32,-143],[-11,-83],[-14,-59],[-33,-221],[-24,-197],[-11,-127],[-10,-192],[-2,-108],[1,-103],[8,-205],[14,-207],[12,-134],[16,-229],[11,-260],[-7,47],[-5,147],[-12,189],[-11,152],[-24,16],[18,27],[-9,83],[-6,87],[-9,88],[-3,106],[1,138],[-1,122],[11,276],[16,180],[19,148],[14,70],[10,87],[8,35],[-2,47],[13,86],[18,38],[9,45],[18,127],[28,58],[8,53],[16,2],[35,105],[23,49],[24,23],[-4,43],[9,29],[-9,16],[-16,-41],[-20,-35],[-11,-40],[-17,-5],[-6,40],[0,60],[-18,12],[-6,-31],[0,-84],[-5,-25],[6,-41],[-4,-36],[-20,-56],[-17,-61],[-8,-1],[-18,30],[-3,43],[-32,-61],[-17,-67],[21,-22],[24,57],[8,-74],[-7,-23],[-38,-223],[-12,-2],[-6,55],[-21,-10],[-4,18],[-32,-11],[-11,12],[-6,-38],[12,-32],[15,-1],[11,17],[-4,-64],[7,-48],[15,-34],[17,-18],[-19,-146],[-13,-185],[-12,-106],[-20,-27],[-7,-27],[-11,18],[14,21],[3,59],[-8,3],[-6,-31],[-29,-75],[4,-32],[24,-16],[25,38],[8,2],[-5,-116],[3,-4],[-4,-202],[-6,-207],[-4,-3],[10,-230],[8,-65],[1,-84],[9,-1],[23,-215],[5,-29],[-9,-47],[4,-34],[-1,-62],[8,-72],[20,-11],[1,-35],[12,18],[2,-127],[-23,7],[-13,-8],[0,-19],[-21,-12],[-6,-99],[-20,11],[-7,40],[-15,3],[-6,55],[-11,4],[-18,98],[-31,12],[-11,33],[-17,-9],[-7,16],[-23,-17],[-4,18],[-13,-1],[-3,-29],[-10,31],[-20,-14],[-8,22],[-6,-22],[-14,20],[-8,30],[3,25],[-16,1],[-3,44],[-15,-1],[-21,75],[-9,-11],[-25,48],[-19,-22],[-13,35],[-15,69],[-10,8],[-2,33],[-8,12],[-18,-15],[-21,47],[-12,-3],[-8,20],[-12,-19],[-9,44],[6,50],[-10,56],[-11,13],[-3,98],[-6,42],[-3,79],[-8,25],[-1,49],[-7,64],[-17,43],[2,31],[-13,26],[-7,37],[5,20],[-11,46],[-9,7],[-1,52],[6,31],[-3,66],[4,29],[-4,86],[-16,25],[1,37],[-12,11],[9,30],[5,86],[-3,31],[4,60],[-13,10],[5,76],[-12,58],[-7,-14],[-7,46],[-9,-18],[-9,39],[-10,-6],[-18,90],[-9,11],[-3,38],[-8,-9],[-10,38],[0,50],[-7,26],[3,41],[-13,48],[2,47],[-17,16],[-7,81],[-10,23],[-8,70],[-35,53],[-4,53],[-7,-2],[-13,59],[2,38],[-17,100],[3,47],[-9,39],[9,29],[-12,11],[-9,47],[4,39],[-14,28],[1,33],[-15,28],[-4,51],[2,41],[-8,26],[-4,73],[-6,1],[-9,88],[-8,1],[-6,47],[1,76],[-7,106],[-18,46],[-10,40],[3,14],[-9,71],[-23,41],[-2,30],[-17,46],[-18,25],[-13,84],[0,21],[-26,21],[-6,44],[-23,7],[3,57],[-2,65],[-5,5],[-6,-67],[-6,27],[2,53],[-17,27],[-13,108],[-8,-4],[-9,32],[-13,-25],[-7,44],[-8,-27],[-37,-13],[-19,31],[-6,-8],[-15,22],[-22,-14],[-12,24],[-17,-7],[-4,-22],[-26,21],[-11,50],[-13,-3],[-20,40],[-14,-18],[-10,-111],[-34,19],[-9,-37],[-7,11],[-22,-32],[-7,10],[-8,-54],[2,-23],[-13,-40],[0,-50],[-7,0],[-2,-59],[-11,-30],[1,-33],[-7,-58],[2,-52],[-5,-48],[-10,-5],[-3,-72],[-5,-37],[10,-22],[-5,-38],[-18,-38],[-10,8],[-7,-67],[-17,-43],[-7,-36],[-4,-84],[-14,-8],[-17,15],[-15,-11],[-14,46],[-27,24],[-27,111],[-24,33],[-10,-8],[-22,38],[-18,77],[-13,24],[-39,21],[-17,28],[-19,61],[-11,12],[-19,81],[0,24],[-14,47],[-21,7],[-12,27],[-5,34],[-30,78],[-9,43],[-7,110],[-12,56],[-7,60],[-13,63],[0,59],[-7,57],[6,72],[-3,54],[2,55],[-7,68],[-11,30],[-3,44],[-13,39],[-1,30],[-13,34],[2,33],[-13,177],[-7,40],[-12,4],[-11,91],[-15,0],[-14,66],[-12,10],[-3,24],[-15,34],[-12,-4],[-7,28],[-31,39],[0,39],[-44,118],[-13,107],[-12,37],[-18,26],[-9,33],[-9,2],[-2,36],[-24,106],[-20,35],[-4,54],[-14,32],[-21,7],[-35,78],[-11,88],[-10,24],[-6,68],[-13,89],[-9,41],[-19,38],[-11,-19],[-11,41]],[[20232,53938],[-5,28],[-16,20],[1,23],[-10,25],[-3,38],[7,18],[1,101],[331,0],[250,-1],[226,0],[183,1],[0,1212],[2,254],[0,149],[2,417],[2,232],[0,1518],[1,434],[0,809],[-1,213],[11,0]],[[20922,66996],[0,-2328]],[[19530,64667],[-136,-2],[-143,-1],[-52,-3],[-133,1],[-93,2],[0,442],[1,219],[-1,508]],[[18973,65833],[0,676],[1,163],[0,1090],[-1,26],[0,516],[-1,267],[1,140]],[[18973,68711],[-2,175],[-1,282],[1,156],[75,2],[22,-12],[85,2],[11,8],[45,-5],[25,8],[87,-2],[194,5],[11,-7],[221,0],[316,0],[14,-4],[144,-2],[178,-1],[23,7],[132,0],[251,-2],[115,-1]],[[29908,65840],[0,-107],[3,-222],[0,-150],[-3,-209],[-12,-8],[3,-76],[-8,-29]],[[29891,65039],[-7,19],[-17,2],[-21,-24],[-18,3],[-13,-24],[-16,28],[-6,-37],[-49,-35],[-3,20],[-15,0],[-27,-33],[-6,21],[-26,1],[-7,-26],[-18,23],[-40,-27],[-3,60],[-9,-17],[-19,-82],[-12,0],[-22,-73],[-13,23],[-24,-58],[-7,13],[-23,-28],[5,-22],[-10,-32],[-29,-11],[-22,-54],[-9,15],[-15,-35]],[[29390,64649],[1,33],[-20,102],[68,130],[-19,97],[4,161],[5,295],[9,422]],[[23231,64184],[167,-9],[159,-8],[156,3],[130,8],[62,0],[197,12],[152,13],[101,14],[12,-38],[1,-33],[18,-14],[-1,-36],[16,-57],[10,-2],[1,-56],[11,-31],[19,-7]],[[24442,63943],[-8,-18],[-17,-144],[-2,-71],[6,-165],[14,-99],[7,-28],[-8,-66],[5,-38],[15,-34],[4,-28],[-3,-61],[26,-77],[15,-57],[11,-14],[10,-69],[13,-8],[11,-76],[16,-54],[59,-137],[20,-90],[3,-90],[8,-78],[-9,-36],[11,-85],[3,-65],[22,-69],[11,7],[11,32],[9,66],[19,4],[27,-45],[16,-5],[38,-82],[-2,-60],[-12,-29],[-13,-59],[10,-92],[-2,-37],[-22,-96],[-6,-99],[-17,-68],[-7,-52],[-1,-78],[5,-70],[18,-50],[20,-89],[25,-37],[11,-54],[8,0],[17,-60],[16,7],[3,-27],[-12,-24],[6,-50],[20,-5],[10,31],[13,-28],[1,-29],[15,-12],[23,-70],[-2,-40],[14,-3],[9,-42],[19,-24],[0,-57],[11,-68],[-13,-8],[2,-50],[26,-161],[-4,-62],[-15,-12],[-8,-56],[17,-53],[-1,-47],[13,-87],[11,-46],[-1,-53],[24,-56],[10,27],[-15,45],[14,12],[17,-56],[8,-53],[11,14]],[[25079,59990],[9,-21],[-5,-90],[-6,-46],[-10,-9],[-1,-38],[17,-37],[-3,-28],[-16,3],[-4,-44],[11,-58],[-8,-29],[-7,-71],[-13,-18],[-18,78],[-13,-13],[-13,-142]],[[24999,59427],[-8,-40],[-13,7],[2,31]],[[24980,59425],[6,38],[-5,49],[-21,2],[-4,-30],[9,-58]],[[24965,59426],[6,-22],[-7,-64],[10,-59],[-5,-37],[-24,-1],[0,-37],[21,-39],[1,-27],[-15,-15],[-30,16],[-3,-21],[28,-74],[1,-61],[-22,-40],[-3,-75],[-12,-23]],[[24911,58847],[-179,-6],[16,110],[23,58],[0,23],[15,53],[16,28],[3,43],[9,7],[5,133],[-22,44],[3,15],[-5,71],[-349,-1],[-323,1],[-141,0],[-222,1],[-210,1]],[[23358,63503],[-31,56],[8,79],[-24,76],[-2,77],[-20,19],[1,32],[-18,26],[-12,110],[1,39],[-11,34],[-1,40],[13,42],[-11,18],[-1,-33],[-20,3],[1,63]],[[26900,61666],[18,-20],[35,40],[23,11],[5,49],[3,98],[12,28],[16,-7],[6,30],[-3,101],[-10,105],[21,52],[0,67],[14,88],[12,27],[6,37],[13,-40],[11,-1],[12,-79],[-8,-40],[11,-20],[9,22],[3,42],[9,20],[9,-25],[4,111],[-10,29],[-3,43],[19,19],[-3,96],[8,41],[10,12],[3,55],[31,-7],[3,83],[25,76],[17,-19],[6,-52],[11,3],[21,47],[17,8],[11,54],[11,8],[8,48],[16,57],[30,89],[16,9],[4,83],[10,26],[-11,50],[12,48],[0,57],[10,23],[-4,60],[13,-11],[-2,52],[7,20],[0,122],[9,30],[0,58],[10,48],[5,61],[10,23],[5,65],[-3,95],[4,71],[-9,84],[-11,44],[9,50],[14,-1],[18,27]],[[27769,63178],[-3,-600],[10,7],[33,103],[12,-1],[10,67],[31,60],[13,75],[11,-2],[28,-36],[11,54],[38,158],[13,-10],[-13,-14],[13,-18],[2,-26],[20,-34],[17,1],[7,-18],[28,-4],[14,38],[-7,49],[13,-1],[-11,32],[14,-11],[9,37],[19,-23],[28,87],[24,-20],[17,-49],[8,-40],[18,20],[17,-23],[14,4],[0,-37],[-16,-15],[12,-69],[19,-41],[-2,-33],[9,-12],[5,-43],[-6,-63],[10,-14]],[[28258,62713],[-9,-45],[-21,-175],[-78,209],[-66,179],[-4,-62],[5,-28],[-6,-36],[7,-11],[-23,-106],[6,-15],[-11,-54],[10,-36],[-16,-62],[-7,-7],[-24,-88],[6,-16],[-14,-63],[-7,21],[-15,-66],[-10,-24],[0,36],[-23,-71],[-20,-130],[-35,101],[-9,-69],[-17,-82],[-1,-71],[-8,1],[-10,-57],[-15,-138],[-28,-94],[-46,53],[-17,109],[-31,47],[-14,-121],[3,-65],[-12,-60],[-22,-87],[6,-44],[-12,-21],[-25,-81],[-7,-56],[6,-29],[-8,-30],[-6,-60],[-10,-51],[-18,-51],[-30,-104],[-21,-112],[2,-36],[-12,-39],[4,-41],[17,-34],[-12,-40],[-18,-34],[-1,-32],[13,-4],[-4,-29],[-49,-99],[-10,68],[-12,-9],[-19,-47],[-41,-71],[-4,26],[-21,38],[-7,-51],[9,-43],[-19,-47],[-17,-5],[-37,-27],[-31,-51],[-27,75],[-11,45],[-8,-21],[-8,-55],[-23,-17],[-2,-30],[-13,-29],[-34,-7],[-19,48],[0,24],[-12,25],[-18,3],[-7,52],[-14,31],[-2,90],[-15,22],[-1,33],[18,34],[-11,29]],[[27075,60636],[-14,-4],[-28,30],[-3,37],[-8,1],[-7,40],[-9,-2],[-7,42],[-15,11],[-13,134],[-10,19],[-13,61],[1,34],[-15,19],[-8,39],[11,55],[-15,22],[-9,80],[-10,45],[-15,37],[0,38],[8,0],[3,55],[-4,20],[11,33],[1,58],[-8,36],[1,90]],[[24442,63943],[12,16],[-2,50],[4,90],[-11,35],[13,69],[31,43],[18,-1],[18,41],[1,61],[6,49],[1,67],[10,27],[14,66],[11,19],[6,106],[-1,98],[-13,75],[-13,6],[-20,85],[11,77],[2,74],[6,55],[19,21],[13,-15],[23,40],[31,-6],[24,17],[16,56],[10,13],[26,-1],[18,57],[16,21],[-1,66],[9,59],[0,52],[9,29],[28,49],[-1,41],[8,72],[-3,58],[7,61],[-7,37],[1,89],[-13,41],[-47,73],[-15,74],[3,60],[-16,63],[-22,37],[-2,26],[-22,35],[0,47]],[[24658,66423],[45,-2],[227,-2],[51,-5],[194,-11],[41,4],[152,1],[82,-5]],[[25450,66403],[-2,-124],[-8,-97],[10,-109],[21,-117],[12,-37],[3,-54],[13,-139],[4,-75],[14,-93],[8,-20],[2,-47]],[[25386,60941],[-8,-66],[-17,-35],[-11,-56],[7,-105],[20,-68],[-6,-50],[-48,-19],[-12,-11],[-18,-52],[-14,26],[-18,-44],[-2,-55],[-9,-65],[2,-25],[17,-65],[7,-66],[-10,-89],[-15,-10],[-13,13],[-19,52],[-35,40],[-14,39],[-31,42],[-19,5],[-13,-21],[-13,-42],[-9,-65],[-16,-52],[-4,-55],[14,-52]],[[20232,53938],[-214,0],[-254,0],[0,-524],[-234,-1]],[[24911,58847],[4,-38],[18,-49],[0,-45],[-24,23],[-9,-49],[20,-36],[-11,-33],[-11,-1],[-9,-52],[-17,-22],[-9,21],[-15,-41],[6,-68],[9,-17],[12,23],[3,-38],[-26,-42],[1,-53],[9,-10],[-3,-40],[-22,56],[-9,-9],[-5,-58],[9,-42],[-11,-75],[-8,88],[-23,-67],[-3,-46],[12,-6],[2,43],[15,-35],[-9,-47],[0,-45],[-16,-10],[4,-47],[15,-7],[6,-29],[-12,-43],[15,-58],[-10,-25],[-12,21],[-9,-26],[-9,-100],[-25,13],[-3,-49]],[[24751,57677],[17,-55],[0,-45],[-18,-44],[-31,-44],[-4,59],[-11,2],[-2,-29],[8,-44],[-5,-25],[6,-72],[-14,-19],[-5,34],[2,57],[-10,-27],[2,-35],[-7,-14],[6,-40],[20,-2],[2,-31],[-14,-50],[-11,18],[1,49],[-10,-21],[0,-64],[12,-61],[1,-27],[-13,-51],[6,-83],[-25,-57],[0,-63],[-10,1],[3,54],[-19,-1],[-5,-27],[8,-45],[-7,-30],[-19,-15],[-4,-71],[-16,43],[-9,-29],[14,-43],[20,1],[2,-25],[-13,-28],[-16,33],[-12,-32],[9,-51],[11,3],[3,-24],[-8,-61],[-24,-6],[7,-45],[-11,-16],[-5,43],[-16,-23],[-3,-29],[22,-34],[-18,-78],[7,-55],[16,-26],[-10,-34],[-8,18],[-24,-2],[-1,-59],[10,-26],[13,14],[8,-50],[-12,-18],[-16,22],[-7,35],[-17,-16],[-2,-28],[25,-51],[2,-33],[-28,-41],[13,-63],[-14,-80],[18,16],[-1,51],[14,-27],[-4,-54],[-17,-10],[-3,-19],[10,-24],[17,14],[10,73],[5,-32],[-23,-90],[0,-64],[12,-68],[3,42],[10,13],[2,-23],[-13,-52],[2,-75],[-3,-23],[-14,-8],[-11,14],[-5,-39],[23,-62],[-13,-59]],[[24512,55359],[-219,4],[-154,5],[-157,7],[-86,0],[-185,2]],[[16868,55911],[16,-5],[28,-53],[21,-22],[1,-25],[16,-61],[-5,-43],[-13,25],[-26,7],[-6,35],[0,74],[-20,16],[-12,52]],[[16867,55390],[9,4],[22,-117],[40,-130],[-10,4],[-11,-22],[-17,44],[-13,72],[-14,119],[-6,26]],[[16741,55926],[8,7],[1,-41],[-11,7],[2,27]],[[16637,56552],[8,-17],[11,14],[0,-30],[-17,-4],[-9,21],[7,16]],[[16596,55679],[14,7],[20,-35],[8,-31],[-13,-15],[-20,21],[-9,53]],[[16501,56608],[18,-7],[13,-22],[15,5],[19,-43],[19,-4],[7,39],[20,-20],[-11,-43],[-28,-11],[-17,-31],[-42,24],[-1,61],[-12,52]],[[16410,56520],[22,8],[9,21],[13,-8],[13,19],[0,-48],[18,-13],[1,-48],[-41,-54],[-16,37],[-19,86]],[[16354,56562],[16,17],[6,28],[6,-35],[13,-26],[-21,-6],[-20,22]],[[15305,65829],[155,-4],[9,6],[77,-1],[56,12],[28,-8],[115,2],[37,5],[95,-1],[45,-5],[154,-8],[114,-4],[197,0],[92,2]],[[16479,65825],[0,-1]],[[16479,65824],[0,-1448],[1,-34],[0,-756],[-1,-393],[-1,-13],[0,-457],[-1,-122],[2,-263],[26,-77],[115,-330],[114,-336],[63,-182],[99,-298],[125,-377],[62,-186],[127,-394],[313,-989],[234,-759],[70,-234],[147,-492]],[[17950,55027],[-416,-126],[-254,-89],[-3,98],[-9,62],[-8,20],[-14,-23],[-3,66],[1,71],[-8,41],[9,61],[-9,161],[-13,127],[-9,54],[-40,193],[-25,61],[-10,51],[-15,37],[-9,-2],[-19,95],[-26,59],[-14,15],[-20,57],[-25,88],[-24,39],[-2,-47],[-21,-23],[-18,14],[-10,25],[-15,6],[-4,38],[9,34],[1,43],[-14,116],[-11,64],[-17,50],[-35,1],[-22,-8],[-16,-36],[-14,38],[-28,16],[-37,59],[-12,2],[-24,53],[-17,141],[-10,10],[-17,53],[-4,-3],[-20,65],[-21,25],[-6,20],[-32,4],[-16,-24],[-18,25],[-22,-10],[-37,60],[-23,0],[-15,15],[-44,-7],[-48,-22],[-1,31],[-13,66],[-16,30],[-12,-4],[-6,32],[13,143],[-11,60],[8,119],[-17,54],[9,115],[1,140],[-18,56],[-14,7],[-3,-21],[-27,55],[-11,48],[10,131],[-2,50],[-11,53],[-27,14],[-27,102],[-18,101],[-24,25],[-17,66],[-5,81],[-16,47],[-7,37],[-14,35],[-6,99],[-5,35],[-20,29],[-15,104],[-25,94],[-33,64],[-11,45],[-8,80],[1,42],[-11,101],[2,92],[-11,16],[10,74],[18,-38],[9,30],[7,61],[8,141],[-21,149],[-12,43],[-10,11],[-9,-28],[-37,2],[-28,68],[-22,102],[-14,18],[-2,31],[-17,60],[-4,62],[5,129],[-12,89],[-2,52],[-12,14],[-6,33],[-1,64],[5,27],[2,77],[-6,134],[14,28],[16,8],[6,-24],[7,-88],[-9,-9],[11,-107],[-2,-27],[27,-23],[27,-80],[8,5],[14,-63],[12,3],[-6,40],[-12,19],[-10,87],[-7,109],[-21,54],[-2,46],[-22,26],[9,74],[-7,68],[-15,-1],[-14,68],[8,-9],[9,26],[0,40],[19,-2],[10,39],[-10,71],[-26,44],[-13,-30],[-14,-6],[2,-47],[-5,-46],[15,-51],[-12,-25],[-4,-44],[19,-56],[-7,-14],[-11,29],[7,-71],[-15,-16],[-9,38],[-26,61],[-13,-12],[-23,67],[-10,53],[-17,33],[-16,8],[-20,-33],[14,127],[3,48],[-12,92],[7,20],[-16,70],[-11,-10],[-1,67],[-17,106],[-20,51],[-14,19],[-22,64],[-37,176],[-14,29],[-8,41],[-31,90],[-24,116],[14,78],[-1,42],[-14,126],[-16,123],[-7,105],[3,99],[13,132],[-5,52],[0,65],[-14,92],[-4,108],[-16,36],[-6,55],[-35,133],[-7,6],[0,43],[-8,43],[-22,32],[-49,151],[4,63],[-4,70],[-13,74],[9,98],[14,109],[42,265],[11,95],[7,119],[-12,37],[-1,97],[4,2],[11,99],[12,244],[-5,126],[-15,128],[-8,96],[-9,-4],[-17,54],[10,74],[5,110],[-3,67]],[[28861,63044],[-1,28]],[[28874,63137],[-6,7],[-22,-81],[2,-39],[11,-31],[1,-49],[-8,-28],[0,-41],[14,-52],[7,-58],[21,-62],[10,-68],[3,-58],[-5,-35],[2,-126],[16,-48],[7,-43],[2,-74],[34,-137],[16,-29],[10,24],[4,-36],[5,-129],[4,-244]],[[29002,61700],[-105,1],[-74,9],[-2,72],[-25,1311],[0,86]],[[28426,62262],[21,70],[37,-118],[-36,-118]],[[28448,62096],[0,93],[-22,73]],[[6433,39922],[2,44],[19,76],[12,7],[13,93],[16,52],[3,58],[-17,94],[-4,45],[-1,105],[8,37],[18,-9],[18,-32],[3,-32],[22,-44],[15,-47],[12,6],[25,-32],[39,-77],[13,-19],[22,-61],[16,-57],[17,-76],[-3,-47],[1,-90],[8,-10],[16,12],[7,-57],[-1,-57],[22,-82],[22,-39],[5,-21],[-4,-44],[-13,-51],[-17,-47],[-14,-56],[-23,-38],[-20,-47],[-20,-18],[-16,15],[-9,-9],[-18,-66],[-16,-25],[-13,-48],[-14,-16],[-12,-59],[1,-33],[-8,-37],[-5,-59],[-20,-63],[-15,61],[-22,52],[-22,29],[-10,95],[5,113],[4,151],[-10,106],[1,46],[-9,12],[-5,114],[-7,66],[-9,8],[-8,108]],[[6254,41293],[5,69],[11,56],[14,6],[13,-33],[10,-78],[10,-50],[24,29],[18,35],[26,-21],[0,-16],[17,-51],[10,-15],[5,-40],[31,-37],[5,-32],[0,-52],[-8,-43],[-13,-40],[-6,3],[-17,-36],[-14,10],[-30,-53],[-21,-9],[-17,26],[-7,210],[-7,20],[-14,-24],[-26,50],[-13,58],[-6,58]],[[6253,40841],[7,29],[28,57],[10,-30],[-4,-44],[5,-17],[-13,-19],[-5,15],[-18,-23],[-10,32]],[[6153,41274],[7,27],[13,5],[26,-19],[17,-60],[8,-51],[-9,-65],[-19,-29],[-17,-5],[-7,60],[-3,73],[-14,32],[-2,32]],[[6084,41504],[6,52],[9,29],[-2,58],[17,-2],[3,-14],[54,-29],[10,34],[4,-42],[22,-13],[27,18],[17,-25],[-8,-55],[-18,-51],[-20,-21],[-35,32],[-26,31],[-15,-14],[-29,-5],[-16,17]],[[5814,42059],[43,9],[13,49],[4,35],[13,48],[14,15],[6,-27],[6,-70],[20,-84],[4,-52],[-4,-15],[3,-47],[18,-55],[3,57],[12,-2],[-4,-64],[8,-24],[-1,-29],[17,-70],[-12,-37],[-11,18],[-21,-29],[-6,26],[-17,31],[-25,11],[-30,-20],[-7,4],[-7,84],[-11,34],[-1,31],[-14,67],[0,61],[-13,45]],[[5394,42585],[1,40],[11,38],[4,49],[33,72],[8,26],[23,-18],[3,25],[16,-11],[8,14],[15,-20],[10,-37],[5,-45],[0,-46],[-11,-63],[1,-106],[-4,-28],[-28,-78],[-8,15],[-36,12],[-18,71],[-24,29],[-9,61]],[[5266,42374],[4,43],[12,44],[19,45],[2,38],[11,9],[2,-31],[-5,-57],[2,-36],[-20,-28],[-16,-97],[-12,30],[1,40]],[[24498,67577],[-5,-52],[10,-50],[-1,-74],[27,-41],[13,-76],[-18,-60],[-6,-52],[-9,-24],[1,-108],[8,-88],[0,-68],[12,-25],[13,-169],[33,-64],[47,-37],[17,-20],[18,-109],[0,-37]],[[23231,64184],[4,28],[-10,56],[-13,16],[-15,58],[2,37],[13,35],[-4,83],[10,51],[-7,27],[2,66],[-9,20],[1,42],[-7,30],[5,27],[-5,93],[12,17],[-24,24],[4,37],[-5,63],[13,41],[-20,27],[7,29],[-1,116],[-20,10],[2,77],[-9,1],[-2,-37],[-15,28],[3,56],[-11,39],[7,39],[-8,41],[11,18],[-6,54],[8,20],[3,46],[-12,23],[-1,38],[-14,61],[6,11],[3,66],[-16,6],[1,30],[-15,11],[5,16],[-15,25],[1,83],[-22,56],[-3,48],[10,25],[-14,103],[-11,29],[0,76],[9,44],[-4,44],[-14,8]],[[26280,62461],[18,48],[7,-2],[15,-54],[21,-28],[14,29],[14,-3],[8,29],[8,-8],[4,-69],[29,-32],[10,-84],[16,-83],[0,-66],[5,-26],[40,-41],[33,19],[29,-46],[3,-34],[15,-26],[5,-50],[28,-29],[14,66],[26,22],[15,-32],[28,-20],[11,-24],[5,-43],[13,24],[30,-1],[10,53],[18,34],[9,39],[15,0],[21,32],[7,-33],[-3,-44],[9,-111],[13,-37],[21,-6],[21,-79],[13,-35],[2,-44]],[[27075,60636],[-108,-317],[-37,-39],[-22,-41],[-19,-49],[-25,-45],[0,-86],[-16,-39],[-12,-2],[-12,-33],[3,-59],[-6,-45],[-25,-36],[-29,-4],[-16,-80],[-2,-50],[-16,-4],[-33,-35],[-39,-52],[-21,2],[-33,-49],[-8,-27]],[[26599,59546],[-4,-21],[-83,8],[-79,2],[-76,5],[-83,11],[-51,16],[-74,9],[-55,-14],[-96,8],[-56,10],[-83,22],[-49,4],[-16,-22],[-7,22],[-146,-12],[-92,-2],[-114,-8],[1,35],[-61,17],[10,-147],[-6,-64],[-137,6],[-126,0],[-84,6],[-33,-10]],[[24980,59425],[-15,1]],[[28739,61120],[-14,0]],[[28725,61120],[-1,72],[8,28],[11,-40],[-4,-60]],[[28711,61320],[2,79],[11,13],[7,-30],[5,-118],[-15,21],[4,27],[-14,8]],[[28627,62072],[5,20],[5,-46],[-10,26]],[[29002,61700],[-1,-43],[-9,-105],[-5,-15],[-20,-211],[-18,-120]],[[28949,61206],[-107,-38],[-6,-55],[-6,4]],[[28830,61117],[-13,30],[-19,-4],[-22,-64],[-9,-1],[-1,67],[7,70],[17,28],[-17,2],[2,45],[11,40],[-21,9],[-12,-33],[-4,28],[5,58],[26,27],[-6,39],[-9,-13],[-4,36],[15,112],[-15,-24],[-7,-47],[0,-60],[-8,-1],[-11,77],[11,9],[-1,53],[-8,10],[-4,-49],[-9,-33],[6,-27],[-9,-62],[-4,29],[-17,-23],[-9,12],[-16,83],[-9,13],[2,43],[-24,151],[20,14],[5,39],[-8,-7],[-9,51],[8,40],[12,22],[6,-25],[12,26],[1,-36],[22,-9],[13,-39],[4,10],[-16,69],[-17,14],[-8,42],[-7,-3],[-16,77],[-5,-28],[-12,20],[-1,-59],[-7,8],[3,101],[18,92],[14,-45],[8,10],[-3,124],[-8,17],[-17,-47],[-12,4],[1,-48],[-12,-17],[4,104],[16,101],[7,-51],[21,-11],[11,31],[-6,54],[11,55],[-16,-9],[-3,-52],[4,-31],[-12,17],[3,63],[-6,59],[-7,14],[16,136],[12,42],[-2,24],[14,25],[7,37],[30,-6],[-11,24],[18,70],[-10,6],[12,122],[-35,-24],[-6,-48],[12,-24],[4,-32],[-12,-14],[-34,-97],[-7,31],[7,54],[-8,28],[0,-44],[-9,-51],[8,-34],[-7,-46],[-6,96],[-15,14],[6,-103],[-8,8],[-6,-42],[12,-22],[-21,-44],[-7,-28],[-13,8],[-2,26],[-22,46],[3,-46],[9,-13],[2,-41],[27,-54],[2,-67],[-5,-25],[13,-48],[-23,-45],[7,-37],[-3,-40],[-9,4],[-7,-55],[6,-53],[-17,-58],[9,-50],[-2,-54],[6,-73],[-2,-89],[7,-65],[22,-80],[8,-62],[-9,-45],[-14,7],[9,-42],[9,22],[8,-14],[-7,-47],[4,-48],[18,-92],[-5,-22],[5,-97],[-9,19],[-11,58],[-8,4],[-5,64],[-8,-9],[-2,-57],[-7,38],[-8,-3],[-5,48],[-12,45],[-23,23],[-35,3],[-8,129],[-8,13],[-4,-31],[10,-68],[-2,-22],[-22,43],[-2,34],[-13,31],[-12,114],[-20,-44],[-33,-56],[-12,27],[-7,115],[11,82],[15,57],[20,30],[-5,10]],[[28423,61914],[-1,45],[7,27],[18,25],[1,85]],[[28426,62262],[-9,37],[-20,6],[-8,17],[1,48],[-26,42],[-34,15],[-6,39],[-10,13],[1,58],[9,18],[7,49],[-23,43],[-6,45],[-15,-1],[-16,25],[-13,-3]],[[26327,70327],[8,17],[9,-60],[65,-63],[-17,-58],[-23,18],[-14,61],[-28,85]],[[26120,70229],[5,40],[7,-20],[-12,-20]],[[26084,70289],[21,-39],[-4,-36],[-19,38],[2,37]],[[26055,70019],[7,48],[3,69],[6,15],[1,57],[18,-7],[-1,-85],[4,-83],[-19,-44],[-19,30]],[[26035,70180],[13,8],[-5,-54],[-7,1],[-1,45]],[[25984,69839],[13,-17],[1,-59],[-14,76]],[[25933,69486],[6,23],[19,-25],[-6,-96],[-17,52],[-2,46]],[[25908,69335],[11,44],[6,-47],[-17,3]],[[25759,70041],[20,-64],[-8,-22],[-4,36],[-14,43],[6,7]],[[25722,65552],[30,68],[27,87],[37,261],[34,146],[19,134],[10,99],[10,176],[-1,58],[6,87],[-1,163],[-6,182],[-11,120],[-35,230],[-11,94],[-12,138],[-17,119],[0,48],[22,102],[7,50],[1,77],[-9,134],[-14,90],[4,32],[20,51],[24,151],[21,112],[4,124],[9,134],[-11,112],[1,33],[27,43],[20,15],[6,93],[-2,74],[10,36],[13,-18],[16,80],[18,-35],[17,13],[8,32],[9,86],[10,16],[15,94],[11,47],[9,-7],[12,35],[3,-39],[-19,-32],[-3,-42],[12,-81],[-23,-81],[13,19],[0,-74],[-6,-7],[-8,-84],[7,-95],[8,-2],[19,145],[3,98],[13,20],[-8,-158],[-15,-44],[-6,-67],[14,-14],[8,65],[7,13],[22,135],[5,78],[-1,56],[4,82],[-6,85],[5,94],[17,49],[10,3],[18,48],[18,16],[25,-7],[26,14],[12,20],[-1,33],[-33,17],[-14,47],[-8,114],[16,75],[13,14],[20,69],[-2,31],[-18,27],[60,-15],[7,49],[61,-102],[26,-58],[13,20],[11,-16],[13,10],[32,-34],[24,-85],[3,-57],[17,-27],[33,4],[8,-9],[29,-77],[23,-7],[34,-71],[29,6],[21,-78],[11,-25],[-9,-27],[15,-96],[11,-30],[14,-133],[-20,21],[-16,34],[-15,-41],[4,-110],[12,-44],[21,-26],[5,-59],[1,-98],[7,-37],[-4,-71],[-8,-67],[2,-65],[-5,-111],[-1,-121],[-12,-15],[-14,-64],[-24,2],[-8,-30],[-8,-108],[-4,-115],[-19,-5],[-8,-19],[0,-49],[-42,-6],[-13,-35],[-9,-76],[-5,-124],[-8,-42],[13,-91],[16,-32],[9,33],[5,-38],[20,-21],[13,-38],[10,16],[28,120],[14,0],[7,25],[-7,51],[9,44],[9,87],[4,-50],[19,31],[5,29],[-21,31],[24,-3],[11,24],[5,41],[23,10],[34,28],[9,45],[31,30],[11,-30],[23,-25],[15,-39],[17,-123],[10,-37],[7,-97],[5,-208],[17,-178],[4,-247],[10,-143],[18,-110],[2,-48],[-11,-46],[-7,-145],[4,-47],[-12,-113],[-4,-67],[-18,-66],[-15,4],[-12,-42],[1,66],[-9,27],[10,16],[15,62],[-14,26],[-15,-5],[-19,-34],[-7,-32],[9,-27],[2,-45],[-15,4],[-11,-52],[1,-84],[-7,-77],[-17,-53],[-30,-25],[-18,-97],[2,-127],[-3,-44],[-15,-25],[-1,-70],[-16,-39],[-6,-39],[-13,-4],[-7,-65],[-11,-11],[-17,-72],[5,-79],[-8,-9]],[[26661,65520],[-86,-11],[-167,-20],[-124,-12]],[[25045,72671],[21,69],[95,141],[7,-2],[43,98],[31,42],[6,-11],[28,29],[-1,-28],[-12,-16],[-30,-80],[0,-30],[-25,-55],[-51,-53],[-42,-66],[2,-20],[23,0],[-59,-73],[-18,3],[-18,52]],[[24721,71146],[19,40],[12,3],[39,49],[38,34],[31,77],[19,64],[16,27],[33,17],[15,-17],[29,27],[22,-3],[52,75],[30,94],[22,5],[29,23],[10,39],[5,51],[25,65],[14,16],[30,82],[23,23],[21,56],[11,54],[20,52],[58,85],[56,25],[50,-7],[23,-39],[1,-45],[-11,5],[-17,-24],[-19,13],[-21,-10],[5,-47],[-32,-57],[-30,-95],[-19,-20],[-5,-74],[-7,9],[-7,-52],[-14,-26],[-5,-67],[-12,-48],[-9,-6],[-12,-164],[6,-52],[-9,-35],[11,3],[20,87],[3,44],[7,-13],[29,80],[28,43],[-12,-55],[-12,-24],[-15,-77],[30,84],[26,18],[14,-13],[37,1],[15,-30],[8,8],[17,-35],[8,-39],[15,11],[22,-63],[3,-61],[17,-49],[6,-47],[14,-49],[19,-15],[-2,-79],[11,-28],[26,-15],[42,10],[25,43],[11,-8],[14,-72],[12,-27],[19,-4],[8,46],[16,-7],[9,-38],[4,69],[-7,53],[16,20],[7,-32],[-6,-56],[17,-26],[26,72],[40,62],[59,110],[11,-21],[61,42],[46,-16],[35,-3],[30,7],[62,85],[24,12],[30,-7],[32,14],[-22,-84],[-2,-135],[2,-45],[-8,-19],[9,-51],[16,-8],[9,16],[6,-26],[15,3],[17,-28],[34,49],[13,-4],[11,-46],[-1,-35],[25,28],[7,-7],[10,65],[19,24],[23,-19],[11,9],[8,39],[27,-5],[5,-30],[-10,-100],[7,-120],[1,-95],[-29,-2],[-8,-65],[15,-12],[5,21],[15,-4],[8,-38],[19,-19],[-13,-40],[24,-75],[12,-1],[20,-45],[8,38],[14,-35],[8,26],[-16,100],[14,-15],[41,13],[12,-15],[14,-91],[16,-31],[-10,-64],[-14,-20],[-27,39],[-31,-16],[-31,42],[-11,-12],[-27,1],[-27,23],[-60,-26],[-13,-28],[-37,69],[-15,48],[-13,-7],[-13,30],[-10,-41],[2,-51],[-15,-32],[1,-45],[9,-63],[-12,-20],[-24,42],[-3,31],[-21,37],[-5,30],[-22,64],[-38,46],[-13,-7],[-33,49],[-18,-5],[-13,23],[-5,-20],[-19,11],[-25,-75],[-17,-73],[-9,-8],[-32,23],[-23,-15],[-8,-22],[2,-34],[-23,37],[-21,17],[-24,-14],[-10,11],[-23,-24],[-13,-42],[-2,-63],[-9,-72],[-14,4],[-7,-39],[-22,-15],[-6,-46],[-13,-3],[0,-45],[-12,-9],[4,-61],[-20,32],[-9,40],[12,27],[1,34],[11,31],[1,40],[13,-4],[15,87],[-3,43],[-12,10],[-18,-75],[-38,24],[3,-51],[-13,-47],[-5,-56],[-30,-31],[-5,-27],[-6,39],[3,55],[-4,67],[-8,32],[-10,-19],[-5,-120],[3,-12],[-31,-55],[-26,-129],[-17,-146],[-19,-65],[-20,-112],[-41,-174],[6,-33]],[[25508,69434],[-19,14],[-8,47],[-13,28],[-2,29],[15,118],[11,48],[-2,34],[-11,25],[-16,-47],[-27,-10]],[[25436,69720],[0,0]],[[25436,69720],[-7,47],[7,24],[-3,38],[13,34],[6,40],[-3,47],[8,69],[-14,75],[12,13],[-8,44],[-13,18],[-6,33],[-24,4],[-9,43],[-21,-18],[-18,45],[17,52],[-7,21],[0,47],[-40,48],[-14,-14],[-24,47],[-12,-15],[-21,21],[-2,25],[-27,-2],[-3,-32],[-14,0],[-4,29],[-17,16],[-12,-13],[-86,142],[-287,231],[1,27],[-28,167],[-27,16],[-10,24]],[[24739,71113],[0,0]],[[24739,71113],[-12,-6],[-6,39]],[[25252,52115],[30,-13],[-14,-20],[-12,9],[-4,24]],[[25179,52148],[16,13],[30,-29],[6,-15],[-24,5],[-28,26]],[[25119,52114],[15,7],[15,31],[-4,-29],[-21,-27],[-5,18]],[[25071,52140],[21,-1],[8,13],[-5,-43],[-10,-7],[-17,26],[3,12]],[[24751,57677],[229,-2],[156,1],[202,1]],[[25284,52292],[-4,-32],[-7,15],[-10,-40],[-18,27],[-13,-15],[-5,30],[-18,7],[-18,-23],[-23,49],[-2,-28],[-21,38],[-22,-3],[-31,-27],[-28,-42],[-30,-33],[4,54],[-10,30],[-14,-27],[9,-17],[1,-40],[-25,-57],[-8,-80],[-9,10],[-13,-16]],[[24969,52072],[-12,0],[-13,50],[-4,66],[0,69],[-15,77],[0,54],[-10,43],[-11,19],[-4,39],[-10,34],[-4,95],[-8,14],[10,88],[-4,36],[7,25],[9,125],[7,19],[-1,45],[7,22],[-7,36],[-165,-2],[-134,-1],[-226,0],[13,21],[7,58],[-16,50],[-1,28],[10,46],[-3,41],[-12,30],[1,38],[18,-7],[17,20],[2,43],[-12,37],[-1,45],[-7,16],[9,39],[4,-50],[8,-29],[9,7],[0,29],[-13,75],[-1,74],[20,18],[12,35],[-4,32],[-18,-13],[-9,30],[5,38],[10,-28],[18,0],[1,106],[11,35],[23,5],[4,18],[-29,11],[7,94],[12,11],[2,-43],[7,-17],[5,28],[-6,21],[24,78],[-2,50],[7,25],[19,14],[0,50],[-19,26],[5,25],[13,-39],[5,36],[12,22],[9,69],[-15,24],[2,-62],[-32,11],[2,79],[27,20],[7,27],[14,-31],[5,42],[-2,53],[12,-8],[16,79],[-4,18],[-6,-40],[-23,17],[0,58],[8,20],[-8,35],[-10,-20],[-23,49],[3,58],[5,1],[17,-48],[10,7],[-5,26],[-21,50],[14,31],[8,37],[-7,37],[-6,-46],[-20,-26],[-6,14],[-3,52],[9,38],[16,33],[2,27],[-31,30],[1,71],[5,37],[21,52],[2,39],[-9,72],[-11,-4],[1,-67],[-14,-26],[-9,22],[3,48],[10,50]],[[17580,73980],[234,-2],[232,3],[190,-5],[190,2],[348,-2],[211,0],[232,2],[328,0],[141,0],[292,0],[227,1],[143,-1],[294,0],[114,0],[167,1]],[[18973,68711],[-21,23],[-6,49],[-24,59],[2,43],[-28,117],[-17,36],[-8,-52],[-20,-3],[5,-33],[-16,-98],[15,-64],[-32,26],[-9,-16],[-24,13],[-3,-19],[-30,-40],[-13,63],[-22,-8],[-13,-25],[-10,13],[-21,-30],[-8,22],[-14,-8],[-12,35],[-16,7],[-9,-35],[-9,0],[-2,-61],[-8,-45],[-24,38],[-8,-20],[-11,24],[-33,2],[-17,22],[-17,-23],[-15,-72],[6,-53],[-9,-22],[-11,44],[-18,24],[-15,40],[-6,53],[5,34],[-21,81],[9,48],[-5,50],[-18,109],[-32,58],[-26,-44],[-4,40],[-28,53],[-11,97],[14,13],[2,55],[-4,61],[-19,39],[2,26],[-17,15],[-7,73],[-24,73],[-1,35],[-14,54],[2,70],[-8,19],[-6,57],[6,30],[-1,46],[-19,0],[7,95],[-15,25],[-12,-2],[2,26],[-10,44],[-15,26],[-9,-13],[2,-41],[-15,-35],[-19,-82],[-19,-26],[-13,12],[-3,-58],[-24,-42],[-5,36],[-14,22],[-13,60],[-25,0],[4,53],[-8,36],[18,37],[1,48],[-19,74],[18,89],[25,1],[7,44],[-13,54],[6,49],[-19,27],[-4,54],[9,58],[-17,33],[2,49],[19,7],[-1,79],[-6,30],[13,24],[1,116],[13,65],[-7,69],[12,3],[10,123],[-3,58],[-8,10],[-26,-23],[-4,-21],[-22,15],[-19,-5],[-8,39],[6,39],[-7,30],[-14,9],[-4,-30],[-15,-21],[-6,17],[6,55],[-34,58],[-16,59],[4,71],[-20,60],[-13,-1],[-6,60],[-19,82],[-17,54],[-12,13],[-5,37],[-11,7],[2,38],[-9,41],[-24,10],[-32,45],[-7,54],[-47,87],[-11,-2],[12,36],[22,8],[3,22],[-16,7],[-5,57],[-11,5],[2,34],[13,32],[-12,55],[2,63],[-13,24],[-7,47],[-8,-6],[-8,88],[-15,21],[-39,152],[-1,279],[1,109],[0,804]],[[29991,69339],[3,68],[18,64],[-3,15],[11,74],[-13,36],[18,11],[4,26],[22,42],[15,-61],[28,-5],[13,70]],[[30213,67064],[-30,-174],[-2,-44]],[[29724,66677],[-9,53],[-6,-10],[-12,102],[9,73],[1,57],[13,10],[8,45],[-6,52],[9,33],[-5,65],[4,138],[12,64],[-6,60],[10,135],[-5,35],[5,74],[15,33],[6,109],[9,44],[19,43],[6,44],[-1,64],[19,67],[0,85],[12,44],[12,69],[0,47],[-10,68],[6,57],[-6,34],[10,61],[35,32],[10,-13],[16,21],[5,52],[24,14],[14,39],[7,45],[16,22],[-6,59],[11,13],[2,73],[-10,38],[-11,102],[15,52],[4,64],[18,75],[-13,89],[11,30]],[[29842,64964],[3,18],[27,22],[-21,-43],[-9,3]],[[29812,64781],[5,20],[11,-16],[0,-50],[-6,35],[-10,11]],[[29792,64880],[16,16],[-12,-43],[-4,27]],[[29275,64272],[5,-67],[-9,-39],[-38,-78],[-11,-1]],[[28633,68013],[16,50],[-5,-45],[-11,-5]],[[28611,68032],[12,40],[9,-5],[-21,-35]],[[27689,66145],[33,53],[53,111],[29,91],[30,50],[26,25],[11,70],[13,36],[4,52],[36,56],[19,54],[-4,80],[-13,40],[2,43],[-7,37],[-23,35],[1,92],[-18,15],[9,77],[-5,125],[-3,13],[28,22],[38,42],[56,47],[40,20],[33,2],[38,-9],[36,8],[86,-42],[23,-19],[15,-47],[23,-46],[12,-10],[40,49],[35,1],[43,12],[21,-19],[23,-1],[14,25],[30,20],[18,40],[9,1],[19,80],[30,64],[10,8],[19,54],[14,5],[20,-15],[17,19],[9,53],[2,87],[-9,180],[-20,40],[11,50],[14,11],[2,-33],[21,41],[-3,43],[-19,47],[-22,-15],[5,29],[-15,51],[-15,1],[1,80],[16,115],[19,5],[23,42],[0,48],[18,22],[27,55],[9,-5],[16,29],[25,75],[4,46],[12,51],[41,121],[31,100],[56,141],[-1,12],[68,109],[26,62],[18,0],[22,37],[27,-29],[19,10],[91,-8],[53,-1],[107,14],[24,-1],[93,10]],[[29478,69336],[1,-109],[-7,-30],[-4,-63],[13,-57],[-10,-55],[-2,-92],[-4,-31],[4,-70],[19,-88],[4,-69],[-12,-80],[7,-114],[-4,-36],[-19,-63],[-5,-89],[-8,-79],[9,-27],[-1,-103],[10,-67],[-5,-64],[12,-57],[-16,-97],[-7,-114],[10,-26],[7,66],[19,0],[2,-53],[13,-29],[-2,-343],[-6,-422],[0,-74],[-4,-37],[8,-65]],[[29390,64649],[-7,-42],[-21,-42],[-2,-79],[-13,2],[9,-60],[18,87],[11,-15],[10,42],[21,27],[18,2],[4,33],[22,-30],[2,41],[9,-28],[20,-8],[18,-23],[23,28],[2,43],[17,8],[10,-12],[75,3],[39,20],[14,18],[30,63],[9,40],[12,13],[13,50],[21,21],[12,-2],[-18,-52],[-9,-6],[15,-31],[5,-44],[17,-12],[11,25],[16,-72],[15,17],[23,48],[2,28],[17,11],[12,-12],[-5,-21],[-67,-94],[-78,-123],[-50,-62],[-81,-93],[-53,-78],[-43,-41],[-27,-12],[-6,15],[-64,-60],[-61,10],[-46,-55],[3,38],[-23,-2],[3,25],[-11,39],[7,35],[-8,36]],[[26861,65369],[16,17],[-2,-36],[-14,19]],[[26831,65420],[6,90],[11,-35],[-3,-35],[-14,-42],[0,22]],[[26661,65520],[1,-26],[21,-28],[13,17],[37,-82],[25,-20],[11,-21],[18,-66],[19,-29],[18,23],[2,50],[7,13],[14,-55],[19,2],[-1,-37],[29,-96],[16,-33],[22,-21],[41,57],[22,4],[17,35],[51,60],[37,-38],[19,15],[20,-9],[29,61],[29,86],[8,10],[16,58],[44,102],[10,1],[67,108],[30,17],[24,34],[65,69],[17,24]],[[15490,70789],[21,10],[13,-45],[-1,-55],[17,-42],[25,-1],[32,51],[14,-4],[59,-119],[7,-61],[18,-81],[1,-57],[7,-52],[-3,-67],[10,-88],[-4,-41],[3,-50],[33,-54],[46,-35],[11,-19],[17,14],[13,-32],[18,-5],[23,39],[23,7],[54,83],[12,45],[15,16],[21,-15],[29,12],[28,26],[19,-30],[17,-9],[18,14],[34,-40],[9,-75],[14,4],[19,50],[34,4],[13,-16],[11,34],[47,51],[15,35],[21,-9],[21,-51],[22,6],[34,26],[20,5],[11,42],[28,27],[29,46],[46,27],[37,10],[13,57],[14,23],[24,-22],[64,39],[17,-14],[19,6],[28,42],[11,36],[163,1],[250,-3],[164,-3]],[[17338,70482],[16,-107],[11,-27],[16,-75],[18,5],[10,-47],[19,-2],[16,-48],[0,-53],[13,-49],[7,-54],[-24,-108],[-1,-55],[-10,-23],[-24,-150],[1,-36],[-9,-51],[-7,-116],[-13,-40],[-6,-53],[-14,-44],[-3,-51],[7,-58],[-9,-68],[-18,-76],[0,-21],[-32,-49],[-14,-93],[-8,-97],[-10,-66],[-18,-48],[3,-66],[-8,-36],[15,-69],[-8,-56],[13,-35],[19,25],[16,-59],[20,12],[2,-53],[18,-17],[1,-31],[-10,-62],[-12,-17],[1,-42],[11,-32],[-1,-43],[-12,-81],[0,-54],[-11,-11],[-2,-59],[0,-2105]],[[17307,65831],[-166,-2],[-273,-5],[-26,-3],[-143,2],[-220,2]],[[15305,65829],[-21,55],[-15,55],[-7,69],[2,33],[-14,81],[2,32],[-7,63],[-2,126],[13,147],[-7,107],[-17,87],[-11,2],[-11,123],[15,90],[12,96],[6,83],[0,52],[9,80],[6,99],[-6,42],[17,53],[8,43],[16,132],[15,193],[15,283],[7,225],[4,188],[-2,8],[10,197],[-1,69],[7,184],[0,92],[-5,39],[8,91],[12,227],[8,117],[4,157],[-3,66],[3,109],[-4,69],[5,24],[5,176],[-1,76],[-11,41],[6,87],[-2,83],[-7,45],[16,36],[1,109],[-19,193],[27,-79],[14,-14],[-3,38],[23,10],[7,17],[11,-28],[12,31],[15,0],[20,51]],[[26599,59546],[33,-4],[78,1],[5,-5],[157,-1],[61,3],[151,-2],[3,26],[77,-5],[-8,-28]],[[18139,65823],[61,-6],[262,13],[192,2],[5,-5],[196,3],[118,3]],[[18136,60011],[0,880],[1,11],[-1,272],[1,173],[-1,298],[1,318],[0,1661],[1,149],[0,628],[1,266],[0,1156]],[[28738,60998],[7,-15],[-7,-27],[0,42]],[[28949,61206],[-16,-79],[-15,-98],[-8,-27],[-5,21],[-15,-7],[-19,-78],[-12,-70],[-11,-126],[1,-64],[-23,-128],[7,-14],[-18,-91],[-12,-79],[-9,-11],[1,-57],[-11,-86],[-18,-64],[-16,2],[4,-35],[-9,-5],[-1,84],[-10,55],[-4,61],[2,70],[9,59],[3,89],[10,105],[4,76],[16,79],[18,110],[-4,34],[21,17],[15,65],[1,28],[-20,21],[25,54]],[[28739,61120],[-11,-44],[-3,44]],[[28423,61914],[-20,-21],[-13,21],[0,-52],[-18,-113],[-4,-52],[2,-76],[15,-59],[29,15],[6,26],[15,0],[12,38],[9,-30],[-6,-74],[19,-64],[0,-49],[35,-59],[25,-2],[7,-28],[6,21],[24,-9],[4,-44],[16,-39],[8,-59],[13,-15],[15,-54],[20,-23],[30,-68],[-5,-65],[-15,-24],[-2,-107],[4,-29],[-11,-46],[13,-23],[-19,-30],[-31,64],[-11,-27],[-7,25],[0,41],[-13,81],[-19,32],[-8,35],[-12,12],[-21,103],[-11,11],[-4,45],[-13,30],[-2,-30],[28,-89],[20,-114],[15,-24],[1,-25],[16,-14],[10,-96],[11,-53],[30,-4],[7,-36],[31,-24],[-14,-29],[-1,-37],[13,-8],[4,22],[8,-41],[5,-110],[-8,-90],[-18,63],[-21,45],[-9,-42],[11,-39],[7,-55],[9,-14],[-22,-24],[-18,-4],[6,-39],[22,11],[-2,-76],[14,12],[4,-31],[12,-20],[6,-49],[-9,-97],[-4,15],[-16,-18],[-15,-34],[-10,68],[-29,61],[-14,45],[4,48],[-13,71],[-22,-9],[-8,-25],[-10,46],[-18,11],[-4,23],[-21,-35],[11,-33],[12,8],[18,-13],[15,-55],[9,-2],[8,58],[8,-119],[1,-67],[22,-19],[25,-82],[1,-65],[27,4],[9,27],[1,-33],[9,-11],[-3,86],[17,6],[13,-29],[35,-36],[17,27],[11,-11],[8,-128],[12,-140],[9,-71],[7,-94]],[[15775,72069],[4,105],[10,72],[12,-52],[-2,-58],[19,-32],[-18,-27],[-5,-26],[-18,-12],[-2,30]],[[15740,73454],[0,40],[20,-41],[-17,-26],[-3,27]],[[15720,73667],[6,14],[26,-115],[-18,42],[-14,59]],[[15715,73495],[8,29],[12,-47],[-15,-33],[-5,51]],[[15707,73080],[13,89],[14,59],[2,55],[16,11],[7,-19],[0,-49],[19,-38],[3,-26],[-15,-19],[-17,15],[-1,-29],[-13,-34],[-14,-7],[3,-24],[23,10],[11,-42],[8,-84],[-4,-14],[10,-100],[8,27],[-5,67],[10,-3],[16,-57],[16,-13],[7,-94],[-8,-58],[-14,13],[-12,86],[-21,-25],[2,30],[-19,44],[3,93],[-5,56],[-18,-4],[-3,30],[-22,54]],[[15649,73739],[11,-4],[34,-53],[-8,-8],[-22,20],[-15,45]],[[15623,73630],[17,26],[2,-33],[-19,7]],[[15618,73982],[15,0],[4,-29],[-17,-2],[-2,31]],[[15586,73509],[7,30],[20,1],[2,-29],[15,-33],[17,-9],[-18,69],[37,108],[12,-2],[37,-58],[-19,-50],[11,-66],[-2,-62],[-11,-25],[4,-69],[-20,-12],[-15,50],[-9,-12],[-22,11],[-31,62],[-6,76],[-9,20]],[[15577,73617],[18,-10],[18,-54],[-30,41],[-6,23]],[[17306,73978],[-1,-290],[0,-441],[-2,-286],[0,-702],[1,-52],[0,-1247],[-7,-48],[20,-76],[8,-54],[0,-63],[12,-40],[-17,-93],[7,-11],[11,-93]],[[15490,70789],[-34,9],[-3,34],[-12,6],[-10,-31],[-13,10],[-19,-51],[-9,7],[-21,74],[-10,8],[-7,-47],[-10,-10],[6,139],[1,124],[-4,165],[13,-61],[-2,-100],[4,-137],[17,0],[1,37],[-10,40],[0,61],[12,-37],[14,83],[-19,116],[11,42],[25,53],[-17,37],[-6,-27],[-18,-2],[4,-23],[-16,4],[-20,44],[-1,55],[-11,130],[8,8],[6,-52],[11,31],[52,63],[-10,27],[-34,23],[-2,45],[-27,14],[-8,-24],[8,-90],[-16,-21],[3,38],[-4,206],[-14,176],[-24,80],[-9,207],[-5,77],[-15,162],[-14,36],[-4,55],[-14,23],[-5,31],[-19,29],[-12,110],[-8,101],[1,53],[-11,56],[12,58],[9,138],[-19,46],[3,22],[17,1],[40,-55],[32,-64],[10,-1],[25,-39],[6,12],[41,-55],[-1,-20],[35,-41],[56,-11],[21,13],[31,-37],[9,19],[10,-18],[24,7],[12,-32],[41,2],[32,71],[-3,-24],[22,-42],[7,-45],[17,17],[17,-5],[-3,-32],[14,-20],[1,-59],[10,6],[3,53],[-14,34],[0,40],[12,28],[21,10],[3,-31],[-15,-34],[10,-50],[7,6],[2,48],[10,14],[8,-100],[-15,-10],[11,-42],[8,-78],[13,-21],[-8,-25],[-16,2],[2,-42],[-17,-36],[-9,-113],[-14,-9],[11,113],[-6,17],[-19,-101],[-4,-53],[-21,-70],[-38,-183],[-13,-119],[12,8],[23,-13],[12,27],[21,17],[3,38],[-44,-62],[-17,27],[42,226],[31,74],[29,28],[3,73],[16,73],[31,68],[-9,97],[22,-40],[14,-187],[-22,0],[3,-40],[11,-14],[-4,-56],[7,-19],[0,-53],[-14,-38],[-1,-38],[15,-16],[-10,-48],[-6,-87],[4,-21],[-10,-57],[7,-49],[-15,-79],[-27,78],[8,96],[-16,-42],[-6,-63],[30,-83],[-10,-16],[1,-48],[-11,-26],[-16,46],[-20,105],[12,37],[1,61],[-7,25],[0,-51],[-12,-57],[7,-72],[-6,-48],[13,14],[11,-66],[27,-22],[11,37],[0,33],[13,16],[8,79],[10,53],[-2,30],[25,-58],[10,25],[-4,36],[27,34],[0,50],[-8,58],[-8,11],[6,35],[-10,40],[-7,71],[22,38],[-24,58],[16,82],[-6,91],[15,46],[9,119],[22,25],[-1,69],[-14,23],[-23,86],[1,74],[-10,49],[-15,4],[3,-24],[-11,-28],[10,-67],[18,-50],[1,-35],[-26,85],[-12,4],[-7,58],[2,77],[18,24],[16,-22],[10,42],[-10,45],[-28,45],[-13,48],[1,39],[-29,-33],[-7,33],[4,45],[-13,-17],[3,39],[24,28],[13,-15],[9,-49],[19,7],[-10,108],[17,6],[5,34],[-21,66],[-5,66],[8,44],[-13,30],[-17,-6],[-11,-41],[9,-44],[-19,40],[8,57],[-10,25],[-9,-14],[-1,65],[-21,54],[11,21],[-5,36],[-13,16],[16,54],[184,0],[97,-6],[145,5],[143,-2],[190,0],[169,0],[165,1],[178,0],[325,-2]],[[25685,69733],[6,80],[31,-17],[-23,-128],[-14,65]],[[25568,69555],[12,14],[2,-63],[-14,23],[0,26]],[[24707,71654],[8,83],[12,4],[-5,-75],[-15,-12]],[[24691,71507],[21,33],[-14,-47],[-7,14]],[[24655,71564],[5,21],[30,29],[5,-13],[-11,-48],[-24,-11],[-5,22]],[[24625,71464],[3,27],[20,41],[1,-19],[-24,-49]],[[24631,71609],[14,-54],[-13,-3],[-8,37],[7,20]],[[24621,71679],[35,36],[11,-55],[14,34],[2,-44],[-16,-9],[-17,-49],[-11,42],[-16,20],[-2,25]],[[24616,71401],[17,18],[32,86],[14,-32],[-30,-33],[5,-35],[-17,-4],[-20,-37],[-1,37]],[[24563,71635],[15,17],[-1,-44],[-14,27]],[[24276,71309],[20,-30],[34,11],[49,52],[19,27],[18,0],[48,70],[25,27],[6,26],[17,-22],[7,33],[25,10],[22,70],[14,-12],[14,35],[10,-4],[24,-81],[-14,-76],[-24,-78],[9,-73],[-16,-35],[-11,-77],[13,-16],[42,73],[5,54],[42,-108],[13,-22],[9,10],[25,-27]],[[25508,69434],[-10,-58],[-1,-80],[-37,-13],[-21,-40],[3,-47],[-11,-59],[-9,-15],[-11,-83],[-12,-42],[-7,-104],[3,-25],[-13,-50],[20,-42],[12,7],[7,53],[26,64],[10,3],[15,63],[0,36],[31,133],[26,36],[11,-7],[11,34],[15,-32],[-6,46],[12,97],[27,109],[7,100],[12,-5],[21,32],[1,59],[17,60],[22,-3],[-2,-87],[-16,-5],[-2,-142],[-12,-40],[-8,4],[-5,-53],[-14,-52],[5,-43],[-13,-39],[4,-26],[-18,-33],[-13,-62],[-8,-87],[-17,-107],[-9,-26],[-9,-62],[-21,-268],[9,-94],[-2,-71],[-12,-41],[-23,-46],[-3,-62],[-8,-37],[-14,-162],[2,-82],[8,-50],[-2,-102],[-21,-118],[-7,-136],[-20,-107],[-9,-156],[8,-76],[-5,-38],[8,-85],[-7,-57],[14,-62],[0,-85],[6,-63],[16,-59],[-4,-89],[-11,-107],[6,-145]],[[2682,386],[26,11],[1,-51],[-9,8],[-8,-28],[-10,60]],[[2636,452],[21,8],[-4,-21],[-13,-12],[-4,25]],[[2313,271],[13,35],[16,2],[19,68],[4,-20],[27,2],[4,-44],[-7,13],[-29,-30],[-23,-89],[-11,47],[-13,16]],[[90204,32599],[5,15],[34,16],[21,137],[6,65],[7,-11],[7,-43],[14,-11],[-10,-88],[-32,-109],[-9,-44],[-2,-111],[-12,-56],[-18,30],[-7,101],[8,50],[-12,59]],[[90597,35570],[10,43],[4,-16],[-8,-45],[-6,18]],[[90537,37432],[5,20],[1,-49],[-6,29]],[[90507,37973],[14,53],[0,59],[11,0],[0,-66],[-9,-13],[-10,-55],[-6,22]],[[90501,34555],[4,28],[2,101],[9,-12],[20,67],[5,-22],[-14,-80],[4,-63],[-13,7],[0,-73],[-12,18],[-5,29]],[[90487,38800],[6,39],[11,-28],[-1,-51],[-8,-23],[-7,25],[-1,38]],[[90486,35993],[20,2],[3,-36],[-19,-8],[-4,42]],[[90472,34420],[4,45],[13,54],[5,-54],[-4,-24],[7,-40],[-2,-61],[-9,-29],[-14,109]],[[90343,33382],[11,51],[21,35],[15,-9],[-2,-35],[-12,-13],[-8,-39],[-11,-6],[-5,23],[-9,-7]],[[28030,56345],[-13,-8],[-36,-51],[-27,-66],[-35,-121],[-18,-79],[-7,-45],[-16,-58],[-14,-93],[-13,-174],[3,-55],[-7,-48],[-14,-47],[-23,-41],[-9,-97],[-17,10],[-17,-16],[-11,39],[-16,-33],[-10,-63],[3,-31],[8,10],[0,-33],[-15,-20],[-18,-45],[-9,-52],[-34,-59],[-10,38],[-11,-7],[-1,-32],[17,-22],[-5,-59],[-25,-52],[-7,-40],[-10,5],[-24,-22],[-17,-59],[-6,18],[-36,-90],[-8,21],[-15,-28],[-2,30],[-13,-1],[-4,-42],[15,-83],[-7,-74],[-32,-62],[-19,-20],[-2,41],[-19,40],[-11,-22],[-2,-31],[12,-15],[14,-59],[-15,-65],[-25,-59],[-9,0],[-17,-67],[5,-21]],[[31708,38299],[11,-21],[12,13],[9,-36],[-17,-36],[-12,19],[-3,61]],[[31642,38028],[49,54],[35,-32],[-18,-26],[-21,-7],[-11,-24],[-8,12],[-17,-17],[-9,40]],[[31637,38350],[7,-14],[0,-44],[-7,58]],[[31170,38320],[15,18],[17,49],[-4,63],[7,32],[14,12],[20,-6],[17,-25],[50,2],[20,-22],[24,26],[18,-5],[25,-25],[8,20],[28,0],[27,-20],[16,1],[7,-19],[6,24],[37,-35],[4,19],[18,-18],[6,7],[31,-33],[14,-49],[7,13],[5,-27],[10,-6],[14,22],[-5,-40],[3,-84],[13,-30],[-7,-43],[-11,19],[3,-28],[-10,2],[-7,-32],[-13,1],[-11,-59],[-7,-83],[-8,-6],[-1,-44],[-25,-46],[-15,-9],[-12,12],[-7,-27],[-10,13],[-21,-43],[-10,9],[-9,-29],[-8,9],[-18,66],[-12,-10],[-7,-34],[-21,60],[-8,0],[-25,-33],[-14,24],[-12,-19],[-25,47],[-7,-39],[-14,-27],[-21,-3],[-12,-18],[-8,41],[-21,8],[-11,-32],[-19,19],[-12,-12],[1,53],[10,31],[-11,12],[3,65],[5,15],[1,75],[7,31],[-10,101],[-13,21],[-9,78]],[[30985,38023],[20,12],[5,-43],[-15,-38],[-12,32],[2,37]],[[31858,38286],[13,39],[11,-4],[15,-28],[-13,-4],[1,-49],[-9,20],[-13,-5],[-5,31]],[[31828,37522],[7,36],[-4,40],[7,30],[10,-13],[8,22],[17,3],[6,-29],[39,5],[2,-18],[-32,-48],[-41,-30],[-19,2]],[[31779,38288],[6,50],[10,-23],[12,26],[19,-21],[33,6],[-2,-23],[-14,-4],[9,-42],[-16,-11],[-15,23],[-7,-20],[-12,49],[-23,-10]],[[17306,73978],[171,1],[103,1]],[[18139,65823],[-119,3],[-36,-2],[-58,9],[-63,-7],[-79,0],[-293,0],[-184,5]],[[29478,69336],[71,5],[115,0],[40,-9],[62,-5],[57,2],[168,10]],[[25149,51924],[13,-63],[5,-76],[-3,-101],[-10,-105],[-4,3],[8,90],[4,100],[-1,46],[-12,106]],[[25020,51931],[11,38],[32,81],[2,-14],[-13,-63],[2,-28],[13,-33],[-15,-50],[-3,47],[-10,-10],[-17,10],[-2,22]],[[24941,51321],[17,10],[-9,-42],[-8,32]],[[24732,50824],[7,27],[13,-65],[-8,-14],[-12,52]],[[24681,50807],[39,-33],[-19,-8],[-20,41]],[[24628,50763],[25,19],[2,-17],[-26,-20],[-1,18]],[[24275,51386],[10,27],[12,-5],[3,26],[22,-6],[23,-61],[9,7],[6,-29],[-15,-36],[-1,-40],[-14,-19],[-59,115],[4,21]],[[24969,52072],[-17,-35],[-8,7],[-17,-56],[-2,-38],[-12,-15],[3,-40],[-28,17],[-11,-45],[5,-68],[18,-10],[13,25],[-4,-59],[8,-34],[15,-19],[13,11],[6,29],[5,101],[-2,13],[24,54],[3,44],[18,-34],[13,6],[0,-21],[-17,-34],[0,-34],[15,-17],[3,-61],[15,14],[11,82],[16,-25],[-4,-55],[-13,0],[-12,-44],[22,2],[-3,-29],[-31,-22],[13,-66],[11,22],[-7,-59],[-9,26],[-14,11],[-12,-55],[-1,-99],[-9,-5],[-6,86],[-11,1],[-2,-66],[13,-58],[-13,33],[-14,5],[-8,-17],[-15,6],[18,-39],[0,-32],[-23,49],[0,-25],[12,-32],[-12,-14],[1,-34],[11,-36],[20,-11],[-1,-22],[12,-24],[-1,-34],[7,-46],[9,30],[5,-21],[22,-2],[16,-34],[3,30],[20,-91],[11,44],[24,-111],[0,-59],[6,-13],[18,28],[7,-41],[-24,-15],[-2,-33],[16,-3],[-8,-52],[-11,24],[-12,-96],[2,-44],[-21,36],[-2,55],[-8,16],[-31,-138],[-15,-41],[7,67],[9,29],[5,48],[9,21],[0,54],[9,23],[-1,51],[-10,24],[-4,-62],[-16,-29],[-12,29],[-14,77],[-34,43],[-10,45],[-56,33],[-12,-14],[-48,-143],[-46,-115],[-7,10],[4,41],[-12,16],[-2,41],[6,3],[-12,100],[-11,27],[-9,-1],[1,-28],[-8,-36],[2,76],[-10,56],[-13,-64],[-14,14],[-7,-22],[-7,31],[-6,-27],[10,-63],[-12,4],[-7,-27],[-4,-54],[-8,7],[-5,-57],[-8,12],[-19,-33],[-6,-76],[-16,16],[5,21],[-13,67],[-18,57],[-11,-13],[-26,21],[-10,33],[-25,12],[-16,25],[-16,60],[12,14],[7,58],[8,-12],[12,-52],[7,22],[-1,-68],[15,-17],[-4,104],[-23,64],[0,42],[-11,7],[-9,-41],[-13,-13],[2,41],[-10,-7],[3,39],[9,28],[-10,40],[-29,-50],[-10,80],[-10,-8],[-6,118],[-26,1],[6,33],[1,85],[-32,16],[-13,-10],[-20,-38],[-7,57],[8,41],[8,-3],[-2,46],[-16,8],[-14,-22],[-9,20],[-2,-40],[-24,-36],[-14,-34],[-6,32],[-18,-16],[0,-32],[9,-30],[18,-8],[-9,-30],[8,-63],[20,21],[5,-18],[-13,-14],[6,-20],[-32,-6],[-26,-49],[-20,-9],[-82,63],[-35,42],[-57,101],[-23,32],[-41,40],[-33,5],[-14,-14],[-36,7],[-58,-25],[-17,-13],[-26,-53]],[[30097,65246],[-20,-46],[-6,102],[2,64],[-10,22],[2,-159],[-17,2],[-2,-35],[-10,-7],[-1,55],[16,95],[8,68],[17,46]],[[30029,65436],[5,7],[11,-52],[-5,-7],[-11,52]],[[30019,65203],[6,51],[-4,23],[5,57],[4,-20],[0,-85],[-11,-26]],[[29960,64853],[11,80],[5,-14],[1,-76],[-17,10]],[[30068,65494],[-3,-45],[-14,-41],[-6,42],[4,35],[-19,54],[-8,40],[5,-129],[-22,17],[12,-39],[1,-75],[-12,-11],[8,-53],[0,-72],[-10,-45],[-8,-73],[-12,6],[-27,-18],[-27,-34],[-38,-30],[-1,16]]]};

/***/ },
/* 184 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var asap = __webpack_require__(556);
	
	function noop() {}
	
	// States:
	//
	// 0 - pending
	// 1 - fulfilled with _value
	// 2 - rejected with _value
	// 3 - adopted the state of another promise, _value
	//
	// once the state is no longer pending (0) it is immutable
	
	// All `_` prefixed properties will be reduced to `_{random number}`
	// at build time to obfuscate them and discourage their use.
	// We don't use symbols or Object.defineProperty to fully hide them
	// because the performance isn't good enough.
	
	
	// to avoid using try/catch inside critical functions, we
	// extract them to here.
	var LAST_ERROR = null;
	var IS_ERROR = {};
	function getThen(obj) {
	  try {
	    return obj.then;
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	function tryCallOne(fn, a) {
	  try {
	    return fn(a);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	function tryCallTwo(fn, a, b) {
	  try {
	    fn(a, b);
	  } catch (ex) {
	    LAST_ERROR = ex;
	    return IS_ERROR;
	  }
	}
	
	module.exports = Promise;
	
	function Promise(fn) {
	  if (typeof this !== 'object') {
	    throw new TypeError('Promises must be constructed via new');
	  }
	  if (typeof fn !== 'function') {
	    throw new TypeError('not a function');
	  }
	  this._45 = 0;
	  this._81 = 0;
	  this._65 = null;
	  this._54 = null;
	  if (fn === noop) return;
	  doResolve(fn, this);
	}
	Promise._10 = null;
	Promise._97 = null;
	Promise._61 = noop;
	
	Promise.prototype.then = function(onFulfilled, onRejected) {
	  if (this.constructor !== Promise) {
	    return safeThen(this, onFulfilled, onRejected);
	  }
	  var res = new Promise(noop);
	  handle(this, new Handler(onFulfilled, onRejected, res));
	  return res;
	};
	
	function safeThen(self, onFulfilled, onRejected) {
	  return new self.constructor(function (resolve, reject) {
	    var res = new Promise(noop);
	    res.then(resolve, reject);
	    handle(self, new Handler(onFulfilled, onRejected, res));
	  });
	};
	function handle(self, deferred) {
	  while (self._81 === 3) {
	    self = self._65;
	  }
	  if (Promise._10) {
	    Promise._10(self);
	  }
	  if (self._81 === 0) {
	    if (self._45 === 0) {
	      self._45 = 1;
	      self._54 = deferred;
	      return;
	    }
	    if (self._45 === 1) {
	      self._45 = 2;
	      self._54 = [self._54, deferred];
	      return;
	    }
	    self._54.push(deferred);
	    return;
	  }
	  handleResolved(self, deferred);
	}
	
	function handleResolved(self, deferred) {
	  asap(function() {
	    var cb = self._81 === 1 ? deferred.onFulfilled : deferred.onRejected;
	    if (cb === null) {
	      if (self._81 === 1) {
	        resolve(deferred.promise, self._65);
	      } else {
	        reject(deferred.promise, self._65);
	      }
	      return;
	    }
	    var ret = tryCallOne(cb, self._65);
	    if (ret === IS_ERROR) {
	      reject(deferred.promise, LAST_ERROR);
	    } else {
	      resolve(deferred.promise, ret);
	    }
	  });
	}
	function resolve(self, newValue) {
	  // Promise Resolution Procedure: https://github.com/promises-aplus/promises-spec#the-promise-resolution-procedure
	  if (newValue === self) {
	    return reject(
	      self,
	      new TypeError('A promise cannot be resolved with itself.')
	    );
	  }
	  if (
	    newValue &&
	    (typeof newValue === 'object' || typeof newValue === 'function')
	  ) {
	    var then = getThen(newValue);
	    if (then === IS_ERROR) {
	      return reject(self, LAST_ERROR);
	    }
	    if (
	      then === self.then &&
	      newValue instanceof Promise
	    ) {
	      self._81 = 3;
	      self._65 = newValue;
	      finale(self);
	      return;
	    } else if (typeof then === 'function') {
	      doResolve(then.bind(newValue), self);
	      return;
	    }
	  }
	  self._81 = 1;
	  self._65 = newValue;
	  finale(self);
	}
	
	function reject(self, newValue) {
	  self._81 = 2;
	  self._65 = newValue;
	  if (Promise._97) {
	    Promise._97(self, newValue);
	  }
	  finale(self);
	}
	function finale(self) {
	  if (self._45 === 1) {
	    handle(self, self._54);
	    self._54 = null;
	  }
	  if (self._45 === 2) {
	    for (var i = 0; i < self._54.length; i++) {
	      handle(self, self._54[i]);
	    }
	    self._54 = null;
	  }
	}
	
	function Handler(onFulfilled, onRejected, promise){
	  this.onFulfilled = typeof onFulfilled === 'function' ? onFulfilled : null;
	  this.onRejected = typeof onRejected === 'function' ? onRejected : null;
	  this.promise = promise;
	}
	
	/**
	 * Take a potentially misbehaving resolver function and make sure
	 * onFulfilled and onRejected are only called once.
	 *
	 * Makes no guarantees about asynchrony.
	 */
	function doResolve(fn, promise) {
	  var done = false;
	  var res = tryCallTwo(fn, function (value) {
	    if (done) return;
	    done = true;
	    resolve(promise, value);
	  }, function (reason) {
	    if (done) return;
	    done = true;
	    reject(promise, reason);
	  })
	  if (!done && res === IS_ERROR) {
	    done = true;
	    reject(promise, LAST_ERROR);
	  }
	}


/***/ },
/* 185 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = {
	
	  GLOBAL: {
	    HIDE: '__react_tooltip_hide_event',
	    REBUILD: '__react_tooltip_rebuild_event',
	    SHOW: '__react_tooltip_show_event'
	  }
	};

/***/ },
/* 186 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCustomEvent = function (ele) {
	    var event = this.state.event;
	
	    return event || !!ele.getAttribute('data-event');
	  };
	
	  /* Bind listener for custom event */
	  target.prototype.customBindListener = function (ele) {
	    var _this = this;
	
	    var _state = this.state,
	        event = _state.event,
	        eventOff = _state.eventOff;
	
	    var dataEvent = ele.getAttribute('data-event') || event;
	    var dataEventOff = ele.getAttribute('data-event-off') || eventOff;
	
	    dataEvent.split(' ').forEach(function (event) {
	      ele.removeEventListener(event, customListeners.get(ele, event));
	      var customListener = checkStatus.bind(_this, dataEventOff);
	      customListeners.set(ele, event, customListener);
	      ele.addEventListener(event, customListener, false);
	    });
	    if (dataEventOff) {
	      dataEventOff.split(' ').forEach(function (event) {
	        ele.removeEventListener(event, _this.hideTooltip);
	        ele.addEventListener(event, _this.hideTooltip, false);
	      });
	    }
	  };
	
	  /* Unbind listener for custom event */
	  target.prototype.customUnbindListener = function (ele) {
	    var _state2 = this.state,
	        event = _state2.event,
	        eventOff = _state2.eventOff;
	
	    var dataEvent = event || ele.getAttribute('data-event');
	    var dataEventOff = eventOff || ele.getAttribute('data-event-off');
	
	    ele.removeEventListener(dataEvent, customListeners.get(ele, event));
	    if (dataEventOff) ele.removeEventListener(dataEventOff, this.hideTooltip);
	  };
	};
	
	function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }
	
	/**
	 * Custom events to control showing and hiding of tooltip
	 *
	 * @attributes
	 * - `event` {String}
	 * - `eventOff` {String}
	 */
	
	var checkStatus = exports.checkStatus = function checkStatus(dataEventOff, e) {
	  var show = this.state.show;
	  var id = this.props.id;
	
	  var isCapture = this.isCapture(e.currentTarget);
	  var currentItem = e.currentTarget.getAttribute('currentItem');
	
	  if (!isCapture) e.stopPropagation();
	  if (show && currentItem === 'true') {
	    if (!dataEventOff) this.hideTooltip(e);
	  } else {
	    e.currentTarget.setAttribute('currentItem', 'true');
	    setUntargetItems(e.currentTarget, this.getTargetArray(id));
	    this.showTooltip(e);
	  }
	};
	
	var setUntargetItems = function setUntargetItems(currentTarget, targetArray) {
	  for (var i = 0; i < targetArray.length; i++) {
	    if (currentTarget !== targetArray[i]) {
	      targetArray[i].setAttribute('currentItem', 'false');
	    } else {
	      targetArray[i].setAttribute('currentItem', 'true');
	    }
	  }
	};
	
	var customListeners = {
	  id: '9b69f92e-d3fe-498b-b1b4-c5e63a51b0cf',
	  set: function set(target, event, listener) {
	    if (this.id in target) {
	      var map = target[this.id];
	      map[event] = listener;
	    } else {
	      // this is workaround for WeakMap, which is not supported in older browsers, such as IE
	      Object.defineProperty(target, this.id, {
	        configurable: true,
	        value: _defineProperty({}, event, listener)
	      });
	    }
	  },
	  get: function get(target, event) {
	    var map = target[this.id];
	    if (map !== undefined) {
	      return map[event];
	    }
	  }
	};

/***/ },
/* 187 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(103));
	
	var _ChildMapping = __webpack_require__(596);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function _assertThisInitialized(self) { if (self === void 0) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return self; }
	
	var values = Object.values || function (obj) {
	  return Object.keys(obj).map(function (k) {
	    return obj[k];
	  });
	};
	
	var defaultProps = {
	  component: 'div',
	  childFactory: function childFactory(child) {
	    return child;
	  }
	  /**
	   * The `<TransitionGroup>` component manages a set of transition components
	   * (`<Transition>` and `<CSSTransition>`) in a list. Like with the transition
	   * components, `<TransitionGroup>` is a state machine for managing the mounting
	   * and unmounting of components over time.
	   *
	   * Consider the example below. As items are removed or added to the TodoList the
	   * `in` prop is toggled automatically by the `<TransitionGroup>`.
	   *
	   * Note that `<TransitionGroup>`  does not define any animation behavior!
	   * Exactly _how_ a list item animates is up to the individual transition
	   * component. This means you can mix and match animations across different list
	   * items.
	   */
	
	};
	
	var TransitionGroup =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(TransitionGroup, _React$Component);
	
	  function TransitionGroup(props, context) {
	    var _this;
	
	    _this = _React$Component.call(this, props, context) || this;
	
	    var handleExited = _this.handleExited.bind(_assertThisInitialized(_assertThisInitialized(_this))); // Initial children should all be entering, dependent on appear
	
	
	    _this.state = {
	      contextValue: {
	        isMounting: true
	      },
	      handleExited: handleExited,
	      firstRender: true
	    };
	    return _this;
	  }
	
	  var _proto = TransitionGroup.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.mounted = true;
	    this.setState({
	      contextValue: {
	        isMounting: false
	      }
	    });
	  };
	
	  _proto.componentWillUnmount = function componentWillUnmount() {
	    this.mounted = false;
	  };
	
	  TransitionGroup.getDerivedStateFromProps = function getDerivedStateFromProps(nextProps, _ref) {
	    var prevChildMapping = _ref.children,
	        handleExited = _ref.handleExited,
	        firstRender = _ref.firstRender;
	    return {
	      children: firstRender ? (0, _ChildMapping.getInitialChildMapping)(nextProps, handleExited) : (0, _ChildMapping.getNextChildMapping)(nextProps, prevChildMapping, handleExited),
	      firstRender: false
	    };
	  };
	
	  _proto.handleExited = function handleExited(child, node) {
	    var currentChildMapping = (0, _ChildMapping.getChildMapping)(this.props.children);
	    if (child.key in currentChildMapping) return;
	
	    if (child.props.onExited) {
	      child.props.onExited(node);
	    }
	
	    if (this.mounted) {
	      this.setState(function (state) {
	        var children = _extends({}, state.children);
	
	        delete children[child.key];
	        return {
	          children: children
	        };
	      });
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        Component = _this$props.component,
	        childFactory = _this$props.childFactory,
	        props = _objectWithoutPropertiesLoose(_this$props, ["component", "childFactory"]);
	
	    var contextValue = this.state.contextValue;
	    var children = values(this.state.children).map(childFactory);
	    delete props.appear;
	    delete props.enter;
	    delete props.exit;
	
	    if (Component === null) {
	      return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	        value: contextValue
	      }, children);
	    }
	
	    return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: contextValue
	    }, _react.default.createElement(Component, props, children));
	  };
	
	  return TransitionGroup;
	}(_react.default.Component);
	
	TransitionGroup.propTypes =  false ? {
	  /**
	   * `<TransitionGroup>` renders a `<div>` by default. You can change this
	   * behavior by providing a `component` prop.
	   * If you use React v16+ and would like to avoid a wrapping `<div>` element
	   * you can pass in `component={null}`. This is useful if the wrapping div
	   * borks your css styles.
	   */
	  component: _propTypes.default.any,
	
	  /**
	   * A set of `<Transition>` components, that are toggled `in` and out as they
	   * leave. the `<TransitionGroup>` will inject specific transition props, so
	   * remember to spread them through if you are wrapping the `<Transition>` as
	   * with our `<Fade>` example.
	   *
	   * While this component is meant for multiple `Transition` or `CSSTransition`
	   * children, sometimes you may want to have a single transition child with
	   * content that you want to be transitioned out and in when you change it
	   * (e.g. routes, images etc.) In that case you can change the `key` prop of
	   * the transition child as you change its content, this will cause
	   * `TransitionGroup` to transition the child out and back in.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A convenience prop that enables or disables appear animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  appear: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables enter animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  enter: _propTypes.default.bool,
	
	  /**
	   * A convenience prop that enables or disables exit animations
	   * for all children. Note that specifying this will override any defaults set
	   * on individual children Transitions.
	   */
	  exit: _propTypes.default.bool,
	
	  /**
	   * You may need to apply reactive updates to a child as it is exiting.
	   * This is generally done by using `cloneElement` however in the case of an exiting
	   * child the element has already been removed and not accessible to the consumer.
	   *
	   * If you do need to update a child as it leaves you can provide a `childFactory`
	   * to wrap every child, even the ones that are leaving.
	   *
	   * @type Function(child: ReactElement) -> ReactElement
	   */
	  childFactory: _propTypes.default.func
	} : {};
	TransitionGroup.defaultProps = defaultProps;
	var _default = TransitionGroup;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 188 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	var _default = {
	  disabled: false
	};
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 189 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.classNamesShape = exports.timeoutsShape = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var timeoutsShape =  false ? _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	  enter: _propTypes.default.number,
	  exit: _propTypes.default.number,
	  appear: _propTypes.default.number
	}).isRequired]) : null;
	exports.timeoutsShape = timeoutsShape;
	var classNamesShape =  false ? _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  active: _propTypes.default.string
	}), _propTypes.default.shape({
	  enter: _propTypes.default.string,
	  enterDone: _propTypes.default.string,
	  enterActive: _propTypes.default.string,
	  exit: _propTypes.default.string,
	  exitDone: _propTypes.default.string,
	  exitActive: _propTypes.default.string
	})]) : null;
	exports.classNamesShape = classNamesShape;

/***/ },
/* 190 */
/***/ function(module, exports, __webpack_require__) {

	// https://github.com/topojson/topojson-client v3.1.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.topojson = global.topojson || {}));
	}(this, function (exports) { 'use strict';
	
	function identity(x) {
	  return x;
	}
	
	function transform(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2, n = input.length, output = new Array(n);
	    output[0] = (x0 += input[0]) * kx + dx;
	    output[1] = (y0 += input[1]) * ky + dy;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	}
	
	function bbox(topology) {
	  var t = transform(topology.transform), key,
	      x0 = Infinity, y0 = x0, x1 = -x0, y1 = -x0;
	
	  function bboxPoint(p) {
	    p = t(p);
	    if (p[0] < x0) x0 = p[0];
	    if (p[0] > x1) x1 = p[0];
	    if (p[1] < y0) y0 = p[1];
	    if (p[1] > y1) y1 = p[1];
	  }
	
	  function bboxGeometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(bboxGeometry); break;
	      case "Point": bboxPoint(o.coordinates); break;
	      case "MultiPoint": o.coordinates.forEach(bboxPoint); break;
	    }
	  }
	
	  topology.arcs.forEach(function(arc) {
	    var i = -1, n = arc.length, p;
	    while (++i < n) {
	      p = t(arc[i], i);
	      if (p[0] < x0) x0 = p[0];
	      if (p[0] > x1) x1 = p[0];
	      if (p[1] < y0) y0 = p[1];
	      if (p[1] > y1) y1 = p[1];
	    }
	  });
	
	  for (key in topology.objects) {
	    bboxGeometry(topology.objects[key]);
	  }
	
	  return [x0, y0, x1, y1];
	}
	
	function reverse(array, n) {
	  var t, j = array.length, i = j - n;
	  while (i < --j) t = array[i], array[i++] = array[j], array[j] = t;
	}
	
	function feature(topology, o) {
	  if (typeof o === "string") o = topology.objects[o];
	  return o.type === "GeometryCollection"
	      ? {type: "FeatureCollection", features: o.geometries.map(function(o) { return feature$1(topology, o); })}
	      : feature$1(topology, o);
	}
	
	function feature$1(topology, o) {
	  var id = o.id,
	      bbox = o.bbox,
	      properties = o.properties == null ? {} : o.properties,
	      geometry = object(topology, o);
	  return id == null && bbox == null ? {type: "Feature", properties: properties, geometry: geometry}
	      : bbox == null ? {type: "Feature", id: id, properties: properties, geometry: geometry}
	      : {type: "Feature", id: id, bbox: bbox, properties: properties, geometry: geometry};
	}
	
	function object(topology, o) {
	  var transformPoint = transform(topology.transform),
	      arcs = topology.arcs;
	
	  function arc(i, points) {
	    if (points.length) points.pop();
	    for (var a = arcs[i < 0 ? ~i : i], k = 0, n = a.length; k < n; ++k) {
	      points.push(transformPoint(a[k], k));
	    }
	    if (i < 0) reverse(points, n);
	  }
	
	  function point(p) {
	    return transformPoint(p);
	  }
	
	  function line(arcs) {
	    var points = [];
	    for (var i = 0, n = arcs.length; i < n; ++i) arc(arcs[i], points);
	    if (points.length < 2) points.push(points[0]); // This should never happen per the specification.
	    return points;
	  }
	
	  function ring(arcs) {
	    var points = line(arcs);
	    while (points.length < 4) points.push(points[0]); // This may happen if an arc has only two points.
	    return points;
	  }
	
	  function polygon(arcs) {
	    return arcs.map(ring);
	  }
	
	  function geometry(o) {
	    var type = o.type, coordinates;
	    switch (type) {
	      case "GeometryCollection": return {type: type, geometries: o.geometries.map(geometry)};
	      case "Point": coordinates = point(o.coordinates); break;
	      case "MultiPoint": coordinates = o.coordinates.map(point); break;
	      case "LineString": coordinates = line(o.arcs); break;
	      case "MultiLineString": coordinates = o.arcs.map(line); break;
	      case "Polygon": coordinates = polygon(o.arcs); break;
	      case "MultiPolygon": coordinates = o.arcs.map(polygon); break;
	      default: return null;
	    }
	    return {type: type, coordinates: coordinates};
	  }
	
	  return geometry(o);
	}
	
	function stitch(topology, arcs) {
	  var stitchedArcs = {},
	      fragmentByStart = {},
	      fragmentByEnd = {},
	      fragments = [],
	      emptyIndex = -1;
	
	  // Stitch empty arcs first, since they may be subsumed by other arcs.
	  arcs.forEach(function(i, j) {
	    var arc = topology.arcs[i < 0 ? ~i : i], t;
	    if (arc.length < 3 && !arc[1][0] && !arc[1][1]) {
	      t = arcs[++emptyIndex], arcs[emptyIndex] = i, arcs[j] = t;
	    }
	  });
	
	  arcs.forEach(function(i) {
	    var e = ends(i),
	        start = e[0],
	        end = e[1],
	        f, g;
	
	    if (f = fragmentByEnd[start]) {
	      delete fragmentByEnd[f.end];
	      f.push(i);
	      f.end = end;
	      if (g = fragmentByStart[end]) {
	        delete fragmentByStart[g.start];
	        var fg = g === f ? f : f.concat(g);
	        fragmentByStart[fg.start = f.start] = fragmentByEnd[fg.end = g.end] = fg;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else if (f = fragmentByStart[end]) {
	      delete fragmentByStart[f.start];
	      f.unshift(i);
	      f.start = start;
	      if (g = fragmentByEnd[start]) {
	        delete fragmentByEnd[g.end];
	        var gf = g === f ? f : g.concat(f);
	        fragmentByStart[gf.start = g.start] = fragmentByEnd[gf.end = f.end] = gf;
	      } else {
	        fragmentByStart[f.start] = fragmentByEnd[f.end] = f;
	      }
	    } else {
	      f = [i];
	      fragmentByStart[f.start = start] = fragmentByEnd[f.end = end] = f;
	    }
	  });
	
	  function ends(i) {
	    var arc = topology.arcs[i < 0 ? ~i : i], p0 = arc[0], p1;
	    if (topology.transform) p1 = [0, 0], arc.forEach(function(dp) { p1[0] += dp[0], p1[1] += dp[1]; });
	    else p1 = arc[arc.length - 1];
	    return i < 0 ? [p1, p0] : [p0, p1];
	  }
	
	  function flush(fragmentByEnd, fragmentByStart) {
	    for (var k in fragmentByEnd) {
	      var f = fragmentByEnd[k];
	      delete fragmentByStart[f.start];
	      delete f.start;
	      delete f.end;
	      f.forEach(function(i) { stitchedArcs[i < 0 ? ~i : i] = 1; });
	      fragments.push(f);
	    }
	  }
	
	  flush(fragmentByEnd, fragmentByStart);
	  flush(fragmentByStart, fragmentByEnd);
	  arcs.forEach(function(i) { if (!stitchedArcs[i < 0 ? ~i : i]) fragments.push([i]); });
	
	  return fragments;
	}
	
	function mesh(topology) {
	  return object(topology, meshArcs.apply(this, arguments));
	}
	
	function meshArcs(topology, object, filter) {
	  var arcs, i, n;
	  if (arguments.length > 1) arcs = extractArcs(topology, object, filter);
	  else for (i = 0, arcs = new Array(n = topology.arcs.length); i < n; ++i) arcs[i] = i;
	  return {type: "MultiLineString", arcs: stitch(topology, arcs)};
	}
	
	function extractArcs(topology, object, filter) {
	  var arcs = [],
	      geomsByArc = [],
	      geom;
	
	  function extract0(i) {
	    var j = i < 0 ? ~i : i;
	    (geomsByArc[j] || (geomsByArc[j] = [])).push({i: i, g: geom});
	  }
	
	  function extract1(arcs) {
	    arcs.forEach(extract0);
	  }
	
	  function extract2(arcs) {
	    arcs.forEach(extract1);
	  }
	
	  function extract3(arcs) {
	    arcs.forEach(extract2);
	  }
	
	  function geometry(o) {
	    switch (geom = o, o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "LineString": extract1(o.arcs); break;
	      case "MultiLineString": case "Polygon": extract2(o.arcs); break;
	      case "MultiPolygon": extract3(o.arcs); break;
	    }
	  }
	
	  geometry(object);
	
	  geomsByArc.forEach(filter == null
	      ? function(geoms) { arcs.push(geoms[0].i); }
	      : function(geoms) { if (filter(geoms[0].g, geoms[geoms.length - 1].g)) arcs.push(geoms[0].i); });
	
	  return arcs;
	}
	
	function planarRingArea(ring) {
	  var i = -1, n = ring.length, a, b = ring[n - 1], area = 0;
	  while (++i < n) a = b, b = ring[i], area += a[0] * b[1] - a[1] * b[0];
	  return Math.abs(area); // Note: doubled area!
	}
	
	function merge(topology) {
	  return object(topology, mergeArcs.apply(this, arguments));
	}
	
	function mergeArcs(topology, objects) {
	  var polygonsByArc = {},
	      polygons = [],
	      groups = [];
	
	  objects.forEach(geometry);
	
	  function geometry(o) {
	    switch (o.type) {
	      case "GeometryCollection": o.geometries.forEach(geometry); break;
	      case "Polygon": extract(o.arcs); break;
	      case "MultiPolygon": o.arcs.forEach(extract); break;
	    }
	  }
	
	  function extract(polygon) {
	    polygon.forEach(function(ring) {
	      ring.forEach(function(arc) {
	        (polygonsByArc[arc = arc < 0 ? ~arc : arc] || (polygonsByArc[arc] = [])).push(polygon);
	      });
	    });
	    polygons.push(polygon);
	  }
	
	  function area(ring) {
	    return planarRingArea(object(topology, {type: "Polygon", arcs: [ring]}).coordinates[0]);
	  }
	
	  polygons.forEach(function(polygon) {
	    if (!polygon._) {
	      var group = [],
	          neighbors = [polygon];
	      polygon._ = 1;
	      groups.push(group);
	      while (polygon = neighbors.pop()) {
	        group.push(polygon);
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            polygonsByArc[arc < 0 ? ~arc : arc].forEach(function(polygon) {
	              if (!polygon._) {
	                polygon._ = 1;
	                neighbors.push(polygon);
	              }
	            });
	          });
	        });
	      }
	    }
	  });
	
	  polygons.forEach(function(polygon) {
	    delete polygon._;
	  });
	
	  return {
	    type: "MultiPolygon",
	    arcs: groups.map(function(polygons) {
	      var arcs = [], n;
	
	      // Extract the exterior (unique) arcs.
	      polygons.forEach(function(polygon) {
	        polygon.forEach(function(ring) {
	          ring.forEach(function(arc) {
	            if (polygonsByArc[arc < 0 ? ~arc : arc].length < 2) {
	              arcs.push(arc);
	            }
	          });
	        });
	      });
	
	      // Stitch the arcs into one or more rings.
	      arcs = stitch(topology, arcs);
	
	      // If more than one ring is returned,
	      // at most one of these rings can be the exterior;
	      // choose the one with the greatest absolute area.
	      if ((n = arcs.length) > 1) {
	        for (var i = 1, k = area(arcs[0]), ki, t; i < n; ++i) {
	          if ((ki = area(arcs[i])) > k) {
	            t = arcs[0], arcs[0] = arcs[i], arcs[i] = t, k = ki;
	          }
	        }
	      }
	
	      return arcs;
	    }).filter(function(arcs) {
	      return arcs.length > 0;
	    })
	  };
	}
	
	function bisect(a, x) {
	  var lo = 0, hi = a.length;
	  while (lo < hi) {
	    var mid = lo + hi >>> 1;
	    if (a[mid] < x) lo = mid + 1;
	    else hi = mid;
	  }
	  return lo;
	}
	
	function neighbors(objects) {
	  var indexesByArc = {}, // arc index -> array of object indexes
	      neighbors = objects.map(function() { return []; });
	
	  function line(arcs, i) {
	    arcs.forEach(function(a) {
	      if (a < 0) a = ~a;
	      var o = indexesByArc[a];
	      if (o) o.push(i);
	      else indexesByArc[a] = [i];
	    });
	  }
	
	  function polygon(arcs, i) {
	    arcs.forEach(function(arc) { line(arc, i); });
	  }
	
	  function geometry(o, i) {
	    if (o.type === "GeometryCollection") o.geometries.forEach(function(o) { geometry(o, i); });
	    else if (o.type in geometryType) geometryType[o.type](o.arcs, i);
	  }
	
	  var geometryType = {
	    LineString: line,
	    MultiLineString: polygon,
	    Polygon: polygon,
	    MultiPolygon: function(arcs, i) { arcs.forEach(function(arc) { polygon(arc, i); }); }
	  };
	
	  objects.forEach(geometry);
	
	  for (var i in indexesByArc) {
	    for (var indexes = indexesByArc[i], m = indexes.length, j = 0; j < m; ++j) {
	      for (var k = j + 1; k < m; ++k) {
	        var ij = indexes[j], ik = indexes[k], n;
	        if ((n = neighbors[ij])[i = bisect(n, ik)] !== ik) n.splice(i, 0, ik);
	        if ((n = neighbors[ik])[i = bisect(n, ij)] !== ij) n.splice(i, 0, ij);
	      }
	    }
	  }
	
	  return neighbors;
	}
	
	function untransform(transform) {
	  if (transform == null) return identity;
	  var x0,
	      y0,
	      kx = transform.scale[0],
	      ky = transform.scale[1],
	      dx = transform.translate[0],
	      dy = transform.translate[1];
	  return function(input, i) {
	    if (!i) x0 = y0 = 0;
	    var j = 2,
	        n = input.length,
	        output = new Array(n),
	        x1 = Math.round((input[0] - dx) / kx),
	        y1 = Math.round((input[1] - dy) / ky);
	    output[0] = x1 - x0, x0 = x1;
	    output[1] = y1 - y0, y0 = y1;
	    while (j < n) output[j] = input[j], ++j;
	    return output;
	  };
	}
	
	function quantize(topology, transform) {
	  if (topology.transform) throw new Error("already quantized");
	
	  if (!transform || !transform.scale) {
	    if (!((n = Math.floor(transform)) >= 2)) throw new Error("n must be ≥2");
	    box = topology.bbox || bbox(topology);
	    var x0 = box[0], y0 = box[1], x1 = box[2], y1 = box[3], n;
	    transform = {scale: [x1 - x0 ? (x1 - x0) / (n - 1) : 1, y1 - y0 ? (y1 - y0) / (n - 1) : 1], translate: [x0, y0]};
	  } else {
	    box = topology.bbox;
	  }
	
	  var t = untransform(transform), box, key, inputs = topology.objects, outputs = {};
	
	  function quantizePoint(point) {
	    return t(point);
	  }
	
	  function quantizeGeometry(input) {
	    var output;
	    switch (input.type) {
	      case "GeometryCollection": output = {type: "GeometryCollection", geometries: input.geometries.map(quantizeGeometry)}; break;
	      case "Point": output = {type: "Point", coordinates: quantizePoint(input.coordinates)}; break;
	      case "MultiPoint": output = {type: "MultiPoint", coordinates: input.coordinates.map(quantizePoint)}; break;
	      default: return input;
	    }
	    if (input.id != null) output.id = input.id;
	    if (input.bbox != null) output.bbox = input.bbox;
	    if (input.properties != null) output.properties = input.properties;
	    return output;
	  }
	
	  function quantizeArc(input) {
	    var i = 0, j = 1, n = input.length, p, output = new Array(n); // pessimistic
	    output[0] = t(input[0], 0);
	    while (++i < n) if ((p = t(input[i], i))[0] || p[1]) output[j++] = p; // non-coincident points
	    if (j === 1) output[j++] = [0, 0]; // an arc must have at least two points
	    output.length = j;
	    return output;
	  }
	
	  for (key in inputs) outputs[key] = quantizeGeometry(inputs[key]);
	
	  return {
	    type: "Topology",
	    bbox: box,
	    transform: transform,
	    objects: outputs,
	    arcs: topology.arcs.map(quantizeArc)
	  };
	}
	
	exports.bbox = bbox;
	exports.feature = feature;
	exports.merge = merge;
	exports.mergeArcs = mergeArcs;
	exports.mesh = mesh;
	exports.meshArcs = meshArcs;
	exports.neighbors = neighbors;
	exports.quantize = quantize;
	exports.transform = transform;
	exports.untransform = untransform;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 191 */
/***/ function(module, exports) {

	function _arrayWithoutHoles(arr) {
	  if (Array.isArray(arr)) {
	    for (var i = 0, arr2 = new Array(arr.length); i < arr.length; i++) {
	      arr2[i] = arr[i];
	    }
	
	    return arr2;
	  }
	}
	
	module.exports = _arrayWithoutHoles;

/***/ },
/* 192 */
/***/ function(module, exports) {

	function _getPrototypeOf(o) {
	  module.exports = _getPrototypeOf = Object.setPrototypeOf ? Object.getPrototypeOf : function _getPrototypeOf(o) {
	    return o.__proto__ || Object.getPrototypeOf(o);
	  };
	  return _getPrototypeOf(o);
	}
	
	module.exports = _getPrototypeOf;

/***/ },
/* 193 */
/***/ function(module, exports, __webpack_require__) {

	var setPrototypeOf = __webpack_require__(197);
	
	function _inherits(subClass, superClass) {
	  if (typeof superClass !== "function" && superClass !== null) {
	    throw new TypeError("Super expression must either be null or a function");
	  }
	
	  subClass.prototype = Object.create(superClass && superClass.prototype, {
	    constructor: {
	      value: subClass,
	      writable: true,
	      configurable: true
	    }
	  });
	  if (superClass) setPrototypeOf(subClass, superClass);
	}
	
	module.exports = _inherits;

/***/ },
/* 194 */
/***/ function(module, exports) {

	function _iterableToArrayLimit(arr, i) {
	  if (!(Symbol.iterator in Object(arr) || Object.prototype.toString.call(arr) === "[object Arguments]")) {
	    return;
	  }
	
	  var _arr = [];
	  var _n = true;
	  var _d = false;
	  var _e = undefined;
	
	  try {
	    for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) {
	      _arr.push(_s.value);
	
	      if (i && _arr.length === i) break;
	    }
	  } catch (err) {
	    _d = true;
	    _e = err;
	  } finally {
	    try {
	      if (!_n && _i["return"] != null) _i["return"]();
	    } finally {
	      if (_d) throw _e;
	    }
	  }
	
	  return _arr;
	}
	
	module.exports = _iterableToArrayLimit;

/***/ },
/* 195 */
/***/ function(module, exports) {

	function _nonIterableSpread() {
	  throw new TypeError("Invalid attempt to spread non-iterable instance");
	}
	
	module.exports = _nonIterableSpread;

/***/ },
/* 196 */
/***/ function(module, exports, __webpack_require__) {

	var _typeof = __webpack_require__(33);
	
	var assertThisInitialized = __webpack_require__(106);
	
	function _possibleConstructorReturn(self, call) {
	  if (call && (_typeof(call) === "object" || typeof call === "function")) {
	    return call;
	  }
	
	  return assertThisInitialized(self);
	}
	
	module.exports = _possibleConstructorReturn;

/***/ },
/* 197 */
/***/ function(module, exports) {

	function _setPrototypeOf(o, p) {
	  module.exports = _setPrototypeOf = Object.setPrototypeOf || function _setPrototypeOf(o, p) {
	    o.__proto__ = p;
	    return o;
	  };
	
	  return _setPrototypeOf(o, p);
	}
	
	module.exports = _setPrototypeOf;

/***/ },
/* 198 */
/***/ function(module, exports, __webpack_require__) {

	var arrayWithHoles = __webpack_require__(105);
	
	var iterableToArray = __webpack_require__(108);
	
	var nonIterableRest = __webpack_require__(109);
	
	function _toArray(arr) {
	  return arrayWithHoles(arr) || iterableToArray(arr) || nonIterableRest();
	}
	
	module.exports = _toArray;

/***/ },
/* 199 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	/**
	 * Validators are functions which assert certain type.
	 * They can return a string which can then be used
	 * to display a helpful error message.
	 * They can also return a function for a custom error message.
	 */
	var isPlainObject = __webpack_require__(528);
	var xtend = __webpack_require__(47);
	
	var DEFAULT_ERROR_PATH = 'value';
	var NEWLINE_INDENT = '\n  ';
	
	var v = {};
	
	/**
	 * Runners
	 *
	 * Take root validators and run assertion
	 */
	v.assert = function(rootValidator, options) {
	  options = options || {};
	  return function(value) {
	    var message = validate(rootValidator, value);
	    // all good
	    if (!message) {
	      return;
	    }
	
	    var errorMessage = processMessage(message, options);
	
	    if (options.apiName) {
	      errorMessage = options.apiName + ': ' + errorMessage;
	    }
	
	    throw new Error(errorMessage);
	  };
	};
	
	/**
	 * Higher Order Validators
	 *
	 * validators which take other validators as input
	 * and output a new validator
	 */
	v.shape = function shape(validatorObj) {
	  var validators = objectEntries(validatorObj);
	  return function shapeValidator(value) {
	    var validationResult = validate(v.plainObject, value);
	
	    if (validationResult) {
	      return validationResult;
	    }
	
	    var key, validator;
	    var errorMessages = [];
	
	    for (var i = 0; i < validators.length; i++) {
	      key = validators[i].key;
	      validator = validators[i].value;
	      validationResult = validate(validator, value[key]);
	
	      if (validationResult) {
	        // return [key].concat(validationResult);
	        errorMessages.push([key].concat(validationResult));
	      }
	    }
	
	    if (errorMessages.length < 2) {
	      return errorMessages[0];
	    }
	
	    // enumerate all the error messages
	    return function(options) {
	      errorMessages = errorMessages.map(function(message) {
	        var key = message[0];
	        var renderedMessage = processMessage(message, options)
	          .split('\n')
	          .join(NEWLINE_INDENT); // indents any inner nesting
	        return '- ' + key + ': ' + renderedMessage;
	      });
	
	      var objectId = options.path.join('.');
	      var ofPhrase = objectId === DEFAULT_ERROR_PATH ? '' : ' of ' + objectId;
	
	      return (
	        'The following properties' +
	        ofPhrase +
	        ' have invalid values:' +
	        NEWLINE_INDENT +
	        errorMessages.join(NEWLINE_INDENT)
	      );
	    };
	  };
	};
	
	v.strictShape = function strictShape(validatorObj) {
	  var shapeValidator = v.shape(validatorObj);
	  return function strictShapeValidator(value) {
	    var shapeResult = shapeValidator(value);
	    if (shapeResult) {
	      return shapeResult;
	    }
	
	    var invalidKeys = Object.keys(value).reduce(function(memo, valueKey) {
	      if (validatorObj[valueKey] === undefined) {
	        memo.push(valueKey);
	      }
	      return memo;
	    }, []);
	
	    if (invalidKeys.length !== 0) {
	      return function() {
	        return 'The following keys are invalid: ' + invalidKeys.join(', ');
	      };
	    }
	  };
	};
	
	v.arrayOf = function arrayOf(validator) {
	  return createArrayValidator(validator);
	};
	
	v.tuple = function tuple() {
	  var validators = Array.isArray(arguments[0])
	    ? arguments[0]
	    : Array.prototype.slice.call(arguments);
	  return createArrayValidator(validators);
	};
	
	// Currently array validation fails when the first invalid item is found.
	function createArrayValidator(validators) {
	  var validatingTuple = Array.isArray(validators);
	  var getValidator = function(index) {
	    if (validatingTuple) {
	      return validators[index];
	    }
	    return validators;
	  };
	
	  return function arrayValidator(value) {
	    var validationResult = validate(v.plainArray, value);
	    if (validationResult) {
	      return validationResult;
	    }
	
	    if (validatingTuple && value.length !== validators.length) {
	      return 'an array with ' + validators.length + ' items';
	    }
	
	    for (var i = 0; i < value.length; i++) {
	      validationResult = validate(getValidator(i), value[i]);
	      if (validationResult) {
	        return [i].concat(validationResult);
	      }
	    }
	  };
	}
	
	v.required = function required(validator) {
	  function requiredValidator(value) {
	    if (value == null) {
	      return function(options) {
	        return formatErrorMessage(
	          options,
	          isArrayCulprit(options.path)
	            ? 'cannot be undefined/null.'
	            : 'is required.'
	        );
	      };
	    }
	    return validator.apply(this, arguments);
	  }
	  requiredValidator.__required = true;
	
	  return requiredValidator;
	};
	
	v.oneOfType = function oneOfType() {
	  var validators = Array.isArray(arguments[0])
	    ? arguments[0]
	    : Array.prototype.slice.call(arguments);
	  return function oneOfTypeValidator(value) {
	    var messages = validators
	      .map(function(validator) {
	        return validate(validator, value);
	      })
	      .filter(Boolean);
	
	    // If we don't have as many messages as no. of validators,
	    // then at least one validator was ok with the value.
	    if (messages.length !== validators.length) {
	      return;
	    }
	
	    // check primitive type
	    if (
	      messages.every(function(message) {
	        return message.length === 1 && typeof message[0] === 'string';
	      })
	    ) {
	      return orList(
	        messages.map(function(m) {
	          return m[0];
	        })
	      );
	    }
	
	    // Complex oneOfTypes like
	    // `v.oneOftypes(v.shape({name: v.string})`, `v.shape({name: v.number}))`
	    // are complex ¯\_(ツ)_/¯. For the current scope only returning the longest message.
	    return messages.reduce(function(max, arr) {
	      return arr.length > max.length ? arr : max;
	    });
	  };
	};
	
	/**
	 * Meta Validators
	 * which take options as argument (not validators)
	 * and return a new primitive validator
	 */
	v.equal = function equal(compareWith) {
	  return function equalValidator(value) {
	    if (value !== compareWith) {
	      return JSON.stringify(compareWith);
	    }
	  };
	};
	
	v.oneOf = function oneOf() {
	  var options = Array.isArray(arguments[0])
	    ? arguments[0]
	    : Array.prototype.slice.call(arguments);
	  var validators = options.map(function(value) {
	    return v.equal(value);
	  });
	
	  return v.oneOfType.apply(this, validators);
	};
	
	v.range = function range(compareWith) {
	  var min = compareWith[0];
	  var max = compareWith[1];
	  return function rangeValidator(value) {
	    var validationResult = validate(v.number, value);
	
	    if (validationResult || value < min || value > max) {
	      return 'number between ' + min + ' & ' + max + ' (inclusive)';
	    }
	  };
	};
	
	/**
	 * Primitive validators
	 *
	 * simple validators which return a string or undefined
	 */
	v.any = function any() {
	  return;
	};
	
	v.boolean = function boolean(value) {
	  if (typeof value !== 'boolean') {
	    return 'boolean';
	  }
	};
	
	v.number = function number(value) {
	  if (typeof value !== 'number') {
	    return 'number';
	  }
	};
	
	v.plainArray = function plainArray(value) {
	  if (!Array.isArray(value)) {
	    return 'array';
	  }
	};
	
	v.plainObject = function plainObject(value) {
	  if (!isPlainObject(value)) {
	    return 'object';
	  }
	};
	
	v.string = function string(value) {
	  if (typeof value !== 'string') {
	    return 'string';
	  }
	};
	
	v.func = function func(value) {
	  if (typeof value !== 'function') {
	    return 'function';
	  }
	};
	
	function validate(validator, value) {
	  // assertions are optional by default unless wrapped in v.require
	  if (value == null && !validator.hasOwnProperty('__required')) {
	    return;
	  }
	
	  var result = validator(value);
	
	  if (result) {
	    return Array.isArray(result) ? result : [result];
	  }
	}
	
	function processMessage(message, options) {
	  // message array follows the convention
	  // [...path, result]
	  // path is an array of object keys / array indices
	  // result is output of the validator
	  var len = message.length;
	
	  var result = message[len - 1];
	  var path = message.slice(0, len - 1);
	
	  if (path.length === 0) {
	    path = [DEFAULT_ERROR_PATH];
	  }
	  options = xtend(options, { path: path });
	
	  return typeof result === 'function'
	    ? result(options) // allows customization of result
	    : formatErrorMessage(options, prettifyResult(result));
	}
	
	function orList(list) {
	  if (list.length < 2) {
	    return list[0];
	  }
	  if (list.length === 2) {
	    return list.join(' or ');
	  }
	  return list.slice(0, -1).join(', ') + ', or ' + list.slice(-1);
	}
	
	function prettifyResult(result) {
	  return 'must be ' + addArticle(result) + '.';
	}
	
	function addArticle(nounPhrase) {
	  if (/^an? /.test(nounPhrase)) {
	    return nounPhrase;
	  }
	  if (/^[aeiou]/i.test(nounPhrase)) {
	    return 'an ' + nounPhrase;
	  }
	  if (/^[a-z]/i.test(nounPhrase)) {
	    return 'a ' + nounPhrase;
	  }
	  return nounPhrase;
	}
	
	function formatErrorMessage(options, prettyResult) {
	  var arrayCulprit = isArrayCulprit(options.path);
	  var output = options.path.join('.') + ' ' + prettyResult;
	  var prepend = arrayCulprit ? 'Item at position ' : '';
	
	  return prepend + output;
	}
	
	function isArrayCulprit(path) {
	  return typeof path[path.length - 1] == 'number' || typeof path[0] == 'number';
	}
	
	function objectEntries(obj) {
	  return Object.keys(obj || {}).map(function(key) {
	    return { key: key, value: obj[key] };
	  });
	}
	
	v.validate = validate;
	v.processMessage = processMessage;
	
	module.exports = v;


/***/ },
/* 200 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var nanoid = __webpack_require__(540)
	
	/**
	 * Construct a new mapbox event client to send interaction events to the mapbox event service
	 * @param {Object} options options with which to create the service
	 * @param {String} options.accessToken the mapbox access token to make requests
	 * @param {Number} [options.flushInterval=1000] the number of ms after which to flush the event queue
	 * @param {Number} [options.maxQueueSize=100] the number of events to queue before flushing
	 * @private
	 */
	function MapboxEventManager(options) {
	  this.origin = options.origin || 'https://api.mapbox.com';
	  this.endpoint = 'events/v2';
	  this.access_token = options.accessToken;
	  this.version = '0.2.0'
	  this.sessionID = this.generateSessionID();
	  this.userAgent = this.getUserAgent();
	
	  this.options = options;
	  this.send = this.send.bind(this);
	
	
	  // parse global options to be sent with each request
	  this.countries = (options.countries) ? options.countries.split(",") : null;
	  this.types = (options.types) ? options.types.split(",") : null;
	  this.bbox = (options.bbox) ? options.bbox : null;
	  this.language = (options.language) ? options.language.split(",") : null;
	  this.limit = (options.limit) ? +options.limit : null;
	  this.locale = navigator.language || null;
	  this.enableEventLogging = this.shouldEnableLogging(options);
	  this.eventQueue = new Array();
	  this.flushInterval = options.flushInterval || 1000;
	  this.maxQueueSize = options.maxQueueSize || 100;
	  this.timer = (this.flushInterval) ? setTimeout(this.flush.bind(this), this.flushInterval) : null;
	  // keep some state to deduplicate requests if necessary
	  this.lastSentInput = "";
	  this.lastSentIndex = 0;
	}
	
	MapboxEventManager.prototype = {
	  /**
	     * Send a search.select event to the mapbox events service
	     * This event marks the array index of the item selected by the user out of the array of possible options
	     * @private
	     * @param {Object} selected the geojson feature selected by the user
	     * @param {Object} geocoder a mapbox-gl-geocoder instance
	     * @returns {Promise}
	     */
	  select: function(selected, geocoder){
	    var resultIndex = this.getSelectedIndex(selected, geocoder);
	    var payload = this.getEventPayload('search.select', geocoder);
	    payload.resultIndex = resultIndex;
	    payload.resultPlaceName  = selected.place_name;
	    payload.resultId = selected.id;
	    if ((resultIndex === this.lastSentIndex && payload.queryString === this.lastSentInput) || resultIndex == -1) {
	      // don't log duplicate events if the user re-selected the same feature on the same search
	      return;
	    }
	    this.lastSentIndex = resultIndex;
	    this.lastSentInput = payload.queryString;
	    if (!payload.queryString) return; // will be rejected
	    return this.push(payload)
	  },
	
	  /**
	     * Send a search-start event to the mapbox events service
	     * This turnstile event marks when a user starts a new search
	     * @private
	     * @param {Object} geocoder a mapbox-gl-geocoder instance
	     * @returns {Promise}
	     */
	  start: function(geocoder){
	    var payload = this.getEventPayload('search.start', geocoder);
	    if (!payload.queryString) return; // will be rejected
	    return this.push(payload);
	  },
	
	  /**
	   * Send a search-keyevent event to the mapbox events service
	   * This event records each keypress in sequence
	   * @private
	   * @param {Object} keyEvent the keydown event to log
	   * @param {Obeject} geocoder a mapbox-gl-geocoder instance
	   * 
	   */
	  keyevent: function(keyEvent, geocoder){
	
	    //pass invalid event
	    if (!keyEvent.key) return;
	    // don't send events for keys that don't change the input
	    // TAB, ESC, LEFT, RIGHT, ENTER, UP, DOWN
	    if (keyEvent.metaKey || [9, 27, 37, 39, 13, 38, 40].indexOf(keyEvent.keyCode) !== -1) return;
	    var payload = this.getEventPayload('search.keystroke', geocoder);
	    payload.lastAction = keyEvent.key;
	    if (!payload.queryString) return; // will be rejected
	    return this.push(payload);
	  },
	
	  /**
	   * Send an event to the events service
	   *
	   * The event is skipped if the instance is not enabled to send logging events
	   *
	   * @private
	   * @param {Object} payload the http POST body of the event
	   * @param {Function} [callback] a callback function to invoke when the send has completed
	   * @returns {Promise}
	   */
	  send: function (payload, callback) {
	    if (!this.enableEventLogging) {
	      if (callback) return callback();
	      return;
	    }
	    var options = this.getRequestOptions(payload);
	    this.request(options, function(err){
	      if (err) return this.handleError(err, callback);
	      if (callback) {
	        return callback();
	      }
	    }.bind(this))
	  },
	  /**
	   * Get http request options
	   * @private
	   * @param {*} payload
	   */
	  getRequestOptions: function(payload){
	    if (!Array.isArray(payload)) payload = [payload];
	    var options = {
	      // events must be sent with POST
	      method: "POST",
	      host: this.origin,
	      path: this.endpoint +  "?access_token=" + this.access_token,
	      headers: {
	        'Content-Type': 'application/json'
	      },
	      body:JSON.stringify(payload) //events are arrays
	    }
	    return options
	  },
	
	  /**
	   * Get the event payload to send to the events service
	   * Most payload properties are shared across all events
	   * @private
	   * @param {String} event the name of the event to send to the events service. Valid options are 'search.start', 'search.select', 'search.feedback'.
	   * @param {Object} geocoder a mapbox-gl-geocoder instance
	   * @returns {Object} an event payload
	   */
	  getEventPayload: function (event, geocoder) {
	    var proximity;
	    if (!geocoder.options.proximity) proximity = null;
	    else proximity = [geocoder.options.proximity.longitude, geocoder.options.proximity.latitude];
	
	    var zoom = (geocoder._map) ? geocoder._map.getZoom() : undefined;
	    var payload = {
	      event: event,
	      created: +new Date(),
	      sessionIdentifier: this.sessionID,
	      country: this.countries,
	      userAgent: this.userAgent,
	      language: this.language,
	      bbox: this.bbox,
	      types: this.types,
	      endpoint: 'mapbox.places',
	      // fuzzyMatch: search.fuzzy, //todo  --> add to plugin
	      proximity: proximity,
	      limit: geocoder.options.limit,
	      // routing: search.routing, //todo --> add to plugin
	      mapZoom: zoom,
	      keyboardLocale: this.locale
	    }
	
	    // get the text in the search bar
	    if (event === "search.select"){
	      payload.queryString = geocoder.inputString;
	    }else if (event != "search.select" && geocoder._inputEl){
	      payload.queryString = geocoder._inputEl.value;
	    }else{
	      payload.queryString = geocoder.inputString;
	    }
	    return payload;
	  },
	
	  /**
	   * Wraps the request function for easier testing
	   * Make an http request and invoke a callback
	   * @private
	   * @param {Object} opts options describing the http request to be made
	   * @param {Function} callback the callback to invoke when the http request is completed
	   */
	  request: function (opts, callback) {
	    var xhttp = new XMLHttpRequest();
	    xhttp.onreadystatechange = function() {
	      if (this.readyState == 4 ) {
	        if (this.status == 204){
	          //success
	          return callback(null);
	        }else {
	          return callback(this.statusText);
	        }
	      }
	    };
	
	    xhttp.open(opts.method, opts.host + '/' + opts.path, true);
	    for (var header in opts.headers){
	      var headerValue = opts.headers[header];
	      xhttp.setRequestHeader(header, headerValue)
	    }
	    xhttp.send(opts.body);
	  },
	
	  /**
	   * Handle an error that occurred while making a request
	   * @param {Object} err an error instance to log
	   * @private
	   */
	  handleError: function (err, callback) {
	    if (callback) return callback(err);
	  },
	
	  /**
	   * Generate a session ID to be returned with all of the searches made by this geocoder instance
	   * ID is random and cannot be tracked across sessions
	   * @private
	   */
	  generateSessionID: function () {
	    return nanoid();
	  },
	
	  /**
	   * Get a user agent string to send with the request to the events service
	   * @private
	   */
	  getUserAgent: function () {
	    return 'mapbox-gl-geocoder.' + this.version + "." + navigator.userAgent;
	  },
	
	  /**
	     * Get the 0-based numeric index of the item that the user selected out of the list of options
	     * @private
	     * @param {Object} selected the geojson feature selected by the user
	     * @param {Object} geocoder a Mapbox-GL-Geocoder instance
	     * @returns {Number} the index of the selected result
	     */
	  getSelectedIndex: function(selected, geocoder){
	    if (!geocoder._typeahead) return;
	    var results = geocoder._typeahead.data;
	    var selectedID = selected.id;
	    var resultIDs = results.map(function (feature) {
	      return feature.id;
	    });
	    var selectedIdx = resultIDs.indexOf(selectedID);
	    return selectedIdx;
	  },
	
	  /**
	     * Check whether events should be logged
	     * Clients using a localGeocoder or an origin other than mapbox should not have events logged
	     * @private
	     */
	  shouldEnableLogging: function(options){
	    if (options.enableEventLogging === false) return false;
	    if (options.origin && options.origin.indexOf('api.mapbox.com') == -1) return false;
	    // hard to make sense of events when a local instance is suplementing results from origin
	    if (options.localGeocoder) return false;
	    // hard to make sense of events when a custom filter is in use
	    if (options.filter) return false;
	    return true;
	  },
	
	  /**
	   * Flush out the event queue by sending events to the events service
	   * @private
	   */
	  flush: function(){
	    if (this.eventQueue.length > 0){
	      this.send(this.eventQueue);
	      this.eventQueue = new Array();
	    }
	    // //reset the timer
	    if (this.timer)  clearTimeout(this.timer);
	    if (this.flushInterval) this.timer = setTimeout(this.flush.bind(this), this.flushInterval)
	  },
	
	  /**
	   * Push event into the pending queue
	   * @param {Object} evt the event to send to the events service
	   * @param {Boolean} forceFlush indicates that the event queue should be flushed after adding this event regardless of size of the queue
	   * @private
	   */
	  push: function(evt, forceFlush){
	    this.eventQueue.push(evt);
	    if (this.eventQueue.length >= this.maxQueueSize || forceFlush){
	      this.flush();
	    }
	  },
	
	  /**
	   * Flush any remaining events from the queue before it is removed
	   * @private
	   */
	  remove: function(){
	    this.flush();
	  }
	}
	
	
	
	module.exports = MapboxEventManager;


/***/ },
/* 201 */
/***/ function(module, exports) {

	module.exports = {
	  'fr': {
	    'name': 'France',
	    'bbox': [[-4.59235, 41.380007], [9.560016, 51.148506]]
	  },
	  'us': {
	    'name': 'United States',
	    'bbox': [[-171.791111, 18.91619], [-66.96466, 71.357764]]
	  },
	  'ru': {
	    'name': 'Russia',
	    'bbox': [[19.66064, 41.151416], [190.10042, 81.2504]]
	  },
	  'ca': {
	    'name': 'Canada',
	    'bbox': [[-140.99778, 41.675105], [-52.648099, 83.23324]]
	  }
	};


/***/ },
/* 202 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Typeahead = __webpack_require__(604);
	var debounce = __webpack_require__(537);
	var extend = __webpack_require__(47);
	var EventEmitter = __webpack_require__(574).EventEmitter;
	var exceptions = __webpack_require__(201);
	var MapboxClient = __webpack_require__(204);
	var mbxGeocoder = __webpack_require__(212);
	var MapboxEventManager = __webpack_require__(200);
	var localization = __webpack_require__(203);
	var subtag = __webpack_require__(603);
	
	/**
	 * A geocoder component using the [Mapbox Geocoding API](https://docs.mapbox.com/api/search/#geocoding)
	 * @class MapboxGeocoder
	 * @param {Object} options
	 * @param {String} options.accessToken Required.
	 * @param {String} [options.origin=https://api.mapbox.com] Use to set a custom API origin.
	 * @param {Object} [options.mapboxgl] A [mapbox-gl](https://github.com/mapbox/mapbox-gl-js) instance to use when creating [Markers](https://docs.mapbox.com/mapbox-gl-js/api/#marker). Required if `options.marker` is `true`.
	 * @param {Number} [options.zoom=16] On geocoded result what zoom level should the map animate to when a `bbox` isn't found in the response. If a `bbox` is found the map will fit to the `bbox`.
	 * @param {Boolean|Object} [options.flyTo=true] If `false`, animating the map to a selected result is disabled. If `true`, animating the map will use the default animation parameters. If an object, it will be passed as `options` to the map [`flyTo`](https://docs.mapbox.com/mapbox-gl-js/api/#map#flyto) or [`fitBounds`](https://docs.mapbox.com/mapbox-gl-js/api/#map#fitbounds) method providing control over the animation of the transition.
	 * @param {String} [options.placeholder=Search] Override the default placeholder attribute value.
	 * @param {Object} [options.proximity] a proximity argument: this is
	 * a geographical point given as an object with `latitude` and `longitude`
	 * properties. Search results closer to this point will be given
	 * higher priority.
	 * @param {Boolean} [options.trackProximity=true] If `true`, the geocoder proximity will automatically update based on the map view.
	 * @param {Boolean} [options.collapsed=false] If `true`, the geocoder control will collapse until hovered or in focus.
	 * @param {Boolean} [options.clearAndBlurOnEsc=false] If `true`, the geocoder control will clear it's contents and blur when user presses the escape key.
	 * @param {Boolean} [options.clearOnBlur=false] If `true`, the geocoder control will clear its value when the input blurs.
	 * @param {Array} [options.bbox] a bounding box argument: this is
	 * a bounding box given as an array in the format `[minX, minY, maxX, maxY]`.
	 * Search results will be limited to the bounding box.
	 * @param {string} [options.countries] a comma separated list of country codes to
	 * limit results to specified country or countries.
	 * @param {string} [options.types] a comma seperated list of types that filter
	 * results to match those specified. See https://docs.mapbox.com/api/search/#data-types
	 * for available types.
	 * If reverseGeocode is enabled, you should specify one type. If you configure more than one type, the first type will be used.
	 * @param {Number} [options.minLength=2] Minimum number of characters to enter before results are shown.
	 * @param {Number} [options.limit=5] Maximum number of results to show.
	 * @param {string} [options.language] Specify the language to use for response text and query result weighting. Options are IETF language tags comprised of a mandatory ISO 639-1 language code and optionally one or more IETF subtags for country or script. More than one value can also be specified, separated by commas. Defaults to the browser's language settings.
	 * @param {Function} [options.filter] A function which accepts a Feature in the [Carmen GeoJSON](https://github.com/mapbox/carmen/blob/master/carmen-geojson.md) format to filter out results from the Geocoding API response before they are included in the suggestions list. Return `true` to keep the item, `false` otherwise.
	 * @param {Function} [options.localGeocoder] A function accepting the query string which performs local geocoding to supplement results from the Mapbox Geocoding API. Expected to return an Array of GeoJSON Features in the [Carmen GeoJSON](https://github.com/mapbox/carmen/blob/master/carmen-geojson.md) format.
	 * @param {distance|score} [options.reverseMode=distance] - Set the factors that are used to sort nearby results.
	 * @param {boolean} [options.reverseGeocode=false] If `true`, enable reverse geocoding mode. In reverse geocoding, search input is expected to be coordinates in the form `lat, lon`, with suggestions being the reverse geocodes.
	 * @param {Boolean} [options.enableEventLogging=true] Allow Mapbox to collect anonymous usage statistics from the plugin.
	 * @param {Boolean|Object} [options.marker=true]  If `true`, a [Marker](https://docs.mapbox.com/mapbox-gl-js/api/#marker) will be added to the map at the location of the user-selected result using a default set of Marker options.  If the value is an object, the marker will be constructed using these options. If `false`, no marker will be added to the map. Requires that `options.mapboxgl` also be set.
	 * @param {Function} [options.render] A function that specifies how the results should be rendered in the dropdown menu. This function should accepts a single [Carmen GeoJSON](https://github.com/mapbox/carmen/blob/master/carmen-geojson.md) object as input and return a string. Any HTML in the returned string will be rendered.
	 * @param {Function} [options.getItemValue] A function that specifies how the selected result should be rendered in the search bar. This function should accept a single [Carmen GeoJSON](https://github.com/mapbox/carmen/blob/master/carmen-geojson.md) object as input and return a string. HTML tags in the output string will not be rendered. Defaults to `(item) => item.place_name`.
	 * @param {String} [options.mode=mapbox.places] A string specifying the geocoding [endpoint](https://docs.mapbox.com/api/search/#endpoints) to query. Options are `mapbox.places` and `mapbox.places-permanent`. The `mapbox.places-permanent` mode requires an enterprise license for permanent geocodes.
	 * @param {Boolean} [options.localGeocoderOnly=false] If `true`, indicates that the `localGeocoder` results should be the only ones returned to the user. If `false`, indicates that the `localGeocoder` results should be combined with those from the Mapbox API with the `localGeocoder` results ranked higher.
	 * @example
	 * var geocoder = new MapboxGeocoder({ accessToken: mapboxgl.accessToken });
	 * map.addControl(geocoder);
	 * @return {MapboxGeocoder} `this`
	 *
	 */
	
	function MapboxGeocoder(options) {
	  this._eventEmitter = new EventEmitter();
	  this.options = extend({}, this.options, options);
	  this.inputString = '';
	  this.fresh = true;
	  this.lastSelected = null;
	}
	
	MapboxGeocoder.prototype = {
	  options: {
	    zoom: 16,
	    flyTo: true,
	    trackProximity: true,
	    minLength: 2,
	    reverseGeocode: false,
	    limit: 5,
	    origin: 'https://api.mapbox.com',
	    enableEventLogging: true,
	    marker: true,
	    mapboxgl: null,
	    collapsed: false,
	    clearAndBlurOnEsc: false,
	    clearOnBlur: false,
	    getItemValue: function(item) {
	      return item.place_name
	    },
	    render: function(item) {
	      var placeName = item.place_name.split(',');
	      return '<div class="mapboxgl-ctrl-geocoder--suggestion"><div class="mapboxgl-ctrl-geocoder--suggestion-title">' + placeName[0]+ '</div><div class="mapboxgl-ctrl-geocoder--suggestion-address">' + placeName.splice(1, placeName.length).join(',') + '</div></div>';
	    }
	  },
	
	  /**
	   * Add the geocoder to a container. The container can be either a `mapboxgl.Map` or a reference to an HTML `class` or `id`.
	   *
	   * If the container is a `mapboxgl.Map`, this function will behave identically to `Map.addControl(geocoder)`.
	   * If the container is an HTML `id` or `class`, the geocoder will be appended to that element.
	   *
	   * This function will throw an error if the container is not either a map or a `class`/`id` reference.
	   * It will also throw an error if the referenced HTML element cannot be found in the `document.body`.
	   *
	   * For example, if the HTML body contains the element `<div id='geocoder-container'></div>`, the following script will append the geocoder to `#geocoder-container`:
	   *
	   * ```javascript
	   * var geocoder = new MapboxGeocoder({ accessToken: mapboxgl.accessToken });
	   * geocoder.addTo('#geocoder-container');
	   * ```
	   * @param {String|mapboxgl.Map} container A reference to the container to which to add the geocoder
	   */
	  addTo: function(container){
	    // if the container is a map, add the control like normal
	    if (container._controlContainer){
	      //  it's a mapbox-gl map, add like normal
	      container.addControl(this)
	    }
	    // if the container is not a map, but an html element, then add the control to that element
	    else if (typeof container == 'string' && (container.startsWith('#') || container.startsWith('.'))){
	      const parent = document.querySelectorAll(container);
	      if (parent.length == 0){
	        throw new Error("Element ", container, "not found.")
	      }
	
	      if (parent.length > 1){
	        throw new Error("Geocoder can only be added to a single html element")
	      }
	
	      parent.forEach(function(parentEl){
	        const el = this.onAdd(); //returns the input elements, which are then added to the requested html container
	        parentEl.appendChild(el);
	      }.bind(this))
	
	    }else{
	      throw new Error("Error: addTo Container must be a mapbox-gl-js map or a html element reference")
	    }
	  },
	
	  onAdd: function(map) {
	    if (map && typeof map != 'string'){
	      this._map = map;
	    }
	
	    this.setLanguage();
	
	    if (!this.options.localGeocoderOnly){
	      this.geocoderService = mbxGeocoder(
	        MapboxClient({
	          accessToken: this.options.accessToken,
	          origin: this.options.origin
	        })
	      );
	    }
	
	    if (this.options.localGeocoderOnly && !this.options.localGeocoder){
	      throw new Error("A localGeocoder function must be specified to use localGeocoderOnly mode")
	    }
	
	    this.eventManager = new MapboxEventManager(this.options);
	
	    this._onChange = this._onChange.bind(this);
	    this._onKeyDown = this._onKeyDown.bind(this);
	    this._onPaste = this._onPaste.bind(this);
	    this._onBlur = this._onBlur.bind(this);
	    this._showButton = this._showButton.bind(this);
	    this._hideButton = this._hideButton.bind(this);
	    this._onQueryResult = this._onQueryResult.bind(this);
	    this.clear = this.clear.bind(this);
	    this._updateProximity = this._updateProximity.bind(this);
	    this._collapse = this._collapse.bind(this);
	    this._unCollapse = this._unCollapse.bind(this);
	    this._clear = this._clear.bind(this);
	    this._clearOnBlur = this._clearOnBlur.bind(this);
	
	    var el = (this.container = document.createElement('div'));
	    el.className = 'mapboxgl-ctrl-geocoder mapboxgl-ctrl';
	
	    var searchIcon = this.createIcon('search', '<path d="M7.4 2.5c-2.7 0-4.9 2.2-4.9 4.9s2.2 4.9 4.9 4.9c1 0 1.8-.2 2.5-.8l3.7 3.7c.2.2.4.3.8.3.7 0 1.1-.4 1.1-1.1 0-.3-.1-.5-.3-.8L11.4 10c.4-.8.8-1.6.8-2.5.1-2.8-2.1-5-4.8-5zm0 1.6c1.8 0 3.2 1.4 3.2 3.2s-1.4 3.2-3.2 3.2-3.3-1.3-3.3-3.1 1.4-3.3 3.3-3.3z"/>')
	
	    this._inputEl = document.createElement('input');
	    this._inputEl.type = 'text';
	    this._inputEl.className = 'mapboxgl-ctrl-geocoder--input';
	
	    this.setPlaceholder();
	
	    if (this.options.collapsed) {
	      this._collapse();
	      this.container.addEventListener('mouseenter', this._unCollapse);
	      this.container.addEventListener('mouseleave', this._collapse);
	      this._inputEl.addEventListener('focus', this._unCollapse);
	    }
	
	    if (this.options.collapsed || this.options.clearOnBlur) {
	      this._inputEl.addEventListener('blur', this._onBlur);
	    }
	
	    this._inputEl.addEventListener('keydown', debounce(this._onKeyDown, 200));
	    this._inputEl.addEventListener('paste', this._onPaste);
	    this._inputEl.addEventListener('change', this._onChange);
	    this.container.addEventListener('mouseenter', this._showButton);
	    this.container.addEventListener('mouseleave', this._hideButton);
	    this._inputEl.addEventListener('keyup', function(e){
	      this.eventManager.keyevent(e, this);
	    }.bind(this));
	
	    var actions = document.createElement('div');
	    actions.classList.add('mapboxgl-ctrl-geocoder--pin-right');
	
	    this._clearEl = document.createElement('button');
	    this._clearEl.setAttribute('aria-label', 'Clear');
	    this._clearEl.addEventListener('click', this.clear);
	    this._clearEl.className = 'mapboxgl-ctrl-geocoder--button';
	
	    var buttonIcon = this.createIcon('close', '<path d="M3.8 2.5c-.6 0-1.3.7-1.3 1.3 0 .3.2.7.5.8L7.2 9 3 13.2c-.3.3-.5.7-.5 1 0 .6.7 1.3 1.3 1.3.3 0 .7-.2 1-.5L9 10.8l4.2 4.2c.2.3.7.3 1 .3.6 0 1.3-.7 1.3-1.3 0-.3-.2-.7-.3-1l-4.4-4L15 4.6c.3-.2.5-.5.5-.8 0-.7-.7-1.3-1.3-1.3-.3 0-.7.2-1 .3L9 7.1 4.8 2.8c-.3-.1-.7-.3-1-.3z"/>')
	    this._clearEl.appendChild(buttonIcon);
	
	    this._loadingEl = this.createIcon('loading', '<path fill="#333" d="M4.4 4.4l.8.8c2.1-2.1 5.5-2.1 7.6 0l.8-.8c-2.5-2.5-6.7-2.5-9.2 0z"/><path opacity=".1" d="M12.8 12.9c-2.1 2.1-5.5 2.1-7.6 0-2.1-2.1-2.1-5.5 0-7.7l-.8-.8c-2.5 2.5-2.5 6.7 0 9.2s6.6 2.5 9.2 0 2.5-6.6 0-9.2l-.8.8c2.2 2.1 2.2 5.6 0 7.7z"/>');
	
	    actions.appendChild(this._clearEl);
	    actions.appendChild(this._loadingEl);
	
	    el.appendChild(searchIcon);
	    el.appendChild(this._inputEl);
	    el.appendChild(actions);
	
	    this._typeahead = new Typeahead(this._inputEl, [], {
	      filter: false,
	      minLength: this.options.minLength,
	      limit: this.options.limit
	    });
	
	    this.setRenderFunction(this.options.render);
	    this._typeahead.getItemValue = this.options.getItemValue;
	
	    this.mapMarker = null;
	    this._handleMarker = this._handleMarker.bind(this);
	    if (this._map){
	      if (this.options.trackProximity ) {
	        this._updateProximity();
	        this._map.on('moveend', this._updateProximity);
	      }
	      this._mapboxgl = this.options.mapboxgl;
	      if (!this._mapboxgl && this.options.marker) {
	        // eslint-disable-next-line no-console
	        console.error("No mapboxgl detected in options. Map markers are disabled. Please set options.mapboxgl.");
	        this.options.marker = false;
	      }
	    }
	    return el;
	  },
	
	  createIcon: function(name, path) {
	    var icon = document.createElementNS('http://www.w3.org/2000/svg', 'svg');
	    icon.setAttribute('class', 'mapboxgl-ctrl-geocoder--icon mapboxgl-ctrl-geocoder--icon-' + name);
	    icon.setAttribute('viewBox', '0 0 18 18');
	    icon.setAttribute('xml:space','preserve');
	    icon.setAttribute('width', 18);
	    icon.setAttribute('height', 18);
	    icon.innerHTML = path;
	    return icon;
	  },
	
	  onRemove: function() {
	    this.container.parentNode.removeChild(this.container);
	
	    if (this.options.trackProximity && this._map) {
	      this._map.off('moveend', this._updateProximity);
	    }
	
	    this._removeMarker();
	
	    this._map = null;
	
	    return this;
	  },
	
	  _onPaste: function(e){
	    var value = (e.clipboardData || window.clipboardData).getData('text');
	    if (value.length >= this.options.minLength) {
	      this._geocode(value);
	    }
	  },
	
	  _onKeyDown: function(e) {
	    var ESC_KEY_CODE = 27,
	      TAB_KEY_CODE = 9;
	
	    if (e.keyCode === ESC_KEY_CODE && this.options.clearAndBlurOnEsc) {
	      this._clear(e);
	      return this._inputEl.blur();
	    }
	
	    // if target has shadowRoot, then get the actual active element inside the shadowRoot
	    var target = e.target && e.target.shadowRoot
	      ? e.target.shadowRoot.activeElement
	      : e.target;
	    var value = target ? target.value : '';
	
	    if (!value) {
	      this.fresh = true;
	      // the user has removed all the text
	      if (e.keyCode !== TAB_KEY_CODE) this.clear(e);
	      return (this._clearEl.style.display = 'none');
	    }
	
	    // TAB, ESC, LEFT, RIGHT, ENTER, UP, DOWN
	    if ((e.metaKey || [TAB_KEY_CODE, ESC_KEY_CODE, 37, 39, 13, 38, 40].indexOf(e.keyCode) !== -1))
	      return;
	
	    if (target.value.length >= this.options.minLength) {
	      this._geocode(target.value);
	    }
	  },
	
	  _showButton: function() {
	    if (this._typeahead.selected) this._clearEl.style.display = 'block';
	  },
	
	  _hideButton: function() {
	    if (this._typeahead.selected) this._clearEl.style.display = 'none';
	  },
	
	  _onBlur: function(e) {
	    if (this.options.clearOnBlur) {
	      this._clearOnBlur(e);
	    }
	    if (this.options.collapsed) {
	      this._collapse();
	    }
	  },
	  _onChange: function() {
	    var selected = this._typeahead.selected;
	    if (selected  && JSON.stringify(selected) !== this.lastSelected) {
	      this._clearEl.style.display = 'none';
	      if (this.options.flyTo) {
	        var flyOptions;
	        if (selected.properties && !exceptions[selected.properties.short_code] && selected.bbox) {
	          var bbox = selected.bbox;
	          flyOptions = extend({}, this.options.flyTo);
	          if (this._map){
	            this._map.fitBounds([[bbox[0], bbox[1]], [bbox[2], bbox[3]]], flyOptions);
	          }
	        } else if (selected.properties && exceptions[selected.properties.short_code]) {
	          // Certain geocoder search results return (and therefore zoom to fit)
	          // an unexpectedly large bounding box: for example, both Russia and the
	          // USA span both sides of -180/180, or France includes the island of
	          // Reunion in the Indian Ocean. An incomplete list of these exceptions
	          // at ./exceptions.json provides "reasonable" bounding boxes as a
	          // short-term solution; this may be amended as necessary.
	          flyOptions = extend({}, this.options.flyTo);
	          if (this._map){
	            this._map.fitBounds(exceptions[selected.properties.short_code].bbox, flyOptions);
	          }
	        } else {
	          var defaultFlyOptions = {
	            zoom: this.options.zoom
	          }
	          flyOptions = extend({}, defaultFlyOptions, this.options.flyTo);
	          //  ensure that center is not overriden by custom options
	          flyOptions.center = selected.center;
	          if (this._map){
	            this._map.flyTo(flyOptions);
	          }
	        }
	      }
	      if (this.options.marker && this._mapboxgl){
	        this._handleMarker(selected);
	      }
	
	      // After selecting a feature, re-focus the textarea and set
	      // cursor at start.
	      this._inputEl.focus();
	      this._inputEl.scrollLeft = 0;
	      this._inputEl.setSelectionRange(0, 0);
	      this.lastSelected = JSON.stringify(selected);
	      this._eventEmitter.emit('result', { result: selected });
	      this.eventManager.select(selected, this);
	    }
	  },
	
	  _geocode: function(searchInput) {
	    this._loadingEl.style.display = 'block';
	    this._eventEmitter.emit('loading', { query: searchInput });
	    this.inputString = searchInput;
	    // Possible config proprerties to pass to client
	    var keys = [
	      'bbox',
	      'limit',
	      'proximity',
	      'countries',
	      'types',
	      'language',
	      'reverseMode',
	      'mode'
	    ];
	    var self = this;
	    // Create config object
	    var config = keys.reduce(function(config, key) {
	      if (self.options[key]) {
	        // countries, types, and language need to be passed in as arrays to client
	        // https://github.com/mapbox/mapbox-sdk-js/blob/master/services/geocoding.js#L38-L47
	        ['countries', 'types', 'language'].indexOf(key) > -1
	          ? (config[key] = self.options[key].split(/[\s,]+/))
	          : (config[key] = self.options[key]);
	
	        if (key === 'proximity' && self.options[key] && self.options[key].longitude && self.options[key].latitude) {
	          config[key] = [self.options[key].longitude, self.options[key].latitude]
	        }
	      }
	      return config;
	    }, {});
	
	    var request;
	    if (this.options.localGeocoderOnly){
	      request = Promise.resolve();
	    }
	    // check if searchInput resembles coordinates, and if it does,
	    // make the request a reverseGeocode
	    else if (
	      this.options.reverseGeocode &&
	      /(-?\d+\.?\d*)[, ]+(-?\d+\.?\d*)[ ]*$/.test(searchInput)
	    ) {
	      // parse coordinates
	      var coords = searchInput.split(/[\s(,)?]+/).map(function(c) {
	        return parseFloat(c, 10);
	      }).reverse();
	
	      // client only accepts one type for reverseGeocode, so
	      // use first config type if one, if not default to poi
	      config.types ? [config.types[0]] : ["poi"];
	      config = extend(config, { query: coords, limit: 1 });
	      request = this.geocoderService.reverseGeocode(config).send();
	    } else {
	      config = extend(config, { query: searchInput });
	      request = this.geocoderService.forwardGeocode(config).send();
	    }
	
	    var localGeocoderRes = [];
	    if (this.options.localGeocoder) {
	      localGeocoderRes = this.options.localGeocoder(searchInput);
	      if (!localGeocoderRes) {
	        localGeocoderRes = [];
	      }
	    }
	
	    request.then(
	      function(response) {
	        this._loadingEl.style.display = 'none';
	
	        var res = {};
	
	        if (!response){
	          res = {
	            type: 'FeatureCollection',
	            features: []
	          }
	        }else if (response.statusCode == '200') {
	          res = response.body;
	          res.request = response.request
	          res.headers = response.headers
	        }
	
	        res.config = config;
	        if (this.fresh){
	          this.eventManager.start(this);
	          this.fresh = false;
	        }
	        // supplement Mapbox Geocoding API results with locally populated results
	        res.features = res.features
	          ? localGeocoderRes.concat(res.features)
	          : localGeocoderRes;
	
	        // apply results filter if provided
	        if (this.options.filter && res.features.length) {
	          res.features = res.features.filter(this.options.filter);
	        }
	
	        if (res.features.length) {
	          this._clearEl.style.display = 'block';
	          this._eventEmitter.emit('results', res);
	          this._typeahead.update(res.features);
	        } else {
	          this._clearEl.style.display = 'none';
	          this._typeahead.selected = null;
	          this._renderNoResults();
	          this._eventEmitter.emit('results', res);
	        }
	
	      }.bind(this)
	    );
	
	    request.catch(
	      function(err) {
	        this._loadingEl.style.display = 'none';
	
	        // in the event of an error in the Mapbox Geocoding API still display results from the localGeocoder
	        if (localGeocoderRes.length && this.options.localGeocoder) {
	          this._clearEl.style.display = 'block';
	          this._typeahead.update(localGeocoderRes);
	        } else {
	          this._clearEl.style.display = 'none';
	          this._typeahead.selected = null;
	          this._renderError();
	        }
	
	        this._eventEmitter.emit('results', { features: localGeocoderRes });
	        this._eventEmitter.emit('error', { error: err });
	      }.bind(this)
	    );
	
	    return request;
	  },
	
	  /**
	   * Shared logic for clearing input
	   * @param {Event} [ev] the event that triggered the clear, if available
	   * @private
	   *
	   */
	  _clear: function(ev) {
	    if (ev) ev.preventDefault();
	    this._inputEl.value = '';
	    this._typeahead.selected = null;
	    this._typeahead.clear();
	    this._onChange();
	    this._clearEl.style.display = 'none';
	    this._removeMarker();
	    this.lastSelected = null;
	    this._eventEmitter.emit('clear');
	    this.fresh = true;
	  },
	
	  /**
	   * Clear and then focus the input.
	   * @param {Event} [ev] the event that triggered the clear, if available
	   *
	   */
	  clear: function(ev) {
	    this._clear(ev);
	    this._inputEl.focus();
	  },
	
	
	  /**
	   * Clear the input, without refocusing it. Used to implement clearOnBlur
	   * constructor option.
	   * @param {Event} [ev] the blur event
	   * @private
	   */
	  _clearOnBlur: function(ev) {
	    var ctx = this;
	
	    /*
	     * If relatedTarget is not found, assume user targeted the suggestions list.
	     * In that case, do not clear on blur. There are other edge cases where
	     * ev.relatedTarget could be null. Clicking on list always results in null
	     * relatedtarget because of upstream behavior in `suggestions`.
	     *
	     * The ideal solution would be to check if ev.relatedTarget is a child of
	     * the list. See issue #258 for details on why we can't do that yet.
	     */
	    if (ev.relatedTarget) {
	      ctx._clear(ev);
	    }
	  },
	
	  _onQueryResult: function(response) {
	    var results = response.body;
	    if (!results.features.length) return;
	    var result = results.features[0];
	    this._typeahead.selected = result;
	    this._inputEl.value = result.place_name;
	    this._onChange();
	  },
	
	  _updateProximity: function() {
	    // proximity is designed for local scale, if the user is looking at the whole world,
	    // it doesn't make sense to factor in the arbitrary centre of the map
	    if (!this._map){
	      return;
	    }
	    if (this._map.getZoom() > 9) {
	      var center = this._map.getCenter().wrap();
	      this.setProximity({ longitude: center.lng, latitude: center.lat });
	    } else {
	      this.setProximity(null);
	    }
	  },
	
	  _collapse: function() {
	    // do not collapse if input is in focus
	    if (!this._inputEl.value && this._inputEl !== document.activeElement) this.container.classList.add('mapboxgl-ctrl-geocoder--collapsed');
	  },
	
	  _unCollapse: function() {
	    this.container.classList.remove('mapboxgl-ctrl-geocoder--collapsed');
	  },
	
	  /**
	   * Set & query the input
	   * @param {string} searchInput location name or other search input
	   * @returns {MapboxGeocoder} this
	   */
	  query: function(searchInput) {
	    this._geocode(searchInput).then(this._onQueryResult);
	    return this;
	  },
	
	  _renderError: function(){
	    var errorMessage = "<div class='mapbox-gl-geocoder--error'>There was an error reaching the server</div>"
	    this._renderMessage(errorMessage);
	  },
	
	  _renderNoResults: function(){
	    var errorMessage = "<div class='mapbox-gl-geocoder--error mapbox-gl-geocoder--no-results'>No results found</div>";
	    this._renderMessage(errorMessage);
	  },
	
	  _renderMessage: function(msg){
	    this._typeahead.update([]);
	    this._typeahead.selected = null;
	    this._typeahead.clear();
	    this._typeahead.renderError(msg);
	  },
	
	  /**
	   * Get the text to use as the search bar placeholder
	   *
	   * If placeholder is provided in options, then use options.placeholder
	   * Otherwise, if language is provided in options, then use the localized string of the first language if available
	   * Otherwise use the default
	   *
	   * @returns {String} the value to use as the search bar placeholder
	   * @private
	   */
	  _getPlaceholderText: function(){
	    if (this.options.placeholder) return this.options.placeholder;
	    if (this.options.language){
	      var firstLanguage = this.options.language.split(",")[0];
	      var language = subtag.language(firstLanguage);
	      var localizedValue = localization.placeholder[language];
	      if (localizedValue)  return localizedValue;
	    }
	    return 'Search';
	  },
	
	  /**
	   * Set input
	   * @param {string} searchInput location name or other search input
	   * @returns {MapboxGeocoder} this
	   */
	  setInput: function(searchInput) {
	    // Set input value to passed value and clear everything else.
	    this._inputEl.value = searchInput;
	    this._typeahead.selected = null;
	    this._typeahead.clear();
	    this._onChange();
	    return this;
	  },
	
	  /**
	   * Set proximity
	   * @param {Object} proximity The new `options.proximity` value. This is a geographical point given as an object with `latitude` and `longitude` properties.
	   * @returns {MapboxGeocoder} this
	   */
	  setProximity: function(proximity) {
	    this.options.proximity = proximity;
	    return this;
	  },
	
	  /**
	   * Get proximity
	   * @returns {Object} The geocoder proximity
	   */
	  getProximity: function() {
	    return this.options.proximity;
	  },
	
	  /**
	   * Set the render function used in the results dropdown
	   * @param {Function} fn The function to use as a render function. This function accepts a single [Carmen GeoJSON](https://github.com/mapbox/carmen/blob/master/carmen-geojson.md) object as input and returns a string.
	   * @returns {MapboxGeocoder} this
	   */
	  setRenderFunction: function(fn){
	    if (fn && typeof(fn) == "function"){
	      this._typeahead.render = fn;
	    }
	    return this;
	  },
	
	  /**
	   * Get the function used to render the results dropdown
	   *
	   * @returns {Function} the render function
	   */
	  getRenderFunction: function(){
	    return this._typeahead.render;
	  },
	
	  /**
	   * Get the language to use in UI elements and when making search requests
	   *
	   * Look first at the explicitly set options otherwise use the browser's language settings
	   * @param {String} language Specify the language to use for response text and query result weighting. Options are IETF language tags comprised of a mandatory ISO 639-1 language code and optionally one or more IETF subtags for country or script. More than one value can also be specified, separated by commas.
	   * @returns {MapboxGeocoder} this
	   */
	  setLanguage: function(language){
	    var browserLocale = navigator.language || navigator.userLanguage || navigator.browserLanguage;
	    this.options.language = language || this.options.language || browserLocale;
	    return this;
	  },
	
	  /**
	   * Get the language to use in UI elements and when making search requests
	   * @returns {String} The language(s) used by the plugin, if any
	   */
	  getLanguage: function(){
	    return this.options.language;
	  },
	
	  /**
	   * Get the zoom level the map will move to when there is no bounding box on the selected result
	   * @returns {Number} the map zoom
	   */
	  getZoom: function(){
	    return this.options.zoom;
	  },
	
	  /**
	   * Set the zoom level
	   * @param {Number} zoom The zoom level that the map should animate to when a `bbox` isn't found in the response. If a `bbox` is found the map will fit to the `bbox`.
	   * @returns {MapboxGeocoder} this
	   */
	  setZoom: function(zoom){
	    this.options.zoom = zoom;
	    return this;
	  },
	
	  /**
	   * Get the parameters used to fly to the selected response, if any
	   * @returns {Boolean|Object} The `flyTo` option
	   */
	  getFlyTo: function(){
	    return this.options.flyTo;
	  },
	
	  /**
	   * Set the flyTo options
	   * @param {Boolean|Object} flyTo If false, animating the map to a selected result is disabled. If true, animating the map will use the default animation parameters. If an object, it will be passed as `options` to the map [`flyTo`](https://docs.mapbox.com/mapbox-gl-js/api/#map#flyto) or [`fitBounds`](https://docs.mapbox.com/mapbox-gl-js/api/#map#fitbounds) method providing control over the animation of the transition.
	   */
	  setFlyTo: function(flyTo){
	    this.options.flyTo = flyTo;
	    return this;
	  },
	
	  /**
	   * Get the value of the placeholder string
	   * @returns {String} The input element's placeholder value
	   */
	  getPlaceholder: function(){
	    return this.options.placeholder;
	  },
	
	  /**
	   * Set the value of the input element's placeholder
	   * @param {String} placeholder the text to use as the input element's placeholder
	   * @returns {MapboxGeocoder} this
	   */
	  setPlaceholder: function(placeholder){
	    this.placeholder = (placeholder) ? placeholder : this._getPlaceholderText();
	    this._inputEl.placeholder = this.placeholder;
	    this._inputEl.setAttribute('aria-label', this.placeholder);
	    return this
	  },
	
	  /**
	   * Get the bounding box used by the plugin
	   * @returns {Array<Number>} the bounding box, if any
	   */
	  getBbox: function(){
	    return this.options.bbox;
	  },
	
	  /**
	   * Set the bounding box to limit search results to
	   * @param {Array<Number>} bbox a bounding box given as an array in the format [minX, minY, maxX, maxY].
	   * @returns {MapboxGeocoder} this
	   */
	  setBbox: function(bbox){
	    this.options.bbox = bbox;
	    return this;
	  },
	
	  /**
	   * Get a list of the countries to limit search results to
	   * @returns {String} a comma separated list of countries to limit to, if any
	   */
	  getCountries: function(){
	    return this.options.countries;
	  },
	
	  /**
	   * Set the countries to limit search results to
	   * @param {String} countries a comma separated list of countries to limit to
	   * @returns {MapboxGeocoder} this
	   */
	  setCountries: function(countries){
	    this.options.countries = countries;
	    return this;
	  },
	
	  /**
	   * Get a list of the types to limit search results to
	   * @returns {String} a comma separated list of types to limit to
	   */
	  getTypes: function(){
	    return this.options.types;
	  },
	
	  /**
	   * Set the types to limit search results to
	   * @param {String} countries a comma separated list of types to limit to
	   * @returns {MapboxGeocoder} this
	   */
	  setTypes: function(types){
	    this.options.types = types;
	    return this;
	  },
	
	  /**
	   * Get the minimum number of characters typed to trigger results used in the plugin
	   * @returns {Number} The minimum length in characters before a search is triggered
	   */
	  getMinLength: function(){
	    return this.options.minLength;
	  },
	
	  /**
	   * Set the minimum number of characters typed to trigger results used by the plugin
	   * @param {Number} minLength the minimum length in characters
	   * @returns {MapboxGeocoder} this
	   */
	  setMinLength: function(minLength){
	    this.options.minLength = minLength;
	    if (this._typeahead)  this._typeahead.minLength = minLength;
	    return this;
	  },
	
	  /**
	   * Get the limit value for the number of results to display used by the plugin
	   * @returns {Number} The limit value for the number of results to display used by the plugin
	   */
	  getLimit: function(){
	    return this.options.limit;
	  },
	
	  /**
	   * Set the limit value for the number of results to display used by the plugin
	   * @param {Number} limit the number of search results to return
	   * @returns {MapboxGeocoder}
	   */
	  setLimit: function(limit){
	    this.options.limit = limit;
	    if (this._typeahead) this._typeahead.options.limit = limit;
	    return this;
	  },
	
	  /**
	   * Get the filter function used by the plugin
	   * @returns {Function} the filter function
	   */
	  getFilter: function(){
	    return this.options.filter;
	  },
	
	  /**
	   * Set the filter function used by the plugin.
	   * @param {Function} filter A function which accepts a Feature in the [Carmen GeoJSON](https://github.com/mapbox/carmen/blob/master/carmen-geojson.md) format to filter out results from the Geocoding API response before they are included in the suggestions list. Return `true` to keep the item, `false` otherwise.
	   * @returns {MapboxGeocoder} this
	   */
	  setFilter: function(filter){
	    this.options.filter = filter;
	    return this;
	  },
	
	  /**
	   * Set the geocoding endpoint used by the plugin.
	   * @param {Function} origin A function which accepts an HTTPS URL to specify the endpoint to query results from.
	   * @returns {MapboxGeocoder} this
	   */
	  setOrigin: function(origin){
	    this.options.origin = origin;
	    this.geocoderService = mbxGeocoder(
	      MapboxClient({
	        accessToken: this.options.accessToken,
	        origin: this.options.origin
	      })
	    );
	    return this;
	  },
	
	  /**
	   * Get the geocoding endpoint the plugin is currently set to
	   * @returns {Function} the endpoint URL
	   */
	  getOrigin: function(){
	    return this.options.origin;
	  },
	
	  /**
	   * Handle the placement of a result marking the selected result
	   * @private
	   * @param {Object} selected the selected geojson feature
	   * @returns {MapboxGeocoder} this
	   */
	  _handleMarker: function(selected){
	    // clean up any old marker that might be present
	    if (!this._map){
	      return;
	    }
	    this._removeMarker();
	    var defaultMarkerOptions = {
	      color: '#4668F2'
	    }
	    var markerOptions = extend({}, defaultMarkerOptions, this.options.marker)
	    this.mapMarker = new this._mapboxgl.Marker(markerOptions);
	    if (selected.center) {
	      this.mapMarker
	        .setLngLat(selected.center)
	        .addTo(this._map);
	    } else if (selected.geometry && selected.geometry.type && selected.geometry.type === 'Point' && selected.geometry.coordinates) {
	      this.mapMarker
	        .setLngLat(selected.geometry.coordinates)
	        .addTo(this._map);
	    }
	    return this;
	  },
	
	  /**
	   * Handle the removal of a result marker
	   * @private
	   */
	  _removeMarker: function(){
	    if (this.mapMarker){
	      this.mapMarker.remove();
	      this.mapMarker = null;
	    }
	  },
	
	  /**
	   * Subscribe to events that happen within the plugin.
	   * @param {String} type name of event. Available events and the data passed into their respective event objects are:
	   *
	   * - __clear__ `Emitted when the input is cleared`
	   * - __loading__ `{ query } Emitted when the geocoder is looking up a query`
	   * - __results__ `{ results } Fired when the geocoder returns a response`
	   * - __result__ `{ result } Fired when input is set`
	   * - __error__ `{ error } Error as string`
	   * @param {Function} fn function that's called when the event is emitted.
	   * @returns {MapboxGeocoder} this;
	   */
	  on: function(type, fn) {
	    this._eventEmitter.on(type, fn);
	    return this;
	  },
	
	  /**
	   * Remove an event
	   * @returns {MapboxGeocoder} this
	   * @param {String} type Event name.
	   * @param {Function} fn Function that should unsubscribe to the event emitted.
	   */
	  off: function(type, fn) {
	    this._eventEmitter.removeListener(type, fn);
	    this.eventManager.remove();
	    return this;
	  }
	};
	
	module.exports = MapboxGeocoder;


/***/ },
/* 203 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Localized values for the placeholder string
	 * 
	 * @private
	 */
	var placeholder = {
	  // list drawn from https://docs.mapbox.com/api/search/#language-coverage
	  'de': 'Suche', // german
	  'it': 'Ricerca', //italian
	  'en': 'Search', // english
	  'nl': 'Zoeken', //dutch
	  'fr': 'Chercher',  //french
	  'ca': 'Cerca', //catalan
	  'he': 'לחפש', //hebrew
	  'ja': 'サーチ',  //japanese
	  'lv': 'Meklēt', //latvian
	  'pt': 'Procurar', //portuguese 
	  'sr': 'Претрага', //serbian
	  'zh': '搜索', //chinese-simplified
	  'cs': 'Vyhledávání', //czech
	  'hu': 'Keresés', //hungarian
	  'ka': 'ძიება', // georgian
	  'nb': 'Søke', //norwegian
	  'sk': 'Vyhľadávanie', //slovak
	  'th': 'ค้นหา', //thai
	  'fi': 'Hae',//finnish
	  'is': 'Leita',//icelandic
	  'ko': '수색',//korean
	  'pl':  'Szukaj', //polish
	  'sl': 'Iskanje', //slovenian
	  'fa': 'جستجو' //persian(aka farsi)
	}
	
	module.exports = {placeholder: placeholder};


/***/ },
/* 204 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var client = __webpack_require__(111);
	
	module.exports = client;


/***/ },
/* 205 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var MapiResponse = __webpack_require__(208);
	var MapiError = __webpack_require__(206);
	var constants = __webpack_require__(61);
	var parseHeaders = __webpack_require__(209);
	
	// Keys are request IDs, values are XHRs.
	var requestsUnderway = {};
	
	function browserAbort(request) {
	  var xhr = requestsUnderway[request.id];
	  if (!xhr) return;
	  xhr.abort();
	  delete requestsUnderway[request.id];
	}
	
	function createResponse(request, xhr) {
	  return new MapiResponse(request, {
	    body: xhr.response,
	    headers: parseHeaders(xhr.getAllResponseHeaders()),
	    statusCode: xhr.status
	  });
	}
	
	function normalizeBrowserProgressEvent(event) {
	  var total = event.total;
	  var transferred = event.loaded;
	  var percent = (100 * transferred) / total;
	  return {
	    total: total,
	    transferred: transferred,
	    percent: percent
	  };
	}
	
	function sendRequestXhr(request, xhr) {
	  return new Promise(function(resolve, reject) {
	    xhr.onprogress = function(event) {
	      request.emitter.emit(
	        constants.EVENT_PROGRESS_DOWNLOAD,
	        normalizeBrowserProgressEvent(event)
	      );
	    };
	
	    var file = request.file;
	    if (file) {
	      xhr.upload.onprogress = function(event) {
	        request.emitter.emit(
	          constants.EVENT_PROGRESS_UPLOAD,
	          normalizeBrowserProgressEvent(event)
	        );
	      };
	    }
	
	    xhr.onerror = function(error) {
	      reject(error);
	    };
	
	    xhr.onabort = function() {
	      var mapiError = new MapiError({
	        request: request,
	        type: constants.ERROR_REQUEST_ABORTED
	      });
	      reject(mapiError);
	    };
	
	    xhr.onload = function() {
	      delete requestsUnderway[request.id];
	      if (xhr.status < 200 || xhr.status >= 400) {
	        var mapiError = new MapiError({
	          request: request,
	          body: xhr.response,
	          statusCode: xhr.status
	        });
	        reject(mapiError);
	        return;
	      }
	      resolve(xhr);
	    };
	
	    var body = request.body;
	
	    // matching service needs to send a www-form-urlencoded request
	    if (typeof body === 'string') {
	      xhr.send(body);
	    } else if (body) {
	      xhr.send(JSON.stringify(body));
	    } else if (file) {
	      xhr.send(file);
	    } else {
	      xhr.send();
	    }
	
	    requestsUnderway[request.id] = xhr;
	  }).then(function(xhr) {
	    return createResponse(request, xhr);
	  });
	}
	
	// The accessToken argument gives this function flexibility
	// for Mapbox's internal client.
	function createRequestXhr(request, accessToken) {
	  var url = request.url(accessToken);
	  var xhr = new window.XMLHttpRequest();
	  xhr.open(request.method, url);
	  Object.keys(request.headers).forEach(function(key) {
	    xhr.setRequestHeader(key, request.headers[key]);
	  });
	  return xhr;
	}
	
	function browserSend(request) {
	  return Promise.resolve().then(function() {
	    var xhr = createRequestXhr(request, request.client.accessToken);
	    return sendRequestXhr(request, xhr);
	  });
	}
	
	module.exports = {
	  browserAbort: browserAbort,
	  sendRequestXhr: sendRequestXhr,
	  browserSend: browserSend,
	  createRequestXhr: createRequestXhr
	};


/***/ },
/* 206 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var constants = __webpack_require__(61);
	
	/**
	 * A Mapbox API error.
	 *
	 * If there's an error during the API transaction,
	 * the Promise returned by `MapiRequest`'s [`send`](#send)
	 * method should reject with a `MapiError`.
	 *
	 * @class MapiError
	 * @hideconstructor
	 * @property {MapiRequest} request - The errored request.
	 * @property {string} type - The type of error. Usually this is `'HttpError'`.
	 *   If the request was aborted, so the error was
	 *   not sent from the server, the type will be
	 *   `'RequestAbortedError'`.
	 * @property {number} [statusCode] - The numeric status code of
	 *   the HTTP response.
	 * @property {Object | string} [body] - If the server sent a response body,
	 *   this property exposes that response, parsed as JSON if possible.
	 * @property {string} [message] - Whatever message could be derived from the
	 *   call site and HTTP response.
	 *
	 * @param {MapiRequest} options.request
	 * @param {number} [options.statusCode]
	 * @param {string} [options.body]
	 * @param {string} [options.message]
	 * @param {string} [options.type]
	 */
	function MapiError(options) {
	  var errorType = options.type || constants.ERROR_HTTP;
	
	  var body;
	  if (options.body) {
	    try {
	      body = JSON.parse(options.body);
	    } catch (e) {
	      body = options.body;
	    }
	  } else {
	    body = null;
	  }
	
	  var message = options.message || null;
	  if (!message) {
	    if (typeof body === 'string') {
	      message = body;
	    } else if (body && typeof body.message === 'string') {
	      message = body.message;
	    } else if (errorType === constants.ERROR_REQUEST_ABORTED) {
	      message = 'Request aborted';
	    }
	  }
	
	  this.message = message;
	  this.type = errorType;
	  this.statusCode = options.statusCode || null;
	  this.request = options.request;
	  this.body = body;
	}
	
	module.exports = MapiError;


/***/ },
/* 207 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var parseToken = __webpack_require__(113);
	var xtend = __webpack_require__(47);
	var EventEmitter = __webpack_require__(522);
	var urlUtils = __webpack_require__(211);
	var constants = __webpack_require__(61);
	
	var requestId = 1;
	
	/**
	 * A Mapbox API request.
	 *
	 * Note that creating a `MapiRequest` does *not* send the request automatically.
	 * Use the request's `send` method to send it off and get a `Promise`.
	 *
	 * The `emitter` property is an `EventEmitter` that emits the following events:
	 *
	 * - `'response'` - Listeners will be called with a `MapiResponse`.
	 * - `'error'` - Listeners will be called with a `MapiError`.
	 * - `'downloadProgress'` - Listeners will be called with `ProgressEvents`.
	 * - `'uploadProgress'` - Listeners will be called with `ProgressEvents`.
	 *   Upload events are only available when the request includes a file.
	 *
	 * @class MapiRequest
	 * @property {EventEmitter} emitter - An event emitter. See above.
	 * @property {MapiClient} client - This request's `MapiClient`.
	 * @property {MapiResponse|null} response - If this request has been sent and received
	 *   a response, the response is available on this property.
	 * @property {MapiError|Error|null} error - If this request has been sent and
	 *   received an error in response, the error is available on this property.
	 * @property {boolean} aborted - If the request has been aborted
	 *   (via [`abort`](#abort)), this property will be `true`.
	 * @property {boolean} sent - If the request has been sent, this property will
	 *   be `true`. You cannot send the same request twice, so if you need to create
	 *   a new request that is the equivalent of an existing one, use
	 *   [`clone`](#clone).
	 * @property {string} path - The request's path, including colon-prefixed route
	 *   parameters.
	 * @property {string} origin - The request's origin.
	 * @property {string} method - The request's HTTP method.
	 * @property {Object} query - A query object, which will be transformed into
	 *   a URL query string.
	 * @property {Object} params - A route parameters object, whose values will
	 *   be interpolated the path.
	 * @property {Object} headers - The request's headers.
	 * @property {Object|string|null} body - Data to send with the request.
	 *   If the request has a body, it will also be sent with the header
	 *   `'Content-Type: application/json'`.
	 * @property {Blob|ArrayBuffer|string|ReadStream} file - A file to
	 *   send with the request. The browser client accepts Blobs and ArrayBuffers;
	 *   the Node client accepts strings (filepaths) and ReadStreams.
	 */
	
	/**
	 * @ignore
	 * @param {MapiClient} client
	 * @param {Object} options
	 * @param {string} options.method
	 * @param {string} options.path
	 * @param {Object} [options.query={}]
	 * @param {Object} [options.params={}]
	 * @param {string} [options.origin]
	 * @param {Object} [options.headers]
	 * @param {Object} [options.body=null]
	 * @param {Blob|ArrayBuffer|string|ReadStream} [options.file=null]
	 */
	function MapiRequest(client, options) {
	  if (!client) {
	    throw new Error('MapiRequest requires a client');
	  }
	  if (!options || !options.path || !options.method) {
	    throw new Error(
	      'MapiRequest requires an options object with path and method properties'
	    );
	  }
	
	  var defaultHeaders = {};
	  if (options.body) {
	    defaultHeaders['content-type'] = 'application/json';
	  }
	
	  var headersWithDefaults = xtend(defaultHeaders, options.headers);
	
	  // Disallows duplicate header names of mixed case,
	  // e.g. Content-Type and content-type.
	  var headers = Object.keys(headersWithDefaults).reduce(function(memo, name) {
	    memo[name.toLowerCase()] = headersWithDefaults[name];
	    return memo;
	  }, {});
	
	  this.id = requestId++;
	  this._options = options;
	
	  this.emitter = new EventEmitter();
	  this.client = client;
	  this.response = null;
	  this.error = null;
	  this.sent = false;
	  this.aborted = false;
	  this.path = options.path;
	  this.method = options.method;
	  this.origin = options.origin || client.origin;
	  this.query = options.query || {};
	  this.params = options.params || {};
	  this.body = options.body || null;
	  this.file = options.file || null;
	  this.headers = headers;
	}
	
	/**
	 * Get the URL of the request.
	 *
	 * @param {string} [accessToken] - By default, the access token of the request's
	 *   client is used.
	 * @return {string}
	 */
	MapiRequest.prototype.url = function url(accessToken) {
	  var url = urlUtils.prependOrigin(this.path, this.origin);
	  url = urlUtils.appendQueryObject(url, this.query);
	  var routeParams = this.params;
	  if (accessToken) {
	    url = urlUtils.appendQueryParam(url, 'access_token', accessToken);
	    var accessTokenOwnerId = parseToken(accessToken).user;
	    routeParams = xtend({ ownerId: accessTokenOwnerId }, routeParams);
	  }
	  url = urlUtils.interpolateRouteParams(url, routeParams);
	  return url;
	};
	
	/**
	 * Send the request. Returns a Promise that resolves with a `MapiResponse`.
	 * You probably want to use `response.body`.
	 *
	 * `send` only retrieves the first page of paginated results. You can get
	 * the next page by using the `MapiResponse`'s [`nextPage`](#nextpage)
	 * function, or iterate through all pages using [`eachPage`](#eachpage)
	 * instead of `send`.
	 *
	 * @returns {Promise<MapiResponse>}
	 */
	MapiRequest.prototype.send = function send() {
	  var self = this;
	
	  if (self.sent) {
	    throw new Error(
	      'This request has already been sent. Check the response and error properties. Create a new request with clone().'
	    );
	  }
	  self.sent = true;
	
	  return self.client.sendRequest(self).then(
	    function(response) {
	      self.response = response;
	      self.emitter.emit(constants.EVENT_RESPONSE, response);
	      return response;
	    },
	    function(error) {
	      self.error = error;
	      self.emitter.emit(constants.EVENT_ERROR, error);
	      throw error;
	    }
	  );
	};
	
	/**
	 * Abort the request.
	 *
	 * Any pending `Promise` returned by [`send`](#send) will be rejected with
	 * an error with `type: 'RequestAbortedError'`. If you've created a request
	 * that might be aborted, you need to catch and handle such errors.
	 *
	 * This method will also abort any requests created while fetching subsequent
	 * pages via [`eachPage`](#eachpage).
	 *
	 * If the request has not been sent or has already been aborted, nothing
	 * will happen.
	 */
	MapiRequest.prototype.abort = function abort() {
	  if (this._nextPageRequest) {
	    this._nextPageRequest.abort();
	    delete this._nextPageRequest;
	  }
	
	  if (this.response || this.error || this.aborted) return;
	
	  this.aborted = true;
	  this.client.abortRequest(this);
	};
	
	/**
	 * Invoke a callback for each page of a paginated API response.
	 *
	 * The callback should have the following signature:
	 *
	 * ```js
	 * (
	 *   error: MapiError,
	 *   response: MapiResponse,
	 *   next: () => void
	 * ) => void
	 * ```
	 *
	 * **The next page will not be fetched until you've invoked the
	 * `next` callback**, indicating that you're ready for it.
	 *
	 * @param {Function} callback
	 */
	MapiRequest.prototype.eachPage = function eachPage(callback) {
	  var self = this;
	
	  function handleResponse(response) {
	    function getNextPage() {
	      delete self._nextPageRequest;
	      var nextPageRequest = response.nextPage();
	      if (nextPageRequest) {
	        self._nextPageRequest = nextPageRequest;
	        getPage(nextPageRequest);
	      }
	    }
	    callback(null, response, getNextPage);
	  }
	
	  function handleError(error) {
	    callback(error, null, function() {});
	  }
	
	  function getPage(request) {
	    request.send().then(handleResponse, handleError);
	  }
	  getPage(this);
	};
	
	/**
	 * Clone this request.
	 *
	 * Each request can only be sent *once*. So if you'd like to send the
	 * same request again, clone it and send away.
	 *
	 * @returns {MapiRequest} - A new `MapiRequest` configured just like this one.
	 */
	MapiRequest.prototype.clone = function clone() {
	  return this._extend();
	};
	
	/**
	 * @ignore
	 */
	MapiRequest.prototype._extend = function _extend(options) {
	  var extendedOptions = xtend(this._options, options);
	  return new MapiRequest(this.client, extendedOptions);
	};
	
	module.exports = MapiRequest;


/***/ },
/* 208 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var parseLinkHeader = __webpack_require__(210);
	
	/**
	 * A Mapbox API response.
	 *
	 * @class MapiResponse
	 * @property {Object} body - The response body, parsed as JSON.
	 * @property {string} rawBody - The raw response body.
	 * @property {number} statusCode - The response's status code.
	 * @property {Object} headers - The parsed response headers.
	 * @property {Object} links - The parsed response links.
	 * @property {MapiRequest} request - The response's originating `MapiRequest`.
	 */
	
	/**
	 * @ignore
	 * @param {MapiRequest} request
	 * @param {Object} responseData
	 * @param {Object} responseData.headers
	 * @param {string} responseData.body
	 * @param {number} responseData.statusCode
	 */
	function MapiResponse(request, responseData) {
	  this.request = request;
	  this.headers = responseData.headers;
	  this.rawBody = responseData.body;
	  this.statusCode = responseData.statusCode;
	  try {
	    this.body = JSON.parse(responseData.body || '{}');
	  } catch (parseError) {
	    this.body = responseData.body;
	  }
	  this.links = parseLinkHeader(this.headers.link);
	}
	
	/**
	 * Check if there is a next page that you can fetch.
	 *
	 * @returns {boolean}
	 */
	MapiResponse.prototype.hasNextPage = function hasNextPage() {
	  return !!this.links.next;
	};
	
	/**
	 * Create a request for the next page, if there is one.
	 * If there is no next page, returns `null`.
	 *
	 * @returns {MapiRequest | null}
	 */
	MapiResponse.prototype.nextPage = function nextPage() {
	  if (!this.hasNextPage()) return null;
	  return this.request._extend({
	    path: this.links.next.url
	  });
	};
	
	module.exports = MapiResponse;


/***/ },
/* 209 */
/***/ function(module, exports) {

	'use strict';
	
	function parseSingleHeader(raw) {
	  var boundary = raw.indexOf(':');
	  var name = raw
	    .substring(0, boundary)
	    .trim()
	    .toLowerCase();
	  var value = raw.substring(boundary + 1).trim();
	  return {
	    name: name,
	    value: value
	  };
	}
	
	/**
	 * Parse raw headers into an object with lowercase properties.
	 * Does not fully parse headings into more complete data structure,
	 * as larger libraries might do. Also does not deal with duplicate
	 * headers because Node doesn't seem to deal with those well, so
	 * we shouldn't let the browser either, for consistency.
	 *
	 * @param {string} raw
	 * @returns {Object}
	 */
	function parseHeaders(raw) {
	  var headers = {};
	  if (!raw) {
	    return headers;
	  }
	
	  raw
	    .trim()
	    .split(/[\r|\n]+/)
	    .forEach(function(rawHeader) {
	      var parsed = parseSingleHeader(rawHeader);
	      headers[parsed.name] = parsed.value;
	    });
	
	  return headers;
	}
	
	module.exports = parseHeaders;


/***/ },
/* 210 */
/***/ function(module, exports) {

	'use strict';
	
	// Like https://github.com/thlorenz/lib/parse-link-header but without any
	// additional dependencies.
	
	function parseParam(param) {
	  var parts = param.match(/\s*(.+)\s*=\s*"?([^"]+)"?/);
	  if (!parts) return null;
	
	  return {
	    key: parts[1],
	    value: parts[2]
	  };
	}
	
	function parseLink(link) {
	  var parts = link.match(/<?([^>]*)>(.*)/);
	  if (!parts) return null;
	
	  var linkUrl = parts[1];
	  var linkParams = parts[2].split(';');
	  var rel = null;
	  var parsedLinkParams = linkParams.reduce(function(result, param) {
	    var parsed = parseParam(param);
	    if (!parsed) return result;
	    if (parsed.key === 'rel') {
	      if (!rel) {
	        rel = parsed.value;
	      }
	      return result;
	    }
	    result[parsed.key] = parsed.value;
	    return result;
	  }, {});
	  if (!rel) return null;
	
	  return {
	    url: linkUrl,
	    rel: rel,
	    params: parsedLinkParams
	  };
	}
	
	/**
	 * Parse a Link header.
	 *
	 * @param {string} linkHeader
	 * @returns {{
	 *   [string]: {
	 *     url: string,
	 *     params: { [string]: string }
	 *   }
	 * }}
	 */
	function parseLinkHeader(linkHeader) {
	  if (!linkHeader) return {};
	
	  return linkHeader.split(/,\s*</).reduce(function(result, link) {
	    var parsed = parseLink(link);
	    if (!parsed) return result;
	    // rel value can be multiple whitespace-separated rels.
	    var splitRel = parsed.rel.split(/\s+/);
	    splitRel.forEach(function(rel) {
	      if (!result[rel]) {
	        result[rel] = {
	          url: parsed.url,
	          params: parsed.params
	        };
	      }
	    });
	    return result;
	  }, {});
	}
	
	module.exports = parseLinkHeader;


/***/ },
/* 211 */
/***/ function(module, exports) {

	'use strict';
	
	// Encode each item of an array individually. The comma
	// delimiters should not themselves be encoded.
	function encodeArray(arrayValue) {
	  return arrayValue.map(encodeURIComponent).join(',');
	}
	
	function encodeValue(value) {
	  if (Array.isArray(value)) {
	    return encodeArray(value);
	  }
	  return encodeURIComponent(String(value));
	}
	
	/**
	 * Append a query parameter to a URL.
	 *
	 * @param {string} url
	 * @param {string} key
	 * @param {string|number|boolean|Array<*>>} [value] - Provide an array
	 *   if the value is a list and commas between values need to be
	 *   preserved, unencoded.
	 * @returns {string} - Modified URL.
	 */
	function appendQueryParam(url, key, value) {
	  if (value === false || value === null) {
	    return url;
	  }
	  var punctuation = /\?/.test(url) ? '&' : '?';
	  var query = encodeURIComponent(key);
	  if (value !== undefined && value !== '' && value !== true) {
	    query += '=' + encodeValue(value);
	  }
	  return '' + url + punctuation + query;
	}
	
	/**
	 * Derive a query string from an object and append it
	 * to a URL.
	 *
	 * @param {string} url
	 * @param {Object} [queryObject] - Values should be primitives.
	 * @returns {string} - Modified URL.
	 */
	function appendQueryObject(url, queryObject) {
	  if (!queryObject) {
	    return url;
	  }
	
	  var result = url;
	  Object.keys(queryObject).forEach(function(key) {
	    var value = queryObject[key];
	    if (value === undefined) {
	      return;
	    }
	    if (Array.isArray(value)) {
	      value = value
	        .filter(function(v) {
	          return !!v;
	        })
	        .join(',');
	    }
	    result = appendQueryParam(result, key, value);
	  });
	  return result;
	}
	
	/**
	 * Prepend an origin to a URL. If the URL already has an
	 * origin, do nothing.
	 *
	 * @param {string} url
	 * @param {string} origin
	 * @returns {string} - Modified URL.
	 */
	function prependOrigin(url, origin) {
	  if (!origin) {
	    return url;
	  }
	
	  if (url.slice(0, 4) === 'http') {
	    return url;
	  }
	
	  var delimiter = url[0] === '/' ? '' : '/';
	  return '' + origin.replace(/\/$/, '') + delimiter + url;
	}
	
	/**
	 * Interpolate values into a route with express-style,
	 * colon-prefixed route parameters.
	 *
	 * @param {string} route
	 * @param {Object} [params] - Values should be primitives
	 *   or arrays of primitives. Provide an array if the value
	 *   is a list and commas between values need to be
	 *   preserved, unencoded.
	 * @returns {string} - Modified URL.
	 */
	function interpolateRouteParams(route, params) {
	  if (!params) {
	    return route;
	  }
	  return route.replace(/\/:([a-zA-Z0-9]+)/g, function(_, paramId) {
	    var value = params[paramId];
	    if (value === undefined) {
	      throw new Error('Unspecified route parameter ' + paramId);
	    }
	    var preppedValue = encodeValue(value);
	    return '/' + preppedValue;
	  });
	}
	
	module.exports = {
	  appendQueryObject: appendQueryObject,
	  appendQueryParam: appendQueryParam,
	  prependOrigin: prependOrigin,
	  interpolateRouteParams: interpolateRouteParams
	};


/***/ },
/* 212 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var xtend = __webpack_require__(47);
	var v = __webpack_require__(217);
	var pick = __webpack_require__(215);
	var stringifyBooleans = __webpack_require__(216);
	var createServiceFactory = __webpack_require__(213);
	
	/**
	 * Geocoding API service.
	 *
	 * Learn more about this service and its responses in
	 * [the HTTP service documentation](https://www.mapbox.com/api-documentation/#geocoding).
	 */
	var Geocoding = {};
	
	var featureTypes = [
	  'country',
	  'region',
	  'postcode',
	  'district',
	  'place',
	  'locality',
	  'neighborhood',
	  'address',
	  'poi',
	  'poi.landmark'
	];
	
	/**
	 * Search for a place.
	 *
	 * See the [public documentation](https://www.mapbox.com/api-documentation/#search-for-places).
	 *
	 * @param {Object} config
	 * @param {string} config.query - A place name.
	 * @param {'mapbox.places'|'mapbox.places-permanent'} [config.mode="mapbox.places"] - Either `mapbox.places` for ephemeral geocoding, or `mapbox.places-permanent` for storing results and batch geocoding.
	 * @param {Array<string>} [config.countries] - Limits results to the specified countries.
	 *   Each item in the array should be an [ISO 3166 alpha 2 country code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2).
	 * @param {Coordinates} [config.proximity] - Bias local results based on a provided location.
	 * @param {Array<'country'|'region'|'postcode'|'district'|'place'|'locality'|'neighborhood'|'address'|'poi'|'poi.landmark'>} [config.types] - Filter results by feature types.
	 * @param {boolean} [config.autocomplete=true] - Return autocomplete results or not.
	 * @param {BoundingBox} [config.bbox] - Limit results to a bounding box.
	 * @param {number} [config.limit=5] - Limit the number of results returned.
	 * @param {Array<string>} [config.language] - Specify the language to use for response text and, for forward geocoding, query result weighting.
	 *  Options are [IETF language tags](https://en.wikipedia.org/wiki/IETF_language_tag) comprised of a mandatory
	 *  [ISO 639-1 language code](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) and optionally one or more IETF subtags for country or script.
	 * @return {MapiRequest}
	 */
	Geocoding.forwardGeocode = function(config) {
	  v.assertShape({
	    query: v.required(v.string),
	    mode: v.oneOf('mapbox.places', 'mapbox.places-permanent'),
	    countries: v.arrayOf(v.string),
	    proximity: v.coordinates,
	    types: v.arrayOf(v.oneOf(featureTypes)),
	    autocomplete: v.boolean,
	    bbox: v.arrayOf(v.number),
	    limit: v.number,
	    language: v.arrayOf(v.string)
	  })(config);
	
	  config.mode = config.mode || 'mapbox.places';
	
	  var query = stringifyBooleans(
	    xtend(
	      { country: config.countries },
	      pick(config, [
	        'proximity',
	        'types',
	        'autocomplete',
	        'bbox',
	        'limit',
	        'language'
	      ])
	    )
	  );
	
	  return this.client.createRequest({
	    method: 'GET',
	    path: '/geocoding/v5/:mode/:query.json',
	    params: pick(config, ['mode', 'query']),
	    query: query
	  });
	};
	
	/**
	 * Search for places near coordinates.
	 *
	 * See the [public documentation](https://www.mapbox.com/api-documentation/#retrieve-places-near-a-location).
	 *
	 * @param {Object} config
	 * @param {Coordinates} config.query - Coordinates at which features will be searched.
	 * @param {'mapbox.places'|'mapbox.places-permanent'} [config.mode="mapbox.places"] - Either `mapbox.places` for ephemeral geocoding, or `mapbox.places-permanent` for storing results and batch geocoding.
	 * @param {Array<string>} [config.countries] - Limits results to the specified countries.
	 *   Each item in the array should be an [ISO 3166 alpha 2 country code](https://en.wikipedia.org/wiki/ISO_3166-1_alpha-2).
	 * @param {Array<'country'|'region'|'postcode'|'district'|'place'|'locality'|'neighborhood'|'address'|'poi'|'poi.landmark'>} [config.types] - Filter results by feature types.
	 * @param {BoundingBox} [config.bbox] - Limit results to a bounding box.
	 * @param {number} [config.limit=1] - Limit the number of results returned. If using this option, you must provide a single item for `types`.
	 * @param {Array<string>} [config.language] - Specify the language to use for response text and, for forward geocoding, query result weighting.
	 *  Options are [IETF language tags](https://en.wikipedia.org/wiki/IETF_language_tag) comprised of a mandatory
	 *  [ISO 639-1 language code](https://en.wikipedia.org/wiki/List_of_ISO_639-1_codes) and optionally one or more IETF subtags for country or script.
	 * @param {'distance'|'score'} [config.reverseMode='distance'] - Set the factors that are used to sort nearby results.
	 * @return {MapiRequest}
	 */
	Geocoding.reverseGeocode = function(config) {
	  v.assertShape({
	    query: v.required(v.coordinates),
	    mode: v.oneOf('mapbox.places', 'mapbox.places-permanent'),
	    countries: v.arrayOf(v.string),
	    types: v.arrayOf(v.oneOf(featureTypes)),
	    bbox: v.arrayOf(v.number),
	    limit: v.number,
	    language: v.arrayOf(v.string),
	    reverseMode: v.oneOf('distance', 'score')
	  })(config);
	
	  config.mode = config.mode || 'mapbox.places';
	
	  var query = stringifyBooleans(
	    xtend(
	      { country: config.countries },
	      pick(config, [
	        'country',
	        'types',
	        'bbox',
	        'limit',
	        'language',
	        'reverseMode'
	      ])
	    )
	  );
	
	  return this.client.createRequest({
	    method: 'GET',
	    path: '/geocoding/v5/:mode/:query.json',
	    params: pick(config, ['mode', 'query']),
	    query: query
	  });
	};
	
	module.exports = createServiceFactory(Geocoding);


/***/ },
/* 213 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var MapiClient = __webpack_require__(112);
	// This will create the environment-appropriate client.
	var createClient = __webpack_require__(111);
	
	function createServiceFactory(ServicePrototype) {
	  return function(clientOrConfig) {
	    var client;
	    if (MapiClient.prototype.isPrototypeOf(clientOrConfig)) {
	      client = clientOrConfig;
	    } else {
	      client = createClient(clientOrConfig);
	    }
	    var service = Object.create(ServicePrototype);
	    service.client = client;
	    return service;
	  };
	}
	
	module.exports = createServiceFactory;


/***/ },
/* 214 */
/***/ function(module, exports) {

	'use strict';
	
	function objectMap(obj, cb) {
	  return Object.keys(obj).reduce(function(result, key) {
	    result[key] = cb(key, obj[key]);
	    return result;
	  }, {});
	}
	
	module.exports = objectMap;


/***/ },
/* 215 */
/***/ function(module, exports) {

	'use strict';
	
	/**
	 * Create a new object by picking properties off an existing object.
	 * The second param can be overloaded as a callback for
	 * more fine grained picking of properties.
	 * @param {Object} source
	 * @param {Array<string>|function(string, Object):boolean} keys
	 * @returns {Object}
	 */
	function pick(source, keys) {
	  var filter = function(key, val) {
	    return keys.indexOf(key) !== -1 && val !== undefined;
	  };
	
	  if (typeof keys === 'function') {
	    filter = keys;
	  }
	
	  return Object.keys(source)
	    .filter(function(key) {
	      return filter(key, source[key]);
	    })
	    .reduce(function(result, key) {
	      result[key] = source[key];
	      return result;
	    }, {});
	}
	
	module.exports = pick;


/***/ },
/* 216 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var objectMap = __webpack_require__(214);
	
	/**
	 * Stringify all the boolean values in an object, so true becomes "true".
	 *
	 * @param {Object} obj
	 * @returns {Object}
	 */
	function stringifyBoolean(obj) {
	  return objectMap(obj, function(_, value) {
	    return typeof value === 'boolean' ? JSON.stringify(value) : value;
	  });
	}
	
	module.exports = stringifyBoolean;


/***/ },
/* 217 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {'use strict';
	
	var xtend = __webpack_require__(47);
	var v = __webpack_require__(199);
	
	function file(value) {
	  // If we're in a browser so Blob is available, the file must be that.
	  // In Node, however, it could be a filepath or a pipeable (Readable) stream.
	  if (typeof window !== 'undefined') {
	    if (value instanceof global.Blob || value instanceof global.ArrayBuffer) {
	      return;
	    }
	    return 'Blob or ArrayBuffer';
	  }
	  if (typeof value === 'string' || value.pipe !== undefined) {
	    return;
	  }
	  return 'Filename or Readable stream';
	}
	
	function assertShape(validatorObj, apiName) {
	  return v.assert(v.strictShape(validatorObj), apiName);
	}
	
	function date(value) {
	  var msg = 'date';
	  if (typeof value === 'boolean') {
	    return msg;
	  }
	  try {
	    var date = new Date(value);
	    if (date.getTime && isNaN(date.getTime())) {
	      return msg;
	    }
	  } catch (e) {
	    return msg;
	  }
	}
	
	function coordinates(value) {
	  return v.tuple(v.number, v.number)(value);
	}
	
	module.exports = xtend(v, {
	  file: file,
	  date: date,
	  coordinates: coordinates,
	  assertShape: assertShape
	});
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 218 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var styles = function styles(theme) {
	  var backgroundColorDefault = theme.palette.type === 'light' ? theme.palette.grey[100] : theme.palette.grey[900];
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      flexDirection: 'column',
	      width: '100%',
	      boxSizing: 'border-box',
	      // Prevent padding issue with the Modal and fixed positioned AppBar.
	      zIndex: theme.zIndex.appBar,
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `position="fixed"`. */
	    positionFixed: {
	      position: 'fixed',
	      top: 0,
	      left: 'auto',
	      right: 0,
	      '@media print': {
	        // Prevent the app bar to be visible on each printed page.
	        position: 'absolute'
	      }
	    },
	
	    /* Styles applied to the root element if `position="absolute"`. */
	    positionAbsolute: {
	      position: 'absolute',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="sticky"`. */
	    positionSticky: {
	      // ⚠️ sticky is not supported by IE 11.
	      position: 'sticky',
	      top: 0,
	      left: 'auto',
	      right: 0
	    },
	
	    /* Styles applied to the root element if `position="static"`. */
	    positionStatic: {
	      position: 'static',
	      transform: 'translateZ(0)' // Make sure we can see the elevation.
	
	    },
	
	    /* Styles applied to the root element if `position="relative"`. */
	    positionRelative: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if `color="default"`. */
	    colorDefault: {
	      backgroundColor: backgroundColorDefault,
	      color: theme.palette.getContrastText(backgroundColorDefault)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="transparent"`. */
	    colorTransparent: {
	      backgroundColor: 'transparent',
	      color: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	var AppBar = React.forwardRef(function AppBar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$position = props.position,
	      position = _props$position === void 0 ? 'fixed' : _props$position,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "position"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    component: "header",
	    elevation: 4,
	    className: (0, _clsx.default)(classes.root, classes["position".concat((0, _capitalize.default)(position))], classes["color".concat((0, _capitalize.default)(color))], className, position === 'fixed' && 'mui-fixed'),
	    ref: ref
	  }, other));
	});
	 false ? AppBar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary', 'transparent']),
	
	  /**
	   * The positioning type. The behavior of the different options is described
	   * [in the MDN web docs](https://developer.mozilla.org/en-US/docs/Learn/CSS/CSS_layout/Positioning).
	   * Note: `sticky` is not universally supported and will fall back to `static` when unavailable.
	   */
	  position: _propTypes.default.oneOf(['absolute', 'fixed', 'relative', 'static', 'sticky'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAppBar'
	})(AppBar);
	
	exports.default = _default;

/***/ },
/* 219 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _AppBar.default;
	  }
	});
	
	var _AppBar = _interopRequireDefault(__webpack_require__(218));

/***/ },
/* 220 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Person = _interopRequireDefault(__webpack_require__(426));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      flexShrink: 0,
	      width: 40,
	      height: 40,
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(20),
	      lineHeight: 1,
	      borderRadius: '50%',
	      overflow: 'hidden',
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the root element if not `src` or `srcSet`. */
	    colorDefault: {
	      color: theme.palette.background.default,
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the root element if `variant="circle"`. */
	    circle: {},
	
	    /* Styles applied to the root element if `variant="rounded"`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="square"`. */
	    square: {
	      borderRadius: 0
	    },
	
	    /* Styles applied to the img element if either `src` or `srcSet` is defined. */
	    img: {
	      width: '100%',
	      height: '100%',
	      textAlign: 'center',
	      // Handle non-square image. The property isn't supported by IE 11.
	      objectFit: 'cover',
	      // Hide alt text.
	      color: 'transparent',
	      // Hide the image broken icon, only works on Chrome.
	      textIndent: 10000
	    },
	
	    /* Styles applied to the fallback icon */
	    fallback: {
	      width: '75%',
	      height: '75%'
	    }
	  };
	};
	
	exports.styles = styles;
	
	function useLoaded(_ref) {
	  var src = _ref.src,
	      srcSet = _ref.srcSet;
	
	  var _React$useState = React.useState(false),
	      loaded = _React$useState[0],
	      setLoaded = _React$useState[1];
	
	  React.useEffect(function () {
	    if (!src && !srcSet) {
	      return undefined;
	    }
	
	    setLoaded(false);
	    var active = true;
	    var image = new Image();
	    image.src = src;
	    image.srcSet = srcSet;
	
	    image.onload = function () {
	      if (!active) {
	        return;
	      }
	
	      setLoaded('loaded');
	    };
	
	    image.onerror = function () {
	      if (!active) {
	        return;
	      }
	
	      setLoaded('error');
	    };
	
	    return function () {
	      active = false;
	    };
	  }, [src, srcSet]);
	  return loaded;
	}
	
	var Avatar = React.forwardRef(function Avatar(props, ref) {
	  var alt = props.alt,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      imgProps = props.imgProps,
	      sizes = props.sizes,
	      src = props.src,
	      srcSet = props.srcSet,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'circle' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["alt", "children", "classes", "className", "component", "imgProps", "sizes", "src", "srcSet", "variant"]);
	  var children = null; // Use a hook instead of onError on the img element to support server-side rendering.
	
	  var loaded = useLoaded({
	    src: src,
	    srcSet: srcSet
	  });
	  var hasImg = src || srcSet;
	  var hasImgNotFailing = hasImg && loaded !== 'error';
	
	  if (hasImgNotFailing) {
	    children = /*#__PURE__*/React.createElement("img", (0, _extends2.default)({
	      alt: alt,
	      src: src,
	      srcSet: srcSet,
	      sizes: sizes,
	      className: classes.img
	    }, imgProps));
	  } else if (childrenProp != null) {
	    children = childrenProp;
	  } else if (hasImg && alt) {
	    children = alt[0];
	  } else {
	    children = /*#__PURE__*/React.createElement(_Person.default, {
	      className: classes.fallback
	    });
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes.system, classes[variant], className, !hasImgNotFailing && classes.colorDefault),
	    ref: ref
	  }, other), children);
	});
	 false ? Avatar.propTypes = {
	  /**
	   * Used in combination with `src` or `srcSet` to
	   * provide an alt attribute for the rendered `img` element.
	   */
	  alt: _propTypes.default.string,
	
	  /**
	   * Used to render icon or text elements inside the Avatar if `src` is not set.
	   * This can be an element, or just a string.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Attributes applied to the `img` element if the component is used to display an image.
	   * It can be used to listen for the loading error event.
	   */
	  imgProps: _propTypes.default.object,
	
	  /**
	   * The `sizes` attribute for the `img` element.
	   */
	  sizes: _propTypes.default.string,
	
	  /**
	   * The `src` attribute for the `img` element.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * The `srcSet` attribute for the `img` element.
	   * Use this attribute for responsive image display.
	   */
	  srcSet: _propTypes.default.string,
	
	  /**
	   * The shape of the avatar.
	   */
	  variant: _propTypes.default.oneOf(['circle', 'rounded', 'square'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiAvatar'
	})(Avatar);
	
	exports.default = _default;

/***/ },
/* 221 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Avatar.default;
	  }
	});
	
	var _Avatar = _interopRequireDefault(__webpack_require__(220));

/***/ },
/* 222 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Fade = _interopRequireDefault(__webpack_require__(77));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    // Improve scrollable dialog support.
	    zIndex: -1,
	    position: 'fixed',
	    display: 'flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	exports.styles = styles;
	var Backdrop = React.forwardRef(function Backdrop(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      transitionDuration = props.transitionDuration,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "invisible", "open", "transitionDuration"]);
	  return /*#__PURE__*/React.createElement(_Fade.default, (0, _extends2.default)({
	    in: open,
	    timeout: transitionDuration
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.root, className, invisible && classes.invisible),
	    "aria-hidden": true,
	    ref: ref
	  }, children));
	});
	 false ? Backdrop.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBackdrop'
	})(Backdrop);
	
	exports.default = _default;

/***/ },
/* 223 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var RADIUS_STANDARD = 10;
	var RADIUS_DOT = 4;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'inline-flex',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the badge `span` element. */
	    badge: {
	      display: 'flex',
	      flexDirection: 'row',
	      flexWrap: 'wrap',
	      justifyContent: 'center',
	      alignContent: 'center',
	      alignItems: 'center',
	      position: 'absolute',
	      boxSizing: 'border-box',
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(12),
	      minWidth: RADIUS_STANDARD * 2,
	      lineHeight: 1,
	      padding: '0 6px',
	      height: RADIUS_STANDARD * 2,
	      borderRadius: RADIUS_STANDARD,
	      zIndex: 1,
	      // Render the badge on top of potential ripples.
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeInOut,
	        duration: theme.transitions.duration.enteringScreen
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      backgroundColor: theme.palette.error.main,
	      color: theme.palette.error.contrastText
	    },
	
	    /* Styles applied to the root element if `variant="dot"`. */
	    dot: {
	      borderRadius: RADIUS_DOT,
	      height: RADIUS_DOT * 2,
	      minWidth: RADIUS_DOT * 2,
	      padding: 0
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="rectangle"`. */
	    anchorOriginTopRightRectangle: {
	      top: 0,
	      right: 0,
	      transform: 'scale(1) translate(50%, -50%)',
	      transformOrigin: '100% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="rectangle"`. */
	    anchorOriginBottomRightRectangle: {
	      bottom: 0,
	      right: 0,
	      transform: 'scale(1) translate(50%, 50%)',
	      transformOrigin: '100% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="rectangle"`. */
	    anchorOriginTopLeftRectangle: {
	      top: 0,
	      left: 0,
	      transform: 'scale(1) translate(-50%, -50%)',
	      transformOrigin: '0% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="rectangle"`. */
	    anchorOriginBottomLeftRectangle: {
	      bottom: 0,
	      left: 0,
	      transform: 'scale(1) translate(-50%, 50%)',
	      transformOrigin: '0% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }} overlap="circle"`. */
	    anchorOriginTopRightCircle: {
	      top: '14%',
	      right: '14%',
	      transform: 'scale(1) translate(50%, -50%)',
	      transformOrigin: '100% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }} overlap="circle"`. */
	    anchorOriginBottomRightCircle: {
	      bottom: '14%',
	      right: '14%',
	      transform: 'scale(1) translate(50%, 50%)',
	      transformOrigin: '100% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(50%, 50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }} overlap="circle"`. */
	    anchorOriginTopLeftCircle: {
	      top: '14%',
	      left: '14%',
	      transform: 'scale(1) translate(-50%, -50%)',
	      transformOrigin: '0% 0%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, -50%)'
	      }
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }} overlap="circle"`. */
	    anchorOriginBottomLeftCircle: {
	      bottom: '14%',
	      left: '14%',
	      transform: 'scale(1) translate(-50%, 50%)',
	      transformOrigin: '0% 100%',
	      '&$invisible': {
	        transform: 'scale(0) translate(-50%, 50%)'
	      }
	    },
	
	    /* Pseudo-class to the badge `span` element if `invisible={true}`. */
	    invisible: {
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeInOut,
	        duration: theme.transitions.duration.leavingScreen
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	var Badge = React.forwardRef(function Badge(props, ref) {
	  var _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'right'
	  } : _props$anchorOrigin,
	      badgeContent = props.badgeContent,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      ComponentProp = _props$component === void 0 ? 'span' : _props$component,
	      invisibleProp = props.invisible,
	      _props$max = props.max,
	      max = _props$max === void 0 ? 99 : _props$max,
	      _props$overlap = props.overlap,
	      overlap = _props$overlap === void 0 ? 'rectangle' : _props$overlap,
	      _props$showZero = props.showZero,
	      showZero = _props$showZero === void 0 ? false : _props$showZero,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorOrigin", "badgeContent", "children", "classes", "className", "color", "component", "invisible", "max", "overlap", "showZero", "variant"]);
	  var invisible = invisibleProp;
	
	  if (invisibleProp == null && (badgeContent === 0 && !showZero || badgeContent == null && variant !== 'dot')) {
	    invisible = true;
	  }
	
	  var displayValue = '';
	
	  if (variant !== 'dot') {
	    displayValue = badgeContent > max ? "".concat(max, "+") : badgeContent;
	  }
	
	  return /*#__PURE__*/React.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), children, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.badge, classes["".concat(anchorOrigin.horizontal).concat((0, _capitalize.default)(anchorOrigin.vertical), "}")], classes["anchorOrigin".concat((0, _capitalize.default)(anchorOrigin.vertical)).concat((0, _capitalize.default)(anchorOrigin.horizontal)).concat((0, _capitalize.default)(overlap))], color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], invisible && classes.invisible, variant === 'dot' && classes.dot)
	  }, displayValue));
	});
	 false ? Badge.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The anchor of the badge.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOf(['left', 'right']).isRequired,
	    vertical: _propTypes.default.oneOf(['bottom', 'top']).isRequired
	  }),
	
	  /**
	   * The content rendered within the badge.
	   */
	  badgeContent: _propTypes.default.node,
	
	  /**
	   * The badge will be added relative to this node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'error', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the badge will be invisible.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * Max count to show.
	   */
	  max: _propTypes.default.number,
	
	  /**
	   * Wrapped shape the badge should overlap.
	   */
	  overlap: _propTypes.default.oneOf(['circle', 'rectangle']),
	
	  /**
	   * Controls whether the badge is hidden when `badgeContent` is zero.
	   */
	  showZero: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['dot', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBadge'
	})(Badge);
	
	exports.default = _default;

/***/ },
/* 224 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Badge.default;
	  }
	});
	
	var _Badge = _interopRequireDefault(__webpack_require__(223));

/***/ },
/* 225 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(18);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      justifyContent: 'center',
	      height: 56,
	      backgroundColor: theme.palette.background.paper
	    }
	  };
	};
	
	exports.styles = styles;
	var BottomNavigation = React.forwardRef(function BottomNavigation(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      onChange = props.onChange,
	      _props$showLabels = props.showLabels,
	      showLabels = _props$showLabels === void 0 ? false : _props$showLabels,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "onChange", "showLabels", "value"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), React.Children.map(children, function (child, childIndex) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the BottomNavigation component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    return React.cloneElement(child, {
	      selected: childValue === value,
	      showLabel: child.props.showLabel !== undefined ? child.props.showLabel : showLabels,
	      value: childValue,
	      onChange: onChange
	    });
	  }));
	});
	 false ? BottomNavigation.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {any} value We default to the index of the child.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, all `BottomNavigationAction`s will show their labels.
	   * By default, only the selected `BottomNavigationAction` will show its label.
	   */
	  showLabels: _propTypes.default.bool,
	
	  /**
	   * The value of the currently selected `BottomNavigationAction`.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigation'
	})(BottomNavigation);
	
	exports.default = _default;

/***/ },
/* 226 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigation.default;
	  }
	});
	
	var _BottomNavigation = _interopRequireDefault(__webpack_require__(225));

/***/ },
/* 227 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(67));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      transition: theme.transitions.create(['color', 'padding-top'], {
	        duration: theme.transitions.duration.short
	      }),
	      padding: '6px 12px 8px',
	      minWidth: 80,
	      maxWidth: 168,
	      color: theme.palette.text.secondary,
	      flex: '1',
	      '&$iconOnly': {
	        paddingTop: 16
	      },
	      '&$selected': {
	        paddingTop: 6,
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Pseudo-class applied to the root element if selected. */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `showLabel={false}` and not selected. */
	    iconOnly: {},
	
	    /* Styles applied to the span element that wraps the icon and label. */
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the label's span element. */
	    label: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(12),
	      opacity: 1,
	      transition: 'font-size 0.2s, opacity 0.2s',
	      transitionDelay: '0.1s',
	      '&$iconOnly': {
	        opacity: 0,
	        transitionDelay: '0s'
	      },
	      '&$selected': {
	        fontSize: theme.typography.pxToRem(14)
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var BottomNavigationAction = React.forwardRef(function BottomNavigationAction(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      icon = props.icon,
	      label = props.label,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      selected = props.selected,
	      showLabel = props.showLabel,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "icon", "label", "onChange", "onClick", "selected", "showLabel", "value"]);
	
	  var handleChange = function handleChange(event) {
	    if (onChange) {
	      onChange(event, value);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, selected ? classes.selected : !showLabel && classes.iconOnly),
	    focusRipple: true,
	    onClick: handleChange
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.wrapper
	  }, icon, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.label, selected ? classes.selected : !showLabel && classes.iconOnly)
	  }, label)));
	});
	 false ? BottomNavigationAction.propTypes = {
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `BottomNavigationAction` will show its label.
	   * By default, only the selected `BottomNavigationAction`
	   * inside `BottomNavigation` will show its label.
	   */
	  showLabel: _propTypes.default.bool,
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBottomNavigationAction'
	})(BottomNavigationAction);
	
	exports.default = _default;

/***/ },
/* 228 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _BottomNavigationAction.default;
	  }
	});
	
	var _BottomNavigationAction = _interopRequireDefault(__webpack_require__(227));

/***/ },
/* 229 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styleFunction = void 0;
	
	var _system = __webpack_require__(173);
	
	var _styled = _interopRequireDefault(__webpack_require__(162));
	
	var styleFunction = (0, _system.css)((0, _system.compose)(_system.borders, _system.display, _system.flexbox, _system.grid, _system.positions, _system.palette, _system.shadows, _system.sizing, _system.spacing, _system.typography));
	/**
	 * @ignore - do not document.
	 */
	
	exports.styleFunction = styleFunction;
	var Box = (0, _styled.default)('div')(styleFunction, {
	  name: 'MuiBox'
	});
	var _default = Box;
	exports.default = _default;

/***/ },
/* 230 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Box.default;
	  }
	});
	Object.defineProperty(exports, "styleFunction", {
	  enumerable: true,
	  get: function get() {
	    return _Box.styleFunction;
	  }
	});
	
	var _Box = _interopRequireWildcard(__webpack_require__(229));

/***/ },
/* 231 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _MoreHoriz = _interopRequireDefault(__webpack_require__(425));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      display: 'flex',
	      marginLeft: theme.spacing(0.5),
	      marginRight: theme.spacing(0.5),
	      backgroundColor: theme.palette.grey[100],
	      color: theme.palette.grey[700],
	      borderRadius: 2,
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: theme.palette.grey[200]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[0],
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.grey[200], 0.12)
	      }
	    },
	    icon: {
	      width: 24,
	      height: 16
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function BreadcrumbCollapsed(props) {
	  var classes = props.classes,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    component: "li",
	    className: classes.root,
	    focusRipple: true
	  }, other), /*#__PURE__*/React.createElement(_MoreHoriz.default, {
	    className: classes.icon
	  }));
	}
	
	 false ? BreadcrumbCollapsed.propTypes = {
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateBreadcrumbCollapsed'
	})(BreadcrumbCollapsed);
	
	exports.default = _default;

/***/ },
/* 232 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(18);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var _BreadcrumbCollapsed = _interopRequireDefault(__webpack_require__(231));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the ol element. */
	  ol: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    alignItems: 'center',
	    padding: 0,
	    margin: 0,
	    listStyle: 'none'
	  },
	
	  /* Styles applied to the li element. */
	  li: {},
	
	  /* Styles applied to the separator element. */
	  separator: {
	    display: 'flex',
	    userSelect: 'none',
	    marginLeft: 8,
	    marginRight: 8
	  }
	};
	exports.styles = styles;
	
	function insertSeparators(items, className, separator) {
	  return items.reduce(function (acc, current, index) {
	    if (index < items.length - 1) {
	      acc = acc.concat(current, /*#__PURE__*/React.createElement("li", {
	        "aria-hidden": true,
	        key: "separator-".concat(index),
	        className: className
	      }, separator));
	    } else {
	      acc.push(current);
	    }
	
	    return acc;
	  }, []);
	}
	
	var Breadcrumbs = React.forwardRef(function Breadcrumbs(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'nav' : _props$component,
	      _props$expandText = props.expandText,
	      expandText = _props$expandText === void 0 ? 'Show path' : _props$expandText,
	      _props$itemsAfterColl = props.itemsAfterCollapse,
	      itemsAfterCollapse = _props$itemsAfterColl === void 0 ? 1 : _props$itemsAfterColl,
	      _props$itemsBeforeCol = props.itemsBeforeCollapse,
	      itemsBeforeCollapse = _props$itemsBeforeCol === void 0 ? 1 : _props$itemsBeforeCol,
	      _props$maxItems = props.maxItems,
	      maxItems = _props$maxItems === void 0 ? 8 : _props$maxItems,
	      _props$separator = props.separator,
	      separator = _props$separator === void 0 ? '/' : _props$separator,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "expandText", "itemsAfterCollapse", "itemsBeforeCollapse", "maxItems", "separator"]);
	
	  var _React$useState = React.useState(false),
	      expanded = _React$useState[0],
	      setExpanded = _React$useState[1];
	
	  var renderItemsBeforeAndAfter = function renderItemsBeforeAndAfter(allItems) {
	    var handleClickExpand = function handleClickExpand(event) {
	      setExpanded(true); // The clicked element received the focus but gets removed from the DOM.
	      // Let's keep the focus in the component after expanding.
	
	      var focusable = event.currentTarget.parentNode.querySelector('a[href],button,[tabindex]');
	
	      if (focusable) {
	        focusable.focus();
	      }
	    }; // This defends against someone passing weird input, to ensure that if all
	    // items would be shown anyway, we just show all items without the EllipsisItem
	
	
	    if (itemsBeforeCollapse + itemsAfterCollapse >= allItems.length) {
	      if (false) {
	        console.error(['Material-UI: you have provided an invalid combination of props to the Breadcrumbs.', "itemsAfterCollapse={".concat(itemsAfterCollapse, "} + itemsBeforeCollapse={").concat(itemsBeforeCollapse, "} >= maxItems={").concat(maxItems, "}")].join('\n'));
	      }
	
	      return allItems;
	    }
	
	    return [].concat((0, _toConsumableArray2.default)(allItems.slice(0, itemsBeforeCollapse)), [/*#__PURE__*/React.createElement(_BreadcrumbCollapsed.default, {
	      "aria-label": expandText,
	      key: "ellipsis",
	      onClick: handleClickExpand
	    })], (0, _toConsumableArray2.default)(allItems.slice(allItems.length - itemsAfterCollapse, allItems.length)));
	  };
	
	  var allItems = React.Children.toArray(children).filter(function (child) {
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Breadcrumbs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return React.isValidElement(child);
	  }).map(function (child, index) {
	    return /*#__PURE__*/React.createElement("li", {
	      className: classes.li,
	      key: "child-".concat(index)
	    }, child);
	  });
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    ref: ref,
	    component: Component,
	    color: "textSecondary",
	    className: (0, _clsx.default)(classes.root, className)
	  }, other), /*#__PURE__*/React.createElement("ol", {
	    className: classes.ol
	  }, insertSeparators(expanded || maxItems && allItems.length <= maxItems ? allItems : renderItemsBeforeAndAfter(allItems), classes.separator, separator)));
	});
	 false ? Breadcrumbs.propTypes = {
	  /**
	   * The breadcrumb children.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it maps the variant to a good default headline component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Override the default label for the expand button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  expandText: _propTypes.default.string,
	
	  /**
	   * If max items is exceeded, the number of items to show after the ellipsis.
	   */
	  itemsAfterCollapse: _propTypes.default.number,
	
	  /**
	   * If max items is exceeded, the number of items to show before the ellipsis.
	   */
	  itemsBeforeCollapse: _propTypes.default.number,
	
	  /**
	   * Specifies the maximum number of breadcrumbs to display. When there are more
	   * than the maximum number, only the first `itemsBeforeCollapse` and last `itemsAfterCollapse`
	   * will be shown, with an ellipsis in between.
	   */
	  maxItems: _propTypes.default.number,
	
	  /**
	   * Custom separator node.
	   */
	  separator: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiBreadcrumbs'
	})(Breadcrumbs);
	
	exports.default = _default;

/***/ },
/* 233 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Breadcrumbs.default;
	  }
	});
	
	var _Breadcrumbs = _interopRequireDefault(__webpack_require__(232));

/***/ },
/* 234 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      boxSizing: 'border-box',
	      minWidth: 64,
	      padding: '6px 16px',
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        },
	        '&$disabled': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // Ensure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `variant="text"`. */
	    text: {
	      padding: '6px 8px'
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="primary"`. */
	    textPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="text"` and `color="secondary"`. */
	    textSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      padding: '5px 15px',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '&$disabled': {
	        border: "1px solid ".concat(theme.palette.action.disabledBackground)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.primary.main),
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)),
	      '&:hover': {
	        border: "1px solid ".concat(theme.palette.secondary.main),
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        border: "1px solid ".concat(theme.palette.action.disabled)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"`. */
	    contained: {
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      boxShadow: theme.shadows[2],
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        boxShadow: theme.shadows[4],
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          boxShadow: theme.shadows[2],
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        }
	      },
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&:active': {
	        boxShadow: theme.shadows[8]
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"` and `color="primary"`. */
	    containedPrimary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="contained"` and `color="secondary"`. */
	    containedSecondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `disableElevation={true}`. */
	    disableElevation: {
	      boxShadow: 'none',
	      '&:hover': {
	        boxShadow: 'none'
	      },
	      '&$focusVisible': {
	        boxShadow: 'none'
	      },
	      '&:active': {
	        boxShadow: 'none'
	      },
	      '&$disabled': {
	        boxShadow: 'none'
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit',
	      borderColor: 'currentColor'
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="text"`. */
	    textSizeSmall: {
	      padding: '4px 5px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="text"`. */
	    textSizeLarge: {
	      padding: '8px 11px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="outlined"`. */
	    outlinedSizeSmall: {
	      padding: '3px 9px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="outlined"`. */
	    outlinedSizeLarge: {
	      padding: '7px 21px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"` and `variant="contained"`. */
	    containedSizeSmall: {
	      padding: '4px 10px',
	      fontSize: theme.typography.pxToRem(13)
	    },
	
	    /* Styles applied to the root element if `size="large"` and `variant="contained"`. */
	    containedSizeLarge: {
	      padding: '8px 22px',
	      fontSize: theme.typography.pxToRem(15)
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {},
	
	    /* Styles applied to the root element if `size="large"`. */
	    sizeLarge: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the startIcon element if supplied. */
	    startIcon: {
	      display: 'inherit',
	      marginRight: 8,
	      marginLeft: -4,
	      '&$iconSizeSmall': {
	        marginLeft: -2
	      }
	    },
	
	    /* Styles applied to the endIcon element if supplied. */
	    endIcon: {
	      display: 'inherit',
	      marginRight: -4,
	      marginLeft: 8,
	      '&$iconSizeSmall': {
	        marginRight: -2
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="small"`. */
	    iconSizeSmall: {
	      '& > *:first-child': {
	        fontSize: 18
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="medium"`. */
	    iconSizeMedium: {
	      '& > *:first-child': {
	        fontSize: 20
	      }
	    },
	
	    /* Styles applied to the icon element if supplied and `size="large"`. */
	    iconSizeLarge: {
	      '& > *:first-child': {
	        fontSize: 22
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var Button = React.forwardRef(function Button(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableElevati = props.disableElevation,
	      disableElevation = _props$disableElevati === void 0 ? false : _props$disableElevati,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      endIconProp = props.endIcon,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      startIconProp = props.startIcon,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'text' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableElevation", "disableFocusRipple", "endIcon", "focusVisibleClassName", "fullWidth", "size", "startIcon", "type", "variant"]);
	  var startIcon = startIconProp && /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.startIcon, classes["iconSize".concat((0, _capitalize.default)(size))])
	  }, startIconProp);
	  var endIcon = endIconProp && /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.endIcon, classes["iconSize".concat((0, _capitalize.default)(size))])
	  }, endIconProp);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[variant], className, color === 'inherit' ? classes.colorInherit : color !== 'default' && classes["".concat(variant).concat((0, _capitalize.default)(color))], size !== 'medium' && [classes["".concat(variant, "Size").concat((0, _capitalize.default)(size))], classes["size".concat((0, _capitalize.default)(size))]], disableElevation && classes.disableElevation, disabled && classes.disabled, fullWidth && classes.fullWidth),
	    component: component,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
	    ref: ref,
	    type: type
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, startIcon, children, endIcon));
	});
	 false ? Button.propTypes = {
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, no elevation is used.
	   */
	  disableElevation: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * Element placed after the children.
	   */
	  endIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * If `true`, the button will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * Element placed before the children.
	   */
	  startIcon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['text', 'outlined', 'contained'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButton'
	})(Button);
	
	exports.default = _default;

/***/ },
/* 235 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(29));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(57));
	
	var _TouchRipple = _interopRequireDefault(__webpack_require__(237));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    alignItems: 'center',
	    justifyContent: 'center',
	    position: 'relative',
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    textDecoration: 'none',
	    // So we take precedent over the style of a native <a /> element.
	    color: 'inherit',
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$disabled': {
	      pointerEvents: 'none',
	      // Disable link interactions
	      cursor: 'default'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if `disabled={true}`. */
	  disabled: {},
	
	  /* Pseudo-class applied to the root element if keyboard focused. */
	  focusVisible: {}
	};
	/**
	 * `ButtonBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating a button.
	 * It contains a load of style reset and some focus/ripple logic.
	 */
	
	exports.styles = styles;
	var ButtonBase = React.forwardRef(function ButtonBase(props, ref) {
	  var action = props.action,
	      buttonRefProp = props.buttonRef,
	      _props$centerRipple = props.centerRipple,
	      centerRipple = _props$centerRipple === void 0 ? false : _props$centerRipple,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$disableTouchRi = props.disableTouchRipple,
	      disableTouchRipple = _props$disableTouchRi === void 0 ? false : _props$disableTouchRi,
	      _props$focusRipple = props.focusRipple,
	      focusRipple = _props$focusRipple === void 0 ? false : _props$focusRipple,
	      focusVisibleClassName = props.focusVisibleClassName,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onFocusVisible = props.onFocusVisible,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      onMouseDown = props.onMouseDown,
	      onMouseLeave = props.onMouseLeave,
	      onMouseUp = props.onMouseUp,
	      onTouchEnd = props.onTouchEnd,
	      onTouchMove = props.onTouchMove,
	      onTouchStart = props.onTouchStart,
	      onDragLeave = props.onDragLeave,
	      _props$tabIndex = props.tabIndex,
	      tabIndex = _props$tabIndex === void 0 ? 0 : _props$tabIndex,
	      TouchRippleProps = props.TouchRippleProps,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'button' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "buttonRef", "centerRipple", "children", "classes", "className", "component", "disabled", "disableRipple", "disableTouchRipple", "focusRipple", "focusVisibleClassName", "onBlur", "onClick", "onFocus", "onFocusVisible", "onKeyDown", "onKeyUp", "onMouseDown", "onMouseLeave", "onMouseUp", "onTouchEnd", "onTouchMove", "onTouchStart", "onDragLeave", "tabIndex", "TouchRippleProps", "type"]);
	  var buttonRef = React.useRef(null);
	
	  function getButtonNode() {
	    // #StrictMode ready
	    return ReactDOM.findDOMNode(buttonRef.current);
	  }
	
	  var rippleRef = React.useRef(null);
	
	  var _React$useState = React.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  if (disabled && focusVisible) {
	    setFocusVisible(false);
	  }
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  React.useImperativeHandle(action, function () {
	    return {
	      focusVisible: function focusVisible() {
	        setFocusVisible(true);
	        buttonRef.current.focus();
	      }
	    };
	  }, []);
	  React.useEffect(function () {
	    if (focusVisible && focusRipple && !disableRipple) {
	      rippleRef.current.pulsate();
	    }
	  }, [disableRipple, focusRipple, focusVisible]);
	
	  function useRippleHandler(rippleAction, eventCallback) {
	    var skipRippleAction = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : disableTouchRipple;
	    return (0, _useEventCallback.default)(function (event) {
	      if (eventCallback) {
	        eventCallback(event);
	      }
	
	      var ignore = skipRippleAction;
	
	      if (!ignore && rippleRef.current) {
	        rippleRef.current[rippleAction](event);
	      }
	
	      return true;
	    });
	  }
	
	  var handleMouseDown = useRippleHandler('start', onMouseDown);
	  var handleDragLeave = useRippleHandler('stop', onDragLeave);
	  var handleMouseUp = useRippleHandler('stop', onMouseUp);
	  var handleMouseLeave = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      event.preventDefault();
	    }
	
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	  });
	  var handleTouchStart = useRippleHandler('start', onTouchStart);
	  var handleTouchEnd = useRippleHandler('stop', onTouchEnd);
	  var handleTouchMove = useRippleHandler('stop', onTouchMove);
	  var handleBlur = useRippleHandler('stop', function (event) {
	    if (focusVisible) {
	      onBlurVisible(event);
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  }, false);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    // Fix for https://github.com/facebook/react/issues/7769
	    if (!buttonRef.current) {
	      buttonRef.current = event.currentTarget;
	    }
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	
	      if (onFocusVisible) {
	        onFocusVisible(event);
	      }
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  });
	
	  var isNonNativeButton = function isNonNativeButton() {
	    var button = getButtonNode();
	    return component && component !== 'button' && !(button.tagName === 'A' && button.href);
	  };
	  /**
	   * IE 11 shim for https://developer.mozilla.org/en-US/docs/Web/API/KeyboardEvent/repeat
	   */
	
	
	  var keydownRef = React.useRef(false);
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    // Check if key is already down to avoid repeats being counted as multiple activations
	    if (focusRipple && !keydownRef.current && focusVisible && rippleRef.current && event.key === ' ') {
	      keydownRef.current = true;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.start(event);
	      });
	    }
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === ' ') {
	      event.preventDefault();
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (event.target === event.currentTarget && isNonNativeButton() && event.key === 'Enter' && !disabled) {
	      event.preventDefault();
	
	      if (onClick) {
	        onClick(event);
	      }
	    }
	  });
	  var handleKeyUp = (0, _useEventCallback.default)(function (event) {
	    // calling preventDefault in keyUp on a <button> will not dispatch a click event if Space is pressed
	    // https://codesandbox.io/s/button-keyup-preventdefault-dn7f0
	    if (focusRipple && event.key === ' ' && rippleRef.current && focusVisible && !event.defaultPrevented) {
	      keydownRef.current = false;
	      event.persist();
	      rippleRef.current.stop(event, function () {
	        rippleRef.current.pulsate(event);
	      });
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    } // Keyboard accessibility for non interactive elements
	
	
	    if (onClick && event.target === event.currentTarget && isNonNativeButton() && event.key === ' ' && !event.defaultPrevented) {
	      onClick(event);
	    }
	  });
	  var ComponentProp = component;
	
	  if (ComponentProp === 'button' && other.href) {
	    ComponentProp = 'a';
	  }
	
	  var buttonProps = {};
	
	  if (ComponentProp === 'button') {
	    buttonProps.type = type;
	    buttonProps.disabled = disabled;
	  } else {
	    if (ComponentProp !== 'a' || !other.href) {
	      buttonProps.role = 'button';
	    }
	
	    buttonProps['aria-disabled'] = disabled;
	  }
	
	  var handleUserRef = (0, _useForkRef.default)(buttonRefProp, ref);
	  var handleOwnRef = (0, _useForkRef.default)(focusVisibleRef, buttonRef);
	  var handleRef = (0, _useForkRef.default)(handleUserRef, handleOwnRef);
	
	  var _React$useState2 = React.useState(false),
	      mountedState = _React$useState2[0],
	      setMountedState = _React$useState2[1];
	
	  React.useEffect(function () {
	    setMountedState(true);
	  }, []);
	  var enableTouchRipple = mountedState && !disableRipple && !disabled;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (enableTouchRipple && !rippleRef.current) {
	        console.error(['Material-UI: the `component` prop provided to ButtonBase is invalid.', 'Please make sure the children prop is rendered in this custom component.'].join('\n'));
	      }
	    }, [enableTouchRipple]);
	  }
	
	  return /*#__PURE__*/React.createElement(ComponentProp, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, focusVisible && [classes.focusVisible, focusVisibleClassName], disabled && classes.disabled),
	    onBlur: handleBlur,
	    onClick: onClick,
	    onFocus: handleFocus,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    onMouseDown: handleMouseDown,
	    onMouseLeave: handleMouseLeave,
	    onMouseUp: handleMouseUp,
	    onDragLeave: handleDragLeave,
	    onTouchEnd: handleTouchEnd,
	    onTouchMove: handleTouchMove,
	    onTouchStart: handleTouchStart,
	    ref: handleRef,
	    tabIndex: disabled ? -1 : tabIndex
	  }, buttonProps, other), children, enableTouchRipple ?
	  /*#__PURE__*/
	
	  /* TouchRipple is only needed client-side, x2 boost on the server. */
	  React.createElement(_TouchRipple.default, (0, _extends2.default)({
	    ref: rippleRef,
	    center: centerRipple
	  }, TouchRippleProps)) : null);
	});
	 false ? ButtonBase.propTypes = {
	  /**
	   * A ref for imperative actions.
	   * It currently only supports `focusVisible()` action.
	   */
	  action: _utils.refType,
	
	  /**
	   * @ignore
	   *
	   * Use that prop to pass a ref to the native button component.
	   * @deprecated Use `ref` instead.
	   */
	  buttonRef: _utils.refType,
	
	  /**
	   * If `true`, the ripples will be centered.
	   * They won't start at the cursor interaction position.
	   */
	  centerRipple: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * If `true`, the base button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   *
	   * ⚠️ Without a ripple there is no styling for :focus-visible by default. Be sure
	   * to highlight the element by applying separate styles with the `focusVisibleClassName`.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the touch ripple effect will be disabled.
	   */
	  disableTouchRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the base button will have a keyboard focus ripple.
	   * `disableRipple` must also be `false`.
	   */
	  focusRipple: _propTypes.default.bool,
	
	  /**
	   * This prop can help a person know which element has the keyboard focus.
	   * The class name will be applied when the element gain the focus through a keyboard interaction.
	   * It's a polyfill for the [CSS :focus-visible selector](https://drafts.csswg.org/selectors-4/#the-focus-visible-pseudo).
	   * The rationale for using this feature [is explained here](https://github.com/WICG/focus-visible/blob/master/explainer.md).
	   * A [polyfill can be used](https://github.com/WICG/focus-visible) to apply a `focus-visible` class to other components
	   * if needed.
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onDragLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is focused with a keyboard.
	   * We trigger a `onFocus` callback too.
	   */
	  onFocusVisible: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseUp: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchEnd: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchMove: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onTouchStart: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Props applied to the `TouchRipple` element.
	   */
	  TouchRippleProps: _propTypes.default.object,
	
	  /**
	   * Used to control the button's purpose.
	   * This prop passes the value to the `type` attribute of the native button component.
	   */
	  type: _propTypes.default.oneOf(['submit', 'reset', 'button'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonBase'
	})(ButtonBase);
	
	exports.default = _default;

/***/ },
/* 236 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(29));
	
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * @ignore - internal component.
	 */
	
	function Ripple(props) {
	  var classes = props.classes,
	      _props$pulsate = props.pulsate,
	      pulsate = _props$pulsate === void 0 ? false : _props$pulsate,
	      rippleX = props.rippleX,
	      rippleY = props.rippleY,
	      rippleSize = props.rippleSize,
	      inProp = props.in,
	      _props$onExited = props.onExited,
	      onExited = _props$onExited === void 0 ? function () {} : _props$onExited,
	      timeout = props.timeout;
	
	  var _React$useState = React.useState(false),
	      leaving = _React$useState[0],
	      setLeaving = _React$useState[1];
	
	  var rippleClassName = (0, _clsx.default)(classes.ripple, classes.rippleVisible, pulsate && classes.ripplePulsate);
	  var rippleStyles = {
	    width: rippleSize,
	    height: rippleSize,
	    top: -(rippleSize / 2) + rippleY,
	    left: -(rippleSize / 2) + rippleX
	  };
	  var childClassName = (0, _clsx.default)(classes.child, leaving && classes.childLeaving, pulsate && classes.childPulsate);
	  var handleExited = (0, _useEventCallback.default)(onExited); // Ripple is used for user feedback (e.g. click or press) so we want to apply styles with the highest priority
	
	  useEnhancedEffect(function () {
	    if (!inProp) {
	      // react-transition-group#onExit
	      setLeaving(true); // react-transition-group#onExited
	
	      var timeoutId = setTimeout(handleExited, timeout);
	      return function () {
	        clearTimeout(timeoutId);
	      };
	    }
	
	    return undefined;
	  }, [handleExited, inProp, timeout]);
	  return /*#__PURE__*/React.createElement("span", {
	    className: rippleClassName,
	    style: rippleStyles
	  }, /*#__PURE__*/React.createElement("span", {
	    className: childClassName
	  }));
	}
	
	 false ? Ripple.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore - injected from TransitionGroup
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * If `true`, the ripple pulsates, typically indicating the keyboard focus state of an element.
	   */
	  pulsate: _propTypes.default.bool,
	
	  /**
	   * Diameter of the ripple.
	   */
	  rippleSize: _propTypes.default.number,
	
	  /**
	   * Horizontal position of the ripple center.
	   */
	  rippleX: _propTypes.default.number,
	
	  /**
	   * Vertical position of the ripple center.
	   */
	  rippleY: _propTypes.default.number,
	
	  /**
	   * exit delay
	   */
	  timeout: _propTypes.default.number.isRequired
	} : void 0;
	var _default = Ripple;
	exports.default = _default;

/***/ },
/* 237 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.DELAY_RIPPLE = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(46);
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Ripple = _interopRequireDefault(__webpack_require__(236));
	
	var DURATION = 550;
	var DELAY_RIPPLE = 80;
	exports.DELAY_RIPPLE = DELAY_RIPPLE;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      zIndex: 0,
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit'
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripple` class. */
	    ripple: {
	      opacity: 0,
	      position: 'absolute'
	    },
	
	    /* Styles applied to the internal `Ripple` components `rippleVisible` class. */
	    rippleVisible: {
	      opacity: 0.3,
	      transform: 'scale(1)',
	      animation: "$enter ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `ripplePulsate` class. */
	    ripplePulsate: {
	      animationDuration: "".concat(theme.transitions.duration.shorter, "ms")
	    },
	
	    /* Styles applied to the internal `Ripple` components `child` class. */
	    child: {
	      opacity: 1,
	      display: 'block',
	      width: '100%',
	      height: '100%',
	      borderRadius: '50%',
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the internal `Ripple` components `childLeaving` class. */
	    childLeaving: {
	      opacity: 0,
	      animation: "$exit ".concat(DURATION, "ms ").concat(theme.transitions.easing.easeInOut)
	    },
	
	    /* Styles applied to the internal `Ripple` components `childPulsate` class. */
	    childPulsate: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      animation: "$pulsate 2500ms ".concat(theme.transitions.easing.easeInOut, " 200ms infinite")
	    },
	    '@keyframes enter': {
	      '0%': {
	        transform: 'scale(0)',
	        opacity: 0.1
	      },
	      '100%': {
	        transform: 'scale(1)',
	        opacity: 0.3
	      }
	    },
	    '@keyframes exit': {
	      '0%': {
	        opacity: 1
	      },
	      '100%': {
	        opacity: 0
	      }
	    },
	    '@keyframes pulsate': {
	      '0%': {
	        transform: 'scale(1)'
	      },
	      '50%': {
	        transform: 'scale(0.92)'
	      },
	      '100%': {
	        transform: 'scale(1)'
	      }
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 *
	 * TODO v5: Make private
	 */
	
	
	exports.styles = styles;
	var TouchRipple = React.forwardRef(function TouchRipple(props, ref) {
	  var _props$center = props.center,
	      centerProp = _props$center === void 0 ? false : _props$center,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["center", "classes", "className"]);
	
	  var _React$useState = React.useState([]),
	      ripples = _React$useState[0],
	      setRipples = _React$useState[1];
	
	  var nextKey = React.useRef(0);
	  var rippleCallback = React.useRef(null);
	  React.useEffect(function () {
	    if (rippleCallback.current) {
	      rippleCallback.current();
	      rippleCallback.current = null;
	    }
	  }, [ripples]); // Used to filter out mouse emulated events on mobile.
	
	  var ignoringMouseDown = React.useRef(false); // We use a timer in order to only show the ripples for touch "click" like events.
	  // We don't want to display the ripple for touch scroll events.
	
	  var startTimer = React.useRef(null); // This is the hook called once the previous timeout is ready.
	
	  var startTimerCommit = React.useRef(null);
	  var container = React.useRef(null);
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(startTimer.current);
	    };
	  }, []);
	  var startCommit = React.useCallback(function (params) {
	    var pulsate = params.pulsate,
	        rippleX = params.rippleX,
	        rippleY = params.rippleY,
	        rippleSize = params.rippleSize,
	        cb = params.cb;
	    setRipples(function (oldRipples) {
	      return [].concat((0, _toConsumableArray2.default)(oldRipples), [/*#__PURE__*/React.createElement(_Ripple.default, {
	        key: nextKey.current,
	        classes: classes,
	        timeout: DURATION,
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize
	      })]);
	    });
	    nextKey.current += 1;
	    rippleCallback.current = cb;
	  }, [classes]);
	  var start = React.useCallback(function () {
	    var event = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var cb = arguments.length > 2 ? arguments[2] : undefined;
	    var _options$pulsate = options.pulsate,
	        pulsate = _options$pulsate === void 0 ? false : _options$pulsate,
	        _options$center = options.center,
	        center = _options$center === void 0 ? centerProp || options.pulsate : _options$center,
	        _options$fakeElement = options.fakeElement,
	        fakeElement = _options$fakeElement === void 0 ? false : _options$fakeElement;
	
	    if (event.type === 'mousedown' && ignoringMouseDown.current) {
	      ignoringMouseDown.current = false;
	      return;
	    }
	
	    if (event.type === 'touchstart') {
	      ignoringMouseDown.current = true;
	    }
	
	    var element = fakeElement ? null : container.current;
	    var rect = element ? element.getBoundingClientRect() : {
	      width: 0,
	      height: 0,
	      left: 0,
	      top: 0
	    }; // Get the size of the ripple
	
	    var rippleX;
	    var rippleY;
	    var rippleSize;
	
	    if (center || event.clientX === 0 && event.clientY === 0 || !event.clientX && !event.touches) {
	      rippleX = Math.round(rect.width / 2);
	      rippleY = Math.round(rect.height / 2);
	    } else {
	      var clientX = event.clientX ? event.clientX : event.touches[0].clientX;
	      var clientY = event.clientY ? event.clientY : event.touches[0].clientY;
	      rippleX = Math.round(clientX - rect.left);
	      rippleY = Math.round(clientY - rect.top);
	    }
	
	    if (center) {
	      rippleSize = Math.sqrt((2 * Math.pow(rect.width, 2) + Math.pow(rect.height, 2)) / 3); // For some reason the animation is broken on Mobile Chrome if the size if even.
	
	      if (rippleSize % 2 === 0) {
	        rippleSize += 1;
	      }
	    } else {
	      var sizeX = Math.max(Math.abs((element ? element.clientWidth : 0) - rippleX), rippleX) * 2 + 2;
	      var sizeY = Math.max(Math.abs((element ? element.clientHeight : 0) - rippleY), rippleY) * 2 + 2;
	      rippleSize = Math.sqrt(Math.pow(sizeX, 2) + Math.pow(sizeY, 2));
	    } // Touche devices
	
	
	    if (event.touches) {
	      // check that this isn't another touchstart due to multitouch
	      // otherwise we will only clear a single timer when unmounting while two
	      // are running
	      if (startTimerCommit.current === null) {
	        // Prepare the ripple effect.
	        startTimerCommit.current = function () {
	          startCommit({
	            pulsate: pulsate,
	            rippleX: rippleX,
	            rippleY: rippleY,
	            rippleSize: rippleSize,
	            cb: cb
	          });
	        }; // Delay the execution of the ripple effect.
	
	
	        startTimer.current = setTimeout(function () {
	          if (startTimerCommit.current) {
	            startTimerCommit.current();
	            startTimerCommit.current = null;
	          }
	        }, DELAY_RIPPLE); // We have to make a tradeoff with this value.
	      }
	    } else {
	      startCommit({
	        pulsate: pulsate,
	        rippleX: rippleX,
	        rippleY: rippleY,
	        rippleSize: rippleSize,
	        cb: cb
	      });
	    }
	  }, [centerProp, startCommit]);
	  var pulsate = React.useCallback(function () {
	    start({}, {
	      pulsate: true
	    });
	  }, [start]);
	  var stop = React.useCallback(function (event, cb) {
	    clearTimeout(startTimer.current); // The touch interaction occurs too quickly.
	    // We still want to show ripple effect.
	
	    if (event.type === 'touchend' && startTimerCommit.current) {
	      event.persist();
	      startTimerCommit.current();
	      startTimerCommit.current = null;
	      startTimer.current = setTimeout(function () {
	        stop(event, cb);
	      });
	      return;
	    }
	
	    startTimerCommit.current = null;
	    setRipples(function (oldRipples) {
	      if (oldRipples.length > 0) {
	        return oldRipples.slice(1);
	      }
	
	      return oldRipples;
	    });
	    rippleCallback.current = cb;
	  }, []);
	  React.useImperativeHandle(ref, function () {
	    return {
	      pulsate: pulsate,
	      start: start,
	      stop: stop
	    };
	  }, [pulsate, start, stop]);
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: container
	  }, other), /*#__PURE__*/React.createElement(_reactTransitionGroup.TransitionGroup, {
	    component: null,
	    exit: true
	  }, ripples));
	});
	 false ? TouchRipple.propTypes = {
	  /**
	   * If `true`, the ripple starts at the center of the component
	   * rather than at the point of interaction.
	   */
	  center: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiTouchRipple'
	})(React.memo(TouchRipple));
	
	exports.default = _default;

/***/ },
/* 238 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(18);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Button = _interopRequireDefault(__webpack_require__(34));
	
	// Force a side effect so we don't have any override priority issue.
	// eslint-disable-next-line no-unused-expressions
	_Button.default.styles;
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="contained"`. */
	    contained: {
	      boxShadow: theme.shadows[2]
	    },
	
	    /* Pseudo-class applied to child elements if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the children. */
	    grouped: {
	      minWidth: 40
	    },
	
	    /* Styles applied to the children if `orientation="horizontal"`. */
	    groupedHorizontal: {
	      '&:not(:first-child)': {
	        borderTopLeftRadius: 0,
	        borderBottomLeftRadius: 0
	      },
	      '&:not(:last-child)': {
	        borderTopRightRadius: 0,
	        borderBottomRightRadius: 0
	      }
	    },
	
	    /* Styles applied to the children if `orientation="vertical"`. */
	    groupedVertical: {
	      '&:not(:first-child)': {
	        borderTopRightRadius: 0,
	        borderTopLeftRadius: 0
	      },
	      '&:not(:last-child)': {
	        borderBottomRightRadius: 0,
	        borderBottomLeftRadius: 0
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"`. */
	    groupedText: {},
	
	    /* Styles applied to the children if `variant="text"` and `orientation="horizontal"`. */
	    groupedTextHorizontal: {
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `orientation="vertical"`. */
	    groupedTextVertical: {
	      '&:not(:last-child)': {
	        borderBottom: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)')
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `color="primary"`. */
	    groupedTextPrimary: {
	      '&:not(:last-child)': {
	        borderColor: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.5)
	      }
	    },
	
	    /* Styles applied to the children if `variant="text"` and `color="secondary"`. */
	    groupedTextSecondary: {
	      '&:not(:last-child)': {
	        borderColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.5)
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"`. */
	    groupedOutlined: {},
	
	    /* Styles applied to the children if `variant="outlined"` and `orientation="horizontal"`. */
	    groupedOutlinedHorizontal: {
	      '&:not(:first-child)': {
	        marginLeft: -1
	      },
	      '&:not(:last-child)': {
	        borderRightColor: 'transparent'
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `orientation="vertical"`. */
	    groupedOutlinedVertical: {
	      '&:not(:first-child)': {
	        marginTop: -1
	      },
	      '&:not(:last-child)': {
	        borderBottomColor: 'transparent'
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `color="primary"`. */
	    groupedOutlinedPrimary: {
	      '&:hover': {
	        borderColor: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the children if `variant="outlined"` and `color="secondary"`. */
	    groupedOutlinedSecondary: {
	      '&:hover': {
	        borderColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"`. */
	    groupedContained: {
	      boxShadow: 'none'
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `orientation="horizontal"`. */
	    groupedContainedHorizontal: {
	      '&:not(:last-child)': {
	        borderRight: "1px solid ".concat(theme.palette.grey[400]),
	        '&$disabled': {
	          borderRight: "1px solid ".concat(theme.palette.action.disabled)
	        }
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `orientation="vertical"`. */
	    groupedContainedVertical: {
	      '&:not(:last-child)': {
	        borderBottom: "1px solid ".concat(theme.palette.grey[400]),
	        '&$disabled': {
	          borderBottom: "1px solid ".concat(theme.palette.action.disabled)
	        }
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `color="primary"`. */
	    groupedContainedPrimary: {
	      '&:not(:last-child)': {
	        borderColor: theme.palette.primary.dark
	      }
	    },
	
	    /* Styles applied to the children if `variant="contained"` and `color="secondary"`. */
	    groupedContainedSecondary: {
	      '&:not(:last-child)': {
	        borderColor: theme.palette.secondary.dark
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var ButtonGroup = React.forwardRef(function ButtonGroup(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$disableRipple = props.disableRipple,
	      disableRipple = _props$disableRipple === void 0 ? false : _props$disableRipple,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'outlined' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "disableRipple", "fullWidth", "orientation", "size", "variant"]);
	  var buttonClassName = (0, _clsx.default)(classes.grouped, classes["grouped".concat((0, _capitalize.default)(orientation))], classes["grouped".concat((0, _capitalize.default)(variant))], classes["grouped".concat((0, _capitalize.default)(variant)).concat((0, _capitalize.default)(orientation))], classes["grouped".concat((0, _capitalize.default)(variant)).concat(color !== 'default' ? (0, _capitalize.default)(color) : '')], disabled && classes.disabled);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: "group",
	    className: (0, _clsx.default)(classes.root, className, fullWidth && classes.fullWidth, variant === 'contained' && classes.contained, orientation === 'vertical' && classes.vertical),
	    ref: ref
	  }, other), React.Children.map(children, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the ButtonGroup component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return React.cloneElement(child, {
	      className: (0, _clsx.default)(buttonClassName, child.props.className),
	      disabled: child.props.disabled || disabled,
	      color: child.props.color || color,
	      disableFocusRipple: disableFocusRipple,
	      disableRipple: disableRipple,
	      fullWidth: fullWidth,
	      size: child.props.size || size,
	      variant: child.props.variant || variant
	    });
	  }));
	});
	 false ? ButtonGroup.propTypes = {
	  /**
	   * The content of the button group.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the buttons will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the button keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the button ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the buttons will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The group orientation.
	   */
	  orientation: _propTypes.default.oneOf(['vertical', 'horizontal']),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['text', 'outlined', 'contained'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiButtonGroup'
	})(ButtonGroup);
	
	exports.default = _default;

/***/ },
/* 239 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    overflow: 'hidden'
	  }
	};
	exports.styles = styles;
	var Card = React.forwardRef(function Card(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$raised = props.raised,
	      raised = _props$raised === void 0 ? false : _props$raised,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "raised"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    elevation: raised ? 8 : 1,
	    ref: ref
	  }, other));
	});
	 false ? Card.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the card will use raised styling.
	   */
	  raised: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCard'
	})(Card);
	
	exports.default = _default;

/***/ },
/* 240 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Card.default;
	  }
	});
	
	var _Card = _interopRequireDefault(__webpack_require__(239));

/***/ },
/* 241 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      textAlign: 'inherit',
	      width: '100%',
	      '&:hover $focusHighlight': {
	        opacity: theme.palette.action.hoverOpacity
	      },
	      '&$focusVisible $focusHighlight': {
	        opacity: 0.12
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the action area is keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the overlay that covers the action area when it is keyboard focused. */
	    focusHighlight: {
	      overflow: 'hidden',
	      pointerEvents: 'none',
	      position: 'absolute',
	      top: 0,
	      right: 0,
	      bottom: 0,
	      left: 0,
	      borderRadius: 'inherit',
	      opacity: 0,
	      backgroundColor: 'currentcolor',
	      transition: theme.transitions.create('opacity', {
	        duration: theme.transitions.duration.short
	      })
	    }
	  };
	};
	
	exports.styles = styles;
	var CardActionArea = React.forwardRef(function CardActionArea(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      focusVisibleClassName = props.focusVisibleClassName,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "focusVisibleClassName"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    focusVisibleClassName: (0, _clsx.default)(focusVisibleClassName, classes.focusVisible),
	    ref: ref
	  }, other), children, /*#__PURE__*/React.createElement("span", {
	    className: classes.focusHighlight
	  }));
	});
	 false ? CardActionArea.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActionArea'
	})(CardActionArea);
	
	exports.default = _default;

/***/ },
/* 242 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardActionArea.default;
	  }
	});
	
	var _CardActionArea = _interopRequireDefault(__webpack_require__(241));

/***/ },
/* 243 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var CardActions = React.forwardRef(function CardActions(props, ref) {
	  var _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableSpacing", "classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? CardActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardActions'
	})(CardActions);
	
	exports.default = _default;

/***/ },
/* 244 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardActions.default;
	  }
	});
	
	var _CardActions = _interopRequireDefault(__webpack_require__(243));

/***/ },
/* 245 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    padding: 16,
	    '&:last-child': {
	      paddingBottom: 24
	    }
	  }
	};
	exports.styles = styles;
	var CardContent = React.forwardRef(function CardContent(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? CardContent.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardContent'
	})(CardContent);
	
	exports.default = _default;

/***/ },
/* 246 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardContent.default;
	  }
	});
	
	var _CardContent = _interopRequireDefault(__webpack_require__(245));

/***/ },
/* 247 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 16
	  },
	
	  /* Styles applied to the avatar element. */
	  avatar: {
	    flex: '0 0 auto',
	    marginRight: 16
	  },
	
	  /* Styles applied to the action element. */
	  action: {
	    flex: '0 0 auto',
	    alignSelf: 'flex-start',
	    marginTop: -8,
	    marginRight: -8
	  },
	
	  /* Styles applied to the content wrapper element. */
	  content: {
	    flex: '1 1 auto'
	  },
	
	  /* Styles applied to the title Typography element. */
	  title: {},
	
	  /* Styles applied to the subheader Typography element. */
	  subheader: {}
	};
	exports.styles = styles;
	var CardHeader = React.forwardRef(function CardHeader(props, ref) {
	  var action = props.action,
	      avatar = props.avatar,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      subheaderProp = props.subheader,
	      subheaderTypographyProps = props.subheaderTypographyProps,
	      titleProp = props.title,
	      titleTypographyProps = props.titleTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "avatar", "classes", "className", "component", "disableTypography", "subheader", "subheaderTypographyProps", "title", "titleTypographyProps"]);
	  var title = titleProp;
	
	  if (title != null && title.type !== _Typography.default && !disableTypography) {
	    title = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: avatar ? 'body2' : 'h5',
	      className: classes.title,
	      component: "span",
	      display: "block"
	    }, titleTypographyProps), title);
	  }
	
	  var subheader = subheaderProp;
	
	  if (subheader != null && subheader.type !== _Typography.default && !disableTypography) {
	    subheader = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: avatar ? 'body2' : 'body1',
	      className: classes.subheader,
	      color: "textSecondary",
	      component: "span",
	      display: "block"
	    }, subheaderTypographyProps), subheader);
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), avatar && /*#__PURE__*/React.createElement("div", {
	    className: classes.avatar
	  }, avatar), /*#__PURE__*/React.createElement("div", {
	    className: classes.content
	  }, title, subheader), action && /*#__PURE__*/React.createElement("div", {
	    className: classes.action
	  }, action));
	});
	 false ? CardHeader.propTypes = {
	  /**
	   * The action to display in the card header.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The Avatar for the Card Header.
	   */
	  avatar: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, `subheader` and `title` won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `title` text, and optional `subheader` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  subheader: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the subheader
	   * (as long as disableTypography is not `true`).
	   */
	  subheaderTypographyProps: _propTypes.default.object,
	
	  /**
	   * The content of the Card Title.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the title
	   * (as long as disableTypography is not `true`).
	   */
	  titleTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardHeader'
	})(CardHeader);
	
	exports.default = _default;

/***/ },
/* 248 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardHeader.default;
	  }
	});
	
	var _CardHeader = _interopRequireDefault(__webpack_require__(247));

/***/ },
/* 249 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _utils = __webpack_require__(9);
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'block',
	    backgroundSize: 'cover',
	    backgroundRepeat: 'no-repeat',
	    backgroundPosition: 'center'
	  },
	
	  /* Styles applied to the root element if `component="video, audio, picture, iframe, or img"`. */
	  media: {
	    width: '100%'
	  },
	
	  /* Styles applied to the root element if `component="picture or img"`. */
	  img: {
	    // ⚠️ object-fit is not supported by IE 11.
	    objectFit: 'cover'
	  }
	};
	exports.styles = styles;
	var MEDIA_COMPONENTS = ['video', 'audio', 'picture', 'iframe', 'img'];
	var CardMedia = React.forwardRef(function CardMedia(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      image = props.image,
	      src = props.src,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "image", "src", "style"]);
	  var isMediaComponent = MEDIA_COMPONENTS.indexOf(Component) !== -1;
	  var composedStyle = !isMediaComponent && image ? (0, _extends2.default)({
	    backgroundImage: "url(\"".concat(image, "\")")
	  }, style) : style;
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, isMediaComponent && classes.media, "picture img".indexOf(Component) !== -1 && classes.img),
	    ref: ref,
	    style: composedStyle,
	    src: isMediaComponent ? image || src : undefined
	  }, other), children);
	});
	 false ? CardMedia.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    if (!props.children && !props.image && !props.src && !props.component) {
	      return new Error('Material-UI: either `children`, `image`, `src` or `component` prop must be specified.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Component for rendering image.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Image to be displayed as a background image.
	   * Either `image` or `src` prop must be specified.
	   * Note that caller must specify height otherwise the image will not be visible.
	   */
	  image: _propTypes.default.string,
	
	  /**
	   * An alias for `image` property.
	   * Available only with media components.
	   * Media components: `video`, `audio`, `picture`, `iframe`, `img`.
	   */
	  src: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCardMedia'
	})(CardMedia);
	
	exports.default = _default;

/***/ },
/* 250 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CardMedia.default;
	  }
	});
	
	var _CardMedia = _interopRequireDefault(__webpack_require__(249));

/***/ },
/* 251 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(88));
	
	var _CheckBoxOutlineBlank = _interopRequireDefault(__webpack_require__(422));
	
	var _CheckBox = _interopRequireDefault(__webpack_require__(421));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _IndeterminateCheckBox = _interopRequireDefault(__webpack_require__(424));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Pseudo-class applied to the root element if `checked={true}`. */
	    checked: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `indeterminate={true}`. */
	    indeterminate: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultCheckedIcon = /*#__PURE__*/React.createElement(_CheckBox.default, null);
	var defaultIcon = /*#__PURE__*/React.createElement(_CheckBoxOutlineBlank.default, null);
	var defaultIndeterminateIcon = /*#__PURE__*/React.createElement(_IndeterminateCheckBox.default, null);
	var Checkbox = React.forwardRef(function Checkbox(props, ref) {
	  var _props$checkedIcon = props.checkedIcon,
	      checkedIcon = _props$checkedIcon === void 0 ? defaultCheckedIcon : _props$checkedIcon,
	      classes = props.classes,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      _props$icon = props.icon,
	      icon = _props$icon === void 0 ? defaultIcon : _props$icon,
	      _props$indeterminate = props.indeterminate,
	      indeterminate = _props$indeterminate === void 0 ? false : _props$indeterminate,
	      _props$indeterminateI = props.indeterminateIcon,
	      indeterminateIcon = _props$indeterminateI === void 0 ? defaultIndeterminateIcon : _props$indeterminateI,
	      inputProps = props.inputProps,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["checkedIcon", "classes", "color", "icon", "indeterminate", "indeterminateIcon", "inputProps", "size"]);
	  return /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    classes: {
	      root: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], indeterminate && classes.indeterminate),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    color: color,
	    inputProps: (0, _extends2.default)({
	      'data-indeterminate': indeterminate
	    }, inputProps),
	    icon: React.cloneElement(indeterminate ? indeterminateIcon : icon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    checkedIcon: React.cloneElement(indeterminate ? indeterminateIcon : checkedIcon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    ref: ref
	  }, other));
	});
	 false ? Checkbox.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the checkbox will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the component appears indeterminate.
	   * This does not set the native input element to indeterminate due
	   * to inconsistent behavior across browsers.
	   * However, we set a `data-indeterminate` attribute on the input.
	   */
	  indeterminate: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is indeterminate.
	   */
	  indeterminateIcon: _propTypes.default.node,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the checkbox.
	   * `small` is equivalent to the dense checkbox styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   * The browser uses "on" as the default value.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCheckbox'
	})(Checkbox);
	
	exports.default = _default;

/***/ },
/* 252 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Checkbox.default;
	  }
	});
	
	var _Checkbox = _interopRequireDefault(__webpack_require__(251));

/***/ },
/* 253 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _Cancel = _interopRequireDefault(__webpack_require__(420));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(67));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var styles = function styles(theme) {
	  var backgroundColor = theme.palette.type === 'light' ? theme.palette.grey[300] : theme.palette.grey[700];
	  var deleteIconColor = (0, _colorManipulator.fade)(theme.palette.text.primary, 0.26);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      fontFamily: theme.typography.fontFamily,
	      fontSize: theme.typography.pxToRem(13),
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      height: 32,
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      borderRadius: 32 / 2,
	      whiteSpace: 'nowrap',
	      transition: theme.transitions.create(['background-color', 'box-shadow']),
	      // label will inherit this from root, then `clickable` class overrides this for both
	      cursor: 'default',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      textDecoration: 'none',
	      border: 'none',
	      // Remove `button` border
	      padding: 0,
	      // Remove `button` padding
	      verticalAlign: 'middle',
	      boxSizing: 'border-box',
	      '&$disabled': {
	        opacity: 0.5,
	        pointerEvents: 'none'
	      },
	      '& $avatar': {
	        marginLeft: 5,
	        marginRight: -6,
	        width: 24,
	        height: 24,
	        color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	        fontSize: theme.typography.pxToRem(12)
	      },
	      '& $avatarColorPrimary': {
	        color: theme.palette.primary.contrastText,
	        backgroundColor: theme.palette.primary.dark
	      },
	      '& $avatarColorSecondary': {
	        color: theme.palette.secondary.contrastText,
	        backgroundColor: theme.palette.secondary.dark
	      },
	      '& $avatarSmall': {
	        marginLeft: 4,
	        marginRight: -4,
	        width: 18,
	        height: 18,
	        fontSize: theme.typography.pxToRem(10)
	      }
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      height: 24
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main,
	      color: theme.palette.primary.contrastText
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main,
	      color: theme.palette.secondary.contrastText
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `onClick` is defined or `clickable={true}`. */
	    clickable: {
	      userSelect: 'none',
	      WebkitTapHighlightColor: 'transparent',
	      cursor: 'pointer',
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      },
	      '&:active': {
	        boxShadow: theme.shadows[1]
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="primary"` is defined or `clickable={true}`. */
	    clickableColorPrimary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onClick` and `color="secondary"` is defined or `clickable={true}`. */
	    clickableColorSecondary: {
	      '&:hover, &:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` is defined. */
	    deletable: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(backgroundColor, 0.08)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="primary"` is defined. */
	    deletableColorPrimary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.primary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `onDelete` and `color="secondary"` is defined. */
	    deletableColorSecondary: {
	      '&:focus': {
	        backgroundColor: (0, _colorManipulator.emphasize)(theme.palette.secondary.main, 0.2)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      backgroundColor: 'transparent',
	      border: "1px solid ".concat(theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)'),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.text.primary, theme.palette.action.hoverOpacity)
	      },
	      '& $avatar': {
	        marginLeft: 4
	      },
	      '& $avatarSmall': {
	        marginLeft: 2
	      },
	      '& $icon': {
	        marginLeft: 4
	      },
	      '& $iconSmall': {
	        marginLeft: 2
	      },
	      '& $deleteIcon': {
	        marginRight: 5
	      },
	      '& $deleteIconSmall': {
	        marginRight: 3
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="primary"`. */
	    outlinedPrimary: {
	      color: theme.palette.primary.main,
	      border: "1px solid ".concat(theme.palette.primary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` and `color="secondary"`. */
	    outlinedSecondary: {
	      color: theme.palette.secondary.main,
	      border: "1px solid ".concat(theme.palette.secondary.main),
	      '$clickable&:hover, $clickable&:focus, $deletable&:focus': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity)
	      }
	    },
	    // TODO v5: remove
	
	    /* Styles applied to the `avatar` element. */
	    avatar: {},
	
	    /* Styles applied to the `avatar` element if `size="small"`. */
	    avatarSmall: {},
	
	    /* Styles applied to the `avatar` element if `color="primary"`. */
	    avatarColorPrimary: {},
	
	    /* Styles applied to the `avatar` element if `color="secondary"`. */
	    avatarColorSecondary: {},
	
	    /* Styles applied to the `icon` element. */
	    icon: {
	      color: theme.palette.type === 'light' ? theme.palette.grey[700] : theme.palette.grey[300],
	      marginLeft: 5,
	      marginRight: -6
	    },
	
	    /* Styles applied to the `icon` element if `size="small"`. */
	    iconSmall: {
	      width: 18,
	      height: 18,
	      marginLeft: 4,
	      marginRight: -4
	    },
	
	    /* Styles applied to the `icon` element if `color="primary"`. */
	    iconColorPrimary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the `icon` element if `color="secondary"`. */
	    iconColorSecondary: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the label `span` element. */
	    label: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      paddingLeft: 12,
	      paddingRight: 12,
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the label `span` element if `size="small"`. */
	    labelSmall: {
	      paddingLeft: 8,
	      paddingRight: 8
	    },
	
	    /* Styles applied to the `deleteIcon` element. */
	    deleteIcon: {
	      WebkitTapHighlightColor: 'transparent',
	      color: deleteIconColor,
	      height: 22,
	      width: 22,
	      cursor: 'pointer',
	      margin: '0 5px 0 -6px',
	      '&:hover': {
	        color: (0, _colorManipulator.fade)(deleteIconColor, 0.4)
	      }
	    },
	
	    /* Styles applied to the `deleteIcon` element if `size="small"`. */
	    deleteIconSmall: {
	      height: 16,
	      width: 16,
	      marginRight: 4,
	      marginLeft: -4
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="default"`. */
	    deleteIconColorPrimary: {
	      color: (0, _colorManipulator.fade)(theme.palette.primary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="default"`. */
	    deleteIconColorSecondary: {
	      color: (0, _colorManipulator.fade)(theme.palette.secondary.contrastText, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.contrastText
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="primary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorPrimary: {
	      color: (0, _colorManipulator.fade)(theme.palette.primary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.primary.main
	      }
	    },
	
	    /* Styles applied to the deleteIcon element if `color="secondary"` and `variant="outlined"`. */
	    deleteIconOutlinedColorSecondary: {
	      color: (0, _colorManipulator.fade)(theme.palette.secondary.main, 0.7),
	      '&:hover, &:active': {
	        color: theme.palette.secondary.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function isDeleteKeyboardEvent(keyboardEvent) {
	  return keyboardEvent.key === 'Backspace' || keyboardEvent.key === 'Delete';
	}
	/**
	 * Chips represent complex entities in small blocks, such as a contact.
	 */
	
	
	var Chip = React.forwardRef(function Chip(props, ref) {
	  var avatarProp = props.avatar,
	      classes = props.classes,
	      className = props.className,
	      clickableProp = props.clickable,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      ComponentProp = props.component,
	      deleteIconProp = props.deleteIcon,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      iconProp = props.icon,
	      label = props.label,
	      onClick = props.onClick,
	      onDelete = props.onDelete,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'default' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["avatar", "classes", "className", "clickable", "color", "component", "deleteIcon", "disabled", "icon", "label", "onClick", "onDelete", "onKeyDown", "onKeyUp", "size", "variant"]);
	  var chipRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(chipRef, ref);
	
	  var handleDeleteIconClick = function handleDeleteIconClick(event) {
	    // Stop the event from bubbling up to the `Chip`
	    event.stopPropagation();
	
	    if (onDelete) {
	      onDelete(event);
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // Ignore events from children of `Chip`.
	    if (event.currentTarget === event.target && isDeleteKeyboardEvent(event)) {
	      // will be handled in keyUp, otherwise some browsers
	      // might init navigation
	      event.preventDefault();
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleKeyUp = function handleKeyUp(event) {
	    // Ignore events from children of `Chip`.
	    if (event.currentTarget === event.target) {
	      if (onDelete && isDeleteKeyboardEvent(event)) {
	        onDelete(event);
	      } else if (event.key === 'Escape' && chipRef.current) {
	        chipRef.current.blur();
	      }
	    }
	
	    if (onKeyUp) {
	      onKeyUp(event);
	    }
	  };
	
	  var clickable = clickableProp !== false && onClick ? true : clickableProp;
	  var small = size === 'small';
	  var Component = ComponentProp || (clickable ? _ButtonBase.default : 'div');
	  var moreProps = Component === _ButtonBase.default ? {
	    component: 'div'
	  } : {};
	  var deleteIcon = null;
	
	  if (onDelete) {
	    var customClasses = (0, _clsx.default)(color !== 'default' && (variant === "default" ? classes["deleteIconColor".concat((0, _capitalize.default)(color))] : classes["deleteIconOutlinedColor".concat((0, _capitalize.default)(color))]), small && classes.deleteIconSmall);
	    deleteIcon = deleteIconProp && React.isValidElement(deleteIconProp) ? React.cloneElement(deleteIconProp, {
	      className: (0, _clsx.default)(deleteIconProp.props.className, classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    }) : /*#__PURE__*/React.createElement(_Cancel.default, {
	      className: (0, _clsx.default)(classes.deleteIcon, customClasses),
	      onClick: handleDeleteIconClick
	    });
	  }
	
	  var avatar = null;
	
	  if (avatarProp && React.isValidElement(avatarProp)) {
	    avatar = React.cloneElement(avatarProp, {
	      className: (0, _clsx.default)(classes.avatar, avatarProp.props.className, small && classes.avatarSmall, color !== 'default' && classes["avatarColor".concat((0, _capitalize.default)(color))])
	    });
	  }
	
	  var icon = null;
	
	  if (iconProp && React.isValidElement(iconProp)) {
	    icon = React.cloneElement(iconProp, {
	      className: (0, _clsx.default)(classes.icon, iconProp.props.className, small && classes.iconSmall, color !== 'default' && classes["iconColor".concat((0, _capitalize.default)(color))])
	    });
	  }
	
	  if (false) {
	    if (avatar && icon) {
	      console.error('Material-UI: the Chip component can not handle the avatar ' + 'and the icon prop at the same time. Pick one.');
	    }
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: clickable || onDelete ? 'button' : undefined,
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && [classes["color".concat((0, _capitalize.default)(color))], clickable && classes["clickableColor".concat((0, _capitalize.default)(color))], onDelete && classes["deletableColor".concat((0, _capitalize.default)(color))]], variant !== "default" && [classes.outlined, {
	      'primary': classes.outlinedPrimary,
	      'secondary': classes.outlinedSecondary
	    }[color]], disabled && classes.disabled, small && classes.sizeSmall, clickable && classes.clickable, onDelete && classes.deletable),
	    "aria-disabled": disabled ? true : undefined,
	    tabIndex: clickable || onDelete ? 0 : undefined,
	    onClick: onClick,
	    onKeyDown: handleKeyDown,
	    onKeyUp: handleKeyUp,
	    ref: handleRef
	  }, moreProps, other), avatar || icon, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.label, small && classes.labelSmall)
	  }, label), deleteIcon);
	});
	 false ? Chip.propTypes = {
	  /**
	   * Avatar element.
	   */
	  avatar: _propTypes.default.element,
	
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the chip will appear clickable, and will raise when pressed,
	   * even if the onClick prop is not defined.
	   * If false, the chip will not be clickable, even if onClick prop is defined.
	   * This can be used, for example,
	   * along with the component prop to indicate an anchor Chip is clickable.
	   */
	  clickable: _propTypes.default.bool,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Override the default delete icon element. Shown only if `onDelete` is set.
	   */
	  deleteIcon: _propTypes.default.element,
	
	  /**
	   * If `true`, the chip should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Icon element.
	   */
	  icon: _propTypes.default.element,
	
	  /**
	   * The content of the label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * Callback function fired when the delete icon is clicked.
	   * If set, the delete icon will be shown.
	   */
	  onDelete: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The size of the chip.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['default', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiChip'
	})(Chip);
	
	exports.default = _default;

/***/ },
/* 254 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var SIZE = 44;
	
	function getRelativeValue(value, min, max) {
	  return (Math.min(Math.max(min, value), max) - min) / (max - min);
	}
	
	function easeOut(t) {
	  t = getRelativeValue(t, 0, 1); // https://gist.github.com/gre/1650294
	
	  t = (t -= 1) * t * t + 1;
	  return t;
	}
	
	function easeIn(t) {
	  return t * t;
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-block'
	    },
	
	    /* Styles applied to the root element if `variant="static"`. */
	    static: {
	      transition: theme.transitions.create('transform')
	    },
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {
	      animation: '$circular-rotate 1.4s linear infinite'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the `svg` element. */
	    svg: {
	      display: 'block' // Keeps the progress centered
	
	    },
	
	    /* Styles applied to the `circle` svg path. */
	    circle: {
	      stroke: 'currentColor' // Use butt to follow the specification, by chance, it's already the default CSS value.
	      // strokeLinecap: 'butt',
	
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="static"`. */
	    circleStatic: {
	      transition: theme.transitions.create('stroke-dashoffset')
	    },
	
	    /* Styles applied to the `circle` svg path if `variant="indeterminate"`. */
	    circleIndeterminate: {
	      animation: '$circular-dash 1.4s ease-in-out infinite',
	      // Some default value that looks fine waiting for the animation to kicks in.
	      strokeDasharray: '80px, 200px',
	      strokeDashoffset: '0px' // Add the unit to fix a Edge 16 and below bug.
	
	    },
	    '@keyframes circular-rotate': {
	      '100%': {
	        transform: 'rotate(360deg)'
	      }
	    },
	    '@keyframes circular-dash': {
	      '0%': {
	        strokeDasharray: '1px, 200px',
	        strokeDashoffset: '0px'
	      },
	      '50%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-15px'
	      },
	      '100%': {
	        strokeDasharray: '100px, 200px',
	        strokeDashoffset: '-125px'
	      }
	    },
	
	    /* Styles applied to the `circle` svg path if `disableShrink={true}`. */
	    circleDisableShrink: {
	      animation: 'none'
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	var CircularProgress = React.forwardRef(function CircularProgress(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$disableShrink = props.disableShrink,
	      disableShrink = _props$disableShrink === void 0 ? false : _props$disableShrink,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 40 : _props$size,
	      style = props.style,
	      _props$thickness = props.thickness,
	      thickness = _props$thickness === void 0 ? 3.6 : _props$thickness,
	      _props$value = props.value,
	      value = _props$value === void 0 ? 0 : _props$value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "disableShrink", "size", "style", "thickness", "value", "variant"]);
	  var circleStyle = {};
	  var rootStyle = {};
	  var rootProps = {};
	
	  if (variant === 'determinate' || variant === 'static') {
	    var circumference = 2 * Math.PI * ((SIZE - thickness) / 2);
	    circleStyle.strokeDasharray = circumference.toFixed(3);
	    rootProps['aria-valuenow'] = Math.round(value);
	
	    if (variant === 'static') {
	      circleStyle.strokeDashoffset = "".concat(((100 - value) / 100 * circumference).toFixed(3), "px");
	      rootStyle.transform = 'rotate(-90deg)';
	    } else {
	      circleStyle.strokeDashoffset = "".concat((easeIn((100 - value) / 100) * circumference).toFixed(3), "px");
	      rootStyle.transform = "rotate(".concat((easeOut(value / 70) * 270).toFixed(3), "deg)");
	    }
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], {
	      'indeterminate': classes.indeterminate,
	      'static': classes.static
	    }[variant]),
	    style: (0, _extends2.default)({
	      width: size,
	      height: size
	    }, rootStyle, {}, style),
	    ref: ref,
	    role: "progressbar"
	  }, rootProps, other), /*#__PURE__*/React.createElement("svg", {
	    className: classes.svg,
	    viewBox: "".concat(SIZE / 2, " ").concat(SIZE / 2, " ").concat(SIZE, " ").concat(SIZE)
	  }, /*#__PURE__*/React.createElement("circle", {
	    className: (0, _clsx.default)(classes.circle, disableShrink && classes.circleDisableShrink, {
	      'indeterminate': classes.circleIndeterminate,
	      'static': classes.circleStatic
	    }[variant]),
	    style: circleStyle,
	    cx: SIZE,
	    cy: SIZE,
	    r: (SIZE - thickness) / 2,
	    fill: "none",
	    strokeWidth: thickness
	  })));
	});
	 false ? CircularProgress.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the shrink animation is disabled.
	   * This only works if variant is `indeterminate`.
	   */
	  disableShrink: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	    if (props.disableShrink && props.variant && props.variant !== 'indeterminate') {
	      return new Error('Material-UI: you have provided the `disableShrink` prop ' + 'with a variant other than `indeterminate`. This will have no effect.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * The size of the circle.
	   * If using a number, the pixel unit is assumed.
	   * If using a string, you need to provide the CSS unit, e.g '3rem'.
	   */
	  size: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The thickness of the circle.
	   */
	  thickness: _propTypes.default.number,
	
	  /**
	   * The value of the progress indicator for the determinate and static variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['determinate', 'indeterminate', 'static'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCircularProgress',
	  flip: false
	})(CircularProgress);
	
	exports.default = _default;

/***/ },
/* 255 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CircularProgress.default;
	  }
	});
	
	var _CircularProgress = _interopRequireDefault(__webpack_require__(254));

/***/ },
/* 256 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(27));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(29));
	
	var _utils = __webpack_require__(9);
	
	function mapEventPropToEvent(eventProp) {
	  return eventProp.substring(2).toLowerCase();
	}
	/**
	 * Listen for click events that occur somewhere in the document, outside of the element itself.
	 * For instance, if you need to hide a menu when people click anywhere else on your page.
	 */
	
	
	function ClickAwayListener(props) {
	  var children = props.children,
	      _props$disableReactTr = props.disableReactTree,
	      disableReactTree = _props$disableReactTr === void 0 ? false : _props$disableReactTr,
	      _props$mouseEvent = props.mouseEvent,
	      mouseEvent = _props$mouseEvent === void 0 ? 'onClick' : _props$mouseEvent,
	      onClickAway = props.onClickAway,
	      _props$touchEvent = props.touchEvent,
	      touchEvent = _props$touchEvent === void 0 ? 'onTouchEnd' : _props$touchEvent;
	  var movedRef = React.useRef(false);
	  var nodeRef = React.useRef(null);
	  var mountedRef = React.useRef(false);
	  var syntheticEventRef = React.useRef(false);
	  React.useEffect(function () {
	    mountedRef.current = true;
	    return function () {
	      mountedRef.current = false;
	    };
	  }, []); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    nodeRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // The handler doesn't take event.defaultPrevented into account:
	  //
	  // event.preventDefault() is meant to stop default behaviours like
	  // clicking a checkbox to check it, hitting a button to submit a form,
	  // and hitting left arrow to move the cursor in a text input etc.
	  // Only special HTML elements have these default behaviors.
	
	  var handleClickAway = (0, _useEventCallback.default)(function (event) {
	    // Given developers can stop the propagation of the synthetic event,
	    // we can only be confident with a positive value.
	    var insideReactTree = syntheticEventRef.current;
	    syntheticEventRef.current = false; // 1. IE 11 support, which trigger the handleClickAway even after the unbind
	    // 2. The child might render null.
	
	    if (!mountedRef.current || !nodeRef.current) {
	      return;
	    } // Do not act if user performed touchmove
	
	
	    if (movedRef.current) {
	      movedRef.current = false;
	      return;
	    }
	
	    var insideDOM; // If not enough, can use https://github.com/DieterHolvoet/event-propagation-path/blob/master/propagationPath.js
	
	    if (event.composedPath) {
	      insideDOM = event.composedPath().indexOf(nodeRef.current) > -1;
	    } else {
	      var doc = (0, _ownerDocument.default)(nodeRef.current); // TODO v6 remove dead logic https://caniuse.com/#search=composedPath.
	      // `doc.contains` works in modern browsers but isn't supported in IE 11:
	      // https://github.com/timmywil/panzoom/issues/450
	      // https://github.com/videojs/video.js/pull/5872
	
	      insideDOM = !(doc.documentElement && doc.documentElement.contains(event.target)) || nodeRef.current.contains(event.target);
	    }
	
	    if (!insideDOM && (disableReactTree || !insideReactTree)) {
	      onClickAway(event);
	    }
	  }); // Keep track of mouse/touch events that bubbled up through the portal.
	
	  var createHandleSynthetic = function createHandleSynthetic(handlerName) {
	    return function (event) {
	      syntheticEventRef.current = true;
	      var childrenPropsHandler = children.props[handlerName];
	
	      if (childrenPropsHandler) {
	        childrenPropsHandler(event);
	      }
	    };
	  };
	
	  var childrenProps = {
	    ref: handleRef
	  };
	
	  if (touchEvent !== false) {
	    childrenProps[touchEvent] = createHandleSynthetic(touchEvent);
	  }
	
	  React.useEffect(function () {
	    if (touchEvent !== false) {
	      var mappedTouchEvent = mapEventPropToEvent(touchEvent);
	      var doc = (0, _ownerDocument.default)(nodeRef.current);
	
	      var handleTouchMove = function handleTouchMove() {
	        movedRef.current = true;
	      };
	
	      doc.addEventListener(mappedTouchEvent, handleClickAway);
	      doc.addEventListener('touchmove', handleTouchMove);
	      return function () {
	        doc.removeEventListener(mappedTouchEvent, handleClickAway);
	        doc.removeEventListener('touchmove', handleTouchMove);
	      };
	    }
	
	    return undefined;
	  }, [handleClickAway, touchEvent]);
	
	  if (mouseEvent !== false) {
	    childrenProps[mouseEvent] = createHandleSynthetic(mouseEvent);
	  }
	
	  React.useEffect(function () {
	    if (mouseEvent !== false) {
	      var mappedMouseEvent = mapEventPropToEvent(mouseEvent);
	      var doc = (0, _ownerDocument.default)(nodeRef.current);
	      doc.addEventListener(mappedMouseEvent, handleClickAway);
	      return function () {
	        doc.removeEventListener(mappedMouseEvent, handleClickAway);
	      };
	    }
	
	    return undefined;
	  }, [handleClickAway, mouseEvent]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, React.cloneElement(children, childrenProps));
	}
	
	 false ? ClickAwayListener.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The wrapped element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * The mouse event to listen to. You can disable the listener by providing `false`.
	   */
	  disableReactTree: _propTypes.default.bool,
	
	  /**
	   * The mouse event to listen to. You can disable the listener by providing `false`.
	   */
	  mouseEvent: _propTypes.default.oneOf(['onClick', 'onMouseDown', 'onMouseUp', false]),
	
	  /**
	   * Callback fired when a "click away" event is detected.
	   */
	  onClickAway: _propTypes.default.func.isRequired,
	
	  /**
	   * The touch event to listen to. You can disable the listener by providing `false`.
	   */
	  touchEvent: _propTypes.default.oneOf(['onTouchEnd', 'onTouchStart', false])
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  ClickAwayListener['propTypes' + ''] = (0, _utils.exactProp)(ClickAwayListener.propTypes);
	}
	
	var _default = ClickAwayListener;
	exports.default = _default;

/***/ },
/* 257 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(46);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _transitions = __webpack_require__(26);
	
	var _utils = __webpack_require__(44);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the container element. */
	    container: {
	      height: 0,
	      overflow: 'hidden',
	      transition: theme.transitions.create('height')
	    },
	
	    /* Styles applied to the container element when the transition has entered. */
	    entered: {
	      height: 'auto',
	      overflow: 'visible'
	    },
	
	    /* Styles applied to the container element when the transition has exited and `collapsedHeight` != 0px. */
	    hidden: {
	      visibility: 'hidden'
	    },
	
	    /* Styles applied to the outer wrapper element. */
	    wrapper: {
	      // Hack to get children with a negative margin to not falsify the height computation.
	      display: 'flex'
	    },
	
	    /* Styles applied to the inner wrapper element. */
	    wrapperInner: {
	      width: '100%'
	    }
	  };
	};
	/**
	 * The Collapse transition is used by the
	 * [Vertical Stepper](/components/steppers/#vertical-stepper) StepContent component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	
	exports.styles = styles;
	var Collapse = React.forwardRef(function Collapse(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$collapsedHeigh = props.collapsedHeight,
	      collapsedHeightProp = _props$collapsedHeigh === void 0 ? '0px' : _props$collapsedHeigh,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExiting = props.onExiting,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? _transitions.duration.standard : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "collapsedHeight", "component", "in", "onEnter", "onEntered", "onEntering", "onExit", "onExiting", "style", "timeout"]);
	  var theme = (0, _useTheme.default)();
	  var timer = React.useRef();
	  var wrapperRef = React.useRef(null);
	  var autoTransitionDuration = React.useRef();
	  var collapsedHeight = typeof collapsedHeightProp === 'number' ? "".concat(collapsedHeightProp, "px") : collapsedHeightProp;
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    node.style.height = collapsedHeight;
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleEntering = function handleEntering(node, isAppearing) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration;
	
	    if (timeout === 'auto') {
	      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	      node.style.transitionDuration = "".concat(duration2, "ms");
	      autoTransitionDuration.current = duration2;
	    } else {
	      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	    }
	
	    node.style.height = "".concat(wrapperHeight, "px");
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  };
	
	  var handleEntered = function handleEntered(node, isAppearing) {
	    node.style.height = 'auto';
	
	    if (onEntered) {
	      onEntered(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	    node.style.height = "".concat(wrapperHeight, "px");
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  var handleExiting = function handleExiting(node) {
	    var wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
	
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration;
	
	    if (timeout === 'auto') {
	      var duration2 = theme.transitions.getAutoHeightDuration(wrapperHeight);
	      node.style.transitionDuration = "".concat(duration2, "ms");
	      autoTransitionDuration.current = duration2;
	    } else {
	      node.style.transitionDuration = typeof transitionDuration === 'string' ? transitionDuration : "".concat(transitionDuration, "ms");
	    }
	
	    node.style.height = collapsedHeight;
	
	    if (onExiting) {
	      onExiting(node);
	    }
	  };
	
	  var addEndListener = function addEndListener(_, next) {
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTransitionDuration.current || 0);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    in: inProp,
	    onEnter: handleEnter,
	    onEntered: handleEntered,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExiting: handleExiting,
	    addEndListener: addEndListener,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, className, {
	        'entered': classes.entered,
	        'exited': !inProp && collapsedHeight === '0px' && classes.hidden
	      }[state]),
	      style: (0, _extends2.default)({
	        minHeight: collapsedHeight
	      }, style),
	      ref: ref
	    }, childProps), /*#__PURE__*/React.createElement("div", {
	      className: classes.wrapper,
	      ref: wrapperRef
	    }, /*#__PURE__*/React.createElement("div", {
	      className: classes.wrapperInner
	    }, children)));
	  });
	});
	 false ? Collapse.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content node to be collapsed.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The height of the container when collapsed.
	   */
	  collapsedHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	Collapse.muiSupportAuto = true;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCollapse'
	})(Collapse);
	
	exports.default = _default;

/***/ },
/* 258 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _defineProperty2.default)({
	      width: '100%',
	      marginLeft: 'auto',
	      boxSizing: 'border-box',
	      marginRight: 'auto',
	      paddingLeft: theme.spacing(2),
	      paddingRight: theme.spacing(2),
	      display: 'block'
	    }, theme.breakpoints.up('sm'), {
	      paddingLeft: theme.spacing(3),
	      paddingRight: theme.spacing(3)
	    }),
	
	    /* Styles applied to the root element if `disableGutters={true}`. */
	    disableGutters: {
	      paddingLeft: 0,
	      paddingRight: 0
	    },
	
	    /* Styles applied to the root element if `fixed={true}`. */
	    fixed: Object.keys(theme.breakpoints.values).reduce(function (acc, breakpoint) {
	      var value = theme.breakpoints.values[breakpoint];
	
	      if (value !== 0) {
	        acc[theme.breakpoints.up(breakpoint)] = {
	          maxWidth: value
	        };
	      }
	
	      return acc;
	    }, {}),
	
	    /* Styles applied to the root element if `maxWidth="xs"`. */
	    maxWidthXs: (0, _defineProperty2.default)({}, theme.breakpoints.up('xs'), {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 444)
	    }),
	
	    /* Styles applied to the root element if `maxWidth="sm"`. */
	    maxWidthSm: (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), {
	      maxWidth: theme.breakpoints.values.sm
	    }),
	
	    /* Styles applied to the root element if `maxWidth="md"`. */
	    maxWidthMd: (0, _defineProperty2.default)({}, theme.breakpoints.up('md'), {
	      maxWidth: theme.breakpoints.values.md
	    }),
	
	    /* Styles applied to the root element if `maxWidth="lg"`. */
	    maxWidthLg: (0, _defineProperty2.default)({}, theme.breakpoints.up('lg'), {
	      maxWidth: theme.breakpoints.values.lg
	    }),
	
	    /* Styles applied to the root element if `maxWidth="xl"`. */
	    maxWidthXl: (0, _defineProperty2.default)({}, theme.breakpoints.up('xl'), {
	      maxWidth: theme.breakpoints.values.xl
	    })
	  };
	};
	
	exports.styles = styles;
	var Container = React.forwardRef(function Container(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$fixed = props.fixed,
	      fixed = _props$fixed === void 0 ? false : _props$fixed,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === void 0 ? 'lg' : _props$maxWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "fixed", "maxWidth"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, fixed && classes.fixed, disableGutters && classes.disableGutters, maxWidth !== false && classes["maxWidth".concat((0, _capitalize.default)(String(maxWidth)))]),
	    ref: ref
	  }, other));
	});
	 false ? Container.propTypes = {
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * Set the max-width to match the min-width of the current breakpoint.
	   * This is useful if you'd prefer to design for a fixed set of sizes
	   * instead of trying to accommodate a fully fluid viewport.
	   * It's fluid by default.
	   */
	  fixed: _propTypes.default.bool,
	
	  /**
	   * Determine the max-width of the container.
	   * The container width grows with the size of the screen.
	   * Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl', false])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiContainer'
	})(Container);
	
	exports.default = _default;

/***/ },
/* 259 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Container.default;
	  }
	});
	
	var _Container = _interopRequireDefault(__webpack_require__(258));

/***/ },
/* 260 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = exports.body = exports.html = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _utils = __webpack_require__(9);
	
	var html = {
	  WebkitFontSmoothing: 'antialiased',
	  // Antialiasing.
	  MozOsxFontSmoothing: 'grayscale',
	  // Antialiasing.
	  // Change from `box-sizing: content-box` so that `width`
	  // is not affected by `padding` or `border`.
	  boxSizing: 'border-box'
	};
	exports.html = html;
	
	var body = function body(theme) {
	  return (0, _extends2.default)({
	    color: theme.palette.text.primary
	  }, theme.typography.body2, {
	    backgroundColor: theme.palette.background.default,
	    '@media print': {
	      // Save printer ink.
	      backgroundColor: theme.palette.common.white
	    }
	  });
	};
	
	exports.body = body;
	
	var styles = function styles(theme) {
	  return {
	    '@global': {
	      html: html,
	      '*, *::before, *::after': {
	        boxSizing: 'inherit'
	      },
	      'strong, b': {
	        fontWeight: theme.typography.fontWeightBold
	      },
	      body: (0, _extends2.default)({
	        margin: 0
	      }, body(theme), {
	        // Add support for document.body.requestFullScreen().
	        // Other elements, if background transparent, are not supported.
	        '&::backdrop': {
	          backgroundColor: theme.palette.background.default
	        }
	      })
	    }
	  };
	};
	/**
	 * Kickstart an elegant, consistent, and simple baseline to build upon.
	 */
	
	
	exports.styles = styles;
	
	function CssBaseline(props) {
	  /* eslint-disable no-unused-vars */
	  var _props$children = props.children,
	      children = _props$children === void 0 ? null : _props$children,
	      classes = props.classes;
	  /* eslint-enable no-unused-vars */
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, children);
	}
	
	 false ? CssBaseline.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  CssBaseline['propTypes' + ''] = (0, _utils.exactProp)(CssBaseline.propTypes);
	}
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiCssBaseline'
	})(CssBaseline);
	
	exports.default = _default;

/***/ },
/* 261 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _CssBaseline.default;
	  }
	});
	
	var _CssBaseline = _interopRequireDefault(__webpack_require__(260));

/***/ },
/* 262 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _Modal = _interopRequireDefault(__webpack_require__(65));
	
	var _Backdrop = _interopRequireDefault(__webpack_require__(74));
	
	var _Fade = _interopRequireDefault(__webpack_require__(77));
	
	var _transitions = __webpack_require__(26);
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	/* eslint-disable jsx-a11y/click-events-have-key-events */
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      '@media print': {
	        // Use !important to override the Modal inline-style.
	        position: 'absolute !important'
	      }
	    },
	
	    /* Styles applied to the container element if `scroll="paper"`. */
	    scrollPaper: {
	      display: 'flex',
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the container element if `scroll="body"`. */
	    scrollBody: {
	      overflowY: 'auto',
	      overflowX: 'hidden',
	      textAlign: 'center',
	      '&:after': {
	        content: '""',
	        display: 'inline-block',
	        verticalAlign: 'middle',
	        height: '100%',
	        width: '0'
	      }
	    },
	
	    /* Styles applied to the container element. */
	    container: {
	      height: '100%',
	      '@media print': {
	        height: 'auto'
	      },
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: {
	      margin: 32,
	      position: 'relative',
	      overflowY: 'auto',
	      // Fix IE 11 issue, to remove at some point.
	      '@media print': {
	        overflowY: 'visible',
	        boxShadow: 'none'
	      }
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="paper"`. */
	    paperScrollPaper: {
	      display: 'flex',
	      flexDirection: 'column',
	      maxHeight: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `scroll="body"`. */
	    paperScrollBody: {
	      display: 'inline-block',
	      verticalAlign: 'middle',
	      textAlign: 'left' // 'initial' doesn't work on IE 11
	
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth=false`. */
	    paperWidthFalse: {
	      maxWidth: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xs"`. */
	    paperWidthXs: {
	      maxWidth: Math.max(theme.breakpoints.values.xs, 444),
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(Math.max(theme.breakpoints.values.xs, 444) + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="sm"`. */
	    paperWidthSm: {
	      maxWidth: theme.breakpoints.values.sm,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.sm + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="md"`. */
	    paperWidthMd: {
	      maxWidth: theme.breakpoints.values.md,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.md + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="lg"`. */
	    paperWidthLg: {
	      maxWidth: theme.breakpoints.values.lg,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.lg + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `maxWidth="xl"`. */
	    paperWidthXl: {
	      maxWidth: theme.breakpoints.values.xl,
	      '&$paperScrollBody': (0, _defineProperty2.default)({}, theme.breakpoints.down(theme.breakpoints.values.xl + 32 * 2), {
	        maxWidth: 'calc(100% - 64px)'
	      })
	    },
	
	    /* Styles applied to the `Paper` component if `fullWidth={true}`. */
	    paperFullWidth: {
	      width: 'calc(100% - 64px)'
	    },
	
	    /* Styles applied to the `Paper` component if `fullScreen={true}`. */
	    paperFullScreen: {
	      margin: 0,
	      width: '100%',
	      maxWidth: '100%',
	      height: '100%',
	      maxHeight: 'none',
	      borderRadius: 0,
	      '&$paperScrollBody': {
	        margin: 0,
	        maxWidth: '100%'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultTransitionDuration = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * Dialogs are overlaid modal paper based components with a backdrop.
	 */
	
	var Dialog = React.forwardRef(function Dialog(props, ref) {
	  var BackdropProps = props.BackdropProps,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$fullScreen = props.fullScreen,
	      fullScreen = _props$fullScreen === void 0 ? false : _props$fullScreen,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$maxWidth = props.maxWidth,
	      maxWidth = _props$maxWidth === void 0 ? 'sm' : _props$maxWidth,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperComponent = props.PaperComponent,
	      PaperComponent = _props$PaperComponent === void 0 ? _Paper.default : _props$PaperComponent,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$scroll = props.scroll,
	      scroll = _props$scroll === void 0 ? 'paper' : _props$scroll,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Fade.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? defaultTransitionDuration : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      ariaDescribedby = props['aria-describedby'],
	      ariaLabelledby = props['aria-labelledby'],
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropProps", "children", "classes", "className", "disableBackdropClick", "disableEscapeKeyDown", "fullScreen", "fullWidth", "maxWidth", "onBackdropClick", "onClose", "onEnter", "onEntered", "onEntering", "onEscapeKeyDown", "onExit", "onExited", "onExiting", "open", "PaperComponent", "PaperProps", "scroll", "TransitionComponent", "transitionDuration", "TransitionProps", "aria-describedby", "aria-labelledby"]);
	  var mouseDownTarget = React.useRef();
	
	  var handleMouseDown = function handleMouseDown(event) {
	    mouseDownTarget.current = event.target;
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    // Ignore the events not coming from the "backdrop"
	    // We don't want to close the dialog when clicking the dialog content.
	    if (event.target !== event.currentTarget) {
	      return;
	    } // Make sure the event starts and ends on the same DOM element.
	
	
	    if (event.target !== mouseDownTarget.current) {
	      return;
	    }
	
	    mouseDownTarget.current = null;
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    BackdropComponent: _Backdrop.default,
	    BackdropProps: (0, _extends2.default)({
	      transitionDuration: transitionDuration
	    }, BackdropProps),
	    closeAfterTransition: true,
	    disableBackdropClick: disableBackdropClick,
	    disableEscapeKeyDown: disableEscapeKeyDown,
	    onEscapeKeyDown: onEscapeKeyDown,
	    onClose: onClose,
	    open: open,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    timeout: transitionDuration,
	    onEnter: onEnter,
	    onEntering: onEntering,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExiting: onExiting,
	    onExited: onExited,
	    role: "none presentation"
	  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.container, classes["scroll".concat((0, _capitalize.default)(scroll))]),
	    onClick: handleBackdropClick,
	    onMouseDown: handleMouseDown
	  }, /*#__PURE__*/React.createElement(PaperComponent, (0, _extends2.default)({
	    elevation: 24,
	    role: "dialog",
	    "aria-describedby": ariaDescribedby,
	    "aria-labelledby": ariaLabelledby
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, classes["paperScroll".concat((0, _capitalize.default)(scroll))], classes["paperWidth".concat((0, _capitalize.default)(String(maxWidth)))], PaperProps.className, fullScreen && classes.paperFullScreen, fullWidth && classes.paperFullWidth)
	  }), children))));
	});
	 false ? Dialog.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The id(s) of the element(s) that describe the dialog.
	   */
	  'aria-describedby': _propTypes.default.string,
	
	  /**
	   * The id(s) of the element(s) that label the dialog.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * Dialog children, usually the included sub-components.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, clicking the backdrop will not fire the `onClose` callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire the `onClose` callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog will be full-screen
	   */
	  fullScreen: _propTypes.default.bool,
	
	  /**
	   * If `true`, the dialog stretches to `maxWidth`.
	   *
	   * Notice that the dialog width grow is limited by the default margin.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * Determine the max-width of the dialog.
	   * The dialog width grows with the size of the screen.
	   * Set to `false` to disable `maxWidth`.
	   */
	  maxWidth: _propTypes.default.oneOf(['lg', 'md', 'sm', 'xl', 'xs', false]),
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog enters.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableKeyboard` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired before the dialog exits.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the dialog is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the Dialog is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * The component used to render the body of the dialog.
	   */
	  PaperComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default.object,
	
	  /**
	   * Determine the container for scrolling the dialog.
	   */
	  scroll: _propTypes.default.oneOf(['body', 'paper']),
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialog'
	})(Dialog);
	
	exports.default = _default;

/***/ },
/* 263 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Dialog.default;
	  }
	});
	
	var _Dialog = _interopRequireDefault(__webpack_require__(262));

/***/ },
/* 264 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end',
	    flex: '0 0 auto'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var DialogActions = React.forwardRef(function DialogActions(props, ref) {
	  var _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableSpacing", "classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? DialogActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogActions'
	})(DialogActions);
	
	exports.default = _default;

/***/ },
/* 265 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogActions.default;
	  }
	});
	
	var _DialogActions = _interopRequireDefault(__webpack_require__(264));

/***/ },
/* 266 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      flex: '1 1 auto',
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      overflowY: 'auto',
	      padding: '8px 24px',
	      '&:first-child': {
	        // dialog without title
	        paddingTop: 20
	      }
	    },
	
	    /* Styles applied to the root element if `dividers={true}`. */
	    dividers: {
	      padding: '16px 24px',
	      borderTop: "1px solid ".concat(theme.palette.divider),
	      borderBottom: "1px solid ".concat(theme.palette.divider)
	    }
	  };
	};
	
	exports.styles = styles;
	var DialogContent = React.forwardRef(function DialogContent(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$dividers = props.dividers,
	      dividers = _props$dividers === void 0 ? false : _props$dividers,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "dividers"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dividers && classes.dividers),
	    ref: ref
	  }, other));
	});
	 false ? DialogContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display the top and bottom dividers.
	   */
	  dividers: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContent'
	})(DialogContent);
	
	exports.default = _default;

/***/ },
/* 267 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContent.default;
	  }
	});
	
	var _DialogContent = _interopRequireDefault(__webpack_require__(266));

/***/ },
/* 268 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    marginBottom: 12
	  }
	};
	exports.styles = styles;
	var DialogContentText = React.forwardRef(function DialogContentText(props, ref) {
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    component: "p",
	    variant: "body1",
	    color: "textSecondary",
	    ref: ref
	  }, props));
	});
	 false ? DialogContentText.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogContentText'
	})(DialogContentText);
	
	exports.default = _default;

/***/ },
/* 269 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogContentText.default;
	  }
	});
	
	var _DialogContentText = _interopRequireDefault(__webpack_require__(268));

/***/ },
/* 270 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    margin: 0,
	    padding: '16px 24px',
	    flex: '0 0 auto'
	  }
	};
	exports.styles = styles;
	var DialogTitle = React.forwardRef(function DialogTitle(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), disableTypography ? children : /*#__PURE__*/React.createElement(_Typography.default, {
	    component: "h2",
	    variant: "h6"
	  }, children));
	});
	 false ? DialogTitle.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a typography component.
	   * For instance, this can be useful to render an h4 instead of the default h2.
	   */
	  disableTypography: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDialogTitle'
	})(DialogTitle);
	
	exports.default = _default;

/***/ },
/* 271 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _DialogTitle.default;
	  }
	});
	
	var _DialogTitle = _interopRequireDefault(__webpack_require__(270));

/***/ },
/* 272 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(15);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 1,
	      margin: 0,
	      // Reset browser default style.
	      border: 'none',
	      flexShrink: 0,
	      backgroundColor: theme.palette.divider
	    },
	
	    /* Styles applied to the root element if `absolute={true}`. */
	    absolute: {
	      position: 'absolute',
	      bottom: 0,
	      left: 0,
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `variant="inset"`. */
	    inset: {
	      marginLeft: 72
	    },
	
	    /* Styles applied to the root element if `light={true}`. */
	    light: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.divider, 0.08)
	    },
	
	    /* Styles applied to the root element if `variant="middle"`. */
	    middle: {
	      marginLeft: theme.spacing(2),
	      marginRight: theme.spacing(2)
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      height: '100%',
	      width: 1
	    },
	
	    /* Styles applied to the root element if `flexItem={true}`. */
	    flexItem: {
	      alignSelf: 'stretch',
	      height: 'auto'
	    }
	  };
	};
	
	exports.styles = styles;
	var Divider = React.forwardRef(function Divider(props, ref) {
	  var _props$absolute = props.absolute,
	      absolute = _props$absolute === void 0 ? false : _props$absolute,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'hr' : _props$component,
	      _props$flexItem = props.flexItem,
	      flexItem = _props$flexItem === void 0 ? false : _props$flexItem,
	      _props$light = props.light,
	      light = _props$light === void 0 ? false : _props$light,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$role = props.role,
	      role = _props$role === void 0 ? Component !== 'hr' ? 'separator' : undefined : _props$role,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'fullWidth' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["absolute", "classes", "className", "component", "flexItem", "light", "orientation", "role", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'fullWidth' && classes[variant], absolute && classes.absolute, flexItem && classes.flexItem, light && classes.light, orientation === 'vertical' && classes.vertical),
	    role: role,
	    ref: ref
	  }, other));
	});
	 false ? Divider.propTypes = {
	  /**
	   * Absolutely position the element.
	   */
	  absolute: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, a vertical divider will have the correct height when used in flex container.
	   * (By default, a vertical divider will have a calculated height of `0px` if it is the child of a flex container.)
	   */
	  flexItem: _propTypes.default.bool,
	
	  /**
	   * If `true`, the divider will have a lighter color.
	   */
	  light: _propTypes.default.bool,
	
	  /**
	   * The divider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['fullWidth', 'inset', 'middle'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiDivider'
	})(Divider);
	
	exports.default = _default;

/***/ },
/* 273 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Divider.default;
	  }
	});
	
	var _Divider = _interopRequireDefault(__webpack_require__(272));

/***/ },
/* 274 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Drawer.default;
	  }
	});
	
	var _Drawer = _interopRequireDefault(__webpack_require__(76));

/***/ },
/* 275 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _toArray2 = _interopRequireDefault(__webpack_require__(198));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(32));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(18);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _Collapse = _interopRequireDefault(__webpack_require__(75));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ExpansionPanelContext = _interopRequireDefault(__webpack_require__(116));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(39));
	
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      transition: theme.transitions.create(['margin'], transition),
	      '&:before': {
	        position: 'absolute',
	        left: 0,
	        top: -1,
	        right: 0,
	        height: 1,
	        content: '""',
	        opacity: 1,
	        backgroundColor: theme.palette.divider,
	        transition: theme.transitions.create(['opacity', 'background-color'], transition)
	      },
	      '&:first-child': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$expanded': {
	        margin: '16px 0',
	        '&:first-child': {
	          marginTop: 0
	        },
	        '&:last-child': {
	          marginBottom: 0
	        },
	        '&:before': {
	          opacity: 0
	        }
	      },
	      '&$expanded + &': {
	        '&:before': {
	          display: 'none'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: 0,
	      '&:first-child': {
	        borderTopLeftRadius: theme.shape.borderRadius,
	        borderTopRightRadius: theme.shape.borderRadius
	      },
	      '&:last-child': {
	        borderBottomLeftRadius: theme.shape.borderRadius,
	        borderBottomRightRadius: theme.shape.borderRadius,
	        // Fix a rendering issue on Edge
	        '@supports (-ms-ime-align: auto)': {
	          borderBottomLeftRadius: 0,
	          borderBottomRightRadius: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `expanded={true}`. */
	    expanded: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {}
	  };
	};
	
	exports.styles = styles;
	var ExpansionPanel = React.forwardRef(function ExpansionPanel(props, ref) {
	  var childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$defaultExpande = props.defaultExpanded,
	      defaultExpanded = _props$defaultExpande === void 0 ? false : _props$defaultExpande,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      expandedProp = props.expanded,
	      onChange = props.onChange,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "defaultExpanded", "disabled", "expanded", "onChange", "square", "TransitionComponent", "TransitionProps"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: expandedProp,
	    default: defaultExpanded,
	    name: 'ExpansionPanel',
	    state: 'expanded'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      expanded = _useControlled2[0],
	      setExpandedState = _useControlled2[1];
	
	  var handleChange = React.useCallback(function (event) {
	    setExpandedState(!expanded);
	
	    if (onChange) {
	      onChange(event, !expanded);
	    }
	  }, [expanded, onChange, setExpandedState]);
	
	  var _React$Children$toArr = React.Children.toArray(childrenProp),
	      _React$Children$toArr2 = (0, _toArray2.default)(_React$Children$toArr),
	      summary = _React$Children$toArr2[0],
	      children = _React$Children$toArr2.slice(1);
	
	  var contextValue = React.useMemo(function () {
	    return {
	      expanded: expanded,
	      disabled: disabled,
	      toggle: handleChange
	    };
	  }, [expanded, disabled, handleChange]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, expanded && classes.expanded, disabled && classes.disabled, !square && classes.rounded),
	    ref: ref,
	    square: square
	  }, other), /*#__PURE__*/React.createElement(_ExpansionPanelContext.default.Provider, {
	    value: contextValue
	  }, summary), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: expanded,
	    timeout: "auto"
	  }, TransitionProps), /*#__PURE__*/React.createElement("div", {
	    "aria-labelledby": summary.props.id,
	    id: summary.props['aria-controls'],
	    role: "region"
	  }, children)));
	});
	 false ? ExpansionPanel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the expansion panel.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node.isRequired, function (props) {
	    var summary = React.Children.toArray(props.children)[0];
	
	    if ((0, _reactIs.isFragment)(summary)) {
	      return new Error("Material-UI: the ExpansionPanel doesn't accept a Fragment as a child. " + 'Consider providing an array instead.');
	    }
	
	    if (!React.isValidElement(summary)) {
	      return new Error('Material-UI: expected the first child of ExpansionPanel to be a valid element.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, expands the panel by default.
	   */
	  defaultExpanded: _propTypes.default.bool,
	
	  /**
	   * If `true`, the panel will be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, expands the panel, otherwise collapse it.
	   * Setting this prop enables control over the panel.
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the expand/collapse state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {boolean} expanded The `expanded` state of the panel.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The component used for the collapse effect.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanel'
	})(ExpansionPanel);
	
	exports.default = _default;

/***/ },
/* 276 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanel.default;
	  }
	});
	
	var _ExpansionPanel = _interopRequireDefault(__webpack_require__(275));

/***/ },
/* 277 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    alignItems: 'center',
	    padding: 8,
	    justifyContent: 'flex-end'
	  },
	
	  /* Styles applied to the root element if `disableSpacing={false}`. */
	  spacing: {
	    '& > :not(:first-child)': {
	      marginLeft: 8
	    }
	  }
	};
	exports.styles = styles;
	var ExpansionPanelActions = React.forwardRef(function ExpansionPanelActions(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableSpacing = props.disableSpacing,
	      disableSpacing = _props$disableSpacing === void 0 ? false : _props$disableSpacing,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableSpacing"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, !disableSpacing && classes.spacing),
	    ref: ref
	  }, other));
	});
	 false ? ExpansionPanelActions.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the actions do not have additional margin.
	   */
	  disableSpacing: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelActions'
	})(ExpansionPanelActions);
	
	exports.default = _default;

/***/ },
/* 278 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelActions.default;
	  }
	});
	
	var _ExpansionPanelActions = _interopRequireDefault(__webpack_require__(277));

/***/ },
/* 279 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    padding: '8px 24px 24px'
	  }
	};
	exports.styles = styles;
	var ExpansionPanelDetails = React.forwardRef(function ExpansionPanelDetails(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? ExpansionPanelDetails.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the expansion panel details.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelDetails'
	})(ExpansionPanelDetails);
	
	exports.default = _default;

/***/ },
/* 280 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelDetails.default;
	  }
	});
	
	var _ExpansionPanelDetails = _interopRequireDefault(__webpack_require__(279));

/***/ },
/* 281 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(48));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ExpansionPanelContext = _interopRequireDefault(__webpack_require__(116));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = function styles(theme) {
	  var transition = {
	    duration: theme.transitions.duration.shortest
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      minHeight: 8 * 6,
	      transition: theme.transitions.create(['min-height', 'background-color'], transition),
	      padding: theme.spacing(0, 3),
	      '&:hover:not($disabled)': {
	        cursor: 'pointer'
	      },
	      '&$expanded': {
	        minHeight: 64
	      },
	      '&$focused': {
	        backgroundColor: theme.palette.grey[300]
	      },
	      '&$disabled': {
	        opacity: 0.38
	      }
	    },
	
	    /* Pseudo-class applied to the root element, children wrapper element and `IconButton` component if `expanded={true}`. */
	    expanded: {},
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the children wrapper element. */
	    content: {
	      display: 'flex',
	      flexGrow: 1,
	      transition: theme.transitions.create(['margin'], transition),
	      margin: '12px 0',
	      '&$expanded': {
	        margin: '20px 0'
	      }
	    },
	
	    /* Styles applied to the `IconButton` component when `expandIcon` is supplied. */
	    expandIcon: {
	      transform: 'rotate(0deg)',
	      transition: theme.transitions.create('transform', transition),
	      '&:hover': {
	        // Disable the hover effect for the IconButton,
	        // because a hover effect should apply to the entire Expand button and
	        // not only to the IconButton.
	        backgroundColor: 'transparent'
	      },
	      '&$expanded': {
	        transform: 'rotate(180deg)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var ExpansionPanelSummary = React.forwardRef(function ExpansionPanelSummary(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      expandIcon = props.expandIcon,
	      IconButtonProps = props.IconButtonProps,
	      onBlur = props.onBlur,
	      onClick = props.onClick,
	      onFocusVisible = props.onFocusVisible,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "expandIcon", "IconButtonProps", "onBlur", "onClick", "onFocusVisible"]);
	
	  var _React$useState = React.useState(false),
	      focusedState = _React$useState[0],
	      setFocusedState = _React$useState[1];
	
	  var handleFocusVisible = function handleFocusVisible(event) {
	    setFocusedState(true);
	
	    if (onFocusVisible) {
	      onFocusVisible(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    setFocusedState(false);
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var _React$useContext = React.useContext(_ExpansionPanelContext.default),
	      _React$useContext$dis = _React$useContext.disabled,
	      disabled = _React$useContext$dis === void 0 ? false : _React$useContext$dis,
	      expanded = _React$useContext.expanded,
	      toggle = _React$useContext.toggle;
	
	  var handleChange = function handleChange(event) {
	    if (toggle) {
	      toggle(event);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    focusRipple: false,
	    disableRipple: true,
	    disabled: disabled,
	    component: "div",
	    "aria-expanded": expanded,
	    className: (0, _clsx.default)(classes.root, className, disabled && classes.disabled, expanded && classes.expanded, focusedState && classes.focused),
	    onFocusVisible: handleFocusVisible,
	    onBlur: handleBlur,
	    onClick: handleChange,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.content, expanded && classes.expanded)
	  }, children), expandIcon && /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.expandIcon, expanded && classes.expanded),
	    edge: "end",
	    component: "div",
	    tabIndex: null,
	    role: null,
	    "aria-hidden": true
	  }, IconButtonProps), expandIcon));
	});
	 false ? ExpansionPanelSummary.propTypes = {
	  /**
	   * The content of the expansion panel summary.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The icon to display as the expand indicator.
	   */
	  expandIcon: _propTypes.default.node,
	
	  /**
	   * Props applied to the `IconButton` element wrapping the expand icon.
	   */
	  IconButtonProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocusVisible: _propTypes.default.func
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiExpansionPanelSummary'
	})(ExpansionPanelSummary);
	
	exports.default = _default;

/***/ },
/* 282 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ExpansionPanelSummary.default;
	  }
	});
	
	var _ExpansionPanelSummary = _interopRequireDefault(__webpack_require__(281));

/***/ },
/* 283 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.button, {
	      boxSizing: 'border-box',
	      minHeight: 36,
	      transition: theme.transitions.create(['background-color', 'box-shadow', 'border'], {
	        duration: theme.transitions.duration.short
	      }),
	      borderRadius: '50%',
	      padding: 0,
	      minWidth: 0,
	      width: 56,
	      height: 56,
	      boxShadow: theme.shadows[6],
	      '&:active': {
	        boxShadow: theme.shadows[12]
	      },
	      color: theme.palette.getContrastText(theme.palette.grey[300]),
	      backgroundColor: theme.palette.grey[300],
	      '&:hover': {
	        backgroundColor: theme.palette.grey.A100,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.grey[300]
	        },
	        '&$disabled': {
	          backgroundColor: theme.palette.action.disabledBackground
	        },
	        textDecoration: 'none'
	      },
	      '&$focusVisible': {
	        boxShadow: theme.shadows[6]
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled,
	        boxShadow: theme.shadows[0],
	        backgroundColor: theme.palette.action.disabledBackground
	      }
	    }),
	
	    /* Styles applied to the span element that wraps the children. */
	    label: {
	      width: '100%',
	      // assure the correct width for iOS Safari
	      display: 'inherit',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    primary: {
	      color: theme.palette.primary.contrastText,
	      backgroundColor: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.primary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.primary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    secondary: {
	      color: theme.palette.secondary.contrastText,
	      backgroundColor: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: theme.palette.secondary.dark,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: theme.palette.secondary.main
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="extended"`. */
	    extended: {
	      borderRadius: 48 / 2,
	      padding: '0 16px',
	      width: 'auto',
	      minHeight: 'auto',
	      minWidth: 48,
	      height: 48,
	      '&$sizeSmall': {
	        width: 'auto',
	        padding: '0 8px',
	        borderRadius: 34 / 2,
	        minWidth: 34,
	        height: 34
	      },
	      '&$sizeMedium': {
	        width: 'auto',
	        padding: '0 16px',
	        borderRadius: 40 / 2,
	        minWidth: 40,
	        height: 40
	      }
	    },
	
	    /* Pseudo-class applied to the ButtonBase root element if the button is keyboard focused. */
	    focusVisible: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `size="small"``. */
	    sizeSmall: {
	      width: 40,
	      height: 40
	    },
	
	    /* Styles applied to the root element if `size="medium"``. */
	    sizeMedium: {
	      width: 48,
	      height: 48
	    }
	  };
	};
	
	exports.styles = styles;
	var Fab = React.forwardRef(function Fab(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'button' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'large' : _props$size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'round' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "disableFocusRipple", "focusVisibleClassName", "size", "variant"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== "round" && classes.extended, size !== 'large' && classes["size".concat((0, _capitalize.default)(size))], disabled && classes.disabled, {
	      'primary': classes.primary,
	      'secondary': classes.secondary,
	      'inherit': classes.colorInherit
	    }[color]),
	    component: component,
	    disabled: disabled,
	    focusRipple: !disableFocusRipple,
	    focusVisibleClassName: (0, _clsx.default)(classes.focusVisible, focusVisibleClassName),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, children));
	});
	 false ? Fab.propTypes = {
	  /**
	   * The content of the button.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * The URL to link to when the button is clicked.
	   * If defined, an `a` element will be used as the root node.
	   */
	  href: _propTypes.default.string,
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium', 'large']),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['round', 'extended'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFab'
	})(Fab);
	
	exports.default = _default;

/***/ },
/* 284 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Fab.default;
	  }
	});
	
	var _Fab = _interopRequireDefault(__webpack_require__(283));

/***/ },
/* 285 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(46);
	
	var _transitions = __webpack_require__(26);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var _utils = __webpack_require__(44);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  entering: {
	    opacity: 1
	  },
	  entered: {
	    opacity: 1
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Fade transition is used by the [Modal](/components/modal/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Fade = React.forwardRef(function Fade(props, ref) {
	  var children = props.children,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onExit = props.onExit,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);
	  var theme = (0, _useTheme.default)();
	  var handleRef = (0, _useForkRef.default)(children.ref, ref);
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('opacity', transitionProps);
	    node.style.transition = theme.transitions.create('opacity', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    onEnter: handleEnter,
	    onExit: handleExit,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], {}, style, {}, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Fade.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Fade;
	exports.default = _default;

/***/ },
/* 286 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(49));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  var backgroundColor = light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      backgroundColor: backgroundColor,
	      borderTopLeftRadius: theme.shape.borderRadius,
	      borderTopRightRadius: theme.shape.borderRadius,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '&:hover': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.13)' : 'rgba(255, 255, 255, 0.13)',
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: backgroundColor
	        }
	      },
	      '&$focused': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.09)' : 'rgba(255, 255, 255, 0.09)'
	      },
	      '&$disabled': {
	        backgroundColor: light ? 'rgba(0, 0, 0, 0.12)' : 'rgba(255, 255, 255, 0.12)'
	      }
	    },
	
	    /* Styles applied to the root element if color secondary. */
	    colorSecondary: {
	      '&$underline:after': {
	        borderBottomColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary.main),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:before': {
	        borderBottom: "1px solid ".concat(theme.palette.text.primary)
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 12
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 12
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '27px 12px 10px',
	      '&$marginDense': {
	        paddingTop: 23,
	        paddingBottom: 6
	      }
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '27px 12px 10px',
	      '&:-webkit-autofill': {
	        WebkitBoxShadow: theme.palette.type === 'dark' ? '0 0 0 100px #266798 inset' : null,
	        WebkitTextFillColor: theme.palette.type === 'dark' ? '#fff' : null,
	        borderTopLeftRadius: 'inherit',
	        borderTopRightRadius: 'inherit'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 23,
	      paddingBottom: 6
	    },
	
	    /* Styles applied to the `input` if in `<FormControl hiddenLabel />`. */
	    inputHiddenLabel: {
	      paddingTop: 18,
	      paddingBottom: 19,
	      '&$inputMarginDense': {
	        paddingTop: 10,
	        paddingBottom: 11
	      }
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	var FilledInput = React.forwardRef(function FilledInput(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? FilledInput.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	FilledInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFilledInput'
	})(FilledInput);
	
	exports.default = _default;

/***/ },
/* 287 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(80);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(55));
	
	var _FormControlContext = _interopRequireDefault(__webpack_require__(62));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'inline-flex',
	    flexDirection: 'column',
	    position: 'relative',
	    // Reset fieldset default style.
	    minWidth: 0,
	    padding: 0,
	    margin: 0,
	    border: 0,
	    verticalAlign: 'top' // Fix alignment issue on Safari.
	
	  },
	
	  /* Styles applied to the root element if `margin="normal"`. */
	  marginNormal: {
	    marginTop: 16,
	    marginBottom: 8
	  },
	
	  /* Styles applied to the root element if `margin="dense"`. */
	  marginDense: {
	    marginTop: 8,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the root element if `fullWidth={true}`. */
	  fullWidth: {
	    width: '100%'
	  }
	};
	/**
	 * Provides context such as filled/focused/error/required for form inputs.
	 * Relying on the context provides high flexibility and ensures that the state always stays
	 * consistent across the children of the `FormControl`.
	 * This context is used by the following components:
	 *
	 *  - FormLabel
	 *  - FormHelperText
	 *  - Input
	 *  - InputLabel
	 *
	 * You can find one composition example below and more going to [the demos](/components/text-fields/#components).
	 *
	 * ```jsx
	 * <FormControl>
	 *   <InputLabel htmlFor="my-input">Email address</InputLabel>
	 *   <Input id="my-input" aria-describedby="my-helper-text" />
	 *   <FormHelperText id="my-helper-text">We'll never share your email.</FormHelperText>
	 * </FormControl>
	 * ```
	 *
	 * ⚠️Only one input can be used within a FormControl.
	 */
	
	exports.styles = styles;
	var FormControl = React.forwardRef(function FormControl(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      visuallyFocused = props.focused,
	      _props$hiddenLabel = props.hiddenLabel,
	      hiddenLabel = _props$hiddenLabel === void 0 ? false : _props$hiddenLabel,
	      _props$margin = props.margin,
	      margin = _props$margin === void 0 ? 'none' : _props$margin,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      size = props.size,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "fullWidth", "focused", "hiddenLabel", "margin", "required", "size", "variant"]);
	
	  var _React$useState = React.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialAdornedStart = false;
	
	    if (children) {
	      React.Children.forEach(children, function (child) {
	        if (!(0, _isMuiElement.default)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        var input = (0, _isMuiElement.default)(child, ['Select']) ? child.props.input : child;
	
	        if (input && (0, _utils.isAdornedStart)(input.props)) {
	          initialAdornedStart = true;
	        }
	      });
	    }
	
	    return initialAdornedStart;
	  }),
	      adornedStart = _React$useState[0],
	      setAdornedStart = _React$useState[1];
	
	  var _React$useState2 = React.useState(function () {
	    // We need to iterate through the children and find the Input in order
	    // to fully support server-side rendering.
	    var initialFilled = false;
	
	    if (children) {
	      React.Children.forEach(children, function (child) {
	        if (!(0, _isMuiElement.default)(child, ['Input', 'Select'])) {
	          return;
	        }
	
	        if ((0, _utils.isFilled)(child.props, true)) {
	          initialFilled = true;
	        }
	      });
	    }
	
	    return initialFilled;
	  }),
	      filled = _React$useState2[0],
	      setFilled = _React$useState2[1];
	
	  var _React$useState3 = React.useState(false),
	      _focused = _React$useState3[0],
	      setFocused = _React$useState3[1];
	
	  var focused = visuallyFocused !== undefined ? visuallyFocused : _focused;
	
	  if (disabled && focused) {
	    setFocused(false);
	  }
	
	  var registerEffect;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    var registeredInput = React.useRef(false);
	
	    registerEffect = function registerEffect() {
	      if (registeredInput.current) {
	        console.error(['Material-UI: there are multiple InputBase components inside a FormControl.', 'This is not supported. It might cause infinite rendering loops.', 'Only use one InputBase.'].join('\n'));
	      }
	
	      registeredInput.current = true;
	      return function () {
	        registeredInput.current = false;
	      };
	    };
	  }
	
	  var onFilled = React.useCallback(function () {
	    setFilled(true);
	  }, []);
	  var onEmpty = React.useCallback(function () {
	    setFilled(false);
	  }, []);
	  var childContext = {
	    adornedStart: adornedStart,
	    setAdornedStart: setAdornedStart,
	    color: color,
	    disabled: disabled,
	    error: error,
	    filled: filled,
	    focused: focused,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    margin: (size === 'small' ? 'dense' : undefined) || margin,
	    onBlur: function onBlur() {
	      setFocused(false);
	    },
	    onEmpty: onEmpty,
	    onFilled: onFilled,
	    onFocus: function onFocus() {
	      setFocused(true);
	    },
	    registerEffect: registerEffect,
	    required: required,
	    variant: variant
	  };
	  return /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: childContext
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, margin !== 'none' && classes["margin".concat((0, _capitalize.default)(margin))], fullWidth && classes.fullWidth),
	    ref: ref
	  }, other), children));
	});
	 false ? FormControl.propTypes = {
	  /**
	   * The contents of the form control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the label, input and helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be displayed in focused state.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be hidden.
	   * This is used to increase density for a `FilledInput`.
	   * Be sure to add `aria-label` to the `input` element.
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['none', 'dense', 'normal']),
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the text field.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControl'
	})(FormControl);
	
	exports.default = _default;

/***/ },
/* 288 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _FormControl = __webpack_require__(79);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      cursor: 'pointer',
	      // For correct alignment with the text.
	      verticalAlign: 'middle',
	      WebkitTapHighlightColor: 'transparent',
	      marginLeft: -11,
	      marginRight: 16,
	      // used for row presentation of radio/checkbox
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `labelPlacement="start"`. */
	    labelPlacementStart: {
	      flexDirection: 'row-reverse',
	      marginLeft: 16,
	      // used for row presentation of radio/checkbox
	      marginRight: -11
	    },
	
	    /* Styles applied to the root element if `labelPlacement="top"`. */
	    labelPlacementTop: {
	      flexDirection: 'column-reverse',
	      marginLeft: 16
	    },
	
	    /* Styles applied to the root element if `labelPlacement="bottom"`. */
	    labelPlacementBottom: {
	      flexDirection: 'column',
	      marginLeft: 16
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the label's Typography component. */
	    label: {
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    }
	  };
	};
	/**
	 * Drop in replacement of the `Radio`, `Switch` and `Checkbox` component.
	 * Use this component if you want to display an extra label.
	 */
	
	
	exports.styles = styles;
	var FormControlLabel = React.forwardRef(function FormControlLabel(props, ref) {
	  var checked = props.checked,
	      classes = props.classes,
	      className = props.className,
	      control = props.control,
	      disabledProp = props.disabled,
	      inputRef = props.inputRef,
	      label = props.label,
	      _props$labelPlacement = props.labelPlacement,
	      labelPlacement = _props$labelPlacement === void 0 ? 'end' : _props$labelPlacement,
	      name = props.name,
	      onChange = props.onChange,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "className", "control", "disabled", "inputRef", "label", "labelPlacement", "name", "onChange", "value"]);
	  var muiFormControl = (0, _FormControl.useFormControl)();
	  var disabled = disabledProp;
	
	  if (typeof disabled === 'undefined' && typeof control.props.disabled !== 'undefined') {
	    disabled = control.props.disabled;
	  }
	
	  if (typeof disabled === 'undefined' && muiFormControl) {
	    disabled = muiFormControl.disabled;
	  }
	
	  var controlProps = {
	    disabled: disabled
	  };
	  ['checked', 'name', 'onChange', 'value', 'inputRef'].forEach(function (key) {
	    if (typeof control.props[key] === 'undefined' && typeof props[key] !== 'undefined') {
	      controlProps[key] = props[key];
	    }
	  });
	  return /*#__PURE__*/React.createElement("label", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, labelPlacement !== 'end' && classes["labelPlacement".concat((0, _capitalize.default)(labelPlacement))], disabled && classes.disabled),
	    ref: ref
	  }, other), React.cloneElement(control, controlProps), /*#__PURE__*/React.createElement(_Typography.default, {
	    component: "span",
	    className: (0, _clsx.default)(classes.label, disabled && classes.disabled)
	  }, label));
	});
	 false ? FormControlLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component appears selected.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A control element. For instance, it can be be a `Radio`, a `Switch` or a `Checkbox`.
	   */
	  control: _propTypes.default.element.isRequired,
	
	  /**
	   * If `true`, the control will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The text to be used in an enclosing label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The position of the label.
	   */
	  labelPlacement: _propTypes.default.oneOf(['bottom', 'end', 'start', 'top']),
	
	  /**
	   * @ignore
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The value of the component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormControlLabel'
	})(FormControlLabel);
	
	exports.default = _default;

/***/ },
/* 289 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _FormControlLabel.default;
	  }
	});
	
	var _FormControlLabel = _interopRequireDefault(__webpack_require__(288));

/***/ },
/* 290 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexDirection: 'column',
	    flexWrap: 'wrap'
	  },
	
	  /* Styles applied to the root element if `row={true}`. */
	  row: {
	    flexDirection: 'row'
	  }
	};
	/**
	 * `FormGroup` wraps controls such as `Checkbox` and `Switch`.
	 * It provides compact row layout.
	 * For the `Radio`, you should be using the `RadioGroup` component instead of this one.
	 */
	
	exports.styles = styles;
	var FormGroup = React.forwardRef(function FormGroup(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$row = props.row,
	      row = _props$row === void 0 ? false : _props$row,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "row"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, row && classes.row),
	    ref: ref
	  }, other));
	});
	 false ? FormGroup.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Display group of elements in a compact row.
	   */
	  row: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormGroup'
	})(FormGroup);
	
	exports.default = _default;

/***/ },
/* 291 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(43));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(36));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.caption, {
	      textAlign: 'left',
	      marginTop: 3,
	      margin: 0,
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      marginTop: 4
	    },
	
	    /* Styles applied to the root element if `variant="filled"` or `variant="outlined"`. */
	    contained: {
	      marginLeft: 14,
	      marginRight: 14
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {}
	  };
	};
	
	exports.styles = styles;
	var FormHelperText = React.forwardRef(function FormHelperText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'p' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      margin = props.margin,
	      required = props.required,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disabled", "error", "filled", "focused", "margin", "required", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant', 'margin', 'disabled', 'error', 'filled', 'focused', 'required']
	  });
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, (fcs.variant === 'filled' || fcs.variant === 'outlined') && classes.contained, className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required, fcs.margin === 'dense' && classes.marginDense),
	    ref: ref
	  }, other), children === ' ' ?
	  /*#__PURE__*/
	  // eslint-disable-next-line react/no-danger
	  React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : children);
	});
	 false ? FormHelperText.propTypes = {
	  /**
	   * The content of the component.
	   *
	   * If `' '` is provided, the component reserves one line height for displaying a future message.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the helper text should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, helper text should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the helper text should use focused classes key.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * If `true`, the helper text should use required classes key.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormHelperText'
	})(FormHelperText);
	
	exports.default = _default;

/***/ },
/* 292 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(43));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(36));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({
	      color: theme.palette.text.secondary
	    }, theme.typography.body1, {
	      lineHeight: 1,
	      padding: 0,
	      '&$focused': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }),
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {
	      '&$focused': {
	        color: theme.palette.secondary.main
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `filled={true}`. */
	    filled: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Styles applied to the asterisk element. */
	    asterisk: {
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var FormLabel = React.forwardRef(function FormLabel(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'label' : _props$component,
	      disabled = props.disabled,
	      error = props.error,
	      filled = props.filled,
	      focused = props.focused,
	      required = props.required,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "disabled", "error", "filled", "focused", "required"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['color', 'required', 'focused', 'disabled', 'error', 'filled']
	  });
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fcs.filled && classes.filled, fcs.focused && classes.focused, fcs.required && classes.required),
	    ref: ref
	  }, other), children, fcs.required && /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.asterisk, fcs.error && classes.error)
	  }, "\u2009", '*'));
	});
	 false ? FormLabel.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the label should be displayed in a disabled state.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label should use filled classes key.
	   */
	  filled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused (used by `FormGroup` components).
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiFormLabel'
	})(FormLabel);
	
	exports.default = _default;

/***/ },
/* 293 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _requirePropFactory = _interopRequireDefault(__webpack_require__(166));
	
	// A grid component using the following libs as inspiration.
	//
	// For the implementation:
	// - https://getbootstrap.com/docs/4.3/layout/grid/
	// - https://github.com/kristoferjoseph/flexboxgrid/blob/master/src/css/flexboxgrid.css
	// - https://github.com/roylee0704/react-flexbox-grid
	// - https://material.angularjs.org/latest/layout/introduction
	//
	// Follow this flexbox Guide to better understand the underlying model:
	// - https://css-tricks.com/snippets/css/a-guide-to-flexbox/
	var SPACINGS = [0, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10];
	var GRID_SIZES = ['auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12];
	
	function generateGrid(globalStyles, theme, breakpoint) {
	  var styles = {};
	  GRID_SIZES.forEach(function (size) {
	    var key = "grid-".concat(breakpoint, "-").concat(size);
	
	    if (size === true) {
	      // For the auto layouting
	      styles[key] = {
	        flexBasis: 0,
	        flexGrow: 1,
	        maxWidth: '100%'
	      };
	      return;
	    }
	
	    if (size === 'auto') {
	      styles[key] = {
	        flexBasis: 'auto',
	        flexGrow: 0,
	        maxWidth: 'none'
	      };
	      return;
	    } // Keep 7 significant numbers.
	
	
	    var width = "".concat(Math.round(size / 12 * 10e7) / 10e5, "%"); // Close to the bootstrap implementation:
	    // https://github.com/twbs/bootstrap/blob/8fccaa2439e97ec72a4b7dc42ccc1f649790adb0/scss/mixins/_grid.scss#L41
	
	    styles[key] = {
	      flexBasis: width,
	      flexGrow: 0,
	      maxWidth: width
	    };
	  }); // No need for a media query for the first size.
	
	  if (breakpoint === 'xs') {
	    (0, _extends2.default)(globalStyles, styles);
	  } else {
	    globalStyles[theme.breakpoints.up(breakpoint)] = styles;
	  }
	}
	
	function getOffset(val) {
	  var div = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 1;
	  var parse = parseFloat(val);
	  return "".concat(parse / div).concat(String(val).replace(String(parse), '') || 'px');
	}
	
	function generateGutter(theme, breakpoint) {
	  var styles = {};
	  SPACINGS.forEach(function (spacing) {
	    var themeSpacing = theme.spacing(spacing);
	
	    if (themeSpacing === 0) {
	      return;
	    }
	
	    styles["spacing-".concat(breakpoint, "-").concat(spacing)] = {
	      margin: "-".concat(getOffset(themeSpacing, 2)),
	      width: "calc(100% + ".concat(getOffset(themeSpacing), ")"),
	      '& > $item': {
	        padding: getOffset(themeSpacing, 2)
	      }
	    };
	  });
	  return styles;
	} // Default CSS values
	// flex: '0 1 auto',
	// flexDirection: 'row',
	// alignItems: 'flex-start',
	// flexWrap: 'nowrap',
	// justifyContent: 'flex-start',
	
	
	var styles = function styles(theme) {
	  return (0, _extends2.default)({
	    /* Styles applied to the root element */
	    root: {},
	
	    /* Styles applied to the root element if `container={true}`. */
	    container: {
	      boxSizing: 'border-box',
	      display: 'flex',
	      flexWrap: 'wrap',
	      width: '100%'
	    },
	
	    /* Styles applied to the root element if `item={true}`. */
	    item: {
	      boxSizing: 'border-box',
	      margin: '0' // For instance, it's useful when used with a `figure` element.
	
	    },
	
	    /* Styles applied to the root element if `zeroMinWidth={true}`. */
	    zeroMinWidth: {
	      minWidth: 0
	    },
	
	    /* Styles applied to the root element if `direction="column"`. */
	    'direction-xs-column': {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the root element if `direction="column-reverse"`. */
	    'direction-xs-column-reverse': {
	      flexDirection: 'column-reverse'
	    },
	
	    /* Styles applied to the root element if `direction="row-reverse"`. */
	    'direction-xs-row-reverse': {
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `wrap="nowrap"`. */
	    'wrap-xs-nowrap': {
	      flexWrap: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `wrap="reverse"`. */
	    'wrap-xs-wrap-reverse': {
	      flexWrap: 'wrap-reverse'
	    },
	
	    /* Styles applied to the root element if `alignItems="center"`. */
	    'align-items-xs-center': {
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `alignItems="flex-start"`. */
	    'align-items-xs-flex-start': {
	      alignItems: 'flex-start'
	    },
	
	    /* Styles applied to the root element if `alignItems="flex-end"`. */
	    'align-items-xs-flex-end': {
	      alignItems: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `alignItems="baseline"`. */
	    'align-items-xs-baseline': {
	      alignItems: 'baseline'
	    },
	
	    /* Styles applied to the root element if `alignContent="center"`. */
	    'align-content-xs-center': {
	      alignContent: 'center'
	    },
	
	    /* Styles applied to the root element if `alignContent="flex-start"`. */
	    'align-content-xs-flex-start': {
	      alignContent: 'flex-start'
	    },
	
	    /* Styles applied to the root element if `alignContent="flex-end"`. */
	    'align-content-xs-flex-end': {
	      alignContent: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `alignContent="space-between"`. */
	    'align-content-xs-space-between': {
	      alignContent: 'space-between'
	    },
	
	    /* Styles applied to the root element if `alignContent="space-around"`. */
	    'align-content-xs-space-around': {
	      alignContent: 'space-around'
	    },
	
	    /* Styles applied to the root element if `justify="center"`. */
	    'justify-xs-center': {
	      justifyContent: 'center'
	    },
	
	    /* Styles applied to the root element if `justify="flex-end"`. */
	    'justify-xs-flex-end': {
	      justifyContent: 'flex-end'
	    },
	
	    /* Styles applied to the root element if `justify="space-between"`. */
	    'justify-xs-space-between': {
	      justifyContent: 'space-between'
	    },
	
	    /* Styles applied to the root element if `justify="space-around"`. */
	    'justify-xs-space-around': {
	      justifyContent: 'space-around'
	    },
	
	    /* Styles applied to the root element if `justify="space-evenly"`. */
	    'justify-xs-space-evenly': {
	      justifyContent: 'space-evenly'
	    }
	  }, generateGutter(theme, 'xs'), {}, theme.breakpoints.keys.reduce(function (accumulator, key) {
	    // Use side effect over immutability for better performance.
	    generateGrid(accumulator, theme, key);
	    return accumulator;
	  }, {}));
	};
	
	exports.styles = styles;
	var Grid = React.forwardRef(function Grid(props, ref) {
	  var _props$alignContent = props.alignContent,
	      alignContent = _props$alignContent === void 0 ? 'stretch' : _props$alignContent,
	      _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'stretch' : _props$alignItems,
	      classes = props.classes,
	      classNameProp = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$container = props.container,
	      container = _props$container === void 0 ? false : _props$container,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'row' : _props$direction,
	      _props$item = props.item,
	      item = _props$item === void 0 ? false : _props$item,
	      _props$justify = props.justify,
	      justify = _props$justify === void 0 ? 'flex-start' : _props$justify,
	      _props$lg = props.lg,
	      lg = _props$lg === void 0 ? false : _props$lg,
	      _props$md = props.md,
	      md = _props$md === void 0 ? false : _props$md,
	      _props$sm = props.sm,
	      sm = _props$sm === void 0 ? false : _props$sm,
	      _props$spacing = props.spacing,
	      spacing = _props$spacing === void 0 ? 0 : _props$spacing,
	      _props$wrap = props.wrap,
	      wrap = _props$wrap === void 0 ? 'wrap' : _props$wrap,
	      _props$xl = props.xl,
	      xl = _props$xl === void 0 ? false : _props$xl,
	      _props$xs = props.xs,
	      xs = _props$xs === void 0 ? false : _props$xs,
	      _props$zeroMinWidth = props.zeroMinWidth,
	      zeroMinWidth = _props$zeroMinWidth === void 0 ? false : _props$zeroMinWidth,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignContent", "alignItems", "classes", "className", "component", "container", "direction", "item", "justify", "lg", "md", "sm", "spacing", "wrap", "xl", "xs", "zeroMinWidth"]);
	  var className = (0, _clsx.default)(classes.root, classNameProp, container && [classes.container, spacing !== 0 && classes["spacing-xs-".concat(String(spacing))]], item && classes.item, zeroMinWidth && classes.zeroMinWidth, direction !== 'row' && classes["direction-xs-".concat(String(direction))], wrap !== 'wrap' && classes["wrap-xs-".concat(String(wrap))], alignItems !== 'stretch' && classes["align-items-xs-".concat(String(alignItems))], alignContent !== 'stretch' && classes["align-content-xs-".concat(String(alignContent))], justify !== 'flex-start' && classes["justify-xs-".concat(String(justify))], xs !== false && classes["grid-xs-".concat(String(xs))], sm !== false && classes["grid-sm-".concat(String(sm))], md !== false && classes["grid-md-".concat(String(md))], lg !== false && classes["grid-lg-".concat(String(lg))], xl !== false && classes["grid-xl-".concat(String(xl))]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: className,
	    ref: ref
	  }, other));
	});
	 false ? Grid.propTypes = {
	  /**
	   * Defines the `align-content` style property.
	   * It's applied for all screen sizes.
	   */
	  alignContent: _propTypes.default.oneOf(['stretch', 'center', 'flex-start', 'flex-end', 'space-between', 'space-around']),
	
	  /**
	   * Defines the `align-items` style property.
	   * It's applied for all screen sizes.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'stretch', 'baseline']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the component will have the flex *container* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  container: _propTypes.default.bool,
	
	  /**
	   * Defines the `flex-direction` style property.
	   * It is applied for all screen sizes.
	   */
	  direction: _propTypes.default.oneOf(['row', 'row-reverse', 'column', 'column-reverse']),
	
	  /**
	   * If `true`, the component will have the flex *item* behavior.
	   * You should be wrapping *items* with a *container*.
	   */
	  item: _propTypes.default.bool,
	
	  /**
	   * Defines the `justify-content` style property.
	   * It is applied for all screen sizes.
	   */
	  justify: _propTypes.default.oneOf(['flex-start', 'center', 'flex-end', 'space-between', 'space-around', 'space-evenly']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `lg` breakpoint and wider screens if not overridden.
	   */
	  lg: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `md` breakpoint and wider screens if not overridden.
	   */
	  md: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `sm` breakpoint and wider screens if not overridden.
	   */
	  sm: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the space between the type `item` component.
	   * It can only be used on a type `container` component.
	   */
	  spacing: _propTypes.default.oneOf(SPACINGS),
	
	  /**
	   * Defines the `flex-wrap` style property.
	   * It's applied for all screen sizes.
	   */
	  wrap: _propTypes.default.oneOf(['nowrap', 'wrap', 'wrap-reverse']),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for the `xl` breakpoint and wider screens.
	   */
	  xl: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * Defines the number of grids the component is going to use.
	   * It's applied for all the screen sizes with the lowest priority.
	   */
	  xs: _propTypes.default.oneOf([false, 'auto', true, 1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11, 12]),
	
	  /**
	   * If `true`, it sets `min-width: 0` on the item.
	   * Refer to the limitations section of the documentation to better understand the use case.
	   */
	  zeroMinWidth: _propTypes.default.bool
	} : void 0;
	var StyledGrid = (0, _withStyles.default)(styles, {
	  name: 'MuiGrid'
	})(Grid);
	
	if (false) {
	  var requireProp = (0, _requirePropFactory.default)('Grid');
	  StyledGrid.propTypes = (0, _extends2.default)({}, StyledGrid.propTypes, {
	    alignContent: requireProp('container'),
	    alignItems: requireProp('container'),
	    direction: requireProp('container'),
	    justify: requireProp('container'),
	    lg: requireProp('item'),
	    md: requireProp('item'),
	    sm: requireProp('item'),
	    spacing: requireProp('container'),
	    wrap: requireProp('container'),
	    xs: requireProp('item'),
	    zeroMinWidth: requireProp('item')
	  });
	}
	
	var _default = StyledGrid;
	exports.default = _default;

/***/ },
/* 294 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Grid.default;
	  }
	});
	
	var _Grid = _interopRequireDefault(__webpack_require__(293));

/***/ },
/* 295 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(18);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    flexWrap: 'wrap',
	    overflowY: 'auto',
	    listStyle: 'none',
	    padding: 0,
	    WebkitOverflowScrolling: 'touch' // Add iOS momentum scrolling.
	
	  }
	};
	exports.styles = styles;
	var GridList = React.forwardRef(function GridList(props, ref) {
	  var _props$cellHeight = props.cellHeight,
	      cellHeight = _props$cellHeight === void 0 ? 180 : _props$cellHeight,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$cols = props.cols,
	      cols = _props$cols === void 0 ? 2 : _props$cols,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$spacing = props.spacing,
	      spacing = _props$spacing === void 0 ? 4 : _props$spacing,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["cellHeight", "children", "classes", "className", "cols", "component", "spacing", "style"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    style: (0, _extends2.default)({
	      margin: -spacing / 2
	    }, style)
	  }, other), React.Children.map(children, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the GridList component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childCols = child.props.cols || 1;
	    var childRows = child.props.rows || 1;
	    return React.cloneElement(child, {
	      style: (0, _extends2.default)({
	        width: "".concat(100 / cols * childCols, "%"),
	        height: cellHeight === 'auto' ? 'auto' : cellHeight * childRows + spacing,
	        padding: spacing / 2
	      }, child.props.style)
	    });
	  }));
	});
	 false ? GridList.propTypes = {
	  /**
	   * Number of px for one cell height.
	   * You can set `'auto'` if you want to let the children determine the height.
	   */
	  cellHeight: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.oneOf(['auto'])]),
	
	  /**
	   * Grid Tiles that will be in Grid List.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Number of columns.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Number of px for the spacing between tiles.
	   */
	  spacing: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridList'
	})(GridList);
	
	exports.default = _default;

/***/ },
/* 296 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridList.default;
	  }
	});
	
	var _GridList = _interopRequireDefault(__webpack_require__(295));

/***/ },
/* 297 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _debounce = _interopRequireDefault(__webpack_require__(37));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(55));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    boxSizing: 'border-box',
	    flexShrink: 0
	  },
	
	  /* Styles applied to the `div` element that wraps the children. */
	  tile: {
	    position: 'relative',
	    display: 'block',
	    // In case it's not rendered with a div.
	    height: '100%',
	    overflow: 'hidden'
	  },
	
	  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
	  imgFullHeight: {
	    height: '100%',
	    transform: 'translateX(-50%)',
	    position: 'relative',
	    left: '50%'
	  },
	
	  /* Styles applied to an `img` element child, if needed to ensure it covers the tile. */
	  imgFullWidth: {
	    width: '100%',
	    position: 'relative',
	    transform: 'translateY(-50%)',
	    top: '50%'
	  }
	};
	exports.styles = styles;
	
	var fit = function fit(imgEl, classes) {
	  if (!imgEl || !imgEl.complete) {
	    return;
	  }
	
	  if (imgEl.width / imgEl.height > imgEl.parentElement.offsetWidth / imgEl.parentElement.offsetHeight) {
	    var _imgEl$classList, _imgEl$classList2;
	
	    (_imgEl$classList = imgEl.classList).remove.apply(_imgEl$classList, (0, _toConsumableArray2.default)(classes.imgFullWidth.split(' ')));
	
	    (_imgEl$classList2 = imgEl.classList).add.apply(_imgEl$classList2, (0, _toConsumableArray2.default)(classes.imgFullHeight.split(' ')));
	  } else {
	    var _imgEl$classList3, _imgEl$classList4;
	
	    (_imgEl$classList3 = imgEl.classList).remove.apply(_imgEl$classList3, (0, _toConsumableArray2.default)(classes.imgFullHeight.split(' ')));
	
	    (_imgEl$classList4 = imgEl.classList).add.apply(_imgEl$classList4, (0, _toConsumableArray2.default)(classes.imgFullWidth.split(' ')));
	  }
	};
	
	function ensureImageCover(imgEl, classes) {
	  if (!imgEl) {
	    return;
	  }
	
	  if (imgEl.complete) {
	    fit(imgEl, classes);
	  } else {
	    imgEl.addEventListener('load', function () {
	      fit(imgEl, classes);
	    });
	  }
	}
	
	var GridListTile = React.forwardRef(function GridListTile(props, ref) {
	  // cols rows default values are for docs only
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$cols = props.cols,
	      cols = _props$cols === void 0 ? 1 : _props$cols,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$rows = props.rows,
	      rows = _props$rows === void 0 ? 1 : _props$rows,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "cols", "component", "rows"]);
	  var imgRef = React.useRef(null);
	  React.useEffect(function () {
	    ensureImageCover(imgRef.current, classes);
	  });
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      fit(imgRef.current, classes);
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [classes]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: classes.tile
	  }, React.Children.map(children, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (child.type === 'img' || (0, _isMuiElement.default)(child, ['Image'])) {
	      return React.cloneElement(child, {
	        ref: imgRef
	      });
	    }
	
	    return child;
	  })));
	});
	 false ? GridListTile.propTypes = {
	  /**
	   * Theoretically you can pass any node as children, but the main use case is to pass an img,
	   * in which case GridListTile takes care of making the image "cover" available space
	   * (similar to `background-size: cover` or to `object-fit: cover`).
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Width of the tile in number of grid cells.
	   */
	  cols: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Height of the tile in number of grid cells.
	   */
	  rows: _propTypes.default.number
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTile'
	})(GridListTile);
	
	exports.default = _default;

/***/ },
/* 298 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTile.default;
	  }
	});
	
	var _GridListTile = _interopRequireDefault(__webpack_require__(297));

/***/ },
/* 299 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      left: 0,
	      right: 0,
	      height: 48,
	      background: 'rgba(0, 0, 0, 0.5)',
	      display: 'flex',
	      alignItems: 'center',
	      fontFamily: theme.typography.fontFamily
	    },
	
	    /* Styles applied to the root element if `titlePosition="bottom"`. */
	    titlePositionBottom: {
	      bottom: 0
	    },
	
	    /* Styles applied to the root element if `titlePosition="top"`. */
	    titlePositionTop: {
	      top: 0
	    },
	
	    /* Styles applied to the root element if a `subtitle` is provided. */
	    rootSubtitle: {
	      height: 68
	    },
	
	    /* Styles applied to the title and subtitle container element. */
	    titleWrap: {
	      flexGrow: 1,
	      marginLeft: 16,
	      marginRight: 16,
	      color: theme.palette.common.white,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the container element if `actionPosition="left"`. */
	    titleWrapActionPosLeft: {
	      marginLeft: 0
	    },
	
	    /* Styles applied to the container element if `actionPosition="right"`. */
	    titleWrapActionPosRight: {
	      marginRight: 0
	    },
	
	    /* Styles applied to the title container element. */
	    title: {
	      fontSize: theme.typography.pxToRem(16),
	      lineHeight: '24px',
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the subtitle container element. */
	    subtitle: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1,
	      textOverflow: 'ellipsis',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the actionIcon if supplied. */
	    actionIcon: {},
	
	    /* Styles applied to the actionIcon if `actionPosition="left"`. */
	    actionIconActionPosLeft: {
	      order: -1
	    }
	  };
	};
	
	exports.styles = styles;
	var GridListTileBar = React.forwardRef(function GridListTileBar(props, ref) {
	  var actionIcon = props.actionIcon,
	      _props$actionPosition = props.actionPosition,
	      actionPosition = _props$actionPosition === void 0 ? 'right' : _props$actionPosition,
	      classes = props.classes,
	      className = props.className,
	      subtitle = props.subtitle,
	      title = props.title,
	      _props$titlePosition = props.titlePosition,
	      titlePosition = _props$titlePosition === void 0 ? 'bottom' : _props$titlePosition,
	      other = (0, _objectWithoutProperties2.default)(props, ["actionIcon", "actionPosition", "classes", "className", "subtitle", "title", "titlePosition"]);
	  var actionPos = actionIcon && actionPosition;
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, titlePosition === 'top' ? classes.titlePositionTop : classes.titlePositionBottom, subtitle && classes.rootSubtitle),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.titleWrap, {
	      'left': classes.titleWrapActionPosLeft,
	      'right': classes.titleWrapActionPosRight
	    }[actionPos])
	  }, /*#__PURE__*/React.createElement("div", {
	    className: classes.title
	  }, title), subtitle ? /*#__PURE__*/React.createElement("div", {
	    className: classes.subtitle
	  }, subtitle) : null), actionIcon ? /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.actionIcon, actionPos === 'left' && classes.actionIconActionPosLeft)
	  }, actionIcon) : null);
	});
	 false ? GridListTileBar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * An IconButton element to be used as secondary action target
	   * (primary action target is the tile itself).
	   */
	  actionIcon: _propTypes.default.node,
	
	  /**
	   * Position of secondary action IconButton.
	   */
	  actionPosition: _propTypes.default.oneOf(['left', 'right']),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * String or element serving as subtitle (support text).
	   */
	  subtitle: _propTypes.default.node,
	
	  /**
	   * Title to be displayed on tile.
	   */
	  title: _propTypes.default.node,
	
	  /**
	   * Position of the title bar.
	   */
	  titlePosition: _propTypes.default.oneOf(['bottom', 'top'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiGridListTileBar'
	})(GridListTileBar);
	
	exports.default = _default;

/***/ },
/* 300 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _GridListTileBar.default;
	  }
	});
	
	var _GridListTileBar = _interopRequireDefault(__webpack_require__(299));

/***/ },
/* 301 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(46);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var _utils = __webpack_require__(44);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	function getScale(value) {
	  return "scale(".concat(value, ", ").concat(Math.pow(value, 2), ")");
	}
	
	var styles = {
	  entering: {
	    opacity: 1,
	    transform: getScale(1)
	  },
	  entered: {
	    opacity: 1,
	    transform: 'none'
	  }
	};
	/**
	 * The Grow transition is used by the [Tooltip](/components/tooltips/) and
	 * [Popover](/components/popover/) components.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Grow = React.forwardRef(function Grow(props, ref) {
	  var children = props.children,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onExit = props.onExit,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? 'auto' : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);
	  var timer = React.useRef();
	  var autoTimeout = React.useRef();
	  var handleRef = (0, _useForkRef.default)(children.ref, ref);
	  var theme = (0, _useTheme.default)();
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var _getTransitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    }),
	        transitionDuration = _getTransitionProps.duration,
	        delay = _getTransitionProps.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay
	    })].join(',');
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var _getTransitionProps2 = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    }),
	        transitionDuration = _getTransitionProps2.duration,
	        delay = _getTransitionProps2.delay;
	
	    var duration;
	
	    if (timeout === 'auto') {
	      duration = theme.transitions.getAutoHeightDuration(node.clientHeight);
	      autoTimeout.current = duration;
	    } else {
	      duration = transitionDuration;
	    }
	
	    node.style.transition = [theme.transitions.create('opacity', {
	      duration: duration,
	      delay: delay
	    }), theme.transitions.create('transform', {
	      duration: duration * 0.666,
	      delay: delay || duration * 0.333
	    })].join(',');
	    node.style.opacity = '0';
	    node.style.transform = getScale(0.75);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  var addEndListener = function addEndListener(_, next) {
	    if (timeout === 'auto') {
	      timer.current = setTimeout(next, autoTimeout.current || 0);
	    }
	  };
	
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(timer.current);
	    };
	  }, []);
	  return /*#__PURE__*/React.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    onEnter: handleEnter,
	    onExit: handleExit,
	    addEndListener: addEndListener,
	    timeout: timeout === 'auto' ? null : timeout
	  }, other), function (state, childProps) {
	    return React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        opacity: 0,
	        transform: getScale(0.75),
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], {}, style, {}, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Grow.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	Grow.muiSupportAuto = true;
	var _default = Grow;
	exports.default = _default;

/***/ },
/* 302 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _HiddenJs = _interopRequireDefault(__webpack_require__(304));
	
	var _HiddenCss = _interopRequireDefault(__webpack_require__(303));
	
	/**
	 * Responsively hides children based on the selected implementation.
	 */
	function Hidden(props) {
	  var _props$implementation = props.implementation,
	      implementation = _props$implementation === void 0 ? 'js' : _props$implementation,
	      _props$lgDown = props.lgDown,
	      lgDown = _props$lgDown === void 0 ? false : _props$lgDown,
	      _props$lgUp = props.lgUp,
	      lgUp = _props$lgUp === void 0 ? false : _props$lgUp,
	      _props$mdDown = props.mdDown,
	      mdDown = _props$mdDown === void 0 ? false : _props$mdDown,
	      _props$mdUp = props.mdUp,
	      mdUp = _props$mdUp === void 0 ? false : _props$mdUp,
	      _props$smDown = props.smDown,
	      smDown = _props$smDown === void 0 ? false : _props$smDown,
	      _props$smUp = props.smUp,
	      smUp = _props$smUp === void 0 ? false : _props$smUp,
	      _props$xlDown = props.xlDown,
	      xlDown = _props$xlDown === void 0 ? false : _props$xlDown,
	      _props$xlUp = props.xlUp,
	      xlUp = _props$xlUp === void 0 ? false : _props$xlUp,
	      _props$xsDown = props.xsDown,
	      xsDown = _props$xsDown === void 0 ? false : _props$xsDown,
	      _props$xsUp = props.xsUp,
	      xsUp = _props$xsUp === void 0 ? false : _props$xsUp,
	      other = (0, _objectWithoutProperties2.default)(props, ["implementation", "lgDown", "lgUp", "mdDown", "mdUp", "smDown", "smUp", "xlDown", "xlUp", "xsDown", "xsUp"]);
	
	  if (implementation === 'js') {
	    return /*#__PURE__*/React.createElement(_HiddenJs.default, (0, _extends2.default)({
	      lgDown: lgDown,
	      lgUp: lgUp,
	      mdDown: mdDown,
	      mdUp: mdUp,
	      smDown: smDown,
	      smUp: smUp,
	      xlDown: xlDown,
	      xlUp: xlUp,
	      xsDown: xsDown,
	      xsUp: xsUp
	    }, other));
	  }
	
	  return /*#__PURE__*/React.createElement(_HiddenCss.default, (0, _extends2.default)({
	    lgDown: lgDown,
	    lgUp: lgUp,
	    mdDown: mdDown,
	    mdUp: mdUp,
	    smDown: smDown,
	    smUp: smUp,
	    xlDown: xlDown,
	    xlUp: xlUp,
	    xsDown: xsDown,
	    xsUp: xsUp
	  }, other));
	}
	
	 false ? Hidden.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this prop when choosing the `js` implementation with server-side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty component during the first mount.
	   * You might want to use an heuristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * https://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : void 0;
	var _default = Hidden;
	exports.default = _default;

/***/ },
/* 303 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var styles = function styles(theme) {
	  var hidden = {
	    display: 'none'
	  };
	  return theme.breakpoints.keys.reduce(function (acc, key) {
	    acc["only".concat((0, _capitalize.default)(key))] = (0, _defineProperty2.default)({}, theme.breakpoints.only(key), hidden);
	    acc["".concat(key, "Up")] = (0, _defineProperty2.default)({}, theme.breakpoints.up(key), hidden);
	    acc["".concat(key, "Down")] = (0, _defineProperty2.default)({}, theme.breakpoints.down(key), hidden);
	    return acc;
	  }, {});
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function HiddenCss(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      only = props.only,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "only"]);
	  var theme = (0, _useTheme.default)();
	
	  if (false) {
	    var unknownProps = Object.keys(other).filter(function (propName) {
	      var isUndeclaredBreakpoint = !theme.breakpoints.keys.some(function (breakpoint) {
	        return "".concat(breakpoint, "Up") === propName || "".concat(breakpoint, "Down") === propName;
	      });
	      return isUndeclaredBreakpoint;
	    });
	
	    if (unknownProps.length > 0) {
	      console.error("Material-UI: unsupported props received by `<Hidden implementation=\"css\" />`: ".concat(unknownProps.join(', '), ". Did you forget to wrap this component in a ThemeProvider declaring these breakpoints?"));
	    }
	  }
	
	  var clsx = [];
	
	  if (className) {
	    clsx.push(className);
	  }
	
	  for (var i = 0; i < theme.breakpoints.keys.length; i += 1) {
	    var breakpoint = theme.breakpoints.keys[i];
	    var breakpointUp = props["".concat(breakpoint, "Up")];
	    var breakpointDown = props["".concat(breakpoint, "Down")];
	
	    if (breakpointUp) {
	      clsx.push(classes["".concat(breakpoint, "Up")]);
	    }
	
	    if (breakpointDown) {
	      clsx.push(classes["".concat(breakpoint, "Down")]);
	    }
	  }
	
	  if (only) {
	    var onlyBreakpoints = Array.isArray(only) ? only : [only];
	    onlyBreakpoints.forEach(function (breakpoint) {
	      clsx.push(classes["only".concat((0, _capitalize.default)(breakpoint))]);
	    });
	  }
	
	  return /*#__PURE__*/React.createElement("div", {
	    className: clsx.join(' ')
	  }, children);
	}
	
	 false ? HiddenCss.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateHiddenCss'
	})(HiddenCss);
	
	exports.default = _default;

/***/ },
/* 304 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(9);
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(90));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	/**
	 * @ignore - internal component.
	 */
	function HiddenJs(props) {
	  var children = props.children,
	      only = props.only,
	      width = props.width;
	  var theme = (0, _useTheme.default)();
	  var visible = true; // `only` check is faster to get out sooner if used.
	
	  if (only) {
	    if (Array.isArray(only)) {
	      for (var i = 0; i < only.length; i += 1) {
	        var breakpoint = only[i];
	
	        if (width === breakpoint) {
	          visible = false;
	          break;
	        }
	      }
	    } else if (only && width === only) {
	      visible = false;
	    }
	  } // Allow `only` to be combined with other props. If already hidden, no need to check others.
	
	
	  if (visible) {
	    // determine visibility based on the smallest size up
	    for (var _i = 0; _i < theme.breakpoints.keys.length; _i += 1) {
	      var _breakpoint = theme.breakpoints.keys[_i];
	      var breakpointUp = props["".concat(_breakpoint, "Up")];
	      var breakpointDown = props["".concat(_breakpoint, "Down")];
	
	      if (breakpointUp && (0, _withWidth.isWidthUp)(_breakpoint, width) || breakpointDown && (0, _withWidth.isWidthDown)(_breakpoint, width)) {
	        visible = false;
	        break;
	      }
	    }
	  }
	
	  if (!visible) {
	    return null;
	  }
	
	  return children;
	}
	
	HiddenJs.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Specify which implementation to use.  'js' is the default, 'css' works better for
	   * server-side rendering.
	   */
	  implementation: _propTypes.default.oneOf(['js', 'css']),
	
	  /**
	   * You can use this prop when choosing the `js` implementation with server-side rendering.
	   *
	   * As `window.innerWidth` is unavailable on the server,
	   * we default to rendering an empty component during the first mount.
	   * You might want to use an heuristic to approximate
	   * the screen width of the client browser screen width.
	   *
	   * For instance, you could be using the user-agent or the client-hints.
	   * https://caniuse.com/#search=client%20hint
	   */
	  initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  lgDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  lgUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  mdDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  mdUp: _propTypes.default.bool,
	
	  /**
	   * Hide the given breakpoint(s).
	   */
	  only: _propTypes.default.oneOfType([_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']), _propTypes.default.arrayOf(_propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']))]),
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  smDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  smUp: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * width prop provided by withWidth decorator.
	   */
	  width: _propTypes.default.string.isRequired,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xlDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xlUp: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and down will be hidden.
	   */
	  xsDown: _propTypes.default.bool,
	
	  /**
	   * If `true`, screens this size and up will be hidden.
	   */
	  xsUp: _propTypes.default.bool
	};
	
	if (false) {
	  HiddenJs.propTypes = (0, _utils.exactProp)(HiddenJs.propTypes);
	}
	
	var _default = (0, _withWidth.default)()(HiddenJs);
	
	exports.default = _default;

/***/ },
/* 305 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Hidden.default;
	  }
	});
	
	var _Hidden = _interopRequireDefault(__webpack_require__(302));

/***/ },
/* 306 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      fontSize: theme.typography.pxToRem(24),
	      width: '1em',
	      height: '1em',
	      // Chrome fix for https://bugs.chromium.org/p/chromium/issues/detail?id=820541
	      // To remove at some point.
	      overflow: 'hidden',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(36)
	    }
	  };
	};
	
	exports.styles = styles;
	var Icon = React.forwardRef(function Icon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "fontSize"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)('material-icons', classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _capitalize.default)(fontSize))]),
	    "aria-hidden": true,
	    ref: ref
	  }, other));
	});
	 false ? Icon.propTypes = {
	  /**
	   * The name of the icon font ligature.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['inherit', 'primary', 'secondary', 'action', 'error', 'disabled']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['inherit', 'default', 'small', 'large'])
	} : void 0;
	Icon.muiName = 'Icon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIcon'
	})(Icon);
	
	exports.default = _default;

/***/ },
/* 307 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Icon.default;
	  }
	});
	
	var _Icon = _interopRequireDefault(__webpack_require__(306));

/***/ },
/* 308 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      textAlign: 'center',
	      flex: '0 0 auto',
	      fontSize: theme.typography.pxToRem(24),
	      padding: 12,
	      borderRadius: '50%',
	      overflow: 'visible',
	      // Explicitly set the default value to solve a bug on IE 11.
	      color: theme.palette.action.active,
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.action.active, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      },
	      '&$disabled': {
	        backgroundColor: 'transparent',
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -12,
	      '$sizeSmall&': {
	        marginLeft: -3
	      }
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -12,
	      '$sizeSmall&': {
	        marginRight: -3
	      }
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main,
	      '&:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: 3,
	      fontSize: theme.typography.pxToRem(18)
	    },
	
	    /* Styles applied to the children container element. */
	    label: {
	      width: '100%',
	      display: 'flex',
	      alignItems: 'inherit',
	      justifyContent: 'inherit'
	    }
	  };
	};
	/**
	 * Refer to the [Icons](/components/icons/) section of the documentation
	 * regarding the available icon options.
	 */
	
	
	exports.styles = styles;
	var IconButton = React.forwardRef(function IconButton(props, ref) {
	  var _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["edge", "children", "classes", "className", "color", "disabled", "disableFocusRipple", "size"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], disabled && classes.disabled, size === "small" && classes["size".concat((0, _capitalize.default)(size))], {
	      'start': classes.edgeStart,
	      'end': classes.edgeEnd
	    }[edge]),
	    centerRipple: true,
	    focusRipple: !disableFocusRipple,
	    disabled: disabled,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, children));
	});
	 false ? IconButton.propTypes = {
	  /**
	   * The icon element.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var found = React.Children.toArray(props.children).some(function (child) {
	      return React.isValidElement(child) && child.props.onClick;
	    });
	
	    if (found) {
	      return new Error(['Material-UI: you are providing an onClick event listener ' + 'to a child of a button element.', 'Firefox will never trigger the event.', 'You should move the onClick listener to the parent button element.', 'https://github.com/mui-org/material-ui/issues/13957'].join('\n'));
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the button will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['start', 'end', false]),
	
	  /**
	   * The size of the button.
	   * `small` is equivalent to the dense button styling.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiIconButton'
	})(IconButton);
	
	exports.default = _default;

/***/ },
/* 309 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(49));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var bottomLineColor = light ? 'rgba(0, 0, 0, 0.42)' : 'rgba(255, 255, 255, 0.7)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative'
	    },
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      'label + &': {
	        marginTop: 16
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if color secondary. */
	    colorSecondary: {
	      '&$underline:after': {
	        borderBottomColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if `disableUnderline={false}`. */
	    underline: {
	      '&:after': {
	        borderBottom: "2px solid ".concat(theme.palette.primary.main),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '""',
	        position: 'absolute',
	        right: 0,
	        transform: 'scaleX(0)',
	        transition: theme.transitions.create('transform', {
	          duration: theme.transitions.duration.shorter,
	          easing: theme.transitions.easing.easeOut
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&$focused:after': {
	        transform: 'scaleX(1)'
	      },
	      '&$error:after': {
	        borderBottomColor: theme.palette.error.main,
	        transform: 'scaleX(1)' // error is always underlined in red
	
	      },
	      '&:before': {
	        borderBottom: "1px solid ".concat(bottomLineColor),
	        left: 0,
	        bottom: 0,
	        // Doing the other way around crash on IE 11 "''" https://github.com/cssinjs/jss/issues/242
	        content: '"\\00a0"',
	        position: 'absolute',
	        right: 0,
	        transition: theme.transitions.create('border-bottom-color', {
	          duration: theme.transitions.duration.shorter
	        }),
	        pointerEvents: 'none' // Transparent to the hover style.
	
	      },
	      '&:hover:not($disabled):before': {
	        borderBottom: "2px solid ".concat(theme.palette.text.primary),
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          borderBottom: "1px solid ".concat(bottomLineColor)
	        }
	      },
	      '&$disabled:before': {
	        borderBottomStyle: 'dotted'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {},
	
	    /* Styles applied to the `input` element. */
	    input: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {},
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {},
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {}
	  };
	};
	
	exports.styles = styles;
	var Input = React.forwardRef(function Input(props, ref) {
	  var disableUnderline = props.disableUnderline,
	      classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["disableUnderline", "classes", "fullWidth", "inputComponent", "multiline", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, !disableUnderline && classes.underline),
	      underline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? Input.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will not have an underline.
	   */
	  disableUnderline: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	Input.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInput'
	})(Input);
	
	exports.default = _default;

/***/ },
/* 310 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(62));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    height: '0.01em',
	    // Fix IE 11 flexbox alignment. To remove at some point.
	    maxHeight: '2em',
	    alignItems: 'center',
	    whiteSpace: 'nowrap'
	  },
	
	  /* Styles applied to the root element if `variant="filled"`. */
	  filled: {
	    '&$positionStart:not($hiddenLabel)': {
	      marginTop: 16
	    }
	  },
	
	  /* Styles applied to the root element if `position="start"`. */
	  positionStart: {
	    marginRight: 8
	  },
	
	  /* Styles applied to the root element if `position="end"`. */
	  positionEnd: {
	    marginLeft: 8
	  },
	
	  /* Styles applied to the root element if `disablePointerEvents=true`. */
	  disablePointerEvents: {
	    pointerEvents: 'none'
	  },
	
	  /* Styles applied if the adornment is used inside <FormControl hiddenLabel />. */
	  hiddenLabel: {},
	
	  /* Styles applied if the adornment is used inside <FormControl margin="dense" />. */
	  marginDense: {}
	};
	exports.styles = styles;
	var InputAdornment = React.forwardRef(function InputAdornment(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disablePointer = props.disablePointerEvents,
	      disablePointerEvents = _props$disablePointer === void 0 ? false : _props$disablePointer,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      position = props.position,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "disablePointerEvents", "disableTypography", "position", "variant"]);
	  var muiFormControl = (0, _FormControlContext.useFormControl)() || {};
	  var variant = variantProp;
	
	  if (variantProp && muiFormControl.variant) {
	    if (false) {
	      if (variantProp === muiFormControl.variant) {
	        console.error('Material-UI: The `InputAdornment` variant infers the variant prop ' + 'you do not have to provide one.');
	      }
	    }
	  }
	
	  if (muiFormControl && !variant) {
	    variant = muiFormControl.variant;
	  }
	
	  return /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, disablePointerEvents && classes.disablePointerEvents, muiFormControl.hiddenLabel && classes.hiddenLabel, variant === 'filled' && classes.filled, {
	      'start': classes.positionStart,
	      'end': classes.positionEnd
	    }[position], muiFormControl.margin === 'dense' && classes.marginDense),
	    ref: ref
	  }, other), typeof children === 'string' && !disableTypography ? /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "textSecondary"
	  }, children) : children));
	});
	 false ? InputAdornment.propTypes = {
	  /**
	   * The content of the component, normally an `IconButton` or string.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Disable pointer events on the root.
	   * This allows for the content of the adornment to focus the input on click.
	   */
	  disablePointerEvents: _propTypes.default.bool,
	
	  /**
	   * If children is a string then disable wrapping in a Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  muiFormControl: _propTypes.default.object,
	
	  /**
	   * The position this adornment should appear relative to the `Input`.
	   */
	  position: _propTypes.default.oneOf(['start', 'end']),
	
	  /**
	   * The variant to use.
	   * Note: If you are using the `TextField` component or the `FormControl` component
	   * you do not have to set this manually.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputAdornment'
	})(InputAdornment);
	
	exports.default = _default;

/***/ },
/* 311 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _InputAdornment.default;
	  }
	});
	
	var _InputAdornment = _interopRequireDefault(__webpack_require__(310));

/***/ },
/* 312 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _formControlState = _interopRequireDefault(__webpack_require__(43));
	
	var _FormControlContext = _interopRequireWildcard(__webpack_require__(62));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _TextareaAutosize = _interopRequireDefault(__webpack_require__(146));
	
	var _utils2 = __webpack_require__(80);
	
	/* eslint-disable jsx-a11y/click-events-have-key-events, jsx-a11y/no-static-element-interactions */
	var styles = function styles(theme) {
	  var light = theme.palette.type === 'light';
	  var placeholder = {
	    color: 'currentColor',
	    opacity: light ? 0.42 : 0.5,
	    transition: theme.transitions.create('opacity', {
	      duration: theme.transitions.duration.shorter
	    })
	  };
	  var placeholderHidden = {
	    opacity: '0 !important'
	  };
	  var placeholderVisible = {
	    opacity: light ? 0.42 : 0.5
	  };
	  return {
	    '@global': {
	      '@keyframes mui-auto-fill': {
	        from: {}
	      },
	      '@keyframes mui-auto-fill-cancel': {
	        from: {}
	      }
	    },
	
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body1, {
	      color: theme.palette.text.primary,
	      lineHeight: '1.1876em',
	      // Reset (19px), match the native input line-height
	      boxSizing: 'border-box',
	      // Prevent padding issue with fullWidth.
	      position: 'relative',
	      cursor: 'text',
	      display: 'inline-flex',
	      alignItems: 'center',
	      '&$disabled': {
	        color: theme.palette.text.disabled,
	        cursor: 'default'
	      }
	    }),
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {},
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {},
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      '&$marginDense': {
	        paddingTop: 4 - 1
	      }
	    },
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {},
	
	    /* Styles applied to the root element if `fullWidth={true}`. */
	    fullWidth: {
	      width: '100%'
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      font: 'inherit',
	      color: 'currentColor',
	      padding: "".concat(8 - 2, "px 0 ").concat(8 - 1, "px"),
	      border: 0,
	      boxSizing: 'content-box',
	      background: 'none',
	      height: '1.1876em',
	      // Reset (19px), match the native input line-height
	      margin: 0,
	      // Reset for Safari
	      WebkitTapHighlightColor: 'transparent',
	      display: 'block',
	      // Make the flex item shrink with Firefox
	      minWidth: 0,
	      width: '100%',
	      // Fix IE 11 width issue
	      animationName: 'mui-auto-fill-cancel',
	      '&::-webkit-input-placeholder': placeholder,
	      '&::-moz-placeholder': placeholder,
	      // Firefox 19+
	      '&:-ms-input-placeholder': placeholder,
	      // IE 11
	      '&::-ms-input-placeholder': placeholder,
	      // Edge
	      '&:focus': {
	        outline: 0
	      },
	      // Reset Firefox invalid required input style
	      '&:invalid': {
	        boxShadow: 'none'
	      },
	      '&::-webkit-search-decoration': {
	        // Remove the padding when type=search.
	        '-webkit-appearance': 'none'
	      },
	      // Show and hide the placeholder logic
	      'label[data-shrink=false] + $formControl &': {
	        '&::-webkit-input-placeholder': placeholderHidden,
	        '&::-moz-placeholder': placeholderHidden,
	        // Firefox 19+
	        '&:-ms-input-placeholder': placeholderHidden,
	        // IE 11
	        '&::-ms-input-placeholder': placeholderHidden,
	        // Edge
	        '&:focus::-webkit-input-placeholder': placeholderVisible,
	        '&:focus::-moz-placeholder': placeholderVisible,
	        // Firefox 19+
	        '&:focus:-ms-input-placeholder': placeholderVisible,
	        // IE 11
	        '&:focus::-ms-input-placeholder': placeholderVisible // Edge
	
	      },
	      '&$disabled': {
	        opacity: 1 // Reset iOS opacity
	
	      },
	      '&:-webkit-autofill': {
	        animationDuration: '5000s',
	        animationName: 'mui-auto-fill'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 4 - 1
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      height: 'auto',
	      resize: 'none',
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `type="search"`. */
	    inputTypeSearch: {
	      // Improve type search style.
	      '-moz-appearance': 'textfield',
	      '-webkit-appearance': 'textfield'
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {},
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {},
	
	    /* Styles applied to the `input` element if `hiddenLabel={true}`. */
	    inputHiddenLabel: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * `InputBase` contains as few styles as possible.
	 * It aims to be a simple building block for creating an input.
	 * It contains a load of style reset and some state logic.
	 */
	
	var InputBase = React.forwardRef(function InputBase(props, ref) {
	  var ariaDescribedby = props['aria-describedby'],
	      autoComplete = props.autoComplete,
	      autoFocus = props.autoFocus,
	      classes = props.classes,
	      className = props.className,
	      color = props.color,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      endAdornment = props.endAdornment,
	      error = props.error,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      id = props.id,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      _props$inputProps = props.inputProps,
	      inputPropsProp = _props$inputProps === void 0 ? {} : _props$inputProps,
	      inputRefProp = props.inputRef,
	      margin = props.margin,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      onFocus = props.onFocus,
	      onKeyDown = props.onKeyDown,
	      onKeyUp = props.onKeyUp,
	      placeholder = props.placeholder,
	      readOnly = props.readOnly,
	      renderSuffix = props.renderSuffix,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      rowsMin = props.rowsMin,
	      startAdornment = props.startAdornment,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      valueProp = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-describedby", "autoComplete", "autoFocus", "classes", "className", "color", "defaultValue", "disabled", "endAdornment", "error", "fullWidth", "id", "inputComponent", "inputProps", "inputRef", "margin", "multiline", "name", "onBlur", "onChange", "onClick", "onFocus", "onKeyDown", "onKeyUp", "placeholder", "readOnly", "renderSuffix", "rows", "rowsMax", "rowsMin", "startAdornment", "type", "value"]);
	  var value = inputPropsProp.value != null ? inputPropsProp.value : valueProp;
	
	  var _React$useRef = React.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = React.useRef();
	  var handleInputRefWarning = React.useCallback(function (instance) {
	    if (false) {
	      if (instance && !(instance instanceof HTMLInputElement) && !instance.focus) {
	        console.error(['Material-UI: you have provided a `inputComponent` to the input component', 'that does not correctly handle the `inputRef` prop.', 'Make sure the `inputRef` prop is called with a HTMLInputElement.'].join('\n'));
	      }
	    }
	  }, []);
	  var handleInputPropsRefProp = (0, _useForkRef.default)(inputPropsProp.ref, handleInputRefWarning);
	  var handleInputRefProp = (0, _useForkRef.default)(inputRefProp, handleInputPropsRefProp);
	  var handleInputRef = (0, _useForkRef.default)(inputRef, handleInputRefProp);
	
	  var _React$useState = React.useState(false),
	      focused = _React$useState[0],
	      setFocused = _React$useState[1];
	
	  var muiFormControl = (0, _FormControlContext.useFormControl)();
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (muiFormControl) {
	        return muiFormControl.registerEffect();
	      }
	
	      return undefined;
	    }, [muiFormControl]);
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['color', 'disabled', 'error', 'hiddenLabel', 'margin', 'required', 'filled']
	  });
	  fcs.focused = muiFormControl ? muiFormControl.focused : focused; // The blur won't fire when the disabled state is set on a focused input.
	  // We need to book keep the focused state manually.
	
	  React.useEffect(function () {
	    if (!muiFormControl && disabled && focused) {
	      setFocused(false);
	
	      if (onBlur) {
	        onBlur();
	      }
	    }
	  }, [muiFormControl, disabled, focused, onBlur]);
	  var onFilled = muiFormControl && muiFormControl.onFilled;
	  var onEmpty = muiFormControl && muiFormControl.onEmpty;
	  var checkDirty = React.useCallback(function (obj) {
	    if ((0, _utils2.isFilled)(obj)) {
	      if (onFilled) {
	        onFilled();
	      }
	    } else if (onEmpty) {
	      onEmpty();
	    }
	  }, [onFilled, onEmpty]);
	  useEnhancedEffect(function () {
	    if (isControlled) {
	      checkDirty({
	        value: value
	      });
	    }
	  }, [value, checkDirty, isControlled]);
	
	  var handleFocus = function handleFocus(event) {
	    // Fix a bug with IE 11 where the focus/blur events are triggered
	    // while the input is disabled.
	    if (fcs.disabled) {
	      event.stopPropagation();
	      return;
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	
	    if (inputPropsProp.onFocus) {
	      inputPropsProp.onFocus(event);
	    }
	
	    if (muiFormControl && muiFormControl.onFocus) {
	      muiFormControl.onFocus(event);
	    } else {
	      setFocused(true);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    if (onBlur) {
	      onBlur(event);
	    }
	
	    if (inputPropsProp.onBlur) {
	      inputPropsProp.onBlur(event);
	    }
	
	    if (muiFormControl && muiFormControl.onBlur) {
	      muiFormControl.onBlur(event);
	    } else {
	      setFocused(false);
	    }
	  };
	
	  var handleChange = function handleChange(event) {
	    if (!isControlled) {
	      var element = event.target || inputRef.current;
	
	      if (element == null) {
	        throw new TypeError('Material-UI: Expected valid input target. ' + 'Did you use a custom `inputComponent` and forget to forward refs? ' + 'See https://material-ui.com/r/input-component-ref-interface for more info.');
	      }
	
	      checkDirty({
	        value: element.value
	      });
	    }
	
	    for (var _len = arguments.length, args = new Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
	      args[_key - 1] = arguments[_key];
	    }
	
	    if (inputPropsProp.onChange) {
	      inputPropsProp.onChange.apply(inputPropsProp, [event].concat(args));
	    } // Perform in the willUpdate
	
	
	    if (onChange) {
	      onChange.apply(void 0, [event].concat(args));
	    }
	  }; // Check the input state on mount, in case it was filled by the user
	  // or auto filled by the browser before the hydration (for SSR).
	
	
	  React.useEffect(function () {
	    checkDirty(inputRef.current);
	  }, []); // eslint-disable-line react-hooks/exhaustive-deps
	
	  var handleClick = function handleClick(event) {
	    if (inputRef.current && event.currentTarget === event.target) {
	      inputRef.current.focus();
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  var InputComponent = inputComponent;
	  var inputProps = (0, _extends2.default)({}, inputPropsProp, {
	    ref: handleInputRef
	  });
	
	  if (typeof InputComponent !== 'string') {
	    inputProps = (0, _extends2.default)({
	      // Rename ref to inputRef as we don't know the
	      // provided `inputComponent` structure.
	      inputRef: handleInputRef,
	      type: type
	    }, inputProps, {
	      ref: null
	    });
	  } else if (multiline) {
	    if (rows && !rowsMax && !rowsMin) {
	      InputComponent = 'textarea';
	    } else {
	      inputProps = (0, _extends2.default)({
	        rows: rows,
	        rowsMax: rowsMax
	      }, inputProps);
	      InputComponent = _TextareaAutosize.default;
	    }
	  } else {
	    inputProps = (0, _extends2.default)({
	      type: type
	    }, inputProps);
	  }
	
	  var handleAutoFill = function handleAutoFill(event) {
	    // Provide a fake value as Chrome might not let you access it for security reasons.
	    checkDirty(event.animationName === 'mui-auto-fill-cancel' ? inputRef.current : {
	      value: 'x'
	    });
	  };
	
	  React.useEffect(function () {
	    if (muiFormControl) {
	      muiFormControl.setAdornedStart(Boolean(startAdornment));
	    }
	  }, [muiFormControl, startAdornment]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(fcs.color || 'primary'))], className, fcs.disabled && classes.disabled, fcs.error && classes.error, fullWidth && classes.fullWidth, fcs.focused && classes.focused, muiFormControl && classes.formControl, multiline && classes.multiline, startAdornment && classes.adornedStart, endAdornment && classes.adornedEnd, fcs.margin === 'dense' && classes.marginDense),
	    onClick: handleClick,
	    ref: ref
	  }, other), startAdornment, /*#__PURE__*/React.createElement(_FormControlContext.default.Provider, {
	    value: null
	  }, /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
	    "aria-invalid": fcs.error,
	    "aria-describedby": ariaDescribedby,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    disabled: fcs.disabled,
	    id: id,
	    onAnimationStart: handleAutoFill,
	    name: name,
	    placeholder: placeholder,
	    readOnly: readOnly,
	    required: fcs.required,
	    rows: rows,
	    value: value,
	    onKeyDown: onKeyDown,
	    onKeyUp: onKeyUp
	  }, inputProps, {
	    className: (0, _clsx.default)(classes.input, inputPropsProp.className, fcs.disabled && classes.disabled, multiline && classes.inputMultiline, fcs.hiddenLabel && classes.inputHiddenLabel, startAdornment && classes.inputAdornedStart, endAdornment && classes.inputAdornedEnd, type === 'search' && classes.inputTypeSearch, fcs.margin === 'dense' && classes.inputMarginDense),
	    onBlur: handleBlur,
	    onChange: handleChange,
	    onFocus: handleFocus
	  }))), endAdornment, renderSuffix ? renderSuffix((0, _extends2.default)({}, fcs, {
	    startAdornment: startAdornment
	  })) : null);
	});
	 false ? InputBase.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  'aria-describedby': _propTypes.default.string,
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the input is blurred.
	   *
	   * Notice that the first argument (event) might be undefined.
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onKeyUp: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  renderSuffix: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display when multiline option is set to true.
	   */
	  rowsMin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputBase'
	})(InputBase);
	
	exports.default = _default;

/***/ },
/* 313 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(43));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(36));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _FormLabel = _interopRequireDefault(__webpack_require__(119));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      transformOrigin: 'top left'
	    },
	
	    /* Pseudo-class applied to the root element if `focused={true}`. */
	    focused: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element if `required={true}`. */
	    required: {},
	
	    /* Pseudo-class applied to the asterisk element. */
	    asterisk: {},
	
	    /* Styles applied to the root element if the component is a descendant of `FormControl`. */
	    formControl: {
	      position: 'absolute',
	      left: 0,
	      top: 0,
	      // slight alteration to spec spacing to match visual spec result
	      transform: 'translate(0, 24px) scale(1)'
	    },
	
	    /* Styles applied to the root element if `margin="dense"`. */
	    marginDense: {
	      // Compensation for the `Input.inputDense` style.
	      transform: 'translate(0, 21px) scale(1)'
	    },
	
	    /* Styles applied to the `input` element if `shrink={true}`. */
	    shrink: {
	      transform: 'translate(0, 1.5px) scale(0.75)',
	      transformOrigin: 'top left'
	    },
	
	    /* Styles applied to the `input` element if `disableAnimation={false}`. */
	    animated: {
	      transition: theme.transitions.create(['color', 'transform'], {
	        duration: theme.transitions.duration.shorter,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the root element if `variant="filled"`. */
	    filled: {
	      // Chrome's autofill feature gives the input field a yellow background.
	      // Since the input field is behind the label in the HTML tree,
	      // the input field is drawn last and hides the label with an opaque background color.
	      // zIndex: 1 will raise the label above opaque background-colors of input.
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(12px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(12px, 17px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(12px, 10px) scale(0.75)',
	        '&$marginDense': {
	          transform: 'translate(12px, 7px) scale(0.75)'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `variant="outlined"`. */
	    outlined: {
	      // see comment above on filled.zIndex
	      zIndex: 1,
	      pointerEvents: 'none',
	      transform: 'translate(14px, 20px) scale(1)',
	      '&$marginDense': {
	        transform: 'translate(14px, 12px) scale(1)'
	      },
	      '&$shrink': {
	        transform: 'translate(14px, -6px) scale(0.75)'
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var InputLabel = React.forwardRef(function InputLabel(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disableAnimati = props.disableAnimation,
	      disableAnimation = _props$disableAnimati === void 0 ? false : _props$disableAnimati,
	      margin = props.margin,
	      shrinkProp = props.shrink,
	      variant = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disableAnimation", "margin", "shrink", "variant"]);
	  var muiFormControl = (0, _useFormControl.default)();
	  var shrink = shrinkProp;
	
	  if (typeof shrink === 'undefined' && muiFormControl) {
	    shrink = muiFormControl.filled || muiFormControl.focused || muiFormControl.adornedStart;
	  }
	
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['margin', 'variant']
	  });
	  return /*#__PURE__*/React.createElement(_FormLabel.default, (0, _extends2.default)({
	    "data-shrink": shrink,
	    className: (0, _clsx.default)(classes.root, className, muiFormControl && classes.formControl, !disableAnimation && classes.animated, shrink && classes.shrink, fcs.margin === 'dense' && classes.marginDense, {
	      'filled': classes.filled,
	      'outlined': classes.outlined
	    }[fcs.variant]),
	    classes: {
	      focused: classes.focused,
	      disabled: classes.disabled,
	      error: classes.error,
	      required: classes.required,
	      asterisk: classes.asterisk
	    },
	    ref: ref
	  }, other));
	});
	 false ? InputLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The contents of the `InputLabel`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * If `true`, the transition animation is disabled.
	   */
	  disableAnimation: _propTypes.default.bool,
	
	  /**
	   * If `true`, apply disabled class.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input of this label is focused.
	   */
	  focused: _propTypes.default.bool,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense']),
	
	  /**
	   * if `true`, the label will indicate that the input is required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label is shrunk.
	   */
	  shrink: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiInputLabel'
	})(InputLabel);
	
	exports.default = _default;

/***/ },
/* 314 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var TRANSITION_DURATION = 4; // seconds
	
	var styles = function styles(theme) {
	  var getColor = function getColor(color) {
	    return theme.palette.type === 'light' ? (0, _colorManipulator.lighten)(color, 0.62) : (0, _colorManipulator.darken)(color, 0.5);
	  };
	
	  var backgroundPrimary = getColor(theme.palette.primary.main);
	  var backgroundSecondary = getColor(theme.palette.secondary.main);
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      overflow: 'hidden',
	      height: 4
	    },
	
	    /* Styles applied to the root and bar2 element if `color="primary"`; bar2 if `variant="buffer"`. */
	    colorPrimary: {
	      backgroundColor: backgroundPrimary
	    },
	
	    /* Styles applied to the root and bar2 elements if `color="secondary"`; bar2 if `variant="buffer"`. */
	    colorSecondary: {
	      backgroundColor: backgroundSecondary
	    },
	
	    /* Styles applied to the root element if `variant="determinate"`. */
	    determinate: {},
	
	    /* Styles applied to the root element if `variant="indeterminate"`. */
	    indeterminate: {},
	
	    /* Styles applied to the root element if `variant="buffer"`. */
	    buffer: {
	      backgroundColor: 'transparent'
	    },
	
	    /* Styles applied to the root element if `variant="query"`. */
	    query: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"`. */
	    dashed: {
	      position: 'absolute',
	      marginTop: 0,
	      height: '100%',
	      width: '100%',
	      animation: '$buffer 3s infinite linear'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"` and `color="primary"`. */
	    dashedColorPrimary: {
	      backgroundImage: "radial-gradient(".concat(backgroundPrimary, " 0%, ").concat(backgroundPrimary, " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	
	    /* Styles applied to the additional bar element if `variant="buffer"` and `color="secondary"`. */
	    dashedColorSecondary: {
	      backgroundImage: "radial-gradient(".concat(backgroundSecondary, " 0%, ").concat(backgroundSecondary, " 16%, transparent 42%)"),
	      backgroundSize: '10px 10px',
	      backgroundPosition: '0px -23px'
	    },
	
	    /* Styles applied to the layered bar1 and bar2 elements. */
	    bar: {
	      width: '100%',
	      position: 'absolute',
	      left: 0,
	      bottom: 0,
	      top: 0,
	      transition: 'transform 0.2s linear',
	      transformOrigin: 'left'
	    },
	
	    /* Styles applied to the bar elements if `color="primary"`; bar2 if `variant` not "buffer". */
	    barColorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	
	    /* Styles applied to the bar elements if `color="secondary"`; bar2 if `variant` not "buffer". */
	    barColorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the bar1 element if `variant="indeterminate or query"`. */
	    bar1Indeterminate: {
	      width: 'auto',
	      animation: '$indeterminate1 2.1s cubic-bezier(0.65, 0.815, 0.735, 0.395) infinite'
	    },
	
	    /* Styles applied to the bar1 element if `variant="determinate"`. */
	    bar1Determinate: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	
	    /* Styles applied to the bar1 element if `variant="buffer"`. */
	    bar1Buffer: {
	      zIndex: 1,
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	
	    /* Styles applied to the bar2 element if `variant="indeterminate or query"`. */
	    bar2Indeterminate: {
	      width: 'auto',
	      animation: '$indeterminate2 2.1s cubic-bezier(0.165, 0.84, 0.44, 1) 1.15s infinite'
	    },
	
	    /* Styles applied to the bar2 element if `variant="buffer"`. */
	    bar2Buffer: {
	      transition: "transform .".concat(TRANSITION_DURATION, "s linear")
	    },
	    // Legends:
	    // || represents the viewport
	    // -  represents a light background
	    // x  represents a dark background
	    '@keyframes indeterminate1': {
	      //  |-----|---x-||-----||-----|
	      '0%': {
	        left: '-35%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||xxxx-|
	      '60%': {
	        left: '100%',
	        right: '-90%'
	      },
	      '100%': {
	        left: '100%',
	        right: '-90%'
	      }
	    },
	    '@keyframes indeterminate2': {
	      //  |xxxxx|xxxxx||-----||-----|
	      '0%': {
	        left: '-200%',
	        right: '100%'
	      },
	      //  |-----|-----||-----||-x----|
	      '60%': {
	        left: '107%',
	        right: '-8%'
	      },
	      '100%': {
	        left: '107%',
	        right: '-8%'
	      }
	    },
	    '@keyframes buffer': {
	      '0%': {
	        opacity: 1,
	        backgroundPosition: '0px -23px'
	      },
	      '50%': {
	        opacity: 0,
	        backgroundPosition: '0px -23px'
	      },
	      '100%': {
	        opacity: 1,
	        backgroundPosition: '-200px -23px'
	      }
	    }
	  };
	};
	/**
	 * ## ARIA
	 *
	 * If the progress bar is describing the loading progress of a particular region of a page,
	 * you should use `aria-describedby` to point to the progress bar, and set the `aria-busy`
	 * attribute to `true` on that region until it has finished loading.
	 */
	
	
	exports.styles = styles;
	var LinearProgress = React.forwardRef(function LinearProgress(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      value = props.value,
	      valueBuffer = props.valueBuffer,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'indeterminate' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "value", "valueBuffer", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var rootProps = {};
	  var inlineStyles = {
	    bar1: {},
	    bar2: {}
	  };
	
	  if (variant === 'determinate' || variant === 'buffer') {
	    if (value !== undefined) {
	      rootProps['aria-valuenow'] = Math.round(value);
	      var transform = value - 100;
	
	      if (theme.direction === 'rtl') {
	        transform = -transform;
	      }
	
	      inlineStyles.bar1.transform = "translateX(".concat(transform, "%)");
	    } else if (false) {
	      console.error('Material-UI: you need to provide a value prop ' + 'when using the determinate or buffer variant of LinearProgress .');
	    }
	  }
	
	  if (variant === 'buffer') {
	    if (valueBuffer !== undefined) {
	      var _transform = (valueBuffer || 0) - 100;
	
	      if (theme.direction === 'rtl') {
	        _transform = -_transform;
	      }
	
	      inlineStyles.bar2.transform = "translateX(".concat(_transform, "%)");
	    } else if (false) {
	      console.error('Material-UI: you need to provide a valueBuffer prop ' + 'when using the buffer variant of LinearProgress.');
	    }
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, {
	      'determinate': classes.determinate,
	      'indeterminate': classes.indeterminate,
	      'buffer': classes.buffer,
	      'query': classes.query
	    }[variant]),
	    role: "progressbar"
	  }, rootProps, {
	    ref: ref
	  }, other), variant === 'buffer' ? /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.dashed, classes["dashedColor".concat((0, _capitalize.default)(color))])
	  }) : null, /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.bar, classes["barColor".concat((0, _capitalize.default)(color))], (variant === 'indeterminate' || variant === 'query') && classes.bar1Indeterminate, {
	      'determinate': classes.bar1Determinate,
	      'buffer': classes.bar1Buffer
	    }[variant]),
	    style: inlineStyles.bar1
	  }), variant === 'determinate' ? null : /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.bar, (variant === 'indeterminate' || variant === 'query') && classes.bar2Indeterminate, variant === 'buffer' ? [classes["color".concat((0, _capitalize.default)(color))], classes.bar2Buffer] : classes["barColor".concat((0, _capitalize.default)(color))]),
	    style: inlineStyles.bar2
	  }));
	});
	 false ? LinearProgress.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The value of the progress indicator for the determinate and buffer variants.
	   * Value between 0 and 100.
	   */
	  value: _propTypes.default.number,
	
	  /**
	   * The value for the buffer variant.
	   * Value between 0 and 100.
	   */
	  valueBuffer: _propTypes.default.number,
	
	  /**
	   * The variant to use.
	   * Use indeterminate or query when there is no progress value.
	   */
	  variant: _propTypes.default.oneOf(['buffer', 'determinate', 'indeterminate', 'query'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLinearProgress'
	})(LinearProgress);
	
	exports.default = _default;

/***/ },
/* 315 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _utils = __webpack_require__(9);
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(57));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the root element if `underline="none"`. */
	  underlineNone: {
	    textDecoration: 'none'
	  },
	
	  /* Styles applied to the root element if `underline="hover"`. */
	  underlineHover: {
	    textDecoration: 'none',
	    '&:hover': {
	      textDecoration: 'underline'
	    }
	  },
	
	  /* Styles applied to the root element if `underline="always"`. */
	  underlineAlways: {
	    textDecoration: 'underline'
	  },
	  // Same reset as ButtonBase.root
	
	  /* Styles applied to the root element if `component="button"`. */
	  button: {
	    position: 'relative',
	    WebkitTapHighlightColor: 'transparent',
	    backgroundColor: 'transparent',
	    // Reset default value
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0,
	    border: 0,
	    margin: 0,
	    // Remove the margin in Safari
	    borderRadius: 0,
	    padding: 0,
	    // Remove the padding in Firefox
	    cursor: 'pointer',
	    userSelect: 'none',
	    verticalAlign: 'middle',
	    '-moz-appearance': 'none',
	    // Reset
	    '-webkit-appearance': 'none',
	    // Reset
	    '&::-moz-focus-inner': {
	      borderStyle: 'none' // Remove Firefox dotted outline.
	
	    },
	    '&$focusVisible': {
	      outline: 'auto'
	    }
	  },
	
	  /* Pseudo-class applied to the root element if the link is keyboard focused. */
	  focusVisible: {}
	};
	exports.styles = styles;
	var Link = React.forwardRef(function Link(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'a' : _props$component,
	      onBlur = props.onBlur,
	      onFocus = props.onFocus,
	      TypographyClasses = props.TypographyClasses,
	      _props$underline = props.underline,
	      underline = _props$underline === void 0 ? 'hover' : _props$underline,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'inherit' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "onBlur", "onFocus", "TypographyClasses", "underline", "variant"]);
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState = React.useState(false),
	      focusVisible = _React$useState[0],
	      setFocusVisible = _React$useState[1];
	
	  var handlerRef = (0, _useForkRef.default)(ref, focusVisibleRef);
	
	  var handleBlur = function handleBlur(event) {
	    if (focusVisible) {
	      onBlurVisible();
	      setFocusVisible(false);
	    }
	
	    if (onBlur) {
	      onBlur(event);
	    }
	  };
	
	  var handleFocus = function handleFocus(event) {
	    if (isFocusVisible(event)) {
	      setFocusVisible(true);
	    }
	
	    if (onFocus) {
	      onFocus(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["underline".concat((0, _capitalize.default)(underline))], className, focusVisible && classes.focusVisible, component === 'button' && classes.button),
	    classes: TypographyClasses,
	    color: color,
	    component: component,
	    onBlur: handleBlur,
	    onFocus: handleFocus,
	    ref: handlerRef,
	    variant: variant
	  }, other));
	});
	 false ? Link.propTypes = {
	  /**
	   * The content of the link.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the link.
	   */
	  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _utils.elementTypeAcceptingRef,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * `classes` prop applied to the [`Typography`](/api/typography/) element.
	   */
	  TypographyClasses: _propTypes.default.object,
	
	  /**
	   * Controls when the link should have an underline.
	   */
	  underline: _propTypes.default.oneOf(['none', 'hover', 'always']),
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiLink'
	})(Link);
	
	exports.default = _default;

/***/ },
/* 316 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Link.default;
	  }
	});
	
	var _Link = _interopRequireDefault(__webpack_require__(315));

/***/ },
/* 317 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(50));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    listStyle: 'none',
	    margin: 0,
	    padding: 0,
	    position: 'relative'
	  },
	
	  /* Styles applied to the root element if `disablePadding={false}`. */
	  padding: {
	    paddingTop: 8,
	    paddingBottom: 8
	  },
	
	  /* Styles applied to the root element if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if a `subheader` is provided. */
	  subheader: {
	    paddingTop: 0
	  }
	};
	exports.styles = styles;
	var List = React.forwardRef(function List(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'ul' : _props$component,
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disablePadding = props.disablePadding,
	      disablePadding = _props$disablePadding === void 0 ? false : _props$disablePadding,
	      subheader = props.subheader,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "component", "dense", "disablePadding", "subheader"]);
	  var context = React.useMemo(function () {
	    return {
	      dense: dense
	    };
	  }, [dense]);
	  return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	    value: context
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, !disablePadding && classes.padding, subheader && classes.subheader),
	    ref: ref
	  }, other), subheader, children));
	});
	 false ? List.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used for
	   * the list and list items.
	   * The prop is available to descendant components as the `dense` context.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, vertical padding will be removed from the list.
	   */
	  disablePadding: _propTypes.default.bool,
	
	  /**
	   * The content of the subheader, normally `ListSubheader`.
	   */
	  subheader: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiList'
	})(List);
	
	exports.default = _default;

/***/ },
/* 318 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(55));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(50));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the (normally root) `component` element. May be wrapped by a `container`. */
	    root: {
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      position: 'relative',
	      textDecoration: 'none',
	      width: '100%',
	      boxSizing: 'border-box',
	      textAlign: 'left',
	      paddingTop: 8,
	      paddingBottom: 8,
	      '&$focusVisible': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$selected, &$selected:hover': {
	        backgroundColor: theme.palette.action.selected
	      },
	      '&$disabled': {
	        opacity: 0.5
	      }
	    },
	
	    /* Styles applied to the `container` element if `children` includes `ListItemSecondaryAction`. */
	    container: {
	      position: 'relative'
	    },
	
	    /* Pseudo-class applied to the `component`'s `focusVisibleClassName` prop if `button={true}`. */
	    focusVisible: {},
	
	    /* Styles applied to the `component` element if dense. */
	    dense: {
	      paddingTop: 4,
	      paddingBottom: 4
	    },
	
	    /* Styles applied to the `component` element if `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      alignItems: 'flex-start'
	    },
	
	    /* Pseudo-class applied to the inner `component` element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the inner `component` element if `divider={true}`. */
	    divider: {
	      borderBottom: "1px solid ".concat(theme.palette.divider),
	      backgroundClip: 'padding-box'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the inner `component` element if `button={true}`. */
	    button: {
	      transition: theme.transitions.create('background-color', {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&:hover': {
	        textDecoration: 'none',
	        backgroundColor: theme.palette.action.hover,
	        // Reset on touch devices, it doesn't add specificity
	        '@media (hover: none)': {
	          backgroundColor: 'transparent'
	        }
	      }
	    },
	
	    /* Styles applied to the `component` element if `children` includes `ListItemSecondaryAction`. */
	    secondaryAction: {
	      // Add some space to avoid collision as `ListItemSecondaryAction`
	      // is absolutely positioned.
	      paddingRight: 48
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {}
	  };
	};
	
	exports.styles = styles;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * Uses an additional container component if `ListItemSecondaryAction` is the last child.
	 */
	
	var ListItem = React.forwardRef(function ListItem(props, ref) {
	  var _props$alignItems = props.alignItems,
	      alignItems = _props$alignItems === void 0 ? 'center' : _props$alignItems,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$button = props.button,
	      button = _props$button === void 0 ? false : _props$button,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      componentProp = props.component,
	      _props$ContainerCompo = props.ContainerComponent,
	      ContainerComponent = _props$ContainerCompo === void 0 ? 'li' : _props$ContainerCompo,
	      _props$ContainerProps = props.ContainerProps;
	  _props$ContainerProps = _props$ContainerProps === void 0 ? {} : _props$ContainerProps;
	  var ContainerClassName = _props$ContainerProps.className,
	      ContainerProps = (0, _objectWithoutProperties2.default)(_props$ContainerProps, ["className"]),
	      _props$dense = props.dense,
	      dense = _props$dense === void 0 ? false : _props$dense,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$divider = props.divider,
	      divider = _props$divider === void 0 ? false : _props$divider,
	      focusVisibleClassName = props.focusVisibleClassName,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["alignItems", "autoFocus", "button", "children", "classes", "className", "component", "ContainerComponent", "ContainerProps", "dense", "disabled", "disableGutters", "divider", "focusVisibleClassName", "selected"]);
	  var context = React.useContext(_ListContext.default);
	  var childContext = {
	    dense: dense || context.dense || false,
	    alignItems: alignItems
	  };
	  var listItemRef = React.useRef(null);
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      if (listItemRef.current) {
	        listItemRef.current.focus();
	      } else if (false) {
	        console.error('Material-UI: unable to set focus to a ListItem whose component has not been rendered.');
	      }
	    }
	  }, [autoFocus]);
	  var children = React.Children.toArray(childrenProp);
	  var hasSecondaryAction = children.length && (0, _isMuiElement.default)(children[children.length - 1], ['ListItemSecondaryAction']);
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    listItemRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(handleOwnRef, ref);
	  var componentProps = (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, childContext.dense && classes.dense, !disableGutters && classes.gutters, divider && classes.divider, disabled && classes.disabled, button && classes.button, alignItems !== "center" && classes.alignItemsFlexStart, hasSecondaryAction && classes.secondaryAction, selected && classes.selected),
	    disabled: disabled
	  }, other);
	  var Component = componentProp || 'li';
	
	  if (button) {
	    componentProps.component = componentProp || 'div';
	    componentProps.focusVisibleClassName = (0, _clsx.default)(classes.focusVisible, focusVisibleClassName);
	    Component = _ButtonBase.default;
	  }
	
	  if (hasSecondaryAction) {
	    // Use div by default.
	    Component = !componentProps.component && !componentProp ? 'div' : Component; // Avoid nesting of li > li.
	
	    if (ContainerComponent === 'li') {
	      if (Component === 'li') {
	        Component = 'div';
	      } else if (componentProps.component === 'li') {
	        componentProps.component = 'div';
	      }
	    }
	
	    return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	      value: childContext
	    }, /*#__PURE__*/React.createElement(ContainerComponent, (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.container, ContainerClassName),
	      ref: handleRef
	    }, ContainerProps), /*#__PURE__*/React.createElement(Component, componentProps, children), children.pop()));
	  }
	
	  return /*#__PURE__*/React.createElement(_ListContext.default.Provider, {
	    value: childContext
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: handleRef
	  }, componentProps), children));
	});
	 false ? ListItem.propTypes = {
	  /**
	   * Defines the `align-items` style property.
	   */
	  alignItems: _propTypes.default.oneOf(['flex-start', 'center']),
	
	  /**
	   * If `true`, the list item will be focused during the first mount.
	   * Focus will also be triggered if the value changes from false to true.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be a button (using `ButtonBase`). Props intended
	   * for `ButtonBase` can then be applied to `ListItem`.
	   */
	  button: _propTypes.default.bool,
	
	  /**
	   * The content of the component. If a `ListItemSecondaryAction` is used it must
	   * be the last child.
	   */
	  children: (0, _utils.chainPropTypes)(_propTypes.default.node, function (props) {
	    var children = React.Children.toArray(props.children); // React.Children.toArray(props.children).findLastIndex(isListItemSecondaryAction)
	
	    var secondaryActionIndex = -1;
	
	    for (var i = children.length - 1; i >= 0; i -= 1) {
	      var child = children[i];
	
	      if ((0, _isMuiElement.default)(child, ['ListItemSecondaryAction'])) {
	        secondaryActionIndex = i;
	        break;
	      }
	    } //  is ListItemSecondaryAction the last child of ListItem
	
	
	    if (secondaryActionIndex !== -1 && secondaryActionIndex !== children.length - 1) {
	      return new Error('Material-UI: you used an element after ListItemSecondaryAction. ' + 'For ListItem to detect that it has a secondary action ' + 'you must pass it as the last child to ListItem.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * By default, it's a `li` when `button` is `false` and a `div` when `button` is `true`.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The container component used when a `ListItemSecondaryAction` is the last child.
	   */
	  ContainerComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the container component if used.
	   */
	  ContainerProps: _propTypes.default.object,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list item will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, a 1px light border is added to the bottom of the list item.
	   */
	  divider: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  focusVisibleClassName: _propTypes.default.string,
	
	  /**
	   * Use to apply selected styling.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItem'
	})(ListItem);
	
	exports.default = _default;

/***/ },
/* 319 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(50));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    minWidth: 56,
	    flexShrink: 0
	  },
	
	  /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	  alignItemsFlexStart: {
	    marginTop: 8
	  }
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Avatar`.
	 */
	
	exports.styles = styles;
	var ListItemAvatar = React.forwardRef(function ListItemAvatar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  var context = React.useContext(_ListContext.default);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	 false ? ListItemAvatar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component – normally `Avatar`.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemAvatar'
	})(ListItemAvatar);
	
	exports.default = _default;

/***/ },
/* 320 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemAvatar.default;
	  }
	});
	
	var _ListItemAvatar = _interopRequireDefault(__webpack_require__(319));

/***/ },
/* 321 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(50));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      minWidth: 56,
	      color: theme.palette.action.active,
	      flexShrink: 0,
	      display: 'inline-flex'
	    },
	
	    /* Styles applied to the root element when the parent `ListItem` uses `alignItems="flex-start"`. */
	    alignItemsFlexStart: {
	      marginTop: 8
	    }
	  };
	};
	/**
	 * A simple wrapper to apply `List` styles to an `Icon` or `SvgIcon`.
	 */
	
	
	exports.styles = styles;
	var ListItemIcon = React.forwardRef(function ListItemIcon(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  var context = React.useContext(_ListContext.default);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, context.alignItems === 'flex-start' && classes.alignItemsFlexStart),
	    ref: ref
	  }, other));
	});
	 false ? ListItemIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component, normally `Icon`, `SvgIcon`,
	   * or a `@material-ui/icons` SVG icon element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemIcon'
	})(ListItemIcon);
	
	exports.default = _default;

/***/ },
/* 322 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemIcon.default;
	  }
	});
	
	var _ListItemIcon = _interopRequireDefault(__webpack_require__(321));

/***/ },
/* 323 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    position: 'absolute',
	    right: 16,
	    top: '50%',
	    transform: 'translateY(-50%)'
	  }
	};
	/**
	 * Must be used as the last child of ListItem to function properly.
	 */
	
	exports.styles = styles;
	var ListItemSecondaryAction = React.forwardRef(function ListItemSecondaryAction(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other));
	});
	 false ? ListItemSecondaryAction.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component, normally an `IconButton` or selection control.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	ListItemSecondaryAction.muiName = 'ListItemSecondaryAction';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemSecondaryAction'
	})(ListItemSecondaryAction);
	
	exports.default = _default;

/***/ },
/* 324 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemSecondaryAction.default;
	  }
	});
	
	var _ListItemSecondaryAction = _interopRequireDefault(__webpack_require__(323));

/***/ },
/* 325 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var _ListContext = _interopRequireDefault(__webpack_require__(50));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    flex: '1 1 auto',
	    minWidth: 0,
	    marginTop: 4,
	    marginBottom: 4
	  },
	
	  /* Styles applied to the `Typography` components if primary and secondary are set. */
	  multiline: {
	    marginTop: 6,
	    marginBottom: 6
	  },
	
	  /* Styles applied to the `Typography` components if dense. */
	  dense: {},
	
	  /* Styles applied to the root element if `inset={true}`. */
	  inset: {
	    paddingLeft: 56
	  },
	
	  /* Styles applied to the primary `Typography` component. */
	  primary: {},
	
	  /* Styles applied to the secondary `Typography` component. */
	  secondary: {}
	};
	exports.styles = styles;
	var ListItemText = React.forwardRef(function ListItemText(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$disableTypogra = props.disableTypography,
	      disableTypography = _props$disableTypogra === void 0 ? false : _props$disableTypogra,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      primaryProp = props.primary,
	      primaryTypographyProps = props.primaryTypographyProps,
	      secondaryProp = props.secondary,
	      secondaryTypographyProps = props.secondaryTypographyProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "disableTypography", "inset", "primary", "primaryTypographyProps", "secondary", "secondaryTypographyProps"]);
	
	  var _React$useContext = React.useContext(_ListContext.default),
	      dense = _React$useContext.dense;
	
	  var primary = primaryProp != null ? primaryProp : children;
	
	  if (primary != null && primary.type !== _Typography.default && !disableTypography) {
	    primary = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: dense ? 'body2' : 'body1',
	      className: classes.primary,
	      component: "span",
	      display: "block"
	    }, primaryTypographyProps), primary);
	  }
	
	  var secondary = secondaryProp;
	
	  if (secondary != null && secondary.type !== _Typography.default && !disableTypography) {
	    secondary = /*#__PURE__*/React.createElement(_Typography.default, (0, _extends2.default)({
	      variant: "body2",
	      className: classes.secondary,
	      color: "textSecondary",
	      display: "block"
	    }, secondaryTypographyProps), secondary);
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, dense && classes.dense, inset && classes.inset, primary && secondary && classes.multiline),
	    ref: ref
	  }, other), primary, secondary);
	});
	 false ? ListItemText.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Alias for the `primary` prop.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the children won't be wrapped by a Typography component.
	   * This can be useful to render an alternative Typography variant by wrapping
	   * the `children` (or `primary`) text, and optional `secondary` text
	   * with the Typography component.
	   */
	  disableTypography: _propTypes.default.bool,
	
	  /**
	   * If `true`, the children will be indented.
	   * This should be used if there is no left avatar or left icon.
	   */
	  inset: _propTypes.default.bool,
	
	  /**
	   * The main content element.
	   */
	  primary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the primary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  primaryTypographyProps: _propTypes.default.object,
	
	  /**
	   * The secondary content element.
	   */
	  secondary: _propTypes.default.node,
	
	  /**
	   * These props will be forwarded to the secondary typography component
	   * (as long as disableTypography is not `true`).
	   */
	  secondaryTypographyProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListItemText'
	})(ListItemText);
	
	exports.default = _default;

/***/ },
/* 326 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ListItemText.default;
	  }
	});
	
	var _ListItemText = _interopRequireDefault(__webpack_require__(325));

/***/ },
/* 327 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      boxSizing: 'border-box',
	      lineHeight: '48px',
	      listStyle: 'none',
	      color: theme.palette.text.secondary,
	      fontFamily: theme.typography.fontFamily,
	      fontWeight: theme.typography.fontWeightMedium,
	      fontSize: theme.typography.pxToRem(14)
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the inner `component` element if `disableGutters={false}`. */
	    gutters: {
	      paddingLeft: 16,
	      paddingRight: 16
	    },
	
	    /* Styles applied to the root element if `inset={true}`. */
	    inset: {
	      paddingLeft: 72
	    },
	
	    /* Styles applied to the root element if `disableSticky={false}`. */
	    sticky: {
	      position: 'sticky',
	      top: 0,
	      zIndex: 1,
	      backgroundColor: 'inherit'
	    }
	  };
	};
	
	exports.styles = styles;
	var ListSubheader = React.forwardRef(function ListSubheader(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'default' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$disableSticky = props.disableSticky,
	      disableSticky = _props$disableSticky === void 0 ? false : _props$disableSticky,
	      _props$inset = props.inset,
	      inset = _props$inset === void 0 ? false : _props$inset,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "component", "disableGutters", "disableSticky", "inset"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'default' && classes["color".concat((0, _capitalize.default)(color))], inset && classes.inset, !disableSticky && classes.sticky, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? ListSubheader.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'inherit']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the List Subheader will not have gutters.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will not stick to the top during scroll.
	   */
	  disableSticky: _propTypes.default.bool,
	
	  /**
	   * If `true`, the List Subheader will be indented.
	   */
	  inset: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiListSubheader'
	})(ListSubheader);
	
	exports.default = _default;

/***/ },
/* 328 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Menu.default;
	  }
	});
	
	var _Menu = _interopRequireDefault(__webpack_require__(125));

/***/ },
/* 329 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ListItem = _interopRequireDefault(__webpack_require__(123));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.body1, (0, _defineProperty2.default)({
	      minHeight: 48,
	      paddingTop: 6,
	      paddingBottom: 6,
	      boxSizing: 'border-box',
	      width: 'auto',
	      overflow: 'hidden',
	      whiteSpace: 'nowrap'
	    }, theme.breakpoints.up('sm'), {
	      minHeight: 'auto'
	    })),
	    // TODO v5: remove
	
	    /* Styles applied to the root element if `disableGutters={false}`. */
	    gutters: {},
	
	    /* Styles applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Styles applied to the root element if dense. */
	    dense: (0, _extends3.default)({}, theme.typography.body2, {
	      minHeight: 'auto'
	    })
	  };
	};
	
	exports.styles = styles;
	var MenuItem = React.forwardRef(function MenuItem(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      component = _props$component === void 0 ? 'li' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      ListItemClasses = props.ListItemClasses,
	      _props$role = props.role,
	      role = _props$role === void 0 ? 'menuitem' : _props$role,
	      selected = props.selected,
	      tabIndexProp = props.tabIndex,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "ListItemClasses", "role", "selected", "tabIndex"]);
	  var tabIndex;
	
	  if (!props.disabled) {
	    tabIndex = tabIndexProp !== undefined ? tabIndexProp : -1;
	  }
	
	  return /*#__PURE__*/React.createElement(_ListItem.default, (0, _extends3.default)({
	    button: true,
	    role: role,
	    tabIndex: tabIndex,
	    component: component,
	    selected: selected,
	    disableGutters: disableGutters,
	    classes: (0, _extends3.default)({
	      dense: classes.dense
	    }, ListItemClasses),
	    className: (0, _clsx.default)(classes.root, className, selected && classes.selected, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? MenuItem.propTypes = {
	  /**
	   * Menu item contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, compact vertical padding designed for keyboard and mouse input will be used.
	   */
	  dense: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the left and right padding is removed.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * `classes` prop applied to the [`ListItem`](/api/list-item/) element.
	   */
	  ListItemClasses: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  role: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.number
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMenuItem'
	})(MenuItem);
	
	exports.default = _default;

/***/ },
/* 330 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(18);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(27));
	
	var _List = _interopRequireDefault(__webpack_require__(122));
	
	var _getScrollbarSize = _interopRequireDefault(__webpack_require__(165));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	function nextItem(list, item, disableListWrap) {
	  if (list === item) {
	    return list.firstChild;
	  }
	
	  if (item && item.nextElementSibling) {
	    return item.nextElementSibling;
	  }
	
	  return disableListWrap ? null : list.firstChild;
	}
	
	function previousItem(list, item, disableListWrap) {
	  if (list === item) {
	    return disableListWrap ? list.firstChild : list.lastChild;
	  }
	
	  if (item && item.previousElementSibling) {
	    return item.previousElementSibling;
	  }
	
	  return disableListWrap ? null : list.lastChild;
	}
	
	function textCriteriaMatches(nextFocus, textCriteria) {
	  if (textCriteria === undefined) {
	    return true;
	  }
	
	  var text = nextFocus.innerText;
	
	  if (text === undefined) {
	    // jsdom doesn't support innerText
	    text = nextFocus.textContent;
	  }
	
	  text = text.trim().toLowerCase();
	
	  if (text.length === 0) {
	    return false;
	  }
	
	  if (textCriteria.repeating) {
	    return text[0] === textCriteria.keys[0];
	  }
	
	  return text.indexOf(textCriteria.keys.join('')) === 0;
	}
	
	function moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, traversalFunction, textCriteria) {
	  var wrappedOnce = false;
	  var nextFocus = traversalFunction(list, currentFocus, currentFocus ? disableListWrap : false);
	
	  while (nextFocus) {
	    // Prevent infinite loop.
	    if (nextFocus === list.firstChild) {
	      if (wrappedOnce) {
	        return;
	      }
	
	      wrappedOnce = true;
	    } // Same logic as useAutocomplete.js
	
	
	    var nextFocusDisabled = disabledItemsFocusable ? false : nextFocus.disabled || nextFocus.getAttribute('aria-disabled') === 'true';
	
	    if (!nextFocus.hasAttribute('tabindex') || !textCriteriaMatches(nextFocus, textCriteria) || nextFocusDisabled) {
	      // Move to the next element.
	      nextFocus = traversalFunction(list, nextFocus, disableListWrap);
	    } else {
	      nextFocus.focus();
	      return;
	    }
	  }
	}
	
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	/**
	 * A permanently displayed menu following https://www.w3.org/TR/wai-aria-practices/#menubutton.
	 * It's exposed to help customization of the [`Menu`](/api/menu/) component. If you
	 * use it separately you need to move focus into the component manually. Once
	 * the focus is placed inside the component it is fully keyboard accessible.
	 */
	
	var MenuList = React.forwardRef(function MenuList(props, ref) {
	  var actions = props.actions,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      _props$autoFocusItem = props.autoFocusItem,
	      autoFocusItem = _props$autoFocusItem === void 0 ? false : _props$autoFocusItem,
	      children = props.children,
	      className = props.className,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      onKeyDown = props.onKeyDown,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'selectedMenu' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "autoFocus", "autoFocusItem", "children", "className", "disabledItemsFocusable", "disableListWrap", "onKeyDown", "variant"]);
	  var listRef = React.useRef(null);
	  var textCriteriaRef = React.useRef({
	    keys: [],
	    repeating: true,
	    previousKeyMatched: true,
	    lastTime: null
	  });
	  useEnhancedEffect(function () {
	    if (autoFocus) {
	      listRef.current.focus();
	    }
	  }, [autoFocus]);
	  React.useImperativeHandle(actions, function () {
	    return {
	      adjustStyleForScrollbar: function adjustStyleForScrollbar(containerElement, theme) {
	        // Let's ignore that piece of logic if users are already overriding the width
	        // of the menu.
	        var noExplicitWidth = !listRef.current.style.width;
	
	        if (containerElement.clientHeight < listRef.current.clientHeight && noExplicitWidth) {
	          var scrollbarSize = "".concat((0, _getScrollbarSize.default)(true), "px");
	          listRef.current.style[theme.direction === 'rtl' ? 'paddingLeft' : 'paddingRight'] = scrollbarSize;
	          listRef.current.style.width = "calc(100% + ".concat(scrollbarSize, ")");
	        }
	
	        return listRef.current;
	      }
	    };
	  }, []);
	
	  var handleKeyDown = function handleKeyDown(event) {
	    var list = listRef.current;
	    var key = event.key;
	    /**
	     * @type {Element} - will always be defined since we are in a keydown handler
	     * attached to an element. A keydown event is either dispatched to the activeElement
	     * or document.body or document.documentElement. Only the first case will
	     * trigger this specific handler.
	     */
	
	    var currentFocus = (0, _ownerDocument.default)(list).activeElement;
	
	    if (key === 'ArrowDown') {
	      // Prevent scroll of the page
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, nextItem);
	    } else if (key === 'ArrowUp') {
	      event.preventDefault();
	      moveFocus(list, currentFocus, disableListWrap, disabledItemsFocusable, previousItem);
	    } else if (key === 'Home') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, disabledItemsFocusable, nextItem);
	    } else if (key === 'End') {
	      event.preventDefault();
	      moveFocus(list, null, disableListWrap, disabledItemsFocusable, previousItem);
	    } else if (key.length === 1) {
	      var criteria = textCriteriaRef.current;
	      var lowerKey = key.toLowerCase();
	      var currTime = performance.now();
	
	      if (criteria.keys.length > 0) {
	        // Reset
	        if (currTime - criteria.lastTime > 500) {
	          criteria.keys = [];
	          criteria.repeating = true;
	          criteria.previousKeyMatched = true;
	        } else if (criteria.repeating && lowerKey !== criteria.keys[0]) {
	          criteria.repeating = false;
	        }
	      }
	
	      criteria.lastTime = currTime;
	      criteria.keys.push(lowerKey);
	      var keepFocusOnCurrent = currentFocus && !criteria.repeating && textCriteriaMatches(currentFocus, criteria);
	
	      if (criteria.previousKeyMatched && (keepFocusOnCurrent || moveFocus(list, currentFocus, false, disabledItemsFocusable, nextItem, criteria))) {
	        event.preventDefault();
	      } else {
	        criteria.previousKeyMatched = false;
	      }
	    }
	
	    if (onKeyDown) {
	      onKeyDown(event);
	    }
	  };
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    listRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(handleOwnRef, ref);
	  /**
	   * the index of the item should receive focus
	   * in a `variant="selectedMenu"` it's the first `selected` item
	   * otherwise it's the very first item.
	   */
	
	  var activeItemIndex = -1; // since we inject focus related props into children we have to do a lookahead
	  // to check if there is a `selected` item. We're looking for the last `selected`
	  // item and use the first valid item as a fallback
	
	  React.Children.forEach(children, function (child, index) {
	    if (!React.isValidElement(child)) {
	      return;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Menu component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    if (!child.props.disabled) {
	      if (variant === 'selectedMenu' && child.props.selected) {
	        activeItemIndex = index;
	      } else if (activeItemIndex === -1) {
	        activeItemIndex = index;
	      }
	    }
	  });
	  var items = React.Children.map(children, function (child, index) {
	    if (index === activeItemIndex) {
	      var newChildProps = {};
	
	      if (autoFocusItem) {
	        newChildProps.autoFocus = true;
	      }
	
	      if (child.props.tabIndex === undefined && variant === 'selectedMenu') {
	        newChildProps.tabIndex = 0;
	      }
	
	      return React.cloneElement(child, newChildProps);
	    }
	
	    return child;
	  });
	  return /*#__PURE__*/React.createElement(_List.default, (0, _extends2.default)({
	    role: "menu",
	    ref: handleRef,
	    className: className,
	    onKeyDown: handleKeyDown,
	    tabIndex: autoFocus ? 0 : -1
	  }, other), items);
	});
	 false ? MenuList.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, will focus the `[role="menu"]` container and move into tab order.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, will focus the first menuitem if `variant="menu"` or selected item
	   * if `variant="selectedMenu"`.
	   */
	  autoFocusItem: _propTypes.default.bool,
	
	  /**
	   * MenuList contents, normally `MenuItem`s.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, will allow focus on disabled items.
	   */
	  disabledItemsFocusable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the menu items will not wrap focus.
	   */
	  disableListWrap: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onKeyDown: _propTypes.default.func,
	
	  /**
	   * The variant to use. Use `menu` to prevent selected items from impacting the initial focus
	   * and the vertical alignment relative to the anchor element.
	   */
	  variant: _propTypes.default.oneOf(['menu', 'selectedMenu'])
	} : void 0;
	var _default = MenuList;
	exports.default = _default;

/***/ },
/* 331 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _LinearProgress = _interopRequireDefault(__webpack_require__(121));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      flexDirection: 'row',
	      justifyContent: 'space-between',
	      alignItems: 'center',
	      background: theme.palette.background.default,
	      padding: 8
	    },
	
	    /* Styles applied to the root element if `position="bottom"`. */
	    positionBottom: {
	      position: 'fixed',
	      bottom: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	
	    /* Styles applied to the root element if `position="top"`. */
	    positionTop: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      right: 0,
	      zIndex: theme.zIndex.mobileStepper
	    },
	
	    /* Styles applied to the root element if `position="static"`. */
	    positionStatic: {},
	
	    /* Styles applied to the dots container if `variant="dots"`. */
	    dots: {
	      display: 'flex',
	      flexDirection: 'row'
	    },
	
	    /* Styles applied to each dot if `variant="dots"`. */
	    dot: {
	      backgroundColor: theme.palette.action.disabled,
	      borderRadius: '50%',
	      width: 8,
	      height: 8,
	      margin: '0 2px'
	    },
	
	    /* Styles applied to a dot if `variant="dots"` and this is the active step. */
	    dotActive: {
	      backgroundColor: theme.palette.primary.main
	    },
	
	    /* Styles applied to the Linear Progress component if `variant="progress"`. */
	    progress: {
	      width: '50%'
	    }
	  };
	};
	
	exports.styles = styles;
	var MobileStepper = React.forwardRef(function MobileStepper(props, ref) {
	  var _props$activeStep = props.activeStep,
	      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
	      backButton = props.backButton,
	      classes = props.classes,
	      className = props.className,
	      LinearProgressProps = props.LinearProgressProps,
	      nextButton = props.nextButton,
	      _props$position = props.position,
	      position = _props$position === void 0 ? 'bottom' : _props$position,
	      steps = props.steps,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'dots' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "backButton", "classes", "className", "LinearProgressProps", "nextButton", "position", "steps", "variant"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: (0, _clsx.default)(classes.root, classes["position".concat((0, _capitalize.default)(position))], className),
	    ref: ref
	  }, other), backButton, variant === 'text' && /*#__PURE__*/React.createElement(React.Fragment, null, activeStep + 1, " / ", steps), variant === 'dots' && /*#__PURE__*/React.createElement("div", {
	    className: classes.dots
	  }, (0, _toConsumableArray2.default)(new Array(steps)).map(function (_, index) {
	    return /*#__PURE__*/React.createElement("div", {
	      key: index,
	      className: (0, _clsx.default)(classes.dot, index === activeStep && classes.dotActive)
	    });
	  })), variant === 'progress' && /*#__PURE__*/React.createElement(_LinearProgress.default, (0, _extends2.default)({
	    className: classes.progress,
	    variant: "determinate",
	    value: Math.ceil(activeStep / (steps - 1) * 100)
	  }, LinearProgressProps)), nextButton);
	});
	 false ? MobileStepper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the active step (zero based index).
	   * Defines which dot is highlighted when the variant is 'dots'.
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * A back button element. For instance, it can be a `Button` or an `IconButton`.
	   */
	  backButton: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Props applied to the `LinearProgress` element.
	   */
	  LinearProgressProps: _propTypes.default.object,
	
	  /**
	   * A next button element. For instance, it can be a `Button` or an `IconButton`.
	   */
	  nextButton: _propTypes.default.node,
	
	  /**
	   * Set the positioning type.
	   */
	  position: _propTypes.default.oneOf(['bottom', 'static', 'top']),
	
	  /**
	   * The total steps.
	   */
	  steps: _propTypes.default.number.isRequired,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['dots', 'progress', 'text'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiMobileStepper'
	})(MobileStepper);
	
	exports.default = _default;

/***/ },
/* 332 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _MobileStepper.default;
	  }
	});
	
	var _MobileStepper = _interopRequireDefault(__webpack_require__(331));

/***/ },
/* 333 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(20);
	
	var _utils = __webpack_require__(9);
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(27));
	
	var _Portal = _interopRequireDefault(__webpack_require__(84));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(54));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(29));
	
	var _zIndex = _interopRequireDefault(__webpack_require__(163));
	
	var _ModalManager = _interopRequireWildcard(__webpack_require__(128));
	
	var _TrapFocus = _interopRequireDefault(__webpack_require__(335));
	
	var _SimpleBackdrop = _interopRequireDefault(__webpack_require__(334));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container;
	  return ReactDOM.findDOMNode(container);
	}
	
	function getHasTransition(props) {
	  return props.children ? props.children.props.hasOwnProperty('in') : false;
	} // A modal manager used to track and manage the state of open Modals.
	// Modals don't open on the server so this won't conflict with concurrent requests.
	
	
	var defaultManager = new _ModalManager.default();
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      zIndex: theme.zIndex.modal,
	      right: 0,
	      bottom: 0,
	      top: 0,
	      left: 0
	    },
	
	    /* Styles applied to the root element if the `Modal` has exited. */
	    hidden: {
	      visibility: 'hidden'
	    }
	  };
	};
	/**
	 * Modal is a lower-level construct that is leveraged by the following components:
	 *
	 * - [Dialog](/api/dialog/)
	 * - [Drawer](/api/drawer/)
	 * - [Menu](/api/menu/)
	 * - [Popover](/api/popover/)
	 *
	 * If you are creating a modal dialog, you probably want to use the [Dialog](/api/dialog/) component
	 * rather than directly using Modal.
	 *
	 * This component shares many concepts with [react-overlays](https://react-bootstrap.github.io/react-overlays/#modals).
	 */
	
	
	exports.styles = styles;
	var Modal = React.forwardRef(function Modal(inProps, ref) {
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiModal',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$BackdropCompon = props.BackdropComponent,
	      BackdropComponent = _props$BackdropCompon === void 0 ? _SimpleBackdrop.default : _props$BackdropCompon,
	      BackdropProps = props.BackdropProps,
	      children = props.children,
	      _props$closeAfterTran = props.closeAfterTransition,
	      closeAfterTransition = _props$closeAfterTran === void 0 ? false : _props$closeAfterTran,
	      container = props.container,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableBackdro = props.disableBackdropClick,
	      disableBackdropClick = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableEscapeK = props.disableEscapeKeyDown,
	      disableEscapeKeyDown = _props$disableEscapeK === void 0 ? false : _props$disableEscapeK,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      _props$disableScrollL = props.disableScrollLock,
	      disableScrollLock = _props$disableScrollL === void 0 ? false : _props$disableScrollL,
	      _props$hideBackdrop = props.hideBackdrop,
	      hideBackdrop = _props$hideBackdrop === void 0 ? false : _props$hideBackdrop,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      _props$manager = props.manager,
	      manager = _props$manager === void 0 ? defaultManager : _props$manager,
	      onBackdropClick = props.onBackdropClick,
	      onClose = props.onClose,
	      onEscapeKeyDown = props.onEscapeKeyDown,
	      onRendered = props.onRendered,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["BackdropComponent", "BackdropProps", "children", "closeAfterTransition", "container", "disableAutoFocus", "disableBackdropClick", "disableEnforceFocus", "disableEscapeKeyDown", "disablePortal", "disableRestoreFocus", "disableScrollLock", "hideBackdrop", "keepMounted", "manager", "onBackdropClick", "onClose", "onEscapeKeyDown", "onRendered", "open"]);
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var modal = React.useRef({});
	  var mountNodeRef = React.useRef(null);
	  var modalRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(modalRef, ref);
	  var hasTransition = getHasTransition(props);
	
	  var getDoc = function getDoc() {
	    return (0, _ownerDocument.default)(mountNodeRef.current);
	  };
	
	  var getModal = function getModal() {
	    modal.current.modalRef = modalRef.current;
	    modal.current.mountNode = mountNodeRef.current;
	    return modal.current;
	  };
	
	  var handleMounted = function handleMounted() {
	    manager.mount(getModal(), {
	      disableScrollLock: disableScrollLock
	    }); // Fix a bug on Chrome where the scroll isn't initially 0.
	
	    modalRef.current.scrollTop = 0;
	  };
	
	  var handleOpen = (0, _useEventCallback.default)(function () {
	    var resolvedContainer = getContainer(container) || getDoc().body;
	    manager.add(getModal(), resolvedContainer); // The element was already mounted.
	
	    if (modalRef.current) {
	      handleMounted();
	    }
	  });
	  var isTopModal = React.useCallback(function () {
	    return manager.isTopModal(getModal());
	  }, [manager]);
	  var handlePortalRef = (0, _useEventCallback.default)(function (node) {
	    mountNodeRef.current = node;
	
	    if (!node) {
	      return;
	    }
	
	    if (onRendered) {
	      onRendered();
	    }
	
	    if (open && isTopModal()) {
	      handleMounted();
	    } else {
	      (0, _ModalManager.ariaHidden)(modalRef.current, true);
	    }
	  });
	  var handleClose = React.useCallback(function () {
	    manager.remove(getModal());
	  }, [manager]);
	  React.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, [handleClose]);
	  React.useEffect(function () {
	    if (open) {
	      handleOpen();
	    } else if (!hasTransition || !closeAfterTransition) {
	      handleClose();
	    }
	  }, [open, handleClose, hasTransition, closeAfterTransition, handleOpen]);
	
	  if (!keepMounted && !open && (!hasTransition || exited)) {
	    return null;
	  }
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	
	    if (closeAfterTransition) {
	      handleClose();
	    }
	  };
	
	  var handleBackdropClick = function handleBackdropClick(event) {
	    if (event.target !== event.currentTarget) {
	      return;
	    }
	
	    if (onBackdropClick) {
	      onBackdropClick(event);
	    }
	
	    if (!disableBackdropClick && onClose) {
	      onClose(event, 'backdropClick');
	    }
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    // The handler doesn't take event.defaultPrevented into account:
	    //
	    // event.preventDefault() is meant to stop default behaviours like
	    // clicking a checkbox to check it, hitting a button to submit a form,
	    // and hitting left arrow to move the cursor in a text input etc.
	    // Only special HTML elements have these default behaviors.
	    if (event.key !== 'Escape' || !isTopModal()) {
	      return;
	    } // Swallow the event, in case someone is listening for the escape key on the body.
	
	
	    event.stopPropagation();
	
	    if (onEscapeKeyDown) {
	      onEscapeKeyDown(event);
	    }
	
	    if (!disableEscapeKeyDown && onClose) {
	      onClose(event, 'escapeKeyDown');
	    }
	  };
	
	  var inlineStyle = styles(theme || {
	    zIndex: _zIndex.default
	  });
	  var childProps = {};
	
	  if (children.props.tabIndex === undefined) {
	    childProps.tabIndex = children.props.tabIndex || '-1';
	  } // It's a Transition like component
	
	
	  if (hasTransition) {
	    childProps.onEnter = (0, _createChainedFunction.default)(handleEnter, children.props.onEnter);
	    childProps.onExited = (0, _createChainedFunction.default)(handleExited, children.props.onExited);
	  }
	
	  return /*#__PURE__*/React.createElement(_Portal.default, {
	    ref: handlePortalRef,
	    container: container,
	    disablePortal: disablePortal
	  }, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    onKeyDown: handleKeyDown,
	    role: "presentation"
	  }, other, {
	    style: (0, _extends2.default)({}, inlineStyle.root, {}, !open && exited ? inlineStyle.hidden : {}, {}, other.style)
	  }), hideBackdrop ? null : /*#__PURE__*/React.createElement(BackdropComponent, (0, _extends2.default)({
	    open: open,
	    onClick: handleBackdropClick
	  }, BackdropProps)), /*#__PURE__*/React.createElement(_TrapFocus.default, {
	    disableEnforceFocus: disableEnforceFocus,
	    disableAutoFocus: disableAutoFocus,
	    disableRestoreFocus: disableRestoreFocus,
	    getDoc: getDoc,
	    isEnabled: isTopModal,
	    open: open
	  }, React.cloneElement(children, childProps))));
	});
	 false ? Modal.propTypes = {
	  /**
	   * A backdrop component. This prop enables custom backdrop rendering.
	   */
	  BackdropComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Backdrop`](/api/backdrop/) element.
	   */
	  BackdropProps: _propTypes.default.object,
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * When set to true the Modal waits until a nested Transition is completed before closing.
	   */
	  closeAfterTransition: _propTypes.default.bool,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   */
	  container: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]),
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, clicking the backdrop will not fire any callback.
	   */
	  disableBackdropClick: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, hitting escape will not fire any callback.
	   */
	  disableEscapeKeyDown: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Disable the scroll lock behavior.
	   */
	  disableScrollLock: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is not rendered.
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Modal.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  manager: _propTypes.default.object,
	
	  /**
	   * Callback fired when the backdrop is clicked.
	   */
	  onBackdropClick: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * The `reason` parameter can optionally be used to control the response to `onClose`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"escapeKeyDown"`, `"backdropClick"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the escape key is pressed,
	   * `disableEscapeKeyDown` is false and the modal is in focus.
	   */
	  onEscapeKeyDown: _propTypes.default.func,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   * It signals that the `open={true}` prop took effect.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = Modal;
	exports.default = _default;

/***/ },
/* 334 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    zIndex: -1,
	    position: 'fixed',
	    right: 0,
	    bottom: 0,
	    top: 0,
	    left: 0,
	    backgroundColor: 'rgba(0, 0, 0, 0.5)',
	    WebkitTapHighlightColor: 'transparent'
	  },
	
	  /* Styles applied to the root element if `invisible={true}`. */
	  invisible: {
	    backgroundColor: 'transparent'
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	var SimpleBackdrop = React.forwardRef(function SimpleBackdrop(props, ref) {
	  var _props$invisible = props.invisible,
	      invisible = _props$invisible === void 0 ? false : _props$invisible,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["invisible", "open"]);
	  return open ? /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    "aria-hidden": true,
	    ref: ref
	  }, other, {
	    style: (0, _extends2.default)({}, styles.root, {}, invisible ? styles.invisible : {}, {}, other.style)
	  })) : null;
	});
	 false ? SimpleBackdrop.propTypes = {
	  /**
	   * If `true`, the backdrop is invisible.
	   * It can be used when rendering a popover or a custom select component.
	   */
	  invisible: _propTypes.default.bool,
	
	  /**
	   * If `true`, the backdrop is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	var _default = SimpleBackdrop;
	exports.default = _default;

/***/ },
/* 335 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(27));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	/* eslint-disable consistent-return, jsx-a11y/no-noninteractive-tabindex */
	
	/**
	 * @ignore - internal component.
	 */
	function TrapFocus(props) {
	  var children = props.children,
	      _props$disableAutoFoc = props.disableAutoFocus,
	      disableAutoFocus = _props$disableAutoFoc === void 0 ? false : _props$disableAutoFoc,
	      _props$disableEnforce = props.disableEnforceFocus,
	      disableEnforceFocus = _props$disableEnforce === void 0 ? false : _props$disableEnforce,
	      _props$disableRestore = props.disableRestoreFocus,
	      disableRestoreFocus = _props$disableRestore === void 0 ? false : _props$disableRestore,
	      getDoc = props.getDoc,
	      isEnabled = props.isEnabled,
	      open = props.open;
	  var ignoreNextEnforceFocus = React.useRef();
	  var sentinelStart = React.useRef(null);
	  var sentinelEnd = React.useRef(null);
	  var nodeToRestore = React.useRef();
	  var rootRef = React.useRef(null); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    rootRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // ⚠️ You may rely on React.useMemo as a performance optimization, not as a semantic guarantee.
	  // https://reactjs.org/docs/hooks-reference.html#usememo
	
	  React.useMemo(function () {
	    if (!open || typeof window === 'undefined') {
	      return;
	    }
	
	    nodeToRestore.current = getDoc().activeElement;
	  }, [open]); // eslint-disable-line react-hooks/exhaustive-deps
	
	  React.useEffect(function () {
	    if (!open) {
	      return;
	    }
	
	    var doc = (0, _ownerDocument.default)(rootRef.current); // We might render an empty child.
	
	    if (!disableAutoFocus && rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	      if (!rootRef.current.hasAttribute('tabIndex')) {
	        if (false) {
	          console.error(['Material-UI: the modal content node does not accept focus.', 'For the benefit of assistive technologies, ' + 'the tabIndex of the node is being set to "-1".'].join('\n'));
	        }
	
	        rootRef.current.setAttribute('tabIndex', -1);
	      }
	
	      rootRef.current.focus();
	    }
	
	    var contain = function contain() {
	      if (disableEnforceFocus || !isEnabled() || ignoreNextEnforceFocus.current) {
	        ignoreNextEnforceFocus.current = false;
	        return;
	      }
	
	      if (rootRef.current && !rootRef.current.contains(doc.activeElement)) {
	        rootRef.current.focus();
	      }
	    };
	
	    var loopFocus = function loopFocus(event) {
	      // 9 = Tab
	      if (disableEnforceFocus || !isEnabled() || event.keyCode !== 9) {
	        return;
	      } // Make sure the next tab starts from the right place.
	
	
	      if (doc.activeElement === rootRef.current) {
	        // We need to ignore the next contain as
	        // it will try to move the focus back to the rootRef element.
	        ignoreNextEnforceFocus.current = true;
	
	        if (event.shiftKey) {
	          sentinelEnd.current.focus();
	        } else {
	          sentinelStart.current.focus();
	        }
	      }
	    };
	
	    doc.addEventListener('focus', contain, true);
	    doc.addEventListener('keydown', loopFocus, true); // With Edge, Safari and Firefox, no focus related events are fired when the focused area stops being a focused area
	    // e.g. https://bugzilla.mozilla.org/show_bug.cgi?id=559561.
	    //
	    // The whatwg spec defines how the browser should behave but does not explicitly mention any events:
	    // https://html.spec.whatwg.org/multipage/interaction.html#focus-fixup-rule.
	
	    var interval = setInterval(function () {
	      contain();
	    }, 50);
	    return function () {
	      clearInterval(interval);
	      doc.removeEventListener('focus', contain, true);
	      doc.removeEventListener('keydown', loopFocus, true); // restoreLastFocus()
	
	      if (!disableRestoreFocus) {
	        // In IE 11 it is possible for document.activeElement to be null resulting
	        // in nodeToRestore.current being null.
	        // Not all elements in IE 11 have a focus method.
	        // Once IE 11 support is dropped the focus() call can be unconditional.
	        if (nodeToRestore.current && nodeToRestore.current.focus) {
	          nodeToRestore.current.focus();
	        }
	
	        nodeToRestore.current = null;
	      }
	    };
	  }, [disableAutoFocus, disableEnforceFocus, disableRestoreFocus, isEnabled, open]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelStart,
	    "data-test": "sentinelStart"
	  }), React.cloneElement(children, {
	    ref: handleRef
	  }), /*#__PURE__*/React.createElement("div", {
	    tabIndex: 0,
	    ref: sentinelEnd,
	    "data-test": "sentinelEnd"
	  }));
	}
	
	 false ? TrapFocus.propTypes = {
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * If `true`, the modal will not automatically shift focus to itself when it opens, and
	   * replace it to the last focused element when it closes.
	   * This also works correctly with any modal children that have the `disableAutoFocus` prop.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableAutoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not prevent focus from leaving the modal while open.
	   *
	   * Generally this should never be set to `true` as it makes the modal less
	   * accessible to assistive technologies, like screen readers.
	   */
	  disableEnforceFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the modal will not restore focus to previously focused element once
	   * modal is hidden.
	   */
	  disableRestoreFocus: _propTypes.default.bool,
	
	  /**
	   * Return the document to consider.
	   * We use it to implement the restore focus between different browser documents.
	   */
	  getDoc: _propTypes.default.func.isRequired,
	
	  /**
	   * Do we still want to enforce the focus?
	   * This prop helps nesting TrapFocus elements.
	   */
	  isEnabled: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, the modal is open.
	   */
	  open: _propTypes.default.bool.isRequired
	} : void 0;
	/*
	
	In the future, we should be able to replace TrapFocus with:
	https://github.com/facebook/react/blob/master/packages/react-events/docs/FocusScope.md
	
	```jsx
	import FocusScope from 'react-dom/FocusScope';
	
	function TrapFocus(props) {
	  const {
	    children
	    disableAutoFocus = false,
	    disableEnforceFocus = false,
	    disableRestoreFocus = false,
	    open,
	  } = props;
	
	  if (!open) {
	    return children;
	  }
	
	  return (
	    <FocusScope
	      autoFocus={!disableAutoFocus}
	      contain={!disableEnforceFocus}
	      restoreFocus={!disableRestoreFocus}
	    >
	      {children}
	    </FocusScope>
	  );
	}
	```
	
	*/
	
	var _default = TrapFocus;
	exports.default = _default;

/***/ },
/* 336 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _NativeSelect.default;
	  }
	});
	
	var _NativeSelect = _interopRequireDefault(__webpack_require__(129));

/***/ },
/* 337 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(9);
	
	var useEnhancedEffect = typeof window !== 'undefined' && ("production") !== 'test' ? React.useLayoutEffect : React.useEffect;
	/**
	 * NoSsr purposely removes components from the subject of Server Side Rendering (SSR).
	 *
	 * This component can be useful in a variety of situations:
	 * - Escape hatch for broken dependencies not supporting SSR.
	 * - Improve the time-to-first paint on the client by only rendering above the fold.
	 * - Reduce the rendering time on the server.
	 * - Under too heavy server load, you can turn on service degradation.
	 */
	
	function NoSsr(props) {
	  var children = props.children,
	      _props$defer = props.defer,
	      defer = _props$defer === void 0 ? false : _props$defer,
	      _props$fallback = props.fallback,
	      fallback = _props$fallback === void 0 ? null : _props$fallback;
	
	  var _React$useState = React.useState(false),
	      mountedState = _React$useState[0],
	      setMountedState = _React$useState[1];
	
	  useEnhancedEffect(function () {
	    if (!defer) {
	      setMountedState(true);
	    }
	  }, [defer]);
	  React.useEffect(function () {
	    if (defer) {
	      setMountedState(true);
	    }
	  }, [defer]); // We need the Fragment here to force react-docgen to recognise NoSsr as a component.
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, mountedState ? children : fallback);
	}
	
	 false ? NoSsr.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * You can wrap a node.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * If `true`, the component will not only prevent server-side rendering.
	   * It will also defer the rendering of the children into a different screen frame.
	   */
	  defer: _propTypes.default.bool,
	
	  /**
	   * The fallback content to display.
	   */
	  fallback: _propTypes.default.node
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  NoSsr['propTypes' + ''] = (0, _utils.exactProp)(NoSsr.propTypes);
	}
	
	var _default = NoSsr;
	exports.default = _default;

/***/ },
/* 338 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'absolute',
	      bottom: 0,
	      right: 0,
	      top: -5,
	      left: 0,
	      margin: 0,
	      padding: 0,
	      paddingLeft: 8,
	      pointerEvents: 'none',
	      borderRadius: 'inherit',
	      borderStyle: 'solid',
	      borderWidth: 1
	    },
	
	    /* Styles applied to the legend element when `labelWidth` is provided. */
	    legend: {
	      textAlign: 'left',
	      padding: 0,
	      lineHeight: '11px',
	      // sync with `height` in `legend` styles
	      transition: theme.transitions.create('width', {
	        duration: 150,
	        easing: theme.transitions.easing.easeOut
	      })
	    },
	
	    /* Styles applied to the legend element. */
	    legendLabelled: {
	      display: 'block',
	      width: 'auto',
	      textAlign: 'left',
	      padding: 0,
	      height: 11,
	      // sync with `lineHeight` in `legend` styles
	      fontSize: '0.75em',
	      visibility: 'hidden',
	      maxWidth: 0.01,
	      transition: theme.transitions.create('max-width', {
	        duration: 50,
	        easing: theme.transitions.easing.easeOut
	      }),
	      '& > span': {
	        paddingLeft: 5,
	        paddingRight: 5,
	        display: 'inline-block'
	      }
	    },
	
	    /* Styles applied to the legend element is notched. */
	    legendNotched: {
	      maxWidth: 1000,
	      transition: theme.transitions.create('max-width', {
	        duration: 100,
	        easing: theme.transitions.easing.easeOut,
	        delay: 50
	      })
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var NotchedOutline = React.forwardRef(function NotchedOutline(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      label = props.label,
	      labelWidthProp = props.labelWidth,
	      notched = props.notched,
	      style = props.style,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "label", "labelWidth", "notched", "style"]);
	  var theme = (0, _useTheme.default)();
	  var align = theme.direction === 'rtl' ? 'right' : 'left';
	
	  if (label !== undefined) {
	    return /*#__PURE__*/React.createElement("fieldset", (0, _extends3.default)({
	      "aria-hidden": true,
	      className: (0, _clsx.default)(classes.root, className),
	      ref: ref,
	      style: style
	    }, other), /*#__PURE__*/React.createElement("legend", {
	      className: (0, _clsx.default)(classes.legendLabelled, notched && classes.legendNotched)
	    }, label ? /*#__PURE__*/React.createElement("span", null, label) : /*#__PURE__*/React.createElement("span", {
	      dangerouslySetInnerHTML: {
	        __html: '&#8203;'
	      }
	    })));
	  }
	
	  var labelWidth = labelWidthProp > 0 ? labelWidthProp * 0.75 + 8 : 0.01;
	  return /*#__PURE__*/React.createElement("fieldset", (0, _extends3.default)({
	    "aria-hidden": true,
	    style: (0, _extends3.default)((0, _defineProperty2.default)({}, "padding".concat((0, _capitalize.default)(align)), 8), style),
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("legend", {
	    className: classes.legend,
	    style: {
	      // IE 11: fieldset with legend does not render
	      // a border radius. This maintains consistency
	      // by always having a legend rendered
	      width: notched ? labelWidth : 0.01
	    }
	  }, /*#__PURE__*/React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  })));
	});
	 false ? NotchedOutline.propTypes = {
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The label.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The width of the label.
	   */
	  labelWidth: _propTypes.default.number.isRequired,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateNotchedOutline'
	})(NotchedOutline);
	
	exports.default = _default;

/***/ },
/* 339 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _InputBase = _interopRequireDefault(__webpack_require__(49));
	
	var _NotchedOutline = _interopRequireDefault(__webpack_require__(338));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  var borderColor = theme.palette.type === 'light' ? 'rgba(0, 0, 0, 0.23)' : 'rgba(255, 255, 255, 0.23)';
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      borderRadius: theme.shape.borderRadius,
	      '&:hover $notchedOutline': {
	        borderColor: theme.palette.text.primary
	      },
	      // Reset on touch devices, it doesn't add specificity
	      '@media (hover: none)': {
	        '&:hover $notchedOutline': {
	          borderColor: borderColor
	        }
	      },
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.primary.main,
	        borderWidth: 2
	      },
	      '&$error $notchedOutline': {
	        borderColor: theme.palette.error.main
	      },
	      '&$disabled $notchedOutline': {
	        borderColor: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the color is secondary. */
	    colorSecondary: {
	      '&$focused $notchedOutline': {
	        borderColor: theme.palette.secondary.main
	      }
	    },
	
	    /* Styles applied to the root element if the component is focused. */
	    focused: {},
	
	    /* Styles applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `startAdornment` is provided. */
	    adornedStart: {
	      paddingLeft: 14
	    },
	
	    /* Styles applied to the root element if `endAdornment` is provided. */
	    adornedEnd: {
	      paddingRight: 14
	    },
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {},
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    marginDense: {},
	
	    /* Styles applied to the root element if `multiline={true}`. */
	    multiline: {
	      padding: '18.5px 14px',
	      '&$marginDense': {
	        paddingTop: 10.5,
	        paddingBottom: 10.5
	      }
	    },
	
	    /* Styles applied to the `NotchedOutline` element. */
	    notchedOutline: {
	      borderColor: borderColor
	    },
	
	    /* Styles applied to the `input` element. */
	    input: {
	      padding: '18.5px 14px',
	      '&:-webkit-autofill': {
	        WebkitBoxShadow: theme.palette.type === 'dark' ? '0 0 0 100px #266798 inset' : null,
	        WebkitTextFillColor: theme.palette.type === 'dark' ? '#fff' : null,
	        borderRadius: 'inherit'
	      }
	    },
	
	    /* Styles applied to the `input` element if `margin="dense"`. */
	    inputMarginDense: {
	      paddingTop: 10.5,
	      paddingBottom: 10.5
	    },
	
	    /* Styles applied to the `input` element if `multiline={true}`. */
	    inputMultiline: {
	      padding: 0
	    },
	
	    /* Styles applied to the `input` element if `startAdornment` is provided. */
	    inputAdornedStart: {
	      paddingLeft: 0
	    },
	
	    /* Styles applied to the `input` element if `endAdornment` is provided. */
	    inputAdornedEnd: {
	      paddingRight: 0
	    }
	  };
	};
	
	exports.styles = styles;
	var OutlinedInput = React.forwardRef(function OutlinedInput(props, ref) {
	  var classes = props.classes,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      _props$inputComponent = props.inputComponent,
	      inputComponent = _props$inputComponent === void 0 ? 'input' : _props$inputComponent,
	      label = props.label,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      notched = props.notched,
	      _props$type = props.type,
	      type = _props$type === void 0 ? 'text' : _props$type,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "fullWidth", "inputComponent", "label", "labelWidth", "multiline", "notched", "type"]);
	  return /*#__PURE__*/React.createElement(_InputBase.default, (0, _extends2.default)({
	    renderSuffix: function renderSuffix(state) {
	      return /*#__PURE__*/React.createElement(_NotchedOutline.default, {
	        className: classes.notchedOutline,
	        label: label,
	        labelWidth: labelWidth,
	        notched: typeof notched !== 'undefined' ? notched : Boolean(state.startAdornment || state.filled || state.focused)
	      });
	    },
	    classes: (0, _extends2.default)({}, classes, {
	      root: (0, _clsx.default)(classes.root, classes.underline),
	      notchedOutline: null
	    }),
	    fullWidth: fullWidth,
	    inputComponent: inputComponent,
	    multiline: multiline,
	    ref: ref,
	    type: type
	  }, other));
	});
	 false ? OutlinedInput.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * End `InputAdornment` for this component.
	   */
	  endAdornment: _propTypes.default.node,
	
	  /**
	   * If `true`, the input will indicate an error. This is normally obtained via context from
	   * FormControl.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * The component used for the `input` element.
	   * Either a string to use a DOM element or a component.
	   */
	  inputComponent: _propTypes.default.elementType,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label of the input. It is only used for layout. The actual labelling
	   * is handled by `InputLabel`. If specified `labelWidth` is ignored.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The width of the label. Is ignored if `label` is provided. Prefer `label`
	   * if the input label appears with a strike through.
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * If `dense`, will adjust vertical spacing. This is normally obtained via context from
	   * FormControl.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none']),
	
	  /**
	   * If `true`, a textarea element will be rendered.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * If `true`, the outline is notched to accommodate the label.
	   */
	  notched: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * It prevents the user from changing the value of the field
	   * (not from interacting with the field).
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Start `InputAdornment` for this component.
	   */
	  startAdornment: _propTypes.default.node,
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any
	} : void 0;
	OutlinedInput.muiName = 'Input';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiOutlinedInput'
	})(OutlinedInput);
	
	exports.default = _default;

/***/ },
/* 340 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  var elevations = {};
	  theme.shadows.forEach(function (shadow, index) {
	    elevations["elevation".concat(index)] = {
	      boxShadow: shadow
	    };
	  });
	  return (0, _extends2.default)({
	    /* Styles applied to the root element. */
	    root: {
	      backgroundColor: theme.palette.background.paper,
	      color: theme.palette.text.primary,
	      transition: theme.transitions.create('box-shadow')
	    },
	
	    /* Styles applied to the root element if `square={false}`. */
	    rounded: {
	      borderRadius: theme.shape.borderRadius
	    },
	
	    /* Styles applied to the root element if `variant="outlined"` */
	    outlined: {
	      border: "1px solid ".concat(theme.palette.divider)
	    }
	  }, elevations);
	};
	
	exports.styles = styles;
	var Paper = React.forwardRef(function Paper(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$square = props.square,
	      square = _props$square === void 0 ? false : _props$square,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 1 : _props$elevation,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'elevation' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "square", "elevation", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant === 'outlined' ? classes.outlined : classes["elevation".concat(elevation)], !square && classes.rounded),
	    ref: ref
	  }, other));
	});
	 false ? Paper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Shadow depth, corresponds to `dp` in the spec.
	   * It accepts values between 0 and 24 inclusive.
	   */
	  elevation: (0, _utils.chainPropTypes)(_propTypes.default.number, function (props) {
	    var classes = props.classes,
	        elevation = props.elevation; // in case `withStyles` fails to inject we don't need this warning
	
	    if (classes === undefined) {
	      return null;
	    }
	
	    if (elevation != null && classes["elevation".concat(elevation)] === undefined) {
	      return new Error("Material-UI: this elevation `".concat(elevation, "` is not implemented."));
	    }
	
	    return null;
	  }),
	
	  /**
	   * If `true`, rounded corners are disabled.
	   */
	  square: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['elevation', 'outlined'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPaper'
	})(Paper);
	
	exports.default = _default;

/***/ },
/* 341 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getOffsetTop = getOffsetTop;
	exports.getOffsetLeft = getOffsetLeft;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _debounce = _interopRequireDefault(__webpack_require__(37));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(27));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(56));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(54));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Modal = _interopRequireDefault(__webpack_require__(65));
	
	var _Grow = _interopRequireDefault(__webpack_require__(63));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	function getOffsetTop(rect, vertical) {
	  var offset = 0;
	
	  if (typeof vertical === 'number') {
	    offset = vertical;
	  } else if (vertical === 'center') {
	    offset = rect.height / 2;
	  } else if (vertical === 'bottom') {
	    offset = rect.height;
	  }
	
	  return offset;
	}
	
	function getOffsetLeft(rect, horizontal) {
	  var offset = 0;
	
	  if (typeof horizontal === 'number') {
	    offset = horizontal;
	  } else if (horizontal === 'center') {
	    offset = rect.width / 2;
	  } else if (horizontal === 'right') {
	    offset = rect.width;
	  }
	
	  return offset;
	}
	
	function getTransformOriginValue(transformOrigin) {
	  return [transformOrigin.horizontal, transformOrigin.vertical].map(function (n) {
	    return typeof n === 'number' ? "".concat(n, "px") : n;
	  }).join(' ');
	} // Sum the scrollTop between two elements.
	
	
	function getScrollParent(parent, child) {
	  var element = child;
	  var scrollTop = 0;
	
	  while (element && element !== parent) {
	    element = element.parentElement;
	    scrollTop += element.scrollTop;
	  }
	
	  return scrollTop;
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var styles = {
	  /* Styles applied to the root element */
	  root: {},
	
	  /* Styles applied to the `Paper` component. */
	  paper: {
	    position: 'absolute',
	    overflowY: 'auto',
	    overflowX: 'hidden',
	    // So we see the popover when it's empty.
	    // It's most likely on issue on userland.
	    minWidth: 16,
	    minHeight: 16,
	    maxWidth: 'calc(100% - 32px)',
	    maxHeight: 'calc(100% - 32px)',
	    // We disable the focus ring for mouse, touch and keyboard users.
	    outline: 0
	  }
	};
	exports.styles = styles;
	var Popover = React.forwardRef(function Popover(props, ref) {
	  var action = props.action,
	      anchorEl = props.anchorEl,
	      _props$anchorOrigin = props.anchorOrigin,
	      anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$anchorOrigin,
	      anchorPosition = props.anchorPosition,
	      _props$anchorReferenc = props.anchorReference,
	      anchorReference = _props$anchorReferenc === void 0 ? 'anchorEl' : _props$anchorReferenc,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      containerProp = props.container,
	      _props$elevation = props.elevation,
	      elevation = _props$elevation === void 0 ? 8 : _props$elevation,
	      getContentAnchorEl = props.getContentAnchorEl,
	      _props$marginThreshol = props.marginThreshold,
	      marginThreshold = _props$marginThreshol === void 0 ? 16 : _props$marginThreshol,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      _props$transformOrigi = props.transformOrigin,
	      transformOrigin = _props$transformOrigi === void 0 ? {
	    vertical: 'top',
	    horizontal: 'left'
	  } : _props$transformOrigi,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      _props$TransitionProp = props.TransitionProps,
	      TransitionProps = _props$TransitionProp === void 0 ? {} : _props$TransitionProp,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorEl", "anchorOrigin", "anchorPosition", "anchorReference", "children", "classes", "className", "container", "elevation", "getContentAnchorEl", "marginThreshold", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "open", "PaperProps", "transformOrigin", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  var paperRef = React.useRef(); // Returns the top/left offset of the position
	  // to attach to on the anchor element (or body if none is provided)
	
	  var getAnchorOffset = React.useCallback(function (contentAnchorOffset) {
	    if (anchorReference === 'anchorPosition') {
	      if (false) {
	        if (!anchorPosition) {
	          console.error('Material-UI: you need to provide a `anchorPosition` prop when using ' + '<Popover anchorReference="anchorPosition" />.');
	        }
	      }
	
	      return anchorPosition;
	    }
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl);
	    var containerWindow = (0, _ownerWindow.default)(resolvedAnchorEl); // If an anchor element wasn't provided, just use the parent body element of this Popover
	
	    var anchorElement = resolvedAnchorEl instanceof containerWindow.Element ? resolvedAnchorEl : (0, _ownerDocument.default)(paperRef.current).body;
	    var anchorRect = anchorElement.getBoundingClientRect();
	
	    if (false) {
	      var box = anchorElement.getBoundingClientRect();
	
	      if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	        console.warn(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	      }
	    }
	
	    var anchorVertical = contentAnchorOffset === 0 ? anchorOrigin.vertical : 'center';
	    return {
	      top: anchorRect.top + getOffsetTop(anchorRect, anchorVertical),
	      left: anchorRect.left + getOffsetLeft(anchorRect, anchorOrigin.horizontal)
	    };
	  }, [anchorEl, anchorOrigin.horizontal, anchorOrigin.vertical, anchorPosition, anchorReference]); // Returns the vertical offset of inner content to anchor the transform on if provided
	
	  var getContentAnchorOffset = React.useCallback(function (element) {
	    var contentAnchorOffset = 0;
	
	    if (getContentAnchorEl && anchorReference === 'anchorEl') {
	      var contentAnchorEl = getContentAnchorEl(element);
	
	      if (contentAnchorEl && element.contains(contentAnchorEl)) {
	        var scrollTop = getScrollParent(element, contentAnchorEl);
	        contentAnchorOffset = contentAnchorEl.offsetTop + contentAnchorEl.clientHeight / 2 - scrollTop || 0;
	      } // != the default value
	
	
	      if (false) {
	        if (anchorOrigin.vertical !== 'top') {
	          console.error(['Material-UI: you can not change the default `anchorOrigin.vertical` value ', 'when also providing the `getContentAnchorEl` prop to the popover component.', 'Only use one of the two props.', 'Set `getContentAnchorEl` to `null | undefined`' + ' or leave `anchorOrigin.vertical` unchanged.'].join('\n'));
	        }
	      }
	    }
	
	    return contentAnchorOffset;
	  }, [anchorOrigin.vertical, anchorReference, getContentAnchorEl]); // Return the base transform origin using the element
	  // and taking the content anchor offset into account if in use
	
	  var getTransformOrigin = React.useCallback(function (elemRect) {
	    var contentAnchorOffset = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
	    return {
	      vertical: getOffsetTop(elemRect, transformOrigin.vertical) + contentAnchorOffset,
	      horizontal: getOffsetLeft(elemRect, transformOrigin.horizontal)
	    };
	  }, [transformOrigin.horizontal, transformOrigin.vertical]);
	  var getPositioningStyle = React.useCallback(function (element) {
	    // Check if the parent has requested anchoring on an inner content node
	    var contentAnchorOffset = getContentAnchorOffset(element);
	    var elemRect = {
	      width: element.offsetWidth,
	      height: element.offsetHeight
	    }; // Get the transform origin point on the element itself
	
	    var elemTransformOrigin = getTransformOrigin(elemRect, contentAnchorOffset);
	
	    if (anchorReference === 'none') {
	      return {
	        top: null,
	        left: null,
	        transformOrigin: getTransformOriginValue(elemTransformOrigin)
	      };
	    } // Get the offset of of the anchoring element
	
	
	    var anchorOffset = getAnchorOffset(contentAnchorOffset); // Calculate element positioning
	
	    var top = anchorOffset.top - elemTransformOrigin.vertical;
	    var left = anchorOffset.left - elemTransformOrigin.horizontal;
	    var bottom = top + elemRect.height;
	    var right = left + elemRect.width; // Use the parent window of the anchorEl if provided
	
	    var containerWindow = (0, _ownerWindow.default)(getAnchorEl(anchorEl)); // Window thresholds taking required margin into account
	
	    var heightThreshold = containerWindow.innerHeight - marginThreshold;
	    var widthThreshold = containerWindow.innerWidth - marginThreshold; // Check if the vertical axis needs shifting
	
	    if (top < marginThreshold) {
	      var diff = top - marginThreshold;
	      top -= diff;
	      elemTransformOrigin.vertical += diff;
	    } else if (bottom > heightThreshold) {
	      var _diff = bottom - heightThreshold;
	
	      top -= _diff;
	      elemTransformOrigin.vertical += _diff;
	    }
	
	    if (false) {
	      if (elemRect.height > heightThreshold && elemRect.height && heightThreshold) {
	        console.error(['Material-UI: the popover component is too tall.', "Some part of it can not be seen on the screen (".concat(elemRect.height - heightThreshold, "px)."), 'Please consider adding a `max-height` to improve the user-experience.'].join('\n'));
	      }
	    } // Check if the horizontal axis needs shifting
	
	
	    if (left < marginThreshold) {
	      var _diff2 = left - marginThreshold;
	
	      left -= _diff2;
	      elemTransformOrigin.horizontal += _diff2;
	    } else if (right > widthThreshold) {
	      var _diff3 = right - widthThreshold;
	
	      left -= _diff3;
	      elemTransformOrigin.horizontal += _diff3;
	    }
	
	    return {
	      top: "".concat(Math.round(top), "px"),
	      left: "".concat(Math.round(left), "px"),
	      transformOrigin: getTransformOriginValue(elemTransformOrigin)
	    };
	  }, [anchorEl, anchorReference, getAnchorOffset, getContentAnchorOffset, getTransformOrigin, marginThreshold]);
	  var setPositioningStyles = React.useCallback(function () {
	    var element = paperRef.current;
	
	    if (!element) {
	      return;
	    }
	
	    var positioning = getPositioningStyle(element);
	
	    if (positioning.top !== null) {
	      element.style.top = positioning.top;
	    }
	
	    if (positioning.left !== null) {
	      element.style.left = positioning.left;
	    }
	
	    element.style.transformOrigin = positioning.transformOrigin;
	  }, [getPositioningStyle]);
	
	  var handleEntering = function handleEntering(element, isAppearing) {
	    if (onEntering) {
	      onEntering(element, isAppearing);
	    }
	
	    setPositioningStyles();
	  };
	
	  var handlePaperRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    paperRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  React.useEffect(function () {
	    if (open) {
	      setPositioningStyles();
	    }
	  });
	  React.useImperativeHandle(action, function () {
	    return open ? {
	      updatePosition: function updatePosition() {
	        setPositioningStyles();
	      }
	    } : null;
	  }, [open, setPositioningStyles]);
	  React.useEffect(function () {
	    if (!open) {
	      return undefined;
	    }
	
	    var handleResize = (0, _debounce.default)(function () {
	      setPositioningStyles();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [open, setPositioningStyles]);
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  } // If the container prop is provided, use that
	  // If the anchorEl prop is provided, use its parent body element as the container
	  // If neither are provided let the Modal take care of choosing the container
	
	
	  var container = containerProp || (anchorEl ? (0, _ownerDocument.default)(getAnchorEl(anchorEl)).body : undefined);
	  return /*#__PURE__*/React.createElement(_Modal.default, (0, _extends2.default)({
	    container: container,
	    open: open,
	    ref: ref,
	    BackdropProps: {
	      invisible: true
	    },
	    className: (0, _clsx.default)(classes.root, className)
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    appear: true,
	    in: open,
	    onEnter: onEnter,
	    onEntered: onEntered,
	    onExit: onExit,
	    onExited: onExited,
	    onExiting: onExiting,
	    timeout: transitionDuration
	  }, TransitionProps, {
	    onEntering: (0, _createChainedFunction.default)(handleEntering, TransitionProps.onEntering)
	  }), /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    elevation: elevation,
	    ref: handlePaperRef
	  }, PaperProps, {
	    className: (0, _clsx.default)(classes.paper, PaperProps.className)
	  }), children)));
	});
	 false ? Popover.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A ref for imperative actions.
	   * It currently only supports updatePosition() action.
	   */
	  action: _utils.refType,
	
	  /**
	   * This is the DOM element, or a function that returns the DOM element,
	   * that may be used to set the position of the popover.
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]), function (props) {
	    if (props.open && (!props.anchorReference || props.anchorReference === 'anchorEl')) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	      var containerWindow = (0, _ownerWindow.default)(resolvedAnchorEl);
	
	      if (resolvedAnchorEl instanceof containerWindow.Element) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else {
	        return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', "It should be an Element instance but it's `".concat(resolvedAnchorEl, "` instead.")].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * This is the point on the anchor where the popover's
	   * `anchorEl` will attach to. This is not used when the
	   * anchorReference is 'anchorPosition'.
	   *
	   * Options:
	   * vertical: [top, center, bottom];
	   * horizontal: [left, center, right].
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center', 'left', 'right']), _propTypes.default.number]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom', 'center', 'top']), _propTypes.default.number]).isRequired
	  }),
	
	  /**
	   * This is the position that may be used
	   * to set the position of the popover.
	   * The coordinates are relative to
	   * the application's client area.
	   */
	  anchorPosition: _propTypes.default.shape({
	    left: _propTypes.default.number.isRequired,
	    top: _propTypes.default.number.isRequired
	  }),
	
	  /**
	   * This determines which anchor prop to refer to to set
	   * the position of the popover.
	   */
	  anchorReference: _propTypes.default.oneOf(['anchorEl', 'anchorPosition', 'none']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will passed to the Modal component.
	   * By default, it uses the body of the anchorEl's top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(React.Component), _propTypes.default.instanceOf(typeof Element === 'undefined' ? Object : Element)]),
	
	  /**
	   * The elevation of the popover.
	   */
	  elevation: _propTypes.default.number,
	
	  /**
	   * This function is called in order to retrieve the content anchor element.
	   * It's the opposite of the `anchorEl` prop.
	   * The content anchor element should be an element inside the popover.
	   * It's used to correctly scroll and set the position of the popover.
	   * The positioning strategy tries to make the content anchor element just above the
	   * anchor element.
	   */
	  getContentAnchorEl: _propTypes.default.func,
	
	  /**
	   * Specifies how close to the edge of the window the popover can appear.
	   */
	  marginThreshold: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the component is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * If `true`, the popover is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Props applied to the [`Paper`](/api/paper/) element.
	   */
	  PaperProps: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .shape({
	    component: _utils.elementTypeAcceptingRef
	  }),
	
	  /**
	   * This is the point on the popover which
	   * will attach to the anchor's origin.
	   *
	   * Options:
	   * vertical: [top, center, bottom, x(px)];
	   * horizontal: [left, center, right, x(px)].
	   */
	  transformOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOfType([_propTypes.default.oneOf(['center', 'left', 'right']), _propTypes.default.number]).isRequired,
	    vertical: _propTypes.default.oneOfType([_propTypes.default.oneOf(['bottom', 'center', 'top']), _propTypes.default.number]).isRequired
	  }),
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiPopover'
	})(Popover);
	
	exports.default = _default;

/***/ },
/* 342 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _popper = _interopRequireDefault(__webpack_require__(542));
	
	var _utils = __webpack_require__(9);
	
	var _styles = __webpack_require__(20);
	
	var _Portal = _interopRequireDefault(__webpack_require__(84));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(54));
	
	var _setRef = _interopRequireDefault(__webpack_require__(38));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(56));
	
	function flipPlacement(placement, theme) {
	  var direction = theme && theme.direction || 'ltr';
	
	  if (direction === 'ltr') {
	    return placement;
	  }
	
	  switch (placement) {
	    case 'bottom-end':
	      return 'bottom-start';
	
	    case 'bottom-start':
	      return 'bottom-end';
	
	    case 'top-end':
	      return 'top-start';
	
	    case 'top-start':
	      return 'top-end';
	
	    default:
	      return placement;
	  }
	}
	
	function getAnchorEl(anchorEl) {
	  return typeof anchorEl === 'function' ? anchorEl() : anchorEl;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var defaultPopperOptions = {};
	/**
	 * Poppers rely on the 3rd party library [Popper.js](https://popper.js.org/docs/v1/) for positioning.
	 */
	
	var Popper = React.forwardRef(function Popper(props, ref) {
	  var anchorEl = props.anchorEl,
	      children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      _props$keepMounted = props.keepMounted,
	      keepMounted = _props$keepMounted === void 0 ? false : _props$keepMounted,
	      modifiers = props.modifiers,
	      open = props.open,
	      _props$placement = props.placement,
	      initialPlacement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      _props$popperOptions = props.popperOptions,
	      popperOptions = _props$popperOptions === void 0 ? defaultPopperOptions : _props$popperOptions,
	      popperRefProp = props.popperRef,
	      style = props.style,
	      _props$transition = props.transition,
	      transition = _props$transition === void 0 ? false : _props$transition,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorEl", "children", "container", "disablePortal", "keepMounted", "modifiers", "open", "placement", "popperOptions", "popperRef", "style", "transition"]);
	  var tooltipRef = React.useRef(null);
	  var ownRef = (0, _useForkRef.default)(tooltipRef, ref);
	  var popperRef = React.useRef(null);
	  var handlePopperRef = (0, _useForkRef.default)(popperRef, popperRefProp);
	  var handlePopperRefRef = React.useRef(handlePopperRef);
	  useEnhancedEffect(function () {
	    handlePopperRefRef.current = handlePopperRef;
	  }, [handlePopperRef]);
	  React.useImperativeHandle(popperRefProp, function () {
	    return popperRef.current;
	  }, []);
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var theme = (0, _styles.useTheme)();
	  var rtlPlacement = flipPlacement(initialPlacement, theme);
	  /**
	   * placement initialized from prop but can change during lifetime if modifiers.flip.
	   * modifiers.flip is essentially a flip for controlled/uncontrolled behavior
	   */
	
	  var _React$useState2 = React.useState(rtlPlacement),
	      placement = _React$useState2[0],
	      setPlacement = _React$useState2[1];
	
	  React.useEffect(function () {
	    if (popperRef.current) {
	      popperRef.current.update();
	    }
	  });
	  var handleOpen = React.useCallback(function () {
	    if (!tooltipRef.current || !anchorEl || !open) {
	      return;
	    }
	
	    if (popperRef.current) {
	      popperRef.current.destroy();
	      handlePopperRefRef.current(null);
	    }
	
	    var handlePopperUpdate = function handlePopperUpdate(data) {
	      setPlacement(data.placement);
	    };
	
	    var resolvedAnchorEl = getAnchorEl(anchorEl);
	
	    if (false) {
	      var containerWindow = (0, _ownerWindow.default)(resolvedAnchorEl);
	
	      if (resolvedAnchorEl instanceof containerWindow.Element) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          console.warn(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      }
	    }
	
	    var popper = new _popper.default(getAnchorEl(anchorEl), tooltipRef.current, (0, _extends2.default)({
	      placement: rtlPlacement
	    }, popperOptions, {
	      modifiers: (0, _extends2.default)({}, disablePortal ? {} : {
	        // It's using scrollParent by default, we can use the viewport when using a portal.
	        preventOverflow: {
	          boundariesElement: 'window'
	        }
	      }, {}, modifiers, {}, popperOptions.modifiers),
	      // We could have been using a custom modifier like react-popper is doing.
	      // But it seems this is the best public API for this use case.
	      onCreate: (0, _createChainedFunction.default)(handlePopperUpdate, popperOptions.onCreate),
	      onUpdate: (0, _createChainedFunction.default)(handlePopperUpdate, popperOptions.onUpdate)
	    }));
	    handlePopperRefRef.current(popper);
	  }, [anchorEl, disablePortal, modifiers, open, rtlPlacement, popperOptions]);
	  var handleRef = React.useCallback(function (node) {
	    (0, _setRef.default)(ownRef, node);
	    handleOpen();
	  }, [ownRef, handleOpen]);
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  var handleClose = function handleClose() {
	    if (!popperRef.current) {
	      return;
	    }
	
	    popperRef.current.destroy();
	    handlePopperRefRef.current(null);
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	    handleClose();
	  };
	
	  React.useEffect(function () {
	    // Let's update the popper position.
	    handleOpen();
	  }, [handleOpen]);
	  React.useEffect(function () {
	    return function () {
	      handleClose();
	    };
	  }, []);
	  React.useEffect(function () {
	    if (!open && !transition) {
	      // Otherwise handleExited will call this.
	      handleClose();
	    }
	  }, [open, transition]);
	
	  if (!keepMounted && !open && (!transition || exited)) {
	    return null;
	  }
	
	  var childProps = {
	    placement: placement
	  };
	
	  if (transition) {
	    childProps.TransitionProps = {
	      in: open,
	      onEnter: handleEnter,
	      onExited: handleExited
	    };
	  }
	
	  return /*#__PURE__*/React.createElement(_Portal.default, {
	    disablePortal: disablePortal,
	    container: container
	  }, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: handleRef,
	    role: "tooltip"
	  }, other, {
	    style: (0, _extends2.default)({
	      // Prevents scroll issue, waiting for Popper.js to add this style once initiated.
	      position: 'fixed',
	      // Fix Popper.js display issue
	      top: 0,
	      left: 0
	    }, style)
	  }), typeof children === 'function' ? children(childProps) : children));
	});
	 false ? Popper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This is the reference element, or a function that returns the reference element,
	   * that may be used to set the position of the popover.
	   * The return value will passed as the reference object of the Popper
	   * instance.
	   *
	   * The reference element should be an HTML Element instance or a [referenceObject](https://popper.js.org/docs/v1/#referenceObject).
	   */
	  anchorEl: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]), function (props) {
	    if (props.open) {
	      var resolvedAnchorEl = getAnchorEl(props.anchorEl);
	      var containerWindow = (0, _ownerWindow.default)(resolvedAnchorEl);
	
	      if (resolvedAnchorEl instanceof containerWindow.Element) {
	        var box = resolvedAnchorEl.getBoundingClientRect();
	
	        if (process.env.NODE_ENV !== 'test' && box.top === 0 && box.left === 0 && box.right === 0 && box.bottom === 0) {
	          return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'The anchor element should be part of the document layout.', "Make sure the element is present in the document or that it's not display none."].join('\n'));
	        }
	      } else if (!resolvedAnchorEl || typeof resolvedAnchorEl.clientWidth !== 'number' || typeof resolvedAnchorEl.clientHeight !== 'number' || typeof resolvedAnchorEl.getBoundingClientRect !== 'function') {
	        return new Error(['Material-UI: the `anchorEl` prop provided to the component is invalid.', 'It should be an HTML Element instance or a referenceObject ', '(https://popper.js.org/docs/v1/#referenceObject).'].join('\n'));
	      }
	    }
	
	    return null;
	  }),
	
	  /**
	   * Popper render function or node.
	   */
	  children: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_propTypes.default.node, _propTypes.default.func]).isRequired,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will passed to the Modal component.
	   * By default, it uses the body of the anchorEl's top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(React.Component), _propTypes.default.instanceOf(typeof Element === 'undefined' ? Object : Element)]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Always keep the children in the DOM.
	   * This prop can be useful in SEO situation or
	   * when you want to maximize the responsiveness of the Popper.
	   */
	  keepMounted: _propTypes.default.bool,
	
	  /**
	   * Popper.js is based on a "plugin-like" architecture,
	   * most of its features are fully encapsulated "modifiers".
	   *
	   * A modifier is a function that is called each time Popper.js needs to
	   * compute the position of the popper.
	   * For this reason, modifiers should be very performant to avoid bottlenecks.
	   * To learn how to create a modifier, [read the modifiers documentation](https://popper.js.org/docs/v1/#modifiers).
	   */
	  modifiers: _propTypes.default.object,
	
	  /**
	   * If `true`, the popper is visible.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * Popper placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * Options provided to the [`popper.js`](https://popper.js.org/docs/v1/) instance.
	   */
	  popperOptions: _propTypes.default.object,
	
	  /**
	   * A ref that points to the used popper instance.
	   */
	  popperRef: _utils.refType,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * Help supporting a react-transition-group/Transition component.
	   */
	  transition: _propTypes.default.bool
	} : void 0;
	var _default = Popper;
	exports.default = _default;

/***/ },
/* 343 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(9);
	
	var _setRef = _interopRequireDefault(__webpack_require__(38));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	function getContainer(container) {
	  container = typeof container === 'function' ? container() : container; // #StrictMode ready
	
	  return ReactDOM.findDOMNode(container);
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	/**
	 * Portals provide a first-class way to render children into a DOM node
	 * that exists outside the DOM hierarchy of the parent component.
	 */
	
	var Portal = React.forwardRef(function Portal(props, ref) {
	  var children = props.children,
	      container = props.container,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      onRendered = props.onRendered;
	
	  var _React$useState = React.useState(null),
	      mountNode = _React$useState[0],
	      setMountNode = _React$useState[1];
	
	  var handleRef = (0, _useForkRef.default)(React.isValidElement(children) ? children.ref : null, ref);
	  useEnhancedEffect(function () {
	    if (!disablePortal) {
	      setMountNode(getContainer(container) || document.body);
	    }
	  }, [container, disablePortal]);
	  useEnhancedEffect(function () {
	    if (mountNode && !disablePortal) {
	      (0, _setRef.default)(ref, mountNode);
	      return function () {
	        (0, _setRef.default)(ref, null);
	      };
	    }
	
	    return undefined;
	  }, [ref, mountNode, disablePortal]);
	  useEnhancedEffect(function () {
	    if (onRendered && (mountNode || disablePortal)) {
	      onRendered();
	    }
	  }, [onRendered, mountNode, disablePortal]);
	
	  if (disablePortal) {
	    if (React.isValidElement(children)) {
	      return React.cloneElement(children, {
	        ref: handleRef
	      });
	    }
	
	    return children;
	  }
	
	  return mountNode ? ReactDOM.createPortal(children, mountNode) : mountNode;
	});
	 false ? Portal.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The children to render into the `container`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * A node, component instance, or function that returns either.
	   * The `container` will have the portal children appended to it.
	   * By default, it uses the body of the top-level document object,
	   * so it's simply `document.body` most of the time.
	   */
	  container: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .oneOfType([_propTypes.default.func, _propTypes.default.instanceOf(React.Component), _propTypes.default.instanceOf(typeof Element === 'undefined' ? Object : Element)]),
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * Callback fired once the children has been mounted into the `container`.
	   *
	   * This prop will be deprecated and removed in v5, the ref can be used instead.
	   */
	  onRendered: _propTypes.default.func
	} : void 0;
	
	if (false) {
	  // eslint-disable-next-line
	  Portal['propTypes' + ''] = (0, _utils.exactProp)(Portal.propTypes);
	}
	
	var _default = Portal;
	exports.default = _default;

/***/ },
/* 344 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(88));
	
	var _RadioButtonIcon = _interopRequireDefault(__webpack_require__(345));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(54));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _useRadioGroup = _interopRequireDefault(__webpack_require__(133));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Pseudo-class applied to the root element if `checked={true}`. */
	    checked: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          // Reset on touch devices, it doesn't add specificity
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.action.disabled
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultCheckedIcon = /*#__PURE__*/React.createElement(_RadioButtonIcon.default, {
	  checked: true
	});
	var defaultIcon = /*#__PURE__*/React.createElement(_RadioButtonIcon.default, null);
	var Radio = React.forwardRef(function Radio(props, ref) {
	  var checkedProp = props.checked,
	      classes = props.classes,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      nameProp = props.name,
	      onChangeProp = props.onChange,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["checked", "classes", "color", "name", "onChange", "size"]);
	  var radioGroup = (0, _useRadioGroup.default)();
	  var checked = checkedProp;
	  var onChange = (0, _createChainedFunction.default)(onChangeProp, radioGroup && radioGroup.onChange);
	  var name = nameProp;
	
	  if (radioGroup) {
	    if (typeof checked === 'undefined') {
	      checked = radioGroup.value === props.value;
	    }
	
	    if (typeof name === 'undefined') {
	      name = radioGroup.name;
	    }
	  }
	
	  return /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    color: color,
	    type: "radio",
	    icon: React.cloneElement(defaultIcon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    checkedIcon: React.cloneElement(defaultCheckedIcon, {
	      fontSize: size === 'small' ? 'small' : 'default'
	    }),
	    classes: {
	      root: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))]),
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    name: name,
	    checked: checked,
	    onChange: onChange,
	    ref: ref
	  }, other));
	});
	 false ? Radio.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * If `true`, the radio will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the radio.
	   * `small` is equivalent to the dense radio styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiRadio'
	})(Radio);
	
	exports.default = _default;

/***/ },
/* 345 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _RadioButtonUnchecked = _interopRequireDefault(__webpack_require__(428));
	
	var _RadioButtonChecked = _interopRequireDefault(__webpack_require__(427));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'relative',
	      display: 'flex',
	      '&$checked $layer': {
	        transform: 'scale(1)',
	        transition: theme.transitions.create('transform', {
	          easing: theme.transitions.easing.easeOut,
	          duration: theme.transitions.duration.shortest
	        })
	      }
	    },
	    layer: {
	      left: 0,
	      position: 'absolute',
	      transform: 'scale(0)',
	      transition: theme.transitions.create('transform', {
	        easing: theme.transitions.easing.easeIn,
	        duration: theme.transitions.duration.shortest
	      })
	    },
	    checked: {}
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	
	function RadioButtonIcon(props) {
	  var checked = props.checked,
	      classes = props.classes,
	      fontSize = props.fontSize;
	  return /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.root, checked && classes.checked)
	  }, /*#__PURE__*/React.createElement(_RadioButtonUnchecked.default, {
	    fontSize: fontSize
	  }), /*#__PURE__*/React.createElement(_RadioButtonChecked.default, {
	    fontSize: fontSize,
	    className: classes.layer
	  }));
	}
	
	 false ? RadioButtonIcon.propTypes = {
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The size of the radio.
	   * `small` is equivalent to the dense radio styling.
	   */
	  fontSize: _propTypes.default.oneOf(['small', 'default'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateRadioButtonIcon'
	})(RadioButtonIcon);
	
	exports.default = _default;

/***/ },
/* 346 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Radio.default;
	  }
	});
	
	var _Radio = _interopRequireDefault(__webpack_require__(344));

/***/ },
/* 347 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(32));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _FormGroup = _interopRequireDefault(__webpack_require__(117));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(39));
	
	var _RadioGroupContext = _interopRequireDefault(__webpack_require__(132));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(89));
	
	var RadioGroup = React.forwardRef(function RadioGroup(props, ref) {
	  var actions = props.actions,
	      children = props.children,
	      nameProp = props.name,
	      valueProp = props.value,
	      onChange = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["actions", "children", "name", "value", "onChange"]);
	  var rootRef = React.useRef(null);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: props.defaultValue,
	    name: 'RadioGroup'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  React.useImperativeHandle(actions, function () {
	    return {
	      focus: function focus() {
	        var input = rootRef.current.querySelector('input:not(:disabled):checked');
	
	        if (!input) {
	          input = rootRef.current.querySelector('input:not(:disabled)');
	        }
	
	        if (input) {
	          input.focus();
	        }
	      }
	    };
	  }, []);
	  var handleRef = (0, _useForkRef.default)(ref, rootRef);
	
	  var handleChange = function handleChange(event) {
	    setValue(event.target.value);
	
	    if (onChange) {
	      onChange(event, event.target.value);
	    }
	  };
	
	  var name = (0, _unstable_useId.default)(nameProp);
	  return /*#__PURE__*/React.createElement(_RadioGroupContext.default.Provider, {
	    value: {
	      name: name,
	      onChange: handleChange,
	      value: value
	    }
	  }, /*#__PURE__*/React.createElement(_FormGroup.default, (0, _extends2.default)({
	    role: "radiogroup",
	    ref: handleRef
	  }, other), children));
	});
	 false ? RadioGroup.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * The default `input` element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * The name used to reference the value of the control.
	   * If you don't provide this prop, it falls back to a randomly generated name.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback fired when a radio button is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Value of the selected radio button. The DOM API casts this to a string.
	   */
	  value: _propTypes.default.any
	} : void 0;
	var _default = RadioGroup;
	exports.default = _default;

/***/ },
/* 348 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RadioGroup.default;
	  }
	});
	Object.defineProperty(exports, "useRadioGroup", {
	  enumerable: true,
	  get: function get() {
	    return _useRadioGroup.default;
	  }
	});
	
	var _RadioGroup = _interopRequireDefault(__webpack_require__(347));
	
	var _useRadioGroup = _interopRequireDefault(__webpack_require__(133));

/***/ },
/* 349 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(73));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(60));
	
	var _possibleConstructorReturn2 = _interopRequireDefault(__webpack_require__(196));
	
	var _getPrototypeOf2 = _interopRequireDefault(__webpack_require__(192));
	
	var _inherits2 = _interopRequireDefault(__webpack_require__(193));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(9);
	
	var _setRef = _interopRequireDefault(__webpack_require__(38));
	
	function _createSuper(Derived) { return function () { var Super = (0, _getPrototypeOf2.default)(Derived), result; if (_isNativeReflectConstruct()) { var NewTarget = (0, _getPrototypeOf2.default)(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2.default)(this, result); }; }
	
	function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call(Reflect.construct(Date, [], function () {})); return true; } catch (e) { return false; } }
	
	/**
	 * ⚠️⚠️⚠️
	 * If you want the DOM element of a Material-UI component check out
	 * [FAQ: How can I access the DOM element?](/getting-started/faq/#how-can-i-access-the-dom-element)
	 * first.
	 *
	 * This component uses `findDOMNode` which is deprecated in React.StrictMode.
	 *
	 * Helper component to allow attaching a ref to a
	 * wrapped element to access the underlying DOM element.
	 *
	 * It's highly inspired by https://github.com/facebook/react/issues/11401#issuecomment-340543801.
	 * For example:
	 * ```jsx
	 * import React from 'react';
	 * import RootRef from '@material-ui/core/RootRef';
	 *
	 * function MyComponent() {
	 *   const domRef = React.useRef();
	 *
	 *   React.useEffect(() => {
	 *     console.log(domRef.current); // DOM node
	 *   }, []);
	 *
	 *   return (
	 *     <RootRef rootRef={domRef}>
	 *       <SomeChildComponent />
	 *     </RootRef>
	 *   );
	 * }
	 * ```
	 */
	var RootRef = /*#__PURE__*/function (_React$Component) {
	  (0, _inherits2.default)(RootRef, _React$Component);
	
	  var _super = _createSuper(RootRef);
	
	  function RootRef() {
	    (0, _classCallCheck2.default)(this, RootRef);
	    return _super.apply(this, arguments);
	  }
	
	  (0, _createClass2.default)(RootRef, [{
	    key: "componentDidMount",
	    value: function componentDidMount() {
	      this.ref = ReactDOM.findDOMNode(this);
	      (0, _setRef.default)(this.props.rootRef, this.ref);
	    }
	  }, {
	    key: "componentDidUpdate",
	    value: function componentDidUpdate(prevProps) {
	      var ref = ReactDOM.findDOMNode(this);
	
	      if (prevProps.rootRef !== this.props.rootRef || this.ref !== ref) {
	        if (prevProps.rootRef !== this.props.rootRef) {
	          (0, _setRef.default)(prevProps.rootRef, null);
	        }
	
	        this.ref = ref;
	        (0, _setRef.default)(this.props.rootRef, this.ref);
	      }
	    }
	  }, {
	    key: "componentWillUnmount",
	    value: function componentWillUnmount() {
	      this.ref = null;
	      (0, _setRef.default)(this.props.rootRef, null);
	    }
	  }, {
	    key: "render",
	    value: function render() {
	      return this.props.children;
	    }
	  }]);
	  return RootRef;
	}(React.Component);
	
	 false ? RootRef.propTypes = {
	  /**
	   * The wrapped element.
	   */
	  children: _propTypes.default.element.isRequired,
	
	  /**
	   * A ref that points to the first DOM node of the wrapped element.
	   */
	  rootRef: _utils.refType.isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? RootRef.propTypes = (0, _utils.exactProp)(RootRef.propTypes) : void 0;
	}
	
	var _default = RootRef;
	exports.default = _default;

/***/ },
/* 350 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _RootRef.default;
	  }
	});
	
	var _RootRef = _interopRequireDefault(__webpack_require__(349));

/***/ },
/* 351 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _styles = __webpack_require__(20);
	
	var _SelectInput = _interopRequireDefault(__webpack_require__(352));
	
	var _formControlState = _interopRequireDefault(__webpack_require__(43));
	
	var _useFormControl = _interopRequireDefault(__webpack_require__(36));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(156));
	
	var _Input = _interopRequireDefault(__webpack_require__(64));
	
	var _NativeSelect = __webpack_require__(129);
	
	var _NativeSelectInput = _interopRequireDefault(__webpack_require__(130));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(78));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(81));
	
	var styles = _NativeSelect.styles;
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement(_Input.default, null);
	
	var _ref2 = /*#__PURE__*/React.createElement(_FilledInput.default, null);
	
	var Select = React.forwardRef(function Select(props, ref) {
	  var _props$autoWidth = props.autoWidth,
	      autoWidth = _props$autoWidth === void 0 ? false : _props$autoWidth,
	      children = props.children,
	      classes = props.classes,
	      _props$displayEmpty = props.displayEmpty,
	      displayEmpty = _props$displayEmpty === void 0 ? false : _props$displayEmpty,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDropDown.default : _props$IconComponent,
	      id = props.id,
	      input = props.input,
	      inputProps = props.inputProps,
	      label = props.label,
	      labelId = props.labelId,
	      _props$labelWidth = props.labelWidth,
	      labelWidth = _props$labelWidth === void 0 ? 0 : _props$labelWidth,
	      MenuProps = props.MenuProps,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      _props$native = props.native,
	      native = _props$native === void 0 ? false : _props$native,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      renderValue = props.renderValue,
	      SelectDisplayProps = props.SelectDisplayProps,
	      _props$variant = props.variant,
	      variantProps = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoWidth", "children", "classes", "displayEmpty", "IconComponent", "id", "input", "inputProps", "label", "labelId", "labelWidth", "MenuProps", "multiple", "native", "onClose", "onOpen", "open", "renderValue", "SelectDisplayProps", "variant"]);
	  var inputComponent = native ? _NativeSelectInput.default : _SelectInput.default;
	  var muiFormControl = (0, _useFormControl.default)();
	  var fcs = (0, _formControlState.default)({
	    props: props,
	    muiFormControl: muiFormControl,
	    states: ['variant']
	  });
	  var variant = fcs.variant || variantProps;
	  var InputComponent = input || {
	    standard: _ref,
	    outlined: /*#__PURE__*/React.createElement(_OutlinedInput.default, {
	      label: label,
	      labelWidth: labelWidth
	    }),
	    filled: _ref2
	  }[variant];
	  return React.cloneElement(InputComponent, (0, _extends2.default)({
	    // Most of the logic is implemented in `SelectInput`.
	    // The `Select` component is a simple API wrapper to expose something better to play with.
	    inputComponent: inputComponent,
	    inputProps: (0, _extends2.default)({
	      children: children,
	      IconComponent: IconComponent,
	      variant: variant,
	      type: undefined,
	      // We render a select. We can ignore the type provided by the `Input`.
	      multiple: multiple
	    }, native ? {
	      id: id
	    } : {
	      autoWidth: autoWidth,
	      displayEmpty: displayEmpty,
	      labelId: labelId,
	      MenuProps: MenuProps,
	      onClose: onClose,
	      onOpen: onOpen,
	      open: open,
	      renderValue: renderValue,
	      SelectDisplayProps: (0, _extends2.default)({
	        id: id
	      }, SelectDisplayProps)
	    }, {}, inputProps, {
	      classes: inputProps ? (0, _styles.mergeClasses)({
	        baseClasses: classes,
	        newClasses: inputProps.classes,
	        Component: Select
	      }) : classes
	    }, input ? input.props.inputProps : {}),
	    ref: ref
	  }, other));
	});
	 false ? Select.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `MenuItem` when `native` is false and `option` when `native` is true.
	   *
	   * ⚠️The `MenuItem` elements **must** be direct descendants when `native` is false.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, a value is displayed even if no items are selected.
	   *
	   * In order to display a meaningful value, a function should be passed to the `renderValue` prop which returns the value to be displayed when no items are selected.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType,
	
	  /**
	   * The `id` of the wrapper element or the `select` elment when `native`.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * An `Input` element; does not have to be a material-ui specific `Input`.
	   */
	  input: _propTypes.default.element,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   * When `native` is `true`, the attributes are applied on the `select` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * See [OutlinedInput#label](/api/outlined-input/#props)
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * The ID of an element that acts as an additional label. The Select will
	   * be labelled by the additional label and the selected value.
	   */
	  labelId: _propTypes.default.string,
	
	  /**
	   * See [OutlinedInput#label](/api/outlined-input/#props)
	   */
	  labelWidth: _propTypes.default.number,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the component will be using a native `select` element.
	   */
	  native: _propTypes.default.bool,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected when `native` is `false` (default).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   * You can only use it when the `native` prop is `false` (default).
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   * You can only use it when the `native` prop is `false` (default).
	   *
	   * @param {any} value The `value` provided to the component.
	   * @returns {ReactNode}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * The input value. Providing an empty string will select no options.
	   * This prop is required when the `native` prop is `false` (default).
	   * Set to an empty string `''` if you don't want any of the available options to be selected.
	   *
	   * If the value is an object it must have reference equality with the option in order to be selected.
	   * If the value is not an object, the string representation must match with the string representation of the option in order to be selected.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	Select.muiName = 'Select';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSelect'
	})(Select);
	
	exports.default = _default;

/***/ },
/* 352 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(32));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(33));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(18);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _utils = __webpack_require__(9);
	
	var _Menu = _interopRequireDefault(__webpack_require__(125));
	
	var _utils2 = __webpack_require__(80);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(39));
	
	function areEqualValues(a, b) {
	  if ((0, _typeof2.default)(b) === 'object' && b !== null) {
	    return a === b;
	  }
	
	  return String(a) === String(b);
	}
	
	function isEmpty(display) {
	  return display == null || typeof display === 'string' && !display.trim();
	}
	/**
	 * @ignore - internal component.
	 */
	
	
	var SelectInput = React.forwardRef(function SelectInput(props, ref) {
	  var ariaLabel = props['aria-label'],
	      autoFocus = props.autoFocus,
	      autoWidth = props.autoWidth,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      defaultValue = props.defaultValue,
	      disabled = props.disabled,
	      displayEmpty = props.displayEmpty,
	      IconComponent = props.IconComponent,
	      inputRefProp = props.inputRef,
	      labelId = props.labelId,
	      _props$MenuProps = props.MenuProps,
	      MenuProps = _props$MenuProps === void 0 ? {} : _props$MenuProps,
	      multiple = props.multiple,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onFocus = props.onFocus,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      readOnly = props.readOnly,
	      renderValue = props.renderValue,
	      required = props.required,
	      _props$SelectDisplayP = props.SelectDisplayProps,
	      SelectDisplayProps = _props$SelectDisplayP === void 0 ? {} : _props$SelectDisplayP,
	      tabIndexProp = props.tabIndex,
	      type = props.type,
	      valueProp = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "autoFocus", "autoWidth", "children", "classes", "className", "defaultValue", "disabled", "displayEmpty", "IconComponent", "inputRef", "labelId", "MenuProps", "multiple", "name", "onBlur", "onChange", "onClose", "onFocus", "onOpen", "open", "readOnly", "renderValue", "required", "SelectDisplayProps", "tabIndex", "type", "value", "variant"]);
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: 'SelectInput'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  var inputRef = React.useRef(null);
	
	  var _React$useState = React.useState(null),
	      displayNode = _React$useState[0],
	      setDisplayNode = _React$useState[1];
	
	  var _React$useRef = React.useRef(openProp != null),
	      isOpenControlled = _React$useRef.current;
	
	  var _React$useState2 = React.useState(),
	      menuMinWidthState = _React$useState2[0],
	      setMenuMinWidthState = _React$useState2[1];
	
	  var _React$useState3 = React.useState(false),
	      openState = _React$useState3[0],
	      setOpenState = _React$useState3[1];
	
	  var handleRef = (0, _useForkRef.default)(ref, inputRefProp);
	  React.useImperativeHandle(handleRef, function () {
	    return {
	      focus: function focus() {
	        displayNode.focus();
	      },
	      node: inputRef.current,
	      value: value
	    };
	  }, [displayNode, value]);
	  React.useEffect(function () {
	    if (autoFocus && displayNode) {
	      displayNode.focus();
	    }
	  }, [autoFocus, displayNode]);
	
	  var update = function update(open, event) {
	    if (open) {
	      if (onOpen) {
	        onOpen(event);
	      }
	    } else if (onClose) {
	      onClose(event);
	    }
	
	    if (!isOpenControlled) {
	      setMenuMinWidthState(autoWidth ? null : displayNode.clientWidth);
	      setOpenState(open);
	    }
	  };
	
	  var handleMouseDown = function handleMouseDown(event) {
	    // Ignore everything but left-click
	    if (event.button !== 0) {
	      return;
	    } // Hijack the default focus behavior.
	
	
	    event.preventDefault();
	    displayNode.focus();
	    update(true, event);
	  };
	
	  var handleClose = function handleClose(event) {
	    update(false, event);
	  };
	
	  var handleItemClick = function handleItemClick(child) {
	    return function (event) {
	      if (!multiple) {
	        update(false, event);
	      }
	
	      var newValue;
	
	      if (multiple) {
	        newValue = Array.isArray(value) ? (0, _toConsumableArray2.default)(value) : [];
	        var itemIndex = value.indexOf(child.props.value);
	
	        if (itemIndex === -1) {
	          newValue.push(child.props.value);
	        } else {
	          newValue.splice(itemIndex, 1);
	        }
	      } else {
	        newValue = child.props.value;
	      }
	
	      if (value === newValue) {
	        return;
	      }
	
	      setValue(newValue);
	
	      if (onChange) {
	        event.persist(); // Preact support, target is read only property on a native event.
	
	        Object.defineProperty(event, 'target', {
	          writable: true,
	          value: {
	            value: newValue,
	            name: name
	          }
	        });
	        onChange(event, child);
	      }
	    };
	  };
	
	  var handleKeyDown = function handleKeyDown(event) {
	    if (!readOnly) {
	      var validKeys = [' ', 'ArrowUp', 'ArrowDown', // The native select doesn't respond to enter on MacOS, but it's recommended by
	      // https://www.w3.org/TR/wai-aria-practices/examples/listbox/listbox-collapsible.html
	      'Enter'];
	
	      if (validKeys.indexOf(event.key) !== -1) {
	        event.preventDefault();
	        update(true, event);
	      }
	    }
	  };
	
	  var open = displayNode !== null && (isOpenControlled ? openProp : openState);
	
	  var handleBlur = function handleBlur(event) {
	    // if open event.stopImmediatePropagation
	    if (!open && onBlur) {
	      event.persist(); // Preact support, target is read only property on a native event.
	
	      Object.defineProperty(event, 'target', {
	        writable: true,
	        value: {
	          value: value,
	          name: name
	        }
	      });
	      onBlur(event);
	    }
	  };
	
	  delete other['aria-invalid'];
	  var display;
	  var displaySingle;
	  var displayMultiple = [];
	  var computeDisplay = false;
	  var foundMatch = false; // No need to display any value if the field is empty.
	
	  if ((0, _utils2.isFilled)({
	    value: value
	  }) || displayEmpty) {
	    if (renderValue) {
	      display = renderValue(value);
	    } else {
	      computeDisplay = true;
	    }
	  }
	
	  var items = React.Children.map(children, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Select component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var selected;
	
	    if (multiple) {
	      if (!Array.isArray(value)) {
	        throw new Error('Material-UI: the `value` prop must be an array ' + 'when using the `Select` component with `multiple`.');
	      }
	
	      selected = value.some(function (v) {
	        return areEqualValues(v, child.props.value);
	      });
	
	      if (selected && computeDisplay) {
	        displayMultiple.push(child.props.children);
	      }
	    } else {
	      selected = areEqualValues(value, child.props.value);
	
	      if (selected && computeDisplay) {
	        displaySingle = child.props.children;
	      }
	    }
	
	    if (selected) {
	      foundMatch = true;
	    }
	
	    return React.cloneElement(child, {
	      'aria-selected': selected ? 'true' : undefined,
	      onClick: handleItemClick(child),
	      onKeyUp: function onKeyUp(event) {
	        if (event.key === ' ') {
	          // otherwise our MenuItems dispatches a click event
	          // it's not behavior of the native <option> and causes
	          // the select to close immediately since we open on space keydown
	          event.preventDefault();
	        }
	
	        var onKeyUp = child.props.onKeyUp;
	
	        if (typeof onKeyUp === 'function') {
	          onKeyUp(event);
	        }
	      },
	      role: 'option',
	      selected: selected,
	      value: undefined,
	      // The value is most likely not a valid HTML attribute.
	      'data-value': child.props.value // Instead, we provide it as a data attribute.
	
	    });
	  });
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useEffect(function () {
	      if (!foundMatch && !multiple && value !== '') {
	        var values = React.Children.toArray(children).map(function (child) {
	          return child.props.value;
	        });
	        console.warn(["Material-UI: you have provided an out-of-range value `".concat(value, "` for the select ").concat(name ? "(name=\"".concat(name, "\") ") : '', "component."), "Consider providing a value that matches one of the available options or ''.", "The available values are ".concat(values.filter(function (x) {
	          return x != null;
	        }).map(function (x) {
	          return "`".concat(x, "`");
	        }).join(', ') || '""', ".")].join('\n'));
	      }
	    }, [foundMatch, children, multiple, name, value]);
	  }
	
	  if (computeDisplay) {
	    display = multiple ? displayMultiple.join(', ') : displaySingle;
	  } // Avoid performing a layout computation in the render method.
	
	
	  var menuMinWidth = menuMinWidthState;
	
	  if (!autoWidth && isOpenControlled && displayNode) {
	    menuMinWidth = displayNode.clientWidth;
	  }
	
	  var tabIndex;
	
	  if (typeof tabIndexProp !== 'undefined') {
	    tabIndex = tabIndexProp;
	  } else {
	    tabIndex = disabled ? null : 0;
	  }
	
	  var buttonId = SelectDisplayProps.id || (name ? "mui-component-select-".concat(name) : undefined);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, // TODO v5: merge root and select
	    classes.select, classes.selectMenu, classes[variant], className, disabled && classes.disabled),
	    ref: setDisplayNode,
	    tabIndex: tabIndex,
	    role: "button",
	    "aria-disabled": disabled ? 'true' : undefined,
	    "aria-expanded": open ? 'true' : undefined,
	    "aria-haspopup": "listbox",
	    "aria-label": ariaLabel,
	    "aria-labelledby": [labelId, buttonId].filter(Boolean).join(' ') || undefined,
	    onKeyDown: handleKeyDown,
	    onMouseDown: disabled || readOnly ? null : handleMouseDown,
	    onBlur: handleBlur,
	    onFocus: onFocus
	  }, SelectDisplayProps, {
	    // The id is required for proper a11y
	    id: buttonId
	  }), isEmpty(display) ?
	  /*#__PURE__*/
	  // eslint-disable-next-line react/no-danger
	  React.createElement("span", {
	    dangerouslySetInnerHTML: {
	      __html: '&#8203;'
	    }
	  }) : display), /*#__PURE__*/React.createElement("input", (0, _extends2.default)({
	    value: Array.isArray(value) ? value.join(',') : value,
	    name: name,
	    ref: inputRef,
	    type: "hidden",
	    autoFocus: autoFocus
	  }, other)), /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["icon".concat((0, _capitalize.default)(variant))], open && classes.iconOpen, disabled && classes.disabled)
	  }), /*#__PURE__*/React.createElement(_Menu.default, (0, _extends2.default)({
	    id: "menu-".concat(name || ''),
	    anchorEl: displayNode,
	    open: open,
	    onClose: handleClose
	  }, MenuProps, {
	    MenuListProps: (0, _extends2.default)({
	      'aria-labelledby': labelId,
	      role: 'listbox',
	      disableListWrap: true
	    }, MenuProps.MenuListProps),
	    PaperProps: (0, _extends2.default)({}, MenuProps.PaperProps, {
	      style: (0, _extends2.default)({
	        minWidth: menuMinWidth
	      }, MenuProps.PaperProps != null ? MenuProps.PaperProps.style : null)
	    })
	  }), items));
	});
	 false ? SelectInput.propTypes = {
	  /**
	   * @ignore
	   */
	  'aria-label': _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * If `true`, the width of the popover will automatically be set according to the items inside the
	   * menu, otherwise it will be at least the width of the select input.
	   */
	  autoWidth: _propTypes.default.bool,
	
	  /**
	   * The option elements to populate the select with.
	   * Can be some `<MenuItem>` elements.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * The CSS class name of the select element.
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the select will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected item is displayed even if its value is empty.
	   */
	  displayEmpty: _propTypes.default.bool,
	
	  /**
	   * The icon that displays the arrow.
	   */
	  IconComponent: _propTypes.default.elementType.isRequired,
	
	  /**
	   * Imperative handle implementing `{ value: T, node: HTMLElement, focus(): void }`
	   * Equivalent to `ref`
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The ID of an element that acts as an additional label. The Select will
	   * be labelled by the additional label and the selected value.
	   */
	  labelId: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`Menu`](/api/menu/) element.
	   */
	  MenuProps: _propTypes.default.object,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `select` or hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback function fired when a menu item is selected.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (any).
	   * @param {object} [child] The react element that was selected.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control `select` open state.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  readOnly: _propTypes.default.bool,
	
	  /**
	   * Render the selected value.
	   *
	   * @param {any} value The `value` provided to the component.
	   * @returns {ReactNode}
	   */
	  renderValue: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Props applied to the clickable div element.
	   */
	  SelectDisplayProps: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  tabIndex: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  type: _propTypes.default.any,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'outlined', 'filled'])
	} : void 0;
	var _default = SelectInput;
	exports.default = _default;

/***/ },
/* 353 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.setTranslateValue = setTranslateValue;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _debounce = _interopRequireDefault(__webpack_require__(37));
	
	var _reactTransitionGroup = __webpack_require__(46);
	
	var _utils = __webpack_require__(9);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var _transitions = __webpack_require__(26);
	
	var _utils2 = __webpack_require__(44);
	
	// Translate the node so he can't be seen on the screen.
	// Later, we gonna translate back the node to his original location
	// with `none`.`
	function getTranslateValue(direction, node) {
	  var rect = node.getBoundingClientRect();
	  var transform;
	
	  if (node.fakeTransform) {
	    transform = node.fakeTransform;
	  } else {
	    var computedStyle = window.getComputedStyle(node);
	    transform = computedStyle.getPropertyValue('-webkit-transform') || computedStyle.getPropertyValue('transform');
	  }
	
	  var offsetX = 0;
	  var offsetY = 0;
	
	  if (transform && transform !== 'none' && typeof transform === 'string') {
	    var transformValues = transform.split('(')[1].split(')')[0].split(',');
	    offsetX = parseInt(transformValues[4], 10);
	    offsetY = parseInt(transformValues[5], 10);
	  }
	
	  if (direction === 'left') {
	    return "translateX(".concat(window.innerWidth, "px) translateX(-").concat(rect.left - offsetX, "px)");
	  }
	
	  if (direction === 'right') {
	    return "translateX(-".concat(rect.left + rect.width - offsetX, "px)");
	  }
	
	  if (direction === 'up') {
	    return "translateY(".concat(window.innerHeight, "px) translateY(-").concat(rect.top - offsetY, "px)");
	  } // direction === 'down'
	
	
	  return "translateY(-".concat(rect.top + rect.height - offsetY, "px)");
	}
	
	function setTranslateValue(direction, node) {
	  var transform = getTranslateValue(direction, node);
	
	  if (transform) {
	    node.style.webkitTransform = transform;
	    node.style.transform = transform;
	  }
	}
	
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Slide transition is used by the [Drawer](/components/drawers/) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Slide = React.forwardRef(function Slide(props, ref) {
	  var children = props.children,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'down' : _props$direction,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "direction", "in", "onEnter", "onEntering", "onExit", "onExited", "style", "timeout"]);
	  var theme = (0, _useTheme.default)();
	  var childrenRef = React.useRef(null);
	  /**
	   * used in cloneElement(children, { ref: handleRef })
	   */
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    childrenRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  var handleRefIntermediary = (0, _useForkRef.default)(children.ref, handleOwnRef);
	  var handleRef = (0, _useForkRef.default)(handleRefIntermediary, ref);
	
	  var handleEnter = function handleEnter(_, isAppearing) {
	    var node = childrenRef.current;
	    setTranslateValue(direction, node);
	    (0, _utils2.reflow)(node);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleEntering = function handleEntering(_, isAppearing) {
	    var node = childrenRef.current;
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.easeOut
	    }));
	    node.style.webkitTransform = 'none';
	    node.style.transform = 'none';
	
	    if (onEntering) {
	      onEntering(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit() {
	    var node = childrenRef.current;
	    var transitionProps = (0, _utils2.getTransitionProps)({
	      timeout: timeout,
	      style: style
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('-webkit-transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    node.style.transition = theme.transitions.create('transform', (0, _extends2.default)({}, transitionProps, {
	      easing: theme.transitions.easing.sharp
	    }));
	    setTranslateValue(direction, node);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  var handleExited = function handleExited() {
	    var node = childrenRef.current; // No need for transitions when the component is hidden
	
	    node.style.webkitTransition = '';
	    node.style.transition = '';
	
	    if (onExited) {
	      onExited(node);
	    }
	  };
	
	  var updatePosition = React.useCallback(function () {
	    if (childrenRef.current) {
	      setTranslateValue(direction, childrenRef.current);
	    }
	  }, [direction]);
	  React.useEffect(function () {
	    // Skip configuration where the position is screen size invariant.
	    if (inProp || direction === 'down' || direction === 'right') {
	      return undefined;
	    }
	
	    var handleResize = (0, _debounce.default)(function () {
	      if (childrenRef.current) {
	        setTranslateValue(direction, childrenRef.current);
	      }
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [direction, inProp]);
	  React.useEffect(function () {
	    if (!inProp) {
	      // We need to update the position of the drawer when the direction change and
	      // when it's hidden.
	      updatePosition();
	    }
	  }, [inProp, updatePosition]);
	  return /*#__PURE__*/React.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    onEnter: handleEnter,
	    onEntering: handleEntering,
	    onExit: handleExit,
	    onExited: handleExited,
	    appear: true,
	    in: inProp,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return React.cloneElement(children, (0, _extends2.default)({
	      ref: handleRef,
	      style: (0, _extends2.default)({
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, style, {}, children.props.style)
	    }, childProps));
	  });
	});
	 false ? Slide.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _utils.elementAcceptingRef,
	
	  /**
	   * Direction the child node will enter from.
	   */
	  direction: _propTypes.default.oneOf(['down', 'left', 'right', 'up']),
	
	  /**
	   * If `true`, show the component; triggers the enter or exit animation.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Slide;
	exports.default = _default;

/***/ },
/* 354 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(32));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(57));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(27));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(29));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(39));
	
	var _ValueLabel = _interopRequireDefault(__webpack_require__(355));
	
	function asc(a, b) {
	  return a - b;
	}
	
	function clamp(value, min, max) {
	  return Math.min(Math.max(min, value), max);
	}
	
	function findClosest(values, currentValue) {
	  var _values$reduce = values.reduce(function (acc, value, index) {
	    var distance = Math.abs(currentValue - value);
	
	    if (acc === null || distance < acc.distance || distance === acc.distance) {
	      return {
	        distance: distance,
	        index: index
	      };
	    }
	
	    return acc;
	  }, null),
	      closestIndex = _values$reduce.index;
	
	  return closestIndex;
	}
	
	function trackFinger(event, touchId) {
	  if (touchId.current !== undefined && event.changedTouches) {
	    for (var i = 0; i < event.changedTouches.length; i += 1) {
	      var touch = event.changedTouches[i];
	
	      if (touch.identifier === touchId.current) {
	        return {
	          x: touch.clientX,
	          y: touch.clientY
	        };
	      }
	    }
	
	    return false;
	  }
	
	  return {
	    x: event.clientX,
	    y: event.clientY
	  };
	}
	
	function valueToPercent(value, min, max) {
	  return (value - min) * 100 / (max - min);
	}
	
	function percentToValue(percent, min, max) {
	  return (max - min) * percent + min;
	}
	
	function getDecimalPrecision(num) {
	  // This handles the case when num is very small (0.00000001), js will turn this into 1e-8.
	  // When num is bigger than 1 or less than -1 it won't get converted to this notation so it's fine.
	  if (Math.abs(num) < 1) {
	    var parts = num.toExponential().split('e-');
	    var matissaDecimalPart = parts[0].split('.')[1];
	    return (matissaDecimalPart ? matissaDecimalPart.length : 0) + parseInt(parts[1], 10);
	  }
	
	  var decimalPart = num.toString().split('.')[1];
	  return decimalPart ? decimalPart.length : 0;
	}
	
	function roundValueToStep(value, step, min) {
	  var nearest = Math.round((value - min) / step) * step + min;
	  return Number(nearest.toFixed(getDecimalPrecision(step)));
	}
	
	function setValueIndex(_ref) {
	  var values = _ref.values,
	      source = _ref.source,
	      newValue = _ref.newValue,
	      index = _ref.index;
	
	  // Performance shortcut
	  if (values[index] === newValue) {
	    return source;
	  }
	
	  var output = (0, _toConsumableArray2.default)(values);
	  output[index] = newValue;
	  return output;
	}
	
	function focusThumb(_ref2) {
	  var sliderRef = _ref2.sliderRef,
	      activeIndex = _ref2.activeIndex,
	      setActive = _ref2.setActive;
	
	  if (!sliderRef.current.contains(document.activeElement) || Number(document.activeElement.getAttribute('data-index')) !== activeIndex) {
	    sliderRef.current.querySelector("[data-index=\"".concat(activeIndex, "\"]")).focus();
	  }
	
	  if (setActive) {
	    setActive(activeIndex);
	  }
	}
	
	var axisProps = {
	  horizontal: {
	    offset: function offset(percent) {
	      return {
	        left: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        width: "".concat(percent, "%")
	      };
	    }
	  },
	  'horizontal-reverse': {
	    offset: function offset(percent) {
	      return {
	        right: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        width: "".concat(percent, "%")
	      };
	    }
	  },
	  vertical: {
	    offset: function offset(percent) {
	      return {
	        bottom: "".concat(percent, "%")
	      };
	    },
	    leap: function leap(percent) {
	      return {
	        height: "".concat(percent, "%")
	      };
	    }
	  }
	};
	
	var Identity = function Identity(x) {
	  return x;
	};
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      height: 2,
	      width: '100%',
	      boxSizing: 'content-box',
	      padding: '13px 0',
	      display: 'inline-block',
	      position: 'relative',
	      cursor: 'pointer',
	      touchAction: 'none',
	      color: theme.palette.primary.main,
	      WebkitTapHighlightColor: 'transparent',
	      '&$disabled': {
	        pointerEvents: 'none',
	        cursor: 'default',
	        color: theme.palette.grey[400]
	      },
	      '&$vertical': {
	        width: 2,
	        height: '100%',
	        padding: '0 13px'
	      },
	      // The primary input mechanism of the device includes a pointing device of limited accuracy.
	      '@media (pointer: coarse)': {
	        // Reach 42px touch target, about ~8mm on screen.
	        padding: '20px 0',
	        '&$vertical': {
	          padding: '0 20px'
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {// TODO v5: move the style here
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `marks` is provided with at least one label. */
	    marked: {
	      marginBottom: 20,
	      '&$vertical': {
	        marginBottom: 'auto',
	        marginRight: 20
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `orientation="vertical"`. */
	    vertical: {},
	
	    /* Pseudo-class applied to the root and thumb element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the rail element. */
	    rail: {
	      display: 'block',
	      position: 'absolute',
	      width: '100%',
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor',
	      opacity: 0.38,
	      '$vertical &': {
	        height: '100%',
	        width: 2
	      }
	    },
	
	    /* Styles applied to the track element. */
	    track: {
	      display: 'block',
	      position: 'absolute',
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor',
	      '$vertical &': {
	        width: 2
	      }
	    },
	
	    /* Styles applied to the track element if `track={false}`. */
	    trackFalse: {
	      '& $track': {
	        display: 'none'
	      }
	    },
	
	    /* Styles applied to the track element if `track="inverted"`. */
	    trackInverted: {
	      '& $track': {
	        backgroundColor: // Same logic as the LinearProgress track color
	        theme.palette.type === 'light' ? (0, _colorManipulator.lighten)(theme.palette.primary.main, 0.62) : (0, _colorManipulator.darken)(theme.palette.primary.main, 0.5)
	      },
	      '& $rail': {
	        opacity: 1
	      }
	    },
	
	    /* Styles applied to the thumb element. */
	    thumb: {
	      position: 'absolute',
	      width: 12,
	      height: 12,
	      marginLeft: -6,
	      marginTop: -5,
	      boxSizing: 'border-box',
	      borderRadius: '50%',
	      outline: 0,
	      backgroundColor: 'currentColor',
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      transition: theme.transitions.create(['box-shadow'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&::after': {
	        position: 'absolute',
	        content: '""',
	        borderRadius: '50%',
	        // reach 42px hit target (2 * 15 + thumb diameter)
	        left: -15,
	        top: -15,
	        right: -15,
	        bottom: -15
	      },
	      '&$focusVisible,&:hover': {
	        boxShadow: "0px 0px 0px 8px ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.16)),
	        '@media (hover: none)': {
	          boxShadow: 'none'
	        }
	      },
	      '&$active': {
	        boxShadow: "0px 0px 0px 14px ".concat((0, _colorManipulator.fade)(theme.palette.primary.main, 0.16))
	      },
	      '&$disabled': {
	        width: 8,
	        height: 8,
	        marginLeft: -4,
	        marginTop: -3,
	        '&:hover': {
	          boxShadow: 'none'
	        }
	      },
	      '$vertical &': {
	        marginLeft: -5,
	        marginBottom: -6
	      },
	      '$vertical &$disabled': {
	        marginLeft: -3,
	        marginBottom: -4
	      }
	    },
	
	    /* Styles applied to the thumb element if `color="primary"`. */
	    thumbColorPrimary: {// TODO v5: move the style here
	    },
	
	    /* Styles applied to the thumb element if `color="secondary"`. */
	    thumbColorSecondary: {
	      '&$focusVisible,&:hover': {
	        boxShadow: "0px 0px 0px 8px ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.16))
	      },
	      '&$active': {
	        boxShadow: "0px 0px 0px 14px ".concat((0, _colorManipulator.fade)(theme.palette.secondary.main, 0.16))
	      }
	    },
	
	    /* Pseudo-class applied to the thumb element if it's active. */
	    active: {},
	
	    /* Pseudo-class applied to the thumb element if keyboard focused. */
	    focusVisible: {},
	
	    /* Styles applied to the thumb label element. */
	    valueLabel: {},
	
	    /* Styles applied to the mark element. */
	    mark: {
	      position: 'absolute',
	      width: 2,
	      height: 2,
	      borderRadius: 1,
	      backgroundColor: 'currentColor'
	    },
	
	    /* Styles applied to the mark element if active (depending on the value). */
	    markActive: {
	      backgroundColor: theme.palette.background.paper,
	      opacity: 0.8
	    },
	
	    /* Styles applied to the mark label element. */
	    markLabel: (0, _extends2.default)({}, theme.typography.body2, {
	      color: theme.palette.text.secondary,
	      position: 'absolute',
	      top: 26,
	      transform: 'translateX(-50%)',
	      whiteSpace: 'nowrap',
	      '$vertical &': {
	        top: 'auto',
	        left: 26,
	        transform: 'translateY(50%)'
	      },
	      '@media (pointer: coarse)': {
	        top: 40,
	        '$vertical &': {
	          left: 31
	        }
	      }
	    }),
	
	    /* Styles applied to the mark label element if active (depending on the value). */
	    markLabelActive: {
	      color: theme.palette.text.primary
	    }
	  };
	};
	
	exports.styles = styles;
	var Slider = React.forwardRef(function Slider(props, ref) {
	  var ariaLabel = props['aria-label'],
	      ariaLabelledby = props['aria-labelledby'],
	      ariaValuetext = props['aria-valuetext'],
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'span' : _props$component,
	      defaultValue = props.defaultValue,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      getAriaLabel = props.getAriaLabel,
	      getAriaValueText = props.getAriaValueText,
	      _props$marks = props.marks,
	      marksProp = _props$marks === void 0 ? false : _props$marks,
	      _props$max = props.max,
	      max = _props$max === void 0 ? 100 : _props$max,
	      _props$min = props.min,
	      min = _props$min === void 0 ? 0 : _props$min,
	      name = props.name,
	      onChange = props.onChange,
	      onChangeCommitted = props.onChangeCommitted,
	      onMouseDown = props.onMouseDown,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$scale = props.scale,
	      scale = _props$scale === void 0 ? Identity : _props$scale,
	      _props$step = props.step,
	      step = _props$step === void 0 ? 1 : _props$step,
	      _props$ThumbComponent = props.ThumbComponent,
	      ThumbComponent = _props$ThumbComponent === void 0 ? 'span' : _props$ThumbComponent,
	      _props$track = props.track,
	      track = _props$track === void 0 ? 'normal' : _props$track,
	      valueProp = props.value,
	      _props$ValueLabelComp = props.ValueLabelComponent,
	      ValueLabelComponent = _props$ValueLabelComp === void 0 ? _ValueLabel.default : _props$ValueLabelComp,
	      _props$valueLabelDisp = props.valueLabelDisplay,
	      valueLabelDisplay = _props$valueLabelDisp === void 0 ? 'off' : _props$valueLabelDisp,
	      _props$valueLabelForm = props.valueLabelFormat,
	      valueLabelFormat = _props$valueLabelForm === void 0 ? Identity : _props$valueLabelForm,
	      other = (0, _objectWithoutProperties2.default)(props, ["aria-label", "aria-labelledby", "aria-valuetext", "classes", "className", "color", "component", "defaultValue", "disabled", "getAriaLabel", "getAriaValueText", "marks", "max", "min", "name", "onChange", "onChangeCommitted", "onMouseDown", "orientation", "scale", "step", "ThumbComponent", "track", "value", "ValueLabelComponent", "valueLabelDisplay", "valueLabelFormat"]);
	  var theme = (0, _useTheme.default)();
	  var touchId = React.useRef(); // We can't use the :active browser pseudo-classes.
	  // - The active state isn't triggered when clicking on the rail.
	  // - The active state isn't transfered when inversing a range slider.
	
	  var _React$useState = React.useState(-1),
	      active = _React$useState[0],
	      setActive = _React$useState[1];
	
	  var _React$useState2 = React.useState(-1),
	      open = _React$useState2[0],
	      setOpen = _React$useState2[1];
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: 'Slider'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      valueDerived = _useControlled2[0],
	      setValueState = _useControlled2[1];
	
	  var range = Array.isArray(valueDerived);
	  var instanceRef = React.useRef();
	  var values = range ? (0, _toConsumableArray2.default)(valueDerived).sort(asc) : [valueDerived];
	  values = values.map(function (value) {
	    return clamp(value, min, max);
	  });
	  var marks = marksProp === true && step !== null ? (0, _toConsumableArray2.default)(Array(Math.floor((max - min) / step) + 1)).map(function (_, index) {
	    return {
	      value: min + step * index
	    };
	  }) : marksProp || [];
	  instanceRef.current = {
	    source: valueDerived // Keep track of the input value to leverage immutable state comparison.
	
	  };
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState3 = React.useState(-1),
	      focusVisible = _React$useState3[0],
	      setFocusVisible = _React$useState3[1];
	
	  var sliderRef = React.useRef();
	  var handleFocusRef = (0, _useForkRef.default)(focusVisibleRef, sliderRef);
	  var handleRef = (0, _useForkRef.default)(ref, handleFocusRef);
	  var handleFocus = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	
	    if (isFocusVisible(event)) {
	      setFocusVisible(index);
	    }
	
	    setOpen(index);
	  });
	  var handleBlur = (0, _useEventCallback.default)(function () {
	    if (focusVisible !== -1) {
	      setFocusVisible(-1);
	      onBlurVisible();
	    }
	
	    setOpen(-1);
	  });
	  var handleMouseOver = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	    setOpen(index);
	  });
	  var handleMouseLeave = (0, _useEventCallback.default)(function () {
	    setOpen(-1);
	  });
	  var handleKeyDown = (0, _useEventCallback.default)(function (event) {
	    var index = Number(event.currentTarget.getAttribute('data-index'));
	    var value = values[index];
	    var tenPercents = (max - min) / 10;
	    var marksValues = marks.map(function (mark) {
	      return mark.value;
	    });
	    var marksIndex = marksValues.indexOf(value);
	    var newValue;
	
	    switch (event.key) {
	      case 'Home':
	        newValue = min;
	        break;
	
	      case 'End':
	        newValue = max;
	        break;
	
	      case 'PageUp':
	        if (step) {
	          newValue = value + tenPercents;
	        }
	
	        break;
	
	      case 'PageDown':
	        if (step) {
	          newValue = value - tenPercents;
	        }
	
	        break;
	
	      case 'ArrowRight':
	      case 'ArrowUp':
	        if (step) {
	          newValue = value + step;
	        } else {
	          newValue = marksValues[marksIndex + 1] || marksValues[marksValues.length - 1];
	        }
	
	        break;
	
	      case 'ArrowLeft':
	      case 'ArrowDown':
	        if (step) {
	          newValue = value - step;
	        } else {
	          newValue = marksValues[marksIndex - 1] || marksValues[0];
	        }
	
	        break;
	
	      default:
	        return;
	    } // Prevent scroll of the page
	
	
	    event.preventDefault();
	
	    if (step) {
	      newValue = roundValueToStep(newValue, step, min);
	    }
	
	    newValue = clamp(newValue, min, max);
	
	    if (range) {
	      var previousValue = newValue;
	      newValue = setValueIndex({
	        values: values,
	        source: valueDerived,
	        newValue: newValue,
	        index: index
	      }).sort(asc);
	      focusThumb({
	        sliderRef: sliderRef,
	        activeIndex: newValue.indexOf(previousValue)
	      });
	    }
	
	    setValueState(newValue);
	    setFocusVisible(index);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    if (onChangeCommitted) {
	      onChangeCommitted(event, newValue);
	    }
	  });
	  var previousIndex = React.useRef();
	  var axis = orientation;
	
	  if (theme.direction === 'rtl' && orientation !== "vertical") {
	    axis += '-reverse';
	  }
	
	  var getFingerNewValue = function getFingerNewValue(_ref3) {
	    var finger = _ref3.finger,
	        _ref3$move = _ref3.move,
	        move = _ref3$move === void 0 ? false : _ref3$move,
	        values2 = _ref3.values,
	        source = _ref3.source;
	    var slider = sliderRef.current;
	
	    var _slider$getBoundingCl = slider.getBoundingClientRect(),
	        width = _slider$getBoundingCl.width,
	        height = _slider$getBoundingCl.height,
	        bottom = _slider$getBoundingCl.bottom,
	        left = _slider$getBoundingCl.left;
	
	    var percent;
	
	    if (axis.indexOf('vertical') === 0) {
	      percent = (bottom - finger.y) / height;
	    } else {
	      percent = (finger.x - left) / width;
	    }
	
	    if (axis.indexOf('-reverse') !== -1) {
	      percent = 1 - percent;
	    }
	
	    var newValue;
	    newValue = percentToValue(percent, min, max);
	
	    if (step) {
	      newValue = roundValueToStep(newValue, step, min);
	    } else {
	      var marksValues = marks.map(function (mark) {
	        return mark.value;
	      });
	      var closestIndex = findClosest(marksValues, newValue);
	      newValue = marksValues[closestIndex];
	    }
	
	    newValue = clamp(newValue, min, max);
	    var activeIndex = 0;
	
	    if (range) {
	      if (!move) {
	        activeIndex = findClosest(values2, newValue);
	      } else {
	        activeIndex = previousIndex.current;
	      }
	
	      var previousValue = newValue;
	      newValue = setValueIndex({
	        values: values2,
	        source: source,
	        newValue: newValue,
	        index: activeIndex
	      }).sort(asc);
	      activeIndex = newValue.indexOf(previousValue);
	      previousIndex.current = activeIndex;
	    }
	
	    return {
	      newValue: newValue,
	      activeIndex: activeIndex
	    };
	  };
	
	  var handleTouchMove = (0, _useEventCallback.default)(function (event) {
	    var finger = trackFinger(event, touchId);
	
	    if (!finger) {
	      return;
	    }
	
	    var _getFingerNewValue = getFingerNewValue({
	      finger: finger,
	      move: true,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue.newValue,
	        activeIndex = _getFingerNewValue.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	  });
	  var handleTouchEnd = (0, _useEventCallback.default)(function (event) {
	    var finger = trackFinger(event, touchId);
	
	    if (!finger) {
	      return;
	    }
	
	    var _getFingerNewValue2 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue2.newValue;
	
	    setActive(-1);
	
	    if (event.type === 'touchend') {
	      setOpen(-1);
	    }
	
	    if (onChangeCommitted) {
	      onChangeCommitted(event, newValue);
	    }
	
	    touchId.current = undefined;
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.removeEventListener('mousemove', handleTouchMove);
	    doc.removeEventListener('mouseup', handleTouchEnd);
	    doc.removeEventListener('touchmove', handleTouchMove);
	    doc.removeEventListener('touchend', handleTouchEnd);
	  });
	  var handleTouchStart = (0, _useEventCallback.default)(function (event) {
	    // Workaround as Safari has partial support for touchAction: 'none'.
	    event.preventDefault();
	    var touch = event.changedTouches[0];
	
	    if (touch != null) {
	      // A number that uniquely identifies the current finger in the touch session.
	      touchId.current = touch.identifier;
	    }
	
	    var finger = trackFinger(event, touchId);
	
	    var _getFingerNewValue3 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue3.newValue,
	        activeIndex = _getFingerNewValue3.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.addEventListener('touchmove', handleTouchMove);
	    doc.addEventListener('touchend', handleTouchEnd);
	  });
	  React.useEffect(function () {
	    var slider = sliderRef.current;
	    slider.addEventListener('touchstart', handleTouchStart);
	    var doc = (0, _ownerDocument.default)(slider);
	    return function () {
	      slider.removeEventListener('touchstart', handleTouchStart);
	      doc.removeEventListener('mousemove', handleTouchMove);
	      doc.removeEventListener('mouseup', handleTouchEnd);
	      doc.removeEventListener('touchmove', handleTouchMove);
	      doc.removeEventListener('touchend', handleTouchEnd);
	    };
	  }, [handleTouchEnd, handleTouchMove, handleTouchStart]);
	  var handleMouseDown = (0, _useEventCallback.default)(function (event) {
	    if (onMouseDown) {
	      onMouseDown(event);
	    }
	
	    event.preventDefault();
	    var finger = trackFinger(event, touchId);
	
	    var _getFingerNewValue4 = getFingerNewValue({
	      finger: finger,
	      values: values,
	      source: valueDerived
	    }),
	        newValue = _getFingerNewValue4.newValue,
	        activeIndex = _getFingerNewValue4.activeIndex;
	
	    focusThumb({
	      sliderRef: sliderRef,
	      activeIndex: activeIndex,
	      setActive: setActive
	    });
	    setValueState(newValue);
	
	    if (onChange) {
	      onChange(event, newValue);
	    }
	
	    var doc = (0, _ownerDocument.default)(sliderRef.current);
	    doc.addEventListener('mousemove', handleTouchMove);
	    doc.addEventListener('mouseup', handleTouchEnd);
	  });
	  var trackOffset = valueToPercent(range ? values[0] : min, min, max);
	  var trackLeap = valueToPercent(values[values.length - 1], min, max) - trackOffset;
	  var trackStyle = (0, _extends2.default)({}, axisProps[axis].offset(trackOffset), {}, axisProps[axis].leap(trackLeap));
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: handleRef,
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, disabled && classes.disabled, marks.length > 0 && marks.some(function (mark) {
	      return mark.label;
	    }) && classes.marked, track === false && classes.trackFalse, orientation === 'vertical' && classes.vertical, track === 'inverted' && classes.trackInverted),
	    onMouseDown: handleMouseDown
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.rail
	  }), /*#__PURE__*/React.createElement("span", {
	    className: classes.track,
	    style: trackStyle
	  }), /*#__PURE__*/React.createElement("input", {
	    value: values.join(','),
	    name: name,
	    type: "hidden"
	  }), marks.map(function (mark, index) {
	    var percent = valueToPercent(mark.value, min, max);
	    var style = axisProps[axis].offset(percent);
	    var markActive;
	
	    if (track === false) {
	      markActive = values.indexOf(mark.value) !== -1;
	    } else {
	      markActive = track === 'normal' && (range ? mark.value >= values[0] && mark.value <= values[values.length - 1] : mark.value <= values[0]) || track === 'inverted' && (range ? mark.value <= values[0] || mark.value >= values[values.length - 1] : mark.value >= values[0]);
	    }
	
	    return /*#__PURE__*/React.createElement(React.Fragment, {
	      key: mark.value
	    }, /*#__PURE__*/React.createElement("span", {
	      style: style,
	      "data-index": index,
	      className: (0, _clsx.default)(classes.mark, markActive && classes.markActive)
	    }), mark.label != null ? /*#__PURE__*/React.createElement("span", {
	      "aria-hidden": true,
	      "data-index": index,
	      style: style,
	      className: (0, _clsx.default)(classes.markLabel, markActive && classes.markLabelActive)
	    }, mark.label) : null);
	  }), values.map(function (value, index) {
	    var percent = valueToPercent(value, min, max);
	    var style = axisProps[axis].offset(percent);
	    return /*#__PURE__*/React.createElement(ValueLabelComponent, {
	      key: index,
	      valueLabelFormat: valueLabelFormat,
	      valueLabelDisplay: valueLabelDisplay,
	      className: classes.valueLabel,
	      value: typeof valueLabelFormat === 'function' ? valueLabelFormat(scale(value), index) : valueLabelFormat,
	      index: index,
	      open: open === index || active === index || valueLabelDisplay === 'on',
	      disabled: disabled
	    }, /*#__PURE__*/React.createElement(ThumbComponent, {
	      className: (0, _clsx.default)(classes.thumb, classes["thumbColor".concat((0, _capitalize.default)(color))], active === index && classes.active, disabled && classes.disabled, focusVisible === index && classes.focusVisible),
	      tabIndex: disabled ? null : 0,
	      role: "slider",
	      style: style,
	      "data-index": index,
	      "aria-label": getAriaLabel ? getAriaLabel(index) : ariaLabel,
	      "aria-labelledby": ariaLabelledby,
	      "aria-orientation": orientation,
	      "aria-valuemax": scale(max),
	      "aria-valuemin": scale(min),
	      "aria-valuenow": scale(value),
	      "aria-valuetext": getAriaValueText ? getAriaValueText(scale(value), index) : ariaValuetext,
	      onKeyDown: handleKeyDown,
	      onFocus: handleFocus,
	      onBlur: handleBlur,
	      onMouseOver: handleMouseOver,
	      onMouseLeave: handleMouseLeave
	    }));
	  }));
	});
	 false ? Slider.propTypes = {
	  /**
	   * The label of the slider.
	   */
	  'aria-label': (0, _utils.chainPropTypes)(_propTypes.default.string, function (props) {
	    var range = Array.isArray(props.value || props.defaultValue);
	
	    if (range && props['aria-label'] != null) {
	      return new Error('Material-UI: you need to use the `getAriaLabel` prop instead of `aria-label` when using a range slider.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * The id of the element containing a label for the slider.
	   */
	  'aria-labelledby': _propTypes.default.string,
	
	  /**
	   * A string value that provides a user-friendly name for the current value of the slider.
	   */
	  'aria-valuetext': (0, _utils.chainPropTypes)(_propTypes.default.string, function (props) {
	    var range = Array.isArray(props.value || props.defaultValue);
	
	    if (range && props['aria-valuetext'] != null) {
	      return new Error('Material-UI: you need to use the `getAriaValueText` prop instead of `aria-valuetext` when using a range slider.');
	    }
	
	    return null;
	  }),
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The default element value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	
	  /**
	   * If `true`, the slider will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the thumb labels of the slider.
	   *
	   * @param {number} index The thumb label's index to format.
	   * @returns {string}
	   */
	  getAriaLabel: _propTypes.default.func,
	
	  /**
	   * Accepts a function which returns a string value that provides a user-friendly name for the current value of the slider.
	   *
	   * @param {number} value The thumb label's value to format.
	   * @param {number} index The thumb label's index to format.
	   * @returns {string}
	   */
	  getAriaValueText: _propTypes.default.func,
	
	  /**
	   * Marks indicate predetermined values to which the user can move the slider.
	   * If `true` the marks will be spaced according the value of the `step` prop.
	   * If an array, it should contain objects with `value` and an optional `label` keys.
	   */
	  marks: _propTypes.default.oneOfType([_propTypes.default.bool, _propTypes.default.array]),
	
	  /**
	   * The maximum allowed value of the slider.
	   * Should not be equal to min.
	   */
	  max: _propTypes.default.number,
	
	  /**
	   * The minimum allowed value of the slider.
	   * Should not be equal to max.
	   */
	  min: _propTypes.default.number,
	
	  /**
	   * Name attribute of the hidden `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * Callback function that is fired when the slider's value changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number | number[]} value The new value.
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback function that is fired when the `mouseup` is triggered.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number | number[]} value The new value.
	   */
	  onChangeCommitted: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseDown: _propTypes.default.func,
	
	  /**
	   * The slider orientation.
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * A transformation function, to change the scale of the slider.
	   */
	  scale: _propTypes.default.func,
	
	  /**
	   * The granularity with which the slider can step through values. (A "discrete" slider.)
	   * The `min` prop serves as the origin for the valid values.
	   * We recommend (max - min) to be evenly divisible by the step.
	   *
	   * When step is `null`, the thumb can only be slid onto marks provided with the `marks` prop.
	   */
	  step: _propTypes.default.number,
	
	  /**
	   * The component used to display the value label.
	   */
	  ThumbComponent: _propTypes.default.elementType,
	
	  /**
	   * The track presentation:
	   *
	   * - `normal` the track will render a bar representing the slider value.
	   * - `inverted` the track will render a bar representing the remaining slider value.
	   * - `false` the track will render without a bar.
	   */
	  track: _propTypes.default.oneOf(['normal', false, 'inverted']),
	
	  /**
	   * The value of the slider.
	   * For ranged sliders, provide an array with two values.
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.arrayOf(_propTypes.default.number)]),
	
	  /**
	   * The value label component.
	   */
	  ValueLabelComponent: _propTypes.default.elementType,
	
	  /**
	   * Controls when the value label is displayed:
	   *
	   * - `auto` the value label will display when the thumb is hovered or focused.
	   * - `on` will display persistently.
	   * - `off` will never display.
	   */
	  valueLabelDisplay: _propTypes.default.oneOf(['on', 'auto', 'off']),
	
	  /**
	   * The format function the value label's value.
	   *
	   * When a function is provided, it should have the following signature:
	   *
	   * - {number} value The value label's value to format
	   * - {number} index The value label's index to format
	   */
	  valueLabelFormat: _propTypes.default.oneOfType([_propTypes.default.string, _propTypes.default.func])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSlider'
	})(Slider);
	
	exports.default = _default;

/***/ },
/* 355 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    thumb: {
	      '&$open': {
	        '& $offset': {
	          transform: 'scale(1) translateY(-10px)'
	        }
	      }
	    },
	    open: {},
	    offset: (0, _extends2.default)({
	      zIndex: 1
	    }, theme.typography.body2, {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1.2,
	      transition: theme.transitions.create(['transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      top: -34,
	      transformOrigin: 'bottom center',
	      transform: 'scale(0)',
	      position: 'absolute'
	    }),
	    circle: {
	      display: 'flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: 32,
	      height: 32,
	      borderRadius: '50% 50% 50% 0',
	      backgroundColor: 'currentColor',
	      transform: 'rotate(-45deg)'
	    },
	    label: {
	      color: theme.palette.primary.contrastText,
	      transform: 'rotate(45deg)'
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	function ValueLabel(props) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      open = props.open,
	      value = props.value,
	      valueLabelDisplay = props.valueLabelDisplay;
	
	  if (valueLabelDisplay === 'off') {
	    return children;
	  }
	
	  return React.cloneElement(children, {
	    className: (0, _clsx.default)(children.props.className, (open || valueLabelDisplay === 'on') && classes.open, classes.thumb)
	  }, /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.offset, className)
	  }, /*#__PURE__*/React.createElement("span", {
	    className: classes.circle
	  }, /*#__PURE__*/React.createElement("span", {
	    className: classes.label
	  }, value))));
	}
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateValueLabel'
	})(ValueLabel);
	
	exports.default = _default;

/***/ },
/* 356 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Slider.default;
	  }
	});
	
	var _Slider = _interopRequireDefault(__webpack_require__(354));

/***/ },
/* 357 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _extends8 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _transitions = __webpack_require__(26);
	
	var _ClickAwayListener = _interopRequireDefault(__webpack_require__(115));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(29));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _createChainedFunction = _interopRequireDefault(__webpack_require__(54));
	
	var _Grow = _interopRequireDefault(__webpack_require__(63));
	
	var _SnackbarContent = _interopRequireDefault(__webpack_require__(135));
	
	var styles = function styles(theme) {
	  var top1 = {
	    top: 8
	  };
	  var bottom1 = {
	    bottom: 8
	  };
	  var right = {
	    justifyContent: 'flex-end'
	  };
	  var left = {
	    justifyContent: 'flex-start'
	  };
	  var top3 = {
	    top: 24
	  };
	  var bottom3 = {
	    bottom: 24
	  };
	  var right3 = {
	    right: 24
	  };
	  var left3 = {
	    left: 24
	  };
	  var center = {
	    left: '50%',
	    right: 'auto',
	    transform: 'translateX(-50%)'
	  };
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      zIndex: theme.zIndex.snackbar,
	      position: 'fixed',
	      display: 'flex',
	      left: 8,
	      right: 8,
	      justifyContent: 'center',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'center' }}`. */
	    anchorOriginTopCenter: (0, _extends8.default)({}, top1, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({}, top3, {}, center))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'center' }}`. */
	    anchorOriginBottomCenter: (0, _extends8.default)({}, bottom1, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({}, bottom3, {}, center))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'right' }}`. */
	    anchorOriginTopRight: (0, _extends8.default)({}, top1, {}, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      left: 'auto'
	    }, top3, {}, right3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'right' }}`. */
	    anchorOriginBottomRight: (0, _extends8.default)({}, bottom1, {}, right, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      left: 'auto'
	    }, bottom3, {}, right3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'top', 'left' }}`. */
	    anchorOriginTopLeft: (0, _extends8.default)({}, top1, {}, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      right: 'auto'
	    }, top3, {}, left3))),
	
	    /* Styles applied to the root element if `anchorOrigin={{ 'bottom', 'left' }}`. */
	    anchorOriginBottomLeft: (0, _extends8.default)({}, bottom1, {}, left, (0, _defineProperty2.default)({}, theme.breakpoints.up('sm'), (0, _extends8.default)({
	      right: 'auto'
	    }, bottom3, {}, left3)))
	  };
	};
	
	exports.styles = styles;
	var Snackbar = React.forwardRef(function Snackbar(props, ref) {
	  var action = props.action,
	      _props$anchorOrigin = props.anchorOrigin;
	  _props$anchorOrigin = _props$anchorOrigin === void 0 ? {
	    vertical: 'bottom',
	    horizontal: 'center'
	  } : _props$anchorOrigin;
	  var vertical = _props$anchorOrigin.vertical,
	      horizontal = _props$anchorOrigin.horizontal,
	      _props$autoHideDurati = props.autoHideDuration,
	      autoHideDuration = _props$autoHideDurati === void 0 ? null : _props$autoHideDurati,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      ClickAwayListenerProps = props.ClickAwayListenerProps,
	      ContentProps = props.ContentProps,
	      _props$disableWindowB = props.disableWindowBlurListener,
	      disableWindowBlurListener = _props$disableWindowB === void 0 ? false : _props$disableWindowB,
	      message = props.message,
	      onClose = props.onClose,
	      onEnter = props.onEnter,
	      onEntered = props.onEntered,
	      onEntering = props.onEntering,
	      onExit = props.onExit,
	      onExited = props.onExited,
	      onExiting = props.onExiting,
	      onMouseEnter = props.onMouseEnter,
	      onMouseLeave = props.onMouseLeave,
	      open = props.open,
	      resumeHideDuration = props.resumeHideDuration,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? {
	    enter: _transitions.duration.enteringScreen,
	    exit: _transitions.duration.leavingScreen
	  } : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "anchorOrigin", "autoHideDuration", "children", "classes", "className", "ClickAwayListenerProps", "ContentProps", "disableWindowBlurListener", "message", "onClose", "onEnter", "onEntered", "onEntering", "onExit", "onExited", "onExiting", "onMouseEnter", "onMouseLeave", "open", "resumeHideDuration", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	  var timerAutoHide = React.useRef();
	
	  var _React$useState = React.useState(true),
	      exited = _React$useState[0],
	      setExited = _React$useState[1];
	
	  var handleClose = (0, _useEventCallback.default)(function () {
	    if (onClose) {
	      onClose.apply(void 0, arguments);
	    }
	  });
	  var setAutoHideTimer = (0, _useEventCallback.default)(function (autoHideDurationParam) {
	    if (!onClose || autoHideDurationParam == null) {
	      return;
	    }
	
	    clearTimeout(timerAutoHide.current);
	    timerAutoHide.current = setTimeout(function () {
	      handleClose(null, 'timeout');
	    }, autoHideDurationParam);
	  });
	  React.useEffect(function () {
	    if (open) {
	      setAutoHideTimer(autoHideDuration);
	    }
	
	    return function () {
	      clearTimeout(timerAutoHide.current);
	    };
	  }, [open, autoHideDuration, setAutoHideTimer]); // Pause the timer when the user is interacting with the Snackbar
	  // or when the user hide the window.
	
	  var handlePause = function handlePause() {
	    clearTimeout(timerAutoHide.current);
	  }; // Restart the timer when the user is no longer interacting with the Snackbar
	  // or when the window is shown back.
	
	
	  var handleResume = React.useCallback(function () {
	    if (autoHideDuration != null) {
	      setAutoHideTimer(resumeHideDuration != null ? resumeHideDuration : autoHideDuration * 0.5);
	    }
	  }, [autoHideDuration, resumeHideDuration, setAutoHideTimer]);
	
	  var handleMouseEnter = function handleMouseEnter(event) {
	    if (onMouseEnter) {
	      onMouseEnter(event);
	    }
	
	    handlePause();
	  };
	
	  var handleMouseLeave = function handleMouseLeave(event) {
	    if (onMouseLeave) {
	      onMouseLeave(event);
	    }
	
	    handleResume();
	  };
	
	  var handleClickAway = function handleClickAway(event) {
	    if (onClose) {
	      onClose(event, 'clickaway');
	    }
	  };
	
	  var handleExited = function handleExited() {
	    setExited(true);
	  };
	
	  var handleEnter = function handleEnter() {
	    setExited(false);
	  };
	
	  React.useEffect(function () {
	    if (!disableWindowBlurListener && open) {
	      window.addEventListener('focus', handleResume);
	      window.addEventListener('blur', handlePause);
	      return function () {
	        window.removeEventListener('focus', handleResume);
	        window.removeEventListener('blur', handlePause);
	      };
	    }
	
	    return undefined;
	  }, [disableWindowBlurListener, handleResume, open]); // So we only render active snackbars.
	
	  if (!open && exited) {
	    return null;
	  }
	
	  return /*#__PURE__*/React.createElement(_ClickAwayListener.default, (0, _extends8.default)({
	    onClickAway: handleClickAway
	  }, ClickAwayListenerProps), /*#__PURE__*/React.createElement("div", (0, _extends8.default)({
	    className: (0, _clsx.default)(classes.root, classes["anchorOrigin".concat((0, _capitalize.default)(vertical)).concat((0, _capitalize.default)(horizontal))], className),
	    onMouseEnter: handleMouseEnter,
	    onMouseLeave: handleMouseLeave,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends8.default)({
	    appear: true,
	    in: open,
	    onEnter: (0, _createChainedFunction.default)(handleEnter, onEnter),
	    onEntered: onEntered,
	    onEntering: onEntering,
	    onExit: onExit,
	    onExited: (0, _createChainedFunction.default)(handleExited, onExited),
	    onExiting: onExiting,
	    timeout: transitionDuration,
	    direction: vertical === 'top' ? 'down' : 'up'
	  }, TransitionProps), children || /*#__PURE__*/React.createElement(_SnackbarContent.default, (0, _extends8.default)({
	    message: message,
	    action: action
	  }, ContentProps)))));
	});
	 false ? Snackbar.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display. It renders after the message, at the end of the snackbar.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * The anchor of the `Snackbar`.
	   */
	  anchorOrigin: _propTypes.default.shape({
	    horizontal: _propTypes.default.oneOf(['center', 'left', 'right']).isRequired,
	    vertical: _propTypes.default.oneOf(['bottom', 'top']).isRequired
	  }),
	
	  /**
	   * The number of milliseconds to wait before automatically calling the
	   * `onClose` function. `onClose` should then set the state of the `open`
	   * prop to hide the Snackbar. This behavior is disabled by default with
	   * the `null` value.
	   */
	  autoHideDuration: _propTypes.default.number,
	
	  /**
	   * Replace the `SnackbarContent` component.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Props applied to the `ClickAwayListener` element.
	   */
	  ClickAwayListenerProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the [`SnackbarContent`](/api/snackbar-content/) element.
	   */
	  ContentProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the `autoHideDuration` timer will expire even if the window is not focused.
	   */
	  disableWindowBlurListener: _propTypes.default.bool,
	
	  /**
	   * When displaying multiple consecutive Snackbars from a parent rendering a single
	   * <Snackbar/>, add the key prop to ensure independent treatment of each message.
	   * e.g. <Snackbar key={message} />, otherwise, the message may update-in-place and
	   * features such as autoHideDuration may be canceled.
	   */
	  key: _propTypes.default.any,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   * Typically `onClose` is used to set state in the parent component,
	   * which is used to control the `Snackbar` `open` prop.
	   * The `reason` parameter can optionally be used to control the response to `onClose`,
	   * for example ignoring `clickaway`.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"timeout"` (`autoHideDuration` expired), `"clickaway"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is entering.
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has entered.
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is entering.
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * Callback fired before the transition is exiting.
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition has exited.
	   */
	  onExited: _propTypes.default.func,
	
	  /**
	   * Callback fired when the transition is exiting.
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onMouseLeave: _propTypes.default.func,
	
	  /**
	   * If `true`, `Snackbar` is open.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before dismissing after user interaction.
	   * If `autoHideDuration` prop isn't specified, it does nothing.
	   * If `autoHideDuration` prop is specified but `resumeHideDuration` isn't,
	   * we default to `autoHideDuration / 2` ms.
	   */
	  resumeHideDuration: _propTypes.default.number,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  flip: false,
	  name: 'MuiSnackbar'
	})(Snackbar);
	
	exports.default = _default;

/***/ },
/* 358 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Snackbar.default;
	  }
	});
	
	var _Snackbar = _interopRequireDefault(__webpack_require__(357));

/***/ },
/* 359 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _colorManipulator = __webpack_require__(15);
	
	var styles = function styles(theme) {
	  var emphasis = theme.palette.type === 'light' ? 0.8 : 0.98;
	  var backgroundColor = (0, _colorManipulator.emphasize)(theme.palette.background.default, emphasis);
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.body2, (0, _defineProperty2.default)({
	      color: theme.palette.getContrastText(backgroundColor),
	      backgroundColor: backgroundColor,
	      display: 'flex',
	      alignItems: 'center',
	      flexWrap: 'wrap',
	      padding: '6px 16px',
	      borderRadius: theme.shape.borderRadius,
	      flexGrow: 1
	    }, theme.breakpoints.up('sm'), {
	      flexGrow: 'initial',
	      minWidth: 288
	    })),
	
	    /* Styles applied to the message wrapper element. */
	    message: {
	      padding: '8px 0'
	    },
	
	    /* Styles applied to the action wrapper element if `action` is provided. */
	    action: {
	      display: 'flex',
	      alignItems: 'center',
	      marginLeft: 'auto',
	      paddingLeft: 16,
	      marginRight: -8
	    }
	  };
	};
	
	exports.styles = styles;
	var SnackbarContent = React.forwardRef(function SnackbarContent(props, ref) {
	  var action = props.action,
	      classes = props.classes,
	      className = props.className,
	      message = props.message,
	      _props$role = props.role,
	      role = _props$role === void 0 ? 'alert' : _props$role,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "classes", "className", "message", "role"]);
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends3.default)({
	    role: role,
	    square: true,
	    elevation: 6,
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("div", {
	    className: classes.message
	  }, message), action ? /*#__PURE__*/React.createElement("div", {
	    className: classes.action
	  }, action) : null);
	});
	 false ? SnackbarContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * The action to display. It renders after the message, at the end of the snackbar.
	   */
	  action: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The message to display.
	   */
	  message: _propTypes.default.node,
	
	  /**
	   * The ARIA role attribute of the element.
	   */
	  role: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSnackbarContent'
	})(SnackbarContent);
	
	exports.default = _default;

/***/ },
/* 360 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(18);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {},
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {
	    paddingLeft: 8,
	    paddingRight: 8
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {},
	
	  /* Styles applied to the root element if `alternativeLabel={true}`. */
	  alternativeLabel: {
	    flex: 1,
	    position: 'relative'
	  },
	
	  /* Pseudo-class applied to the root element if `completed={true}`. */
	  completed: {}
	};
	exports.styles = styles;
	var Step = React.forwardRef(function Step(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      connector = props.connector,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$expanded = props.expanded,
	      expanded = _props$expanded === void 0 ? false : _props$expanded,
	      index = props.index,
	      last = props.last,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "connector", "disabled", "expanded", "index", "last", "orientation"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, completed && classes.completed),
	    ref: ref
	  }, other), connector && alternativeLabel && index !== 0 && React.cloneElement(connector, {
	    orientation: orientation,
	    alternativeLabel: alternativeLabel,
	    index: index,
	    active: active,
	    completed: completed,
	    disabled: disabled
	  }), React.Children.map(children, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Step component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    return React.cloneElement(child, (0, _extends2.default)({
	      active: active,
	      alternativeLabel: alternativeLabel,
	      completed: completed,
	      disabled: disabled,
	      expanded: expanded,
	      last: last,
	      icon: index + 1,
	      orientation: orientation
	    }, child.props));
	  }));
	});
	 false ? Step.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Sets the step as active. Is passed to child components.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Should be `Step` sub-components such as `StepLabel`, `StepContent`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepButton` is a child of `Step`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Expand the step.
	   */
	  expanded: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStep'
	})(Step);
	
	exports.default = _default;

/***/ },
/* 361 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Step.default;
	  }
	});
	
	var _Step = _interopRequireDefault(__webpack_require__(360));

/***/ },
/* 362 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var _StepLabel = _interopRequireDefault(__webpack_require__(138));
	
	var _isMuiElement = _interopRequireDefault(__webpack_require__(55));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: '100%',
	    padding: '24px 16px',
	    margin: '-24px -16px',
	    boxSizing: 'content-box'
	  },
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {},
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    justifyContent: 'flex-start',
	    padding: '8px',
	    margin: '-8px'
	  },
	
	  /* Styles applied to the `ButtonBase` touch-ripple. */
	  touchRipple: {
	    color: 'rgba(0, 0, 0, 0.3)'
	  }
	};
	exports.styles = styles;
	var StepButton = React.forwardRef(function StepButton(props, ref) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      expanded = props.expanded,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "expanded", "icon", "last", "optional", "orientation"]);
	  var childProps = {
	    active: active,
	    alternativeLabel: alternativeLabel,
	    completed: completed,
	    disabled: disabled,
	    icon: icon,
	    optional: optional,
	    orientation: orientation
	  };
	  var child = (0, _isMuiElement.default)(children, ['StepLabel']) ? React.cloneElement(children, childProps) : /*#__PURE__*/React.createElement(_StepLabel.default, childProps, children);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    disabled: disabled,
	    TouchRippleProps: {
	      className: classes.touchRipple
	    },
	    className: (0, _clsx.default)(classes.root, classes[orientation], className),
	    ref: ref
	  }, other), child);
	});
	 false ? StepButton.propTypes = {
	  /**
	   * @ignore
	   * Passed in via `Step` - passed through to `StepLabel`.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Set internally by Stepper when it's supplied with the alternativeLabel property.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Can be a `StepLabel` or a node to place inside `StepLabel` as children.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * Sets completed styling. Is passed to StepLabel.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * Disables the button and sets disabled styling. Is passed to StepLabel.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   * potentially passed from parent `Step`
	   */
	  expanded: _propTypes.default.bool,
	
	  /**
	   * The icon displayed by the step label.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  last: _propTypes.default.bool,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepButton'
	})(StepButton);
	
	exports.default = _default;

/***/ },
/* 363 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepButton.default;
	  }
	});
	
	var _StepButton = _interopRequireDefault(__webpack_require__(362));

/***/ },
/* 364 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      flex: '1 1 auto'
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    horizontal: {},
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      marginLeft: 12,
	      // half icon
	      padding: '0 0 8px'
	    },
	
	    /* Styles applied to the root element if `alternativeLabel={true}`. */
	    alternativeLabel: {
	      position: 'absolute',
	      top: 8 + 4,
	      left: 'calc(-50% + 20px)',
	      right: 'calc(50% + 20px)'
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the root element if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the line element. */
	    line: {
	      display: 'block',
	      borderColor: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600]
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal"`. */
	    lineHorizontal: {
	      borderTopStyle: 'solid',
	      borderTopWidth: 1
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    lineVertical: {
	      borderLeftStyle: 'solid',
	      borderLeftWidth: 1,
	      minHeight: 24
	    }
	  };
	};
	
	exports.styles = styles;
	var StepConnector = React.forwardRef(function StepConnector(props, ref) {
	  var active = props.active,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      disabled = props.disabled,
	      index = props.index,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "classes", "className", "completed", "disabled", "index", "orientation"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel, active && classes.active, completed && classes.completed, disabled && classes.disabled),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.line, {
	      'horizontal': classes.lineHorizontal,
	      'vertical': classes.lineVertical
	    }[orientation])
	  }));
	});
	 false ? StepConnector.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepConnector'
	})(StepConnector);
	
	exports.default = _default;

/***/ },
/* 365 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _Collapse = _interopRequireDefault(__webpack_require__(75));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      marginTop: 8,
	      marginLeft: 12,
	      // half icon
	      paddingLeft: 8 + 12,
	      // margin + half icon
	      paddingRight: 8,
	      borderLeft: "1px solid ".concat(theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[600])
	    },
	
	    /* Styles applied to the root element if `last={true}` (controlled by `Step`). */
	    last: {
	      borderLeft: 'none'
	    },
	
	    /* Styles applied to the Transition component. */
	    transition: {}
	  };
	};
	
	exports.styles = styles;
	var StepContent = React.forwardRef(function StepContent(props, ref) {
	  var active = props.active,
	      alternativeLabel = props.alternativeLabel,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      completed = props.completed,
	      expanded = props.expanded,
	      last = props.last,
	      optional = props.optional,
	      orientation = props.orientation,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Collapse.default : _props$TransitionComp,
	      _props$transitionDura = props.transitionDuration,
	      transitionDurationProp = _props$transitionDura === void 0 ? 'auto' : _props$transitionDura,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "expanded", "last", "optional", "orientation", "TransitionComponent", "transitionDuration", "TransitionProps"]);
	
	  if (false) {
	    if (orientation !== 'vertical') {
	      console.error('Material-UI: <StepContent /> is only designed for use with the vertical stepper.');
	    }
	  }
	
	  var transitionDuration = transitionDurationProp;
	
	  if (transitionDurationProp === 'auto' && !TransitionComponent.muiSupportAuto) {
	    transitionDuration = undefined;
	  }
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, last && classes.last),
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	    in: active || expanded,
	    className: classes.transition,
	    timeout: transitionDuration,
	    unmountOnExit: true
	  }, TransitionProps), children));
	});
	 false ? StepContent.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Step content.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Adjust the duration of the content expand transition.
	   * Passed as a prop to the transition component.
	   *
	   * Set to 'auto' to automatically calculate transition time based on height.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepContent'
	})(StepContent);
	
	exports.default = _default;

/***/ },
/* 366 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _StepContent.default;
	  }
	});
	
	var _StepContent = _interopRequireDefault(__webpack_require__(365));

/***/ },
/* 367 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _CheckCircle = _interopRequireDefault(__webpack_require__(423));
	
	var _Warning = _interopRequireDefault(__webpack_require__(429));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _SvgIcon = _interopRequireDefault(__webpack_require__(51));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'block',
	      color: theme.palette.text.disabled,
	      '&$completed': {
	        color: theme.palette.primary.main
	      },
	      '&$active': {
	        color: theme.palette.primary.main
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Styles applied to the SVG text element. */
	    text: {
	      fill: theme.palette.primary.contrastText,
	      fontSize: theme.typography.caption.fontSize,
	      fontFamily: theme.typography.fontFamily
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the root element if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element if `error={true}`. */
	    error: {}
	  };
	};
	
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement("circle", {
	  cx: "12",
	  cy: "12",
	  r: "12"
	});
	
	var StepIcon = React.forwardRef(function StepIcon(props, ref) {
	  var _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      icon = props.icon,
	      _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      classes = props.classes;
	
	  if (typeof icon === 'number' || typeof icon === 'string') {
	    var className = (0, _clsx.default)(classes.root, active && classes.active, error && classes.error, completed && classes.completed);
	
	    if (error) {
	      return /*#__PURE__*/React.createElement(_Warning.default, {
	        className: className,
	        ref: ref
	      });
	    }
	
	    if (completed) {
	      return /*#__PURE__*/React.createElement(_CheckCircle.default, {
	        className: className,
	        ref: ref
	      });
	    }
	
	    return /*#__PURE__*/React.createElement(_SvgIcon.default, {
	      className: className,
	      ref: ref
	    }, _ref, /*#__PURE__*/React.createElement("text", {
	      className: classes.text,
	      x: "12",
	      y: "16",
	      textAnchor: "middle"
	    }, icon));
	  }
	
	  return icon;
	});
	 false ? StepIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Whether this step is active.
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * Mark the step as completed. Is passed to child components.
	   */
	  completed: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * The label displayed in the step icon.
	   */
	  icon: _propTypes.default.node
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepIcon'
	})(StepIcon);
	
	exports.default = _default;

/***/ },
/* 368 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var _StepIcon = _interopRequireDefault(__webpack_require__(137));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'flex',
	      alignItems: 'center',
	      '&$alternativeLabel': {
	        flexDirection: 'column'
	      },
	      '&$disabled': {
	        cursor: 'default'
	      }
	    },
	
	    /* Styles applied to the root element if `orientation="horizontal". */
	    horizontal: {},
	
	    /* Styles applied to the root element if `orientation="vertical". */
	    vertical: {},
	
	    /* Styles applied to the `Typography` component which wraps `children`. */
	    label: {
	      color: theme.palette.text.secondary,
	      '&$active': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$completed': {
	        color: theme.palette.text.primary,
	        fontWeight: 500
	      },
	      '&$alternativeLabel': {
	        textAlign: 'center',
	        marginTop: 16
	      },
	      '&$error': {
	        color: theme.palette.error.main
	      }
	    },
	
	    /* Pseudo-class applied to the `Typography` component if `active={true}`. */
	    active: {},
	
	    /* Pseudo-class applied to the `Typography` component if `completed={true}`. */
	    completed: {},
	
	    /* Pseudo-class applied to the root element and `Typography` component if `error={true}`. */
	    error: {},
	
	    /* Pseudo-class applied to the root element and `Typography` component if `disabled={true}`. */
	    disabled: {},
	
	    /* Styles applied to the `icon` container element. */
	    iconContainer: {
	      flexShrink: 0,
	      // Fix IE 11 issue
	      display: 'flex',
	      paddingRight: 8,
	      '&$alternativeLabel': {
	        paddingRight: 0
	      }
	    },
	
	    /* Pseudo-class applied to the root and icon container and `Typography` if `alternativeLabel={true}`. */
	    alternativeLabel: {},
	
	    /* Styles applied to the container element which wraps `Typography` and `optional`. */
	    labelContainer: {
	      width: '100%'
	    }
	  };
	};
	
	exports.styles = styles;
	var StepLabel = React.forwardRef(function StepLabel(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$completed = props.completed,
	      completed = _props$completed === void 0 ? false : _props$completed,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      expanded = props.expanded,
	      icon = props.icon,
	      last = props.last,
	      optional = props.optional,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      StepIconComponentProp = props.StepIconComponent,
	      StepIconProps = props.StepIconProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "alternativeLabel", "children", "classes", "className", "completed", "disabled", "error", "expanded", "icon", "last", "optional", "orientation", "StepIconComponent", "StepIconProps"]);
	  var StepIconComponent = StepIconComponentProp;
	
	  if (icon && !StepIconComponent) {
	    StepIconComponent = _StepIcon.default;
	  }
	
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, disabled && classes.disabled, alternativeLabel && classes.alternativeLabel, error && classes.error),
	    ref: ref
	  }, other), icon || StepIconComponent ? /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.iconContainer, alternativeLabel && classes.alternativeLabel)
	  }, /*#__PURE__*/React.createElement(StepIconComponent, (0, _extends2.default)({
	    completed: completed,
	    active: active,
	    error: error,
	    icon: icon
	  }, StepIconProps))) : null, /*#__PURE__*/React.createElement("span", {
	    className: classes.labelContainer
	  }, /*#__PURE__*/React.createElement(_Typography.default, {
	    variant: "body2",
	    component: "span",
	    className: (0, _clsx.default)(classes.label, alternativeLabel && classes.alternativeLabel, completed && classes.completed, active && classes.active, error && classes.error),
	    display: "block"
	  }, children), optional));
	});
	 false ? StepLabel.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * In most cases will simply be a string containing a title for the label.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Mark the step as disabled, will also disable the button if
	   * `StepLabelButton` is a child of `StepLabel`. Is passed to child components.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * Mark the step as failed.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Override the default label of the step icon.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The optional node to display.
	   */
	  optional: _propTypes.default.node,
	
	  /**
	   * The component to render in place of the [`StepIcon`](/api/step-icon/).
	   */
	  StepIconComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`StepIcon`](/api/step-icon/) element.
	   */
	  StepIconProps: _propTypes.default.object
	} : void 0;
	StepLabel.muiName = 'StepLabel';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepLabel'
	})(StepLabel);
	
	exports.default = _default;

/***/ },
/* 369 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _StepConnector = _interopRequireDefault(__webpack_require__(136));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'flex',
	    padding: 24
	  },
	
	  /* Styles applied to the root element if `orientation="horizontal"`. */
	  horizontal: {
	    flexDirection: 'row',
	    alignItems: 'center'
	  },
	
	  /* Styles applied to the root element if `orientation="vertical"`. */
	  vertical: {
	    flexDirection: 'column'
	  },
	
	  /* Styles applied to the root element if `alternativeLabel={true}`. */
	  alternativeLabel: {
	    alignItems: 'flex-start'
	  }
	};
	exports.styles = styles;
	var defaultConnector = /*#__PURE__*/React.createElement(_StepConnector.default, null);
	var Stepper = React.forwardRef(function Stepper(props, ref) {
	  var _props$activeStep = props.activeStep,
	      activeStep = _props$activeStep === void 0 ? 0 : _props$activeStep,
	      _props$alternativeLab = props.alternativeLabel,
	      alternativeLabel = _props$alternativeLab === void 0 ? false : _props$alternativeLab,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$connector = props.connector,
	      connectorProp = _props$connector === void 0 ? defaultConnector : _props$connector,
	      _props$nonLinear = props.nonLinear,
	      nonLinear = _props$nonLinear === void 0 ? false : _props$nonLinear,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["activeStep", "alternativeLabel", "children", "classes", "className", "connector", "nonLinear", "orientation"]);
	  var connector = React.isValidElement(connectorProp) ? React.cloneElement(connectorProp, {
	    orientation: orientation
	  }) : null;
	  var childrenArray = React.Children.toArray(children);
	  var steps = childrenArray.map(function (step, index) {
	    var controlProps = {
	      alternativeLabel: alternativeLabel,
	      connector: connectorProp,
	      last: index + 1 === childrenArray.length,
	      orientation: orientation
	    };
	    var state = {
	      index: index,
	      active: false,
	      completed: false,
	      disabled: false
	    };
	
	    if (activeStep === index) {
	      state.active = true;
	    } else if (!nonLinear && activeStep > index) {
	      state.completed = true;
	    } else if (!nonLinear && activeStep < index) {
	      state.disabled = true;
	    }
	
	    return [!alternativeLabel && connector && index !== 0 && React.cloneElement(connector, (0, _extends2.default)({
	      key: index
	    }, state)), React.cloneElement(step, (0, _extends2.default)({}, controlProps, {}, state, {}, step.props))];
	  });
	  return /*#__PURE__*/React.createElement(_Paper.default, (0, _extends2.default)({
	    square: true,
	    elevation: 0,
	    className: (0, _clsx.default)(classes.root, classes[orientation], className, alternativeLabel && classes.alternativeLabel),
	    ref: ref
	  }, other), steps);
	});
	 false ? Stepper.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the active step (zero based index).
	   * Set to -1 to disable all the steps.
	   */
	  activeStep: _propTypes.default.number,
	
	  /**
	   * If set to 'true' and orientation is horizontal,
	   * then the step label will be positioned under the icon.
	   */
	  alternativeLabel: _propTypes.default.bool,
	
	  /**
	   * Two or more `<Step />` components.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * An element to be placed between each step.
	   */
	  connector: _propTypes.default.element,
	
	  /**
	   * If set the `Stepper` will not assist in controlling steps for linear flow.
	   */
	  nonLinear: _propTypes.default.bool,
	
	  /**
	   * The stepper orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiStepper'
	})(Stepper);
	
	exports.default = _default;

/***/ },
/* 370 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Stepper.default;
	  }
	});
	
	var _Stepper = _interopRequireDefault(__webpack_require__(369));

/***/ },
/* 371 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      userSelect: 'none',
	      width: '1em',
	      height: '1em',
	      display: 'inline-block',
	      fill: 'currentColor',
	      flexShrink: 0,
	      fontSize: theme.typography.pxToRem(24),
	      transition: theme.transitions.create('fill', {
	        duration: theme.transitions.duration.shorter
	      })
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="action"`. */
	    colorAction: {
	      color: theme.palette.action.active
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `color="disabled"`. */
	    colorDisabled: {
	      color: theme.palette.action.disabled
	    },
	
	    /* Styles applied to the root element if `fontSize="inherit"`. */
	    fontSizeInherit: {
	      fontSize: 'inherit'
	    },
	
	    /* Styles applied to the root element if `fontSize="small"`. */
	    fontSizeSmall: {
	      fontSize: theme.typography.pxToRem(20)
	    },
	
	    /* Styles applied to the root element if `fontSize="large"`. */
	    fontSizeLarge: {
	      fontSize: theme.typography.pxToRem(35)
	    }
	  };
	};
	
	exports.styles = styles;
	var SvgIcon = React.forwardRef(function SvgIcon(props, ref) {
	  var children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'inherit' : _props$color,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'svg' : _props$component,
	      _props$fontSize = props.fontSize,
	      fontSize = _props$fontSize === void 0 ? 'default' : _props$fontSize,
	      htmlColor = props.htmlColor,
	      titleAccess = props.titleAccess,
	      _props$viewBox = props.viewBox,
	      viewBox = _props$viewBox === void 0 ? '0 0 24 24' : _props$viewBox,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "classes", "className", "color", "component", "fontSize", "htmlColor", "titleAccess", "viewBox"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, color !== 'inherit' && classes["color".concat((0, _capitalize.default)(color))], fontSize !== 'default' && classes["fontSize".concat((0, _capitalize.default)(fontSize))]),
	    focusable: "false",
	    viewBox: viewBox,
	    color: htmlColor,
	    "aria-hidden": titleAccess ? undefined : 'true',
	    role: titleAccess ? 'img' : undefined,
	    ref: ref
	  }, other), children, titleAccess ? /*#__PURE__*/React.createElement("title", null, titleAccess) : null);
	});
	 false ? SvgIcon.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Node passed into the SVG element.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   * You can use the `htmlColor` prop to apply a color attribute to the SVG element.
	   */
	  color: _propTypes.default.oneOf(['action', 'disabled', 'error', 'inherit', 'primary', 'secondary']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The fontSize applied to the icon. Defaults to 24px, but can be configure to inherit font size.
	   */
	  fontSize: _propTypes.default.oneOf(['default', 'inherit', 'large', 'small']),
	
	  /**
	   * Applies a color attribute to the SVG element.
	   */
	  htmlColor: _propTypes.default.string,
	
	  /**
	   * The shape-rendering attribute. The behavior of the different options is described on the
	   * [MDN Web Docs](https://developer.mozilla.org/en-US/docs/Web/SVG/Attribute/shape-rendering).
	   * If you are having issues with blurry icons you should investigate this property.
	   */
	  shapeRendering: _propTypes.default.string,
	
	  /**
	   * Provides a human-readable title for the element that contains it.
	   * https://www.w3.org/TR/SVG-access/#Equivalent
	   */
	  titleAccess: _propTypes.default.string,
	
	  /**
	   * Allows you to redefine what the coordinates without units mean inside an SVG element.
	   * For example, if the SVG element is 500 (width) by 200 (height),
	   * and you pass viewBox="0 0 50 20",
	   * this means that the coordinates inside the SVG will go from the top left corner (0,0)
	   * to bottom right (50,20) and each unit will be worth 10px.
	   */
	  viewBox: _propTypes.default.string
	} : void 0;
	SvgIcon.muiName = 'SvgIcon';
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSvgIcon'
	})(SvgIcon);
	
	exports.default = _default;

/***/ },
/* 372 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _Drawer = __webpack_require__(76);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'fixed',
	      top: 0,
	      left: 0,
	      bottom: 0,
	      zIndex: theme.zIndex.drawer - 1
	    },
	    anchorLeft: {
	      right: 'auto'
	    },
	    anchorRight: {
	      left: 'auto',
	      right: 0
	    },
	    anchorTop: {
	      bottom: 'auto',
	      right: 0
	    },
	    anchorBottom: {
	      top: 'auto',
	      bottom: 0,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var SwipeArea = React.forwardRef(function SwipeArea(props, ref) {
	  var anchor = props.anchor,
	      classes = props.classes,
	      className = props.className,
	      width = props.width,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "classes", "className", "width"]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["anchor".concat((0, _capitalize.default)(anchor))], className),
	    ref: ref,
	    style: (0, _defineProperty2.default)({}, (0, _Drawer.isHorizontal)(anchor) ? 'width' : 'height', width)
	  }, other));
	});
	 false ? SwipeArea.propTypes = {
	  /**
	   * Side on which to attach the discovery area.
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']).isRequired,
	
	  /**
	   * @ignore
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  width: _propTypes.default.number.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateSwipeArea'
	})(SwipeArea);
	
	exports.default = _default;

/***/ },
/* 373 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.reset = reset;
	exports.default = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _utils = __webpack_require__(9);
	
	var _styles = __webpack_require__(20);
	
	var _Drawer = _interopRequireWildcard(__webpack_require__(76));
	
	var _ownerDocument = _interopRequireDefault(__webpack_require__(27));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(29));
	
	var _transitions = __webpack_require__(26);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var _utils2 = __webpack_require__(44);
	
	var _NoSsr = _interopRequireDefault(__webpack_require__(131));
	
	var _SwipeArea = _interopRequireDefault(__webpack_require__(372));
	
	// This value is closed to what browsers are using internally to
	// trigger a native scroll.
	var UNCERTAINTY_THRESHOLD = 3; // px
	// We can only have one node at the time claiming ownership for handling the swipe.
	// Otherwise, the UX would be confusing.
	// That's why we use a singleton here.
	
	var nodeThatClaimedTheSwipe = null; // Exported for test purposes.
	
	function reset() {
	  nodeThatClaimedTheSwipe = null;
	}
	
	function calculateCurrentX(anchor, touches) {
	  return anchor === 'right' ? document.body.offsetWidth - touches[0].pageX : touches[0].pageX;
	}
	
	function calculateCurrentY(anchor, touches) {
	  return anchor === 'bottom' ? window.innerHeight - touches[0].clientY : touches[0].clientY;
	}
	
	function getMaxTranslate(horizontalSwipe, paperInstance) {
	  return horizontalSwipe ? paperInstance.clientWidth : paperInstance.clientHeight;
	}
	
	function getTranslate(currentTranslate, startLocation, open, maxTranslate) {
	  return Math.min(Math.max(open ? startLocation - currentTranslate : maxTranslate + startLocation - currentTranslate, 0), maxTranslate);
	}
	
	function getDomTreeShapes(element, rootNode) {
	  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L129
	  var domTreeShapes = [];
	
	  while (element && element !== rootNode) {
	    var style = window.getComputedStyle(element);
	
	    if ( // Ignore the scroll children if the element is absolute positioned.
	    style.getPropertyValue('position') === 'absolute' || // Ignore the scroll children if the element has an overflowX hidden
	    style.getPropertyValue('overflow-x') === 'hidden') {
	      domTreeShapes = [];
	    } else if (element.clientWidth > 0 && element.scrollWidth > element.clientWidth || element.clientHeight > 0 && element.scrollHeight > element.clientHeight) {
	      // Ignore the nodes that have no width.
	      // Keep elements with a scroll
	      domTreeShapes.push(element);
	    }
	
	    element = element.parentElement;
	  }
	
	  return domTreeShapes;
	}
	
	function findNativeHandler(_ref) {
	  var domTreeShapes = _ref.domTreeShapes,
	      start = _ref.start,
	      current = _ref.current,
	      anchor = _ref.anchor;
	  // Adapted from https://github.com/oliviertassinari/react-swipeable-views/blob/7666de1dba253b896911adf2790ce51467670856/packages/react-swipeable-views/src/SwipeableViews.js#L175
	  var axisProperties = {
	    scrollPosition: {
	      x: 'scrollLeft',
	      y: 'scrollTop'
	    },
	    scrollLength: {
	      x: 'scrollWidth',
	      y: 'scrollHeight'
	    },
	    clientLength: {
	      x: 'clientWidth',
	      y: 'clientHeight'
	    }
	  };
	  return domTreeShapes.some(function (shape) {
	    // Determine if we are going backward or forward.
	    var goingForward = current >= start;
	
	    if (anchor === 'top' || anchor === 'left') {
	      goingForward = !goingForward;
	    }
	
	    var axis = anchor === 'left' || anchor === 'right' ? 'x' : 'y';
	    var scrollPosition = shape[axisProperties.scrollPosition[axis]];
	    var areNotAtStart = scrollPosition > 0;
	    var areNotAtEnd = scrollPosition + shape[axisProperties.clientLength[axis]] < shape[axisProperties.scrollLength[axis]];
	
	    if (goingForward && areNotAtEnd || !goingForward && areNotAtStart) {
	      return shape;
	    }
	
	    return null;
	  });
	}
	
	var disableSwipeToOpenDefault = typeof navigator !== 'undefined' && /iPad|iPhone|iPod/.test(navigator.userAgent);
	var transitionDurationDefault = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var SwipeableDrawer = React.forwardRef(function SwipeableDrawer(inProps, ref) {
	  var theme = (0, _useTheme.default)();
	  var props = (0, _styles.getThemeProps)({
	    name: 'MuiSwipeableDrawer',
	    props: (0, _extends2.default)({}, inProps),
	    theme: theme
	  });
	  var _props$anchor = props.anchor,
	      anchor = _props$anchor === void 0 ? 'left' : _props$anchor,
	      _props$disableBackdro = props.disableBackdropTransition,
	      disableBackdropTransition = _props$disableBackdro === void 0 ? false : _props$disableBackdro,
	      _props$disableDiscove = props.disableDiscovery,
	      disableDiscovery = _props$disableDiscove === void 0 ? false : _props$disableDiscove,
	      _props$disableSwipeTo = props.disableSwipeToOpen,
	      disableSwipeToOpen = _props$disableSwipeTo === void 0 ? disableSwipeToOpenDefault : _props$disableSwipeTo,
	      hideBackdrop = props.hideBackdrop,
	      _props$hysteresis = props.hysteresis,
	      hysteresis = _props$hysteresis === void 0 ? 0.52 : _props$hysteresis,
	      _props$minFlingVeloci = props.minFlingVelocity,
	      minFlingVelocity = _props$minFlingVeloci === void 0 ? 450 : _props$minFlingVeloci,
	      _props$ModalProps = props.ModalProps;
	  _props$ModalProps = _props$ModalProps === void 0 ? {} : _props$ModalProps;
	  var BackdropProps = _props$ModalProps.BackdropProps,
	      ModalPropsProp = (0, _objectWithoutProperties2.default)(_props$ModalProps, ["BackdropProps"]),
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      open = props.open,
	      _props$PaperProps = props.PaperProps,
	      PaperProps = _props$PaperProps === void 0 ? {} : _props$PaperProps,
	      SwipeAreaProps = props.SwipeAreaProps,
	      _props$swipeAreaWidth = props.swipeAreaWidth,
	      swipeAreaWidth = _props$swipeAreaWidth === void 0 ? 20 : _props$swipeAreaWidth,
	      _props$transitionDura = props.transitionDuration,
	      transitionDuration = _props$transitionDura === void 0 ? transitionDurationDefault : _props$transitionDura,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'temporary' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchor", "disableBackdropTransition", "disableDiscovery", "disableSwipeToOpen", "hideBackdrop", "hysteresis", "minFlingVelocity", "ModalProps", "onClose", "onOpen", "open", "PaperProps", "SwipeAreaProps", "swipeAreaWidth", "transitionDuration", "variant"]);
	
	  var _React$useState = React.useState(false),
	      maybeSwiping = _React$useState[0],
	      setMaybeSwiping = _React$useState[1];
	
	  var swipeInstance = React.useRef({
	    isSwiping: null
	  });
	  var swipeAreaRef = React.useRef();
	  var backdropRef = React.useRef();
	  var paperRef = React.useRef();
	  var touchDetected = React.useRef(false); // Ref for transition duration based on / to match swipe speed
	
	  var calculatedDurationRef = React.useRef(); // Use a ref so the open value used is always up to date inside useCallback.
	
	  useEnhancedEffect(function () {
	    calculatedDurationRef.current = null;
	  }, [open]);
	  var setPosition = React.useCallback(function (translate) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var _options$mode = options.mode,
	        mode = _options$mode === void 0 ? null : _options$mode,
	        _options$changeTransi = options.changeTransition,
	        changeTransition = _options$changeTransi === void 0 ? true : _options$changeTransi;
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var rtlTranslateMultiplier = ['right', 'bottom'].indexOf(anchorRtl) !== -1 ? 1 : -1;
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var transform = horizontalSwipe ? "translate(".concat(rtlTranslateMultiplier * translate, "px, 0)") : "translate(0, ".concat(rtlTranslateMultiplier * translate, "px)");
	    var drawerStyle = paperRef.current.style;
	    drawerStyle.webkitTransform = transform;
	    drawerStyle.transform = transform;
	    var transition = '';
	
	    if (mode) {
	      transition = theme.transitions.create('all', (0, _utils2.getTransitionProps)({
	        timeout: transitionDuration
	      }, {
	        mode: mode
	      }));
	    }
	
	    if (changeTransition) {
	      drawerStyle.webkitTransition = transition;
	      drawerStyle.transition = transition;
	    }
	
	    if (!disableBackdropTransition && !hideBackdrop) {
	      var backdropStyle = backdropRef.current.style;
	      backdropStyle.opacity = 1 - translate / getMaxTranslate(horizontalSwipe, paperRef.current);
	
	      if (changeTransition) {
	        backdropStyle.webkitTransition = transition;
	        backdropStyle.transition = transition;
	      }
	    }
	  }, [anchor, disableBackdropTransition, hideBackdrop, theme, transitionDuration]);
	  var handleBodyTouchEnd = (0, _useEventCallback.default)(function (event) {
	    if (!touchDetected.current) {
	      return;
	    }
	
	    nodeThatClaimedTheSwipe = null;
	    touchDetected.current = false;
	    setMaybeSwiping(false); // The swipe wasn't started.
	
	    if (!swipeInstance.current.isSwiping) {
	      swipeInstance.current.isSwiping = null;
	      return;
	    }
	
	    swipeInstance.current.isSwiping = null;
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontal = (0, _Drawer.isHorizontal)(anchor);
	    var current;
	
	    if (horizontal) {
	      current = calculateCurrentX(anchorRtl, event.changedTouches);
	    } else {
	      current = calculateCurrentY(anchorRtl, event.changedTouches);
	    }
	
	    var startLocation = horizontal ? swipeInstance.current.startX : swipeInstance.current.startY;
	    var maxTranslate = getMaxTranslate(horizontal, paperRef.current);
	    var currentTranslate = getTranslate(current, startLocation, open, maxTranslate);
	    var translateRatio = currentTranslate / maxTranslate;
	
	    if (Math.abs(swipeInstance.current.velocity) > minFlingVelocity) {
	      // Calculate transition duration to match swipe speed
	      calculatedDurationRef.current = Math.abs((maxTranslate - currentTranslate) / swipeInstance.current.velocity) * 1000;
	    }
	
	    if (open) {
	      if (swipeInstance.current.velocity > minFlingVelocity || translateRatio > hysteresis) {
	        onClose();
	      } else {
	        // Reset the position, the swipe was aborted.
	        setPosition(0, {
	          mode: 'exit'
	        });
	      }
	
	      return;
	    }
	
	    if (swipeInstance.current.velocity < -minFlingVelocity || 1 - translateRatio > hysteresis) {
	      onOpen();
	    } else {
	      // Reset the position, the swipe was aborted.
	      setPosition(getMaxTranslate(horizontal, paperRef.current), {
	        mode: 'enter'
	      });
	    }
	  });
	  var handleBodyTouchMove = (0, _useEventCallback.default)(function (event) {
	    // the ref may be null when a parent component updates while swiping
	    if (!paperRef.current || !touchDetected.current) {
	      return;
	    } // We are not supposed to handle this touch move because the swipe was started in a scrollable container in the drawer
	
	
	    if (nodeThatClaimedTheSwipe != null && nodeThatClaimedTheSwipe !== swipeInstance.current) {
	      return;
	    }
	
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var currentX = calculateCurrentX(anchorRtl, event.touches);
	    var currentY = calculateCurrentY(anchorRtl, event.touches);
	
	    if (open && paperRef.current.contains(event.target) && nodeThatClaimedTheSwipe == null) {
	      var domTreeShapes = getDomTreeShapes(event.target, paperRef.current);
	      var nativeHandler = findNativeHandler({
	        domTreeShapes: domTreeShapes,
	        start: horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY,
	        current: horizontalSwipe ? currentX : currentY,
	        anchor: anchor
	      });
	
	      if (nativeHandler) {
	        nodeThatClaimedTheSwipe = nativeHandler;
	        return;
	      }
	
	      nodeThatClaimedTheSwipe = swipeInstance.current;
	    } // We don't know yet.
	
	
	    if (swipeInstance.current.isSwiping == null) {
	      var dx = Math.abs(currentX - swipeInstance.current.startX);
	      var dy = Math.abs(currentY - swipeInstance.current.startY); // We are likely to be swiping, let's prevent the scroll event on iOS.
	
	      if (dx > dy) {
	        if (event.cancelable) {
	          event.preventDefault();
	        }
	      }
	
	      var definitelySwiping = horizontalSwipe ? dx > dy && dx > UNCERTAINTY_THRESHOLD : dy > dx && dy > UNCERTAINTY_THRESHOLD;
	
	      if (definitelySwiping === true || (horizontalSwipe ? dy > UNCERTAINTY_THRESHOLD : dx > UNCERTAINTY_THRESHOLD)) {
	        swipeInstance.current.isSwiping = definitelySwiping;
	
	        if (!definitelySwiping) {
	          handleBodyTouchEnd(event);
	          return;
	        } // Shift the starting point.
	
	
	        swipeInstance.current.startX = currentX;
	        swipeInstance.current.startY = currentY; // Compensate for the part of the drawer displayed on touch start.
	
	        if (!disableDiscovery && !open) {
	          if (horizontalSwipe) {
	            swipeInstance.current.startX -= swipeAreaWidth;
	          } else {
	            swipeInstance.current.startY -= swipeAreaWidth;
	          }
	        }
	      }
	    }
	
	    if (!swipeInstance.current.isSwiping) {
	      return;
	    }
	
	    var maxTranslate = getMaxTranslate(horizontalSwipe, paperRef.current);
	    var startLocation = horizontalSwipe ? swipeInstance.current.startX : swipeInstance.current.startY;
	
	    if (open && !swipeInstance.current.paperHit) {
	      startLocation = Math.min(startLocation, maxTranslate);
	    }
	
	    var translate = getTranslate(horizontalSwipe ? currentX : currentY, startLocation, open, maxTranslate);
	
	    if (open) {
	      if (!swipeInstance.current.paperHit) {
	        var paperHit = horizontalSwipe ? currentX < maxTranslate : currentY < maxTranslate;
	
	        if (paperHit) {
	          swipeInstance.current.paperHit = true;
	          swipeInstance.current.startX = currentX;
	          swipeInstance.current.startY = currentY;
	        } else {
	          return;
	        }
	      } else if (translate === 0) {
	        swipeInstance.current.startX = currentX;
	        swipeInstance.current.startY = currentY;
	      }
	    }
	
	    if (swipeInstance.current.lastTranslate === null) {
	      swipeInstance.current.lastTranslate = translate;
	      swipeInstance.current.lastTime = performance.now() + 1;
	    }
	
	    var velocity = (translate - swipeInstance.current.lastTranslate) / (performance.now() - swipeInstance.current.lastTime) * 1e3; // Low Pass filter.
	
	    swipeInstance.current.velocity = swipeInstance.current.velocity * 0.4 + velocity * 0.6;
	    swipeInstance.current.lastTranslate = translate;
	    swipeInstance.current.lastTime = performance.now(); // We are swiping, let's prevent the scroll event on iOS.
	
	    if (event.cancelable) {
	      event.preventDefault();
	    }
	
	    setPosition(translate);
	  });
	  var handleBodyTouchStart = (0, _useEventCallback.default)(function (event) {
	    // We are not supposed to handle this touch move.
	    // Example of use case: ignore the event if there is a Slider.
	    if (event.defaultPrevented) {
	      return;
	    } // We can only have one node at the time claiming ownership for handling the swipe.
	
	
	    if (event.muiHandled) {
	      return;
	    } // At least one element clogs the drawer interaction zone.
	
	
	    if (open && !backdropRef.current.contains(event.target) && !paperRef.current.contains(event.target)) {
	      return;
	    }
	
	    var anchorRtl = (0, _Drawer.getAnchor)(theme, anchor);
	    var horizontalSwipe = (0, _Drawer.isHorizontal)(anchor);
	    var currentX = calculateCurrentX(anchorRtl, event.touches);
	    var currentY = calculateCurrentY(anchorRtl, event.touches);
	
	    if (!open) {
	      if (disableSwipeToOpen || event.target !== swipeAreaRef.current) {
	        return;
	      }
	
	      if (horizontalSwipe) {
	        if (currentX > swipeAreaWidth) {
	          return;
	        }
	      } else if (currentY > swipeAreaWidth) {
	        return;
	      }
	    }
	
	    event.muiHandled = true;
	    nodeThatClaimedTheSwipe = null;
	    swipeInstance.current.startX = currentX;
	    swipeInstance.current.startY = currentY;
	    setMaybeSwiping(true);
	
	    if (!open && paperRef.current) {
	      // The ref may be null when a parent component updates while swiping.
	      setPosition(getMaxTranslate(horizontalSwipe, paperRef.current) + (disableDiscovery ? 20 : -swipeAreaWidth), {
	        changeTransition: false
	      });
	    }
	
	    swipeInstance.current.velocity = 0;
	    swipeInstance.current.lastTime = null;
	    swipeInstance.current.lastTranslate = null;
	    swipeInstance.current.paperHit = false;
	    touchDetected.current = true;
	  });
	  React.useEffect(function () {
	    if (variant === 'temporary') {
	      var doc = (0, _ownerDocument.default)(paperRef.current);
	      doc.addEventListener('touchstart', handleBodyTouchStart);
	      doc.addEventListener('touchmove', handleBodyTouchMove, {
	        passive: false
	      });
	      doc.addEventListener('touchend', handleBodyTouchEnd);
	      return function () {
	        doc.removeEventListener('touchstart', handleBodyTouchStart);
	        doc.removeEventListener('touchmove', handleBodyTouchMove, {
	          passive: false
	        });
	        doc.removeEventListener('touchend', handleBodyTouchEnd);
	      };
	    }
	
	    return undefined;
	  }, [variant, handleBodyTouchStart, handleBodyTouchMove, handleBodyTouchEnd]);
	  React.useEffect(function () {
	    return function () {
	      // We need to release the lock.
	      if (nodeThatClaimedTheSwipe === swipeInstance.current) {
	        nodeThatClaimedTheSwipe = null;
	      }
	    };
	  }, []);
	  React.useEffect(function () {
	    if (!open) {
	      setMaybeSwiping(false);
	    }
	  }, [open]);
	  var handleBackdropRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    backdropRef.current = ReactDOM.findDOMNode(instance);
	  }, []);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement(_Drawer.default, (0, _extends2.default)({
	    open: variant === 'temporary' && maybeSwiping ? true : open,
	    variant: variant,
	    ModalProps: (0, _extends2.default)({
	      BackdropProps: (0, _extends2.default)({}, BackdropProps, {
	        ref: handleBackdropRef
	      })
	    }, ModalPropsProp),
	    PaperProps: (0, _extends2.default)({}, PaperProps, {
	      style: (0, _extends2.default)({
	        pointerEvents: variant === 'temporary' && !open ? 'none' : ''
	      }, PaperProps.style),
	      ref: paperRef
	    }),
	    anchor: anchor,
	    transitionDuration: calculatedDurationRef.current || transitionDuration,
	    onClose: onClose,
	    ref: ref
	  }, other)), !disableSwipeToOpen && variant === 'temporary' && /*#__PURE__*/React.createElement(_NoSsr.default, null, /*#__PURE__*/React.createElement(_SwipeArea.default, (0, _extends2.default)({
	    anchor: anchor,
	    ref: swipeAreaRef,
	    width: swipeAreaWidth
	  }, SwipeAreaProps))));
	});
	 false ? SwipeableDrawer.propTypes = {
	  /**
	   * @ignore
	   */
	  anchor: _propTypes.default.oneOf(['left', 'top', 'right', 'bottom']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Disable the backdrop transition.
	   * This can improve the FPS on low-end devices.
	   */
	  disableBackdropTransition: _propTypes.default.bool,
	
	  /**
	   * If `true`, touching the screen near the edge of the drawer will not slide in the drawer a bit
	   * to promote accidental discovery of the swipe gesture.
	   */
	  disableDiscovery: _propTypes.default.bool,
	
	  /**
	   * If `true`, swipe to open is disabled. This is useful in browsers where swiping triggers
	   * navigation actions. Swipe to open is disabled on iOS browsers by default.
	   */
	  disableSwipeToOpen: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  hideBackdrop: _propTypes.default.bool,
	
	  /**
	   * Affects how far the drawer must be opened/closed to change his state.
	   * Specified as percent (0-1) of the width of the drawer
	   */
	  hysteresis: _propTypes.default.number,
	
	  /**
	   * Defines, from which (average) velocity on, the swipe is
	   * defined as complete although hysteresis isn't reached.
	   * Good threshold is between 250 - 1000 px/s
	   */
	  minFlingVelocity: _propTypes.default.number,
	
	  /**
	   * @ignore
	   */
	  ModalProps: _propTypes.default.shape({
	    BackdropProps: _propTypes.default.shape({
	      component: _utils.elementTypeAcceptingRef
	    })
	  }),
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the component requests to be opened.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func.isRequired,
	
	  /**
	   * If `true`, the drawer is open.
	   */
	  open: _propTypes.default.bool.isRequired,
	
	  /**
	   * @ignore
	   */
	  PaperProps: _propTypes.default.shape({
	    component: _utils.elementTypeAcceptingRef,
	    style: _propTypes.default.object
	  }),
	
	  /**
	   * The element is used to intercept the touch events on the edge.
	   */
	  SwipeAreaProps: _propTypes.default.object,
	
	  /**
	   * The width of the left most (or right most) area in pixels where the
	   * drawer can be swiped open from.
	   */
	  swipeAreaWidth: _propTypes.default.number,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  transitionDuration: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })]),
	
	  /**
	   * @ignore
	   */
	  variant: _propTypes.default.oneOf(['permanent', 'persistent', 'temporary'])
	} : void 0;
	var _default = SwipeableDrawer;
	exports.default = _default;

/***/ },
/* 374 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _SwipeableDrawer.default;
	  }
	});
	
	var _SwipeableDrawer = _interopRequireDefault(__webpack_require__(373));

/***/ },
/* 375 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _SwitchBase = _interopRequireDefault(__webpack_require__(88));
	
	// @inheritedComponent IconButton
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'inline-flex',
	      width: 34 + 12 * 2,
	      height: 14 + 12 * 2,
	      overflow: 'hidden',
	      padding: 12,
	      boxSizing: 'border-box',
	      position: 'relative',
	      flexShrink: 0,
	      zIndex: 0,
	      // Reset the stacking context.
	      verticalAlign: 'middle' // For correct alignment with the text.
	
	    },
	
	    /* Styles applied to the root element if `edge="start"`. */
	    edgeStart: {
	      marginLeft: -8
	    },
	
	    /* Styles applied to the root element if `edge="end"`. */
	    edgeEnd: {
	      marginRight: -8
	    },
	
	    /* Styles applied to the internal `SwitchBase` component's `root` class. */
	    switchBase: {
	      position: 'absolute',
	      top: 0,
	      left: 0,
	      zIndex: 1,
	      // Render above the focus ripple.
	      color: theme.palette.type === 'light' ? theme.palette.grey[50] : theme.palette.grey[400],
	      transition: theme.transitions.create(['left', 'transform'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      '&$checked': {
	        transform: 'translateX(20px)'
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        opacity: 0.5
	      },
	      '&$disabled + $track': {
	        opacity: theme.palette.type === 'light' ? 0.12 : 0.1
	      }
	    },
	
	    /* Styles applied to the internal SwitchBase component's root element if `color="primary"`. */
	    colorPrimary: {
	      '&$checked': {
	        color: theme.palette.primary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.primary.main, theme.palette.action.hoverOpacity),
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        backgroundColor: theme.palette.primary.main
	      },
	      '&$disabled + $track': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	      }
	    },
	
	    /* Styles applied to the internal SwitchBase component's root element if `color="secondary"`. */
	    colorSecondary: {
	      '&$checked': {
	        color: theme.palette.secondary.main,
	        '&:hover': {
	          backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.hoverOpacity),
	          '@media (hover: none)': {
	            backgroundColor: 'transparent'
	          }
	        }
	      },
	      '&$disabled': {
	        color: theme.palette.type === 'light' ? theme.palette.grey[400] : theme.palette.grey[800]
	      },
	      '&$checked + $track': {
	        backgroundColor: theme.palette.secondary.main
	      },
	      '&$disabled + $track': {
	        backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white
	      }
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      width: 40,
	      height: 24,
	      padding: 7,
	      '& $thumb': {
	        width: 16,
	        height: 16
	      },
	      '& $switchBase': {
	        padding: 4,
	        '&$checked': {
	          transform: 'translateX(16px)'
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the internal `SwitchBase` component's `checked` class. */
	    checked: {},
	
	    /* Pseudo-class applied to the internal SwitchBase component's disabled class. */
	    disabled: {},
	
	    /* Styles applied to the internal SwitchBase component's input element. */
	    input: {
	      left: '-100%',
	      width: '300%'
	    },
	
	    /* Styles used to create the thumb passed to the internal `SwitchBase` component `icon` prop. */
	    thumb: {
	      boxShadow: theme.shadows[1],
	      backgroundColor: 'currentColor',
	      width: 20,
	      height: 20,
	      borderRadius: '50%'
	    },
	
	    /* Styles applied to the track element. */
	    track: {
	      height: '100%',
	      width: '100%',
	      borderRadius: 14 / 2,
	      zIndex: -1,
	      transition: theme.transitions.create(['opacity', 'background-color'], {
	        duration: theme.transitions.duration.shortest
	      }),
	      backgroundColor: theme.palette.type === 'light' ? theme.palette.common.black : theme.palette.common.white,
	      opacity: theme.palette.type === 'light' ? 0.38 : 0.3
	    }
	  };
	};
	
	exports.styles = styles;
	var Switch = React.forwardRef(function Switch(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'secondary' : _props$color,
	      _props$edge = props.edge,
	      edge = _props$edge === void 0 ? false : _props$edge,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "edge", "size"]);
	  var icon = /*#__PURE__*/React.createElement("span", {
	    className: classes.thumb
	  });
	  return /*#__PURE__*/React.createElement("span", {
	    className: (0, _clsx.default)(classes.root, className, {
	      'start': classes.edgeStart,
	      'end': classes.edgeEnd
	    }[edge], size === "small" && classes["size".concat((0, _capitalize.default)(size))])
	  }, /*#__PURE__*/React.createElement(_SwitchBase.default, (0, _extends2.default)({
	    type: "checkbox",
	    icon: icon,
	    checkedIcon: icon,
	    classes: {
	      root: (0, _clsx.default)(classes.switchBase, classes["color".concat((0, _capitalize.default)(color))]),
	      input: classes.input,
	      checked: classes.checked,
	      disabled: classes.disabled
	    },
	    ref: ref
	  }, other)), /*#__PURE__*/React.createElement("span", {
	    className: classes.track
	  }));
	});
	 false ? Switch.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the component is checked.
	   */
	  checked: _propTypes.default.bool,
	
	  /**
	   * The icon to display when the component is checked.
	   */
	  checkedIcon: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['default', 'primary', 'secondary']),
	
	  /**
	   * @ignore
	   */
	  defaultChecked: _propTypes.default.bool,
	
	  /**
	   * If `true`, the switch will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * If given, uses a negative margin to counteract the padding on one
	   * side (this is often helpful for aligning the left or right
	   * side of the icon with content above or below, without ruining the border
	   * size and shape).
	   */
	  edge: _propTypes.default.oneOf(['end', 'start', false]),
	
	  /**
	   * The icon to display when the component is unchecked.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * The id of the `input` element.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * Callback fired when the state is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   * You can pull out the new checked state by accessing `event.target.checked` (boolean).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * If `true`, the `input` element will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * The size of the switch.
	   * `small` is equivalent to the dense switch styling.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the component. The DOM API casts this to a string.
	   * The browser uses "on" as the default value.
	   */
	  value: _propTypes.default.any
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiSwitch'
	})(Switch);
	
	exports.default = _default;

/***/ },
/* 376 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Switch.default;
	  }
	});
	
	var _Switch = _interopRequireDefault(__webpack_require__(375));

/***/ },
/* 377 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _unsupportedProp = _interopRequireDefault(__webpack_require__(67));
	
	var styles = function styles(theme) {
	  var _extends2;
	
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends3.default)({}, theme.typography.button, (_extends2 = {
	      maxWidth: 264,
	      minWidth: 72,
	      position: 'relative',
	      boxSizing: 'border-box',
	      minHeight: 48,
	      flexShrink: 0,
	      padding: '6px 12px'
	    }, (0, _defineProperty2.default)(_extends2, theme.breakpoints.up('sm'), {
	      padding: '6px 24px'
	    }), (0, _defineProperty2.default)(_extends2, "overflow", 'hidden'), (0, _defineProperty2.default)(_extends2, "whiteSpace", 'normal'), (0, _defineProperty2.default)(_extends2, "textAlign", 'center'), (0, _defineProperty2.default)(_extends2, theme.breakpoints.up('sm'), {
	      minWidth: 160
	    }), _extends2)),
	
	    /* Styles applied to the root element if both `icon` and `label` are provided. */
	    labelIcon: {
	      minHeight: 72,
	      paddingTop: 9,
	      '& $wrapper > *:first-child': {
	        marginBottom: 6
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="inherit"`. */
	    textColorInherit: {
	      color: 'inherit',
	      opacity: 0.7,
	      '&$selected': {
	        opacity: 1
	      },
	      '&$disabled': {
	        opacity: 0.5
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="primary"`. */
	    textColorPrimary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.primary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	
	    /* Styles applied to the root element if the parent [`Tabs`](/api/tabs/) has `textColor="secondary"`. */
	    textColorSecondary: {
	      color: theme.palette.text.secondary,
	      '&$selected': {
	        color: theme.palette.secondary.main
	      },
	      '&$disabled': {
	        color: theme.palette.text.disabled
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}` (controlled by the Tabs component). */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `disabled={true}` (controlled by the Tabs component). */
	    disabled: {},
	
	    /* Styles applied to the root element if `fullWidth={true}` (controlled by the Tabs component). */
	    fullWidth: {
	      flexShrink: 1,
	      flexGrow: 1,
	      flexBasis: 0,
	      maxWidth: 'none'
	    },
	
	    /* Styles applied to the root element if `wrapped={true}`. */
	    wrapped: {
	      fontSize: theme.typography.pxToRem(12),
	      lineHeight: 1.5
	    },
	
	    /* Styles applied to the `icon` and `label`'s wrapper element. */
	    wrapper: {
	      display: 'inline-flex',
	      alignItems: 'center',
	      justifyContent: 'center',
	      width: '100%',
	      flexDirection: 'column'
	    }
	  };
	};
	
	exports.styles = styles;
	var Tab = React.forwardRef(function Tab(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disableFocusRi = props.disableFocusRipple,
	      disableFocusRipple = _props$disableFocusRi === void 0 ? false : _props$disableFocusRi,
	      fullWidth = props.fullWidth,
	      icon = props.icon,
	      indicator = props.indicator,
	      label = props.label,
	      onChange = props.onChange,
	      onClick = props.onClick,
	      selected = props.selected,
	      _props$textColor = props.textColor,
	      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
	      value = props.value,
	      _props$wrapped = props.wrapped,
	      wrapped = _props$wrapped === void 0 ? false : _props$wrapped,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "disabled", "disableFocusRipple", "fullWidth", "icon", "indicator", "label", "onChange", "onClick", "selected", "textColor", "value", "wrapped"]);
	
	  var handleChange = function handleChange(event) {
	    if (onChange) {
	      onChange(event, value);
	    }
	
	    if (onClick) {
	      onClick(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends3.default)({
	    focusRipple: !disableFocusRipple,
	    className: (0, _clsx.default)(classes.root, classes["textColor".concat((0, _capitalize.default)(textColor))], className, disabled && classes.disabled, selected && classes.selected, label && icon && classes.labelIcon, fullWidth && classes.fullWidth, wrapped && classes.wrapped),
	    ref: ref,
	    role: "tab",
	    "aria-selected": selected,
	    disabled: disabled,
	    onClick: handleChange
	  }, other), /*#__PURE__*/React.createElement("span", {
	    className: classes.wrapper
	  }, icon, label), indicator);
	});
	 false ? Tab.propTypes = {
	  /**
	   * This prop isn't supported.
	   * Use the `component` prop if you need to change the children structure.
	   */
	  children: _unsupportedProp.default,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, the tab will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the  keyboard focus ripple will be disabled.
	   * `disableRipple` must also be true.
	   */
	  disableFocusRipple: _propTypes.default.bool,
	
	  /**
	   * If `true`, the ripple effect will be disabled.
	   */
	  disableRipple: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The icon element.
	   */
	  icon: _propTypes.default.node,
	
	  /**
	   * @ignore
	   * For server-side rendering consideration, we let the selected tab
	   * render the indicator.
	   */
	  indicator: _propTypes.default.node,
	
	  /**
	   * The label element.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onClick: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  selected: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),
	
	  /**
	   * You can provide your own value. Otherwise, we fallback to the child position index.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * Tab labels appear in a single row.
	   * They can use a second line if needed.
	   */
	  wrapped: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTab'
	})(Tab);
	
	exports.default = _default;

/***/ },
/* 378 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tab.default;
	  }
	});
	
	var _Tab = _interopRequireDefault(__webpack_require__(377));

/***/ },
/* 379 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _TableContext = _interopRequireDefault(__webpack_require__(139));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      display: 'table',
	      width: '100%',
	      borderCollapse: 'collapse',
	      borderSpacing: 0,
	      '& caption': (0, _extends2.default)({}, theme.typography.body2, {
	        padding: theme.spacing(2),
	        color: theme.palette.text.secondary,
	        textAlign: 'left',
	        captionSide: 'bottom'
	      })
	    },
	
	    /* Styles applied to the root element if `stickyHeader={true}`. */
	    stickyHeader: {
	      borderCollapse: 'separate'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultComponent = 'table';
	var Table = React.forwardRef(function Table(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      _props$padding = props.padding,
	      padding = _props$padding === void 0 ? 'default' : _props$padding,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      _props$stickyHeader = props.stickyHeader,
	      stickyHeader = _props$stickyHeader === void 0 ? false : _props$stickyHeader,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "padding", "size", "stickyHeader"]);
	  var table = React.useMemo(function () {
	    return {
	      padding: padding,
	      size: size,
	      stickyHeader: stickyHeader
	    };
	  }, [padding, size, stickyHeader]);
	  return /*#__PURE__*/React.createElement(_TableContext.default.Provider, {
	    value: table
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    role: Component === defaultComponent ? null : 'table',
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, stickyHeader && classes.stickyHeader)
	  }, other)));
	});
	 false ? Table.propTypes = {
	  /**
	   * The content of the table, normally `TableHead` and `TableBody`.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Allows TableCells to inherit padding of the Table.
	   */
	  padding: _propTypes.default.oneOf(['default', 'checkbox', 'none']),
	
	  /**
	   * Allows TableCells to inherit size of the Table.
	   */
	  size: _propTypes.default.oneOf(['small', 'medium']),
	
	  /**
	   * Set the header sticky.
	   *
	   * ⚠️ It doesn't work with IE 11.
	   */
	  stickyHeader: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTable'
	})(Table);
	
	exports.default = _default;

/***/ },
/* 380 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(52));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-row-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'body'
	};
	var defaultComponent = 'tbody';
	var TableBody = React.forwardRef(function TableBody(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableBody.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableBody'
	})(TableBody);
	
	exports.default = _default;

/***/ },
/* 381 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _colorManipulator = __webpack_require__(15);
	
	var _TableContext = _interopRequireDefault(__webpack_require__(139));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(52));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: (0, _extends2.default)({}, theme.typography.body2, {
	      display: 'table-cell',
	      verticalAlign: 'inherit',
	      // Workaround for a rendering bug with spanned columns in Chrome 62.0.
	      // Removes the alpha (sets it to 1), and lightens or darkens the theme color.
	      borderBottom: "1px solid\n    ".concat(theme.palette.type === 'light' ? (0, _colorManipulator.lighten)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.88) : (0, _colorManipulator.darken)((0, _colorManipulator.fade)(theme.palette.divider, 1), 0.68)),
	      textAlign: 'left',
	      padding: 16
	    }),
	
	    /* Styles applied to the root element if `variant="head"` or `context.table.head`. */
	    head: {
	      color: theme.palette.text.primary,
	      lineHeight: theme.typography.pxToRem(24),
	      fontWeight: theme.typography.fontWeightMedium
	    },
	
	    /* Styles applied to the root element if `variant="body"` or `context.table.body`. */
	    body: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `variant="footer"` or `context.table.footer`. */
	    footer: {
	      color: theme.palette.text.secondary,
	      lineHeight: theme.typography.pxToRem(21),
	      fontSize: theme.typography.pxToRem(12)
	    },
	
	    /* Styles applied to the root element if `size="small"`. */
	    sizeSmall: {
	      padding: '6px 24px 6px 16px',
	      '&:last-child': {
	        paddingRight: 16
	      },
	      '&$paddingCheckbox': {
	        width: 24,
	        // prevent the checkbox column from growing
	        padding: '0px 12px 0 16px',
	        '&:last-child': {
	          paddingLeft: 12,
	          paddingRight: 16
	        },
	        '& > *': {
	          padding: 0
	        }
	      }
	    },
	
	    /* Styles applied to the root element if `padding="checkbox"`. */
	    paddingCheckbox: {
	      width: 48,
	      // prevent the checkbox column from growing
	      padding: '0 0 0 4px',
	      '&:last-child': {
	        paddingLeft: 0,
	        paddingRight: 4
	      }
	    },
	
	    /* Styles applied to the root element if `padding="none"`. */
	    paddingNone: {
	      padding: 0,
	      '&:last-child': {
	        padding: 0
	      }
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right',
	      flexDirection: 'row-reverse'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `context.table.stickyHeader={true}`. */
	    stickyHeader: {
	      position: 'sticky',
	      top: 0,
	      left: 0,
	      zIndex: 2,
	      backgroundColor: theme.palette.background.default
	    }
	  };
	};
	/**
	 * The component renders a `<th>` element when the parent context is a header
	 * or otherwise a `<td>` element.
	 */
	
	
	exports.styles = styles;
	var TableCell = React.forwardRef(function TableCell(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      component = props.component,
	      paddingProp = props.padding,
	      scopeProp = props.scope,
	      sizeProp = props.size,
	      sortDirection = props.sortDirection,
	      variantProp = props.variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "component", "padding", "scope", "size", "sortDirection", "variant"]);
	  var table = React.useContext(_TableContext.default);
	  var tablelvl2 = React.useContext(_Tablelvl2Context.default);
	  var isHeadCell = tablelvl2 && tablelvl2.variant === 'head';
	  var role;
	  var Component;
	
	  if (component) {
	    Component = component;
	    role = isHeadCell ? 'columnheader' : 'cell';
	  } else {
	    Component = isHeadCell ? 'th' : 'td';
	  }
	
	  var scope = scopeProp;
	
	  if (!scope && isHeadCell) {
	    scope = 'col';
	  }
	
	  var padding = paddingProp || (table && table.padding ? table.padding : 'default');
	  var size = sizeProp || (table && table.size ? table.size : 'medium');
	  var variant = variantProp || tablelvl2 && tablelvl2.variant;
	  var ariaSort = null;
	
	  if (sortDirection) {
	    ariaSort = sortDirection === 'asc' ? 'ascending' : 'descending';
	  }
	
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, classes[variant], className, align !== 'inherit' && classes["align".concat((0, _capitalize.default)(align))], padding !== 'default' && classes["padding".concat((0, _capitalize.default)(padding))], size !== 'medium' && classes["size".concat((0, _capitalize.default)(size))], variant === 'head' && table && table.stickyHeader && classes.stickyHeader),
	    "aria-sort": ariaSort,
	    role: role,
	    scope: scope
	  }, other));
	});
	 false ? TableCell.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * Set the text-align on the table cell content.
	   *
	   * Monetary or generally number fields **should be right aligned** as that allows
	   * you to add them up quickly in your head without having to worry about decimals.
	   */
	  align: _propTypes.default.oneOf(['center', 'inherit', 'justify', 'left', 'right']),
	
	  /**
	   * The table cell contents.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Sets the padding applied to the cell.
	   * By default, the Table parent component set the value (`default`).
	   */
	  padding: _propTypes.default.oneOf(['checkbox', 'default', 'none']),
	
	  /**
	   * Set scope attribute.
	   */
	  scope: _propTypes.default.string,
	
	  /**
	   * Specify the size of the cell.
	   * By default, the Table parent component set the value (`medium`).
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * Set aria-sort direction.
	   */
	  sortDirection: _propTypes.default.oneOf(['asc', 'desc', false]),
	
	  /**
	   * Specify the cell type.
	   * By default, the TableHead, TableBody or TableFooter parent component set the value.
	   */
	  variant: _propTypes.default.oneOf(['body', 'footer', 'head'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableCell'
	})(TableCell);
	
	exports.default = _default;

/***/ },
/* 382 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    width: '100%',
	    overflowX: 'auto'
	  }
	};
	exports.styles = styles;
	var TableContainer = React.forwardRef(function TableContainer(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className)
	  }, other));
	});
	 false ? TableContainer.propTypes = {
	  /**
	   * The table itself, normally `<Table />`
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableContainer'
	})(TableContainer);
	
	exports.default = _default;

/***/ },
/* 383 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(52));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-footer-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'footer'
	};
	var defaultComponent = 'tfoot';
	var TableFooter = React.forwardRef(function TableFooter(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableFooter.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableFooter'
	})(TableFooter);
	
	exports.default = _default;

/***/ },
/* 384 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableFooter.default;
	  }
	});
	
	var _TableFooter = _interopRequireDefault(__webpack_require__(383));

/***/ },
/* 385 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(52));
	
	var styles = {
	  /* Styles applied to the root element. */
	  root: {
	    display: 'table-header-group'
	  }
	};
	exports.styles = styles;
	var tablelvl2 = {
	  variant: 'head'
	};
	var defaultComponent = 'thead';
	var TableHead = React.forwardRef(function TableHead(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component"]);
	  return /*#__PURE__*/React.createElement(_Tablelvl2Context.default.Provider, {
	    value: tablelvl2
	  }, /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    ref: ref,
	    role: Component === defaultComponent ? null : 'rowgroup'
	  }, other)));
	});
	 false ? TableHead.propTypes = {
	  /**
	   * The content of the component, normally `TableRow`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableHead'
	})(TableHead);
	
	exports.default = _default;

/***/ },
/* 386 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(9);
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _InputBase = _interopRequireDefault(__webpack_require__(49));
	
	var _MenuItem = _interopRequireDefault(__webpack_require__(126));
	
	var _Select = _interopRequireDefault(__webpack_require__(85));
	
	var _TableCell = _interopRequireDefault(__webpack_require__(86));
	
	var _Toolbar = _interopRequireDefault(__webpack_require__(147));
	
	var _Typography = _interopRequireDefault(__webpack_require__(24));
	
	var _TablePaginationActions = _interopRequireDefault(__webpack_require__(387));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: theme.palette.text.primary,
	      fontSize: theme.typography.pxToRem(14),
	      overflow: 'auto',
	      // Increase the specificity to override TableCell.
	      '&:last-child': {
	        padding: 0
	      }
	    },
	
	    /* Styles applied to the Toolbar component. */
	    toolbar: {
	      minHeight: 52,
	      paddingRight: 2
	    },
	
	    /* Styles applied to the spacer element. */
	    spacer: {
	      flex: '1 1 100%'
	    },
	
	    /* Styles applied to the caption Typography components if `variant="caption"`. */
	    caption: {
	      flexShrink: 0
	    },
	    // TODO v5: `.selectRoot` should be merged with `.input`
	
	    /* Styles applied to the Select component root element. */
	    selectRoot: {
	      marginRight: 32,
	      marginLeft: 8
	    },
	
	    /* Styles applied to the Select component `select` class. */
	    select: {
	      paddingLeft: 8,
	      paddingRight: 24,
	      textAlign: 'right',
	      textAlignLast: 'right' // Align <select> on Chrome.
	
	    },
	    // TODO v5: remove
	
	    /* Styles applied to the Select component `icon` class. */
	    selectIcon: {},
	
	    /* Styles applied to the `InputBase` component. */
	    input: {
	      color: 'inherit',
	      fontSize: 'inherit',
	      flexShrink: 0
	    },
	
	    /* Styles applied to the MenuItem component. */
	    menuItem: {},
	
	    /* Styles applied to the internal `TablePaginationActions` component. */
	    actions: {
	      flexShrink: 0,
	      marginLeft: 20
	    }
	  };
	};
	
	exports.styles = styles;
	
	var defaultLabelDisplayedRows = function defaultLabelDisplayedRows(_ref) {
	  var from = _ref.from,
	      to = _ref.to,
	      count = _ref.count;
	  return "".concat(from, "-").concat(to === -1 ? count : to, " of ").concat(count !== -1 ? count : "more than ".concat(to));
	};
	
	var defaultRowsPerPageOptions = [10, 25, 50, 100];
	/**
	 * A `TableCell` based component for placing inside `TableFooter` for pagination.
	 */
	
	var TablePagination = React.forwardRef(function TablePagination(props, ref) {
	  var _props$ActionsCompone = props.ActionsComponent,
	      ActionsComponent = _props$ActionsCompone === void 0 ? _TablePaginationActions.default : _props$ActionsCompone,
	      backIconButtonProps = props.backIconButtonProps,
	      _props$backIconButton = props.backIconButtonText,
	      backIconButtonText = _props$backIconButton === void 0 ? 'Previous page' : _props$backIconButton,
	      classes = props.classes,
	      className = props.className,
	      colSpanProp = props.colSpan,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? _TableCell.default : _props$component,
	      count = props.count,
	      _props$labelDisplayed = props.labelDisplayedRows,
	      labelDisplayedRows = _props$labelDisplayed === void 0 ? defaultLabelDisplayedRows : _props$labelDisplayed,
	      _props$labelRowsPerPa = props.labelRowsPerPage,
	      labelRowsPerPage = _props$labelRowsPerPa === void 0 ? 'Rows per page:' : _props$labelRowsPerPa,
	      nextIconButtonProps = props.nextIconButtonProps,
	      _props$nextIconButton = props.nextIconButtonText,
	      nextIconButtonText = _props$nextIconButton === void 0 ? 'Next page' : _props$nextIconButton,
	      onChangePage = props.onChangePage,
	      onChangeRowsPerPage = props.onChangeRowsPerPage,
	      page = props.page,
	      rowsPerPage = props.rowsPerPage,
	      _props$rowsPerPageOpt = props.rowsPerPageOptions,
	      rowsPerPageOptions = _props$rowsPerPageOpt === void 0 ? defaultRowsPerPageOptions : _props$rowsPerPageOpt,
	      _props$SelectProps = props.SelectProps,
	      SelectProps = _props$SelectProps === void 0 ? {} : _props$SelectProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["ActionsComponent", "backIconButtonProps", "backIconButtonText", "classes", "className", "colSpan", "component", "count", "labelDisplayedRows", "labelRowsPerPage", "nextIconButtonProps", "nextIconButtonText", "onChangePage", "onChangeRowsPerPage", "page", "rowsPerPage", "rowsPerPageOptions", "SelectProps"]);
	  var colSpan;
	
	  if (Component === _TableCell.default || Component === 'td') {
	    colSpan = colSpanProp || 1000; // col-span over everything
	  }
	
	  var MenuItemComponent = SelectProps.native ? 'option' : _MenuItem.default;
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    colSpan: colSpan,
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(_Toolbar.default, {
	    className: classes.toolbar
	  }, /*#__PURE__*/React.createElement("div", {
	    className: classes.spacer
	  }), rowsPerPageOptions.length > 1 && /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "inherit",
	    variant: "body2",
	    className: classes.caption
	  }, labelRowsPerPage), rowsPerPageOptions.length > 1 && /*#__PURE__*/React.createElement(_Select.default, (0, _extends2.default)({
	    classes: {
	      select: classes.select,
	      icon: classes.selectIcon
	    },
	    input: /*#__PURE__*/React.createElement(_InputBase.default, {
	      className: (0, _clsx.default)(classes.input, classes.selectRoot)
	    }),
	    value: rowsPerPage,
	    onChange: onChangeRowsPerPage,
	    inputProps: {
	      'aria-label': labelRowsPerPage
	    }
	  }, SelectProps), rowsPerPageOptions.map(function (rowsPerPageOption) {
	    return /*#__PURE__*/React.createElement(MenuItemComponent, {
	      className: classes.menuItem,
	      key: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption,
	      value: rowsPerPageOption.value ? rowsPerPageOption.value : rowsPerPageOption
	    }, rowsPerPageOption.label ? rowsPerPageOption.label : rowsPerPageOption);
	  })), /*#__PURE__*/React.createElement(_Typography.default, {
	    color: "inherit",
	    variant: "body2",
	    className: classes.caption
	  }, labelDisplayedRows({
	    from: count === 0 ? 0 : page * rowsPerPage + 1,
	    to: count !== -1 ? Math.min(count, (page + 1) * rowsPerPage) : (page + 1) * rowsPerPage,
	    count: count,
	    page: page
	  })), /*#__PURE__*/React.createElement(ActionsComponent, {
	    className: classes.actions,
	    backIconButtonProps: (0, _extends2.default)({
	      title: backIconButtonText,
	      'aria-label': backIconButtonText
	    }, backIconButtonProps),
	    count: count,
	    nextIconButtonProps: (0, _extends2.default)({
	      title: nextIconButtonText,
	      'aria-label': nextIconButtonText
	    }, nextIconButtonProps),
	    onChangePage: onChangePage,
	    page: page,
	    rowsPerPage: rowsPerPage
	  })));
	});
	 false ? TablePagination.propTypes = {
	  /**
	   * The component used for displaying the actions.
	   * Either a string to use a DOM element or a component.
	   */
	  ActionsComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the back arrow [`IconButton`](/api/icon-button/) component.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Text label for the back arrow icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  backIconButtonText: _propTypes.default.string,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  colSpan: _propTypes.default.number,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * The total number of rows.
	   *
	   * To enable server side pagination for an unknown number of items, provide -1.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Customize the displayed rows label. Invoked with a `{ from, to, count, page }`
	   * object.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  labelDisplayedRows: _propTypes.default.func,
	
	  /**
	   * Customize the rows per page label.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  labelRowsPerPage: _propTypes.default.node,
	
	  /**
	   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Text label for the next arrow icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  nextIconButtonText: _propTypes.default.string,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * Callback fired when the number of rows per page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onChangeRowsPerPage: _propTypes.default.func,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: (0, _utils.chainPropTypes)(_propTypes.default.number.isRequired, function (props) {
	    var count = props.count,
	        page = props.page,
	        rowsPerPage = props.rowsPerPage;
	
	    if (count === -1) {
	      return null;
	    }
	
	    var newLastPage = Math.max(0, Math.ceil(count / rowsPerPage) - 1);
	
	    if (page < 0 || page > newLastPage) {
	      return new Error('Material-UI: the page prop of a TablePagination is out of range ' + "(0 to ".concat(newLastPage, ", but page is ").concat(page, ")."));
	    }
	
	    return null;
	  }),
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired,
	
	  /**
	   * Customizes the options of the rows per page select field. If less than two options are
	   * available, no select field will be displayed.
	   */
	  rowsPerPageOptions: _propTypes.default.array,
	
	  /**
	   * Props applied to the rows per page [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTablePagination'
	})(TablePagination);
	
	exports.default = _default;

/***/ },
/* 387 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(157));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(158));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(48));
	
	var _ref = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, null);
	
	var _ref2 = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref3 = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, null);
	
	var _ref4 = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, null);
	
	/**
	 * @ignore - internal component.
	 */
	var TablePaginationActions = React.forwardRef(function TablePaginationActions(props, ref) {
	  var backIconButtonProps = props.backIconButtonProps,
	      count = props.count,
	      nextIconButtonProps = props.nextIconButtonProps,
	      onChangePage = props.onChangePage,
	      page = props.page,
	      rowsPerPage = props.rowsPerPage,
	      other = (0, _objectWithoutProperties2.default)(props, ["backIconButtonProps", "count", "nextIconButtonProps", "onChangePage", "page", "rowsPerPage"]);
	  var theme = (0, _useTheme.default)();
	
	  var handleBackButtonClick = function handleBackButtonClick(event) {
	    onChangePage(event, page - 1);
	  };
	
	  var handleNextButtonClick = function handleNextButtonClick(event) {
	    onChangePage(event, page + 1);
	  };
	
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: ref
	  }, other), /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    onClick: handleBackButtonClick,
	    disabled: page === 0,
	    color: "inherit"
	  }, backIconButtonProps), theme.direction === 'rtl' ? _ref : _ref2), /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({
	    onClick: handleNextButtonClick,
	    disabled: count !== -1 ? page >= Math.ceil(count / rowsPerPage) - 1 : false,
	    color: "inherit"
	  }, nextIconButtonProps), theme.direction === 'rtl' ? _ref3 : _ref4));
	});
	 false ? TablePaginationActions.propTypes = {
	  /**
	   * Props applied to the back arrow [`IconButton`](/api/icon-button/) element.
	   */
	  backIconButtonProps: _propTypes.default.object,
	
	  /**
	   * The total number of rows.
	   */
	  count: _propTypes.default.number.isRequired,
	
	  /**
	   * Props applied to the next arrow [`IconButton`](/api/icon-button/) element.
	   */
	  nextIconButtonProps: _propTypes.default.object,
	
	  /**
	   * Callback fired when the page is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {number} page The page selected.
	   */
	  onChangePage: _propTypes.default.func.isRequired,
	
	  /**
	   * The zero-based index of the current page.
	   */
	  page: _propTypes.default.number.isRequired,
	
	  /**
	   * The number of rows per page.
	   */
	  rowsPerPage: _propTypes.default.number.isRequired
	} : void 0;
	var _default = TablePaginationActions;
	exports.default = _default;

/***/ },
/* 388 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TablePagination.default;
	  }
	});
	
	var _TablePagination = _interopRequireDefault(__webpack_require__(386));

/***/ },
/* 389 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _Tablelvl2Context = _interopRequireDefault(__webpack_require__(52));
	
	var _colorManipulator = __webpack_require__(15);
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      color: 'inherit',
	      display: 'table-row',
	      verticalAlign: 'middle',
	      // We disable the focus ring for mouse, touch and keyboard users.
	      outline: 0,
	      '&$hover:hover': {
	        backgroundColor: theme.palette.action.hover
	      },
	      '&$selected, &$selected:hover': {
	        backgroundColor: (0, _colorManipulator.fade)(theme.palette.secondary.main, theme.palette.action.selectedOpacity)
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `selected={true}`. */
	    selected: {},
	
	    /* Pseudo-class applied to the root element if `hover={true}`. */
	    hover: {},
	
	    /* Styles applied to the root element if table variant="head". */
	    head: {},
	
	    /* Styles applied to the root element if table variant="footer". */
	    footer: {}
	  };
	};
	
	exports.styles = styles;
	var defaultComponent = 'tr';
	/**
	 * Will automatically set dynamic row height
	 * based on the material table element parent (head, body, etc).
	 */
	
	var TableRow = React.forwardRef(function TableRow(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? defaultComponent : _props$component,
	      _props$hover = props.hover,
	      hover = _props$hover === void 0 ? false : _props$hover,
	      _props$selected = props.selected,
	      selected = _props$selected === void 0 ? false : _props$selected,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "hover", "selected"]);
	  var tablelvl2 = React.useContext(_Tablelvl2Context.default);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, tablelvl2 && {
	      'head': classes.head,
	      'footer': classes.footer
	    }[tablelvl2.variant], hover && classes.hover, selected && classes.selected),
	    role: Component === defaultComponent ? null : 'row'
	  }, other));
	});
	 false ? TableRow.propTypes = {
	  /**
	   * Should be valid <tr> children such as `TableCell`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, the table row will shade on hover.
	   */
	  hover: _propTypes.default.bool,
	
	  /**
	   * If `true`, the table row will have the selected shading.
	   */
	  selected: _propTypes.default.bool
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableRow'
	})(TableRow);
	
	exports.default = _default;

/***/ },
/* 390 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _ArrowDownward = _interopRequireDefault(__webpack_require__(419));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      cursor: 'pointer',
	      display: 'inline-flex',
	      justifyContent: 'flex-start',
	      flexDirection: 'inherit',
	      alignItems: 'center',
	      '&:focus': {
	        color: theme.palette.text.secondary
	      },
	      '&:hover': {
	        color: theme.palette.text.secondary,
	        '& $icon': {
	          opacity: 0.5
	        }
	      },
	      '&$active': {
	        color: theme.palette.text.primary,
	        // && instead of & is a workaround for https://github.com/cssinjs/jss/issues/1045
	        '&& $icon': {
	          opacity: 1,
	          color: theme.palette.text.secondary
	        }
	      }
	    },
	
	    /* Pseudo-class applied to the root element if `active={true}`. */
	    active: {},
	
	    /* Styles applied to the icon component. */
	    icon: {
	      fontSize: 18,
	      marginRight: 4,
	      marginLeft: 4,
	      opacity: 0,
	      transition: theme.transitions.create(['opacity', 'transform'], {
	        duration: theme.transitions.duration.shorter
	      }),
	      userSelect: 'none'
	    },
	
	    /* Styles applied to the icon component if `direction="desc"`. */
	    iconDirectionDesc: {
	      transform: 'rotate(0deg)'
	    },
	
	    /* Styles applied to the icon component if `direction="asc"`. */
	    iconDirectionAsc: {
	      transform: 'rotate(180deg)'
	    }
	  };
	};
	/**
	 * A button based label for placing inside `TableCell` for column sorting.
	 */
	
	
	exports.styles = styles;
	var TableSortLabel = React.forwardRef(function TableSortLabel(props, ref) {
	  var _props$active = props.active,
	      active = _props$active === void 0 ? false : _props$active,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$direction = props.direction,
	      direction = _props$direction === void 0 ? 'asc' : _props$direction,
	      _props$hideSortIcon = props.hideSortIcon,
	      hideSortIcon = _props$hideSortIcon === void 0 ? false : _props$hideSortIcon,
	      _props$IconComponent = props.IconComponent,
	      IconComponent = _props$IconComponent === void 0 ? _ArrowDownward.default : _props$IconComponent,
	      other = (0, _objectWithoutProperties2.default)(props, ["active", "children", "classes", "className", "direction", "hideSortIcon", "IconComponent"]);
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, active && classes.active),
	    component: "span",
	    disableRipple: true,
	    ref: ref
	  }, other), children, hideSortIcon && !active ? null : /*#__PURE__*/React.createElement(IconComponent, {
	    className: (0, _clsx.default)(classes.icon, classes["iconDirection".concat((0, _capitalize.default)(direction))])
	  }));
	});
	 false ? TableSortLabel.propTypes = {
	  /**
	   * If `true`, the label will have the active styling (should be true for the sorted column).
	   */
	  active: _propTypes.default.bool,
	
	  /**
	   * Label contents, the arrow will be appended automatically.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The current sort direction.
	   */
	  direction: _propTypes.default.oneOf(['asc', 'desc']),
	
	  /**
	   * Hide sort icon when active is false.
	   */
	  hideSortIcon: _propTypes.default.bool,
	
	  /**
	   * Sort icon to use.
	   */
	  IconComponent: _propTypes.default.elementType
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTableSortLabel'
	})(TableSortLabel);
	
	exports.default = _default;

/***/ },
/* 391 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _TableSortLabel.default;
	  }
	});
	
	var _TableSortLabel = _interopRequireDefault(__webpack_require__(390));

/***/ },
/* 392 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = ScrollbarSize;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _debounce = _interopRequireDefault(__webpack_require__(37));
	
	var styles = {
	  width: 99,
	  height: 99,
	  position: 'absolute',
	  top: -9999,
	  overflow: 'scroll'
	};
	/**
	 * @ignore - internal component.
	 * The component is originates from https://github.com/STORIS/react-scrollbar-size.
	 * It has been moved into the core in order to minimize the bundle size.
	 */
	
	function ScrollbarSize(props) {
	  var onChange = props.onChange,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange"]);
	  var scrollbarHeight = React.useRef();
	  var nodeRef = React.useRef(null);
	
	  var setMeasurements = function setMeasurements() {
	    scrollbarHeight.current = nodeRef.current.offsetHeight - nodeRef.current.clientHeight;
	  };
	
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      var prevHeight = scrollbarHeight.current;
	      setMeasurements();
	
	      if (prevHeight !== scrollbarHeight.current) {
	        onChange(scrollbarHeight.current);
	      }
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [onChange]);
	  React.useEffect(function () {
	    setMeasurements();
	    onChange(scrollbarHeight.current);
	  }, [onChange]);
	  return /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    style: styles,
	    ref: nodeRef
	  }, other));
	}
	
	 false ? ScrollbarSize.propTypes = {
	  onChange: _propTypes.default.func.isRequired
	} : void 0;

/***/ },
/* 393 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    root: {
	      position: 'absolute',
	      height: 2,
	      bottom: 0,
	      width: '100%',
	      transition: theme.transitions.create()
	    },
	    colorPrimary: {
	      backgroundColor: theme.palette.primary.main
	    },
	    colorSecondary: {
	      backgroundColor: theme.palette.secondary.main
	    },
	    vertical: {
	      height: '100%',
	      width: 2,
	      right: 0
	    }
	  };
	};
	/**
	 * @ignore - internal component.
	 */
	
	
	exports.styles = styles;
	var TabIndicator = React.forwardRef(function TabIndicator(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      color = props.color,
	      orientation = props.orientation,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "color", "orientation"]);
	  return /*#__PURE__*/React.createElement("span", (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes["color".concat((0, _capitalize.default)(color))], className, orientation === 'vertical' && classes.vertical),
	    ref: ref
	  }, other));
	});
	 false ? TabIndicator.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   * The color of the tab indicator.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']).isRequired,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']).isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateTabIndicator'
	})(TabIndicator);
	
	exports.default = _default;

/***/ },
/* 394 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _KeyboardArrowLeft = _interopRequireDefault(__webpack_require__(157));
	
	var _KeyboardArrowRight = _interopRequireDefault(__webpack_require__(158));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _ButtonBase = _interopRequireDefault(__webpack_require__(19));
	
	/* eslint-disable jsx-a11y/aria-role */
	var styles = {
	  root: {
	    width: 40,
	    flexShrink: 0
	  },
	  vertical: {
	    width: '100%',
	    height: 40,
	    '& svg': {
	      transform: 'rotate(90deg)'
	    }
	  }
	};
	/**
	 * @ignore - internal component.
	 */
	
	exports.styles = styles;
	
	var _ref = /*#__PURE__*/React.createElement(_KeyboardArrowLeft.default, {
	  fontSize: "small"
	});
	
	var _ref2 = /*#__PURE__*/React.createElement(_KeyboardArrowRight.default, {
	  fontSize: "small"
	});
	
	var TabScrollButton = React.forwardRef(function TabScrollButton(props, ref) {
	  var classes = props.classes,
	      classNameProp = props.className,
	      direction = props.direction,
	      orientation = props.orientation,
	      visible = props.visible,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "direction", "orientation", "visible"]);
	  var className = (0, _clsx.default)(classes.root, classNameProp, orientation === 'vertical' && classes.vertical);
	
	  if (!visible) {
	    return /*#__PURE__*/React.createElement("div", {
	      className: className
	    });
	  }
	
	  return /*#__PURE__*/React.createElement(_ButtonBase.default, (0, _extends2.default)({
	    component: "div",
	    className: className,
	    ref: ref,
	    role: null,
	    tabIndex: null
	  }, other), direction === 'left' ? _ref : _ref2);
	});
	 false ? TabScrollButton.propTypes = {
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Which direction should the button indicate?
	   */
	  direction: _propTypes.default.oneOf(['left', 'right']).isRequired,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']).isRequired,
	
	  /**
	   * Should the button be present or just consume space.
	   */
	  visible: _propTypes.default.bool.isRequired
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'PrivateTabScrollButton'
	})(TabScrollButton);
	
	exports.default = _default;

/***/ },
/* 395 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _reactIs = __webpack_require__(18);
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _debounce = _interopRequireDefault(__webpack_require__(37));
	
	var _ownerWindow = _interopRequireDefault(__webpack_require__(56));
	
	var _scrollLeft = __webpack_require__(446);
	
	var _animate = _interopRequireDefault(__webpack_require__(418));
	
	var _ScrollbarSize = _interopRequireDefault(__webpack_require__(392));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _TabIndicator = _interopRequireDefault(__webpack_require__(393));
	
	var _TabScrollButton = _interopRequireDefault(__webpack_require__(394));
	
	var _useEventCallback = _interopRequireDefault(__webpack_require__(29));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      overflow: 'hidden',
	      minHeight: 48,
	      WebkitOverflowScrolling: 'touch',
	      // Add iOS momentum scrolling.
	      display: 'flex'
	    },
	
	    /* Styles applied to the root element if `orientation="vertical"`. */
	    vertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the flex container element. */
	    flexContainer: {
	      display: 'flex'
	    },
	
	    /* Styles applied to the flex container element if `orientation="vertical"`. */
	    flexContainerVertical: {
	      flexDirection: 'column'
	    },
	
	    /* Styles applied to the flex container element if `centered={true}` & `!variant="scrollable"`. */
	    centered: {
	      justifyContent: 'center'
	    },
	
	    /* Styles applied to the tablist element. */
	    scroller: {
	      position: 'relative',
	      display: 'inline-block',
	      flex: '1 1 auto',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the tablist element if `!variant="scrollable"`. */
	    fixed: {
	      overflowX: 'hidden',
	      width: '100%'
	    },
	
	    /* Styles applied to the tablist element if `variant="scrollable"`. */
	    scrollable: {
	      overflowX: 'scroll',
	      // Hide dimensionless scrollbar on MacOS
	      scrollbarWidth: 'none',
	      // Firefox
	      '&::-webkit-scrollbar': {
	        display: 'none' // Safari + Chrome
	
	      }
	    },
	
	    /* Styles applied to the `ScrollButtonComponent` component. */
	    scrollButtons: {},
	
	    /* Styles applied to the `ScrollButtonComponent` component if `scrollButtons="auto"` or scrollButtons="desktop"`. */
	    scrollButtonsDesktop: (0, _defineProperty2.default)({}, theme.breakpoints.down('xs'), {
	      display: 'none'
	    }),
	
	    /* Styles applied to the `TabIndicator` component. */
	    indicator: {}
	  };
	};
	
	exports.styles = styles;
	var Tabs = React.forwardRef(function Tabs(props, ref) {
	  var action = props.action,
	      _props$centered = props.centered,
	      centered = _props$centered === void 0 ? false : _props$centered,
	      childrenProp = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$indicatorColor = props.indicatorColor,
	      indicatorColor = _props$indicatorColor === void 0 ? 'secondary' : _props$indicatorColor,
	      onChange = props.onChange,
	      _props$orientation = props.orientation,
	      orientation = _props$orientation === void 0 ? 'horizontal' : _props$orientation,
	      _props$ScrollButtonCo = props.ScrollButtonComponent,
	      ScrollButtonComponent = _props$ScrollButtonCo === void 0 ? _TabScrollButton.default : _props$ScrollButtonCo,
	      _props$scrollButtons = props.scrollButtons,
	      scrollButtons = _props$scrollButtons === void 0 ? 'auto' : _props$scrollButtons,
	      _props$TabIndicatorPr = props.TabIndicatorProps,
	      TabIndicatorProps = _props$TabIndicatorPr === void 0 ? {} : _props$TabIndicatorPr,
	      _props$textColor = props.textColor,
	      textColor = _props$textColor === void 0 ? 'inherit' : _props$textColor,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["action", "centered", "children", "classes", "className", "component", "indicatorColor", "onChange", "orientation", "ScrollButtonComponent", "scrollButtons", "TabIndicatorProps", "textColor", "value", "variant"]);
	  var theme = (0, _useTheme.default)();
	  var scrollable = variant === 'scrollable';
	  var isRtl = theme.direction === 'rtl';
	  var vertical = orientation === 'vertical';
	  var scrollStart = vertical ? 'scrollTop' : 'scrollLeft';
	  var start = vertical ? 'top' : 'left';
	  var end = vertical ? 'bottom' : 'right';
	  var clientSize = vertical ? 'clientHeight' : 'clientWidth';
	  var size = vertical ? 'height' : 'width';
	
	  if (false) {
	    if (centered && scrollable) {
	      console.error('Material-UI: you can not use the `centered={true}` and `variant="scrollable"` properties ' + 'at the same time on a `Tabs` component.');
	    }
	  }
	
	  var _React$useState = React.useState(false),
	      mounted = _React$useState[0],
	      setMounted = _React$useState[1];
	
	  var _React$useState2 = React.useState({}),
	      indicatorStyle = _React$useState2[0],
	      setIndicatorStyle = _React$useState2[1];
	
	  var _React$useState3 = React.useState({
	    start: false,
	    end: false
	  }),
	      displayScroll = _React$useState3[0],
	      setDisplayScroll = _React$useState3[1];
	
	  var _React$useState4 = React.useState({
	    overflow: 'hidden',
	    marginBottom: null
	  }),
	      scrollerStyle = _React$useState4[0],
	      setScrollerStyle = _React$useState4[1];
	
	  var valueToIndex = new Map();
	  var tabsRef = React.useRef(null);
	  var childrenWrapperRef = React.useRef(null);
	
	  var getTabsMeta = function getTabsMeta() {
	    var tabsNode = tabsRef.current;
	    var tabsMeta;
	
	    if (tabsNode) {
	      var rect = tabsNode.getBoundingClientRect(); // create a new object with ClientRect class props + scrollLeft
	
	      tabsMeta = {
	        clientWidth: tabsNode.clientWidth,
	        scrollLeft: tabsNode.scrollLeft,
	        scrollTop: tabsNode.scrollTop,
	        scrollLeftNormalized: (0, _scrollLeft.getNormalizedScrollLeft)(tabsNode, theme.direction),
	        scrollWidth: tabsNode.scrollWidth,
	        top: rect.top,
	        bottom: rect.bottom,
	        left: rect.left,
	        right: rect.right
	      };
	    }
	
	    var tabMeta;
	
	    if (tabsNode && value !== false) {
	      var _children = childrenWrapperRef.current.children;
	
	      if (_children.length > 0) {
	        var tab = _children[valueToIndex.get(value)];
	
	        if (false) {
	          if (!tab) {
	            console.error(["Material-UI: the value provided to the Tabs component is invalid.", "None of the Tabs' children match with `".concat(value, "`."), valueToIndex.keys ? "You can provide one of the following values: ".concat(Array.from(valueToIndex.keys()).join(', '), ".") : null].join('\n'));
	          }
	        }
	
	        tabMeta = tab ? tab.getBoundingClientRect() : null;
	      }
	    }
	
	    return {
	      tabsMeta: tabsMeta,
	      tabMeta: tabMeta
	    };
	  };
	
	  var updateIndicatorState = (0, _useEventCallback.default)(function () {
	    var _newIndicatorStyle;
	
	    var _getTabsMeta = getTabsMeta(),
	        tabsMeta = _getTabsMeta.tabsMeta,
	        tabMeta = _getTabsMeta.tabMeta;
	
	    var startValue = 0;
	
	    if (tabMeta && tabsMeta) {
	      if (vertical) {
	        startValue = tabMeta.top - tabsMeta.top + tabsMeta.scrollTop;
	      } else {
	        var correction = isRtl ? tabsMeta.scrollLeftNormalized + tabsMeta.clientWidth - tabsMeta.scrollWidth : tabsMeta.scrollLeft;
	        startValue = tabMeta.left - tabsMeta.left + correction;
	      }
	    }
	
	    var newIndicatorStyle = (_newIndicatorStyle = {}, (0, _defineProperty2.default)(_newIndicatorStyle, start, startValue), (0, _defineProperty2.default)(_newIndicatorStyle, size, tabMeta ? tabMeta[size] : 0), _newIndicatorStyle);
	
	    if (isNaN(indicatorStyle[start]) || isNaN(indicatorStyle[size])) {
	      setIndicatorStyle(newIndicatorStyle);
	    } else {
	      var dStart = Math.abs(indicatorStyle[start] - newIndicatorStyle[start]);
	      var dSize = Math.abs(indicatorStyle[size] - newIndicatorStyle[size]);
	
	      if (dStart >= 1 || dSize >= 1) {
	        setIndicatorStyle(newIndicatorStyle);
	      }
	    }
	  });
	
	  var scroll = function scroll(scrollValue) {
	    (0, _animate.default)(scrollStart, tabsRef.current, scrollValue);
	  };
	
	  var moveTabsScroll = function moveTabsScroll(delta) {
	    var scrollValue = tabsRef.current[scrollStart];
	
	    if (vertical) {
	      scrollValue += delta;
	    } else {
	      scrollValue += delta * (isRtl ? -1 : 1); // Fix for Edge
	
	      scrollValue *= isRtl && (0, _scrollLeft.detectScrollType)() === 'reverse' ? -1 : 1;
	    }
	
	    scroll(scrollValue);
	  };
	
	  var handleStartScrollClick = function handleStartScrollClick() {
	    moveTabsScroll(-tabsRef.current[clientSize]);
	  };
	
	  var handleEndScrollClick = function handleEndScrollClick() {
	    moveTabsScroll(tabsRef.current[clientSize]);
	  };
	
	  var handleScrollbarSizeChange = React.useCallback(function (scrollbarHeight) {
	    setScrollerStyle({
	      overflow: null,
	      marginBottom: -scrollbarHeight
	    });
	  }, []);
	
	  var getConditionalElements = function getConditionalElements() {
	    var conditionalElements = {};
	    conditionalElements.scrollbarSizeListener = scrollable ? /*#__PURE__*/React.createElement(_ScrollbarSize.default, {
	      className: classes.scrollable,
	      onChange: handleScrollbarSizeChange
	    }) : null;
	    var scrollButtonsActive = displayScroll.start || displayScroll.end;
	    var showScrollButtons = scrollable && (scrollButtons === 'auto' && scrollButtonsActive || scrollButtons === 'desktop' || scrollButtons === 'on');
	    conditionalElements.scrollButtonStart = showScrollButtons ? /*#__PURE__*/React.createElement(ScrollButtonComponent, {
	      orientation: orientation,
	      direction: isRtl ? 'right' : 'left',
	      onClick: handleStartScrollClick,
	      visible: displayScroll.start,
	      className: (0, _clsx.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
	    }) : null;
	    conditionalElements.scrollButtonEnd = showScrollButtons ? /*#__PURE__*/React.createElement(ScrollButtonComponent, {
	      orientation: orientation,
	      direction: isRtl ? 'left' : 'right',
	      onClick: handleEndScrollClick,
	      visible: displayScroll.end,
	      className: (0, _clsx.default)(classes.scrollButtons, scrollButtons !== 'on' && classes.scrollButtonsDesktop)
	    }) : null;
	    return conditionalElements;
	  };
	
	  var scrollSelectedIntoView = (0, _useEventCallback.default)(function () {
	    var _getTabsMeta2 = getTabsMeta(),
	        tabsMeta = _getTabsMeta2.tabsMeta,
	        tabMeta = _getTabsMeta2.tabMeta;
	
	    if (!tabMeta || !tabsMeta) {
	      return;
	    }
	
	    if (tabMeta[start] < tabsMeta[start]) {
	      // left side of button is out of view
	      var nextScrollStart = tabsMeta[scrollStart] + (tabMeta[start] - tabsMeta[start]);
	      scroll(nextScrollStart);
	    } else if (tabMeta[end] > tabsMeta[end]) {
	      // right side of button is out of view
	      var _nextScrollStart = tabsMeta[scrollStart] + (tabMeta[end] - tabsMeta[end]);
	
	      scroll(_nextScrollStart);
	    }
	  });
	  var updateScrollButtonState = (0, _useEventCallback.default)(function () {
	    if (scrollable && scrollButtons !== 'off') {
	      var _tabsRef$current = tabsRef.current,
	          scrollTop = _tabsRef$current.scrollTop,
	          scrollHeight = _tabsRef$current.scrollHeight,
	          clientHeight = _tabsRef$current.clientHeight,
	          scrollWidth = _tabsRef$current.scrollWidth,
	          clientWidth = _tabsRef$current.clientWidth;
	      var showStartScroll;
	      var showEndScroll;
	
	      if (vertical) {
	        showStartScroll = scrollTop > 1;
	        showEndScroll = scrollTop < scrollHeight - clientHeight - 1;
	      } else {
	        var scrollLeft = (0, _scrollLeft.getNormalizedScrollLeft)(tabsRef.current, theme.direction); // use 1 for the potential rounding error with browser zooms.
	
	        showStartScroll = isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
	        showEndScroll = !isRtl ? scrollLeft < scrollWidth - clientWidth - 1 : scrollLeft > 1;
	      }
	
	      if (showStartScroll !== displayScroll.start || showEndScroll !== displayScroll.end) {
	        setDisplayScroll({
	          start: showStartScroll,
	          end: showEndScroll
	        });
	      }
	    }
	  });
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      updateIndicatorState();
	      updateScrollButtonState();
	    });
	    var win = (0, _ownerWindow.default)(tabsRef.current);
	    win.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      win.removeEventListener('resize', handleResize);
	    };
	  }, [updateIndicatorState, updateScrollButtonState]);
	  var handleTabsScroll = React.useCallback((0, _debounce.default)(function () {
	    updateScrollButtonState();
	  }));
	  React.useEffect(function () {
	    return function () {
	      handleTabsScroll.clear();
	    };
	  }, [handleTabsScroll]);
	  React.useEffect(function () {
	    setMounted(true);
	  }, []);
	  React.useEffect(function () {
	    updateIndicatorState();
	    updateScrollButtonState();
	  });
	  React.useEffect(function () {
	    scrollSelectedIntoView();
	  }, [scrollSelectedIntoView, indicatorStyle]);
	  React.useImperativeHandle(action, function () {
	    return {
	      updateIndicator: updateIndicatorState,
	      updateScrollButtons: updateScrollButtonState
	    };
	  }, [updateIndicatorState, updateScrollButtonState]);
	  var indicator = /*#__PURE__*/React.createElement(_TabIndicator.default, (0, _extends2.default)({
	    className: classes.indicator,
	    orientation: orientation,
	    color: indicatorColor
	  }, TabIndicatorProps, {
	    style: (0, _extends2.default)({}, indicatorStyle, {}, TabIndicatorProps.style)
	  }));
	  var childIndex = 0;
	  var children = React.Children.map(childrenProp, function (child) {
	    if (!React.isValidElement(child)) {
	      return null;
	    }
	
	    if (false) {
	      if ((0, _reactIs.isFragment)(child)) {
	        console.error(["Material-UI: the Tabs component doesn't accept a Fragment as a child.", 'Consider providing an array instead.'].join('\n'));
	      }
	    }
	
	    var childValue = child.props.value === undefined ? childIndex : child.props.value;
	    valueToIndex.set(childValue, childIndex);
	    var selected = childValue === value;
	    childIndex += 1;
	    return React.cloneElement(child, {
	      fullWidth: variant === 'fullWidth',
	      indicator: selected && !mounted && indicator,
	      selected: selected,
	      onChange: onChange,
	      textColor: textColor,
	      value: childValue
	    });
	  });
	  var conditionalElements = getConditionalElements();
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, vertical && classes.vertical),
	    ref: ref
	  }, other), conditionalElements.scrollButtonStart, conditionalElements.scrollbarSizeListener, /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.scroller, scrollable ? classes.scrollable : classes.fixed),
	    style: scrollerStyle,
	    ref: tabsRef,
	    onScroll: handleTabsScroll
	  }, /*#__PURE__*/React.createElement("div", {
	    className: (0, _clsx.default)(classes.flexContainer, vertical && classes.flexContainerVertical, centered && !scrollable && classes.centered),
	    ref: childrenWrapperRef,
	    role: "tablist"
	  }, children), mounted && indicator), conditionalElements.scrollButtonEnd);
	});
	 false ? Tabs.propTypes = {
	  /**
	   * Callback fired when the component mounts.
	   * This is useful when you want to trigger an action programmatically.
	   * It supports two actions: `updateIndicator()` and `updateScrollButtons()`
	   *
	   * @param {object} actions This object contains all possible actions
	   * that can be triggered programmatically.
	   */
	  action: _utils.refType,
	
	  /**
	   * If `true`, the tabs will be centered.
	   * This property is intended for large views.
	   */
	  centered: _propTypes.default.bool,
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Determines the color of the indicator.
	   */
	  indicatorColor: _propTypes.default.oneOf(['secondary', 'primary']),
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {any} value We default to the index of the child (number)
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * The tabs orientation (layout flow direction).
	   */
	  orientation: _propTypes.default.oneOf(['horizontal', 'vertical']),
	
	  /**
	   * The component used to render the scroll buttons.
	   */
	  ScrollButtonComponent: _propTypes.default.elementType,
	
	  /**
	   * Determine behavior of scroll buttons when tabs are set to scroll:
	   *
	   * - `auto` will only present them when not all the items are visible.
	   * - `desktop` will only present them on medium and larger viewports.
	   * - `on` will always present them.
	   * - `off` will never present them.
	   */
	  scrollButtons: _propTypes.default.oneOf(['auto', 'desktop', 'on', 'off']),
	
	  /**
	   * Props applied to the tab indicator element.
	   */
	  TabIndicatorProps: _propTypes.default.object,
	
	  /**
	   * Determines the color of the `Tab`.
	   */
	  textColor: _propTypes.default.oneOf(['secondary', 'primary', 'inherit']),
	
	  /**
	   * The value of the currently selected `Tab`.
	   * If you don't want any selected `Tab`, you can set this property to `false`.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   *  Determines additional display behavior of the tabs:
	   *
	   *  - `scrollable` will invoke scrolling properties and allow for horizontally
	   *  scrolling (or swiping) of the tab bar.
	   *  -`fullWidth` will make the tabs grow to use all the available space,
	   *  which should be used for small views, like on mobile.
	   *  - `standard` will render the default state.
	   */
	  variant: _propTypes.default.oneOf(['standard', 'scrollable', 'fullWidth'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTabs'
	})(Tabs);
	
	exports.default = _default;

/***/ },
/* 396 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tabs.default;
	  }
	});
	
	var _Tabs = _interopRequireDefault(__webpack_require__(395));

/***/ },
/* 397 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _Input = _interopRequireDefault(__webpack_require__(64));
	
	var _FilledInput = _interopRequireDefault(__webpack_require__(78));
	
	var _OutlinedInput = _interopRequireDefault(__webpack_require__(81));
	
	var _InputLabel = _interopRequireDefault(__webpack_require__(120));
	
	var _FormControl = _interopRequireDefault(__webpack_require__(79));
	
	var _FormHelperText = _interopRequireDefault(__webpack_require__(118));
	
	var _Select = _interopRequireDefault(__webpack_require__(85));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var variantComponent = {
	  standard: _Input.default,
	  filled: _FilledInput.default,
	  outlined: _OutlinedInput.default
	};
	var styles = {
	  /* Styles applied to the root element. */
	  root: {}
	};
	/**
	 * The `TextField` is a convenience wrapper for the most common cases (80%).
	 * It cannot be all things to all people, otherwise the API would grow out of control.
	 *
	 * ## Advanced Configuration
	 *
	 * It's important to understand that the text field is a simple abstraction
	 * on top of the following components:
	 *
	 * - [FormControl](/api/form-control/)
	 * - [InputLabel](/api/input-label/)
	 * - [FilledInput](/api/filled-input/)
	 * - [OutlinedInput](/api/outlined-input/)
	 * - [Input](/api/input/)
	 * - [FormHelperText](/api/form-helper-text/)
	 *
	 * If you wish to alter the props applied to the `input` element, you can do so as follows:
	 *
	 * ```jsx
	 * const inputProps = {
	 *   step: 300,
	 * };
	 *
	 * return <TextField id="time" type="time" inputProps={inputProps} />;
	 * ```
	 *
	 * For advanced cases, please look at the source of TextField by clicking on the
	 * "Edit this page" button above. Consider either:
	 *
	 * - using the upper case props for passing values directly to the components
	 * - using the underlying components directly as shown in the demos
	 */
	
	exports.styles = styles;
	var TextField = React.forwardRef(function TextField(props, ref) {
	  var autoComplete = props.autoComplete,
	      _props$autoFocus = props.autoFocus,
	      autoFocus = _props$autoFocus === void 0 ? false : _props$autoFocus,
	      children = props.children,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'primary' : _props$color,
	      defaultValue = props.defaultValue,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$error = props.error,
	      error = _props$error === void 0 ? false : _props$error,
	      FormHelperTextProps = props.FormHelperTextProps,
	      _props$fullWidth = props.fullWidth,
	      fullWidth = _props$fullWidth === void 0 ? false : _props$fullWidth,
	      helperText = props.helperText,
	      hiddenLabel = props.hiddenLabel,
	      id = props.id,
	      InputLabelProps = props.InputLabelProps,
	      inputProps = props.inputProps,
	      InputProps = props.InputProps,
	      inputRef = props.inputRef,
	      label = props.label,
	      _props$multiline = props.multiline,
	      multiline = _props$multiline === void 0 ? false : _props$multiline,
	      name = props.name,
	      onBlur = props.onBlur,
	      onChange = props.onChange,
	      onFocus = props.onFocus,
	      placeholder = props.placeholder,
	      _props$required = props.required,
	      required = _props$required === void 0 ? false : _props$required,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      _props$select = props.select,
	      select = _props$select === void 0 ? false : _props$select,
	      SelectProps = props.SelectProps,
	      type = props.type,
	      value = props.value,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'standard' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoFocus", "children", "classes", "className", "color", "defaultValue", "disabled", "error", "FormHelperTextProps", "fullWidth", "helperText", "hiddenLabel", "id", "InputLabelProps", "inputProps", "InputProps", "inputRef", "label", "multiline", "name", "onBlur", "onChange", "onFocus", "placeholder", "required", "rows", "rowsMax", "select", "SelectProps", "type", "value", "variant"]);
	
	  if (false) {
	    if (select && !children) {
	      console.error('Material-UI: `children` must be passed when using the `TextField` component with `select`.');
	    }
	  }
	
	  var InputMore = {};
	
	  if (variant === 'outlined') {
	    if (InputLabelProps && typeof InputLabelProps.shrink !== 'undefined') {
	      InputMore.notched = InputLabelProps.shrink;
	    }
	
	    if (label) {
	      InputMore.label = /*#__PURE__*/React.createElement(React.Fragment, null, label, required && "\xA0*");
	    }
	  }
	
	  if (select) {
	    // unset defaults from textbox inputs
	    if (!SelectProps || !SelectProps.native) {
	      InputMore.id = undefined;
	    }
	
	    InputMore['aria-describedby'] = undefined;
	  }
	
	  var helperTextId = helperText && id ? "".concat(id, "-helper-text") : undefined;
	  var inputLabelId = label && id ? "".concat(id, "-label") : undefined;
	  var InputComponent = variantComponent[variant];
	  var InputElement = /*#__PURE__*/React.createElement(InputComponent, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    autoComplete: autoComplete,
	    autoFocus: autoFocus,
	    defaultValue: defaultValue,
	    fullWidth: fullWidth,
	    multiline: multiline,
	    name: name,
	    rows: rows,
	    rowsMax: rowsMax,
	    type: type,
	    value: value,
	    id: id,
	    inputRef: inputRef,
	    onBlur: onBlur,
	    onChange: onChange,
	    onFocus: onFocus,
	    placeholder: placeholder,
	    inputProps: inputProps
	  }, InputMore, InputProps));
	  return /*#__PURE__*/React.createElement(_FormControl.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className),
	    disabled: disabled,
	    error: error,
	    fullWidth: fullWidth,
	    hiddenLabel: hiddenLabel,
	    ref: ref,
	    required: required,
	    color: color,
	    variant: variant
	  }, other), label && /*#__PURE__*/React.createElement(_InputLabel.default, (0, _extends2.default)({
	    htmlFor: id,
	    id: inputLabelId
	  }, InputLabelProps), label), select ? /*#__PURE__*/React.createElement(_Select.default, (0, _extends2.default)({
	    "aria-describedby": helperTextId,
	    id: id,
	    labelId: inputLabelId,
	    value: value,
	    input: InputElement
	  }, SelectProps), children) : InputElement, helperText && /*#__PURE__*/React.createElement(_FormHelperText.default, (0, _extends2.default)({
	    id: helperTextId
	  }, FormHelperTextProps), helperText));
	});
	 false ? TextField.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * This prop helps users to fill forms faster, especially on mobile devices.
	   * The name can be confusing, as it's more like an autofill.
	   * You can learn more about it [following the specification](https://html.spec.whatwg.org/multipage/form-control-infrastructure.html#autofill).
	   */
	  autoComplete: _propTypes.default.string,
	
	  /**
	   * If `true`, the `input` element will be focused during the first mount.
	   */
	  autoFocus: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['primary', 'secondary']),
	
	  /**
	   * The default value of the `input` element.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the `input` element will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, the label will be displayed in an error state.
	   */
	  error: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`FormHelperText`](/api/form-helper-text/) element.
	   */
	  FormHelperTextProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the input will take up the full width of its container.
	   */
	  fullWidth: _propTypes.default.bool,
	
	  /**
	   * The helper text content.
	   */
	  helperText: _propTypes.default.node,
	
	  /**
	   * @ignore
	   */
	  hiddenLabel: _propTypes.default.bool,
	
	  /**
	   * The id of the `input` element.
	   * Use this prop to make `label` and `helperText` accessible for screen readers.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Props applied to the [`InputLabel`](/api/input-label/) element.
	   */
	  InputLabelProps: _propTypes.default.object,
	
	  /**
	   * [Attributes](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Attributes) applied to the `input` element.
	   */
	  inputProps: _propTypes.default.object,
	
	  /**
	   * Props applied to the Input element.
	   * It will be a [`FilledInput`](/api/filled-input/),
	   * [`OutlinedInput`](/api/outlined-input/) or [`Input`](/api/input/)
	   * component depending on the `variant` prop value.
	   */
	  InputProps: _propTypes.default.object,
	
	  /**
	   * Pass a ref to the `input` element.
	   */
	  inputRef: _utils.refType,
	
	  /**
	   * The label content.
	   */
	  label: _propTypes.default.node,
	
	  /**
	   * If `dense` or `normal`, will adjust vertical spacing of this and contained components.
	   */
	  margin: _propTypes.default.oneOf(['dense', 'none', 'normal']),
	
	  /**
	   * If `true`, a textarea element will be rendered instead of an input.
	   */
	  multiline: _propTypes.default.bool,
	
	  /**
	   * Name attribute of the `input` element.
	   */
	  name: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onBlur: _propTypes.default.func,
	
	  /**
	   * Callback fired when the value is changed.
	   *
	   * @param {object} event The event source of the callback.
	   * You can pull out the new value by accessing `event.target.value` (string).
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onFocus: _propTypes.default.func,
	
	  /**
	   * The short hint displayed in the input before the user enters a value.
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * If `true`, the label is displayed as required and the `input` element` will be required.
	   */
	  required: _propTypes.default.bool,
	
	  /**
	   * Number of rows to display when multiline option is set to true.
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display when multiline option is set to true.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Render a [`Select`](/api/select/) element while passing the Input element to `Select` as `input` parameter.
	   * If this option is set you must pass the options of the select as children.
	   */
	  select: _propTypes.default.bool,
	
	  /**
	   * Props applied to the [`Select`](/api/select/) element.
	   */
	  SelectProps: _propTypes.default.object,
	
	  /**
	   * The size of the text field.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * Type of the `input` element. It should be [a valid HTML5 input type](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#Form_%3Cinput%3E_types).
	   */
	  type: _propTypes.default.string,
	
	  /**
	   * The value of the `input` element, required for a controlled component.
	   */
	  value: _propTypes.default.any,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['filled', 'outlined', 'standard'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTextField'
	})(TextField);
	
	exports.default = _default;

/***/ },
/* 398 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _debounce = _interopRequireDefault(__webpack_require__(37));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	function getStyleValue(computedStyle, property) {
	  return parseInt(computedStyle[property], 10) || 0;
	}
	
	var useEnhancedEffect = typeof window !== 'undefined' ? React.useLayoutEffect : React.useEffect;
	var styles = {
	  /* Styles applied to the shadow textarea element. */
	  shadow: {
	    // Visibility needed to hide the extra text area on iPads
	    visibility: 'hidden',
	    // Remove from the content flow
	    position: 'absolute',
	    // Ignore the scrollbar width
	    overflow: 'hidden',
	    height: 0,
	    top: 0,
	    left: 0,
	    // Create a new layer, increase the isolation of the computed values
	    transform: 'translateZ(0)'
	  }
	};
	var TextareaAutosize = React.forwardRef(function TextareaAutosize(props, ref) {
	  var onChange = props.onChange,
	      rows = props.rows,
	      rowsMax = props.rowsMax,
	      _props$rowsMin = props.rowsMin,
	      rowsMinProp = _props$rowsMin === void 0 ? 1 : _props$rowsMin,
	      style = props.style,
	      value = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["onChange", "rows", "rowsMax", "rowsMin", "style", "value"]);
	  var rowsMin = rows || rowsMinProp;
	
	  var _React$useRef = React.useRef(value != null),
	      isControlled = _React$useRef.current;
	
	  var inputRef = React.useRef(null);
	  var handleRef = (0, _useForkRef.default)(ref, inputRef);
	  var shadowRef = React.useRef(null);
	  var renders = React.useRef(0);
	
	  var _React$useState = React.useState({}),
	      state = _React$useState[0],
	      setState = _React$useState[1];
	
	  var syncHeight = React.useCallback(function () {
	    var input = inputRef.current;
	    var computedStyle = window.getComputedStyle(input);
	    var inputShallow = shadowRef.current;
	    inputShallow.style.width = computedStyle.width;
	    inputShallow.value = input.value || props.placeholder || 'x';
	    var boxSizing = computedStyle['box-sizing'];
	    var padding = getStyleValue(computedStyle, 'padding-bottom') + getStyleValue(computedStyle, 'padding-top');
	    var border = getStyleValue(computedStyle, 'border-bottom-width') + getStyleValue(computedStyle, 'border-top-width'); // The height of the inner content
	
	    var innerHeight = inputShallow.scrollHeight - padding; // Measure height of a textarea with a single row
	
	    inputShallow.value = 'x';
	    var singleRowHeight = inputShallow.scrollHeight - padding; // The height of the outer content
	
	    var outerHeight = innerHeight;
	
	    if (rowsMin) {
	      outerHeight = Math.max(Number(rowsMin) * singleRowHeight, outerHeight);
	    }
	
	    if (rowsMax) {
	      outerHeight = Math.min(Number(rowsMax) * singleRowHeight, outerHeight);
	    }
	
	    outerHeight = Math.max(outerHeight, singleRowHeight); // Take the box sizing into account for applying this value as a style.
	
	    var outerHeightStyle = outerHeight + (boxSizing === 'border-box' ? padding + border : 0);
	    var overflow = Math.abs(outerHeight - innerHeight) <= 1;
	    setState(function (prevState) {
	      // Need a large enough difference to update the height.
	      // This prevents infinite rendering loop.
	      if (renders.current < 20 && (outerHeightStyle > 0 && Math.abs((prevState.outerHeightStyle || 0) - outerHeightStyle) > 1 || prevState.overflow !== overflow)) {
	        renders.current += 1;
	        return {
	          overflow: overflow,
	          outerHeightStyle: outerHeightStyle
	        };
	      }
	
	      if (false) {
	        if (renders.current === 20) {
	          console.error(['Material-UI: too many re-renders. The layout is unstable.', 'TextareaAutosize limits the number of renders to prevent an infinite loop.'].join('\n'));
	        }
	      }
	
	      return prevState;
	    });
	  }, [rowsMax, rowsMin, props.placeholder]);
	  React.useEffect(function () {
	    var handleResize = (0, _debounce.default)(function () {
	      renders.current = 0;
	      syncHeight();
	    });
	    window.addEventListener('resize', handleResize);
	    return function () {
	      handleResize.clear();
	      window.removeEventListener('resize', handleResize);
	    };
	  }, [syncHeight]);
	  useEnhancedEffect(function () {
	    syncHeight();
	  });
	  React.useEffect(function () {
	    renders.current = 0;
	  }, [value]);
	
	  var handleChange = function handleChange(event) {
	    renders.current = 0;
	
	    if (!isControlled) {
	      syncHeight();
	    }
	
	    if (onChange) {
	      onChange(event);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("textarea", (0, _extends2.default)({
	    value: value,
	    onChange: handleChange,
	    ref: handleRef // Apply the rows prop to get a "correct" first SSR paint
	    ,
	    rows: rowsMin,
	    style: (0, _extends2.default)({
	      height: state.outerHeightStyle,
	      // Need a large enough difference to allow scrolling.
	      // This prevents infinite rendering loop.
	      overflow: state.overflow ? 'hidden' : null
	    }, style)
	  }, other)), /*#__PURE__*/React.createElement("textarea", {
	    "aria-hidden": true,
	    className: props.className,
	    readOnly: true,
	    ref: shadowRef,
	    tabIndex: -1,
	    style: (0, _extends2.default)({}, styles.shadow, {}, style)
	  }));
	});
	 false ? TextareaAutosize.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * @ignore
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  placeholder: _propTypes.default.string,
	
	  /**
	   * Use `rowsMin` instead. The prop will be removed in v5.
	   *
	   * @deprecated
	   */
	  rows: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Maximum number of rows to display.
	   */
	  rowsMax: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * Minimum number of rows to display.
	   */
	  rowsMin: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.string]),
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.arrayOf(_propTypes.default.string), _propTypes.default.number, _propTypes.default.string])
	} : void 0;
	var _default = TextareaAutosize;
	exports.default = _default;

/***/ },
/* 399 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      position: 'relative',
	      display: 'flex',
	      alignItems: 'center'
	    },
	
	    /* Styles applied to the root element if `disableGutters={false}`. */
	    gutters: (0, _defineProperty2.default)({
	      paddingLeft: theme.spacing(2),
	      paddingRight: theme.spacing(2)
	    }, theme.breakpoints.up('sm'), {
	      paddingLeft: theme.spacing(3),
	      paddingRight: theme.spacing(3)
	    }),
	
	    /* Styles applied to the root element if `variant="regular"`. */
	    regular: theme.mixins.toolbar,
	
	    /* Styles applied to the root element if `variant="dense"`. */
	    dense: {
	      minHeight: 48
	    }
	  };
	};
	
	exports.styles = styles;
	var Toolbar = React.forwardRef(function Toolbar(props, ref) {
	  var classes = props.classes,
	      className = props.className,
	      _props$component = props.component,
	      Component = _props$component === void 0 ? 'div' : _props$component,
	      _props$disableGutters = props.disableGutters,
	      disableGutters = _props$disableGutters === void 0 ? false : _props$disableGutters,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'regular' : _props$variant,
	      other = (0, _objectWithoutProperties2.default)(props, ["classes", "className", "component", "disableGutters", "variant"]);
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, classes[variant], className, !disableGutters && classes.gutters),
	    ref: ref
	  }, other));
	});
	 false ? Toolbar.propTypes = {
	  /**
	   * Toolbar children, usually a mixture of `IconButton`, `Button` and `Typography`.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * If `true`, disables gutter padding.
	   */
	  disableGutters: _propTypes.default.bool,
	
	  /**
	   * The variant to use.
	   */
	  variant: _propTypes.default.oneOf(['regular', 'dense'])
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiToolbar'
	})(Toolbar);
	
	exports.default = _default;

/***/ },
/* 400 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.testReset = testReset;
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(32));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var ReactDOM = _interopRequireWildcard(__webpack_require__(16));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _utils = __webpack_require__(9);
	
	var _colorManipulator = __webpack_require__(15);
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var _Grow = _interopRequireDefault(__webpack_require__(63));
	
	var _Popper = _interopRequireDefault(__webpack_require__(83));
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var _unstable_useId = _interopRequireDefault(__webpack_require__(89));
	
	var _setRef = _interopRequireDefault(__webpack_require__(38));
	
	var _useIsFocusVisible2 = _interopRequireDefault(__webpack_require__(57));
	
	var _useControlled3 = _interopRequireDefault(__webpack_require__(39));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	function arrowGenerator() {
	  return {
	    '&[x-placement*="bottom"] $arrow': {
	      flip: false,
	      top: 0,
	      left: 0,
	      marginTop: '-0.95em',
	      marginLeft: 4,
	      marginRight: 4,
	      width: '2em',
	      height: '1em',
	      '&::before': {
	        flip: false,
	        borderWidth: '0 1em 1em 1em',
	        borderColor: 'transparent transparent currentcolor transparent'
	      }
	    },
	    '&[x-placement*="top"] $arrow': {
	      flip: false,
	      bottom: 0,
	      left: 0,
	      marginBottom: '-0.95em',
	      marginLeft: 4,
	      marginRight: 4,
	      width: '2em',
	      height: '1em',
	      '&::before': {
	        flip: false,
	        borderWidth: '1em 1em 0 1em',
	        borderColor: 'currentcolor transparent transparent transparent'
	      }
	    },
	    '&[x-placement*="right"] $arrow': {
	      flip: false,
	      left: 0,
	      marginLeft: '-0.95em',
	      marginTop: 4,
	      marginBottom: 4,
	      height: '2em',
	      width: '1em',
	      '&::before': {
	        flip: false,
	        borderWidth: '1em 1em 1em 0',
	        borderColor: 'transparent currentcolor transparent transparent'
	      }
	    },
	    '&[x-placement*="left"] $arrow': {
	      flip: false,
	      right: 0,
	      marginRight: '-0.95em',
	      marginTop: 4,
	      marginBottom: 4,
	      height: '2em',
	      width: '1em',
	      '&::before': {
	        flip: false,
	        borderWidth: '1em 0 1em 1em',
	        borderColor: 'transparent transparent transparent currentcolor'
	      }
	    }
	  };
	}
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the Popper component. */
	    popper: {
	      zIndex: theme.zIndex.tooltip,
	      pointerEvents: 'none',
	      flip: false // disable jss-rtl plugin
	
	    },
	
	    /* Styles applied to the Popper component if `interactive={true}`. */
	    popperInteractive: {
	      pointerEvents: 'auto'
	    },
	
	    /* Styles applied to the Popper component if `arrow={true}`. */
	    popperArrow: arrowGenerator(),
	
	    /* Styles applied to the tooltip (label wrapper) element. */
	    tooltip: {
	      backgroundColor: (0, _colorManipulator.fade)(theme.palette.grey[700], 0.9),
	      borderRadius: theme.shape.borderRadius,
	      color: theme.palette.common.white,
	      fontFamily: theme.typography.fontFamily,
	      padding: '4px 8px',
	      fontSize: theme.typography.pxToRem(10),
	      lineHeight: "".concat(round(14 / 10), "em"),
	      maxWidth: 300,
	      wordWrap: 'break-word',
	      fontWeight: theme.typography.fontWeightMedium
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if `arrow={true}`. */
	    tooltipArrow: {
	      position: 'relative',
	      margin: '0'
	    },
	
	    /* Styles applied to the arrow element. */
	    arrow: {
	      position: 'absolute',
	      fontSize: 6,
	      color: (0, _colorManipulator.fade)(theme.palette.grey[700], 0.9),
	      '&::before': {
	        content: '""',
	        margin: 'auto',
	        display: 'block',
	        width: 0,
	        height: 0,
	        borderStyle: 'solid'
	      }
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if the tooltip is opened by touch. */
	    touch: {
	      padding: '8px 16px',
	      fontSize: theme.typography.pxToRem(14),
	      lineHeight: "".concat(round(16 / 14), "em"),
	      fontWeight: theme.typography.fontWeightRegular
	    },
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "left". */
	    tooltipPlacementLeft: (0, _defineProperty2.default)({
	      transformOrigin: 'right center',
	      margin: '0 24px '
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "right". */
	    tooltipPlacementRight: (0, _defineProperty2.default)({
	      transformOrigin: 'left center',
	      margin: '0 24px'
	    }, theme.breakpoints.up('sm'), {
	      margin: '0 14px'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "top". */
	    tooltipPlacementTop: (0, _defineProperty2.default)({
	      transformOrigin: 'center bottom',
	      margin: '24px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    }),
	
	    /* Styles applied to the tooltip (label wrapper) element if `placement` contains "bottom". */
	    tooltipPlacementBottom: (0, _defineProperty2.default)({
	      transformOrigin: 'center top',
	      margin: '24px 0'
	    }, theme.breakpoints.up('sm'), {
	      margin: '14px 0'
	    })
	  };
	};
	
	exports.styles = styles;
	var hystersisOpen = false;
	var hystersisTimer = null;
	
	function testReset() {
	  hystersisOpen = false;
	  clearTimeout(hystersisTimer);
	}
	
	var Tooltip = React.forwardRef(function Tooltip(props, ref) {
	  var _props$arrow = props.arrow,
	      arrow = _props$arrow === void 0 ? false : _props$arrow,
	      children = props.children,
	      classes = props.classes,
	      _props$disableFocusLi = props.disableFocusListener,
	      disableFocusListener = _props$disableFocusLi === void 0 ? false : _props$disableFocusLi,
	      _props$disableHoverLi = props.disableHoverListener,
	      disableHoverListener = _props$disableHoverLi === void 0 ? false : _props$disableHoverLi,
	      _props$disableTouchLi = props.disableTouchListener,
	      disableTouchListener = _props$disableTouchLi === void 0 ? false : _props$disableTouchLi,
	      _props$enterDelay = props.enterDelay,
	      enterDelay = _props$enterDelay === void 0 ? 100 : _props$enterDelay,
	      _props$enterNextDelay = props.enterNextDelay,
	      enterNextDelay = _props$enterNextDelay === void 0 ? 0 : _props$enterNextDelay,
	      _props$enterTouchDela = props.enterTouchDelay,
	      enterTouchDelay = _props$enterTouchDela === void 0 ? 700 : _props$enterTouchDela,
	      idProp = props.id,
	      _props$interactive = props.interactive,
	      interactive = _props$interactive === void 0 ? false : _props$interactive,
	      _props$leaveDelay = props.leaveDelay,
	      leaveDelay = _props$leaveDelay === void 0 ? 0 : _props$leaveDelay,
	      _props$leaveTouchDela = props.leaveTouchDelay,
	      leaveTouchDelay = _props$leaveTouchDela === void 0 ? 1500 : _props$leaveTouchDela,
	      onClose = props.onClose,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      _props$placement = props.placement,
	      placement = _props$placement === void 0 ? 'bottom' : _props$placement,
	      PopperProps = props.PopperProps,
	      title = props.title,
	      _props$TransitionComp = props.TransitionComponent,
	      TransitionComponent = _props$TransitionComp === void 0 ? _Grow.default : _props$TransitionComp,
	      TransitionProps = props.TransitionProps,
	      other = (0, _objectWithoutProperties2.default)(props, ["arrow", "children", "classes", "disableFocusListener", "disableHoverListener", "disableTouchListener", "enterDelay", "enterNextDelay", "enterTouchDelay", "id", "interactive", "leaveDelay", "leaveTouchDelay", "onClose", "onOpen", "open", "placement", "PopperProps", "title", "TransitionComponent", "TransitionProps"]);
	  var theme = (0, _useTheme.default)();
	
	  var _React$useState = React.useState(),
	      childNode = _React$useState[0],
	      setChildNode = _React$useState[1];
	
	  var _React$useState2 = React.useState(null),
	      arrowRef = _React$useState2[0],
	      setArrowRef = _React$useState2[1];
	
	  var ignoreNonTouchEvents = React.useRef(false);
	  var closeTimer = React.useRef();
	  var enterTimer = React.useRef();
	  var leaveTimer = React.useRef();
	  var touchTimer = React.useRef();
	
	  var _useControlled = (0, _useControlled3.default)({
	    controlled: openProp,
	    default: false,
	    name: 'Tooltip',
	    state: 'open'
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      openState = _useControlled2[0],
	      setOpenState = _useControlled2[1];
	
	  var open = openState;
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    var _React$useRef = React.useRef(openProp !== undefined),
	        isControlled = _React$useRef.current; // eslint-disable-next-line react-hooks/rules-of-hooks
	
	
	    React.useEffect(function () {
	      if (childNode && childNode.disabled && !isControlled && title !== '' && childNode.tagName.toLowerCase() === 'button') {
	        console.error(['Material-UI: you are providing a disabled `button` child to the Tooltip component.', 'A disabled element does not fire events.', "Tooltip needs to listen to the child element's events to display the title.", '', 'Add a simple wrapper element, such as a `span`.'].join('\n'));
	      }
	    }, [title, childNode, isControlled]);
	  }
	
	  var id = (0, _unstable_useId.default)(idProp);
	  React.useEffect(function () {
	    return function () {
	      clearTimeout(closeTimer.current);
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	      clearTimeout(touchTimer.current);
	    };
	  }, []);
	
	  var handleOpen = function handleOpen(event) {
	    clearTimeout(hystersisTimer);
	    hystersisOpen = true; // The mouseover event will trigger for every nested element in the tooltip.
	    // We can skip rerendering when the tooltip is already open.
	    // We are using the mouseover event instead of the mouseenter event to fix a hide/show issue.
	
	    setOpenState(true);
	
	    if (onOpen) {
	      onOpen(event);
	    }
	  };
	
	  var handleEnter = function handleEnter() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      var childrenProps = children.props;
	
	      if (event.type === 'mouseover' && childrenProps.onMouseOver && forward) {
	        childrenProps.onMouseOver(event);
	      }
	
	      if (ignoreNonTouchEvents.current && event.type !== 'touchstart') {
	        return;
	      } // Remove the title ahead of time.
	      // We don't want to wait for the next render commit.
	      // We would risk displaying two tooltips at the same time (native + this one).
	
	
	      if (childNode) {
	        childNode.removeAttribute('title');
	      }
	
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	
	      if (enterDelay || hystersisOpen && enterNextDelay) {
	        event.persist();
	        enterTimer.current = setTimeout(function () {
	          handleOpen(event);
	        }, hystersisOpen ? enterNextDelay : enterDelay);
	      } else {
	        handleOpen(event);
	      }
	    };
	  };
	
	  var _useIsFocusVisible = (0, _useIsFocusVisible2.default)(),
	      isFocusVisible = _useIsFocusVisible.isFocusVisible,
	      onBlurVisible = _useIsFocusVisible.onBlurVisible,
	      focusVisibleRef = _useIsFocusVisible.ref;
	
	  var _React$useState3 = React.useState(false),
	      childIsFocusVisible = _React$useState3[0],
	      setChildIsFocusVisible = _React$useState3[1];
	
	  var handleBlur = function handleBlur() {
	    if (childIsFocusVisible) {
	      setChildIsFocusVisible(false);
	      onBlurVisible();
	    }
	  };
	
	  var handleFocus = function handleFocus() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      // Workaround for https://github.com/facebook/react/issues/7769
	      // The autoFocus of React might trigger the event before the componentDidMount.
	      // We need to account for this eventuality.
	      if (!childNode) {
	        setChildNode(event.currentTarget);
	      }
	
	      if (isFocusVisible(event)) {
	        setChildIsFocusVisible(true);
	        handleEnter()(event);
	      }
	
	      var childrenProps = children.props;
	
	      if (childrenProps.onFocus && forward) {
	        childrenProps.onFocus(event);
	      }
	    };
	  };
	
	  var handleClose = function handleClose(event) {
	    clearTimeout(hystersisTimer);
	    hystersisTimer = setTimeout(function () {
	      hystersisOpen = false;
	    }, 800 + leaveDelay);
	    setOpenState(false);
	
	    if (onClose) {
	      onClose(event);
	    }
	
	    clearTimeout(closeTimer.current);
	    closeTimer.current = setTimeout(function () {
	      ignoreNonTouchEvents.current = false;
	    }, theme.transitions.duration.shortest);
	  };
	
	  var handleLeave = function handleLeave() {
	    var forward = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : true;
	    return function (event) {
	      var childrenProps = children.props;
	
	      if (event.type === 'blur') {
	        if (childrenProps.onBlur && forward) {
	          childrenProps.onBlur(event);
	        }
	
	        handleBlur();
	      }
	
	      if (event.type === 'mouseleave' && childrenProps.onMouseLeave && event.currentTarget === childNode) {
	        childrenProps.onMouseLeave(event);
	      }
	
	      clearTimeout(enterTimer.current);
	      clearTimeout(leaveTimer.current);
	      event.persist();
	      leaveTimer.current = setTimeout(function () {
	        handleClose(event);
	      }, leaveDelay);
	    };
	  };
	
	  var handleTouchStart = function handleTouchStart(event) {
	    ignoreNonTouchEvents.current = true;
	    var childrenProps = children.props;
	
	    if (childrenProps.onTouchStart) {
	      childrenProps.onTouchStart(event);
	    }
	
	    clearTimeout(leaveTimer.current);
	    clearTimeout(closeTimer.current);
	    clearTimeout(touchTimer.current);
	    event.persist();
	    touchTimer.current = setTimeout(function () {
	      handleEnter()(event);
	    }, enterTouchDelay);
	  };
	
	  var handleTouchEnd = function handleTouchEnd(event) {
	    if (children.props.onTouchEnd) {
	      children.props.onTouchEnd(event);
	    }
	
	    clearTimeout(touchTimer.current);
	    clearTimeout(leaveTimer.current);
	    event.persist();
	    leaveTimer.current = setTimeout(function () {
	      handleClose(event);
	    }, leaveTouchDelay);
	  };
	
	  var handleUseRef = (0, _useForkRef.default)(setChildNode, ref);
	  var handleFocusRef = (0, _useForkRef.default)(focusVisibleRef, handleUseRef); // can be removed once we drop support for non ref forwarding class components
	
	  var handleOwnRef = React.useCallback(function (instance) {
	    // #StrictMode ready
	    (0, _setRef.default)(handleFocusRef, ReactDOM.findDOMNode(instance));
	  }, [handleFocusRef]);
	  var handleRef = (0, _useForkRef.default)(children.ref, handleOwnRef); // There is no point in displaying an empty tooltip.
	
	  if (title === '') {
	    open = false;
	  } // For accessibility and SEO concerns, we render the title to the DOM node when
	  // the tooltip is hidden. However, we have made a tradeoff when
	  // `disableHoverListener` is set. This title logic is disabled.
	  // It's allowing us to keep the implementation size minimal.
	  // We are open to change the tradeoff.
	
	
	  var shouldShowNativeTitle = !open && !disableHoverListener;
	  var childrenProps = (0, _extends2.default)({
	    'aria-describedby': open ? id : null,
	    title: shouldShowNativeTitle && typeof title === 'string' ? title : null
	  }, other, {}, children.props, {
	    className: (0, _clsx.default)(other.className, children.props.className),
	    ref: handleRef
	  });
	  var interactiveWrapperListeners = {};
	
	  if (!disableTouchListener) {
	    childrenProps.onTouchStart = handleTouchStart;
	    childrenProps.onTouchEnd = handleTouchEnd;
	  }
	
	  if (!disableHoverListener) {
	    childrenProps.onMouseOver = handleEnter();
	    childrenProps.onMouseLeave = handleLeave();
	
	    if (interactive) {
	      interactiveWrapperListeners.onMouseOver = handleEnter(false);
	      interactiveWrapperListeners.onMouseLeave = handleLeave(false);
	    }
	  }
	
	  if (!disableFocusListener) {
	    childrenProps.onFocus = handleFocus();
	    childrenProps.onBlur = handleLeave();
	
	    if (interactive) {
	      interactiveWrapperListeners.onFocus = handleFocus(false);
	      interactiveWrapperListeners.onBlur = handleLeave(false);
	    }
	  }
	
	  if (false) {
	    if (children.props.title) {
	      console.error(['Material-UI: you have provided a `title` prop to the child of <Tooltip />.', "Remove this title prop `".concat(children.props.title, "` or the Tooltip component.")].join('\n'));
	    }
	  }
	
	  var mergedPopperProps = React.useMemo(function () {
	    return (0, _utils.deepmerge)({
	      popperOptions: {
	        modifiers: {
	          arrow: {
	            enabled: Boolean(arrowRef),
	            element: arrowRef
	          }
	        }
	      }
	    }, PopperProps);
	  }, [arrowRef, PopperProps]);
	  return /*#__PURE__*/React.createElement(React.Fragment, null, React.cloneElement(children, childrenProps), /*#__PURE__*/React.createElement(_Popper.default, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.popper, interactive && classes.popperInteractive, arrow && classes.popperArrow),
	    placement: placement,
	    anchorEl: childNode,
	    open: childNode ? open : false,
	    id: childrenProps['aria-describedby'],
	    transition: true
	  }, interactiveWrapperListeners, mergedPopperProps), function (_ref) {
	    var placementInner = _ref.placement,
	        TransitionPropsInner = _ref.TransitionProps;
	    return /*#__PURE__*/React.createElement(TransitionComponent, (0, _extends2.default)({
	      timeout: theme.transitions.duration.shorter
	    }, TransitionPropsInner, TransitionProps), /*#__PURE__*/React.createElement("div", {
	      className: (0, _clsx.default)(classes.tooltip, classes["tooltipPlacement".concat((0, _capitalize.default)(placementInner.split('-')[0]))], ignoreNonTouchEvents.current && classes.touch, arrow && classes.tooltipArrow)
	    }, title, arrow ? /*#__PURE__*/React.createElement("span", {
	      className: classes.arrow,
	      ref: setArrowRef
	    }) : null));
	  }));
	});
	 false ? Tooltip.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, adds an arrow to the tooltip.
	   */
	  arrow: _propTypes.default.bool,
	
	  /**
	   * Tooltip reference element.
	   */
	  children: _utils.elementAcceptingRef.isRequired,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * Do not respond to focus events.
	   */
	  disableFocusListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to hover events.
	   */
	  disableHoverListener: _propTypes.default.bool,
	
	  /**
	   * Do not respond to long press touch events.
	   */
	  disableTouchListener: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before showing the tooltip.
	   * This prop won't impact the enter touch delay (`enterTouchDelay`).
	   */
	  enterDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds to wait before showing the tooltip when one was already recently opened.
	   */
	  enterNextDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds a user must touch the element before showing the tooltip.
	   */
	  enterTouchDelay: _propTypes.default.number,
	
	  /**
	   * This prop is used to help implement the accessibility logic.
	   * If you don't provide this prop. It falls back to a randomly generated id.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * Makes a tooltip interactive, i.e. will not close when the user
	   * hovers over the tooltip before the `leaveDelay` is expired.
	   */
	  interactive: _propTypes.default.bool,
	
	  /**
	   * The number of milliseconds to wait before hiding the tooltip.
	   * This prop won't impact the leave touch delay (`leaveTouchDelay`).
	   */
	  leaveDelay: _propTypes.default.number,
	
	  /**
	   * The number of milliseconds after the user stops touching an element before hiding the tooltip.
	   */
	  leaveTouchDelay: _propTypes.default.number,
	
	  /**
	   * Callback fired when the component requests to be closed.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the component requests to be open.
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * If `true`, the tooltip is shown.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * Tooltip placement.
	   */
	  placement: _propTypes.default.oneOf(['bottom-end', 'bottom-start', 'bottom', 'left-end', 'left-start', 'left', 'right-end', 'right-start', 'right', 'top-end', 'top-start', 'top']),
	
	  /**
	   * Props applied to the [`Popper`](/api/popper/) element.
	   */
	  PopperProps: _propTypes.default.object,
	
	  /**
	   * Tooltip title. Zero-length titles string are never displayed.
	   */
	  title: _propTypes.default
	  /* @typescript-to-proptypes-ignore */
	  .node.isRequired,
	
	  /**
	   * The component used for the transition.
	   * [Follow this guide](/components/transitions/#transitioncomponent-prop) to learn more about the requirements for this component.
	   */
	  TransitionComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the [`Transition`](http://reactcommunity.org/react-transition-group/transition#Transition-props) element.
	   */
	  TransitionProps: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTooltip'
	})(Tooltip);
	
	exports.default = _default;

/***/ },
/* 401 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Tooltip.default;
	  }
	});
	
	var _Tooltip = _interopRequireDefault(__webpack_require__(400));

/***/ },
/* 402 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.styles = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _withStyles = _interopRequireDefault(__webpack_require__(7));
	
	var _capitalize = _interopRequireDefault(__webpack_require__(10));
	
	var styles = function styles(theme) {
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      margin: 0
	    },
	
	    /* Styles applied to the root element if `variant="body2"`. */
	    body2: theme.typography.body2,
	
	    /* Styles applied to the root element if `variant="body1"`. */
	    body1: theme.typography.body1,
	
	    /* Styles applied to the root element if `variant="caption"`. */
	    caption: theme.typography.caption,
	
	    /* Styles applied to the root element if `variant="button"`. */
	    button: theme.typography.button,
	
	    /* Styles applied to the root element if `variant="h1"`. */
	    h1: theme.typography.h1,
	
	    /* Styles applied to the root element if `variant="h2"`. */
	    h2: theme.typography.h2,
	
	    /* Styles applied to the root element if `variant="h3"`. */
	    h3: theme.typography.h3,
	
	    /* Styles applied to the root element if `variant="h4"`. */
	    h4: theme.typography.h4,
	
	    /* Styles applied to the root element if `variant="h5"`. */
	    h5: theme.typography.h5,
	
	    /* Styles applied to the root element if `variant="h6"`. */
	    h6: theme.typography.h6,
	
	    /* Styles applied to the root element if `variant="subtitle1"`. */
	    subtitle1: theme.typography.subtitle1,
	
	    /* Styles applied to the root element if `variant="subtitle2"`. */
	    subtitle2: theme.typography.subtitle2,
	
	    /* Styles applied to the root element if `variant="overline"`. */
	    overline: theme.typography.overline,
	
	    /* Styles applied to the root element if `variant="srOnly"`. Only accessible to screen readers. */
	    srOnly: {
	      position: 'absolute',
	      height: 1,
	      width: 1,
	      overflow: 'hidden'
	    },
	
	    /* Styles applied to the root element if `align="left"`. */
	    alignLeft: {
	      textAlign: 'left'
	    },
	
	    /* Styles applied to the root element if `align="center"`. */
	    alignCenter: {
	      textAlign: 'center'
	    },
	
	    /* Styles applied to the root element if `align="right"`. */
	    alignRight: {
	      textAlign: 'right'
	    },
	
	    /* Styles applied to the root element if `align="justify"`. */
	    alignJustify: {
	      textAlign: 'justify'
	    },
	
	    /* Styles applied to the root element if `nowrap={true}`. */
	    noWrap: {
	      overflow: 'hidden',
	      textOverflow: 'ellipsis',
	      whiteSpace: 'nowrap'
	    },
	
	    /* Styles applied to the root element if `gutterBottom={true}`. */
	    gutterBottom: {
	      marginBottom: '0.35em'
	    },
	
	    /* Styles applied to the root element if `paragraph={true}`. */
	    paragraph: {
	      marginBottom: 16
	    },
	
	    /* Styles applied to the root element if `color="inherit"`. */
	    colorInherit: {
	      color: 'inherit'
	    },
	
	    /* Styles applied to the root element if `color="primary"`. */
	    colorPrimary: {
	      color: theme.palette.primary.main
	    },
	
	    /* Styles applied to the root element if `color="secondary"`. */
	    colorSecondary: {
	      color: theme.palette.secondary.main
	    },
	
	    /* Styles applied to the root element if `color="textPrimary"`. */
	    colorTextPrimary: {
	      color: theme.palette.text.primary
	    },
	
	    /* Styles applied to the root element if `color="textSecondary"`. */
	    colorTextSecondary: {
	      color: theme.palette.text.secondary
	    },
	
	    /* Styles applied to the root element if `color="error"`. */
	    colorError: {
	      color: theme.palette.error.main
	    },
	
	    /* Styles applied to the root element if `display="inline"`. */
	    displayInline: {
	      display: 'inline'
	    },
	
	    /* Styles applied to the root element if `display="block"`. */
	    displayBlock: {
	      display: 'block'
	    }
	  };
	};
	
	exports.styles = styles;
	var defaultVariantMapping = {
	  h1: 'h1',
	  h2: 'h2',
	  h3: 'h3',
	  h4: 'h4',
	  h5: 'h5',
	  h6: 'h6',
	  subtitle1: 'h6',
	  subtitle2: 'h6',
	  body1: 'p',
	  body2: 'p'
	};
	var Typography = React.forwardRef(function Typography(props, ref) {
	  var _props$align = props.align,
	      align = _props$align === void 0 ? 'inherit' : _props$align,
	      classes = props.classes,
	      className = props.className,
	      _props$color = props.color,
	      color = _props$color === void 0 ? 'initial' : _props$color,
	      component = props.component,
	      _props$display = props.display,
	      display = _props$display === void 0 ? 'initial' : _props$display,
	      _props$gutterBottom = props.gutterBottom,
	      gutterBottom = _props$gutterBottom === void 0 ? false : _props$gutterBottom,
	      _props$noWrap = props.noWrap,
	      noWrap = _props$noWrap === void 0 ? false : _props$noWrap,
	      _props$paragraph = props.paragraph,
	      paragraph = _props$paragraph === void 0 ? false : _props$paragraph,
	      _props$variant = props.variant,
	      variant = _props$variant === void 0 ? 'body1' : _props$variant,
	      _props$variantMapping = props.variantMapping,
	      variantMapping = _props$variantMapping === void 0 ? defaultVariantMapping : _props$variantMapping,
	      other = (0, _objectWithoutProperties2.default)(props, ["align", "classes", "className", "color", "component", "display", "gutterBottom", "noWrap", "paragraph", "variant", "variantMapping"]);
	  var Component = component || (paragraph ? 'p' : variantMapping[variant] || defaultVariantMapping[variant]) || 'span';
	  return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	    className: (0, _clsx.default)(classes.root, className, variant !== 'inherit' && classes[variant], color !== 'initial' && classes["color".concat((0, _capitalize.default)(color))], noWrap && classes.noWrap, gutterBottom && classes.gutterBottom, paragraph && classes.paragraph, align !== 'inherit' && classes["align".concat((0, _capitalize.default)(align))], display !== 'initial' && classes["display".concat((0, _capitalize.default)(display))]),
	    ref: ref
	  }, other));
	});
	 false ? Typography.propTypes = {
	  /**
	   * Set the text-align on the component.
	   */
	  align: _propTypes.default.oneOf(['inherit', 'left', 'center', 'right', 'justify']),
	
	  /**
	   * The content of the component.
	   */
	  children: _propTypes.default.node,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object.isRequired,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * The color of the component. It supports those theme colors that make sense for this component.
	   */
	  color: _propTypes.default.oneOf(['initial', 'inherit', 'primary', 'secondary', 'textPrimary', 'textSecondary', 'error']),
	
	  /**
	   * The component used for the root node.
	   * Either a string to use a DOM element or a component.
	   * Overrides the behavior of the `variantMapping` prop.
	   */
	  component: _propTypes.default.elementType,
	
	  /**
	   * Controls the display type
	   */
	  display: _propTypes.default.oneOf(['initial', 'block', 'inline']),
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  gutterBottom: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will not wrap, but instead will truncate with a text overflow ellipsis.
	   *
	   * Note that text overflow can only happen with block or inline-block level elements
	   * (the element needs to have a width in order to overflow).
	   */
	  noWrap: _propTypes.default.bool,
	
	  /**
	   * If `true`, the text will have a bottom margin.
	   */
	  paragraph: _propTypes.default.bool,
	
	  /**
	   * Applies the theme typography styles.
	   */
	  variant: _propTypes.default.oneOf(['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline', 'srOnly', 'inherit']),
	
	  /**
	   * The component maps the variant prop to a range of different DOM element types.
	   * For instance, subtitle1 to `<h6>`.
	   * If you wish to change that mapping, you can provide your own.
	   * Alternatively, you can use the `component` prop.
	   */
	  variantMapping: _propTypes.default.object
	} : void 0;
	
	var _default = (0, _withStyles.default)(styles, {
	  name: 'MuiTypography'
	})(Typography);
	
	exports.default = _default;

/***/ },
/* 403 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _reactTransitionGroup = __webpack_require__(46);
	
	var _transitions = __webpack_require__(26);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var _utils = __webpack_require__(44);
	
	var _useForkRef = _interopRequireDefault(__webpack_require__(11));
	
	var styles = {
	  entering: {
	    transform: 'none'
	  },
	  entered: {
	    transform: 'none'
	  }
	};
	var defaultTimeout = {
	  enter: _transitions.duration.enteringScreen,
	  exit: _transitions.duration.leavingScreen
	};
	/**
	 * The Zoom transition can be used for the floating variant of the
	 * [Button](/components/buttons/#floating-action-buttons) component.
	 * It uses [react-transition-group](https://github.com/reactjs/react-transition-group) internally.
	 */
	
	var Zoom = React.forwardRef(function Zoom(props, ref) {
	  var children = props.children,
	      inProp = props.in,
	      onEnter = props.onEnter,
	      onExit = props.onExit,
	      style = props.style,
	      _props$timeout = props.timeout,
	      timeout = _props$timeout === void 0 ? defaultTimeout : _props$timeout,
	      other = (0, _objectWithoutProperties2.default)(props, ["children", "in", "onEnter", "onExit", "style", "timeout"]);
	  var theme = (0, _useTheme.default)();
	  var handleRef = (0, _useForkRef.default)(children.ref, ref);
	
	  var handleEnter = function handleEnter(node, isAppearing) {
	    (0, _utils.reflow)(node); // So the animation always start from the start.
	
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'enter'
	    });
	    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	    node.style.transition = theme.transitions.create('transform', transitionProps);
	
	    if (onEnter) {
	      onEnter(node, isAppearing);
	    }
	  };
	
	  var handleExit = function handleExit(node) {
	    var transitionProps = (0, _utils.getTransitionProps)({
	      style: style,
	      timeout: timeout
	    }, {
	      mode: 'exit'
	    });
	    node.style.webkitTransition = theme.transitions.create('transform', transitionProps);
	    node.style.transition = theme.transitions.create('transform', transitionProps);
	
	    if (onExit) {
	      onExit(node);
	    }
	  };
	
	  return /*#__PURE__*/React.createElement(_reactTransitionGroup.Transition, (0, _extends2.default)({
	    appear: true,
	    in: inProp,
	    onEnter: handleEnter,
	    onExit: handleExit,
	    timeout: timeout
	  }, other), function (state, childProps) {
	    return React.cloneElement(children, (0, _extends2.default)({
	      style: (0, _extends2.default)({
	        transform: 'scale(0)',
	        visibility: state === 'exited' && !inProp ? 'hidden' : undefined
	      }, styles[state], {}, style, {}, children.props.style),
	      ref: handleRef
	    }, childProps));
	  });
	});
	 false ? Zoom.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * A single child content element.
	   */
	  children: _propTypes.default.element,
	
	  /**
	   * If `true`, the component will transition in.
	   */
	  in: _propTypes.default.bool,
	
	  /**
	   * @ignore
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * @ignore
	   */
	  style: _propTypes.default.object,
	
	  /**
	   * The duration for the transition, in milliseconds.
	   * You may specify a single timeout for all transitions, or individually with an object.
	   */
	  timeout: _propTypes.default.oneOfType([_propTypes.default.number, _propTypes.default.shape({
	    appear: _propTypes.default.number,
	    enter: _propTypes.default.number,
	    exit: _propTypes.default.number
	  })])
	} : void 0;
	var _default = Zoom;
	exports.default = _default;

/***/ },
/* 404 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Zoom.default;
	  }
	});
	
	var _Zoom = _interopRequireDefault(__webpack_require__(403));

/***/ },
/* 405 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var amber = {
	  50: '#fff8e1',
	  100: '#ffecb3',
	  200: '#ffe082',
	  300: '#ffd54f',
	  400: '#ffca28',
	  500: '#ffc107',
	  600: '#ffb300',
	  700: '#ffa000',
	  800: '#ff8f00',
	  900: '#ff6f00',
	  A100: '#ffe57f',
	  A200: '#ffd740',
	  A400: '#ffc400',
	  A700: '#ffab00'
	};
	var _default = amber;
	exports.default = _default;

/***/ },
/* 406 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var blueGrey = {
	  50: '#eceff1',
	  100: '#cfd8dc',
	  200: '#b0bec5',
	  300: '#90a4ae',
	  400: '#78909c',
	  500: '#607d8b',
	  600: '#546e7a',
	  700: '#455a64',
	  800: '#37474f',
	  900: '#263238',
	  A100: '#cfd8dc',
	  A200: '#b0bec5',
	  A400: '#78909c',
	  A700: '#455a64'
	};
	var _default = blueGrey;
	exports.default = _default;

/***/ },
/* 407 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var brown = {
	  50: '#efebe9',
	  100: '#d7ccc8',
	  200: '#bcaaa4',
	  300: '#a1887f',
	  400: '#8d6e63',
	  500: '#795548',
	  600: '#6d4c41',
	  700: '#5d4037',
	  800: '#4e342e',
	  900: '#3e2723',
	  A100: '#d7ccc8',
	  A200: '#bcaaa4',
	  A400: '#8d6e63',
	  A700: '#5d4037'
	};
	var _default = brown;
	exports.default = _default;

/***/ },
/* 408 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var cyan = {
	  50: '#e0f7fa',
	  100: '#b2ebf2',
	  200: '#80deea',
	  300: '#4dd0e1',
	  400: '#26c6da',
	  500: '#00bcd4',
	  600: '#00acc1',
	  700: '#0097a7',
	  800: '#00838f',
	  900: '#006064',
	  A100: '#84ffff',
	  A200: '#18ffff',
	  A400: '#00e5ff',
	  A700: '#00b8d4'
	};
	var _default = cyan;
	exports.default = _default;

/***/ },
/* 409 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepOrange = {
	  50: '#fbe9e7',
	  100: '#ffccbc',
	  200: '#ffab91',
	  300: '#ff8a65',
	  400: '#ff7043',
	  500: '#ff5722',
	  600: '#f4511e',
	  700: '#e64a19',
	  800: '#d84315',
	  900: '#bf360c',
	  A100: '#ff9e80',
	  A200: '#ff6e40',
	  A400: '#ff3d00',
	  A700: '#dd2c00'
	};
	var _default = deepOrange;
	exports.default = _default;

/***/ },
/* 410 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var deepPurple = {
	  50: '#ede7f6',
	  100: '#d1c4e9',
	  200: '#b39ddb',
	  300: '#9575cd',
	  400: '#7e57c2',
	  500: '#673ab7',
	  600: '#5e35b1',
	  700: '#512da8',
	  800: '#4527a0',
	  900: '#311b92',
	  A100: '#b388ff',
	  A200: '#7c4dff',
	  A400: '#651fff',
	  A700: '#6200ea'
	};
	var _default = deepPurple;
	exports.default = _default;

/***/ },
/* 411 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "common", {
	  enumerable: true,
	  get: function get() {
	    return _common.default;
	  }
	});
	Object.defineProperty(exports, "red", {
	  enumerable: true,
	  get: function get() {
	    return _red.default;
	  }
	});
	Object.defineProperty(exports, "pink", {
	  enumerable: true,
	  get: function get() {
	    return _pink.default;
	  }
	});
	Object.defineProperty(exports, "purple", {
	  enumerable: true,
	  get: function get() {
	    return _purple.default;
	  }
	});
	Object.defineProperty(exports, "deepPurple", {
	  enumerable: true,
	  get: function get() {
	    return _deepPurple.default;
	  }
	});
	Object.defineProperty(exports, "indigo", {
	  enumerable: true,
	  get: function get() {
	    return _indigo.default;
	  }
	});
	Object.defineProperty(exports, "blue", {
	  enumerable: true,
	  get: function get() {
	    return _blue.default;
	  }
	});
	Object.defineProperty(exports, "lightBlue", {
	  enumerable: true,
	  get: function get() {
	    return _lightBlue.default;
	  }
	});
	Object.defineProperty(exports, "cyan", {
	  enumerable: true,
	  get: function get() {
	    return _cyan.default;
	  }
	});
	Object.defineProperty(exports, "teal", {
	  enumerable: true,
	  get: function get() {
	    return _teal.default;
	  }
	});
	Object.defineProperty(exports, "green", {
	  enumerable: true,
	  get: function get() {
	    return _green.default;
	  }
	});
	Object.defineProperty(exports, "lightGreen", {
	  enumerable: true,
	  get: function get() {
	    return _lightGreen.default;
	  }
	});
	Object.defineProperty(exports, "lime", {
	  enumerable: true,
	  get: function get() {
	    return _lime.default;
	  }
	});
	Object.defineProperty(exports, "yellow", {
	  enumerable: true,
	  get: function get() {
	    return _yellow.default;
	  }
	});
	Object.defineProperty(exports, "amber", {
	  enumerable: true,
	  get: function get() {
	    return _amber.default;
	  }
	});
	Object.defineProperty(exports, "orange", {
	  enumerable: true,
	  get: function get() {
	    return _orange.default;
	  }
	});
	Object.defineProperty(exports, "deepOrange", {
	  enumerable: true,
	  get: function get() {
	    return _deepOrange.default;
	  }
	});
	Object.defineProperty(exports, "brown", {
	  enumerable: true,
	  get: function get() {
	    return _brown.default;
	  }
	});
	Object.defineProperty(exports, "grey", {
	  enumerable: true,
	  get: function get() {
	    return _grey.default;
	  }
	});
	Object.defineProperty(exports, "blueGrey", {
	  enumerable: true,
	  get: function get() {
	    return _blueGrey.default;
	  }
	});
	
	var _common = _interopRequireDefault(__webpack_require__(149));
	
	var _red = _interopRequireDefault(__webpack_require__(155));
	
	var _pink = _interopRequireDefault(__webpack_require__(154));
	
	var _purple = _interopRequireDefault(__webpack_require__(415));
	
	var _deepPurple = _interopRequireDefault(__webpack_require__(410));
	
	var _indigo = _interopRequireDefault(__webpack_require__(152));
	
	var _blue = _interopRequireDefault(__webpack_require__(148));
	
	var _lightBlue = _interopRequireDefault(__webpack_require__(412));
	
	var _cyan = _interopRequireDefault(__webpack_require__(408));
	
	var _teal = _interopRequireDefault(__webpack_require__(416));
	
	var _green = _interopRequireDefault(__webpack_require__(150));
	
	var _lightGreen = _interopRequireDefault(__webpack_require__(413));
	
	var _lime = _interopRequireDefault(__webpack_require__(414));
	
	var _yellow = _interopRequireDefault(__webpack_require__(417));
	
	var _amber = _interopRequireDefault(__webpack_require__(405));
	
	var _orange = _interopRequireDefault(__webpack_require__(153));
	
	var _deepOrange = _interopRequireDefault(__webpack_require__(409));
	
	var _brown = _interopRequireDefault(__webpack_require__(407));
	
	var _grey = _interopRequireDefault(__webpack_require__(151));
	
	var _blueGrey = _interopRequireDefault(__webpack_require__(406));

/***/ },
/* 412 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightBlue = {
	  50: '#e1f5fe',
	  100: '#b3e5fc',
	  200: '#81d4fa',
	  300: '#4fc3f7',
	  400: '#29b6f6',
	  500: '#03a9f4',
	  600: '#039be5',
	  700: '#0288d1',
	  800: '#0277bd',
	  900: '#01579b',
	  A100: '#80d8ff',
	  A200: '#40c4ff',
	  A400: '#00b0ff',
	  A700: '#0091ea'
	};
	var _default = lightBlue;
	exports.default = _default;

/***/ },
/* 413 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lightGreen = {
	  50: '#f1f8e9',
	  100: '#dcedc8',
	  200: '#c5e1a5',
	  300: '#aed581',
	  400: '#9ccc65',
	  500: '#8bc34a',
	  600: '#7cb342',
	  700: '#689f38',
	  800: '#558b2f',
	  900: '#33691e',
	  A100: '#ccff90',
	  A200: '#b2ff59',
	  A400: '#76ff03',
	  A700: '#64dd17'
	};
	var _default = lightGreen;
	exports.default = _default;

/***/ },
/* 414 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var lime = {
	  50: '#f9fbe7',
	  100: '#f0f4c3',
	  200: '#e6ee9c',
	  300: '#dce775',
	  400: '#d4e157',
	  500: '#cddc39',
	  600: '#c0ca33',
	  700: '#afb42b',
	  800: '#9e9d24',
	  900: '#827717',
	  A100: '#f4ff81',
	  A200: '#eeff41',
	  A400: '#c6ff00',
	  A700: '#aeea00'
	};
	var _default = lime;
	exports.default = _default;

/***/ },
/* 415 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var purple = {
	  50: '#f3e5f5',
	  100: '#e1bee7',
	  200: '#ce93d8',
	  300: '#ba68c8',
	  400: '#ab47bc',
	  500: '#9c27b0',
	  600: '#8e24aa',
	  700: '#7b1fa2',
	  800: '#6a1b9a',
	  900: '#4a148c',
	  A100: '#ea80fc',
	  A200: '#e040fb',
	  A400: '#d500f9',
	  A700: '#aa00ff'
	};
	var _default = purple;
	exports.default = _default;

/***/ },
/* 416 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var teal = {
	  50: '#e0f2f1',
	  100: '#b2dfdb',
	  200: '#80cbc4',
	  300: '#4db6ac',
	  400: '#26a69a',
	  500: '#009688',
	  600: '#00897b',
	  700: '#00796b',
	  800: '#00695c',
	  900: '#004d40',
	  A100: '#a7ffeb',
	  A200: '#64ffda',
	  A400: '#1de9b6',
	  A700: '#00bfa5'
	};
	var _default = teal;
	exports.default = _default;

/***/ },
/* 417 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var yellow = {
	  50: '#fffde7',
	  100: '#fff9c4',
	  200: '#fff59d',
	  300: '#fff176',
	  400: '#ffee58',
	  500: '#ffeb3b',
	  600: '#fdd835',
	  700: '#fbc02d',
	  800: '#f9a825',
	  900: '#f57f17',
	  A100: '#ffff8d',
	  A200: '#ffff00',
	  A400: '#ffea00',
	  A700: '#ffd600'
	};
	var _default = yellow;
	exports.default = _default;

/***/ },
/* 418 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = animate;
	
	function easeInOutSin(time) {
	  return (1 + Math.sin(Math.PI * time - Math.PI / 2)) / 2;
	}
	
	function animate(property, element, to) {
	  var options = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : {};
	  var cb = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : function () {};
	  var _options$ease = options.ease,
	      ease = _options$ease === void 0 ? easeInOutSin : _options$ease,
	      _options$duration = options.duration,
	      duration = _options$duration === void 0 ? 300 : _options$duration;
	  var start = null;
	  var from = element[property];
	  var cancelled = false;
	
	  var cancel = function cancel() {
	    cancelled = true;
	  };
	
	  var step = function step(timestamp) {
	    if (cancelled) {
	      cb(new Error('Animation cancelled'));
	      return;
	    }
	
	    if (start === null) {
	      start = timestamp;
	    }
	
	    var time = Math.min(1, (timestamp - start) / duration);
	    element[property] = ease(time) * (to - from) + from;
	
	    if (time >= 1) {
	      requestAnimationFrame(function () {
	        cb(null);
	      });
	      return;
	    }
	
	    requestAnimationFrame(step);
	  };
	
	  if (from === to) {
	    cb(new Error('Element already at target position'));
	    return cancel;
	  }
	
	  requestAnimationFrame(step);
	  return cancel;
	}

/***/ },
/* 419 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M20 12l-1.41-1.41L13 16.17V4h-2v12.17l-5.58-5.59L4 12l8 8 8-8z"
	}), 'ArrowDownward');
	
	exports.default = _default;

/***/ },
/* 420 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 2C6.47 2 2 6.47 2 12s4.47 10 10 10 10-4.47 10-10S17.53 2 12 2zm5 13.59L15.59 17 12 13.41 8.41 17 7 15.59 10.59 12 7 8.41 8.41 7 12 10.59 15.59 7 17 8.41 13.41 12 17 15.59z"
	}), 'Cancel');
	
	exports.default = _default;

/***/ },
/* 421 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 3H5c-1.11 0-2 .9-2 2v14c0 1.1.89 2 2 2h14c1.11 0 2-.9 2-2V5c0-1.1-.89-2-2-2zm-9 14l-5-5 1.41-1.41L10 14.17l7.59-7.59L19 8l-9 9z"
	}), 'CheckBox');
	
	exports.default = _default;

/***/ },
/* 422 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 5v14H5V5h14m0-2H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2z"
	}), 'CheckBoxOutlineBlank');
	
	exports.default = _default;

/***/ },
/* 423 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 0a12 12 0 1 0 0 24 12 12 0 0 0 0-24zm-2 17l-5-5 1.4-1.4 3.6 3.6 7.6-7.6L19 8l-9 9z"
	}), 'CheckCircle');
	
	exports.default = _default;

/***/ },
/* 424 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 3H5c-1.1 0-2 .9-2 2v14c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2V5c0-1.1-.9-2-2-2zm-2 10H7v-2h10v2z"
	}), 'IndeterminateCheckBox');
	
	exports.default = _default;

/***/ },
/* 425 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M6 10c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm12 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2zm-6 0c-1.1 0-2 .9-2 2s.9 2 2 2 2-.9 2-2-.9-2-2-2z"
	}), 'MoreHoriz');
	
	exports.default = _default;

/***/ },
/* 426 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 12c2.21 0 4-1.79 4-4s-1.79-4-4-4-4 1.79-4 4 1.79 4 4 4zm0 2c-2.67 0-8 1.34-8 4v2h16v-2c0-2.66-5.33-4-8-4z"
	}), 'Person');
	
	exports.default = _default;

/***/ },
/* 427 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M8.465 8.465C9.37 7.56 10.62 7 12 7C14.76 7 17 9.24 17 12C17 13.38 16.44 14.63 15.535 15.535C14.63 16.44 13.38 17 12 17C9.24 17 7 14.76 7 12C7 10.62 7.56 9.37 8.465 8.465Z"
	}), 'RadioButtonChecked');
	
	exports.default = _default;

/***/ },
/* 428 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M12 2C6.48 2 2 6.48 2 12s4.48 10 10 10 10-4.48 10-10S17.52 2 12 2zm0 18c-4.42 0-8-3.58-8-8s3.58-8 8-8 8 3.58 8 8-3.58 8-8 8z"
	}), 'RadioButtonUnchecked');
	
	exports.default = _default;

/***/ },
/* 429 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(17));
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _createSvgIcon.default)( /*#__PURE__*/React.createElement("path", {
	  d: "M1 21h22L12 2 1 21zm12-3h-2v-2h2v2zm0-4h-2v-4h2v4z"
	}), 'Warning');
	
	exports.default = _default;

/***/ },
/* 430 */
94,
/* 431 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createMixins;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(5));
	
	function createMixins(breakpoints, spacing, mixins) {
	  var _toolbar;
	
	  return (0, _extends3.default)({
	    gutters: function gutters() {
	      var styles = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      // To deprecate in v4.1
	      //       warning(
	      //         false,
	      //         [
	      //           'Material-UI: theme.mixins.gutters() is deprecated.',
	      //           'You can use the source of the mixin directly:',
	      //           `
	      // paddingLeft: theme.spacing(2),
	      // paddingRight: theme.spacing(2),
	      // [theme.breakpoints.up('sm')]: {
	      //   paddingLeft: theme.spacing(3),
	      //   paddingRight: theme.spacing(3),
	      // },
	      // `,
	      //         ].join('\n'),
	      //       );
	      return (0, _extends3.default)({
	        paddingLeft: spacing(2),
	        paddingRight: spacing(2)
	      }, styles, (0, _defineProperty2.default)({}, breakpoints.up('sm'), (0, _extends3.default)({
	        paddingLeft: spacing(3),
	        paddingRight: spacing(3)
	      }, styles[breakpoints.up('sm')])));
	    },
	    toolbar: (_toolbar = {
	      minHeight: 56
	    }, (0, _defineProperty2.default)(_toolbar, "".concat(breakpoints.up('xs'), " and (orientation: landscape)"), {
	      minHeight: 48
	    }), (0, _defineProperty2.default)(_toolbar, breakpoints.up('sm'), {
	      minHeight: 64
	    }), _toolbar)
	  }, mixins);
	}

/***/ },
/* 432 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createPalette;
	exports.dark = exports.light = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(9);
	
	var _common = _interopRequireDefault(__webpack_require__(149));
	
	var _grey = _interopRequireDefault(__webpack_require__(151));
	
	var _indigo = _interopRequireDefault(__webpack_require__(152));
	
	var _pink = _interopRequireDefault(__webpack_require__(154));
	
	var _red = _interopRequireDefault(__webpack_require__(155));
	
	var _orange = _interopRequireDefault(__webpack_require__(153));
	
	var _blue = _interopRequireDefault(__webpack_require__(148));
	
	var _green = _interopRequireDefault(__webpack_require__(150));
	
	var _colorManipulator = __webpack_require__(15);
	
	var light = {
	  // The colors used to style the text.
	  text: {
	    // The most important text.
	    primary: 'rgba(0, 0, 0, 0.87)',
	    // Secondary text.
	    secondary: 'rgba(0, 0, 0, 0.54)',
	    // Disabled text have even lower visual prominence.
	    disabled: 'rgba(0, 0, 0, 0.38)',
	    // Text hints.
	    hint: 'rgba(0, 0, 0, 0.38)'
	  },
	  // The color used to divide different elements.
	  divider: 'rgba(0, 0, 0, 0.12)',
	  // The background colors used to style the surfaces.
	  // Consistency between these values is important.
	  background: {
	    paper: _common.default.white,
	    default: _grey.default[50]
	  },
	  // The colors used to style the action elements.
	  action: {
	    // The color of an active action like an icon button.
	    active: 'rgba(0, 0, 0, 0.54)',
	    // The color of an hovered action.
	    hover: 'rgba(0, 0, 0, 0.04)',
	    hoverOpacity: 0.04,
	    // The color of a selected action.
	    selected: 'rgba(0, 0, 0, 0.08)',
	    selectedOpacity: 0.08,
	    // The color of a disabled action.
	    disabled: 'rgba(0, 0, 0, 0.26)',
	    // The background color of a disabled action.
	    disabledBackground: 'rgba(0, 0, 0, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(0, 0, 0, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpacity: 0.12
	  }
	};
	exports.light = light;
	var dark = {
	  text: {
	    primary: _common.default.white,
	    secondary: 'rgba(255, 255, 255, 0.7)',
	    disabled: 'rgba(255, 255, 255, 0.5)',
	    hint: 'rgba(255, 255, 255, 0.5)',
	    icon: 'rgba(255, 255, 255, 0.5)'
	  },
	  divider: 'rgba(255, 255, 255, 0.12)',
	  background: {
	    paper: _grey.default[800],
	    default: '#303030'
	  },
	  action: {
	    active: _common.default.white,
	    hover: 'rgba(255, 255, 255, 0.08)',
	    hoverOpacity: 0.08,
	    selected: 'rgba(255, 255, 255, 0.16)',
	    selectedOpacity: 0.16,
	    disabled: 'rgba(255, 255, 255, 0.3)',
	    disabledBackground: 'rgba(255, 255, 255, 0.12)',
	    disabledOpacity: 0.38,
	    focus: 'rgba(255, 255, 255, 0.12)',
	    focusOpacity: 0.12,
	    activatedOpacity: 0.24
	  }
	};
	exports.dark = dark;
	
	function addLightOrDark(intent, direction, shade, tonalOffset) {
	  if (!intent[direction]) {
	    if (intent.hasOwnProperty(shade)) {
	      intent[direction] = intent[shade];
	    } else if (direction === 'light') {
	      intent.light = (0, _colorManipulator.lighten)(intent.main, tonalOffset);
	    } else if (direction === 'dark') {
	      intent.dark = (0, _colorManipulator.darken)(intent.main, tonalOffset * 1.5);
	    }
	  }
	}
	
	function createPalette(palette) {
	  var _palette$primary = palette.primary,
	      primary = _palette$primary === void 0 ? {
	    light: _indigo.default[300],
	    main: _indigo.default[500],
	    dark: _indigo.default[700]
	  } : _palette$primary,
	      _palette$secondary = palette.secondary,
	      secondary = _palette$secondary === void 0 ? {
	    light: _pink.default.A200,
	    main: _pink.default.A400,
	    dark: _pink.default.A700
	  } : _palette$secondary,
	      _palette$error = palette.error,
	      error = _palette$error === void 0 ? {
	    light: _red.default[300],
	    main: _red.default[500],
	    dark: _red.default[700]
	  } : _palette$error,
	      _palette$warning = palette.warning,
	      warning = _palette$warning === void 0 ? {
	    light: _orange.default[300],
	    main: _orange.default[500],
	    dark: _orange.default[700]
	  } : _palette$warning,
	      _palette$info = palette.info,
	      info = _palette$info === void 0 ? {
	    light: _blue.default[300],
	    main: _blue.default[500],
	    dark: _blue.default[700]
	  } : _palette$info,
	      _palette$success = palette.success,
	      success = _palette$success === void 0 ? {
	    light: _green.default[300],
	    main: _green.default[500],
	    dark: _green.default[700]
	  } : _palette$success,
	      _palette$type = palette.type,
	      type = _palette$type === void 0 ? 'light' : _palette$type,
	      _palette$contrastThre = palette.contrastThreshold,
	      contrastThreshold = _palette$contrastThre === void 0 ? 3 : _palette$contrastThre,
	      _palette$tonalOffset = palette.tonalOffset,
	      tonalOffset = _palette$tonalOffset === void 0 ? 0.2 : _palette$tonalOffset,
	      other = (0, _objectWithoutProperties2.default)(palette, ["primary", "secondary", "error", "warning", "info", "success", "type", "contrastThreshold", "tonalOffset"]); // Use the same logic as
	  // Bootstrap: https://github.com/twbs/bootstrap/blob/1d6e3710dd447de1a200f29e8fa521f8a0908f70/scss/_functions.scss#L59
	  // and material-components-web https://github.com/material-components/material-components-web/blob/ac46b8863c4dab9fc22c4c662dc6bd1b65dd652f/packages/mdc-theme/_functions.scss#L54
	
	  function getContrastText(background) {
	    var contrastText = (0, _colorManipulator.getContrastRatio)(background, dark.text.primary) >= contrastThreshold ? dark.text.primary : light.text.primary;
	
	    if (false) {
	      var contrast = (0, _colorManipulator.getContrastRatio)(background, contrastText);
	
	      if (contrast < 3) {
	        console.error(["Material-UI: the contrast ratio of ".concat(contrast, ":1 for ").concat(contrastText, " on ").concat(background), 'falls below the WCAG recommended absolute minimum contrast ratio of 3:1.', 'https://www.w3.org/TR/2008/REC-WCAG20-20081211/#visual-audio-contrast-contrast'].join('\n'));
	      }
	    }
	
	    return contrastText;
	  }
	
	  var augmentColor = function augmentColor(color) {
	    var mainShade = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 500;
	    var lightShade = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 300;
	    var darkShade = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 700;
	    color = (0, _extends2.default)({}, color);
	
	    if (!color.main && color[mainShade]) {
	      color.main = color[mainShade];
	    }
	
	    if (!color.main) {
	      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "The color object needs to have a `main` property or a `".concat(mainShade, "` property.")].join('\n'));
	    }
	
	    if (typeof color.main !== 'string') {
	      throw new Error(['Material-UI: the color provided to augmentColor(color) is invalid.', "`color.main` should be a string, but `".concat(JSON.stringify(color.main), "` was provided instead."), '', 'Did you intend to use one of the following approaches?', '', 'import { green } from "@material-ui/core/colors";', '', 'const theme1 = createMuiTheme({ palette: {', '  primary: green,', '} });', '', 'const theme2 = createMuiTheme({ palette: {', '  primary: { main: green[500] },', '} });'].join('\n'));
	    }
	
	    addLightOrDark(color, 'light', lightShade, tonalOffset);
	    addLightOrDark(color, 'dark', darkShade, tonalOffset);
	
	    if (!color.contrastText) {
	      color.contrastText = getContrastText(color.main);
	    }
	
	    return color;
	  };
	
	  var types = {
	    dark: dark,
	    light: light
	  };
	
	  if (false) {
	    if (!types[type]) {
	      console.error("Material-UI: the palette type `".concat(type, "` is not supported."));
	    }
	  }
	
	  var paletteOutput = (0, _utils.deepmerge)((0, _extends2.default)({
	    // A collection of common colors.
	    common: _common.default,
	    // The palette type, can be light or dark.
	    type: type,
	    // The colors used to represent primary interface elements for a user.
	    primary: augmentColor(primary),
	    // The colors used to represent secondary interface elements for a user.
	    secondary: augmentColor(secondary, 'A400', 'A200', 'A700'),
	    // The colors used to represent interface elements that the user should be made aware of.
	    error: augmentColor(error),
	    // The colors used to represent potentially dangerous actions or important messages.
	    warning: augmentColor(warning),
	    // The colors used to present information to the user that is neutral and not necessarily important.
	    info: augmentColor(info),
	    // The colors used to indicate the successful completion of an action that user triggered.
	    success: augmentColor(success),
	    // The grey colors.
	    grey: _grey.default,
	    // Used by `getContrastText()` to maximize the contrast between
	    // the background and the text.
	    contrastThreshold: contrastThreshold,
	    // Takes a background color and returns the text color that maximizes the contrast.
	    getContrastText: getContrastText,
	    // Generate a rich color object.
	    augmentColor: augmentColor,
	    // Used by the functions below to shift a color's luminance by approximately
	    // two indexes within its tonal palette.
	    // E.g., shift from Red 500 to Red 300 or Red 700.
	    tonalOffset: tonalOffset
	  }, types[type]), other);
	  return paletteOutput;
	}

/***/ },
/* 433 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createSpacing;
	
	var _system = __webpack_require__(173);
	
	var warnOnce;
	
	function createSpacing() {
	  var spacingInput = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : 8;
	
	  // Already transformed.
	  if (spacingInput.mui) {
	    return spacingInput;
	  } // Material Design layouts are visually balanced. Most measurements align to an 8dp grid applied, which aligns both spacing and the overall layout.
	  // Smaller components, such as icons and type, can align to a 4dp grid.
	  // https://material.io/design/layout/understanding-layout.html#usage
	
	
	  var transform = (0, _system.createUnarySpacing)({
	    spacing: spacingInput
	  });
	
	  var spacing = function spacing() {
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    if (false) {
	      if (!(args.length <= 4)) {
	        console.error("Material-UI: Too many arguments provided, expected between 0 and 4, got ".concat(args.length));
	      }
	    }
	
	    if (args.length === 0) {
	      return transform(1);
	    }
	
	    if (args.length === 1) {
	      return transform(args[0]);
	    }
	
	    return args.map(function (argument) {
	      if (typeof argument === 'string') {
	        return argument;
	      }
	
	      var output = transform(argument);
	      return typeof output === 'number' ? "".concat(output, "px") : output;
	    }).join(' ');
	  }; // Backward compatibility, to remove in v5.
	
	
	  Object.defineProperty(spacing, 'unit', {
	    get: function get() {
	      if (false) {
	        if (!warnOnce || process.env.NODE_ENV === 'test') {
	          console.error(['Material-UI: theme.spacing.unit usage has been deprecated.', 'It will be removed in v5.', 'You can replace `theme.spacing.unit * y` with `theme.spacing(y)`.', '', 'You can use the `https://github.com/mui-org/material-ui/tree/master/packages/material-ui-codemod/README.md#theme-spacing-api` migration helper to make the process smoother.'].join('\n'));
	        }
	
	        warnOnce = true;
	      }
	
	      return spacingInput;
	    }
	  });
	  spacing.mui = true;
	  return spacing;
	}

/***/ },
/* 434 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	var _styles = __webpack_require__(20);
	
	// let warnOnce = false;
	// To remove in v5
	function createStyles(styles) {
	  // warning(
	  //   warnOnce,
	  //   [
	  //     'Material-UI: createStyles from @material-ui/core/styles is deprecated.',
	  //     'Please use @material-ui/styles/createStyles',
	  //   ].join('\n'),
	  // );
	  // warnOnce = true;
	  return (0, _styles.createStyles)(styles);
	}

/***/ },
/* 435 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createTypography;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _utils = __webpack_require__(9);
	
	function round(value) {
	  return Math.round(value * 1e5) / 1e5;
	}
	
	var caseAllCaps = {
	  textTransform: 'uppercase'
	};
	var defaultFontFamily = '"Roboto", "Helvetica", "Arial", sans-serif';
	/**
	 * @see @link{https://material.io/design/typography/the-type-system.html}
	 * @see @link{https://material.io/design/typography/understanding-typography.html}
	 */
	
	function createTypography(palette, typography) {
	  var _ref = typeof typography === 'function' ? typography(palette) : typography,
	      _ref$fontFamily = _ref.fontFamily,
	      fontFamily = _ref$fontFamily === void 0 ? defaultFontFamily : _ref$fontFamily,
	      _ref$fontSize = _ref.fontSize,
	      fontSize = _ref$fontSize === void 0 ? 14 : _ref$fontSize,
	      _ref$fontWeightLight = _ref.fontWeightLight,
	      fontWeightLight = _ref$fontWeightLight === void 0 ? 300 : _ref$fontWeightLight,
	      _ref$fontWeightRegula = _ref.fontWeightRegular,
	      fontWeightRegular = _ref$fontWeightRegula === void 0 ? 400 : _ref$fontWeightRegula,
	      _ref$fontWeightMedium = _ref.fontWeightMedium,
	      fontWeightMedium = _ref$fontWeightMedium === void 0 ? 500 : _ref$fontWeightMedium,
	      _ref$fontWeightBold = _ref.fontWeightBold,
	      fontWeightBold = _ref$fontWeightBold === void 0 ? 700 : _ref$fontWeightBold,
	      _ref$htmlFontSize = _ref.htmlFontSize,
	      htmlFontSize = _ref$htmlFontSize === void 0 ? 16 : _ref$htmlFontSize,
	      allVariants = _ref.allVariants,
	      pxToRem2 = _ref.pxToRem,
	      other = (0, _objectWithoutProperties2.default)(_ref, ["fontFamily", "fontSize", "fontWeightLight", "fontWeightRegular", "fontWeightMedium", "fontWeightBold", "htmlFontSize", "allVariants", "pxToRem"]);
	
	  if (false) {
	    if (typeof fontSize !== 'number') {
	      console.error('Material-UI: `fontSize` is required to be a number.');
	    }
	
	    if (typeof htmlFontSize !== 'number') {
	      console.error('Material-UI: `htmlFontSize` is required to be a number.');
	    }
	  }
	
	  var coef = fontSize / 14;
	
	  var pxToRem = pxToRem2 || function (size) {
	    return "".concat(size / htmlFontSize * coef, "rem");
	  };
	
	  var buildVariant = function buildVariant(fontWeight, size, lineHeight, letterSpacing, casing) {
	    return (0, _extends2.default)({
	      fontFamily: fontFamily,
	      fontWeight: fontWeight,
	      fontSize: pxToRem(size),
	      // Unitless following https://meyerweb.com/eric/thoughts/2006/02/08/unitless-line-heights/
	      lineHeight: lineHeight
	    }, fontFamily === defaultFontFamily ? {
	      letterSpacing: "".concat(round(letterSpacing / size), "em")
	    } : {}, {}, casing, {}, allVariants);
	  };
	
	  var variants = {
	    h1: buildVariant(fontWeightLight, 96, 1.167, -1.5),
	    h2: buildVariant(fontWeightLight, 60, 1.2, -0.5),
	    h3: buildVariant(fontWeightRegular, 48, 1.167, 0),
	    h4: buildVariant(fontWeightRegular, 34, 1.235, 0.25),
	    h5: buildVariant(fontWeightRegular, 24, 1.334, 0),
	    h6: buildVariant(fontWeightMedium, 20, 1.6, 0.15),
	    subtitle1: buildVariant(fontWeightRegular, 16, 1.75, 0.15),
	    subtitle2: buildVariant(fontWeightMedium, 14, 1.57, 0.1),
	    body1: buildVariant(fontWeightRegular, 16, 1.5, 0.15),
	    body2: buildVariant(fontWeightRegular, 14, 1.43, 0.15),
	    button: buildVariant(fontWeightMedium, 14, 1.75, 0.4, caseAllCaps),
	    caption: buildVariant(fontWeightRegular, 12, 1.66, 0.4),
	    overline: buildVariant(fontWeightRegular, 12, 2.66, 1, caseAllCaps)
	  };
	  return (0, _utils.deepmerge)((0, _extends2.default)({
	    htmlFontSize: htmlFontSize,
	    pxToRem: pxToRem,
	    round: round,
	    // TODO v5: remove
	    fontFamily: fontFamily,
	    fontSize: fontSize,
	    fontWeightLight: fontWeightLight,
	    fontWeightRegular: fontWeightRegular,
	    fontWeightMedium: fontWeightMedium,
	    fontWeightBold: fontWeightBold
	  }, variants), other, {
	    clone: false // No need to clone deep
	
	  });
	}

/***/ },
/* 436 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isUnitless = isUnitless;
	exports.getUnit = getUnit;
	exports.toUnitless = toUnitless;
	exports.convertLength = convertLength;
	exports.alignProperty = alignProperty;
	exports.fontGrid = fontGrid;
	exports.responsiveProperty = responsiveProperty;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	function isUnitless(value) {
	  return String(parseFloat(value)).length === String(value).length;
	} // Ported from Compass
	// https://github.com/Compass/compass/blob/master/core/stylesheets/compass/typography/_units.scss
	// Emulate the sass function "unit"
	
	
	function getUnit(input) {
	  return String(input).match(/[\d.\-+]*\s*(.*)/)[1] || '';
	} // Emulate the sass function "unitless"
	
	
	function toUnitless(length) {
	  return parseFloat(length);
	} // Convert any CSS <length> or <percentage> value to any another.
	// From https://github.com/KyleAMathews/convert-css-length
	
	
	function convertLength(baseFontSize) {
	  return function (length, toUnit) {
	    var fromUnit = getUnit(length); // Optimize for cases where `from` and `to` units are accidentally the same.
	
	    if (fromUnit === toUnit) {
	      return length;
	    } // Convert input length to pixels.
	
	
	    var pxLength = toUnitless(length);
	
	    if (fromUnit !== 'px') {
	      if (fromUnit === 'em') {
	        pxLength = toUnitless(length) * toUnitless(baseFontSize);
	      } else if (fromUnit === 'rem') {
	        pxLength = toUnitless(length) * toUnitless(baseFontSize);
	        return length;
	      }
	    } // Convert length in pixels to the output unit
	
	
	    var outputLength = pxLength;
	
	    if (toUnit !== 'px') {
	      if (toUnit === 'em') {
	        outputLength = pxLength / toUnitless(baseFontSize);
	      } else if (toUnit === 'rem') {
	        outputLength = pxLength / toUnitless(baseFontSize);
	      } else {
	        return length;
	      }
	    }
	
	    return parseFloat(outputLength.toFixed(5)) + toUnit;
	  };
	}
	
	function alignProperty(_ref) {
	  var size = _ref.size,
	      grid = _ref.grid;
	  var sizeBelow = size - size % grid;
	  var sizeAbove = sizeBelow + grid;
	  return size - sizeBelow < sizeAbove - size ? sizeBelow : sizeAbove;
	} // fontGrid finds a minimal grid (in rem) for the fontSize values so that the
	// lineHeight falls under a x pixels grid, 4px in the case of Material Design,
	// without changing the relative line height
	
	
	function fontGrid(_ref2) {
	  var lineHeight = _ref2.lineHeight,
	      pixels = _ref2.pixels,
	      htmlFontSize = _ref2.htmlFontSize;
	  return pixels / (lineHeight * htmlFontSize);
	}
	/**
	 * generate a responsive version of a given CSS property
	 * @example
	 * responsiveProperty({
	 *   cssProperty: 'fontSize',
	 *   min: 15,
	 *   max: 20,
	 *   unit: 'px',
	 *   breakpoints: [300, 600],
	 * })
	 *
	 * // this returns
	 *
	 * {
	 *   fontSize: '15px',
	 *   '@media (min-width:300px)': {
	 *     fontSize: '17.5px',
	 *   },
	 *   '@media (min-width:600px)': {
	 *     fontSize: '20px',
	 *   },
	 * }
	 *
	 * @param {Object} params
	 * @param {string} params.cssProperty - The CSS property to be made responsive
	 * @param {number} params.min - The smallest value of the CSS property
	 * @param {number} params.max - The largest value of the CSS property
	 * @param {string} [params.unit] - The unit to be used for the CSS property
	 * @param {Array.number} [params.breakpoints]  - An array of breakpoints
	 * @param {number} [params.alignStep] - Round scaled value to fall under this grid
	 * @returns {Object} responsive styles for {params.cssProperty}
	 */
	
	
	function responsiveProperty(_ref3) {
	  var cssProperty = _ref3.cssProperty,
	      min = _ref3.min,
	      max = _ref3.max,
	      _ref3$unit = _ref3.unit,
	      unit = _ref3$unit === void 0 ? 'rem' : _ref3$unit,
	      _ref3$breakpoints = _ref3.breakpoints,
	      breakpoints = _ref3$breakpoints === void 0 ? [600, 960, 1280] : _ref3$breakpoints,
	      _ref3$transform = _ref3.transform,
	      transform = _ref3$transform === void 0 ? null : _ref3$transform;
	  var output = (0, _defineProperty2.default)({}, cssProperty, "".concat(min).concat(unit));
	  var factor = (max - min) / breakpoints[breakpoints.length - 1];
	  breakpoints.forEach(function (breakpoint) {
	    var value = min + factor * breakpoint;
	
	    if (transform !== null) {
	      value = transform(value);
	    }
	
	    output["@media (min-width:".concat(breakpoint, "px)")] = (0, _defineProperty2.default)({}, cssProperty, "".concat(Math.round(value * 10000) / 10000).concat(unit));
	  });
	  return output;
	}

/***/ },
/* 437 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _styles = __webpack_require__(20);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(53));
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return (0, _styles.makeStyles)(stylesOrCreator, (0, _extends2.default)({
	    defaultTheme: _defaultTheme.default
	  }, options));
	}
	
	var _default = makeStyles;
	exports.default = _default;

/***/ },
/* 438 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = responsiveFontSizes;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _cssUtils = __webpack_require__(436);
	
	function responsiveFontSizes(themeInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var _options$breakpoints = options.breakpoints,
	      breakpoints = _options$breakpoints === void 0 ? ['sm', 'md', 'lg'] : _options$breakpoints,
	      _options$disableAlign = options.disableAlign,
	      disableAlign = _options$disableAlign === void 0 ? false : _options$disableAlign,
	      _options$factor = options.factor,
	      factor = _options$factor === void 0 ? 2 : _options$factor,
	      _options$variants = options.variants,
	      variants = _options$variants === void 0 ? ['h1', 'h2', 'h3', 'h4', 'h5', 'h6', 'subtitle1', 'subtitle2', 'body1', 'body2', 'caption', 'button', 'overline'] : _options$variants;
	  var theme = (0, _extends2.default)({}, themeInput);
	  theme.typography = (0, _extends2.default)({}, theme.typography);
	  var typography = theme.typography; // Convert between css lengths e.g. em->px or px->rem
	  // Set the baseFontSize for your project. Defaults to 16px (also the browser default).
	
	  var convert = (0, _cssUtils.convertLength)(typography.htmlFontSize);
	  var breakpointValues = breakpoints.map(function (x) {
	    return theme.breakpoints.values[x];
	  });
	  variants.forEach(function (variant) {
	    var style = typography[variant];
	    var remFontSize = parseFloat(convert(style.fontSize, 'rem'));
	
	    if (remFontSize <= 1) {
	      return;
	    }
	
	    var maxFontSize = remFontSize;
	    var minFontSize = 1 + (maxFontSize - 1) / factor;
	    var lineHeight = style.lineHeight;
	
	    if (!(0, _cssUtils.isUnitless)(lineHeight) && !disableAlign) {
	      throw new Error(["Material-UI: unsupported non-unitless line height with grid alignment.", 'Use unitless line heights instead.'].join('\n'));
	    }
	
	    if (!(0, _cssUtils.isUnitless)(lineHeight)) {
	      // make it unitless
	      lineHeight = parseFloat(convert(lineHeight, 'rem')) / parseFloat(remFontSize);
	    }
	
	    var transform = null;
	
	    if (!disableAlign) {
	      transform = function transform(value) {
	        return (0, _cssUtils.alignProperty)({
	          size: value,
	          grid: (0, _cssUtils.fontGrid)({
	            pixels: 4,
	            lineHeight: lineHeight,
	            htmlFontSize: typography.htmlFontSize
	          })
	        });
	      };
	    }
	
	    typography[variant] = (0, _extends2.default)({}, style, {}, (0, _cssUtils.responsiveProperty)({
	      cssProperty: 'fontSize',
	      min: minFontSize,
	      max: maxFontSize,
	      unit: 'rem',
	      breakpoints: breakpointValues,
	      transform: transform
	    }));
	  });
	  return theme;
	}

/***/ },
/* 439 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shadowKeyUmbraOpacity = 0.2;
	var shadowKeyPenumbraOpacity = 0.14;
	var shadowAmbientShadowOpacity = 0.12;
	
	function createShadow() {
	  return ["".concat(arguments.length <= 0 ? undefined : arguments[0], "px ").concat(arguments.length <= 1 ? undefined : arguments[1], "px ").concat(arguments.length <= 2 ? undefined : arguments[2], "px ").concat(arguments.length <= 3 ? undefined : arguments[3], "px rgba(0,0,0,").concat(shadowKeyUmbraOpacity, ")"), "".concat(arguments.length <= 4 ? undefined : arguments[4], "px ").concat(arguments.length <= 5 ? undefined : arguments[5], "px ").concat(arguments.length <= 6 ? undefined : arguments[6], "px ").concat(arguments.length <= 7 ? undefined : arguments[7], "px rgba(0,0,0,").concat(shadowKeyPenumbraOpacity, ")"), "".concat(arguments.length <= 8 ? undefined : arguments[8], "px ").concat(arguments.length <= 9 ? undefined : arguments[9], "px ").concat(arguments.length <= 10 ? undefined : arguments[10], "px ").concat(arguments.length <= 11 ? undefined : arguments[11], "px rgba(0,0,0,").concat(shadowAmbientShadowOpacity, ")")].join(',');
	} // Values from https://github.com/material-components/material-components-web/blob/be8747f94574669cb5e7add1a7c54fa41a89cec7/packages/mdc-elevation/_variables.scss
	
	
	var shadows = ['none', createShadow(0, 2, 1, -1, 0, 1, 1, 0, 0, 1, 3, 0), createShadow(0, 3, 1, -2, 0, 2, 2, 0, 0, 1, 5, 0), createShadow(0, 3, 3, -2, 0, 3, 4, 0, 0, 1, 8, 0), createShadow(0, 2, 4, -1, 0, 4, 5, 0, 0, 1, 10, 0), createShadow(0, 3, 5, -1, 0, 5, 8, 0, 0, 1, 14, 0), createShadow(0, 3, 5, -1, 0, 6, 10, 0, 0, 1, 18, 0), createShadow(0, 4, 5, -2, 0, 7, 10, 1, 0, 2, 16, 1), createShadow(0, 5, 5, -3, 0, 8, 10, 1, 0, 3, 14, 2), createShadow(0, 5, 6, -3, 0, 9, 12, 1, 0, 3, 16, 2), createShadow(0, 6, 6, -3, 0, 10, 14, 1, 0, 4, 18, 3), createShadow(0, 6, 7, -4, 0, 11, 15, 1, 0, 4, 20, 3), createShadow(0, 7, 8, -4, 0, 12, 17, 2, 0, 5, 22, 4), createShadow(0, 7, 8, -4, 0, 13, 19, 2, 0, 5, 24, 4), createShadow(0, 7, 9, -4, 0, 14, 21, 2, 0, 5, 26, 4), createShadow(0, 8, 9, -5, 0, 15, 22, 2, 0, 6, 28, 5), createShadow(0, 8, 10, -5, 0, 16, 24, 2, 0, 6, 30, 5), createShadow(0, 8, 11, -5, 0, 17, 26, 2, 0, 6, 32, 5), createShadow(0, 9, 11, -5, 0, 18, 28, 2, 0, 7, 34, 6), createShadow(0, 9, 12, -6, 0, 19, 29, 2, 0, 7, 36, 6), createShadow(0, 10, 13, -6, 0, 20, 31, 3, 0, 8, 38, 7), createShadow(0, 10, 13, -6, 0, 21, 33, 3, 0, 8, 40, 7), createShadow(0, 10, 14, -6, 0, 22, 35, 3, 0, 8, 42, 7), createShadow(0, 11, 14, -7, 0, 23, 36, 3, 0, 9, 44, 8), createShadow(0, 11, 15, -7, 0, 24, 38, 3, 0, 9, 46, 8)];
	var _default = shadows;
	exports.default = _default;

/***/ },
/* 440 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	var shape = {
	  borderRadius: 4
	};
	var _default = shape;
	exports.default = _default;

/***/ },
/* 441 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _styles = __webpack_require__(20);
	
	var _defaultTheme = _interopRequireDefault(__webpack_require__(53));
	
	var withTheme = (0, _styles.withThemeCreator)({
	  defaultTheme: _defaultTheme.default
	});
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 442 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useMediaQuery;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _styles = __webpack_require__(20);
	
	function useMediaQuery(queryInput) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var theme = (0, _styles.useTheme)();
	  var props = (0, _styles.getThemeProps)({
	    theme: theme,
	    name: 'MuiUseMediaQuery',
	    props: {}
	  });
	
	  if (false) {
	    if (typeof queryInput === 'function' && theme === null) {
	      console.error(['Material-UI: the `query` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	    }
	  }
	
	  var query = typeof queryInput === 'function' ? queryInput(theme) : queryInput;
	  query = query.replace(/^@media( ?)/m, ''); // Wait for jsdom to support the match media feature.
	  // All the browsers Material-UI support have this built-in.
	  // This defensive check is here for simplicity.
	  // Most of the time, the match media logic isn't central to people tests.
	
	  var supportMatchMedia = typeof window !== 'undefined' && typeof window.matchMedia !== 'undefined';
	
	  var _props$options = (0, _extends2.default)({}, props, {}, options),
	      _props$options$defaul = _props$options.defaultMatches,
	      defaultMatches = _props$options$defaul === void 0 ? false : _props$options$defaul,
	      _props$options$matchM = _props$options.matchMedia,
	      matchMedia = _props$options$matchM === void 0 ? supportMatchMedia ? window.matchMedia : null : _props$options$matchM,
	      _props$options$noSsr = _props$options.noSsr,
	      noSsr = _props$options$noSsr === void 0 ? false : _props$options$noSsr,
	      _props$options$ssrMat = _props$options.ssrMatchMedia,
	      ssrMatchMedia = _props$options$ssrMat === void 0 ? null : _props$options$ssrMat;
	
	  var _React$useState = React.useState(function () {
	    if (noSsr && supportMatchMedia) {
	      return matchMedia(query).matches;
	    }
	
	    if (ssrMatchMedia) {
	      return ssrMatchMedia(query).matches;
	    } // Once the component is mounted, we rely on the
	    // event listeners to return the correct matches value.
	
	
	    return defaultMatches;
	  }),
	      match = _React$useState[0],
	      setMatch = _React$useState[1];
	
	  React.useEffect(function () {
	    var active = true;
	
	    if (!supportMatchMedia) {
	      return undefined;
	    }
	
	    var queryList = matchMedia(query);
	
	    var updateMatch = function updateMatch() {
	      // Workaround Safari wrong implementation of matchMedia
	      // TODO can we remove it?
	      // https://github.com/mui-org/material-ui/pull/17315#issuecomment-528286677
	      if (active) {
	        setMatch(queryList.matches);
	      }
	    };
	
	    updateMatch();
	    queryList.addListener(updateMatch);
	    return function () {
	      active = false;
	      queryList.removeListener(updateMatch);
	    };
	  }, [query, matchMedia, supportMatchMedia]);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    React.useDebugValue({
	      query: query,
	      match: match
	    });
	  }
	
	  return match;
	}

/***/ },
/* 443 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useScrollTrigger.default;
	  }
	});
	
	var _useScrollTrigger = _interopRequireDefault(__webpack_require__(444));

/***/ },
/* 444 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useScrollTrigger;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	function getScrollY(ref) {
	  return ref.pageYOffset !== undefined ? ref.pageYOffset : ref.scrollTop;
	}
	
	function defaultTrigger(event, store, options) {
	  var _options$disableHyste = options.disableHysteresis,
	      disableHysteresis = _options$disableHyste === void 0 ? false : _options$disableHyste,
	      _options$threshold = options.threshold,
	      threshold = _options$threshold === void 0 ? 100 : _options$threshold;
	  var previous = store.current;
	  store.current = event ? getScrollY(event.currentTarget) : previous;
	
	  if (!disableHysteresis && previous !== undefined) {
	    if (store.current < previous) {
	      return false;
	    }
	  }
	
	  return store.current > threshold;
	}
	
	var defaultTarget = typeof window !== 'undefined' ? window : null;
	
	function useScrollTrigger() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$getTrigger = options.getTrigger,
	      getTrigger = _options$getTrigger === void 0 ? defaultTrigger : _options$getTrigger,
	      _options$target = options.target,
	      target = _options$target === void 0 ? defaultTarget : _options$target,
	      other = (0, _objectWithoutProperties2.default)(options, ["getTrigger", "target"]);
	  var store = React.useRef();
	
	  var _React$useState = React.useState(function () {
	    return getTrigger(null, store, other);
	  }),
	      trigger = _React$useState[0],
	      setTrigger = _React$useState[1];
	
	  React.useEffect(function () {
	    var handleScroll = function handleScroll(event) {
	      setTrigger(getTrigger(event, store, other));
	    };
	
	    handleScroll(null); // Re-evaluate trigger when dependencies change
	
	    target.addEventListener('scroll', handleScroll);
	    return function () {
	      target.removeEventListener('scroll', handleScroll);
	    }; // See Option 3. https://github.com/facebook/react/issues/14476#issuecomment-471199055
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	  }, [target, getTrigger, JSON.stringify(other)]);
	  return trigger;
	}

/***/ },
/* 445 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = deprecatedPropType;
	
	function deprecatedPropType(validator, reason) {
	  if (true) {
	    return function () {
	      return null;
	    };
	  }
	
	  return function (props, propName, componentName, location, propFullName) {
	    var componentNameSafe = componentName || '<<anonymous>>';
	    var propFullNameSafe = propFullName || propName;
	
	    if (typeof props[propName] !== 'undefined') {
	      return new Error("The ".concat(location, " `").concat(propFullNameSafe, "` of ") + "`".concat(componentNameSafe, "` is deprecated. ").concat(reason));
	    }
	
	    return null;
	  };
	}

/***/ },
/* 446 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.detectScrollType = detectScrollType;
	exports.getNormalizedScrollLeft = getNormalizedScrollLeft;
	// Source from https://github.com/alitaheri/normalize-scroll-left
	var cachedType;
	/**
	 * Based on the jquery plugin https://github.com/othree/jquery.rtl-scroll-type
	 *
	 * Types of scrollLeft, assiming scrollWidth=100 and direction is rtl.
	 *
	 * Browser        | Type          | <- Most Left | Most Right -> | Initial
	 * -------------- | ------------- | ------------ | ------------- | -------
	 * WebKit         | default       | 0            | 100           | 100
	 * Firefox/Opera  | negative      | -100         | 0             | 0
	 * IE/Edge        | reverse       | 100          | 0             | 0
	 */
	
	function detectScrollType() {
	  if (cachedType) {
	    return cachedType;
	  }
	
	  var dummy = document.createElement('div');
	  dummy.appendChild(document.createTextNode('ABCD'));
	  dummy.dir = 'rtl';
	  dummy.style.fontSize = '14px';
	  dummy.style.width = '4px';
	  dummy.style.height = '1px';
	  dummy.style.position = 'absolute';
	  dummy.style.top = '-1000px';
	  dummy.style.overflow = 'scroll';
	  document.body.appendChild(dummy);
	  cachedType = 'reverse';
	
	  if (dummy.scrollLeft > 0) {
	    cachedType = 'default';
	  } else {
	    dummy.scrollLeft = 1;
	
	    if (dummy.scrollLeft === 0) {
	      cachedType = 'negative';
	    }
	  }
	
	  document.body.removeChild(dummy);
	  return cachedType;
	} // Based on https://stackoverflow.com/a/24394376
	
	
	function getNormalizedScrollLeft(element, direction) {
	  var scrollLeft = element.scrollLeft; // Perform the calculations only when direction is rtl to avoid messing up the ltr bahavior
	
	  if (direction !== 'rtl') {
	    return scrollLeft;
	  }
	
	  var type = detectScrollType();
	
	  switch (type) {
	    case 'negative':
	      return element.scrollWidth - element.clientWidth + scrollLeft;
	
	    case 'reverse':
	      return element.scrollWidth - element.clientWidth - scrollLeft;
	
	    default:
	      return scrollLeft;
	  }
	}

/***/ },
/* 447 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withMobileDialog.default;
	  }
	});
	
	var _withMobileDialog = _interopRequireDefault(__webpack_require__(448));

/***/ },
/* 448 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _withWidth = _interopRequireWildcard(__webpack_require__(90));
	
	/**
	 * Dialog will responsively be full screen *at or below* the given breakpoint
	 * (defaults to 'sm' for mobile devices).
	 * Notice that this Higher-order Component is incompatible with server-side rendering.
	 */
	var withMobileDialog = function withMobileDialog() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$breakpoint = options.breakpoint,
	        breakpoint = _options$breakpoint === void 0 ? 'sm' : _options$breakpoint;
	
	    function WithMobileDialog(props) {
	      return /*#__PURE__*/React.createElement(Component, (0, _extends2.default)({
	        fullScreen: (0, _withWidth.isWidthDown)(breakpoint, props.width)
	      }, props));
	    }
	
	     false ? WithMobileDialog.propTypes = {
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']).isRequired
	    } : void 0;
	    return (0, _withWidth.default)()(WithMobileDialog);
	  };
	};
	
	var _default = withMobileDialog;
	exports.default = _default;

/***/ },
/* 449 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.isWidthDown = exports.isWidthUp = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(9);
	
	var _styles = __webpack_require__(20);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(430));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(13));
	
	var _createBreakpoints = __webpack_require__(159);
	
	var _useMediaQuery = _interopRequireDefault(__webpack_require__(164));
	
	// By default, returns true if screen width is the same or greater than the given breakpoint.
	var isWidthUp = function isWidthUp(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(breakpoint) <= _createBreakpoints.keys.indexOf(width);
	  }
	
	  return _createBreakpoints.keys.indexOf(breakpoint) < _createBreakpoints.keys.indexOf(width);
	}; // By default, returns true if screen width is the same or less than the given breakpoint.
	
	
	exports.isWidthUp = isWidthUp;
	
	var isWidthDown = function isWidthDown(breakpoint, width) {
	  var inclusive = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : true;
	
	  if (inclusive) {
	    return _createBreakpoints.keys.indexOf(width) <= _createBreakpoints.keys.indexOf(breakpoint);
	  }
	
	  return _createBreakpoints.keys.indexOf(width) < _createBreakpoints.keys.indexOf(breakpoint);
	};
	
	exports.isWidthDown = isWidthDown;
	var useEnhancedEffect = typeof window === 'undefined' ? React.useEffect : React.useLayoutEffect;
	
	var withWidth = function withWidth() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  return function (Component) {
	    var _options$withTheme = options.withTheme,
	        withThemeOption = _options$withTheme === void 0 ? false : _options$withTheme,
	        _options$noSSR = options.noSSR,
	        noSSR = _options$noSSR === void 0 ? false : _options$noSSR,
	        initialWidthOption = options.initialWidth;
	
	    function WithWidth(props) {
	      var contextTheme = (0, _useTheme.default)();
	      var theme = props.theme || contextTheme;
	
	      var _getThemeProps = (0, _styles.getThemeProps)({
	        theme: theme,
	        name: 'MuiWithWidth',
	        props: (0, _extends2.default)({}, props)
	      }),
	          initialWidth = _getThemeProps.initialWidth,
	          width = _getThemeProps.width,
	          other = (0, _objectWithoutProperties2.default)(_getThemeProps, ["initialWidth", "width"]);
	
	      var _React$useState = React.useState(false),
	          mountedState = _React$useState[0],
	          setMountedState = _React$useState[1];
	
	      useEnhancedEffect(function () {
	        setMountedState(true);
	      }, []);
	      /**
	       * innerWidth |xs      sm      md      lg      xl
	       *            |-------|-------|-------|-------|------>
	       * width      |  xs   |  sm   |  md   |  lg   |  xl
	       */
	
	      var keys = (0, _toConsumableArray2.default)(theme.breakpoints.keys).reverse();
	      var widthComputed = keys.reduce(function (output, key) {
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        var matches = (0, _useMediaQuery.default)(theme.breakpoints.up(key));
	        return !output && matches ? key : output;
	      }, null);
	      var more = (0, _extends2.default)({
	        width: width || (mountedState || noSSR ? widthComputed : undefined) || initialWidth || initialWidthOption
	      }, withThemeOption ? {
	        theme: theme
	      } : {}, {}, other); // When rendering the component on the server,
	      // we have no idea about the client browser screen width.
	      // In order to prevent blinks and help the reconciliation of the React tree
	      // we are not rendering the child component.
	      //
	      // An alternative is to use the `initialWidth` property.
	
	      if (more.width === undefined) {
	        return null;
	      }
	
	      return /*#__PURE__*/React.createElement(Component, more);
	    }
	
	     false ? WithWidth.propTypes = {
	      /**
	       * As `window.innerWidth` is unavailable on the server,
	       * we default to rendering an empty component during the first mount.
	       * You might want to use an heuristic to approximate
	       * the screen width of the client browser screen width.
	       *
	       * For instance, you could be using the user-agent or the client-hints.
	       * https://caniuse.com/#search=client%20hint
	       */
	      initialWidth: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl']),
	
	      /**
	       * @ignore
	       */
	      theme: _propTypes.default.object,
	
	      /**
	       * Bypass the width calculation logic.
	       */
	      width: _propTypes.default.oneOf(['xs', 'sm', 'md', 'lg', 'xl'])
	    } : void 0;
	
	    if (false) {
	      WithWidth.displayName = "WithWidth(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithWidth, Component);
	    return WithWidth;
	  };
	};
	
	var _default = withWidth;
	exports.default = _default;

/***/ },
/* 450 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(68));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 10l5 5 5-5H7z"
	}), 'ArrowDropDownSharp');
	
	exports.default = _default;

/***/ },
/* 451 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(68));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M7 14l5-5 5 5H7z"
	}), 'ArrowDropUpSharp');
	
	exports.default = _default;

/***/ },
/* 452 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(68));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M9.4 16.6L4.8 12l4.6-4.6L8 6l-6 6 6 6 1.4-1.4zm5.2 0l4.6-4.6-4.6-4.6L16 6l6 6-6 6-1.4-1.4z"
	}), 'Code');
	
	exports.default = _default;

/***/ },
/* 453 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _createSvgIcon = _interopRequireDefault(__webpack_require__(68));
	
	var _default = (0, _createSvgIcon.default)(_react.default.createElement("path", {
	  d: "M19 12v7H5v-7H3v7c0 1.1.9 2 2 2h14c1.1 0 2-.9 2-2v-7h-2zm-6 .67l2.59-2.58L17 11.5l-5 5-5-5 1.41-1.41L11 12.67V3h2z"
	}), 'SaveAlt');
	
	exports.default = _default;

/***/ },
/* 454 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "createFilterOptions", {
	  enumerable: true,
	  get: function get() {
	    return _useAutocomplete2.createFilterOptions;
	  }
	});
	exports.default = exports.styles = void 0;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _styles = __webpack_require__(161);
	
	var _Popper = _interopRequireDefault(__webpack_require__(83));
	
	var _ListSubheader = _interopRequireDefault(__webpack_require__(124));
	
	var _Paper = _interopRequireDefault(__webpack_require__(23));
	
	var _IconButton = _interopRequireDefault(__webpack_require__(48));
	
	var _Chip = _interopRequireDefault(__webpack_require__(114));
	
	var _Close = _interopRequireDefault(__webpack_require__(457));
	
	var _ArrowDropDown = _interopRequireDefault(__webpack_require__(456));
	
	var _useAutocomplete2 = _interopRequireWildcard(__webpack_require__(458));
	
	var styles = function styles(theme) {
	  var _option;
	
	  return {
	    /* Styles applied to the root element. */
	    root: {
	      '&:hover $clearIndicatorDirty, &$focused $clearIndicatorDirty': {
	        visibility: 'visible'
	      }
	    },
	
	    /* Pseudo-class applied to the root element if focused. */
	    focused: {},
	
	    /* Styles applied to the tag elements, e.g. the chips. */
	    tag: {
	      margin: 3,
	      maxWidth: 'calc(100% - 6px)'
	    },
	
	    /* Styles applied to the tag elements, e.g. the chips if `size="small"`. */
	    tagSizeSmall: {
	      margin: 2,
	      maxWidth: 'calc(100% - 4px)'
	    },
	
	    /* Styles applied when the popup icon is rendered. */
	    hasPopupIcon: {},
	
	    /* Styles applied when the clear icon is rendered. */
	    hasClearIcon: {},
	
	    /* Styles applied to the Input element. */
	    inputRoot: {
	      flexWrap: 'wrap',
	      '$hasPopupIcon &, $hasClearIcon &': {
	        paddingRight: 26 + 4
	      },
	      '$hasPopupIcon$hasClearIcon &': {
	        paddingRight: 52 + 4
	      },
	      '& $input': {
	        width: 0,
	        minWidth: 30
	      },
	      '&[class*="MuiInput-root"]': {
	        paddingBottom: 1,
	        '& $input': {
	          padding: 4
	        },
	        '& $input:first-child': {
	          padding: '6px 0'
	        }
	      },
	      '&[class*="MuiInput-root"][class*="MuiInput-marginDense"]': {
	        '& $input': {
	          padding: '4px 4px 5px'
	        },
	        '& $input:first-child': {
	          padding: '3px 0 6px'
	        }
	      },
	      '&[class*="MuiOutlinedInput-root"]': {
	        padding: 9,
	        '$hasPopupIcon &, $hasClearIcon &': {
	          paddingRight: 26 + 4 + 9
	        },
	        '$hasPopupIcon$hasClearIcon &': {
	          paddingRight: 52 + 4 + 9
	        },
	        '& $input': {
	          padding: '9.5px 4px'
	        },
	        '& $input:first-child': {
	          paddingLeft: 6
	        },
	        '& $endAdornment': {
	          right: 9
	        }
	      },
	      '&[class*="MuiOutlinedInput-root"][class*="MuiOutlinedInput-marginDense"]': {
	        padding: 6,
	        '& $input': {
	          padding: '4.5px 4px'
	        }
	      },
	      '&[class*="MuiFilledInput-root"]': {
	        paddingTop: 19,
	        paddingLeft: 8,
	        '$hasPopupIcon &, $hasClearIcon &': {
	          paddingRight: 26 + 4 + 9
	        },
	        '$hasPopupIcon$hasClearIcon &': {
	          paddingRight: 52 + 4 + 9
	        },
	        '& $input': {
	          padding: '9px 4px'
	        },
	        '& $endAdornment': {
	          right: 9
	        }
	      },
	      '&[class*="MuiFilledInput-root"][class*="MuiFilledInput-marginDense"]': {
	        paddingBottom: 1,
	        '& $input': {
	          padding: '4.5px 4px'
	        }
	      }
	    },
	
	    /* Styles applied to the input element. */
	    input: {
	      flexGrow: 1,
	      textOverflow: 'ellipsis',
	      opacity: 0
	    },
	
	    /* Styles applied to the input element if tag focused. */
	    inputFocused: {
	      opacity: 1
	    },
	
	    /* Styles applied to the endAdornment element. */
	    endAdornment: {
	      // We use a position absolute to support wrapping tags.
	      position: 'absolute',
	      right: 0,
	      top: 'calc(50% - 14px)' // Center vertically
	
	    },
	
	    /* Styles applied to the clear indicator. */
	    clearIndicator: {
	      marginRight: -2,
	      padding: 4,
	      visibility: 'hidden'
	    },
	
	    /* Styles applied to the clear indicator if the input is dirty. */
	    clearIndicatorDirty: {},
	
	    /* Styles applied to the popup indicator. */
	    popupIndicator: {
	      padding: 2,
	      marginRight: -2
	    },
	
	    /* Styles applied to the popup indicator if the popup is open. */
	    popupIndicatorOpen: {
	      transform: 'rotate(180deg)'
	    },
	
	    /* Styles applied to the popper element. */
	    popper: {
	      zIndex: theme.zIndex.modal
	    },
	
	    /* Styles applied to the popper element if `disablePortal={true}`. */
	    popperDisablePortal: {
	      position: 'absolute'
	    },
	
	    /* Styles applied to the `Paper` component. */
	    paper: (0, _extends2.default)({}, theme.typography.body1, {
	      overflow: 'hidden',
	      margin: '4px 0'
	    }),
	
	    /* Styles applied to the `listbox` component. */
	    listbox: {
	      listStyle: 'none',
	      margin: 0,
	      padding: '8px 0px',
	      maxHeight: '40vh',
	      overflow: 'auto'
	    },
	
	    /* Styles applied to the loading wrapper. */
	    loading: {
	      color: theme.palette.text.secondary,
	      padding: '14px 16px'
	    },
	
	    /* Styles applied to the no option wrapper. */
	    noOptions: {
	      color: theme.palette.text.secondary,
	      padding: '14px 16px'
	    },
	
	    /* Styles applied to the option elements. */
	    option: (_option = {
	      minHeight: 48,
	      display: 'flex',
	      justifyContent: 'flex-start',
	      alignItems: 'center',
	      cursor: 'pointer',
	      paddingTop: 6,
	      boxSizing: 'border-box',
	      outline: '0',
	      WebkitTapHighlightColor: 'transparent',
	      paddingBottom: 6,
	      paddingLeft: 16,
	      paddingRight: 16
	    }, (0, _defineProperty2.default)(_option, theme.breakpoints.up('sm'), {
	      minHeight: 'auto'
	    }), (0, _defineProperty2.default)(_option, '&[aria-selected="true"]', {
	      backgroundColor: theme.palette.action.selected
	    }), (0, _defineProperty2.default)(_option, '&[data-focus="true"]', {
	      backgroundColor: theme.palette.action.hover
	    }), (0, _defineProperty2.default)(_option, '&:active', {
	      backgroundColor: theme.palette.action.selected
	    }), (0, _defineProperty2.default)(_option, '&[aria-disabled="true"]', {
	      opacity: theme.palette.action.disabledOpacity,
	      pointerEvents: 'none'
	    }), _option),
	
	    /* Styles applied to the group's label elements. */
	    groupLabel: {
	      backgroundColor: theme.palette.background.paper,
	      top: -8
	    },
	
	    /* Styles applied to the group's ul elements. */
	    groupUl: {
	      padding: 0,
	      '& $option': {
	        paddingLeft: 24
	      }
	    }
	  };
	};
	
	exports.styles = styles;
	
	function DisablePortal(props) {
	  // eslint-disable-next-line react/prop-types
	  var anchorEl = props.anchorEl,
	      open = props.open,
	      other = (0, _objectWithoutProperties2.default)(props, ["anchorEl", "open"]);
	  return /*#__PURE__*/React.createElement("div", other);
	}
	
	var _ref = /*#__PURE__*/React.createElement(_Close.default, {
	  fontSize: "small"
	});
	
	var _ref2 = /*#__PURE__*/React.createElement(_ArrowDropDown.default, null);
	
	var Autocomplete = React.forwardRef(function Autocomplete(props, ref) {
	  /* eslint-disable no-unused-vars */
	  var _props$autoComplete = props.autoComplete,
	      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
	      _props$autoHighlight = props.autoHighlight,
	      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
	      _props$autoSelect = props.autoSelect,
	      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
	      _props$blurOnSelect = props.blurOnSelect,
	      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
	      ChipProps = props.ChipProps,
	      classes = props.classes,
	      className = props.className,
	      _props$clearOnEscape = props.clearOnEscape,
	      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
	      _props$clearText = props.clearText,
	      clearText = _props$clearText === void 0 ? 'Clear' : _props$clearText,
	      _props$closeIcon = props.closeIcon,
	      closeIcon = _props$closeIcon === void 0 ? _ref : _props$closeIcon,
	      _props$closeText = props.closeText,
	      closeText = _props$closeText === void 0 ? 'Close' : _props$closeText,
	      _props$debug = props.debug,
	      debug = _props$debug === void 0 ? false : _props$debug,
	      _props$defaultValue = props.defaultValue,
	      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
	      _props$disableClearab = props.disableClearable,
	      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
	      _props$disableCloseOn = props.disableCloseOnSelect,
	      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
	      _props$disabled = props.disabled,
	      disabled = _props$disabled === void 0 ? false : _props$disabled,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      _props$disablePortal = props.disablePortal,
	      disablePortal = _props$disablePortal === void 0 ? false : _props$disablePortal,
	      filterOptions = props.filterOptions,
	      _props$filterSelected = props.filterSelectedOptions,
	      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
	      _props$forcePopupIcon = props.forcePopupIcon,
	      forcePopupIcon = _props$forcePopupIcon === void 0 ? 'auto' : _props$forcePopupIcon,
	      _props$freeSolo = props.freeSolo,
	      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
	      _props$getLimitTagsTe = props.getLimitTagsText,
	      getLimitTagsText = _props$getLimitTagsTe === void 0 ? function (more) {
	    return "+".concat(more);
	  } : _props$getLimitTagsTe,
	      getOptionDisabled = props.getOptionDisabled,
	      _props$getOptionLabel = props.getOptionLabel,
	      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
	    return x;
	  } : _props$getOptionLabel,
	      getOptionSelected = props.getOptionSelected,
	      groupBy = props.groupBy,
	      idProp = props.id,
	      _props$includeInputIn = props.includeInputInList,
	      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
	      inputValueProp = props.inputValue,
	      _props$limitTags = props.limitTags,
	      limitTags = _props$limitTags === void 0 ? -1 : _props$limitTags,
	      _props$ListboxCompone = props.ListboxComponent,
	      ListboxComponent = _props$ListboxCompone === void 0 ? 'ul' : _props$ListboxCompone,
	      ListboxProps = props.ListboxProps,
	      _props$loading = props.loading,
	      loading = _props$loading === void 0 ? false : _props$loading,
	      _props$loadingText = props.loadingText,
	      loadingText = _props$loadingText === void 0 ? 'Loading…' : _props$loadingText,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      _props$noOptionsText = props.noOptionsText,
	      noOptionsText = _props$noOptionsText === void 0 ? 'No options' : _props$noOptionsText,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onInputChange = props.onInputChange,
	      onOpen = props.onOpen,
	      open = props.open,
	      _props$openOnFocus = props.openOnFocus,
	      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
	      _props$openText = props.openText,
	      openText = _props$openText === void 0 ? 'Open' : _props$openText,
	      options = props.options,
	      _props$PaperComponent = props.PaperComponent,
	      PaperComponent = _props$PaperComponent === void 0 ? _Paper.default : _props$PaperComponent,
	      _props$PopperComponen = props.PopperComponent,
	      PopperComponentProp = _props$PopperComponen === void 0 ? _Popper.default : _props$PopperComponen,
	      _props$popupIcon = props.popupIcon,
	      popupIcon = _props$popupIcon === void 0 ? _ref2 : _props$popupIcon,
	      renderGroupProp = props.renderGroup,
	      renderInput = props.renderInput,
	      renderOptionProp = props.renderOption,
	      renderTags = props.renderTags,
	      _props$selectOnFocus = props.selectOnFocus,
	      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
	      _props$size = props.size,
	      size = _props$size === void 0 ? 'medium' : _props$size,
	      valueProp = props.value,
	      other = (0, _objectWithoutProperties2.default)(props, ["autoComplete", "autoHighlight", "autoSelect", "blurOnSelect", "ChipProps", "classes", "className", "clearOnEscape", "clearText", "closeIcon", "closeText", "debug", "defaultValue", "disableClearable", "disableCloseOnSelect", "disabled", "disabledItemsFocusable", "disableListWrap", "disablePortal", "filterOptions", "filterSelectedOptions", "forcePopupIcon", "freeSolo", "getLimitTagsText", "getOptionDisabled", "getOptionLabel", "getOptionSelected", "groupBy", "id", "includeInputInList", "inputValue", "limitTags", "ListboxComponent", "ListboxProps", "loading", "loadingText", "multiple", "noOptionsText", "onChange", "onClose", "onInputChange", "onOpen", "open", "openOnFocus", "openText", "options", "PaperComponent", "PopperComponent", "popupIcon", "renderGroup", "renderInput", "renderOption", "renderTags", "selectOnFocus", "size", "value"]);
	  /* eslint-enable no-unused-vars */
	
	  var PopperComponent = disablePortal ? DisablePortal : PopperComponentProp;
	
	  var _useAutocomplete = (0, _useAutocomplete2.default)((0, _extends2.default)({}, props, {
	    componentName: 'Autocomplete'
	  })),
	      getRootProps = _useAutocomplete.getRootProps,
	      getInputProps = _useAutocomplete.getInputProps,
	      getInputLabelProps = _useAutocomplete.getInputLabelProps,
	      getPopupIndicatorProps = _useAutocomplete.getPopupIndicatorProps,
	      getClearProps = _useAutocomplete.getClearProps,
	      getTagProps = _useAutocomplete.getTagProps,
	      getListboxProps = _useAutocomplete.getListboxProps,
	      getOptionProps = _useAutocomplete.getOptionProps,
	      value = _useAutocomplete.value,
	      dirty = _useAutocomplete.dirty,
	      id = _useAutocomplete.id,
	      popupOpen = _useAutocomplete.popupOpen,
	      focused = _useAutocomplete.focused,
	      focusedTag = _useAutocomplete.focusedTag,
	      anchorEl = _useAutocomplete.anchorEl,
	      setAnchorEl = _useAutocomplete.setAnchorEl,
	      inputValue = _useAutocomplete.inputValue,
	      groupedOptions = _useAutocomplete.groupedOptions;
	
	  var startAdornment;
	
	  if (multiple && value.length > 0) {
	    var getCustomizedTagProps = function getCustomizedTagProps(params) {
	      return (0, _extends2.default)({
	        className: (0, _clsx.default)(classes.tag, size === 'small' && classes.tagSizeSmall),
	        disabled: disabled
	      }, getTagProps(params));
	    };
	
	    if (renderTags) {
	      startAdornment = renderTags(value, getCustomizedTagProps);
	    } else {
	      startAdornment = value.map(function (option, index) {
	        return /*#__PURE__*/React.createElement(_Chip.default, (0, _extends2.default)({
	          label: getOptionLabel(option),
	          size: size
	        }, getCustomizedTagProps({
	          index: index
	        }), ChipProps));
	      });
	    }
	  }
	
	  if (limitTags > -1 && Array.isArray(startAdornment)) {
	    var more = startAdornment.length - limitTags;
	
	    if (limitTags && !focused && more > 0) {
	      startAdornment = startAdornment.splice(0, limitTags);
	      startAdornment.push( /*#__PURE__*/React.createElement("span", {
	        className: classes.tag,
	        key: startAdornment.length
	      }, getLimitTagsText(more)));
	    }
	  }
	
	  var defaultRenderGroup = function defaultRenderGroup(params) {
	    return /*#__PURE__*/React.createElement("li", {
	      key: params.key
	    }, /*#__PURE__*/React.createElement(_ListSubheader.default, {
	      className: classes.groupLabel,
	      component: "div"
	    }, params.group), /*#__PURE__*/React.createElement("ul", {
	      className: classes.groupUl
	    }, params.children));
	  };
	
	  var renderGroup = renderGroupProp || defaultRenderGroup;
	  var renderOption = renderOptionProp || getOptionLabel;
	
	  var renderListOption = function renderListOption(option, index) {
	    var optionProps = getOptionProps({
	      option: option,
	      index: index
	    });
	    return /*#__PURE__*/React.createElement("li", (0, _extends2.default)({}, optionProps, {
	      className: classes.option
	    }), renderOption(option, {
	      selected: optionProps['aria-selected'],
	      inputValue: inputValue
	    }));
	  };
	
	  var hasClearIcon = !disableClearable && !disabled;
	  var hasPopupIcon = (!freeSolo || forcePopupIcon === true) && forcePopupIcon !== false;
	  return /*#__PURE__*/React.createElement(React.Fragment, null, /*#__PURE__*/React.createElement("div", (0, _extends2.default)({
	    ref: ref,
	    className: (0, _clsx.default)(classes.root, className, focused && classes.focused, hasClearIcon && classes.hasClearIcon, hasPopupIcon && classes.hasPopupIcon)
	  }, getRootProps(other)), renderInput({
	    id: id,
	    disabled: disabled,
	    fullWidth: true,
	    size: size === 'small' ? 'small' : undefined,
	    InputLabelProps: getInputLabelProps(),
	    InputProps: {
	      ref: setAnchorEl,
	      className: classes.inputRoot,
	      startAdornment: startAdornment,
	      endAdornment: /*#__PURE__*/React.createElement("div", {
	        className: classes.endAdornment
	      }, hasClearIcon ? /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({}, getClearProps(), {
	        "aria-label": clearText,
	        title: clearText,
	        className: (0, _clsx.default)(classes.clearIndicator, dirty && classes.clearIndicatorDirty)
	      }), closeIcon) : null, hasPopupIcon ? /*#__PURE__*/React.createElement(_IconButton.default, (0, _extends2.default)({}, getPopupIndicatorProps(), {
	        disabled: disabled,
	        "aria-label": popupOpen ? closeText : openText,
	        title: popupOpen ? closeText : openText,
	        className: (0, _clsx.default)(classes.popupIndicator, popupOpen && classes.popupIndicatorOpen)
	      }), popupIcon) : null)
	    },
	    inputProps: (0, _extends2.default)({
	      className: (0, _clsx.default)(classes.input, focusedTag === -1 && classes.inputFocused),
	      disabled: disabled
	    }, getInputProps())
	  })), popupOpen && anchorEl ? /*#__PURE__*/React.createElement(PopperComponent, {
	    className: (0, _clsx.default)(classes.popper, disablePortal && classes.popperDisablePortal),
	    style: {
	      width: anchorEl ? anchorEl.clientWidth : null
	    },
	    role: "presentation",
	    anchorEl: anchorEl,
	    open: true
	  }, /*#__PURE__*/React.createElement(PaperComponent, {
	    className: classes.paper
	  }, loading && groupedOptions.length === 0 ? /*#__PURE__*/React.createElement("div", {
	    className: classes.loading
	  }, loadingText) : null, groupedOptions.length === 0 && !freeSolo && !loading ? /*#__PURE__*/React.createElement("div", {
	    className: classes.noOptions
	  }, noOptionsText) : null, groupedOptions.length > 0 ? /*#__PURE__*/React.createElement(ListboxComponent, (0, _extends2.default)({
	    className: classes.listbox
	  }, getListboxProps(), ListboxProps), groupedOptions.map(function (option, index) {
	    if (groupBy) {
	      return renderGroup({
	        key: option.key,
	        group: option.group,
	        children: option.options.map(function (option2, index2) {
	          return renderListOption(option2, option.index + index2);
	        })
	      });
	    }
	
	    return renderListOption(option, index);
	  })) : null)) : null);
	});
	 false ? Autocomplete.propTypes = {
	  // ----------------------------- Warning --------------------------------
	  // | These PropTypes are generated from the TypeScript type definitions |
	  // |     To update them edit the d.ts file and run "yarn proptypes"     |
	  // ----------------------------------------------------------------------
	
	  /**
	   * If `true`, the portion of the selected suggestion that has not been typed by the user,
	   * known as the completion string, appears inline after the input cursor in the textbox.
	   * The inline completion string is visually highlighted and has a selected state.
	   */
	  autoComplete: _propTypes.default.bool,
	
	  /**
	   * If `true`, the first option is automatically highlighted.
	   */
	  autoHighlight: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected option becomes the value of the input
	   * when the Autocomplete loses focus unless the user chooses
	   * a different option or changes the character string in the input.
	   */
	  autoSelect: _propTypes.default.bool,
	
	  /**
	   * Control if the input should be blurred when an option is selected:
	   *
	   * - `false` the input is not blurred.
	   * - `true` the input is always blurred.
	   * - `touch` the input is blurred after a touch event.
	   * - `mouse` the input is blurred after a mouse event.
	   */
	  blurOnSelect: _propTypes.default.oneOfType([_propTypes.default.oneOf(['mouse', 'touch']), _propTypes.default.bool]),
	
	  /**
	   * Props applied to the [`Chip`](/api/chip/) element.
	   */
	  ChipProps: _propTypes.default.object,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, clear all values when the user presses escape and the popup is closed.
	   */
	  clearOnEscape: _propTypes.default.bool,
	
	  /**
	   * Override the default text for the *clear* icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  clearText: _propTypes.default.string,
	
	  /**
	   * The icon to display in place of the default close icon.
	   */
	  closeIcon: _propTypes.default.node,
	
	  /**
	   * Override the default text for the *close popup* icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  closeText: _propTypes.default.string,
	
	  /**
	   * If `true`, the popup will ignore the blur event if the input is filled.
	   * You can inspect the popup markup with your browser tools.
	   * Consider this option when you need to customize the component.
	   */
	  debug: _propTypes.default.bool,
	
	  /**
	   * The default input value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.oneOfType([_propTypes.default.any, _propTypes.default.array]),
	
	  /**
	   * If `true`, the input can't be cleared.
	   */
	  disableClearable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the popup won't close when a value is selected.
	   */
	  disableCloseOnSelect: _propTypes.default.bool,
	
	  /**
	   * If `true`, the input will be disabled.
	   */
	  disabled: _propTypes.default.bool,
	
	  /**
	   * If `true`, will allow focus on disabled items.
	   */
	  disabledItemsFocusable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list box in the popup will not wrap focus.
	   */
	  disableListWrap: _propTypes.default.bool,
	
	  /**
	   * Disable the portal behavior.
	   * The children stay within it's parent DOM hierarchy.
	   */
	  disablePortal: _propTypes.default.bool,
	
	  /**
	   * A filter function that determines the options that are eligible.
	   *
	   * @param {T[]} options The options to render.
	   * @param {object} state The state of the component.
	   * @returns {T[]}
	   */
	  filterOptions: _propTypes.default.func,
	
	  /**
	   * If `true`, hide the selected options from the list box.
	   */
	  filterSelectedOptions: _propTypes.default.bool,
	
	  /**
	   * Force the visibility display of the popup icon.
	   */
	  forcePopupIcon: _propTypes.default.oneOfType([_propTypes.default.oneOf(['auto']), _propTypes.default.bool]),
	
	  /**
	   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
	   */
	  freeSolo: _propTypes.default.bool,
	
	  /**
	   * The label to display when the tags are truncated (`limitTags`).
	   *
	   * @param {number} more The number of truncated tags.
	   * @returns {ReactNode}
	   */
	  getLimitTagsText: _propTypes.default.func,
	
	  /**
	   * Used to determine the disabled state for a given option.
	   */
	  getOptionDisabled: _propTypes.default.func,
	
	  /**
	   * Used to determine the string value for a given option.
	   * It's used to fill the input (and the list box options if `renderOption` is not provided).
	   */
	  getOptionLabel: _propTypes.default.func,
	
	  /**
	   * Used to determine if an option is selected.
	   * Uses strict equality by default.
	   */
	  getOptionSelected: _propTypes.default.func,
	
	  /**
	   * If provided, the options will be grouped under the returned string.
	   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
	   *
	   * @param {T} options The option to group.
	   * @returns {string}
	   */
	  groupBy: _propTypes.default.func,
	
	  /**
	   * This prop is used to help implement the accessibility logic.
	   * If you don't provide this prop. It falls back to a randomly generated id.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the highlight can move to the input.
	   */
	  includeInputInList: _propTypes.default.bool,
	
	  /**
	   * The input value.
	   */
	  inputValue: _propTypes.default.string,
	
	  /**
	   * The maximum number of tags that will be visible when not focused.
	   * Set `-1` to disable the limit.
	   */
	  limitTags: _propTypes.default.number,
	
	  /**
	   * The component used to render the listbox.
	   */
	  ListboxComponent: _propTypes.default.elementType,
	
	  /**
	   * Props applied to the Listbox element.
	   */
	  ListboxProps: _propTypes.default.object,
	
	  /**
	   * If `true`, the component is in a loading state.
	   */
	  loading: _propTypes.default.bool,
	
	  /**
	   * Text to display when in a loading state.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  loadingText: _propTypes.default.node,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Text to display when there are no options.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  noOptionsText: _propTypes.default.node,
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {T} value
	   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the popup requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} reason Can be: `"toggleInput"`, `"escape"`, `"select-option"`, `"blur"`.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the input value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} value The new value of the text input.
	   * @param {string} reason Can be: `"input"` (user input), `"reset"` (programmatic change), `"clear"`.
	   */
	  onInputChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the popup requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control the popup` open state.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * If `true`, the popup will open on input focus.
	   */
	  openOnFocus: _propTypes.default.bool,
	
	  /**
	   * Override the default text for the *open popup* icon button.
	   *
	   * For localization purposes, you can use the provided [translations](/guides/localization/).
	   */
	  openText: _propTypes.default.string,
	
	  /**
	   * Array of options.
	   */
	  options: _propTypes.default.array.isRequired,
	
	  /**
	   * The component used to render the body of the popup.
	   */
	  PaperComponent: _propTypes.default.elementType,
	
	  /**
	   * The component used to position the popup.
	   */
	  PopperComponent: _propTypes.default.elementType,
	
	  /**
	   * The icon to display in place of the default popup icon.
	   */
	  popupIcon: _propTypes.default.node,
	
	  /**
	   * Render the group.
	   *
	   * @param {any} option The group to render.
	   * @returns {ReactNode}
	   */
	  renderGroup: _propTypes.default.func,
	
	  /**
	   * Render the input.
	   *
	   * @param {object} params
	   * @returns {ReactNode}
	   */
	  renderInput: _propTypes.default.func.isRequired,
	
	  /**
	   * Render the option, use `getOptionLabel` by default.
	   *
	   * @param {T} option The option to render.
	   * @param {object} state The state of the component.
	   * @returns {ReactNode}
	   */
	  renderOption: _propTypes.default.func,
	
	  /**
	   * Render the selected value.
	   *
	   * @param {T[]} value The `value` provided to the component.
	   * @param {function} getTagProps A tag props getter.
	   * @returns {ReactNode}
	   */
	  renderTags: _propTypes.default.func,
	
	  /**
	   * If `true`, the input's text will be selected on focus.
	   * It helps the user clear the selected value.
	   */
	  selectOnFocus: _propTypes.default.bool,
	
	  /**
	   * The size of the autocomplete.
	   */
	  size: _propTypes.default.oneOf(['medium', 'small']),
	
	  /**
	   * The value of the autocomplete.
	   *
	   * The value must have reference equality with the option in order to be selected.
	   * You can customize the equality behavior with the `getOptionSelected` prop.
	   */
	  value: _propTypes.default.oneOfType([_propTypes.default.any, _propTypes.default.array])
	} : void 0;
	
	var _default = (0, _styles.withStyles)(styles, {
	  name: 'MuiAutocomplete'
	})(Autocomplete);
	
	exports.default = _default;

/***/ },
/* 455 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _Autocomplete.default;
	  }
	});
	Object.defineProperty(exports, "createFilterOptions", {
	  enumerable: true,
	  get: function get() {
	    return _Autocomplete.createFilterOptions;
	  }
	});
	
	var _Autocomplete = _interopRequireWildcard(__webpack_require__(454));

/***/ },
/* 456 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _utils = __webpack_require__(66);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M7 10l5 5 5-5z"
	}), 'ArrowDropDown');
	
	exports.default = _default;

/***/ },
/* 457 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _utils = __webpack_require__(66);
	
	/**
	 * @ignore - internal component.
	 */
	var _default = (0, _utils.createSvgIcon)( /*#__PURE__*/React.createElement("path", {
	  d: "M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"
	}), 'Close');
	
	exports.default = _default;

/***/ },
/* 458 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _useAutocomplete.default;
	  }
	});
	Object.defineProperty(exports, "createFilterOptions", {
	  enumerable: true,
	  get: function get() {
	    return _useAutocomplete.createFilterOptions;
	  }
	});
	
	var _useAutocomplete = _interopRequireWildcard(__webpack_require__(459));

/***/ },
/* 459 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createFilterOptions = createFilterOptions;
	exports.default = useAutocomplete;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(33));
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(32));
	
	var React = _interopRequireWildcard(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(66);
	
	/* eslint-disable no-constant-condition */
	// https://stackoverflow.com/questions/990904/remove-accents-diacritics-in-a-string-in-javascript
	// Give up on IE 11 support for this feature
	function stripDiacritics(string) {
	  return typeof string.normalize !== 'undefined' ? string.normalize('NFD').replace(/[\u0300-\u036f]/g, '') : string;
	}
	
	function createFilterOptions() {
	  var config = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _config$ignoreAccents = config.ignoreAccents,
	      ignoreAccents = _config$ignoreAccents === void 0 ? true : _config$ignoreAccents,
	      _config$ignoreCase = config.ignoreCase,
	      ignoreCase = _config$ignoreCase === void 0 ? true : _config$ignoreCase,
	      limit = config.limit,
	      _config$matchFrom = config.matchFrom,
	      matchFrom = _config$matchFrom === void 0 ? 'any' : _config$matchFrom,
	      _config$startAfter = config.startAfter,
	      startAfter = _config$startAfter === void 0 ? 0 : _config$startAfter,
	      stringify = config.stringify,
	      _config$trim = config.trim,
	      trim = _config$trim === void 0 ? false : _config$trim;
	  return function (options, _ref) {
	    var inputValue = _ref.inputValue,
	        getOptionLabel = _ref.getOptionLabel;
	    var input = trim ? inputValue.trim() : inputValue;
	
	    if (ignoreCase) {
	      input = input.toLowerCase();
	    }
	
	    if (ignoreAccents) {
	      input = stripDiacritics(input);
	    }
	
	    if (startAfter > 0 && input.length <= startAfter) {
	      return [];
	    }
	
	    var filteredOptions = options.filter(function (option) {
	      var candidate = (stringify || getOptionLabel)(option);
	
	      if (ignoreCase) {
	        candidate = candidate.toLowerCase();
	      }
	
	      if (ignoreAccents) {
	        candidate = stripDiacritics(candidate);
	      }
	
	      return matchFrom === 'start' ? candidate.indexOf(input) === 0 : candidate.indexOf(input) > -1;
	    });
	    return typeof limit === 'number' ? filteredOptions.slice(0, limit) : filteredOptions;
	  };
	} // To replace with .findIndex() once we stop IE 11 support.
	
	
	function findIndex(array, comp) {
	  for (var i = 0; i < array.length; i += 1) {
	    if (comp(array[i])) {
	      return i;
	    }
	  }
	
	  return -1;
	}
	
	var defaultFilterOptions = createFilterOptions(); // Number of options to jump in list box when pageup and pagedown keys are used.
	
	var pageSize = 5;
	
	function useAutocomplete(props) {
	  var _props$autoComplete = props.autoComplete,
	      autoComplete = _props$autoComplete === void 0 ? false : _props$autoComplete,
	      _props$autoHighlight = props.autoHighlight,
	      autoHighlight = _props$autoHighlight === void 0 ? false : _props$autoHighlight,
	      _props$autoSelect = props.autoSelect,
	      autoSelect = _props$autoSelect === void 0 ? false : _props$autoSelect,
	      _props$blurOnSelect = props.blurOnSelect,
	      blurOnSelect = _props$blurOnSelect === void 0 ? false : _props$blurOnSelect,
	      _props$clearOnEscape = props.clearOnEscape,
	      clearOnEscape = _props$clearOnEscape === void 0 ? false : _props$clearOnEscape,
	      _props$componentName = props.componentName,
	      componentName = _props$componentName === void 0 ? 'useAutocomplete' : _props$componentName,
	      _props$debug = props.debug,
	      debug = _props$debug === void 0 ? false : _props$debug,
	      _props$defaultValue = props.defaultValue,
	      defaultValue = _props$defaultValue === void 0 ? props.multiple ? [] : null : _props$defaultValue,
	      _props$disableClearab = props.disableClearable,
	      disableClearable = _props$disableClearab === void 0 ? false : _props$disableClearab,
	      _props$disableCloseOn = props.disableCloseOnSelect,
	      disableCloseOnSelect = _props$disableCloseOn === void 0 ? false : _props$disableCloseOn,
	      _props$disabledItemsF = props.disabledItemsFocusable,
	      disabledItemsFocusable = _props$disabledItemsF === void 0 ? false : _props$disabledItemsF,
	      _props$disableListWra = props.disableListWrap,
	      disableListWrap = _props$disableListWra === void 0 ? false : _props$disableListWra,
	      _props$filterOptions = props.filterOptions,
	      filterOptions = _props$filterOptions === void 0 ? defaultFilterOptions : _props$filterOptions,
	      _props$filterSelected = props.filterSelectedOptions,
	      filterSelectedOptions = _props$filterSelected === void 0 ? false : _props$filterSelected,
	      _props$freeSolo = props.freeSolo,
	      freeSolo = _props$freeSolo === void 0 ? false : _props$freeSolo,
	      getOptionDisabled = props.getOptionDisabled,
	      _props$getOptionLabel = props.getOptionLabel,
	      getOptionLabel = _props$getOptionLabel === void 0 ? function (x) {
	    return x;
	  } : _props$getOptionLabel,
	      _props$getOptionSelec = props.getOptionSelected,
	      getOptionSelected = _props$getOptionSelec === void 0 ? function (option, value) {
	    return option === value;
	  } : _props$getOptionSelec,
	      groupBy = props.groupBy,
	      idProp = props.id,
	      _props$includeInputIn = props.includeInputInList,
	      includeInputInList = _props$includeInputIn === void 0 ? false : _props$includeInputIn,
	      inputValueProp = props.inputValue,
	      _props$multiple = props.multiple,
	      multiple = _props$multiple === void 0 ? false : _props$multiple,
	      onChange = props.onChange,
	      onClose = props.onClose,
	      onInputChange = props.onInputChange,
	      onOpen = props.onOpen,
	      openProp = props.open,
	      _props$openOnFocus = props.openOnFocus,
	      openOnFocus = _props$openOnFocus === void 0 ? false : _props$openOnFocus,
	      options = props.options,
	      _props$selectOnFocus = props.selectOnFocus,
	      selectOnFocus = _props$selectOnFocus === void 0 ? !props.freeSolo : _props$selectOnFocus,
	      valueProp = props.value;
	  var id = (0, _utils.unstable_useId)(idProp);
	  var ignoreFocus = React.useRef(false);
	  var firstFocus = React.useRef(true);
	  var inputRef = React.useRef(null);
	  var listboxRef = React.useRef(null);
	
	  var _React$useState = React.useState(null),
	      anchorEl = _React$useState[0],
	      setAnchorEl = _React$useState[1];
	
	  var _React$useState2 = React.useState(-1),
	      focusedTag = _React$useState2[0],
	      setFocusedTag = _React$useState2[1];
	
	  var defaultHighlighted = autoHighlight ? 0 : -1;
	  var highlightedIndexRef = React.useRef(defaultHighlighted);
	  var setHighlightedIndex = (0, _utils.useEventCallback)(function (index) {
	    var mouse = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	    highlightedIndexRef.current = index; // does the index exist?
	
	    if (index === -1) {
	      inputRef.current.removeAttribute('aria-activedescendant');
	    } else {
	      inputRef.current.setAttribute('aria-activedescendant', "".concat(id, "-option-").concat(index));
	    }
	
	    if (!listboxRef.current) {
	      return;
	    }
	
	    var prev = listboxRef.current.querySelector('[data-focus]');
	
	    if (prev) {
	      prev.removeAttribute('data-focus');
	    }
	
	    var listboxNode = listboxRef.current.parentElement.querySelector('[role="listbox"]'); // "No results"
	
	    if (!listboxNode) {
	      return;
	    }
	
	    if (index === -1) {
	      listboxNode.scrollTop = 0;
	      return;
	    }
	
	    var option = listboxRef.current.querySelector("[data-option-index=\"".concat(index, "\"]"));
	
	    if (!option) {
	      return;
	    }
	
	    option.setAttribute('data-focus', 'true'); // Scroll active descendant into view.
	    // Logic copied from https://www.w3.org/TR/wai-aria-practices/examples/listbox/js/listbox.js
	    //
	    // Consider this API instead once it has a better browser support:
	    // .scrollIntoView({ scrollMode: 'if-needed', block: 'nearest' });
	
	    if (listboxNode.scrollHeight > listboxNode.clientHeight && !mouse) {
	      var element = option;
	      var scrollBottom = listboxNode.clientHeight + listboxNode.scrollTop;
	      var elementBottom = element.offsetTop + element.offsetHeight;
	
	      if (elementBottom > scrollBottom) {
	        listboxNode.scrollTop = elementBottom - listboxNode.clientHeight;
	      } else if (element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0) < listboxNode.scrollTop) {
	        listboxNode.scrollTop = element.offsetTop - element.offsetHeight * (groupBy ? 1.3 : 0);
	      }
	    }
	  });
	
	  var _useControlled = (0, _utils.useControlled)({
	    controlled: valueProp,
	    default: defaultValue,
	    name: componentName
	  }),
	      _useControlled2 = (0, _slicedToArray2.default)(_useControlled, 2),
	      value = _useControlled2[0],
	      setValue = _useControlled2[1];
	
	  var _useControlled3 = (0, _utils.useControlled)({
	    controlled: inputValueProp,
	    default: '',
	    name: componentName,
	    state: 'inputValue'
	  }),
	      _useControlled4 = (0, _slicedToArray2.default)(_useControlled3, 2),
	      inputValue = _useControlled4[0],
	      setInputValue = _useControlled4[1];
	
	  var _React$useState3 = React.useState(false),
	      focused = _React$useState3[0],
	      setFocused = _React$useState3[1];
	
	  var resetInputValue = (0, _utils.useEventCallback)(function (event, newValue) {
	    var newInputValue;
	
	    if (multiple) {
	      newInputValue = '';
	    } else if (newValue == null) {
	      newInputValue = '';
	    } else {
	      var optionLabel = getOptionLabel(newValue);
	
	      if (false) {
	        if (typeof optionLabel !== 'string') {
	          var erroneousReturn = optionLabel === undefined ? 'undefined' : "".concat((0, _typeof2.default)(optionLabel), " (").concat(optionLabel, ")");
	          console.error("Material-UI: the `getOptionLabel` method of ".concat(componentName, " returned ").concat(erroneousReturn, " instead of a string for ").concat(JSON.stringify(newValue), "."));
	        }
	      }
	
	      newInputValue = typeof optionLabel === 'string' ? optionLabel : '';
	    }
	
	    if (inputValue === newInputValue) {
	      return;
	    }
	
	    setInputValue(newInputValue);
	
	    if (onInputChange) {
	      onInputChange(event, newInputValue, 'reset');
	    }
	  });
	  React.useEffect(function () {
	    resetInputValue(null, value);
	  }, [value, resetInputValue]);
	
	  var _React$useRef = React.useRef(openProp != null),
	      isOpenControlled = _React$useRef.current;
	
	  var _React$useState4 = React.useState(false),
	      openState = _React$useState4[0],
	      setOpenState = _React$useState4[1];
	
	  var open = isOpenControlled ? openProp : openState;
	  var inputValueIsSelectedValue = !multiple && value != null && inputValue === getOptionLabel(value);
	  var popupOpen = open;
	  var filteredOptions = popupOpen ? filterOptions(options.filter(function (option) {
	    if (filterSelectedOptions && (multiple ? value : [value]).some(function (value2) {
	      return value2 !== null && getOptionSelected(option, value2);
	    })) {
	      return false;
	    }
	
	    return true;
	  }), // we use the empty string to manipulate `filterOptions` to not filter any options
	  // i.e. the filter predicate always returns true
	  {
	    inputValue: inputValueIsSelectedValue ? '' : inputValue,
	    getOptionLabel: getOptionLabel
	  }) : [];
	  popupOpen = freeSolo && filteredOptions.length === 0 ? false : popupOpen;
	
	  if (false) {
	    if (value !== null && !freeSolo && options.length > 0) {
	      var missingValue = (multiple ? value : [value]).filter(function (value2) {
	        return !options.some(function (option) {
	          return getOptionSelected(option, value2);
	        });
	      });
	
	      if (missingValue.length > 0) {
	        console.warn(["Material-UI: the value provided to ".concat(componentName, " is invalid."), "None of the options match with `".concat(missingValue.length > 1 ? JSON.stringify(missingValue) : JSON.stringify(missingValue[0]), "`."), 'You can use the `getOptionSelected` prop to customize the equality test.'].join('\n'));
	      }
	    }
	  }
	
	  var focusTag = (0, _utils.useEventCallback)(function (tagToFocus) {
	    if (tagToFocus === -1) {
	      inputRef.current.focus();
	    } else {
	      anchorEl.querySelector("[data-tag-index=\"".concat(tagToFocus, "\"]")).focus();
	    }
	  }); // Ensure the focusedTag is never inconsistent
	
	  React.useEffect(function () {
	    if (multiple && focusedTag > value.length - 1) {
	      setFocusedTag(-1);
	      focusTag(-1);
	    }
	  }, [value, multiple, focusedTag, focusTag]);
	
	  function validOptionIndex(index, direction) {
	    if (!listboxRef.current || index === -1) {
	      return -1;
	    }
	
	    var nextFocus = index;
	
	    while (true) {
	      // Out of range
	      if (direction === 'next' && nextFocus === filteredOptions.length || direction === 'previous' && nextFocus === -1) {
	        return -1;
	      }
	
	      var option = listboxRef.current.querySelector("[data-option-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js
	
	      var nextFocusDisabled = disabledItemsFocusable ? false : option && (option.disabled || option.getAttribute('aria-disabled') === 'true');
	
	      if (option && !option.hasAttribute('tabindex') || nextFocusDisabled) {
	        // Move to the next element.
	        nextFocus += direction === 'next' ? 1 : -1;
	      } else {
	        return nextFocus;
	      }
	    }
	  }
	
	  var changeHighlightedIndex = (0, _utils.useEventCallback)(function (diff, direction) {
	    if (!popupOpen) {
	      return;
	    }
	
	    var getNextIndex = function getNextIndex() {
	      var maxIndex = filteredOptions.length - 1;
	
	      if (diff === 'reset') {
	        return defaultHighlighted;
	      }
	
	      if (diff === 'start') {
	        return 0;
	      }
	
	      if (diff === 'end') {
	        return maxIndex;
	      }
	
	      var newIndex = highlightedIndexRef.current + diff;
	
	      if (newIndex < 0) {
	        if (newIndex === -1 && includeInputInList) {
	          return -1;
	        }
	
	        if (disableListWrap && highlightedIndexRef.current !== -1 || Math.abs(diff) > 1) {
	          return 0;
	        }
	
	        return maxIndex;
	      }
	
	      if (newIndex > maxIndex) {
	        if (newIndex === maxIndex + 1 && includeInputInList) {
	          return -1;
	        }
	
	        if (disableListWrap || Math.abs(diff) > 1) {
	          return maxIndex;
	        }
	
	        return 0;
	      }
	
	      return newIndex;
	    };
	
	    var nextIndex = validOptionIndex(getNextIndex(), direction);
	    setHighlightedIndex(nextIndex);
	
	    if (autoComplete && diff !== 'reset') {
	      if (nextIndex === -1) {
	        inputRef.current.value = inputValue;
	      } else {
	        var option = getOptionLabel(filteredOptions[nextIndex]);
	        inputRef.current.value = option; // The portion of the selected suggestion that has not been typed by the user,
	        // a completion string, appears inline after the input cursor in the textbox.
	
	        var index = option.toLowerCase().indexOf(inputValue.toLowerCase());
	
	        if (index === 0 && inputValue.length > 0) {
	          inputRef.current.setSelectionRange(inputValue.length, option.length);
	        }
	      }
	    }
	  });
	  React.useEffect(function () {
	    if (!open) {
	      return;
	    }
	
	    var valueItem = multiple ? value[0] : value; // The popup is empty
	
	    if (filteredOptions.length === 0 || valueItem == null) {
	      changeHighlightedIndex('reset', 'next');
	      return;
	    } // Synchronize the value with the highlighted index
	
	
	    if (!filterSelectedOptions && valueItem != null) {
	      var currentOption = filteredOptions[highlightedIndexRef.current]; // Keep the current highlighted index if possible
	
	      if (multiple && currentOption && findIndex(value, function (val) {
	        return getOptionSelected(currentOption, val);
	      }) !== -1) {
	        return;
	      }
	
	      var itemIndex = findIndex(filteredOptions, function (optionItem) {
	        return getOptionSelected(optionItem, valueItem);
	      });
	      setHighlightedIndex(itemIndex);
	      return;
	    } // Keep the index in the boundaries
	
	
	    if (highlightedIndexRef.current >= filteredOptions.length - 1) {
	      setHighlightedIndex(filteredOptions.length - 1);
	    } // Ignore filterOptions => options, getOptionSelected, getOptionLabel)
	    // eslint-disable-next-line react-hooks/exhaustive-deps
	
	  }, [value, open, filterSelectedOptions, changeHighlightedIndex, setHighlightedIndex, inputValue, multiple]);
	
	  var handleOpen = function handleOpen(event) {
	    if (open) {
	      return;
	    }
	
	    if (onOpen) {
	      onOpen(event);
	    }
	
	    if (!isOpenControlled) {
	      setOpenState(true);
	    }
	  };
	
	  var handleClose = function handleClose(event, reason) {
	    if (!open) {
	      return;
	    }
	
	    if (onClose) {
	      onClose(event, reason);
	    }
	
	    if (!isOpenControlled) {
	      setOpenState(false);
	    }
	  };
	
	  var handleValue = function handleValue(event, newValue, reason, details) {
	    if (value === newValue) {
	      return;
	    }
	
	    if (onChange) {
	      onChange(event, newValue, reason, details);
	    }
	
	    setValue(newValue);
	  };
	
	  var isTouch = React.useRef(false);
	
	  var selectNewValue = function selectNewValue(event, option) {
	    var reasonProp = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : 'select-option';
	    var origin = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : 'options';
	    var reason = reasonProp;
	    var newValue = option;
	
	    if (multiple) {
	      newValue = Array.isArray(value) ? (0, _toConsumableArray2.default)(value) : [];
	
	      if (false) {
	        var matches = newValue.filter(function (val) {
	          return getOptionSelected(option, val);
	        });
	
	        if (matches.length > 1) {
	          console.error(["Material-UI: the `getOptionSelected` method of ".concat(componentName, " do not handle the arguments correctly."), "The component expects a single value to match a given option but found ".concat(matches.length, " matches.")].join('\n'));
	        }
	      }
	
	      var itemIndex = findIndex(newValue, function (valueItem) {
	        return getOptionSelected(option, valueItem);
	      });
	
	      if (itemIndex === -1) {
	        newValue.push(option);
	      } else if (origin !== 'freeSolo') {
	        newValue.splice(itemIndex, 1);
	        reason = 'remove-option';
	      }
	    }
	
	    resetInputValue(event, newValue);
	    handleValue(event, newValue, reason, {
	      option: option
	    });
	
	    if (!disableCloseOnSelect) {
	      handleClose(event, reason);
	    }
	
	    if (blurOnSelect === true || blurOnSelect === 'touch' && isTouch.current || blurOnSelect === 'mouse' && !isTouch.current) {
	      inputRef.current.blur();
	    }
	  };
	
	  function validTagIndex(index, direction) {
	    if (index === -1) {
	      return -1;
	    }
	
	    var nextFocus = index;
	
	    while (true) {
	      // Out of range
	      if (direction === 'next' && nextFocus === value.length || direction === 'previous' && nextFocus === -1) {
	        return -1;
	      }
	
	      var option = anchorEl.querySelector("[data-tag-index=\"".concat(nextFocus, "\"]")); // Same logic as MenuList.js
	
	      if (option && (!option.hasAttribute('tabindex') || option.disabled || option.getAttribute('aria-disabled') === 'true')) {
	        nextFocus += direction === 'next' ? 1 : -1;
	      } else {
	        return nextFocus;
	      }
	    }
	  }
	
	  var handleFocusTag = function handleFocusTag(event, direction) {
	    if (!multiple) {
	      return;
	    }
	
	    handleClose(event, 'toggleInput');
	    var nextTag = focusedTag;
	
	    if (focusedTag === -1) {
	      if (inputValue === '' && direction === 'previous') {
	        nextTag = value.length - 1;
	      }
	    } else {
	      nextTag += direction === 'next' ? 1 : -1;
	
	      if (nextTag < 0) {
	        nextTag = 0;
	      }
	
	      if (nextTag === value.length) {
	        nextTag = -1;
	      }
	    }
	
	    nextTag = validTagIndex(nextTag, direction);
	    setFocusedTag(nextTag);
	    focusTag(nextTag);
	  };
	
	  var handleClear = function handleClear(event) {
	    ignoreFocus.current = true;
	    setInputValue('');
	
	    if (onInputChange) {
	      onInputChange(event, '', 'clear');
	    }
	
	    handleValue(event, multiple ? [] : null, 'clear');
	  };
	
	  var handleKeyDown = function handleKeyDown(other) {
	    return function (event) {
	      if (focusedTag !== -1 && ['ArrowLeft', 'ArrowRight'].indexOf(event.key) === -1) {
	        setFocusedTag(-1);
	        focusTag(-1);
	      }
	
	      switch (event.key) {
	        case 'Home':
	          if (popupOpen) {
	            // Prevent scroll of the page
	            event.preventDefault();
	            changeHighlightedIndex('start', 'next');
	          }
	
	          break;
	
	        case 'End':
	          if (popupOpen) {
	            // Prevent scroll of the page
	            event.preventDefault();
	            changeHighlightedIndex('end', 'previous');
	          }
	
	          break;
	
	        case 'PageUp':
	          // Prevent scroll of the page
	          event.preventDefault();
	          changeHighlightedIndex(-pageSize, 'previous');
	          handleOpen(event);
	          break;
	
	        case 'PageDown':
	          // Prevent scroll of the page
	          event.preventDefault();
	          changeHighlightedIndex(pageSize, 'next');
	          handleOpen(event);
	          break;
	
	        case 'ArrowDown':
	          // Prevent cursor move
	          event.preventDefault();
	          changeHighlightedIndex(1, 'next');
	          handleOpen(event);
	          break;
	
	        case 'ArrowUp':
	          // Prevent cursor move
	          event.preventDefault();
	          changeHighlightedIndex(-1, 'previous');
	          handleOpen(event);
	          break;
	
	        case 'ArrowLeft':
	          handleFocusTag(event, 'previous');
	          break;
	
	        case 'ArrowRight':
	          handleFocusTag(event, 'next');
	          break;
	
	        case 'Enter':
	          // Wait until IME is settled.
	          if (event.which === 229) {
	            break;
	          }
	
	          if (highlightedIndexRef.current !== -1 && popupOpen) {
	            var option = filteredOptions[highlightedIndexRef.current];
	            var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
	
	            if (disabled) {
	              return;
	            } // We don't want to validate the form.
	
	
	            event.preventDefault();
	            selectNewValue(event, option, 'select-option'); // Move the selection to the end.
	
	            if (autoComplete) {
	              inputRef.current.setSelectionRange(inputRef.current.value.length, inputRef.current.value.length);
	            }
	          } else if (freeSolo && inputValue !== '' && inputValueIsSelectedValue === false) {
	            if (multiple) {
	              // Allow people to add new values before they submit the form.
	              event.preventDefault();
	            }
	
	            selectNewValue(event, inputValue, 'create-option', 'freeSolo');
	          }
	
	          break;
	
	        case 'Escape':
	          if (popupOpen) {
	            // Avoid Opera to exit fullscreen mode.
	            event.preventDefault(); // Avoid the Modal to handle the event.
	
	            event.stopPropagation();
	            handleClose(event, 'escape');
	          } else if (clearOnEscape && (inputValue !== '' || multiple && value.length > 0)) {
	            // Avoid Opera to exit fullscreen mode.
	            event.preventDefault(); // Avoid the Modal to handle the event.
	
	            event.stopPropagation();
	            handleClear(event);
	          }
	
	          break;
	
	        case 'Backspace':
	          if (multiple && inputValue === '' && value.length > 0) {
	            var index = focusedTag === -1 ? value.length - 1 : focusedTag;
	            var newValue = (0, _toConsumableArray2.default)(value);
	            newValue.splice(index, 1);
	            handleValue(event, newValue, 'remove-option', {
	              option: value[index]
	            });
	          }
	
	          break;
	
	        default:
	      }
	
	      if (other.onKeyDown) {
	        other.onKeyDown(event);
	      }
	    };
	  };
	
	  var handleFocus = function handleFocus(event) {
	    setFocused(true);
	
	    if (openOnFocus && !ignoreFocus.current) {
	      handleOpen(event);
	    }
	  };
	
	  var handleBlur = function handleBlur(event) {
	    // Ignore the event when using the scrollbar with IE 11
	    if (listboxRef.current !== null && document.activeElement === listboxRef.current.parentElement) {
	      inputRef.current.focus();
	      return;
	    }
	
	    setFocused(false);
	    firstFocus.current = true;
	    ignoreFocus.current = false;
	
	    if (debug && inputValue !== '') {
	      return;
	    }
	
	    if (autoSelect && highlightedIndexRef.current !== -1 && popupOpen) {
	      selectNewValue(event, filteredOptions[highlightedIndexRef.current], 'blur');
	    } else if (autoSelect && freeSolo && inputValue !== '') {
	      selectNewValue(event, inputValue, 'blur', 'freeSolo');
	    } else if (!freeSolo) {
	      resetInputValue(event, value);
	    }
	
	    handleClose(event, 'blur');
	  };
	
	  var handleInputChange = function handleInputChange(event) {
	    var newValue = event.target.value;
	
	    if (inputValue !== newValue) {
	      setInputValue(newValue);
	
	      if (onInputChange) {
	        onInputChange(event, newValue, 'input');
	      }
	    }
	
	    if (newValue === '') {
	      if (!disableClearable && !multiple) {
	        handleValue(event, null, 'clear');
	      }
	    } else {
	      handleOpen(event);
	    }
	  };
	
	  var handleOptionMouseOver = function handleOptionMouseOver(event) {
	    var index = Number(event.currentTarget.getAttribute('data-option-index'));
	    setHighlightedIndex(index, 'mouse');
	  };
	
	  var handleOptionTouchStart = function handleOptionTouchStart() {
	    isTouch.current = true;
	  };
	
	  var handleOptionClick = function handleOptionClick(event) {
	    var index = Number(event.currentTarget.getAttribute('data-option-index'));
	    selectNewValue(event, filteredOptions[index], 'select-option');
	    isTouch.current = false;
	  };
	
	  var handleTagDelete = function handleTagDelete(index) {
	    return function (event) {
	      var newValue = (0, _toConsumableArray2.default)(value);
	      newValue.splice(index, 1);
	      handleValue(event, newValue, 'remove-option', {
	        option: value[index]
	      });
	    };
	  };
	
	  var handleListboxRef = (0, _utils.useEventCallback)(function (node) {
	    (0, _utils.setRef)(listboxRef, node);
	
	    if (!node) {
	      return;
	    } // Automatically select the first option as the listbox become visible.
	
	
	    if (highlightedIndexRef.current === -1 && autoHighlight) {
	      changeHighlightedIndex('reset', 'next');
	    } else {
	      // Restore the focus to the correct option.
	      setHighlightedIndex(highlightedIndexRef.current);
	    }
	  });
	
	  var handlePopupIndicator = function handlePopupIndicator(event) {
	    if (open) {
	      handleClose(event, 'toggleInput');
	    } else {
	      handleOpen(event);
	    }
	  }; // Prevent input blur when interacting with the combobox
	
	
	  var handleMouseDown = function handleMouseDown(event) {
	    if (event.target.getAttribute('id') !== id) {
	      event.preventDefault();
	    }
	  }; // Focus the input when interacting with the combobox
	
	
	  var handleClick = function handleClick() {
	    inputRef.current.focus();
	
	    if (selectOnFocus && firstFocus.current && inputRef.current.selectionEnd - inputRef.current.selectionStart === 0) {
	      inputRef.current.select();
	    }
	
	    firstFocus.current = false;
	  };
	
	  var handleInputMouseDown = function handleInputMouseDown(event) {
	    if (inputValue === '') {
	      handlePopupIndicator(event);
	    }
	  };
	
	  var dirty = freeSolo && inputValue.length > 0;
	  dirty = dirty || (multiple ? value.length > 0 : value !== null);
	  var groupedOptions = filteredOptions;
	
	  if (groupBy) {
	    // used to keep track of key and indexes in the result array
	    var indexBy = new Map();
	    var warn = false;
	    groupedOptions = filteredOptions.reduce(function (acc, option, index) {
	      var group = groupBy(option);
	
	      if (acc.length > 0 && acc[acc.length - 1].group === group) {
	        acc[acc.length - 1].options.push(option);
	      } else {
	        if (false) {
	          if (indexBy.get(group) && !warn) {
	            console.warn("Material-UI: the options provided combined with the `groupBy` method of ".concat(componentName, " returns duplicated headers."), 'You can solve the issue by sorting the options with the output of `groupBy`.');
	            warn = true;
	          }
	
	          indexBy.set(group, true);
	        }
	
	        acc.push({
	          key: index,
	          index: index,
	          group: group,
	          options: [option]
	        });
	      }
	
	      return acc;
	    }, []);
	  }
	
	  return {
	    getRootProps: function getRootProps() {
	      var other = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	      return (0, _extends2.default)({
	        'aria-owns': popupOpen ? "".concat(id, "-popup") : null,
	        role: 'combobox',
	        'aria-expanded': popupOpen
	      }, other, {
	        onKeyDown: handleKeyDown(other),
	        onMouseDown: handleMouseDown,
	        onClick: handleClick
	      });
	    },
	    getInputLabelProps: function getInputLabelProps() {
	      return {
	        id: "".concat(id, "-label"),
	        htmlFor: id
	      };
	    },
	    getInputProps: function getInputProps() {
	      return {
	        id: id,
	        value: inputValue,
	        onBlur: handleBlur,
	        onFocus: handleFocus,
	        onChange: handleInputChange,
	        onMouseDown: handleInputMouseDown,
	        // if open then this is handled imperativeley so don't let react override
	        // only have an opinion about this when closed
	        'aria-activedescendant': popupOpen ? '' : null,
	        'aria-autocomplete': autoComplete ? 'both' : 'list',
	        'aria-controls': popupOpen ? "".concat(id, "-popup") : null,
	        // Disable browser's suggestion that might overlap with the popup.
	        // Handle autocomplete but not autofill.
	        autoComplete: 'off',
	        ref: inputRef,
	        autoCapitalize: 'none',
	        spellCheck: 'false'
	      };
	    },
	    getClearProps: function getClearProps() {
	      return {
	        tabIndex: -1,
	        onClick: handleClear
	      };
	    },
	    getPopupIndicatorProps: function getPopupIndicatorProps() {
	      return {
	        tabIndex: -1,
	        onClick: handlePopupIndicator
	      };
	    },
	    getTagProps: function getTagProps(_ref2) {
	      var index = _ref2.index;
	      return {
	        key: index,
	        'data-tag-index': index,
	        tabIndex: -1,
	        onDelete: handleTagDelete(index)
	      };
	    },
	    getListboxProps: function getListboxProps() {
	      return {
	        role: 'listbox',
	        id: "".concat(id, "-popup"),
	        'aria-labelledby': "".concat(id, "-label"),
	        ref: handleListboxRef,
	        onMouseDown: function onMouseDown(event) {
	          // Prevent blur
	          event.preventDefault();
	        }
	      };
	    },
	    getOptionProps: function getOptionProps(_ref3) {
	      var index = _ref3.index,
	          option = _ref3.option;
	      var selected = (multiple ? value : [value]).some(function (value2) {
	        return value2 != null && getOptionSelected(option, value2);
	      });
	      var disabled = getOptionDisabled ? getOptionDisabled(option) : false;
	      return {
	        key: index,
	        tabIndex: -1,
	        role: 'option',
	        id: "".concat(id, "-option-").concat(index),
	        onMouseOver: handleOptionMouseOver,
	        onClick: handleOptionClick,
	        onTouchStart: handleOptionTouchStart,
	        'data-option-index': index,
	        'aria-disabled': disabled,
	        'aria-selected': selected
	      };
	    },
	    id: id,
	    inputValue: inputValue,
	    value: value,
	    dirty: dirty,
	    popupOpen: popupOpen,
	    focused: focused || focusedTag !== -1,
	    anchorEl: anchorEl,
	    setAnchorEl: setAnchorEl,
	    focusedTag: focusedTag,
	    groupedOptions: groupedOptions
	  };
	}
	
	useAutocomplete.propTypes = {
	  /**
	   * If `true`, the portion of the selected suggestion that has not been typed by the user,
	   * known as the completion string, appears inline after the input cursor in the textbox.
	   * The inline completion string is visually highlighted and has a selected state.
	   */
	  autoComplete: _propTypes.default.bool,
	
	  /**
	   * If `true`, the first option is automatically highlighted.
	   */
	  autoHighlight: _propTypes.default.bool,
	
	  /**
	   * If `true`, the selected option becomes the value of the input
	   * when the Autocomplete loses focus unless the user chooses
	   * a different option or changes the character string in the input.
	   */
	  autoSelect: _propTypes.default.bool,
	
	  /**
	   * Override or extend the styles applied to the component.
	   * See [CSS API](#css) below for more details.
	   */
	  classes: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  className: _propTypes.default.string,
	
	  /**
	   * If `true`, clear all values when the user presses escape and the popup is closed.
	   */
	  clearOnEscape: _propTypes.default.bool,
	
	  /**
	   * The component name that is using this hook. Used for warnings.
	   */
	  componentName: _propTypes.default.string,
	
	  /**
	   * If `true`, the popup will ignore the blur event if the input is filled.
	   * You can inspect the popup markup with your browser tools.
	   * Consider this option when you need to customize the component.
	   */
	  debug: _propTypes.default.bool,
	
	  /**
	   * The default input value. Use when the component is not controlled.
	   */
	  defaultValue: _propTypes.default.any,
	
	  /**
	   * If `true`, the input can't be cleared.
	   */
	  disableClearable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the popup won't close when a value is selected.
	   */
	  disableCloseOnSelect: _propTypes.default.bool,
	
	  /**
	   * If `true`, will allow focus on disabled items.
	   */
	  disabledItemsFocusable: _propTypes.default.bool,
	
	  /**
	   * If `true`, the list box in the popup will not wrap focus.
	   */
	  disableListWrap: _propTypes.default.bool,
	
	  /**
	   * A filter function that determins the options that are eligible.
	   *
	   * @param {any} options The options to render.
	   * @param {object} state The state of the component.
	   * @returns {boolean}
	   */
	  filterOptions: _propTypes.default.func,
	
	  /**
	   * If `true`, hide the selected options from the list box.
	   */
	  filterSelectedOptions: _propTypes.default.bool,
	
	  /**
	   * If `true`, the Autocomplete is free solo, meaning that the user input is not bound to provided options.
	   */
	  freeSolo: _propTypes.default.bool,
	
	  /**
	   * Used to determine the disabled state for a given option.
	   */
	  getOptionDisabled: _propTypes.default.func,
	
	  /**
	   * Used to determine the string value for a given option.
	   * It's used to fill the input (and the list box options if `renderOption` is not provided).
	   */
	  getOptionLabel: _propTypes.default.func,
	
	  /**
	   * If provided, the options will be grouped under the returned string.
	   * The groupBy value is also used as the text for group headings when `renderGroup` is not provided.
	   *
	   * @param {any} options The option to group.
	   * @returns {string}
	   */
	  groupBy: _propTypes.default.func,
	
	  /**
	   * This prop is used to help implement the accessibility logic.
	   * If you don't provide this prop. It falls back to a randomly generated id.
	   */
	  id: _propTypes.default.string,
	
	  /**
	   * If `true`, the highlight can move to the input.
	   */
	  includeInputInList: _propTypes.default.bool,
	
	  /**
	   * If `true`, `value` must be an array and the menu will support multiple selections.
	   */
	  multiple: _propTypes.default.bool,
	
	  /**
	   * Callback fired when the value changes.
	   *
	   * @param {object} event The event source of the callback
	   * @param {any} value
	   * @param {string} reason One of "create-option", "select-option", "remove-option", "blur" or "clear".
	   */
	  onChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the popup requests to be closed.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onClose: _propTypes.default.func,
	
	  /**
	   * Callback fired when the text input value changes.
	   *
	   * @param {object} event The event source of the callback.
	   * @param {string} value The new value of the text input.
	   * @param {string} reason One of "input" (user input) or "reset" (programmatic change).
	   */
	  onInputChange: _propTypes.default.func,
	
	  /**
	   * Callback fired when the popup requests to be opened.
	   * Use in controlled mode (see open).
	   *
	   * @param {object} event The event source of the callback.
	   */
	  onOpen: _propTypes.default.func,
	
	  /**
	   * Control the popup` open state.
	   */
	  open: _propTypes.default.bool,
	
	  /**
	   * If `true`, the popup will open on input focus.
	   */
	  openOnFocus: _propTypes.default.bool,
	
	  /**
	   * Array of options.
	   */
	  options: _propTypes.default.array,
	
	  /**
	   * The input value.
	   */
	  value: _propTypes.default.any
	};

/***/ },
/* 460 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _classCallCheck2 = _interopRequireDefault(__webpack_require__(73));
	
	var _createClass2 = _interopRequireDefault(__webpack_require__(60));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _jss = __webpack_require__(40);
	
	var _StylesProvider = _interopRequireDefault(__webpack_require__(91));
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(92));
	
	var ServerStyleSheets = /*#__PURE__*/function () {
	  function ServerStyleSheets() {
	    var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    (0, _classCallCheck2.default)(this, ServerStyleSheets);
	    this.options = options;
	  }
	
	  (0, _createClass2.default)(ServerStyleSheets, [{
	    key: "collect",
	    value: function collect(children) {
	      // This is needed in order to deduplicate the injection of CSS in the page.
	      var sheetsManager = new Map(); // This is needed in order to inject the critical CSS.
	
	      this.sheetsRegistry = new _jss.SheetsRegistry(); // A new class name generator
	
	      var generateClassName = (0, _createGenerateClassName.default)();
	      return /*#__PURE__*/_react.default.createElement(_StylesProvider.default, (0, _extends2.default)({
	        sheetsManager: sheetsManager,
	        serverGenerateClassName: generateClassName,
	        sheetsRegistry: this.sheetsRegistry
	      }, this.options), children);
	    }
	  }, {
	    key: "toString",
	    value: function toString() {
	      return this.sheetsRegistry ? this.sheetsRegistry.toString() : '';
	    }
	  }, {
	    key: "getStyleElement",
	    value: function getStyleElement(props) {
	      return _react.default.createElement('style', (0, _extends2.default)({
	        id: 'jss-server-side',
	        key: 'jss-server-side',
	        dangerouslySetInnerHTML: {
	          __html: this.toString()
	        }
	      }, props));
	    }
	  }]);
	  return ServerStyleSheets;
	}();
	
	exports.default = ServerStyleSheets;

/***/ },
/* 461 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ServerStyleSheets.default;
	  }
	});
	
	var _ServerStyleSheets = _interopRequireDefault(__webpack_require__(460));

/***/ },
/* 462 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = StylesProvider;
	exports.StylesContext = exports.sheetsManager = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(9);
	
	var _createGenerateClassName = _interopRequireDefault(__webpack_require__(92));
	
	var _jss = __webpack_require__(40);
	
	var _jssPreset = _interopRequireDefault(__webpack_require__(170));
	
	// Default JSS instance.
	var jss = (0, _jss.create)((0, _jssPreset.default)()); // Use a singleton or the provided one by the context.
	//
	// The counter-based approach doesn't tolerate any mistake.
	// It's much safer to use the same counter everywhere.
	
	var generateClassName = (0, _createGenerateClassName.default)(); // Exported for test purposes
	
	var sheetsManager = new Map();
	exports.sheetsManager = sheetsManager;
	var defaultOptions = {
	  disableGeneration: false,
	  generateClassName: generateClassName,
	  jss: jss,
	  sheetsCache: null,
	  sheetsManager: sheetsManager,
	  sheetsRegistry: null
	};
	
	var StylesContext = _react.default.createContext(defaultOptions);
	
	exports.StylesContext = StylesContext;
	
	if (false) {
	  StylesContext.displayName = 'StylesContext';
	}
	
	var injectFirstNode;
	
	function StylesProvider(props) {
	  var children = props.children,
	      _props$injectFirst = props.injectFirst,
	      injectFirst = _props$injectFirst === void 0 ? false : _props$injectFirst,
	      _props$disableGenerat = props.disableGeneration,
	      disableGeneration = _props$disableGenerat === void 0 ? false : _props$disableGenerat,
	      localOptions = (0, _objectWithoutProperties2.default)(props, ["children", "injectFirst", "disableGeneration"]);
	
	  var outerOptions = _react.default.useContext(StylesContext);
	
	  var context = (0, _extends2.default)({}, outerOptions, {
	    disableGeneration: disableGeneration
	  }, localOptions);
	
	  if (false) {
	    if (typeof window === 'undefined' && !context.sheetsManager) {
	      console.error('Material-UI: you need to use the ServerStyleSheets API when rendering on the server.');
	    }
	  }
	
	  if (false) {
	    if (context.jss.options.insertionPoint && injectFirst) {
	      console.error('Material-UI: you cannot use a custom insertionPoint and <StylesContext injectFirst> at the same time.');
	    }
	  }
	
	  if (false) {
	    if (injectFirst && localOptions.jss) {
	      console.error('Material-UI: you cannot use the jss and injectFirst props at the same time.');
	    }
	  }
	
	  if (!context.jss.options.insertionPoint && injectFirst && typeof window !== 'undefined') {
	    if (!injectFirstNode) {
	      var head = document.head;
	      injectFirstNode = document.createComment('mui-inject-first');
	      head.insertBefore(injectFirstNode, head.firstChild);
	    }
	
	    context.jss = (0, _jss.create)({
	      plugins: (0, _jssPreset.default)().plugins,
	      insertionPoint: injectFirstNode
	    });
	  }
	
	  return /*#__PURE__*/_react.default.createElement(StylesContext.Provider, {
	    value: context
	  }, children);
	}
	
	 false ? StylesProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * You can disable the generation of the styles with this option.
	   * It can be useful when traversing the React tree outside of the HTML
	   * rendering step on the server.
	   * Let's say you are using react-apollo to extract all
	   * the queries made by the interface server-side - you can significantly speed up the traversal with this prop.
	   */
	  disableGeneration: _propTypes.default.bool,
	
	  /**
	   * JSS's class name generator.
	   */
	  generateClassName: _propTypes.default.func,
	
	  /**
	   * By default, the styles are injected last in the <head> element of the page.
	   * As a result, they gain more specificity than any other style sheet.
	   * If you want to override Material-UI's styles, set this prop.
	   */
	  injectFirst: _propTypes.default.bool,
	
	  /**
	   * JSS's instance.
	   */
	  jss: _propTypes.default.object,
	
	  /**
	   * @ignore
	   */
	  serverGenerateClassName: _propTypes.default.func,
	
	  /**
	   * @ignore
	   *
	   * Beta feature.
	   *
	   * Cache for the sheets.
	   */
	  sheetsCache: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * The sheetsManager is used to deduplicate style sheet injection in the page.
	   * It's deduplicating using the (theme, styles) couple.
	   * On the server, you should provide a new instance for each request.
	   */
	  sheetsManager: _propTypes.default.object,
	
	  /**
	   * @ignore
	   *
	   * Collect the sheets.
	   */
	  sheetsRegistry: _propTypes.default.object
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? StylesProvider.propTypes = (0, _utils.exactProp)(StylesProvider.propTypes) : void 0;
	}

/***/ },
/* 463 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(9);
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(172));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(58));
	
	var _nested = _interopRequireDefault(__webpack_require__(167));
	
	// To support composition of theme.
	function mergeOuterLocalTheme(outerTheme, localTheme) {
	  if (typeof localTheme === 'function') {
	    var mergedTheme = localTheme(outerTheme);
	
	    if (false) {
	      if (!mergedTheme) {
	        console.error(['Material-UI: you should return an object from your theme function, i.e.', '<ThemeProvider theme={() => ({})} />'].join('\n'));
	      }
	    }
	
	    return mergedTheme;
	  }
	
	  return (0, _extends2.default)({}, outerTheme, {}, localTheme);
	}
	/**
	 * This component takes a `theme` prop.
	 * It makes the `theme` available down the React tree thanks to React context.
	 * This component should preferably be used at **the root of your component tree**.
	 */
	
	
	function ThemeProvider(props) {
	  var children = props.children,
	      localTheme = props.theme;
	  var outerTheme = (0, _useTheme.default)();
	
	  if (false) {
	    if (outerTheme === null && typeof localTheme === 'function') {
	      console.error(['Material-UI: you are providing a theme function prop to the ThemeProvider component:', '<ThemeProvider theme={outerTheme => outerTheme} />', '', 'However, no outer theme is present.', 'Make sure a theme is already injected higher in the React tree ' + 'or provide a theme object.'].join('\n'));
	    }
	  }
	
	  var theme = _react.default.useMemo(function () {
	    var output = outerTheme === null ? localTheme : mergeOuterLocalTheme(outerTheme, localTheme);
	
	    if (output != null) {
	      output[_nested.default] = outerTheme !== null;
	    }
	
	    return output;
	  }, [localTheme, outerTheme]);
	
	  return /*#__PURE__*/_react.default.createElement(_ThemeContext.default.Provider, {
	    value: theme
	  }, children);
	}
	
	 false ? ThemeProvider.propTypes = {
	  /**
	   * Your component tree.
	   */
	  children: _propTypes.default.node.isRequired,
	
	  /**
	   * A theme object. You can provide a function to extend the outer theme.
	   */
	  theme: _propTypes.default.oneOfType([_propTypes.default.object, _propTypes.default.func]).isRequired
	} : void 0;
	
	if (false) {
	  process.env.NODE_ENV !== "production" ? ThemeProvider.propTypes = (0, _utils.exactProp)(ThemeProvider.propTypes) : void 0;
	}
	
	var _default = ThemeProvider;
	exports.default = _default;

/***/ },
/* 464 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _ThemeProvider.default;
	  }
	});
	
	var _ThemeProvider = _interopRequireDefault(__webpack_require__(463));

/***/ },
/* 465 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createGenerateClassName;
	
	var _nested = _interopRequireDefault(__webpack_require__(167));
	
	/**
	 * This is the list of the style rule name we use as drop in replacement for the built-in
	 * pseudo classes (:checked, :disabled, :focused, etc.).
	 *
	 * Why do they exist in the first place?
	 * These classes are used at a specificity of 2.
	 * It allows them to override previously definied styles as well as
	 * being untouched by simple user overrides.
	 */
	var pseudoClasses = ['checked', 'disabled', 'error', 'focused', 'focusVisible', 'required', 'expanded', 'selected']; // Returns a function which generates unique class names based on counters.
	// When new generator function is created, rule counter is reset.
	// We need to reset the rule counter for SSR for each request.
	//
	// It's inspired by
	// https://github.com/cssinjs/jss/blob/4e6a05dd3f7b6572fdd3ab216861d9e446c20331/src/utils/createGenerateClassName.js
	
	function createGenerateClassName() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var _options$disableGloba = options.disableGlobal,
	      disableGlobal = _options$disableGloba === void 0 ? false : _options$disableGloba,
	      _options$productionPr = options.productionPrefix,
	      productionPrefix = _options$productionPr === void 0 ? 'jss' : _options$productionPr,
	      _options$seed = options.seed,
	      seed = _options$seed === void 0 ? '' : _options$seed;
	  var seedPrefix = seed === '' ? '' : "".concat(seed, "-");
	  var ruleCounter = 0;
	  return function (rule, styleSheet) {
	    ruleCounter += 1;
	
	    if (false) {
	      if (ruleCounter >= 1e10) {
	        console.warn(['Material-UI: you might have a memory leak.', 'The ruleCounter is not supposed to grow that much.'].join(''));
	      }
	    }
	
	    var name = styleSheet.options.name; // Is a global static MUI style?
	
	    if (name && name.indexOf('Mui') === 0 && !styleSheet.options.link && !disableGlobal) {
	      // We can use a shorthand class name, we never use the keys to style the components.
	      if (pseudoClasses.indexOf(rule.key) !== -1) {
	        return "Mui-".concat(rule.key);
	      }
	
	      var prefix = "".concat(seedPrefix).concat(name, "-").concat(rule.key);
	
	      if (!styleSheet.options.theme[_nested.default] || seed !== '') {
	        return prefix;
	      }
	
	      return "".concat(prefix, "-").concat(ruleCounter);
	    }
	
	    if (true) {
	      return "".concat(seedPrefix).concat(productionPrefix).concat(ruleCounter);
	    }
	
	    var suffix = "".concat(rule.key, "-").concat(ruleCounter); // Help with debuggability.
	
	    if (styleSheet.options.classNamePrefix) {
	      return "".concat(seedPrefix).concat(styleSheet.options.classNamePrefix, "-").concat(suffix);
	    }
	
	    return "".concat(seedPrefix).concat(suffix);
	  };
	}

/***/ },
/* 466 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = createStyles;
	
	function createStyles(styles) {
	  return styles;
	}

/***/ },
/* 467 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _createStyles.default;
	  }
	});
	
	var _createStyles = _interopRequireDefault(__webpack_require__(466));

/***/ },
/* 468 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getStylesCreator;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(33));
	
	var _utils = __webpack_require__(9);
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(168));
	
	function getStylesCreator(stylesOrCreator) {
	  var themingEnabled = typeof stylesOrCreator === 'function';
	
	  if (false) {
	    if ((0, _typeof2.default)(stylesOrCreator) !== 'object' && !themingEnabled) {
	      console.error(['Material-UI: the `styles` argument provided is invalid.', 'You need to provide a function generating the styles or a styles object.'].join('\n'));
	    }
	  }
	
	  return {
	    create: function create(theme, name) {
	      var styles;
	
	      try {
	        styles = themingEnabled ? stylesOrCreator(theme) : stylesOrCreator;
	      } catch (err) {
	        if (false) {
	          if (themingEnabled === true && theme === _noopTheme.default) {
	            // TODO: prepend error message/name instead
	            console.error(['Material-UI: the `styles` argument provided is invalid.', 'You are providing a function without a theme in the context.', 'One of the parent elements needs to use a ThemeProvider.'].join('\n'));
	          }
	        }
	
	        throw err;
	      }
	
	      if (!name || !theme.overrides || !theme.overrides[name]) {
	        return styles;
	      }
	
	      var overrides = theme.overrides[name];
	      var stylesWithOverrides = (0, _extends2.default)({}, styles);
	      Object.keys(overrides).forEach(function (key) {
	        if (false) {
	          if (!stylesWithOverrides[key]) {
	            console.warn(['Material-UI: you are trying to override a style that does not exist.', "Fix the `".concat(key, "` key of `theme.overrides.").concat(name, "`.")].join('\n'));
	          }
	        }
	
	        stylesWithOverrides[key] = (0, _utils.deepmerge)(stylesWithOverrides[key], overrides[key]);
	      });
	      return stylesWithOverrides;
	    },
	    options: {}
	  };
	}

/***/ },
/* 469 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _getStylesCreator.default;
	  }
	});
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(468));

/***/ },
/* 470 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = getThemeProps;
	
	/* eslint-disable no-restricted-syntax */
	function getThemeProps(params) {
	  var theme = params.theme,
	      name = params.name,
	      props = params.props;
	
	  if (!theme || !theme.props || !theme.props[name]) {
	    return props;
	  } // Resolve default props, code borrow from React source.
	  // https://github.com/facebook/react/blob/15a8f031838a553e41c0b66eb1bcf1da8448104d/packages/react/src/ReactElement.js#L221
	
	
	  var defaultProps = theme.props[name];
	  var propName;
	
	  for (propName in defaultProps) {
	    if (props[propName] === undefined) {
	      props[propName] = defaultProps[propName];
	    }
	  }
	
	  return props;
	}

/***/ },
/* 471 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = jssPreset;
	
	var _jssPluginRuleValueFunction = _interopRequireDefault(__webpack_require__(535));
	
	var _jssPluginGlobal = _interopRequireDefault(__webpack_require__(532));
	
	var _jssPluginNested = _interopRequireDefault(__webpack_require__(533));
	
	var _jssPluginCamelCase = _interopRequireDefault(__webpack_require__(530));
	
	var _jssPluginDefaultUnit = _interopRequireDefault(__webpack_require__(531));
	
	var _jssPluginVendorPrefixer = _interopRequireDefault(__webpack_require__(536));
	
	var _jssPluginPropsSort = _interopRequireDefault(__webpack_require__(534));
	
	// Subset of jss-preset-default with only the plugins the Material-UI components are using.
	function jssPreset() {
	  return {
	    plugins: [(0, _jssPluginRuleValueFunction.default)(), (0, _jssPluginGlobal.default)(), (0, _jssPluginNested.default)(), (0, _jssPluginCamelCase.default)(), (0, _jssPluginDefaultUnit.default)(), // Disable the vendor prefixer server-side, it does nothing.
	    // This way, we can get a performance boost.
	    // In the documentation, we are using `autoprefixer` to solve this problem.
	    typeof window === 'undefined' ? null : (0, _jssPluginVendorPrefixer.default)(), (0, _jssPluginPropsSort.default)()]
	  };
	}

/***/ },
/* 472 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.increment = increment;
	
	/* eslint-disable import/prefer-default-export */
	// Global index counter to preserve source order.
	// We create the style sheet during at the creation of the component,
	// children are handled after the parents, so the order of style elements would be parent->child.
	// It is a problem though when a parent passes a className
	// which needs to override any child's styles.
	// StyleSheet of the child has a higher specificity, because of the source order.
	// So our solution is to render sheets them in the reverse order child->sheet, so
	// that parent has a higher specificity.
	var indexCounter = -1e9;
	
	function increment() {
	  indexCounter += 1;
	
	  if (false) {
	    if (indexCounter >= 0) {
	      console.warn(['Material-UI: you might have a memory leak.', 'The indexCounter is not supposed to grow that much.'].join('\n'));
	    }
	  }
	
	  return indexCounter;
	}

/***/ },
/* 473 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = makeStyles;
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _jss = __webpack_require__(40);
	
	var _mergeClasses = _interopRequireDefault(__webpack_require__(171));
	
	var _multiKeyStore = _interopRequireDefault(__webpack_require__(474));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(58));
	
	var _StylesProvider = __webpack_require__(91);
	
	var _indexCounter = __webpack_require__(472);
	
	var _getStylesCreator = _interopRequireDefault(__webpack_require__(469));
	
	var _noopTheme = _interopRequireDefault(__webpack_require__(168));
	
	function getClasses(_ref, classes, Component) {
	  var state = _ref.state,
	      stylesOptions = _ref.stylesOptions;
	
	  if (stylesOptions.disableGeneration) {
	    return classes || {};
	  }
	
	  if (!state.cacheClasses) {
	    state.cacheClasses = {
	      // Cache for the finalized classes value.
	      value: null,
	      // Cache for the last used classes prop pointer.
	      lastProp: null,
	      // Cache for the last used rendered classes pointer.
	      lastJSS: {}
	    };
	  } // Tracks if either the rendered classes or classes prop has changed,
	  // requiring the generation of a new finalized classes object.
	
	
	  var generate = false;
	
	  if (state.classes !== state.cacheClasses.lastJSS) {
	    state.cacheClasses.lastJSS = state.classes;
	    generate = true;
	  }
	
	  if (classes !== state.cacheClasses.lastProp) {
	    state.cacheClasses.lastProp = classes;
	    generate = true;
	  }
	
	  if (generate) {
	    state.cacheClasses.value = (0, _mergeClasses.default)({
	      baseClasses: state.cacheClasses.lastJSS,
	      newClasses: classes,
	      Component: Component
	    });
	  }
	
	  return state.cacheClasses.value;
	}
	
	function attach(_ref2, props) {
	  var state = _ref2.state,
	      theme = _ref2.theme,
	      stylesOptions = _ref2.stylesOptions,
	      stylesCreator = _ref2.stylesCreator,
	      name = _ref2.name;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  if (!sheetManager) {
	    sheetManager = {
	      refs: 0,
	      staticSheet: null,
	      dynamicStyles: null
	    };
	
	    _multiKeyStore.default.set(stylesOptions.sheetsManager, stylesCreator, theme, sheetManager);
	  }
	
	  var options = (0, _extends2.default)({}, stylesCreator.options, {}, stylesOptions, {
	    theme: theme,
	    flip: typeof stylesOptions.flip === 'boolean' ? stylesOptions.flip : theme.direction === 'rtl'
	  });
	  options.generateId = options.serverGenerateClassName || options.generateClassName;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    var staticSheet;
	
	    if (stylesOptions.sheetsCache) {
	      staticSheet = _multiKeyStore.default.get(stylesOptions.sheetsCache, stylesCreator, theme);
	    }
	
	    var styles = stylesCreator.create(theme, name);
	
	    if (!staticSheet) {
	      staticSheet = stylesOptions.jss.createStyleSheet(styles, (0, _extends2.default)({
	        link: false
	      }, options));
	      staticSheet.attach();
	
	      if (stylesOptions.sheetsCache) {
	        _multiKeyStore.default.set(stylesOptions.sheetsCache, stylesCreator, theme, staticSheet);
	      }
	    }
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(staticSheet);
	    }
	
	    sheetManager.staticSheet = staticSheet;
	    sheetManager.dynamicStyles = (0, _jss.getDynamicStyles)(styles);
	  }
	
	  if (sheetManager.dynamicStyles) {
	    var dynamicSheet = stylesOptions.jss.createStyleSheet(sheetManager.dynamicStyles, (0, _extends2.default)({
	      link: true
	    }, options));
	    dynamicSheet.update(props);
	    dynamicSheet.attach();
	    state.dynamicSheet = dynamicSheet;
	    state.classes = (0, _mergeClasses.default)({
	      baseClasses: sheetManager.staticSheet.classes,
	      newClasses: dynamicSheet.classes
	    });
	
	    if (sheetsRegistry) {
	      sheetsRegistry.add(dynamicSheet);
	    }
	  } else {
	    state.classes = sheetManager.staticSheet.classes;
	  }
	
	  sheetManager.refs += 1;
	}
	
	function update(_ref3, props) {
	  var state = _ref3.state;
	
	  if (state.dynamicSheet) {
	    state.dynamicSheet.update(props);
	  }
	}
	
	function detach(_ref4) {
	  var state = _ref4.state,
	      theme = _ref4.theme,
	      stylesOptions = _ref4.stylesOptions,
	      stylesCreator = _ref4.stylesCreator;
	
	  if (stylesOptions.disableGeneration) {
	    return;
	  }
	
	  var sheetManager = _multiKeyStore.default.get(stylesOptions.sheetsManager, stylesCreator, theme);
	
	  sheetManager.refs -= 1;
	  var sheetsRegistry = stylesOptions.sheetsRegistry;
	
	  if (sheetManager.refs === 0) {
	    _multiKeyStore.default.delete(stylesOptions.sheetsManager, stylesCreator, theme);
	
	    stylesOptions.jss.removeStyleSheet(sheetManager.staticSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(sheetManager.staticSheet);
	    }
	  }
	
	  if (state.dynamicSheet) {
	    stylesOptions.jss.removeStyleSheet(state.dynamicSheet);
	
	    if (sheetsRegistry) {
	      sheetsRegistry.remove(state.dynamicSheet);
	    }
	  }
	}
	
	function useSynchronousEffect(func, values) {
	  var key = _react.default.useRef([]);
	
	  var output; // Store "generation" key. Just returns a new object every time
	
	  var currentKey = _react.default.useMemo(function () {
	    return {};
	  }, values); // eslint-disable-line react-hooks/exhaustive-deps
	  // "the first render", or "memo dropped the value"
	
	
	  if (key.current !== currentKey) {
	    key.current = currentKey;
	    output = func();
	  }
	
	  _react.default.useEffect(function () {
	    return function () {
	      if (output) {
	        output();
	      }
	    };
	  }, [currentKey] // eslint-disable-line react-hooks/exhaustive-deps
	  );
	}
	
	function makeStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  var name = options.name,
	      classNamePrefixOption = options.classNamePrefix,
	      Component = options.Component,
	      _options$defaultTheme = options.defaultTheme,
	      defaultTheme = _options$defaultTheme === void 0 ? _noopTheme.default : _options$defaultTheme,
	      stylesOptions2 = (0, _objectWithoutProperties2.default)(options, ["name", "classNamePrefix", "Component", "defaultTheme"]);
	  var stylesCreator = (0, _getStylesCreator.default)(stylesOrCreator);
	  var classNamePrefix = name || classNamePrefixOption || 'makeStyles';
	  stylesCreator.options = {
	    index: (0, _indexCounter.increment)(),
	    name: name,
	    meta: classNamePrefix,
	    classNamePrefix: classNamePrefix
	  };
	
	  var useStyles = function useStyles() {
	    var props = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	    var theme = (0, _useTheme.default)() || defaultTheme;
	    var stylesOptions = (0, _extends2.default)({}, _react.default.useContext(_StylesProvider.StylesContext), {}, stylesOptions2);
	
	    var instance = _react.default.useRef();
	
	    var shouldUpdate = _react.default.useRef();
	
	    useSynchronousEffect(function () {
	      var current = {
	        name: name,
	        state: {},
	        stylesCreator: stylesCreator,
	        stylesOptions: stylesOptions,
	        theme: theme
	      };
	      attach(current, props);
	      shouldUpdate.current = false;
	      instance.current = current;
	      return function () {
	        detach(current);
	      };
	    }, [theme, stylesCreator]);
	
	    _react.default.useEffect(function () {
	      if (shouldUpdate.current) {
	        update(instance.current, props);
	      }
	
	      shouldUpdate.current = true;
	    });
	
	    var classes = getClasses(instance.current, props.classes, Component);
	
	    if (false) {
	      // eslint-disable-next-line react-hooks/rules-of-hooks
	      _react.default.useDebugValue(classes);
	    }
	
	    return classes;
	  };
	
	  return useStyles;
	}

/***/ },
/* 474 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	// Used https://github.com/thinkloop/multi-key-cache as inspiration
	var multiKeyStore = {
	  set: function set(cache, key1, key2, value) {
	    var subCache = cache.get(key1);
	
	    if (!subCache) {
	      subCache = new Map();
	      cache.set(key1, subCache);
	    }
	
	    subCache.set(key2, value);
	  },
	  get: function get(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    return subCache ? subCache.get(key2) : undefined;
	  },
	  delete: function _delete(cache, key1, key2) {
	    var subCache = cache.get(key1);
	    subCache.delete(key2);
	  }
	};
	var _default = multiKeyStore;
	exports.default = _default;

/***/ },
/* 475 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = mergeClasses;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _utils = __webpack_require__(9);
	
	function mergeClasses() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var baseClasses = options.baseClasses,
	      newClasses = options.newClasses,
	      Component = options.Component;
	
	  if (!newClasses) {
	    return baseClasses;
	  }
	
	  var nextClasses = (0, _extends2.default)({}, baseClasses);
	
	  if (false) {
	    if (typeof newClasses === 'string') {
	      console.error(["Material-UI: the value `".concat(newClasses, "` ") + "provided to the classes prop of ".concat((0, _utils.getDisplayName)(Component), " is incorrect."), 'You might want to use the className prop instead.'].join('\n'));
	      return baseClasses;
	    }
	  }
	
	  Object.keys(newClasses).forEach(function (key) {
	    if (false) {
	      if (!baseClasses[key] && newClasses[key]) {
	        console.error(["Material-UI: the key `".concat(key, "` ") + "provided to the classes prop is not implemented in ".concat((0, _utils.getDisplayName)(Component), "."), "You can only override one of the following: ".concat(Object.keys(baseClasses).join(','), ".")].join('\n'));
	      }
	
	      if (newClasses[key] && typeof newClasses[key] !== 'string') {
	        console.error(["Material-UI: the key `".concat(key, "` ") + "provided to the classes prop is not valid for ".concat((0, _utils.getDisplayName)(Component), "."), "You need to provide a non empty string instead of: ".concat(newClasses[key], ".")].join('\n'));
	      }
	    }
	
	    if (newClasses[key]) {
	      nextClasses[key] = "".concat(baseClasses[key], " ").concat(newClasses[key]);
	    }
	  });
	  return nextClasses;
	}

/***/ },
/* 476 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _styled.default;
	  }
	});
	
	var _styled = _interopRequireDefault(__webpack_require__(477));

/***/ },
/* 477 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = styled;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _clsx = _interopRequireDefault(__webpack_require__(8));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _utils = __webpack_require__(9);
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(94));
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(93));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	} // styled-components's API removes the mapping between components and styles.
	// Using components as a low-level styling construct can be simpler.
	
	
	function styled(Component) {
	  var componentCreator = function componentCreator(style) {
	    var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	    var name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["name"]);
	
	    if (false) {
	      throw new Error(['You are calling styled(Component)(style) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var stylesOrCreator = typeof style === 'function' ? function (theme) {
	      return {
	        root: function root(props) {
	          return style((0, _extends2.default)({
	            theme: theme
	          }, props));
	        }
	      };
	    } : {
	      root: style
	    };
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	    var filterProps;
	    var propTypes = {};
	
	    if (style.filterProps) {
	      filterProps = style.filterProps;
	      delete style.filterProps;
	    }
	    /* eslint-disable react/forbid-foreign-prop-types */
	
	
	    if (style.propTypes) {
	      propTypes = style.propTypes;
	      delete style.propTypes;
	    }
	    /* eslint-enable react/forbid-foreign-prop-types */
	
	
	    var StyledComponent = _react.default.forwardRef(function StyledComponent(props, ref) {
	      var children = props.children,
	          classNameProp = props.className,
	          clone = props.clone,
	          ComponentProp = props.component,
	          other = (0, _objectWithoutProperties2.default)(props, ["children", "className", "clone", "component"]);
	      var classes = useStyles(props);
	      var className = (0, _clsx.default)(classes.root, classNameProp);
	      var spread = other;
	
	      if (filterProps) {
	        spread = omit(spread, filterProps);
	      }
	
	      if (clone) {
	        return _react.default.cloneElement(children, (0, _extends2.default)({
	          className: (0, _clsx.default)(children.props.className, className)
	        }, spread));
	      }
	
	      if (typeof children === 'function') {
	        return children((0, _extends2.default)({
	          className: className
	        }, spread));
	      }
	
	      var FinalComponent = ComponentProp || Component;
	      return /*#__PURE__*/_react.default.createElement(FinalComponent, (0, _extends2.default)({
	        ref: ref,
	        className: className
	      }, spread), children);
	    });
	
	     false ? StyledComponent.propTypes = (0, _extends2.default)({
	      /**
	       * A render function or node.
	       */
	      children: _propTypes.default.oneOfType([_propTypes.default.node, _propTypes.default.func]),
	
	      /**
	       * @ignore
	       */
	      className: _propTypes.default.string,
	
	      /**
	       * If `true`, the component will recycle it's children DOM element.
	       * It's using `React.cloneElement` internally.
	       *
	       * This prop will be deprecated and removed in v5
	       */
	      clone: (0, _utils.chainPropTypes)(_propTypes.default.bool, function (props) {
	        if (props.clone && props.component) {
	          return new Error('You can not use the clone and component prop at the same time.');
	        }
	
	        return null;
	      }),
	
	      /**
	       * The component used for the root node.
	       * Either a string to use a DOM element or a component.
	       */
	      component: _propTypes.default.elementType
	    }, propTypes) : void 0;
	
	    if (false) {
	      StyledComponent.displayName = "Styled(".concat(classNamePrefix, ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(StyledComponent, Component);
	    return StyledComponent;
	  };
	
	  return componentCreator;
	}

/***/ },
/* 478 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = useTheme;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _ThemeContext = _interopRequireDefault(__webpack_require__(172));
	
	function useTheme() {
	  var theme = _react.default.useContext(_ThemeContext.default);
	
	  if (false) {
	    // eslint-disable-next-line react-hooks/rules-of-hooks
	    _react.default.useDebugValue(theme);
	  }
	
	  return theme;
	}

/***/ },
/* 479 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withStyles.default;
	  }
	});
	
	var _withStyles = _interopRequireDefault(__webpack_require__(480));

/***/ },
/* 480 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(94));
	
	var _utils = __webpack_require__(9);
	
	var _makeStyles = _interopRequireDefault(__webpack_require__(93));
	
	var _getThemeProps = _interopRequireDefault(__webpack_require__(169));
	
	var _useTheme = _interopRequireDefault(__webpack_require__(58));
	
	// Link a style sheet with a component.
	// It does not modify the component passed to it;
	// instead, it returns a new component, with a `classes` property.
	var withStyles = function withStyles(stylesOrCreator) {
	  var options = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};
	  return function (Component) {
	    var defaultTheme = options.defaultTheme,
	        _options$withTheme = options.withTheme,
	        withTheme = _options$withTheme === void 0 ? false : _options$withTheme,
	        name = options.name,
	        stylesOptions = (0, _objectWithoutProperties2.default)(options, ["defaultTheme", "withTheme", "name"]);
	
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withStyles(styles)(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var classNamePrefix = name;
	
	    if (false) {
	      if (!name) {
	        // Provide a better DX outside production.
	        var displayName = (0, _utils.getDisplayName)(Component);
	
	        if (displayName !== undefined) {
	          classNamePrefix = displayName;
	        }
	      }
	    }
	
	    var useStyles = (0, _makeStyles.default)(stylesOrCreator, (0, _extends2.default)({
	      defaultTheme: defaultTheme,
	      Component: Component,
	      name: name || Component.displayName,
	      classNamePrefix: classNamePrefix
	    }, stylesOptions));
	
	    var WithStyles = _react.default.forwardRef(function WithStyles(props, ref) {
	      var classesProp = props.classes,
	          innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["classes", "innerRef"]); // The wrapper receives only user supplied props, which could be a subset of
	      // the actual props Component might receive due to merging with defaultProps.
	      // So copying it here would give us the same result in the wrapper as well.
	
	      var classes = useStyles((0, _extends2.default)({}, Component.defaultProps, {}, props));
	      var theme;
	      var more = other;
	
	      if (typeof name === 'string' || withTheme) {
	        // name and withTheme are invariant in the outer scope
	        // eslint-disable-next-line react-hooks/rules-of-hooks
	        theme = (0, _useTheme.default)() || defaultTheme;
	
	        if (name) {
	          more = (0, _getThemeProps.default)({
	            theme: theme,
	            name: name,
	            props: other
	          });
	        } // Provide the theme to the wrapped component.
	        // So we don't have to use the `withTheme()` Higher-order Component.
	
	
	        if (withTheme && !more.theme) {
	          more.theme = theme;
	        }
	      }
	
	      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	        ref: innerRef || ref,
	        classes: classes
	      }, more));
	    });
	
	     false ? WithStyles.propTypes = {
	      /**
	       * Override or extend the styles applied to the component.
	       */
	      classes: _propTypes.default.object,
	
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return null; // return new Error(
	        //   'Material-UI: the `innerRef` prop is deprecated and will be removed in v5. ' +
	        //     'Refs are now automatically forwarded to the inner component.',
	        // );
	      })
	    } : void 0;
	
	    if (false) {
	      WithStyles.displayName = "WithStyles(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithStyles, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithStyles.Naked = Component;
	      WithStyles.options = options;
	      WithStyles.useStyles = useStyles;
	    }
	
	    return WithStyles;
	  };
	};
	
	var _default = withStyles;
	exports.default = _default;

/***/ },
/* 481 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var _exportNames = {};
	Object.defineProperty(exports, "default", {
	  enumerable: true,
	  get: function get() {
	    return _withTheme.default;
	  }
	});
	
	var _withTheme = _interopRequireWildcard(__webpack_require__(482));
	
	Object.keys(_withTheme).forEach(function (key) {
	  if (key === "default" || key === "__esModule") return;
	  if (Object.prototype.hasOwnProperty.call(_exportNames, key)) return;
	  Object.defineProperty(exports, key, {
	    enumerable: true,
	    get: function get() {
	      return _withTheme[key];
	    }
	  });
	});

/***/ },
/* 482 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.withThemeCreator = withThemeCreator;
	exports.default = void 0;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _objectWithoutProperties2 = _interopRequireDefault(__webpack_require__(6));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _hoistNonReactStatics = _interopRequireDefault(__webpack_require__(94));
	
	var _utils = __webpack_require__(9);
	
	var _useTheme = _interopRequireDefault(__webpack_require__(58));
	
	function withThemeCreator() {
	  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
	  var defaultTheme = options.defaultTheme;
	
	  var withTheme = function withTheme(Component) {
	    if (false) {
	      if (Component === undefined) {
	        throw new Error(['You are calling withTheme(Component) with an undefined component.', 'You may have forgotten to import it.'].join('\n'));
	      }
	    }
	
	    var WithTheme = _react.default.forwardRef(function WithTheme(props, ref) {
	      var innerRef = props.innerRef,
	          other = (0, _objectWithoutProperties2.default)(props, ["innerRef"]);
	      var theme = (0, _useTheme.default)() || defaultTheme;
	      return /*#__PURE__*/_react.default.createElement(Component, (0, _extends2.default)({
	        theme: theme,
	        ref: innerRef || ref
	      }, other));
	    });
	
	     false ? WithTheme.propTypes = {
	      /**
	       * Use that prop to pass a ref to the decorated component.
	       * @deprecated
	       */
	      innerRef: (0, _utils.chainPropTypes)(_propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]), function (props) {
	        if (props.innerRef == null) {
	          return null;
	        }
	
	        return new Error('Material-UI: the `innerRef` prop is deprecated and will be removed in v5. ' + 'Refs are now automatically forwarded to the inner component.');
	      })
	    } : void 0;
	
	    if (false) {
	      WithTheme.displayName = "WithTheme(".concat((0, _utils.getDisplayName)(Component), ")");
	    }
	
	    (0, _hoistNonReactStatics.default)(WithTheme, Component);
	
	    if (false) {
	      // Exposed for test purposes.
	      WithTheme.Naked = Component;
	    }
	
	    return WithTheme;
	  };
	
	  return withTheme;
	} // Provide the theme object as a prop to the input component.
	// It's an alternative API to useTheme().
	// We encourage the usage of useTheme() where possible.
	
	
	var withTheme = withThemeCreator();
	var _default = withTheme;
	exports.default = _default;

/***/ },
/* 483 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.borderRadius = exports.borderColor = exports.borderLeft = exports.borderBottom = exports.borderRight = exports.borderTop = exports.border = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(28));
	
	var _compose = _interopRequireDefault(__webpack_require__(30));
	
	function getBorder(value) {
	  if (typeof value !== 'number') {
	    return value;
	  }
	
	  return "".concat(value, "px solid");
	}
	
	var border = (0, _style.default)({
	  prop: 'border',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.border = border;
	var borderTop = (0, _style.default)({
	  prop: 'borderTop',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderTop = borderTop;
	var borderRight = (0, _style.default)({
	  prop: 'borderRight',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderRight = borderRight;
	var borderBottom = (0, _style.default)({
	  prop: 'borderBottom',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderBottom = borderBottom;
	var borderLeft = (0, _style.default)({
	  prop: 'borderLeft',
	  themeKey: 'borders',
	  transform: getBorder
	});
	exports.borderLeft = borderLeft;
	var borderColor = (0, _style.default)({
	  prop: 'borderColor',
	  themeKey: 'palette'
	});
	exports.borderColor = borderColor;
	var borderRadius = (0, _style.default)({
	  prop: 'borderRadius',
	  themeKey: 'shape'
	});
	exports.borderRadius = borderRadius;
	var borders = (0, _compose.default)(border, borderTop, borderRight, borderBottom, borderLeft, borderColor, borderRadius);
	var _default = borders;
	exports.default = _default;

/***/ },
/* 484 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _toConsumableArray2 = _interopRequireDefault(__webpack_require__(22));
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _merge = _interopRequireDefault(__webpack_require__(69));
	
	function omit(input, fields) {
	  var output = {};
	  Object.keys(input).forEach(function (prop) {
	    if (fields.indexOf(prop) === -1) {
	      output[prop] = input[prop];
	    }
	  });
	  return output;
	}
	
	function css(styleFunction) {
	  var newStyleFunction = function newStyleFunction(props) {
	    var output = styleFunction(props);
	
	    if (props.css) {
	      return (0, _extends2.default)({}, (0, _merge.default)(output, styleFunction((0, _extends2.default)({
	        theme: props.theme
	      }, props.css))), {}, omit(props.css, [styleFunction.filterProps]));
	    }
	
	    return output;
	  };
	
	  newStyleFunction.propTypes =  false ? (0, _extends2.default)({}, styleFunction.propTypes, {
	    css: _propTypes.default.object
	  }) : {};
	  newStyleFunction.filterProps = ['css'].concat((0, _toConsumableArray2.default)(styleFunction.filterProps));
	  return newStyleFunction;
	}
	
	var _default = css;
	exports.default = _default;

/***/ },
/* 485 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.whiteSpace = exports.visibility = exports.textOverflow = exports.overflow = exports.displayRaw = exports.displayPrint = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(28));
	
	var _compose = _interopRequireDefault(__webpack_require__(30));
	
	var displayPrint = (0, _style.default)({
	  prop: 'displayPrint',
	  cssProperty: false,
	  transform: function transform(value) {
	    return {
	      '@media print': {
	        display: value
	      }
	    };
	  }
	});
	exports.displayPrint = displayPrint;
	var displayRaw = (0, _style.default)({
	  prop: 'display'
	});
	exports.displayRaw = displayRaw;
	var overflow = (0, _style.default)({
	  prop: 'overflow'
	});
	exports.overflow = overflow;
	var textOverflow = (0, _style.default)({
	  prop: 'textOverflow'
	});
	exports.textOverflow = textOverflow;
	var visibility = (0, _style.default)({
	  prop: 'visibility'
	});
	exports.visibility = visibility;
	var whiteSpace = (0, _style.default)({
	  prop: 'whiteSpace'
	});
	exports.whiteSpace = whiteSpace;
	
	var _default = (0, _compose.default)(displayPrint, displayRaw, overflow, textOverflow, visibility, whiteSpace);
	
	exports.default = _default;

/***/ },
/* 486 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.justifySelf = exports.justifyItems = exports.alignSelf = exports.flexShrink = exports.flexGrow = exports.flex = exports.order = exports.alignContent = exports.alignItems = exports.justifyContent = exports.flexWrap = exports.flexDirection = exports.flexBasis = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(28));
	
	var _compose = _interopRequireDefault(__webpack_require__(30));
	
	var flexBasis = (0, _style.default)({
	  prop: 'flexBasis'
	});
	exports.flexBasis = flexBasis;
	var flexDirection = (0, _style.default)({
	  prop: 'flexDirection'
	});
	exports.flexDirection = flexDirection;
	var flexWrap = (0, _style.default)({
	  prop: 'flexWrap'
	});
	exports.flexWrap = flexWrap;
	var justifyContent = (0, _style.default)({
	  prop: 'justifyContent'
	});
	exports.justifyContent = justifyContent;
	var alignItems = (0, _style.default)({
	  prop: 'alignItems'
	});
	exports.alignItems = alignItems;
	var alignContent = (0, _style.default)({
	  prop: 'alignContent'
	});
	exports.alignContent = alignContent;
	var order = (0, _style.default)({
	  prop: 'order'
	});
	exports.order = order;
	var flex = (0, _style.default)({
	  prop: 'flex'
	});
	exports.flex = flex;
	var flexGrow = (0, _style.default)({
	  prop: 'flexGrow'
	});
	exports.flexGrow = flexGrow;
	var flexShrink = (0, _style.default)({
	  prop: 'flexShrink'
	});
	exports.flexShrink = flexShrink;
	var alignSelf = (0, _style.default)({
	  prop: 'alignSelf'
	});
	exports.alignSelf = alignSelf;
	var justifyItems = (0, _style.default)({
	  prop: 'justifyItems'
	});
	exports.justifyItems = justifyItems;
	var justifySelf = (0, _style.default)({
	  prop: 'justifySelf'
	});
	exports.justifySelf = justifySelf;
	var flexbox = (0, _compose.default)(flexBasis, flexDirection, flexWrap, justifyContent, alignItems, alignContent, order, flex, flexGrow, flexShrink, alignSelf, justifyItems, justifySelf);
	var _default = flexbox;
	exports.default = _default;

/***/ },
/* 487 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.gridArea = exports.gridTemplateAreas = exports.gridTemplateRows = exports.gridTemplateColumns = exports.gridAutoRows = exports.gridAutoColumns = exports.gridAutoFlow = exports.gridRow = exports.gridColumn = exports.gridRowGap = exports.gridColumnGap = exports.gridGap = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(28));
	
	var _compose = _interopRequireDefault(__webpack_require__(30));
	
	var gridGap = (0, _style.default)({
	  prop: 'gridGap'
	});
	exports.gridGap = gridGap;
	var gridColumnGap = (0, _style.default)({
	  prop: 'gridColumnGap'
	});
	exports.gridColumnGap = gridColumnGap;
	var gridRowGap = (0, _style.default)({
	  prop: 'gridRowGap'
	});
	exports.gridRowGap = gridRowGap;
	var gridColumn = (0, _style.default)({
	  prop: 'gridColumn'
	});
	exports.gridColumn = gridColumn;
	var gridRow = (0, _style.default)({
	  prop: 'gridRow'
	});
	exports.gridRow = gridRow;
	var gridAutoFlow = (0, _style.default)({
	  prop: 'gridAutoFlow'
	});
	exports.gridAutoFlow = gridAutoFlow;
	var gridAutoColumns = (0, _style.default)({
	  prop: 'gridAutoColumns'
	});
	exports.gridAutoColumns = gridAutoColumns;
	var gridAutoRows = (0, _style.default)({
	  prop: 'gridAutoRows'
	});
	exports.gridAutoRows = gridAutoRows;
	var gridTemplateColumns = (0, _style.default)({
	  prop: 'gridTemplateColumns'
	});
	exports.gridTemplateColumns = gridTemplateColumns;
	var gridTemplateRows = (0, _style.default)({
	  prop: 'gridTemplateRows'
	});
	exports.gridTemplateRows = gridTemplateRows;
	var gridTemplateAreas = (0, _style.default)({
	  prop: 'gridTemplateAreas'
	});
	exports.gridTemplateAreas = gridTemplateAreas;
	var gridArea = (0, _style.default)({
	  prop: 'gridArea'
	});
	exports.gridArea = gridArea;
	var grid = (0, _compose.default)(gridGap, gridColumnGap, gridRowGap, gridColumn, gridRow, gridAutoFlow, gridAutoColumns, gridAutoRows, gridTemplateColumns, gridTemplateRows, gridTemplateAreas, gridArea);
	var _default = grid;
	exports.default = _default;

/***/ },
/* 488 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = memoize;
	
	function memoize(fn) {
	  var cache = {};
	  return function (arg) {
	    if (cache[arg] === undefined) {
	      cache[arg] = fn(arg);
	    }
	
	    return cache[arg];
	  };
	}

/***/ },
/* 489 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.bgcolor = exports.color = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(28));
	
	var _compose = _interopRequireDefault(__webpack_require__(30));
	
	var color = (0, _style.default)({
	  prop: 'color',
	  themeKey: 'palette'
	});
	exports.color = color;
	var bgcolor = (0, _style.default)({
	  prop: 'bgcolor',
	  cssProperty: 'backgroundColor',
	  themeKey: 'palette'
	});
	exports.bgcolor = bgcolor;
	var palette = (0, _compose.default)(color, bgcolor);
	var _default = palette;
	exports.default = _default;

/***/ },
/* 490 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.left = exports.bottom = exports.right = exports.top = exports.zIndex = exports.position = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(28));
	
	var _compose = _interopRequireDefault(__webpack_require__(30));
	
	var position = (0, _style.default)({
	  prop: 'position'
	});
	exports.position = position;
	var zIndex = (0, _style.default)({
	  prop: 'zIndex',
	  themeKey: 'zIndex'
	});
	exports.zIndex = zIndex;
	var top = (0, _style.default)({
	  prop: 'top'
	});
	exports.top = top;
	var right = (0, _style.default)({
	  prop: 'right'
	});
	exports.right = right;
	var bottom = (0, _style.default)({
	  prop: 'bottom'
	});
	exports.bottom = bottom;
	var left = (0, _style.default)({
	  prop: 'left'
	});
	exports.left = left;
	
	var _default = (0, _compose.default)(position, zIndex, top, right, bottom, left);
	
	exports.default = _default;

/***/ },
/* 491 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(28));
	
	var boxShadow = (0, _style.default)({
	  prop: 'boxShadow',
	  themeKey: 'shadows'
	});
	var _default = boxShadow;
	exports.default = _default;

/***/ },
/* 492 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.boxSizing = exports.sizeHeight = exports.sizeWidth = exports.minHeight = exports.maxHeight = exports.height = exports.minWidth = exports.maxWidth = exports.width = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(28));
	
	var _compose = _interopRequireDefault(__webpack_require__(30));
	
	function transform(value) {
	  return value <= 1 ? "".concat(value * 100, "%") : value;
	}
	
	var width = (0, _style.default)({
	  prop: 'width',
	  transform: transform
	});
	exports.width = width;
	var maxWidth = (0, _style.default)({
	  prop: 'maxWidth',
	  transform: transform
	});
	exports.maxWidth = maxWidth;
	var minWidth = (0, _style.default)({
	  prop: 'minWidth',
	  transform: transform
	});
	exports.minWidth = minWidth;
	var height = (0, _style.default)({
	  prop: 'height',
	  transform: transform
	});
	exports.height = height;
	var maxHeight = (0, _style.default)({
	  prop: 'maxHeight',
	  transform: transform
	});
	exports.maxHeight = maxHeight;
	var minHeight = (0, _style.default)({
	  prop: 'minHeight',
	  transform: transform
	});
	exports.minHeight = minHeight;
	var sizeWidth = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'width',
	  transform: transform
	});
	exports.sizeWidth = sizeWidth;
	var sizeHeight = (0, _style.default)({
	  prop: 'size',
	  cssProperty: 'height',
	  transform: transform
	});
	exports.sizeHeight = sizeHeight;
	var boxSizing = (0, _style.default)({
	  prop: 'boxSizing'
	});
	exports.boxSizing = boxSizing;
	var sizing = (0, _compose.default)(width, maxWidth, minWidth, height, maxHeight, minHeight, boxSizing);
	var _default = sizing;
	exports.default = _default;

/***/ },
/* 493 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.createUnarySpacing = createUnarySpacing;
	exports.default = void 0;
	
	var _slicedToArray2 = _interopRequireDefault(__webpack_require__(32));
	
	var _responsivePropType = _interopRequireDefault(__webpack_require__(174));
	
	var _breakpoints = __webpack_require__(95);
	
	var _merge = _interopRequireDefault(__webpack_require__(69));
	
	var _memoize = _interopRequireDefault(__webpack_require__(488));
	
	var properties = {
	  m: 'margin',
	  p: 'padding'
	};
	var directions = {
	  t: 'Top',
	  r: 'Right',
	  b: 'Bottom',
	  l: 'Left',
	  x: ['Left', 'Right'],
	  y: ['Top', 'Bottom']
	};
	var aliases = {
	  marginX: 'mx',
	  marginY: 'my',
	  paddingX: 'px',
	  paddingY: 'py'
	}; // memoize() impact:
	// From 300,000 ops/sec
	// To 350,000 ops/sec
	
	var getCssProperties = (0, _memoize.default)(function (prop) {
	  // It's not a shorthand notation.
	  if (prop.length > 2) {
	    if (aliases[prop]) {
	      prop = aliases[prop];
	    } else {
	      return [prop];
	    }
	  }
	
	  var _prop$split = prop.split(''),
	      _prop$split2 = (0, _slicedToArray2.default)(_prop$split, 2),
	      a = _prop$split2[0],
	      b = _prop$split2[1];
	
	  var property = properties[a];
	  var direction = directions[b] || '';
	  return Array.isArray(direction) ? direction.map(function (dir) {
	    return property + dir;
	  }) : [property + direction];
	});
	var spacingKeys = ['m', 'mt', 'mr', 'mb', 'ml', 'mx', 'my', 'p', 'pt', 'pr', 'pb', 'pl', 'px', 'py', 'margin', 'marginTop', 'marginRight', 'marginBottom', 'marginLeft', 'marginX', 'marginY', 'padding', 'paddingTop', 'paddingRight', 'paddingBottom', 'paddingLeft', 'paddingX', 'paddingY'];
	
	function createUnarySpacing(theme) {
	  var themeSpacing = theme.spacing || 8;
	
	  if (typeof themeSpacing === 'number') {
	    return function (abs) {
	      if (false) {
	        if (typeof abs !== 'number') {
	          console.error("@material-ui/system: expected spacing argument to be a number, got ".concat(abs, "."));
	        }
	      }
	
	      return themeSpacing * abs;
	    };
	  }
	
	  if (Array.isArray(themeSpacing)) {
	    return function (abs) {
	      if (false) {
	        if (abs > themeSpacing.length - 1) {
	          console.error(["@material-ui/system: the value provided (".concat(abs, ") overflows."), "The supported values are: ".concat(JSON.stringify(themeSpacing), "."), "".concat(abs, " > ").concat(themeSpacing.length - 1, ", you need to add the missing values.")].join('\n'));
	        }
	      }
	
	      return themeSpacing[abs];
	    };
	  }
	
	  if (typeof themeSpacing === 'function') {
	    return themeSpacing;
	  }
	
	  if (false) {
	    console.error(["@material-ui/system: the `theme.spacing` value (".concat(themeSpacing, ") is invalid."), 'It should be a number, an array or a function.'].join('\n'));
	  }
	
	  return function () {
	    return undefined;
	  };
	}
	
	function getValue(transformer, propValue) {
	  if (typeof propValue === 'string') {
	    return propValue;
	  }
	
	  var abs = Math.abs(propValue);
	  var transformed = transformer(abs);
	
	  if (propValue >= 0) {
	    return transformed;
	  }
	
	  if (typeof transformed === 'number') {
	    return -transformed;
	  }
	
	  return "-".concat(transformed);
	}
	
	function getStyleFromPropValue(cssProperties, transformer) {
	  return function (propValue) {
	    return cssProperties.reduce(function (acc, cssProperty) {
	      acc[cssProperty] = getValue(transformer, propValue);
	      return acc;
	    }, {});
	  };
	}
	
	function spacing(props) {
	  var theme = props.theme;
	  var transformer = createUnarySpacing(theme);
	  return Object.keys(props).map(function (prop) {
	    // Using a hash computation over an array iteration could be faster, but with only 28 items,
	    // it's doesn't worth the bundle size.
	    if (spacingKeys.indexOf(prop) === -1) {
	      return null;
	    }
	
	    var cssProperties = getCssProperties(prop);
	    var styleFromPropValue = getStyleFromPropValue(cssProperties, transformer);
	    var propValue = props[prop];
	    return (0, _breakpoints.handleBreakpoints)(props, propValue, styleFromPropValue);
	  }).reduce(_merge.default, {});
	}
	
	spacing.propTypes =  false ? spacingKeys.reduce(function (obj, key) {
	  obj[key] = _responsivePropType.default;
	  return obj;
	}, {}) : {};
	spacing.filterProps = spacingKeys;
	var _default = spacing;
	exports.default = _default;

/***/ },
/* 494 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exports.textAlign = exports.lineHeight = exports.letterSpacing = exports.fontWeight = exports.fontStyle = exports.fontSize = exports.fontFamily = void 0;
	
	var _style = _interopRequireDefault(__webpack_require__(28));
	
	var _compose = _interopRequireDefault(__webpack_require__(30));
	
	var fontFamily = (0, _style.default)({
	  prop: 'fontFamily',
	  themeKey: 'typography'
	});
	exports.fontFamily = fontFamily;
	var fontSize = (0, _style.default)({
	  prop: 'fontSize',
	  themeKey: 'typography'
	});
	exports.fontSize = fontSize;
	var fontStyle = (0, _style.default)({
	  prop: 'fontStyle',
	  themeKey: 'typography'
	});
	exports.fontStyle = fontStyle;
	var fontWeight = (0, _style.default)({
	  prop: 'fontWeight',
	  themeKey: 'typography'
	});
	exports.fontWeight = fontWeight;
	var letterSpacing = (0, _style.default)({
	  prop: 'letterSpacing'
	});
	exports.letterSpacing = letterSpacing;
	var lineHeight = (0, _style.default)({
	  prop: 'lineHeight'
	});
	exports.lineHeight = lineHeight;
	var textAlign = (0, _style.default)({
	  prop: 'textAlign'
	});
	exports.textAlign = textAlign;
	var typography = (0, _compose.default)(fontFamily, fontSize, fontStyle, fontWeight, letterSpacing, lineHeight, textAlign);
	var _default = typography;
	exports.default = _default;

/***/ },
/* 495 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.isPlainObject = isPlainObject;
	exports.default = deepmerge;
	
	var _extends2 = _interopRequireDefault(__webpack_require__(5));
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(33));
	
	function isPlainObject(item) {
	  return item && (0, _typeof2.default)(item) === 'object' && item.constructor === Object;
	}
	
	function deepmerge(target, source) {
	  var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {
	    clone: true
	  };
	  var output = options.clone ? (0, _extends2.default)({}, target) : target;
	
	  if (isPlainObject(target) && isPlainObject(source)) {
	    Object.keys(source).forEach(function (key) {
	      // Avoid prototype pollution
	      if (key === '__proto__') {
	        return;
	      }
	
	      if (isPlainObject(source[key]) && key in target) {
	        output[key] = deepmerge(target[key], source[key], options);
	      } else {
	        output[key] = source[key];
	      }
	    });
	  }
	
	  return output;
	}

/***/ },
/* 496 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(96));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function acceptingRef(props, propName, componentName, location, propFullName) {
	  var element = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (element == null) {
	    return null;
	  }
	
	  var warningHint;
	  var elementType = element.type;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof elementType === 'function' && !isClassComponent(elementType)) {
	    warningHint = 'Did you accidentally use a plain function component for an element instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var elementAcceptingRef = (0, _chainPropTypes.default)(_propTypes.default.element, acceptingRef);
	elementAcceptingRef.isRequired = (0, _chainPropTypes.default)(_propTypes.default.element.isRequired, acceptingRef);
	var _default = elementAcceptingRef;
	exports.default = _default;

/***/ },
/* 497 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	var _interopRequireWildcard = __webpack_require__(3);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var PropTypes = _interopRequireWildcard(__webpack_require__(4));
	
	var _chainPropTypes = _interopRequireDefault(__webpack_require__(96));
	
	function isClassComponent(elementType) {
	  // elementType.prototype?.isReactComponent
	  var _elementType$prototyp = elementType.prototype,
	      prototype = _elementType$prototyp === void 0 ? {} : _elementType$prototyp;
	  return Boolean(prototype.isReactComponent);
	}
	
	function elementTypeAcceptingRef(props, propName, componentName, location, propFullName) {
	  var propValue = props[propName];
	  var safePropName = propFullName || propName;
	
	  if (propValue == null) {
	    return null;
	  }
	
	  var warningHint;
	  /**
	   * Blacklisting instead of whitelisting
	   *
	   * Blacklisting will miss some components, such as React.Fragment. Those will at least
	   * trigger a warning in React.
	   * We can't whitelist because there is no safe way to detect React.forwardRef
	   * or class components. "Safe" means there's no public API.
	   *
	   */
	
	  if (typeof propValue === 'function' && !isClassComponent(propValue)) {
	    warningHint = 'Did you accidentally provide a plain function component instead?';
	  }
	
	  if (warningHint !== undefined) {
	    return new Error("Invalid ".concat(location, " `").concat(safePropName, "` supplied to `").concat(componentName, "`. ") + "Expected an element type that can hold a ref. ".concat(warningHint, " ") + 'For more information see https://material-ui.com/r/caveat-with-refs-guide');
	  }
	
	  return null;
	}
	
	var _default = (0, _chainPropTypes.default)(PropTypes.elementType, elementTypeAcceptingRef);
	
	exports.default = _default;

/***/ },
/* 498 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = exactProp;
	exports.specialProperty = void 0;
	
	var _defineProperty2 = _interopRequireDefault(__webpack_require__(12));
	
	var _extends3 = _interopRequireDefault(__webpack_require__(5));
	
	// This module is based on https://github.com/airbnb/prop-types-exact repository.
	// However, in order to reduce the number of dependencies and to remove some extra safe checks
	// the module was forked.
	// Only exported for test purposes.
	var specialProperty = "exact-prop: \u200B";
	exports.specialProperty = specialProperty;
	
	function exactProp(propTypes) {
	  if (true) {
	    return propTypes;
	  }
	
	  return (0, _extends3.default)({}, propTypes, (0, _defineProperty2.default)({}, specialProperty, function (props) {
	    var unsupportedProps = Object.keys(props).filter(function (prop) {
	      return !propTypes.hasOwnProperty(prop);
	    });
	
	    if (unsupportedProps.length > 0) {
	      return new Error("The following props are not supported: ".concat(unsupportedProps.map(function (prop) {
	        return "`".concat(prop, "`");
	      }).join(', '), ". Please remove them."));
	    }
	
	    return null;
	  }));
	}

/***/ },
/* 499 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.getFunctionName = getFunctionName;
	exports.default = getDisplayName;
	
	var _typeof2 = _interopRequireDefault(__webpack_require__(33));
	
	var _reactIs = __webpack_require__(18);
	
	// Simplified polyfill for IE 11 support
	// https://github.com/JamesMGreene/Function.name/blob/58b314d4a983110c3682f1228f845d39ccca1817/Function.name.js#L3
	var fnNameMatchRegex = /^\s*function(?:\s|\s*\/\*.*\*\/\s*)+([^(\s/]*)\s*/;
	
	function getFunctionName(fn) {
	  var match = "".concat(fn).match(fnNameMatchRegex);
	  var name = match && match[1];
	  return name || '';
	}
	/**
	 * @param {function} Component
	 * @param {string} fallback
	 * @returns {string | undefined}
	 */
	
	
	function getFunctionComponentName(Component) {
	  var fallback = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : '';
	  return Component.displayName || Component.name || getFunctionName(Component) || fallback;
	}
	
	function getWrappedName(outerType, innerType, wrapperName) {
	  var functionName = getFunctionComponentName(innerType);
	  return outerType.displayName || (functionName !== '' ? "".concat(wrapperName, "(").concat(functionName, ")") : wrapperName);
	}
	/**
	 * cherry-pick from
	 * https://github.com/facebook/react/blob/769b1f270e1251d9dbdce0fcbd9e92e502d059b8/packages/shared/getComponentName.js
	 * originally forked from recompose/getDisplayName with added IE 11 support
	 *
	 * @param {React.ReactType} Component
	 * @returns {string | undefined}
	 */
	
	
	function getDisplayName(Component) {
	  if (Component == null) {
	    return undefined;
	  }
	
	  if (typeof Component === 'string') {
	    return Component;
	  }
	
	  if (typeof Component === 'function') {
	    return getFunctionComponentName(Component, 'Component');
	  }
	
	  if ((0, _typeof2.default)(Component) === 'object') {
	    switch (Component.$$typeof) {
	      case _reactIs.ForwardRef:
	        return getWrappedName(Component, Component.render, 'ForwardRef');
	
	      case _reactIs.Memo:
	        return getWrappedName(Component, Component.type, 'memo');
	
	      default:
	        return undefined;
	    }
	  }
	
	  return undefined;
	}

/***/ },
/* 500 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	/* eslint-disable */
	// https://github.com/zloirock/core-js/issues/86#issuecomment-115759028
	var _default = typeof window != 'undefined' && window.Math == Math ? window : typeof self != 'undefined' && self.Math == Math ? self : Function('return this')();
	
	exports.default = _default;

/***/ },
/* 501 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(1);
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var refType = _propTypes.default.oneOfType([_propTypes.default.func, _propTypes.default.object]);
	
	var _default = refType;
	exports.default = _default;

/***/ },
/* 502 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_RESULT__;/* WEBPACK VAR INJECTION */(function(module, global) {/*! http://mths.be/base64 v0.1.0 by @mathias | MIT license */
	;(function(root) {
	
		// Detect free variables `exports`.
		var freeExports = typeof exports == 'object' && exports;
	
		// Detect free variable `module`.
		var freeModule = typeof module == 'object' && module &&
			module.exports == freeExports && module;
	
		// Detect free variable `global`, from Node.js or Browserified code, and use
		// it as `root`.
		var freeGlobal = typeof global == 'object' && global;
		if (freeGlobal.global === freeGlobal || freeGlobal.window === freeGlobal) {
			root = freeGlobal;
		}
	
		/*--------------------------------------------------------------------------*/
	
		var InvalidCharacterError = function(message) {
			this.message = message;
		};
		InvalidCharacterError.prototype = new Error;
		InvalidCharacterError.prototype.name = 'InvalidCharacterError';
	
		var error = function(message) {
			// Note: the error messages used throughout this file match those used by
			// the native `atob`/`btoa` implementation in Chromium.
			throw new InvalidCharacterError(message);
		};
	
		var TABLE = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/';
		// http://whatwg.org/html/common-microsyntaxes.html#space-character
		var REGEX_SPACE_CHARACTERS = /[\t\n\f\r ]/g;
	
		// `decode` is designed to be fully compatible with `atob` as described in the
		// HTML Standard. http://whatwg.org/html/webappapis.html#dom-windowbase64-atob
		// The optimized base64-decoding algorithm used is based on @atk’s excellent
		// implementation. https://gist.github.com/atk/1020396
		var decode = function(input) {
			input = String(input)
				.replace(REGEX_SPACE_CHARACTERS, '');
			var length = input.length;
			if (length % 4 == 0) {
				input = input.replace(/==?$/, '');
				length = input.length;
			}
			if (
				length % 4 == 1 ||
				// http://whatwg.org/C#alphanumeric-ascii-characters
				/[^+a-zA-Z0-9/]/.test(input)
			) {
				error(
					'Invalid character: the string to be decoded is not correctly encoded.'
				);
			}
			var bitCounter = 0;
			var bitStorage;
			var buffer;
			var output = '';
			var position = -1;
			while (++position < length) {
				buffer = TABLE.indexOf(input.charAt(position));
				bitStorage = bitCounter % 4 ? bitStorage * 64 + buffer : buffer;
				// Unless this is the first of a group of 4 characters…
				if (bitCounter++ % 4) {
					// …convert the first 8 bits to a single ASCII character.
					output += String.fromCharCode(
						0xFF & bitStorage >> (-2 * bitCounter & 6)
					);
				}
			}
			return output;
		};
	
		// `encode` is designed to be fully compatible with `btoa` as described in the
		// HTML Standard: http://whatwg.org/html/webappapis.html#dom-windowbase64-btoa
		var encode = function(input) {
			input = String(input);
			if (/[^\0-\xFF]/.test(input)) {
				// Note: no need to special-case astral symbols here, as surrogates are
				// matched, and the input is supposed to only contain ASCII anyway.
				error(
					'The string to be encoded contains characters outside of the ' +
					'Latin1 range.'
				);
			}
			var padding = input.length % 3;
			var output = '';
			var position = -1;
			var a;
			var b;
			var c;
			var d;
			var buffer;
			// Make sure any padding is handled outside of the loop.
			var length = input.length - padding;
	
			while (++position < length) {
				// Read three bytes, i.e. 24 bits.
				a = input.charCodeAt(position) << 16;
				b = input.charCodeAt(++position) << 8;
				c = input.charCodeAt(++position);
				buffer = a + b + c;
				// Turn the 24 bits into four chunks of 6 bits each, and append the
				// matching character for each of them to the output.
				output += (
					TABLE.charAt(buffer >> 18 & 0x3F) +
					TABLE.charAt(buffer >> 12 & 0x3F) +
					TABLE.charAt(buffer >> 6 & 0x3F) +
					TABLE.charAt(buffer & 0x3F)
				);
			}
	
			if (padding == 2) {
				a = input.charCodeAt(position) << 8;
				b = input.charCodeAt(++position);
				buffer = a + b;
				output += (
					TABLE.charAt(buffer >> 10) +
					TABLE.charAt((buffer >> 4) & 0x3F) +
					TABLE.charAt((buffer << 2) & 0x3F) +
					'='
				);
			} else if (padding == 1) {
				buffer = input.charCodeAt(position);
				output += (
					TABLE.charAt(buffer >> 2) +
					TABLE.charAt((buffer << 4) & 0x3F) +
					'=='
				);
			}
	
			return output;
		};
	
		var base64 = {
			'encode': encode,
			'decode': decode,
			'version': '0.1.0'
		};
	
		// Some AMD build optimizers, like r.js, check for specific condition patterns
		// like the following:
		if (
			true
		) {
			!(__WEBPACK_AMD_DEFINE_RESULT__ = function() {
				return base64;
			}.call(exports, __webpack_require__, exports, module), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		}	else if (freeExports && !freeExports.nodeType) {
			if (freeModule) { // in Node.js or RingoJS v0.8.0+
				freeModule.exports = base64;
			} else { // in Narwhal or RingoJS v0.7.0-
				for (var key in base64) {
					base64.hasOwnProperty(key) && (freeExports[key] = base64[key]);
				}
			}
		} else { // in Rhino or a web browser
			root.base64 = base64;
		}
	
	}(this));
	
	/* WEBPACK VAR INJECTION */}.call(exports, __webpack_require__(580)(module), (function() { return this; }())))

/***/ },
/* 503 */
/***/ function(module, exports, __webpack_require__) {

	var __WEBPACK_AMD_DEFINE_ARRAY__, __WEBPACK_AMD_DEFINE_RESULT__;/*!
	  Copyright (c) 2017 Jed Watson.
	  Licensed under the MIT License (MIT), see
	  http://jedwatson.github.io/classnames
	*/
	/* global define */
	
	(function () {
		'use strict';
	
		var hasOwn = {}.hasOwnProperty;
	
		function classNames () {
			var classes = [];
	
			for (var i = 0; i < arguments.length; i++) {
				var arg = arguments[i];
				if (!arg) continue;
	
				var argType = typeof arg;
	
				if (argType === 'string' || argType === 'number') {
					classes.push(arg);
				} else if (Array.isArray(arg) && arg.length) {
					var inner = classNames.apply(null, arg);
					if (inner) {
						classes.push(inner);
					}
				} else if (argType === 'object') {
					for (var key in arg) {
						if (hasOwn.call(arg, key) && arg[key]) {
							classes.push(key);
						}
					}
				}
			}
	
			return classes.join(' ');
		}
	
		if (typeof module !== 'undefined' && module.exports) {
			classNames.default = classNames;
			module.exports = classNames;
		} else if (true) {
			// register as 'classnames', consistent with npm package name
			!(__WEBPACK_AMD_DEFINE_ARRAY__ = [], __WEBPACK_AMD_DEFINE_RESULT__ = function () {
				return classNames;
			}.apply(exports, __WEBPACK_AMD_DEFINE_ARRAY__), __WEBPACK_AMD_DEFINE_RESULT__ !== undefined && (module.exports = __WEBPACK_AMD_DEFINE_RESULT__));
		} else {
			window.classNames = classNames;
		}
	}());


/***/ },
/* 504 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var isInBrowser = _interopDefault(__webpack_require__(178));
	var _toConsumableArray = _interopDefault(__webpack_require__(22));
	
	// Export javascript style and css style vendor prefixes.
	var js = '';
	var css = '';
	var vendor = '';
	var browser = '';
	var isTouch = isInBrowser && 'ontouchstart' in document.documentElement; // We should not do anything if required serverside.
	
	if (isInBrowser) {
	  // Order matters. We need to check Webkit the last one because
	  // other vendors use to add Webkit prefixes to some properties
	  var jsCssMap = {
	    Moz: '-moz-',
	    ms: '-ms-',
	    O: '-o-',
	    Webkit: '-webkit-'
	  };
	
	  var _document$createEleme = document.createElement('p'),
	      style = _document$createEleme.style;
	
	  var testProp = 'Transform';
	
	  for (var key in jsCssMap) {
	    if (key + testProp in style) {
	      js = key;
	      css = jsCssMap[key];
	      break;
	    }
	  } // Correctly detect the Edge browser.
	
	
	  if (js === 'Webkit' && 'msHyphens' in style) {
	    js = 'ms';
	    css = jsCssMap.ms;
	    browser = 'edge';
	  } // Correctly detect the Safari browser.
	
	
	  if (js === 'Webkit' && '-apple-trailing-word' in style) {
	    vendor = 'apple';
	  }
	}
	/**
	 * Vendor prefix string for the current browser.
	 *
	 * @type {{js: String, css: String, vendor: String, browser: String}}
	 * @api public
	 */
	
	
	var prefix = {
	  js: js,
	  css: css,
	  vendor: vendor,
	  browser: browser,
	  isTouch: isTouch
	};
	
	/**
	 * Test if a keyframe at-rule should be prefixed or not
	 *
	 * @param {String} vendor prefix string for the current browser.
	 * @return {String}
	 * @api public
	 */
	
	function supportedKeyframes(key) {
	  // Keyframes is already prefixed. e.g. key = '@-webkit-keyframes a'
	  if (key[1] === '-') return key; // No need to prefix IE/Edge. Older browsers will ignore unsupported rules.
	  // https://caniuse.com/#search=keyframes
	
	  if (prefix.js === 'ms') return key;
	  return "@" + prefix.css + "keyframes" + key.substr(10);
	}
	
	// https://caniuse.com/#search=appearance
	
	var appearence = {
	  noPrefill: ['appearance'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'appearance') return false;
	    if (prefix.js === 'ms') return "-webkit-" + prop;
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=color-adjust
	
	var colorAdjust = {
	  noPrefill: ['color-adjust'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'color-adjust') return false;
	    if (prefix.js === 'Webkit') return prefix.css + "print-" + prop;
	    return prop;
	  }
	};
	
	var regExp = /[-\s]+(.)?/g;
	/**
	 * Replaces the letter with the capital letter
	 *
	 * @param {String} match
	 * @param {String} c
	 * @return {String}
	 * @api private
	 */
	
	function toUpper(match, c) {
	  return c ? c.toUpperCase() : '';
	}
	/**
	 * Convert dash separated strings to camel-cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	
	function camelize(str) {
	  return str.replace(regExp, toUpper);
	}
	
	/**
	 * Convert dash separated strings to pascal cased.
	 *
	 * @param {String} str
	 * @return {String}
	 * @api private
	 */
	
	function pascalize(str) {
	  return camelize("-" + str);
	}
	
	// but we can use a longhand property instead.
	// https://caniuse.com/#search=mask
	
	var mask = {
	  noPrefill: ['mask'],
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^mask/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var longhand = 'mask-image';
	
	      if (camelize(longhand) in style) {
	        return prop;
	      }
	
	      if (prefix.js + pascalize(longhand) in style) {
	        return prefix.css + prop;
	      }
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=text-orientation
	
	var textOrientation = {
	  noPrefill: ['text-orientation'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'text-orientation') return false;
	
	    if (prefix.vendor === 'apple' && !prefix.isTouch) {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=transform
	
	var transform = {
	  noPrefill: ['transform'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transform') return false;
	
	    if (options.transform) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=transition
	
	var transition = {
	  noPrefill: ['transition'],
	  supportedProperty: function supportedProperty(prop, style, options) {
	    if (prop !== 'transition') return false;
	
	    if (options.transition) {
	      return prop;
	    }
	
	    return prefix.css + prop;
	  }
	};
	
	// https://caniuse.com/#search=writing-mode
	
	var writingMode = {
	  noPrefill: ['writing-mode'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'writing-mode') return false;
	
	    if (prefix.js === 'Webkit' || prefix.js === 'ms' && prefix.browser !== 'edge') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=user-select
	
	var userSelect = {
	  noPrefill: ['user-select'],
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'user-select') return false;
	
	    if (prefix.js === 'Moz' || prefix.js === 'ms' || prefix.vendor === 'apple') {
	      return prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=multicolumn
	// https://github.com/postcss/autoprefixer/issues/491
	// https://github.com/postcss/autoprefixer/issues/177
	
	var breakPropsOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^break-/.test(prop)) return false;
	
	    if (prefix.js === 'Webkit') {
	      var jsProp = "WebkitColumn" + pascalize(prop);
	      return jsProp in style ? prefix.css + "column-" + prop : false;
	    }
	
	    if (prefix.js === 'Moz') {
	      var _jsProp = "page" + pascalize(prop);
	
	      return _jsProp in style ? "page-" + prop : false;
	    }
	
	    return false;
	  }
	};
	
	// See https://github.com/postcss/autoprefixer/issues/324.
	
	var inlineLogicalOld = {
	  supportedProperty: function supportedProperty(prop, style) {
	    if (!/^(border|margin|padding)-inline/.test(prop)) return false;
	    if (prefix.js === 'Moz') return prop;
	    var newProp = prop.replace('-inline', '');
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	// Camelization is required because we can't test using.
	// CSS syntax for e.g. in FF.
	
	var unprefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    return camelize(prop) in style ? prop : false;
	  }
	};
	
	var prefixed = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var pascalized = pascalize(prop); // Return custom CSS variable without prefixing.
	
	    if (prop[0] === '-') return prop; // Return already prefixed value without prefixing.
	
	    if (prop[0] === '-' && prop[1] === '-') return prop;
	    if (prefix.js + pascalized in style) return prefix.css + prop; // Try webkit fallback.
	
	    if (prefix.js !== 'Webkit' && "Webkit" + pascalized in style) return "-webkit-" + prop;
	    return false;
	  }
	};
	
	// https://caniuse.com/#search=scroll-snap
	
	var scrollSnap = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop.substring(0, 11) !== 'scroll-snap') return false;
	
	    if (prefix.js === 'ms') {
	      return "" + prefix.css + prop;
	    }
	
	    return prop;
	  }
	};
	
	// https://caniuse.com/#search=overscroll-behavior
	
	var overscrollBehavior = {
	  supportedProperty: function supportedProperty(prop) {
	    if (prop !== 'overscroll-behavior') return false;
	
	    if (prefix.js === 'ms') {
	      return prefix.css + "scroll-chaining";
	    }
	
	    return prop;
	  }
	};
	
	var propMap = {
	  'flex-grow': 'flex-positive',
	  'flex-shrink': 'flex-negative',
	  'flex-basis': 'flex-preferred-size',
	  'justify-content': 'flex-pack',
	  order: 'flex-order',
	  'align-items': 'flex-align',
	  'align-content': 'flex-line-pack' // 'align-self' is handled by 'align-self' plugin.
	
	}; // Support old flex spec from 2012.
	
	var flex2012 = {
	  supportedProperty: function supportedProperty(prop, style) {
	    var newProp = propMap[prop];
	    if (!newProp) return false;
	    return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	  }
	};
	
	var propMap$1 = {
	  flex: 'box-flex',
	  'flex-grow': 'box-flex',
	  'flex-direction': ['box-orient', 'box-direction'],
	  order: 'box-ordinal-group',
	  'align-items': 'box-align',
	  'flex-flow': ['box-orient', 'box-direction'],
	  'justify-content': 'box-pack'
	};
	var propKeys = Object.keys(propMap$1);
	
	var prefixCss = function prefixCss(p) {
	  return prefix.css + p;
	}; // Support old flex spec from 2009.
	
	
	var flex2009 = {
	  supportedProperty: function supportedProperty(prop, style, _ref) {
	    var multiple = _ref.multiple;
	
	    if (propKeys.indexOf(prop) > -1) {
	      var newProp = propMap$1[prop];
	
	      if (!Array.isArray(newProp)) {
	        return prefix.js + pascalize(newProp) in style ? prefix.css + newProp : false;
	      }
	
	      if (!multiple) return false;
	
	      for (var i = 0; i < newProp.length; i++) {
	        if (!(prefix.js + pascalize(newProp[0]) in style)) {
	          return false;
	        }
	      }
	
	      return newProp.map(prefixCss);
	    }
	
	    return false;
	  }
	};
	
	// plugins = [
	//   ...plugins,
	//    breakPropsOld,
	//    inlineLogicalOld,
	//    unprefixed,
	//    prefixed,
	//    scrollSnap,
	//    flex2012,
	//    flex2009
	// ]
	// Plugins without 'noPrefill' value, going last.
	// 'flex-*' plugins should be at the bottom.
	// 'flex2009' going after 'flex2012'.
	// 'prefixed' going after 'unprefixed'
	
	var plugins = [appearence, colorAdjust, mask, textOrientation, transform, transition, writingMode, userSelect, breakPropsOld, inlineLogicalOld, unprefixed, prefixed, scrollSnap, overscrollBehavior, flex2012, flex2009];
	var propertyDetectors = plugins.filter(function (p) {
	  return p.supportedProperty;
	}).map(function (p) {
	  return p.supportedProperty;
	});
	var noPrefill = plugins.filter(function (p) {
	  return p.noPrefill;
	}).reduce(function (a, p) {
	  a.push.apply(a, _toConsumableArray(p.noPrefill));
	  return a;
	}, []);
	
	var el;
	var cache = {};
	
	if (isInBrowser) {
	  el = document.createElement('p'); // We test every property on vendor prefix requirement.
	  // Once tested, result is cached. It gives us up to 70% perf boost.
	  // http://jsperf.com/element-style-object-access-vs-plain-object
	  //
	  // Prefill cache with known css properties to reduce amount of
	  // properties we need to feature test at runtime.
	  // http://davidwalsh.name/vendor-prefix
	
	  var computed = window.getComputedStyle(document.documentElement, '');
	
	  for (var key$1 in computed) {
	    // eslint-disable-next-line no-restricted-globals
	    if (!isNaN(key$1)) cache[computed[key$1]] = computed[key$1];
	  } // Properties that cannot be correctly detected using the
	  // cache prefill method.
	
	
	  noPrefill.forEach(function (x) {
	    return delete cache[x];
	  });
	}
	/**
	 * Test if a property is supported, returns supported property with vendor
	 * prefix if required. Returns `false` if not supported.
	 *
	 * @param {String} prop dash separated
	 * @param {Object} [options]
	 * @return {String|Boolean}
	 * @api public
	 */
	
	
	function supportedProperty(prop, options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  // For server-side rendering.
	  if (!el) return prop; // Remove cache for benchmark tests or return property from the cache.
	
	  if (("production") !== 'benchmark' && cache[prop] != null) {
	    return cache[prop];
	  } // Check if 'transition' or 'transform' natively supported in browser.
	
	
	  if (prop === 'transition' || prop === 'transform') {
	    options[prop] = prop in el.style;
	  } // Find a plugin for current prefix property.
	
	
	  for (var i = 0; i < propertyDetectors.length; i++) {
	    cache[prop] = propertyDetectors[i](prop, el.style, options); // Break loop, if value found.
	
	    if (cache[prop]) break;
	  } // Reset styles for current property.
	  // Firefox can even throw an error for invalid properties, e.g., "0".
	
	
	  try {
	    el.style[prop] = '';
	  } catch (err) {
	    return false;
	  }
	
	  return cache[prop];
	}
	
	var cache$1 = {};
	var transitionProperties = {
	  transition: 1,
	  'transition-property': 1,
	  '-webkit-transition': 1,
	  '-webkit-transition-property': 1
	};
	var transPropsRegExp = /(^\s*[\w-]+)|, (\s*[\w-]+)(?![^()]*\))/g;
	var el$1;
	/**
	 * Returns prefixed value transition/transform if needed.
	 *
	 * @param {String} match
	 * @param {String} p1
	 * @param {String} p2
	 * @return {String}
	 * @api private
	 */
	
	function prefixTransitionCallback(match, p1, p2) {
	  if (p1 === 'var') return 'var';
	  if (p1 === 'all') return 'all';
	  if (p2 === 'all') return ', all';
	  var prefixedValue = p1 ? supportedProperty(p1) : ", " + supportedProperty(p2);
	  if (!prefixedValue) return p1 || p2;
	  return prefixedValue;
	}
	
	if (isInBrowser) el$1 = document.createElement('p');
	/**
	 * Returns prefixed value if needed. Returns `false` if value is not supported.
	 *
	 * @param {String} property
	 * @param {String} value
	 * @return {String|Boolean}
	 * @api public
	 */
	
	function supportedValue(property, value) {
	  // For server-side rendering.
	  var prefixedValue = value;
	  if (!el$1 || property === 'content') return value; // It is a string or a number as a string like '1'.
	  // We want only prefixable values here.
	  // eslint-disable-next-line no-restricted-globals
	
	  if (typeof prefixedValue !== 'string' || !isNaN(parseInt(prefixedValue, 10))) {
	    return prefixedValue;
	  } // Create cache key for current value.
	
	
	  var cacheKey = property + prefixedValue; // Remove cache for benchmark tests or return value from cache.
	
	  if (("production") !== 'benchmark' && cache$1[cacheKey] != null) {
	    return cache$1[cacheKey];
	  } // IE can even throw an error in some cases, for e.g. style.content = 'bar'.
	
	
	  try {
	    // Test value as it is.
	    el$1.style[property] = prefixedValue;
	  } catch (err) {
	    // Return false if value not supported.
	    cache$1[cacheKey] = false;
	    return false;
	  } // If 'transition' or 'transition-property' property.
	
	
	  if (transitionProperties[property]) {
	    prefixedValue = prefixedValue.replace(transPropsRegExp, prefixTransitionCallback);
	  } else if (el$1.style[property] === '') {
	    // Value with a vendor prefix.
	    prefixedValue = prefix.css + prefixedValue; // Hardcode test to convert "flex" to "-ms-flexbox" for IE10.
	
	    if (prefixedValue === '-ms-flex') el$1.style[property] = '-ms-flexbox'; // Test prefixed value.
	
	    el$1.style[property] = prefixedValue; // Return false if value not supported.
	
	    if (el$1.style[property] === '') {
	      cache$1[cacheKey] = false;
	      return false;
	    }
	  } // Reset styles for current property.
	
	
	  el$1.style[property] = ''; // Write current value to cache.
	
	  cache$1[cacheKey] = prefixedValue;
	  return cache$1[cacheKey];
	}
	
	exports.prefix = prefix;
	exports.supportedKeyframes = supportedKeyframes;
	exports.supportedProperty = supportedProperty;
	exports.supportedValue = supportedValue;


/***/ },
/* 505 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dispatch/ v1.0.6 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var noop = {value: function() {}};
	
	function dispatch() {
	  for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	    if (!(t = arguments[i] + "") || (t in _) || /[\s.]/.test(t)) throw new Error("illegal type: " + t);
	    _[t] = [];
	  }
	  return new Dispatch(_);
	}
	
	function Dispatch(_) {
	  this._ = _;
	}
	
	function parseTypenames(typenames, types) {
	  return typenames.trim().split(/^|\s+/).map(function(t) {
	    var name = "", i = t.indexOf(".");
	    if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	    if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	    return {type: t, name: name};
	  });
	}
	
	Dispatch.prototype = dispatch.prototype = {
	  constructor: Dispatch,
	  on: function(typename, callback) {
	    var _ = this._,
	        T = parseTypenames(typename + "", _),
	        t,
	        i = -1,
	        n = T.length;
	
	    // If no callback was specified, return the callback of the given type and name.
	    if (arguments.length < 2) {
	      while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	      return;
	    }
	
	    // If a type was specified, set the callback for the given type and name.
	    // Otherwise, if a null callback was specified, remove callbacks of the given name.
	    if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	    while (++i < n) {
	      if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
	      else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
	    }
	
	    return this;
	  },
	  copy: function() {
	    var copy = {}, _ = this._;
	    for (var t in _) copy[t] = _[t].slice();
	    return new Dispatch(copy);
	  },
	  call: function(type, that) {
	    if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  },
	  apply: function(type, that, args) {
	    if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	    for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	  }
	};
	
	function get(type, name) {
	  for (var i = 0, n = type.length, c; i < n; ++i) {
	    if ((c = type[i]).name === name) {
	      return c.value;
	    }
	  }
	}
	
	function set(type, name, callback) {
	  for (var i = 0, n = type.length; i < n; ++i) {
	    if (type[i].name === name) {
	      type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	      break;
	    }
	  }
	  if (callback != null) type.push({name: name, value: callback});
	  return type;
	}
	
	exports.dispatch = dispatch;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 506 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dsv/ v1.2.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var EOL = {},
	    EOF = {},
	    QUOTE = 34,
	    NEWLINE = 10,
	    RETURN = 13;
	
	function objectConverter(columns) {
	  return new Function("d", "return {" + columns.map(function(name, i) {
	    return JSON.stringify(name) + ": d[" + i + "] || \"\"";
	  }).join(",") + "}");
	}
	
	function customConverter(columns, f) {
	  var object = objectConverter(columns);
	  return function(row, i) {
	    return f(object(row), i, columns);
	  };
	}
	
	// Compute unique columns in order of discovery.
	function inferColumns(rows) {
	  var columnSet = Object.create(null),
	      columns = [];
	
	  rows.forEach(function(row) {
	    for (var column in row) {
	      if (!(column in columnSet)) {
	        columns.push(columnSet[column] = column);
	      }
	    }
	  });
	
	  return columns;
	}
	
	function pad(value, width) {
	  var s = value + "", length = s.length;
	  return length < width ? new Array(width - length + 1).join(0) + s : s;
	}
	
	function formatYear(year) {
	  return year < 0 ? "-" + pad(-year, 6)
	    : year > 9999 ? "+" + pad(year, 6)
	    : pad(year, 4);
	}
	
	function formatDate(date) {
	  var hours = date.getUTCHours(),
	      minutes = date.getUTCMinutes(),
	      seconds = date.getUTCSeconds(),
	      milliseconds = date.getUTCMilliseconds();
	  return isNaN(date) ? "Invalid Date"
	      : formatYear(date.getUTCFullYear()) + "-" + pad(date.getUTCMonth() + 1, 2) + "-" + pad(date.getUTCDate(), 2)
	      + (milliseconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "." + pad(milliseconds, 3) + "Z"
	      : seconds ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + ":" + pad(seconds, 2) + "Z"
	      : minutes || hours ? "T" + pad(hours, 2) + ":" + pad(minutes, 2) + "Z"
	      : "");
	}
	
	function dsv(delimiter) {
	  var reFormat = new RegExp("[\"" + delimiter + "\n\r]"),
	      DELIMITER = delimiter.charCodeAt(0);
	
	  function parse(text, f) {
	    var convert, columns, rows = parseRows(text, function(row, i) {
	      if (convert) return convert(row, i - 1);
	      columns = row, convert = f ? customConverter(row, f) : objectConverter(row);
	    });
	    rows.columns = columns || [];
	    return rows;
	  }
	
	  function parseRows(text, f) {
	    var rows = [], // output rows
	        N = text.length,
	        I = 0, // current character index
	        n = 0, // current line number
	        t, // current token
	        eof = N <= 0, // current token followed by EOF?
	        eol = false; // current token followed by EOL?
	
	    // Strip the trailing newline.
	    if (text.charCodeAt(N - 1) === NEWLINE) --N;
	    if (text.charCodeAt(N - 1) === RETURN) --N;
	
	    function token() {
	      if (eof) return EOF;
	      if (eol) return eol = false, EOL;
	
	      // Unescape quotes.
	      var i, j = I, c;
	      if (text.charCodeAt(j) === QUOTE) {
	        while (I++ < N && text.charCodeAt(I) !== QUOTE || text.charCodeAt(++I) === QUOTE);
	        if ((i = I) >= N) eof = true;
	        else if ((c = text.charCodeAt(I++)) === NEWLINE) eol = true;
	        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
	        return text.slice(j + 1, i - 1).replace(/""/g, "\"");
	      }
	
	      // Find next delimiter or newline.
	      while (I < N) {
	        if ((c = text.charCodeAt(i = I++)) === NEWLINE) eol = true;
	        else if (c === RETURN) { eol = true; if (text.charCodeAt(I) === NEWLINE) ++I; }
	        else if (c !== DELIMITER) continue;
	        return text.slice(j, i);
	      }
	
	      // Return last token before EOF.
	      return eof = true, text.slice(j, N);
	    }
	
	    while ((t = token()) !== EOF) {
	      var row = [];
	      while (t !== EOL && t !== EOF) row.push(t), t = token();
	      if (f && (row = f(row, n++)) == null) continue;
	      rows.push(row);
	    }
	
	    return rows;
	  }
	
	  function preformatBody(rows, columns) {
	    return rows.map(function(row) {
	      return columns.map(function(column) {
	        return formatValue(row[column]);
	      }).join(delimiter);
	    });
	  }
	
	  function format(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return [columns.map(formatValue).join(delimiter)].concat(preformatBody(rows, columns)).join("\n");
	  }
	
	  function formatBody(rows, columns) {
	    if (columns == null) columns = inferColumns(rows);
	    return preformatBody(rows, columns).join("\n");
	  }
	
	  function formatRows(rows) {
	    return rows.map(formatRow).join("\n");
	  }
	
	  function formatRow(row) {
	    return row.map(formatValue).join(delimiter);
	  }
	
	  function formatValue(value) {
	    return value == null ? ""
	        : value instanceof Date ? formatDate(value)
	        : reFormat.test(value += "") ? "\"" + value.replace(/"/g, "\"\"") + "\""
	        : value;
	  }
	
	  return {
	    parse: parse,
	    parseRows: parseRows,
	    format: format,
	    formatBody: formatBody,
	    formatRows: formatRows,
	    formatRow: formatRow,
	    formatValue: formatValue
	  };
	}
	
	var csv = dsv(",");
	
	var csvParse = csv.parse;
	var csvParseRows = csv.parseRows;
	var csvFormat = csv.format;
	var csvFormatBody = csv.formatBody;
	var csvFormatRows = csv.formatRows;
	var csvFormatRow = csv.formatRow;
	var csvFormatValue = csv.formatValue;
	
	var tsv = dsv("\t");
	
	var tsvParse = tsv.parse;
	var tsvParseRows = tsv.parseRows;
	var tsvFormat = tsv.format;
	var tsvFormatBody = tsv.formatBody;
	var tsvFormatRows = tsv.formatRows;
	var tsvFormatRow = tsv.formatRow;
	var tsvFormatValue = tsv.formatValue;
	
	function autoType(object) {
	  for (var key in object) {
	    var value = object[key].trim(), number, m;
	    if (!value) value = null;
	    else if (value === "true") value = true;
	    else if (value === "false") value = false;
	    else if (value === "NaN") value = NaN;
	    else if (!isNaN(number = +value)) value = number;
	    else if (m = value.match(/^([-+]\d{2})?\d{4}(-\d{2}(-\d{2})?)?(T\d{2}:\d{2}(:\d{2}(\.\d{3})?)?(Z|[-+]\d{2}:\d{2})?)?$/)) {
	      if (fixtz && !!m[4] && !m[7]) value = value.replace(/-/g, "/").replace(/T/, " ");
	      value = new Date(value);
	    }
	    else continue;
	    object[key] = value;
	  }
	  return object;
	}
	
	// https://github.com/d3/d3-dsv/issues/45
	var fixtz = new Date("2019-01-01T00:00").getHours() || new Date("2019-07-01T00:00").getHours();
	
	exports.autoType = autoType;
	exports.csvFormat = csvFormat;
	exports.csvFormatBody = csvFormatBody;
	exports.csvFormatRow = csvFormatRow;
	exports.csvFormatRows = csvFormatRows;
	exports.csvFormatValue = csvFormatValue;
	exports.csvParse = csvParse;
	exports.csvParseRows = csvParseRows;
	exports.dsvFormat = dsv;
	exports.tsvFormat = tsvFormat;
	exports.tsvFormatBody = tsvFormatBody;
	exports.tsvFormatRow = tsvFormatRow;
	exports.tsvFormatRows = tsvFormatRows;
	exports.tsvFormatValue = tsvFormatValue;
	exports.tsvParse = tsvParse;
	exports.tsvParseRows = tsvParseRows;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 507 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-ease/ v1.0.6 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function linear(t) {
	  return +t;
	}
	
	function quadIn(t) {
	  return t * t;
	}
	
	function quadOut(t) {
	  return t * (2 - t);
	}
	
	function quadInOut(t) {
	  return ((t *= 2) <= 1 ? t * t : --t * (2 - t) + 1) / 2;
	}
	
	function cubicIn(t) {
	  return t * t * t;
	}
	
	function cubicOut(t) {
	  return --t * t * t + 1;
	}
	
	function cubicInOut(t) {
	  return ((t *= 2) <= 1 ? t * t * t : (t -= 2) * t * t + 2) / 2;
	}
	
	var exponent = 3;
	
	var polyIn = (function custom(e) {
	  e = +e;
	
	  function polyIn(t) {
	    return Math.pow(t, e);
	  }
	
	  polyIn.exponent = custom;
	
	  return polyIn;
	})(exponent);
	
	var polyOut = (function custom(e) {
	  e = +e;
	
	  function polyOut(t) {
	    return 1 - Math.pow(1 - t, e);
	  }
	
	  polyOut.exponent = custom;
	
	  return polyOut;
	})(exponent);
	
	var polyInOut = (function custom(e) {
	  e = +e;
	
	  function polyInOut(t) {
	    return ((t *= 2) <= 1 ? Math.pow(t, e) : 2 - Math.pow(2 - t, e)) / 2;
	  }
	
	  polyInOut.exponent = custom;
	
	  return polyInOut;
	})(exponent);
	
	var pi = Math.PI,
	    halfPi = pi / 2;
	
	function sinIn(t) {
	  return 1 - Math.cos(t * halfPi);
	}
	
	function sinOut(t) {
	  return Math.sin(t * halfPi);
	}
	
	function sinInOut(t) {
	  return (1 - Math.cos(pi * t)) / 2;
	}
	
	function expIn(t) {
	  return Math.pow(2, 10 * t - 10);
	}
	
	function expOut(t) {
	  return 1 - Math.pow(2, -10 * t);
	}
	
	function expInOut(t) {
	  return ((t *= 2) <= 1 ? Math.pow(2, 10 * t - 10) : 2 - Math.pow(2, 10 - 10 * t)) / 2;
	}
	
	function circleIn(t) {
	  return 1 - Math.sqrt(1 - t * t);
	}
	
	function circleOut(t) {
	  return Math.sqrt(1 - --t * t);
	}
	
	function circleInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - Math.sqrt(1 - t * t) : Math.sqrt(1 - (t -= 2) * t) + 1) / 2;
	}
	
	var b1 = 4 / 11,
	    b2 = 6 / 11,
	    b3 = 8 / 11,
	    b4 = 3 / 4,
	    b5 = 9 / 11,
	    b6 = 10 / 11,
	    b7 = 15 / 16,
	    b8 = 21 / 22,
	    b9 = 63 / 64,
	    b0 = 1 / b1 / b1;
	
	function bounceIn(t) {
	  return 1 - bounceOut(1 - t);
	}
	
	function bounceOut(t) {
	  return (t = +t) < b1 ? b0 * t * t : t < b3 ? b0 * (t -= b2) * t + b4 : t < b6 ? b0 * (t -= b5) * t + b7 : b0 * (t -= b8) * t + b9;
	}
	
	function bounceInOut(t) {
	  return ((t *= 2) <= 1 ? 1 - bounceOut(1 - t) : bounceOut(t - 1) + 1) / 2;
	}
	
	var overshoot = 1.70158;
	
	var backIn = (function custom(s) {
	  s = +s;
	
	  function backIn(t) {
	    return t * t * ((s + 1) * t - s);
	  }
	
	  backIn.overshoot = custom;
	
	  return backIn;
	})(overshoot);
	
	var backOut = (function custom(s) {
	  s = +s;
	
	  function backOut(t) {
	    return --t * t * ((s + 1) * t + s) + 1;
	  }
	
	  backOut.overshoot = custom;
	
	  return backOut;
	})(overshoot);
	
	var backInOut = (function custom(s) {
	  s = +s;
	
	  function backInOut(t) {
	    return ((t *= 2) < 1 ? t * t * ((s + 1) * t - s) : (t -= 2) * t * ((s + 1) * t + s) + 2) / 2;
	  }
	
	  backInOut.overshoot = custom;
	
	  return backInOut;
	})(overshoot);
	
	var tau = 2 * Math.PI,
	    amplitude = 1,
	    period = 0.3;
	
	var elasticIn = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticIn(t) {
	    return a * Math.pow(2, 10 * --t) * Math.sin((s - t) / p);
	  }
	
	  elasticIn.amplitude = function(a) { return custom(a, p * tau); };
	  elasticIn.period = function(p) { return custom(a, p); };
	
	  return elasticIn;
	})(amplitude, period);
	
	var elasticOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticOut(t) {
	    return 1 - a * Math.pow(2, -10 * (t = +t)) * Math.sin((t + s) / p);
	  }
	
	  elasticOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticOut.period = function(p) { return custom(a, p); };
	
	  return elasticOut;
	})(amplitude, period);
	
	var elasticInOut = (function custom(a, p) {
	  var s = Math.asin(1 / (a = Math.max(1, a))) * (p /= tau);
	
	  function elasticInOut(t) {
	    return ((t = t * 2 - 1) < 0
	        ? a * Math.pow(2, 10 * t) * Math.sin((s - t) / p)
	        : 2 - a * Math.pow(2, -10 * t) * Math.sin((s + t) / p)) / 2;
	  }
	
	  elasticInOut.amplitude = function(a) { return custom(a, p * tau); };
	  elasticInOut.period = function(p) { return custom(a, p); };
	
	  return elasticInOut;
	})(amplitude, period);
	
	exports.easeBack = backInOut;
	exports.easeBackIn = backIn;
	exports.easeBackInOut = backInOut;
	exports.easeBackOut = backOut;
	exports.easeBounce = bounceOut;
	exports.easeBounceIn = bounceIn;
	exports.easeBounceInOut = bounceInOut;
	exports.easeBounceOut = bounceOut;
	exports.easeCircle = circleInOut;
	exports.easeCircleIn = circleIn;
	exports.easeCircleInOut = circleInOut;
	exports.easeCircleOut = circleOut;
	exports.easeCubic = cubicInOut;
	exports.easeCubicIn = cubicIn;
	exports.easeCubicInOut = cubicInOut;
	exports.easeCubicOut = cubicOut;
	exports.easeElastic = elasticOut;
	exports.easeElasticIn = elasticIn;
	exports.easeElasticInOut = elasticInOut;
	exports.easeElasticOut = elasticOut;
	exports.easeExp = expInOut;
	exports.easeExpIn = expIn;
	exports.easeExpInOut = expInOut;
	exports.easeExpOut = expOut;
	exports.easeLinear = linear;
	exports.easePoly = polyInOut;
	exports.easePolyIn = polyIn;
	exports.easePolyInOut = polyInOut;
	exports.easePolyOut = polyOut;
	exports.easeQuad = quadInOut;
	exports.easeQuadIn = quadIn;
	exports.easeQuadInOut = quadInOut;
	exports.easeQuadOut = quadOut;
	exports.easeSin = sinInOut;
	exports.easeSinIn = sinIn;
	exports.easeSinInOut = sinInOut;
	exports.easeSinOut = sinOut;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 508 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ v1.4.3 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	// Computes the decimal coefficient and exponent of the specified number x with
	// significant digits p, where x is positive and p is in [1, 21] or undefined.
	// For example, formatDecimal(1.23) returns ["123", 0].
	function formatDecimal(x, p) {
	  if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	  var i, coefficient = x.slice(0, i);
	
	  // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	  // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	  return [
	    coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	    +x.slice(i + 1)
	  ];
	}
	
	function exponent(x) {
	  return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	}
	
	function formatGroup(grouping, thousands) {
	  return function(value, width) {
	    var i = value.length,
	        t = [],
	        j = 0,
	        g = grouping[0],
	        length = 0;
	
	    while (i > 0 && g > 0) {
	      if (length + g + 1 > width) g = Math.max(1, width - length);
	      t.push(value.substring(i -= g, i + g));
	      if ((length += g + 1) > width) break;
	      g = grouping[j = (j + 1) % grouping.length];
	    }
	
	    return t.reverse().join(thousands);
	  };
	}
	
	function formatNumerals(numerals) {
	  return function(value) {
	    return value.replace(/[0-9]/g, function(i) {
	      return numerals[+i];
	    });
	  };
	}
	
	// [[fill]align][sign][symbol][0][width][,][.precision][~][type]
	var re = /^(?:(.)?([<>=^]))?([+\-( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?(~)?([a-z%])?$/i;
	
	function formatSpecifier(specifier) {
	  if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	  var match;
	  return new FormatSpecifier({
	    fill: match[1],
	    align: match[2],
	    sign: match[3],
	    symbol: match[4],
	    zero: match[5],
	    width: match[6],
	    comma: match[7],
	    precision: match[8] && match[8].slice(1),
	    trim: match[9],
	    type: match[10]
	  });
	}
	
	formatSpecifier.prototype = FormatSpecifier.prototype; // instanceof
	
	function FormatSpecifier(specifier) {
	  this.fill = specifier.fill === undefined ? " " : specifier.fill + "";
	  this.align = specifier.align === undefined ? ">" : specifier.align + "";
	  this.sign = specifier.sign === undefined ? "-" : specifier.sign + "";
	  this.symbol = specifier.symbol === undefined ? "" : specifier.symbol + "";
	  this.zero = !!specifier.zero;
	  this.width = specifier.width === undefined ? undefined : +specifier.width;
	  this.comma = !!specifier.comma;
	  this.precision = specifier.precision === undefined ? undefined : +specifier.precision;
	  this.trim = !!specifier.trim;
	  this.type = specifier.type === undefined ? "" : specifier.type + "";
	}
	
	FormatSpecifier.prototype.toString = function() {
	  return this.fill
	      + this.align
	      + this.sign
	      + this.symbol
	      + (this.zero ? "0" : "")
	      + (this.width === undefined ? "" : Math.max(1, this.width | 0))
	      + (this.comma ? "," : "")
	      + (this.precision === undefined ? "" : "." + Math.max(0, this.precision | 0))
	      + (this.trim ? "~" : "")
	      + this.type;
	};
	
	// Trims insignificant zeros, e.g., replaces 1.2000k with 1.2k.
	function formatTrim(s) {
	  out: for (var n = s.length, i = 1, i0 = -1, i1; i < n; ++i) {
	    switch (s[i]) {
	      case ".": i0 = i1 = i; break;
	      case "0": if (i0 === 0) i0 = i; i1 = i; break;
	      default: if (!+s[i]) break out; if (i0 > 0) i0 = 0; break;
	    }
	  }
	  return i0 > 0 ? s.slice(0, i0) + s.slice(i1 + 1) : s;
	}
	
	var prefixExponent;
	
	function formatPrefixAuto(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1],
	      i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	      n = coefficient.length;
	  return i === n ? coefficient
	      : i > n ? coefficient + new Array(i - n + 1).join("0")
	      : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	      : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	}
	
	function formatRounded(x, p) {
	  var d = formatDecimal(x, p);
	  if (!d) return x + "";
	  var coefficient = d[0],
	      exponent = d[1];
	  return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	      : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	      : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	}
	
	var formatTypes = {
	  "%": function(x, p) { return (x * 100).toFixed(p); },
	  "b": function(x) { return Math.round(x).toString(2); },
	  "c": function(x) { return x + ""; },
	  "d": function(x) { return Math.round(x).toString(10); },
	  "e": function(x, p) { return x.toExponential(p); },
	  "f": function(x, p) { return x.toFixed(p); },
	  "g": function(x, p) { return x.toPrecision(p); },
	  "o": function(x) { return Math.round(x).toString(8); },
	  "p": function(x, p) { return formatRounded(x * 100, p); },
	  "r": formatRounded,
	  "s": formatPrefixAuto,
	  "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	  "x": function(x) { return Math.round(x).toString(16); }
	};
	
	function identity(x) {
	  return x;
	}
	
	var map = Array.prototype.map,
	    prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	function formatLocale(locale) {
	  var group = locale.grouping === undefined || locale.thousands === undefined ? identity : formatGroup(map.call(locale.grouping, Number), locale.thousands + ""),
	      currencyPrefix = locale.currency === undefined ? "" : locale.currency[0] + "",
	      currencySuffix = locale.currency === undefined ? "" : locale.currency[1] + "",
	      decimal = locale.decimal === undefined ? "." : locale.decimal + "",
	      numerals = locale.numerals === undefined ? identity : formatNumerals(map.call(locale.numerals, String)),
	      percent = locale.percent === undefined ? "%" : locale.percent + "",
	      minus = locale.minus === undefined ? "-" : locale.minus + "",
	      nan = locale.nan === undefined ? "NaN" : locale.nan + "";
	
	  function newFormat(specifier) {
	    specifier = formatSpecifier(specifier);
	
	    var fill = specifier.fill,
	        align = specifier.align,
	        sign = specifier.sign,
	        symbol = specifier.symbol,
	        zero = specifier.zero,
	        width = specifier.width,
	        comma = specifier.comma,
	        precision = specifier.precision,
	        trim = specifier.trim,
	        type = specifier.type;
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // The "" type, and any invalid type, is an alias for ".12~g".
	    else if (!formatTypes[type]) precision === undefined && (precision = 12), trim = true, type = "g";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    // Compute the prefix and suffix.
	    // For SI-prefix, the suffix is lazily computed.
	    var prefix = symbol === "$" ? currencyPrefix : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	        suffix = symbol === "$" ? currencySuffix : /[%p]/.test(type) ? percent : "";
	
	    // What format function should we use?
	    // Is this an integer type?
	    // Can this type generate exponential notation?
	    var formatType = formatTypes[type],
	        maybeSuffix = /[defgprs%]/.test(type);
	
	    // Set the default precision if not specified,
	    // or clamp the specified precision to the supported range.
	    // For significant precision, it must be in [1, 21].
	    // For fixed precision, it must be in [0, 20].
	    precision = precision === undefined ? 6
	        : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	        : Math.max(0, Math.min(20, precision));
	
	    function format(value) {
	      var valuePrefix = prefix,
	          valueSuffix = suffix,
	          i, n, c;
	
	      if (type === "c") {
	        valueSuffix = formatType(value) + valueSuffix;
	        value = "";
	      } else {
	        value = +value;
	
	        // Perform the initial formatting.
	        var valueNegative = value < 0;
	        value = isNaN(value) ? nan : formatType(Math.abs(value), precision);
	
	        // Trim insignificant zeros.
	        if (trim) value = formatTrim(value);
	
	        // If a negative value rounds to zero during formatting, treat as positive.
	        if (valueNegative && +value === 0) valueNegative = false;
	
	        // Compute the prefix and suffix.
	        valuePrefix = (valueNegative ? (sign === "(" ? sign : minus) : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	
	        valueSuffix = (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + valueSuffix + (valueNegative && sign === "(" ? ")" : "");
	
	        // Break the formatted value into the integer “value” part that can be
	        // grouped, and fractional or exponential “suffix” part that is not.
	        if (maybeSuffix) {
	          i = -1, n = value.length;
	          while (++i < n) {
	            if (c = value.charCodeAt(i), 48 > c || c > 57) {
	              valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	              value = value.slice(0, i);
	              break;
	            }
	          }
	        }
	      }
	
	      // If the fill character is not "0", grouping is applied before padding.
	      if (comma && !zero) value = group(value, Infinity);
	
	      // Compute the padding.
	      var length = valuePrefix.length + value.length + valueSuffix.length,
	          padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	      // If the fill character is "0", grouping is applied after padding.
	      if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	      // Reconstruct the final output based on the desired alignment.
	      switch (align) {
	        case "<": value = valuePrefix + value + valueSuffix + padding; break;
	        case "=": value = valuePrefix + padding + value + valueSuffix; break;
	        case "^": value = padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length); break;
	        default: value = padding + valuePrefix + value + valueSuffix; break;
	      }
	
	      return numerals(value);
	    }
	
	    format.toString = function() {
	      return specifier + "";
	    };
	
	    return format;
	  }
	
	  function formatPrefix(specifier, value) {
	    var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	        e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	        k = Math.pow(10, -e),
	        prefix = prefixes[8 + e / 3];
	    return function(value) {
	      return f(k * value) + prefix;
	    };
	  }
	
	  return {
	    format: newFormat,
	    formatPrefix: formatPrefix
	  };
	}
	
	var locale;
	
	defaultLocale({
	  decimal: ".",
	  thousands: ",",
	  grouping: [3],
	  currency: ["$", ""],
	  minus: "-"
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.format = locale.format;
	  exports.formatPrefix = locale.formatPrefix;
	  return locale;
	}
	
	function precisionFixed(step) {
	  return Math.max(0, -exponent(Math.abs(step)));
	}
	
	function precisionPrefix(step, value) {
	  return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	}
	
	function precisionRound(step, max) {
	  step = Math.abs(step), max = Math.abs(max) - step;
	  return Math.max(0, exponent(max) - exponent(step)) + 1;
	}
	
	exports.FormatSpecifier = FormatSpecifier;
	exports.formatDefaultLocale = defaultLocale;
	exports.formatLocale = formatLocale;
	exports.formatSpecifier = formatSpecifier;
	exports.precisionFixed = precisionFixed;
	exports.precisionPrefix = precisionPrefix;
	exports.precisionRound = precisionRound;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 509 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-hierarchy/ v1.1.9 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	function defaultSeparation(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	function meanX(children) {
	  return children.reduce(meanXReduce, 0) / children.length;
	}
	
	function meanXReduce(x, c) {
	  return x + c.x;
	}
	
	function maxY(children) {
	  return 1 + children.reduce(maxYReduce, 0);
	}
	
	function maxYReduce(y, c) {
	  return Math.max(y, c.y);
	}
	
	function leafLeft(node) {
	  var children;
	  while (children = node.children) node = children[0];
	  return node;
	}
	
	function leafRight(node) {
	  var children;
	  while (children = node.children) node = children[children.length - 1];
	  return node;
	}
	
	function cluster() {
	  var separation = defaultSeparation,
	      dx = 1,
	      dy = 1,
	      nodeSize = false;
	
	  function cluster(root) {
	    var previousNode,
	        x = 0;
	
	    // First walk, computing the initial x & y values.
	    root.eachAfter(function(node) {
	      var children = node.children;
	      if (children) {
	        node.x = meanX(children);
	        node.y = maxY(children);
	      } else {
	        node.x = previousNode ? x += separation(node, previousNode) : 0;
	        node.y = 0;
	        previousNode = node;
	      }
	    });
	
	    var left = leafLeft(root),
	        right = leafRight(root),
	        x0 = left.x - separation(left, right) / 2,
	        x1 = right.x + separation(right, left) / 2;
	
	    // Second walk, normalizing x & y to the desired size.
	    return root.eachAfter(nodeSize ? function(node) {
	      node.x = (node.x - root.x) * dx;
	      node.y = (root.y - node.y) * dy;
	    } : function(node) {
	      node.x = (node.x - x0) / (x1 - x0) * dx;
	      node.y = (1 - (root.y ? node.y / root.y : 1)) * dy;
	    });
	  }
	
	  cluster.separation = function(x) {
	    return arguments.length ? (separation = x, cluster) : separation;
	  };
	
	  cluster.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? null : [dx, dy]);
	  };
	
	  cluster.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], cluster) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return cluster;
	}
	
	function count(node) {
	  var sum = 0,
	      children = node.children,
	      i = children && children.length;
	  if (!i) sum = 1;
	  else while (--i >= 0) sum += children[i].value;
	  node.value = sum;
	}
	
	function node_count() {
	  return this.eachAfter(count);
	}
	
	function node_each(callback) {
	  var node = this, current, next = [node], children, i, n;
	  do {
	    current = next.reverse(), next = [];
	    while (node = current.pop()) {
	      callback(node), children = node.children;
	      if (children) for (i = 0, n = children.length; i < n; ++i) {
	        next.push(children[i]);
	      }
	    }
	  } while (next.length);
	  return this;
	}
	
	function node_eachBefore(callback) {
	  var node = this, nodes = [node], children, i;
	  while (node = nodes.pop()) {
	    callback(node), children = node.children;
	    if (children) for (i = children.length - 1; i >= 0; --i) {
	      nodes.push(children[i]);
	    }
	  }
	  return this;
	}
	
	function node_eachAfter(callback) {
	  var node = this, nodes = [node], next = [], children, i, n;
	  while (node = nodes.pop()) {
	    next.push(node), children = node.children;
	    if (children) for (i = 0, n = children.length; i < n; ++i) {
	      nodes.push(children[i]);
	    }
	  }
	  while (node = next.pop()) {
	    callback(node);
	  }
	  return this;
	}
	
	function node_sum(value) {
	  return this.eachAfter(function(node) {
	    var sum = +value(node.data) || 0,
	        children = node.children,
	        i = children && children.length;
	    while (--i >= 0) sum += children[i].value;
	    node.value = sum;
	  });
	}
	
	function node_sort(compare) {
	  return this.eachBefore(function(node) {
	    if (node.children) {
	      node.children.sort(compare);
	    }
	  });
	}
	
	function node_path(end) {
	  var start = this,
	      ancestor = leastCommonAncestor(start, end),
	      nodes = [start];
	  while (start !== ancestor) {
	    start = start.parent;
	    nodes.push(start);
	  }
	  var k = nodes.length;
	  while (end !== ancestor) {
	    nodes.splice(k, 0, end);
	    end = end.parent;
	  }
	  return nodes;
	}
	
	function leastCommonAncestor(a, b) {
	  if (a === b) return a;
	  var aNodes = a.ancestors(),
	      bNodes = b.ancestors(),
	      c = null;
	  a = aNodes.pop();
	  b = bNodes.pop();
	  while (a === b) {
	    c = a;
	    a = aNodes.pop();
	    b = bNodes.pop();
	  }
	  return c;
	}
	
	function node_ancestors() {
	  var node = this, nodes = [node];
	  while (node = node.parent) {
	    nodes.push(node);
	  }
	  return nodes;
	}
	
	function node_descendants() {
	  var nodes = [];
	  this.each(function(node) {
	    nodes.push(node);
	  });
	  return nodes;
	}
	
	function node_leaves() {
	  var leaves = [];
	  this.eachBefore(function(node) {
	    if (!node.children) {
	      leaves.push(node);
	    }
	  });
	  return leaves;
	}
	
	function node_links() {
	  var root = this, links = [];
	  root.each(function(node) {
	    if (node !== root) { // Don’t include the root’s parent, if any.
	      links.push({source: node.parent, target: node});
	    }
	  });
	  return links;
	}
	
	function hierarchy(data, children) {
	  var root = new Node(data),
	      valued = +data.value && (root.value = data.value),
	      node,
	      nodes = [root],
	      child,
	      childs,
	      i,
	      n;
	
	  if (children == null) children = defaultChildren;
	
	  while (node = nodes.pop()) {
	    if (valued) node.value = +node.data.value;
	    if ((childs = children(node.data)) && (n = childs.length)) {
	      node.children = new Array(n);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new Node(childs[i]));
	        child.parent = node;
	        child.depth = node.depth + 1;
	      }
	    }
	  }
	
	  return root.eachBefore(computeHeight);
	}
	
	function node_copy() {
	  return hierarchy(this).eachBefore(copyData);
	}
	
	function defaultChildren(d) {
	  return d.children;
	}
	
	function copyData(node) {
	  node.data = node.data.data;
	}
	
	function computeHeight(node) {
	  var height = 0;
	  do node.height = height;
	  while ((node = node.parent) && (node.height < ++height));
	}
	
	function Node(data) {
	  this.data = data;
	  this.depth =
	  this.height = 0;
	  this.parent = null;
	}
	
	Node.prototype = hierarchy.prototype = {
	  constructor: Node,
	  count: node_count,
	  each: node_each,
	  eachAfter: node_eachAfter,
	  eachBefore: node_eachBefore,
	  sum: node_sum,
	  sort: node_sort,
	  path: node_path,
	  ancestors: node_ancestors,
	  descendants: node_descendants,
	  leaves: node_leaves,
	  links: node_links,
	  copy: node_copy
	};
	
	var slice = Array.prototype.slice;
	
	function shuffle(array) {
	  var m = array.length,
	      t,
	      i;
	
	  while (m) {
	    i = Math.random() * m-- | 0;
	    t = array[m];
	    array[m] = array[i];
	    array[i] = t;
	  }
	
	  return array;
	}
	
	function enclose(circles) {
	  var i = 0, n = (circles = shuffle(slice.call(circles))).length, B = [], p, e;
	
	  while (i < n) {
	    p = circles[i];
	    if (e && enclosesWeak(e, p)) ++i;
	    else e = encloseBasis(B = extendBasis(B, p)), i = 0;
	  }
	
	  return e;
	}
	
	function extendBasis(B, p) {
	  var i, j;
	
	  if (enclosesWeakAll(p, B)) return [p];
	
	  // If we get here then B must have at least one element.
	  for (i = 0; i < B.length; ++i) {
	    if (enclosesNot(p, B[i])
	        && enclosesWeakAll(encloseBasis2(B[i], p), B)) {
	      return [B[i], p];
	    }
	  }
	
	  // If we get here then B must have at least two elements.
	  for (i = 0; i < B.length - 1; ++i) {
	    for (j = i + 1; j < B.length; ++j) {
	      if (enclosesNot(encloseBasis2(B[i], B[j]), p)
	          && enclosesNot(encloseBasis2(B[i], p), B[j])
	          && enclosesNot(encloseBasis2(B[j], p), B[i])
	          && enclosesWeakAll(encloseBasis3(B[i], B[j], p), B)) {
	        return [B[i], B[j], p];
	      }
	    }
	  }
	
	  // If we get here then something is very wrong.
	  throw new Error;
	}
	
	function enclosesNot(a, b) {
	  var dr = a.r - b.r, dx = b.x - a.x, dy = b.y - a.y;
	  return dr < 0 || dr * dr < dx * dx + dy * dy;
	}
	
	function enclosesWeak(a, b) {
	  var dr = a.r - b.r + 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function enclosesWeakAll(a, B) {
	  for (var i = 0; i < B.length; ++i) {
	    if (!enclosesWeak(a, B[i])) {
	      return false;
	    }
	  }
	  return true;
	}
	
	function encloseBasis(B) {
	  switch (B.length) {
	    case 1: return encloseBasis1(B[0]);
	    case 2: return encloseBasis2(B[0], B[1]);
	    case 3: return encloseBasis3(B[0], B[1], B[2]);
	  }
	}
	
	function encloseBasis1(a) {
	  return {
	    x: a.x,
	    y: a.y,
	    r: a.r
	  };
	}
	
	function encloseBasis2(a, b) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x21 = x2 - x1, y21 = y2 - y1, r21 = r2 - r1,
	      l = Math.sqrt(x21 * x21 + y21 * y21);
	  return {
	    x: (x1 + x2 + x21 / l * r21) / 2,
	    y: (y1 + y2 + y21 / l * r21) / 2,
	    r: (l + r1 + r2) / 2
	  };
	}
	
	function encloseBasis3(a, b, c) {
	  var x1 = a.x, y1 = a.y, r1 = a.r,
	      x2 = b.x, y2 = b.y, r2 = b.r,
	      x3 = c.x, y3 = c.y, r3 = c.r,
	      a2 = x1 - x2,
	      a3 = x1 - x3,
	      b2 = y1 - y2,
	      b3 = y1 - y3,
	      c2 = r2 - r1,
	      c3 = r3 - r1,
	      d1 = x1 * x1 + y1 * y1 - r1 * r1,
	      d2 = d1 - x2 * x2 - y2 * y2 + r2 * r2,
	      d3 = d1 - x3 * x3 - y3 * y3 + r3 * r3,
	      ab = a3 * b2 - a2 * b3,
	      xa = (b2 * d3 - b3 * d2) / (ab * 2) - x1,
	      xb = (b3 * c2 - b2 * c3) / ab,
	      ya = (a3 * d2 - a2 * d3) / (ab * 2) - y1,
	      yb = (a2 * c3 - a3 * c2) / ab,
	      A = xb * xb + yb * yb - 1,
	      B = 2 * (r1 + xa * xb + ya * yb),
	      C = xa * xa + ya * ya - r1 * r1,
	      r = -(A ? (B + Math.sqrt(B * B - 4 * A * C)) / (2 * A) : C / B);
	  return {
	    x: x1 + xa + xb * r,
	    y: y1 + ya + yb * r,
	    r: r
	  };
	}
	
	function place(b, a, c) {
	  var dx = b.x - a.x, x, a2,
	      dy = b.y - a.y, y, b2,
	      d2 = dx * dx + dy * dy;
	  if (d2) {
	    a2 = a.r + c.r, a2 *= a2;
	    b2 = b.r + c.r, b2 *= b2;
	    if (a2 > b2) {
	      x = (d2 + b2 - a2) / (2 * d2);
	      y = Math.sqrt(Math.max(0, b2 / d2 - x * x));
	      c.x = b.x - x * dx - y * dy;
	      c.y = b.y - x * dy + y * dx;
	    } else {
	      x = (d2 + a2 - b2) / (2 * d2);
	      y = Math.sqrt(Math.max(0, a2 / d2 - x * x));
	      c.x = a.x + x * dx - y * dy;
	      c.y = a.y + x * dy + y * dx;
	    }
	  } else {
	    c.x = a.x + c.r;
	    c.y = a.y;
	  }
	}
	
	function intersects(a, b) {
	  var dr = a.r + b.r - 1e-6, dx = b.x - a.x, dy = b.y - a.y;
	  return dr > 0 && dr * dr > dx * dx + dy * dy;
	}
	
	function score(node) {
	  var a = node._,
	      b = node.next._,
	      ab = a.r + b.r,
	      dx = (a.x * b.r + b.x * a.r) / ab,
	      dy = (a.y * b.r + b.y * a.r) / ab;
	  return dx * dx + dy * dy;
	}
	
	function Node$1(circle) {
	  this._ = circle;
	  this.next = null;
	  this.previous = null;
	}
	
	function packEnclose(circles) {
	  if (!(n = circles.length)) return 0;
	
	  var a, b, c, n, aa, ca, i, j, k, sj, sk;
	
	  // Place the first circle.
	  a = circles[0], a.x = 0, a.y = 0;
	  if (!(n > 1)) return a.r;
	
	  // Place the second circle.
	  b = circles[1], a.x = -b.r, b.x = a.r, b.y = 0;
	  if (!(n > 2)) return a.r + b.r;
	
	  // Place the third circle.
	  place(b, a, c = circles[2]);
	
	  // Initialize the front-chain using the first three circles a, b and c.
	  a = new Node$1(a), b = new Node$1(b), c = new Node$1(c);
	  a.next = c.previous = b;
	  b.next = a.previous = c;
	  c.next = b.previous = a;
	
	  // Attempt to place each remaining circle…
	  pack: for (i = 3; i < n; ++i) {
	    place(a._, b._, c = circles[i]), c = new Node$1(c);
	
	    // Find the closest intersecting circle on the front-chain, if any.
	    // “Closeness” is determined by linear distance along the front-chain.
	    // “Ahead” or “behind” is likewise determined by linear distance.
	    j = b.next, k = a.previous, sj = b._.r, sk = a._.r;
	    do {
	      if (sj <= sk) {
	        if (intersects(j._, c._)) {
	          b = j, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sj += j._.r, j = j.next;
	      } else {
	        if (intersects(k._, c._)) {
	          a = k, a.next = b, b.previous = a, --i;
	          continue pack;
	        }
	        sk += k._.r, k = k.previous;
	      }
	    } while (j !== k.next);
	
	    // Success! Insert the new circle c between a and b.
	    c.previous = a, c.next = b, a.next = b.previous = b = c;
	
	    // Compute the new closest circle pair to the centroid.
	    aa = score(a);
	    while ((c = c.next) !== b) {
	      if ((ca = score(c)) < aa) {
	        a = c, aa = ca;
	      }
	    }
	    b = a.next;
	  }
	
	  // Compute the enclosing circle of the front chain.
	  a = [b._], c = b; while ((c = c.next) !== b) a.push(c._); c = enclose(a);
	
	  // Translate the circles to put the enclosing circle around the origin.
	  for (i = 0; i < n; ++i) a = circles[i], a.x -= c.x, a.y -= c.y;
	
	  return c.r;
	}
	
	function siblings(circles) {
	  packEnclose(circles);
	  return circles;
	}
	
	function optional(f) {
	  return f == null ? null : required(f);
	}
	
	function required(f) {
	  if (typeof f !== "function") throw new Error;
	  return f;
	}
	
	function constantZero() {
	  return 0;
	}
	
	function constant(x) {
	  return function() {
	    return x;
	  };
	}
	
	function defaultRadius(d) {
	  return Math.sqrt(d.value);
	}
	
	function index() {
	  var radius = null,
	      dx = 1,
	      dy = 1,
	      padding = constantZero;
	
	  function pack(root) {
	    root.x = dx / 2, root.y = dy / 2;
	    if (radius) {
	      root.eachBefore(radiusLeaf(radius))
	          .eachAfter(packChildren(padding, 0.5))
	          .eachBefore(translateChild(1));
	    } else {
	      root.eachBefore(radiusLeaf(defaultRadius))
	          .eachAfter(packChildren(constantZero, 1))
	          .eachAfter(packChildren(padding, root.r / Math.min(dx, dy)))
	          .eachBefore(translateChild(Math.min(dx, dy) / (2 * root.r)));
	    }
	    return root;
	  }
	
	  pack.radius = function(x) {
	    return arguments.length ? (radius = optional(x), pack) : radius;
	  };
	
	  pack.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], pack) : [dx, dy];
	  };
	
	  pack.padding = function(x) {
	    return arguments.length ? (padding = typeof x === "function" ? x : constant(+x), pack) : padding;
	  };
	
	  return pack;
	}
	
	function radiusLeaf(radius) {
	  return function(node) {
	    if (!node.children) {
	      node.r = Math.max(0, +radius(node) || 0);
	    }
	  };
	}
	
	function packChildren(padding, k) {
	  return function(node) {
	    if (children = node.children) {
	      var children,
	          i,
	          n = children.length,
	          r = padding(node) * k || 0,
	          e;
	
	      if (r) for (i = 0; i < n; ++i) children[i].r += r;
	      e = packEnclose(children);
	      if (r) for (i = 0; i < n; ++i) children[i].r -= r;
	      node.r = e + r;
	    }
	  };
	}
	
	function translateChild(k) {
	  return function(node) {
	    var parent = node.parent;
	    node.r *= k;
	    if (parent) {
	      node.x = parent.x + k * node.x;
	      node.y = parent.y + k * node.y;
	    }
	  };
	}
	
	function roundNode(node) {
	  node.x0 = Math.round(node.x0);
	  node.y0 = Math.round(node.y0);
	  node.x1 = Math.round(node.x1);
	  node.y1 = Math.round(node.y1);
	}
	
	function treemapDice(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (x1 - x0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.y0 = y0, node.y1 = y1;
	    node.x0 = x0, node.x1 = x0 += node.value * k;
	  }
	}
	
	function partition() {
	  var dx = 1,
	      dy = 1,
	      padding = 0,
	      round = false;
	
	  function partition(root) {
	    var n = root.height + 1;
	    root.x0 =
	    root.y0 = padding;
	    root.x1 = dx;
	    root.y1 = dy / n;
	    root.eachBefore(positionNode(dy, n));
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(dy, n) {
	    return function(node) {
	      if (node.children) {
	        treemapDice(node, node.x0, dy * (node.depth + 1) / n, node.x1, dy * (node.depth + 2) / n);
	      }
	      var x0 = node.x0,
	          y0 = node.y0,
	          x1 = node.x1 - padding,
	          y1 = node.y1 - padding;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      node.x0 = x0;
	      node.y0 = y0;
	      node.x1 = x1;
	      node.y1 = y1;
	    };
	  }
	
	  partition.round = function(x) {
	    return arguments.length ? (round = !!x, partition) : round;
	  };
	
	  partition.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], partition) : [dx, dy];
	  };
	
	  partition.padding = function(x) {
	    return arguments.length ? (padding = +x, partition) : padding;
	  };
	
	  return partition;
	}
	
	var keyPrefix = "$", // Protect against keys like “__proto__”.
	    preroot = {depth: -1},
	    ambiguous = {};
	
	function defaultId(d) {
	  return d.id;
	}
	
	function defaultParentId(d) {
	  return d.parentId;
	}
	
	function stratify() {
	  var id = defaultId,
	      parentId = defaultParentId;
	
	  function stratify(data) {
	    var d,
	        i,
	        n = data.length,
	        root,
	        parent,
	        node,
	        nodes = new Array(n),
	        nodeId,
	        nodeKey,
	        nodeByKey = {};
	
	    for (i = 0; i < n; ++i) {
	      d = data[i], node = nodes[i] = new Node(d);
	      if ((nodeId = id(d, i, data)) != null && (nodeId += "")) {
	        nodeKey = keyPrefix + (node.id = nodeId);
	        nodeByKey[nodeKey] = nodeKey in nodeByKey ? ambiguous : node;
	      }
	    }
	
	    for (i = 0; i < n; ++i) {
	      node = nodes[i], nodeId = parentId(data[i], i, data);
	      if (nodeId == null || !(nodeId += "")) {
	        if (root) throw new Error("multiple roots");
	        root = node;
	      } else {
	        parent = nodeByKey[keyPrefix + nodeId];
	        if (!parent) throw new Error("missing: " + nodeId);
	        if (parent === ambiguous) throw new Error("ambiguous: " + nodeId);
	        if (parent.children) parent.children.push(node);
	        else parent.children = [node];
	        node.parent = parent;
	      }
	    }
	
	    if (!root) throw new Error("no root");
	    root.parent = preroot;
	    root.eachBefore(function(node) { node.depth = node.parent.depth + 1; --n; }).eachBefore(computeHeight);
	    root.parent = null;
	    if (n > 0) throw new Error("cycle");
	
	    return root;
	  }
	
	  stratify.id = function(x) {
	    return arguments.length ? (id = required(x), stratify) : id;
	  };
	
	  stratify.parentId = function(x) {
	    return arguments.length ? (parentId = required(x), stratify) : parentId;
	  };
	
	  return stratify;
	}
	
	function defaultSeparation$1(a, b) {
	  return a.parent === b.parent ? 1 : 2;
	}
	
	// function radialSeparation(a, b) {
	//   return (a.parent === b.parent ? 1 : 2) / a.depth;
	// }
	
	// This function is used to traverse the left contour of a subtree (or
	// subforest). It returns the successor of v on this contour. This successor is
	// either given by the leftmost child of v or by the thread of v. The function
	// returns null if and only if v is on the highest level of its subtree.
	function nextLeft(v) {
	  var children = v.children;
	  return children ? children[0] : v.t;
	}
	
	// This function works analogously to nextLeft.
	function nextRight(v) {
	  var children = v.children;
	  return children ? children[children.length - 1] : v.t;
	}
	
	// Shifts the current subtree rooted at w+. This is done by increasing
	// prelim(w+) and mod(w+) by shift.
	function moveSubtree(wm, wp, shift) {
	  var change = shift / (wp.i - wm.i);
	  wp.c -= change;
	  wp.s += shift;
	  wm.c += change;
	  wp.z += shift;
	  wp.m += shift;
	}
	
	// All other shifts, applied to the smaller subtrees between w- and w+, are
	// performed by this function. To prepare the shifts, we have to adjust
	// change(w+), shift(w+), and change(w-).
	function executeShifts(v) {
	  var shift = 0,
	      change = 0,
	      children = v.children,
	      i = children.length,
	      w;
	  while (--i >= 0) {
	    w = children[i];
	    w.z += shift;
	    w.m += shift;
	    shift += w.s + (change += w.c);
	  }
	}
	
	// If vi-’s ancestor is a sibling of v, returns vi-’s ancestor. Otherwise,
	// returns the specified (default) ancestor.
	function nextAncestor(vim, v, ancestor) {
	  return vim.a.parent === v.parent ? vim.a : ancestor;
	}
	
	function TreeNode(node, i) {
	  this._ = node;
	  this.parent = null;
	  this.children = null;
	  this.A = null; // default ancestor
	  this.a = this; // ancestor
	  this.z = 0; // prelim
	  this.m = 0; // mod
	  this.c = 0; // change
	  this.s = 0; // shift
	  this.t = null; // thread
	  this.i = i; // number
	}
	
	TreeNode.prototype = Object.create(Node.prototype);
	
	function treeRoot(root) {
	  var tree = new TreeNode(root, 0),
	      node,
	      nodes = [tree],
	      child,
	      children,
	      i,
	      n;
	
	  while (node = nodes.pop()) {
	    if (children = node._.children) {
	      node.children = new Array(n = children.length);
	      for (i = n - 1; i >= 0; --i) {
	        nodes.push(child = node.children[i] = new TreeNode(children[i], i));
	        child.parent = node;
	      }
	    }
	  }
	
	  (tree.parent = new TreeNode(null, 0)).children = [tree];
	  return tree;
	}
	
	// Node-link tree diagram using the Reingold-Tilford "tidy" algorithm
	function tree() {
	  var separation = defaultSeparation$1,
	      dx = 1,
	      dy = 1,
	      nodeSize = null;
	
	  function tree(root) {
	    var t = treeRoot(root);
	
	    // Compute the layout using Buchheim et al.’s algorithm.
	    t.eachAfter(firstWalk), t.parent.m = -t.z;
	    t.eachBefore(secondWalk);
	
	    // If a fixed node size is specified, scale x and y.
	    if (nodeSize) root.eachBefore(sizeNode);
	
	    // If a fixed tree size is specified, scale x and y based on the extent.
	    // Compute the left-most, right-most, and depth-most nodes for extents.
	    else {
	      var left = root,
	          right = root,
	          bottom = root;
	      root.eachBefore(function(node) {
	        if (node.x < left.x) left = node;
	        if (node.x > right.x) right = node;
	        if (node.depth > bottom.depth) bottom = node;
	      });
	      var s = left === right ? 1 : separation(left, right) / 2,
	          tx = s - left.x,
	          kx = dx / (right.x + s + tx),
	          ky = dy / (bottom.depth || 1);
	      root.eachBefore(function(node) {
	        node.x = (node.x + tx) * kx;
	        node.y = node.depth * ky;
	      });
	    }
	
	    return root;
	  }
	
	  // Computes a preliminary x-coordinate for v. Before that, FIRST WALK is
	  // applied recursively to the children of v, as well as the function
	  // APPORTION. After spacing out the children by calling EXECUTE SHIFTS, the
	  // node v is placed to the midpoint of its outermost children.
	  function firstWalk(v) {
	    var children = v.children,
	        siblings = v.parent.children,
	        w = v.i ? siblings[v.i - 1] : null;
	    if (children) {
	      executeShifts(v);
	      var midpoint = (children[0].z + children[children.length - 1].z) / 2;
	      if (w) {
	        v.z = w.z + separation(v._, w._);
	        v.m = v.z - midpoint;
	      } else {
	        v.z = midpoint;
	      }
	    } else if (w) {
	      v.z = w.z + separation(v._, w._);
	    }
	    v.parent.A = apportion(v, w, v.parent.A || siblings[0]);
	  }
	
	  // Computes all real x-coordinates by summing up the modifiers recursively.
	  function secondWalk(v) {
	    v._.x = v.z + v.parent.m;
	    v.m += v.parent.m;
	  }
	
	  // The core of the algorithm. Here, a new subtree is combined with the
	  // previous subtrees. Threads are used to traverse the inside and outside
	  // contours of the left and right subtree up to the highest common level. The
	  // vertices used for the traversals are vi+, vi-, vo-, and vo+, where the
	  // superscript o means outside and i means inside, the subscript - means left
	  // subtree and + means right subtree. For summing up the modifiers along the
	  // contour, we use respective variables si+, si-, so-, and so+. Whenever two
	  // nodes of the inside contours conflict, we compute the left one of the
	  // greatest uncommon ancestors using the function ANCESTOR and call MOVE
	  // SUBTREE to shift the subtree and prepare the shifts of smaller subtrees.
	  // Finally, we add a new thread (if necessary).
	  function apportion(v, w, ancestor) {
	    if (w) {
	      var vip = v,
	          vop = v,
	          vim = w,
	          vom = vip.parent.children[0],
	          sip = vip.m,
	          sop = vop.m,
	          sim = vim.m,
	          som = vom.m,
	          shift;
	      while (vim = nextRight(vim), vip = nextLeft(vip), vim && vip) {
	        vom = nextLeft(vom);
	        vop = nextRight(vop);
	        vop.a = v;
	        shift = vim.z + sim - vip.z - sip + separation(vim._, vip._);
	        if (shift > 0) {
	          moveSubtree(nextAncestor(vim, v, ancestor), v, shift);
	          sip += shift;
	          sop += shift;
	        }
	        sim += vim.m;
	        sip += vip.m;
	        som += vom.m;
	        sop += vop.m;
	      }
	      if (vim && !nextRight(vop)) {
	        vop.t = vim;
	        vop.m += sim - sop;
	      }
	      if (vip && !nextLeft(vom)) {
	        vom.t = vip;
	        vom.m += sip - som;
	        ancestor = v;
	      }
	    }
	    return ancestor;
	  }
	
	  function sizeNode(node) {
	    node.x *= dx;
	    node.y = node.depth * dy;
	  }
	
	  tree.separation = function(x) {
	    return arguments.length ? (separation = x, tree) : separation;
	  };
	
	  tree.size = function(x) {
	    return arguments.length ? (nodeSize = false, dx = +x[0], dy = +x[1], tree) : (nodeSize ? null : [dx, dy]);
	  };
	
	  tree.nodeSize = function(x) {
	    return arguments.length ? (nodeSize = true, dx = +x[0], dy = +x[1], tree) : (nodeSize ? [dx, dy] : null);
	  };
	
	  return tree;
	}
	
	function treemapSlice(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      node,
	      i = -1,
	      n = nodes.length,
	      k = parent.value && (y1 - y0) / parent.value;
	
	  while (++i < n) {
	    node = nodes[i], node.x0 = x0, node.x1 = x1;
	    node.y0 = y0, node.y1 = y0 += node.value * k;
	  }
	}
	
	var phi = (1 + Math.sqrt(5)) / 2;
	
	function squarifyRatio(ratio, parent, x0, y0, x1, y1) {
	  var rows = [],
	      nodes = parent.children,
	      row,
	      nodeValue,
	      i0 = 0,
	      i1 = 0,
	      n = nodes.length,
	      dx, dy,
	      value = parent.value,
	      sumValue,
	      minValue,
	      maxValue,
	      newRatio,
	      minRatio,
	      alpha,
	      beta;
	
	  while (i0 < n) {
	    dx = x1 - x0, dy = y1 - y0;
	
	    // Find the next non-empty node.
	    do sumValue = nodes[i1++].value; while (!sumValue && i1 < n);
	    minValue = maxValue = sumValue;
	    alpha = Math.max(dy / dx, dx / dy) / (value * ratio);
	    beta = sumValue * sumValue * alpha;
	    minRatio = Math.max(maxValue / beta, beta / minValue);
	
	    // Keep adding nodes while the aspect ratio maintains or improves.
	    for (; i1 < n; ++i1) {
	      sumValue += nodeValue = nodes[i1].value;
	      if (nodeValue < minValue) minValue = nodeValue;
	      if (nodeValue > maxValue) maxValue = nodeValue;
	      beta = sumValue * sumValue * alpha;
	      newRatio = Math.max(maxValue / beta, beta / minValue);
	      if (newRatio > minRatio) { sumValue -= nodeValue; break; }
	      minRatio = newRatio;
	    }
	
	    // Position and record the row orientation.
	    rows.push(row = {value: sumValue, dice: dx < dy, children: nodes.slice(i0, i1)});
	    if (row.dice) treemapDice(row, x0, y0, x1, value ? y0 += dy * sumValue / value : y1);
	    else treemapSlice(row, x0, y0, value ? x0 += dx * sumValue / value : x1, y1);
	    value -= sumValue, i0 = i1;
	  }
	
	  return rows;
	}
	
	var squarify = (function custom(ratio) {
	
	  function squarify(parent, x0, y0, x1, y1) {
	    squarifyRatio(ratio, parent, x0, y0, x1, y1);
	  }
	
	  squarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return squarify;
	})(phi);
	
	function index$1() {
	  var tile = squarify,
	      round = false,
	      dx = 1,
	      dy = 1,
	      paddingStack = [0],
	      paddingInner = constantZero,
	      paddingTop = constantZero,
	      paddingRight = constantZero,
	      paddingBottom = constantZero,
	      paddingLeft = constantZero;
	
	  function treemap(root) {
	    root.x0 =
	    root.y0 = 0;
	    root.x1 = dx;
	    root.y1 = dy;
	    root.eachBefore(positionNode);
	    paddingStack = [0];
	    if (round) root.eachBefore(roundNode);
	    return root;
	  }
	
	  function positionNode(node) {
	    var p = paddingStack[node.depth],
	        x0 = node.x0 + p,
	        y0 = node.y0 + p,
	        x1 = node.x1 - p,
	        y1 = node.y1 - p;
	    if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	    if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	    node.x0 = x0;
	    node.y0 = y0;
	    node.x1 = x1;
	    node.y1 = y1;
	    if (node.children) {
	      p = paddingStack[node.depth + 1] = paddingInner(node) / 2;
	      x0 += paddingLeft(node) - p;
	      y0 += paddingTop(node) - p;
	      x1 -= paddingRight(node) - p;
	      y1 -= paddingBottom(node) - p;
	      if (x1 < x0) x0 = x1 = (x0 + x1) / 2;
	      if (y1 < y0) y0 = y1 = (y0 + y1) / 2;
	      tile(node, x0, y0, x1, y1);
	    }
	  }
	
	  treemap.round = function(x) {
	    return arguments.length ? (round = !!x, treemap) : round;
	  };
	
	  treemap.size = function(x) {
	    return arguments.length ? (dx = +x[0], dy = +x[1], treemap) : [dx, dy];
	  };
	
	  treemap.tile = function(x) {
	    return arguments.length ? (tile = required(x), treemap) : tile;
	  };
	
	  treemap.padding = function(x) {
	    return arguments.length ? treemap.paddingInner(x).paddingOuter(x) : treemap.paddingInner();
	  };
	
	  treemap.paddingInner = function(x) {
	    return arguments.length ? (paddingInner = typeof x === "function" ? x : constant(+x), treemap) : paddingInner;
	  };
	
	  treemap.paddingOuter = function(x) {
	    return arguments.length ? treemap.paddingTop(x).paddingRight(x).paddingBottom(x).paddingLeft(x) : treemap.paddingTop();
	  };
	
	  treemap.paddingTop = function(x) {
	    return arguments.length ? (paddingTop = typeof x === "function" ? x : constant(+x), treemap) : paddingTop;
	  };
	
	  treemap.paddingRight = function(x) {
	    return arguments.length ? (paddingRight = typeof x === "function" ? x : constant(+x), treemap) : paddingRight;
	  };
	
	  treemap.paddingBottom = function(x) {
	    return arguments.length ? (paddingBottom = typeof x === "function" ? x : constant(+x), treemap) : paddingBottom;
	  };
	
	  treemap.paddingLeft = function(x) {
	    return arguments.length ? (paddingLeft = typeof x === "function" ? x : constant(+x), treemap) : paddingLeft;
	  };
	
	  return treemap;
	}
	
	function binary(parent, x0, y0, x1, y1) {
	  var nodes = parent.children,
	      i, n = nodes.length,
	      sum, sums = new Array(n + 1);
	
	  for (sums[0] = sum = i = 0; i < n; ++i) {
	    sums[i + 1] = sum += nodes[i].value;
	  }
	
	  partition(0, n, parent.value, x0, y0, x1, y1);
	
	  function partition(i, j, value, x0, y0, x1, y1) {
	    if (i >= j - 1) {
	      var node = nodes[i];
	      node.x0 = x0, node.y0 = y0;
	      node.x1 = x1, node.y1 = y1;
	      return;
	    }
	
	    var valueOffset = sums[i],
	        valueTarget = (value / 2) + valueOffset,
	        k = i + 1,
	        hi = j - 1;
	
	    while (k < hi) {
	      var mid = k + hi >>> 1;
	      if (sums[mid] < valueTarget) k = mid + 1;
	      else hi = mid;
	    }
	
	    if ((valueTarget - sums[k - 1]) < (sums[k] - valueTarget) && i + 1 < k) --k;
	
	    var valueLeft = sums[k] - valueOffset,
	        valueRight = value - valueLeft;
	
	    if ((x1 - x0) > (y1 - y0)) {
	      var xk = (x0 * valueRight + x1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, xk, y1);
	      partition(k, j, valueRight, xk, y0, x1, y1);
	    } else {
	      var yk = (y0 * valueRight + y1 * valueLeft) / value;
	      partition(i, k, valueLeft, x0, y0, x1, yk);
	      partition(k, j, valueRight, x0, yk, x1, y1);
	    }
	  }
	}
	
	function sliceDice(parent, x0, y0, x1, y1) {
	  (parent.depth & 1 ? treemapSlice : treemapDice)(parent, x0, y0, x1, y1);
	}
	
	var resquarify = (function custom(ratio) {
	
	  function resquarify(parent, x0, y0, x1, y1) {
	    if ((rows = parent._squarify) && (rows.ratio === ratio)) {
	      var rows,
	          row,
	          nodes,
	          i,
	          j = -1,
	          n,
	          m = rows.length,
	          value = parent.value;
	
	      while (++j < m) {
	        row = rows[j], nodes = row.children;
	        for (i = row.value = 0, n = nodes.length; i < n; ++i) row.value += nodes[i].value;
	        if (row.dice) treemapDice(row, x0, y0, x1, y0 += (y1 - y0) * row.value / value);
	        else treemapSlice(row, x0, y0, x0 += (x1 - x0) * row.value / value, y1);
	        value -= row.value;
	      }
	    } else {
	      parent._squarify = rows = squarifyRatio(ratio, parent, x0, y0, x1, y1);
	      rows.ratio = ratio;
	    }
	  }
	
	  resquarify.ratio = function(x) {
	    return custom((x = +x) > 1 ? x : 1);
	  };
	
	  return resquarify;
	})(phi);
	
	exports.cluster = cluster;
	exports.hierarchy = hierarchy;
	exports.pack = index;
	exports.packEnclose = enclose;
	exports.packSiblings = siblings;
	exports.partition = partition;
	exports.stratify = stratify;
	exports.tree = tree;
	exports.treemap = index$1;
	exports.treemapBinary = binary;
	exports.treemapDice = treemapDice;
	exports.treemapResquarify = resquarify;
	exports.treemapSlice = treemapSlice;
	exports.treemapSliceDice = sliceDice;
	exports.treemapSquarify = squarify;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 510 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-scale-chromatic/ v1.5.0 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(98), __webpack_require__(70)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-interpolate', 'd3-color'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3, global.d3));
	}(this, function (exports, d3Interpolate, d3Color) { 'use strict';
	
	function colors(specifier) {
	  var n = specifier.length / 6 | 0, colors = new Array(n), i = 0;
	  while (i < n) colors[i] = "#" + specifier.slice(i * 6, ++i * 6);
	  return colors;
	}
	
	var category10 = colors("1f77b4ff7f0e2ca02cd627289467bd8c564be377c27f7f7fbcbd2217becf");
	
	var Accent = colors("7fc97fbeaed4fdc086ffff99386cb0f0027fbf5b17666666");
	
	var Dark2 = colors("1b9e77d95f027570b3e7298a66a61ee6ab02a6761d666666");
	
	var Paired = colors("a6cee31f78b4b2df8a33a02cfb9a99e31a1cfdbf6fff7f00cab2d66a3d9affff99b15928");
	
	var Pastel1 = colors("fbb4aeb3cde3ccebc5decbe4fed9a6ffffcce5d8bdfddaecf2f2f2");
	
	var Pastel2 = colors("b3e2cdfdcdaccbd5e8f4cae4e6f5c9fff2aef1e2cccccccc");
	
	var Set1 = colors("e41a1c377eb84daf4a984ea3ff7f00ffff33a65628f781bf999999");
	
	var Set2 = colors("66c2a5fc8d628da0cbe78ac3a6d854ffd92fe5c494b3b3b3");
	
	var Set3 = colors("8dd3c7ffffb3bebadafb807280b1d3fdb462b3de69fccde5d9d9d9bc80bdccebc5ffed6f");
	
	var Tableau10 = colors("4e79a7f28e2ce1575976b7b259a14fedc949af7aa1ff9da79c755fbab0ab");
	
	function ramp(scheme) {
	  return d3Interpolate.interpolateRgbBasis(scheme[scheme.length - 1]);
	}
	
	var scheme = new Array(3).concat(
	  "d8b365f5f5f55ab4ac",
	  "a6611adfc27d80cdc1018571",
	  "a6611adfc27df5f5f580cdc1018571",
	  "8c510ad8b365f6e8c3c7eae55ab4ac01665e",
	  "8c510ad8b365f6e8c3f5f5f5c7eae55ab4ac01665e",
	  "8c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e",
	  "8c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e",
	  "5430058c510abf812ddfc27df6e8c3c7eae580cdc135978f01665e003c30",
	  "5430058c510abf812ddfc27df6e8c3f5f5f5c7eae580cdc135978f01665e003c30"
	).map(colors);
	
	var BrBG = ramp(scheme);
	
	var scheme$1 = new Array(3).concat(
	  "af8dc3f7f7f77fbf7b",
	  "7b3294c2a5cfa6dba0008837",
	  "7b3294c2a5cff7f7f7a6dba0008837",
	  "762a83af8dc3e7d4e8d9f0d37fbf7b1b7837",
	  "762a83af8dc3e7d4e8f7f7f7d9f0d37fbf7b1b7837",
	  "762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b7837",
	  "762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b7837",
	  "40004b762a839970abc2a5cfe7d4e8d9f0d3a6dba05aae611b783700441b",
	  "40004b762a839970abc2a5cfe7d4e8f7f7f7d9f0d3a6dba05aae611b783700441b"
	).map(colors);
	
	var PRGn = ramp(scheme$1);
	
	var scheme$2 = new Array(3).concat(
	  "e9a3c9f7f7f7a1d76a",
	  "d01c8bf1b6dab8e1864dac26",
	  "d01c8bf1b6daf7f7f7b8e1864dac26",
	  "c51b7de9a3c9fde0efe6f5d0a1d76a4d9221",
	  "c51b7de9a3c9fde0eff7f7f7e6f5d0a1d76a4d9221",
	  "c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221",
	  "c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221",
	  "8e0152c51b7dde77aef1b6dafde0efe6f5d0b8e1867fbc414d9221276419",
	  "8e0152c51b7dde77aef1b6dafde0eff7f7f7e6f5d0b8e1867fbc414d9221276419"
	).map(colors);
	
	var PiYG = ramp(scheme$2);
	
	var scheme$3 = new Array(3).concat(
	  "998ec3f7f7f7f1a340",
	  "5e3c99b2abd2fdb863e66101",
	  "5e3c99b2abd2f7f7f7fdb863e66101",
	  "542788998ec3d8daebfee0b6f1a340b35806",
	  "542788998ec3d8daebf7f7f7fee0b6f1a340b35806",
	  "5427888073acb2abd2d8daebfee0b6fdb863e08214b35806",
	  "5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b35806",
	  "2d004b5427888073acb2abd2d8daebfee0b6fdb863e08214b358067f3b08",
	  "2d004b5427888073acb2abd2d8daebf7f7f7fee0b6fdb863e08214b358067f3b08"
	).map(colors);
	
	var PuOr = ramp(scheme$3);
	
	var scheme$4 = new Array(3).concat(
	  "ef8a62f7f7f767a9cf",
	  "ca0020f4a58292c5de0571b0",
	  "ca0020f4a582f7f7f792c5de0571b0",
	  "b2182bef8a62fddbc7d1e5f067a9cf2166ac",
	  "b2182bef8a62fddbc7f7f7f7d1e5f067a9cf2166ac",
	  "b2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac",
	  "b2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac",
	  "67001fb2182bd6604df4a582fddbc7d1e5f092c5de4393c32166ac053061",
	  "67001fb2182bd6604df4a582fddbc7f7f7f7d1e5f092c5de4393c32166ac053061"
	).map(colors);
	
	var RdBu = ramp(scheme$4);
	
	var scheme$5 = new Array(3).concat(
	  "ef8a62ffffff999999",
	  "ca0020f4a582bababa404040",
	  "ca0020f4a582ffffffbababa404040",
	  "b2182bef8a62fddbc7e0e0e09999994d4d4d",
	  "b2182bef8a62fddbc7ffffffe0e0e09999994d4d4d",
	  "b2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d",
	  "b2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d",
	  "67001fb2182bd6604df4a582fddbc7e0e0e0bababa8787874d4d4d1a1a1a",
	  "67001fb2182bd6604df4a582fddbc7ffffffe0e0e0bababa8787874d4d4d1a1a1a"
	).map(colors);
	
	var RdGy = ramp(scheme$5);
	
	var scheme$6 = new Array(3).concat(
	  "fc8d59ffffbf91bfdb",
	  "d7191cfdae61abd9e92c7bb6",
	  "d7191cfdae61ffffbfabd9e92c7bb6",
	  "d73027fc8d59fee090e0f3f891bfdb4575b4",
	  "d73027fc8d59fee090ffffbfe0f3f891bfdb4575b4",
	  "d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4",
	  "d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4",
	  "a50026d73027f46d43fdae61fee090e0f3f8abd9e974add14575b4313695",
	  "a50026d73027f46d43fdae61fee090ffffbfe0f3f8abd9e974add14575b4313695"
	).map(colors);
	
	var RdYlBu = ramp(scheme$6);
	
	var scheme$7 = new Array(3).concat(
	  "fc8d59ffffbf91cf60",
	  "d7191cfdae61a6d96a1a9641",
	  "d7191cfdae61ffffbfa6d96a1a9641",
	  "d73027fc8d59fee08bd9ef8b91cf601a9850",
	  "d73027fc8d59fee08bffffbfd9ef8b91cf601a9850",
	  "d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850",
	  "d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850",
	  "a50026d73027f46d43fdae61fee08bd9ef8ba6d96a66bd631a9850006837",
	  "a50026d73027f46d43fdae61fee08bffffbfd9ef8ba6d96a66bd631a9850006837"
	).map(colors);
	
	var RdYlGn = ramp(scheme$7);
	
	var scheme$8 = new Array(3).concat(
	  "fc8d59ffffbf99d594",
	  "d7191cfdae61abdda42b83ba",
	  "d7191cfdae61ffffbfabdda42b83ba",
	  "d53e4ffc8d59fee08be6f59899d5943288bd",
	  "d53e4ffc8d59fee08bffffbfe6f59899d5943288bd",
	  "d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd",
	  "d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd",
	  "9e0142d53e4ff46d43fdae61fee08be6f598abdda466c2a53288bd5e4fa2",
	  "9e0142d53e4ff46d43fdae61fee08bffffbfe6f598abdda466c2a53288bd5e4fa2"
	).map(colors);
	
	var Spectral = ramp(scheme$8);
	
	var scheme$9 = new Array(3).concat(
	  "e5f5f999d8c92ca25f",
	  "edf8fbb2e2e266c2a4238b45",
	  "edf8fbb2e2e266c2a42ca25f006d2c",
	  "edf8fbccece699d8c966c2a42ca25f006d2c",
	  "edf8fbccece699d8c966c2a441ae76238b45005824",
	  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45005824",
	  "f7fcfde5f5f9ccece699d8c966c2a441ae76238b45006d2c00441b"
	).map(colors);
	
	var BuGn = ramp(scheme$9);
	
	var scheme$a = new Array(3).concat(
	  "e0ecf49ebcda8856a7",
	  "edf8fbb3cde38c96c688419d",
	  "edf8fbb3cde38c96c68856a7810f7c",
	  "edf8fbbfd3e69ebcda8c96c68856a7810f7c",
	  "edf8fbbfd3e69ebcda8c96c68c6bb188419d6e016b",
	  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d6e016b",
	  "f7fcfde0ecf4bfd3e69ebcda8c96c68c6bb188419d810f7c4d004b"
	).map(colors);
	
	var BuPu = ramp(scheme$a);
	
	var scheme$b = new Array(3).concat(
	  "e0f3dba8ddb543a2ca",
	  "f0f9e8bae4bc7bccc42b8cbe",
	  "f0f9e8bae4bc7bccc443a2ca0868ac",
	  "f0f9e8ccebc5a8ddb57bccc443a2ca0868ac",
	  "f0f9e8ccebc5a8ddb57bccc44eb3d32b8cbe08589e",
	  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe08589e",
	  "f7fcf0e0f3dbccebc5a8ddb57bccc44eb3d32b8cbe0868ac084081"
	).map(colors);
	
	var GnBu = ramp(scheme$b);
	
	var scheme$c = new Array(3).concat(
	  "fee8c8fdbb84e34a33",
	  "fef0d9fdcc8afc8d59d7301f",
	  "fef0d9fdcc8afc8d59e34a33b30000",
	  "fef0d9fdd49efdbb84fc8d59e34a33b30000",
	  "fef0d9fdd49efdbb84fc8d59ef6548d7301f990000",
	  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301f990000",
	  "fff7ecfee8c8fdd49efdbb84fc8d59ef6548d7301fb300007f0000"
	).map(colors);
	
	var OrRd = ramp(scheme$c);
	
	var scheme$d = new Array(3).concat(
	  "ece2f0a6bddb1c9099",
	  "f6eff7bdc9e167a9cf02818a",
	  "f6eff7bdc9e167a9cf1c9099016c59",
	  "f6eff7d0d1e6a6bddb67a9cf1c9099016c59",
	  "f6eff7d0d1e6a6bddb67a9cf3690c002818a016450",
	  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016450",
	  "fff7fbece2f0d0d1e6a6bddb67a9cf3690c002818a016c59014636"
	).map(colors);
	
	var PuBuGn = ramp(scheme$d);
	
	var scheme$e = new Array(3).concat(
	  "ece7f2a6bddb2b8cbe",
	  "f1eef6bdc9e174a9cf0570b0",
	  "f1eef6bdc9e174a9cf2b8cbe045a8d",
	  "f1eef6d0d1e6a6bddb74a9cf2b8cbe045a8d",
	  "f1eef6d0d1e6a6bddb74a9cf3690c00570b0034e7b",
	  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0034e7b",
	  "fff7fbece7f2d0d1e6a6bddb74a9cf3690c00570b0045a8d023858"
	).map(colors);
	
	var PuBu = ramp(scheme$e);
	
	var scheme$f = new Array(3).concat(
	  "e7e1efc994c7dd1c77",
	  "f1eef6d7b5d8df65b0ce1256",
	  "f1eef6d7b5d8df65b0dd1c77980043",
	  "f1eef6d4b9dac994c7df65b0dd1c77980043",
	  "f1eef6d4b9dac994c7df65b0e7298ace125691003f",
	  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125691003f",
	  "f7f4f9e7e1efd4b9dac994c7df65b0e7298ace125698004367001f"
	).map(colors);
	
	var PuRd = ramp(scheme$f);
	
	var scheme$g = new Array(3).concat(
	  "fde0ddfa9fb5c51b8a",
	  "feebe2fbb4b9f768a1ae017e",
	  "feebe2fbb4b9f768a1c51b8a7a0177",
	  "feebe2fcc5c0fa9fb5f768a1c51b8a7a0177",
	  "feebe2fcc5c0fa9fb5f768a1dd3497ae017e7a0177",
	  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a0177",
	  "fff7f3fde0ddfcc5c0fa9fb5f768a1dd3497ae017e7a017749006a"
	).map(colors);
	
	var RdPu = ramp(scheme$g);
	
	var scheme$h = new Array(3).concat(
	  "edf8b17fcdbb2c7fb8",
	  "ffffcca1dab441b6c4225ea8",
	  "ffffcca1dab441b6c42c7fb8253494",
	  "ffffccc7e9b47fcdbb41b6c42c7fb8253494",
	  "ffffccc7e9b47fcdbb41b6c41d91c0225ea80c2c84",
	  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea80c2c84",
	  "ffffd9edf8b1c7e9b47fcdbb41b6c41d91c0225ea8253494081d58"
	).map(colors);
	
	var YlGnBu = ramp(scheme$h);
	
	var scheme$i = new Array(3).concat(
	  "f7fcb9addd8e31a354",
	  "ffffccc2e69978c679238443",
	  "ffffccc2e69978c67931a354006837",
	  "ffffccd9f0a3addd8e78c67931a354006837",
	  "ffffccd9f0a3addd8e78c67941ab5d238443005a32",
	  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443005a32",
	  "ffffe5f7fcb9d9f0a3addd8e78c67941ab5d238443006837004529"
	).map(colors);
	
	var YlGn = ramp(scheme$i);
	
	var scheme$j = new Array(3).concat(
	  "fff7bcfec44fd95f0e",
	  "ffffd4fed98efe9929cc4c02",
	  "ffffd4fed98efe9929d95f0e993404",
	  "ffffd4fee391fec44ffe9929d95f0e993404",
	  "ffffd4fee391fec44ffe9929ec7014cc4c028c2d04",
	  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c028c2d04",
	  "ffffe5fff7bcfee391fec44ffe9929ec7014cc4c02993404662506"
	).map(colors);
	
	var YlOrBr = ramp(scheme$j);
	
	var scheme$k = new Array(3).concat(
	  "ffeda0feb24cf03b20",
	  "ffffb2fecc5cfd8d3ce31a1c",
	  "ffffb2fecc5cfd8d3cf03b20bd0026",
	  "ffffb2fed976feb24cfd8d3cf03b20bd0026",
	  "ffffb2fed976feb24cfd8d3cfc4e2ae31a1cb10026",
	  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cb10026",
	  "ffffccffeda0fed976feb24cfd8d3cfc4e2ae31a1cbd0026800026"
	).map(colors);
	
	var YlOrRd = ramp(scheme$k);
	
	var scheme$l = new Array(3).concat(
	  "deebf79ecae13182bd",
	  "eff3ffbdd7e76baed62171b5",
	  "eff3ffbdd7e76baed63182bd08519c",
	  "eff3ffc6dbef9ecae16baed63182bd08519c",
	  "eff3ffc6dbef9ecae16baed64292c62171b5084594",
	  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b5084594",
	  "f7fbffdeebf7c6dbef9ecae16baed64292c62171b508519c08306b"
	).map(colors);
	
	var Blues = ramp(scheme$l);
	
	var scheme$m = new Array(3).concat(
	  "e5f5e0a1d99b31a354",
	  "edf8e9bae4b374c476238b45",
	  "edf8e9bae4b374c47631a354006d2c",
	  "edf8e9c7e9c0a1d99b74c47631a354006d2c",
	  "edf8e9c7e9c0a1d99b74c47641ab5d238b45005a32",
	  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45005a32",
	  "f7fcf5e5f5e0c7e9c0a1d99b74c47641ab5d238b45006d2c00441b"
	).map(colors);
	
	var Greens = ramp(scheme$m);
	
	var scheme$n = new Array(3).concat(
	  "f0f0f0bdbdbd636363",
	  "f7f7f7cccccc969696525252",
	  "f7f7f7cccccc969696636363252525",
	  "f7f7f7d9d9d9bdbdbd969696636363252525",
	  "f7f7f7d9d9d9bdbdbd969696737373525252252525",
	  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525",
	  "fffffff0f0f0d9d9d9bdbdbd969696737373525252252525000000"
	).map(colors);
	
	var Greys = ramp(scheme$n);
	
	var scheme$o = new Array(3).concat(
	  "efedf5bcbddc756bb1",
	  "f2f0f7cbc9e29e9ac86a51a3",
	  "f2f0f7cbc9e29e9ac8756bb154278f",
	  "f2f0f7dadaebbcbddc9e9ac8756bb154278f",
	  "f2f0f7dadaebbcbddc9e9ac8807dba6a51a34a1486",
	  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a34a1486",
	  "fcfbfdefedf5dadaebbcbddc9e9ac8807dba6a51a354278f3f007d"
	).map(colors);
	
	var Purples = ramp(scheme$o);
	
	var scheme$p = new Array(3).concat(
	  "fee0d2fc9272de2d26",
	  "fee5d9fcae91fb6a4acb181d",
	  "fee5d9fcae91fb6a4ade2d26a50f15",
	  "fee5d9fcbba1fc9272fb6a4ade2d26a50f15",
	  "fee5d9fcbba1fc9272fb6a4aef3b2ccb181d99000d",
	  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181d99000d",
	  "fff5f0fee0d2fcbba1fc9272fb6a4aef3b2ccb181da50f1567000d"
	).map(colors);
	
	var Reds = ramp(scheme$p);
	
	var scheme$q = new Array(3).concat(
	  "fee6cefdae6be6550d",
	  "feeddefdbe85fd8d3cd94701",
	  "feeddefdbe85fd8d3ce6550da63603",
	  "feeddefdd0a2fdae6bfd8d3ce6550da63603",
	  "feeddefdd0a2fdae6bfd8d3cf16913d948018c2d04",
	  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d948018c2d04",
	  "fff5ebfee6cefdd0a2fdae6bfd8d3cf16913d94801a636037f2704"
	).map(colors);
	
	var Oranges = ramp(scheme$q);
	
	function cividis(t) {
	  t = Math.max(0, Math.min(1, t));
	  return "rgb("
	      + Math.max(0, Math.min(255, Math.round(-4.54 - t * (35.34 - t * (2381.73 - t * (6402.7 - t * (7024.72 - t * 2710.57))))))) + ", "
	      + Math.max(0, Math.min(255, Math.round(32.49 + t * (170.73 + t * (52.82 - t * (131.46 - t * (176.58 - t * 67.37))))))) + ", "
	      + Math.max(0, Math.min(255, Math.round(81.24 + t * (442.36 - t * (2482.43 - t * (6167.24 - t * (6614.94 - t * 2475.67)))))))
	      + ")";
	}
	
	var cubehelix = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(300, 0.5, 0.0), d3Color.cubehelix(-240, 0.5, 1.0));
	
	var warm = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(-100, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var cool = d3Interpolate.interpolateCubehelixLong(d3Color.cubehelix(260, 0.75, 0.35), d3Color.cubehelix(80, 1.50, 0.8));
	
	var c = d3Color.cubehelix();
	
	function rainbow(t) {
	  if (t < 0 || t > 1) t -= Math.floor(t);
	  var ts = Math.abs(t - 0.5);
	  c.h = 360 * t - 100;
	  c.s = 1.5 - 1.5 * ts;
	  c.l = 0.8 - 0.9 * ts;
	  return c + "";
	}
	
	var c$1 = d3Color.rgb(),
	    pi_1_3 = Math.PI / 3,
	    pi_2_3 = Math.PI * 2 / 3;
	
	function sinebow(t) {
	  var x;
	  t = (0.5 - t) * Math.PI;
	  c$1.r = 255 * (x = Math.sin(t)) * x;
	  c$1.g = 255 * (x = Math.sin(t + pi_1_3)) * x;
	  c$1.b = 255 * (x = Math.sin(t + pi_2_3)) * x;
	  return c$1 + "";
	}
	
	function turbo(t) {
	  t = Math.max(0, Math.min(1, t));
	  return "rgb("
	      + Math.max(0, Math.min(255, Math.round(34.61 + t * (1172.33 - t * (10793.56 - t * (33300.12 - t * (38394.49 - t * 14825.05))))))) + ", "
	      + Math.max(0, Math.min(255, Math.round(23.31 + t * (557.33 + t * (1225.33 - t * (3574.96 - t * (1073.77 + t * 707.56))))))) + ", "
	      + Math.max(0, Math.min(255, Math.round(27.2 + t * (3211.1 - t * (15327.97 - t * (27814 - t * (22569.18 - t * 6838.66)))))))
	      + ")";
	}
	
	function ramp$1(range) {
	  var n = range.length;
	  return function(t) {
	    return range[Math.max(0, Math.min(n - 1, Math.floor(t * n)))];
	  };
	}
	
	var viridis = ramp$1(colors("44015444025645045745055946075a46085c460a5d460b5e470d60470e6147106347116447136548146748166848176948186a481a6c481b6d481c6e481d6f481f70482071482173482374482475482576482677482878482979472a7a472c7a472d7b472e7c472f7d46307e46327e46337f463480453581453781453882443983443a83443b84433d84433e85423f854240864241864142874144874045884046883f47883f48893e49893e4a893e4c8a3d4d8a3d4e8a3c4f8a3c508b3b518b3b528b3a538b3a548c39558c39568c38588c38598c375a8c375b8d365c8d365d8d355e8d355f8d34608d34618d33628d33638d32648e32658e31668e31678e31688e30698e306a8e2f6b8e2f6c8e2e6d8e2e6e8e2e6f8e2d708e2d718e2c718e2c728e2c738e2b748e2b758e2a768e2a778e2a788e29798e297a8e297b8e287c8e287d8e277e8e277f8e27808e26818e26828e26828e25838e25848e25858e24868e24878e23888e23898e238a8d228b8d228c8d228d8d218e8d218f8d21908d21918c20928c20928c20938c1f948c1f958b1f968b1f978b1f988b1f998a1f9a8a1e9b8a1e9c891e9d891f9e891f9f881fa0881fa1881fa1871fa28720a38620a48621a58521a68522a78522a88423a98324aa8325ab8225ac8226ad8127ad8128ae8029af7f2ab07f2cb17e2db27d2eb37c2fb47c31b57b32b67a34b67935b77937b87838b9773aba763bbb753dbc743fbc7340bd7242be7144bf7046c06f48c16e4ac16d4cc26c4ec36b50c46a52c56954c56856c66758c7655ac8645cc8635ec96260ca6063cb5f65cb5e67cc5c69cd5b6ccd5a6ece5870cf5773d05675d05477d1537ad1517cd2507fd34e81d34d84d44b86d54989d5488bd6468ed64590d74393d74195d84098d83e9bd93c9dd93ba0da39a2da37a5db36a8db34aadc32addc30b0dd2fb2dd2db5de2bb8de29bade28bddf26c0df25c2df23c5e021c8e020cae11fcde11dd0e11cd2e21bd5e21ad8e219dae319dde318dfe318e2e418e5e419e7e419eae51aece51befe51cf1e51df4e61ef6e620f8e621fbe723fde725"));
	
	var magma = ramp$1(colors("00000401000501010601010802010902020b02020d03030f03031204041405041606051806051a07061c08071e0907200a08220b09240c09260d0a290e0b2b100b2d110c2f120d31130d34140e36150e38160f3b180f3d19103f1a10421c10441d11471e114920114b21114e22115024125325125527125829115a2a115c2c115f2d11612f116331116533106734106936106b38106c390f6e3b0f703d0f713f0f72400f74420f75440f764510774710784910784a10794c117a4e117b4f127b51127c52137c54137d56147d57157e59157e5a167e5c167f5d177f5f187f601880621980641a80651a80671b80681c816a1c816b1d816d1d816e1e81701f81721f817320817521817621817822817922827b23827c23827e24828025828125818326818426818627818827818928818b29818c29818e2a81902a81912b81932b80942c80962c80982d80992d809b2e7f9c2e7f9e2f7fa02f7fa1307ea3307ea5317ea6317da8327daa337dab337cad347cae347bb0357bb2357bb3367ab5367ab73779b83779ba3878bc3978bd3977bf3a77c03a76c23b75c43c75c53c74c73d73c83e73ca3e72cc3f71cd4071cf4070d0416fd2426fd3436ed5446dd6456cd8456cd9466bdb476adc4869de4968df4a68e04c67e24d66e34e65e44f64e55064e75263e85362e95462ea5661eb5760ec5860ed5a5fee5b5eef5d5ef05f5ef1605df2625df2645cf3655cf4675cf4695cf56b5cf66c5cf66e5cf7705cf7725cf8745cf8765cf9785df9795df97b5dfa7d5efa7f5efa815ffb835ffb8560fb8761fc8961fc8a62fc8c63fc8e64fc9065fd9266fd9467fd9668fd9869fd9a6afd9b6bfe9d6cfe9f6dfea16efea36ffea571fea772fea973feaa74feac76feae77feb078feb27afeb47bfeb67cfeb77efeb97ffebb81febd82febf84fec185fec287fec488fec68afec88cfeca8dfecc8ffecd90fecf92fed194fed395fed597fed799fed89afdda9cfddc9efddea0fde0a1fde2a3fde3a5fde5a7fde7a9fde9aafdebacfcecaefceeb0fcf0b2fcf2b4fcf4b6fcf6b8fcf7b9fcf9bbfcfbbdfcfdbf"));
	
	var inferno = ramp$1(colors("00000401000501010601010802010a02020c02020e03021004031204031405041706041907051b08051d09061f0a07220b07240c08260d08290e092b10092d110a30120a32140b34150b37160b39180c3c190c3e1b0c411c0c431e0c451f0c48210c4a230c4c240c4f260c51280b53290b552b0b572d0b592f0a5b310a5c320a5e340a5f3609613809623909633b09643d09653e0966400a67420a68440a68450a69470b6a490b6a4a0c6b4c0c6b4d0d6c4f0d6c510e6c520e6d540f6d550f6d57106e59106e5a116e5c126e5d126e5f136e61136e62146e64156e65156e67166e69166e6a176e6c186e6d186e6f196e71196e721a6e741a6e751b6e771c6d781c6d7a1d6d7c1d6d7d1e6d7f1e6c801f6c82206c84206b85216b87216b88226a8a226a8c23698d23698f24699025689225689326679526679727669827669a28659b29649d29649f2a63a02a63a22b62a32c61a52c60a62d60a82e5fa92e5eab2f5ead305dae305cb0315bb1325ab3325ab43359b63458b73557b93556ba3655bc3754bd3853bf3952c03a51c13a50c33b4fc43c4ec63d4dc73e4cc83f4bca404acb4149cc4248ce4347cf4446d04545d24644d34743d44842d54a41d74b3fd84c3ed94d3dda4e3cdb503bdd513ade5238df5337e05536e15635e25734e35933e45a31e55c30e65d2fe75e2ee8602de9612bea632aeb6429eb6628ec6726ed6925ee6a24ef6c23ef6e21f06f20f1711ff1731df2741cf3761bf37819f47918f57b17f57d15f67e14f68013f78212f78410f8850ff8870ef8890cf98b0bf98c0af98e09fa9008fa9207fa9407fb9606fb9706fb9906fb9b06fb9d07fc9f07fca108fca309fca50afca60cfca80dfcaa0ffcac11fcae12fcb014fcb216fcb418fbb61afbb81dfbba1ffbbc21fbbe23fac026fac228fac42afac62df9c72ff9c932f9cb35f8cd37f8cf3af7d13df7d340f6d543f6d746f5d949f5db4cf4dd4ff4df53f4e156f3e35af3e55df2e661f2e865f2ea69f1ec6df1ed71f1ef75f1f179f2f27df2f482f3f586f3f68af4f88ef5f992f6fa96f8fb9af9fc9dfafda1fcffa4"));
	
	var plasma = ramp$1(colors("0d088710078813078916078a19068c1b068d1d068e20068f2206902406912605912805922a05932c05942e05952f059631059733059735049837049938049a3a049a3c049b3e049c3f049c41049d43039e44039e46039f48039f4903a04b03a14c02a14e02a25002a25102a35302a35502a45601a45801a45901a55b01a55c01a65e01a66001a66100a76300a76400a76600a76700a86900a86a00a86c00a86e00a86f00a87100a87201a87401a87501a87701a87801a87a02a87b02a87d03a87e03a88004a88104a78305a78405a78606a68707a68808a68a09a58b0aa58d0ba58e0ca48f0da4910ea3920fa39410a29511a19613a19814a099159f9a169f9c179e9d189d9e199da01a9ca11b9ba21d9aa31e9aa51f99a62098a72197a82296aa2395ab2494ac2694ad2793ae2892b02991b12a90b22b8fb32c8eb42e8db52f8cb6308bb7318ab83289ba3388bb3488bc3587bd3786be3885bf3984c03a83c13b82c23c81c33d80c43e7fc5407ec6417dc7427cc8437bc9447aca457acb4679cc4778cc4977cd4a76ce4b75cf4c74d04d73d14e72d24f71d35171d45270d5536fd5546ed6556dd7566cd8576bd9586ada5a6ada5b69db5c68dc5d67dd5e66de5f65de6164df6263e06363e16462e26561e26660e3685fe4695ee56a5de56b5de66c5ce76e5be76f5ae87059e97158e97257ea7457eb7556eb7655ec7754ed7953ed7a52ee7b51ef7c51ef7e50f07f4ff0804ef1814df1834cf2844bf3854bf3874af48849f48948f58b47f58c46f68d45f68f44f79044f79143f79342f89441f89540f9973ff9983ef99a3efa9b3dfa9c3cfa9e3bfb9f3afba139fba238fca338fca537fca636fca835fca934fdab33fdac33fdae32fdaf31fdb130fdb22ffdb42ffdb52efeb72dfeb82cfeba2cfebb2bfebd2afebe2afec029fdc229fdc328fdc527fdc627fdc827fdca26fdcb26fccd25fcce25fcd025fcd225fbd324fbd524fbd724fad824fada24f9dc24f9dd25f8df25f8e125f7e225f7e425f6e626f6e826f5e926f5eb27f4ed27f3ee27f3f027f2f227f1f426f1f525f0f724f0f921"));
	
	exports.interpolateBlues = Blues;
	exports.interpolateBrBG = BrBG;
	exports.interpolateBuGn = BuGn;
	exports.interpolateBuPu = BuPu;
	exports.interpolateCividis = cividis;
	exports.interpolateCool = cool;
	exports.interpolateCubehelixDefault = cubehelix;
	exports.interpolateGnBu = GnBu;
	exports.interpolateGreens = Greens;
	exports.interpolateGreys = Greys;
	exports.interpolateInferno = inferno;
	exports.interpolateMagma = magma;
	exports.interpolateOrRd = OrRd;
	exports.interpolateOranges = Oranges;
	exports.interpolatePRGn = PRGn;
	exports.interpolatePiYG = PiYG;
	exports.interpolatePlasma = plasma;
	exports.interpolatePuBu = PuBu;
	exports.interpolatePuBuGn = PuBuGn;
	exports.interpolatePuOr = PuOr;
	exports.interpolatePuRd = PuRd;
	exports.interpolatePurples = Purples;
	exports.interpolateRainbow = rainbow;
	exports.interpolateRdBu = RdBu;
	exports.interpolateRdGy = RdGy;
	exports.interpolateRdPu = RdPu;
	exports.interpolateRdYlBu = RdYlBu;
	exports.interpolateRdYlGn = RdYlGn;
	exports.interpolateReds = Reds;
	exports.interpolateSinebow = sinebow;
	exports.interpolateSpectral = Spectral;
	exports.interpolateTurbo = turbo;
	exports.interpolateViridis = viridis;
	exports.interpolateWarm = warm;
	exports.interpolateYlGn = YlGn;
	exports.interpolateYlGnBu = YlGnBu;
	exports.interpolateYlOrBr = YlOrBr;
	exports.interpolateYlOrRd = YlOrRd;
	exports.schemeAccent = Accent;
	exports.schemeBlues = scheme$l;
	exports.schemeBrBG = scheme;
	exports.schemeBuGn = scheme$9;
	exports.schemeBuPu = scheme$a;
	exports.schemeCategory10 = category10;
	exports.schemeDark2 = Dark2;
	exports.schemeGnBu = scheme$b;
	exports.schemeGreens = scheme$m;
	exports.schemeGreys = scheme$n;
	exports.schemeOrRd = scheme$c;
	exports.schemeOranges = scheme$q;
	exports.schemePRGn = scheme$1;
	exports.schemePaired = Paired;
	exports.schemePastel1 = Pastel1;
	exports.schemePastel2 = Pastel2;
	exports.schemePiYG = scheme$2;
	exports.schemePuBu = scheme$e;
	exports.schemePuBuGn = scheme$d;
	exports.schemePuOr = scheme$3;
	exports.schemePuRd = scheme$f;
	exports.schemePurples = scheme$o;
	exports.schemeRdBu = scheme$4;
	exports.schemeRdGy = scheme$5;
	exports.schemeRdPu = scheme$g;
	exports.schemeRdYlBu = scheme$6;
	exports.schemeRdYlGn = scheme$7;
	exports.schemeReds = scheme$p;
	exports.schemeSet1 = Set1;
	exports.schemeSet2 = Set2;
	exports.schemeSet3 = Set3;
	exports.schemeSpectral = scheme$8;
	exports.schemeTableau10 = Tableau10;
	exports.schemeYlGn = scheme$i;
	exports.schemeYlGnBu = scheme$h;
	exports.schemeYlOrBr = scheme$j;
	exports.schemeYlOrRd = scheme$k;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 511 */
/***/ function(module, exports, __webpack_require__) {

	(function (global, factory) {
	   true ? module.exports = factory(__webpack_require__(512), __webpack_require__(71), __webpack_require__(513), __webpack_require__(31)) :
	  typeof define === 'function' && define.amd ? define(['d3-dispatch', 'd3-scale', 'd3-format', 'd3-array'], factory) :
	  (global.indexRollup = factory(global.d3Dispatch,global.d3Scale,global.d3Format,global.d3Array));
	}(this, function (d3Dispatch,d3Scale,d3Format,d3Array) { 'use strict';
	
	  var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) {
	    return typeof obj;
	  } : function (obj) {
	    return obj && typeof Symbol === "function" && obj.constructor === Symbol ? "symbol" : typeof obj;
	  };
	
	  var helper = {
	
	    d3_identity: function d3_identity(d) {
	      return d;
	    },
	
	    d3_mergeLabels: function d3_mergeLabels() {
	      var gen = arguments.length <= 0 || arguments[0] === undefined ? [] : arguments[0];
	      var labels = arguments[1];
	      var domain = arguments[2];
	      var range = arguments[3];
	
	
	      if ((typeof labels === "undefined" ? "undefined" : _typeof(labels)) === "object") {
	        if (labels.length === 0) return gen;
	
	        var i = labels.length;
	        for (; i < gen.length; i++) {
	          labels.push(gen[i]);
	        }
	        return labels;
	      } else if (typeof labels === "function") {
	        var customLabels = [];
	        var genLength = gen.length;
	        for (var _i = 0; _i < genLength; _i++) {
	          customLabels.push(labels({
	            i: _i,
	            genLength: genLength,
	            generatedLabels: gen,
	            domain: domain,
	            range: range }));
	        }
	        return customLabels;
	      }
	
	      return gen;
	    },
	
	    d3_linearLegend: function d3_linearLegend(scale, cells, labelFormat) {
	      var data = [];
	
	      if (cells.length > 1) {
	        data = cells;
	      } else {
	        var domain = scale.domain(),
	            increment = (domain[domain.length - 1] - domain[0]) / (cells - 1),
	            i = 0;
	
	        for (; i < cells; i++) {
	          data.push(domain[0] + i * increment);
	        }
	      }
	
	      var labels = data.map(labelFormat);
	
	      return { data: data,
	        labels: labels,
	        feature: function feature(d) {
	          return scale(d);
	        } };
	    },
	
	    d3_quantLegend: function d3_quantLegend(scale, labelFormat, labelDelimiter) {
	      var labels = scale.range().map(function (d) {
	        var invert = scale.invertExtent(d);
	
	        return labelFormat(invert[0]) + " " + labelDelimiter + " " + labelFormat(invert[1]);
	      });
	
	      return { data: scale.range(),
	        labels: labels,
	        feature: this.d3_identity
	      };
	    },
	
	    d3_ordinalLegend: function d3_ordinalLegend(scale) {
	      return { data: scale.domain(),
	        labels: scale.domain(),
	        feature: function feature(d) {
	          return scale(d);
	        } };
	    },
	
	    d3_drawShapes: function d3_drawShapes(shape, shapes, shapeHeight, shapeWidth, shapeRadius, path) {
	      if (shape === "rect") {
	        shapes.attr("height", shapeHeight).attr("width", shapeWidth);
	      } else if (shape === "circle") {
	        shapes.attr("r", shapeRadius); //.attr("cx", shapeRadius).attr("cy", shapeRadius);
	      } else if (shape === "line") {
	        shapes.attr("x1", 0).attr("x2", shapeWidth).attr("y1", 0).attr("y2", 0);
	      } else if (shape === "path") {
	        shapes.attr("d", path);
	      }
	    },
	
	    d3_addText: function d3_addText(svg, enter, labels, classPrefix) {
	      enter.append("text").attr("class", classPrefix + "label");
	      svg.selectAll("g." + classPrefix + "cell text").data(labels).text(this.d3_identity);
	    },
	
	    d3_calcType: function d3_calcType(scale, ascending, cells, labels, labelFormat, labelDelimiter) {
	      var type = scale.invertExtent ? this.d3_quantLegend(scale, labelFormat, labelDelimiter) : scale.ticks ? this.d3_linearLegend(scale, cells, labelFormat) : this.d3_ordinalLegend(scale);
	
	      type.labels = this.d3_mergeLabels(type.labels, labels, scale.domain(), scale.range());
	
	      if (ascending) {
	        type.labels = this.d3_reverse(type.labels);
	        type.data = this.d3_reverse(type.data);
	      }
	
	      return type;
	    },
	
	    d3_reverse: function d3_reverse(arr) {
	      var mirror = [];
	      for (var i = 0, l = arr.length; i < l; i++) {
	        mirror[i] = arr[l - i - 1];
	      }
	      return mirror;
	    },
	
	    d3_placement: function d3_placement(orient, cell, cellTrans, text, textTrans, labelAlign) {
	      cell.attr("transform", cellTrans);
	      text.attr("transform", textTrans);
	      if (orient === "horizontal") {
	        text.style("text-anchor", labelAlign);
	      }
	    },
	
	    d3_addEvents: function d3_addEvents(cells, dispatcher) {
	      var _ = this;
	
	      cells.on("mouseover.legend", function (d) {
	        _.d3_cellOver(dispatcher, d, this);
	      }).on("mouseout.legend", function (d) {
	        _.d3_cellOut(dispatcher, d, this);
	      }).on("click.legend", function (d) {
	        _.d3_cellClick(dispatcher, d, this);
	      });
	    },
	
	    d3_cellOver: function d3_cellOver(cellDispatcher, d, obj) {
	      cellDispatcher.call("cellover", obj, d);
	    },
	
	    d3_cellOut: function d3_cellOut(cellDispatcher, d, obj) {
	      cellDispatcher.call("cellout", obj, d);
	    },
	
	    d3_cellClick: function d3_cellClick(cellDispatcher, d, obj) {
	      cellDispatcher.call("cellclick", obj, d);
	    },
	
	    d3_title: function d3_title(svg, title, classPrefix) {
	      if (title !== "") {
	
	        var titleText = svg.selectAll('text.' + classPrefix + 'legendTitle');
	
	        titleText.data([title]).enter().append('text').attr('class', classPrefix + 'legendTitle');
	
	        svg.selectAll('text.' + classPrefix + 'legendTitle').text(title);
	
	        var cellsSvg = svg.select('.' + classPrefix + 'legendCells');
	
	        var yOffset = svg.select('.' + classPrefix + 'legendTitle').nodes().map(function (d) {
	          return d.getBBox().height;
	        })[0],
	            xOffset = -cellsSvg.nodes().map(function (d) {
	          return d.getBBox().x;
	        })[0];
	
	        cellsSvg.attr('transform', 'translate(' + xOffset + ',' + (yOffset + 10) + ')');
	      }
	    }
	  };
	
	  function color() {
	
	    var scale = d3Scale.scaleLinear(),
	        shape = "rect",
	        shapeWidth = 15,
	        shapeHeight = 15,
	        shapeRadius = 10,
	        shapePadding = 2,
	        cells = [5],
	        labels = [],
	        classPrefix = "",
	        useClass = false,
	        title = "",
	        labelFormat = d3Format.format(".01f"),
	        labelOffset = 10,
	        labelAlign = "middle",
	        labelDelimiter = "to",
	        orient = "vertical",
	        ascending = false,
	        path,
	        legendDispatcher = d3Dispatch.dispatch("cellover", "cellout", "cellclick");
	
	    function legend(svg) {
	
	      var type = helper.d3_calcType(scale, ascending, cells, labels, labelFormat, labelDelimiter),
	          legendG = svg.selectAll('g').data([scale]);
	
	      legendG.enter().append('g').attr('class', classPrefix + 'legendCells');
	
	      var cell = svg.select('.' + classPrefix + 'legendCells').selectAll("." + classPrefix + "cell").data(type.data),
	          cellEnter = cell.enter().append("g").attr("class", classPrefix + "cell"),
	          //.merge(cell).style("opacity", 1e-6),
	      shapeEnter = cellEnter.append(shape).attr("class", classPrefix + "swatch"),
	          shapes = svg.selectAll("g." + classPrefix + "cell " + shape);
	
	      //add event handlers
	      helper.d3_addEvents(cellEnter, legendDispatcher);
	
	      cell.exit().transition().style("opacity", 0).remove();
	
	      helper.d3_drawShapes(shape, shapes, shapeHeight, shapeWidth, shapeRadius, path);
	
	      helper.d3_addText(svg, cellEnter, type.labels, classPrefix);
	
	      // we need to merge the selection, otherwise changes in the legend (e.g. change of orientation) are applied only to the new cells and not the existing ones.
	      cell = cellEnter.merge(cell);
	
	      // sets placement
	      var text = cell.selectAll("text"),
	          shapeSize = shapes.nodes().map(function (d) {
	        return d.getBBox();
	      });
	
	      //sets scale
	      //everything is fill except for line which is stroke,
	      if (!useClass) {
	        if (shape == "line") {
	          shapes.style("stroke", type.feature);
	        } else {
	          shapes.style("fill", type.feature);
	        }
	      } else {
	        shapes.attr("class", function (d) {
	          return classPrefix + "swatch " + type.feature(d);
	        });
	      }
	
	      var cellTrans,
	          textTrans,
	          textAlign = labelAlign == "start" ? 0 : labelAlign == "middle" ? 0.5 : 1;
	
	      //positions cells and text
	      if (orient === "vertical") {
	        cellTrans = function cellTrans(d, i) {
	          return "translate(0, " + i * (shapeSize[i].height + shapePadding) + ")";
	        };
	        textTrans = function textTrans(d, i) {
	          return "translate(" + (shapeSize[i].width + shapeSize[i].x + labelOffset) + "," + (shapeSize[i].y + shapeSize[i].height / 2 + 5) + ")";
	        };
	      } else if (orient === "horizontal") {
	        cellTrans = function cellTrans(d, i) {
	          return "translate(" + i * (shapeSize[i].width + shapePadding) + ",0)";
	        };
	        textTrans = function textTrans(d, i) {
	          return "translate(" + (shapeSize[i].width * textAlign + shapeSize[i].x) + "," + (shapeSize[i].height + shapeSize[i].y + labelOffset + 8) + ")";
	        };
	      }
	
	      helper.d3_placement(orient, cell, cellTrans, text, textTrans, labelAlign);
	      helper.d3_title(svg, title, classPrefix);
	
	      cell.transition().style("opacity", 1);
	    }
	
	    legend.scale = function (_) {
	      if (!arguments.length) return scale;
	      scale = _;
	      return legend;
	    };
	
	    legend.cells = function (_) {
	      if (!arguments.length) return cells;
	      if (_.length > 1 || _ >= 2) {
	        cells = _;
	      }
	      return legend;
	    };
	
	    legend.shape = function (_, d) {
	      if (!arguments.length) return shape;
	      if (_ == "rect" || _ == "circle" || _ == "line" || _ == "path" && typeof d === 'string') {
	        shape = _;
	        path = d;
	      }
	      return legend;
	    };
	
	    legend.shapeWidth = function (_) {
	      if (!arguments.length) return shapeWidth;
	      shapeWidth = +_;
	      return legend;
	    };
	
	    legend.shapeHeight = function (_) {
	      if (!arguments.length) return shapeHeight;
	      shapeHeight = +_;
	      return legend;
	    };
	
	    legend.shapeRadius = function (_) {
	      if (!arguments.length) return shapeRadius;
	      shapeRadius = +_;
	      return legend;
	    };
	
	    legend.shapePadding = function (_) {
	      if (!arguments.length) return shapePadding;
	      shapePadding = +_;
	      return legend;
	    };
	
	    legend.labels = function (_) {
	      if (!arguments.length) return labels;
	      labels = _;
	      return legend;
	    };
	
	    legend.labelAlign = function (_) {
	      if (!arguments.length) return labelAlign;
	      if (_ == "start" || _ == "end" || _ == "middle") {
	        labelAlign = _;
	      }
	      return legend;
	    };
	
	    legend.labelFormat = function (_) {
	      if (!arguments.length) return labelFormat;
	      labelFormat = typeof _ === 'string' ? d3Format.format(_) : _;
	      return legend;
	    };
	
	    legend.labelOffset = function (_) {
	      if (!arguments.length) return labelOffset;
	      labelOffset = +_;
	      return legend;
	    };
	
	    legend.labelDelimiter = function (_) {
	      if (!arguments.length) return labelDelimiter;
	      labelDelimiter = _;
	      return legend;
	    };
	
	    legend.useClass = function (_) {
	      if (!arguments.length) return useClass;
	      if (_ === true || _ === false) {
	        useClass = _;
	      }
	      return legend;
	    };
	
	    legend.orient = function (_) {
	      if (!arguments.length) return orient;
	      _ = _.toLowerCase();
	      if (_ == "horizontal" || _ == "vertical") {
	        orient = _;
	      }
	      return legend;
	    };
	
	    legend.ascending = function (_) {
	      if (!arguments.length) return ascending;
	      ascending = !!_;
	      return legend;
	    };
	
	    legend.classPrefix = function (_) {
	      if (!arguments.length) return classPrefix;
	      classPrefix = _;
	      return legend;
	    };
	
	    legend.title = function (_) {
	      if (!arguments.length) return title;
	      title = _;
	      return legend;
	    };
	
	    legend.on = function () {
	      var value = legendDispatcher.on.apply(legendDispatcher, arguments);
	      return value === legendDispatcher ? legend : value;
	    };
	
	    return legend;
	  };
	
	  function size() {
	
	    var scale = d3Scale.scaleLinear(),
	        shape = "rect",
	        shapeWidth = 15,
	        shapePadding = 2,
	        cells = [5],
	        labels = [],
	        useStroke = false,
	        classPrefix = "",
	        title = "",
	        labelFormat = d3Format.format(".01f"),
	        labelOffset = 10,
	        labelAlign = "middle",
	        labelDelimiter = "to",
	        orient = "vertical",
	        ascending = false,
	        path,
	        legendDispatcher = d3Dispatch.dispatch("cellover", "cellout", "cellclick");
	
	    function legend(svg) {
	
	      var type = helper.d3_calcType(scale, ascending, cells, labels, labelFormat, labelDelimiter),
	          legendG = svg.selectAll('g').data([scale]);
	
	      legendG.enter().append('g').attr('class', classPrefix + 'legendCells');
	
	      var cell = svg.select('.' + classPrefix + 'legendCells').selectAll("." + classPrefix + "cell").data(type.data),
	          cellEnter = cell.enter().append("g").attr("class", classPrefix + "cell"),
	          //.merge(cell).style("opacity", 1e-6),
	      shapeEnter = cellEnter.append(shape).attr("class", classPrefix + "swatch"),
	          shapes = svg.selectAll("g." + classPrefix + "cell " + shape);
	
	      //add event handlers
	      helper.d3_addEvents(cellEnter, legendDispatcher);
	
	      cell.exit().transition().style("opacity", 0).remove();
	
	      //creates shape
	      if (shape === "line") {
	        helper.d3_drawShapes(shape, shapes, 0, shapeWidth);
	        shapes.attr("stroke-width", type.feature);
	      } else {
	        helper.d3_drawShapes(shape, shapes, type.feature, type.feature, type.feature, path);
	      }
	
	      helper.d3_addText(svg, cellEnter, type.labels, classPrefix);
	
	      // we need to merge the selection, otherwise changes in the legend (e.g. change of orientation) are applied only to the new cells and not the existing ones.
	      cell = cellEnter.merge(cell);
	
	      //sets placement
	      var text = cell.selectAll("text"),
	          shapeSize = shapes.nodes().map(function (d, i) {
	        var bbox = d.getBBox();
	        var stroke = scale(type.data[i]);
	
	        if (shape === "line" && orient === "horizontal") {
	          bbox.height = bbox.height + stroke;
	        } else if (shape === "line" && orient === "vertical") {
	          bbox.width = bbox.width;
	        }
	
	        return bbox;
	      });
	
	      var maxH = d3Array.max(shapeSize, function (d) {
	        return d.height + d.y;
	      }),
	          maxW = d3Array.max(shapeSize, function (d) {
	        return d.width + d.x;
	      });
	
	      var cellTrans,
	          textTrans,
	          textAlign = labelAlign == "start" ? 0 : labelAlign == "middle" ? 0.5 : 1;
	
	      //positions cells and text
	      if (orient === "vertical") {
	
	        cellTrans = function cellTrans(d, i) {
	          var height = d3Array.sum(shapeSize.slice(0, i + 1), function (d) {
	            return d.height;
	          });
	          return "translate(0, " + (height + i * shapePadding) + ")";
	        };
	
	        textTrans = function textTrans(d, i) {
	          return "translate(" + (maxW + labelOffset) + "," + (shapeSize[i].y + shapeSize[i].height / 2 + 5) + ")";
	        };
	      } else if (orient === "horizontal") {
	        cellTrans = function cellTrans(d, i) {
	          var width = d3Array.sum(shapeSize.slice(0, i + 1), function (d) {
	            return d.width;
	          });
	          return "translate(" + (width + i * shapePadding) + ",0)";
	        };
	
	        textTrans = function textTrans(d, i) {
	          return "translate(" + (shapeSize[i].width * textAlign + shapeSize[i].x) + "," + (maxH + labelOffset) + ")";
	        };
	      }
	
	      helper.d3_placement(orient, cell, cellTrans, text, textTrans, labelAlign);
	      helper.d3_title(svg, title, classPrefix);
	
	      cell.transition().style("opacity", 1);
	    }
	
	    legend.scale = function (_) {
	      if (!arguments.length) return scale;
	      scale = _;
	      return legend;
	    };
	
	    legend.cells = function (_) {
	      if (!arguments.length) return cells;
	      if (_.length > 1 || _ >= 2) {
	        cells = _;
	      }
	      return legend;
	    };
	
	    legend.shape = function (_, d) {
	      if (!arguments.length) return shape;
	      if (_ == "rect" || _ == "circle" || _ == "line") {
	        shape = _;
	        path = d;
	      }
	      return legend;
	    };
	
	    legend.shapeWidth = function (_) {
	      if (!arguments.length) return shapeWidth;
	      shapeWidth = +_;
	      return legend;
	    };
	
	    legend.shapePadding = function (_) {
	      if (!arguments.length) return shapePadding;
	      shapePadding = +_;
	      return legend;
	    };
	
	    legend.labels = function (_) {
	      if (!arguments.length) return labels;
	      labels = _;
	      return legend;
	    };
	
	    legend.labelAlign = function (_) {
	      if (!arguments.length) return labelAlign;
	      if (_ == "start" || _ == "end" || _ == "middle") {
	        labelAlign = _;
	      }
	      return legend;
	    };
	
	    legend.labelFormat = function (_) {
	      if (!arguments.length) return labelFormat;
	      labelFormat = typeof _ === 'string' ? d3Format.format(_) : _;
	      return legend;
	    };
	
	    legend.labelOffset = function (_) {
	      if (!arguments.length) return labelOffset;
	      labelOffset = +_;
	      return legend;
	    };
	
	    legend.labelDelimiter = function (_) {
	      if (!arguments.length) return labelDelimiter;
	      labelDelimiter = _;
	      return legend;
	    };
	
	    legend.orient = function (_) {
	      if (!arguments.length) return orient;
	      _ = _.toLowerCase();
	      if (_ == "horizontal" || _ == "vertical") {
	        orient = _;
	      }
	      return legend;
	    };
	
	    legend.ascending = function (_) {
	      if (!arguments.length) return ascending;
	      ascending = !!_;
	      return legend;
	    };
	
	    legend.classPrefix = function (_) {
	      if (!arguments.length) return classPrefix;
	      classPrefix = _;
	      return legend;
	    };
	
	    legend.title = function (_) {
	      if (!arguments.length) return title;
	      title = _;
	      return legend;
	    };
	
	    legend.on = function () {
	      var value = legendDispatcher.on.apply(legendDispatcher, arguments);
	      return value === legendDispatcher ? legend : value;
	    };
	
	    return legend;
	  };
	
	  function symbol() {
	
	    var scale = d3Scale.scaleLinear(),
	        shape = "path",
	        shapeWidth = 15,
	        shapeHeight = 15,
	        shapeRadius = 10,
	        shapePadding = 5,
	        cells = [5],
	        labels = [],
	        classPrefix = "",
	        useClass = false,
	        title = "",
	        labelFormat = d3Format.format(".01f"),
	        labelAlign = "middle",
	        labelOffset = 10,
	        labelDelimiter = "to",
	        orient = "vertical",
	        ascending = false,
	        legendDispatcher = d3Dispatch.dispatch("cellover", "cellout", "cellclick");
	
	    function legend(svg) {
	
	      var type = helper.d3_calcType(scale, ascending, cells, labels, labelFormat, labelDelimiter),
	          legendG = svg.selectAll('g').data([scale]);
	
	      legendG.enter().append('g').attr('class', classPrefix + 'legendCells');
	
	      var cell = svg.select('.' + classPrefix + 'legendCells').selectAll("." + classPrefix + "cell").data(type.data),
	          cellEnter = cell.enter().append("g").attr("class", classPrefix + "cell"),
	          //.style("opacity", 1e-6),
	      shapeEnter = cellEnter.append(shape).attr("class", classPrefix + "swatch"),
	          shapes = svg.selectAll("g." + classPrefix + "cell " + shape);
	
	      //add event handlers
	      helper.d3_addEvents(cellEnter, legendDispatcher);
	
	      //remove old shapes
	      cell.exit().transition().style("opacity", 0).remove();
	
	      helper.d3_drawShapes(shape, shapes, shapeHeight, shapeWidth, shapeRadius, type.feature);
	      helper.d3_addText(svg, cellEnter, type.labels, classPrefix);
	
	      // we need to merge the selection, otherwise changes in the legend (e.g. change of orientation) are applied only to the new cells and not the existing ones.
	      cell = cellEnter.merge(cell);
	
	      // sets placement
	      var text = cell.selectAll("text"),
	          shapeSize = shapes.nodes().map(function (d) {
	        return d.getBBox();
	      });
	
	      var maxH = d3Array.max(shapeSize, function (d) {
	        return d.height;
	      }),
	          maxW = d3Array.max(shapeSize, function (d) {
	        return d.width;
	      });
	
	      var cellTrans,
	          textTrans,
	          textAlign = labelAlign == "start" ? 0 : labelAlign == "middle" ? 0.5 : 1;
	
	      //positions cells and text
	      if (orient === "vertical") {
	        cellTrans = function cellTrans(d, i) {
	          return "translate(0, " + i * (maxH + shapePadding) + ")";
	        };
	        textTrans = function textTrans(d, i) {
	          return "translate(" + (maxW + labelOffset) + "," + (shapeSize[i].y + shapeSize[i].height / 2 + 5) + ")";
	        };
	      } else if (orient === "horizontal") {
	        cellTrans = function cellTrans(d, i) {
	          return "translate(" + i * (maxW + shapePadding) + ",0)";
	        };
	        textTrans = function textTrans(d, i) {
	          return "translate(" + (shapeSize[i].width * textAlign + shapeSize[i].x) + "," + (maxH + labelOffset) + ")";
	        };
	      }
	
	      helper.d3_placement(orient, cell, cellTrans, text, textTrans, labelAlign);
	      helper.d3_title(svg, title, classPrefix);
	      cell.transition().style("opacity", 1);
	    }
	
	    legend.scale = function (_) {
	      if (!arguments.length) return scale;
	      scale = _;
	      return legend;
	    };
	
	    legend.cells = function (_) {
	      if (!arguments.length) return cells;
	      if (_.length > 1 || _ >= 2) {
	        cells = _;
	      }
	      return legend;
	    };
	
	    legend.shapePadding = function (_) {
	      if (!arguments.length) return shapePadding;
	      shapePadding = +_;
	      return legend;
	    };
	
	    legend.labels = function (_) {
	      if (!arguments.length) return labels;
	      labels = _;
	      return legend;
	    };
	
	    legend.labelAlign = function (_) {
	      if (!arguments.length) return labelAlign;
	      if (_ == "start" || _ == "end" || _ == "middle") {
	        labelAlign = _;
	      }
	      return legend;
	    };
	
	    legend.labelFormat = function (_) {
	      if (!arguments.length) return labelFormat;
	      labelFormat = typeof _ === 'string' ? d3Format.format(_) : _;
	      return legend;
	    };
	
	    legend.labelOffset = function (_) {
	      if (!arguments.length) return labelOffset;
	      labelOffset = +_;
	      return legend;
	    };
	
	    legend.labelDelimiter = function (_) {
	      if (!arguments.length) return labelDelimiter;
	      labelDelimiter = _;
	      return legend;
	    };
	
	    legend.orient = function (_) {
	      if (!arguments.length) return orient;
	      _ = _.toLowerCase();
	      if (_ == "horizontal" || _ == "vertical") {
	        orient = _;
	      }
	      return legend;
	    };
	
	    legend.ascending = function (_) {
	      if (!arguments.length) return ascending;
	      ascending = !!_;
	      return legend;
	    };
	
	    legend.classPrefix = function (_) {
	      if (!arguments.length) return classPrefix;
	      classPrefix = _;
	      return legend;
	    };
	
	    legend.title = function (_) {
	      if (!arguments.length) return title;
	      title = _;
	      return legend;
	    };
	
	    legend.on = function () {
	      var value = legendDispatcher.on.apply(legendDispatcher, arguments);
	      return value === legendDispatcher ? legend : value;
	    };
	
	    return legend;
	  };
	
	  var thresholdLabels = function thresholdLabels(_ref) {
	    var i = _ref.i;
	    var genLength = _ref.genLength;
	    var generatedLabels = _ref.generatedLabels;
	
	
	    if (i === 0) {
	      return generatedLabels[i].replace('NaN to', 'Less than');
	    } else if (i === genLength - 1) {
	      return 'More than ' + generatedLabels[genLength - 1].replace(' to NaN', '');
	    }
	    return generatedLabels[i];
	  };
	
	  var legendHelpers = {
	    thresholdLabels: thresholdLabels
	  };
	
	  var index = {
	    legendColor: color,
	    legendSize: size,
	    legendSymbol: symbol,
	    legendHelpers: legendHelpers
	  };
	
	  return index;
	
	}));
	//# sourceMappingURL=indexRollup.js.map


/***/ },
/* 512 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-dispatch/ Version 1.0.1. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  var noop = {value: function() {}};
	
	  function dispatch() {
	    for (var i = 0, n = arguments.length, _ = {}, t; i < n; ++i) {
	      if (!(t = arguments[i] + "") || (t in _)) throw new Error("illegal type: " + t);
	      _[t] = [];
	    }
	    return new Dispatch(_);
	  }
	
	  function Dispatch(_) {
	    this._ = _;
	  }
	
	  function parseTypenames(typenames, types) {
	    return typenames.trim().split(/^|\s+/).map(function(t) {
	      var name = "", i = t.indexOf(".");
	      if (i >= 0) name = t.slice(i + 1), t = t.slice(0, i);
	      if (t && !types.hasOwnProperty(t)) throw new Error("unknown type: " + t);
	      return {type: t, name: name};
	    });
	  }
	
	  Dispatch.prototype = dispatch.prototype = {
	    constructor: Dispatch,
	    on: function(typename, callback) {
	      var _ = this._,
	          T = parseTypenames(typename + "", _),
	          t,
	          i = -1,
	          n = T.length;
	
	      // If no callback was specified, return the callback of the given type and name.
	      if (arguments.length < 2) {
	        while (++i < n) if ((t = (typename = T[i]).type) && (t = get(_[t], typename.name))) return t;
	        return;
	      }
	
	      // If a type was specified, set the callback for the given type and name.
	      // Otherwise, if a null callback was specified, remove callbacks of the given name.
	      if (callback != null && typeof callback !== "function") throw new Error("invalid callback: " + callback);
	      while (++i < n) {
	        if (t = (typename = T[i]).type) _[t] = set(_[t], typename.name, callback);
	        else if (callback == null) for (t in _) _[t] = set(_[t], typename.name, null);
	      }
	
	      return this;
	    },
	    copy: function() {
	      var copy = {}, _ = this._;
	      for (var t in _) copy[t] = _[t].slice();
	      return new Dispatch(copy);
	    },
	    call: function(type, that) {
	      if ((n = arguments.length - 2) > 0) for (var args = new Array(n), i = 0, n, t; i < n; ++i) args[i] = arguments[i + 2];
	      if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	      for (t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	    },
	    apply: function(type, that, args) {
	      if (!this._.hasOwnProperty(type)) throw new Error("unknown type: " + type);
	      for (var t = this._[type], i = 0, n = t.length; i < n; ++i) t[i].value.apply(that, args);
	    }
	  };
	
	  function get(type, name) {
	    for (var i = 0, n = type.length, c; i < n; ++i) {
	      if ((c = type[i]).name === name) {
	        return c.value;
	      }
	    }
	  }
	
	  function set(type, name, callback) {
	    for (var i = 0, n = type.length; i < n; ++i) {
	      if (type[i].name === name) {
	        type[i] = noop, type = type.slice(0, i).concat(type.slice(i + 1));
	        break;
	      }
	    }
	    if (callback != null) type.push({name: name, value: callback});
	    return type;
	  }
	
	  exports.dispatch = dispatch;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 513 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-format/ Version 1.0.2. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports) :
	  typeof define === 'function' && define.amd ? define(['exports'], factory) :
	  (factory((global.d3 = global.d3 || {})));
	}(this, function (exports) { 'use strict';
	
	  // Computes the decimal coefficient and exponent of the specified number x with
	  // significant digits p, where x is positive and p is in [1, 21] or undefined.
	  // For example, formatDecimal(1.23) returns ["123", 0].
	  function formatDecimal(x, p) {
	    if ((i = (x = p ? x.toExponential(p - 1) : x.toExponential()).indexOf("e")) < 0) return null; // NaN, ±Infinity
	    var i, coefficient = x.slice(0, i);
	
	    // The string returned by toExponential either has the form \d\.\d+e[-+]\d+
	    // (e.g., 1.2e+3) or the form \de[-+]\d+ (e.g., 1e+3).
	    return [
	      coefficient.length > 1 ? coefficient[0] + coefficient.slice(2) : coefficient,
	      +x.slice(i + 1)
	    ];
	  }
	
	  function exponent(x) {
	    return x = formatDecimal(Math.abs(x)), x ? x[1] : NaN;
	  }
	
	  function formatGroup(grouping, thousands) {
	    return function(value, width) {
	      var i = value.length,
	          t = [],
	          j = 0,
	          g = grouping[0],
	          length = 0;
	
	      while (i > 0 && g > 0) {
	        if (length + g + 1 > width) g = Math.max(1, width - length);
	        t.push(value.substring(i -= g, i + g));
	        if ((length += g + 1) > width) break;
	        g = grouping[j = (j + 1) % grouping.length];
	      }
	
	      return t.reverse().join(thousands);
	    };
	  }
	
	  function formatDefault(x, p) {
	    x = x.toPrecision(p);
	
	    out: for (var n = x.length, i = 1, i0 = -1, i1; i < n; ++i) {
	      switch (x[i]) {
	        case ".": i0 = i1 = i; break;
	        case "0": if (i0 === 0) i0 = i; i1 = i; break;
	        case "e": break out;
	        default: if (i0 > 0) i0 = 0; break;
	      }
	    }
	
	    return i0 > 0 ? x.slice(0, i0) + x.slice(i1 + 1) : x;
	  }
	
	  var prefixExponent;
	
	  function formatPrefixAuto(x, p) {
	    var d = formatDecimal(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1],
	        i = exponent - (prefixExponent = Math.max(-8, Math.min(8, Math.floor(exponent / 3))) * 3) + 1,
	        n = coefficient.length;
	    return i === n ? coefficient
	        : i > n ? coefficient + new Array(i - n + 1).join("0")
	        : i > 0 ? coefficient.slice(0, i) + "." + coefficient.slice(i)
	        : "0." + new Array(1 - i).join("0") + formatDecimal(x, Math.max(0, p + i - 1))[0]; // less than 1y!
	  }
	
	  function formatRounded(x, p) {
	    var d = formatDecimal(x, p);
	    if (!d) return x + "";
	    var coefficient = d[0],
	        exponent = d[1];
	    return exponent < 0 ? "0." + new Array(-exponent).join("0") + coefficient
	        : coefficient.length > exponent + 1 ? coefficient.slice(0, exponent + 1) + "." + coefficient.slice(exponent + 1)
	        : coefficient + new Array(exponent - coefficient.length + 2).join("0");
	  }
	
	  var formatTypes = {
	    "": formatDefault,
	    "%": function(x, p) { return (x * 100).toFixed(p); },
	    "b": function(x) { return Math.round(x).toString(2); },
	    "c": function(x) { return x + ""; },
	    "d": function(x) { return Math.round(x).toString(10); },
	    "e": function(x, p) { return x.toExponential(p); },
	    "f": function(x, p) { return x.toFixed(p); },
	    "g": function(x, p) { return x.toPrecision(p); },
	    "o": function(x) { return Math.round(x).toString(8); },
	    "p": function(x, p) { return formatRounded(x * 100, p); },
	    "r": formatRounded,
	    "s": formatPrefixAuto,
	    "X": function(x) { return Math.round(x).toString(16).toUpperCase(); },
	    "x": function(x) { return Math.round(x).toString(16); }
	  };
	
	  // [[fill]align][sign][symbol][0][width][,][.precision][type]
	  var re = /^(?:(.)?([<>=^]))?([+\-\( ])?([$#])?(0)?(\d+)?(,)?(\.\d+)?([a-z%])?$/i;
	
	  function formatSpecifier(specifier) {
	    return new FormatSpecifier(specifier);
	  }
	
	  function FormatSpecifier(specifier) {
	    if (!(match = re.exec(specifier))) throw new Error("invalid format: " + specifier);
	
	    var match,
	        fill = match[1] || " ",
	        align = match[2] || ">",
	        sign = match[3] || "-",
	        symbol = match[4] || "",
	        zero = !!match[5],
	        width = match[6] && +match[6],
	        comma = !!match[7],
	        precision = match[8] && +match[8].slice(1),
	        type = match[9] || "";
	
	    // The "n" type is an alias for ",g".
	    if (type === "n") comma = true, type = "g";
	
	    // Map invalid types to the default format.
	    else if (!formatTypes[type]) type = "";
	
	    // If zero fill is specified, padding goes after sign and before digits.
	    if (zero || (fill === "0" && align === "=")) zero = true, fill = "0", align = "=";
	
	    this.fill = fill;
	    this.align = align;
	    this.sign = sign;
	    this.symbol = symbol;
	    this.zero = zero;
	    this.width = width;
	    this.comma = comma;
	    this.precision = precision;
	    this.type = type;
	  }
	
	  FormatSpecifier.prototype.toString = function() {
	    return this.fill
	        + this.align
	        + this.sign
	        + this.symbol
	        + (this.zero ? "0" : "")
	        + (this.width == null ? "" : Math.max(1, this.width | 0))
	        + (this.comma ? "," : "")
	        + (this.precision == null ? "" : "." + Math.max(0, this.precision | 0))
	        + this.type;
	  };
	
	  var prefixes = ["y","z","a","f","p","n","µ","m","","k","M","G","T","P","E","Z","Y"];
	
	  function identity(x) {
	    return x;
	  }
	
	  function formatLocale(locale) {
	    var group = locale.grouping && locale.thousands ? formatGroup(locale.grouping, locale.thousands) : identity,
	        currency = locale.currency,
	        decimal = locale.decimal;
	
	    function newFormat(specifier) {
	      specifier = formatSpecifier(specifier);
	
	      var fill = specifier.fill,
	          align = specifier.align,
	          sign = specifier.sign,
	          symbol = specifier.symbol,
	          zero = specifier.zero,
	          width = specifier.width,
	          comma = specifier.comma,
	          precision = specifier.precision,
	          type = specifier.type;
	
	      // Compute the prefix and suffix.
	      // For SI-prefix, the suffix is lazily computed.
	      var prefix = symbol === "$" ? currency[0] : symbol === "#" && /[boxX]/.test(type) ? "0" + type.toLowerCase() : "",
	          suffix = symbol === "$" ? currency[1] : /[%p]/.test(type) ? "%" : "";
	
	      // What format function should we use?
	      // Is this an integer type?
	      // Can this type generate exponential notation?
	      var formatType = formatTypes[type],
	          maybeSuffix = !type || /[defgprs%]/.test(type);
	
	      // Set the default precision if not specified,
	      // or clamp the specified precision to the supported range.
	      // For significant precision, it must be in [1, 21].
	      // For fixed precision, it must be in [0, 20].
	      precision = precision == null ? (type ? 6 : 12)
	          : /[gprs]/.test(type) ? Math.max(1, Math.min(21, precision))
	          : Math.max(0, Math.min(20, precision));
	
	      function format(value) {
	        var valuePrefix = prefix,
	            valueSuffix = suffix,
	            i, n, c;
	
	        if (type === "c") {
	          valueSuffix = formatType(value) + valueSuffix;
	          value = "";
	        } else {
	          value = +value;
	
	          // Convert negative to positive, and compute the prefix.
	          // Note that -0 is not less than 0, but 1 / -0 is!
	          var valueNegative = (value < 0 || 1 / value < 0) && (value *= -1, true);
	
	          // Perform the initial formatting.
	          value = formatType(value, precision);
	
	          // If the original value was negative, it may be rounded to zero during
	          // formatting; treat this as (positive) zero.
	          if (valueNegative) {
	            i = -1, n = value.length;
	            valueNegative = false;
	            while (++i < n) {
	              if (c = value.charCodeAt(i), (48 < c && c < 58)
	                  || (type === "x" && 96 < c && c < 103)
	                  || (type === "X" && 64 < c && c < 71)) {
	                valueNegative = true;
	                break;
	              }
	            }
	          }
	
	          // Compute the prefix and suffix.
	          valuePrefix = (valueNegative ? (sign === "(" ? sign : "-") : sign === "-" || sign === "(" ? "" : sign) + valuePrefix;
	          valueSuffix = valueSuffix + (type === "s" ? prefixes[8 + prefixExponent / 3] : "") + (valueNegative && sign === "(" ? ")" : "");
	
	          // Break the formatted value into the integer “value” part that can be
	          // grouped, and fractional or exponential “suffix” part that is not.
	          if (maybeSuffix) {
	            i = -1, n = value.length;
	            while (++i < n) {
	              if (c = value.charCodeAt(i), 48 > c || c > 57) {
	                valueSuffix = (c === 46 ? decimal + value.slice(i + 1) : value.slice(i)) + valueSuffix;
	                value = value.slice(0, i);
	                break;
	              }
	            }
	          }
	        }
	
	        // If the fill character is not "0", grouping is applied before padding.
	        if (comma && !zero) value = group(value, Infinity);
	
	        // Compute the padding.
	        var length = valuePrefix.length + value.length + valueSuffix.length,
	            padding = length < width ? new Array(width - length + 1).join(fill) : "";
	
	        // If the fill character is "0", grouping is applied after padding.
	        if (comma && zero) value = group(padding + value, padding.length ? width - valueSuffix.length : Infinity), padding = "";
	
	        // Reconstruct the final output based on the desired alignment.
	        switch (align) {
	          case "<": return valuePrefix + value + valueSuffix + padding;
	          case "=": return valuePrefix + padding + value + valueSuffix;
	          case "^": return padding.slice(0, length = padding.length >> 1) + valuePrefix + value + valueSuffix + padding.slice(length);
	        }
	        return padding + valuePrefix + value + valueSuffix;
	      }
	
	      format.toString = function() {
	        return specifier + "";
	      };
	
	      return format;
	    }
	
	    function formatPrefix(specifier, value) {
	      var f = newFormat((specifier = formatSpecifier(specifier), specifier.type = "f", specifier)),
	          e = Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3,
	          k = Math.pow(10, -e),
	          prefix = prefixes[8 + e / 3];
	      return function(value) {
	        return f(k * value) + prefix;
	      };
	    }
	
	    return {
	      format: newFormat,
	      formatPrefix: formatPrefix
	    };
	  }
	
	  var locale;
	  defaultLocale({
	    decimal: ".",
	    thousands: ",",
	    grouping: [3],
	    currency: ["$", ""]
	  });
	
	  function defaultLocale(definition) {
	    locale = formatLocale(definition);
	    exports.format = locale.format;
	    exports.formatPrefix = locale.formatPrefix;
	    return locale;
	  }
	
	  function precisionFixed(step) {
	    return Math.max(0, -exponent(Math.abs(step)));
	  }
	
	  function precisionPrefix(step, value) {
	    return Math.max(0, Math.max(-8, Math.min(8, Math.floor(exponent(value) / 3))) * 3 - exponent(Math.abs(step)));
	  }
	
	  function precisionRound(step, max) {
	    step = Math.abs(step), max = Math.abs(max) - step;
	    return Math.max(0, exponent(max) - exponent(step)) + 1;
	  }
	
	  exports.formatDefaultLocale = defaultLocale;
	  exports.formatLocale = formatLocale;
	  exports.formatSpecifier = formatSpecifier;
	  exports.precisionFixed = precisionFixed;
	  exports.precisionPrefix = precisionPrefix;
	  exports.precisionRound = precisionRound;
	
	  Object.defineProperty(exports, '__esModule', { value: true });
	
	}));

/***/ },
/* 514 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-time-format/ v2.2.3 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports, __webpack_require__(176)) :
	typeof define === 'function' && define.amd ? define(['exports', 'd3-time'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}, global.d3));
	}(this, function (exports, d3Time) { 'use strict';
	
	function localDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(-1, d.m, d.d, d.H, d.M, d.S, d.L);
	    date.setFullYear(d.y);
	    return date;
	  }
	  return new Date(d.y, d.m, d.d, d.H, d.M, d.S, d.L);
	}
	
	function utcDate(d) {
	  if (0 <= d.y && d.y < 100) {
	    var date = new Date(Date.UTC(-1, d.m, d.d, d.H, d.M, d.S, d.L));
	    date.setUTCFullYear(d.y);
	    return date;
	  }
	  return new Date(Date.UTC(d.y, d.m, d.d, d.H, d.M, d.S, d.L));
	}
	
	function newDate(y, m, d) {
	  return {y: y, m: m, d: d, H: 0, M: 0, S: 0, L: 0};
	}
	
	function formatLocale(locale) {
	  var locale_dateTime = locale.dateTime,
	      locale_date = locale.date,
	      locale_time = locale.time,
	      locale_periods = locale.periods,
	      locale_weekdays = locale.days,
	      locale_shortWeekdays = locale.shortDays,
	      locale_months = locale.months,
	      locale_shortMonths = locale.shortMonths;
	
	  var periodRe = formatRe(locale_periods),
	      periodLookup = formatLookup(locale_periods),
	      weekdayRe = formatRe(locale_weekdays),
	      weekdayLookup = formatLookup(locale_weekdays),
	      shortWeekdayRe = formatRe(locale_shortWeekdays),
	      shortWeekdayLookup = formatLookup(locale_shortWeekdays),
	      monthRe = formatRe(locale_months),
	      monthLookup = formatLookup(locale_months),
	      shortMonthRe = formatRe(locale_shortMonths),
	      shortMonthLookup = formatLookup(locale_shortMonths);
	
	  var formats = {
	    "a": formatShortWeekday,
	    "A": formatWeekday,
	    "b": formatShortMonth,
	    "B": formatMonth,
	    "c": null,
	    "d": formatDayOfMonth,
	    "e": formatDayOfMonth,
	    "f": formatMicroseconds,
	    "H": formatHour24,
	    "I": formatHour12,
	    "j": formatDayOfYear,
	    "L": formatMilliseconds,
	    "m": formatMonthNumber,
	    "M": formatMinutes,
	    "p": formatPeriod,
	    "q": formatQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatSeconds,
	    "u": formatWeekdayNumberMonday,
	    "U": formatWeekNumberSunday,
	    "V": formatWeekNumberISO,
	    "w": formatWeekdayNumberSunday,
	    "W": formatWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatYear,
	    "Y": formatFullYear,
	    "Z": formatZone,
	    "%": formatLiteralPercent
	  };
	
	  var utcFormats = {
	    "a": formatUTCShortWeekday,
	    "A": formatUTCWeekday,
	    "b": formatUTCShortMonth,
	    "B": formatUTCMonth,
	    "c": null,
	    "d": formatUTCDayOfMonth,
	    "e": formatUTCDayOfMonth,
	    "f": formatUTCMicroseconds,
	    "H": formatUTCHour24,
	    "I": formatUTCHour12,
	    "j": formatUTCDayOfYear,
	    "L": formatUTCMilliseconds,
	    "m": formatUTCMonthNumber,
	    "M": formatUTCMinutes,
	    "p": formatUTCPeriod,
	    "q": formatUTCQuarter,
	    "Q": formatUnixTimestamp,
	    "s": formatUnixTimestampSeconds,
	    "S": formatUTCSeconds,
	    "u": formatUTCWeekdayNumberMonday,
	    "U": formatUTCWeekNumberSunday,
	    "V": formatUTCWeekNumberISO,
	    "w": formatUTCWeekdayNumberSunday,
	    "W": formatUTCWeekNumberMonday,
	    "x": null,
	    "X": null,
	    "y": formatUTCYear,
	    "Y": formatUTCFullYear,
	    "Z": formatUTCZone,
	    "%": formatLiteralPercent
	  };
	
	  var parses = {
	    "a": parseShortWeekday,
	    "A": parseWeekday,
	    "b": parseShortMonth,
	    "B": parseMonth,
	    "c": parseLocaleDateTime,
	    "d": parseDayOfMonth,
	    "e": parseDayOfMonth,
	    "f": parseMicroseconds,
	    "H": parseHour24,
	    "I": parseHour24,
	    "j": parseDayOfYear,
	    "L": parseMilliseconds,
	    "m": parseMonthNumber,
	    "M": parseMinutes,
	    "p": parsePeriod,
	    "q": parseQuarter,
	    "Q": parseUnixTimestamp,
	    "s": parseUnixTimestampSeconds,
	    "S": parseSeconds,
	    "u": parseWeekdayNumberMonday,
	    "U": parseWeekNumberSunday,
	    "V": parseWeekNumberISO,
	    "w": parseWeekdayNumberSunday,
	    "W": parseWeekNumberMonday,
	    "x": parseLocaleDate,
	    "X": parseLocaleTime,
	    "y": parseYear,
	    "Y": parseFullYear,
	    "Z": parseZone,
	    "%": parseLiteralPercent
	  };
	
	  // These recursive directive definitions must be deferred.
	  formats.x = newFormat(locale_date, formats);
	  formats.X = newFormat(locale_time, formats);
	  formats.c = newFormat(locale_dateTime, formats);
	  utcFormats.x = newFormat(locale_date, utcFormats);
	  utcFormats.X = newFormat(locale_time, utcFormats);
	  utcFormats.c = newFormat(locale_dateTime, utcFormats);
	
	  function newFormat(specifier, formats) {
	    return function(date) {
	      var string = [],
	          i = -1,
	          j = 0,
	          n = specifier.length,
	          c,
	          pad,
	          format;
	
	      if (!(date instanceof Date)) date = new Date(+date);
	
	      while (++i < n) {
	        if (specifier.charCodeAt(i) === 37) {
	          string.push(specifier.slice(j, i));
	          if ((pad = pads[c = specifier.charAt(++i)]) != null) c = specifier.charAt(++i);
	          else pad = c === "e" ? " " : "0";
	          if (format = formats[c]) c = format(date, pad);
	          string.push(c);
	          j = i + 1;
	        }
	      }
	
	      string.push(specifier.slice(j, i));
	      return string.join("");
	    };
	  }
	
	  function newParse(specifier, Z) {
	    return function(string) {
	      var d = newDate(1900, undefined, 1),
	          i = parseSpecifier(d, specifier, string += "", 0),
	          week, day;
	      if (i != string.length) return null;
	
	      // If a UNIX timestamp is specified, return it.
	      if ("Q" in d) return new Date(d.Q);
	      if ("s" in d) return new Date(d.s * 1000 + ("L" in d ? d.L : 0));
	
	      // If this is utcParse, never use the local timezone.
	      if (Z && !("Z" in d)) d.Z = 0;
	
	      // The am-pm flag is 0 for AM, and 1 for PM.
	      if ("p" in d) d.H = d.H % 12 + d.p * 12;
	
	      // If the month was not specified, inherit from the quarter.
	      if (d.m === undefined) d.m = "q" in d ? d.q : 0;
	
	      // Convert day-of-week and week-of-year to day-of-year.
	      if ("V" in d) {
	        if (d.V < 1 || d.V > 53) return null;
	        if (!("w" in d)) d.w = 1;
	        if ("Z" in d) {
	          week = utcDate(newDate(d.y, 0, 1)), day = week.getUTCDay();
	          week = day > 4 || day === 0 ? d3Time.utcMonday.ceil(week) : d3Time.utcMonday(week);
	          week = d3Time.utcDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getUTCFullYear();
	          d.m = week.getUTCMonth();
	          d.d = week.getUTCDate() + (d.w + 6) % 7;
	        } else {
	          week = localDate(newDate(d.y, 0, 1)), day = week.getDay();
	          week = day > 4 || day === 0 ? d3Time.timeMonday.ceil(week) : d3Time.timeMonday(week);
	          week = d3Time.timeDay.offset(week, (d.V - 1) * 7);
	          d.y = week.getFullYear();
	          d.m = week.getMonth();
	          d.d = week.getDate() + (d.w + 6) % 7;
	        }
	      } else if ("W" in d || "U" in d) {
	        if (!("w" in d)) d.w = "u" in d ? d.u % 7 : "W" in d ? 1 : 0;
	        day = "Z" in d ? utcDate(newDate(d.y, 0, 1)).getUTCDay() : localDate(newDate(d.y, 0, 1)).getDay();
	        d.m = 0;
	        d.d = "W" in d ? (d.w + 6) % 7 + d.W * 7 - (day + 5) % 7 : d.w + d.U * 7 - (day + 6) % 7;
	      }
	
	      // If a time zone is specified, all fields are interpreted as UTC and then
	      // offset according to the specified time zone.
	      if ("Z" in d) {
	        d.H += d.Z / 100 | 0;
	        d.M += d.Z % 100;
	        return utcDate(d);
	      }
	
	      // Otherwise, all fields are in local time.
	      return localDate(d);
	    };
	  }
	
	  function parseSpecifier(d, specifier, string, j) {
	    var i = 0,
	        n = specifier.length,
	        m = string.length,
	        c,
	        parse;
	
	    while (i < n) {
	      if (j >= m) return -1;
	      c = specifier.charCodeAt(i++);
	      if (c === 37) {
	        c = specifier.charAt(i++);
	        parse = parses[c in pads ? specifier.charAt(i++) : c];
	        if (!parse || ((j = parse(d, string, j)) < 0)) return -1;
	      } else if (c != string.charCodeAt(j++)) {
	        return -1;
	      }
	    }
	
	    return j;
	  }
	
	  function parsePeriod(d, string, i) {
	    var n = periodRe.exec(string.slice(i));
	    return n ? (d.p = periodLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortWeekday(d, string, i) {
	    var n = shortWeekdayRe.exec(string.slice(i));
	    return n ? (d.w = shortWeekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseWeekday(d, string, i) {
	    var n = weekdayRe.exec(string.slice(i));
	    return n ? (d.w = weekdayLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseShortMonth(d, string, i) {
	    var n = shortMonthRe.exec(string.slice(i));
	    return n ? (d.m = shortMonthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseMonth(d, string, i) {
	    var n = monthRe.exec(string.slice(i));
	    return n ? (d.m = monthLookup[n[0].toLowerCase()], i + n[0].length) : -1;
	  }
	
	  function parseLocaleDateTime(d, string, i) {
	    return parseSpecifier(d, locale_dateTime, string, i);
	  }
	
	  function parseLocaleDate(d, string, i) {
	    return parseSpecifier(d, locale_date, string, i);
	  }
	
	  function parseLocaleTime(d, string, i) {
	    return parseSpecifier(d, locale_time, string, i);
	  }
	
	  function formatShortWeekday(d) {
	    return locale_shortWeekdays[d.getDay()];
	  }
	
	  function formatWeekday(d) {
	    return locale_weekdays[d.getDay()];
	  }
	
	  function formatShortMonth(d) {
	    return locale_shortMonths[d.getMonth()];
	  }
	
	  function formatMonth(d) {
	    return locale_months[d.getMonth()];
	  }
	
	  function formatPeriod(d) {
	    return locale_periods[+(d.getHours() >= 12)];
	  }
	
	  function formatQuarter(d) {
	    return 1 + ~~(d.getMonth() / 3);
	  }
	
	  function formatUTCShortWeekday(d) {
	    return locale_shortWeekdays[d.getUTCDay()];
	  }
	
	  function formatUTCWeekday(d) {
	    return locale_weekdays[d.getUTCDay()];
	  }
	
	  function formatUTCShortMonth(d) {
	    return locale_shortMonths[d.getUTCMonth()];
	  }
	
	  function formatUTCMonth(d) {
	    return locale_months[d.getUTCMonth()];
	  }
	
	  function formatUTCPeriod(d) {
	    return locale_periods[+(d.getUTCHours() >= 12)];
	  }
	
	  function formatUTCQuarter(d) {
	    return 1 + ~~(d.getUTCMonth() / 3);
	  }
	
	  return {
	    format: function(specifier) {
	      var f = newFormat(specifier += "", formats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    parse: function(specifier) {
	      var p = newParse(specifier += "", false);
	      p.toString = function() { return specifier; };
	      return p;
	    },
	    utcFormat: function(specifier) {
	      var f = newFormat(specifier += "", utcFormats);
	      f.toString = function() { return specifier; };
	      return f;
	    },
	    utcParse: function(specifier) {
	      var p = newParse(specifier += "", true);
	      p.toString = function() { return specifier; };
	      return p;
	    }
	  };
	}
	
	var pads = {"-": "", "_": " ", "0": "0"},
	    numberRe = /^\s*\d+/, // note: ignores next directive
	    percentRe = /^%/,
	    requoteRe = /[\\^$*+?|[\]().{}]/g;
	
	function pad(value, fill, width) {
	  var sign = value < 0 ? "-" : "",
	      string = (sign ? -value : value) + "",
	      length = string.length;
	  return sign + (length < width ? new Array(width - length + 1).join(fill) + string : string);
	}
	
	function requote(s) {
	  return s.replace(requoteRe, "\\$&");
	}
	
	function formatRe(names) {
	  return new RegExp("^(?:" + names.map(requote).join("|") + ")", "i");
	}
	
	function formatLookup(names) {
	  var map = {}, i = -1, n = names.length;
	  while (++i < n) map[names[i].toLowerCase()] = i;
	  return map;
	}
	
	function parseWeekdayNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.w = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekdayNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.u = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberSunday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.U = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberISO(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.V = +n[0], i + n[0].length) : -1;
	}
	
	function parseWeekNumberMonday(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.W = +n[0], i + n[0].length) : -1;
	}
	
	function parseFullYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 4));
	  return n ? (d.y = +n[0], i + n[0].length) : -1;
	}
	
	function parseYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.y = +n[0] + (+n[0] > 68 ? 1900 : 2000), i + n[0].length) : -1;
	}
	
	function parseZone(d, string, i) {
	  var n = /^(Z)|([+-]\d\d)(?::?(\d\d))?/.exec(string.slice(i, i + 6));
	  return n ? (d.Z = n[1] ? 0 : -(n[2] + (n[3] || "00")), i + n[0].length) : -1;
	}
	
	function parseQuarter(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 1));
	  return n ? (d.q = n[0] * 3 - 3, i + n[0].length) : -1;
	}
	
	function parseMonthNumber(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.m = n[0] - 1, i + n[0].length) : -1;
	}
	
	function parseDayOfMonth(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseDayOfYear(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.m = 0, d.d = +n[0], i + n[0].length) : -1;
	}
	
	function parseHour24(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.H = +n[0], i + n[0].length) : -1;
	}
	
	function parseMinutes(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.M = +n[0], i + n[0].length) : -1;
	}
	
	function parseSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 2));
	  return n ? (d.S = +n[0], i + n[0].length) : -1;
	}
	
	function parseMilliseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 3));
	  return n ? (d.L = +n[0], i + n[0].length) : -1;
	}
	
	function parseMicroseconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i, i + 6));
	  return n ? (d.L = Math.floor(n[0] / 1000), i + n[0].length) : -1;
	}
	
	function parseLiteralPercent(d, string, i) {
	  var n = percentRe.exec(string.slice(i, i + 1));
	  return n ? i + n[0].length : -1;
	}
	
	function parseUnixTimestamp(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.Q = +n[0], i + n[0].length) : -1;
	}
	
	function parseUnixTimestampSeconds(d, string, i) {
	  var n = numberRe.exec(string.slice(i));
	  return n ? (d.s = +n[0], i + n[0].length) : -1;
	}
	
	function formatDayOfMonth(d, p) {
	  return pad(d.getDate(), p, 2);
	}
	
	function formatHour24(d, p) {
	  return pad(d.getHours(), p, 2);
	}
	
	function formatHour12(d, p) {
	  return pad(d.getHours() % 12 || 12, p, 2);
	}
	
	function formatDayOfYear(d, p) {
	  return pad(1 + d3Time.timeDay.count(d3Time.timeYear(d), d), p, 3);
	}
	
	function formatMilliseconds(d, p) {
	  return pad(d.getMilliseconds(), p, 3);
	}
	
	function formatMicroseconds(d, p) {
	  return formatMilliseconds(d, p) + "000";
	}
	
	function formatMonthNumber(d, p) {
	  return pad(d.getMonth() + 1, p, 2);
	}
	
	function formatMinutes(d, p) {
	  return pad(d.getMinutes(), p, 2);
	}
	
	function formatSeconds(d, p) {
	  return pad(d.getSeconds(), p, 2);
	}
	
	function formatWeekdayNumberMonday(d) {
	  var day = d.getDay();
	  return day === 0 ? 7 : day;
	}
	
	function formatWeekNumberSunday(d, p) {
	  return pad(d3Time.timeSunday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function formatWeekNumberISO(d, p) {
	  var day = d.getDay();
	  d = (day >= 4 || day === 0) ? d3Time.timeThursday(d) : d3Time.timeThursday.ceil(d);
	  return pad(d3Time.timeThursday.count(d3Time.timeYear(d), d) + (d3Time.timeYear(d).getDay() === 4), p, 2);
	}
	
	function formatWeekdayNumberSunday(d) {
	  return d.getDay();
	}
	
	function formatWeekNumberMonday(d, p) {
	  return pad(d3Time.timeMonday.count(d3Time.timeYear(d) - 1, d), p, 2);
	}
	
	function formatYear(d, p) {
	  return pad(d.getFullYear() % 100, p, 2);
	}
	
	function formatFullYear(d, p) {
	  return pad(d.getFullYear() % 10000, p, 4);
	}
	
	function formatZone(d) {
	  var z = d.getTimezoneOffset();
	  return (z > 0 ? "-" : (z *= -1, "+"))
	      + pad(z / 60 | 0, "0", 2)
	      + pad(z % 60, "0", 2);
	}
	
	function formatUTCDayOfMonth(d, p) {
	  return pad(d.getUTCDate(), p, 2);
	}
	
	function formatUTCHour24(d, p) {
	  return pad(d.getUTCHours(), p, 2);
	}
	
	function formatUTCHour12(d, p) {
	  return pad(d.getUTCHours() % 12 || 12, p, 2);
	}
	
	function formatUTCDayOfYear(d, p) {
	  return pad(1 + d3Time.utcDay.count(d3Time.utcYear(d), d), p, 3);
	}
	
	function formatUTCMilliseconds(d, p) {
	  return pad(d.getUTCMilliseconds(), p, 3);
	}
	
	function formatUTCMicroseconds(d, p) {
	  return formatUTCMilliseconds(d, p) + "000";
	}
	
	function formatUTCMonthNumber(d, p) {
	  return pad(d.getUTCMonth() + 1, p, 2);
	}
	
	function formatUTCMinutes(d, p) {
	  return pad(d.getUTCMinutes(), p, 2);
	}
	
	function formatUTCSeconds(d, p) {
	  return pad(d.getUTCSeconds(), p, 2);
	}
	
	function formatUTCWeekdayNumberMonday(d) {
	  var dow = d.getUTCDay();
	  return dow === 0 ? 7 : dow;
	}
	
	function formatUTCWeekNumberSunday(d, p) {
	  return pad(d3Time.utcSunday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function formatUTCWeekNumberISO(d, p) {
	  var day = d.getUTCDay();
	  d = (day >= 4 || day === 0) ? d3Time.utcThursday(d) : d3Time.utcThursday.ceil(d);
	  return pad(d3Time.utcThursday.count(d3Time.utcYear(d), d) + (d3Time.utcYear(d).getUTCDay() === 4), p, 2);
	}
	
	function formatUTCWeekdayNumberSunday(d) {
	  return d.getUTCDay();
	}
	
	function formatUTCWeekNumberMonday(d, p) {
	  return pad(d3Time.utcMonday.count(d3Time.utcYear(d) - 1, d), p, 2);
	}
	
	function formatUTCYear(d, p) {
	  return pad(d.getUTCFullYear() % 100, p, 2);
	}
	
	function formatUTCFullYear(d, p) {
	  return pad(d.getUTCFullYear() % 10000, p, 4);
	}
	
	function formatUTCZone() {
	  return "+0000";
	}
	
	function formatLiteralPercent() {
	  return "%";
	}
	
	function formatUnixTimestamp(d) {
	  return +d;
	}
	
	function formatUnixTimestampSeconds(d) {
	  return Math.floor(+d / 1000);
	}
	
	var locale;
	
	defaultLocale({
	  dateTime: "%x, %X",
	  date: "%-m/%-d/%Y",
	  time: "%-I:%M:%S %p",
	  periods: ["AM", "PM"],
	  days: ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
	  shortDays: ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
	  months: ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
	  shortMonths: ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"]
	});
	
	function defaultLocale(definition) {
	  locale = formatLocale(definition);
	  exports.timeFormat = locale.format;
	  exports.timeParse = locale.parse;
	  exports.utcFormat = locale.utcFormat;
	  exports.utcParse = locale.utcParse;
	  return locale;
	}
	
	var isoSpecifier = "%Y-%m-%dT%H:%M:%S.%LZ";
	
	function formatIsoNative(date) {
	  return date.toISOString();
	}
	
	var formatIso = Date.prototype.toISOString
	    ? formatIsoNative
	    : exports.utcFormat(isoSpecifier);
	
	function parseIsoNative(string) {
	  var date = new Date(string);
	  return isNaN(date) ? null : date;
	}
	
	var parseIso = +new Date("2000-01-01T00:00:00.000Z")
	    ? parseIsoNative
	    : exports.utcParse(isoSpecifier);
	
	exports.isoFormat = formatIso;
	exports.isoParse = parseIso;
	exports.timeFormatDefaultLocale = defaultLocale;
	exports.timeFormatLocale = formatLocale;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 515 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-timer/ v1.0.10 Copyright 2019 Mike Bostock
	(function (global, factory) {
	 true ? factory(exports) :
	typeof define === 'function' && define.amd ? define(['exports'], factory) :
	(global = global || self, factory(global.d3 = global.d3 || {}));
	}(this, function (exports) { 'use strict';
	
	var frame = 0, // is an animation frame pending?
	    timeout = 0, // is a timeout pending?
	    interval = 0, // are any timers active?
	    pokeDelay = 1000, // how frequently we check for clock skew
	    taskHead,
	    taskTail,
	    clockLast = 0,
	    clockNow = 0,
	    clockSkew = 0,
	    clock = typeof performance === "object" && performance.now ? performance : Date,
	    setFrame = typeof window === "object" && window.requestAnimationFrame ? window.requestAnimationFrame.bind(window) : function(f) { setTimeout(f, 17); };
	
	function now() {
	  return clockNow || (setFrame(clearNow), clockNow = clock.now() + clockSkew);
	}
	
	function clearNow() {
	  clockNow = 0;
	}
	
	function Timer() {
	  this._call =
	  this._time =
	  this._next = null;
	}
	
	Timer.prototype = timer.prototype = {
	  constructor: Timer,
	  restart: function(callback, delay, time) {
	    if (typeof callback !== "function") throw new TypeError("callback is not a function");
	    time = (time == null ? now() : +time) + (delay == null ? 0 : +delay);
	    if (!this._next && taskTail !== this) {
	      if (taskTail) taskTail._next = this;
	      else taskHead = this;
	      taskTail = this;
	    }
	    this._call = callback;
	    this._time = time;
	    sleep();
	  },
	  stop: function() {
	    if (this._call) {
	      this._call = null;
	      this._time = Infinity;
	      sleep();
	    }
	  }
	};
	
	function timer(callback, delay, time) {
	  var t = new Timer;
	  t.restart(callback, delay, time);
	  return t;
	}
	
	function timerFlush() {
	  now(); // Get the current time, if not already set.
	  ++frame; // Pretend we’ve set an alarm, if we haven’t already.
	  var t = taskHead, e;
	  while (t) {
	    if ((e = clockNow - t._time) >= 0) t._call.call(null, e);
	    t = t._next;
	  }
	  --frame;
	}
	
	function wake() {
	  clockNow = (clockLast = clock.now()) + clockSkew;
	  frame = timeout = 0;
	  try {
	    timerFlush();
	  } finally {
	    frame = 0;
	    nap();
	    clockNow = 0;
	  }
	}
	
	function poke() {
	  var now = clock.now(), delay = now - clockLast;
	  if (delay > pokeDelay) clockSkew -= delay, clockLast = now;
	}
	
	function nap() {
	  var t0, t1 = taskHead, t2, time = Infinity;
	  while (t1) {
	    if (t1._call) {
	      if (time > t1._time) time = t1._time;
	      t0 = t1, t1 = t1._next;
	    } else {
	      t2 = t1._next, t1._next = null;
	      t1 = t0 ? t0._next = t2 : taskHead = t2;
	    }
	  }
	  taskTail = t0;
	  sleep(time);
	}
	
	function sleep(time) {
	  if (frame) return; // Soonest alarm already set, or will be.
	  if (timeout) timeout = clearTimeout(timeout);
	  var delay = time - clockNow; // Strictly less than if we recomputed clockNow.
	  if (delay > 24) {
	    if (time < Infinity) timeout = setTimeout(wake, time - clock.now() - clockSkew);
	    if (interval) interval = clearInterval(interval);
	  } else {
	    if (!interval) clockLast = clock.now(), interval = setInterval(poke, pokeDelay);
	    frame = 1, setFrame(wake);
	  }
	}
	
	function timeout$1(callback, delay, time) {
	  var t = new Timer;
	  delay = delay == null ? 0 : +delay;
	  t.restart(function(elapsed) {
	    t.stop();
	    callback(elapsed + delay);
	  }, delay, time);
	  return t;
	}
	
	function interval$1(callback, delay, time) {
	  var t = new Timer, total = delay;
	  if (delay == null) return t.restart(callback, delay, time), t;
	  delay = +delay, time = time == null ? now() : +time;
	  t.restart(function tick(elapsed) {
	    elapsed += total;
	    t.restart(tick, total += delay, time);
	    callback(elapsed);
	  }, delay, time);
	  return t;
	}
	
	exports.interval = interval$1;
	exports.now = now;
	exports.timeout = timeout$1;
	exports.timer = timer;
	exports.timerFlush = timerFlush;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	}));


/***/ },
/* 516 */
/***/ function(module, exports, __webpack_require__) {

	// https://d3js.org/d3-transition/ Version 1.0.3. Copyright 2016 Mike Bostock.
	(function (global, factory) {
	   true ? factory(exports, __webpack_require__(99), __webpack_require__(505), __webpack_require__(515), __webpack_require__(98), __webpack_require__(70), __webpack_require__(507)) :
	  typeof define === 'function' && define.amd ? define(['exports', 'd3-selection', 'd3-dispatch', 'd3-timer', 'd3-interpolate', 'd3-color', 'd3-ease'], factory) :
	  (factory((global.d3 = global.d3 || {}),global.d3,global.d3,global.d3,global.d3,global.d3,global.d3));
	}(this, (function (exports,d3Selection,d3Dispatch,d3Timer,d3Interpolate,d3Color,d3Ease) { 'use strict';
	
	var emptyOn = d3Dispatch.dispatch("start", "end", "interrupt");
	var emptyTween = [];
	
	var CREATED = 0;
	var SCHEDULED = 1;
	var STARTING = 2;
	var STARTED = 3;
	var RUNNING = 4;
	var ENDING = 5;
	var ENDED = 6;
	
	var schedule = function(node, name, id, index, group, timing) {
	  var schedules = node.__transition;
	  if (!schedules) node.__transition = {};
	  else if (id in schedules) return;
	  create(node, id, {
	    name: name,
	    index: index, // For context during callback.
	    group: group, // For context during callback.
	    on: emptyOn,
	    tween: emptyTween,
	    time: timing.time,
	    delay: timing.delay,
	    duration: timing.duration,
	    ease: timing.ease,
	    timer: null,
	    state: CREATED
	  });
	};
	
	function init(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id]) || schedule.state > CREATED) throw new Error("too late");
	  return schedule;
	}
	
	function set(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id]) || schedule.state > STARTING) throw new Error("too late");
	  return schedule;
	}
	
	function get(node, id) {
	  var schedule = node.__transition;
	  if (!schedule || !(schedule = schedule[id])) throw new Error("too late");
	  return schedule;
	}
	
	function create(node, id, self) {
	  var schedules = node.__transition,
	      tween;
	
	  // Initialize the self timer when the transition is created.
	  // Note the actual delay is not known until the first callback!
	  schedules[id] = self;
	  self.timer = d3Timer.timer(schedule, 0, self.time);
	
	  function schedule(elapsed) {
	    self.state = SCHEDULED;
	    self.timer.restart(start, self.delay, self.time);
	
	    // If the elapsed delay is less than our first sleep, start immediately.
	    if (self.delay <= elapsed) start(elapsed - self.delay);
	  }
	
	  function start(elapsed) {
	    var i, j, n, o;
	
	    // If the state is not SCHEDULED, then we previously errored on start.
	    if (self.state !== SCHEDULED) return stop();
	
	    for (i in schedules) {
	      o = schedules[i];
	      if (o.name !== self.name) continue;
	
	      // While this element already has a starting transition during this frame,
	      // defer starting an interrupting transition until that transition has a
	      // chance to tick (and possibly end); see d3/d3-transition#54!
	      if (o.state === STARTED) return d3Timer.timeout(start);
	
	      // Interrupt the active transition, if any.
	      // Dispatch the interrupt event.
	      if (o.state === RUNNING) {
	        o.state = ENDED;
	        o.timer.stop();
	        o.on.call("interrupt", node, node.__data__, o.index, o.group);
	        delete schedules[i];
	      }
	
	      // Cancel any pre-empted transitions. No interrupt event is dispatched
	      // because the cancelled transitions never started. Note that this also
	      // removes this transition from the pending list!
	      else if (+i < id) {
	        o.state = ENDED;
	        o.timer.stop();
	        delete schedules[i];
	      }
	    }
	
	    // Defer the first tick to end of the current frame; see d3/d3#1576.
	    // Note the transition may be canceled after start and before the first tick!
	    // Note this must be scheduled before the start event; see d3/d3-transition#16!
	    // Assuming this is successful, subsequent callbacks go straight to tick.
	    d3Timer.timeout(function() {
	      if (self.state === STARTED) {
	        self.state = RUNNING;
	        self.timer.restart(tick, self.delay, self.time);
	        tick(elapsed);
	      }
	    });
	
	    // Dispatch the start event.
	    // Note this must be done before the tween are initialized.
	    self.state = STARTING;
	    self.on.call("start", node, node.__data__, self.index, self.group);
	    if (self.state !== STARTING) return; // interrupted
	    self.state = STARTED;
	
	    // Initialize the tween, deleting null tween.
	    tween = new Array(n = self.tween.length);
	    for (i = 0, j = -1; i < n; ++i) {
	      if (o = self.tween[i].value.call(node, node.__data__, self.index, self.group)) {
	        tween[++j] = o;
	      }
	    }
	    tween.length = j + 1;
	  }
	
	  function tick(elapsed) {
	    var t = elapsed < self.duration ? self.ease.call(null, elapsed / self.duration) : (self.timer.restart(stop), self.state = ENDING, 1),
	        i = -1,
	        n = tween.length;
	
	    while (++i < n) {
	      tween[i].call(null, t);
	    }
	
	    // Dispatch the end event.
	    if (self.state === ENDING) {
	      self.on.call("end", node, node.__data__, self.index, self.group);
	      stop();
	    }
	  }
	
	  function stop() {
	    self.state = ENDED;
	    self.timer.stop();
	    delete schedules[id];
	    for (var i in schedules) return; // eslint-disable-line no-unused-vars
	    delete node.__transition;
	  }
	}
	
	var interrupt = function(node, name) {
	  var schedules = node.__transition,
	      schedule,
	      active,
	      empty = true,
	      i;
	
	  if (!schedules) return;
	
	  name = name == null ? null : name + "";
	
	  for (i in schedules) {
	    if ((schedule = schedules[i]).name !== name) { empty = false; continue; }
	    active = schedule.state > STARTING && schedule.state < ENDING;
	    schedule.state = ENDED;
	    schedule.timer.stop();
	    if (active) schedule.on.call("interrupt", node, node.__data__, schedule.index, schedule.group);
	    delete schedules[i];
	  }
	
	  if (empty) delete node.__transition;
	};
	
	var selection_interrupt = function(name) {
	  return this.each(function() {
	    interrupt(this, name);
	  });
	};
	
	function tweenRemove(id, name) {
	  var tween0, tween1;
	  return function() {
	    var schedule = set(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = tween0 = tween;
	      for (var i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1 = tween1.slice();
	          tween1.splice(i, 1);
	          break;
	        }
	      }
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	function tweenFunction(id, name, value) {
	  var tween0, tween1;
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    var schedule = set(this, id),
	        tween = schedule.tween;
	
	    // If this node shared tween with the previous node,
	    // just assign the updated shared tween and we’re done!
	    // Otherwise, copy-on-write.
	    if (tween !== tween0) {
	      tween1 = (tween0 = tween).slice();
	      for (var t = {name: name, value: value}, i = 0, n = tween1.length; i < n; ++i) {
	        if (tween1[i].name === name) {
	          tween1[i] = t;
	          break;
	        }
	      }
	      if (i === n) tween1.push(t);
	    }
	
	    schedule.tween = tween1;
	  };
	}
	
	var transition_tween = function(name, value) {
	  var id = this._id;
	
	  name += "";
	
	  if (arguments.length < 2) {
	    var tween = get(this.node(), id).tween;
	    for (var i = 0, n = tween.length, t; i < n; ++i) {
	      if ((t = tween[i]).name === name) {
	        return t.value;
	      }
	    }
	    return null;
	  }
	
	  return this.each((value == null ? tweenRemove : tweenFunction)(id, name, value));
	};
	
	function tweenValue(transition, name, value) {
	  var id = transition._id;
	
	  transition.each(function() {
	    var schedule = set(this, id);
	    (schedule.value || (schedule.value = {}))[name] = value.apply(this, arguments);
	  });
	
	  return function(node) {
	    return get(node, id).value[name];
	  };
	}
	
	var interpolate = function(a, b) {
	  var c;
	  return (typeof b === "number" ? d3Interpolate.interpolateNumber
	      : b instanceof d3Color.color ? d3Interpolate.interpolateRgb
	      : (c = d3Color.color(b)) ? (b = c, d3Interpolate.interpolateRgb)
	      : d3Interpolate.interpolateString)(a, b);
	};
	
	function attrRemove(name) {
	  return function() {
	    this.removeAttribute(name);
	  };
	}
	
	function attrRemoveNS(fullname) {
	  return function() {
	    this.removeAttributeNS(fullname.space, fullname.local);
	  };
	}
	
	function attrConstant(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrConstantNS(fullname, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function attrFunction(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttribute(name);
	    value0 = this.getAttribute(name);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function attrFunctionNS(fullname, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var value0, value1 = value(this);
	    if (value1 == null) return void this.removeAttributeNS(fullname.space, fullname.local);
	    value0 = this.getAttributeNS(fullname.space, fullname.local);
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_attr = function(name, value) {
	  var fullname = d3Selection.namespace(name), i = fullname === "transform" ? d3Interpolate.interpolateTransformSvg : interpolate;
	  return this.attrTween(name, typeof value === "function"
	      ? (fullname.local ? attrFunctionNS : attrFunction)(fullname, i, tweenValue(this, "attr." + name, value))
	      : value == null ? (fullname.local ? attrRemoveNS : attrRemove)(fullname)
	      : (fullname.local ? attrConstantNS : attrConstant)(fullname, i, value));
	};
	
	function attrTweenNS(fullname, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttributeNS(fullname.space, fullname.local, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	function attrTween(name, value) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.setAttribute(name, i(t));
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_attrTween = function(name, value) {
	  var key = "attr." + name;
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  var fullname = d3Selection.namespace(name);
	  return this.tween(key, (fullname.local ? attrTweenNS : attrTween)(fullname, value));
	};
	
	function delayFunction(id, value) {
	  return function() {
	    init(this, id).delay = +value.apply(this, arguments);
	  };
	}
	
	function delayConstant(id, value) {
	  return value = +value, function() {
	    init(this, id).delay = value;
	  };
	}
	
	var transition_delay = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? delayFunction
	          : delayConstant)(id, value))
	      : get(this.node(), id).delay;
	};
	
	function durationFunction(id, value) {
	  return function() {
	    set(this, id).duration = +value.apply(this, arguments);
	  };
	}
	
	function durationConstant(id, value) {
	  return value = +value, function() {
	    set(this, id).duration = value;
	  };
	}
	
	var transition_duration = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each((typeof value === "function"
	          ? durationFunction
	          : durationConstant)(id, value))
	      : get(this.node(), id).duration;
	};
	
	function easeConstant(id, value) {
	  if (typeof value !== "function") throw new Error;
	  return function() {
	    set(this, id).ease = value;
	  };
	}
	
	var transition_ease = function(value) {
	  var id = this._id;
	
	  return arguments.length
	      ? this.each(easeConstant(id, value))
	      : get(this.node(), id).ease;
	};
	
	var transition_filter = function(match) {
	  if (typeof match !== "function") match = d3Selection.matcher(match);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = [], node, i = 0; i < n; ++i) {
	      if ((node = group[i]) && match.call(node, node.__data__, i, group)) {
	        subgroup.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, this._name, this._id);
	};
	
	var transition_merge = function(transition) {
	  if (transition._id !== this._id) throw new Error;
	
	  for (var groups0 = this._groups, groups1 = transition._groups, m0 = groups0.length, m1 = groups1.length, m = Math.min(m0, m1), merges = new Array(m0), j = 0; j < m; ++j) {
	    for (var group0 = groups0[j], group1 = groups1[j], n = group0.length, merge = merges[j] = new Array(n), node, i = 0; i < n; ++i) {
	      if (node = group0[i] || group1[i]) {
	        merge[i] = node;
	      }
	    }
	  }
	
	  for (; j < m0; ++j) {
	    merges[j] = groups0[j];
	  }
	
	  return new Transition(merges, this._parents, this._name, this._id);
	};
	
	function start(name) {
	  return (name + "").trim().split(/^|\s+/).every(function(t) {
	    var i = t.indexOf(".");
	    if (i >= 0) t = t.slice(0, i);
	    return !t || t === "start";
	  });
	}
	
	function onFunction(id, name, listener) {
	  var on0, on1, sit = start(name) ? init : set;
	  return function() {
	    var schedule = sit(this, id),
	        on = schedule.on;
	
	    // If this node shared a dispatch with the previous node,
	    // just assign the updated shared dispatch and we’re done!
	    // Otherwise, copy-on-write.
	    if (on !== on0) (on1 = (on0 = on).copy()).on(name, listener);
	
	    schedule.on = on1;
	  };
	}
	
	var transition_on = function(name, listener) {
	  var id = this._id;
	
	  return arguments.length < 2
	      ? get(this.node(), id).on.on(name)
	      : this.each(onFunction(id, name, listener));
	};
	
	function removeFunction(id) {
	  return function() {
	    var parent = this.parentNode;
	    for (var i in this.__transition) if (+i !== id) return;
	    if (parent) parent.removeChild(this);
	  };
	}
	
	var transition_remove = function() {
	  return this.on("end.remove", removeFunction(this._id));
	};
	
	var transition_select = function(select) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select !== "function") select = d3Selection.selector(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = new Array(m), j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, subgroup = subgroups[j] = new Array(n), node, subnode, i = 0; i < n; ++i) {
	      if ((node = group[i]) && (subnode = select.call(node, node.__data__, i, group))) {
	        if ("__data__" in node) subnode.__data__ = node.__data__;
	        subgroup[i] = subnode;
	        schedule(subgroup[i], name, id, i, subgroup, get(node, id));
	      }
	    }
	  }
	
	  return new Transition(subgroups, this._parents, name, id);
	};
	
	var transition_selectAll = function(select) {
	  var name = this._name,
	      id = this._id;
	
	  if (typeof select !== "function") select = d3Selection.selectorAll(select);
	
	  for (var groups = this._groups, m = groups.length, subgroups = [], parents = [], j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        for (var children = select.call(node, node.__data__, i, group), child, inherit = get(node, id), k = 0, l = children.length; k < l; ++k) {
	          if (child = children[k]) {
	            schedule(child, name, id, k, children, inherit);
	          }
	        }
	        subgroups.push(children);
	        parents.push(node);
	      }
	    }
	  }
	
	  return new Transition(subgroups, parents, name, id);
	};
	
	var Selection = d3Selection.selection.prototype.constructor;
	
	var transition_selection = function() {
	  return new Selection(this._groups, this._parents);
	};
	
	function styleRemove(name, interpolate$$1) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var style = d3Selection.window(this).getComputedStyle(this, null),
	        value0 = style.getPropertyValue(name),
	        value1 = (this.style.removeProperty(name), style.getPropertyValue(name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	function styleRemoveEnd(name) {
	  return function() {
	    this.style.removeProperty(name);
	  };
	}
	
	function styleConstant(name, interpolate$$1, value1) {
	  var value00,
	      interpolate0;
	  return function() {
	    var value0 = d3Selection.window(this).getComputedStyle(this, null).getPropertyValue(name);
	    return value0 === value1 ? null
	        : value0 === value00 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value1);
	  };
	}
	
	function styleFunction(name, interpolate$$1, value) {
	  var value00,
	      value10,
	      interpolate0;
	  return function() {
	    var style = d3Selection.window(this).getComputedStyle(this, null),
	        value0 = style.getPropertyValue(name),
	        value1 = value(this);
	    if (value1 == null) value1 = (this.style.removeProperty(name), style.getPropertyValue(name));
	    return value0 === value1 ? null
	        : value0 === value00 && value1 === value10 ? interpolate0
	        : interpolate0 = interpolate$$1(value00 = value0, value10 = value1);
	  };
	}
	
	var transition_style = function(name, value, priority) {
	  var i = (name += "") === "transform" ? d3Interpolate.interpolateTransformCss : interpolate;
	  return value == null ? this
	          .styleTween(name, styleRemove(name, i))
	          .on("end.style." + name, styleRemoveEnd(name))
	      : this.styleTween(name, typeof value === "function"
	          ? styleFunction(name, i, tweenValue(this, "style." + name, value))
	          : styleConstant(name, i, value), priority);
	};
	
	function styleTween(name, value, priority) {
	  function tween() {
	    var node = this, i = value.apply(node, arguments);
	    return i && function(t) {
	      node.style.setProperty(name, i(t), priority);
	    };
	  }
	  tween._value = value;
	  return tween;
	}
	
	var transition_styleTween = function(name, value, priority) {
	  var key = "style." + (name += "");
	  if (arguments.length < 2) return (key = this.tween(key)) && key._value;
	  if (value == null) return this.tween(key, null);
	  if (typeof value !== "function") throw new Error;
	  return this.tween(key, styleTween(name, value, priority == null ? "" : priority));
	};
	
	function textConstant(value) {
	  return function() {
	    this.textContent = value;
	  };
	}
	
	function textFunction(value) {
	  return function() {
	    var value1 = value(this);
	    this.textContent = value1 == null ? "" : value1;
	  };
	}
	
	var transition_text = function(value) {
	  return this.tween("text", typeof value === "function"
	      ? textFunction(tweenValue(this, "text", value))
	      : textConstant(value == null ? "" : value + ""));
	};
	
	var transition_transition = function() {
	  var name = this._name,
	      id0 = this._id,
	      id1 = newId();
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        var inherit = get(node, id0);
	        schedule(node, name, id1, i, group, {
	          time: inherit.time + inherit.delay + inherit.duration,
	          delay: 0,
	          duration: inherit.duration,
	          ease: inherit.ease
	        });
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id1);
	};
	
	var id = 0;
	
	function Transition(groups, parents, name, id) {
	  this._groups = groups;
	  this._parents = parents;
	  this._name = name;
	  this._id = id;
	}
	
	function transition(name) {
	  return d3Selection.selection().transition(name);
	}
	
	function newId() {
	  return ++id;
	}
	
	var selection_prototype = d3Selection.selection.prototype;
	
	Transition.prototype = transition.prototype = {
	  constructor: Transition,
	  select: transition_select,
	  selectAll: transition_selectAll,
	  filter: transition_filter,
	  merge: transition_merge,
	  selection: transition_selection,
	  transition: transition_transition,
	  call: selection_prototype.call,
	  nodes: selection_prototype.nodes,
	  node: selection_prototype.node,
	  size: selection_prototype.size,
	  empty: selection_prototype.empty,
	  each: selection_prototype.each,
	  on: transition_on,
	  attr: transition_attr,
	  attrTween: transition_attrTween,
	  style: transition_style,
	  styleTween: transition_styleTween,
	  text: transition_text,
	  remove: transition_remove,
	  tween: transition_tween,
	  delay: transition_delay,
	  duration: transition_duration,
	  ease: transition_ease
	};
	
	var defaultTiming = {
	  time: null, // Set on use.
	  delay: 0,
	  duration: 250,
	  ease: d3Ease.easeCubicInOut
	};
	
	function inherit(node, id) {
	  var timing;
	  while (!(timing = node.__transition) || !(timing = timing[id])) {
	    if (!(node = node.parentNode)) {
	      return defaultTiming.time = d3Timer.now(), defaultTiming;
	    }
	  }
	  return timing;
	}
	
	var selection_transition = function(name) {
	  var id,
	      timing;
	
	  if (name instanceof Transition) {
	    id = name._id, name = name._name;
	  } else {
	    id = newId(), (timing = defaultTiming).time = d3Timer.now(), name = name == null ? null : name + "";
	  }
	
	  for (var groups = this._groups, m = groups.length, j = 0; j < m; ++j) {
	    for (var group = groups[j], n = group.length, node, i = 0; i < n; ++i) {
	      if (node = group[i]) {
	        schedule(node, name, id, i, group, timing || inherit(node, id));
	      }
	    }
	  }
	
	  return new Transition(groups, this._parents, name, id);
	};
	
	d3Selection.selection.prototype.interrupt = selection_interrupt;
	d3Selection.selection.prototype.transition = selection_transition;
	
	var root = [null];
	
	var active = function(node, name) {
	  var schedules = node.__transition,
	      schedule,
	      i;
	
	  if (schedules) {
	    name = name == null ? null : name + "";
	    for (i in schedules) {
	      if ((schedule = schedules[i]).state > SCHEDULED && schedule.name === name) {
	        return new Transition([[node]], root, name, +i);
	      }
	    }
	  }
	
	  return null;
	};
	
	exports.transition = transition;
	exports.active = active;
	exports.interrupt = interrupt;
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	})));


/***/ },
/* 517 */
/***/ function(module, exports) {

	'use strict';
	var token = '%[a-f0-9]{2}';
	var singleMatcher = new RegExp(token, 'gi');
	var multiMatcher = new RegExp('(' + token + ')+', 'gi');
	
	function decodeComponents(components, split) {
		try {
			// Try to decode the entire string first
			return decodeURIComponent(components.join(''));
		} catch (err) {
			// Do nothing
		}
	
		if (components.length === 1) {
			return components;
		}
	
		split = split || 1;
	
		// Split the array in 2 parts
		var left = components.slice(0, split);
		var right = components.slice(split);
	
		return Array.prototype.concat.call([], decodeComponents(left), decodeComponents(right));
	}
	
	function decode(input) {
		try {
			return decodeURIComponent(input);
		} catch (err) {
			var tokens = input.match(singleMatcher);
	
			for (var i = 1; i < tokens.length; i++) {
				input = decodeComponents(tokens, i).join('');
	
				tokens = input.match(singleMatcher);
			}
	
			return input;
		}
	}
	
	function customDecodeURIComponent(input) {
		// Keep track of all the replacements and prefill the map with the `BOM`
		var replaceMap = {
			'%FE%FF': '\uFFFD\uFFFD',
			'%FF%FE': '\uFFFD\uFFFD'
		};
	
		var match = multiMatcher.exec(input);
		while (match) {
			try {
				// Decode as big chunks as possible
				replaceMap[match[0]] = decodeURIComponent(match[0]);
			} catch (err) {
				var result = decode(match[0]);
	
				if (result !== match[0]) {
					replaceMap[match[0]] = result;
				}
			}
	
			match = multiMatcher.exec(input);
		}
	
		// Add `%C2` at the end of the map to make sure it does not replace the combinator before everything else
		replaceMap['%C2'] = '\uFFFD';
	
		var entries = Object.keys(replaceMap);
	
		for (var i = 0; i < entries.length; i++) {
			// Replace all decoded components
			var key = entries[i];
			input = input.replace(new RegExp(key, 'g'), replaceMap[key]);
		}
	
		return input;
	}
	
	module.exports = function (encodedURI) {
		if (typeof encodedURI !== 'string') {
			throw new TypeError('Expected `encodedURI` to be of type `string`, got `' + typeof encodedURI + '`');
		}
	
		try {
			encodedURI = encodedURI.replace(/\+/g, ' ');
	
			// Try the built in decoder first
			return decodeURIComponent(encodedURI);
		} catch (err) {
			// Fallback to a more advanced decoder
			return customDecodeURIComponent(encodedURI);
		}
	};


/***/ },
/* 518 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	var _interopRequireDefault = __webpack_require__(521);
	
	exports.__esModule = true;
	exports.default = addClass;
	
	var _hasClass = _interopRequireDefault(__webpack_require__(519));
	
	function addClass(element, className) {
	  if (element.classList) element.classList.add(className);else if (!(0, _hasClass.default)(element, className)) if (typeof element.className === 'string') element.className = element.className + " " + className;else element.setAttribute('class', (element.className && element.className.baseVal || '') + " " + className);
	}
	
	module.exports = exports["default"];

/***/ },
/* 519 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = hasClass;
	
	function hasClass(element, className) {
	  if (element.classList) return !!className && element.classList.contains(className);
	  return (" " + (element.className.baseVal || element.className) + " ").indexOf(" " + className + " ") !== -1;
	}
	
	module.exports = exports["default"];

/***/ },
/* 520 */
/***/ function(module, exports) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = removeClass;
	
	function replaceClassName(origClass, classToRemove) {
	  return origClass.replace(new RegExp("(^|\\s)" + classToRemove + "(?:\\s|$)", 'g'), '$1').replace(/\s+/g, ' ').replace(/^\s*|\s*$/g, '');
	}
	
	function removeClass(element, className) {
	  if (element.classList) {
	    element.classList.remove(className);
	  } else if (typeof element.className === 'string') {
	    ;
	    element.className = replaceClassName(element.className, className);
	  } else {
	    element.setAttribute('class', replaceClassName(element.className && element.className.baseVal || '', className));
	  }
	}
	
	module.exports = exports["default"];

/***/ },
/* 521 */
1,
/* 522 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var has = Object.prototype.hasOwnProperty
	  , prefix = '~';
	
	/**
	 * Constructor to create a storage for our `EE` objects.
	 * An `Events` instance is a plain object whose properties are event names.
	 *
	 * @constructor
	 * @private
	 */
	function Events() {}
	
	//
	// We try to not inherit from `Object.prototype`. In some engines creating an
	// instance in this way is faster than calling `Object.create(null)` directly.
	// If `Object.create(null)` is not supported we prefix the event names with a
	// character to make sure that the built-in object properties are not
	// overridden or used as an attack vector.
	//
	if (Object.create) {
	  Events.prototype = Object.create(null);
	
	  //
	  // This hack is needed because the `__proto__` property is still inherited in
	  // some old browsers like Android 4, iPhone 5.1, Opera 11 and Safari 5.
	  //
	  if (!new Events().__proto__) prefix = false;
	}
	
	/**
	 * Representation of a single event listener.
	 *
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} [once=false] Specify if the listener is a one-time listener.
	 * @constructor
	 * @private
	 */
	function EE(fn, context, once) {
	  this.fn = fn;
	  this.context = context;
	  this.once = once || false;
	}
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} context The context to invoke the listener with.
	 * @param {Boolean} once Specify if the listener is a one-time listener.
	 * @returns {EventEmitter}
	 * @private
	 */
	function addListener(emitter, event, fn, context, once) {
	  if (typeof fn !== 'function') {
	    throw new TypeError('The listener must be a function');
	  }
	
	  var listener = new EE(fn, context || emitter, once)
	    , evt = prefix ? prefix + event : event;
	
	  if (!emitter._events[evt]) emitter._events[evt] = listener, emitter._eventsCount++;
	  else if (!emitter._events[evt].fn) emitter._events[evt].push(listener);
	  else emitter._events[evt] = [emitter._events[evt], listener];
	
	  return emitter;
	}
	
	/**
	 * Clear event by name.
	 *
	 * @param {EventEmitter} emitter Reference to the `EventEmitter` instance.
	 * @param {(String|Symbol)} evt The Event name.
	 * @private
	 */
	function clearEvent(emitter, evt) {
	  if (--emitter._eventsCount === 0) emitter._events = new Events();
	  else delete emitter._events[evt];
	}
	
	/**
	 * Minimal `EventEmitter` interface that is molded against the Node.js
	 * `EventEmitter` interface.
	 *
	 * @constructor
	 * @public
	 */
	function EventEmitter() {
	  this._events = new Events();
	  this._eventsCount = 0;
	}
	
	/**
	 * Return an array listing the events for which the emitter has registered
	 * listeners.
	 *
	 * @returns {Array}
	 * @public
	 */
	EventEmitter.prototype.eventNames = function eventNames() {
	  var names = []
	    , events
	    , name;
	
	  if (this._eventsCount === 0) return names;
	
	  for (name in (events = this._events)) {
	    if (has.call(events, name)) names.push(prefix ? name.slice(1) : name);
	  }
	
	  if (Object.getOwnPropertySymbols) {
	    return names.concat(Object.getOwnPropertySymbols(events));
	  }
	
	  return names;
	};
	
	/**
	 * Return the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Array} The registered listeners.
	 * @public
	 */
	EventEmitter.prototype.listeners = function listeners(event) {
	  var evt = prefix ? prefix + event : event
	    , handlers = this._events[evt];
	
	  if (!handlers) return [];
	  if (handlers.fn) return [handlers.fn];
	
	  for (var i = 0, l = handlers.length, ee = new Array(l); i < l; i++) {
	    ee[i] = handlers[i].fn;
	  }
	
	  return ee;
	};
	
	/**
	 * Return the number of listeners listening to a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Number} The number of listeners.
	 * @public
	 */
	EventEmitter.prototype.listenerCount = function listenerCount(event) {
	  var evt = prefix ? prefix + event : event
	    , listeners = this._events[evt];
	
	  if (!listeners) return 0;
	  if (listeners.fn) return 1;
	  return listeners.length;
	};
	
	/**
	 * Calls each of the listeners registered for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @returns {Boolean} `true` if the event had listeners, else `false`.
	 * @public
	 */
	EventEmitter.prototype.emit = function emit(event, a1, a2, a3, a4, a5) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return false;
	
	  var listeners = this._events[evt]
	    , len = arguments.length
	    , args
	    , i;
	
	  if (listeners.fn) {
	    if (listeners.once) this.removeListener(event, listeners.fn, undefined, true);
	
	    switch (len) {
	      case 1: return listeners.fn.call(listeners.context), true;
	      case 2: return listeners.fn.call(listeners.context, a1), true;
	      case 3: return listeners.fn.call(listeners.context, a1, a2), true;
	      case 4: return listeners.fn.call(listeners.context, a1, a2, a3), true;
	      case 5: return listeners.fn.call(listeners.context, a1, a2, a3, a4), true;
	      case 6: return listeners.fn.call(listeners.context, a1, a2, a3, a4, a5), true;
	    }
	
	    for (i = 1, args = new Array(len -1); i < len; i++) {
	      args[i - 1] = arguments[i];
	    }
	
	    listeners.fn.apply(listeners.context, args);
	  } else {
	    var length = listeners.length
	      , j;
	
	    for (i = 0; i < length; i++) {
	      if (listeners[i].once) this.removeListener(event, listeners[i].fn, undefined, true);
	
	      switch (len) {
	        case 1: listeners[i].fn.call(listeners[i].context); break;
	        case 2: listeners[i].fn.call(listeners[i].context, a1); break;
	        case 3: listeners[i].fn.call(listeners[i].context, a1, a2); break;
	        case 4: listeners[i].fn.call(listeners[i].context, a1, a2, a3); break;
	        default:
	          if (!args) for (j = 1, args = new Array(len -1); j < len; j++) {
	            args[j - 1] = arguments[j];
	          }
	
	          listeners[i].fn.apply(listeners[i].context, args);
	      }
	    }
	  }
	
	  return true;
	};
	
	/**
	 * Add a listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.on = function on(event, fn, context) {
	  return addListener(this, event, fn, context, false);
	};
	
	/**
	 * Add a one-time listener for a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn The listener function.
	 * @param {*} [context=this] The context to invoke the listener with.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.once = function once(event, fn, context) {
	  return addListener(this, event, fn, context, true);
	};
	
	/**
	 * Remove the listeners of a given event.
	 *
	 * @param {(String|Symbol)} event The event name.
	 * @param {Function} fn Only remove the listeners that match this function.
	 * @param {*} context Only remove the listeners that have this context.
	 * @param {Boolean} once Only remove one-time listeners.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeListener = function removeListener(event, fn, context, once) {
	  var evt = prefix ? prefix + event : event;
	
	  if (!this._events[evt]) return this;
	  if (!fn) {
	    clearEvent(this, evt);
	    return this;
	  }
	
	  var listeners = this._events[evt];
	
	  if (listeners.fn) {
	    if (
	      listeners.fn === fn &&
	      (!once || listeners.once) &&
	      (!context || listeners.context === context)
	    ) {
	      clearEvent(this, evt);
	    }
	  } else {
	    for (var i = 0, events = [], length = listeners.length; i < length; i++) {
	      if (
	        listeners[i].fn !== fn ||
	        (once && !listeners[i].once) ||
	        (context && listeners[i].context !== context)
	      ) {
	        events.push(listeners[i]);
	      }
	    }
	
	    //
	    // Reset the array, or remove it completely if we have no more listeners.
	    //
	    if (events.length) this._events[evt] = events.length === 1 ? events[0] : events;
	    else clearEvent(this, evt);
	  }
	
	  return this;
	};
	
	/**
	 * Remove all listeners, or those of the specified event.
	 *
	 * @param {(String|Symbol)} [event] The event name.
	 * @returns {EventEmitter} `this`.
	 * @public
	 */
	EventEmitter.prototype.removeAllListeners = function removeAllListeners(event) {
	  var evt;
	
	  if (event) {
	    evt = prefix ? prefix + event : event;
	    if (this._events[evt]) clearEvent(this, evt);
	  } else {
	    this._events = new Events();
	    this._eventsCount = 0;
	  }
	
	  return this;
	};
	
	//
	// Alias methods names because people roll like that.
	//
	EventEmitter.prototype.off = EventEmitter.prototype.removeListener;
	EventEmitter.prototype.addListener = EventEmitter.prototype.on;
	
	//
	// Expose the prefix.
	//
	EventEmitter.prefixed = prefix;
	
	//
	// Allow `EventEmitter` to be imported as module namespace.
	//
	EventEmitter.EventEmitter = EventEmitter;
	
	//
	// Expose the module.
	//
	if (true) {
	  module.exports = EventEmitter;
	}


/***/ },
/* 523 */
/***/ function(module, exports, __webpack_require__) {

	/*
	 * Fuzzy
	 * https://github.com/myork/fuzzy
	 *
	 * Copyright (c) 2012 Matt York
	 * Licensed under the MIT license.
	 */
	
	(function() {
	
	var root = this;
	
	var fuzzy = {};
	
	// Use in node or in browser
	if (true) {
	  module.exports = fuzzy;
	} else {
	  root.fuzzy = fuzzy;
	}
	
	// Return all elements of `array` that have a fuzzy
	// match against `pattern`.
	fuzzy.simpleFilter = function(pattern, array) {
	  return array.filter(function(str) {
	    return fuzzy.test(pattern, str);
	  });
	};
	
	// Does `pattern` fuzzy match `str`?
	fuzzy.test = function(pattern, str) {
	  return fuzzy.match(pattern, str) !== null;
	};
	
	// If `pattern` matches `str`, wrap each matching character
	// in `opts.pre` and `opts.post`. If no match, return null
	fuzzy.match = function(pattern, str, opts) {
	  opts = opts || {};
	  var patternIdx = 0
	    , result = []
	    , len = str.length
	    , totalScore = 0
	    , currScore = 0
	    // prefix
	    , pre = opts.pre || ''
	    // suffix
	    , post = opts.post || ''
	    // String to compare against. This might be a lowercase version of the
	    // raw string
	    , compareString =  opts.caseSensitive && str || str.toLowerCase()
	    , ch;
	
	  pattern = opts.caseSensitive && pattern || pattern.toLowerCase();
	
	  // For each character in the string, either add it to the result
	  // or wrap in template if it's the next string in the pattern
	  for(var idx = 0; idx < len; idx++) {
	    ch = str[idx];
	    if(compareString[idx] === pattern[patternIdx]) {
	      ch = pre + ch + post;
	      patternIdx += 1;
	
	      // consecutive characters should increase the score more than linearly
	      currScore += 1 + currScore;
	    } else {
	      currScore = 0;
	    }
	    totalScore += currScore;
	    result[result.length] = ch;
	  }
	
	  // return rendered string if we have a match for every char
	  if(patternIdx === pattern.length) {
	    // if the string is an exact match with pattern, totalScore should be maxed
	    totalScore = (compareString === pattern) ? Infinity : totalScore;
	    return {rendered: result.join(''), score: totalScore};
	  }
	
	  return null;
	};
	
	// The normal entry point. Filters `arr` for matches against `pattern`.
	// It returns an array with matching values of the type:
	//
	//     [{
	//         string:   '<b>lah' // The rendered string
	//       , index:    2        // The index of the element in `arr`
	//       , original: 'blah'   // The original element in `arr`
	//     }]
	//
	// `opts` is an optional argument bag. Details:
	//
	//    opts = {
	//        // string to put before a matching character
	//        pre:     '<b>'
	//
	//        // string to put after matching character
	//      , post:    '</b>'
	//
	//        // Optional function. Input is an entry in the given arr`,
	//        // output should be the string to test `pattern` against.
	//        // In this example, if `arr = [{crying: 'koala'}]` we would return
	//        // 'koala'.
	//      , extract: function(arg) { return arg.crying; }
	//    }
	fuzzy.filter = function(pattern, arr, opts) {
	  if(!arr || arr.length === 0) {
	    return [];
	  }
	  if (typeof pattern !== 'string') {
	    return arr;
	  }
	  opts = opts || {};
	  return arr
	    .reduce(function(prev, element, idx, arr) {
	      var str = element;
	      if(opts.extract) {
	        str = opts.extract(element);
	      }
	      var rendered = fuzzy.match(pattern, str, opts);
	      if(rendered != null) {
	        prev[prev.length] = {
	            string: rendered.rendered
	          , score: rendered.score
	          , index: idx
	          , original: element
	        };
	      }
	      return prev;
	    }, [])
	
	    // Sort by score. Browsers are inconsistent wrt stable/unstable
	    // sorting, so force stable by using the index in the case of tie.
	    // See http://ofb.net/~sethml/is-sort-stable.html
	    .sort(function(a,b) {
	      var compare = b.score - a.score;
	      if(compare) return compare;
	      return a.index - b.index;
	    });
	};
	
	
	}());
	


/***/ },
/* 524 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {// @flow
	'use strict';
	
	var key = '__global_unique_id__';
	
	module.exports = function() {
	  return global[key] = (global[key] || 0) + 1;
	};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 525 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var resolvePathname=_interopDefault(__webpack_require__(599)),valueEqual=_interopDefault(__webpack_require__(608));__webpack_require__(41);var invariant=_interopDefault(__webpack_require__(104));function _extends(){return(_extends=Object.assign||function(t){for(var n=1;n<arguments.length;n++){var e=arguments[n];for(var a in e)Object.prototype.hasOwnProperty.call(e,a)&&(t[a]=e[a])}return t}).apply(this,arguments)}function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function stripLeadingSlash(t){return"/"===t.charAt(0)?t.substr(1):t}function hasBasename(t,n){return 0===t.toLowerCase().indexOf(n.toLowerCase())&&-1!=="/?#".indexOf(t.charAt(n.length))}function stripBasename(t,n){return hasBasename(t,n)?t.substr(n.length):t}function stripTrailingSlash(t){return"/"===t.charAt(t.length-1)?t.slice(0,-1):t}function parsePath(t){var n=t||"/",e="",a="",r=n.indexOf("#");-1!==r&&(a=n.substr(r),n=n.substr(0,r));var o=n.indexOf("?");return-1!==o&&(e=n.substr(o),n=n.substr(0,o)),{pathname:n,search:"?"===e?"":e,hash:"#"===a?"":a}}function createPath(t){var n=t.pathname,e=t.search,a=t.hash,r=n||"/";return e&&"?"!==e&&(r+="?"===e.charAt(0)?e:"?"+e),a&&"#"!==a&&(r+="#"===a.charAt(0)?a:"#"+a),r}function createLocation(t,n,e,a){var r;"string"==typeof t?(r=parsePath(t)).state=n:(void 0===(r=_extends({},t)).pathname&&(r.pathname=""),r.search?"?"!==r.search.charAt(0)&&(r.search="?"+r.search):r.search="",r.hash?"#"!==r.hash.charAt(0)&&(r.hash="#"+r.hash):r.hash="",void 0!==n&&void 0===r.state&&(r.state=n));try{r.pathname=decodeURI(r.pathname)}catch(t){throw t instanceof URIError?new URIError('Pathname "'+r.pathname+'" could not be decoded. This is likely caused by an invalid percent-encoding.'):t}return e&&(r.key=e),a?r.pathname?"/"!==r.pathname.charAt(0)&&(r.pathname=resolvePathname(r.pathname,a.pathname)):r.pathname=a.pathname:r.pathname||(r.pathname="/"),r}function locationsAreEqual(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash&&t.key===n.key&&valueEqual(t.state,n.state)}function createTransitionManager(){var o=null;var a=[];return{setPrompt:function(t){return o=t,function(){o===t&&(o=null)}},confirmTransitionTo:function(t,n,e,a){if(null!=o){var r="function"==typeof o?o(t,n):o;"string"==typeof r?"function"==typeof e?e(r,a):a(!0):a(!1!==r)}else a(!0)},appendListener:function(t){var n=!0;function e(){n&&t.apply(void 0,arguments)}return a.push(e),function(){n=!1,a=a.filter(function(t){return t!==e})}},notifyListeners:function(){for(var t=arguments.length,n=new Array(t),e=0;e<t;e++)n[e]=arguments[e];a.forEach(function(t){return t.apply(void 0,n)})}}}var canUseDOM=!("undefined"==typeof window||!window.document||!window.document.createElement);function getConfirmation(t,n){n(window.confirm(t))}function supportsHistory(){var t=window.navigator.userAgent;return(-1===t.indexOf("Android 2.")&&-1===t.indexOf("Android 4.0")||-1===t.indexOf("Mobile Safari")||-1!==t.indexOf("Chrome")||-1!==t.indexOf("Windows Phone"))&&(window.history&&"pushState"in window.history)}function supportsPopStateOnHashChange(){return-1===window.navigator.userAgent.indexOf("Trident")}function supportsGoWithoutReloadUsingHash(){return-1===window.navigator.userAgent.indexOf("Firefox")}function isExtraneousPopstateEvent(t){return void 0===t.state&&-1===navigator.userAgent.indexOf("CriOS")}var PopStateEvent="popstate",HashChangeEvent="hashchange";function getHistoryState(){try{return window.history.state||{}}catch(t){return{}}}function createBrowserHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var s=window.history,c=supportsHistory(),n=!supportsPopStateOnHashChange(),e=t,a=e.forceRefresh,h=void 0!==a&&a,r=e.getUserConfirmation,u=void 0===r?getConfirmation:r,o=e.keyLength,i=void 0===o?6:o,f=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"";function l(t){var n=t||{},e=n.key,a=n.state,r=window.location,o=r.pathname+r.search+r.hash;return f&&(o=stripBasename(o,f)),createLocation(o,a,e)}function d(){return Math.random().toString(36).substr(2,i)}var v=createTransitionManager();function p(t){_extends(T,t),T.length=s.length,v.notifyListeners(T.location,T.action)}function g(t){isExtraneousPopstateEvent(t)||w(l(t.state))}function P(){w(l(getHistoryState()))}var m=!1;function w(n){if(m)m=!1,p();else{v.confirmTransitionTo(n,"POP",u,function(t){t?p({action:"POP",location:n}):function(t){var n=T.location,e=H.indexOf(n.key);-1===e&&(e=0);var a=H.indexOf(t.key);-1===a&&(a=0);var r=e-a;r&&(m=!0,L(r))}(n)})}}var y=l(getHistoryState()),H=[y.key];function x(t){return f+createPath(t)}function L(t){s.go(t)}var O=0;function E(t){1===(O+=t)&&1===t?(window.addEventListener(PopStateEvent,g),n&&window.addEventListener(HashChangeEvent,P)):0===O&&(window.removeEventListener(PopStateEvent,g),n&&window.removeEventListener(HashChangeEvent,P))}var S=!1;var T={length:s.length,action:"POP",location:y,createHref:x,push:function(t,n){var i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,"PUSH",u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.pushState({key:e,state:a},null,n),h)window.location.href=n;else{var r=H.indexOf(T.location.key),o=H.slice(0,r+1);o.push(i.key),H=o,p({action:"PUSH",location:i})}else window.location.href=n}})},replace:function(t,n){var o="REPLACE",i=createLocation(t,n,d(),T.location);v.confirmTransitionTo(i,o,u,function(t){if(t){var n=x(i),e=i.key,a=i.state;if(c)if(s.replaceState({key:e,state:a},null,n),h)window.location.replace(n);else{var r=H.indexOf(T.location.key);-1!==r&&(H[r]=i.key),p({action:o,location:i})}else window.location.replace(n)}})},go:L,goBack:function(){L(-1)},goForward:function(){L(1)},block:function(t){void 0===t&&(t=!1);var n=v.setPrompt(t);return S||(E(1),S=!0),function(){return S&&(S=!1,E(-1)),n()}},listen:function(t){var n=v.appendListener(t);return E(1),function(){E(-1),n()}}};return T}var HashChangeEvent$1="hashchange",HashPathCoders={hashbang:{encodePath:function(t){return"!"===t.charAt(0)?t:"!/"+stripLeadingSlash(t)},decodePath:function(t){return"!"===t.charAt(0)?t.substr(1):t}},noslash:{encodePath:stripLeadingSlash,decodePath:addLeadingSlash},slash:{encodePath:addLeadingSlash,decodePath:addLeadingSlash}};function stripHash(t){var n=t.indexOf("#");return-1===n?t:t.slice(0,n)}function getHashPath(){var t=window.location.href,n=t.indexOf("#");return-1===n?"":t.substring(n+1)}function pushHashPath(t){window.location.hash=t}function replaceHashPath(t){window.location.replace(stripHash(window.location.href)+"#"+t)}function createHashHistory(t){void 0===t&&(t={}),canUseDOM||invariant(!1);var n=window.history,e=(supportsGoWithoutReloadUsingHash(),t),a=e.getUserConfirmation,i=void 0===a?getConfirmation:a,r=e.hashType,o=void 0===r?"slash":r,s=t.basename?stripTrailingSlash(addLeadingSlash(t.basename)):"",c=HashPathCoders[o],h=c.encodePath,u=c.decodePath;function f(){var t=u(getHashPath());return s&&(t=stripBasename(t,s)),createLocation(t)}var l=createTransitionManager();function d(t){_extends(E,t),E.length=n.length,l.notifyListeners(E.location,E.action)}var v=!1,p=null;function g(){var t=getHashPath(),n=h(t);if(t!==n)replaceHashPath(n);else{var e=f(),a=E.location;if(!v&&function(t,n){return t.pathname===n.pathname&&t.search===n.search&&t.hash===n.hash}(a,e))return;if(p===createPath(e))return;p=null,function(n){if(v)v=!1,d();else{l.confirmTransitionTo(n,"POP",i,function(t){t?d({action:"POP",location:n}):function(t){var n=E.location,e=y.lastIndexOf(createPath(n));-1===e&&(e=0);var a=y.lastIndexOf(createPath(t));-1===a&&(a=0);var r=e-a;r&&(v=!0,H(r))}(n)})}}(e)}}var P=getHashPath(),m=h(P);P!==m&&replaceHashPath(m);var w=f(),y=[createPath(w)];function H(t){n.go(t)}var x=0;function L(t){1===(x+=t)&&1===t?window.addEventListener(HashChangeEvent$1,g):0===x&&window.removeEventListener(HashChangeEvent$1,g)}var O=!1;var E={length:n.length,action:"POP",location:w,createHref:function(t){var n=document.querySelector("base"),e="";return n&&n.getAttribute("href")&&(e=stripHash(window.location.href)),e+"#"+h(s+createPath(t))},push:function(t,n){var o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,"PUSH",i,function(t){if(t){var n=createPath(o),e=h(s+n);if(getHashPath()!==e){p=n,pushHashPath(e);var a=y.lastIndexOf(createPath(E.location)),r=y.slice(0,a+1);r.push(n),y=r,d({action:"PUSH",location:o})}else d()}})},replace:function(t,n){var r="REPLACE",o=createLocation(t,void 0,void 0,E.location);l.confirmTransitionTo(o,r,i,function(t){if(t){var n=createPath(o),e=h(s+n);getHashPath()!==e&&(p=n,replaceHashPath(e));var a=y.indexOf(createPath(E.location));-1!==a&&(y[a]=n),d({action:r,location:o})}})},go:H,goBack:function(){H(-1)},goForward:function(){H(1)},block:function(t){void 0===t&&(t=!1);var n=l.setPrompt(t);return O||(L(1),O=!0),function(){return O&&(O=!1,L(-1)),n()}},listen:function(t){var n=l.appendListener(t);return L(1),function(){L(-1),n()}}};return E}function clamp(t,n,e){return Math.min(Math.max(t,n),e)}function createMemoryHistory(t){void 0===t&&(t={});var n=t,r=n.getUserConfirmation,e=n.initialEntries,a=void 0===e?["/"]:e,o=n.initialIndex,i=void 0===o?0:o,s=n.keyLength,c=void 0===s?6:s,h=createTransitionManager();function u(t){_extends(g,t),g.length=g.entries.length,h.notifyListeners(g.location,g.action)}function f(){return Math.random().toString(36).substr(2,c)}var l=clamp(i,0,a.length-1),d=a.map(function(t){return createLocation(t,void 0,"string"==typeof t?f():t.key||f())}),v=createPath;function p(t){var n=clamp(g.index+t,0,g.entries.length-1),e=g.entries[n];h.confirmTransitionTo(e,"POP",r,function(t){t?u({action:"POP",location:e,index:n}):u()})}var g={length:d.length,action:"POP",location:d[l],index:l,entries:d,createHref:v,push:function(t,n){var a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,"PUSH",r,function(t){if(t){var n=g.index+1,e=g.entries.slice(0);e.length>n?e.splice(n,e.length-n,a):e.push(a),u({action:"PUSH",location:a,index:n,entries:e})}})},replace:function(t,n){var e="REPLACE",a=createLocation(t,n,f(),g.location);h.confirmTransitionTo(a,e,r,function(t){t&&(g.entries[g.index]=a,u({action:e,location:a}))})},go:p,goBack:function(){p(-1)},goForward:function(){p(1)},canGo:function(t){var n=g.index+t;return 0<=n&&n<g.entries.length},block:function(t){return void 0===t&&(t=!1),h.setPrompt(t)},listen:function(t){return h.appendListener(t)}};return g}exports.createBrowserHistory=createBrowserHistory,exports.createHashHistory=createHashHistory,exports.createMemoryHistory=createMemoryHistory,exports.createLocation=createLocation,exports.locationsAreEqual=locationsAreEqual,exports.parsePath=parsePath,exports.createPath=createPath;


/***/ },
/* 526 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var reactIs = __webpack_require__(18);
	
	/**
	 * Copyright 2015, Yahoo! Inc.
	 * Copyrights licensed under the New BSD License. See the accompanying LICENSE file for terms.
	 */
	var REACT_STATICS = {
	  childContextTypes: true,
	  contextType: true,
	  contextTypes: true,
	  defaultProps: true,
	  displayName: true,
	  getDefaultProps: true,
	  getDerivedStateFromError: true,
	  getDerivedStateFromProps: true,
	  mixins: true,
	  propTypes: true,
	  type: true
	};
	var KNOWN_STATICS = {
	  name: true,
	  length: true,
	  prototype: true,
	  caller: true,
	  callee: true,
	  arguments: true,
	  arity: true
	};
	var FORWARD_REF_STATICS = {
	  '$$typeof': true,
	  render: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true
	};
	var MEMO_STATICS = {
	  '$$typeof': true,
	  compare: true,
	  defaultProps: true,
	  displayName: true,
	  propTypes: true,
	  type: true
	};
	var TYPE_STATICS = {};
	TYPE_STATICS[reactIs.ForwardRef] = FORWARD_REF_STATICS;
	
	function getStatics(component) {
	  if (reactIs.isMemo(component)) {
	    return MEMO_STATICS;
	  }
	
	  return TYPE_STATICS[component['$$typeof']] || REACT_STATICS;
	}
	
	var defineProperty = Object.defineProperty;
	var getOwnPropertyNames = Object.getOwnPropertyNames;
	var getOwnPropertySymbols = Object.getOwnPropertySymbols;
	var getOwnPropertyDescriptor = Object.getOwnPropertyDescriptor;
	var getPrototypeOf = Object.getPrototypeOf;
	var objectPrototype = Object.prototype;
	function hoistNonReactStatics(targetComponent, sourceComponent, blacklist) {
	  if (typeof sourceComponent !== 'string') {
	    // don't hoist over string (html) components
	    if (objectPrototype) {
	      var inheritedComponent = getPrototypeOf(sourceComponent);
	
	      if (inheritedComponent && inheritedComponent !== objectPrototype) {
	        hoistNonReactStatics(targetComponent, inheritedComponent, blacklist);
	      }
	    }
	
	    var keys = getOwnPropertyNames(sourceComponent);
	
	    if (getOwnPropertySymbols) {
	      keys = keys.concat(getOwnPropertySymbols(sourceComponent));
	    }
	
	    var targetStatics = getStatics(targetComponent);
	    var sourceStatics = getStatics(sourceComponent);
	
	    for (var i = 0; i < keys.length; ++i) {
	      var key = keys[i];
	
	      if (!KNOWN_STATICS[key] && !(blacklist && blacklist[key]) && !(sourceStatics && sourceStatics[key]) && !(targetStatics && targetStatics[key])) {
	        var descriptor = getOwnPropertyDescriptor(sourceComponent, key);
	
	        try {
	          // Avoid failures from read-only properties
	          defineProperty(targetComponent, key, descriptor);
	        } catch (e) {}
	      }
	    }
	  }
	
	  return targetComponent;
	}
	
	module.exports = hoistNonReactStatics;


/***/ },
/* 527 */
/***/ function(module, exports) {

	'use strict';
	
	/* eslint-disable no-var, prefer-template */
	var uppercasePattern = /[A-Z]/g;
	var msPattern = /^ms-/;
	var cache = {};
	
	function toHyphenLower(match) {
	  return '-' + match.toLowerCase()
	}
	
	function hyphenateStyleName(name) {
	  if (cache.hasOwnProperty(name)) {
	    return cache[name]
	  }
	
	  var hName = name.replace(uppercasePattern, toHyphenLower);
	  return (cache[name] = msPattern.test(hName) ? '-' + hName : hName)
	}
	
	module.exports = hyphenateStyleName;


/***/ },
/* 528 */
/***/ function(module, exports) {

	'use strict';
	var toString = Object.prototype.toString;
	
	module.exports = function (x) {
		var prototype;
		return toString.call(x) === '[object Object]' && (prototype = Object.getPrototypeOf(x), prototype === null || prototype === Object.getPrototypeOf({}));
	};


/***/ },
/* 529 */
/***/ function(module, exports) {

	module.exports = Array.isArray || function (arr) {
	  return Object.prototype.toString.call(arr) == '[object Array]';
	};


/***/ },
/* 530 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var hyphenate = _interopDefault(__webpack_require__(527));
	
	/**
	 * Convert camel cased property names to dash separated.
	 *
	 * @param {Object} style
	 * @return {Object}
	 */
	
	function convertCase(style) {
	  var converted = {};
	
	  for (var prop in style) {
	    var key = prop.indexOf('--') === 0 ? prop : hyphenate(prop);
	    converted[key] = style[prop];
	  }
	
	  if (style.fallbacks) {
	    if (Array.isArray(style.fallbacks)) converted.fallbacks = style.fallbacks.map(convertCase);else converted.fallbacks = convertCase(style.fallbacks);
	  }
	
	  return converted;
	}
	/**
	 * Allow camel cased property names by converting them back to dasherized.
	 *
	 * @param {Rule} rule
	 */
	
	
	function camelCase() {
	  function onProcessStyle(style) {
	    if (Array.isArray(style)) {
	      // Handle rules like @font-face, which can have multiple styles in an array
	      for (var index = 0; index < style.length; index++) {
	        style[index] = convertCase(style[index]);
	      }
	
	      return style;
	    }
	
	    return convertCase(style);
	  }
	
	  function onChangeValue(value, prop, rule) {
	    if (prop.indexOf('--') === 0) {
	      return value;
	    }
	
	    var hyphenatedProp = hyphenate(prop); // There was no camel case in place
	
	    if (prop === hyphenatedProp) return value;
	    rule.prop(hyphenatedProp, value); // Core will ignore that property value we set the proper one above.
	
	    return null;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = camelCase;


/***/ },
/* 531 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var jss = __webpack_require__(40);
	
	var px = jss.hasCSSTOMSupport && CSS ? CSS.px : 'px';
	var ms = jss.hasCSSTOMSupport && CSS ? CSS.ms : 'ms';
	var percent = jss.hasCSSTOMSupport && CSS ? CSS.percent : '%';
	/**
	 * Generated jss-plugin-default-unit CSS property units
	 *
	 * @type object
	 */
	
	var defaultUnits = {
	  // Animation properties
	  'animation-delay': ms,
	  'animation-duration': ms,
	  // Background properties
	  'background-position': px,
	  'background-position-x': px,
	  'background-position-y': px,
	  'background-size': px,
	  // Border Properties
	  border: px,
	  'border-bottom': px,
	  'border-bottom-left-radius': px,
	  'border-bottom-right-radius': px,
	  'border-bottom-width': px,
	  'border-left': px,
	  'border-left-width': px,
	  'border-radius': px,
	  'border-right': px,
	  'border-right-width': px,
	  'border-top': px,
	  'border-top-left-radius': px,
	  'border-top-right-radius': px,
	  'border-top-width': px,
	  'border-width': px,
	  // Margin properties
	  margin: px,
	  'margin-bottom': px,
	  'margin-left': px,
	  'margin-right': px,
	  'margin-top': px,
	  // Padding properties
	  padding: px,
	  'padding-bottom': px,
	  'padding-left': px,
	  'padding-right': px,
	  'padding-top': px,
	  // Mask properties
	  'mask-position-x': px,
	  'mask-position-y': px,
	  'mask-size': px,
	  // Width and height properties
	  height: px,
	  width: px,
	  'min-height': px,
	  'max-height': px,
	  'min-width': px,
	  'max-width': px,
	  // Position properties
	  bottom: px,
	  left: px,
	  top: px,
	  right: px,
	  // Shadow properties
	  'box-shadow': px,
	  'text-shadow': px,
	  // Column properties
	  'column-gap': px,
	  'column-rule': px,
	  'column-rule-width': px,
	  'column-width': px,
	  // Font and text properties
	  'font-size': px,
	  'font-size-delta': px,
	  'letter-spacing': px,
	  'text-indent': px,
	  'text-stroke': px,
	  'text-stroke-width': px,
	  'word-spacing': px,
	  // Motion properties
	  motion: px,
	  'motion-offset': px,
	  // Outline properties
	  outline: px,
	  'outline-offset': px,
	  'outline-width': px,
	  // Perspective properties
	  perspective: px,
	  'perspective-origin-x': percent,
	  'perspective-origin-y': percent,
	  // Transform properties
	  'transform-origin': percent,
	  'transform-origin-x': percent,
	  'transform-origin-y': percent,
	  'transform-origin-z': percent,
	  // Transition properties
	  'transition-delay': ms,
	  'transition-duration': ms,
	  // Alignment properties
	  'vertical-align': px,
	  'flex-basis': px,
	  // Some random properties
	  'shape-margin': px,
	  size: px,
	  // Grid properties
	  grid: px,
	  'grid-gap': px,
	  'grid-row-gap': px,
	  'grid-column-gap': px,
	  'grid-template-rows': px,
	  'grid-template-columns': px,
	  'grid-auto-rows': px,
	  'grid-auto-columns': px,
	  // Not existing properties.
	  // Used to avoid issues with jss-plugin-expand integration.
	  'box-shadow-x': px,
	  'box-shadow-y': px,
	  'box-shadow-blur': px,
	  'box-shadow-spread': px,
	  'font-line-height': px,
	  'text-shadow-x': px,
	  'text-shadow-y': px,
	  'text-shadow-blur': px
	};
	
	/**
	 * Clones the object and adds a camel cased property version.
	 */
	function addCamelCasedVersion(obj) {
	  var regExp = /(-[a-z])/g;
	
	  var replace = function replace(str) {
	    return str[1].toUpperCase();
	  };
	
	  var newObj = {};
	
	  for (var _key in obj) {
	    newObj[_key] = obj[_key];
	    newObj[_key.replace(regExp, replace)] = obj[_key];
	  }
	
	  return newObj;
	}
	
	var units = addCamelCasedVersion(defaultUnits);
	/**
	 * Recursive deep style passing function
	 */
	
	function iterate(prop, value, options) {
	  if (!value) return value;
	
	  if (Array.isArray(value)) {
	    for (var i = 0; i < value.length; i++) {
	      value[i] = iterate(prop, value[i], options);
	    }
	  } else if (typeof value === 'object') {
	    if (prop === 'fallbacks') {
	      for (var innerProp in value) {
	        value[innerProp] = iterate(innerProp, value[innerProp], options);
	      }
	    } else {
	      for (var _innerProp in value) {
	        value[_innerProp] = iterate(prop + "-" + _innerProp, value[_innerProp], options);
	      }
	    }
	  } else if (typeof value === 'number') {
	    var unit = options[prop] || units[prop];
	
	    if (unit) {
	      return typeof unit === 'function' ? unit(value).toString() : "" + value + unit;
	    }
	
	    return value.toString();
	  }
	
	  return value;
	}
	/**
	 * Add unit to numeric values.
	 */
	
	
	function defaultUnit(options) {
	  if (options === void 0) {
	    options = {};
	  }
	
	  var camelCasedOptions = addCamelCasedVersion(options);
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	
	    for (var prop in style) {
	      style[prop] = iterate(prop, style[prop], camelCasedOptions);
	    }
	
	    return style;
	  }
	
	  function onChangeValue(value, prop) {
	    return iterate(prop, value, camelCasedOptions);
	  }
	
	  return {
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = defaultUnit;


/***/ },
/* 532 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(5));
	var jss = __webpack_require__(40);
	
	var at = '@global';
	var atPrefix = '@global ';
	
	var GlobalContainerRule =
	/*#__PURE__*/
	function () {
	  function GlobalContainerRule(key, styles, options) {
	    this.type = 'global';
	    this.at = at;
	    this.rules = void 0;
	    this.options = void 0;
	    this.key = void 0;
	    this.isProcessed = false;
	    this.key = key;
	    this.options = options;
	    this.rules = new jss.RuleList(_extends({}, options, {
	      parent: this
	    }));
	
	    for (var selector in styles) {
	      this.rules.add(selector, styles[selector]);
	    }
	
	    this.rules.process();
	  }
	  /**
	   * Get a rule.
	   */
	
	
	  var _proto = GlobalContainerRule.prototype;
	
	  _proto.getRule = function getRule(name) {
	    return this.rules.get(name);
	  }
	  /**
	   * Create and register rule, run plugins.
	   */
	  ;
	
	  _proto.addRule = function addRule(name, style, options) {
	    var rule = this.rules.add(name, style, options);
	    this.options.jss.plugins.onProcessRule(rule);
	    return rule;
	  }
	  /**
	   * Get index of a rule.
	   */
	  ;
	
	  _proto.indexOf = function indexOf(rule) {
	    return this.rules.indexOf(rule);
	  }
	  /**
	   * Generates a CSS string.
	   */
	  ;
	
	  _proto.toString = function toString() {
	    return this.rules.toString();
	  };
	
	  return GlobalContainerRule;
	}();
	
	var GlobalPrefixedRule =
	/*#__PURE__*/
	function () {
	  function GlobalPrefixedRule(key, style, options) {
	    this.type = 'global';
	    this.at = at;
	    this.options = void 0;
	    this.rule = void 0;
	    this.isProcessed = false;
	    this.key = void 0;
	    this.key = key;
	    this.options = options;
	    var selector = key.substr(atPrefix.length);
	    this.rule = options.jss.createRule(selector, style, _extends({}, options, {
	      parent: this
	    }));
	  }
	
	  var _proto2 = GlobalPrefixedRule.prototype;
	
	  _proto2.toString = function toString(options) {
	    return this.rule ? this.rule.toString(options) : '';
	  };
	
	  return GlobalPrefixedRule;
	}();
	
	var separatorRegExp = /\s*,\s*/g;
	
	function addScope(selector, scope) {
	  var parts = selector.split(separatorRegExp);
	  var scoped = '';
	
	  for (var i = 0; i < parts.length; i++) {
	    scoped += scope + " " + parts[i].trim();
	    if (parts[i + 1]) scoped += ', ';
	  }
	
	  return scoped;
	}
	
	function handleNestedGlobalContainerRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	  var rules = style ? style[at] : null;
	  if (!rules) return;
	
	  for (var name in rules) {
	    options.sheet.addRule(name, rules[name], _extends({}, options, {
	      selector: addScope(name, rule.selector)
	    }));
	  }
	
	  delete style[at];
	}
	
	function handlePrefixedGlobalRule(rule) {
	  var options = rule.options,
	      style = rule.style;
	
	  for (var prop in style) {
	    if (prop[0] !== '@' || prop.substr(0, at.length) !== at) continue;
	    var selector = addScope(prop.substr(at.length), rule.selector);
	    options.sheet.addRule(selector, style[prop], _extends({}, options, {
	      selector: selector
	    }));
	    delete style[prop];
	  }
	}
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	
	
	function jssGlobal() {
	  function onCreateRule(name, styles, options) {
	    if (!name) return null;
	
	    if (name === at) {
	      return new GlobalContainerRule(name, styles, options);
	    }
	
	    if (name[0] === '@' && name.substr(0, atPrefix.length) === atPrefix) {
	      return new GlobalPrefixedRule(name, styles, options);
	    }
	
	    var parent = options.parent;
	
	    if (parent) {
	      if (parent.type === 'global' || parent.options.parent && parent.options.parent.type === 'global') {
	        options.scoped = false;
	      }
	    }
	
	    if (options.scoped === false) {
	      options.selector = name;
	    }
	
	    return null;
	  }
	
	  function onProcessRule(rule) {
	    if (rule.type !== 'style') return;
	    handleNestedGlobalContainerRule(rule);
	    handlePrefixedGlobalRule(rule);
	  }
	
	  return {
	    onCreateRule: onCreateRule,
	    onProcessRule: onProcessRule
	  };
	}
	
	exports.default = jssGlobal;


/***/ },
/* 533 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var _extends = _interopDefault(__webpack_require__(5));
	var warning = _interopDefault(__webpack_require__(41));
	
	var separatorRegExp = /\s*,\s*/g;
	var parentRegExp = /&/g;
	var refRegExp = /\$([\w-]+)/g;
	/**
	 * Convert nested rules to separate, remove them from original styles.
	 *
	 * @param {Rule} rule
	 * @api public
	 */
	
	function jssNested() {
	  // Get a function to be used for $ref replacement.
	  function getReplaceRef(container, sheet) {
	    return function (match, key) {
	      var rule = container.getRule(key) || sheet && sheet.getRule(key);
	
	      if (rule) {
	        rule = rule;
	        return rule.selector;
	      }
	
	       false ? warning(false, "[JSS] Could not find the referenced rule \"" + key + "\" in \"" + (container.options.meta || container.toString()) + "\".") : void 0;
	      return key;
	    };
	  }
	
	  function replaceParentRefs(nestedProp, parentProp) {
	    var parentSelectors = parentProp.split(separatorRegExp);
	    var nestedSelectors = nestedProp.split(separatorRegExp);
	    var result = '';
	
	    for (var i = 0; i < parentSelectors.length; i++) {
	      var parent = parentSelectors[i];
	
	      for (var j = 0; j < nestedSelectors.length; j++) {
	        var nested = nestedSelectors[j];
	        if (result) result += ', '; // Replace all & by the parent or prefix & with the parent.
	
	        result += nested.indexOf('&') !== -1 ? nested.replace(parentRegExp, parent) : parent + " " + nested;
	      }
	    }
	
	    return result;
	  }
	
	  function getOptions(rule, container, prevOptions) {
	    // Options has been already created, now we only increase index.
	    if (prevOptions) return _extends({}, prevOptions, {
	      index: prevOptions.index + 1
	    });
	    var nestingLevel = rule.options.nestingLevel;
	    nestingLevel = nestingLevel === undefined ? 1 : nestingLevel + 1;
	
	    var options = _extends({}, rule.options, {
	      nestingLevel: nestingLevel,
	      index: container.indexOf(rule) + 1 // We don't need the parent name to be set options for chlid.
	
	    });
	
	    delete options.name;
	    return options;
	  }
	
	  function onProcessStyle(style, rule, sheet) {
	    if (rule.type !== 'style') return style;
	    var styleRule = rule;
	    var container = styleRule.options.parent;
	    var options;
	    var replaceRef;
	
	    for (var prop in style) {
	      var isNested = prop.indexOf('&') !== -1;
	      var isNestedConditional = prop[0] === '@';
	      if (!isNested && !isNestedConditional) continue;
	      options = getOptions(styleRule, container, options);
	
	      if (isNested) {
	        var selector = replaceParentRefs(prop, styleRule.selector); // Lazily create the ref replacer function just once for
	        // all nested rules within the sheet.
	
	        if (!replaceRef) replaceRef = getReplaceRef(container, sheet); // Replace all $refs.
	
	        selector = selector.replace(refRegExp, replaceRef);
	        container.addRule(selector, style[prop], _extends({}, options, {
	          selector: selector
	        }));
	      } else if (isNestedConditional) {
	        // Place conditional right after the parent rule to ensure right ordering.
	        container.addRule(prop, {}, options) // Flow expects more options but they aren't required
	        // And flow doesn't know this will always be a StyleRule which has the addRule method
	        // $FlowFixMe
	        .addRule(styleRule.key, style[prop], {
	          selector: styleRule.selector
	        });
	      }
	
	      delete style[prop];
	    }
	
	    return style;
	  }
	
	  return {
	    onProcessStyle: onProcessStyle
	  };
	}
	
	exports.default = jssNested;


/***/ },
/* 534 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	/**
	 * Sort props by length.
	 */
	function jssPropsSort() {
	  var sort = function sort(prop0, prop1) {
	    if (prop0.length === prop1.length) {
	      return prop0 > prop1 ? 1 : -1;
	    }
	
	    return prop0.length - prop1.length;
	  };
	
	  return {
	    onProcessStyle: function onProcessStyle(style, rule) {
	      if (rule.type !== 'style') return style;
	      var newStyle = {};
	      var props = Object.keys(style).sort(sort);
	
	      for (var i = 0; i < props.length; i++) {
	        newStyle[props[i]] = style[props[i]];
	      }
	
	      return newStyle;
	    }
	  };
	}
	
	exports.default = jssPropsSort;


/***/ },
/* 535 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }
	
	var warning = _interopDefault(__webpack_require__(41));
	var jss = __webpack_require__(40);
	
	var now = Date.now();
	var fnValuesNs = "fnValues" + now;
	var fnRuleNs = "fnStyle" + ++now;
	function functionPlugin() {
	  return {
	    onCreateRule: function onCreateRule(name, decl, options) {
	      if (typeof decl !== 'function') return null;
	      var rule = jss.createRule(name, {}, options);
	      rule[fnRuleNs] = decl;
	      return rule;
	    },
	    onProcessStyle: function onProcessStyle(style, rule) {
	      // We need to extract function values from the declaration, so that we can keep core unaware of them.
	      // We need to do that only once.
	      // We don't need to extract functions on each style update, since this can happen only once.
	      // We don't support function values inside of function rules.
	      if (fnValuesNs in rule || fnRuleNs in rule) return style;
	      var fnValues = {};
	
	      for (var prop in style) {
	        var value = style[prop];
	        if (typeof value !== 'function') continue;
	        delete style[prop];
	        fnValues[prop] = value;
	      } // $FlowFixMe
	
	
	      rule[fnValuesNs] = fnValues;
	      return style;
	    },
	    onUpdate: function onUpdate(data, rule, sheet, options) {
	      var styleRule = rule;
	      var fnRule = styleRule[fnRuleNs]; // If we have a style function, the entire rule is dynamic and style object
	      // will be returned from that function.
	
	      if (fnRule) {
	        // Empty object will remove all currently defined props
	        // in case function rule returns a falsy value.
	        styleRule.style = fnRule(data) || {};
	
	        if (false) {
	          for (var prop in styleRule.style) {
	            if (typeof styleRule.style[prop] === 'function') {
	              process.env.NODE_ENV !== "production" ? warning(false, '[JSS] Function values inside function rules are not supported.') : void 0;
	              break;
	            }
	          }
	        }
	      }
	
	      var fnValues = styleRule[fnValuesNs]; // If we have a fn values map, it is a rule with function values.
	
	      if (fnValues) {
	        for (var _prop in fnValues) {
	          styleRule.prop(_prop, fnValues[_prop](data), options);
	        }
	      }
	    }
	  };
	}
	
	exports.default = functionPlugin;


/***/ },
/* 536 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, '__esModule', { value: true });
	
	var vendor = __webpack_require__(504);
	var jss = __webpack_require__(40);
	
	/**
	 * Add vendor prefix to a property name when needed.
	 *
	 * @api public
	 */
	
	function jssVendorPrefixer() {
	  function onProcessRule(rule) {
	    if (rule.type === 'keyframes') {
	      var atRule = rule;
	      atRule.at = vendor.supportedKeyframes(atRule.at);
	    }
	  }
	
	  function prefixStyle(style) {
	    for (var prop in style) {
	      var value = style[prop];
	
	      if (prop === 'fallbacks' && Array.isArray(value)) {
	        style[prop] = value.map(prefixStyle);
	        continue;
	      }
	
	      var changeProp = false;
	      var supportedProp = vendor.supportedProperty(prop);
	      if (supportedProp && supportedProp !== prop) changeProp = true;
	      var changeValue = false;
	      var supportedValue = vendor.supportedValue(supportedProp, jss.toCssValue(value));
	      if (supportedValue && supportedValue !== value) changeValue = true;
	
	      if (changeProp || changeValue) {
	        if (changeProp) delete style[prop];
	        style[supportedProp || prop] = supportedValue || value;
	      }
	    }
	
	    return style;
	  }
	
	  function onProcessStyle(style, rule) {
	    if (rule.type !== 'style') return style;
	    return prefixStyle(style);
	  }
	
	  function onChangeValue(value, prop) {
	    return vendor.supportedValue(prop, jss.toCssValue(value)) || value;
	  }
	
	  return {
	    onProcessRule: onProcessRule,
	    onProcessStyle: onProcessStyle,
	    onChangeValue: onChangeValue
	  };
	}
	
	exports.default = jssVendorPrefixer;


/***/ },
/* 537 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/**
	 * lodash (Custom Build) <https://lodash.com/>
	 * Build: `lodash modularize exports="npm" -o ./`
	 * Copyright jQuery Foundation and other contributors <https://jquery.org/>
	 * Released under MIT license <https://lodash.com/license>
	 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
	 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
	 */
	
	/** Used as the `TypeError` message for "Functions" methods. */
	var FUNC_ERROR_TEXT = 'Expected a function';
	
	/** Used as references for various `Number` constants. */
	var NAN = 0 / 0;
	
	/** `Object#toString` result references. */
	var symbolTag = '[object Symbol]';
	
	/** Used to match leading and trailing whitespace. */
	var reTrim = /^\s+|\s+$/g;
	
	/** Used to detect bad signed hexadecimal string values. */
	var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;
	
	/** Used to detect binary string values. */
	var reIsBinary = /^0b[01]+$/i;
	
	/** Used to detect octal string values. */
	var reIsOctal = /^0o[0-7]+$/i;
	
	/** Built-in method references without a dependency on `root`. */
	var freeParseInt = parseInt;
	
	/** Detect free variable `global` from Node.js. */
	var freeGlobal = typeof global == 'object' && global && global.Object === Object && global;
	
	/** Detect free variable `self`. */
	var freeSelf = typeof self == 'object' && self && self.Object === Object && self;
	
	/** Used as a reference to the global object. */
	var root = freeGlobal || freeSelf || Function('return this')();
	
	/** Used for built-in method references. */
	var objectProto = Object.prototype;
	
	/**
	 * Used to resolve the
	 * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
	 * of values.
	 */
	var objectToString = objectProto.toString;
	
	/* Built-in method references for those with the same name as other `lodash` methods. */
	var nativeMax = Math.max,
	    nativeMin = Math.min;
	
	/**
	 * Gets the timestamp of the number of milliseconds that have elapsed since
	 * the Unix epoch (1 January 1970 00:00:00 UTC).
	 *
	 * @static
	 * @memberOf _
	 * @since 2.4.0
	 * @category Date
	 * @returns {number} Returns the timestamp.
	 * @example
	 *
	 * _.defer(function(stamp) {
	 *   console.log(_.now() - stamp);
	 * }, _.now());
	 * // => Logs the number of milliseconds it took for the deferred invocation.
	 */
	var now = function() {
	  return root.Date.now();
	};
	
	/**
	 * Creates a debounced function that delays invoking `func` until after `wait`
	 * milliseconds have elapsed since the last time the debounced function was
	 * invoked. The debounced function comes with a `cancel` method to cancel
	 * delayed `func` invocations and a `flush` method to immediately invoke them.
	 * Provide `options` to indicate whether `func` should be invoked on the
	 * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
	 * with the last arguments provided to the debounced function. Subsequent
	 * calls to the debounced function return the result of the last `func`
	 * invocation.
	 *
	 * **Note:** If `leading` and `trailing` options are `true`, `func` is
	 * invoked on the trailing edge of the timeout only if the debounced function
	 * is invoked more than once during the `wait` timeout.
	 *
	 * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
	 * until to the next tick, similar to `setTimeout` with a timeout of `0`.
	 *
	 * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
	 * for details over the differences between `_.debounce` and `_.throttle`.
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Function
	 * @param {Function} func The function to debounce.
	 * @param {number} [wait=0] The number of milliseconds to delay.
	 * @param {Object} [options={}] The options object.
	 * @param {boolean} [options.leading=false]
	 *  Specify invoking on the leading edge of the timeout.
	 * @param {number} [options.maxWait]
	 *  The maximum time `func` is allowed to be delayed before it's invoked.
	 * @param {boolean} [options.trailing=true]
	 *  Specify invoking on the trailing edge of the timeout.
	 * @returns {Function} Returns the new debounced function.
	 * @example
	 *
	 * // Avoid costly calculations while the window size is in flux.
	 * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
	 *
	 * // Invoke `sendMail` when clicked, debouncing subsequent calls.
	 * jQuery(element).on('click', _.debounce(sendMail, 300, {
	 *   'leading': true,
	 *   'trailing': false
	 * }));
	 *
	 * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
	 * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
	 * var source = new EventSource('/stream');
	 * jQuery(source).on('message', debounced);
	 *
	 * // Cancel the trailing debounced invocation.
	 * jQuery(window).on('popstate', debounced.cancel);
	 */
	function debounce(func, wait, options) {
	  var lastArgs,
	      lastThis,
	      maxWait,
	      result,
	      timerId,
	      lastCallTime,
	      lastInvokeTime = 0,
	      leading = false,
	      maxing = false,
	      trailing = true;
	
	  if (typeof func != 'function') {
	    throw new TypeError(FUNC_ERROR_TEXT);
	  }
	  wait = toNumber(wait) || 0;
	  if (isObject(options)) {
	    leading = !!options.leading;
	    maxing = 'maxWait' in options;
	    maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
	    trailing = 'trailing' in options ? !!options.trailing : trailing;
	  }
	
	  function invokeFunc(time) {
	    var args = lastArgs,
	        thisArg = lastThis;
	
	    lastArgs = lastThis = undefined;
	    lastInvokeTime = time;
	    result = func.apply(thisArg, args);
	    return result;
	  }
	
	  function leadingEdge(time) {
	    // Reset any `maxWait` timer.
	    lastInvokeTime = time;
	    // Start the timer for the trailing edge.
	    timerId = setTimeout(timerExpired, wait);
	    // Invoke the leading edge.
	    return leading ? invokeFunc(time) : result;
	  }
	
	  function remainingWait(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime,
	        result = wait - timeSinceLastCall;
	
	    return maxing ? nativeMin(result, maxWait - timeSinceLastInvoke) : result;
	  }
	
	  function shouldInvoke(time) {
	    var timeSinceLastCall = time - lastCallTime,
	        timeSinceLastInvoke = time - lastInvokeTime;
	
	    // Either this is the first call, activity has stopped and we're at the
	    // trailing edge, the system time has gone backwards and we're treating
	    // it as the trailing edge, or we've hit the `maxWait` limit.
	    return (lastCallTime === undefined || (timeSinceLastCall >= wait) ||
	      (timeSinceLastCall < 0) || (maxing && timeSinceLastInvoke >= maxWait));
	  }
	
	  function timerExpired() {
	    var time = now();
	    if (shouldInvoke(time)) {
	      return trailingEdge(time);
	    }
	    // Restart the timer.
	    timerId = setTimeout(timerExpired, remainingWait(time));
	  }
	
	  function trailingEdge(time) {
	    timerId = undefined;
	
	    // Only invoke if we have `lastArgs` which means `func` has been
	    // debounced at least once.
	    if (trailing && lastArgs) {
	      return invokeFunc(time);
	    }
	    lastArgs = lastThis = undefined;
	    return result;
	  }
	
	  function cancel() {
	    if (timerId !== undefined) {
	      clearTimeout(timerId);
	    }
	    lastInvokeTime = 0;
	    lastArgs = lastCallTime = lastThis = timerId = undefined;
	  }
	
	  function flush() {
	    return timerId === undefined ? result : trailingEdge(now());
	  }
	
	  function debounced() {
	    var time = now(),
	        isInvoking = shouldInvoke(time);
	
	    lastArgs = arguments;
	    lastThis = this;
	    lastCallTime = time;
	
	    if (isInvoking) {
	      if (timerId === undefined) {
	        return leadingEdge(lastCallTime);
	      }
	      if (maxing) {
	        // Handle invocations in a tight loop.
	        timerId = setTimeout(timerExpired, wait);
	        return invokeFunc(lastCallTime);
	      }
	    }
	    if (timerId === undefined) {
	      timerId = setTimeout(timerExpired, wait);
	    }
	    return result;
	  }
	  debounced.cancel = cancel;
	  debounced.flush = flush;
	  return debounced;
	}
	
	/**
	 * Checks if `value` is the
	 * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
	 * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
	 *
	 * @static
	 * @memberOf _
	 * @since 0.1.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is an object, else `false`.
	 * @example
	 *
	 * _.isObject({});
	 * // => true
	 *
	 * _.isObject([1, 2, 3]);
	 * // => true
	 *
	 * _.isObject(_.noop);
	 * // => true
	 *
	 * _.isObject(null);
	 * // => false
	 */
	function isObject(value) {
	  var type = typeof value;
	  return !!value && (type == 'object' || type == 'function');
	}
	
	/**
	 * Checks if `value` is object-like. A value is object-like if it's not `null`
	 * and has a `typeof` result of "object".
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
	 * @example
	 *
	 * _.isObjectLike({});
	 * // => true
	 *
	 * _.isObjectLike([1, 2, 3]);
	 * // => true
	 *
	 * _.isObjectLike(_.noop);
	 * // => false
	 *
	 * _.isObjectLike(null);
	 * // => false
	 */
	function isObjectLike(value) {
	  return !!value && typeof value == 'object';
	}
	
	/**
	 * Checks if `value` is classified as a `Symbol` primitive or object.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to check.
	 * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
	 * @example
	 *
	 * _.isSymbol(Symbol.iterator);
	 * // => true
	 *
	 * _.isSymbol('abc');
	 * // => false
	 */
	function isSymbol(value) {
	  return typeof value == 'symbol' ||
	    (isObjectLike(value) && objectToString.call(value) == symbolTag);
	}
	
	/**
	 * Converts `value` to a number.
	 *
	 * @static
	 * @memberOf _
	 * @since 4.0.0
	 * @category Lang
	 * @param {*} value The value to process.
	 * @returns {number} Returns the number.
	 * @example
	 *
	 * _.toNumber(3.2);
	 * // => 3.2
	 *
	 * _.toNumber(Number.MIN_VALUE);
	 * // => 5e-324
	 *
	 * _.toNumber(Infinity);
	 * // => Infinity
	 *
	 * _.toNumber('3.2');
	 * // => 3.2
	 */
	function toNumber(value) {
	  if (typeof value == 'number') {
	    return value;
	  }
	  if (isSymbol(value)) {
	    return NAN;
	  }
	  if (isObject(value)) {
	    var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
	    value = isObject(other) ? (other + '') : other;
	  }
	  if (typeof value != 'string') {
	    return value === 0 ? value : +value;
	  }
	  value = value.replace(reTrim, '');
	  var isBinary = reIsBinary.test(value);
	  return (isBinary || reIsOctal.test(value))
	    ? freeParseInt(value.slice(2), isBinary ? 2 : 8)
	    : (reIsBadHex.test(value) ? NAN : +value);
	}
	
	module.exports = debounce;
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 538 */
/***/ function(module, exports, __webpack_require__) {

	/* Mapbox GL JS is licensed under the 3-Clause BSD License. Full text of license: https://github.com/mapbox/mapbox-gl-js/blob/v1.8.0/LICENSE.txt */
	(function (global, factory) {
	 true ? module.exports = factory() :
	typeof define === 'function' && define.amd ? define(factory) :
	(global = global || self, global.mapboxgl = factory());
	}(this, (function () { 'use strict';
	
	/* eslint-disable */
	
	var shared, worker, mapboxgl;
	// define gets called three times: one for each chunk. we rely on the order
	// they're imported to know which is which
	function define(_, chunk) {
	if (!shared) {
	    shared = chunk;
	} else if (!worker) {
	    worker = chunk;
	} else {
	    var workerBundleString = 'var sharedChunk = {}; (' + shared + ')(sharedChunk); (' + worker + ')(sharedChunk);'
	
	    var sharedChunk = {};
	    shared(sharedChunk);
	    mapboxgl = chunk(sharedChunk);
	    mapboxgl.workerUrl = window.URL.createObjectURL(new Blob([workerBundleString], { type: 'text/javascript' }));
	}
	}
	
	
	define(["exports"],(function(t){"use strict";function e(t,e){return t(e={exports:{}},e.exports),e.exports}var r=n;function n(t,e,r,n){this.cx=3*t,this.bx=3*(r-t)-this.cx,this.ax=1-this.cx-this.bx,this.cy=3*e,this.by=3*(n-e)-this.cy,this.ay=1-this.cy-this.by,this.p1x=t,this.p1y=n,this.p2x=r,this.p2y=n;}n.prototype.sampleCurveX=function(t){return ((this.ax*t+this.bx)*t+this.cx)*t},n.prototype.sampleCurveY=function(t){return ((this.ay*t+this.by)*t+this.cy)*t},n.prototype.sampleCurveDerivativeX=function(t){return (3*this.ax*t+2*this.bx)*t+this.cx},n.prototype.solveCurveX=function(t,e){var r,n,i,a,o;for(void 0===e&&(e=1e-6),i=t,o=0;o<8;o++){if(a=this.sampleCurveX(i)-t,Math.abs(a)<e)return i;var s=this.sampleCurveDerivativeX(i);if(Math.abs(s)<1e-6)break;i-=a/s;}if((i=t)<(r=0))return r;if(i>(n=1))return n;for(;r<n;){if(a=this.sampleCurveX(i),Math.abs(a-t)<e)return i;t>a?r=i:n=i,i=.5*(n-r)+r;}return i},n.prototype.solve=function(t,e){return this.sampleCurveY(this.solveCurveX(t,e))};var i=a;function a(t,e){this.x=t,this.y=e;}function o(t,e,n,i){var a=new r(t,e,n,i);return function(t){return a.solve(t)}}a.prototype={clone:function(){return new a(this.x,this.y)},add:function(t){return this.clone()._add(t)},sub:function(t){return this.clone()._sub(t)},multByPoint:function(t){return this.clone()._multByPoint(t)},divByPoint:function(t){return this.clone()._divByPoint(t)},mult:function(t){return this.clone()._mult(t)},div:function(t){return this.clone()._div(t)},rotate:function(t){return this.clone()._rotate(t)},rotateAround:function(t,e){return this.clone()._rotateAround(t,e)},matMult:function(t){return this.clone()._matMult(t)},unit:function(){return this.clone()._unit()},perp:function(){return this.clone()._perp()},round:function(){return this.clone()._round()},mag:function(){return Math.sqrt(this.x*this.x+this.y*this.y)},equals:function(t){return this.x===t.x&&this.y===t.y},dist:function(t){return Math.sqrt(this.distSqr(t))},distSqr:function(t){var e=t.x-this.x,r=t.y-this.y;return e*e+r*r},angle:function(){return Math.atan2(this.y,this.x)},angleTo:function(t){return Math.atan2(this.y-t.y,this.x-t.x)},angleWith:function(t){return this.angleWithSep(t.x,t.y)},angleWithSep:function(t,e){return Math.atan2(this.x*e-this.y*t,this.x*t+this.y*e)},_matMult:function(t){var e=t[0]*this.x+t[1]*this.y,r=t[2]*this.x+t[3]*this.y;return this.x=e,this.y=r,this},_add:function(t){return this.x+=t.x,this.y+=t.y,this},_sub:function(t){return this.x-=t.x,this.y-=t.y,this},_mult:function(t){return this.x*=t,this.y*=t,this},_div:function(t){return this.x/=t,this.y/=t,this},_multByPoint:function(t){return this.x*=t.x,this.y*=t.y,this},_divByPoint:function(t){return this.x/=t.x,this.y/=t.y,this},_unit:function(){return this._div(this.mag()),this},_perp:function(){var t=this.y;return this.y=this.x,this.x=-t,this},_rotate:function(t){var e=Math.cos(t),r=Math.sin(t),n=e*this.x-r*this.y,i=r*this.x+e*this.y;return this.x=n,this.y=i,this},_rotateAround:function(t,e){var r=Math.cos(t),n=Math.sin(t),i=e.x+r*(this.x-e.x)-n*(this.y-e.y),a=e.y+n*(this.x-e.x)+r*(this.y-e.y);return this.x=i,this.y=a,this},_round:function(){return this.x=Math.round(this.x),this.y=Math.round(this.y),this}},a.convert=function(t){return t instanceof a?t:Array.isArray(t)?new a(t[0],t[1]):t};var s=o(.25,.1,.25,1);function u(t,e,r){return Math.min(r,Math.max(e,t))}function l(t,e,r){var n=r-e,i=((t-e)%n+n)%n+e;return i===e?r:i}function p(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var a=i[n];for(var o in a)t[o]=a[o];}return t}var c=1;function h(){return c++}function f(){return function t(e){return e?(e^16*Math.random()>>e/4).toString(16):([1e7]+-[1e3]+-4e3+-8e3+-1e11).replace(/[018]/g,t)}()}function y(t){return !!t&&/^[0-9a-f]{8}-[0-9a-f]{4}-[4][0-9a-f]{3}-[89ab][0-9a-f]{3}-[0-9a-f]{12}$/i.test(t)}function d(t,e){t.forEach((function(t){e[t]&&(e[t]=e[t].bind(e));}));}function m(t,e){return -1!==t.indexOf(e,t.length-e.length)}function v(t,e,r){var n={};for(var i in t)n[i]=e.call(r||this,t[i],i,t);return n}function g(t,e,r){var n={};for(var i in t)e.call(r||this,t[i],i,t)&&(n[i]=t[i]);return n}function x(t){return Array.isArray(t)?t.map(x):"object"==typeof t&&t?v(t,x):t}var b={};function _(t){b[t]||("undefined"!=typeof console&&console.warn(t),b[t]=!0);}function w(t,e,r){return (r.y-t.y)*(e.x-t.x)>(e.y-t.y)*(r.x-t.x)}function A(t){for(var e=0,r=0,n=t.length,i=n-1,a=void 0,o=void 0;r<n;i=r++)a=t[r],e+=((o=t[i]).x-a.x)*(a.y+o.y);return e}function S(){return "undefined"!=typeof WorkerGlobalScope&&"undefined"!=typeof self&&self instanceof WorkerGlobalScope}function k(t){var e={};if(t.replace(/(?:^|(?:\s*\,\s*))([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)(?:\=(?:([^\x00-\x20\(\)<>@\,;\:\\"\/\[\]\?\=\{\}\x7F]+)|(?:\"((?:[^"\\]|\\.)*)\")))?/g,(function(t,r,n,i){var a=n||i;return e[r]=!a||a.toLowerCase(),""})),e["max-age"]){var r=parseInt(e["max-age"],10);isNaN(r)?delete e["max-age"]:e["max-age"]=r;}return e}var I=null;function z(t){if(null==I){var e=t.navigator?t.navigator.userAgent:null;I=!!t.safari||!(!e||!(/\b(iPad|iPhone|iPod)\b/.test(e)||e.match("Safari")&&!e.match("Chrome")));}return I}function C(t){try{var e=self[t];return e.setItem("_mapbox_test_",1),e.removeItem("_mapbox_test_"),!0}catch(t){return !1}}var T,E,M,B,P=self.performance&&self.performance.now?self.performance.now.bind(self.performance):Date.now.bind(Date),V=self.requestAnimationFrame||self.mozRequestAnimationFrame||self.webkitRequestAnimationFrame||self.msRequestAnimationFrame,F=self.cancelAnimationFrame||self.mozCancelAnimationFrame||self.webkitCancelAnimationFrame||self.msCancelAnimationFrame,L={now:P,frame:function(t){var e=V(t);return {cancel:function(){return F(e)}}},getImageData:function(t,e){void 0===e&&(e=0);var r=self.document.createElement("canvas"),n=r.getContext("2d");if(!n)throw new Error("failed to create canvas 2d context");return r.width=t.width,r.height=t.height,n.drawImage(t,0,0,t.width,t.height),n.getImageData(-e,-e,t.width+2*e,t.height+2*e)},resolveURL:function(t){return T||(T=self.document.createElement("a")),T.href=t,T.href},hardwareConcurrency:self.navigator.hardwareConcurrency||4,get devicePixelRatio(){return self.devicePixelRatio},get prefersReducedMotion(){return !!self.matchMedia&&(null==E&&(E=self.matchMedia("(prefers-reduced-motion: reduce)")),E.matches)}},D={API_URL:"https://api.mapbox.com",get EVENTS_URL(){return this.API_URL?0===this.API_URL.indexOf("https://api.mapbox.cn")?"https://events.mapbox.cn/events/v2":0===this.API_URL.indexOf("https://api.mapbox.com")?"https://events.mapbox.com/events/v2":null:null},FEEDBACK_URL:"https://apps.mapbox.com/feedback",REQUIRE_ACCESS_TOKEN:!0,ACCESS_TOKEN:null,MAX_PARALLEL_IMAGE_REQUESTS:16},O={supported:!1,testSupport:function(t){if(R||!B)return;U?j(t):M=t;}},R=!1,U=!1;function j(t){var e=t.createTexture();t.bindTexture(t.TEXTURE_2D,e);try{if(t.texImage2D(t.TEXTURE_2D,0,t.RGBA,t.RGBA,t.UNSIGNED_BYTE,B),t.isContextLost())return;O.supported=!0;}catch(t){}t.deleteTexture(e),R=!0;}self.document&&((B=self.document.createElement("img")).onload=function(){M&&j(M),M=null,U=!0;},B.onerror=function(){R=!0,M=null;},B.src="data:image/webp;base64,UklGRh4AAABXRUJQVlA4TBEAAAAvAQAAAAfQ//73v/+BiOh/AAA=");var q="01";var N=function(t,e){this._transformRequestFn=t,this._customAccessToken=e,this._createSkuToken();};function K(t){return 0===t.indexOf("mapbox:")}N.prototype._createSkuToken=function(){var t=function(){for(var t="",e=0;e<10;e++)t+="0123456789abcdefghijklmnopqrstuvwxyzABCDEFGHIJKLMNOPQRSTUVWXYZ"[Math.floor(62*Math.random())];return {token:["1",q,t].join(""),tokenExpiresAt:Date.now()+432e5}}();this._skuToken=t.token,this._skuTokenExpiresAt=t.tokenExpiresAt;},N.prototype._isSkuTokenExpired=function(){return Date.now()>this._skuTokenExpiresAt},N.prototype.transformRequest=function(t,e){return this._transformRequestFn&&this._transformRequestFn(t,e)||{url:t}},N.prototype.normalizeStyleURL=function(t,e){if(!K(t))return t;var r=J(t);return r.path="/styles/v1"+r.path,this._makeAPIURL(r,this._customAccessToken||e)},N.prototype.normalizeGlyphsURL=function(t,e){if(!K(t))return t;var r=J(t);return r.path="/fonts/v1"+r.path,this._makeAPIURL(r,this._customAccessToken||e)},N.prototype.normalizeSourceURL=function(t,e){if(!K(t))return t;var r=J(t);return r.path="/v4/"+r.authority+".json",r.params.push("secure"),this._makeAPIURL(r,this._customAccessToken||e)},N.prototype.normalizeSpriteURL=function(t,e,r,n){var i=J(t);return K(t)?(i.path="/styles/v1"+i.path+"/sprite"+e+r,this._makeAPIURL(i,this._customAccessToken||n)):(i.path+=""+e+r,Y(i))},N.prototype.normalizeTileURL=function(t,e){if(this._isSkuTokenExpired()&&this._createSkuToken(),t&&!K(t))return t;var r=J(t),n=L.devicePixelRatio>=2||512===e?"@2x":"",i=O.supported?".webp":"$1";r.path=r.path.replace(/(\.(png|jpg)\d*)(?=$)/,""+n+i),r.path=r.path.replace(/^.+\/v4\//,"/"),r.path="/v4"+r.path;var a=this._customAccessToken||function(t){for(var e=0,r=t;e<r.length;e+=1){var n=r[e].match(/^access_token=(.*)$/);if(n)return n[1]}return null}(r.params)||D.ACCESS_TOKEN;return D.REQUIRE_ACCESS_TOKEN&&a&&this._skuToken&&r.params.push("sku="+this._skuToken),this._makeAPIURL(r,a)},N.prototype.canonicalizeTileURL=function(t,e){var r=J(t);if(!r.path.match(/(^\/v4\/)/)||!r.path.match(/\.[\w]+$/))return t;var n="mapbox://tiles/";n+=r.path.replace("/v4/","");var i=r.params;return e&&(i=i.filter((function(t){return !t.match(/^access_token=/)}))),i.length&&(n+="?"+i.join("&")),n},N.prototype.canonicalizeTileset=function(t,e){for(var r=!!e&&K(e),n=[],i=0,a=t.tiles||[];i<a.length;i+=1){var o=a[i];Z(o)?n.push(this.canonicalizeTileURL(o,r)):n.push(o);}return n},N.prototype._makeAPIURL=function(t,e){var r="See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes",n=J(D.API_URL);if(t.protocol=n.protocol,t.authority=n.authority,"/"!==n.path&&(t.path=""+n.path+t.path),!D.REQUIRE_ACCESS_TOKEN)return Y(t);if(!(e=e||D.ACCESS_TOKEN))throw new Error("An API access token is required to use Mapbox GL. "+r);if("s"===e[0])throw new Error("Use a public access token (pk.*) with Mapbox GL, not a secret access token (sk.*). "+r);return t.params=t.params.filter((function(t){return -1===t.indexOf("access_token")})),t.params.push("access_token="+e),Y(t)};var X=/^((https?:)?\/\/)?([^\/]+\.)?mapbox\.c(n|om)(\/|\?|$)/i;function Z(t){return X.test(t)}var G=/^(\w+):\/\/([^/?]*)(\/[^?]+)?\??(.+)?/;function J(t){var e=t.match(G);if(!e)throw new Error("Unable to parse URL object");return {protocol:e[1],authority:e[2],path:e[3]||"/",params:e[4]?e[4].split("&"):[]}}function Y(t){var e=t.params.length?"?"+t.params.join("&"):"";return t.protocol+"://"+t.authority+t.path+e}function H(t){if(!t)return null;var e,r=t.split(".");if(!r||3!==r.length)return null;try{return JSON.parse((e=r[1],decodeURIComponent(self.atob(e).split("").map((function(t){return "%"+("00"+t.charCodeAt(0).toString(16)).slice(-2)})).join(""))))}catch(t){return null}}var $=function(t){this.type=t,this.anonId=null,this.eventData={},this.queue=[],this.pendingRequest=null;};$.prototype.getStorageKey=function(t){var e,r=H(D.ACCESS_TOKEN),n="";return r&&r.u?(e=r.u,n=self.btoa(encodeURIComponent(e).replace(/%([0-9A-F]{2})/g,(function(t,e){return String.fromCharCode(Number("0x"+e))})))):n=D.ACCESS_TOKEN||"",t?"mapbox.eventData."+t+":"+n:"mapbox.eventData:"+n},$.prototype.fetchEventData=function(){var t=C("localStorage"),e=this.getStorageKey(),r=this.getStorageKey("uuid");if(t)try{var n=self.localStorage.getItem(e);n&&(this.eventData=JSON.parse(n));var i=self.localStorage.getItem(r);i&&(this.anonId=i);}catch(t){_("Unable to read from LocalStorage");}},$.prototype.saveEventData=function(){var t=C("localStorage"),e=this.getStorageKey(),r=this.getStorageKey("uuid");if(t)try{self.localStorage.setItem(r,this.anonId),Object.keys(this.eventData).length>=1&&self.localStorage.setItem(e,JSON.stringify(this.eventData));}catch(t){_("Unable to write to LocalStorage");}},$.prototype.processRequests=function(t){},$.prototype.postEvent=function(t,e,r,n){var i=this;if(D.EVENTS_URL){var a=J(D.EVENTS_URL);a.params.push("access_token="+(n||D.ACCESS_TOKEN||""));var o={event:this.type,created:new Date(t).toISOString(),sdkIdentifier:"mapbox-gl-js",sdkVersion:"1.8.0",skuId:q,userId:this.anonId},s=e?p(o,e):o,u={url:Y(a),headers:{"Content-Type":"text/plain"},body:JSON.stringify([s])};this.pendingRequest=wt(u,(function(t){i.pendingRequest=null,r(t),i.saveEventData(),i.processRequests(n);}));}},$.prototype.queueRequest=function(t,e){this.queue.push(t),this.processRequests(e);};var W,Q,tt=function(t){function e(){t.call(this,"map.load"),this.success={},this.skuToken="";}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.postMapLoadEvent=function(t,e,r,n){this.skuToken=r,(D.EVENTS_URL&&n||D.ACCESS_TOKEN&&Array.isArray(t)&&t.some((function(t){return K(t)||Z(t)})))&&this.queueRequest({id:e,timestamp:Date.now()},n);},e.prototype.processRequests=function(t){var e=this;if(!this.pendingRequest&&0!==this.queue.length){var r=this.queue.shift(),n=r.id,i=r.timestamp;n&&this.success[n]||(this.anonId||this.fetchEventData(),y(this.anonId)||(this.anonId=f()),this.postEvent(i,{skuToken:this.skuToken},(function(t){t||n&&(e.success[n]=!0);}),t));}},e}($),et=new(function(t){function e(e){t.call(this,"appUserTurnstile"),this._customAccessToken=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.postTurnstileEvent=function(t,e){D.EVENTS_URL&&D.ACCESS_TOKEN&&Array.isArray(t)&&t.some((function(t){return K(t)||Z(t)}))&&this.queueRequest(Date.now(),e);},e.prototype.processRequests=function(t){var e=this;if(!this.pendingRequest&&0!==this.queue.length){this.anonId&&this.eventData.lastSuccess&&this.eventData.tokenU||this.fetchEventData();var r=H(D.ACCESS_TOKEN),n=r?r.u:D.ACCESS_TOKEN,i=n!==this.eventData.tokenU;y(this.anonId)||(this.anonId=f(),i=!0);var a=this.queue.shift();if(this.eventData.lastSuccess){var o=new Date(this.eventData.lastSuccess),s=new Date(a),u=(a-this.eventData.lastSuccess)/864e5;i=i||u>=1||u<-1||o.getDate()!==s.getDate();}else i=!0;if(!i)return this.processRequests();this.postEvent(a,{"enabled.telemetry":!1},(function(t){t||(e.eventData.lastSuccess=a,e.eventData.tokenU=n);}),t);}},e}($)),rt=et.postTurnstileEvent.bind(et),nt=new tt,it=nt.postMapLoadEvent.bind(nt),at="mapbox-tiles",ot=500,st=50,ut=42e4;function lt(){self.caches&&!W&&(W=self.caches.open(at));}function pt(t,e,r){if(lt(),W){var n={status:e.status,statusText:e.statusText,headers:new self.Headers};e.headers.forEach((function(t,e){return n.headers.set(e,t)}));var i=k(e.headers.get("Cache-Control")||"");if(!i["no-store"])i["max-age"]&&n.headers.set("Expires",new Date(r+1e3*i["max-age"]).toUTCString()),new Date(n.headers.get("Expires")).getTime()-r<ut||function(t,e){if(void 0===Q)try{new Response(new ReadableStream),Q=!0;}catch(t){Q=!1;}Q?e(t.body):t.blob().then(e);}(e,(function(e){var r=new self.Response(e,n);lt(),W&&W.then((function(e){return e.put(ct(t.url),r)})).catch((function(t){return _(t.message)}));}));}}function ct(t){var e=t.indexOf("?");return e<0?t:t.slice(0,e)}function ht(t,e){if(lt(),!W)return e(null);var r=ct(t.url);W.then((function(t){t.match(r).then((function(n){var i=function(t){if(!t)return !1;var e=new Date(t.headers.get("Expires")||0),r=k(t.headers.get("Cache-Control")||"");return e>Date.now()&&!r["no-cache"]}(n);t.delete(r),i&&t.put(r,n.clone()),e(null,n,i);})).catch(e);})).catch(e);}var ft,yt=1/0;function dt(){return null==ft&&(ft=self.OffscreenCanvas&&new self.OffscreenCanvas(1,1).getContext("2d")&&"function"==typeof self.createImageBitmap),ft}var mt={Unknown:"Unknown",Style:"Style",Source:"Source",Tile:"Tile",Glyphs:"Glyphs",SpriteImage:"SpriteImage",SpriteJSON:"SpriteJSON",Image:"Image"};"function"==typeof Object.freeze&&Object.freeze(mt);var vt=function(t){function e(e,r,n){401===r&&Z(n)&&(e+=": you may have provided an invalid Mapbox access token. See https://www.mapbox.com/api-documentation/#access-tokens-and-token-scopes"),t.call(this,e),this.status=r,this.url=n,this.name=this.constructor.name,this.message=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.toString=function(){return this.name+": "+this.message+" ("+this.status+"): "+this.url},e}(Error),gt=S()?function(){return self.worker&&self.worker.referrer}:function(){return ("blob:"===self.location.protocol?self.parent:self).location.href};function xt(t,e){var r,n=new self.AbortController,i=new self.Request(t.url,{method:t.method||"GET",body:t.body,credentials:t.credentials,headers:t.headers,referrer:gt(),signal:n.signal}),a=!1,o=!1,s=(r=i.url).indexOf("sku=")>0&&Z(r);"json"===t.type&&i.headers.set("Accept","application/json");var u=function(r,n,a){if(!o){if(r&&"SecurityError"!==r.message&&_(r),n&&a)return l(n);var u=Date.now();self.fetch(i).then((function(r){if(r.ok){var n=s?r.clone():null;return l(r,n,u)}return e(new vt(r.statusText,r.status,t.url))})).catch((function(t){20!==t.code&&e(new Error(t.message));}));}},l=function(r,n,s){("arrayBuffer"===t.type?r.arrayBuffer():"json"===t.type?r.json():r.text()).then((function(t){o||(n&&s&&pt(i,n,s),a=!0,e(null,t,r.headers.get("Cache-Control"),r.headers.get("Expires")));})).catch((function(t){o||e(new Error(t.message));}));};return s?ht(i,u):u(null,null),{cancel:function(){o=!0,a||n.abort();}}}var bt=function(t,e){if(r=t.url,!(/^file:/.test(r)||/^file:/.test(gt())&&!/^\w+:/.test(r))){if(self.fetch&&self.Request&&self.AbortController&&self.Request.prototype.hasOwnProperty("signal"))return xt(t,e);if(S()&&self.worker&&self.worker.actor){return self.worker.actor.send("getResource",t,e,void 0,!0)}}var r;return function(t,e){var r=new self.XMLHttpRequest;for(var n in r.open(t.method||"GET",t.url,!0),"arrayBuffer"===t.type&&(r.responseType="arraybuffer"),t.headers)r.setRequestHeader(n,t.headers[n]);return "json"===t.type&&(r.responseType="text",r.setRequestHeader("Accept","application/json")),r.withCredentials="include"===t.credentials,r.onerror=function(){e(new Error(r.statusText));},r.onload=function(){if((r.status>=200&&r.status<300||0===r.status)&&null!==r.response){var n=r.response;if("json"===t.type)try{n=JSON.parse(r.response);}catch(t){return e(t)}e(null,n,r.getResponseHeader("Cache-Control"),r.getResponseHeader("Expires"));}else e(new vt(r.statusText,r.status,t.url));},r.send(t.body),{cancel:function(){return r.abort()}}}(t,e)},_t=function(t,e){return bt(p(t,{type:"arrayBuffer"}),e)},wt=function(t,e){return bt(p(t,{method:"POST"}),e)};var At,St,kt="data:image/png;base64,iVBORw0KGgoAAAANSUhEUgAAAAEAAAABCAYAAAAfFcSJAAAAC0lEQVQYV2NgAAIAAAUAAarVyFEAAAAASUVORK5CYII=";At=[],St=0;var It=function(t,e){if(O.supported&&(t.headers||(t.headers={}),t.headers.accept="image/webp,*/*"),St>=D.MAX_PARALLEL_IMAGE_REQUESTS){var r={requestParameters:t,callback:e,cancelled:!1,cancel:function(){this.cancelled=!0;}};return At.push(r),r}St++;var n=!1,i=function(){if(!n)for(n=!0,St--;At.length&&St<D.MAX_PARALLEL_IMAGE_REQUESTS;){var t=At.shift(),e=t.requestParameters,r=t.callback;t.cancelled||(t.cancel=It(e,r).cancel);}},a=_t(t,(function(t,r,n,a){i(),t?e(t):r&&(dt()?function(t,e){var r=new self.Blob([new Uint8Array(t)],{type:"image/png"});self.createImageBitmap(r).then((function(t){e(null,t);})).catch((function(t){e(new Error("Could not load image because of "+t.message+". Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."));}));}(r,e):function(t,e,r,n){var i=new self.Image,a=self.URL;i.onload=function(){e(null,i),a.revokeObjectURL(i.src);},i.onerror=function(){return e(new Error("Could not load image. Please make sure to use a supported image type such as PNG or JPEG. Note that SVGs are not supported."))};var o=new self.Blob([new Uint8Array(t)],{type:"image/png"});i.cacheControl=r,i.expires=n,i.src=t.byteLength?a.createObjectURL(o):kt;}(r,e,n,a));}));return {cancel:function(){a.cancel(),i();}}};function zt(t,e,r){r[t]&&-1!==r[t].indexOf(e)||(r[t]=r[t]||[],r[t].push(e));}function Ct(t,e,r){if(r&&r[t]){var n=r[t].indexOf(e);-1!==n&&r[t].splice(n,1);}}var Tt=function(t,e){void 0===e&&(e={}),p(this,e),this.type=t;},Et=function(t){function e(e,r){void 0===r&&(r={}),t.call(this,"error",p({error:e},r));}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Tt),Mt=function(){};Mt.prototype.on=function(t,e){return this._listeners=this._listeners||{},zt(t,e,this._listeners),this},Mt.prototype.off=function(t,e){return Ct(t,e,this._listeners),Ct(t,e,this._oneTimeListeners),this},Mt.prototype.once=function(t,e){return this._oneTimeListeners=this._oneTimeListeners||{},zt(t,e,this._oneTimeListeners),this},Mt.prototype.fire=function(t,e){"string"==typeof t&&(t=new Tt(t,e||{}));var r=t.type;if(this.listens(r)){t.target=this;for(var n=0,i=this._listeners&&this._listeners[r]?this._listeners[r].slice():[];n<i.length;n+=1){i[n].call(this,t);}for(var a=0,o=this._oneTimeListeners&&this._oneTimeListeners[r]?this._oneTimeListeners[r].slice():[];a<o.length;a+=1){var s=o[a];Ct(r,s,this._oneTimeListeners),s.call(this,t);}var u=this._eventedParent;u&&(p(t,"function"==typeof this._eventedParentData?this._eventedParentData():this._eventedParentData),u.fire(t));}else t instanceof Et&&console.error(t.error);return this},Mt.prototype.listens=function(t){return this._listeners&&this._listeners[t]&&this._listeners[t].length>0||this._oneTimeListeners&&this._oneTimeListeners[t]&&this._oneTimeListeners[t].length>0||this._eventedParent&&this._eventedParent.listens(t)},Mt.prototype.setEventedParent=function(t,e){return this._eventedParent=t,this._eventedParentData=e,this};var Bt={$version:8,$root:{version:{required:!0,type:"enum",values:[8]},name:{type:"string"},metadata:{type:"*"},center:{type:"array",value:"number"},zoom:{type:"number"},bearing:{type:"number",default:0,period:360,units:"degrees"},pitch:{type:"number",default:0,units:"degrees"},light:{type:"light"},sources:{required:!0,type:"sources"},sprite:{type:"string"},glyphs:{type:"string"},transition:{type:"transition"},layers:{required:!0,type:"array",value:"layer"}},sources:{"*":{type:"source"}},source:["source_vector","source_raster","source_raster_dem","source_geojson","source_video","source_image"],source_vector:{type:{required:!0,type:"enum",values:{vector:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},attribution:{type:"string"},promoteId:{type:"promoteId"},"*":{type:"*"}},source_raster:{type:{required:!0,type:"enum",values:{raster:{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},scheme:{type:"enum",values:{xyz:{},tms:{}},default:"xyz"},attribution:{type:"string"},"*":{type:"*"}},source_raster_dem:{type:{required:!0,type:"enum",values:{"raster-dem":{}}},url:{type:"string"},tiles:{type:"array",value:"string"},bounds:{type:"array",value:"number",length:4,default:[-180,-85.051129,180,85.051129]},minzoom:{type:"number",default:0},maxzoom:{type:"number",default:22},tileSize:{type:"number",default:512,units:"pixels"},attribution:{type:"string"},encoding:{type:"enum",values:{terrarium:{},mapbox:{}},default:"mapbox"},"*":{type:"*"}},source_geojson:{type:{required:!0,type:"enum",values:{geojson:{}}},data:{type:"*"},maxzoom:{type:"number",default:18},attribution:{type:"string"},buffer:{type:"number",default:128,maximum:512,minimum:0},tolerance:{type:"number",default:.375},cluster:{type:"boolean",default:!1},clusterRadius:{type:"number",default:50,minimum:0},clusterMaxZoom:{type:"number"},clusterProperties:{type:"*"},lineMetrics:{type:"boolean",default:!1},generateId:{type:"boolean",default:!1},promoteId:{type:"promoteId"}},source_video:{type:{required:!0,type:"enum",values:{video:{}}},urls:{required:!0,type:"array",value:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},source_image:{type:{required:!0,type:"enum",values:{image:{}}},url:{required:!0,type:"string"},coordinates:{required:!0,type:"array",length:4,value:{type:"array",length:2,value:"number"}}},layer:{id:{type:"string",required:!0},type:{type:"enum",values:{fill:{},line:{},symbol:{},circle:{},heatmap:{},"fill-extrusion":{},raster:{},hillshade:{},background:{}},required:!0},metadata:{type:"*"},source:{type:"string"},"source-layer":{type:"string"},minzoom:{type:"number",minimum:0,maximum:24},maxzoom:{type:"number",minimum:0,maximum:24},filter:{type:"filter"},layout:{type:"layout"},paint:{type:"paint"}},layout:["layout_fill","layout_line","layout_circle","layout_heatmap","layout_fill-extrusion","layout_symbol","layout_raster","layout_hillshade","layout_background"],layout_background:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_fill:{"fill-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_circle:{"circle-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_heatmap:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},"layout_fill-extrusion":{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_line:{"line-cap":{type:"enum",values:{butt:{},round:{},square:{}},default:"butt",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-join":{type:"enum",values:{bevel:{},round:{},miter:{}},default:"miter",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"line-miter-limit":{type:"number",default:2,requires:[{"line-join":"miter"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-round-limit":{type:"number",default:1.05,requires:[{"line-join":"round"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_symbol:{"symbol-placement":{type:"enum",values:{point:{},line:{},"line-center":{}},default:"point",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-spacing":{type:"number",default:250,minimum:1,units:"pixels",requires:[{"symbol-placement":"line"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"symbol-avoid-edges":{type:"boolean",default:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"symbol-sort-key":{type:"number",expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"symbol-z-order":{type:"enum",values:{auto:{},"viewport-y":{},source:{}},default:"auto",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-allow-overlap":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-ignore-placement":{type:"boolean",default:!1,requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-optional":{type:"boolean",default:!1,requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-size":{type:"number",default:1,minimum:0,units:"factor of the original icon size",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-text-fit":{type:"enum",values:{none:{},width:{},height:{},both:{}},default:"none",requires:["icon-image","text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-text-fit-padding":{type:"array",value:"number",length:4,default:[0,0,0,0],units:"pixels",requires:["icon-image","text-field",{"icon-text-fit":["both","width","height"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-image":{type:"resolvedImage",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-keep-upright":{type:"boolean",default:!1,requires:["icon-image",{"icon-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"icon-offset":{type:"array",value:"number",length:2,default:[0,0],requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"icon-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-pitch-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotation-alignment":{type:"enum",values:{map:{},viewport:{},auto:{}},default:"auto",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-field":{type:"formatted",default:"",tokens:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-font":{type:"array",value:"string",default:["Open Sans Regular","Arial Unicode MS Regular"],requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-size":{type:"number",default:16,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-width":{type:"number",default:10,minimum:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-line-height":{type:"number",default:1.2,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-letter-spacing":{type:"number",default:0,units:"ems",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-justify":{type:"enum",values:{auto:{},left:{},center:{},right:{}},default:"center",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-radial-offset":{type:"number",units:"ems",default:0,requires:["text-field"],"property-type":"data-driven",expression:{interpolated:!0,parameters:["zoom","feature"]}},"text-variable-anchor":{type:"array",value:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},requires:["text-field",{"symbol-placement":["point"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-anchor":{type:"enum",values:{center:{},left:{},right:{},top:{},bottom:{},"top-left":{},"top-right":{},"bottom-left":{},"bottom-right":{}},default:"center",requires:["text-field",{"!":"text-variable-anchor"}],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-max-angle":{type:"number",default:45,units:"degrees",requires:["text-field",{"symbol-placement":["line","line-center"]}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-writing-mode":{type:"array",value:"enum",values:{horizontal:{},vertical:{}},requires:["text-field",{"symbol-placement":["point"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-rotate":{type:"number",default:0,period:360,units:"degrees",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-padding":{type:"number",default:2,minimum:0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-keep-upright":{type:"boolean",default:!0,requires:["text-field",{"text-rotation-alignment":"map"},{"symbol-placement":["line","line-center"]}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-transform":{type:"enum",values:{none:{},uppercase:{},lowercase:{}},default:"none",requires:["text-field"],expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-offset":{type:"array",value:"number",units:"ems",length:2,default:[0,0],requires:["text-field",{"!":"text-radial-offset"}],expression:{interpolated:!0,parameters:["zoom","feature"]},"property-type":"data-driven"},"text-allow-overlap":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-ignore-placement":{type:"boolean",default:!1,requires:["text-field"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-optional":{type:"boolean",default:!1,requires:["text-field","icon-image"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_raster:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},layout_hillshade:{visibility:{type:"enum",values:{visible:{},none:{}},default:"visible","property-type":"constant"}},filter:{type:"array",value:"*"},filter_operator:{type:"enum",values:{"==":{},"!=":{},">":{},">=":{},"<":{},"<=":{},in:{},"!in":{},all:{},any:{},none:{},has:{},"!has":{}}},geometry_type:{type:"enum",values:{Point:{},LineString:{},Polygon:{}}},function:{expression:{type:"expression"},stops:{type:"array",value:"function_stop"},base:{type:"number",default:1,minimum:0},property:{type:"string",default:"$zoom"},type:{type:"enum",values:{identity:{},exponential:{},interval:{},categorical:{}},default:"exponential"},colorSpace:{type:"enum",values:{rgb:{},lab:{},hcl:{}},default:"rgb"},default:{type:"*",required:!1}},function_stop:{type:"array",minimum:0,maximum:24,value:["number","color"],length:2},expression:{type:"array",value:"*",minimum:1},expression_name:{type:"enum",values:{let:{group:"Variable binding"},var:{group:"Variable binding"},literal:{group:"Types"},array:{group:"Types"},at:{group:"Lookup"},in:{group:"Lookup"},case:{group:"Decision"},match:{group:"Decision"},coalesce:{group:"Decision"},step:{group:"Ramps, scales, curves"},interpolate:{group:"Ramps, scales, curves"},"interpolate-hcl":{group:"Ramps, scales, curves"},"interpolate-lab":{group:"Ramps, scales, curves"},ln2:{group:"Math"},pi:{group:"Math"},e:{group:"Math"},typeof:{group:"Types"},string:{group:"Types"},number:{group:"Types"},boolean:{group:"Types"},object:{group:"Types"},collator:{group:"Types"},format:{group:"Types"},image:{group:"Types"},"number-format":{group:"Types"},"to-string":{group:"Types"},"to-number":{group:"Types"},"to-boolean":{group:"Types"},"to-rgba":{group:"Color"},"to-color":{group:"Types"},rgb:{group:"Color"},rgba:{group:"Color"},get:{group:"Lookup"},has:{group:"Lookup"},length:{group:"Lookup"},properties:{group:"Feature data"},"feature-state":{group:"Feature data"},"geometry-type":{group:"Feature data"},id:{group:"Feature data"},zoom:{group:"Zoom"},"heatmap-density":{group:"Heatmap"},"line-progress":{group:"Feature data"},accumulated:{group:"Feature data"},"+":{group:"Math"},"*":{group:"Math"},"-":{group:"Math"},"/":{group:"Math"},"%":{group:"Math"},"^":{group:"Math"},sqrt:{group:"Math"},log10:{group:"Math"},ln:{group:"Math"},log2:{group:"Math"},sin:{group:"Math"},cos:{group:"Math"},tan:{group:"Math"},asin:{group:"Math"},acos:{group:"Math"},atan:{group:"Math"},min:{group:"Math"},max:{group:"Math"},round:{group:"Math"},abs:{group:"Math"},ceil:{group:"Math"},floor:{group:"Math"},"==":{group:"Decision"},"!=":{group:"Decision"},">":{group:"Decision"},"<":{group:"Decision"},">=":{group:"Decision"},"<=":{group:"Decision"},all:{group:"Decision"},any:{group:"Decision"},"!":{group:"Decision"},"is-supported-script":{group:"String"},upcase:{group:"String"},downcase:{group:"String"},concat:{group:"String"},"resolved-locale":{group:"String"}}},light:{anchor:{type:"enum",default:"viewport",values:{map:{},viewport:{}},"property-type":"data-constant",transition:!1,expression:{interpolated:!1,parameters:["zoom"]}},position:{type:"array",default:[1.15,210,30],length:3,value:"number","property-type":"data-constant",transition:!0,expression:{interpolated:!0,parameters:["zoom"]}},color:{type:"color","property-type":"data-constant",default:"#ffffff",expression:{interpolated:!0,parameters:["zoom"]},transition:!0},intensity:{type:"number","property-type":"data-constant",default:.5,minimum:0,maximum:1,expression:{interpolated:!0,parameters:["zoom"]},transition:!0}},paint:["paint_fill","paint_line","paint_circle","paint_heatmap","paint_fill-extrusion","paint_symbol","paint_raster","paint_hillshade","paint_background"],paint_fill:{"fill-antialias":{type:"boolean",default:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-outline-color":{type:"color",transition:!0,requires:[{"!":"fill-pattern"},{"fill-antialias":!0}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"}},"paint_fill-extrusion":{"fill-extrusion-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"fill-extrusion-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["fill-extrusion-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"fill-extrusion-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"fill-extrusion-height":{type:"number",default:0,minimum:0,units:"meters",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-base":{type:"number",default:0,minimum:0,units:"meters",transition:!0,requires:["fill-extrusion-height"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"fill-extrusion-vertical-gradient":{type:"boolean",default:!0,transition:!1,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_line:{"line-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"line-pattern"}],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"line-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["line-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"line-width":{type:"number",default:1,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-gap-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-offset":{type:"number",default:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"line-dasharray":{type:"array",value:"number",minimum:0,transition:!0,units:"line widths",requires:[{"!":"line-pattern"}],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"line-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom","feature"]},"property-type":"cross-faded-data-driven"},"line-gradient":{type:"color",transition:!1,requires:[{"!":"line-dasharray"},{"!":"line-pattern"},{source:"geojson",has:{lineMetrics:!0}}],expression:{interpolated:!0,parameters:["line-progress"]},"property-type":"color-ramp"}},paint_circle:{"circle-radius":{type:"number",default:5,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-blur":{type:"number",default:0,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"circle-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["circle-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-scale":{type:"enum",values:{map:{},viewport:{}},default:"map",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-pitch-alignment":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"circle-stroke-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"circle-stroke-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"}},paint_heatmap:{"heatmap-radius":{type:"number",default:30,minimum:1,transition:!0,units:"pixels",expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-weight":{type:"number",default:1,minimum:0,transition:!1,expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"heatmap-intensity":{type:"number",default:1,minimum:0,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"heatmap-color":{type:"color",default:["interpolate",["linear"],["heatmap-density"],0,"rgba(0, 0, 255, 0)",.1,"royalblue",.3,"cyan",.5,"lime",.7,"yellow",1,"red"],transition:!1,expression:{interpolated:!0,parameters:["heatmap-density"]},"property-type":"color-ramp"},"heatmap-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_symbol:{"icon-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-color":{type:"color",default:"#000000",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"icon-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["icon-image"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"icon-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["icon-image","icon-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"text-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-color":{type:"color",default:"#000000",transition:!0,overridable:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-color":{type:"color",default:"rgba(0, 0, 0, 0)",transition:!0,requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-width":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-halo-blur":{type:"number",default:0,minimum:0,transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom","feature","feature-state"]},"property-type":"data-driven"},"text-translate":{type:"array",value:"number",length:2,default:[0,0],transition:!0,units:"pixels",requires:["text-field"],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"text-translate-anchor":{type:"enum",values:{map:{},viewport:{}},default:"map",requires:["text-field","text-translate"],expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"}},paint_raster:{"raster-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-hue-rotate":{type:"number",default:0,period:360,transition:!0,units:"degrees",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-min":{type:"number",default:0,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-brightness-max":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-saturation":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-contrast":{type:"number",default:0,minimum:-1,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"raster-resampling":{type:"enum",values:{linear:{},nearest:{}},default:"linear",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"raster-fade-duration":{type:"number",default:300,minimum:0,transition:!1,units:"milliseconds",expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_hillshade:{"hillshade-illumination-direction":{type:"number",default:335,minimum:0,maximum:359,transition:!1,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-illumination-anchor":{type:"enum",values:{map:{},viewport:{}},default:"viewport",expression:{interpolated:!1,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-exaggeration":{type:"number",default:.5,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-shadow-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-highlight-color":{type:"color",default:"#FFFFFF",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"hillshade-accent-color":{type:"color",default:"#000000",transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},paint_background:{"background-color":{type:"color",default:"#000000",transition:!0,requires:[{"!":"background-pattern"}],expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"},"background-pattern":{type:"resolvedImage",transition:!0,expression:{interpolated:!1,parameters:["zoom"]},"property-type":"cross-faded"},"background-opacity":{type:"number",default:1,minimum:0,maximum:1,transition:!0,expression:{interpolated:!0,parameters:["zoom"]},"property-type":"data-constant"}},transition:{duration:{type:"number",default:300,minimum:0,units:"milliseconds"},delay:{type:"number",default:0,minimum:0,units:"milliseconds"}},"property-type":{"data-driven":{type:"property-type"},"cross-faded":{type:"property-type"},"cross-faded-data-driven":{type:"property-type"},"color-ramp":{type:"property-type"},"data-constant":{type:"property-type"},constant:{type:"property-type"}},promoteId:{"*":{type:"string"}}},Pt=function(t,e,r,n){this.message=(t?t+": ":"")+r,n&&(this.identifier=n),null!=e&&e.__line__&&(this.line=e.__line__);};function Vt(t){var e=t.key,r=t.value;return r?[new Pt(e,r,"constants have been deprecated as of v8")]:[]}function Ft(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];for(var n=0,i=e;n<i.length;n+=1){var a=i[n];for(var o in a)t[o]=a[o];}return t}function Lt(t){return t instanceof Number||t instanceof String||t instanceof Boolean?t.valueOf():t}function Dt(t){if(Array.isArray(t))return t.map(Dt);if(t instanceof Object&&!(t instanceof Number||t instanceof String||t instanceof Boolean)){var e={};for(var r in t)e[r]=Dt(t[r]);return e}return Lt(t)}var Ot=function(t){function e(e,r){t.call(this,r),this.message=r,this.key=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(Error),Rt=function(t,e){void 0===e&&(e=[]),this.parent=t,this.bindings={};for(var r=0,n=e;r<n.length;r+=1){var i=n[r],a=i[0],o=i[1];this.bindings[a]=o;}};Rt.prototype.concat=function(t){return new Rt(this,t)},Rt.prototype.get=function(t){if(this.bindings[t])return this.bindings[t];if(this.parent)return this.parent.get(t);throw new Error(t+" not found in scope.")},Rt.prototype.has=function(t){return !!this.bindings[t]||!!this.parent&&this.parent.has(t)};var Ut={kind:"null"},jt={kind:"number"},qt={kind:"string"},Nt={kind:"boolean"},Kt={kind:"color"},Xt={kind:"object"},Zt={kind:"value"},Gt={kind:"collator"},Jt={kind:"formatted"},Yt={kind:"resolvedImage"};function Ht(t,e){return {kind:"array",itemType:t,N:e}}function $t(t){if("array"===t.kind){var e=$t(t.itemType);return "number"==typeof t.N?"array<"+e+", "+t.N+">":"value"===t.itemType.kind?"array":"array<"+e+">"}return t.kind}var Wt=[Ut,jt,qt,Nt,Kt,Jt,Xt,Ht(Zt),Yt];function Qt(t,e){if("error"===e.kind)return null;if("array"===t.kind){if("array"===e.kind&&(0===e.N&&"value"===e.itemType.kind||!Qt(t.itemType,e.itemType))&&("number"!=typeof t.N||t.N===e.N))return null}else{if(t.kind===e.kind)return null;if("value"===t.kind)for(var r=0,n=Wt;r<n.length;r+=1){if(!Qt(n[r],e))return null}}return "Expected "+$t(t)+" but found "+$t(e)+" instead."}var te=e((function(t,e){var r={transparent:[0,0,0,0],aliceblue:[240,248,255,1],antiquewhite:[250,235,215,1],aqua:[0,255,255,1],aquamarine:[127,255,212,1],azure:[240,255,255,1],beige:[245,245,220,1],bisque:[255,228,196,1],black:[0,0,0,1],blanchedalmond:[255,235,205,1],blue:[0,0,255,1],blueviolet:[138,43,226,1],brown:[165,42,42,1],burlywood:[222,184,135,1],cadetblue:[95,158,160,1],chartreuse:[127,255,0,1],chocolate:[210,105,30,1],coral:[255,127,80,1],cornflowerblue:[100,149,237,1],cornsilk:[255,248,220,1],crimson:[220,20,60,1],cyan:[0,255,255,1],darkblue:[0,0,139,1],darkcyan:[0,139,139,1],darkgoldenrod:[184,134,11,1],darkgray:[169,169,169,1],darkgreen:[0,100,0,1],darkgrey:[169,169,169,1],darkkhaki:[189,183,107,1],darkmagenta:[139,0,139,1],darkolivegreen:[85,107,47,1],darkorange:[255,140,0,1],darkorchid:[153,50,204,1],darkred:[139,0,0,1],darksalmon:[233,150,122,1],darkseagreen:[143,188,143,1],darkslateblue:[72,61,139,1],darkslategray:[47,79,79,1],darkslategrey:[47,79,79,1],darkturquoise:[0,206,209,1],darkviolet:[148,0,211,1],deeppink:[255,20,147,1],deepskyblue:[0,191,255,1],dimgray:[105,105,105,1],dimgrey:[105,105,105,1],dodgerblue:[30,144,255,1],firebrick:[178,34,34,1],floralwhite:[255,250,240,1],forestgreen:[34,139,34,1],fuchsia:[255,0,255,1],gainsboro:[220,220,220,1],ghostwhite:[248,248,255,1],gold:[255,215,0,1],goldenrod:[218,165,32,1],gray:[128,128,128,1],green:[0,128,0,1],greenyellow:[173,255,47,1],grey:[128,128,128,1],honeydew:[240,255,240,1],hotpink:[255,105,180,1],indianred:[205,92,92,1],indigo:[75,0,130,1],ivory:[255,255,240,1],khaki:[240,230,140,1],lavender:[230,230,250,1],lavenderblush:[255,240,245,1],lawngreen:[124,252,0,1],lemonchiffon:[255,250,205,1],lightblue:[173,216,230,1],lightcoral:[240,128,128,1],lightcyan:[224,255,255,1],lightgoldenrodyellow:[250,250,210,1],lightgray:[211,211,211,1],lightgreen:[144,238,144,1],lightgrey:[211,211,211,1],lightpink:[255,182,193,1],lightsalmon:[255,160,122,1],lightseagreen:[32,178,170,1],lightskyblue:[135,206,250,1],lightslategray:[119,136,153,1],lightslategrey:[119,136,153,1],lightsteelblue:[176,196,222,1],lightyellow:[255,255,224,1],lime:[0,255,0,1],limegreen:[50,205,50,1],linen:[250,240,230,1],magenta:[255,0,255,1],maroon:[128,0,0,1],mediumaquamarine:[102,205,170,1],mediumblue:[0,0,205,1],mediumorchid:[186,85,211,1],mediumpurple:[147,112,219,1],mediumseagreen:[60,179,113,1],mediumslateblue:[123,104,238,1],mediumspringgreen:[0,250,154,1],mediumturquoise:[72,209,204,1],mediumvioletred:[199,21,133,1],midnightblue:[25,25,112,1],mintcream:[245,255,250,1],mistyrose:[255,228,225,1],moccasin:[255,228,181,1],navajowhite:[255,222,173,1],navy:[0,0,128,1],oldlace:[253,245,230,1],olive:[128,128,0,1],olivedrab:[107,142,35,1],orange:[255,165,0,1],orangered:[255,69,0,1],orchid:[218,112,214,1],palegoldenrod:[238,232,170,1],palegreen:[152,251,152,1],paleturquoise:[175,238,238,1],palevioletred:[219,112,147,1],papayawhip:[255,239,213,1],peachpuff:[255,218,185,1],peru:[205,133,63,1],pink:[255,192,203,1],plum:[221,160,221,1],powderblue:[176,224,230,1],purple:[128,0,128,1],rebeccapurple:[102,51,153,1],red:[255,0,0,1],rosybrown:[188,143,143,1],royalblue:[65,105,225,1],saddlebrown:[139,69,19,1],salmon:[250,128,114,1],sandybrown:[244,164,96,1],seagreen:[46,139,87,1],seashell:[255,245,238,1],sienna:[160,82,45,1],silver:[192,192,192,1],skyblue:[135,206,235,1],slateblue:[106,90,205,1],slategray:[112,128,144,1],slategrey:[112,128,144,1],snow:[255,250,250,1],springgreen:[0,255,127,1],steelblue:[70,130,180,1],tan:[210,180,140,1],teal:[0,128,128,1],thistle:[216,191,216,1],tomato:[255,99,71,1],turquoise:[64,224,208,1],violet:[238,130,238,1],wheat:[245,222,179,1],white:[255,255,255,1],whitesmoke:[245,245,245,1],yellow:[255,255,0,1],yellowgreen:[154,205,50,1]};function n(t){return (t=Math.round(t))<0?0:t>255?255:t}function i(t){return t<0?0:t>1?1:t}function a(t){return "%"===t[t.length-1]?n(parseFloat(t)/100*255):n(parseInt(t))}function o(t){return "%"===t[t.length-1]?i(parseFloat(t)/100):i(parseFloat(t))}function s(t,e,r){return r<0?r+=1:r>1&&(r-=1),6*r<1?t+(e-t)*r*6:2*r<1?e:3*r<2?t+(e-t)*(2/3-r)*6:t}try{e.parseCSSColor=function(t){var e,i=t.replace(/ /g,"").toLowerCase();if(i in r)return r[i].slice();if("#"===i[0])return 4===i.length?(e=parseInt(i.substr(1),16))>=0&&e<=4095?[(3840&e)>>4|(3840&e)>>8,240&e|(240&e)>>4,15&e|(15&e)<<4,1]:null:7===i.length&&(e=parseInt(i.substr(1),16))>=0&&e<=16777215?[(16711680&e)>>16,(65280&e)>>8,255&e,1]:null;var u=i.indexOf("("),l=i.indexOf(")");if(-1!==u&&l+1===i.length){var p=i.substr(0,u),c=i.substr(u+1,l-(u+1)).split(","),h=1;switch(p){case"rgba":if(4!==c.length)return null;h=o(c.pop());case"rgb":return 3!==c.length?null:[a(c[0]),a(c[1]),a(c[2]),h];case"hsla":if(4!==c.length)return null;h=o(c.pop());case"hsl":if(3!==c.length)return null;var f=(parseFloat(c[0])%360+360)%360/360,y=o(c[1]),d=o(c[2]),m=d<=.5?d*(y+1):d+y-d*y,v=2*d-m;return [n(255*s(v,m,f+1/3)),n(255*s(v,m,f)),n(255*s(v,m,f-1/3)),h];default:return null}}return null};}catch(t){}})).parseCSSColor,ee=function(t,e,r,n){void 0===n&&(n=1),this.r=t,this.g=e,this.b=r,this.a=n;};ee.parse=function(t){if(t){if(t instanceof ee)return t;if("string"==typeof t){var e=te(t);if(e)return new ee(e[0]/255*e[3],e[1]/255*e[3],e[2]/255*e[3],e[3])}}},ee.prototype.toString=function(){var t=this.toArray(),e=t[0],r=t[1],n=t[2],i=t[3];return "rgba("+Math.round(e)+","+Math.round(r)+","+Math.round(n)+","+i+")"},ee.prototype.toArray=function(){var t=this.r,e=this.g,r=this.b,n=this.a;return 0===n?[0,0,0,0]:[255*t/n,255*e/n,255*r/n,n]},ee.black=new ee(0,0,0,1),ee.white=new ee(1,1,1,1),ee.transparent=new ee(0,0,0,0),ee.red=new ee(1,0,0,1);var re=function(t,e,r){this.sensitivity=t?e?"variant":"case":e?"accent":"base",this.locale=r,this.collator=new Intl.Collator(this.locale?this.locale:[],{sensitivity:this.sensitivity,usage:"search"});};re.prototype.compare=function(t,e){return this.collator.compare(t,e)},re.prototype.resolvedLocale=function(){return new Intl.Collator(this.locale?this.locale:[]).resolvedOptions().locale};var ne=function(t,e,r,n,i){this.text=t,this.image=e,this.scale=r,this.fontStack=n,this.textColor=i;},ie=function(t){this.sections=t;};ie.fromString=function(t){return new ie([new ne(t,null,null,null,null)])},ie.prototype.isEmpty=function(){return 0===this.sections.length||!this.sections.some((function(t){return 0!==t.text.length||t.image&&0!==t.image.name.length}))},ie.factory=function(t){return t instanceof ie?t:ie.fromString(t)},ie.prototype.toString=function(){return 0===this.sections.length?"":this.sections.map((function(t){return t.text})).join("")},ie.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];if(n.image)t.push(["image",n.image.name]);else{t.push(n.text);var i={};n.fontStack&&(i["text-font"]=["literal",n.fontStack.split(",")]),n.scale&&(i["font-scale"]=n.scale),n.textColor&&(i["text-color"]=["rgba"].concat(n.textColor.toArray())),t.push(i);}}return t};var ae=function(t){this.name=t.name,this.available=t.available;};function oe(t,e,r,n){return "number"==typeof t&&t>=0&&t<=255&&"number"==typeof e&&e>=0&&e<=255&&"number"==typeof r&&r>=0&&r<=255?void 0===n||"number"==typeof n&&n>=0&&n<=1?null:"Invalid rgba value ["+[t,e,r,n].join(", ")+"]: 'a' must be between 0 and 1.":"Invalid rgba value ["+("number"==typeof n?[t,e,r,n]:[t,e,r]).join(", ")+"]: 'r', 'g', and 'b' must be between 0 and 255."}function se(t){if(null===t)return Ut;if("string"==typeof t)return qt;if("boolean"==typeof t)return Nt;if("number"==typeof t)return jt;if(t instanceof ee)return Kt;if(t instanceof re)return Gt;if(t instanceof ie)return Jt;if(t instanceof ae)return Yt;if(Array.isArray(t)){for(var e,r=t.length,n=0,i=t;n<i.length;n+=1){var a=se(i[n]);if(e){if(e===a)continue;e=Zt;break}e=a;}return Ht(e||Zt,r)}return Xt}function ue(t){var e=typeof t;return null===t?"":"string"===e||"number"===e||"boolean"===e?String(t):t instanceof ee||t instanceof ie||t instanceof ae?t.toString():JSON.stringify(t)}ae.prototype.toString=function(){return this.name},ae.fromString=function(t){return new ae({name:t,available:!1})},ae.prototype.serialize=function(){return ["image",this.name]};var le=function(t,e){this.type=t,this.value=e;};le.parse=function(t,e){if(2!==t.length)return e.error("'literal' expression requires exactly one argument, but found "+(t.length-1)+" instead.");if(!function t(e){if(null===e)return !0;if("string"==typeof e)return !0;if("boolean"==typeof e)return !0;if("number"==typeof e)return !0;if(e instanceof ee)return !0;if(e instanceof re)return !0;if(e instanceof ie)return !0;if(e instanceof ae)return !0;if(Array.isArray(e)){for(var r=0,n=e;r<n.length;r+=1){if(!t(n[r]))return !1}return !0}if("object"==typeof e){for(var i in e)if(!t(e[i]))return !1;return !0}return !1}(t[1]))return e.error("invalid value");var r=t[1],n=se(r),i=e.expectedType;return "array"!==n.kind||0!==n.N||!i||"array"!==i.kind||"number"==typeof i.N&&0!==i.N||(n=i),new le(n,r)},le.prototype.evaluate=function(){return this.value},le.prototype.eachChild=function(){},le.prototype.possibleOutputs=function(){return [this.value]},le.prototype.serialize=function(){return "array"===this.type.kind||"object"===this.type.kind?["literal",this.value]:this.value instanceof ee?["rgba"].concat(this.value.toArray()):this.value instanceof ie?this.value.serialize():this.value};var pe=function(t){this.name="ExpressionEvaluationError",this.message=t;};pe.prototype.toJSON=function(){return this.message};var ce={string:qt,number:jt,boolean:Nt,object:Xt},he=function(t,e){this.type=t,this.args=e;};he.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r,n=1,i=t[0];if("array"===i){var a,o;if(t.length>2){var s=t[1];if("string"!=typeof s||!(s in ce)||"object"===s)return e.error('The item type argument of "array" must be one of string, number, boolean',1);a=ce[s],n++;}else a=Zt;if(t.length>3){if(null!==t[2]&&("number"!=typeof t[2]||t[2]<0||t[2]!==Math.floor(t[2])))return e.error('The length argument to "array" must be a positive integer literal',2);o=t[2],n++;}r=Ht(a,o);}else r=ce[i];for(var u=[];n<t.length;n++){var l=e.parse(t[n],n,Zt);if(!l)return null;u.push(l);}return new he(r,u)},he.prototype.evaluate=function(t){for(var e=0;e<this.args.length;e++){var r=this.args[e].evaluate(t);if(!Qt(this.type,se(r)))return r;if(e===this.args.length-1)throw new pe("Expected value to be of type "+$t(this.type)+", but found "+$t(se(r))+" instead.")}return null},he.prototype.eachChild=function(t){this.args.forEach(t);},he.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.args.map((function(t){return t.possibleOutputs()})))},he.prototype.serialize=function(){var t=this.type,e=[t.kind];if("array"===t.kind){var r=t.itemType;if("string"===r.kind||"number"===r.kind||"boolean"===r.kind){e.push(r.kind);var n=t.N;("number"==typeof n||this.args.length>1)&&e.push(n);}}return e.concat(this.args.map((function(t){return t.serialize()})))};var fe=function(t){this.type=Jt,this.sections=t;};fe.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r=t[1];if(!Array.isArray(r)&&"object"==typeof r)return e.error("First argument must be an image or text section.");for(var n=[],i=!1,a=1;a<=t.length-1;++a){var o=t[a];if(i&&"object"==typeof o&&!Array.isArray(o)){i=!1;var s=null;if(o["font-scale"]&&!(s=e.parse(o["font-scale"],1,jt)))return null;var u=null;if(o["text-font"]&&!(u=e.parse(o["text-font"],1,Ht(qt))))return null;var l=null;if(o["text-color"]&&!(l=e.parse(o["text-color"],1,Kt)))return null;var p=n[n.length-1];p.scale=s,p.font=u,p.textColor=l;}else{var c=e.parse(t[a],1,Zt);if(!c)return null;var h=c.type.kind;if("string"!==h&&"value"!==h&&"null"!==h&&"resolvedImage"!==h)return e.error("Formatted text type must be 'string', 'value', 'image' or 'null'.");i=!0,n.push({content:c,scale:null,font:null,textColor:null});}}return new fe(n)},fe.prototype.evaluate=function(t){return new ie(this.sections.map((function(e){var r=e.content.evaluate(t);return se(r)===Yt?new ne("",r,null,null,null):new ne(ue(r),null,e.scale?e.scale.evaluate(t):null,e.font?e.font.evaluate(t).join(","):null,e.textColor?e.textColor.evaluate(t):null)})))},fe.prototype.eachChild=function(t){for(var e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t(n.content),n.scale&&t(n.scale),n.font&&t(n.font),n.textColor&&t(n.textColor);}},fe.prototype.possibleOutputs=function(){return [void 0]},fe.prototype.serialize=function(){for(var t=["format"],e=0,r=this.sections;e<r.length;e+=1){var n=r[e];t.push(n.content.serialize());var i={};n.scale&&(i["font-scale"]=n.scale.serialize()),n.font&&(i["text-font"]=n.font.serialize()),n.textColor&&(i["text-color"]=n.textColor.serialize()),t.push(i);}return t};var ye=function(t){this.type=Yt,this.input=t;};ye.parse=function(t,e){if(2!==t.length)return e.error("Expected two arguments.");var r=e.parse(t[1],1,qt);return r?new ye(r):e.error("No image name provided.")},ye.prototype.evaluate=function(t){var e=this.input.evaluate(t),r=!1;return t.availableImages&&t.availableImages.indexOf(e)>-1&&(r=!0),new ae({name:e,available:r})},ye.prototype.eachChild=function(t){t(this.input);},ye.prototype.possibleOutputs=function(){return [void 0]},ye.prototype.serialize=function(){return ["image",this.input.serialize()]};var de={"to-boolean":Nt,"to-color":Kt,"to-number":jt,"to-string":qt},me=function(t,e){this.type=t,this.args=e;};me.parse=function(t,e){if(t.length<2)return e.error("Expected at least one argument.");var r=t[0];if(("to-boolean"===r||"to-string"===r)&&2!==t.length)return e.error("Expected one argument.");for(var n=de[r],i=[],a=1;a<t.length;a++){var o=e.parse(t[a],a,Zt);if(!o)return null;i.push(o);}return new me(n,i)},me.prototype.evaluate=function(t){if("boolean"===this.type.kind)return Boolean(this.args[0].evaluate(t));if("color"===this.type.kind){for(var e,r,n=0,i=this.args;n<i.length;n+=1){if(r=null,(e=i[n].evaluate(t))instanceof ee)return e;if("string"==typeof e){var a=t.parseColor(e);if(a)return a}else if(Array.isArray(e)&&!(r=e.length<3||e.length>4?"Invalid rbga value "+JSON.stringify(e)+": expected an array containing either three or four numeric values.":oe(e[0],e[1],e[2],e[3])))return new ee(e[0]/255,e[1]/255,e[2]/255,e[3])}throw new pe(r||"Could not parse color from value '"+("string"==typeof e?e:String(JSON.stringify(e)))+"'")}if("number"===this.type.kind){for(var o=null,s=0,u=this.args;s<u.length;s+=1){if(null===(o=u[s].evaluate(t)))return 0;var l=Number(o);if(!isNaN(l))return l}throw new pe("Could not convert "+JSON.stringify(o)+" to number.")}return "formatted"===this.type.kind?ie.fromString(ue(this.args[0].evaluate(t))):"resolvedImage"===this.type.kind?ae.fromString(ue(this.args[0].evaluate(t))):ue(this.args[0].evaluate(t))},me.prototype.eachChild=function(t){this.args.forEach(t);},me.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.args.map((function(t){return t.possibleOutputs()})))},me.prototype.serialize=function(){if("formatted"===this.type.kind)return new fe([{content:this.args[0],scale:null,font:null,textColor:null}]).serialize();if("resolvedImage"===this.type.kind)return new ye(this.args[0]).serialize();var t=["to-"+this.type.kind];return this.eachChild((function(e){t.push(e.serialize());})),t};var ve=["Unknown","Point","LineString","Polygon"],ge=function(){this.globals=null,this.feature=null,this.featureState=null,this.formattedSection=null,this._parseColorCache={},this.availableImages=null;};ge.prototype.id=function(){return this.feature&&"id"in this.feature?this.feature.id:null},ge.prototype.geometryType=function(){return this.feature?"number"==typeof this.feature.type?ve[this.feature.type]:this.feature.type:null},ge.prototype.properties=function(){return this.feature&&this.feature.properties||{}},ge.prototype.parseColor=function(t){var e=this._parseColorCache[t];return e||(e=this._parseColorCache[t]=ee.parse(t)),e};var xe=function(t,e,r,n){this.name=t,this.type=e,this._evaluate=r,this.args=n;};xe.prototype.evaluate=function(t){return this._evaluate(t,this.args)},xe.prototype.eachChild=function(t){this.args.forEach(t);},xe.prototype.possibleOutputs=function(){return [void 0]},xe.prototype.serialize=function(){return [this.name].concat(this.args.map((function(t){return t.serialize()})))},xe.parse=function(t,e){var r,n=t[0],i=xe.definitions[n];if(!i)return e.error('Unknown expression "'+n+'". If you wanted a literal array, use ["literal", [...]].',0);for(var a=Array.isArray(i)?i[0]:i.type,o=Array.isArray(i)?[[i[1],i[2]]]:i.overloads,s=o.filter((function(e){var r=e[0];return !Array.isArray(r)||r.length===t.length-1})),u=null,l=0,p=s;l<p.length;l+=1){var c=p[l],h=c[0],f=c[1];u=new ke(e.registry,e.path,null,e.scope);for(var y=[],d=!1,m=1;m<t.length;m++){var v=t[m],g=Array.isArray(h)?h[m-1]:h.type,x=u.parse(v,1+y.length,g);if(!x){d=!0;break}y.push(x);}if(!d)if(Array.isArray(h)&&h.length!==y.length)u.error("Expected "+h.length+" arguments, but found "+y.length+" instead.");else{for(var b=0;b<y.length;b++){var _=Array.isArray(h)?h[b]:h.type,w=y[b];u.concat(b+1).checkSubtype(_,w.type);}if(0===u.errors.length)return new xe(n,a,f,y)}}if(1===s.length)(r=e.errors).push.apply(r,u.errors);else{for(var A=(s.length?s:o).map((function(t){var e,r=t[0];return e=r,Array.isArray(e)?"("+e.map($t).join(", ")+")":"("+$t(e.type)+"...)"})).join(" | "),S=[],k=1;k<t.length;k++){var I=e.parse(t[k],1+S.length);if(!I)return null;S.push($t(I.type));}e.error("Expected arguments of type "+A+", but found ("+S.join(", ")+") instead.");}return null},xe.register=function(t,e){for(var r in xe.definitions=e,e)t[r]=xe;};var be=function(t,e,r){this.type=Gt,this.locale=r,this.caseSensitive=t,this.diacriticSensitive=e;};function _e(t){if(t instanceof xe){if("get"===t.name&&1===t.args.length)return !1;if("feature-state"===t.name)return !1;if("has"===t.name&&1===t.args.length)return !1;if("properties"===t.name||"geometry-type"===t.name||"id"===t.name)return !1;if(/^filter-/.test(t.name))return !1}var e=!0;return t.eachChild((function(t){e&&!_e(t)&&(e=!1);})),e}function we(t){if(t instanceof xe&&"feature-state"===t.name)return !1;var e=!0;return t.eachChild((function(t){e&&!we(t)&&(e=!1);})),e}function Ae(t,e){if(t instanceof xe&&e.indexOf(t.name)>=0)return !1;var r=!0;return t.eachChild((function(t){r&&!Ae(t,e)&&(r=!1);})),r}be.parse=function(t,e){if(2!==t.length)return e.error("Expected one argument.");var r=t[1];if("object"!=typeof r||Array.isArray(r))return e.error("Collator options argument must be an object.");var n=e.parse(void 0!==r["case-sensitive"]&&r["case-sensitive"],1,Nt);if(!n)return null;var i=e.parse(void 0!==r["diacritic-sensitive"]&&r["diacritic-sensitive"],1,Nt);if(!i)return null;var a=null;return r.locale&&!(a=e.parse(r.locale,1,qt))?null:new be(n,i,a)},be.prototype.evaluate=function(t){return new re(this.caseSensitive.evaluate(t),this.diacriticSensitive.evaluate(t),this.locale?this.locale.evaluate(t):null)},be.prototype.eachChild=function(t){t(this.caseSensitive),t(this.diacriticSensitive),this.locale&&t(this.locale);},be.prototype.possibleOutputs=function(){return [void 0]},be.prototype.serialize=function(){var t={};return t["case-sensitive"]=this.caseSensitive.serialize(),t["diacritic-sensitive"]=this.diacriticSensitive.serialize(),this.locale&&(t.locale=this.locale.serialize()),["collator",t]};var Se=function(t,e){this.type=e.type,this.name=t,this.boundExpression=e;};Se.parse=function(t,e){if(2!==t.length||"string"!=typeof t[1])return e.error("'var' expression requires exactly one string literal argument.");var r=t[1];return e.scope.has(r)?new Se(r,e.scope.get(r)):e.error('Unknown variable "'+r+'". Make sure "'+r+'" has been bound in an enclosing "let" expression before using it.',1)},Se.prototype.evaluate=function(t){return this.boundExpression.evaluate(t)},Se.prototype.eachChild=function(){},Se.prototype.possibleOutputs=function(){return [void 0]},Se.prototype.serialize=function(){return ["var",this.name]};var ke=function(t,e,r,n,i){void 0===e&&(e=[]),void 0===n&&(n=new Rt),void 0===i&&(i=[]),this.registry=t,this.path=e,this.key=e.map((function(t){return "["+t+"]"})).join(""),this.scope=n,this.errors=i,this.expectedType=r;};function Ie(t,e){for(var r,n,i=t.length-1,a=0,o=i,s=0;a<=o;)if(r=t[s=Math.floor((a+o)/2)],n=t[s+1],r<=e){if(s===i||e<n)return s;a=s+1;}else{if(!(r>e))throw new pe("Input is not a number.");o=s-1;}return 0}ke.prototype.parse=function(t,e,r,n,i){return void 0===i&&(i={}),e?this.concat(e,r,n)._parse(t,i):this._parse(t,i)},ke.prototype._parse=function(t,e){function r(t,e,r){return "assert"===r?new he(e,[t]):"coerce"===r?new me(e,[t]):t}if(null!==t&&"string"!=typeof t&&"boolean"!=typeof t&&"number"!=typeof t||(t=["literal",t]),Array.isArray(t)){if(0===t.length)return this.error('Expected an array with at least one element. If you wanted a literal array, use ["literal", []].');var n=t[0];if("string"!=typeof n)return this.error("Expression name must be a string, but found "+typeof n+' instead. If you wanted a literal array, use ["literal", [...]].',0),null;var i=this.registry[n];if(i){var a=i.parse(t,this);if(!a)return null;if(this.expectedType){var o=this.expectedType,s=a.type;if("string"!==o.kind&&"number"!==o.kind&&"boolean"!==o.kind&&"object"!==o.kind&&"array"!==o.kind||"value"!==s.kind)if("color"!==o.kind&&"formatted"!==o.kind&&"resolvedImage"!==o.kind||"value"!==s.kind&&"string"!==s.kind){if(this.checkSubtype(o,s))return null}else a=r(a,o,e.typeAnnotation||"coerce");else a=r(a,o,e.typeAnnotation||"assert");}if(!(a instanceof le)&&"resolvedImage"!==a.type.kind&&function t(e){if(e instanceof Se)return t(e.boundExpression);if(e instanceof xe&&"error"===e.name)return !1;if(e instanceof be)return !1;var r=e instanceof me||e instanceof he;var n=!0;e.eachChild((function(e){n=r?n&&t(e):n&&e instanceof le;}));if(!n)return !1;return _e(e)&&Ae(e,["zoom","heatmap-density","line-progress","accumulated","is-supported-script"])}(a)){var u=new ge;try{a=new le(a.type,a.evaluate(u));}catch(t){return this.error(t.message),null}}return a}return this.error('Unknown expression "'+n+'". If you wanted a literal array, use ["literal", [...]].',0)}return void 0===t?this.error("'undefined' value invalid. Use null instead."):"object"==typeof t?this.error('Bare objects invalid. Use ["literal", {...}] instead.'):this.error("Expected an array, but found "+typeof t+" instead.")},ke.prototype.concat=function(t,e,r){var n="number"==typeof t?this.path.concat(t):this.path,i=r?this.scope.concat(r):this.scope;return new ke(this.registry,n,e||null,i,this.errors)},ke.prototype.error=function(t){for(var e=[],r=arguments.length-1;r-- >0;)e[r]=arguments[r+1];var n=""+this.key+e.map((function(t){return "["+t+"]"})).join("");this.errors.push(new Ot(n,t));},ke.prototype.checkSubtype=function(t,e){var r=Qt(t,e);return r&&this.error(r),r};var ze=function(t,e,r){this.type=t,this.input=e,this.labels=[],this.outputs=[];for(var n=0,i=r;n<i.length;n+=1){var a=i[n],o=a[0],s=a[1];this.labels.push(o),this.outputs.push(s);}};function Ce(t,e,r){return t*(1-r)+e*r}ze.parse=function(t,e){if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");var r=e.parse(t[1],1,jt);if(!r)return null;var n=[],i=null;e.expectedType&&"value"!==e.expectedType.kind&&(i=e.expectedType);for(var a=1;a<t.length;a+=2){var o=1===a?-1/0:t[a],s=t[a+1],u=a,l=a+1;if("number"!=typeof o)return e.error('Input/output pairs for "step" expressions must be defined using literal numeric values (not computed expressions) for the input values.',u);if(n.length&&n[n.length-1][0]>=o)return e.error('Input/output pairs for "step" expressions must be arranged with input values in strictly ascending order.',u);var p=e.parse(s,l,i);if(!p)return null;i=i||p.type,n.push([o,p]);}return new ze(i,r,n)},ze.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;return n>=e[i-1]?r[i-1].evaluate(t):r[Ie(e,n)].evaluate(t)},ze.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1){t(r[e]);}},ze.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.outputs.map((function(t){return t.possibleOutputs()})))},ze.prototype.serialize=function(){for(var t=["step",this.input.serialize()],e=0;e<this.labels.length;e++)e>0&&t.push(this.labels[e]),t.push(this.outputs[e].serialize());return t};var Te=Object.freeze({__proto__:null,number:Ce,color:function(t,e,r){return new ee(Ce(t.r,e.r,r),Ce(t.g,e.g,r),Ce(t.b,e.b,r),Ce(t.a,e.a,r))},array:function(t,e,r){return t.map((function(t,n){return Ce(t,e[n],r)}))}}),Ee=.95047,Me=1,Be=1.08883,Pe=4/29,Ve=6/29,Fe=3*Ve*Ve,Le=Ve*Ve*Ve,De=Math.PI/180,Oe=180/Math.PI;function Re(t){return t>Le?Math.pow(t,1/3):t/Fe+Pe}function Ue(t){return t>Ve?t*t*t:Fe*(t-Pe)}function je(t){return 255*(t<=.0031308?12.92*t:1.055*Math.pow(t,1/2.4)-.055)}function qe(t){return (t/=255)<=.04045?t/12.92:Math.pow((t+.055)/1.055,2.4)}function Ne(t){var e=qe(t.r),r=qe(t.g),n=qe(t.b),i=Re((.4124564*e+.3575761*r+.1804375*n)/Ee),a=Re((.2126729*e+.7151522*r+.072175*n)/Me);return {l:116*a-16,a:500*(i-a),b:200*(a-Re((.0193339*e+.119192*r+.9503041*n)/Be)),alpha:t.a}}function Ke(t){var e=(t.l+16)/116,r=isNaN(t.a)?e:e+t.a/500,n=isNaN(t.b)?e:e-t.b/200;return e=Me*Ue(e),r=Ee*Ue(r),n=Be*Ue(n),new ee(je(3.2404542*r-1.5371385*e-.4985314*n),je(-.969266*r+1.8760108*e+.041556*n),je(.0556434*r-.2040259*e+1.0572252*n),t.alpha)}function Xe(t,e,r){var n=e-t;return t+r*(n>180||n<-180?n-360*Math.round(n/360):n)}var Ze={forward:Ne,reverse:Ke,interpolate:function(t,e,r){return {l:Ce(t.l,e.l,r),a:Ce(t.a,e.a,r),b:Ce(t.b,e.b,r),alpha:Ce(t.alpha,e.alpha,r)}}},Ge={forward:function(t){var e=Ne(t),r=e.l,n=e.a,i=e.b,a=Math.atan2(i,n)*Oe;return {h:a<0?a+360:a,c:Math.sqrt(n*n+i*i),l:r,alpha:t.a}},reverse:function(t){var e=t.h*De,r=t.c;return Ke({l:t.l,a:Math.cos(e)*r,b:Math.sin(e)*r,alpha:t.alpha})},interpolate:function(t,e,r){return {h:Xe(t.h,e.h,r),c:Ce(t.c,e.c,r),l:Ce(t.l,e.l,r),alpha:Ce(t.alpha,e.alpha,r)}}},Je=Object.freeze({__proto__:null,lab:Ze,hcl:Ge}),Ye=function(t,e,r,n,i){this.type=t,this.operator=e,this.interpolation=r,this.input=n,this.labels=[],this.outputs=[];for(var a=0,o=i;a<o.length;a+=1){var s=o[a],u=s[0],l=s[1];this.labels.push(u),this.outputs.push(l);}};function He(t,e,r,n){var i=n-r,a=t-r;return 0===i?0:1===e?a/i:(Math.pow(e,a)-1)/(Math.pow(e,i)-1)}Ye.interpolationFactor=function(t,e,n,i){var a=0;if("exponential"===t.name)a=He(e,t.base,n,i);else if("linear"===t.name)a=He(e,1,n,i);else if("cubic-bezier"===t.name){var o=t.controlPoints;a=new r(o[0],o[1],o[2],o[3]).solve(He(e,1,n,i));}return a},Ye.parse=function(t,e){var r=t[0],n=t[1],i=t[2],a=t.slice(3);if(!Array.isArray(n)||0===n.length)return e.error("Expected an interpolation type expression.",1);if("linear"===n[0])n={name:"linear"};else if("exponential"===n[0]){var o=n[1];if("number"!=typeof o)return e.error("Exponential interpolation requires a numeric base.",1,1);n={name:"exponential",base:o};}else{if("cubic-bezier"!==n[0])return e.error("Unknown interpolation type "+String(n[0]),1,0);var s=n.slice(1);if(4!==s.length||s.some((function(t){return "number"!=typeof t||t<0||t>1})))return e.error("Cubic bezier interpolation requires four numeric arguments with values between 0 and 1.",1);n={name:"cubic-bezier",controlPoints:s};}if(t.length-1<4)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if((t.length-1)%2!=0)return e.error("Expected an even number of arguments.");if(!(i=e.parse(i,2,jt)))return null;var u=[],l=null;"interpolate-hcl"===r||"interpolate-lab"===r?l=Kt:e.expectedType&&"value"!==e.expectedType.kind&&(l=e.expectedType);for(var p=0;p<a.length;p+=2){var c=a[p],h=a[p+1],f=p+3,y=p+4;if("number"!=typeof c)return e.error('Input/output pairs for "interpolate" expressions must be defined using literal numeric values (not computed expressions) for the input values.',f);if(u.length&&u[u.length-1][0]>=c)return e.error('Input/output pairs for "interpolate" expressions must be arranged with input values in strictly ascending order.',f);var d=e.parse(h,y,l);if(!d)return null;l=l||d.type,u.push([c,d]);}return "number"===l.kind||"color"===l.kind||"array"===l.kind&&"number"===l.itemType.kind&&"number"==typeof l.N?new Ye(l,r,n,i,u):e.error("Type "+$t(l)+" is not interpolatable.")},Ye.prototype.evaluate=function(t){var e=this.labels,r=this.outputs;if(1===e.length)return r[0].evaluate(t);var n=this.input.evaluate(t);if(n<=e[0])return r[0].evaluate(t);var i=e.length;if(n>=e[i-1])return r[i-1].evaluate(t);var a=Ie(e,n),o=e[a],s=e[a+1],u=Ye.interpolationFactor(this.interpolation,n,o,s),l=r[a].evaluate(t),p=r[a+1].evaluate(t);return "interpolate"===this.operator?Te[this.type.kind.toLowerCase()](l,p,u):"interpolate-hcl"===this.operator?Ge.reverse(Ge.interpolate(Ge.forward(l),Ge.forward(p),u)):Ze.reverse(Ze.interpolate(Ze.forward(l),Ze.forward(p),u))},Ye.prototype.eachChild=function(t){t(this.input);for(var e=0,r=this.outputs;e<r.length;e+=1){t(r[e]);}},Ye.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.outputs.map((function(t){return t.possibleOutputs()})))},Ye.prototype.serialize=function(){var t;t="linear"===this.interpolation.name?["linear"]:"exponential"===this.interpolation.name?1===this.interpolation.base?["linear"]:["exponential",this.interpolation.base]:["cubic-bezier"].concat(this.interpolation.controlPoints);for(var e=[this.operator,t,this.input.serialize()],r=0;r<this.labels.length;r++)e.push(this.labels[r],this.outputs[r].serialize());return e};var $e=function(t,e){this.type=t,this.args=e;};$e.parse=function(t,e){if(t.length<2)return e.error("Expectected at least one argument.");var r=null,n=e.expectedType;n&&"value"!==n.kind&&(r=n);for(var i=[],a=0,o=t.slice(1);a<o.length;a+=1){var s=o[a],u=e.parse(s,1+i.length,r,void 0,{typeAnnotation:"omit"});if(!u)return null;r=r||u.type,i.push(u);}var l=n&&i.some((function(t){return Qt(n,t.type)}));return new $e(l?Zt:r,i)},$e.prototype.evaluate=function(t){for(var e,r=null,n=0,i=0,a=this.args;i<a.length;i+=1){if(n++,(r=a[i].evaluate(t))&&r instanceof ae&&!r.available&&(e||(e=r.name),r=null,n===this.args.length&&(r=e)),null!==r)break}return r},$e.prototype.eachChild=function(t){this.args.forEach(t);},$e.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.args.map((function(t){return t.possibleOutputs()})))},$e.prototype.serialize=function(){var t=["coalesce"];return this.eachChild((function(e){t.push(e.serialize());})),t};var We=function(t,e){this.type=e.type,this.bindings=[].concat(t),this.result=e;};We.prototype.evaluate=function(t){return this.result.evaluate(t)},We.prototype.eachChild=function(t){for(var e=0,r=this.bindings;e<r.length;e+=1){t(r[e][1]);}t(this.result);},We.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found "+(t.length-1)+" instead.");for(var r=[],n=1;n<t.length-1;n+=2){var i=t[n];if("string"!=typeof i)return e.error("Expected string, but found "+typeof i+" instead.",n);if(/[^a-zA-Z0-9_]/.test(i))return e.error("Variable names must contain only alphanumeric characters or '_'.",n);var a=e.parse(t[n+1],n+1);if(!a)return null;r.push([i,a]);}var o=e.parse(t[t.length-1],t.length-1,e.expectedType,r);return o?new We(r,o):null},We.prototype.possibleOutputs=function(){return this.result.possibleOutputs()},We.prototype.serialize=function(){for(var t=["let"],e=0,r=this.bindings;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];t.push(i,a.serialize());}return t.push(this.result.serialize()),t};var Qe=function(t,e,r){this.type=t,this.index=e,this.input=r;};Qe.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1,jt),n=e.parse(t[2],2,Ht(e.expectedType||Zt));if(!r||!n)return null;var i=n.type;return new Qe(i.itemType,r,n)},Qe.prototype.evaluate=function(t){var e=this.index.evaluate(t),r=this.input.evaluate(t);if(e<0)throw new pe("Array index out of bounds: "+e+" < 0.");if(e>=r.length)throw new pe("Array index out of bounds: "+e+" > "+(r.length-1)+".");if(e!==Math.floor(e))throw new pe("Array index must be an integer, but found "+e+" instead.");return r[e]},Qe.prototype.eachChild=function(t){t(this.index),t(this.input);},Qe.prototype.possibleOutputs=function(){return [void 0]},Qe.prototype.serialize=function(){return ["at",this.index.serialize(),this.input.serialize()]};var tr=function(t,e){this.type=Nt,this.needle=t,this.haystack=e;};tr.parse=function(t,e){if(3!==t.length)return e.error("Expected 2 arguments, but found "+(t.length-1)+" instead.");var r,n=e.parse(t[1],1,Zt),i=e.parse(t[2],2,Zt);return n&&i?"boolean"!==(r=n.type).kind&&"string"!==r.kind&&"number"!==r.kind&&"null"!==r.kind&&"value"!==r.kind?e.error("Expected first argument to be of type boolean, string, number or null, but found "+$t(n.type)+" instead"):new tr(n,i):null},tr.prototype.evaluate=function(t){var e=this.needle.evaluate(t),r=this.haystack.evaluate(t);if(!e||!r)return !1;if(!function(t){return "boolean"==typeof t||"string"==typeof t||"number"==typeof t}(e))throw new pe("Expected first argument to be of type boolean, string or number, but found "+$t(se(e))+" instead.");if(!function(t){return Array.isArray(t)||"string"==typeof t}(r))throw new pe("Expected second argument to be of type array or string, but found "+$t(se(r))+" instead.");return r.indexOf(e)>=0},tr.prototype.eachChild=function(t){t(this.needle),t(this.haystack);},tr.prototype.possibleOutputs=function(){return [!0,!1]},tr.prototype.serialize=function(){return ["in",this.needle.serialize(),this.haystack.serialize()]};var er=function(t,e,r,n,i,a){this.inputType=t,this.type=e,this.input=r,this.cases=n,this.outputs=i,this.otherwise=a;};er.parse=function(t,e){if(t.length<5)return e.error("Expected at least 4 arguments, but found only "+(t.length-1)+".");if(t.length%2!=1)return e.error("Expected an even number of arguments.");var r,n;e.expectedType&&"value"!==e.expectedType.kind&&(n=e.expectedType);for(var i={},a=[],o=2;o<t.length-1;o+=2){var s=t[o],u=t[o+1];Array.isArray(s)||(s=[s]);var l=e.concat(o);if(0===s.length)return l.error("Expected at least one branch label.");for(var p=0,c=s;p<c.length;p+=1){var h=c[p];if("number"!=typeof h&&"string"!=typeof h)return l.error("Branch labels must be numbers or strings.");if("number"==typeof h&&Math.abs(h)>Number.MAX_SAFE_INTEGER)return l.error("Branch labels must be integers no larger than "+Number.MAX_SAFE_INTEGER+".");if("number"==typeof h&&Math.floor(h)!==h)return l.error("Numeric branch labels must be integer values.");if(r){if(l.checkSubtype(r,se(h)))return null}else r=se(h);if(void 0!==i[String(h)])return l.error("Branch labels must be unique.");i[String(h)]=a.length;}var f=e.parse(u,o,n);if(!f)return null;n=n||f.type,a.push(f);}var y=e.parse(t[1],1,Zt);if(!y)return null;var d=e.parse(t[t.length-1],t.length-1,n);return d?"value"!==y.type.kind&&e.concat(1).checkSubtype(r,y.type)?null:new er(r,n,y,i,a,d):null},er.prototype.evaluate=function(t){var e=this.input.evaluate(t);return (se(e)===this.inputType&&this.outputs[this.cases[e]]||this.otherwise).evaluate(t)},er.prototype.eachChild=function(t){t(this.input),this.outputs.forEach(t),t(this.otherwise);},er.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.outputs.map((function(t){return t.possibleOutputs()}))).concat(this.otherwise.possibleOutputs())},er.prototype.serialize=function(){for(var t=this,e=["match",this.input.serialize()],r=[],n={},i=0,a=Object.keys(this.cases).sort();i<a.length;i+=1){var o=a[i];void 0===(c=n[this.cases[o]])?(n[this.cases[o]]=r.length,r.push([this.cases[o],[o]])):r[c][1].push(o);}for(var s=function(e){return "number"===t.inputType.kind?Number(e):e},u=0,l=r;u<l.length;u+=1){var p=l[u],c=p[0],h=p[1];1===h.length?e.push(s(h[0])):e.push(h.map(s)),e.push(this.outputs[outputIndex$1].serialize());}return e.push(this.otherwise.serialize()),e};var rr=function(t,e,r){this.type=t,this.branches=e,this.otherwise=r;};function nr(t,e){return "=="===t||"!="===t?"boolean"===e.kind||"string"===e.kind||"number"===e.kind||"null"===e.kind||"value"===e.kind:"string"===e.kind||"number"===e.kind||"value"===e.kind}function ir(t,e,r,n){return 0===n.compare(e,r)}function ar(t,e,r){var n="=="!==t&&"!="!==t;return function(){function i(t,e,r){this.type=Nt,this.lhs=t,this.rhs=e,this.collator=r,this.hasUntypedArgument="value"===t.type.kind||"value"===e.type.kind;}return i.parse=function(t,e){if(3!==t.length&&4!==t.length)return e.error("Expected two or three arguments.");var r=t[0],a=e.parse(t[1],1,Zt);if(!a)return null;if(!nr(r,a.type))return e.concat(1).error('"'+r+"\" comparisons are not supported for type '"+$t(a.type)+"'.");var o=e.parse(t[2],2,Zt);if(!o)return null;if(!nr(r,o.type))return e.concat(2).error('"'+r+"\" comparisons are not supported for type '"+$t(o.type)+"'.");if(a.type.kind!==o.type.kind&&"value"!==a.type.kind&&"value"!==o.type.kind)return e.error("Cannot compare types '"+$t(a.type)+"' and '"+$t(o.type)+"'.");n&&("value"===a.type.kind&&"value"!==o.type.kind?a=new he(o.type,[a]):"value"!==a.type.kind&&"value"===o.type.kind&&(o=new he(a.type,[o])));var s=null;if(4===t.length){if("string"!==a.type.kind&&"string"!==o.type.kind&&"value"!==a.type.kind&&"value"!==o.type.kind)return e.error("Cannot use collator to compare non-string types.");if(!(s=e.parse(t[3],3,Gt)))return null}return new i(a,o,s)},i.prototype.evaluate=function(i){var a=this.lhs.evaluate(i),o=this.rhs.evaluate(i);if(n&&this.hasUntypedArgument){var s=se(a),u=se(o);if(s.kind!==u.kind||"string"!==s.kind&&"number"!==s.kind)throw new pe('Expected arguments for "'+t+'" to be (string, string) or (number, number), but found ('+s.kind+", "+u.kind+") instead.")}if(this.collator&&!n&&this.hasUntypedArgument){var l=se(a),p=se(o);if("string"!==l.kind||"string"!==p.kind)return e(i,a,o)}return this.collator?r(i,a,o,this.collator.evaluate(i)):e(i,a,o)},i.prototype.eachChild=function(t){t(this.lhs),t(this.rhs),this.collator&&t(this.collator);},i.prototype.possibleOutputs=function(){return [!0,!1]},i.prototype.serialize=function(){var e=[t];return this.eachChild((function(t){e.push(t.serialize());})),e},i}()}rr.parse=function(t,e){if(t.length<4)return e.error("Expected at least 3 arguments, but found only "+(t.length-1)+".");if(t.length%2!=0)return e.error("Expected an odd number of arguments.");var r;e.expectedType&&"value"!==e.expectedType.kind&&(r=e.expectedType);for(var n=[],i=1;i<t.length-1;i+=2){var a=e.parse(t[i],i,Nt);if(!a)return null;var o=e.parse(t[i+1],i+1,r);if(!o)return null;n.push([a,o]),r=r||o.type;}var s=e.parse(t[t.length-1],t.length-1,r);return s?new rr(r,n,s):null},rr.prototype.evaluate=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];if(i.evaluate(t))return a.evaluate(t)}return this.otherwise.evaluate(t)},rr.prototype.eachChild=function(t){for(var e=0,r=this.branches;e<r.length;e+=1){var n=r[e],i=n[0],a=n[1];t(i),t(a);}t(this.otherwise);},rr.prototype.possibleOutputs=function(){var t;return (t=[]).concat.apply(t,this.branches.map((function(t){t[0];return t[1].possibleOutputs()}))).concat(this.otherwise.possibleOutputs())},rr.prototype.serialize=function(){var t=["case"];return this.eachChild((function(e){t.push(e.serialize());})),t};var or=ar("==",(function(t,e,r){return e===r}),ir),sr=ar("!=",(function(t,e,r){return e!==r}),(function(t,e,r,n){return !ir(0,e,r,n)})),ur=ar("<",(function(t,e,r){return e<r}),(function(t,e,r,n){return n.compare(e,r)<0})),lr=ar(">",(function(t,e,r){return e>r}),(function(t,e,r,n){return n.compare(e,r)>0})),pr=ar("<=",(function(t,e,r){return e<=r}),(function(t,e,r,n){return n.compare(e,r)<=0})),cr=ar(">=",(function(t,e,r){return e>=r}),(function(t,e,r,n){return n.compare(e,r)>=0})),hr=function(t,e,r,n,i){this.type=qt,this.number=t,this.locale=e,this.currency=r,this.minFractionDigits=n,this.maxFractionDigits=i;};hr.parse=function(t,e){if(3!==t.length)return e.error("Expected two arguments.");var r=e.parse(t[1],1,jt);if(!r)return null;var n=t[2];if("object"!=typeof n||Array.isArray(n))return e.error("NumberFormat options argument must be an object.");var i=null;if(n.locale&&!(i=e.parse(n.locale,1,qt)))return null;var a=null;if(n.currency&&!(a=e.parse(n.currency,1,qt)))return null;var o=null;if(n["min-fraction-digits"]&&!(o=e.parse(n["min-fraction-digits"],1,jt)))return null;var s=null;return n["max-fraction-digits"]&&!(s=e.parse(n["max-fraction-digits"],1,jt))?null:new hr(r,i,a,o,s)},hr.prototype.evaluate=function(t){return new Intl.NumberFormat(this.locale?this.locale.evaluate(t):[],{style:this.currency?"currency":"decimal",currency:this.currency?this.currency.evaluate(t):void 0,minimumFractionDigits:this.minFractionDigits?this.minFractionDigits.evaluate(t):void 0,maximumFractionDigits:this.maxFractionDigits?this.maxFractionDigits.evaluate(t):void 0}).format(this.number.evaluate(t))},hr.prototype.eachChild=function(t){t(this.number),this.locale&&t(this.locale),this.currency&&t(this.currency),this.minFractionDigits&&t(this.minFractionDigits),this.maxFractionDigits&&t(this.maxFractionDigits);},hr.prototype.possibleOutputs=function(){return [void 0]},hr.prototype.serialize=function(){var t={};return this.locale&&(t.locale=this.locale.serialize()),this.currency&&(t.currency=this.currency.serialize()),this.minFractionDigits&&(t["min-fraction-digits"]=this.minFractionDigits.serialize()),this.maxFractionDigits&&(t["max-fraction-digits"]=this.maxFractionDigits.serialize()),["number-format",this.number.serialize(),t]};var fr=function(t){this.type=jt,this.input=t;};fr.parse=function(t,e){if(2!==t.length)return e.error("Expected 1 argument, but found "+(t.length-1)+" instead.");var r=e.parse(t[1],1);return r?"array"!==r.type.kind&&"string"!==r.type.kind&&"value"!==r.type.kind?e.error("Expected argument of type string or array, but found "+$t(r.type)+" instead."):new fr(r):null},fr.prototype.evaluate=function(t){var e=this.input.evaluate(t);if("string"==typeof e)return e.length;if(Array.isArray(e))return e.length;throw new pe("Expected value to be of type string or array, but found "+$t(se(e))+" instead.")},fr.prototype.eachChild=function(t){t(this.input);},fr.prototype.possibleOutputs=function(){return [void 0]},fr.prototype.serialize=function(){var t=["length"];return this.eachChild((function(e){t.push(e.serialize());})),t};var yr={"==":or,"!=":sr,">":lr,"<":ur,">=":cr,"<=":pr,array:he,at:Qe,boolean:he,case:rr,coalesce:$e,collator:be,format:fe,image:ye,in:tr,interpolate:Ye,"interpolate-hcl":Ye,"interpolate-lab":Ye,length:fr,let:We,literal:le,match:er,number:he,"number-format":hr,object:he,step:ze,string:he,"to-boolean":me,"to-color":me,"to-number":me,"to-string":me,var:Se};function dr(t,e){var r=e[0],n=e[1],i=e[2],a=e[3];r=r.evaluate(t),n=n.evaluate(t),i=i.evaluate(t);var o=a?a.evaluate(t):1,s=oe(r,n,i,o);if(s)throw new pe(s);return new ee(r/255*o,n/255*o,i/255*o,o)}function mr(t,e){return t in e}function vr(t,e){var r=e[t];return void 0===r?null:r}function gr(t){return {type:t}}function xr(t){return {result:"success",value:t}}function br(t){return {result:"error",value:t}}function _r(t){return "data-driven"===t["property-type"]||"cross-faded-data-driven"===t["property-type"]}function wr(t){return !!t.expression&&t.expression.parameters.indexOf("zoom")>-1}function Ar(t){return !!t.expression&&t.expression.interpolated}function Sr(t){return t instanceof Number?"number":t instanceof String?"string":t instanceof Boolean?"boolean":Array.isArray(t)?"array":null===t?"null":typeof t}function kr(t){return "object"==typeof t&&null!==t&&!Array.isArray(t)}function Ir(t){return t}function zr(t,e,r){return void 0!==t?t:void 0!==e?e:void 0!==r?r:void 0}function Cr(t,e,r,n,i){return zr(typeof r===i?n[r]:void 0,t.default,e.default)}function Tr(t,e,r){if("number"!==Sr(r))return zr(t.default,e.default);var n=t.stops.length;if(1===n)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[n-1][0])return t.stops[n-1][1];var i=Ie(t.stops.map((function(t){return t[0]})),r);return t.stops[i][1]}function Er(t,e,r){var n=void 0!==t.base?t.base:1;if("number"!==Sr(r))return zr(t.default,e.default);var i=t.stops.length;if(1===i)return t.stops[0][1];if(r<=t.stops[0][0])return t.stops[0][1];if(r>=t.stops[i-1][0])return t.stops[i-1][1];var a=Ie(t.stops.map((function(t){return t[0]})),r),o=function(t,e,r,n){var i=n-r,a=t-r;return 0===i?0:1===e?a/i:(Math.pow(e,a)-1)/(Math.pow(e,i)-1)}(r,n,t.stops[a][0],t.stops[a+1][0]),s=t.stops[a][1],u=t.stops[a+1][1],l=Te[e.type]||Ir;if(t.colorSpace&&"rgb"!==t.colorSpace){var p=Je[t.colorSpace];l=function(t,e){return p.reverse(p.interpolate(p.forward(t),p.forward(e),o))};}return "function"==typeof s.evaluate?{evaluate:function(){for(var t=[],e=arguments.length;e--;)t[e]=arguments[e];var r=s.evaluate.apply(void 0,t),n=u.evaluate.apply(void 0,t);if(void 0!==r&&void 0!==n)return l(r,n,o)}}:l(s,u,o)}function Mr(t,e,r){return "color"===e.type?r=ee.parse(r):"formatted"===e.type?r=ie.fromString(r.toString()):"resolvedImage"===e.type?r=ae.fromString(r.toString()):Sr(r)===e.type||"enum"===e.type&&e.values[r]||(r=void 0),zr(r,t.default,e.default)}xe.register(yr,{error:[{kind:"error"},[qt],function(t,e){var r=e[0];throw new pe(r.evaluate(t))}],typeof:[qt,[Zt],function(t,e){return $t(se(e[0].evaluate(t)))}],"to-rgba":[Ht(jt,4),[Kt],function(t,e){return e[0].evaluate(t).toArray()}],rgb:[Kt,[jt,jt,jt],dr],rgba:[Kt,[jt,jt,jt,jt],dr],has:{type:Nt,overloads:[[[qt],function(t,e){return mr(e[0].evaluate(t),t.properties())}],[[qt,Xt],function(t,e){var r=e[0],n=e[1];return mr(r.evaluate(t),n.evaluate(t))}]]},get:{type:Zt,overloads:[[[qt],function(t,e){return vr(e[0].evaluate(t),t.properties())}],[[qt,Xt],function(t,e){var r=e[0],n=e[1];return vr(r.evaluate(t),n.evaluate(t))}]]},"feature-state":[Zt,[qt],function(t,e){return vr(e[0].evaluate(t),t.featureState||{})}],properties:[Xt,[],function(t){return t.properties()}],"geometry-type":[qt,[],function(t){return t.geometryType()}],id:[Zt,[],function(t){return t.id()}],zoom:[jt,[],function(t){return t.globals.zoom}],"heatmap-density":[jt,[],function(t){return t.globals.heatmapDensity||0}],"line-progress":[jt,[],function(t){return t.globals.lineProgress||0}],accumulated:[Zt,[],function(t){return void 0===t.globals.accumulated?null:t.globals.accumulated}],"+":[jt,gr(jt),function(t,e){for(var r=0,n=0,i=e;n<i.length;n+=1){r+=i[n].evaluate(t);}return r}],"*":[jt,gr(jt),function(t,e){for(var r=1,n=0,i=e;n<i.length;n+=1){r*=i[n].evaluate(t);}return r}],"-":{type:jt,overloads:[[[jt,jt],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)-n.evaluate(t)}],[[jt],function(t,e){return -e[0].evaluate(t)}]]},"/":[jt,[jt,jt],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)/n.evaluate(t)}],"%":[jt,[jt,jt],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)%n.evaluate(t)}],ln2:[jt,[],function(){return Math.LN2}],pi:[jt,[],function(){return Math.PI}],e:[jt,[],function(){return Math.E}],"^":[jt,[jt,jt],function(t,e){var r=e[0],n=e[1];return Math.pow(r.evaluate(t),n.evaluate(t))}],sqrt:[jt,[jt],function(t,e){var r=e[0];return Math.sqrt(r.evaluate(t))}],log10:[jt,[jt],function(t,e){var r=e[0];return Math.log(r.evaluate(t))/Math.LN10}],ln:[jt,[jt],function(t,e){var r=e[0];return Math.log(r.evaluate(t))}],log2:[jt,[jt],function(t,e){var r=e[0];return Math.log(r.evaluate(t))/Math.LN2}],sin:[jt,[jt],function(t,e){var r=e[0];return Math.sin(r.evaluate(t))}],cos:[jt,[jt],function(t,e){var r=e[0];return Math.cos(r.evaluate(t))}],tan:[jt,[jt],function(t,e){var r=e[0];return Math.tan(r.evaluate(t))}],asin:[jt,[jt],function(t,e){var r=e[0];return Math.asin(r.evaluate(t))}],acos:[jt,[jt],function(t,e){var r=e[0];return Math.acos(r.evaluate(t))}],atan:[jt,[jt],function(t,e){var r=e[0];return Math.atan(r.evaluate(t))}],min:[jt,gr(jt),function(t,e){return Math.min.apply(Math,e.map((function(e){return e.evaluate(t)})))}],max:[jt,gr(jt),function(t,e){return Math.max.apply(Math,e.map((function(e){return e.evaluate(t)})))}],abs:[jt,[jt],function(t,e){var r=e[0];return Math.abs(r.evaluate(t))}],round:[jt,[jt],function(t,e){var r=e[0].evaluate(t);return r<0?-Math.round(-r):Math.round(r)}],floor:[jt,[jt],function(t,e){var r=e[0];return Math.floor(r.evaluate(t))}],ceil:[jt,[jt],function(t,e){var r=e[0];return Math.ceil(r.evaluate(t))}],"filter-==":[Nt,[qt,Zt],function(t,e){var r=e[0],n=e[1];return t.properties()[r.value]===n.value}],"filter-id-==":[Nt,[Zt],function(t,e){var r=e[0];return t.id()===r.value}],"filter-type-==":[Nt,[qt],function(t,e){var r=e[0];return t.geometryType()===r.value}],"filter-<":[Nt,[qt,Zt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i<a}],"filter-id-<":[Nt,[Zt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<i}],"filter->":[Nt,[qt,Zt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i>a}],"filter-id->":[Nt,[Zt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>i}],"filter-<=":[Nt,[qt,Zt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i<=a}],"filter-id-<=":[Nt,[Zt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n<=i}],"filter->=":[Nt,[qt,Zt],function(t,e){var r=e[0],n=e[1],i=t.properties()[r.value],a=n.value;return typeof i==typeof a&&i>=a}],"filter-id->=":[Nt,[Zt],function(t,e){var r=e[0],n=t.id(),i=r.value;return typeof n==typeof i&&n>=i}],"filter-has":[Nt,[Zt],function(t,e){return e[0].value in t.properties()}],"filter-has-id":[Nt,[],function(t){return null!==t.id()}],"filter-type-in":[Nt,[Ht(qt)],function(t,e){return e[0].value.indexOf(t.geometryType())>=0}],"filter-id-in":[Nt,[Ht(Zt)],function(t,e){return e[0].value.indexOf(t.id())>=0}],"filter-in-small":[Nt,[qt,Ht(Zt)],function(t,e){var r=e[0];return e[1].value.indexOf(t.properties()[r.value])>=0}],"filter-in-large":[Nt,[qt,Ht(Zt)],function(t,e){var r=e[0],n=e[1];return function(t,e,r,n){for(;r<=n;){var i=r+n>>1;if(e[i]===t)return !0;e[i]>t?n=i-1:r=i+1;}return !1}(t.properties()[r.value],n.value,0,n.value.length-1)}],all:{type:Nt,overloads:[[[Nt,Nt],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)&&n.evaluate(t)}],[gr(Nt),function(t,e){for(var r=0,n=e;r<n.length;r+=1){if(!n[r].evaluate(t))return !1}return !0}]]},any:{type:Nt,overloads:[[[Nt,Nt],function(t,e){var r=e[0],n=e[1];return r.evaluate(t)||n.evaluate(t)}],[gr(Nt),function(t,e){for(var r=0,n=e;r<n.length;r+=1){if(n[r].evaluate(t))return !0}return !1}]]},"!":[Nt,[Nt],function(t,e){return !e[0].evaluate(t)}],"is-supported-script":[Nt,[qt],function(t,e){var r=e[0],n=t.globals&&t.globals.isSupportedScript;return !n||n(r.evaluate(t))}],upcase:[qt,[qt],function(t,e){return e[0].evaluate(t).toUpperCase()}],downcase:[qt,[qt],function(t,e){return e[0].evaluate(t).toLowerCase()}],concat:[qt,gr(Zt),function(t,e){return e.map((function(e){return ue(e.evaluate(t))})).join("")}],"resolved-locale":[qt,[Gt],function(t,e){return e[0].evaluate(t).resolvedLocale()}]});var Br=function(t,e){this.expression=t,this._warningHistory={},this._evaluator=new ge,this._defaultValue=e?function(t){return "color"===t.type&&kr(t.default)?new ee(0,0,0,0):"color"===t.type?ee.parse(t.default)||null:void 0===t.default?null:t.default}(e):null,this._enumValues=e&&"enum"===e.type?e.values:null;};function Pr(t){return Array.isArray(t)&&t.length>0&&"string"==typeof t[0]&&t[0]in yr}function Vr(t,e){var r=new ke(yr,[],e?function(t){var e={color:Kt,string:qt,number:jt,enum:qt,boolean:Nt,formatted:Jt,resolvedImage:Yt};if("array"===t.type)return Ht(e[t.value]||Zt,t.length);return e[t.type]}(e):void 0),n=r.parse(t,void 0,void 0,void 0,e&&"string"===e.type?{typeAnnotation:"coerce"}:void 0);return n?xr(new Br(n,e)):br(r.errors)}Br.prototype.evaluateWithoutErrorHandling=function(t,e,r,n,i){return this._evaluator.globals=t,this._evaluator.feature=e,this._evaluator.featureState=r,this._evaluator.availableImages=n||null,this._evaluator.formattedSection=i,this.expression.evaluate(this._evaluator)},Br.prototype.evaluate=function(t,e,r,n,i){this._evaluator.globals=t,this._evaluator.feature=e||null,this._evaluator.featureState=r||null,this._evaluator.availableImages=n||null,this._evaluator.formattedSection=i||null;try{var a=this.expression.evaluate(this._evaluator);if(null==a||"number"==typeof a&&a!=a)return this._defaultValue;if(this._enumValues&&!(a in this._enumValues))throw new pe("Expected value to be one of "+Object.keys(this._enumValues).map((function(t){return JSON.stringify(t)})).join(", ")+", but found "+JSON.stringify(a)+" instead.");return a}catch(t){return this._warningHistory[t.message]||(this._warningHistory[t.message]=!0,"undefined"!=typeof console&&console.warn(t.message)),this._defaultValue}};var Fr=function(t,e){this.kind=t,this._styleExpression=e,this.isStateDependent="constant"!==t&&!we(e.expression);};Fr.prototype.evaluateWithoutErrorHandling=function(t,e,r,n,i){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n,i)},Fr.prototype.evaluate=function(t,e,r,n,i){return this._styleExpression.evaluate(t,e,r,n,i)};var Lr=function(t,e,r,n){this.kind=t,this.zoomStops=r,this._styleExpression=e,this.isStateDependent="camera"!==t&&!we(e.expression),this.interpolationType=n;};function Dr(t,e){if("error"===(t=Vr(t,e)).result)return t;var r=t.value.expression,n=_e(r);if(!n&&!_r(e))return br([new Ot("","data expressions not supported")]);var i=Ae(r,["zoom"]);if(!i&&!wr(e))return br([new Ot("","zoom expressions not supported")]);var a=function t(e){var r=null;if(e instanceof We)r=t(e.result);else if(e instanceof $e)for(var n=0,i=e.args;n<i.length;n+=1){var a=i[n];if(r=t(a))break}else(e instanceof ze||e instanceof Ye)&&e.input instanceof xe&&"zoom"===e.input.name&&(r=e);if(r instanceof Ot)return r;e.eachChild((function(e){var n=t(e);n instanceof Ot?r=n:!r&&n?r=new Ot("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.'):r&&n&&r!==n&&(r=new Ot("",'Only one zoom-based "step" or "interpolate" subexpression may be used in an expression.'));}));return r}(r);if(!a&&!i)return br([new Ot("",'"zoom" expression may only be used as input to a top-level "step" or "interpolate" expression.')]);if(a instanceof Ot)return br([a]);if(a instanceof Ye&&!Ar(e))return br([new Ot("",'"interpolate" expressions cannot be used with this property')]);if(!a)return xr(new Fr(n?"constant":"source",t.value));var o=a instanceof Ye?a.interpolation:void 0;return xr(new Lr(n?"camera":"composite",t.value,a.labels,o))}Lr.prototype.evaluateWithoutErrorHandling=function(t,e,r,n,i){return this._styleExpression.evaluateWithoutErrorHandling(t,e,r,n,i)},Lr.prototype.evaluate=function(t,e,r,n,i){return this._styleExpression.evaluate(t,e,r,n,i)},Lr.prototype.interpolationFactor=function(t,e,r){return this.interpolationType?Ye.interpolationFactor(this.interpolationType,t,e,r):0};var Or=function(t,e){this._parameters=t,this._specification=e,Ft(this,function t(e,r){var n,i,a,o="color"===r.type,s=e.stops&&"object"==typeof e.stops[0][0],u=s||void 0!==e.property,l=s||!u,p=e.type||(Ar(r)?"exponential":"interval");if(o&&((e=Ft({},e)).stops&&(e.stops=e.stops.map((function(t){return [t[0],ee.parse(t[1])]}))),e.default?e.default=ee.parse(e.default):e.default=ee.parse(r.default)),e.colorSpace&&"rgb"!==e.colorSpace&&!Je[e.colorSpace])throw new Error("Unknown color space: "+e.colorSpace);if("exponential"===p)n=Er;else if("interval"===p)n=Tr;else if("categorical"===p){n=Cr,i=Object.create(null);for(var c=0,h=e.stops;c<h.length;c+=1){var f=h[c];i[f[0]]=f[1];}a=typeof e.stops[0][0];}else{if("identity"!==p)throw new Error('Unknown function type "'+p+'"');n=Mr;}if(s){for(var y={},d=[],m=0;m<e.stops.length;m++){var v=e.stops[m],g=v[0].zoom;void 0===y[g]&&(y[g]={zoom:g,type:e.type,property:e.property,default:e.default,stops:[]},d.push(g)),y[g].stops.push([v[0].value,v[1]]);}for(var x=[],b=0,_=d;b<_.length;b+=1){var w=_[b];x.push([y[w].zoom,t(y[w],r)]);}var A={name:"linear"};return {kind:"composite",interpolationType:A,interpolationFactor:Ye.interpolationFactor.bind(void 0,A),zoomStops:x.map((function(t){return t[0]})),evaluate:function(t,n){var i=t.zoom;return Er({stops:x,base:e.base},r,i).evaluate(i,n)}}}if(l){var S="exponential"===p?{name:"exponential",base:void 0!==e.base?e.base:1}:null;return {kind:"camera",interpolationType:S,interpolationFactor:Ye.interpolationFactor.bind(void 0,S),zoomStops:e.stops.map((function(t){return t[0]})),evaluate:function(t){var o=t.zoom;return n(e,r,o,i,a)}}}return {kind:"source",evaluate:function(t,o){var s=o&&o.properties?o.properties[e.property]:void 0;return void 0===s?zr(e.default,r.default):n(e,r,s,i,a)}}}(this._parameters,this._specification));};function Rr(t){var e=t.key,r=t.value,n=t.valueSpec||{},i=t.objectElementValidators||{},a=t.style,o=t.styleSpec,s=[],u=Sr(r);if("object"!==u)return [new Pt(e,r,"object expected, "+u+" found")];for(var l in r){var p=l.split(".")[0],c=n[p]||n["*"],h=void 0;if(i[p])h=i[p];else if(n[p])h=cn;else if(i["*"])h=i["*"];else{if(!n["*"]){s.push(new Pt(e,r[l],'unknown property "'+l+'"'));continue}h=cn;}s=s.concat(h({key:(e?e+".":e)+l,value:r[l],valueSpec:c,style:a,styleSpec:o,object:r,objectKey:l},r));}for(var f in n)i[f]||n[f].required&&void 0===n[f].default&&void 0===r[f]&&s.push(new Pt(e,r,'missing required property "'+f+'"'));return s}function Ur(t){var e=t.value,r=t.valueSpec,n=t.style,i=t.styleSpec,a=t.key,o=t.arrayElementValidator||cn;if("array"!==Sr(e))return [new Pt(a,e,"array expected, "+Sr(e)+" found")];if(r.length&&e.length!==r.length)return [new Pt(a,e,"array length "+r.length+" expected, length "+e.length+" found")];if(r["min-length"]&&e.length<r["min-length"])return [new Pt(a,e,"array length at least "+r["min-length"]+" expected, length "+e.length+" found")];var s={type:r.value,values:r.values};i.$version<7&&(s.function=r.function),"object"===Sr(r.value)&&(s=r.value);for(var u=[],l=0;l<e.length;l++)u=u.concat(o({array:e,arrayIndex:l,value:e[l],valueSpec:s,style:n,styleSpec:i,key:a+"["+l+"]"}));return u}function jr(t){var e=t.key,r=t.value,n=t.valueSpec,i=Sr(r);return "number"===i&&r!=r&&(i="NaN"),"number"!==i?[new Pt(e,r,"number expected, "+i+" found")]:"minimum"in n&&r<n.minimum?[new Pt(e,r,r+" is less than the minimum value "+n.minimum)]:"maximum"in n&&r>n.maximum?[new Pt(e,r,r+" is greater than the maximum value "+n.maximum)]:[]}function qr(t){var e,r,n,i=t.valueSpec,a=Lt(t.value.type),o={},s="categorical"!==a&&void 0===t.value.property,u=!s,l="array"===Sr(t.value.stops)&&"array"===Sr(t.value.stops[0])&&"object"===Sr(t.value.stops[0][0]),p=Rr({key:t.key,value:t.value,valueSpec:t.styleSpec.function,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{stops:function(t){if("identity"===a)return [new Pt(t.key,t.value,'identity function may not have a "stops" property')];var e=[],r=t.value;e=e.concat(Ur({key:t.key,value:r,valueSpec:t.valueSpec,style:t.style,styleSpec:t.styleSpec,arrayElementValidator:c})),"array"===Sr(r)&&0===r.length&&e.push(new Pt(t.key,r,"array must have at least one stop"));return e},default:function(t){return cn({key:t.key,value:t.value,valueSpec:i,style:t.style,styleSpec:t.styleSpec})}}});return "identity"===a&&s&&p.push(new Pt(t.key,t.value,'missing required property "property"')),"identity"===a||t.value.stops||p.push(new Pt(t.key,t.value,'missing required property "stops"')),"exponential"===a&&t.valueSpec.expression&&!Ar(t.valueSpec)&&p.push(new Pt(t.key,t.value,"exponential functions not supported")),t.styleSpec.$version>=8&&(u&&!_r(t.valueSpec)?p.push(new Pt(t.key,t.value,"property functions not supported")):s&&!wr(t.valueSpec)&&p.push(new Pt(t.key,t.value,"zoom functions not supported"))),"categorical"!==a&&!l||void 0!==t.value.property||p.push(new Pt(t.key,t.value,'"property" property is required')),p;function c(t){var e=[],a=t.value,s=t.key;if("array"!==Sr(a))return [new Pt(s,a,"array expected, "+Sr(a)+" found")];if(2!==a.length)return [new Pt(s,a,"array length 2 expected, length "+a.length+" found")];if(l){if("object"!==Sr(a[0]))return [new Pt(s,a,"object expected, "+Sr(a[0])+" found")];if(void 0===a[0].zoom)return [new Pt(s,a,"object stop key must have zoom")];if(void 0===a[0].value)return [new Pt(s,a,"object stop key must have value")];if(n&&n>Lt(a[0].zoom))return [new Pt(s,a[0].zoom,"stop zoom values must appear in ascending order")];Lt(a[0].zoom)!==n&&(n=Lt(a[0].zoom),r=void 0,o={}),e=e.concat(Rr({key:s+"[0]",value:a[0],valueSpec:{zoom:{}},style:t.style,styleSpec:t.styleSpec,objectElementValidators:{zoom:jr,value:h}}));}else e=e.concat(h({key:s+"[0]",value:a[0],valueSpec:{},style:t.style,styleSpec:t.styleSpec},a));return Pr(Dt(a[1]))?e.concat([new Pt(s+"[1]",a[1],"expressions are not allowed in function stops.")]):e.concat(cn({key:s+"[1]",value:a[1],valueSpec:i,style:t.style,styleSpec:t.styleSpec}))}function h(t,n){var s=Sr(t.value),u=Lt(t.value),l=null!==t.value?t.value:n;if(e){if(s!==e)return [new Pt(t.key,l,s+" stop domain type must match previous stop domain type "+e)]}else e=s;if("number"!==s&&"string"!==s&&"boolean"!==s)return [new Pt(t.key,l,"stop domain value must be a number, string, or boolean")];if("number"!==s&&"categorical"!==a){var p="number expected, "+s+" found";return _r(i)&&void 0===a&&(p+='\nIf you intended to use a categorical function, specify `"type": "categorical"`.'),[new Pt(t.key,l,p)]}return "categorical"!==a||"number"!==s||isFinite(u)&&Math.floor(u)===u?"categorical"!==a&&"number"===s&&void 0!==r&&u<r?[new Pt(t.key,l,"stop domain values must appear in ascending order")]:(r=u,"categorical"===a&&u in o?[new Pt(t.key,l,"stop domain values must be unique")]:(o[u]=!0,[])):[new Pt(t.key,l,"integer expected, found "+u)]}}function Nr(t){var e=("property"===t.expressionContext?Dr:Vr)(Dt(t.value),t.valueSpec);if("error"===e.result)return e.value.map((function(e){return new Pt(""+t.key+e.key,t.value,e.message)}));var r=e.value.expression||e.value._styleExpression.expression;if("property"===t.expressionContext&&"text-font"===t.propertyKey&&-1!==r.possibleOutputs().indexOf(void 0))return [new Pt(t.key,t.value,'Invalid data expression for "'+t.propertyKey+'". Output values must be contained as literals within the expression.')];if("property"===t.expressionContext&&"layout"===t.propertyType&&!we(r))return [new Pt(t.key,t.value,'"feature-state" data expressions are not supported with layout properties.')];if("filter"===t.expressionContext&&!we(r))return [new Pt(t.key,t.value,'"feature-state" data expressions are not supported with filters.')];if(t.expressionContext&&0===t.expressionContext.indexOf("cluster")){if(!Ae(r,["zoom","feature-state"]))return [new Pt(t.key,t.value,'"zoom" and "feature-state" expressions are not supported with cluster properties.')];if("cluster-initial"===t.expressionContext&&!_e(r))return [new Pt(t.key,t.value,"Feature data expressions are not supported with initial expression part of cluster properties.")]}return []}function Kr(t){var e=t.key,r=t.value,n=t.valueSpec,i=[];return Array.isArray(n.values)?-1===n.values.indexOf(Lt(r))&&i.push(new Pt(e,r,"expected one of ["+n.values.join(", ")+"], "+JSON.stringify(r)+" found")):-1===Object.keys(n.values).indexOf(Lt(r))&&i.push(new Pt(e,r,"expected one of ["+Object.keys(n.values).join(", ")+"], "+JSON.stringify(r)+" found")),i}function Xr(t){if(!0===t||!1===t)return !0;if(!Array.isArray(t)||0===t.length)return !1;switch(t[0]){case"has":return t.length>=2&&"$id"!==t[1]&&"$type"!==t[1];case"in":return t.length>=3&&Array.isArray(t[2]);case"!in":case"!has":case"none":return !1;case"==":case"!=":case">":case">=":case"<":case"<=":return 3!==t.length||Array.isArray(t[1])||Array.isArray(t[2]);case"any":case"all":for(var e=0,r=t.slice(1);e<r.length;e+=1){var n=r[e];if(!Xr(n)&&"boolean"!=typeof n)return !1}return !0;default:return !0}}Or.deserialize=function(t){return new Or(t._parameters,t._specification)},Or.serialize=function(t){return {_parameters:t._parameters,_specification:t._specification}};var Zr={type:"boolean",default:!1,transition:!1,"property-type":"data-driven",expression:{interpolated:!1,parameters:["zoom","feature"]}};function Gr(t){if(null==t)return function(){return !0};Xr(t)||(t=Yr(t));var e=Vr(t,Zr);if("error"===e.result)throw new Error(e.value.map((function(t){return t.key+": "+t.message})).join(", "));return function(t,r){return e.value.evaluate(t,r)}}function Jr(t,e){return t<e?-1:t>e?1:0}function Yr(t){if(!t)return !0;var e,r=t[0];return t.length<=1?"any"!==r:"=="===r?Hr(t[1],t[2],"=="):"!="===r?Qr(Hr(t[1],t[2],"==")):"<"===r||">"===r||"<="===r||">="===r?Hr(t[1],t[2],r):"any"===r?(e=t.slice(1),["any"].concat(e.map(Yr))):"all"===r?["all"].concat(t.slice(1).map(Yr)):"none"===r?["all"].concat(t.slice(1).map(Yr).map(Qr)):"in"===r?$r(t[1],t.slice(2)):"!in"===r?Qr($r(t[1],t.slice(2))):"has"===r?Wr(t[1]):"!has"!==r||Qr(Wr(t[1]))}function Hr(t,e,r){switch(t){case"$type":return ["filter-type-"+r,e];case"$id":return ["filter-id-"+r,e];default:return ["filter-"+r,t,e]}}function $r(t,e){if(0===e.length)return !1;switch(t){case"$type":return ["filter-type-in",["literal",e]];case"$id":return ["filter-id-in",["literal",e]];default:return e.length>200&&!e.some((function(t){return typeof t!=typeof e[0]}))?["filter-in-large",t,["literal",e.sort(Jr)]]:["filter-in-small",t,["literal",e]]}}function Wr(t){switch(t){case"$type":return !0;case"$id":return ["filter-has-id"];default:return ["filter-has",t]}}function Qr(t){return ["!",t]}function tn(t){return Xr(Dt(t.value))?Nr(Ft({},t,{expressionContext:"filter",valueSpec:{value:"boolean"}})):function t(e){var r=e.value;var n=e.key;if("array"!==Sr(r))return [new Pt(n,r,"array expected, "+Sr(r)+" found")];var i=e.styleSpec;var a;var o=[];if(r.length<1)return [new Pt(n,r,"filter array must have at least 1 element")];o=o.concat(Kr({key:n+"[0]",value:r[0],valueSpec:i.filter_operator,style:e.style,styleSpec:e.styleSpec}));switch(Lt(r[0])){case"<":case"<=":case">":case">=":r.length>=2&&"$type"===Lt(r[1])&&o.push(new Pt(n,r,'"$type" cannot be use with operator "'+r[0]+'"'));case"==":case"!=":3!==r.length&&o.push(new Pt(n,r,'filter array for operator "'+r[0]+'" must have 3 elements'));case"in":case"!in":r.length>=2&&"string"!==(a=Sr(r[1]))&&o.push(new Pt(n+"[1]",r[1],"string expected, "+a+" found"));for(var s=2;s<r.length;s++)a=Sr(r[s]),"$type"===Lt(r[1])?o=o.concat(Kr({key:n+"["+s+"]",value:r[s],valueSpec:i.geometry_type,style:e.style,styleSpec:e.styleSpec})):"string"!==a&&"number"!==a&&"boolean"!==a&&o.push(new Pt(n+"["+s+"]",r[s],"string, number, or boolean expected, "+a+" found"));break;case"any":case"all":case"none":for(var u=1;u<r.length;u++)o=o.concat(t({key:n+"["+u+"]",value:r[u],style:e.style,styleSpec:e.styleSpec}));break;case"has":case"!has":a=Sr(r[1]),2!==r.length?o.push(new Pt(n,r,'filter array for "'+r[0]+'" operator must have 2 elements')):"string"!==a&&o.push(new Pt(n+"[1]",r[1],"string expected, "+a+" found"));}return o}(t)}function en(t,e){var r=t.key,n=t.style,i=t.styleSpec,a=t.value,o=t.objectKey,s=i[e+"_"+t.layerType];if(!s)return [];var u=o.match(/^(.*)-transition$/);if("paint"===e&&u&&s[u[1]]&&s[u[1]].transition)return cn({key:r,value:a,valueSpec:i.transition,style:n,styleSpec:i});var l,p=t.valueSpec||s[o];if(!p)return [new Pt(r,a,'unknown property "'+o+'"')];if("string"===Sr(a)&&_r(p)&&!p.tokens&&(l=/^{([^}]+)}$/.exec(a)))return [new Pt(r,a,'"'+o+'" does not support interpolation syntax\nUse an identity property function instead: `{ "type": "identity", "property": '+JSON.stringify(l[1])+" }`.")];var c=[];return "symbol"===t.layerType&&("text-field"===o&&n&&!n.glyphs&&c.push(new Pt(r,a,'use of "text-field" requires a style "glyphs" property')),"text-font"===o&&kr(Dt(a))&&"identity"===Lt(a.type)&&c.push(new Pt(r,a,'"text-font" does not support identity functions'))),c.concat(cn({key:t.key,value:a,valueSpec:p,style:n,styleSpec:i,expressionContext:"property",propertyType:e,propertyKey:o}))}function rn(t){return en(t,"paint")}function nn(t){return en(t,"layout")}function an(t){var e=[],r=t.value,n=t.key,i=t.style,a=t.styleSpec;r.type||r.ref||e.push(new Pt(n,r,'either "type" or "ref" is required'));var o,s=Lt(r.type),u=Lt(r.ref);if(r.id)for(var l=Lt(r.id),p=0;p<t.arrayIndex;p++){var c=i.layers[p];Lt(c.id)===l&&e.push(new Pt(n,r.id,'duplicate layer id "'+r.id+'", previously used at line '+c.id.__line__));}if("ref"in r)["type","source","source-layer","filter","layout"].forEach((function(t){t in r&&e.push(new Pt(n,r[t],'"'+t+'" is prohibited for ref layers'));})),i.layers.forEach((function(t){Lt(t.id)===u&&(o=t);})),o?o.ref?e.push(new Pt(n,r.ref,"ref cannot reference another ref layer")):s=Lt(o.type):e.push(new Pt(n,r.ref,'ref layer "'+u+'" not found'));else if("background"!==s)if(r.source){var h=i.sources&&i.sources[r.source],f=h&&Lt(h.type);h?"vector"===f&&"raster"===s?e.push(new Pt(n,r.source,'layer "'+r.id+'" requires a raster source')):"raster"===f&&"raster"!==s?e.push(new Pt(n,r.source,'layer "'+r.id+'" requires a vector source')):"vector"!==f||r["source-layer"]?"raster-dem"===f&&"hillshade"!==s?e.push(new Pt(n,r.source,"raster-dem source can only be used with layer type 'hillshade'.")):"line"!==s||!r.paint||!r.paint["line-gradient"]||"geojson"===f&&h.lineMetrics||e.push(new Pt(n,r,'layer "'+r.id+'" specifies a line-gradient, which requires a GeoJSON source with `lineMetrics` enabled.')):e.push(new Pt(n,r,'layer "'+r.id+'" must specify a "source-layer"')):e.push(new Pt(n,r.source,'source "'+r.source+'" not found'));}else e.push(new Pt(n,r,'missing required property "source"'));return e=e.concat(Rr({key:n,value:r,valueSpec:a.layer,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(){return []},type:function(){return cn({key:n+".type",value:r.type,valueSpec:a.layer.type,style:t.style,styleSpec:t.styleSpec,object:r,objectKey:"type"})},filter:tn,layout:function(t){return Rr({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return nn(Ft({layerType:s},t))}}})},paint:function(t){return Rr({layer:r,key:t.key,value:t.value,style:t.style,styleSpec:t.styleSpec,objectElementValidators:{"*":function(t){return rn(Ft({layerType:s},t))}}})}}}))}function on(t){var e=t.value,r=t.key,n=Sr(e);return "string"!==n?[new Pt(r,e,"string expected, "+n+" found")]:[]}var sn={promoteId:function(t){var e=t.key,r=t.value;if("string"===Sr(r))return on({key:e,value:r});var n=[];for(var i in r)n.push.apply(n,on({key:e+"."+i,value:r[i]}));return n}};function un(t){var e=t.value,r=t.key,n=t.styleSpec,i=t.style;if(!e.type)return [new Pt(r,e,'"type" is required')];var a,o=Lt(e.type);switch(o){case"vector":case"raster":case"raster-dem":return a=Rr({key:r,value:e,valueSpec:n["source_"+o.replace("-","_")],style:t.style,styleSpec:n,objectElementValidators:sn});case"geojson":if(a=Rr({key:r,value:e,valueSpec:n.source_geojson,style:i,styleSpec:n,objectElementValidators:sn}),e.cluster)for(var s in e.clusterProperties){var u=e.clusterProperties[s],l=u[0],p=u[1],c="string"==typeof l?[l,["accumulated"],["get",s]]:l;a.push.apply(a,Nr({key:r+"."+s+".map",value:p,expressionContext:"cluster-map"})),a.push.apply(a,Nr({key:r+"."+s+".reduce",value:c,expressionContext:"cluster-reduce"}));}return a;case"video":return Rr({key:r,value:e,valueSpec:n.source_video,style:i,styleSpec:n});case"image":return Rr({key:r,value:e,valueSpec:n.source_image,style:i,styleSpec:n});case"canvas":return [new Pt(r,null,"Please use runtime APIs to add canvas sources, rather than including them in stylesheets.","source.canvas")];default:return Kr({key:r+".type",value:e.type,valueSpec:{values:["vector","raster","raster-dem","geojson","video","image"]},style:i,styleSpec:n})}}function ln(t){var e=t.value,r=t.styleSpec,n=r.light,i=t.style,a=[],o=Sr(e);if(void 0===e)return a;if("object"!==o)return a=a.concat([new Pt("light",e,"object expected, "+o+" found")]);for(var s in e){var u=s.match(/^(.*)-transition$/);a=u&&n[u[1]]&&n[u[1]].transition?a.concat(cn({key:s,value:e[s],valueSpec:r.transition,style:i,styleSpec:r})):n[s]?a.concat(cn({key:s,value:e[s],valueSpec:n[s],style:i,styleSpec:r})):a.concat([new Pt(s,e[s],'unknown property "'+s+'"')]);}return a}var pn={"*":function(){return []},array:Ur,boolean:function(t){var e=t.value,r=t.key,n=Sr(e);return "boolean"!==n?[new Pt(r,e,"boolean expected, "+n+" found")]:[]},number:jr,color:function(t){var e=t.key,r=t.value,n=Sr(r);return "string"!==n?[new Pt(e,r,"color expected, "+n+" found")]:null===te(r)?[new Pt(e,r,'color expected, "'+r+'" found')]:[]},constants:Vt,enum:Kr,filter:tn,function:qr,layer:an,object:Rr,source:un,light:ln,string:on,formatted:function(t){return 0===on(t).length?[]:Nr(t)},resolvedImage:function(t){return 0===on(t).length?[]:Nr(t)}};function cn(t){var e=t.value,r=t.valueSpec,n=t.styleSpec;return r.expression&&kr(Lt(e))?qr(t):r.expression&&Pr(Dt(e))?Nr(t):r.type&&pn[r.type]?pn[r.type](t):Rr(Ft({},t,{valueSpec:r.type?n[r.type]:r}))}function hn(t){var e=t.value,r=t.key,n=on(t);return n.length?n:(-1===e.indexOf("{fontstack}")&&n.push(new Pt(r,e,'"glyphs" url must include a "{fontstack}" token')),-1===e.indexOf("{range}")&&n.push(new Pt(r,e,'"glyphs" url must include a "{range}" token')),n)}function fn(t,e){void 0===e&&(e=Bt);var r=[];return r=r.concat(cn({key:"",value:t,valueSpec:e.$root,styleSpec:e,style:t,objectElementValidators:{glyphs:hn,"*":function(){return []}}})),t.constants&&(r=r.concat(Vt({key:"constants",value:t.constants,style:t,styleSpec:e}))),yn(r)}function yn(t){return [].concat(t).sort((function(t,e){return t.line-e.line}))}function dn(t){return function(){for(var e=[],r=arguments.length;r--;)e[r]=arguments[r];return yn(t.apply(this,e))}}fn.source=dn(un),fn.light=dn(ln),fn.layer=dn(an),fn.filter=dn(tn),fn.paintProperty=dn(rn),fn.layoutProperty=dn(nn);var mn=fn,vn=mn.light,gn=mn.paintProperty,xn=mn.layoutProperty;function bn(t,e){var r=!1;if(e&&e.length)for(var n=0,i=e;n<i.length;n+=1){var a=i[n];t.fire(new Et(new Error(a.message))),r=!0;}return r}var _n=An,wn=3;function An(t,e,r){var n=this.cells=[];if(t instanceof ArrayBuffer){this.arrayBuffer=t;var i=new Int32Array(this.arrayBuffer);t=i[0],e=i[1],r=i[2],this.d=e+2*r;for(var a=0;a<this.d*this.d;a++){var o=i[wn+a],s=i[wn+a+1];n.push(o===s?null:i.subarray(o,s));}var u=i[wn+n.length],l=i[wn+n.length+1];this.keys=i.subarray(u,l),this.bboxes=i.subarray(l),this.insert=this._insertReadonly;}else{this.d=e+2*r;for(var p=0;p<this.d*this.d;p++)n.push([]);this.keys=[],this.bboxes=[];}this.n=e,this.extent=t,this.padding=r,this.scale=e/t,this.uid=0;var c=r/e*t;this.min=-c,this.max=t+c;}An.prototype.insert=function(t,e,r,n,i){this._forEachCell(e,r,n,i,this._insertCell,this.uid++),this.keys.push(t),this.bboxes.push(e),this.bboxes.push(r),this.bboxes.push(n),this.bboxes.push(i);},An.prototype._insertReadonly=function(){throw "Cannot insert into a GridIndex created from an ArrayBuffer."},An.prototype._insertCell=function(t,e,r,n,i,a){this.cells[i].push(a);},An.prototype.query=function(t,e,r,n,i){var a=this.min,o=this.max;if(t<=a&&e<=a&&o<=r&&o<=n&&!i)return Array.prototype.slice.call(this.keys);var s=[];return this._forEachCell(t,e,r,n,this._queryCell,s,{},i),s},An.prototype._queryCell=function(t,e,r,n,i,a,o,s){var u=this.cells[i];if(null!==u)for(var l=this.keys,p=this.bboxes,c=0;c<u.length;c++){var h=u[c];if(void 0===o[h]){var f=4*h;(s?s(p[f+0],p[f+1],p[f+2],p[f+3]):t<=p[f+2]&&e<=p[f+3]&&r>=p[f+0]&&n>=p[f+1])?(o[h]=!0,a.push(l[h])):o[h]=!1;}}},An.prototype._forEachCell=function(t,e,r,n,i,a,o,s){for(var u=this._convertToCellCoord(t),l=this._convertToCellCoord(e),p=this._convertToCellCoord(r),c=this._convertToCellCoord(n),h=u;h<=p;h++)for(var f=l;f<=c;f++){var y=this.d*f+h;if((!s||s(this._convertFromCellCoord(h),this._convertFromCellCoord(f),this._convertFromCellCoord(h+1),this._convertFromCellCoord(f+1)))&&i.call(this,t,e,r,n,y,a,o,s))return}},An.prototype._convertFromCellCoord=function(t){return (t-this.padding)/this.scale},An.prototype._convertToCellCoord=function(t){return Math.max(0,Math.min(this.d-1,Math.floor(t*this.scale)+this.padding))},An.prototype.toArrayBuffer=function(){if(this.arrayBuffer)return this.arrayBuffer;for(var t=this.cells,e=wn+this.cells.length+1+1,r=0,n=0;n<this.cells.length;n++)r+=this.cells[n].length;var i=new Int32Array(e+r+this.keys.length+this.bboxes.length);i[0]=this.extent,i[1]=this.n,i[2]=this.padding;for(var a=e,o=0;o<t.length;o++){var s=t[o];i[wn+o]=a,i.set(s,a),a+=s.length;}return i[wn+t.length]=a,i.set(this.keys,a),a+=this.keys.length,i[wn+t.length+1]=a,i.set(this.bboxes,a),a+=this.bboxes.length,i.buffer};var Sn=self.ImageData,kn=self.ImageBitmap,In={};function zn(t,e,r){void 0===r&&(r={}),Object.defineProperty(e,"_classRegistryKey",{value:t,writeable:!1}),In[t]={klass:e,omit:r.omit||[],shallow:r.shallow||[]};}for(var Cn in zn("Object",Object),_n.serialize=function(t,e){var r=t.toArrayBuffer();return e&&e.push(r),{buffer:r}},_n.deserialize=function(t){return new _n(t.buffer)},zn("Grid",_n),zn("Color",ee),zn("Error",Error),zn("ResolvedImage",ae),zn("StylePropertyFunction",Or),zn("StyleExpression",Br,{omit:["_evaluator"]}),zn("ZoomDependentExpression",Lr),zn("ZoomConstantExpression",Fr),zn("CompoundExpression",xe,{omit:["_evaluate"]}),yr)yr[Cn]._classRegistryKey||zn("Expression_"+Cn,yr[Cn]);function Tn(t){return t&&"undefined"!=typeof ArrayBuffer&&(t instanceof ArrayBuffer||t.constructor&&"ArrayBuffer"===t.constructor.name)}function En(t){return kn&&t instanceof kn}function Mn(t,e){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp)return t;if(Tn(t)||En(t))return e&&e.push(t),t;if(ArrayBuffer.isView(t)){var r=t;return e&&e.push(r.buffer),r}if(t instanceof Sn)return e&&e.push(t.data.buffer),t;if(Array.isArray(t)){for(var n=[],i=0,a=t;i<a.length;i+=1){var o=a[i];n.push(Mn(o,e));}return n}if("object"==typeof t){var s=t.constructor,u=s._classRegistryKey;if(!u)throw new Error("can't serialize object of unregistered class");var l=s.serialize?s.serialize(t,e):{};if(!s.serialize){for(var p in t)if(t.hasOwnProperty(p)&&!(In[u].omit.indexOf(p)>=0)){var c=t[p];l[p]=In[u].shallow.indexOf(p)>=0?c:Mn(c,e);}t instanceof Error&&(l.message=t.message);}if(l.$name)throw new Error("$name property is reserved for worker serialization logic.");return "Object"!==u&&(l.$name=u),l}throw new Error("can't serialize object of type "+typeof t)}function Bn(t){if(null==t||"boolean"==typeof t||"number"==typeof t||"string"==typeof t||t instanceof Boolean||t instanceof Number||t instanceof String||t instanceof Date||t instanceof RegExp||Tn(t)||En(t)||ArrayBuffer.isView(t)||t instanceof Sn)return t;if(Array.isArray(t))return t.map(Bn);if("object"==typeof t){var e=t.$name||"Object",r=In[e].klass;if(!r)throw new Error("can't deserialize unregistered class "+e);if(r.deserialize)return r.deserialize(t);for(var n=Object.create(r.prototype),i=0,a=Object.keys(t);i<a.length;i+=1){var o=a[i];if("$name"!==o){var s=t[o];n[o]=In[e].shallow.indexOf(o)>=0?s:Bn(s);}}return n}throw new Error("can't deserialize object of type "+typeof t)}var Pn=function(){this.first=!0;};Pn.prototype.update=function(t,e){var r=Math.floor(t);return this.first?(this.first=!1,this.lastIntegerZoom=r,this.lastIntegerZoomTime=0,this.lastZoom=t,this.lastFloorZoom=r,!0):(this.lastFloorZoom>r?(this.lastIntegerZoom=r+1,this.lastIntegerZoomTime=e):this.lastFloorZoom<r&&(this.lastIntegerZoom=r,this.lastIntegerZoomTime=e),t!==this.lastZoom&&(this.lastZoom=t,this.lastFloorZoom=r,!0))};var Vn={"Latin-1 Supplement":function(t){return t>=128&&t<=255},Arabic:function(t){return t>=1536&&t<=1791},"Arabic Supplement":function(t){return t>=1872&&t<=1919},"Arabic Extended-A":function(t){return t>=2208&&t<=2303},"Hangul Jamo":function(t){return t>=4352&&t<=4607},"Unified Canadian Aboriginal Syllabics":function(t){return t>=5120&&t<=5759},Khmer:function(t){return t>=6016&&t<=6143},"Unified Canadian Aboriginal Syllabics Extended":function(t){return t>=6320&&t<=6399},"General Punctuation":function(t){return t>=8192&&t<=8303},"Letterlike Symbols":function(t){return t>=8448&&t<=8527},"Number Forms":function(t){return t>=8528&&t<=8591},"Miscellaneous Technical":function(t){return t>=8960&&t<=9215},"Control Pictures":function(t){return t>=9216&&t<=9279},"Optical Character Recognition":function(t){return t>=9280&&t<=9311},"Enclosed Alphanumerics":function(t){return t>=9312&&t<=9471},"Geometric Shapes":function(t){return t>=9632&&t<=9727},"Miscellaneous Symbols":function(t){return t>=9728&&t<=9983},"Miscellaneous Symbols and Arrows":function(t){return t>=11008&&t<=11263},"CJK Radicals Supplement":function(t){return t>=11904&&t<=12031},"Kangxi Radicals":function(t){return t>=12032&&t<=12255},"Ideographic Description Characters":function(t){return t>=12272&&t<=12287},"CJK Symbols and Punctuation":function(t){return t>=12288&&t<=12351},Hiragana:function(t){return t>=12352&&t<=12447},Katakana:function(t){return t>=12448&&t<=12543},Bopomofo:function(t){return t>=12544&&t<=12591},"Hangul Compatibility Jamo":function(t){return t>=12592&&t<=12687},Kanbun:function(t){return t>=12688&&t<=12703},"Bopomofo Extended":function(t){return t>=12704&&t<=12735},"CJK Strokes":function(t){return t>=12736&&t<=12783},"Katakana Phonetic Extensions":function(t){return t>=12784&&t<=12799},"Enclosed CJK Letters and Months":function(t){return t>=12800&&t<=13055},"CJK Compatibility":function(t){return t>=13056&&t<=13311},"CJK Unified Ideographs Extension A":function(t){return t>=13312&&t<=19903},"Yijing Hexagram Symbols":function(t){return t>=19904&&t<=19967},"CJK Unified Ideographs":function(t){return t>=19968&&t<=40959},"Yi Syllables":function(t){return t>=40960&&t<=42127},"Yi Radicals":function(t){return t>=42128&&t<=42191},"Hangul Jamo Extended-A":function(t){return t>=43360&&t<=43391},"Hangul Syllables":function(t){return t>=44032&&t<=55215},"Hangul Jamo Extended-B":function(t){return t>=55216&&t<=55295},"Private Use Area":function(t){return t>=57344&&t<=63743},"CJK Compatibility Ideographs":function(t){return t>=63744&&t<=64255},"Arabic Presentation Forms-A":function(t){return t>=64336&&t<=65023},"Vertical Forms":function(t){return t>=65040&&t<=65055},"CJK Compatibility Forms":function(t){return t>=65072&&t<=65103},"Small Form Variants":function(t){return t>=65104&&t<=65135},"Arabic Presentation Forms-B":function(t){return t>=65136&&t<=65279},"Halfwidth and Fullwidth Forms":function(t){return t>=65280&&t<=65519}};function Fn(t){for(var e=0,r=t;e<r.length;e+=1){if(Dn(r[e].charCodeAt(0)))return !0}return !1}function Ln(t){return !Vn.Arabic(t)&&(!Vn["Arabic Supplement"](t)&&(!Vn["Arabic Extended-A"](t)&&(!Vn["Arabic Presentation Forms-A"](t)&&!Vn["Arabic Presentation Forms-B"](t))))}function Dn(t){return 746===t||747===t||!(t<4352)&&(!!Vn["Bopomofo Extended"](t)||(!!Vn.Bopomofo(t)||(!(!Vn["CJK Compatibility Forms"](t)||t>=65097&&t<=65103)||(!!Vn["CJK Compatibility Ideographs"](t)||(!!Vn["CJK Compatibility"](t)||(!!Vn["CJK Radicals Supplement"](t)||(!!Vn["CJK Strokes"](t)||(!(!Vn["CJK Symbols and Punctuation"](t)||t>=12296&&t<=12305||t>=12308&&t<=12319||12336===t)||(!!Vn["CJK Unified Ideographs Extension A"](t)||(!!Vn["CJK Unified Ideographs"](t)||(!!Vn["Enclosed CJK Letters and Months"](t)||(!!Vn["Hangul Compatibility Jamo"](t)||(!!Vn["Hangul Jamo Extended-A"](t)||(!!Vn["Hangul Jamo Extended-B"](t)||(!!Vn["Hangul Jamo"](t)||(!!Vn["Hangul Syllables"](t)||(!!Vn.Hiragana(t)||(!!Vn["Ideographic Description Characters"](t)||(!!Vn.Kanbun(t)||(!!Vn["Kangxi Radicals"](t)||(!!Vn["Katakana Phonetic Extensions"](t)||(!(!Vn.Katakana(t)||12540===t)||(!(!Vn["Halfwidth and Fullwidth Forms"](t)||65288===t||65289===t||65293===t||t>=65306&&t<=65310||65339===t||65341===t||65343===t||t>=65371&&t<=65503||65507===t||t>=65512&&t<=65519)||(!(!Vn["Small Form Variants"](t)||t>=65112&&t<=65118||t>=65123&&t<=65126)||(!!Vn["Unified Canadian Aboriginal Syllabics"](t)||(!!Vn["Unified Canadian Aboriginal Syllabics Extended"](t)||(!!Vn["Vertical Forms"](t)||(!!Vn["Yijing Hexagram Symbols"](t)||(!!Vn["Yi Syllables"](t)||!!Vn["Yi Radicals"](t))))))))))))))))))))))))))))))}function On(t){return !(Dn(t)||function(t){return !(!Vn["Latin-1 Supplement"](t)||167!==t&&169!==t&&174!==t&&177!==t&&188!==t&&189!==t&&190!==t&&215!==t&&247!==t)||(!(!Vn["General Punctuation"](t)||8214!==t&&8224!==t&&8225!==t&&8240!==t&&8241!==t&&8251!==t&&8252!==t&&8258!==t&&8263!==t&&8264!==t&&8265!==t&&8273!==t)||(!!Vn["Letterlike Symbols"](t)||(!!Vn["Number Forms"](t)||(!(!Vn["Miscellaneous Technical"](t)||!(t>=8960&&t<=8967||t>=8972&&t<=8991||t>=8996&&t<=9e3||9003===t||t>=9085&&t<=9114||t>=9150&&t<=9165||9167===t||t>=9169&&t<=9179||t>=9186&&t<=9215))||(!(!Vn["Control Pictures"](t)||9251===t)||(!!Vn["Optical Character Recognition"](t)||(!!Vn["Enclosed Alphanumerics"](t)||(!!Vn["Geometric Shapes"](t)||(!(!Vn["Miscellaneous Symbols"](t)||t>=9754&&t<=9759)||(!(!Vn["Miscellaneous Symbols and Arrows"](t)||!(t>=11026&&t<=11055||t>=11088&&t<=11097||t>=11192&&t<=11243))||(!!Vn["CJK Symbols and Punctuation"](t)||(!!Vn.Katakana(t)||(!!Vn["Private Use Area"](t)||(!!Vn["CJK Compatibility Forms"](t)||(!!Vn["Small Form Variants"](t)||(!!Vn["Halfwidth and Fullwidth Forms"](t)||(8734===t||8756===t||8757===t||t>=9984&&t<=10087||t>=10102&&t<=10131||65532===t||65533===t)))))))))))))))))}(t))}function Rn(t){return t>=1424&&t<=2303||Vn["Arabic Presentation Forms-A"](t)||Vn["Arabic Presentation Forms-B"](t)}function Un(t,e){return !(!e&&Rn(t))&&!(t>=2304&&t<=3583||t>=3840&&t<=4255||Vn.Khmer(t))}function jn(t){for(var e=0,r=t;e<r.length;e+=1){if(Rn(r[e].charCodeAt(0)))return !0}return !1}var qn="deferred",Nn="loading",Kn="loaded",Xn=null,Zn="unavailable",Gn=null,Jn=function(t){Xn&&Xn(t);};function Yn(){Hn.fire(new Tt("pluginStateChange",{pluginStatus:Zn,pluginURL:Gn}));}var Hn=new Mt,$n=function(){return Zn},Wn=function(){if(Zn!==qn||!Gn)throw new Error("rtl-text-plugin cannot be downloaded unless a pluginURL is specified");Zn=Nn,Yn(),Gn&&_t({url:Gn},(function(t){t?Jn(t):(Zn=Kn,Yn());}));},Qn={applyArabicShaping:null,processBidirectionalText:null,processStyledBidirectionalText:null,isLoaded:function(){return Zn===Kn||null!=Qn.applyArabicShaping},isLoading:function(){return Zn===Nn},setState:function(t){Zn=t.pluginStatus,Gn=t.pluginURL;},isParsed:function(){return null!=Qn.applyArabicShaping&&null!=Qn.processBidirectionalText&&null!=Qn.processStyledBidirectionalText},getPluginURL:function(){return Gn}},ti=function(t,e){this.zoom=t,e?(this.now=e.now,this.fadeDuration=e.fadeDuration,this.zoomHistory=e.zoomHistory,this.transition=e.transition):(this.now=0,this.fadeDuration=0,this.zoomHistory=new Pn,this.transition={});};ti.prototype.isSupportedScript=function(t){return function(t,e){for(var r=0,n=t;r<n.length;r+=1){if(!Un(n[r].charCodeAt(0),e))return !1}return !0}(t,Qn.isLoaded())},ti.prototype.crossFadingFactor=function(){return 0===this.fadeDuration?1:Math.min((this.now-this.zoomHistory.lastIntegerZoomTime)/this.fadeDuration,1)},ti.prototype.getCrossfadeParameters=function(){var t=this.zoom,e=t-Math.floor(t),r=this.crossFadingFactor();return t>this.zoomHistory.lastIntegerZoom?{fromScale:2,toScale:1,t:e+(1-e)*r}:{fromScale:.5,toScale:1,t:1-(1-r)*e}};var ei=function(t,e){this.property=t,this.value=e,this.expression=function(t,e){if(kr(t))return new Or(t,e);if(Pr(t)){var r=Dr(t,e);if("error"===r.result)throw new Error(r.value.map((function(t){return t.key+": "+t.message})).join(", "));return r.value}var n=t;return "string"==typeof t&&"color"===e.type&&(n=ee.parse(t)),{kind:"constant",evaluate:function(){return n}}}(void 0===e?t.specification.default:e,t.specification);};ei.prototype.isDataDriven=function(){return "source"===this.expression.kind||"composite"===this.expression.kind},ei.prototype.possiblyEvaluate=function(t,e){return this.property.possiblyEvaluate(this,t,e)};var ri=function(t){this.property=t,this.value=new ei(t,void 0);};ri.prototype.transitioned=function(t,e){return new ii(this.property,this.value,e,p({},t.transition,this.transition),t.now)},ri.prototype.untransitioned=function(){return new ii(this.property,this.value,null,{},0)};var ni=function(t){this._properties=t,this._values=Object.create(t.defaultTransitionablePropertyValues);};ni.prototype.getValue=function(t){return x(this._values[t].value.value)},ni.prototype.setValue=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new ri(this._values[t].property)),this._values[t].value=new ei(this._values[t].property,null===e?void 0:x(e));},ni.prototype.getTransition=function(t){return x(this._values[t].transition)},ni.prototype.setTransition=function(t,e){this._values.hasOwnProperty(t)||(this._values[t]=new ri(this._values[t].property)),this._values[t].transition=x(e)||void 0;},ni.prototype.serialize=function(){for(var t={},e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e],i=this.getValue(n);void 0!==i&&(t[n]=i);var a=this.getTransition(n);void 0!==a&&(t[n+"-transition"]=a);}return t},ni.prototype.transitioned=function(t,e){for(var r=new ai(this._properties),n=0,i=Object.keys(this._values);n<i.length;n+=1){var a=i[n];r._values[a]=this._values[a].transitioned(t,e._values[a]);}return r},ni.prototype.untransitioned=function(){for(var t=new ai(this._properties),e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e];t._values[n]=this._values[n].untransitioned();}return t};var ii=function(t,e,r,n,i){this.property=t,this.value=e,this.begin=i+n.delay||0,this.end=this.begin+n.duration||0,t.specification.transition&&(n.delay||n.duration)&&(this.prior=r);};ii.prototype.possiblyEvaluate=function(t,e){var r=t.now||0,n=this.value.possiblyEvaluate(t,e),i=this.prior;if(i){if(r>this.end)return this.prior=null,n;if(this.value.isDataDriven())return this.prior=null,n;if(r<this.begin)return i.possiblyEvaluate(t,e);var a=(r-this.begin)/(this.end-this.begin);return this.property.interpolate(i.possiblyEvaluate(t,e),n,function(t){if(t<=0)return 0;if(t>=1)return 1;var e=t*t,r=e*t;return 4*(t<.5?r:3*(t-e)+r-.75)}(a))}return n};var ai=function(t){this._properties=t,this._values=Object.create(t.defaultTransitioningPropertyValues);};ai.prototype.possiblyEvaluate=function(t,e){for(var r=new ui(this._properties),n=0,i=Object.keys(this._values);n<i.length;n+=1){var a=i[n];r._values[a]=this._values[a].possiblyEvaluate(t,e);}return r},ai.prototype.hasTransition=function(){for(var t=0,e=Object.keys(this._values);t<e.length;t+=1){var r=e[t];if(this._values[r].prior)return !0}return !1};var oi=function(t){this._properties=t,this._values=Object.create(t.defaultPropertyValues);};oi.prototype.getValue=function(t){return x(this._values[t].value)},oi.prototype.setValue=function(t,e){this._values[t]=new ei(this._values[t].property,null===e?void 0:x(e));},oi.prototype.serialize=function(){for(var t={},e=0,r=Object.keys(this._values);e<r.length;e+=1){var n=r[e],i=this.getValue(n);void 0!==i&&(t[n]=i);}return t},oi.prototype.possiblyEvaluate=function(t,e){for(var r=new ui(this._properties),n=0,i=Object.keys(this._values);n<i.length;n+=1){var a=i[n];r._values[a]=this._values[a].possiblyEvaluate(t,e);}return r};var si=function(t,e,r){this.property=t,this.value=e,this.parameters=r;};si.prototype.isConstant=function(){return "constant"===this.value.kind},si.prototype.constantOr=function(t){return "constant"===this.value.kind?this.value.value:t},si.prototype.evaluate=function(t,e,r){return this.property.evaluate(this.value,this.parameters,t,e,r)};var ui=function(t){this._properties=t,this._values=Object.create(t.defaultPossiblyEvaluatedValues);};ui.prototype.get=function(t){return this._values[t]};var li=function(t){this.specification=t;};li.prototype.possiblyEvaluate=function(t,e){return t.expression.evaluate(e)},li.prototype.interpolate=function(t,e,r){var n=Te[this.specification.type];return n?n(t,e,r):t};var pi=function(t,e){this.specification=t,this.overrides=e;};pi.prototype.possiblyEvaluate=function(t,e,r){return "constant"===t.expression.kind||"camera"===t.expression.kind?new si(this,{kind:"constant",value:t.expression.evaluate(e,null,{},r)},e):new si(this,t.expression,e)},pi.prototype.interpolate=function(t,e,r){if("constant"!==t.value.kind||"constant"!==e.value.kind)return t;if(void 0===t.value.value||void 0===e.value.value)return new si(this,{kind:"constant",value:void 0},t.parameters);var n=Te[this.specification.type];return n?new si(this,{kind:"constant",value:n(t.value.value,e.value.value,r)},t.parameters):t},pi.prototype.evaluate=function(t,e,r,n,i){return "constant"===t.kind?t.value:t.evaluate(e,r,n,i)};var ci=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.possiblyEvaluate=function(t,e,r){if(void 0===t.value)return new si(this,{kind:"constant",value:void 0},e);if("constant"===t.expression.kind){var n=t.expression.evaluate(e,null,{},r),i="resolvedImage"===t.property.specification.type&&"string"!=typeof n?n.name:n,a=this._calculate(i,i,i,e);return new si(this,{kind:"constant",value:a},e)}if("camera"===t.expression.kind){var o=this._calculate(t.expression.evaluate({zoom:e.zoom-1}),t.expression.evaluate({zoom:e.zoom}),t.expression.evaluate({zoom:e.zoom+1}),e);return new si(this,{kind:"constant",value:o},e)}return new si(this,t.expression,e)},e.prototype.evaluate=function(t,e,r,n,i){if("source"===t.kind){var a=t.evaluate(e,r,n,i);return this._calculate(a,a,a,e)}return "composite"===t.kind?this._calculate(t.evaluate({zoom:Math.floor(e.zoom)-1},r,n),t.evaluate({zoom:Math.floor(e.zoom)},r,n),t.evaluate({zoom:Math.floor(e.zoom)+1},r,n),e):t.value},e.prototype._calculate=function(t,e,r,n){return n.zoom>n.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:r,to:e}},e.prototype.interpolate=function(t){return t},e}(pi),hi=function(t){this.specification=t;};hi.prototype.possiblyEvaluate=function(t,e,r){if(void 0!==t.value){if("constant"===t.expression.kind){var n=t.expression.evaluate(e,null,{},r);return this._calculate(n,n,n,e)}return this._calculate(t.expression.evaluate(new ti(Math.floor(e.zoom-1),e)),t.expression.evaluate(new ti(Math.floor(e.zoom),e)),t.expression.evaluate(new ti(Math.floor(e.zoom+1),e)),e)}},hi.prototype._calculate=function(t,e,r,n){return n.zoom>n.zoomHistory.lastIntegerZoom?{from:t,to:e}:{from:r,to:e}},hi.prototype.interpolate=function(t){return t};var fi=function(t){this.specification=t;};fi.prototype.possiblyEvaluate=function(t,e,r){return !!t.expression.evaluate(e,null,{},r)},fi.prototype.interpolate=function(){return !1};var yi=function(t){for(var e in this.properties=t,this.defaultPropertyValues={},this.defaultTransitionablePropertyValues={},this.defaultTransitioningPropertyValues={},this.defaultPossiblyEvaluatedValues={},this.overridableProperties=[],t){var r=t[e];r.specification.overridable&&this.overridableProperties.push(e);var n=this.defaultPropertyValues[e]=new ei(r,void 0),i=this.defaultTransitionablePropertyValues[e]=new ri(r);this.defaultTransitioningPropertyValues[e]=i.untransitioned(),this.defaultPossiblyEvaluatedValues[e]=n.possiblyEvaluate({});}};zn("DataDrivenProperty",pi),zn("DataConstantProperty",li),zn("CrossFadedDataDrivenProperty",ci),zn("CrossFadedProperty",hi),zn("ColorRampProperty",fi);var di=function(t){function e(e,r){if(t.call(this),this.id=e.id,this.type=e.type,this._featureFilter=function(){return !0},"custom"!==e.type&&(e=e,this.metadata=e.metadata,this.minzoom=e.minzoom,this.maxzoom=e.maxzoom,"background"!==e.type&&(this.source=e.source,this.sourceLayer=e["source-layer"],this.filter=e.filter),r.layout&&(this._unevaluatedLayout=new oi(r.layout)),r.paint)){for(var n in this._transitionablePaint=new ni(r.paint),e.paint)this.setPaintProperty(n,e.paint[n],{validate:!1});for(var i in e.layout)this.setLayoutProperty(i,e.layout[i],{validate:!1});this._transitioningPaint=this._transitionablePaint.untransitioned();}}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getCrossfadeParameters=function(){return this._crossfadeParameters},e.prototype.getLayoutProperty=function(t){return "visibility"===t?this.visibility:this._unevaluatedLayout.getValue(t)},e.prototype.setLayoutProperty=function(t,e,r){if(void 0===r&&(r={}),null!=e){var n="layers."+this.id+".layout."+t;if(this._validate(xn,n,t,e,r))return}"visibility"!==t?this._unevaluatedLayout.setValue(t,e):this.visibility=e;},e.prototype.getPaintProperty=function(t){return m(t,"-transition")?this._transitionablePaint.getTransition(t.slice(0,-"-transition".length)):this._transitionablePaint.getValue(t)},e.prototype.setPaintProperty=function(t,e,r){if(void 0===r&&(r={}),null!=e){var n="layers."+this.id+".paint."+t;if(this._validate(gn,n,t,e,r))return !1}if(m(t,"-transition"))return this._transitionablePaint.setTransition(t.slice(0,-"-transition".length),e||void 0),!1;var i=this._transitionablePaint._values[t],a="cross-faded-data-driven"===i.property.specification["property-type"],o=i.value.isDataDriven(),s=i.value;this._transitionablePaint.setValue(t,e),this._handleSpecialPaintPropertyUpdate(t);var u=this._transitionablePaint._values[t].value;return u.isDataDriven()||o||a||this._handleOverridablePaintPropertyUpdate(t,s,u)},e.prototype._handleSpecialPaintPropertyUpdate=function(t){},e.prototype._handleOverridablePaintPropertyUpdate=function(t,e,r){return !1},e.prototype.isHidden=function(t){return !!(this.minzoom&&t<this.minzoom)||(!!(this.maxzoom&&t>=this.maxzoom)||"none"===this.visibility)},e.prototype.updateTransitions=function(t){this._transitioningPaint=this._transitionablePaint.transitioned(t,this._transitioningPaint);},e.prototype.hasTransition=function(){return this._transitioningPaint.hasTransition()},e.prototype.recalculate=function(t,e){t.getCrossfadeParameters&&(this._crossfadeParameters=t.getCrossfadeParameters()),this._unevaluatedLayout&&(this.layout=this._unevaluatedLayout.possiblyEvaluate(t,e)),this.paint=this._transitioningPaint.possiblyEvaluate(t,e);},e.prototype.serialize=function(){var t={id:this.id,type:this.type,source:this.source,"source-layer":this.sourceLayer,metadata:this.metadata,minzoom:this.minzoom,maxzoom:this.maxzoom,filter:this.filter,layout:this._unevaluatedLayout&&this._unevaluatedLayout.serialize(),paint:this._transitionablePaint&&this._transitionablePaint.serialize()};return this.visibility&&(t.layout=t.layout||{},t.layout.visibility=this.visibility),g(t,(function(t,e){return !(void 0===t||"layout"===e&&!Object.keys(t).length||"paint"===e&&!Object.keys(t).length)}))},e.prototype._validate=function(t,e,r,n,i){return void 0===i&&(i={}),(!i||!1!==i.validate)&&bn(this,t.call(mn,{key:e,layerType:this.type,objectKey:r,value:n,styleSpec:Bt,style:{glyphs:!0,sprite:!0}}))},e.prototype.is3D=function(){return !1},e.prototype.isTileClipped=function(){return !1},e.prototype.hasOffscreenPass=function(){return !1},e.prototype.resize=function(){},e.prototype.isStateDependent=function(){for(var t in this.paint._values){var e=this.paint.get(t);if(e instanceof si&&_r(e.property.specification)&&(("source"===e.value.kind||"composite"===e.value.kind)&&e.value.isStateDependent))return !0}return !1},e}(Mt),mi={Int8:Int8Array,Uint8:Uint8Array,Int16:Int16Array,Uint16:Uint16Array,Int32:Int32Array,Uint32:Uint32Array,Float32:Float32Array},vi=function(t,e){this._structArray=t,this._pos1=e*this.size,this._pos2=this._pos1/2,this._pos4=this._pos1/4,this._pos8=this._pos1/8;},gi=function(){this.isTransferred=!1,this.capacity=-1,this.resize(0);};function xi(t,e){void 0===e&&(e=1);var r=0,n=0;return {members:t.map((function(t){var i,a=(i=t.type,mi[i].BYTES_PER_ELEMENT),o=r=bi(r,Math.max(e,a)),s=t.components||1;return n=Math.max(n,a),r+=a*s,{name:t.name,type:t.type,components:s,offset:o}})),size:bi(r,Math.max(n,e)),alignment:e}}function bi(t,e){return Math.ceil(t/e)*e}gi.serialize=function(t,e){return t._trim(),e&&(t.isTransferred=!0,e.push(t.arrayBuffer)),{length:t.length,arrayBuffer:t.arrayBuffer}},gi.deserialize=function(t){var e=Object.create(this.prototype);return e.arrayBuffer=t.arrayBuffer,e.length=t.length,e.capacity=t.arrayBuffer.byteLength/e.bytesPerElement,e._refreshViews(),e},gi.prototype._trim=function(){this.length!==this.capacity&&(this.capacity=this.length,this.arrayBuffer=this.arrayBuffer.slice(0,this.length*this.bytesPerElement),this._refreshViews());},gi.prototype.clear=function(){this.length=0;},gi.prototype.resize=function(t){this.reserve(t),this.length=t;},gi.prototype.reserve=function(t){if(t>this.capacity){this.capacity=Math.max(t,Math.floor(5*this.capacity),128),this.arrayBuffer=new ArrayBuffer(this.capacity*this.bytesPerElement);var e=this.uint8;this._refreshViews(),e&&this.uint8.set(e);}},gi.prototype._refreshViews=function(){throw new Error("_refreshViews() must be implemented by each concrete StructArray layout")};var _i=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.int16[n+0]=e,this.int16[n+1]=r,t},e}(gi);_i.prototype.bytesPerElement=4,zn("StructArrayLayout2i4",_i);var wi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=4*t;return this.int16[a+0]=e,this.int16[a+1]=r,this.int16[a+2]=n,this.int16[a+3]=i,t},e}(gi);wi.prototype.bytesPerElement=8,zn("StructArrayLayout4i8",wi);var Ai=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=6*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,this.int16[s+4]=a,this.int16[s+5]=o,t},e}(gi);Ai.prototype.bytesPerElement=12,zn("StructArrayLayout2i4i12",Ai);var Si=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=4*t,u=8*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.uint8[u+4]=n,this.uint8[u+5]=i,this.uint8[u+6]=a,this.uint8[u+7]=o,t},e}(gi);Si.prototype.bytesPerElement=8,zn("StructArrayLayout2i4ub8",Si);var ki=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s){var u=this.length;return this.resize(u+1),this.emplace(u,t,e,r,n,i,a,o,s)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u){var l=8*t;return this.uint16[l+0]=e,this.uint16[l+1]=r,this.uint16[l+2]=n,this.uint16[l+3]=i,this.uint16[l+4]=a,this.uint16[l+5]=o,this.uint16[l+6]=s,this.uint16[l+7]=u,t},e}(gi);ki.prototype.bytesPerElement=16,zn("StructArrayLayout8ui16",ki);var Ii=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,c){var h=this.length;return this.resize(h+1),this.emplace(h,t,e,r,n,i,a,o,s,u,l,p,c)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c,h){var f=12*t;return this.int16[f+0]=e,this.int16[f+1]=r,this.int16[f+2]=n,this.int16[f+3]=i,this.uint16[f+4]=a,this.uint16[f+5]=o,this.uint16[f+6]=s,this.uint16[f+7]=u,this.int16[f+8]=l,this.int16[f+9]=p,this.int16[f+10]=c,this.int16[f+11]=h,t},e}(gi);Ii.prototype.bytesPerElement=24,zn("StructArrayLayout4i4ui4i24",Ii);var zi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.float32[i+0]=e,this.float32[i+1]=r,this.float32[i+2]=n,t},e}(gi);zi.prototype.bytesPerElement=12,zn("StructArrayLayout3f12",zi);var Ci=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){var r=1*t;return this.uint32[r+0]=e,t},e}(gi);Ci.prototype.bytesPerElement=4,zn("StructArrayLayout1ul4",Ci);var Ti=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p){var c=this.length;return this.resize(c+1),this.emplace(c,t,e,r,n,i,a,o,s,u,l,p)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c){var h=12*t,f=6*t;return this.int16[h+0]=e,this.int16[h+1]=r,this.int16[h+2]=n,this.int16[h+3]=i,this.int16[h+4]=a,this.int16[h+5]=o,this.uint32[f+3]=s,this.uint16[h+8]=u,this.uint16[h+9]=l,this.int16[h+10]=p,this.int16[h+11]=c,t},e}(gi);Ti.prototype.bytesPerElement=24,zn("StructArrayLayout6i1ul2ui2i24",Ti);var Ei=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a){var o=this.length;return this.resize(o+1),this.emplace(o,t,e,r,n,i,a)},e.prototype.emplace=function(t,e,r,n,i,a,o){var s=6*t;return this.int16[s+0]=e,this.int16[s+1]=r,this.int16[s+2]=n,this.int16[s+3]=i,this.int16[s+4]=a,this.int16[s+5]=o,t},e}(gi);Ei.prototype.bytesPerElement=12,zn("StructArrayLayout2i2i2i12",Ei);var Mi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=12*t,o=3*t;return this.uint8[a+0]=e,this.uint8[a+1]=r,this.float32[o+1]=n,this.float32[o+2]=i,t},e}(gi);Mi.prototype.bytesPerElement=12,zn("StructArrayLayout2ub2f12",Mi);var Bi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m){var v=this.length;return this.resize(v+1),this.emplace(v,t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v){var g=24*t,x=12*t,b=48*t;return this.int16[g+0]=e,this.int16[g+1]=r,this.uint16[g+2]=n,this.uint16[g+3]=i,this.uint32[x+2]=a,this.uint32[x+3]=o,this.uint32[x+4]=s,this.uint16[g+10]=u,this.uint16[g+11]=l,this.uint16[g+12]=p,this.float32[x+7]=c,this.float32[x+8]=h,this.uint8[b+36]=f,this.uint8[b+37]=y,this.uint8[b+38]=d,this.uint32[x+10]=m,this.int16[g+22]=v,t},e}(gi);Bi.prototype.bytesPerElement=48,zn("StructArrayLayout2i2ui3ul3ui2f3ub1ul1i48",Bi);var Pi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x,b,_,w,A,S,k){var I=this.length;return this.resize(I+1),this.emplace(I,t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x,b,_,w,A,S,k)},e.prototype.emplace=function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x,b,_,w,A,S,k,I){var z=30*t,C=15*t;return this.int16[z+0]=e,this.int16[z+1]=r,this.int16[z+2]=n,this.int16[z+3]=i,this.int16[z+4]=a,this.int16[z+5]=o,this.int16[z+6]=s,this.int16[z+7]=u,this.uint16[z+8]=l,this.uint16[z+9]=p,this.uint16[z+10]=c,this.uint16[z+11]=h,this.uint16[z+12]=f,this.uint16[z+13]=y,this.uint16[z+14]=d,this.uint16[z+15]=m,this.uint16[z+16]=v,this.uint16[z+17]=g,this.uint16[z+18]=x,this.uint16[z+19]=b,this.uint16[z+20]=_,this.uint16[z+21]=w,this.uint32[C+11]=A,this.float32[C+12]=S,this.float32[C+13]=k,this.float32[C+14]=I,t},e}(gi);Pi.prototype.bytesPerElement=60,zn("StructArrayLayout8i14ui1ul3f60",Pi);var Vi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){var r=1*t;return this.float32[r+0]=e,t},e}(gi);Vi.prototype.bytesPerElement=4,zn("StructArrayLayout1f4",Vi);var Fi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.int16=new Int16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.int16[i+0]=e,this.int16[i+1]=r,this.int16[i+2]=n,t},e}(gi);Fi.prototype.bytesPerElement=6,zn("StructArrayLayout3i6",Fi);var Li=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint32=new Uint32Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=2*t,a=4*t;return this.uint32[i+0]=e,this.uint16[a+2]=r,this.uint16[a+3]=n,t},e}(gi);Li.prototype.bytesPerElement=8,zn("StructArrayLayout1ul2ui8",Li);var Di=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r){var n=this.length;return this.resize(n+1),this.emplace(n,t,e,r)},e.prototype.emplace=function(t,e,r,n){var i=3*t;return this.uint16[i+0]=e,this.uint16[i+1]=r,this.uint16[i+2]=n,t},e}(gi);Di.prototype.bytesPerElement=6,zn("StructArrayLayout3ui6",Di);var Oi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.uint16[n+0]=e,this.uint16[n+1]=r,t},e}(gi);Oi.prototype.bytesPerElement=4,zn("StructArrayLayout2ui4",Oi);var Ri=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.uint16=new Uint16Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t){var e=this.length;return this.resize(e+1),this.emplace(e,t)},e.prototype.emplace=function(t,e){var r=1*t;return this.uint16[r+0]=e,t},e}(gi);Ri.prototype.bytesPerElement=2,zn("StructArrayLayout1ui2",Ri);var Ui=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e){var r=this.length;return this.resize(r+1),this.emplace(r,t,e)},e.prototype.emplace=function(t,e,r){var n=2*t;return this.float32[n+0]=e,this.float32[n+1]=r,t},e}(gi);Ui.prototype.bytesPerElement=8,zn("StructArrayLayout2f8",Ui);var ji=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._refreshViews=function(){this.uint8=new Uint8Array(this.arrayBuffer),this.float32=new Float32Array(this.arrayBuffer);},e.prototype.emplaceBack=function(t,e,r,n){var i=this.length;return this.resize(i+1),this.emplace(i,t,e,r,n)},e.prototype.emplace=function(t,e,r,n,i){var a=4*t;return this.float32[a+0]=e,this.float32[a+1]=r,this.float32[a+2]=n,this.float32[a+3]=i,t},e}(gi);ji.prototype.bytesPerElement=16,zn("StructArrayLayout4f16",ji);var qi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorPointX:{configurable:!0},anchorPointY:{configurable:!0},x1:{configurable:!0},y1:{configurable:!0},x2:{configurable:!0},y2:{configurable:!0},featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0},radius:{configurable:!0},signedDistanceFromAnchor:{configurable:!0},anchorPoint:{configurable:!0}};return r.anchorPointX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorPointX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorPointY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorPointY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.x1.get=function(){return this._structArray.int16[this._pos2+2]},r.x1.set=function(t){this._structArray.int16[this._pos2+2]=t;},r.y1.get=function(){return this._structArray.int16[this._pos2+3]},r.y1.set=function(t){this._structArray.int16[this._pos2+3]=t;},r.x2.get=function(){return this._structArray.int16[this._pos2+4]},r.x2.set=function(t){this._structArray.int16[this._pos2+4]=t;},r.y2.get=function(){return this._structArray.int16[this._pos2+5]},r.y2.set=function(t){this._structArray.int16[this._pos2+5]=t;},r.featureIndex.get=function(){return this._structArray.uint32[this._pos4+3]},r.featureIndex.set=function(t){this._structArray.uint32[this._pos4+3]=t;},r.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+8]},r.sourceLayerIndex.set=function(t){this._structArray.uint16[this._pos2+8]=t;},r.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+9]},r.bucketIndex.set=function(t){this._structArray.uint16[this._pos2+9]=t;},r.radius.get=function(){return this._structArray.int16[this._pos2+10]},r.radius.set=function(t){this._structArray.int16[this._pos2+10]=t;},r.signedDistanceFromAnchor.get=function(){return this._structArray.int16[this._pos2+11]},r.signedDistanceFromAnchor.set=function(t){this._structArray.int16[this._pos2+11]=t;},r.anchorPoint.get=function(){return new i(this.anchorPointX,this.anchorPointY)},Object.defineProperties(e.prototype,r),e}(vi);qi.prototype.size=24;var Ni=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new qi(this,t)},e}(Ti);zn("CollisionBoxArray",Ni);var Ki=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorX:{configurable:!0},anchorY:{configurable:!0},glyphStartIndex:{configurable:!0},numGlyphs:{configurable:!0},vertexStartIndex:{configurable:!0},lineStartIndex:{configurable:!0},lineLength:{configurable:!0},segment:{configurable:!0},lowerSize:{configurable:!0},upperSize:{configurable:!0},lineOffsetX:{configurable:!0},lineOffsetY:{configurable:!0},writingMode:{configurable:!0},placedOrientation:{configurable:!0},hidden:{configurable:!0},crossTileID:{configurable:!0},associatedIconIndex:{configurable:!0}};return r.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.glyphStartIndex.get=function(){return this._structArray.uint16[this._pos2+2]},r.glyphStartIndex.set=function(t){this._structArray.uint16[this._pos2+2]=t;},r.numGlyphs.get=function(){return this._structArray.uint16[this._pos2+3]},r.numGlyphs.set=function(t){this._structArray.uint16[this._pos2+3]=t;},r.vertexStartIndex.get=function(){return this._structArray.uint32[this._pos4+2]},r.vertexStartIndex.set=function(t){this._structArray.uint32[this._pos4+2]=t;},r.lineStartIndex.get=function(){return this._structArray.uint32[this._pos4+3]},r.lineStartIndex.set=function(t){this._structArray.uint32[this._pos4+3]=t;},r.lineLength.get=function(){return this._structArray.uint32[this._pos4+4]},r.lineLength.set=function(t){this._structArray.uint32[this._pos4+4]=t;},r.segment.get=function(){return this._structArray.uint16[this._pos2+10]},r.segment.set=function(t){this._structArray.uint16[this._pos2+10]=t;},r.lowerSize.get=function(){return this._structArray.uint16[this._pos2+11]},r.lowerSize.set=function(t){this._structArray.uint16[this._pos2+11]=t;},r.upperSize.get=function(){return this._structArray.uint16[this._pos2+12]},r.upperSize.set=function(t){this._structArray.uint16[this._pos2+12]=t;},r.lineOffsetX.get=function(){return this._structArray.float32[this._pos4+7]},r.lineOffsetX.set=function(t){this._structArray.float32[this._pos4+7]=t;},r.lineOffsetY.get=function(){return this._structArray.float32[this._pos4+8]},r.lineOffsetY.set=function(t){this._structArray.float32[this._pos4+8]=t;},r.writingMode.get=function(){return this._structArray.uint8[this._pos1+36]},r.writingMode.set=function(t){this._structArray.uint8[this._pos1+36]=t;},r.placedOrientation.get=function(){return this._structArray.uint8[this._pos1+37]},r.placedOrientation.set=function(t){this._structArray.uint8[this._pos1+37]=t;},r.hidden.get=function(){return this._structArray.uint8[this._pos1+38]},r.hidden.set=function(t){this._structArray.uint8[this._pos1+38]=t;},r.crossTileID.get=function(){return this._structArray.uint32[this._pos4+10]},r.crossTileID.set=function(t){this._structArray.uint32[this._pos4+10]=t;},r.associatedIconIndex.get=function(){return this._structArray.int16[this._pos2+22]},r.associatedIconIndex.set=function(t){this._structArray.int16[this._pos2+22]=t;},Object.defineProperties(e.prototype,r),e}(vi);Ki.prototype.size=48;var Xi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new Ki(this,t)},e}(Bi);zn("PlacedSymbolArray",Xi);var Zi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={anchorX:{configurable:!0},anchorY:{configurable:!0},rightJustifiedTextSymbolIndex:{configurable:!0},centerJustifiedTextSymbolIndex:{configurable:!0},leftJustifiedTextSymbolIndex:{configurable:!0},verticalPlacedTextSymbolIndex:{configurable:!0},placedIconSymbolIndex:{configurable:!0},verticalPlacedIconSymbolIndex:{configurable:!0},key:{configurable:!0},textBoxStartIndex:{configurable:!0},textBoxEndIndex:{configurable:!0},verticalTextBoxStartIndex:{configurable:!0},verticalTextBoxEndIndex:{configurable:!0},iconBoxStartIndex:{configurable:!0},iconBoxEndIndex:{configurable:!0},verticalIconBoxStartIndex:{configurable:!0},verticalIconBoxEndIndex:{configurable:!0},featureIndex:{configurable:!0},numHorizontalGlyphVertices:{configurable:!0},numVerticalGlyphVertices:{configurable:!0},numIconVertices:{configurable:!0},numVerticalIconVertices:{configurable:!0},crossTileID:{configurable:!0},textBoxScale:{configurable:!0},textOffset0:{configurable:!0},textOffset1:{configurable:!0}};return r.anchorX.get=function(){return this._structArray.int16[this._pos2+0]},r.anchorX.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.anchorY.get=function(){return this._structArray.int16[this._pos2+1]},r.anchorY.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.rightJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+2]},r.rightJustifiedTextSymbolIndex.set=function(t){this._structArray.int16[this._pos2+2]=t;},r.centerJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+3]},r.centerJustifiedTextSymbolIndex.set=function(t){this._structArray.int16[this._pos2+3]=t;},r.leftJustifiedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+4]},r.leftJustifiedTextSymbolIndex.set=function(t){this._structArray.int16[this._pos2+4]=t;},r.verticalPlacedTextSymbolIndex.get=function(){return this._structArray.int16[this._pos2+5]},r.verticalPlacedTextSymbolIndex.set=function(t){this._structArray.int16[this._pos2+5]=t;},r.placedIconSymbolIndex.get=function(){return this._structArray.int16[this._pos2+6]},r.placedIconSymbolIndex.set=function(t){this._structArray.int16[this._pos2+6]=t;},r.verticalPlacedIconSymbolIndex.get=function(){return this._structArray.int16[this._pos2+7]},r.verticalPlacedIconSymbolIndex.set=function(t){this._structArray.int16[this._pos2+7]=t;},r.key.get=function(){return this._structArray.uint16[this._pos2+8]},r.key.set=function(t){this._structArray.uint16[this._pos2+8]=t;},r.textBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+9]},r.textBoxStartIndex.set=function(t){this._structArray.uint16[this._pos2+9]=t;},r.textBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+10]},r.textBoxEndIndex.set=function(t){this._structArray.uint16[this._pos2+10]=t;},r.verticalTextBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+11]},r.verticalTextBoxStartIndex.set=function(t){this._structArray.uint16[this._pos2+11]=t;},r.verticalTextBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+12]},r.verticalTextBoxEndIndex.set=function(t){this._structArray.uint16[this._pos2+12]=t;},r.iconBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+13]},r.iconBoxStartIndex.set=function(t){this._structArray.uint16[this._pos2+13]=t;},r.iconBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+14]},r.iconBoxEndIndex.set=function(t){this._structArray.uint16[this._pos2+14]=t;},r.verticalIconBoxStartIndex.get=function(){return this._structArray.uint16[this._pos2+15]},r.verticalIconBoxStartIndex.set=function(t){this._structArray.uint16[this._pos2+15]=t;},r.verticalIconBoxEndIndex.get=function(){return this._structArray.uint16[this._pos2+16]},r.verticalIconBoxEndIndex.set=function(t){this._structArray.uint16[this._pos2+16]=t;},r.featureIndex.get=function(){return this._structArray.uint16[this._pos2+17]},r.featureIndex.set=function(t){this._structArray.uint16[this._pos2+17]=t;},r.numHorizontalGlyphVertices.get=function(){return this._structArray.uint16[this._pos2+18]},r.numHorizontalGlyphVertices.set=function(t){this._structArray.uint16[this._pos2+18]=t;},r.numVerticalGlyphVertices.get=function(){return this._structArray.uint16[this._pos2+19]},r.numVerticalGlyphVertices.set=function(t){this._structArray.uint16[this._pos2+19]=t;},r.numIconVertices.get=function(){return this._structArray.uint16[this._pos2+20]},r.numIconVertices.set=function(t){this._structArray.uint16[this._pos2+20]=t;},r.numVerticalIconVertices.get=function(){return this._structArray.uint16[this._pos2+21]},r.numVerticalIconVertices.set=function(t){this._structArray.uint16[this._pos2+21]=t;},r.crossTileID.get=function(){return this._structArray.uint32[this._pos4+11]},r.crossTileID.set=function(t){this._structArray.uint32[this._pos4+11]=t;},r.textBoxScale.get=function(){return this._structArray.float32[this._pos4+12]},r.textBoxScale.set=function(t){this._structArray.float32[this._pos4+12]=t;},r.textOffset0.get=function(){return this._structArray.float32[this._pos4+13]},r.textOffset0.set=function(t){this._structArray.float32[this._pos4+13]=t;},r.textOffset1.get=function(){return this._structArray.float32[this._pos4+14]},r.textOffset1.set=function(t){this._structArray.float32[this._pos4+14]=t;},Object.defineProperties(e.prototype,r),e}(vi);Zi.prototype.size=60;var Gi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new Zi(this,t)},e}(Pi);zn("SymbolInstanceArray",Gi);var Ji=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={offsetX:{configurable:!0}};return r.offsetX.get=function(){return this._structArray.float32[this._pos4+0]},r.offsetX.set=function(t){this._structArray.float32[this._pos4+0]=t;},Object.defineProperties(e.prototype,r),e}(vi);Ji.prototype.size=4;var Yi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getoffsetX=function(t){return this.float32[1*t+0]},e.prototype.get=function(t){return new Ji(this,t)},e}(Vi);zn("GlyphOffsetArray",Yi);var Hi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={x:{configurable:!0},y:{configurable:!0},tileUnitDistanceFromAnchor:{configurable:!0}};return r.x.get=function(){return this._structArray.int16[this._pos2+0]},r.x.set=function(t){this._structArray.int16[this._pos2+0]=t;},r.y.get=function(){return this._structArray.int16[this._pos2+1]},r.y.set=function(t){this._structArray.int16[this._pos2+1]=t;},r.tileUnitDistanceFromAnchor.get=function(){return this._structArray.int16[this._pos2+2]},r.tileUnitDistanceFromAnchor.set=function(t){this._structArray.int16[this._pos2+2]=t;},Object.defineProperties(e.prototype,r),e}(vi);Hi.prototype.size=6;var $i=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getx=function(t){return this.int16[3*t+0]},e.prototype.gety=function(t){return this.int16[3*t+1]},e.prototype.gettileUnitDistanceFromAnchor=function(t){return this.int16[3*t+2]},e.prototype.get=function(t){return new Hi(this,t)},e}(Fi);zn("SymbolLineVertexArray",$i);var Wi=function(t){function e(){t.apply(this,arguments);}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var r={featureIndex:{configurable:!0},sourceLayerIndex:{configurable:!0},bucketIndex:{configurable:!0}};return r.featureIndex.get=function(){return this._structArray.uint32[this._pos4+0]},r.featureIndex.set=function(t){this._structArray.uint32[this._pos4+0]=t;},r.sourceLayerIndex.get=function(){return this._structArray.uint16[this._pos2+2]},r.sourceLayerIndex.set=function(t){this._structArray.uint16[this._pos2+2]=t;},r.bucketIndex.get=function(){return this._structArray.uint16[this._pos2+3]},r.bucketIndex.set=function(t){this._structArray.uint16[this._pos2+3]=t;},Object.defineProperties(e.prototype,r),e}(vi);Wi.prototype.size=8;var Qi=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.get=function(t){return new Wi(this,t)},e}(Li);zn("FeatureIndexArray",Qi);var ta=xi([{name:"a_pos",components:2,type:"Int16"}],4).members,ea=function(t){void 0===t&&(t=[]),this.segments=t;};function ra(t,e){return 256*(t=u(Math.floor(t),0,255))+(e=u(Math.floor(e),0,255))}ea.prototype.prepareSegment=function(t,e,r,n){var i=this.segments[this.segments.length-1];return t>ea.MAX_VERTEX_ARRAY_LENGTH&&_("Max vertices per segment is "+ea.MAX_VERTEX_ARRAY_LENGTH+": bucket requested "+t),(!i||i.vertexLength+t>ea.MAX_VERTEX_ARRAY_LENGTH||i.sortKey!==n)&&(i={vertexOffset:e.length,primitiveOffset:r.length,vertexLength:0,primitiveLength:0},void 0!==n&&(i.sortKey=n),this.segments.push(i)),i},ea.prototype.get=function(){return this.segments},ea.prototype.destroy=function(){for(var t=0,e=this.segments;t<e.length;t+=1){var r=e[t];for(var n in r.vaos)r.vaos[n].destroy();}},ea.simpleSegment=function(t,e,r,n){return new ea([{vertexOffset:t,primitiveOffset:e,vertexLength:r,primitiveLength:n,vaos:{},sortKey:0}])},ea.MAX_VERTEX_ARRAY_LENGTH=Math.pow(2,16)-1,zn("SegmentVector",ea);var na=e((function(t){t.exports=function(t,e){var r,n,i,a,o,s,u,l;for(r=3&t.length,n=t.length-r,i=e,o=3432918353,s=461845907,l=0;l<n;)u=255&t.charCodeAt(l)|(255&t.charCodeAt(++l))<<8|(255&t.charCodeAt(++l))<<16|(255&t.charCodeAt(++l))<<24,++l,i=27492+(65535&(a=5*(65535&(i=(i^=u=(65535&(u=(u=(65535&u)*o+(((u>>>16)*o&65535)<<16)&4294967295)<<15|u>>>17))*s+(((u>>>16)*s&65535)<<16)&4294967295)<<13|i>>>19))+((5*(i>>>16)&65535)<<16)&4294967295))+((58964+(a>>>16)&65535)<<16);switch(u=0,r){case 3:u^=(255&t.charCodeAt(l+2))<<16;case 2:u^=(255&t.charCodeAt(l+1))<<8;case 1:i^=u=(65535&(u=(u=(65535&(u^=255&t.charCodeAt(l)))*o+(((u>>>16)*o&65535)<<16)&4294967295)<<15|u>>>17))*s+(((u>>>16)*s&65535)<<16)&4294967295;}return i^=t.length,i=2246822507*(65535&(i^=i>>>16))+((2246822507*(i>>>16)&65535)<<16)&4294967295,i=3266489909*(65535&(i^=i>>>13))+((3266489909*(i>>>16)&65535)<<16)&4294967295,(i^=i>>>16)>>>0};})),ia=e((function(t){t.exports=function(t,e){for(var r,n=t.length,i=e^n,a=0;n>=4;)r=1540483477*(65535&(r=255&t.charCodeAt(a)|(255&t.charCodeAt(++a))<<8|(255&t.charCodeAt(++a))<<16|(255&t.charCodeAt(++a))<<24))+((1540483477*(r>>>16)&65535)<<16),i=1540483477*(65535&i)+((1540483477*(i>>>16)&65535)<<16)^(r=1540483477*(65535&(r^=r>>>24))+((1540483477*(r>>>16)&65535)<<16)),n-=4,++a;switch(n){case 3:i^=(255&t.charCodeAt(a+2))<<16;case 2:i^=(255&t.charCodeAt(a+1))<<8;case 1:i=1540483477*(65535&(i^=255&t.charCodeAt(a)))+((1540483477*(i>>>16)&65535)<<16);}return i=1540483477*(65535&(i^=i>>>13))+((1540483477*(i>>>16)&65535)<<16),(i^=i>>>15)>>>0};})),aa=na,oa=na,sa=ia;aa.murmur3=oa,aa.murmur2=sa;var ua=function(){this.ids=[],this.positions=[],this.indexed=!1;};ua.prototype.add=function(t,e,r,n){this.ids.push(pa(t)),this.positions.push(e,r,n);},ua.prototype.getPositions=function(t){for(var e=pa(t),r=0,n=this.ids.length-1;r<n;){var i=r+n>>1;this.ids[i]>=e?n=i:r=i+1;}for(var a=[];this.ids[r]===e;){var o=this.positions[3*r],s=this.positions[3*r+1],u=this.positions[3*r+2];a.push({index:o,start:s,end:u}),r++;}return a},ua.serialize=function(t,e){var r=new Float64Array(t.ids),n=new Uint32Array(t.positions);return function t(e,r,n,i){if(n>=i)return;var a=e[n+i>>1];var o=n-1;var s=i+1;for(;;){do{o++;}while(e[o]<a);do{s--;}while(e[s]>a);if(o>=s)break;ca(e,o,s),ca(r,3*o,3*s),ca(r,3*o+1,3*s+1),ca(r,3*o+2,3*s+2);}t(e,r,n,s);t(e,r,s+1,i);}(r,n,0,r.length-1),e&&e.push(r.buffer,n.buffer),{ids:r,positions:n}},ua.deserialize=function(t){var e=new ua;return e.ids=t.ids,e.positions=t.positions,e.indexed=!0,e};var la=Math.pow(2,53)-1;function pa(t){var e=+t;return !isNaN(e)&&e<=la?e:aa(String(t))}function ca(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}zn("FeaturePositionMap",ua);var ha=function(t,e){this.gl=t.gl,this.location=e;},fa=function(t){function e(e,r){t.call(this,e,r),this.current=0;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){this.current!==t&&(this.current=t,this.gl.uniform1i(this.location,t));},e}(ha),ya=function(t){function e(e,r){t.call(this,e,r),this.current=0;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){this.current!==t&&(this.current=t,this.gl.uniform1f(this.location,t));},e}(ha),da=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0];}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]||(this.current=t,this.gl.uniform2f(this.location,t[0],t[1]));},e}(ha),ma=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0,0];}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]&&t[2]===this.current[2]||(this.current=t,this.gl.uniform3f(this.location,t[0],t[1],t[2]));},e}(ha),va=function(t){function e(e,r){t.call(this,e,r),this.current=[0,0,0,0];}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t[0]===this.current[0]&&t[1]===this.current[1]&&t[2]===this.current[2]&&t[3]===this.current[3]||(this.current=t,this.gl.uniform4f(this.location,t[0],t[1],t[2],t[3]));},e}(ha),ga=function(t){function e(e,r){t.call(this,e,r),this.current=ee.transparent;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){t.r===this.current.r&&t.g===this.current.g&&t.b===this.current.b&&t.a===this.current.a||(this.current=t,this.gl.uniform4f(this.location,t.r,t.g,t.b,t.a));},e}(ha),xa=new Float32Array(16),ba=function(t){function e(e,r){t.call(this,e,r),this.current=xa;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){if(t[12]!==this.current[12]||t[0]!==this.current[0])return this.current=t,void this.gl.uniformMatrix4fv(this.location,!1,t);for(var e=1;e<16;e++)if(t[e]!==this.current[e]){this.current=t,this.gl.uniformMatrix4fv(this.location,!1,t);break}},e}(ha);function _a(t){return [ra(255*t.r,255*t.g),ra(255*t.b,255*t.a)]}var wa=function(t,e,r){this.value=t,this.uniformNames=e.map((function(t){return "u_"+t})),this.type=r;};wa.prototype.setUniform=function(t,e,r){t.set(r.constantOr(this.value));},wa.prototype.getBinding=function(t,e){return "color"===this.type?new ga(t,e):new ya(t,e)};var Aa=function(t,e){this.uniformNames=e.map((function(t){return "u_"+t})),this.patternFrom=null,this.patternTo=null;};Aa.prototype.setConstantPatternPositions=function(t,e){this.patternTo=t.tlbr,this.patternFrom=e.tlbr;},Aa.prototype.setUniform=function(t,e,r,n){var i="u_pattern_to"===n?this.patternTo:"u_pattern_from"===n?this.patternFrom:null;i&&t.set(i);},Aa.prototype.getBinding=function(t,e){return new va(t,e)};var Sa=function(t,e,r,n){this.expression=t,this.type=r,this.maxValue=0,this.paintVertexAttributes=e.map((function(t){return {name:"a_"+t,type:"Float32",components:"color"===r?2:1,offset:0}})),this.paintVertexArray=new n;};Sa.prototype.populatePaintArray=function(t,e,r,n){var i=this.paintVertexArray.length,a=this.expression.evaluate(new ti(0),e,{},[],n);this.paintVertexArray.resize(t),this._setPaintValue(i,t,a);},Sa.prototype.updatePaintArray=function(t,e,r,n){var i=this.expression.evaluate({zoom:0},r,n);this._setPaintValue(t,e,i);},Sa.prototype._setPaintValue=function(t,e,r){if("color"===this.type)for(var n=_a(r),i=t;i<e;i++)this.paintVertexArray.emplace(i,n[0],n[1]);else{for(var a=t;a<e;a++)this.paintVertexArray.emplace(a,r);this.maxValue=Math.max(this.maxValue,Math.abs(r));}},Sa.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},Sa.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();};var ka=function(t,e,r,n,i,a){this.expression=t,this.uniformNames=e.map((function(t){return "u_"+t+"_t"})),this.type=r,this.useIntegerZoom=n,this.zoom=i,this.maxValue=0,this.paintVertexAttributes=e.map((function(t){return {name:"a_"+t,type:"Float32",components:"color"===r?4:2,offset:0}})),this.paintVertexArray=new a;};ka.prototype.populatePaintArray=function(t,e,r,n){var i=this.expression.evaluate(new ti(this.zoom),e,{},[],n),a=this.expression.evaluate(new ti(this.zoom+1),e,{},[],n),o=this.paintVertexArray.length;this.paintVertexArray.resize(t),this._setPaintValue(o,t,i,a);},ka.prototype.updatePaintArray=function(t,e,r,n){var i=this.expression.evaluate({zoom:this.zoom},r,n),a=this.expression.evaluate({zoom:this.zoom+1},r,n);this._setPaintValue(t,e,i,a);},ka.prototype._setPaintValue=function(t,e,r,n){if("color"===this.type)for(var i=_a(r),a=_a(n),o=t;o<e;o++)this.paintVertexArray.emplace(o,i[0],i[1],a[0],a[1]);else{for(var s=t;s<e;s++)this.paintVertexArray.emplace(s,r,n);this.maxValue=Math.max(this.maxValue,Math.abs(r),Math.abs(n));}},ka.prototype.upload=function(t){this.paintVertexArray&&this.paintVertexArray.arrayBuffer&&(this.paintVertexBuffer&&this.paintVertexBuffer.buffer?this.paintVertexBuffer.updateData(this.paintVertexArray):this.paintVertexBuffer=t.createVertexBuffer(this.paintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},ka.prototype.destroy=function(){this.paintVertexBuffer&&this.paintVertexBuffer.destroy();},ka.prototype.setUniform=function(t,e){var r=this.useIntegerZoom?Math.floor(e.zoom):e.zoom,n=u(this.expression.interpolationFactor(r,this.zoom,this.zoom+1),0,1);t.set(n);},ka.prototype.getBinding=function(t,e){return new ya(t,e)};var Ia=function(t,e,r,n,i,a,o){this.expression=t,this.type=r,this.useIntegerZoom=n,this.zoom=i,this.layerId=o,this.paintVertexAttributes=e.map((function(t){return {name:"a_"+t,type:"Uint16",components:4,offset:0}})),this.zoomInPaintVertexArray=new a,this.zoomOutPaintVertexArray=new a;};Ia.prototype.populatePaintArray=function(t,e,r){var n=this.zoomInPaintVertexArray.length;this.zoomInPaintVertexArray.resize(t),this.zoomOutPaintVertexArray.resize(t),this._setPaintValues(n,t,e.patterns&&e.patterns[this.layerId],r);},Ia.prototype.updatePaintArray=function(t,e,r,n,i){this._setPaintValues(t,e,r.patterns&&r.patterns[this.layerId],i);},Ia.prototype._setPaintValues=function(t,e,r,n){if(n&&r){var i=r.min,a=r.mid,o=r.max,s=n[i],u=n[a],l=n[o];if(s&&u&&l)for(var p=t;p<e;p++)this.zoomInPaintVertexArray.emplace(p,u.tl[0],u.tl[1],u.br[0],u.br[1],s.tl[0],s.tl[1],s.br[0],s.br[1]),this.zoomOutPaintVertexArray.emplace(p,u.tl[0],u.tl[1],u.br[0],u.br[1],l.tl[0],l.tl[1],l.br[0],l.br[1]);}},Ia.prototype.upload=function(t){this.zoomInPaintVertexArray&&this.zoomInPaintVertexArray.arrayBuffer&&this.zoomOutPaintVertexArray&&this.zoomOutPaintVertexArray.arrayBuffer&&(this.zoomInPaintVertexBuffer=t.createVertexBuffer(this.zoomInPaintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent),this.zoomOutPaintVertexBuffer=t.createVertexBuffer(this.zoomOutPaintVertexArray,this.paintVertexAttributes,this.expression.isStateDependent));},Ia.prototype.destroy=function(){this.zoomOutPaintVertexBuffer&&this.zoomOutPaintVertexBuffer.destroy(),this.zoomInPaintVertexBuffer&&this.zoomInPaintVertexBuffer.destroy();};var za=function(t,e,r,n){this.binders={},this.layoutAttributes=n,this._buffers=[];var i=[];for(var a in t.paint._values)if(r(a)){var o=t.paint.get(a);if(o instanceof si&&_r(o.property.specification)){var s=Ta(a,t.type),u=o.value,l=o.property.specification.type,p=o.property.useIntegerZoom,c=o.property.specification["property-type"],h="cross-faded"===c||"cross-faded-data-driven"===c;if("constant"===u.kind)this.binders[a]=h?new Aa(u.value,s):new wa(u.value,s,l),i.push("/u_"+a);else if("source"===u.kind||h){var f=Ea(a,l,"source");this.binders[a]=h?new Ia(u,s,l,p,e,f,t.id):new Sa(u,s,l,f),i.push("/a_"+a);}else{var y=Ea(a,l,"composite");this.binders[a]=new ka(u,s,l,p,e,y),i.push("/z_"+a);}}}this.cacheKey=i.sort().join("");};za.prototype.getMaxValue=function(t){var e=this.binders[t];return e instanceof Sa||e instanceof ka?e.maxValue:0},za.prototype.populatePaintArrays=function(t,e,r,n){for(var i in this.binders){var a=this.binders[i];(a instanceof Sa||a instanceof ka||a instanceof Ia)&&a.populatePaintArray(t,e,r,n);}},za.prototype.setConstantPatternPositions=function(t,e){for(var r in this.binders){var n=this.binders[r];n instanceof Aa&&n.setConstantPatternPositions(t,e);}},za.prototype.updatePaintArrays=function(t,e,r,n,i){var a=!1;for(var o in t)for(var s=0,u=e.getPositions(o);s<u.length;s+=1){var l=u[s],p=r.feature(l.index);for(var c in this.binders){var h=this.binders[c];if((h instanceof Sa||h instanceof ka||h instanceof Ia)&&!0===h.expression.isStateDependent){var f=n.paint.get(c);h.expression=f.value,h.updatePaintArray(l.start,l.end,p,t[o],i),a=!0;}}}return a},za.prototype.defines=function(){var t=[];for(var e in this.binders){var r=this.binders[e];(r instanceof wa||r instanceof Aa)&&t.push.apply(t,r.uniformNames.map((function(t){return "#define HAS_UNIFORM_"+t})));}return t},za.prototype.getPaintVertexBuffers=function(){return this._buffers},za.prototype.getUniforms=function(t,e){var r=[];for(var n in this.binders){var i=this.binders[n];if(i instanceof wa||i instanceof Aa||i instanceof ka)for(var a=0,o=i.uniformNames;a<o.length;a+=1){var s=o[a];if(e[s]){var u=i.getBinding(t,e[s]);r.push({name:s,property:n,binding:u});}}}return r},za.prototype.setUniforms=function(t,e,r,n){for(var i=0,a=e;i<a.length;i+=1){var o=a[i],s=o.name,u=o.property,l=o.binding;this.binders[u].setUniform(l,n,r.get(u),s);}},za.prototype.updatePaintBuffers=function(t){for(var e in this._buffers=[],this.binders){var r=this.binders[e];if(t&&r instanceof Ia){var n=2===t.fromScale?r.zoomInPaintVertexBuffer:r.zoomOutPaintVertexBuffer;n&&this._buffers.push(n);}else(r instanceof Sa||r instanceof ka)&&r.paintVertexBuffer&&this._buffers.push(r.paintVertexBuffer);}},za.prototype.upload=function(t){for(var e in this.binders){var r=this.binders[e];(r instanceof Sa||r instanceof ka||r instanceof Ia)&&r.upload(t);}this.updatePaintBuffers();},za.prototype.destroy=function(){for(var t in this.binders){var e=this.binders[t];(e instanceof Sa||e instanceof ka||e instanceof Ia)&&e.destroy();}};var Ca=function(t,e,r,n){void 0===n&&(n=function(){return !0}),this.programConfigurations={};for(var i=0,a=e;i<a.length;i+=1){var o=a[i];this.programConfigurations[o.id]=new za(o,r,n,t);}this.needsUpload=!1,this._featureMap=new ua,this._bufferOffset=0;};function Ta(t,e){return {"text-opacity":["opacity"],"icon-opacity":["opacity"],"text-color":["fill_color"],"icon-color":["fill_color"],"text-halo-color":["halo_color"],"icon-halo-color":["halo_color"],"text-halo-blur":["halo_blur"],"icon-halo-blur":["halo_blur"],"text-halo-width":["halo_width"],"icon-halo-width":["halo_width"],"line-gap-width":["gapwidth"],"line-pattern":["pattern_to","pattern_from"],"fill-pattern":["pattern_to","pattern_from"],"fill-extrusion-pattern":["pattern_to","pattern_from"]}[t]||[t.replace(e+"-","").replace(/-/g,"_")]}function Ea(t,e,r){var n={color:{source:Ui,composite:ji},number:{source:Vi,composite:Ui}},i=function(t){return {"line-pattern":{source:ki,composite:ki},"fill-pattern":{source:ki,composite:ki},"fill-extrusion-pattern":{source:ki,composite:ki}}[t]}(t);return i&&i[r]||n[e][r]}Ca.prototype.populatePaintArrays=function(t,e,r,n,i){for(var a in this.programConfigurations)this.programConfigurations[a].populatePaintArrays(t,e,n,i);void 0!==e.id&&this._featureMap.add(e.id,r,this._bufferOffset,t),this._bufferOffset=t,this.needsUpload=!0;},Ca.prototype.updatePaintArrays=function(t,e,r,n){for(var i=0,a=r;i<a.length;i+=1){var o=a[i];this.needsUpload=this.programConfigurations[o.id].updatePaintArrays(t,this._featureMap,e,o,n)||this.needsUpload;}},Ca.prototype.get=function(t){return this.programConfigurations[t]},Ca.prototype.upload=function(t){if(this.needsUpload){for(var e in this.programConfigurations)this.programConfigurations[e].upload(t);this.needsUpload=!1;}},Ca.prototype.destroy=function(){for(var t in this.programConfigurations)this.programConfigurations[t].destroy();},zn("ConstantBinder",wa),zn("CrossFadedConstantBinder",Aa),zn("SourceExpressionBinder",Sa),zn("CrossFadedCompositeBinder",Ia),zn("CompositeExpressionBinder",ka),zn("ProgramConfiguration",za,{omit:["_buffers"]}),zn("ProgramConfigurationSet",Ca);var Ma=8192;var Ba,Pa=(Ba=15,{min:-1*Math.pow(2,Ba-1),max:Math.pow(2,Ba-1)-1});function Va(t){for(var e=Ma/t.extent,r=t.loadGeometry(),n=0;n<r.length;n++)for(var i=r[n],a=0;a<i.length;a++){var o=i[a];o.x=Math.round(o.x*e),o.y=Math.round(o.y*e),(o.x<Pa.min||o.x>Pa.max||o.y<Pa.min||o.y>Pa.max)&&(_("Geometry exceeds allowed extent, reduce your vector tile buffer size"),o.x=u(o.x,Pa.min,Pa.max),o.y=u(o.y,Pa.min,Pa.max));}return r}function Fa(t,e,r,n,i){t.emplaceBack(2*e+(n+1)/2,2*r+(i+1)/2);}var La=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new _i,this.indexArray=new Di,this.segments=new ea,this.programConfigurations=new Ca(ta,t.layers,t.zoom),this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};function Da(t,e){for(var r=0;r<t.length;r++)if(Za(e,t[r]))return !0;for(var n=0;n<e.length;n++)if(Za(t,e[n]))return !0;return !!ja(t,e)}function Oa(t,e,r){return !!Za(t,e)||!!Na(e,t,r)}function Ra(t,e){if(1===t.length)return Xa(e,t[0]);for(var r=0;r<e.length;r++)for(var n=e[r],i=0;i<n.length;i++)if(Za(t,n[i]))return !0;for(var a=0;a<t.length;a++)if(Xa(e,t[a]))return !0;for(var o=0;o<e.length;o++)if(ja(t,e[o]))return !0;return !1}function Ua(t,e,r){if(t.length>1){if(ja(t,e))return !0;for(var n=0;n<e.length;n++)if(Na(e[n],t,r))return !0}for(var i=0;i<t.length;i++)if(Na(t[i],e,r))return !0;return !1}function ja(t,e){if(0===t.length||0===e.length)return !1;for(var r=0;r<t.length-1;r++)for(var n=t[r],i=t[r+1],a=0;a<e.length-1;a++){if(qa(n,i,e[a],e[a+1]))return !0}return !1}function qa(t,e,r,n){return w(t,r,n)!==w(e,r,n)&&w(t,e,r)!==w(t,e,n)}function Na(t,e,r){var n=r*r;if(1===e.length)return t.distSqr(e[0])<n;for(var i=1;i<e.length;i++){if(Ka(t,e[i-1],e[i])<n)return !0}return !1}function Ka(t,e,r){var n=e.distSqr(r);if(0===n)return t.distSqr(e);var i=((t.x-e.x)*(r.x-e.x)+(t.y-e.y)*(r.y-e.y))/n;return i<0?t.distSqr(e):i>1?t.distSqr(r):t.distSqr(r.sub(e)._mult(i)._add(e))}function Xa(t,e){for(var r,n,i,a=!1,o=0;o<t.length;o++)for(var s=0,u=(r=t[o]).length-1;s<r.length;u=s++)n=r[s],i=r[u],n.y>e.y!=i.y>e.y&&e.x<(i.x-n.x)*(e.y-n.y)/(i.y-n.y)+n.x&&(a=!a);return a}function Za(t,e){for(var r=!1,n=0,i=t.length-1;n<t.length;i=n++){var a=t[n],o=t[i];a.y>e.y!=o.y>e.y&&e.x<(o.x-a.x)*(e.y-a.y)/(o.y-a.y)+a.x&&(r=!r);}return r}function Ga(t,e,r){var n=r[0],i=r[2];if(t.x<n.x&&e.x<n.x||t.x>i.x&&e.x>i.x||t.y<n.y&&e.y<n.y||t.y>i.y&&e.y>i.y)return !1;var a=w(t,e,r[0]);return a!==w(t,e,r[1])||a!==w(t,e,r[2])||a!==w(t,e,r[3])}function Ja(t,e,r){var n=e.paint.get(t).value;return "constant"===n.kind?n.value:r.programConfigurations.get(e.id).getMaxValue(t)}function Ya(t){return Math.sqrt(t[0]*t[0]+t[1]*t[1])}function Ha(t,e,r,n,a){if(!e[0]&&!e[1])return t;var o=i.convert(e)._mult(a);"viewport"===r&&o._rotate(-n);for(var s=[],u=0;u<t.length;u++){var l=t[u];s.push(l.sub(o));}return s}La.prototype.populate=function(t,e){var r=this.layers[0],n=[],i=null;"circle"===r.type&&(i=r.layout.get("circle-sort-key"));for(var a=0,o=t;a<o.length;a+=1){var s=o[a],u=s.feature,l=s.id,p=s.index,c=s.sourceLayerIndex;if(this.layers[0]._featureFilter(new ti(this.zoom),u)){var h=Va(u),f=i?i.evaluate(u,{}):void 0,y={id:l,properties:u.properties,type:u.type,sourceLayerIndex:c,index:p,geometry:h,patterns:{},sortKey:f};n.push(y);}}i&&n.sort((function(t,e){return t.sortKey-e.sortKey}));for(var d=0,m=n;d<m.length;d+=1){var v=m[d],g=v,x=g.geometry,b=g.index,_=g.sourceLayerIndex,w=t[b].feature;this.addFeature(v,x,b),e.featureIndex.insert(w,x,b,_,this.index);}},La.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},La.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},La.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},La.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,ta),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},La.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},La.prototype.addFeature=function(t,e,r){for(var n=0,i=e;n<i.length;n+=1)for(var a=0,o=i[n];a<o.length;a+=1){var s=o[a],u=s.x,l=s.y;if(!(u<0||u>=Ma||l<0||l>=Ma)){var p=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray,t.sortKey),c=p.vertexLength;Fa(this.layoutVertexArray,u,l,-1,-1),Fa(this.layoutVertexArray,u,l,1,-1),Fa(this.layoutVertexArray,u,l,1,1),Fa(this.layoutVertexArray,u,l,-1,1),this.indexArray.emplaceBack(c,c+1,c+2),this.indexArray.emplaceBack(c,c+3,c+2),p.vertexLength+=4,p.primitiveLength+=2;}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,{});},zn("CircleBucket",La,{omit:["layers"]});var $a=new yi({"circle-sort-key":new pi(Bt.layout_circle["circle-sort-key"])}),Wa={paint:new yi({"circle-radius":new pi(Bt.paint_circle["circle-radius"]),"circle-color":new pi(Bt.paint_circle["circle-color"]),"circle-blur":new pi(Bt.paint_circle["circle-blur"]),"circle-opacity":new pi(Bt.paint_circle["circle-opacity"]),"circle-translate":new li(Bt.paint_circle["circle-translate"]),"circle-translate-anchor":new li(Bt.paint_circle["circle-translate-anchor"]),"circle-pitch-scale":new li(Bt.paint_circle["circle-pitch-scale"]),"circle-pitch-alignment":new li(Bt.paint_circle["circle-pitch-alignment"]),"circle-stroke-width":new pi(Bt.paint_circle["circle-stroke-width"]),"circle-stroke-color":new pi(Bt.paint_circle["circle-stroke-color"]),"circle-stroke-opacity":new pi(Bt.paint_circle["circle-stroke-opacity"])}),layout:$a},Qa="undefined"!=typeof Float32Array?Float32Array:Array;Math.hypot||(Math.hypot=function(){for(var t=arguments,e=0,r=arguments.length;r--;)e+=t[r]*t[r];return Math.sqrt(e)});var to,eo,ro=function(t,e,r){return t[0]=e[0]-r[0],t[1]=e[1]-r[1],t[2]=e[2]-r[2],t};to=new Qa(3),Qa!=Float32Array&&(to[0]=0,to[1]=0,to[2]=0),eo=to;function no(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3];return t[0]=r[0]*n+r[4]*i+r[8]*a+r[12]*o,t[1]=r[1]*n+r[5]*i+r[9]*a+r[13]*o,t[2]=r[2]*n+r[6]*i+r[10]*a+r[14]*o,t[3]=r[3]*n+r[7]*i+r[11]*a+r[15]*o,t}!function(){var t=function(){var t=new Qa(4);return Qa!=Float32Array&&(t[0]=0,t[1]=0,t[2]=0,t[3]=0),t}();}();var io=function(t){var e=t[0],r=t[1];return e*e+r*r},ao=(function(){var t=function(){var t=new Qa(2);return Qa!=Float32Array&&(t[0]=0,t[1]=0),t}();}(),function(t){function e(e){t.call(this,e,Wa);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new La(t)},e.prototype.queryRadius=function(t){var e=t;return Ja("circle-radius",this,e)+Ja("circle-stroke-width",this,e)+Ya(this.paint.get("circle-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o,s){for(var u=Ha(t,this.paint.get("circle-translate"),this.paint.get("circle-translate-anchor"),a.angle,o),l=this.paint.get("circle-radius").evaluate(e,r)+this.paint.get("circle-stroke-width").evaluate(e,r),p="map"===this.paint.get("circle-pitch-alignment"),c=p?u:function(t,e){return t.map((function(t){return oo(t,e)}))}(u,s),h=p?l*o:l,f=0,y=n;f<y.length;f+=1)for(var d=0,m=y[f];d<m.length;d+=1){var v=m[d],g=p?v:oo(v,s),x=h,b=no([],[v.x,v.y,0,1],s);if("viewport"===this.paint.get("circle-pitch-scale")&&"map"===this.paint.get("circle-pitch-alignment")?x*=b[3]/a.cameraToCenterDistance:"map"===this.paint.get("circle-pitch-scale")&&"viewport"===this.paint.get("circle-pitch-alignment")&&(x*=a.cameraToCenterDistance/b[3]),Oa(c,g,x))return !0}return !1},e}(di));function oo(t,e){var r=no([],[t.x,t.y,0,1],e);return new i(r[0]/r[3],r[1]/r[3])}var so=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(La);function uo(t,e,r,n){var i=e.width,a=e.height;if(n){if(n instanceof Uint8ClampedArray)n=new Uint8Array(n.buffer);else if(n.length!==i*a*r)throw new RangeError("mismatched image size")}else n=new Uint8Array(i*a*r);return t.width=i,t.height=a,t.data=n,t}function lo(t,e,r){var n=e.width,i=e.height;if(n!==t.width||i!==t.height){var a=uo({},{width:n,height:i},r);po(t,a,{x:0,y:0},{x:0,y:0},{width:Math.min(t.width,n),height:Math.min(t.height,i)},r),t.width=n,t.height=i,t.data=a.data;}}function po(t,e,r,n,i,a){if(0===i.width||0===i.height)return e;if(i.width>t.width||i.height>t.height||r.x>t.width-i.width||r.y>t.height-i.height)throw new RangeError("out of range source coordinates for image copy");if(i.width>e.width||i.height>e.height||n.x>e.width-i.width||n.y>e.height-i.height)throw new RangeError("out of range destination coordinates for image copy");for(var o=t.data,s=e.data,u=0;u<i.height;u++)for(var l=((r.y+u)*t.width+r.x)*a,p=((n.y+u)*e.width+n.x)*a,c=0;c<i.width*a;c++)s[p+c]=o[l+c];return e}zn("HeatmapBucket",so,{omit:["layers"]});var co=function(t,e){uo(this,t,1,e);};co.prototype.resize=function(t){lo(this,t,1);},co.prototype.clone=function(){return new co({width:this.width,height:this.height},new Uint8Array(this.data))},co.copy=function(t,e,r,n,i){po(t,e,r,n,i,1);};var ho=function(t,e){uo(this,t,4,e);};ho.prototype.resize=function(t){lo(this,t,4);},ho.prototype.replace=function(t,e){e?this.data.set(t):t instanceof Uint8ClampedArray?this.data=new Uint8Array(t.buffer):this.data=t;},ho.prototype.clone=function(){return new ho({width:this.width,height:this.height},new Uint8Array(this.data))},ho.copy=function(t,e,r,n,i){po(t,e,r,n,i,4);},zn("AlphaImage",co),zn("RGBAImage",ho);var fo={paint:new yi({"heatmap-radius":new pi(Bt.paint_heatmap["heatmap-radius"]),"heatmap-weight":new pi(Bt.paint_heatmap["heatmap-weight"]),"heatmap-intensity":new li(Bt.paint_heatmap["heatmap-intensity"]),"heatmap-color":new fi(Bt.paint_heatmap["heatmap-color"]),"heatmap-opacity":new li(Bt.paint_heatmap["heatmap-opacity"])})};function yo(t,e){for(var r=new Uint8Array(1024),n={},i=0,a=0;i<256;i++,a+=4){n[e]=i/255;var o=t.evaluate(n);r[a+0]=Math.floor(255*o.r/o.a),r[a+1]=Math.floor(255*o.g/o.a),r[a+2]=Math.floor(255*o.b/o.a),r[a+3]=Math.floor(255*o.a);}return new ho({width:256,height:1},r)}var mo=function(t){function e(e){t.call(this,e,fo),this._updateColorRamp();}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new so(t)},e.prototype._handleSpecialPaintPropertyUpdate=function(t){"heatmap-color"===t&&this._updateColorRamp();},e.prototype._updateColorRamp=function(){var t=this._transitionablePaint._values["heatmap-color"].value.expression;this.colorRamp=yo(t,"heatmapDensity"),this.colorRampTexture=null;},e.prototype.resize=function(){this.heatmapFbo&&(this.heatmapFbo.destroy(),this.heatmapFbo=null);},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return !1},e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("heatmap-opacity")&&"none"!==this.visibility},e}(di),vo={paint:new yi({"hillshade-illumination-direction":new li(Bt.paint_hillshade["hillshade-illumination-direction"]),"hillshade-illumination-anchor":new li(Bt.paint_hillshade["hillshade-illumination-anchor"]),"hillshade-exaggeration":new li(Bt.paint_hillshade["hillshade-exaggeration"]),"hillshade-shadow-color":new li(Bt.paint_hillshade["hillshade-shadow-color"]),"hillshade-highlight-color":new li(Bt.paint_hillshade["hillshade-highlight-color"]),"hillshade-accent-color":new li(Bt.paint_hillshade["hillshade-accent-color"])})},go=function(t){function e(e){t.call(this,e,vo);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.hasOffscreenPass=function(){return 0!==this.paint.get("hillshade-exaggeration")&&"none"!==this.visibility},e}(di),xo=xi([{name:"a_pos",components:2,type:"Int16"}],4).members,bo=wo,_o=wo;function wo(t,e,r){r=r||2;var n,i,a,o,s,u,l,p=e&&e.length,c=p?e[0]*r:t.length,h=Ao(t,0,c,r,!0),f=[];if(!h||h.next===h.prev)return f;if(p&&(h=function(t,e,r,n){var i,a,o,s,u,l=[];for(i=0,a=e.length;i<a;i++)o=e[i]*n,s=i<a-1?e[i+1]*n:t.length,(u=Ao(t,o,s,n,!1))===u.next&&(u.steiner=!0),l.push(Vo(u));for(l.sort(Eo),i=0;i<l.length;i++)Mo(l[i],r),r=So(r,r.next);return r}(t,e,h,r)),t.length>80*r){n=a=t[0],i=o=t[1];for(var y=r;y<c;y+=r)(s=t[y])<n&&(n=s),(u=t[y+1])<i&&(i=u),s>a&&(a=s),u>o&&(o=u);l=0!==(l=Math.max(a-n,o-i))?1/l:0;}return ko(h,f,r,n,i,l),f}function Ao(t,e,r,n,i){var a,o;if(i===Go(t,e,r,n)>0)for(a=e;a<r;a+=n)o=Ko(a,t[a],t[a+1],o);else for(a=r-n;a>=e;a-=n)o=Ko(a,t[a],t[a+1],o);return o&&Oo(o,o.next)&&(Xo(o),o=o.next),o}function So(t,e){if(!t)return t;e||(e=t);var r,n=t;do{if(r=!1,n.steiner||!Oo(n,n.next)&&0!==Do(n.prev,n,n.next))n=n.next;else{if(Xo(n),(n=e=n.prev)===n.next)break;r=!0;}}while(r||n!==e);return e}function ko(t,e,r,n,i,a,o){if(t){!o&&a&&function(t,e,r,n){var i=t;do{null===i.z&&(i.z=Po(i.x,i.y,e,r,n)),i.prevZ=i.prev,i.nextZ=i.next,i=i.next;}while(i!==t);i.prevZ.nextZ=null,i.prevZ=null,function(t){var e,r,n,i,a,o,s,u,l=1;do{for(r=t,t=null,a=null,o=0;r;){for(o++,n=r,s=0,e=0;e<l&&(s++,n=n.nextZ);e++);for(u=l;s>0||u>0&&n;)0!==s&&(0===u||!n||r.z<=n.z)?(i=r,r=r.nextZ,s--):(i=n,n=n.nextZ,u--),a?a.nextZ=i:t=i,i.prevZ=a,a=i;r=n;}a.nextZ=null,l*=2;}while(o>1)}(i);}(t,n,i,a);for(var s,u,l=t;t.prev!==t.next;)if(s=t.prev,u=t.next,a?zo(t,n,i,a):Io(t))e.push(s.i/r),e.push(t.i/r),e.push(u.i/r),Xo(t),t=u.next,l=u.next;else if((t=u)===l){o?1===o?ko(t=Co(So(t),e,r),e,r,n,i,a,2):2===o&&To(t,e,r,n,i,a):ko(So(t),e,r,n,i,a,1);break}}}function Io(t){var e=t.prev,r=t,n=t.next;if(Do(e,r,n)>=0)return !1;for(var i=t.next.next;i!==t.prev;){if(Fo(e.x,e.y,r.x,r.y,n.x,n.y,i.x,i.y)&&Do(i.prev,i,i.next)>=0)return !1;i=i.next;}return !0}function zo(t,e,r,n){var i=t.prev,a=t,o=t.next;if(Do(i,a,o)>=0)return !1;for(var s=i.x<a.x?i.x<o.x?i.x:o.x:a.x<o.x?a.x:o.x,u=i.y<a.y?i.y<o.y?i.y:o.y:a.y<o.y?a.y:o.y,l=i.x>a.x?i.x>o.x?i.x:o.x:a.x>o.x?a.x:o.x,p=i.y>a.y?i.y>o.y?i.y:o.y:a.y>o.y?a.y:o.y,c=Po(s,u,e,r,n),h=Po(l,p,e,r,n),f=t.prevZ,y=t.nextZ;f&&f.z>=c&&y&&y.z<=h;){if(f!==t.prev&&f!==t.next&&Fo(i.x,i.y,a.x,a.y,o.x,o.y,f.x,f.y)&&Do(f.prev,f,f.next)>=0)return !1;if(f=f.prevZ,y!==t.prev&&y!==t.next&&Fo(i.x,i.y,a.x,a.y,o.x,o.y,y.x,y.y)&&Do(y.prev,y,y.next)>=0)return !1;y=y.nextZ;}for(;f&&f.z>=c;){if(f!==t.prev&&f!==t.next&&Fo(i.x,i.y,a.x,a.y,o.x,o.y,f.x,f.y)&&Do(f.prev,f,f.next)>=0)return !1;f=f.prevZ;}for(;y&&y.z<=h;){if(y!==t.prev&&y!==t.next&&Fo(i.x,i.y,a.x,a.y,o.x,o.y,y.x,y.y)&&Do(y.prev,y,y.next)>=0)return !1;y=y.nextZ;}return !0}function Co(t,e,r){var n=t;do{var i=n.prev,a=n.next.next;!Oo(i,a)&&Ro(i,n,n.next,a)&&qo(i,a)&&qo(a,i)&&(e.push(i.i/r),e.push(n.i/r),e.push(a.i/r),Xo(n),Xo(n.next),n=t=a),n=n.next;}while(n!==t);return So(n)}function To(t,e,r,n,i,a){var o=t;do{for(var s=o.next.next;s!==o.prev;){if(o.i!==s.i&&Lo(o,s)){var u=No(o,s);return o=So(o,o.next),u=So(u,u.next),ko(o,e,r,n,i,a),void ko(u,e,r,n,i,a)}s=s.next;}o=o.next;}while(o!==t)}function Eo(t,e){return t.x-e.x}function Mo(t,e){if(e=function(t,e){var r,n=e,i=t.x,a=t.y,o=-1/0;do{if(a<=n.y&&a>=n.next.y&&n.next.y!==n.y){var s=n.x+(a-n.y)*(n.next.x-n.x)/(n.next.y-n.y);if(s<=i&&s>o){if(o=s,s===i){if(a===n.y)return n;if(a===n.next.y)return n.next}r=n.x<n.next.x?n:n.next;}}n=n.next;}while(n!==e);if(!r)return null;if(i===o)return r;var u,l=r,p=r.x,c=r.y,h=1/0;n=r;do{i>=n.x&&n.x>=p&&i!==n.x&&Fo(a<c?i:o,a,p,c,a<c?o:i,a,n.x,n.y)&&(u=Math.abs(a-n.y)/(i-n.x),qo(n,t)&&(u<h||u===h&&(n.x>r.x||n.x===r.x&&Bo(r,n)))&&(r=n,h=u)),n=n.next;}while(n!==l);return r}(t,e)){var r=No(e,t);So(e,e.next),So(r,r.next);}}function Bo(t,e){return Do(t.prev,t,e.prev)<0&&Do(e.next,t,t.next)<0}function Po(t,e,r,n,i){return (t=1431655765&((t=858993459&((t=252645135&((t=16711935&((t=32767*(t-r)*i)|t<<8))|t<<4))|t<<2))|t<<1))|(e=1431655765&((e=858993459&((e=252645135&((e=16711935&((e=32767*(e-n)*i)|e<<8))|e<<4))|e<<2))|e<<1))<<1}function Vo(t){var e=t,r=t;do{(e.x<r.x||e.x===r.x&&e.y<r.y)&&(r=e),e=e.next;}while(e!==t);return r}function Fo(t,e,r,n,i,a,o,s){return (i-o)*(e-s)-(t-o)*(a-s)>=0&&(t-o)*(n-s)-(r-o)*(e-s)>=0&&(r-o)*(a-s)-(i-o)*(n-s)>=0}function Lo(t,e){return t.next.i!==e.i&&t.prev.i!==e.i&&!function(t,e){var r=t;do{if(r.i!==t.i&&r.next.i!==t.i&&r.i!==e.i&&r.next.i!==e.i&&Ro(r,r.next,t,e))return !0;r=r.next;}while(r!==t);return !1}(t,e)&&(qo(t,e)&&qo(e,t)&&function(t,e){var r=t,n=!1,i=(t.x+e.x)/2,a=(t.y+e.y)/2;do{r.y>a!=r.next.y>a&&r.next.y!==r.y&&i<(r.next.x-r.x)*(a-r.y)/(r.next.y-r.y)+r.x&&(n=!n),r=r.next;}while(r!==t);return n}(t,e)&&(Do(t.prev,t,e.prev)||Do(t,e.prev,e))||Oo(t,e)&&Do(t.prev,t,t.next)>0&&Do(e.prev,e,e.next)>0)}function Do(t,e,r){return (e.y-t.y)*(r.x-e.x)-(e.x-t.x)*(r.y-e.y)}function Oo(t,e){return t.x===e.x&&t.y===e.y}function Ro(t,e,r,n){var i=jo(Do(t,e,r)),a=jo(Do(t,e,n)),o=jo(Do(r,n,t)),s=jo(Do(r,n,e));return i!==a&&o!==s||(!(0!==i||!Uo(t,r,e))||(!(0!==a||!Uo(t,n,e))||(!(0!==o||!Uo(r,t,n))||!(0!==s||!Uo(r,e,n)))))}function Uo(t,e,r){return e.x<=Math.max(t.x,r.x)&&e.x>=Math.min(t.x,r.x)&&e.y<=Math.max(t.y,r.y)&&e.y>=Math.min(t.y,r.y)}function jo(t){return t>0?1:t<0?-1:0}function qo(t,e){return Do(t.prev,t,t.next)<0?Do(t,e,t.next)>=0&&Do(t,t.prev,e)>=0:Do(t,e,t.prev)<0||Do(t,t.next,e)<0}function No(t,e){var r=new Zo(t.i,t.x,t.y),n=new Zo(e.i,e.x,e.y),i=t.next,a=e.prev;return t.next=e,e.prev=t,r.next=i,i.prev=r,n.next=r,r.prev=n,a.next=n,n.prev=a,n}function Ko(t,e,r,n){var i=new Zo(t,e,r);return n?(i.next=n.next,i.prev=n,n.next.prev=i,n.next=i):(i.prev=i,i.next=i),i}function Xo(t){t.next.prev=t.prev,t.prev.next=t.next,t.prevZ&&(t.prevZ.nextZ=t.nextZ),t.nextZ&&(t.nextZ.prevZ=t.prevZ);}function Zo(t,e,r){this.i=t,this.x=e,this.y=r,this.prev=null,this.next=null,this.z=null,this.prevZ=null,this.nextZ=null,this.steiner=!1;}function Go(t,e,r,n){for(var i=0,a=e,o=r-n;a<r;a+=n)i+=(t[o]-t[a])*(t[a+1]+t[o+1]),o=a;return i}function Jo(t,e,r,n,i){!function t(e,r,n,i,a){for(;i>n;){if(i-n>600){var o=i-n+1,s=r-n+1,u=Math.log(o),l=.5*Math.exp(2*u/3),p=.5*Math.sqrt(u*l*(o-l)/o)*(s-o/2<0?-1:1),c=Math.max(n,Math.floor(r-s*l/o+p)),h=Math.min(i,Math.floor(r+(o-s)*l/o+p));t(e,r,c,h,a);}var f=e[r],y=n,d=i;for(Yo(e,n,r),a(e[i],f)>0&&Yo(e,n,i);y<d;){for(Yo(e,y,d),y++,d--;a(e[y],f)<0;)y++;for(;a(e[d],f)>0;)d--;}0===a(e[n],f)?Yo(e,n,d):Yo(e,++d,i),d<=r&&(n=d+1),r<=d&&(i=d-1);}}(t,e,r||0,n||t.length-1,i||Ho);}function Yo(t,e,r){var n=t[e];t[e]=t[r],t[r]=n;}function Ho(t,e){return t<e?-1:t>e?1:0}function $o(t,e){var r=t.length;if(r<=1)return [t];for(var n,i,a=[],o=0;o<r;o++){var s=A(t[o]);0!==s&&(t[o].area=Math.abs(s),void 0===i&&(i=s<0),i===s<0?(n&&a.push(n),n=[t[o]]):n.push(t[o]));}if(n&&a.push(n),e>1)for(var u=0;u<a.length;u++)a[u].length<=e||(Jo(a[u],e,1,a[u].length-1,Wo),a[u]=a[u].slice(0,e));return a}function Wo(t,e){return e.area-t.area}function Qo(t,e,r){for(var n=r.patternDependencies,i=!1,a=0,o=e;a<o.length;a+=1){var s=o[a].paint.get(t+"-pattern");s.isConstant()||(i=!0);var u=s.constantOr(null);u&&(i=!0,n[u.to]=!0,n[u.from]=!0);}return i}function ts(t,e,r,n,i){for(var a=i.patternDependencies,o=0,s=e;o<s.length;o+=1){var u=s[o],l=u.paint.get(t+"-pattern").value;if("constant"!==l.kind){var p=l.evaluate({zoom:n-1},r,{},i.availableImages),c=l.evaluate({zoom:n},r,{},i.availableImages),h=l.evaluate({zoom:n+1},r,{},i.availableImages);p=p&&p.name?p.name:p,c=c&&c.name?c.name:c,h=h&&h.name?h.name:h,a[p]=!0,a[c]=!0,a[h]=!0,r.patterns[u.id]={min:p,mid:c,max:h};}}return r}wo.deviation=function(t,e,r,n){var i=e&&e.length,a=i?e[0]*r:t.length,o=Math.abs(Go(t,0,a,r));if(i)for(var s=0,u=e.length;s<u;s++){var l=e[s]*r,p=s<u-1?e[s+1]*r:t.length;o-=Math.abs(Go(t,l,p,r));}var c=0;for(s=0;s<n.length;s+=3){var h=n[s]*r,f=n[s+1]*r,y=n[s+2]*r;c+=Math.abs((t[h]-t[y])*(t[f+1]-t[h+1])-(t[h]-t[f])*(t[y+1]-t[h+1]));}return 0===o&&0===c?0:Math.abs((c-o)/o)},wo.flatten=function(t){for(var e=t[0][0].length,r={vertices:[],holes:[],dimensions:e},n=0,i=0;i<t.length;i++){for(var a=0;a<t[i].length;a++)for(var o=0;o<e;o++)r.vertices.push(t[i][a][o]);i>0&&(n+=t[i-1].length,r.holes.push(n));}return r},bo.default=_o;var es=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.patternFeatures=[],this.layoutVertexArray=new _i,this.indexArray=new Di,this.indexArray2=new Oi,this.programConfigurations=new Ca(xo,t.layers,t.zoom),this.segments=new ea,this.segments2=new ea,this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};es.prototype.populate=function(t,e){this.hasPattern=Qo("fill",this.layers,e);for(var r=this.layers[0].layout.get("fill-sort-key"),n=[],i=0,a=t;i<a.length;i+=1){var o=a[i],s=o.feature,u=o.id,l=o.index,p=o.sourceLayerIndex;if(this.layers[0]._featureFilter(new ti(this.zoom),s)){var c=Va(s),h=r?r.evaluate(s,{},e.availableImages):void 0,f={id:u,properties:s.properties,type:s.type,sourceLayerIndex:p,index:l,geometry:c,patterns:{},sortKey:h};n.push(f);}}r&&n.sort((function(t,e){return t.sortKey-e.sortKey}));for(var y=0,d=n;y<d.length;y+=1){var m=d[y],v=m,g=v.geometry,x=v.index,b=v.sourceLayerIndex;if(this.hasPattern){var _=ts("fill",this.layers,m,this.zoom,e);this.patternFeatures.push(_);}else this.addFeature(m,g,x,{});var w=t[x].feature;e.featureIndex.insert(w,g,x,b,this.index);}},es.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},es.prototype.addFeatures=function(t,e){for(var r=0,n=this.patternFeatures;r<n.length;r+=1){var i=n[r];this.addFeature(i,i.geometry,i.index,e);}},es.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},es.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},es.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,xo),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.indexBuffer2=t.createIndexBuffer(this.indexArray2)),this.programConfigurations.upload(t),this.uploaded=!0;},es.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.indexBuffer2.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.segments2.destroy());},es.prototype.addFeature=function(t,e,r,n){for(var i=0,a=$o(e,500);i<a.length;i+=1){for(var o=a[i],s=0,u=0,l=o;u<l.length;u+=1){s+=l[u].length;}for(var p=this.segments.prepareSegment(s,this.layoutVertexArray,this.indexArray),c=p.vertexLength,h=[],f=[],y=0,d=o;y<d.length;y+=1){var m=d[y];if(0!==m.length){m!==o[0]&&f.push(h.length/2);var v=this.segments2.prepareSegment(m.length,this.layoutVertexArray,this.indexArray2),g=v.vertexLength;this.layoutVertexArray.emplaceBack(m[0].x,m[0].y),this.indexArray2.emplaceBack(g+m.length-1,g),h.push(m[0].x),h.push(m[0].y);for(var x=1;x<m.length;x++)this.layoutVertexArray.emplaceBack(m[x].x,m[x].y),this.indexArray2.emplaceBack(g+x-1,g+x),h.push(m[x].x),h.push(m[x].y);v.vertexLength+=m.length,v.primitiveLength+=m.length;}}for(var b=bo(h,f),_=0;_<b.length;_+=3)this.indexArray.emplaceBack(c+b[_],c+b[_+1],c+b[_+2]);p.vertexLength+=s,p.primitiveLength+=b.length/3;}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,n);},zn("FillBucket",es,{omit:["layers","patternFeatures"]});var rs=new yi({"fill-sort-key":new pi(Bt.layout_fill["fill-sort-key"])}),ns={paint:new yi({"fill-antialias":new li(Bt.paint_fill["fill-antialias"]),"fill-opacity":new pi(Bt.paint_fill["fill-opacity"]),"fill-color":new pi(Bt.paint_fill["fill-color"]),"fill-outline-color":new pi(Bt.paint_fill["fill-outline-color"]),"fill-translate":new li(Bt.paint_fill["fill-translate"]),"fill-translate-anchor":new li(Bt.paint_fill["fill-translate-anchor"]),"fill-pattern":new ci(Bt.paint_fill["fill-pattern"])}),layout:rs},is=function(t){function e(e){t.call(this,e,ns);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(e,r){t.prototype.recalculate.call(this,e,r);var n=this.paint._values["fill-outline-color"];"constant"===n.value.kind&&void 0===n.value.value&&(this.paint._values["fill-outline-color"]=this.paint._values["fill-color"]);},e.prototype.createBucket=function(t){return new es(t)},e.prototype.queryRadius=function(){return Ya(this.paint.get("fill-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,i,a,o){return Ra(Ha(t,this.paint.get("fill-translate"),this.paint.get("fill-translate-anchor"),a.angle,o),n)},e.prototype.isTileClipped=function(){return !0},e}(di),as=xi([{name:"a_pos",components:2,type:"Int16"},{name:"a_normal_ed",components:4,type:"Int16"}],4).members,os=ss;function ss(t,e,r,n,i){this.properties={},this.extent=r,this.type=0,this._pbf=t,this._geometry=-1,this._keys=n,this._values=i,t.readFields(us,this,e);}function us(t,e,r){1==t?e.id=r.readVarint():2==t?function(t,e){var r=t.readVarint()+t.pos;for(;t.pos<r;){var n=e._keys[t.readVarint()],i=e._values[t.readVarint()];e.properties[n]=i;}}(r,e):3==t?e.type=r.readVarint():4==t&&(e._geometry=r.pos);}function ls(t){for(var e,r,n=0,i=0,a=t.length,o=a-1;i<a;o=i++)e=t[i],n+=((r=t[o]).x-e.x)*(e.y+r.y);return n}ss.types=["Unknown","Point","LineString","Polygon"],ss.prototype.loadGeometry=function(){var t=this._pbf;t.pos=this._geometry;for(var e,r=t.readVarint()+t.pos,n=1,a=0,o=0,s=0,u=[];t.pos<r;){if(a<=0){var l=t.readVarint();n=7&l,a=l>>3;}if(a--,1===n||2===n)o+=t.readSVarint(),s+=t.readSVarint(),1===n&&(e&&u.push(e),e=[]),e.push(new i(o,s));else{if(7!==n)throw new Error("unknown command "+n);e&&e.push(e[0].clone());}}return e&&u.push(e),u},ss.prototype.bbox=function(){var t=this._pbf;t.pos=this._geometry;for(var e=t.readVarint()+t.pos,r=1,n=0,i=0,a=0,o=1/0,s=-1/0,u=1/0,l=-1/0;t.pos<e;){if(n<=0){var p=t.readVarint();r=7&p,n=p>>3;}if(n--,1===r||2===r)(i+=t.readSVarint())<o&&(o=i),i>s&&(s=i),(a+=t.readSVarint())<u&&(u=a),a>l&&(l=a);else if(7!==r)throw new Error("unknown command "+r)}return [o,u,s,l]},ss.prototype.toGeoJSON=function(t,e,r){var n,i,a=this.extent*Math.pow(2,r),o=this.extent*t,s=this.extent*e,u=this.loadGeometry(),l=ss.types[this.type];function p(t){for(var e=0;e<t.length;e++){var r=t[e],n=180-360*(r.y+s)/a;t[e]=[360*(r.x+o)/a-180,360/Math.PI*Math.atan(Math.exp(n*Math.PI/180))-90];}}switch(this.type){case 1:var c=[];for(n=0;n<u.length;n++)c[n]=u[n][0];p(u=c);break;case 2:for(n=0;n<u.length;n++)p(u[n]);break;case 3:for(u=function(t){var e=t.length;if(e<=1)return [t];for(var r,n,i=[],a=0;a<e;a++){var o=ls(t[a]);0!==o&&(void 0===n&&(n=o<0),n===o<0?(r&&i.push(r),r=[t[a]]):r.push(t[a]));}r&&i.push(r);return i}(u),n=0;n<u.length;n++)for(i=0;i<u[n].length;i++)p(u[n][i]);}1===u.length?u=u[0]:l="Multi"+l;var h={type:"Feature",geometry:{type:l,coordinates:u},properties:this.properties};return "id"in this&&(h.id=this.id),h};var ps=cs;function cs(t,e){this.version=1,this.name=null,this.extent=4096,this.length=0,this._pbf=t,this._keys=[],this._values=[],this._features=[],t.readFields(hs,this,e),this.length=this._features.length;}function hs(t,e,r){15===t?e.version=r.readVarint():1===t?e.name=r.readString():5===t?e.extent=r.readVarint():2===t?e._features.push(r.pos):3===t?e._keys.push(r.readString()):4===t&&e._values.push(function(t){var e=null,r=t.readVarint()+t.pos;for(;t.pos<r;){var n=t.readVarint()>>3;e=1===n?t.readString():2===n?t.readFloat():3===n?t.readDouble():4===n?t.readVarint64():5===n?t.readVarint():6===n?t.readSVarint():7===n?t.readBoolean():null;}return e}(r));}function fs(t,e,r){if(3===t){var n=new ps(r,r.readVarint()+r.pos);n.length&&(e[n.name]=n);}}cs.prototype.feature=function(t){if(t<0||t>=this._features.length)throw new Error("feature index out of bounds");this._pbf.pos=this._features[t];var e=this._pbf.readVarint()+this._pbf.pos;return new os(this._pbf,e,this.extent,this._keys,this._values)};var ys={VectorTile:function(t,e){this.layers=t.readFields(fs,{},e);},VectorTileFeature:os,VectorTileLayer:ps},ds=ys.VectorTileFeature.types,ms=Math.pow(2,13);function vs(t,e,r,n,i,a,o,s){t.emplaceBack(e,r,2*Math.floor(n*ms)+o,i*ms*2,a*ms*2,Math.round(s));}var gs=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.layoutVertexArray=new Ai,this.indexArray=new Di,this.programConfigurations=new Ca(as,t.layers,t.zoom),this.segments=new ea,this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};function xs(t,e){return t.x===e.x&&(t.x<0||t.x>Ma)||t.y===e.y&&(t.y<0||t.y>Ma)}function bs(t){return t.every((function(t){return t.x<0}))||t.every((function(t){return t.x>Ma}))||t.every((function(t){return t.y<0}))||t.every((function(t){return t.y>Ma}))}gs.prototype.populate=function(t,e){this.features=[],this.hasPattern=Qo("fill-extrusion",this.layers,e);for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=i.feature,o=i.id,s=i.index,u=i.sourceLayerIndex;if(this.layers[0]._featureFilter(new ti(this.zoom),a)){var l=Va(a),p={id:o,sourceLayerIndex:u,index:s,geometry:l,properties:a.properties,type:a.type,patterns:{}};void 0!==a.id&&(p.id=a.id),this.hasPattern?this.features.push(ts("fill-extrusion",this.layers,p,this.zoom,e)):this.addFeature(p,l,s,{}),e.featureIndex.insert(a,l,s,u,this.index,!0);}}},gs.prototype.addFeatures=function(t,e){for(var r=0,n=this.features;r<n.length;r+=1){var i=n[r],a=i.geometry;this.addFeature(i,a,i.index,e);}},gs.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},gs.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},gs.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},gs.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,as),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},gs.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},gs.prototype.addFeature=function(t,e,r,n){for(var i=0,a=$o(e,500);i<a.length;i+=1){for(var o=a[i],s=0,u=0,l=o;u<l.length;u+=1){s+=l[u].length;}for(var p=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray),c=0,h=o;c<h.length;c+=1){var f=h[c];if(0!==f.length&&!bs(f))for(var y=0,d=0;d<f.length;d++){var m=f[d];if(d>=1){var v=f[d-1];if(!xs(m,v)){p.vertexLength+4>ea.MAX_VERTEX_ARRAY_LENGTH&&(p=this.segments.prepareSegment(4,this.layoutVertexArray,this.indexArray));var g=m.sub(v)._perp()._unit(),x=v.dist(m);y+x>32768&&(y=0),vs(this.layoutVertexArray,m.x,m.y,g.x,g.y,0,0,y),vs(this.layoutVertexArray,m.x,m.y,g.x,g.y,0,1,y),y+=x,vs(this.layoutVertexArray,v.x,v.y,g.x,g.y,0,0,y),vs(this.layoutVertexArray,v.x,v.y,g.x,g.y,0,1,y);var b=p.vertexLength;this.indexArray.emplaceBack(b,b+2,b+1),this.indexArray.emplaceBack(b+1,b+2,b+3),p.vertexLength+=4,p.primitiveLength+=2;}}}}if(p.vertexLength+s>ea.MAX_VERTEX_ARRAY_LENGTH&&(p=this.segments.prepareSegment(s,this.layoutVertexArray,this.indexArray)),"Polygon"===ds[t.type]){for(var _=[],w=[],A=p.vertexLength,S=0,k=o;S<k.length;S+=1){var I=k[S];if(0!==I.length){I!==o[0]&&w.push(_.length/2);for(var z=0;z<I.length;z++){var C=I[z];vs(this.layoutVertexArray,C.x,C.y,0,0,1,1,0),_.push(C.x),_.push(C.y);}}}for(var T=bo(_,w),E=0;E<T.length;E+=3)this.indexArray.emplaceBack(A+T[E],A+T[E+2],A+T[E+1]);p.primitiveLength+=T.length/3,p.vertexLength+=s;}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,t,r,n);},zn("FillExtrusionBucket",gs,{omit:["layers","features"]});var _s={paint:new yi({"fill-extrusion-opacity":new li(Bt["paint_fill-extrusion"]["fill-extrusion-opacity"]),"fill-extrusion-color":new pi(Bt["paint_fill-extrusion"]["fill-extrusion-color"]),"fill-extrusion-translate":new li(Bt["paint_fill-extrusion"]["fill-extrusion-translate"]),"fill-extrusion-translate-anchor":new li(Bt["paint_fill-extrusion"]["fill-extrusion-translate-anchor"]),"fill-extrusion-pattern":new ci(Bt["paint_fill-extrusion"]["fill-extrusion-pattern"]),"fill-extrusion-height":new pi(Bt["paint_fill-extrusion"]["fill-extrusion-height"]),"fill-extrusion-base":new pi(Bt["paint_fill-extrusion"]["fill-extrusion-base"]),"fill-extrusion-vertical-gradient":new li(Bt["paint_fill-extrusion"]["fill-extrusion-vertical-gradient"])})},ws=function(t){function e(e){t.call(this,e,_s);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.createBucket=function(t){return new gs(t)},e.prototype.queryRadius=function(){return Ya(this.paint.get("fill-extrusion-translate"))},e.prototype.is3D=function(){return !0},e.prototype.queryIntersectsFeature=function(t,e,r,n,a,o,s,u){var l=Ha(t,this.paint.get("fill-extrusion-translate"),this.paint.get("fill-extrusion-translate-anchor"),o.angle,s),p=this.paint.get("fill-extrusion-height").evaluate(e,r),c=this.paint.get("fill-extrusion-base").evaluate(e,r),h=function(t,e,r,n){for(var a=[],o=0,s=t;o<s.length;o+=1){var u=s[o],l=[u.x,u.y,n,1];no(l,l,e),a.push(new i(l[0]/l[3],l[1]/l[3]));}return a}(l,u,0,0),f=function(t,e,r,n){for(var a=[],o=[],s=n[8]*e,u=n[9]*e,l=n[10]*e,p=n[11]*e,c=n[8]*r,h=n[9]*r,f=n[10]*r,y=n[11]*r,d=0,m=t;d<m.length;d+=1){for(var v=m[d],g=[],x=[],b=0,_=v;b<_.length;b+=1){var w=_[b],A=w.x,S=w.y,k=n[0]*A+n[4]*S+n[12],I=n[1]*A+n[5]*S+n[13],z=n[2]*A+n[6]*S+n[14],C=n[3]*A+n[7]*S+n[15],T=z+l,E=C+p,M=k+c,B=I+h,P=z+f,V=C+y,F=new i((k+s)/E,(I+u)/E);F.z=T/E,g.push(F);var L=new i(M/V,B/V);L.z=P/V,x.push(L);}a.push(g),o.push(x);}return [a,o]}(n,c,p,u);return function(t,e,r){var n=1/0;Ra(r,e)&&(n=Ss(r,e[0]));for(var i=0;i<e.length;i++)for(var a=e[i],o=t[i],s=0;s<a.length-1;s++){var u=a[s],l=a[s+1],p=o[s],c=o[s+1],h=[u,l,c,p,u];Da(r,h)&&(n=Math.min(n,Ss(r,h)));}return n!==1/0&&n}(f[0],f[1],h)},e}(di);function As(t,e){return t.x*e.x+t.y*e.y}function Ss(t,e){if(1===t.length){for(var r,n,i=0,a=e[i++];!r||a.equals(r);)if(!(r=e[i++]))return 1/0;for(;!n||a.equals(n)||r.equals(n);)if(!(n=e[i++]))return 1/0;var o=t[0],s=r.sub(a),u=n.sub(a),l=o.sub(a),p=As(s,s),c=As(s,u),h=As(u,u),f=As(l,s),y=As(l,u),d=p*h-c*c,m=(h*f-c*y)/d,v=(p*y-c*f)/d,g=1-m-v;return a.z*g+r.z*m+n.z*v}for(var x=1/0,b=0,_=e;b<_.length;b+=1){var w=_[b];x=Math.min(x,w.z);}return x}var ks=xi([{name:"a_pos_normal",components:2,type:"Int16"},{name:"a_data",components:4,type:"Uint8"}],4).members,Is=ys.VectorTileFeature.types,zs=Math.cos(Math.PI/180*37.5),Cs=Math.pow(2,14)/.5,Ts=function(t){this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.hasPattern=!1,this.patternFeatures=[],this.layoutVertexArray=new Si,this.indexArray=new Di,this.programConfigurations=new Ca(ks,t.layers,t.zoom),this.segments=new ea,this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id}));};Ts.prototype.populate=function(t,e){this.hasPattern=Qo("line",this.layers,e);for(var r=this.layers[0].layout.get("line-sort-key"),n=[],i=0,a=t;i<a.length;i+=1){var o=a[i],s=o.feature,u=o.id,l=o.index,p=o.sourceLayerIndex;if(this.layers[0]._featureFilter(new ti(this.zoom),s)){var c=Va(s),h=r?r.evaluate(s,{}):void 0,f={id:u,properties:s.properties,type:s.type,sourceLayerIndex:p,index:l,geometry:c,patterns:{},sortKey:h};n.push(f);}}r&&n.sort((function(t,e){return t.sortKey-e.sortKey}));for(var y=0,d=n;y<d.length;y+=1){var m=d[y],v=m,g=v.geometry,x=v.index,b=v.sourceLayerIndex;if(this.hasPattern){var _=ts("line",this.layers,m,this.zoom,e);this.patternFeatures.push(_);}else this.addFeature(m,g,x,{});var w=t[x].feature;e.featureIndex.insert(w,g,x,b,this.index);}},Ts.prototype.update=function(t,e,r){this.stateDependentLayers.length&&this.programConfigurations.updatePaintArrays(t,e,this.stateDependentLayers,r);},Ts.prototype.addFeatures=function(t,e){for(var r=0,n=this.patternFeatures;r<n.length;r+=1){var i=n[r];this.addFeature(i,i.geometry,i.index,e);}},Ts.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length},Ts.prototype.uploadPending=function(){return !this.uploaded||this.programConfigurations.needsUpload},Ts.prototype.upload=function(t){this.uploaded||(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,ks),this.indexBuffer=t.createIndexBuffer(this.indexArray)),this.programConfigurations.upload(t),this.uploaded=!0;},Ts.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy());},Ts.prototype.addFeature=function(t,e,r,n){for(var i=this.layers[0].layout,a=i.get("line-join").evaluate(t,{}),o=i.get("line-cap"),s=i.get("line-miter-limit"),u=i.get("line-round-limit"),l=0,p=e;l<p.length;l+=1){var c=p[l];this.addLine(c,t,a,o,s,u,r,n);}},Ts.prototype.addLine=function(t,e,r,n,i,a,o,s){if(this.distance=0,this.scaledDistance=0,this.totalDistance=0,e.properties&&e.properties.hasOwnProperty("mapbox_clip_start")&&e.properties.hasOwnProperty("mapbox_clip_end")){this.clipStart=+e.properties.mapbox_clip_start,this.clipEnd=+e.properties.mapbox_clip_end;for(var u=0;u<t.length-1;u++)this.totalDistance+=t[u].dist(t[u+1]);this.updateScaledDistance();}for(var l="Polygon"===Is[e.type],p=t.length;p>=2&&t[p-1].equals(t[p-2]);)p--;for(var c=0;c<p-1&&t[c].equals(t[c+1]);)c++;if(!(p<(l?3:2))){"bevel"===r&&(i=1.05);var h,f=this.overscaling<=16?15*Ma/(512*this.overscaling):0,y=this.segments.prepareSegment(10*p,this.layoutVertexArray,this.indexArray),d=void 0,m=void 0,v=void 0,g=void 0;this.e1=this.e2=-1,l&&(h=t[p-2],g=t[c].sub(h)._unit()._perp());for(var x=c;x<p;x++)if(!(m=x===p-1?l?t[c+1]:void 0:t[x+1])||!t[x].equals(m)){g&&(v=g),h&&(d=h),h=t[x],g=m?m.sub(h)._unit()._perp():v;var b=(v=v||g).add(g);0===b.x&&0===b.y||b._unit();var _=v.x*g.x+v.y*g.y,w=b.x*g.x+b.y*g.y,A=0!==w?1/w:1/0,S=2*Math.sqrt(2-2*w),k=w<zs&&d&&m,I=v.x*g.y-v.y*g.x>0;if(k&&x>c){var z=h.dist(d);if(z>2*f){var C=h.sub(h.sub(d)._mult(f/z)._round());this.updateDistance(d,C),this.addCurrentVertex(C,v,0,0,y),d=C;}}var T=d&&m,E=T?r:l?"butt":n;if(T&&"round"===E&&(A<a?E="miter":A<=2&&(E="fakeround")),"miter"===E&&A>i&&(E="bevel"),"bevel"===E&&(A>2&&(E="flipbevel"),A<i&&(E="miter")),d&&this.updateDistance(d,h),"miter"===E)b._mult(A),this.addCurrentVertex(h,b,0,0,y);else if("flipbevel"===E){if(A>100)b=g.mult(-1);else{var M=A*v.add(g).mag()/v.sub(g).mag();b._perp()._mult(M*(I?-1:1));}this.addCurrentVertex(h,b,0,0,y),this.addCurrentVertex(h,b.mult(-1),0,0,y);}else if("bevel"===E||"fakeround"===E){var B=-Math.sqrt(A*A-1),P=I?B:0,V=I?0:B;if(d&&this.addCurrentVertex(h,v,P,V,y),"fakeround"===E)for(var F=Math.round(180*S/Math.PI/20),L=1;L<F;L++){var D=L/F;if(.5!==D){var O=D-.5;D+=D*O*(D-1)*((1.0904+_*(_*(3.55645-1.43519*_)-3.2452))*O*O+(.848013+_*(.215638*_-1.06021)));}var R=g.sub(v)._mult(D)._add(v)._unit()._mult(I?-1:1);this.addHalfVertex(h,R.x,R.y,!1,I,0,y);}m&&this.addCurrentVertex(h,g,-P,-V,y);}else if("butt"===E)this.addCurrentVertex(h,b,0,0,y);else if("square"===E){var U=d?1:-1;this.addCurrentVertex(h,b,U,U,y);}else"round"===E&&(d&&(this.addCurrentVertex(h,v,0,0,y),this.addCurrentVertex(h,v,1,1,y,!0)),m&&(this.addCurrentVertex(h,g,-1,-1,y,!0),this.addCurrentVertex(h,g,0,0,y)));if(k&&x<p-1){var j=h.dist(m);if(j>2*f){var q=h.add(m.sub(h)._mult(f/j)._round());this.updateDistance(h,q),this.addCurrentVertex(q,g,0,0,y),h=q;}}}this.programConfigurations.populatePaintArrays(this.layoutVertexArray.length,e,o,s);}},Ts.prototype.addCurrentVertex=function(t,e,r,n,i,a){void 0===a&&(a=!1);var o=e.x+e.y*r,s=e.y-e.x*r,u=-e.x+e.y*n,l=-e.y-e.x*n;this.addHalfVertex(t,o,s,a,!1,r,i),this.addHalfVertex(t,u,l,a,!0,-n,i),this.distance>Cs/2&&0===this.totalDistance&&(this.distance=0,this.addCurrentVertex(t,e,r,n,i,a));},Ts.prototype.addHalfVertex=function(t,e,r,n,i,a,o){var s=t.x,u=t.y,l=.5*this.scaledDistance;this.layoutVertexArray.emplaceBack((s<<1)+(n?1:0),(u<<1)+(i?1:0),Math.round(63*e)+128,Math.round(63*r)+128,1+(0===a?0:a<0?-1:1)|(63&l)<<2,l>>6);var p=o.vertexLength++;this.e1>=0&&this.e2>=0&&(this.indexArray.emplaceBack(this.e1,this.e2,p),o.primitiveLength++),i?this.e2=p:this.e1=p;},Ts.prototype.updateScaledDistance=function(){this.scaledDistance=this.totalDistance>0?(this.clipStart+(this.clipEnd-this.clipStart)*this.distance/this.totalDistance)*(Cs-1):this.distance;},Ts.prototype.updateDistance=function(t,e){this.distance+=t.dist(e),this.updateScaledDistance();},zn("LineBucket",Ts,{omit:["layers","patternFeatures"]});var Es=new yi({"line-cap":new li(Bt.layout_line["line-cap"]),"line-join":new pi(Bt.layout_line["line-join"]),"line-miter-limit":new li(Bt.layout_line["line-miter-limit"]),"line-round-limit":new li(Bt.layout_line["line-round-limit"]),"line-sort-key":new pi(Bt.layout_line["line-sort-key"])}),Ms={paint:new yi({"line-opacity":new pi(Bt.paint_line["line-opacity"]),"line-color":new pi(Bt.paint_line["line-color"]),"line-translate":new li(Bt.paint_line["line-translate"]),"line-translate-anchor":new li(Bt.paint_line["line-translate-anchor"]),"line-width":new pi(Bt.paint_line["line-width"]),"line-gap-width":new pi(Bt.paint_line["line-gap-width"]),"line-offset":new pi(Bt.paint_line["line-offset"]),"line-blur":new pi(Bt.paint_line["line-blur"]),"line-dasharray":new hi(Bt.paint_line["line-dasharray"]),"line-pattern":new ci(Bt.paint_line["line-pattern"]),"line-gradient":new fi(Bt.paint_line["line-gradient"])}),layout:Es},Bs=new(function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.possiblyEvaluate=function(e,r){return r=new ti(Math.floor(r.zoom),{now:r.now,fadeDuration:r.fadeDuration,zoomHistory:r.zoomHistory,transition:r.transition}),t.prototype.possiblyEvaluate.call(this,e,r)},e.prototype.evaluate=function(e,r,n,i){return r=p({},r,{zoom:Math.floor(r.zoom)}),t.prototype.evaluate.call(this,e,r,n,i)},e}(pi))(Ms.paint.properties["line-width"].specification);Bs.useIntegerZoom=!0;var Ps=function(t){function e(e){t.call(this,e,Ms);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype._handleSpecialPaintPropertyUpdate=function(t){"line-gradient"===t&&this._updateGradient();},e.prototype._updateGradient=function(){var t=this._transitionablePaint._values["line-gradient"].value.expression;this.gradient=yo(t,"lineProgress"),this.gradientTexture=null;},e.prototype.recalculate=function(e,r){t.prototype.recalculate.call(this,e,r),this.paint._values["line-floorwidth"]=Bs.possiblyEvaluate(this._transitioningPaint._values["line-width"].value,e);},e.prototype.createBucket=function(t){return new Ts(t)},e.prototype.queryRadius=function(t){var e=t,r=Vs(Ja("line-width",this,e),Ja("line-gap-width",this,e)),n=Ja("line-offset",this,e);return r/2+Math.abs(n)+Ya(this.paint.get("line-translate"))},e.prototype.queryIntersectsFeature=function(t,e,r,n,a,o,s){var u=Ha(t,this.paint.get("line-translate"),this.paint.get("line-translate-anchor"),o.angle,s),l=s/2*Vs(this.paint.get("line-width").evaluate(e,r),this.paint.get("line-gap-width").evaluate(e,r)),p=this.paint.get("line-offset").evaluate(e,r);return p&&(n=function(t,e){for(var r=[],n=new i(0,0),a=0;a<t.length;a++){for(var o=t[a],s=[],u=0;u<o.length;u++){var l=o[u-1],p=o[u],c=o[u+1],h=0===u?n:p.sub(l)._unit()._perp(),f=u===o.length-1?n:c.sub(p)._unit()._perp(),y=h._add(f)._unit(),d=y.x*f.x+y.y*f.y;y._mult(1/d),s.push(y._mult(e)._add(p));}r.push(s);}return r}(n,p*s)),function(t,e,r){for(var n=0;n<e.length;n++){var i=e[n];if(t.length>=3)for(var a=0;a<i.length;a++)if(Za(t,i[a]))return !0;if(Ua(t,i,r))return !0}return !1}(u,n,l)},e.prototype.isTileClipped=function(){return !0},e}(di);function Vs(t,e){return e>0?e+2*t:t}var Fs=xi([{name:"a_pos_offset",components:4,type:"Int16"},{name:"a_data",components:4,type:"Uint16"},{name:"a_pixeloffset",components:4,type:"Int16"}],4),Ls=xi([{name:"a_projected_pos",components:3,type:"Float32"}],4),Ds=(xi([{name:"a_fade_opacity",components:1,type:"Uint32"}],4),xi([{name:"a_placed",components:2,type:"Uint8"},{name:"a_shift",components:2,type:"Float32"}])),Os=(xi([{type:"Int16",name:"anchorPointX"},{type:"Int16",name:"anchorPointY"},{type:"Int16",name:"x1"},{type:"Int16",name:"y1"},{type:"Int16",name:"x2"},{type:"Int16",name:"y2"},{type:"Uint32",name:"featureIndex"},{type:"Uint16",name:"sourceLayerIndex"},{type:"Uint16",name:"bucketIndex"},{type:"Int16",name:"radius"},{type:"Int16",name:"signedDistanceFromAnchor"}]),xi([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4)),Rs=xi([{name:"a_pos",components:2,type:"Int16"},{name:"a_anchor_pos",components:2,type:"Int16"},{name:"a_extrude",components:2,type:"Int16"}],4);xi([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Uint16",name:"glyphStartIndex"},{type:"Uint16",name:"numGlyphs"},{type:"Uint32",name:"vertexStartIndex"},{type:"Uint32",name:"lineStartIndex"},{type:"Uint32",name:"lineLength"},{type:"Uint16",name:"segment"},{type:"Uint16",name:"lowerSize"},{type:"Uint16",name:"upperSize"},{type:"Float32",name:"lineOffsetX"},{type:"Float32",name:"lineOffsetY"},{type:"Uint8",name:"writingMode"},{type:"Uint8",name:"placedOrientation"},{type:"Uint8",name:"hidden"},{type:"Uint32",name:"crossTileID"},{type:"Int16",name:"associatedIconIndex"}]),xi([{type:"Int16",name:"anchorX"},{type:"Int16",name:"anchorY"},{type:"Int16",name:"rightJustifiedTextSymbolIndex"},{type:"Int16",name:"centerJustifiedTextSymbolIndex"},{type:"Int16",name:"leftJustifiedTextSymbolIndex"},{type:"Int16",name:"verticalPlacedTextSymbolIndex"},{type:"Int16",name:"placedIconSymbolIndex"},{type:"Int16",name:"verticalPlacedIconSymbolIndex"},{type:"Uint16",name:"key"},{type:"Uint16",name:"textBoxStartIndex"},{type:"Uint16",name:"textBoxEndIndex"},{type:"Uint16",name:"verticalTextBoxStartIndex"},{type:"Uint16",name:"verticalTextBoxEndIndex"},{type:"Uint16",name:"iconBoxStartIndex"},{type:"Uint16",name:"iconBoxEndIndex"},{type:"Uint16",name:"verticalIconBoxStartIndex"},{type:"Uint16",name:"verticalIconBoxEndIndex"},{type:"Uint16",name:"featureIndex"},{type:"Uint16",name:"numHorizontalGlyphVertices"},{type:"Uint16",name:"numVerticalGlyphVertices"},{type:"Uint16",name:"numIconVertices"},{type:"Uint16",name:"numVerticalIconVertices"},{type:"Uint32",name:"crossTileID"},{type:"Float32",name:"textBoxScale"},{type:"Float32",components:2,name:"textOffset"}]),xi([{type:"Float32",name:"offsetX"}]),xi([{type:"Int16",name:"x"},{type:"Int16",name:"y"},{type:"Int16",name:"tileUnitDistanceFromAnchor"}]);function Us(t,e,r){return t.sections.forEach((function(t){t.text=function(t,e,r){var n=e.layout.get("text-transform").evaluate(r,{});return "uppercase"===n?t=t.toLocaleUpperCase():"lowercase"===n&&(t=t.toLocaleLowerCase()),Qn.applyArabicShaping&&(t=Qn.applyArabicShaping(t)),t}(t.text,e,r);})),t}var js={"!":"︕","#":"＃",$:"＄","%":"％","&":"＆","(":"︵",")":"︶","*":"＊","+":"＋",",":"︐","-":"︲",".":"・","/":"／",":":"︓",";":"︔","<":"︿","=":"＝",">":"﹀","?":"︖","@":"＠","[":"﹇","\\":"＼","]":"﹈","^":"＾",_:"︳","`":"｀","{":"︷","|":"―","}":"︸","~":"～","¢":"￠","£":"￡","¥":"￥","¦":"￤","¬":"￢","¯":"￣","–":"︲","—":"︱","‘":"﹃","’":"﹄","“":"﹁","”":"﹂","…":"︙","‧":"・","₩":"￦","、":"︑","。":"︒","〈":"︿","〉":"﹀","《":"︽","》":"︾","「":"﹁","」":"﹂","『":"﹃","』":"﹄","【":"︻","】":"︼","〔":"︹","〕":"︺","〖":"︗","〗":"︘","！":"︕","（":"︵","）":"︶","，":"︐","－":"︲","．":"・","：":"︓","；":"︔","＜":"︿","＞":"﹀","？":"︖","［":"﹇","］":"﹈","＿":"︳","｛":"︷","｜":"―","｝":"︸","｟":"︵","｠":"︶","｡":"︒","｢":"﹁","｣":"﹂"};var qs=24,Ns=function(t,e,r,n,i){var a,o,s=8*i-n-1,u=(1<<s)-1,l=u>>1,p=-7,c=r?i-1:0,h=r?-1:1,f=t[e+c];for(c+=h,a=f&(1<<-p)-1,f>>=-p,p+=s;p>0;a=256*a+t[e+c],c+=h,p-=8);for(o=a&(1<<-p)-1,a>>=-p,p+=n;p>0;o=256*o+t[e+c],c+=h,p-=8);if(0===a)a=1-l;else{if(a===u)return o?NaN:1/0*(f?-1:1);o+=Math.pow(2,n),a-=l;}return (f?-1:1)*o*Math.pow(2,a-n)},Ks=function(t,e,r,n,i,a){var o,s,u,l=8*a-i-1,p=(1<<l)-1,c=p>>1,h=23===i?Math.pow(2,-24)-Math.pow(2,-77):0,f=n?0:a-1,y=n?1:-1,d=e<0||0===e&&1/e<0?1:0;for(e=Math.abs(e),isNaN(e)||e===1/0?(s=isNaN(e)?1:0,o=p):(o=Math.floor(Math.log(e)/Math.LN2),e*(u=Math.pow(2,-o))<1&&(o--,u*=2),(e+=o+c>=1?h/u:h*Math.pow(2,1-c))*u>=2&&(o++,u/=2),o+c>=p?(s=0,o=p):o+c>=1?(s=(e*u-1)*Math.pow(2,i),o+=c):(s=e*Math.pow(2,c-1)*Math.pow(2,i),o=0));i>=8;t[r+f]=255&s,f+=y,s/=256,i-=8);for(o=o<<i|s,l+=i;l>0;t[r+f]=255&o,f+=y,o/=256,l-=8);t[r+f-y]|=128*d;},Xs=Zs;function Zs(t){this.buf=ArrayBuffer.isView&&ArrayBuffer.isView(t)?t:new Uint8Array(t||0),this.pos=0,this.type=0,this.length=this.buf.length;}Zs.Varint=0,Zs.Fixed64=1,Zs.Bytes=2,Zs.Fixed32=5;var Gs="undefined"==typeof TextDecoder?null:new TextDecoder("utf8");function Js(t){return t.type===Zs.Bytes?t.readVarint()+t.pos:t.pos+1}function Ys(t,e,r){return r?4294967296*e+(t>>>0):4294967296*(e>>>0)+(t>>>0)}function Hs(t,e,r){var n=e<=16383?1:e<=2097151?2:e<=268435455?3:Math.floor(Math.log(e)/(7*Math.LN2));r.realloc(n);for(var i=r.pos-1;i>=t;i--)r.buf[i+n]=r.buf[i];}function $s(t,e){for(var r=0;r<t.length;r++)e.writeVarint(t[r]);}function Ws(t,e){for(var r=0;r<t.length;r++)e.writeSVarint(t[r]);}function Qs(t,e){for(var r=0;r<t.length;r++)e.writeFloat(t[r]);}function tu(t,e){for(var r=0;r<t.length;r++)e.writeDouble(t[r]);}function eu(t,e){for(var r=0;r<t.length;r++)e.writeBoolean(t[r]);}function ru(t,e){for(var r=0;r<t.length;r++)e.writeFixed32(t[r]);}function nu(t,e){for(var r=0;r<t.length;r++)e.writeSFixed32(t[r]);}function iu(t,e){for(var r=0;r<t.length;r++)e.writeFixed64(t[r]);}function au(t,e){for(var r=0;r<t.length;r++)e.writeSFixed64(t[r]);}function ou(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+16777216*t[e+3]}function su(t,e,r){t[r]=e,t[r+1]=e>>>8,t[r+2]=e>>>16,t[r+3]=e>>>24;}function uu(t,e){return (t[e]|t[e+1]<<8|t[e+2]<<16)+(t[e+3]<<24)}Zs.prototype={destroy:function(){this.buf=null;},readFields:function(t,e,r){for(r=r||this.length;this.pos<r;){var n=this.readVarint(),i=n>>3,a=this.pos;this.type=7&n,t(i,e,this),this.pos===a&&this.skip(n);}return e},readMessage:function(t,e){return this.readFields(t,e,this.readVarint()+this.pos)},readFixed32:function(){var t=ou(this.buf,this.pos);return this.pos+=4,t},readSFixed32:function(){var t=uu(this.buf,this.pos);return this.pos+=4,t},readFixed64:function(){var t=ou(this.buf,this.pos)+4294967296*ou(this.buf,this.pos+4);return this.pos+=8,t},readSFixed64:function(){var t=ou(this.buf,this.pos)+4294967296*uu(this.buf,this.pos+4);return this.pos+=8,t},readFloat:function(){var t=Ns(this.buf,this.pos,!0,23,4);return this.pos+=4,t},readDouble:function(){var t=Ns(this.buf,this.pos,!0,52,8);return this.pos+=8,t},readVarint:function(t){var e,r,n=this.buf;return e=127&(r=n[this.pos++]),r<128?e:(e|=(127&(r=n[this.pos++]))<<7,r<128?e:(e|=(127&(r=n[this.pos++]))<<14,r<128?e:(e|=(127&(r=n[this.pos++]))<<21,r<128?e:function(t,e,r){var n,i,a=r.buf;if(i=a[r.pos++],n=(112&i)>>4,i<128)return Ys(t,n,e);if(i=a[r.pos++],n|=(127&i)<<3,i<128)return Ys(t,n,e);if(i=a[r.pos++],n|=(127&i)<<10,i<128)return Ys(t,n,e);if(i=a[r.pos++],n|=(127&i)<<17,i<128)return Ys(t,n,e);if(i=a[r.pos++],n|=(127&i)<<24,i<128)return Ys(t,n,e);if(i=a[r.pos++],n|=(1&i)<<31,i<128)return Ys(t,n,e);throw new Error("Expected varint not more than 10 bytes")}(e|=(15&(r=n[this.pos]))<<28,t,this))))},readVarint64:function(){return this.readVarint(!0)},readSVarint:function(){var t=this.readVarint();return t%2==1?(t+1)/-2:t/2},readBoolean:function(){return Boolean(this.readVarint())},readString:function(){var t=this.readVarint()+this.pos,e=this.pos;return this.pos=t,t-e>=12&&Gs?function(t,e,r){return Gs.decode(t.subarray(e,r))}(this.buf,e,t):function(t,e,r){var n="",i=e;for(;i<r;){var a,o,s,u=t[i],l=null,p=u>239?4:u>223?3:u>191?2:1;if(i+p>r)break;1===p?u<128&&(l=u):2===p?128==(192&(a=t[i+1]))&&(l=(31&u)<<6|63&a)<=127&&(l=null):3===p?(a=t[i+1],o=t[i+2],128==(192&a)&&128==(192&o)&&((l=(15&u)<<12|(63&a)<<6|63&o)<=2047||l>=55296&&l<=57343)&&(l=null)):4===p&&(a=t[i+1],o=t[i+2],s=t[i+3],128==(192&a)&&128==(192&o)&&128==(192&s)&&((l=(15&u)<<18|(63&a)<<12|(63&o)<<6|63&s)<=65535||l>=1114112)&&(l=null)),null===l?(l=65533,p=1):l>65535&&(l-=65536,n+=String.fromCharCode(l>>>10&1023|55296),l=56320|1023&l),n+=String.fromCharCode(l),i+=p;}return n}(this.buf,e,t)},readBytes:function(){var t=this.readVarint()+this.pos,e=this.buf.subarray(this.pos,t);return this.pos=t,e},readPackedVarint:function(t,e){if(this.type!==Zs.Bytes)return t.push(this.readVarint(e));var r=Js(this);for(t=t||[];this.pos<r;)t.push(this.readVarint(e));return t},readPackedSVarint:function(t){if(this.type!==Zs.Bytes)return t.push(this.readSVarint());var e=Js(this);for(t=t||[];this.pos<e;)t.push(this.readSVarint());return t},readPackedBoolean:function(t){if(this.type!==Zs.Bytes)return t.push(this.readBoolean());var e=Js(this);for(t=t||[];this.pos<e;)t.push(this.readBoolean());return t},readPackedFloat:function(t){if(this.type!==Zs.Bytes)return t.push(this.readFloat());var e=Js(this);for(t=t||[];this.pos<e;)t.push(this.readFloat());return t},readPackedDouble:function(t){if(this.type!==Zs.Bytes)return t.push(this.readDouble());var e=Js(this);for(t=t||[];this.pos<e;)t.push(this.readDouble());return t},readPackedFixed32:function(t){if(this.type!==Zs.Bytes)return t.push(this.readFixed32());var e=Js(this);for(t=t||[];this.pos<e;)t.push(this.readFixed32());return t},readPackedSFixed32:function(t){if(this.type!==Zs.Bytes)return t.push(this.readSFixed32());var e=Js(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed32());return t},readPackedFixed64:function(t){if(this.type!==Zs.Bytes)return t.push(this.readFixed64());var e=Js(this);for(t=t||[];this.pos<e;)t.push(this.readFixed64());return t},readPackedSFixed64:function(t){if(this.type!==Zs.Bytes)return t.push(this.readSFixed64());var e=Js(this);for(t=t||[];this.pos<e;)t.push(this.readSFixed64());return t},skip:function(t){var e=7&t;if(e===Zs.Varint)for(;this.buf[this.pos++]>127;);else if(e===Zs.Bytes)this.pos=this.readVarint()+this.pos;else if(e===Zs.Fixed32)this.pos+=4;else{if(e!==Zs.Fixed64)throw new Error("Unimplemented type: "+e);this.pos+=8;}},writeTag:function(t,e){this.writeVarint(t<<3|e);},realloc:function(t){for(var e=this.length||16;e<this.pos+t;)e*=2;if(e!==this.length){var r=new Uint8Array(e);r.set(this.buf),this.buf=r,this.length=e;}},finish:function(){return this.length=this.pos,this.pos=0,this.buf.subarray(0,this.length)},writeFixed32:function(t){this.realloc(4),su(this.buf,t,this.pos),this.pos+=4;},writeSFixed32:function(t){this.realloc(4),su(this.buf,t,this.pos),this.pos+=4;},writeFixed64:function(t){this.realloc(8),su(this.buf,-1&t,this.pos),su(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8;},writeSFixed64:function(t){this.realloc(8),su(this.buf,-1&t,this.pos),su(this.buf,Math.floor(t*(1/4294967296)),this.pos+4),this.pos+=8;},writeVarint:function(t){(t=+t||0)>268435455||t<0?function(t,e){var r,n;t>=0?(r=t%4294967296|0,n=t/4294967296|0):(n=~(-t/4294967296),4294967295^(r=~(-t%4294967296))?r=r+1|0:(r=0,n=n+1|0));if(t>=0x10000000000000000||t<-0x10000000000000000)throw new Error("Given varint doesn't fit into 10 bytes");e.realloc(10),function(t,e,r){r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos++]=127&t|128,t>>>=7,r.buf[r.pos]=127&t;}(r,0,e),function(t,e){var r=(7&t)<<4;if(e.buf[e.pos++]|=r|((t>>>=3)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;if(e.buf[e.pos++]=127&t|((t>>>=7)?128:0),!t)return;e.buf[e.pos++]=127&t;}(n,e);}(t,this):(this.realloc(4),this.buf[this.pos++]=127&t|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=127&(t>>>=7)|(t>127?128:0),t<=127||(this.buf[this.pos++]=t>>>7&127))));},writeSVarint:function(t){this.writeVarint(t<0?2*-t-1:2*t);},writeBoolean:function(t){this.writeVarint(Boolean(t));},writeString:function(t){t=String(t),this.realloc(4*t.length),this.pos++;var e=this.pos;this.pos=function(t,e,r){for(var n,i,a=0;a<e.length;a++){if((n=e.charCodeAt(a))>55295&&n<57344){if(!i){n>56319||a+1===e.length?(t[r++]=239,t[r++]=191,t[r++]=189):i=n;continue}if(n<56320){t[r++]=239,t[r++]=191,t[r++]=189,i=n;continue}n=i-55296<<10|n-56320|65536,i=null;}else i&&(t[r++]=239,t[r++]=191,t[r++]=189,i=null);n<128?t[r++]=n:(n<2048?t[r++]=n>>6|192:(n<65536?t[r++]=n>>12|224:(t[r++]=n>>18|240,t[r++]=n>>12&63|128),t[r++]=n>>6&63|128),t[r++]=63&n|128);}return r}(this.buf,t,this.pos);var r=this.pos-e;r>=128&&Hs(e,r,this),this.pos=e-1,this.writeVarint(r),this.pos+=r;},writeFloat:function(t){this.realloc(4),Ks(this.buf,t,this.pos,!0,23,4),this.pos+=4;},writeDouble:function(t){this.realloc(8),Ks(this.buf,t,this.pos,!0,52,8),this.pos+=8;},writeBytes:function(t){var e=t.length;this.writeVarint(e),this.realloc(e);for(var r=0;r<e;r++)this.buf[this.pos++]=t[r];},writeRawMessage:function(t,e){this.pos++;var r=this.pos;t(e,this);var n=this.pos-r;n>=128&&Hs(r,n,this),this.pos=r-1,this.writeVarint(n),this.pos+=n;},writeMessage:function(t,e,r){this.writeTag(t,Zs.Bytes),this.writeRawMessage(e,r);},writePackedVarint:function(t,e){e.length&&this.writeMessage(t,$s,e);},writePackedSVarint:function(t,e){e.length&&this.writeMessage(t,Ws,e);},writePackedBoolean:function(t,e){e.length&&this.writeMessage(t,eu,e);},writePackedFloat:function(t,e){e.length&&this.writeMessage(t,Qs,e);},writePackedDouble:function(t,e){e.length&&this.writeMessage(t,tu,e);},writePackedFixed32:function(t,e){e.length&&this.writeMessage(t,ru,e);},writePackedSFixed32:function(t,e){e.length&&this.writeMessage(t,nu,e);},writePackedFixed64:function(t,e){e.length&&this.writeMessage(t,iu,e);},writePackedSFixed64:function(t,e){e.length&&this.writeMessage(t,au,e);},writeBytesField:function(t,e){this.writeTag(t,Zs.Bytes),this.writeBytes(e);},writeFixed32Field:function(t,e){this.writeTag(t,Zs.Fixed32),this.writeFixed32(e);},writeSFixed32Field:function(t,e){this.writeTag(t,Zs.Fixed32),this.writeSFixed32(e);},writeFixed64Field:function(t,e){this.writeTag(t,Zs.Fixed64),this.writeFixed64(e);},writeSFixed64Field:function(t,e){this.writeTag(t,Zs.Fixed64),this.writeSFixed64(e);},writeVarintField:function(t,e){this.writeTag(t,Zs.Varint),this.writeVarint(e);},writeSVarintField:function(t,e){this.writeTag(t,Zs.Varint),this.writeSVarint(e);},writeStringField:function(t,e){this.writeTag(t,Zs.Bytes),this.writeString(e);},writeFloatField:function(t,e){this.writeTag(t,Zs.Fixed32),this.writeFloat(e);},writeDoubleField:function(t,e){this.writeTag(t,Zs.Fixed64),this.writeDouble(e);},writeBooleanField:function(t,e){this.writeVarintField(t,Boolean(e));}};var lu=3;function pu(t,e,r){1===t&&r.readMessage(cu,e);}function cu(t,e,r){if(3===t){var n=r.readMessage(hu,{}),i=n.id,a=n.bitmap,o=n.width,s=n.height,u=n.left,l=n.top,p=n.advance;e.push({id:i,bitmap:new co({width:o+2*lu,height:s+2*lu},a),metrics:{width:o,height:s,left:u,top:l,advance:p}});}}function hu(t,e,r){1===t?e.id=r.readVarint():2===t?e.bitmap=r.readBytes():3===t?e.width=r.readVarint():4===t?e.height=r.readVarint():5===t?e.left=r.readSVarint():6===t?e.top=r.readSVarint():7===t&&(e.advance=r.readVarint());}var fu=lu;function yu(t){for(var e=0,r=0,n=0,i=t;n<i.length;n+=1){var a=i[n];e+=a.w*a.h,r=Math.max(r,a.w);}t.sort((function(t,e){return e.h-t.h}));for(var o=[{x:0,y:0,w:Math.max(Math.ceil(Math.sqrt(e/.95)),r),h:1/0}],s=0,u=0,l=0,p=t;l<p.length;l+=1)for(var c=p[l],h=o.length-1;h>=0;h--){var f=o[h];if(!(c.w>f.w||c.h>f.h)){if(c.x=f.x,c.y=f.y,u=Math.max(u,c.y+c.h),s=Math.max(s,c.x+c.w),c.w===f.w&&c.h===f.h){var y=o.pop();h<o.length&&(o[h]=y);}else c.h===f.h?(f.x+=c.w,f.w-=c.w):c.w===f.w?(f.y+=c.h,f.h-=c.h):(o.push({x:f.x+c.w,y:f.y,w:f.w-c.w,h:c.h}),f.y+=c.h,f.h-=c.h);break}}return {w:s,h:u,fill:e/(s*u)||0}}var du=1,mu=function(t,e){var r=e.pixelRatio,n=e.version,i=e.stretchX,a=e.stretchY,o=e.content;this.paddedRect=t,this.pixelRatio=r,this.stretchX=i,this.stretchY=a,this.content=o,this.version=n;},vu={tl:{configurable:!0},br:{configurable:!0},tlbr:{configurable:!0},displaySize:{configurable:!0}};vu.tl.get=function(){return [this.paddedRect.x+du,this.paddedRect.y+du]},vu.br.get=function(){return [this.paddedRect.x+this.paddedRect.w-du,this.paddedRect.y+this.paddedRect.h-du]},vu.tlbr.get=function(){return this.tl.concat(this.br)},vu.displaySize.get=function(){return [(this.paddedRect.w-2*du)/this.pixelRatio,(this.paddedRect.h-2*du)/this.pixelRatio]},Object.defineProperties(mu.prototype,vu);var gu=function(t,e){var r={},n={};this.haveRenderCallbacks=[];var i=[];this.addImages(t,r,i),this.addImages(e,n,i);var a=yu(i),o=a.w,s=a.h,u=new ho({width:o||1,height:s||1});for(var l in t){var p=t[l],c=r[l].paddedRect;ho.copy(p.data,u,{x:0,y:0},{x:c.x+du,y:c.y+du},p.data);}for(var h in e){var f=e[h],y=n[h].paddedRect,d=y.x+du,m=y.y+du,v=f.data.width,g=f.data.height;ho.copy(f.data,u,{x:0,y:0},{x:d,y:m},f.data),ho.copy(f.data,u,{x:0,y:g-1},{x:d,y:m-1},{width:v,height:1}),ho.copy(f.data,u,{x:0,y:0},{x:d,y:m+g},{width:v,height:1}),ho.copy(f.data,u,{x:v-1,y:0},{x:d-1,y:m},{width:1,height:g}),ho.copy(f.data,u,{x:0,y:0},{x:d+v,y:m},{width:1,height:g});}this.image=u,this.iconPositions=r,this.patternPositions=n;};gu.prototype.addImages=function(t,e,r){for(var n in t){var i=t[n],a={x:0,y:0,w:i.data.width+2*du,h:i.data.height+2*du};r.push(a),e[n]=new mu(a,i),i.hasRenderCallback&&this.haveRenderCallbacks.push(n);}},gu.prototype.patchUpdatedImages=function(t,e){for(var r in t.dispatchRenderCallbacks(this.haveRenderCallbacks),t.updatedImages)this.patchUpdatedImage(this.iconPositions[r],t.getImage(r),e),this.patchUpdatedImage(this.patternPositions[r],t.getImage(r),e);},gu.prototype.patchUpdatedImage=function(t,e,r){if(t&&e&&t.version!==e.version){t.version=e.version;var n=t.tl,i=n[0],a=n[1];r.update(e.data,void 0,{x:i,y:a});}},zn("ImagePosition",mu),zn("ImageAtlas",gu);var xu={horizontal:1,vertical:2,horizontalOnly:3},bu=-17;var _u=function(){this.scale=1,this.fontStack="",this.imageName=null;};_u.forText=function(t,e){var r=new _u;return r.scale=t||1,r.fontStack=e,r},_u.forImage=function(t){var e=new _u;return e.imageName=t,e};var wu=function(){this.text="",this.sectionIndex=[],this.sections=[],this.imageSectionID=null;};function Au(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d){var m,v=wu.fromFeature(t,i);c===xu.vertical&&v.verticalizePunctuation();var g=Qn.processBidirectionalText,x=Qn.processStyledBidirectionalText;if(g&&1===v.sections.length){m=[];for(var b=0,_=g(v.toString(),Eu(v,l,a,e,n,f,y));b<_.length;b+=1){var w=_[b],A=new wu;A.text=w,A.sections=v.sections;for(var S=0;S<w.length;S++)A.sectionIndex.push(0);m.push(A);}}else if(x){m=[];for(var k=0,I=x(v.text,v.sectionIndex,Eu(v,l,a,e,n,f,y));k<I.length;k+=1){var z=I[k],C=new wu;C.text=z[0],C.sectionIndex=z[1],C.sections=v.sections,m.push(C);}}else m=function(t,e){for(var r=[],n=t.text,i=0,a=0,o=e;a<o.length;a+=1){var s=o[a];r.push(t.substring(i,s)),i=s;}return i<n.length&&r.push(t.substring(i,n.length)),r}(v,Eu(v,l,a,e,n,f,y));var T=[],E={positionedLines:T,text:v.toString(),top:p[1],bottom:p[1],left:p[0],right:p[0],writingMode:c,iconsInText:!1,verticalizable:!1};return function(t,e,r,n,i,a,o,s,u,l,p,c){for(var h=0,f=bu,y=0,d=0,m="right"===s?1:"left"===s?0:.5,v=0,g=0,x=i;g<x.length;g+=1){var b=x[g];b.trim();var _=b.getMaxScale(),w=(_-1)*qs,A={positionedGlyphs:[],lineOffset:0};t.positionedLines[v]=A;var S=A.positionedGlyphs,k=0;if(b.length()){for(var I=0;I<b.length();I++){var z=b.getSection(I),C=b.getSectionIndex(I),T=b.getCharCode(I),E=0,M=null,B=null,P=null,V=qs,F=!(u===xu.horizontal||!p&&!Dn(T)||p&&(Su[T]||(Z=T,Vn.Arabic(Z)||Vn["Arabic Supplement"](Z)||Vn["Arabic Extended-A"](Z)||Vn["Arabic Presentation Forms-A"](Z)||Vn["Arabic Presentation Forms-B"](Z))));if(z.imageName){var L=n[z.imageName];if(!L)continue;P=z.imageName,t.iconsInText=t.iconsInText||!0,B=L.paddedRect;var D=L.displaySize;z.scale=z.scale*qs/c,M={width:D[0],height:D[1],left:du,top:-fu,advance:F?D[1]:D[0]};var O=qs-D[1]*z.scale;E=w+O,V=M.advance;var R=F?D[0]*z.scale-qs*_:D[1]*z.scale-qs*_;R>0&&R>k&&(k=R);}else{var U=r[z.fontStack],j=U&&U[T];if(j&&j.rect)B=j.rect,M=j.metrics;else{var q=e[z.fontStack],N=q&&q[T];if(!N)continue;M=N.metrics;}E=(_-z.scale)*qs;}F?(t.verticalizable=!0,S.push({glyph:T,imageName:P,x:h,y:f+E,vertical:F,scale:z.scale,fontStack:z.fontStack,sectionIndex:C,metrics:M,rect:B}),h+=V*z.scale+l):(S.push({glyph:T,imageName:P,x:h,y:f+E,vertical:F,scale:z.scale,fontStack:z.fontStack,sectionIndex:C,metrics:M,rect:B}),h+=M.advance*z.scale+l);}if(0!==S.length){var K=h-l;y=Math.max(K,y),Bu(S,0,S.length-1,m,k);}h=0;var X=a*_+k;A.lineOffset=Math.max(k,w),f+=X,d=Math.max(X,d),++v;}else f+=a,++v;}var Z;var G=f-bu,J=Mu(o),Y=J.horizontalAlign,H=J.verticalAlign;(function(t,e,r,n,i,a,o,s,u){var l=(e-r)*i,p=0;p=a!==o?-s*n-bu:(-n*u+.5)*o;for(var c=0,h=t;c<h.length;c+=1)for(var f=h[c],y=0,d=f.positionedGlyphs;y<d.length;y+=1){var m=d[y];m.x+=l,m.y+=p;}})(t.positionedLines,m,Y,H,y,d,a,G,i.length),t.top+=-H*G,t.bottom=t.top+G,t.left+=-Y*y,t.right=t.left+y;}(E,e,r,n,m,o,s,u,c,l,h,d),!function(t){for(var e=0,r=t;e<r.length;e+=1){if(0!==r[e].positionedGlyphs.length)return !1}return !0}(T)&&E}wu.fromFeature=function(t,e){for(var r=new wu,n=0;n<t.sections.length;n++){var i=t.sections[n];i.image?r.addImageSection(i):r.addTextSection(i,e);}return r},wu.prototype.length=function(){return this.text.length},wu.prototype.getSection=function(t){return this.sections[this.sectionIndex[t]]},wu.prototype.getSectionIndex=function(t){return this.sectionIndex[t]},wu.prototype.getCharCode=function(t){return this.text.charCodeAt(t)},wu.prototype.verticalizePunctuation=function(){this.text=function(t){for(var e="",r=0;r<t.length;r++){var n=t.charCodeAt(r+1)||null,i=t.charCodeAt(r-1)||null;(!n||!On(n)||js[t[r+1]])&&(!i||!On(i)||js[t[r-1]])&&js[t[r]]?e+=js[t[r]]:e+=t[r];}return e}(this.text);},wu.prototype.trim=function(){for(var t=0,e=0;e<this.text.length&&Su[this.text.charCodeAt(e)];e++)t++;for(var r=this.text.length,n=this.text.length-1;n>=0&&n>=t&&Su[this.text.charCodeAt(n)];n--)r--;this.text=this.text.substring(t,r),this.sectionIndex=this.sectionIndex.slice(t,r);},wu.prototype.substring=function(t,e){var r=new wu;return r.text=this.text.substring(t,e),r.sectionIndex=this.sectionIndex.slice(t,e),r.sections=this.sections,r},wu.prototype.toString=function(){return this.text},wu.prototype.getMaxScale=function(){var t=this;return this.sectionIndex.reduce((function(e,r){return Math.max(e,t.sections[r].scale)}),0)},wu.prototype.addTextSection=function(t,e){this.text+=t.text,this.sections.push(_u.forText(t.scale,t.fontStack||e));for(var r=this.sections.length-1,n=0;n<t.text.length;++n)this.sectionIndex.push(r);},wu.prototype.addImageSection=function(t){var e=t.image?t.image.name:"";if(0!==e.length){var r=this.getNextImageSectionCharCode();r?(this.text+=String.fromCharCode(r),this.sections.push(_u.forImage(e)),this.sectionIndex.push(this.sections.length-1)):_("Reached maximum number of images 6401");}else _("Can't add FormattedSection with an empty image.");},wu.prototype.getNextImageSectionCharCode=function(){return this.imageSectionID?this.imageSectionID>=63743?null:++this.imageSectionID:(this.imageSectionID=57344,this.imageSectionID)};var Su={9:!0,10:!0,11:!0,12:!0,13:!0,32:!0},ku={};function Iu(t,e,r,n,i,a){if(e.imageName){var o=n[e.imageName];return o?o.displaySize[0]*e.scale*qs/a+i:0}var s=r[e.fontStack],u=s&&s[t];return u?u.metrics.advance*e.scale+i:0}function zu(t,e,r,n){var i=Math.pow(t-e,2);return n?t<e?i/2:2*i:i+Math.abs(r)*r}function Cu(t,e,r){var n=0;return 10===t&&(n-=1e4),r&&(n+=150),40!==t&&65288!==t||(n+=50),41!==e&&65289!==e||(n+=50),n}function Tu(t,e,r,n,i,a){for(var o=null,s=zu(e,r,i,a),u=0,l=n;u<l.length;u+=1){var p=l[u],c=zu(e-p.x,r,i,a)+p.badness;c<=s&&(o=p,s=c);}return {index:t,x:e,priorBreak:o,badness:s}}function Eu(t,e,r,n,i,a,o){if("point"!==a)return [];if(!t)return [];for(var s,u=[],l=function(t,e,r,n,i,a){for(var o=0,s=0;s<t.length();s++){var u=t.getSection(s);o+=Iu(t.getCharCode(s),u,n,i,e,a);}return o/Math.max(1,Math.ceil(o/r))}(t,e,r,n,i,o),p=t.text.indexOf("​")>=0,c=0,h=0;h<t.length();h++){var f=t.getSection(h),y=t.getCharCode(h);if(Su[y]||(c+=Iu(y,f,n,i,e,o)),h<t.length()-1){var d=!!(!((s=y)<11904)&&(Vn["Bopomofo Extended"](s)||Vn.Bopomofo(s)||Vn["CJK Compatibility Forms"](s)||Vn["CJK Compatibility Ideographs"](s)||Vn["CJK Compatibility"](s)||Vn["CJK Radicals Supplement"](s)||Vn["CJK Strokes"](s)||Vn["CJK Symbols and Punctuation"](s)||Vn["CJK Unified Ideographs Extension A"](s)||Vn["CJK Unified Ideographs"](s)||Vn["Enclosed CJK Letters and Months"](s)||Vn["Halfwidth and Fullwidth Forms"](s)||Vn.Hiragana(s)||Vn["Ideographic Description Characters"](s)||Vn["Kangxi Radicals"](s)||Vn["Katakana Phonetic Extensions"](s)||Vn.Katakana(s)||Vn["Vertical Forms"](s)||Vn["Yi Radicals"](s)||Vn["Yi Syllables"](s)));(ku[y]||d||f.imageName)&&u.push(Tu(h+1,c,l,u,Cu(y,t.getCharCode(h+1),d&&p),!1));}}return function t(e){return e?t(e.priorBreak).concat(e.index):[]}(Tu(t.length(),c,l,u,0,!0))}function Mu(t){var e=.5,r=.5;switch(t){case"right":case"top-right":case"bottom-right":e=1;break;case"left":case"top-left":case"bottom-left":e=0;}switch(t){case"bottom":case"bottom-right":case"bottom-left":r=1;break;case"top":case"top-right":case"top-left":r=0;}return {horizontalAlign:e,verticalAlign:r}}function Bu(t,e,r,n,i){if(n||i)for(var a=t[r],o=a.metrics.advance*a.scale,s=(t[r].x+o)*n,u=e;u<=r;u++)t[u].x-=s,t[u].y+=i;}function Pu(t,e,r,n,i,a){var o,s=t.image;if(s.content){var u=s.content,l=s.pixelRatio||1;o=[u[0]/l,u[1]/l,s.displaySize[0]-u[2]/l,s.displaySize[1]-u[3]/l];}var p,c,h,f,y=e.left*a,d=e.right*a;"width"===r||"both"===r?(f=i[0]+y-n[3],c=i[0]+d+n[1]):c=(f=i[0]+(y+d-s.displaySize[0])/2)+s.displaySize[0];var m=e.top*a,v=e.bottom*a;return "height"===r||"both"===r?(p=i[1]+m-n[0],h=i[1]+v+n[2]):h=(p=i[1]+(m+v-s.displaySize[1])/2)+s.displaySize[1],{image:s,top:p,right:c,bottom:h,left:f,collisionPadding:o}}ku[10]=!0,ku[32]=!0,ku[38]=!0,ku[40]=!0,ku[41]=!0,ku[43]=!0,ku[45]=!0,ku[47]=!0,ku[173]=!0,ku[183]=!0,ku[8203]=!0,ku[8208]=!0,ku[8211]=!0,ku[8231]=!0;var Vu=function(t){function e(e,r,n,i){t.call(this,e,r),this.angle=n,void 0!==i&&(this.segment=i);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.clone=function(){return new e(this.x,this.y,this.angle,this.segment)},e}(i);zn("Anchor",Vu);var Fu=128;function Lu(t,e){var r=e.expression;if("constant"===r.kind)return {kind:"constant",layoutSize:r.evaluate(new ti(t+1))};if("source"===r.kind)return {kind:"source"};for(var n=r.zoomStops,i=r.interpolationType,a=0;a<n.length&&n[a]<=t;)a++;for(var o=a=Math.max(0,a-1);o<n.length&&n[o]<t+1;)o++;o=Math.min(n.length-1,o);var s=n[a],u=n[o];return "composite"===r.kind?{kind:"composite",minZoom:s,maxZoom:u,interpolationType:i}:{kind:"camera",minZoom:s,maxZoom:u,minSize:r.evaluate(new ti(s)),maxSize:r.evaluate(new ti(u)),interpolationType:i}}function Du(t,e,r){var n=e.uSize,i=e.uSizeT,a=r.lowerSize,o=r.upperSize;return "source"===t.kind?a/Fu:"composite"===t.kind?Ce(a/Fu,o/Fu,i):n}function Ou(t,e){var r=0,n=0;if("constant"===t.kind)n=t.layoutSize;else if("source"!==t.kind){var i=t.interpolationType,a=t.minZoom,o=t.maxZoom,s=i?u(Ye.interpolationFactor(i,e,a,o),0,1):0;"camera"===t.kind?n=Ce(t.minSize,t.maxSize,s):r=s;}return {uSizeT:r,uSize:n}}var Ru=Object.freeze({__proto__:null,getSizeData:Lu,evaluateSizeForFeature:Du,evaluateSizeForZoom:Ou,SIZE_PACK_FACTOR:Fu});function Uu(t,e,r,n,i){if(void 0===e.segment)return !0;for(var a=e,o=e.segment+1,s=0;s>-r/2;){if(--o<0)return !1;s-=t[o].dist(a),a=t[o];}s+=t[o].dist(t[o+1]),o++;for(var u=[],l=0;s<r/2;){var p=t[o-1],c=t[o],h=t[o+1];if(!h)return !1;var f=p.angleTo(c)-c.angleTo(h);for(f=Math.abs((f+3*Math.PI)%(2*Math.PI)-Math.PI),u.push({distance:s,angleDelta:f}),l+=f;s-u[0].distance>n;)l-=u.shift().angleDelta;if(l>i)return !1;o++,s+=c.dist(h);}return !0}function ju(t){for(var e=0,r=0;r<t.length-1;r++)e+=t[r].dist(t[r+1]);return e}function qu(t,e,r){return t?.6*e*r:0}function Nu(t,e){return Math.max(t?t.right-t.left:0,e?e.right-e.left:0)}function Ku(t,e,r,n,i,a){for(var o=qu(r,i,a),s=Nu(r,n)*a,u=0,l=ju(t)/2,p=0;p<t.length-1;p++){var c=t[p],h=t[p+1],f=c.dist(h);if(u+f>l){var y=(l-u)/f,d=Ce(c.x,h.x,y),m=Ce(c.y,h.y,y),v=new Vu(d,m,h.angleTo(c),p);return v._round(),!o||Uu(t,v,s,o,e)?v:void 0}u+=f;}}function Xu(t,e,r,n,i,a,o,s,u){var l=qu(n,a,o),p=Nu(n,i),c=p*o,h=0===t[0].x||t[0].x===u||0===t[0].y||t[0].y===u;return e-c<e/4&&(e=c+e/4),function t(e,r,n,i,a,o,s,u,l){var p=o/2;var c=ju(e);var h=0,f=r-n;var y=[];for(var d=0;d<e.length-1;d++){for(var m=e[d],v=e[d+1],g=m.dist(v),x=v.angleTo(m);f+n<h+g;){var b=((f+=n)-h)/g,_=Ce(m.x,v.x,b),w=Ce(m.y,v.y,b);if(_>=0&&_<l&&w>=0&&w<l&&f-p>=0&&f+p<=c){var A=new Vu(_,w,x,d);A._round(),i&&!Uu(e,A,o,i,a)||y.push(A);}}h+=g;}u||y.length||s||(y=t(e,h/2,n,i,a,o,s,!0,l));return y}(t,h?e/2*s%e:(p/2+2*a)*o*s%e,e,l,r,c,h,!1,u)}var Zu=du;function Gu(t,e,r,n){var a=[],o=t.image,s=o.pixelRatio,u=o.paddedRect.w-2*Zu,l=o.paddedRect.h-2*Zu,p=t.right-t.left,c=t.bottom-t.top,h=o.stretchX||[[0,u]],f=o.stretchY||[[0,l]],y=function(t,e){return t+e[1]-e[0]},d=h.reduce(y,0),m=f.reduce(y,0),v=u-d,g=l-m,x=0,b=d,_=0,w=m,A=0,S=v,k=0,I=g;if(o.content&&n){var z=o.content;x=Ju(h,0,z[0]),_=Ju(f,0,z[1]),b=Ju(h,z[0],z[2]),w=Ju(f,z[1],z[3]),A=z[0]-x,k=z[1]-_,S=z[2]-z[0]-b,I=z[3]-z[1]-w;}var C=function(n,a,u,l){var h=Hu(n.stretch-x,b,p,t.left),f=$u(n.fixed-A,S,n.stretch,d),y=Hu(a.stretch-_,w,c,t.top),v=$u(a.fixed-k,I,a.stretch,m),g=Hu(u.stretch-x,b,p,t.left),z=$u(u.fixed-A,S,u.stretch,d),C=Hu(l.stretch-_,w,c,t.top),T=$u(l.fixed-k,I,l.stretch,m),E=new i(h,y),M=new i(g,y),B=new i(g,C),P=new i(h,C),V=new i(f/s,v/s),F=new i(z/s,T/s),L=e*Math.PI/180;if(L){var D=Math.sin(L),O=Math.cos(L),R=[O,-D,D,O];E._matMult(R),M._matMult(R),P._matMult(R),B._matMult(R);}var U=n.stretch+n.fixed,j=u.stretch+u.fixed,q=a.stretch+a.fixed,N=l.stretch+l.fixed;return {tl:E,tr:M,bl:P,br:B,tex:{x:o.paddedRect.x+Zu+U,y:o.paddedRect.y+Zu+q,w:j-U,h:N-q},writingMode:void 0,glyphOffset:[0,0],sectionIndex:0,pixelOffsetTL:V,pixelOffsetBR:F,minFontScaleX:S/s/p,minFontScaleY:I/s/c,isSDF:r}};if(n&&(o.stretchX||o.stretchY))for(var T=Yu(h,v,d),E=Yu(f,g,m),M=0;M<T.length-1;M++)for(var B=T[M],P=T[M+1],V=0;V<E.length-1;V++){var F=E[V],L=E[V+1];a.push(C(B,F,P,L));}else a.push(C({fixed:0,stretch:-1},{fixed:0,stretch:-1},{fixed:0,stretch:u+1},{fixed:0,stretch:l+1}));return a}function Ju(t,e,r){for(var n=0,i=0,a=t;i<a.length;i+=1){var o=a[i];n+=Math.max(e,Math.min(r,o[1]))-Math.max(e,Math.min(r,o[0]));}return n}function Yu(t,e,r){for(var n=[{fixed:-Zu,stretch:0}],i=0,a=t;i<a.length;i+=1){var o=a[i],s=o[0],u=o[1],l=n[n.length-1];n.push({fixed:s-l.stretch,stretch:l.stretch}),n.push({fixed:s-l.stretch,stretch:l.stretch+(u-s)});}return n.push({fixed:e+Zu,stretch:r}),n}function Hu(t,e,r,n){return t/e*r+n}function $u(t,e,r,n){return t-e*r/n}var Wu=function(t,e,r,n,a,o,s,u,l,p,c,h){var f=s.top*u-l,y=s.bottom*u+l,d=s.left*u-l,m=s.right*u+l,v=s.collisionPadding;if(v&&(d-=v[0]*u,f-=v[1]*u,m+=v[2]*u,y+=v[3]*u),this.boxStartIndex=t.length,p){var g=y-f,x=m-d;g>0&&(g=Math.max(10*u,g),this._addLineCollisionCircles(t,e,r,r.segment,x,g,n,a,o,c));}else{if(h){var b=new i(d,f),_=new i(m,f),w=new i(d,y),A=new i(m,y),S=h*Math.PI/180;b._rotate(S),_._rotate(S),w._rotate(S),A._rotate(S),d=Math.min(b.x,_.x,w.x,A.x),m=Math.max(b.x,_.x,w.x,A.x),f=Math.min(b.y,_.y,w.y,A.y),y=Math.max(b.y,_.y,w.y,A.y);}t.emplaceBack(r.x,r.y,d,f,m,y,n,a,o,0,0);}this.boxEndIndex=t.length;};Wu.prototype._addLineCollisionCircles=function(t,e,r,n,i,a,o,s,u,l){var p=a/2,c=Math.floor(i/p)||1,h=1+.4*Math.log(l)/Math.LN2,f=Math.floor(c*h/2),y=-a/2,d=r,m=n+1,v=y,g=-i/2,x=g-i/4;do{if(--m<0){if(v>g)return;m=0;break}v-=e[m].dist(d),d=e[m];}while(v>x);for(var b=e[m].dist(e[m+1]),_=-f;_<c+f;_++){var w=_*p,A=g+w;if(w<0&&(A+=w),w>i&&(A+=w-i),!(A<v)){for(;v+b<A;){if(v+=b,++m+1>=e.length)return;b=e[m].dist(e[m+1]);}var S=A-v,k=e[m],I=e[m+1].sub(k)._unit()._mult(S)._add(k)._round(),z=Math.abs(A-y)<p?0:.8*(A-y);t.emplaceBack(I.x,I.y,-a/2,-a/2,a/2,a/2,o,s,u,a/2,z);}}};var Qu=function(t,e){if(void 0===t&&(t=[]),void 0===e&&(e=tl),this.data=t,this.length=this.data.length,this.compare=e,this.length>0)for(var r=(this.length>>1)-1;r>=0;r--)this._down(r);};function tl(t,e){return t<e?-1:t>e?1:0}function el(t,e,r){void 0===e&&(e=1),void 0===r&&(r=!1);for(var n=1/0,a=1/0,o=-1/0,s=-1/0,u=t[0],l=0;l<u.length;l++){var p=u[l];(!l||p.x<n)&&(n=p.x),(!l||p.y<a)&&(a=p.y),(!l||p.x>o)&&(o=p.x),(!l||p.y>s)&&(s=p.y);}var c=o-n,h=s-a,f=Math.min(c,h),y=f/2,d=new Qu([],rl);if(0===f)return new i(n,a);for(var m=n;m<o;m+=f)for(var v=a;v<s;v+=f)d.push(new nl(m+y,v+y,y,t));for(var g=function(t){for(var e=0,r=0,n=0,i=t[0],a=0,o=i.length,s=o-1;a<o;s=a++){var u=i[a],l=i[s],p=u.x*l.y-l.x*u.y;r+=(u.x+l.x)*p,n+=(u.y+l.y)*p,e+=3*p;}return new nl(r/e,n/e,0,t)}(t),x=d.length;d.length;){var b=d.pop();(b.d>g.d||!g.d)&&(g=b,r&&console.log("found best %d after %d probes",Math.round(1e4*b.d)/1e4,x)),b.max-g.d<=e||(y=b.h/2,d.push(new nl(b.p.x-y,b.p.y-y,y,t)),d.push(new nl(b.p.x+y,b.p.y-y,y,t)),d.push(new nl(b.p.x-y,b.p.y+y,y,t)),d.push(new nl(b.p.x+y,b.p.y+y,y,t)),x+=4);}return r&&(console.log("num probes: "+x),console.log("best distance: "+g.d)),g.p}function rl(t,e){return e.max-t.max}function nl(t,e,r,n){this.p=new i(t,e),this.h=r,this.d=function(t,e){for(var r=!1,n=1/0,i=0;i<e.length;i++)for(var a=e[i],o=0,s=a.length,u=s-1;o<s;u=o++){var l=a[o],p=a[u];l.y>t.y!=p.y>t.y&&t.x<(p.x-l.x)*(t.y-l.y)/(p.y-l.y)+l.x&&(r=!r),n=Math.min(n,Ka(t,l,p));}return (r?1:-1)*Math.sqrt(n)}(this.p,n),this.max=this.d+this.h*Math.SQRT2;}Qu.prototype.push=function(t){this.data.push(t),this.length++,this._up(this.length-1);},Qu.prototype.pop=function(){if(0!==this.length){var t=this.data[0],e=this.data.pop();return this.length--,this.length>0&&(this.data[0]=e,this._down(0)),t}},Qu.prototype.peek=function(){return this.data[0]},Qu.prototype._up=function(t){for(var e=this.data,r=this.compare,n=e[t];t>0;){var i=t-1>>1,a=e[i];if(r(n,a)>=0)break;e[t]=a,t=i;}e[t]=n;},Qu.prototype._down=function(t){for(var e=this.data,r=this.compare,n=this.length>>1,i=e[t];t<n;){var a=1+(t<<1),o=e[a],s=a+1;if(s<this.length&&r(e[s],o)<0&&(a=s,o=e[s]),r(o,i)>=0)break;e[t]=o,t=a;}e[t]=i;};var il=7,al=Number.POSITIVE_INFINITY;function ol(t,e){return e[1]!==al?function(t,e,r){var n=0,i=0;switch(e=Math.abs(e),r=Math.abs(r),t){case"top-right":case"top-left":case"top":i=r-il;break;case"bottom-right":case"bottom-left":case"bottom":i=-r+il;}switch(t){case"top-right":case"bottom-right":case"right":n=-e;break;case"top-left":case"bottom-left":case"left":n=e;}return [n,i]}(t,e[0],e[1]):function(t,e){var r=0,n=0;e<0&&(e=0);var i=e/Math.sqrt(2);switch(t){case"top-right":case"top-left":n=i-il;break;case"bottom-right":case"bottom-left":n=-i+il;break;case"bottom":n=-e+il;break;case"top":n=e-il;}switch(t){case"top-right":case"bottom-right":r=-i;break;case"top-left":case"bottom-left":r=i;break;case"left":r=e;break;case"right":r=-e;}return [r,n]}(t,e[0])}function sl(t){switch(t){case"right":case"top-right":case"bottom-right":return "right";case"left":case"top-left":case"bottom-left":return "left"}return "center"}var ul=255,ll=ul*Fu;function pl(t,e,r,n,a,o,s,u,l,p,c,h,f,y){var d=function(t,e,r,n,a,o,s,u){for(var l=n.layout.get("text-rotate").evaluate(o,{})*Math.PI/180,p=[],c=0,h=e.positionedLines;c<h.length;c+=1)for(var f=h[c],y=0,d=f.positionedGlyphs;y<d.length;y+=1){var m=d[y];if(m.rect){var v=m.rect||{},g=fu+1,x=!0,b=1,_=0,w=(a||u)&&m.vertical,A=m.metrics.advance*m.scale/2;if(u&&e.verticalizable){var S=(m.scale-1)*qs,k=(qs-m.metrics.width*m.scale)/2;_=f.lineOffset/2-(m.imageName?-k:S);}if(m.imageName){var I=s[m.imageName];x=I.sdf,b=I.pixelRatio,g=du/b;}var z=a?[m.x+A,m.y]:[0,0],C=a?[0,0]:[m.x+A+r[0],m.y+r[1]-_],T=[0,0];w&&(T=C,C=[0,0]);var E=(m.metrics.left-g)*m.scale-A+C[0],M=(-m.metrics.top-g)*m.scale+C[1],B=E+v.w*m.scale/b,P=M+v.h*m.scale/b,V=new i(E,M),F=new i(B,M),L=new i(E,P),D=new i(B,P);if(w){var O=new i(-A,A-bu),R=-Math.PI/2,U=qs/2-A,j=m.imageName?U:0,q=new i(5-bu-U,-j),N=new(Function.prototype.bind.apply(i,[null].concat(T)));V._rotateAround(R,O)._add(q)._add(N),F._rotateAround(R,O)._add(q)._add(N),L._rotateAround(R,O)._add(q)._add(N),D._rotateAround(R,O)._add(q)._add(N);}if(l){var K=Math.sin(l),X=Math.cos(l),Z=[X,-K,K,X];V._matMult(Z),F._matMult(Z),L._matMult(Z),D._matMult(Z);}var G=new i(0,0),J=new i(0,0);p.push({tl:V,tr:F,bl:L,br:D,tex:v,writingMode:e.writingMode,glyphOffset:z,sectionIndex:m.sectionIndex,isSDF:x,pixelOffsetTL:G,pixelOffsetBR:J,minFontScaleX:0,minFontScaleY:0});}}return p}(0,r,u,a,o,s,n,t.allowVerticalPlacement),m=t.textSizeData,v=null;"source"===m.kind?(v=[Fu*a.layout.get("text-size").evaluate(s,{})])[0]>ll&&_(t.layerIds[0]+': Value for "text-size" is >= '+ul+'. Reduce your "text-size".'):"composite"===m.kind&&((v=[Fu*y.compositeTextSizes[0].evaluate(s,{}),Fu*y.compositeTextSizes[1].evaluate(s,{})])[0]>ll||v[1]>ll)&&_(t.layerIds[0]+': Value for "text-size" is >= '+ul+'. Reduce your "text-size".'),t.addSymbols(t.text,d,v,u,o,s,p,e,l.lineStartIndex,l.lineLength,f);for(var g=0,x=c;g<x.length;g+=1){h[x[g]]=t.text.placedSymbolArray.length-1;}return 4*d.length}function cl(t){for(var e in t)return t[e];return null}function hl(t,e,r,n){var i=t.compareText;if(e in i){for(var a=i[e],o=a.length-1;o>=0;o--)if(n.dist(a[o])<r)return !0}else i[e]=[];return i[e].push(n),!1}var fl=ys.VectorTileFeature.types,yl=[{name:"a_fade_opacity",components:1,type:"Uint8",offset:0}];function dl(t,e,r,n,i,a,o,s,u,l,p,c,h){var f=s?Math.min(ll,Math.round(s[0])):0,y=s?Math.min(ll,Math.round(s[1])):0;t.emplaceBack(e,r,Math.round(32*n),Math.round(32*i),a,o,(f<<1)+(u?1:0),y,16*l,16*p,256*c,256*h);}function ml(t,e,r){t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r),t.emplaceBack(e.x,e.y,r);}function vl(t){for(var e=0,r=t.sections;e<r.length;e+=1){if(jn(r[e].text))return !0}return !1}var gl=function(t){this.layoutVertexArray=new Ii,this.indexArray=new Di,this.programConfigurations=t,this.segments=new ea,this.dynamicLayoutVertexArray=new zi,this.opacityVertexArray=new Ci,this.placedSymbolArray=new Xi;};gl.prototype.isEmpty=function(){return 0===this.layoutVertexArray.length&&0===this.indexArray.length&&0===this.dynamicLayoutVertexArray.length&&0===this.opacityVertexArray.length},gl.prototype.upload=function(t,e,r,n){this.isEmpty()||(r&&(this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,Fs.members),this.indexBuffer=t.createIndexBuffer(this.indexArray,e),this.dynamicLayoutVertexBuffer=t.createVertexBuffer(this.dynamicLayoutVertexArray,Ls.members,!0),this.opacityVertexBuffer=t.createVertexBuffer(this.opacityVertexArray,yl,!0),this.opacityVertexBuffer.itemSize=1),(r||n)&&this.programConfigurations.upload(t));},gl.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.programConfigurations.destroy(),this.segments.destroy(),this.dynamicLayoutVertexBuffer.destroy(),this.opacityVertexBuffer.destroy());},zn("SymbolBuffers",gl);var xl=function(t,e,r){this.layoutVertexArray=new t,this.layoutAttributes=e,this.indexArray=new r,this.segments=new ea,this.collisionVertexArray=new Mi;};xl.prototype.upload=function(t){this.layoutVertexBuffer=t.createVertexBuffer(this.layoutVertexArray,this.layoutAttributes),this.indexBuffer=t.createIndexBuffer(this.indexArray),this.collisionVertexBuffer=t.createVertexBuffer(this.collisionVertexArray,Ds.members,!0);},xl.prototype.destroy=function(){this.layoutVertexBuffer&&(this.layoutVertexBuffer.destroy(),this.indexBuffer.destroy(),this.segments.destroy(),this.collisionVertexBuffer.destroy());},zn("CollisionBuffers",xl);var bl=function(t){this.collisionBoxArray=t.collisionBoxArray,this.zoom=t.zoom,this.overscaling=t.overscaling,this.layers=t.layers,this.layerIds=this.layers.map((function(t){return t.id})),this.index=t.index,this.pixelRatio=t.pixelRatio,this.sourceLayerIndex=t.sourceLayerIndex,this.hasPattern=!1,this.hasRTLText=!1,this.sortKeyRanges=[];var e=this.layers[0]._unevaluatedLayout._values;this.textSizeData=Lu(this.zoom,e["text-size"]),this.iconSizeData=Lu(this.zoom,e["icon-size"]);var r=this.layers[0].layout,n=r.get("symbol-sort-key"),i=r.get("symbol-z-order");this.sortFeaturesByKey="viewport-y"!==i&&void 0!==n.constantOr(1);var a="viewport-y"===i||"auto"===i&&!this.sortFeaturesByKey;this.sortFeaturesByY=a&&(r.get("text-allow-overlap")||r.get("icon-allow-overlap")||r.get("text-ignore-placement")||r.get("icon-ignore-placement")),"point"===r.get("symbol-placement")&&(this.writingModes=r.get("text-writing-mode").map((function(t){return xu[t]}))),this.stateDependentLayerIds=this.layers.filter((function(t){return t.isStateDependent()})).map((function(t){return t.id})),this.sourceID=t.sourceID;};bl.prototype.createArrays=function(){this.text=new gl(new Ca(Fs.members,this.layers,this.zoom,(function(t){return /^text/.test(t)}))),this.icon=new gl(new Ca(Fs.members,this.layers,this.zoom,(function(t){return /^icon/.test(t)}))),this.glyphOffsetArray=new Yi,this.lineVertexArray=new $i,this.symbolInstances=new Gi;},bl.prototype.calculateGlyphDependencies=function(t,e,r,n,i){for(var a=0;a<t.length;a++)if(e[t.charCodeAt(a)]=!0,(r||n)&&i){var o=js[t.charAt(a)];o&&(e[o.charCodeAt(0)]=!0);}},bl.prototype.populate=function(t,e){var r=this.layers[0],n=r.layout,i=n.get("text-font"),a=n.get("text-field"),o=n.get("icon-image"),s=("constant"!==a.value.kind||a.value.value instanceof ie&&!a.value.value.isEmpty()||a.value.value.toString().length>0)&&("constant"!==i.value.kind||i.value.value.length>0),u=("constant"!==o.value.kind||!!o.value.value)&&Object.keys(o.parameters).length>0,l=n.get("symbol-sort-key");if(this.features=[],s||u){for(var p=e.iconDependencies,c=e.glyphDependencies,h=e.availableImages,f=new ti(this.zoom),y=0,d=t;y<d.length;y+=1){var m=d[y],v=m.feature,g=m.id,x=m.index,b=m.sourceLayerIndex;if(r._featureFilter(f,v)){var _=void 0;if(s){var w=r.getValueAndResolveTokens("text-field",v,h),A=ie.factory(w);vl(A)&&(this.hasRTLText=!0),(!this.hasRTLText||"unavailable"===$n()||this.hasRTLText&&Qn.isParsed())&&(_=Us(A,r,v));}var S=void 0;if(u){var k=r.getValueAndResolveTokens("icon-image",v,h);S=k instanceof ae?k:ae.fromString(k);}if(_||S){var I=this.sortFeaturesByKey?l.evaluate(v,{}):void 0,z={id:g,text:_,icon:S,index:x,sourceLayerIndex:b,geometry:Va(v),properties:v.properties,type:fl[v.type],sortKey:I};if(this.features.push(z),S&&(p[S.name]=!0),_){var C=i.evaluate(v,{}).join(","),T="map"===n.get("text-rotation-alignment")&&"point"!==n.get("symbol-placement");this.allowVerticalPlacement=this.writingModes&&this.writingModes.indexOf(xu.vertical)>=0;for(var E=0,M=_.sections;E<M.length;E+=1){var B=M[E];if(B.image)p[B.image.name]=!0;else{var P=Fn(_.toString()),V=B.fontStack||C,F=c[V]=c[V]||{};this.calculateGlyphDependencies(B.text,F,T,this.allowVerticalPlacement,P);}}}}}}"line"===n.get("symbol-placement")&&(this.features=function(t){var e={},r={},n=[],i=0;function a(e){n.push(t[e]),i++;}function o(t,e,i){var a=r[t];return delete r[t],r[e]=a,n[a].geometry[0].pop(),n[a].geometry[0]=n[a].geometry[0].concat(i[0]),a}function s(t,r,i){var a=e[r];return delete e[r],e[t]=a,n[a].geometry[0].shift(),n[a].geometry[0]=i[0].concat(n[a].geometry[0]),a}function u(t,e,r){var n=r?e[0][e[0].length-1]:e[0][0];return t+":"+n.x+":"+n.y}for(var l=0;l<t.length;l++){var p=t[l],c=p.geometry,h=p.text?p.text.toString():null;if(h){var f=u(h,c),y=u(h,c,!0);if(f in r&&y in e&&r[f]!==e[y]){var d=s(f,y,c),m=o(f,y,n[d].geometry);delete e[f],delete r[y],r[u(h,n[m].geometry,!0)]=m,n[d].geometry=null;}else f in r?o(f,y,c):y in e?s(f,y,c):(a(l),e[f]=i-1,r[y]=i-1);}else a(l);}return n.filter((function(t){return t.geometry}))}(this.features)),this.sortFeaturesByKey&&this.features.sort((function(t,e){return t.sortKey-e.sortKey}));}},bl.prototype.update=function(t,e,r){this.stateDependentLayers.length&&(this.text.programConfigurations.updatePaintArrays(t,e,this.layers,r),this.icon.programConfigurations.updatePaintArrays(t,e,this.layers,r));},bl.prototype.isEmpty=function(){return 0===this.symbolInstances.length&&!this.hasRTLText},bl.prototype.uploadPending=function(){return !this.uploaded||this.text.programConfigurations.needsUpload||this.icon.programConfigurations.needsUpload},bl.prototype.upload=function(t){!this.uploaded&&this.hasDebugData()&&(this.textCollisionBox.upload(t),this.iconCollisionBox.upload(t),this.textCollisionCircle.upload(t),this.iconCollisionCircle.upload(t)),this.text.upload(t,this.sortFeaturesByY,!this.uploaded,this.text.programConfigurations.needsUpload),this.icon.upload(t,this.sortFeaturesByY,!this.uploaded,this.icon.programConfigurations.needsUpload),this.uploaded=!0;},bl.prototype.destroyDebugData=function(){this.textCollisionBox.destroy(),this.iconCollisionBox.destroy(),this.textCollisionCircle.destroy(),this.iconCollisionCircle.destroy();},bl.prototype.destroy=function(){this.text.destroy(),this.icon.destroy(),this.hasDebugData()&&this.destroyDebugData();},bl.prototype.addToLineVertexArray=function(t,e){var r=this.lineVertexArray.length;if(void 0!==t.segment){for(var n=t.dist(e[t.segment+1]),i=t.dist(e[t.segment]),a={},o=t.segment+1;o<e.length;o++)a[o]={x:e[o].x,y:e[o].y,tileUnitDistanceFromAnchor:n},o<e.length-1&&(n+=e[o+1].dist(e[o]));for(var s=t.segment||0;s>=0;s--)a[s]={x:e[s].x,y:e[s].y,tileUnitDistanceFromAnchor:i},s>0&&(i+=e[s-1].dist(e[s]));for(var u=0;u<e.length;u++){var l=a[u];this.lineVertexArray.emplaceBack(l.x,l.y,l.tileUnitDistanceFromAnchor);}}return {lineStartIndex:r,lineLength:this.lineVertexArray.length-r}},bl.prototype.addSymbols=function(t,e,r,n,i,a,o,s,u,l,p){for(var c=t.indexArray,h=t.layoutVertexArray,f=t.segments.prepareSegment(4*e.length,h,c,a.sortKey),y=this.glyphOffsetArray.length,d=f.vertexLength,m=this.allowVerticalPlacement&&o===xu.vertical?Math.PI/2:0,v=a.text&&a.text.sections,g=0;g<e.length;g++){var x=e[g],b=x.tl,_=x.tr,w=x.bl,A=x.br,S=x.tex,k=x.pixelOffsetTL,I=x.pixelOffsetBR,z=x.minFontScaleX,C=x.minFontScaleY,T=x.glyphOffset,E=x.isSDF,M=x.sectionIndex,B=f.vertexLength,P=T[1];dl(h,s.x,s.y,b.x,P+b.y,S.x,S.y,r,E,k.x,k.y,z,C),dl(h,s.x,s.y,_.x,P+_.y,S.x+S.w,S.y,r,E,I.x,k.y,z,C),dl(h,s.x,s.y,w.x,P+w.y,S.x,S.y+S.h,r,E,k.x,I.y,z,C),dl(h,s.x,s.y,A.x,P+A.y,S.x+S.w,S.y+S.h,r,E,I.x,I.y,z,C),ml(t.dynamicLayoutVertexArray,s,m),c.emplaceBack(B,B+1,B+2),c.emplaceBack(B+1,B+2,B+3),f.vertexLength+=4,f.primitiveLength+=2,this.glyphOffsetArray.emplaceBack(T[0]),g!==e.length-1&&M===e[g+1].sectionIndex||t.programConfigurations.populatePaintArrays(h.length,a,a.index,{},v&&v[M]);}t.placedSymbolArray.emplaceBack(s.x,s.y,y,this.glyphOffsetArray.length-y,d,u,l,s.segment,r?r[0]:0,r?r[1]:0,n[0],n[1],o,0,!1,0,p);},bl.prototype._addCollisionDebugVertex=function(t,e,r,n,i,a){return e.emplaceBack(0,0),t.emplaceBack(r.x,r.y,n,i,Math.round(a.x),Math.round(a.y))},bl.prototype.addCollisionDebugVertices=function(t,e,r,n,a,o,s,u){var l=a.segments.prepareSegment(4,a.layoutVertexArray,a.indexArray),p=l.vertexLength,c=a.layoutVertexArray,h=a.collisionVertexArray,f=s.anchorX,y=s.anchorY;if(this._addCollisionDebugVertex(c,h,o,f,y,new i(t,e)),this._addCollisionDebugVertex(c,h,o,f,y,new i(r,e)),this._addCollisionDebugVertex(c,h,o,f,y,new i(r,n)),this._addCollisionDebugVertex(c,h,o,f,y,new i(t,n)),l.vertexLength+=4,u){var d=a.indexArray;d.emplaceBack(p,p+1,p+2),d.emplaceBack(p,p+2,p+3),l.primitiveLength+=2;}else{var m=a.indexArray;m.emplaceBack(p,p+1),m.emplaceBack(p+1,p+2),m.emplaceBack(p+2,p+3),m.emplaceBack(p+3,p),l.primitiveLength+=4;}},bl.prototype.addDebugCollisionBoxes=function(t,e,r,n){for(var i=t;i<e;i++){var a=this.collisionBoxArray.get(i),o=a.x1,s=a.y1,u=a.x2,l=a.y2,p=a.radius>0;this.addCollisionDebugVertices(o,s,u,l,p?n?this.textCollisionCircle:this.iconCollisionCircle:n?this.textCollisionBox:this.iconCollisionBox,a.anchorPoint,r,p);}},bl.prototype.generateCollisionDebugBuffers=function(){this.hasDebugData()&&this.destroyDebugData(),this.textCollisionBox=new xl(Ei,Os.members,Oi),this.iconCollisionBox=new xl(Ei,Os.members,Oi),this.textCollisionCircle=new xl(Ei,Rs.members,Di),this.iconCollisionCircle=new xl(Ei,Rs.members,Di);for(var t=0;t<this.symbolInstances.length;t++){var e=this.symbolInstances.get(t);this.addDebugCollisionBoxes(e.textBoxStartIndex,e.textBoxEndIndex,e,!0),this.addDebugCollisionBoxes(e.verticalTextBoxStartIndex,e.verticalTextBoxEndIndex,e,!0),this.addDebugCollisionBoxes(e.iconBoxStartIndex,e.iconBoxEndIndex,e,!1),this.addDebugCollisionBoxes(e.verticalIconBoxStartIndex,e.verticalIconBoxEndIndex,e,!1);}},bl.prototype._deserializeCollisionBoxesForSymbol=function(t,e,r,n,i,a,o,s,u){for(var l={},p=e;p<r;p++){var c=t.get(p);if(0===c.radius){l.textBox={x1:c.x1,y1:c.y1,x2:c.x2,y2:c.y2,anchorPointX:c.anchorPointX,anchorPointY:c.anchorPointY},l.textFeatureIndex=c.featureIndex;break}l.textCircles||(l.textCircles=[],l.textFeatureIndex=c.featureIndex);l.textCircles.push(c.anchorPointX,c.anchorPointY,c.radius,c.signedDistanceFromAnchor,1);}for(var h=n;h<i;h++){var f=t.get(h);if(0===f.radius){l.verticalTextBox={x1:f.x1,y1:f.y1,x2:f.x2,y2:f.y2,anchorPointX:f.anchorPointX,anchorPointY:f.anchorPointY},l.verticalTextFeatureIndex=f.featureIndex;break}}for(var y=a;y<o;y++){var d=t.get(y);if(0===d.radius){l.iconBox={x1:d.x1,y1:d.y1,x2:d.x2,y2:d.y2,anchorPointX:d.anchorPointX,anchorPointY:d.anchorPointY},l.iconFeatureIndex=d.featureIndex;break}}for(var m=s;m<u;m++){var v=t.get(m);if(0===v.radius){l.verticalIconBox={x1:v.x1,y1:v.y1,x2:v.x2,y2:v.y2,anchorPointX:v.anchorPointX,anchorPointY:v.anchorPointY},l.verticalIconFeatureIndex=v.featureIndex;break}}return l},bl.prototype.deserializeCollisionBoxes=function(t){this.collisionArrays=[];for(var e=0;e<this.symbolInstances.length;e++){var r=this.symbolInstances.get(e);this.collisionArrays.push(this._deserializeCollisionBoxesForSymbol(t,r.textBoxStartIndex,r.textBoxEndIndex,r.verticalTextBoxStartIndex,r.verticalTextBoxEndIndex,r.iconBoxStartIndex,r.iconBoxEndIndex,r.verticalIconBoxStartIndex,r.verticalIconBoxEndIndex));}},bl.prototype.hasTextData=function(){return this.text.segments.get().length>0},bl.prototype.hasIconData=function(){return this.icon.segments.get().length>0},bl.prototype.hasDebugData=function(){return this.textCollisionBox&&this.iconCollisionBox&&this.textCollisionCircle&&this.iconCollisionCircle},bl.prototype.hasTextCollisionBoxData=function(){return this.hasDebugData()&&this.textCollisionBox.segments.get().length>0},bl.prototype.hasIconCollisionBoxData=function(){return this.hasDebugData()&&this.iconCollisionBox.segments.get().length>0},bl.prototype.hasTextCollisionCircleData=function(){return this.hasDebugData()&&this.textCollisionCircle.segments.get().length>0},bl.prototype.hasIconCollisionCircleData=function(){return this.hasDebugData()&&this.iconCollisionCircle.segments.get().length>0},bl.prototype.addIndicesForPlacedSymbol=function(t,e){for(var r=t.placedSymbolArray.get(e),n=r.vertexStartIndex+4*r.numGlyphs,i=r.vertexStartIndex;i<n;i+=4)t.indexArray.emplaceBack(i,i+1,i+2),t.indexArray.emplaceBack(i+1,i+2,i+3);},bl.prototype.getSortedSymbolIndexes=function(t){if(this.sortedAngle===t&&void 0!==this.symbolInstanceIndexes)return this.symbolInstanceIndexes;for(var e=Math.sin(t),r=Math.cos(t),n=[],i=[],a=[],o=0;o<this.symbolInstances.length;++o){a.push(o);var s=this.symbolInstances.get(o);n.push(0|Math.round(e*s.anchorX+r*s.anchorY)),i.push(s.featureIndex);}return a.sort((function(t,e){return n[t]-n[e]||i[e]-i[t]})),a},bl.prototype.addToSortKeyRanges=function(t,e){var r=this.sortKeyRanges[this.sortKeyRanges.length-1];r&&r.sortKey===e?r.symbolInstanceEnd=t+1:this.sortKeyRanges.push({sortKey:e,symbolInstanceStart:t,symbolInstanceEnd:t+1});},bl.prototype.sortFeatures=function(t){var e=this;if(this.sortFeaturesByY&&this.sortedAngle!==t&&!(this.text.segments.get().length>1||this.icon.segments.get().length>1)){this.symbolInstanceIndexes=this.getSortedSymbolIndexes(t),this.sortedAngle=t,this.text.indexArray.clear(),this.icon.indexArray.clear(),this.featureSortOrder=[];for(var r=0,n=this.symbolInstanceIndexes;r<n.length;r+=1){var i=n[r],a=this.symbolInstances.get(i);this.featureSortOrder.push(a.featureIndex),[a.rightJustifiedTextSymbolIndex,a.centerJustifiedTextSymbolIndex,a.leftJustifiedTextSymbolIndex].forEach((function(t,r,n){t>=0&&n.indexOf(t)===r&&e.addIndicesForPlacedSymbol(e.text,t);})),a.verticalPlacedTextSymbolIndex>=0&&this.addIndicesForPlacedSymbol(this.text,a.verticalPlacedTextSymbolIndex),a.placedIconSymbolIndex>=0&&this.addIndicesForPlacedSymbol(this.icon,a.placedIconSymbolIndex),a.verticalPlacedIconSymbolIndex>=0&&this.addIndicesForPlacedSymbol(this.icon,a.verticalPlacedIconSymbolIndex);}this.text.indexBuffer&&this.text.indexBuffer.updateData(this.text.indexArray),this.icon.indexBuffer&&this.icon.indexBuffer.updateData(this.icon.indexArray);}},zn("SymbolBucket",bl,{omit:["layers","collisionBoxArray","features","compareText"]}),bl.MAX_GLYPHS=65535,bl.addDynamicAttributes=ml;var _l=new yi({"symbol-placement":new li(Bt.layout_symbol["symbol-placement"]),"symbol-spacing":new li(Bt.layout_symbol["symbol-spacing"]),"symbol-avoid-edges":new li(Bt.layout_symbol["symbol-avoid-edges"]),"symbol-sort-key":new pi(Bt.layout_symbol["symbol-sort-key"]),"symbol-z-order":new li(Bt.layout_symbol["symbol-z-order"]),"icon-allow-overlap":new li(Bt.layout_symbol["icon-allow-overlap"]),"icon-ignore-placement":new li(Bt.layout_symbol["icon-ignore-placement"]),"icon-optional":new li(Bt.layout_symbol["icon-optional"]),"icon-rotation-alignment":new li(Bt.layout_symbol["icon-rotation-alignment"]),"icon-size":new pi(Bt.layout_symbol["icon-size"]),"icon-text-fit":new li(Bt.layout_symbol["icon-text-fit"]),"icon-text-fit-padding":new li(Bt.layout_symbol["icon-text-fit-padding"]),"icon-image":new pi(Bt.layout_symbol["icon-image"]),"icon-rotate":new pi(Bt.layout_symbol["icon-rotate"]),"icon-padding":new li(Bt.layout_symbol["icon-padding"]),"icon-keep-upright":new li(Bt.layout_symbol["icon-keep-upright"]),"icon-offset":new pi(Bt.layout_symbol["icon-offset"]),"icon-anchor":new pi(Bt.layout_symbol["icon-anchor"]),"icon-pitch-alignment":new li(Bt.layout_symbol["icon-pitch-alignment"]),"text-pitch-alignment":new li(Bt.layout_symbol["text-pitch-alignment"]),"text-rotation-alignment":new li(Bt.layout_symbol["text-rotation-alignment"]),"text-field":new pi(Bt.layout_symbol["text-field"]),"text-font":new pi(Bt.layout_symbol["text-font"]),"text-size":new pi(Bt.layout_symbol["text-size"]),"text-max-width":new pi(Bt.layout_symbol["text-max-width"]),"text-line-height":new li(Bt.layout_symbol["text-line-height"]),"text-letter-spacing":new pi(Bt.layout_symbol["text-letter-spacing"]),"text-justify":new pi(Bt.layout_symbol["text-justify"]),"text-radial-offset":new pi(Bt.layout_symbol["text-radial-offset"]),"text-variable-anchor":new li(Bt.layout_symbol["text-variable-anchor"]),"text-anchor":new pi(Bt.layout_symbol["text-anchor"]),"text-max-angle":new li(Bt.layout_symbol["text-max-angle"]),"text-writing-mode":new li(Bt.layout_symbol["text-writing-mode"]),"text-rotate":new pi(Bt.layout_symbol["text-rotate"]),"text-padding":new li(Bt.layout_symbol["text-padding"]),"text-keep-upright":new li(Bt.layout_symbol["text-keep-upright"]),"text-transform":new pi(Bt.layout_symbol["text-transform"]),"text-offset":new pi(Bt.layout_symbol["text-offset"]),"text-allow-overlap":new li(Bt.layout_symbol["text-allow-overlap"]),"text-ignore-placement":new li(Bt.layout_symbol["text-ignore-placement"]),"text-optional":new li(Bt.layout_symbol["text-optional"])}),wl={paint:new yi({"icon-opacity":new pi(Bt.paint_symbol["icon-opacity"]),"icon-color":new pi(Bt.paint_symbol["icon-color"]),"icon-halo-color":new pi(Bt.paint_symbol["icon-halo-color"]),"icon-halo-width":new pi(Bt.paint_symbol["icon-halo-width"]),"icon-halo-blur":new pi(Bt.paint_symbol["icon-halo-blur"]),"icon-translate":new li(Bt.paint_symbol["icon-translate"]),"icon-translate-anchor":new li(Bt.paint_symbol["icon-translate-anchor"]),"text-opacity":new pi(Bt.paint_symbol["text-opacity"]),"text-color":new pi(Bt.paint_symbol["text-color"],{runtimeType:Kt,getOverride:function(t){return t.textColor},hasOverride:function(t){return !!t.textColor}}),"text-halo-color":new pi(Bt.paint_symbol["text-halo-color"]),"text-halo-width":new pi(Bt.paint_symbol["text-halo-width"]),"text-halo-blur":new pi(Bt.paint_symbol["text-halo-blur"]),"text-translate":new li(Bt.paint_symbol["text-translate"]),"text-translate-anchor":new li(Bt.paint_symbol["text-translate-anchor"])}),layout:_l},Al=function(t){this.type=t.property.overrides?t.property.overrides.runtimeType:Ut,this.defaultValue=t;};Al.prototype.evaluate=function(t){if(t.formattedSection){var e=this.defaultValue.property.overrides;if(e&&e.hasOverride(t.formattedSection))return e.getOverride(t.formattedSection)}return t.feature&&t.featureState?this.defaultValue.evaluate(t.feature,t.featureState):this.defaultValue.property.specification.default},Al.prototype.eachChild=function(t){this.defaultValue.isConstant()||t(this.defaultValue.value._styleExpression.expression);},Al.prototype.possibleOutputs=function(){return [void 0]},Al.prototype.serialize=function(){return null},zn("FormatSectionOverride",Al,{omit:["defaultValue"]});var Sl=function(t){function e(e){t.call(this,e,wl);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.recalculate=function(e,r){if(t.prototype.recalculate.call(this,e,r),"auto"===this.layout.get("icon-rotation-alignment")&&("point"!==this.layout.get("symbol-placement")?this.layout._values["icon-rotation-alignment"]="map":this.layout._values["icon-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-rotation-alignment")&&("point"!==this.layout.get("symbol-placement")?this.layout._values["text-rotation-alignment"]="map":this.layout._values["text-rotation-alignment"]="viewport"),"auto"===this.layout.get("text-pitch-alignment")&&(this.layout._values["text-pitch-alignment"]=this.layout.get("text-rotation-alignment")),"auto"===this.layout.get("icon-pitch-alignment")&&(this.layout._values["icon-pitch-alignment"]=this.layout.get("icon-rotation-alignment")),"point"===this.layout.get("symbol-placement")){var n=this.layout.get("text-writing-mode");if(n){for(var i=[],a=0,o=n;a<o.length;a+=1){var s=o[a];i.indexOf(s)<0&&i.push(s);}this.layout._values["text-writing-mode"]=i;}else this.layout._values["text-writing-mode"]=["horizontal"];}this._setPaintOverrides();},e.prototype.getValueAndResolveTokens=function(t,e,r){var n=this.layout.get(t).evaluate(e,{},r),i=this._unevaluatedLayout._values[t];return i.isDataDriven()||Pr(i.value)||!n?n:function(t,e){return e.replace(/{([^{}]+)}/g,(function(e,r){return r in t?String(t[r]):""}))}(e.properties,n)},e.prototype.createBucket=function(t){return new bl(t)},e.prototype.queryRadius=function(){return 0},e.prototype.queryIntersectsFeature=function(){return !1},e.prototype._setPaintOverrides=function(){for(var t=0,r=wl.paint.overridableProperties;t<r.length;t+=1){var n=r[t];if(e.hasPaintOverride(this.layout,n)){var i=this.paint.get(n),a=new Al(i),o=new Br(a,i.property.specification),s=null;s="constant"===i.value.kind||"source"===i.value.kind?new Fr("source",o):new Lr("composite",o,i.value.zoomStops,i.value._interpolationType),this.paint._values[n]=new si(i.property,s,i.parameters);}}},e.prototype._handleOverridablePaintPropertyUpdate=function(t,r,n){return !(!this.layout||r.isDataDriven()||n.isDataDriven())&&e.hasPaintOverride(this.layout,t)},e.hasPaintOverride=function(t,e){var r=t.get("text-field"),n=wl.paint.properties[e],i=!1,a=function(t){for(var e=0,r=t;e<r.length;e+=1){var a=r[e];if(n.overrides&&n.overrides.hasOverride(a))return void(i=!0)}};if("constant"===r.value.kind&&r.value.value instanceof ie)a(r.value.value.sections);else if("source"===r.value.kind){var o=function(t){if(!i)if(t instanceof le&&se(t.value)===Jt){var e=t.value;a(e.sections);}else t instanceof fe?a(t.sections):t.eachChild(o);},s=r.value;s._styleExpression&&o(s._styleExpression.expression);}return i},e}(di),kl={paint:new yi({"background-color":new li(Bt.paint_background["background-color"]),"background-pattern":new hi(Bt.paint_background["background-pattern"]),"background-opacity":new li(Bt.paint_background["background-opacity"])})},Il=function(t){function e(e){t.call(this,e,kl);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(di),zl={paint:new yi({"raster-opacity":new li(Bt.paint_raster["raster-opacity"]),"raster-hue-rotate":new li(Bt.paint_raster["raster-hue-rotate"]),"raster-brightness-min":new li(Bt.paint_raster["raster-brightness-min"]),"raster-brightness-max":new li(Bt.paint_raster["raster-brightness-max"]),"raster-saturation":new li(Bt.paint_raster["raster-saturation"]),"raster-contrast":new li(Bt.paint_raster["raster-contrast"]),"raster-resampling":new li(Bt.paint_raster["raster-resampling"]),"raster-fade-duration":new li(Bt.paint_raster["raster-fade-duration"])})},Cl=function(t){function e(e){t.call(this,e,zl);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e}(di);var Tl=function(t){function e(e){t.call(this,e,{}),this.implementation=e;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.is3D=function(){return "3d"===this.implementation.renderingMode},e.prototype.hasOffscreenPass=function(){return void 0!==this.implementation.prerender},e.prototype.recalculate=function(){},e.prototype.updateTransitions=function(){},e.prototype.hasTransition=function(){},e.prototype.serialize=function(){},e.prototype.onAdd=function(t){this.implementation.onAdd&&this.implementation.onAdd(t,t.painter.context.gl);},e.prototype.onRemove=function(t){this.implementation.onRemove&&this.implementation.onRemove(t,t.painter.context.gl);},e}(di),El={circle:ao,heatmap:mo,hillshade:go,fill:is,"fill-extrusion":ws,line:Ps,symbol:Sl,background:Il,raster:Cl};var Ml=self.HTMLImageElement,Bl=self.HTMLCanvasElement,Pl=self.HTMLVideoElement,Vl=self.ImageData,Fl=self.ImageBitmap,Ll=function(t,e,r,n){this.context=t,this.format=r,this.texture=t.gl.createTexture(),this.update(e,n);};Ll.prototype.update=function(t,e,r){var n=t.width,i=t.height,a=!(this.size&&this.size[0]===n&&this.size[1]===i||r),o=this.context,s=o.gl;if(this.useMipmap=Boolean(e&&e.useMipmap),s.bindTexture(s.TEXTURE_2D,this.texture),o.pixelStoreUnpackFlipY.set(!1),o.pixelStoreUnpack.set(1),o.pixelStoreUnpackPremultiplyAlpha.set(this.format===s.RGBA&&(!e||!1!==e.premultiply)),a)this.size=[n,i],t instanceof Ml||t instanceof Bl||t instanceof Pl||t instanceof Vl||Fl&&t instanceof Fl?s.texImage2D(s.TEXTURE_2D,0,this.format,this.format,s.UNSIGNED_BYTE,t):s.texImage2D(s.TEXTURE_2D,0,this.format,n,i,0,this.format,s.UNSIGNED_BYTE,t.data);else{var u=r||{x:0,y:0},l=u.x,p=u.y;t instanceof Ml||t instanceof Bl||t instanceof Pl||t instanceof Vl||Fl&&t instanceof Fl?s.texSubImage2D(s.TEXTURE_2D,0,l,p,s.RGBA,s.UNSIGNED_BYTE,t):s.texSubImage2D(s.TEXTURE_2D,0,l,p,n,i,s.RGBA,s.UNSIGNED_BYTE,t.data);}this.useMipmap&&this.isSizePowerOfTwo()&&s.generateMipmap(s.TEXTURE_2D);},Ll.prototype.bind=function(t,e,r){var n=this.context.gl;n.bindTexture(n.TEXTURE_2D,this.texture),r!==n.LINEAR_MIPMAP_NEAREST||this.isSizePowerOfTwo()||(r=n.LINEAR),t!==this.filter&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MAG_FILTER,t),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_MIN_FILTER,r||t),this.filter=t),e!==this.wrap&&(n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_S,e),n.texParameteri(n.TEXTURE_2D,n.TEXTURE_WRAP_T,e),this.wrap=e);},Ll.prototype.isSizePowerOfTwo=function(){return this.size[0]===this.size[1]&&Math.log(this.size[0])/Math.LN2%1==0},Ll.prototype.destroy=function(){this.context.gl.deleteTexture(this.texture),this.texture=null;};var Dl=function(t){var e=this;this._callback=t,this._triggered=!1,"undefined"!=typeof MessageChannel&&(this._channel=new MessageChannel,this._channel.port2.onmessage=function(){e._triggered=!1,e._callback();});};Dl.prototype.trigger=function(){var t=this;this._triggered||(this._triggered=!0,this._channel?this._channel.port1.postMessage(!0):setTimeout((function(){t._triggered=!1,t._callback();}),0));},Dl.prototype.remove=function(){delete this._channel,this._callback=function(){};};var Ol=function(t,e,r){this.target=t,this.parent=e,this.mapId=r,this.callbacks={},this.tasks={},this.taskQueue=[],this.cancelCallbacks={},d(["receive","process"],this),this.invoker=new Dl(this.process),this.target.addEventListener("message",this.receive,!1),this.globalScope=S()?t:self;};function Rl(t,e,r){var n=2*Math.PI*6378137/256/Math.pow(2,r);return [t*n-2*Math.PI*6378137/2,e*n-2*Math.PI*6378137/2]}Ol.prototype.send=function(t,e,r,n,i){var a=this;void 0===i&&(i=!1);var o=Math.round(1e18*Math.random()).toString(36).substring(0,10);r&&(this.callbacks[o]=r);var s=z(this.globalScope)?void 0:[];return this.target.postMessage({id:o,type:t,hasCallback:!!r,targetMapId:n,mustQueue:i,sourceMapId:this.mapId,data:Mn(e,s)},s),{cancel:function(){r&&delete a.callbacks[o],a.target.postMessage({id:o,type:"<cancel>",targetMapId:n,sourceMapId:a.mapId});}}},Ol.prototype.receive=function(t){var e=t.data,r=e.id;if(r&&(!e.targetMapId||this.mapId===e.targetMapId))if("<cancel>"===e.type){delete this.tasks[r];var n=this.cancelCallbacks[r];delete this.cancelCallbacks[r],n&&n();}else S()||e.mustQueue?(this.tasks[r]=e,this.taskQueue.push(r),this.invoker.trigger()):this.processTask(r,e);},Ol.prototype.process=function(){if(this.taskQueue.length){var t=this.taskQueue.shift(),e=this.tasks[t];delete this.tasks[t],this.taskQueue.length&&this.invoker.trigger(),e&&this.processTask(t,e);}},Ol.prototype.processTask=function(t,e){var r=this;if("<response>"===e.type){var n=this.callbacks[t];delete this.callbacks[t],n&&(e.error?n(Bn(e.error)):n(null,Bn(e.data)));}else{var i=!1,a=z(this.globalScope)?void 0:[],o=e.hasCallback?function(e,n){i=!0,delete r.cancelCallbacks[t],r.target.postMessage({id:t,type:"<response>",sourceMapId:r.mapId,error:e?Mn(e):null,data:Mn(n,a)},a);}:function(t){i=!0;},s=null,u=Bn(e.data);if(this.parent[e.type])s=this.parent[e.type](e.sourceMapId,u,o);else if(this.parent.getWorkerSource){var l=e.type.split(".");s=this.parent.getWorkerSource(e.sourceMapId,l[0],u.source)[l[1]](u,o);}else o(new Error("Could not find function "+e.type));!i&&s&&s.cancel&&(this.cancelCallbacks[t]=s.cancel);}},Ol.prototype.remove=function(){this.invoker.remove(),this.target.removeEventListener("message",this.receive,!1);};var Ul=function(t,e){t&&(e?this.setSouthWest(t).setNorthEast(e):4===t.length?this.setSouthWest([t[0],t[1]]).setNorthEast([t[2],t[3]]):this.setSouthWest(t[0]).setNorthEast(t[1]));};Ul.prototype.setNorthEast=function(t){return this._ne=t instanceof jl?new jl(t.lng,t.lat):jl.convert(t),this},Ul.prototype.setSouthWest=function(t){return this._sw=t instanceof jl?new jl(t.lng,t.lat):jl.convert(t),this},Ul.prototype.extend=function(t){var e,r,n=this._sw,i=this._ne;if(t instanceof jl)e=t,r=t;else{if(!(t instanceof Ul))return Array.isArray(t)?t.every(Array.isArray)?this.extend(Ul.convert(t)):this.extend(jl.convert(t)):this;if(e=t._sw,r=t._ne,!e||!r)return this}return n||i?(n.lng=Math.min(e.lng,n.lng),n.lat=Math.min(e.lat,n.lat),i.lng=Math.max(r.lng,i.lng),i.lat=Math.max(r.lat,i.lat)):(this._sw=new jl(e.lng,e.lat),this._ne=new jl(r.lng,r.lat)),this},Ul.prototype.getCenter=function(){return new jl((this._sw.lng+this._ne.lng)/2,(this._sw.lat+this._ne.lat)/2)},Ul.prototype.getSouthWest=function(){return this._sw},Ul.prototype.getNorthEast=function(){return this._ne},Ul.prototype.getNorthWest=function(){return new jl(this.getWest(),this.getNorth())},Ul.prototype.getSouthEast=function(){return new jl(this.getEast(),this.getSouth())},Ul.prototype.getWest=function(){return this._sw.lng},Ul.prototype.getSouth=function(){return this._sw.lat},Ul.prototype.getEast=function(){return this._ne.lng},Ul.prototype.getNorth=function(){return this._ne.lat},Ul.prototype.toArray=function(){return [this._sw.toArray(),this._ne.toArray()]},Ul.prototype.toString=function(){return "LngLatBounds("+this._sw.toString()+", "+this._ne.toString()+")"},Ul.prototype.isEmpty=function(){return !(this._sw&&this._ne)},Ul.prototype.contains=function(t){var e=jl.convert(t),r=e.lng,n=e.lat,i=this._sw.lat<=n&&n<=this._ne.lat,a=this._sw.lng<=r&&r<=this._ne.lng;return this._sw.lng>this._ne.lng&&(a=this._sw.lng>=r&&r>=this._ne.lng),i&&a},Ul.convert=function(t){return !t||t instanceof Ul?t:new Ul(t)};var jl=function(t,e){if(isNaN(t)||isNaN(e))throw new Error("Invalid LngLat object: ("+t+", "+e+")");if(this.lng=+t,this.lat=+e,this.lat>90||this.lat<-90)throw new Error("Invalid LngLat latitude value: must be between -90 and 90")};jl.prototype.wrap=function(){return new jl(l(this.lng,-180,180),this.lat)},jl.prototype.toArray=function(){return [this.lng,this.lat]},jl.prototype.toString=function(){return "LngLat("+this.lng+", "+this.lat+")"},jl.prototype.distanceTo=function(t){var e=Math.PI/180,r=this.lat*e,n=t.lat*e,i=Math.sin(r)*Math.sin(n)+Math.cos(r)*Math.cos(n)*Math.cos((t.lng-this.lng)*e);return 6371008.8*Math.acos(Math.min(i,1))},jl.prototype.toBounds=function(t){void 0===t&&(t=0);var e=360*t/40075017,r=e/Math.cos(Math.PI/180*this.lat);return new Ul(new jl(this.lng-r,this.lat-e),new jl(this.lng+r,this.lat+e))},jl.convert=function(t){if(t instanceof jl)return t;if(Array.isArray(t)&&(2===t.length||3===t.length))return new jl(Number(t[0]),Number(t[1]));if(!Array.isArray(t)&&"object"==typeof t&&null!==t)return new jl(Number("lng"in t?t.lng:t.lon),Number(t.lat));throw new Error("`LngLatLike` argument must be specified as a LngLat instance, an object {lng: <lng>, lat: <lat>}, an object {lon: <lng>, lat: <lat>}, or an array of [<lng>, <lat>]")};var ql=2*Math.PI*6371008.8;function Nl(t){return ql*Math.cos(t*Math.PI/180)}function Kl(t){return (180+t)/360}function Xl(t){return (180-180/Math.PI*Math.log(Math.tan(Math.PI/4+t*Math.PI/360)))/360}function Zl(t,e){return t/Nl(e)}function Gl(t){var e=180-360*t;return 360/Math.PI*Math.atan(Math.exp(e*Math.PI/180))-90}var Jl=function(t,e,r){void 0===r&&(r=0),this.x=+t,this.y=+e,this.z=+r;};Jl.fromLngLat=function(t,e){void 0===e&&(e=0);var r=jl.convert(t);return new Jl(Kl(r.lng),Xl(r.lat),Zl(e,r.lat))},Jl.prototype.toLngLat=function(){return new jl(360*this.x-180,Gl(this.y))},Jl.prototype.toAltitude=function(){return t=this.z,e=this.y,t*Nl(Gl(e));var t,e;},Jl.prototype.meterInMercatorCoordinateUnits=function(){return 1/ql*(t=Gl(this.y),1/Math.cos(t*Math.PI/180));var t;};var Yl=function(t,e,r){this.z=t,this.x=e,this.y=r,this.key=Wl(0,t,t,e,r);};Yl.prototype.equals=function(t){return this.z===t.z&&this.x===t.x&&this.y===t.y},Yl.prototype.url=function(t,e){var r,n,i,a,o,s=(r=this.x,n=this.y,i=this.z,a=Rl(256*r,256*(n=Math.pow(2,i)-n-1),i),o=Rl(256*(r+1),256*(n+1),i),a[0]+","+a[1]+","+o[0]+","+o[1]),u=function(t,e,r){for(var n,i="",a=t;a>0;a--)i+=(e&(n=1<<a-1)?1:0)+(r&n?2:0);return i}(this.z,this.x,this.y);return t[(this.x+this.y)%t.length].replace("{prefix}",(this.x%16).toString(16)+(this.y%16).toString(16)).replace("{z}",String(this.z)).replace("{x}",String(this.x)).replace("{y}",String("tms"===e?Math.pow(2,this.z)-this.y-1:this.y)).replace("{quadkey}",u).replace("{bbox-epsg-3857}",s)},Yl.prototype.getTilePoint=function(t){var e=Math.pow(2,this.z);return new i((t.x*e-this.x)*Ma,(t.y*e-this.y)*Ma)},Yl.prototype.toString=function(){return this.z+"/"+this.x+"/"+this.y};var Hl=function(t,e){this.wrap=t,this.canonical=e,this.key=Wl(t,e.z,e.z,e.x,e.y);},$l=function(t,e,r,n,i){this.overscaledZ=t,this.wrap=e,this.canonical=new Yl(r,+n,+i),this.key=Wl(e,t,r,n,i);};function Wl(t,e,r,n,i){(t*=2)<0&&(t=-1*t-1);var a=1<<r;return (a*a*t+a*i+n).toString(36)+r.toString(36)+e.toString(36)}$l.prototype.equals=function(t){return this.overscaledZ===t.overscaledZ&&this.wrap===t.wrap&&this.canonical.equals(t.canonical)},$l.prototype.scaledTo=function(t){var e=this.canonical.z-t;return t>this.canonical.z?new $l(t,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y):new $l(t,this.wrap,t,this.canonical.x>>e,this.canonical.y>>e)},$l.prototype.calculateScaledKey=function(t,e){var r=this.canonical.z-t;return t>this.canonical.z?Wl(this.wrap*+e,t,this.canonical.z,this.canonical.x,this.canonical.y):Wl(this.wrap*+e,t,t,this.canonical.x>>r,this.canonical.y>>r)},$l.prototype.isChildOf=function(t){if(t.wrap!==this.wrap)return !1;var e=this.canonical.z-t.canonical.z;return 0===t.overscaledZ||t.overscaledZ<this.overscaledZ&&t.canonical.x===this.canonical.x>>e&&t.canonical.y===this.canonical.y>>e},$l.prototype.children=function(t){if(this.overscaledZ>=t)return [new $l(this.overscaledZ+1,this.wrap,this.canonical.z,this.canonical.x,this.canonical.y)];var e=this.canonical.z+1,r=2*this.canonical.x,n=2*this.canonical.y;return [new $l(e,this.wrap,e,r,n),new $l(e,this.wrap,e,r+1,n),new $l(e,this.wrap,e,r,n+1),new $l(e,this.wrap,e,r+1,n+1)]},$l.prototype.isLessThan=function(t){return this.wrap<t.wrap||!(this.wrap>t.wrap)&&(this.overscaledZ<t.overscaledZ||!(this.overscaledZ>t.overscaledZ)&&(this.canonical.x<t.canonical.x||!(this.canonical.x>t.canonical.x)&&this.canonical.y<t.canonical.y))},$l.prototype.wrapped=function(){return new $l(this.overscaledZ,0,this.canonical.z,this.canonical.x,this.canonical.y)},$l.prototype.unwrapTo=function(t){return new $l(this.overscaledZ,t,this.canonical.z,this.canonical.x,this.canonical.y)},$l.prototype.overscaleFactor=function(){return Math.pow(2,this.overscaledZ-this.canonical.z)},$l.prototype.toUnwrapped=function(){return new Hl(this.wrap,this.canonical)},$l.prototype.toString=function(){return this.overscaledZ+"/"+this.canonical.x+"/"+this.canonical.y},$l.prototype.getTilePoint=function(t){return this.canonical.getTilePoint(new Jl(t.x-this.wrap,t.y))},zn("CanonicalTileID",Yl),zn("OverscaledTileID",$l,{omit:["posMatrix"]});var Ql=function(t,e,r){if(this.uid=t,e.height!==e.width)throw new RangeError("DEM tiles must be square");if(r&&"mapbox"!==r&&"terrarium"!==r)return _('"'+r+'" is not a valid encoding type. Valid types include "mapbox" and "terrarium".');this.stride=e.height;var n=this.dim=e.height-2;this.data=new Uint32Array(e.data.buffer),this.encoding=r||"mapbox";for(var i=0;i<n;i++)this.data[this._idx(-1,i)]=this.data[this._idx(0,i)],this.data[this._idx(n,i)]=this.data[this._idx(n-1,i)],this.data[this._idx(i,-1)]=this.data[this._idx(i,0)],this.data[this._idx(i,n)]=this.data[this._idx(i,n-1)];this.data[this._idx(-1,-1)]=this.data[this._idx(0,0)],this.data[this._idx(n,-1)]=this.data[this._idx(n-1,0)],this.data[this._idx(-1,n)]=this.data[this._idx(0,n-1)],this.data[this._idx(n,n)]=this.data[this._idx(n-1,n-1)];};Ql.prototype.get=function(t,e){var r=new Uint8Array(this.data.buffer),n=4*this._idx(t,e);return ("terrarium"===this.encoding?this._unpackTerrarium:this._unpackMapbox)(r[n],r[n+1],r[n+2])},Ql.prototype.getUnpackVector=function(){return "terrarium"===this.encoding?[256,1,1/256,32768]:[6553.6,25.6,.1,1e4]},Ql.prototype._idx=function(t,e){if(t<-1||t>=this.dim+1||e<-1||e>=this.dim+1)throw new RangeError("out of range source coordinates for DEM data");return (e+1)*this.stride+(t+1)},Ql.prototype._unpackMapbox=function(t,e,r){return (256*t*256+256*e+r)/10-1e4},Ql.prototype._unpackTerrarium=function(t,e,r){return 256*t+e+r/256-32768},Ql.prototype.getPixels=function(){return new ho({width:this.stride,height:this.stride},new Uint8Array(this.data.buffer))},Ql.prototype.backfillBorder=function(t,e,r){if(this.dim!==t.dim)throw new Error("dem dimension mismatch");var n=e*this.dim,i=e*this.dim+this.dim,a=r*this.dim,o=r*this.dim+this.dim;switch(e){case-1:n=i-1;break;case 1:i=n+1;}switch(r){case-1:a=o-1;break;case 1:o=a+1;}for(var s=-e*this.dim,u=-r*this.dim,l=a;l<o;l++)for(var p=n;p<i;p++)this.data[this._idx(p,l)]=t.data[this._idx(p+s,l+u)];},zn("DEMData",Ql);var tp=function(t){this._stringToNumber={},this._numberToString=[];for(var e=0;e<t.length;e++){var r=t[e];this._stringToNumber[r]=e,this._numberToString[e]=r;}};tp.prototype.encode=function(t){return this._stringToNumber[t]},tp.prototype.decode=function(t){return this._numberToString[t]};var ep=function(t,e,r,n,i){this.type="Feature",this._vectorTileFeature=t,t._z=e,t._x=r,t._y=n,this.properties=t.properties,this.id=i;},rp={geometry:{configurable:!0}};rp.geometry.get=function(){return void 0===this._geometry&&(this._geometry=this._vectorTileFeature.toGeoJSON(this._vectorTileFeature._x,this._vectorTileFeature._y,this._vectorTileFeature._z).geometry),this._geometry},rp.geometry.set=function(t){this._geometry=t;},ep.prototype.toJSON=function(){var t={geometry:this.geometry};for(var e in this)"_geometry"!==e&&"_vectorTileFeature"!==e&&(t[e]=this[e]);return t},Object.defineProperties(ep.prototype,rp);var np=function(){this.state={},this.stateChanges={},this.deletedStates={};};np.prototype.updateState=function(t,e,r){var n=String(e);if(this.stateChanges[t]=this.stateChanges[t]||{},this.stateChanges[t][n]=this.stateChanges[t][n]||{},p(this.stateChanges[t][n],r),null===this.deletedStates[t])for(var i in this.deletedStates[t]={},this.state[t])i!==n&&(this.deletedStates[t][i]=null);else if(this.deletedStates[t]&&null===this.deletedStates[t][n])for(var a in this.deletedStates[t][n]={},this.state[t][n])r[a]||(this.deletedStates[t][n][a]=null);else for(var o in r){this.deletedStates[t]&&this.deletedStates[t][n]&&null===this.deletedStates[t][n][o]&&delete this.deletedStates[t][n][o];}},np.prototype.removeFeatureState=function(t,e,r){if(!(null===this.deletedStates[t])){var n=String(e);if(this.deletedStates[t]=this.deletedStates[t]||{},r&&void 0!==e)null!==this.deletedStates[t][n]&&(this.deletedStates[t][n]=this.deletedStates[t][n]||{},this.deletedStates[t][n][r]=null);else if(void 0!==e){if(this.stateChanges[t]&&this.stateChanges[t][n])for(r in this.deletedStates[t][n]={},this.stateChanges[t][n])this.deletedStates[t][n][r]=null;else this.deletedStates[t][n]=null;}else this.deletedStates[t]=null;}},np.prototype.getState=function(t,e){var r=String(e),n=this.state[t]||{},i=this.stateChanges[t]||{},a=p({},n[r],i[r]);if(null===this.deletedStates[t])return {};if(this.deletedStates[t]){var o=this.deletedStates[t][e];if(null===o)return {};for(var s in o)delete a[s];}return a},np.prototype.initializeTileState=function(t,e){t.setFeatureState(this.state,e);},np.prototype.coalesceChanges=function(t,e){var r={};for(var n in this.stateChanges){this.state[n]=this.state[n]||{};var i={};for(var a in this.stateChanges[n])this.state[n][a]||(this.state[n][a]={}),p(this.state[n][a],this.stateChanges[n][a]),i[a]=this.state[n][a];r[n]=i;}for(var o in this.deletedStates){this.state[o]=this.state[o]||{};var s={};if(null===this.deletedStates[o])for(var u in this.state[o])s[u]={},this.state[o][u]={};else for(var l in this.deletedStates[o]){if(null===this.deletedStates[o][l])this.state[o][l]={};else for(var c=0,h=Object.keys(this.deletedStates[o][l]);c<h.length;c+=1){var f=h[c];delete this.state[o][l][f];}s[l]=this.state[o][l];}r[o]=r[o]||{},p(r[o],s);}if(this.stateChanges={},this.deletedStates={},0!==Object.keys(r).length)for(var y in t){t[y].setFeatureState(r,e);}};var ip=function(t,e){this.tileID=t,this.x=t.canonical.x,this.y=t.canonical.y,this.z=t.canonical.z,this.grid=new _n(Ma,16,0),this.grid3D=new _n(Ma,16,0),this.featureIndexArray=new Qi,this.promoteId=e;};function ap(t){for(var e=1/0,r=1/0,n=-1/0,i=-1/0,a=0,o=t;a<o.length;a+=1){var s=o[a];e=Math.min(e,s.x),r=Math.min(r,s.y),n=Math.max(n,s.x),i=Math.max(i,s.y);}return {minX:e,minY:r,maxX:n,maxY:i}}function op(t,e){return e-t}ip.prototype.insert=function(t,e,r,n,i,a){var o=this.featureIndexArray.length;this.featureIndexArray.emplaceBack(r,n,i);for(var s=a?this.grid3D:this.grid,u=0;u<e.length;u++){for(var l=e[u],p=[1/0,1/0,-1/0,-1/0],c=0;c<l.length;c++){var h=l[c];p[0]=Math.min(p[0],h.x),p[1]=Math.min(p[1],h.y),p[2]=Math.max(p[2],h.x),p[3]=Math.max(p[3],h.y);}p[0]<Ma&&p[1]<Ma&&p[2]>=0&&p[3]>=0&&s.insert(o,p[0],p[1],p[2],p[3]);}},ip.prototype.loadVTLayers=function(){return this.vtLayers||(this.vtLayers=new ys.VectorTile(new Xs(this.rawTileData)).layers,this.sourceLayerCoder=new tp(this.vtLayers?Object.keys(this.vtLayers).sort():["_geojsonTileLayer"])),this.vtLayers},ip.prototype.query=function(t,e,r){var n=this;this.loadVTLayers();for(var a=t.params||{},o=Ma/t.tileSize/t.scale,s=Gr(a.filter),u=t.queryGeometry,l=t.queryPadding*o,p=ap(u),c=this.grid.query(p.minX-l,p.minY-l,p.maxX+l,p.maxY+l),h=ap(t.cameraQueryGeometry),f=this.grid3D.query(h.minX-l,h.minY-l,h.maxX+l,h.maxY+l,(function(e,r,n,a){return function(t,e,r,n,a){for(var o=0,s=t;o<s.length;o+=1){var u=s[o];if(e<=u.x&&r<=u.y&&n>=u.x&&a>=u.y)return !0}var l=[new i(e,r),new i(e,a),new i(n,a),new i(n,r)];if(t.length>2)for(var p=0,c=l;p<c.length;p+=1){if(Za(t,c[p]))return !0}for(var h=0;h<t.length-1;h++){if(Ga(t[h],t[h+1],l))return !0}return !1}(t.cameraQueryGeometry,e-l,r-l,n+l,a+l)})),y=0,d=f;y<d.length;y+=1){var m=d[y];c.push(m);}c.sort(op);for(var v,g={},x=function(i){var l=c[i];if(l!==v){v=l;var p=n.featureIndexArray.get(l),h=null;n.loadMatchingFeature(g,p.bucketIndex,p.sourceLayerIndex,p.featureIndex,s,a.layers,e,(function(e,i,a){h||(h=Va(e));var s={};return void 0!==a&&(s=r.getState(i.sourceLayer||"_geojsonTileLayer",a)),i.queryIntersectsFeature(u,e,s,h,n.z,t.transform,o,t.pixelPosMatrix)}));}},b=0;b<c.length;b++)x(b);return g},ip.prototype.loadMatchingFeature=function(t,e,r,n,i,a,o,s){var u=this.bucketLayerIDs[e];if(!a||function(t,e){for(var r=0;r<t.length;r++)if(e.indexOf(t[r])>=0)return !0;return !1}(a,u)){var l=this.sourceLayerCoder.decode(r),p=this.vtLayers[l].feature(n);if(i(new ti(this.tileID.overscaledZ),p))for(var c=this.getId(p,l),h=0;h<u.length;h++){var f=u[h];if(!(a&&a.indexOf(f)<0)){var y=o[f];if(y){var d=!s||s(p,y,c);if(d){var m=new ep(p,this.z,this.x,this.y,c);m.layer=y.serialize();var v=t[f];void 0===v&&(v=t[f]=[]),v.push({featureIndex:n,feature:m,intersectionZ:d});}}}}}},ip.prototype.lookupSymbolFeatures=function(t,e,r,n,i,a){var o={};this.loadVTLayers();for(var s=Gr(n),u=0,l=t;u<l.length;u+=1){var p=l[u];this.loadMatchingFeature(o,e,r,p,s,i,a);}return o},ip.prototype.hasLayer=function(t){for(var e=0,r=this.bucketLayerIDs;e<r.length;e+=1)for(var n=0,i=r[e];n<i.length;n+=1){if(t===i[n])return !0}return !1},ip.prototype.getId=function(t,e){var r=t.id;if(this.promoteId){var n="string"==typeof this.promoteId?this.promoteId:this.promoteId[e];"boolean"==typeof(r=t.properties[n])&&(r=Number(r));}return r},zn("FeatureIndex",ip,{omit:["rawTileData","sourceLayerCoder"]});var sp=function(t,e){this.tileID=t,this.uid=h(),this.uses=0,this.tileSize=e,this.buckets={},this.expirationTime=null,this.queryPadding=0,this.hasSymbolBuckets=!1,this.hasRTLText=!1,this.dependencies={},this.expiredRequestCount=0,this.state="loading";};sp.prototype.registerFadeDuration=function(t){var e=t+this.timeAdded;e<L.now()||this.fadeEndTime&&e<this.fadeEndTime||(this.fadeEndTime=e);},sp.prototype.wasRequested=function(){return "errored"===this.state||"loaded"===this.state||"reloading"===this.state},sp.prototype.loadVectorData=function(t,e,r){if(this.hasData()&&this.unloadVectorData(),this.state="loaded",t){for(var n in t.featureIndex&&(this.latestFeatureIndex=t.featureIndex,t.rawTileData?(this.latestRawTileData=t.rawTileData,this.latestFeatureIndex.rawTileData=t.rawTileData):this.latestRawTileData&&(this.latestFeatureIndex.rawTileData=this.latestRawTileData)),this.collisionBoxArray=t.collisionBoxArray,this.buckets=function(t,e){var r={};if(!e)return r;for(var n=function(){var t=a[i],n=t.layerIds.map((function(t){return e.getLayer(t)})).filter(Boolean);if(0!==n.length){t.layers=n,t.stateDependentLayerIds&&(t.stateDependentLayers=t.stateDependentLayerIds.map((function(t){return n.filter((function(e){return e.id===t}))[0]})));for(var o=0,s=n;o<s.length;o+=1){var u=s[o];r[u.id]=t;}}},i=0,a=t;i<a.length;i+=1)n();return r}(t.buckets,e.style),this.hasSymbolBuckets=!1,this.buckets){var i=this.buckets[n];if(i instanceof bl){if(this.hasSymbolBuckets=!0,!r)break;i.justReloaded=!0;}}if(this.hasRTLText=!1,this.hasSymbolBuckets)for(var a in this.buckets){var o=this.buckets[a];if(o instanceof bl&&o.hasRTLText){this.hasRTLText=!0,Qn.isLoading()||Qn.isLoaded()||"deferred"!==$n()||Wn();break}}for(var s in this.queryPadding=0,this.buckets){var u=this.buckets[s];this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(s).queryRadius(u));}t.imageAtlas&&(this.imageAtlas=t.imageAtlas),t.glyphAtlasImage&&(this.glyphAtlasImage=t.glyphAtlasImage);}else this.collisionBoxArray=new Ni;},sp.prototype.unloadVectorData=function(){for(var t in this.buckets)this.buckets[t].destroy();this.buckets={},this.imageAtlasTexture&&this.imageAtlasTexture.destroy(),this.imageAtlas&&(this.imageAtlas=null),this.glyphAtlasTexture&&this.glyphAtlasTexture.destroy(),this.latestFeatureIndex=null,this.state="unloaded";},sp.prototype.getBucket=function(t){return this.buckets[t.id]},sp.prototype.upload=function(t){for(var e in this.buckets){var r=this.buckets[e];r.uploadPending()&&r.upload(t);}var n=t.gl;this.imageAtlas&&!this.imageAtlas.uploaded&&(this.imageAtlasTexture=new Ll(t,this.imageAtlas.image,n.RGBA),this.imageAtlas.uploaded=!0),this.glyphAtlasImage&&(this.glyphAtlasTexture=new Ll(t,this.glyphAtlasImage,n.ALPHA),this.glyphAtlasImage=null);},sp.prototype.prepare=function(t){this.imageAtlas&&this.imageAtlas.patchUpdatedImages(t,this.imageAtlasTexture);},sp.prototype.queryRenderedFeatures=function(t,e,r,n,i,a,o,s,u){return this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData?this.latestFeatureIndex.query({queryGeometry:r,cameraQueryGeometry:n,scale:i,tileSize:this.tileSize,pixelPosMatrix:u,transform:o,params:a,queryPadding:this.queryPadding*s},t,e):{}},sp.prototype.querySourceFeatures=function(t,e){var r=this.latestFeatureIndex;if(r&&r.rawTileData){var n=r.loadVTLayers(),i=e?e.sourceLayer:"",a=n._geojsonTileLayer||n[i];if(a)for(var o=Gr(e&&e.filter),s=this.tileID.canonical,u=s.z,l=s.x,p=s.y,c={z:u,x:l,y:p},h=0;h<a.length;h++){var f=a.feature(h);if(o(new ti(this.tileID.overscaledZ),f)){var y=r.getId(f,i),d=new ep(f,u,l,p,y);d.tile=c,t.push(d);}}}},sp.prototype.hasData=function(){return "loaded"===this.state||"reloading"===this.state||"expired"===this.state},sp.prototype.patternsLoaded=function(){return this.imageAtlas&&!!Object.keys(this.imageAtlas.patternPositions).length},sp.prototype.setExpiryData=function(t){var e=this.expirationTime;if(t.cacheControl){var r=k(t.cacheControl);r["max-age"]&&(this.expirationTime=Date.now()+1e3*r["max-age"]);}else t.expires&&(this.expirationTime=new Date(t.expires).getTime());if(this.expirationTime){var n=Date.now(),i=!1;if(this.expirationTime>n)i=!1;else if(e)if(this.expirationTime<e)i=!0;else{var a=this.expirationTime-e;a?this.expirationTime=n+Math.max(a,3e4):i=!0;}else i=!0;i?(this.expiredRequestCount++,this.state="expired"):this.expiredRequestCount=0;}},sp.prototype.getExpiryTimeout=function(){if(this.expirationTime)return this.expiredRequestCount?1e3*(1<<Math.min(this.expiredRequestCount-1,31)):Math.min(this.expirationTime-(new Date).getTime(),Math.pow(2,31)-1)},sp.prototype.setFeatureState=function(t,e){if(this.latestFeatureIndex&&this.latestFeatureIndex.rawTileData&&0!==Object.keys(t).length){var r=this.latestFeatureIndex.loadVTLayers();for(var n in this.buckets){var i=this.buckets[n],a=i.layers[0].sourceLayer||"_geojsonTileLayer",o=r[a],s=t[a];o&&s&&0!==Object.keys(s).length&&(i.update(s,o,this.imageAtlas&&this.imageAtlas.patternPositions||{}),e&&e.style&&(this.queryPadding=Math.max(this.queryPadding,e.style.getLayer(n).queryRadius(i))));}}},sp.prototype.holdingForFade=function(){return void 0!==this.symbolFadeHoldUntil},sp.prototype.symbolFadeFinished=function(){return !this.symbolFadeHoldUntil||this.symbolFadeHoldUntil<L.now()},sp.prototype.clearFadeHold=function(){this.symbolFadeHoldUntil=void 0;},sp.prototype.setHoldDuration=function(t){this.symbolFadeHoldUntil=L.now()+t;},sp.prototype.setDependencies=function(t,e){for(var r={},n=0,i=e;n<i.length;n+=1){r[i[n]]=!0;}this.dependencies[t]=r;},sp.prototype.hasDependency=function(t,e){for(var r=0,n=t;r<n.length;r+=1){var i=n[r],a=this.dependencies[i];if(a)for(var o=0,s=e;o<s.length;o+=1){if(a[s[o]])return !0}}return !1};var up=self.performance,lp=function(t){this._marks={start:[t.url,"start"].join("#"),end:[t.url,"end"].join("#"),measure:t.url.toString()},up.mark(this._marks.start);};lp.prototype.finish=function(){up.mark(this._marks.end);var t=up.getEntriesByName(this._marks.measure);return 0===t.length&&(up.measure(this._marks.measure,this._marks.start,this._marks.end),t=up.getEntriesByName(this._marks.measure),up.clearMarks(this._marks.start),up.clearMarks(this._marks.end),up.clearMeasures(this._marks.measure)),t},t.Actor=Ol,t.AlphaImage=co,t.CanonicalTileID=Yl,t.CollisionBoxArray=Ni,t.Color=ee,t.DEMData=Ql,t.DataConstantProperty=li,t.DictionaryCoder=tp,t.EXTENT=Ma,t.ErrorEvent=Et,t.EvaluationParameters=ti,t.Event=Tt,t.Evented=Mt,t.FeatureIndex=ip,t.FillBucket=es,t.FillExtrusionBucket=gs,t.ImageAtlas=gu,t.ImagePosition=mu,t.LineBucket=Ts,t.LngLat=jl,t.LngLatBounds=Ul,t.MercatorCoordinate=Jl,t.ONE_EM=qs,t.OverscaledTileID=$l,t.Point=i,t.Point$1=i,t.Properties=yi,t.Protobuf=Xs,t.RGBAImage=ho,t.RequestManager=N,t.RequestPerformance=lp,t.ResourceType=mt,t.SegmentVector=ea,t.SourceFeatureState=np,t.StructArrayLayout1ui2=Ri,t.StructArrayLayout2i4=_i,t.StructArrayLayout2ui4=Oi,t.StructArrayLayout3ui6=Di,t.StructArrayLayout4i8=wi,t.SymbolBucket=bl,t.Texture=Ll,t.Tile=sp,t.Transitionable=ni,t.Uniform1f=ya,t.Uniform1i=fa,t.Uniform2f=da,t.Uniform3f=ma,t.Uniform4f=va,t.UniformColor=ga,t.UniformMatrix4f=ba,t.UnwrappedTileID=Hl,t.ValidationError=Pt,t.WritingMode=xu,t.ZoomHistory=Pn,t.add=function(t,e,r){return t[0]=e[0]+r[0],t[1]=e[1]+r[1],t[2]=e[2]+r[2],t},t.addDynamicAttributes=ml,t.asyncAll=function(t,e,r){if(!t.length)return r(null,[]);var n=t.length,i=new Array(t.length),a=null;t.forEach((function(t,o){e(t,(function(t,e){t&&(a=t),i[o]=e,0==--n&&r(a,i);}));}));},t.bezier=o,t.bindAll=d,t.browser=L,t.cacheEntryPossiblyAdded=function(t){++yt>st&&(t.getActor().send("enforceCacheSizeLimit",ot),yt=0);},t.clamp=u,t.clearTileCache=function(t){var e=self.caches.delete(at);t&&e.catch(t).then((function(){return t()}));},t.clone=function(t){var e=new Qa(16);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e[3]=t[3],e[4]=t[4],e[5]=t[5],e[6]=t[6],e[7]=t[7],e[8]=t[8],e[9]=t[9],e[10]=t[10],e[11]=t[11],e[12]=t[12],e[13]=t[13],e[14]=t[14],e[15]=t[15],e},t.clone$1=x,t.clone$2=function(t){var e=new Qa(3);return e[0]=t[0],e[1]=t[1],e[2]=t[2],e},t.config=D,t.create=function(){var t=new Qa(16);return Qa!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=0,t[12]=0,t[13]=0,t[14]=0),t[0]=1,t[5]=1,t[10]=1,t[15]=1,t},t.create$1=function(){var t=new Qa(9);return Qa!=Float32Array&&(t[1]=0,t[2]=0,t[3]=0,t[5]=0,t[6]=0,t[7]=0),t[0]=1,t[4]=1,t[8]=1,t},t.create$2=function(){var t=new Qa(4);return Qa!=Float32Array&&(t[1]=0,t[2]=0),t[0]=1,t[3]=1,t},t.createCommonjsModule=e,t.createExpression=Vr,t.createLayout=xi,t.createStyleLayer=function(t){return "custom"===t.type?new Tl(t):new El[t.type](t)},t.cross=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=r[0],s=r[1],u=r[2];return t[0]=i*u-a*s,t[1]=a*o-n*u,t[2]=n*s-i*o,t},t.deepEqual=function t(e,r){if(Array.isArray(e)){if(!Array.isArray(r)||e.length!==r.length)return !1;for(var n=0;n<e.length;n++)if(!t(e[n],r[n]))return !1;return !0}if("object"==typeof e&&null!==e&&null!==r){if("object"!=typeof r)return !1;if(Object.keys(e).length!==Object.keys(r).length)return !1;for(var i in e)if(!t(e[i],r[i]))return !1;return !0}return e===r},t.dot=function(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]},t.dot$1=function(t,e){return t[0]*e[0]+t[1]*e[1]+t[2]*e[2]+t[3]*e[3]},t.ease=s,t.emitValidationErrors=bn,t.endsWith=m,t.enforceCacheSizeLimit=function(t){lt(),W&&W.then((function(e){e.keys().then((function(r){for(var n=0;n<r.length-t;n++)e.delete(r[n]);}));}));},t.evaluateSizeForFeature=Du,t.evaluateSizeForZoom=Ou,t.evaluateVariableOffset=ol,t.evented=Hn,t.extend=p,t.featureFilter=Gr,t.filterObject=g,t.fromRotation=function(t,e){var r=Math.sin(e),n=Math.cos(e);return t[0]=n,t[1]=r,t[2]=0,t[3]=-r,t[4]=n,t[5]=0,t[6]=0,t[7]=0,t[8]=1,t},t.getAnchorAlignment=Mu,t.getAnchorJustification=sl,t.getArrayBuffer=_t,t.getImage=It,t.getJSON=function(t,e){return bt(p(t,{type:"json"}),e)},t.getRTLTextPluginStatus=$n,t.getReferrer=gt,t.getVideo=function(t,e){var r,n,i=self.document.createElement("video");i.muted=!0,i.onloadstart=function(){e(null,i);};for(var a=0;a<t.length;a++){var o=self.document.createElement("source");r=t[a],n=void 0,(n=self.document.createElement("a")).href=r,(n.protocol!==self.document.location.protocol||n.host!==self.document.location.host)&&(i.crossOrigin="Anonymous"),o.src=t[a],i.appendChild(o);}return {cancel:function(){}}},t.identity=function(t){return t[0]=1,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=1,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=1,t[11]=0,t[12]=0,t[13]=0,t[14]=0,t[15]=1,t},t.invert=function(t,e){var r=e[0],n=e[1],i=e[2],a=e[3],o=e[4],s=e[5],u=e[6],l=e[7],p=e[8],c=e[9],h=e[10],f=e[11],y=e[12],d=e[13],m=e[14],v=e[15],g=r*s-n*o,x=r*u-i*o,b=r*l-a*o,_=n*u-i*s,w=n*l-a*s,A=i*l-a*u,S=p*d-c*y,k=p*m-h*y,I=p*v-f*y,z=c*m-h*d,C=c*v-f*d,T=h*v-f*m,E=g*T-x*C+b*z+_*I-w*k+A*S;return E?(E=1/E,t[0]=(s*T-u*C+l*z)*E,t[1]=(i*C-n*T-a*z)*E,t[2]=(d*A-m*w+v*_)*E,t[3]=(h*w-c*A-f*_)*E,t[4]=(u*I-o*T-l*k)*E,t[5]=(r*T-i*I+a*k)*E,t[6]=(m*b-y*A-v*x)*E,t[7]=(p*A-h*b+f*x)*E,t[8]=(o*C-s*I+l*S)*E,t[9]=(n*I-r*C-a*S)*E,t[10]=(y*w-d*b+v*g)*E,t[11]=(c*b-p*w-f*g)*E,t[12]=(s*k-o*z-u*S)*E,t[13]=(r*z-n*k+i*S)*E,t[14]=(d*x-y*_-m*g)*E,t[15]=(p*_-c*x+h*g)*E,t):null},t.isChar=Vn,t.isMapboxURL=K,t.keysDifference=function(t,e){var r=[];for(var n in t)n in e||r.push(n);return r},t.makeRequest=bt,t.mapObject=v,t.mercatorXfromLng=Kl,t.mercatorYfromLat=Xl,t.mercatorZfromAltitude=Zl,t.multiply=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3],s=e[4],u=e[5],l=e[6],p=e[7],c=e[8],h=e[9],f=e[10],y=e[11],d=e[12],m=e[13],v=e[14],g=e[15],x=r[0],b=r[1],_=r[2],w=r[3];return t[0]=x*n+b*s+_*c+w*d,t[1]=x*i+b*u+_*h+w*m,t[2]=x*a+b*l+_*f+w*v,t[3]=x*o+b*p+_*y+w*g,x=r[4],b=r[5],_=r[6],w=r[7],t[4]=x*n+b*s+_*c+w*d,t[5]=x*i+b*u+_*h+w*m,t[6]=x*a+b*l+_*f+w*v,t[7]=x*o+b*p+_*y+w*g,x=r[8],b=r[9],_=r[10],w=r[11],t[8]=x*n+b*s+_*c+w*d,t[9]=x*i+b*u+_*h+w*m,t[10]=x*a+b*l+_*f+w*v,t[11]=x*o+b*p+_*y+w*g,x=r[12],b=r[13],_=r[14],w=r[15],t[12]=x*n+b*s+_*c+w*d,t[13]=x*i+b*u+_*h+w*m,t[14]=x*a+b*l+_*f+w*v,t[15]=x*o+b*p+_*y+w*g,t},t.mvt=ys,t.normalize=function(t,e){var r=e[0],n=e[1],i=e[2],a=r*r+n*n+i*i;return a>0&&(a=1/Math.sqrt(a)),t[0]=e[0]*a,t[1]=e[1]*a,t[2]=e[2]*a,t},t.number=Ce,t.offscreenCanvasSupported=dt,t.ortho=function(t,e,r,n,i,a,o){var s=1/(e-r),u=1/(n-i),l=1/(a-o);return t[0]=-2*s,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=-2*u,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[10]=2*l,t[11]=0,t[12]=(e+r)*s,t[13]=(i+n)*u,t[14]=(o+a)*l,t[15]=1,t},t.parseGlyphPBF=function(t){return new Xs(t).readFields(pu,[])},t.pbf=Xs,t.performSymbolLayout=function(t,e,r,n,a,o){t.createArrays();var s=512*t.overscaling;t.tilePixelRatio=Ma/s,t.compareText={},t.iconsNeedLinear=!1;var u=t.layers[0].layout,l=t.layers[0]._unevaluatedLayout._values,p={};if("composite"===t.textSizeData.kind){var c=t.textSizeData,h=c.minZoom,f=c.maxZoom;p.compositeTextSizes=[l["text-size"].possiblyEvaluate(new ti(h)),l["text-size"].possiblyEvaluate(new ti(f))];}if("composite"===t.iconSizeData.kind){var y=t.iconSizeData,d=y.minZoom,m=y.maxZoom;p.compositeIconSizes=[l["icon-size"].possiblyEvaluate(new ti(d)),l["icon-size"].possiblyEvaluate(new ti(m))];}p.layoutTextSize=l["text-size"].possiblyEvaluate(new ti(t.zoom+1)),p.layoutIconSize=l["icon-size"].possiblyEvaluate(new ti(t.zoom+1)),p.textMaxSize=l["text-size"].possiblyEvaluate(new ti(18));for(var v=u.get("text-line-height")*qs,g="map"===u.get("text-rotation-alignment")&&"point"!==u.get("symbol-placement"),x=u.get("text-keep-upright"),b=u.get("text-size"),w=function(){var o=S[A],s=u.get("text-font").evaluate(o,{}).join(","),l=b.evaluate(o,{}),c=p.layoutTextSize.evaluate(o,{}),h=p.layoutIconSize.evaluate(o,{}),f={horizontal:{},vertical:void 0},y=o.text,d=[0,0];if(y){var m=y.toString(),w=u.get("text-letter-spacing").evaluate(o,{})*qs,k=function(t){for(var e=0,r=t;e<r.length;e+=1){if(!Ln(r[e].charCodeAt(0)))return !1}return !0}(m)?w:0,I=u.get("text-anchor").evaluate(o,{}),z=u.get("text-variable-anchor");if(!z){var C=u.get("text-radial-offset").evaluate(o,{});d=C?ol(I,[C*qs,al]):u.get("text-offset").evaluate(o,{}).map((function(t){return t*qs}));}var T=g?"center":u.get("text-justify").evaluate(o,{}),E=u.get("symbol-placement"),M="point"===E?u.get("text-max-width").evaluate(o,{})*qs:0,B=function(){t.allowVerticalPlacement&&Fn(m)&&(f.vertical=Au(y,e,r,a,s,M,v,I,"left",k,d,xu.vertical,!0,E,c,l));};if(!g&&z){for(var P="auto"===T?z.map((function(t){return sl(t)})):[T],V=!1,F=0;F<P.length;F++){var L=P[F];if(!f.horizontal[L])if(V)f.horizontal[L]=f.horizontal[0];else{var D=Au(y,e,r,a,s,M,v,"center",L,k,d,xu.horizontal,!1,E,c,l);D&&(f.horizontal[L]=D,V=1===D.positionedLines.length);}}B();}else{"auto"===T&&(T=sl(I));var O=Au(y,e,r,a,s,M,v,I,T,k,d,xu.horizontal,!1,E,c,l);O&&(f.horizontal[T]=O),B(),Fn(m)&&g&&x&&(f.vertical=Au(y,e,r,a,s,M,v,I,T,k,d,xu.vertical,!1,E,c,l));}}var R=void 0,U=!1;if(o.icon&&o.icon.name){var j=n[o.icon.name];j&&(R=function(t,e,r){var n=Mu(r),i=n.horizontalAlign,a=n.verticalAlign,o=e[0],s=e[1],u=o-t.displaySize[0]*i,l=u+t.displaySize[0],p=s-t.displaySize[1]*a;return {image:t,top:p,bottom:p+t.displaySize[1],left:u,right:l}}(a[o.icon.name],u.get("icon-offset").evaluate(o,{}),u.get("icon-anchor").evaluate(o,{})),U=j.sdf,void 0===t.sdfIcons?t.sdfIcons=j.sdf:t.sdfIcons!==j.sdf&&_("Style sheet warning: Cannot mix SDF and non-SDF icons in one buffer"),j.pixelRatio!==t.pixelRatio?t.iconsNeedLinear=!0:0!==u.get("icon-rotate").constantOr(1)&&(t.iconsNeedLinear=!0));}var q=cl(f.horizontal)||f.vertical;t.iconsInText=!!q&&q.iconsInText,(q||R)&&function(t,e,r,n,a,o,s,u,l,p){var c=o.textMaxSize.evaluate(e,{});void 0===c&&(c=s);var h,f=t.layers[0].layout,y=f.get("icon-offset").evaluate(e,{}),d=cl(r.horizontal),m=s/24,v=t.tilePixelRatio*m,g=t.tilePixelRatio*c/24,x=t.tilePixelRatio*u,b=t.tilePixelRatio*f.get("symbol-spacing"),w=f.get("text-padding")*t.tilePixelRatio,A=f.get("icon-padding")*t.tilePixelRatio,S=f.get("text-max-angle")/180*Math.PI,k="map"===f.get("text-rotation-alignment")&&"point"!==f.get("symbol-placement"),I="map"===f.get("icon-rotation-alignment")&&"point"!==f.get("symbol-placement"),z=f.get("symbol-placement"),C=b/2,T=f.get("icon-text-fit");n&&"none"!==T&&(t.allowVerticalPlacement&&r.vertical&&(h=Pu(n,r.vertical,T,f.get("icon-text-fit-padding"),y,m)),d&&(n=Pu(n,d,T,f.get("icon-text-fit-padding"),y,m)));var E=function(i,s){s.x<0||s.x>=Ma||s.y<0||s.y>=Ma||function(t,e,r,n,i,a,o,s,u,l,p,c,h,f,y,d,m,v,g,x,b,w,A){var S,k,I,z,C,T=t.addToLineVertexArray(e,r),E=0,M=0,B=0,P=0,V=-1,F=-1,L={},D=aa(""),O=0,R=0;void 0===s._unevaluatedLayout.getValue("text-radial-offset")?(S=s.layout.get("text-offset").evaluate(b,{}).map((function(t){return t*qs})),O=S[0],R=S[1]):(O=s.layout.get("text-radial-offset").evaluate(b,{})*qs,R=al);if(t.allowVerticalPlacement&&n.vertical){var U=s.layout.get("text-rotate").evaluate(b,{})+90,j=n.vertical;z=new Wu(u,r,e,l,p,c,j,h,f,y,t.overscaling,U),o&&(C=new Wu(u,r,e,l,p,c,o,m,v,y,t.overscaling,U));}if(i){var q=s.layout.get("icon-rotate").evaluate(b,{}),N="none"!==s.layout.get("icon-text-fit"),K=Gu(i,q,A,N),X=o?Gu(o,q,A,N):void 0;I=new Wu(u,r,e,l,p,c,i,m,v,!1,t.overscaling,q),E=4*K.length;var Z=t.iconSizeData,G=null;"source"===Z.kind?(G=[Fu*s.layout.get("icon-size").evaluate(b,{})])[0]>ll&&_(t.layerIds[0]+': Value for "icon-size" is >= '+ul+'. Reduce your "icon-size".'):"composite"===Z.kind&&((G=[Fu*w.compositeIconSizes[0].evaluate(b,{}),Fu*w.compositeIconSizes[1].evaluate(b,{})])[0]>ll||G[1]>ll)&&_(t.layerIds[0]+': Value for "icon-size" is >= '+ul+'. Reduce your "icon-size".'),t.addSymbols(t.icon,K,G,x,g,b,!1,e,T.lineStartIndex,T.lineLength,-1),V=t.icon.placedSymbolArray.length-1,X&&(M=4*X.length,t.addSymbols(t.icon,X,G,x,g,b,xu.vertical,e,T.lineStartIndex,T.lineLength,-1),F=t.icon.placedSymbolArray.length-1);}for(var J in n.horizontal){var Y=n.horizontal[J];if(!k){D=aa(Y.text);var H=s.layout.get("text-rotate").evaluate(b,{});k=new Wu(u,r,e,l,p,c,Y,h,f,y,t.overscaling,H);}var $=1===Y.positionedLines.length;if(B+=pl(t,e,Y,a,s,y,b,d,T,n.vertical?xu.horizontal:xu.horizontalOnly,$?Object.keys(n.horizontal):[J],L,V,w),$)break}n.vertical&&(P+=pl(t,e,n.vertical,a,s,y,b,d,T,xu.vertical,["vertical"],L,F,w));var W=k?k.boxStartIndex:t.collisionBoxArray.length,Q=k?k.boxEndIndex:t.collisionBoxArray.length,tt=z?z.boxStartIndex:t.collisionBoxArray.length,et=z?z.boxEndIndex:t.collisionBoxArray.length,rt=I?I.boxStartIndex:t.collisionBoxArray.length,nt=I?I.boxEndIndex:t.collisionBoxArray.length,it=C?C.boxStartIndex:t.collisionBoxArray.length,at=C?C.boxEndIndex:t.collisionBoxArray.length;t.glyphOffsetArray.length>=bl.MAX_GLYPHS&&_("Too many glyphs being rendered in a tile. See https://github.com/mapbox/mapbox-gl-js/issues/2907");void 0!==b.sortKey&&t.addToSortKeyRanges(t.symbolInstances.length,b.sortKey);t.symbolInstances.emplaceBack(e.x,e.y,L.right>=0?L.right:-1,L.center>=0?L.center:-1,L.left>=0?L.left:-1,L.vertical||-1,V,F,D,W,Q,tt,et,rt,nt,it,at,l,B,P,E,M,0,h,O,R);}(t,s,i,r,n,a,h,t.layers[0],t.collisionBoxArray,e.index,e.sourceLayerIndex,t.index,v,w,k,l,x,A,I,y,e,o,p);};if("line"===z)for(var M=0,B=function(t,e,r,n,a){for(var o=[],s=0;s<t.length;s++)for(var u=t[s],l=void 0,p=0;p<u.length-1;p++){var c=u[p],h=u[p+1];c.x<e&&h.x<e||(c.x<e?c=new i(e,c.y+(h.y-c.y)*((e-c.x)/(h.x-c.x)))._round():h.x<e&&(h=new i(e,c.y+(h.y-c.y)*((e-c.x)/(h.x-c.x)))._round()),c.y<r&&h.y<r||(c.y<r?c=new i(c.x+(h.x-c.x)*((r-c.y)/(h.y-c.y)),r)._round():h.y<r&&(h=new i(c.x+(h.x-c.x)*((r-c.y)/(h.y-c.y)),r)._round()),c.x>=n&&h.x>=n||(c.x>=n?c=new i(n,c.y+(h.y-c.y)*((n-c.x)/(h.x-c.x)))._round():h.x>=n&&(h=new i(n,c.y+(h.y-c.y)*((n-c.x)/(h.x-c.x)))._round()),c.y>=a&&h.y>=a||(c.y>=a?c=new i(c.x+(h.x-c.x)*((a-c.y)/(h.y-c.y)),a)._round():h.y>=a&&(h=new i(c.x+(h.x-c.x)*((a-c.y)/(h.y-c.y)),a)._round()),l&&c.equals(l[l.length-1])||(l=[c],o.push(l)),l.push(h)))));}return o}(e.geometry,0,0,Ma,Ma);M<B.length;M+=1)for(var P=B[M],V=Xu(P,b,S,r.vertical||d,n,24,g,t.overscaling,Ma),F=0,L=V;F<L.length;F+=1){var D=L[F],O=d;O&&hl(t,O.text,C,D)||E(P,D);}else if("line-center"===z)for(var R=0,U=e.geometry;R<U.length;R+=1){var j=U[R];if(j.length>1){var q=Ku(j,S,r.vertical||d,n,24,g);q&&E(j,q);}}else if("Polygon"===e.type)for(var N=0,K=$o(e.geometry,0);N<K.length;N+=1){var X=K[N],Z=el(X,16);E(X[0],new Vu(Z.x,Z.y,0));}else if("LineString"===e.type)for(var G=0,J=e.geometry;G<J.length;G+=1){var Y=J[G];E(Y,new Vu(Y[0].x,Y[0].y,0));}else if("Point"===e.type)for(var H=0,$=e.geometry;H<$.length;H+=1)for(var W=$[H],Q=0,tt=W;Q<tt.length;Q+=1){var et=tt[Q];E([et],new Vu(et.x,et.y,0));}}(t,o,f,R,n,p,c,h,d,U);},A=0,S=t.features;A<S.length;A+=1)w();o&&t.generateCollisionDebugBuffers();},t.perspective=function(t,e,r,n,i){var a,o=1/Math.tan(e/2);return t[0]=o/r,t[1]=0,t[2]=0,t[3]=0,t[4]=0,t[5]=o,t[6]=0,t[7]=0,t[8]=0,t[9]=0,t[11]=-1,t[12]=0,t[13]=0,t[15]=0,null!=i&&i!==1/0?(a=1/(n-i),t[10]=(i+n)*a,t[14]=2*i*n*a):(t[10]=-1,t[14]=-2*n),t},t.pick=function(t,e){for(var r={},n=0;n<e.length;n++){var i=e[n];i in t&&(r[i]=t[i]);}return r},t.plugin=Qn,t.polygonIntersectsPolygon=Da,t.postMapLoadEvent=it,t.postTurnstileEvent=rt,t.potpack=yu,t.refProperties=["type","source","source-layer","minzoom","maxzoom","filter","layout"],t.register=zn,t.registerForPluginStateChange=function(t){return t({pluginStatus:Zn,pluginURL:Gn}),Hn.on("pluginStateChange",t),t},t.rotate=function(t,e,r){var n=e[0],i=e[1],a=e[2],o=e[3],s=Math.sin(r),u=Math.cos(r);return t[0]=n*u+a*s,t[1]=i*u+o*s,t[2]=n*-s+a*u,t[3]=i*-s+o*u,t},t.rotateX=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),a=e[4],o=e[5],s=e[6],u=e[7],l=e[8],p=e[9],c=e[10],h=e[11];return e!==t&&(t[0]=e[0],t[1]=e[1],t[2]=e[2],t[3]=e[3],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[4]=a*i+l*n,t[5]=o*i+p*n,t[6]=s*i+c*n,t[7]=u*i+h*n,t[8]=l*i-a*n,t[9]=p*i-o*n,t[10]=c*i-s*n,t[11]=h*i-u*n,t},t.rotateZ=function(t,e,r){var n=Math.sin(r),i=Math.cos(r),a=e[0],o=e[1],s=e[2],u=e[3],l=e[4],p=e[5],c=e[6],h=e[7];return e!==t&&(t[8]=e[8],t[9]=e[9],t[10]=e[10],t[11]=e[11],t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15]),t[0]=a*i+l*n,t[1]=o*i+p*n,t[2]=s*i+c*n,t[3]=u*i+h*n,t[4]=l*i-a*n,t[5]=p*i-o*n,t[6]=c*i-s*n,t[7]=h*i-u*n,t},t.scale=function(t,e,r){var n=r[0],i=r[1],a=r[2];return t[0]=e[0]*n,t[1]=e[1]*n,t[2]=e[2]*n,t[3]=e[3]*n,t[4]=e[4]*i,t[5]=e[5]*i,t[6]=e[6]*i,t[7]=e[7]*i,t[8]=e[8]*a,t[9]=e[9]*a,t[10]=e[10]*a,t[11]=e[11]*a,t[12]=e[12],t[13]=e[13],t[14]=e[14],t[15]=e[15],t},t.scale$1=function(t,e,r){return t[0]=e[0]*r,t[1]=e[1]*r,t[2]=e[2]*r,t[3]=e[3]*r,t},t.scale$2=function(t,e,r){return t[0]=e[0]*r,t[1]=e[1]*r,t[2]=e[2]*r,t},t.setCacheLimits=function(t,e){ot=t,st=e;},t.setRTLTextPlugin=function(t,e,r){if(void 0===r&&(r=!1),Zn===qn||Zn===Nn||Zn===Kn)throw new Error("setRTLTextPlugin cannot be called multiple times.");Gn=L.resolveURL(t),Zn=qn,Xn=e,Yn(),r||Wn();},t.sphericalToCartesian=function(t){var e=t[0],r=t[1],n=t[2];return r+=90,r*=Math.PI/180,n*=Math.PI/180,{x:e*Math.cos(r)*Math.sin(n),y:e*Math.sin(r)*Math.sin(n),z:e*Math.cos(n)}},t.sqrLen=io,t.styleSpec=Bt,t.sub=ro,t.symbolSize=Ru,t.transformMat3=function(t,e,r){var n=e[0],i=e[1],a=e[2];return t[0]=n*r[0]+i*r[3]+a*r[6],t[1]=n*r[1]+i*r[4]+a*r[7],t[2]=n*r[2]+i*r[5]+a*r[8],t},t.transformMat4=no,t.translate=function(t,e,r){var n,i,a,o,s,u,l,p,c,h,f,y,d=r[0],m=r[1],v=r[2];return e===t?(t[12]=e[0]*d+e[4]*m+e[8]*v+e[12],t[13]=e[1]*d+e[5]*m+e[9]*v+e[13],t[14]=e[2]*d+e[6]*m+e[10]*v+e[14],t[15]=e[3]*d+e[7]*m+e[11]*v+e[15]):(n=e[0],i=e[1],a=e[2],o=e[3],s=e[4],u=e[5],l=e[6],p=e[7],c=e[8],h=e[9],f=e[10],y=e[11],t[0]=n,t[1]=i,t[2]=a,t[3]=o,t[4]=s,t[5]=u,t[6]=l,t[7]=p,t[8]=c,t[9]=h,t[10]=f,t[11]=y,t[12]=n*d+s*m+c*v+e[12],t[13]=i*d+u*m+h*v+e[13],t[14]=a*d+l*m+f*v+e[14],t[15]=o*d+p*m+y*v+e[15]),t},t.triggerPluginCompletionEvent=Jn,t.uniqueId=h,t.validateCustomStyleLayer=function(t){var e=[],r=t.id;return void 0===r&&e.push({message:"layers."+r+': missing required property "id"'}),void 0===t.render&&e.push({message:"layers."+r+': missing required method "render"'}),t.renderingMode&&"2d"!==t.renderingMode&&"3d"!==t.renderingMode&&e.push({message:"layers."+r+': property "renderingMode" must be either "2d" or "3d"'}),e},t.validateLight=vn,t.validateStyle=mn,t.values=function(t){var e=[];for(var r in t)e.push(t[r]);return e},t.vectorTile=ys,t.version="1.8.0",t.warnOnce=_,t.webpSupported=O,t.window=self,t.wrap=l;}));
	
	define(["./shared"],(function(e){"use strict";function t(e){var r=typeof e;if("number"===r||"boolean"===r||"string"===r||null==e)return JSON.stringify(e);if(Array.isArray(e)){for(var i="[",o=0,n=e;o<n.length;o+=1){i+=t(n[o])+",";}return i+"]"}for(var a=Object.keys(e).sort(),s="{",l=0;l<a.length;l++)s+=JSON.stringify(a[l])+":"+t(e[a[l]])+",";return s+"}"}function r(r){for(var i="",o=0,n=e.refProperties;o<n.length;o+=1){i+="/"+t(r[n[o]]);}return i}var i=function(e){this.keyCache={},e&&this.replace(e);};i.prototype.replace=function(e){this._layerConfigs={},this._layers={},this.update(e,[]);},i.prototype.update=function(t,i){for(var o=this,n=0,a=t;n<a.length;n+=1){var s=a[n];this._layerConfigs[s.id]=s;var l=this._layers[s.id]=e.createStyleLayer(s);l._featureFilter=e.featureFilter(l.filter),this.keyCache[s.id]&&delete this.keyCache[s.id];}for(var u=0,h=i;u<h.length;u+=1){var c=h[u];delete this.keyCache[c],delete this._layerConfigs[c],delete this._layers[c];}this.familiesBySource={};for(var p=0,f=function(e,t){for(var i={},o=0;o<e.length;o++){var n=t&&t[e[o].id]||r(e[o]);t&&(t[e[o].id]=n);var a=i[n];a||(a=i[n]=[]),a.push(e[o]);}var s=[];for(var l in i)s.push(i[l]);return s}(e.values(this._layerConfigs),this.keyCache);p<f.length;p+=1){var d=f[p].map((function(e){return o._layers[e.id]})),g=d[0];if("none"!==g.visibility){var m=g.source||"",v=this.familiesBySource[m];v||(v=this.familiesBySource[m]={});var y=g.sourceLayer||"_geojsonTileLayer",x=v[y];x||(x=v[y]=[]),x.push(d);}}};var o=function(t){var r={},i=[];for(var o in t){var n=t[o],a=r[o]={};for(var s in n){var l=n[+s];if(l&&0!==l.bitmap.width&&0!==l.bitmap.height){var u={x:0,y:0,w:l.bitmap.width+2,h:l.bitmap.height+2};i.push(u),a[s]={rect:u,metrics:l.metrics};}}}var h=e.potpack(i),c=h.w,p=h.h,f=new e.AlphaImage({width:c||1,height:p||1});for(var d in t){var g=t[d];for(var m in g){var v=g[+m];if(v&&0!==v.bitmap.width&&0!==v.bitmap.height){var y=r[d][m].rect;e.AlphaImage.copy(v.bitmap,f,{x:0,y:0},{x:y.x+1,y:y.y+1},v.bitmap);}}}this.image=f,this.positions=r;};e.register("GlyphAtlas",o);var n=function(t){this.tileID=new e.OverscaledTileID(t.tileID.overscaledZ,t.tileID.wrap,t.tileID.canonical.z,t.tileID.canonical.x,t.tileID.canonical.y),this.uid=t.uid,this.zoom=t.zoom,this.pixelRatio=t.pixelRatio,this.tileSize=t.tileSize,this.source=t.source,this.overscaling=this.tileID.overscaleFactor(),this.showCollisionBoxes=t.showCollisionBoxes,this.collectResourceTiming=!!t.collectResourceTiming,this.returnDependencies=!!t.returnDependencies,this.promoteId=t.promoteId;};function a(t,r,i){for(var o=new e.EvaluationParameters(r),n=0,a=t;n<a.length;n+=1){a[n].recalculate(o,i);}}function s(t,r){var i=e.getArrayBuffer(t.request,(function(t,i,o,n){t?r(t):i&&r(null,{vectorTile:new e.vectorTile.VectorTile(new e.pbf(i)),rawData:i,cacheControl:o,expires:n});}));return function(){i.cancel(),r();}}n.prototype.parse=function(t,r,i,n,s){var l=this;this.status="parsing",this.data=t,this.collisionBoxArray=new e.CollisionBoxArray;var u=new e.DictionaryCoder(Object.keys(t.layers).sort()),h=new e.FeatureIndex(this.tileID,this.promoteId);h.bucketLayerIDs=[];var c,p,f,d,g={},m={featureIndex:h,iconDependencies:{},patternDependencies:{},glyphDependencies:{},availableImages:i},v=r.familiesBySource[this.source];for(var y in v){var x=t.layers[y];if(x){1===x.version&&e.warnOnce('Vector tile source "'+this.source+'" layer "'+y+'" does not use vector tile spec v2 and therefore may have some rendering errors.');for(var w=u.encode(y),S=[],M=0;M<x.length;M++){var I=x.feature(M),b=h.getId(I,y);S.push({feature:I,id:b,index:M,sourceLayerIndex:w});}for(var P=0,_=v[y];P<_.length;P+=1){var k=_[P],T=k[0];if(!(T.minzoom&&this.zoom<Math.floor(T.minzoom)))if(!(T.maxzoom&&this.zoom>=T.maxzoom))if("none"!==T.visibility)a(k,this.zoom,i),(g[T.id]=T.createBucket({index:h.bucketLayerIDs.length,layers:k,zoom:this.zoom,pixelRatio:this.pixelRatio,overscaling:this.overscaling,collisionBoxArray:this.collisionBoxArray,sourceLayerIndex:w,sourceID:this.source})).populate(S,m),h.bucketLayerIDs.push(k.map((function(e){return e.id})));}}}var C=e.mapObject(m.glyphDependencies,(function(e){return Object.keys(e).map(Number)}));Object.keys(C).length?n.send("getGlyphs",{uid:this.uid,stacks:C},(function(e,t){c||(c=e,p=t,O.call(l));})):p={};var D=Object.keys(m.iconDependencies);D.length?n.send("getImages",{icons:D,source:this.source,tileID:this.tileID,type:"icons"},(function(e,t){c||(c=e,f=t,O.call(l));})):f={};var L=Object.keys(m.patternDependencies);function O(){if(c)return s(c);if(p&&f&&d){var t=new o(p),r=new e.ImageAtlas(f,d);for(var n in g){var l=g[n];l instanceof e.SymbolBucket?(a(l.layers,this.zoom,i),e.performSymbolLayout(l,p,t.positions,f,r.iconPositions,this.showCollisionBoxes)):l.hasPattern&&(l instanceof e.LineBucket||l instanceof e.FillBucket||l instanceof e.FillExtrusionBucket)&&(a(l.layers,this.zoom,i),l.addFeatures(m,r.patternPositions));}this.status="done",s(null,{buckets:e.values(g).filter((function(e){return !e.isEmpty()})),featureIndex:h,collisionBoxArray:this.collisionBoxArray,glyphAtlasImage:t.image,imageAtlas:r,glyphMap:this.returnDependencies?p:null,iconMap:this.returnDependencies?f:null,glyphPositions:this.returnDependencies?t.positions:null});}}L.length?n.send("getImages",{icons:L,source:this.source,tileID:this.tileID,type:"patterns"},(function(e,t){c||(c=e,d=t,O.call(l));})):d={},O.call(this);};var l=function(e,t,r,i){this.actor=e,this.layerIndex=t,this.availableImages=r,this.loadVectorData=i||s,this.loading={},this.loaded={};};l.prototype.loadTile=function(t,r){var i=this,o=t.uid;this.loading||(this.loading={});var a=!!(t&&t.request&&t.request.collectResourceTiming)&&new e.RequestPerformance(t.request),s=this.loading[o]=new n(t);s.abort=this.loadVectorData(t,(function(t,n){if(delete i.loading[o],t||!n)return s.status="done",i.loaded[o]=s,r(t);var l=n.rawData,u={};n.expires&&(u.expires=n.expires),n.cacheControl&&(u.cacheControl=n.cacheControl);var h={};if(a){var c=a.finish();c&&(h.resourceTiming=JSON.parse(JSON.stringify(c)));}s.vectorTile=n.vectorTile,s.parse(n.vectorTile,i.layerIndex,i.availableImages,i.actor,(function(t,i){if(t||!i)return r(t);r(null,e.extend({rawTileData:l.slice(0)},i,u,h));})),i.loaded=i.loaded||{},i.loaded[o]=s;}));},l.prototype.reloadTile=function(e,t){var r=this,i=this.loaded,o=e.uid,n=this;if(i&&i[o]){var a=i[o];a.showCollisionBoxes=e.showCollisionBoxes;var s=function(e,i){var o=a.reloadCallback;o&&(delete a.reloadCallback,a.parse(a.vectorTile,n.layerIndex,r.availableImages,n.actor,o)),t(e,i);};"parsing"===a.status?a.reloadCallback=s:"done"===a.status&&(a.vectorTile?a.parse(a.vectorTile,this.layerIndex,this.availableImages,this.actor,s):s());}},l.prototype.abortTile=function(e,t){var r=this.loading,i=e.uid;r&&r[i]&&r[i].abort&&(r[i].abort(),delete r[i]),t();},l.prototype.removeTile=function(e,t){var r=this.loaded,i=e.uid;r&&r[i]&&delete r[i],t();};var u=e.window.ImageBitmap,h=function(){this.loaded={};};h.prototype.loadTile=function(t,r){var i=t.uid,o=t.encoding,n=t.rawImageData,a=u&&n instanceof u?this.getImageData(n):n,s=new e.DEMData(i,a,o);this.loaded=this.loaded||{},this.loaded[i]=s,r(null,s);},h.prototype.getImageData=function(t){this.offscreenCanvas&&this.offscreenCanvasContext||(this.offscreenCanvas=new OffscreenCanvas(t.width,t.height),this.offscreenCanvasContext=this.offscreenCanvas.getContext("2d")),this.offscreenCanvas.width=t.width,this.offscreenCanvas.height=t.height,this.offscreenCanvasContext.drawImage(t,0,0,t.width,t.height);var r=this.offscreenCanvasContext.getImageData(-1,-1,t.width+2,t.height+2);return this.offscreenCanvasContext.clearRect(0,0,this.offscreenCanvas.width,this.offscreenCanvas.height),new e.RGBAImage({width:r.width,height:r.height},r.data)},h.prototype.removeTile=function(e){var t=this.loaded,r=e.uid;t&&t[r]&&delete t[r];};var c={RADIUS:6378137,FLATTENING:1/298.257223563,POLAR_RADIUS:6356752.3142};function p(e){var t=0;if(e&&e.length>0){t+=Math.abs(f(e[0]));for(var r=1;r<e.length;r++)t-=Math.abs(f(e[r]));}return t}function f(e){var t,r,i,o,n,a,s=0,l=e.length;if(l>2){for(a=0;a<l;a++)a===l-2?(i=l-2,o=l-1,n=0):a===l-1?(i=l-1,o=0,n=1):(i=a,o=a+1,n=a+2),t=e[i],r=e[o],s+=(d(e[n][0])-d(t[0]))*Math.sin(d(r[1]));s=s*c.RADIUS*c.RADIUS/2;}return s}function d(e){return e*Math.PI/180}var g={geometry:function e(t){var r,i=0;switch(t.type){case"Polygon":return p(t.coordinates);case"MultiPolygon":for(r=0;r<t.coordinates.length;r++)i+=p(t.coordinates[r]);return i;case"Point":case"MultiPoint":case"LineString":case"MultiLineString":return 0;case"GeometryCollection":for(r=0;r<t.geometries.length;r++)i+=e(t.geometries[r]);return i}},ring:f},m=function e(t,r){switch(t&&t.type||null){case"FeatureCollection":return t.features=t.features.map(v(e,r)),t;case"GeometryCollection":return t.geometries=t.geometries.map(v(e,r)),t;case"Feature":return t.geometry=e(t.geometry,r),t;case"Polygon":case"MultiPolygon":return function(e,t){"Polygon"===e.type?e.coordinates=y(e.coordinates,t):"MultiPolygon"===e.type&&(e.coordinates=e.coordinates.map(v(y,t)));return e}(t,r);default:return t}};function v(e,t){return function(r){return e(r,t)}}function y(e,t){t=!!t,e[0]=x(e[0],t);for(var r=1;r<e.length;r++)e[r]=x(e[r],!t);return e}function x(e,t){return function(e){return g.ring(e)>=0}(e)===t?e:e.reverse()}var w=e.vectorTile.VectorTileFeature.prototype.toGeoJSON,S=function(t){this._feature=t,this.extent=e.EXTENT,this.type=t.type,this.properties=t.tags,"id"in t&&!isNaN(t.id)&&(this.id=parseInt(t.id,10));};S.prototype.loadGeometry=function(){if(1===this._feature.type){for(var t=[],r=0,i=this._feature.geometry;r<i.length;r+=1){var o=i[r];t.push([new e.Point$1(o[0],o[1])]);}return t}for(var n=[],a=0,s=this._feature.geometry;a<s.length;a+=1){for(var l=[],u=0,h=s[a];u<h.length;u+=1){var c=h[u];l.push(new e.Point$1(c[0],c[1]));}n.push(l);}return n},S.prototype.toGeoJSON=function(e,t,r){return w.call(this,e,t,r)};var M=function(t){this.layers={_geojsonTileLayer:this},this.name="_geojsonTileLayer",this.extent=e.EXTENT,this.length=t.length,this._features=t;};M.prototype.feature=function(e){return new S(this._features[e])};var I=e.vectorTile.VectorTileFeature,b=P;function P(e,t){this.options=t||{},this.features=e,this.length=e.length;}function _(e,t){this.id="number"==typeof e.id?e.id:void 0,this.type=e.type,this.rawGeometry=1===e.type?[e.geometry]:e.geometry,this.properties=e.tags,this.extent=t||4096;}P.prototype.feature=function(e){return new _(this.features[e],this.options.extent)},_.prototype.loadGeometry=function(){var t=this.rawGeometry;this.geometry=[];for(var r=0;r<t.length;r++){for(var i=t[r],o=[],n=0;n<i.length;n++)o.push(new e.Point$1(i[n][0],i[n][1]));this.geometry.push(o);}return this.geometry},_.prototype.bbox=function(){this.geometry||this.loadGeometry();for(var e=this.geometry,t=1/0,r=-1/0,i=1/0,o=-1/0,n=0;n<e.length;n++)for(var a=e[n],s=0;s<a.length;s++){var l=a[s];t=Math.min(t,l.x),r=Math.max(r,l.x),i=Math.min(i,l.y),o=Math.max(o,l.y);}return [t,i,r,o]},_.prototype.toGeoJSON=I.prototype.toGeoJSON;var k=L,T=L,C=function(e,t){t=t||{};var r={};for(var i in e)r[i]=new b(e[i].features,t),r[i].name=i,r[i].version=t.version,r[i].extent=t.extent;return L({layers:r})},D=b;function L(t){var r=new e.pbf;return function(e,t){for(var r in e.layers)t.writeMessage(3,O,e.layers[r]);}(t,r),r.finish()}function O(e,t){var r;t.writeVarintField(15,e.version||1),t.writeStringField(1,e.name||""),t.writeVarintField(5,e.extent||4096);var i={keys:[],values:[],keycache:{},valuecache:{}};for(r=0;r<e.length;r++)i.feature=e.feature(r),t.writeMessage(2,z,i);var o=i.keys;for(r=0;r<o.length;r++)t.writeStringField(3,o[r]);var n=i.values;for(r=0;r<n.length;r++)t.writeMessage(4,J,n[r]);}function z(e,t){var r=e.feature;void 0!==r.id&&t.writeVarintField(1,r.id),t.writeMessage(2,E,e),t.writeVarintField(3,r.type),t.writeMessage(4,A,r);}function E(e,t){var r=e.feature,i=e.keys,o=e.values,n=e.keycache,a=e.valuecache;for(var s in r.properties){var l=n[s];void 0===l&&(i.push(s),l=i.length-1,n[s]=l),t.writeVarint(l);var u=r.properties[s],h=typeof u;"string"!==h&&"boolean"!==h&&"number"!==h&&(u=JSON.stringify(u));var c=h+":"+u,p=a[c];void 0===p&&(o.push(u),p=o.length-1,a[c]=p),t.writeVarint(p);}}function N(e,t){return (t<<3)+(7&e)}function F(e){return e<<1^e>>31}function A(e,t){for(var r=e.loadGeometry(),i=e.type,o=0,n=0,a=r.length,s=0;s<a;s++){var l=r[s],u=1;1===i&&(u=l.length),t.writeVarint(N(1,u));for(var h=3===i?l.length-1:l.length,c=0;c<h;c++){1===c&&1!==i&&t.writeVarint(N(2,h-1));var p=l[c].x-o,f=l[c].y-n;t.writeVarint(F(p)),t.writeVarint(F(f)),o+=p,n+=f;}3===i&&t.writeVarint(N(7,1));}}function J(e,t){var r=typeof e;"string"===r?t.writeStringField(1,e):"boolean"===r?t.writeBooleanField(7,e):"number"===r&&(e%1!=0?t.writeDoubleField(3,e):e<0?t.writeSVarintField(6,e):t.writeVarintField(5,e));}function Z(e,t,r,i,o,n){if(!(o-i<=r)){var a=i+o>>1;!function e(t,r,i,o,n,a){for(;n>o;){if(n-o>600){var s=n-o+1,l=i-o+1,u=Math.log(s),h=.5*Math.exp(2*u/3),c=.5*Math.sqrt(u*h*(s-h)/s)*(l-s/2<0?-1:1),p=Math.max(o,Math.floor(i-l*h/s+c)),f=Math.min(n,Math.floor(i+(s-l)*h/s+c));e(t,r,i,p,f,a);}var d=r[2*i+a],g=o,m=n;for(B(t,r,o,i),r[2*n+a]>d&&B(t,r,o,n);g<m;){for(B(t,r,g,m),g++,m--;r[2*g+a]<d;)g++;for(;r[2*m+a]>d;)m--;}r[2*o+a]===d?B(t,r,o,m):B(t,r,++m,n),m<=i&&(o=m+1),i<=m&&(n=m-1);}}(e,t,a,i,o,n%2),Z(e,t,r,i,a-1,n+1),Z(e,t,r,a+1,o,n+1);}}function B(e,t,r,i){G(e,r,i),G(t,2*r,2*i),G(t,2*r+1,2*i+1);}function G(e,t,r){var i=e[t];e[t]=e[r],e[r]=i;}function Y(e,t,r,i){var o=e-r,n=t-i;return o*o+n*n}k.fromVectorTileJs=T,k.fromGeojsonVt=C,k.GeoJSONWrapper=D;var R=function(e){return e[0]},j=function(e){return e[1]},V=function(e,t,r,i,o){void 0===t&&(t=R),void 0===r&&(r=j),void 0===i&&(i=64),void 0===o&&(o=Float64Array),this.nodeSize=i,this.points=e;for(var n=e.length<65536?Uint16Array:Uint32Array,a=this.ids=new n(e.length),s=this.coords=new o(2*e.length),l=0;l<e.length;l++)a[l]=l,s[2*l]=t(e[l]),s[2*l+1]=r(e[l]);Z(a,s,i,0,a.length-1,0);};V.prototype.range=function(e,t,r,i){return function(e,t,r,i,o,n,a){for(var s,l,u=[0,e.length-1,0],h=[];u.length;){var c=u.pop(),p=u.pop(),f=u.pop();if(p-f<=a)for(var d=f;d<=p;d++)s=t[2*d],l=t[2*d+1],s>=r&&s<=o&&l>=i&&l<=n&&h.push(e[d]);else{var g=Math.floor((f+p)/2);s=t[2*g],l=t[2*g+1],s>=r&&s<=o&&l>=i&&l<=n&&h.push(e[g]);var m=(c+1)%2;(0===c?r<=s:i<=l)&&(u.push(f),u.push(g-1),u.push(m)),(0===c?o>=s:n>=l)&&(u.push(g+1),u.push(p),u.push(m));}}return h}(this.ids,this.coords,e,t,r,i,this.nodeSize)},V.prototype.within=function(e,t,r){return function(e,t,r,i,o,n){for(var a=[0,e.length-1,0],s=[],l=o*o;a.length;){var u=a.pop(),h=a.pop(),c=a.pop();if(h-c<=n)for(var p=c;p<=h;p++)Y(t[2*p],t[2*p+1],r,i)<=l&&s.push(e[p]);else{var f=Math.floor((c+h)/2),d=t[2*f],g=t[2*f+1];Y(d,g,r,i)<=l&&s.push(e[f]);var m=(u+1)%2;(0===u?r-o<=d:i-o<=g)&&(a.push(c),a.push(f-1),a.push(m)),(0===u?r+o>=d:i+o>=g)&&(a.push(f+1),a.push(h),a.push(m));}}return s}(this.ids,this.coords,e,t,r,this.nodeSize)};var X={minZoom:0,maxZoom:16,radius:40,extent:512,nodeSize:64,log:!1,generateId:!1,reduce:null,map:function(e){return e}},W=function(e){this.options=ee(Object.create(X),e),this.trees=new Array(this.options.maxZoom+1);};function q(e,t,r,i,o){return {x:e,y:t,zoom:1/0,id:r,parentId:-1,numPoints:i,properties:o}}function U(e,t){var r=e.geometry.coordinates,i=r[0],o=r[1];return {x:K(i),y:Q(o),zoom:1/0,index:t,parentId:-1}}function $(e){return {type:"Feature",id:e.id,properties:H(e),geometry:{type:"Point",coordinates:[(i=e.x,360*(i-.5)),(t=e.y,r=(180-360*t)*Math.PI/180,360*Math.atan(Math.exp(r))/Math.PI-90)]}};var t,r,i;}function H(e){var t=e.numPoints,r=t>=1e4?Math.round(t/1e3)+"k":t>=1e3?Math.round(t/100)/10+"k":t;return ee(ee({},e.properties),{cluster:!0,cluster_id:e.id,point_count:t,point_count_abbreviated:r})}function K(e){return e/360+.5}function Q(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function ee(e,t){for(var r in t)e[r]=t[r];return e}function te(e){return e.x}function re(e){return e.y}function ie(e,t,r,i,o,n){var a=o-r,s=n-i;if(0!==a||0!==s){var l=((e-r)*a+(t-i)*s)/(a*a+s*s);l>1?(r=o,i=n):l>0&&(r+=a*l,i+=s*l);}return (a=e-r)*a+(s=t-i)*s}function oe(e,t,r,i){var o={id:void 0===e?null:e,type:t,geometry:r,tags:i,minX:1/0,minY:1/0,maxX:-1/0,maxY:-1/0};return function(e){var t=e.geometry,r=e.type;if("Point"===r||"MultiPoint"===r||"LineString"===r)ne(e,t);else if("Polygon"===r||"MultiLineString"===r)for(var i=0;i<t.length;i++)ne(e,t[i]);else if("MultiPolygon"===r)for(i=0;i<t.length;i++)for(var o=0;o<t[i].length;o++)ne(e,t[i][o]);}(o),o}function ne(e,t){for(var r=0;r<t.length;r+=3)e.minX=Math.min(e.minX,t[r]),e.minY=Math.min(e.minY,t[r+1]),e.maxX=Math.max(e.maxX,t[r]),e.maxY=Math.max(e.maxY,t[r+1]);}function ae(e,t,r,i){if(t.geometry){var o=t.geometry.coordinates,n=t.geometry.type,a=Math.pow(r.tolerance/((1<<r.maxZoom)*r.extent),2),s=[],l=t.id;if(r.promoteId?l=t.properties[r.promoteId]:r.generateId&&(l=i||0),"Point"===n)se(o,s);else if("MultiPoint"===n)for(var u=0;u<o.length;u++)se(o[u],s);else if("LineString"===n)le(o,s,a,!1);else if("MultiLineString"===n){if(r.lineMetrics){for(u=0;u<o.length;u++)s=[],le(o[u],s,a,!1),e.push(oe(l,"LineString",s,t.properties));return}ue(o,s,a,!1);}else if("Polygon"===n)ue(o,s,a,!0);else{if("MultiPolygon"!==n){if("GeometryCollection"===n){for(u=0;u<t.geometry.geometries.length;u++)ae(e,{id:l,geometry:t.geometry.geometries[u],properties:t.properties},r,i);return}throw new Error("Input data is not a valid GeoJSON object.")}for(u=0;u<o.length;u++){var h=[];ue(o[u],h,a,!0),s.push(h);}}e.push(oe(l,n,s,t.properties));}}function se(e,t){t.push(he(e[0])),t.push(ce(e[1])),t.push(0);}function le(e,t,r,i){for(var o,n,a=0,s=0;s<e.length;s++){var l=he(e[s][0]),u=ce(e[s][1]);t.push(l),t.push(u),t.push(0),s>0&&(a+=i?(o*u-l*n)/2:Math.sqrt(Math.pow(l-o,2)+Math.pow(u-n,2))),o=l,n=u;}var h=t.length-3;t[2]=1,function e(t,r,i,o){for(var n,a=o,s=i-r>>1,l=i-r,u=t[r],h=t[r+1],c=t[i],p=t[i+1],f=r+3;f<i;f+=3){var d=ie(t[f],t[f+1],u,h,c,p);if(d>a)n=f,a=d;else if(d===a){var g=Math.abs(f-s);g<l&&(n=f,l=g);}}a>o&&(n-r>3&&e(t,r,n,o),t[n+2]=a,i-n>3&&e(t,n,i,o));}(t,0,h,r),t[h+2]=1,t.size=Math.abs(a),t.start=0,t.end=t.size;}function ue(e,t,r,i){for(var o=0;o<e.length;o++){var n=[];le(e[o],n,r,i),t.push(n);}}function he(e){return e/360+.5}function ce(e){var t=Math.sin(e*Math.PI/180),r=.5-.25*Math.log((1+t)/(1-t))/Math.PI;return r<0?0:r>1?1:r}function pe(e,t,r,i,o,n,a,s){if(i/=t,n>=(r/=t)&&a<i)return e;if(a<r||n>=i)return null;for(var l=[],u=0;u<e.length;u++){var h=e[u],c=h.geometry,p=h.type,f=0===o?h.minX:h.minY,d=0===o?h.maxX:h.maxY;if(f>=r&&d<i)l.push(h);else if(!(d<r||f>=i)){var g=[];if("Point"===p||"MultiPoint"===p)fe(c,g,r,i,o);else if("LineString"===p)de(c,g,r,i,o,!1,s.lineMetrics);else if("MultiLineString"===p)me(c,g,r,i,o,!1);else if("Polygon"===p)me(c,g,r,i,o,!0);else if("MultiPolygon"===p)for(var m=0;m<c.length;m++){var v=[];me(c[m],v,r,i,o,!0),v.length&&g.push(v);}if(g.length){if(s.lineMetrics&&"LineString"===p){for(m=0;m<g.length;m++)l.push(oe(h.id,p,g[m],h.tags));continue}"LineString"!==p&&"MultiLineString"!==p||(1===g.length?(p="LineString",g=g[0]):p="MultiLineString"),"Point"!==p&&"MultiPoint"!==p||(p=3===g.length?"Point":"MultiPoint"),l.push(oe(h.id,p,g,h.tags));}}}return l.length?l:null}function fe(e,t,r,i,o){for(var n=0;n<e.length;n+=3){var a=e[n+o];a>=r&&a<=i&&(t.push(e[n]),t.push(e[n+1]),t.push(e[n+2]));}}function de(e,t,r,i,o,n,a){for(var s,l,u=ge(e),h=0===o?ye:xe,c=e.start,p=0;p<e.length-3;p+=3){var f=e[p],d=e[p+1],g=e[p+2],m=e[p+3],v=e[p+4],y=0===o?f:d,x=0===o?m:v,w=!1;a&&(s=Math.sqrt(Math.pow(f-m,2)+Math.pow(d-v,2))),y<r?x>r&&(l=h(u,f,d,m,v,r),a&&(u.start=c+s*l)):y>i?x<i&&(l=h(u,f,d,m,v,i),a&&(u.start=c+s*l)):ve(u,f,d,g),x<r&&y>=r&&(l=h(u,f,d,m,v,r),w=!0),x>i&&y<=i&&(l=h(u,f,d,m,v,i),w=!0),!n&&w&&(a&&(u.end=c+s*l),t.push(u),u=ge(e)),a&&(c+=s);}var S=e.length-3;f=e[S],d=e[S+1],g=e[S+2],(y=0===o?f:d)>=r&&y<=i&&ve(u,f,d,g),S=u.length-3,n&&S>=3&&(u[S]!==u[0]||u[S+1]!==u[1])&&ve(u,u[0],u[1],u[2]),u.length&&t.push(u);}function ge(e){var t=[];return t.size=e.size,t.start=e.start,t.end=e.end,t}function me(e,t,r,i,o,n){for(var a=0;a<e.length;a++)de(e[a],t,r,i,o,n,!1);}function ve(e,t,r,i){e.push(t),e.push(r),e.push(i);}function ye(e,t,r,i,o,n){var a=(n-t)/(i-t);return e.push(n),e.push(r+(o-r)*a),e.push(1),a}function xe(e,t,r,i,o,n){var a=(n-r)/(o-r);return e.push(t+(i-t)*a),e.push(n),e.push(1),a}function we(e,t){for(var r=[],i=0;i<e.length;i++){var o,n=e[i],a=n.type;if("Point"===a||"MultiPoint"===a||"LineString"===a)o=Se(n.geometry,t);else if("MultiLineString"===a||"Polygon"===a){o=[];for(var s=0;s<n.geometry.length;s++)o.push(Se(n.geometry[s],t));}else if("MultiPolygon"===a)for(o=[],s=0;s<n.geometry.length;s++){for(var l=[],u=0;u<n.geometry[s].length;u++)l.push(Se(n.geometry[s][u],t));o.push(l);}r.push(oe(n.id,a,o,n.tags));}return r}function Se(e,t){var r=[];r.size=e.size,void 0!==e.start&&(r.start=e.start,r.end=e.end);for(var i=0;i<e.length;i+=3)r.push(e[i]+t,e[i+1],e[i+2]);return r}function Me(e,t){if(e.transformed)return e;var r,i,o,n=1<<e.z,a=e.x,s=e.y;for(r=0;r<e.features.length;r++){var l=e.features[r],u=l.geometry,h=l.type;if(l.geometry=[],1===h)for(i=0;i<u.length;i+=2)l.geometry.push(Ie(u[i],u[i+1],t,n,a,s));else for(i=0;i<u.length;i++){var c=[];for(o=0;o<u[i].length;o+=2)c.push(Ie(u[i][o],u[i][o+1],t,n,a,s));l.geometry.push(c);}}return e.transformed=!0,e}function Ie(e,t,r,i,o,n){return [Math.round(r*(e*i-o)),Math.round(r*(t*i-n))]}function be(e,t,r,i,o){for(var n=t===o.maxZoom?0:o.tolerance/((1<<t)*o.extent),a={features:[],numPoints:0,numSimplified:0,numFeatures:0,source:null,x:r,y:i,z:t,transformed:!1,minX:2,minY:1,maxX:-1,maxY:0},s=0;s<e.length;s++){a.numFeatures++,Pe(a,e[s],n,o);var l=e[s].minX,u=e[s].minY,h=e[s].maxX,c=e[s].maxY;l<a.minX&&(a.minX=l),u<a.minY&&(a.minY=u),h>a.maxX&&(a.maxX=h),c>a.maxY&&(a.maxY=c);}return a}function Pe(e,t,r,i){var o=t.geometry,n=t.type,a=[];if("Point"===n||"MultiPoint"===n)for(var s=0;s<o.length;s+=3)a.push(o[s]),a.push(o[s+1]),e.numPoints++,e.numSimplified++;else if("LineString"===n)_e(a,o,e,r,!1,!1);else if("MultiLineString"===n||"Polygon"===n)for(s=0;s<o.length;s++)_e(a,o[s],e,r,"Polygon"===n,0===s);else if("MultiPolygon"===n)for(var l=0;l<o.length;l++){var u=o[l];for(s=0;s<u.length;s++)_e(a,u[s],e,r,!0,0===s);}if(a.length){var h=t.tags||null;if("LineString"===n&&i.lineMetrics){for(var c in h={},t.tags)h[c]=t.tags[c];h.mapbox_clip_start=o.start/o.size,h.mapbox_clip_end=o.end/o.size;}var p={geometry:a,type:"Polygon"===n||"MultiPolygon"===n?3:"LineString"===n||"MultiLineString"===n?2:1,tags:h};null!==t.id&&(p.id=t.id),e.features.push(p);}}function _e(e,t,r,i,o,n){var a=i*i;if(i>0&&t.size<(o?a:i))r.numPoints+=t.length/3;else{for(var s=[],l=0;l<t.length;l+=3)(0===i||t[l+2]>a)&&(r.numSimplified++,s.push(t[l]),s.push(t[l+1])),r.numPoints++;o&&function(e,t){for(var r=0,i=0,o=e.length,n=o-2;i<o;n=i,i+=2)r+=(e[i]-e[n])*(e[i+1]+e[n+1]);if(r>0===t)for(i=0,o=e.length;i<o/2;i+=2){var a=e[i],s=e[i+1];e[i]=e[o-2-i],e[i+1]=e[o-1-i],e[o-2-i]=a,e[o-1-i]=s;}}(s,n),e.push(s);}}function ke(e,t){var r=(t=this.options=function(e,t){for(var r in t)e[r]=t[r];return e}(Object.create(this.options),t)).debug;if(r&&console.time("preprocess data"),t.maxZoom<0||t.maxZoom>24)throw new Error("maxZoom should be in the 0-24 range");if(t.promoteId&&t.generateId)throw new Error("promoteId and generateId cannot be used together.");var i=function(e,t){var r=[];if("FeatureCollection"===e.type)for(var i=0;i<e.features.length;i++)ae(r,e.features[i],t,i);else"Feature"===e.type?ae(r,e,t):ae(r,{geometry:e},t);return r}(e,t);this.tiles={},this.tileCoords=[],r&&(console.timeEnd("preprocess data"),console.log("index: maxZoom: %d, maxPoints: %d",t.indexMaxZoom,t.indexMaxPoints),console.time("generate tiles"),this.stats={},this.total=0),(i=function(e,t){var r=t.buffer/t.extent,i=e,o=pe(e,1,-1-r,r,0,-1,2,t),n=pe(e,1,1-r,2+r,0,-1,2,t);return (o||n)&&(i=pe(e,1,-r,1+r,0,-1,2,t)||[],o&&(i=we(o,1).concat(i)),n&&(i=i.concat(we(n,-1)))),i}(i,t)).length&&this.splitTile(i,0,0,0),r&&(i.length&&console.log("features: %d, points: %d",this.tiles[0].numFeatures,this.tiles[0].numPoints),console.timeEnd("generate tiles"),console.log("tiles generated:",this.total,JSON.stringify(this.stats)));}function Te(e,t,r){return 32*((1<<e)*r+t)+e}function Ce(e,t){var r=e.tileID.canonical;if(!this._geoJSONIndex)return t(null,null);var i=this._geoJSONIndex.getTile(r.z,r.x,r.y);if(!i)return t(null,null);var o=new M(i.features),n=k(o);0===n.byteOffset&&n.byteLength===n.buffer.byteLength||(n=new Uint8Array(n)),t(null,{vectorTile:o,rawData:n.buffer});}W.prototype.load=function(e){var t=this.options,r=t.log,i=t.minZoom,o=t.maxZoom,n=t.nodeSize;r&&console.time("total time");var a="prepare "+e.length+" points";r&&console.time(a),this.points=e;for(var s=[],l=0;l<e.length;l++)e[l].geometry&&s.push(U(e[l],l));this.trees[o+1]=new V(s,te,re,n,Float32Array),r&&console.timeEnd(a);for(var u=o;u>=i;u--){var h=+Date.now();s=this._cluster(s,u),this.trees[u]=new V(s,te,re,n,Float32Array),r&&console.log("z%d: %d clusters in %dms",u,s.length,+Date.now()-h);}return r&&console.timeEnd("total time"),this},W.prototype.getClusters=function(e,t){var r=((e[0]+180)%360+360)%360-180,i=Math.max(-90,Math.min(90,e[1])),o=180===e[2]?180:((e[2]+180)%360+360)%360-180,n=Math.max(-90,Math.min(90,e[3]));if(e[2]-e[0]>=360)r=-180,o=180;else if(r>o){var a=this.getClusters([r,i,180,n],t),s=this.getClusters([-180,i,o,n],t);return a.concat(s)}for(var l=this.trees[this._limitZoom(t)],u=[],h=0,c=l.range(K(r),Q(n),K(o),Q(i));h<c.length;h+=1){var p=c[h],f=l.points[p];u.push(f.numPoints?$(f):this.points[f.index]);}return u},W.prototype.getChildren=function(e){var t=this._getOriginId(e),r=this._getOriginZoom(e),i="No cluster with the specified id.",o=this.trees[r];if(!o)throw new Error(i);var n=o.points[t];if(!n)throw new Error(i);for(var a=this.options.radius/(this.options.extent*Math.pow(2,r-1)),s=[],l=0,u=o.within(n.x,n.y,a);l<u.length;l+=1){var h=u[l],c=o.points[h];c.parentId===e&&s.push(c.numPoints?$(c):this.points[c.index]);}if(0===s.length)throw new Error(i);return s},W.prototype.getLeaves=function(e,t,r){t=t||10,r=r||0;var i=[];return this._appendLeaves(i,e,t,r,0),i},W.prototype.getTile=function(e,t,r){var i=this.trees[this._limitZoom(e)],o=Math.pow(2,e),n=this.options,a=n.extent,s=n.radius/a,l=(r-s)/o,u=(r+1+s)/o,h={features:[]};return this._addTileFeatures(i.range((t-s)/o,l,(t+1+s)/o,u),i.points,t,r,o,h),0===t&&this._addTileFeatures(i.range(1-s/o,l,1,u),i.points,o,r,o,h),t===o-1&&this._addTileFeatures(i.range(0,l,s/o,u),i.points,-1,r,o,h),h.features.length?h:null},W.prototype.getClusterExpansionZoom=function(e){for(var t=this._getOriginZoom(e)-1;t<=this.options.maxZoom;){var r=this.getChildren(e);if(t++,1!==r.length)break;e=r[0].properties.cluster_id;}return t},W.prototype._appendLeaves=function(e,t,r,i,o){for(var n=0,a=this.getChildren(t);n<a.length;n+=1){var s=a[n],l=s.properties;if(l&&l.cluster?o+l.point_count<=i?o+=l.point_count:o=this._appendLeaves(e,l.cluster_id,r,i,o):o<i?o++:e.push(s),e.length===r)break}return o},W.prototype._addTileFeatures=function(e,t,r,i,o,n){for(var a=0,s=e;a<s.length;a+=1){var l=t[s[a]],u=l.numPoints,h={type:1,geometry:[[Math.round(this.options.extent*(l.x*o-r)),Math.round(this.options.extent*(l.y*o-i))]],tags:u?H(l):this.points[l.index].properties},c=void 0;u?c=l.id:this.options.generateId?c=l.index:this.points[l.index].id&&(c=this.points[l.index].id),void 0!==c&&(h.id=c),n.features.push(h);}},W.prototype._limitZoom=function(e){return Math.max(this.options.minZoom,Math.min(e,this.options.maxZoom+1))},W.prototype._cluster=function(e,t){for(var r=[],i=this.options,o=i.radius,n=i.extent,a=i.reduce,s=o/(n*Math.pow(2,t)),l=0;l<e.length;l++){var u=e[l];if(!(u.zoom<=t)){u.zoom=t;for(var h=this.trees[t+1],c=h.within(u.x,u.y,s),p=u.numPoints||1,f=u.x*p,d=u.y*p,g=a&&p>1?this._map(u,!0):null,m=(l<<5)+(t+1)+this.points.length,v=0,y=c;v<y.length;v+=1){var x=y[v],w=h.points[x];if(!(w.zoom<=t)){w.zoom=t;var S=w.numPoints||1;f+=w.x*S,d+=w.y*S,p+=S,w.parentId=m,a&&(g||(g=this._map(u,!0)),a(g,this._map(w)));}}1===p?r.push(u):(u.parentId=m,r.push(q(f/p,d/p,m,p,g)));}}return r},W.prototype._getOriginId=function(e){return e-this.points.length>>5},W.prototype._getOriginZoom=function(e){return (e-this.points.length)%32},W.prototype._map=function(e,t){if(e.numPoints)return t?ee({},e.properties):e.properties;var r=this.points[e.index].properties,i=this.options.map(r);return t&&i===r?ee({},i):i},ke.prototype.options={maxZoom:14,indexMaxZoom:5,indexMaxPoints:1e5,tolerance:3,extent:4096,buffer:64,lineMetrics:!1,promoteId:null,generateId:!1,debug:0},ke.prototype.splitTile=function(e,t,r,i,o,n,a){for(var s=[e,t,r,i],l=this.options,u=l.debug;s.length;){i=s.pop(),r=s.pop(),t=s.pop(),e=s.pop();var h=1<<t,c=Te(t,r,i),p=this.tiles[c];if(!p&&(u>1&&console.time("creation"),p=this.tiles[c]=be(e,t,r,i,l),this.tileCoords.push({z:t,x:r,y:i}),u)){u>1&&(console.log("tile z%d-%d-%d (features: %d, points: %d, simplified: %d)",t,r,i,p.numFeatures,p.numPoints,p.numSimplified),console.timeEnd("creation"));var f="z"+t;this.stats[f]=(this.stats[f]||0)+1,this.total++;}if(p.source=e,o){if(t===l.maxZoom||t===o)continue;var d=1<<o-t;if(r!==Math.floor(n/d)||i!==Math.floor(a/d))continue}else if(t===l.indexMaxZoom||p.numPoints<=l.indexMaxPoints)continue;if(p.source=null,0!==e.length){u>1&&console.time("clipping");var g,m,v,y,x,w,S=.5*l.buffer/l.extent,M=.5-S,I=.5+S,b=1+S;g=m=v=y=null,x=pe(e,h,r-S,r+I,0,p.minX,p.maxX,l),w=pe(e,h,r+M,r+b,0,p.minX,p.maxX,l),e=null,x&&(g=pe(x,h,i-S,i+I,1,p.minY,p.maxY,l),m=pe(x,h,i+M,i+b,1,p.minY,p.maxY,l),x=null),w&&(v=pe(w,h,i-S,i+I,1,p.minY,p.maxY,l),y=pe(w,h,i+M,i+b,1,p.minY,p.maxY,l),w=null),u>1&&console.timeEnd("clipping"),s.push(g||[],t+1,2*r,2*i),s.push(m||[],t+1,2*r,2*i+1),s.push(v||[],t+1,2*r+1,2*i),s.push(y||[],t+1,2*r+1,2*i+1);}}},ke.prototype.getTile=function(e,t,r){var i=this.options,o=i.extent,n=i.debug;if(e<0||e>24)return null;var a=1<<e,s=Te(e,t=(t%a+a)%a,r);if(this.tiles[s])return Me(this.tiles[s],o);n>1&&console.log("drilling down to z%d-%d-%d",e,t,r);for(var l,u=e,h=t,c=r;!l&&u>0;)u--,h=Math.floor(h/2),c=Math.floor(c/2),l=this.tiles[Te(u,h,c)];return l&&l.source?(n>1&&console.log("found parent tile z%d-%d-%d",u,h,c),n>1&&console.time("drilling down"),this.splitTile(l.source,u,h,c,e,t,r),n>1&&console.timeEnd("drilling down"),this.tiles[s]?Me(this.tiles[s],o):null):null};var De=function(t){function r(e,r,i,o){t.call(this,e,r,i,Ce),o&&(this.loadGeoJSON=o);}return t&&(r.__proto__=t),r.prototype=Object.create(t&&t.prototype),r.prototype.constructor=r,r.prototype.loadData=function(e,t){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),this._pendingCallback=t,this._pendingLoadDataParams=e,this._state&&"Idle"!==this._state?this._state="NeedsLoadData":(this._state="Coalescing",this._loadData());},r.prototype._loadData=function(){var t=this;if(this._pendingCallback&&this._pendingLoadDataParams){var r=this._pendingCallback,i=this._pendingLoadDataParams;delete this._pendingCallback,delete this._pendingLoadDataParams;var o=!!(i&&i.request&&i.request.collectResourceTiming)&&new e.RequestPerformance(i.request);this.loadGeoJSON(i,(function(n,a){if(n||!a)return r(n);if("object"!=typeof a)return r(new Error("Input data given to '"+i.source+"' is not a valid GeoJSON object."));m(a,!0);try{t._geoJSONIndex=i.cluster?new W(function(t){var r=t.superclusterOptions,i=t.clusterProperties;if(!i||!r)return r;for(var o={},n={},a={accumulated:null,zoom:0},s={properties:null},l=Object.keys(i),u=0,h=l;u<h.length;u+=1){var c=h[u],p=i[c],f=p[0],d=p[1],g=e.createExpression(d),m=e.createExpression("string"==typeof f?[f,["accumulated"],["get",c]]:f);o[c]=g.value,n[c]=m.value;}return r.map=function(e){s.properties=e;for(var t={},r=0,i=l;r<i.length;r+=1){var n=i[r];t[n]=o[n].evaluate(a,s);}return t},r.reduce=function(e,t){s.properties=t;for(var r=0,i=l;r<i.length;r+=1){var o=i[r];a.accumulated=e[o],e[o]=n[o].evaluate(a,s);}},r}(i)).load(a.features):function(e,t){return new ke(e,t)}(a,i.geojsonVtOptions);}catch(n){return r(n)}t.loaded={};var s={};if(o){var l=o.finish();l&&(s.resourceTiming={},s.resourceTiming[i.source]=JSON.parse(JSON.stringify(l)));}r(null,s);}));}},r.prototype.coalesce=function(){"Coalescing"===this._state?this._state="Idle":"NeedsLoadData"===this._state&&(this._state="Coalescing",this._loadData());},r.prototype.reloadTile=function(e,r){var i=this.loaded,o=e.uid;return i&&i[o]?t.prototype.reloadTile.call(this,e,r):this.loadTile(e,r)},r.prototype.loadGeoJSON=function(t,r){if(t.request)e.getJSON(t.request,r);else{if("string"!=typeof t.data)return r(new Error("Input data given to '"+t.source+"' is not a valid GeoJSON object."));try{return r(null,JSON.parse(t.data))}catch(e){return r(new Error("Input data given to '"+t.source+"' is not a valid GeoJSON object."))}}},r.prototype.removeSource=function(e,t){this._pendingCallback&&this._pendingCallback(null,{abandoned:!0}),t();},r.prototype.getClusterExpansionZoom=function(e,t){try{t(null,this._geoJSONIndex.getClusterExpansionZoom(e.clusterId));}catch(e){t(e);}},r.prototype.getClusterChildren=function(e,t){try{t(null,this._geoJSONIndex.getChildren(e.clusterId));}catch(e){t(e);}},r.prototype.getClusterLeaves=function(e,t){try{t(null,this._geoJSONIndex.getLeaves(e.clusterId,e.limit,e.offset));}catch(e){t(e);}},r}(l);var Le=function(t){var r=this;this.self=t,this.actor=new e.Actor(t,this),this.layerIndexes={},this.availableImages={},this.workerSourceTypes={vector:l,geojson:De},this.workerSources={},this.demWorkerSources={},this.self.registerWorkerSource=function(e,t){if(r.workerSourceTypes[e])throw new Error('Worker source with name "'+e+'" already registered.');r.workerSourceTypes[e]=t;},this.self.registerRTLTextPlugin=function(t){if(e.plugin.isParsed())throw new Error("RTL text plugin already registered.");e.plugin.applyArabicShaping=t.applyArabicShaping,e.plugin.processBidirectionalText=t.processBidirectionalText,e.plugin.processStyledBidirectionalText=t.processStyledBidirectionalText;};};return Le.prototype.setReferrer=function(e,t){this.referrer=t;},Le.prototype.setImages=function(e,t,r){this.availableImages[e]=t,r();},Le.prototype.setLayers=function(e,t,r){this.getLayerIndex(e).replace(t),r();},Le.prototype.updateLayers=function(e,t,r){this.getLayerIndex(e).update(t.layers,t.removedIds),r();},Le.prototype.loadTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).loadTile(t,r);},Le.prototype.loadDEMTile=function(e,t,r){this.getDEMWorkerSource(e,t.source).loadTile(t,r);},Le.prototype.reloadTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).reloadTile(t,r);},Le.prototype.abortTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).abortTile(t,r);},Le.prototype.removeTile=function(e,t,r){this.getWorkerSource(e,t.type,t.source).removeTile(t,r);},Le.prototype.removeDEMTile=function(e,t){this.getDEMWorkerSource(e,t.source).removeTile(t);},Le.prototype.removeSource=function(e,t,r){if(this.workerSources[e]&&this.workerSources[e][t.type]&&this.workerSources[e][t.type][t.source]){var i=this.workerSources[e][t.type][t.source];delete this.workerSources[e][t.type][t.source],void 0!==i.removeSource?i.removeSource(t,r):r();}},Le.prototype.loadWorkerSource=function(e,t,r){try{this.self.importScripts(t.url),r();}catch(e){r(e.toString());}},Le.prototype.syncRTLPluginState=function(t,r,i){try{e.plugin.setState(r);var o=e.plugin.getPluginURL();if(e.plugin.isLoaded()&&!e.plugin.isParsed()&&null!=o){this.self.importScripts(o);var n=e.plugin.isParsed();i(n?void 0:new Error("RTL Text Plugin failed to import scripts from "+o),n);}}catch(e){i(e.toString());}},Le.prototype.getAvailableImages=function(e){var t=this.availableImages[e];return t||(t=[]),t},Le.prototype.getLayerIndex=function(e){var t=this.layerIndexes[e];return t||(t=this.layerIndexes[e]=new i),t},Le.prototype.getWorkerSource=function(e,t,r){var i=this;if(this.workerSources[e]||(this.workerSources[e]={}),this.workerSources[e][t]||(this.workerSources[e][t]={}),!this.workerSources[e][t][r]){var o={send:function(t,r,o){i.actor.send(t,r,o,e);}};this.workerSources[e][t][r]=new this.workerSourceTypes[t](o,this.getLayerIndex(e),this.getAvailableImages(e));}return this.workerSources[e][t][r]},Le.prototype.getDEMWorkerSource=function(e,t){return this.demWorkerSources[e]||(this.demWorkerSources[e]={}),this.demWorkerSources[e][t]||(this.demWorkerSources[e][t]=new h),this.demWorkerSources[e][t]},Le.prototype.enforceCacheSizeLimit=function(t,r){e.enforceCacheSizeLimit(r);},"undefined"!=typeof WorkerGlobalScope&&void 0!==e.window&&e.window instanceof WorkerGlobalScope&&(e.window.worker=new Le(e.window)),Le}));
	
	define(["./shared"],(function(t){"use strict";var e=t.createCommonjsModule((function(t){function e(t){return !!("undefined"!=typeof window&&"undefined"!=typeof document&&Array.prototype&&Array.prototype.every&&Array.prototype.filter&&Array.prototype.forEach&&Array.prototype.indexOf&&Array.prototype.lastIndexOf&&Array.prototype.map&&Array.prototype.some&&Array.prototype.reduce&&Array.prototype.reduceRight&&Array.isArray&&Function.prototype&&Function.prototype.bind&&Object.keys&&Object.create&&Object.getPrototypeOf&&Object.getOwnPropertyNames&&Object.isSealed&&Object.isFrozen&&Object.isExtensible&&Object.getOwnPropertyDescriptor&&Object.defineProperty&&Object.defineProperties&&Object.seal&&Object.freeze&&Object.preventExtensions&&"JSON"in window&&"parse"in JSON&&"stringify"in JSON&&function(){if(!("Worker"in window&&"Blob"in window&&"URL"in window))return !1;var t,e,i=new Blob([""],{type:"text/javascript"}),o=URL.createObjectURL(i);try{e=new Worker(o),t=!0;}catch(e){t=!1;}e&&e.terminate();return URL.revokeObjectURL(o),t}()&&"Uint8ClampedArray"in window&&ArrayBuffer.isView&&function(t){void 0===i[t]&&(i[t]=function(t){var i=document.createElement("canvas"),o=Object.create(e.webGLContextAttributes);return o.failIfMajorPerformanceCaveat=t,i.probablySupportsContext?i.probablySupportsContext("webgl",o)||i.probablySupportsContext("experimental-webgl",o):i.supportsContext?i.supportsContext("webgl",o)||i.supportsContext("experimental-webgl",o):i.getContext("webgl",o)||i.getContext("experimental-webgl",o)}(t));return i[t]}(t&&t.failIfMajorPerformanceCaveat))}t.exports?t.exports=e:window&&(window.mapboxgl=window.mapboxgl||{},window.mapboxgl.supported=e);var i={};e.webGLContextAttributes={antialias:!1,alpha:!0,stencil:!0,depth:!0};})),i={create:function(e,i,o){var r=t.window.document.createElement(e);return void 0!==i&&(r.className=i),o&&o.appendChild(r),r},createNS:function(e,i){return t.window.document.createElementNS(e,i)}},o=t.window.document.documentElement.style;function r(t){if(!o)return t[0];for(var e=0;e<t.length;e++)if(t[e]in o)return t[e];return t[0]}var a,n=r(["userSelect","MozUserSelect","WebkitUserSelect","msUserSelect"]);i.disableDrag=function(){o&&n&&(a=o[n],o[n]="none");},i.enableDrag=function(){o&&n&&(o[n]=a);};var s=r(["transform","WebkitTransform"]);i.setTransform=function(t,e){t.style[s]=e;};var l=!1;try{var c=Object.defineProperty({},"passive",{get:function(){l=!0;}});t.window.addEventListener("test",c,c),t.window.removeEventListener("test",c,c);}catch(t){l=!1;}i.addEventListener=function(t,e,i,o){void 0===o&&(o={}),"passive"in o&&l?t.addEventListener(e,i,o):t.addEventListener(e,i,o.capture);},i.removeEventListener=function(t,e,i,o){void 0===o&&(o={}),"passive"in o&&l?t.removeEventListener(e,i,o):t.removeEventListener(e,i,o.capture);};var u=function(e){e.preventDefault(),e.stopPropagation(),t.window.removeEventListener("click",u,!0);};function h(t){var e=t.userImage;if(e&&e.render&&e.render())return t.data.replace(new Uint8Array(e.data.buffer)),!0;return !1}i.suppressClick=function(){t.window.addEventListener("click",u,!0),t.window.setTimeout((function(){t.window.removeEventListener("click",u,!0);}),0);},i.mousePos=function(e,i){var o=e.getBoundingClientRect(),r=t.window.TouchEvent&&i instanceof t.window.TouchEvent?i.touches[0]:i;return new t.Point(r.clientX-o.left-e.clientLeft,r.clientY-o.top-e.clientTop)},i.touchPos=function(e,i){for(var o=e.getBoundingClientRect(),r=[],a="touchend"===i.type?i.changedTouches:i.touches,n=0;n<a.length;n++)r.push(new t.Point(a[n].clientX-o.left-e.clientLeft,a[n].clientY-o.top-e.clientTop));return r},i.mouseButton=function(e){return void 0!==t.window.InstallTrigger&&2===e.button&&e.ctrlKey&&t.window.navigator.platform.toUpperCase().indexOf("MAC")>=0?0:e.button},i.remove=function(t){t.parentNode&&t.parentNode.removeChild(t);};var p=function(e){function i(){e.call(this),this.images={},this.updatedImages={},this.callbackDispatchedThisFrame={},this.loaded=!1,this.requestors=[],this.patterns={},this.atlasImage=new t.RGBAImage({width:1,height:1}),this.dirty=!0;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.isLoaded=function(){return this.loaded},i.prototype.setLoaded=function(t){if(this.loaded!==t&&(this.loaded=t,t)){for(var e=0,i=this.requestors;e<i.length;e+=1){var o=i[e],r=o.ids,a=o.callback;this._notify(r,a);}this.requestors=[];}},i.prototype.getImage=function(t){return this.images[t]},i.prototype.addImage=function(t,e){this._validate(t,e)&&(this.images[t]=e);},i.prototype._validate=function(e,i){var o=!0;return this._validateStretch(i.stretchX,i.data&&i.data.width)||(this.fire(new t.ErrorEvent(new Error('Image "'+e+'" has invalid "stretchX" value'))),o=!1),this._validateStretch(i.stretchY,i.data&&i.data.height)||(this.fire(new t.ErrorEvent(new Error('Image "'+e+'" has invalid "stretchY" value'))),o=!1),this._validateContent(i.content,i)||(this.fire(new t.ErrorEvent(new Error('Image "'+e+'" has invalid "content" value'))),o=!1),o},i.prototype._validateStretch=function(t,e){if(!t)return !0;for(var i=0,o=0,r=t;o<r.length;o+=1){var a=r[o];if(a[0]<i||a[1]<a[0]||e<a[1])return !1;i=a[1];}return !0},i.prototype._validateContent=function(t,e){return !t||4===t.length&&(!(t[0]<0||e.data.width<t[0])&&(!(t[1]<0||e.data.height<t[1])&&(!(t[2]<0||e.data.width<t[2])&&(!(t[3]<0||e.data.height<t[3])&&(!(t[2]<t[0])&&!(t[3]<t[1]))))))},i.prototype.updateImage=function(t,e){var i=this.images[t];e.version=i.version+1,this.images[t]=e,this.updatedImages[t]=!0;},i.prototype.removeImage=function(t){var e=this.images[t];delete this.images[t],delete this.patterns[t],e.userImage&&e.userImage.onRemove&&e.userImage.onRemove();},i.prototype.listImages=function(){return Object.keys(this.images)},i.prototype.getImages=function(t,e){var i=!0;if(!this.isLoaded())for(var o=0,r=t;o<r.length;o+=1){var a=r[o];this.images[a]||(i=!1);}this.isLoaded()||i?this._notify(t,e):this.requestors.push({ids:t,callback:e});},i.prototype._notify=function(e,i){for(var o={},r=0,a=e;r<a.length;r+=1){var n=a[r];this.images[n]||this.fire(new t.Event("styleimagemissing",{id:n}));var s=this.images[n];s?o[n]={data:s.data.clone(),pixelRatio:s.pixelRatio,sdf:s.sdf,version:s.version,stretchX:s.stretchX,stretchY:s.stretchY,content:s.content,hasRenderCallback:Boolean(s.userImage&&s.userImage.render)}:t.warnOnce('Image "'+n+'" could not be loaded. Please make sure you have added the image with map.addImage() or a "sprite" property in your style. You can provide missing images by listening for the "styleimagemissing" map event.');}i(null,o);},i.prototype.getPixelSize=function(){var t=this.atlasImage;return {width:t.width,height:t.height}},i.prototype.getPattern=function(e){var i=this.patterns[e],o=this.getImage(e);if(!o)return null;if(i&&i.position.version===o.version)return i.position;if(i)i.position.version=o.version;else{var r={w:o.data.width+2,h:o.data.height+2,x:0,y:0},a=new t.ImagePosition(r,o);this.patterns[e]={bin:r,position:a};}return this._updatePatternAtlas(),this.patterns[e].position},i.prototype.bind=function(e){var i=e.gl;this.atlasTexture?this.dirty&&(this.atlasTexture.update(this.atlasImage),this.dirty=!1):this.atlasTexture=new t.Texture(e,this.atlasImage,i.RGBA),this.atlasTexture.bind(i.LINEAR,i.CLAMP_TO_EDGE);},i.prototype._updatePatternAtlas=function(){var e=[];for(var i in this.patterns)e.push(this.patterns[i].bin);var o=t.potpack(e),r=o.w,a=o.h,n=this.atlasImage;for(var s in n.resize({width:r||1,height:a||1}),this.patterns){var l=this.patterns[s].bin,c=l.x+1,u=l.y+1,h=this.images[s].data,p=h.width,d=h.height;t.RGBAImage.copy(h,n,{x:0,y:0},{x:c,y:u},{width:p,height:d}),t.RGBAImage.copy(h,n,{x:0,y:d-1},{x:c,y:u-1},{width:p,height:1}),t.RGBAImage.copy(h,n,{x:0,y:0},{x:c,y:u+d},{width:p,height:1}),t.RGBAImage.copy(h,n,{x:p-1,y:0},{x:c-1,y:u},{width:1,height:d}),t.RGBAImage.copy(h,n,{x:0,y:0},{x:c+p,y:u},{width:1,height:d});}this.dirty=!0;},i.prototype.beginFrame=function(){this.callbackDispatchedThisFrame={};},i.prototype.dispatchRenderCallbacks=function(t){for(var e=0,i=t;e<i.length;e+=1){var o=i[e];if(!this.callbackDispatchedThisFrame[o]){this.callbackDispatchedThisFrame[o]=!0;var r=this.images[o];h(r)&&this.updateImage(o,r);}}},i}(t.Evented);var d=m,_=m,f=1e20;function m(t,e,i,o,r,a){this.fontSize=t||24,this.buffer=void 0===e?3:e,this.cutoff=o||.25,this.fontFamily=r||"sans-serif",this.fontWeight=a||"normal",this.radius=i||8;var n=this.size=this.fontSize+2*this.buffer;this.canvas=document.createElement("canvas"),this.canvas.width=this.canvas.height=n,this.ctx=this.canvas.getContext("2d"),this.ctx.font=this.fontWeight+" "+this.fontSize+"px "+this.fontFamily,this.ctx.textBaseline="middle",this.ctx.fillStyle="black",this.gridOuter=new Float64Array(n*n),this.gridInner=new Float64Array(n*n),this.f=new Float64Array(n),this.d=new Float64Array(n),this.z=new Float64Array(n+1),this.v=new Int16Array(n),this.middle=Math.round(n/2*(navigator.userAgent.indexOf("Gecko/")>=0?1.2:1));}function g(t,e,i,o,r,a,n){for(var s=0;s<e;s++){for(var l=0;l<i;l++)o[l]=t[l*e+s];for(v(o,r,a,n,i),l=0;l<i;l++)t[l*e+s]=r[l];}for(l=0;l<i;l++){for(s=0;s<e;s++)o[s]=t[l*e+s];for(v(o,r,a,n,e),s=0;s<e;s++)t[l*e+s]=Math.sqrt(r[s]);}}function v(t,e,i,o,r){i[0]=0,o[0]=-f,o[1]=+f;for(var a=1,n=0;a<r;a++){for(var s=(t[a]+a*a-(t[i[n]]+i[n]*i[n]))/(2*a-2*i[n]);s<=o[n];)n--,s=(t[a]+a*a-(t[i[n]]+i[n]*i[n]))/(2*a-2*i[n]);i[++n]=a,o[n]=s,o[n+1]=+f;}for(a=0,n=0;a<r;a++){for(;o[n+1]<a;)n++;e[a]=(a-i[n])*(a-i[n])+t[i[n]];}}m.prototype.draw=function(t){this.ctx.clearRect(0,0,this.size,this.size),this.ctx.fillText(t,this.buffer,this.middle);for(var e=this.ctx.getImageData(0,0,this.size,this.size),i=new Uint8ClampedArray(this.size*this.size),o=0;o<this.size*this.size;o++){var r=e.data[4*o+3]/255;this.gridOuter[o]=1===r?0:0===r?f:Math.pow(Math.max(0,.5-r),2),this.gridInner[o]=1===r?f:0===r?0:Math.pow(Math.max(0,r-.5),2);}for(g(this.gridOuter,this.size,this.size,this.f,this.d,this.v,this.z),g(this.gridInner,this.size,this.size,this.f,this.d,this.v,this.z),o=0;o<this.size*this.size;o++){var a=this.gridOuter[o]-this.gridInner[o];i[o]=Math.max(0,Math.min(255,Math.round(255-255*(a/this.radius+this.cutoff))));}return i},d.default=_;var y=function(t,e){this.requestManager=t,this.localIdeographFontFamily=e,this.entries={};};y.prototype.setURL=function(t){this.url=t;},y.prototype.getGlyphs=function(e,i){var o=this,r=[];for(var a in e)for(var n=0,s=e[a];n<s.length;n+=1){var l=s[n];r.push({stack:a,id:l});}t.asyncAll(r,(function(t,e){var i=t.stack,r=t.id,a=o.entries[i];a||(a=o.entries[i]={glyphs:{},requests:{}});var n=a.glyphs[r];if(void 0===n){if(n=o._tinySDF(a,i,r))return a.glyphs[r]=n,void e(null,{stack:i,id:r,glyph:n});var s=Math.floor(r/256);if(256*s>65535)e(new Error("glyphs > 65535 not supported"));else{var l=a.requests[s];l||(l=a.requests[s]=[],y.loadGlyphRange(i,s,o.url,o.requestManager,(function(t,e){if(e)for(var i in e)o._doesCharSupportLocalGlyph(+i)||(a.glyphs[+i]=e[+i]);for(var r=0,n=l;r<n.length;r+=1){(0,n[r])(t,e);}delete a.requests[s];}))),l.push((function(t,o){t?e(t):o&&e(null,{stack:i,id:r,glyph:o[r]||null});}));}}else e(null,{stack:i,id:r,glyph:n});}),(function(t,e){if(t)i(t);else if(e){for(var o={},r=0,a=e;r<a.length;r+=1){var n=a[r],s=n.stack,l=n.id,c=n.glyph;(o[s]||(o[s]={}))[l]=c&&{id:c.id,bitmap:c.bitmap.clone(),metrics:c.metrics};}i(null,o);}}));},y.prototype._doesCharSupportLocalGlyph=function(e){return !!this.localIdeographFontFamily&&(t.isChar["CJK Unified Ideographs"](e)||t.isChar["Hangul Syllables"](e)||t.isChar.Hiragana(e)||t.isChar.Katakana(e))},y.prototype._tinySDF=function(e,i,o){var r=this.localIdeographFontFamily;if(r&&this._doesCharSupportLocalGlyph(o)){var a=e.tinySDF;if(!a){var n="400";/bold/i.test(i)?n="900":/medium/i.test(i)?n="500":/light/i.test(i)&&(n="200"),a=e.tinySDF=new y.TinySDF(24,3,8,.25,r,n);}return {id:o,bitmap:new t.AlphaImage({width:30,height:30},a.draw(String.fromCharCode(o))),metrics:{width:24,height:24,left:0,top:-8,advance:24}}}},y.loadGlyphRange=function(e,i,o,r,a){var n=256*i,s=n+255,l=r.transformRequest(r.normalizeGlyphsURL(o).replace("{fontstack}",e).replace("{range}",n+"-"+s),t.ResourceType.Glyphs);t.getArrayBuffer(l,(function(e,i){if(e)a(e);else if(i){for(var o={},r=0,n=t.parseGlyphPBF(i);r<n.length;r+=1){var s=n[r];o[s.id]=s;}a(null,o);}}));},y.TinySDF=d;var x=function(){this.specification=t.styleSpec.light.position;};x.prototype.possiblyEvaluate=function(e,i){return t.sphericalToCartesian(e.expression.evaluate(i))},x.prototype.interpolate=function(e,i,o){return {x:t.number(e.x,i.x,o),y:t.number(e.y,i.y,o),z:t.number(e.z,i.z,o)}};var b=new t.Properties({anchor:new t.DataConstantProperty(t.styleSpec.light.anchor),position:new x,color:new t.DataConstantProperty(t.styleSpec.light.color),intensity:new t.DataConstantProperty(t.styleSpec.light.intensity)}),w=function(e){function i(i){e.call(this),this._transitionable=new t.Transitionable(b),this.setLight(i),this._transitioning=this._transitionable.untransitioned();}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getLight=function(){return this._transitionable.serialize()},i.prototype.setLight=function(e,i){if(void 0===i&&(i={}),!this._validate(t.validateLight,e,i))for(var o in e){var r=e[o];t.endsWith(o,"-transition")?this._transitionable.setTransition(o.slice(0,-"-transition".length),r):this._transitionable.setValue(o,r);}},i.prototype.updateTransitions=function(t){this._transitioning=this._transitionable.transitioned(t,this._transitioning);},i.prototype.hasTransition=function(){return this._transitioning.hasTransition()},i.prototype.recalculate=function(t){this.properties=this._transitioning.possiblyEvaluate(t);},i.prototype._validate=function(e,i,o){return (!o||!1!==o.validate)&&t.emitValidationErrors(this,e.call(t.validateStyle,t.extend({value:i,style:{glyphs:!0,sprite:!0},styleSpec:t.styleSpec})))},i}(t.Evented),E=function(t,e){this.width=t,this.height=e,this.nextRow=0,this.data=new Uint8Array(this.width*this.height),this.dashEntry={};};E.prototype.getDash=function(t,e){var i=t.join(",")+String(e);return this.dashEntry[i]||(this.dashEntry[i]=this.addDash(t,e)),this.dashEntry[i]},E.prototype.getDashRanges=function(t,e,i){var o=[],r=t.length%2==1?-t[t.length-1]*i:0,a=t[0]*i,n=!0;o.push({left:r,right:a,isDash:n,zeroLength:0===t[0]});for(var s=t[0],l=1;l<t.length;l++){n=!n;var c=t[l];r=s*i,a=(s+=c)*i,o.push({left:r,right:a,isDash:n,zeroLength:0===c});}return o},E.prototype.addRoundDash=function(t,e,i){for(var o=e/2,r=-i;r<=i;r++)for(var a=this.nextRow+i+r,n=this.width*a,s=0,l=t[s],c=0;c<this.width;c++){c/l.right>1&&(l=t[++s]);var u=Math.abs(c-l.left),h=Math.abs(c-l.right),p=Math.min(u,h),d=void 0,_=r/i*(o+1);if(l.isDash){var f=o-Math.abs(_);d=Math.sqrt(p*p+f*f);}else d=o-Math.sqrt(p*p+_*_);this.data[n+c]=Math.max(0,Math.min(255,d+128));}},E.prototype.addRegularDash=function(t){for(var e=t.length-1;e>=0;--e){var i=t[e],o=t[e+1];i.zeroLength?t.splice(e,1):o&&o.isDash===i.isDash&&(o.left=i.left,t.splice(e,1));}var r=t[0],a=t[t.length-1];r.isDash===a.isDash&&(r.left=a.left-this.width,a.right=r.right+this.width);for(var n=this.width*this.nextRow,s=0,l=t[s],c=0;c<this.width;c++){c/l.right>1&&(l=t[++s]);var u=Math.abs(c-l.left),h=Math.abs(c-l.right),p=Math.min(u,h),d=l.isDash?p:-p;this.data[n+c]=Math.max(0,Math.min(255,d+128));}},E.prototype.addDash=function(e,i){var o=i?7:0,r=2*o+1;if(this.nextRow+r>this.height)return t.warnOnce("LineAtlas out of space"),null;for(var a=0,n=0;n<e.length;n++)a+=e[n];var s=this.width/a,l=this.getDashRanges(e,this.width,s);i?this.addRoundDash(l,s,o):this.addRegularDash(l);var c={y:(this.nextRow+o+.5)/this.height,height:2*o/this.height,width:a};return this.nextRow+=r,this.dirty=!0,c},E.prototype.bind=function(t){var e=t.gl;this.texture?(e.bindTexture(e.TEXTURE_2D,this.texture),this.dirty&&(this.dirty=!1,e.texSubImage2D(e.TEXTURE_2D,0,0,0,this.width,this.height,e.ALPHA,e.UNSIGNED_BYTE,this.data))):(this.texture=e.createTexture(),e.bindTexture(e.TEXTURE_2D,this.texture),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_S,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_WRAP_T,e.REPEAT),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MIN_FILTER,e.LINEAR),e.texParameteri(e.TEXTURE_2D,e.TEXTURE_MAG_FILTER,e.LINEAR),e.texImage2D(e.TEXTURE_2D,0,e.ALPHA,this.width,this.height,0,e.ALPHA,e.UNSIGNED_BYTE,this.data));};var T=function e(i,o){this.workerPool=i,this.actors=[],this.currentActor=0,this.id=t.uniqueId();for(var r=this.workerPool.acquire(this.id),a=0;a<r.length;a++){var n=r[a],s=new e.Actor(n,o,this.id);s.name="Worker "+a,this.actors.push(s);}};function I(e,i,o){var r=function(r,a){if(r)return o(r);if(a){var n=t.pick(t.extend(a,e),["tiles","minzoom","maxzoom","attribution","mapbox_logo","bounds","scheme","tileSize","encoding"]);a.vector_layers&&(n.vectorLayers=a.vector_layers,n.vectorLayerIds=n.vectorLayers.map((function(t){return t.id}))),n.tiles=i.canonicalizeTileset(n,e.url),o(null,n);}};return e.url?t.getJSON(i.transformRequest(i.normalizeSourceURL(e.url),t.ResourceType.Source),r):t.browser.frame((function(){return r(null,e)}))}T.prototype.broadcast=function(e,i,o){o=o||function(){},t.asyncAll(this.actors,(function(t,o){t.send(e,i,o);}),o);},T.prototype.getActor=function(){return this.currentActor=(this.currentActor+1)%this.actors.length,this.actors[this.currentActor]},T.prototype.remove=function(){this.actors.forEach((function(t){t.remove();})),this.actors=[],this.workerPool.release(this.id);},T.Actor=t.Actor;var S=function(e,i,o){this.bounds=t.LngLatBounds.convert(this.validateBounds(e)),this.minzoom=i||0,this.maxzoom=o||24;};S.prototype.validateBounds=function(t){return Array.isArray(t)&&4===t.length?[Math.max(-180,t[0]),Math.max(-90,t[1]),Math.min(180,t[2]),Math.min(90,t[3])]:[-180,-90,180,90]},S.prototype.contains=function(e){var i=Math.pow(2,e.z),o=Math.floor(t.mercatorXfromLng(this.bounds.getWest())*i),r=Math.floor(t.mercatorYfromLat(this.bounds.getNorth())*i),a=Math.ceil(t.mercatorXfromLng(this.bounds.getEast())*i),n=Math.ceil(t.mercatorYfromLat(this.bounds.getSouth())*i);return e.x>=o&&e.x<a&&e.y>=r&&e.y<n};var C=function(e){function i(i,o,r,a){if(e.call(this),this.id=i,this.dispatcher=r,this.type="vector",this.minzoom=0,this.maxzoom=22,this.scheme="xyz",this.tileSize=512,this.reparseOverscaled=!0,this.isTileClipped=!0,this._loaded=!1,t.extend(this,t.pick(o,["url","scheme","tileSize","promoteId"])),this._options=t.extend({type:"vector"},o),this._collectResourceTiming=o.collectResourceTiming,512!==this.tileSize)throw new Error("vector tile sources must have a tileSize of 512");this.setEventedParent(a);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=I(this._options,this.map._requestManager,(function(i,o){e._tileJSONRequest=null,e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):o&&(t.extend(e,o),o.bounds&&(e.tileBounds=new S(o.bounds,e.minzoom,e.maxzoom)),t.postTurnstileEvent(o.tiles,e.map._requestManager._customAccessToken),t.postMapLoadEvent(o.tiles,e.map._getMapId(),e.map._requestManager._skuToken,e.map._requestManager._customAccessToken),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})));}));},i.prototype.loaded=function(){return this._loaded},i.prototype.hasTile=function(t){return !this.tileBounds||this.tileBounds.contains(t.canonical)},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);},i.prototype.serialize=function(){return t.extend({},this._options)},i.prototype.loadTile=function(e,i){var o=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme)),r={request:this.map._requestManager.transformRequest(o,t.ResourceType.Tile),uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,tileSize:this.tileSize*e.tileID.overscaleFactor(),type:this.type,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes,promoteId:this.promoteId};function a(o,r){return delete e.request,e.aborted?i(null):o&&404!==o.status?i(o):(r&&r.resourceTiming&&(e.resourceTiming=r.resourceTiming),this.map._refreshExpiredTiles&&r&&e.setExpiryData(r),e.loadVectorData(r,this.map.painter),t.cacheEntryPossiblyAdded(this.dispatcher),i(null),void(e.reloadCallback&&(this.loadTile(e,e.reloadCallback),e.reloadCallback=null)))}r.request.collectResourceTiming=this._collectResourceTiming,e.actor&&"expired"!==e.state?"loading"===e.state?e.reloadCallback=i:e.request=e.actor.send("reloadTile",r,a.bind(this)):(e.actor=this.dispatcher.getActor(),e.request=e.actor.send("loadTile",r,a.bind(this)));},i.prototype.abortTile=function(t){t.request&&(t.request.cancel(),delete t.request),t.actor&&t.actor.send("abortTile",{uid:t.uid,type:this.type,source:this.id},void 0);},i.prototype.unloadTile=function(t){t.unloadVectorData(),t.actor&&t.actor.send("removeTile",{uid:t.uid,type:this.type,source:this.id},void 0);},i.prototype.hasTransition=function(){return !1},i}(t.Evented),P=function(e){function i(i,o,r,a){e.call(this),this.id=i,this.dispatcher=r,this.setEventedParent(a),this.type="raster",this.minzoom=0,this.maxzoom=22,this.roundZoom=!0,this.scheme="xyz",this.tileSize=512,this._loaded=!1,this._options=t.extend({type:"raster"},o),t.extend(this,t.pick(o,["url","scheme","tileSize"]));}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this._tileJSONRequest=I(this._options,this.map._requestManager,(function(i,o){e._tileJSONRequest=null,e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):o&&(t.extend(e,o),o.bounds&&(e.tileBounds=new S(o.bounds,e.minzoom,e.maxzoom)),t.postTurnstileEvent(o.tiles),t.postMapLoadEvent(o.tiles,e.map._getMapId(),e.map._requestManager._skuToken),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})),e.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})));}));},i.prototype.loaded=function(){return this._loaded},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.onRemove=function(){this._tileJSONRequest&&(this._tileJSONRequest.cancel(),this._tileJSONRequest=null);},i.prototype.serialize=function(){return t.extend({},this._options)},i.prototype.hasTile=function(t){return !this.tileBounds||this.tileBounds.contains(t.canonical)},i.prototype.loadTile=function(e,i){var o=this,r=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.tileSize);e.request=t.getImage(this.map._requestManager.transformRequest(r,t.ResourceType.Tile),(function(r,a){if(delete e.request,e.aborted)e.state="unloaded",i(null);else if(r)e.state="errored",i(r);else if(a){o.map._refreshExpiredTiles&&e.setExpiryData(a),delete a.cacheControl,delete a.expires;var n=o.map.painter.context,s=n.gl;e.texture=o.map.painter.getTileTexture(a.width),e.texture?e.texture.update(a,{useMipmap:!0}):(e.texture=new t.Texture(n,a,s.RGBA,{useMipmap:!0}),e.texture.bind(s.LINEAR,s.CLAMP_TO_EDGE,s.LINEAR_MIPMAP_NEAREST),n.extTextureFilterAnisotropic&&s.texParameterf(s.TEXTURE_2D,n.extTextureFilterAnisotropic.TEXTURE_MAX_ANISOTROPY_EXT,n.extTextureFilterAnisotropicMax)),e.state="loaded",t.cacheEntryPossiblyAdded(o.dispatcher),i(null);}}));},i.prototype.abortTile=function(t,e){t.request&&(t.request.cancel(),delete t.request),e();},i.prototype.unloadTile=function(t,e){t.texture&&this.map.painter.saveTileTexture(t.texture),e();},i.prototype.hasTransition=function(){return !1},i}(t.Evented),z=function(e){function i(i,o,r,a){e.call(this,i,o,r,a),this.type="raster-dem",this.maxzoom=22,this._options=t.extend({type:"raster-dem"},o),this.encoding=o.encoding||"mapbox";}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.serialize=function(){return {type:"raster-dem",url:this.url,tileSize:this.tileSize,tiles:this.tiles,bounds:this.bounds,encoding:this.encoding}},i.prototype.loadTile=function(e,i){var o=this.map._requestManager.normalizeTileURL(e.tileID.canonical.url(this.tiles,this.scheme),this.tileSize);function r(t,o){t&&(e.state="errored",i(t)),o&&(e.dem=o,e.needsHillshadePrepare=!0,e.state="loaded",i(null));}e.request=t.getImage(this.map._requestManager.transformRequest(o,t.ResourceType.Tile),function(o,a){if(delete e.request,e.aborted)e.state="unloaded",i(null);else if(o)e.state="errored",i(o);else if(a){this.map._refreshExpiredTiles&&e.setExpiryData(a),delete a.cacheControl,delete a.expires;var n=t.window.ImageBitmap&&a instanceof t.window.ImageBitmap&&t.offscreenCanvasSupported()?a:t.browser.getImageData(a,1),s={uid:e.uid,coord:e.tileID,source:this.id,rawImageData:n,encoding:this.encoding};e.actor&&"expired"!==e.state||(e.actor=this.dispatcher.getActor(),e.actor.send("loadDEMTile",s,r.bind(this)));}}.bind(this)),e.neighboringTiles=this._getNeighboringTiles(e.tileID);},i.prototype._getNeighboringTiles=function(e){var i=e.canonical,o=Math.pow(2,i.z),r=(i.x-1+o)%o,a=0===i.x?e.wrap-1:e.wrap,n=(i.x+1+o)%o,s=i.x+1===o?e.wrap+1:e.wrap,l={};return l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y).key]={backfilled:!1},i.y>0&&(l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y-1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y-1).key]={backfilled:!1}),i.y+1<o&&(l[new t.OverscaledTileID(e.overscaledZ,a,i.z,r,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,e.wrap,i.z,i.x,i.y+1).key]={backfilled:!1},l[new t.OverscaledTileID(e.overscaledZ,s,i.z,n,i.y+1).key]={backfilled:!1}),l},i.prototype.unloadTile=function(t){t.demTexture&&this.map.painter.saveTileTexture(t.demTexture),t.fbo&&(t.fbo.destroy(),delete t.fbo),t.dem&&delete t.dem,delete t.neighboringTiles,t.state="unloaded",t.actor&&t.actor.send("removeDEMTile",{uid:t.uid,source:this.id});},i}(P),L=function(e){function i(i,o,r,a){e.call(this),this.id=i,this.type="geojson",this.minzoom=0,this.maxzoom=18,this.tileSize=512,this.isTileClipped=!0,this.reparseOverscaled=!0,this._removed=!1,this._loaded=!1,this.actor=r.getActor(),this.setEventedParent(a),this._data=o.data,this._options=t.extend({},o),this._collectResourceTiming=o.collectResourceTiming,this._resourceTiming=[],void 0!==o.maxzoom&&(this.maxzoom=o.maxzoom),o.type&&(this.type=o.type),o.attribution&&(this.attribution=o.attribution),this.promoteId=o.promoteId;var n=t.EXTENT/this.tileSize;this.workerOptions=t.extend({source:this.id,cluster:o.cluster||!1,geojsonVtOptions:{buffer:(void 0!==o.buffer?o.buffer:128)*n,tolerance:(void 0!==o.tolerance?o.tolerance:.375)*n,extent:t.EXTENT,maxZoom:this.maxzoom,lineMetrics:o.lineMetrics||!1,generateId:o.generateId||!1},superclusterOptions:{maxZoom:void 0!==o.clusterMaxZoom?Math.min(o.clusterMaxZoom,this.maxzoom-1):this.maxzoom-1,extent:t.EXTENT,radius:(o.clusterRadius||50)*n,log:!1,generateId:o.generateId||!1},clusterProperties:o.clusterProperties},o.workerOptions);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData((function(i){if(i)e.fire(new t.ErrorEvent(i));else{var o={dataType:"source",sourceDataType:"metadata"};e._collectResourceTiming&&e._resourceTiming&&e._resourceTiming.length>0&&(o.resourceTiming=e._resourceTiming,e._resourceTiming=[]),e.fire(new t.Event("data",o));}}));},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.setData=function(e){var i=this;return this._data=e,this.fire(new t.Event("dataloading",{dataType:"source"})),this._updateWorkerData((function(e){if(e)i.fire(new t.ErrorEvent(e));else{var o={dataType:"source",sourceDataType:"content"};i._collectResourceTiming&&i._resourceTiming&&i._resourceTiming.length>0&&(o.resourceTiming=i._resourceTiming,i._resourceTiming=[]),i.fire(new t.Event("data",o));}})),this},i.prototype.getClusterExpansionZoom=function(t,e){return this.actor.send("geojson.getClusterExpansionZoom",{clusterId:t,source:this.id},e),this},i.prototype.getClusterChildren=function(t,e){return this.actor.send("geojson.getClusterChildren",{clusterId:t,source:this.id},e),this},i.prototype.getClusterLeaves=function(t,e,i,o){return this.actor.send("geojson.getClusterLeaves",{source:this.id,clusterId:t,limit:e,offset:i},o),this},i.prototype._updateWorkerData=function(e){var i=this;this._loaded=!1;var o=t.extend({},this.workerOptions),r=this._data;"string"==typeof r?(o.request=this.map._requestManager.transformRequest(t.browser.resolveURL(r),t.ResourceType.Source),o.request.collectResourceTiming=this._collectResourceTiming):o.data=JSON.stringify(r),this.actor.send(this.type+".loadData",o,(function(t,r){i._removed||r&&r.abandoned||(i._loaded=!0,r&&r.resourceTiming&&r.resourceTiming[i.id]&&(i._resourceTiming=r.resourceTiming[i.id].slice(0)),i.actor.send(i.type+".coalesce",{source:o.source},null),e(t));}));},i.prototype.loaded=function(){return this._loaded},i.prototype.loadTile=function(e,i){var o=this,r=e.actor?"reloadTile":"loadTile";e.actor=this.actor;var a={type:this.type,uid:e.uid,tileID:e.tileID,zoom:e.tileID.overscaledZ,maxZoom:this.maxzoom,tileSize:this.tileSize,source:this.id,pixelRatio:t.browser.devicePixelRatio,showCollisionBoxes:this.map.showCollisionBoxes,promoteId:this.promoteId};e.request=this.actor.send(r,a,(function(t,a){return delete e.request,e.unloadVectorData(),e.aborted?i(null):t?i(t):(e.loadVectorData(a,o.map.painter,"reloadTile"===r),i(null))}));},i.prototype.abortTile=function(t){t.request&&(t.request.cancel(),delete t.request),t.aborted=!0;},i.prototype.unloadTile=function(t){t.unloadVectorData(),this.actor.send("removeTile",{uid:t.uid,type:this.type,source:this.id});},i.prototype.onRemove=function(){this._removed=!0,this.actor.send("removeSource",{type:this.type,source:this.id});},i.prototype.serialize=function(){return t.extend({},this._options,{type:this.type,data:this._data})},i.prototype.hasTransition=function(){return !1},i}(t.Evented),M=t.createLayout([{name:"a_pos",type:"Int16",components:2},{name:"a_texture_pos",type:"Int16",components:2}]),D=function(e){function i(t,i,o,r){e.call(this),this.id=t,this.dispatcher=o,this.coordinates=i.coordinates,this.type="image",this.minzoom=0,this.maxzoom=22,this.tileSize=512,this.tiles={},this._loaded=!1,this.setEventedParent(r),this.options=i;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(e,i){var o=this;this._loaded=!1,this.fire(new t.Event("dataloading",{dataType:"source"})),this.url=this.options.url,t.getImage(this.map._requestManager.transformRequest(this.url,t.ResourceType.Image),(function(r,a){o._loaded=!0,r?o.fire(new t.ErrorEvent(r)):a&&(o.image=a,e&&(o.coordinates=e),i&&i(),o._finishLoading());}));},i.prototype.loaded=function(){return this._loaded},i.prototype.updateImage=function(t){var e=this;return this.image&&t.url?(this.options.url=t.url,this.load(t.coordinates,(function(){e.texture=null;})),this):this},i.prototype._finishLoading=function(){this.map&&(this.setCoordinates(this.coordinates),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"metadata"})));},i.prototype.onAdd=function(t){this.map=t,this.load();},i.prototype.setCoordinates=function(e){var i=this;this.coordinates=e;var o=e.map(t.MercatorCoordinate.fromLngLat);this.tileID=function(e){for(var i=1/0,o=1/0,r=-1/0,a=-1/0,n=0,s=e;n<s.length;n+=1){var l=s[n];i=Math.min(i,l.x),o=Math.min(o,l.y),r=Math.max(r,l.x),a=Math.max(a,l.y);}var c=r-i,u=a-o,h=Math.max(c,u),p=Math.max(0,Math.floor(-Math.log(h)/Math.LN2)),d=Math.pow(2,p);return new t.CanonicalTileID(p,Math.floor((i+r)/2*d),Math.floor((o+a)/2*d))}(o),this.minzoom=this.maxzoom=this.tileID.z;var r=o.map((function(t){return i.tileID.getTilePoint(t)._round()}));return this._boundsArray=new t.StructArrayLayout4i8,this._boundsArray.emplaceBack(r[0].x,r[0].y,0,0),this._boundsArray.emplaceBack(r[1].x,r[1].y,t.EXTENT,0),this._boundsArray.emplaceBack(r[3].x,r[3].y,0,t.EXTENT),this._boundsArray.emplaceBack(r[2].x,r[2].y,t.EXTENT,t.EXTENT),this.boundsBuffer&&(this.boundsBuffer.destroy(),delete this.boundsBuffer),this.fire(new t.Event("data",{dataType:"source",sourceDataType:"content"})),this},i.prototype.prepare=function(){if(0!==Object.keys(this.tiles).length&&this.image){var e=this.map.painter.context,i=e.gl;for(var o in this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,M.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture||(this.texture=new t.Texture(e,this.image,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this.tiles){var r=this.tiles[o];"loaded"!==r.state&&(r.state="loaded",r.texture=this.texture);}}},i.prototype.loadTile=function(t,e){this.tileID&&this.tileID.equals(t.tileID.canonical)?(this.tiles[String(t.tileID.wrap)]=t,t.buckets={},e(null)):(t.state="errored",e(null));},i.prototype.serialize=function(){return {type:"image",url:this.options.url,coordinates:this.coordinates}},i.prototype.hasTransition=function(){return !1},i}(t.Evented);var A=function(e){function i(t,i,o,r){e.call(this,t,i,o,r),this.roundZoom=!0,this.type="video",this.options=i;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){var e=this;this._loaded=!1;var i=this.options;this.urls=[];for(var o=0,r=i.urls;o<r.length;o+=1){var a=r[o];this.urls.push(this.map._requestManager.transformRequest(a,t.ResourceType.Source).url);}t.getVideo(this.urls,(function(i,o){e._loaded=!0,i?e.fire(new t.ErrorEvent(i)):o&&(e.video=o,e.video.loop=!0,e.video.addEventListener("playing",(function(){e.map.triggerRepaint();})),e.map&&e.video.play(),e._finishLoading());}));},i.prototype.pause=function(){this.video&&this.video.pause();},i.prototype.play=function(){this.video&&this.video.play();},i.prototype.seek=function(e){if(this.video){var i=this.video.seekable;e<i.start(0)||e>i.end(0)?this.fire(new t.ErrorEvent(new t.ValidationError("sources."+this.id,null,"Playback for this video can be set only between the "+i.start(0)+" and "+i.end(0)+"-second mark."))):this.video.currentTime=e;}},i.prototype.getVideo=function(){return this.video},i.prototype.onAdd=function(t){this.map||(this.map=t,this.load(),this.video&&(this.video.play(),this.setCoordinates(this.coordinates)));},i.prototype.prepare=function(){if(!(0===Object.keys(this.tiles).length||this.video.readyState<2)){var e=this.map.painter.context,i=e.gl;for(var o in this.boundsBuffer||(this.boundsBuffer=e.createVertexBuffer(this._boundsArray,M.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture?this.video.paused||(this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE),i.texSubImage2D(i.TEXTURE_2D,0,0,0,i.RGBA,i.UNSIGNED_BYTE,this.video)):(this.texture=new t.Texture(e,this.video,i.RGBA),this.texture.bind(i.LINEAR,i.CLAMP_TO_EDGE)),this.tiles){var r=this.tiles[o];"loaded"!==r.state&&(r.state="loaded",r.texture=this.texture);}}},i.prototype.serialize=function(){return {type:"video",urls:this.urls,coordinates:this.coordinates}},i.prototype.hasTransition=function(){return this.video&&!this.video.paused},i}(D),R=function(e){function i(i,o,r,a){e.call(this,i,o,r,a),o.coordinates?Array.isArray(o.coordinates)&&4===o.coordinates.length&&!o.coordinates.some((function(t){return !Array.isArray(t)||2!==t.length||t.some((function(t){return "number"!=typeof t}))}))||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'"coordinates" property must be an array of 4 longitude/latitude array pairs'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'missing required property "coordinates"'))),o.animate&&"boolean"!=typeof o.animate&&this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'optional "animate" property must be a boolean value'))),o.canvas?"string"==typeof o.canvas||o.canvas instanceof t.window.HTMLCanvasElement||this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'"canvas" must be either a string representing the ID of the canvas element from which to read, or an HTMLCanvasElement instance'))):this.fire(new t.ErrorEvent(new t.ValidationError("sources."+i,null,'missing required property "canvas"'))),this.options=o,this.animate=void 0===o.animate||o.animate;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.load=function(){this._loaded=!0,this.canvas||(this.canvas=this.options.canvas instanceof t.window.HTMLCanvasElement?this.options.canvas:t.window.document.getElementById(this.options.canvas)),this.width=this.canvas.width,this.height=this.canvas.height,this._hasInvalidDimensions()?this.fire(new t.ErrorEvent(new Error("Canvas dimensions cannot be less than or equal to zero."))):(this.play=function(){this._playing=!0,this.map.triggerRepaint();},this.pause=function(){this._playing&&(this.prepare(),this._playing=!1);},this._finishLoading());},i.prototype.getCanvas=function(){return this.canvas},i.prototype.onAdd=function(t){this.map=t,this.load(),this.canvas&&this.animate&&this.play();},i.prototype.onRemove=function(){this.pause();},i.prototype.prepare=function(){var e=!1;if(this.canvas.width!==this.width&&(this.width=this.canvas.width,e=!0),this.canvas.height!==this.height&&(this.height=this.canvas.height,e=!0),!this._hasInvalidDimensions()&&0!==Object.keys(this.tiles).length){var i=this.map.painter.context,o=i.gl;for(var r in this.boundsBuffer||(this.boundsBuffer=i.createVertexBuffer(this._boundsArray,M.members)),this.boundsSegments||(this.boundsSegments=t.SegmentVector.simpleSegment(0,0,4,2)),this.texture?(e||this._playing)&&this.texture.update(this.canvas,{premultiply:!0}):this.texture=new t.Texture(i,this.canvas,o.RGBA,{premultiply:!0}),this.tiles){var a=this.tiles[r];"loaded"!==a.state&&(a.state="loaded",a.texture=this.texture);}}},i.prototype.serialize=function(){return {type:"canvas",coordinates:this.coordinates}},i.prototype.hasTransition=function(){return this._playing},i.prototype._hasInvalidDimensions=function(){for(var t=0,e=[this.canvas.width,this.canvas.height];t<e.length;t+=1){var i=e[t];if(isNaN(i)||i<=0)return !0}return !1},i}(D),k={vector:C,raster:P,"raster-dem":z,geojson:L,video:A,image:D,canvas:R},B=function(e,i,o,r){var a=new k[i.type](e,i,o,r);if(a.id!==e)throw new Error("Expected Source id to be "+e+" instead of "+a.id);return t.bindAll(["load","abort","unload","serialize","prepare"],a),a};function O(e,i){var o=t.identity([]);return t.translate(o,o,[1,1,0]),t.scale(o,o,[.5*e.width,.5*e.height,1]),t.multiply(o,o,e.calculatePosMatrix(i.toUnwrapped()))}function F(t,e,i,o,r){var a=function(t,e,i){if(t)for(var o=0,r=t;o<r.length;o+=1){var a=e[r[o]];if(a&&a.source===i&&"fill-extrusion"===a.type)return !0}else for(var n in e){var s=e[n];if(s.source===i&&"fill-extrusion"===s.type)return !0}return !1}(o&&o.layers,e,t.id),n=r.maxPitchScaleFactor(),s=t.tilesIn(i,n,a);s.sort(U);for(var l=[],c=0,u=s;c<u.length;c+=1){var h=u[c];l.push({wrappedTileID:h.tileID.wrapped().key,queryResults:h.tile.queryRenderedFeatures(e,t._state,h.queryGeometry,h.cameraQueryGeometry,h.scale,o,r,n,O(t.transform,h.tileID))});}var p=function(t){for(var e={},i={},o=0,r=t;o<r.length;o+=1){var a=r[o],n=a.queryResults,s=a.wrappedTileID,l=i[s]=i[s]||{};for(var c in n)for(var u=n[c],h=l[c]=l[c]||{},p=e[c]=e[c]||[],d=0,_=u;d<_.length;d+=1){var f=_[d];h[f.featureIndex]||(h[f.featureIndex]=!0,p.push(f));}}return e}(l);for(var d in p)p[d].forEach((function(e){var i=e.feature,o=t.getFeatureState(i.layer["source-layer"],i.id);i.source=i.layer.source,i.layer["source-layer"]&&(i.sourceLayer=i.layer["source-layer"]),i.state=o;}));return p}function U(t,e){var i=t.tileID,o=e.tileID;return i.overscaledZ-o.overscaledZ||i.canonical.y-o.canonical.y||i.wrap-o.wrap||i.canonical.x-o.canonical.x}var N=function(t,e){this.max=t,this.onRemove=e,this.reset();};N.prototype.reset=function(){for(var t in this.data)for(var e=0,i=this.data[t];e<i.length;e+=1){var o=i[e];o.timeout&&clearTimeout(o.timeout),this.onRemove(o.value);}return this.data={},this.order=[],this},N.prototype.add=function(t,e,i){var o=this,r=t.wrapped().key;void 0===this.data[r]&&(this.data[r]=[]);var a={value:e,timeout:void 0};if(void 0!==i&&(a.timeout=setTimeout((function(){o.remove(t,a);}),i)),this.data[r].push(a),this.order.push(r),this.order.length>this.max){var n=this._getAndRemoveByKey(this.order[0]);n&&this.onRemove(n);}return this},N.prototype.has=function(t){return t.wrapped().key in this.data},N.prototype.getAndRemove=function(t){return this.has(t)?this._getAndRemoveByKey(t.wrapped().key):null},N.prototype._getAndRemoveByKey=function(t){var e=this.data[t].shift();return e.timeout&&clearTimeout(e.timeout),0===this.data[t].length&&delete this.data[t],this.order.splice(this.order.indexOf(t),1),e.value},N.prototype.getByKey=function(t){var e=this.data[t];return e?e[0].value:null},N.prototype.get=function(t){return this.has(t)?this.data[t.wrapped().key][0].value:null},N.prototype.remove=function(t,e){if(!this.has(t))return this;var i=t.wrapped().key,o=void 0===e?0:this.data[i].indexOf(e),r=this.data[i][o];return this.data[i].splice(o,1),r.timeout&&clearTimeout(r.timeout),0===this.data[i].length&&delete this.data[i],this.onRemove(r.value),this.order.splice(this.order.indexOf(i),1),this},N.prototype.setMaxSize=function(t){for(this.max=t;this.order.length>this.max;){var e=this._getAndRemoveByKey(this.order[0]);e&&this.onRemove(e);}return this},N.prototype.filter=function(t){var e=[];for(var i in this.data)for(var o=0,r=this.data[i];o<r.length;o+=1){var a=r[o];t(a.value)||e.push(a);}for(var n=0,s=e;n<s.length;n+=1){var l=s[n];this.remove(l.value.tileID,l);}};var Z=function(t,e,i){this.context=t;var o=t.gl;this.buffer=o.createBuffer(),this.dynamicDraw=Boolean(i),this.context.unbindVAO(),t.bindElementBuffer.set(this.buffer),o.bufferData(o.ELEMENT_ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?o.DYNAMIC_DRAW:o.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer;};Z.prototype.bind=function(){this.context.bindElementBuffer.set(this.buffer);},Z.prototype.updateData=function(t){var e=this.context.gl;this.context.unbindVAO(),this.bind(),e.bufferSubData(e.ELEMENT_ARRAY_BUFFER,0,t.arrayBuffer);},Z.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer);};var q={Int8:"BYTE",Uint8:"UNSIGNED_BYTE",Int16:"SHORT",Uint16:"UNSIGNED_SHORT",Int32:"INT",Uint32:"UNSIGNED_INT",Float32:"FLOAT"},j=function(t,e,i,o){this.length=e.length,this.attributes=i,this.itemSize=e.bytesPerElement,this.dynamicDraw=o,this.context=t;var r=t.gl;this.buffer=r.createBuffer(),t.bindVertexBuffer.set(this.buffer),r.bufferData(r.ARRAY_BUFFER,e.arrayBuffer,this.dynamicDraw?r.DYNAMIC_DRAW:r.STATIC_DRAW),this.dynamicDraw||delete e.arrayBuffer;};j.prototype.bind=function(){this.context.bindVertexBuffer.set(this.buffer);},j.prototype.updateData=function(t){var e=this.context.gl;this.bind(),e.bufferSubData(e.ARRAY_BUFFER,0,t.arrayBuffer);},j.prototype.enableAttributes=function(t,e){for(var i=0;i<this.attributes.length;i++){var o=this.attributes[i],r=e.attributes[o.name];void 0!==r&&t.enableVertexAttribArray(r);}},j.prototype.setVertexAttribPointers=function(t,e,i){for(var o=0;o<this.attributes.length;o++){var r=this.attributes[o],a=e.attributes[r.name];void 0!==a&&t.vertexAttribPointer(a,r.components,t[q[r.type]],!1,this.itemSize,r.offset+this.itemSize*(i||0));}},j.prototype.destroy=function(){var t=this.context.gl;this.buffer&&(t.deleteBuffer(this.buffer),delete this.buffer);};var V=function(t){this.gl=t.gl,this.default=this.getDefault(),this.current=this.default,this.dirty=!1;};V.prototype.get=function(){return this.current},V.prototype.set=function(t){},V.prototype.getDefault=function(){return this.default},V.prototype.setDefault=function(){this.set(this.default);};var G=function(e){function i(){e.apply(this,arguments);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getDefault=function(){return t.Color.transparent},i.prototype.set=function(t){var e=this.current;(t.r!==e.r||t.g!==e.g||t.b!==e.b||t.a!==e.a||this.dirty)&&(this.gl.clearColor(t.r,t.g,t.b,t.a),this.current=t,this.dirty=!1);},i}(V),W=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 1},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.clearDepth(t),this.current=t,this.dirty=!1);},e}(V),X=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.clearStencil(t),this.current=t,this.dirty=!1);},e}(V),H=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return [!0,!0,!0,!0]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||t[3]!==e[3]||this.dirty)&&(this.gl.colorMask(t[0],t[1],t[2],t[3]),this.current=t,this.dirty=!1);},e}(V),K=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.depthMask(t),this.current=t,this.dirty=!1);},e}(V),Y=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 255},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.stencilMask(t),this.current=t,this.dirty=!1);},e}(V),J=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return {func:this.gl.ALWAYS,ref:0,mask:255}},e.prototype.set=function(t){var e=this.current;(t.func!==e.func||t.ref!==e.ref||t.mask!==e.mask||this.dirty)&&(this.gl.stencilFunc(t.func,t.ref,t.mask),this.current=t,this.dirty=!1);},e}(V),Q=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [t.KEEP,t.KEEP,t.KEEP]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||this.dirty)&&(this.gl.stencilOp(t[0],t[1],t[2]),this.current=t,this.dirty=!1);},e}(V),$=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.STENCIL_TEST):e.disable(e.STENCIL_TEST),this.current=t,this.dirty=!1;}},e}(V),tt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return [0,1]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||this.dirty)&&(this.gl.depthRange(t[0],t[1]),this.current=t,this.dirty=!1);},e}(V),et=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.DEPTH_TEST):e.disable(e.DEPTH_TEST),this.current=t,this.dirty=!1;}},e}(V),it=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.LESS},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.depthFunc(t),this.current=t,this.dirty=!1);},e}(V),ot=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.BLEND):e.disable(e.BLEND),this.current=t,this.dirty=!1;}},e}(V),rt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [t.ONE,t.ZERO]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||this.dirty)&&(this.gl.blendFunc(t[0],t[1]),this.current=t,this.dirty=!1);},e}(V),at=function(e){function i(){e.apply(this,arguments);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getDefault=function(){return t.Color.transparent},i.prototype.set=function(t){var e=this.current;(t.r!==e.r||t.g!==e.g||t.b!==e.b||t.a!==e.a||this.dirty)&&(this.gl.blendColor(t.r,t.g,t.b,t.a),this.current=t,this.dirty=!1);},i}(V),nt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.FUNC_ADD},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.blendEquation(t),this.current=t,this.dirty=!1);},e}(V),st=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;t?e.enable(e.CULL_FACE):e.disable(e.CULL_FACE),this.current=t,this.dirty=!1;}},e}(V),lt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.BACK},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.cullFace(t),this.current=t,this.dirty=!1);},e}(V),ct=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.CCW},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.frontFace(t),this.current=t,this.dirty=!1);},e}(V),ut=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.useProgram(t),this.current=t,this.dirty=!1);},e}(V),ht=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return this.gl.TEXTURE0},e.prototype.set=function(t){(t!==this.current||this.dirty)&&(this.gl.activeTexture(t),this.current=t,this.dirty=!1);},e}(V),pt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){var t=this.gl;return [0,0,t.drawingBufferWidth,t.drawingBufferHeight]},e.prototype.set=function(t){var e=this.current;(t[0]!==e[0]||t[1]!==e[1]||t[2]!==e[2]||t[3]!==e[3]||this.dirty)&&(this.gl.viewport(t[0],t[1],t[2],t[3]),this.current=t,this.dirty=!1);},e}(V),dt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindFramebuffer(e.FRAMEBUFFER,t),this.current=t,this.dirty=!1;}},e}(V),_t=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindRenderbuffer(e.RENDERBUFFER,t),this.current=t,this.dirty=!1;}},e}(V),ft=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindTexture(e.TEXTURE_2D,t),this.current=t,this.dirty=!1;}},e}(V),mt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.bindBuffer(e.ARRAY_BUFFER,t),this.current=t,this.dirty=!1;}},e}(V),gt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){var e=this.gl;e.bindBuffer(e.ELEMENT_ARRAY_BUFFER,t),this.current=t,this.dirty=!1;},e}(V),vt=function(t){function e(e){t.call(this,e),this.vao=e.extVertexArrayObject;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e.prototype.set=function(t){this.vao&&(t!==this.current||this.dirty)&&(this.vao.bindVertexArrayOES(t),this.current=t,this.dirty=!1);},e}(V),yt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return 4},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_ALIGNMENT,t),this.current=t,this.dirty=!1;}},e}(V),xt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_PREMULTIPLY_ALPHA_WEBGL,t),this.current=t,this.dirty=!1;}},e}(V),bt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return !1},e.prototype.set=function(t){if(t!==this.current||this.dirty){var e=this.gl;e.pixelStorei(e.UNPACK_FLIP_Y_WEBGL,t),this.current=t,this.dirty=!1;}},e}(V),wt=function(t){function e(e,i){t.call(this,e),this.context=e,this.parent=i;}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.getDefault=function(){return null},e}(V),Et=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.setDirty=function(){this.dirty=!0;},e.prototype.set=function(t){if(t!==this.current||this.dirty){this.context.bindFramebuffer.set(this.parent);var e=this.gl;e.framebufferTexture2D(e.FRAMEBUFFER,e.COLOR_ATTACHMENT0,e.TEXTURE_2D,t,0),this.current=t,this.dirty=!1;}},e}(wt),Tt=function(t){function e(){t.apply(this,arguments);}return t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e,e.prototype.set=function(t){if(t!==this.current||this.dirty){this.context.bindFramebuffer.set(this.parent);var e=this.gl;e.framebufferRenderbuffer(e.FRAMEBUFFER,e.DEPTH_ATTACHMENT,e.RENDERBUFFER,t),this.current=t,this.dirty=!1;}},e}(wt),It=function(t,e,i){this.context=t,this.width=e,this.height=i;var o=t.gl,r=this.framebuffer=o.createFramebuffer();this.colorAttachment=new Et(t,r),this.depthAttachment=new Tt(t,r);};It.prototype.destroy=function(){var t=this.context.gl,e=this.colorAttachment.get();e&&t.deleteTexture(e);var i=this.depthAttachment.get();i&&t.deleteRenderbuffer(i),t.deleteFramebuffer(this.framebuffer);};var St=function(t,e,i){this.func=t,this.mask=e,this.range=i;};St.ReadOnly=!1,St.ReadWrite=!0,St.disabled=new St(519,St.ReadOnly,[0,1]);var Ct=function(t,e,i,o,r,a){this.test=t,this.ref=e,this.mask=i,this.fail=o,this.depthFail=r,this.pass=a;};Ct.disabled=new Ct({func:519,mask:0},0,0,7680,7680,7680);var Pt=function(t,e,i){this.blendFunction=t,this.blendColor=e,this.mask=i;};Pt.Replace=[1,0],Pt.disabled=new Pt(Pt.Replace,t.Color.transparent,[!1,!1,!1,!1]),Pt.unblended=new Pt(Pt.Replace,t.Color.transparent,[!0,!0,!0,!0]),Pt.alphaBlended=new Pt([1,771],t.Color.transparent,[!0,!0,!0,!0]);var zt=function(t,e,i){this.enable=t,this.mode=e,this.frontFace=i;};zt.disabled=new zt(!1,1029,2305),zt.backCCW=new zt(!0,1029,2305);var Lt=function(t){this.gl=t,this.extVertexArrayObject=this.gl.getExtension("OES_vertex_array_object"),this.clearColor=new G(this),this.clearDepth=new W(this),this.clearStencil=new X(this),this.colorMask=new H(this),this.depthMask=new K(this),this.stencilMask=new Y(this),this.stencilFunc=new J(this),this.stencilOp=new Q(this),this.stencilTest=new $(this),this.depthRange=new tt(this),this.depthTest=new et(this),this.depthFunc=new it(this),this.blend=new ot(this),this.blendFunc=new rt(this),this.blendColor=new at(this),this.blendEquation=new nt(this),this.cullFace=new st(this),this.cullFaceSide=new lt(this),this.frontFace=new ct(this),this.program=new ut(this),this.activeTexture=new ht(this),this.viewport=new pt(this),this.bindFramebuffer=new dt(this),this.bindRenderbuffer=new _t(this),this.bindTexture=new ft(this),this.bindVertexBuffer=new mt(this),this.bindElementBuffer=new gt(this),this.bindVertexArrayOES=this.extVertexArrayObject&&new vt(this),this.pixelStoreUnpack=new yt(this),this.pixelStoreUnpackPremultiplyAlpha=new xt(this),this.pixelStoreUnpackFlipY=new bt(this),this.extTextureFilterAnisotropic=t.getExtension("EXT_texture_filter_anisotropic")||t.getExtension("MOZ_EXT_texture_filter_anisotropic")||t.getExtension("WEBKIT_EXT_texture_filter_anisotropic"),this.extTextureFilterAnisotropic&&(this.extTextureFilterAnisotropicMax=t.getParameter(this.extTextureFilterAnisotropic.MAX_TEXTURE_MAX_ANISOTROPY_EXT)),this.extTextureHalfFloat=t.getExtension("OES_texture_half_float"),this.extTextureHalfFloat&&t.getExtension("OES_texture_half_float_linear"),this.extTimerQuery=t.getExtension("EXT_disjoint_timer_query");};Lt.prototype.setDefault=function(){this.unbindVAO(),this.clearColor.setDefault(),this.clearDepth.setDefault(),this.clearStencil.setDefault(),this.colorMask.setDefault(),this.depthMask.setDefault(),this.stencilMask.setDefault(),this.stencilFunc.setDefault(),this.stencilOp.setDefault(),this.stencilTest.setDefault(),this.depthRange.setDefault(),this.depthTest.setDefault(),this.depthFunc.setDefault(),this.blend.setDefault(),this.blendFunc.setDefault(),this.blendColor.setDefault(),this.blendEquation.setDefault(),this.cullFace.setDefault(),this.cullFaceSide.setDefault(),this.frontFace.setDefault(),this.program.setDefault(),this.activeTexture.setDefault(),this.bindFramebuffer.setDefault(),this.pixelStoreUnpack.setDefault(),this.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.pixelStoreUnpackFlipY.setDefault();},Lt.prototype.setDirty=function(){this.clearColor.dirty=!0,this.clearDepth.dirty=!0,this.clearStencil.dirty=!0,this.colorMask.dirty=!0,this.depthMask.dirty=!0,this.stencilMask.dirty=!0,this.stencilFunc.dirty=!0,this.stencilOp.dirty=!0,this.stencilTest.dirty=!0,this.depthRange.dirty=!0,this.depthTest.dirty=!0,this.depthFunc.dirty=!0,this.blend.dirty=!0,this.blendFunc.dirty=!0,this.blendColor.dirty=!0,this.blendEquation.dirty=!0,this.cullFace.dirty=!0,this.cullFaceSide.dirty=!0,this.frontFace.dirty=!0,this.program.dirty=!0,this.activeTexture.dirty=!0,this.viewport.dirty=!0,this.bindFramebuffer.dirty=!0,this.bindRenderbuffer.dirty=!0,this.bindTexture.dirty=!0,this.bindVertexBuffer.dirty=!0,this.bindElementBuffer.dirty=!0,this.extVertexArrayObject&&(this.bindVertexArrayOES.dirty=!0),this.pixelStoreUnpack.dirty=!0,this.pixelStoreUnpackPremultiplyAlpha.dirty=!0,this.pixelStoreUnpackFlipY.dirty=!0;},Lt.prototype.createIndexBuffer=function(t,e){return new Z(this,t,e)},Lt.prototype.createVertexBuffer=function(t,e,i){return new j(this,t,e,i)},Lt.prototype.createRenderbuffer=function(t,e,i){var o=this.gl,r=o.createRenderbuffer();return this.bindRenderbuffer.set(r),o.renderbufferStorage(o.RENDERBUFFER,t,e,i),this.bindRenderbuffer.set(null),r},Lt.prototype.createFramebuffer=function(t,e){return new It(this,t,e)},Lt.prototype.clear=function(t){var e=t.color,i=t.depth,o=this.gl,r=0;e&&(r|=o.COLOR_BUFFER_BIT,this.clearColor.set(e),this.colorMask.set([!0,!0,!0,!0])),void 0!==i&&(r|=o.DEPTH_BUFFER_BIT,this.depthRange.set([0,1]),this.clearDepth.set(i),this.depthMask.set(!0)),o.clear(r);},Lt.prototype.setCullFace=function(t){!1===t.enable?this.cullFace.set(!1):(this.cullFace.set(!0),this.cullFaceSide.set(t.mode),this.frontFace.set(t.frontFace));},Lt.prototype.setDepthMode=function(t){t.func!==this.gl.ALWAYS||t.mask?(this.depthTest.set(!0),this.depthFunc.set(t.func),this.depthMask.set(t.mask),this.depthRange.set(t.range)):this.depthTest.set(!1);},Lt.prototype.setStencilMode=function(t){t.test.func!==this.gl.ALWAYS||t.mask?(this.stencilTest.set(!0),this.stencilMask.set(t.mask),this.stencilOp.set([t.fail,t.depthFail,t.pass]),this.stencilFunc.set({func:t.test.func,ref:t.ref,mask:t.test.mask})):this.stencilTest.set(!1);},Lt.prototype.setColorMode=function(e){t.deepEqual(e.blendFunction,Pt.Replace)?this.blend.set(!1):(this.blend.set(!0),this.blendFunc.set(e.blendFunction),this.blendColor.set(e.blendColor)),this.colorMask.set(e.mask);},Lt.prototype.unbindVAO=function(){this.extVertexArrayObject&&this.bindVertexArrayOES.set(null);};var Mt=function(e){function i(i,o,r){var a=this;e.call(this),this.id=i,this.dispatcher=r,this.on("data",(function(t){"source"===t.dataType&&"metadata"===t.sourceDataType&&(a._sourceLoaded=!0),a._sourceLoaded&&!a._paused&&"source"===t.dataType&&"content"===t.sourceDataType&&(a.reload(),a.transform&&a.update(a.transform));})),this.on("error",(function(){a._sourceErrored=!0;})),this._source=B(i,o,r,this),this._tiles={},this._cache=new N(0,this._unloadTile.bind(this)),this._timers={},this._cacheTimers={},this._maxTileCacheSize=null,this._loadedParentTiles={},this._coveredTiles={},this._state=new t.SourceFeatureState;}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.onAdd=function(t){this.map=t,this._maxTileCacheSize=t?t._maxTileCacheSize:null,this._source&&this._source.onAdd&&this._source.onAdd(t);},i.prototype.onRemove=function(t){this._source&&this._source.onRemove&&this._source.onRemove(t);},i.prototype.loaded=function(){if(this._sourceErrored)return !0;if(!this._sourceLoaded)return !1;if(!this._source.loaded())return !1;for(var t in this._tiles){var e=this._tiles[t];if("loaded"!==e.state&&"errored"!==e.state)return !1}return !0},i.prototype.getSource=function(){return this._source},i.prototype.pause=function(){this._paused=!0;},i.prototype.resume=function(){if(this._paused){var t=this._shouldReloadOnResume;this._paused=!1,this._shouldReloadOnResume=!1,t&&this.reload(),this.transform&&this.update(this.transform);}},i.prototype._loadTile=function(t,e){return this._source.loadTile(t,e)},i.prototype._unloadTile=function(t){if(this._source.unloadTile)return this._source.unloadTile(t,(function(){}))},i.prototype._abortTile=function(t){if(this._source.abortTile)return this._source.abortTile(t,(function(){}))},i.prototype.serialize=function(){return this._source.serialize()},i.prototype.prepare=function(t){for(var e in this._source.prepare&&this._source.prepare(),this._state.coalesceChanges(this._tiles,this.map?this.map.painter:null),this._tiles){var i=this._tiles[e];i.upload(t),i.prepare(this.map.style.imageManager);}},i.prototype.getIds=function(){return t.values(this._tiles).map((function(t){return t.tileID})).sort(Dt).map((function(t){return t.key}))},i.prototype.getRenderableIds=function(e){var i=this,o=[];for(var r in this._tiles)this._isIdRenderable(r,e)&&o.push(this._tiles[r]);return e?o.sort((function(e,o){var r=e.tileID,a=o.tileID,n=new t.Point(r.canonical.x,r.canonical.y)._rotate(i.transform.angle),s=new t.Point(a.canonical.x,a.canonical.y)._rotate(i.transform.angle);return r.overscaledZ-a.overscaledZ||s.y-n.y||s.x-n.x})).map((function(t){return t.tileID.key})):o.map((function(t){return t.tileID})).sort(Dt).map((function(t){return t.key}))},i.prototype.hasRenderableParent=function(t){var e=this.findLoadedParent(t,0);return !!e&&this._isIdRenderable(e.tileID.key)},i.prototype._isIdRenderable=function(t,e){return this._tiles[t]&&this._tiles[t].hasData()&&!this._coveredTiles[t]&&(e||!this._tiles[t].holdingForFade())},i.prototype.reload=function(){if(this._paused)this._shouldReloadOnResume=!0;else for(var t in this._cache.reset(),this._tiles)"errored"!==this._tiles[t].state&&this._reloadTile(t,"reloading");},i.prototype._reloadTile=function(t,e){var i=this._tiles[t];i&&("loading"!==i.state&&(i.state=e),this._loadTile(i,this._tileLoaded.bind(this,i,t,e)));},i.prototype._tileLoaded=function(e,i,o,r){if(r)return e.state="errored",void(404!==r.status?this._source.fire(new t.ErrorEvent(r,{tile:e})):this.update(this.transform));e.timeAdded=t.browser.now(),"expired"===o&&(e.refreshedUponExpiration=!0),this._setTileReloadTimer(i,e),"raster-dem"===this.getSource().type&&e.dem&&this._backfillDEM(e),this._state.initializeTileState(e,this.map?this.map.painter:null),this._source.fire(new t.Event("data",{dataType:"source",tile:e,coord:e.tileID}));},i.prototype._backfillDEM=function(t){for(var e=this.getRenderableIds(),i=0;i<e.length;i++){var o=e[i];if(t.neighboringTiles&&t.neighboringTiles[o]){var r=this.getTileByID(o);a(t,r),a(r,t);}}function a(t,e){t.needsHillshadePrepare=!0;var i=e.tileID.canonical.x-t.tileID.canonical.x,o=e.tileID.canonical.y-t.tileID.canonical.y,r=Math.pow(2,t.tileID.canonical.z),a=e.tileID.key;0===i&&0===o||Math.abs(o)>1||(Math.abs(i)>1&&(1===Math.abs(i+r)?i+=r:1===Math.abs(i-r)&&(i-=r)),e.dem&&t.dem&&(t.dem.backfillBorder(e.dem,i,o),t.neighboringTiles&&t.neighboringTiles[a]&&(t.neighboringTiles[a].backfilled=!0)));}},i.prototype.getTile=function(t){return this.getTileByID(t.key)},i.prototype.getTileByID=function(t){return this._tiles[t]},i.prototype._retainLoadedChildren=function(t,e,i,o){for(var r in this._tiles){var a=this._tiles[r];if(!(o[r]||!a.hasData()||a.tileID.overscaledZ<=e||a.tileID.overscaledZ>i)){for(var n=a.tileID;a&&a.tileID.overscaledZ>e+1;){var s=a.tileID.scaledTo(a.tileID.overscaledZ-1);(a=this._tiles[s.key])&&a.hasData()&&(n=s);}for(var l=n;l.overscaledZ>e;)if(t[(l=l.scaledTo(l.overscaledZ-1)).key]){o[n.key]=n;break}}}},i.prototype.findLoadedParent=function(t,e){if(t.key in this._loadedParentTiles){var i=this._loadedParentTiles[t.key];return i&&i.tileID.overscaledZ>=e?i:null}for(var o=t.overscaledZ-1;o>=e;o--){var r=t.scaledTo(o),a=this._getLoadedTile(r);if(a)return a}},i.prototype._getLoadedTile=function(t){var e=this._tiles[t.key];return e&&e.hasData()?e:this._cache.getByKey(t.wrapped().key)},i.prototype.updateCacheSize=function(t){var e=(Math.ceil(t.width/this._source.tileSize)+1)*(Math.ceil(t.height/this._source.tileSize)+1),i=Math.floor(5*e),o="number"==typeof this._maxTileCacheSize?Math.min(this._maxTileCacheSize,i):i;this._cache.setMaxSize(o);},i.prototype.handleWrapJump=function(t){var e=(t-(void 0===this._prevLng?t:this._prevLng))/360,i=Math.round(e);if(this._prevLng=t,i){var o={};for(var r in this._tiles){var a=this._tiles[r];a.tileID=a.tileID.unwrapTo(a.tileID.wrap+i),o[a.tileID.key]=a;}for(var n in this._tiles=o,this._timers)clearTimeout(this._timers[n]),delete this._timers[n];for(var s in this._tiles){var l=this._tiles[s];this._setTileReloadTimer(s,l);}}},i.prototype.update=function(e){var o=this;if(this.transform=e,this._sourceLoaded&&!this._paused){var r;this.updateCacheSize(e),this.handleWrapJump(this.transform.center.lng),this._coveredTiles={},this.used?this._source.tileID?r=e.getVisibleUnwrappedCoordinates(this._source.tileID).map((function(e){return new t.OverscaledTileID(e.canonical.z,e.wrap,e.canonical.z,e.canonical.x,e.canonical.y)})):(r=e.coveringTiles({tileSize:this._source.tileSize,minzoom:this._source.minzoom,maxzoom:this._source.maxzoom,roundZoom:this._source.roundZoom,reparseOverscaled:this._source.reparseOverscaled}),this._source.hasTile&&(r=r.filter((function(t){return o._source.hasTile(t)})))):r=[];var a=e.coveringZoomLevel(this._source),n=Math.max(a-i.maxOverzooming,this._source.minzoom),s=Math.max(a+i.maxUnderzooming,this._source.minzoom),l=this._updateRetainedTiles(r,a);if(At(this._source.type)){for(var c={},u={},h=0,p=Object.keys(l);h<p.length;h+=1){var d=p[h],_=l[d],f=this._tiles[d];if(f&&!(f.fadeEndTime&&f.fadeEndTime<=t.browser.now())){var m=this.findLoadedParent(_,n);m&&(this._addTile(m.tileID),c[m.tileID.key]=m.tileID),u[d]=_;}}for(var g in this._retainLoadedChildren(u,a,s,l),c)l[g]||(this._coveredTiles[g]=!0,l[g]=c[g]);}for(var v in l)this._tiles[v].clearFadeHold();for(var y=0,x=t.keysDifference(this._tiles,l);y<x.length;y+=1){var b=x[y],w=this._tiles[b];w.hasSymbolBuckets&&!w.holdingForFade()?w.setHoldDuration(this.map._fadeDuration):w.hasSymbolBuckets&&!w.symbolFadeFinished()||this._removeTile(b);}this._updateLoadedParentTileCache();}},i.prototype.releaseSymbolFadeTiles=function(){for(var t in this._tiles)this._tiles[t].holdingForFade()&&this._removeTile(t);},i.prototype._updateRetainedTiles=function(t,e){for(var o={},r={},a=Math.max(e-i.maxOverzooming,this._source.minzoom),n=Math.max(e+i.maxUnderzooming,this._source.minzoom),s={},l=0,c=t;l<c.length;l+=1){var u=c[l],h=this._addTile(u);o[u.key]=u,h.hasData()||e<this._source.maxzoom&&(s[u.key]=u);}this._retainLoadedChildren(s,e,n,o);for(var p=0,d=t;p<d.length;p+=1){var _=d[p],f=this._tiles[_.key];if(!f.hasData()){if(e+1>this._source.maxzoom){var m=_.children(this._source.maxzoom)[0],g=this.getTile(m);if(g&&g.hasData()){o[m.key]=m;continue}}else{var v=_.children(this._source.maxzoom);if(o[v[0].key]&&o[v[1].key]&&o[v[2].key]&&o[v[3].key])continue}for(var y=f.wasRequested(),x=_.overscaledZ-1;x>=a;--x){var b=_.scaledTo(x);if(r[b.key])break;if(r[b.key]=!0,!(f=this.getTile(b))&&y&&(f=this._addTile(b)),f&&(o[b.key]=b,y=f.wasRequested(),f.hasData()))break}}}return o},i.prototype._updateLoadedParentTileCache=function(){for(var t in this._loadedParentTiles={},this._tiles){for(var e=[],i=void 0,o=this._tiles[t].tileID;o.overscaledZ>0;){if(o.key in this._loadedParentTiles){i=this._loadedParentTiles[o.key];break}e.push(o.key);var r=o.scaledTo(o.overscaledZ-1);if(i=this._getLoadedTile(r))break;o=r;}for(var a=0,n=e;a<n.length;a+=1){var s=n[a];this._loadedParentTiles[s]=i;}}},i.prototype._addTile=function(e){var i=this._tiles[e.key];if(i)return i;(i=this._cache.getAndRemove(e))&&(this._setTileReloadTimer(e.key,i),i.tileID=e,this._state.initializeTileState(i,this.map?this.map.painter:null),this._cacheTimers[e.key]&&(clearTimeout(this._cacheTimers[e.key]),delete this._cacheTimers[e.key],this._setTileReloadTimer(e.key,i)));var o=Boolean(i);return o||(i=new t.Tile(e,this._source.tileSize*e.overscaleFactor()),this._loadTile(i,this._tileLoaded.bind(this,i,e.key,i.state))),i?(i.uses++,this._tiles[e.key]=i,o||this._source.fire(new t.Event("dataloading",{tile:i,coord:i.tileID,dataType:"source"})),i):null},i.prototype._setTileReloadTimer=function(t,e){var i=this;t in this._timers&&(clearTimeout(this._timers[t]),delete this._timers[t]);var o=e.getExpiryTimeout();o&&(this._timers[t]=setTimeout((function(){i._reloadTile(t,"expired"),delete i._timers[t];}),o));},i.prototype._removeTile=function(t){var e=this._tiles[t];e&&(e.uses--,delete this._tiles[t],this._timers[t]&&(clearTimeout(this._timers[t]),delete this._timers[t]),e.uses>0||(e.hasData()&&"reloading"!==e.state?this._cache.add(e.tileID,e,e.getExpiryTimeout()):(e.aborted=!0,this._abortTile(e),this._unloadTile(e))));},i.prototype.clearTiles=function(){for(var t in this._shouldReloadOnResume=!1,this._paused=!1,this._tiles)this._removeTile(t);this._cache.reset();},i.prototype.tilesIn=function(e,i,o){var r=this,a=[],n=this.transform;if(!n)return a;for(var s=o?n.getCameraQueryGeometry(e):e,l=e.map((function(t){return n.pointCoordinate(t)})),c=s.map((function(t){return n.pointCoordinate(t)})),u=this.getIds(),h=1/0,p=1/0,d=-1/0,_=-1/0,f=0,m=c;f<m.length;f+=1){var g=m[f];h=Math.min(h,g.x),p=Math.min(p,g.y),d=Math.max(d,g.x),_=Math.max(_,g.y);}for(var v=function(e){var o=r._tiles[u[e]];if(!o.holdingForFade()){var s=o.tileID,f=Math.pow(2,n.zoom-o.tileID.overscaledZ),m=i*o.queryPadding*t.EXTENT/o.tileSize/f,g=[s.getTilePoint(new t.MercatorCoordinate(h,p)),s.getTilePoint(new t.MercatorCoordinate(d,_))];if(g[0].x-m<t.EXTENT&&g[0].y-m<t.EXTENT&&g[1].x+m>=0&&g[1].y+m>=0){var v=l.map((function(t){return s.getTilePoint(t)})),y=c.map((function(t){return s.getTilePoint(t)}));a.push({tile:o,tileID:s,queryGeometry:v,cameraQueryGeometry:y,scale:f});}}},y=0;y<u.length;y++)v(y);return a},i.prototype.getVisibleCoordinates=function(t){for(var e=this,i=this.getRenderableIds(t).map((function(t){return e._tiles[t].tileID})),o=0,r=i;o<r.length;o+=1){var a=r[o];a.posMatrix=this.transform.calculatePosMatrix(a.toUnwrapped());}return i},i.prototype.hasTransition=function(){if(this._source.hasTransition())return !0;if(At(this._source.type))for(var e in this._tiles){var i=this._tiles[e];if(void 0!==i.fadeEndTime&&i.fadeEndTime>=t.browser.now())return !0}return !1},i.prototype.setFeatureState=function(t,e,i){t=t||"_geojsonTileLayer",this._state.updateState(t,e,i);},i.prototype.removeFeatureState=function(t,e,i){t=t||"_geojsonTileLayer",this._state.removeFeatureState(t,e,i);},i.prototype.getFeatureState=function(t,e){return t=t||"_geojsonTileLayer",this._state.getState(t,e)},i.prototype.setDependencies=function(t,e,i){var o=this._tiles[t];o&&o.setDependencies(e,i);},i.prototype.reloadTilesForDependencies=function(t,e){for(var i in this._tiles){this._tiles[i].hasDependency(t,e)&&this._reloadTile(i,"reloading");}this._cache.filter((function(i){return !i.hasDependency(t,e)}));},i}(t.Evented);function Dt(t,e){var i=Math.abs(2*t.wrap)-+(t.wrap<0),o=Math.abs(2*e.wrap)-+(e.wrap<0);return t.overscaledZ-e.overscaledZ||o-i||e.canonical.y-t.canonical.y||e.canonical.x-t.canonical.x}function At(t){return "raster"===t||"image"===t||"video"===t}function Rt(){return new t.window.Worker(hr.workerUrl)}Mt.maxOverzooming=10,Mt.maxUnderzooming=3;var kt=function(){this.active={};};kt.prototype.acquire=function(t){if(!this.workers)for(this.workers=[];this.workers.length<kt.workerCount;)this.workers.push(new Rt);return this.active[t]=!0,this.workers.slice()},kt.prototype.release=function(t){delete this.active[t],0===Object.keys(this.active).length&&(this.workers.forEach((function(t){t.terminate();})),this.workers=null);};var Bt,Ot=Math.floor(t.browser.hardwareConcurrency/2);function Ft(e,i){var o={};for(var r in e)"ref"!==r&&(o[r]=e[r]);return t.refProperties.forEach((function(t){t in i&&(o[t]=i[t]);})),o}function Ut(t){t=t.slice();for(var e=Object.create(null),i=0;i<t.length;i++)e[t[i].id]=t[i];for(var o=0;o<t.length;o++)"ref"in t[o]&&(t[o]=Ft(t[o],e[t[o].ref]));return t}kt.workerCount=Math.max(Math.min(Ot,6),1);var Nt={setStyle:"setStyle",addLayer:"addLayer",removeLayer:"removeLayer",setPaintProperty:"setPaintProperty",setLayoutProperty:"setLayoutProperty",setFilter:"setFilter",addSource:"addSource",removeSource:"removeSource",setGeoJSONSourceData:"setGeoJSONSourceData",setLayerZoomRange:"setLayerZoomRange",setLayerProperty:"setLayerProperty",setCenter:"setCenter",setZoom:"setZoom",setBearing:"setBearing",setPitch:"setPitch",setSprite:"setSprite",setGlyphs:"setGlyphs",setTransition:"setTransition",setLight:"setLight"};function Zt(t,e,i){i.push({command:Nt.addSource,args:[t,e[t]]});}function qt(t,e,i){e.push({command:Nt.removeSource,args:[t]}),i[t]=!0;}function jt(t,e,i,o){qt(t,i,o),Zt(t,e,i);}function Vt(e,i,o){var r;for(r in e[o])if(e[o].hasOwnProperty(r)&&"data"!==r&&!t.deepEqual(e[o][r],i[o][r]))return !1;for(r in i[o])if(i[o].hasOwnProperty(r)&&"data"!==r&&!t.deepEqual(e[o][r],i[o][r]))return !1;return !0}function Gt(e,i,o,r,a,n){var s;for(s in i=i||{},e=e||{})e.hasOwnProperty(s)&&(t.deepEqual(e[s],i[s])||o.push({command:n,args:[r,s,i[s],a]}));for(s in i)i.hasOwnProperty(s)&&!e.hasOwnProperty(s)&&(t.deepEqual(e[s],i[s])||o.push({command:n,args:[r,s,i[s],a]}));}function Wt(t){return t.id}function Xt(t,e){return t[e.id]=e,t}function Ht(e,i){if(!e)return [{command:Nt.setStyle,args:[i]}];var o=[];try{if(!t.deepEqual(e.version,i.version))return [{command:Nt.setStyle,args:[i]}];t.deepEqual(e.center,i.center)||o.push({command:Nt.setCenter,args:[i.center]}),t.deepEqual(e.zoom,i.zoom)||o.push({command:Nt.setZoom,args:[i.zoom]}),t.deepEqual(e.bearing,i.bearing)||o.push({command:Nt.setBearing,args:[i.bearing]}),t.deepEqual(e.pitch,i.pitch)||o.push({command:Nt.setPitch,args:[i.pitch]}),t.deepEqual(e.sprite,i.sprite)||o.push({command:Nt.setSprite,args:[i.sprite]}),t.deepEqual(e.glyphs,i.glyphs)||o.push({command:Nt.setGlyphs,args:[i.glyphs]}),t.deepEqual(e.transition,i.transition)||o.push({command:Nt.setTransition,args:[i.transition]}),t.deepEqual(e.light,i.light)||o.push({command:Nt.setLight,args:[i.light]});var r={},a=[];!function(e,i,o,r){var a;for(a in i=i||{},e=e||{})e.hasOwnProperty(a)&&(i.hasOwnProperty(a)||qt(a,o,r));for(a in i)i.hasOwnProperty(a)&&(e.hasOwnProperty(a)?t.deepEqual(e[a],i[a])||("geojson"===e[a].type&&"geojson"===i[a].type&&Vt(e,i,a)?o.push({command:Nt.setGeoJSONSourceData,args:[a,i[a].data]}):jt(a,i,o,r)):Zt(a,i,o));}(e.sources,i.sources,a,r);var n=[];e.layers&&e.layers.forEach((function(t){r[t.source]?o.push({command:Nt.removeLayer,args:[t.id]}):n.push(t);})),o=o.concat(a),function(e,i,o){i=i||[];var r,a,n,s,l,c,u,h=(e=e||[]).map(Wt),p=i.map(Wt),d=e.reduce(Xt,{}),_=i.reduce(Xt,{}),f=h.slice(),m=Object.create(null);for(r=0,a=0;r<h.length;r++)n=h[r],_.hasOwnProperty(n)?a++:(o.push({command:Nt.removeLayer,args:[n]}),f.splice(f.indexOf(n,a),1));for(r=0,a=0;r<p.length;r++)n=p[p.length-1-r],f[f.length-1-r]!==n&&(d.hasOwnProperty(n)?(o.push({command:Nt.removeLayer,args:[n]}),f.splice(f.lastIndexOf(n,f.length-a),1)):a++,c=f[f.length-r],o.push({command:Nt.addLayer,args:[_[n],c]}),f.splice(f.length-r,0,n),m[n]=!0);for(r=0;r<p.length;r++)if(s=d[n=p[r]],l=_[n],!m[n]&&!t.deepEqual(s,l))if(t.deepEqual(s.source,l.source)&&t.deepEqual(s["source-layer"],l["source-layer"])&&t.deepEqual(s.type,l.type)){for(u in Gt(s.layout,l.layout,o,n,null,Nt.setLayoutProperty),Gt(s.paint,l.paint,o,n,null,Nt.setPaintProperty),t.deepEqual(s.filter,l.filter)||o.push({command:Nt.setFilter,args:[n,l.filter]}),t.deepEqual(s.minzoom,l.minzoom)&&t.deepEqual(s.maxzoom,l.maxzoom)||o.push({command:Nt.setLayerZoomRange,args:[n,l.minzoom,l.maxzoom]}),s)s.hasOwnProperty(u)&&"layout"!==u&&"paint"!==u&&"filter"!==u&&"metadata"!==u&&"minzoom"!==u&&"maxzoom"!==u&&(0===u.indexOf("paint.")?Gt(s[u],l[u],o,n,u.slice(6),Nt.setPaintProperty):t.deepEqual(s[u],l[u])||o.push({command:Nt.setLayerProperty,args:[n,u,l[u]]}));for(u in l)l.hasOwnProperty(u)&&!s.hasOwnProperty(u)&&"layout"!==u&&"paint"!==u&&"filter"!==u&&"metadata"!==u&&"minzoom"!==u&&"maxzoom"!==u&&(0===u.indexOf("paint.")?Gt(s[u],l[u],o,n,u.slice(6),Nt.setPaintProperty):t.deepEqual(s[u],l[u])||o.push({command:Nt.setLayerProperty,args:[n,u,l[u]]}));}else o.push({command:Nt.removeLayer,args:[n]}),c=f[f.lastIndexOf(n)+1],o.push({command:Nt.addLayer,args:[l,c]});}(n,i.layers,o);}catch(t){console.warn("Unable to compute style diff:",t),o=[{command:Nt.setStyle,args:[i]}];}return o}var Kt=function(t,e,i){var o=this.boxCells=[],r=this.circleCells=[];this.xCellCount=Math.ceil(t/i),this.yCellCount=Math.ceil(e/i);for(var a=0;a<this.xCellCount*this.yCellCount;a++)o.push([]),r.push([]);this.circleKeys=[],this.boxKeys=[],this.bboxes=[],this.circles=[],this.width=t,this.height=e,this.xScale=this.xCellCount/t,this.yScale=this.yCellCount/e,this.boxUid=0,this.circleUid=0;};function Yt(e,i,o,r,a){var n=t.create();return i?(t.scale(n,n,[1/a,1/a,1]),o||t.rotateZ(n,n,r.angle)):t.multiply(n,r.labelPlaneMatrix,e),n}function Jt(e,i,o,r,a){if(i){var n=t.clone(e);return t.scale(n,n,[a,a,1]),o||t.rotateZ(n,n,-r.angle),n}return r.glCoordMatrix}function Qt(e,i){var o=[e.x,e.y,0,1];le(o,o,i);var r=o[3];return {point:new t.Point(o[0]/r,o[1]/r),signedDistanceFromCamera:r}}function $t(t,e){var i=t[0]/t[3],o=t[1]/t[3];return i>=-e[0]&&i<=e[0]&&o>=-e[1]&&o<=e[1]}function te(e,i,o,r,a,n,s,l){var c=r?e.textSizeData:e.iconSizeData,u=t.evaluateSizeForZoom(c,o.transform.zoom),h=[256/o.width*2+1,256/o.height*2+1],p=r?e.text.dynamicLayoutVertexArray:e.icon.dynamicLayoutVertexArray;p.clear();for(var d=e.lineVertexArray,_=r?e.text.placedSymbolArray:e.icon.placedSymbolArray,f=o.transform.width/o.transform.height,m=!1,g=0;g<_.length;g++){var v=_.get(g);if(v.hidden||v.writingMode===t.WritingMode.vertical&&!m)se(v.numGlyphs,p);else{m=!1;var y=[v.anchorX,v.anchorY,0,1];if(t.transformMat4(y,y,i),$t(y,h)){var x=.5+y[3]/o.transform.cameraToCenterDistance*.5,b=t.evaluateSizeForFeature(c,u,v),w=s?b*x:b/x,E=new t.Point(v.anchorX,v.anchorY),T=Qt(E,a);if(T.signedDistanceFromCamera<=0)se(v.numGlyphs,p);else{var I=T.point,S={},C=oe(v,w,!1,l,i,a,n,e.glyphOffsetArray,d,p,I,E,S,f);m=C.useVertical,(C.notEnoughRoom||m||C.needsFlipping&&oe(v,w,!0,l,i,a,n,e.glyphOffsetArray,d,p,I,E,S,f).notEnoughRoom)&&se(v.numGlyphs,p);}}else se(v.numGlyphs,p);}}r?e.text.dynamicLayoutVertexBuffer.updateData(p):e.icon.dynamicLayoutVertexBuffer.updateData(p);}function ee(t,e,i,o,r,a,n,s,l,c,u,h){var p=s.glyphStartIndex+s.numGlyphs,d=s.lineStartIndex,_=s.lineStartIndex+s.lineLength,f=e.getoffsetX(s.glyphStartIndex),m=e.getoffsetX(p-1),g=ae(t*f,i,o,r,a,n,s.segment,d,_,l,c,u,h);if(!g)return null;var v=ae(t*m,i,o,r,a,n,s.segment,d,_,l,c,u,h);return v?{first:g,last:v}:null}function ie(e,i,o,r){if(e===t.WritingMode.horizontal&&Math.abs(o.y-i.y)>Math.abs(o.x-i.x)*r)return {useVertical:!0};return (e===t.WritingMode.vertical?i.y<o.y:i.x>o.x)?{needsFlipping:!0}:null}function oe(e,i,o,r,a,n,s,l,c,u,h,p,d,_){var f,m=i/24,g=e.lineOffsetX*m,v=e.lineOffsetY*m;if(e.numGlyphs>1){var y=e.glyphStartIndex+e.numGlyphs,x=e.lineStartIndex,b=e.lineStartIndex+e.lineLength,w=ee(m,l,g,v,o,h,p,e,c,n,d,!1);if(!w)return {notEnoughRoom:!0};var E=Qt(w.first.point,s).point,T=Qt(w.last.point,s).point;if(r&&!o){var I=ie(e.writingMode,E,T,_);if(I)return I}f=[w.first];for(var S=e.glyphStartIndex+1;S<y-1;S++)f.push(ae(m*l.getoffsetX(S),g,v,o,h,p,e.segment,x,b,c,n,d,!1));f.push(w.last);}else{if(r&&!o){var C=Qt(p,a).point,P=e.lineStartIndex+e.segment+1,z=new t.Point(c.getx(P),c.gety(P)),L=Qt(z,a),M=L.signedDistanceFromCamera>0?L.point:re(p,z,C,1,a),D=ie(e.writingMode,C,M,_);if(D)return D}var A=ae(m*l.getoffsetX(e.glyphStartIndex),g,v,o,h,p,e.segment,e.lineStartIndex,e.lineStartIndex+e.lineLength,c,n,d,!1);if(!A)return {notEnoughRoom:!0};f=[A];}for(var R=0,k=f;R<k.length;R+=1){var B=k[R];t.addDynamicAttributes(u,B.point,B.angle);}return {}}function re(t,e,i,o,r){var a=Qt(t.add(t.sub(e)._unit()),r).point,n=i.sub(a);return i.add(n._mult(o/n.mag()))}function ae(e,i,o,r,a,n,s,l,c,u,h,p,d){var _=r?e-i:e+i,f=_>0?1:-1,m=0;r&&(f*=-1,m=Math.PI),f<0&&(m+=Math.PI);for(var g=f>0?l+s:l+s+1,v=g,y=a,x=a,b=0,w=0,E=Math.abs(_);b+w<=E;){if((g+=f)<l||g>=c)return null;if(x=y,void 0===(y=p[g])){var T=new t.Point(u.getx(g),u.gety(g)),I=Qt(T,h);if(I.signedDistanceFromCamera>0)y=p[g]=I.point;else{var S=g-f;y=re(0===b?n:new t.Point(u.getx(S),u.gety(S)),T,x,E-b+1,h);}}b+=w,w=x.dist(y);}var C=(E-b)/w,P=y.sub(x),z=P.mult(C)._add(x);return z._add(P._unit()._perp()._mult(o*f)),{point:z,angle:m+Math.atan2(y.y-x.y,y.x-x.x),tileDistance:d?{prevTileDistance:g-f===v?0:u.gettileUnitDistanceFromAnchor(g-f),lastSegmentViewportDistance:E-b}:null}}Kt.prototype.keysLength=function(){return this.boxKeys.length+this.circleKeys.length},Kt.prototype.insert=function(t,e,i,o,r){this._forEachCell(e,i,o,r,this._insertBoxCell,this.boxUid++),this.boxKeys.push(t),this.bboxes.push(e),this.bboxes.push(i),this.bboxes.push(o),this.bboxes.push(r);},Kt.prototype.insertCircle=function(t,e,i,o){this._forEachCell(e-o,i-o,e+o,i+o,this._insertCircleCell,this.circleUid++),this.circleKeys.push(t),this.circles.push(e),this.circles.push(i),this.circles.push(o);},Kt.prototype._insertBoxCell=function(t,e,i,o,r,a){this.boxCells[r].push(a);},Kt.prototype._insertCircleCell=function(t,e,i,o,r,a){this.circleCells[r].push(a);},Kt.prototype._query=function(t,e,i,o,r,a){if(i<0||t>this.width||o<0||e>this.height)return !r&&[];var n=[];if(t<=0&&e<=0&&this.width<=i&&this.height<=o){if(r)return !0;for(var s=0;s<this.boxKeys.length;s++)n.push({key:this.boxKeys[s],x1:this.bboxes[4*s],y1:this.bboxes[4*s+1],x2:this.bboxes[4*s+2],y2:this.bboxes[4*s+3]});for(var l=0;l<this.circleKeys.length;l++){var c=this.circles[3*l],u=this.circles[3*l+1],h=this.circles[3*l+2];n.push({key:this.circleKeys[l],x1:c-h,y1:u-h,x2:c+h,y2:u+h});}return a?n.filter(a):n}var p={hitTest:r,seenUids:{box:{},circle:{}}};return this._forEachCell(t,e,i,o,this._queryCell,n,p,a),r?n.length>0:n},Kt.prototype._queryCircle=function(t,e,i,o,r){var a=t-i,n=t+i,s=e-i,l=e+i;if(n<0||a>this.width||l<0||s>this.height)return !o&&[];var c=[],u={hitTest:o,circle:{x:t,y:e,radius:i},seenUids:{box:{},circle:{}}};return this._forEachCell(a,s,n,l,this._queryCellCircle,c,u,r),o?c.length>0:c},Kt.prototype.query=function(t,e,i,o,r){return this._query(t,e,i,o,!1,r)},Kt.prototype.hitTest=function(t,e,i,o,r){return this._query(t,e,i,o,!0,r)},Kt.prototype.hitTestCircle=function(t,e,i,o){return this._queryCircle(t,e,i,!0,o)},Kt.prototype._queryCell=function(t,e,i,o,r,a,n,s){var l=n.seenUids,c=this.boxCells[r];if(null!==c)for(var u=this.bboxes,h=0,p=c;h<p.length;h+=1){var d=p[h];if(!l.box[d]){l.box[d]=!0;var _=4*d;if(t<=u[_+2]&&e<=u[_+3]&&i>=u[_+0]&&o>=u[_+1]&&(!s||s(this.boxKeys[d]))){if(n.hitTest)return a.push(!0),!0;a.push({key:this.boxKeys[d],x1:u[_],y1:u[_+1],x2:u[_+2],y2:u[_+3]});}}}var f=this.circleCells[r];if(null!==f)for(var m=this.circles,g=0,v=f;g<v.length;g+=1){var y=v[g];if(!l.circle[y]){l.circle[y]=!0;var x=3*y;if(this._circleAndRectCollide(m[x],m[x+1],m[x+2],t,e,i,o)&&(!s||s(this.circleKeys[y]))){if(n.hitTest)return a.push(!0),!0;var b=m[x],w=m[x+1],E=m[x+2];a.push({key:this.circleKeys[y],x1:b-E,y1:w-E,x2:b+E,y2:w+E});}}}},Kt.prototype._queryCellCircle=function(t,e,i,o,r,a,n,s){var l=n.circle,c=n.seenUids,u=this.boxCells[r];if(null!==u)for(var h=this.bboxes,p=0,d=u;p<d.length;p+=1){var _=d[p];if(!c.box[_]){c.box[_]=!0;var f=4*_;if(this._circleAndRectCollide(l.x,l.y,l.radius,h[f+0],h[f+1],h[f+2],h[f+3])&&(!s||s(this.boxKeys[_])))return a.push(!0),!0}}var m=this.circleCells[r];if(null!==m)for(var g=this.circles,v=0,y=m;v<y.length;v+=1){var x=y[v];if(!c.circle[x]){c.circle[x]=!0;var b=3*x;if(this._circlesCollide(g[b],g[b+1],g[b+2],l.x,l.y,l.radius)&&(!s||s(this.circleKeys[x])))return a.push(!0),!0}}},Kt.prototype._forEachCell=function(t,e,i,o,r,a,n,s){for(var l=this._convertToXCellCoord(t),c=this._convertToYCellCoord(e),u=this._convertToXCellCoord(i),h=this._convertToYCellCoord(o),p=l;p<=u;p++)for(var d=c;d<=h;d++){var _=this.xCellCount*d+p;if(r.call(this,t,e,i,o,_,a,n,s))return}},Kt.prototype._convertToXCellCoord=function(t){return Math.max(0,Math.min(this.xCellCount-1,Math.floor(t*this.xScale)))},Kt.prototype._convertToYCellCoord=function(t){return Math.max(0,Math.min(this.yCellCount-1,Math.floor(t*this.yScale)))},Kt.prototype._circlesCollide=function(t,e,i,o,r,a){var n=o-t,s=r-e,l=i+a;return l*l>n*n+s*s},Kt.prototype._circleAndRectCollide=function(t,e,i,o,r,a,n){var s=(a-o)/2,l=Math.abs(t-(o+s));if(l>s+i)return !1;var c=(n-r)/2,u=Math.abs(e-(r+c));if(u>c+i)return !1;if(l<=s||u<=c)return !0;var h=l-s,p=u-c;return h*h+p*p<=i*i};var ne=new Float32Array([-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0,-1/0,-1/0,0]);function se(t,e){for(var i=0;i<t;i++){var o=e.length;e.resize(o+4),e.float32.set(ne,3*o);}}function le(t,e,i){var o=e[0],r=e[1];return t[0]=i[0]*o+i[4]*r+i[12],t[1]=i[1]*o+i[5]*r+i[13],t[3]=i[3]*o+i[7]*r+i[15],t}var ce=function(t,e,i){void 0===e&&(e=new Kt(t.width+200,t.height+200,25)),void 0===i&&(i=new Kt(t.width+200,t.height+200,25)),this.transform=t,this.grid=e,this.ignoredGrid=i,this.pitchfactor=Math.cos(t._pitch)*t.cameraToCenterDistance,this.screenRightBoundary=t.width+100,this.screenBottomBoundary=t.height+100,this.gridRightBoundary=t.width+200,this.gridBottomBoundary=t.height+200;};function ue(t,e,i){t[e+4]=i?1:0;}function he(e,i,o){return i*(t.EXTENT/(e.tileSize*Math.pow(2,o-e.tileID.overscaledZ)))}ce.prototype.placeCollisionBox=function(t,e,i,o,r){var a=this.projectAndGetPerspectiveRatio(o,t.anchorPointX,t.anchorPointY),n=i*a.perspectiveRatio,s=t.x1*n+a.point.x,l=t.y1*n+a.point.y,c=t.x2*n+a.point.x,u=t.y2*n+a.point.y;return !this.isInsideGrid(s,l,c,u)||!e&&this.grid.hitTest(s,l,c,u,r)?{box:[],offscreen:!1}:{box:[s,l,c,u],offscreen:this.isOffscreen(s,l,c,u)}},ce.prototype.approximateTileDistance=function(t,e,i,o,r){var a=r?1:o/this.pitchfactor,n=t.lastSegmentViewportDistance*i;return t.prevTileDistance+n+(a-1)*n*Math.abs(Math.sin(e))},ce.prototype.placeCollisionCircles=function(e,i,o,r,a,n,s,l,c,u,h,p,d){var _=[],f=this.projectAnchor(c,a.anchorX,a.anchorY),m=l/24,g=a.lineOffsetX*l,v=a.lineOffsetY*l,y=new t.Point(a.anchorX,a.anchorY),x=ee(m,s,g,v,!1,Qt(y,u).point,y,a,n,u,{},!0),b=!1,w=!1,E=!0,T=f.perspectiveRatio*r,I=1/(r*o),S=0,C=0;x&&(S=this.approximateTileDistance(x.first.tileDistance,x.first.angle,I,f.cameraDistance,p),C=this.approximateTileDistance(x.last.tileDistance,x.last.angle,I,f.cameraDistance,p));for(var P=0;P<e.length;P+=5){var z=e[P],L=e[P+1],M=e[P+2],D=e[P+3];if(!x||D<-S||D>C)ue(e,P,!1);else{var A=this.projectPoint(c,z,L),R=M*T;if(_.length>0){var k=A.x-_[_.length-4],B=A.y-_[_.length-3];if(R*R*2>k*k+B*B)if(P+8<e.length){var O=e[P+8];if(O>-S&&O<C){ue(e,P,!1);continue}}}var F=P/5;_.push(A.x,A.y,R,F),ue(e,P,!0);var U=A.x-R,N=A.y-R,Z=A.x+R,q=A.y+R;if(E=E&&this.isOffscreen(U,N,Z,q),w=w||this.isInsideGrid(U,N,Z,q),!i&&this.grid.hitTestCircle(A.x,A.y,R,d)){if(!h)return {circles:[],offscreen:!1};b=!0;}}}return {circles:b||!w?[]:_,offscreen:E}},ce.prototype.queryRenderedSymbols=function(e){if(0===e.length||0===this.grid.keysLength()&&0===this.ignoredGrid.keysLength())return {};for(var i=[],o=1/0,r=1/0,a=-1/0,n=-1/0,s=0,l=e;s<l.length;s+=1){var c=l[s],u=new t.Point(c.x+100,c.y+100);o=Math.min(o,u.x),r=Math.min(r,u.y),a=Math.max(a,u.x),n=Math.max(n,u.y),i.push(u);}for(var h={},p={},d=0,_=this.grid.query(o,r,a,n).concat(this.ignoredGrid.query(o,r,a,n));d<_.length;d+=1){var f=_[d],m=f.key;if(void 0===h[m.bucketInstanceId]&&(h[m.bucketInstanceId]={}),!h[m.bucketInstanceId][m.featureIndex]){var g=[new t.Point(f.x1,f.y1),new t.Point(f.x2,f.y1),new t.Point(f.x2,f.y2),new t.Point(f.x1,f.y2)];t.polygonIntersectsPolygon(i,g)&&(h[m.bucketInstanceId][m.featureIndex]=!0,void 0===p[m.bucketInstanceId]&&(p[m.bucketInstanceId]=[]),p[m.bucketInstanceId].push(m.featureIndex));}}return p},ce.prototype.insertCollisionBox=function(t,e,i,o,r){var a={bucketInstanceId:i,featureIndex:o,collisionGroupID:r};(e?this.ignoredGrid:this.grid).insert(a,t[0],t[1],t[2],t[3]);},ce.prototype.insertCollisionCircles=function(t,e,i,o,r){for(var a=e?this.ignoredGrid:this.grid,n={bucketInstanceId:i,featureIndex:o,collisionGroupID:r},s=0;s<t.length;s+=4)a.insertCircle(n,t[s],t[s+1],t[s+2]);},ce.prototype.projectAnchor=function(t,e,i){var o=[e,i,0,1];return le(o,o,t),{perspectiveRatio:.5+this.transform.cameraToCenterDistance/o[3]*.5,cameraDistance:o[3]}},ce.prototype.projectPoint=function(e,i,o){var r=[i,o,0,1];return le(r,r,e),new t.Point((r[0]/r[3]+1)/2*this.transform.width+100,(-r[1]/r[3]+1)/2*this.transform.height+100)},ce.prototype.projectAndGetPerspectiveRatio=function(e,i,o){var r=[i,o,0,1];return le(r,r,e),{point:new t.Point((r[0]/r[3]+1)/2*this.transform.width+100,(-r[1]/r[3]+1)/2*this.transform.height+100),perspectiveRatio:.5+this.transform.cameraToCenterDistance/r[3]*.5}},ce.prototype.isOffscreen=function(t,e,i,o){return i<100||t>=this.screenRightBoundary||o<100||e>this.screenBottomBoundary},ce.prototype.isInsideGrid=function(t,e,i,o){return i>=0&&t<this.gridRightBoundary&&o>=0&&e<this.gridBottomBoundary};var pe=function(t,e,i,o){this.opacity=t?Math.max(0,Math.min(1,t.opacity+(t.placed?e:-e))):o&&i?1:0,this.placed=i;};pe.prototype.isHidden=function(){return 0===this.opacity&&!this.placed};var de=function(t,e,i,o,r){this.text=new pe(t?t.text:null,e,i,r),this.icon=new pe(t?t.icon:null,e,o,r);};de.prototype.isHidden=function(){return this.text.isHidden()&&this.icon.isHidden()};var _e=function(t,e,i){this.text=t,this.icon=e,this.skipFade=i;},fe=function(t,e,i,o,r){this.bucketInstanceId=t,this.featureIndex=e,this.sourceLayerIndex=i,this.bucketIndex=o,this.tileID=r;},me=function(t){this.crossSourceCollisions=t,this.maxGroupID=0,this.collisionGroups={};};function ge(e,i,o,r,a){var n=t.getAnchorAlignment(e),s=-(n.horizontalAlign-.5)*i,l=-(n.verticalAlign-.5)*o,c=t.evaluateVariableOffset(e,r);return new t.Point(s+c[0]*a,l+c[1]*a)}function ve(e,i,o,r,a,n){var s=e.x1,l=e.x2,c=e.y1,u=e.y2,h=e.anchorPointX,p=e.anchorPointY,d=new t.Point(i,o);return r&&d._rotate(a?n:-n),{x1:s+d.x,y1:c+d.y,x2:l+d.x,y2:u+d.y,anchorPointX:h,anchorPointY:p}}me.prototype.get=function(t){if(this.crossSourceCollisions)return {ID:0,predicate:null};if(!this.collisionGroups[t]){var e=++this.maxGroupID;this.collisionGroups[t]={ID:e,predicate:function(t){return t.collisionGroupID===e}};}return this.collisionGroups[t]};var ye=function(t,e,i,o){this.transform=t.clone(),this.collisionIndex=new ce(this.transform),this.placements={},this.opacities={},this.variableOffsets={},this.stale=!1,this.commitTime=0,this.fadeDuration=e,this.retainedQueryData={},this.collisionGroups=new me(i),this.prevPlacement=o,o&&(o.prevPlacement=void 0),this.placedOrientations={};};function xe(t,e,i,o,r){t.emplaceBack(e?1:0,i?1:0,o||0,r||0),t.emplaceBack(e?1:0,i?1:0,o||0,r||0),t.emplaceBack(e?1:0,i?1:0,o||0,r||0),t.emplaceBack(e?1:0,i?1:0,o||0,r||0);}ye.prototype.getBucketParts=function(e,i,o,r){var a=o.getBucket(i),n=o.latestFeatureIndex;if(a&&n&&i.id===a.layerIds[0]){var s=o.collisionBoxArray,l=a.layers[0].layout,c=Math.pow(2,this.transform.zoom-o.tileID.overscaledZ),u=o.tileSize/t.EXTENT,h=this.transform.calculatePosMatrix(o.tileID.toUnwrapped()),p=Yt(h,"map"===l.get("text-pitch-alignment"),"map"===l.get("text-rotation-alignment"),this.transform,he(o,1,this.transform.zoom));this.retainedQueryData[a.bucketInstanceId]=new fe(a.bucketInstanceId,n,a.sourceLayerIndex,a.index,o.tileID);var d={bucket:a,layout:l,posMatrix:h,textLabelPlaneMatrix:p,scale:c,textPixelRatio:u,holdingForFade:o.holdingForFade(),collisionBoxArray:s,partiallyEvaluatedTextSize:t.evaluateSizeForZoom(a.textSizeData,this.transform.zoom),collisionGroup:this.collisionGroups.get(a.sourceID)};if(r)for(var _=0,f=a.sortKeyRanges;_<f.length;_+=1){var m=f[_],g=m.sortKey,v=m.symbolInstanceStart,y=m.symbolInstanceEnd;e.push({sortKey:g,symbolInstanceStart:v,symbolInstanceEnd:y,parameters:d});}else e.push({symbolInstanceStart:0,symbolInstanceEnd:a.symbolInstances.length,parameters:d});}},ye.prototype.attemptAnchorPlacement=function(t,e,i,o,r,a,n,s,l,c,u,h,p,d,_){var f,m=[h.textOffset0,h.textOffset1],g=ge(t,i,o,m,r),v=this.collisionIndex.placeCollisionBox(ve(e,g.x,g.y,a,n,this.transform.angle),u,s,l,c.predicate);if(_&&0===this.collisionIndex.placeCollisionBox(ve(_,g.x,g.y,a,n,this.transform.angle),u,s,l,c.predicate).box.length)return;if(v.box.length>0)return this.prevPlacement&&this.prevPlacement.variableOffsets[h.crossTileID]&&this.prevPlacement.placements[h.crossTileID]&&this.prevPlacement.placements[h.crossTileID].text&&(f=this.prevPlacement.variableOffsets[h.crossTileID].anchor),this.variableOffsets[h.crossTileID]={textOffset:m,width:i,height:o,anchor:t,textBoxScale:r,prevAnchor:f},this.markUsedJustification(p,t,h,d),p.allowVerticalPlacement&&(this.markUsedOrientation(p,d,h),this.placedOrientations[h.crossTileID]=d),{shift:g,placedGlyphBoxes:v}},ye.prototype.placeLayerBucketPart=function(e,i,o){var r=this,a=e.parameters,n=a.bucket,s=a.layout,l=a.posMatrix,c=a.textLabelPlaneMatrix,u=a.scale,h=a.textPixelRatio,p=a.holdingForFade,d=a.collisionBoxArray,_=a.partiallyEvaluatedTextSize,f=a.collisionGroup,m=s.get("text-optional"),g=s.get("icon-optional"),v=s.get("text-allow-overlap"),y=s.get("icon-allow-overlap"),x="map"===s.get("text-rotation-alignment"),b="map"===s.get("text-pitch-alignment"),w="none"!==s.get("icon-text-fit"),E="viewport-y"===s.get("symbol-z-order"),T=v&&(y||!n.hasIconData()||g),I=y&&(v||!n.hasTextData()||m);!n.collisionArrays&&d&&n.deserializeCollisionBoxes(d);var S=function(e,a){if(!i[e.crossTileID])if(p)r.placements[e.crossTileID]=new _e(!1,!1,!1);else{var d,E=!1,S=!1,C=!0,P=null,z={box:null,offscreen:null},L={box:null,offscreen:null},M=null,D=null,A=0,R=0,k=0;a.textFeatureIndex&&(A=a.textFeatureIndex),a.verticalTextFeatureIndex&&(R=a.verticalTextFeatureIndex);var B=a.textBox;if(B){var O=function(i){var o=t.WritingMode.horizontal;if(n.allowVerticalPlacement&&!i&&r.prevPlacement){var a=r.prevPlacement.placedOrientations[e.crossTileID];a&&(r.placedOrientations[e.crossTileID]=a,o=a,r.markUsedOrientation(n,o,e));}return o},F=function(i,o){if(n.allowVerticalPlacement&&e.numVerticalGlyphVertices>0&&a.verticalTextBox)for(var r=0,s=n.writingModes;r<s.length;r+=1){if(s[r]===t.WritingMode.vertical?(z=o(),L=z):z=i(),z&&z.box&&z.box.length)break}else z=i();};if(s.get("text-variable-anchor")){var U=s.get("text-variable-anchor");if(r.prevPlacement&&r.prevPlacement.variableOffsets[e.crossTileID]){var N=r.prevPlacement.variableOffsets[e.crossTileID];U.indexOf(N.anchor)>0&&(U=U.filter((function(t){return t!==N.anchor}))).unshift(N.anchor);}var Z=function(t,i,o){for(var a=t.x2-t.x1,s=t.y2-t.y1,c=e.textBoxScale,u=w&&!y?i:null,p={box:[],offscreen:!1},d=v?2*U.length:U.length,_=0;_<d;++_){var m=U[_%U.length],g=_>=U.length,T=r.attemptAnchorPlacement(m,t,a,s,c,x,b,h,l,f,g,e,n,o,u);if(T&&(p=T.placedGlyphBoxes)&&p.box&&p.box.length){E=!0,P=T.shift;break}}return p};F((function(){return Z(B,a.iconBox,t.WritingMode.horizontal)}),(function(){var i=a.verticalTextBox,o=z&&z.box&&z.box.length;return n.allowVerticalPlacement&&!o&&e.numVerticalGlyphVertices>0&&i?Z(i,a.verticalIconBox,t.WritingMode.vertical):{box:null,offscreen:null}})),z&&(E=z.box,C=z.offscreen);var q=O(z&&z.box);if(!E&&r.prevPlacement){var j=r.prevPlacement.variableOffsets[e.crossTileID];j&&(r.variableOffsets[e.crossTileID]=j,r.markUsedJustification(n,j.anchor,e,q));}}else{var V=function(t,i){var o=r.collisionIndex.placeCollisionBox(t,v,h,l,f.predicate);return o&&o.box&&o.box.length&&(r.markUsedOrientation(n,i,e),r.placedOrientations[e.crossTileID]=i),o};F((function(){return V(B,t.WritingMode.horizontal)}),(function(){var i=a.verticalTextBox;return n.allowVerticalPlacement&&e.numVerticalGlyphVertices>0&&i?V(i,t.WritingMode.vertical):{box:null,offscreen:null}})),O(z&&z.box&&z.box.length);}}E=(d=z)&&d.box&&d.box.length>0,C=d&&d.offscreen;var G=a.textCircles;if(G){var W=n.text.placedSymbolArray.get(e.centerJustifiedTextSymbolIndex),X=t.evaluateSizeForFeature(n.textSizeData,_,W);M=r.collisionIndex.placeCollisionCircles(G,v,u,h,W,n.lineVertexArray,n.glyphOffsetArray,X,l,c,o,b,f.predicate),E=v||M.circles.length>0,C=C&&M.offscreen;}if(a.iconFeatureIndex&&(k=a.iconFeatureIndex),a.iconBox){var H=function(t){var e=w&&P?ve(t,P.x,P.y,x,b,r.transform.angle):t;return r.collisionIndex.placeCollisionBox(e,y,h,l,f.predicate)};S=L&&L.box&&L.box.length&&a.verticalIconBox?(D=H(a.verticalIconBox)).box.length>0:(D=H(a.iconBox)).box.length>0,C=C&&D.offscreen;}var K=m||0===e.numHorizontalGlyphVertices&&0===e.numVerticalGlyphVertices,Y=g||0===e.numIconVertices;K||Y?Y?K||(S=S&&E):E=S&&E:S=E=S&&E,E&&d&&d.box&&(L&&L.box&&R?r.collisionIndex.insertCollisionBox(d.box,s.get("text-ignore-placement"),n.bucketInstanceId,R,f.ID):r.collisionIndex.insertCollisionBox(d.box,s.get("text-ignore-placement"),n.bucketInstanceId,A,f.ID)),S&&D&&r.collisionIndex.insertCollisionBox(D.box,s.get("icon-ignore-placement"),n.bucketInstanceId,k,f.ID),E&&M&&r.collisionIndex.insertCollisionCircles(M.circles,s.get("text-ignore-placement"),n.bucketInstanceId,A,f.ID),r.placements[e.crossTileID]=new _e(E||T,S||I,C||n.justReloaded),i[e.crossTileID]=!0;}};if(E)for(var C=n.getSortedSymbolIndexes(this.transform.angle),P=C.length-1;P>=0;--P){var z=C[P];S(n.symbolInstances.get(z),n.collisionArrays[z]);}else for(var L=e.symbolInstanceStart;L<e.symbolInstanceEnd;L++)S(n.symbolInstances.get(L),n.collisionArrays[L]);n.justReloaded=!1;},ye.prototype.markUsedJustification=function(e,i,o,r){var a,n={left:o.leftJustifiedTextSymbolIndex,center:o.centerJustifiedTextSymbolIndex,right:o.rightJustifiedTextSymbolIndex};a=r===t.WritingMode.vertical?o.verticalPlacedTextSymbolIndex:n[t.getAnchorJustification(i)];for(var s=0,l=[o.leftJustifiedTextSymbolIndex,o.centerJustifiedTextSymbolIndex,o.rightJustifiedTextSymbolIndex,o.verticalPlacedTextSymbolIndex];s<l.length;s+=1){var c=l[s];c>=0&&(e.text.placedSymbolArray.get(c).crossTileID=a>=0&&c!==a?0:o.crossTileID);}},ye.prototype.markUsedOrientation=function(e,i,o){for(var r=i===t.WritingMode.horizontal||i===t.WritingMode.horizontalOnly?i:0,a=i===t.WritingMode.vertical?i:0,n=0,s=[o.leftJustifiedTextSymbolIndex,o.centerJustifiedTextSymbolIndex,o.rightJustifiedTextSymbolIndex];n<s.length;n+=1){var l=s[n];e.text.placedSymbolArray.get(l).placedOrientation=r;}o.verticalPlacedTextSymbolIndex&&(e.text.placedSymbolArray.get(o.verticalPlacedTextSymbolIndex).placedOrientation=a);},ye.prototype.commit=function(t){this.commitTime=t,this.zoomAtLastRecencyCheck=this.transform.zoom;var e=this.prevPlacement,i=!1;this.prevZoomAdjustment=e?e.zoomAdjustment(this.transform.zoom):0;var o=e?e.symbolFadeChange(t):1,r=e?e.opacities:{},a=e?e.variableOffsets:{},n=e?e.placedOrientations:{};for(var s in this.placements){var l=this.placements[s],c=r[s];c?(this.opacities[s]=new de(c,o,l.text,l.icon),i=i||l.text!==c.text.placed||l.icon!==c.icon.placed):(this.opacities[s]=new de(null,o,l.text,l.icon,l.skipFade),i=i||l.text||l.icon);}for(var u in r){var h=r[u];if(!this.opacities[u]){var p=new de(h,o,!1,!1);p.isHidden()||(this.opacities[u]=p,i=i||h.text.placed||h.icon.placed);}}for(var d in a)this.variableOffsets[d]||!this.opacities[d]||this.opacities[d].isHidden()||(this.variableOffsets[d]=a[d]);for(var _ in n)this.placedOrientations[_]||!this.opacities[_]||this.opacities[_].isHidden()||(this.placedOrientations[_]=n[_]);i?this.lastPlacementChangeTime=t:"number"!=typeof this.lastPlacementChangeTime&&(this.lastPlacementChangeTime=e?e.lastPlacementChangeTime:t);},ye.prototype.updateLayerOpacities=function(t,e){for(var i={},o=0,r=e;o<r.length;o+=1){var a=r[o],n=a.getBucket(t);n&&a.latestFeatureIndex&&t.id===n.layerIds[0]&&this.updateBucketOpacities(n,i,a.collisionBoxArray);}},ye.prototype.updateBucketOpacities=function(e,i,o){var r=this;e.hasTextData()&&e.text.opacityVertexArray.clear(),e.hasIconData()&&e.icon.opacityVertexArray.clear(),e.hasIconCollisionBoxData()&&e.iconCollisionBox.collisionVertexArray.clear(),e.hasTextCollisionBoxData()&&e.textCollisionBox.collisionVertexArray.clear(),e.hasIconCollisionCircleData()&&e.iconCollisionCircle.collisionVertexArray.clear(),e.hasTextCollisionCircleData()&&e.textCollisionCircle.collisionVertexArray.clear();var a=e.layers[0].layout,n=new de(null,0,!1,!1,!0),s=a.get("text-allow-overlap"),l=a.get("icon-allow-overlap"),c=a.get("text-variable-anchor"),u="map"===a.get("text-rotation-alignment"),h="map"===a.get("text-pitch-alignment"),p="none"!==a.get("icon-text-fit"),d=new de(null,0,s&&(l||!e.hasIconData()||a.get("icon-optional")),l&&(s||!e.hasTextData()||a.get("text-optional")),!0);!e.collisionArrays&&o&&(e.hasIconCollisionBoxData()||e.hasIconCollisionCircleData()||e.hasTextCollisionBoxData()||e.hasTextCollisionCircleData())&&e.deserializeCollisionBoxes(o);for(var _=function(t,e,i){for(var o=0;o<e/4;o++)t.opacityVertexArray.emplaceBack(i);},f=function(o){var a=e.symbolInstances.get(o),s=a.numHorizontalGlyphVertices,l=a.numVerticalGlyphVertices,f=a.crossTileID,m=i[f],g=r.opacities[f];m?g=n:g||(g=d,r.opacities[f]=g),i[f]=!0;var v=s>0||l>0,y=a.numIconVertices>0,x=r.placedOrientations[a.crossTileID],b=x===t.WritingMode.vertical,w=x===t.WritingMode.horizontal||x===t.WritingMode.horizontalOnly;if(v){var E=Pe(g.text),T=b?ze:E;_(e.text,s,T);var I=w?ze:E;_(e.text,l,I);var S=g.text.isHidden();[a.rightJustifiedTextSymbolIndex,a.centerJustifiedTextSymbolIndex,a.leftJustifiedTextSymbolIndex].forEach((function(t){t>=0&&(e.text.placedSymbolArray.get(t).hidden=S||b?1:0);})),a.verticalPlacedTextSymbolIndex>=0&&(e.text.placedSymbolArray.get(a.verticalPlacedTextSymbolIndex).hidden=S||w?1:0);var C=r.variableOffsets[a.crossTileID];C&&r.markUsedJustification(e,C.anchor,a,x);var P=r.placedOrientations[a.crossTileID];P&&(r.markUsedJustification(e,"left",a,P),r.markUsedOrientation(e,P,a));}if(y){var z=Pe(g.icon),L=!(p&&a.verticalPlacedIconSymbolIndex&&b);if(a.placedIconSymbolIndex>=0){var M=L?z:ze;_(e.icon,a.numIconVertices,M),e.icon.placedSymbolArray.get(a.placedIconSymbolIndex).hidden=g.icon.isHidden();}if(a.verticalPlacedIconSymbolIndex>=0){var D=L?ze:z;_(e.icon,a.numVerticalIconVertices,D),e.icon.placedSymbolArray.get(a.verticalPlacedIconSymbolIndex).hidden=g.icon.isHidden();}}if(e.hasIconCollisionBoxData()||e.hasIconCollisionCircleData()||e.hasTextCollisionBoxData()||e.hasTextCollisionCircleData()){var A=e.collisionArrays[o];if(A){var R=new t.Point(0,0);if(A.textBox||A.verticalTextBox){var k=!0;if(c){var B=r.variableOffsets[f];B?(R=ge(B.anchor,B.width,B.height,B.textOffset,B.textBoxScale),u&&R._rotate(h?r.transform.angle:-r.transform.angle)):k=!1;}A.textBox&&xe(e.textCollisionBox.collisionVertexArray,g.text.placed,!k||b,R.x,R.y),A.verticalTextBox&&xe(e.textCollisionBox.collisionVertexArray,g.text.placed,!k||w,R.x,R.y);}var O=Boolean(!w&&A.verticalIconBox);A.iconBox&&xe(e.iconCollisionBox.collisionVertexArray,g.icon.placed,O,p?R.x:0,p?R.y:0),A.verticalIconBox&&xe(e.iconCollisionBox.collisionVertexArray,g.icon.placed,!O,p?R.x:0,p?R.y:0);var F=A.textCircles;if(F&&e.hasTextCollisionCircleData())for(var U=0;U<F.length;U+=5){var N=m||0===F[U+4];xe(e.textCollisionCircle.collisionVertexArray,g.text.placed,N);}}}},m=0;m<e.symbolInstances.length;m++)f(m);e.sortFeatures(this.transform.angle),this.retainedQueryData[e.bucketInstanceId]&&(this.retainedQueryData[e.bucketInstanceId].featureSortOrder=e.featureSortOrder),e.hasTextData()&&e.text.opacityVertexBuffer&&e.text.opacityVertexBuffer.updateData(e.text.opacityVertexArray),e.hasIconData()&&e.icon.opacityVertexBuffer&&e.icon.opacityVertexBuffer.updateData(e.icon.opacityVertexArray),e.hasIconCollisionBoxData()&&e.iconCollisionBox.collisionVertexBuffer&&e.iconCollisionBox.collisionVertexBuffer.updateData(e.iconCollisionBox.collisionVertexArray),e.hasTextCollisionBoxData()&&e.textCollisionBox.collisionVertexBuffer&&e.textCollisionBox.collisionVertexBuffer.updateData(e.textCollisionBox.collisionVertexArray),e.hasIconCollisionCircleData()&&e.iconCollisionCircle.collisionVertexBuffer&&e.iconCollisionCircle.collisionVertexBuffer.updateData(e.iconCollisionCircle.collisionVertexArray),e.hasTextCollisionCircleData()&&e.textCollisionCircle.collisionVertexBuffer&&e.textCollisionCircle.collisionVertexBuffer.updateData(e.textCollisionCircle.collisionVertexArray);},ye.prototype.symbolFadeChange=function(t){return 0===this.fadeDuration?1:(t-this.commitTime)/this.fadeDuration+this.prevZoomAdjustment},ye.prototype.zoomAdjustment=function(t){return Math.max(0,(this.transform.zoom-t)/1.5)},ye.prototype.hasTransitions=function(t){return this.stale||t-this.lastPlacementChangeTime<this.fadeDuration},ye.prototype.stillRecent=function(t,e){var i=this.zoomAtLastRecencyCheck===e?1-this.zoomAdjustment(e):1;return this.zoomAtLastRecencyCheck=e,this.commitTime+this.fadeDuration*i>t},ye.prototype.setStale=function(){this.stale=!0;};var be=Math.pow(2,25),we=Math.pow(2,24),Ee=Math.pow(2,17),Te=Math.pow(2,16),Ie=Math.pow(2,9),Se=Math.pow(2,8),Ce=Math.pow(2,1);function Pe(t){if(0===t.opacity&&!t.placed)return 0;if(1===t.opacity&&t.placed)return 4294967295;var e=t.placed?1:0,i=Math.floor(127*t.opacity);return i*be+e*we+i*Ee+e*Te+i*Ie+e*Se+i*Ce+e}var ze=0,Le=function(t){this._sortAcrossTiles="viewport-y"!==t.layout.get("symbol-z-order")&&void 0!==t.layout.get("symbol-sort-key").constantOr(1),this._currentTileIndex=0,this._currentPartIndex=0,this._seenCrossTileIDs={},this._bucketParts=[];};Le.prototype.continuePlacement=function(t,e,i,o,r){for(var a=this._bucketParts;this._currentTileIndex<t.length;){var n=t[this._currentTileIndex];if(e.getBucketParts(a,o,n,this._sortAcrossTiles),this._currentTileIndex++,r())return !0}for(this._sortAcrossTiles&&(this._sortAcrossTiles=!1,a.sort((function(t,e){return t.sortKey-e.sortKey})));this._currentPartIndex<a.length;){var s=a[this._currentPartIndex];if(e.placeLayerBucketPart(s,this._seenCrossTileIDs,i),this._currentPartIndex++,r())return !0}return !1};var Me=function(t,e,i,o,r,a,n){this.placement=new ye(t,r,a,n),this._currentPlacementIndex=e.length-1,this._forceFullPlacement=i,this._showCollisionBoxes=o,this._done=!1;};Me.prototype.isDone=function(){return this._done},Me.prototype.continuePlacement=function(e,i,o){for(var r=this,a=t.browser.now(),n=function(){var e=t.browser.now()-a;return !r._forceFullPlacement&&e>2};this._currentPlacementIndex>=0;){var s=i[e[this._currentPlacementIndex]],l=this.placement.collisionIndex.transform.zoom;if("symbol"===s.type&&(!s.minzoom||s.minzoom<=l)&&(!s.maxzoom||s.maxzoom>l)){if(this._inProgressLayer||(this._inProgressLayer=new Le(s)),this._inProgressLayer.continuePlacement(o[s.source],this.placement,this._showCollisionBoxes,s,n))return;delete this._inProgressLayer;}this._currentPlacementIndex--;}this._done=!0;},Me.prototype.commit=function(t){return this.placement.commit(t),this.placement};var De=512/t.EXTENT/2,Ae=function(t,e,i){this.tileID=t,this.indexedSymbolInstances={},this.bucketInstanceId=i;for(var o=0;o<e.length;o++){var r=e.get(o),a=r.key;this.indexedSymbolInstances[a]||(this.indexedSymbolInstances[a]=[]),this.indexedSymbolInstances[a].push({crossTileID:r.crossTileID,coord:this.getScaledCoordinates(r,t)});}};Ae.prototype.getScaledCoordinates=function(e,i){var o=i.canonical.z-this.tileID.canonical.z,r=De/Math.pow(2,o);return {x:Math.floor((i.canonical.x*t.EXTENT+e.anchorX)*r),y:Math.floor((i.canonical.y*t.EXTENT+e.anchorY)*r)}},Ae.prototype.findMatches=function(t,e,i){for(var o=this.tileID.canonical.z<e.canonical.z?1:Math.pow(2,this.tileID.canonical.z-e.canonical.z),r=0;r<t.length;r++){var a=t.get(r);if(!a.crossTileID){var n=this.indexedSymbolInstances[a.key];if(n)for(var s=this.getScaledCoordinates(a,e),l=0,c=n;l<c.length;l+=1){var u=c[l];if(Math.abs(u.coord.x-s.x)<=o&&Math.abs(u.coord.y-s.y)<=o&&!i[u.crossTileID]){i[u.crossTileID]=!0,a.crossTileID=u.crossTileID;break}}}}};var Re=function(){this.maxCrossTileID=0;};Re.prototype.generate=function(){return ++this.maxCrossTileID};var ke=function(){this.indexes={},this.usedCrossTileIDs={},this.lng=0;};ke.prototype.handleWrapJump=function(t){var e=Math.round((t-this.lng)/360);if(0!==e)for(var i in this.indexes){var o=this.indexes[i],r={};for(var a in o){var n=o[a];n.tileID=n.tileID.unwrapTo(n.tileID.wrap+e),r[n.tileID.key]=n;}this.indexes[i]=r;}this.lng=t;},ke.prototype.addBucket=function(t,e,i){if(this.indexes[t.overscaledZ]&&this.indexes[t.overscaledZ][t.key]){if(this.indexes[t.overscaledZ][t.key].bucketInstanceId===e.bucketInstanceId)return !1;this.removeBucketCrossTileIDs(t.overscaledZ,this.indexes[t.overscaledZ][t.key]);}for(var o=0;o<e.symbolInstances.length;o++){e.symbolInstances.get(o).crossTileID=0;}this.usedCrossTileIDs[t.overscaledZ]||(this.usedCrossTileIDs[t.overscaledZ]={});var r=this.usedCrossTileIDs[t.overscaledZ];for(var a in this.indexes){var n=this.indexes[a];if(Number(a)>t.overscaledZ)for(var s in n){var l=n[s];l.tileID.isChildOf(t)&&l.findMatches(e.symbolInstances,t,r);}else{var c=n[t.scaledTo(Number(a)).key];c&&c.findMatches(e.symbolInstances,t,r);}}for(var u=0;u<e.symbolInstances.length;u++){var h=e.symbolInstances.get(u);h.crossTileID||(h.crossTileID=i.generate(),r[h.crossTileID]=!0);}return void 0===this.indexes[t.overscaledZ]&&(this.indexes[t.overscaledZ]={}),this.indexes[t.overscaledZ][t.key]=new Ae(t,e.symbolInstances,e.bucketInstanceId),!0},ke.prototype.removeBucketCrossTileIDs=function(t,e){for(var i in e.indexedSymbolInstances)for(var o=0,r=e.indexedSymbolInstances[i];o<r.length;o+=1){var a=r[o];delete this.usedCrossTileIDs[t][a.crossTileID];}},ke.prototype.removeStaleBuckets=function(t){var e=!1;for(var i in this.indexes){var o=this.indexes[i];for(var r in o)t[o[r].bucketInstanceId]||(this.removeBucketCrossTileIDs(i,o[r]),delete o[r],e=!0);}return e};var Be=function(){this.layerIndexes={},this.crossTileIDs=new Re,this.maxBucketInstanceId=0,this.bucketsInCurrentPlacement={};};Be.prototype.addLayer=function(t,e,i){var o=this.layerIndexes[t.id];void 0===o&&(o=this.layerIndexes[t.id]=new ke);var r=!1,a={};o.handleWrapJump(i);for(var n=0,s=e;n<s.length;n+=1){var l=s[n],c=l.getBucket(t);c&&t.id===c.layerIds[0]&&(c.bucketInstanceId||(c.bucketInstanceId=++this.maxBucketInstanceId),o.addBucket(l.tileID,c,this.crossTileIDs)&&(r=!0),a[c.bucketInstanceId]=!0);}return o.removeStaleBuckets(a)&&(r=!0),r},Be.prototype.pruneUnusedLayers=function(t){var e={};for(var i in t.forEach((function(t){e[t]=!0;})),this.layerIndexes)e[i]||delete this.layerIndexes[i];};var Oe=function(e,i){return t.emitValidationErrors(e,i&&i.filter((function(t){return "source.canvas"!==t.identifier})))},Fe=t.pick(Nt,["addLayer","removeLayer","setPaintProperty","setLayoutProperty","setFilter","addSource","removeSource","setLayerZoomRange","setLight","setTransition","setGeoJSONSourceData"]),Ue=t.pick(Nt,["setCenter","setZoom","setBearing","setPitch"]),Ne=function(){var e={},i=t.styleSpec.$version;for(var o in t.styleSpec.$root){var r=t.styleSpec.$root[o];if(r.required){var a=null;null!=(a="version"===o?i:"array"===r.type?[]:{})&&(e[o]=a);}}return e}(),Ze=function(e){function i(o,r){var a=this;void 0===r&&(r={}),e.call(this),this.map=o,this.dispatcher=new T((Bt||(Bt=new kt),Bt),this),this.imageManager=new p,this.imageManager.setEventedParent(this),this.glyphManager=new y(o._requestManager,r.localIdeographFontFamily),this.lineAtlas=new E(256,512),this.crossTileSymbolIndex=new Be,this._layers={},this._order=[],this.sourceCaches={},this.zoomHistory=new t.ZoomHistory,this._loaded=!1,this._resetUpdates(),this.dispatcher.broadcast("setReferrer",t.getReferrer());var n=this;this._rtlTextPluginCallback=i.registerForPluginStateChange((function(e){var i={pluginStatus:e.pluginStatus,pluginURL:e.pluginURL};n.dispatcher.broadcast("syncRTLPluginState",i,(function(e,i){if((t.triggerPluginCompletionEvent(e),i)&&i.every((function(t){return t})))for(var o in n.sourceCaches)n.sourceCaches[o].reload();}));})),this.on("data",(function(t){if("source"===t.dataType&&"metadata"===t.sourceDataType){var e=a.sourceCaches[t.sourceId];if(e){var i=e.getSource();if(i&&i.vectorLayerIds)for(var o in a._layers){var r=a._layers[o];r.source===i.id&&a._validateLayer(r);}}}}));}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.loadURL=function(e,i){var o=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"}));var r="boolean"==typeof i.validate?i.validate:!t.isMapboxURL(e);e=this.map._requestManager.normalizeStyleURL(e,i.accessToken);var a=this.map._requestManager.transformRequest(e,t.ResourceType.Style);this._request=t.getJSON(a,(function(e,i){o._request=null,e?o.fire(new t.ErrorEvent(e)):i&&o._load(i,r);}));},i.prototype.loadJSON=function(e,i){var o=this;void 0===i&&(i={}),this.fire(new t.Event("dataloading",{dataType:"style"})),this._request=t.browser.frame((function(){o._request=null,o._load(e,!1!==i.validate);}));},i.prototype.loadEmpty=function(){this.fire(new t.Event("dataloading",{dataType:"style"})),this._load(Ne,!1);},i.prototype._load=function(e,i){if(!i||!Oe(this,t.validateStyle(e))){for(var o in this._loaded=!0,this.stylesheet=e,e.sources)this.addSource(o,e.sources[o],{validate:!1});e.sprite?this._loadSprite(e.sprite):this.imageManager.setLoaded(!0),this.glyphManager.setURL(e.glyphs);var r=Ut(this.stylesheet.layers);this._order=r.map((function(t){return t.id})),this._layers={};for(var a=0,n=r;a<n.length;a+=1){var s=n[a];(s=t.createStyleLayer(s)).setEventedParent(this,{layer:{id:s.id}}),this._layers[s.id]=s;}this.dispatcher.broadcast("setLayers",this._serializeLayers(this._order)),this.light=new w(this.stylesheet.light),this.fire(new t.Event("data",{dataType:"style"})),this.fire(new t.Event("style.load"));}},i.prototype._loadSprite=function(e){var i=this;this._spriteRequest=function(e,i,o){var r,a,n,s=t.browser.devicePixelRatio>1?"@2x":"",l=t.getJSON(i.transformRequest(i.normalizeSpriteURL(e,s,".json"),t.ResourceType.SpriteJSON),(function(t,e){l=null,n||(n=t,r=e,u());})),c=t.getImage(i.transformRequest(i.normalizeSpriteURL(e,s,".png"),t.ResourceType.SpriteImage),(function(t,e){c=null,n||(n=t,a=e,u());}));function u(){if(n)o(n);else if(r&&a){var e=t.browser.getImageData(a),i={};for(var s in r){var l=r[s],c=l.width,u=l.height,h=l.x,p=l.y,d=l.sdf,_=l.pixelRatio,f=l.stretchX,m=l.stretchY,g=l.content,v=new t.RGBAImage({width:c,height:u});t.RGBAImage.copy(e,v,{x:h,y:p},{x:0,y:0},{width:c,height:u}),i[s]={data:v,pixelRatio:_,sdf:d,stretchX:f,stretchY:m,content:g};}o(null,i);}}return {cancel:function(){l&&(l.cancel(),l=null),c&&(c.cancel(),c=null);}}}(e,this.map._requestManager,(function(e,o){if(i._spriteRequest=null,e)i.fire(new t.ErrorEvent(e));else if(o)for(var r in o)i.imageManager.addImage(r,o[r]);i.imageManager.setLoaded(!0),i.dispatcher.broadcast("setImages",i.imageManager.listImages()),i.fire(new t.Event("data",{dataType:"style"}));}));},i.prototype._validateLayer=function(e){var i=this.sourceCaches[e.source];if(i){var o=e.sourceLayer;if(o){var r=i.getSource();("geojson"===r.type||r.vectorLayerIds&&-1===r.vectorLayerIds.indexOf(o))&&this.fire(new t.ErrorEvent(new Error('Source layer "'+o+'" does not exist on source "'+r.id+'" as specified by style layer "'+e.id+'"')));}}},i.prototype.loaded=function(){if(!this._loaded)return !1;if(Object.keys(this._updatedSources).length)return !1;for(var t in this.sourceCaches)if(!this.sourceCaches[t].loaded())return !1;return !!this.imageManager.isLoaded()},i.prototype._serializeLayers=function(t){for(var e=[],i=0,o=t;i<o.length;i+=1){var r=o[i],a=this._layers[r];"custom"!==a.type&&e.push(a.serialize());}return e},i.prototype.hasTransitions=function(){if(this.light&&this.light.hasTransition())return !0;for(var t in this.sourceCaches)if(this.sourceCaches[t].hasTransition())return !0;for(var e in this._layers)if(this._layers[e].hasTransition())return !0;return !1},i.prototype._checkLoaded=function(){if(!this._loaded)throw new Error("Style is not done loading")},i.prototype.update=function(e){if(this._loaded){var i=this._changed;if(this._changed){var o=Object.keys(this._updatedLayers),r=Object.keys(this._removedLayers);for(var a in (o.length||r.length)&&this._updateWorkerLayers(o,r),this._updatedSources){var n=this._updatedSources[a];"reload"===n?this._reloadSource(a):"clear"===n&&this._clearSource(a);}for(var s in this._updateTilesForChangedImages(),this._updatedPaintProps)this._layers[s].updateTransitions(e);this.light.updateTransitions(e),this._resetUpdates();}for(var l in this.sourceCaches)this.sourceCaches[l].used=!1;for(var c=this.imageManager.listImages(),u=0,h=this._order;u<h.length;u+=1){var p=h[u],d=this._layers[p];d.recalculate(e,c),!d.isHidden(e.zoom)&&d.source&&(this.sourceCaches[d.source].used=!0);}this.light.recalculate(e),this.z=e.zoom,i&&this.fire(new t.Event("data",{dataType:"style"}));}},i.prototype._updateTilesForChangedImages=function(){var t=Object.keys(this._changedImages);if(t.length){for(var e in this.sourceCaches)this.sourceCaches[e].reloadTilesForDependencies(["icons","patterns"],t);this._changedImages={};}},i.prototype._updateWorkerLayers=function(t,e){this.dispatcher.broadcast("updateLayers",{layers:this._serializeLayers(t),removedIds:e});},i.prototype._resetUpdates=function(){this._changed=!1,this._updatedLayers={},this._removedLayers={},this._updatedSources={},this._updatedPaintProps={},this._changedImages={};},i.prototype.setState=function(e){var i=this;if(this._checkLoaded(),Oe(this,t.validateStyle(e)))return !1;(e=t.clone$1(e)).layers=Ut(e.layers);var o=Ht(this.serialize(),e).filter((function(t){return !(t.command in Ue)}));if(0===o.length)return !1;var r=o.filter((function(t){return !(t.command in Fe)}));if(r.length>0)throw new Error("Unimplemented: "+r.map((function(t){return t.command})).join(", ")+".");return o.forEach((function(t){"setTransition"!==t.command&&i[t.command].apply(i,t.args);})),this.stylesheet=e,!0},i.prototype.addImage=function(e,i){if(this.getImage(e))return this.fire(new t.ErrorEvent(new Error("An image with this name already exists.")));this.imageManager.addImage(e,i),this._changedImages[e]=!0,this._changed=!0,this.fire(new t.Event("data",{dataType:"style"}));},i.prototype.updateImage=function(t,e){this.imageManager.updateImage(t,e);},i.prototype.getImage=function(t){return this.imageManager.getImage(t)},i.prototype.removeImage=function(e){if(!this.getImage(e))return this.fire(new t.ErrorEvent(new Error("No image with this name exists.")));this.imageManager.removeImage(e),this._changedImages[e]=!0,this._changed=!0,this.fire(new t.Event("data",{dataType:"style"}));},i.prototype.listImages=function(){return this._checkLoaded(),this.imageManager.listImages()},i.prototype.addSource=function(e,i,o){var r=this;if(void 0===o&&(o={}),this._checkLoaded(),void 0!==this.sourceCaches[e])throw new Error("There is already a source with this ID");if(!i.type)throw new Error("The type property must be defined, but the only the following properties were given: "+Object.keys(i).join(", ")+".");if(!(["vector","raster","geojson","video","image"].indexOf(i.type)>=0)||!this._validate(t.validateStyle.source,"sources."+e,i,null,o)){this.map&&this.map._collectResourceTiming&&(i.collectResourceTiming=!0);var a=this.sourceCaches[e]=new Mt(e,i,this.dispatcher);a.style=this,a.setEventedParent(this,(function(){return {isSourceLoaded:r.loaded(),source:a.serialize(),sourceId:e}})),a.onAdd(this.map),this._changed=!0;}},i.prototype.removeSource=function(e){if(this._checkLoaded(),void 0===this.sourceCaches[e])throw new Error("There is no source with this ID");for(var i in this._layers)if(this._layers[i].source===e)return this.fire(new t.ErrorEvent(new Error('Source "'+e+'" cannot be removed while layer "'+i+'" is using it.')));var o=this.sourceCaches[e];delete this.sourceCaches[e],delete this._updatedSources[e],o.fire(new t.Event("data",{sourceDataType:"metadata",dataType:"source",sourceId:e})),o.setEventedParent(null),o.clearTiles(),o.onRemove&&o.onRemove(this.map),this._changed=!0;},i.prototype.setGeoJSONSourceData=function(t,e){this._checkLoaded(),this.sourceCaches[t].getSource().setData(e),this._changed=!0;},i.prototype.getSource=function(t){return this.sourceCaches[t]&&this.sourceCaches[t].getSource()},i.prototype.addLayer=function(e,i,o){void 0===o&&(o={}),this._checkLoaded();var r=e.id;if(this.getLayer(r))this.fire(new t.ErrorEvent(new Error('Layer with id "'+r+'" already exists on this map')));else{var a;if("custom"===e.type){if(Oe(this,t.validateCustomStyleLayer(e)))return;a=t.createStyleLayer(e);}else{if("object"==typeof e.source&&(this.addSource(r,e.source),e=t.clone$1(e),e=t.extend(e,{source:r})),this._validate(t.validateStyle.layer,"layers."+r,e,{arrayIndex:-1},o))return;a=t.createStyleLayer(e),this._validateLayer(a),a.setEventedParent(this,{layer:{id:r}});}var n=i?this._order.indexOf(i):this._order.length;if(i&&-1===n)this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.')));else{if(this._order.splice(n,0,r),this._layerOrderChanged=!0,this._layers[r]=a,this._removedLayers[r]&&a.source&&"custom"!==a.type){var s=this._removedLayers[r];delete this._removedLayers[r],s.type!==a.type?this._updatedSources[a.source]="clear":(this._updatedSources[a.source]="reload",this.sourceCaches[a.source].pause());}this._updateLayer(a),a.onAdd&&a.onAdd(this.map);}}},i.prototype.moveLayer=function(e,i){if(this._checkLoaded(),this._changed=!0,this._layers[e]){if(e!==i){var o=this._order.indexOf(e);this._order.splice(o,1);var r=i?this._order.indexOf(i):this._order.length;i&&-1===r?this.fire(new t.ErrorEvent(new Error('Layer with id "'+i+'" does not exist on this map.'))):(this._order.splice(r,0,e),this._layerOrderChanged=!0);}}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be moved.")));},i.prototype.removeLayer=function(e){this._checkLoaded();var i=this._layers[e];if(i){i.setEventedParent(null);var o=this._order.indexOf(e);this._order.splice(o,1),this._layerOrderChanged=!0,this._changed=!0,this._removedLayers[e]=i,delete this._layers[e],delete this._updatedLayers[e],delete this._updatedPaintProps[e],i.onRemove&&i.onRemove(this.map);}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be removed.")));},i.prototype.getLayer=function(t){return this._layers[t]},i.prototype.setLayerZoomRange=function(e,i,o){this._checkLoaded();var r=this.getLayer(e);r?r.minzoom===i&&r.maxzoom===o||(null!=i&&(r.minzoom=i),null!=o&&(r.maxzoom=o),this._updateLayer(r)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot have zoom extent.")));},i.prototype.setFilter=function(e,i,o){void 0===o&&(o={}),this._checkLoaded();var r=this.getLayer(e);if(r){if(!t.deepEqual(r.filter,i))return null==i?(r.filter=void 0,void this._updateLayer(r)):void(this._validate(t.validateStyle.filter,"layers."+r.id+".filter",i,null,o)||(r.filter=t.clone$1(i),this._updateLayer(r)))}else this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be filtered.")));},i.prototype.getFilter=function(e){return t.clone$1(this.getLayer(e).filter)},i.prototype.setLayoutProperty=function(e,i,o,r){void 0===r&&(r={}),this._checkLoaded();var a=this.getLayer(e);a?t.deepEqual(a.getLayoutProperty(i),o)||(a.setLayoutProperty(i,o,r),this._updateLayer(a)):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")));},i.prototype.getLayoutProperty=function(e,i){var o=this.getLayer(e);if(o)return o.getLayoutProperty(i);this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style.")));},i.prototype.setPaintProperty=function(e,i,o,r){void 0===r&&(r={}),this._checkLoaded();var a=this.getLayer(e);a?t.deepEqual(a.getPaintProperty(i),o)||(a.setPaintProperty(i,o,r)&&this._updateLayer(a),this._changed=!0,this._updatedPaintProps[e]=!0):this.fire(new t.ErrorEvent(new Error("The layer '"+e+"' does not exist in the map's style and cannot be styled.")));},i.prototype.getPaintProperty=function(t,e){return this.getLayer(t).getPaintProperty(e)},i.prototype.setFeatureState=function(e,i){this._checkLoaded();var o=e.source,r=e.sourceLayer,a=this.sourceCaches[o];if(void 0!==a){var n=a.getSource().type;"geojson"===n&&r?this.fire(new t.ErrorEvent(new Error("GeoJSON sources cannot have a sourceLayer parameter."))):"vector"!==n||r?(void 0===e.id&&this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided."))),a.setFeatureState(r,e.id,i)):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+o+"' does not exist in the map's style.")));},i.prototype.removeFeatureState=function(e,i){this._checkLoaded();var o=e.source,r=this.sourceCaches[o];if(void 0!==r){var a=r.getSource().type,n="vector"===a?e.sourceLayer:void 0;"vector"!==a||n?i&&"string"!=typeof e.id&&"number"!=typeof e.id?this.fire(new t.ErrorEvent(new Error("A feature id is requred to remove its specific state property."))):r.removeFeatureState(n,e.id,i):this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+o+"' does not exist in the map's style.")));},i.prototype.getFeatureState=function(e){this._checkLoaded();var i=e.source,o=e.sourceLayer,r=this.sourceCaches[i];if(void 0!==r){if("vector"!==r.getSource().type||o)return void 0===e.id&&this.fire(new t.ErrorEvent(new Error("The feature id parameter must be provided."))),r.getFeatureState(o,e.id);this.fire(new t.ErrorEvent(new Error("The sourceLayer parameter must be provided for vector source types.")));}else this.fire(new t.ErrorEvent(new Error("The source '"+i+"' does not exist in the map's style.")));},i.prototype.getTransition=function(){return t.extend({duration:300,delay:0},this.stylesheet&&this.stylesheet.transition)},i.prototype.serialize=function(){return t.filterObject({version:this.stylesheet.version,name:this.stylesheet.name,metadata:this.stylesheet.metadata,light:this.stylesheet.light,center:this.stylesheet.center,zoom:this.stylesheet.zoom,bearing:this.stylesheet.bearing,pitch:this.stylesheet.pitch,sprite:this.stylesheet.sprite,glyphs:this.stylesheet.glyphs,transition:this.stylesheet.transition,sources:t.mapObject(this.sourceCaches,(function(t){return t.serialize()})),layers:this._serializeLayers(this._order)},(function(t){return void 0!==t}))},i.prototype._updateLayer=function(t){this._updatedLayers[t.id]=!0,t.source&&!this._updatedSources[t.source]&&"raster"!==this.sourceCaches[t.source].getSource().type&&(this._updatedSources[t.source]="reload",this.sourceCaches[t.source].pause()),this._changed=!0;},i.prototype._flattenAndSortRenderedFeatures=function(t){for(var e=this,i=function(t){return "fill-extrusion"===e._layers[t].type},o={},r=[],a=this._order.length-1;a>=0;a--){var n=this._order[a];if(i(n)){o[n]=a;for(var s=0,l=t;s<l.length;s+=1){var c=l[s][n];if(c)for(var u=0,h=c;u<h.length;u+=1){var p=h[u];r.push(p);}}}}r.sort((function(t,e){return e.intersectionZ-t.intersectionZ}));for(var d=[],_=this._order.length-1;_>=0;_--){var f=this._order[_];if(i(f))for(var m=r.length-1;m>=0;m--){var g=r[m].feature;if(o[g.layer.id]<_)break;d.push(g),r.pop();}else for(var v=0,y=t;v<y.length;v+=1){var x=y[v][f];if(x)for(var b=0,w=x;b<w.length;b+=1){var E=w[b];d.push(E.feature);}}}return d},i.prototype.queryRenderedFeatures=function(e,i,o){i&&i.filter&&this._validate(t.validateStyle.filter,"queryRenderedFeatures.filter",i.filter,null,i);var r={};if(i&&i.layers){if(!Array.isArray(i.layers))return this.fire(new t.ErrorEvent(new Error("parameters.layers must be an Array."))),[];for(var a=0,n=i.layers;a<n.length;a+=1){var s=n[a],l=this._layers[s];if(!l)return this.fire(new t.ErrorEvent(new Error("The layer '"+s+"' does not exist in the map's style and cannot be queried for features."))),[];r[l.source]=!0;}}var c=[];for(var u in this.sourceCaches)i.layers&&!r[u]||c.push(F(this.sourceCaches[u],this._layers,e,i,o));return this.placement&&c.push(function(t,e,i,o,r,a){for(var n={},s=r.queryRenderedSymbols(i),l=[],c=0,u=Object.keys(s).map(Number);c<u.length;c+=1){var h=u[c];l.push(a[h]);}l.sort(U);for(var p=function(){var e=_[d],i=e.featureIndex.lookupSymbolFeatures(s[e.bucketInstanceId],e.bucketIndex,e.sourceLayerIndex,o.filter,o.layers,t);for(var r in i){var a=n[r]=n[r]||[],l=i[r];l.sort((function(t,i){var o=e.featureSortOrder;if(o){var r=o.indexOf(t.featureIndex);return o.indexOf(i.featureIndex)-r}return i.featureIndex-t.featureIndex}));for(var c=0,u=l;c<u.length;c+=1){var h=u[c];a.push(h);}}},d=0,_=l;d<_.length;d+=1)p();var f=function(i){n[i].forEach((function(o){var r=o.feature,a=t[i],n=e[a.source].getFeatureState(r.layer["source-layer"],r.id);r.source=r.layer.source,r.layer["source-layer"]&&(r.sourceLayer=r.layer["source-layer"]),r.state=n;}));};for(var m in n)f(m);return n}(this._layers,this.sourceCaches,e,i,this.placement.collisionIndex,this.placement.retainedQueryData)),this._flattenAndSortRenderedFeatures(c)},i.prototype.querySourceFeatures=function(e,i){i&&i.filter&&this._validate(t.validateStyle.filter,"querySourceFeatures.filter",i.filter,null,i);var o=this.sourceCaches[e];return o?function(t,e){for(var i=t.getRenderableIds().map((function(e){return t.getTileByID(e)})),o=[],r={},a=0;a<i.length;a++){var n=i[a],s=n.tileID.canonical.key;r[s]||(r[s]=!0,n.querySourceFeatures(o,e));}return o}(o,i):[]},i.prototype.addSourceType=function(t,e,o){return i.getSourceType(t)?o(new Error('A source type called "'+t+'" already exists.')):(i.setSourceType(t,e),e.workerSourceURL?void this.dispatcher.broadcast("loadWorkerSource",{name:t,url:e.workerSourceURL},o):o(null,null))},i.prototype.getLight=function(){return this.light.getLight()},i.prototype.setLight=function(e,i){void 0===i&&(i={}),this._checkLoaded();var o=this.light.getLight(),r=!1;for(var a in e)if(!t.deepEqual(e[a],o[a])){r=!0;break}if(r){var n={now:t.browser.now(),transition:t.extend({duration:300,delay:0},this.stylesheet.transition)};this.light.setLight(e,i),this.light.updateTransitions(n);}},i.prototype._validate=function(e,i,o,r,a){return void 0===a&&(a={}),(!a||!1!==a.validate)&&Oe(this,e.call(t.validateStyle,t.extend({key:i,style:this.serialize(),value:o,styleSpec:t.styleSpec},r)))},i.prototype._remove=function(){for(var e in this._request&&(this._request.cancel(),this._request=null),this._spriteRequest&&(this._spriteRequest.cancel(),this._spriteRequest=null),t.evented.off("pluginStateChange",this._rtlTextPluginCallback),this._layers){this._layers[e].setEventedParent(null);}for(var i in this.sourceCaches)this.sourceCaches[i].clearTiles(),this.sourceCaches[i].setEventedParent(null);this.imageManager.setEventedParent(null),this.setEventedParent(null),this.dispatcher.remove();},i.prototype._clearSource=function(t){this.sourceCaches[t].clearTiles();},i.prototype._reloadSource=function(t){this.sourceCaches[t].resume(),this.sourceCaches[t].reload();},i.prototype._updateSources=function(t){for(var e in this.sourceCaches)this.sourceCaches[e].update(t);},i.prototype._generateCollisionBoxes=function(){for(var t in this.sourceCaches)this._reloadSource(t);},i.prototype._updatePlacement=function(e,i,o,r,a){void 0===a&&(a=!1);for(var n=!1,s=!1,l={},c=0,u=this._order;c<u.length;c+=1){var h=u[c],p=this._layers[h];if("symbol"===p.type){if(!l[p.source]){var d=this.sourceCaches[p.source];l[p.source]=d.getRenderableIds(!0).map((function(t){return d.getTileByID(t)})).sort((function(t,e){return e.tileID.overscaledZ-t.tileID.overscaledZ||(t.tileID.isLessThan(e.tileID)?-1:1)}));}var _=this.crossTileSymbolIndex.addLayer(p,l[p.source],e.center.lng);n=n||_;}}if(this.crossTileSymbolIndex.pruneUnusedLayers(this._order),((a=a||this._layerOrderChanged||0===o)||!this.pauseablePlacement||this.pauseablePlacement.isDone()&&!this.placement.stillRecent(t.browser.now(),e.zoom))&&(this.pauseablePlacement=new Me(e,this._order,a,i,o,r,this.placement),this._layerOrderChanged=!1),this.pauseablePlacement.isDone()?this.placement.setStale():(this.pauseablePlacement.continuePlacement(this._order,this._layers,l),this.pauseablePlacement.isDone()&&(this.placement=this.pauseablePlacement.commit(t.browser.now()),s=!0),n&&this.pauseablePlacement.placement.setStale()),s||n)for(var f=0,m=this._order;f<m.length;f+=1){var g=m[f],v=this._layers[g];"symbol"===v.type&&this.placement.updateLayerOpacities(v,l[v.source]);}return !this.pauseablePlacement.isDone()||this.placement.hasTransitions(t.browser.now())},i.prototype._releaseSymbolFadeTiles=function(){for(var t in this.sourceCaches)this.sourceCaches[t].releaseSymbolFadeTiles();},i.prototype.getImages=function(t,e,i){this.imageManager.getImages(e.icons,i),this._updateTilesForChangedImages();var o=this.sourceCaches[e.source];o&&o.setDependencies(e.tileID.key,e.type,e.icons);},i.prototype.getGlyphs=function(t,e,i){this.glyphManager.getGlyphs(e.stacks,i);},i.prototype.getResource=function(e,i,o){return t.makeRequest(i,o)},i}(t.Evented);Ze.getSourceType=function(t){return k[t]},Ze.setSourceType=function(t,e){k[t]=e;},Ze.registerForPluginStateChange=t.registerForPluginStateChange;var qe=t.createLayout([{name:"a_pos",type:"Int16",components:2}]),je=fi("#ifdef GL_ES\nprecision mediump float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif","#ifdef GL_ES\nprecision highp float;\n#else\n#if !defined(lowp)\n#define lowp\n#endif\n#if !defined(mediump)\n#define mediump\n#endif\n#if !defined(highp)\n#define highp\n#endif\n#endif\nvec2 unpack_float(const float packedValue) {int packedIntValue=int(packedValue);int v0=packedIntValue/256;return vec2(v0,packedIntValue-v0*256);}vec2 unpack_opacity(const float packedOpacity) {int intOpacity=int(packedOpacity)/2;return vec2(float(intOpacity)/127.0,mod(packedOpacity,2.0));}vec4 decode_color(const vec2 encodedColor) {return vec4(unpack_float(encodedColor[0])/255.0,unpack_float(encodedColor[1])/255.0\n);}float unpack_mix_vec2(const vec2 packedValue,const float t) {return mix(packedValue[0],packedValue[1],t);}vec4 unpack_mix_color(const vec4 packedColors,const float t) {vec4 minColor=decode_color(vec2(packedColors[0],packedColors[1]));vec4 maxColor=decode_color(vec2(packedColors[2],packedColors[3]));return mix(minColor,maxColor,t);}vec2 get_pattern_pos(const vec2 pixel_coord_upper,const vec2 pixel_coord_lower,const vec2 pattern_size,const float tile_units_to_pixels,const vec2 pos) {vec2 offset=mod(mod(mod(pixel_coord_upper,pattern_size)*256.0,pattern_size)*256.0+pixel_coord_lower,pattern_size);return (tile_units_to_pixels*pos+offset)/pattern_size;}"),Ve=fi("uniform vec4 u_color;uniform float u_opacity;void main() {gl_FragColor=u_color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),Ge=fi("uniform vec2 u_pattern_tl_a;uniform vec2 u_pattern_br_a;uniform vec2 u_pattern_tl_b;uniform vec2 u_pattern_br_b;uniform vec2 u_texsize;uniform float u_mix;uniform float u_opacity;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(u_pattern_tl_a/u_texsize,u_pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(u_pattern_tl_b/u_texsize,u_pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_mix)*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pattern_size_a;uniform vec2 u_pattern_size_b;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_scale_a;uniform float u_scale_b;uniform float u_tile_units_to_pixels;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_a*u_pattern_size_a,u_tile_units_to_pixels,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,u_scale_b*u_pattern_size_b,u_tile_units_to_pixels,a_pos);}"),We=fi("varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=v_data.xy;float extrude_length=length(extrude);lowp float antialiasblur=v_data.z;float antialiased_blur=-max(blur,antialiasblur);float opacity_t=smoothstep(0.0,antialiased_blur,extrude_length-1.0);float color_t=stroke_width < 0.01 ? 0.0 : smoothstep(antialiased_blur,0.0,extrude_length-radius/(radius+stroke_width));gl_FragColor=opacity_t*mix(color*opacity,stroke_color*stroke_opacity,color_t);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform bool u_scale_with_map;uniform bool u_pitch_with_map;uniform vec2 u_extrude_scale;uniform lowp float u_device_pixel_ratio;uniform highp float u_camera_to_center_distance;attribute vec2 a_pos;varying vec3 v_data;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define mediump float radius\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define highp vec4 stroke_color\n#pragma mapbox: define mediump float stroke_width\n#pragma mapbox: define lowp float stroke_opacity\nvoid main(void) {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize mediump float radius\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize highp vec4 stroke_color\n#pragma mapbox: initialize mediump float stroke_width\n#pragma mapbox: initialize lowp float stroke_opacity\nvec2 extrude=vec2(mod(a_pos,2.0)*2.0-1.0);vec2 circle_center=floor(a_pos*0.5);if (u_pitch_with_map) {vec2 corner_position=circle_center;if (u_scale_with_map) {corner_position+=extrude*(radius+stroke_width)*u_extrude_scale;} else {vec4 projected_center=u_matrix*vec4(circle_center,0,1);corner_position+=extrude*(radius+stroke_width)*u_extrude_scale*(projected_center.w/u_camera_to_center_distance);}gl_Position=u_matrix*vec4(corner_position,0,1);} else {gl_Position=u_matrix*vec4(circle_center,0,1);if (u_scale_with_map) {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*u_camera_to_center_distance;} else {gl_Position.xy+=extrude*(radius+stroke_width)*u_extrude_scale*gl_Position.w;}}lowp float antialiasblur=1.0/u_device_pixel_ratio/(radius+stroke_width);v_data=vec3(extrude.x,extrude.y,antialiasblur);}"),Xe=fi("void main() {gl_FragColor=vec4(1.0);}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),He=fi("uniform highp float u_intensity;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#define GAUSS_COEF 0.3989422804014327\nvoid main() {\n#pragma mapbox: initialize highp float weight\nfloat d=-0.5*3.0*3.0*dot(v_extrude,v_extrude);float val=weight*u_intensity*GAUSS_COEF*exp(d);gl_FragColor=vec4(val,1.0,1.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform float u_extrude_scale;uniform float u_opacity;uniform float u_intensity;attribute vec2 a_pos;varying vec2 v_extrude;\n#pragma mapbox: define highp float weight\n#pragma mapbox: define mediump float radius\nconst highp float ZERO=1.0/255.0/16.0;\n#define GAUSS_COEF 0.3989422804014327\nvoid main(void) {\n#pragma mapbox: initialize highp float weight\n#pragma mapbox: initialize mediump float radius\nvec2 unscaled_extrude=vec2(mod(a_pos,2.0)*2.0-1.0);float S=sqrt(-2.0*log(ZERO/weight/u_intensity/GAUSS_COEF))/3.0;v_extrude=S*unscaled_extrude;vec2 extrude=v_extrude*radius*u_extrude_scale;vec4 pos=vec4(floor(a_pos*0.5)+extrude,0,1);gl_Position=u_matrix*pos;}"),Ke=fi("uniform sampler2D u_image;uniform sampler2D u_color_ramp;uniform float u_opacity;varying vec2 v_pos;void main() {float t=texture2D(u_image,v_pos).r;vec4 color=texture2D(u_color_ramp,vec2(t,0.5));gl_FragColor=color*u_opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(0.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;attribute vec2 a_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos*u_world,0,1);v_pos.x=a_pos.x;v_pos.y=1.0-a_pos.y;}"),Ye=fi("varying float v_placed;varying float v_notUsed;void main() {float alpha=0.5;gl_FragColor=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {gl_FragColor=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {gl_FragColor*=.1;}}","attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;attribute vec2 a_shift;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);gl_Position.xy+=(a_extrude+a_shift)*u_extrude_scale*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;}"),Je=fi("uniform float u_overscale_factor;varying float v_placed;varying float v_notUsed;varying float v_radius;varying vec2 v_extrude;varying vec2 v_extrude_scale;void main() {float alpha=0.5;vec4 color=vec4(1.0,0.0,0.0,1.0)*alpha;if (v_placed > 0.5) {color=vec4(0.0,0.0,1.0,0.5)*alpha;}if (v_notUsed > 0.5) {color*=.2;}float extrude_scale_length=length(v_extrude_scale);float extrude_length=length(v_extrude)*extrude_scale_length;float stroke_width=15.0*extrude_scale_length/u_overscale_factor;float radius=v_radius*extrude_scale_length;float distance_to_edge=abs(extrude_length-radius);float opacity_t=smoothstep(-stroke_width,0.0,-distance_to_edge);gl_FragColor=opacity_t*color;}","attribute vec2 a_pos;attribute vec2 a_anchor_pos;attribute vec2 a_extrude;attribute vec2 a_placed;uniform mat4 u_matrix;uniform vec2 u_extrude_scale;uniform float u_camera_to_center_distance;varying float v_placed;varying float v_notUsed;varying float v_radius;varying vec2 v_extrude;varying vec2 v_extrude_scale;void main() {vec4 projectedPoint=u_matrix*vec4(a_anchor_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float collision_perspective_ratio=clamp(0.5+0.5*(u_camera_to_center_distance/camera_to_anchor_distance),0.0,4.0);gl_Position=u_matrix*vec4(a_pos,0.0,1.0);highp float padding_factor=1.2;gl_Position.xy+=a_extrude*u_extrude_scale*padding_factor*gl_Position.w*collision_perspective_ratio;v_placed=a_placed.x;v_notUsed=a_placed.y;v_radius=abs(a_extrude.y);v_extrude=a_extrude*padding_factor;v_extrude_scale=u_extrude_scale*u_camera_to_center_distance*collision_perspective_ratio;}"),Qe=fi("uniform highp vec4 u_color;void main() {gl_FragColor=u_color;}","attribute vec2 a_pos;uniform mat4 u_matrix;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);}"),$e=fi("#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_FragColor=color*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);}"),ti=fi("varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=outline_color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","attribute vec2 a_pos;uniform mat4 u_matrix;uniform vec2 u_world;varying vec2 v_pos;\n#pragma mapbox: define highp vec4 outline_color\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 outline_color\n#pragma mapbox: initialize lowp float opacity\ngl_Position=u_matrix*vec4(a_pos,0,1);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),ei=fi("uniform vec2 u_texsize;uniform sampler2D u_image;uniform float u_fade;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);float dist=length(v_pos-gl_FragCoord.xy);float alpha=1.0-smoothstep(0.0,1.0,dist);gl_FragColor=mix(color1,color2,u_fade)*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_world;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec4 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec2 v_pos;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;gl_Position=u_matrix*vec4(a_pos,0,1);vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,a_pos);v_pos=(gl_Position.xy/gl_Position.w+1.0)/2.0*u_world;}"),ii=fi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);gl_FragColor=mix(color1,color2,u_fade)*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform vec4 u_scale;attribute vec2 a_pos;varying vec2 v_pos_a;varying vec2 v_pos_b;\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileZoomRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);gl_Position=u_matrix*vec4(a_pos,0,1);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileZoomRatio,a_pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileZoomRatio,a_pos);}"),oi=fi("varying vec4 v_color;void main() {gl_FragColor=v_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;uniform float u_vertical_gradient;uniform lowp float u_opacity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec4 v_color;\n#pragma mapbox: define highp float base\n#pragma mapbox: define highp float height\n#pragma mapbox: define highp vec4 color\nvoid main() {\n#pragma mapbox: initialize highp float base\n#pragma mapbox: initialize highp float height\n#pragma mapbox: initialize highp vec4 color\nvec3 normal=a_normal_ed.xyz;base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);gl_Position=u_matrix*vec4(a_pos,t > 0.0 ? height : base,1);float colorvalue=color.r*0.2126+color.g*0.7152+color.b*0.0722;v_color=vec4(0.0,0.0,0.0,1.0);vec4 ambientlight=vec4(0.03,0.03,0.03,1.0);color+=ambientlight;float directional=clamp(dot(normal/16384.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((1.0-colorvalue+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_color.r+=clamp(color.r*directional*u_lightcolor.r,mix(0.0,0.3,1.0-u_lightcolor.r),1.0);v_color.g+=clamp(color.g*directional*u_lightcolor.g,mix(0.0,0.3,1.0-u_lightcolor.g),1.0);v_color.b+=clamp(color.b*directional*u_lightcolor.b,mix(0.0,0.3,1.0-u_lightcolor.b),1.0);v_color*=u_opacity;}"),ri=fi("uniform vec2 u_texsize;uniform float u_fade;uniform sampler2D u_image;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;vec2 imagecoord=mod(v_pos_a,1.0);vec2 pos=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,imagecoord);vec4 color1=texture2D(u_image,pos);vec2 imagecoord_b=mod(v_pos_b,1.0);vec2 pos2=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,imagecoord_b);vec4 color2=texture2D(u_image,pos2);vec4 mixedColor=mix(color1,color2,u_fade);gl_FragColor=mixedColor*v_lighting;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_pixel_coord_upper;uniform vec2 u_pixel_coord_lower;uniform float u_height_factor;uniform vec4 u_scale;uniform float u_vertical_gradient;uniform lowp float u_opacity;uniform vec3 u_lightcolor;uniform lowp vec3 u_lightpos;uniform lowp float u_lightintensity;attribute vec2 a_pos;attribute vec4 a_normal_ed;varying vec2 v_pos_a;varying vec2 v_pos_b;varying vec4 v_lighting;\n#pragma mapbox: define lowp float base\n#pragma mapbox: define lowp float height\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float base\n#pragma mapbox: initialize lowp float height\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec3 normal=a_normal_ed.xyz;float edgedistance=a_normal_ed.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);base=max(0.0,base);height=max(0.0,height);float t=mod(normal.x,2.0);float z=t > 0.0 ? height : base;gl_Position=u_matrix*vec4(a_pos,z,1);vec2 pos=normal.x==1.0 && normal.y==0.0 && normal.z==16384.0\n? a_pos\n: vec2(edgedistance,z*u_height_factor);v_pos_a=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,fromScale*display_size_a,tileRatio,pos);v_pos_b=get_pattern_pos(u_pixel_coord_upper,u_pixel_coord_lower,toScale*display_size_b,tileRatio,pos);v_lighting=vec4(0.0,0.0,0.0,1.0);float directional=clamp(dot(normal/16383.0,u_lightpos),0.0,1.0);directional=mix((1.0-u_lightintensity),max((0.5+u_lightintensity),1.0),directional);if (normal.y !=0.0) {directional*=((1.0-u_vertical_gradient)+(u_vertical_gradient*clamp((t+base)*pow(height/150.0,0.5),mix(0.7,0.98,1.0-u_lightintensity),1.0)));}v_lighting.rgb+=clamp(directional*u_lightcolor,mix(vec3(0.0),vec3(0.3),1.0-u_lightcolor),vec3(1.0));v_lighting*=u_opacity;}"),ai=fi("#ifdef GL_ES\nprecision highp float;\n#endif\nuniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_dimension;uniform float u_zoom;uniform float u_maxzoom;uniform vec4 u_unpack;float getElevation(vec2 coord,float bias) {vec4 data=texture2D(u_image,coord)*255.0;data.a=-1.0;return dot(data,u_unpack)/4.0;}void main() {vec2 epsilon=1.0/u_dimension;float a=getElevation(v_pos+vec2(-epsilon.x,-epsilon.y),0.0);float b=getElevation(v_pos+vec2(0,-epsilon.y),0.0);float c=getElevation(v_pos+vec2(epsilon.x,-epsilon.y),0.0);float d=getElevation(v_pos+vec2(-epsilon.x,0),0.0);float e=getElevation(v_pos,0.0);float f=getElevation(v_pos+vec2(epsilon.x,0),0.0);float g=getElevation(v_pos+vec2(-epsilon.x,epsilon.y),0.0);float h=getElevation(v_pos+vec2(0,epsilon.y),0.0);float i=getElevation(v_pos+vec2(epsilon.x,epsilon.y),0.0);float exaggeration=u_zoom < 2.0 ? 0.4 : u_zoom < 4.5 ? 0.35 : 0.3;vec2 deriv=vec2((c+f+f+i)-(a+d+d+g),(g+h+h+i)-(a+b+b+c))/ pow(2.0,(u_zoom-u_maxzoom)*exaggeration+19.2562-u_zoom);gl_FragColor=clamp(vec4(deriv.x/2.0+0.5,deriv.y/2.0+0.5,1.0,1.0),0.0,1.0);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_dimension;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);highp vec2 epsilon=1.0/u_dimension;float scale=(u_dimension.x-2.0)/u_dimension.x;v_pos=(a_texture_pos/8192.0)*scale+epsilon;}"),ni=fi("uniform sampler2D u_image;varying vec2 v_pos;uniform vec2 u_latrange;uniform vec2 u_light;uniform vec4 u_shadow;uniform vec4 u_highlight;uniform vec4 u_accent;\n#define PI 3.141592653589793\nvoid main() {vec4 pixel=texture2D(u_image,v_pos);vec2 deriv=((pixel.rg*2.0)-1.0);float scaleFactor=cos(radians((u_latrange[0]-u_latrange[1])*(1.0-v_pos.y)+u_latrange[1]));float slope=atan(1.25*length(deriv)/scaleFactor);float aspect=deriv.x !=0.0 ? atan(deriv.y,-deriv.x) : PI/2.0*(deriv.y > 0.0 ? 1.0 :-1.0);float intensity=u_light.x;float azimuth=u_light.y+PI;float base=1.875-intensity*1.75;float maxValue=0.5*PI;float scaledSlope=intensity !=0.5 ? ((pow(base,slope)-1.0)/(pow(base,maxValue)-1.0))*maxValue : slope;float accent=cos(scaledSlope);vec4 accent_color=(1.0-accent)*u_accent*clamp(intensity*2.0,0.0,1.0);float shade=abs(mod((aspect+azimuth)/PI+0.5,2.0)-1.0);vec4 shade_color=mix(u_shadow,u_highlight,shade)*sin(scaledSlope)*clamp(intensity*2.0,0.0,1.0);gl_FragColor=accent_color*(1.0-shade_color.a)+shade_color;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos=a_texture_pos/8192.0;}"),si=fi("uniform lowp float u_device_pixel_ratio;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform vec2 u_units_to_pixels;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_linesofar;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),li=fi("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;varying vec2 v_width2;varying vec2 v_normal;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);vec4 color=texture2D(u_image,vec2(v_lineprogress,0.5));gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define MAX_LINE_DISTANCE 32767.0\n#define scale 0.015873016\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying float v_gamma_scale;varying highp float v_lineprogress;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;v_lineprogress=(floor(a_data.z/4.0)+a_data.w*64.0)*2.0/MAX_LINE_DISTANCE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_width2=vec2(outset,inset);}"),ci=fi("uniform lowp float u_device_pixel_ratio;uniform vec2 u_texsize;uniform float u_fade;uniform mediump vec4 u_scale;uniform sampler2D u_image;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\nvec2 pattern_tl_a=pattern_from.xy;vec2 pattern_br_a=pattern_from.zw;vec2 pattern_tl_b=pattern_to.xy;vec2 pattern_br_b=pattern_to.zw;float pixelRatio=u_scale.x;float tileZoomRatio=u_scale.y;float fromScale=u_scale.z;float toScale=u_scale.w;vec2 display_size_a=vec2((pattern_br_a.x-pattern_tl_a.x)/pixelRatio,(pattern_br_a.y-pattern_tl_a.y)/pixelRatio);vec2 display_size_b=vec2((pattern_br_b.x-pattern_tl_b.x)/pixelRatio,(pattern_br_b.y-pattern_tl_b.y)/pixelRatio);vec2 pattern_size_a=vec2(display_size_a.x*fromScale/tileZoomRatio,display_size_a.y);vec2 pattern_size_b=vec2(display_size_b.x*toScale/tileZoomRatio,display_size_b.y);float dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float x_a=mod(v_linesofar/pattern_size_a.x,1.0);float x_b=mod(v_linesofar/pattern_size_b.x,1.0);float y_a=0.5+(v_normal.y*clamp(v_width2.s,0.0,(pattern_size_a.y+2.0)/2.0)/pattern_size_a.y);float y_b=0.5+(v_normal.y*clamp(v_width2.s,0.0,(pattern_size_b.y+2.0)/2.0)/pattern_size_b.y);vec2 pos_a=mix(pattern_tl_a/u_texsize,pattern_br_a/u_texsize,vec2(x_a,y_a));vec2 pos_b=mix(pattern_tl_b/u_texsize,pattern_br_b/u_texsize,vec2(x_b,y_b));vec4 color=mix(texture2D(u_image,pos_a),texture2D(u_image,pos_b),u_fade);gl_FragColor=color*alpha*opacity;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform vec2 u_units_to_pixels;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;varying vec2 v_normal;varying vec2 v_width2;varying float v_linesofar;varying float v_gamma_scale;\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp vec4 pattern_from\n#pragma mapbox: define lowp vec4 pattern_to\nvoid main() {\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize mediump vec4 pattern_from\n#pragma mapbox: initialize mediump vec4 pattern_to\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_linesofar=a_linesofar;v_width2=vec2(outset,inset);}"),ui=fi("uniform lowp float u_device_pixel_ratio;uniform sampler2D u_image;uniform float u_sdfgamma;uniform float u_mix;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat dist=length(v_normal)*v_width2.s;float blur2=(blur+1.0/u_device_pixel_ratio)*v_gamma_scale;float alpha=clamp(min(dist-(v_width2.t-blur2),v_width2.s-dist)/blur2,0.0,1.0);float sdfdist_a=texture2D(u_image,v_tex_a).a;float sdfdist_b=texture2D(u_image,v_tex_b).a;float sdfdist=mix(sdfdist_a,sdfdist_b,u_mix);alpha*=smoothstep(0.5-u_sdfgamma/floorwidth,0.5+u_sdfgamma/floorwidth,sdfdist);gl_FragColor=color*(alpha*opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","\n#define scale 0.015873016\n#define LINE_DISTANCE_SCALE 2.0\nattribute vec2 a_pos_normal;attribute vec4 a_data;uniform mat4 u_matrix;uniform mediump float u_ratio;uniform lowp float u_device_pixel_ratio;uniform vec2 u_patternscale_a;uniform float u_tex_y_a;uniform vec2 u_patternscale_b;uniform float u_tex_y_b;uniform vec2 u_units_to_pixels;varying vec2 v_normal;varying vec2 v_width2;varying vec2 v_tex_a;varying vec2 v_tex_b;varying float v_gamma_scale;\n#pragma mapbox: define highp vec4 color\n#pragma mapbox: define lowp float blur\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define mediump float gapwidth\n#pragma mapbox: define lowp float offset\n#pragma mapbox: define mediump float width\n#pragma mapbox: define lowp float floorwidth\nvoid main() {\n#pragma mapbox: initialize highp vec4 color\n#pragma mapbox: initialize lowp float blur\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize mediump float gapwidth\n#pragma mapbox: initialize lowp float offset\n#pragma mapbox: initialize mediump float width\n#pragma mapbox: initialize lowp float floorwidth\nfloat ANTIALIASING=1.0/u_device_pixel_ratio/2.0;vec2 a_extrude=a_data.xy-128.0;float a_direction=mod(a_data.z,4.0)-1.0;float a_linesofar=(floor(a_data.z/4.0)+a_data.w*64.0)*LINE_DISTANCE_SCALE;vec2 pos=floor(a_pos_normal*0.5);mediump vec2 normal=a_pos_normal-2.0*pos;normal.y=normal.y*2.0-1.0;v_normal=normal;gapwidth=gapwidth/2.0;float halfwidth=width/2.0;offset=-1.0*offset;float inset=gapwidth+(gapwidth > 0.0 ? ANTIALIASING : 0.0);float outset=gapwidth+halfwidth*(gapwidth > 0.0 ? 2.0 : 1.0)+(halfwidth==0.0 ? 0.0 : ANTIALIASING);mediump vec2 dist=outset*a_extrude*scale;mediump float u=0.5*a_direction;mediump float t=1.0-abs(u);mediump vec2 offset2=offset*a_extrude*scale*normal.y*mat2(t,-u,u,t);vec4 projected_extrude=u_matrix*vec4(dist/u_ratio,0.0,0.0);gl_Position=u_matrix*vec4(pos+offset2/u_ratio,0.0,1.0)+projected_extrude;float extrude_length_without_perspective=length(dist);float extrude_length_with_perspective=length(projected_extrude.xy/gl_Position.w*u_units_to_pixels);v_gamma_scale=extrude_length_without_perspective/extrude_length_with_perspective;v_tex_a=vec2(a_linesofar*u_patternscale_a.x/floorwidth,normal.y*u_patternscale_a.y+u_tex_y_a);v_tex_b=vec2(a_linesofar*u_patternscale_b.x/floorwidth,normal.y*u_patternscale_b.y+u_tex_y_b);v_width2=vec2(outset,inset);}"),hi=fi("uniform float u_fade_t;uniform float u_opacity;uniform sampler2D u_image0;uniform sampler2D u_image1;varying vec2 v_pos0;varying vec2 v_pos1;uniform float u_brightness_low;uniform float u_brightness_high;uniform float u_saturation_factor;uniform float u_contrast_factor;uniform vec3 u_spin_weights;void main() {vec4 color0=texture2D(u_image0,v_pos0);vec4 color1=texture2D(u_image1,v_pos1);if (color0.a > 0.0) {color0.rgb=color0.rgb/color0.a;}if (color1.a > 0.0) {color1.rgb=color1.rgb/color1.a;}vec4 color=mix(color0,color1,u_fade_t);color.a*=u_opacity;vec3 rgb=color.rgb;rgb=vec3(dot(rgb,u_spin_weights.xyz),dot(rgb,u_spin_weights.zxy),dot(rgb,u_spin_weights.yzx));float average=(color.r+color.g+color.b)/3.0;rgb+=(average-rgb)*u_saturation_factor;rgb=(rgb-0.5)*u_contrast_factor+0.5;vec3 u_high_vec=vec3(u_brightness_low,u_brightness_low,u_brightness_low);vec3 u_low_vec=vec3(u_brightness_high,u_brightness_high,u_brightness_high);gl_FragColor=vec4(mix(u_high_vec,u_low_vec,rgb)*color.a,color.a);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","uniform mat4 u_matrix;uniform vec2 u_tl_parent;uniform float u_scale_parent;uniform float u_buffer_scale;attribute vec2 a_pos;attribute vec2 a_texture_pos;varying vec2 v_pos0;varying vec2 v_pos1;void main() {gl_Position=u_matrix*vec4(a_pos,0,1);v_pos0=(((a_texture_pos/8192.0)-0.5)/u_buffer_scale )+0.5;v_pos1=(v_pos0*u_scale_parent)+u_tl_parent;}"),pi=fi("uniform sampler2D u_texture;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nlowp float alpha=opacity*v_fade_opacity;gl_FragColor=texture2D(u_texture,v_tex)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform highp float u_camera_to_center_distance;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform float u_fade_change;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform vec2 u_texsize;varying vec2 v_tex;varying float v_fade_opacity;\n#pragma mapbox: define lowp float opacity\nvoid main() {\n#pragma mapbox: initialize lowp float opacity\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;vec2 a_minFontScale=a_pixeloffset.zw/256.0;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*max(a_minFontScale,fontScale)+a_pxoffset/16.0),0.0,1.0);gl_Position.z=mix(-1.1*gl_Position.w,gl_Position.z,float(projected_pos.w > 0.0));v_tex=a_tex/u_texsize;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;v_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));}"),di=fi("#define SDF_PX 8.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;uniform bool u_is_text;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat EDGE_GAMMA=0.105/u_device_pixel_ratio;vec2 tex=v_data0.xy;float gamma_scale=v_data1.x;float size=v_data1.y;float fade_opacity=v_data1[2];float fontScale=u_is_text ? size/24.0 : size;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec4 a_pixeloffset;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;varying vec2 v_data0;varying vec3 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);vec2 a_pxoffset=a_pixeloffset.xy;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=u_is_text ? size/24.0 : size;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale+a_pxoffset),0.0,1.0);float gamma_scale=gl_Position.w;gl_Position.z=mix(-1.1*gl_Position.w,gl_Position.z,float(projected_pos.w > 0.0));vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0=a_tex/u_texsize;v_data1=vec3(gamma_scale,size,interpolated_fade_opacity);}"),_i=fi("#define SDF_PX 8.0\n#define SDF 1.0\n#define ICON 0.0\nuniform bool u_is_halo;uniform sampler2D u_texture;uniform sampler2D u_texture_icon;uniform highp float u_gamma_scale;uniform lowp float u_device_pixel_ratio;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nfloat fade_opacity=v_data1[2];if (v_data1.w==ICON) {vec2 tex_icon=v_data0.zw;lowp float alpha=opacity*fade_opacity;gl_FragColor=texture2D(u_texture_icon,tex_icon)*alpha;\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\nreturn;}vec2 tex=v_data0.xy;float EDGE_GAMMA=0.105/u_device_pixel_ratio;float gamma_scale=v_data1.x;float size=v_data1.y;float fontScale=size/24.0;lowp vec4 color=fill_color;highp float gamma=EDGE_GAMMA/(fontScale*u_gamma_scale);lowp float buff=(256.0-64.0)/256.0;if (u_is_halo) {color=halo_color;gamma=(halo_blur*1.19/SDF_PX+EDGE_GAMMA)/(fontScale*u_gamma_scale);buff=(6.0-halo_width/fontScale)/SDF_PX;}lowp float dist=texture2D(u_texture,tex).a;highp float gamma_scaled=gamma*gamma_scale;highp float alpha=smoothstep(buff-gamma_scaled,buff+gamma_scaled,dist);gl_FragColor=color*(alpha*opacity*fade_opacity);\n#ifdef OVERDRAW_INSPECTOR\ngl_FragColor=vec4(1.0);\n#endif\n}","const float PI=3.141592653589793;attribute vec4 a_pos_offset;attribute vec4 a_data;attribute vec3 a_projected_pos;attribute float a_fade_opacity;uniform bool u_is_size_zoom_constant;uniform bool u_is_size_feature_constant;uniform highp float u_size_t;uniform highp float u_size;uniform mat4 u_matrix;uniform mat4 u_label_plane_matrix;uniform mat4 u_coord_matrix;uniform bool u_is_text;uniform bool u_pitch_with_map;uniform highp float u_pitch;uniform bool u_rotate_symbol;uniform highp float u_aspect_ratio;uniform highp float u_camera_to_center_distance;uniform float u_fade_change;uniform vec2 u_texsize;uniform vec2 u_texsize_icon;varying vec4 v_data0;varying vec4 v_data1;\n#pragma mapbox: define highp vec4 fill_color\n#pragma mapbox: define highp vec4 halo_color\n#pragma mapbox: define lowp float opacity\n#pragma mapbox: define lowp float halo_width\n#pragma mapbox: define lowp float halo_blur\nvoid main() {\n#pragma mapbox: initialize highp vec4 fill_color\n#pragma mapbox: initialize highp vec4 halo_color\n#pragma mapbox: initialize lowp float opacity\n#pragma mapbox: initialize lowp float halo_width\n#pragma mapbox: initialize lowp float halo_blur\nvec2 a_pos=a_pos_offset.xy;vec2 a_offset=a_pos_offset.zw;vec2 a_tex=a_data.xy;vec2 a_size=a_data.zw;float a_size_min=floor(a_size[0]*0.5);float is_sdf=a_size[0]-2.0*a_size_min;highp float segment_angle=-a_projected_pos[2];float size;if (!u_is_size_zoom_constant && !u_is_size_feature_constant) {size=mix(a_size_min,a_size[1],u_size_t)/128.0;} else if (u_is_size_zoom_constant && !u_is_size_feature_constant) {size=a_size_min/128.0;} else {size=u_size;}vec4 projectedPoint=u_matrix*vec4(a_pos,0,1);highp float camera_to_anchor_distance=projectedPoint.w;highp float distance_ratio=u_pitch_with_map ?\ncamera_to_anchor_distance/u_camera_to_center_distance :\nu_camera_to_center_distance/camera_to_anchor_distance;highp float perspective_ratio=clamp(0.5+0.5*distance_ratio,0.0,4.0);size*=perspective_ratio;float fontScale=size/24.0;highp float symbol_rotation=0.0;if (u_rotate_symbol) {vec4 offsetProjectedPoint=u_matrix*vec4(a_pos+vec2(1,0),0,1);vec2 a=projectedPoint.xy/projectedPoint.w;vec2 b=offsetProjectedPoint.xy/offsetProjectedPoint.w;symbol_rotation=atan((b.y-a.y)/u_aspect_ratio,b.x-a.x);}highp float angle_sin=sin(segment_angle+symbol_rotation);highp float angle_cos=cos(segment_angle+symbol_rotation);mat2 rotation_matrix=mat2(angle_cos,-1.0*angle_sin,angle_sin,angle_cos);vec4 projected_pos=u_label_plane_matrix*vec4(a_projected_pos.xy,0.0,1.0);gl_Position=u_coord_matrix*vec4(projected_pos.xy/projected_pos.w+rotation_matrix*(a_offset/32.0*fontScale),0.0,1.0);float gamma_scale=gl_Position.w;vec2 fade_opacity=unpack_opacity(a_fade_opacity);float fade_change=fade_opacity[1] > 0.5 ? u_fade_change :-u_fade_change;float interpolated_fade_opacity=max(0.0,min(1.0,fade_opacity[0]+fade_change));v_data0.xy=a_tex/u_texsize;v_data0.zw=a_tex/u_texsize_icon;v_data1=vec4(gamma_scale,size,interpolated_fade_opacity,is_sdf);}");function fi(t,e){var i=/#pragma mapbox: ([\w]+) ([\w]+) ([\w]+) ([\w]+)/g,o={};return {fragmentSource:t=t.replace(i,(function(t,e,i,r,a){return o[a]=!0,"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nvarying "+i+" "+r+" "+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"\n#ifdef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n"})),vertexSource:e=e.replace(i,(function(t,e,i,r,a){var n="float"===r?"vec2":"vec4",s=a.match(/color/)?"color":n;return o[a]?"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nuniform lowp float u_"+a+"_t;\nattribute "+i+" "+n+" a_"+a+";\nvarying "+i+" "+r+" "+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"vec4"===s?"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+a+" = a_"+a+";\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+a+" = unpack_mix_"+s+"(a_"+a+", u_"+a+"_t);\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"define"===e?"\n#ifndef HAS_UNIFORM_u_"+a+"\nuniform lowp float u_"+a+"_t;\nattribute "+i+" "+n+" a_"+a+";\n#else\nuniform "+i+" "+r+" u_"+a+";\n#endif\n":"vec4"===s?"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = a_"+a+";\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n":"\n#ifndef HAS_UNIFORM_u_"+a+"\n    "+i+" "+r+" "+a+" = unpack_mix_"+s+"(a_"+a+", u_"+a+"_t);\n#else\n    "+i+" "+r+" "+a+" = u_"+a+";\n#endif\n"}))}}var mi=Object.freeze({__proto__:null,prelude:je,background:Ve,backgroundPattern:Ge,circle:We,clippingMask:Xe,heatmap:He,heatmapTexture:Ke,collisionBox:Ye,collisionCircle:Je,debug:Qe,fill:$e,fillOutline:ti,fillOutlinePattern:ei,fillPattern:ii,fillExtrusion:oi,fillExtrusionPattern:ri,hillshadePrepare:ai,hillshade:ni,line:si,lineGradient:li,linePattern:ci,lineSDF:ui,raster:hi,symbolIcon:pi,symbolSDF:di,symbolTextAndIcon:_i}),gi=function(){this.boundProgram=null,this.boundLayoutVertexBuffer=null,this.boundPaintVertexBuffers=[],this.boundIndexBuffer=null,this.boundVertexOffset=null,this.boundDynamicVertexBuffer=null,this.vao=null;};gi.prototype.bind=function(t,e,i,o,r,a,n,s){this.context=t;for(var l=this.boundPaintVertexBuffers.length!==o.length,c=0;!l&&c<o.length;c++)this.boundPaintVertexBuffers[c]!==o[c]&&(l=!0);var u=!this.vao||this.boundProgram!==e||this.boundLayoutVertexBuffer!==i||l||this.boundIndexBuffer!==r||this.boundVertexOffset!==a||this.boundDynamicVertexBuffer!==n||this.boundDynamicVertexBuffer2!==s;!t.extVertexArrayObject||u?this.freshBind(e,i,o,r,a,n,s):(t.bindVertexArrayOES.set(this.vao),n&&n.bind(),r&&r.dynamicDraw&&r.bind(),s&&s.bind());},gi.prototype.freshBind=function(t,e,i,o,r,a,n){var s,l=t.numAttributes,c=this.context,u=c.gl;if(c.extVertexArrayObject)this.vao&&this.destroy(),this.vao=c.extVertexArrayObject.createVertexArrayOES(),c.bindVertexArrayOES.set(this.vao),s=0,this.boundProgram=t,this.boundLayoutVertexBuffer=e,this.boundPaintVertexBuffers=i,this.boundIndexBuffer=o,this.boundVertexOffset=r,this.boundDynamicVertexBuffer=a,this.boundDynamicVertexBuffer2=n;else{s=c.currentNumAttributes||0;for(var h=l;h<s;h++)u.disableVertexAttribArray(h);}e.enableAttributes(u,t);for(var p=0,d=i;p<d.length;p+=1){d[p].enableAttributes(u,t);}a&&a.enableAttributes(u,t),n&&n.enableAttributes(u,t),e.bind(),e.setVertexAttribPointers(u,t,r);for(var _=0,f=i;_<f.length;_+=1){var m=f[_];m.bind(),m.setVertexAttribPointers(u,t,r);}a&&(a.bind(),a.setVertexAttribPointers(u,t,r)),o&&o.bind(),n&&(n.bind(),n.setVertexAttribPointers(u,t,r)),c.currentNumAttributes=l;},gi.prototype.destroy=function(){this.vao&&(this.context.extVertexArrayObject.deleteVertexArrayOES(this.vao),this.vao=null);};var vi=function(t,e,i,o,r){var a=t.gl;this.program=a.createProgram();var n=i?i.defines():[];r&&n.push("#define OVERDRAW_INSPECTOR;");var s=n.concat(je.fragmentSource,e.fragmentSource).join("\n"),l=n.concat(je.vertexSource,e.vertexSource).join("\n"),c=a.createShader(a.FRAGMENT_SHADER);if(a.isContextLost())this.failedToCreate=!0;else{a.shaderSource(c,s),a.compileShader(c),a.attachShader(this.program,c);var u=a.createShader(a.VERTEX_SHADER);if(a.isContextLost())this.failedToCreate=!0;else{a.shaderSource(u,l),a.compileShader(u),a.attachShader(this.program,u);for(var h=i?i.layoutAttributes:[],p=0;p<h.length;p++)a.bindAttribLocation(this.program,p,h[p].name);a.linkProgram(this.program),this.numAttributes=a.getProgramParameter(this.program,a.ACTIVE_ATTRIBUTES),this.attributes={};for(var d={},_=0;_<this.numAttributes;_++){var f=a.getActiveAttrib(this.program,_);f&&(this.attributes[f.name]=a.getAttribLocation(this.program,f.name));}for(var m=a.getProgramParameter(this.program,a.ACTIVE_UNIFORMS),g=0;g<m;g++){var v=a.getActiveUniform(this.program,g);v&&(d[v.name]=a.getUniformLocation(this.program,v.name));}this.fixedUniforms=o(t,d),this.binderUniforms=i?i.getUniforms(t,d):[];}}};function yi(e,i,o){var r=1/he(o,1,i.transform.tileZoom),a=Math.pow(2,o.tileID.overscaledZ),n=o.tileSize*Math.pow(2,i.transform.tileZoom)/a,s=n*(o.tileID.canonical.x+o.tileID.wrap*a),l=n*o.tileID.canonical.y;return {u_image:0,u_texsize:o.imageAtlasTexture.size,u_scale:[t.browser.devicePixelRatio,r,e.fromScale,e.toScale],u_fade:e.t,u_pixel_coord_upper:[s>>16,l>>16],u_pixel_coord_lower:[65535&s,65535&l]}}vi.prototype.draw=function(t,e,i,o,r,a,n,s,l,c,u,h,p,d,_,f){var m,g=t.gl;if(!this.failedToCreate){for(var v in t.program.set(this.program),t.setDepthMode(i),t.setStencilMode(o),t.setColorMode(r),t.setCullFace(a),this.fixedUniforms)this.fixedUniforms[v].set(n[v]);d&&d.setUniforms(t,this.binderUniforms,h,{zoom:p});for(var y=(m={},m[g.LINES]=2,m[g.TRIANGLES]=3,m[g.LINE_STRIP]=1,m)[e],x=0,b=u.get();x<b.length;x+=1){var w=b[x],E=w.vaos||(w.vaos={});(E[s]||(E[s]=new gi)).bind(t,this,l,d?d.getPaintVertexBuffers():[],c,w.vertexOffset,_,f),g.drawElements(e,w.primitiveLength*y,g.UNSIGNED_SHORT,w.primitiveOffset*y*2);}}};var xi=function(e,i,o,r){var a=i.style.light,n=a.properties.get("position"),s=[n.x,n.y,n.z],l=t.create$1();"viewport"===a.properties.get("anchor")&&t.fromRotation(l,-i.transform.angle),t.transformMat3(s,s,l);var c=a.properties.get("color");return {u_matrix:e,u_lightpos:s,u_lightintensity:a.properties.get("intensity"),u_lightcolor:[c.r,c.g,c.b],u_vertical_gradient:+o,u_opacity:r}},bi=function(e,i,o,r,a,n,s){return t.extend(xi(e,i,o,r),yi(n,i,s),{u_height_factor:-Math.pow(2,a.overscaledZ)/s.tileSize/8})},wi=function(t){return {u_matrix:t}},Ei=function(e,i,o,r){return t.extend(wi(e),yi(o,i,r))},Ti=function(t,e){return {u_matrix:t,u_world:e}},Ii=function(e,i,o,r,a){return t.extend(Ei(e,i,o,r),{u_world:a})},Si=function(e,i,o,r){var a,n,s=e.transform;if("map"===r.paint.get("circle-pitch-alignment")){var l=he(o,1,s.zoom);a=!0,n=[l,l];}else a=!1,n=s.pixelsToGLUnits;return {u_camera_to_center_distance:s.cameraToCenterDistance,u_scale_with_map:+("map"===r.paint.get("circle-pitch-scale")),u_matrix:e.translatePosMatrix(i.posMatrix,o,r.paint.get("circle-translate"),r.paint.get("circle-translate-anchor")),u_pitch_with_map:+a,u_device_pixel_ratio:t.browser.devicePixelRatio,u_extrude_scale:n}},Ci=function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pixels_to_tile_units:new t.Uniform1f(e,i.u_pixels_to_tile_units),u_extrude_scale:new t.Uniform2f(e,i.u_extrude_scale),u_overscale_factor:new t.Uniform1f(e,i.u_overscale_factor)}},Pi=function(t,e,i){var o=he(i,1,e.zoom),r=Math.pow(2,e.zoom-i.tileID.overscaledZ),a=i.tileID.overscaleFactor();return {u_matrix:t,u_camera_to_center_distance:e.cameraToCenterDistance,u_pixels_to_tile_units:o,u_extrude_scale:[e.pixelsToGLUnits[0]/(o*r),e.pixelsToGLUnits[1]/(o*r)],u_overscale_factor:a}},zi=function(t,e){return {u_matrix:t,u_color:e}},Li=function(t){return {u_matrix:t}},Mi=function(t,e,i,o){return {u_matrix:t,u_extrude_scale:he(e,1,i),u_intensity:o}},Di=function(e,i,o,r){var a=t.create();t.ortho(a,0,e.width,e.height,0,0,1);var n=e.context.gl;return {u_matrix:a,u_world:[n.drawingBufferWidth,n.drawingBufferHeight],u_image:o,u_color_ramp:r,u_opacity:i.paint.get("heatmap-opacity")}},Ai=function(t,e,i){var o=i.paint.get("hillshade-shadow-color"),r=i.paint.get("hillshade-highlight-color"),a=i.paint.get("hillshade-accent-color"),n=i.paint.get("hillshade-illumination-direction")*(Math.PI/180);"viewport"===i.paint.get("hillshade-illumination-anchor")&&(n-=t.transform.angle);var s=!t.options.moving;return {u_matrix:t.transform.calculatePosMatrix(e.tileID.toUnwrapped(),s),u_image:0,u_latrange:ki(t,e.tileID),u_light:[i.paint.get("hillshade-exaggeration"),n],u_shadow:o,u_highlight:r,u_accent:a}},Ri=function(e,i,o){var r=i.stride,a=t.create();return t.ortho(a,0,t.EXTENT,-t.EXTENT,0,0,1),t.translate(a,a,[0,-t.EXTENT,0]),{u_matrix:a,u_image:1,u_dimension:[r,r],u_zoom:e.overscaledZ,u_maxzoom:o,u_unpack:i.getUnpackVector()}};function ki(e,i){var o=Math.pow(2,i.canonical.z),r=i.canonical.y;return [new t.MercatorCoordinate(0,r/o).toLngLat().lat,new t.MercatorCoordinate(0,(r+1)/o).toLngLat().lat]}var Bi=function(e,i,o){var r=e.transform;return {u_matrix:Zi(e,i,o),u_ratio:1/he(i,1,r.zoom),u_device_pixel_ratio:t.browser.devicePixelRatio,u_units_to_pixels:[1/r.pixelsToGLUnits[0],1/r.pixelsToGLUnits[1]]}},Oi=function(e,i,o){return t.extend(Bi(e,i,o),{u_image:0})},Fi=function(e,i,o,r){var a=e.transform,n=Ni(i,a);return {u_matrix:Zi(e,i,o),u_texsize:i.imageAtlasTexture.size,u_ratio:1/he(i,1,a.zoom),u_device_pixel_ratio:t.browser.devicePixelRatio,u_image:0,u_scale:[t.browser.devicePixelRatio,n,r.fromScale,r.toScale],u_fade:r.t,u_units_to_pixels:[1/a.pixelsToGLUnits[0],1/a.pixelsToGLUnits[1]]}},Ui=function(e,i,o,r,a){var n=e.transform,s=e.lineAtlas,l=Ni(i,n),c="round"===o.layout.get("line-cap"),u=s.getDash(r.from,c),h=s.getDash(r.to,c),p=u.width*a.fromScale,d=h.width*a.toScale;return t.extend(Bi(e,i,o),{u_patternscale_a:[l/p,-u.height/2],u_patternscale_b:[l/d,-h.height/2],u_sdfgamma:s.width/(256*Math.min(p,d)*t.browser.devicePixelRatio)/2,u_image:0,u_tex_y_a:u.y,u_tex_y_b:h.y,u_mix:a.t})};function Ni(t,e){return 1/he(t,1,e.tileZoom)}function Zi(t,e,i){return t.translatePosMatrix(e.tileID.posMatrix,e,i.paint.get("line-translate"),i.paint.get("line-translate-anchor"))}var qi=function(t,e,i,o,r){return {u_matrix:t,u_tl_parent:e,u_scale_parent:i,u_buffer_scale:1,u_fade_t:o.mix,u_opacity:o.opacity*r.paint.get("raster-opacity"),u_image0:0,u_image1:1,u_brightness_low:r.paint.get("raster-brightness-min"),u_brightness_high:r.paint.get("raster-brightness-max"),u_saturation_factor:(n=r.paint.get("raster-saturation"),n>0?1-1/(1.001-n):-n),u_contrast_factor:(a=r.paint.get("raster-contrast"),a>0?1/(1-a):1+a),u_spin_weights:ji(r.paint.get("raster-hue-rotate"))};var a,n;};function ji(t){t*=Math.PI/180;var e=Math.sin(t),i=Math.cos(t);return [(2*i+1)/3,(-Math.sqrt(3)*e-i+1)/3,(Math.sqrt(3)*e-i+1)/3]}var Vi=function(t,e,i,o,r,a,n,s,l,c){var u=r.transform;return {u_is_size_zoom_constant:+("constant"===t||"source"===t),u_is_size_feature_constant:+("constant"===t||"camera"===t),u_size_t:e?e.uSizeT:0,u_size:e?e.uSize:0,u_camera_to_center_distance:u.cameraToCenterDistance,u_pitch:u.pitch/360*2*Math.PI,u_rotate_symbol:+i,u_aspect_ratio:u.width/u.height,u_fade_change:r.options.fadeDuration?r.symbolFadeChange:1,u_matrix:a,u_label_plane_matrix:n,u_coord_matrix:s,u_is_text:+l,u_pitch_with_map:+o,u_texsize:c,u_texture:0}},Gi=function(e,i,o,r,a,n,s,l,c,u,h){var p=a.transform;return t.extend(Vi(e,i,o,r,a,n,s,l,c,u),{u_gamma_scale:r?Math.cos(p._pitch)*p.cameraToCenterDistance:1,u_device_pixel_ratio:t.browser.devicePixelRatio,u_is_halo:+h})},Wi=function(e,i,o,r,a,n,s,l,c,u){return t.extend(Gi(e,i,o,r,a,n,s,l,!0,c,!0),{u_texsize_icon:u,u_texture_icon:1})},Xi=function(t,e,i){return {u_matrix:t,u_opacity:e,u_color:i}},Hi=function(e,i,o,r,a,n){return t.extend(function(t,e,i,o){var r=i.imageManager.getPattern(t.from.toString()),a=i.imageManager.getPattern(t.to.toString()),n=i.imageManager.getPixelSize(),s=n.width,l=n.height,c=Math.pow(2,o.tileID.overscaledZ),u=o.tileSize*Math.pow(2,i.transform.tileZoom)/c,h=u*(o.tileID.canonical.x+o.tileID.wrap*c),p=u*o.tileID.canonical.y;return {u_image:0,u_pattern_tl_a:r.tl,u_pattern_br_a:r.br,u_pattern_tl_b:a.tl,u_pattern_br_b:a.br,u_texsize:[s,l],u_mix:e.t,u_pattern_size_a:r.displaySize,u_pattern_size_b:a.displaySize,u_scale_a:e.fromScale,u_scale_b:e.toScale,u_tile_units_to_pixels:1/he(o,1,i.transform.tileZoom),u_pixel_coord_upper:[h>>16,p>>16],u_pixel_coord_lower:[65535&h,65535&p]}}(r,n,o,a),{u_matrix:e,u_opacity:i})},Ki={fillExtrusion:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_lightpos:new t.Uniform3f(e,i.u_lightpos),u_lightintensity:new t.Uniform1f(e,i.u_lightintensity),u_lightcolor:new t.Uniform3f(e,i.u_lightcolor),u_vertical_gradient:new t.Uniform1f(e,i.u_vertical_gradient),u_opacity:new t.Uniform1f(e,i.u_opacity)}},fillExtrusionPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_lightpos:new t.Uniform3f(e,i.u_lightpos),u_lightintensity:new t.Uniform1f(e,i.u_lightintensity),u_lightcolor:new t.Uniform3f(e,i.u_lightcolor),u_vertical_gradient:new t.Uniform1f(e,i.u_vertical_gradient),u_height_factor:new t.Uniform1f(e,i.u_height_factor),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade),u_opacity:new t.Uniform1f(e,i.u_opacity)}},fill:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},fillPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},fillOutline:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world)}},fillOutlinePattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_texsize:new t.Uniform2f(e,i.u_texsize),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},circle:function(e,i){return {u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_scale_with_map:new t.Uniform1i(e,i.u_scale_with_map),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_extrude_scale:new t.Uniform2f(e,i.u_extrude_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},collisionBox:Ci,collisionCircle:Ci,debug:function(e,i){return {u_color:new t.UniformColor(e,i.u_color),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},clippingMask:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},heatmap:function(e,i){return {u_extrude_scale:new t.Uniform1f(e,i.u_extrude_scale),u_intensity:new t.Uniform1f(e,i.u_intensity),u_matrix:new t.UniformMatrix4f(e,i.u_matrix)}},heatmapTexture:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_world:new t.Uniform2f(e,i.u_world),u_image:new t.Uniform1i(e,i.u_image),u_color_ramp:new t.Uniform1i(e,i.u_color_ramp),u_opacity:new t.Uniform1f(e,i.u_opacity)}},hillshade:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_latrange:new t.Uniform2f(e,i.u_latrange),u_light:new t.Uniform2f(e,i.u_light),u_shadow:new t.UniformColor(e,i.u_shadow),u_highlight:new t.UniformColor(e,i.u_highlight),u_accent:new t.UniformColor(e,i.u_accent)}},hillshadePrepare:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_image:new t.Uniform1i(e,i.u_image),u_dimension:new t.Uniform2f(e,i.u_dimension),u_zoom:new t.Uniform1f(e,i.u_zoom),u_maxzoom:new t.Uniform1f(e,i.u_maxzoom),u_unpack:new t.Uniform4f(e,i.u_unpack)}},line:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels)}},lineGradient:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_image:new t.Uniform1i(e,i.u_image)}},linePattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_texsize:new t.Uniform2f(e,i.u_texsize),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_image:new t.Uniform1i(e,i.u_image),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_scale:new t.Uniform4f(e,i.u_scale),u_fade:new t.Uniform1f(e,i.u_fade)}},lineSDF:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_ratio:new t.Uniform1f(e,i.u_ratio),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_units_to_pixels:new t.Uniform2f(e,i.u_units_to_pixels),u_patternscale_a:new t.Uniform2f(e,i.u_patternscale_a),u_patternscale_b:new t.Uniform2f(e,i.u_patternscale_b),u_sdfgamma:new t.Uniform1f(e,i.u_sdfgamma),u_image:new t.Uniform1i(e,i.u_image),u_tex_y_a:new t.Uniform1f(e,i.u_tex_y_a),u_tex_y_b:new t.Uniform1f(e,i.u_tex_y_b),u_mix:new t.Uniform1f(e,i.u_mix)}},raster:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_tl_parent:new t.Uniform2f(e,i.u_tl_parent),u_scale_parent:new t.Uniform1f(e,i.u_scale_parent),u_buffer_scale:new t.Uniform1f(e,i.u_buffer_scale),u_fade_t:new t.Uniform1f(e,i.u_fade_t),u_opacity:new t.Uniform1f(e,i.u_opacity),u_image0:new t.Uniform1i(e,i.u_image0),u_image1:new t.Uniform1i(e,i.u_image1),u_brightness_low:new t.Uniform1f(e,i.u_brightness_low),u_brightness_high:new t.Uniform1f(e,i.u_brightness_high),u_saturation_factor:new t.Uniform1f(e,i.u_saturation_factor),u_contrast_factor:new t.Uniform1f(e,i.u_contrast_factor),u_spin_weights:new t.Uniform3f(e,i.u_spin_weights)}},symbolIcon:function(e,i){return {u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1f(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texture:new t.Uniform1i(e,i.u_texture)}},symbolSDF:function(e,i){return {u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1f(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texture:new t.Uniform1i(e,i.u_texture),u_gamma_scale:new t.Uniform1f(e,i.u_gamma_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_is_halo:new t.Uniform1f(e,i.u_is_halo)}},symbolTextAndIcon:function(e,i){return {u_is_size_zoom_constant:new t.Uniform1i(e,i.u_is_size_zoom_constant),u_is_size_feature_constant:new t.Uniform1i(e,i.u_is_size_feature_constant),u_size_t:new t.Uniform1f(e,i.u_size_t),u_size:new t.Uniform1f(e,i.u_size),u_camera_to_center_distance:new t.Uniform1f(e,i.u_camera_to_center_distance),u_pitch:new t.Uniform1f(e,i.u_pitch),u_rotate_symbol:new t.Uniform1i(e,i.u_rotate_symbol),u_aspect_ratio:new t.Uniform1f(e,i.u_aspect_ratio),u_fade_change:new t.Uniform1f(e,i.u_fade_change),u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_label_plane_matrix:new t.UniformMatrix4f(e,i.u_label_plane_matrix),u_coord_matrix:new t.UniformMatrix4f(e,i.u_coord_matrix),u_is_text:new t.Uniform1f(e,i.u_is_text),u_pitch_with_map:new t.Uniform1i(e,i.u_pitch_with_map),u_texsize:new t.Uniform2f(e,i.u_texsize),u_texsize_icon:new t.Uniform2f(e,i.u_texsize_icon),u_texture:new t.Uniform1i(e,i.u_texture),u_texture_icon:new t.Uniform1i(e,i.u_texture_icon),u_gamma_scale:new t.Uniform1f(e,i.u_gamma_scale),u_device_pixel_ratio:new t.Uniform1f(e,i.u_device_pixel_ratio),u_is_halo:new t.Uniform1f(e,i.u_is_halo)}},background:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_opacity:new t.Uniform1f(e,i.u_opacity),u_color:new t.UniformColor(e,i.u_color)}},backgroundPattern:function(e,i){return {u_matrix:new t.UniformMatrix4f(e,i.u_matrix),u_opacity:new t.Uniform1f(e,i.u_opacity),u_image:new t.Uniform1i(e,i.u_image),u_pattern_tl_a:new t.Uniform2f(e,i.u_pattern_tl_a),u_pattern_br_a:new t.Uniform2f(e,i.u_pattern_br_a),u_pattern_tl_b:new t.Uniform2f(e,i.u_pattern_tl_b),u_pattern_br_b:new t.Uniform2f(e,i.u_pattern_br_b),u_texsize:new t.Uniform2f(e,i.u_texsize),u_mix:new t.Uniform1f(e,i.u_mix),u_pattern_size_a:new t.Uniform2f(e,i.u_pattern_size_a),u_pattern_size_b:new t.Uniform2f(e,i.u_pattern_size_b),u_scale_a:new t.Uniform1f(e,i.u_scale_a),u_scale_b:new t.Uniform1f(e,i.u_scale_b),u_pixel_coord_upper:new t.Uniform2f(e,i.u_pixel_coord_upper),u_pixel_coord_lower:new t.Uniform2f(e,i.u_pixel_coord_lower),u_tile_units_to_pixels:new t.Uniform1f(e,i.u_tile_units_to_pixels)}}};function Yi(t,e,i,o,r,a,n,s){for(var l=t.context,c=l.gl,u=r?t.useProgram("collisionCircle"):t.useProgram("collisionBox"),h=0;h<o.length;h++){var p=o[h],d=e.getTile(p),_=d.getBucket(i);if(_){var f=r?s?_.textCollisionCircle:_.iconCollisionCircle:s?_.textCollisionBox:_.iconCollisionBox;if(f){var m=p.posMatrix;0===a[0]&&0===a[1]||(m=t.translatePosMatrix(p.posMatrix,d,a,n)),u.draw(l,r?c.TRIANGLES:c.LINES,St.disabled,Ct.disabled,t.colorModeForRenderPass(),zt.disabled,Pi(m,t.transform,d),i.id,f.layoutVertexBuffer,f.indexBuffer,f.segments,null,t.transform.zoom,null,null,f.collisionVertexBuffer);}}}}function Ji(t,e,i,o,r,a,n){Yi(t,e,i,o,!1,r,a,n),Yi(t,e,i,o,!0,r,a,n);}var Qi=t.identity(new Float32Array(16));function $i(e,i,o,r,a,n){var s=t.getAnchorAlignment(e),l=-(s.horizontalAlign-.5)*i,c=-(s.verticalAlign-.5)*o,u=t.evaluateVariableOffset(e,r);return new t.Point((l/a+u[0])*n,(c/a+u[1])*n)}function to(e,i,o,r,a,n,s,l,c,u,h){var p=e.text.placedSymbolArray,d=e.text.dynamicLayoutVertexArray,_=e.icon.dynamicLayoutVertexArray,f={};d.clear();for(var m=0;m<p.length;m++){var g=p.get(m),v=e.allowVerticalPlacement&&!g.placedOrientation,y=g.hidden||!g.crossTileID||v?null:r[g.crossTileID];if(y){var x=new t.Point(g.anchorX,g.anchorY),b=Qt(x,o?l:s),w=.5+n.cameraToCenterDistance/b.signedDistanceFromCamera*.5,E=a.evaluateSizeForFeature(e.textSizeData,u,g)*w/t.ONE_EM;o&&(E*=e.tilePixelRatio/c);for(var T=y.width,I=y.height,S=$i(y.anchor,T,I,y.textOffset,y.textBoxScale,E),C=o?Qt(x.add(S),s).point:b.point.add(i?S.rotate(-n.angle):S),P=e.allowVerticalPlacement&&g.placedOrientation===t.WritingMode.vertical?Math.PI/2:0,z=0;z<g.numGlyphs;z++)t.addDynamicAttributes(d,C,P);h&&g.associatedIconIndex>=0&&(f[g.associatedIconIndex]={shiftedAnchor:C,angle:P});}else se(g.numGlyphs,d);}if(h){_.clear();for(var L=e.icon.placedSymbolArray,M=0;M<L.length;M++){var D=L.get(M);if(D.hidden)se(D.numGlyphs,_);else{var A=f[M];if(A)for(var R=0;R<D.numGlyphs;R++)t.addDynamicAttributes(_,A.shiftedAnchor,A.angle);else se(D.numGlyphs,_);}}e.icon.dynamicLayoutVertexBuffer.updateData(_);}e.text.dynamicLayoutVertexBuffer.updateData(d);}function eo(t,e,i){return i.iconsInText&&e?"symbolTextAndIcon":t?"symbolSDF":"symbolIcon"}function io(e,i,o,r,a,n,s,l,c,u,h,p){for(var d,_,f=e.context,m=f.gl,g=e.transform,v="map"===l,y="map"===c,x=v&&"point"!==o.layout.get("symbol-placement"),b=v&&!y&&!x,w=void 0!==o.layout.get("symbol-sort-key").constantOr(1),E=e.depthModeForSublayer(0,St.ReadOnly),T=o.layout.get("text-variable-anchor"),I=[],S=0,C=r;S<C.length;S+=1){var P=C[S],z=i.getTile(P),L=z.getBucket(o);if(L){var M=a?L.text:L.icon;if(M&&M.segments.get().length){var D=M.programConfigurations.get(o.id),A=a||L.sdfIcons,R=a?L.textSizeData:L.iconSizeData,k=y||0!==g.pitch;d||(d=e.useProgram(eo(A,a,L),D),_=t.evaluateSizeForZoom(R,g.zoom));var B=void 0,O=[0,0],F=void 0,U=void 0,N=null,Z=void 0;if(a){if(F=z.glyphAtlasTexture,U=m.LINEAR,B=z.glyphAtlasTexture.size,L.iconsInText){O=z.imageAtlasTexture.size,N=z.imageAtlasTexture;var q="composite"===R.kind||"camera"===R.kind;Z=k||e.options.rotating||e.options.zooming||q?m.LINEAR:m.NEAREST;}}else{var j=1!==o.layout.get("icon-size").constantOr(0)||L.iconsNeedLinear;F=z.imageAtlasTexture,U=A||e.options.rotating||e.options.zooming||j||k?m.LINEAR:m.NEAREST,B=z.imageAtlasTexture.size;}var V=he(z,1,e.transform.zoom),G=Yt(P.posMatrix,y,v,e.transform,V),W=Jt(P.posMatrix,y,v,e.transform,V),X=T&&L.hasTextData(),H="none"!==o.layout.get("icon-text-fit")&&X&&L.hasIconData();x&&te(L,P.posMatrix,e,a,G,W,y,u);var K=e.translatePosMatrix(P.posMatrix,z,n,s),Y=x||a&&T||H?Qi:G,J=e.translatePosMatrix(W,z,n,s,!0),Q=A&&0!==o.paint.get(a?"text-halo-width":"icon-halo-width").constantOr(1),$={program:d,buffers:M,uniformValues:A?L.iconsInText?Wi(R.kind,_,b,y,e,K,Y,J,B,O):Gi(R.kind,_,b,y,e,K,Y,J,a,B,!0):Vi(R.kind,_,b,y,e,K,Y,J,a,B),atlasTexture:F,atlasTextureIcon:N,atlasInterpolation:U,atlasInterpolationIcon:Z,isSDF:A,hasHalo:Q};if(w)for(var tt=0,et=M.segments.get();tt<et.length;tt+=1){var it=et[tt];I.push({segments:new t.SegmentVector([it]),sortKey:it.sortKey,state:$});}else I.push({segments:M.segments,sortKey:0,state:$});}}}w&&I.sort((function(t,e){return t.sortKey-e.sortKey}));for(var ot=0,rt=I;ot<rt.length;ot+=1){var at=rt[ot],nt=at.state;if(f.activeTexture.set(m.TEXTURE0),nt.atlasTexture.bind(nt.atlasInterpolation,m.CLAMP_TO_EDGE),nt.atlasTextureIcon&&(f.activeTexture.set(m.TEXTURE1),nt.atlasTextureIcon&&nt.atlasTextureIcon.bind(nt.atlasInterpolationIcon,m.CLAMP_TO_EDGE)),nt.isSDF){var st=nt.uniformValues;nt.hasHalo&&(st.u_is_halo=1,oo(nt.buffers,at.segments,o,e,nt.program,E,h,p,st)),st.u_is_halo=0;}oo(nt.buffers,at.segments,o,e,nt.program,E,h,p,nt.uniformValues);}}function oo(t,e,i,o,r,a,n,s,l){var c=o.context,u=c.gl;r.draw(c,u.TRIANGLES,a,n,s,zt.disabled,l,i.id,t.layoutVertexBuffer,t.indexBuffer,e,i.paint,o.transform.zoom,t.programConfigurations.get(i.id),t.dynamicLayoutVertexBuffer,t.opacityVertexBuffer);}function ro(t,e,i,o,r,a,n){var s,l,c,u,h,p=t.context.gl,d=i.paint.get("fill-pattern"),_=d&&d.constantOr(1),f=i.getCrossfadeParameters();n?(l=_&&!i.getPaintProperty("fill-outline-color")?"fillOutlinePattern":"fillOutline",s=p.LINES):(l=_?"fillPattern":"fill",s=p.TRIANGLES);for(var m=0,g=o;m<g.length;m+=1){var v=g[m],y=e.getTile(v);if(!_||y.patternsLoaded()){var x=y.getBucket(i);if(x){var b=x.programConfigurations.get(i.id),w=t.useProgram(l,b);_&&(t.context.activeTexture.set(p.TEXTURE0),y.imageAtlasTexture.bind(p.LINEAR,p.CLAMP_TO_EDGE),b.updatePaintBuffers(f));var E=d.constantOr(null);if(E&&y.imageAtlas){var T=y.imageAtlas,I=T.patternPositions[E.to.toString()],S=T.patternPositions[E.from.toString()];I&&S&&b.setConstantPatternPositions(I,S);}var C=t.translatePosMatrix(v.posMatrix,y,i.paint.get("fill-translate"),i.paint.get("fill-translate-anchor"));if(n){u=x.indexBuffer2,h=x.segments2;var P=[p.drawingBufferWidth,p.drawingBufferHeight];c="fillOutlinePattern"===l&&_?Ii(C,t,f,y,P):Ti(C,P);}else u=x.indexBuffer,h=x.segments,c=_?Ei(C,t,f,y):wi(C);w.draw(t.context,s,r,t.stencilModeForClipping(v),a,zt.disabled,c,i.id,x.layoutVertexBuffer,u,h,i.paint,t.transform.zoom,b);}}}}function ao(t,e,i,o,r,a,n){for(var s=t.context,l=s.gl,c=i.paint.get("fill-extrusion-pattern"),u=c.constantOr(1),h=i.getCrossfadeParameters(),p=i.paint.get("fill-extrusion-opacity"),d=0,_=o;d<_.length;d+=1){var f=_[d],m=e.getTile(f),g=m.getBucket(i);if(g){var v=g.programConfigurations.get(i.id),y=t.useProgram(u?"fillExtrusionPattern":"fillExtrusion",v);u&&(t.context.activeTexture.set(l.TEXTURE0),m.imageAtlasTexture.bind(l.LINEAR,l.CLAMP_TO_EDGE),v.updatePaintBuffers(h));var x=c.constantOr(null);if(x&&m.imageAtlas){var b=m.imageAtlas,w=b.patternPositions[x.to.toString()],E=b.patternPositions[x.from.toString()];w&&E&&v.setConstantPatternPositions(w,E);}var T=t.translatePosMatrix(f.posMatrix,m,i.paint.get("fill-extrusion-translate"),i.paint.get("fill-extrusion-translate-anchor")),I=i.paint.get("fill-extrusion-vertical-gradient"),S=u?bi(T,t,I,p,f,h,m):xi(T,t,I,p);y.draw(s,s.gl.TRIANGLES,r,a,n,zt.backCCW,S,i.id,g.layoutVertexBuffer,g.indexBuffer,g.segments,i.paint,t.transform.zoom,v);}}}function no(t,e,i,o,r,a){var n=t.context,s=n.gl,l=e.fbo;if(l){var c=t.useProgram("hillshade");n.activeTexture.set(s.TEXTURE0),s.bindTexture(s.TEXTURE_2D,l.colorAttachment.get());var u=Ai(t,e,i);c.draw(n,s.TRIANGLES,o,r,a,zt.disabled,u,i.id,t.rasterBoundsBuffer,t.quadTriangleIndexBuffer,t.rasterBoundsSegments);}}function so(e,i,o,r,a,n,s){var l=e.context,c=l.gl,u=i.dem;if(u&&u.data){var h=u.dim,p=u.stride,d=u.getPixels();if(l.activeTexture.set(c.TEXTURE1),l.pixelStoreUnpackPremultiplyAlpha.set(!1),i.demTexture=i.demTexture||e.getTileTexture(p),i.demTexture){var _=i.demTexture;_.update(d,{premultiply:!1}),_.bind(c.NEAREST,c.CLAMP_TO_EDGE);}else i.demTexture=new t.Texture(l,d,c.RGBA,{premultiply:!1}),i.demTexture.bind(c.NEAREST,c.CLAMP_TO_EDGE);l.activeTexture.set(c.TEXTURE0);var f=i.fbo;if(!f){var m=new t.Texture(l,{width:h,height:h,data:null},c.RGBA);m.bind(c.LINEAR,c.CLAMP_TO_EDGE),(f=i.fbo=l.createFramebuffer(h,h)).colorAttachment.set(m.texture);}l.bindFramebuffer.set(f.framebuffer),l.viewport.set([0,0,h,h]),e.useProgram("hillshadePrepare").draw(l,c.TRIANGLES,a,n,s,zt.disabled,Ri(i.tileID,u,r),o.id,e.rasterBoundsBuffer,e.quadTriangleIndexBuffer,e.rasterBoundsSegments),i.needsHillshadePrepare=!1;}}function lo(e,i,o,r,a){var n=r.paint.get("raster-fade-duration");if(n>0){var s=t.browser.now(),l=(s-e.timeAdded)/n,c=i?(s-i.timeAdded)/n:-1,u=o.getSource(),h=a.coveringZoomLevel({tileSize:u.tileSize,roundZoom:u.roundZoom}),p=!i||Math.abs(i.tileID.overscaledZ-h)>Math.abs(e.tileID.overscaledZ-h),d=p&&e.refreshedUponExpiration?1:t.clamp(p?l:1-c,0,1);return e.refreshedUponExpiration&&l>=1&&(e.refreshedUponExpiration=!1),i?{opacity:1,mix:1-d}:{opacity:d,mix:0}}return {opacity:1,mix:0}}function co(e,i,o){var r=e.context,a=r.gl,n=o.posMatrix,s=e.useProgram("debug"),l=St.disabled,c=Ct.disabled,u=e.colorModeForRenderPass(),h="$debug";s.draw(r,a.LINE_STRIP,l,c,u,zt.disabled,zi(n,t.Color.red),h,e.debugBuffer,e.tileBorderIndexBuffer,e.debugSegments);var p=i.getTileByID(o.key).latestRawTileData,d=p&&p.byteLength||0,_=Math.floor(d/1024),f=i.getTile(o).tileSize,m=512/Math.min(f,512),g=o.canonical.toString();o.overscaledZ!==o.canonical.z&&(g+=" => "+o.overscaledZ);for(var v=function(t,e,i,o){o=o||1;var r,a,n,s,l,c,u,h,p=[];for(r=0,a=t.length;r<a;r++)if(l=uo[t[r]]){for(h=null,n=0,s=l[1].length;n<s;n+=2)-1===l[1][n]&&-1===l[1][n+1]?h=null:(c=e+l[1][n]*o,u=i-l[1][n+1]*o,h&&p.push(h.x,h.y,c,u),h={x:c,y:u});e+=l[0]*o;}return p}(g+" "+_+"kb",50,200*m,5*m),y=new t.StructArrayLayout2i4,x=new t.StructArrayLayout2ui4,b=0;b<v.length;b+=2)y.emplaceBack(v[b],v[b+1]),x.emplaceBack(b,b+1);for(var w=r.createVertexBuffer(y,qe.members),E=r.createIndexBuffer(x),T=t.SegmentVector.simpleSegment(0,0,y.length/2,y.length/2),I=t.EXTENT/(Math.pow(2,e.transform.zoom-o.overscaledZ)*f*m),S=[],C=-1;C<=1;C++)for(var P=-1;P<=1&&(0!==C||0!==P);P++)S.push([C,P]);for(var z=0;z<S.length;z++){var L=S[z];s.draw(r,a.LINES,l,c,u,zt.disabled,zi(t.translate([],n,[I*L[0],I*L[1],0]),t.Color.white),h,w,E,T);}s.draw(r,a.LINES,l,c,u,zt.disabled,zi(n,t.Color.black),h,w,E,T),w.destroy(),E.destroy(),T.destroy();}var uo={" ":[16,[]],"!":[10,[5,21,5,7,-1,-1,5,2,4,1,5,0,6,1,5,2]],'"':[16,[4,21,4,14,-1,-1,12,21,12,14]],"#":[21,[11,25,4,-7,-1,-1,17,25,10,-7,-1,-1,4,12,18,12,-1,-1,3,6,17,6]],$:[20,[8,25,8,-4,-1,-1,12,25,12,-4,-1,-1,17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],"%":[24,[21,21,3,0,-1,-1,8,21,10,19,10,17,9,15,7,14,5,14,3,16,3,18,4,20,6,21,8,21,10,20,13,19,16,19,19,20,21,21,-1,-1,17,7,15,6,14,4,14,2,16,0,18,0,20,1,21,3,21,5,19,7,17,7]],"&":[26,[23,12,23,13,22,14,21,14,20,13,19,11,17,6,15,3,13,1,11,0,7,0,5,1,4,2,3,4,3,6,4,8,5,9,12,13,13,14,14,16,14,18,13,20,11,21,9,20,8,18,8,16,9,13,11,10,16,3,18,1,20,0,22,0,23,1,23,2]],"'":[10,[5,19,4,20,5,21,6,20,6,18,5,16,4,15]],"(":[14,[11,25,9,23,7,20,5,16,4,11,4,7,5,2,7,-2,9,-5,11,-7]],")":[14,[3,25,5,23,7,20,9,16,10,11,10,7,9,2,7,-2,5,-5,3,-7]],"*":[16,[8,21,8,9,-1,-1,3,18,13,12,-1,-1,13,18,3,12]],"+":[26,[13,18,13,0,-1,-1,4,9,22,9]],",":[10,[6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"-":[26,[4,9,22,9]],".":[10,[5,2,4,1,5,0,6,1,5,2]],"/":[22,[20,25,2,-7]],0:[20,[9,21,6,20,4,17,3,12,3,9,4,4,6,1,9,0,11,0,14,1,16,4,17,9,17,12,16,17,14,20,11,21,9,21]],1:[20,[6,17,8,18,11,21,11,0]],2:[20,[4,16,4,17,5,19,6,20,8,21,12,21,14,20,15,19,16,17,16,15,15,13,13,10,3,0,17,0]],3:[20,[5,21,16,21,10,13,13,13,15,12,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],4:[20,[13,21,3,7,18,7,-1,-1,13,21,13,0]],5:[20,[15,21,5,21,4,12,5,13,8,14,11,14,14,13,16,11,17,8,17,6,16,3,14,1,11,0,8,0,5,1,4,2,3,4]],6:[20,[16,18,15,20,12,21,10,21,7,20,5,17,4,12,4,7,5,3,7,1,10,0,11,0,14,1,16,3,17,6,17,7,16,10,14,12,11,13,10,13,7,12,5,10,4,7]],7:[20,[17,21,7,0,-1,-1,3,21,17,21]],8:[20,[8,21,5,20,4,18,4,16,5,14,7,13,11,12,14,11,16,9,17,7,17,4,16,2,15,1,12,0,8,0,5,1,4,2,3,4,3,7,4,9,6,11,9,12,13,13,15,14,16,16,16,18,15,20,12,21,8,21]],9:[20,[16,14,15,11,13,9,10,8,9,8,6,9,4,11,3,14,3,15,4,18,6,20,9,21,10,21,13,20,15,18,16,14,16,9,15,4,13,1,10,0,8,0,5,1,4,3]],":":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,5,2,4,1,5,0,6,1,5,2]],";":[10,[5,14,4,13,5,12,6,13,5,14,-1,-1,6,1,5,0,4,1,5,2,6,1,6,-1,5,-3,4,-4]],"<":[24,[20,18,4,9,20,0]],"=":[26,[4,12,22,12,-1,-1,4,6,22,6]],">":[24,[4,18,20,9,4,0]],"?":[18,[3,16,3,17,4,19,5,20,7,21,11,21,13,20,14,19,15,17,15,15,14,13,13,12,9,10,9,7,-1,-1,9,2,8,1,9,0,10,1,9,2]],"@":[27,[18,13,17,15,15,16,12,16,10,15,9,14,8,11,8,8,9,6,11,5,14,5,16,6,17,8,-1,-1,12,16,10,14,9,11,9,8,10,6,11,5,-1,-1,18,16,17,8,17,6,19,5,21,5,23,7,24,10,24,12,23,15,22,17,20,19,18,20,15,21,12,21,9,20,7,19,5,17,4,15,3,12,3,9,4,6,5,4,7,2,9,1,12,0,15,0,18,1,20,2,21,3,-1,-1,19,16,18,8,18,6,19,5]],A:[18,[9,21,1,0,-1,-1,9,21,17,0,-1,-1,4,7,14,7]],B:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,-1,-1,4,11,13,11,16,10,17,9,18,7,18,4,17,2,16,1,13,0,4,0]],C:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5]],D:[21,[4,21,4,0,-1,-1,4,21,11,21,14,20,16,18,17,16,18,13,18,8,17,5,16,3,14,1,11,0,4,0]],E:[19,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11,-1,-1,4,0,17,0]],F:[18,[4,21,4,0,-1,-1,4,21,17,21,-1,-1,4,11,12,11]],G:[21,[18,16,17,18,15,20,13,21,9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,18,8,-1,-1,13,8,18,8]],H:[22,[4,21,4,0,-1,-1,18,21,18,0,-1,-1,4,11,18,11]],I:[8,[4,21,4,0]],J:[16,[12,21,12,5,11,2,10,1,8,0,6,0,4,1,3,2,2,5,2,7]],K:[21,[4,21,4,0,-1,-1,18,21,4,7,-1,-1,9,12,18,0]],L:[17,[4,21,4,0,-1,-1,4,0,16,0]],M:[24,[4,21,4,0,-1,-1,4,21,12,0,-1,-1,20,21,12,0,-1,-1,20,21,20,0]],N:[22,[4,21,4,0,-1,-1,4,21,18,0,-1,-1,18,21,18,0]],O:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21]],P:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,14,17,12,16,11,13,10,4,10]],Q:[22,[9,21,7,20,5,18,4,16,3,13,3,8,4,5,5,3,7,1,9,0,13,0,15,1,17,3,18,5,19,8,19,13,18,16,17,18,15,20,13,21,9,21,-1,-1,12,4,18,-2]],R:[21,[4,21,4,0,-1,-1,4,21,13,21,16,20,17,19,18,17,18,15,17,13,16,12,13,11,4,11,-1,-1,11,11,18,0]],S:[20,[17,18,15,20,12,21,8,21,5,20,3,18,3,16,4,14,5,13,7,12,13,10,15,9,16,8,17,6,17,3,15,1,12,0,8,0,5,1,3,3]],T:[16,[8,21,8,0,-1,-1,1,21,15,21]],U:[22,[4,21,4,6,5,3,7,1,10,0,12,0,15,1,17,3,18,6,18,21]],V:[18,[1,21,9,0,-1,-1,17,21,9,0]],W:[24,[2,21,7,0,-1,-1,12,21,7,0,-1,-1,12,21,17,0,-1,-1,22,21,17,0]],X:[20,[3,21,17,0,-1,-1,17,21,3,0]],Y:[18,[1,21,9,11,9,0,-1,-1,17,21,9,11]],Z:[20,[17,21,3,0,-1,-1,3,21,17,21,-1,-1,3,0,17,0]],"[":[14,[4,25,4,-7,-1,-1,5,25,5,-7,-1,-1,4,25,11,25,-1,-1,4,-7,11,-7]],"\\":[14,[0,21,14,-3]],"]":[14,[9,25,9,-7,-1,-1,10,25,10,-7,-1,-1,3,25,10,25,-1,-1,3,-7,10,-7]],"^":[16,[6,15,8,18,10,15,-1,-1,3,12,8,17,13,12,-1,-1,8,17,8,0]],_:[16,[0,-2,16,-2]],"`":[10,[6,21,5,20,4,18,4,16,5,15,6,16,5,17]],a:[19,[15,14,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],b:[19,[4,21,4,0,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],c:[18,[15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],d:[19,[15,21,15,0,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],e:[18,[3,8,15,8,15,10,14,12,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],f:[12,[10,21,8,21,6,20,5,17,5,0,-1,-1,2,14,9,14]],g:[19,[15,14,15,-2,14,-5,13,-6,11,-7,8,-7,6,-6,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],h:[19,[4,21,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],i:[8,[3,21,4,20,5,21,4,22,3,21,-1,-1,4,14,4,0]],j:[10,[5,21,6,20,7,21,6,22,5,21,-1,-1,6,14,6,-3,5,-6,3,-7,1,-7]],k:[17,[4,21,4,0,-1,-1,14,14,4,4,-1,-1,8,8,15,0]],l:[8,[4,21,4,0]],m:[30,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0,-1,-1,15,10,18,13,20,14,23,14,25,13,26,10,26,0]],n:[19,[4,14,4,0,-1,-1,4,10,7,13,9,14,12,14,14,13,15,10,15,0]],o:[19,[8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3,16,6,16,8,15,11,13,13,11,14,8,14]],p:[19,[4,14,4,-7,-1,-1,4,11,6,13,8,14,11,14,13,13,15,11,16,8,16,6,15,3,13,1,11,0,8,0,6,1,4,3]],q:[19,[15,14,15,-7,-1,-1,15,11,13,13,11,14,8,14,6,13,4,11,3,8,3,6,4,3,6,1,8,0,11,0,13,1,15,3]],r:[13,[4,14,4,0,-1,-1,4,8,5,11,7,13,9,14,12,14]],s:[17,[14,11,13,13,10,14,7,14,4,13,3,11,4,9,6,8,11,7,13,6,14,4,14,3,13,1,10,0,7,0,4,1,3,3]],t:[12,[5,21,5,4,6,1,8,0,10,0,-1,-1,2,14,9,14]],u:[19,[4,14,4,4,5,1,7,0,10,0,12,1,15,4,-1,-1,15,14,15,0]],v:[16,[2,14,8,0,-1,-1,14,14,8,0]],w:[22,[3,14,7,0,-1,-1,11,14,7,0,-1,-1,11,14,15,0,-1,-1,19,14,15,0]],x:[17,[3,14,14,0,-1,-1,14,14,3,0]],y:[16,[2,14,8,0,-1,-1,14,14,8,0,6,-4,4,-6,2,-7,1,-7]],z:[17,[14,14,3,0,-1,-1,3,14,14,14,-1,-1,3,0,14,0]],"{":[14,[9,25,7,24,6,23,5,21,5,19,6,17,7,16,8,14,8,12,6,10,-1,-1,7,24,6,22,6,20,7,18,8,17,9,15,9,13,8,11,4,9,8,7,9,5,9,3,8,1,7,0,6,-2,6,-4,7,-6,-1,-1,6,8,8,6,8,4,7,2,6,1,5,-1,5,-3,6,-5,7,-6,9,-7]],"|":[8,[4,25,4,-7]],"}":[14,[5,25,7,24,8,23,9,21,9,19,8,17,7,16,6,14,6,12,8,10,-1,-1,7,24,8,22,8,20,7,18,6,17,5,15,5,13,6,11,10,9,6,7,5,5,5,3,6,1,7,0,8,-2,8,-4,7,-6,-1,-1,8,8,6,6,6,4,7,2,8,1,9,-1,9,-3,8,-5,7,-6,5,-7]],"~":[24,[3,6,3,8,4,11,6,12,8,12,10,11,14,8,16,7,18,7,20,8,21,10,-1,-1,3,8,4,10,6,11,8,11,10,10,14,7,16,6,18,6,20,7,21,10,21,12]]};var ho={symbol:function(e,i,o,r,a){if("translucent"===e.renderPass){var n=Ct.disabled,s=e.colorModeForRenderPass();o.layout.get("text-variable-anchor")&&function(e,i,o,r,a,n,s){for(var l=i.transform,c="map"===a,u="map"===n,h=0,p=e;h<p.length;h+=1){var d=p[h],_=r.getTile(d),f=_.getBucket(o);if(f&&f.text&&f.text.segments.get().length){var m=f.textSizeData,g=t.evaluateSizeForZoom(m,l.zoom),v=he(_,1,i.transform.zoom),y=Yt(d.posMatrix,u,c,i.transform,v),x="none"!==o.layout.get("icon-text-fit")&&f.hasIconData();if(g){var b=Math.pow(2,l.zoom-_.tileID.overscaledZ);to(f,c,u,s,t.symbolSize,l,y,d.posMatrix,b,g,x);}}}}(r,e,o,i,o.layout.get("text-rotation-alignment"),o.layout.get("text-pitch-alignment"),a),0!==o.paint.get("icon-opacity").constantOr(1)&&io(e,i,o,r,!1,o.paint.get("icon-translate"),o.paint.get("icon-translate-anchor"),o.layout.get("icon-rotation-alignment"),o.layout.get("icon-pitch-alignment"),o.layout.get("icon-keep-upright"),n,s),0!==o.paint.get("text-opacity").constantOr(1)&&io(e,i,o,r,!0,o.paint.get("text-translate"),o.paint.get("text-translate-anchor"),o.layout.get("text-rotation-alignment"),o.layout.get("text-pitch-alignment"),o.layout.get("text-keep-upright"),n,s),i.map.showCollisionBoxes&&(Ji(e,i,o,r,o.paint.get("text-translate"),o.paint.get("text-translate-anchor"),!0),Ji(e,i,o,r,o.paint.get("icon-translate"),o.paint.get("icon-translate-anchor"),!1));}},circle:function(e,i,o,r){if("translucent"===e.renderPass){var a=o.paint.get("circle-opacity"),n=o.paint.get("circle-stroke-width"),s=o.paint.get("circle-stroke-opacity"),l=void 0!==o.layout.get("circle-sort-key").constantOr(1);if(0!==a.constantOr(1)||0!==n.constantOr(1)&&0!==s.constantOr(1)){for(var c=e.context,u=c.gl,h=e.depthModeForSublayer(0,St.ReadOnly),p=Ct.disabled,d=e.colorModeForRenderPass(),_=[],f=0;f<r.length;f++){var m=r[f],g=i.getTile(m),v=g.getBucket(o);if(v){var y=v.programConfigurations.get(o.id),x={programConfiguration:y,program:e.useProgram("circle",y),layoutVertexBuffer:v.layoutVertexBuffer,indexBuffer:v.indexBuffer,uniformValues:Si(e,m,g,o)};if(l)for(var b=0,w=v.segments.get();b<w.length;b+=1){var E=w[b];_.push({segments:new t.SegmentVector([E]),sortKey:E.sortKey,state:x});}else _.push({segments:v.segments,sortKey:0,state:x});}}l&&_.sort((function(t,e){return t.sortKey-e.sortKey}));for(var T=0,I=_;T<I.length;T+=1){var S=I[T],C=S.state,P=C.programConfiguration,z=C.program,L=C.layoutVertexBuffer,M=C.indexBuffer,D=C.uniformValues,A=S.segments;z.draw(c,u.TRIANGLES,h,p,d,zt.disabled,D,o.id,L,M,A,o.paint,e.transform.zoom,P);}}}},heatmap:function(e,i,o,r){if(0!==o.paint.get("heatmap-opacity"))if("offscreen"===e.renderPass){var a=e.context,n=a.gl,s=e.depthModeForSublayer(0,St.ReadOnly),l=Ct.disabled,c=new Pt([n.ONE,n.ONE],t.Color.transparent,[!0,!0,!0,!0]);!function(t,e,i){var o=t.gl;t.activeTexture.set(o.TEXTURE1),t.viewport.set([0,0,e.width/4,e.height/4]);var r=i.heatmapFbo;if(r)o.bindTexture(o.TEXTURE_2D,r.colorAttachment.get()),t.bindFramebuffer.set(r.framebuffer);else{var a=o.createTexture();o.bindTexture(o.TEXTURE_2D,a),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_WRAP_S,o.CLAMP_TO_EDGE),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_WRAP_T,o.CLAMP_TO_EDGE),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_MIN_FILTER,o.LINEAR),o.texParameteri(o.TEXTURE_2D,o.TEXTURE_MAG_FILTER,o.LINEAR),r=i.heatmapFbo=t.createFramebuffer(e.width/4,e.height/4),function t(e,i,o,r){var a=e.gl;a.texImage2D(a.TEXTURE_2D,0,a.RGBA,i.width/4,i.height/4,0,a.RGBA,e.extTextureHalfFloat?e.extTextureHalfFloat.HALF_FLOAT_OES:a.UNSIGNED_BYTE,null);r.colorAttachment.set(o);e.extTextureHalfFloat&&a.checkFramebufferStatus(a.FRAMEBUFFER)!==a.FRAMEBUFFER_COMPLETE&&(e.extTextureHalfFloat=null,r.colorAttachment.setDirty(),t(e,i,o,r));}(t,e,a,r);}}(a,e,o),a.clear({color:t.Color.transparent});for(var u=0;u<r.length;u++){var h=r[u];if(!i.hasRenderableParent(h)){var p=i.getTile(h),d=p.getBucket(o);if(d){var _=d.programConfigurations.get(o.id),f=e.useProgram("heatmap",_),m=e.transform.zoom;f.draw(a,n.TRIANGLES,s,l,c,zt.disabled,Mi(h.posMatrix,p,m,o.paint.get("heatmap-intensity")),o.id,d.layoutVertexBuffer,d.indexBuffer,d.segments,o.paint,e.transform.zoom,_);}}}a.viewport.set([0,0,e.width,e.height]);}else"translucent"===e.renderPass&&(e.context.setColorMode(e.colorModeForRenderPass()),function(e,i){var o=e.context,r=o.gl,a=i.heatmapFbo;if(!a)return;o.activeTexture.set(r.TEXTURE0),r.bindTexture(r.TEXTURE_2D,a.colorAttachment.get()),o.activeTexture.set(r.TEXTURE1);var n=i.colorRampTexture;n||(n=i.colorRampTexture=new t.Texture(o,i.colorRamp,r.RGBA));n.bind(r.LINEAR,r.CLAMP_TO_EDGE),e.useProgram("heatmapTexture").draw(o,r.TRIANGLES,St.disabled,Ct.disabled,e.colorModeForRenderPass(),zt.disabled,Di(e,i,0,1),i.id,e.viewportBuffer,e.quadTriangleIndexBuffer,e.viewportSegments,i.paint,e.transform.zoom);}(e,o));},line:function(e,i,o,r){if("translucent"===e.renderPass){var a=o.paint.get("line-opacity"),n=o.paint.get("line-width");if(0!==a.constantOr(1)&&0!==n.constantOr(1)){var s=e.depthModeForSublayer(0,St.ReadOnly),l=e.colorModeForRenderPass(),c=o.paint.get("line-dasharray"),u=o.paint.get("line-pattern"),h=u.constantOr(1),p=o.paint.get("line-gradient"),d=o.getCrossfadeParameters(),_=h?"linePattern":c?"lineSDF":p?"lineGradient":"line",f=e.context,m=f.gl,g=!0;if(p){f.activeTexture.set(m.TEXTURE0);var v=o.gradientTexture;if(!o.gradient)return;v||(v=o.gradientTexture=new t.Texture(f,o.gradient,m.RGBA)),v.bind(m.LINEAR,m.CLAMP_TO_EDGE);}for(var y=0,x=r;y<x.length;y+=1){var b=x[y],w=i.getTile(b);if(!h||w.patternsLoaded()){var E=w.getBucket(o);if(E){var T=E.programConfigurations.get(o.id),I=e.context.program.get(),S=e.useProgram(_,T),C=g||S.program!==I,P=u.constantOr(null);if(P&&w.imageAtlas){var z=w.imageAtlas,L=z.patternPositions[P.to.toString()],M=z.patternPositions[P.from.toString()];L&&M&&T.setConstantPatternPositions(L,M);}var D=h?Fi(e,w,o,d):c?Ui(e,w,o,c,d):p?Oi(e,w,o):Bi(e,w,o);h?(f.activeTexture.set(m.TEXTURE0),w.imageAtlasTexture.bind(m.LINEAR,m.CLAMP_TO_EDGE),T.updatePaintBuffers(d)):c&&(C||e.lineAtlas.dirty)&&(f.activeTexture.set(m.TEXTURE0),e.lineAtlas.bind(f)),S.draw(f,m.TRIANGLES,s,e.stencilModeForClipping(b),l,zt.disabled,D,o.id,E.layoutVertexBuffer,E.indexBuffer,E.segments,o.paint,e.transform.zoom,T),g=!1;}}}}}},fill:function(e,i,o,r){var a=o.paint.get("fill-color"),n=o.paint.get("fill-opacity");if(0!==n.constantOr(1)){var s=e.colorModeForRenderPass(),l=o.paint.get("fill-pattern"),c=e.opaquePassEnabledForLayer()&&!l.constantOr(1)&&1===a.constantOr(t.Color.transparent).a&&1===n.constantOr(0)?"opaque":"translucent";if(e.renderPass===c){var u=e.depthModeForSublayer(1,"opaque"===e.renderPass?St.ReadWrite:St.ReadOnly);ro(e,i,o,r,u,s,!1);}if("translucent"===e.renderPass&&o.paint.get("fill-antialias")){var h=e.depthModeForSublayer(o.getPaintProperty("fill-outline-color")?2:0,St.ReadOnly);ro(e,i,o,r,h,s,!0);}}},"fill-extrusion":function(t,e,i,o){var r=i.paint.get("fill-extrusion-opacity");if(0!==r&&"translucent"===t.renderPass){var a=new St(t.context.gl.LEQUAL,St.ReadWrite,t.depthRangeFor3D);if(1!==r||i.paint.get("fill-extrusion-pattern").constantOr(1))ao(t,e,i,o,a,Ct.disabled,Pt.disabled),ao(t,e,i,o,a,t.stencilModeFor3D(),t.colorModeForRenderPass());else{var n=t.colorModeForRenderPass();ao(t,e,i,o,a,Ct.disabled,n);}}},hillshade:function(t,e,i,o){if("offscreen"===t.renderPass||"translucent"===t.renderPass){for(var r=t.context,a=e.getSource().maxzoom,n=t.depthModeForSublayer(0,St.ReadOnly),s=t.colorModeForRenderPass(),l="translucent"===t.renderPass?t.stencilConfigForOverlap(o):[{},o],c=l[0],u=0,h=l[1];u<h.length;u+=1){var p=h[u],d=e.getTile(p);d.needsHillshadePrepare&&"offscreen"===t.renderPass?so(t,d,i,a,n,Ct.disabled,s):"translucent"===t.renderPass&&no(t,d,i,n,c[p.overscaledZ],s);}r.viewport.set([0,0,t.width,t.height]);}},raster:function(t,e,i,o){if("translucent"===t.renderPass&&0!==i.paint.get("raster-opacity")&&o.length)for(var r=t.context,a=r.gl,n=e.getSource(),s=t.useProgram("raster"),l=t.colorModeForRenderPass(),c=n instanceof D?[{},o]:t.stencilConfigForOverlap(o),u=c[0],h=c[1],p=h[h.length-1].overscaledZ,d=!t.options.moving,_=0,f=h;_<f.length;_+=1){var m=f[_],g=t.depthModeForSublayer(m.overscaledZ-p,1===i.paint.get("raster-opacity")?St.ReadWrite:St.ReadOnly,a.LESS),v=e.getTile(m),y=t.transform.calculatePosMatrix(m.toUnwrapped(),d);v.registerFadeDuration(i.paint.get("raster-fade-duration"));var x=e.findLoadedParent(m,0),b=lo(v,x,e,i,t.transform),w=void 0,E=void 0,T="nearest"===i.paint.get("raster-resampling")?a.NEAREST:a.LINEAR;r.activeTexture.set(a.TEXTURE0),v.texture.bind(T,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),r.activeTexture.set(a.TEXTURE1),x?(x.texture.bind(T,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST),w=Math.pow(2,x.tileID.overscaledZ-v.tileID.overscaledZ),E=[v.tileID.canonical.x*w%1,v.tileID.canonical.y*w%1]):v.texture.bind(T,a.CLAMP_TO_EDGE,a.LINEAR_MIPMAP_NEAREST);var I=qi(y,E||[0,0],w||1,b,i);n instanceof D?s.draw(r,a.TRIANGLES,g,Ct.disabled,l,zt.disabled,I,i.id,n.boundsBuffer,t.quadTriangleIndexBuffer,n.boundsSegments):s.draw(r,a.TRIANGLES,g,u[m.overscaledZ],l,zt.disabled,I,i.id,t.rasterBoundsBuffer,t.quadTriangleIndexBuffer,t.rasterBoundsSegments);}},background:function(t,e,i){var o=i.paint.get("background-color"),r=i.paint.get("background-opacity");if(0!==r){var a=t.context,n=a.gl,s=t.transform,l=s.tileSize,c=i.paint.get("background-pattern");if(!t.isPatternMissing(c)){var u=!c&&1===o.a&&1===r&&t.opaquePassEnabledForLayer()?"opaque":"translucent";if(t.renderPass===u){var h=Ct.disabled,p=t.depthModeForSublayer(0,"opaque"===u?St.ReadWrite:St.ReadOnly),d=t.colorModeForRenderPass(),_=t.useProgram(c?"backgroundPattern":"background"),f=s.coveringTiles({tileSize:l});c&&(a.activeTexture.set(n.TEXTURE0),t.imageManager.bind(t.context));for(var m=i.getCrossfadeParameters(),g=0,v=f;g<v.length;g+=1){var y=v[g],x=t.transform.calculatePosMatrix(y.toUnwrapped()),b=c?Hi(x,r,t,c,{tileID:y,tileSize:l},m):Xi(x,r,o);_.draw(a,n.TRIANGLES,p,h,d,zt.disabled,b,i.id,t.tileExtentBuffer,t.quadTriangleIndexBuffer,t.tileExtentSegments);}}}}},debug:function(t,e,i){for(var o=0;o<i.length;o++)co(t,e,i[o]);},custom:function(t,e,i){var o=t.context,r=i.implementation;if("offscreen"===t.renderPass){var a=r.prerender;a&&(t.setCustomLayerDefaults(),o.setColorMode(t.colorModeForRenderPass()),a.call(r,o.gl,t.transform.customLayerMatrix()),o.setDirty(),t.setBaseState());}else if("translucent"===t.renderPass){t.setCustomLayerDefaults(),o.setColorMode(t.colorModeForRenderPass()),o.setStencilMode(Ct.disabled);var n="3d"===r.renderingMode?new St(t.context.gl.LEQUAL,St.ReadWrite,t.depthRangeFor3D):t.depthModeForSublayer(0,St.ReadOnly);o.setDepthMode(n),r.render(o.gl,t.transform.customLayerMatrix()),o.setDirty(),t.setBaseState(),o.bindFramebuffer.set(null);}}},po=function(t,e){this.context=new Lt(t),this.transform=e,this._tileTextures={},this.setup(),this.numSublayers=Mt.maxUnderzooming+Mt.maxOverzooming+1,this.depthEpsilon=1/Math.pow(2,16),this.depthRboNeedsClear=!0,this.crossTileSymbolIndex=new Be,this.gpuTimers={};};po.prototype.resize=function(e,i){var o=this.context.gl;if(this.width=e*t.browser.devicePixelRatio,this.height=i*t.browser.devicePixelRatio,this.context.viewport.set([0,0,this.width,this.height]),this.style)for(var r=0,a=this.style._order;r<a.length;r+=1){var n=a[r];this.style._layers[n].resize();}this.depthRbo&&(o.deleteRenderbuffer(this.depthRbo),this.depthRbo=null);},po.prototype.setup=function(){var e=this.context,i=new t.StructArrayLayout2i4;i.emplaceBack(0,0),i.emplaceBack(t.EXTENT,0),i.emplaceBack(0,t.EXTENT),i.emplaceBack(t.EXTENT,t.EXTENT),this.tileExtentBuffer=e.createVertexBuffer(i,qe.members),this.tileExtentSegments=t.SegmentVector.simpleSegment(0,0,4,2);var o=new t.StructArrayLayout2i4;o.emplaceBack(0,0),o.emplaceBack(t.EXTENT,0),o.emplaceBack(0,t.EXTENT),o.emplaceBack(t.EXTENT,t.EXTENT),this.debugBuffer=e.createVertexBuffer(o,qe.members),this.debugSegments=t.SegmentVector.simpleSegment(0,0,4,5);var r=new t.StructArrayLayout4i8;r.emplaceBack(0,0,0,0),r.emplaceBack(t.EXTENT,0,t.EXTENT,0),r.emplaceBack(0,t.EXTENT,0,t.EXTENT),r.emplaceBack(t.EXTENT,t.EXTENT,t.EXTENT,t.EXTENT),this.rasterBoundsBuffer=e.createVertexBuffer(r,M.members),this.rasterBoundsSegments=t.SegmentVector.simpleSegment(0,0,4,2);var a=new t.StructArrayLayout2i4;a.emplaceBack(0,0),a.emplaceBack(1,0),a.emplaceBack(0,1),a.emplaceBack(1,1),this.viewportBuffer=e.createVertexBuffer(a,qe.members),this.viewportSegments=t.SegmentVector.simpleSegment(0,0,4,2);var n=new t.StructArrayLayout1ui2;n.emplaceBack(0),n.emplaceBack(1),n.emplaceBack(3),n.emplaceBack(2),n.emplaceBack(0),this.tileBorderIndexBuffer=e.createIndexBuffer(n);var s=new t.StructArrayLayout3ui6;s.emplaceBack(0,1,2),s.emplaceBack(2,1,3),this.quadTriangleIndexBuffer=e.createIndexBuffer(s);var l=this.context.gl;this.stencilClearMode=new Ct({func:l.ALWAYS,mask:0},0,255,l.ZERO,l.ZERO,l.ZERO);},po.prototype.clearStencil=function(){var e=this.context,i=e.gl;this.nextStencilID=1,this.currentStencilSource=void 0;var o=t.create();t.ortho(o,0,this.width,this.height,0,0,1),t.scale(o,o,[i.drawingBufferWidth,i.drawingBufferHeight,0]),this.useProgram("clippingMask").draw(e,i.TRIANGLES,St.disabled,this.stencilClearMode,Pt.disabled,zt.disabled,Li(o),"$clipping",this.viewportBuffer,this.quadTriangleIndexBuffer,this.viewportSegments);},po.prototype._renderTileClippingMasks=function(t,e){if(this.currentStencilSource!==t.source&&t.isTileClipped()&&e&&e.length){this.currentStencilSource=t.source;var i=this.context,o=i.gl;this.nextStencilID+e.length>256&&this.clearStencil(),i.setColorMode(Pt.disabled),i.setDepthMode(St.disabled);var r=this.useProgram("clippingMask");this._tileClippingMaskIDs={};for(var a=0,n=e;a<n.length;a+=1){var s=n[a],l=this._tileClippingMaskIDs[s.key]=this.nextStencilID++;r.draw(i,o.TRIANGLES,St.disabled,new Ct({func:o.ALWAYS,mask:0},l,255,o.KEEP,o.KEEP,o.REPLACE),Pt.disabled,zt.disabled,Li(s.posMatrix),"$clipping",this.tileExtentBuffer,this.quadTriangleIndexBuffer,this.tileExtentSegments);}}},po.prototype.stencilModeFor3D=function(){this.currentStencilSource=void 0,this.nextStencilID+1>256&&this.clearStencil();var t=this.nextStencilID++,e=this.context.gl;return new Ct({func:e.NOTEQUAL,mask:255},t,255,e.KEEP,e.KEEP,e.REPLACE)},po.prototype.stencilModeForClipping=function(t){var e=this.context.gl;return new Ct({func:e.EQUAL,mask:255},this._tileClippingMaskIDs[t.key],0,e.KEEP,e.KEEP,e.REPLACE)},po.prototype.stencilConfigForOverlap=function(t){var e,i=this.context.gl,o=t.sort((function(t,e){return e.overscaledZ-t.overscaledZ})),r=o[o.length-1].overscaledZ,a=o[0].overscaledZ-r+1;if(a>1){this.currentStencilSource=void 0,this.nextStencilID+a>256&&this.clearStencil();for(var n={},s=0;s<a;s++)n[s+r]=new Ct({func:i.GEQUAL,mask:255},s+this.nextStencilID,255,i.KEEP,i.KEEP,i.REPLACE);return this.nextStencilID+=a,[n,o]}return [(e={},e[r]=Ct.disabled,e),o]},po.prototype.colorModeForRenderPass=function(){var e=this.context.gl;if(this._showOverdrawInspector){return new Pt([e.CONSTANT_COLOR,e.ONE],new t.Color(1/8,1/8,1/8,0),[!0,!0,!0,!0])}return "opaque"===this.renderPass?Pt.unblended:Pt.alphaBlended},po.prototype.depthModeForSublayer=function(t,e,i){if(!this.opaquePassEnabledForLayer())return St.disabled;var o=1-((1+this.currentLayer)*this.numSublayers+t)*this.depthEpsilon;return new St(i||this.context.gl.LEQUAL,e,[o,o])},po.prototype.opaquePassEnabledForLayer=function(){return this.currentLayer<this.opaquePassCutoff},po.prototype.render=function(e,i){var o=this;this.style=e,this.options=i,this.lineAtlas=e.lineAtlas,this.imageManager=e.imageManager,this.glyphManager=e.glyphManager,this.symbolFadeChange=e.placement.symbolFadeChange(t.browser.now()),this.imageManager.beginFrame();var r=this.style._order,a=this.style.sourceCaches;for(var n in a){var s=a[n];s.used&&s.prepare(this.context);}var l,c,u={},h={},p={};for(var d in a){var _=a[d];u[d]=_.getVisibleCoordinates(),h[d]=u[d].slice().reverse(),p[d]=_.getVisibleCoordinates(!0).reverse();}this.opaquePassCutoff=1/0;for(var f=0;f<r.length;f++){var m=r[f];if(this.style._layers[m].is3D()){this.opaquePassCutoff=f;break}}this.renderPass="offscreen",this.depthRboNeedsClear=!0;for(var g=0,v=r;g<v.length;g+=1){var y=v[g],x=this.style._layers[y];if(x.hasOffscreenPass()&&!x.isHidden(this.transform.zoom)){var b=h[x.source];("custom"===x.type||b.length)&&this.renderLayer(this,a[x.source],x,b);}}for(this.context.bindFramebuffer.set(null),this.context.clear({color:i.showOverdrawInspector?t.Color.black:t.Color.transparent,depth:1}),this.clearStencil(),this._showOverdrawInspector=i.showOverdrawInspector,this.depthRangeFor3D=[0,1-(e._order.length+2)*this.numSublayers*this.depthEpsilon],this.renderPass="opaque",this.currentLayer=r.length-1;this.currentLayer>=0;this.currentLayer--){var w=this.style._layers[r[this.currentLayer]],E=a[w.source],T=u[w.source];this._renderTileClippingMasks(w,T),this.renderLayer(this,E,w,T);}for(this.renderPass="translucent",this.currentLayer=0;this.currentLayer<r.length;this.currentLayer++){var I=this.style._layers[r[this.currentLayer]],S=a[I.source],C=("symbol"===I.type?p:h)[I.source];this._renderTileClippingMasks(I,u[I.source]),this.renderLayer(this,S,I,C);}this.options.showTileBoundaries&&(t.values(this.style._layers).forEach((function(t){t.source&&!t.isHidden(o.transform.zoom)&&(t.source!==(c&&c.id)&&(c=o.style.sourceCaches[t.source]),(!l||l.getSource().maxzoom<c.getSource().maxzoom)&&(l=c));})),l&&ho.debug(this,l,l.getVisibleCoordinates()));this.context.setDefault();},po.prototype.setupOffscreenDepthRenderbuffer=function(){var t=this.context;this.depthRbo||(this.depthRbo=t.createRenderbuffer(t.gl.DEPTH_COMPONENT16,this.width,this.height));},po.prototype.renderLayer=function(t,e,i,o){i.isHidden(this.transform.zoom)||("background"===i.type||"custom"===i.type||o.length)&&(this.id=i.id,this.gpuTimingStart(i),ho[i.type](t,e,i,o,this.style.placement.variableOffsets),this.gpuTimingEnd());},po.prototype.gpuTimingStart=function(t){if(this.options.gpuTiming){var e=this.context.extTimerQuery,i=this.gpuTimers[t.id];i||(i=this.gpuTimers[t.id]={calls:0,cpuTime:0,query:e.createQueryEXT()}),i.calls++,e.beginQueryEXT(e.TIME_ELAPSED_EXT,i.query);}},po.prototype.gpuTimingEnd=function(){if(this.options.gpuTiming){var t=this.context.extTimerQuery;t.endQueryEXT(t.TIME_ELAPSED_EXT);}},po.prototype.collectGpuTimers=function(){var t=this.gpuTimers;return this.gpuTimers={},t},po.prototype.queryGpuTimers=function(t){var e={};for(var i in t){var o=t[i],r=this.context.extTimerQuery,a=r.getQueryObjectEXT(o.query,r.QUERY_RESULT_EXT)/1e6;r.deleteQueryEXT(o.query),e[i]=a;}return e},po.prototype.translatePosMatrix=function(e,i,o,r,a){if(!o[0]&&!o[1])return e;var n=a?"map"===r?this.transform.angle:0:"viewport"===r?-this.transform.angle:0;if(n){var s=Math.sin(n),l=Math.cos(n);o=[o[0]*l-o[1]*s,o[0]*s+o[1]*l];}var c=[a?o[0]:he(i,o[0],this.transform.zoom),a?o[1]:he(i,o[1],this.transform.zoom),0],u=new Float32Array(16);return t.translate(u,e,c),u},po.prototype.saveTileTexture=function(t){var e=this._tileTextures[t.size[0]];e?e.push(t):this._tileTextures[t.size[0]]=[t];},po.prototype.getTileTexture=function(t){var e=this._tileTextures[t];return e&&e.length>0?e.pop():null},po.prototype.isPatternMissing=function(t){if(!t)return !1;var e=this.imageManager.getPattern(t.from.toString()),i=this.imageManager.getPattern(t.to.toString());return !e||!i},po.prototype.useProgram=function(t,e){this.cache=this.cache||{};var i=""+t+(e?e.cacheKey:"")+(this._showOverdrawInspector?"/overdraw":"");return this.cache[i]||(this.cache[i]=new vi(this.context,mi[t],e,Ki[t],this._showOverdrawInspector)),this.cache[i]},po.prototype.setCustomLayerDefaults=function(){this.context.unbindVAO(),this.context.cullFace.setDefault(),this.context.activeTexture.setDefault(),this.context.pixelStoreUnpack.setDefault(),this.context.pixelStoreUnpackPremultiplyAlpha.setDefault(),this.context.pixelStoreUnpackFlipY.setDefault();},po.prototype.setBaseState=function(){var t=this.context.gl;this.context.cullFace.set(!1),this.context.viewport.set([0,0,this.width,this.height]),this.context.blendEquation.set(t.FUNC_ADD);};var _o=function(t,e){this.points=t,this.planes=e;};_o.fromInvProjectionMatrix=function(e,i,o){var r=Math.pow(2,o),a=[[-1,1,-1,1],[1,1,-1,1],[1,-1,-1,1],[-1,-1,-1,1],[-1,1,1,1],[1,1,1,1],[1,-1,1,1],[-1,-1,1,1]].map((function(i){return t.transformMat4([],i,e)})).map((function(e){return t.scale$1([],e,1/e[3]/i*r)})),n=[[0,1,2],[6,5,4],[0,3,7],[2,1,5],[3,2,6],[0,4,5]].map((function(e){var i=t.sub([],a[e[0]],a[e[1]]),o=t.sub([],a[e[2]],a[e[1]]),r=t.normalize([],t.cross([],i,o)),n=-t.dot(r,a[e[1]]);return r.concat(n)}));return new _o(a,n)};var fo=function(e,i){this.min=e,this.max=i,this.center=t.scale$2([],t.add([],this.min,this.max),.5);};fo.prototype.quadrant=function(e){for(var i=[e%2==0,e<2],o=t.clone$2(this.min),r=t.clone$2(this.max),a=0;a<i.length;a++)o[a]=i[a]?this.min[a]:this.center[a],r[a]=i[a]?this.center[a]:this.max[a];return r[2]=this.max[2],new fo(o,r)},fo.prototype.distanceX=function(t){return Math.max(Math.min(this.max[0],t[0]),this.min[0])-t[0]},fo.prototype.distanceY=function(t){return Math.max(Math.min(this.max[1],t[1]),this.min[1])-t[1]},fo.prototype.intersects=function(e){for(var i=[[this.min[0],this.min[1],0,1],[this.max[0],this.min[1],0,1],[this.max[0],this.max[1],0,1],[this.min[0],this.max[1],0,1]],o=!0,r=0;r<e.planes.length;r++){for(var a=e.planes[r],n=0,s=0;s<i.length;s++)n+=t.dot$1(a,i[s])>=0;if(0===n)return 0;n!==i.length&&(o=!1);}if(o)return 2;for(var l=0;l<3;l++){for(var c=Number.MAX_VALUE,u=-Number.MAX_VALUE,h=0;h<e.points.length;h++){var p=e.points[h][l]-this.min[l];c=Math.min(c,p),u=Math.max(u,p);}if(u<0||c>this.max[l]-this.min[l])return 0}return 1};var mo=function(e,i,o,r,a){this.tileSize=512,this.maxValidLatitude=85.051129,this._renderWorldCopies=void 0===a||a,this._minZoom=e||0,this._maxZoom=i||22,this._minPitch=null==o?0:o,this._maxPitch=null==r?60:r,this.setMaxBounds(),this.width=0,this.height=0,this._center=new t.LngLat(0,0),this.zoom=0,this.angle=0,this._fov=.6435011087932844,this._pitch=0,this._unmodified=!0,this._posMatrixCache={},this._alignedPosMatrixCache={};},go={minZoom:{configurable:!0},maxZoom:{configurable:!0},minPitch:{configurable:!0},maxPitch:{configurable:!0},renderWorldCopies:{configurable:!0},worldSize:{configurable:!0},centerPoint:{configurable:!0},size:{configurable:!0},bearing:{configurable:!0},pitch:{configurable:!0},fov:{configurable:!0},zoom:{configurable:!0},center:{configurable:!0},unmodified:{configurable:!0},point:{configurable:!0}};mo.prototype.clone=function(){var t=new mo(this._minZoom,this._maxZoom,this._minPitch,this.maxPitch,this._renderWorldCopies);return t.tileSize=this.tileSize,t.latRange=this.latRange,t.width=this.width,t.height=this.height,t._center=this._center,t.zoom=this.zoom,t.angle=this.angle,t._fov=this._fov,t._pitch=this._pitch,t._unmodified=this._unmodified,t._calcMatrices(),t},go.minZoom.get=function(){return this._minZoom},go.minZoom.set=function(t){this._minZoom!==t&&(this._minZoom=t,this.zoom=Math.max(this.zoom,t));},go.maxZoom.get=function(){return this._maxZoom},go.maxZoom.set=function(t){this._maxZoom!==t&&(this._maxZoom=t,this.zoom=Math.min(this.zoom,t));},go.minPitch.get=function(){return this._minPitch},go.minPitch.set=function(t){this._minPitch!==t&&(this._minPitch=t,this.pitch=Math.max(this.pitch,t));},go.maxPitch.get=function(){return this._maxPitch},go.maxPitch.set=function(t){this._maxPitch!==t&&(this._maxPitch=t,this.pitch=Math.min(this.pitch,t));},go.renderWorldCopies.get=function(){return this._renderWorldCopies},go.renderWorldCopies.set=function(t){void 0===t?t=!0:null===t&&(t=!1),this._renderWorldCopies=t;},go.worldSize.get=function(){return this.tileSize*this.scale},go.centerPoint.get=function(){return this.size._div(2)},go.size.get=function(){return new t.Point(this.width,this.height)},go.bearing.get=function(){return -this.angle/Math.PI*180},go.bearing.set=function(e){var i=-t.wrap(e,-180,180)*Math.PI/180;this.angle!==i&&(this._unmodified=!1,this.angle=i,this._calcMatrices(),this.rotationMatrix=t.create$2(),t.rotate(this.rotationMatrix,this.rotationMatrix,this.angle));},go.pitch.get=function(){return this._pitch/Math.PI*180},go.pitch.set=function(e){var i=t.clamp(e,this.minPitch,this.maxPitch)/180*Math.PI;this._pitch!==i&&(this._unmodified=!1,this._pitch=i,this._calcMatrices());},go.fov.get=function(){return this._fov/Math.PI*180},go.fov.set=function(t){t=Math.max(.01,Math.min(60,t)),this._fov!==t&&(this._unmodified=!1,this._fov=t/180*Math.PI,this._calcMatrices());},go.zoom.get=function(){return this._zoom},go.zoom.set=function(t){var e=Math.min(Math.max(t,this.minZoom),this.maxZoom);this._zoom!==e&&(this._unmodified=!1,this._zoom=e,this.scale=this.zoomScale(e),this.tileZoom=Math.floor(e),this.zoomFraction=e-this.tileZoom,this._constrain(),this._calcMatrices());},go.center.get=function(){return this._center},go.center.set=function(t){t.lat===this._center.lat&&t.lng===this._center.lng||(this._unmodified=!1,this._center=t,this._constrain(),this._calcMatrices());},mo.prototype.coveringZoomLevel=function(t){var e=(t.roundZoom?Math.round:Math.floor)(this.zoom+this.scaleZoom(this.tileSize/t.tileSize));return Math.max(0,e)},mo.prototype.getVisibleUnwrappedCoordinates=function(e){var i=[new t.UnwrappedTileID(0,e)];if(this._renderWorldCopies)for(var o=this.pointCoordinate(new t.Point(0,0)),r=this.pointCoordinate(new t.Point(this.width,0)),a=this.pointCoordinate(new t.Point(this.width,this.height)),n=this.pointCoordinate(new t.Point(0,this.height)),s=Math.floor(Math.min(o.x,r.x,a.x,n.x)),l=Math.floor(Math.max(o.x,r.x,a.x,n.x)),c=s-1;c<=l+1;c++)0!==c&&i.push(new t.UnwrappedTileID(c,e));return i},mo.prototype.coveringTiles=function(e){var i=this.coveringZoomLevel(e),o=i;if(void 0!==e.minzoom&&i<e.minzoom)return [];void 0!==e.maxzoom&&i>e.maxzoom&&(i=e.maxzoom);var r=t.MercatorCoordinate.fromLngLat(this.center),a=Math.pow(2,i),n=[a*r.x,a*r.y,0],s=_o.fromInvProjectionMatrix(this.invProjMatrix,this.worldSize,i),l=e.minzoom||0;this.pitch<=60&&(l=i);var c=function(t){return {aabb:new fo([t*a,0,0],[(t+1)*a,a,0]),zoom:0,x:0,y:0,wrap:t,fullyVisible:!1}},u=[],h=[],p=i,d=e.reparseOverscaled?o:i;if(this._renderWorldCopies)for(var _=1;_<=3;_++)u.push(c(-_)),u.push(c(_));for(u.push(c(0));u.length>0;){var f=u.pop(),m=f.x,g=f.y,v=f.fullyVisible;if(!v){var y=f.aabb.intersects(s);if(0===y)continue;v=2===y;}var x=f.aabb.distanceX(n),b=f.aabb.distanceY(n),w=Math.max(Math.abs(x),Math.abs(b)),E=3+(1<<p-f.zoom)-2;if(f.zoom===p||w>E&&f.zoom>=l)h.push({tileID:new t.OverscaledTileID(f.zoom===p?d:f.zoom,f.wrap,f.zoom,m,g),distanceSq:t.sqrLen([n[0]-.5-m,n[1]-.5-g])});else for(var T=0;T<4;T++){var I=(m<<1)+T%2,S=(g<<1)+(T>>1);u.push({aabb:f.aabb.quadrant(T),zoom:f.zoom+1,x:I,y:S,wrap:f.wrap,fullyVisible:v});}}return h.sort((function(t,e){return t.distanceSq-e.distanceSq})).map((function(t){return t.tileID}))},mo.prototype.resize=function(t,e){this.width=t,this.height=e,this.pixelsToGLUnits=[2/t,-2/e],this._constrain(),this._calcMatrices();},go.unmodified.get=function(){return this._unmodified},mo.prototype.zoomScale=function(t){return Math.pow(2,t)},mo.prototype.scaleZoom=function(t){return Math.log(t)/Math.LN2},mo.prototype.project=function(e){var i=t.clamp(e.lat,-this.maxValidLatitude,this.maxValidLatitude);return new t.Point(t.mercatorXfromLng(e.lng)*this.worldSize,t.mercatorYfromLat(i)*this.worldSize)},mo.prototype.unproject=function(e){return new t.MercatorCoordinate(e.x/this.worldSize,e.y/this.worldSize).toLngLat()},go.point.get=function(){return this.project(this.center)},mo.prototype.setLocationAtPoint=function(e,i){var o=this.pointCoordinate(i),r=this.pointCoordinate(this.centerPoint),a=this.locationCoordinate(e),n=new t.MercatorCoordinate(a.x-(o.x-r.x),a.y-(o.y-r.y));this.center=this.coordinateLocation(n),this._renderWorldCopies&&(this.center=this.center.wrap());},mo.prototype.locationPoint=function(t){return this.coordinatePoint(this.locationCoordinate(t))},mo.prototype.pointLocation=function(t){return this.coordinateLocation(this.pointCoordinate(t))},mo.prototype.locationCoordinate=function(e){return t.MercatorCoordinate.fromLngLat(e)},mo.prototype.coordinateLocation=function(t){return t.toLngLat()},mo.prototype.pointCoordinate=function(e){var i=[e.x,e.y,0,1],o=[e.x,e.y,1,1];t.transformMat4(i,i,this.pixelMatrixInverse),t.transformMat4(o,o,this.pixelMatrixInverse);var r=i[3],a=o[3],n=i[0]/r,s=o[0]/a,l=i[1]/r,c=o[1]/a,u=i[2]/r,h=o[2]/a,p=u===h?0:(0-u)/(h-u);return new t.MercatorCoordinate(t.number(n,s,p)/this.worldSize,t.number(l,c,p)/this.worldSize)},mo.prototype.coordinatePoint=function(e){var i=[e.x*this.worldSize,e.y*this.worldSize,0,1];return t.transformMat4(i,i,this.pixelMatrix),new t.Point(i[0]/i[3],i[1]/i[3])},mo.prototype.getBounds=function(){return (new t.LngLatBounds).extend(this.pointLocation(new t.Point(0,0))).extend(this.pointLocation(new t.Point(this.width,0))).extend(this.pointLocation(new t.Point(this.width,this.height))).extend(this.pointLocation(new t.Point(0,this.height)))},mo.prototype.getMaxBounds=function(){return this.latRange&&2===this.latRange.length&&this.lngRange&&2===this.lngRange.length?new t.LngLatBounds([this.lngRange[0],this.latRange[0]],[this.lngRange[1],this.latRange[1]]):null},mo.prototype.setMaxBounds=function(t){t?(this.lngRange=[t.getWest(),t.getEast()],this.latRange=[t.getSouth(),t.getNorth()],this._constrain()):(this.lngRange=null,this.latRange=[-this.maxValidLatitude,this.maxValidLatitude]);},mo.prototype.calculatePosMatrix=function(e,i){void 0===i&&(i=!1);var o=e.key,r=i?this._alignedPosMatrixCache:this._posMatrixCache;if(r[o])return r[o];var a=e.canonical,n=this.worldSize/this.zoomScale(a.z),s=a.x+Math.pow(2,a.z)*e.wrap,l=t.identity(new Float64Array(16));return t.translate(l,l,[s*n,a.y*n,0]),t.scale(l,l,[n/t.EXTENT,n/t.EXTENT,1]),t.multiply(l,i?this.alignedProjMatrix:this.projMatrix,l),r[o]=new Float32Array(l),r[o]},mo.prototype.customLayerMatrix=function(){return this.mercatorMatrix.slice()},mo.prototype._constrain=function(){if(this.center&&this.width&&this.height&&!this._constraining){this._constraining=!0;var e,i,o,r,a=-90,n=90,s=-180,l=180,c=this.size,u=this._unmodified;if(this.latRange){var h=this.latRange;a=t.mercatorYfromLat(h[1])*this.worldSize,e=(n=t.mercatorYfromLat(h[0])*this.worldSize)-a<c.y?c.y/(n-a):0;}if(this.lngRange){var p=this.lngRange;s=t.mercatorXfromLng(p[0])*this.worldSize,i=(l=t.mercatorXfromLng(p[1])*this.worldSize)-s<c.x?c.x/(l-s):0;}var d=this.point,_=Math.max(i||0,e||0);if(_)return this.center=this.unproject(new t.Point(i?(l+s)/2:d.x,e?(n+a)/2:d.y)),this.zoom+=this.scaleZoom(_),this._unmodified=u,void(this._constraining=!1);if(this.latRange){var f=d.y,m=c.y/2;f-m<a&&(r=a+m),f+m>n&&(r=n-m);}if(this.lngRange){var g=d.x,v=c.x/2;g-v<s&&(o=s+v),g+v>l&&(o=l-v);}void 0===o&&void 0===r||(this.center=this.unproject(new t.Point(void 0!==o?o:d.x,void 0!==r?r:d.y))),this._unmodified=u,this._constraining=!1;}},mo.prototype._calcMatrices=function(){if(this.height){this.cameraToCenterDistance=.5/Math.tan(this._fov/2)*this.height;var e=this._fov/2,i=Math.PI/2+this._pitch,o=Math.sin(e)*this.cameraToCenterDistance/Math.sin(t.clamp(Math.PI-i-e,.01,Math.PI-.01)),r=this.point,a=r.x,n=r.y,s=1.01*(Math.cos(Math.PI/2-this._pitch)*o+this.cameraToCenterDistance),l=this.height/50,c=new Float64Array(16);t.perspective(c,this._fov,this.width/this.height,l,s),t.scale(c,c,[1,-1,1]),t.translate(c,c,[0,0,-this.cameraToCenterDistance]),t.rotateX(c,c,this._pitch),t.rotateZ(c,c,this.angle),t.translate(c,c,[-a,-n,0]),this.mercatorMatrix=t.scale([],c,[this.worldSize,this.worldSize,this.worldSize]),t.scale(c,c,[1,1,t.mercatorZfromAltitude(1,this.center.lat)*this.worldSize,1]),this.projMatrix=c,this.invProjMatrix=t.invert([],this.projMatrix);var u=this.width%2/2,h=this.height%2/2,p=Math.cos(this.angle),d=Math.sin(this.angle),_=a-Math.round(a)+p*u+d*h,f=n-Math.round(n)+p*h+d*u,m=new Float64Array(c);if(t.translate(m,m,[_>.5?_-1:_,f>.5?f-1:f,0]),this.alignedProjMatrix=m,c=t.create(),t.scale(c,c,[this.width/2,-this.height/2,1]),t.translate(c,c,[1,-1,0]),this.labelPlaneMatrix=c,c=t.create(),t.scale(c,c,[1,-1,1]),t.translate(c,c,[-1,-1,0]),t.scale(c,c,[2/this.width,2/this.height,1]),this.glCoordMatrix=c,this.pixelMatrix=t.multiply(new Float64Array(16),this.labelPlaneMatrix,this.projMatrix),!(c=t.invert(new Float64Array(16),this.pixelMatrix)))throw new Error("failed to invert matrix");this.pixelMatrixInverse=c,this._posMatrixCache={},this._alignedPosMatrixCache={};}},mo.prototype.maxPitchScaleFactor=function(){if(!this.pixelMatrixInverse)return 1;var e=this.pointCoordinate(new t.Point(0,0)),i=[e.x*this.worldSize,e.y*this.worldSize,0,1];return t.transformMat4(i,i,this.pixelMatrix)[3]/this.cameraToCenterDistance},mo.prototype.getCameraPoint=function(){var e=this._pitch,i=Math.tan(e)*(this.cameraToCenterDistance||1);return this.centerPoint.add(new t.Point(0,i))},mo.prototype.getCameraQueryGeometry=function(e){var i=this.getCameraPoint();if(1===e.length)return [e[0],i];for(var o=i.x,r=i.y,a=i.x,n=i.y,s=0,l=e;s<l.length;s+=1){var c=l[s];o=Math.min(o,c.x),r=Math.min(r,c.y),a=Math.max(a,c.x),n=Math.max(n,c.y);}return [new t.Point(o,r),new t.Point(a,r),new t.Point(a,n),new t.Point(o,n),new t.Point(o,r)]},Object.defineProperties(mo.prototype,go);var vo=function(e){var i,o,r,a,n;this._hashName=e&&encodeURIComponent(e),t.bindAll(["_getCurrentHash","_onHashChange","_updateHash"],this),this._updateHash=(i=this._updateHashUnthrottled.bind(this),o=300,r=!1,a=null,n=function(){a=null,r&&(i(),a=setTimeout(n,o),r=!1);},function(){return r=!0,a||n(),a});};vo.prototype.addTo=function(e){return this._map=e,t.window.addEventListener("hashchange",this._onHashChange,!1),this._map.on("moveend",this._updateHash),this},vo.prototype.remove=function(){return t.window.removeEventListener("hashchange",this._onHashChange,!1),this._map.off("moveend",this._updateHash),clearTimeout(this._updateHash()),delete this._map,this},vo.prototype.getHashString=function(e){var i=this._map.getCenter(),o=Math.round(100*this._map.getZoom())/100,r=Math.ceil((o*Math.LN2+Math.log(512/360/.5))/Math.LN10),a=Math.pow(10,r),n=Math.round(i.lng*a)/a,s=Math.round(i.lat*a)/a,l=this._map.getBearing(),c=this._map.getPitch(),u="";if(u+=e?"/"+n+"/"+s+"/"+o:o+"/"+s+"/"+n,(l||c)&&(u+="/"+Math.round(10*l)/10),c&&(u+="/"+Math.round(c)),this._hashName){var h=this._hashName,p=!1,d=t.window.location.hash.slice(1).split("&").map((function(t){var e=t.split("=")[0];return e===h?(p=!0,e+"="+u):t})).filter((function(t){return t}));return p||d.push(h+"="+u),"#"+d.join("&")}return "#"+u},vo.prototype._getCurrentHash=function(){var e,i=this,o=t.window.location.hash.replace("#","");return this._hashName?(o.split("&").map((function(t){return t.split("=")})).forEach((function(t){t[0]===i._hashName&&(e=t);})),(e&&e[1]||"").split("/")):o.split("/")},vo.prototype._onHashChange=function(){var t=this._getCurrentHash();if(t.length>=3&&!t.some((function(t){return isNaN(t)}))){var e=this._map.dragRotate.isEnabled()&&this._map.touchZoomRotate.isEnabled()?+(t[3]||0):this._map.getBearing();return this._map.jumpTo({center:[+t[2],+t[1]],zoom:+t[0],bearing:e,pitch:+(t[4]||0)}),!0}return !1},vo.prototype._updateHashUnthrottled=function(){var e=this.getHashString();try{t.window.history.replaceState(t.window.history.state,"",e);}catch(t){}};var yo=function(e){function o(o,r,a,n){void 0===n&&(n={});var s=i.mousePos(r.getCanvasContainer(),a),l=r.unproject(s);e.call(this,o,t.extend({point:s,lngLat:l,originalEvent:a},n)),this._defaultPrevented=!1,this.target=r;}e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o;var r={defaultPrevented:{configurable:!0}};return o.prototype.preventDefault=function(){this._defaultPrevented=!0;},r.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(o.prototype,r),o}(t.Event),xo=function(e){function o(o,r,a){var n=i.touchPos(r.getCanvasContainer(),a),s=n.map((function(t){return r.unproject(t)})),l=n.reduce((function(t,e,i,o){return t.add(e.div(o.length))}),new t.Point(0,0)),c=r.unproject(l);e.call(this,o,{points:n,point:l,lngLats:s,lngLat:c,originalEvent:a}),this._defaultPrevented=!1;}e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o;var r={defaultPrevented:{configurable:!0}};return o.prototype.preventDefault=function(){this._defaultPrevented=!0;},r.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(o.prototype,r),o}(t.Event),bo=function(t){function e(e,i,o){t.call(this,e,{originalEvent:o}),this._defaultPrevented=!1;}t&&(e.__proto__=t),e.prototype=Object.create(t&&t.prototype),e.prototype.constructor=e;var i={defaultPrevented:{configurable:!0}};return e.prototype.preventDefault=function(){this._defaultPrevented=!0;},i.defaultPrevented.get=function(){return this._defaultPrevented},Object.defineProperties(e.prototype,i),e}(t.Event),wo=function(e){this._map=e,this._el=e.getCanvasContainer(),this._delta=0,this._defaultZoomRate=.01,this._wheelZoomRate=1/450,t.bindAll(["_onWheel","_onTimeout","_onScrollFrame","_onScrollFinished"],this);};wo.prototype.setZoomRate=function(t){this._defaultZoomRate=t;},wo.prototype.setWheelZoomRate=function(t){this._wheelZoomRate=t;},wo.prototype.isEnabled=function(){return !!this._enabled},wo.prototype.isActive=function(){return !!this._active},wo.prototype.isZooming=function(){return !!this._zooming},wo.prototype.enable=function(t){this.isEnabled()||(this._enabled=!0,this._aroundCenter=t&&"center"===t.around);},wo.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},wo.prototype.onWheel=function(e){if(this.isEnabled()){var i=e.deltaMode===t.window.WheelEvent.DOM_DELTA_LINE?40*e.deltaY:e.deltaY,o=t.browser.now(),r=o-(this._lastWheelEventTime||0);this._lastWheelEventTime=o,0!==i&&i%4.000244140625==0?this._type="wheel":0!==i&&Math.abs(i)<4?this._type="trackpad":r>400?(this._type=null,this._lastValue=i,this._timeout=setTimeout(this._onTimeout,40,e)):this._type||(this._type=Math.abs(r*i)<200?"trackpad":"wheel",this._timeout&&(clearTimeout(this._timeout),this._timeout=null,i+=this._lastValue)),e.shiftKey&&i&&(i/=4),this._type&&(this._lastWheelEvent=e,this._delta-=i,this.isActive()||this._start(e)),e.preventDefault();}},wo.prototype._onTimeout=function(t){this._type="wheel",this._delta-=this._lastValue,this.isActive()||this._start(t);},wo.prototype._start=function(e){if(this._delta){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),this._active=!0,this.isZooming()||(this._zooming=!0,this._map.fire(new t.Event("movestart",{originalEvent:e})),this._map.fire(new t.Event("zoomstart",{originalEvent:e}))),this._finishTimeout&&clearTimeout(this._finishTimeout);var o=i.mousePos(this._el,e);this._around=t.LngLat.convert(this._aroundCenter?this._map.getCenter():this._map.unproject(o)),this._aroundPoint=this._map.transform.locationPoint(this._around),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onScrollFrame));}},wo.prototype._onScrollFrame=function(){var e=this;if(this._frameId=null,this.isActive()){var i=this._map.transform;if(0!==this._delta){var o="wheel"===this._type&&Math.abs(this._delta)>4.000244140625?this._wheelZoomRate:this._defaultZoomRate,r=2/(1+Math.exp(-Math.abs(this._delta*o)));this._delta<0&&0!==r&&(r=1/r);var a="number"==typeof this._targetZoom?i.zoomScale(this._targetZoom):i.scale;this._targetZoom=Math.min(i.maxZoom,Math.max(i.minZoom,i.scaleZoom(a*r))),"wheel"===this._type&&(this._startZoom=i.zoom,this._easing=this._smoothOutEasing(200)),this._delta=0;}var n="number"==typeof this._targetZoom?this._targetZoom:i.zoom,s=this._startZoom,l=this._easing,c=!1;if("wheel"===this._type&&s&&l){var u=Math.min((t.browser.now()-this._lastWheelEventTime)/200,1),h=l(u);i.zoom=t.number(s,n,h),u<1?this._frameId||(this._frameId=this._map._requestRenderFrame(this._onScrollFrame)):c=!0;}else i.zoom=n,c=!0;i.setLocationAtPoint(this._around,this._aroundPoint),this._map.fire(new t.Event("move",{originalEvent:this._lastWheelEvent})),this._map.fire(new t.Event("zoom",{originalEvent:this._lastWheelEvent})),c&&(this._active=!1,this._finishTimeout=setTimeout((function(){e._zooming=!1,e._map.fire(new t.Event("zoomend",{originalEvent:e._lastWheelEvent})),e._map.fire(new t.Event("moveend",{originalEvent:e._lastWheelEvent})),delete e._targetZoom;}),200));}},wo.prototype._smoothOutEasing=function(e){var i=t.ease;if(this._prevEase){var o=this._prevEase,r=(t.browser.now()-o.start)/o.duration,a=o.easing(r+.01)-o.easing(r),n=.27/Math.sqrt(a*a+1e-4)*.01,s=Math.sqrt(.0729-n*n);i=t.bezier(n,s,.25,1);}return this._prevEase={start:t.browser.now(),duration:e,easing:i},i};var Eo=function(e,i){this._map=e,this._el=e.getCanvasContainer(),this._container=e.getContainer(),this._clickTolerance=i.clickTolerance||1,t.bindAll(["_onMouseMove","_onMouseUp","_onKeyDown"],this);};Eo.prototype.isEnabled=function(){return !!this._enabled},Eo.prototype.isActive=function(){return !!this._active},Eo.prototype.enable=function(){this.isEnabled()||(this._enabled=!0);},Eo.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},Eo.prototype.onMouseDown=function(e){this.isEnabled()&&e.shiftKey&&0===e.button&&(t.window.document.addEventListener("mousemove",this._onMouseMove,!1),t.window.document.addEventListener("keydown",this._onKeyDown,!1),t.window.document.addEventListener("mouseup",this._onMouseUp,!1),i.disableDrag(),this._startPos=this._lastPos=i.mousePos(this._el,e),this._active=!0);},Eo.prototype._onMouseMove=function(t){var e=i.mousePos(this._el,t);if(!(this._lastPos.equals(e)||!this._box&&e.dist(this._startPos)<this._clickTolerance)){var o=this._startPos;this._lastPos=e,this._box||(this._box=i.create("div","mapboxgl-boxzoom",this._container),this._container.classList.add("mapboxgl-crosshair"),this._fireEvent("boxzoomstart",t));var r=Math.min(o.x,e.x),a=Math.max(o.x,e.x),n=Math.min(o.y,e.y),s=Math.max(o.y,e.y);i.setTransform(this._box,"translate("+r+"px,"+n+"px)"),this._box.style.width=a-r+"px",this._box.style.height=s-n+"px";}},Eo.prototype._onMouseUp=function(e){if(0===e.button){var o=this._startPos,r=i.mousePos(this._el,e);this._finish(),i.suppressClick(),o.x===r.x&&o.y===r.y?this._fireEvent("boxzoomcancel",e):this._map.fitScreenCoordinates(o,r,this._map.getBearing(),{linear:!0}).fire(new t.Event("boxzoomend",{originalEvent:e}));}},Eo.prototype._onKeyDown=function(t){27===t.keyCode&&(this._finish(),this._fireEvent("boxzoomcancel",t));},Eo.prototype._finish=function(){this._active=!1,t.window.document.removeEventListener("mousemove",this._onMouseMove,!1),t.window.document.removeEventListener("keydown",this._onKeyDown,!1),t.window.document.removeEventListener("mouseup",this._onMouseUp,!1),this._container.classList.remove("mapboxgl-crosshair"),this._box&&(i.remove(this._box),this._box=null),i.enableDrag(),delete this._startPos,delete this._lastPos;},Eo.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,{originalEvent:i}))};var To=t.bezier(0,0,.25,1),Io=function(e,i){this._map=e,this._el=i.element||e.getCanvasContainer(),this._state="disabled",this._button=i.button||"right",this._bearingSnap=i.bearingSnap||0,this._pitchWithRotate=!1!==i.pitchWithRotate,this._clickTolerance=i.clickTolerance||1,t.bindAll(["onMouseDown","_onMouseMove","_onMouseUp","_onBlur","_onDragFrame"],this);};Io.prototype.isEnabled=function(){return "disabled"!==this._state},Io.prototype.isActive=function(){return "active"===this._state},Io.prototype.enable=function(){this.isEnabled()||(this._state="enabled");},Io.prototype.disable=function(){if(this.isEnabled())switch(this._state){case"active":this._state="disabled",this._unbind(),this._deactivate(),this._fireEvent("rotateend"),this._pitchWithRotate&&this._fireEvent("pitchend"),this._fireEvent("moveend");break;case"pending":this._state="disabled",this._unbind();break;default:this._state="disabled";}},Io.prototype.onMouseDown=function(e){if("enabled"===this._state){var o="touchstart"===e.type;if(o)this._startTime=Date.now();else if("right"===this._button){if(this._eventButton=i.mouseButton(e),e.altKey||e.metaKey)return;if(this._eventButton!==(e.ctrlKey?0:2))return}else{if(e.ctrlKey||0!==i.mouseButton(e))return;this._eventButton=0;}i.disableDrag(),o?(t.window.document.addEventListener("touchmove",this._onMouseMove,{capture:!0}),t.window.document.addEventListener("touchend",this._onMouseUp)):(t.window.document.addEventListener("mousemove",this._onMouseMove,{capture:!0}),t.window.document.addEventListener("mouseup",this._onMouseUp)),t.window.addEventListener("blur",this._onBlur),this._state="pending",this._inertia=[[t.browser.now(),this._map.getBearing()]],this._startPos=this._prevPos=this._lastPos=i.mousePos(this._el,e),this._center=this._map.transform.centerPoint,e.preventDefault();}},Io.prototype._onMouseMove=function(t){var e=i.mousePos(this._el,t);this._lastPos.equals(e)||"pending"===this._state&&e.dist(this._startPos)<this._clickTolerance||(this._lastMoveEvent=t,this._lastPos=e,"pending"===this._state&&(this._state="active",this._fireEvent("rotatestart",t),this._fireEvent("movestart",t),this._pitchWithRotate&&this._fireEvent("pitchstart",t)),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onDragFrame)));},Io.prototype._onDragFrame=function(){this._frameId=null;var e=this._lastMoveEvent;if(e){var i=this._map.transform,o=this._prevPos,r=this._lastPos,a=.8*(o.x-r.x),n=-.5*(o.y-r.y),s=i.bearing-a,l=i.pitch-n,c=this._inertia,u=c[c.length-1];this._drainInertiaBuffer(),c.push([t.browser.now(),this._map._normalizeBearing(s,u[1])]);var h=i.bearing;if(i.bearing=s,this._pitchWithRotate){var p=i.pitch;i.pitch=l,i.pitch!==p&&this._fireEvent("pitch",e);}i.bearing!==h&&this._fireEvent("rotate",e),this._fireEvent("move",e),delete this._lastMoveEvent,this._prevPos=this._lastPos;}},Io.prototype._onMouseUp=function(t){var e="touchend"===t.type;if(e&&this._startPos===this._lastPos&&Date.now()-this._startTime<300&&this._el.click(),e||i.mouseButton(t)===this._eventButton)switch(this._state){case"active":this._state="enabled",i.suppressClick(),this._unbind(),this._deactivate(),this._inertialRotate(t);break;case"pending":this._state="enabled",this._unbind();}},Io.prototype._onBlur=function(t){switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._fireEvent("rotateend",t),this._pitchWithRotate&&this._fireEvent("pitchend",t),this._fireEvent("moveend",t);break;case"pending":this._state="enabled",this._unbind();}},Io.prototype._unbind=function(){t.window.document.removeEventListener("mousemove",this._onMouseMove,{capture:!0}),t.window.document.removeEventListener("mouseup",this._onMouseUp),t.window.document.removeEventListener("touchmove",this._onMouseMove,{capture:!0}),t.window.document.removeEventListener("touchend",this._onMouseUp),t.window.removeEventListener("blur",this._onBlur),i.enableDrag();},Io.prototype._deactivate=function(){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._lastMoveEvent,delete this._startPos,delete this._prevPos,delete this._lastPos;},Io.prototype._inertialRotate=function(t){var e=this;this._fireEvent("rotateend",t),this._drainInertiaBuffer();var i=this._map,o=i.getBearing(),r=this._inertia,a=function(){Math.abs(o)<e._bearingSnap?i.resetNorth({noMoveStart:!0},{originalEvent:t}):e._fireEvent("moveend",t),e._pitchWithRotate&&e._fireEvent("pitchend",t);};if(r.length<2)a();else{var n=r[0],s=r[r.length-1],l=r[r.length-2],c=i._normalizeBearing(o,l[1]),u=s[1]-n[1],h=u<0?-1:1,p=(s[0]-n[0])/1e3;if(0!==u&&0!==p){var d=Math.abs(u*(.25/p));d>180&&(d=180);var _=d/180;c+=h*d*(_/2),Math.abs(i._normalizeBearing(c,0))<this._bearingSnap&&(c=i._normalizeBearing(0,c)),i.rotateTo(c,{duration:1e3*_,easing:To,noMoveStart:!0},{originalEvent:t});}else a();}},Io.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,i?{originalEvent:i}:{}))},Io.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>0&&i-e[0][0]>160;)e.shift();};var So={linearity:.3,easing:t.bezier(0,0,.3,1),maxSpeed:1400,deceleration:2500},Co=function(e,i){this._map=e,this._el=e.getCanvasContainer(),this._state="disabled",this._clickTolerance=i.clickTolerance||1,this._inertiaOptions=So,t.bindAll(["_onMove","_onMouseUp","_onTouchEnd","_onBlur","_onDragFrame"],this);};Co.prototype.isEnabled=function(){return "disabled"!==this._state},Co.prototype.isActive=function(){return "active"===this._state},Co.prototype.enable=function(e){this.isEnabled()||(this._el.classList.add("mapboxgl-touch-drag-pan"),this._state="enabled",this._inertiaOptions=t.extend(So,e));},Co.prototype.disable=function(){if(this.isEnabled())switch(this._el.classList.remove("mapboxgl-touch-drag-pan"),this._state){case"active":this._state="disabled",this._unbind(),this._deactivate(),this._fireEvent("dragend"),this._fireEvent("moveend");break;case"pending":this._state="disabled",this._unbind();break;default:this._state="disabled";}},Co.prototype.onMouseDown=function(e){"enabled"===this._state&&(e.ctrlKey||0!==i.mouseButton(e)||(i.addEventListener(t.window.document,"mousemove",this._onMove,{capture:!0}),i.addEventListener(t.window.document,"mouseup",this._onMouseUp),this._start(e)));},Co.prototype.onTouchStart=function(e){this.isEnabled()&&(e.touches&&e.touches.length>1&&("pending"===this._state||"active"===this._state)||(i.addEventListener(t.window.document,"touchmove",this._onMove,{capture:!0,passive:!1}),i.addEventListener(t.window.document,"touchend",this._onTouchEnd),this._start(e)));},Co.prototype._start=function(e){t.window.addEventListener("blur",this._onBlur),this._state="pending",this._startPos=this._mouseDownPos=this._prevPos=this._lastPos=i.mousePos(this._el,e),this._startTouch=this._lastTouch=t.window.TouchEvent&&e instanceof t.window.TouchEvent?i.touchPos(this._el,e):null,this._inertia=[[t.browser.now(),this._startPos]];},Co.prototype._touchesMatch=function(t,e){return !(!t||!e||t.length!==e.length)&&t.every((function(t,i){return e[i]===t}))},Co.prototype._onMove=function(e){e.preventDefault();var o=t.window.TouchEvent&&e instanceof t.window.TouchEvent?i.touchPos(this._el,e):null,r=i.mousePos(this._el,e);(o?this._touchesMatch(this._lastTouch,o):this._lastPos.equals(r))||"pending"===this._state&&r.dist(this._mouseDownPos)<this._clickTolerance||(this._lastMoveEvent=e,this._lastPos=r,this._lastTouch=o,this._drainInertiaBuffer(),this._inertia.push([t.browser.now(),this._lastPos]),"pending"===this._state&&(this._state="active",this._shouldStart=!0),this._frameId||(this._frameId=this._map._requestRenderFrame(this._onDragFrame)));},Co.prototype._onDragFrame=function(){this._frameId=null;var t=this._lastMoveEvent;if(t)if(this._map.touchZoomRotate.isActive())this._abort(t);else if(this._shouldStart&&(this._fireEvent("dragstart",t),this._fireEvent("movestart",t),this._shouldStart=!1),this.isActive()){var e=this._map.transform;e.setLocationAtPoint(e.pointLocation(this._prevPos),this._lastPos),this._fireEvent("drag",t),this._fireEvent("move",t),this._prevPos=this._lastPos,delete this._lastMoveEvent;}},Co.prototype._onMouseUp=function(t){if(0===i.mouseButton(t))switch(this._state){case"active":this._state="enabled",i.suppressClick(),this._unbind(),this._deactivate(),this._inertialPan(t);break;case"pending":this._state="enabled",this._unbind();}},Co.prototype._onTouchEnd=function(t){if(t.touches&&0!==t.touches.length)switch(this._state){case"pending":case"active":break;case"enabled":this.onTouchStart(t);}else switch(this._state){case"active":this._state="enabled",this._unbind(),this._deactivate(),this._inertialPan(t);break;case"pending":this._state="enabled",this._unbind();break;case"enabled":this._unbind();}},Co.prototype._abort=function(e){switch(this._state){case"active":this._state="enabled",this._shouldStart||(this._fireEvent("dragend",e),this._fireEvent("moveend",e)),this._unbind(),this._deactivate(),t.window.TouchEvent&&e instanceof t.window.TouchEvent&&e.touches.length>1&&i.addEventListener(t.window.document,"touchend",this._onTouchEnd);break;case"pending":this._state="enabled",this._unbind();break;case"enabled":this._unbind();}},Co.prototype._onBlur=function(t){this._abort(t);},Co.prototype._unbind=function(){i.removeEventListener(t.window.document,"touchmove",this._onMove,{capture:!0,passive:!1}),i.removeEventListener(t.window.document,"touchend",this._onTouchEnd),i.removeEventListener(t.window.document,"mousemove",this._onMove,{capture:!0}),i.removeEventListener(t.window.document,"mouseup",this._onMouseUp),i.removeEventListener(t.window,"blur",this._onBlur);},Co.prototype._deactivate=function(){this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._lastMoveEvent,delete this._startPos,delete this._prevPos,delete this._mouseDownPos,delete this._lastPos,delete this._startTouch,delete this._lastTouch,delete this._shouldStart;},Co.prototype._inertialPan=function(t){this._fireEvent("dragend",t),this._drainInertiaBuffer();var e=this._inertia;if(e.length<2)this._fireEvent("moveend",t);else{var i=e[e.length-1],o=e[0],r=i[1].sub(o[1]),a=(i[0]-o[0])/1e3;if(0===a||i[1].equals(o[1]))this._fireEvent("moveend",t);else{var n=this._inertiaOptions,s=n.linearity,l=n.easing,c=n.maxSpeed,u=n.deceleration,h=r.mult(s/a),p=h.mag();p>c&&(p=c,h._unit()._mult(p));var d=p/(u*s),_=h.mult(-d/2);this._map.panBy(_,{duration:1e3*d,easing:l,noMoveStart:!0},{originalEvent:t});}}},Co.prototype._fireEvent=function(e,i){return this._map.fire(new t.Event(e,i?{originalEvent:i}:{}))},Co.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>0&&i-e[0][0]>160;)e.shift();};var Po=function(e){this._map=e,this._el=e.getCanvasContainer(),t.bindAll(["_onKeyDown"],this);};function zo(t){return t*(2-t)}Po.prototype.isEnabled=function(){return !!this._enabled},Po.prototype.enable=function(){this.isEnabled()||(this._el.addEventListener("keydown",this._onKeyDown,!1),this._enabled=!0);},Po.prototype.disable=function(){this.isEnabled()&&(this._el.removeEventListener("keydown",this._onKeyDown),this._enabled=!1);},Po.prototype._onKeyDown=function(t){if(!(t.altKey||t.ctrlKey||t.metaKey)){var e=0,i=0,o=0,r=0,a=0;switch(t.keyCode){case 61:case 107:case 171:case 187:e=1;break;case 189:case 109:case 173:e=-1;break;case 37:t.shiftKey?i=-1:(t.preventDefault(),r=-1);break;case 39:t.shiftKey?i=1:(t.preventDefault(),r=1);break;case 38:t.shiftKey?o=1:(t.preventDefault(),a=-1);break;case 40:t.shiftKey?o=-1:(a=1,t.preventDefault());break;default:return}var n=this._map,s=n.getZoom(),l={duration:300,delayEndEvents:500,easing:zo,zoom:e?Math.round(s)+e*(t.shiftKey?2:1):s,bearing:n.getBearing()+15*i,pitch:n.getPitch()+10*o,offset:[100*-r,100*-a],center:n.getCenter()};n.easeTo(l,{originalEvent:t});}};var Lo=function(e){this._map=e,t.bindAll(["_onDblClick","_onZoomEnd"],this);};Lo.prototype.isEnabled=function(){return !!this._enabled},Lo.prototype.isActive=function(){return !!this._active},Lo.prototype.enable=function(){this.isEnabled()||(this._enabled=!0);},Lo.prototype.disable=function(){this.isEnabled()&&(this._enabled=!1);},Lo.prototype.onTouchStart=function(t){var e=this;if(this.isEnabled()&&!(t.points.length>1))if(this._tapped){var i=t.points[0],o=this._tappedPoint;if(o&&o.dist(i)<=30){t.originalEvent.preventDefault();var r=function(){e._tapped&&e._zoom(t),e._map.off("touchcancel",a),e._resetTapped();},a=function(){e._map.off("touchend",r),e._resetTapped();};this._map.once("touchend",r),this._map.once("touchcancel",a);}else this._resetTapped();}else this._tappedPoint=t.points[0],this._tapped=setTimeout((function(){e._tapped=null,e._tappedPoint=null;}),300);},Lo.prototype._resetTapped=function(){clearTimeout(this._tapped),this._tapped=null,this._tappedPoint=null;},Lo.prototype.onDblClick=function(t){this.isEnabled()&&(t.originalEvent.preventDefault(),this._zoom(t));},Lo.prototype._zoom=function(t){this._active=!0,this._map.on("zoomend",this._onZoomEnd),this._map.zoomTo(this._map.getZoom()+(t.originalEvent.shiftKey?-1:1),{around:t.lngLat},t);},Lo.prototype._onZoomEnd=function(){this._active=!1,this._map.off("zoomend",this._onZoomEnd);};var Mo=t.bezier(0,0,.15,1),Do=function(e){this._map=e,this._el=e.getCanvasContainer(),t.bindAll(["_onMove","_onEnd","_onTouchFrame"],this);};Do.prototype.isEnabled=function(){return !!this._enabled},Do.prototype.enable=function(t){this.isEnabled()||(this._el.classList.add("mapboxgl-touch-zoom-rotate"),this._enabled=!0,this._aroundCenter=!!t&&"center"===t.around);},Do.prototype.disable=function(){this.isEnabled()&&(this._el.classList.remove("mapboxgl-touch-zoom-rotate"),this._enabled=!1);},Do.prototype.disableRotation=function(){this._rotationDisabled=!0;},Do.prototype.enableRotation=function(){this._rotationDisabled=!1;},Do.prototype.isActive=function(){return this.isEnabled()&&!!this._gestureIntent},Do.prototype.onStart=function(e){if(this.isEnabled()&&2===e.touches.length){var o=i.mousePos(this._el,e.touches[0]),r=i.mousePos(this._el,e.touches[1]),a=o.add(r).div(2);this._startVec=o.sub(r),this._startAround=this._map.transform.pointLocation(a),this._gestureIntent=void 0,this._inertia=[],i.addEventListener(t.window.document,"touchmove",this._onMove,{passive:!1}),i.addEventListener(t.window.document,"touchend",this._onEnd);}},Do.prototype._getTouchEventData=function(t){var e=i.mousePos(this._el,t.touches[0]),o=i.mousePos(this._el,t.touches[1]),r=e.sub(o);return {vec:r,center:e.add(o).div(2),scale:r.mag()/this._startVec.mag(),bearing:this._rotationDisabled?0:180*r.angleWith(this._startVec)/Math.PI}},Do.prototype._onMove=function(e){if(2===e.touches.length){var i=this._getTouchEventData(e),o=i.vec,r=i.scale,a=i.bearing;if(!this._gestureIntent){var n=this._rotationDisabled&&1!==r||Math.abs(1-r)>.15;Math.abs(a)>10?this._gestureIntent="rotate":n&&(this._gestureIntent="zoom"),this._gestureIntent&&(this._map.fire(new t.Event(this._gestureIntent+"start",{originalEvent:e})),this._map.fire(new t.Event("movestart",{originalEvent:e})),this._startVec=o);}this._lastTouchEvent=e,this._frameId||(this._frameId=this._map._requestRenderFrame(this._onTouchFrame)),e.preventDefault();}},Do.prototype._onTouchFrame=function(){this._frameId=null;var e=this._gestureIntent;if(e){var i=this._map.transform;this._startScale||(this._startScale=i.scale,this._startBearing=i.bearing);var o=this._getTouchEventData(this._lastTouchEvent),r=o.center,a=o.bearing,n=o.scale,s=i.pointLocation(r),l=i.locationPoint(s);"rotate"===e&&(i.bearing=this._startBearing+a),i.zoom=i.scaleZoom(this._startScale*n),i.setLocationAtPoint(this._startAround,l),this._map.fire(new t.Event(e,{originalEvent:this._lastTouchEvent})),this._map.fire(new t.Event("move",{originalEvent:this._lastTouchEvent})),this._drainInertiaBuffer(),this._inertia.push([t.browser.now(),n,r]);}},Do.prototype._onEnd=function(e){i.removeEventListener(t.window.document,"touchmove",this._onMove,{passive:!1}),i.removeEventListener(t.window.document,"touchend",this._onEnd);var o=this._gestureIntent,r=this._startScale;if(this._frameId&&(this._map._cancelRenderFrame(this._frameId),this._frameId=null),delete this._gestureIntent,delete this._startScale,delete this._startBearing,delete this._lastTouchEvent,o){this._map.fire(new t.Event(o+"end",{originalEvent:e})),this._drainInertiaBuffer();var a=this._inertia,n=this._map;if(a.length<2)n.snapToNorth({},{originalEvent:e});else{var s=a[a.length-1],l=a[0],c=n.transform.scaleZoom(r*s[1]),u=n.transform.scaleZoom(r*l[1]),h=c-u,p=(s[0]-l[0])/1e3,d=s[2];if(0!==p&&c!==u){var _=.15*h/p;Math.abs(_)>2.5&&(_=_>0?2.5:-2.5);var f=1e3*Math.abs(_/(12*.15)),m=c+_*f/2e3;n.easeTo({zoom:m,duration:f,easing:Mo,around:this._aroundCenter?n.getCenter():n.unproject(d),noMoveStart:!0},{originalEvent:e});}else n.snapToNorth({},{originalEvent:e});}}},Do.prototype._drainInertiaBuffer=function(){for(var e=this._inertia,i=t.browser.now();e.length>2&&i-e[0][0]>160;)e.shift();};var Ao={scrollZoom:wo,boxZoom:Eo,dragRotate:Io,dragPan:Co,keyboard:Po,doubleClickZoom:Lo,touchZoomRotate:Do};var Ro=function(e){function i(i,o){e.call(this),this._moving=!1,this._zooming=!1,this.transform=i,this._bearingSnap=o.bearingSnap,t.bindAll(["_renderFrameCallback"],this);}return e&&(i.__proto__=e),i.prototype=Object.create(e&&e.prototype),i.prototype.constructor=i,i.prototype.getCenter=function(){return new t.LngLat(this.transform.center.lng,this.transform.center.lat)},i.prototype.setCenter=function(t,e){return this.jumpTo({center:t},e)},i.prototype.panBy=function(e,i,o){return e=t.Point.convert(e).mult(-1),this.panTo(this.transform.center,t.extend({offset:e},i),o)},i.prototype.panTo=function(e,i,o){return this.easeTo(t.extend({center:e},i),o)},i.prototype.getZoom=function(){return this.transform.zoom},i.prototype.setZoom=function(t,e){return this.jumpTo({zoom:t},e),this},i.prototype.zoomTo=function(e,i,o){return this.easeTo(t.extend({zoom:e},i),o)},i.prototype.zoomIn=function(t,e){return this.zoomTo(this.getZoom()+1,t,e),this},i.prototype.zoomOut=function(t,e){return this.zoomTo(this.getZoom()-1,t,e),this},i.prototype.getBearing=function(){return this.transform.bearing},i.prototype.setBearing=function(t,e){return this.jumpTo({bearing:t},e),this},i.prototype.rotateTo=function(e,i,o){return this.easeTo(t.extend({bearing:e},i),o)},i.prototype.resetNorth=function(e,i){return this.rotateTo(0,t.extend({duration:1e3},e),i),this},i.prototype.resetNorthPitch=function(e,i){return this.easeTo(t.extend({bearing:0,pitch:0,duration:1e3},e),i),this},i.prototype.snapToNorth=function(t,e){return Math.abs(this.getBearing())<this._bearingSnap?this.resetNorth(t,e):this},i.prototype.getPitch=function(){return this.transform.pitch},i.prototype.setPitch=function(t,e){return this.jumpTo({pitch:t},e),this},i.prototype.cameraForBounds=function(e,i){return e=t.LngLatBounds.convert(e),this._cameraForBoxAndBearing(e.getNorthWest(),e.getSouthEast(),0,i)},i.prototype._cameraForBoxAndBearing=function(e,i,o,r){if("number"==typeof(r=t.extend({padding:{top:0,bottom:0,right:0,left:0},offset:[0,0],maxZoom:this.transform.maxZoom},r)).padding){var a=r.padding;r.padding={top:a,bottom:a,right:a,left:a};}if(t.deepEqual(Object.keys(r.padding).sort((function(t,e){return t<e?-1:t>e?1:0})),["bottom","left","right","top"])){var n=this.transform,s=n.project(t.LngLat.convert(e)),l=n.project(t.LngLat.convert(i)),c=s.rotate(-o*Math.PI/180),u=l.rotate(-o*Math.PI/180),h=new t.Point(Math.max(c.x,u.x),Math.max(c.y,u.y)),p=new t.Point(Math.min(c.x,u.x),Math.min(c.y,u.y)),d=h.sub(p),_=(n.width-r.padding.left-r.padding.right)/d.x,f=(n.height-r.padding.top-r.padding.bottom)/d.y;if(!(f<0||_<0)){var m=Math.min(n.scaleZoom(n.scale*Math.min(_,f)),r.maxZoom),g=t.Point.convert(r.offset),v=(r.padding.left-r.padding.right)/2,y=(r.padding.top-r.padding.bottom)/2,x=new t.Point(g.x+v,g.y+y).mult(n.scale/n.zoomScale(m));return {center:n.unproject(s.add(l).div(2).sub(x)),zoom:m,bearing:o}}t.warnOnce("Map cannot fit within canvas with the given bounds, padding, and/or offset.");}else t.warnOnce("options.padding must be a positive number, or an Object with keys 'bottom', 'left', 'right', 'top'");},i.prototype.fitBounds=function(t,e,i){return this._fitInternal(this.cameraForBounds(t,e),e,i)},i.prototype.fitScreenCoordinates=function(e,i,o,r,a){return this._fitInternal(this._cameraForBoxAndBearing(this.transform.pointLocation(t.Point.convert(e)),this.transform.pointLocation(t.Point.convert(i)),o,r),r,a)},i.prototype._fitInternal=function(e,i,o){return e?(i=t.extend(e,i)).linear?this.easeTo(i,o):this.flyTo(i,o):this},i.prototype.jumpTo=function(e,i){this.stop();var o=this.transform,r=!1,a=!1,n=!1;return "zoom"in e&&o.zoom!==+e.zoom&&(r=!0,o.zoom=+e.zoom),void 0!==e.center&&(o.center=t.LngLat.convert(e.center)),"bearing"in e&&o.bearing!==+e.bearing&&(a=!0,o.bearing=+e.bearing),"pitch"in e&&o.pitch!==+e.pitch&&(n=!0,o.pitch=+e.pitch),this.fire(new t.Event("movestart",i)).fire(new t.Event("move",i)),r&&this.fire(new t.Event("zoomstart",i)).fire(new t.Event("zoom",i)).fire(new t.Event("zoomend",i)),a&&this.fire(new t.Event("rotatestart",i)).fire(new t.Event("rotate",i)).fire(new t.Event("rotateend",i)),n&&this.fire(new t.Event("pitchstart",i)).fire(new t.Event("pitch",i)).fire(new t.Event("pitchend",i)),this.fire(new t.Event("moveend",i))},i.prototype.easeTo=function(e,i){var o=this;this.stop(),(!1===(e=t.extend({offset:[0,0],duration:500,easing:t.ease},e)).animate||!e.essential&&t.browser.prefersReducedMotion)&&(e.duration=0);var r=this.transform,a=this.getZoom(),n=this.getBearing(),s=this.getPitch(),l="zoom"in e?+e.zoom:a,c="bearing"in e?this._normalizeBearing(e.bearing,n):n,u="pitch"in e?+e.pitch:s,h=r.centerPoint.add(t.Point.convert(e.offset)),p=r.pointLocation(h),d=t.LngLat.convert(e.center||p);this._normalizeCenter(d);var _,f,m=r.project(p),g=r.project(d).sub(m),v=r.zoomScale(l-a);return e.around&&(_=t.LngLat.convert(e.around),f=r.locationPoint(_)),this._zooming=l!==a,this._rotating=n!==c,this._pitching=u!==s,this._prepareEase(i,e.noMoveStart),clearTimeout(this._easeEndTimeoutID),this._ease((function(e){if(o._zooming&&(r.zoom=t.number(a,l,e)),o._rotating&&(r.bearing=t.number(n,c,e)),o._pitching&&(r.pitch=t.number(s,u,e)),_)r.setLocationAtPoint(_,f);else{var p=r.zoomScale(r.zoom-a),d=l>a?Math.min(2,v):Math.max(.5,v),y=Math.pow(d,1-e),x=r.unproject(m.add(g.mult(e*y)).mult(p));r.setLocationAtPoint(r.renderWorldCopies?x.wrap():x,h);}o._fireMoveEvents(i);}),(function(){e.delayEndEvents?o._easeEndTimeoutID=setTimeout((function(){return o._afterEase(i)}),e.delayEndEvents):o._afterEase(i);}),e),this},i.prototype._prepareEase=function(e,i){this._moving=!0,i||this.fire(new t.Event("movestart",e)),this._zooming&&this.fire(new t.Event("zoomstart",e)),this._rotating&&this.fire(new t.Event("rotatestart",e)),this._pitching&&this.fire(new t.Event("pitchstart",e));},i.prototype._fireMoveEvents=function(e){this.fire(new t.Event("move",e)),this._zooming&&this.fire(new t.Event("zoom",e)),this._rotating&&this.fire(new t.Event("rotate",e)),this._pitching&&this.fire(new t.Event("pitch",e));},i.prototype._afterEase=function(e){var i=this._zooming,o=this._rotating,r=this._pitching;this._moving=!1,this._zooming=!1,this._rotating=!1,this._pitching=!1,i&&this.fire(new t.Event("zoomend",e)),o&&this.fire(new t.Event("rotateend",e)),r&&this.fire(new t.Event("pitchend",e)),this.fire(new t.Event("moveend",e));},i.prototype.flyTo=function(e,i){var o=this;if(!e.essential&&t.browser.prefersReducedMotion){var r=t.pick(e,["center","zoom","bearing","pitch","around"]);return this.jumpTo(r,i)}this.stop(),e=t.extend({offset:[0,0],speed:1.2,curve:1.42,easing:t.ease},e);var a=this.transform,n=this.getZoom(),s=this.getBearing(),l=this.getPitch(),c="zoom"in e?t.clamp(+e.zoom,a.minZoom,a.maxZoom):n,u="bearing"in e?this._normalizeBearing(e.bearing,s):s,h="pitch"in e?+e.pitch:l,p=a.zoomScale(c-n),d=a.centerPoint.add(t.Point.convert(e.offset)),_=a.pointLocation(d),f=t.LngLat.convert(e.center||_);this._normalizeCenter(f);var m=a.project(_),g=a.project(f).sub(m),v=e.curve,y=Math.max(a.width,a.height),x=y/p,b=g.mag();if("minZoom"in e){var w=t.clamp(Math.min(e.minZoom,n,c),a.minZoom,a.maxZoom),E=y/a.zoomScale(w-n);v=Math.sqrt(E/b*2);}var T=v*v;function I(t){var e=(x*x-y*y+(t?-1:1)*T*T*b*b)/(2*(t?x:y)*T*b);return Math.log(Math.sqrt(e*e+1)-e)}function S(t){return (Math.exp(t)-Math.exp(-t))/2}function C(t){return (Math.exp(t)+Math.exp(-t))/2}var P=I(0),z=function(t){return C(P)/C(P+v*t)},L=function(t){return y*((C(P)*(S(e=P+v*t)/C(e))-S(P))/T)/b;var e;},M=(I(1)-P)/v;if(Math.abs(b)<1e-6||!isFinite(M)){if(Math.abs(y-x)<1e-6)return this.easeTo(e,i);var D=x<y?-1:1;M=Math.abs(Math.log(x/y))/v,L=function(){return 0},z=function(t){return Math.exp(D*v*t)};}if("duration"in e)e.duration=+e.duration;else{var A="screenSpeed"in e?+e.screenSpeed/v:+e.speed;e.duration=1e3*M/A;}return e.maxDuration&&e.duration>e.maxDuration&&(e.duration=0),this._zooming=!0,this._rotating=s!==u,this._pitching=h!==l,this._prepareEase(i,!1),this._ease((function(e){var r=e*M,p=1/z(r);a.zoom=1===e?c:n+a.scaleZoom(p),o._rotating&&(a.bearing=t.number(s,u,e)),o._pitching&&(a.pitch=t.number(l,h,e));var _=1===e?f:a.unproject(m.add(g.mult(L(r))).mult(p));a.setLocationAtPoint(a.renderWorldCopies?_.wrap():_,d),o._fireMoveEvents(i);}),(function(){return o._afterEase(i)}),e),this},i.prototype.isEasing=function(){return !!this._easeFrameId},i.prototype.stop=function(){if(this._easeFrameId&&(this._cancelRenderFrame(this._easeFrameId),delete this._easeFrameId,delete this._onEaseFrame),this._onEaseEnd){var t=this._onEaseEnd;delete this._onEaseEnd,t.call(this);}return this},i.prototype._ease=function(e,i,o){!1===o.animate||0===o.duration?(e(1),i()):(this._easeStart=t.browser.now(),this._easeOptions=o,this._onEaseFrame=e,this._onEaseEnd=i,this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback));},i.prototype._renderFrameCallback=function(){var e=Math.min((t.browser.now()-this._easeStart)/this._easeOptions.duration,1);this._onEaseFrame(this._easeOptions.easing(e)),e<1?this._easeFrameId=this._requestRenderFrame(this._renderFrameCallback):this.stop();},i.prototype._normalizeBearing=function(e,i){e=t.wrap(e,-180,180);var o=Math.abs(e-i);return Math.abs(e-360-i)<o&&(e-=360),Math.abs(e+360-i)<o&&(e+=360),e},i.prototype._normalizeCenter=function(t){var e=this.transform;if(e.renderWorldCopies&&!e.lngRange){var i=t.lng-e.center.lng;t.lng+=i>180?-360:i<-180?360:0;}},i}(t.Evented),ko=function(e){void 0===e&&(e={}),this.options=e,t.bindAll(["_updateEditLink","_updateData","_updateCompact"],this);};ko.prototype.getDefaultPosition=function(){return "bottom-right"},ko.prototype.onAdd=function(t){var e=this.options&&this.options.compact;return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-attrib"),this._innerContainer=i.create("div","mapboxgl-ctrl-attrib-inner",this._container),e&&this._container.classList.add("mapboxgl-compact"),this._updateAttributions(),this._updateEditLink(),this._map.on("styledata",this._updateData),this._map.on("sourcedata",this._updateData),this._map.on("moveend",this._updateEditLink),void 0===e&&(this._map.on("resize",this._updateCompact),this._updateCompact()),this._container},ko.prototype.onRemove=function(){i.remove(this._container),this._map.off("styledata",this._updateData),this._map.off("sourcedata",this._updateData),this._map.off("moveend",this._updateEditLink),this._map.off("resize",this._updateCompact),this._map=void 0,this._attribHTML=void 0;},ko.prototype._updateEditLink=function(){var e=this._editLink;e||(e=this._editLink=this._container.querySelector(".mapbox-improve-map"));var i=[{key:"owner",value:this.styleOwner},{key:"id",value:this.styleId},{key:"access_token",value:this._map._requestManager._customAccessToken||t.config.ACCESS_TOKEN}];if(e){var o=i.reduce((function(t,e,o){return e.value&&(t+=e.key+"="+e.value+(o<i.length-1?"&":"")),t}),"?");e.href=t.config.FEEDBACK_URL+"/"+o+(this._map._hash?this._map._hash.getHashString(!0):""),e.rel="noopener nofollow";}},ko.prototype._updateData=function(t){!t||"metadata"!==t.sourceDataType&&"style"!==t.dataType||(this._updateAttributions(),this._updateEditLink());},ko.prototype._updateAttributions=function(){if(this._map.style){var t=[];if(this.options.customAttribution&&(Array.isArray(this.options.customAttribution)?t=t.concat(this.options.customAttribution.map((function(t){return "string"!=typeof t?"":t}))):"string"==typeof this.options.customAttribution&&t.push(this.options.customAttribution)),this._map.style.stylesheet){var e=this._map.style.stylesheet;this.styleOwner=e.owner,this.styleId=e.id;}var i=this._map.style.sourceCaches;for(var o in i){var r=i[o];if(r.used){var a=r.getSource();a.attribution&&t.indexOf(a.attribution)<0&&t.push(a.attribution);}}t.sort((function(t,e){return t.length-e.length}));var n=(t=t.filter((function(e,i){for(var o=i+1;o<t.length;o++)if(t[o].indexOf(e)>=0)return !1;return !0}))).join(" | ");n!==this._attribHTML&&(this._attribHTML=n,t.length?(this._innerContainer.innerHTML=n,this._container.classList.remove("mapboxgl-attrib-empty")):this._container.classList.add("mapboxgl-attrib-empty"),this._editLink=null);}},ko.prototype._updateCompact=function(){this._map.getCanvasContainer().offsetWidth<=640?this._container.classList.add("mapboxgl-compact"):this._container.classList.remove("mapboxgl-compact");};var Bo=function(){t.bindAll(["_updateLogo"],this),t.bindAll(["_updateCompact"],this);};Bo.prototype.onAdd=function(t){this._map=t,this._container=i.create("div","mapboxgl-ctrl");var e=i.create("a","mapboxgl-ctrl-logo");return e.target="_blank",e.rel="noopener nofollow",e.href="https://www.mapbox.com/",e.setAttribute("aria-label",this._map._getUIString("LogoControl.Title")),e.setAttribute("rel","noopener nofollow"),this._container.appendChild(e),this._container.style.display="none",this._map.on("sourcedata",this._updateLogo),this._updateLogo(),this._map.on("resize",this._updateCompact),this._updateCompact(),this._container},Bo.prototype.onRemove=function(){i.remove(this._container),this._map.off("sourcedata",this._updateLogo),this._map.off("resize",this._updateCompact);},Bo.prototype.getDefaultPosition=function(){return "bottom-left"},Bo.prototype._updateLogo=function(t){t&&"metadata"!==t.sourceDataType||(this._container.style.display=this._logoRequired()?"block":"none");},Bo.prototype._logoRequired=function(){if(this._map.style){var t=this._map.style.sourceCaches;for(var e in t){if(t[e].getSource().mapbox_logo)return !0}return !1}},Bo.prototype._updateCompact=function(){var t=this._container.children;if(t.length){var e=t[0];this._map.getCanvasContainer().offsetWidth<250?e.classList.add("mapboxgl-compact"):e.classList.remove("mapboxgl-compact");}};var Oo=function(){this._queue=[],this._id=0,this._cleared=!1,this._currentlyRunning=!1;};Oo.prototype.add=function(t){var e=++this._id;return this._queue.push({callback:t,id:e,cancelled:!1}),e},Oo.prototype.remove=function(t){for(var e=this._currentlyRunning,i=0,o=e?this._queue.concat(e):this._queue;i<o.length;i+=1){var r=o[i];if(r.id===t)return void(r.cancelled=!0)}},Oo.prototype.run=function(){var t=this._currentlyRunning=this._queue;this._queue=[];for(var e=0,i=t;e<i.length;e+=1){var o=i[e];if(!o.cancelled&&(o.callback(),this._cleared))break}this._cleared=!1,this._currentlyRunning=!1;},Oo.prototype.clear=function(){this._currentlyRunning&&(this._cleared=!0),this._queue=[];};var Fo={"FullscreenControl.Enter":"Enter fullscreen","FullscreenControl.Exit":"Exit fullscreen","GeolocateControl.FindMyLocation":"Find my location","GeolocateControl.LocationNotAvailable":"Location not available","LogoControl.Title":"Mapbox logo","NavigationControl.ResetBearing":"Reset bearing to north","NavigationControl.ZoomIn":"Zoom in","NavigationControl.ZoomOut":"Zoom out","ScaleControl.Feet":"ft","ScaleControl.Meters":"m","ScaleControl.Kilometers":"km","ScaleControl.Miles":"mi","ScaleControl.NauticalMiles":"nm"},Uo=t.window.HTMLImageElement,No=t.window.HTMLElement,Zo=t.window.ImageBitmap,qo=0,jo=60,Vo={center:[0,0],zoom:0,bearing:0,pitch:0,minZoom:-2,maxZoom:22,minPitch:qo,maxPitch:jo,interactive:!0,scrollZoom:!0,boxZoom:!0,dragRotate:!0,dragPan:!0,keyboard:!0,doubleClickZoom:!0,touchZoomRotate:!0,bearingSnap:7,clickTolerance:3,hash:!1,attributionControl:!0,failIfMajorPerformanceCaveat:!1,preserveDrawingBuffer:!1,trackResize:!0,renderWorldCopies:!0,refreshExpiredTiles:!0,maxTileCacheSize:null,localIdeographFontFamily:"sans-serif",transformRequest:null,accessToken:null,fadeDuration:300,crossSourceCollisions:!0},Go=function(o){function r(e){var r=this;if(null!=(e=t.extend({},Vo,e)).minZoom&&null!=e.maxZoom&&e.minZoom>e.maxZoom)throw new Error("maxZoom must be greater than or equal to minZoom");if(null!=e.minPitch&&null!=e.maxPitch&&e.minPitch>e.maxPitch)throw new Error("maxPitch must be greater than or equal to minPitch");if(null!=e.minPitch&&e.minPitch<qo)throw new Error("minPitch must be greater than or equal to "+qo);if(null!=e.maxPitch&&e.maxPitch>jo)throw new Error("maxPitch must be less than or equal to "+jo);var a=new mo(e.minZoom,e.maxZoom,e.minPitch,e.maxPitch,e.renderWorldCopies);if(o.call(this,a,e),this._interactive=e.interactive,this._maxTileCacheSize=e.maxTileCacheSize,this._failIfMajorPerformanceCaveat=e.failIfMajorPerformanceCaveat,this._preserveDrawingBuffer=e.preserveDrawingBuffer,this._antialias=e.antialias,this._trackResize=e.trackResize,this._bearingSnap=e.bearingSnap,this._refreshExpiredTiles=e.refreshExpiredTiles,this._fadeDuration=e.fadeDuration,this._crossSourceCollisions=e.crossSourceCollisions,this._crossFadingFactor=1,this._collectResourceTiming=e.collectResourceTiming,this._renderTaskQueue=new Oo,this._controls=[],this._mapId=t.uniqueId(),this._locale=t.extend({},Fo,e.locale),this._requestManager=new t.RequestManager(e.transformRequest,e.accessToken),"string"==typeof e.container){if(this._container=t.window.document.getElementById(e.container),!this._container)throw new Error("Container '"+e.container+"' not found.")}else{if(!(e.container instanceof No))throw new Error("Invalid type: 'container' must be a String or HTMLElement.");this._container=e.container;}if(e.maxBounds&&this.setMaxBounds(e.maxBounds),t.bindAll(["_onWindowOnline","_onWindowResize","_contextLost","_contextRestored"],this),this._setupContainer(),this._setupPainter(),void 0===this.painter)throw new Error("Failed to initialize WebGL.");this.on("move",(function(){return r._update(!1)})),this.on("moveend",(function(){return r._update(!1)})),this.on("zoom",(function(){return r._update(!0)})),void 0!==t.window&&(t.window.addEventListener("online",this._onWindowOnline,!1),t.window.addEventListener("resize",this._onWindowResize,!1)),function(t,e){var o=t.getCanvasContainer(),r=null,a=!1,n=null;for(var s in Ao)t[s]=new Ao[s](t,e),e.interactive&&e[s]&&t[s].enable(e[s]);i.addEventListener(o,"mouseout",(function(e){t.fire(new yo("mouseout",t,e));})),i.addEventListener(o,"mousedown",(function(r){a=!0,n=i.mousePos(o,r);var s=new yo("mousedown",t,r);if(t.fire(s),s.defaultPrevented)return;e.interactive&&!t.doubleClickZoom.isActive()&&t.stop();t.boxZoom.onMouseDown(r),t.boxZoom.isActive()||t.dragPan.isActive()||t.dragRotate.onMouseDown(r);t.boxZoom.isActive()||t.dragRotate.isActive()||t.dragPan.onMouseDown(r);})),i.addEventListener(o,"mouseup",(function(e){var i=t.dragRotate.isActive();r&&!i&&t.fire(new yo("contextmenu",t,r));r=null,a=!1,t.fire(new yo("mouseup",t,e));})),i.addEventListener(o,"mousemove",(function(e){if(t.dragPan.isActive())return;if(t.dragRotate.isActive())return;var i=e.target;for(;i&&i!==o;)i=i.parentNode;if(i!==o)return;t.fire(new yo("mousemove",t,e));})),i.addEventListener(o,"mouseover",(function(e){var i=e.target;for(;i&&i!==o;)i=i.parentNode;if(i!==o)return;t.fire(new yo("mouseover",t,e));})),i.addEventListener(o,"touchstart",(function(i){var o=new xo("touchstart",t,i);if(t.fire(o),o.defaultPrevented)return;e.interactive&&t.stop();t.boxZoom.isActive()||t.dragRotate.isActive()||t.dragPan.onTouchStart(i);t.touchZoomRotate.onStart(i),t.doubleClickZoom.onTouchStart(o);}),{passive:!1}),i.addEventListener(o,"touchmove",(function(e){t.fire(new xo("touchmove",t,e));}),{passive:!1}),i.addEventListener(o,"touchend",(function(e){t.fire(new xo("touchend",t,e));})),i.addEventListener(o,"touchcancel",(function(e){t.fire(new xo("touchcancel",t,e));})),i.addEventListener(o,"click",(function(r){var a=i.mousePos(o,r);(!n||a.equals(n)||a.dist(n)<e.clickTolerance)&&t.fire(new yo("click",t,r));})),i.addEventListener(o,"dblclick",(function(e){var i=new yo("dblclick",t,e);if(t.fire(i),i.defaultPrevented)return;t.doubleClickZoom.onDblClick(i);})),i.addEventListener(o,"contextmenu",(function(e){var i=t.dragRotate.isActive();a||i?a&&(r=e):t.fire(new yo("contextmenu",t,e));(t.dragRotate.isEnabled()||t.listens("contextmenu"))&&e.preventDefault();})),i.addEventListener(o,"wheel",(function(i){e.interactive&&t.stop();var o=new bo("wheel",t,i);if(t.fire(o),o.defaultPrevented)return;t.scrollZoom.onWheel(i);}),{passive:!1});}(this,e);var n="string"==typeof e.hash&&e.hash||void 0;this._hash=e.hash&&new vo(n).addTo(this),this._hash&&this._hash._onHashChange()||(this.jumpTo({center:e.center,zoom:e.zoom,bearing:e.bearing,pitch:e.pitch}),e.bounds&&(this.resize(),this.fitBounds(e.bounds,t.extend({},e.fitBoundsOptions,{duration:0})))),this.resize(),this._localIdeographFontFamily=e.localIdeographFontFamily,e.style&&this.setStyle(e.style,{localIdeographFontFamily:e.localIdeographFontFamily}),e.attributionControl&&this.addControl(new ko({customAttribution:e.customAttribution})),this.addControl(new Bo,e.logoPosition),this.on("style.load",(function(){r.transform.unmodified&&r.jumpTo(r.style.stylesheet);})),this.on("data",(function(e){r._update("style"===e.dataType),r.fire(new t.Event(e.dataType+"data",e));})),this.on("dataloading",(function(e){r.fire(new t.Event(e.dataType+"dataloading",e));}));}o&&(r.__proto__=o),r.prototype=Object.create(o&&o.prototype),r.prototype.constructor=r;var a={showTileBoundaries:{configurable:!0},showCollisionBoxes:{configurable:!0},showOverdrawInspector:{configurable:!0},repaint:{configurable:!0},vertices:{configurable:!0},version:{configurable:!0}};return r.prototype._getMapId=function(){return this._mapId},r.prototype.addControl=function(e,i){if(void 0===i&&e.getDefaultPosition&&(i=e.getDefaultPosition()),void 0===i&&(i="top-right"),!e||!e.onAdd)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.addControl(). Argument must be a control with onAdd and onRemove methods.")));var o=e.onAdd(this);this._controls.push(e);var r=this._controlPositions[i];return -1!==i.indexOf("bottom")?r.insertBefore(o,r.firstChild):r.appendChild(o),this},r.prototype.removeControl=function(e){if(!e||!e.onRemove)return this.fire(new t.ErrorEvent(new Error("Invalid argument to map.removeControl(). Argument must be a control with onAdd and onRemove methods.")));var i=this._controls.indexOf(e);return i>-1&&this._controls.splice(i,1),e.onRemove(this),this},r.prototype.resize=function(e){var i=this._containerDimensions(),o=i[0],r=i[1];return this._resizeCanvas(o,r),this.transform.resize(o,r),this.painter.resize(o,r),this.fire(new t.Event("movestart",e)).fire(new t.Event("move",e)).fire(new t.Event("resize",e)).fire(new t.Event("moveend",e)),this},r.prototype.getBounds=function(){return this.transform.getBounds()},r.prototype.getMaxBounds=function(){return this.transform.getMaxBounds()},r.prototype.setMaxBounds=function(e){return this.transform.setMaxBounds(t.LngLatBounds.convert(e)),this._update()},r.prototype.setMinZoom=function(t){if((t=null==t?-2:t)>=-2&&t<=this.transform.maxZoom)return this.transform.minZoom=t,this._update(),this.getZoom()<t&&this.setZoom(t),this;throw new Error("minZoom must be between -2 and the current maxZoom, inclusive")},r.prototype.getMinZoom=function(){return this.transform.minZoom},r.prototype.setMaxZoom=function(t){if((t=null==t?22:t)>=this.transform.minZoom)return this.transform.maxZoom=t,this._update(),this.getZoom()>t&&this.setZoom(t),this;throw new Error("maxZoom must be greater than the current minZoom")},r.prototype.getMaxZoom=function(){return this.transform.maxZoom},r.prototype.setMinPitch=function(t){if((t=null==t?qo:t)<qo)throw new Error("minPitch must be greater than or equal to "+qo);if(t>=qo&&t<=this.transform.maxPitch)return this.transform.minPitch=t,this._update(),this.getPitch()<t&&this.setPitch(t),this;throw new Error("minPitch must be between "+qo+" and the current maxPitch, inclusive")},r.prototype.getMinPitch=function(){return this.transform.minPitch},r.prototype.setMaxPitch=function(t){if((t=null==t?jo:t)>jo)throw new Error("maxPitch must be less than or equal to "+jo);if(t>=this.transform.minPitch)return this.transform.maxPitch=t,this._update(),this.getPitch()>t&&this.setPitch(t),this;throw new Error("maxPitch must be greater than the current minPitch")},r.prototype.getMaxPitch=function(){return this.transform.maxPitch},r.prototype.getRenderWorldCopies=function(){return this.transform.renderWorldCopies},r.prototype.setRenderWorldCopies=function(t){return this.transform.renderWorldCopies=t,this._update()},r.prototype.project=function(e){return this.transform.locationPoint(t.LngLat.convert(e))},r.prototype.unproject=function(e){return this.transform.pointLocation(t.Point.convert(e))},r.prototype.isMoving=function(){return this._moving||this.dragPan.isActive()||this.dragRotate.isActive()||this.scrollZoom.isActive()},r.prototype.isZooming=function(){return this._zooming||this.scrollZoom.isZooming()},r.prototype.isRotating=function(){return this._rotating||this.dragRotate.isActive()},r.prototype._createDelegatedListener=function(t,e,i){var o,r=this;if("mouseenter"===t||"mouseover"===t){var a=!1;return {layer:e,listener:i,delegates:{mousemove:function(o){var n=r.getLayer(e)?r.queryRenderedFeatures(o.point,{layers:[e]}):[];n.length?a||(a=!0,i.call(r,new yo(t,r,o.originalEvent,{features:n}))):a=!1;},mouseout:function(){a=!1;}}}}if("mouseleave"===t||"mouseout"===t){var n=!1;return {layer:e,listener:i,delegates:{mousemove:function(o){(r.getLayer(e)?r.queryRenderedFeatures(o.point,{layers:[e]}):[]).length?n=!0:n&&(n=!1,i.call(r,new yo(t,r,o.originalEvent)));},mouseout:function(e){n&&(n=!1,i.call(r,new yo(t,r,e.originalEvent)));}}}}return {layer:e,listener:i,delegates:(o={},o[t]=function(t){var o=r.getLayer(e)?r.queryRenderedFeatures(t.point,{layers:[e]}):[];o.length&&(t.features=o,i.call(r,t),delete t.features);},o)}},r.prototype.on=function(t,e,i){if(void 0===i)return o.prototype.on.call(this,t,e);var r=this._createDelegatedListener(t,e,i);for(var a in this._delegatedListeners=this._delegatedListeners||{},this._delegatedListeners[t]=this._delegatedListeners[t]||[],this._delegatedListeners[t].push(r),r.delegates)this.on(a,r.delegates[a]);return this},r.prototype.once=function(t,e,i){if(void 0===i)return o.prototype.once.call(this,t,e);var r=this._createDelegatedListener(t,e,i);for(var a in r.delegates)this.once(a,r.delegates[a]);return this},r.prototype.off=function(t,e,i){var r=this;if(void 0===i)return o.prototype.off.call(this,t,e);return this._delegatedListeners&&this._delegatedListeners[t]&&function(o){for(var a=o[t],n=0;n<a.length;n++){var s=a[n];if(s.layer===e&&s.listener===i){for(var l in s.delegates)r.off(l,s.delegates[l]);return a.splice(n,1),r}}}(this._delegatedListeners),this},r.prototype.queryRenderedFeatures=function(e,i){if(!this.style)return [];var o;if(void 0!==i||void 0===e||e instanceof t.Point||Array.isArray(e)||(i=e,e=void 0),i=i||{},(e=e||[[0,0],[this.transform.width,this.transform.height]])instanceof t.Point||"number"==typeof e[0])o=[t.Point.convert(e)];else{var r=t.Point.convert(e[0]),a=t.Point.convert(e[1]);o=[r,new t.Point(a.x,r.y),a,new t.Point(r.x,a.y),r];}return this.style.queryRenderedFeatures(o,i,this.transform)},r.prototype.querySourceFeatures=function(t,e){return this.style.querySourceFeatures(t,e)},r.prototype.setStyle=function(e,i){return !1!==(i=t.extend({},{localIdeographFontFamily:this._localIdeographFontFamily},i)).diff&&i.localIdeographFontFamily===this._localIdeographFontFamily&&this.style&&e?(this._diffStyle(e,i),this):(this._localIdeographFontFamily=i.localIdeographFontFamily,this._updateStyle(e,i))},r.prototype._getUIString=function(t){var e=this._locale[t];if(null==e)throw new Error("Missing UI string '"+t+"'");return e},r.prototype._updateStyle=function(t,e){return this.style&&(this.style.setEventedParent(null),this.style._remove()),t?(this.style=new Ze(this,e||{}),this.style.setEventedParent(this,{style:this.style}),"string"==typeof t?this.style.loadURL(t):this.style.loadJSON(t),this):(delete this.style,this)},r.prototype._lazyInitEmptyStyle=function(){this.style||(this.style=new Ze(this,{}),this.style.setEventedParent(this,{style:this.style}),this.style.loadEmpty());},r.prototype._diffStyle=function(e,i){var o=this;if("string"==typeof e){var r=this._requestManager.normalizeStyleURL(e),a=this._requestManager.transformRequest(r,t.ResourceType.Style);t.getJSON(a,(function(e,r){e?o.fire(new t.ErrorEvent(e)):r&&o._updateDiff(r,i);}));}else"object"==typeof e&&this._updateDiff(e,i);},r.prototype._updateDiff=function(e,i){try{this.style.setState(e)&&this._update(!0);}catch(o){t.warnOnce("Unable to perform style diff: "+(o.message||o.error||o)+".  Rebuilding the style from scratch."),this._updateStyle(e,i);}},r.prototype.getStyle=function(){if(this.style)return this.style.serialize()},r.prototype.isStyleLoaded=function(){return this.style?this.style.loaded():t.warnOnce("There is no style added to the map.")},r.prototype.addSource=function(t,e){return this._lazyInitEmptyStyle(),this.style.addSource(t,e),this._update(!0)},r.prototype.isSourceLoaded=function(e){var i=this.style&&this.style.sourceCaches[e];if(void 0!==i)return i.loaded();this.fire(new t.ErrorEvent(new Error("There is no source with ID '"+e+"'")));},r.prototype.areTilesLoaded=function(){var t=this.style&&this.style.sourceCaches;for(var e in t){var i=t[e]._tiles;for(var o in i){var r=i[o];if("loaded"!==r.state&&"errored"!==r.state)return !1}}return !0},r.prototype.addSourceType=function(t,e,i){return this._lazyInitEmptyStyle(),this.style.addSourceType(t,e,i)},r.prototype.removeSource=function(t){return this.style.removeSource(t),this._update(!0)},r.prototype.getSource=function(t){return this.style.getSource(t)},r.prototype.addImage=function(e,i,o){void 0===o&&(o={});var r=o.pixelRatio;void 0===r&&(r=1);var a=o.sdf;void 0===a&&(a=!1);var n=o.stretchX,s=o.stretchY,l=o.content;this._lazyInitEmptyStyle();if(i instanceof Uo||Zo&&i instanceof Zo){var c=t.browser.getImageData(i),u=c.width,h=c.height,p=c.data;this.style.addImage(e,{data:new t.RGBAImage({width:u,height:h},p),pixelRatio:r,stretchX:n,stretchY:s,content:l,sdf:a,version:0});}else{if(void 0===i.width||void 0===i.height)return this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.addImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));var d=i.width,_=i.height,f=i.data,m=i;this.style.addImage(e,{data:new t.RGBAImage({width:d,height:_},new Uint8Array(f)),pixelRatio:r,stretchX:n,stretchY:s,content:l,sdf:a,version:0,userImage:m}),m.onAdd&&m.onAdd(this,e);}},r.prototype.updateImage=function(e,i){var o=this.style.getImage(e);if(!o)return this.fire(new t.ErrorEvent(new Error("The map has no image with that id. If you are adding a new image use `map.addImage(...)` instead.")));var r=i instanceof Uo||Zo&&i instanceof Zo?t.browser.getImageData(i):i,a=r.width,n=r.height,s=r.data;if(void 0===a||void 0===n)return this.fire(new t.ErrorEvent(new Error("Invalid arguments to map.updateImage(). The second argument must be an `HTMLImageElement`, `ImageData`, `ImageBitmap`, or object with `width`, `height`, and `data` properties with the same format as `ImageData`")));if(a!==o.data.width||n!==o.data.height)return this.fire(new t.ErrorEvent(new Error("The width and height of the updated image must be that same as the previous version of the image")));var l=!(i instanceof Uo||Zo&&i instanceof Zo);o.data.replace(s,l),this.style.updateImage(e,o);},r.prototype.hasImage=function(e){return e?!!this.style.getImage(e):(this.fire(new t.ErrorEvent(new Error("Missing required image id"))),!1)},r.prototype.removeImage=function(t){this.style.removeImage(t);},r.prototype.loadImage=function(e,i){t.getImage(this._requestManager.transformRequest(e,t.ResourceType.Image),i);},r.prototype.listImages=function(){return this.style.listImages()},r.prototype.addLayer=function(t,e){return this._lazyInitEmptyStyle(),this.style.addLayer(t,e),this._update(!0)},r.prototype.moveLayer=function(t,e){return this.style.moveLayer(t,e),this._update(!0)},r.prototype.removeLayer=function(t){return this.style.removeLayer(t),this._update(!0)},r.prototype.getLayer=function(t){return this.style.getLayer(t)},r.prototype.setLayerZoomRange=function(t,e,i){return this.style.setLayerZoomRange(t,e,i),this._update(!0)},r.prototype.setFilter=function(t,e,i){return void 0===i&&(i={}),this.style.setFilter(t,e,i),this._update(!0)},r.prototype.getFilter=function(t){return this.style.getFilter(t)},r.prototype.setPaintProperty=function(t,e,i,o){return void 0===o&&(o={}),this.style.setPaintProperty(t,e,i,o),this._update(!0)},r.prototype.getPaintProperty=function(t,e){return this.style.getPaintProperty(t,e)},r.prototype.setLayoutProperty=function(t,e,i,o){return void 0===o&&(o={}),this.style.setLayoutProperty(t,e,i,o),this._update(!0)},r.prototype.getLayoutProperty=function(t,e){return this.style.getLayoutProperty(t,e)},r.prototype.setLight=function(t,e){return void 0===e&&(e={}),this._lazyInitEmptyStyle(),this.style.setLight(t,e),this._update(!0)},r.prototype.getLight=function(){return this.style.getLight()},r.prototype.setFeatureState=function(t,e){return this.style.setFeatureState(t,e),this._update()},r.prototype.removeFeatureState=function(t,e){return this.style.removeFeatureState(t,e),this._update()},r.prototype.getFeatureState=function(t){return this.style.getFeatureState(t)},r.prototype.getContainer=function(){return this._container},r.prototype.getCanvasContainer=function(){return this._canvasContainer},r.prototype.getCanvas=function(){return this._canvas},r.prototype._containerDimensions=function(){var t=0,e=0;return this._container&&(t=this._container.clientWidth||400,e=this._container.clientHeight||300),[t,e]},r.prototype._detectMissingCSS=function(){"rgb(250, 128, 114)"!==t.window.getComputedStyle(this._missingCSSCanary).getPropertyValue("background-color")&&t.warnOnce("This page appears to be missing CSS declarations for Mapbox GL JS, which may cause the map to display incorrectly. Please ensure your page includes mapbox-gl.css, as described in https://www.mapbox.com/mapbox-gl-js/api/.");},r.prototype._setupContainer=function(){var t=this._container;t.classList.add("mapboxgl-map"),(this._missingCSSCanary=i.create("div","mapboxgl-canary",t)).style.visibility="hidden",this._detectMissingCSS();var e=this._canvasContainer=i.create("div","mapboxgl-canvas-container",t);this._interactive&&e.classList.add("mapboxgl-interactive"),this._canvas=i.create("canvas","mapboxgl-canvas",e),this._canvas.style.position="absolute",this._canvas.addEventListener("webglcontextlost",this._contextLost,!1),this._canvas.addEventListener("webglcontextrestored",this._contextRestored,!1),this._canvas.setAttribute("tabindex","0"),this._canvas.setAttribute("aria-label","Map");var o=this._containerDimensions();this._resizeCanvas(o[0],o[1]);var r=this._controlContainer=i.create("div","mapboxgl-control-container",t),a=this._controlPositions={};["top-left","top-right","bottom-left","bottom-right"].forEach((function(t){a[t]=i.create("div","mapboxgl-ctrl-"+t,r);}));},r.prototype._resizeCanvas=function(e,i){var o=t.browser.devicePixelRatio||1;this._canvas.width=o*e,this._canvas.height=o*i,this._canvas.style.width=e+"px",this._canvas.style.height=i+"px";},r.prototype._setupPainter=function(){var i=t.extend({},e.webGLContextAttributes,{failIfMajorPerformanceCaveat:this._failIfMajorPerformanceCaveat,preserveDrawingBuffer:this._preserveDrawingBuffer,antialias:this._antialias||!1}),o=this._canvas.getContext("webgl",i)||this._canvas.getContext("experimental-webgl",i);o?(this.painter=new po(o,this.transform),t.webpSupported.testSupport(o)):this.fire(new t.ErrorEvent(new Error("Failed to initialize WebGL")));},r.prototype._contextLost=function(e){e.preventDefault(),this._frame&&(this._frame.cancel(),this._frame=null),this.fire(new t.Event("webglcontextlost",{originalEvent:e}));},r.prototype._contextRestored=function(e){this._setupPainter(),this.resize(),this._update(),this.fire(new t.Event("webglcontextrestored",{originalEvent:e}));},r.prototype.loaded=function(){return !this._styleDirty&&!this._sourcesDirty&&!!this.style&&this.style.loaded()},r.prototype._update=function(t){return this.style?(this._styleDirty=this._styleDirty||t,this._sourcesDirty=!0,this.triggerRepaint(),this):this},r.prototype._requestRenderFrame=function(t){return this._update(),this._renderTaskQueue.add(t)},r.prototype._cancelRenderFrame=function(t){this._renderTaskQueue.remove(t);},r.prototype._render=function(){var e,i=this,o=0,r=this.painter.context.extTimerQuery;this.listens("gpu-timing-frame")&&(e=r.createQueryEXT(),r.beginQueryEXT(r.TIME_ELAPSED_EXT,e),o=t.browser.now()),this.painter.context.setDirty(),this.painter.setBaseState(),this._renderTaskQueue.run();var a=!1;if(this.style&&this._styleDirty){this._styleDirty=!1;var n=this.transform.zoom,s=t.browser.now();this.style.zoomHistory.update(n,s);var l=new t.EvaluationParameters(n,{now:s,fadeDuration:this._fadeDuration,zoomHistory:this.style.zoomHistory,transition:this.style.getTransition()}),c=l.crossFadingFactor();1===c&&c===this._crossFadingFactor||(a=!0,this._crossFadingFactor=c),this.style.update(l);}if(this.style&&this._sourcesDirty&&(this._sourcesDirty=!1,this.style._updateSources(this.transform)),this._placementDirty=this.style&&this.style._updatePlacement(this.painter.transform,this.showCollisionBoxes,this._fadeDuration,this._crossSourceCollisions),this.painter.render(this.style,{showTileBoundaries:this.showTileBoundaries,showOverdrawInspector:this._showOverdrawInspector,rotating:this.isRotating(),zooming:this.isZooming(),moving:this.isMoving(),gpuTiming:!!this.listens("gpu-timing-layer"),fadeDuration:this._fadeDuration}),this.fire(new t.Event("render")),this.loaded()&&!this._loaded&&(this._loaded=!0,this.fire(new t.Event("load"))),this.style&&(this.style.hasTransitions()||a)&&(this._styleDirty=!0),this.style&&!this._placementDirty&&this.style._releaseSymbolFadeTiles(),this.listens("gpu-timing-frame")){var u=t.browser.now()-o;r.endQueryEXT(r.TIME_ELAPSED_EXT,e),setTimeout((function(){var o=r.getQueryObjectEXT(e,r.QUERY_RESULT_EXT)/1e6;r.deleteQueryEXT(e),i.fire(new t.Event("gpu-timing-frame",{cpuTime:u,gpuTime:o}));}),50);}if(this.listens("gpu-timing-layer")){var h=this.painter.collectGpuTimers();setTimeout((function(){var e=i.painter.queryGpuTimers(h);i.fire(new t.Event("gpu-timing-layer",{layerTimes:e}));}),50);}return this._sourcesDirty||this._styleDirty||this._placementDirty||this._repaint?this.triggerRepaint():!this.isMoving()&&this.loaded()&&(this._fullyLoaded||(this._fullyLoaded=!0),this.fire(new t.Event("idle"))),this},r.prototype.remove=function(){this._hash&&this._hash.remove();for(var e=0,i=this._controls;e<i.length;e+=1){i[e].onRemove(this);}this._controls=[],this._frame&&(this._frame.cancel(),this._frame=null),this._renderTaskQueue.clear(),this.setStyle(null),void 0!==t.window&&(t.window.removeEventListener("resize",this._onWindowResize,!1),t.window.removeEventListener("online",this._onWindowOnline,!1));var o=this.painter.context.gl.getExtension("WEBGL_lose_context");o&&o.loseContext(),Wo(this._canvasContainer),Wo(this._controlContainer),Wo(this._missingCSSCanary),this._container.classList.remove("mapboxgl-map"),this.fire(new t.Event("remove"));},r.prototype.triggerRepaint=function(){var e=this;this.style&&!this._frame&&(this._frame=t.browser.frame((function(t){e._frame=null,e._render();})));},r.prototype._onWindowOnline=function(){this._update();},r.prototype._onWindowResize=function(t){this._trackResize&&this.resize({originalEvent:t})._update();},a.showTileBoundaries.get=function(){return !!this._showTileBoundaries},a.showTileBoundaries.set=function(t){this._showTileBoundaries!==t&&(this._showTileBoundaries=t,this._update());},a.showCollisionBoxes.get=function(){return !!this._showCollisionBoxes},a.showCollisionBoxes.set=function(t){this._showCollisionBoxes!==t&&(this._showCollisionBoxes=t,t?this.style._generateCollisionBoxes():this._update());},a.showOverdrawInspector.get=function(){return !!this._showOverdrawInspector},a.showOverdrawInspector.set=function(t){this._showOverdrawInspector!==t&&(this._showOverdrawInspector=t,this._update());},a.repaint.get=function(){return !!this._repaint},a.repaint.set=function(t){this._repaint!==t&&(this._repaint=t,this.triggerRepaint());},a.vertices.get=function(){return !!this._vertices},a.vertices.set=function(t){this._vertices=t,this._update();},r.prototype._setCacheLimits=function(e,i){t.setCacheLimits(e,i);},a.version.get=function(){return t.version},Object.defineProperties(r.prototype,a),r}(Ro);function Wo(t){t.parentNode&&t.parentNode.removeChild(t);}var Xo={showCompass:!0,showZoom:!0,visualizePitch:!1},Ho=function(e){var o=this;this.options=t.extend({},Xo,e),this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._container.addEventListener("contextmenu",(function(t){return t.preventDefault()})),this.options.showZoom&&(t.bindAll(["_setButtonTitle","_updateZoomButtons"],this),this._zoomInButton=this._createButton("mapboxgl-ctrl-zoom-in",(function(t){return o._map.zoomIn({},{originalEvent:t})})),i.create("span","mapboxgl-ctrl-icon",this._zoomInButton).setAttribute("aria-hidden",!0),this._zoomOutButton=this._createButton("mapboxgl-ctrl-zoom-out",(function(t){return o._map.zoomOut({},{originalEvent:t})})),i.create("span","mapboxgl-ctrl-icon",this._zoomOutButton).setAttribute("aria-hidden",!0)),this.options.showCompass&&(t.bindAll(["_rotateCompassArrow"],this),this._compass=this._createButton("mapboxgl-ctrl-compass",(function(t){o.options.visualizePitch?o._map.resetNorthPitch({},{originalEvent:t}):o._map.resetNorth({},{originalEvent:t});})),this._compassIcon=i.create("span","mapboxgl-ctrl-icon",this._compass),this._compassIcon.setAttribute("aria-hidden",!0));};function Ko(e,i,o){if(e=new t.LngLat(e.lng,e.lat),i){var r=new t.LngLat(e.lng-360,e.lat),a=new t.LngLat(e.lng+360,e.lat),n=o.locationPoint(e).distSqr(i);o.locationPoint(r).distSqr(i)<n?e=r:o.locationPoint(a).distSqr(i)<n&&(e=a);}for(;Math.abs(e.lng-o.center.lng)>180;){var s=o.locationPoint(e);if(s.x>=0&&s.y>=0&&s.x<=o.width&&s.y<=o.height)break;e.lng>o.center.lng?e.lng-=360:e.lng+=360;}return e}Ho.prototype._updateZoomButtons=function(){var t=this._map.getZoom();this._zoomInButton.disabled=t===this._map.getMaxZoom(),this._zoomOutButton.disabled=t===this._map.getMinZoom();},Ho.prototype._rotateCompassArrow=function(){var t=this.options.visualizePitch?"scale("+1/Math.pow(Math.cos(this._map.transform.pitch*(Math.PI/180)),.5)+") rotateX("+this._map.transform.pitch+"deg) rotateZ("+this._map.transform.angle*(180/Math.PI)+"deg)":"rotate("+this._map.transform.angle*(180/Math.PI)+"deg)";this._compassIcon.style.transform=t;},Ho.prototype.onAdd=function(t){return this._map=t,this.options.showZoom&&(this._setButtonTitle(this._zoomInButton,"ZoomIn"),this._setButtonTitle(this._zoomOutButton,"ZoomOut"),this._map.on("zoom",this._updateZoomButtons),this._updateZoomButtons()),this.options.showCompass&&(this._setButtonTitle(this._compass,"ResetBearing"),this.options.visualizePitch&&this._map.on("pitch",this._rotateCompassArrow),this._map.on("rotate",this._rotateCompassArrow),this._rotateCompassArrow(),this._handler=new Io(t,{button:"left",element:this._compass,clickTolerance:t.dragRotate._clickTolerance}),i.addEventListener(this._compass,"mousedown",this._handler.onMouseDown),i.addEventListener(this._compass,"touchstart",this._handler.onMouseDown,{passive:!1}),this._handler.enable()),this._container},Ho.prototype.onRemove=function(){i.remove(this._container),this.options.showZoom&&this._map.off("zoom",this._updateZoomButtons),this.options.showCompass&&(this.options.visualizePitch&&this._map.off("pitch",this._rotateCompassArrow),this._map.off("rotate",this._rotateCompassArrow),i.removeEventListener(this._compass,"mousedown",this._handler.onMouseDown),i.removeEventListener(this._compass,"touchstart",this._handler.onMouseDown,{passive:!1}),this._handler.disable(),delete this._handler),delete this._map;},Ho.prototype._createButton=function(t,e){var o=i.create("button",t,this._container);return o.type="button",o.addEventListener("click",e),o},Ho.prototype._setButtonTitle=function(t,e){var i=this._map._getUIString("NavigationControl."+e);t.title=i,t.setAttribute("aria-label",i);};var Yo={center:"translate(-50%,-50%)",top:"translate(-50%,0)","top-left":"translate(0,0)","top-right":"translate(-100%,0)",bottom:"translate(-50%,-100%)","bottom-left":"translate(0,-100%)","bottom-right":"translate(-100%,-100%)",left:"translate(0,-50%)",right:"translate(-100%,-50%)"};function Jo(t,e,i){var o=t.classList;for(var r in Yo)o.remove("mapboxgl-"+i+"-anchor-"+r);o.add("mapboxgl-"+i+"-anchor-"+e);}var Qo,$o=function(e){function o(o,r){var a=this;if(e.call(this),(o instanceof t.window.HTMLElement||r)&&(o=t.extend({element:o},r)),t.bindAll(["_update","_onMove","_onUp","_addDragHandler","_onMapClick","_onKeyPress"],this),this._anchor=o&&o.anchor||"center",this._color=o&&o.color||"#3FB1CE",this._draggable=o&&o.draggable||!1,this._state="inactive",this._rotation=o&&o.rotation||0,this._rotationAlignment=o&&o.rotationAlignment||"auto",this._pitchAlignment=o&&o.pitchAlignment&&"auto"!==o.pitchAlignment?o.pitchAlignment:this._rotationAlignment,o&&o.element)this._element=o.element,this._offset=t.Point.convert(o&&o.offset||[0,0]);else{this._defaultMarker=!0,this._element=i.create("div"),this._element.setAttribute("aria-label","Map marker");var n=i.createNS("http://www.w3.org/2000/svg","svg");n.setAttributeNS(null,"display","block"),n.setAttributeNS(null,"height","41px"),n.setAttributeNS(null,"width","27px"),n.setAttributeNS(null,"viewBox","0 0 27 41");var s=i.createNS("http://www.w3.org/2000/svg","g");s.setAttributeNS(null,"stroke","none"),s.setAttributeNS(null,"stroke-width","1"),s.setAttributeNS(null,"fill","none"),s.setAttributeNS(null,"fill-rule","evenodd");var l=i.createNS("http://www.w3.org/2000/svg","g");l.setAttributeNS(null,"fill-rule","nonzero");var c=i.createNS("http://www.w3.org/2000/svg","g");c.setAttributeNS(null,"transform","translate(3.0, 29.0)"),c.setAttributeNS(null,"fill","#000000");for(var u=0,h=[{rx:"10.5",ry:"5.25002273"},{rx:"10.5",ry:"5.25002273"},{rx:"9.5",ry:"4.77275007"},{rx:"8.5",ry:"4.29549936"},{rx:"7.5",ry:"3.81822308"},{rx:"6.5",ry:"3.34094679"},{rx:"5.5",ry:"2.86367051"},{rx:"4.5",ry:"2.38636864"}];u<h.length;u+=1){var p=h[u],d=i.createNS("http://www.w3.org/2000/svg","ellipse");d.setAttributeNS(null,"opacity","0.04"),d.setAttributeNS(null,"cx","10.5"),d.setAttributeNS(null,"cy","5.80029008"),d.setAttributeNS(null,"rx",p.rx),d.setAttributeNS(null,"ry",p.ry),c.appendChild(d);}var _=i.createNS("http://www.w3.org/2000/svg","g");_.setAttributeNS(null,"fill",this._color);var f=i.createNS("http://www.w3.org/2000/svg","path");f.setAttributeNS(null,"d","M27,13.5 C27,19.074644 20.250001,27.000002 14.75,34.500002 C14.016665,35.500004 12.983335,35.500004 12.25,34.500002 C6.7499993,27.000002 0,19.222562 0,13.5 C0,6.0441559 6.0441559,0 13.5,0 C20.955844,0 27,6.0441559 27,13.5 Z"),_.appendChild(f);var m=i.createNS("http://www.w3.org/2000/svg","g");m.setAttributeNS(null,"opacity","0.25"),m.setAttributeNS(null,"fill","#000000");var g=i.createNS("http://www.w3.org/2000/svg","path");g.setAttributeNS(null,"d","M13.5,0 C6.0441559,0 0,6.0441559 0,13.5 C0,19.222562 6.7499993,27 12.25,34.5 C13,35.522727 14.016664,35.500004 14.75,34.5 C20.250001,27 27,19.074644 27,13.5 C27,6.0441559 20.955844,0 13.5,0 Z M13.5,1 C20.415404,1 26,6.584596 26,13.5 C26,15.898657 24.495584,19.181431 22.220703,22.738281 C19.945823,26.295132 16.705119,30.142167 13.943359,33.908203 C13.743445,34.180814 13.612715,34.322738 13.5,34.441406 C13.387285,34.322738 13.256555,34.180814 13.056641,33.908203 C10.284481,30.127985 7.4148684,26.314159 5.015625,22.773438 C2.6163816,19.232715 1,15.953538 1,13.5 C1,6.584596 6.584596,1 13.5,1 Z"),m.appendChild(g);var v=i.createNS("http://www.w3.org/2000/svg","g");v.setAttributeNS(null,"transform","translate(6.0, 7.0)"),v.setAttributeNS(null,"fill","#FFFFFF");var y=i.createNS("http://www.w3.org/2000/svg","g");y.setAttributeNS(null,"transform","translate(8.0, 8.0)");var x=i.createNS("http://www.w3.org/2000/svg","circle");x.setAttributeNS(null,"fill","#000000"),x.setAttributeNS(null,"opacity","0.25"),x.setAttributeNS(null,"cx","5.5"),x.setAttributeNS(null,"cy","5.5"),x.setAttributeNS(null,"r","5.4999962");var b=i.createNS("http://www.w3.org/2000/svg","circle");b.setAttributeNS(null,"fill","#FFFFFF"),b.setAttributeNS(null,"cx","5.5"),b.setAttributeNS(null,"cy","5.5"),b.setAttributeNS(null,"r","5.4999962"),y.appendChild(x),y.appendChild(b),l.appendChild(c),l.appendChild(_),l.appendChild(m),l.appendChild(v),l.appendChild(y),n.appendChild(l),this._element.appendChild(n),this._offset=t.Point.convert(o&&o.offset||[0,-14]);}this._element.classList.add("mapboxgl-marker"),this._element.addEventListener("dragstart",(function(t){t.preventDefault();})),this._element.addEventListener("mousedown",(function(t){t.preventDefault();})),this._element.addEventListener("focus",(function(){var t=a._map.getContainer();t.scrollTop=0,t.scrollLeft=0;})),Jo(this._element,this._anchor,"marker"),this._popup=null;}return e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o,o.prototype.addTo=function(t){return this.remove(),this._map=t,t.getCanvasContainer().appendChild(this._element),t.on("move",this._update),t.on("moveend",this._update),this.setDraggable(this._draggable),this._update(),this._map.on("click",this._onMapClick),this},o.prototype.remove=function(){return this._map&&(this._map.off("click",this._onMapClick),this._map.off("move",this._update),this._map.off("moveend",this._update),this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler),this._map.off("mouseup",this._onUp),this._map.off("touchend",this._onUp),this._map.off("mousemove",this._onMove),this._map.off("touchmove",this._onMove),delete this._map),i.remove(this._element),this._popup&&this._popup.remove(),this},o.prototype.getLngLat=function(){return this._lngLat},o.prototype.setLngLat=function(e){return this._lngLat=t.LngLat.convert(e),this._pos=null,this._popup&&this._popup.setLngLat(this._lngLat),this._update(),this},o.prototype.getElement=function(){return this._element},o.prototype.setPopup=function(t){if(this._popup&&(this._popup.remove(),this._popup=null,this._element.removeEventListener("keypress",this._onKeyPress),this._originalTabIndex||this._element.removeAttribute("tabindex")),t){if(!("offset"in t.options)){var e=Math.sqrt(Math.pow(13.5,2)/2);t.options.offset=this._defaultMarker?{top:[0,0],"top-left":[0,0],"top-right":[0,0],bottom:[0,-38.1],"bottom-left":[e,-1*(24.6+e)],"bottom-right":[-e,-1*(24.6+e)],left:[13.5,-24.6],right:[-13.5,-24.6]}:this._offset;}this._popup=t,this._lngLat&&this._popup.setLngLat(this._lngLat),this._originalTabIndex=this._element.getAttribute("tabindex"),this._originalTabIndex||this._element.setAttribute("tabindex","0"),this._element.addEventListener("keypress",this._onKeyPress);}return this},o.prototype._onKeyPress=function(t){var e=t.code,i=t.charCode||t.keyCode;"Space"!==e&&"Enter"!==e&&32!==i&&13!==i||this.togglePopup();},o.prototype._onMapClick=function(t){var e=t.originalEvent.target,i=this._element;this._popup&&(e===i||i.contains(e))&&this.togglePopup();},o.prototype.getPopup=function(){return this._popup},o.prototype.togglePopup=function(){var t=this._popup;return t?(t.isOpen()?t.remove():t.addTo(this._map),this):this},o.prototype._update=function(t){if(this._map){this._map.transform.renderWorldCopies&&(this._lngLat=Ko(this._lngLat,this._pos,this._map.transform)),this._pos=this._map.project(this._lngLat)._add(this._offset);var e="";"viewport"===this._rotationAlignment||"auto"===this._rotationAlignment?e="rotateZ("+this._rotation+"deg)":"map"===this._rotationAlignment&&(e="rotateZ("+(this._rotation-this._map.getBearing())+"deg)");var o="";"viewport"===this._pitchAlignment||"auto"===this._pitchAlignment?o="rotateX(0deg)":"map"===this._pitchAlignment&&(o="rotateX("+this._map.getPitch()+"deg)"),t&&"moveend"!==t.type||(this._pos=this._pos.round()),i.setTransform(this._element,Yo[this._anchor]+" translate("+this._pos.x+"px, "+this._pos.y+"px) "+o+" "+e);}},o.prototype.getOffset=function(){return this._offset},o.prototype.setOffset=function(e){return this._offset=t.Point.convert(e),this._update(),this},o.prototype._onMove=function(e){this._pos=e.point.sub(this._positionDelta),this._lngLat=this._map.unproject(this._pos),this.setLngLat(this._lngLat),this._element.style.pointerEvents="none","pending"===this._state&&(this._state="active",this.fire(new t.Event("dragstart"))),this.fire(new t.Event("drag"));},o.prototype._onUp=function(){this._element.style.pointerEvents="auto",this._positionDelta=null,this._map.off("mousemove",this._onMove),this._map.off("touchmove",this._onMove),"active"===this._state&&this.fire(new t.Event("dragend")),this._state="inactive";},o.prototype._addDragHandler=function(t){this._element.contains(t.originalEvent.target)&&(t.preventDefault(),this._positionDelta=t.point.sub(this._pos).add(this._offset),this._state="pending",this._map.on("mousemove",this._onMove),this._map.on("touchmove",this._onMove),this._map.once("mouseup",this._onUp),this._map.once("touchend",this._onUp));},o.prototype.setDraggable=function(t){return this._draggable=!!t,this._map&&(t?(this._map.on("mousedown",this._addDragHandler),this._map.on("touchstart",this._addDragHandler)):(this._map.off("mousedown",this._addDragHandler),this._map.off("touchstart",this._addDragHandler))),this},o.prototype.isDraggable=function(){return this._draggable},o.prototype.setRotation=function(t){return this._rotation=t||0,this._update(),this},o.prototype.getRotation=function(){return this._rotation},o.prototype.setRotationAlignment=function(t){return this._rotationAlignment=t||"auto",this._update(),this},o.prototype.getRotationAlignment=function(){return this._rotationAlignment},o.prototype.setPitchAlignment=function(t){return this._pitchAlignment=t&&"auto"!==t?t:this._rotationAlignment,this._update(),this},o.prototype.getPitchAlignment=function(){return this._pitchAlignment},o}(t.Evented),tr={positionOptions:{enableHighAccuracy:!1,maximumAge:0,timeout:6e3},fitBoundsOptions:{maxZoom:15},trackUserLocation:!1,showAccuracyCircle:!0,showUserLocation:!0};var er=0,ir=!1,or=function(e){function o(i){e.call(this),this.options=t.extend({},tr,i),t.bindAll(["_onSuccess","_onError","_onZoom","_finish","_setupUI","_updateCamera","_updateMarker"],this);}return e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o,o.prototype.onAdd=function(e){var o;return this._map=e,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),o=this._setupUI,void 0!==Qo?o(Qo):void 0!==t.window.navigator.permissions?t.window.navigator.permissions.query({name:"geolocation"}).then((function(t){Qo="denied"!==t.state,o(Qo);})):(Qo=!!t.window.navigator.geolocation,o(Qo)),this._container},o.prototype.onRemove=function(){void 0!==this._geolocationWatchID&&(t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0),this.options.showUserLocation&&this._userLocationDotMarker&&this._userLocationDotMarker.remove(),this.options.showAccuracyCircle&&this._accuracyCircleMarker&&this._accuracyCircleMarker.remove(),i.remove(this._container),this._map.off("zoom",this._onZoom),this._map=void 0,er=0,ir=!1;},o.prototype._isOutOfMapMaxBounds=function(t){var e=this._map.getMaxBounds(),i=t.coords;return e&&(i.longitude<e.getWest()||i.longitude>e.getEast()||i.latitude<e.getSouth()||i.latitude>e.getNorth())},o.prototype._setErrorState=function(){switch(this._watchState){case"WAITING_ACTIVE":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"ACTIVE_LOCK":this._watchState="ACTIVE_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");break;case"BACKGROUND":this._watchState="BACKGROUND_ERROR",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting");}},o.prototype._onSuccess=function(e){if(this._map){if(this._isOutOfMapMaxBounds(e))return this._setErrorState(),this.fire(new t.Event("outofmaxbounds",e)),this._updateMarker(),void this._finish();if(this.options.trackUserLocation)switch(this._lastKnownPosition=e,this._watchState){case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"BACKGROUND":case"BACKGROUND_ERROR":this._watchState="BACKGROUND",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");}this.options.showUserLocation&&"OFF"!==this._watchState&&this._updateMarker(e),this.options.trackUserLocation&&"ACTIVE_LOCK"!==this._watchState||this._updateCamera(e),this.options.showUserLocation&&this._dotElement.classList.remove("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("geolocate",e)),this._finish();}},o.prototype._updateCamera=function(e){var i=new t.LngLat(e.coords.longitude,e.coords.latitude),o=e.coords.accuracy,r=this._map.getBearing(),a=t.extend({bearing:r},this.options.fitBoundsOptions);this._map.fitBounds(i.toBounds(o),a,{geolocateSource:!0});},o.prototype._updateMarker=function(e){if(e){var i=new t.LngLat(e.coords.longitude,e.coords.latitude);this._accuracyCircleMarker.setLngLat(i).addTo(this._map),this._userLocationDotMarker.setLngLat(i).addTo(this._map),this._accuracy=e.coords.accuracy,this.options.showUserLocation&&this.options.showAccuracyCircle&&this._updateCircleRadius();}else this._userLocationDotMarker.remove(),this._accuracyCircleMarker.remove();},o.prototype._updateCircleRadius=function(){var t=this._map._container.clientHeight/2,e=this._map.unproject([0,t]),i=this._map.unproject([1,t]),o=e.distanceTo(i),r=Math.ceil(2*this._accuracy/o);this._circleElement.style.width=r+"px",this._circleElement.style.height=r+"px";},o.prototype._onZoom=function(){this.options.showUserLocation&&this.options.showAccuracyCircle&&this._updateCircleRadius();},o.prototype._onError=function(e){if(this._map){if(this.options.trackUserLocation)if(1===e.code){this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this._geolocateButton.disabled=!0;var i=this._map._getUIString("GeolocateControl.LocationNotAvailable");this._geolocateButton.title=i,this._geolocateButton.setAttribute("aria-label",i),void 0!==this._geolocationWatchID&&this._clearWatch();}else{if(3===e.code&&ir)return;this._setErrorState();}"OFF"!==this._watchState&&this.options.showUserLocation&&this._dotElement.classList.add("mapboxgl-user-location-dot-stale"),this.fire(new t.Event("error",e)),this._finish();}},o.prototype._finish=function(){this._timeoutId&&clearTimeout(this._timeoutId),this._timeoutId=void 0;},o.prototype._setupUI=function(e){var o=this;if(this._container.addEventListener("contextmenu",(function(t){return t.preventDefault()})),this._geolocateButton=i.create("button","mapboxgl-ctrl-geolocate",this._container),i.create("span","mapboxgl-ctrl-icon",this._geolocateButton).setAttribute("aria-hidden",!0),this._geolocateButton.type="button",!1===e){t.warnOnce("Geolocation support is not available so the GeolocateControl will be disabled.");var r=this._map._getUIString("GeolocateControl.LocationNotAvailable");this._geolocateButton.disabled=!0,this._geolocateButton.title=r,this._geolocateButton.setAttribute("aria-label",r);}else{var a=this._map._getUIString("GeolocateControl.FindMyLocation");this._geolocateButton.title=a,this._geolocateButton.setAttribute("aria-label",a);}this.options.trackUserLocation&&(this._geolocateButton.setAttribute("aria-pressed","false"),this._watchState="OFF"),this.options.showUserLocation&&(this._dotElement=i.create("div","mapboxgl-user-location-dot"),this._userLocationDotMarker=new $o(this._dotElement),this._circleElement=i.create("div","mapboxgl-user-location-accuracy-circle"),this._accuracyCircleMarker=new $o({element:this._circleElement,pitchAlignment:"map"}),this.options.trackUserLocation&&(this._watchState="OFF"),this._map.on("zoom",this._onZoom)),this._geolocateButton.addEventListener("click",this.trigger.bind(this)),this._setup=!0,this.options.trackUserLocation&&this._map.on("movestart",(function(e){var i=e.originalEvent&&"resize"===e.originalEvent.type;e.geolocateSource||"ACTIVE_LOCK"!==o._watchState||i||(o._watchState="BACKGROUND",o._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background"),o._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),o.fire(new t.Event("trackuserlocationend")));}));},o.prototype.trigger=function(){if(!this._setup)return t.warnOnce("Geolocate control triggered before added to a map"),!1;if(this.options.trackUserLocation){switch(this._watchState){case"OFF":this._watchState="WAITING_ACTIVE",this.fire(new t.Event("trackuserlocationstart"));break;case"WAITING_ACTIVE":case"ACTIVE_LOCK":case"ACTIVE_ERROR":case"BACKGROUND_ERROR":er--,ir=!1,this._watchState="OFF",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-active-error"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background-error"),this.fire(new t.Event("trackuserlocationend"));break;case"BACKGROUND":this._watchState="ACTIVE_LOCK",this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-background"),this._lastKnownPosition&&this._updateCamera(this._lastKnownPosition),this.fire(new t.Event("trackuserlocationstart"));}switch(this._watchState){case"WAITING_ACTIVE":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_LOCK":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active");break;case"ACTIVE_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-active-error");break;case"BACKGROUND":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background");break;case"BACKGROUND_ERROR":this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-background-error");}if("OFF"===this._watchState&&void 0!==this._geolocationWatchID)this._clearWatch();else if(void 0===this._geolocationWatchID){var e;this._geolocateButton.classList.add("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","true"),++er>1?(e={maximumAge:6e5,timeout:0},ir=!0):(e=this.options.positionOptions,ir=!1),this._geolocationWatchID=t.window.navigator.geolocation.watchPosition(this._onSuccess,this._onError,e);}}else t.window.navigator.geolocation.getCurrentPosition(this._onSuccess,this._onError,this.options.positionOptions),this._timeoutId=setTimeout(this._finish,1e4);return !0},o.prototype._clearWatch=function(){t.window.navigator.geolocation.clearWatch(this._geolocationWatchID),this._geolocationWatchID=void 0,this._geolocateButton.classList.remove("mapboxgl-ctrl-geolocate-waiting"),this._geolocateButton.setAttribute("aria-pressed","false"),this.options.showUserLocation&&this._updateMarker(null);},o}(t.Evented),rr={maxWidth:100,unit:"metric"},ar=function(e){this.options=t.extend({},rr,e),t.bindAll(["_onMove","setUnit"],this);};function nr(t,e,i){var o=i&&i.maxWidth||100,r=t._container.clientHeight/2,a=t.unproject([0,r]),n=t.unproject([o,r]),s=a.distanceTo(n);if(i&&"imperial"===i.unit){var l=3.2808*s;if(l>5280)sr(e,o,l/5280,t._getUIString("ScaleControl.Miles"));else sr(e,o,l,t._getUIString("ScaleControl.Feet"));}else if(i&&"nautical"===i.unit){sr(e,o,s/1852,t._getUIString("ScaleControl.NauticalMiles"));}else s>=1e3?sr(e,o,s/1e3,t._getUIString("ScaleControl.Kilometers")):sr(e,o,s,t._getUIString("ScaleControl.Meters"));}function sr(t,e,i,o){var r,a,n,s=(r=i,a=Math.pow(10,(""+Math.floor(r)).length-1),n=(n=r/a)>=10?10:n>=5?5:n>=3?3:n>=2?2:n>=1?1:function(t){var e=Math.pow(10,Math.ceil(-Math.log(t)/Math.LN10));return Math.round(t*e)/e}(n),a*n),l=s/i;t.style.width=e*l+"px",t.innerHTML=s+"&nbsp;"+o;}ar.prototype.getDefaultPosition=function(){return "bottom-left"},ar.prototype._onMove=function(){nr(this._map,this._container,this.options);},ar.prototype.onAdd=function(t){return this._map=t,this._container=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-scale",t.getContainer()),this._map.on("move",this._onMove),this._onMove(),this._container},ar.prototype.onRemove=function(){i.remove(this._container),this._map.off("move",this._onMove),this._map=void 0;},ar.prototype.setUnit=function(t){this.options.unit=t,nr(this._map,this._container,this.options);};var lr=function(e){this._fullscreen=!1,e&&e.container&&(e.container instanceof t.window.HTMLElement?this._container=e.container:t.warnOnce("Full screen control 'container' must be a DOM element.")),t.bindAll(["_onClickFullscreen","_changeIcon"],this),"onfullscreenchange"in t.window.document?this._fullscreenchange="fullscreenchange":"onmozfullscreenchange"in t.window.document?this._fullscreenchange="mozfullscreenchange":"onwebkitfullscreenchange"in t.window.document?this._fullscreenchange="webkitfullscreenchange":"onmsfullscreenchange"in t.window.document&&(this._fullscreenchange="MSFullscreenChange");};lr.prototype.onAdd=function(e){return this._map=e,this._container||(this._container=this._map.getContainer()),this._controlContainer=i.create("div","mapboxgl-ctrl mapboxgl-ctrl-group"),this._checkFullscreenSupport()?this._setupUI():(this._controlContainer.style.display="none",t.warnOnce("This device does not support fullscreen mode.")),this._controlContainer},lr.prototype.onRemove=function(){i.remove(this._controlContainer),this._map=null,t.window.document.removeEventListener(this._fullscreenchange,this._changeIcon);},lr.prototype._checkFullscreenSupport=function(){return !!(t.window.document.fullscreenEnabled||t.window.document.mozFullScreenEnabled||t.window.document.msFullscreenEnabled||t.window.document.webkitFullscreenEnabled)},lr.prototype._setupUI=function(){var e=this._fullscreenButton=i.create("button","mapboxgl-ctrl-fullscreen",this._controlContainer);i.create("span","mapboxgl-ctrl-icon",e).setAttribute("aria-hidden",!0),e.type="button",this._updateTitle(),this._fullscreenButton.addEventListener("click",this._onClickFullscreen),t.window.document.addEventListener(this._fullscreenchange,this._changeIcon);},lr.prototype._updateTitle=function(){var t=this._getTitle();this._fullscreenButton.setAttribute("aria-label",t),this._fullscreenButton.title=t;},lr.prototype._getTitle=function(){return this._map._getUIString(this._isFullscreen()?"FullscreenControl.Exit":"FullscreenControl.Enter")},lr.prototype._isFullscreen=function(){return this._fullscreen},lr.prototype._changeIcon=function(){(t.window.document.fullscreenElement||t.window.document.mozFullScreenElement||t.window.document.webkitFullscreenElement||t.window.document.msFullscreenElement)===this._container!==this._fullscreen&&(this._fullscreen=!this._fullscreen,this._fullscreenButton.classList.toggle("mapboxgl-ctrl-shrink"),this._fullscreenButton.classList.toggle("mapboxgl-ctrl-fullscreen"),this._updateTitle());},lr.prototype._onClickFullscreen=function(){this._isFullscreen()?t.window.document.exitFullscreen?t.window.document.exitFullscreen():t.window.document.mozCancelFullScreen?t.window.document.mozCancelFullScreen():t.window.document.msExitFullscreen?t.window.document.msExitFullscreen():t.window.document.webkitCancelFullScreen&&t.window.document.webkitCancelFullScreen():this._container.requestFullscreen?this._container.requestFullscreen():this._container.mozRequestFullScreen?this._container.mozRequestFullScreen():this._container.msRequestFullscreen?this._container.msRequestFullscreen():this._container.webkitRequestFullscreen&&this._container.webkitRequestFullscreen();};var cr={closeButton:!0,closeOnClick:!0,className:"",maxWidth:"240px"},ur=function(e){function o(i){e.call(this),this.options=t.extend(Object.create(cr),i),t.bindAll(["_update","_onClose","remove"],this);}return e&&(o.__proto__=e),o.prototype=Object.create(e&&e.prototype),o.prototype.constructor=o,o.prototype.addTo=function(e){var i=this;return this._map=e,this.options.closeOnClick&&this._map.on("click",this._onClose),this.options.closeOnMove&&this._map.on("move",this._onClose),this._map.on("remove",this.remove),this._update(),this._trackPointer?(this._map.on("mousemove",(function(t){i._update(t.point);})),this._map.on("mouseup",(function(t){i._update(t.point);})),this._container&&this._container.classList.add("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.add("mapboxgl-track-pointer")):this._map.on("move",this._update),this.fire(new t.Event("open")),this},o.prototype.isOpen=function(){return !!this._map},o.prototype.remove=function(){return this._content&&i.remove(this._content),this._container&&(i.remove(this._container),delete this._container),this._map&&(this._map.off("move",this._update),this._map.off("move",this._onClose),this._map.off("click",this._onClose),this._map.off("remove",this.remove),this._map.off("mousemove"),delete this._map),this.fire(new t.Event("close")),this},o.prototype.getLngLat=function(){return this._lngLat},o.prototype.setLngLat=function(e){return this._lngLat=t.LngLat.convert(e),this._pos=null,this._trackPointer=!1,this._update(),this._map&&(this._map.on("move",this._update),this._map.off("mousemove"),this._container&&this._container.classList.remove("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.remove("mapboxgl-track-pointer")),this},o.prototype.trackPointer=function(){var t=this;return this._trackPointer=!0,this._pos=null,this._update(),this._map&&(this._map.off("move",this._update),this._map.on("mousemove",(function(e){t._update(e.point);})),this._map.on("drag",(function(e){t._update(e.point);})),this._container&&this._container.classList.add("mapboxgl-popup-track-pointer"),this._map._canvasContainer.classList.add("mapboxgl-track-pointer")),this},o.prototype.getElement=function(){return this._container},o.prototype.setText=function(e){return this.setDOMContent(t.window.document.createTextNode(e))},o.prototype.setHTML=function(e){var i,o=t.window.document.createDocumentFragment(),r=t.window.document.createElement("body");for(r.innerHTML=e;i=r.firstChild;)o.appendChild(i);return this.setDOMContent(o)},o.prototype.getMaxWidth=function(){return this._container.style.maxWidth},o.prototype.setMaxWidth=function(t){return this.options.maxWidth=t,this._update(),this},o.prototype.setDOMContent=function(t){return this._createContent(),this._content.appendChild(t),this._update(),this},o.prototype.addClassName=function(t){this._container.classList.add(t);},o.prototype.removeClassName=function(t){this._container.classList.remove(t);},o.prototype.toggleClassName=function(t){return this._container.classList.toggle(t)},o.prototype._createContent=function(){this._content&&i.remove(this._content),this._content=i.create("div","mapboxgl-popup-content",this._container),this.options.closeButton&&(this._closeButton=i.create("button","mapboxgl-popup-close-button",this._content),this._closeButton.type="button",this._closeButton.setAttribute("aria-label","Close popup"),this._closeButton.innerHTML="&#215;",this._closeButton.addEventListener("click",this._onClose));},o.prototype._update=function(e){var o=this,r=this._lngLat||this._trackPointer;if(this._map&&r&&this._content&&(this._container||(this._container=i.create("div","mapboxgl-popup",this._map.getContainer()),this._tip=i.create("div","mapboxgl-popup-tip",this._container),this._container.appendChild(this._content),this.options.className&&this.options.className.split(" ").forEach((function(t){return o._container.classList.add(t)})),this._trackPointer&&this._container.classList.add("mapboxgl-popup-track-pointer")),this.options.maxWidth&&this._container.style.maxWidth!==this.options.maxWidth&&(this._container.style.maxWidth=this.options.maxWidth),this._map.transform.renderWorldCopies&&!this._trackPointer&&(this._lngLat=Ko(this._lngLat,this._pos,this._map.transform)),!this._trackPointer||e)){var a=this._pos=this._trackPointer&&e?e:this._map.project(this._lngLat),n=this.options.anchor,s=function e(i){if(i){if("number"==typeof i){var o=Math.round(Math.sqrt(.5*Math.pow(i,2)));return {center:new t.Point(0,0),top:new t.Point(0,i),"top-left":new t.Point(o,o),"top-right":new t.Point(-o,o),bottom:new t.Point(0,-i),"bottom-left":new t.Point(o,-o),"bottom-right":new t.Point(-o,-o),left:new t.Point(i,0),right:new t.Point(-i,0)}}if(i instanceof t.Point||Array.isArray(i)){var r=t.Point.convert(i);return {center:r,top:r,"top-left":r,"top-right":r,bottom:r,"bottom-left":r,"bottom-right":r,left:r,right:r}}return {center:t.Point.convert(i.center||[0,0]),top:t.Point.convert(i.top||[0,0]),"top-left":t.Point.convert(i["top-left"]||[0,0]),"top-right":t.Point.convert(i["top-right"]||[0,0]),bottom:t.Point.convert(i.bottom||[0,0]),"bottom-left":t.Point.convert(i["bottom-left"]||[0,0]),"bottom-right":t.Point.convert(i["bottom-right"]||[0,0]),left:t.Point.convert(i.left||[0,0]),right:t.Point.convert(i.right||[0,0])}}return e(new t.Point(0,0))}(this.options.offset);if(!n){var l,c=this._container.offsetWidth,u=this._container.offsetHeight;l=a.y+s.bottom.y<u?["top"]:a.y>this._map.transform.height-u?["bottom"]:[],a.x<c/2?l.push("left"):a.x>this._map.transform.width-c/2&&l.push("right"),n=0===l.length?"bottom":l.join("-");}var h=a.add(s[n]).round();i.setTransform(this._container,Yo[n]+" translate("+h.x+"px,"+h.y+"px)"),Jo(this._container,n,"popup");}},o.prototype._onClose=function(){this.remove();},o}(t.Evented);var hr={version:t.version,supported:e,setRTLTextPlugin:t.setRTLTextPlugin,getRTLTextPluginStatus:t.getRTLTextPluginStatus,Map:Go,NavigationControl:Ho,GeolocateControl:or,AttributionControl:ko,ScaleControl:ar,FullscreenControl:lr,Popup:ur,Marker:$o,Style:Ze,LngLat:t.LngLat,LngLatBounds:t.LngLatBounds,Point:t.Point,MercatorCoordinate:t.MercatorCoordinate,Evented:t.Evented,config:t.config,get accessToken(){return t.config.ACCESS_TOKEN},set accessToken(e){t.config.ACCESS_TOKEN=e;},get baseApiUrl(){return t.config.API_URL},set baseApiUrl(e){t.config.API_URL=e;},get workerCount(){return kt.workerCount},set workerCount(t){kt.workerCount=t;},get maxParallelImageRequests(){return t.config.MAX_PARALLEL_IMAGE_REQUESTS},set maxParallelImageRequests(e){t.config.MAX_PARALLEL_IMAGE_REQUESTS=e;},clearStorage:function(e){t.clearTileCache(e);},workerUrl:""};return hr}));
	
	//
	
	return mapboxgl;
	
	})));
	//# sourceMappingURL=mapbox-gl.js.map


/***/ },
/* 539 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';function _interopDefault(e){return(e&&(typeof e==='object')&&'default'in e)?e['default']:e}var React=__webpack_require__(2),React__default=_interopDefault(React),_inheritsLoose=_interopDefault(__webpack_require__(107)),PropTypes=_interopDefault(__webpack_require__(4)),gud=_interopDefault(__webpack_require__(524)),warning=_interopDefault(__webpack_require__(41));var MAX_SIGNED_31_BIT_INT = 1073741823;
	
	function objectIs(x, y) {
	  if (x === y) {
	    return x !== 0 || 1 / x === 1 / y;
	  } else {
	    return x !== x && y !== y;
	  }
	}
	
	function createEventEmitter(value) {
	  var handlers = [];
	  return {
	    on: function on(handler) {
	      handlers.push(handler);
	    },
	    off: function off(handler) {
	      handlers = handlers.filter(function (h) {
	        return h !== handler;
	      });
	    },
	    get: function get() {
	      return value;
	    },
	    set: function set(newValue, changedBits) {
	      value = newValue;
	      handlers.forEach(function (handler) {
	        return handler(value, changedBits);
	      });
	    }
	  };
	}
	
	function onlyChild(children) {
	  return Array.isArray(children) ? children[0] : children;
	}
	
	function createReactContext(defaultValue, calculateChangedBits) {
	  var _Provider$childContex, _Consumer$contextType;
	
	  var contextProp = '__create-react-context-' + gud() + '__';
	
	  var Provider =
	  /*#__PURE__*/
	  function (_Component) {
	    _inheritsLoose(Provider, _Component);
	
	    function Provider() {
	      var _this;
	
	      _this = _Component.apply(this, arguments) || this;
	      _this.emitter = createEventEmitter(_this.props.value);
	      return _this;
	    }
	
	    var _proto = Provider.prototype;
	
	    _proto.getChildContext = function getChildContext() {
	      var _ref;
	
	      return _ref = {}, _ref[contextProp] = this.emitter, _ref;
	    };
	
	    _proto.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      if (this.props.value !== nextProps.value) {
	        var oldValue = this.props.value;
	        var newValue = nextProps.value;
	        var changedBits;
	
	        if (objectIs(oldValue, newValue)) {
	          changedBits = 0;
	        } else {
	          changedBits = typeof calculateChangedBits === 'function' ? calculateChangedBits(oldValue, newValue) : MAX_SIGNED_31_BIT_INT;
	
	          if (false) {
	            warning((changedBits & MAX_SIGNED_31_BIT_INT) === changedBits, 'calculateChangedBits: Expected the return value to be a ' + '31-bit integer. Instead received: ' + changedBits);
	          }
	
	          changedBits |= 0;
	
	          if (changedBits !== 0) {
	            this.emitter.set(nextProps.value, changedBits);
	          }
	        }
	      }
	    };
	
	    _proto.render = function render() {
	      return this.props.children;
	    };
	
	    return Provider;
	  }(React.Component);
	
	  Provider.childContextTypes = (_Provider$childContex = {}, _Provider$childContex[contextProp] = PropTypes.object.isRequired, _Provider$childContex);
	
	  var Consumer =
	  /*#__PURE__*/
	  function (_Component2) {
	    _inheritsLoose(Consumer, _Component2);
	
	    function Consumer() {
	      var _this2;
	
	      _this2 = _Component2.apply(this, arguments) || this;
	      _this2.state = {
	        value: _this2.getValue()
	      };
	
	      _this2.onUpdate = function (newValue, changedBits) {
	        var observedBits = _this2.observedBits | 0;
	
	        if ((observedBits & changedBits) !== 0) {
	          _this2.setState({
	            value: _this2.getValue()
	          });
	        }
	      };
	
	      return _this2;
	    }
	
	    var _proto2 = Consumer.prototype;
	
	    _proto2.componentWillReceiveProps = function componentWillReceiveProps(nextProps) {
	      var observedBits = nextProps.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentDidMount = function componentDidMount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].on(this.onUpdate);
	      }
	
	      var observedBits = this.props.observedBits;
	      this.observedBits = observedBits === undefined || observedBits === null ? MAX_SIGNED_31_BIT_INT : observedBits;
	    };
	
	    _proto2.componentWillUnmount = function componentWillUnmount() {
	      if (this.context[contextProp]) {
	        this.context[contextProp].off(this.onUpdate);
	      }
	    };
	
	    _proto2.getValue = function getValue() {
	      if (this.context[contextProp]) {
	        return this.context[contextProp].get();
	      } else {
	        return defaultValue;
	      }
	    };
	
	    _proto2.render = function render() {
	      return onlyChild(this.props.children)(this.state.value);
	    };
	
	    return Consumer;
	  }(React.Component);
	
	  Consumer.contextTypes = (_Consumer$contextType = {}, _Consumer$contextType[contextProp] = PropTypes.object, _Consumer$contextType);
	  return {
	    Provider: Provider,
	    Consumer: Consumer
	  };
	}var index = React__default.createContext || createReactContext;module.exports=index;

/***/ },
/* 540 */
/***/ function(module, exports, __webpack_require__) {

	// This file replaces `index.js` in bundlers like webpack or Rollup,
	// according to `browser` config in `package.json`.
	
	if (false) {
	  // All bundlers will remove this block in production bundle
	  if (typeof navigator !== 'undefined' && navigator.product === 'ReactNative') {
	    throw new Error(
	      'React Native does not have a built-in secure random generator. ' +
	      'If you don’t need unpredictable IDs, you can use `nanoid/non-secure`. ' +
	      'For secure ID install `expo-random` locally and use `nanoid/async`.'
	    )
	  }
	  if (typeof self === 'undefined' || (!self.crypto && !self.msCrypto)) {
	    throw new Error(
	      'Your browser does not have secure random generator. ' +
	      'If you don’t need unpredictable IDs, you can use nanoid/non-secure.'
	    )
	  }
	}
	
	var crypto = self.crypto || self.msCrypto
	
	// This alphabet uses a-z A-Z 0-9 _- symbols.
	// Symbols are generated for smaller size.
	// -_zyxwvutsrqponmlkjihgfedcba9876543210ZYXWVUTSRQPONMLKJIHGFEDCBA
	var url = '-_'
	// Loop from 36 to 0 (from z to a and 9 to 0 in Base36).
	var i = 36
	while (i--) {
	  // 36 is radix. Number.prototype.toString(36) returns number
	  // in Base36 representation. Base36 is like hex, but it uses 0–9 and a-z.
	  url += i.toString(36)
	}
	// Loop from 36 to 10 (from Z to A in Base36).
	i = 36
	while (i-- - 10) {
	  url += i.toString(36).toUpperCase()
	}
	
	module.exports = function (size) {
	  var id = ''
	  var bytes = crypto.getRandomValues(new Uint8Array(size || 21))
	  i = size || 21
	
	  // Compact alternative for `for (var i = 0; i < size; i++)`
	  while (i--) {
	    // We can’t use bytes bigger than the alphabet. 63 is 00111111 bitmask.
	    // This mask reduces random byte 0-255 to 0-63 values.
	    // There is no need in `|| ''` and `* 1.6` hacks in here,
	    // because bitmask trim bytes exact to alphabet size.
	    id += url[bytes[i] & 63]
	  }
	  return id
	}


/***/ },
/* 541 */
/***/ function(module, exports, __webpack_require__) {

	var isarray = __webpack_require__(529)
	
	/**
	 * Expose `pathToRegexp`.
	 */
	module.exports = pathToRegexp
	module.exports.parse = parse
	module.exports.compile = compile
	module.exports.tokensToFunction = tokensToFunction
	module.exports.tokensToRegExp = tokensToRegExp
	
	/**
	 * The main path matching regexp utility.
	 *
	 * @type {RegExp}
	 */
	var PATH_REGEXP = new RegExp([
	  // Match escaped characters that would otherwise appear in future matches.
	  // This allows the user to escape special characters that won't transform.
	  '(\\\\.)',
	  // Match Express-style parameters and un-named parameters with a prefix
	  // and optional suffixes. Matches appear as:
	  //
	  // "/:test(\\d+)?" => ["/", "test", "\d+", undefined, "?", undefined]
	  // "/route(\\d+)"  => [undefined, undefined, undefined, "\d+", undefined, undefined]
	  // "/*"            => ["/", undefined, undefined, undefined, undefined, "*"]
	  '([\\/.])?(?:(?:\\:(\\w+)(?:\\(((?:\\\\.|[^\\\\()])+)\\))?|\\(((?:\\\\.|[^\\\\()])+)\\))([+*?])?|(\\*))'
	].join('|'), 'g')
	
	/**
	 * Parse a string for the raw tokens.
	 *
	 * @param  {string}  str
	 * @param  {Object=} options
	 * @return {!Array}
	 */
	function parse (str, options) {
	  var tokens = []
	  var key = 0
	  var index = 0
	  var path = ''
	  var defaultDelimiter = options && options.delimiter || '/'
	  var res
	
	  while ((res = PATH_REGEXP.exec(str)) != null) {
	    var m = res[0]
	    var escaped = res[1]
	    var offset = res.index
	    path += str.slice(index, offset)
	    index = offset + m.length
	
	    // Ignore already escaped sequences.
	    if (escaped) {
	      path += escaped[1]
	      continue
	    }
	
	    var next = str[index]
	    var prefix = res[2]
	    var name = res[3]
	    var capture = res[4]
	    var group = res[5]
	    var modifier = res[6]
	    var asterisk = res[7]
	
	    // Push the current path onto the tokens.
	    if (path) {
	      tokens.push(path)
	      path = ''
	    }
	
	    var partial = prefix != null && next != null && next !== prefix
	    var repeat = modifier === '+' || modifier === '*'
	    var optional = modifier === '?' || modifier === '*'
	    var delimiter = res[2] || defaultDelimiter
	    var pattern = capture || group
	
	    tokens.push({
	      name: name || key++,
	      prefix: prefix || '',
	      delimiter: delimiter,
	      optional: optional,
	      repeat: repeat,
	      partial: partial,
	      asterisk: !!asterisk,
	      pattern: pattern ? escapeGroup(pattern) : (asterisk ? '.*' : '[^' + escapeString(delimiter) + ']+?')
	    })
	  }
	
	  // Match any characters still remaining.
	  if (index < str.length) {
	    path += str.substr(index)
	  }
	
	  // If the path exists, push it onto the end.
	  if (path) {
	    tokens.push(path)
	  }
	
	  return tokens
	}
	
	/**
	 * Compile a string to a template function for the path.
	 *
	 * @param  {string}             str
	 * @param  {Object=}            options
	 * @return {!function(Object=, Object=)}
	 */
	function compile (str, options) {
	  return tokensToFunction(parse(str, options), options)
	}
	
	/**
	 * Prettier encoding of URI path segments.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeURIComponentPretty (str) {
	  return encodeURI(str).replace(/[\/?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Encode the asterisk parameter. Similar to `pretty`, but allows slashes.
	 *
	 * @param  {string}
	 * @return {string}
	 */
	function encodeAsterisk (str) {
	  return encodeURI(str).replace(/[?#]/g, function (c) {
	    return '%' + c.charCodeAt(0).toString(16).toUpperCase()
	  })
	}
	
	/**
	 * Expose a method for transforming tokens into the path function.
	 */
	function tokensToFunction (tokens, options) {
	  // Compile all the tokens into regexps.
	  var matches = new Array(tokens.length)
	
	  // Compile all the patterns before compilation.
	  for (var i = 0; i < tokens.length; i++) {
	    if (typeof tokens[i] === 'object') {
	      matches[i] = new RegExp('^(?:' + tokens[i].pattern + ')$', flags(options))
	    }
	  }
	
	  return function (obj, opts) {
	    var path = ''
	    var data = obj || {}
	    var options = opts || {}
	    var encode = options.pretty ? encodeURIComponentPretty : encodeURIComponent
	
	    for (var i = 0; i < tokens.length; i++) {
	      var token = tokens[i]
	
	      if (typeof token === 'string') {
	        path += token
	
	        continue
	      }
	
	      var value = data[token.name]
	      var segment
	
	      if (value == null) {
	        if (token.optional) {
	          // Prepend partial segment prefixes.
	          if (token.partial) {
	            path += token.prefix
	          }
	
	          continue
	        } else {
	          throw new TypeError('Expected "' + token.name + '" to be defined')
	        }
	      }
	
	      if (isarray(value)) {
	        if (!token.repeat) {
	          throw new TypeError('Expected "' + token.name + '" to not repeat, but received `' + JSON.stringify(value) + '`')
	        }
	
	        if (value.length === 0) {
	          if (token.optional) {
	            continue
	          } else {
	            throw new TypeError('Expected "' + token.name + '" to not be empty')
	          }
	        }
	
	        for (var j = 0; j < value.length; j++) {
	          segment = encode(value[j])
	
	          if (!matches[i].test(segment)) {
	            throw new TypeError('Expected all "' + token.name + '" to match "' + token.pattern + '", but received `' + JSON.stringify(segment) + '`')
	          }
	
	          path += (j === 0 ? token.prefix : token.delimiter) + segment
	        }
	
	        continue
	      }
	
	      segment = token.asterisk ? encodeAsterisk(value) : encode(value)
	
	      if (!matches[i].test(segment)) {
	        throw new TypeError('Expected "' + token.name + '" to match "' + token.pattern + '", but received "' + segment + '"')
	      }
	
	      path += token.prefix + segment
	    }
	
	    return path
	  }
	}
	
	/**
	 * Escape a regular expression string.
	 *
	 * @param  {string} str
	 * @return {string}
	 */
	function escapeString (str) {
	  return str.replace(/([.+*?=^!:${}()[\]|\/\\])/g, '\\$1')
	}
	
	/**
	 * Escape the capturing group by escaping special characters and meaning.
	 *
	 * @param  {string} group
	 * @return {string}
	 */
	function escapeGroup (group) {
	  return group.replace(/([=!:$\/()])/g, '\\$1')
	}
	
	/**
	 * Attach the keys as a property of the regexp.
	 *
	 * @param  {!RegExp} re
	 * @param  {Array}   keys
	 * @return {!RegExp}
	 */
	function attachKeys (re, keys) {
	  re.keys = keys
	  return re
	}
	
	/**
	 * Get the flags for a regexp from the options.
	 *
	 * @param  {Object} options
	 * @return {string}
	 */
	function flags (options) {
	  return options && options.sensitive ? '' : 'i'
	}
	
	/**
	 * Pull out keys from a regexp.
	 *
	 * @param  {!RegExp} path
	 * @param  {!Array}  keys
	 * @return {!RegExp}
	 */
	function regexpToRegexp (path, keys) {
	  // Use a negative lookahead to match only capturing groups.
	  var groups = path.source.match(/\((?!\?)/g)
	
	  if (groups) {
	    for (var i = 0; i < groups.length; i++) {
	      keys.push({
	        name: i,
	        prefix: null,
	        delimiter: null,
	        optional: false,
	        repeat: false,
	        partial: false,
	        asterisk: false,
	        pattern: null
	      })
	    }
	  }
	
	  return attachKeys(path, keys)
	}
	
	/**
	 * Transform an array into a regexp.
	 *
	 * @param  {!Array}  path
	 * @param  {Array}   keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function arrayToRegexp (path, keys, options) {
	  var parts = []
	
	  for (var i = 0; i < path.length; i++) {
	    parts.push(pathToRegexp(path[i], keys, options).source)
	  }
	
	  var regexp = new RegExp('(?:' + parts.join('|') + ')', flags(options))
	
	  return attachKeys(regexp, keys)
	}
	
	/**
	 * Create a path regexp from string input.
	 *
	 * @param  {string}  path
	 * @param  {!Array}  keys
	 * @param  {!Object} options
	 * @return {!RegExp}
	 */
	function stringToRegexp (path, keys, options) {
	  return tokensToRegExp(parse(path, options), keys, options)
	}
	
	/**
	 * Expose a function for taking tokens and returning a RegExp.
	 *
	 * @param  {!Array}          tokens
	 * @param  {(Array|Object)=} keys
	 * @param  {Object=}         options
	 * @return {!RegExp}
	 */
	function tokensToRegExp (tokens, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  var strict = options.strict
	  var end = options.end !== false
	  var route = ''
	
	  // Iterate over the tokens and create our regexp string.
	  for (var i = 0; i < tokens.length; i++) {
	    var token = tokens[i]
	
	    if (typeof token === 'string') {
	      route += escapeString(token)
	    } else {
	      var prefix = escapeString(token.prefix)
	      var capture = '(?:' + token.pattern + ')'
	
	      keys.push(token)
	
	      if (token.repeat) {
	        capture += '(?:' + prefix + capture + ')*'
	      }
	
	      if (token.optional) {
	        if (!token.partial) {
	          capture = '(?:' + prefix + '(' + capture + '))?'
	        } else {
	          capture = prefix + '(' + capture + ')?'
	        }
	      } else {
	        capture = prefix + '(' + capture + ')'
	      }
	
	      route += capture
	    }
	  }
	
	  var delimiter = escapeString(options.delimiter || '/')
	  var endsWithDelimiter = route.slice(-delimiter.length) === delimiter
	
	  // In non-strict mode we allow a slash at the end of match. If the path to
	  // match already ends with a slash, we remove it for consistency. The slash
	  // is valid at the end of a path match, not in the middle. This is important
	  // in non-ending mode, where "/test/" shouldn't match "/test//route".
	  if (!strict) {
	    route = (endsWithDelimiter ? route.slice(0, -delimiter.length) : route) + '(?:' + delimiter + '(?=$))?'
	  }
	
	  if (end) {
	    route += '$'
	  } else {
	    // In non-ending mode, we need the capturing groups to match as much as
	    // possible by using a positive lookahead to the end or next path segment.
	    route += strict && endsWithDelimiter ? '' : '(?=' + delimiter + '|$)'
	  }
	
	  return attachKeys(new RegExp('^' + route, flags(options)), keys)
	}
	
	/**
	 * Normalize the given path string, returning a regular expression.
	 *
	 * An empty array can be passed in for the keys, which will hold the
	 * placeholder key descriptions. For example, using `/user/:id`, `keys` will
	 * contain `[{ name: 'id', delimiter: '/', optional: false, repeat: false }]`.
	 *
	 * @param  {(string|RegExp|Array)} path
	 * @param  {(Array|Object)=}       keys
	 * @param  {Object=}               options
	 * @return {!RegExp}
	 */
	function pathToRegexp (path, keys, options) {
	  if (!isarray(keys)) {
	    options = /** @type {!Object} */ (keys || options)
	    keys = []
	  }
	
	  options = options || {}
	
	  if (path instanceof RegExp) {
	    return regexpToRegexp(path, /** @type {!Array} */ (keys))
	  }
	
	  if (isarray(path)) {
	    return arrayToRegexp(/** @type {!Array} */ (path), /** @type {!Array} */ (keys), options)
	  }
	
	  return stringToRegexp(/** @type {string} */ (path), /** @type {!Array} */ (keys), options)
	}


/***/ },
/* 542 */
/***/ function(module, exports, __webpack_require__) {

	/* WEBPACK VAR INJECTION */(function(global) {/**!
	 * @fileOverview Kickass library to create and place poppers near their reference elements.
	 * @version 1.16.1
	 * @license
	 * Copyright (c) 2016 Federico Zivolo and contributors
	 *
	 * Permission is hereby granted, free of charge, to any person obtaining a copy
	 * of this software and associated documentation files (the "Software"), to deal
	 * in the Software without restriction, including without limitation the rights
	 * to use, copy, modify, merge, publish, distribute, sublicense, and/or sell
	 * copies of the Software, and to permit persons to whom the Software is
	 * furnished to do so, subject to the following conditions:
	 *
	 * The above copyright notice and this permission notice shall be included in all
	 * copies or substantial portions of the Software.
	 *
	 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
	 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
	 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
	 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
	 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
	 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN THE
	 * SOFTWARE.
	 */
	(function (global, factory) {
		 true ? module.exports = factory() :
		typeof define === 'function' && define.amd ? define(factory) :
		(global.Popper = factory());
	}(this, (function () { 'use strict';
	
	var isBrowser = typeof window !== 'undefined' && typeof document !== 'undefined' && typeof navigator !== 'undefined';
	
	var timeoutDuration = function () {
	  var longerTimeoutBrowsers = ['Edge', 'Trident', 'Firefox'];
	  for (var i = 0; i < longerTimeoutBrowsers.length; i += 1) {
	    if (isBrowser && navigator.userAgent.indexOf(longerTimeoutBrowsers[i]) >= 0) {
	      return 1;
	    }
	  }
	  return 0;
	}();
	
	function microtaskDebounce(fn) {
	  var called = false;
	  return function () {
	    if (called) {
	      return;
	    }
	    called = true;
	    window.Promise.resolve().then(function () {
	      called = false;
	      fn();
	    });
	  };
	}
	
	function taskDebounce(fn) {
	  var scheduled = false;
	  return function () {
	    if (!scheduled) {
	      scheduled = true;
	      setTimeout(function () {
	        scheduled = false;
	        fn();
	      }, timeoutDuration);
	    }
	  };
	}
	
	var supportsMicroTasks = isBrowser && window.Promise;
	
	/**
	* Create a debounced version of a method, that's asynchronously deferred
	* but called in the minimum time possible.
	*
	* @method
	* @memberof Popper.Utils
	* @argument {Function} fn
	* @returns {Function}
	*/
	var debounce = supportsMicroTasks ? microtaskDebounce : taskDebounce;
	
	/**
	 * Check if the given variable is a function
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Any} functionToCheck - variable to check
	 * @returns {Boolean} answer to: is a function?
	 */
	function isFunction(functionToCheck) {
	  var getType = {};
	  return functionToCheck && getType.toString.call(functionToCheck) === '[object Function]';
	}
	
	/**
	 * Get CSS computed property of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Eement} element
	 * @argument {String} property
	 */
	function getStyleComputedProperty(element, property) {
	  if (element.nodeType !== 1) {
	    return [];
	  }
	  // NOTE: 1 DOM access here
	  var window = element.ownerDocument.defaultView;
	  var css = window.getComputedStyle(element, null);
	  return property ? css[property] : css;
	}
	
	/**
	 * Returns the parentNode or the host of the element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} parent
	 */
	function getParentNode(element) {
	  if (element.nodeName === 'HTML') {
	    return element;
	  }
	  return element.parentNode || element.host;
	}
	
	/**
	 * Returns the scrolling parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} scroll parent
	 */
	function getScrollParent(element) {
	  // Return body, `getScroll` will take care to get the correct `scrollTop` from it
	  if (!element) {
	    return document.body;
	  }
	
	  switch (element.nodeName) {
	    case 'HTML':
	    case 'BODY':
	      return element.ownerDocument.body;
	    case '#document':
	      return element.body;
	  }
	
	  // Firefox want us to check `-x` and `-y` variations as well
	
	  var _getStyleComputedProp = getStyleComputedProperty(element),
	      overflow = _getStyleComputedProp.overflow,
	      overflowX = _getStyleComputedProp.overflowX,
	      overflowY = _getStyleComputedProp.overflowY;
	
	  if (/(auto|scroll|overlay)/.test(overflow + overflowY + overflowX)) {
	    return element;
	  }
	
	  return getScrollParent(getParentNode(element));
	}
	
	/**
	 * Returns the reference node of the reference object, or the reference object itself.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Element|Object} reference - the reference element (the popper will be relative to this)
	 * @returns {Element} parent
	 */
	function getReferenceNode(reference) {
	  return reference && reference.referenceNode ? reference.referenceNode : reference;
	}
	
	var isIE11 = isBrowser && !!(window.MSInputMethodContext && document.documentMode);
	var isIE10 = isBrowser && /MSIE 10/.test(navigator.userAgent);
	
	/**
	 * Determines if the browser is Internet Explorer
	 * @method
	 * @memberof Popper.Utils
	 * @param {Number} version to check
	 * @returns {Boolean} isIE
	 */
	function isIE(version) {
	  if (version === 11) {
	    return isIE11;
	  }
	  if (version === 10) {
	    return isIE10;
	  }
	  return isIE11 || isIE10;
	}
	
	/**
	 * Returns the offset parent of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} offset parent
	 */
	function getOffsetParent(element) {
	  if (!element) {
	    return document.documentElement;
	  }
	
	  var noOffsetParent = isIE(10) ? document.body : null;
	
	  // NOTE: 1 DOM access here
	  var offsetParent = element.offsetParent || null;
	  // Skip hidden elements which don't have an offsetParent
	  while (offsetParent === noOffsetParent && element.nextElementSibling) {
	    offsetParent = (element = element.nextElementSibling).offsetParent;
	  }
	
	  var nodeName = offsetParent && offsetParent.nodeName;
	
	  if (!nodeName || nodeName === 'BODY' || nodeName === 'HTML') {
	    return element ? element.ownerDocument.documentElement : document.documentElement;
	  }
	
	  // .offsetParent will return the closest TH, TD or TABLE in case
	  // no offsetParent is present, I hate this job...
	  if (['TH', 'TD', 'TABLE'].indexOf(offsetParent.nodeName) !== -1 && getStyleComputedProperty(offsetParent, 'position') === 'static') {
	    return getOffsetParent(offsetParent);
	  }
	
	  return offsetParent;
	}
	
	function isOffsetContainer(element) {
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY') {
	    return false;
	  }
	  return nodeName === 'HTML' || getOffsetParent(element.firstElementChild) === element;
	}
	
	/**
	 * Finds the root node (document, shadowDOM root) of the given element
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} node
	 * @returns {Element} root node
	 */
	function getRoot(node) {
	  if (node.parentNode !== null) {
	    return getRoot(node.parentNode);
	  }
	
	  return node;
	}
	
	/**
	 * Finds the offset parent common to the two provided nodes
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element1
	 * @argument {Element} element2
	 * @returns {Element} common offset parent
	 */
	function findCommonOffsetParent(element1, element2) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element1 || !element1.nodeType || !element2 || !element2.nodeType) {
	    return document.documentElement;
	  }
	
	  // Here we make sure to give as "start" the element that comes first in the DOM
	  var order = element1.compareDocumentPosition(element2) & Node.DOCUMENT_POSITION_FOLLOWING;
	  var start = order ? element1 : element2;
	  var end = order ? element2 : element1;
	
	  // Get common ancestor container
	  var range = document.createRange();
	  range.setStart(start, 0);
	  range.setEnd(end, 0);
	  var commonAncestorContainer = range.commonAncestorContainer;
	
	  // Both nodes are inside #document
	
	  if (element1 !== commonAncestorContainer && element2 !== commonAncestorContainer || start.contains(end)) {
	    if (isOffsetContainer(commonAncestorContainer)) {
	      return commonAncestorContainer;
	    }
	
	    return getOffsetParent(commonAncestorContainer);
	  }
	
	  // one of the nodes is inside shadowDOM, find which one
	  var element1root = getRoot(element1);
	  if (element1root.host) {
	    return findCommonOffsetParent(element1root.host, element2);
	  } else {
	    return findCommonOffsetParent(element1, getRoot(element2).host);
	  }
	}
	
	/**
	 * Gets the scroll value of the given element in the given side (top and left)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {String} side `top` or `left`
	 * @returns {number} amount of scrolled pixels
	 */
	function getScroll(element) {
	  var side = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 'top';
	
	  var upperSide = side === 'top' ? 'scrollTop' : 'scrollLeft';
	  var nodeName = element.nodeName;
	
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    var html = element.ownerDocument.documentElement;
	    var scrollingElement = element.ownerDocument.scrollingElement || html;
	    return scrollingElement[upperSide];
	  }
	
	  return element[upperSide];
	}
	
	/*
	 * Sum or subtract the element scroll values (left and top) from a given rect object
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} rect - Rect object you want to change
	 * @param {HTMLElement} element - The element from the function reads the scroll values
	 * @param {Boolean} subtract - set to true if you want to subtract the scroll values
	 * @return {Object} rect - The modifier rect object
	 */
	function includeScroll(rect, element) {
	  var subtract = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var scrollTop = getScroll(element, 'top');
	  var scrollLeft = getScroll(element, 'left');
	  var modifier = subtract ? -1 : 1;
	  rect.top += scrollTop * modifier;
	  rect.bottom += scrollTop * modifier;
	  rect.left += scrollLeft * modifier;
	  rect.right += scrollLeft * modifier;
	  return rect;
	}
	
	/*
	 * Helper to detect borders of a given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {CSSStyleDeclaration} styles
	 * Result of `getStyleComputedProperty` on the given element
	 * @param {String} axis - `x` or `y`
	 * @return {number} borders - The borders size of the given axis
	 */
	
	function getBordersSize(styles, axis) {
	  var sideA = axis === 'x' ? 'Left' : 'Top';
	  var sideB = sideA === 'Left' ? 'Right' : 'Bottom';
	
	  return parseFloat(styles['border' + sideA + 'Width']) + parseFloat(styles['border' + sideB + 'Width']);
	}
	
	function getSize(axis, body, html, computedStyle) {
	  return Math.max(body['offset' + axis], body['scroll' + axis], html['client' + axis], html['offset' + axis], html['scroll' + axis], isIE(10) ? parseInt(html['offset' + axis]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Top' : 'Left')]) + parseInt(computedStyle['margin' + (axis === 'Height' ? 'Bottom' : 'Right')]) : 0);
	}
	
	function getWindowSizes(document) {
	  var body = document.body;
	  var html = document.documentElement;
	  var computedStyle = isIE(10) && getComputedStyle(html);
	
	  return {
	    height: getSize('Height', body, html, computedStyle),
	    width: getSize('Width', body, html, computedStyle)
	  };
	}
	
	var classCallCheck = function (instance, Constructor) {
	  if (!(instance instanceof Constructor)) {
	    throw new TypeError("Cannot call a class as a function");
	  }
	};
	
	var createClass = function () {
	  function defineProperties(target, props) {
	    for (var i = 0; i < props.length; i++) {
	      var descriptor = props[i];
	      descriptor.enumerable = descriptor.enumerable || false;
	      descriptor.configurable = true;
	      if ("value" in descriptor) descriptor.writable = true;
	      Object.defineProperty(target, descriptor.key, descriptor);
	    }
	  }
	
	  return function (Constructor, protoProps, staticProps) {
	    if (protoProps) defineProperties(Constructor.prototype, protoProps);
	    if (staticProps) defineProperties(Constructor, staticProps);
	    return Constructor;
	  };
	}();
	
	
	
	
	
	var defineProperty = function (obj, key, value) {
	  if (key in obj) {
	    Object.defineProperty(obj, key, {
	      value: value,
	      enumerable: true,
	      configurable: true,
	      writable: true
	    });
	  } else {
	    obj[key] = value;
	  }
	
	  return obj;
	};
	
	var _extends = Object.assign || function (target) {
	  for (var i = 1; i < arguments.length; i++) {
	    var source = arguments[i];
	
	    for (var key in source) {
	      if (Object.prototype.hasOwnProperty.call(source, key)) {
	        target[key] = source[key];
	      }
	    }
	  }
	
	  return target;
	};
	
	/**
	 * Given element offsets, generate an output similar to getBoundingClientRect
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} offsets
	 * @returns {Object} ClientRect like output
	 */
	function getClientRect(offsets) {
	  return _extends({}, offsets, {
	    right: offsets.left + offsets.width,
	    bottom: offsets.top + offsets.height
	  });
	}
	
	/**
	 * Get bounding client rect of given element
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} element
	 * @return {Object} client rect
	 */
	function getBoundingClientRect(element) {
	  var rect = {};
	
	  // IE10 10 FIX: Please, don't ask, the element isn't
	  // considered in DOM in some circumstances...
	  // This isn't reproducible in IE10 compatibility mode of IE11
	  try {
	    if (isIE(10)) {
	      rect = element.getBoundingClientRect();
	      var scrollTop = getScroll(element, 'top');
	      var scrollLeft = getScroll(element, 'left');
	      rect.top += scrollTop;
	      rect.left += scrollLeft;
	      rect.bottom += scrollTop;
	      rect.right += scrollLeft;
	    } else {
	      rect = element.getBoundingClientRect();
	    }
	  } catch (e) {}
	
	  var result = {
	    left: rect.left,
	    top: rect.top,
	    width: rect.right - rect.left,
	    height: rect.bottom - rect.top
	  };
	
	  // subtract scrollbar size from sizes
	  var sizes = element.nodeName === 'HTML' ? getWindowSizes(element.ownerDocument) : {};
	  var width = sizes.width || element.clientWidth || result.width;
	  var height = sizes.height || element.clientHeight || result.height;
	
	  var horizScrollbar = element.offsetWidth - width;
	  var vertScrollbar = element.offsetHeight - height;
	
	  // if an hypothetical scrollbar is detected, we must be sure it's not a `border`
	  // we make this check conditional for performance reasons
	  if (horizScrollbar || vertScrollbar) {
	    var styles = getStyleComputedProperty(element);
	    horizScrollbar -= getBordersSize(styles, 'x');
	    vertScrollbar -= getBordersSize(styles, 'y');
	
	    result.width -= horizScrollbar;
	    result.height -= vertScrollbar;
	  }
	
	  return getClientRect(result);
	}
	
	function getOffsetRectRelativeToArbitraryNode(children, parent) {
	  var fixedPosition = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : false;
	
	  var isIE10 = isIE(10);
	  var isHTML = parent.nodeName === 'HTML';
	  var childrenRect = getBoundingClientRect(children);
	  var parentRect = getBoundingClientRect(parent);
	  var scrollParent = getScrollParent(children);
	
	  var styles = getStyleComputedProperty(parent);
	  var borderTopWidth = parseFloat(styles.borderTopWidth);
	  var borderLeftWidth = parseFloat(styles.borderLeftWidth);
	
	  // In cases where the parent is fixed, we must ignore negative scroll in offset calc
	  if (fixedPosition && isHTML) {
	    parentRect.top = Math.max(parentRect.top, 0);
	    parentRect.left = Math.max(parentRect.left, 0);
	  }
	  var offsets = getClientRect({
	    top: childrenRect.top - parentRect.top - borderTopWidth,
	    left: childrenRect.left - parentRect.left - borderLeftWidth,
	    width: childrenRect.width,
	    height: childrenRect.height
	  });
	  offsets.marginTop = 0;
	  offsets.marginLeft = 0;
	
	  // Subtract margins of documentElement in case it's being used as parent
	  // we do this only on HTML because it's the only element that behaves
	  // differently when margins are applied to it. The margins are included in
	  // the box of the documentElement, in the other cases not.
	  if (!isIE10 && isHTML) {
	    var marginTop = parseFloat(styles.marginTop);
	    var marginLeft = parseFloat(styles.marginLeft);
	
	    offsets.top -= borderTopWidth - marginTop;
	    offsets.bottom -= borderTopWidth - marginTop;
	    offsets.left -= borderLeftWidth - marginLeft;
	    offsets.right -= borderLeftWidth - marginLeft;
	
	    // Attach marginTop and marginLeft because in some circumstances we may need them
	    offsets.marginTop = marginTop;
	    offsets.marginLeft = marginLeft;
	  }
	
	  if (isIE10 && !fixedPosition ? parent.contains(scrollParent) : parent === scrollParent && scrollParent.nodeName !== 'BODY') {
	    offsets = includeScroll(offsets, parent);
	  }
	
	  return offsets;
	}
	
	function getViewportOffsetRectRelativeToArtbitraryNode(element) {
	  var excludeScroll = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var html = element.ownerDocument.documentElement;
	  var relativeOffset = getOffsetRectRelativeToArbitraryNode(element, html);
	  var width = Math.max(html.clientWidth, window.innerWidth || 0);
	  var height = Math.max(html.clientHeight, window.innerHeight || 0);
	
	  var scrollTop = !excludeScroll ? getScroll(html) : 0;
	  var scrollLeft = !excludeScroll ? getScroll(html, 'left') : 0;
	
	  var offset = {
	    top: scrollTop - relativeOffset.top + relativeOffset.marginTop,
	    left: scrollLeft - relativeOffset.left + relativeOffset.marginLeft,
	    width: width,
	    height: height
	  };
	
	  return getClientRect(offset);
	}
	
	/**
	 * Check if the given element is fixed or is inside a fixed parent
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @argument {Element} customContainer
	 * @returns {Boolean} answer to "isFixed?"
	 */
	function isFixed(element) {
	  var nodeName = element.nodeName;
	  if (nodeName === 'BODY' || nodeName === 'HTML') {
	    return false;
	  }
	  if (getStyleComputedProperty(element, 'position') === 'fixed') {
	    return true;
	  }
	  var parentNode = getParentNode(element);
	  if (!parentNode) {
	    return false;
	  }
	  return isFixed(parentNode);
	}
	
	/**
	 * Finds the first parent of an element that has a transformed property defined
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Element} first transformed parent or documentElement
	 */
	
	function getFixedPositionOffsetParent(element) {
	  // This check is needed to avoid errors in case one of the elements isn't defined for any reason
	  if (!element || !element.parentElement || isIE()) {
	    return document.documentElement;
	  }
	  var el = element.parentElement;
	  while (el && getStyleComputedProperty(el, 'transform') === 'none') {
	    el = el.parentElement;
	  }
	  return el || document.documentElement;
	}
	
	/**
	 * Computed the boundaries limits and return them
	 * @method
	 * @memberof Popper.Utils
	 * @param {HTMLElement} popper
	 * @param {HTMLElement} reference
	 * @param {number} padding
	 * @param {HTMLElement} boundariesElement - Element used to define the boundaries
	 * @param {Boolean} fixedPosition - Is in fixed position mode
	 * @returns {Object} Coordinates of the boundaries
	 */
	function getBoundaries(popper, reference, padding, boundariesElement) {
	  var fixedPosition = arguments.length > 4 && arguments[4] !== undefined ? arguments[4] : false;
	
	  // NOTE: 1 DOM access here
	
	  var boundaries = { top: 0, left: 0 };
	  var offsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	
	  // Handle viewport case
	  if (boundariesElement === 'viewport') {
	    boundaries = getViewportOffsetRectRelativeToArtbitraryNode(offsetParent, fixedPosition);
	  } else {
	    // Handle other cases based on DOM element used as boundaries
	    var boundariesNode = void 0;
	    if (boundariesElement === 'scrollParent') {
	      boundariesNode = getScrollParent(getParentNode(reference));
	      if (boundariesNode.nodeName === 'BODY') {
	        boundariesNode = popper.ownerDocument.documentElement;
	      }
	    } else if (boundariesElement === 'window') {
	      boundariesNode = popper.ownerDocument.documentElement;
	    } else {
	      boundariesNode = boundariesElement;
	    }
	
	    var offsets = getOffsetRectRelativeToArbitraryNode(boundariesNode, offsetParent, fixedPosition);
	
	    // In case of HTML, we need a different computation
	    if (boundariesNode.nodeName === 'HTML' && !isFixed(offsetParent)) {
	      var _getWindowSizes = getWindowSizes(popper.ownerDocument),
	          height = _getWindowSizes.height,
	          width = _getWindowSizes.width;
	
	      boundaries.top += offsets.top - offsets.marginTop;
	      boundaries.bottom = height + offsets.top;
	      boundaries.left += offsets.left - offsets.marginLeft;
	      boundaries.right = width + offsets.left;
	    } else {
	      // for all the other DOM elements, this one is good
	      boundaries = offsets;
	    }
	  }
	
	  // Add paddings
	  padding = padding || 0;
	  var isPaddingNumber = typeof padding === 'number';
	  boundaries.left += isPaddingNumber ? padding : padding.left || 0;
	  boundaries.top += isPaddingNumber ? padding : padding.top || 0;
	  boundaries.right -= isPaddingNumber ? padding : padding.right || 0;
	  boundaries.bottom -= isPaddingNumber ? padding : padding.bottom || 0;
	
	  return boundaries;
	}
	
	function getArea(_ref) {
	  var width = _ref.width,
	      height = _ref.height;
	
	  return width * height;
	}
	
	/**
	 * Utility used to transform the `auto` placement to the placement with more
	 * available space.
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeAutoPlacement(placement, refRect, popper, reference, boundariesElement) {
	  var padding = arguments.length > 5 && arguments[5] !== undefined ? arguments[5] : 0;
	
	  if (placement.indexOf('auto') === -1) {
	    return placement;
	  }
	
	  var boundaries = getBoundaries(popper, reference, padding, boundariesElement);
	
	  var rects = {
	    top: {
	      width: boundaries.width,
	      height: refRect.top - boundaries.top
	    },
	    right: {
	      width: boundaries.right - refRect.right,
	      height: boundaries.height
	    },
	    bottom: {
	      width: boundaries.width,
	      height: boundaries.bottom - refRect.bottom
	    },
	    left: {
	      width: refRect.left - boundaries.left,
	      height: boundaries.height
	    }
	  };
	
	  var sortedAreas = Object.keys(rects).map(function (key) {
	    return _extends({
	      key: key
	    }, rects[key], {
	      area: getArea(rects[key])
	    });
	  }).sort(function (a, b) {
	    return b.area - a.area;
	  });
	
	  var filteredAreas = sortedAreas.filter(function (_ref2) {
	    var width = _ref2.width,
	        height = _ref2.height;
	    return width >= popper.clientWidth && height >= popper.clientHeight;
	  });
	
	  var computedPlacement = filteredAreas.length > 0 ? filteredAreas[0].key : sortedAreas[0].key;
	
	  var variation = placement.split('-')[1];
	
	  return computedPlacement + (variation ? '-' + variation : '');
	}
	
	/**
	 * Get offsets to the reference element
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} state
	 * @param {Element} popper - the popper element
	 * @param {Element} reference - the reference element (the popper will be relative to this)
	 * @param {Element} fixedPosition - is in fixed position mode
	 * @returns {Object} An object containing the offsets which will be applied to the popper
	 */
	function getReferenceOffsets(state, popper, reference) {
	  var fixedPosition = arguments.length > 3 && arguments[3] !== undefined ? arguments[3] : null;
	
	  var commonOffsetParent = fixedPosition ? getFixedPositionOffsetParent(popper) : findCommonOffsetParent(popper, getReferenceNode(reference));
	  return getOffsetRectRelativeToArbitraryNode(reference, commonOffsetParent, fixedPosition);
	}
	
	/**
	 * Get the outer sizes of the given element (offset size + margins)
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element
	 * @returns {Object} object containing width and height properties
	 */
	function getOuterSizes(element) {
	  var window = element.ownerDocument.defaultView;
	  var styles = window.getComputedStyle(element);
	  var x = parseFloat(styles.marginTop || 0) + parseFloat(styles.marginBottom || 0);
	  var y = parseFloat(styles.marginLeft || 0) + parseFloat(styles.marginRight || 0);
	  var result = {
	    width: element.offsetWidth + y,
	    height: element.offsetHeight + x
	  };
	  return result;
	}
	
	/**
	 * Get the opposite placement of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement
	 * @returns {String} flipped placement
	 */
	function getOppositePlacement(placement) {
	  var hash = { left: 'right', right: 'left', bottom: 'top', top: 'bottom' };
	  return placement.replace(/left|right|bottom|top/g, function (matched) {
	    return hash[matched];
	  });
	}
	
	/**
	 * Get offsets to the popper
	 * @method
	 * @memberof Popper.Utils
	 * @param {Object} position - CSS position the Popper will get applied
	 * @param {HTMLElement} popper - the popper element
	 * @param {Object} referenceOffsets - the reference offsets (the popper will be relative to this)
	 * @param {String} placement - one of the valid placement options
	 * @returns {Object} popperOffsets - An object containing the offsets which will be applied to the popper
	 */
	function getPopperOffsets(popper, referenceOffsets, placement) {
	  placement = placement.split('-')[0];
	
	  // Get popper node sizes
	  var popperRect = getOuterSizes(popper);
	
	  // Add position, width and height to our offsets object
	  var popperOffsets = {
	    width: popperRect.width,
	    height: popperRect.height
	  };
	
	  // depending by the popper placement we have to compute its offsets slightly differently
	  var isHoriz = ['right', 'left'].indexOf(placement) !== -1;
	  var mainSide = isHoriz ? 'top' : 'left';
	  var secondarySide = isHoriz ? 'left' : 'top';
	  var measurement = isHoriz ? 'height' : 'width';
	  var secondaryMeasurement = !isHoriz ? 'height' : 'width';
	
	  popperOffsets[mainSide] = referenceOffsets[mainSide] + referenceOffsets[measurement] / 2 - popperRect[measurement] / 2;
	  if (placement === secondarySide) {
	    popperOffsets[secondarySide] = referenceOffsets[secondarySide] - popperRect[secondaryMeasurement];
	  } else {
	    popperOffsets[secondarySide] = referenceOffsets[getOppositePlacement(secondarySide)];
	  }
	
	  return popperOffsets;
	}
	
	/**
	 * Mimics the `find` method of Array
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function find(arr, check) {
	  // use native find if supported
	  if (Array.prototype.find) {
	    return arr.find(check);
	  }
	
	  // use `filter` to obtain the same behavior of `find`
	  return arr.filter(check)[0];
	}
	
	/**
	 * Return the index of the matching object
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Array} arr
	 * @argument prop
	 * @argument value
	 * @returns index or -1
	 */
	function findIndex(arr, prop, value) {
	  // use native findIndex if supported
	  if (Array.prototype.findIndex) {
	    return arr.findIndex(function (cur) {
	      return cur[prop] === value;
	    });
	  }
	
	  // use `find` + `indexOf` if `findIndex` isn't supported
	  var match = find(arr, function (obj) {
	    return obj[prop] === value;
	  });
	  return arr.indexOf(match);
	}
	
	/**
	 * Loop trough the list of modifiers and run them in order,
	 * each of them will then edit the data object.
	 * @method
	 * @memberof Popper.Utils
	 * @param {dataObject} data
	 * @param {Array} modifiers
	 * @param {String} ends - Optional modifier name used as stopper
	 * @returns {dataObject}
	 */
	function runModifiers(modifiers, data, ends) {
	  var modifiersToRun = ends === undefined ? modifiers : modifiers.slice(0, findIndex(modifiers, 'name', ends));
	
	  modifiersToRun.forEach(function (modifier) {
	    if (modifier['function']) {
	      // eslint-disable-line dot-notation
	      console.warn('`modifier.function` is deprecated, use `modifier.fn`!');
	    }
	    var fn = modifier['function'] || modifier.fn; // eslint-disable-line dot-notation
	    if (modifier.enabled && isFunction(fn)) {
	      // Add properties to offsets to make them a complete clientRect object
	      // we do this before each modifier to make sure the previous one doesn't
	      // mess with these values
	      data.offsets.popper = getClientRect(data.offsets.popper);
	      data.offsets.reference = getClientRect(data.offsets.reference);
	
	      data = fn(data, modifier);
	    }
	  });
	
	  return data;
	}
	
	/**
	 * Updates the position of the popper, computing the new offsets and applying
	 * the new style.<br />
	 * Prefer `scheduleUpdate` over `update` because of performance reasons.
	 * @method
	 * @memberof Popper
	 */
	function update() {
	  // if popper is destroyed, don't perform any further update
	  if (this.state.isDestroyed) {
	    return;
	  }
	
	  var data = {
	    instance: this,
	    styles: {},
	    arrowStyles: {},
	    attributes: {},
	    flipped: false,
	    offsets: {}
	  };
	
	  // compute reference element offsets
	  data.offsets.reference = getReferenceOffsets(this.state, this.popper, this.reference, this.options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  data.placement = computeAutoPlacement(this.options.placement, data.offsets.reference, this.popper, this.reference, this.options.modifiers.flip.boundariesElement, this.options.modifiers.flip.padding);
	
	  // store the computed placement inside `originalPlacement`
	  data.originalPlacement = data.placement;
	
	  data.positionFixed = this.options.positionFixed;
	
	  // compute the popper offsets
	  data.offsets.popper = getPopperOffsets(this.popper, data.offsets.reference, data.placement);
	
	  data.offsets.popper.position = this.options.positionFixed ? 'fixed' : 'absolute';
	
	  // run the modifiers
	  data = runModifiers(this.modifiers, data);
	
	  // the first `update` will call `onCreate` callback
	  // the other ones will call `onUpdate` callback
	  if (!this.state.isCreated) {
	    this.state.isCreated = true;
	    this.options.onCreate(data);
	  } else {
	    this.options.onUpdate(data);
	  }
	}
	
	/**
	 * Helper used to know if the given modifier is enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @returns {Boolean}
	 */
	function isModifierEnabled(modifiers, modifierName) {
	  return modifiers.some(function (_ref) {
	    var name = _ref.name,
	        enabled = _ref.enabled;
	    return enabled && name === modifierName;
	  });
	}
	
	/**
	 * Get the prefixed supported property name
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} property (camelCase)
	 * @returns {String} prefixed property (camelCase or PascalCase, depending on the vendor prefix)
	 */
	function getSupportedPropertyName(property) {
	  var prefixes = [false, 'ms', 'Webkit', 'Moz', 'O'];
	  var upperProp = property.charAt(0).toUpperCase() + property.slice(1);
	
	  for (var i = 0; i < prefixes.length; i++) {
	    var prefix = prefixes[i];
	    var toCheck = prefix ? '' + prefix + upperProp : property;
	    if (typeof document.body.style[toCheck] !== 'undefined') {
	      return toCheck;
	    }
	  }
	  return null;
	}
	
	/**
	 * Destroys the popper.
	 * @method
	 * @memberof Popper
	 */
	function destroy() {
	  this.state.isDestroyed = true;
	
	  // touch DOM only if `applyStyle` modifier is enabled
	  if (isModifierEnabled(this.modifiers, 'applyStyle')) {
	    this.popper.removeAttribute('x-placement');
	    this.popper.style.position = '';
	    this.popper.style.top = '';
	    this.popper.style.left = '';
	    this.popper.style.right = '';
	    this.popper.style.bottom = '';
	    this.popper.style.willChange = '';
	    this.popper.style[getSupportedPropertyName('transform')] = '';
	  }
	
	  this.disableEventListeners();
	
	  // remove the popper if user explicitly asked for the deletion on destroy
	  // do not use `remove` because IE11 doesn't support it
	  if (this.options.removeOnDestroy) {
	    this.popper.parentNode.removeChild(this.popper);
	  }
	  return this;
	}
	
	/**
	 * Get the window associated with the element
	 * @argument {Element} element
	 * @returns {Window}
	 */
	function getWindow(element) {
	  var ownerDocument = element.ownerDocument;
	  return ownerDocument ? ownerDocument.defaultView : window;
	}
	
	function attachToScrollParents(scrollParent, event, callback, scrollParents) {
	  var isBody = scrollParent.nodeName === 'BODY';
	  var target = isBody ? scrollParent.ownerDocument.defaultView : scrollParent;
	  target.addEventListener(event, callback, { passive: true });
	
	  if (!isBody) {
	    attachToScrollParents(getScrollParent(target.parentNode), event, callback, scrollParents);
	  }
	  scrollParents.push(target);
	}
	
	/**
	 * Setup needed event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function setupEventListeners(reference, options, state, updateBound) {
	  // Resize event listener on window
	  state.updateBound = updateBound;
	  getWindow(reference).addEventListener('resize', state.updateBound, { passive: true });
	
	  // Scroll event listener on scroll parents
	  var scrollElement = getScrollParent(reference);
	  attachToScrollParents(scrollElement, 'scroll', state.updateBound, state.scrollParents);
	  state.scrollElement = scrollElement;
	  state.eventsEnabled = true;
	
	  return state;
	}
	
	/**
	 * It will add resize/scroll events and start recalculating
	 * position of the popper element when they are triggered.
	 * @method
	 * @memberof Popper
	 */
	function enableEventListeners() {
	  if (!this.state.eventsEnabled) {
	    this.state = setupEventListeners(this.reference, this.options, this.state, this.scheduleUpdate);
	  }
	}
	
	/**
	 * Remove event listeners used to update the popper position
	 * @method
	 * @memberof Popper.Utils
	 * @private
	 */
	function removeEventListeners(reference, state) {
	  // Remove resize event listener on window
	  getWindow(reference).removeEventListener('resize', state.updateBound);
	
	  // Remove scroll event listener on scroll parents
	  state.scrollParents.forEach(function (target) {
	    target.removeEventListener('scroll', state.updateBound);
	  });
	
	  // Reset state
	  state.updateBound = null;
	  state.scrollParents = [];
	  state.scrollElement = null;
	  state.eventsEnabled = false;
	  return state;
	}
	
	/**
	 * It will remove resize/scroll events and won't recalculate popper position
	 * when they are triggered. It also won't trigger `onUpdate` callback anymore,
	 * unless you call `update` method manually.
	 * @method
	 * @memberof Popper
	 */
	function disableEventListeners() {
	  if (this.state.eventsEnabled) {
	    cancelAnimationFrame(this.scheduleUpdate);
	    this.state = removeEventListeners(this.reference, this.state);
	  }
	}
	
	/**
	 * Tells if a given input is a number
	 * @method
	 * @memberof Popper.Utils
	 * @param {*} input to check
	 * @return {Boolean}
	 */
	function isNumeric(n) {
	  return n !== '' && !isNaN(parseFloat(n)) && isFinite(n);
	}
	
	/**
	 * Set the style to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the style to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setStyles(element, styles) {
	  Object.keys(styles).forEach(function (prop) {
	    var unit = '';
	    // add unit if the value is numeric and is one of the following
	    if (['width', 'height', 'top', 'right', 'bottom', 'left'].indexOf(prop) !== -1 && isNumeric(styles[prop])) {
	      unit = 'px';
	    }
	    element.style[prop] = styles[prop] + unit;
	  });
	}
	
	/**
	 * Set the attributes to the given popper
	 * @method
	 * @memberof Popper.Utils
	 * @argument {Element} element - Element to apply the attributes to
	 * @argument {Object} styles
	 * Object with a list of properties and values which will be applied to the element
	 */
	function setAttributes(element, attributes) {
	  Object.keys(attributes).forEach(function (prop) {
	    var value = attributes[prop];
	    if (value !== false) {
	      element.setAttribute(prop, attributes[prop]);
	    } else {
	      element.removeAttribute(prop);
	    }
	  });
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} data.styles - List of style properties - values to apply to popper element
	 * @argument {Object} data.attributes - List of attribute properties - values to apply to popper element
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The same data object
	 */
	function applyStyle(data) {
	  // any property present in `data.styles` will be applied to the popper,
	  // in this way we can make the 3rd party modifiers add custom styles to it
	  // Be aware, modifiers could override the properties defined in the previous
	  // lines of this modifier!
	  setStyles(data.instance.popper, data.styles);
	
	  // any property present in `data.attributes` will be applied to the popper,
	  // they will be set as HTML attributes of the element
	  setAttributes(data.instance.popper, data.attributes);
	
	  // if arrowElement is defined and arrowStyles has some properties
	  if (data.arrowElement && Object.keys(data.arrowStyles).length) {
	    setStyles(data.arrowElement, data.arrowStyles);
	  }
	
	  return data;
	}
	
	/**
	 * Set the x-placement attribute before everything else because it could be used
	 * to add margins to the popper margins needs to be calculated to get the
	 * correct popper offsets.
	 * @method
	 * @memberof Popper.modifiers
	 * @param {HTMLElement} reference - The reference element used to position the popper
	 * @param {HTMLElement} popper - The HTML element used as popper
	 * @param {Object} options - Popper.js options
	 */
	function applyStyleOnLoad(reference, popper, options, modifierOptions, state) {
	  // compute reference element offsets
	  var referenceOffsets = getReferenceOffsets(state, popper, reference, options.positionFixed);
	
	  // compute auto placement, store placement inside the data object,
	  // modifiers will be able to edit `placement` if needed
	  // and refer to originalPlacement to know the original value
	  var placement = computeAutoPlacement(options.placement, referenceOffsets, popper, reference, options.modifiers.flip.boundariesElement, options.modifiers.flip.padding);
	
	  popper.setAttribute('x-placement', placement);
	
	  // Apply `position` to popper before anything else because
	  // without the position applied we can't guarantee correct computations
	  setStyles(popper, { position: options.positionFixed ? 'fixed' : 'absolute' });
	
	  return options;
	}
	
	/**
	 * @function
	 * @memberof Popper.Utils
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Boolean} shouldRound - If the offsets should be rounded at all
	 * @returns {Object} The popper's position offsets rounded
	 *
	 * The tale of pixel-perfect positioning. It's still not 100% perfect, but as
	 * good as it can be within reason.
	 * Discussion here: https://github.com/FezVrasta/popper.js/pull/715
	 *
	 * Low DPI screens cause a popper to be blurry if not using full pixels (Safari
	 * as well on High DPI screens).
	 *
	 * Firefox prefers no rounding for positioning and does not have blurriness on
	 * high DPI screens.
	 *
	 * Only horizontal placement and left/right values need to be considered.
	 */
	function getRoundedOffsets(data, shouldRound) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	  var round = Math.round,
	      floor = Math.floor;
	
	  var noRound = function noRound(v) {
	    return v;
	  };
	
	  var referenceWidth = round(reference.width);
	  var popperWidth = round(popper.width);
	
	  var isVertical = ['left', 'right'].indexOf(data.placement) !== -1;
	  var isVariation = data.placement.indexOf('-') !== -1;
	  var sameWidthParity = referenceWidth % 2 === popperWidth % 2;
	  var bothOddWidth = referenceWidth % 2 === 1 && popperWidth % 2 === 1;
	
	  var horizontalToInteger = !shouldRound ? noRound : isVertical || isVariation || sameWidthParity ? round : floor;
	  var verticalToInteger = !shouldRound ? noRound : round;
	
	  return {
	    left: horizontalToInteger(bothOddWidth && !isVariation && shouldRound ? popper.left - 1 : popper.left),
	    top: verticalToInteger(popper.top),
	    bottom: verticalToInteger(popper.bottom),
	    right: horizontalToInteger(popper.right)
	  };
	}
	
	var isFirefox = isBrowser && /Firefox/i.test(navigator.userAgent);
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function computeStyle(data, options) {
	  var x = options.x,
	      y = options.y;
	  var popper = data.offsets.popper;
	
	  // Remove this legacy support in Popper.js v2
	
	  var legacyGpuAccelerationOption = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'applyStyle';
	  }).gpuAcceleration;
	  if (legacyGpuAccelerationOption !== undefined) {
	    console.warn('WARNING: `gpuAcceleration` option moved to `computeStyle` modifier and will not be supported in future versions of Popper.js!');
	  }
	  var gpuAcceleration = legacyGpuAccelerationOption !== undefined ? legacyGpuAccelerationOption : options.gpuAcceleration;
	
	  var offsetParent = getOffsetParent(data.instance.popper);
	  var offsetParentRect = getBoundingClientRect(offsetParent);
	
	  // Styles
	  var styles = {
	    position: popper.position
	  };
	
	  var offsets = getRoundedOffsets(data, window.devicePixelRatio < 2 || !isFirefox);
	
	  var sideA = x === 'bottom' ? 'top' : 'bottom';
	  var sideB = y === 'right' ? 'left' : 'right';
	
	  // if gpuAcceleration is set to `true` and transform is supported,
	  //  we use `translate3d` to apply the position to the popper we
	  // automatically use the supported prefixed version if needed
	  var prefixedProperty = getSupportedPropertyName('transform');
	
	  // now, let's make a step back and look at this code closely (wtf?)
	  // If the content of the popper grows once it's been positioned, it
	  // may happen that the popper gets misplaced because of the new content
	  // overflowing its reference element
	  // To avoid this problem, we provide two options (x and y), which allow
	  // the consumer to define the offset origin.
	  // If we position a popper on top of a reference element, we can set
	  // `x` to `top` to make the popper grow towards its top instead of
	  // its bottom.
	  var left = void 0,
	      top = void 0;
	  if (sideA === 'bottom') {
	    // when offsetParent is <html> the positioning is relative to the bottom of the screen (excluding the scrollbar)
	    // and not the bottom of the html element
	    if (offsetParent.nodeName === 'HTML') {
	      top = -offsetParent.clientHeight + offsets.bottom;
	    } else {
	      top = -offsetParentRect.height + offsets.bottom;
	    }
	  } else {
	    top = offsets.top;
	  }
	  if (sideB === 'right') {
	    if (offsetParent.nodeName === 'HTML') {
	      left = -offsetParent.clientWidth + offsets.right;
	    } else {
	      left = -offsetParentRect.width + offsets.right;
	    }
	  } else {
	    left = offsets.left;
	  }
	  if (gpuAcceleration && prefixedProperty) {
	    styles[prefixedProperty] = 'translate3d(' + left + 'px, ' + top + 'px, 0)';
	    styles[sideA] = 0;
	    styles[sideB] = 0;
	    styles.willChange = 'transform';
	  } else {
	    // othwerise, we use the standard `top`, `left`, `bottom` and `right` properties
	    var invertTop = sideA === 'bottom' ? -1 : 1;
	    var invertLeft = sideB === 'right' ? -1 : 1;
	    styles[sideA] = top * invertTop;
	    styles[sideB] = left * invertLeft;
	    styles.willChange = sideA + ', ' + sideB;
	  }
	
	  // Attributes
	  var attributes = {
	    'x-placement': data.placement
	  };
	
	  // Update `data` attributes, styles and arrowStyles
	  data.attributes = _extends({}, attributes, data.attributes);
	  data.styles = _extends({}, styles, data.styles);
	  data.arrowStyles = _extends({}, data.offsets.arrow, data.arrowStyles);
	
	  return data;
	}
	
	/**
	 * Helper used to know if the given modifier depends from another one.<br />
	 * It checks if the needed modifier is listed and enabled.
	 * @method
	 * @memberof Popper.Utils
	 * @param {Array} modifiers - list of modifiers
	 * @param {String} requestingName - name of requesting modifier
	 * @param {String} requestedName - name of requested modifier
	 * @returns {Boolean}
	 */
	function isModifierRequired(modifiers, requestingName, requestedName) {
	  var requesting = find(modifiers, function (_ref) {
	    var name = _ref.name;
	    return name === requestingName;
	  });
	
	  var isRequired = !!requesting && modifiers.some(function (modifier) {
	    return modifier.name === requestedName && modifier.enabled && modifier.order < requesting.order;
	  });
	
	  if (!isRequired) {
	    var _requesting = '`' + requestingName + '`';
	    var requested = '`' + requestedName + '`';
	    console.warn(requested + ' modifier is required by ' + _requesting + ' modifier in order to work, be sure to include it before ' + _requesting + '!');
	  }
	  return isRequired;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function arrow(data, options) {
	  var _data$offsets$arrow;
	
	  // arrow depends on keepTogether in order to work
	  if (!isModifierRequired(data.instance.modifiers, 'arrow', 'keepTogether')) {
	    return data;
	  }
	
	  var arrowElement = options.element;
	
	  // if arrowElement is a string, suppose it's a CSS selector
	  if (typeof arrowElement === 'string') {
	    arrowElement = data.instance.popper.querySelector(arrowElement);
	
	    // if arrowElement is not found, don't run the modifier
	    if (!arrowElement) {
	      return data;
	    }
	  } else {
	    // if the arrowElement isn't a query selector we must check that the
	    // provided DOM node is child of its popper node
	    if (!data.instance.popper.contains(arrowElement)) {
	      console.warn('WARNING: `arrow.element` must be child of its popper element!');
	      return data;
	    }
	  }
	
	  var placement = data.placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isVertical = ['left', 'right'].indexOf(placement) !== -1;
	
	  var len = isVertical ? 'height' : 'width';
	  var sideCapitalized = isVertical ? 'Top' : 'Left';
	  var side = sideCapitalized.toLowerCase();
	  var altSide = isVertical ? 'left' : 'top';
	  var opSide = isVertical ? 'bottom' : 'right';
	  var arrowElementSize = getOuterSizes(arrowElement)[len];
	
	  //
	  // extends keepTogether behavior making sure the popper and its
	  // reference have enough pixels in conjunction
	  //
	
	  // top/left side
	  if (reference[opSide] - arrowElementSize < popper[side]) {
	    data.offsets.popper[side] -= popper[side] - (reference[opSide] - arrowElementSize);
	  }
	  // bottom/right side
	  if (reference[side] + arrowElementSize > popper[opSide]) {
	    data.offsets.popper[side] += reference[side] + arrowElementSize - popper[opSide];
	  }
	  data.offsets.popper = getClientRect(data.offsets.popper);
	
	  // compute center of the popper
	  var center = reference[side] + reference[len] / 2 - arrowElementSize / 2;
	
	  // Compute the sideValue using the updated popper offsets
	  // take popper margin in account because we don't have this info available
	  var css = getStyleComputedProperty(data.instance.popper);
	  var popperMarginSide = parseFloat(css['margin' + sideCapitalized]);
	  var popperBorderSide = parseFloat(css['border' + sideCapitalized + 'Width']);
	  var sideValue = center - data.offsets.popper[side] - popperMarginSide - popperBorderSide;
	
	  // prevent arrowElement from being placed not contiguously to its popper
	  sideValue = Math.max(Math.min(popper[len] - arrowElementSize, sideValue), 0);
	
	  data.arrowElement = arrowElement;
	  data.offsets.arrow = (_data$offsets$arrow = {}, defineProperty(_data$offsets$arrow, side, Math.round(sideValue)), defineProperty(_data$offsets$arrow, altSide, ''), _data$offsets$arrow);
	
	  return data;
	}
	
	/**
	 * Get the opposite placement variation of the given one
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement variation
	 * @returns {String} flipped placement variation
	 */
	function getOppositeVariation(variation) {
	  if (variation === 'end') {
	    return 'start';
	  } else if (variation === 'start') {
	    return 'end';
	  }
	  return variation;
	}
	
	/**
	 * List of accepted placements to use as values of the `placement` option.<br />
	 * Valid placements are:
	 * - `auto`
	 * - `top`
	 * - `right`
	 * - `bottom`
	 * - `left`
	 *
	 * Each placement can have a variation from this list:
	 * - `-start`
	 * - `-end`
	 *
	 * Variations are interpreted easily if you think of them as the left to right
	 * written languages. Horizontally (`top` and `bottom`), `start` is left and `end`
	 * is right.<br />
	 * Vertically (`left` and `right`), `start` is top and `end` is bottom.
	 *
	 * Some valid examples are:
	 * - `top-end` (on top of reference, right aligned)
	 * - `right-start` (on right of reference, top aligned)
	 * - `bottom` (on bottom, centered)
	 * - `auto-end` (on the side with more space available, alignment depends by placement)
	 *
	 * @static
	 * @type {Array}
	 * @enum {String}
	 * @readonly
	 * @method placements
	 * @memberof Popper
	 */
	var placements = ['auto-start', 'auto', 'auto-end', 'top-start', 'top', 'top-end', 'right-start', 'right', 'right-end', 'bottom-end', 'bottom', 'bottom-start', 'left-end', 'left', 'left-start'];
	
	// Get rid of `auto` `auto-start` and `auto-end`
	var validPlacements = placements.slice(3);
	
	/**
	 * Given an initial placement, returns all the subsequent placements
	 * clockwise (or counter-clockwise).
	 *
	 * @method
	 * @memberof Popper.Utils
	 * @argument {String} placement - A valid placement (it accepts variations)
	 * @argument {Boolean} counter - Set to true to walk the placements counterclockwise
	 * @returns {Array} placements including their variations
	 */
	function clockwise(placement) {
	  var counter = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : false;
	
	  var index = validPlacements.indexOf(placement);
	  var arr = validPlacements.slice(index + 1).concat(validPlacements.slice(0, index));
	  return counter ? arr.reverse() : arr;
	}
	
	var BEHAVIORS = {
	  FLIP: 'flip',
	  CLOCKWISE: 'clockwise',
	  COUNTERCLOCKWISE: 'counterclockwise'
	};
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function flip(data, options) {
	  // if `inner` modifier is enabled, we can't use the `flip` modifier
	  if (isModifierEnabled(data.instance.modifiers, 'inner')) {
	    return data;
	  }
	
	  if (data.flipped && data.placement === data.originalPlacement) {
	    // seems like flip is trying to loop, probably there's not enough space on any of the flippable sides
	    return data;
	  }
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, options.boundariesElement, data.positionFixed);
	
	  var placement = data.placement.split('-')[0];
	  var placementOpposite = getOppositePlacement(placement);
	  var variation = data.placement.split('-')[1] || '';
	
	  var flipOrder = [];
	
	  switch (options.behavior) {
	    case BEHAVIORS.FLIP:
	      flipOrder = [placement, placementOpposite];
	      break;
	    case BEHAVIORS.CLOCKWISE:
	      flipOrder = clockwise(placement);
	      break;
	    case BEHAVIORS.COUNTERCLOCKWISE:
	      flipOrder = clockwise(placement, true);
	      break;
	    default:
	      flipOrder = options.behavior;
	  }
	
	  flipOrder.forEach(function (step, index) {
	    if (placement !== step || flipOrder.length === index + 1) {
	      return data;
	    }
	
	    placement = data.placement.split('-')[0];
	    placementOpposite = getOppositePlacement(placement);
	
	    var popperOffsets = data.offsets.popper;
	    var refOffsets = data.offsets.reference;
	
	    // using floor because the reference offsets may contain decimals we are not going to consider here
	    var floor = Math.floor;
	    var overlapsRef = placement === 'left' && floor(popperOffsets.right) > floor(refOffsets.left) || placement === 'right' && floor(popperOffsets.left) < floor(refOffsets.right) || placement === 'top' && floor(popperOffsets.bottom) > floor(refOffsets.top) || placement === 'bottom' && floor(popperOffsets.top) < floor(refOffsets.bottom);
	
	    var overflowsLeft = floor(popperOffsets.left) < floor(boundaries.left);
	    var overflowsRight = floor(popperOffsets.right) > floor(boundaries.right);
	    var overflowsTop = floor(popperOffsets.top) < floor(boundaries.top);
	    var overflowsBottom = floor(popperOffsets.bottom) > floor(boundaries.bottom);
	
	    var overflowsBoundaries = placement === 'left' && overflowsLeft || placement === 'right' && overflowsRight || placement === 'top' && overflowsTop || placement === 'bottom' && overflowsBottom;
	
	    // flip the variation if required
	    var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	
	    // flips variation if reference element overflows boundaries
	    var flippedVariationByRef = !!options.flipVariations && (isVertical && variation === 'start' && overflowsLeft || isVertical && variation === 'end' && overflowsRight || !isVertical && variation === 'start' && overflowsTop || !isVertical && variation === 'end' && overflowsBottom);
	
	    // flips variation if popper content overflows boundaries
	    var flippedVariationByContent = !!options.flipVariationsByContent && (isVertical && variation === 'start' && overflowsRight || isVertical && variation === 'end' && overflowsLeft || !isVertical && variation === 'start' && overflowsBottom || !isVertical && variation === 'end' && overflowsTop);
	
	    var flippedVariation = flippedVariationByRef || flippedVariationByContent;
	
	    if (overlapsRef || overflowsBoundaries || flippedVariation) {
	      // this boolean to detect any flip loop
	      data.flipped = true;
	
	      if (overlapsRef || overflowsBoundaries) {
	        placement = flipOrder[index + 1];
	      }
	
	      if (flippedVariation) {
	        variation = getOppositeVariation(variation);
	      }
	
	      data.placement = placement + (variation ? '-' + variation : '');
	
	      // this object contains `position`, we want to preserve it along with
	      // any additional property we may add in the future
	      data.offsets.popper = _extends({}, data.offsets.popper, getPopperOffsets(data.instance.popper, data.offsets.reference, data.placement));
	
	      data = runModifiers(data.instance.modifiers, data, 'flip');
	    }
	  });
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function keepTogether(data) {
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var placement = data.placement.split('-')[0];
	  var floor = Math.floor;
	  var isVertical = ['top', 'bottom'].indexOf(placement) !== -1;
	  var side = isVertical ? 'right' : 'bottom';
	  var opSide = isVertical ? 'left' : 'top';
	  var measurement = isVertical ? 'width' : 'height';
	
	  if (popper[side] < floor(reference[opSide])) {
	    data.offsets.popper[opSide] = floor(reference[opSide]) - popper[measurement];
	  }
	  if (popper[opSide] > floor(reference[side])) {
	    data.offsets.popper[opSide] = floor(reference[side]);
	  }
	
	  return data;
	}
	
	/**
	 * Converts a string containing value + unit into a px value number
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} str - Value + unit string
	 * @argument {String} measurement - `height` or `width`
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @returns {Number|String}
	 * Value in pixels, or original string if no values were extracted
	 */
	function toValue(str, measurement, popperOffsets, referenceOffsets) {
	  // separate value from unit
	  var split = str.match(/((?:\-|\+)?\d*\.?\d*)(.*)/);
	  var value = +split[1];
	  var unit = split[2];
	
	  // If it's not a number it's an operator, I guess
	  if (!value) {
	    return str;
	  }
	
	  if (unit.indexOf('%') === 0) {
	    var element = void 0;
	    switch (unit) {
	      case '%p':
	        element = popperOffsets;
	        break;
	      case '%':
	      case '%r':
	      default:
	        element = referenceOffsets;
	    }
	
	    var rect = getClientRect(element);
	    return rect[measurement] / 100 * value;
	  } else if (unit === 'vh' || unit === 'vw') {
	    // if is a vh or vw, we calculate the size based on the viewport
	    var size = void 0;
	    if (unit === 'vh') {
	      size = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
	    } else {
	      size = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
	    }
	    return size / 100 * value;
	  } else {
	    // if is an explicit pixel unit, we get rid of the unit and keep the value
	    // if is an implicit unit, it's px, and we return just the value
	    return value;
	  }
	}
	
	/**
	 * Parse an `offset` string to extrapolate `x` and `y` numeric offsets.
	 * @function
	 * @memberof {modifiers~offset}
	 * @private
	 * @argument {String} offset
	 * @argument {Object} popperOffsets
	 * @argument {Object} referenceOffsets
	 * @argument {String} basePlacement
	 * @returns {Array} a two cells array with x and y offsets in numbers
	 */
	function parseOffset(offset, popperOffsets, referenceOffsets, basePlacement) {
	  var offsets = [0, 0];
	
	  // Use height if placement is left or right and index is 0 otherwise use width
	  // in this way the first offset will use an axis and the second one
	  // will use the other one
	  var useHeight = ['right', 'left'].indexOf(basePlacement) !== -1;
	
	  // Split the offset string to obtain a list of values and operands
	  // The regex addresses values with the plus or minus sign in front (+10, -20, etc)
	  var fragments = offset.split(/(\+|\-)/).map(function (frag) {
	    return frag.trim();
	  });
	
	  // Detect if the offset string contains a pair of values or a single one
	  // they could be separated by comma or space
	  var divider = fragments.indexOf(find(fragments, function (frag) {
	    return frag.search(/,|\s/) !== -1;
	  }));
	
	  if (fragments[divider] && fragments[divider].indexOf(',') === -1) {
	    console.warn('Offsets separated by white space(s) are deprecated, use a comma (,) instead.');
	  }
	
	  // If divider is found, we divide the list of values and operands to divide
	  // them by ofset X and Y.
	  var splitRegex = /\s*,\s*|\s+/;
	  var ops = divider !== -1 ? [fragments.slice(0, divider).concat([fragments[divider].split(splitRegex)[0]]), [fragments[divider].split(splitRegex)[1]].concat(fragments.slice(divider + 1))] : [fragments];
	
	  // Convert the values with units to absolute pixels to allow our computations
	  ops = ops.map(function (op, index) {
	    // Most of the units rely on the orientation of the popper
	    var measurement = (index === 1 ? !useHeight : useHeight) ? 'height' : 'width';
	    var mergeWithPrevious = false;
	    return op
	    // This aggregates any `+` or `-` sign that aren't considered operators
	    // e.g.: 10 + +5 => [10, +, +5]
	    .reduce(function (a, b) {
	      if (a[a.length - 1] === '' && ['+', '-'].indexOf(b) !== -1) {
	        a[a.length - 1] = b;
	        mergeWithPrevious = true;
	        return a;
	      } else if (mergeWithPrevious) {
	        a[a.length - 1] += b;
	        mergeWithPrevious = false;
	        return a;
	      } else {
	        return a.concat(b);
	      }
	    }, [])
	    // Here we convert the string values into number values (in px)
	    .map(function (str) {
	      return toValue(str, measurement, popperOffsets, referenceOffsets);
	    });
	  });
	
	  // Loop trough the offsets arrays and execute the operations
	  ops.forEach(function (op, index) {
	    op.forEach(function (frag, index2) {
	      if (isNumeric(frag)) {
	        offsets[index] += frag * (op[index2 - 1] === '-' ? -1 : 1);
	      }
	    });
	  });
	  return offsets;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @argument {Number|String} options.offset=0
	 * The offset value as described in the modifier description
	 * @returns {Object} The data object, properly modified
	 */
	function offset(data, _ref) {
	  var offset = _ref.offset;
	  var placement = data.placement,
	      _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var basePlacement = placement.split('-')[0];
	
	  var offsets = void 0;
	  if (isNumeric(+offset)) {
	    offsets = [+offset, 0];
	  } else {
	    offsets = parseOffset(offset, popper, reference, basePlacement);
	  }
	
	  if (basePlacement === 'left') {
	    popper.top += offsets[0];
	    popper.left -= offsets[1];
	  } else if (basePlacement === 'right') {
	    popper.top += offsets[0];
	    popper.left += offsets[1];
	  } else if (basePlacement === 'top') {
	    popper.left += offsets[0];
	    popper.top -= offsets[1];
	  } else if (basePlacement === 'bottom') {
	    popper.left += offsets[0];
	    popper.top += offsets[1];
	  }
	
	  data.popper = popper;
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function preventOverflow(data, options) {
	  var boundariesElement = options.boundariesElement || getOffsetParent(data.instance.popper);
	
	  // If offsetParent is the reference element, we really want to
	  // go one step up and use the next offsetParent as reference to
	  // avoid to make this modifier completely useless and look like broken
	  if (data.instance.reference === boundariesElement) {
	    boundariesElement = getOffsetParent(boundariesElement);
	  }
	
	  // NOTE: DOM access here
	  // resets the popper's position so that the document size can be calculated excluding
	  // the size of the popper element itself
	  var transformProp = getSupportedPropertyName('transform');
	  var popperStyles = data.instance.popper.style; // assignment to help minification
	  var top = popperStyles.top,
	      left = popperStyles.left,
	      transform = popperStyles[transformProp];
	
	  popperStyles.top = '';
	  popperStyles.left = '';
	  popperStyles[transformProp] = '';
	
	  var boundaries = getBoundaries(data.instance.popper, data.instance.reference, options.padding, boundariesElement, data.positionFixed);
	
	  // NOTE: DOM access here
	  // restores the original style properties after the offsets have been computed
	  popperStyles.top = top;
	  popperStyles.left = left;
	  popperStyles[transformProp] = transform;
	
	  options.boundaries = boundaries;
	
	  var order = options.priority;
	  var popper = data.offsets.popper;
	
	  var check = {
	    primary: function primary(placement) {
	      var value = popper[placement];
	      if (popper[placement] < boundaries[placement] && !options.escapeWithReference) {
	        value = Math.max(popper[placement], boundaries[placement]);
	      }
	      return defineProperty({}, placement, value);
	    },
	    secondary: function secondary(placement) {
	      var mainSide = placement === 'right' ? 'left' : 'top';
	      var value = popper[mainSide];
	      if (popper[placement] > boundaries[placement] && !options.escapeWithReference) {
	        value = Math.min(popper[mainSide], boundaries[placement] - (placement === 'right' ? popper.width : popper.height));
	      }
	      return defineProperty({}, mainSide, value);
	    }
	  };
	
	  order.forEach(function (placement) {
	    var side = ['left', 'top'].indexOf(placement) !== -1 ? 'primary' : 'secondary';
	    popper = _extends({}, popper, check[side](placement));
	  });
	
	  data.offsets.popper = popper;
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function shift(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var shiftvariation = placement.split('-')[1];
	
	  // if shift shiftvariation is specified, run the modifier
	  if (shiftvariation) {
	    var _data$offsets = data.offsets,
	        reference = _data$offsets.reference,
	        popper = _data$offsets.popper;
	
	    var isVertical = ['bottom', 'top'].indexOf(basePlacement) !== -1;
	    var side = isVertical ? 'left' : 'top';
	    var measurement = isVertical ? 'width' : 'height';
	
	    var shiftOffsets = {
	      start: defineProperty({}, side, reference[side]),
	      end: defineProperty({}, side, reference[side] + reference[measurement] - popper[measurement])
	    };
	
	    data.offsets.popper = _extends({}, popper, shiftOffsets[shiftvariation]);
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by update method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function hide(data) {
	  if (!isModifierRequired(data.instance.modifiers, 'hide', 'preventOverflow')) {
	    return data;
	  }
	
	  var refRect = data.offsets.reference;
	  var bound = find(data.instance.modifiers, function (modifier) {
	    return modifier.name === 'preventOverflow';
	  }).boundaries;
	
	  if (refRect.bottom < bound.top || refRect.left > bound.right || refRect.top > bound.bottom || refRect.right < bound.left) {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === true) {
	      return data;
	    }
	
	    data.hide = true;
	    data.attributes['x-out-of-boundaries'] = '';
	  } else {
	    // Avoid unnecessary DOM access if visibility hasn't changed
	    if (data.hide === false) {
	      return data;
	    }
	
	    data.hide = false;
	    data.attributes['x-out-of-boundaries'] = false;
	  }
	
	  return data;
	}
	
	/**
	 * @function
	 * @memberof Modifiers
	 * @argument {Object} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {Object} The data object, properly modified
	 */
	function inner(data) {
	  var placement = data.placement;
	  var basePlacement = placement.split('-')[0];
	  var _data$offsets = data.offsets,
	      popper = _data$offsets.popper,
	      reference = _data$offsets.reference;
	
	  var isHoriz = ['left', 'right'].indexOf(basePlacement) !== -1;
	
	  var subtractLength = ['top', 'left'].indexOf(basePlacement) === -1;
	
	  popper[isHoriz ? 'left' : 'top'] = reference[basePlacement] - (subtractLength ? popper[isHoriz ? 'width' : 'height'] : 0);
	
	  data.placement = getOppositePlacement(placement);
	  data.offsets.popper = getClientRect(popper);
	
	  return data;
	}
	
	/**
	 * Modifier function, each modifier can have a function of this type assigned
	 * to its `fn` property.<br />
	 * These functions will be called on each update, this means that you must
	 * make sure they are performant enough to avoid performance bottlenecks.
	 *
	 * @function ModifierFn
	 * @argument {dataObject} data - The data object generated by `update` method
	 * @argument {Object} options - Modifiers configuration and options
	 * @returns {dataObject} The data object, properly modified
	 */
	
	/**
	 * Modifiers are plugins used to alter the behavior of your poppers.<br />
	 * Popper.js uses a set of 9 modifiers to provide all the basic functionalities
	 * needed by the library.
	 *
	 * Usually you don't want to override the `order`, `fn` and `onLoad` props.
	 * All the other properties are configurations that could be tweaked.
	 * @namespace modifiers
	 */
	var modifiers = {
	  /**
	   * Modifier used to shift the popper on the start or end of its reference
	   * element.<br />
	   * It will read the variation of the `placement` property.<br />
	   * It can be one either `-end` or `-start`.
	   * @memberof modifiers
	   * @inner
	   */
	  shift: {
	    /** @prop {number} order=100 - Index used to define the order of execution */
	    order: 100,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: shift
	  },
	
	  /**
	   * The `offset` modifier can shift your popper on both its axis.
	   *
	   * It accepts the following units:
	   * - `px` or unit-less, interpreted as pixels
	   * - `%` or `%r`, percentage relative to the length of the reference element
	   * - `%p`, percentage relative to the length of the popper element
	   * - `vw`, CSS viewport width unit
	   * - `vh`, CSS viewport height unit
	   *
	   * For length is intended the main axis relative to the placement of the popper.<br />
	   * This means that if the placement is `top` or `bottom`, the length will be the
	   * `width`. In case of `left` or `right`, it will be the `height`.
	   *
	   * You can provide a single value (as `Number` or `String`), or a pair of values
	   * as `String` divided by a comma or one (or more) white spaces.<br />
	   * The latter is a deprecated method because it leads to confusion and will be
	   * removed in v2.<br />
	   * Additionally, it accepts additions and subtractions between different units.
	   * Note that multiplications and divisions aren't supported.
	   *
	   * Valid examples are:
	   * ```
	   * 10
	   * '10%'
	   * '10, 10'
	   * '10%, 10'
	   * '10 + 10%'
	   * '10 - 5vh + 3%'
	   * '-10px + 5vh, 5px - 6%'
	   * ```
	   * > **NB**: If you desire to apply offsets to your poppers in a way that may make them overlap
	   * > with their reference element, unfortunately, you will have to disable the `flip` modifier.
	   * > You can read more on this at this [issue](https://github.com/FezVrasta/popper.js/issues/373).
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  offset: {
	    /** @prop {number} order=200 - Index used to define the order of execution */
	    order: 200,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: offset,
	    /** @prop {Number|String} offset=0
	     * The offset value as described in the modifier description
	     */
	    offset: 0
	  },
	
	  /**
	   * Modifier used to prevent the popper from being positioned outside the boundary.
	   *
	   * A scenario exists where the reference itself is not within the boundaries.<br />
	   * We can say it has "escaped the boundaries" — or just "escaped".<br />
	   * In this case we need to decide whether the popper should either:
	   *
	   * - detach from the reference and remain "trapped" in the boundaries, or
	   * - if it should ignore the boundary and "escape with its reference"
	   *
	   * When `escapeWithReference` is set to`true` and reference is completely
	   * outside its boundaries, the popper will overflow (or completely leave)
	   * the boundaries in order to remain attached to the edge of the reference.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  preventOverflow: {
	    /** @prop {number} order=300 - Index used to define the order of execution */
	    order: 300,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: preventOverflow,
	    /**
	     * @prop {Array} [priority=['left','right','top','bottom']]
	     * Popper will try to prevent overflow following these priorities by default,
	     * then, it could overflow on the left and on top of the `boundariesElement`
	     */
	    priority: ['left', 'right', 'top', 'bottom'],
	    /**
	     * @prop {number} padding=5
	     * Amount of pixel used to define a minimum distance between the boundaries
	     * and the popper. This makes sure the popper always has a little padding
	     * between the edges of its container
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='scrollParent'
	     * Boundaries used by the modifier. Can be `scrollParent`, `window`,
	     * `viewport` or any DOM element.
	     */
	    boundariesElement: 'scrollParent'
	  },
	
	  /**
	   * Modifier used to make sure the reference and its popper stay near each other
	   * without leaving any gap between the two. Especially useful when the arrow is
	   * enabled and you want to ensure that it points to its reference element.
	   * It cares only about the first axis. You can still have poppers with margin
	   * between the popper and its reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  keepTogether: {
	    /** @prop {number} order=400 - Index used to define the order of execution */
	    order: 400,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: keepTogether
	  },
	
	  /**
	   * This modifier is used to move the `arrowElement` of the popper to make
	   * sure it is positioned between the reference element and its popper element.
	   * It will read the outer size of the `arrowElement` node to detect how many
	   * pixels of conjunction are needed.
	   *
	   * It has no effect if no `arrowElement` is provided.
	   * @memberof modifiers
	   * @inner
	   */
	  arrow: {
	    /** @prop {number} order=500 - Index used to define the order of execution */
	    order: 500,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: arrow,
	    /** @prop {String|HTMLElement} element='[x-arrow]' - Selector or node used as arrow */
	    element: '[x-arrow]'
	  },
	
	  /**
	   * Modifier used to flip the popper's placement when it starts to overlap its
	   * reference element.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   *
	   * **NOTE:** this modifier will interrupt the current update cycle and will
	   * restart it if it detects the need to flip the placement.
	   * @memberof modifiers
	   * @inner
	   */
	  flip: {
	    /** @prop {number} order=600 - Index used to define the order of execution */
	    order: 600,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: flip,
	    /**
	     * @prop {String|Array} behavior='flip'
	     * The behavior used to change the popper's placement. It can be one of
	     * `flip`, `clockwise`, `counterclockwise` or an array with a list of valid
	     * placements (with optional variations)
	     */
	    behavior: 'flip',
	    /**
	     * @prop {number} padding=5
	     * The popper will flip if it hits the edges of the `boundariesElement`
	     */
	    padding: 5,
	    /**
	     * @prop {String|HTMLElement} boundariesElement='viewport'
	     * The element which will define the boundaries of the popper position.
	     * The popper will never be placed outside of the defined boundaries
	     * (except if `keepTogether` is enabled)
	     */
	    boundariesElement: 'viewport',
	    /**
	     * @prop {Boolean} flipVariations=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the reference element overlaps its boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariations: false,
	    /**
	     * @prop {Boolean} flipVariationsByContent=false
	     * The popper will switch placement variation between `-start` and `-end` when
	     * the popper element overlaps its reference boundaries.
	     *
	     * The original placement should have a set variation.
	     */
	    flipVariationsByContent: false
	  },
	
	  /**
	   * Modifier used to make the popper flow toward the inner of the reference element.
	   * By default, when this modifier is disabled, the popper will be placed outside
	   * the reference element.
	   * @memberof modifiers
	   * @inner
	   */
	  inner: {
	    /** @prop {number} order=700 - Index used to define the order of execution */
	    order: 700,
	    /** @prop {Boolean} enabled=false - Whether the modifier is enabled or not */
	    enabled: false,
	    /** @prop {ModifierFn} */
	    fn: inner
	  },
	
	  /**
	   * Modifier used to hide the popper when its reference element is outside of the
	   * popper boundaries. It will set a `x-out-of-boundaries` attribute which can
	   * be used to hide with a CSS selector the popper when its reference is
	   * out of boundaries.
	   *
	   * Requires the `preventOverflow` modifier before it in order to work.
	   * @memberof modifiers
	   * @inner
	   */
	  hide: {
	    /** @prop {number} order=800 - Index used to define the order of execution */
	    order: 800,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: hide
	  },
	
	  /**
	   * Computes the style that will be applied to the popper element to gets
	   * properly positioned.
	   *
	   * Note that this modifier will not touch the DOM, it just prepares the styles
	   * so that `applyStyle` modifier can apply it. This separation is useful
	   * in case you need to replace `applyStyle` with a custom implementation.
	   *
	   * This modifier has `850` as `order` value to maintain backward compatibility
	   * with previous versions of Popper.js. Expect the modifiers ordering method
	   * to change in future major versions of the library.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  computeStyle: {
	    /** @prop {number} order=850 - Index used to define the order of execution */
	    order: 850,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: computeStyle,
	    /**
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: true,
	    /**
	     * @prop {string} [x='bottom']
	     * Where to anchor the X axis (`bottom` or `top`). AKA X offset origin.
	     * Change this if your popper should grow in a direction different from `bottom`
	     */
	    x: 'bottom',
	    /**
	     * @prop {string} [x='left']
	     * Where to anchor the Y axis (`left` or `right`). AKA Y offset origin.
	     * Change this if your popper should grow in a direction different from `right`
	     */
	    y: 'right'
	  },
	
	  /**
	   * Applies the computed styles to the popper element.
	   *
	   * All the DOM manipulations are limited to this modifier. This is useful in case
	   * you want to integrate Popper.js inside a framework or view library and you
	   * want to delegate all the DOM manipulations to it.
	   *
	   * Note that if you disable this modifier, you must make sure the popper element
	   * has its position set to `absolute` before Popper.js can do its work!
	   *
	   * Just disable this modifier and define your own to achieve the desired effect.
	   *
	   * @memberof modifiers
	   * @inner
	   */
	  applyStyle: {
	    /** @prop {number} order=900 - Index used to define the order of execution */
	    order: 900,
	    /** @prop {Boolean} enabled=true - Whether the modifier is enabled or not */
	    enabled: true,
	    /** @prop {ModifierFn} */
	    fn: applyStyle,
	    /** @prop {Function} */
	    onLoad: applyStyleOnLoad,
	    /**
	     * @deprecated since version 1.10.0, the property moved to `computeStyle` modifier
	     * @prop {Boolean} gpuAcceleration=true
	     * If true, it uses the CSS 3D transformation to position the popper.
	     * Otherwise, it will use the `top` and `left` properties
	     */
	    gpuAcceleration: undefined
	  }
	};
	
	/**
	 * The `dataObject` is an object containing all the information used by Popper.js.
	 * This object is passed to modifiers and to the `onCreate` and `onUpdate` callbacks.
	 * @name dataObject
	 * @property {Object} data.instance The Popper.js instance
	 * @property {String} data.placement Placement applied to popper
	 * @property {String} data.originalPlacement Placement originally defined on init
	 * @property {Boolean} data.flipped True if popper has been flipped by flip modifier
	 * @property {Boolean} data.hide True if the reference element is out of boundaries, useful to know when to hide the popper
	 * @property {HTMLElement} data.arrowElement Node used as arrow by arrow modifier
	 * @property {Object} data.styles Any CSS property defined here will be applied to the popper. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.arrowStyles Any CSS property defined here will be applied to the popper arrow. It expects the JavaScript nomenclature (eg. `marginBottom`)
	 * @property {Object} data.boundaries Offsets of the popper boundaries
	 * @property {Object} data.offsets The measurements of popper, reference and arrow elements
	 * @property {Object} data.offsets.popper `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.reference `top`, `left`, `width`, `height` values
	 * @property {Object} data.offsets.arrow] `top` and `left` offsets, only one of them will be different from 0
	 */
	
	/**
	 * Default options provided to Popper.js constructor.<br />
	 * These can be overridden using the `options` argument of Popper.js.<br />
	 * To override an option, simply pass an object with the same
	 * structure of the `options` object, as the 3rd argument. For example:
	 * ```
	 * new Popper(ref, pop, {
	 *   modifiers: {
	 *     preventOverflow: { enabled: false }
	 *   }
	 * })
	 * ```
	 * @type {Object}
	 * @static
	 * @memberof Popper
	 */
	var Defaults = {
	  /**
	   * Popper's placement.
	   * @prop {Popper.placements} placement='bottom'
	   */
	  placement: 'bottom',
	
	  /**
	   * Set this to true if you want popper to position it self in 'fixed' mode
	   * @prop {Boolean} positionFixed=false
	   */
	  positionFixed: false,
	
	  /**
	   * Whether events (resize, scroll) are initially enabled.
	   * @prop {Boolean} eventsEnabled=true
	   */
	  eventsEnabled: true,
	
	  /**
	   * Set to true if you want to automatically remove the popper when
	   * you call the `destroy` method.
	   * @prop {Boolean} removeOnDestroy=false
	   */
	  removeOnDestroy: false,
	
	  /**
	   * Callback called when the popper is created.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onCreate}
	   */
	  onCreate: function onCreate() {},
	
	  /**
	   * Callback called when the popper is updated. This callback is not called
	   * on the initialization/creation of the popper, but only on subsequent
	   * updates.<br />
	   * By default, it is set to no-op.<br />
	   * Access Popper.js instance with `data.instance`.
	   * @prop {onUpdate}
	   */
	  onUpdate: function onUpdate() {},
	
	  /**
	   * List of modifiers used to modify the offsets before they are applied to the popper.
	   * They provide most of the functionalities of Popper.js.
	   * @prop {modifiers}
	   */
	  modifiers: modifiers
	};
	
	/**
	 * @callback onCreate
	 * @param {dataObject} data
	 */
	
	/**
	 * @callback onUpdate
	 * @param {dataObject} data
	 */
	
	// Utils
	// Methods
	var Popper = function () {
	  /**
	   * Creates a new Popper.js instance.
	   * @class Popper
	   * @param {Element|referenceObject} reference - The reference element used to position the popper
	   * @param {Element} popper - The HTML / XML element used as the popper
	   * @param {Object} options - Your custom options to override the ones defined in [Defaults](#defaults)
	   * @return {Object} instance - The generated Popper.js instance
	   */
	  function Popper(reference, popper) {
	    var _this = this;
	
	    var options = arguments.length > 2 && arguments[2] !== undefined ? arguments[2] : {};
	    classCallCheck(this, Popper);
	
	    this.scheduleUpdate = function () {
	      return requestAnimationFrame(_this.update);
	    };
	
	    // make update() debounced, so that it only runs at most once-per-tick
	    this.update = debounce(this.update.bind(this));
	
	    // with {} we create a new object with the options inside it
	    this.options = _extends({}, Popper.Defaults, options);
	
	    // init state
	    this.state = {
	      isDestroyed: false,
	      isCreated: false,
	      scrollParents: []
	    };
	
	    // get reference and popper elements (allow jQuery wrappers)
	    this.reference = reference && reference.jquery ? reference[0] : reference;
	    this.popper = popper && popper.jquery ? popper[0] : popper;
	
	    // Deep merge modifiers options
	    this.options.modifiers = {};
	    Object.keys(_extends({}, Popper.Defaults.modifiers, options.modifiers)).forEach(function (name) {
	      _this.options.modifiers[name] = _extends({}, Popper.Defaults.modifiers[name] || {}, options.modifiers ? options.modifiers[name] : {});
	    });
	
	    // Refactoring modifiers' list (Object => Array)
	    this.modifiers = Object.keys(this.options.modifiers).map(function (name) {
	      return _extends({
	        name: name
	      }, _this.options.modifiers[name]);
	    })
	    // sort the modifiers by order
	    .sort(function (a, b) {
	      return a.order - b.order;
	    });
	
	    // modifiers have the ability to execute arbitrary code when Popper.js get inited
	    // such code is executed in the same order of its modifier
	    // they could add new properties to their options configuration
	    // BE AWARE: don't add options to `options.modifiers.name` but to `modifierOptions`!
	    this.modifiers.forEach(function (modifierOptions) {
	      if (modifierOptions.enabled && isFunction(modifierOptions.onLoad)) {
	        modifierOptions.onLoad(_this.reference, _this.popper, _this.options, modifierOptions, _this.state);
	      }
	    });
	
	    // fire the first update to position the popper in the right place
	    this.update();
	
	    var eventsEnabled = this.options.eventsEnabled;
	    if (eventsEnabled) {
	      // setup event listeners, they will take care of update the position in specific situations
	      this.enableEventListeners();
	    }
	
	    this.state.eventsEnabled = eventsEnabled;
	  }
	
	  // We can't use class properties because they don't get listed in the
	  // class prototype and break stuff like Sinon stubs
	
	
	  createClass(Popper, [{
	    key: 'update',
	    value: function update$$1() {
	      return update.call(this);
	    }
	  }, {
	    key: 'destroy',
	    value: function destroy$$1() {
	      return destroy.call(this);
	    }
	  }, {
	    key: 'enableEventListeners',
	    value: function enableEventListeners$$1() {
	      return enableEventListeners.call(this);
	    }
	  }, {
	    key: 'disableEventListeners',
	    value: function disableEventListeners$$1() {
	      return disableEventListeners.call(this);
	    }
	
	    /**
	     * Schedules an update. It will run on the next UI update available.
	     * @method scheduleUpdate
	     * @memberof Popper
	     */
	
	
	    /**
	     * Collection of utilities useful when writing custom modifiers.
	     * Starting from version 1.7, this method is available only if you
	     * include `popper-utils.js` before `popper.js`.
	     *
	     * **DEPRECATION**: This way to access PopperUtils is deprecated
	     * and will be removed in v2! Use the PopperUtils module directly instead.
	     * Due to the high instability of the methods contained in Utils, we can't
	     * guarantee them to follow semver. Use them at your own risk!
	     * @static
	     * @private
	     * @type {Object}
	     * @deprecated since version 1.8
	     * @member Utils
	     * @memberof Popper
	     */
	
	  }]);
	  return Popper;
	}();
	
	/**
	 * The `referenceObject` is an object that provides an interface compatible with Popper.js
	 * and lets you use it as replacement of a real DOM node.<br />
	 * You can use this method to position a popper relatively to a set of coordinates
	 * in case you don't have a DOM node to use as reference.
	 *
	 * ```
	 * new Popper(referenceObject, popperNode);
	 * ```
	 *
	 * NB: This feature isn't supported in Internet Explorer 10.
	 * @name referenceObject
	 * @property {Function} data.getBoundingClientRect
	 * A function that returns a set of coordinates compatible with the native `getBoundingClientRect` method.
	 * @property {number} data.clientWidth
	 * An ES6 getter that will return the width of the virtual reference element.
	 * @property {number} data.clientHeight
	 * An ES6 getter that will return the height of the virtual reference element.
	 */
	
	
	Popper.Utils = (typeof window !== 'undefined' ? window : global).PopperUtils;
	Popper.placements = placements;
	Popper.Defaults = Defaults;
	
	return Popper;
	
	})));
	//# sourceMappingURL=popper.js.map
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 543 */
/***/ function(module, exports, __webpack_require__) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = __webpack_require__(544);
	
	function emptyFunction() {}
	function emptyFunctionWithReset() {}
	emptyFunctionWithReset.resetWarningCache = emptyFunction;
	
	module.exports = function() {
	  function shim(props, propName, componentName, location, propFullName, secret) {
	    if (secret === ReactPropTypesSecret) {
	      // It is still safe when called from React.
	      return;
	    }
	    var err = new Error(
	      'Calling PropTypes validators directly is not supported by the `prop-types` package. ' +
	      'Use PropTypes.checkPropTypes() to call them. ' +
	      'Read more at http://fb.me/use-check-prop-types'
	    );
	    err.name = 'Invariant Violation';
	    throw err;
	  };
	  shim.isRequired = shim;
	  function getShim() {
	    return shim;
	  };
	  // Important!
	  // Keep this list in sync with production version in `./factoryWithTypeCheckers.js`.
	  var ReactPropTypes = {
	    array: shim,
	    bool: shim,
	    func: shim,
	    number: shim,
	    object: shim,
	    string: shim,
	    symbol: shim,
	
	    any: shim,
	    arrayOf: getShim,
	    element: shim,
	    elementType: shim,
	    instanceOf: getShim,
	    node: shim,
	    objectOf: getShim,
	    oneOf: getShim,
	    oneOfType: getShim,
	    shape: getShim,
	    exact: getShim,
	
	    checkPropTypes: emptyFunctionWithReset,
	    resetWarningCache: emptyFunction
	  };
	
	  ReactPropTypes.PropTypes = ReactPropTypes;
	
	  return ReactPropTypes;
	};


/***/ },
/* 544 */
/***/ function(module, exports) {

	/**
	 * Copyright (c) 2013-present, Facebook, Inc.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';
	
	var ReactPropTypesSecret = 'SECRET_DO_NOT_PASS_THIS_OR_YOU_WILL_BE_FIRED';
	
	module.exports = ReactPropTypesSecret;


/***/ },
/* 545 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	var strictUriEncode = __webpack_require__(602);
	var objectAssign = __webpack_require__(100);
	var decodeComponent = __webpack_require__(517);
	
	function encoderForArrayFormat(opts) {
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, index) {
					return value === null ? [
						encode(key, opts),
						'[',
						index,
						']'
					].join('') : [
						encode(key, opts),
						'[',
						encode(index, opts),
						']=',
						encode(value, opts)
					].join('');
				};
	
			case 'bracket':
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'[]=',
						encode(value, opts)
					].join('');
				};
	
			default:
				return function (key, value) {
					return value === null ? encode(key, opts) : [
						encode(key, opts),
						'=',
						encode(value, opts)
					].join('');
				};
		}
	}
	
	function parserForArrayFormat(opts) {
		var result;
	
		switch (opts.arrayFormat) {
			case 'index':
				return function (key, value, accumulator) {
					result = /\[(\d*)\]$/.exec(key);
	
					key = key.replace(/\[\d*\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					}
	
					if (accumulator[key] === undefined) {
						accumulator[key] = {};
					}
	
					accumulator[key][result[1]] = value;
				};
	
			case 'bracket':
				return function (key, value, accumulator) {
					result = /(\[\])$/.exec(key);
					key = key.replace(/\[\]$/, '');
	
					if (!result) {
						accumulator[key] = value;
						return;
					} else if (accumulator[key] === undefined) {
						accumulator[key] = [value];
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
	
			default:
				return function (key, value, accumulator) {
					if (accumulator[key] === undefined) {
						accumulator[key] = value;
						return;
					}
	
					accumulator[key] = [].concat(accumulator[key], value);
				};
		}
	}
	
	function encode(value, opts) {
		if (opts.encode) {
			return opts.strict ? strictUriEncode(value) : encodeURIComponent(value);
		}
	
		return value;
	}
	
	function keysSorter(input) {
		if (Array.isArray(input)) {
			return input.sort();
		} else if (typeof input === 'object') {
			return keysSorter(Object.keys(input)).sort(function (a, b) {
				return Number(a) - Number(b);
			}).map(function (key) {
				return input[key];
			});
		}
	
		return input;
	}
	
	function extract(str) {
		var queryStart = str.indexOf('?');
		if (queryStart === -1) {
			return '';
		}
		return str.slice(queryStart + 1);
	}
	
	function parse(str, opts) {
		opts = objectAssign({arrayFormat: 'none'}, opts);
	
		var formatter = parserForArrayFormat(opts);
	
		// Create an object with no prototype
		// https://github.com/sindresorhus/query-string/issues/47
		var ret = Object.create(null);
	
		if (typeof str !== 'string') {
			return ret;
		}
	
		str = str.trim().replace(/^[?#&]/, '');
	
		if (!str) {
			return ret;
		}
	
		str.split('&').forEach(function (param) {
			var parts = param.replace(/\+/g, ' ').split('=');
			// Firefox (pre 40) decodes `%3D` to `=`
			// https://github.com/sindresorhus/query-string/pull/37
			var key = parts.shift();
			var val = parts.length > 0 ? parts.join('=') : undefined;
	
			// missing `=` should be `null`:
			// http://w3.org/TR/2012/WD-url-20120524/#collect-url-parameters
			val = val === undefined ? null : decodeComponent(val);
	
			formatter(decodeComponent(key), val, ret);
		});
	
		return Object.keys(ret).sort().reduce(function (result, key) {
			var val = ret[key];
			if (Boolean(val) && typeof val === 'object' && !Array.isArray(val)) {
				// Sort object keys, not values
				result[key] = keysSorter(val);
			} else {
				result[key] = val;
			}
	
			return result;
		}, Object.create(null));
	}
	
	exports.extract = extract;
	exports.parse = parse;
	
	exports.stringify = function (obj, opts) {
		var defaults = {
			encode: true,
			strict: true,
			arrayFormat: 'none'
		};
	
		opts = objectAssign(defaults, opts);
	
		if (opts.sort === false) {
			opts.sort = function () {};
		}
	
		var formatter = encoderForArrayFormat(opts);
	
		return obj ? Object.keys(obj).sort(opts.sort).map(function (key) {
			var val = obj[key];
	
			if (val === undefined) {
				return '';
			}
	
			if (val === null) {
				return encode(key, opts);
			}
	
			if (Array.isArray(val)) {
				var result = [];
	
				val.slice().forEach(function (val2) {
					if (val2 === undefined) {
						return;
					}
	
					result.push(formatter(key, val2, result.length));
				});
	
				return result.join('&');
			}
	
			return encode(key, opts) + '=' + encode(val, opts);
		}).filter(function (x) {
			return x.length > 0;
		}).join('&') : '';
	};
	
	exports.parseUrl = function (str, opts) {
		return {
			url: str.split('?')[0] || '',
			query: parse(extract(str), opts)
		};
	};


/***/ },
/* 546 */
/***/ function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__(549);


/***/ },
/* 547 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(179);
	
	var _metaProps = __webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var defaultProps = {
	  target: '_blank'
	};
	
	var CSVDownload = function (_React$Component) {
	  _inherits(CSVDownload, _React$Component);
	
	  function CSVDownload(props) {
	    _classCallCheck(this, CSVDownload);
	
	    var _this = _possibleConstructorReturn(this, (CSVDownload.__proto__ || Object.getPrototypeOf(CSVDownload)).call(this, props));
	
	    _this.state = {};
	    return _this;
	  }
	
	  _createClass(CSVDownload, [{
	    key: 'buildURI',
	    value: function buildURI() {
	      return _core.buildURI.apply(undefined, arguments);
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          headers = _props.headers,
	          separator = _props.separator,
	          enclosingCharacter = _props.enclosingCharacter,
	          uFEFF = _props.uFEFF,
	          target = _props.target,
	          specs = _props.specs,
	          replace = _props.replace;
	
	      this.state.page = window.open(this.buildURI(data, uFEFF, headers, separator, enclosingCharacter), target, specs, replace);
	    }
	  }, {
	    key: 'getWindow',
	    value: function getWindow() {
	      return this.state.page;
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return null;
	    }
	  }]);
	
	  return CSVDownload;
	}(_react2.default.Component);
	
	CSVDownload.defaultProps = Object.assign(_metaProps.defaultProps, defaultProps);
	CSVDownload.propTypes = _metaProps.propTypes;
	exports.default = CSVDownload;

/***/ },
/* 548 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _core = __webpack_require__(179);
	
	var _metaProps = __webpack_require__(180);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutProperties(obj, keys) { var target = {}; for (var i in obj) { if (keys.indexOf(i) >= 0) continue; if (!Object.prototype.hasOwnProperty.call(obj, i)) continue; target[i] = obj[i]; } return target; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var CSVLink = function (_React$Component) {
	  _inherits(CSVLink, _React$Component);
	
	  function CSVLink(props) {
	    _classCallCheck(this, CSVLink);
	
	    var _this = _possibleConstructorReturn(this, (CSVLink.__proto__ || Object.getPrototypeOf(CSVLink)).call(this, props));
	
	    _this.buildURI = _this.buildURI.bind(_this);
	    _this.state = { href: '' };
	    return _this;
	  }
	
	  _createClass(CSVLink, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      var _props = this.props,
	          data = _props.data,
	          headers = _props.headers,
	          separator = _props.separator,
	          uFEFF = _props.uFEFF,
	          enclosingCharacter = _props.enclosingCharacter;
	
	      this.setState({ href: this.buildURI(data, uFEFF, headers, separator, enclosingCharacter) });
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate(prevProps) {
	      if (this.props !== prevProps) {
	        var data = prevProps.data,
	            headers = prevProps.headers,
	            separator = prevProps.separator,
	            uFEFF = prevProps.uFEFF;
	
	        this.setState({ href: this.buildURI(data, uFEFF, headers, separator) });
	      }
	    }
	  }, {
	    key: 'buildURI',
	    value: function buildURI() {
	      return _core.buildURI.apply(undefined, arguments);
	    }
	  }, {
	    key: 'handleLegacy',
	    value: function handleLegacy(event) {
	      if (window.navigator.msSaveOrOpenBlob) {
	        event.preventDefault();
	
	        var _props2 = this.props,
	            data = _props2.data,
	            headers = _props2.headers,
	            separator = _props2.separator,
	            filename = _props2.filename,
	            enclosingCharacter = _props2.enclosingCharacter,
	            uFEFF = _props2.uFEFF;
	
	
	        var blob = new Blob([uFEFF ? '\uFEFF' : '', (0, _core.toCSV)(data, headers, separator, enclosingCharacter)]);
	        window.navigator.msSaveBlob(blob, filename);
	
	        return false;
	      }
	    }
	  }, {
	    key: 'handleAsyncClick',
	    value: function handleAsyncClick(event) {
	      var _this2 = this;
	
	      var done = function done(proceed) {
	        if (proceed === false) {
	          event.preventDefault();
	          return;
	        }
	        _this2.handleLegacy(event);
	      };
	
	      this.props.onClick(event, done);
	    }
	  }, {
	    key: 'handleSyncClick',
	    value: function handleSyncClick(event) {
	      var stopEvent = this.props.onClick(event) === false;
	      if (stopEvent) {
	        event.preventDefault();
	        return;
	      }
	      this.handleLegacy(event);
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick() {
	      var _this3 = this;
	
	      return function (event) {
	        if (typeof _this3.props.onClick === 'function') {
	          return _this3.props.asyncOnClick ? _this3.handleAsyncClick(event) : _this3.handleSyncClick(event);
	        }
	        _this3.handleLegacy(event);
	      };
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this4 = this;
	
	      var _props3 = this.props,
	          data = _props3.data,
	          headers = _props3.headers,
	          separator = _props3.separator,
	          filename = _props3.filename,
	          uFEFF = _props3.uFEFF,
	          children = _props3.children,
	          onClick = _props3.onClick,
	          asyncOnClick = _props3.asyncOnClick,
	          enclosingCharacter = _props3.enclosingCharacter,
	          rest = _objectWithoutProperties(_props3, ['data', 'headers', 'separator', 'filename', 'uFEFF', 'children', 'onClick', 'asyncOnClick', 'enclosingCharacter']);
	
	      return _react2.default.createElement(
	        'a',
	        _extends({
	          download: filename
	        }, rest, {
	          ref: function ref(link) {
	            return _this4.link = link;
	          },
	          target: '_self',
	          href: this.state.href,
	          onClick: this.handleClick()
	        }),
	        children
	      );
	    }
	  }]);
	
	  return CSVLink;
	}(_react2.default.Component);
	
	CSVLink.defaultProps = _metaProps.defaultProps;
	CSVLink.propTypes = _metaProps.propTypes;
	exports.default = CSVLink;

/***/ },
/* 549 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.CSVLink = exports.CSVDownload = undefined;
	
	var _Download = __webpack_require__(547);
	
	var _Download2 = _interopRequireDefault(_Download);
	
	var _Link = __webpack_require__(548);
	
	var _Link2 = _interopRequireDefault(_Link);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var CSVDownload = exports.CSVDownload = _Download2.default;
	var CSVLink = exports.CSVLink = _Link2.default;

/***/ },
/* 550 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.0
	 * react-dom.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	/*
	 Modernizr 3.0.0pre (Custom Build) | MIT
	*/
	'use strict';var aa=__webpack_require__(2),p=__webpack_require__(100),ba=__webpack_require__(601);function ca(a,b,c,d,e,f,g,h){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[c,d,e,f,g,h],k=0;a=Error(b.replace(/%s/g,function(){return l[k++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function t(a){for(var b=arguments.length-1,c="https://reactjs.org/docs/error-decoder.html?invariant="+a,d=0;d<b;d++)c+="&args[]="+encodeURIComponent(arguments[d+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",c)}aa?void 0:t("227");function da(a,b,c,d,e,f,g,h,l){var k=Array.prototype.slice.call(arguments,3);try{b.apply(c,k)}catch(m){this.onError(m)}}
	var ea=!1,fa=null,ha=!1,ia=null,ja={onError:function(a){ea=!0;fa=a}};function ka(a,b,c,d,e,f,g,h,l){ea=!1;fa=null;da.apply(ja,arguments)}function la(a,b,c,d,e,f,g,h,l){ka.apply(this,arguments);if(ea){if(ea){var k=fa;ea=!1;fa=null}else t("198"),k=void 0;ha||(ha=!0,ia=k)}}var ma=null,na={};
	function oa(){if(ma)for(var a in na){var b=na[a],c=ma.indexOf(a);-1<c?void 0:t("96",a);if(!pa[c]){b.extractEvents?void 0:t("97",a);pa[c]=b;c=b.eventTypes;for(var d in c){var e=void 0;var f=c[d],g=b,h=d;ra.hasOwnProperty(h)?t("99",h):void 0;ra[h]=f;var l=f.phasedRegistrationNames;if(l){for(e in l)l.hasOwnProperty(e)&&sa(l[e],g,h);e=!0}else f.registrationName?(sa(f.registrationName,g,h),e=!0):e=!1;e?void 0:t("98",d,a)}}}}
	function sa(a,b,c){ta[a]?t("100",a):void 0;ta[a]=b;ua[a]=b.eventTypes[c].dependencies}var pa=[],ra={},ta={},ua={},va=null,wa=null,xa=null;function ya(a,b,c){var d=a.type||"unknown-event";a.currentTarget=xa(c);la(d,b,void 0,a);a.currentTarget=null}function za(a,b){null==b?t("30"):void 0;if(null==a)return b;if(Array.isArray(a)){if(Array.isArray(b))return a.push.apply(a,b),a;a.push(b);return a}return Array.isArray(b)?[a].concat(b):[a,b]}
	function Aa(a,b,c){Array.isArray(a)?a.forEach(b,c):a&&b.call(c,a)}var Ba=null;function Ca(a){if(a){var b=a._dispatchListeners,c=a._dispatchInstances;if(Array.isArray(b))for(var d=0;d<b.length&&!a.isPropagationStopped();d++)ya(a,b[d],c[d]);else b&&ya(a,b,c);a._dispatchListeners=null;a._dispatchInstances=null;a.isPersistent()||a.constructor.release(a)}}
	var Da={injectEventPluginOrder:function(a){ma?t("101"):void 0;ma=Array.prototype.slice.call(a);oa()},injectEventPluginsByName:function(a){var b=!1,c;for(c in a)if(a.hasOwnProperty(c)){var d=a[c];na.hasOwnProperty(c)&&na[c]===d||(na[c]?t("102",c):void 0,na[c]=d,b=!0)}b&&oa()}};
	function Ea(a,b){var c=a.stateNode;if(!c)return null;var d=va(c);if(!d)return null;c=d[b];a:switch(b){case "onClick":case "onClickCapture":case "onDoubleClick":case "onDoubleClickCapture":case "onMouseDown":case "onMouseDownCapture":case "onMouseMove":case "onMouseMoveCapture":case "onMouseUp":case "onMouseUpCapture":(d=!d.disabled)||(a=a.type,d=!("button"===a||"input"===a||"select"===a||"textarea"===a));a=!d;break a;default:a=!1}if(a)return null;c&&"function"!==typeof c?t("231",b,typeof c):void 0;
	return c}function Fa(a){null!==a&&(Ba=za(Ba,a));a=Ba;Ba=null;if(a&&(Aa(a,Ca),Ba?t("95"):void 0,ha))throw a=ia,ha=!1,ia=null,a;}var Ga=Math.random().toString(36).slice(2),Ha="__reactInternalInstance$"+Ga,Ia="__reactEventHandlers$"+Ga;function Ja(a){if(a[Ha])return a[Ha];for(;!a[Ha];)if(a.parentNode)a=a.parentNode;else return null;a=a[Ha];return 5===a.tag||6===a.tag?a:null}function Ka(a){a=a[Ha];return!a||5!==a.tag&&6!==a.tag?null:a}
	function La(a){if(5===a.tag||6===a.tag)return a.stateNode;t("33")}function Ma(a){return a[Ia]||null}function Na(a){do a=a.return;while(a&&5!==a.tag);return a?a:null}function Oa(a,b,c){if(b=Ea(a,c.dispatchConfig.phasedRegistrationNames[b]))c._dispatchListeners=za(c._dispatchListeners,b),c._dispatchInstances=za(c._dispatchInstances,a)}
	function Pa(a){if(a&&a.dispatchConfig.phasedRegistrationNames){for(var b=a._targetInst,c=[];b;)c.push(b),b=Na(b);for(b=c.length;0<b--;)Oa(c[b],"captured",a);for(b=0;b<c.length;b++)Oa(c[b],"bubbled",a)}}function Qa(a,b,c){a&&c&&c.dispatchConfig.registrationName&&(b=Ea(a,c.dispatchConfig.registrationName))&&(c._dispatchListeners=za(c._dispatchListeners,b),c._dispatchInstances=za(c._dispatchInstances,a))}function Ra(a){a&&a.dispatchConfig.registrationName&&Qa(a._targetInst,null,a)}
	function Sa(a){Aa(a,Pa)}var Ta=!("undefined"===typeof window||!window.document||!window.document.createElement);function Ua(a,b){var c={};c[a.toLowerCase()]=b.toLowerCase();c["Webkit"+a]="webkit"+b;c["Moz"+a]="moz"+b;return c}var Va={animationend:Ua("Animation","AnimationEnd"),animationiteration:Ua("Animation","AnimationIteration"),animationstart:Ua("Animation","AnimationStart"),transitionend:Ua("Transition","TransitionEnd")},Wa={},Xa={};
	Ta&&(Xa=document.createElement("div").style,"AnimationEvent"in window||(delete Va.animationend.animation,delete Va.animationiteration.animation,delete Va.animationstart.animation),"TransitionEvent"in window||delete Va.transitionend.transition);function Ya(a){if(Wa[a])return Wa[a];if(!Va[a])return a;var b=Va[a],c;for(c in b)if(b.hasOwnProperty(c)&&c in Xa)return Wa[a]=b[c];return a}
	var Za=Ya("animationend"),$a=Ya("animationiteration"),ab=Ya("animationstart"),bb=Ya("transitionend"),cb="abort canplay canplaythrough durationchange emptied encrypted ended error loadeddata loadedmetadata loadstart pause play playing progress ratechange seeked seeking stalled suspend timeupdate volumechange waiting".split(" "),db=null,eb=null,fb=null;
	function gb(){if(fb)return fb;var a,b=eb,c=b.length,d,e="value"in db?db.value:db.textContent,f=e.length;for(a=0;a<c&&b[a]===e[a];a++);var g=c-a;for(d=1;d<=g&&b[c-d]===e[f-d];d++);return fb=e.slice(a,1<d?1-d:void 0)}function hb(){return!0}function ib(){return!1}
	function A(a,b,c,d){this.dispatchConfig=a;this._targetInst=b;this.nativeEvent=c;a=this.constructor.Interface;for(var e in a)a.hasOwnProperty(e)&&((b=a[e])?this[e]=b(c):"target"===e?this.target=d:this[e]=c[e]);this.isDefaultPrevented=(null!=c.defaultPrevented?c.defaultPrevented:!1===c.returnValue)?hb:ib;this.isPropagationStopped=ib;return this}
	p(A.prototype,{preventDefault:function(){this.defaultPrevented=!0;var a=this.nativeEvent;a&&(a.preventDefault?a.preventDefault():"unknown"!==typeof a.returnValue&&(a.returnValue=!1),this.isDefaultPrevented=hb)},stopPropagation:function(){var a=this.nativeEvent;a&&(a.stopPropagation?a.stopPropagation():"unknown"!==typeof a.cancelBubble&&(a.cancelBubble=!0),this.isPropagationStopped=hb)},persist:function(){this.isPersistent=hb},isPersistent:ib,destructor:function(){var a=this.constructor.Interface,
	b;for(b in a)this[b]=null;this.nativeEvent=this._targetInst=this.dispatchConfig=null;this.isPropagationStopped=this.isDefaultPrevented=ib;this._dispatchInstances=this._dispatchListeners=null}});A.Interface={type:null,target:null,currentTarget:function(){return null},eventPhase:null,bubbles:null,cancelable:null,timeStamp:function(a){return a.timeStamp||Date.now()},defaultPrevented:null,isTrusted:null};
	A.extend=function(a){function b(){}function c(){return d.apply(this,arguments)}var d=this;b.prototype=d.prototype;var e=new b;p(e,c.prototype);c.prototype=e;c.prototype.constructor=c;c.Interface=p({},d.Interface,a);c.extend=d.extend;jb(c);return c};jb(A);function kb(a,b,c,d){if(this.eventPool.length){var e=this.eventPool.pop();this.call(e,a,b,c,d);return e}return new this(a,b,c,d)}function lb(a){a instanceof this?void 0:t("279");a.destructor();10>this.eventPool.length&&this.eventPool.push(a)}
	function jb(a){a.eventPool=[];a.getPooled=kb;a.release=lb}var mb=A.extend({data:null}),nb=A.extend({data:null}),ob=[9,13,27,32],pb=Ta&&"CompositionEvent"in window,qb=null;Ta&&"documentMode"in document&&(qb=document.documentMode);
	var rb=Ta&&"TextEvent"in window&&!qb,sb=Ta&&(!pb||qb&&8<qb&&11>=qb),tb=String.fromCharCode(32),vb={beforeInput:{phasedRegistrationNames:{bubbled:"onBeforeInput",captured:"onBeforeInputCapture"},dependencies:["compositionend","keypress","textInput","paste"]},compositionEnd:{phasedRegistrationNames:{bubbled:"onCompositionEnd",captured:"onCompositionEndCapture"},dependencies:"blur compositionend keydown keypress keyup mousedown".split(" ")},compositionStart:{phasedRegistrationNames:{bubbled:"onCompositionStart",
	captured:"onCompositionStartCapture"},dependencies:"blur compositionstart keydown keypress keyup mousedown".split(" ")},compositionUpdate:{phasedRegistrationNames:{bubbled:"onCompositionUpdate",captured:"onCompositionUpdateCapture"},dependencies:"blur compositionupdate keydown keypress keyup mousedown".split(" ")}},wb=!1;
	function xb(a,b){switch(a){case "keyup":return-1!==ob.indexOf(b.keyCode);case "keydown":return 229!==b.keyCode;case "keypress":case "mousedown":case "blur":return!0;default:return!1}}function yb(a){a=a.detail;return"object"===typeof a&&"data"in a?a.data:null}var zb=!1;function Ab(a,b){switch(a){case "compositionend":return yb(b);case "keypress":if(32!==b.which)return null;wb=!0;return tb;case "textInput":return a=b.data,a===tb&&wb?null:a;default:return null}}
	function Bb(a,b){if(zb)return"compositionend"===a||!pb&&xb(a,b)?(a=gb(),fb=eb=db=null,zb=!1,a):null;switch(a){case "paste":return null;case "keypress":if(!(b.ctrlKey||b.altKey||b.metaKey)||b.ctrlKey&&b.altKey){if(b.char&&1<b.char.length)return b.char;if(b.which)return String.fromCharCode(b.which)}return null;case "compositionend":return sb&&"ko"!==b.locale?null:b.data;default:return null}}
	var Cb={eventTypes:vb,extractEvents:function(a,b,c,d){var e=void 0;var f=void 0;if(pb)b:{switch(a){case "compositionstart":e=vb.compositionStart;break b;case "compositionend":e=vb.compositionEnd;break b;case "compositionupdate":e=vb.compositionUpdate;break b}e=void 0}else zb?xb(a,c)&&(e=vb.compositionEnd):"keydown"===a&&229===c.keyCode&&(e=vb.compositionStart);e?(sb&&"ko"!==c.locale&&(zb||e!==vb.compositionStart?e===vb.compositionEnd&&zb&&(f=gb()):(db=d,eb="value"in db?db.value:db.textContent,zb=
	!0)),e=mb.getPooled(e,b,c,d),f?e.data=f:(f=yb(c),null!==f&&(e.data=f)),Sa(e),f=e):f=null;(a=rb?Ab(a,c):Bb(a,c))?(b=nb.getPooled(vb.beforeInput,b,c,d),b.data=a,Sa(b)):b=null;return null===f?b:null===b?f:[f,b]}},Db=null,Eb=null,Fb=null;function Gb(a){if(a=wa(a)){"function"!==typeof Db?t("280"):void 0;var b=va(a.stateNode);Db(a.stateNode,a.type,b)}}function Hb(a){Eb?Fb?Fb.push(a):Fb=[a]:Eb=a}function Ib(){if(Eb){var a=Eb,b=Fb;Fb=Eb=null;Gb(a);if(b)for(a=0;a<b.length;a++)Gb(b[a])}}
	function Jb(a,b){return a(b)}function Kb(a,b,c){return a(b,c)}function Lb(){}var Mb=!1;function Nb(a,b){if(Mb)return a(b);Mb=!0;try{return Jb(a,b)}finally{if(Mb=!1,null!==Eb||null!==Fb)Lb(),Ib()}}var Ob={color:!0,date:!0,datetime:!0,"datetime-local":!0,email:!0,month:!0,number:!0,password:!0,range:!0,search:!0,tel:!0,text:!0,time:!0,url:!0,week:!0};function Pb(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return"input"===b?!!Ob[a.type]:"textarea"===b?!0:!1}
	function Qb(a){a=a.target||a.srcElement||window;a.correspondingUseElement&&(a=a.correspondingUseElement);return 3===a.nodeType?a.parentNode:a}function Sb(a){if(!Ta)return!1;a="on"+a;var b=a in document;b||(b=document.createElement("div"),b.setAttribute(a,"return;"),b="function"===typeof b[a]);return b}function Tb(a){var b=a.type;return(a=a.nodeName)&&"input"===a.toLowerCase()&&("checkbox"===b||"radio"===b)}
	function Ub(a){var b=Tb(a)?"checked":"value",c=Object.getOwnPropertyDescriptor(a.constructor.prototype,b),d=""+a[b];if(!a.hasOwnProperty(b)&&"undefined"!==typeof c&&"function"===typeof c.get&&"function"===typeof c.set){var e=c.get,f=c.set;Object.defineProperty(a,b,{configurable:!0,get:function(){return e.call(this)},set:function(a){d=""+a;f.call(this,a)}});Object.defineProperty(a,b,{enumerable:c.enumerable});return{getValue:function(){return d},setValue:function(a){d=""+a},stopTracking:function(){a._valueTracker=
	null;delete a[b]}}}}function Vb(a){a._valueTracker||(a._valueTracker=Ub(a))}function Wb(a){if(!a)return!1;var b=a._valueTracker;if(!b)return!0;var c=b.getValue();var d="";a&&(d=Tb(a)?a.checked?"true":"false":a.value);a=d;return a!==c?(b.setValue(a),!0):!1}
	var Xb=aa.__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED,Yb=/^(.*)[\\\/]/,D="function"===typeof Symbol&&Symbol.for,Zb=D?Symbol.for("react.element"):60103,$b=D?Symbol.for("react.portal"):60106,ac=D?Symbol.for("react.fragment"):60107,bc=D?Symbol.for("react.strict_mode"):60108,cc=D?Symbol.for("react.profiler"):60114,dc=D?Symbol.for("react.provider"):60109,ec=D?Symbol.for("react.context"):60110,fc=D?Symbol.for("react.concurrent_mode"):60111,gc=D?Symbol.for("react.forward_ref"):60112,hc=D?Symbol.for("react.suspense"):
	60113,ic=D?Symbol.for("react.memo"):60115,jc=D?Symbol.for("react.lazy"):60116,kc="function"===typeof Symbol&&Symbol.iterator;function lc(a){if(null===a||"object"!==typeof a)return null;a=kc&&a[kc]||a["@@iterator"];return"function"===typeof a?a:null}
	function mc(a){if(null==a)return null;if("function"===typeof a)return a.displayName||a.name||null;if("string"===typeof a)return a;switch(a){case fc:return"ConcurrentMode";case ac:return"Fragment";case $b:return"Portal";case cc:return"Profiler";case bc:return"StrictMode";case hc:return"Suspense"}if("object"===typeof a)switch(a.$$typeof){case ec:return"Context.Consumer";case dc:return"Context.Provider";case gc:var b=a.render;b=b.displayName||b.name||"";return a.displayName||(""!==b?"ForwardRef("+b+
	")":"ForwardRef");case ic:return mc(a.type);case jc:if(a=1===a._status?a._result:null)return mc(a)}return null}function nc(a){var b="";do{a:switch(a.tag){case 3:case 4:case 6:case 7:case 10:case 9:var c="";break a;default:var d=a._debugOwner,e=a._debugSource,f=mc(a.type);c=null;d&&(c=mc(d.type));d=f;f="";e?f=" (at "+e.fileName.replace(Yb,"")+":"+e.lineNumber+")":c&&(f=" (created by "+c+")");c="\n    in "+(d||"Unknown")+f}b+=c;a=a.return}while(a);return b}
	var oc=/^[:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD][:A-Z_a-z\u00C0-\u00D6\u00D8-\u00F6\u00F8-\u02FF\u0370-\u037D\u037F-\u1FFF\u200C-\u200D\u2070-\u218F\u2C00-\u2FEF\u3001-\uD7FF\uF900-\uFDCF\uFDF0-\uFFFD\-.0-9\u00B7\u0300-\u036F\u203F-\u2040]*$/,pc=Object.prototype.hasOwnProperty,qc={},rc={};
	function sc(a){if(pc.call(rc,a))return!0;if(pc.call(qc,a))return!1;if(oc.test(a))return rc[a]=!0;qc[a]=!0;return!1}function tc(a,b,c,d){if(null!==c&&0===c.type)return!1;switch(typeof b){case "function":case "symbol":return!0;case "boolean":if(d)return!1;if(null!==c)return!c.acceptsBooleans;a=a.toLowerCase().slice(0,5);return"data-"!==a&&"aria-"!==a;default:return!1}}
	function uc(a,b,c,d){if(null===b||"undefined"===typeof b||tc(a,b,c,d))return!0;if(d)return!1;if(null!==c)switch(c.type){case 3:return!b;case 4:return!1===b;case 5:return isNaN(b);case 6:return isNaN(b)||1>b}return!1}function F(a,b,c,d,e){this.acceptsBooleans=2===b||3===b||4===b;this.attributeName=d;this.attributeNamespace=e;this.mustUseProperty=c;this.propertyName=a;this.type=b}var G={};
	"children dangerouslySetInnerHTML defaultValue defaultChecked innerHTML suppressContentEditableWarning suppressHydrationWarning style".split(" ").forEach(function(a){G[a]=new F(a,0,!1,a,null)});[["acceptCharset","accept-charset"],["className","class"],["htmlFor","for"],["httpEquiv","http-equiv"]].forEach(function(a){var b=a[0];G[b]=new F(b,1,!1,a[1],null)});["contentEditable","draggable","spellCheck","value"].forEach(function(a){G[a]=new F(a,2,!1,a.toLowerCase(),null)});
	["autoReverse","externalResourcesRequired","focusable","preserveAlpha"].forEach(function(a){G[a]=new F(a,2,!1,a,null)});"allowFullScreen async autoFocus autoPlay controls default defer disabled formNoValidate hidden loop noModule noValidate open playsInline readOnly required reversed scoped seamless itemScope".split(" ").forEach(function(a){G[a]=new F(a,3,!1,a.toLowerCase(),null)});["checked","multiple","muted","selected"].forEach(function(a){G[a]=new F(a,3,!0,a,null)});
	["capture","download"].forEach(function(a){G[a]=new F(a,4,!1,a,null)});["cols","rows","size","span"].forEach(function(a){G[a]=new F(a,6,!1,a,null)});["rowSpan","start"].forEach(function(a){G[a]=new F(a,5,!1,a.toLowerCase(),null)});var vc=/[\-:]([a-z])/g;function wc(a){return a[1].toUpperCase()}
	"accent-height alignment-baseline arabic-form baseline-shift cap-height clip-path clip-rule color-interpolation color-interpolation-filters color-profile color-rendering dominant-baseline enable-background fill-opacity fill-rule flood-color flood-opacity font-family font-size font-size-adjust font-stretch font-style font-variant font-weight glyph-name glyph-orientation-horizontal glyph-orientation-vertical horiz-adv-x horiz-origin-x image-rendering letter-spacing lighting-color marker-end marker-mid marker-start overline-position overline-thickness paint-order panose-1 pointer-events rendering-intent shape-rendering stop-color stop-opacity strikethrough-position strikethrough-thickness stroke-dasharray stroke-dashoffset stroke-linecap stroke-linejoin stroke-miterlimit stroke-opacity stroke-width text-anchor text-decoration text-rendering underline-position underline-thickness unicode-bidi unicode-range units-per-em v-alphabetic v-hanging v-ideographic v-mathematical vector-effect vert-adv-y vert-origin-x vert-origin-y word-spacing writing-mode xmlns:xlink x-height".split(" ").forEach(function(a){var b=a.replace(vc,
	wc);G[b]=new F(b,1,!1,a,null)});"xlink:actuate xlink:arcrole xlink:href xlink:role xlink:show xlink:title xlink:type".split(" ").forEach(function(a){var b=a.replace(vc,wc);G[b]=new F(b,1,!1,a,"http://www.w3.org/1999/xlink")});["xml:base","xml:lang","xml:space"].forEach(function(a){var b=a.replace(vc,wc);G[b]=new F(b,1,!1,a,"http://www.w3.org/XML/1998/namespace")});G.tabIndex=new F("tabIndex",1,!1,"tabindex",null);
	function xc(a,b,c,d){var e=G.hasOwnProperty(b)?G[b]:null;var f=null!==e?0===e.type:d?!1:!(2<b.length)||"o"!==b[0]&&"O"!==b[0]||"n"!==b[1]&&"N"!==b[1]?!1:!0;f||(uc(b,c,e,d)&&(c=null),d||null===e?sc(b)&&(null===c?a.removeAttribute(b):a.setAttribute(b,""+c)):e.mustUseProperty?a[e.propertyName]=null===c?3===e.type?!1:"":c:(b=e.attributeName,d=e.attributeNamespace,null===c?a.removeAttribute(b):(e=e.type,c=3===e||4===e&&!0===c?"":""+c,d?a.setAttributeNS(d,b,c):a.setAttribute(b,c))))}
	function yc(a){switch(typeof a){case "boolean":case "number":case "object":case "string":case "undefined":return a;default:return""}}function zc(a,b){var c=b.checked;return p({},b,{defaultChecked:void 0,defaultValue:void 0,value:void 0,checked:null!=c?c:a._wrapperState.initialChecked})}
	function Ac(a,b){var c=null==b.defaultValue?"":b.defaultValue,d=null!=b.checked?b.checked:b.defaultChecked;c=yc(null!=b.value?b.value:c);a._wrapperState={initialChecked:d,initialValue:c,controlled:"checkbox"===b.type||"radio"===b.type?null!=b.checked:null!=b.value}}function Bc(a,b){b=b.checked;null!=b&&xc(a,"checked",b,!1)}
	function Cc(a,b){Bc(a,b);var c=yc(b.value),d=b.type;if(null!=c)if("number"===d){if(0===c&&""===a.value||a.value!=c)a.value=""+c}else a.value!==""+c&&(a.value=""+c);else if("submit"===d||"reset"===d){a.removeAttribute("value");return}b.hasOwnProperty("value")?Dc(a,b.type,c):b.hasOwnProperty("defaultValue")&&Dc(a,b.type,yc(b.defaultValue));null==b.checked&&null!=b.defaultChecked&&(a.defaultChecked=!!b.defaultChecked)}
	function Ec(a,b,c){if(b.hasOwnProperty("value")||b.hasOwnProperty("defaultValue")){var d=b.type;if(!("submit"!==d&&"reset"!==d||void 0!==b.value&&null!==b.value))return;b=""+a._wrapperState.initialValue;c||b===a.value||(a.value=b);a.defaultValue=b}c=a.name;""!==c&&(a.name="");a.defaultChecked=!a.defaultChecked;a.defaultChecked=!!a._wrapperState.initialChecked;""!==c&&(a.name=c)}
	function Dc(a,b,c){if("number"!==b||a.ownerDocument.activeElement!==a)null==c?a.defaultValue=""+a._wrapperState.initialValue:a.defaultValue!==""+c&&(a.defaultValue=""+c)}var Fc={change:{phasedRegistrationNames:{bubbled:"onChange",captured:"onChangeCapture"},dependencies:"blur change click focus input keydown keyup selectionchange".split(" ")}};function Gc(a,b,c){a=A.getPooled(Fc.change,a,b,c);a.type="change";Hb(c);Sa(a);return a}var Hc=null,Ic=null;function Jc(a){Fa(a)}
	function Kc(a){var b=La(a);if(Wb(b))return a}function Lc(a,b){if("change"===a)return b}var Mc=!1;Ta&&(Mc=Sb("input")&&(!document.documentMode||9<document.documentMode));function Nc(){Hc&&(Hc.detachEvent("onpropertychange",Oc),Ic=Hc=null)}function Oc(a){"value"===a.propertyName&&Kc(Ic)&&(a=Gc(Ic,a,Qb(a)),Nb(Jc,a))}function Pc(a,b,c){"focus"===a?(Nc(),Hc=b,Ic=c,Hc.attachEvent("onpropertychange",Oc)):"blur"===a&&Nc()}function Qc(a){if("selectionchange"===a||"keyup"===a||"keydown"===a)return Kc(Ic)}
	function Rc(a,b){if("click"===a)return Kc(b)}function Sc(a,b){if("input"===a||"change"===a)return Kc(b)}
	var Tc={eventTypes:Fc,_isInputEventSupported:Mc,extractEvents:function(a,b,c,d){var e=b?La(b):window,f=void 0,g=void 0,h=e.nodeName&&e.nodeName.toLowerCase();"select"===h||"input"===h&&"file"===e.type?f=Lc:Pb(e)?Mc?f=Sc:(f=Qc,g=Pc):(h=e.nodeName)&&"input"===h.toLowerCase()&&("checkbox"===e.type||"radio"===e.type)&&(f=Rc);if(f&&(f=f(a,b)))return Gc(f,c,d);g&&g(a,e,b);"blur"===a&&(a=e._wrapperState)&&a.controlled&&"number"===e.type&&Dc(e,"number",e.value)}},Uc=A.extend({view:null,detail:null}),Vc={Alt:"altKey",
	Control:"ctrlKey",Meta:"metaKey",Shift:"shiftKey"};function Wc(a){var b=this.nativeEvent;return b.getModifierState?b.getModifierState(a):(a=Vc[a])?!!b[a]:!1}function Xc(){return Wc}
	var Yc=0,Zc=0,$c=!1,ad=!1,bd=Uc.extend({screenX:null,screenY:null,clientX:null,clientY:null,pageX:null,pageY:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,getModifierState:Xc,button:null,buttons:null,relatedTarget:function(a){return a.relatedTarget||(a.fromElement===a.srcElement?a.toElement:a.fromElement)},movementX:function(a){if("movementX"in a)return a.movementX;var b=Yc;Yc=a.screenX;return $c?"mousemove"===a.type?a.screenX-b:0:($c=!0,0)},movementY:function(a){if("movementY"in a)return a.movementY;
	var b=Zc;Zc=a.screenY;return ad?"mousemove"===a.type?a.screenY-b:0:(ad=!0,0)}}),cd=bd.extend({pointerId:null,width:null,height:null,pressure:null,tangentialPressure:null,tiltX:null,tiltY:null,twist:null,pointerType:null,isPrimary:null}),dd={mouseEnter:{registrationName:"onMouseEnter",dependencies:["mouseout","mouseover"]},mouseLeave:{registrationName:"onMouseLeave",dependencies:["mouseout","mouseover"]},pointerEnter:{registrationName:"onPointerEnter",dependencies:["pointerout","pointerover"]},pointerLeave:{registrationName:"onPointerLeave",
	dependencies:["pointerout","pointerover"]}},ed={eventTypes:dd,extractEvents:function(a,b,c,d){var e="mouseover"===a||"pointerover"===a,f="mouseout"===a||"pointerout"===a;if(e&&(c.relatedTarget||c.fromElement)||!f&&!e)return null;e=d.window===d?d:(e=d.ownerDocument)?e.defaultView||e.parentWindow:window;f?(f=b,b=(b=c.relatedTarget||c.toElement)?Ja(b):null):f=null;if(f===b)return null;var g=void 0,h=void 0,l=void 0,k=void 0;if("mouseout"===a||"mouseover"===a)g=bd,h=dd.mouseLeave,l=dd.mouseEnter,k="mouse";
	else if("pointerout"===a||"pointerover"===a)g=cd,h=dd.pointerLeave,l=dd.pointerEnter,k="pointer";var m=null==f?e:La(f);e=null==b?e:La(b);a=g.getPooled(h,f,c,d);a.type=k+"leave";a.target=m;a.relatedTarget=e;c=g.getPooled(l,b,c,d);c.type=k+"enter";c.target=e;c.relatedTarget=m;d=b;if(f&&d)a:{b=f;e=d;k=0;for(g=b;g;g=Na(g))k++;g=0;for(l=e;l;l=Na(l))g++;for(;0<k-g;)b=Na(b),k--;for(;0<g-k;)e=Na(e),g--;for(;k--;){if(b===e||b===e.alternate)break a;b=Na(b);e=Na(e)}b=null}else b=null;e=b;for(b=[];f&&f!==e;){k=
	f.alternate;if(null!==k&&k===e)break;b.push(f);f=Na(f)}for(f=[];d&&d!==e;){k=d.alternate;if(null!==k&&k===e)break;f.push(d);d=Na(d)}for(d=0;d<b.length;d++)Qa(b[d],"bubbled",a);for(d=f.length;0<d--;)Qa(f[d],"captured",c);return[a,c]}};function fd(a,b){return a===b&&(0!==a||1/a===1/b)||a!==a&&b!==b}var gd=Object.prototype.hasOwnProperty;
	function hd(a,b){if(fd(a,b))return!0;if("object"!==typeof a||null===a||"object"!==typeof b||null===b)return!1;var c=Object.keys(a),d=Object.keys(b);if(c.length!==d.length)return!1;for(d=0;d<c.length;d++)if(!gd.call(b,c[d])||!fd(a[c[d]],b[c[d]]))return!1;return!0}function kd(a){var b=a;if(a.alternate)for(;b.return;)b=b.return;else{if(0!==(b.effectTag&2))return 1;for(;b.return;)if(b=b.return,0!==(b.effectTag&2))return 1}return 3===b.tag?2:3}function ld(a){2!==kd(a)?t("188"):void 0}
	function md(a){var b=a.alternate;if(!b)return b=kd(a),3===b?t("188"):void 0,1===b?null:a;for(var c=a,d=b;;){var e=c.return,f=e?e.alternate:null;if(!e||!f)break;if(e.child===f.child){for(var g=e.child;g;){if(g===c)return ld(e),a;if(g===d)return ld(e),b;g=g.sibling}t("188")}if(c.return!==d.return)c=e,d=f;else{g=!1;for(var h=e.child;h;){if(h===c){g=!0;c=e;d=f;break}if(h===d){g=!0;d=e;c=f;break}h=h.sibling}if(!g){for(h=f.child;h;){if(h===c){g=!0;c=f;d=e;break}if(h===d){g=!0;d=f;c=e;break}h=h.sibling}g?
	void 0:t("189")}}c.alternate!==d?t("190"):void 0}3!==c.tag?t("188"):void 0;return c.stateNode.current===c?a:b}function nd(a){a=md(a);if(!a)return null;for(var b=a;;){if(5===b.tag||6===b.tag)return b;if(b.child)b.child.return=b,b=b.child;else{if(b===a)break;for(;!b.sibling;){if(!b.return||b.return===a)return null;b=b.return}b.sibling.return=b.return;b=b.sibling}}return null}
	var od=A.extend({animationName:null,elapsedTime:null,pseudoElement:null}),pd=A.extend({clipboardData:function(a){return"clipboardData"in a?a.clipboardData:window.clipboardData}}),qd=Uc.extend({relatedTarget:null});function rd(a){var b=a.keyCode;"charCode"in a?(a=a.charCode,0===a&&13===b&&(a=13)):a=b;10===a&&(a=13);return 32<=a||13===a?a:0}
	var sd={Esc:"Escape",Spacebar:" ",Left:"ArrowLeft",Up:"ArrowUp",Right:"ArrowRight",Down:"ArrowDown",Del:"Delete",Win:"OS",Menu:"ContextMenu",Apps:"ContextMenu",Scroll:"ScrollLock",MozPrintableKey:"Unidentified"},td={8:"Backspace",9:"Tab",12:"Clear",13:"Enter",16:"Shift",17:"Control",18:"Alt",19:"Pause",20:"CapsLock",27:"Escape",32:" ",33:"PageUp",34:"PageDown",35:"End",36:"Home",37:"ArrowLeft",38:"ArrowUp",39:"ArrowRight",40:"ArrowDown",45:"Insert",46:"Delete",112:"F1",113:"F2",114:"F3",115:"F4",
	116:"F5",117:"F6",118:"F7",119:"F8",120:"F9",121:"F10",122:"F11",123:"F12",144:"NumLock",145:"ScrollLock",224:"Meta"},ud=Uc.extend({key:function(a){if(a.key){var b=sd[a.key]||a.key;if("Unidentified"!==b)return b}return"keypress"===a.type?(a=rd(a),13===a?"Enter":String.fromCharCode(a)):"keydown"===a.type||"keyup"===a.type?td[a.keyCode]||"Unidentified":""},location:null,ctrlKey:null,shiftKey:null,altKey:null,metaKey:null,repeat:null,locale:null,getModifierState:Xc,charCode:function(a){return"keypress"===
	a.type?rd(a):0},keyCode:function(a){return"keydown"===a.type||"keyup"===a.type?a.keyCode:0},which:function(a){return"keypress"===a.type?rd(a):"keydown"===a.type||"keyup"===a.type?a.keyCode:0}}),vd=bd.extend({dataTransfer:null}),wd=Uc.extend({touches:null,targetTouches:null,changedTouches:null,altKey:null,metaKey:null,ctrlKey:null,shiftKey:null,getModifierState:Xc}),xd=A.extend({propertyName:null,elapsedTime:null,pseudoElement:null}),yd=bd.extend({deltaX:function(a){return"deltaX"in a?a.deltaX:"wheelDeltaX"in
	a?-a.wheelDeltaX:0},deltaY:function(a){return"deltaY"in a?a.deltaY:"wheelDeltaY"in a?-a.wheelDeltaY:"wheelDelta"in a?-a.wheelDelta:0},deltaZ:null,deltaMode:null}),zd=[["abort","abort"],[Za,"animationEnd"],[$a,"animationIteration"],[ab,"animationStart"],["canplay","canPlay"],["canplaythrough","canPlayThrough"],["drag","drag"],["dragenter","dragEnter"],["dragexit","dragExit"],["dragleave","dragLeave"],["dragover","dragOver"],["durationchange","durationChange"],["emptied","emptied"],["encrypted","encrypted"],
	["ended","ended"],["error","error"],["gotpointercapture","gotPointerCapture"],["load","load"],["loadeddata","loadedData"],["loadedmetadata","loadedMetadata"],["loadstart","loadStart"],["lostpointercapture","lostPointerCapture"],["mousemove","mouseMove"],["mouseout","mouseOut"],["mouseover","mouseOver"],["playing","playing"],["pointermove","pointerMove"],["pointerout","pointerOut"],["pointerover","pointerOver"],["progress","progress"],["scroll","scroll"],["seeking","seeking"],["stalled","stalled"],
	["suspend","suspend"],["timeupdate","timeUpdate"],["toggle","toggle"],["touchmove","touchMove"],[bb,"transitionEnd"],["waiting","waiting"],["wheel","wheel"]],Ad={},Bd={};function Cd(a,b){var c=a[0];a=a[1];var d="on"+(a[0].toUpperCase()+a.slice(1));b={phasedRegistrationNames:{bubbled:d,captured:d+"Capture"},dependencies:[c],isInteractive:b};Ad[a]=b;Bd[c]=b}
	[["blur","blur"],["cancel","cancel"],["click","click"],["close","close"],["contextmenu","contextMenu"],["copy","copy"],["cut","cut"],["auxclick","auxClick"],["dblclick","doubleClick"],["dragend","dragEnd"],["dragstart","dragStart"],["drop","drop"],["focus","focus"],["input","input"],["invalid","invalid"],["keydown","keyDown"],["keypress","keyPress"],["keyup","keyUp"],["mousedown","mouseDown"],["mouseup","mouseUp"],["paste","paste"],["pause","pause"],["play","play"],["pointercancel","pointerCancel"],
	["pointerdown","pointerDown"],["pointerup","pointerUp"],["ratechange","rateChange"],["reset","reset"],["seeked","seeked"],["submit","submit"],["touchcancel","touchCancel"],["touchend","touchEnd"],["touchstart","touchStart"],["volumechange","volumeChange"]].forEach(function(a){Cd(a,!0)});zd.forEach(function(a){Cd(a,!1)});
	var Dd={eventTypes:Ad,isInteractiveTopLevelEventType:function(a){a=Bd[a];return void 0!==a&&!0===a.isInteractive},extractEvents:function(a,b,c,d){var e=Bd[a];if(!e)return null;switch(a){case "keypress":if(0===rd(c))return null;case "keydown":case "keyup":a=ud;break;case "blur":case "focus":a=qd;break;case "click":if(2===c.button)return null;case "auxclick":case "dblclick":case "mousedown":case "mousemove":case "mouseup":case "mouseout":case "mouseover":case "contextmenu":a=bd;break;case "drag":case "dragend":case "dragenter":case "dragexit":case "dragleave":case "dragover":case "dragstart":case "drop":a=
	vd;break;case "touchcancel":case "touchend":case "touchmove":case "touchstart":a=wd;break;case Za:case $a:case ab:a=od;break;case bb:a=xd;break;case "scroll":a=Uc;break;case "wheel":a=yd;break;case "copy":case "cut":case "paste":a=pd;break;case "gotpointercapture":case "lostpointercapture":case "pointercancel":case "pointerdown":case "pointermove":case "pointerout":case "pointerover":case "pointerup":a=cd;break;default:a=A}b=a.getPooled(e,b,c,d);Sa(b);return b}},Ed=Dd.isInteractiveTopLevelEventType,
	Fd=[];function Gd(a){var b=a.targetInst,c=b;do{if(!c){a.ancestors.push(c);break}var d;for(d=c;d.return;)d=d.return;d=3!==d.tag?null:d.stateNode.containerInfo;if(!d)break;a.ancestors.push(c);c=Ja(d)}while(c);for(c=0;c<a.ancestors.length;c++){b=a.ancestors[c];var e=Qb(a.nativeEvent);d=a.topLevelType;for(var f=a.nativeEvent,g=null,h=0;h<pa.length;h++){var l=pa[h];l&&(l=l.extractEvents(d,b,f,e))&&(g=za(g,l))}Fa(g)}}var Hd=!0;
	function H(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!1)}function Kd(a,b){if(!b)return null;var c=(Ed(a)?Id:Jd).bind(null,a);b.addEventListener(a,c,!0)}function Id(a,b){Kb(Jd,a,b)}
	function Jd(a,b){if(Hd){var c=Qb(b);c=Ja(c);null===c||"number"!==typeof c.tag||2===kd(c)||(c=null);if(Fd.length){var d=Fd.pop();d.topLevelType=a;d.nativeEvent=b;d.targetInst=c;a=d}else a={topLevelType:a,nativeEvent:b,targetInst:c,ancestors:[]};try{Nb(Gd,a)}finally{a.topLevelType=null,a.nativeEvent=null,a.targetInst=null,a.ancestors.length=0,10>Fd.length&&Fd.push(a)}}}var Ld={},Md=0,Nd="_reactListenersID"+(""+Math.random()).slice(2);
	function Od(a){Object.prototype.hasOwnProperty.call(a,Nd)||(a[Nd]=Md++,Ld[a[Nd]]={});return Ld[a[Nd]]}function Pd(a){a=a||("undefined"!==typeof document?document:void 0);if("undefined"===typeof a)return null;try{return a.activeElement||a.body}catch(b){return a.body}}function Qd(a){for(;a&&a.firstChild;)a=a.firstChild;return a}
	function Rd(a,b){var c=Qd(a);a=0;for(var d;c;){if(3===c.nodeType){d=a+c.textContent.length;if(a<=b&&d>=b)return{node:c,offset:b-a};a=d}a:{for(;c;){if(c.nextSibling){c=c.nextSibling;break a}c=c.parentNode}c=void 0}c=Qd(c)}}function Sd(a,b){return a&&b?a===b?!0:a&&3===a.nodeType?!1:b&&3===b.nodeType?Sd(a,b.parentNode):"contains"in a?a.contains(b):a.compareDocumentPosition?!!(a.compareDocumentPosition(b)&16):!1:!1}
	function Td(){for(var a=window,b=Pd();b instanceof a.HTMLIFrameElement;){try{a=b.contentDocument.defaultView}catch(c){break}b=Pd(a.document)}return b}function Ud(a){var b=a&&a.nodeName&&a.nodeName.toLowerCase();return b&&("input"===b&&("text"===a.type||"search"===a.type||"tel"===a.type||"url"===a.type||"password"===a.type)||"textarea"===b||"true"===a.contentEditable)}
	var Vd=Ta&&"documentMode"in document&&11>=document.documentMode,Wd={select:{phasedRegistrationNames:{bubbled:"onSelect",captured:"onSelectCapture"},dependencies:"blur contextmenu dragend focus keydown keyup mousedown mouseup selectionchange".split(" ")}},Xd=null,Yd=null,Zd=null,$d=!1;
	function ae(a,b){var c=b.window===b?b.document:9===b.nodeType?b:b.ownerDocument;if($d||null==Xd||Xd!==Pd(c))return null;c=Xd;"selectionStart"in c&&Ud(c)?c={start:c.selectionStart,end:c.selectionEnd}:(c=(c.ownerDocument&&c.ownerDocument.defaultView||window).getSelection(),c={anchorNode:c.anchorNode,anchorOffset:c.anchorOffset,focusNode:c.focusNode,focusOffset:c.focusOffset});return Zd&&hd(Zd,c)?null:(Zd=c,a=A.getPooled(Wd.select,Yd,a,b),a.type="select",a.target=Xd,Sa(a),a)}
	var be={eventTypes:Wd,extractEvents:function(a,b,c,d){var e=d.window===d?d.document:9===d.nodeType?d:d.ownerDocument,f;if(!(f=!e)){a:{e=Od(e);f=ua.onSelect;for(var g=0;g<f.length;g++){var h=f[g];if(!e.hasOwnProperty(h)||!e[h]){e=!1;break a}}e=!0}f=!e}if(f)return null;e=b?La(b):window;switch(a){case "focus":if(Pb(e)||"true"===e.contentEditable)Xd=e,Yd=b,Zd=null;break;case "blur":Zd=Yd=Xd=null;break;case "mousedown":$d=!0;break;case "contextmenu":case "mouseup":case "dragend":return $d=!1,ae(c,d);case "selectionchange":if(Vd)break;
	case "keydown":case "keyup":return ae(c,d)}return null}};Da.injectEventPluginOrder("ResponderEventPlugin SimpleEventPlugin EnterLeaveEventPlugin ChangeEventPlugin SelectEventPlugin BeforeInputEventPlugin".split(" "));va=Ma;wa=Ka;xa=La;Da.injectEventPluginsByName({SimpleEventPlugin:Dd,EnterLeaveEventPlugin:ed,ChangeEventPlugin:Tc,SelectEventPlugin:be,BeforeInputEventPlugin:Cb});function ce(a){var b="";aa.Children.forEach(a,function(a){null!=a&&(b+=a)});return b}
	function de(a,b){a=p({children:void 0},b);if(b=ce(b.children))a.children=b;return a}function ee(a,b,c,d){a=a.options;if(b){b={};for(var e=0;e<c.length;e++)b["$"+c[e]]=!0;for(c=0;c<a.length;c++)e=b.hasOwnProperty("$"+a[c].value),a[c].selected!==e&&(a[c].selected=e),e&&d&&(a[c].defaultSelected=!0)}else{c=""+yc(c);b=null;for(e=0;e<a.length;e++){if(a[e].value===c){a[e].selected=!0;d&&(a[e].defaultSelected=!0);return}null!==b||a[e].disabled||(b=a[e])}null!==b&&(b.selected=!0)}}
	function fe(a,b){null!=b.dangerouslySetInnerHTML?t("91"):void 0;return p({},b,{value:void 0,defaultValue:void 0,children:""+a._wrapperState.initialValue})}function ge(a,b){var c=b.value;null==c&&(c=b.defaultValue,b=b.children,null!=b&&(null!=c?t("92"):void 0,Array.isArray(b)&&(1>=b.length?void 0:t("93"),b=b[0]),c=b),null==c&&(c=""));a._wrapperState={initialValue:yc(c)}}
	function he(a,b){var c=yc(b.value),d=yc(b.defaultValue);null!=c&&(c=""+c,c!==a.value&&(a.value=c),null==b.defaultValue&&a.defaultValue!==c&&(a.defaultValue=c));null!=d&&(a.defaultValue=""+d)}function ie(a){var b=a.textContent;b===a._wrapperState.initialValue&&(a.value=b)}var je={html:"http://www.w3.org/1999/xhtml",mathml:"http://www.w3.org/1998/Math/MathML",svg:"http://www.w3.org/2000/svg"};
	function ke(a){switch(a){case "svg":return"http://www.w3.org/2000/svg";case "math":return"http://www.w3.org/1998/Math/MathML";default:return"http://www.w3.org/1999/xhtml"}}function le(a,b){return null==a||"http://www.w3.org/1999/xhtml"===a?ke(b):"http://www.w3.org/2000/svg"===a&&"foreignObject"===b?"http://www.w3.org/1999/xhtml":a}
	var me=void 0,ne=function(a){return"undefined"!==typeof MSApp&&MSApp.execUnsafeLocalFunction?function(b,c,d,e){MSApp.execUnsafeLocalFunction(function(){return a(b,c,d,e)})}:a}(function(a,b){if(a.namespaceURI!==je.svg||"innerHTML"in a)a.innerHTML=b;else{me=me||document.createElement("div");me.innerHTML="<svg>"+b+"</svg>";for(b=me.firstChild;a.firstChild;)a.removeChild(a.firstChild);for(;b.firstChild;)a.appendChild(b.firstChild)}});
	function oe(a,b){if(b){var c=a.firstChild;if(c&&c===a.lastChild&&3===c.nodeType){c.nodeValue=b;return}}a.textContent=b}
	var pe={animationIterationCount:!0,borderImageOutset:!0,borderImageSlice:!0,borderImageWidth:!0,boxFlex:!0,boxFlexGroup:!0,boxOrdinalGroup:!0,columnCount:!0,columns:!0,flex:!0,flexGrow:!0,flexPositive:!0,flexShrink:!0,flexNegative:!0,flexOrder:!0,gridArea:!0,gridRow:!0,gridRowEnd:!0,gridRowSpan:!0,gridRowStart:!0,gridColumn:!0,gridColumnEnd:!0,gridColumnSpan:!0,gridColumnStart:!0,fontWeight:!0,lineClamp:!0,lineHeight:!0,opacity:!0,order:!0,orphans:!0,tabSize:!0,widows:!0,zIndex:!0,zoom:!0,fillOpacity:!0,
	floodOpacity:!0,stopOpacity:!0,strokeDasharray:!0,strokeDashoffset:!0,strokeMiterlimit:!0,strokeOpacity:!0,strokeWidth:!0},qe=["Webkit","ms","Moz","O"];Object.keys(pe).forEach(function(a){qe.forEach(function(b){b=b+a.charAt(0).toUpperCase()+a.substring(1);pe[b]=pe[a]})});function re(a,b,c){return null==b||"boolean"===typeof b||""===b?"":c||"number"!==typeof b||0===b||pe.hasOwnProperty(a)&&pe[a]?(""+b).trim():b+"px"}
	function se(a,b){a=a.style;for(var c in b)if(b.hasOwnProperty(c)){var d=0===c.indexOf("--"),e=re(c,b[c],d);"float"===c&&(c="cssFloat");d?a.setProperty(c,e):a[c]=e}}var te=p({menuitem:!0},{area:!0,base:!0,br:!0,col:!0,embed:!0,hr:!0,img:!0,input:!0,keygen:!0,link:!0,meta:!0,param:!0,source:!0,track:!0,wbr:!0});
	function ue(a,b){b&&(te[a]&&(null!=b.children||null!=b.dangerouslySetInnerHTML?t("137",a,""):void 0),null!=b.dangerouslySetInnerHTML&&(null!=b.children?t("60"):void 0,"object"===typeof b.dangerouslySetInnerHTML&&"__html"in b.dangerouslySetInnerHTML?void 0:t("61")),null!=b.style&&"object"!==typeof b.style?t("62",""):void 0)}
	function ve(a,b){if(-1===a.indexOf("-"))return"string"===typeof b.is;switch(a){case "annotation-xml":case "color-profile":case "font-face":case "font-face-src":case "font-face-uri":case "font-face-format":case "font-face-name":case "missing-glyph":return!1;default:return!0}}
	function we(a,b){a=9===a.nodeType||11===a.nodeType?a:a.ownerDocument;var c=Od(a);b=ua[b];for(var d=0;d<b.length;d++){var e=b[d];if(!c.hasOwnProperty(e)||!c[e]){switch(e){case "scroll":Kd("scroll",a);break;case "focus":case "blur":Kd("focus",a);Kd("blur",a);c.blur=!0;c.focus=!0;break;case "cancel":case "close":Sb(e)&&Kd(e,a);break;case "invalid":case "submit":case "reset":break;default:-1===cb.indexOf(e)&&H(e,a)}c[e]=!0}}}function xe(){}var ye=null,ze=null;
	function Ae(a,b){switch(a){case "button":case "input":case "select":case "textarea":return!!b.autoFocus}return!1}function Be(a,b){return"textarea"===a||"option"===a||"noscript"===a||"string"===typeof b.children||"number"===typeof b.children||"object"===typeof b.dangerouslySetInnerHTML&&null!==b.dangerouslySetInnerHTML&&null!=b.dangerouslySetInnerHTML.__html}
	var Ce="function"===typeof setTimeout?setTimeout:void 0,De="function"===typeof clearTimeout?clearTimeout:void 0,Ee=ba.unstable_scheduleCallback,Fe=ba.unstable_cancelCallback;
	function Ge(a,b,c,d,e){a[Ia]=e;"input"===c&&"radio"===e.type&&null!=e.name&&Bc(a,e);ve(c,d);d=ve(c,e);for(var f=0;f<b.length;f+=2){var g=b[f],h=b[f+1];"style"===g?se(a,h):"dangerouslySetInnerHTML"===g?ne(a,h):"children"===g?oe(a,h):xc(a,g,h,d)}switch(c){case "input":Cc(a,e);break;case "textarea":he(a,e);break;case "select":b=a._wrapperState.wasMultiple,a._wrapperState.wasMultiple=!!e.multiple,c=e.value,null!=c?ee(a,!!e.multiple,c,!1):b!==!!e.multiple&&(null!=e.defaultValue?ee(a,!!e.multiple,e.defaultValue,
	!0):ee(a,!!e.multiple,e.multiple?[]:"",!1))}}function He(a){for(a=a.nextSibling;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}function Ie(a){for(a=a.firstChild;a&&1!==a.nodeType&&3!==a.nodeType;)a=a.nextSibling;return a}new Set;var Je=[],Ke=-1;function I(a){0>Ke||(a.current=Je[Ke],Je[Ke]=null,Ke--)}function J(a,b){Ke++;Je[Ke]=a.current;a.current=b}var Le={},K={current:Le},L={current:!1},Me=Le;
	function Oe(a,b){var c=a.type.contextTypes;if(!c)return Le;var d=a.stateNode;if(d&&d.__reactInternalMemoizedUnmaskedChildContext===b)return d.__reactInternalMemoizedMaskedChildContext;var e={},f;for(f in c)e[f]=b[f];d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=b,a.__reactInternalMemoizedMaskedChildContext=e);return e}function M(a){a=a.childContextTypes;return null!==a&&void 0!==a}function Pe(a){I(L,a);I(K,a)}function Qe(a){I(L,a);I(K,a)}
	function Re(a,b,c){K.current!==Le?t("168"):void 0;J(K,b,a);J(L,c,a)}function Se(a,b,c){var d=a.stateNode;a=b.childContextTypes;if("function"!==typeof d.getChildContext)return c;d=d.getChildContext();for(var e in d)e in a?void 0:t("108",mc(b)||"Unknown",e);return p({},c,d)}function Te(a){var b=a.stateNode;b=b&&b.__reactInternalMemoizedMergedChildContext||Le;Me=K.current;J(K,b,a);J(L,L.current,a);return!0}
	function Ue(a,b,c){var d=a.stateNode;d?void 0:t("169");c?(b=Se(a,b,Me),d.__reactInternalMemoizedMergedChildContext=b,I(L,a),I(K,a),J(K,b,a)):I(L,a);J(L,c,a)}var Ve=null,We=null;function Xe(a){return function(b){try{return a(b)}catch(c){}}}
	function Ye(a){if("undefined"===typeof __REACT_DEVTOOLS_GLOBAL_HOOK__)return!1;var b=__REACT_DEVTOOLS_GLOBAL_HOOK__;if(b.isDisabled||!b.supportsFiber)return!0;try{var c=b.inject(a);Ve=Xe(function(a){return b.onCommitFiberRoot(c,a)});We=Xe(function(a){return b.onCommitFiberUnmount(c,a)})}catch(d){}return!0}
	function Ze(a,b,c,d){this.tag=a;this.key=c;this.sibling=this.child=this.return=this.stateNode=this.type=this.elementType=null;this.index=0;this.ref=null;this.pendingProps=b;this.contextDependencies=this.memoizedState=this.updateQueue=this.memoizedProps=null;this.mode=d;this.effectTag=0;this.lastEffect=this.firstEffect=this.nextEffect=null;this.childExpirationTime=this.expirationTime=0;this.alternate=null}function N(a,b,c,d){return new Ze(a,b,c,d)}
	function $e(a){a=a.prototype;return!(!a||!a.isReactComponent)}function af(a){if("function"===typeof a)return $e(a)?1:0;if(void 0!==a&&null!==a){a=a.$$typeof;if(a===gc)return 11;if(a===ic)return 14}return 2}
	function bf(a,b){var c=a.alternate;null===c?(c=N(a.tag,b,a.key,a.mode),c.elementType=a.elementType,c.type=a.type,c.stateNode=a.stateNode,c.alternate=a,a.alternate=c):(c.pendingProps=b,c.effectTag=0,c.nextEffect=null,c.firstEffect=null,c.lastEffect=null);c.childExpirationTime=a.childExpirationTime;c.expirationTime=a.expirationTime;c.child=a.child;c.memoizedProps=a.memoizedProps;c.memoizedState=a.memoizedState;c.updateQueue=a.updateQueue;c.contextDependencies=a.contextDependencies;c.sibling=a.sibling;
	c.index=a.index;c.ref=a.ref;return c}
	function cf(a,b,c,d,e,f){var g=2;d=a;if("function"===typeof a)$e(a)&&(g=1);else if("string"===typeof a)g=5;else a:switch(a){case ac:return df(c.children,e,f,b);case fc:return ef(c,e|3,f,b);case bc:return ef(c,e|2,f,b);case cc:return a=N(12,c,b,e|4),a.elementType=cc,a.type=cc,a.expirationTime=f,a;case hc:return a=N(13,c,b,e),a.elementType=hc,a.type=hc,a.expirationTime=f,a;default:if("object"===typeof a&&null!==a)switch(a.$$typeof){case dc:g=10;break a;case ec:g=9;break a;case gc:g=11;break a;case ic:g=
	14;break a;case jc:g=16;d=null;break a}t("130",null==a?a:typeof a,"")}b=N(g,c,b,e);b.elementType=a;b.type=d;b.expirationTime=f;return b}function df(a,b,c,d){a=N(7,a,d,b);a.expirationTime=c;return a}function ef(a,b,c,d){a=N(8,a,d,b);b=0===(b&1)?bc:fc;a.elementType=b;a.type=b;a.expirationTime=c;return a}function ff(a,b,c){a=N(6,a,null,b);a.expirationTime=c;return a}
	function gf(a,b,c){b=N(4,null!==a.children?a.children:[],a.key,b);b.expirationTime=c;b.stateNode={containerInfo:a.containerInfo,pendingChildren:null,implementation:a.implementation};return b}function hf(a,b){a.didError=!1;var c=a.earliestPendingTime;0===c?a.earliestPendingTime=a.latestPendingTime=b:c<b?a.earliestPendingTime=b:a.latestPendingTime>b&&(a.latestPendingTime=b);jf(b,a)}
	function kf(a,b){a.didError=!1;a.latestPingedTime>=b&&(a.latestPingedTime=0);var c=a.earliestPendingTime,d=a.latestPendingTime;c===b?a.earliestPendingTime=d===b?a.latestPendingTime=0:d:d===b&&(a.latestPendingTime=c);c=a.earliestSuspendedTime;d=a.latestSuspendedTime;0===c?a.earliestSuspendedTime=a.latestSuspendedTime=b:c<b?a.earliestSuspendedTime=b:d>b&&(a.latestSuspendedTime=b);jf(b,a)}function lf(a,b){var c=a.earliestPendingTime;a=a.earliestSuspendedTime;c>b&&(b=c);a>b&&(b=a);return b}
	function jf(a,b){var c=b.earliestSuspendedTime,d=b.latestSuspendedTime,e=b.earliestPendingTime,f=b.latestPingedTime;e=0!==e?e:f;0===e&&(0===a||d<a)&&(e=d);a=e;0!==a&&c>a&&(a=c);b.nextExpirationTimeToWorkOn=e;b.expirationTime=a}function P(a,b){if(a&&a.defaultProps){b=p({},b);a=a.defaultProps;for(var c in a)void 0===b[c]&&(b[c]=a[c])}return b}
	function mf(a){var b=a._result;switch(a._status){case 1:return b;case 2:throw b;case 0:throw b;default:a._status=0;b=a._ctor;b=b();b.then(function(b){0===a._status&&(b=b.default,a._status=1,a._result=b)},function(b){0===a._status&&(a._status=2,a._result=b)});switch(a._status){case 1:return a._result;case 2:throw a._result;}a._result=b;throw b;}}var nf=(new aa.Component).refs;
	function of(a,b,c,d){b=a.memoizedState;c=c(d,b);c=null===c||void 0===c?b:p({},b,c);a.memoizedState=c;d=a.updateQueue;null!==d&&0===a.expirationTime&&(d.baseState=c)}
	var xf={isMounted:function(a){return(a=a._reactInternalFiber)?2===kd(a):!1},enqueueSetState:function(a,b,c){a=a._reactInternalFiber;var d=pf();d=qf(d,a);var e=rf(d);e.payload=b;void 0!==c&&null!==c&&(e.callback=c);sf();tf(a,e);uf(a,d)},enqueueReplaceState:function(a,b,c){a=a._reactInternalFiber;var d=pf();d=qf(d,a);var e=rf(d);e.tag=vf;e.payload=b;void 0!==c&&null!==c&&(e.callback=c);sf();tf(a,e);uf(a,d)},enqueueForceUpdate:function(a,b){a=a._reactInternalFiber;var c=pf();c=qf(c,a);var d=rf(c);d.tag=
	wf;void 0!==b&&null!==b&&(d.callback=b);sf();tf(a,d);uf(a,c)}};function yf(a,b,c,d,e,f,g){a=a.stateNode;return"function"===typeof a.shouldComponentUpdate?a.shouldComponentUpdate(d,f,g):b.prototype&&b.prototype.isPureReactComponent?!hd(c,d)||!hd(e,f):!0}
	function zf(a,b,c){var d=!1,e=Le;var f=b.contextType;"object"===typeof f&&null!==f?f=Af(f):(e=M(b)?Me:K.current,d=b.contextTypes,f=(d=null!==d&&void 0!==d)?Oe(a,e):Le);b=new b(c,f);a.memoizedState=null!==b.state&&void 0!==b.state?b.state:null;b.updater=xf;a.stateNode=b;b._reactInternalFiber=a;d&&(a=a.stateNode,a.__reactInternalMemoizedUnmaskedChildContext=e,a.__reactInternalMemoizedMaskedChildContext=f);return b}
	function Bf(a,b,c,d){a=b.state;"function"===typeof b.componentWillReceiveProps&&b.componentWillReceiveProps(c,d);"function"===typeof b.UNSAFE_componentWillReceiveProps&&b.UNSAFE_componentWillReceiveProps(c,d);b.state!==a&&xf.enqueueReplaceState(b,b.state,null)}
	function Cf(a,b,c,d){var e=a.stateNode;e.props=c;e.state=a.memoizedState;e.refs=nf;var f=b.contextType;"object"===typeof f&&null!==f?e.context=Af(f):(f=M(b)?Me:K.current,e.context=Oe(a,f));f=a.updateQueue;null!==f&&(Df(a,f,c,e,d),e.state=a.memoizedState);f=b.getDerivedStateFromProps;"function"===typeof f&&(of(a,b,f,c),e.state=a.memoizedState);"function"===typeof b.getDerivedStateFromProps||"function"===typeof e.getSnapshotBeforeUpdate||"function"!==typeof e.UNSAFE_componentWillMount&&"function"!==
	typeof e.componentWillMount||(b=e.state,"function"===typeof e.componentWillMount&&e.componentWillMount(),"function"===typeof e.UNSAFE_componentWillMount&&e.UNSAFE_componentWillMount(),b!==e.state&&xf.enqueueReplaceState(e,e.state,null),f=a.updateQueue,null!==f&&(Df(a,f,c,e,d),e.state=a.memoizedState));"function"===typeof e.componentDidMount&&(a.effectTag|=4)}var Ef=Array.isArray;
	function Ff(a,b,c){a=c.ref;if(null!==a&&"function"!==typeof a&&"object"!==typeof a){if(c._owner){c=c._owner;var d=void 0;c&&(1!==c.tag?t("309"):void 0,d=c.stateNode);d?void 0:t("147",a);var e=""+a;if(null!==b&&null!==b.ref&&"function"===typeof b.ref&&b.ref._stringRef===e)return b.ref;b=function(a){var b=d.refs;b===nf&&(b=d.refs={});null===a?delete b[e]:b[e]=a};b._stringRef=e;return b}"string"!==typeof a?t("284"):void 0;c._owner?void 0:t("290",a)}return a}
	function Gf(a,b){"textarea"!==a.type&&t("31","[object Object]"===Object.prototype.toString.call(b)?"object with keys {"+Object.keys(b).join(", ")+"}":b,"")}
	function Hf(a){function b(b,c){if(a){var d=b.lastEffect;null!==d?(d.nextEffect=c,b.lastEffect=c):b.firstEffect=b.lastEffect=c;c.nextEffect=null;c.effectTag=8}}function c(c,d){if(!a)return null;for(;null!==d;)b(c,d),d=d.sibling;return null}function d(a,b){for(a=new Map;null!==b;)null!==b.key?a.set(b.key,b):a.set(b.index,b),b=b.sibling;return a}function e(a,b,c){a=bf(a,b,c);a.index=0;a.sibling=null;return a}function f(b,c,d){b.index=d;if(!a)return c;d=b.alternate;if(null!==d)return d=d.index,d<c?(b.effectTag=
	2,c):d;b.effectTag=2;return c}function g(b){a&&null===b.alternate&&(b.effectTag=2);return b}function h(a,b,c,d){if(null===b||6!==b.tag)return b=ff(c,a.mode,d),b.return=a,b;b=e(b,c,d);b.return=a;return b}function l(a,b,c,d){if(null!==b&&b.elementType===c.type)return d=e(b,c.props,d),d.ref=Ff(a,b,c),d.return=a,d;d=cf(c.type,c.key,c.props,null,a.mode,d);d.ref=Ff(a,b,c);d.return=a;return d}function k(a,b,c,d){if(null===b||4!==b.tag||b.stateNode.containerInfo!==c.containerInfo||b.stateNode.implementation!==
	c.implementation)return b=gf(c,a.mode,d),b.return=a,b;b=e(b,c.children||[],d);b.return=a;return b}function m(a,b,c,d,f){if(null===b||7!==b.tag)return b=df(c,a.mode,d,f),b.return=a,b;b=e(b,c,d);b.return=a;return b}function q(a,b,c){if("string"===typeof b||"number"===typeof b)return b=ff(""+b,a.mode,c),b.return=a,b;if("object"===typeof b&&null!==b){switch(b.$$typeof){case Zb:return c=cf(b.type,b.key,b.props,null,a.mode,c),c.ref=Ff(a,null,b),c.return=a,c;case $b:return b=gf(b,a.mode,c),b.return=a,b}if(Ef(b)||
	lc(b))return b=df(b,a.mode,c,null),b.return=a,b;Gf(a,b)}return null}function x(a,b,c,d){var e=null!==b?b.key:null;if("string"===typeof c||"number"===typeof c)return null!==e?null:h(a,b,""+c,d);if("object"===typeof c&&null!==c){switch(c.$$typeof){case Zb:return c.key===e?c.type===ac?m(a,b,c.props.children,d,e):l(a,b,c,d):null;case $b:return c.key===e?k(a,b,c,d):null}if(Ef(c)||lc(c))return null!==e?null:m(a,b,c,d,null);Gf(a,c)}return null}function C(a,b,c,d,e){if("string"===typeof d||"number"===typeof d)return a=
	a.get(c)||null,h(b,a,""+d,e);if("object"===typeof d&&null!==d){switch(d.$$typeof){case Zb:return a=a.get(null===d.key?c:d.key)||null,d.type===ac?m(b,a,d.props.children,e,d.key):l(b,a,d,e);case $b:return a=a.get(null===d.key?c:d.key)||null,k(b,a,d,e)}if(Ef(d)||lc(d))return a=a.get(c)||null,m(b,a,d,e,null);Gf(b,d)}return null}function w(e,g,h,k){for(var l=null,m=null,n=g,u=g=0,r=null;null!==n&&u<h.length;u++){n.index>u?(r=n,n=null):r=n.sibling;var v=x(e,n,h[u],k);if(null===v){null===n&&(n=r);break}a&&
	n&&null===v.alternate&&b(e,n);g=f(v,g,u);null===m?l=v:m.sibling=v;m=v;n=r}if(u===h.length)return c(e,n),l;if(null===n){for(;u<h.length;u++)if(n=q(e,h[u],k))g=f(n,g,u),null===m?l=n:m.sibling=n,m=n;return l}for(n=d(e,n);u<h.length;u++)if(r=C(n,e,u,h[u],k))a&&null!==r.alternate&&n.delete(null===r.key?u:r.key),g=f(r,g,u),null===m?l=r:m.sibling=r,m=r;a&&n.forEach(function(a){return b(e,a)});return l}function E(e,g,h,k){var l=lc(h);"function"!==typeof l?t("150"):void 0;h=l.call(h);null==h?t("151"):void 0;
	for(var m=l=null,n=g,u=g=0,r=null,v=h.next();null!==n&&!v.done;u++,v=h.next()){n.index>u?(r=n,n=null):r=n.sibling;var z=x(e,n,v.value,k);if(null===z){n||(n=r);break}a&&n&&null===z.alternate&&b(e,n);g=f(z,g,u);null===m?l=z:m.sibling=z;m=z;n=r}if(v.done)return c(e,n),l;if(null===n){for(;!v.done;u++,v=h.next())v=q(e,v.value,k),null!==v&&(g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);return l}for(n=d(e,n);!v.done;u++,v=h.next())v=C(n,e,u,v.value,k),null!==v&&(a&&null!==v.alternate&&n.delete(null===v.key?u:
	v.key),g=f(v,g,u),null===m?l=v:m.sibling=v,m=v);a&&n.forEach(function(a){return b(e,a)});return l}return function(a,d,f,h){var k="object"===typeof f&&null!==f&&f.type===ac&&null===f.key;k&&(f=f.props.children);var l="object"===typeof f&&null!==f;if(l)switch(f.$$typeof){case Zb:a:{l=f.key;for(k=d;null!==k;){if(k.key===l)if(7===k.tag?f.type===ac:k.elementType===f.type){c(a,k.sibling);d=e(k,f.type===ac?f.props.children:f.props,h);d.ref=Ff(a,k,f);d.return=a;a=d;break a}else{c(a,k);break}else b(a,k);k=
	k.sibling}f.type===ac?(d=df(f.props.children,a.mode,h,f.key),d.return=a,a=d):(h=cf(f.type,f.key,f.props,null,a.mode,h),h.ref=Ff(a,d,f),h.return=a,a=h)}return g(a);case $b:a:{for(k=f.key;null!==d;){if(d.key===k)if(4===d.tag&&d.stateNode.containerInfo===f.containerInfo&&d.stateNode.implementation===f.implementation){c(a,d.sibling);d=e(d,f.children||[],h);d.return=a;a=d;break a}else{c(a,d);break}else b(a,d);d=d.sibling}d=gf(f,a.mode,h);d.return=a;a=d}return g(a)}if("string"===typeof f||"number"===typeof f)return f=
	""+f,null!==d&&6===d.tag?(c(a,d.sibling),d=e(d,f,h),d.return=a,a=d):(c(a,d),d=ff(f,a.mode,h),d.return=a,a=d),g(a);if(Ef(f))return w(a,d,f,h);if(lc(f))return E(a,d,f,h);l&&Gf(a,f);if("undefined"===typeof f&&!k)switch(a.tag){case 1:case 0:h=a.type,t("152",h.displayName||h.name||"Component")}return c(a,d)}}var If=Hf(!0),Jf=Hf(!1),Kf={},Lf={current:Kf},Mf={current:Kf},Nf={current:Kf};function Of(a){a===Kf?t("174"):void 0;return a}
	function Pf(a,b){J(Nf,b,a);J(Mf,a,a);J(Lf,Kf,a);var c=b.nodeType;switch(c){case 9:case 11:b=(b=b.documentElement)?b.namespaceURI:le(null,"");break;default:c=8===c?b.parentNode:b,b=c.namespaceURI||null,c=c.tagName,b=le(b,c)}I(Lf,a);J(Lf,b,a)}function Qf(a){I(Lf,a);I(Mf,a);I(Nf,a)}function Rf(a){Of(Nf.current);var b=Of(Lf.current);var c=le(b,a.type);b!==c&&(J(Mf,a,a),J(Lf,c,a))}function Sf(a){Mf.current===a&&(I(Lf,a),I(Mf,a))}
	var Tf=0,Uf=2,Vf=4,Wf=8,Xf=16,Yf=32,Zf=64,$f=128,ag=Xb.ReactCurrentDispatcher,bg=0,cg=null,Q=null,dg=null,eg=null,R=null,fg=null,gg=0,hg=null,ig=0,jg=!1,kg=null,lg=0;function mg(){t("307")}function ng(a,b){if(null===b)return!1;for(var c=0;c<b.length&&c<a.length;c++)if(!fd(a[c],b[c]))return!1;return!0}
	function og(a,b,c,d,e,f){bg=f;cg=b;dg=null!==a?a.memoizedState:null;ag.current=null===dg?pg:qg;b=c(d,e);if(jg){do jg=!1,lg+=1,dg=null!==a?a.memoizedState:null,fg=eg,hg=R=Q=null,ag.current=qg,b=c(d,e);while(jg);kg=null;lg=0}ag.current=rg;a=cg;a.memoizedState=eg;a.expirationTime=gg;a.updateQueue=hg;a.effectTag|=ig;a=null!==Q&&null!==Q.next;bg=0;fg=R=eg=dg=Q=cg=null;gg=0;hg=null;ig=0;a?t("300"):void 0;return b}
	function sg(){ag.current=rg;bg=0;fg=R=eg=dg=Q=cg=null;gg=0;hg=null;ig=0;jg=!1;kg=null;lg=0}function tg(){var a={memoizedState:null,baseState:null,queue:null,baseUpdate:null,next:null};null===R?eg=R=a:R=R.next=a;return R}function ug(){if(null!==fg)R=fg,fg=R.next,Q=dg,dg=null!==Q?Q.next:null;else{null===dg?t("310"):void 0;Q=dg;var a={memoizedState:Q.memoizedState,baseState:Q.baseState,queue:Q.queue,baseUpdate:Q.baseUpdate,next:null};R=null===R?eg=a:R.next=a;dg=Q.next}return R}
	function vg(a,b){return"function"===typeof b?b(a):b}
	function wg(a){var b=ug(),c=b.queue;null===c?t("311"):void 0;if(0<lg){var d=c.dispatch;if(null!==kg){var e=kg.get(c);if(void 0!==e){kg.delete(c);var f=b.memoizedState;do f=a(f,e.action),e=e.next;while(null!==e);fd(f,b.memoizedState)||(xg=!0);b.memoizedState=f;b.baseUpdate===c.last&&(b.baseState=f);return[f,d]}}return[b.memoizedState,d]}d=c.last;var g=b.baseUpdate;f=b.baseState;null!==g?(null!==d&&(d.next=null),d=g.next):d=null!==d?d.next:null;if(null!==d){var h=e=null,l=d,k=!1;do{var m=l.expirationTime;
	m<bg?(k||(k=!0,h=g,e=f),m>gg&&(gg=m)):f=l.eagerReducer===a?l.eagerState:a(f,l.action);g=l;l=l.next}while(null!==l&&l!==d);k||(h=g,e=f);fd(f,b.memoizedState)||(xg=!0);b.memoizedState=f;b.baseUpdate=h;b.baseState=e;c.eagerReducer=a;c.eagerState=f}return[b.memoizedState,c.dispatch]}
	function yg(a,b,c,d){a={tag:a,create:b,destroy:c,deps:d,next:null};null===hg?(hg={lastEffect:null},hg.lastEffect=a.next=a):(b=hg.lastEffect,null===b?hg.lastEffect=a.next=a:(c=b.next,b.next=a,a.next=c,hg.lastEffect=a));return a}function zg(a,b,c,d){var e=tg();ig|=a;e.memoizedState=yg(b,c,void 0,void 0===d?null:d)}
	function Bg(a,b,c,d){var e=ug();d=void 0===d?null:d;var f=void 0;if(null!==Q){var g=Q.memoizedState;f=g.destroy;if(null!==d&&ng(d,g.deps)){yg(Tf,c,f,d);return}}ig|=a;e.memoizedState=yg(b,c,f,d)}function Cg(a,b){if("function"===typeof b)return a=a(),b(a),function(){b(null)};if(null!==b&&void 0!==b)return a=a(),b.current=a,function(){b.current=null}}function Dg(){}
	function Eg(a,b,c){25>lg?void 0:t("301");var d=a.alternate;if(a===cg||null!==d&&d===cg)if(jg=!0,a={expirationTime:bg,action:c,eagerReducer:null,eagerState:null,next:null},null===kg&&(kg=new Map),c=kg.get(b),void 0===c)kg.set(b,a);else{for(b=c;null!==b.next;)b=b.next;b.next=a}else{sf();var e=pf();e=qf(e,a);var f={expirationTime:e,action:c,eagerReducer:null,eagerState:null,next:null},g=b.last;if(null===g)f.next=f;else{var h=g.next;null!==h&&(f.next=h);g.next=f}b.last=f;if(0===a.expirationTime&&(null===
	d||0===d.expirationTime)&&(d=b.eagerReducer,null!==d))try{var l=b.eagerState,k=d(l,c);f.eagerReducer=d;f.eagerState=k;if(fd(k,l))return}catch(m){}finally{}uf(a,e)}}
	var rg={readContext:Af,useCallback:mg,useContext:mg,useEffect:mg,useImperativeHandle:mg,useLayoutEffect:mg,useMemo:mg,useReducer:mg,useRef:mg,useState:mg,useDebugValue:mg},pg={readContext:Af,useCallback:function(a,b){tg().memoizedState=[a,void 0===b?null:b];return a},useContext:Af,useEffect:function(a,b){return zg(516,$f|Zf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):[a];return zg(4,Vf|Yf,Cg.bind(null,b,a),c)},useLayoutEffect:function(a,b){return zg(4,Vf|Yf,a,b)},
	useMemo:function(a,b){var c=tg();b=void 0===b?null:b;a=a();c.memoizedState=[a,b];return a},useReducer:function(a,b,c){var d=tg();b=void 0!==c?c(b):b;d.memoizedState=d.baseState=b;a=d.queue={last:null,dispatch:null,eagerReducer:a,eagerState:b};a=a.dispatch=Eg.bind(null,cg,a);return[d.memoizedState,a]},useRef:function(a){var b=tg();a={current:a};return b.memoizedState=a},useState:function(a){var b=tg();"function"===typeof a&&(a=a());b.memoizedState=b.baseState=a;a=b.queue={last:null,dispatch:null,eagerReducer:vg,
	eagerState:a};a=a.dispatch=Eg.bind(null,cg,a);return[b.memoizedState,a]},useDebugValue:Dg},qg={readContext:Af,useCallback:function(a,b){var c=ug();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ng(b,d[1]))return d[0];c.memoizedState=[a,b];return a},useContext:Af,useEffect:function(a,b){return Bg(516,$f|Zf,a,b)},useImperativeHandle:function(a,b,c){c=null!==c&&void 0!==c?c.concat([a]):[a];return Bg(4,Vf|Yf,Cg.bind(null,b,a),c)},useLayoutEffect:function(a,b){return Bg(4,Vf|Yf,a,b)},
	useMemo:function(a,b){var c=ug();b=void 0===b?null:b;var d=c.memoizedState;if(null!==d&&null!==b&&ng(b,d[1]))return d[0];a=a();c.memoizedState=[a,b];return a},useReducer:wg,useRef:function(){return ug().memoizedState},useState:function(a){return wg(vg,a)},useDebugValue:Dg},Fg=null,Gg=null,Hg=!1;
	function Ig(a,b){var c=N(5,null,null,0);c.elementType="DELETED";c.type="DELETED";c.stateNode=b;c.return=a;c.effectTag=8;null!==a.lastEffect?(a.lastEffect.nextEffect=c,a.lastEffect=c):a.firstEffect=a.lastEffect=c}function Jg(a,b){switch(a.tag){case 5:var c=a.type;b=1!==b.nodeType||c.toLowerCase()!==b.nodeName.toLowerCase()?null:b;return null!==b?(a.stateNode=b,!0):!1;case 6:return b=""===a.pendingProps||3!==b.nodeType?null:b,null!==b?(a.stateNode=b,!0):!1;default:return!1}}
	function Kg(a){if(Hg){var b=Gg;if(b){var c=b;if(!Jg(a,b)){b=He(c);if(!b||!Jg(a,b)){a.effectTag|=2;Hg=!1;Fg=a;return}Ig(Fg,c)}Fg=a;Gg=Ie(b)}else a.effectTag|=2,Hg=!1,Fg=a}}function Lg(a){for(a=a.return;null!==a&&5!==a.tag&&3!==a.tag;)a=a.return;Fg=a}function Mg(a){if(a!==Fg)return!1;if(!Hg)return Lg(a),Hg=!0,!1;var b=a.type;if(5!==a.tag||"head"!==b&&"body"!==b&&!Be(b,a.memoizedProps))for(b=Gg;b;)Ig(a,b),b=He(b);Lg(a);Gg=Fg?He(a.stateNode):null;return!0}function Ng(){Gg=Fg=null;Hg=!1}
	var Og=Xb.ReactCurrentOwner,xg=!1;function S(a,b,c,d){b.child=null===a?Jf(b,null,c,d):If(b,a.child,c,d)}function Pg(a,b,c,d,e){c=c.render;var f=b.ref;Qg(b,e);d=og(a,b,c,d,f,e);if(null!==a&&!xg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Rg(a,b,e);b.effectTag|=1;S(a,b,d,e);return b.child}
	function Sg(a,b,c,d,e,f){if(null===a){var g=c.type;if("function"===typeof g&&!$e(g)&&void 0===g.defaultProps&&null===c.compare&&void 0===c.defaultProps)return b.tag=15,b.type=g,Tg(a,b,g,d,e,f);a=cf(c.type,null,d,null,b.mode,f);a.ref=b.ref;a.return=b;return b.child=a}g=a.child;if(e<f&&(e=g.memoizedProps,c=c.compare,c=null!==c?c:hd,c(e,d)&&a.ref===b.ref))return Rg(a,b,f);b.effectTag|=1;a=bf(g,d,f);a.ref=b.ref;a.return=b;return b.child=a}
	function Tg(a,b,c,d,e,f){return null!==a&&hd(a.memoizedProps,d)&&a.ref===b.ref&&(xg=!1,e<f)?Rg(a,b,f):Ug(a,b,c,d,f)}function Vg(a,b){var c=b.ref;if(null===a&&null!==c||null!==a&&a.ref!==c)b.effectTag|=128}function Ug(a,b,c,d,e){var f=M(c)?Me:K.current;f=Oe(b,f);Qg(b,e);c=og(a,b,c,d,f,e);if(null!==a&&!xg)return b.updateQueue=a.updateQueue,b.effectTag&=-517,a.expirationTime<=e&&(a.expirationTime=0),Rg(a,b,e);b.effectTag|=1;S(a,b,c,e);return b.child}
	function Wg(a,b,c,d,e){if(M(c)){var f=!0;Te(b)}else f=!1;Qg(b,e);if(null===b.stateNode)null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),zf(b,c,d,e),Cf(b,c,d,e),d=!0;else if(null===a){var g=b.stateNode,h=b.memoizedProps;g.props=h;var l=g.context,k=c.contextType;"object"===typeof k&&null!==k?k=Af(k):(k=M(c)?Me:K.current,k=Oe(b,k));var m=c.getDerivedStateFromProps,q="function"===typeof m||"function"===typeof g.getSnapshotBeforeUpdate;q||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&
	"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&Bf(b,g,d,k);Xg=!1;var x=b.memoizedState;l=g.state=x;var C=b.updateQueue;null!==C&&(Df(b,C,d,g,e),l=b.memoizedState);h!==d||x!==l||L.current||Xg?("function"===typeof m&&(of(b,c,m,d),l=b.memoizedState),(h=Xg||yf(b,c,h,d,x,l,k))?(q||"function"!==typeof g.UNSAFE_componentWillMount&&"function"!==typeof g.componentWillMount||("function"===typeof g.componentWillMount&&g.componentWillMount(),"function"===typeof g.UNSAFE_componentWillMount&&
	g.UNSAFE_componentWillMount()),"function"===typeof g.componentDidMount&&(b.effectTag|=4)):("function"===typeof g.componentDidMount&&(b.effectTag|=4),b.memoizedProps=d,b.memoizedState=l),g.props=d,g.state=l,g.context=k,d=h):("function"===typeof g.componentDidMount&&(b.effectTag|=4),d=!1)}else g=b.stateNode,h=b.memoizedProps,g.props=b.type===b.elementType?h:P(b.type,h),l=g.context,k=c.contextType,"object"===typeof k&&null!==k?k=Af(k):(k=M(c)?Me:K.current,k=Oe(b,k)),m=c.getDerivedStateFromProps,(q="function"===
	typeof m||"function"===typeof g.getSnapshotBeforeUpdate)||"function"!==typeof g.UNSAFE_componentWillReceiveProps&&"function"!==typeof g.componentWillReceiveProps||(h!==d||l!==k)&&Bf(b,g,d,k),Xg=!1,l=b.memoizedState,x=g.state=l,C=b.updateQueue,null!==C&&(Df(b,C,d,g,e),x=b.memoizedState),h!==d||l!==x||L.current||Xg?("function"===typeof m&&(of(b,c,m,d),x=b.memoizedState),(m=Xg||yf(b,c,h,d,l,x,k))?(q||"function"!==typeof g.UNSAFE_componentWillUpdate&&"function"!==typeof g.componentWillUpdate||("function"===
	typeof g.componentWillUpdate&&g.componentWillUpdate(d,x,k),"function"===typeof g.UNSAFE_componentWillUpdate&&g.UNSAFE_componentWillUpdate(d,x,k)),"function"===typeof g.componentDidUpdate&&(b.effectTag|=4),"function"===typeof g.getSnapshotBeforeUpdate&&(b.effectTag|=256)):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),b.memoizedProps=d,b.memoizedState=
	x),g.props=d,g.state=x,g.context=k,d=m):("function"!==typeof g.componentDidUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=4),"function"!==typeof g.getSnapshotBeforeUpdate||h===a.memoizedProps&&l===a.memoizedState||(b.effectTag|=256),d=!1);return Yg(a,b,c,d,f,e)}
	function Yg(a,b,c,d,e,f){Vg(a,b);var g=0!==(b.effectTag&64);if(!d&&!g)return e&&Ue(b,c,!1),Rg(a,b,f);d=b.stateNode;Og.current=b;var h=g&&"function"!==typeof c.getDerivedStateFromError?null:d.render();b.effectTag|=1;null!==a&&g?(b.child=If(b,a.child,null,f),b.child=If(b,null,h,f)):S(a,b,h,f);b.memoizedState=d.state;e&&Ue(b,c,!0);return b.child}function Zg(a){var b=a.stateNode;b.pendingContext?Re(a,b.pendingContext,b.pendingContext!==b.context):b.context&&Re(a,b.context,!1);Pf(a,b.containerInfo)}
	function $g(a,b,c){var d=b.mode,e=b.pendingProps,f=b.memoizedState;if(0===(b.effectTag&64)){f=null;var g=!1}else f={timedOutAt:null!==f?f.timedOutAt:0},g=!0,b.effectTag&=-65;if(null===a)if(g){var h=e.fallback;a=df(null,d,0,null);0===(b.mode&1)&&(a.child=null!==b.memoizedState?b.child.child:b.child);d=df(h,d,c,null);a.sibling=d;c=a;c.return=d.return=b}else c=d=Jf(b,null,e.children,c);else null!==a.memoizedState?(d=a.child,h=d.sibling,g?(c=e.fallback,e=bf(d,d.pendingProps,0),0===(b.mode&1)&&(g=null!==
	b.memoizedState?b.child.child:b.child,g!==d.child&&(e.child=g)),d=e.sibling=bf(h,c,h.expirationTime),c=e,e.childExpirationTime=0,c.return=d.return=b):c=d=If(b,d.child,e.children,c)):(h=a.child,g?(g=e.fallback,e=df(null,d,0,null),e.child=h,0===(b.mode&1)&&(e.child=null!==b.memoizedState?b.child.child:b.child),d=e.sibling=df(g,d,c,null),d.effectTag|=2,c=e,e.childExpirationTime=0,c.return=d.return=b):d=c=If(b,h,e.children,c)),b.stateNode=a.stateNode;b.memoizedState=f;b.child=c;return d}
	function Rg(a,b,c){null!==a&&(b.contextDependencies=a.contextDependencies);if(b.childExpirationTime<c)return null;null!==a&&b.child!==a.child?t("153"):void 0;if(null!==b.child){a=b.child;c=bf(a,a.pendingProps,a.expirationTime);b.child=c;for(c.return=b;null!==a.sibling;)a=a.sibling,c=c.sibling=bf(a,a.pendingProps,a.expirationTime),c.return=b;c.sibling=null}return b.child}
	function ah(a,b,c){var d=b.expirationTime;if(null!==a)if(a.memoizedProps!==b.pendingProps||L.current)xg=!0;else{if(d<c){xg=!1;switch(b.tag){case 3:Zg(b);Ng();break;case 5:Rf(b);break;case 1:M(b.type)&&Te(b);break;case 4:Pf(b,b.stateNode.containerInfo);break;case 10:bh(b,b.memoizedProps.value);break;case 13:if(null!==b.memoizedState){d=b.child.childExpirationTime;if(0!==d&&d>=c)return $g(a,b,c);b=Rg(a,b,c);return null!==b?b.sibling:null}}return Rg(a,b,c)}}else xg=!1;b.expirationTime=0;switch(b.tag){case 2:d=
	b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);a=b.pendingProps;var e=Oe(b,K.current);Qg(b,c);e=og(null,b,d,a,e,c);b.effectTag|=1;if("object"===typeof e&&null!==e&&"function"===typeof e.render&&void 0===e.$$typeof){b.tag=1;sg();if(M(d)){var f=!0;Te(b)}else f=!1;b.memoizedState=null!==e.state&&void 0!==e.state?e.state:null;var g=d.getDerivedStateFromProps;"function"===typeof g&&of(b,d,g,a);e.updater=xf;b.stateNode=e;e._reactInternalFiber=b;Cf(b,d,a,c);b=Yg(null,b,d,!0,f,
	c)}else b.tag=0,S(null,b,e,c),b=b.child;return b;case 16:e=b.elementType;null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2);f=b.pendingProps;a=mf(e);b.type=a;e=b.tag=af(a);f=P(a,f);g=void 0;switch(e){case 0:g=Ug(null,b,a,f,c);break;case 1:g=Wg(null,b,a,f,c);break;case 11:g=Pg(null,b,a,f,c);break;case 14:g=Sg(null,b,a,P(a.type,f),d,c);break;default:t("306",a,"")}return g;case 0:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),Ug(a,b,d,e,c);case 1:return d=b.type,e=b.pendingProps,
	e=b.elementType===d?e:P(d,e),Wg(a,b,d,e,c);case 3:Zg(b);d=b.updateQueue;null===d?t("282"):void 0;e=b.memoizedState;e=null!==e?e.element:null;Df(b,d,b.pendingProps,null,c);d=b.memoizedState.element;if(d===e)Ng(),b=Rg(a,b,c);else{e=b.stateNode;if(e=(null===a||null===a.child)&&e.hydrate)Gg=Ie(b.stateNode.containerInfo),Fg=b,e=Hg=!0;e?(b.effectTag|=2,b.child=Jf(b,null,d,c)):(S(a,b,d,c),Ng());b=b.child}return b;case 5:return Rf(b),null===a&&Kg(b),d=b.type,e=b.pendingProps,f=null!==a?a.memoizedProps:null,
	g=e.children,Be(d,e)?g=null:null!==f&&Be(d,f)&&(b.effectTag|=16),Vg(a,b),1!==c&&b.mode&1&&e.hidden?(b.expirationTime=b.childExpirationTime=1,b=null):(S(a,b,g,c),b=b.child),b;case 6:return null===a&&Kg(b),null;case 13:return $g(a,b,c);case 4:return Pf(b,b.stateNode.containerInfo),d=b.pendingProps,null===a?b.child=If(b,null,d,c):S(a,b,d,c),b.child;case 11:return d=b.type,e=b.pendingProps,e=b.elementType===d?e:P(d,e),Pg(a,b,d,e,c);case 7:return S(a,b,b.pendingProps,c),b.child;case 8:return S(a,b,b.pendingProps.children,
	c),b.child;case 12:return S(a,b,b.pendingProps.children,c),b.child;case 10:a:{d=b.type._context;e=b.pendingProps;g=b.memoizedProps;f=e.value;bh(b,f);if(null!==g){var h=g.value;f=fd(h,f)?0:("function"===typeof d._calculateChangedBits?d._calculateChangedBits(h,f):1073741823)|0;if(0===f){if(g.children===e.children&&!L.current){b=Rg(a,b,c);break a}}else for(h=b.child,null!==h&&(h.return=b);null!==h;){var l=h.contextDependencies;if(null!==l){g=h.child;for(var k=l.first;null!==k;){if(k.context===d&&0!==
	(k.observedBits&f)){1===h.tag&&(k=rf(c),k.tag=wf,tf(h,k));h.expirationTime<c&&(h.expirationTime=c);k=h.alternate;null!==k&&k.expirationTime<c&&(k.expirationTime=c);for(var m=h.return;null!==m;){k=m.alternate;if(m.childExpirationTime<c)m.childExpirationTime=c,null!==k&&k.childExpirationTime<c&&(k.childExpirationTime=c);else if(null!==k&&k.childExpirationTime<c)k.childExpirationTime=c;else break;m=m.return}l.expirationTime<c&&(l.expirationTime=c);break}k=k.next}}else g=10===h.tag?h.type===b.type?null:
	h.child:h.child;if(null!==g)g.return=h;else for(g=h;null!==g;){if(g===b){g=null;break}h=g.sibling;if(null!==h){h.return=g.return;g=h;break}g=g.return}h=g}}S(a,b,e.children,c);b=b.child}return b;case 9:return e=b.type,f=b.pendingProps,d=f.children,Qg(b,c),e=Af(e,f.unstable_observedBits),d=d(e),b.effectTag|=1,S(a,b,d,c),b.child;case 14:return e=b.type,f=P(e,b.pendingProps),f=P(e.type,f),Sg(a,b,e,f,d,c);case 15:return Tg(a,b,b.type,b.pendingProps,d,c);case 17:return d=b.type,e=b.pendingProps,e=b.elementType===
	d?e:P(d,e),null!==a&&(a.alternate=null,b.alternate=null,b.effectTag|=2),b.tag=1,M(d)?(a=!0,Te(b)):a=!1,Qg(b,c),zf(b,d,e,c),Cf(b,d,e,c),Yg(null,b,d,!0,a,c);default:t("156")}}var ch={current:null},dh=null,eh=null,fh=null;function bh(a,b){var c=a.type._context;J(ch,c._currentValue,a);c._currentValue=b}function gh(a){var b=ch.current;I(ch,a);a.type._context._currentValue=b}function Qg(a,b){dh=a;fh=eh=null;var c=a.contextDependencies;null!==c&&c.expirationTime>=b&&(xg=!0);a.contextDependencies=null}
	function Af(a,b){if(fh!==a&&!1!==b&&0!==b){if("number"!==typeof b||1073741823===b)fh=a,b=1073741823;b={context:a,observedBits:b,next:null};null===eh?(null===dh?t("308"):void 0,eh=b,dh.contextDependencies={first:b,expirationTime:0}):eh=eh.next=b}return a._currentValue}var hh=0,vf=1,wf=2,ih=3,Xg=!1;function jh(a){return{baseState:a,firstUpdate:null,lastUpdate:null,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}
	function kh(a){return{baseState:a.baseState,firstUpdate:a.firstUpdate,lastUpdate:a.lastUpdate,firstCapturedUpdate:null,lastCapturedUpdate:null,firstEffect:null,lastEffect:null,firstCapturedEffect:null,lastCapturedEffect:null}}function rf(a){return{expirationTime:a,tag:hh,payload:null,callback:null,next:null,nextEffect:null}}function lh(a,b){null===a.lastUpdate?a.firstUpdate=a.lastUpdate=b:(a.lastUpdate.next=b,a.lastUpdate=b)}
	function tf(a,b){var c=a.alternate;if(null===c){var d=a.updateQueue;var e=null;null===d&&(d=a.updateQueue=jh(a.memoizedState))}else d=a.updateQueue,e=c.updateQueue,null===d?null===e?(d=a.updateQueue=jh(a.memoizedState),e=c.updateQueue=jh(c.memoizedState)):d=a.updateQueue=kh(e):null===e&&(e=c.updateQueue=kh(d));null===e||d===e?lh(d,b):null===d.lastUpdate||null===e.lastUpdate?(lh(d,b),lh(e,b)):(lh(d,b),e.lastUpdate=b)}
	function mh(a,b){var c=a.updateQueue;c=null===c?a.updateQueue=jh(a.memoizedState):nh(a,c);null===c.lastCapturedUpdate?c.firstCapturedUpdate=c.lastCapturedUpdate=b:(c.lastCapturedUpdate.next=b,c.lastCapturedUpdate=b)}function nh(a,b){var c=a.alternate;null!==c&&b===c.updateQueue&&(b=a.updateQueue=kh(b));return b}
	function oh(a,b,c,d,e,f){switch(c.tag){case vf:return a=c.payload,"function"===typeof a?a.call(f,d,e):a;case ih:a.effectTag=a.effectTag&-2049|64;case hh:a=c.payload;e="function"===typeof a?a.call(f,d,e):a;if(null===e||void 0===e)break;return p({},d,e);case wf:Xg=!0}return d}
	function Df(a,b,c,d,e){Xg=!1;b=nh(a,b);for(var f=b.baseState,g=null,h=0,l=b.firstUpdate,k=f;null!==l;){var m=l.expirationTime;m<e?(null===g&&(g=l,f=k),h<m&&(h=m)):(k=oh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=32,l.nextEffect=null,null===b.lastEffect?b.firstEffect=b.lastEffect=l:(b.lastEffect.nextEffect=l,b.lastEffect=l)));l=l.next}m=null;for(l=b.firstCapturedUpdate;null!==l;){var q=l.expirationTime;q<e?(null===m&&(m=l,null===g&&(f=k)),h<q&&(h=q)):(k=oh(a,b,l,k,c,d),null!==l.callback&&(a.effectTag|=
	32,l.nextEffect=null,null===b.lastCapturedEffect?b.firstCapturedEffect=b.lastCapturedEffect=l:(b.lastCapturedEffect.nextEffect=l,b.lastCapturedEffect=l)));l=l.next}null===g&&(b.lastUpdate=null);null===m?b.lastCapturedUpdate=null:a.effectTag|=32;null===g&&null===m&&(f=k);b.baseState=f;b.firstUpdate=g;b.firstCapturedUpdate=m;a.expirationTime=h;a.memoizedState=k}
	function ph(a,b,c){null!==b.firstCapturedUpdate&&(null!==b.lastUpdate&&(b.lastUpdate.next=b.firstCapturedUpdate,b.lastUpdate=b.lastCapturedUpdate),b.firstCapturedUpdate=b.lastCapturedUpdate=null);qh(b.firstEffect,c);b.firstEffect=b.lastEffect=null;qh(b.firstCapturedEffect,c);b.firstCapturedEffect=b.lastCapturedEffect=null}function qh(a,b){for(;null!==a;){var c=a.callback;if(null!==c){a.callback=null;var d=b;"function"!==typeof c?t("191",c):void 0;c.call(d)}a=a.nextEffect}}
	function rh(a,b){return{value:a,source:b,stack:nc(b)}}function sh(a){a.effectTag|=4}var wh=void 0,xh=void 0,yh=void 0,zh=void 0;wh=function(a,b){for(var c=b.child;null!==c;){if(5===c.tag||6===c.tag)a.appendChild(c.stateNode);else if(4!==c.tag&&null!==c.child){c.child.return=c;c=c.child;continue}if(c===b)break;for(;null===c.sibling;){if(null===c.return||c.return===b)return;c=c.return}c.sibling.return=c.return;c=c.sibling}};xh=function(){};
	yh=function(a,b,c,d,e){var f=a.memoizedProps;if(f!==d){var g=b.stateNode;Of(Lf.current);a=null;switch(c){case "input":f=zc(g,f);d=zc(g,d);a=[];break;case "option":f=de(g,f);d=de(g,d);a=[];break;case "select":f=p({},f,{value:void 0});d=p({},d,{value:void 0});a=[];break;case "textarea":f=fe(g,f);d=fe(g,d);a=[];break;default:"function"!==typeof f.onClick&&"function"===typeof d.onClick&&(g.onclick=xe)}ue(c,d);g=c=void 0;var h=null;for(c in f)if(!d.hasOwnProperty(c)&&f.hasOwnProperty(c)&&null!=f[c])if("style"===
	c){var l=f[c];for(g in l)l.hasOwnProperty(g)&&(h||(h={}),h[g]="")}else"dangerouslySetInnerHTML"!==c&&"children"!==c&&"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&"autoFocus"!==c&&(ta.hasOwnProperty(c)?a||(a=[]):(a=a||[]).push(c,null));for(c in d){var k=d[c];l=null!=f?f[c]:void 0;if(d.hasOwnProperty(c)&&k!==l&&(null!=k||null!=l))if("style"===c)if(l){for(g in l)!l.hasOwnProperty(g)||k&&k.hasOwnProperty(g)||(h||(h={}),h[g]="");for(g in k)k.hasOwnProperty(g)&&l[g]!==k[g]&&(h||
	(h={}),h[g]=k[g])}else h||(a||(a=[]),a.push(c,h)),h=k;else"dangerouslySetInnerHTML"===c?(k=k?k.__html:void 0,l=l?l.__html:void 0,null!=k&&l!==k&&(a=a||[]).push(c,""+k)):"children"===c?l===k||"string"!==typeof k&&"number"!==typeof k||(a=a||[]).push(c,""+k):"suppressContentEditableWarning"!==c&&"suppressHydrationWarning"!==c&&(ta.hasOwnProperty(c)?(null!=k&&we(e,c),a||l===k||(a=[])):(a=a||[]).push(c,k))}h&&(a=a||[]).push("style",h);e=a;(b.updateQueue=e)&&sh(b)}};zh=function(a,b,c,d){c!==d&&sh(b)};
	var Ah="function"===typeof WeakSet?WeakSet:Set;function Bh(a,b){var c=b.source,d=b.stack;null===d&&null!==c&&(d=nc(c));null!==c&&mc(c.type);b=b.value;null!==a&&1===a.tag&&mc(a.type);try{console.error(b)}catch(e){setTimeout(function(){throw e;})}}function Ch(a){var b=a.ref;if(null!==b)if("function"===typeof b)try{b(null)}catch(c){Dh(a,c)}else b.current=null}
	function Eh(a,b,c){c=c.updateQueue;c=null!==c?c.lastEffect:null;if(null!==c){var d=c=c.next;do{if((d.tag&a)!==Tf){var e=d.destroy;d.destroy=void 0;void 0!==e&&e()}(d.tag&b)!==Tf&&(e=d.create,d.destroy=e());d=d.next}while(d!==c)}}
	function Fh(a,b){for(var c=a;;){if(5===c.tag){var d=c.stateNode;if(b)d.style.display="none";else{d=c.stateNode;var e=c.memoizedProps.style;e=void 0!==e&&null!==e&&e.hasOwnProperty("display")?e.display:null;d.style.display=re("display",e)}}else if(6===c.tag)c.stateNode.nodeValue=b?"":c.memoizedProps;else if(13===c.tag&&null!==c.memoizedState){d=c.child.sibling;d.return=c;c=d;continue}else if(null!==c.child){c.child.return=c;c=c.child;continue}if(c===a)break;for(;null===c.sibling;){if(null===c.return||
	c.return===a)return;c=c.return}c.sibling.return=c.return;c=c.sibling}}
	function Gh(a){"function"===typeof We&&We(a);switch(a.tag){case 0:case 11:case 14:case 15:var b=a.updateQueue;if(null!==b&&(b=b.lastEffect,null!==b)){var c=b=b.next;do{var d=c.destroy;if(void 0!==d){var e=a;try{d()}catch(f){Dh(e,f)}}c=c.next}while(c!==b)}break;case 1:Ch(a);b=a.stateNode;if("function"===typeof b.componentWillUnmount)try{b.props=a.memoizedProps,b.state=a.memoizedState,b.componentWillUnmount()}catch(f){Dh(a,f)}break;case 5:Ch(a);break;case 4:Hh(a)}}
	function Ih(a){return 5===a.tag||3===a.tag||4===a.tag}
	function Jh(a){a:{for(var b=a.return;null!==b;){if(Ih(b)){var c=b;break a}b=b.return}t("160");c=void 0}var d=b=void 0;switch(c.tag){case 5:b=c.stateNode;d=!1;break;case 3:b=c.stateNode.containerInfo;d=!0;break;case 4:b=c.stateNode.containerInfo;d=!0;break;default:t("161")}c.effectTag&16&&(oe(b,""),c.effectTag&=-17);a:b:for(c=a;;){for(;null===c.sibling;){if(null===c.return||Ih(c.return)){c=null;break a}c=c.return}c.sibling.return=c.return;for(c=c.sibling;5!==c.tag&&6!==c.tag;){if(c.effectTag&2)continue b;
	if(null===c.child||4===c.tag)continue b;else c.child.return=c,c=c.child}if(!(c.effectTag&2)){c=c.stateNode;break a}}for(var e=a;;){if(5===e.tag||6===e.tag)if(c)if(d){var f=b,g=e.stateNode,h=c;8===f.nodeType?f.parentNode.insertBefore(g,h):f.insertBefore(g,h)}else b.insertBefore(e.stateNode,c);else d?(g=b,h=e.stateNode,8===g.nodeType?(f=g.parentNode,f.insertBefore(h,g)):(f=g,f.appendChild(h)),g=g._reactRootContainer,null!==g&&void 0!==g||null!==f.onclick||(f.onclick=xe)):b.appendChild(e.stateNode);
	else if(4!==e.tag&&null!==e.child){e.child.return=e;e=e.child;continue}if(e===a)break;for(;null===e.sibling;){if(null===e.return||e.return===a)return;e=e.return}e.sibling.return=e.return;e=e.sibling}}
	function Hh(a){for(var b=a,c=!1,d=void 0,e=void 0;;){if(!c){c=b.return;a:for(;;){null===c?t("160"):void 0;switch(c.tag){case 5:d=c.stateNode;e=!1;break a;case 3:d=c.stateNode.containerInfo;e=!0;break a;case 4:d=c.stateNode.containerInfo;e=!0;break a}c=c.return}c=!0}if(5===b.tag||6===b.tag){a:for(var f=b,g=f;;)if(Gh(g),null!==g.child&&4!==g.tag)g.child.return=g,g=g.child;else{if(g===f)break;for(;null===g.sibling;){if(null===g.return||g.return===f)break a;g=g.return}g.sibling.return=g.return;g=g.sibling}e?
	(f=d,g=b.stateNode,8===f.nodeType?f.parentNode.removeChild(g):f.removeChild(g)):d.removeChild(b.stateNode)}else if(4===b.tag?(d=b.stateNode.containerInfo,e=!0):Gh(b),null!==b.child){b.child.return=b;b=b.child;continue}if(b===a)break;for(;null===b.sibling;){if(null===b.return||b.return===a)return;b=b.return;4===b.tag&&(c=!1)}b.sibling.return=b.return;b=b.sibling}}
	function Kh(a,b){switch(b.tag){case 0:case 11:case 14:case 15:Eh(Vf,Wf,b);break;case 1:break;case 5:var c=b.stateNode;if(null!=c){var d=b.memoizedProps;a=null!==a?a.memoizedProps:d;var e=b.type,f=b.updateQueue;b.updateQueue=null;null!==f&&Ge(c,f,e,a,d,b)}break;case 6:null===b.stateNode?t("162"):void 0;b.stateNode.nodeValue=b.memoizedProps;break;case 3:break;case 12:break;case 13:c=b.memoizedState;d=void 0;a=b;null===c?d=!1:(d=!0,a=b.child,0===c.timedOutAt&&(c.timedOutAt=pf()));null!==a&&Fh(a,d);c=
	b.updateQueue;if(null!==c){b.updateQueue=null;var g=b.stateNode;null===g&&(g=b.stateNode=new Ah);c.forEach(function(a){var c=Lh.bind(null,b,a);g.has(a)||(g.add(a),a.then(c,c))})}break;case 17:break;default:t("163")}}var Mh="function"===typeof WeakMap?WeakMap:Map;function Nh(a,b,c){c=rf(c);c.tag=ih;c.payload={element:null};var d=b.value;c.callback=function(){Oh(d);Bh(a,b)};return c}
	function Ph(a,b,c){c=rf(c);c.tag=ih;var d=a.type.getDerivedStateFromError;if("function"===typeof d){var e=b.value;c.payload=function(){return d(e)}}var f=a.stateNode;null!==f&&"function"===typeof f.componentDidCatch&&(c.callback=function(){"function"!==typeof d&&(null===Qh?Qh=new Set([this]):Qh.add(this));var c=b.value,e=b.stack;Bh(a,b);this.componentDidCatch(c,{componentStack:null!==e?e:""})});return c}
	function Rh(a){switch(a.tag){case 1:M(a.type)&&Pe(a);var b=a.effectTag;return b&2048?(a.effectTag=b&-2049|64,a):null;case 3:return Qf(a),Qe(a),b=a.effectTag,0!==(b&64)?t("285"):void 0,a.effectTag=b&-2049|64,a;case 5:return Sf(a),null;case 13:return b=a.effectTag,b&2048?(a.effectTag=b&-2049|64,a):null;case 4:return Qf(a),null;case 10:return gh(a),null;default:return null}}
	var Sh=Xb.ReactCurrentDispatcher,Th=Xb.ReactCurrentOwner,Uh=1073741822,Vh=0,Wh=!1,T=null,Xh=null,U=0,Yh=-1,Zh=!1,V=null,$h=!1,ai=null,bi=null,ci=null,Qh=null;function di(){if(null!==T)for(var a=T.return;null!==a;){var b=a;switch(b.tag){case 1:var c=b.type.childContextTypes;null!==c&&void 0!==c&&Pe(b);break;case 3:Qf(b);Qe(b);break;case 5:Sf(b);break;case 4:Qf(b);break;case 10:gh(b)}a=a.return}Xh=null;U=0;Yh=-1;Zh=!1;T=null}
	function ei(a,b){ci=bi=ai=null;var c=W;W=!0;do{if(b.effectTag&512){var d=!1,e=void 0;try{var f=b;Eh($f,Tf,f);Eh(Tf,Zf,f)}catch(g){d=!0,e=g}d&&Dh(b,e)}b=b.nextEffect}while(null!==b);W=c;c=a.expirationTime;0!==c&&fi(a,c)}function sf(){null!==bi&&Fe(bi);null!==ci&&ci()}
	function gi(a){for(;;){var b=a.alternate,c=a.return,d=a.sibling;if(0===(a.effectTag&1024)){T=a;a:{var e=b;b=a;var f=U;var g=b.pendingProps;switch(b.tag){case 2:break;case 16:break;case 15:case 0:break;case 1:M(b.type)&&Pe(b);break;case 3:Qf(b);Qe(b);g=b.stateNode;g.pendingContext&&(g.context=g.pendingContext,g.pendingContext=null);if(null===e||null===e.child)Mg(b),b.effectTag&=-3;xh(b);break;case 5:Sf(b);var h=Of(Nf.current);f=b.type;if(null!==e&&null!=b.stateNode)yh(e,b,f,g,h),e.ref!==b.ref&&(b.effectTag|=
	128);else if(g){var l=Of(Lf.current);if(Mg(b)){g=b;e=g.stateNode;var k=g.type,m=g.memoizedProps,q=h;e[Ha]=g;e[Ia]=m;f=void 0;h=k;switch(h){case "iframe":case "object":H("load",e);break;case "video":case "audio":for(k=0;k<cb.length;k++)H(cb[k],e);break;case "source":H("error",e);break;case "img":case "image":case "link":H("error",e);H("load",e);break;case "form":H("reset",e);H("submit",e);break;case "details":H("toggle",e);break;case "input":Ac(e,m);H("invalid",e);we(q,"onChange");break;case "select":e._wrapperState=
	{wasMultiple:!!m.multiple};H("invalid",e);we(q,"onChange");break;case "textarea":ge(e,m),H("invalid",e),we(q,"onChange")}ue(h,m);k=null;for(f in m)m.hasOwnProperty(f)&&(l=m[f],"children"===f?"string"===typeof l?e.textContent!==l&&(k=["children",l]):"number"===typeof l&&e.textContent!==""+l&&(k=["children",""+l]):ta.hasOwnProperty(f)&&null!=l&&we(q,f));switch(h){case "input":Vb(e);Ec(e,m,!0);break;case "textarea":Vb(e);ie(e,m);break;case "select":case "option":break;default:"function"===typeof m.onClick&&
	(e.onclick=xe)}f=k;g.updateQueue=f;g=null!==f?!0:!1;g&&sh(b)}else{m=b;e=f;q=g;k=9===h.nodeType?h:h.ownerDocument;l===je.html&&(l=ke(e));l===je.html?"script"===e?(e=k.createElement("div"),e.innerHTML="<script>\x3c/script>",k=e.removeChild(e.firstChild)):"string"===typeof q.is?k=k.createElement(e,{is:q.is}):(k=k.createElement(e),"select"===e&&q.multiple&&(k.multiple=!0)):k=k.createElementNS(l,e);e=k;e[Ha]=m;e[Ia]=g;wh(e,b,!1,!1);q=e;k=f;m=g;var x=h,C=ve(k,m);switch(k){case "iframe":case "object":H("load",
	q);h=m;break;case "video":case "audio":for(h=0;h<cb.length;h++)H(cb[h],q);h=m;break;case "source":H("error",q);h=m;break;case "img":case "image":case "link":H("error",q);H("load",q);h=m;break;case "form":H("reset",q);H("submit",q);h=m;break;case "details":H("toggle",q);h=m;break;case "input":Ac(q,m);h=zc(q,m);H("invalid",q);we(x,"onChange");break;case "option":h=de(q,m);break;case "select":q._wrapperState={wasMultiple:!!m.multiple};h=p({},m,{value:void 0});H("invalid",q);we(x,"onChange");break;case "textarea":ge(q,
	m);h=fe(q,m);H("invalid",q);we(x,"onChange");break;default:h=m}ue(k,h);l=void 0;var w=k,E=q,v=h;for(l in v)if(v.hasOwnProperty(l)){var n=v[l];"style"===l?se(E,n):"dangerouslySetInnerHTML"===l?(n=n?n.__html:void 0,null!=n&&ne(E,n)):"children"===l?"string"===typeof n?("textarea"!==w||""!==n)&&oe(E,n):"number"===typeof n&&oe(E,""+n):"suppressContentEditableWarning"!==l&&"suppressHydrationWarning"!==l&&"autoFocus"!==l&&(ta.hasOwnProperty(l)?null!=n&&we(x,l):null!=n&&xc(E,l,n,C))}switch(k){case "input":Vb(q);
	Ec(q,m,!1);break;case "textarea":Vb(q);ie(q,m);break;case "option":null!=m.value&&q.setAttribute("value",""+yc(m.value));break;case "select":h=q;h.multiple=!!m.multiple;q=m.value;null!=q?ee(h,!!m.multiple,q,!1):null!=m.defaultValue&&ee(h,!!m.multiple,m.defaultValue,!0);break;default:"function"===typeof h.onClick&&(q.onclick=xe)}(g=Ae(f,g))&&sh(b);b.stateNode=e}null!==b.ref&&(b.effectTag|=128)}else null===b.stateNode?t("166"):void 0;break;case 6:e&&null!=b.stateNode?zh(e,b,e.memoizedProps,g):("string"!==
	typeof g&&(null===b.stateNode?t("166"):void 0),e=Of(Nf.current),Of(Lf.current),Mg(b)?(g=b,f=g.stateNode,e=g.memoizedProps,f[Ha]=g,(g=f.nodeValue!==e)&&sh(b)):(f=b,g=(9===e.nodeType?e:e.ownerDocument).createTextNode(g),g[Ha]=b,f.stateNode=g));break;case 11:break;case 13:g=b.memoizedState;if(0!==(b.effectTag&64)){b.expirationTime=f;T=b;break a}g=null!==g;f=null!==e&&null!==e.memoizedState;null!==e&&!g&&f&&(e=e.child.sibling,null!==e&&(h=b.firstEffect,null!==h?(b.firstEffect=e,e.nextEffect=h):(b.firstEffect=
	b.lastEffect=e,e.nextEffect=null),e.effectTag=8));if(g||f)b.effectTag|=4;break;case 7:break;case 8:break;case 12:break;case 4:Qf(b);xh(b);break;case 10:gh(b);break;case 9:break;case 14:break;case 17:M(b.type)&&Pe(b);break;default:t("156")}T=null}b=a;if(1===U||1!==b.childExpirationTime){g=0;for(f=b.child;null!==f;)e=f.expirationTime,h=f.childExpirationTime,e>g&&(g=e),h>g&&(g=h),f=f.sibling;b.childExpirationTime=g}if(null!==T)return T;null!==c&&0===(c.effectTag&1024)&&(null===c.firstEffect&&(c.firstEffect=
	a.firstEffect),null!==a.lastEffect&&(null!==c.lastEffect&&(c.lastEffect.nextEffect=a.firstEffect),c.lastEffect=a.lastEffect),1<a.effectTag&&(null!==c.lastEffect?c.lastEffect.nextEffect=a:c.firstEffect=a,c.lastEffect=a))}else{a=Rh(a,U);if(null!==a)return a.effectTag&=1023,a;null!==c&&(c.firstEffect=c.lastEffect=null,c.effectTag|=1024)}if(null!==d)return d;if(null!==c)a=c;else break}return null}
	function hi(a){var b=ah(a.alternate,a,U);a.memoizedProps=a.pendingProps;null===b&&(b=gi(a));Th.current=null;return b}
	function ii(a,b){Wh?t("243"):void 0;sf();Wh=!0;var c=Sh.current;Sh.current=rg;var d=a.nextExpirationTimeToWorkOn;if(d!==U||a!==Xh||null===T)di(),Xh=a,U=d,T=bf(Xh.current,null,U),a.pendingCommitExpirationTime=0;var e=!1;do{try{if(b)for(;null!==T&&!ji();)T=hi(T);else for(;null!==T;)T=hi(T)}catch(E){if(fh=eh=dh=null,sg(),null===T)e=!0,Oh(E);else{null===T?t("271"):void 0;var f=T,g=f.return;if(null===g)e=!0,Oh(E);else{a:{var h=a,l=g,k=f,m=E;g=U;k.effectTag|=1024;k.firstEffect=k.lastEffect=null;if(null!==
	m&&"object"===typeof m&&"function"===typeof m.then){var q=m;m=l;var x=-1,C=-1;do{if(13===m.tag){var w=m.alternate;if(null!==w&&(w=w.memoizedState,null!==w)){C=10*(1073741822-w.timedOutAt);break}w=m.pendingProps.maxDuration;if("number"===typeof w)if(0>=w)x=0;else if(-1===x||w<x)x=w}m=m.return}while(null!==m);m=l;do{if(w=13===m.tag)w=void 0===m.memoizedProps.fallback?!1:null===m.memoizedState;if(w){l=m.updateQueue;null===l?(l=new Set,l.add(q),m.updateQueue=l):l.add(q);if(0===(m.mode&1)){m.effectTag|=
	64;k.effectTag&=-1957;1===k.tag&&(null===k.alternate?k.tag=17:(g=rf(1073741823),g.tag=wf,tf(k,g)));k.expirationTime=1073741823;break a}k=h.pingCache;null===k?(k=h.pingCache=new Mh,l=new Set,k.set(q,l)):(l=k.get(q),void 0===l&&(l=new Set,k.set(q,l)));l.has(g)||(l.add(g),k=ki.bind(null,h,q,g),q.then(k,k));-1===x?h=1073741823:(-1===C&&(C=10*(1073741822-lf(h,g))-5E3),h=C+x);0<=h&&Yh<h&&(Yh=h);m.effectTag|=2048;m.expirationTime=g;break a}m=m.return}while(null!==m);m=Error((mc(k.type)||"A React component")+
	" suspended while rendering, but no fallback UI was specified.\n\nAdd a <Suspense fallback=...> component higher in the tree to provide a loading indicator or placeholder to display."+nc(k))}Zh=!0;m=rh(m,k);h=l;do{switch(h.tag){case 3:h.effectTag|=2048;h.expirationTime=g;g=Nh(h,m,g);mh(h,g);break a;case 1:if(q=m,x=h.type,C=h.stateNode,0===(h.effectTag&64)&&("function"===typeof x.getDerivedStateFromError||null!==C&&"function"===typeof C.componentDidCatch&&(null===Qh||!Qh.has(C)))){h.effectTag|=2048;
	h.expirationTime=g;g=Ph(h,q,g);mh(h,g);break a}}h=h.return}while(null!==h)}T=gi(f);continue}}}break}while(1);Wh=!1;Sh.current=c;fh=eh=dh=null;sg();if(e)Xh=null,a.finishedWork=null;else if(null!==T)a.finishedWork=null;else{c=a.current.alternate;null===c?t("281"):void 0;Xh=null;if(Zh){e=a.latestPendingTime;f=a.latestSuspendedTime;g=a.latestPingedTime;if(0!==e&&e<d||0!==f&&f<d||0!==g&&g<d){kf(a,d);li(a,c,d,a.expirationTime,-1);return}if(!a.didError&&b){a.didError=!0;d=a.nextExpirationTimeToWorkOn=d;
	b=a.expirationTime=1073741823;li(a,c,d,b,-1);return}}b&&-1!==Yh?(kf(a,d),b=10*(1073741822-lf(a,d)),b<Yh&&(Yh=b),b=10*(1073741822-pf()),b=Yh-b,li(a,c,d,a.expirationTime,0>b?0:b)):(a.pendingCommitExpirationTime=d,a.finishedWork=c)}}
	function Dh(a,b){for(var c=a.return;null!==c;){switch(c.tag){case 1:var d=c.stateNode;if("function"===typeof c.type.getDerivedStateFromError||"function"===typeof d.componentDidCatch&&(null===Qh||!Qh.has(d))){a=rh(b,a);a=Ph(c,a,1073741823);tf(c,a);uf(c,1073741823);return}break;case 3:a=rh(b,a);a=Nh(c,a,1073741823);tf(c,a);uf(c,1073741823);return}c=c.return}3===a.tag&&(c=rh(b,a),c=Nh(a,c,1073741823),tf(a,c),uf(a,1073741823))}
	function qf(a,b){0!==Vh?a=Vh:Wh?a=$h?1073741823:U:b.mode&1?(a=mi?1073741822-10*(((1073741822-a+15)/10|0)+1):1073741822-25*(((1073741822-a+500)/25|0)+1),null!==Xh&&a===U&&--a):a=1073741823;mi&&(0===ni||a<ni)&&(ni=a);return a}
	function ki(a,b,c){var d=a.pingCache;null!==d&&d.delete(b);if(null!==Xh&&U===c)Xh=null;else if(b=a.earliestSuspendedTime,d=a.latestSuspendedTime,0!==b&&c<=b&&c>=d){a.didError=!1;b=a.latestPingedTime;if(0===b||b>c)a.latestPingedTime=c;jf(c,a);c=a.expirationTime;0!==c&&fi(a,c)}}function Lh(a,b){var c=a.stateNode;null!==c&&c.delete(b);b=pf();b=qf(b,a);a=oi(a,b);null!==a&&(hf(a,b),b=a.expirationTime,0!==b&&fi(a,b))}
	function oi(a,b){a.expirationTime<b&&(a.expirationTime=b);var c=a.alternate;null!==c&&c.expirationTime<b&&(c.expirationTime=b);var d=a.return,e=null;if(null===d&&3===a.tag)e=a.stateNode;else for(;null!==d;){c=d.alternate;d.childExpirationTime<b&&(d.childExpirationTime=b);null!==c&&c.childExpirationTime<b&&(c.childExpirationTime=b);if(null===d.return&&3===d.tag){e=d.stateNode;break}d=d.return}return e}
	function uf(a,b){a=oi(a,b);null!==a&&(!Wh&&0!==U&&b>U&&di(),hf(a,b),Wh&&!$h&&Xh===a||fi(a,a.expirationTime),pi>qi&&(pi=0,t("185")))}function ri(a,b,c,d,e){var f=Vh;Vh=1073741823;try{return a(b,c,d,e)}finally{Vh=f}}var si=null,X=null,ti=0,ui=void 0,W=!1,vi=null,Y=0,ni=0,wi=!1,xi=null,Z=!1,yi=!1,mi=!1,zi=null,Ai=ba.unstable_now(),Bi=1073741822-(Ai/10|0),Ci=Bi,qi=50,pi=0,Di=null;function Ei(){Bi=1073741822-((ba.unstable_now()-Ai)/10|0)}
	function Fi(a,b){if(0!==ti){if(b<ti)return;null!==ui&&ba.unstable_cancelCallback(ui)}ti=b;a=ba.unstable_now()-Ai;ui=ba.unstable_scheduleCallback(Gi,{timeout:10*(1073741822-b)-a})}function li(a,b,c,d,e){a.expirationTime=d;0!==e||ji()?0<e&&(a.timeoutHandle=Ce(Hi.bind(null,a,b,c),e)):(a.pendingCommitExpirationTime=c,a.finishedWork=b)}function Hi(a,b,c){a.pendingCommitExpirationTime=c;a.finishedWork=b;Ei();Ci=Bi;Ii(a,c)}function pf(){if(W)return Ci;Ji();if(0===Y||1===Y)Ei(),Ci=Bi;return Ci}
	function fi(a,b){null===a.nextScheduledRoot?(a.expirationTime=b,null===X?(si=X=a,a.nextScheduledRoot=a):(X=X.nextScheduledRoot=a,X.nextScheduledRoot=si)):b>a.expirationTime&&(a.expirationTime=b);W||(Z?yi&&(vi=a,Y=1073741823,Ki(a,1073741823,!1)):1073741823===b?Li(1073741823,!1):Fi(a,b))}
	function Ji(){var a=0,b=null;if(null!==X)for(var c=X,d=si;null!==d;){var e=d.expirationTime;if(0===e){null===c||null===X?t("244"):void 0;if(d===d.nextScheduledRoot){si=X=d.nextScheduledRoot=null;break}else if(d===si)si=e=d.nextScheduledRoot,X.nextScheduledRoot=e,d.nextScheduledRoot=null;else if(d===X){X=c;X.nextScheduledRoot=si;d.nextScheduledRoot=null;break}else c.nextScheduledRoot=d.nextScheduledRoot,d.nextScheduledRoot=null;d=c.nextScheduledRoot}else{e>a&&(a=e,b=d);if(d===X)break;if(1073741823===
	a)break;c=d;d=d.nextScheduledRoot}}vi=b;Y=a}var Mi=!1;function ji(){return Mi?!0:ba.unstable_shouldYield()?Mi=!0:!1}function Gi(){try{if(!ji()&&null!==si){Ei();var a=si;do{var b=a.expirationTime;0!==b&&Bi<=b&&(a.nextExpirationTimeToWorkOn=Bi);a=a.nextScheduledRoot}while(a!==si)}Li(0,!0)}finally{Mi=!1}}
	function Li(a,b){Ji();if(b)for(Ei(),Ci=Bi;null!==vi&&0!==Y&&a<=Y&&!(Mi&&Bi>Y);)Ki(vi,Y,Bi>Y),Ji(),Ei(),Ci=Bi;else for(;null!==vi&&0!==Y&&a<=Y;)Ki(vi,Y,!1),Ji();b&&(ti=0,ui=null);0!==Y&&Fi(vi,Y);pi=0;Di=null;if(null!==zi)for(a=zi,zi=null,b=0;b<a.length;b++){var c=a[b];try{c._onComplete()}catch(d){wi||(wi=!0,xi=d)}}if(wi)throw a=xi,xi=null,wi=!1,a;}function Ii(a,b){W?t("253"):void 0;vi=a;Y=b;Ki(a,b,!1);Li(1073741823,!1)}
	function Ki(a,b,c){W?t("245"):void 0;W=!0;if(c){var d=a.finishedWork;null!==d?Oi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,De(d)),ii(a,c),d=a.finishedWork,null!==d&&(ji()?a.finishedWork=d:Oi(a,d,b)))}else d=a.finishedWork,null!==d?Oi(a,d,b):(a.finishedWork=null,d=a.timeoutHandle,-1!==d&&(a.timeoutHandle=-1,De(d)),ii(a,c),d=a.finishedWork,null!==d&&Oi(a,d,b));W=!1}
	function Oi(a,b,c){var d=a.firstBatch;if(null!==d&&d._expirationTime>=c&&(null===zi?zi=[d]:zi.push(d),d._defer)){a.finishedWork=b;a.expirationTime=0;return}a.finishedWork=null;a===Di?pi++:(Di=a,pi=0);$h=Wh=!0;a.current===b?t("177"):void 0;c=a.pendingCommitExpirationTime;0===c?t("261"):void 0;a.pendingCommitExpirationTime=0;d=b.expirationTime;var e=b.childExpirationTime;d=e>d?e:d;a.didError=!1;0===d?(a.earliestPendingTime=0,a.latestPendingTime=0,a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=
	0):(d<a.latestPingedTime&&(a.latestPingedTime=0),e=a.latestPendingTime,0!==e&&(e>d?a.earliestPendingTime=a.latestPendingTime=0:a.earliestPendingTime>d&&(a.earliestPendingTime=a.latestPendingTime)),e=a.earliestSuspendedTime,0===e?hf(a,d):d<a.latestSuspendedTime?(a.earliestSuspendedTime=0,a.latestSuspendedTime=0,a.latestPingedTime=0,hf(a,d)):d>e&&hf(a,d));jf(0,a);Th.current=null;1<b.effectTag?null!==b.lastEffect?(b.lastEffect.nextEffect=b,d=b.firstEffect):d=b:d=b.firstEffect;ye=Hd;e=Td();if(Ud(e)){if("selectionStart"in
	e)var f={start:e.selectionStart,end:e.selectionEnd};else a:{f=(f=e.ownerDocument)&&f.defaultView||window;var g=f.getSelection&&f.getSelection();if(g&&0!==g.rangeCount){f=g.anchorNode;var h=g.anchorOffset,l=g.focusNode;g=g.focusOffset;try{f.nodeType,l.nodeType}catch(ub){f=null;break a}var k=0,m=-1,q=-1,x=0,C=0,w=e,E=null;b:for(;;){for(var v;;){w!==f||0!==h&&3!==w.nodeType||(m=k+h);w!==l||0!==g&&3!==w.nodeType||(q=k+g);3===w.nodeType&&(k+=w.nodeValue.length);if(null===(v=w.firstChild))break;E=w;w=v}for(;;){if(w===
	e)break b;E===f&&++x===h&&(m=k);E===l&&++C===g&&(q=k);if(null!==(v=w.nextSibling))break;w=E;E=w.parentNode}w=v}f=-1===m||-1===q?null:{start:m,end:q}}else f=null}f=f||{start:0,end:0}}else f=null;ze={focusedElem:e,selectionRange:f};Hd=!1;for(V=d;null!==V;){e=!1;f=void 0;try{for(;null!==V;){if(V.effectTag&256)a:{var n=V.alternate;h=V;switch(h.tag){case 0:case 11:case 15:Eh(Uf,Tf,h);break a;case 1:if(h.effectTag&256&&null!==n){var u=n.memoizedProps,z=n.memoizedState,Ag=h.stateNode,Ni=Ag.getSnapshotBeforeUpdate(h.elementType===
	h.type?u:P(h.type,u),z);Ag.__reactInternalSnapshotBeforeUpdate=Ni}break a;case 3:case 5:case 6:case 4:case 17:break a;default:t("163")}}V=V.nextEffect}}catch(ub){e=!0,f=ub}e&&(null===V?t("178"):void 0,Dh(V,f),null!==V&&(V=V.nextEffect))}for(V=d;null!==V;){n=!1;u=void 0;try{for(;null!==V;){var y=V.effectTag;y&16&&oe(V.stateNode,"");if(y&128){var B=V.alternate;if(null!==B){var r=B.ref;null!==r&&("function"===typeof r?r(null):r.current=null)}}switch(y&14){case 2:Jh(V);V.effectTag&=-3;break;case 6:Jh(V);
	V.effectTag&=-3;Kh(V.alternate,V);break;case 4:Kh(V.alternate,V);break;case 8:z=V;Hh(z);z.return=null;z.child=null;z.memoizedState=null;z.updateQueue=null;var O=z.alternate;null!==O&&(O.return=null,O.child=null,O.memoizedState=null,O.updateQueue=null)}V=V.nextEffect}}catch(ub){n=!0,u=ub}n&&(null===V?t("178"):void 0,Dh(V,u),null!==V&&(V=V.nextEffect))}r=ze;B=Td();y=r.focusedElem;n=r.selectionRange;if(B!==y&&y&&y.ownerDocument&&Sd(y.ownerDocument.documentElement,y)){null!==n&&Ud(y)&&(B=n.start,r=n.end,
	void 0===r&&(r=B),"selectionStart"in y?(y.selectionStart=B,y.selectionEnd=Math.min(r,y.value.length)):(r=(B=y.ownerDocument||document)&&B.defaultView||window,r.getSelection&&(r=r.getSelection(),u=y.textContent.length,O=Math.min(n.start,u),n=void 0===n.end?O:Math.min(n.end,u),!r.extend&&O>n&&(u=n,n=O,O=u),u=Rd(y,O),z=Rd(y,n),u&&z&&(1!==r.rangeCount||r.anchorNode!==u.node||r.anchorOffset!==u.offset||r.focusNode!==z.node||r.focusOffset!==z.offset)&&(B=B.createRange(),B.setStart(u.node,u.offset),r.removeAllRanges(),
	O>n?(r.addRange(B),r.extend(z.node,z.offset)):(B.setEnd(z.node,z.offset),r.addRange(B))))));B=[];for(r=y;r=r.parentNode;)1===r.nodeType&&B.push({element:r,left:r.scrollLeft,top:r.scrollTop});"function"===typeof y.focus&&y.focus();for(y=0;y<B.length;y++)r=B[y],r.element.scrollLeft=r.left,r.element.scrollTop=r.top}ze=null;Hd=!!ye;ye=null;a.current=b;for(V=d;null!==V;){y=!1;B=void 0;try{for(r=a,O=c;null!==V;){var qa=V.effectTag;if(qa&36){var Rb=V.alternate;n=V;u=O;switch(n.tag){case 0:case 11:case 15:Eh(Xf,
	Yf,n);break;case 1:var id=n.stateNode;if(n.effectTag&4)if(null===Rb)id.componentDidMount();else{var dj=n.elementType===n.type?Rb.memoizedProps:P(n.type,Rb.memoizedProps);id.componentDidUpdate(dj,Rb.memoizedState,id.__reactInternalSnapshotBeforeUpdate)}var th=n.updateQueue;null!==th&&ph(n,th,id,u);break;case 3:var uh=n.updateQueue;if(null!==uh){z=null;if(null!==n.child)switch(n.child.tag){case 5:z=n.child.stateNode;break;case 1:z=n.child.stateNode}ph(n,uh,z,u)}break;case 5:var ej=n.stateNode;null===
	Rb&&n.effectTag&4&&Ae(n.type,n.memoizedProps)&&ej.focus();break;case 6:break;case 4:break;case 12:break;case 13:break;case 17:break;default:t("163")}}if(qa&128){var jd=V.ref;if(null!==jd){var vh=V.stateNode;switch(V.tag){case 5:var Ne=vh;break;default:Ne=vh}"function"===typeof jd?jd(Ne):jd.current=Ne}}qa&512&&(ai=r);V=V.nextEffect}}catch(ub){y=!0,B=ub}y&&(null===V?t("178"):void 0,Dh(V,B),null!==V&&(V=V.nextEffect))}null!==d&&null!==ai&&(qa=ei.bind(null,a,d),bi=Ee(qa),ci=qa);Wh=$h=!1;"function"===
	typeof Ve&&Ve(b.stateNode);qa=b.expirationTime;b=b.childExpirationTime;b=b>qa?b:qa;0===b&&(Qh=null);a.expirationTime=b;a.finishedWork=null}function Oh(a){null===vi?t("246"):void 0;vi.expirationTime=0;wi||(wi=!0,xi=a)}function Pi(a,b){var c=Z;Z=!0;try{return a(b)}finally{(Z=c)||W||Li(1073741823,!1)}}function Qi(a,b){if(Z&&!yi){yi=!0;try{return a(b)}finally{yi=!1}}return a(b)}
	function Ri(a,b,c){if(mi)return a(b,c);Z||W||0===ni||(Li(ni,!1),ni=0);var d=mi,e=Z;Z=mi=!0;try{return a(b,c)}finally{mi=d,(Z=e)||W||Li(1073741823,!1)}}
	function Si(a,b,c,d,e){var f=b.current;a:if(c){c=c._reactInternalFiber;b:{2===kd(c)&&1===c.tag?void 0:t("170");var g=c;do{switch(g.tag){case 3:g=g.stateNode.context;break b;case 1:if(M(g.type)){g=g.stateNode.__reactInternalMemoizedMergedChildContext;break b}}g=g.return}while(null!==g);t("171");g=void 0}if(1===c.tag){var h=c.type;if(M(h)){c=Se(c,h,g);break a}}c=g}else c=Le;null===b.context?b.context=c:b.pendingContext=c;b=e;e=rf(d);e.payload={element:a};b=void 0===b?null:b;null!==b&&(e.callback=b);
	sf();tf(f,e);uf(f,d);return d}function Ti(a,b,c,d){var e=b.current,f=pf();e=qf(f,e);return Si(a,b,c,e,d)}function Ui(a){a=a.current;if(!a.child)return null;switch(a.child.tag){case 5:return a.child.stateNode;default:return a.child.stateNode}}function Vi(a,b,c){var d=3<arguments.length&&void 0!==arguments[3]?arguments[3]:null;return{$$typeof:$b,key:null==d?null:""+d,children:a,containerInfo:b,implementation:c}}
	Db=function(a,b,c){switch(b){case "input":Cc(a,c);b=c.name;if("radio"===c.type&&null!=b){for(c=a;c.parentNode;)c=c.parentNode;c=c.querySelectorAll("input[name="+JSON.stringify(""+b)+'][type="radio"]');for(b=0;b<c.length;b++){var d=c[b];if(d!==a&&d.form===a.form){var e=Ma(d);e?void 0:t("90");Wb(d);Cc(d,e)}}}break;case "textarea":he(a,c);break;case "select":b=c.value,null!=b&&ee(a,!!c.multiple,b,!1)}};
	function Wi(a){var b=1073741822-25*(((1073741822-pf()+500)/25|0)+1);b>=Uh&&(b=Uh-1);this._expirationTime=Uh=b;this._root=a;this._callbacks=this._next=null;this._hasChildren=this._didComplete=!1;this._children=null;this._defer=!0}Wi.prototype.render=function(a){this._defer?void 0:t("250");this._hasChildren=!0;this._children=a;var b=this._root._internalRoot,c=this._expirationTime,d=new Xi;Si(a,b,null,c,d._onCommit);return d};
	Wi.prototype.then=function(a){if(this._didComplete)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Wi.prototype.commit=function(){var a=this._root._internalRoot,b=a.firstBatch;this._defer&&null!==b?void 0:t("251");if(this._hasChildren){var c=this._expirationTime;if(b!==this){this._hasChildren&&(c=this._expirationTime=b._expirationTime,this.render(this._children));for(var d=null,e=b;e!==this;)d=e,e=e._next;null===d?t("251"):void 0;d._next=e._next;this._next=b;a.firstBatch=this}this._defer=!1;Ii(a,c);b=this._next;this._next=null;b=a.firstBatch=b;null!==b&&b._hasChildren&&b.render(b._children)}else this._next=
	null,this._defer=!1};Wi.prototype._onComplete=function(){if(!this._didComplete){this._didComplete=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++)(0,a[b])()}};function Xi(){this._callbacks=null;this._didCommit=!1;this._onCommit=this._onCommit.bind(this)}Xi.prototype.then=function(a){if(this._didCommit)a();else{var b=this._callbacks;null===b&&(b=this._callbacks=[]);b.push(a)}};
	Xi.prototype._onCommit=function(){if(!this._didCommit){this._didCommit=!0;var a=this._callbacks;if(null!==a)for(var b=0;b<a.length;b++){var c=a[b];"function"!==typeof c?t("191",c):void 0;c()}}};
	function Yi(a,b,c){b=N(3,null,null,b?3:0);a={current:b,containerInfo:a,pendingChildren:null,pingCache:null,earliestPendingTime:0,latestPendingTime:0,earliestSuspendedTime:0,latestSuspendedTime:0,latestPingedTime:0,didError:!1,pendingCommitExpirationTime:0,finishedWork:null,timeoutHandle:-1,context:null,pendingContext:null,hydrate:c,nextExpirationTimeToWorkOn:0,expirationTime:0,firstBatch:null,nextScheduledRoot:null};this._internalRoot=b.stateNode=a}
	Yi.prototype.render=function(a,b){var c=this._internalRoot,d=new Xi;b=void 0===b?null:b;null!==b&&d.then(b);Ti(a,c,null,d._onCommit);return d};Yi.prototype.unmount=function(a){var b=this._internalRoot,c=new Xi;a=void 0===a?null:a;null!==a&&c.then(a);Ti(null,b,null,c._onCommit);return c};Yi.prototype.legacy_renderSubtreeIntoContainer=function(a,b,c){var d=this._internalRoot,e=new Xi;c=void 0===c?null:c;null!==c&&e.then(c);Ti(b,d,a,e._onCommit);return e};
	Yi.prototype.createBatch=function(){var a=new Wi(this),b=a._expirationTime,c=this._internalRoot,d=c.firstBatch;if(null===d)c.firstBatch=a,a._next=null;else{for(c=null;null!==d&&d._expirationTime>=b;)c=d,d=d._next;a._next=d;null!==c&&(c._next=a)}return a};function Zi(a){return!(!a||1!==a.nodeType&&9!==a.nodeType&&11!==a.nodeType&&(8!==a.nodeType||" react-mount-point-unstable "!==a.nodeValue))}Jb=Pi;Kb=Ri;Lb=function(){W||0===ni||(Li(ni,!1),ni=0)};
	function $i(a,b){b||(b=a?9===a.nodeType?a.documentElement:a.firstChild:null,b=!(!b||1!==b.nodeType||!b.hasAttribute("data-reactroot")));if(!b)for(var c;c=a.lastChild;)a.removeChild(c);return new Yi(a,!1,b)}
	function aj(a,b,c,d,e){var f=c._reactRootContainer;if(f){if("function"===typeof e){var g=e;e=function(){var a=Ui(f._internalRoot);g.call(a)}}null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)}else{f=c._reactRootContainer=$i(c,d);if("function"===typeof e){var h=e;e=function(){var a=Ui(f._internalRoot);h.call(a)}}Qi(function(){null!=a?f.legacy_renderSubtreeIntoContainer(a,b,e):f.render(b,e)})}return Ui(f._internalRoot)}
	function bj(a,b){var c=2<arguments.length&&void 0!==arguments[2]?arguments[2]:null;Zi(b)?void 0:t("200");return Vi(a,b,null,c)}
	var fj={createPortal:bj,findDOMNode:function(a){if(null==a)return null;if(1===a.nodeType)return a;var b=a._reactInternalFiber;void 0===b&&("function"===typeof a.render?t("188"):t("268",Object.keys(a)));a=nd(b);a=null===a?null:a.stateNode;return a},hydrate:function(a,b,c){Zi(b)?void 0:t("200");return aj(null,a,b,!0,c)},render:function(a,b,c){Zi(b)?void 0:t("200");return aj(null,a,b,!1,c)},unstable_renderSubtreeIntoContainer:function(a,b,c,d){Zi(c)?void 0:t("200");null==a||void 0===a._reactInternalFiber?
	t("38"):void 0;return aj(a,b,c,!1,d)},unmountComponentAtNode:function(a){Zi(a)?void 0:t("40");return a._reactRootContainer?(Qi(function(){aj(null,null,a,!1,function(){a._reactRootContainer=null})}),!0):!1},unstable_createPortal:function(){return bj.apply(void 0,arguments)},unstable_batchedUpdates:Pi,unstable_interactiveUpdates:Ri,flushSync:function(a,b){W?t("187"):void 0;var c=Z;Z=!0;try{return ri(a,b)}finally{Z=c,Li(1073741823,!1)}},unstable_createRoot:cj,unstable_flushControlled:function(a){var b=
	Z;Z=!0;try{ri(a)}finally{(Z=b)||W||Li(1073741823,!1)}},__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{Events:[Ka,La,Ma,Da.injectEventPluginsByName,ra,Sa,function(a){Aa(a,Ra)},Hb,Ib,Jd,Fa]}};function cj(a,b){Zi(a)?void 0:t("299","unstable_createRoot");return new Yi(a,!0,null!=b&&!0===b.hydrate)}
	(function(a){var b=a.findFiberByHostInstance;return Ye(p({},a,{overrideProps:null,currentDispatcherRef:Xb.ReactCurrentDispatcher,findHostInstanceByFiber:function(a){a=nd(a);return null===a?null:a.stateNode},findFiberByHostInstance:function(a){return b?b(a):null}}))})({findFiberByHostInstance:Ja,bundleType:0,version:"16.8.0",rendererPackageName:"react-dom"});var gj={default:fj},hj=gj&&fj||gj;module.exports=hj.default||hj;


/***/ },
/* 551 */
/***/ function(module, exports) {

	/** @license React v16.12.0
	 * react-is.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});
	var b="function"===typeof Symbol&&Symbol.for,c=b?Symbol.for("react.element"):60103,d=b?Symbol.for("react.portal"):60106,e=b?Symbol.for("react.fragment"):60107,f=b?Symbol.for("react.strict_mode"):60108,g=b?Symbol.for("react.profiler"):60114,h=b?Symbol.for("react.provider"):60109,k=b?Symbol.for("react.context"):60110,l=b?Symbol.for("react.async_mode"):60111,m=b?Symbol.for("react.concurrent_mode"):60111,n=b?Symbol.for("react.forward_ref"):60112,p=b?Symbol.for("react.suspense"):60113,q=b?Symbol.for("react.suspense_list"):
	60120,r=b?Symbol.for("react.memo"):60115,t=b?Symbol.for("react.lazy"):60116,v=b?Symbol.for("react.fundamental"):60117,w=b?Symbol.for("react.responder"):60118,x=b?Symbol.for("react.scope"):60119;function y(a){if("object"===typeof a&&null!==a){var u=a.$$typeof;switch(u){case c:switch(a=a.type,a){case l:case m:case e:case g:case f:case p:return a;default:switch(a=a&&a.$$typeof,a){case k:case n:case t:case r:case h:return a;default:return u}}case d:return u}}}function z(a){return y(a)===m}
	exports.typeOf=y;exports.AsyncMode=l;exports.ConcurrentMode=m;exports.ContextConsumer=k;exports.ContextProvider=h;exports.Element=c;exports.ForwardRef=n;exports.Fragment=e;exports.Lazy=t;exports.Memo=r;exports.Portal=d;exports.Profiler=g;exports.StrictMode=f;exports.Suspense=p;
	exports.isValidElementType=function(a){return"string"===typeof a||"function"===typeof a||a===e||a===m||a===g||a===f||a===p||a===q||"object"===typeof a&&null!==a&&(a.$$typeof===t||a.$$typeof===r||a.$$typeof===h||a.$$typeof===k||a.$$typeof===n||a.$$typeof===v||a.$$typeof===w||a.$$typeof===x)};exports.isAsyncMode=function(a){return z(a)||y(a)===l};exports.isConcurrentMode=z;exports.isContextConsumer=function(a){return y(a)===k};exports.isContextProvider=function(a){return y(a)===h};
	exports.isElement=function(a){return"object"===typeof a&&null!==a&&a.$$typeof===c};exports.isForwardRef=function(a){return y(a)===n};exports.isFragment=function(a){return y(a)===e};exports.isLazy=function(a){return y(a)===t};exports.isMemo=function(a){return y(a)===r};exports.isPortal=function(a){return y(a)===d};exports.isProfiler=function(a){return y(a)===g};exports.isStrictMode=function(a){return y(a)===f};exports.isSuspense=function(a){return y(a)===p};


/***/ },
/* 552 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(e){return e&&"object"==typeof e&&"default"in e?e.default:e}Object.defineProperty(exports,"__esModule",{value:!0});var reactRouter=__webpack_require__(554),React=_interopDefault(__webpack_require__(2)),history=__webpack_require__(177);__webpack_require__(4),__webpack_require__(41);var invariant=_interopDefault(__webpack_require__(104));function _extends(){return(_extends=Object.assign||function(e){for(var r=1;r<arguments.length;r++){var t=arguments[r];for(var o in t)Object.prototype.hasOwnProperty.call(t,o)&&(e[o]=t[o])}return e}).apply(this,arguments)}function _inheritsLoose(e,r){e.prototype=Object.create(r.prototype),(e.prototype.constructor=e).__proto__=r}function _objectWithoutPropertiesLoose(e,r){if(null==e)return{};var t,o,n={},a=Object.keys(e);for(o=0;o<a.length;o++)t=a[o],0<=r.indexOf(t)||(n[t]=e[t]);return n}var BrowserRouter=function(n){function e(){for(var e,r=arguments.length,t=new Array(r),o=0;o<r;o++)t[o]=arguments[o];return(e=n.call.apply(n,[this].concat(t))||this).history=history.createBrowserHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),HashRouter=function(n){function e(){for(var e,r=arguments.length,t=new Array(r),o=0;o<r;o++)t[o]=arguments[o];return(e=n.call.apply(n,[this].concat(t))||this).history=history.createHashHistory(e.props),e}return _inheritsLoose(e,n),e.prototype.render=function(){return React.createElement(reactRouter.Router,{history:this.history,children:this.props.children})},e}(React.Component),resolveToLocation=function(e,r){return"function"==typeof e?e(r):e},normalizeToLocation=function(e,r){return"string"==typeof e?history.createLocation(e,null,null,r):e},forwardRefShim=function(e){return e},forwardRef=React.forwardRef;function isModifiedEvent(e){return!!(e.metaKey||e.altKey||e.ctrlKey||e.shiftKey)}void 0===forwardRef&&(forwardRef=forwardRefShim);var LinkAnchor=forwardRef(function(e,r){var t=e.innerRef,o=e.navigate,n=e.onClick,a=_objectWithoutPropertiesLoose(e,["innerRef","navigate","onClick"]),i=a.target,c=_extends({},a,{onClick:function(r){try{n&&n(r)}catch(e){throw r.preventDefault(),e}r.defaultPrevented||0!==r.button||i&&"_self"!==i||isModifiedEvent(r)||(r.preventDefault(),o())}});return c.ref=forwardRefShim!==forwardRef&&r||t,React.createElement("a",c)}),Link=forwardRef(function(e,a){var r=e.component,i=void 0===r?LinkAnchor:r,c=e.replace,f=e.to,u=e.innerRef,s=_objectWithoutPropertiesLoose(e,["component","replace","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(r){r||invariant(!1);var t=r.history,e=normalizeToLocation(resolveToLocation(f,r.location),r.location),o=e?t.createHref(e):"",n=_extends({},s,{href:o,navigate:function(){var e=resolveToLocation(f,r.location);(c?t.replace:t.push)(e)}});return forwardRefShim!==forwardRef?n.ref=a||u:n.innerRef=u,React.createElement(i,n)})}),forwardRefShim$1=function(e){return e},forwardRef$1=React.forwardRef;function joinClassnames(){for(var e=arguments.length,r=new Array(e),t=0;t<e;t++)r[t]=arguments[t];return r.filter(function(e){return e}).join(" ")}void 0===forwardRef$1&&(forwardRef$1=forwardRefShim$1);var NavLink=forwardRef$1(function(e,s){var r=e["aria-current"],l=void 0===r?"page":r,t=e.activeClassName,p=void 0===t?"active":t,h=e.activeStyle,R=e.className,d=e.exact,v=e.isActive,y=e.location,m=e.strict,w=e.style,_=e.to,L=e.innerRef,x=_objectWithoutPropertiesLoose(e,["aria-current","activeClassName","activeStyle","className","exact","isActive","location","strict","style","to","innerRef"]);return React.createElement(reactRouter.__RouterContext.Consumer,null,function(e){e||invariant(!1);var r=y||e.location,t=normalizeToLocation(resolveToLocation(_,r),r),o=t.pathname,n=o&&o.replace(/([.+*?=^!:${}()[\]|/\\])/g,"\\$1"),a=n?reactRouter.matchPath(r.pathname,{path:n,exact:d,strict:m}):null,i=!!(v?v(a,r):a),c=i?joinClassnames(R,p):R,f=i?_extends({},w,{},h):w,u=_extends({"aria-current":i&&l||null,className:c,style:f,to:t},x);return forwardRefShim$1!==forwardRef$1?u.ref=s||L:u.innerRef=L,React.createElement(Link,u)})});Object.keys(reactRouter).forEach(function(e){"default"!==e&&Object.defineProperty(exports,e,{enumerable:!0,get:function(){return reactRouter[e]}})}),exports.BrowserRouter=BrowserRouter,exports.HashRouter=HashRouter,exports.Link=Link,exports.NavLink=NavLink;
	//# sourceMappingURL=react-router-dom.min.js.map


/***/ },
/* 553 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";function _interopDefault(t){return t&&"object"==typeof t&&"default"in t?t.default:t}Object.defineProperty(exports,"__esModule",{value:!0});var React=_interopDefault(__webpack_require__(2));__webpack_require__(4);var history=__webpack_require__(177);__webpack_require__(41);var createContext=_interopDefault(__webpack_require__(539)),invariant=_interopDefault(__webpack_require__(104)),pathToRegexp=_interopDefault(__webpack_require__(541));__webpack_require__(18);var hoistStatics=_interopDefault(__webpack_require__(526));function _extends(){return(_extends=Object.assign||function(t){for(var e=1;e<arguments.length;e++){var n=arguments[e];for(var o in n)Object.prototype.hasOwnProperty.call(n,o)&&(t[o]=n[o])}return t}).apply(this,arguments)}function _inheritsLoose(t,e){t.prototype=Object.create(e.prototype),(t.prototype.constructor=t).__proto__=e}function _objectWithoutPropertiesLoose(t,e){if(null==t)return{};var n,o,r={},a=Object.keys(t);for(o=0;o<a.length;o++)n=a[o],0<=e.indexOf(n)||(r[n]=t[n]);return r}var createNamedContext=function(t){var e=createContext();return e.displayName=t,e},context=createNamedContext("Router"),Router=function(n){function t(t){var e;return(e=n.call(this,t)||this).state={location:t.history.location},e._isMounted=!1,e._pendingLocation=null,t.staticContext||(e.unlisten=t.history.listen(function(t){e._isMounted?e.setState({location:t}):e._pendingLocation=t})),e}_inheritsLoose(t,n),t.computeRootMatch=function(t){return{path:"/",url:"/",params:{},isExact:"/"===t}};var e=t.prototype;return e.componentDidMount=function(){this._isMounted=!0,this._pendingLocation&&this.setState({location:this._pendingLocation})},e.componentWillUnmount=function(){this.unlisten&&this.unlisten()},e.render=function(){return React.createElement(context.Provider,{children:this.props.children||null,value:{history:this.props.history,location:this.state.location,match:t.computeRootMatch(this.state.location.pathname),staticContext:this.props.staticContext}})},t}(React.Component),MemoryRouter=function(r){function t(){for(var t,e=arguments.length,n=new Array(e),o=0;o<e;o++)n[o]=arguments[o];return(t=r.call.apply(r,[this].concat(n))||this).history=history.createMemoryHistory(t.props),t}return _inheritsLoose(t,r),t.prototype.render=function(){return React.createElement(Router,{history:this.history,children:this.props.children})},t}(React.Component),Lifecycle=function(t){function e(){return t.apply(this,arguments)||this}_inheritsLoose(e,t);var n=e.prototype;return n.componentDidMount=function(){this.props.onMount&&this.props.onMount.call(this,this)},n.componentDidUpdate=function(t){this.props.onUpdate&&this.props.onUpdate.call(this,this,t)},n.componentWillUnmount=function(){this.props.onUnmount&&this.props.onUnmount.call(this,this)},n.render=function(){return null},e}(React.Component);function Prompt(t){var o=t.message,e=t.when,r=void 0===e||e;return React.createElement(context.Consumer,null,function(t){if(t||invariant(!1),!r||t.staticContext)return null;var n=t.history.block;return React.createElement(Lifecycle,{onMount:function(t){t.release=n(o)},onUpdate:function(t,e){e.message!==o&&(t.release(),t.release=n(o))},onUnmount:function(t){t.release()},message:o})})}var cache={},cacheLimit=1e4,cacheCount=0;function compilePath(t){if(cache[t])return cache[t];var e=pathToRegexp.compile(t);return cacheCount<cacheLimit&&(cache[t]=e,cacheCount++),e}function generatePath(t,e){return void 0===t&&(t="/"),void 0===e&&(e={}),"/"===t?t:compilePath(t)(e,{pretty:!0})}function Redirect(t){var a=t.computedMatch,i=t.to,e=t.push,c=void 0!==e&&e;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=t.history,n=t.staticContext,o=c?e.push:e.replace,r=history.createLocation(a?"string"==typeof i?generatePath(i,a.params):_extends({},i,{pathname:generatePath(i.pathname,a.params)}):i);return n?(o(r),null):React.createElement(Lifecycle,{onMount:function(){o(r)},onUpdate:function(t,e){var n=history.createLocation(e.to);history.locationsAreEqual(n,_extends({},r,{key:n.key}))||o(r)},to:i})})}var cache$1={},cacheLimit$1=1e4,cacheCount$1=0;function compilePath$1(t,e){var n=""+e.end+e.strict+e.sensitive,o=cache$1[n]||(cache$1[n]={});if(o[t])return o[t];var r=[],a={regexp:pathToRegexp(t,r,e),keys:r};return cacheCount$1<cacheLimit$1&&(o[t]=a,cacheCount$1++),a}function matchPath(u,t){void 0===t&&(t={}),"string"!=typeof t&&!Array.isArray(t)||(t={path:t});var e=t,n=e.path,o=e.exact,p=void 0!==o&&o,r=e.strict,h=void 0!==r&&r,a=e.sensitive,l=void 0!==a&&a;return[].concat(n).reduce(function(t,e){if(!e&&""!==e)return null;if(t)return t;var n=compilePath$1(e,{end:p,strict:h,sensitive:l}),o=n.regexp,r=n.keys,a=o.exec(u);if(!a)return null;var i=a[0],c=a.slice(1),s=u===i;return p&&!s?null:{path:e,url:"/"===e&&""===i?"/":i,isExact:s,params:r.reduce(function(t,e,n){return t[e.name]=c[n],t},{})}},null)}var Route=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var c=this;return React.createElement(context.Consumer,null,function(t){t||invariant(!1);var e=c.props.location||t.location,n=_extends({},t,{location:e,match:c.props.computedMatch?c.props.computedMatch:c.props.path?matchPath(e.pathname,c.props):t.match}),o=c.props,r=o.children,a=o.component,i=o.render;return Array.isArray(r)&&0===r.length&&(r=null),React.createElement(context.Provider,{value:n},n.match?r?"function"==typeof r?r(n):r:a?React.createElement(a,n):i?i(n):null:"function"==typeof r?r(n):null)})},e}(React.Component);function addLeadingSlash(t){return"/"===t.charAt(0)?t:"/"+t}function addBasename(t,e){return t?_extends({},e,{pathname:addLeadingSlash(t)+e.pathname}):e}function stripBasename(t,e){if(!t)return e;var n=addLeadingSlash(t);return 0!==e.pathname.indexOf(n)?e:_extends({},e,{pathname:e.pathname.substr(n.length)})}function createURL(t){return"string"==typeof t?t:history.createPath(t)}function staticHandler(t){return function(){invariant(!1)}}function noop(){}var StaticRouter=function(r){function t(){for(var e,t=arguments.length,n=new Array(t),o=0;o<t;o++)n[o]=arguments[o];return(e=r.call.apply(r,[this].concat(n))||this).handlePush=function(t){return e.navigateTo(t,"PUSH")},e.handleReplace=function(t){return e.navigateTo(t,"REPLACE")},e.handleListen=function(){return noop},e.handleBlock=function(){return noop},e}_inheritsLoose(t,r);var e=t.prototype;return e.navigateTo=function(t,e){var n=this.props,o=n.basename,r=void 0===o?"":o,a=n.context,i=void 0===a?{}:a;i.action=e,i.location=addBasename(r,history.createLocation(t)),i.url=createURL(i.location)},e.render=function(){var t=this.props,e=t.basename,n=void 0===e?"":e,o=t.context,r=void 0===o?{}:o,a=t.location,i=void 0===a?"/":a,c=_objectWithoutPropertiesLoose(t,["basename","context","location"]),s={createHref:function(t){return addLeadingSlash(n+createURL(t))},action:"POP",location:stripBasename(n,history.createLocation(i)),push:this.handlePush,replace:this.handleReplace,go:staticHandler(),goBack:staticHandler(),goForward:staticHandler(),listen:this.handleListen,block:this.handleBlock};return React.createElement(Router,_extends({},c,{history:s,staticContext:r}))},t}(React.Component),Switch=function(t){function e(){return t.apply(this,arguments)||this}return _inheritsLoose(e,t),e.prototype.render=function(){var t=this;return React.createElement(context.Consumer,null,function(n){n||invariant(!1);var o,r,a=t.props.location||n.location;return React.Children.forEach(t.props.children,function(t){if(null==r&&React.isValidElement(t)){var e=(o=t).props.path||t.props.from;r=e?matchPath(a.pathname,_extends({},t.props,{path:e})):n.match}}),r?React.cloneElement(o,{location:a,computedMatch:r}):null})},e}(React.Component);function withRouter(o){function t(t){var e=t.wrappedComponentRef,n=_objectWithoutPropertiesLoose(t,["wrappedComponentRef"]);return React.createElement(context.Consumer,null,function(t){return t||invariant(!1),React.createElement(o,_extends({},n,t,{ref:e}))})}var e="withRouter("+(o.displayName||o.name)+")";return t.displayName=e,t.WrappedComponent=o,hoistStatics(t,o)}var useContext=React.useContext;function useHistory(){return useContext(context).history}function useLocation(){return useContext(context).location}function useParams(){var t=useContext(context).match;return t?t.params:{}}function useRouteMatch(t){return t?matchPath(useLocation().pathname,t):useContext(context).match}exports.MemoryRouter=MemoryRouter,exports.Prompt=Prompt,exports.Redirect=Redirect,exports.Route=Route,exports.Router=Router,exports.StaticRouter=StaticRouter,exports.Switch=Switch,exports.__RouterContext=context,exports.generatePath=generatePath,exports.matchPath=matchPath,exports.useHistory=useHistory,exports.useLocation=useLocation,exports.useParams=useParams,exports.useRouteMatch=useRouteMatch,exports.withRouter=withRouter;
	//# sourceMappingURL=react-router.min.js.map


/***/ },
/* 554 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	if (true) {
	  module.exports = __webpack_require__(553);
	} else {
	  module.exports = require("./cjs/react-router.js");
	}


/***/ },
/* 555 */
/***/ function(module, exports, __webpack_require__) {

	// @remove-on-eject-begin
	/**
	 * Copyright (c) 2015-present, Facebook, Inc.
	 * All rights reserved.
	 *
	 * This source code is licensed under the BSD-style license found in the
	 * LICENSE file in the root directory of this source tree. An additional grant
	 * of patent rights can be found in the PATENTS file in the same directory.
	 */
	// @remove-on-eject-end
	
	if (typeof Promise === 'undefined') {
	  // Rejection tracking prevents a common issue where React gets into an
	  // inconsistent state due to an error, but it gets swallowed by a Promise,
	  // and the user has no idea what causes React's erratic future behavior.
	  __webpack_require__(579).enable();
	  window.Promise = __webpack_require__(578);
	}
	
	// fetch() polyfill for making API calls.
	__webpack_require__(581);
	
	// Object.assign() is commonly used with React.
	// It will use the native implementation if it's present and isn't buggy.
	Object.assign = __webpack_require__(577);


/***/ },
/* 556 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {"use strict";
	
	// Use the fastest means possible to execute a task in its own turn, with
	// priority over other events including IO, animation, reflow, and redraw
	// events in browsers.
	//
	// An exception thrown by a task will permanently interrupt the processing of
	// subsequent tasks. The higher level `asap` function ensures that if an
	// exception is thrown by a task, that the task queue will continue flushing as
	// soon as possible, but if you use `rawAsap` directly, you are responsible to
	// either ensure that no exceptions are thrown from your task, or to manually
	// call `rawAsap.requestFlush` if an exception is thrown.
	module.exports = rawAsap;
	function rawAsap(task) {
	    if (!queue.length) {
	        requestFlush();
	        flushing = true;
	    }
	    // Equivalent to push, but avoids a function call.
	    queue[queue.length] = task;
	}
	
	var queue = [];
	// Once a flush has been requested, no further calls to `requestFlush` are
	// necessary until the next `flush` completes.
	var flushing = false;
	// `requestFlush` is an implementation-specific method that attempts to kick
	// off a `flush` event as quickly as possible. `flush` will attempt to exhaust
	// the event queue before yielding to the browser's own event loop.
	var requestFlush;
	// The position of the next task to execute in the task queue. This is
	// preserved between calls to `flush` so that it can be resumed if
	// a task throws an exception.
	var index = 0;
	// If a task schedules additional tasks recursively, the task queue can grow
	// unbounded. To prevent memory exhaustion, the task queue will periodically
	// truncate already-completed tasks.
	var capacity = 1024;
	
	// The flush function processes all tasks that have been scheduled with
	// `rawAsap` unless and until one of those tasks throws an exception.
	// If a task throws an exception, `flush` ensures that its state will remain
	// consistent and will resume where it left off when called again.
	// However, `flush` does not make any arrangements to be called again if an
	// exception is thrown.
	function flush() {
	    while (index < queue.length) {
	        var currentIndex = index;
	        // Advance the index before calling the task. This ensures that we will
	        // begin flushing on the next task the task throws an error.
	        index = index + 1;
	        queue[currentIndex].call();
	        // Prevent leaking memory for long chains of recursive calls to `asap`.
	        // If we call `asap` within tasks scheduled by `asap`, the queue will
	        // grow, but to avoid an O(n) walk for every task we execute, we don't
	        // shift tasks off the queue after they have been executed.
	        // Instead, we periodically shift 1024 tasks off the queue.
	        if (index > capacity) {
	            // Manually shift all values starting at the index back to the
	            // beginning of the queue.
	            for (var scan = 0, newLength = queue.length - index; scan < newLength; scan++) {
	                queue[scan] = queue[scan + index];
	            }
	            queue.length -= index;
	            index = 0;
	        }
	    }
	    queue.length = 0;
	    index = 0;
	    flushing = false;
	}
	
	// `requestFlush` is implemented using a strategy based on data collected from
	// every available SauceLabs Selenium web driver worker at time of writing.
	// https://docs.google.com/spreadsheets/d/1mG-5UYGup5qxGdEMWkhP6BWCz053NUb2E1QoUTU16uA/edit#gid=783724593
	
	// Safari 6 and 6.1 for desktop, iPad, and iPhone are the only browsers that
	// have WebKitMutationObserver but not un-prefixed MutationObserver.
	// Must use `global` or `self` instead of `window` to work in both frames and web
	// workers. `global` is a provision of Browserify, Mr, Mrs, or Mop.
	
	/* globals self */
	var scope = typeof global !== "undefined" ? global : self;
	var BrowserMutationObserver = scope.MutationObserver || scope.WebKitMutationObserver;
	
	// MutationObservers are desirable because they have high priority and work
	// reliably everywhere they are implemented.
	// They are implemented in all modern browsers.
	//
	// - Android 4-4.3
	// - Chrome 26-34
	// - Firefox 14-29
	// - Internet Explorer 11
	// - iPad Safari 6-7.1
	// - iPhone Safari 7-7.1
	// - Safari 6-7
	if (typeof BrowserMutationObserver === "function") {
	    requestFlush = makeRequestCallFromMutationObserver(flush);
	
	// MessageChannels are desirable because they give direct access to the HTML
	// task queue, are implemented in Internet Explorer 10, Safari 5.0-1, and Opera
	// 11-12, and in web workers in many engines.
	// Although message channels yield to any queued rendering and IO tasks, they
	// would be better than imposing the 4ms delay of timers.
	// However, they do not work reliably in Internet Explorer or Safari.
	
	// Internet Explorer 10 is the only browser that has setImmediate but does
	// not have MutationObservers.
	// Although setImmediate yields to the browser's renderer, it would be
	// preferrable to falling back to setTimeout since it does not have
	// the minimum 4ms penalty.
	// Unfortunately there appears to be a bug in Internet Explorer 10 Mobile (and
	// Desktop to a lesser extent) that renders both setImmediate and
	// MessageChannel useless for the purposes of ASAP.
	// https://github.com/kriskowal/q/issues/396
	
	// Timers are implemented universally.
	// We fall back to timers in workers in most engines, and in foreground
	// contexts in the following browsers.
	// However, note that even this simple case requires nuances to operate in a
	// broad spectrum of browsers.
	//
	// - Firefox 3-13
	// - Internet Explorer 6-9
	// - iPad Safari 4.3
	// - Lynx 2.8.7
	} else {
	    requestFlush = makeRequestCallFromTimer(flush);
	}
	
	// `requestFlush` requests that the high priority event queue be flushed as
	// soon as possible.
	// This is useful to prevent an error thrown in a task from stalling the event
	// queue if the exception handled by Node.js’s
	// `process.on("uncaughtException")` or by a domain.
	rawAsap.requestFlush = requestFlush;
	
	// To request a high priority event, we induce a mutation observer by toggling
	// the text of a text node between "1" and "-1".
	function makeRequestCallFromMutationObserver(callback) {
	    var toggle = 1;
	    var observer = new BrowserMutationObserver(callback);
	    var node = document.createTextNode("");
	    observer.observe(node, {characterData: true});
	    return function requestCall() {
	        toggle = -toggle;
	        node.data = toggle;
	    };
	}
	
	// The message channel technique was discovered by Malte Ubl and was the
	// original foundation for this library.
	// http://www.nonblocking.io/2011/06/windownexttick.html
	
	// Safari 6.0.5 (at least) intermittently fails to create message ports on a
	// page's first load. Thankfully, this version of Safari supports
	// MutationObservers, so we don't need to fall back in that case.
	
	// function makeRequestCallFromMessageChannel(callback) {
	//     var channel = new MessageChannel();
	//     channel.port1.onmessage = callback;
	//     return function requestCall() {
	//         channel.port2.postMessage(0);
	//     };
	// }
	
	// For reasons explained above, we are also unable to use `setImmediate`
	// under any circumstances.
	// Even if we were, there is another bug in Internet Explorer 10.
	// It is not sufficient to assign `setImmediate` to `requestFlush` because
	// `setImmediate` must be called *by name* and therefore must be wrapped in a
	// closure.
	// Never forget.
	
	// function makeRequestCallFromSetImmediate(callback) {
	//     return function requestCall() {
	//         setImmediate(callback);
	//     };
	// }
	
	// Safari 6.0 has a problem where timers will get lost while the user is
	// scrolling. This problem does not impact ASAP because Safari 6.0 supports
	// mutation observers, so that implementation is used instead.
	// However, if we ever elect to use timers in Safari, the prevalent work-around
	// is to add a scroll event listener that calls for a flush.
	
	// `setTimeout` does not call the passed callback if the delay is less than
	// approximately 7 in web workers in Firefox 8 through 18, and sometimes not
	// even then.
	
	function makeRequestCallFromTimer(callback) {
	    return function requestCall() {
	        // We dispatch a timeout with a specified delay of 0 for engines that
	        // can reliably accommodate that request. This will usually be snapped
	        // to a 4 milisecond delay, but once we're flushing, there's no delay
	        // between events.
	        var timeoutHandle = setTimeout(handleTimer, 0);
	        // However, since this timer gets frequently dropped in Firefox
	        // workers, we enlist an interval handle that will try to fire
	        // an event 20 times per second until it succeeds.
	        var intervalHandle = setInterval(handleTimer, 50);
	
	        function handleTimer() {
	            // Whichever timer succeeds will cancel both timers and
	            // execute the callback.
	            clearTimeout(timeoutHandle);
	            clearInterval(intervalHandle);
	            callback();
	        }
	    };
	}
	
	// This is for `asap.js` only.
	// Its name will be periodically randomized to break any code that depends on
	// its existence.
	rawAsap.makeRequestCallFromTimer = makeRequestCallFromTimer;
	
	// ASAP was originally a nextTick shim included in Q. This was factored out
	// into this ASAP package. It was later adapted to RSVP which made further
	// amendments. These decisions, particularly to marginalize MessageChannel and
	// to capture the MutationObserver implementation in a closure, were integrated
	// back into ASAP proper.
	// https://github.com/tildeio/rsvp.js/blob/cddf7232546a9cf858524b75cde6f9edf72620a7/lib/rsvp/asap.js
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 557 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(181);
	
	__webpack_require__(14);
	
	var _BarChart = __webpack_require__(558);
	
	var _BarChart2 = _interopRequireDefault(_BarChart);
	
	var _Post1Tree = __webpack_require__(563);
	
	var _Post1Tree2 = _interopRequireDefault(_Post1Tree);
	
	var _Post2Tree = __webpack_require__(566);
	
	var _Post2Tree2 = _interopRequireDefault(_Post2Tree);
	
	var _Post2Map = __webpack_require__(564);
	
	var _Post2Map2 = _interopRequireDefault(_Post2Map);
	
	var _Post2Table = __webpack_require__(565);
	
	var _Post2Table2 = _interopRequireDefault(_Post2Table);
	
	var _Post3Table = __webpack_require__(568);
	
	var _Post3Table2 = _interopRequireDefault(_Post3Table);
	
	var _Post3Map = __webpack_require__(567);
	
	var _Post3Map2 = _interopRequireDefault(_Post3Map);
	
	var _Post4DistrictMap = __webpack_require__(569);
	
	var _Post4DistrictMap2 = _interopRequireDefault(_Post4DistrictMap);
	
	var _Post4Map = __webpack_require__(570);
	
	var _Post4Map2 = _interopRequireDefault(_Post4Map);
	
	var _Post4Table = __webpack_require__(571);
	
	var _Post4Table2 = _interopRequireDefault(_Post4Table);
	
	var _Post5Table = __webpack_require__(573);
	
	var _Post5Table2 = _interopRequireDefault(_Post5Table);
	
	var _Post5Map = __webpack_require__(572);
	
	var _Post5Map2 = _interopRequireDefault(_Post5Map);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var App = function (_Component) {
	  _inherits(App, _Component);
	
	  function App() {
	    _classCallCheck(this, App);
	
	    return _possibleConstructorReturn(this, (App.__proto__ || Object.getPrototypeOf(App)).apply(this, arguments));
	  }
	
	  _createClass(App, [{
	    key: 'render',
	    value: function render() {
	
	      return _react2.default.createElement(
	        _reactRouterDom.HashRouter,
	        { basename: '/' },
	        _react2.default.createElement(
	          'main',
	          null,
	          _react2.default.createElement(
	            _reactRouterDom.Switch,
	            null,
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/', component: _Post1Tree2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post1Tree', component: _Post1Tree2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post2Tree', component: _Post2Tree2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post2Map', component: _Post2Map2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post2Table', component: _Post2Table2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post3Table', component: _Post3Table2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post3Map', component: _Post3Map2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post4Map', component: _Post4Map2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post4DistrictMap', component: _Post4DistrictMap2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post4Table', component: _Post4Table2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post5Table', component: _Post5Table2.default }),
	            _react2.default.createElement(_reactRouterDom.Route, { exact: true, path: '/Post5Map', component: _Post5Map2.default })
	          )
	        )
	      );
	    }
	  }]);
	
	  return App;
	}(_react.Component);
	
	exports.default = App;

/***/ },
/* 558 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Scale = __webpack_require__(71);
	
	var _d3Array = __webpack_require__(31);
	
	var _d3Selection = __webpack_require__(99);
	
	var _d3SvgLegend = __webpack_require__(511);
	
	var _d3Transition = __webpack_require__(516);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var BarChart = function (_Component) {
	  _inherits(BarChart, _Component);
	
	  function BarChart(props) {
	    _classCallCheck(this, BarChart);
	
	    var _this = _possibleConstructorReturn(this, (BarChart.__proto__ || Object.getPrototypeOf(BarChart)).call(this, props));
	
	    _this.createBarChart = _this.createBarChart.bind(_this);
	    return _this;
	  }
	
	  _createClass(BarChart, [{
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      this.createBarChart();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      this.createBarChart();
	    }
	  }, {
	    key: 'createBarChart',
	    value: function createBarChart() {
	      var _this2 = this;
	
	      var node = this.node;
	      var dataMax = (0, _d3Array.max)(this.props.data.map(function (d) {
	        return (0, _d3Array.sum)(d.data);
	      }));
	      var barWidth = this.props.size[0] / this.props.data.length;
	
	      var legend = (0, _d3SvgLegend.legendColor)().scale(this.props.colorScale).labels(["Wave 1", "Wave 2", "Wave 3", "Wave 4"]);
	
	      (0, _d3Selection.select)(node).selectAll("g.legend").data([0]).enter().append("g").attr("class", "legend").call(legend);
	
	      (0, _d3Selection.select)(node).select("g.legend").attr("transform", "translate(" + (this.props.size[0] - 100) + ", 20)");
	
	      var yScale = (0, _d3Scale.scaleLinear)().domain([0, dataMax]).range([0, this.props.size[1]]);
	
	      (0, _d3Selection.select)(node).selectAll("rect.bar").data(this.props.data).enter().append("rect").attr("class", "bar").on("mouseover", this.props.onHover);
	
	      (0, _d3Selection.select)(node).selectAll("rect.bar").data(this.props.data).exit().remove();
	
	      (0, _d3Selection.select)(node).selectAll("rect.bar").data(this.props.data).attr("x", function (d, i) {
	        return i * barWidth;
	      }).attr("y", function (d) {
	        return _this2.props.size[1] - yScale((0, _d3Array.sum)(d.data));
	      }).attr("height", function (d) {
	        return yScale((0, _d3Array.sum)(d.data));
	      }).attr("width", barWidth).style("fill", function (d, i) {
	        return _this2.props.colorScale(d.launchday);
	      }).style("stroke", "black").style("stroke-opacity", 0.25);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var _this3 = this;
	
	      return _react2.default.createElement('svg', { ref: function ref(node) {
	          return _this3.node = node;
	        }, width: this.props.size[0], height: this.props.size[1] });
	    }
	  }]);
	
	  return BarChart;
	}(_react.Component);
	
	exports.default = BarChart;

/***/ },
/* 559 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _ColorSchemes = __webpack_require__(72);
	
	var _FormatMoney = __webpack_require__(59);
	
	var _FormatMoney2 = _interopRequireDefault(_FormatMoney);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _counties10m = __webpack_require__(561);
	
	var _counties10m2 = _interopRequireDefault(_counties10m);
	
	var _states10m = __webpack_require__(183);
	
	var _states10m2 = _interopRequireDefault(_states10m);
	
	var _d3Array = __webpack_require__(31);
	
	var _d3Geo = __webpack_require__(175);
	
	var _topojsonClient = __webpack_require__(190);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var colorScale = _ColorSchemes.bucketScale;
	
	var CountiesMap = function (_Component) {
	  _inherits(CountiesMap, _Component);
	
	  function CountiesMap() {
	    _classCallCheck(this, CountiesMap);
	
	    return _possibleConstructorReturn(this, (CountiesMap.__proto__ || Object.getPrototypeOf(CountiesMap)).apply(this, arguments));
	  }
	
	  _createClass(CountiesMap, [{
	    key: 'render',
	    value: function render() {
	      var width = (0, _d3Array.min)([900, this.props.size[0]]);
	      var slice = this.props.slice;
	      var dataset = this.props.data;
	
	      var stateTopojsonData = (0, _topojsonClient.feature)(_states10m2.default, _states10m2.default.objects.states).features;
	      var topojsonData = (0, _topojsonClient.feature)(_counties10m2.default, _counties10m2.default.objects.counties).features;
	      var projection = (0, _d3Geo.geoAlbersUsa)().scale(width * 1).translate([width / 2, 250]);
	      var pathGenerator = (0, _d3Geo.geoPath)().projection(projection);
	
	      if (dataset.length > 0) {
	        var _loop = function _loop(s) {
	          var countydata = dataset.find(function (e) {
	            return e.GEOID === topojsonData[s].id;
	          });
	          for (var key in countydata) {
	            if (key !== "" && key !== "GEOID") {
	              topojsonData[s].properties[key] = countydata[key];
	            }
	          }
	        };
	
	        for (var s = 0; s < topojsonData.length; s++) {
	          _loop(s);
	        }
	
	        colorScale.domain([-1.3, 0, 0.5, 1.3]);
	
	        var states = stateTopojsonData.map(function (d, i) {
	          return _react2.default.createElement('path', {
	            key: "path" + i,
	            d: pathGenerator(d),
	            style: {
	              fill: "none",
	              stroke: "white",
	              strokeOpacity: 1,
	              strokeWidth: "1.5px"
	            },
	            className: "states " + d.properties.name
	          });
	        });
	
	        var counties = topojsonData.map(function (d, i) {
	          return _react2.default.createElement('path', {
	            key: "path" + i,
	            d: pathGenerator(d),
	            'data-tip': d.properties["County"] + ": " + Math.round(d.properties["pop_change"] * 1000) / 1000 + "%",
	            style: {
	              fill: colorScale(d.properties[slice]),
	              stroke: "white",
	              strokeOpacity: 0.1
	            },
	            className: "counties " + d.properties.name
	          });
	        });
	
	        var legmargin = {
	          vertical: 20,
	          textoffset: 25
	        };
	
	        var legend = _react2.default.createElement(
	          'g',
	          { transform: "translate(" + (width - 150) + ", " + (this.props.size[1] - legmargin.vertical * 8) + ")" },
	          _react2.default.createElement('rect', {
	            width: 20, height: 20, x: 0, y: 0,
	            style: { fill: colorScale(-2) }
	          }),
	          _react2.default.createElement(
	            'text',
	            {
	              x: legmargin.textoffset,
	              y: legmargin.vertical * 1 - 5, fontSize: '0.75rem', textAnchor: 'start'
	            },
	            "Less than " + colorScale.domain()[0] + "%"
	          ),
	          _react2.default.createElement('rect', {
	            width: 20, height: 20, x: 0, y: legmargin.vertical * 1,
	            style: { fill: colorScale(-0.5) }
	          }),
	          _react2.default.createElement(
	            'text',
	            {
	              x: legmargin.textoffset,
	              y: legmargin.vertical * 2 - 5, fontSize: '0.75rem', textAnchor: 'start'
	            },
	            colorScale.domain()[0] + "% - " + colorScale.domain()[1] + "%"
	          ),
	          _react2.default.createElement('rect', {
	            width: 20, height: 20, x: 0, y: legmargin.vertical * 2,
	            style: { fill: colorScale(0.25) }
	          }),
	          _react2.default.createElement(
	            'text',
	            {
	              x: legmargin.textoffset,
	              y: legmargin.vertical * 3 - 5, fontSize: '0.75rem', textAnchor: 'start'
	            },
	            colorScale.domain()[1] + "% - " + colorScale.domain()[2] + "%"
	          ),
	          _react2.default.createElement('rect', {
	            width: 20, height: 20, x: 0, y: legmargin.vertical * 3,
	            style: { fill: colorScale(0.5) }
	          }),
	          _react2.default.createElement(
	            'text',
	            {
	              x: legmargin.textoffset,
	              y: legmargin.vertical * 4 - 5, fontSize: '0.75rem', textAnchor: 'start'
	            },
	            colorScale.domain()[2] + "% - " + colorScale.domain()[3] + "%"
	          ),
	          _react2.default.createElement('rect', {
	            width: 20, height: 20, x: 0, y: legmargin.vertical * 4,
	            style: { fill: colorScale(2) }
	          }),
	          _react2.default.createElement(
	            'text',
	            {
	              x: legmargin.textoffset,
	              y: legmargin.vertical * 5 - 5, fontSize: '0.75rem', textAnchor: 'start'
	            },
	            colorScale.domain()[3] + "% and up"
	          )
	        );
	
	        return _react2.default.createElement(
	          'svg',
	          { width: this.props.size[0], height: this.props.size[1] },
	          counties,
	          states,
	          legend
	        );
	      } else {
	        var _counties = topojsonData.map(function (d, i) {
	          return _react2.default.createElement('path', {
	            key: "path" + i,
	            d: pathGenerator(d),
	            style: { fill: "#ccc", stroke: "white", strokeOpacity: 0.5 },
	            className: "counties " + d.properties.name
	          });
	        });
	        return _react2.default.createElement(
	          'svg',
	          { width: width, height: this.props.size[1] },
	          _counties
	        );
	      }
	    }
	  }]);
	
	  return CountiesMap;
	}(_react.Component);
	
	exports.default = CountiesMap;

/***/ },
/* 560 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	var usStateNames = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
	
	exports.default = usStateNames;

/***/ },
/* 561 */
/***/ function(module, exports) {

	"use strict";Object.defineProperty(exports,"__esModule",{value:true});exports.default={"type":"Topology","bbox":[-179.14733999999999,-14.552548999999999,179.77847,71.352561],"transform":{"scale":[0.003589293992939929,0.0008590596905969058],"translate":[-179.14733999999999,-14.552548999999999]},"objects":{"counties":{"type":"GeometryCollection","geometries":[{"type":"Polygon","arcs":[[0,1,2,3,4,5,6,7,8,9,10,11]],"id":"04015","properties":{"name":"Mohave"}},{"type":"Polygon","arcs":[[12,13,14,15,16,17,18]],"id":"22105","properties":{"name":"Tangipahoa"}},{"type":"Polygon","arcs":[[19,20,21,22,23]],"id":"16063","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[24,25,26,27,28,29,30,31,32]],"id":"27119","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[33,34,35,36,37,38,39]],"id":"38017","properties":{"name":"Cass"}},{"type":"Polygon","arcs":[[40,41,42,43,44]],"id":"46081","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[45,46,47,48,49,50]],"id":"36095","properties":{"name":"Schoharie"}},{"type":"MultiPolygon","arcs":[[[51]],[[52]],[[53]],[[54,55,56,57]],[[58]],[[59]]],"id":"02275","properties":{"name":"Wrangell"}},{"type":"Polygon","arcs":[[60,61,62,63]],"id":"13143","properties":{"name":"Haralson"}},{"type":"Polygon","arcs":[[64,65,66,67,68]],"id":"13023","properties":{"name":"Bleckley"}},{"type":"Polygon","arcs":[[69,70,71,72,73,74]],"id":"18093","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[75,76,77,78,79,80]],"id":"18079","properties":{"name":"Jennings"}},{"type":"Polygon","arcs":[[81,82,83,84,85,86]],"id":"26087","properties":{"name":"Lapeer"}},{"type":"Polygon","arcs":[[87,88,89,90,91,92]],"id":"28017","properties":{"name":"Chickasaw"}},{"type":"Polygon","arcs":[[93,94,95,96,97,98]],"id":"39033","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[99,100,101,102,103,104,105]],"id":"46099","properties":{"name":"Minnehaha"}},{"type":"Polygon","arcs":[[106,-105,107,108,109,110]],"id":"46125","properties":{"name":"Turner"}},{"type":"Polygon","arcs":[[111,112,113,114,115,116]],"id":"48471","properties":{"name":"Walker"}},{"type":"Polygon","arcs":[[117,118,119,120]],"id":"72133","properties":{"name":"Santa Isabel"}},{"type":"Polygon","arcs":[[121,122,123,124,125,126]],"id":"46003","properties":{"name":"Aurora"}},{"type":"Polygon","arcs":[[127,128,129,130,131,132,133]],"id":"48047","properties":{"name":"Brooks"}},{"type":"Polygon","arcs":[[134,135,136,137,138,139,140]],"id":"72025","properties":{"name":"Caguas"}},{"type":"Polygon","arcs":[[141,142,143,144,145]],"id":"72033","properties":{"name":"CataÃ±o"}},{"type":"Polygon","arcs":[[146,147,148,149,150,151]],"id":"72101","properties":{"name":"Morovis"}},{"type":"Polygon","arcs":[[152,153,154,155,156]],"id":"31029","properties":{"name":"Chase"}},{"type":"Polygon","arcs":[[157,158,159,160]],"id":"72054","properties":{"name":"Florida"}},{"type":"Polygon","arcs":[[161,162,163,164,165,166]],"id":"08021","properties":{"name":"Conejos"}},{"type":"Polygon","arcs":[[167,168,169,170,171,172,173,174]],"id":"24043","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[175,176,177,178,179]],"id":"20137","properties":{"name":"Norton"}},{"type":"Polygon","arcs":[[180,181,182,183,184,185]],"id":"17053","properties":{"name":"Ford"}},{"type":"Polygon","arcs":[[186,187,188,189,190,191]],"id":"48117","properties":{"name":"Deaf Smith"}},{"type":"Polygon","arcs":[[192,193,194,195,196,197,198,199]],"id":"13261","properties":{"name":"Sumter"}},{"type":"Polygon","arcs":[[200,201,202,203,204,205,206,207]],"id":"55075","properties":{"name":"Marinette"}},{"type":"Polygon","arcs":[[208,209,210,211,212,213,214]],"id":"06069","properties":{"name":"San Benito"}},{"type":"Polygon","arcs":[[215,216,217,218,219,220,221]],"id":"13199","properties":{"name":"Meriwether"}},{"type":"Polygon","arcs":[[222,223,224,225,226,227]],"id":"19013","properties":{"name":"Black Hawk"}},{"type":"Polygon","arcs":[[228,229,230,231]],"id":"19081","properties":{"name":"Hancock"}},{"type":"Polygon","arcs":[[232,-27]],"id":"27125","properties":{"name":"Red Lake"}},{"type":"Polygon","arcs":[[233,234,235,236,237]],"id":"31125","properties":{"name":"Nance"}},{"type":"Polygon","arcs":[[238,239,240,241]],"id":"42075","properties":{"name":"Lebanon"}},{"type":"Polygon","arcs":[[242,243,244,245]],"id":"48219","properties":{"name":"Hockley"}},{"type":"Polygon","arcs":[[246,247,248,249,250,251]],"id":"48417","properties":{"name":"Shackelford"}},{"type":"Polygon","arcs":[[252,253,254,255,256,257,258]],"id":"48451","properties":{"name":"Tom Green"}},{"type":"Polygon","arcs":[[259,260,261,262,263,264]],"id":"48497","properties":{"name":"Wise"}},{"type":"Polygon","arcs":[[265,266,267,-100,268,269]],"id":"46079","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[270,271,272,273,274,275,276]],"id":"46069","properties":{"name":"Hyde"}},{"type":"Polygon","arcs":[[277,278,279,280,281,282]],"id":"48101","properties":{"name":"Cottle"}},{"type":"Polygon","arcs":[[283,284,285]],"id":"04023","properties":{"name":"Santa Cruz"}},{"type":"Polygon","arcs":[[286,287,288,289,290]],"id":"19179","properties":{"name":"Wapello"}},{"type":"Polygon","arcs":[[291,292,293,294,295,296]],"id":"19031","properties":{"name":"Cedar"}},{"type":"Polygon","arcs":[[297,298,299,300,301,302,303,304,305]],"id":"30033","properties":{"name":"Garfield"}},{"type":"Polygon","arcs":[[306,307,308,309,310,311,312]],"id":"29185","properties":{"name":"St. Clair"}},{"type":"Polygon","arcs":[[313,314,315,316,317]],"id":"12091","properties":{"name":"Okaloosa"}},{"type":"Polygon","arcs":[[318,319,320,321,322]],"id":"21219","properties":{"name":"Todd"}},{"type":"Polygon","arcs":[[323,324,325,326,327]],"id":"23003","properties":{"name":"Aroostook"}},{"type":"Polygon","arcs":[[328,329,330,-175,331,332,333,334]],"id":"24001","properties":{"name":"Allegany"}},{"type":"Polygon","arcs":[[335,336,337,338,339]],"id":"28075","properties":{"name":"Lauderdale"}},{"type":"Polygon","arcs":[[340,341,342,343,344,345]],"id":"38021","properties":{"name":"Dickey"}},{"type":"Polygon","arcs":[[346,347,348,349,350]],"id":"27093","properties":{"name":"Meeker"}},{"type":"Polygon","arcs":[[351,352,353,354]],"id":"46007","properties":{"name":"Bennett"}},{"type":"Polygon","arcs":[[355,356,357,358,359,360,361,362]],"id":"49043","properties":{"name":"Summit"}},{"type":"Polygon","arcs":[[363,364,365,366,367,368]],"id":"36099","properties":{"name":"Seneca"}},{"type":"Polygon","arcs":[[369,370,371,372,373,374,375]],"id":"20073","properties":{"name":"Greenwood"}},{"type":"Polygon","arcs":[[376,377,378,379]],"id":"20101","properties":{"name":"Lane"}},{"type":"Polygon","arcs":[[380,381,382,383,384,385]],"id":"26123","properties":{"name":"Newaygo"}},{"type":"Polygon","arcs":[[386,387,388,389,390]],"id":"31035","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[391,392,393,394]],"id":"36073","properties":{"name":"Orleans"}},{"type":"Polygon","arcs":[[395,396,397,398,399,400,401]],"id":"38063","properties":{"name":"Nelson"}},{"type":"Polygon","arcs":[[402,403,404,405,406,407]],"id":"40011","properties":{"name":"Blaine"}},{"type":"Polygon","arcs":[[408,409,410,411,412]],"id":"48441","properties":{"name":"Taylor"}},{"type":"Polygon","arcs":[[413,414,415,416,417]],"id":"48011","properties":{"name":"Armstrong"}},{"type":"Polygon","arcs":[[418,419,420,421]],"id":"48233","properties":{"name":"Hutchinson"}},{"type":"Polygon","arcs":[[-258,422,423,424]],"id":"48235","properties":{"name":"Irion"}},{"type":"Polygon","arcs":[[425,426,427,428,429,430]],"id":"55137","properties":{"name":"Waushara"}},{"type":"Polygon","arcs":[[431,432,433,434,435,436,437]],"id":"47151","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[438,439,440,441,442]],"id":"55113","properties":{"name":"Sawyer"}},{"type":"Polygon","arcs":[[443,444,445,446,447]],"id":"26073","properties":{"name":"Isabella"}},{"type":"Polygon","arcs":[[448,449,450,451,452,453]],"id":"28131","properties":{"name":"Stone"}},{"type":"Polygon","arcs":[[454,455,-93,456,457,458]],"id":"28013","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[459,460,461,462,463]],"id":"31171","properties":{"name":"Thomas"}},{"type":"Polygon","arcs":[[464,465,466,467,468,469]],"id":"48335","properties":{"name":"Mitchell"}},{"type":"Polygon","arcs":[[470,471,472,473,474]],"id":"08057","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[475,476,477,478,479]],"id":"19089","properties":{"name":"Howard"}},{"type":"Polygon","arcs":[[480,481,482,483,-82]],"id":"26151","properties":{"name":"Sanilac"}},{"type":"Polygon","arcs":[[484,485,486,487,488,489,490]],"id":"18075","properties":{"name":"Jay"}},{"type":"Polygon","arcs":[[491,492,493,494,495]],"id":"38075","properties":{"name":"Renville"}},{"type":"Polygon","arcs":[[496,497,498,499,500]],"id":"41021","properties":{"name":"Gilliam"}},{"type":"Polygon","arcs":[[501,502,503,504,505]],"id":"29119","properties":{"name":"McDonald"}},{"type":"Polygon","arcs":[[506,507,508,509]],"id":"48501","properties":{"name":"Yoakum"}},{"type":"Polygon","arcs":[[510,511,512,-279,513]],"id":"48075","properties":{"name":"Childress"}},{"type":"Polygon","arcs":[[514,515,516,517]],"id":"13097","properties":{"name":"Douglas"}},{"type":"Polygon","arcs":[[518,519,520,521]],"id":"02158","properties":{"name":"Kusilvak"}},{"type":"Polygon","arcs":[[522,523,524,525,526]],"id":"19181","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[527,528,529,530,531,532]],"id":"40031","properties":{"name":"Comanche"}},{"type":"Polygon","arcs":[[533,534,535,536,537,538,539,540]],"id":"40009","properties":{"name":"Beckham"}},{"type":"Polygon","arcs":[[-274,541,542,543,544]],"id":"46017","properties":{"name":"Buffalo"}},{"type":"Polygon","arcs":[[545,546,547,548,549,550]],"id":"48171","properties":{"name":"Gillespie"}},{"type":"Polygon","arcs":[[551,552,553,554]],"id":"48125","properties":{"name":"Dickens"}},{"type":"Polygon","arcs":[[555,556,557,558,559]],"id":"48283","properties":{"name":"La Salle"}},{"type":"Polygon","arcs":[[560,561,562,563]],"id":"54093","properties":{"name":"Tucker"}},{"type":"Polygon","arcs":[[564,565,566,567,568,569,570,571,572,573,574,575]],"id":"06089","properties":{"name":"Shasta"}},{"type":"Polygon","arcs":[[576,577,578,579,580,581]],"id":"17165","properties":{"name":"Saline"}},{"type":"Polygon","arcs":[[582,583,584,585,586]],"id":"26101","properties":{"name":"Manistee"}},{"type":"Polygon","arcs":[[587,588,589,590,591]],"id":"31071","properties":{"name":"Garfield"}},{"type":"Polygon","arcs":[[592,593,-591,594,595,596,597,598,599]],"id":"31041","properties":{"name":"Custer"}},{"type":"Polygon","arcs":[[600,-270,601,602,603]],"id":"46097","properties":{"name":"Miner"}},{"type":"Polygon","arcs":[[604,605,606,607,608,609]],"id":"46025","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[610,611,612,613,614]],"id":"05037","properties":{"name":"Cross"}},{"type":"Polygon","arcs":[[615,616,617,-167,618,619,620]],"id":"08007","properties":{"name":"Archuleta"}},{"type":"Polygon","arcs":[[621,622,623,624]],"id":"12043","properties":{"name":"Glades"}},{"type":"Polygon","arcs":[[625,626,627,628,629]],"id":"46053","properties":{"name":"Gregory"}},{"type":"Polygon","arcs":[[630,631,632,-419,633]],"id":"48195","properties":{"name":"Hansford"}},{"type":"MultiPolygon","arcs":[[[634,635,636,637,638]],[[639,640,641]]],"id":"53053","properties":{"name":"Pierce"}},{"type":"Polygon","arcs":[[642,643,644,-216,645,646,647]],"id":"13077","properties":{"name":"Coweta"}},{"type":"Polygon","arcs":[[648,649,650,651]],"id":"13059","properties":{"name":"Clarke"}},{"type":"Polygon","arcs":[[652,653,654,655,656]],"id":"18081","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[657,658,659,660,661,662]],"id":"20115","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[663,664,665,666,667]],"id":"27059","properties":{"name":"Isanti"}},{"type":"Polygon","arcs":[[668,669,670,671,672,673]],"id":"31003","properties":{"name":"Antelope"}},{"type":"Polygon","arcs":[[674,675,676,677,678]],"id":"39103","properties":{"name":"Medina"}},{"type":"Polygon","arcs":[[679,680,681,682,683,684]],"id":"47153","properties":{"name":"Sequatchie"}},{"type":"Polygon","arcs":[[685,686,687,688]],"id":"48375","properties":{"name":"Potter"}},{"type":"Polygon","arcs":[[689,690,691,692,693]],"id":"48145","properties":{"name":"Falls"}},{"type":"Polygon","arcs":[[-399,694,695,696,697,698]],"id":"38039","properties":{"name":"Griggs"}},{"type":"Polygon","arcs":[[-125,699,700,701]],"id":"46043","properties":{"name":"Douglas"}},{"type":"Polygon","arcs":[[702,703,704,705,706,707]],"id":"48193","properties":{"name":"Hamilton"}},{"type":"Polygon","arcs":[[708,709,710,711,712]],"id":"19185","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[713,714,715,716,717,718,719]],"id":"38087","properties":{"name":"Slope"}},{"type":"Polygon","arcs":[[720,-412,721,722,-255,723]],"id":"48399","properties":{"name":"Runnels"}},{"type":"Polygon","arcs":[[6,-6,4,-4,724,725,726,727,728,-8]],"id":"04005","properties":{"name":"Coconino"}},{"type":"Polygon","arcs":[[729,730,731,732,733]],"id":"16009","properties":{"name":"Benewah"}},{"type":"Polygon","arcs":[[734,735,736,737,738,739,740]],"id":"20007","properties":{"name":"Barber"}},{"type":"Polygon","arcs":[[741,742,743,744,-102]],"id":"27133","properties":{"name":"Rock"}},{"type":"Polygon","arcs":[[745,-324,746,747]],"id":"23029","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[748,749,750,751,752]],"id":"30051","properties":{"name":"Liberty"}},{"type":"Polygon","arcs":[[753,754,755,756]],"id":"46091","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[757,758,-364,759,760]],"id":"36117","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[761,762]],"id":"02060","properties":{"name":"Bristol Bay"}},{"type":"Polygon","arcs":[[763,764,765,766,767]],"id":"12027","properties":{"name":"DeSoto"}},{"type":"Polygon","arcs":[[768,769,770,771,772,773]],"id":"13015","properties":{"name":"Bartow"}},{"type":"Polygon","arcs":[[774,775,776,777,778]],"id":"19127","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[779,780,781,782,783,784]],"id":"20047","properties":{"name":"Edwards"}},{"type":"Polygon","arcs":[[785,786,787,788,789]],"id":"26129","properties":{"name":"Ogemaw"}},{"type":"Polygon","arcs":[[790,-237,791,792,793,794]],"id":"31093","properties":{"name":"Howard"}},{"type":"Polygon","arcs":[[795,796,797,798,799,800]],"id":"39063","properties":{"name":"Hancock"}},{"type":"Polygon","arcs":[[801,802,803,804,805,806,807]],"id":"21209","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[808,809,810,811,-682]],"id":"47007","properties":{"name":"Bledsoe"}},{"type":"Polygon","arcs":[[812,813,814,815,816,817]],"id":"37157","properties":{"name":"Rockingham"}},{"type":"Polygon","arcs":[[818,819,820,821,822]],"id":"48189","properties":{"name":"Hale"}},{"type":"Polygon","arcs":[[823]],"id":"51820","properties":{"name":"Waynesboro"}},{"type":"Polygon","arcs":[[824,825,826,827,828]],"id":"56025","properties":{"name":"Natrona"}},{"type":"Polygon","arcs":[[-114,829,830,831,832]],"id":"48407","properties":{"name":"San Jacinto"}},{"type":"Polygon","arcs":[[833,834,835,-427,836]],"id":"55135","properties":{"name":"Waupaca"}},{"type":"Polygon","arcs":[[837,838,839,840,841]],"id":"39067","properties":{"name":"Harrison"}},{"type":"Polygon","arcs":[[842,843,844,845,846,847,848]],"id":"13087","properties":{"name":"Decatur"}},{"type":"Polygon","arcs":[[849,850,851,852,853]],"id":"22001","properties":{"name":"Acadia"}},{"type":"Polygon","arcs":[[854,855,856,857,858]],"id":"27019","properties":{"name":"Carver"}},{"type":"Polygon","arcs":[[859,860,861,862,-578,863]],"id":"17065","properties":{"name":"Hamilton"}},{"type":"Polygon","arcs":[[864,865,-351,866,867,868]],"id":"27067","properties":{"name":"Kandiyohi"}},{"type":"Polygon","arcs":[[869,870,871,872,873]],"id":"55071","properties":{"name":"Manitowoc"}},{"type":"Polygon","arcs":[[874,875,876,877,878,879]],"id":"01013","properties":{"name":"Butler"}},{"type":"Polygon","arcs":[[880,881,882,883,884,885,886]],"id":"13169","properties":{"name":"Jones"}},{"type":"Polygon","arcs":[[887,888,889,890]],"id":"19069","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[891,892,893,894,895,896]],"id":"18113","properties":{"name":"Noble"}},{"type":"Polygon","arcs":[[897,898,899,900,901,902]],"id":"20193","properties":{"name":"Thomas"}},{"type":"Polygon","arcs":[[903,904,905,-444,906]],"id":"26035","properties":{"name":"Clare"}},{"type":"Polygon","arcs":[[907,908,909,910]],"id":"26039","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[911,912,913,914,915,916]],"id":"29225","properties":{"name":"Webster"}},{"type":"Polygon","arcs":[[917,918,919,920,921]],"id":"31005","properties":{"name":"Arthur"}},{"type":"Polygon","arcs":[[922,923,924,925,926]],"id":"31143","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[927,928,929,930,-606]],"id":"46029","properties":{"name":"Codington"}},{"type":"Polygon","arcs":[[931,932,933,-128,934,935]],"id":"48131","properties":{"name":"Duval"}},{"type":"Polygon","arcs":[[936,-422,937,-686,938,939]],"id":"48341","properties":{"name":"Moore"}},{"type":"Polygon","arcs":[[940,941,942,943,944,945]],"id":"48317","properties":{"name":"Martin"}},{"type":"Polygon","arcs":[[946,947,948,949,950,951,952]],"id":"39083","properties":{"name":"Knox"}},{"type":"Polygon","arcs":[[953,954,955,956,957]],"id":"72073","properties":{"name":"Jayuya"}},{"type":"Polygon","arcs":[[958,959,960,961,962,-691,963]],"id":"48293","properties":{"name":"Limestone"}},{"type":"Polygon","arcs":[[964,965,966,967,968]],"id":"19055","properties":{"name":"Delaware"}},{"type":"Polygon","arcs":[[969,970,971,972]],"id":"31159","properties":{"name":"Seward"}},{"type":"Polygon","arcs":[[973,974,975,976]],"id":"48507","properties":{"name":"Zavala"}},{"type":"Polygon","arcs":[[977,978,979,980,981,982,983,984,985]],"id":"06091","properties":{"name":"Sierra"}},{"type":"Polygon","arcs":[[986,987,988,989,990]],"id":"17201","properties":{"name":"Winnebago"}},{"type":"Polygon","arcs":[[991,992,993,994,995,996]],"id":"23031","properties":{"name":"York"}},{"type":"Polygon","arcs":[[997,998,999,1000,1001]],"id":"24011","properties":{"name":"Caroline"}},{"type":"Polygon","arcs":[[1002,1003,1004,1005,1006]],"id":"26119","properties":{"name":"Montmorency"}},{"type":"Polygon","arcs":[[-38,1007,1008,1009,1010,1011,1012]],"id":"38077","properties":{"name":"Richland"}},{"type":"Polygon","arcs":[[1013,1014,1015,1016,1017,1018]],"id":"42007","properties":{"name":"Beaver"}},{"type":"Polygon","arcs":[[1019,1020,1021,-246,-507]],"id":"48079","properties":{"name":"Cochran"}},{"type":"Polygon","arcs":[[1022,-789,1023,1024,1025,-906]],"id":"26051","properties":{"name":"Gladwin"}},{"type":"Polygon","arcs":[[1026,1027,1028,1029,1030,1031,1032]],"id":"08121","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[1033,-969,1034,1035,-224]],"id":"19019","properties":{"name":"Buchanan"}},{"type":"Polygon","arcs":[[1036,1037,1038,1039,1040,1041,1042]],"id":"19187","properties":{"name":"Webster"}},{"type":"Polygon","arcs":[[1043,-785,1044,1045,1046,1047]],"id":"20057","properties":{"name":"Ford"}},{"type":"Polygon","arcs":[[-1006,1048,-786,-909]],"id":"26135","properties":{"name":"Oscoda"}},{"type":"Polygon","arcs":[[1049,1050,1051,1052]],"id":"28099","properties":{"name":"Neshoba"}},{"type":"Polygon","arcs":[[1053,1054,1055,1056,1057,1058]],"id":"31137","properties":{"name":"Phelps"}},{"type":"Polygon","arcs":[[1059,1060,1061,1062,1063,1064]],"id":"31039","properties":{"name":"Cuming"}},{"type":"Polygon","arcs":[[1065,1066,1067,1068,1069,1070,1071]],"id":"45045","properties":{"name":"Greenville"}},{"type":"Polygon","arcs":[[1072,1073,1074,1075,1076]],"id":"48151","properties":{"name":"Fisher"}},{"type":"Polygon","arcs":[[1077,1078,1079,1080,1081]],"id":"37069","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[1082,1083,1084,1085,1086,1087]],"id":"39039","properties":{"name":"Defiance"}},{"type":"Polygon","arcs":[[1088,1089,1090,1091,1092,1093]],"id":"47055","properties":{"name":"Giles"}},{"type":"Polygon","arcs":[[1094,1095,1096,1097,1098]],"id":"48023","properties":{"name":"Baylor"}},{"type":"Polygon","arcs":[[1099,1100,1101,1102,1103]],"id":"48365","properties":{"name":"Panola"}},{"type":"Polygon","arcs":[[1104,1105,1106,1107]],"id":"53001","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[-1040,1108,1109,1110,1111,1112]],"id":"19015","properties":{"name":"Boone"}},{"type":"Polygon","arcs":[[1113,1114,1115,-265,1116,1117,1118]],"id":"48237","properties":{"name":"Jack"}},{"type":"Polygon","arcs":[[1119,1120,1121,1122,1123]],"id":"72009","properties":{"name":"Aibonito"}},{"type":"Polygon","arcs":[[1124,1125,-370,1126,-660]],"id":"20017","properties":{"name":"Chase"}},{"type":"Polygon","arcs":[[-706,1127,1128,1129,1130]],"id":"48099","properties":{"name":"Coryell"}},{"type":"Polygon","arcs":[[1131,1132,1133,1134,1135]],"id":"26037","properties":{"name":"Clinton"}},{"type":"Polygon","arcs":[[1136,1137,1138,-373]],"id":"20207","properties":{"name":"Woodson"}},{"type":"Polygon","arcs":[[1139,1140,1141,1142,1143,1144,1145]],"id":"17037","properties":{"name":"DeKalb"}},{"type":"Polygon","arcs":[[1146,1147,1148,1149,1150]],"id":"19159","properties":{"name":"Ringgold"}},{"type":"Polygon","arcs":[[1151,1152,1153,1154,1155]],"id":"19165","properties":{"name":"Shelby"}},{"type":"Polygon","arcs":[[1156,1157,1158,1159,1160,1161,-212,1162]],"id":"06019","properties":{"name":"Fresno"}},{"type":"Polygon","arcs":[[1163,1164,1165,-1147,1166]],"id":"19175","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[1167,1168,1169,1170,1171,1172]],"id":"17123","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[1173,1174,1175,1176,1177,1178]],"id":"17147","properties":{"name":"Piatt"}},{"type":"Polygon","arcs":[[1179,1180,-1167,1181,1182]],"id":"19003","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[1183,1184,1185,1186,1187,1188,1189]],"id":"17159","properties":{"name":"Richland"}},{"type":"Polygon","arcs":[[1190,1191,1192,1193,1194]],"id":"47023","properties":{"name":"Chester"}},{"type":"Polygon","arcs":[[1195,1196,1197,1198,1199]],"id":"26023","properties":{"name":"Branch"}},{"type":"Polygon","arcs":[[1200,1201,1202,1203,1204,1205]],"id":"37151","properties":{"name":"Randolph"}},{"type":"Polygon","arcs":[[1206,1207,1208,1209,1210,1211]],"id":"20199","properties":{"name":"Wallace"}},{"type":"Polygon","arcs":[[1212,1213,1214,1215,1216,1217]],"id":"18177","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[1218]],"id":"51595","properties":{"name":"Emporia"}},{"type":"Polygon","arcs":[[1219,1220,1221,1222,1223]],"id":"48295","properties":{"name":"Lipscomb"}},{"type":"Polygon","arcs":[[1224,1225,1226,1227]],"id":"47169","properties":{"name":"Trousdale"}},{"type":"Polygon","arcs":[[1228,1229,1230,1231,1232,1233,1234,1235,1236,-726,1237]],"id":"49037","properties":{"name":"San Juan"}},{"type":"Polygon","arcs":[[1238,1239,1240,-287,1241,1242]],"id":"19123","properties":{"name":"Mahaska"}},{"type":"Polygon","arcs":[[1243,1244,1245,1246]],"id":"16021","properties":{"name":"Boundary"}},{"type":"Polygon","arcs":[[1247,1248,1249,1250,1251,1252,1253]],"id":"17107","properties":{"name":"Logan"}},{"type":"Polygon","arcs":[[1254,1255,1256,1257,1258]],"id":"20059","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[1259,1260,1261,1262,1263,1264,1265,1266]],"id":"22013","properties":{"name":"Bienville"}},{"type":"Polygon","arcs":[[1267,1268,1269,1270,1271]],"id":"06005","properties":{"name":"Amador"}},{"type":"Polygon","arcs":[[1272,1273,-1268,1274,1275]],"id":"06017","properties":{"name":"El Dorado"}},{"type":"Polygon","arcs":[[1276,1277,1278,1279,1280]],"id":"05065","properties":{"name":"Izard"}},{"type":"Polygon","arcs":[[1281]],"id":"51530","properties":{"name":"Buena Vista"}},{"type":"Polygon","arcs":[[1282,1283]],"id":"51590","properties":{"name":"Danville"}},{"type":"Polygon","arcs":[[1284,1285]],"id":"51640","properties":{"name":"Galax"}},{"type":"Polygon","arcs":[[1286]],"id":"51660","properties":{"name":"Harrisonburg"}},{"type":"Polygon","arcs":[[1287]],"id":"51690","properties":{"name":"Martinsville"}},{"type":"Polygon","arcs":[[1288,1289,1290,1291,1292,1293]],"id":"18049","properties":{"name":"Fulton"}},{"type":"Polygon","arcs":[[1294,1295,-1164,-1181,1296]],"id":"19001","properties":{"name":"Adair"}},{"type":"Polygon","arcs":[[1297,-215,213,-213,-1162,1298,1299,1300]],"id":"06053","properties":{"name":"Monterey"}},{"type":"Polygon","arcs":[[1301,1302,1303,1304,1305]],"id":"29219","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[1306,1307,1308,1309,1310]],"id":"37197","properties":{"name":"Yadkin"}},{"type":"Polygon","arcs":[[-446,1311,1312,1313,-1132,1314]],"id":"26057","properties":{"name":"Gratiot"}},{"type":"Polygon","arcs":[[1315,1316,1317,1318,1319,1320]],"id":"21129","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[1321,1322,1323,1324,1325,1326]],"id":"20133","properties":{"name":"Neosho"}},{"type":"Polygon","arcs":[[1327,-1136,1328,1329,1330]],"id":"26067","properties":{"name":"Ionia"}},{"type":"Polygon","arcs":[[1331,1332,1333,1334,1335]],"id":"26077","properties":{"name":"Kalamazoo"}},{"type":"Polygon","arcs":[[1336,1337,1338,1339,1340,1341]],"id":"21149","properties":{"name":"McLean"}},{"type":"Polygon","arcs":[[1342,1343,1344,1345,1346,1347]],"id":"27033","properties":{"name":"Cottonwood"}},{"type":"Polygon","arcs":[[-585,1348,1349,-382,1350]],"id":"26085","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[-586,-1351,1351,1352]],"id":"26105","properties":{"name":"Mason"}},{"type":"Polygon","arcs":[[1353,-448,1354,-383]],"id":"26107","properties":{"name":"Mecosta"}},{"type":"Polygon","arcs":[[1355,-386,1356,1357,1358]],"id":"26121","properties":{"name":"Muskegon"}},{"type":"Polygon","arcs":[[1359,1360,1361,1362,1363,1364]],"id":"27047","properties":{"name":"Freeborn"}},{"type":"Polygon","arcs":[[1365,1366,1367,1368,1369,1370,1371]],"id":"17051","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[1372,1373,1374,1375,-1368]],"id":"17049","properties":{"name":"Effingham"}},{"type":"Polygon","arcs":[[1376,1377,1378,1379]],"id":"27009","properties":{"name":"Benton"}},{"type":"Polygon","arcs":[[1380,1381,1382,1383,-415]],"id":"48129","properties":{"name":"Donley"}},{"type":"Polygon","arcs":[[1384,1385,1386,1387,1388]],"id":"27041","properties":{"name":"Douglas"}},{"type":"Polygon","arcs":[[1389,1390,1391,1392,-404]],"id":"40073","properties":{"name":"Kingfisher"}},{"type":"Polygon","arcs":[[1393,1394,1395,1396,1397,1398]],"id":"47053","properties":{"name":"Gibson"}},{"type":"Polygon","arcs":[[1399,1400,1401,1402,1403,1404,1405]],"id":"47005","properties":{"name":"Benton"}},{"type":"Polygon","arcs":[[1406,1407,1408,1409]],"id":"45009","properties":{"name":"Bamberg"}},{"type":"Polygon","arcs":[[1410,1411,1412,1413,1414,-557,1415,1416]],"id":"48013","properties":{"name":"Atascosa"}},{"type":"Polygon","arcs":[[1417,1418,1419,-111,1420,1421,1422,-701]],"id":"46067","properties":{"name":"Hutchinson"}},{"type":"Polygon","arcs":[[1423,1424,1425,1426,-41,1427]],"id":"46019","properties":{"name":"Butte"}},{"type":"MultiPolygon","arcs":[[[1428,1429,1430,1431]],[[1432,1433]],[[1434]],[[1435,1436]],[[1437]],[[1438]],[[1439]],[[1440]],[[1441,1442]],[[1443,1444,1445,1446]]],"id":"02105","properties":{"name":"Hoonah-Angoon"}},{"type":"Polygon","arcs":[[1447,1448,1449,1450,-542,-273]],"id":"46059","properties":{"name":"Hand"}},{"type":"Polygon","arcs":[[-608,1451,1452,-266,-601,1453,1454]],"id":"46077","properties":{"name":"Kingsbury"}},{"type":"Polygon","arcs":[[1455,1456,1457,1458,1459]],"id":"47101","properties":{"name":"Lewis"}},{"type":"Polygon","arcs":[[1460,1461,1462,1463,1464]],"id":"55069","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[1465,-1397,1466,1467,-1191,1468,1469]],"id":"47113","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[1470]],"id":"51540","properties":{"name":"Charlottesville"}},{"type":"Polygon","arcs":[[1471,1472,1473,1474,1475,1476]],"id":"30037","properties":{"name":"Golden Valley"}},{"type":"Polygon","arcs":[[1477,1478,1479,1480,1481,1482,1483,-827]],"id":"56009","properties":{"name":"Converse"}},{"type":"Polygon","arcs":[[1484,1485,1486,1487,1488]],"id":"47179","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[1489,1490,-1465,1491,1492,1493]],"id":"55119","properties":{"name":"Taylor"}},{"type":"Polygon","arcs":[[1494,1495,1496,1497,1498,1499,1500,1501,1502,-1502,1501,1503,1504]],"id":"56029","properties":{"name":"Park"}},{"type":"Polygon","arcs":[[1505,1506,-1348,1507,-743,1508]],"id":"27101","properties":{"name":"Murray"}},{"type":"Polygon","arcs":[[1509,1510,1511,1512,1513,1514]],"id":"55133","properties":{"name":"Waukesha"}},{"type":"Polygon","arcs":[[1515,1516,-1509,-742,1517]],"id":"27117","properties":{"name":"Pipestone"}},{"type":"Polygon","arcs":[[1518,1519,1520,1521,1522]],"id":"51099","properties":{"name":"King George"}},{"type":"Polygon","arcs":[[1523,1524,1525,1526,1527,1528,1529]],"id":"30001","properties":{"name":"Beaverhead"}},{"type":"Polygon","arcs":[[1530,1531,-1472,1532,1533]],"id":"30107","properties":{"name":"Wheatland"}},{"type":"Polygon","arcs":[[1534,-916,1535,1536,1537,1538]],"id":"29043","properties":{"name":"Christian"}},{"type":"Polygon","arcs":[[1539,1540,1541,1542,1543,1544]],"id":"29053","properties":{"name":"Cooper"}},{"type":"Polygon","arcs":[[1545,1546,1547,1548,1549,1550]],"id":"20029","properties":{"name":"Cloud"}},{"type":"Polygon","arcs":[[1551,1552,1553,1554,1555]],"id":"51159","properties":{"name":"Richmond"}},{"type":"Polygon","arcs":[[1556,-1398,-1466,1557,1558]],"id":"47033","properties":{"name":"Crockett"}},{"type":"Polygon","arcs":[[1559,1560,1561,1562,1563]],"id":"18063","properties":{"name":"Hendricks"}},{"type":"Polygon","arcs":[[1564,1565,1566,1567,1568,1569,1570,-378]],"id":"20135","properties":{"name":"Ness"}},{"type":"Polygon","arcs":[[1571,1572,1573,1574,-1143]],"id":"17093","properties":{"name":"Kendall"}},{"type":"Polygon","arcs":[[1575,1576,1577,1578,1579]],"id":"18149","properties":{"name":"Starke"}},{"type":"Polygon","arcs":[[1580,1581,1582,1583,1584,-654]],"id":"18145","properties":{"name":"Shelby"}},{"type":"Polygon","arcs":[[1585,1586,1587,1588,-913,1589]],"id":"29105","properties":{"name":"Laclede"}},{"type":"Polygon","arcs":[[1590,1591,1592,1593,1594,1595]],"id":"29117","properties":{"name":"Livingston"}},{"type":"Polygon","arcs":[[1596,1597,-1007,-908,1598]],"id":"26137","properties":{"name":"Otsego"}},{"type":"Polygon","arcs":[[1599,1600,1601,1602,1603]],"id":"31087","properties":{"name":"Hitchcock"}},{"type":"Polygon","arcs":[[-910,-790,-1023,-905,1604]],"id":"26143","properties":{"name":"Roscommon"}},{"type":"Polygon","arcs":[[1605,1606,1607,1608,1609]],"id":"29011","properties":{"name":"Barton"}},{"type":"Polygon","arcs":[[-416,-1384,1610,1611,1612,1613]],"id":"48045","properties":{"name":"Briscoe"}},{"type":"Polygon","arcs":[[1614,1615,1616,1617,1618,1619]],"id":"26161","properties":{"name":"Washtenaw"}},{"type":"Polygon","arcs":[[1620,-1330,1621,1622,-1333,1623]],"id":"26015","properties":{"name":"Barry"}},{"type":"Polygon","arcs":[[1624,1625,1626,1627,1628]],"id":"35029","properties":{"name":"Luna"}},{"type":"Polygon","arcs":[[1629,1630,1631,1632,1633,1634,1635]],"id":"51169","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[1636,1637,1638,1639,1640]],"id":"33007","properties":{"name":"Coos"}},{"type":"Polygon","arcs":[[1641,1642,1643,1644,1645,1646]],"id":"38095","properties":{"name":"Towner"}},{"type":"Polygon","arcs":[[1647,1648,1649,1650,-502,1651]],"id":"29145","properties":{"name":"Newton"}},{"type":"MultiPolygon","arcs":[[[1652,1653]],[[-1431,1654,-55,1655]]],"id":"02195","properties":{"name":"Petersburg"}},{"type":"Polygon","arcs":[[1656,-1065,1657,1658,1659]],"id":"31167","properties":{"name":"Stanton"}},{"type":"Polygon","arcs":[[1660,1661,1662,-1060,-1657,1663]],"id":"31179","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[1664,1665,1666,1667,-205,203,-203]],"id":"26109","properties":{"name":"Menominee"}},{"type":"Polygon","arcs":[[1668,1669,1670,1671,1672]],"id":"48175","properties":{"name":"Goliad"}},{"type":"Polygon","arcs":[[1673,-39,-1013,1674,-343,1675]],"id":"38073","properties":{"name":"Ransom"}},{"type":"Polygon","arcs":[[1676,1677,-1381,1678]],"id":"48179","properties":{"name":"Gray"}},{"type":"Polygon","arcs":[[1679,1680,1681,1682,1683,1684]],"id":"42121","properties":{"name":"Venango"}},{"type":"Polygon","arcs":[[-1383,1685,-514,-278,1686,-1611]],"id":"48191","properties":{"name":"Hall"}},{"type":"Polygon","arcs":[[1687,-1538,1688,1689,1690]],"id":"29209","properties":{"name":"Stone"}},{"type":"Polygon","arcs":[[1691,1692,1693,1694,1695,1696]],"id":"39057","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[1697,1698,-1596,1699,1700,1701]],"id":"29061","properties":{"name":"Daviess"}},{"type":"Polygon","arcs":[[1702,1703,1704,1705,1706,1707]],"id":"29199","properties":{"name":"Scotland"}},{"type":"Polygon","arcs":[[1708,1709,1710,1711,1712,1713,1714]],"id":"48049","properties":{"name":"Brown"}},{"type":"Polygon","arcs":[[-509,1715,1716,-941,1717,1718]],"id":"48165","properties":{"name":"Gaines"}},{"type":"Polygon","arcs":[[-1130,1719,-694,1720,1721,1722,1723]],"id":"48027","properties":{"name":"Bell"}},{"type":"Polygon","arcs":[[1724,-1247,1725,1726,1727]],"id":"53051","properties":{"name":"Pend Oreille"}},{"type":"Polygon","arcs":[[1728,1729,1730,1731,1732,1733]],"id":"13277","properties":{"name":"Tift"}},{"type":"Polygon","arcs":[[1734,1735,1736,1737,1738]],"id":"48435","properties":{"name":"Sutton"}},{"type":"Polygon","arcs":[[1739,1740,1741,1742,1743]],"id":"51023","properties":{"name":"Botetourt"}},{"type":"Polygon","arcs":[[1744,1745,1746,1747,1748]],"id":"48405","properties":{"name":"San Augustine"}},{"type":"Polygon","arcs":[[-139,1749,1750,1751,1752,1753,1754]],"id":"72129","properties":{"name":"San Lorenzo"}},{"type":"Polygon","arcs":[[1755,1756,1757,1758,-149,1759]],"id":"72143","properties":{"name":"Vega Alta"}},{"type":"Polygon","arcs":[[1760,1761,1762,1763]],"id":"27017","properties":{"name":"Carlton"}},{"type":"Polygon","arcs":[[1764,1765,1766,1767,1768]],"id":"12029","properties":{"name":"Dixie"}},{"type":"Polygon","arcs":[[1769,1770,1771,1772,1773,1774]],"id":"13211","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[1775,1776,1777,1778]],"id":"02188","properties":{"name":"Northwest Arctic"}},{"type":"Polygon","arcs":[[1779,1780,1781,-715,1782]],"id":"38007","properties":{"name":"Billings"}},{"type":"Polygon","arcs":[[1783,1784,1785,-1764,1786,1787,1788,1789]],"id":"27001","properties":{"name":"Aitkin"}},{"type":"Polygon","arcs":[[1790,1791,1792,1793,1794,1795,1796]],"id":"08045","properties":{"name":"Garfield"}},{"type":"Polygon","arcs":[[-1257,1797,1798,1799]],"id":"20003","properties":{"name":"Anderson"}},{"type":"Polygon","arcs":[[-282,1800,1801,1802,-553]],"id":"48269","properties":{"name":"King"}},{"type":"Polygon","arcs":[[1803,-407,1804,1805,-535,1806]],"id":"40039","properties":{"name":"Custer"}},{"type":"Polygon","arcs":[[1807,-98,1808,1809,1810,1811]],"id":"39101","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[1812,1813,1814,1815,1816,1817]],"id":"17095","properties":{"name":"Knox"}},{"type":"Polygon","arcs":[[1818,1819,1820,1821]],"id":"13013","properties":{"name":"Barrow"}},{"type":"Polygon","arcs":[[-1144,-1575,1822,1823,1824,-1170,1825,1826,1827]],"id":"17099","properties":{"name":"LaSalle"}},{"type":"Polygon","arcs":[[1828,1829,1830,1831,1832]],"id":"01031","properties":{"name":"Coffee"}},{"type":"Polygon","arcs":[[1833,1834,1835,1836]],"id":"12085","properties":{"name":"Martin"}},{"type":"Polygon","arcs":[[1837,1838,1839,-1109,-1039]],"id":"19079","properties":{"name":"Hamilton"}},{"type":"Polygon","arcs":[[-890,1840,-775,1841,-1839]],"id":"19083","properties":{"name":"Hardin"}},{"type":"Polygon","arcs":[[1842,1843,1844,1845,1846,1847]],"id":"16037","properties":{"name":"Custer"}},{"type":"Polygon","arcs":[[1848,1849,1850,1851,1852,1853]],"id":"13037","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[1854,1855,1856,1857]],"id":"19093","properties":{"name":"Ida"}},{"type":"Polygon","arcs":[[1858,1859,-162,-618,1860]],"id":"08105","properties":{"name":"Rio Grande"}},{"type":"Polygon","arcs":[[1861,-1243,1862,1863,-524,1864]],"id":"19125","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[1865,-1028,1866,1867]],"id":"08087","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[1868,1869,1870,-1240,1871]],"id":"19157","properties":{"name":"Poweshiek"}},{"type":"Polygon","arcs":[[1872,1873,1874,-1248,1875,1876]],"id":"17179","properties":{"name":"Tazewell"}},{"type":"Polygon","arcs":[[1877,1878,1879,1880]],"id":"08039","properties":{"name":"Elbert"}},{"type":"Polygon","arcs":[[-1111,1881,1882,-1865,-523,1883]],"id":"19153","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[1884,1885,1886,1887,1888]],"id":"39149","properties":{"name":"Shelby"}},{"type":"Polygon","arcs":[[1889,-527,1890,-1165,-1296]],"id":"19121","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[1891,1892,1893,1894,-677]],"id":"39153","properties":{"name":"Summit"}},{"type":"Polygon","arcs":[[1895,1896,-765,1897]],"id":"12049","properties":{"name":"Hardee"}},{"type":"Polygon","arcs":[[1898,1899,1900,1901,1902,1903,1904]],"id":"39161","properties":{"name":"Van Wert"}},{"type":"Polygon","arcs":[[1905,-1696,1906,1907,1908,1909]],"id":"39165","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[1910,1911,1912,1913,-974,1914]],"id":"48463","properties":{"name":"Uvalde"}},{"type":"Polygon","arcs":[[1915,1916,1917,1918,1919,-650,1920]],"id":"13195","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[1921,1922,-842,1923,1924,1925]],"id":"39059","properties":{"name":"Guernsey"}},{"type":"Polygon","arcs":[[1926,1927,1928,1929,-1412]],"id":"48493","properties":{"name":"Wilson"}},{"type":"Polygon","arcs":[[-1810,1930,-953,1931,1932,1933]],"id":"39041","properties":{"name":"Delaware"}},{"type":"Polygon","arcs":[[1934,1935,1936,1937,1938]],"id":"39055","properties":{"name":"Geauga"}},{"type":"Polygon","arcs":[[-538,1939,1940,1941]],"id":"40055","properties":{"name":"Greer"}},{"type":"Polygon","arcs":[[1942,1943,1944,1945,1946,1947,1948]],"id":"27131","properties":{"name":"Rice"}},{"type":"Polygon","arcs":[[1949,1950,1951,1952,1953,1954,1955]],"id":"05025","properties":{"name":"Cleveland"}},{"type":"Polygon","arcs":[[1956,1957,1958,1959,1960,-196]],"id":"13093","properties":{"name":"Dooly"}},{"type":"Polygon","arcs":[[-423,-257,1961,-1735,1962]],"id":"48413","properties":{"name":"Schleicher"}},{"type":"Polygon","arcs":[[1963,1964,1965,1966,-1345]],"id":"27165","properties":{"name":"Watonwan"}},{"type":"Polygon","arcs":[[1967,1968,1969,-391,1970,1971]],"id":"31001","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[1972,1973,1974,1975]],"id":"37003","properties":{"name":"Alexander"}},{"type":"Polygon","arcs":[[1976,-312,1977,1978,-1607]],"id":"29039","properties":{"name":"Cedar"}},{"type":"Polygon","arcs":[[1979,-417,-1614,1980,-820,1981]],"id":"48437","properties":{"name":"Swisher"}},{"type":"Polygon","arcs":[[1982,1983,1984,1985,1986,1987,1988]],"id":"30049","properties":{"name":"Lewis and Clark"}},{"type":"Polygon","arcs":[[1989,1990,1991,-1545,1992,1993,1994]],"id":"29159","properties":{"name":"Pettis"}},{"type":"Polygon","arcs":[[-1612,-1687,-283,-552,1995]],"id":"48345","properties":{"name":"Motley"}},{"type":"Polygon","arcs":[[1996,1997,1998,-1524,1999,2000]],"id":"30081","properties":{"name":"Ravalli"}},{"type":"Polygon","arcs":[[2001,2002,2003,-11,2004,2005,2006,2007]],"id":"06071","properties":{"name":"San Bernardino"}},{"type":"Polygon","arcs":[[2008,2009,2010,2011,2012,2013]],"id":"13189","properties":{"name":"McDuffie"}},{"type":"MultiPolygon","arcs":[[[2014]],[[2015,2016,2017,2018,-1446,2019],[-1439]]],"id":"02100","properties":{"name":"Haines"}},{"type":"Polygon","arcs":[[-1492,-1464,2020,2021,2022,2023,2024]],"id":"55073","properties":{"name":"Marathon"}},{"type":"MultiPolygon","arcs":[[[2025]],[[2026]],[[2027]],[[2028]],[[2029]],[[2030]],[[2031]],[[2032]],[[2033]],[[2034]],[[2035]],[[2036]],[[2037]],[[2038]],[[2039]],[[2040]],[[2041]],[[2042,2043]],[[2044]],[[2045]],[[2046]],[[2047]],[[2048]],[[2049]]],"id":"02013","properties":{"name":"Aleutians East"}},{"type":"MultiPolygon","arcs":[[[2050]],[[2051]],[[2052]],[[2053]],[[2054]],[[2055]],[[2056]],[[2057]],[[2058]],[[2059]],[[2060,2061,2062]],[[2063]]],"id":"02150","properties":{"name":"Kodiak Island"}},{"type":"MultiPolygon","arcs":[[[2064]],[[2065]],[[2066]],[[2067]],[[2068]],[[2069,-762,2070,2071,2072,2073,-2063,2074,-2043]]],"id":"02164","properties":{"name":"Lake and Peninsula"}},{"type":"MultiPolygon","arcs":[[[2075]],[[2076]],[[2077]],[[2078]],[[2079]],[[2080]],[[2081]],[[2082]],[[2083,2084,2085,2086,2087,2088,2089]]],"id":"02261","properties":{"name":"Valdez-Cordova"}},{"type":"Polygon","arcs":[[2090,2091,-1418,-700,-124]],"id":"46035","properties":{"name":"Davison"}},{"type":"Polygon","arcs":[[2092,2093,2094,2095,2096,2097,2098,2099]],"id":"41023","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[2100,2101,2102,2103,2104,2105]],"id":"39129","properties":{"name":"Pickaway"}},{"type":"Polygon","arcs":[[-1938,2106,2107,2108,-1893]],"id":"39133","properties":{"name":"Portage"}},{"type":"Polygon","arcs":[[2109,2110,2111,2112,-847]],"id":"13131","properties":{"name":"Grady"}},{"type":"Polygon","arcs":[[2113,2114,2115,2116,2117,2118]],"id":"72093","properties":{"name":"Maricao"}},{"type":"Polygon","arcs":[[2119,2120,2121,2122,2123,2124]],"id":"54075","properties":{"name":"Pocahontas"}},{"type":"Polygon","arcs":[[2125,2126,2127]],"id":"72117","properties":{"name":"RincÃ³n"}},{"type":"Polygon","arcs":[[2128,2129,2130,2131,-1385,2132,2133]],"id":"27111","properties":{"name":"Otter Tail"}},{"type":"Polygon","arcs":[[2134,2135,2136,2137,2138,2139,2140]],"id":"13111","properties":{"name":"Fannin"}},{"type":"Polygon","arcs":[[2141,2142,2143,-28,-233,-26]],"id":"27113","properties":{"name":"Pennington"}},{"type":"Polygon","arcs":[[2144,2145,2146,2147]],"id":"17021","properties":{"name":"Christian"}},{"type":"Polygon","arcs":[[2148,2149,2150,2151,2152,-1291]],"id":"18169","properties":{"name":"Wabash"}},{"type":"Polygon","arcs":[[2153,2154,2155,2156,2157,-1232]],"id":"08085","properties":{"name":"Montrose"}},{"type":"Polygon","arcs":[[2158,2159,2160,-14,2161]],"id":"28113","properties":{"name":"Pike"}},{"type":"Polygon","arcs":[[-495,2162,2163,2164,2165,2166]],"id":"38049","properties":{"name":"McHenry"}},{"type":"Polygon","arcs":[[2167,2168,2169,2170,-1704,2171]],"id":"19177","properties":{"name":"Van Buren"}},{"type":"Polygon","arcs":[[2172,2173,2174]],"id":"17171","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[2175,-886,2176,2177,2178]],"id":"13021","properties":{"name":"Bibb"}},{"type":"Polygon","arcs":[[2179,-140,-1755,2180,2181,2182,-1122]],"id":"72035","properties":{"name":"Cayey"}},{"type":"Polygon","arcs":[[-1026,2183,2184,-1312,-445]],"id":"26111","properties":{"name":"Midland"}},{"type":"Polygon","arcs":[[2185,2186,2187,2188,-1567,2189]],"id":"20051","properties":{"name":"Ellis"}},{"type":"Polygon","arcs":[[2190,2191,2192,-2163,-494]],"id":"38009","properties":{"name":"Bottineau"}},{"type":"MultiPolygon","arcs":[[[2193]],[[2194]]],"id":"60020","properties":{"name":"Manu'a"}},{"type":"Polygon","arcs":[[2195,2196]],"id":"60050","properties":{"name":"Western"}},{"type":"Polygon","arcs":[[-894,2197,-1087,2198,-1905,2199,2200,2201,2202]],"id":"18003","properties":{"name":"Allen"}},{"type":"Polygon","arcs":[[2203,2204,2205,2206,2207,2208]],"id":"20085","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[2209,2210,2211,2212,2213,-2169]],"id":"19087","properties":{"name":"Henry"}},{"type":"Polygon","arcs":[[2214,2215,2216,-1560,2217]],"id":"18011","properties":{"name":"Boone"}},{"type":"Polygon","arcs":[[573,-573,571,-571,569,-569,2218,2219,2220,2221,2222,-575]],"id":"06103","properties":{"name":"Tehama"}},{"type":"Polygon","arcs":[[-1292,-2153,2223,2224,2225]],"id":"18103","properties":{"name":"Miami"}},{"type":"Polygon","arcs":[[2226,2227,2228,2229,2230]],"id":"38047","properties":{"name":"Logan"}},{"type":"Polygon","arcs":[[2231,2232,2233,2234,2235,2236]],"id":"40021","properties":{"name":"Cherokee"}},{"type":"Polygon","arcs":[[2237,-275,-545,2238,2239,-626,2240,2241,2242,2243]],"id":"46085","properties":{"name":"Lyman"}},{"type":"Polygon","arcs":[[-30,2244,2245,2246]],"id":"27087","properties":{"name":"Mahnomen"}},{"type":"Polygon","arcs":[[-1493,-2025,2247,2248,2249,2250]],"id":"55019","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[2251,2252,-380,2253,2254,2255]],"id":"20171","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[2256,2257,2258,2259,2260]],"id":"27135","properties":{"name":"Roseau"}},{"type":"Polygon","arcs":[[2261,2262,2263,2264,2265,2266,2267]],"id":"05115","properties":{"name":"Pope"}},{"type":"Polygon","arcs":[[2268,2269,2270,2271,2272]],"id":"26095","properties":{"name":"Luce"}},{"type":"Polygon","arcs":[[-1994,2273,2274,2275,-309,2276]],"id":"29015","properties":{"name":"Benton"}},{"type":"Polygon","arcs":[[2277,2278,2279,2280,2281,-2264]],"id":"05141","properties":{"name":"Van Buren"}},{"type":"Polygon","arcs":[[2282,2283,2284,2285,2286,2287,2288,2289]],"id":"51199","properties":{"name":"York"}},{"type":"Polygon","arcs":[[-915,2290,2291,2292,2293,2294,-1536]],"id":"29067","properties":{"name":"Douglas"}},{"type":"Polygon","arcs":[[2295,2296,2297,2298,-1989,2299,2300,2301,2302,2303]],"id":"30029","properties":{"name":"Flathead"}},{"type":"Polygon","arcs":[[2304,2305,2306,2307,2308]],"id":"48305","properties":{"name":"Lynn"}},{"type":"Polygon","arcs":[[2309,2310,2311,2312,2313,2314]],"id":"29065","properties":{"name":"Dent"}},{"type":"Polygon","arcs":[[2315,2316,2317,2318,-1962]],"id":"48327","properties":{"name":"Menard"}},{"type":"Polygon","arcs":[[-1076,-413,-721,2319,-467]],"id":"48353","properties":{"name":"Nolan"}},{"type":"Polygon","arcs":[[2320,-2313,2321,2322,2323,2324]],"id":"29203","properties":{"name":"Shannon"}},{"type":"Polygon","arcs":[[2325,2326,-469,2327,-253,2328]],"id":"48431","properties":{"name":"Sterling"}},{"type":"Polygon","arcs":[[2329,2330,2331,2332,2333]],"id":"08089","properties":{"name":"Otero"}},{"type":"Polygon","arcs":[[2334,2335,2336,2337,-2306]],"id":"48169","properties":{"name":"Garza"}},{"type":"Polygon","arcs":[[2338,2339,2340,2341]],"id":"08119","properties":{"name":"Teller"}},{"type":"Polygon","arcs":[[2342,-2303,2343,2344,2345,2346,2347]],"id":"30089","properties":{"name":"Sanders"}},{"type":"Polygon","arcs":[[2348,-251,2349,-1709,2350,-410]],"id":"48059","properties":{"name":"Callahan"}},{"type":"Polygon","arcs":[[-1803,2351,2352,-1074,2353]],"id":"48433","properties":{"name":"Stonewall"}},{"type":"Polygon","arcs":[[2354,2355,2356,2357,-529,2358]],"id":"40051","properties":{"name":"Grady"}},{"type":"Polygon","arcs":[[2359,2360,2361,2362,2363,2364]],"id":"48159","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[2365,2366,2367,2368,2369,2370]],"id":"48467","properties":{"name":"Van Zandt"}},{"type":"Polygon","arcs":[[2371,-1059,2372,2373]],"id":"31073","properties":{"name":"Gosper"}},{"type":"Polygon","arcs":[[2374,2375,2376,2377,-388]],"id":"31059","properties":{"name":"Fillmore"}},{"type":"Polygon","arcs":[[2378,2379,2380,2381,2382,-2366,2383,2384]],"id":"48231","properties":{"name":"Hunt"}},{"type":"Polygon","arcs":[[2385,2386,-117,2387,2388]],"id":"48313","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[2389,2390,2391,2392,2393,2394,2395]],"id":"40019","properties":{"name":"Carter"}},{"type":"Polygon","arcs":[[2396,2397,2398,2399,2400]],"id":"51157","properties":{"name":"Rappahannock"}},{"type":"Polygon","arcs":[[2401,2402,2403,2404,2405]],"id":"01103","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[2406,2407,2408,2409,2410]],"id":"51079","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[2411,-1777,2412,2413,2414,2415,2416,2417,2418,-520]],"id":"02290","properties":{"name":"Yukon-Koyukuk"}},{"type":"Polygon","arcs":[[2419,2420,2421,2422,2423]],"id":"42059","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[-1953,2424,2425,2426,2427,2428]],"id":"05043","properties":{"name":"Drew"}},{"type":"Polygon","arcs":[[2429,2430,-458,2431,2432,2433,2434]],"id":"28043","properties":{"name":"Grenada"}},{"type":"Polygon","arcs":[[2435,2436],[2437]],"id":"51750","properties":{"name":"Radford"}},{"type":"Polygon","arcs":[[2438,2439,2440,2441,2442]],"id":"29211","properties":{"name":"Sullivan"}},{"type":"Polygon","arcs":[[2443,2444,2445,2446,2447]],"id":"54047","properties":{"name":"McDowell"}},{"type":"Polygon","arcs":[[2448,2449,2450,2451,2452]],"id":"37133","properties":{"name":"Onslow"}},{"type":"Polygon","arcs":[[2453,2454,2455,2456,2457,2458]],"id":"29049","properties":{"name":"Clinton"}},{"type":"Polygon","arcs":[[2459,2460,2461,2462,2463,2464]],"id":"12005","properties":{"name":"Bay"}},{"type":"Polygon","arcs":[[-144,2465,2466,2467]],"id":"72061","properties":{"name":"Guaynabo"}},{"type":"Polygon","arcs":[[2468,2469,2470,2471,2472]],"id":"72029","properties":{"name":"CanÃ³vanas"}},{"type":"Polygon","arcs":[[-150,-1759,2473,2474,2475,2476]],"id":"72047","properties":{"name":"Corozal"}},{"type":"MultiPolygon","arcs":[[[2477,2478,2479,-636,2480]],[[2481]]],"id":"53033","properties":{"name":"King"}},{"type":"Polygon","arcs":[[2482,2483,2484,2485,2486,2487,2488,2489,2490,2491,2492,-2493,2492,2493,-2479,2494]],"id":"53007","properties":{"name":"Chelan"}},{"type":"Polygon","arcs":[[2495,2496,2497,2498]],"id":"12035","properties":{"name":"Flagler"}},{"type":"Polygon","arcs":[[-2494,-2493,2492,-2493,-2492,2490,-2490,2488,-2488,2486,-2486,2499,2500,2501,-2480]],"id":"53037","properties":{"name":"Kittitas"}},{"type":"Polygon","arcs":[[2502,2503,2504,2505]],"id":"12095","properties":{"name":"Orange"}},{"type":"Polygon","arcs":[[2506,-68,2507,2508,-1959]],"id":"13235","properties":{"name":"Pulaski"}},{"type":"Polygon","arcs":[[2509,2510,-2162,-13,2511,2512,2513]],"id":"28005","properties":{"name":"Amite"}},{"type":"Polygon","arcs":[[2514,2515,2516,2517,2518]],"id":"46045","properties":{"name":"Edmunds"}},{"type":"Polygon","arcs":[[-1574,2519,2520,2521,-1823]],"id":"17063","properties":{"name":"Grundy"}},{"type":"Polygon","arcs":[[2522,2523,2524,-735,2525,-783]],"id":"20151","properties":{"name":"Pratt"}},{"type":"Polygon","arcs":[[2526,2527,2528,-888,-230]],"id":"19033","properties":{"name":"Cerro Gordo"}},{"type":"Polygon","arcs":[[2529,2530,2531,2532,2533,2534]],"id":"31155","properties":{"name":"Saunders"}},{"type":"Polygon","arcs":[[2535,2536,2537,2538,2539]],"id":"05125","properties":{"name":"Saline"}},{"type":"Polygon","arcs":[[-2023,-837,-426,2540,2541]],"id":"55097","properties":{"name":"Portage"}},{"type":"Polygon","arcs":[[2542,2543,-1610,2544,2545,2546,-1324]],"id":"20037","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[2547,2548,2549,2550,2551]],"id":"48221","properties":{"name":"Hood"}},{"type":"Polygon","arcs":[[2552,2553,2554,2555,-371,-1126]],"id":"20111","properties":{"name":"Lyon"}},{"type":"Polygon","arcs":[[2556,2557,2558,2559,2560]],"id":"46047","properties":{"name":"Fall River"}},{"type":"Polygon","arcs":[[2561,-299,297,-306,2562,2563,2564]],"id":"30069","properties":{"name":"Petroleum"}},{"type":"Polygon","arcs":[[2565,2566,2567,2568,2569,-2215,2570]],"id":"18023","properties":{"name":"Clinton"}},{"type":"Polygon","arcs":[[-696,2571,-40,-1674,2572,2573]],"id":"38003","properties":{"name":"Barnes"}},{"type":"Polygon","arcs":[[2574,2575,2576,2577,2578]],"id":"50015","properties":{"name":"Lamoille"}},{"type":"Polygon","arcs":[[2579,2580,2581,2582,2583,2584]],"id":"13035","properties":{"name":"Butts"}},{"type":"Polygon","arcs":[[-2248,-2024,-2542,2585,2586,2587]],"id":"55141","properties":{"name":"Wood"}},{"type":"Polygon","arcs":[[2588,-231,-891,-1838,-1038]],"id":"19197","properties":{"name":"Wright"}},{"type":"Polygon","arcs":[[2589,2590,2591,-546,2592,-2318]],"id":"48319","properties":{"name":"Mason"}},{"type":"Polygon","arcs":[[2593,2594,2595,2596]],"id":"48183","properties":{"name":"Gregg"}},{"type":"Polygon","arcs":[[2597,2598,2599,2600,2601,2602]],"id":"28105","properties":{"name":"Oktibbeha"}},{"type":"Polygon","arcs":[[-985,983,-983,981,-981,2603,2604,2605]],"id":"06057","properties":{"name":"Nevada"}},{"type":"Polygon","arcs":[[-2559,2606,2607,2608,2609]],"id":"31045","properties":{"name":"Dawes"}},{"type":"Polygon","arcs":[[2610,2611,2612,2613,2614]],"id":"41033","properties":{"name":"Josephine"}},{"type":"Polygon","arcs":[[-972,2615,2616,2617,-2376]],"id":"31151","properties":{"name":"Saline"}},{"type":"Polygon","arcs":[[-1222,2618,2619,2620,2621]],"id":"48211","properties":{"name":"Hemphill"}},{"type":"Polygon","arcs":[[2622,-2584,2623,2624,2625]],"id":"13171","properties":{"name":"Lamar"}},{"type":"Polygon","arcs":[[2626,2627,2628,2629,2630]],"id":"28065","properties":{"name":"Jefferson Davis"}},{"type":"Polygon","arcs":[[-1932,-952,2631,2632,2633,2634,2635]],"id":"39089","properties":{"name":"Licking"}},{"type":"Polygon","arcs":[[-189,2636,-1982,-819,2637,2638]],"id":"48069","properties":{"name":"Castro"}},{"type":"Polygon","arcs":[[2639,-1599,2640,2641,2642]],"id":"26009","properties":{"name":"Antrim"}},{"type":"Polygon","arcs":[[2643,2644,2645,2646,2647,-177]],"id":"20147","properties":{"name":"Phillips"}},{"type":"Polygon","arcs":[[2648,2649,2650,2651]],"id":"20067","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[-1986,2652,2653,2654]],"id":"30007","properties":{"name":"Broadwater"}},{"type":"Polygon","arcs":[[-597,2655,-794,2656,-1968,2657,-1055,2658]],"id":"31019","properties":{"name":"Buffalo"}},{"type":"Polygon","arcs":[[2659,2660,2661,2662]],"id":"32009","properties":{"name":"Esmeralda"}},{"type":"Polygon","arcs":[[2663,2664,2665,2666,2667]],"id":"37135","properties":{"name":"Orange"}},{"type":"Polygon","arcs":[[2668,2669,2670,2671,2672,2673]],"id":"16051","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[2674,-1199,2675,-892,2676]],"id":"18087","properties":{"name":"LaGrange"}},{"type":"Polygon","arcs":[[-967,2677,2678,2679,-293,2680]],"id":"19105","properties":{"name":"Jones"}},{"type":"Polygon","arcs":[[2681,2682,2683,2684,2685,2686]],"id":"19027","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[2687,2688,-697,-2574,2689,-2228,2690]],"id":"38093","properties":{"name":"Stutsman"}},{"type":"Polygon","arcs":[[2691,-1041,-1113,2692,2693,-2684]],"id":"19073","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[2694,2695,2696,2697,2698,2699,2700]],"id":"01003","properties":{"name":"Baldwin"}},{"type":"Polygon","arcs":[[2701,2702,2703,-1620,2704,2705,2706]],"id":"26075","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[2707,-1635,2708,2709,2710]],"id":"47067","properties":{"name":"Hancock"}},{"type":"Polygon","arcs":[[-178,-2648,2711,2712,2713,2714]],"id":"20065","properties":{"name":"Graham"}},{"type":"Polygon","arcs":[[-1799,2715,-1322,-1138]],"id":"20001","properties":{"name":"Allen"}},{"type":"Polygon","arcs":[[2716,2717,2718,2719,2720,2721]],"id":"40127","properties":{"name":"Pushmataha"}},{"type":"Polygon","arcs":[[2722,2723,2724,2725,2726]],"id":"48461","properties":{"name":"Upton"}},{"type":"Polygon","arcs":[[2727,-2518,2728,-271,2729,2730]],"id":"46107","properties":{"name":"Potter"}},{"type":"Polygon","arcs":[[-1057,2731,-2644,2732]],"id":"31083","properties":{"name":"Harlan"}},{"type":"Polygon","arcs":[[2733,2734,2735,2736,2737]],"id":"19063","properties":{"name":"Emmet"}},{"type":"Polygon","arcs":[[2738,2739,2740,2741,-1643]],"id":"38019","properties":{"name":"Cavalier"}},{"type":"Polygon","arcs":[[2742,2743,2744,2745,2746,2747]],"id":"06109","properties":{"name":"Tuolumne"}},{"type":"Polygon","arcs":[[-2713,2748,-2190,-1566,2749]],"id":"20195","properties":{"name":"Trego"}},{"type":"Polygon","arcs":[[2750,-935,-134,2751,2752]],"id":"48247","properties":{"name":"Jim Hogg"}},{"type":"Polygon","arcs":[[2753,2754,2755,2756]],"id":"72069","properties":{"name":"Humacao"}},{"type":"Polygon","arcs":[[2757,2758,2759]],"id":"55078","properties":{"name":"Menominee"}},{"type":"Polygon","arcs":[[-1966,2760,2761,2762,-2735,2763]],"id":"27091","properties":{"name":"Martin"}},{"type":"Polygon","arcs":[[2764,2765,2766,-875,2767,2768]],"id":"01085","properties":{"name":"Lowndes"}},{"type":"Polygon","arcs":[[2769,2770,-808,2771,2772,2773]],"id":"21073","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[2774,2775,2776,2777,2778]],"id":"29205","properties":{"name":"Shelby"}},{"type":"Polygon","arcs":[[2779,2780,2781,2782,2783,2784]],"id":"40037","properties":{"name":"Creek"}},{"type":"Polygon","arcs":[[2785,2786,2787,2788,2789,2790]],"id":"48285","properties":{"name":"Lavaca"}},{"type":"Polygon","arcs":[[-429,2791,2792,2793,2794,2795]],"id":"55047","properties":{"name":"Green Lake"}},{"type":"Polygon","arcs":[[-598,-2659,-1054,-2372,2796,2797]],"id":"31047","properties":{"name":"Dawson"}},{"type":"Polygon","arcs":[[-1335,-1200,-2675,2798,2799]],"id":"26149","properties":{"name":"St. Joseph"}},{"type":"Polygon","arcs":[[2800,2801,2802,-860,2803,2804]],"id":"17081","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[2805,-480,2806,-2528,2807]],"id":"19131","properties":{"name":"Mitchell"}},{"type":"Polygon","arcs":[[2808,-2415,2809,-2085,2810,2811]],"id":"02240","properties":{"name":"Southeast Fairbanks"}},{"type":"Polygon","arcs":[[-1826,-1169,2812]],"id":"17155","properties":{"name":"Putnam"}},{"type":"Polygon","arcs":[[2813,2814,-1183,2815,2816]],"id":"19137","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[2817,2818,-223,2819]],"id":"19017","properties":{"name":"Bremer"}},{"type":"Polygon","arcs":[[2820,-1370,2821,2822,-2802,2823]],"id":"17121","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[2824,2825,2826,2827,2828]],"id":"37025","properties":{"name":"Cabarrus"}},{"type":"Polygon","arcs":[[2829,-945,2830,-2724,2831]],"id":"48329","properties":{"name":"Midland"}},{"type":"Polygon","arcs":[[-2319,-2593,-551,2832,2833,-1736]],"id":"48267","properties":{"name":"Kimble"}},{"type":"Polygon","arcs":[[2834,2835,2836,2837,2838]],"id":"55103","properties":{"name":"Richland"}},{"type":"Polygon","arcs":[[-938,-421,2839,-1679,-414,-687]],"id":"48065","properties":{"name":"Carson"}},{"type":"Polygon","arcs":[[2840,2841,2842,2843,2844]],"id":"21061","properties":{"name":"Edmonson"}},{"type":"Polygon","arcs":[[2845,2846,2847,2848,2849,2850,2851]],"id":"18047","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[2852,2853,2854,-1848,2855,2856]],"id":"16085","properties":{"name":"Valley"}},{"type":"Polygon","arcs":[[2857,2858,2859,2860,2861,2862]],"id":"51109","properties":{"name":"Louisa"}},{"type":"Polygon","arcs":[[2863,-1118,2864,-2552,2865,2866,2867]],"id":"48363","properties":{"name":"Palo Pinto"}},{"type":"Polygon","arcs":[[2868,-2638,-823,-243,2869]],"id":"48279","properties":{"name":"Lamb"}},{"type":"Polygon","arcs":[[2870,2871,2872,2873,-2465,2874,-316]],"id":"12131","properties":{"name":"Walton"}},{"type":"Polygon","arcs":[[-49,2875,2876,2877,2878]],"id":"36039","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[-1214,2879,-489,2880,-1889,2881,2882,2883]],"id":"39037","properties":{"name":"Darke"}},{"type":"Polygon","arcs":[[-2259,2884,2885,2886,2887,2888,2889,-2143,2890]],"id":"27007","properties":{"name":"Beltrami"}},{"type":"Polygon","arcs":[[2891,2892,-907,-1354,-1350]],"id":"26133","properties":{"name":"Osceola"}},{"type":"Polygon","arcs":[[-375,2893,2894,2895,2896,2897]],"id":"20049","properties":{"name":"Elk"}},{"type":"Polygon","arcs":[[2898,2899,2900,2901,2902]],"id":"20075","properties":{"name":"Hamilton"}},{"type":"Polygon","arcs":[[2903,2904,2905,2906,-1761,-1786,2907,2908]],"id":"27137","properties":{"name":"St. Louis"}},{"type":"Polygon","arcs":[[2909,2910,2911,-2211,2912,2913]],"id":"19183","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-250,2914,-2867,2915,2916,-1710,-2350]],"id":"48133","properties":{"name":"Eastland"}},{"type":"Polygon","arcs":[[-2833,-550,2917,2918,2919,2920]],"id":"48265","properties":{"name":"Kerr"}},{"type":"Polygon","arcs":[[2921,2922,2923,2924,2925,2926]],"id":"36003","properties":{"name":"Allegany"}},{"type":"Polygon","arcs":[[-822,2927,-2305,-244]],"id":"48303","properties":{"name":"Lubbock"}},{"type":"Polygon","arcs":[[2928,2929]],"id":"51775","properties":{"name":"Salem"}},{"type":"Polygon","arcs":[[2930,2931]],"id":"51670","properties":{"name":"Hopewell"}},{"type":"Polygon","arcs":[[2932,2933,2934,2935,-1814,2936]],"id":"17073","properties":{"name":"Henry"}},{"type":"Polygon","arcs":[[2937,2938,-1053,2939,2940]],"id":"28079","properties":{"name":"Leake"}},{"type":"Polygon","arcs":[[2941,2942,2943,2944,2945,2946,2947]],"id":"35057","properties":{"name":"Torrance"}},{"type":"Polygon","arcs":[[2948,2949,-153,2950,2951]],"id":"08095","properties":{"name":"Phillips"}},{"type":"Polygon","arcs":[[2952,-2951,-157,2953,2954,2955,-1030]],"id":"08125","properties":{"name":"Yuma"}},{"type":"Polygon","arcs":[[2956,2957,2958,2959]],"id":"19141","properties":{"name":"O'Brien"}},{"type":"Polygon","arcs":[[-2941,2960,2961,2962,2963]],"id":"28123","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[-590,2964,2965,2966,-595]],"id":"31175","properties":{"name":"Valley"}},{"type":"Polygon","arcs":[[2967,-1310,2968,2969,-2825,2970,2971,2972,-1974]],"id":"37097","properties":{"name":"Iredell"}},{"type":"Polygon","arcs":[[2973,2974,2975,2976,2977]],"id":"01057","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[2978,2979,-180,2980,-899,2981]],"id":"20039","properties":{"name":"Decatur"}},{"type":"Polygon","arcs":[[2982,2983,2984,2985,2986,-2096]],"id":"41001","properties":{"name":"Baker"}},{"type":"Polygon","arcs":[[2987,2988,2989,2990,2991]],"id":"01133","properties":{"name":"Winston"}},{"type":"Polygon","arcs":[[2992,2993,2994,2995,2996]],"id":"29221","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[2997,2998,2999]],"id":"72015","properties":{"name":"Arroyo"}},{"type":"Polygon","arcs":[[3000,3001,3002,3003,3004,3005,3006]],"id":"18007","properties":{"name":"Benton"}},{"type":"MultiPolygon","arcs":[[[3007]],[[3008]],[[3009]],[[3010]],[[3011,3012,3013,3014,3015,3016,3017,3018]]],"id":"06083","properties":{"name":"Santa Barbara"}},{"type":"Polygon","arcs":[[3019,-576,-2223,3020,3021]],"id":"06105","properties":{"name":"Trinity"}},{"type":"Polygon","arcs":[[3022,3023,3024,3025,3026,3027]],"id":"17117","properties":{"name":"Macoupin"}},{"type":"Polygon","arcs":[[3028,3029,3030,3031,-1313,-2185]],"id":"26145","properties":{"name":"Saginaw"}},{"type":"Polygon","arcs":[[-2866,-2551,3032,3033,-704,3034,-2916]],"id":"48143","properties":{"name":"Erath"}},{"type":"MultiPolygon","arcs":[[[3035,3036,3037,3038,3039,3040]],[[3041,3042]]],"id":"12101","properties":{"name":"Pasco"}},{"type":"Polygon","arcs":[[3043,3044,-818,3045,3046]],"id":"37169","properties":{"name":"Stokes"}},{"type":"Polygon","arcs":[[3047,3048,-2857,3049,3050,3051,3052]],"id":"16045","properties":{"name":"Gem"}},{"type":"Polygon","arcs":[[3053,3054,3055,3056,3057]],"id":"54021","properties":{"name":"Gilmer"}},{"type":"Polygon","arcs":[[-738,3058,3059,3060,3061,3062]],"id":"40003","properties":{"name":"Alfalfa"}},{"type":"Polygon","arcs":[[3063,3064,3065,3066,3067,-1547,3068]],"id":"20201","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[3069,3070,3071,3072,3073]],"id":"13109","properties":{"name":"Evans"}},{"type":"Polygon","arcs":[[3074,3075,3076,-1218,3077,3078,3079]],"id":"18065","properties":{"name":"Henry"}},{"type":"Polygon","arcs":[[3080,3081,3082,3083]],"id":"45023","properties":{"name":"Chester"}},{"type":"Polygon","arcs":[[3084,-2005,-10,3085,3086,3087,3088]],"id":"04012","properties":{"name":"La Paz"}},{"type":"Polygon","arcs":[[3089,3090,3091,-593,3092,-461]],"id":"31009","properties":{"name":"Blaine"}},{"type":"Polygon","arcs":[[-2855,3093,-2000,-1530,3094,3095,-1843]],"id":"16059","properties":{"name":"Lemhi"}},{"type":"Polygon","arcs":[[3096,-1048,3097,3098,3099]],"id":"20069","properties":{"name":"Gray"}},{"type":"Polygon","arcs":[[-2433,3100,3101,3102,3103]],"id":"28097","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[3104,3105,3106,3107,-2594,3108,3109]],"id":"48459","properties":{"name":"Upshur"}},{"type":"Polygon","arcs":[[3110,3111,3112,3113,3114,3115,-548]],"id":"48031","properties":{"name":"Blanco"}},{"type":"Polygon","arcs":[[3116,3117,3118,3119,3120]],"id":"20061","properties":{"name":"Geary"}},{"type":"Polygon","arcs":[[3121,3122,3123,3124,3125,3126]],"id":"21041","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[3127,3128,-1289,-1578,3129]],"id":"18099","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[3130,-817,3131,-1201,3132]],"id":"37081","properties":{"name":"Guilford"}},{"type":"Polygon","arcs":[[3133,3134]],"id":"51610","properties":{"name":"Falls Church"}},{"type":"Polygon","arcs":[[3135]],"id":"51678","properties":{"name":"Lexington"}},{"type":"Polygon","arcs":[[3136,-2706,3137,3138,3139,3140,-1197]],"id":"26059","properties":{"name":"Hillsdale"}},{"type":"Polygon","arcs":[[-1209,3141,-2256,3142,-2900,3143]],"id":"20203","properties":{"name":"Wichita"}},{"type":"Polygon","arcs":[[-1946,3144,3145,3146,3147]],"id":"27039","properties":{"name":"Dodge"}},{"type":"Polygon","arcs":[[3148,-1174,3149,-1250]],"id":"17039","properties":{"name":"De Witt"}},{"type":"Polygon","arcs":[[-1718,-946,-2830,3150,3151,3152]],"id":"48003","properties":{"name":"Andrews"}},{"type":"Polygon","arcs":[[3153,-1454,-604,3154,-2091,-123,3155]],"id":"46111","properties":{"name":"Sanborn"}},{"type":"Polygon","arcs":[[3156,3157,-1949,3158,3159,3160]],"id":"27079","properties":{"name":"Le Sueur"}},{"type":"Polygon","arcs":[[3161,3162,3163,3164,-988,3165]],"id":"55105","properties":{"name":"Rock"}},{"type":"Polygon","arcs":[[-1947,-3148,3166,-1361,3167]],"id":"27147","properties":{"name":"Steele"}},{"type":"Polygon","arcs":[[3168,3169,3170,3171,3172,3173]],"id":"42065","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[3174,3175,-1043,3176,3177]],"id":"19151","properties":{"name":"Pocahontas"}},{"type":"Polygon","arcs":[[-1508,-1347,3178,3179,3180,-744]],"id":"27105","properties":{"name":"Nobles"}},{"type":"MultiPolygon","arcs":[[[3181,3182]],[[3183]],[[3184]],[[3185]],[[3186]],[[3187]],[[3188]],[[3189]],[[3190]],[[3191]],[[3192]],[[-1654,3193]],[[3194,3195]]],"id":"02198","properties":{"name":"Prince of Wales-Hyder"}},{"type":"Polygon","arcs":[[3196,3197,3198,-353]],"id":"46121","properties":{"name":"Todd"}},{"type":"Polygon","arcs":[[3199,3200,3201,3202,3203]],"id":"13003","properties":{"name":"Atkinson"}},{"type":"MultiPolygon","arcs":[[[-3196,3204]],[[3205]],[[-1442,3206]]],"id":"02220","properties":{"name":"Sitka"}},{"type":"Polygon","arcs":[[-2434,-3104,3207,3208,3209]],"id":"28015","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[3210,3211,-1834,3212]],"id":"12111","properties":{"name":"St. Lucie"}},{"type":"Polygon","arcs":[[-290,-2172,-1703,3213,3214]],"id":"19051","properties":{"name":"Davis"}},{"type":"Polygon","arcs":[[3215,3216,3217,3218,3219]],"id":"17109","properties":{"name":"McDonough"}},{"type":"Polygon","arcs":[[3220,3221,3222,3223,3224]],"id":"39143","properties":{"name":"Sandusky"}},{"type":"Polygon","arcs":[[-2823,3225,-1189,3226,3227,-861,-2803]],"id":"17191","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[3228,3229,3230,3231,3232,3233]],"id":"48243","properties":{"name":"Jeff Davis"}},{"type":"Polygon","arcs":[[3234,-858,3235,-3157,3236,3237]],"id":"27143","properties":{"name":"Sibley"}},{"type":"Polygon","arcs":[[3238,-1098,3239,-1802]],"id":"48275","properties":{"name":"Knox"}},{"type":"Polygon","arcs":[[3240,3241,3242,3243,3244,3245,3246]],"id":"17163","properties":{"name":"St. Clair"}},{"type":"Polygon","arcs":[[-788,3247,3248,3249,-1024]],"id":"26011","properties":{"name":"Arenac"}},{"type":"Polygon","arcs":[[-1375,3250,3251,3252,-1184,3253]],"id":"17079","properties":{"name":"Jasper"}},{"type":"Polygon","arcs":[[-1548,-3068,3254,-3117,3255,3256]],"id":"20027","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[3257,3258,3259,3260,-2001,-3094,-2854,3261,3262]],"id":"16049","properties":{"name":"Idaho"}},{"type":"Polygon","arcs":[[3263,-1647,3264,-2192]],"id":"38079","properties":{"name":"Rolette"}},{"type":"Polygon","arcs":[[-2981,-179,-2715,3265,-900]],"id":"20179","properties":{"name":"Sheridan"}},{"type":"Polygon","arcs":[[3266,3267,-3111,-547,-2592]],"id":"48299","properties":{"name":"Llano"}},{"type":"Polygon","arcs":[[3268,3269,3270,-2334,3271,3272,3273]],"id":"08101","properties":{"name":"Pueblo"}},{"type":"Polygon","arcs":[[3274,3275,-2615,3276,3277]],"id":"41015","properties":{"name":"Curry"}},{"type":"Polygon","arcs":[[3278,-2602,3279,3280,-1050,3281]],"id":"28159","properties":{"name":"Winston"}},{"type":"Polygon","arcs":[[-2658,-1972,3282,-1056]],"id":"31099","properties":{"name":"Kearney"}},{"type":"Polygon","arcs":[[-2476,3283,3284,3285,-1120,3286,3287]],"id":"72019","properties":{"name":"Barranquitas"}},{"type":"Polygon","arcs":[[3288,-2423,3289,3290,3291,3292,3293,3294]],"id":"54103","properties":{"name":"Wetzel"}},{"type":"Polygon","arcs":[[3295,-844,3296,3297]],"id":"13201","properties":{"name":"Miller"}},{"type":"Polygon","arcs":[[-1860,3298,3299,3300,-163]],"id":"08003","properties":{"name":"Alamosa"}},{"type":"Polygon","arcs":[[-784,-2526,-741,3301,3302,-1045]],"id":"20097","properties":{"name":"Kiowa"}},{"type":"Polygon","arcs":[[3303,3304,3305,-717]],"id":"38041","properties":{"name":"Hettinger"}},{"type":"Polygon","arcs":[[-3146,3306,3307,3308,3309,3310]],"id":"27109","properties":{"name":"Olmsted"}},{"type":"Polygon","arcs":[[3311,-2472,3312,-1751]],"id":"72077","properties":{"name":"Juncos"}},{"type":"Polygon","arcs":[[-1857,3313,-2687,-1152,3314,3315]],"id":"19047","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[3316,3317,3318,-1259,3319,-2555]],"id":"20139","properties":{"name":"Osage"}},{"type":"Polygon","arcs":[[3320,-227,3321,-776,-1841]],"id":"19075","properties":{"name":"Grundy"}},{"type":"Polygon","arcs":[[3322,3323,-903,3324,-1207,3325]],"id":"20181","properties":{"name":"Sherman"}},{"type":"Polygon","arcs":[[-2117,3326,3327,3328,3329]],"id":"72121","properties":{"name":"Sabana Grande"}},{"type":"Polygon","arcs":[[-2686,3330,3331,-1153]],"id":"19009","properties":{"name":"Audubon"}},{"type":"MultiPolygon","arcs":[[[3332]],[[3333]],[[3334]],[[3335]],[[3336,-748,3337,3338,3339,3340]]],"id":"23009","properties":{"name":"Hancock"}},{"type":"Polygon","arcs":[[3341,3342,3343,3344,3345,3346]],"id":"05081","properties":{"name":"Little River"}},{"type":"Polygon","arcs":[[3347,3348,3349,3350]],"id":"05143","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[3351,3352,3353,3354,-2536,3355]],"id":"05119","properties":{"name":"Pulaski"}},{"type":"Polygon","arcs":[[3356,3357,3358,3359,-3353,3360]],"id":"05085","properties":{"name":"Lonoke"}},{"type":"Polygon","arcs":[[3361,3362,3363,3364,3365,3366,3367]],"id":"08009","properties":{"name":"Baca"}},{"type":"Polygon","arcs":[[3368,3369,3370,3371,3372,3373,3374,3375]],"id":"16031","properties":{"name":"Cassia"}},{"type":"Polygon","arcs":[[3376,3377,3378,3379,3380,3381,3382]],"id":"01021","properties":{"name":"Chilton"}},{"type":"Polygon","arcs":[[-1961,3383,3384,3385,3386,-197]],"id":"13081","properties":{"name":"Crisp"}},{"type":"Polygon","arcs":[[3387,3388,-1506,-1517,3389]],"id":"27083","properties":{"name":"Lyon"}},{"type":"Polygon","arcs":[[3390,3391,3392,3393,3394,3395]],"id":"51049","properties":{"name":"Cumberland"}},{"type":"Polygon","arcs":[[3396,3397,3398,3399,3400,3401]],"id":"31133","properties":{"name":"Pawnee"}},{"type":"Polygon","arcs":[[-2621,3402,-541,3403,-1678]],"id":"48483","properties":{"name":"Wheeler"}},{"type":"Polygon","arcs":[[-398,3404,3405,-34,-2572,-695]],"id":"38091","properties":{"name":"Steele"}},{"type":"Polygon","arcs":[[-926,-973,-2375,3406]],"id":"31185","properties":{"name":"York"}},{"type":"Polygon","arcs":[[-2641,-911,3407,3408]],"id":"26079","properties":{"name":"Kalkaska"}},{"type":"Polygon","arcs":[[-2647,3409,3410,-2186,-2749,-2712]],"id":"20163","properties":{"name":"Rooks"}},{"type":"Polygon","arcs":[[3411,3412,3413,-3251,-1374]],"id":"17035","properties":{"name":"Cumberland"}},{"type":"Polygon","arcs":[[3414,3415,3416,3417,-2120,3418,3419]],"id":"54101","properties":{"name":"Webster"}},{"type":"Polygon","arcs":[[3420,3421,3422,3423,3424]],"id":"28139","properties":{"name":"Tippah"}},{"type":"Polygon","arcs":[[3425,3426,3427,3428,3429,3430,-3200,3431]],"id":"13069","properties":{"name":"Coffee"}},{"type":"Polygon","arcs":[[3432,3433,3434,3435,3436]],"id":"20169","properties":{"name":"Saline"}},{"type":"Polygon","arcs":[[3437,3438,3439,3440]],"id":"28119","properties":{"name":"Quitman"}},{"type":"Polygon","arcs":[[-2690,-2573,-1676,-342,3441,-2229]],"id":"38045","properties":{"name":"LaMoure"}},{"type":"Polygon","arcs":[[3442,-3437,3443,3444,3445,3446]],"id":"20053","properties":{"name":"Ellsworth"}},{"type":"Polygon","arcs":[[3447,3448,3449,-70,3450,3451,3452,3453]],"id":"18055","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[3454,3455,-1707,3456,3457,3458,-2440]],"id":"29001","properties":{"name":"Adair"}},{"type":"Polygon","arcs":[[3459,3460,3461,3462,-950,3463]],"id":"39075","properties":{"name":"Holmes"}},{"type":"Polygon","arcs":[[-2265,-2282,3464,3465,3466]],"id":"05029","properties":{"name":"Conway"}},{"type":"Polygon","arcs":[[-1579,-1294,3467,3468,3469]],"id":"18131","properties":{"name":"Pulaski"}},{"type":"Polygon","arcs":[[3470,3471,3472,3473,-3285]],"id":"72045","properties":{"name":"ComerÃ­o"}},{"type":"Polygon","arcs":[[3474,3475,-238,-791,3476,-2966]],"id":"31077","properties":{"name":"Greeley"}},{"type":"Polygon","arcs":[[3477,-555,-2335,-2928]],"id":"48107","properties":{"name":"Crosby"}},{"type":"Polygon","arcs":[[3478,3479,3480,3481,3482,3483,3484]],"id":"21083","properties":{"name":"Graves"}},{"type":"Polygon","arcs":[[3485,3486,3487,3488,3489,3490]],"id":"21171","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[3491,-1372,3492,3493]],"id":"17005","properties":{"name":"Bond"}},{"type":"Polygon","arcs":[[3494,3495,3496,3497,3498,3499,3500]],"id":"05097","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[3501,3502,3503,3504,3505,-1227]],"id":"47159","properties":{"name":"Smith"}},{"type":"Polygon","arcs":[[3506,3507,3508,3509,3510,3511]],"id":"17045","properties":{"name":"Edgar"}},{"type":"Polygon","arcs":[[3512,3513,3514,3515,3516,3517]],"id":"42021","properties":{"name":"Cambria"}},{"type":"Polygon","arcs":[[3518,3519,3520,3521,3522,3523]],"id":"41043","properties":{"name":"Linn"}},{"type":"Polygon","arcs":[[-867,-350,3524,-3238,3525,3526,3527,3528,3529]],"id":"27129","properties":{"name":"Renville"}},{"type":"Polygon","arcs":[[3530,3531,3532,3533,-1386,-2132]],"id":"27153","properties":{"name":"Todd"}},{"type":"Polygon","arcs":[[3534,3535,3536,3537,-3520,3538]],"id":"41047","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[3539,-241,3540,3541,3542,3543,3544]],"id":"42071","properties":{"name":"Lancaster"}},{"type":"Polygon","arcs":[[3545,3546,3547,3548,-2280]],"id":"05023","properties":{"name":"Cleburne"}},{"type":"Polygon","arcs":[[3549,3550,-3427,3551,3552]],"id":"13017","properties":{"name":"Ben Hill"}},{"type":"MultiPolygon","arcs":[[[3553]],[[3554]],[[3555]],[[3556,3557]]],"id":"15009","properties":{"name":"Maui"}},{"type":"Polygon","arcs":[[3558,3559,3560,3561,3562,-1587]],"id":"29169","properties":{"name":"Pulaski"}},{"type":"Polygon","arcs":[[-1415,3563,-932,-558]],"id":"48311","properties":{"name":"McMullen"}},{"type":"Polygon","arcs":[[-1035,-968,-2681,-292,3564,3565]],"id":"19113","properties":{"name":"Linn"}},{"type":"Polygon","arcs":[[-420,-633,3566,-1223,-2622,-1677,-2840]],"id":"48393","properties":{"name":"Roberts"}},{"type":"Polygon","arcs":[[-1871,3567,-2914,3568,-288,-1241]],"id":"19107","properties":{"name":"Keokuk"}},{"type":"Polygon","arcs":[[-2104,3569,3570,3571,3572,3573]],"id":"39073","properties":{"name":"Hocking"}},{"type":"Polygon","arcs":[[3574,3575,3576,3577,3578]],"id":"13053","properties":{"name":"Chattahoochee"}},{"type":"Polygon","arcs":[[3579,-2564,3580,3581,-1474]],"id":"30065","properties":{"name":"Musselshell"}},{"type":"Polygon","arcs":[[3582,-647,3583,3584]],"id":"13149","properties":{"name":"Heard"}},{"type":"Polygon","arcs":[[3585,3586]],"id":"27031","properties":{"name":"Cook"}},{"type":"Polygon","arcs":[[3587,3588,-2682,-3314,-1856]],"id":"19161","properties":{"name":"Sac"}},{"type":"Polygon","arcs":[[3589,3590,3591,-2665,3592]],"id":"37145","properties":{"name":"Person"}},{"type":"Polygon","arcs":[[-2413,-1776,3593]],"id":"02185","properties":{"name":"North Slope"}},{"type":"Polygon","arcs":[[3594,3595,3596]],"id":"72095","properties":{"name":"Maunabo"}},{"type":"Polygon","arcs":[[3597,-2202,3598,3599,-2151]],"id":"18069","properties":{"name":"Huntington"}},{"type":"Polygon","arcs":[[3600,-2996,3601,3602,3603,3604,-2311]],"id":"29093","properties":{"name":"Iron"}},{"type":"Polygon","arcs":[[-554,-2354,-1073,3605,-2336]],"id":"48263","properties":{"name":"Kent"}},{"type":"Polygon","arcs":[[3606,3607,-2437,3608,3609,3610,3611,3612]],"id":"51155","properties":{"name":"Pulaski"}},{"type":"Polygon","arcs":[[3613,-1700,-1595,3614,3615,-2455]],"id":"29025","properties":{"name":"Caldwell"}},{"type":"Polygon","arcs":[[3616,3617,3618,3619,3620,3621]],"id":"01073","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[3622]],"id":"15001","properties":{"name":"Hawaii"}},{"type":"Polygon","arcs":[[3623,3624,3625,3626]],"id":"53023","properties":{"name":"Garfield"}},{"type":"Polygon","arcs":[[3627,3628,3629,3630,3631]],"id":"01027","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[3632,3633,-1858,3634,3635,3636,3637]],"id":"19193","properties":{"name":"Woodbury"}},{"type":"Polygon","arcs":[[3638,-1155,3639,-2814,3640,3641,3642,3643]],"id":"19155","properties":{"name":"Pottawattamie"}},{"type":"Polygon","arcs":[[-1845,3644,3645,3646,-3371,3647,-21,3648,3649]],"id":"16013","properties":{"name":"Blaine"}},{"type":"MultiPolygon","arcs":[[[3650]],[[3651,3652,-3341,3653,3654,3655,3656]]],"id":"23027","properties":{"name":"Waldo"}},{"type":"Polygon","arcs":[[3657,3658,3659,3660,3661,3662]],"id":"25025","properties":{"name":"Suffolk"}},{"type":"Polygon","arcs":[[3663,3664,3665,3666,3667,3668]],"id":"25011","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-1025,-3250,3669,3670,-3029,-2184]],"id":"26017","properties":{"name":"Bay"}},{"type":"Polygon","arcs":[[3671,3672,3673,-3390,-1516]],"id":"27081","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[3674,3675,3676,3677,3678,3679]],"id":"28011","properties":{"name":"Bolivar"}},{"type":"Polygon","arcs":[[3680,3681,3682,-1005]],"id":"26007","properties":{"name":"Alpena"}},{"type":"Polygon","arcs":[[3683,3684,3685,3686,3687,3688,3689]],"id":"26053","properties":{"name":"Gogebic"}},{"type":"Polygon","arcs":[[3690,-327,3691,3692,-3652,3693,3694]],"id":"23025","properties":{"name":"Somerset"}},{"type":"Polygon","arcs":[[3695,3696,3697,3698,3699,3700,3701,3702,3703]],"id":"28149","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[3704,3705,3706,3707,3708,3709,3710]],"id":"36075","properties":{"name":"Oswego"}},{"type":"Polygon","arcs":[[3711,-3528,3712,-1343,-1507,-3389]],"id":"27127","properties":{"name":"Redwood"}},{"type":"Polygon","arcs":[[3713,3714,3715,3716,3717,3718,3719]],"id":"39095","properties":{"name":"Lucas"}},{"type":"Polygon","arcs":[[3720,-296,3721,3722,3723]],"id":"19139","properties":{"name":"Muscatine"}},{"type":"Polygon","arcs":[[-531,3724,3725,3726,3727,3728]],"id":"40033","properties":{"name":"Cotton"}},{"type":"Polygon","arcs":[[-3641,-2817,3729,3730,3731]],"id":"19129","properties":{"name":"Mills"}},{"type":"Polygon","arcs":[[3732,3733,3734,3735]],"id":"36059","properties":{"name":"Nassau"}},{"type":"Polygon","arcs":[[3736,3737,3738,3739,3740,3741]],"id":"30109","properties":{"name":"Wibaux"}},{"type":"Polygon","arcs":[[3742,3743,3744,3745,3746]],"id":"29155","properties":{"name":"Pemiscot"}},{"type":"Polygon","arcs":[[3747,3748,3749,3750,3751,-2777]],"id":"29127","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[3752,3753,-1629,3754,3755]],"id":"35017","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[3756,-171,3757,3758,3759,3760,3761,3762]],"id":"51107","properties":{"name":"Loudoun"}},{"type":"Polygon","arcs":[[3763,3764,3765,3766,3767,-1426]],"id":"46105","properties":{"name":"Perkins"}},{"type":"Polygon","arcs":[[3768,-3115,3769,3770,3771]],"id":"48091","properties":{"name":"Comal"}},{"type":"Polygon","arcs":[[3772,-2753,3773,3774]],"id":"48505","properties":{"name":"Zapata"}},{"type":"MultiPolygon","arcs":[[[3775,3776,3777,3778]],[[3779,3780,3781,3782]],[[3783,3784,3785]]],"id":"48007","properties":{"name":"Aransas"}},{"type":"Polygon","arcs":[[3786,3787,3788,3789,3790,3791]],"id":"48361","properties":{"name":"Orange"}},{"type":"Polygon","arcs":[[3792,-3152,3793,3794,3795]],"id":"48495","properties":{"name":"Winkler"}},{"type":"Polygon","arcs":[[3796,3797,3798,3799,3800,3801]],"id":"51011","properties":{"name":"Appomattox"}},{"type":"Polygon","arcs":[[3802,3803,3804,-1108,3805,3806,3807,-2501]],"id":"53025","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[3808,-3293,3809,3810,-3055,3811]],"id":"54017","properties":{"name":"Doddridge"}},{"type":"Polygon","arcs":[[3812,-563,3813,3814,-2121,-3418,3815]],"id":"54083","properties":{"name":"Randolph"}},{"type":"Polygon","arcs":[[-3180,3816,3817,-2957,3818]],"id":"19143","properties":{"name":"Osceola"}},{"type":"Polygon","arcs":[[-1320,3819,3820,3821,3822]],"id":"21189","properties":{"name":"Owsley"}},{"type":"Polygon","arcs":[[3823,3824,-1078,3825]],"id":"37181","properties":{"name":"Vance"}},{"type":"Polygon","arcs":[[-728,3826,3827,3828,3829,3830]],"id":"04007","properties":{"name":"Gila"}},{"type":"Polygon","arcs":[[3831,3832,3833,3834,-2278,-2263,3835]],"id":"05129","properties":{"name":"Searcy"}},{"type":"Polygon","arcs":[[3836,3837,3838,3839,3840,3841]],"id":"05095","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[3842,3843,-2460,-2874]],"id":"12133","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[3844,3845,-1775,3846,-2581,3847]],"id":"13217","properties":{"name":"Newton"}},{"type":"Polygon","arcs":[[3848,3849,3850,-3037,3851,3852]],"id":"12119","properties":{"name":"Sumter"}},{"type":"Polygon","arcs":[[-1584,3853,-2851,3854,-76,3855]],"id":"18031","properties":{"name":"Decatur"}},{"type":"Polygon","arcs":[[3856,3857,3858,-1034,-2819]],"id":"19065","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[3859,-778,-1872,-1239,-1862,-1883]],"id":"19099","properties":{"name":"Jasper"}},{"type":"Polygon","arcs":[[3860,3861,-1321,-3823,3862,3863,3864]],"id":"21109","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[3865,3866,3867,-3697,3868,3869]],"id":"22035","properties":{"name":"East Carroll"}},{"type":"Polygon","arcs":[[-853,3870,3871,3872,3873,3874]],"id":"22113","properties":{"name":"Vermilion"}},{"type":"Polygon","arcs":[[3875,3876,3877,3878,-850,3879]],"id":"22039","properties":{"name":"Evangeline"}},{"type":"Polygon","arcs":[[3880,-1701,-3614,-2454,3881,3882]],"id":"29063","properties":{"name":"DeKalb"}},{"type":"Polygon","arcs":[[-1304,3883,3884,3885,-2993,3886,3887]],"id":"29071","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[3888,3889,-3397,3890]],"id":"31097","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[3891,-673,3892,-3475,-2965,-589]],"id":"31183","properties":{"name":"Wheeler"}},{"type":"Polygon","arcs":[[3893,3894,3895,3896,-1625,-3754,3897]],"id":"35051","properties":{"name":"Sierra"}},{"type":"Polygon","arcs":[[3898,3899,3900,3901,3902,3903]],"id":"37107","properties":{"name":"Lenoir"}},{"type":"Polygon","arcs":[[3904,3905,3906,3907,3908,3909]],"id":"37045","properties":{"name":"Cleveland"}},{"type":"Polygon","arcs":[[3910,3911,3912,3913,3914]],"id":"31105","properties":{"name":"Kimball"}},{"type":"Polygon","arcs":[[3915,3916,-2237,3917,3918,3919]],"id":"40145","properties":{"name":"Wagoner"}},{"type":"Polygon","arcs":[[3920,3921,3922,3923]],"id":"40027","properties":{"name":"Cleveland"}},{"type":"Polygon","arcs":[[3924,3925,3926,-2392]],"id":"40099","properties":{"name":"Murray"}},{"type":"Polygon","arcs":[[3927,3928,3929,-1017]],"id":"42003","properties":{"name":"Allegheny"}},{"type":"Polygon","arcs":[[3930,3931,3932,-3084,3933,3934,3935]],"id":"45087","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[3936,-276,-2238,3937]],"id":"46065","properties":{"name":"Hughes"}},{"type":"Polygon","arcs":[[3938,3939,3940,3941,3942,3943]],"id":"21235","properties":{"name":"Whitley"}},{"type":"Polygon","arcs":[[3944,3945,-1072,3946,3947,3948]],"id":"37175","properties":{"name":"Transylvania"}},{"type":"Polygon","arcs":[[3949,3950,3951,3952,3953,3954,-3901]],"id":"37049","properties":{"name":"Craven"}},{"type":"Polygon","arcs":[[-2353,3955,-252,-2349,-409,-1075]],"id":"48253","properties":{"name":"Jones"}},{"type":"Polygon","arcs":[[3956]],"id":"51720","properties":{"name":"Norton"}},{"type":"Polygon","arcs":[[3957,3958,3959,3960,3961,3962]],"id":"39105","properties":{"name":"Meigs"}},{"type":"Polygon","arcs":[[3963,3964,-3963,3965,3966,3967]],"id":"39053","properties":{"name":"Gallia"}},{"type":"Polygon","arcs":[[3968,-3419,-2125,3969,3970,3971,3972,3973]],"id":"54025","properties":{"name":"Greenbrier"}},{"type":"MultiPolygon","arcs":[[[3974,3975]]],"id":"78030","properties":{"name":"St. Thomas"}},{"type":"Polygon","arcs":[[3976,3977,3978,-612,3979]],"id":"05111","properties":{"name":"Poinsett"}},{"type":"Polygon","arcs":[[3980,3981,3982,-2747,3983,3984]],"id":"06099","properties":{"name":"Stanislaus"}},{"type":"Polygon","arcs":[[3985,3986,3987,3988,3989]],"id":"06011","properties":{"name":"Colusa"}},{"type":"Polygon","arcs":[[3990,3991,3992,3993,3994]],"id":"13089","properties":{"name":"DeKalb"}},{"type":"Polygon","arcs":[[3995,3996,3997,3998,3999]],"id":"13311","properties":{"name":"White"}},{"type":"Polygon","arcs":[[4000,4001,4002,-769,4003,4004]],"id":"13115","properties":{"name":"Floyd"}},{"type":"Polygon","arcs":[[4005,-24,4006,4007,4008]],"id":"16047","properties":{"name":"Gooding"}},{"type":"Polygon","arcs":[[4009,-990,-1146,4010,4011,4012]],"id":"17141","properties":{"name":"Ogle"}},{"type":"Polygon","arcs":[[4013,4014,4015,-3738,4016]],"id":"30083","properties":{"name":"Richland"}},{"type":"Polygon","arcs":[[4017,4018,4019,4020,4021]],"id":"37065","properties":{"name":"Edgecombe"}},{"type":"Polygon","arcs":[[4022,4023,-634,-937,4024]],"id":"48421","properties":{"name":"Sherman"}},{"type":"Polygon","arcs":[[4025,4026,4027,4028,4029]],"id":"01017","properties":{"name":"Chambers"}},{"type":"Polygon","arcs":[[-1269,-1274,4030,4031,-2743,4032]],"id":"06003","properties":{"name":"Alpine"}},{"type":"Polygon","arcs":[[-2613,4033,4034,4035,-565,-3020,4036,4037]],"id":"06093","properties":{"name":"Siskiyou"}},{"type":"Polygon","arcs":[[4038,4039,4040,-1235]],"id":"08083","properties":{"name":"Montezuma"}},{"type":"Polygon","arcs":[[4041,4042,-2141,4043,4044,4045]],"id":"13213","properties":{"name":"Murray"}},{"type":"Polygon","arcs":[[4046,4047,4048,4049,4050,-3373]],"id":"16071","properties":{"name":"Oneida"}},{"type":"Polygon","arcs":[[4051,4052,4053,4054,4055,4056]],"id":"18129","properties":{"name":"Posey"}},{"type":"Polygon","arcs":[[4057,4058,4059,4060,4061,4062,4063,4064,4065]],"id":"21093","properties":{"name":"Hardin"}},{"type":"Polygon","arcs":[[-3790,4066,4067,-3874,4068,4069]],"id":"22023","properties":{"name":"Cameron"}},{"type":"Polygon","arcs":[[4070,4071,4072,4073,-1256]],"id":"20121","properties":{"name":"Miami"}},{"type":"Polygon","arcs":[[-2856,-1847,4074,4075,-3050]],"id":"16015","properties":{"name":"Boise"}},{"type":"Polygon","arcs":[[-2672,4076,4077,4078,4079,4080,4081]],"id":"16019","properties":{"name":"Bonneville"}},{"type":"Polygon","arcs":[[4082,4083,4084,4085,4086,4087,4088]],"id":"25023","properties":{"name":"Plymouth"}},{"type":"Polygon","arcs":[[4089,4090,4091,4092,4093,4094,4095,4096]],"id":"22077","properties":{"name":"Pointe Coupee"}},{"type":"Polygon","arcs":[[4097,4098,-1665,-202,4099]],"id":"26043","properties":{"name":"Dickinson"}},{"type":"Polygon","arcs":[[-2545,-1609,4100,4101,-1649,4102]],"id":"29097","properties":{"name":"Jasper"}},{"type":"Polygon","arcs":[[4103,-2651,4104,4105,4106,4107]],"id":"20189","properties":{"name":"Stevens"}},{"type":"Polygon","arcs":[[4108,4109,4110,4111,4112,4113]],"id":"17085","properties":{"name":"Jo Daviess"}},{"type":"Polygon","arcs":[[-3218,4114,-1817,4115,-1877,4116,4117]],"id":"17057","properties":{"name":"Fulton"}},{"type":"Polygon","arcs":[[4118,-761,4119,4120,4121,-393]],"id":"36055","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[4122,-3587,4123,-2905]],"id":"27075","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[4124,4125,4126,4127,-4128,4128,4129]],"id":"41037","properties":{"name":"Lake"}},{"type":"MultiPolygon","arcs":[[[4130,4131]],[[4132]],[[4133]]],"id":"44005","properties":{"name":"Newport"}},{"type":"Polygon","arcs":[[4134,4135,4136,4137,4138,4139,4140]],"id":"36043","properties":{"name":"Herkimer"}},{"type":"Polygon","arcs":[[4141,-3367,4142,4143,4144,4145,4146,4147]],"id":"35059","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[4148,4149,4150,4151,4152,4153]],"id":"48071","properties":{"name":"Chambers"}},{"type":"Polygon","arcs":[[4154,4155,4156,-3804,4157,-2484,4158,4159]],"id":"53047","properties":{"name":"Okanogan"}},{"type":"Polygon","arcs":[[4160,4161,4162,4163,-3619,4164]],"id":"01115","properties":{"name":"St. Clair"}},{"type":"Polygon","arcs":[[4165,4166,4167,4168,4169]],"id":"55059","properties":{"name":"Kenosha"}},{"type":"Polygon","arcs":[[-956,4170,4171,4172,-118,4173,4174]],"id":"72075","properties":{"name":"Juana DÃ­az"}},{"type":"Polygon","arcs":[[-430,-2796,4175,4176]],"id":"55077","properties":{"name":"Marquette"}},{"type":"Polygon","arcs":[[-441,4177,4178,4179,4180,-1461,-1491,4181]],"id":"55099","properties":{"name":"Price"}},{"type":"Polygon","arcs":[[4182,-2469,4183,4184]],"id":"72087","properties":{"name":"LoÃ­za"}},{"type":"Polygon","arcs":[[-2347,4185,4186,4187,-731,4188,4189]],"id":"16079","properties":{"name":"Shoshone"}},{"type":"Polygon","arcs":[[4190,4191,-1976,4192,4193,4194]],"id":"37027","properties":{"name":"Caldwell"}},{"type":"Polygon","arcs":[[4195,4196,4197,4198]],"id":"38065","properties":{"name":"Oliver"}},{"type":"Polygon","arcs":[[-3399,4199,4200,4201,4202,4203]],"id":"31147","properties":{"name":"Richardson"}},{"type":"Polygon","arcs":[[4204,4205,-2979,4206,-1603]],"id":"31145","properties":{"name":"Red Willow"}},{"type":"Polygon","arcs":[[4207,4208,4209,-3792,4210,4211]],"id":"48199","properties":{"name":"Hardin"}},{"type":"Polygon","arcs":[[4212,4213,-1093,4214,4215,4216,4217,4218]],"id":"01077","properties":{"name":"Lauderdale"}},{"type":"Polygon","arcs":[[-504,4219,4220,4221,-3348,4222,4223]],"id":"05007","properties":{"name":"Benton"}},{"type":"Polygon","arcs":[[4224,4225,-1827,-2813,-1168,4226,-2935]],"id":"17011","properties":{"name":"Bureau"}},{"type":"Polygon","arcs":[[-2152,-3600,4227,4228,4229,4230,4231,4232,-2224]],"id":"18053","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[-3408,-1605,-904,-2893,4233]],"id":"26113","properties":{"name":"Missaukee"}},{"type":"Polygon","arcs":[[-1355,-447,-1315,-1328,4234,-384]],"id":"26117","properties":{"name":"Montcalm"}},{"type":"Polygon","arcs":[[-1589,4235,-2291,-914]],"id":"29229","properties":{"name":"Wright"}},{"type":"Polygon","arcs":[[-1588,-3563,4236,-2314,-2321,4237,-2292,-4236]],"id":"29215","properties":{"name":"Texas"}},{"type":"Polygon","arcs":[[4238,4239,4240,4241,-3603]],"id":"29123","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[4242,4243,4244,-2159,-2511,4245,4246]],"id":"28085","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[4247,4248,4249,4250,4251]],"id":"35011","properties":{"name":"De Baca"}},{"type":"Polygon","arcs":[[4252,-4020,4253,4254,-3950,-3900,4255]],"id":"37147","properties":{"name":"Pitt"}},{"type":"Polygon","arcs":[[4256,-4198,4257,4258,4259,4260,4261]],"id":"38059","properties":{"name":"Morton"}},{"type":"Polygon","arcs":[[4262,4263,4264,4265,-95,4266,-3223]],"id":"39077","properties":{"name":"Huron"}},{"type":"Polygon","arcs":[[-2782,4267,-3919,4268,4269,4270]],"id":"40111","properties":{"name":"Okmulgee"}},{"type":"Polygon","arcs":[[4271,4272,4273,4274,4275,4276,4277,4278]],"id":"45041","properties":{"name":"Florence"}},{"type":"Polygon","arcs":[[4279,4280,4281,4282,4283]],"id":"45081","properties":{"name":"Saluda"}},{"type":"Polygon","arcs":[[4284,4285,-4058,4286,4287,4288]],"id":"21027","properties":{"name":"Breckinridge"}},{"type":"Polygon","arcs":[[-4055,4289,4290,4291,4292,4293]],"id":"21225","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[4294,4295,4296,-432,4297,4298]],"id":"21231","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[4299,-2774,4300,4301,4302,4303]],"id":"21211","properties":{"name":"Shelby"}},{"type":"Polygon","arcs":[[-3902,-3955,4304,-2449,4305]],"id":"37103","properties":{"name":"Jones"}},{"type":"Polygon","arcs":[[4306,4307,4308,4309,4310]],"id":"47105","properties":{"name":"Loudon"}},{"type":"Polygon","arcs":[[4311,4312,4313,-959,4314,4315]],"id":"48217","properties":{"name":"Hill"}},{"type":"Polygon","arcs":[[4316,4317,4318,4319,4320,4321,4322]],"id":"51087","properties":{"name":"Henrico"}},{"type":"Polygon","arcs":[[4323,4324,4325,-839,4326]],"id":"39019","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[-2741,4327,4328,4329,-396,4330]],"id":"38099","properties":{"name":"Walsh"}},{"type":"Polygon","arcs":[[4331,4332,4333,-2760,4334,-2021,-1463]],"id":"55067","properties":{"name":"Langlade"}},{"type":"Polygon","arcs":[[4335,4336,-1494,-2251,4337,4338]],"id":"55017","properties":{"name":"Chippewa"}},{"type":"Polygon","arcs":[[4339,4340,4341,4342,4343]],"id":"22101","properties":{"name":"St. Mary"}},{"type":"Polygon","arcs":[[4344,4345,4346,4347,4348]],"id":"72023","properties":{"name":"Cabo Rojo"}},{"type":"Polygon","arcs":[[4349,4350,4351,4352,4353,4354]],"id":"41009","properties":{"name":"Columbia"}},{"type":"Polygon","arcs":[[4355,4356,-2098,4357,4358,4359,-4126]],"id":"41025","properties":{"name":"Harney"}},{"type":"Polygon","arcs":[[4360,-1722,4361,4362,4363,4364]],"id":"48491","properties":{"name":"Williamson"}},{"type":"Polygon","arcs":[[4365,4366,4367,4368,-360]],"id":"49009","properties":{"name":"Daggett"}},{"type":"Polygon","arcs":[[4369,4370,-1915,4371,4372]],"id":"48271","properties":{"name":"Kinney"}},{"type":"Polygon","arcs":[[4373,-356,4374,4375,4376]],"id":"49029","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[4377,4378,-4379,4378,4379,4380,4381,4382,4383,4384,-4385,4384,-4385,4384,4385,4386,4387,4388,-4389,4388,4389,4390]],"id":"51620","properties":{"name":"Franklin"}},{"type":"MultiPolygon","arcs":[[[4391]],[[4392,4393,4394,4395,-1033,4396,-1878,4397,4398]]],"id":"08005","properties":{"name":"Arapahoe"}},{"type":"Polygon","arcs":[[4399,4400,4401,4402,4403,-4002,4404,4405]],"id":"13295","properties":{"name":"Walker"}},{"type":"Polygon","arcs":[[4406,4407,4408,4409,4410,4411]],"id":"18121","properties":{"name":"Parke"}},{"type":"Polygon","arcs":[[4412,-79,4413,4414,4415]],"id":"18143","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[-2844,4416,4417,4418,4419,4420]],"id":"21227","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[4421,4422,-1266,4423,4424]],"id":"22081","properties":{"name":"Red River"}},{"type":"Polygon","arcs":[[-3527,4425,4426,-1964,-1344,-3713]],"id":"27015","properties":{"name":"Brown"}},{"type":"Polygon","arcs":[[4427,4428,4429,4430,-1306,4431,4432]],"id":"29139","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[4433,-3746,4434,4435,4436,4437,4438,4439,-3978,4440]],"id":"05093","properties":{"name":"Mississippi"}},{"type":"Polygon","arcs":[[4441,4442,4443,4444,-1277,4445]],"id":"05049","properties":{"name":"Fulton"}},{"type":"Polygon","arcs":[[4446,4447,-4406,4448,4449,4450,4451]],"id":"01049","properties":{"name":"DeKalb"}},{"type":"Polygon","arcs":[[4452,4453,4454,-3495,4455,4456]],"id":"05127","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[-3277,-2614,-4038,4457,4458]],"id":"06015","properties":{"name":"Del Norte"}},{"type":"Polygon","arcs":[[4459,4460,-991,-4010,4461,-4111]],"id":"17177","properties":{"name":"Stephenson"}},{"type":"Polygon","arcs":[[4462,4463,4464,4465,4466,4467]],"id":"18025","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[4468,4469,4470,4471]],"id":"18043","properties":{"name":"Floyd"}},{"type":"Polygon","arcs":[[-3072,4472,4473,4474,4475,4476]],"id":"13179","properties":{"name":"Liberty"}},{"type":"Polygon","arcs":[[-23,4477,-3369,4478,-4007]],"id":"16053","properties":{"name":"Jerome"}},{"type":"Polygon","arcs":[[4479,4480,4481,4482,4483,4484,-4484,4485,4486]],"id":"24045","properties":{"name":"Wicomico"}},{"type":"Polygon","arcs":[[4487,4488,4489,4490]],"id":"26013","properties":{"name":"Baraga"}},{"type":"Polygon","arcs":[[4491,4492,4493,4494,4495,-1,4496,4497]],"id":"32017","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[4498,4499,4500,4501,4502]],"id":"34011","properties":{"name":"Cumberland"}},{"type":"Polygon","arcs":[[4503,4504,4505,4506]],"id":"18115","properties":{"name":"Ohio"}},{"type":"Polygon","arcs":[[4507,4508,4509,4510,4511,4512]],"id":"36061","properties":{"name":"New York"}},{"type":"Polygon","arcs":[[4513,4514,-4136,4515,4516,4517]],"id":"36089","properties":{"name":"St. Lawrence"}},{"type":"Polygon","arcs":[[4518,4519,-4247,4520,4521,4522]],"id":"28063","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[4523,-2721,4524,4525,4526,4527]],"id":"40023","properties":{"name":"Choctaw"}},{"type":"Polygon","arcs":[[4528,4529,4530,-2175,4531,4532,4533,4534,-3750]],"id":"17149","properties":{"name":"Pike"}},{"type":"Polygon","arcs":[[4535,4536,4537,4538,-2213]],"id":"19057","properties":{"name":"Des Moines"}},{"type":"Polygon","arcs":[[4539,4540,4541,-4015,4542,4543]],"id":"30085","properties":{"name":"Roosevelt"}},{"type":"Polygon","arcs":[[4544,4545,4546,4547,-1070,4548,4549,4550]],"id":"45007","properties":{"name":"Anderson"}},{"type":"Polygon","arcs":[[4551,4552,-2557,4553,4554]],"id":"46033","properties":{"name":"Custer"}},{"type":"Polygon","arcs":[[4555,-4438,4556,4557,4558,4559,4560]],"id":"47157","properties":{"name":"Shelby"}},{"type":"Polygon","arcs":[[4561,4562,4563,4564,4565]],"id":"34019","properties":{"name":"Hunterdon"}},{"type":"Polygon","arcs":[[4566,4567,-813,-3045,4568],[-1288]],"id":"51089","properties":{"name":"Henry"}},{"type":"Polygon","arcs":[[-2286,4569,4570,4571]],"id":"51650","properties":{"name":"Hampton"}},{"type":"Polygon","arcs":[[4572,4573,-300,-2562,4574,4575]],"id":"30071","properties":{"name":"Phillips"}},{"type":"Polygon","arcs":[[4576,4577,4578,4579,4580,4581,-3429]],"id":"13161","properties":{"name":"Jeff Davis"}},{"type":"Polygon","arcs":[[4582,-4080,4583,4584,4585,4586,4587,4588]],"id":"56023","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[4589,4590,4591,4592,4593]],"id":"01063","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[4594,4595,4596,4597]],"id":"05061","properties":{"name":"Howard"}},{"type":"Polygon","arcs":[[4598,4599,4600,-2123]],"id":"51091","properties":{"name":"Highland"}},{"type":"Polygon","arcs":[[4601,4602,4603,4604]],"id":"51101","properties":{"name":"King William"}},{"type":"MultiPolygon","arcs":[[[4605]],[[4606,4607,-439,4608]]],"id":"55007","properties":{"name":"Bayfield"}},{"type":"Polygon","arcs":[[4609,4610,4611,4612,-2839,4613,4614,4615]],"id":"55123","properties":{"name":"Vernon"}},{"type":"Polygon","arcs":[[-672,4616,4617,-234,-3476,-3893]],"id":"31011","properties":{"name":"Boone"}},{"type":"Polygon","arcs":[[-4202,4618,4619,4620,4621,4622]],"id":"20043","properties":{"name":"Doniphan"}},{"type":"Polygon","arcs":[[-2967,-3477,-795,-2656,-596]],"id":"31163","properties":{"name":"Sherman"}},{"type":"Polygon","arcs":[[4623,4624,4625,-2663,4626]],"id":"32021","properties":{"name":"Mineral"}},{"type":"Polygon","arcs":[[4627,4628,4629,4630,-1402]],"id":"47083","properties":{"name":"Houston"}},{"type":"MultiPolygon","arcs":[[[-3781,4631]],[[4632,4633,4634,-3777,4635,4636,4637]]],"id":"48057","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[4638,-4005,4639,4640,4641,4642,-4450]],"id":"01019","properties":{"name":"Cherokee"}},{"type":"Polygon","arcs":[[-1475,-3582,4643,4644,4645,4646,4647]],"id":"30111","properties":{"name":"Yellowstone"}},{"type":"Polygon","arcs":[[-793,4648,4649,-1969,-2657]],"id":"31079","properties":{"name":"Hall"}},{"type":"Polygon","arcs":[[4650,4651,4652,-3091,4653]],"id":"31017","properties":{"name":"Brown"}},{"type":"Polygon","arcs":[[4654,-2948,4655,4656]],"id":"35061","properties":{"name":"Valencia"}},{"type":"Polygon","arcs":[[4657,4658,4659,4660,-2944,4661]],"id":"35047","properties":{"name":"San Miguel"}},{"type":"Polygon","arcs":[[4662,-3046,-3131,4663,4664,-1308]],"id":"37067","properties":{"name":"Forsyth"}},{"type":"Polygon","arcs":[[4665,4666,-3904,4667,4668,4669]],"id":"37191","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[4670,4671,4672,4673,4674]],"id":"37017","properties":{"name":"Bladen"}},{"type":"Polygon","arcs":[[4675,4676,-1534,4677,4678,4679,-2653,-1985]],"id":"30059","properties":{"name":"Meagher"}},{"type":"Polygon","arcs":[[4680,4681,-3865,4682,4683,4684]],"id":"21203","properties":{"name":"Rockcastle"}},{"type":"Polygon","arcs":[[4685,4686,-4284,4687,4688,4689]],"id":"45047","properties":{"name":"Greenwood"}},{"type":"Polygon","arcs":[[4690,4691,-4289,4692,4693]],"id":"21091","properties":{"name":"Hancock"}},{"type":"Polygon","arcs":[[4694,4695,4696,4697,4698,4699,4700]],"id":"21045","properties":{"name":"Casey"}},{"type":"Polygon","arcs":[[4701,4702,4703,4704,4705]],"id":"21113","properties":{"name":"Jessamine"}},{"type":"Polygon","arcs":[[4706,4707,-1067,4708]],"id":"37149","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[4709,4710,4711,4712,4713]],"id":"37121","properties":{"name":"Mitchell"}},{"type":"Polygon","arcs":[[4714,4715,4716,4717,4718,4719]],"id":"37053","properties":{"name":"Currituck"}},{"type":"MultiPolygon","arcs":[[[-2438]],[[4720,4721,4722,4723,-3609,-2436,-3608]]],"id":"51121","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[-4322,4724]],"id":"51760","properties":{"name":"Richmond"}},{"type":"Polygon","arcs":[[-3806,-1107,4725,4726,4727,4728]],"id":"53021","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-2475,4729,4730,-3471,-3284]],"id":"72105","properties":{"name":"Naranjito"}},{"type":"Polygon","arcs":[[4731,-2396,4732,4733,4734,-3726]],"id":"40067","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[4735,4736,4737,4738,4739,4740,4741]],"id":"47091","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[4742,4743,4744,4745,4746]],"id":"47121","properties":{"name":"Meigs"}},{"type":"Polygon","arcs":[[-544,4747,-127,4748,-2239]],"id":"46015","properties":{"name":"Brule"}},{"type":"Polygon","arcs":[[4749,4750,4751,4752,4753,-4313,4754]],"id":"48139","properties":{"name":"Ellis"}},{"type":"Polygon","arcs":[[-3727,-4735,4755,-1115,4756,4757]],"id":"48077","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[4758,4759,-3802,4760,4761,4762]],"id":"51009","properties":{"name":"Amherst"}},{"type":"Polygon","arcs":[[4763,-1861,-617,4764]],"id":"08079","properties":{"name":"Mineral"}},{"type":"Polygon","arcs":[[4765,4766,4767,4768,4769,4770,4771,4772]],"id":"13107","properties":{"name":"Emanuel"}},{"type":"Polygon","arcs":[[-4117,-1876,-1254,4773,4774,4775]],"id":"17125","properties":{"name":"Mason"}},{"type":"Polygon","arcs":[[-1840,-1842,-779,-3860,-1882,-1110]],"id":"19169","properties":{"name":"Story"}},{"type":"Polygon","arcs":[[4776,4777,-3633,4778]],"id":"19149","properties":{"name":"Plymouth"}},{"type":"Polygon","arcs":[[4779,4780,4781,4782,4783]],"id":"20173","properties":{"name":"Sedgwick"}},{"type":"Polygon","arcs":[[4784,-3125,4785,-2770,-4300,4786]],"id":"21103","properties":{"name":"Henry"}},{"type":"Polygon","arcs":[[4787,4788,4789]],"id":"22089","properties":{"name":"St. Charles"}},{"type":"Polygon","arcs":[[-4217,4790,4791,4792]],"id":"01033","properties":{"name":"Colbert"}},{"type":"Polygon","arcs":[[4793,4794,4795,4796,-286,4797,4798]],"id":"04019","properties":{"name":"Pima"}},{"type":"Polygon","arcs":[[4799,4800,-3756,4801,4802,4803]],"id":"04011","properties":{"name":"Greenlee"}},{"type":"Polygon","arcs":[[4804,4805,-615,4806,-3837,4807]],"id":"05147","properties":{"name":"Woodruff"}},{"type":"Polygon","arcs":[[-1836,4808,4809,4810]],"id":"12099","properties":{"name":"Palm Beach"}},{"type":"Polygon","arcs":[[4811,4812,4813,4814,4815]],"id":"13127","properties":{"name":"Glynn"}},{"type":"Polygon","arcs":[[4816,-3215,4817,4818,-710]],"id":"19007","properties":{"name":"Appanoose"}},{"type":"Polygon","arcs":[[4819,4820,-4114,4821,-2678,-966]],"id":"19061","properties":{"name":"Dubuque"}},{"type":"Polygon","arcs":[[4822,4823,4824,4825,-3488,4826]],"id":"21057","properties":{"name":"Cumberland"}},{"type":"MultiPolygon","arcs":[[[4827,4828,4829,4830,4831,-4340,4832,-3872]],[[4833]]],"id":"22045","properties":{"name":"Iberia"}},{"type":"Polygon","arcs":[[4834,4835,4836,-1186]],"id":"17101","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[4837,4838,4839]],"id":"24037","properties":{"name":"St. Mary's"}},{"type":"Polygon","arcs":[[4840,4841,4842,4843,4844,4845]],"id":"22033","properties":{"name":"East Baton Rouge"}},{"type":"Polygon","arcs":[[4846,4847,4848,4849]],"id":"22043","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[-1352,-381,-1356,4850]],"id":"26127","properties":{"name":"Oceana"}},{"type":"Polygon","arcs":[[4851,4852,4853,4854,-3889,4855]],"id":"31131","properties":{"name":"Otoe"}},{"type":"Polygon","arcs":[[4856,-4169,4857,4858,4859,-1141,4860]],"id":"17111","properties":{"name":"McHenry"}},{"type":"Polygon","arcs":[[4861,4862,4863,4864,-3410,-2646]],"id":"20183","properties":{"name":"Smith"}},{"type":"Polygon","arcs":[[-4860,4865,4866,-1572,-1142]],"id":"17089","properties":{"name":"Kane"}},{"type":"Polygon","arcs":[[-3896,4867,4868,4869,4870,4871,4872,4873]],"id":"35035","properties":{"name":"Otero"}},{"type":"Polygon","arcs":[[4874,4875,-4467,4876,-4285,-4692]],"id":"18123","properties":{"name":"Perry"}},{"type":"Polygon","arcs":[[-4836,4877,4878,-3453,4879,4880,4881,4882]],"id":"18083","properties":{"name":"Knox"}},{"type":"Polygon","arcs":[[4883,4884,4885,4886,4887]],"id":"42049","properties":{"name":"Erie"}},{"type":"Polygon","arcs":[[4888,4889,4890,4891,4892]],"id":"45019","properties":{"name":"Charleston"}},{"type":"Polygon","arcs":[[-3908,4893,4894,4895,4896,4897,4898,4899,-4899,4898,4900,-3081,-3933,4901]],"id":"45091","properties":{"name":"York"}},{"type":"Polygon","arcs":[[4902,4903,4904,4905,4906]],"id":"45053","properties":{"name":"Jasper"}},{"type":"Polygon","arcs":[[4907,4908,4909,4910,4911,4912,4913,4914]],"id":"36071","properties":{"name":"Orange"}},{"type":"Polygon","arcs":[[4915,4916,4917,-3665,4918]],"id":"50025","properties":{"name":"Windham"}},{"type":"Polygon","arcs":[[-4802,-3755,-1628,4919,4920]],"id":"35023","properties":{"name":"Hidalgo"}},{"type":"Polygon","arcs":[[4921,4922,4923,-4657,4924,4925,4926]],"id":"35006","properties":{"name":"Cibola"}},{"type":"Polygon","arcs":[[-2446,4927,4928,4929,4930,4931,4932]],"id":"54055","properties":{"name":"Mercer"}},{"type":"Polygon","arcs":[[4933,4934,4935,-2424,-3289,4936]],"id":"54051","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[4937,4938,4939,4940,4941,-2766,4942]],"id":"01101","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[4943,-4451,-4643,4944,-4161,4945]],"id":"01055","properties":{"name":"Etowah"}},{"type":"Polygon","arcs":[[4946,-4792,4947,-2988,4948,4949]],"id":"01059","properties":{"name":"Franklin"}},{"type":"MultiPolygon","arcs":[[[-521,-2419,4950,4951,-2073,4952,4953,4954,4955]],[[4956]],[[4957]],[[4958]]],"id":"02050","properties":{"name":"Bethel"}},{"type":"Polygon","arcs":[[4959,-43,4960,4961,4962,4963,-4552]],"id":"46103","properties":{"name":"Pennington"}},{"type":"Polygon","arcs":[[4964,4965,-610,4966,-1449,4967]],"id":"46115","properties":{"name":"Spink"}},{"type":"Polygon","arcs":[[4968,4969,-4779,-3638,4970,4971,4972]],"id":"46127","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[4973,4974,4975,-4904]],"id":"45013","properties":{"name":"Beaufort"}},{"type":"Polygon","arcs":[[4976,4977,4978,4979,4980,4981]],"id":"47029","properties":{"name":"Cocke"}},{"type":"Polygon","arcs":[[4982,4983,4984,-4566,4985,4986,4987,4988]],"id":"42017","properties":{"name":"Bucks"}},{"type":"Polygon","arcs":[[-1422,4989,4990,4991]],"id":"46009","properties":{"name":"Bon Homme"}},{"type":"Polygon","arcs":[[-4630,4992,4993,4994,4995,4996]],"id":"47043","properties":{"name":"Dickson"}},{"type":"Polygon","arcs":[[4997,4998,4999,5000,5001]],"id":"40105","properties":{"name":"Nowata"}},{"type":"Polygon","arcs":[[5002,-2384,-2371,5003,-4752,5004]],"id":"48257","properties":{"name":"Kaufman"}},{"type":"Polygon","arcs":[[5005,5006,-1099,-3239,-1801,-281]],"id":"48155","properties":{"name":"Foard"}},{"type":"Polygon","arcs":[[5007,5008,-4346]],"id":"72067","properties":{"name":"Hormigueros"}},{"type":"Polygon","arcs":[[5009,5010,5011,5012,5013]],"id":"23023","properties":{"name":"Sagadahoc"}},{"type":"Polygon","arcs":[[5014,5015,-2379,5016,5017,5018]],"id":"48085","properties":{"name":"Collin"}},{"type":"Polygon","arcs":[[-2917,-3035,-703,5019,-1711]],"id":"48093","properties":{"name":"Comanche"}},{"type":"Polygon","arcs":[[-723,5020,5021,-2316,-256]],"id":"48095","properties":{"name":"Concho"}},{"type":"Polygon","arcs":[[5022,-2727,5023,5024,5025]],"id":"48103","properties":{"name":"Crane"}},{"type":"Polygon","arcs":[[5026,5027,5028,5029,5030,-4870]],"id":"35015","properties":{"name":"Eddy"}},{"type":"Polygon","arcs":[[5031,5032,5033,-2315,-4237,-3562]],"id":"29161","properties":{"name":"Phelps"}},{"type":"Polygon","arcs":[[5034,5035,5036,-2267,5037,-4454]],"id":"05083","properties":{"name":"Logan"}},{"type":"Polygon","arcs":[[-2456,-3616,5038,5039,5040,5041]],"id":"29177","properties":{"name":"Ray"}},{"type":"Polygon","arcs":[[5042,-2661,5043,5044,-2003,5045,5046,-1159]],"id":"06027","properties":{"name":"Inyo"}},{"type":"Polygon","arcs":[[5047,5048,-3174,5049,5050]],"id":"42005","properties":{"name":"Armstrong"}},{"type":"Polygon","arcs":[[5051,-2972,5052,5053,-3906,5054]],"id":"37109","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-4981,5055,5056,-3945,5057,5058,5059]],"id":"37087","properties":{"name":"Haywood"}},{"type":"Polygon","arcs":[[5060,5061,-2710,5062,5063,5064,5065]],"id":"47057","properties":{"name":"Grainger"}},{"type":"Polygon","arcs":[[5066,5067,5068,5069,5070]],"id":"42023","properties":{"name":"Cameron"}},{"type":"Polygon","arcs":[[-109,5071,-4973,5072,5073,5074]],"id":"46027","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[5075,5076,5077,5078,5079]],"id":"42025","properties":{"name":"Carbon"}},{"type":"Polygon","arcs":[[5080,5081,5082,5083,5084,5085]],"id":"45025","properties":{"name":"Chesterfield"}},{"type":"Polygon","arcs":[[5086,5087,-4889,5088]],"id":"45035","properties":{"name":"Dorchester"}},{"type":"Polygon","arcs":[[5089,5090,5091,5092,5093,5094,-1593]],"id":"29041","properties":{"name":"Chariton"}},{"type":"Polygon","arcs":[[5095,5096,-2579,5097,5098]],"id":"50011","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[5099,5100,-5071,5101,-3171,5102]],"id":"42047","properties":{"name":"Elk"}},{"type":"Polygon","arcs":[[5103,5104,5105]],"id":"51115","properties":{"name":"Mathews"}},{"type":"Polygon","arcs":[[5106,5107,5108,5109,-3560,5110,5111]],"id":"29131","properties":{"name":"Miller"}},{"type":"Polygon","arcs":[[-304,5112,5113,5114,5115,5116]],"id":"30017","properties":{"name":"Custer"}},{"type":"Polygon","arcs":[[-5116,5117,5118,5119,5120,5121,5122]],"id":"30075","properties":{"name":"Powder River"}},{"type":"Polygon","arcs":[[5123,-1341,5124,5125,5126]],"id":"21107","properties":{"name":"Hopkins"}},{"type":"Polygon","arcs":[[5127,-2269,5128,5129,5130]],"id":"26003","properties":{"name":"Alger"}},{"type":"Polygon","arcs":[[5131,5132,5133,5134,5135]],"id":"21115","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[-1177,5136,-3512,5137,5138]],"id":"17041","properties":{"name":"Douglas"}},{"type":"Polygon","arcs":[[5139,5140,5141,5142,5143,5144]],"id":"21119","properties":{"name":"Knott"}},{"type":"Polygon","arcs":[[5145,-662,5146,-4781,5147]],"id":"20079","properties":{"name":"Harvey"}},{"type":"Polygon","arcs":[[5148,-3241,5149]],"id":"29510","properties":{"name":"St. Louis"}},{"type":"Polygon","arcs":[[-3516,5150,5151,5152,-330,5153]],"id":"42009","properties":{"name":"Bedford"}},{"type":"Polygon","arcs":[[-4203,-4623,5154,-2205,5155]],"id":"20013","properties":{"name":"Brown"}},{"type":"Polygon","arcs":[[5156,5157,5158,5159,5160,5161,5162,5163]],"id":"05099","properties":{"name":"Nevada"}},{"type":"Polygon","arcs":[[-3500,5164,-5158,5165,-4595]],"id":"05109","properties":{"name":"Pike"}},{"type":"Polygon","arcs":[[5166,5167,5168,5169,5170]],"id":"51730","properties":{"name":"Petersburg"}},{"type":"Polygon","arcs":[[-4534,5171,5172,-4430,5173,5174]],"id":"29163","properties":{"name":"Pike"}},{"type":"Polygon","arcs":[[-3027,5175,5176,5177,5178]],"id":"17083","properties":{"name":"Jersey"}},{"type":"Polygon","arcs":[[5179,-4277,5180,5181,5182,5183]],"id":"45027","properties":{"name":"Clarendon"}},{"type":"Polygon","arcs":[[-2709,-1634,5184,-1489,5185,5186,-5063]],"id":"47073","properties":{"name":"Hawkins"}},{"type":"Polygon","arcs":[[5187,5188,5189,-1192,-1468]],"id":"47077","properties":{"name":"Henderson"}},{"type":"Polygon","arcs":[[-5084,5190,-4272,5191,5192]],"id":"45031","properties":{"name":"Darlington"}},{"type":"Polygon","arcs":[[-3542,5193,5194,5195,5196,5197]],"id":"42029","properties":{"name":"Chester"}},{"type":"Polygon","arcs":[[5198,5199,5200,5201,-4274]],"id":"45033","properties":{"name":"Dillon"}},{"type":"Polygon","arcs":[[5202,-3169,-5049,5203,-1683]],"id":"42031","properties":{"name":"Clarion"}},{"type":"Polygon","arcs":[[5204,-4100,-201,5205]],"id":"55037","properties":{"name":"Florence"}},{"type":"Polygon","arcs":[[5206,-5103,-3170,-5203,-1682]],"id":"42053","properties":{"name":"Forest"}},{"type":"Polygon","arcs":[[5207,5208,5209,5210,5211]],"id":"13049","properties":{"name":"Charlton"}},{"type":"Polygon","arcs":[[-619,-166,5212,5213,5214,5215,5216,5217]],"id":"35039","properties":{"name":"Rio Arriba"}},{"type":"Polygon","arcs":[[5218,-4425,5219,5220,5221,-1102]],"id":"22031","properties":{"name":"De Soto"}},{"type":"Polygon","arcs":[[-3592,5222,5223,5224,-2666]],"id":"37063","properties":{"name":"Durham"}},{"type":"Polygon","arcs":[[5225,5226,-4922,5227]],"id":"35031","properties":{"name":"McKinley"}},{"type":"Polygon","arcs":[[5228,5229,5230,5231,5232]],"id":"24013","properties":{"name":"Carroll"}},{"type":"MultiPolygon","arcs":[[[5233,5234]],[[-5197,5235,5236,5237,5238,5239,5240,5241]]],"id":"10003","properties":{"name":"New Castle"}},{"type":"Polygon","arcs":[[5242,5243,-3323,5244,-2955]],"id":"20023","properties":{"name":"Cheyenne"}},{"type":"Polygon","arcs":[[5245,5246,5247,5248,5249,-4581]],"id":"13001","properties":{"name":"Appling"}},{"type":"Polygon","arcs":[[5250,5251,5252,-4938,5253,-3380]],"id":"01051","properties":{"name":"Elmore"}},{"type":"Polygon","arcs":[[5254,5255,-4039,-1234]],"id":"08033","properties":{"name":"Dolores"}},{"type":"Polygon","arcs":[[5256,-2261,5257,5258]],"id":"27069","properties":{"name":"Kittson"}},{"type":"Polygon","arcs":[[5259,-1747,5260,5261,-3787,-4210,5262]],"id":"48241","properties":{"name":"Jasper"}},{"type":"Polygon","arcs":[[5263,5264,5265,-4891,5266,5267]],"id":"45043","properties":{"name":"Georgetown"}},{"type":"Polygon","arcs":[[5268,-3730,5269,5270,-4853]],"id":"19071","properties":{"name":"Fremont"}},{"type":"Polygon","arcs":[[5271,-4775,5272,5273,5274,5275]],"id":"17017","properties":{"name":"Cass"}},{"type":"Polygon","arcs":[[5276,5277,5278,-4916,5279,5280,5281]],"id":"50027","properties":{"name":"Windsor"}},{"type":"Polygon","arcs":[[5282,-2166,5283,5284,-4196,5285,5286,5287]],"id":"38055","properties":{"name":"McLean"}},{"type":"Polygon","arcs":[[5288,-4256,-3899,-4667]],"id":"37079","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[5289,5290,5291,5292,5293]],"id":"17127","properties":{"name":"Massac"}},{"type":"MultiPolygon","arcs":[[[5294,5295]],[[5296,-1001,5297,-4480,5298]]],"id":"24019","properties":{"name":"Dorchester"}},{"type":"Polygon","arcs":[[5299,-4189,-730,5300]],"id":"16055","properties":{"name":"Kootenai"}},{"type":"Polygon","arcs":[[5301,5302,5303,5304]],"id":"09007","properties":{"name":"Middlesex"}},{"type":"Polygon","arcs":[[5305,-2799,-2677,-897,5306,-3128,5307]],"id":"18039","properties":{"name":"Elkhart"}},{"type":"Polygon","arcs":[[5308,-1210,-3144,-2899,5309,5310]],"id":"20071","properties":{"name":"Greeley"}},{"type":"Polygon","arcs":[[5311,-5275,5312,-3023,5313,-2173,-4531]],"id":"17137","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[5314,5315,5316,-3940]],"id":"21121","properties":{"name":"Knox"}},{"type":"Polygon","arcs":[[5317,-713,5318,5319,-1148]],"id":"19053","properties":{"name":"Decatur"}},{"type":"Polygon","arcs":[[5320,5321,5322,5323,5324,-5132,5325]],"id":"21127","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[5326,5327,-564,-3813,5328,5329]],"id":"54001","properties":{"name":"Barbour"}},{"type":"Polygon","arcs":[[5330,5331,-3669,5332,5333,5334,5335,5336]],"id":"25003","properties":{"name":"Berkshire"}},{"type":"Polygon","arcs":[[5337,-4428,5338,5339,5340]],"id":"29027","properties":{"name":"Callaway"}},{"type":"Polygon","arcs":[[5341,5342,5343,5344,5345,5346]],"id":"27073","properties":{"name":"Lac qui Parle"}},{"type":"Polygon","arcs":[[-2862,5347,-4317,5348,-3393,5349]],"id":"51075","properties":{"name":"Goochland"}},{"type":"Polygon","arcs":[[5350,5351,5352,-4585]],"id":"56035","properties":{"name":"Sublette"}},{"type":"Polygon","arcs":[[-4050,5353,5354,5355,5356]],"id":"49005","properties":{"name":"Cache"}},{"type":"Polygon","arcs":[[-1245,5357,-2304,-2343,5358]],"id":"30053","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[5359,5360,5361,5362,5363,5364,5365]],"id":"12001","properties":{"name":"Alachua"}},{"type":"Polygon","arcs":[[-4704,5366,5367,5368,-3861,-4682,5369]],"id":"21151","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[5370,5371,5372,-2791,5373,5374,-1929]],"id":"48177","properties":{"name":"Gonzales"}},{"type":"Polygon","arcs":[[5375,5376,-674,-3892,-588,5377,5378]],"id":"31089","properties":{"name":"Holt"}},{"type":"Polygon","arcs":[[5379,5380,5381,-4670,5382,5383]],"id":"37101","properties":{"name":"Johnston"}},{"type":"Polygon","arcs":[[5384,-2937,-1813,5385,5386,-4537,5387]],"id":"17131","properties":{"name":"Mercer"}},{"type":"Polygon","arcs":[[-478,5388,5389,5390,-3858,5391]],"id":"19191","properties":{"name":"Winneshiek"}},{"type":"Polygon","arcs":[[-1558,-1470,5392,5393,5394,5395]],"id":"47075","properties":{"name":"Haywood"}},{"type":"Polygon","arcs":[[5396,5397,-335,5398,5399,5400]],"id":"24023","properties":{"name":"Garrett"}},{"type":"Polygon","arcs":[[5401,-5401,5402,-561,-5328,5403,5404]],"id":"54077","properties":{"name":"Preston"}},{"type":"Polygon","arcs":[[5405,5406,5407,-4491,5408,5409]],"id":"26061","properties":{"name":"Houghton"}},{"type":"MultiPolygon","arcs":[[[5410,-5395,5411,-4557,-4437]],[[-4439,-4556,5412]]],"id":"47167","properties":{"name":"Tipton"}},{"type":"Polygon","arcs":[[-1134,5413,5414,-2703,5415]],"id":"26065","properties":{"name":"Ingham"}},{"type":"Polygon","arcs":[[-4783,5416,5417,5418,5419,5420]],"id":"20191","properties":{"name":"Sumner"}},{"type":"Polygon","arcs":[[5421,5422,5423,5424,5425,5426,5427]],"id":"21135","properties":{"name":"Lewis"}},{"type":"Polygon","arcs":[[-4211,-3791,-4070,5428,-4150,5429]],"id":"48245","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[5430,5431,-3644,5432,5433]],"id":"31177","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[5434,5435,5436,-497,5437,5438,5439,5440]],"id":"53039","properties":{"name":"Klickitat"}},{"type":"Polygon","arcs":[[5441,-3751,-4535,-5175,5442]],"id":"29173","properties":{"name":"Ralls"}},{"type":"Polygon","arcs":[[-1483,5443,5444,5445,-472,5446]],"id":"56001","properties":{"name":"Albany"}},{"type":"Polygon","arcs":[[5447,5448,-2410,5449,-2858,5450,5451,5452],[-1471]],"id":"51003","properties":{"name":"Albemarle"}},{"type":"Polygon","arcs":[[-5040,5453,5454,-1991,5455,5456]],"id":"29107","properties":{"name":"Lafayette"}},{"type":"Polygon","arcs":[[5457,5458,-5032,-3561,-5110]],"id":"29125","properties":{"name":"Maries"}},{"type":"Polygon","arcs":[[5459,-5339,-4433,5460,-5458,-5109]],"id":"29151","properties":{"name":"Osage"}},{"type":"Polygon","arcs":[[-3159,-1948,-3168,-1360,5461,5462]],"id":"27161","properties":{"name":"Waseca"}},{"type":"Polygon","arcs":[[5463,5464,5465,5466,-4542,5467]],"id":"38105","properties":{"name":"Williams"}},{"type":"Polygon","arcs":[[-3799,5468,-3396,5469,5470,5471,5472]],"id":"51147","properties":{"name":"Prince Edward"}},{"type":"Polygon","arcs":[[5473,-5241,5474,5475,5476]],"id":"24029","properties":{"name":"Kent"}},{"type":"Polygon","arcs":[[5477,-3219,-4118,-4776,-5272,5478,5479]],"id":"17169","properties":{"name":"Schuyler"}},{"type":"Polygon","arcs":[[5480,5481,5482,5483,5484,-3759]],"id":"24031","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[-1194,5485,5486,5487]],"id":"47109","properties":{"name":"McNairy"}},{"type":"Polygon","arcs":[[5488,5489,5490,-1260,5491]],"id":"22119","properties":{"name":"Webster"}},{"type":"Polygon","arcs":[[5492,5493,5494]],"id":"37129","properties":{"name":"New Hanover"}},{"type":"Polygon","arcs":[[-5409,-4490,5495,-4098,-5205,5496,5497,-3686,5498]],"id":"26071","properties":{"name":"Iron"}},{"type":"Polygon","arcs":[[-5292,5499,5500,5501,5502,5503,5504,5505]],"id":"21139","properties":{"name":"Livingston"}},{"type":"Polygon","arcs":[[5506,-1271,5507,-3982,5508,5509]],"id":"06077","properties":{"name":"San Joaquin"}},{"type":"Polygon","arcs":[[5510,-5293,-5506,5511,-3480,5512,5513]],"id":"21145","properties":{"name":"McCracken"}},{"type":"Polygon","arcs":[[5514,5515,-4974,-4903,5516,5517]],"id":"45049","properties":{"name":"Hampton"}},{"type":"Polygon","arcs":[[-1658,-1064,5518,5519,5520]],"id":"31037","properties":{"name":"Colfax"}},{"type":"MultiPolygon","arcs":[[[5521]]],"id":"78010","properties":{"name":"St. Croix"}},{"type":"Polygon","arcs":[[5522,-2654,-4680,5523,-1505,5524,5525,5526]],"id":"30031","properties":{"name":"Gallatin"}},{"type":"Polygon","arcs":[[-1404,5527,5528,-1460,5529,5530]],"id":"47135","properties":{"name":"Perry"}},{"type":"Polygon","arcs":[[5531,-4075,-1846,-3650,5532,-4009,5533,5534]],"id":"16039","properties":{"name":"Elmore"}},{"type":"Polygon","arcs":[[-2609,5535,5536,5537,5538]],"id":"31013","properties":{"name":"Box Butte"}},{"type":"MultiPolygon","arcs":[[[5539,-4089,5540,-4131,5541,5542,5543]]],"id":"25005","properties":{"name":"Bristol"}},{"type":"Polygon","arcs":[[-1187,-4837,-4883,5544,5545,5546]],"id":"17185","properties":{"name":"Wabash"}},{"type":"Polygon","arcs":[[5547,5548,5549,5550,5551,5552]],"id":"21095","properties":{"name":"Harlan"}},{"type":"Polygon","arcs":[[5553,5554,5555,-1089,5556,-1457]],"id":"47119","properties":{"name":"Maury"}},{"type":"Polygon","arcs":[[5557,5558,-4067,-3789,5559]],"id":"22019","properties":{"name":"Calcasieu"}},{"type":"Polygon","arcs":[[5560,-2667,-5225,5561,5562,5563,5564,-1203]],"id":"37037","properties":{"name":"Chatham"}},{"type":"Polygon","arcs":[[-976,5565,-560,5566,5567]],"id":"48127","properties":{"name":"Dimmit"}},{"type":"Polygon","arcs":[[-5135,5568,-5140,5569,5570,5571]],"id":"21153","properties":{"name":"Magoffin"}},{"type":"Polygon","arcs":[[-4376,5572,5573,5574]],"id":"49011","properties":{"name":"Davis"}},{"type":"Polygon","arcs":[[5575,5576,5577,5578]],"id":"49031","properties":{"name":"Piute"}},{"type":"Polygon","arcs":[[-5325,5579,5580,5581,5582,-5133]],"id":"21159","properties":{"name":"Martin"}},{"type":"Polygon","arcs":[[5583,5584,-4616,5585,-5390,5586]],"id":"27055","properties":{"name":"Houston"}},{"type":"Polygon","arcs":[[5587,5588,5589,-4352]],"id":"53011","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[5590,5591,5592,5593]],"id":"55089","properties":{"name":"Ozaukee"}},{"type":"Polygon","arcs":[[5594,-1987,-2655,-5523,5595,5596,5597]],"id":"30043","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[5598,-4982,-5060,5599,5600,5601]],"id":"47155","properties":{"name":"Sevier"}},{"type":"Polygon","arcs":[[-2182,5602,-3000,5603,5604]],"id":"72057","properties":{"name":"Guayama"}},{"type":"Polygon","arcs":[[5605,5606,5607,5608]],"id":"32011","properties":{"name":"Eureka"}},{"type":"Polygon","arcs":[[5609,5610,5611,-1262,5612]],"id":"22061","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[5613,5614,5615,-5610,5616]],"id":"22111","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[5617,5618,5619,5620]],"id":"33001","properties":{"name":"Belknap"}},{"type":"Polygon","arcs":[[-1954,-2429,5621,5622,5623]],"id":"05011","properties":{"name":"Bradley"}},{"type":"Polygon","arcs":[[5624,5625,5626,-1601,5627,-155]],"id":"31085","properties":{"name":"Hayes"}},{"type":"Polygon","arcs":[[5628,5629,5630,5631,5632,5633,5634,5635,5636]],"id":"42097","properties":{"name":"Northumberland"}},{"type":"MultiPolygon","arcs":[[[5637,-1002,-5297,5638]],[[5639]]],"id":"24041","properties":{"name":"Talbot"}},{"type":"Polygon","arcs":[[5640,5641,5642,-2958]],"id":"19041","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[5643,5644,5645,-2135,-4043,5646]],"id":"47139","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[5647,5648,-2209,5649,5650,5651]],"id":"20149","properties":{"name":"Pottawatomie"}},{"type":"Polygon","arcs":[[5652,5653,5654]],"id":"24510","properties":{"name":"Baltimore"}},{"type":"Polygon","arcs":[[5655,5656,-5014,5657,5658]],"id":"23001","properties":{"name":"Androscoggin"}},{"type":"Polygon","arcs":[[5659,5660,5661,-3454,-4879,5662]],"id":"18153","properties":{"name":"Sullivan"}},{"type":"Polygon","arcs":[[5663,5664,-3424,5665,5666,5667,5668]],"id":"28145","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[-1346,-1967,-2764,-2734,5669,-3817,-3179]],"id":"27063","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[5670,5671,5672,5673,5674,5675,5676]],"id":"49049","properties":{"name":"Utah"}},{"type":"Polygon","arcs":[[5677,-3973,5678,5679,-4930,5680]],"id":"54089","properties":{"name":"Summers"}},{"type":"Polygon","arcs":[[-5675,5681,5682,5683,5684,5685]],"id":"49039","properties":{"name":"Sanpete"}},{"type":"Polygon","arcs":[[-2794,5686,5687,-1510,5688,5689,5690]],"id":"55027","properties":{"name":"Dodge"}},{"type":"Polygon","arcs":[[5691,5692,-5347,5693,-929,5694]],"id":"46051","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[-5153,5695,5696,-168,-331]],"id":"42057","properties":{"name":"Fulton"}},{"type":"Polygon","arcs":[[5697,5698,5699,5700,5701,5702]],"id":"55093","properties":{"name":"Pierce"}},{"type":"Polygon","arcs":[[5703,5704,-1531,-4677,5705]],"id":"30045","properties":{"name":"Judith Basin"}},{"type":"Polygon","arcs":[[5706,5707,-5086,5708,5709,-3082,-4901,-4899,4898,4899,-4899,-4898,4896,-4896]],"id":"45057","properties":{"name":"Lancaster"}},{"type":"Polygon","arcs":[[5710,5711,-1522,5712,5713,-4602,5714]],"id":"51033","properties":{"name":"Caroline"}},{"type":"Polygon","arcs":[[5715,5716,5717,-5444,-1482]],"id":"56031","properties":{"name":"Platte"}},{"type":"Polygon","arcs":[[5718,5719,5720,5721,5722,-5703,5723]],"id":"27163","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[5724,5725,5726,5727,5728,5729,5730]],"id":"29133","properties":{"name":"Mississippi"}},{"type":"Polygon","arcs":[[-5078,5731,5732,-4984,5733]],"id":"42095","properties":{"name":"Northampton"}},{"type":"Polygon","arcs":[[-5221,5734,5735,5736,5737,5738]],"id":"22085","properties":{"name":"Sabine"}},{"type":"Polygon","arcs":[[5739,5740,5741,-4827,-3487,5742]],"id":"21169","properties":{"name":"Metcalfe"}},{"type":"Polygon","arcs":[[-3829,5743,-4795,5744]],"id":"04021","properties":{"name":"Pinal"}},{"type":"Polygon","arcs":[[-1237,5745,5746,-3827,-727]],"id":"04017","properties":{"name":"Navajo"}},{"type":"Polygon","arcs":[[5747,-3088,5748,-4799,5749]],"id":"04027","properties":{"name":"Yuma"}},{"type":"Polygon","arcs":[[5750,5751,5752,-5721,5753,-665]],"id":"27025","properties":{"name":"Chisago"}},{"type":"Polygon","arcs":[[-3745,5754,5755,-1399,-1557,5756,-4435]],"id":"47045","properties":{"name":"Dyer"}},{"type":"Polygon","arcs":[[5757,5758,5759,5760,5761]],"id":"21181","properties":{"name":"Nicholas"}},{"type":"Polygon","arcs":[[5762,-5462,-1365,5763,5764,-2762]],"id":"27043","properties":{"name":"Faribault"}},{"type":"Polygon","arcs":[[5765,-5144,5766,-5549,5767,5768,-3821]],"id":"21193","properties":{"name":"Perry"}},{"type":"Polygon","arcs":[[5769,-3346,-3345,3344,5770,5771,5772,5773]],"id":"48037","properties":{"name":"Bowie"}},{"type":"Polygon","arcs":[[-5119,5774,-1428,-45,5775,5776]],"id":"56011","properties":{"name":"Crook"}},{"type":"Polygon","arcs":[[5777,-5192,-4279,5778]],"id":"45061","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[5779,5780,5781,5782,5783,-5717]],"id":"56015","properties":{"name":"Goshen"}},{"type":"MultiPolygon","arcs":[[[5784,-4085]],[[-3659,5785]],[[5786,-3663,5787,-4083,-5540,5788,5789]]],"id":"25021","properties":{"name":"Norfolk"}},{"type":"Polygon","arcs":[[5790,5791,5792,5793,5794,-4064]],"id":"21123","properties":{"name":"Larue"}},{"type":"Polygon","arcs":[[5795,-1528,5796,-5526,5797,5798,5799,-2670]],"id":"16043","properties":{"name":"Fremont"}},{"type":"Polygon","arcs":[[-4004,-774,5800,-61,5801,-4640]],"id":"13233","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[-354,-3199,5802,-4654,-3090,-460,5803,5804,5805]],"id":"31031","properties":{"name":"Cherry"}},{"type":"Polygon","arcs":[[-3992,5806,5807,-3845,5808]],"id":"13247","properties":{"name":"Rockdale"}},{"type":"Polygon","arcs":[[5809,-3089,-5748,5810,5811]],"id":"06025","properties":{"name":"Imperial"}},{"type":"Polygon","arcs":[[-1726,-1246,-5359,-2348,-4190,-5300,5812]],"id":"16017","properties":{"name":"Bonner"}},{"type":"Polygon","arcs":[[5813,5814,5815,-4407,5816]],"id":"18045","properties":{"name":"Fountain"}},{"type":"Polygon","arcs":[[5817,5818,5819,5820,5821,5822,5823]],"id":"47031","properties":{"name":"Coffee"}},{"type":"Polygon","arcs":[[5824,5825,5826,-680,5827,-5821,5828]],"id":"47177","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[5829,-5582,5830,5831,5832,5833,5834,-5142]],"id":"21195","properties":{"name":"Pike"}},{"type":"Polygon","arcs":[[5835,5836,5837,-1317,5838,5839]],"id":"21197","properties":{"name":"Powell"}},{"type":"Polygon","arcs":[[-1358,5840,5841,5842]],"id":"26139","properties":{"name":"Ottawa"}},{"type":"Polygon","arcs":[[5843,5844,5845,-1225,5846,5847,5848]],"id":"47165","properties":{"name":"Sumner"}},{"type":"Polygon","arcs":[[5849,5850,5851,5852,5853]],"id":"37153","properties":{"name":"Richmond"}},{"type":"Polygon","arcs":[[-3232,5854,5855,5856,5857]],"id":"48043","properties":{"name":"Brewster"}},{"type":"Polygon","arcs":[[5858,5859,-1478,-826,5860,5861]],"id":"56019","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[5862,5863,5864,-5722,-5753]],"id":"55095","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[-5865,5865,-5698,-5723]],"id":"55109","properties":{"name":"St. Croix"}},{"type":"Polygon","arcs":[[5866,-4025,5867,-4144]],"id":"48111","properties":{"name":"Dallam"}},{"type":"Polygon","arcs":[[5868,-5637,5869,5870,5871,5872]],"id":"42067","properties":{"name":"Juniata"}},{"type":"Polygon","arcs":[[5873,5874,5875,5876,5877,5878,5879]],"id":"18089","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[5880,5881,5882,5883,5884]],"id":"42131","properties":{"name":"Wyoming"}},{"type":"Polygon","arcs":[[5885,5886,-5041,-5457,5887,5888,5889]],"id":"29095","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[5890,5891,-1015,5892,5893]],"id":"42073","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[5894,-1685,5895,-5891,5896,5897]],"id":"42085","properties":{"name":"Mercer"}},{"type":"Polygon","arcs":[[5898,-5885,5899,5900,-5076,5901,5902]],"id":"42079","properties":{"name":"Luzerne"}},{"type":"Polygon","arcs":[[-3649,-20,-4006,-5533]],"id":"16025","properties":{"name":"Camas"}},{"type":"Polygon","arcs":[[-3565,-297,-3721,5903,-2911,5904]],"id":"19103","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[-525,-1864,5905,-709,5906]],"id":"19117","properties":{"name":"Lucas"}},{"type":"Polygon","arcs":[[5907,-739,-3063,5908,5909,5910]],"id":"40151","properties":{"name":"Woods"}},{"type":"Polygon","arcs":[[5911,-5910,5912,5913,5914]],"id":"40153","properties":{"name":"Woodward"}},{"type":"Polygon","arcs":[[-2946,5915,-4252,5916,-4868,-3895,5917]],"id":"35027","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-5286,-4199,-4257,5918,5919]],"id":"38057","properties":{"name":"Mercer"}},{"type":"Polygon","arcs":[[-4925,-4656,-2947,-5918,-3894,5920]],"id":"35053","properties":{"name":"Socorro"}},{"type":"Polygon","arcs":[[5921,5922,-2566,5923,-5815,5924,-3006]],"id":"18157","properties":{"name":"Tippecanoe"}},{"type":"Polygon","arcs":[[5925,5926,5927,5928,5929,5930]],"id":"21221","properties":{"name":"Trigg"}},{"type":"Polygon","arcs":[[-5852,5931,5932,5933]],"id":"37165","properties":{"name":"Scotland"}},{"type":"Polygon","arcs":[[-2804,-864,-577,5934,5935,5936]],"id":"17055","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-863,5937,-4056,-4294,5938,-579]],"id":"17059","properties":{"name":"Gallatin"}},{"type":"Polygon","arcs":[[-4532,-2174,-5314,-3028,-5179,5939]],"id":"17061","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[-4033,-2748,-3983,-5508,-1270]],"id":"06009","properties":{"name":"Calaveras"}},{"type":"Polygon","arcs":[[5940,-4689,5941,5942,5943,5944]],"id":"45065","properties":{"name":"McCormick"}},{"type":"MultiPolygon","arcs":[[[-4546,5945]],[[-3947,-1071,-4548,5946]]],"id":"45077","properties":{"name":"Pickens"}},{"type":"Polygon","arcs":[[-5451,-2863,-5350,-3392,5947]],"id":"51065","properties":{"name":"Fluvanna"}},{"type":"Polygon","arcs":[[5948,-5779,-4278,-5180,5949,5950]],"id":"45085","properties":{"name":"Sumter"}},{"type":"Polygon","arcs":[[5951,5952,-1553,5953]],"id":"51133","properties":{"name":"Northumberland"}},{"type":"Polygon","arcs":[[5954,-5426,5955,5956,-5760,5957]],"id":"21069","properties":{"name":"Fleming"}},{"type":"Polygon","arcs":[[-435,5958,5959,5960,5961,5962]],"id":"47001","properties":{"name":"Anderson"}},{"type":"Polygon","arcs":[[5963,5964,5965,-1983,-2299]],"id":"30099","properties":{"name":"Teton"}},{"type":"Polygon","arcs":[[-165,5966,5967,5968,-5213]],"id":"35055","properties":{"name":"Taos"}},{"type":"Polygon","arcs":[[-3129,-5307,-896,5969,-2149,-1290]],"id":"18085","properties":{"name":"Kosciusko"}},{"type":"Polygon","arcs":[[5970,-4260,5971,5972,5973]],"id":"38085","properties":{"name":"Sioux"}},{"type":"Polygon","arcs":[[-3489,-4826,5974,5975,5976,5977,5978]],"id":"47027","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[-5772,5979,5980,5981,5982]],"id":"48067","properties":{"name":"Cass"}},{"type":"Polygon","arcs":[[5983,-5659,5984,-992,5985,-1639,5986]],"id":"23017","properties":{"name":"Oxford"}},{"type":"Polygon","arcs":[[-5761,-5957,5987,5988,5989]],"id":"21011","properties":{"name":"Bath"}},{"type":"Polygon","arcs":[[-4664,-3133,-1206,5990,5991,5992]],"id":"37057","properties":{"name":"Davidson"}},{"type":"Polygon","arcs":[[-5658,-5013,5993,-993,-5985]],"id":"23005","properties":{"name":"Cumberland"}},{"type":"Polygon","arcs":[[5994,-3160,-5463,-5763,-2761,-1965,-4427]],"id":"27013","properties":{"name":"Blue Earth"}},{"type":"Polygon","arcs":[[5995,5996,5997,5998,5999,-4390,-4389,4388,-4389,-4388,4386,-4386,-4385,4384,-4385,4384,-4385,-4384,4382,-4382,-4381,-4380,-4379,4378,-4379,-4378]],"id":"51093","properties":{"name":"Isle of Wight"}},{"type":"Polygon","arcs":[[-5353,6000,6001,6002,-4366,-359,6003,-4586]],"id":"56037","properties":{"name":"Sweetwater"}},{"type":"Polygon","arcs":[[-2346,6004,6005,-4186]],"id":"30061","properties":{"name":"Mineral"}},{"type":"Polygon","arcs":[[6006,6007,6008]],"id":"51685","properties":{"name":"Manassas Park"}},{"type":"Polygon","arcs":[[6009,-4176,-2795,-5691,6010,6011]],"id":"55021","properties":{"name":"Columbia"}},{"type":"Polygon","arcs":[[6012,-1760,-148,6013]],"id":"72145","properties":{"name":"Vega Baja"}},{"type":"Polygon","arcs":[[6014,6015,-2731,6016,6017,6018]],"id":"46041","properties":{"name":"Dewey"}},{"type":"Polygon","arcs":[[6019,-1409,-5515,6020,6021]],"id":"45005","properties":{"name":"Allendale"}},{"type":"Polygon","arcs":[[6022,-5186,-1488,6023,6024,-4979]],"id":"47059","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[-3863,-3822,-5769,6025,6026,-5316,6027]],"id":"21051","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[6028,-4292,6029,6030,6031,-5503]],"id":"21055","properties":{"name":"Crittenden"}},{"type":"Polygon","arcs":[[6032,6033,-5854,-5082]],"id":"37007","properties":{"name":"Anson"}},{"type":"Polygon","arcs":[[6034,-437,6035,6036,6037,6038]],"id":"47049","properties":{"name":"Fentress"}},{"type":"MultiPolygon","arcs":[[[-5729,6039,6040,6041,6042]],[[6043,6044]]],"id":"21075","properties":{"name":"Fulton"}},{"type":"Polygon","arcs":[[6045,6046,-5323,6047,6048]],"id":"21019","properties":{"name":"Boyd"}},{"type":"Polygon","arcs":[[-4549,6049,-4690,-5941,6050]],"id":"45001","properties":{"name":"Abbeville"}},{"type":"Polygon","arcs":[[6051,6052,6053,6054,6055,-2786,-5373,6056]],"id":"48149","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[-5437,6057,6058,-2093,6059,-498]],"id":"41049","properties":{"name":"Morrow"}},{"type":"Polygon","arcs":[[6060,6061,6062,-5151,-3515]],"id":"42013","properties":{"name":"Blair"}},{"type":"Polygon","arcs":[[6063]],"id":"25019","properties":{"name":"Nantucket"}},{"type":"Polygon","arcs":[[-5181,-4276,6064,-5268,6065]],"id":"45089","properties":{"name":"Williamsburg"}},{"type":"Polygon","arcs":[[-3526,-3237,-3161,-5995,-4426]],"id":"27103","properties":{"name":"Nicollet"}},{"type":"Polygon","arcs":[[6066,6067,-1230,6068,-5577]],"id":"49055","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[6069,-1723,-4361,6070,-3112,-3268,6071]],"id":"48053","properties":{"name":"Burnet"}},{"type":"Polygon","arcs":[[6072,6073,-5598,6074,-1525,-1999]],"id":"30023","properties":{"name":"Deer Lodge"}},{"type":"Polygon","arcs":[[-5597,6075,-1526,-6075]],"id":"30093","properties":{"name":"Silver Bow"}},{"type":"Polygon","arcs":[[-1421,-110,-5075,6076,6077,-4990]],"id":"46135","properties":{"name":"Yankton"}},{"type":"Polygon","arcs":[[-4963,6078,6079,6080,-352,6081]],"id":"46071","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-5977,6082,-6039,6083,6084]],"id":"47133","properties":{"name":"Overton"}},{"type":"Polygon","arcs":[[-5683,6085,6086,-6068,6087]],"id":"49015","properties":{"name":"Emery"}},{"type":"Polygon","arcs":[[6088,-1672,6089,-4637,6090,-3783,6091,-3786,6092]],"id":"48391","properties":{"name":"Refugio"}},{"type":"Polygon","arcs":[[6093,6094,-1224,-3567,-632]],"id":"48357","properties":{"name":"Ochiltree"}},{"type":"Polygon","arcs":[[-4041,6095,-620,-5218,6096,-5226,6097]],"id":"35045","properties":{"name":"San Juan"}},{"type":"Polygon","arcs":[[-1279,6098,6099,6100,6101,-3547,6102]],"id":"05063","properties":{"name":"Independence"}},{"type":"Polygon","arcs":[[6103,-5111,-3559,-1586,6104,6105,-2275]],"id":"29029","properties":{"name":"Camden"}},{"type":"Polygon","arcs":[[6106,-5259,6107,-4328,-2740]],"id":"38067","properties":{"name":"Pembina"}},{"type":"Polygon","arcs":[[-6101,6108,6109,-3980,-611,-4806,6110]],"id":"05067","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-104,6111,6112,-4969,-5072,-108]],"id":"46083","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-6041,6113,6114,-1394,-5756,6115]],"id":"47131","properties":{"name":"Obion"}},{"type":"Polygon","arcs":[[6116,-4282,6117,6118,6119,6120,6121]],"id":"45003","properties":{"name":"Aiken"}},{"type":"Polygon","arcs":[[6122,-3524,6123,6124]],"id":"41003","properties":{"name":"Benton"}},{"type":"Polygon","arcs":[[6125,-6124,-3523,6126,6127,6128,6129]],"id":"41039","properties":{"name":"Lane"}},{"type":"Polygon","arcs":[[6130,6131,6132,6133,6134,-4603,-5714]],"id":"51097","properties":{"name":"King and Queen"}},{"type":"Polygon","arcs":[[6135,6136,-5731,6137,6138]],"id":"29201","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[-4634,6139,6140,6141,6142]],"id":"48321","properties":{"name":"Matagorda"}},{"type":"Polygon","arcs":[[-1097,6143,6144,-248,6145]],"id":"48447","properties":{"name":"Throckmorton"}},{"type":"Polygon","arcs":[[6146,-443,6147,6148]],"id":"55129","properties":{"name":"Washburn"}},{"type":"Polygon","arcs":[[6149,-5578,-6069,-1229,6150,6151]],"id":"49017","properties":{"name":"Garfield"}},{"type":"Polygon","arcs":[[6152,-5433,-3643,6153,-2531]],"id":"31055","properties":{"name":"Douglas"}},{"type":"Polygon","arcs":[[6154,6155]],"id":"51520","properties":{"name":"Bristol"}},{"type":"Polygon","arcs":[[6156,-32,6157,-35,-3406]],"id":"38097","properties":{"name":"Traill"}},{"type":"Polygon","arcs":[[-3354,-3360,6158,6159,-1951,6160]],"id":"05069","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[6161,6162,6163,-6109,-6100,6164]],"id":"05075","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[-5168,6165]],"id":"51570","properties":{"name":"Colonial Heights"}},{"type":"Polygon","arcs":[[6166,6167,6168,6169,6170]],"id":"48001","properties":{"name":"Anderson"}},{"type":"Polygon","arcs":[[6171,-5513,-3479,6172,-5727]],"id":"21039","properties":{"name":"Carlisle"}},{"type":"Polygon","arcs":[[-4309,6173,-5601,6174,6175,6176]],"id":"47009","properties":{"name":"Blount"}},{"type":"Polygon","arcs":[[6177,6178,-1406,6179,-5188,-1467,-1396]],"id":"47017","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[-3483,6180,6181,-1400,-6179,6182]],"id":"47079","properties":{"name":"Henry"}},{"type":"Polygon","arcs":[[6183,6184,6185,6186,6187,-5334]],"id":"25013","properties":{"name":"Hampden"}},{"type":"Polygon","arcs":[[-3615,-1594,-5095,6188,-5454,-5039]],"id":"29033","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[6189,6190,-6057,-5372,6191,6192]],"id":"48055","properties":{"name":"Caldwell"}},{"type":"Polygon","arcs":[[6193,-5281,6194,6195]],"id":"50021","properties":{"name":"Rutland"}},{"type":"Polygon","arcs":[[-3538,6196,6197,6198,6199,-3521]],"id":"41031","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[6200,-2447,-4933,6201,6202,6203]],"id":"51185","properties":{"name":"Tazewell"}},{"type":"Polygon","arcs":[[6204,-3763,6205,6206,6207]],"id":"51043","properties":{"name":"Clarke"}},{"type":"Polygon","arcs":[[6208,6209,-4172]],"id":"72149","properties":{"name":"Villalba"}},{"type":"Polygon","arcs":[[6210,6211,6212,-1766,6213]],"id":"12067","properties":{"name":"Lafayette"}},{"type":"Polygon","arcs":[[-374,-1139,-1327,6214,-2894]],"id":"20205","properties":{"name":"Wilson"}},{"type":"Polygon","arcs":[[-1188,-5547,6215,-3227]],"id":"17047","properties":{"name":"Edwards"}},{"type":"Polygon","arcs":[[-1644,-2742,-4331,-402,6216]],"id":"38071","properties":{"name":"Ramsey"}},{"type":"Polygon","arcs":[[-6076,-5596,-5527,-5797,-1527]],"id":"30057","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[-5271,6217,6218,6219,6220,-4854]],"id":"29005","properties":{"name":"Atchison"}},{"type":"Polygon","arcs":[[6221,6222,6223,6224,6225,-3590,6226]],"id":"51083","properties":{"name":"Halifax"}},{"type":"Polygon","arcs":[[6227,6228,6229,-3134,6230]],"id":"51013","properties":{"name":"Arlington"}},{"type":"MultiPolygon","arcs":[[[6231]],[[6232,-4159,-2483,6233,6234]],[[6235]]],"id":"53057","properties":{"name":"Skagit"}},{"type":"Polygon","arcs":[[6236,-3741,6237,-720,6238,6239,6240,-5114]],"id":"30025","properties":{"name":"Fallon"}},{"type":"Polygon","arcs":[[6241,6242,6243,-5997,6244,6245]],"id":"51181","properties":{"name":"Surry"}},{"type":"Polygon","arcs":[[6246,6247,6248,-4728]],"id":"53071","properties":{"name":"Walla Walla"}},{"type":"Polygon","arcs":[[6249,6250,6251,6252,6253,-771]],"id":"13057","properties":{"name":"Cherokee"}},{"type":"Polygon","arcs":[[6254,6255,6256,6257,6258]],"id":"27149","properties":{"name":"Stevens"}},{"type":"Polygon","arcs":[[-2896,6259,6260,6261,6262]],"id":"20019","properties":{"name":"Chautauqua"}},{"type":"Polygon","arcs":[[6263,6264,6265,-1702,-3881,6266]],"id":"29075","properties":{"name":"Gentry"}},{"type":"Polygon","arcs":[[6267,6268,-6207,6269,-2397,6270]],"id":"51187","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[-1863,-1242,-291,-4817,-5906]],"id":"19135","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[6271,6272,-1417,6273,-1914]],"id":"48325","properties":{"name":"Medina"}},{"type":"Polygon","arcs":[[-4621,6274,-3882,-2459,6275,6276]],"id":"29021","properties":{"name":"Buchanan"}},{"type":"Polygon","arcs":[[-5115,-6241,6277,-1424,-5775,-5118]],"id":"30011","properties":{"name":"Carter"}},{"type":"Polygon","arcs":[[6278,6279,-2642,-3409,6280,6281]],"id":"26055","properties":{"name":"Grand Traverse"}},{"type":"Polygon","arcs":[[6282,-4218,-4793,-4947,6283,6284,6285]],"id":"28141","properties":{"name":"Tishomingo"}},{"type":"Polygon","arcs":[[6286,-4926,-5921,-3898,-3753,-4801]],"id":"35003","properties":{"name":"Catron"}},{"type":"Polygon","arcs":[[6287,-3517,-5154,-329,-5398,6288]],"id":"42111","properties":{"name":"Somerset"}},{"type":"Polygon","arcs":[[-366,6289,6290,6291,6292,6293]],"id":"36109","properties":{"name":"Tompkins"}},{"type":"Polygon","arcs":[[-3709,6294,6295,6296]],"id":"36067","properties":{"name":"Onondaga"}},{"type":"Polygon","arcs":[[-5201,6297,6298,6299,-5265,6300]],"id":"45051","properties":{"name":"Horry"}},{"type":"Polygon","arcs":[[6301,6302,6303,-751]],"id":"30041","properties":{"name":"Hill"}},{"type":"Polygon","arcs":[[6304,6305,6306,-2876,-48]],"id":"36001","properties":{"name":"Albany"}},{"type":"Polygon","arcs":[[-517,6307,-6253,6308,6309,-3995,6310,6311,-643,6312]],"id":"13121","properties":{"name":"Fulton"}},{"type":"Polygon","arcs":[[-5700,6313,6314,6315,6316,6317]],"id":"55091","properties":{"name":"Pepin"}},{"type":"Polygon","arcs":[[6318,-3383,6319,6320,6321]],"id":"01105","properties":{"name":"Perry"}},{"type":"Polygon","arcs":[[-2809,6322,-2416]],"id":"02090","properties":{"name":"Fairbanks North Star"}},{"type":"Polygon","arcs":[[6323,6324,6325,6326]],"id":"13125","properties":{"name":"Glascock"}},{"type":"Polygon","arcs":[[-944,6327,-2326,6328,-2831]],"id":"48173","properties":{"name":"Glasscock"}},{"type":"Polygon","arcs":[[-1504,-1502,1501,1502,-1502,-1501,6329,-5351,-4584,-4079,6330,-5798,-5525]],"id":"56039","properties":{"name":"Teton"}},{"type":"MultiPolygon","arcs":[[[-4394,6331]],[[6332,6333,6334,6335,6336,6337,-4399,6338,6339]]],"id":"08059","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[6340,-2155,6341]],"id":"08029","properties":{"name":"Delta"}},{"type":"Polygon","arcs":[[-3994,6342,6343,6344,-6311]],"id":"13063","properties":{"name":"Clayton"}},{"type":"Polygon","arcs":[[-74,6345,-4463,6346,6347]],"id":"18117","properties":{"name":"Orange"}},{"type":"MultiPolygon","arcs":[[[6348]],[[6349]],[[6350]],[[-3733,6351]]],"id":"36103","properties":{"name":"Suffolk"}},{"type":"MultiPolygon","arcs":[[[6352]],[[-4517,6353,-3705,6354]],[[6355]]],"id":"36045","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[-4074,6356,6357,6358,-1798]],"id":"20107","properties":{"name":"Linn"}},{"type":"Polygon","arcs":[[6359,6360,6361,-3910,6362,6363,-4707,6364]],"id":"37161","properties":{"name":"Rutherford"}},{"type":"Polygon","arcs":[[6365,6366,6367,-4562,-4985,-5733]],"id":"34041","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[6368,6369,-5579,-6150,6370,-4494]],"id":"49001","properties":{"name":"Beaver"}},{"type":"Polygon","arcs":[[6371,6372,-4737,6373,-6155,6374,-1632,6375]],"id":"51191","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-4945,-4642,6376,6377,-4162]],"id":"01015","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[6378,6379,6380,6381,6382,-1772]],"id":"13133","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[6383,6384,6385,6386]],"id":"54009","properties":{"name":"Brooke"}},{"type":"MultiPolygon","arcs":[[[6387]],[[6388]],[[-2072,6389,-4953]],[[6390]],[[6391,-4955]]],"id":"02070","properties":{"name":"Dillingham"}},{"type":"Polygon","arcs":[[-3087,6392,-3830,-5745,-4794,-5749]],"id":"04013","properties":{"name":"Maricopa"}},{"type":"Polygon","arcs":[[-4881,6393,6394,6395,6396]],"id":"18125","properties":{"name":"Pike"}},{"type":"Polygon","arcs":[[-3855,-2850,6397,-4504,6398,6399,-77]],"id":"18137","properties":{"name":"Ripley"}},{"type":"Polygon","arcs":[[-2525,6400,-4784,-5421,6401,-736]],"id":"20095","properties":{"name":"Kingman"}},{"type":"Polygon","arcs":[[6402,-1550,6403,6404,6405]],"id":"20123","properties":{"name":"Mitchell"}},{"type":"Polygon","arcs":[[-1570,6406,-780,-1044,-3097,6407]],"id":"20083","properties":{"name":"Hodgeman"}},{"type":"Polygon","arcs":[[-3120,6408,-2553,-1125,-659,6409]],"id":"20127","properties":{"name":"Morris"}},{"type":"Polygon","arcs":[[-1789,6410,-668,6411,-1377,6412,6413]],"id":"27095","properties":{"name":"Mille Lacs"}},{"type":"Polygon","arcs":[[-5667,6414,6415,6416,-89,6417]],"id":"28081","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[6418,6419,-5669,6420,-455,6421,6422]],"id":"28071","properties":{"name":"Lafayette"}},{"type":"Polygon","arcs":[[6423,6424,6425,6426,-4243,-4520]],"id":"28029","properties":{"name":"Copiah"}},{"type":"Polygon","arcs":[[6427,6428,6429,6430,-450,6431]],"id":"28111","properties":{"name":"Perry"}},{"type":"Polygon","arcs":[[-4330,6432,-33,-6157,-3405,-397]],"id":"38035","properties":{"name":"Grand Forks"}},{"type":"Polygon","arcs":[[6433,6434,6435,-5236,-5196]],"id":"42045","properties":{"name":"Delaware"}},{"type":"Polygon","arcs":[[6436,6437,6438,6439,6440]],"id":"44003","properties":{"name":"Kent"}},{"type":"Polygon","arcs":[[6441,-5905,-2910,-3568,-1870]],"id":"19095","properties":{"name":"Iowa"}},{"type":"Polygon","arcs":[[-1063,6442,-5434,-6153,-2530,6443,-5519]],"id":"31053","properties":{"name":"Dodge"}},{"type":"Polygon","arcs":[[-334,6444,6445,-5399]],"id":"54057","properties":{"name":"Mineral"}},{"type":"Polygon","arcs":[[6446,-4808,-3842,6447,-3358]],"id":"05117","properties":{"name":"Prairie"}},{"type":"Polygon","arcs":[[-5747,6448,-4804,6449,-4796,-5744,-3828]],"id":"04009","properties":{"name":"Graham"}},{"type":"Polygon","arcs":[[-474,6450,6451,6452,6453,6454,6455,6456]],"id":"08049","properties":{"name":"Grand"}},{"type":"Polygon","arcs":[[6457,6458,6459,6460,6461,-3299,-1859,-4764,6462]],"id":"08109","properties":{"name":"Saguache"}},{"type":"Polygon","arcs":[[6463,6464,-3213,-1837,-623,6465]],"id":"12093","properties":{"name":"Okeechobee"}},{"type":"Polygon","arcs":[[-2140,6466,6467,6468,-4044]],"id":"13123","properties":{"name":"Gilmer"}},{"type":"Polygon","arcs":[[-3431,6469,6470,6471,-5212,6472,6473,-3201]],"id":"13299","properties":{"name":"Ware"}},{"type":"Polygon","arcs":[[6474,-5443,-5174,-4429,-5338,6475,6476]],"id":"29007","properties":{"name":"Audrain"}},{"type":"Polygon","arcs":[[-5216,6477,6478,6479,6480]],"id":"35028","properties":{"name":"Los Alamos"}},{"type":"Polygon","arcs":[[6481,6482,-4575,-2565,-3580,-1473,-1532,-5705]],"id":"30027","properties":{"name":"Fergus"}},{"type":"Polygon","arcs":[[6483,-5379,6484,-4652]],"id":"31149","properties":{"name":"Rock"}},{"type":"Polygon","arcs":[[6485,6486,-5288,6487,6488,-5466]],"id":"38061","properties":{"name":"Mountrail"}},{"type":"Polygon","arcs":[[6489,6490,6491,-1337,6492,-4290,-4054]],"id":"21101","properties":{"name":"Henderson"}},{"type":"Polygon","arcs":[[6493,-5789,-5544,6494,6495,-6437,6496]],"id":"44007","properties":{"name":"Providence"}},{"type":"Polygon","arcs":[[6497,-3943,6498,6499,-5959,-434]],"id":"47013","properties":{"name":"Campbell"}},{"type":"MultiPolygon","arcs":[[[6500,6501,6502,6503]],[[6504,6505,6506,6507,-131]]],"id":"48261","properties":{"name":"Kenedy"}},{"type":"Polygon","arcs":[[6508,-4121,6509,6510,-2923,6511]],"id":"36051","properties":{"name":"Livingston"}},{"type":"Polygon","arcs":[[6512,-3967,6513,6514,6515,6516]],"id":"54011","properties":{"name":"Cabell"}},{"type":"Polygon","arcs":[[6517,6518,6519,-3987,6520,-2220]],"id":"06007","properties":{"name":"Butte"}},{"type":"Polygon","arcs":[[-6455,6521,6522,6523,6524]],"id":"08117","properties":{"name":"Summit"}},{"type":"Polygon","arcs":[[6525,6526,-4551,6527,-1918]],"id":"13147","properties":{"name":"Hart"}},{"type":"Polygon","arcs":[[-5386,-1818,-4115,-3217,6528]],"id":"17187","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[6529,6530,6531,-3449,6532]],"id":"18119","properties":{"name":"Owen"}},{"type":"Polygon","arcs":[[6533,6534,-6347,-4468,-4876,6535,6536,-6395]],"id":"18037","properties":{"name":"Dubois"}},{"type":"Polygon","arcs":[[-2189,6537,6538,6539,-1568]],"id":"20165","properties":{"name":"Rush"}},{"type":"Polygon","arcs":[[-225,-1036,-3566,-6442,6540]],"id":"19011","properties":{"name":"Benton"}},{"type":"Polygon","arcs":[[6541,-4683,-3864,-6028,-5315,-3939,6542]],"id":"21125","properties":{"name":"Laurel"}},{"type":"Polygon","arcs":[[6543,6544,6545,6546,-2523,-782]],"id":"20185","properties":{"name":"Stafford"}},{"type":"Polygon","arcs":[[-5736,6547,6548,6549,6550,6551]],"id":"22115","properties":{"name":"Vernon"}},{"type":"Polygon","arcs":[[6552,6553,6554,-1615,-2704,-5415]],"id":"26093","properties":{"name":"Livingston"}},{"type":"Polygon","arcs":[[-3167,-3147,-3311,6555,-476,-2806,6556,-1362]],"id":"27099","properties":{"name":"Mower"}},{"type":"Polygon","arcs":[[-2629,6557,6558,6559,6560]],"id":"28073","properties":{"name":"Lamar"}},{"type":"Polygon","arcs":[[6561,6562,6563,6564,6565,6566]],"id":"28053","properties":{"name":"Humphreys"}},{"type":"Polygon","arcs":[[6567,6568,-1664,6569,-670]],"id":"31139","properties":{"name":"Pierce"}},{"type":"Polygon","arcs":[[6570,6571,-5571,6572,-1318,-5838]],"id":"21237","properties":{"name":"Wolfe"}},{"type":"Polygon","arcs":[[6573,-5127,6574,-5927,6575,-6031]],"id":"21033","properties":{"name":"Caldwell"}},{"type":"Polygon","arcs":[[-1427,-3768,6576,6577,-4961,-42]],"id":"46093","properties":{"name":"Meade"}},{"type":"Polygon","arcs":[[6578,6579,6580,6581,6582,6583,-4696,6584]],"id":"21021","properties":{"name":"Boyle"}},{"type":"Polygon","arcs":[[6585,-4713,6586,6587,6588]],"id":"37199","properties":{"name":"Yancey"}},{"type":"Polygon","arcs":[[-6320,-3382,6589,-2769,6590,6591]],"id":"01047","properties":{"name":"Dallas"}},{"type":"Polygon","arcs":[[6592,-2626,6593,-218]],"id":"13231","properties":{"name":"Pike"}},{"type":"Polygon","arcs":[[-878,6594,6595,6596]],"id":"01035","properties":{"name":"Conecuh"}},{"type":"Polygon","arcs":[[-3466,6597,-3356,-2540,6598,6599]],"id":"05105","properties":{"name":"Perry"}},{"type":"Polygon","arcs":[[-6468,6600,-6250,6601]],"id":"13227","properties":{"name":"Pickens"}},{"type":"Polygon","arcs":[[6602,-6382,6603,6604,-6327,6605,6606]],"id":"13141","properties":{"name":"Hancock"}},{"type":"Polygon","arcs":[[6607,-200,6608,6609,6610]],"id":"13307","properties":{"name":"Webster"}},{"type":"Polygon","arcs":[[6611,-4231,6612,-3075,6613,6614]],"id":"18095","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[-3451,-75,-6348,-6535,6615]],"id":"18101","properties":{"name":"Martin"}},{"type":"Polygon","arcs":[[-2254,-379,-1571,-6408,-3100,6616,6617]],"id":"20055","properties":{"name":"Finney"}},{"type":"Polygon","arcs":[[-2207,6618,6619,6620,6621]],"id":"20087","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[-3469,6622,6623,-5922,-3005,6624]],"id":"18181","properties":{"name":"White"}},{"type":"Polygon","arcs":[[-4698,6625,-4684,-6542,6626,-4296,6627]],"id":"21199","properties":{"name":"Pulaski"}},{"type":"Polygon","arcs":[[-5479,-5276,-5312,-4530,6628]],"id":"17009","properties":{"name":"Brown"}},{"type":"Polygon","arcs":[[6629,6630,6631,6632,6633,6634,6635]],"id":"22021","properties":{"name":"Caldwell"}},{"type":"Polygon","arcs":[[-5888,-5456,-1990,6636,6637]],"id":"29101","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[-4241,6638,6639,6640,6641]],"id":"29017","properties":{"name":"Bollinger"}},{"type":"Polygon","arcs":[[-2323,6642,6643,6644,6645,6646]],"id":"29035","properties":{"name":"Carter"}},{"type":"Polygon","arcs":[[-971,-2534,6647,-4856,6648,-2616]],"id":"31109","properties":{"name":"Lancaster"}},{"type":"Polygon","arcs":[[6649,6650,6651,6652,-4564]],"id":"34035","properties":{"name":"Somerset"}},{"type":"Polygon","arcs":[[6653,-6512,-2922,6654,6655]],"id":"36121","properties":{"name":"Wyoming"}},{"type":"Polygon","arcs":[[6656,-367,-6294,6657,6658]],"id":"36097","properties":{"name":"Schuyler"}},{"type":"Polygon","arcs":[[6659,6660,6661,6662,-1886]],"id":"39091","properties":{"name":"Logan"}},{"type":"Polygon","arcs":[[6663,-1811,-1934,6664,6665,6666,-6662]],"id":"39159","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[-5050,-3173,6667,-3513,6668]],"id":"42063","properties":{"name":"Indiana"}},{"type":"Polygon","arcs":[[-4065,-5795,6669,-5740,6670,-2842,6671]],"id":"21099","properties":{"name":"Hart"}},{"type":"Polygon","arcs":[[-1339,6672,-4693,-4288,6673,6674,6675]],"id":"21183","properties":{"name":"Ohio"}},{"type":"Polygon","arcs":[[6676,6677,-2519,-2728,-6016,6678]],"id":"46129","properties":{"name":"Walworth"}},{"type":"Polygon","arcs":[[-5065,6679,-4977,-5599,6680]],"id":"47089","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[6681,6682,6683,6684,-5758,6685,-804]],"id":"21097","properties":{"name":"Harrison"}},{"type":"Polygon","arcs":[[-5600,-5059,6686,6687,6688,-6175]],"id":"37173","properties":{"name":"Swain"}},{"type":"Polygon","arcs":[[6689,-2364,6690,-3110,6691,6692,6693,6694,6695,6696,-6697,6696,6697,6698,6699,6700,6701,6702,6703,-2368,6704]],"id":"48499","properties":{"name":"Wood"}},{"type":"Polygon","arcs":[[6705,6706,6707,6708,6709,6710]],"id":"37091","properties":{"name":"Hertford"}},{"type":"Polygon","arcs":[[-832,6711,-4212,-5430,-4149,6712,6713]],"id":"48291","properties":{"name":"Liberty"}},{"type":"Polygon","arcs":[[6714,6715,-80,-4413,6716,-72,6717]],"id":"18071","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-6540,6718,-6544,-781,-6407,-1569]],"id":"20145","properties":{"name":"Pawnee"}},{"type":"Polygon","arcs":[[-2556,-3320,-1258,-1800,-1137,-372]],"id":"20031","properties":{"name":"Coffey"}},{"type":"Polygon","arcs":[[-852,6719,6720,-4828,-3871]],"id":"22055","properties":{"name":"Lafayette"}},{"type":"Polygon","arcs":[[6721,-2133,-1389,-6255,6722]],"id":"27051","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[6723,-2963,6724,6725,6726]],"id":"28121","properties":{"name":"Rankin"}},{"type":"Polygon","arcs":[[6727,6728,-6727,-6425,6729,-3700]],"id":"28049","properties":{"name":"Hinds"}},{"type":"Polygon","arcs":[[6730,6731,6732,-4671,6733,6734]],"id":"37051","properties":{"name":"Cumberland"}},{"type":"Polygon","arcs":[[6735,6736,6737,6738,-1311,-2968,-1973,-4192]],"id":"37193","properties":{"name":"Wilkes"}},{"type":"Polygon","arcs":[[-1902,6739,6740,-6660,-1885,6741]],"id":"39011","properties":{"name":"Auglaize"}},{"type":"Polygon","arcs":[[6742,6743,6744,6745,6746,6747,-3922]],"id":"40125","properties":{"name":"Pottawatomie"}},{"type":"Polygon","arcs":[[6748,-4270,6749,6750,6751,6752]],"id":"40091","properties":{"name":"McIntosh"}},{"type":"Polygon","arcs":[[6753,6754,-3535,6755,6756]],"id":"41071","properties":{"name":"Yamhill"}},{"type":"Polygon","arcs":[[-5079,-5734,-4983,6757,6758,6759]],"id":"42077","properties":{"name":"Lehigh"}},{"type":"Polygon","arcs":[[-5793,6760,-4701,6761,6762]],"id":"21217","properties":{"name":"Taylor"}},{"type":"Polygon","arcs":[[-4417,-2843,-6671,-5743,-3486,6763]],"id":"21009","properties":{"name":"Barren"}},{"type":"Polygon","arcs":[[-6071,-4365,6764,-6190,6765,-3113]],"id":"48453","properties":{"name":"Travis"}},{"type":"Polygon","arcs":[[-115,-833,-6714,6766,6767,6768]],"id":"48339","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[6769,-470,-2327,-6328,-943]],"id":"48227","properties":{"name":"Howard"}},{"type":"Polygon","arcs":[[6770,-5834,6771,6772,-1630,6773,-5551],[-3957]],"id":"51195","properties":{"name":"Wise"}},{"type":"Polygon","arcs":[[6774]],"id":"51840","properties":{"name":"Winchester"}},{"type":"Polygon","arcs":[[-4266,6775,-948,6776,-96]],"id":"39139","properties":{"name":"Richland"}},{"type":"Polygon","arcs":[[-6726,6777,6778,-2627,6779,-6426]],"id":"28127","properties":{"name":"Simpson"}},{"type":"Polygon","arcs":[[6780,-6476,-5341,6781,6782,-1542,6783]],"id":"29019","properties":{"name":"Boone"}},{"type":"Polygon","arcs":[[-752,-6304,6784,-6482,-5704,6785,-5965,6786]],"id":"30015","properties":{"name":"Chouteau"}},{"type":"Polygon","arcs":[[6787,-927,-3407,-387,-1970,-4650]],"id":"31081","properties":{"name":"Hamilton"}},{"type":"Polygon","arcs":[[-6480,6788,-6478,-5215,6789,-4662,-2943,6790,6791]],"id":"35049","properties":{"name":"Santa Fe"}},{"type":"Polygon","arcs":[[6792,-5383,-4669,6793,6794,-4672,-6733]],"id":"37163","properties":{"name":"Sampson"}},{"type":"Polygon","arcs":[[6795,-2783,-4271,-6749,6796,6797,-6745]],"id":"40107","properties":{"name":"Okfuskee"}},{"type":"Polygon","arcs":[[6798,6799,6800,-1391,6801,-3061]],"id":"40047","properties":{"name":"Garfield"}},{"type":"Polygon","arcs":[[-5989,6802,6803,-6571,-5837,6804]],"id":"21165","properties":{"name":"Menifee"}},{"type":"Polygon","arcs":[[-5214,-5969,6805,6806,-4658,-6790]],"id":"35033","properties":{"name":"Mora"}},{"type":"Polygon","arcs":[[-6570,-1660,6807,-4617,-671]],"id":"31119","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[-236,6808,-923,-6788,-4649,-792]],"id":"31121","properties":{"name":"Merrick"}},{"type":"Polygon","arcs":[[-3522,-6200,6809,-4356,-4125,6810,-6127]],"id":"41017","properties":{"name":"Deschutes"}},{"type":"Polygon","arcs":[[-4359,6811,6812,6813,6814,6815,6816]],"id":"32013","properties":{"name":"Humboldt"}},{"type":"Polygon","arcs":[[6817,6818,6819,6820,6821]],"id":"42117","properties":{"name":"Tioga"}},{"type":"Polygon","arcs":[[-6675,6822,-2845,-4421,6823,6824]],"id":"21031","properties":{"name":"Butler"}},{"type":"Polygon","arcs":[[-4466,6825,-4059,-4286,-4877]],"id":"21163","properties":{"name":"Meade"}},{"type":"Polygon","arcs":[[-6584,-6583,-6582,6826,-4685,-6626,-4697]],"id":"21137","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-5317,-6027,6827,-5553,6828,6829,-3941]],"id":"21013","properties":{"name":"Bell"}},{"type":"Polygon","arcs":[[-3124,6830,6831,-802,-2771,-4786]],"id":"21187","properties":{"name":"Owen"}},{"type":"Polygon","arcs":[[6832,6833,-3952]],"id":"37137","properties":{"name":"Pamlico"}},{"type":"Polygon","arcs":[[6834,6835,6836,6837,6838,6839]],"id":"37187","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[6840,6841,6842,6843,6844]],"id":"54015","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[6845,-5121,6846,-5859,6847]],"id":"56033","properties":{"name":"Sheridan"}},{"type":"Polygon","arcs":[[6848,-146,6849,6850,6851]],"id":"72137","properties":{"name":"Toa Baja"}},{"type":"Polygon","arcs":[[-5009,6852,-2118,-3330,6853,-4347]],"id":"72125","properties":{"name":"San GermÃ¡n"}},{"type":"Polygon","arcs":[[6854,-4914,6855,6856,6857]],"id":"42103","properties":{"name":"Pike"}},{"type":"Polygon","arcs":[[6858,6859,-6831,-3123,6860]],"id":"21077","properties":{"name":"Gallatin"}},{"type":"Polygon","arcs":[[-1204,-5565,6861,6862,-6731,6863,-5851,6864]],"id":"37125","properties":{"name":"Moore"}},{"type":"Polygon","arcs":[[-5933,6865,-6734,-4675,6866,-5200,6867]],"id":"37155","properties":{"name":"Robeson"}},{"type":"Polygon","arcs":[[-4364,6868,-6052,-6191,-6765]],"id":"48021","properties":{"name":"Bastrop"}},{"type":"Polygon","arcs":[[6869,6870,6871,-830,-113]],"id":"48455","properties":{"name":"Trinity"}},{"type":"Polygon","arcs":[[6872,6873,6874,-3047,-4663,-1307,-6739,6875]],"id":"37171","properties":{"name":"Surry"}},{"type":"Polygon","arcs":[[6876,6877,-5464,6878]],"id":"38023","properties":{"name":"Divide"}},{"type":"Polygon","arcs":[[-4183,6879,6880,6881,6882,6883,-2470]],"id":"72119","properties":{"name":"RÃ­o Grande"}},{"type":"Polygon","arcs":[[-1408,6884,-5089,-4893,6885,-4975,-5516]],"id":"45029","properties":{"name":"Colleton"}},{"type":"Polygon","arcs":[[-3505,6886,6887,-5825,6888,6889]],"id":"47041","properties":{"name":"DeKalb"}},{"type":"Polygon","arcs":[[-4315,-964,-690,-1720,-1129,6890]],"id":"48309","properties":{"name":"McLennan"}},{"type":"Polygon","arcs":[[-3954,6891,-2450,-4305]],"id":"37031","properties":{"name":"Carteret"}},{"type":"Polygon","arcs":[[-5022,6892,-1714,6893,-2590,-2317]],"id":"48307","properties":{"name":"McCulloch"}},{"type":"Polygon","arcs":[[-3140,6894,6895,-1083,6896,6897]],"id":"39171","properties":{"name":"Williams"}},{"type":"Polygon","arcs":[[6898,6899,6900,6901,6902,6903,6904,-6142]],"id":"48039","properties":{"name":"Brazoria"}},{"type":"Polygon","arcs":[[-1924,-841,6905,6906,-4934,6907,6908]],"id":"39013","properties":{"name":"Belmont"}},{"type":"Polygon","arcs":[[6909,6910,6911,6912,6913,6914]],"id":"39071","properties":{"name":"Highland"}},{"type":"Polygon","arcs":[[-3719,6915,-3225,6916,-796,6917]],"id":"39173","properties":{"name":"Wood"}},{"type":"Polygon","arcs":[[6918,6919,-874,6920,6921,6922]],"id":"55015","properties":{"name":"Calumet"}},{"type":"Polygon","arcs":[[6923,6924,6925,-5873,6926]],"id":"42087","properties":{"name":"Mifflin"}},{"type":"Polygon","arcs":[[6927,-5915,6928,6929,-2619,-1221,6930]],"id":"40045","properties":{"name":"Ellis"}},{"type":"Polygon","arcs":[[6931,6932,-2243,6933,6934,6935,-6080]],"id":"46075","properties":{"name":"Jones"}},{"type":"Polygon","arcs":[[-5929,6936,6937,-4628,-1401,-6182,6938]],"id":"47161","properties":{"name":"Stewart"}},{"type":"Polygon","arcs":[[6939,6940,6941,-2870,-1022]],"id":"48017","properties":{"name":"Bailey"}},{"type":"MultiPolygon","arcs":[[[6942,6943,-957,-4175,6944,6945]]],"id":"72113","properties":{"name":"Ponce"}},{"type":"Polygon","arcs":[[6946,-1941,6947,6948,6949,6950]],"id":"40065","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-1069,6951,-3936,6952,-4686,-6050]],"id":"45059","properties":{"name":"Laurens"}},{"type":"Polygon","arcs":[[6953,6954,-3764,-1425,-6278,-6240]],"id":"46063","properties":{"name":"Harding"}},{"type":"Polygon","arcs":[[6955,6956,6957,6958,6959]],"id":"54105","properties":{"name":"Wirt"}},{"type":"Polygon","arcs":[[6960,6961,-6919,6962,-835]],"id":"55087","properties":{"name":"Outagamie"}},{"type":"Polygon","arcs":[[-4261,-5971,6963,-3305,6964]],"id":"38037","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[6965,-4355,6966,6967]],"id":"41007","properties":{"name":"Clatsop"}},{"type":"Polygon","arcs":[[6968,-5902,-5080,-6760,6969,-239,6970,-5635]],"id":"42107","properties":{"name":"Schuylkill"}},{"type":"Polygon","arcs":[[-6821,6971,6972,6973,6974,-5632,6975,6976,6977]],"id":"42081","properties":{"name":"Lycoming"}},{"type":"MultiPolygon","arcs":[[[6978,6979]],[[-6888,6980,6981,6982,-5826]]],"id":"47185","properties":{"name":"White"}},{"type":"Polygon","arcs":[[6983,6984,6985,6986,-6316]],"id":"55011","properties":{"name":"Buffalo"}},{"type":"Polygon","arcs":[[6987]],"id":"69110","properties":{"name":"Saipan"}},{"type":"Polygon","arcs":[[-6854,-3329,6988,6989,-4348]],"id":"72079","properties":{"name":"Lajas"}},{"type":"Polygon","arcs":[[6990,6991,6992,6993,6994,6995,6996]],"id":"72131","properties":{"name":"San SebastiÃ¡n"}},{"type":"Polygon","arcs":[[6997,-4107,6998,6999,-6094,-631,-4024,7000]],"id":"40139","properties":{"name":"Texas"}},{"type":"Polygon","arcs":[[-6974,7001,-5903,-6969,-5634,7002]],"id":"42037","properties":{"name":"Columbia"}},{"type":"Polygon","arcs":[[-5973,7003,7004,-6679,-6015,7005,-3766]],"id":"46031","properties":{"name":"Corson"}},{"type":"Polygon","arcs":[[-6169,7006,7007,-6870,-112,-2387,7008]],"id":"48225","properties":{"name":"Houston"}},{"type":"Polygon","arcs":[[-6894,-1713,7009,7010,-6072,-3267,-2591]],"id":"48411","properties":{"name":"San Saba"}},{"type":"Polygon","arcs":[[-4320,7011,7012,7013,-6243,7014,7015]],"id":"51036","properties":{"name":"Charles City"}},{"type":"Polygon","arcs":[[7016,-6271,-2401,7017,-2407,7018]],"id":"51139","properties":{"name":"Page"}},{"type":"Polygon","arcs":[[-2241,-630,7019,-3198,7020]],"id":"46123","properties":{"name":"Tripp"}},{"type":"Polygon","arcs":[[-3233,-5858,7021]],"id":"48377","properties":{"name":"Presidio"}},{"type":"Polygon","arcs":[[-6371,-6152,7022,7023,-4495]],"id":"49021","properties":{"name":"Iron"}},{"type":"Polygon","arcs":[[7024,7025,-1749,7026,7027]],"id":"48347","properties":{"name":"Nacogdoches"}},{"type":"Polygon","arcs":[[7028,7029,7030,7031,7032,7033,-6054]],"id":"48477","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-3374,-4051,-5357,7034,7035,7036]],"id":"49003","properties":{"name":"Box Elder"}},{"type":"Polygon","arcs":[[7037,7038,7039,-261,7040]],"id":"48097","properties":{"name":"Cooke"}},{"type":"Polygon","arcs":[[7041,-6950,7042,7043,-1095,-5007]],"id":"48487","properties":{"name":"Wilbarger"}},{"type":"Polygon","arcs":[[-962,7044,-6170,-7009,-2386,7045]],"id":"48289","properties":{"name":"Leon"}},{"type":"Polygon","arcs":[[-1930,-5375,7046,-1669,7047,7048,-1413]],"id":"48255","properties":{"name":"Karnes"}},{"type":"Polygon","arcs":[[-4932,7049,-3613,7050,7051,-6202]],"id":"51021","properties":{"name":"Bland"}},{"type":"Polygon","arcs":[[7052,7053,-6246,7054,7055]],"id":"51183","properties":{"name":"Sussex"}},{"type":"Polygon","arcs":[[7056,-5472,7057,7058,7059]],"id":"51111","properties":{"name":"Lunenburg"}},{"type":"Polygon","arcs":[[7060,-3058,7061,-6842,7062,-6957]],"id":"54013","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[7063,-2448,-6201,7064,7065,-5832]],"id":"51027","properties":{"name":"Buchanan"}},{"type":"Polygon","arcs":[[7066,-7060,7067,7068,-3824,7069,-6225]],"id":"51117","properties":{"name":"Mecklenburg"}},{"type":"Polygon","arcs":[[-6686,-5762,7070,7071,7072,-805]],"id":"21017","properties":{"name":"Bourbon"}},{"type":"Polygon","arcs":[[-22,-3648,-3370,-4478]],"id":"16067","properties":{"name":"Minidoka"}},{"type":"Polygon","arcs":[[7073,-6876,-6738,7074]],"id":"37005","properties":{"name":"Alleghany"}},{"type":"Polygon","arcs":[[-3395,7075,7076,7077,7078,-5470]],"id":"51007","properties":{"name":"Amelia"}},{"type":"Polygon","arcs":[[7079,-5106,7080,-2283,7081,-6133]],"id":"51073","properties":{"name":"Gloucester"}},{"type":"Polygon","arcs":[[7082,-6268,-7017,7083,7084]],"id":"51171","properties":{"name":"Shenandoah"}},{"type":"Polygon","arcs":[[-5833,-7066,7085,-6772]],"id":"51051","properties":{"name":"Dickenson"}},{"type":"Polygon","arcs":[[7086,7087,7088,-958,-6944,7089,7090]],"id":"72141","properties":{"name":"Utuado"}},{"type":"Polygon","arcs":[[7091,-6148,7092,-4336,7093,-5864]],"id":"55005","properties":{"name":"Barron"}},{"type":"Polygon","arcs":[[7094,7095,7096,7097,-2126]],"id":"72003","properties":{"name":"Aguada"}},{"type":"Polygon","arcs":[[7098,7099,7100,7101]],"id":"53049","properties":{"name":"Pacific"}},{"type":"Polygon","arcs":[[7102,7103,7104,7105]],"id":"54045","properties":{"name":"Logan"}},{"type":"Polygon","arcs":[[7106,7107,-2745,7108,-1157]],"id":"06039","properties":{"name":"Madera"}},{"type":"Polygon","arcs":[[7109,7110,7111,-871,7112]],"id":"55061","properties":{"name":"Kewaunee"}},{"type":"Polygon","arcs":[[7113,-2147,7114,-1366,-3492,7115,-3025]],"id":"17135","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[-2156,-6341,7116,7117,7118,-6458,7119,7120]],"id":"08051","properties":{"name":"Gunnison"}},{"type":"Polygon","arcs":[[7121,-656,7122,-6715,7123]],"id":"18013","properties":{"name":"Brown"}},{"type":"Polygon","arcs":[[7124,7125,7126,7127,7128]],"id":"13101","properties":{"name":"Echols"}},{"type":"Polygon","arcs":[[7129,-5563,7130,-5384,-6793,-6732,-6863]],"id":"37085","properties":{"name":"Harnett"}},{"type":"Polygon","arcs":[[-6292,7131,7132,7133,7134,7135]],"id":"36107","properties":{"name":"Tioga"}},{"type":"Polygon","arcs":[[-6864,-6735,-6866,-5932]],"id":"37093","properties":{"name":"Hoke"}},{"type":"Polygon","arcs":[[7136,7137,7138,7139]],"id":"37143","properties":{"name":"Perquimans"}},{"type":"Polygon","arcs":[[-4631,-4997,7140,-5528,-1403]],"id":"47085","properties":{"name":"Humphreys"}},{"type":"Polygon","arcs":[[-688,-418,-1980,-2637,-188]],"id":"48381","properties":{"name":"Randall"}},{"type":"Polygon","arcs":[[-3301,7141,7142,7143,-5967,-164]],"id":"08023","properties":{"name":"Costilla"}},{"type":"MultiPolygon","arcs":[[[7144]],[[7145,-3914,7146,-1868,7147,7148,7149,7150]]],"id":"08123","properties":{"name":"Weld"}},{"type":"Polygon","arcs":[[7151,7152,-4046,7153,-4403]],"id":"13313","properties":{"name":"Whitfield"}},{"type":"Polygon","arcs":[[7154,7155,7156,7157,-6684,7158]],"id":"21023","properties":{"name":"Bracken"}},{"type":"Polygon","arcs":[[-4232,-6612,7159,-2569,7160]],"id":"18159","properties":{"name":"Tipton"}},{"type":"Polygon","arcs":[[7161,-4699,-6628,-4295,7162,-4824]],"id":"21207","properties":{"name":"Russell"}},{"type":"Polygon","arcs":[[-6032,-6576,-5926,7163,-5504]],"id":"21143","properties":{"name":"Lyon"}},{"type":"Polygon","arcs":[[-1046,-3303,7164,7165,7166,7167]],"id":"20025","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[-3591,-6226,-7070,-3826,-1082,7168,-5223]],"id":"37077","properties":{"name":"Granville"}},{"type":"MultiPolygon","arcs":[[[7169,7170]],[[-6839,7171,7172,7173,7174,7175]]],"id":"37095","properties":{"name":"Hyde"}},{"type":"Polygon","arcs":[[7176,-6566,7177,7178]],"id":"28125","properties":{"name":"Sharkey"}},{"type":"Polygon","arcs":[[-7090,-6943,7179,7180,7181,7182]],"id":"72001","properties":{"name":"Adjuntas"}},{"type":"Polygon","arcs":[[-6607,7183,7184,-883,7185]],"id":"13009","properties":{"name":"Baldwin"}},{"type":"Polygon","arcs":[[-4287,-4066,-6672,-2841,-6823,-6674]],"id":"21085","properties":{"name":"Grayson"}},{"type":"Polygon","arcs":[[-5668,-6418,-88,-456,-6421]],"id":"28115","properties":{"name":"Pontotoc"}},{"type":"Polygon","arcs":[[-628,7186,7187,-5376,7188]],"id":"31015","properties":{"name":"Boyd"}},{"type":"Polygon","arcs":[[7189]],"id":"51790","properties":{"name":"Staunton"}},{"type":"Polygon","arcs":[[-2533,7190,-3731,-5269,-4852,-6648]],"id":"31025","properties":{"name":"Cass"}},{"type":"Polygon","arcs":[[-1451,7191,-3156,-122,-4748,-543]],"id":"46073","properties":{"name":"Jerauld"}},{"type":"Polygon","arcs":[[-4797,-6450,-4803,-4921,7192,-284]],"id":"04003","properties":{"name":"Cochise"}},{"type":"Polygon","arcs":[[7193,-4456,-3501,-4598,7194,7195]],"id":"05113","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[-3083,-5710,7196,7197,7198,-3934]],"id":"45039","properties":{"name":"Fairfield"}},{"type":"MultiPolygon","arcs":[[[7199]],[[-3018,7200,7201,7202]],[[7203]]],"id":"06111","properties":{"name":"Ventura"}},{"type":"Polygon","arcs":[[7204,-2007,7205,7206,7207]],"id":"06059","properties":{"name":"Orange"}},{"type":"Polygon","arcs":[[7208,-3852,-3036,7209]],"id":"12053","properties":{"name":"Hernando"}},{"type":"Polygon","arcs":[[7210,7211,7212,7213,-4473,-3071]],"id":"13029","properties":{"name":"Bryan"}},{"type":"Polygon","arcs":[[-2763,-5765,7214,-232,7215,7216,-2736]],"id":"19109","properties":{"name":"Kossuth"}},{"type":"Polygon","arcs":[[7217,-2902,-2652,-4104,7218,-3364]],"id":"20187","properties":{"name":"Stanton"}},{"type":"Polygon","arcs":[[7219,-3272,-2333,7220,-3368,-4142,7221,-7143]],"id":"08071","properties":{"name":"Las Animas"}},{"type":"Polygon","arcs":[[-3026,-7116,-3494,7222,-3242,-5149,7223,7224,-5176]],"id":"17119","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[7225,-767,-625,7226,7227,7228,7229]],"id":"12015","properties":{"name":"Charlotte"}},{"type":"Polygon","arcs":[[-5545,-4882,-6397,7230,7231,-4052,7232]],"id":"18051","properties":{"name":"Gibson"}},{"type":"Polygon","arcs":[[7233,7234,-3722,-295]],"id":"19163","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[7235,-6128,-6811,-4130,7236,-4035,7237]],"id":"41035","properties":{"name":"Klamath"}},{"type":"Polygon","arcs":[[-5374,-2790,7238,-1670,-7047]],"id":"48123","properties":{"name":"DeWitt"}},{"type":"Polygon","arcs":[[7239,-338,7240,7241,7242,7243,7244]],"id":"01023","properties":{"name":"Choctaw"}},{"type":"Polygon","arcs":[[7245,7246,7247,-4594,7248,-7241,-337]],"id":"01119","properties":{"name":"Sumter"}},{"type":"Polygon","arcs":[[7249,-1690,7250,7251,7252,7253,-4221]],"id":"05015","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[7254,7255,-5046,-2002,7256,-7201,-3017,7257]],"id":"06029","properties":{"name":"Kern"}},{"type":"MultiPolygon","arcs":[[[-7227,7258,7259,7260]],[[7261]],[[-7229,7262]]],"id":"12071","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[7263,-475,-6457,7264,-1793,7265,7266]],"id":"08107","properties":{"name":"Routt"}},{"type":"Polygon","arcs":[[7267,7268,7269,7270,7271,7272,7273]],"id":"17181","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[-3302,-740,-5908,7274,-7165]],"id":"20033","properties":{"name":"Comanche"}},{"type":"Polygon","arcs":[[7275,7276,-4694,-6673,-1338,-6492]],"id":"21059","properties":{"name":"Daviess"}},{"type":"MultiPolygon","arcs":[[[7277]],[[7278]],[[7279,7280,7281]]],"id":"22087","properties":{"name":"St. Bernard"}},{"type":"Polygon","arcs":[[7282,7283,-4048,7284,7285]],"id":"16005","properties":{"name":"Bannock"}},{"type":"Polygon","arcs":[[7286,-1604,-4207,-2982,-898,-3324,-5244]],"id":"20153","properties":{"name":"Rawlins"}},{"type":"Polygon","arcs":[[7287,7288,7289,7290,7291,-2111]],"id":"13275","properties":{"name":"Thomas"}},{"type":"Polygon","arcs":[[7292,7293,-1854,7294,-3298,7295,7296]],"id":"13099","properties":{"name":"Early"}},{"type":"Polygon","arcs":[[-5799,-6331,-4078,7297]],"id":"16081","properties":{"name":"Teton"}},{"type":"Polygon","arcs":[[-3543,-5198,-5242,-5474,7298,7299]],"id":"24015","properties":{"name":"Cecil"}},{"type":"Polygon","arcs":[[-484,7300,7301,-83]],"id":"26147","properties":{"name":"St. Clair"}},{"type":"Polygon","arcs":[[-3840,7302,7303,7304,-3676,7305,7306]],"id":"05107","properties":{"name":"Phillips"}},{"type":"Polygon","arcs":[[7307,7308,-5510,7309,7310]],"id":"06013","properties":{"name":"Contra Costa"}},{"type":"Polygon","arcs":[[7311,-5304,7312,7313,7314]],"id":"09009","properties":{"name":"New Haven"}},{"type":"Polygon","arcs":[[-7231,-6396,-6537,7315,-7276,-6491,7316]],"id":"18173","properties":{"name":"Warrick"}},{"type":"Polygon","arcs":[[7317,-4415,7318,7319,7320,7321,-4470]],"id":"18019","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[7322,7323,7324,-2506,7325,-3850]],"id":"12069","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[7326,7327,7328,7329]],"id":"21037","properties":{"name":"Campbell"}},{"type":"Polygon","arcs":[[7330,-2513,7331,-4841,7332,7333]],"id":"22037","properties":{"name":"East Feliciana"}},{"type":"Polygon","arcs":[[7334,7335,7336,7337,-6212]],"id":"12121","properties":{"name":"Suwannee"}},{"type":"MultiPolygon","arcs":[[[7338,-7334,7339,-4092,7340]],[[7341,-4090,7342]]],"id":"22125","properties":{"name":"West Feliciana"}},{"type":"MultiPolygon","arcs":[[[-3339,7343]],[[7344]],[[7345]],[[-3655,7346,7347]]],"id":"23013","properties":{"name":"Knox"}},{"type":"Polygon","arcs":[[7348,7349,7350,7351,-1617]],"id":"26163","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[-4560,7352,7353,7354,7355]],"id":"28033","properties":{"name":"DeSoto"}},{"type":"Polygon","arcs":[[7356,-5232,7357,7358,7359,-5482]],"id":"24027","properties":{"name":"Howard"}},{"type":"Polygon","arcs":[[7360,7361,7362,7363,-7268,7364,-6639,-4240]],"id":"29157","properties":{"name":"Perry"}},{"type":"Polygon","arcs":[[-5173,7365,7366,7367,7368,7369,7370,7371,7372,-1302,-4431]],"id":"29113","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-2889,7373,7374,7375,7376]],"id":"27057","properties":{"name":"Hubbard"}},{"type":"Polygon","arcs":[[-2546,-4103,-1648,7377,7378,7379]],"id":"20021","properties":{"name":"Cherokee"}},{"type":"Polygon","arcs":[[7380,-6258,7381,-5342,-5693,7382]],"id":"27011","properties":{"name":"Big Stone"}},{"type":"Polygon","arcs":[[-5240,7383,7384,-999,7385,-5475]],"id":"10001","properties":{"name":"Kent"}},{"type":"Polygon","arcs":[[7386,-3053,7387,7388]],"id":"16075","properties":{"name":"Payette"}},{"type":"Polygon","arcs":[[-1198,-3141,-6898,7389,-2676]],"id":"18151","properties":{"name":"Steuben"}},{"type":"Polygon","arcs":[[-1768,7390,-5365,7391,7392,7393]],"id":"12075","properties":{"name":"Levy"}},{"type":"Polygon","arcs":[[-3202,-6474,7394,7395,-7126,7396]],"id":"13065","properties":{"name":"Clinch"}},{"type":"Polygon","arcs":[[7397,7398,-2800,-5306,7399]],"id":"26027","properties":{"name":"Cass"}},{"type":"Polygon","arcs":[[-4559,7400,7401,-5664,-6420,7402,-7353]],"id":"28093","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[-385,-4235,-1331,-1621,7403,-5841,-1357]],"id":"26081","properties":{"name":"Kent"}},{"type":"Polygon","arcs":[[7404,7405,-5625,-154,-2950,7406,7407]],"id":"31135","properties":{"name":"Perkins"}},{"type":"Polygon","arcs":[[7408,7409,7410,7411]],"id":"34029","properties":{"name":"Ocean"}},{"type":"Polygon","arcs":[[-3509,7412,-4411,7413,-5661,7414]],"id":"18167","properties":{"name":"Vigo"}},{"type":"Polygon","arcs":[[7415,-6658,-6293,-7136,7416,-6819]],"id":"36015","properties":{"name":"Chemung"}},{"type":"Polygon","arcs":[[-4507,7417,-6861,-3122,7418,-6399]],"id":"18155","properties":{"name":"Switzerland"}},{"type":"Polygon","arcs":[[7419,-7375,7420,-3531,-2131]],"id":"27159","properties":{"name":"Wadena"}},{"type":"Polygon","arcs":[[7421,-4554,-2561,7422,-5780,-5716,-1481]],"id":"56027","properties":{"name":"Niobrara"}},{"type":"Polygon","arcs":[[-4073,7423,7424,-307,7425,-6357]],"id":"29013","properties":{"name":"Bates"}},{"type":"Polygon","arcs":[[7426,-389,-2378,7427,7428,7429]],"id":"31129","properties":{"name":"Nuckolls"}},{"type":"Polygon","arcs":[[-78,-6400,-7419,-3127,7430,-7319,-4414]],"id":"18077","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[7431,7432,7433,-4509,7434,7435,7436]],"id":"34003","properties":{"name":"Bergen"}},{"type":"Polygon","arcs":[[7437,7438,7439,7440,-7433,7441]],"id":"36119","properties":{"name":"Westchester"}},{"type":"Polygon","arcs":[[-395,7442,7443,7444]],"id":"36063","properties":{"name":"Niagara"}},{"type":"Polygon","arcs":[[7445,-6736,-4191,7446,-4740]],"id":"37189","properties":{"name":"Watauga"}},{"type":"Polygon","arcs":[[7447,-868,-3530,7448,-5344]],"id":"27023","properties":{"name":"Chippewa"}},{"type":"Polygon","arcs":[[-5418,7449,7450,7451,7452]],"id":"40071","properties":{"name":"Kay"}},{"type":"Polygon","arcs":[[-581,7453,-5501,-5500,-5291,7454]],"id":"17151","properties":{"name":"Pope"}},{"type":"Polygon","arcs":[[-5901,7455,7456,-6857,7457,-6366,-5732,-5077]],"id":"42089","properties":{"name":"Monroe"}},{"type":"MultiPolygon","arcs":[[[-6789,-6479]],[[-5217,-6481,-6792,7458,-4923,-5227,-6097]]],"id":"35043","properties":{"name":"Sandoval"}},{"type":"Polygon","arcs":[[-3095,-1529,-5796,-2669,7459]],"id":"16033","properties":{"name":"Clark"}},{"type":"MultiPolygon","arcs":[[[7460,7461,-1597,-2640,7462]],[[7463]],[[7464]],[[7465]],[[7466]]],"id":"26029","properties":{"name":"Charlevoix"}},{"type":"Polygon","arcs":[[-2705,-1619,7467,-3715,7468,-3138]],"id":"26091","properties":{"name":"Lenawee"}},{"type":"Polygon","arcs":[[-6317,-6987,7469,-3308,7470]],"id":"27157","properties":{"name":"Wabasha"}},{"type":"Polygon","arcs":[[7471,-2457,-5042,-5887,7472]],"id":"29047","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[7473,7474,-2784,-6796,-6744,7475]],"id":"40081","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-5393,-1469,-1195,-5488,7476,-3421,7477,7478]],"id":"47069","properties":{"name":"Hardeman"}},{"type":"Polygon","arcs":[[7479,-2909,7480,-2886,7481]],"id":"27071","properties":{"name":"Koochiching"}},{"type":"Polygon","arcs":[[-31,-2247,7482,7483,-36,-6158]],"id":"27107","properties":{"name":"Norman"}},{"type":"Polygon","arcs":[[-3510,-7415,-5660,7484,-3252,-3414,7485]],"id":"17023","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[-7483,-2246,7486,-7376,-7420,-2130,7487]],"id":"27005","properties":{"name":"Becker"}},{"type":"Polygon","arcs":[[7488,-3315,-1156,-3639,-5432,7489]],"id":"19085","properties":{"name":"Harrison"}},{"type":"Polygon","arcs":[[7490,-3441,7491,7492,-3677,-7305]],"id":"28027","properties":{"name":"Coahoma"}},{"type":"Polygon","arcs":[[-4660,7493,-4146,7494,7495,-192,7496,7497,-4249,7498]],"id":"35037","properties":{"name":"Quay"}},{"type":"Polygon","arcs":[[-6652,7499,7500,7501,7502,7503]],"id":"34023","properties":{"name":"Middlesex"}},{"type":"Polygon","arcs":[[-3815,7504,7505,7506,7507,-4599,-2122]],"id":"54071","properties":{"name":"Pendleton"}},{"type":"Polygon","arcs":[[-2428,7508,7509,7510,-5622]],"id":"05003","properties":{"name":"Ashley"}},{"type":"Polygon","arcs":[[-3678,-7493,7511,7512,-6562,7513]],"id":"28133","properties":{"name":"Sunflower"}},{"type":"Polygon","arcs":[[7514,-7355,7515,7516,-3438,-7491,-7304,7517]],"id":"28143","properties":{"name":"Tunica"}},{"type":"Polygon","arcs":[[-711,-4819,7518,-3455,-2439,7519]],"id":"29171","properties":{"name":"Putnam"}},{"type":"Polygon","arcs":[[-4818,-3214,-1708,-3456,-7519]],"id":"29197","properties":{"name":"Schuyler"}},{"type":"Polygon","arcs":[[7520,7521,7522,-3812,-3054,-7061,-6956]],"id":"54085","properties":{"name":"Ritchie"}},{"type":"Polygon","arcs":[[7523,-3294,-3809,-7523,7524,7525]],"id":"54095","properties":{"name":"Tyler"}},{"type":"Polygon","arcs":[[-4724,7526,7527,7528,7529,-3610]],"id":"51063","properties":{"name":"Floyd"}},{"type":"Polygon","arcs":[[-4543,-4014,7530,7531,-302,7532]],"id":"30055","properties":{"name":"McCone"}},{"type":"Polygon","arcs":[[-2208,-6622,7533,-3318,7534,-5650]],"id":"20177","properties":{"name":"Shawnee"}},{"type":"Polygon","arcs":[[-7390,-6897,-1088,-2198,-893]],"id":"18033","properties":{"name":"DeKalb"}},{"type":"Polygon","arcs":[[7535,-1518,-101,-268]],"id":"46101","properties":{"name":"Moody"}},{"type":"Polygon","arcs":[[-7332,-2512,-19,7536,-4842]],"id":"22091","properties":{"name":"St. Helena"}},{"type":"Polygon","arcs":[[7537,-3690,3688,-3688,7538,-4179,7539]],"id":"55051","properties":{"name":"Iron"}},{"type":"Polygon","arcs":[[7540,-3795,7541,-5026,7542,7543]],"id":"48475","properties":{"name":"Ward"}},{"type":"Polygon","arcs":[[7544,-3728,-4758,7545,-7044]],"id":"48485","properties":{"name":"Wichita"}},{"type":"MultiPolygon","arcs":[[[-6503,7546,7547,7548]],[[-6507,7549,7550,7551]]],"id":"48489","properties":{"name":"Willacy"}},{"type":"Polygon","arcs":[[7552,7553,-3870,7554,7555,-6632,7556]],"id":"22083","properties":{"name":"Richland"}},{"type":"Polygon","arcs":[[-1705,-2171,7557,7558,7559,7560]],"id":"29045","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[7561,7562,7563,-3291]],"id":"54049","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[7564,7565,7566,-7521,-6960,7567,-3960]],"id":"54107","properties":{"name":"Wood"}},{"type":"Polygon","arcs":[[-3292,-7564,7568,-5330,7569,7570,-3810]],"id":"54033","properties":{"name":"Harrison"}},{"type":"Polygon","arcs":[[7571,7572,-4544,-7533,-301,-4574]],"id":"30105","properties":{"name":"Valley"}},{"type":"Polygon","arcs":[[7573,7574,7575,-3661,7576]],"id":"25009","properties":{"name":"Essex"}},{"type":"Polygon","arcs":[[7577,-4742,7578,-4710,7579,-1486]],"id":"47019","properties":{"name":"Carter"}},{"type":"Polygon","arcs":[[-322,7580,7581,-5849,7582,7583,7584]],"id":"47147","properties":{"name":"Robertson"}},{"type":"Polygon","arcs":[[-2427,7585,-3680,7586,7587,-3867,7588,7589,-7509]],"id":"05017","properties":{"name":"Chicot"}},{"type":"Polygon","arcs":[[-7160,-6615,7590,7591,-2216,-2570]],"id":"18057","properties":{"name":"Hamilton"}},{"type":"Polygon","arcs":[[7592,-2225,-4233,-7161,-2568,7593]],"id":"18067","properties":{"name":"Howard"}},{"type":"Polygon","arcs":[[-2217,-7592,7594,-1581,-653,7595,-1561]],"id":"18097","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[-5924,-2571,-2218,-1564,7596,-4408,-5816]],"id":"18107","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[7597,7598,-2938,-2964,-6724,-6729]],"id":"28089","properties":{"name":"Madison"}},{"type":"MultiPolygon","arcs":[[[7599,7600,-2271]]],"id":"26033","properties":{"name":"Chippewa"}},{"type":"MultiPolygon","arcs":[[[7601]],[[-2272,-7601,7602,7603]]],"id":"26097","properties":{"name":"Mackinac"}},{"type":"Polygon","arcs":[[7604,7605,7606,7607,-5210]],"id":"12089","properties":{"name":"Nassau"}},{"type":"Polygon","arcs":[[-7563,7608,-5404,-5327,-7569]],"id":"54091","properties":{"name":"Taylor"}},{"type":"Polygon","arcs":[[-4746,7609,-5647,-4042,-7153,7610]],"id":"47011","properties":{"name":"Bradley"}},{"type":"Polygon","arcs":[[7611,7612,7613,-7335,-6211,7614,7615]],"id":"12079","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[7616,-3209,7617,7618,-6564]],"id":"28051","properties":{"name":"Holmes"}},{"type":"Polygon","arcs":[[7619,-3484,-6183,-6178,-1395,-6115]],"id":"47183","properties":{"name":"Weakley"}},{"type":"Polygon","arcs":[[7620,-5701,-6318,-7471,-3307,-3145,-1945]],"id":"27049","properties":{"name":"Goodhue"}},{"type":"Polygon","arcs":[[7621,7622,-917,-1535,7623,7624]],"id":"29077","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[7625,7626,-3585,7627,-4026,7628,-3629]],"id":"01111","properties":{"name":"Randolph"}},{"type":"Polygon","arcs":[[-3897,-4874,7629,7630,-1626]],"id":"35013","properties":{"name":"DoÃ±a Ana"}},{"type":"Polygon","arcs":[[7631,7632,-6976,-5631,-5630,7633,-6925]],"id":"42119","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[-2730,-277,-3937,7634,-6017]],"id":"46119","properties":{"name":"Sully"}},{"type":"Polygon","arcs":[[-1640,-5986,-997,7635,-5618,7636]],"id":"33003","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[-2929,7637]],"id":"51770","properties":{"name":"Roanoke"}},{"type":"Polygon","arcs":[[-5904,-3724,-5388,-4536,-2212,-2912]],"id":"19115","properties":{"name":"Louisa"}},{"type":"Polygon","arcs":[[-2816,7638,7639,-6218,-5270]],"id":"19145","properties":{"name":"Page"}},{"type":"Polygon","arcs":[[-5709,-5085,-5193,-5778,-5949,7640,-7197]],"id":"45055","properties":{"name":"Kershaw"}},{"type":"Polygon","arcs":[[7641,-7285,-4047,-3372,-3647]],"id":"16077","properties":{"name":"Power"}},{"type":"Polygon","arcs":[[7642,-3275,7643]],"id":"41011","properties":{"name":"Coos"}},{"type":"Polygon","arcs":[[-6129,-7236,7644,-2611,-3276,-7643,7645]],"id":"41019","properties":{"name":"Douglas"}},{"type":"Polygon","arcs":[[-4614,-2838,7646,7647,7648]],"id":"55023","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[7649,7650,-1741,7651,7652,-3971],[7653]],"id":"51005","properties":{"name":"Alleghany"}},{"type":"Polygon","arcs":[[-4931,-5680,7654,7655,-4721,-3607,-7050]],"id":"51071","properties":{"name":"Giles"}},{"type":"Polygon","arcs":[[-7337,7656,-7127,-7396,7657,7658,-5360,7659]],"id":"12023","properties":{"name":"Columbia"}},{"type":"Polygon","arcs":[[7660,-2467,7661,-135,7662,-3473]],"id":"72007","properties":{"name":"Aguas Buenas"}},{"type":"Polygon","arcs":[[-955,7663,-151,-2477,-3288,7664,-6209,-4171]],"id":"72107","properties":{"name":"Orocovis"}},{"type":"Polygon","arcs":[[-5719,7665,7666,7667]],"id":"27123","properties":{"name":"Ramsey"}},{"type":"Polygon","arcs":[[7668,-4368,7669,7670,-1791,7671,7672]],"id":"49047","properties":{"name":"Uintah"}},{"type":"Polygon","arcs":[[7673,7674,7675,-4567,7676,-7528]],"id":"51067","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[7677,-3557]],"id":"15005","properties":{"name":"Kalawao"}},{"type":"Polygon","arcs":[[-5155,-4622,-6277,7678,7679,-6619,-2206]],"id":"20005","properties":{"name":"Atchison"}},{"type":"Polygon","arcs":[[7680,-6497,-6441,7681,7682]],"id":"09015","properties":{"name":"Windham"}},{"type":"Polygon","arcs":[[7683,7684,-7682,-6440,7685,7686,-5302]],"id":"09011","properties":{"name":"New London"}},{"type":"Polygon","arcs":[[7687,7688,7689,7690,-3536,-6755]],"id":"41005","properties":{"name":"Clackamas"}},{"type":"Polygon","arcs":[[-1103,-5222,-5739,7691,-1745,-7026,7692]],"id":"48419","properties":{"name":"Shelby"}},{"type":"Polygon","arcs":[[7693,-5893,-1014,7694,7695,-4325,7696]],"id":"39029","properties":{"name":"Columbiana"}},{"type":"Polygon","arcs":[[-1161,7697,-7255,7698,-1299]],"id":"06031","properties":{"name":"Kings"}},{"type":"Polygon","arcs":[[7699,-3021,-2222,7700,7701,7702,7703]],"id":"06045","properties":{"name":"Mendocino"}},{"type":"Polygon","arcs":[[-4398,-1881,7704,-2339,-6339]],"id":"08035","properties":{"name":"Douglas"}},{"type":"Polygon","arcs":[[-549,-3116,-3769,7705,7706,-2918]],"id":"48259","properties":{"name":"Kendall"}},{"type":"Polygon","arcs":[[7707,7708,-3832,7709,-7252]],"id":"05009","properties":{"name":"Boone"}},{"type":"Polygon","arcs":[[-6801,7710,7711,-7474,7712,-1392]],"id":"40083","properties":{"name":"Logan"}},{"type":"Polygon","arcs":[[7713,-4141,7714,7715,-3707]],"id":"36065","properties":{"name":"Oneida"}},{"type":"Polygon","arcs":[[7716,-6688,7717,7718,7719,7720]],"id":"37113","properties":{"name":"Macon"}},{"type":"Polygon","arcs":[[7721,7722,7723,7724,7725,7726,7727]],"id":"36031","properties":{"name":"Essex"}},{"type":"Polygon","arcs":[[-2124,-4601,7728,7729,-7650,-3970]],"id":"51017","properties":{"name":"Bath"}},{"type":"Polygon","arcs":[[7730,7731,7732,7733,-7104]],"id":"54005","properties":{"name":"Boone"}},{"type":"Polygon","arcs":[[7734,7735,-3974,-5678,7736]],"id":"54019","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[7737,7738,-6845,-7735,7739,-7732,7740,7741]],"id":"54039","properties":{"name":"Kanawha"}},{"type":"Polygon","arcs":[[7742,7743,7744,7745,-6882]],"id":"72037","properties":{"name":"Ceiba"}},{"type":"Polygon","arcs":[[7746,-160,7747,-152,-7664,-954,-7089]],"id":"72039","properties":{"name":"Ciales"}},{"type":"Polygon","arcs":[[7748,-7266,-1792,-7671]],"id":"08103","properties":{"name":"Rio Blanco"}},{"type":"Polygon","arcs":[[-1562,-7596,-657,-7122,7749,-6531,7750]],"id":"18109","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[7751,-6635,7752,7753,7754,-4848]],"id":"22059","properties":{"name":"LaSalle"}},{"type":"Polygon","arcs":[[-1543,-6783,7755,-5107,7756]],"id":"29135","properties":{"name":"Moniteau"}},{"type":"Polygon","arcs":[[-4887,7757,-1680,-5895,7758,7759]],"id":"42039","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[-5956,-5425,7760,7761,7762,-6803,-5988]],"id":"21205","properties":{"name":"Rowan"}},{"type":"Polygon","arcs":[[-4995,7763,7764,7765,7766,-5555,7767]],"id":"47187","properties":{"name":"Williamson"}},{"type":"Polygon","arcs":[[-1675,-1012,-754,7768,-344]],"id":"38081","properties":{"name":"Sargent"}},{"type":"Polygon","arcs":[[-6989,-3328,7769,7770]],"id":"72055","properties":{"name":"GuÃ¡nica"}},{"type":"Polygon","arcs":[[7771,-3259,7772]],"id":"16061","properties":{"name":"Lewis"}},{"type":"Polygon","arcs":[[7773,7774,7775,-7773,-3258,7776,7777]],"id":"16069","properties":{"name":"Nez Perce"}},{"type":"Polygon","arcs":[[7778,-7430,7779,-1551,-6403,7780,-4864]],"id":"20089","properties":{"name":"Jewell"}},{"type":"Polygon","arcs":[[7781,-3401,7782,-5648,7783,-3066]],"id":"20117","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[-3400,-4204,-5156,-2204,-5649,-7783]],"id":"20131","properties":{"name":"Nemaha"}},{"type":"Polygon","arcs":[[7784,-4223,-3351,7785,7786,-2234]],"id":"40001","properties":{"name":"Adair"}},{"type":"Polygon","arcs":[[-7720,7787,7788,7789,7790]],"id":"37043","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[7791,-3948,-5947,-4547,-5946,-4545,-6527,7792,7793,7794,7795]],"id":"45073","properties":{"name":"Oconee"}},{"type":"Polygon","arcs":[[-3350,7796,7797,7798,7799,-7786]],"id":"05033","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[-3143,-2255,-6618,-2649,-2901]],"id":"20093","properties":{"name":"Kearny"}},{"type":"Polygon","arcs":[[7800]],"id":"72049","properties":{"name":"Culebra"}},{"type":"Polygon","arcs":[[-2630,-6561,7801,7802,7803,7804]],"id":"28091","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[7805,-6422,-459,-2431,7806]],"id":"28161","properties":{"name":"Yalobusha"}},{"type":"Polygon","arcs":[[7807,-2373,-1058,-2733,-176,-2980,-4206]],"id":"31065","properties":{"name":"Furnas"}},{"type":"Polygon","arcs":[[7808,7809,-5588,-4351,7810]],"id":"53015","properties":{"name":"Cowlitz"}},{"type":"Polygon","arcs":[[-1092,7811,7812,-2402,7813,-4215]],"id":"01083","properties":{"name":"Limestone"}},{"type":"Polygon","arcs":[[7814,7815,7816,-2462]],"id":"12013","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[7817,-3853,-7209,7818,-7393]],"id":"12017","properties":{"name":"Citrus"}},{"type":"Polygon","arcs":[[-7588,7819,-7179,7820,-3698,-3868]],"id":"28055","properties":{"name":"Issaquena"}},{"type":"Polygon","arcs":[[7821,-4472,7822,-4060,-6826,-4465]],"id":"18061","properties":{"name":"Harrison"}},{"type":"Polygon","arcs":[[-7219,-4108,-6998,7823,-3365]],"id":"20129","properties":{"name":"Morton"}},{"type":"Polygon","arcs":[[-4708,-6364,7824,-3931,-6952,-1068]],"id":"45083","properties":{"name":"Spartanburg"}},{"type":"Polygon","arcs":[[-1549,-3257,7825,-3434,7826,-6404]],"id":"20143","properties":{"name":"Ottawa"}},{"type":"Polygon","arcs":[[7827,7828,-4645]],"id":"30103","properties":{"name":"Treasure"}},{"type":"Polygon","arcs":[[7829,-5073,-4972,7830,7831,-1662]],"id":"31051","properties":{"name":"Dixon"}},{"type":"Polygon","arcs":[[7832,7833,-6149,-7092,-5863,-5752]],"id":"55013","properties":{"name":"Burnett"}},{"type":"Polygon","arcs":[[7834,-6011,-5690,7835,-3162,7836,7837]],"id":"55025","properties":{"name":"Dane"}},{"type":"Polygon","arcs":[[7838,7839,7840,7841,7842,-4342,7843,-4831]],"id":"22007","properties":{"name":"Assumption"}},{"type":"Polygon","arcs":[[7844,7845,7846,7847,-6858,-7457,7848]],"id":"42127","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[7849,-7715,-4140,7850,-51,7851,7852]],"id":"36077","properties":{"name":"Otsego"}},{"type":"Polygon","arcs":[[7853,7854,-3925,-2391,7855,-2357]],"id":"40049","properties":{"name":"Garvin"}},{"type":"Polygon","arcs":[[-4515,7856,-7728,7857,7858,7859,-4137]],"id":"36041","properties":{"name":"Hamilton"}},{"type":"Polygon","arcs":[[-4222,-7254,7860,7861,7862,-7797,-3349]],"id":"05087","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[7863,-7845,7864,-5883,7865,-7134]],"id":"42115","properties":{"name":"Susquehanna"}},{"type":"MultiPolygon","arcs":[[[7866]],[[7867,7868,7869,7870]]],"id":"12037","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-848,-2113,7871,7872,7873,7874,7875]],"id":"12039","properties":{"name":"Gadsden"}},{"type":"Polygon","arcs":[[-2463,-7817,7876,-7871,7877]],"id":"12045","properties":{"name":"Gulf"}},{"type":"Polygon","arcs":[[7878,-7291,7879,-7616,7880,7881,7882]],"id":"12065","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[7883,-3040,7884,7885,-3042]],"id":"12103","properties":{"name":"Pinellas"}},{"type":"Polygon","arcs":[[7886,7887,-533,7888,-6948,-1940,-537]],"id":"40075","properties":{"name":"Kiowa"}},{"type":"Polygon","arcs":[[-7798,-7863,7889,-5036,7890]],"id":"05047","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[7891,7892,-2780,7893,7894]],"id":"40117","properties":{"name":"Pawnee"}},{"type":"Polygon","arcs":[[-3927,7895,7896,7897,7898,7899,-2393]],"id":"40069","properties":{"name":"Johnston"}},{"type":"Polygon","arcs":[[-1149,-5320,7900,7901,-1698,-6266,7902]],"id":"29081","properties":{"name":"Harrison"}},{"type":"Polygon","arcs":[[-6779,7903,7904,7905,-6558,-2628]],"id":"28031","properties":{"name":"Covington"}},{"type":"Polygon","arcs":[[7906,-7811,-4350,-6966,7907,-7101]],"id":"53069","properties":{"name":"Wahkiakum"}},{"type":"Polygon","arcs":[[7908,7909,7910,7911,7912]],"id":"12019","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[-2273,-7604,7913,7914,-5129]],"id":"26153","properties":{"name":"Schoolcraft"}},{"type":"Polygon","arcs":[[-1762,-2907,7915,-4609,-6147,-7834,7916]],"id":"55031","properties":{"name":"Douglas"}},{"type":"MultiPolygon","arcs":[[[7917,7918,7919]],[[7920,7921,7922,7923,-1957,-195,7924]]],"id":"13193","properties":{"name":"Macon"}},{"type":"Polygon","arcs":[[7925,7926,-5617,-5613,-1261,-5491]],"id":"22027","properties":{"name":"Claiborne"}},{"type":"Polygon","arcs":[[-7703,7927,7928,7929,7930,7931,7932]],"id":"06097","properties":{"name":"Sonoma"}},{"type":"Polygon","arcs":[[-3923,-6748,7933,-7854,-2356,7934]],"id":"40087","properties":{"name":"McClain"}},{"type":"Polygon","arcs":[[7935,-2617,-6649,-3891,-3402,-7782,-3065]],"id":"31067","properties":{"name":"Gage"}},{"type":"Polygon","arcs":[[7936,-5773,-5983,7937,-3106,7938,7939]],"id":"48343","properties":{"name":"Morris"}},{"type":"Polygon","arcs":[[-7713,-7476,-6743,-3921,7940]],"id":"40109","properties":{"name":"Oklahoma"}},{"type":"Polygon","arcs":[[7941,-2365,-6690,7942,-2382]],"id":"48223","properties":{"name":"Hopkins"}},{"type":"Polygon","arcs":[[-4139,7943,7944,7945,-46,-7851]],"id":"36057","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[7946,-6262,7947,7948,-7892,7949,-7451]],"id":"40113","properties":{"name":"Osage"}},{"type":"Polygon","arcs":[[7950,-318,7951,7952]],"id":"12113","properties":{"name":"Santa Rosa"}},{"type":"Polygon","arcs":[[-7325,7953,-2503]],"id":"12117","properties":{"name":"Seminole"}},{"type":"Polygon","arcs":[[-1853,7954,7955,-845,-3296,-7295]],"id":"13007","properties":{"name":"Baker"}},{"type":"Polygon","arcs":[[7956,7957,-4400,-4448,7958]],"id":"13083","properties":{"name":"Dade"}},{"type":"Polygon","arcs":[[7959,7960,7961,7962,-7955,-1852]],"id":"13095","properties":{"name":"Dougherty"}},{"type":"Polygon","arcs":[[-7963,7963,7964,-7288,-2110,-846,-7956]],"id":"13205","properties":{"name":"Mitchell"}},{"type":"Polygon","arcs":[[-7296,-3297,-843,7965,7966]],"id":"13253","properties":{"name":"Seminole"}},{"type":"Polygon","arcs":[[7967,-7894,-2785,-7475,-7712]],"id":"40119","properties":{"name":"Payne"}},{"type":"Polygon","arcs":[[-5976,7968,-4298,-438,-6035,-6083]],"id":"47137","properties":{"name":"Pickett"}},{"type":"Polygon","arcs":[[-5794,-6763,7969,-5741,-6670]],"id":"21087","properties":{"name":"Green"}},{"type":"Polygon","arcs":[[-5017,-2385,-5003,7970]],"id":"48397","properties":{"name":"Rockwall"}},{"type":"MultiPolygon","arcs":[[[7971]],[[7972,-3975]]],"id":"78020","properties":{"name":"St. John"}},{"type":"Polygon","arcs":[[-4872,7973,-3234,7974,7975]],"id":"48229","properties":{"name":"Hudspeth"}},{"type":"Polygon","arcs":[[-6958,-7063,-6841,-7739,7976]],"id":"54087","properties":{"name":"Roane"}},{"type":"Polygon","arcs":[[-6627,-6543,-3944,-6498,-433,-4297]],"id":"21147","properties":{"name":"McCreary"}},{"type":"Polygon","arcs":[[7977,7978,-7245,7979,7980,-6429,7981]],"id":"28153","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[-7647,-2837,7982,7983,-4109,-4821,7984]],"id":"55043","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[7985,7986,7987,-7341,-4091,-7342,7988,7989]],"id":"22029","properties":{"name":"Concordia"}},{"type":"Polygon","arcs":[[-6704,6702,-6702,6700,-6700,6698,-6698,-6697,6696,-6697,-6696,6694,-6694,-6693,-6692,-3109,-2597,7990,7991,7992,-2369]],"id":"48423","properties":{"name":"Smith"}},{"type":"Polygon","arcs":[[7993,-7722,-7857,-4514,7994]],"id":"36033","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[7995,7996,-3704,7997,-3702,7998,-4523,7999,-7986,8000]],"id":"22107","properties":{"name":"Tensas"}},{"type":"Polygon","arcs":[[8001,8002,-2514,-7331,-7339,-7988]],"id":"28157","properties":{"name":"Wilkinson"}},{"type":"Polygon","arcs":[[-3701,-6730,-6424,-4519,-7999]],"id":"28021","properties":{"name":"Claiborne"}},{"type":"Polygon","arcs":[[-339,-7240,-7979,8003]],"id":"28023","properties":{"name":"Clarke"}},{"type":"Polygon","arcs":[[-2517,8004,-4968,-1448,-272,-2729]],"id":"46049","properties":{"name":"Faulk"}},{"type":"Polygon","arcs":[[-1458,-5557,-1094,-4214,8005]],"id":"47099","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[-7906,8006,-6432,-449,8007,-6559]],"id":"28035","properties":{"name":"Forrest"}},{"type":"Polygon","arcs":[[8008,8009,-638,8010,8011,-7809,-7907,-7100]],"id":"53041","properties":{"name":"Lewis"}},{"type":"Polygon","arcs":[[-7676,8012,8013,-6222,8014,-1284,8015,-814,-4568]],"id":"51143","properties":{"name":"Pittsylvania"}},{"type":"Polygon","arcs":[[-333,8016,8017,8018,-6445]],"id":"54027","properties":{"name":"Hampshire"}},{"type":"Polygon","arcs":[[-6519,8019,-986,-2606,8020,8021]],"id":"06115","properties":{"name":"Yuba"}},{"type":"Polygon","arcs":[[-6565,-7619,-7598,-6728,-3699,-7821,-7178]],"id":"28163","properties":{"name":"Yazoo"}},{"type":"Polygon","arcs":[[-2925,8022,-6822,-6978,8023,-5068,8024]],"id":"42105","properties":{"name":"Potter"}},{"type":"Polygon","arcs":[[-132,-6508,-7552,8025,8026,8027]],"id":"48215","properties":{"name":"Hidalgo"}},{"type":"Polygon","arcs":[[8028,8029]],"id":"51131","properties":{"name":"Northampton"}},{"type":"Polygon","arcs":[[-4516,-4135,-7714,-3706,-6354]],"id":"36049","properties":{"name":"Lewis"}},{"type":"Polygon","arcs":[[8030,-7925,-194,8031]],"id":"13249","properties":{"name":"Schley"}},{"type":"Polygon","arcs":[[8032,-7648,-7985,-4820,-965,-3859]],"id":"19043","properties":{"name":"Clayton"}},{"type":"Polygon","arcs":[[-6709,8033,-7140,8034]],"id":"37041","properties":{"name":"Chowan"}},{"type":"Polygon","arcs":[[8035,8036,-4452,-4944,8037,8038,-2404]],"id":"01095","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[8039,8040,8041,-7846,-7864,-7133]],"id":"36007","properties":{"name":"Broome"}},{"type":"Polygon","arcs":[[-7946,8042,-6305,-47]],"id":"36093","properties":{"name":"Schenectady"}},{"type":"Polygon","arcs":[[8043,-2389,8044,-7031,8045]],"id":"48041","properties":{"name":"Brazos"}},{"type":"Polygon","arcs":[[8046,8047,8048,8049,8050,-2399]],"id":"51047","properties":{"name":"Culpeper"}},{"type":"Polygon","arcs":[[8051,8052,-8046,-7030,8053]],"id":"48051","properties":{"name":"Burleson"}},{"type":"MultiPolygon","arcs":[[[8054]],[[8055]],[[-453,8056,8057,8058]]],"id":"28047","properties":{"name":"Harrison"}},{"type":"Polygon","arcs":[[8059,8060,8061,-2360,-7942,-2381]],"id":"48119","properties":{"name":"Delta"}},{"type":"Polygon","arcs":[[-7024,8062,-2,-4496]],"id":"49053","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-6975,-7003,-5633]],"id":"42093","properties":{"name":"Montour"}},{"type":"Polygon","arcs":[[-5024,-2726,8063,-424,-1963,-1739,8064,8065,8066]],"id":"48105","properties":{"name":"Crockett"}},{"type":"Polygon","arcs":[[8067,-2498,8068,8069,-7954,-7324,8070]],"id":"12127","properties":{"name":"Volusia"}},{"type":"Polygon","arcs":[[-6511,8071,8072,-6659,-7416,-6818,-8023,-2924]],"id":"36101","properties":{"name":"Steuben"}},{"type":"Polygon","arcs":[[-1513,8073,8074,-4166,8075]],"id":"55101","properties":{"name":"Racine"}},{"type":"Polygon","arcs":[[8076,-2538,8077,8078,8079,-3498]],"id":"05059","properties":{"name":"Hot Spring"}},{"type":"Polygon","arcs":[[-7216,-2589,-1037,-3176]],"id":"19091","properties":{"name":"Humboldt"}},{"type":"Polygon","arcs":[[-3887,-2997,-3601,-2310,-5034,8080]],"id":"29055","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[-5345,-7449,-3529,-3712,-3388,-3674,8081]],"id":"27173","properties":{"name":"Yellow Medicine"}},{"type":"Polygon","arcs":[[-3993,-5809,-3848,-2580,8082,-6343]],"id":"13151","properties":{"name":"Henry"}},{"type":"Polygon","arcs":[[8083,8084,8085,8086,-4940]],"id":"01011","properties":{"name":"Bullock"}},{"type":"Polygon","arcs":[[-3984,8087,-7107,-1163,-211,8088]],"id":"06047","properties":{"name":"Merced"}},{"type":"Polygon","arcs":[[8089,-6134,-7082,-2290,8090,-2288,8091,8092,-7013]],"id":"51095","properties":{"name":"James City"}},{"type":"Polygon","arcs":[[-5612,8093,-6630,8094,-1263]],"id":"22049","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[8095,8096,8097,8098,-7137,-8034,-6708]],"id":"37073","properties":{"name":"Gates"}},{"type":"Polygon","arcs":[[8099,8100,8101,-4610,-5585,8102]],"id":"55063","properties":{"name":"La Crosse"}},{"type":"MultiPolygon","arcs":[[[-7919,8103,-7922]],[[8104,8105,8106,-7920,-7921,-8031,8107]]],"id":"13269","properties":{"name":"Taylor"}},{"type":"Polygon","arcs":[[8108,8109,-7138,-8099]],"id":"37139","properties":{"name":"Pasquotank"}},{"type":"Polygon","arcs":[[-6206,-3762,8110,8111,-8047,-2398,-6270]],"id":"51061","properties":{"name":"Fauquier"}},{"type":"Polygon","arcs":[[-2409,8112,-8050,8113,-2859,-5450]],"id":"51137","properties":{"name":"Orange"}},{"type":"Polygon","arcs":[[8114,-7853,8115,-8041,8116]],"id":"36017","properties":{"name":"Chenango"}},{"type":"Polygon","arcs":[[-4762,8117,8118]],"id":"51680","properties":{"name":"Lynchburg"}},{"type":"Polygon","arcs":[[8119,8120,8121,8122,-7897]],"id":"40029","properties":{"name":"Coal"}},{"type":"Polygon","arcs":[[-6797,-6753,8123,-8121,8124,8125]],"id":"40063","properties":{"name":"Hughes"}},{"type":"Polygon","arcs":[[-4363,8126,-8054,-7029,-6053,-6869]],"id":"48287","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[8127,-8118,-4761,-3801,8128,-6223,-8014]],"id":"51031","properties":{"name":"Campbell"}},{"type":"Polygon","arcs":[[-7934,-6747,8129,-8125,-8120,-7896,-3926,-7855]],"id":"40123","properties":{"name":"Pontotoc"}},{"type":"Polygon","arcs":[[-2604,-980,8130,8131,-4128,-4127,-4360,-6817,8132,8133,8134,8135,8136,8137]],"id":"32031","properties":{"name":"Washoe"}},{"type":"Polygon","arcs":[[8138,8139,-4915,-6855,-7848]],"id":"36105","properties":{"name":"Sullivan"}},{"type":"Polygon","arcs":[[8140,8141,8142,8143,8144]],"id":"42041","properties":{"name":"Cumberland"}},{"type":"Polygon","arcs":[[-3811,-7571,8145,-3416,8146,-3056]],"id":"54041","properties":{"name":"Lewis"}},{"type":"Polygon","arcs":[[8147,-3880,-854,-3875,-4068,-5559,8148]],"id":"22053","properties":{"name":"Jefferson Davis"}},{"type":"Polygon","arcs":[[-462,-3093,-600,8149,8150]],"id":"31113","properties":{"name":"Logan"}},{"type":"Polygon","arcs":[[8151,8152,-3579,8153,8154,-8085,8155]],"id":"01113","properties":{"name":"Russell"}},{"type":"Polygon","arcs":[[-4445,8156,8157,-6165,-6099,-1278]],"id":"05135","properties":{"name":"Sharp"}},{"type":"Polygon","arcs":[[-5047,-7256,-7698,-1160]],"id":"06107","properties":{"name":"Tulare"}},{"type":"Polygon","arcs":[[-4418,-6764,-3491,8158,-5845,8159]],"id":"21003","properties":{"name":"Allen"}},{"type":"Polygon","arcs":[[8160,8161,8162,8163,8164,8165,-4788]],"id":"22051","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[-4910,8166,8167,-7438,8168]],"id":"36079","properties":{"name":"Putnam"}},{"type":"Polygon","arcs":[[-4911,-8169,-7442,-7432,8169]],"id":"36087","properties":{"name":"Rockland"}},{"type":"Polygon","arcs":[[-8168,8170,8171,-7314,8172,-7439]],"id":"09001","properties":{"name":"Fairfield"}},{"type":"Polygon","arcs":[[8173,-2293,-4238,-2325,8174,-4443]],"id":"29091","properties":{"name":"Howell"}},{"type":"MultiPolygon","arcs":[[[8175]]],"id":"66010","properties":{"name":"Guam"}},{"type":"Polygon","arcs":[[-692,-963,-7046,-8044,-8053,8176]],"id":"48395","properties":{"name":"Robertson"}},{"type":"Polygon","arcs":[[8177,8178,8179,-1275,-1272,-5507,-7309,8180]],"id":"06067","properties":{"name":"Sacramento"}},{"type":"Polygon","arcs":[[-6751,8181,8182,8183,8184,8185]],"id":"40061","properties":{"name":"Haskell"}},{"type":"Polygon","arcs":[[-8185,8186,-2718,8187]],"id":"40077","properties":{"name":"Latimer"}},{"type":"Polygon","arcs":[[-7695,-1019,8188,-6384,8189]],"id":"54029","properties":{"name":"Hancock"}},{"type":"Polygon","arcs":[[8190,-5164,8191,-5489,8192,8193]],"id":"05073","properties":{"name":"Lafayette"}},{"type":"Polygon","arcs":[[8194,8195,-7410,8196,8197,-4500,8198]],"id":"34001","properties":{"name":"Atlantic"}},{"type":"Polygon","arcs":[[-5534,-4008,-4479,-3376,8199,8200]],"id":"16083","properties":{"name":"Twin Falls"}},{"type":"Polygon","arcs":[[-1712,-5020,-708,8201,-7010]],"id":"48333","properties":{"name":"Mills"}},{"type":"Polygon","arcs":[[-4825,-7163,-4299,-7969,-5975]],"id":"21053","properties":{"name":"Clinton"}},{"type":"Polygon","arcs":[[8202,-1894,-2109,8203,-7697,-4324,8204,-3461]],"id":"39151","properties":{"name":"Stark"}},{"type":"Polygon","arcs":[[-3620,-4164,8205,8206,-3378,8207]],"id":"01117","properties":{"name":"Shelby"}},{"type":"Polygon","arcs":[[8208,-6756,-3539,-3519,-6123,8209]],"id":"41053","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[8210,8211,-3447,8212,-6538,-2188]],"id":"20167","properties":{"name":"Russell"}},{"type":"Polygon","arcs":[[-6621,8213,8214,-1255,-3319,-7534]],"id":"20045","properties":{"name":"Douglas"}},{"type":"Polygon","arcs":[[-7429,8215,-3069,-1546,-7780]],"id":"20157","properties":{"name":"Republic"}},{"type":"Polygon","arcs":[[8216,8217,-8181,-7308,8218,-7930]],"id":"06095","properties":{"name":"Solano"}},{"type":"Polygon","arcs":[[8219,-4446,-1281,8220,-3834,8221]],"id":"05005","properties":{"name":"Baxter"}},{"type":"Polygon","arcs":[[8222,8223,8224,8225]],"id":"51710","properties":{"name":"Norfolk"}},{"type":"Polygon","arcs":[[8226,8227,-1020,-510,-1719,-3153,-3793,8228,-5028]],"id":"35025","properties":{"name":"Lea"}},{"type":"MultiPolygon","arcs":[[[-7998,-3703]],[[-7555,-3869,-3696,-7997,8229]]],"id":"22065","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[-5029,-8229,-3796,-7541,8230]],"id":"48301","properties":{"name":"Loving"}},{"type":"MultiPolygon","arcs":[[[8231,8232]],[[8233,8234,8235,-7149,8236,-6336],[8237],[-7145]]],"id":"08014","properties":{"name":"Broomfield"}},{"type":"Polygon","arcs":[[-2720,8238,-7196,8239,-3347,-5770,8240,-4525]],"id":"40089","properties":{"name":"McCurtain"}},{"type":"Polygon","arcs":[[8241,-6386,8242,-4935,-6907]],"id":"54069","properties":{"name":"Ohio"}},{"type":"Polygon","arcs":[[-6176,-6689,-7717,8243,8244]],"id":"37075","properties":{"name":"Graham"}},{"type":"Polygon","arcs":[[8245,-8244,-7721,-7791,8246,-2136,-5646]],"id":"37039","properties":{"name":"Cherokee"}},{"type":"Polygon","arcs":[[-4971,-3637,8247,-7831]],"id":"31043","properties":{"name":"Dakota"}},{"type":"Polygon","arcs":[[8248,8249,8250,-5790,-6494,-7681,8251,-6185,8252,-3667]],"id":"25027","properties":{"name":"Worcester"}},{"type":"Polygon","arcs":[[8253,8254,8255,-1910,8256,-2848]],"id":"39017","properties":{"name":"Butler"}},{"type":"Polygon","arcs":[[8257,-8193,-5492,-1267,-4423,8258]],"id":"22015","properties":{"name":"Bossier"}},{"type":"Polygon","arcs":[[-4011,-1145,-1828,-4226,8259]],"id":"17103","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[-4353,-5590,8260,8261,-7689,8262]],"id":"41051","properties":{"name":"Multnomah"}},{"type":"Polygon","arcs":[[8263,-5495,8264,-6299,8265]],"id":"37019","properties":{"name":"Brunswick"}},{"type":"Polygon","arcs":[[8266,-6084,-6038,8267,-6981,-6887,-3504]],"id":"47141","properties":{"name":"Putnam"}},{"type":"Polygon","arcs":[[8268,8269,8270,8271,-4018,8272]],"id":"37083","properties":{"name":"Halifax"}},{"type":"Polygon","arcs":[[-3096,-7460,-2674,8273,-3645,-1844]],"id":"16023","properties":{"name":"Butte"}},{"type":"Polygon","arcs":[[8274,-4395,-6332,-4393,-6338],[-4392]],"id":"08031","properties":{"name":"Denver"}},{"type":"Polygon","arcs":[[-7510,-7590,8275,-7553,8276,-5615]],"id":"22067","properties":{"name":"Morehouse"}},{"type":"Polygon","arcs":[[8277,-4570,-2285]],"id":"51735","properties":{"name":"Poquoson"}},{"type":"Polygon","arcs":[[8278,-8226,8279,8280]],"id":"51740","properties":{"name":"Portsmouth"}},{"type":"MultiPolygon","arcs":[[[-8238]],[[8281,-7150,-8236,-8235,-8234,-6335,8282,-6452],[-8232,-8233]]],"id":"08013","properties":{"name":"Boulder"}},{"type":"Polygon","arcs":[[8283,8284,-7282,8285,-8163]],"id":"22071","properties":{"name":"Orleans"}},{"type":"Polygon","arcs":[[-5058,-3949,-7792,-7718,-6687]],"id":"37099","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[8286,8287,8288,-2697,8289,-7243]],"id":"01025","properties":{"name":"Clarke"}},{"type":"Polygon","arcs":[[-7249,-4593,8290,-6321,-6592,8291,-8287,-7242]],"id":"01091","properties":{"name":"Marengo"}},{"type":"Polygon","arcs":[[8292,8293,-6322,-8291,-4592]],"id":"01065","properties":{"name":"Hale"}},{"type":"Polygon","arcs":[[8294,8295,-2978,8296,8297]],"id":"01075","properties":{"name":"Lamar"}},{"type":"Polygon","arcs":[[8298,-8297,-2977,8299,-4590,-7248,8300]],"id":"01107","properties":{"name":"Pickens"}},{"type":"Polygon","arcs":[[-4855,-6221,8301,-4200,-3398,-3890]],"id":"31127","properties":{"name":"Nemaha"}},{"type":"Polygon","arcs":[[8302,-4323,-4725,-4321,-7016,8303,-2931,8304,-5169,-6166,-5167,8305,-7077]],"id":"51041","properties":{"name":"Chesterfield"}},{"type":"Polygon","arcs":[[-7692,-5738,8306,-5261,-1746]],"id":"48403","properties":{"name":"Sabine"}},{"type":"Polygon","arcs":[[8307,-6282,-583,8308]],"id":"26019","properties":{"name":"Benzie"}},{"type":"Polygon","arcs":[[8309,-5889,-6638,8310,-7424,-4072]],"id":"29037","properties":{"name":"Cass"}},{"type":"Polygon","arcs":[[-8207,8311,-3631,8312,-5251,-3379]],"id":"01037","properties":{"name":"Coosa"}},{"type":"Polygon","arcs":[[-5446,8313,-7151,-8282,-6451,-473]],"id":"08069","properties":{"name":"Larimer"}},{"type":"Polygon","arcs":[[-7583,-5848,8314,8315,-7765,8316]],"id":"47037","properties":{"name":"Davidson"}},{"type":"Polygon","arcs":[[8317,-7632,-6924,8318,-6062,8319]],"id":"42027","properties":{"name":"Centre"}},{"type":"Polygon","arcs":[[8320,8321,8322,8323,-6055,-7034]],"id":"48015","properties":{"name":"Austin"}},{"type":"Polygon","arcs":[[8324,-5099,8325,8326]],"id":"50013","properties":{"name":"Grand Isle"}},{"type":"Polygon","arcs":[[-5999,8327,-8281,8328,8329,-8097,8330]],"id":"51800","properties":{"name":"Suffolk"}},{"type":"Polygon","arcs":[[8331,8332,-2330,-3271]],"id":"08025","properties":{"name":"Crowley"}},{"type":"Polygon","arcs":[[8333,-3274,8334,-6461]],"id":"08027","properties":{"name":"Custer"}},{"type":"Polygon","arcs":[[-5611,-5616,-8277,-7557,-6631,-8094]],"id":"22073","properties":{"name":"Ouachita"}},{"type":"Polygon","arcs":[[-6329,-2329,-259,-425,-8064,-2725]],"id":"48383","properties":{"name":"Reagan"}},{"type":"Polygon","arcs":[[-2358,-7856,-2390,-4732,-3725,-530]],"id":"40137","properties":{"name":"Stephens"}},{"type":"Polygon","arcs":[[-3605,8335,-6643,-2322,-2312]],"id":"29179","properties":{"name":"Reynolds"}},{"type":"Polygon","arcs":[[-5030,-8231,-7544,8336,-3230,8337]],"id":"48389","properties":{"name":"Reeves"}},{"type":"Polygon","arcs":[[-7705,-1880,8338,-3270,8339,-2340]],"id":"08041","properties":{"name":"El Paso"}},{"type":"Polygon","arcs":[[8340,8341,8342,-7526,8343,-7566,8344]],"id":"39167","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-7652,-1740,8345,-4722,-7656,8346]],"id":"51045","properties":{"name":"Craig"}},{"type":"Polygon","arcs":[[-2991,8347,8348,-3617,8349,-2975,8350]],"id":"01127","properties":{"name":"Walker"}},{"type":"Polygon","arcs":[[-8018,8351,8352,-6208,-6269,-7083,8353],[-6775]],"id":"51069","properties":{"name":"Frederick"}},{"type":"Polygon","arcs":[[-1476,-4648,8354,8355,8356]],"id":"30095","properties":{"name":"Stillwater"}},{"type":"Polygon","arcs":[[-2161,8357,-7803,8358,8359,-15]],"id":"22117","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-5847,-1228,-3506,-6890,8360,8361,-8315]],"id":"47189","properties":{"name":"Wilson"}},{"type":"Polygon","arcs":[[8362,-4187,-6006,8363,-3260,-7772,-7776]],"id":"16035","properties":{"name":"Clearwater"}},{"type":"MultiPolygon","arcs":[[[8364]],[[8365,8366]],[[8367,8368,-4789,-8166,8369,8370,-7842]]],"id":"22057","properties":{"name":"Lafourche"}},{"type":"Polygon","arcs":[[8371,-7461,8372]],"id":"26047","properties":{"name":"Emmet"}},{"type":"Polygon","arcs":[[-7069,8373,8374,-8269,-1079,-3825]],"id":"37185","properties":{"name":"Warren"}},{"type":"MultiPolygon","arcs":[[[8375]]],"id":"69120","properties":{"name":"Tinian"}},{"type":"Polygon","arcs":[[8376,8377,-161,-7747,-7088,8378]],"id":"72013","properties":{"name":"Arecibo"}},{"type":"Polygon","arcs":[[-1618,-7352,8379,-3716,-7468]],"id":"26115","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[-2302,8380,-2344]],"id":"30047","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[-2345,-8381,-2301,8381,8382,-1997,-3261,-8364,-6005]],"id":"30063","properties":{"name":"Missoula"}},{"type":"Polygon","arcs":[[-8283,-6334,8383,-6453]],"id":"08047","properties":{"name":"Gilpin"}},{"type":"Polygon","arcs":[[-6462,-8335,-3273,-7220,-7142,-3300]],"id":"08055","properties":{"name":"Huerfano"}},{"type":"Polygon","arcs":[[8384,8385,-7106,8386,-2444,-7064,-5831,-5581]],"id":"54059","properties":{"name":"Mingo"}},{"type":"Polygon","arcs":[[-174,8387,-8352,-8017,-332]],"id":"54065","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[-7244,-8290,-2696,8388,8389,-7980]],"id":"01129","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-2146,8390,8391,8392,-3412,-1373,-1367,-7115]],"id":"17173","properties":{"name":"Shelby"}},{"type":"Polygon","arcs":[[8393,-5817,-4412,-7413,-3508,8394]],"id":"18165","properties":{"name":"Vermillion"}},{"type":"Polygon","arcs":[[-4987,8395,8396,-7411,-8196,8397,8398]],"id":"34005","properties":{"name":"Burlington"}},{"type":"Polygon","arcs":[[-3310,8399,-5587,-5389,-477,-6556]],"id":"27045","properties":{"name":"Fillmore"}},{"type":"Polygon","arcs":[[-263,8400,8401,-4750,8402,8403]],"id":"48439","properties":{"name":"Tarrant"}},{"type":"Polygon","arcs":[[-4859,8404,8405,-5875,8406,8407,-4866]],"id":"17031","properties":{"name":"Cook"}},{"type":"MultiPolygon","arcs":[[[8408]],[[8409]],[[8410]],[[8411]],[[8412]]],"id":"69085","properties":{"name":"Northern Islands"}},{"type":"Polygon","arcs":[[-8280,-8225,8413,-4715,8414,-8329]],"id":"51550","properties":{"name":"Chesapeake"}},{"type":"Polygon","arcs":[[-3032,8415,-6553,-5414,-1133,-1314]],"id":"26155","properties":{"name":"Shiawassee"}},{"type":"Polygon","arcs":[[8416,8417,-481,-87,8418,-3030,-3671]],"id":"26157","properties":{"name":"Tuscola"}},{"type":"Polygon","arcs":[[-719,8419,-6954,-6239]],"id":"38011","properties":{"name":"Bowman"}},{"type":"Polygon","arcs":[[8420,-1783,-714,-6238,-3740]],"id":"38033","properties":{"name":"Golden Valley"}},{"type":"Polygon","arcs":[[-4338,-2250,8421,8422,-6984,-6315,8423]],"id":"55035","properties":{"name":"Eau Claire"}},{"type":"Polygon","arcs":[[8424,8425,8426,-4031,-1273,8427]],"id":"32005","properties":{"name":"Douglas"}},{"type":"Polygon","arcs":[[8428,-485,8429,-4229]],"id":"18009","properties":{"name":"Blackford"}},{"type":"Polygon","arcs":[[-3599,-2201,8430,-486,-8429,-4228]],"id":"18179","properties":{"name":"Wells"}},{"type":"Polygon","arcs":[[8431,-1955,-5624,8432,8433]],"id":"05013","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[-2521,8434,-5880,8435,8436,-182,8437]],"id":"17091","properties":{"name":"Kankakee"}},{"type":"Polygon","arcs":[[-7232,-7317,-6490,-4053]],"id":"18163","properties":{"name":"Vanderburgh"}},{"type":"Polygon","arcs":[[8438,-3262,-2853,-3049,8439,-2985]],"id":"16003","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[-6186,-8252,-7683,-7685,8440]],"id":"09013","properties":{"name":"Tolland"}},{"type":"Polygon","arcs":[[-4471,-7322,8441,-4303,8442,8443,-4061,-7823]],"id":"21111","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[-8359,-7802,-6560,-8008,-454,8444,8445]],"id":"28109","properties":{"name":"Pearl River"}},{"type":"Polygon","arcs":[[8446,8447,-8368,-7841]],"id":"22093","properties":{"name":"St. James"}},{"type":"Polygon","arcs":[[-361,-4369,-7669,8448,-5673,8449]],"id":"49013","properties":{"name":"Duchesne"}},{"type":"Polygon","arcs":[[-6766,-6193,8450,-3770,-3114]],"id":"48209","properties":{"name":"Hays"}},{"type":"Polygon","arcs":[[8451,-5676,-5686,8452,8453]],"id":"49023","properties":{"name":"Juab"}},{"type":"Polygon","arcs":[[8454,8455,8456,-6706,8457,-8270,-8375]],"id":"37131","properties":{"name":"Northampton"}},{"type":"Polygon","arcs":[[-2767,-4942,8458,-1829,8459,-876]],"id":"01041","properties":{"name":"Crenshaw"}},{"type":"Polygon","arcs":[[-4589,8460,8461,8462]],"id":"16007","properties":{"name":"Bear Lake"}},{"type":"Polygon","arcs":[[-2883,8463,8464,-1697,-1906,-8256,8465]],"id":"39113","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[8466,8467,8468,8469,8470,-1831]],"id":"01045","properties":{"name":"Dale"}},{"type":"MultiPolygon","arcs":[[[8471,8472]],[[8473,8474]]],"id":"06075","properties":{"name":"San Francisco"}},{"type":"Polygon","arcs":[[-7121,8475,8476,8477,-2157]],"id":"08091","properties":{"name":"Ouray"}},{"type":"Polygon","arcs":[[-7272,8478,-5294,-5511,8479,8480]],"id":"17153","properties":{"name":"Pulaski"}},{"type":"Polygon","arcs":[[8481,8482,8483,-6162,-8158,8484]],"id":"05121","properties":{"name":"Randolph"}},{"type":"Polygon","arcs":[[-3548,-6102,-6111,-4805,-6447,-3357,8485]],"id":"05145","properties":{"name":"White"}},{"type":"Polygon","arcs":[[8486,-679,8487,-3464,-949,-6776,-4265]],"id":"39005","properties":{"name":"Ashland"}},{"type":"Polygon","arcs":[[-3918,-2236,8488,-8182,-6750,-4269]],"id":"40101","properties":{"name":"Muskogee"}},{"type":"MultiPolygon","arcs":[[[8489]],[[8490]],[[-4343,-7843,-8371,8491,-8366,8492]]],"id":"22109","properties":{"name":"Terrebonne"}},{"type":"Polygon","arcs":[[8493,-8210,-6125,-6126,8494]],"id":"41041","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-482,-8418,8495]],"id":"26063","properties":{"name":"Huron"}},{"type":"Polygon","arcs":[[8496,-1150,-7903,-6265,8497]],"id":"29227","properties":{"name":"Worth"}},{"type":"Polygon","arcs":[[8498,8499,-6477,-6781,8500,-5092]],"id":"29175","properties":{"name":"Randolph"}},{"type":"Polygon","arcs":[[8501]],"id":"15003","properties":{"name":"Honolulu"}},{"type":"Polygon","arcs":[[8502,-8453,-5685,8503,-6369,-4493]],"id":"49027","properties":{"name":"Millard"}},{"type":"Polygon","arcs":[[-8504,-5684,-6088,-6067,-5576,-6370]],"id":"49041","properties":{"name":"Sevier"}},{"type":"Polygon","arcs":[[8504,-7036,-5574,8505,-5677,-8452,8506]],"id":"49045","properties":{"name":"Tooele"}},{"type":"MultiPolygon","arcs":[[[8507,8508,8509,8510]],[[8511]],[[8512]],[[8513]],[[8514,8515,8516]],[[8517]],[[8518]],[[8519]],[[8520]]],"id":"12087","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[8521,8522,-6121,8523,-6022,8524,8525,-4767]],"id":"13033","properties":{"name":"Burke"}},{"type":"Polygon","arcs":[[-4029,8526,8527,-8152,8528,8529]],"id":"01081","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[8530,-6093,-3785,8531,8532,8533,8534]],"id":"48409","properties":{"name":"San Patricio"}},{"type":"Polygon","arcs":[[-7108,-8088,-2746]],"id":"06043","properties":{"name":"Mariposa"}},{"type":"Polygon","arcs":[[-7640,8535,-8498,-6264,8536,8537,-6219]],"id":"29147","properties":{"name":"Nodaway"}},{"type":"Polygon","arcs":[[-1369,-1376,-3254,-1190,-3226,-2822]],"id":"17025","properties":{"name":"Clay"}},{"type":"MultiPolygon","arcs":[[[8538]],[[8539]],[[8540]],[[8541]],[[-57,8542,-3183,8543]]],"id":"02130","properties":{"name":"Ketchikan Gateway"}},{"type":"Polygon","arcs":[[8544,-1444,8545,-2087]],"id":"02282","properties":{"name":"Yakutat"}},{"type":"Polygon","arcs":[[-2200,-1904,8546,-487,-8431]],"id":"18001","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[8547,-1211,-5309,8548,8549]],"id":"08017","properties":{"name":"Cheyenne"}},{"type":"Polygon","arcs":[[-6500,8550,-5061,8551,-5960]],"id":"47173","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[-184,8552,-3001,8553,-8395,-3507,8554]],"id":"17183","properties":{"name":"Vermilion"}},{"type":"Polygon","arcs":[[8555,8556]],"id":"53009","properties":{"name":"Clallam"}},{"type":"Polygon","arcs":[[8557,8558,8559,-8009,-7099,8560]],"id":"53027","properties":{"name":"Grays Harbor"}},{"type":"Polygon","arcs":[[8561,8562,-2496,8563,-7910]],"id":"12109","properties":{"name":"St. Johns"}},{"type":"Polygon","arcs":[[-8556,8564,8565,-8558,8566]],"id":"53031","properties":{"name":"Jefferson"}},{"type":"MultiPolygon","arcs":[[[-7932,8567]]],"id":"06041","properties":{"name":"Marin"}},{"type":"Polygon","arcs":[[-7078,-8306,-5171,8568,-7053,8569,8570,8571]],"id":"51053","properties":{"name":"Dinwiddie"}},{"type":"Polygon","arcs":[[-4774,-1253,8572,-5273]],"id":"17129","properties":{"name":"Menard"}},{"type":"Polygon","arcs":[[-4367,-6003,8573,-7267,-7749,-7670]],"id":"08081","properties":{"name":"Moffat"}},{"type":"Polygon","arcs":[[-7284,8574,-8462,-5354,-4049]],"id":"16041","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-6520,-8022,8575,-8179,8576,-3988]],"id":"06101","properties":{"name":"Sutter"}},{"type":"Polygon","arcs":[[-7696,-8190,-6387,-8242,-6906,-840,-4326]],"id":"39081","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[-7497,-191,8577,-6941,8578]],"id":"35009","properties":{"name":"Curry"}},{"type":"Polygon","arcs":[[-2877,8579,-5337,8580,8581]],"id":"36021","properties":{"name":"Columbia"}},{"type":"Polygon","arcs":[[-7513,8582,-2435,-3210,-7617,-6563]],"id":"28083","properties":{"name":"Leflore"}},{"type":"Polygon","arcs":[[-8247,-7790,8583,-3996,8584,-2137]],"id":"13291","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[8585,-6914,8586,8587,-5428,8588]],"id":"39001","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[-4501,-8198,8589]],"id":"34009","properties":{"name":"Cape May"}},{"type":"Polygon","arcs":[[-4497,-12,-2004,-5045,8590]],"id":"32003","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[-7680,8591,8592,8593,-8214,-6620]],"id":"20103","properties":{"name":"Leavenworth"}},{"type":"Polygon","arcs":[[-3394,-5349,-8303,-7076]],"id":"51145","properties":{"name":"Powhatan"}},{"type":"Polygon","arcs":[[-4157,8594,8595,8596,8597,-1105,-3805]],"id":"53043","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[8598,8599,-640,8600,8601,-8559,-8566]],"id":"53045","properties":{"name":"Mason"}},{"type":"MultiPolygon","arcs":[[[8602]],[[8603]],[[8604]],[[8605]]],"id":"53055","properties":{"name":"San Juan"}},{"type":"Polygon","arcs":[[8606,-3246,8607,8608,8609]],"id":"17133","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[-1795,8610,8611,8612,-7118,8613]],"id":"08097","properties":{"name":"Pitkin"}},{"type":"Polygon","arcs":[[8614,-8131,-979,8615,-567]],"id":"06035","properties":{"name":"Lassen"}},{"type":"Polygon","arcs":[[-3569,-2913,-2210,-2168,-289]],"id":"19101","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[8616,-5310,-2903,-7218,-3363,8617]],"id":"08099","properties":{"name":"Prowers"}},{"type":"Polygon","arcs":[[-732,-4188,-8363,-7775,8618]],"id":"16057","properties":{"name":"Latah"}},{"type":"Polygon","arcs":[[-2505,8619,8620,-6464,8621]],"id":"12097","properties":{"name":"Osceola"}},{"type":"Polygon","arcs":[[8622,8623,8624,-855,8625,-348]],"id":"27171","properties":{"name":"Wright"}},{"type":"Polygon","arcs":[[-6594,-2625,8626,8627,-8106,8628,-219]],"id":"13293","properties":{"name":"Upson"}},{"type":"Polygon","arcs":[[8629,8630,-7408,8631,8632]],"id":"31049","properties":{"name":"Deuel"}},{"type":"Polygon","arcs":[[8633,-939,-689,-187,-7496]],"id":"48359","properties":{"name":"Oldham"}},{"type":"Polygon","arcs":[[8634,-1821,8635,-1770,-3846,-5808]],"id":"13297","properties":{"name":"Walton"}},{"type":"Polygon","arcs":[[-6606,-6326,8636,8637,8638,-7184]],"id":"13303","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[8639,-7436,8640,8641,8642]],"id":"34013","properties":{"name":"Essex"}},{"type":"Polygon","arcs":[[8643,8644,8645,-4812,8646,8647,-5248]],"id":"13305","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[8648,-7224,-5150,-3247,-8607,8649,-3885]],"id":"29189","properties":{"name":"St. Louis"}},{"type":"Polygon","arcs":[[-7537,-18,8650,8651,-4843]],"id":"22063","properties":{"name":"Livingston"}},{"type":"Polygon","arcs":[[-3381,-5254,-4943,-2765,-6590]],"id":"01001","properties":{"name":"Autauga"}},{"type":"Polygon","arcs":[[-8086,-8155,8652,8653,8654,8655,-8468,8656]],"id":"01005","properties":{"name":"Barbour"}},{"type":"MultiPolygon","arcs":[[[8657]],[[-8389,-2695,8658,8659,8660,8661]]],"id":"01097","properties":{"name":"Mobile"}},{"type":"Polygon","arcs":[[8662,-1728,8663,-8596,8664]],"id":"53065","properties":{"name":"Stevens"}},{"type":"MultiPolygon","arcs":[[[8665]],[[-4160,-6233,8666]],[[8667]]],"id":"53073","properties":{"name":"Whatcom"}},{"type":"Polygon","arcs":[[-1731,8668,-3432,-3204,8669,8670,8671]],"id":"13019","properties":{"name":"Berrien"}},{"type":"Polygon","arcs":[[8672,-4587,-6004,-358]],"id":"56041","properties":{"name":"Uinta"}},{"type":"Polygon","arcs":[[8673,-8570,-7056,8674,-8456],[-1219]],"id":"51081","properties":{"name":"Greensville"}},{"type":"Polygon","arcs":[[-8337,-7543,-5025,-8067,8675,-5855,-3231]],"id":"48371","properties":{"name":"Pecos"}},{"type":"Polygon","arcs":[[-3723,-7235,8676,8677,-2933,-5385]],"id":"17161","properties":{"name":"Rock Island"}},{"type":"Polygon","arcs":[[-1215,-2884,-8466,-8255,8678]],"id":"39135","properties":{"name":"Preble"}},{"type":"Polygon","arcs":[[8679,-1085,8680,-801,8681,-1900]],"id":"39137","properties":{"name":"Putnam"}},{"type":"Polygon","arcs":[[8682,-8477,8683,8684,-5256]],"id":"08111","properties":{"name":"San Juan"}},{"type":"Polygon","arcs":[[-2920,8685,-1912,8686]],"id":"48385","properties":{"name":"Real"}},{"type":"Polygon","arcs":[[-2300,-1988,-5595,-6074,8687,-8382]],"id":"30077","properties":{"name":"Powell"}},{"type":"Polygon","arcs":[[8688,8689,8690,8691,-4578,8692]],"id":"13309","properties":{"name":"Wheeler"}},{"type":"Polygon","arcs":[[-3085,-5810,8693,-7206,-2006]],"id":"06065","properties":{"name":"Riverside"}},{"type":"Polygon","arcs":[[-7378,-1652,-506,8694,8695]],"id":"40115","properties":{"name":"Ottawa"}},{"type":"Polygon","arcs":[[-6883,-7746,8696,-2755,8697]],"id":"72103","properties":{"name":"Naguabo"}},{"type":"Polygon","arcs":[[-3683,8698,8699,-1049]],"id":"26001","properties":{"name":"Alcona"}},{"type":"Polygon","arcs":[[8700,-5861,-825,8701,8702,-1498]],"id":"56043","properties":{"name":"Washakie"}},{"type":"Polygon","arcs":[[8703,-5018,-7971,-5005,-4751,-8402]],"id":"48113","properties":{"name":"Dallas"}},{"type":"Polygon","arcs":[[8704,-7181,8705,8706]],"id":"72059","properties":{"name":"Guayanilla"}},{"type":"Polygon","arcs":[[-895,-2203,-3598,-2150,-5970]],"id":"18183","properties":{"name":"Whitley"}},{"type":"Polygon","arcs":[[-5412,-5394,-7479,8707,-7401,-4558]],"id":"47047","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[-4865,-7781,-6406,8708,-8211,-2187,-3411]],"id":"20141","properties":{"name":"Osborne"}},{"type":"Polygon","arcs":[[-7098,8709,-6997,8710,8711,8712,-2127]],"id":"72011","properties":{"name":"AÃ±asco"}},{"type":"MultiPolygon","arcs":[[[-8712,8713,-2119,-6853,-5008,-4345,8714]],[[8715]]],"id":"72097","properties":{"name":"MayagÃ¼ez"}},{"type":"Polygon","arcs":[[-2196,8716]],"id":"60010","properties":{"name":"Eastern"}},{"type":"Polygon","arcs":[[8717,-6195,-5280,-4919,-3664,-5332,8718]],"id":"50003","properties":{"name":"Bennington"}},{"type":"Polygon","arcs":[[-4158,-3803,-2500,-2485]],"id":"53017","properties":{"name":"Douglas"}},{"type":"MultiPolygon","arcs":[[[-3779,8719,8720,8721]],[[-8533,8722,8723,8724]]],"id":"48355","properties":{"name":"Nueces"}},{"type":"Polygon","arcs":[[8725,8726,8727,-2575,-5097]],"id":"50019","properties":{"name":"Orleans"}},{"type":"Polygon","arcs":[[-5400,-6446,8728,-7505,-3814,-562,-5403]],"id":"54023","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[8729,-5943,8730,8731,-2010]],"id":"13073","properties":{"name":"Columbia"}},{"type":"Polygon","arcs":[[-2861,8732,-5715,-4605,8733,-4318,-5348]],"id":"51085","properties":{"name":"Hanover"}},{"type":"Polygon","arcs":[[-4526,-8241,-5774,-7937,8734,-2361,-8062,8735]],"id":"48387","properties":{"name":"Red River"}},{"type":"Polygon","arcs":[[8736,-2105,-3574,8737,8738,8739,-6912]],"id":"39141","properties":{"name":"Ross"}},{"type":"Polygon","arcs":[[-67,8740,-8689,8741,8742,-2508]],"id":"13091","properties":{"name":"Dodge"}},{"type":"Polygon","arcs":[[-6310,8743,8744,-1822,-8635,-5807,-3991]],"id":"13135","properties":{"name":"Gwinnett"}},{"type":"Polygon","arcs":[[-6467,-2139,8745,8746,8747,-6251,-6601]],"id":"13085","properties":{"name":"Dawson"}},{"type":"Polygon","arcs":[[8748,-3626,8749,-7777,-3263,-8439,-2984,8750,8751]],"id":"41063","properties":{"name":"Wallowa"}},{"type":"Polygon","arcs":[[-8638,8752,-4773,8753,8754]],"id":"13167","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[-6325,8755,-2012,8756,-8522,-4766,-8753,-8637]],"id":"13163","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[8757,8758,8759,-1692,-8465]],"id":"39023","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[8760,8761,8762,8763,8764,-3747,-4434,8765]],"id":"29069","properties":{"name":"Dunklin"}},{"type":"Polygon","arcs":[[8766,-8327,8767,-7723,-7994]],"id":"36019","properties":{"name":"Clinton"}},{"type":"Polygon","arcs":[[-7651,-7730,8768,8769,-4759,8770,-1742],[-3136],[-1282]],"id":"51163","properties":{"name":"Rockbridge"}},{"type":"Polygon","arcs":[[-5870,8771,-8141,8772]],"id":"42099","properties":{"name":"Perry"}},{"type":"Polygon","arcs":[[8773,8774,-8762,8775,-8483]],"id":"05021","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[-172,-3757,-6205,8776]],"id":"54037","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[8777,8778,8779,-2297]],"id":"30035","properties":{"name":"Glacier"}},{"type":"Polygon","arcs":[[-8326,-5098,-2578,8780,8781,-7724,-8768]],"id":"50007","properties":{"name":"Chittenden"}},{"type":"Polygon","arcs":[[8782,-2960,-4777,-4970,-6113]],"id":"19167","properties":{"name":"Sioux"}},{"type":"Polygon","arcs":[[-722,-411,-2351,-1715,-6893,-5021]],"id":"48083","properties":{"name":"Coleman"}},{"type":"Polygon","arcs":[[-2596,8783,-1104,-7693,-7025,8784,-7991]],"id":"48401","properties":{"name":"Rusk"}},{"type":"Polygon","arcs":[[8785,8786,8787,8788,-5422,-8588]],"id":"39145","properties":{"name":"Scioto"}},{"type":"MultiPolygon","arcs":[[[8789,-1436]],[[8790]],[[8791,-1429,8792,-1433,8793,-2018]]],"id":"02110","properties":{"name":"Juneau"}},{"type":"Polygon","arcs":[[8794,8795,-7518,-7303,-3839]],"id":"05077","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[-4807,-614,8796,-8795,-3838]],"id":"05123","properties":{"name":"St. Francis"}},{"type":"Polygon","arcs":[[-5593,8797,-8074,-1512]],"id":"55079","properties":{"name":"Milwaukee"}},{"type":"Polygon","arcs":[[-8422,-2249,-2588,8798,8799,-8101,8800]],"id":"55053","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-4565,-6653,-7504,8801,-8396,-4986]],"id":"34021","properties":{"name":"Mercer"}},{"type":"Polygon","arcs":[[8802,-7075,-6737,-7446,-4739]],"id":"37009","properties":{"name":"Ashe"}},{"type":"Polygon","arcs":[[8803,-2134,-6722,8804,-1009]],"id":"27167","properties":{"name":"Wilkin"}},{"type":"Polygon","arcs":[[-2230,-3442,-341,8805,8806,8807]],"id":"38051","properties":{"name":"McIntosh"}},{"type":"Polygon","arcs":[[-8781,-2577,8808,8809,8810]],"id":"50023","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-7832,-8248,-3636,8811,8812,-1061,-1663]],"id":"31173","properties":{"name":"Thurston"}},{"type":"Polygon","arcs":[[-6816,8813,8814,-8133]],"id":"32027","properties":{"name":"Pershing"}},{"type":"Polygon","arcs":[[8815,-8810,8816,8817,-5277]],"id":"50017","properties":{"name":"Orange"}},{"type":"MultiPolygon","arcs":[[[8818]],[[8819]],[[-7111,8820]]],"id":"55029","properties":{"name":"Door"}},{"type":"Polygon","arcs":[[-568,-8616,-978,-8020,-6518,-2219]],"id":"06063","properties":{"name":"Plumas"}},{"type":"Polygon","arcs":[[-6917,-3224,-4267,-94,8821,-797]],"id":"39147","properties":{"name":"Seneca"}},{"type":"Polygon","arcs":[[-5517,-4907,8822,-7212,8823,8824]],"id":"13103","properties":{"name":"Effingham"}},{"type":"Polygon","arcs":[[8825,-5806,8826,8827,8828,-5536,-2608]],"id":"31161","properties":{"name":"Sheridan"}},{"type":"Polygon","arcs":[[-602,-269,-106,-107,-1420,8829]],"id":"46087","properties":{"name":"McCook"}},{"type":"Polygon","arcs":[[8830,-207,8831,8832,8833,-2758,-4334]],"id":"55083","properties":{"name":"Oconto"}},{"type":"Polygon","arcs":[[-2417,-6323,-2812,8834]],"id":"02068","properties":{"name":"Denali"}},{"type":"Polygon","arcs":[[-7435,-4508,8835,8836,8837,-8641]],"id":"34017","properties":{"name":"Hudson"}},{"type":"Polygon","arcs":[[-1500,8838,-8702,-829,8839,-6001,-5352,-6330]],"id":"56013","properties":{"name":"Fremont"}},{"type":"Polygon","arcs":[[-2778,-3752,-5442,-6475,-8500]],"id":"29137","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[8840,-2635,8841,-3570,-2103]],"id":"39045","properties":{"name":"Fairfield"}},{"type":"Polygon","arcs":[[-8192,-5163,8842,8843,-7926,-5490]],"id":"05027","properties":{"name":"Columbia"}},{"type":"Polygon","arcs":[[8844,8845,-4460,-4110,-7984]],"id":"55065","properties":{"name":"Lafayette"}},{"type":"Polygon","arcs":[[-4512,8846,8847]],"id":"36047","properties":{"name":"Kings"}},{"type":"Polygon","arcs":[[-1993,-1544,-7757,-5112,-6104,-2274]],"id":"29141","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[-6257,8848,-869,-7448,-5343,-7382]],"id":"27151","properties":{"name":"Swift"}},{"type":"Polygon","arcs":[[8849,-6138,-5730,-6043,8850,-6045,8851,-3743,-8765]],"id":"29143","properties":{"name":"New Madrid"}},{"type":"Polygon","arcs":[[-7837,-3166,-987,-4461,-8846,8852]],"id":"55045","properties":{"name":"Green"}},{"type":"Polygon","arcs":[[-8814,-6815,8853,-5609,8854,8855]],"id":"32015","properties":{"name":"Lander"}},{"type":"Polygon","arcs":[[8856,-8136]],"id":"32029","properties":{"name":"Storey"}},{"type":"Polygon","arcs":[[-7459,-6791,-2942,-4655,-4924]],"id":"35001","properties":{"name":"Bernalillo"}},{"type":"Polygon","arcs":[[-3203,-7397,-7125,8857,-8670]],"id":"13173","properties":{"name":"Lanier"}},{"type":"Polygon","arcs":[[-5776,-44,-4960,-4555,-7422,-1480,8858]],"id":"56045","properties":{"name":"Weston"}},{"type":"Polygon","arcs":[[8859,-6655,-2927,8860,8861,8862]],"id":"36009","properties":{"name":"Cattaraugus"}},{"type":"Polygon","arcs":[[8863,8864,-136,-7662,-2466,-143,8865]],"id":"72127","properties":{"name":"San Juan"}},{"type":"Polygon","arcs":[[8866,8867,-137,-8865]],"id":"72139","properties":{"name":"Trujillo Alto"}},{"type":"Polygon","arcs":[[-2693,-1112,-1884,-1890,8868]],"id":"19049","properties":{"name":"Dallas"}},{"type":"Polygon","arcs":[[-8066,8869,8870,-5856,-8676]],"id":"48443","properties":{"name":"Terrell"}},{"type":"Polygon","arcs":[[8871,-7793,-6526,-1917,8872]],"id":"13119","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-5935,-582,8873,-7270,8874]],"id":"17199","properties":{"name":"Williamson"}},{"type":"Polygon","arcs":[[-1937,8875,-7759,-5898,8876,-2107]],"id":"39155","properties":{"name":"Trumbull"}},{"type":"Polygon","arcs":[[-1171,-1825,8877,8878,-1874,8879]],"id":"17203","properties":{"name":"Woodford"}},{"type":"Polygon","arcs":[[-8685,8880,-621,-6096,-4040]],"id":"08067","properties":{"name":"La Plata"}},{"type":"Polygon","arcs":[[-3462,-8205,-4327,-838,-1923,8881]],"id":"39157","properties":{"name":"Tuscarawas"}},{"type":"Polygon","arcs":[[-5258,-2260,-2891,-2142,-25,-6433,-4329,-6108]],"id":"27089","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[-1787,-1763,-7917,-7833,-5751,8882]],"id":"27115","properties":{"name":"Pine"}},{"type":"Polygon","arcs":[[-5162,8883,8884,-8434,8885,-8843]],"id":"05103","properties":{"name":"Ouachita"}},{"type":"Polygon","arcs":[[8886,8887,-675,-8487,-4264,8888]],"id":"39093","properties":{"name":"Lorain"}},{"type":"Polygon","arcs":[[8889,-6588,8890,-6360,8891,-5057]],"id":"37021","properties":{"name":"Buncombe"}},{"type":"Polygon","arcs":[[-6164,8892,-8766,-4441,-3977,-6110]],"id":"05031","properties":{"name":"Craighead"}},{"type":"Polygon","arcs":[[-5917,-4251,8893,-8227,-5027,-4869]],"id":"35005","properties":{"name":"Chaves"}},{"type":"Polygon","arcs":[[-2560,-2610,-5539,8894,-5781,-7423]],"id":"31165","properties":{"name":"Sioux"}},{"type":"Polygon","arcs":[[-8079,8895,-1956,-8432,-8885,8896]],"id":"05039","properties":{"name":"Dallas"}},{"type":"Polygon","arcs":[[8897,-4194,8898,-5055,-3905,-6362,8899]],"id":"37023","properties":{"name":"Burke"}},{"type":"Polygon","arcs":[[-6587,-4712,8900,-8900,-6361,-8891]],"id":"37111","properties":{"name":"McDowell"}},{"type":"Polygon","arcs":[[-7634,5629,-5630,-5629,-5869,-6926]],"id":"42109","properties":{"name":"Snyder"}},{"type":"Polygon","arcs":[[-8742,-8693,-4577,-3428,-3551,8901]],"id":"13271","properties":{"name":"Telfair"}},{"type":"Polygon","arcs":[[8902,-768,-7226,8903]],"id":"12115","properties":{"name":"Sarasota"}},{"type":"Polygon","arcs":[[-6528,-4550,-6051,-5945,8904,8905,8906,-1919]],"id":"13105","properties":{"name":"Elbert"}},{"type":"Polygon","arcs":[[8907,-8671,-8858,-7129,8908,-7613,8909]],"id":"13185","properties":{"name":"Lowndes"}},{"type":"Polygon","arcs":[[-220,-8629,-8105,8910,-3576,8911,8912]],"id":"13263","properties":{"name":"Talbot"}},{"type":"Polygon","arcs":[[-6867,-4674,8913,-8266,-6298]],"id":"37047","properties":{"name":"Columbus"}},{"type":"Polygon","arcs":[[-7454,-580,-5939,-4293,-6029,-5502,-5501,5500]],"id":"17069","properties":{"name":"Hardin"}},{"type":"Polygon","arcs":[[-8747,8914,-3999,8915,8916,8917,-8745,8918]],"id":"13139","properties":{"name":"Hall"}},{"type":"Polygon","arcs":[[8919,-5480,-6629,-4529,-3749,8920]],"id":"17001","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[8921,8922,-2178,8923,-69,-2507,-1958,-7924]],"id":"13153","properties":{"name":"Houston"}},{"type":"Polygon","arcs":[[8924,-5263,-4209,8925]],"id":"48457","properties":{"name":"Tyler"}},{"type":"Polygon","arcs":[[-6213,-7338,-7660,-5366,-7391,-1767]],"id":"12041","properties":{"name":"Gilchrist"}},{"type":"Polygon","arcs":[[-857,8926,8927,-1943,-3158,-3236]],"id":"27139","properties":{"name":"Scott"}},{"type":"Polygon","arcs":[[-3208,-3103,8928,-3282,-2939,-7599,-7618]],"id":"28007","properties":{"name":"Attala"}},{"type":"Polygon","arcs":[[-8740,8929,-8786,-8587,-6913]],"id":"39131","properties":{"name":"Pike"}},{"type":"Polygon","arcs":[[-6936,6934,-6934,-2242,-7021,-3197,-6081]],"id":"46095","properties":{"name":"Mellette"}},{"type":"Polygon","arcs":[[8930,8931,-8863,8932,-4885]],"id":"36013","properties":{"name":"Chautauqua"}},{"type":"Polygon","arcs":[[-8114,-8049,8933,8934,8935,-5711,-8733,-2860]],"id":"51177","properties":{"name":"Spotsylvania"}},{"type":"Polygon","arcs":[[-2324,-6647,8936,-8485,-8157,-4444,-8175]],"id":"29149","properties":{"name":"Oregon"}},{"type":"Polygon","arcs":[[-7503,8937,-7412,-8397,-8802]],"id":"34025","properties":{"name":"Monmouth"}},{"type":"Polygon","arcs":[[-8788,8938,-3968,-6513,8939,-6046,8940]],"id":"39087","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[-4489,8941,-5131,8942,-1666,-4099,-5496]],"id":"26103","properties":{"name":"Marquette"}},{"type":"Polygon","arcs":[[8943,-5249,-8648,8944,-6471]],"id":"13229","properties":{"name":"Pierce"}},{"type":"MultiPolygon","arcs":[[[8945]],[[8946]]],"id":"15007","properties":{"name":"Kauai"}},{"type":"Polygon","arcs":[[-3172,-5102,-5070,8947,-8320,-6061,-3514,-6668]],"id":"42033","properties":{"name":"Clearfield"}},{"type":"Polygon","arcs":[[-2890,-7377,-7487,-2245,-29,-2144]],"id":"27029","properties":{"name":"Clearwater"}},{"type":"Polygon","arcs":[[8948,-3552,-3426,-8669,-1730]],"id":"13155","properties":{"name":"Irwin"}},{"type":"Polygon","arcs":[[8949,-1790,-6414,8950]],"id":"27035","properties":{"name":"Crow Wing"}},{"type":"Polygon","arcs":[[-305,-5117,-5123,8951,-7828,-4644,-3581,-2563]],"id":"30087","properties":{"name":"Rosebud"}},{"type":"Polygon","arcs":[[-678,-1895,-8203,-3460,-8488]],"id":"39169","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[-624,-4811,8952,8953,-7259]],"id":"12051","properties":{"name":"Hendry"}},{"type":"Polygon","arcs":[[-8905,-5944,-8730,-2009,8954]],"id":"13181","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-4476,8955,-8645,8956]],"id":"13183","properties":{"name":"Long"}},{"type":"Polygon","arcs":[[-7239,-2789,8957,-4638,-6090,-1671]],"id":"48469","properties":{"name":"Victoria"}},{"type":"Polygon","arcs":[[-1908,8958,8959,-7155,8960,-7327,8961]],"id":"39025","properties":{"name":"Clermont"}},{"type":"Polygon","arcs":[[-1011,8962,-7383,-5692,8963,-755]],"id":"46109","properties":{"name":"Roberts"}},{"type":"Polygon","arcs":[[-4964,-6082,-355,-8826,-2607,-2558,-4553]],"id":"46102","properties":{"name":"Oglala Lakota"}},{"type":"Polygon","arcs":[[-6844,8964,-3420,-3969,-7736]],"id":"54067","properties":{"name":"Nicholas"}},{"type":"Polygon","arcs":[[8965,-6992,8966,8967,8968]],"id":"72071","properties":{"name":"Isabela"}},{"type":"Polygon","arcs":[[-6996,8969,-2114,-8714,-8711]],"id":"72083","properties":{"name":"Las MarÃ­as"}},{"type":"Polygon","arcs":[[8970,8971,-6993,-8966]],"id":"72115","properties":{"name":"Quebradillas"}},{"type":"Polygon","arcs":[[-6995,8972,8973,-7091,-7183,8974,-2115,-8970]],"id":"72081","properties":{"name":"Lares"}},{"type":"Polygon","arcs":[[8975,8976,-7743,-6881]],"id":"72089","properties":{"name":"Luquillo"}},{"type":"Polygon","arcs":[[-7180,-6946,8977,-8706]],"id":"72111","properties":{"name":"PeÃ±uelas"}},{"type":"Polygon","arcs":[[-5619,-7636,-996,8978,8979]],"id":"33017","properties":{"name":"Strafford"}},{"type":"Polygon","arcs":[[-3465,-2281,-3549,-8486,-3361,-3352,-6598]],"id":"05045","properties":{"name":"Faulkner"}},{"type":"Polygon","arcs":[[8980,-8609,8981,-7362,8982]],"id":"29186","properties":{"name":"Ste. Genevieve"}},{"type":"Polygon","arcs":[[-6154,-3642,-3732,-7191,-2532]],"id":"31153","properties":{"name":"Sarpy"}},{"type":"Polygon","arcs":[[-8112,8983,8984,-1523,-5712,-8936,8985,-8934,-8048]],"id":"51179","properties":{"name":"Stafford"}},{"type":"Polygon","arcs":[[8986,-5919,-4262,-6965,-3304,-716,-1782]],"id":"38089","properties":{"name":"Stark"}},{"type":"Polygon","arcs":[[-5823,8987,8988,8989,8990,8991,8992]],"id":"47051","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-496,-2167,-5283,-6487,8993]],"id":"38101","properties":{"name":"Ward"}},{"type":"Polygon","arcs":[[8994,-684,8995,-7957,8996,-8989]],"id":"47115","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[8997,-7666,-5724,-5702,-7621,-1944,-8928]],"id":"27037","properties":{"name":"Dakota"}},{"type":"Polygon","arcs":[[-4230,-8430,-491,8998,-3076,-6613]],"id":"18035","properties":{"name":"Delaware"}},{"type":"Polygon","arcs":[[-7481,-2908,-1785,8999,-2887]],"id":"27061","properties":{"name":"Itasca"}},{"type":"Polygon","arcs":[[-8700,9000,-3248,-787]],"id":"26069","properties":{"name":"Iosco"}},{"type":"Polygon","arcs":[[-3445,9001,9002,-6546,9003]],"id":"20159","properties":{"name":"Rice"}},{"type":"Polygon","arcs":[[9004,-7473,-5886,9005,-8593]],"id":"20209","properties":{"name":"Wyandotte"}},{"type":"Polygon","arcs":[[9006,-5567,-559,-936,-2751,-3773,9007]],"id":"48479","properties":{"name":"Webb"}},{"type":"Polygon","arcs":[[-8323,9008,-6899,-6141,9009,9010]],"id":"48481","properties":{"name":"Wharton"}},{"type":"Polygon","arcs":[[-2624,-2583,9011,-887,-2176,9012,-8627]],"id":"13207","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[-1820,-652,9013,-6379,-1771,-8636]],"id":"13219","properties":{"name":"Oconee"}},{"type":"Polygon","arcs":[[-7918,9014,-8922,-7923,-8104]],"id":"13225","properties":{"name":"Peach"}},{"type":"Polygon","arcs":[[9015,9016,9017,-8654]],"id":"13239","properties":{"name":"Quitman"}},{"type":"Polygon","arcs":[[-3463,-8882,-1922,9018,-2632,-951]],"id":"39031","properties":{"name":"Coshocton"}},{"type":"Polygon","arcs":[[-9017,9019,-6610,9020,-1850,9021]],"id":"13243","properties":{"name":"Randolph"}},{"type":"Polygon","arcs":[[-3313,-2471,-6884,-8698,-2754,9022,-1752]],"id":"72085","properties":{"name":"Las Piedras"}},{"type":"Polygon","arcs":[[9023,-7742,9024,-6515,9025]],"id":"54079","properties":{"name":"Putnam"}},{"type":"Polygon","arcs":[[-7105,-7734,9026,-4928,-2445,-8387]],"id":"54109","properties":{"name":"Wyoming"}},{"type":"Polygon","arcs":[[-6856,-4913,9027,9028,-6367,-7458]],"id":"34037","properties":{"name":"Sussex"}},{"type":"Polygon","arcs":[[9029,-3621,-8208,-3377,-6319,-8294]],"id":"01007","properties":{"name":"Bibb"}},{"type":"Polygon","arcs":[[9030,-6284,-4950,9031,9032,-6416]],"id":"28057","properties":{"name":"Itawamba"}},{"type":"Polygon","arcs":[[-7560,9033,-8921,-3748,-2776,9034]],"id":"29111","properties":{"name":"Lewis"}},{"type":"Polygon","arcs":[[-5279,9035,9036,9037,9038,-4917]],"id":"33019","properties":{"name":"Sullivan"}},{"type":"Polygon","arcs":[[-2193,-3265,-1646,9039,9040,9041,-2164]],"id":"38069","properties":{"name":"Pierce"}},{"type":"Polygon","arcs":[[9042,9043,-3735,9044,-8847,-4511]],"id":"36081","properties":{"name":"Queens"}},{"type":"Polygon","arcs":[[-8016,-1283,-8015,-6227,-3593,-2664,9045,-815]],"id":"37033","properties":{"name":"Caswell"}},{"type":"Polygon","arcs":[[9046,-5410,-5499,-3685]],"id":"26131","properties":{"name":"Ontonagon"}},{"type":"Polygon","arcs":[[-4844,-8652,9047,-8447,-7840,9048]],"id":"22005","properties":{"name":"Ascension"}},{"type":"Polygon","arcs":[[9049,-6466,-622,-766,-1897]],"id":"12055","properties":{"name":"Highlands"}},{"type":"Polygon","arcs":[[-6365,-4709,-1066,-3946,-8892]],"id":"37089","properties":{"name":"Henderson"}},{"type":"Polygon","arcs":[[-1154,-3332,-1297,-1180,-2815,-3640]],"id":"19029","properties":{"name":"Cass"}},{"type":"Polygon","arcs":[[-8760,9050,-6666,9051,-2101,9052,-1693]],"id":"39097","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[9053,9054,-3211,-6465,-8621]],"id":"12061","properties":{"name":"Indian River"}},{"type":"Polygon","arcs":[[9055,-7799,-7891,-5035,-4453,9056]],"id":"05131","properties":{"name":"Sebastian"}},{"type":"Polygon","arcs":[[-8437,9057,-3002,-8553,-183]],"id":"17075","properties":{"name":"Iroquois"}},{"type":"Polygon","arcs":[[-8154,-3578,9058,-6611,-9020,-9016,-8653]],"id":"13259","properties":{"name":"Stewart"}},{"type":"Polygon","arcs":[[9059,9060,-1939,-1892,-676,-8888]],"id":"39035","properties":{"name":"Cuyahoga"}},{"type":"Polygon","arcs":[[-3847,-1774,9061,-881,-9012,-2582]],"id":"13159","properties":{"name":"Jasper"}},{"type":"Polygon","arcs":[[-6252,-8748,-8919,-8744,-6309]],"id":"13117","properties":{"name":"Forsyth"}},{"type":"Polygon","arcs":[[9062,9063,-5535,-8201,9064,-6813,9065]],"id":"16073","properties":{"name":"Owyhee"}},{"type":"Polygon","arcs":[[9066,9067,-3985,-8089,-210,9068,9069]],"id":"06085","properties":{"name":"Santa Clara"}},{"type":"Polygon","arcs":[[9070,-4849,-7755,9071,-3877,9072,-6549]],"id":"22079","properties":{"name":"Rapides"}},{"type":"Polygon","arcs":[[-90,-6417,-9033,9073,-8295,9074,9075]],"id":"28095","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[9076,-4988,-8399,9077,9078,-6435]],"id":"42101","properties":{"name":"Philadelphia"}},{"type":"Polygon","arcs":[[9079,-8979,-995,9080,-7575,9081]],"id":"33015","properties":{"name":"Rockingham"}},{"type":"Polygon","arcs":[[9082,9083,-8719,-5331,-8580,-6307]],"id":"36083","properties":{"name":"Rensselaer"}},{"type":"Polygon","arcs":[[-5054,9084,-4894,-3907]],"id":"37071","properties":{"name":"Gaston"}},{"type":"Polygon","arcs":[[9085,-6641,9086,-6139,-8850,-8764,9087]],"id":"29207","properties":{"name":"Stoddard"}},{"type":"Polygon","arcs":[[-8828,9088,-922,9089,-8630,9090,9091]],"id":"31069","properties":{"name":"Garden"}},{"type":"Polygon","arcs":[[-4941,-8087,-8657,-8467,-1830,-8459]],"id":"01109","properties":{"name":"Pike"}},{"type":"Polygon","arcs":[[-4886,-8933,-8862,9092,-5100,-5207,-1681,-7758]],"id":"42123","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[-1325,-2547,-7380,9093,-4999,9094]],"id":"20099","properties":{"name":"Labette"}},{"type":"Polygon","arcs":[[-1891,-526,-5907,-5318,-1166]],"id":"19039","properties":{"name":"Clarke"}},{"type":"Polygon","arcs":[[9095,-8695,-505,-4224,-7785,-2233,9096]],"id":"40041","properties":{"name":"Delaware"}},{"type":"Polygon","arcs":[[9097,-7400,-5308,-3130,-1577,9098]],"id":"18141","properties":{"name":"St. Joseph"}},{"type":"Polygon","arcs":[[9099,-7172,-6838]],"id":"37177","properties":{"name":"Tyrrell"}},{"type":"Polygon","arcs":[[-7120,-6463,-4765,-616,-8881,-8684,-8476]],"id":"08053","properties":{"name":"Hinsdale"}},{"type":"MultiPolygon","arcs":[[[-8721,9100,-6501,9101]],[[-8724,9102,-6505,-130,9103]]],"id":"48273","properties":{"name":"Kleberg"}},{"type":"Polygon","arcs":[[-3611,-7530,9104,-6874,9105,-1285,9106,9107]],"id":"51035","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[-2987,9108,-7389,9109,-9066,-6812,-4358,-2097]],"id":"41045","properties":{"name":"Malheur"}},{"type":"Polygon","arcs":[[9110,9111,-4838,9112,9113]],"id":"24009","properties":{"name":"Calvert"}},{"type":"Polygon","arcs":[[-5134,-5583,-5830,-5141,-5569]],"id":"21071","properties":{"name":"Floyd"}},{"type":"Polygon","arcs":[[-6767,-6713,-4154,9114,9115,9116,9117,-6901,9118,9119]],"id":"48201","properties":{"name":"Harris"}},{"type":"Polygon","arcs":[[-8092,-2287,-4572,9120]],"id":"51700","properties":{"name":"Newport News"}},{"type":"Polygon","arcs":[[-8835,-2811,-2084,9121,9122,9123,-4951,-2418]],"id":"02170","properties":{"name":"Matanuska-Susitna"}},{"type":"Polygon","arcs":[[-4596,-5166,-5157,-8191,9124,-3343]],"id":"05057","properties":{"name":"Hempstead"}},{"type":"Polygon","arcs":[[-7354,-7403,-6419,9125,-7516]],"id":"28137","properties":{"name":"Tate"}},{"type":"Polygon","arcs":[[9126,-8837,9127,-7501]],"id":"36085","properties":{"name":"Richmond"}},{"type":"Polygon","arcs":[[-2165,-9042,9128,9129,9130,-5284]],"id":"38083","properties":{"name":"Sheridan"}},{"type":"Polygon","arcs":[[9131,-2878,-8582,9132,-4908,-8140]],"id":"36111","properties":{"name":"Ulster"}},{"type":"Polygon","arcs":[[-2969,-1309,-4665,-5993,9133]],"id":"37059","properties":{"name":"Davie"}},{"type":"Polygon","arcs":[[-513,9134,-6951,-7042,-5006,-280]],"id":"48197","properties":{"name":"Hardeman"}},{"type":"Polygon","arcs":[[-6018,-7635,-3938,-2244,-6933,9135]],"id":"46117","properties":{"name":"Stanley"}},{"type":"Polygon","arcs":[[9136,-2442,9137,-1591,-1699,-7902]],"id":"29079","properties":{"name":"Grundy"}},{"type":"Polygon","arcs":[[-6665,-1933,-2636,-8841,-2102,-9052]],"id":"39049","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-8021,-2605,-8138,9138,-8428,-1276,-8180,-8576]],"id":"06061","properties":{"name":"Placer"}},{"type":"Polygon","arcs":[[-8594,-9006,-5890,-8310,-4071,-8215]],"id":"20091","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[-5335,-6188,9139,-7315,-8172,9140]],"id":"09005","properties":{"name":"Litchfield"}},{"type":"Polygon","arcs":[[-1832,-8471,9141,9142,9143,-2872,9144]],"id":"01061","properties":{"name":"Geneva"}},{"type":"Polygon","arcs":[[9145,-7297,-7967,9146,-9142,-8470]],"id":"01069","properties":{"name":"Houston"}},{"type":"Polygon","arcs":[[-6373,9147,9148,-9107,-1286,-9106,-6873,-7074,-8803,-4738]],"id":"51077","properties":{"name":"Grayson"}},{"type":"Polygon","arcs":[[-1031,-2956,-5245,-3326,-1212,-8548,9149]],"id":"08063","properties":{"name":"Kit Carson"}},{"type":"Polygon","arcs":[[-3635,-3316,-7489,9150,-8812]],"id":"19133","properties":{"name":"Monona"}},{"type":"Polygon","arcs":[[-8307,-5737,-6552,9151,-5560,-3788,-5262]],"id":"48351","properties":{"name":"Newton"}},{"type":"Polygon","arcs":[[9152,9153,9154,-6604,-6381]],"id":"13265","properties":{"name":"Taliaferro"}},{"type":"Polygon","arcs":[[-539,-1942,-6947,-9135,-512,9155]],"id":"40057","properties":{"name":"Harmon"}},{"type":"Polygon","arcs":[[-4754,9156,9157,-960,-4314]],"id":"48349","properties":{"name":"Navarro"}},{"type":"Polygon","arcs":[[9158,-4771,9159,-5246,-4580]],"id":"13279","properties":{"name":"Toombs"}},{"type":"Polygon","arcs":[[-2995,9160,-8983,-7361,-4239,-3602]],"id":"29187","properties":{"name":"St. Francois"}},{"type":"Polygon","arcs":[[9161,-4147,-7494,-4659,-6807]],"id":"35021","properties":{"name":"Harding"}},{"type":"Polygon","arcs":[[-4678,-1533,-1477,-8357,9162]],"id":"30097","properties":{"name":"Sweet Grass"}},{"type":"Polygon","arcs":[[9163,9164,-6585,-4695,-6761,-5792]],"id":"21155","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[-8316,-8362,9165,-5819,9166,9167,-7766]],"id":"47149","properties":{"name":"Rutherford"}},{"type":"MultiPolygon","arcs":[[[9168,-6234,-2495,-2478,9169,9170]]],"id":"53061","properties":{"name":"Snohomish"}},{"type":"Polygon","arcs":[[-6276,-2458,-7472,-9005,-8592,-7679]],"id":"29165","properties":{"name":"Platte"}},{"type":"Polygon","arcs":[[-8257,-1909,-8962,-7330,9171,9172,9173]],"id":"39061","properties":{"name":"Hamilton"}},{"type":"Polygon","arcs":[[-7141,-4996,-7768,-5554,-1456,-5529]],"id":"47081","properties":{"name":"Hickman"}},{"type":"Polygon","arcs":[[-4756,-4734,9174,-7041,-260,-1116]],"id":"48337","properties":{"name":"Montague"}},{"type":"Polygon","arcs":[[-5674,-8449,-7673,-6086,-5682]],"id":"49007","properties":{"name":"Carbon"}},{"type":"Polygon","arcs":[[-7826,-3256,-3121,-6410,-658,-3435]],"id":"20041","properties":{"name":"Dickinson"}},{"type":"Polygon","arcs":[[-2522,-8438,-181,9175,-8878,-1824]],"id":"17105","properties":{"name":"Livingston"}},{"type":"Polygon","arcs":[[-5038,-2266,-3467,-6600,9176,-3496,-4455]],"id":"05149","properties":{"name":"Yell"}},{"type":"Polygon","arcs":[[-5800,-7298,-4077,-2671]],"id":"16065","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[-3584,-646,-222,9177,-4027,-7628]],"id":"13285","properties":{"name":"Troup"}},{"type":"Polygon","arcs":[[9178,-1898,-764,-8903,9179]],"id":"12081","properties":{"name":"Manatee"}},{"type":"MultiPolygon","arcs":[[[9180,9181,9182,-8029,9183]],[[9184]],[[9185,9186]]],"id":"51001","properties":{"name":"Accomack"}},{"type":"Polygon","arcs":[[-885,9187,-65,-8924,-2177]],"id":"13289","properties":{"name":"Twiggs"}},{"type":"Polygon","arcs":[[-5476,-7386,-998,-5638,9188]],"id":"24035","properties":{"name":"Queen Anne's"}},{"type":"Polygon","arcs":[[-3668,-8253,-6184,-5333]],"id":"25015","properties":{"name":"Hampshire"}},{"type":"Polygon","arcs":[[-4538,-5387,-6529,-3216,9189,9190]],"id":"17071","properties":{"name":"Henderson"}},{"type":"Polygon","arcs":[[9191,-9097,-2232,-3917,9192]],"id":"40097","properties":{"name":"Mayes"}},{"type":"Polygon","arcs":[[-5170,-8305,-2932,-8304,-7015,-6242,-7054,-8569]],"id":"51149","properties":{"name":"Prince George"}},{"type":"Polygon","arcs":[[-7434,-7441,9193,-9043,-4510]],"id":"36005","properties":{"name":"Bronx"}},{"type":"Polygon","arcs":[[-3499,-8080,-8897,-8884,-5161,5159,-5159,-5165]],"id":"05019","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[-799,9194,-1812,-6664,-6661,-6741,9195]],"id":"39065","properties":{"name":"Hardin"}},{"type":"Polygon","arcs":[[-6274,-1416,-556,-5566,-975]],"id":"48163","properties":{"name":"Frio"}},{"type":"Polygon","arcs":[[-9177,-6599,-2539,-8077,-3497]],"id":"05051","properties":{"name":"Garland"}},{"type":"Polygon","arcs":[[-156,-5628,-1600,-7287,-5243,-2954]],"id":"31057","properties":{"name":"Dundy"}},{"type":"Polygon","arcs":[[9196,-5520,-6444,-2535,-970,-925]],"id":"31023","properties":{"name":"Butler"}},{"type":"Polygon","arcs":[[-7672,-1797,9197,-1231,-6087]],"id":"49019","properties":{"name":"Grand"}},{"type":"Polygon","arcs":[[-8734,-4604,-6135,-8090,-7012,-4319]],"id":"51127","properties":{"name":"New Kent"}},{"type":"Polygon","arcs":[[-9032,-4949,-2992,-8351,-2974,-8296,-9074]],"id":"01093","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[-8780,9198,-753,-6787,-5964,-2298]],"id":"30073","properties":{"name":"Pondera"}},{"type":"Polygon","arcs":[[-8137,9199,-8425,-9139]],"id":"32510","properties":{"name":"Carson City"}},{"type":"Polygon","arcs":[[9200,9201,-5361,-7659]],"id":"12125","properties":{"name":"Union"}},{"type":"MultiPolygon","arcs":[[[-9122,-2090,9202,9203]],[[9204]]],"id":"02020","properties":{"name":"Anchorage"}},{"type":"Polygon","arcs":[[-7539,-3687,-5498,9205,9206,-4180]],"id":"55125","properties":{"name":"Vilas"}},{"type":"Polygon","arcs":[[9207,-2603,-3279,-8929,-3102]],"id":"28019","properties":{"name":"Choctaw"}},{"type":"Polygon","arcs":[[-2377,9208,-8216,-7428]],"id":"31169","properties":{"name":"Thayer"}},{"type":"Polygon","arcs":[[-773,9209,-515,9210,-62,-5801]],"id":"13223","properties":{"name":"Paulding"}},{"type":"Polygon","arcs":[[9211,-8507,-8454,-8503,-4492,9212,-5607]],"id":"32033","properties":{"name":"White Pine"}},{"type":"Polygon","arcs":[[9213,9214,-1100,-8784,-2595,-3108]],"id":"48203","properties":{"name":"Harrison"}},{"type":"Polygon","arcs":[[-6312,-6345,9215,-644]],"id":"13113","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[-7591,-6614,-3080,9216,-1582,-7595]],"id":"18059","properties":{"name":"Hancock"}},{"type":"Polygon","arcs":[[-7753,-6634,9217,-8001,-7990,9218]],"id":"22025","properties":{"name":"Catahoula"}},{"type":"Polygon","arcs":[[9219,-7328,-8961,-7159,-6683,9220]],"id":"21191","properties":{"name":"Pendleton"}},{"type":"Polygon","arcs":[[-3612,-9108,-9149,9221,-7051]],"id":"51197","properties":{"name":"Wythe"}},{"type":"Polygon","arcs":[[9222,9223,-6848,-5862,-8701,-1497]],"id":"56003","properties":{"name":"Big Horn"}},{"type":"Polygon","arcs":[[-3767,-7006,-6019,9224,-6577]],"id":"46137","properties":{"name":"Ziebach"}},{"type":"MultiPolygon","arcs":[[[9225]],[[9226,9227]]],"id":"25007","properties":{"name":"Dukes"}},{"type":"Polygon","arcs":[[-8918,9228,-1921,-649,-1819]],"id":"13157","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-5879,9229,-3003,-9058,-8436]],"id":"18111","properties":{"name":"Newton"}},{"type":"Polygon","arcs":[[9230,-4527,-8736,-8061,9231]],"id":"48277","properties":{"name":"Lamar"}},{"type":"Polygon","arcs":[[-7374,-2888,-9000,-1784,-8950,9232,-3532,-7421]],"id":"27021","properties":{"name":"Cass"}},{"type":"Polygon","arcs":[[-1981,-1613,-1996,-3478,-821]],"id":"48153","properties":{"name":"Floyd"}},{"type":"Polygon","arcs":[[-3079,9233,-2852,-3854,-1583,-9217]],"id":"18139","properties":{"name":"Rush"}},{"type":"Polygon","arcs":[[-1300,-7699,-7258,-3016,-3015,-3014,3012,-3012,9234]],"id":"06079","properties":{"name":"San Luis Obispo"}},{"type":"Polygon","arcs":[[-9003,9235,-5148,-4780,-6401,-2524,-6547]],"id":"20155","properties":{"name":"Reno"}},{"type":"Polygon","arcs":[[-3177,-1042,-2692,-2683,-3589]],"id":"19025","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[-1788,-8883,-664,-6411]],"id":"27065","properties":{"name":"Kanabec"}},{"type":"Polygon","arcs":[[-5069,-8024,-6977,-7633,-8318,-8948]],"id":"42035","properties":{"name":"Clinton"}},{"type":"Polygon","arcs":[[-3325,-902,9236,-2252,-3142,-1208]],"id":"20109","properties":{"name":"Logan"}},{"type":"Polygon","arcs":[[-1907,-1695,9237,-6910,9238,-8959]],"id":"39027","properties":{"name":"Clinton"}},{"type":"Polygon","arcs":[[-8682,-800,-9196,-6740,-1901]],"id":"39003","properties":{"name":"Allen"}},{"type":"Polygon","arcs":[[-4335,-2759,-8834,9239,-6961,-834,-2022]],"id":"55115","properties":{"name":"Shawano"}},{"type":"Polygon","arcs":[[-2235,-7787,-7800,-9056,9240,-8183,-8489]],"id":"40135","properties":{"name":"Sequoyah"}},{"type":"Polygon","arcs":[[-6982,-8268,-6037,9241,9242,9243,-810,9244,-6979,9245]],"id":"47035","properties":{"name":"Cumberland"}},{"type":"Polygon","arcs":[[9246,-6377,-4641,-5802,-64,9247,-7626,-3628]],"id":"01029","properties":{"name":"Cleburne"}},{"type":"Polygon","arcs":[[-84,-7302,9248,-7350,9249]],"id":"26099","properties":{"name":"Macomb"}},{"type":"Polygon","arcs":[[-8419,-86,9250,-6554,-8416,-3031]],"id":"26049","properties":{"name":"Genesee"}},{"type":"Polygon","arcs":[[-3165,9251,-4861,-1140,-989]],"id":"17007","properties":{"name":"Boone"}},{"type":"Polygon","arcs":[[-4016,-5467,-6489,9252,-1780,-8421,-3739]],"id":"38053","properties":{"name":"McKenzie"}},{"type":"Polygon","arcs":[[-7529,-7677,-4569,-3044,-6875,-9105]],"id":"51141","properties":{"name":"Patrick"}},{"type":"Polygon","arcs":[[-7273,-8481,9253,-5725,-6137,9254]],"id":"17003","properties":{"name":"Alexander"}},{"type":"Polygon","arcs":[[-7195,-4597,-3342,-8240]],"id":"05133","properties":{"name":"Sevier"}},{"type":"Polygon","arcs":[[-6431,9255,-8661,9256,-451]],"id":"28039","properties":{"name":"George"}},{"type":"Polygon","arcs":[[-6651,9257,-8642,-8838,-9127,-7500]],"id":"34039","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[-4112,-4462,-4013,9258,9259,9260]],"id":"17015","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[-3385,9261,-3553,-8949,-1729,9262]],"id":"13287","properties":{"name":"Turner"}},{"type":"Polygon","arcs":[[-8474,9263,-9070,9264,9265]],"id":"06081","properties":{"name":"San Mateo"}},{"type":"Polygon","arcs":[[9266,9267,-8824,-7211,-3070,9268,-4769]],"id":"13031","properties":{"name":"Bulloch"}},{"type":"Polygon","arcs":[[-4822,-4113,-9261,9269,-2679]],"id":"19097","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-2158,-8478,-8683,-5255,-1233]],"id":"08113","properties":{"name":"San Miguel"}},{"type":"Polygon","arcs":[[-3774,-2752,-133,-8028,9270]],"id":"48427","properties":{"name":"Starr"}},{"type":"Polygon","arcs":[[-2138,-8585,-4000,-8915,-8746]],"id":"13187","properties":{"name":"Lumpkin"}},{"type":"Polygon","arcs":[[-9029,9271,-8643,-9258,-6650,-4563,-6368]],"id":"34027","properties":{"name":"Morris"}},{"type":"Polygon","arcs":[[9272,-2797,-2374,-7808,-4205,-1602,-5627]],"id":"31063","properties":{"name":"Frontier"}},{"type":"Polygon","arcs":[[-7094,-4339,-8424,-6314,-5699,-5866]],"id":"55033","properties":{"name":"Dunn"}},{"type":"Polygon","arcs":[[-6145,9273,-2868,-2915,-249]],"id":"48429","properties":{"name":"Stephens"}},{"type":"Polygon","arcs":[[-9216,-6344,-8083,-2585,-2623,-6593,-217,-645]],"id":"13255","properties":{"name":"Spalding"}},{"type":"Polygon","arcs":[[-3139,-7469,-3714,9274,-6895]],"id":"39051","properties":{"name":"Fulton"}},{"type":"Polygon","arcs":[[-479,-5392,-3857,-2818,9275]],"id":"19037","properties":{"name":"Chickasaw"}},{"type":"Polygon","arcs":[[-8578,-190,-2639,-2869,-6942]],"id":"48369","properties":{"name":"Parmer"}},{"type":"Polygon","arcs":[[-2181,-1754,9276,-3597,9277,-2998,-5603]],"id":"72109","properties":{"name":"Patillas"}},{"type":"Polygon","arcs":[[-5896,-1684,-5204,-5048,-3928,-1016,-5892]],"id":"42019","properties":{"name":"Butler"}},{"type":"Polygon","arcs":[[9278,-1637,9279,9280,-8727]],"id":"50009","properties":{"name":"Essex"}},{"type":"Polygon","arcs":[[-2685,-2694,-8869,-1295,-3331]],"id":"19077","properties":{"name":"Guthrie"}},{"type":"Polygon","arcs":[[-9065,-8200,-3375,-7037,-8505,-9212,-5606,-8854,-6814]],"id":"32007","properties":{"name":"Elko"}},{"type":"Polygon","arcs":[[9281,-8991,9282,-8036,-2403,-7813]],"id":"01089","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[-4032,-8427,9283,-4627,-2662,-5043,-1158,-7109,-2744]],"id":"06051","properties":{"name":"Mono"}},{"type":"Polygon","arcs":[[-7207,-8694,-5812,9284]],"id":"06073","properties":{"name":"San Diego"}},{"type":"Polygon","arcs":[[-4653,-6485,-5378,-592,-594,-3092]],"id":"31115","properties":{"name":"Loup"}},{"type":"Polygon","arcs":[[-8895,-5538,9285,9286,-5782]],"id":"31157","properties":{"name":"Scotts Bluff"}},{"type":"Polygon","arcs":[[-718,-3306,-6964,-5974,-3765,-6955,-8420]],"id":"38001","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[-1193,-5190,9287,9288,-4219,-6283,9289,-5486]],"id":"47071","properties":{"name":"Hardin"}},{"type":"Polygon","arcs":[[-7938,-5982,9290,-9214,-3107]],"id":"48315","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[-7789,9291,9292,-3997,-8584]],"id":"13281","properties":{"name":"Towns"}},{"type":"Polygon","arcs":[[-9173,9293,9294,-6859,-7418,-4506,9295]],"id":"21015","properties":{"name":"Boone"}},{"type":"Polygon","arcs":[[9296,-1336,-7399,9297,9298]],"id":"26159","properties":{"name":"Van Buren"}},{"type":"Polygon","arcs":[[-8065,-1738,9299,-4370,9300,-8870]],"id":"48465","properties":{"name":"Val Verde"}},{"type":"Polygon","arcs":[[-7185,-8639,-8755,9301,-9188,-884]],"id":"13319","properties":{"name":"Wilkinson"}},{"type":"Polygon","arcs":[[-3387,9302,-7961,9303,-198]],"id":"13177","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[9304,-3073,-4477,-8957,-8644,-5247,-9160]],"id":"13267","properties":{"name":"Tattnall"}},{"type":"Polygon","arcs":[[9305,-3694,-3657,9306,-5010,-5657]],"id":"23011","properties":{"name":"Kennebec"}},{"type":"Polygon","arcs":[[-5764,-1364,9307,-229,-7215]],"id":"19189","properties":{"name":"Winnebago"}},{"type":"Polygon","arcs":[[-5670,-2738,-5641,-3818]],"id":"19059","properties":{"name":"Dickinson"}},{"type":"Polygon","arcs":[[-5220,-4424,-1265,9308,-4850,-9071,-6548,-5735]],"id":"22069","properties":{"name":"Natchitoches"}},{"type":"Polygon","arcs":[[9309,9310,-158,-8378]],"id":"72017","properties":{"name":"Barceloneta"}},{"type":"Polygon","arcs":[[-8827,-5805,9311,-918,-9089]],"id":"31075","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[-7556,-8230,-7996,-9218,-6633]],"id":"22041","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-8911,-8108,-8032,-193,-6608,-9059,-3577]],"id":"13197","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[-7055,-6245,-5996,-4391,-6000,-8331,-8096,-6707,-8457,-8675]],"id":"51175","properties":{"name":"Southampton"}},{"type":"Polygon","arcs":[[-8423,-8801,-8100,9312,-6985]],"id":"55121","properties":{"name":"Trempealeau"}},{"type":"Polygon","arcs":[[9313,9314,-8217,-7929]],"id":"06055","properties":{"name":"Napa"}},{"type":"Polygon","arcs":[[-3835,-8221,-1280,-6103,-3546,-2279]],"id":"05137","properties":{"name":"Stone"}},{"type":"Polygon","arcs":[[-1378,-6412,-667,9315,9316,-8624,9317]],"id":"27141","properties":{"name":"Sherburne"}},{"type":"Polygon","arcs":[[-4873,-7976,9318,-7630]],"id":"48141","properties":{"name":"El Paso"}},{"type":"Polygon","arcs":[[-173,-8777,-8353,-8388]],"id":"54003","properties":{"name":"Berkeley"}},{"type":"Polygon","arcs":[[9319,-6824,-4420,9320,-7581,-321]],"id":"21141","properties":{"name":"Logan"}},{"type":"Polygon","arcs":[[-468,-2320,-724,-254,-2328]],"id":"48081","properties":{"name":"Coke"}},{"type":"Polygon","arcs":[[-8739,9321,-3964,-8939,-8787,-8930]],"id":"39079","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-4815,9322,-7605,-5209,9323]],"id":"13039","properties":{"name":"Camden"}},{"type":"Polygon","arcs":[[-4741,-7447,-4195,-8898,-8901,-4711,-7579]],"id":"37011","properties":{"name":"Avery"}},{"type":"MultiPolygon","arcs":[[[9324]],[[9325]],[[9326]],[[9327]],[[9328]],[[9329]],[[9330]],[[9331]],[[9332]],[[9333]],[[9334]],[[9335]],[[9336]],[[9337]],[[9338]],[[9339]],[[9340]],[[9341]],[[9342]],[[9343]],[[9344]],[[9345]],[[9346]],[[9347]],[[9348]],[[9349]],[[9350]],[[9351]],[[9352]],[[9353]],[[9354]],[[9355]],[[9356]],[[9357]],[[9358]],[[9359]],[[9360]],[[9361]],[[9362]],[[9363]],[[9364]],[[9365]],[[9366]]],"id":"02016","properties":{"name":"Aleutians West"}},{"type":"MultiPolygon","arcs":[[[9367]],[[9368]],[[9369]],[[9370]],[[-9203,-2089,9371]],[[9372]],[[9373]],[[9374]],[[-4952,-9124,9375,-2061,-2074]]],"id":"02122","properties":{"name":"Kenai Peninsula"}},{"type":"Polygon","arcs":[[-7607,9376,-8562,-7909,9377]],"id":"12031","properties":{"name":"Duval"}},{"type":"MultiPolygon","arcs":[[[9378]],[[-7686,-6439,9379]]],"id":"44009","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-6454,-8384,-6333,9380,-6522]],"id":"08019","properties":{"name":"Clear Creek"}},{"type":"Polygon","arcs":[[9381,-2294,-8174,-4442,-8220,9382]],"id":"29153","properties":{"name":"Ozark"}},{"type":"Polygon","arcs":[[9383,-8549,-5311,-8617,9384,-2331,-8333]],"id":"08061","properties":{"name":"Kiowa"}},{"type":"MultiPolygon","arcs":[[[9385,-7548]],[[-7551,9386,-8026]]],"id":"48061","properties":{"name":"Cameron"}},{"type":"Polygon","arcs":[[-1537,-2295,-9382,9387,-7708,-7251,-1689]],"id":"29213","properties":{"name":"Taney"}},{"type":"Polygon","arcs":[[-1393,-7941,-3924,-7935,-2355,9388,-405]],"id":"40017","properties":{"name":"Canadian"}},{"type":"Polygon","arcs":[[-7862,9389,-2268,-5037,-7890]],"id":"05071","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[-8852,-6044,-8851,-6042,-6116,-5755,-3744]],"id":"47095","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[-3800,-5473,-7057,-7067,-6224,-8129]],"id":"51037","properties":{"name":"Charlotte"}},{"type":"Polygon","arcs":[[-8484,-8776,-8761,-8893,-6163]],"id":"05055","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[9390,-7883,9391,-7869,9392]],"id":"12129","properties":{"name":"Wakulla"}},{"type":"Polygon","arcs":[[9393,-3681,-1004,9394]],"id":"26141","properties":{"name":"Presque Isle"}},{"type":"Polygon","arcs":[[9395,-8407,-5874,-8435,-2520,-1573]],"id":"17197","properties":{"name":"Will"}},{"type":"Polygon","arcs":[[9396]],"id":"72147","properties":{"name":"Vieques"}},{"type":"Polygon","arcs":[[-7740,-7737,-5681,-4929,-9027,-7733]],"id":"54081","properties":{"name":"Raleigh"}},{"type":"Polygon","arcs":[[-63,-9211,-518,-6313,-648,-3583,-7627,-9248]],"id":"13045","properties":{"name":"Carroll"}},{"type":"Polygon","arcs":[[9397,-8855,-5608,-9213,-4498,-8591,-5044,-2660,-4626]],"id":"32023","properties":{"name":"Nye"}},{"type":"Polygon","arcs":[[9398,-6922,9399,9400,-5687,-2793]],"id":"55039","properties":{"name":"Fond du Lac"}},{"type":"Polygon","arcs":[[-2214,-4539,-9191,9401,-7558,-2170]],"id":"19111","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[9402,9403,-9083,-6306,-8043,-7945,9404,-7859]],"id":"36091","properties":{"name":"Saratoga"}},{"type":"Polygon","arcs":[[9405,-4096,9406,-6720,-851,-3879]],"id":"22097","properties":{"name":"St. Landry"}},{"type":"Polygon","arcs":[[-8123,9407,-2722,-4524,9408,-7898]],"id":"40005","properties":{"name":"Atoka"}},{"type":"Polygon","arcs":[[-7860,-9405,-7944,-4138]],"id":"36035","properties":{"name":"Fulton"}},{"type":"Polygon","arcs":[[-8124,-6752,-8186,-8188,-2717,-9408,-8122]],"id":"40121","properties":{"name":"Pittsburg"}},{"type":"Polygon","arcs":[[-3572,9409,9410,-8345,-7565,-3959,9411]],"id":"39009","properties":{"name":"Athens"}},{"type":"Polygon","arcs":[[-8292,-6591,-2768,-880,9412,-8288]],"id":"01131","properties":{"name":"Wilcox"}},{"type":"Polygon","arcs":[[9413,9414,-6289,-5397,-5402,9415,-2421]],"id":"42051","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[9416,9417,9418,-8038,-4946,-4165,-3618,-8349]],"id":"01009","properties":{"name":"Blount"}},{"type":"Polygon","arcs":[[-4404,-7154,-4045,-6469,-6602,-770,-4003]],"id":"13129","properties":{"name":"Gordon"}},{"type":"Polygon","arcs":[[-9048,-8651,-17,9419,-8161,-4790,-8369,-8448]],"id":"22095","properties":{"name":"St. John the Baptist"}},{"type":"Polygon","arcs":[[-5884,-7865,-7849,-7456,-5900]],"id":"42069","properties":{"name":"Lackawanna"}},{"type":"Polygon","arcs":[[-9243,9420,-5962,9421,-4307,9422,-4744,9423]],"id":"47145","properties":{"name":"Roane"}},{"type":"Polygon","arcs":[[-8868,9424,-3312,-1750,-138]],"id":"72063","properties":{"name":"Gurabo"}},{"type":"Polygon","arcs":[[9425,-8807,9426,-6677,-7005]],"id":"46021","properties":{"name":"Campbell"}},{"type":"Polygon","arcs":[[-2116,-8975,-7182,-8705,9427,-7770,-3327]],"id":"72153","properties":{"name":"Yauco"}},{"type":"Polygon","arcs":[[-7340,-7333,-4846,9428,-4093]],"id":"22121","properties":{"name":"West Baton Rouge"}},{"type":"Polygon","arcs":[[-4409,-7597,-1563,-7751,-6530,9429]],"id":"18133","properties":{"name":"Putnam"}},{"type":"Polygon","arcs":[[-1182,-1151,-8497,-8536,-7639]],"id":"19173","properties":{"name":"Taylor"}},{"type":"Polygon","arcs":[[-3646,-8274,-2673,-4082,9430,-7286,-7642]],"id":"16011","properties":{"name":"Bingham"}},{"type":"MultiPolygon","arcs":[[[9431]],[[9432]],[[9433]],[[9434]],[[9435]],[[9436]],[[9437]],[[9438,-7540,-4178,-440,-4608]]],"id":"55003","properties":{"name":"Ashland"}},{"type":"Polygon","arcs":[[-6986,-9313,-8103,-5584,-8400,-3309,-7470]],"id":"27169","properties":{"name":"Winona"}},{"type":"Polygon","arcs":[[9439,-7084,-7019,-2411,-5449,9440,-7507],[-1287]],"id":"51165","properties":{"name":"Rockingham"}},{"type":"Polygon","arcs":[[9441,9442,-4540,-7573]],"id":"30019","properties":{"name":"Daniels"}},{"type":"Polygon","arcs":[[-7570,-5329,-3816,-3417,-8146]],"id":"54097","properties":{"name":"Upshur"}},{"type":"Polygon","arcs":[[-8968,9443,-7096,9444]],"id":"72005","properties":{"name":"Aguadilla"}},{"type":"Polygon","arcs":[[9445,-4184,-2473,-9425,-8867,-8864]],"id":"72031","properties":{"name":"Carolina"}},{"type":"Polygon","arcs":[[9446,-8379,-7087,-8974,9447]],"id":"72065","properties":{"name":"Hatillo"}},{"type":"Polygon","arcs":[[9448,-6768,-9120,9449,-8321,-7033]],"id":"48473","properties":{"name":"Waller"}},{"type":"Polygon","arcs":[[-1753,-9023,-2757,9450,-3595,-9277]],"id":"72151","properties":{"name":"Yabucoa"}},{"type":"Polygon","arcs":[[-6536,-4875,-4691,-7277,-7316]],"id":"18147","properties":{"name":"Spencer"}},{"type":"Polygon","arcs":[[-8372,9451,-9395,-1003,-1598,-7462]],"id":"26031","properties":{"name":"Cheboygan"}},{"type":"Polygon","arcs":[[-9133,-8581,-5336,-9141,-8171,-8167,-4909]],"id":"36027","properties":{"name":"Dutchess"}},{"type":"Polygon","arcs":[[-5524,-4679,-9163,-8356,9452,-1495]],"id":"30067","properties":{"name":"Park"}},{"type":"Polygon","arcs":[[-6550,-9073,-3876,-8148,9453]],"id":"22003","properties":{"name":"Allen"}},{"type":"Polygon","arcs":[[-2940,-1052,-340,9454,-2961]],"id":"28101","properties":{"name":"Newton"}},{"type":"Polygon","arcs":[[-4094,-9429,-4845,-9049,-7839,-4830,9455]],"id":"22047","properties":{"name":"Iberville"}},{"type":"Polygon","arcs":[[-3604,-4242,-6642,-9086,9456,-6644,-8336]],"id":"29223","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[-7889,-532,-3729,-7545,-7043,-6949]],"id":"40141","properties":{"name":"Tillman"}},{"type":"Polygon","arcs":[[-759,9457,-3710,-6297,9458,-6290,-365]],"id":"36011","properties":{"name":"Cayuga"}},{"type":"Polygon","arcs":[[-7788,-7719,-7796,9459,-9292]],"id":"13241","properties":{"name":"Rabun"}},{"type":"Polygon","arcs":[[-3979,-4440,-5413,-4561,-7356,-7515,-8796,-8797,-613]],"id":"05035","properties":{"name":"Crittenden"}},{"type":"Polygon","arcs":[[-9143,-9147,-7966,-849,-7876,-7815,-2461,-3844,9460]],"id":"12063","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[9461,-6850,-145,-2468,-7661,-3472,-4731]],"id":"72021","properties":{"name":"BayamÃ³n"}},{"type":"Polygon","arcs":[[-3474,-7663,-141,-2180,-1121,-3286]],"id":"72041","properties":{"name":"Cidra"}},{"type":"Polygon","arcs":[[-4791,-4216,-7814,-2406,9462,-2989,-4948]],"id":"01079","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[-8443,-4302,9463,9464,9465]],"id":"21215","properties":{"name":"Spencer"}},{"type":"Polygon","arcs":[[-8602,9466,-639,-8010,-8560]],"id":"53067","properties":{"name":"Thurston"}},{"type":"Polygon","arcs":[[9467,9468,-3672,-7536,-267,-1453]],"id":"46011","properties":{"name":"Brookings"}},{"type":"Polygon","arcs":[[-5822,-5828,-685,-8995,-8988]],"id":"47061","properties":{"name":"Grundy"}},{"type":"Polygon","arcs":[[-7048,-1673,-6089,-8531,9469]],"id":"48025","properties":{"name":"Bee"}},{"type":"Polygon","arcs":[[9470,9471,-9113,-4840,9472]],"id":"24017","properties":{"name":"Charles"}},{"type":"Polygon","arcs":[[-5881,-5899,-7002,-6973,9473]],"id":"42113","properties":{"name":"Sullivan"}},{"type":"Polygon","arcs":[[-2289,-8091]],"id":"51830","properties":{"name":"Williamsburg"}},{"type":"Polygon","arcs":[[-8735,-7940,9474,-2362]],"id":"48449","properties":{"name":"Titus"}},{"type":"Polygon","arcs":[[-2363,-9475,-7939,-3105,-6691]],"id":"48063","properties":{"name":"Camp"}},{"type":"Polygon","arcs":[[9475,-5824,-8993,9476]],"id":"47127","properties":{"name":"Moore"}},{"type":"Polygon","arcs":[[9477,-7899,-9409,-4528,-9231,9478,9479]],"id":"40013","properties":{"name":"Bryan"}},{"type":"Polygon","arcs":[[-2388,-116,-6769,-9449,-7032,-8045]],"id":"48185","properties":{"name":"Grimes"}},{"type":"Polygon","arcs":[[-7874,7872,-7872,-2112,-7292,-7879,-9391,9480]],"id":"12073","properties":{"name":"Leon"}},{"type":"Polygon","arcs":[[-91,-9076,9481,-2599,9482]],"id":"28025","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[-6220,-8538,9483,-4619,-4201,-8302]],"id":"29087","properties":{"name":"Holt"}},{"type":"Polygon","arcs":[[-7444,9484,-6656,-8860,-8932,9485]],"id":"36029","properties":{"name":"Erie"}},{"type":"Polygon","arcs":[[-8440,-3048,-7387,-9109,-2986]],"id":"16087","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-6578,-9225,-9136,-6932,-6079,-4962]],"id":"46055","properties":{"name":"Haakon"}},{"type":"Polygon","arcs":[[-8184,-9241,-9057,-4457,-7194,-8239,-2719,-8187]],"id":"40079","properties":{"name":"Le Flore"}},{"type":"Polygon","arcs":[[-6047,-8940,-6517,9486,-8385,-5580,-5324]],"id":"54099","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[-7532,9487,-3742,-6237,-5113,-303]],"id":"30079","properties":{"name":"Prairie"}},{"type":"Polygon","arcs":[[9488,-7953,9489,-2700]],"id":"12033","properties":{"name":"Escambia"}},{"type":"Polygon","arcs":[[-9302,-8754,9490,-8690,-8741,-66]],"id":"13175","properties":{"name":"Laurens"}},{"type":"Polygon","arcs":[[9491,-2820,-228,-3321,-889]],"id":"19023","properties":{"name":"Butler"}},{"type":"Polygon","arcs":[[9492,-5439,9493,-500,9494,-6197,-3537,-7691]],"id":"41065","properties":{"name":"Wasco"}},{"type":"Polygon","arcs":[[-6077,-5074,-7830,-1661,-6569,9495]],"id":"31027","properties":{"name":"Cedar"}},{"type":"Polygon","arcs":[[-9038,9496,-9082,-7574,9497,-8250,9498]],"id":"33011","properties":{"name":"Hillsborough"}},{"type":"Polygon","arcs":[[-8525,-6021,-5518,-8825,-9268,9499]],"id":"13251","properties":{"name":"Screven"}},{"type":"Polygon","arcs":[[-8813,-9151,-7490,-5431,-6443,-1062]],"id":"31021","properties":{"name":"Burt"}},{"type":"MultiPolygon","arcs":[[[-4486,4483,-4485,-4484,-4483,9500,-9181,9501]],[[-9187,9502]],[[-5295,9503]]],"id":"24039","properties":{"name":"Somerset"}},{"type":"Polygon","arcs":[[-4482,9504,9505,-9182,-9501]],"id":"24047","properties":{"name":"Worcester"}},{"type":"Polygon","arcs":[[9506,-492,-8994,-6486,-5465,-6878]],"id":"38013","properties":{"name":"Burke"}},{"type":"Polygon","arcs":[[9507,9508,9509,-5877]],"id":"18127","properties":{"name":"Porter"}},{"type":"Polygon","arcs":[[-8311,-6637,-1995,-2277,-308,-7425]],"id":"29083","properties":{"name":"Henry"}},{"type":"Polygon","arcs":[[-6296,9510,-8117,-8040,-7132,-6291,-9459]],"id":"36023","properties":{"name":"Cortland"}},{"type":"Polygon","arcs":[[-3051,-4076,-5532,-9064,9511]],"id":"16001","properties":{"name":"Ada"}},{"type":"Polygon","arcs":[[-2936,-4227,-1173,9512,-1815]],"id":"17175","properties":{"name":"Stark"}},{"type":"Polygon","arcs":[[-9130,9513,-2691,-2227,9514,9515]],"id":"38043","properties":{"name":"Kidder"}},{"type":"Polygon","arcs":[[-6203,-7052,-9222,-9148,-6372,9516]],"id":"51173","properties":{"name":"Smyth"}},{"type":"Polygon","arcs":[[9517,-2013,-8756,-6324,-6605,-9155]],"id":"13301","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[-7158,9518,-5958,-5759,-6685]],"id":"21201","properties":{"name":"Robertson"}},{"type":"MultiPolygon","arcs":[[[9519]],[[-1778,-2412,-519,9520]],[[9521]]],"id":"02180","properties":{"name":"Nome"}},{"type":"Polygon","arcs":[[-2337,-3606,-1077,-466,9522]],"id":"48415","properties":{"name":"Scurry"}},{"type":"Polygon","arcs":[[9523,-8534,-8725,-9104,-129,-934]],"id":"48249","properties":{"name":"Jim Wells"}},{"type":"Polygon","arcs":[[-9209,-2618,-7936,-3064]],"id":"31095","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[-8361,-6889,-5829,-5820,-9166]],"id":"47015","properties":{"name":"Cannon"}},{"type":"Polygon","arcs":[[-3468,-1293,-2226,-7593,9524,-6623]],"id":"18017","properties":{"name":"Cass"}},{"type":"Polygon","arcs":[[-9444,-8967,-6991,-8710,-7097]],"id":"72099","properties":{"name":"Moca"}},{"type":"Polygon","arcs":[[-9487,-6516,-9025,-7741,-7731,-7103,-8386]],"id":"54043","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[9525,-8150,-599,-2798,-9273,-5626,-7406,9526]],"id":"31111","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-8608,-3245,9527,9528,9529,-7363,-8982]],"id":"17157","properties":{"name":"Randolph"}},{"type":"Polygon","arcs":[[-9401,9530,-5594,-1511,-5688]],"id":"55131","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-5484,9531,9532,-6228]],"id":"11001","properties":{"name":"District of Columbia"}},{"type":"Polygon","arcs":[[9533,9534,-5104,-7080,-6132]],"id":"51119","properties":{"name":"Middlesex"}},{"type":"Polygon","arcs":[[-3283,9535,-4862,-2645,-2732]],"id":"31061","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-7310,-5509,-3981,-9068,9536,-8472,9537]],"id":"06001","properties":{"name":"Alameda"}},{"type":"Polygon","arcs":[[-6229,-9533,9538,9539]],"id":"51510","properties":{"name":"Alexandria"}},{"type":"Polygon","arcs":[[-6160,9540,9541,-2425,-1952]],"id":"05079","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-6795,9542,-2452,9543,-5493,-8264,-8914,-4673]],"id":"37141","properties":{"name":"Pender"}},{"type":"Polygon","arcs":[[-6187,-8441,-7684,-5305,-7312,-9140]],"id":"09003","properties":{"name":"Hartford"}},{"type":"Polygon","arcs":[[-4168,9544,-8405,-4858]],"id":"17097","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[-6808,-1659,-5521,-9197,-924,-6809,-235,-4618]],"id":"31141","properties":{"name":"Platte"}},{"type":"Polygon","arcs":[[-6617,-3099,9545,9546,-4105,-2650]],"id":"20081","properties":{"name":"Haskell"}},{"type":"Polygon","arcs":[[-3151,-2832,-2723,-5023,-7542,-3794]],"id":"48135","properties":{"name":"Ector"}},{"type":"Polygon","arcs":[[-310,-2276,-6106,9547,9548]],"id":"29085","properties":{"name":"Hickory"}},{"type":"Polygon","arcs":[[-7068,-7059,9549,-8571,-8674,-8455,-8374]],"id":"51025","properties":{"name":"Brunswick"}},{"type":"Polygon","arcs":[[-2807,-9276,-9492,-2529]],"id":"19067","properties":{"name":"Floyd"}},{"type":"Polygon","arcs":[[9550]],"id":"51600","properties":{"name":"Fairfax"}},{"type":"Polygon","arcs":[[-5537,-8829,-9092,9551,9552,-9286]],"id":"31123","properties":{"name":"Morrill"}},{"type":"Polygon","arcs":[[9553,-1514,-8076,-4170,-4857,-9252,-3164]],"id":"55127","properties":{"name":"Walworth"}},{"type":"Polygon","arcs":[[-9269,-3074,-9305,-4770]],"id":"13043","properties":{"name":"Candler"}},{"type":"Polygon","arcs":[[-1251,-3150,-1179,9554,-8391,-2145,9555]],"id":"17115","properties":{"name":"Macon"}},{"type":"Polygon","arcs":[[-901,-3266,-2714,-2750,-1565,-377,-2253,-9237]],"id":"20063","properties":{"name":"Gove"}},{"type":"Polygon","arcs":[[-7981,-8390,-8662,-9256,-6430]],"id":"28041","properties":{"name":"Greene"}},{"type":"Polygon","arcs":[[9556,-2824,-2801,9557,-9528,-3244]],"id":"17189","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[9558,-325,-746,-3337,-3653,-3693]],"id":"23019","properties":{"name":"Penobscot"}},{"type":"Polygon","arcs":[[-2586,-2541,-431,-4177,-6010,9559]],"id":"55001","properties":{"name":"Adams"}},{"type":"MultiPolygon","arcs":[[[9560]],[[9561]],[[-9257,-8660,9562,-8057,-452]]],"id":"28059","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[9563,-1733,9564,9565,-7289,-7965]],"id":"13071","properties":{"name":"Colquitt"}},{"type":"Polygon","arcs":[[-4936,-8243,-6385,-8189,-1018,-3930,9566,-9414,-2420]],"id":"42125","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-7385,9567,-9505,-4481,-5298,-1000]],"id":"10005","properties":{"name":"Sussex"}},{"type":"Polygon","arcs":[[-3119,9568,-5651,-7535,-3317,-2554,-6409]],"id":"20197","properties":{"name":"Wabaunsee"}},{"type":"Polygon","arcs":[[-5512,-5505,-7164,-5931,9569,-3481]],"id":"21157","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[-7763,9570,-5326,-5136,-5572,-6572,-6804]],"id":"21175","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[-1340,-6676,-6825,-9320,-320,9571,-5125]],"id":"21177","properties":{"name":"Muhlenberg"}},{"type":"Polygon","arcs":[[-9321,-4419,-8160,-5844,-7582]],"id":"21213","properties":{"name":"Simpson"}},{"type":"Polygon","arcs":[[-4193,-1975,-2973,-5052,-8899]],"id":"37035","properties":{"name":"Catawba"}},{"type":"Polygon","arcs":[[-7452,-7950,-7895,-7968,-7711,-6800]],"id":"40103","properties":{"name":"Noble"}},{"type":"Polygon","arcs":[[-4727,9572,-3627,-8749,9573,-6247]],"id":"53013","properties":{"name":"Columbia"}},{"type":"Polygon","arcs":[[-9455,-8004,-7978,9574,9575]],"id":"28061","properties":{"name":"Jasper"}},{"type":"Polygon","arcs":[[-7485,-5663,-4878,-4835,-1185,-3253]],"id":"17033","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[-4967,-609,-1455,-3154,-7192,-1450]],"id":"46005","properties":{"name":"Beadle"}},{"type":"Polygon","arcs":[[-9275,-3720,-6918,-8681,-1084,-6896]],"id":"39069","properties":{"name":"Henry"}},{"type":"Polygon","arcs":[[-9053,-2106,-8737,-6911,-9238,-1694]],"id":"39047","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[-3078,-1217,9576,-2846,-9234]],"id":"18041","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[-7943,-6705,-2367,-2383]],"id":"48379","properties":{"name":"Rains"}},{"type":"Polygon","arcs":[[-5319,-712,-7520,-2443,-9137,-7901]],"id":"29129","properties":{"name":"Mercer"}},{"type":"Polygon","arcs":[[9577,-400,-699,9578,9579]],"id":"38027","properties":{"name":"Eddy"}},{"type":"Polygon","arcs":[[-3155,-603,-8830,-1419,-2092]],"id":"46061","properties":{"name":"Hanson"}},{"type":"Polygon","arcs":[[-1888,9580,-8758,-8464,-2882]],"id":"39109","properties":{"name":"Miami"}},{"type":"Polygon","arcs":[[-1117,-264,-8404,9581,-2548,-2865]],"id":"48367","properties":{"name":"Parker"}},{"type":"Polygon","arcs":[[9582,-1119,-2864,-9274,-6144]],"id":"48503","properties":{"name":"Young"}},{"type":"Polygon","arcs":[[-6872,9583,-8926,-4208,-6712,-831]],"id":"48373","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[-6551,-9454,-8149,-5558,-9152]],"id":"22011","properties":{"name":"Beauregard"}},{"type":"Polygon","arcs":[[-8461,-4588,-8673,-357,-4374,9584,-5355]],"id":"49033","properties":{"name":"Rich"}},{"type":"Polygon","arcs":[[-2502,-3808,9585,-5435,9586,-8011,-637]],"id":"53077","properties":{"name":"Yakima"}},{"type":"MultiPolygon","arcs":[[[9587]],[[-3718,9588,9589,-3221,-6916]]],"id":"39123","properties":{"name":"Ottawa"}},{"type":"Polygon","arcs":[[-4533,-5940,-5178,9590,-7366,-5172]],"id":"17013","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[-7144,-7222,-4148,-9162,-6806,-5968]],"id":"35007","properties":{"name":"Colfax"}},{"type":"Polygon","arcs":[[-7020,-629,-7189,-6484,-4651,-5803]],"id":"31103","properties":{"name":"Keya Paha"}},{"type":"Polygon","arcs":[[-1499,-8703,-8839]],"id":"56017","properties":{"name":"Hot Springs"}},{"type":"Polygon","arcs":[[-8480,-5514,-6172,-5726,-9254]],"id":"21007","properties":{"name":"Ballard"}},{"type":"Polygon","arcs":[[9591,-7027,-1748,-5260,-8925,-9584,-6871,-7008]],"id":"48005","properties":{"name":"Angelina"}},{"type":"Polygon","arcs":[[-5182,-6066,-5267,-4890,-5088,9592]],"id":"45015","properties":{"name":"Berkeley"}},{"type":"Polygon","arcs":[[-931,9593,-9468,-1452,-607]],"id":"46057","properties":{"name":"Hamlin"}},{"type":"Polygon","arcs":[[-4688,-4283,-6117,9594,-8731,-5942]],"id":"45037","properties":{"name":"Edgefield"}},{"type":"Polygon","arcs":[[-1414,-7049,-9470,-8535,-9524,-933,-3564]],"id":"48297","properties":{"name":"Live Oak"}},{"type":"Polygon","arcs":[[-1388,9595,-865,-8849,-6256]],"id":"27121","properties":{"name":"Pope"}},{"type":"Polygon","arcs":[[9596,9597,-8341,-9411,9598]],"id":"39115","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[9599,-5440,-9493,-7690,-8262]],"id":"41027","properties":{"name":"Hood River"}},{"type":"Polygon","arcs":[[-311,-9549,9600,-7622,9601,-1978]],"id":"29167","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[9602,-2308,9603,-942,-1717]],"id":"48115","properties":{"name":"Dawson"}},{"type":"Polygon","arcs":[[-2422,-9416,-5405,-7609,-7562,-3290]],"id":"54061","properties":{"name":"Monongalia"}},{"type":"Polygon","arcs":[[-3240,-6146,-247,-3956,-2352]],"id":"48207","properties":{"name":"Haskell"}},{"type":"Polygon","arcs":[[-245,-2309,-9603,-1716,-508]],"id":"48445","properties":{"name":"Terry"}},{"type":"Polygon","arcs":[[-7546,-4757,-1114,-9583,-1096]],"id":"48009","properties":{"name":"Archer"}},{"type":"Polygon","arcs":[[-1363,-6557,-2808,-2527,-9308]],"id":"19195","properties":{"name":"Worth"}},{"type":"Polygon","arcs":[[-7970,-6762,-4700,-7162,-4823,-5742]],"id":"21001","properties":{"name":"Adair"}},{"type":"Polygon","arcs":[[-6523,-9381,-6340,-2342,9604,9605,9606]],"id":"08093","properties":{"name":"Park"}},{"type":"Polygon","arcs":[[-6119,9607,9608,-5183,-9593,-5087,-6885,-1407,9609]],"id":"45075","properties":{"name":"Orangeburg"}},{"type":"Polygon","arcs":[[9610,-6524,-9607,9611,-8612]],"id":"08065","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[-8789,-8941,-6049,9612,-5423]],"id":"21089","properties":{"name":"Greenup"}},{"type":"Polygon","arcs":[[-9460,-7795,9613,9614,-8916,-3998,-9293]],"id":"13137","properties":{"name":"Habersham"}},{"type":"Polygon","arcs":[[-3573,-9412,-3958,-3965,-9322,-8738]],"id":"39163","properties":{"name":"Vinton"}},{"type":"Polygon","arcs":[[-8822,-99,-1808,-9195,-798]],"id":"39175","properties":{"name":"Wyandot"}},{"type":"Polygon","arcs":[[-4646,-7829,-8952,-5122,-6846,-9224,9615]],"id":"30003","properties":{"name":"Big Horn"}},{"type":"Polygon","arcs":[[-4521,-4246,-2510,-8003,9616]],"id":"28037","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-6008,9617],[9618]],"id":"51683","properties":{"name":"Manassas"}},{"type":"Polygon","arcs":[[-4745,-9423,-4311,9619,-5644,-7610]],"id":"47107","properties":{"name":"McMinn"}},{"type":"Polygon","arcs":[[9620,-463,-8151,-9526,9621,-920]],"id":"31117","properties":{"name":"McPherson"}},{"type":"Polygon","arcs":[[-6798,-8126,-8130,-6746]],"id":"40133","properties":{"name":"Seminole"}},{"type":"Polygon","arcs":[[-5004,-2370,-7993,9622,-6167,9623,-9157,-4753]],"id":"48213","properties":{"name":"Henderson"}},{"type":"Polygon","arcs":[[-8782,-8811,-8816,-5282,-6194,9624,-7725]],"id":"50001","properties":{"name":"Addison"}},{"type":"Polygon","arcs":[[9625,-9552,-9091,-8633,9626,9627,-3912]],"id":"31033","properties":{"name":"Cheyenne"}},{"type":"Polygon","arcs":[[9628,-323,-7585,9629,-4993,-4629,-6938]],"id":"47125","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[9630,9631,-4316,-6891,-1128,-705,-3034]],"id":"48035","properties":{"name":"Bosque"}},{"type":"Polygon","arcs":[[9632,-5530,-1459,-8006,-4213,-9289]],"id":"47181","properties":{"name":"Wayne"}},{"type":"Polygon","arcs":[[-6953,-3935,-7199,9633,9634,-4280,-4687]],"id":"45071","properties":{"name":"Newberry"}},{"type":"Polygon","arcs":[[-5868,-940,-8634,-7495,-4145]],"id":"48205","properties":{"name":"Hartley"}},{"type":"Polygon","arcs":[[-442,-4182,-1490,-4337,-7093]],"id":"55107","properties":{"name":"Rusk"}},{"type":"Polygon","arcs":[[-3423,9635,-6285,-9031,-6415,-5666]],"id":"28117","properties":{"name":"Prentiss"}},{"type":"Polygon","arcs":[[-2959,9636,-1855,-3634,-4778]],"id":"19035","properties":{"name":"Cherokee"}},{"type":"Polygon","arcs":[[-3098,-1047,-7168,9637,9638,-9546]],"id":"20119","properties":{"name":"Meade"}},{"type":"Polygon","arcs":[[-3404,-540,-9156,-511,-1686,-1382]],"id":"48087","properties":{"name":"Collingsworth"}},{"type":"Polygon","arcs":[[-7079,-8572,-9550,-7058,-5471]],"id":"51135","properties":{"name":"Nottoway"}},{"type":"Polygon","arcs":[[-2634,9639,-9599,-9410,-3571,-8842]],"id":"39127","properties":{"name":"Perry"}},{"type":"Polygon","arcs":[[-3708,-7716,-7850,-8115,-9511,-6295]],"id":"36053","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[-3007,-5925,-5814,-8394,-8554]],"id":"18171","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[-8626,-859,-3235,-3525,-349]],"id":"27085","properties":{"name":"McLeod"}},{"type":"Polygon","arcs":[[-2550,9640,-9631,-3033]],"id":"48425","properties":{"name":"Somervell"}},{"type":"Polygon","arcs":[[-1887,-6663,-6667,-9051,-8759,-9581]],"id":"39021","properties":{"name":"Champaign"}},{"type":"MultiPolygon","arcs":[[[9641,-8510]],[[9642,9643,9644,-8508,9645,-8516]]],"id":"12086","properties":{"name":"Miami-Dade"}},{"type":"Polygon","arcs":[[-9500,-9267,-4768,-8526]],"id":"13165","properties":{"name":"Jenkins"}},{"type":"Polygon","arcs":[[-5914,9646,-408,-1804,9647,-6929]],"id":"40043","properties":{"name":"Dewey"}},{"type":"Polygon","arcs":[[-2395,9648,9649,-7038,-9175,-4733]],"id":"40085","properties":{"name":"Love"}},{"type":"Polygon","arcs":[[-4582,-5250,-8944,-6470,-3430]],"id":"13005","properties":{"name":"Bacon"}},{"type":"Polygon","arcs":[[-326,-9559,-3692]],"id":"23021","properties":{"name":"Piscataquis"}},{"type":"Polygon","arcs":[[9650,9651,-1935,-9061]],"id":"39085","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[-6056,-8324,-9011,9652,-2787]],"id":"48089","properties":{"name":"Colorado"}},{"type":"Polygon","arcs":[[-5768,-5548,-6828,-6026]],"id":"21131","properties":{"name":"Leslie"}},{"type":"Polygon","arcs":[[-3989,-8577,-8178,-8218,-9315,9653]],"id":"06113","properties":{"name":"Yolo"}},{"type":"Polygon","arcs":[[-9202,9654,-7912,9655,-5362]],"id":"12007","properties":{"name":"Bradford"}},{"type":"Polygon","arcs":[[-9085,-5053,-2971,-2829,9656,-5707,-4895]],"id":"37119","properties":{"name":"Mecklenburg"}},{"type":"Polygon","arcs":[[-8879,-9176,-186,9657,-1175,-3149,-1249,-1875]],"id":"17113","properties":{"name":"McLean"}},{"type":"Polygon","arcs":[[-4354,-8263,-7688,-6754,9658]],"id":"41067","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-7414,-4410,-9430,-6533,-3448,-5662]],"id":"18021","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[-9158,-9624,-6171,-7045,-961]],"id":"48161","properties":{"name":"Freestone"}},{"type":"Polygon","arcs":[[-7359,9659,-5654,9660,-9111,9661]],"id":"24003","properties":{"name":"Anne Arundel"}},{"type":"Polygon","arcs":[[-8861,-2926,-8025,-5067,-5101,-9093]],"id":"42083","properties":{"name":"McKean"}},{"type":"Polygon","arcs":[[-1706,-7561,-9035,-2775,9662,-3457]],"id":"29103","properties":{"name":"Knox"}},{"type":"Polygon","arcs":[[-2737,-7217,-3175,-5642]],"id":"19147","properties":{"name":"Palo Alto"}},{"type":"Polygon","arcs":[[-3458,-9663,-2779,-8499,-5091,9663]],"id":"29121","properties":{"name":"Macon"}},{"type":"Polygon","arcs":[[-2601,9664,-8301,-7247,9665,-3280]],"id":"28103","properties":{"name":"Noxubee"}},{"type":"Polygon","arcs":[[-6427,-6780,-2631,-7805,9666,-4244]],"id":"28077","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[-1879,-4397,-1032,-9150,-8550,-9384,-8332,-8339]],"id":"08073","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-6402,-5420,9667,-3059,-737]],"id":"20077","properties":{"name":"Harper"}},{"type":"Polygon","arcs":[[-226,-6541,-1869,-777,-3322]],"id":"19171","properties":{"name":"Tama"}},{"type":"Polygon","arcs":[[-9482,-9075,-8298,-8299,-9665,-2600]],"id":"28087","properties":{"name":"Lowndes"}},{"type":"Polygon","arcs":[[-1608,-1979,-9602,-7625,9668,-4101]],"id":"29057","properties":{"name":"Dade"}},{"type":"Polygon","arcs":[[-2307,-2338,-9523,-465,-6770,-9604]],"id":"48033","properties":{"name":"Borden"}},{"type":"Polygon","arcs":[[-5643,-3178,-3588,-9637]],"id":"19021","properties":{"name":"Buena Vista"}},{"type":"Polygon","arcs":[[-6180,-1405,-5531,-9633,-9288,-5189]],"id":"47039","properties":{"name":"Decatur"}},{"type":"Polygon","arcs":[[-7388,-3052,-9512,-9063,-9110]],"id":"16027","properties":{"name":"Canyon"}},{"type":"Polygon","arcs":[[-4245,-9667,-7804,-8358,-2160]],"id":"28147","properties":{"name":"Walthall"}},{"type":"Polygon","arcs":[[-9039,-9499,-8249,-3666,-4918]],"id":"33005","properties":{"name":"Cheshire"}},{"type":"Polygon","arcs":[[-9138,-2441,-3459,-9664,-5090,-1592]],"id":"29115","properties":{"name":"Linn"}},{"type":"Polygon","arcs":[[-6930,-9648,-1807,-534,-3403,-2620]],"id":"40129","properties":{"name":"Roger Mills"}},{"type":"Polygon","arcs":[[9669,-6012,-7835,9670,-2835,-4613]],"id":"55111","properties":{"name":"Sauk"}},{"type":"Polygon","arcs":[[-9072,-7754,-9219,-7989,-7343,-4097,-9406,-3878]],"id":"22009","properties":{"name":"Avoyelles"}},{"type":"Polygon","arcs":[[-4102,-9669,-7624,-1539,-1688,9671,-1650]],"id":"29109","properties":{"name":"Lawrence"}},{"type":"Polygon","arcs":[[-1080,-8273,-4022,9672,-5381]],"id":"37127","properties":{"name":"Nash"}},{"type":"Polygon","arcs":[[-499,-6060,-2100,9673,-6198,-9495]],"id":"41069","properties":{"name":"Wheeler"}},{"type":"Polygon","arcs":[[-5424,-9613,-6048,-5322,9674,-7761]],"id":"21043","properties":{"name":"Carter"}},{"type":"Polygon","arcs":[[-6025,9675,-6589,-8890,-5056,-4980]],"id":"37115","properties":{"name":"Madison"}},{"type":"MultiPolygon","arcs":[[[-9619]],[[-3761,9676,9677,9678,-8984,-8111],[-6007,-6009,-9618]]],"id":"51153","properties":{"name":"Prince William"}},{"type":"Polygon","arcs":[[-8398,-8195,9679,-9078]],"id":"34007","properties":{"name":"Camden"}},{"type":"Polygon","arcs":[[-9579,-698,-2689,9680]],"id":"38031","properties":{"name":"Foster"}},{"type":"Polygon","arcs":[[-7086,-7065,-6204,-9517,-6376,-1631,-6773]],"id":"51167","properties":{"name":"Russell"}},{"type":"MultiPolygon","arcs":[[[9681]],[[-8943,-5130,-7915,9682,-1667]]],"id":"26041","properties":{"name":"Delta"}},{"type":"Polygon","arcs":[[-6717,-4416,-7318,-4469,-7822,-4464,-6346,-73]],"id":"18175","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-4661,-7499,-4248,-5916,-2945]],"id":"35019","properties":{"name":"Guadalupe"}},{"type":"Polygon","arcs":[[-6398,-2849,-9174,-9296,-4505]],"id":"18029","properties":{"name":"Dearborn"}},{"type":"Polygon","arcs":[[-9172,-7329,-9220,9683,-9294]],"id":"21117","properties":{"name":"Kenton"}},{"type":"MultiPolygon","arcs":[[[-9307,-3656,-7348,9684,-5011]]],"id":"23015","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-8708,-7478,-3425,-5665,-7402]],"id":"28009","properties":{"name":"Benton"}},{"type":"Polygon","arcs":[[-103,-745,-3181,-3819,-8783,-6112]],"id":"19119","properties":{"name":"Lyon"}},{"type":"Polygon","arcs":[[-7072,9685,-5840,9686,-5368,9687]],"id":"21049","properties":{"name":"Clark"}},{"type":"Polygon","arcs":[[9688,9689,-6034,9690,-2827]],"id":"37167","properties":{"name":"Stanly"}},{"type":"Polygon","arcs":[[-9167,-5818,-9476,9691,9692]],"id":"47003","properties":{"name":"Bedford"}},{"type":"Polygon","arcs":[[-5452,-5948,-3391,-5469,-3798,9693]],"id":"51029","properties":{"name":"Buckingham"}},{"type":"Polygon","arcs":[[-9388,-9383,-8222,-3833,-7709]],"id":"05089","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[-8537,-6267,-3883,-6275,-4620,-9484]],"id":"29003","properties":{"name":"Andrew"}},{"type":"Polygon","arcs":[[-2976,-8350,-3622,-9030,-8293,-4591,-8300]],"id":"01125","properties":{"name":"Tuscaloosa"}},{"type":"Polygon","arcs":[[9694,-6851,-9462,-4730,-2474,-1758]],"id":"72135","properties":{"name":"Toa Alta"}},{"type":"Polygon","arcs":[[-5187,-6023,-4978,-6680,-5064]],"id":"47063","properties":{"name":"Hamblen"}},{"type":"Polygon","arcs":[[-3807,-4729,-6249,9695,-6058,-5436,-9586]],"id":"53005","properties":{"name":"Benton"}},{"type":"Polygon","arcs":[[-8956,-4475,9696,-4813,-8646]],"id":"13191","properties":{"name":"McIntosh"}},{"type":"Polygon","arcs":[[-4871,-5031,-8338,-3229,-7974]],"id":"48109","properties":{"name":"Culberson"}},{"type":"Polygon","arcs":[[-2011,-8732,-9595,-6122,-8523,-8757]],"id":"13245","properties":{"name":"Richmond"}},{"type":"Polygon","arcs":[[-9570,-5930,-6939,-6181,-3482]],"id":"21035","properties":{"name":"Calloway"}},{"type":"Polygon","arcs":[[9697,-5620,-8980,-9080,-9497,-9037]],"id":"33013","properties":{"name":"Merrimack"}},{"type":"MultiPolygon","arcs":[[[-4152,9698]],[[9699,-6904]],[[-9118,9116,-9116,9700,-6902]]],"id":"48167","properties":{"name":"Galveston"}},{"type":"Polygon","arcs":[[-9287,-9553,-9626,-3911,9701,-5783]],"id":"31007","properties":{"name":"Banner"}},{"type":"Polygon","arcs":[[-2537,-3355,-6161,-1950,-8896,-8078]],"id":"05053","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[9702,-5238,9703,-4503,9704,-5234]],"id":"34033","properties":{"name":"Salem"}},{"type":"Polygon","arcs":[[-6967,-9659,-6757,-8209,-8494,9705]],"id":"41057","properties":{"name":"Tillamook"}},{"type":"Polygon","arcs":[[-7726,-9625,-6196,-8718,-9084,-9404,9706]],"id":"36115","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[9707,-7482,-2885,-2258]],"id":"27077","properties":{"name":"Lake of the Woods"}},{"type":"Polygon","arcs":[[-8237,-7148,-1867,-1027,-4396,-8275,-6337]],"id":"08001","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[9708,-3990,-9654,-9314,-7928,-7702]],"id":"06033","properties":{"name":"Lake"}},{"type":"Polygon","arcs":[[-8906,-8955,-2014,-9518,-9154,9709]],"id":"13317","properties":{"name":"Wilkes"}},{"type":"Polygon","arcs":[[-5093,-8501,-6784,-1541,9710]],"id":"29089","properties":{"name":"Howard"}},{"type":"Polygon","arcs":[[-6759,9711,-5194,-3541,-240,-6970]],"id":"42011","properties":{"name":"Berks"}},{"type":"Polygon","arcs":[[9712,-5978,-6085,-8267,-3503]],"id":"47087","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[9713,-6014,-147,-7748,-159,-9311]],"id":"72091","properties":{"name":"ManatÃ­"}},{"type":"Polygon","arcs":[[-3057,-8147,-3415,-8965,-6843,-7062]],"id":"54007","properties":{"name":"Braxton"}},{"type":"Polygon","arcs":[[-7157,9714,-8589,-5427,-5955,-9519]],"id":"21161","properties":{"name":"Mason"}},{"type":"Polygon","arcs":[[9715,-9298,-7398,-9098,9716]],"id":"26021","properties":{"name":"Berrien"}},{"type":"Polygon","arcs":[[-9658,-185,-8555,-5137,-1176]],"id":"17019","properties":{"name":"Champaign"}},{"type":"Polygon","arcs":[[-4600,-7508,-9441,-5448,9717,-8769,-7729],[-7190],[-824]],"id":"51015","properties":{"name":"Augusta"}},{"type":"Polygon","arcs":[[-3359,-6448,-3841,-7307,9718,-9541,-6159]],"id":"05001","properties":{"name":"Arkansas"}},{"type":"Polygon","arcs":[[-8628,-9013,-2179,-8923,-9015,-8107]],"id":"13079","properties":{"name":"Crawford"}},{"type":"Polygon","arcs":[[-3452,-6616,-6534,-6394,-4880]],"id":"18027","properties":{"name":"Daviess"}},{"type":"MultiPolygon","arcs":[[[9719]],[[9720,-7170]],[[-4718,9721]],[[-7174,9722]]],"id":"37055","properties":{"name":"Dare"}},{"type":"Polygon","arcs":[[-4017,-3737,-9488,-7531]],"id":"30021","properties":{"name":"Dawson"}},{"type":"Polygon","arcs":[[-8202,-707,-1131,-1724,-6070,-7011]],"id":"48281","properties":{"name":"Lampasas"}},{"type":"Polygon","arcs":[[-7615,-6214,-1765,9723,-7881]],"id":"12123","properties":{"name":"Taylor"}},{"type":"Polygon","arcs":[[9724,-7152,-4402]],"id":"13047","properties":{"name":"Catoosa"}},{"type":"Polygon","arcs":[[-772,-6254,-6308,-516,-9210]],"id":"13067","properties":{"name":"Cobb"}},{"type":"MultiPolygon","arcs":[[[-4832,-7844,-4341]],[[-4095,-9456,-4829,-6721,-9407]]],"id":"22099","properties":{"name":"St. Martin"}},{"type":"Polygon","arcs":[[-7492,-3440,9725,-7807,-2430,-8583,-7512]],"id":"28135","properties":{"name":"Tallahatchie"}},{"type":"Polygon","arcs":[[-9548,-6105,-1590,-912,-7623,-9601]],"id":"29059","properties":{"name":"Dallas"}},{"type":"Polygon","arcs":[[-4021,-4253,-5289,-4666,-5382,-9673]],"id":"37195","properties":{"name":"Wilson"}},{"type":"Polygon","arcs":[[-1645,-6217,-401,-9578,9726,-9040]],"id":"38005","properties":{"name":"Benson"}},{"type":"Polygon","arcs":[[-9635,9727,9728,-9608,-6118,-4281]],"id":"45063","properties":{"name":"Lexington"}},{"type":"Polygon","arcs":[[-1737,-2834,-2921,-8687,-1911,-4371,-9300]],"id":"48137","properties":{"name":"Edwards"}},{"type":"Polygon","arcs":[[-4405,-4001,-4639,-4449]],"id":"13055","properties":{"name":"Chattooga"}},{"type":"Polygon","arcs":[[9729,-3544,-7300,9730,9731]],"id":"24025","properties":{"name":"Harford"}},{"type":"Polygon","arcs":[[-5853,-5934,-6868,-5199,-4273,-5191,-5083]],"id":"45069","properties":{"name":"Marlboro"}},{"type":"Polygon","arcs":[[-3067,-7784,-5652,-9569,-3118,-3255]],"id":"20161","properties":{"name":"Riley"}},{"type":"Polygon","arcs":[[-5842,-7404,-1624,-1332,-9297,9732]],"id":"26005","properties":{"name":"Allegan"}},{"type":"Polygon","arcs":[[-6782,-5340,-5460,-5108,-7756]],"id":"29051","properties":{"name":"Cole"}},{"type":"Polygon","arcs":[[-7893,-7949,9733,9734,-3920,-4268,-2781]],"id":"40143","properties":{"name":"Tulsa"}},{"type":"Polygon","arcs":[[-3771,-8451,-6192,-5371,-1928,9735]],"id":"48187","properties":{"name":"Guadalupe"}},{"type":"Polygon","arcs":[[-8728,-9281,9736,-8817,-8809,-2576]],"id":"50005","properties":{"name":"Caledonia"}},{"type":"Polygon","arcs":[[-5689,-1515,-9554,-3163,-7836]],"id":"55055","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[-8144,9737,-5229,9738,9739]],"id":"42001","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[-6405,-7827,-3433,-3443,-8212,-8709]],"id":"20105","properties":{"name":"Lincoln"}},{"type":"MultiPolygon","arcs":[[[-9171,9740]],[[9741]]],"id":"53029","properties":{"name":"Island"}},{"type":"Polygon","arcs":[[9742,-4991,-6078,-9496,-6568,-669,-5377,-7188]],"id":"31107","properties":{"name":"Knox"}},{"type":"Polygon","arcs":[[-8857,-8135,9743,-4624,-9284,-8426,-9200]],"id":"32019","properties":{"name":"Lyon"}},{"type":"Polygon","arcs":[[-7762,-9675,-5321,-9571]],"id":"21063","properties":{"name":"Elliott"}},{"type":"Polygon","arcs":[[-4705,-5370,-4681,-6827,-6581,9744]],"id":"21079","properties":{"name":"Garrard"}},{"type":"Polygon","arcs":[[-5767,-5143,-5835,-6771,-5550]],"id":"21133","properties":{"name":"Letcher"}},{"type":"Polygon","arcs":[[-3126,-4785,9745,-7320,-7431]],"id":"21223","properties":{"name":"Trimble"}},{"type":"Polygon","arcs":[[-4310,-6177,-8245,-8246,-5645,-9620]],"id":"47123","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[-2400,-8051,-8113,-2408,-7018]],"id":"51113","properties":{"name":"Madison"}},{"type":"Polygon","arcs":[[-7223,-3493,-1371,-2821,-9557,-3243]],"id":"17027","properties":{"name":"Clinton"}},{"type":"Polygon","arcs":[[-4810,9746,-9644,9747,-8953]],"id":"12011","properties":{"name":"Broward"}},{"type":"Polygon","arcs":[[-9547,-9639,9748,-6999,-4106]],"id":"20175","properties":{"name":"Seward"}},{"type":"Polygon","arcs":[[-7992,-8785,-7028,-9592,-7007,-6168,-9623]],"id":"48073","properties":{"name":"Cherokee"}},{"type":"Polygon","arcs":[[-9719,-7306,-3675,-7586,-2426,-9542]],"id":"05041","properties":{"name":"Desha"}},{"type":"Polygon","arcs":[[-9431,-4081,-4583,-8463,-8575,-7283]],"id":"16029","properties":{"name":"Caribou"}},{"type":"Polygon","arcs":[[-4668,-3903,-4306,-2453,-9543,-6794]],"id":"37061","properties":{"name":"Duplin"}},{"type":"Polygon","arcs":[[-8213,-3446,-9004,-6545,-6719,-6539]],"id":"20009","properties":{"name":"Barton"}},{"type":"Polygon","arcs":[[-1806,9749,-7887,-536]],"id":"40149","properties":{"name":"Washita"}},{"type":"Polygon","arcs":[[-7265,-6456,-6525,-9611,-8611,-1794]],"id":"08037","properties":{"name":"Eagle"}},{"type":"Polygon","arcs":[[-2108,-8877,-5897,-5894,-7694,-8204]],"id":"39099","properties":{"name":"Mahoning"}},{"type":"Polygon","arcs":[[-5253,9750,-8529,-8156,-8084,-4939]],"id":"01087","properties":{"name":"Macon"}},{"type":"Polygon","arcs":[[-8547,-1903,-6742,-2881,-488]],"id":"39107","properties":{"name":"Mercer"}},{"type":"Polygon","arcs":[[-3760,-5485,-6231,-3135,-6230,-9540,9751,-9471,9752,-9678,-9677],[-9551]],"id":"51059","properties":{"name":"Fairfax"}},{"type":"Polygon","arcs":[[-9207,9753,-4332,-1462,-4181]],"id":"55085","properties":{"name":"Oneida"}},{"type":"Polygon","arcs":[[-8751,-2983,-2095,9754]],"id":"41061","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[-6120,-9610,-1410,-6020,-8524]],"id":"45011","properties":{"name":"Barnwell"}},{"type":"Polygon","arcs":[[9755,-362,-8450,-5672]],"id":"49051","properties":{"name":"Wasatch"}},{"type":"MultiPolygon","arcs":[[[9756]],[[9757]],[[-6279,-8308,9758]],[[9759]]],"id":"26089","properties":{"name":"Leelanau"}},{"type":"Polygon","arcs":[[-7559,-9402,-9190,-3220,-5478,-8920,-9034]],"id":"17067","properties":{"name":"Hancock"}},{"type":"Polygon","arcs":[[9760,-5954,-1552,9761,-1520]],"id":"51193","properties":{"name":"Westmoreland"}},{"type":"Polygon","arcs":[[-3630,-7629,-4030,-8530,-9751,-5252,-8313]],"id":"01123","properties":{"name":"Tallapoosa"}},{"type":"Polygon","arcs":[[-1732,-8672,-8908,9762,-9565]],"id":"13075","properties":{"name":"Cook"}},{"type":"MultiPolygon","arcs":[[[-5407,9763]],[[9764]]],"id":"26083","properties":{"name":"Keweenaw"}},{"type":"Polygon","arcs":[[-3281,-9666,-7246,-336,-1051]],"id":"28069","properties":{"name":"Kemper"}},{"type":"Polygon","arcs":[[-1086,-8680,-1899,-2199]],"id":"39125","properties":{"name":"Paulding"}},{"type":"Polygon","arcs":[[-6024,-1487,-7580,-4714,-6586,-9676]],"id":"47171","properties":{"name":"Unicoi"}},{"type":"Polygon","arcs":[[-9159,-4579,-8692,9765]],"id":"13209","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[-9566,-9763,-8910,-7612,-7880,-7290]],"id":"13027","properties":{"name":"Brooks"}},{"type":"Polygon","arcs":[[-3913,-9628,9766,-2952,-2953,-1029,-1866,-7147]],"id":"08075","properties":{"name":"Logan"}},{"type":"Polygon","arcs":[[-1809,-97,-6777,-947,-1931]],"id":"39117","properties":{"name":"Morrow"}},{"type":"Polygon","arcs":[[-9019,-1926,9767,-9597,-9640,-2633]],"id":"39119","properties":{"name":"Muskingum"}},{"type":"Polygon","arcs":[[-8823,-4906,9768,-7213]],"id":"13051","properties":{"name":"Chatham"}},{"type":"Polygon","arcs":[[-9018,-9022,-1849,-7294,9769,-8655]],"id":"13061","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[-9627,-8632,-7407,-2949,-9767]],"id":"08115","properties":{"name":"Sedgwick"}},{"type":"Polygon","arcs":[[-3851,-7326,-8622,-9050,-1896,9770,-3038]],"id":"12105","properties":{"name":"Polk"}},{"type":"Polygon","arcs":[[9771,-9479,-9232,-8060,-2380,-5016]],"id":"48147","properties":{"name":"Fannin"}},{"type":"Polygon","arcs":[[-6173,-3485,-7620,-6114,-6040,-5728]],"id":"21105","properties":{"name":"Hickman"}},{"type":"Polygon","arcs":[[-8990,-8997,-7959,-4447,-8037,-9283]],"id":"01071","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-8912,-3575,-8153,-8528,9772]],"id":"13215","properties":{"name":"Muscogee"}},{"type":"Polygon","arcs":[[9773,-9259,-4012,-8260,-4225,-2934,-8678]],"id":"17195","properties":{"name":"Whiteside"}},{"type":"Polygon","arcs":[[9774,-9054,-8620,-2504,-8070]],"id":"12009","properties":{"name":"Brevard"}},{"type":"Polygon","arcs":[[-3386,-9263,-1734,-9564,-7964,-7962,-9303]],"id":"13321","properties":{"name":"Worth"}},{"type":"Polygon","arcs":[[-8945,-8647,-4816,-9324,-5208,-6472]],"id":"13025","properties":{"name":"Brantley"}},{"type":"Polygon","arcs":[[-1805,-406,-9389,-2359,-528,-7888,-9750]],"id":"40015","properties":{"name":"Caddo"}},{"type":"Polygon","arcs":[[9775,-9692,-9477,-8992,-9282,-7812,-1091]],"id":"47103","properties":{"name":"Lincoln"}},{"type":"Polygon","arcs":[[-6908,-4937,-3295,-7524,-8343,9776]],"id":"39111","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[9777,-4611,-8102,-8800]],"id":"55081","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[-6363,-3909,-4902,-3932,-7825]],"id":"45021","properties":{"name":"Cherokee"}},{"type":"Polygon","arcs":[[-5497,-5206,-208,-8831,-4333,-9754,-9206]],"id":"55041","properties":{"name":"Forest"}},{"type":"Polygon","arcs":[[-806,-7073,-9688,-5367,-4703,9778]],"id":"21067","properties":{"name":"Fayette"}},{"type":"Polygon","arcs":[[-394,-4122,-6509,-6654,-9485,-7443]],"id":"36037","properties":{"name":"Genesee"}},{"type":"Polygon","arcs":[[9779,9780,9781,-6579,-9165]],"id":"21229","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-8272,9782,-6835,9783,-4254,-4019]],"id":"37117","properties":{"name":"Martin"}},{"type":"Polygon","arcs":[[-3366,-7824,-7001,-4023,-5867,-4143]],"id":"40025","properties":{"name":"Cimarron"}},{"type":"Polygon","arcs":[[-5202,-6301,-5264,-6065,-4275]],"id":"45067","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[-877,-8460,-1833,-9145,-2871,-315,9784,-6595]],"id":"01039","properties":{"name":"Covington"}},{"type":"MultiPolygon","arcs":[[[9785]],[[9786]],[[-7257,-2008,-7205,9787,-7202]]],"id":"06037","properties":{"name":"Los Angeles"}},{"type":"Polygon","arcs":[[-8909,-7128,-7657,-7336,-7614]],"id":"12047","properties":{"name":"Hamilton"}},{"type":"Polygon","arcs":[[-7260,-8954,-9748,-9643,-8515,9788]],"id":"12021","properties":{"name":"Collier"}},{"type":"Polygon","arcs":[[-2895,-6215,-1326,-9095,-4998,9789,-6260]],"id":"20125","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[-3228,-6216,-5546,-7233,-4057,-5938,-862]],"id":"17193","properties":{"name":"White"}},{"type":"Polygon","arcs":[[-503,-1651,-9672,-1691,-7250,-4220]],"id":"29009","properties":{"name":"Barry"}},{"type":"Polygon","arcs":[[-85,-9250,-7349,-1616,-6555,-9251]],"id":"26125","properties":{"name":"Oakland"}},{"type":"Polygon","arcs":[[-5586,-4615,-7649,-8033,-5391]],"id":"19005","properties":{"name":"Allamakee"}},{"type":"Polygon","arcs":[[-6261,-9790,-5002,9790,-9734,-7948]],"id":"40147","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[9791,-4576,-6483,-6785,-6303]],"id":"30005","properties":{"name":"Blaine"}},{"type":"Polygon","arcs":[[-5953,9792,-1554]],"id":"51103","properties":{"name":"Lancaster"}},{"type":"Polygon","arcs":[[-7395,-6473,-5211,-7608,-9378,-7913,-9655,-9201,-7658]],"id":"12003","properties":{"name":"Baker"}},{"type":"Polygon","arcs":[[-1264,-8095,-6636,-7752,-4847,-9309]],"id":"22127","properties":{"name":"Winn"}},{"type":"Polygon","arcs":[[-7767,-9168,-9693,-9776,-1090,-5556]],"id":"47117","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[-1521,-9762,-1556,9793,-9534,-6131,-5713]],"id":"51057","properties":{"name":"Essex"}},{"type":"Polygon","arcs":[[-490,-2880,-1213,-3077,-8999]],"id":"18135","properties":{"name":"Randolph"}},{"type":"Polygon","arcs":[[9794,-749,-9199,-8779]],"id":"30101","properties":{"name":"Toole"}},{"type":"Polygon","arcs":[[-3695,-9306,-5656,-5984,9795]],"id":"23007","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-1329,-1135,-5416,-2702,9796,-1622]],"id":"26045","properties":{"name":"Eaton"}},{"type":"Polygon","arcs":[[-8573,-1252,-9556,-2148,-7114,-3024,-5313,-5274]],"id":"17167","properties":{"name":"Sangamon"}},{"type":"Polygon","arcs":[[9797,-4087,9798,-9227]],"id":"25001","properties":{"name":"Barnstable"}},{"type":"Polygon","arcs":[[9799,-6879,-5468,-4541,-9443]],"id":"30091","properties":{"name":"Sheridan"}},{"type":"Polygon","arcs":[[-7498,-8579,-6940,-1021,-8228,-8894,-4250]],"id":"35041","properties":{"name":"Roosevelt"}},{"type":"Polygon","arcs":[[-9668,-5419,-7453,-6799,-3060]],"id":"40053","properties":{"name":"Grant"}},{"type":"Polygon","arcs":[[-8143,9800,-3545,-9730,9801,-5230,-9738]],"id":"42133","properties":{"name":"York"}},{"type":"Polygon","arcs":[[-1773,-6383,-6603,-7186,-882,-9062]],"id":"13237","properties":{"name":"Putnam"}},{"type":"Polygon","arcs":[[-9614,-7794,-8872,9802]],"id":"13257","properties":{"name":"Stephens"}},{"type":"Polygon","arcs":[[-9615,-9803,-8873,-1916,-9229,-8917]],"id":"13011","properties":{"name":"Banks"}},{"type":"Polygon","arcs":[[-5878,-9510,-1580,-3470,-6625,-3004,-9230]],"id":"18073","properties":{"name":"Jasper"}},{"type":"Polygon","arcs":[[-3436,-663,-5146,-9236,-9002,-3444]],"id":"20113","properties":{"name":"McPherson"}},{"type":"Polygon","arcs":[[-9233,-8951,-6413,-1380,9803,-3533]],"id":"27097","properties":{"name":"Morrison"}},{"type":"Polygon","arcs":[[-5224,-7169,-1081,-5380,-7131,-5562]],"id":"37183","properties":{"name":"Wake"}},{"type":"Polygon","arcs":[[-3679,-7514,-6567,-7177,-7820,-7587]],"id":"28151","properties":{"name":"Washington"}},{"type":"Polygon","arcs":[[-9270,-9260,-9774,-8677,-7234,-294,-2680]],"id":"19045","properties":{"name":"Clinton"}},{"type":"Polygon","arcs":[[-7727,-9707,-9403,-7858]],"id":"36113","properties":{"name":"Warren"}},{"type":"Polygon","arcs":[[-9413,-879,-6597,9804,-2698,-8289]],"id":"01099","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[-5564,-7130,-6862]],"id":"37105","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[-9802,-9732,9805,-5655,-9660,-7358,-5231]],"id":"24005","properties":{"name":"Baltimore"}},{"type":"Polygon","arcs":[[-8996,-683,-812,9806,-4747,-7611,-9725,-4401,-7958]],"id":"47065","properties":{"name":"Hamilton"}},{"type":"Polygon","arcs":[[-170,9807,-9739,-5233,-7357,-5481,-3758]],"id":"24021","properties":{"name":"Frederick"}},{"type":"Polygon","arcs":[[-5757,-1559,-5396,-5411,-4436]],"id":"47097","properties":{"name":"Lauderdale"}},{"type":"Polygon","arcs":[[-8116,-7852,-50,-2879,-9132,-8139,-7847,-8042]],"id":"36025","properties":{"name":"Delaware"}},{"type":"Polygon","arcs":[[-4163,-6378,-9247,-3632,-8312,-8206]],"id":"01121","properties":{"name":"Talladega"}},{"type":"Polygon","arcs":[[-1623,-9797,-2707,-3137,-1196,-1334]],"id":"26025","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[-8613,-9612,-9606,9808,-6459,-7119]],"id":"08015","properties":{"name":"Chaffee"}},{"type":"Polygon","arcs":[[-1178,-5139,9809,-8392,-9555]],"id":"17139","properties":{"name":"Moultrie"}},{"type":"Polygon","arcs":[[-9126,-6423,-7806,-9726,-3439,-7517]],"id":"28107","properties":{"name":"Panola"}},{"type":"Polygon","arcs":[[-8383,-8688,-6073,-1998]],"id":"30039","properties":{"name":"Granite"}},{"type":"Polygon","arcs":[[-9712,-6758,-4989,-9077,-6434,-5195]],"id":"42091","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[-8319,-6927,-5872,9810,-5696,-5152,-6063]],"id":"42061","properties":{"name":"Huntingdon"}},{"type":"Polygon","arcs":[[-8322,-9450,-9119,-6900,-9009]],"id":"48157","properties":{"name":"Fort Bend"}},{"type":"Polygon","arcs":[[-6199,-9674,-2099,-4357,-6810]],"id":"41013","properties":{"name":"Crook"}},{"type":"Polygon","arcs":[[-8271,-8458,-6711,9811,-6836,-9783]],"id":"37015","properties":{"name":"Bertie"}},{"type":"Polygon","arcs":[[-8799,-2587,-9560,-9670,-4612,-9778]],"id":"55057","properties":{"name":"Juneau"}},{"type":"Polygon","arcs":[[-2394,-7900,-9478,9812,-9649]],"id":"40095","properties":{"name":"Marshall"}},{"type":"Polygon","arcs":[[-1721,-693,-8177,-8052,-8127,-4362]],"id":"48331","properties":{"name":"Milam"}},{"type":"Polygon","arcs":[[-6281,-4234,-2892,-1349,-584]],"id":"26165","properties":{"name":"Wexford"}},{"type":"Polygon","arcs":[[-9134,-5992,-9689,-2826,-2970]],"id":"37159","properties":{"name":"Rowan"}},{"type":"Polygon","arcs":[[-807,-9779,-4702,9813,9814,-2772]],"id":"21239","properties":{"name":"Woodford"}},{"type":"Polygon","arcs":[[-7166,-7275,-5911,-5912,-6928,9815]],"id":"40059","properties":{"name":"Harper"}},{"type":"Polygon","arcs":[[-836,-6963,-6923,-9399,-2792,-428]],"id":"55139","properties":{"name":"Winnebago"}},{"type":"Polygon","arcs":[[-5126,-9572,-319,-9629,-6937,-5928,-6575]],"id":"21047","properties":{"name":"Christian"}},{"type":"Polygon","arcs":[[-3132,-816,-9046,-2668,-5561,-1202]],"id":"37001","properties":{"name":"Alamance"}},{"type":"Polygon","arcs":[[-9687,-5839,-1316,-3862,-5369]],"id":"21065","properties":{"name":"Estill"}},{"type":"Polygon","arcs":[[-3929,-5051,-6669,-3518,-6288,-9415,-9567]],"id":"42129","properties":{"name":"Westmoreland"}},{"type":"Polygon","arcs":[[-6189,-5094,-9711,-1540,-1992,-5455]],"id":"29195","properties":{"name":"Saline"}},{"type":"Polygon","arcs":[[9816,-756,-8964,-5695,-928,-605,-4966]],"id":"46037","properties":{"name":"Day"}},{"type":"Polygon","arcs":[[9817,-7706,-3772,-9736,-1927,-1411,-6273]],"id":"48029","properties":{"name":"Bexar"}},{"type":"Polygon","arcs":[[-1743,-8771,-4763,-8119,-8128,-8013,-7675,9818]],"id":"51019","properties":{"name":"Bedford"}},{"type":"Polygon","arcs":[[-8960,-9239,-6915,-8586,-9715,-7156]],"id":"39015","properties":{"name":"Brown"}},{"type":"Polygon","arcs":[[-9696,-6248,-9574,-8752,-9755,-2094,-6059]],"id":"41059","properties":{"name":"Umatilla"}},{"type":"Polygon","arcs":[[-436,-5963,-9421,-9242,-6036]],"id":"47129","properties":{"name":"Morgan"}},{"type":"Polygon","arcs":[[-8346,-1744,-9819,-7674,-7527,-4723],[-7638,-2930]],"id":"51161","properties":{"name":"Roanoke"}},{"type":"Polygon","arcs":[[-8935,-8986]],"id":"51630","properties":{"name":"Fredericksburg"}},{"type":"Polygon","arcs":[[-8664,-1727,-5813,-5301,-734,9819,-8597]],"id":"53063","properties":{"name":"Spokane"}},{"type":"Polygon","arcs":[[-8344,-7525,-7522,-7567]],"id":"54073","properties":{"name":"Pleasants"}},{"type":"Polygon","arcs":[[9820,-9448,-8973,-6994,-8972]],"id":"72027","properties":{"name":"Camuy"}},{"type":"Polygon","arcs":[[-9749,-9638,-7167,-9816,-6931,-1220,-6095,-7000]],"id":"40007","properties":{"name":"Beaver"}},{"type":"Polygon","arcs":[[-3942,-6830,9821,-2711,-5062,-8551,-6499]],"id":"47025","properties":{"name":"Claiborne"}},{"type":"Polygon","arcs":[[-1236,-6098,-5228,-4927,-6287,-4800,-6449,-5746]],"id":"04001","properties":{"name":"Apache"}},{"type":"Polygon","arcs":[[-9178,-221,-8913,-9773,-8527,-4028]],"id":"13145","properties":{"name":"Harris"}},{"type":"Polygon","arcs":[[-7816,-7875,-9481,-9393,-7868,-7877]],"id":"12077","properties":{"name":"Liberty"}},{"type":"Polygon","arcs":[[-8445,-8059,9822,9823]],"id":"28045","properties":{"name":"Hancock"}},{"type":"Polygon","arcs":[[9824,-4888,-7760,-8876,-1936,-9652]],"id":"39007","properties":{"name":"Ashtabula"}},{"type":"Polygon","arcs":[[-2221,-6521,-3986,-9709,-7701]],"id":"06021","properties":{"name":"Glenn"}},{"type":"Polygon","arcs":[[-9094,-7379,-8696,-9096,-9192,9825,-5000]],"id":"40035","properties":{"name":"Craig"}},{"type":"Polygon","arcs":[[-7271,-8874,-7455,-5290,-8479]],"id":"17087","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[-7373,7371,-7371,7369,-7369,7367,-7367,-9591,-5177,-7225,-8649,-3884,-1303]],"id":"29183","properties":{"name":"St. Charles"}},{"type":"Polygon","arcs":[[9826,-2897,-6263,-7947,-7450,-5417]],"id":"20035","properties":{"name":"Cowley"}},{"type":"Polygon","arcs":[[-7589,-3866,-7554,-8276]],"id":"22123","properties":{"name":"West Carroll"}},{"type":"Polygon","arcs":[[9827,-9515,-2231,-8808,-9426,-7004,-5972,-4259]],"id":"38029","properties":{"name":"Emmons"}},{"type":"Polygon","arcs":[[-6646,9828,-8774,-8482,-8937]],"id":"29181","properties":{"name":"Ripley"}},{"type":"Polygon","arcs":[[-9069,-209,-1298,9829,-9265]],"id":"06087","properties":{"name":"Santa Cruz"}},{"type":"Polygon","arcs":[[-4458,-4037,-3022,-7700,9830]],"id":"06023","properties":{"name":"Humboldt"}},{"type":"Polygon","arcs":[[-8806,-346,9831,-2515,-6678,-9427]],"id":"46089","properties":{"name":"McPherson"}},{"type":"Polygon","arcs":[[-1106,-8598,-9820,-733,-8619,-7774,9832,-3624,-9573,-4726]],"id":"53075","properties":{"name":"Whitman"}},{"type":"Polygon","arcs":[[9833,-8665,-8595,-4156]],"id":"53019","properties":{"name":"Ferry"}},{"type":"Polygon","arcs":[[-6609,-199,-9304,-7960,-1851,-9021]],"id":"13273","properties":{"name":"Terrell"}},{"type":"Polygon","arcs":[[-651,-1920,-8907,-9710,-9153,-6380,-9014]],"id":"13221","properties":{"name":"Oglethorpe"}},{"type":"Polygon","arcs":[[-8355,-4647,-9616,-9223,-1496,-9453]],"id":"30009","properties":{"name":"Carbon"}},{"type":"Polygon","arcs":[[-5718,-5784,-9702,-3915,-7146,-8314,-5445]],"id":"56021","properties":{"name":"Laramie"}},{"type":"Polygon","arcs":[[-655,-1585,-3856,-81,-6716,-7123]],"id":"18005","properties":{"name":"Bartholomew"}},{"type":"Polygon","arcs":[[-9295,-9684,-9221,-6682,-803,-6832,-6860]],"id":"21081","properties":{"name":"Grant"}},{"type":"MultiPolygon","arcs":[[[9834]],[[-9590,9835,-8889,-4263,-3222]]],"id":"39043","properties":{"name":"Erie"}},{"type":"Polygon","arcs":[[9836,-9814,-4706,-9745,-6580,-9782]],"id":"21167","properties":{"name":"Mercer"}},{"type":"Polygon","arcs":[[-7484,-7488,-2129,-8804,-1008,-37]],"id":"27027","properties":{"name":"Clay"}},{"type":"Polygon","arcs":[[-5990,-6805,-5836,-9686,-7071]],"id":"21173","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[-5991,-1205,-6865,-5850,-9690]],"id":"37123","properties":{"name":"Montgomery"}},{"type":"Polygon","arcs":[[-9317,9837,-7667,-8998,-8927,-856,-8625]],"id":"27053","properties":{"name":"Hennepin"}},{"type":"Polygon","arcs":[[-4291,-6493,-1342,-5124,-6574,-6030]],"id":"21233","properties":{"name":"Webster"}},{"type":"Polygon","arcs":[[9838,-9717,-9099,-1576,-9509]],"id":"18091","properties":{"name":"LaPorte"}},{"type":"Polygon","arcs":[[-2716,-6359,9839,-2543,-1323]],"id":"20011","properties":{"name":"Bourbon"}},{"type":"Polygon","arcs":[[-9657,-2828,-9691,-6033,-5081,-5708]],"id":"37179","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[-8224,9840,-4716,-8414]],"id":"51810","properties":{"name":"Virginia Beach"}},{"type":"Polygon","arcs":[[-8833,9841,-7113,-870,-6920,-6962,-9240]],"id":"55009","properties":{"name":"Brown"}},{"type":"Polygon","arcs":[[-9809,-9605,-2341,-8340,-3269,-8334,-6460]],"id":"08043","properties":{"name":"Fremont"}},{"type":"Polygon","arcs":[[9842,-9575,-7982,-6428,-8007,-7905]],"id":"28067","properties":{"name":"Jones"}},{"type":"Polygon","arcs":[[-1971,-390,-7427,-7779,-4863,-9536]],"id":"31181","properties":{"name":"Webster"}},{"type":"Polygon","arcs":[[-8415,-4720,9843,-8109,-8098,-8330]],"id":"37029","properties":{"name":"Camden"}},{"type":"Polygon","arcs":[[-9582,-8403,-4755,-4312,-9632,-9641,-2549]],"id":"48251","properties":{"name":"Johnson"}},{"type":"Polygon","arcs":[[-1796,-8614,-7117,-6342,-2154,-9198]],"id":"08077","properties":{"name":"Mesa"}},{"type":"Polygon","arcs":[[-5966,-6786,-5706,-4676,-1984]],"id":"30013","properties":{"name":"Cascade"}},{"type":"Polygon","arcs":[[-5147,-661,-1127,-376,-2898,-9827,-4782]],"id":"20015","properties":{"name":"Butler"}},{"type":"Polygon","arcs":[[-6488,-5287,-5920,-8987,-1781,-9253]],"id":"38025","properties":{"name":"Dunn"}},{"type":"Polygon","arcs":[[-5573,-4375,-363,-9756,-5671,-8506]],"id":"49035","properties":{"name":"Salt Lake"}},{"type":"Polygon","arcs":[[-7040,9844,-5019,-8704,-8401,-262]],"id":"48121","properties":{"name":"Denton"}},{"type":"Polygon","arcs":[[-2240,-4749,-126,-702,-1423,-4992,-9743,-7187,-627]],"id":"46023","properties":{"name":"Charles Mix"}},{"type":"Polygon","arcs":[[-9718,-5453,-9694,-3797,-4760,-8770]],"id":"51125","properties":{"name":"Nelson"}},{"type":"Polygon","arcs":[[-7665,-3287,-1124,9845,-119,-4173,-6210]],"id":"72043","properties":{"name":"Coamo"}},{"type":"Polygon","arcs":[[-9041,-9727,-9580,-9681,-2688,-9514,-9129]],"id":"38103","properties":{"name":"Wells"}},{"type":"Polygon","arcs":[[9846,-6852,-9695,-1757]],"id":"72051","properties":{"name":"Dorado"}},{"type":"Polygon","arcs":[[-1816,-9513,-1172,-8880,-1873,-4116]],"id":"17143","properties":{"name":"Peoria"}},{"type":"Polygon","arcs":[[-6436,-9079,-9680,-8199,-4499,-9704,-5237]],"id":"34015","properties":{"name":"Gloucester"}},{"type":"Polygon","arcs":[[-666,-5754,-5720,-7668,-9838,-9316]],"id":"27003","properties":{"name":"Anoka"}},{"type":"Polygon","arcs":[[-345,-7769,-757,-9817,-4965,-8005,-2516,-9832]],"id":"46013","properties":{"name":"Brown"}},{"type":"Polygon","arcs":[[-5909,-3062,-6802,-1390,-403,-9647,-5913]],"id":"40093","properties":{"name":"Major"}},{"type":"Polygon","arcs":[[-930,-5694,-5346,-8082,-3673,-9469,-9594]],"id":"46039","properties":{"name":"Deuel"}},{"type":"Polygon","arcs":[[-2016,9847]],"id":"02230","properties":{"name":"Skagway"}},{"type":"Polygon","arcs":[[-1633,-6375,-6156,-6374,-4736,-7578,-1485,-5185]],"id":"47163","properties":{"name":"Sullivan"}},{"type":"Polygon","arcs":[[-6495,-5543,9848]],"id":"44001","properties":{"name":"Bristol"}},{"type":"Polygon","arcs":[[-8552,-5066,-6681,-5602,-6174,-4308,-9422,-5961]],"id":"47093","properties":{"name":"Knox"}},{"type":"Polygon","arcs":[[-8840,-828,-1484,-5447,-471,-7264,-8574,-6002]],"id":"56007","properties":{"name":"Carbon"}},{"type":"Polygon","arcs":[[-5636,-6971,-242,-3540,-9801,-8142,-8772]],"id":"42043","properties":{"name":"Dauphin"}},{"type":"Polygon","arcs":[[-7654]],"id":"51580","properties":{"name":"Covington"}},{"type":"Polygon","arcs":[[-2836,-9671,-7838,-8853,-8845,-7983]],"id":"55049","properties":{"name":"Iowa"}},{"type":"Polygon","arcs":[[-6983,-9246,-6980,-9245,-809,-681,-5827]],"id":"47175","properties":{"name":"Van Buren"}},{"type":"Polygon","arcs":[[-2919,-7707,-9818,-6272,-1913,-8686]],"id":"48019","properties":{"name":"Bandera"}},{"type":"Polygon","arcs":[[-9144,-9461,-3843,-2873]],"id":"12059","properties":{"name":"Holmes"}},{"type":"Polygon","arcs":[[-5438,-501,-9494]],"id":"41055","properties":{"name":"Sherman"}},{"type":"Polygon","arcs":[[-8656,-9770,-7293,-9146,-8469]],"id":"01067","properties":{"name":"Henry"}},{"type":"Polygon","arcs":[[-8886,-8433,-5623,-7511,-5614,-7927,-8844]],"id":"05139","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[-8019,-8354,-7085,-9440,-7506,-8729]],"id":"54031","properties":{"name":"Hardy"}},{"type":"Polygon","arcs":[[-9291,-5981,9849,-8259,-4422,-5219,-1101,-9215]],"id":"22017","properties":{"name":"Caddo"}},{"type":"Polygon","arcs":[[-2612,-7645,-7238,-4034]],"id":"41029","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-7237,-4129,4127,-8132,-8615,-566,-4036]],"id":"06049","properties":{"name":"Modoc"}},{"type":"Polygon","arcs":[[-7477,-5487,-9290,-6286,-9636,-3422]],"id":"28003","properties":{"name":"Alcorn"}},{"type":"Polygon","arcs":[[-9385,-8618,-3362,-7221,-2332]],"id":"08011","properties":{"name":"Bent"}},{"type":"Polygon","arcs":[[-7750,-7124,-6718,-71,-3450,-6532]],"id":"18105","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[-8444,-9466,9850,-4062]],"id":"21029","properties":{"name":"Bullitt"}},{"type":"Polygon","arcs":[[-1925,-6909,-9777,-8342,-9598,-9768]],"id":"39121","properties":{"name":"Noble"}},{"type":"Polygon","arcs":[[-4301,-2773,-9815,-9837,-9781,9851,-9464]],"id":"21005","properties":{"name":"Anderson"}},{"type":"Polygon","arcs":[[-9851,-9465,-9852,-9780,-9164,-5791,-4063]],"id":"21179","properties":{"name":"Nelson"}},{"type":"Polygon","arcs":[[-7035,-5356,-9585,-4377,-5575]],"id":"49057","properties":{"name":"Weber"}},{"type":"Polygon","arcs":[[-7023,-6151,-1238,-725,-3,-8063]],"id":"49025","properties":{"name":"Kane"}},{"type":"Polygon","arcs":[[-3344,-9125,-8194,-8258,-9850,-5980,-5771,-3345]],"id":"05091","properties":{"name":"Miller"}},{"type":"Polygon","arcs":[[-7198,-7641,-5951,9852,-9728,-9634]],"id":"45079","properties":{"name":"Richland"}},{"type":"Polygon","arcs":[[-9656,-7911,-8564,-2499,-8068,9853,-5363]],"id":"12107","properties":{"name":"Putnam"}},{"type":"Polygon","arcs":[[9854,-5936,-8875,-7269,-7364,-9530]],"id":"17077","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[-9784,-6840,-7176,9855,-6833,-3951,-4255]],"id":"37013","properties":{"name":"Beaufort"}},{"type":"Polygon","arcs":[[-368,-6657,-8073,9856]],"id":"36123","properties":{"name":"Yates"}},{"type":"Polygon","arcs":[[-8159,-3490,-5979,-9713,-3502,-1226,-5846]],"id":"47111","properties":{"name":"Macon"}},{"type":"Polygon","arcs":[[-4372,-977,-5568,-9007,9857]],"id":"48323","properties":{"name":"Maverick"}},{"type":"Polygon","arcs":[[-1010,-8805,-6723,-6259,-7381,-8963]],"id":"27155","properties":{"name":"Traverse"}},{"type":"Polygon","arcs":[[-8815,-8856,-9398,-4625,-9744,-8134]],"id":"32001","properties":{"name":"Churchill"}},{"type":"Polygon","arcs":[[-5120,-5777,-8859,-1479,-5860,-6847]],"id":"56005","properties":{"name":"Campbell"}},{"type":"Polygon","arcs":[[-7810,-8012,-9587,-5441,-9600,-8261,-5589]],"id":"53059","properties":{"name":"Skamania"}},{"type":"Polygon","arcs":[[-1960,-2509,-8743,-8902,-3550,-9262,-3384]],"id":"13315","properties":{"name":"Wilcox"}},{"type":"MultiPolygon","arcs":[[[9858]],[[-8977,9859,-7744]]],"id":"72053","properties":{"name":"Fajardo"}},{"type":"Polygon","arcs":[[-9244,-9424,-4743,-9807,-811]],"id":"47143","properties":{"name":"Rhea"}},{"type":"Polygon","arcs":[[-1319,-6573,-5570,-5145,-5766,-3820]],"id":"21025","properties":{"name":"Breathitt"}},{"type":"Polygon","arcs":[[-6358,-7426,-313,-1977,-1606,-2544,-9840]],"id":"29217","properties":{"name":"Vernon"}},{"type":"Polygon","arcs":[[-9805,-6596,-9785,-314,-7951,-9489,-2699]],"id":"01053","properties":{"name":"Escambia"}},{"type":"Polygon","arcs":[[-5364,-9854,-8071,-7323,-3849,-7818,-7392]],"id":"12083","properties":{"name":"Marion"}},{"type":"Polygon","arcs":[[-9833,-7778,-8750,-3625]],"id":"53003","properties":{"name":"Asotin"}},{"type":"Polygon","arcs":[[-9457,-9088,-8763,-8775,-9829,-6645]],"id":"29023","properties":{"name":"Butler"}},{"type":"Polygon","arcs":[[-7365,-7274,-9255,-6136,-9087,-6640]],"id":"29031","properties":{"name":"Cape Girardeau"}},{"type":"Polygon","arcs":[[-5552,-6774,-1636,-2708,-9822,-6829]],"id":"51105","properties":{"name":"Lee"}},{"type":"Polygon","arcs":[[-2990,-9463,-2405,-8039,-9419,9417,-9417,-8348]],"id":"01043","properties":{"name":"Cullman"}},{"type":"Polygon","arcs":[[-5138,-3511,-7486,-3413,-8393,-9810]],"id":"17029","properties":{"name":"Coles"}},{"type":"Polygon","arcs":[[-9525,-7594,-2567,-5923,-6624]],"id":"18015","properties":{"name":"Carroll"}},{"type":"MultiPolygon","arcs":[[[9860]],[[-8286,-7281,9861,-8164]]],"id":"22075","properties":{"name":"Plaquemines"}},{"type":"Polygon","arcs":[[-5804,-464,-9621,-919,-9312]],"id":"31091","properties":{"name":"Hooker"}},{"type":"Polygon","arcs":[[-5285,-9131,-9516,-9828,-4258,-4197]],"id":"38015","properties":{"name":"Burleigh"}},{"type":"Polygon","arcs":[[-5679,-3972,-7653,-8347,-7655]],"id":"54063","properties":{"name":"Monroe"}},{"type":"Polygon","arcs":[[-7584,-8317,-7764,-4994,-9630]],"id":"47021","properties":{"name":"Cheatham"}},{"type":"Polygon","arcs":[[-7135,-7866,-5882,-9474,-6972,-6820,-7417]],"id":"42015","properties":{"name":"Bradford"}},{"type":"Polygon","arcs":[[-7321,-9746,-4787,-4304,-8442]],"id":"21185","properties":{"name":"Oldham"}},{"type":"Polygon","arcs":[[-7253,-7710,-3836,-2262,-9390,-7861]],"id":"05101","properties":{"name":"Newton"}},{"type":"Polygon","arcs":[[-8818,-9737,-9280,-1641,-7637,-5621,-9698,-9036,-5278]],"id":"33009","properties":{"name":"Grafton"}},{"type":"Polygon","arcs":[[-6921,-873,9862,-5591,-9531,-9400]],"id":"55117","properties":{"name":"Sheboygan"}},{"type":"Polygon","arcs":[[-2962,-9576,-9843,-7904,-6778,-6725]],"id":"28129","properties":{"name":"Smith"}},{"type":"Polygon","arcs":[[-8360,-8446,-9824,9863,-8284,-8162,-9420,-16]],"id":"22103","properties":{"name":"St. Tammany"}},{"type":"Polygon","arcs":[[-9539,-9532,-5483,-7360,-9662,-9114,-9472,-9752]],"id":"24033","properties":{"name":"Prince George's"}},{"type":"Polygon","arcs":[[-1387,-3534,-9804,-1379,-9318,-8623,-347,-866,-9596]],"id":"27145","properties":{"name":"Stearns"}},{"type":"Polygon","arcs":[[-9498,-7577,-3660,-5786,-3658,-5787,-8251]],"id":"25017","properties":{"name":"Middlesex"}},{"type":"Polygon","arcs":[[-5697,-9811,-5871,-8773,-8145,-9740,-9808,-169]],"id":"42055","properties":{"name":"Franklin"}},{"type":"Polygon","arcs":[[-9558,-2805,-5937,-9855,-9529]],"id":"17145","properties":{"name":"Perry"}},{"type":"Polygon","arcs":[[-5461,-4432,-1305,-3888,-8081,-5033,-5459]],"id":"29073","properties":{"name":"Gasconade"}},{"type":"Polygon","arcs":[[-1216,-8679,-8254,-2847,-9577]],"id":"18161","properties":{"name":"Union"}},{"type":"Polygon","arcs":[[-8650,-8610,-8981,-9161,-2994,-3886]],"id":"29099","properties":{"name":"Jefferson"}},{"type":"Polygon","arcs":[[-9791,-5001,-9826,-9193,-3916,-9735]],"id":"40131","properties":{"name":"Rogers"}},{"type":"Polygon","arcs":[[-9853,-5950,-5184,-9609,-9729]],"id":"45017","properties":{"name":"Calhoun"}},{"type":"Polygon","arcs":[[-3961,-7568,-6959,-7977,-7738,-9024,9864]],"id":"54035","properties":{"name":"Jackson"}},{"type":"Polygon","arcs":[[9865]],"id":"69100","properties":{"name":"Rota"}},{"type":"Polygon","arcs":[[-9846,-1123,-2183,-5605,9866,-120]],"id":"72123","properties":{"name":"Salinas"}},{"type":"Polygon","arcs":[[-2788,-9653,-9010,-6140,-4633,-8958]],"id":"48239","properties":{"name":"Jackson"}},{"type":"MultiPolygon","arcs":[[[-641,-8600,9867]]],"id":"53035","properties":{"name":"Kitsap"}},{"type":"Polygon","arcs":[[-3039,-9771,-9179,9868,-7885]],"id":"12057","properties":{"name":"Hillsborough"}},{"type":"Polygon","arcs":[[-8408,-9396,-4867]],"id":"17043","properties":{"name":"DuPage"}},{"type":"Polygon","arcs":[[-9028,-4912,-8170,-7437,-8640,-9272]],"id":"34031","properties":{"name":"Passaic"}},{"type":"Polygon","arcs":[[-9650,-9813,-9480,-9772,-5015,-9845,-7039]],"id":"48181","properties":{"name":"Grayson"}},{"type":"Polygon","arcs":[[-4772,-9766,-8691,-9491]],"id":"13283","properties":{"name":"Treutlen"}},{"type":"Polygon","arcs":[[-457,-92,-9483,-2598,-9208,-3101,-2432]],"id":"28155","properties":{"name":"Webster"}},{"type":"Polygon","arcs":[[-9090,-921,-9622,-9527,-7405,-8631]],"id":"31101","properties":{"name":"Keith"}},{"type":"Polygon","arcs":[[-8000,-4522,-9617,-8002,-7987]],"id":"28001","properties":{"name":"Adams"}},{"type":"Polygon","arcs":[[-4120,-760,-369,-9857,-8072,-6510]],"id":"36069","properties":{"name":"Ontario"}},{"type":"Polygon","arcs":[[-3962,-9865,-9026,-6514,-3966]],"id":"54053","properties":{"name":"Mason"}},{"type":"Polygon","arcs":[[-729,-3831,-6393,-3086,-9]],"id":"04025","properties":{"name":"Yavapai"}}]},"states":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[-1237,-1236,-6098,-5228,-4927,-6287,4800,-3756,4801,-4921,7192,284,4797,5749,5747,3088,3084,-2005,10,11,0,1,2,724,725]]],"id":"04","properties":{"name":"Arizona"}},{"type":"MultiPolygon","arcs":[[[-8446,-9824,9863,8284,7279,9861,8164,8369,8491,8366,8492,4343,4832,3872,4068,4069,-3790,-3789,5559,-9152,6551,5736,5737,5738,5221,-1102,-1101,-9215,-9291,-5981,9849,8257,-8193,5488,5489,7925,7926,5613,-7510,-7590,-7589,3866,3867,-3697,-3696,-3704,-3703,-3702,7998,-4523,7999,7986,7987,7338,7330,-2513,-2512,12,13,-2161,8357,-7803,8358]],[[4833]],[[7277]],[[7278]],[[8364]],[[8489]],[[8490]],[[9860]]],"id":"22","properties":{"name":"Louisiana"}},{"type":"MultiPolygon","arcs":[[[9064,-6813,9065,-9110,7388,-9109,-2986,-2985,8438,3262,7776,7777,7773,8618,732,733,5300,5812,-1726,1246,1243,1244,-5359,-2348,-2347,4185,-6006,8363,3260,-2001,-2000,-1530,-1529,-1528,5796,-5526,5797,-6331,4078,4079,-4583,-4589,8460,-5354,4049,4050,3373,3374,8199]]],"id":"16","properties":{"name":"Idaho"}},{"type":"MultiPolygon","arcs":[[[5258,5256,2256,9707,7479,2903,4122,3585,4123,2905,2906,1761,-7917,-7833,5751,5752,5721,5722,-5703,-5702,-5701,-6318,-6317,-6987,-6986,-9313,-8103,5584,-4616,5585,-5390,-5389,-477,-476,-2806,6556,1362,1363,5763,5764,2762,-2735,-2734,5669,-3817,3179,3180,744,-102,1517,3671,3672,8081,5345,5346,-5693,7382,-8963,-1010,-1009,-1008,-37,-36,-6158,31,32,-6433,-4329,-6108]]],"id":"27","properties":{"name":"Minnesota"}},{"type":"MultiPolygon","arcs":[[[35,36,1007,1008,1009,1010,-754,7768,344,345,8805,8806,-9426,-7004,5972,-3765,-6955,-6954,-6239,719,-6238,-3740,-3739,-4016,-4542,5467,6878,6876,9506,492,2190,3263,1641,2738,6106,-5259,6107,4328,6432,-33,-32,6157]]],"id":"38","properties":{"name":"North Dakota"}},{"type":"MultiPolygon","arcs":[[[1423,-6278,-6240,6953,6954,3764,-5973,7003,9425,-8807,-8806,-346,-345,-7769,753,-1011,8962,-7383,5692,-5347,-5346,-8082,-3673,-3672,-1518,101,102,6111,6112,4969,-4779,-3638,4970,4971,5072,5073,6076,6077,4990,-9743,-7187,627,628,7019,3198,353,-8826,-2607,2558,2559,2560,4553,4554,4959,43,44,1427]]],"id":"46","properties":{"name":"South Dakota"}},{"type":"MultiPolygon","arcs":[[[-7846,-7864,7133,7134,7416,-6819,-6818,-8023,2924,2925,8860,8861,8932,-4885,8930,9485,7444,391,4118,757,9457,3710,6354,4517,7994,8766,-8327,8767,7723,7724,-9625,-6196,-8718,-8719,-5331,-5337,-5336,-9141,-8171,8167,7438,7439,9193,9043,3735,6351,3733,9044,8847,4512,4507,4508,-7434,-7433,-7432,8169,4911,4912,4913,-6855,-7848,-7847]],[[6348]],[[6349]],[[6350]],[[6352]],[[6355]],[[9126,-8837,9127,-7501]]],"id":"36","properties":{"name":"New York"}},{"type":"MultiPolygon","arcs":[[[51]],[[52]],[[53]],[[8793,2018,1446,8545,2087,9371,9203,9122,9375,2061,2074,2043,2069,762,2070,6389,4953,6391,4955,521,9520,1778,3593,2413,2809,2085,8544,1444,2019,9847,2016,8791,1429,1654,55,8542,3181,8543,57,1655,1431,8792,1433]],[[58]],[[59]],[[1434]],[[1436,8789]],[[1437]],[[1439]],[[1440]],[[1442,3206]],[[1652,3193]],[[2014]],[[2025]],[[2026]],[[2027]],[[2028]],[[2029]],[[2030]],[[2031]],[[2032]],[[2033]],[[2034]],[[2035]],[[2036]],[[2037]],[[2038]],[[2039]],[[2040]],[[2041]],[[2044]],[[2045]],[[2046]],[[2047]],[[2048]],[[2049]],[[2050]],[[2051]],[[2052]],[[2053]],[[2054]],[[2055]],[[2056]],[[2057]],[[2058]],[[2059]],[[2063]],[[2064]],[[2065]],[[2066]],[[2067]],[[2068]],[[2075]],[[2076]],[[2077]],[[2078]],[[2079]],[[2080]],[[2081]],[[2082]],[[3183]],[[3184]],[[3185]],[[3186]],[[3187]],[[3188]],[[3189]],[[3190]],[[3191]],[[3192]],[[3194,3204]],[[3205]],[[4956]],[[4957]],[[4958]],[[6387]],[[6388]],[[6390]],[[8538]],[[8539]],[[8540]],[[8541]],[[8790]],[[9204]],[[9324]],[[9325]],[[9326]],[[9327]],[[9328]],[[9329]],[[9330]],[[9331]],[[9332]],[[9333]],[[9334]],[[9335]],[[9336]],[[9337]],[[9338]],[[9339]],[[9340]],[[9341]],[[9342]],[[9343]],[[9344]],[[9345]],[[9346]],[[9347]],[[9348]],[[9349]],[[9350]],[[9351]],[[9352]],[[9353]],[[9354]],[[9355]],[[9356]],[[9357]],[[9358]],[[9359]],[[9360]],[[9361]],[[9362]],[[9363]],[[9364]],[[9365]],[[9366]],[[9367]],[[9368]],[[9369]],[[9370]],[[9372]],[[9373]],[[9374]],[[9519]],[[9521]]],"id":"02","properties":{"name":"Alaska"}},{"type":"MultiPolygon","arcs":[[[4004,-4639,-4449,4405,-4448,7958,7956,7957,4400,9724,7152,4041,4042,2134,2135,-8247,-7790,-7789,-7788,-7719,-7796,-7795,-7794,-7793,6526,-4551,-4550,-6051,-5945,-5944,-5943,8730,-9595,-6122,-6121,8523,-6022,-6021,-5518,-5517,-4907,-4906,9768,7213,4473,9696,4813,9322,-7605,5209,5210,6472,7394,7395,7126,7127,8908,-7613,-7612,-7880,7290,7291,2111,2112,847,848,7965,7966,7296,7292,9769,-8655,-8654,-8653,-8154,3578,-8153,-8528,-8527,-4028,-4027,-7628,3584,-7627,-9248,63,5801,-4640]]],"id":"13","properties":{"name":"Georgia"}},{"type":"MultiPolygon","arcs":[[[5659,7414,-3509,-3508,8394,-8554,3000,3001,-9058,-8436,5879,5873,5874,5875,9507,9838,-9717,9097,-7400,5305,-2799,2674,-1199,-1198,-3141,-6898,-6897,-1088,-1087,2198,-1905,-1904,8546,487,488,-2880,1213,1214,-8679,-8254,2847,-9174,-9296,4505,7417,-6861,-3122,-3127,7430,7319,7320,7321,4470,7822,-4060,-6826,4465,4876,-4285,-4692,-4691,-7277,-7276,-6491,-6490,4053,4054,4055,4056,7232,-5545,4882,-4836,4877,5662]]],"id":"18","properties":{"name":"Indiana"}},{"type":"MultiPolygon","arcs":[[[7300,9248,7350,8379,-3716,-3715,7468,3138,3139,3140,1197,1198,-2675,2798,-5306,7399,-9098,9716,9715,9298,9732,5842,1358,4850,1352,586,8308,9758,6279,2642,7462,8372,9451,9393,3681,8698,9000,3248,3669,8416,8495,482]],[[-5205,5496,5497,3686,3687,3688,3689,3683,9046,5405,9763,5407,4487,8941,5127,2269,7599,7602,7913,9682,1667,-205,203,-203,-202,4099]],[[7463]],[[7464]],[[7465]],[[7466]],[[7601]],[[9681]],[[9756]],[[9757]],[[9759]],[[9764]]],"id":"26","properties":{"name":"Michigan"}},{"type":"MultiPolygon","arcs":[[[-8298,-8299,-8301,-7247,-7246,336,337,-7240,-7245,7979,-8390,-8662,-8661,-8660,9562,8057,9822,9823,8445,-8359,7802,-8358,2160,-14,-13,2511,2512,-7331,-7339,-7988,-7987,-8000,4522,-7999,3701,3702,3703,3695,3696,-3868,-7588,-7587,3679,3674,3675,-7305,-7304,7517,7514,7355,-4560,-4559,7400,-8708,-7478,3420,-7477,-5487,-9290,6282,-4218,-4793,-4947,-4950,9031,9073,-8295]],[[8054]],[[8055]],[[9560]],[[9561]]],"id":"28","properties":{"name":"Mississippi"}},{"type":"MultiPolygon","arcs":[[[1086,1087,6896,6897,-3140,-3139,-7469,3714,3715,3716,9588,9835,8886,9059,9650,9824,-4888,-7760,-7759,-5898,-5897,-5894,-5893,-1014,7694,-8190,-6387,-8242,6906,-4934,-4937,-3295,-7524,-7526,8343,-7566,-7565,3959,3960,3961,3965,3966,-6513,8939,-6046,8940,8788,-5422,-5428,8588,-9715,-7156,-7155,8960,-7327,-7330,9171,9172,9173,-2848,8253,8678,-1215,-1214,2879,-489,-488,-8547,1903,1904,-2199]],[[9587]],[[9834]]],"id":"39","properties":{"name":"Ohio"}},{"type":"MultiPolygon","arcs":[[[8870,5856,7021,7974,9318,-7630,-4873,-4872,-4871,-5031,-5030,-5029,-8229,3792,3152,1718,509,1019,1020,6939,6940,-8578,190,191,-7496,-7495,-4145,-4144,5866,4022,4023,630,6093,6094,1219,1220,2618,2619,3402,-541,-540,-9156,511,9134,-6951,-6950,7042,7544,-3728,-3727,-4735,-4734,9174,7037,-9650,-9813,-9480,-9479,9230,-4527,-4526,-8241,5769,-3346,5770,5979,5980,9290,9214,1100,1101,-5222,-5739,-5738,-5737,-6552,9151,-5560,3788,3789,-4070,5428,4150,9698,4152,9114,9700,6902,9699,6904,6142,4634,3777,8719,9100,6501,7546,9385,7548,6503,9101,8721,3775,4635,6090,3779,4631,3781,6091,3783,8531,8722,9102,6505,7549,9386,8026,9270,3774,9007,9857,4372,9300]]],"id":"48","properties":{"name":"Texas"}},{"type":"MultiPolygon","arcs":[[[6944,8977,8706,9427,7770,6989,4348,8714,8712,2127,7094,9444,8968,8970,9820,9446,8376,9309,9713,6012,1755,9846,6848,141,8865,9445,4184,6879,8975,9859,7744,8696,2755,9450,3595,9277,2998,5603,9866,120,4173]],[[7800]],[[8715]],[[9396]],[[9858]]],"id":"72","properties":{"name":"Puerto Rico"}},{"type":"MultiPolygon","arcs":[[[8631,9626,9627,3912,3913,3914,9701,-5783,-5782,-5781,-7423,-2560,-2559,2606,8825,-354,-3199,-7020,-629,-628,7186,9742,-4991,-6078,-6077,-5074,-5073,-4972,-4971,-3637,-3636,8811,-9151,-7490,5431,-3644,-3643,-3642,-3732,-3731,-5269,4852,4853,-6221,8301,4200,4201,4202,4203,3399,3400,-7782,-3065,-3064,-8216,7428,7429,-7779,-4863,-4862,-2645,-2644,-176,-2980,-2979,4206,1603,-7287,-5243,-2954,156,152,-2950,7406]]],"id":"31","properties":{"name":"Nebraska"}},{"type":"MultiPolygon","arcs":[[[164,165,618,619,-6096,4040,-1235,-1234,-1233,-1232,-9198,1796,1790,-7671,-7670,-4367,-6003,8573,7263,470,471,-5446,8313,7145,-3914,-3913,-9628,-9627,-8632,-7407,2949,-153,-157,2953,2954,-5245,-3326,-1212,-1211,-5309,-5311,-5310,-2903,-7218,3363,3364,3365,3366,-4142,7221,7143,-5967]]],"id":"08","properties":{"name":"Colorado"}},{"type":"MultiPolygon","arcs":[[[-9802,9729,-3544,-3543,-5198,-5242,-5241,5474,-7386,998,999,5297,4480,9504,9505,-9182,-9181,9501,4486,5298,5638,9188,5476,7298,9730,9805,5652,9660,9111,4838,9472,9470,-9752,-9539,-9532,5483,5484,-3759,-3758,170,171,172,173,331,332,333,5398,5399,5400,5396,5397,328,329,330,167,168,9807,-9739,5228,5229]],[[5295,9503]],[[5639]],[[-9187,9502]]],"id":"24","properties":{"name":"Maryland"}},{"type":"MultiPolygon","arcs":[[[4861,4862,7778,-7430,-7429,8215,3063,3064,7781,-3401,-3400,-4204,-4203,-4202,4618,4619,4620,-6277,7678,8591,9004,-7473,-5886,-5890,-8310,4071,4072,6356,6357,9839,2543,-1610,2544,-4103,-1648,7377,7378,9093,-4999,-4998,9789,6260,6261,-7947,-7450,5417,5418,9667,-3059,737,738,-5908,7274,7165,7166,9637,9748,-6999,4106,-6998,7823,-3365,-3364,7217,2902,5309,5310,5308,1210,1211,3325,5244,-2955,5242,7286,-1604,-4207,2978,2979,175,2643,2644]]],"id":"20","properties":{"name":"Kansas"}},{"type":"MultiPolygon","arcs":[[[-5500,5291,5292,-5511,8479,9253,-5725,-6137,9254,7273,7267,-7364,-7363,-8982,8608,8609,8606,3246,3240,-5149,7223,7224,5176,9590,-7366,-5172,4533,4534,-3750,-3749,8920,-9034,-7559,-9402,9190,-4538,-4537,5387,-3723,-7235,8676,9773,9259,9260,4112,4113,4108,4109,4459,4460,986,987,-3165,9251,4856,-4169,-4168,9544,8405,-5875,-5874,-5880,8435,9057,-3002,-3001,8553,-8395,3507,3508,-7415,-5660,-5663,-4878,4835,-4883,5544,-7233,-4057,-4056,-4294,-4293,-6029,-5502]]],"id":"17","properties":{"name":"Illinois"}},{"type":"MultiPolygon","arcs":[[[201,202,203,204,205,8831,9841,7109,8820,7111,871,9862,5591,8797,8074,4166,4167,4168,-4857,-9252,3164,-988,-987,-4461,-4460,-4110,-4109,-4821,7984,7647,7648,4614,4615,-5585,8102,9312,6985,6986,6316,6317,5700,5701,5702,-5723,-5722,-5753,-5752,7832,7916,-1762,-2907,7915,4606,9438,7537,-3690,3688,-3688,-3687,-5498,-5497,5204,-4100]],[[4605]],[[8818]],[[8819]],[[9431]],[[9432]],[[9433]],[[9434]],[[9435]],[[9436]],[[9437]]],"id":"55","properties":{"name":"Wisconsin"}},{"type":"MultiPolygon","arcs":[[[9265,8474,9263,9066,9536,8472,9537,7310,8218,7930,8567,7932,7703,9830,4458,-3277,-2614,-2613,4033,4034,-7237,-4129,4127,-8132,-8131,979,2603,-8138,9138,-8428,1272,4030,-8427,9283,-4627,-2662,-2661,5043,5044,2003,-11,2004,-3085,-3089,-5748,5810,9284,7207,9787,7202,3018,9234,1300,9829]],[[3007]],[[3008]],[[3009]],[[3010]],[[7199]],[[7203]],[[9785]],[[9786]]],"id":"06","properties":{"name":"California"}},{"type":"MultiPolygon","arcs":[[[4778,-4970,-6113,-6112,-103,-745,-3181,-3180,3816,-5670,2733,2734,-2763,-5765,-5764,-1364,-1363,-6557,2805,475,476,5388,5389,-5586,-4615,-7649,-7648,-7985,4820,-4114,-4113,-9261,-9260,-9774,-8677,7234,3722,-5388,4536,4537,-9191,9401,-7558,2170,-1704,-1703,3213,4817,4818,710,711,5318,5319,1148,1149,-8497,-8536,7639,-6218,5270,-4853,5268,3730,3731,3641,3642,3643,-5432,7489,9150,-8812,3635,3636,3637]]],"id":"19","properties":{"name":"Iowa"}},{"type":"MultiPolygon","arcs":[[[-9730,9801,-5230,-5229,9738,-9808,-169,-168,-331,-330,-329,-5398,-5397,-5402,9415,2421,2422,2423,-4936,-8243,-6385,-8189,1018,1013,5892,5893,5896,5897,7758,7759,4887,4883,4884,-8933,-8862,-8861,-2926,-2925,8022,6817,6818,-7417,-7135,-7134,7863,7845,7846,7847,6854,-4914,6855,7457,-6366,5732,4984,-4566,4985,4986,-8399,9077,9078,6435,-5236,5196,5197,3542,3543]]],"id":"42","properties":{"name":"Pennsylvania"}},{"type":"MultiPolygon","arcs":[[[7571,9441,9799,-6879,-5468,4541,4015,3738,3739,6237,-720,6238,6239,6277,-1424,-5775,5118,5119,5120,-6846,-9224,-9223,-1496,-1495,-1505,5524,5525,-5797,1527,1528,1529,1999,2000,-3261,-8364,6005,-4186,2346,2347,5358,-1245,5357,2295,8777,9794,749,6301,9791,4572]]],"id":"30","properties":{"name":"Montana"}},{"type":"MultiPolygon","arcs":[[[-4073,-4072,8309,5889,5885,7472,-9005,-8592,-7679,6276,-4621,-4620,-4619,-4201,-8302,6220,-4854,-5271,6217,-7640,8535,8496,-1150,-1149,-5320,-5319,-712,-711,-4819,-4818,-3214,1702,1703,-2171,7557,7558,9033,-8921,3748,3749,-4535,-4534,5171,7365,-9591,-5177,-7225,-7224,5148,-3241,-3247,-8607,-8610,-8609,8981,7362,7363,-7268,-7274,-9255,6136,5724,5725,5726,5727,5728,-6043,8850,-6045,8851,3743,3744,3745,-4434,8765,8760,8761,-8775,-8774,-8482,-8485,-8157,-4444,-4443,-4442,-8220,9382,9387,-7708,-7251,1689,-7250,-4220,503,504,505,1651,1647,4102,-2545,1609,-2544,-9840,-6358,-6357]]],"id":"29","properties":{"name":"Missouri"}},{"type":"MultiPolygon","arcs":[[[-9143,-9147,-7966,-849,-848,-2113,-2112,-7292,-7291,7879,7611,7612,-8909,-7128,-7127,-7396,-7395,-6473,-5211,-5210,7604,7605,9376,8562,2496,8068,9774,9054,3211,1834,4808,9746,9644,8508,9641,8510,9645,8516,9788,7260,7227,7262,7229,8903,9179,9868,7885,3042,7883,3040,7209,7818,7393,1768,9723,7881,9391,7869,7877,2463,2874,316,7951,9489,-2700,9488,7950,313,314,2870,2871,-9144]],[[7261]],[[7866]],[[8511]],[[8512]],[[8513]],[[8517]],[[8518]],[[8519]],[[8520]]],"id":"12","properties":{"name":"Florida"}},{"type":"MultiPolygon","arcs":[[[5928,-6939,-6181,3482,3483,-7620,-6114,6040,6041,6042,-5729,-5728,-5727,-5726,-9254,-8480,5510,-5293,-5292,5499,5500,5501,6028,4292,4293,-4055,-4054,6489,6490,7275,7276,4690,4691,4284,-4877,-4466,6825,4059,-7823,-4471,-7322,-7321,-7320,-7431,3126,3121,6860,-7418,-4506,9295,-9173,-9172,7329,7326,-8961,7154,7155,9714,-8589,5427,5421,-8789,-8941,6045,6046,5323,5579,5580,5830,5831,5832,5833,-6771,5550,5551,6828,6829,3941,3942,-6498,-433,-432,4297,-7969,-5975,4825,3488,3489,8158,-5845,-5844,-7582,-7581,321,322,-9629,-6937]],[[6043,6044]]],"id":"21","properties":{"name":"Kentucky"}},{"type":"MultiPolygon","arcs":[[[3337,7343,3339,3653,7346,9684,5011,5993,993,994,995,996,5985,-1639,5986,9795,3690,327,746]],[[3332]],[[3333]],[[3334]],[[3335]],[[3650]],[[7344]],[[7345]]],"id":"23","properties":{"name":"Maine"}},{"type":"MultiPolygon","arcs":[[[357,358,4365,4366,7669,7670,-1791,-1797,9197,1231,1232,1233,1234,1235,1236,-726,-725,-3,-2,-4496,-4495,-4494,-4493,8502,8453,8506,8504,7036,-3374,-4051,-4050,5353,-8461,-4588,-8673]]],"id":"49","properties":{"name":"Utah"}},{"type":"MultiPolygon","arcs":[[[-2619,-1221,-1220,-6095,-6094,-631,-4024,-4023,-5867,-4143,-3366,-7824,6997,-4107,6998,-9749,-9638,-7167,-7166,-7275,5907,-739,-738,3058,-9668,-5419,-5418,7449,7946,-6262,-6261,-9790,4997,4998,-9094,-7379,-7378,-1652,-506,-505,-4224,-4223,-3351,7785,-7800,-9056,-9057,-4457,-7194,-7196,8239,-3347,-5770,8240,4525,4526,-9231,9478,9479,9812,9649,-7038,-9175,4733,4734,3726,3727,-7545,-7043,6949,6950,-9135,-512,9155,539,540,-3403,-2620]]],"id":"40","properties":{"name":"Oklahoma"}},{"type":"MultiPolygon","arcs":[[[-3942,-6830,9821,2707,-1635,-1634,-1633,-6375,-6156,-6374,4736,4737,4738,4739,4740,7578,-4710,-4714,-6586,-9676,6024,4979,4980,-5060,5599,6174,6175,-8245,-8246,5645,-2135,-4043,-4042,-7153,-9725,-4401,-7958,-7957,8996,8989,8990,-9282,-7812,1091,1092,-4214,-4213,-4219,-6283,9289,5486,7476,-3421,7477,8707,-7401,4558,4559,4560,5412,-4439,-4438,-4437,-4436,-4435,-3745,-3744,-8852,-6044,-8851,-6042,-6041,6113,7619,-3484,-3483,6180,6938,-5929,6936,9628,-323,-322,7580,7581,5843,5844,-8159,-3490,-3489,-4826,5974,7968,-4298,431,432,6497,-3943]]],"id":"47","properties":{"name":"Tennessee"}},{"type":"MultiPolygon","arcs":[[[-9696,-6248,-9574,8748,-3626,8749,-7777,-3263,-8439,2984,2985,9108,-7389,9109,-9066,-6812,4358,4359,4126,4128,7236,-4035,-4034,2612,2613,3276,3277,7643,7645,6129,8494,9705,6967,6965,4349,4350,4351,-5590,8260,9599,-5440,-5439,-5438,496,-5437,6057]]],"id":"41","properties":{"name":"Oregon"}},{"type":"MultiPolygon","arcs":[[[-5400,-5399,-334,-333,-332,-174,-173,-172,-3757,-6205,-8353,-8352,8017,-8354,-7085,-9440,7506,7507,-4599,2122,2123,3969,3970,-7653,-8347,-7655,5679,4930,4931,4932,2446,2447,-7064,-5831,-5581,-5580,-5324,-6047,-8940,6512,-3967,-3966,-3962,-3961,-3960,7564,7565,-8344,7525,7523,3294,4936,4933,-6907,8241,6386,8189,-7695,-1019,8188,6384,8242,4935,-2424,-2423,-2422,-9416,5401,-5401]]],"id":"54","properties":{"name":"West Virginia"}},{"type":"MultiPolygon","arcs":[[[-7518,7303,7304,-3676,-3675,-3680,7586,7587,-3867,7588,7589,7509,-5614,-7927,-7926,-5490,-5489,8192,-8258,-9850,-5980,-5771,3345,3346,-8240,7195,7193,4456,9056,9055,7799,-7786,3350,4222,4223,-504,4219,7249,-1690,7250,7707,-9388,-9383,8219,4441,4442,4443,8156,8484,8481,8773,8774,-8762,-8761,-8766,4433,-3746,4434,4435,4436,4437,4438,-5413,-4561,-7356,-7515]]],"id":"05","properties":{"name":"Arkansas"}},{"type":"MultiPolygon","arcs":[[[9169,9740,9168,6234,8666,4154,9833,8662,1724,-1247,1725,-5813,-5301,-734,-733,-8619,-7774,-7778,-8750,3625,-8749,9573,6247,9695,-6058,5436,-497,5437,5438,5439,-9600,-8261,5589,-4352,-4351,-4350,-6966,7907,7101,8560,8566,8556,8564,8598,9867,641,8600,9466,634,2480]],[[2481]],[[6231]],[[6235]],[[8602]],[[8603]],[[8604]],[[8605]],[[8665]],[[8667]],[[9741]]],"id":"53","properties":{"name":"Washington"}},{"type":"MultiPolygon","arcs":[[[3589,-6226,-7070,3823,-7069,8373,8454,8455,8456,6706,8095,8096,-8330,-8415,4714,4715,4716,9721,4718,9843,8109,7138,8034,6709,9811,6836,9099,7172,9722,7174,9855,6833,3952,6891,2450,9543,5493,8264,-6299,-6298,-5200,6867,5933,5852,-5082,-5081,-5708,-5707,-4895,-4894,3907,3908,6362,6363,4707,-1067,-1066,-1072,3946,3947,-7792,7718,7787,7788,7789,8246,-2136,-5646,8245,8244,-6176,-6175,-5600,5059,-4981,-4980,-6025,9675,6585,4713,4709,-7579,-4741,-4740,-4739,8802,7073,6872,6873,6874,3043,3044,812,813,-8016,-1283,-8015,-6227]],[[7170,9720]],[[9719]]],"id":"37","properties":{"name":"North Carolina"}},{"type":"MultiPolygon","arcs":[[[4598,-7508,-7507,9439,7084,8353,-8018,8351,8352,6204,3756,-171,3757,3758,-5485,6227,-9533,9538,9751,-9471,9752,9678,8984,1518,9760,5951,9792,1554,9793,9534,5104,7080,2283,8277,4570,9120,8092,7013,6243,5997,8327,8278,8222,9840,-4716,-4715,8414,8329,-8097,-8096,-6707,-8457,-8456,-8455,-8374,7068,-3824,7069,6225,-3590,6226,8014,1282,8015,-814,-813,-3045,-3044,-6875,-6874,-6873,-7074,-8803,-4738,-4737,6373,6155,6374,1632,1633,1634,-2708,-9822,-6829,-5552,-5551,6770,-5834,-5833,-5832,7063,-2448,-2447,-4933,-4932,-4931,-5680,7654,8346,7652,-3971,-3970,-2124,-2123]],[[9180,9181,9182,8029,9183]],[[9184]],[[9185,9186]]],"id":"51","properties":{"name":"Virginia"}},{"type":"MultiPolygon","arcs":[[[6002,-4366,-359,-358,8672,4587,4588,4582,-4080,-4079,6330,-5798,-5525,1504,1494,1495,9222,9223,6845,-5121,-5120,-5119,5774,-1428,-45,-44,-4960,-4555,-4554,-2561,7422,5780,5781,5782,-9702,-3915,-7146,-8314,5445,-472,-471,-7264,-8574]]],"id":"56","properties":{"name":"Wyoming"}},{"type":"MultiPolygon","arcs":[[[-314,-7951,-9489,2699,2700,8658,8659,8660,8661,8389,-7980,7244,7239,-338,-337,7245,7246,8300,8298,8297,8294,-9074,-9032,4949,4946,4792,4217,4218,4212,4213,-1093,-1092,7811,9281,-8991,-8990,-8997,-7959,4447,-4406,4448,4638,-4005,4639,-5802,-64,9247,7626,-3585,7627,4026,4027,8526,8527,8152,-3579,8153,8652,8653,8654,-9770,-7293,-7297,-7967,9146,9142,9143,-2872,-2871,-315]],[[8657]]],"id":"01","properties":{"name":"Alabama"}},{"type":"MultiPolygon","arcs":[[[-6363,-3909,-3908,4893,4894,5706,5707,5080,5081,-5853,-5934,-6868,5199,6297,6298,6299,5265,4891,6885,4975,4904,4905,4906,5516,5517,6020,6021,-8524,6120,6121,9594,-8731,5942,5943,5944,6050,4549,4550,-6527,7792,7793,7794,7795,7791,-3948,-3947,1071,1065,1066,-4708,-6364]]],"id":"45","properties":{"name":"South Carolina"}},{"type":"MultiPolygon","arcs":[[[1626,4919,4920,-4802,3755,-4801,6286,4926,5227,6097,-4041,6095,-620,-619,-166,-165,5966,-7144,-7222,4141,-3367,4142,4143,4144,7494,7495,-192,-191,8577,-6941,-6940,-1021,-1020,-510,-1719,-3153,-3793,8228,5028,5029,5030,4870,4871,4872,7629,7630]]],"id":"35","properties":{"name":"New Mexico"}},{"type":"MultiPolygon","arcs":[[[-996,-995,9080,-7575,-7574,9497,-8250,-8249,-3666,-4918,-4917,-5279,-5278,-8818,-9737,-9280,1636,1637,1638,-5986,-997]]],"id":"33","properties":{"name":"New Hampshire"}},{"type":"MultiPolygon","arcs":[[[2193]],[[2194]],[[2196,8716]]],"id":"60","properties":{"name":"American Samoa"}},{"type":"MultiPolygon","arcs":[[[9278,-1637,9279,9736,8817,5277,5278,4916,4917,-3665,-3664,-5332,8718,8717,6195,9624,-7725,-7724,-8768,8326,8324,5095,8725]]],"id":"50","properties":{"name":"Vermont"}},{"type":"MultiPolygon","arcs":[[[2660,2661,4626,-9284,8426,-4031,-1273,8427,-9139,8137,-2604,-980,8130,8131,-4128,-4127,-4360,-4359,6811,6812,-9065,-8200,-3375,-7037,-8505,-8507,-8454,-8503,4492,4493,4494,4495,-1,-12,-2004,-5045,-5044]]],"id":"32","properties":{"name":"Nevada"}},{"type":"MultiPolygon","arcs":[[[3553]],[[3554]],[[3555]],[[3557,7677]],[[3622]],[[8501]],[[8945]],[[8946]]],"id":"15","properties":{"name":"Hawaii"}},{"type":"MultiPolygon","arcs":[[[7573,7574,7575,3661,5787,4083,5784,4085,9798,9227,9797,4087,5540,-4131,5541,5542,5543,5788,-6494,-7681,8251,6185,6186,6187,5334,5335,5336,5330,5331,3663,3664,3665,8248,8249,-9498]],[[6063]],[[9225]]],"id":"25","properties":{"name":"Massachusetts"}},{"type":"MultiPolygon","arcs":[[[3975,7972]],[[5521]],[[7971]]],"id":"78","properties":{"name":"United States Virgin Islands"}},{"type":"MultiPolygon","arcs":[[[4130,4131]],[[4132]],[[4133]],[[6495,6437,9379,-7686,6439,6440,6496,6493,-5789,-5544,-5543,9848]],[[9378]]],"id":"44","properties":{"name":"Rhode Island"}},{"type":"MultiPolygon","arcs":[[[-6436,-9079,-9078,8398,-4987,-4986,4565,-4985,-5733,6365,-7458,-6856,-4913,-4912,-8170,7431,7432,7433,-4509,-4508,8835,8836,-9127,7500,7501,8937,7408,8196,8589,4501,9704,-5234,9702,-5238,-5237]]],"id":"34","properties":{"name":"New Jersey"}},{"type":"MultiPolygon","arcs":[[[5233,5234]],[[-999,7385,-5475,5240,5241,-5197,5235,5236,5237,5238,7383,9567,-9505,-4481,-5298,-1000]]],"id":"10","properties":{"name":"Delaware"}},{"type":"MultiPolygon","arcs":[[[5302,7312,8172,-7439,-8168,8170,9140,-5335,-6188,-6187,-6186,-8252,7680,-6497,-6441,-6440,7685,7686]]],"id":"09","properties":{"name":"Connecticut"}},{"type":"MultiPolygon","arcs":[[[6987]],[[8375]],[[8408]],[[8409]],[[8410]],[[8411]],[[8412]],[[9865]]],"id":"69","properties":{"name":"Commonwealth of the Northern Mariana Islands"}},{"type":"MultiPolygon","arcs":[[[8175]]],"id":"66","properties":{"name":"Guam"}},{"type":"MultiPolygon","arcs":[[[-5484,9531,9532,-6228]]],"id":"11","properties":{"name":"District of Columbia"}}]},"nation":{"type":"GeometryCollection","geometries":[{"type":"MultiPolygon","arcs":[[[1626,4919,7192,284,4797,5749,5810,9284,7207,9787,7202,3018,9234,1300,9829,9265,8474,9263,9066,9536,8472,9537,7310,8218,7930,8567,7932,7703,9830,4458,3277,7643,7645,6129,8494,9705,6967,7907,7101,8560,8566,8556,8564,8598,9867,641,8600,9466,634,2480,9169,9740,9168,6234,8666,4154,9833,8662,1724,1243,5357,2295,8777,9794,749,6301,9791,4572,7571,9441,9799,6876,9506,492,2190,3263,1641,2738,6106,5256,2256,9707,7479,2903,4122,3585,4123,2905,7915,4606,9438,7537,3683,9046,5405,9763,5407,4487,8941,5127,2269,7599,7602,7913,9682,1667,205,8831,9841,7109,8820,7111,871,9862,5591,8797,8074,4166,9544,8405,5875,9507,9838,9715,9298,9732,5842,1358,4850,1352,586,8308,9758,6279,2642,7462,8372,9451,9393,3681,8698,9000,3248,3669,8416,8495,482,7300,9248,7350,8379,3716,9588,9835,8886,9059,9650,9824,4883,8930,9485,7444,391,4118,757,9457,3710,6354,4517,7994,8766,8324,5095,8725,9278,1637,5986,9795,3690,327,746,3337,7343,3339,3653,7346,9684,5011,5993,993,9080,7575,3661,5787,4083,5784,4085,9798,9227,9797,4087,5540,4131,5541,9848,6495,6437,9379,7686,5302,7312,8172,7439,9193,9043,3735,6351,3733,9044,8847,4512,8835,9127,7501,8937,7408,8196,8589,4501,9704,5234,9702,5238,7383,9567,9505,9182,8029,9183,9501,4486,5298,5638,9188,5476,7298,9730,9805,5652,9660,9111,4838,9472,9752,9678,8984,1518,9760,5951,9792,1554,9793,9534,5104,7080,2283,8277,4570,9120,8092,7013,6243,5997,8327,8278,8222,9840,4716,9721,4718,9843,8109,7138,8034,6709,9811,6836,9099,7172,9722,7174,9855,6833,3952,6891,2450,9543,5493,8264,6299,5265,4891,6885,4975,4904,9768,7213,4473,9696,4813,9322,7605,9376,8562,2496,8068,9774,9054,3211,1834,4808,9746,9644,8508,9641,8510,9645,8516,9788,7260,7227,7262,7229,8903,9179,9868,7885,3042,7883,3040,7209,7818,7393,1768,9723,7881,9391,7869,7877,2463,2874,316,7951,9489,2700,8658,9562,8057,9822,9863,8284,7279,9861,8164,8369,8491,8366,8492,4343,4832,3872,4068,5428,4150,9698,4152,9114,9700,6902,9699,6904,6142,4634,3777,8719,9100,6501,7546,9385,7548,6503,9101,8721,3775,4635,6090,3779,4631,3781,6091,3783,8531,8722,9102,6505,7549,9386,8026,9270,3774,9007,9857,4372,9300,8870,5856,7021,7974,9318,7630],[5500]],[[4833]],[[7277]],[[7278]],[[8364]],[[8489]],[[8490]],[[9860]],[[6348]],[[6349]],[[6350]],[[6352]],[[6355]],[[51]],[[52]],[[53]],[[8793,2018,1446,8545,2087,9371,9203,9122,9375,2061,2074,2043,2069,762,2070,6389,4953,6391,4955,521,9520,1778,3593,2413,2809,2085,8544,1444,2019,9847,2016,8791,1429,1654,55,8542,3181,8543,57,1655,1431,8792,1433]],[[58]],[[59]],[[1434]],[[1436,8789]],[[1437]],[[1439]],[[1440]],[[1442,3206]],[[1652,3193]],[[2014]],[[2025]],[[2026]],[[2027]],[[2028]],[[2029]],[[2030]],[[2031]],[[2032]],[[2033]],[[2034]],[[2035]],[[2036]],[[2037]],[[2038]],[[2039]],[[2040]],[[2041]],[[2044]],[[2045]],[[2046]],[[2047]],[[2048]],[[2049]],[[2050]],[[2051]],[[2052]],[[2053]],[[2054]],[[2055]],[[2056]],[[2057]],[[2058]],[[2059]],[[2063]],[[2064]],[[2065]],[[2066]],[[2067]],[[2068]],[[2075]],[[2076]],[[2077]],[[2078]],[[2079]],[[2080]],[[2081]],[[2082]],[[3183]],[[3184]],[[3185]],[[3186]],[[3187]],[[3188]],[[3189]],[[3190]],[[3191]],[[3192]],[[3194,3204]],[[3205]],[[4956]],[[4957]],[[4958]],[[6387]],[[6388]],[[6390]],[[8538]],[[8539]],[[8540]],[[8541]],[[8790]],[[9204]],[[9324]],[[9325]],[[9326]],[[9327]],[[9328]],[[9329]],[[9330]],[[9331]],[[9332]],[[9333]],[[9334]],[[9335]],[[9336]],[[9337]],[[9338]],[[9339]],[[9340]],[[9341]],[[9342]],[[9343]],[[9344]],[[9345]],[[9346]],[[9347]],[[9348]],[[9349]],[[9350]],[[9351]],[[9352]],[[9353]],[[9354]],[[9355]],[[9356]],[[9357]],[[9358]],[[9359]],[[9360]],[[9361]],[[9362]],[[9363]],[[9364]],[[9365]],[[9366]],[[9367]],[[9368]],[[9369]],[[9370]],[[9372]],[[9373]],[[9374]],[[9519]],[[9521]],[[7463]],[[7464]],[[7465]],[[7466]],[[7601]],[[9681]],[[9756]],[[9757]],[[9759]],[[9764]],[[8054]],[[8055]],[[9560]],[[9561]],[[9587]],[[9834]],[[6944,8977,8706,9427,7770,6989,4348,8714,8712,2127,7094,9444,8968,8970,9820,9446,8376,9309,9713,6012,1755,9846,6848,141,8865,9445,4184,6879,8975,9859,7744,8696,2755,9450,3595,9277,2998,5603,9866,120,4173]],[[7800]],[[8715]],[[9396]],[[9858]],[[5295,9503]],[[5639]],[[9502,9185]],[[4605]],[[8818]],[[8819]],[[9431]],[[9432]],[[9433]],[[9434]],[[9435]],[[9436]],[[9437]],[[3007]],[[3008]],[[3009]],[[3010]],[[7199]],[[7203]],[[9785]],[[9786]],[[7261]],[[7866]],[[8511]],[[8512]],[[8513]],[[8517]],[[8518]],[[8519]],[[8520]],[[3332]],[[3333]],[[3334]],[[3335]],[[3650]],[[7344]],[[7345]],[[2481]],[[6231]],[[6235]],[[8602]],[[8603]],[[8604]],[[8605]],[[8665]],[[8667]],[[9741]],[[7170,9720]],[[9719]],[[9184]],[[8657]],[[2193]],[[2194]],[[2196,8716]],[[3553]],[[3554]],[[3555]],[[3557,7677]],[[3622]],[[8501]],[[8945]],[[8946]],[[6063]],[[9225]],[[3975,7972]],[[5521]],[[7971]],[[4132]],[[4133]],[[9378]],[[6987]],[[8375]],[[8408]],[[8409]],[[8410]],[[8411]],[[8412]],[[9865]],[[8175]]]}]}},"arcs":[[[18136,59828],[0,183]],[[18136,60011],[200,0],[121,0]],[[18457,60011],[101,0]],[[18558,60011],[2,-56],[-12,-70],[-10,-107]],[[18538,59778],[0,0]],[[18538,59778],[-2,-83]],[[18536,59695],[0,0]],[[18536,59695],[-6,-64],[5,-85],[-10,-51],[0,-50],[9,-35],[-6,-28],[6,-62],[-11,-64],[-16,-5],[-21,-74],[-20,-2],[-10,-33],[-22,-26],[-14,-1],[-29,-75],[-6,9],[-12,-27],[0,-35],[-9,-36],[-21,11],[-12,-57],[3,-76],[7,-27],[-5,-57],[7,-34],[-7,-74],[0,-340]],[[18336,58297],[0,-1409]],[[18336,56888],[-8,-27],[-48,17],[-14,-77],[-26,-38],[-17,35],[-28,-18],[-3,30],[-21,-2],[-30,12],[-15,46],[-14,5]],[[18112,56871],[-11,54],[-14,19],[-31,100],[-13,7],[2,58],[-26,239],[-23,63],[-7,69],[-16,57],[1,147]],[[17974,57684],[6,95],[-10,22],[21,43],[0,72],[-9,178],[-6,65],[-11,47],[-4,58],[6,36],[0,103],[-9,38],[3,39],[-7,31],[3,51],[-5,59],[4,56],[9,24],[-10,31],[-12,97],[4,43],[-7,80],[25,31],[9,29],[5,-14],[12,25],[17,-1],[2,-25],[24,19],[13,-3],[18,-71],[-2,-28],[21,-51],[24,11],[24,183],[5,15],[1,230],[-2,272],[0,254]],[[24679,53026],[5,0]],[[24684,53026],[56,0]],[[24740,53026],[0,-110],[9,-17],[15,-146],[2,-62]],[[24766,52691],[3,-76],[0,-332],[15,-59],[8,-89]],[[24792,52135],[-39,70],[-51,-21]],[[24702,52184],[-1,92],[-9,68],[-7,19],[-6,66],[0,190]],[[24679,52619],[0,407]],[[17985,67226],[61,1]],[[18046,67227],[184,0]],[[18230,67227],[0,-407],[-14,0],[0,-99],[-47,0]],[[18169,66721],[-32,0],[0,51],[-83,1],[-5,48],[-64,0]],[[17985,66821],[0,405]],[[22846,73017],[180,1]],[[23026,73018],[0,-178],[5,0],[0,-67]],[[23031,72773],[0,-135],[36,-1],[0,-101],[144,1],[0,101],[35,1],[0,101]],[[23246,72740],[36,-2]],[[23282,72738],[1,-303],[7,0],[0,-202]],[[23290,72233],[-143,-1]],[[23147,72232],[-219,0]],[[22928,72232],[-1,130],[-5,3],[-5,68]],[[22917,72433],[-7,36],[-6,77],[-8,17],[-11,101],[-3,58],[-11,34],[-5,121],[-8,22],[-12,118]],[[22690,71930],[71,-1]],[[22761,71929],[172,-1]],[[22933,71928],[1,-102]],[[22934,71826],[3,-40],[-1,-171],[11,-51],[6,11],[-6,-117],[-5,-17],[6,-112],[-5,-68],[2,-37]],[[22945,71224],[-2,-3],[-134,-1]],[[22809,71220],[-112,0]],[[22697,71220],[0,406],[-7,0],[0,304]],[[20921,68824],[34,9],[13,22],[12,-12],[6,20],[71,-1]],[[21057,68862],[-2,-405],[34,1],[0,-135]],[[21089,68323],[-168,0]],[[20921,68323],[0,46]],[[20921,68369],[0,455]],[[29114,66796],[24,-19],[30,-46],[46,12],[7,15]],[[29221,66758],[2,-46],[-13,-11],[9,-39],[24,-2],[1,20]],[[29244,66680],[5,-14],[-8,-115],[-14,-79],[4,-66],[-10,-86],[3,-14]],[[29224,66306],[3,-36],[-29,-25],[-9,21],[-18,-22]],[[29171,66244],[-49,81],[-26,109]],[[29096,66434],[23,126],[-10,145],[5,91]],[[12999,82714],[4,48],[9,-30],[-13,-18]],[[12979,82569],[2,29],[21,40],[21,-38],[-1,-22],[-24,-37],[-19,28]],[[12954,82690],[20,33],[17,52],[-5,-50],[-18,-75],[-14,40]],[[12982,82959],[22,19],[9,46],[25,1],[13,33],[7,54],[17,54],[27,-1]],[[13102,83165],[-2,-19],[71,-81],[-8,-61],[11,-57],[7,-119],[71,14],[33,-77],[82,-115],[23,-48]],[[13390,82602],[-5,-74],[18,-26],[11,-59],[-26,-77],[-42,-29],[-6,31],[-26,-57],[-22,-27],[19,-73],[-3,-67],[-31,4],[-32,82],[-23,5],[7,-32],[-47,-12],[-20,-89],[8,-28],[-4,-35],[-12,-9],[-20,-79],[19,-57],[-12,-55],[0,-66],[-28,8],[-7,-53],[-26,-27]],[[13080,81701],[-7,79],[-16,70],[21,-29],[7,75],[27,37],[12,147],[-8,102],[10,57],[6,-21],[12,42],[7,92],[-21,-11],[-4,-58],[-19,-30],[-21,-61],[13,-113],[-8,-42],[-33,3],[-12,-43],[3,-30],[-17,-14],[-7,34],[4,67],[-19,23],[-12,128],[-32,-17],[0,-48],[-28,118],[-3,123],[8,25],[25,1],[7,66],[13,49],[30,12],[16,-72],[7,63],[-15,168],[9,3],[30,-45],[4,-59],[11,-32],[6,23],[-9,77],[-22,35],[-19,48],[-3,53],[-11,13],[-12,-25],[-10,49],[-23,32],[-5,57],[10,37]],[[12850,82395],[7,53],[10,-24],[22,-97],[10,-68],[-13,-15],[-21,61],[-9,4],[-6,86]],[[12838,82543],[18,86],[21,30],[30,-20],[24,22],[28,-42],[4,-36],[-18,-53],[6,-82],[-16,-19],[-44,-22],[-23,65],[-24,29],[-6,42]],[[26122,56404],[49,-3],[0,8],[45,-2]],[[26216,56407],[4,0],[-1,-108]],[[26219,56299],[-3,1],[0,-114],[-16,-23],[-9,6],[-42,-56],[-13,1]],[[26136,56114],[-14,290]],[[26649,54717],[75,153]],[[26724,54870],[25,-187]],[[26749,54683],[-10,34],[-37,-129],[6,-20],[-17,-61]],[[26691,54507],[-42,151]],[[26649,54658],[0,59]],[[25761,62228],[0,102]],[[25761,62330],[102,-2]],[[25863,62328],[10,0],[2,-264]],[[25875,62064],[-10,-36],[0,-53]],[[25865,61975],[-104,-1]],[[25761,61974],[0,254]],[[26039,62491],[33,2],[35,73]],[[26107,62566],[-1,-329]],[[26106,62237],[-26,-1],[0,-34],[-10,0],[0,-34],[-10,0],[0,-34],[-20,-10]],[[26040,62124],[-14,19],[-18,-29]],[[26008,62114],[-1,304]],[[26007,62418],[0,71],[32,2]],[[26754,67376],[0,-51],[33,1],[1,-152]],[[26788,67174],[4,-303]],[[26792,66871],[-33,-6]],[[26759,66865],[-98,-9]],[[26661,66856],[-2,197],[0,202]],[[26659,67255],[0,11],[30,3],[0,101],[65,6]],[[25077,56605],[88,0]],[[25165,56605],[29,0]],[[25194,56605],[0,-306]],[[25194,56299],[-59,1],[0,-68],[-29,0],[0,-17]],[[25106,56215],[-44,-1]],[[25062,56214],[1,85],[14,1],[0,305]],[[26756,64659],[72,0],[7,4]],[[26835,64663],[29,-1]],[[26864,64662],[-1,-331]],[[26863,64331],[-36,1],[0,-9]],[[26827,64323],[-71,-2]],[[26756,64321],[0,338]],[[22851,67982],[67,0]],[[22918,67982],[121,2]],[[23039,67984],[0,-407]],[[23039,67577],[-40,0]],[[22999,67577],[-91,0]],[[22908,67577],[-57,-1]],[[22851,67576],[0,406]],[[22775,67577],[76,-1]],[[22908,67577],[0,-485]],[[22908,67092],[-66,0]],[[22842,67092],[0,101],[-66,-1]],[[22776,67192],[-1,385]],[[23272,52945],[51,149]],[[23323,53094],[0,-141],[15,-58],[-5,-35],[20,3]],[[23353,52863],[-9,-414]],[[23344,52449],[-1,5],[-66,1],[-64,141]],[[23213,52596],[-9,272]],[[23204,52868],[21,18],[19,37],[18,-21],[10,43]],[[31398,37874],[8,42],[-1,27]],[[31405,37943],[19,-7],[7,-24]],[[31431,37912],[-2,-46]],[[31429,37866],[-13,-44],[-18,52]],[[22383,68083],[133,3]],[[22516,68086],[2,-100]],[[22518,67986],[0,-317],[1,-94]],[[22519,67575],[-107,1]],[[22412,67576],[-25,0]],[[22387,67576],[-1,407],[-3,0],[0,100]],[[22462,48678],[81,-3]],[[22543,48675],[49,-1]],[[22592,48674],[20,-1],[0,-60]],[[22612,48613],[0,-498]],[[22612,48115],[-93,2]],[[22519,48117],[-29,1]],[[22490,48118],[2,316],[-14,-1],[0,102],[-7,0],[0,108],[-9,35]],[[31491,38138],[7,20],[7,88]],[[31505,38246],[7,11]],[[31512,38257],[6,-9]],[[31518,38248],[2,-92],[4,-22]],[[31524,38134],[-7,-47],[1,-26],[-9,-36]],[[31509,38025],[-4,41],[-8,24]],[[31497,38090],[-6,48]],[[31479,38421],[9,22]],[[31488,38443],[5,-39]],[[31493,38404],[-6,-16]],[[31487,38388],[-11,7]],[[31476,38395],[3,26]],[[31395,38326],[5,-1]],[[31400,38325],[13,1],[6,-32]],[[31419,38294],[3,-13]],[[31422,38281],[-4,-46]],[[31418,38235],[-3,-24],[-18,-18]],[[31397,38193],[-2,133]],[[21479,64015],[0,300]],[[21479,64315],[197,0]],[[21676,64315],[1,-404]],[[21677,63911],[-198,-2]],[[21479,63909],[0,106]],[[31360,38347],[12,18]],[[31372,38365],[3,-63]],[[31375,38302],[-16,-15]],[[31359,38287],[1,60]],[[20190,60480],[53,-5],[125,2]],[[20368,60477],[0,-51],[83,0]],[[20451,60426],[-3,-16],[9,-62],[-7,-49],[5,-78],[-6,-53],[3,-37],[-9,-72],[15,-53]],[[20458,60006],[-80,-1]],[[20378,60005],[-131,-2]],[[20247,60003],[-32,171],[-2,63],[-23,40],[0,203]],[[28085,63180],[68,0]],[[28153,63180],[175,-3]],[[28328,63177],[-11,-42],[5,-9],[-8,-42],[-14,-24],[-8,-92],[-7,-39],[2,-44],[-17,-169]],[[28270,62716],[-12,-3]],[[28258,62713],[-10,14],[6,63],[-5,43],[-9,12],[-3,54],[-8,15]],[[28229,62914],[0,41],[-10,-18],[-8,51],[16,15],[0,37],[-14,-4],[-17,23],[-18,-20],[-4,21]],[[28174,63060],[-21,68],[-24,20],[-23,-89],[-19,20]],[[28087,63079],[-2,46],[8,20],[-8,35]],[[22001,63504],[154,1]],[[22155,63505],[0,-506]],[[22155,62999],[-149,0]],[[22006,62999],[-5,-1]],[[22001,62998],[0,506]],[[25266,64221],[63,1],[-4,438]],[[25325,64660],[32,4]],[[25357,64664],[4,-593],[51,-3]],[[25412,64068],[1,-100]],[[25413,63968],[-147,-1]],[[25266,63967],[0,254]],[[21203,57896],[244,0]],[[21447,57896],[0,-508]],[[21447,57388],[-100,0]],[[21347,57388],[-144,0]],[[21203,57388],[0,241]],[[21203,57629],[0,267]],[[26389,54346],[0,38]],[[26389,54384],[69,-9],[0,83]],[[26458,54458],[13,-3],[0,-49],[14,7],[16,-24]],[[26501,54389],[-2,-21],[12,-67],[8,-75]],[[26519,54226],[11,-97],[0,-44]],[[26530,54085],[-116,8],[0,-50]],[[26414,54043],[-29,109]],[[26385,54152],[4,194]],[[25276,70164],[102,-11],[0,79]],[[25378,70232],[17,17],[9,-43],[24,-4],[9,-38]],[[25437,70164],[10,-13],[8,-44],[-12,-13],[14,-75],[-8,-69],[3,-47],[-6,-40],[-13,-34],[3,-38],[-7,-24],[7,-47]],[[25436,69720],[0,0]],[[25436,69720],[27,10],[16,47],[11,-25],[2,-34],[-11,-48],[-15,-118],[2,-29],[13,-28],[8,-47],[19,-14]],[[25508,69434],[-10,-58],[-1,-80],[-37,-13]],[[25460,69283],[1,29],[-51,3],[0,32],[-50,3],[1,101],[-20,2],[1,100],[-34,5],[1,201],[-34,3]],[[25275,69762],[1,402]],[[16021,59887],[4,21],[13,-15]],[[16038,59893],[6,-2],[20,100],[10,6],[10,-32],[56,0]],[[16140,59965],[-5,-40],[10,-14],[13,-57],[3,-34],[58,-98],[4,-14]],[[16223,59708],[88,-293],[2,-186],[-18,-15],[-5,-56]],[[16290,59158],[-19,50],[8,-59],[3,-65],[-15,-1],[-29,104],[-17,19],[-8,-39],[-9,20],[-7,-30]],[[16197,59157],[0,0]],[[16197,59157],[-7,9],[-1,41],[-10,51],[-43,144],[-3,33],[-20,-4],[5,31],[-9,30],[2,65],[-12,53],[-29,34],[-5,32],[9,12],[-7,46],[-12,10],[-21,77],[-7,10],[-6,56]],[[26268,55577],[3,37],[98,-2]],[[26369,55612],[1,-44]],[[26370,55568],[-6,-72],[-5,-131],[3,-45]],[[26362,55320],[0,-67],[5,-36]],[[26367,55217],[-17,-43],[-37,-1]],[[26313,55173],[-14,29],[-30,4]],[[26269,55206],[-1,113],[0,258]],[[24125,66578],[132,0]],[[24257,66578],[0,-202],[5,0],[0,-199]],[[24262,66177],[-65,0]],[[24197,66177],[-66,-1]],[[24131,66176],[0,201],[-6,0],[0,101]],[[24125,66478],[0,100]],[[23731,67292],[132,0]],[[23863,67292],[-1,-404]],[[23862,66888],[-131,-1]],[[23731,66887],[0,405]],[[23031,72773],[215,1],[0,-34]],[[22527,65226],[53,0],[0,17],[17,1],[0,17],[43,1],[16,17]],[[22656,65279],[35,1],[0,-154]],[[22691,65126],[-1,-99],[-53,-2],[0,-17],[-44,0],[-13,-34],[-49,0],[1,151],[-4,0]],[[22528,65125],[-1,0]],[[22527,65125],[0,101]],[[28588,64149],[27,-69]],[[28615,64080],[80,-210]],[[28695,63870],[-43,-70],[-36,-20],[-36,-48]],[[28580,63732],[-17,166],[-14,157],[39,94]],[[21322,56315],[148,-1]],[[21470,56314],[3,-506]],[[21473,55808],[-145,-2]],[[21328,55806],[-6,509]],[[22159,55304],[39,0]],[[22198,55304],[105,0]],[[22303,55304],[0,-515]],[[22303,54789],[-5,0]],[[22298,54789],[-139,0]],[[22159,54789],[0,515]],[[21698,53674],[112,7],[1,166],[10,-11]],[[21821,53836],[164,-3]],[[21985,53833],[1,-129],[34,-2]],[[22020,53702],[-1,-574]],[[22019,53128],[-160,-1]],[[21859,53127],[-1,509],[-160,5]],[[21698,53641],[0,33]],[[22631,55859],[120,0]],[[22751,55859],[29,-4]],[[22780,55855],[-3,-287],[-1,-224]],[[22776,55344],[-41,3]],[[22735,55347],[-105,9]],[[22630,55356],[1,503]],[[22784,68386],[67,1]],[[22851,68387],[67,0]],[[22918,68387],[0,-405]],[[22851,67982],[-67,1]],[[22784,67983],[0,403]],[[22142,69204],[28,-1]],[[22170,69203],[73,0]],[[22243,69203],[-1,-407],[4,0],[0,-410]],[[22246,68386],[-77,-3]],[[22169,68383],[-24,29]],[[22145,68412],[0,385],[-4,0]],[[22141,68797],[1,407]],[[21907,56884],[28,-1]],[[21935,56883],[117,-2]],[[22052,56881],[0,-102]],[[22052,56779],[-4,21],[-10,-14],[-1,-459]],[[22037,56327],[-131,0]],[[21906,56327],[1,557]],[[19139,53877],[0,-136],[-2,0],[-1,-168],[1,-160]],[[19137,53413],[-172,0],[-81,109]],[[18884,53522],[0,111],[57,0],[0,238],[86,1],[0,6],[112,-1]],[[24101,64854],[65,1]],[[24166,64855],[64,1]],[[24230,64856],[0,-306]],[[24230,64550],[-128,-1]],[[24102,64549],[-1,305]],[[24456,65668],[0,102]],[[24456,65770],[131,-2]],[[24587,65768],[0,-203]],[[24587,65565],[-1,-203]],[[24586,65362],[-130,1]],[[24456,65363],[0,305]],[[19834,71964],[0,0]],[[19834,71964],[-1,97],[14,61],[0,54]],[[19847,72176],[13,6],[0,67],[13,38],[15,2],[9,28],[10,67],[22,2],[2,19],[25,-6],[6,-22],[16,2],[7,77]],[[19985,72456],[37,-13],[9,-22],[38,9],[29,-7],[36,17],[5,69],[36,-3],[6,44],[16,21],[14,-6],[11,65],[15,44],[-6,29],[12,34],[-3,30],[15,28],[8,-29]],[[20263,72766],[16,-1],[1,-103],[27,0],[0,-395],[-11,0],[0,-204],[36,1],[0,-202],[23,0]],[[20355,71862],[0,-374]],[[20355,71488],[0,-16]],[[20355,71472],[-176,-1],[0,17],[-209,-1],[0,-9],[-118,0]],[[19852,71478],[-13,31],[8,106],[7,36],[-11,53],[-10,95],[9,47],[-11,99],[3,19]],[[23706,61217],[3,207]],[[23709,61424],[137,-15],[9,7]],[[23855,61416],[8,-10],[-2,-146]],[[23861,61260],[-2,-186],[-16,1],[-2,-101]],[[23841,60974],[-15,2]],[[23826,60976],[-51,6],[1,68],[-72,9]],[[23704,61059],[2,158]],[[25733,53023],[27,-3]],[[25760,53020],[83,-1]],[[25843,53019],[-2,-716]],[[25841,52303],[-66,20],[-46,-11]],[[25729,52312],[4,711]],[[25579,59593],[22,502]],[[25601,60095],[2,-37],[37,5],[18,18]],[[25658,60081],[-2,-486]],[[25656,59595],[-15,-1]],[[25641,59594],[-62,-1]],[[31021,70115],[-68,-47]],[[30953,70068],[-59,-41],[1,-8],[-43,-29],[-6,6],[2,341],[-3,200],[0,395],[-72,0],[0,15],[-35,1]],[[30738,70948],[0,205],[-251,2]],[[30487,71155],[-84,0]],[[30403,71155],[7,141],[215,890],[13,-3],[27,-38],[11,4],[-3,-58],[1,-141],[4,-18],[37,-73],[25,43],[26,30],[28,2],[11,52],[30,11],[25,-12],[0,62],[16,23],[25,-6],[23,-36],[4,-32],[33,-68],[36,-132],[0,-15],[28,-51],[0,-545],[3,-693],[-1,-71],[9,-30],[-15,-39],[14,-70],[-15,-34],[1,-133]],[[27922,63180],[33,0]],[[27955,63180],[119,0]],[[28074,63180],[11,0]],[[28087,63079],[-13,-8],[-1,-24],[-14,11],[11,-32],[-13,1],[7,-49],[-14,-38]],[[28050,62940],[-28,4],[-7,18],[-18,-1]],[[27997,62961],[-19,34],[-2,26],[-13,18],[13,14],[-13,10],[-38,-158],[-11,-54],[-31,40]],[[27883,62891],[39,289]],[[25139,54862],[147,1]],[[25286,54863],[-9,-314]],[[25277,54549],[-3,-94]],[[25274,54455],[-134,-4]],[[25140,54451],[-1,411]],[[22328,70417],[1,399]],[[22329,70816],[139,0],[131,0]],[[22599,70816],[7,0]],[[22606,70816],[0,-403]],[[22606,70413],[-113,0],[-87,3]],[[22406,70416],[-78,1]],[[23510,69703],[106,0],[0,-51],[34,1]],[[23650,69653],[1,-354]],[[23651,69299],[-68,0],[0,-101]],[[23583,69198],[-72,-1]],[[23511,69197],[-1,506]],[[21463,67449],[246,-1]],[[21709,67448],[0,-456]],[[21709,66992],[-111,-2],[-127,4]],[[21471,66994],[0,151],[-8,0],[0,304]],[[18808,64433],[8,14],[16,-36],[10,13],[0,32],[11,46],[-14,71],[1,40],[-15,5],[-4,41],[24,81],[17,22],[18,6],[4,50],[28,16]],[[18912,64834],[9,-1],[37,75],[15,52]],[[18973,64960],[0,-296],[93,-2],[133,-1],[52,3]],[[19251,64664],[14,0]],[[19265,64664],[0,-214]],[[19265,64450],[-28,-7],[-17,15],[-37,15],[-13,-12],[-9,-40],[-31,-11],[-11,-21],[-23,-5],[-5,14],[-9,-34],[-26,9],[-15,-41],[-25,16],[-2,-56]],[[19014,64292],[-9,3],[-12,-102],[-14,-18],[-15,20],[-11,-5],[-9,-49],[-32,45],[-17,42],[-11,7],[-8,72],[-22,-55],[-4,-52],[-18,12]],[[18832,64212],[-14,67],[3,37],[-16,87],[3,30]],[[28469,67010],[70,13]],[[28539,67023],[-7,-81],[6,-135],[-7,-57],[3,-89],[13,-50],[5,-55]],[[28552,66556],[13,-66],[9,-19],[-31,-4]],[[28543,66467],[-55,-6]],[[28488,66461],[0,142],[-11,61],[-3,57],[-7,-1]],[[28467,66720],[-3,108],[5,19],[0,163]],[[23020,61275],[46,-1],[0,101]],[[23066,61375],[111,-2]],[[23177,61373],[0,-152]],[[23177,61221],[-1,-356]],[[23176,60865],[0,-152]],[[23176,60713],[-157,4]],[[23019,60717],[1,558]],[[21859,61989],[123,-2]],[[21982,61987],[1,-507]],[[21983,61480],[-123,2]],[[21860,61482],[-1,507]],[[25940,67539],[1,405]],[[25941,67944],[132,0]],[[26073,67944],[0,-404]],[[26073,67540],[0,-203]],[[26073,67337],[-63,-1]],[[26010,67336],[-69,0],[-1,203]],[[22531,64315],[126,1]],[[22657,64316],[0,-405]],[[22657,63911],[-125,-1]],[[22532,63910],[-1,0]],[[22531,63910],[0,405]],[[28051,67427],[26,6],[38,-9],[36,8],[31,-12]],[[28182,67420],[-1,-270]],[[28181,67150],[-130,-5]],[[28051,67145],[0,282]],[[22527,73042],[108,0]],[[22635,73042],[0,-203],[6,0],[0,-405]],[[22641,72434],[-29,0]],[[22612,72434],[-143,0]],[[22469,72434],[-7,0],[0,202]],[[22462,72636],[0,80]],[[22462,72716],[0,124],[28,0],[1,202],[36,0]],[[22431,59038],[119,0]],[[22550,59038],[1,-377],[-1,-135]],[[22550,58526],[-29,0],[0,-202]],[[22521,58324],[-86,0]],[[22435,58324],[-3,0],[0,304]],[[22432,58628],[-1,101],[0,309]],[[22010,54799],[144,-3],[0,-7]],[[22154,54789],[0,-504]],[[22154,54285],[-23,1]],[[22131,54286],[-122,0]],[[22009,54286],[1,513]],[[21599,57895],[149,-1]],[[21748,57894],[-1,-505]],[[21747,57389],[-106,-1]],[[21641,57388],[-44,1]],[[21597,57389],[2,506]],[[21599,58911],[149,0]],[[21748,58911],[0,-501]],[[21748,58410],[-149,-1]],[[21599,58409],[0,502]],[[21859,53127],[-76,-5]],[[21783,53122],[-87,-4]],[[21696,53118],[2,523]],[[24949,68445],[104,-3]],[[25053,68442],[94,-1]],[[25147,68441],[0,-302]],[[25147,68139],[-78,0]],[[25069,68139],[-120,-1]],[[24949,68138],[0,307]],[[26290,59549],[2,0]],[[26292,59549],[65,-9],[79,-5]],[[26436,59535],[3,-67],[-10,-35],[-12,6],[-6,-50],[4,-91],[2,-120],[-13,-29],[1,-50]],[[26405,59099],[-9,-49],[-10,-13]],[[26386,59037],[-9,47],[-27,38],[-1,35],[-11,4],[-25,117]],[[26313,59278],[12,28],[-9,47],[-11,104]],[[26305,59457],[-15,92]],[[24405,70670],[87,1],[87,-4]],[[24579,70667],[0,-202],[69,1]],[[24648,70466],[0,-400]],[[24648,70066],[-240,-1]],[[24408,70065],[-1,402],[-2,1],[0,202]],[[26205,67942],[135,2]],[[26340,67944],[-1,-407]],[[26339,67537],[-66,0]],[[26273,67537],[-67,0]],[[26206,67537],[-1,405]],[[25021,52921],[56,0]],[[25077,52921],[71,1]],[[25148,52922],[0,-204]],[[25148,52718],[0,-68]],[[25148,52650],[-99,0],[-2,-34],[-27,0]],[[25020,52616],[1,55],[0,250]],[[24974,56707],[73,-1]],[[25047,56706],[1,-102],[29,1]],[[25062,56214],[0,-19],[-88,-1]],[[24974,56194],[0,170]],[[24974,56364],[0,343]],[[21815,65933],[161,-2]],[[21976,65931],[1,-403]],[[21977,65528],[-124,0]],[[21853,65528],[-37,1]],[[21816,65529],[-1,404]],[[21724,54800],[0,4]],[[21724,54804],[143,-2]],[[21867,54802],[-1,-512]],[[21866,54290],[-44,1]],[[21822,54291],[-101,1]],[[21721,54292],[3,508]],[[20140,64670],[150,-4]],[[20290,64666],[36,-2]],[[20326,64664],[1,-70],[14,-42],[3,-37],[22,-76],[28,-189],[10,-88],[1,-59],[11,6],[4,-40]],[[20420,64069],[-12,-20],[-1,-69],[-12,-29],[-4,-42],[-19,26],[-31,-47],[-8,14],[-18,-21],[-8,38],[-10,-2],[-1,-30],[-16,32],[-10,-14],[-18,15],[-10,58],[-11,-49],[-22,14],[-4,58],[-7,20]],[[20198,64021],[-1,75],[-13,77],[-1,47],[10,94],[-1,47],[10,88],[-15,86],[-12,-17],[-13,40],[-6,-11],[-13,32],[-7,53],[4,38]],[[24126,67577],[29,0]],[[24155,67577],[103,1]],[[24258,67578],[-1,-335]],[[24257,67243],[-132,0]],[[24125,67243],[1,334]],[[26754,67376],[4,0],[-4,405]],[[26754,67781],[143,18]],[[26897,67799],[2,-117],[17,-178],[4,-247],[6,-66]],[[26926,67191],[-138,-17]],[[26169,63944],[3,0],[2,219]],[[26174,64163],[37,1]],[[26211,64164],[74,5]],[[26285,64169],[0,-256]],[[26285,63913],[0,-49]],[[26285,63864],[-116,-4]],[[26169,63860],[0,84]],[[21488,73755],[0,223]],[[21488,73978],[146,1]],[[21634,73979],[0,-326],[13,0],[0,-202],[109,-1]],[[21756,73450],[0,-101]],[[21756,73349],[-218,1],[0,303],[-50,1],[0,101]],[[16297,70181],[17,11],[30,-61],[22,6],[34,26],[20,5],[11,42],[28,27],[20,32]],[[16479,70269],[-2,-344],[0,-302],[35,-1],[-1,-102],[35,0],[-1,-102],[-8,-16]],[[16537,69402],[-44,-2],[-152,2]],[[16341,69402],[-3,18]],[[16338,69420],[13,39],[-6,87],[-14,16],[-7,55],[8,175],[12,18],[-2,58],[12,19],[10,-18],[-2,36],[15,-5],[-12,74],[0,41],[-9,36],[-7,-7],[-6,39],[-17,20],[-29,78]],[[23550,59739],[153,-22]],[[23703,59717],[1,-11],[-3,-279]],[[23701,59427],[-151,1]],[[23550,59428],[0,196]],[[23550,59624],[0,115]],[[21199,55806],[129,0]],[[21328,55806],[0,-500]],[[21328,55306],[-131,1]],[[21197,55307],[2,350],[0,149]],[[21935,57388],[116,-1]],[[22051,57387],[1,-216]],[[22052,57171],[0,-290]],[[21935,56883],[0,505]],[[26257,56263],[7,-7],[43,16],[0,21]],[[26307,56293],[28,-2],[13,-71]],[[26348,56220],[-21,-70],[-1,-24],[-27,-38],[-16,-66]],[[26283,56022],[-27,0],[1,241]],[[4612,90593],[59,-1],[0,-100],[53,0],[0,-101],[53,0],[0,-101],[319,0]],[[5096,90290],[-24,-15],[0,-117],[-15,0],[0,-403],[-14,0],[0,-403],[36,0],[0,-303],[107,0]],[[5186,89049],[18,-89],[41,-27],[19,13],[18,-26],[-4,-29],[-41,10],[-31,-22],[-38,-46],[-49,-25],[-27,-29],[-44,-70],[-27,-63],[-90,-36],[-42,-41],[-27,-4],[-57,-58],[-31,-4],[-32,24],[-56,24],[-20,-22],[-21,6],[2,45],[-11,16],[-59,-23],[-10,7],[-30,-57],[-56,-16],[-30,-36],[-34,8],[-18,21],[-20,-14],[-16,-34],[5,-28],[-17,-9],[2,-54],[-37,-22],[-36,36],[-58,6],[-4,-57],[9,-23],[-2,-70],[16,6],[1,-44],[-27,-21],[-29,-76],[-22,28],[-8,-35],[5,-45],[18,-9],[-2,-61],[-24,-41],[-42,-17],[-38,-37],[-21,3],[-4,42],[-50,4],[-54,-40],[-3,18],[-35,-50]],[[3906,87856],[-19,62],[22,49],[27,-6],[19,23],[0,45],[-17,-21],[-30,32],[-16,54],[2,23],[-20,7],[-13,35],[-10,-14],[-12,-99],[-14,-6],[-38,16],[-10,21],[-10,66],[1,129],[-11,19],[-43,10],[-18,37],[-10,98],[42,44],[6,38],[-17,46],[-30,31],[-45,-27],[0,-46],[-21,23],[-9,88],[8,147],[6,11],[-2,-107],[92,47],[0,19],[-35,20],[-20,28],[-24,82],[2,18],[36,19],[55,-8],[33,25],[-29,134],[-4,46],[3,84],[21,77],[101,278],[4,29],[27,77],[29,61],[5,70],[18,67],[21,34],[19,-4],[9,23],[-11,115],[26,188],[18,70],[38,61],[-18,24],[4,22],[58,133],[60,46],[48,11],[42,-45],[43,-11],[32,-84],[24,-6],[6,-26],[54,-88],[73,24],[61,124],[4,47],[44,29],[19,49]],[[23781,65263],[97,-5],[8,-18],[24,-2]],[[23910,65238],[0,-384]],[[23910,64854],[-64,0]],[[23846,64854],[-65,1]],[[23781,64855],[0,408]],[[22435,57513],[147,0]],[[22582,57513],[1,-202]],[[22583,57311],[-14,0],[0,-203]],[[22569,57108],[-29,1],[0,-51],[-14,-17],[-59,0],[0,-33],[-29,0],[-14,-17]],[[22424,56991],[0,118],[-46,0],[0,101]],[[22378,57210],[0,304],[57,-1]],[[22051,58174],[118,-1],[0,102],[59,0]],[[22228,58275],[0,-51]],[[22228,58224],[1,-406]],[[22229,57818],[-13,-2]],[[22216,57816],[-9,-7],[-96,9],[0,-101],[-29,1]],[[22082,57718],[-31,0]],[[22051,57718],[0,177]],[[22051,57895],[0,279]],[[22246,68386],[104,2]],[[22350,68388],[0,-305]],[[22350,68083],[-120,-1]],[[22230,68082],[1,71],[-24,60],[-20,10],[-13,43],[5,68],[-10,49]],[[22245,52444],[95,-2]],[[22340,52442],[103,2]],[[22443,52444],[1,-420]],[[22444,52024],[-92,-1]],[[22352,52023],[-106,-5],[-1,178]],[[22245,52196],[0,248]],[[21761,56325],[145,2]],[[21906,56327],[1,-510]],[[21907,55817],[-145,0]],[[21762,55817],[-1,508]],[[22219,50280],[166,8]],[[22385,50288],[0,-1]],[[22385,50287],[0,-518],[-1,-168]],[[22384,49601],[-163,-32],[-1,203]],[[22220,49772],[-1,56],[0,452]],[[27676,62607],[35,46],[49,-63],[6,-25]],[[27766,62565],[5,-18],[45,36],[5,-24],[-12,-48],[-6,-72],[16,-15],[-12,-121],[-5,-6]],[[27802,62297],[-14,11],[-28,2],[-77,72],[3,46],[-14,45]],[[27672,62473],[-4,18],[8,116]],[[15783,64879],[293,1]],[[16076,64880],[32,1]],[[16108,64881],[0,-324],[3,0],[-2,-536]],[[16109,64021],[-47,0]],[[16062,64021],[-42,-12],[-11,21],[-13,-19],[-33,7],[-25,-32],[-19,13],[-23,-16]],[[15896,63983],[0,0]],[[15896,63983],[-12,-17],[-59,-31],[-32,5],[-17,17],[-37,-72],[-27,42],[-29,-25],[-5,6],[-12,-48],[-5,6]],[[15661,63866],[0,0]],[[15661,63866],[-14,0]],[[15647,63866],[0,0]],[[15647,63866],[-22,-29]],[[15625,63837],[-1,56],[13,38],[8,59],[26,33],[16,69],[12,7],[9,50],[19,19],[-3,65],[-12,69],[13,44],[-4,20],[17,51],[-2,48],[17,74],[1,95],[21,57],[4,77],[14,12],[4,72],[-14,27]],[[25197,61015],[0,51]],[[25197,61066],[93,1]],[[25290,61067],[0,-359]],[[25290,60708],[-11,1]],[[25279,60709],[-82,-1]],[[25197,60708],[0,307]],[[25886,68762],[116,-6]],[[26002,68756],[-1,-406]],[[26001,68350],[-62,3]],[[25939,68353],[-95,14]],[[25844,68367],[12,82],[21,112],[9,201]],[[22268,65933],[128,1]],[[22396,65934],[1,-405]],[[22397,65529],[-127,0]],[[22270,65529],[-2,0]],[[22268,65529],[0,404]],[[21981,65528],[69,-2],[88,2]],[[22138,65528],[130,1]],[[22270,65529],[0,-403],[3,-1]],[[22273,65125],[-1,-404]],[[22272,64721],[-61,0]],[[22211,64721],[-223,0]],[[21988,64721],[-3,0],[0,404],[-4,0]],[[21981,65125],[0,403]],[[22650,68386],[134,0]],[[22784,67983],[-67,0]],[[22717,67983],[-67,1]],[[22650,67984],[0,402]],[[22613,69501],[136,-2]],[[22749,69499],[1,-404]],[[22750,69095],[0,-303]],[[22750,68792],[-101,1]],[[22649,68793],[-1,101],[-34,0]],[[22614,68894],[1,304],[-2,0],[0,303]],[[24547,58095],[0,105]],[[24547,58200],[31,-3],[89,8],[0,-9],[30,1]],[[24697,58197],[-1,-307],[1,-40]],[[24697,57850],[-61,5],[-89,0]],[[24547,57855],[0,240]],[[19966,60502],[99,1]],[[20065,60503],[0,-36],[116,5],[0,9]],[[20181,60481],[9,-1]],[[20247,60003],[-110,-1],[-2,9],[-152,-1]],[[19983,60010],[-17,0]],[[19966,60010],[0,492]],[[27188,48409],[82,-1],[0,103],[28,1],[-1,102],[63,1]],[[27360,48615],[9,-42],[11,-23],[-4,-228]],[[27376,48322],[-16,-221],[-173,1]],[[27187,48102],[1,307]],[[22181,67577],[66,-1]],[[22247,67576],[-4,-36],[15,-36],[25,-3],[27,-133],[25,-72],[23,-14],[6,-23],[0,-55],[6,-29],[23,-10],[23,-81],[20,-3],[26,-40],[7,-48]],[[22469,66993],[-210,0]],[[22259,66993],[-78,0]],[[22181,66993],[0,584]],[[21599,59428],[150,0]],[[21749,59428],[-1,-515]],[[21748,58913],[0,-2]],[[21599,58911],[0,517]],[[15728,71772],[16,37],[0,33],[13,16],[8,79],[10,53],[-2,30],[25,-58],[10,25],[-10,14],[7,23]],[[15805,72024],[23,-73],[54,-1],[9,-56],[18,-43],[13,1],[17,-40],[9,18],[17,-12],[14,35],[30,-28],[7,12],[20,-46],[28,-5],[12,-36],[18,3]],[[16094,71753],[2,-36],[-9,-67],[-11,-22],[-3,-66],[-19,-59],[8,-12],[11,-92]],[[16073,71399],[-84,0],[-21,-62],[-27,12],[-7,17],[-24,-15],[-45,24]],[[15865,71375],[-19,5],[-10,26],[1,45],[-41,28],[-11,18],[-1,44],[-19,33],[-1,38],[-20,14],[-10,42],[-10,82],[4,22]],[[15698,72062],[0,59]],[[15698,72121],[71,0]],[[15769,72121],[3,-32],[-10,-57],[7,-49],[-15,-79],[-27,78],[8,96],[-16,-42],[-6,-63],[30,-83],[-10,-16],[1,-48],[-11,-26],[-16,46],[-20,105],[12,37],[-1,74]],[[26272,55950],[64,-1],[3,-10]],[[26339,55939],[-5,-74],[11,-94],[15,-26],[10,-91]],[[26370,55654],[-1,-42]],[[26268,55577],[0,38],[-21,1]],[[26247,55616],[-21,234]],[[26226,55850],[8,36],[13,-23],[8,37],[15,29],[2,21]],[[26638,56479],[10,25],[39,61]],[[26687,56565],[28,-48]],[[26715,56517],[-4,-66],[9,-44],[-10,-66]],[[26710,56341],[-13,8],[-27,84],[-24,5],[-8,41]],[[25882,63076],[83,6]],[[25965,63082],[-1,-297],[1,-42]],[[25965,62743],[-37,-4]],[[25928,62739],[-47,-3]],[[25881,62736],[1,340]],[[22783,61884],[123,0]],[[22906,61884],[0,-101],[31,0]],[[22937,61783],[0,-203],[-5,0],[-1,-306]],[[22931,61274],[-87,3]],[[22844,61277],[0,101],[-61,-1]],[[22783,61377],[0,507]],[[23858,70178],[104,-5]],[[23962,70173],[0,-200],[33,-1],[1,-170]],[[23996,69802],[-21,3],[-116,1]],[[23859,69806],[0,167]],[[23859,69973],[-1,205]],[[22525,66339],[129,1]],[[22654,66340],[0,-405]],[[22654,65935],[1,-202]],[[22655,65733],[-129,-1]],[[22526,65732],[0,194],[-2,8]],[[22524,65934],[1,405]],[[27018,64741],[1,85],[26,0],[1,73],[27,0],[1,88],[26,0]],[[27100,64987],[54,2]],[[27154,64989],[-1,-336]],[[27153,64653],[-123,4]],[[27030,64657],[-12,0],[0,84]],[[26061,58301],[14,2]],[[26075,58303],[27,16],[10,24]],[[26112,58343],[-3,-31],[9,-57],[24,-87],[25,-73]],[[26167,58095],[-5,-41],[-40,-200]],[[26122,57854],[-4,88],[-12,46],[-31,53],[-1,13]],[[26074,58054],[15,45],[6,56],[-14,30],[0,64],[-20,52]],[[21448,58404],[151,0]],[[21599,58404],[0,-509]],[[21599,57895],[-152,1]],[[21447,57896],[1,508]],[[22809,53352],[133,282]],[[22942,53634],[57,-351]],[[22999,53283],[-65,-134]],[[22934,53149],[0,6],[-67,-145]],[[22867,53010],[-58,342]],[[22612,72434],[1,-8],[-1,-395],[7,0],[0,-100]],[[22619,71931],[-141,0]],[[22478,71931],[0,100],[-9,0]],[[22469,72031],[0,304]],[[22469,72335],[0,99]],[[22519,67575],[57,0]],[[22576,67575],[1,-16],[1,-335]],[[22578,67224],[-159,205],[-8,-3],[1,150]],[[22479,53822],[86,184],[-15,88]],[[22550,54094],[57,117]],[[22607,54211],[66,-402]],[[22673,53809],[-115,-243]],[[22558,53566],[-25,-55]],[[22533,53511],[-54,311]],[[23846,64548],[128,0]],[[23974,64548],[0,-366]],[[23974,64182],[-77,-4]],[[23897,64178],[-51,0]],[[23846,64178],[0,370]],[[20924,71117],[68,-1],[0,104],[53,0]],[[21045,71220],[106,0]],[[21151,71220],[84,0]],[[21235,71220],[1,-405]],[[21236,70815],[-20,-1]],[[21216,70814],[-101,-1],[-191,0]],[[20924,70813],[0,304]],[[21985,54286],[24,0]],[[22131,54286],[-3,-589]],[[22128,53697],[-108,5]],[[21985,53833],[0,453]],[[18558,60011],[331,1]],[[18889,60012],[167,2]],[[19056,60014],[0,-3189]],[[19056,56825],[-11,53],[-16,-51],[-14,43],[-14,18],[-20,53],[-22,39],[-14,-25],[-1,22],[-16,17],[-11,52],[-17,-30],[-12,16],[-13,-15],[-5,-60],[-5,81],[-8,-43],[-24,11],[22,45],[-23,16]],[[18832,57067],[0,385],[-62,1],[0,207],[-9,-5],[-147,-4],[0,204],[-30,1],[1,130],[-9,-26],[-29,6],[-33,79],[-17,-6],[-11,19],[-42,35],[-8,47],[-31,70],[-17,29],[-8,33],[-24,27],[-20,-2]],[[17303,72077],[64,0],[0,17],[21,6],[0,-17],[30,0],[0,34],[12,17],[71,-1]],[[17501,72133],[0,-456]],[[17501,71677],[-35,0],[0,17],[-105,-5],[-17,53],[-14,-13],[-9,26],[3,30],[-20,14]],[[17304,71799],[-1,154]],[[17303,71953],[0,124]],[[22326,60558],[153,1]],[[22479,60559],[0,-101],[32,0]],[[22511,60458],[0,-450]],[[22511,60008],[-55,1]],[[22456,60009],[-127,1]],[[22329,60010],[0,448],[-3,0]],[[22326,60458],[0,100]],[[23039,67984],[108,-1]],[[23147,67983],[4,0]],[[23151,67983],[0,-406]],[[23151,67577],[-112,0]],[[30951,69617],[32,18],[-5,99],[-25,334]],[[31021,70115],[23,-21],[3,20],[10,-57],[19,-28],[30,-23],[14,19],[8,-62],[1,-56],[-13,8],[-11,-22],[7,-68],[16,-63],[-9,-73],[-10,-41],[23,-116],[0,-23],[18,-40],[13,28],[1,46],[18,-30],[19,-3],[13,-56],[6,-51],[-8,-14],[10,-32],[12,-98],[15,-38],[1,-118],[-12,-50],[-10,2],[-4,-32],[-32,-113],[-24,-25],[4,-22],[-15,-8],[6,42],[-4,85],[-27,-30],[12,-58],[-12,-43],[-11,13],[-13,-58],[-13,18],[-10,-12],[2,-35],[16,-40],[-22,-57],[-13,46],[-6,57],[-13,-10],[-3,-38],[-8,3],[-7,59],[-7,-62],[-9,-14],[-8,-74],[-7,19],[-6,-48],[-4,42],[-12,-18]],[[30978,68642],[-7,68],[-9,135],[6,3],[-6,99],[-5,-3],[-20,308],[34,20],[-11,218],[-9,127]],[[18872,73071],[38,0],[0,808],[1,97]],[[18911,73976],[147,2]],[[19058,73978],[0,-99],[-4,-808]],[[19054,73071],[-20,0],[0,-101],[-162,-1]],[[18872,72969],[0,102]],[[22614,70412],[209,0]],[[22823,70412],[0,-439]],[[22823,69973],[-38,0],[-2,34],[-169,1]],[[22614,70008],[0,404]],[[28354,67318],[31,0],[43,12],[21,-19],[23,-1],[14,25],[30,20],[20,40]],[[28536,67395],[6,-307],[-3,-65]],[[28469,67010],[-47,-1],[-1,32],[-66,-6]],[[28355,67035],[-1,283]],[[6173,85487],[189,0],[0,-313],[-263,0]],[[6099,85174],[50,106],[4,57],[19,93],[1,57]],[[27050,48612],[0,152]],[[27050,48764],[137,2]],[[27187,48766],[1,-357]],[[27188,48409],[-117,2],[-21,-4]],[[27050,48407],[0,205]],[[26217,56630],[1,137],[5,0],[1,155],[5,0],[-1,53]],[[26228,56975],[15,-10],[0,18],[61,-3],[0,19],[23,0]],[[26327,56999],[0,-216],[-2,-29],[0,-145]],[[26325,56609],[-22,2]],[[26303,56611],[-51,3]],[[26252,56614],[-35,1],[0,15]],[[23937,66074],[64,0]],[[24001,66074],[65,1]],[[24066,66075],[0,-404]],[[24066,65671],[-129,0]],[[23937,65671],[0,403]],[[22171,61073],[0,203]],[[22171,61276],[61,0],[0,-101],[91,0]],[[22323,61175],[0,-204],[3,0]],[[22326,60971],[0,-107]],[[22326,60864],[-152,2]],[[22174,60866],[-3,207]],[[26405,68749],[135,2]],[[26540,68751],[1,-404]],[[26541,68347],[-79,0]],[[26462,68347],[-56,-1]],[[26406,68346],[-1,403]],[[22401,65126],[126,-1]],[[22528,65125],[0,-404]],[[22528,64721],[-121,0]],[[22407,64721],[-7,0]],[[22400,64721],[1,405]],[[26542,64862],[128,-1]],[[26670,64861],[0,-204]],[[26670,64657],[-10,0],[0,-50],[-6,0],[0,-51],[-10,0],[0,-101]],[[26644,64455],[-102,2]],[[26542,64457],[0,117]],[[26542,64574],[0,288]],[[26302,61585],[33,91],[12,49]],[[26347,61725],[6,23]],[[26353,61748],[9,-69],[19,-70],[7,-86],[-3,-19]],[[26385,61504],[12,-88]],[[26397,61416],[-61,-91],[-2,-15]],[[26334,61310],[-7,33],[1,37],[-16,-4],[-5,26]],[[26307,61402],[-5,183]],[[26112,58343],[44,179],[3,52]],[[26159,58574],[60,7],[3,-30],[28,26],[3,-8]],[[26253,58569],[-36,-167],[-17,-55],[2,-43],[-13,-50],[9,-18],[-6,-20]],[[26192,58216],[-9,-3],[-16,-118]],[[27615,59478],[88,-1]],[[27703,59477],[56,-1]],[[27759,59476],[-5,-339]],[[27754,59137],[-1,-10]],[[27753,59127],[-140,19]],[[27613,59146],[2,332]],[[21469,56883],[25,0]],[[21494,56883],[121,-1]],[[21615,56882],[0,-561]],[[21615,56321],[-145,-7]],[[21470,56314],[-1,569]],[[27916,61255],[12,36],[11,-5],[-2,-64],[-14,-11],[-7,44]],[[19952,67578],[118,-1]],[[20070,67577],[0,-9],[185,0],[103,2]],[[20358,67570],[1,-25],[0,-808],[-1,-1],[0,-401]],[[20358,66335],[-153,-3],[-250,4]],[[19955,66336],[-5,0],[-1,405],[12,-1],[0,404],[-4,0],[0,401],[-5,33]],[[23353,52863],[4,44],[17,10],[2,-46],[12,-49]],[[23388,52822],[19,-50],[-4,-79],[10,-25],[2,-40],[14,26],[13,-86],[-6,-32],[18,-3],[36,-53],[-9,-23],[5,-20]],[[23486,52437],[2,-8],[-90,-165]],[[23398,52264],[-17,-30],[6,33],[-9,36],[-22,39],[-12,107]],[[25053,68952],[173,-3],[-1,-103]],[[25225,68846],[-36,0],[-1,-404]],[[25188,68442],[-41,-1]],[[25053,68442],[0,510]],[[27250,63752],[1,105],[17,-1],[1,151]],[[27269,64007],[92,-10]],[[27361,63997],[21,-2],[-5,-307]],[[27377,63688],[-94,16],[-1,-3]],[[27282,63701],[-32,2],[0,49]],[[26265,52709],[7,52],[17,34],[9,109],[1,170],[6,33]],[[26305,53107],[24,-2],[0,14],[28,-1]],[[26357,53118],[10,-1]],[[26367,53117],[37,1]],[[26404,53118],[-1,-453]],[[26403,52665],[-135,25]],[[26268,52690],[-3,19]],[[24104,52422],[38,-1]],[[24142,52421],[70,0],[0,-51],[19,1],[0,-102],[9,-59]],[[24240,52210],[-9,-34],[0,-33],[-21,-44],[1,-21],[-11,-44]],[[24200,52034],[-25,-95],[-13,-20],[-23,35],[-14,43],[-19,-28]],[[24106,51969],[-1,49],[10,56],[-10,56],[2,128],[-3,45],[10,48],[-10,71]],[[23719,69298],[68,-1]],[[23787,69297],[0,-101],[68,1],[1,-102]],[[23856,69095],[-22,-25],[-9,-52],[4,-35],[-14,-15],[-8,-30],[-20,-34]],[[23787,68904],[0,39],[-33,0],[0,51],[-34,0]],[[23720,68994],[-1,304]],[[25198,61320],[1,153]],[[25199,61473],[92,-1]],[[25291,61472],[-1,-404]],[[25290,61068],[0,-1]],[[25197,61066],[1,254]],[[23373,69803],[34,0]],[[23407,69803],[103,1],[0,-101]],[[23511,69197],[-136,-1]],[[23375,69196],[0,304]],[[23375,69500],[-2,101],[0,202]],[[25382,68439],[43,0],[1,101],[33,0]],[[25459,68540],[63,0]],[[25522,68540],[0,-40],[8,-61],[-2,-71],[-12,-41],[-23,-46],[-3,-62],[-8,-37],[-13,-149]],[[25469,68033],[-86,0]],[[25383,68033],[-1,102],[0,304]],[[25713,54146],[114,3]],[[25827,54149],[0,-307],[-1,-53],[-14,0],[0,-151]],[[25812,53638],[-56,-2]],[[25756,53636],[-38,1],[-8,25],[-11,100],[0,141]],[[25699,53903],[0,90]],[[25699,53993],[-1,153],[15,0]],[[26560,55508],[75,46]],[[26635,55554],[33,16]],[[26668,55570],[4,-93],[16,-209]],[[26688,55268],[-14,-32]],[[26674,55236],[-30,-62]],[[26644,55174],[-24,50],[-16,0],[-11,33],[-4,42]],[[26589,55299],[-10,129],[-19,80]],[[23862,66888],[132,-1]],[[23994,66887],[0,-408]],[[23994,66479],[-132,1]],[[23862,66480],[0,408]],[[26048,65276],[128,3]],[[26176,65279],[1,-305]],[[26177,64974],[-33,0]],[[26144,64974],[-64,3],[1,33],[-33,0]],[[26048,65010],[0,165]],[[26048,65175],[0,101]],[[21664,63000],[181,0]],[[21845,63000],[5,0]],[[21850,63000],[0,-506]],[[21850,62494],[-25,0]],[[21825,62494],[-162,2]],[[21663,62496],[1,504]],[[26206,68350],[65,-3]],[[26271,68347],[68,-1]],[[26339,68346],[1,-402]],[[26205,67942],[1,408]],[[26273,69158],[132,-4]],[[26405,69154],[0,-405]],[[26405,68749],[-28,4],[-105,1]],[[26272,68754],[1,404]],[[23981,60494],[0,84],[61,-4]],[[24042,60574],[46,-3]],[[24088,60571],[-1,-254],[4,0],[-2,-229]],[[24089,60088],[-61,5]],[[24028,60093],[0,17],[-45,4]],[[23983,60114],[1,211],[-4,0],[1,169]],[[21498,65531],[156,1]],[[21654,65532],[5,0]],[[21659,65532],[0,-405]],[[21659,65127],[-161,-1]],[[21498,65126],[0,405]],[[22656,64869],[17,71],[30,82],[17,14],[0,18]],[[22720,65054],[21,34],[20,8],[23,32]],[[22784,65128],[0,-407]],[[22784,64721],[-127,0]],[[22657,64721],[-1,148]],[[22749,69499],[75,1]],[[22824,69500],[95,-2],[1,-202]],[[22920,69296],[-1,-201]],[[22919,69095],[-169,0]],[[22384,49601],[131,0]],[[22515,49601],[28,0]],[[22543,49601],[0,-926]],[[22462,48678],[1,91],[-19,18],[-58,-5]],[[22386,48782],[-2,819]],[[21448,58911],[151,0]],[[21599,58409],[0,-5]],[[21448,58404],[0,9]],[[21448,58413],[0,498]],[[21435,54799],[2,0]],[[21437,54799],[143,3]],[[21580,54802],[-1,-510]],[[21579,54292],[-23,-1]],[[21556,54291],[-121,0]],[[21435,54291],[0,508]],[[26858,63910],[28,-6],[1,239],[5,0]],[[26892,64143],[69,1],[11,5]],[[26972,64149],[33,15]],[[27005,64164],[11,6],[-2,-136]],[[27014,64034],[-3,-253]],[[27011,63781],[-78,8],[0,22],[-76,14]],[[26857,63825],[1,85]],[[31366,38241],[0,-65],[9,-49],[-3,-44]],[[31372,38083],[-1,-12]],[[31371,38071],[-1,-1]],[[31370,38070],[-11,24],[-16,-16]],[[31343,38078],[6,102],[6,-9],[2,53],[9,17]],[[22906,53851],[59,124]],[[22965,53975],[62,-22]],[[23027,53953],[72,-446]],[[23099,53507],[-24,-46],[1,-19]],[[23076,53442],[-77,-159]],[[22942,53634],[-36,217]],[[24389,66580],[132,3]],[[24521,66583],[1,-408]],[[24522,66175],[-65,1]],[[24457,66176],[-65,0]],[[24392,66176],[0,201],[-3,0],[0,203]],[[22784,64721],[128,-1]],[[22912,64720],[0,-405],[-1,0]],[[22911,64315],[-127,1]],[[22784,64316],[0,405]],[[22020,50798],[194,6]],[[22214,50804],[2,-524]],[[22216,50280],[-197,8]],[[22019,50288],[1,510]],[[16198,63083],[16,37],[5,81],[17,41],[16,-38],[7,-39],[10,11],[20,-48],[12,33],[137,1]],[[16438,63162],[36,2],[4,16]],[[16478,63180],[0,-323]],[[16478,62857],[-139,1],[-9,20],[-6,59],[-9,11],[-25,-6],[-18,-66],[-16,-28],[-16,-4]],[[16240,62844],[0,0]],[[16240,62844],[-6,-5]],[[16234,62839],[0,0]],[[16234,62839],[-33,-20],[-7,-25]],[[16194,62794],[-3,143],[-7,27],[9,25],[5,94]],[[25004,66413],[10,0]],[[25014,66413],[118,-6]],[[25132,66407],[0,-399]],[[25132,66008],[-65,-2],[0,63],[-62,-3]],[[25005,66066],[-1,347]],[[30134,67917],[8,-8],[20,25],[29,9]],[[30191,67943],[5,-26],[19,15],[12,-20],[3,-38],[-4,-63],[22,-16],[9,30],[25,-82],[-10,-42],[39,-83]],[[30311,67618],[-9,-45],[6,-67],[-8,-43],[-10,-15],[3,-33],[-14,-24],[-14,4],[-10,-25],[-11,-98],[5,-19],[-14,-80],[1,-22],[-14,-74],[-9,-13]],[[30213,67064],[-32,74]],[[30181,67138],[-3,76],[6,42],[-41,128],[-9,53],[8,101],[-1,87]],[[30141,67625],[-3,34],[-4,258]],[[28752,62244],[2,67],[14,49],[12,62],[3,43],[25,40]],[[28808,62505],[7,-364]],[[28815,62141],[4,-227]],[[28819,61914],[-15,59],[-10,-11],[-11,32],[-30,-35]],[[28753,61959],[-20,64],[14,59],[19,38],[-14,84],[0,40]],[[26407,69554],[33,0]],[[26440,69554],[102,4]],[[26542,69558],[0,-199],[-3,-1],[1,-202]],[[26540,69156],[-135,-2]],[[26405,69154],[2,400]],[[22945,71224],[2,-4]],[[22947,71220],[9,-55],[4,-119],[5,-49],[20,-98],[13,-27],[1,-129],[11,-188],[-5,-43]],[[23005,70512],[3,-100]],[[23008,70412],[-185,0]],[[22823,70412],[0,66],[-9,6],[1,332],[-6,0]],[[22809,70816],[0,404]],[[27478,64246],[0,248]],[[27478,64494],[101,4]],[[27579,64498],[3,-210]],[[27582,64288],[1,-71],[-10,-5],[-50,-153]],[[27523,64059],[-45,-1]],[[27478,64058],[0,188]],[[21199,55806],[1,212]],[[21200,56018],[2,296]],[[21202,56314],[120,1]],[[26339,68346],[67,0]],[[26462,68347],[0,-192]],[[26462,68155],[0,-199]],[[26462,67956],[-55,3],[-1,-17],[-66,2]],[[21018,63200],[1,304]],[[21019,63504],[65,0],[0,406],[1,101]],[[21085,64011],[22,-1],[169,3]],[[21276,64013],[0,-102],[-3,1],[0,-406],[-3,0],[0,-506]],[[21270,63000],[-98,-3]],[[21172,62997],[-154,1]],[[21018,62998],[0,202]],[[24257,66578],[132,2]],[[24392,66176],[-65,3]],[[24327,66179],[-65,-2]],[[23599,66582],[131,-1]],[[23730,66581],[1,-101]],[[23731,66480],[-1,-100],[12,0],[0,-305]],[[23742,66075],[-65,0]],[[23677,66075],[-65,-1]],[[23612,66074],[0,308],[-13,0],[0,99]],[[23599,66481],[0,101]],[[21988,61074],[183,-1]],[[22174,60866],[1,-311]],[[22175,60555],[-61,0],[-93,8]],[[22021,60563],[-30,1]],[[21991,60564],[0,409],[-3,0],[0,101]],[[26540,69156],[0,-405]],[[25027,55275],[84,-1],[24,-14],[4,9]],[[25139,55269],[0,-407]],[[25139,54862],[-112,-1]],[[25027,54861],[0,414]],[[22150,64300],[17,-9],[39,1],[7,-8]],[[22213,64284],[24,0],[24,-14],[19,2]],[[22280,64272],[0,-361]],[[22280,63911],[-126,0]],[[22154,63911],[-3,0]],[[22151,63911],[-1,389]],[[22881,65936],[55,0]],[[22936,65936],[75,-1],[0,-86]],[[23011,65849],[0,-319]],[[23011,65530],[-98,1]],[[22913,65531],[-32,1]],[[22881,65532],[0,404]],[[26906,57850],[32,40],[7,-9],[12,52],[10,-27]],[[26967,57906],[39,5]],[[27006,57911],[-3,-403],[22,-75]],[[27025,57433],[-25,-231],[0,-60],[-22,-60]],[[26978,57082],[-28,80],[-3,51],[-8,33],[-3,93],[4,83],[-10,50]],[[26930,57472],[-2,88],[-6,36],[-6,105],[-16,-9],[-1,38],[8,39],[-20,-17],[-10,6],[-20,-20],[-4,24]],[[26853,57762],[30,59],[23,29]],[[21868,55312],[38,-1]],[[21906,55311],[105,-3]],[[22011,55308],[-1,-509]],[[22010,54799],[-143,3]],[[21867,54802],[1,510]],[[28042,59050],[21,-12],[12,82],[11,-1],[9,37]],[[28095,59156],[37,-12],[11,-11],[9,-43],[16,7],[10,-15]],[[28178,59082],[-69,-447]],[[28109,58635],[-14,91],[-13,17],[0,23],[-12,7],[-9,44],[-33,55]],[[28028,58872],[1,68],[13,110]],[[26285,65163],[128,1]],[[26413,65164],[32,1],[0,-305]],[[26445,64860],[-32,-1]],[[26413,64859],[0,51],[-32,0],[0,52],[-96,-1]],[[26285,64961],[0,21]],[[26285,64982],[0,181]],[[25615,58187],[13,2],[9,24],[27,-28],[11,-28],[9,11]],[[25684,58168],[10,-17],[5,-103],[13,-18],[4,26],[5,-67]],[[25721,57989],[-3,-316]],[[25718,57673],[-104,8]],[[25614,57681],[-4,1]],[[25610,57682],[3,144],[5,46],[-7,12],[2,63],[0,179],[2,61]],[[22197,56325],[146,0]],[[22343,56325],[-1,-508]],[[22342,55817],[-144,2]],[[22198,55819],[-1,389]],[[22197,56208],[0,117]],[[23586,54649],[14,-37],[16,5],[9,-47],[86,77]],[[23711,54647],[0,-229]],[[23711,54418],[0,-237],[8,-12]],[[23719,54169],[-1,-2],[-138,-7]],[[23580,54160],[-25,-1],[0,124],[6,93],[0,50],[6,54],[8,27],[10,98],[1,44]],[[16763,71956],[284,-2]],[[17047,71954],[-3,-457],[-9,-22],[-3,-74],[-9,-20],[-14,13],[-18,-37],[-14,-10]],[[16977,71347],[-65,-2],[-257,1]],[[16655,71346],[0,203],[107,-1],[1,408]],[[23742,66075],[65,-1]],[[23807,66074],[0,-402]],[[23807,65672],[-33,0]],[[23774,65672],[-97,0]],[[23677,65672],[0,403]],[[22491,55815],[0,83]],[[22491,55898],[123,0]],[[22614,55898],[0,-39],[17,0]],[[22630,55356],[-37,2]],[[22593,55358],[-104,5]],[[22489,55363],[2,452]],[[31436,38070],[20,33]],[[31456,38103],[7,-43]],[[31463,38060],[-2,-56]],[[31461,38004],[-9,-22]],[[31452,37982],[-18,58],[2,30]],[[22937,61783],[130,-1]],[[23067,61782],[-1,-407]],[[23020,61275],[-89,-1]],[[22673,53809],[22,45],[23,-144]],[[22718,53710],[52,-311]],[[22770,53399],[-136,-292]],[[22634,53107],[-76,459]],[[26275,67133],[131,-1]],[[26406,67132],[1,-398]],[[26407,66734],[0,-7],[-66,0]],[[26341,66727],[-66,1]],[[26275,66728],[0,405]],[[23177,61221],[122,-2]],[[23299,61219],[-1,-356]],[[23298,60863],[-122,2]],[[25132,66008],[66,2]],[[25198,66010],[32,0]],[[25230,66010],[0,-102],[-3,0],[0,-404]],[[25227,65504],[-1,-102]],[[25226,65402],[-93,-4]],[[25133,65398],[-1,307]],[[25132,65705],[1,201],[-1,102]],[[23591,64550],[127,-3]],[[23718,64547],[0,-376]],[[23718,64171],[-60,-3]],[[23658,64168],[-67,-1]],[[23591,64167],[0,383]],[[23289,65672],[129,0]],[[23418,65672],[0,-304],[15,0],[0,-114]],[[23433,65254],[-32,1]],[[23401,65255],[-96,1]],[[23305,65256],[0,112],[-17,0],[1,304]],[[16328,60062],[9,-43],[16,-112],[-1,-56],[24,-61],[0,-30],[39,-18],[42,65],[14,-12],[12,30],[12,-8],[16,29],[20,-10],[6,53],[16,59],[-2,28],[11,40],[9,5],[5,38],[9,-17],[4,51],[12,-5],[7,45],[-8,12],[4,34],[7,-19],[10,12],[2,-33],[15,62],[12,-16],[16,69],[-2,121],[6,45],[81,272]],[[16751,60692],[13,-33],[17,-8],[18,-87],[15,15],[6,-30]],[[16820,60549],[4,-32],[-7,-57],[2,-59],[24,-41],[7,-50],[-5,-32],[11,-105],[14,-2],[18,-32],[26,-65],[5,-73],[15,-113],[0,-64],[-7,-8],[9,-103]],[[16936,59713],[-174,-3],[0,-99],[-89,4],[-1,-101],[-44,2],[-30,-101]],[[16598,59415],[-26,-81],[-2,14],[-21,-17],[-2,-17],[-57,-1],[0,-255],[-99,-320]],[[16391,58738],[-12,66],[-21,6],[-13,48],[-17,31],[-14,41],[-3,35],[-13,7],[-6,66],[12,45],[-15,56],[1,19]],[[16223,59708],[73,248],[18,-1],[-2,54],[16,53]],[[23591,64850],[64,0]],[[23655,64850],[64,-1]],[[23719,64849],[-1,-302]],[[23591,64550],[0,300]],[[24938,64840],[48,0]],[[24986,64840],[38,-1],[-8,-52],[54,1]],[[25070,64788],[32,1],[0,-209]],[[25102,64580],[-26,2],[-92,-7]],[[24984,64575],[7,61],[-53,0]],[[24938,64636],[0,204]],[[25187,63567],[0,51],[16,0],[0,50],[31,162]],[[25234,63830],[32,1]],[[25266,63831],[-1,-68],[0,-401]],[[25265,63362],[0,-102],[-3,0]],[[25262,63260],[-76,1]],[[25186,63261],[1,306]],[[23464,64851],[63,0]],[[23527,64851],[64,-1]],[[23591,64550],[-127,1]],[[23464,64551],[0,300]],[[25322,62161],[87,3]],[[25409,62164],[11,0]],[[25420,62164],[-1,-326]],[[25419,61838],[-12,0]],[[25407,61838],[-54,-1]],[[25353,61837],[0,34],[-29,1]],[[25324,61872],[-13,41],[7,33],[-3,80],[7,0],[0,135]],[[25160,58180],[7,0],[39,72],[17,93],[0,22]],[[25223,58367],[14,-1],[5,-45],[11,-43],[26,-34],[14,12],[1,-86]],[[25294,58170],[-1,-44]],[[25293,58126],[-57,1],[-20,-24],[-7,-49],[-7,-11],[-8,-73],[-18,1]],[[25176,57971],[-3,95],[-13,64],[0,50]],[[26148,65914],[130,1]],[[26278,65915],[1,-364]],[[26279,65551],[-104,0]],[[26175,65551],[-26,0]],[[26149,65551],[-1,363]],[[27610,58754],[141,-24]],[[27751,58730],[0,-66]],[[27751,58664],[-4,-382]],[[27747,58282],[-59,-4]],[[27688,58278],[-84,-7]],[[27604,58271],[6,483]],[[21481,62494],[158,1]],[[21639,62495],[-2,-505]],[[21637,61990],[-23,-1]],[[21614,61989],[-133,-2]],[[21481,61987],[0,406]],[[21481,62393],[0,101]],[[26174,63508],[109,1]],[[26283,63509],[-1,-103]],[[26282,63406],[0,-222]],[[26282,63184],[-62,3],[0,-16]],[[26220,63171],[-42,0],[1,85],[-11,0]],[[26168,63256],[1,99],[5,1],[0,152]],[[28304,59677],[10,-1],[3,-35],[-13,-9],[0,45]],[[21899,59428],[151,0]],[[22050,59428],[1,0],[0,-517]],[[22051,58911],[-151,1]],[[21900,58912],[-1,0]],[[21899,58912],[0,516]],[[25873,59251],[3,13],[1,110],[8,-2],[3,42]],[[25888,59414],[10,-6],[7,-44],[52,-22]],[[25957,59342],[-1,-35],[-15,-16],[-12,-31],[-16,-69]],[[25913,59191],[-19,54],[-11,-7],[-1,-36],[-9,49]],[[19085,60640],[9,28],[3,43],[11,38],[18,28],[4,54],[15,77],[-9,1],[-4,34],[12,15],[9,78],[28,10],[5,-27],[4,37],[14,-6],[4,54],[20,78],[16,-6],[3,47],[13,75],[8,-7],[17,60]],[[19285,61351],[12,42],[-10,43],[9,8],[-11,33],[-1,28],[-15,86],[2,36],[-10,-28],[-5,24],[8,36],[0,75],[-6,23]],[[19258,61757],[153,-1],[116,1]],[[19527,61757],[0,-262],[5,-142]],[[19532,61353],[0,-317]],[[19532,61036],[0,-408],[-1,-53]],[[19531,60575],[0,-566]],[[19531,60009],[-162,-1],[-104,0]],[[19265,60008],[-131,0],[-6,7],[-72,-1]],[[18889,60012],[18,42],[-5,34],[18,-50],[-1,47],[7,-8],[10,49],[10,-12],[45,29],[8,41],[14,30],[5,89],[7,9],[-1,37],[7,33],[-8,35],[17,-31],[13,12],[10,39],[-8,36],[15,37],[-11,19],[6,42],[15,-4],[5,73]],[[24037,65259],[32,0]],[[24069,65259],[96,1]],[[24165,65260],[1,-405]],[[24101,64854],[-64,0]],[[24037,64854],[0,405]],[[17306,73978],[171,1],[103,1]],[[17580,73980],[0,-580]],[[17580,73400],[-205,-2],[-1,404],[-68,-1]],[[17306,73801],[0,177]],[[24948,63875],[94,6]],[[25042,63881],[0,-51],[32,1]],[[25074,63831],[1,-272]],[[25075,63559],[1,-152],[-21,-1]],[[25055,63406],[-52,1],[0,17],[-22,1],[0,51],[-26,-1]],[[24955,63475],[-1,135],[-6,35]],[[24948,63645],[0,230]],[[23304,62035],[124,-1]],[[23428,62034],[-2,-51],[0,-355]],[[23426,61628],[-124,1]],[[23302,61629],[0,51]],[[23302,61680],[0,304],[2,51]],[[23897,54668],[38,-1],[0,52],[25,1],[-7,83],[-2,68]],[[23951,54871],[83,0]],[[24034,54871],[1,-152],[28,-1]],[[24063,54718],[1,-253],[-7,-30],[-4,-74]],[[24053,54361],[-35,1]],[[24018,54362],[-69,1]],[[23949,54363],[-7,51],[0,51],[-60,0]],[[23882,54465],[6,56],[-6,29],[7,69],[-6,34],[14,15]],[[16193,61766],[24,24],[4,-16],[23,47],[22,-2],[38,-58],[28,7],[42,41],[18,1],[22,58],[6,39],[21,17],[4,62],[14,7]],[[16459,61993],[0,-225]],[[16459,61768],[-23,-18],[-13,7],[-22,-29],[-29,-16],[-9,14],[-12,-31],[-11,1],[-8,-29],[-24,-38],[-5,-52],[-49,-68],[-25,-77],[-28,5]],[[16201,61437],[-8,87]],[[16193,61524],[0,242]],[[16478,62417],[1,-79],[26,-77]],[[16505,62261],[8,-74],[-24,-109],[-30,-85]],[[16193,61766],[-26,243],[-6,-6]],[[16161,62003],[11,86],[0,35],[11,35],[6,81],[28,24],[0,31],[23,-12],[13,56],[23,4],[24,-69],[19,-35],[17,19],[12,40],[10,74],[54,-6],[16,9],[11,42],[39,0]],[[24236,59150],[130,-9]],[[24366,59141],[5,-52],[-2,-51],[-1,-191],[-7,0],[-1,-68]],[[24360,58779],[-11,1],[-27,-88]],[[24322,58692],[-13,18],[-16,57],[-15,-14],[-11,28],[-9,-19],[-10,11],[8,34],[-4,46],[12,34],[-16,35],[-7,55],[-14,-8],[-2,32]],[[24225,59001],[-5,49],[15,-1],[1,101]],[[27795,60874],[14,21],[2,-19],[-13,-56],[-3,54]],[[27806,59476],[-35,0]],[[27771,59476],[3,42],[-17,31],[5,17],[22,-20],[7,50],[9,-42],[9,-7],[8,-37],[-9,2],[-2,-36]],[[27363,59628],[4,26],[11,-1],[-10,-50]],[[27368,59603],[-5,25]],[[27925,61684],[13,49],[10,-31],[2,-38],[-15,-10],[-9,-25],[-1,55]],[[27650,59643],[6,32],[12,-9],[2,-67],[-8,4],[-12,40]],[[25821,64866],[109,2]],[[25930,64868],[0,-103],[16,2],[0,-52],[21,2]],[[25967,64717],[-1,-51]],[[25966,64666],[-61,-4],[-1,-100]],[[25904,64562],[-83,0]],[[25821,64562],[0,304]],[[23527,65254],[128,-1]],[[23655,65253],[0,-403]],[[23527,64851],[1,201],[-1,202]],[[15974,59837],[7,40],[24,40],[16,-30]],[[16391,58738],[11,-1],[10,-47],[-5,-24],[10,-30],[2,-35]],[[16419,58601],[-251,5],[-64,2]],[[16104,58608],[-19,70],[-14,35],[-6,99],[-5,35],[-20,29],[-15,104],[-25,94],[-33,64],[-11,45],[-8,80],[1,42],[-11,101],[2,92],[-11,16],[10,74],[18,-38],[9,30],[7,61],[8,141],[-7,55]],[[24485,62330],[21,-1],[0,-69],[22,-1],[-1,-69],[43,-2]],[[24570,62188],[-2,-376]],[[24568,61812],[-12,17],[-13,54],[-22,-12],[-26,27],[0,25],[-25,76],[-14,-10]],[[24456,61989],[-14,12]],[[24442,62001],[1,157],[42,-1],[0,173]],[[27380,59121],[34,32],[18,6],[9,-19],[8,40],[9,-20],[12,19],[4,-30],[19,0],[4,-22]],[[27497,59127],[4,-119],[-22,-53],[6,-54]],[[27485,58901],[-55,5]],[[27430,58906],[-53,5]],[[27377,58911],[3,210]],[[26339,67537],[67,0]],[[26406,67537],[0,-393]],[[26406,67144],[0,-12]],[[26275,67133],[1,202],[-3,0],[0,202]],[[26535,60642],[20,109],[3,34],[21,58],[7,1]],[[26586,60844],[4,0]],[[26590,60844],[25,-57],[27,-33]],[[26642,60754],[-16,-154]],[[26626,60600],[-12,5],[-4,34],[-12,-33],[-15,11],[-3,-31],[-24,-9],[-15,36]],[[26541,60613],[-6,29]],[[23298,60863],[121,0]],[[23419,60863],[0,-67]],[[23419,60796],[0,-339]],[[23419,60457],[-120,0]],[[23299,60457],[-1,0]],[[23298,60457],[0,406]],[[26143,67133],[132,0]],[[26275,66728],[-66,0]],[[26209,66728],[-65,-1]],[[26144,66727],[-1,406]],[[26017,66320],[62,1]],[[26079,66321],[68,-2]],[[26147,66319],[1,-405]],[[26148,65914],[-131,-3]],[[26017,65911],[0,409]],[[25535,60764],[24,42]],[[25559,60806],[41,-72],[46,-64],[16,-7]],[[25662,60663],[-18,-93],[1,-75]],[[25645,60495],[-20,-3],[-11,-38],[-24,13]],[[25590,60467],[-15,38],[-3,74],[3,35],[-7,60]],[[25568,60674],[-6,22],[-24,14],[-3,54]],[[23315,68387],[99,-1]],[[23414,68386],[2,-101],[67,0]],[[23483,68285],[0,-303]],[[23483,67982],[-165,0]],[[23318,67982],[-3,0]],[[23315,67982],[0,405]],[[26001,68350],[72,1]],[[26073,68351],[0,-407]],[[25941,67944],[-2,409]],[[25941,67944],[-110,5]],[[25831,67949],[0,42],[-9,134],[-14,90],[4,32],[20,51],[12,69]],[[26073,67944],[132,-2]],[[26206,67537],[-133,3]],[[25823,67545],[117,-6]],[[26010,67336],[0,-102]],[[26010,67234],[-33,1],[0,-102],[-101,0]],[[25876,67133],[-35,230],[-11,94],[-7,88]],[[23821,67982],[67,0]],[[23888,67982],[99,0]],[[23987,67982],[0,-406]],[[23987,67576],[-124,0]],[[23863,67576],[-42,0]],[[23821,67576],[0,406]],[[25046,62371],[0,221],[31,0]],[[25077,62592],[93,-2]],[[25170,62590],[-1,-354],[32,3]],[[25201,62239],[0,-103]],[[25201,62136],[-94,-4],[-30,2],[0,-102]],[[25077,62032],[-32,6]],[[25045,62038],[-1,300],[2,33]],[[25170,62590],[93,-1]],[[25263,62589],[0,-51],[31,0]],[[25294,62538],[-1,-303]],[[25293,62235],[-92,4]],[[23788,70280],[2,-306]],[[23790,69974],[-109,0]],[[23681,69974],[-15,70],[1,57],[-20,124]],[[23647,70225],[-23,55],[164,0]],[[21748,57894],[153,2]],[[21901,57896],[-1,-507]],[[21900,57389],[-112,0]],[[21788,57389],[-41,0]],[[23230,70612],[173,-1]],[[23403,70611],[0,-202],[2,-186]],[[23405,70223],[0,-17]],[[23405,70206],[-172,2]],[[23233,70208],[0,202],[-3,0],[0,202]],[[22550,59038],[29,0]],[[22579,59038],[120,0]],[[22699,59038],[0,-511]],[[22699,58527],[-149,-1]],[[25073,59085],[53,-4],[1,25]],[[25127,59106],[18,-54],[15,-62],[21,-13],[20,-58]],[[25201,58919],[-3,-310],[-1,-6]],[[25197,58603],[-58,7]],[[25139,58610],[-14,35],[-40,41],[-6,44],[-1,79],[-15,37]],[[25063,58846],[7,31],[3,208]],[[25335,58986],[10,32],[11,83],[15,48],[-5,59],[2,57],[29,1]],[[25397,59266],[3,-8]],[[25400,59258],[7,-48],[1,-81]],[[25408,59129],[10,-96],[-1,-35],[-23,-119],[-6,-72],[3,-23],[24,-13],[-4,-81],[-6,-29]],[[25405,58661],[-3,-29]],[[25402,58632],[-16,-6],[0,34],[-41,7]],[[25345,58667],[-11,1],[1,318]],[[27282,55866],[10,-33],[30,-42],[39,-83],[26,-76],[3,-41],[11,-31]],[[27401,55560],[-27,-60],[3,-45],[-6,-31],[-9,50],[-40,-89]],[[27322,55385],[-12,31],[-19,76]],[[27291,55492],[-10,49],[2,53],[2,223],[-3,49]],[[22384,50990],[111,-159]],[[22495,50831],[60,-270]],[[22555,50561],[26,-111]],[[22581,50450],[-66,-203]],[[22515,50247],[0,42],[-130,-2]],[[22385,50288],[-1,515]],[[22384,50803],[0,187]],[[22576,67575],[42,1]],[[22618,67576],[100,1]],[[22718,67577],[57,0]],[[22776,67192],[-67,-1]],[[22709,67191],[-122,0]],[[22587,67191],[-9,33]],[[20920,69320],[5,4],[0,247]],[[20925,69571],[133,0],[169,0]],[[21227,69571],[0,-202]],[[21227,69369],[-2,-507],[-168,0]],[[20921,68824],[0,353],[-1,143]],[[12690,84293],[118,338]],[[12808,84631],[28,-176],[57,-182],[32,-161],[30,-111]],[[12955,84001],[-1,-27],[-20,-12],[-28,5],[-18,38],[13,56],[-16,30],[2,47],[-17,22],[-15,-35],[-18,30],[-10,-17],[-22,16],[-27,62],[-19,-25],[-19,16],[-20,42],[-17,-57]],[[12703,84192],[-5,100],[-8,1]],[[12663,84216],[17,48]],[[12680,84264],[-1,-52],[-16,4]],[[12611,83642],[15,25],[14,-33],[-27,-31],[-2,39]],[[12379,84716],[-16,-66],[-3,-82],[24,-75],[19,34],[14,-8],[11,51],[19,-4],[15,23],[67,51]],[[12529,84640],[-3,-87],[25,-75],[2,-52],[21,-52],[14,-87],[17,-55],[2,-142],[21,-60],[4,-65],[-9,-2],[-5,47],[-38,120],[-10,115],[-19,37],[-9,53],[-21,0],[26,-101],[4,-34],[-13,-23],[35,-121],[23,-49],[-2,-62],[24,-113],[-19,6],[15,-102],[0,-27],[-25,-62],[-20,26],[-17,-1],[4,-34],[-21,-104],[-38,-83],[-24,-25],[-2,-33],[-31,-65],[-29,3],[-9,89],[-4,135],[21,80],[15,23],[-16,31],[-1,69],[14,6],[12,-39],[6,23],[-40,141],[-1,58],[-18,60],[-5,82],[-11,43],[8,125],[-12,81],[-3,95],[-11,91],[4,44],[-20,93],[-17,45],[-9,77],[-6,101],[4,49],[42,-103],[7,-47],[14,-9],[4,-58]],[[12097,84881],[16,18],[19,-7],[16,-52],[-29,-6],[-22,47]],[[12043,86098],[0,0]],[[11978,85151],[9,14],[7,-59],[-16,45]],[[11978,84786],[30,41],[3,-53],[-16,-19],[-17,31]],[[12270,84186],[-31,-11],[-16,17],[-42,82],[-29,43],[-52,57],[-52,83],[-21,-129],[-13,-60],[-96,-8]],[[11918,84260],[-25,26],[-7,49],[-25,36],[5,174],[16,33],[8,-9],[29,60],[3,51],[-12,92],[32,-2],[0,-54],[12,-60],[28,61],[29,-6],[17,-20],[17,49],[36,50],[14,-55],[41,-30],[25,-53],[-12,-78],[-31,-76],[4,-49],[12,-5],[8,60],[32,108],[15,12],[34,-55],[46,-10],[11,-32],[29,-16],[15,-79],[-4,-67],[-22,-44],[-37,49],[-10,-8],[12,-40],[18,-18],[33,-75],[-44,-43]],[[11480,85398],[116,116]],[[11596,85514],[22,1],[51,108],[111,158],[11,23],[68,8],[26,110]],[[11885,85922],[32,-12],[6,-21],[46,-19],[12,-34],[11,33],[17,-43],[41,-1],[19,-42],[13,0],[21,-43],[-4,-35],[7,-53],[36,-75],[-10,-70],[20,-23],[-15,-25],[-27,-15],[-8,-27],[-10,-112],[14,3],[41,-43],[5,-44],[35,-45],[-1,-44],[25,-86],[-10,-18],[-22,25],[-17,-30],[13,-102]],[[12175,84921],[-18,-16],[-33,50],[-27,-37],[-50,-19],[3,81],[-25,16],[-4,19],[30,39],[-10,69],[5,53],[-28,109],[0,36],[-22,84],[13,24],[-2,90],[-19,64],[-12,10],[15,-131],[-12,-125],[-27,-5],[-42,70],[-26,30],[-15,150],[-11,-68],[-13,-22],[-44,54],[-14,-20],[-10,50],[-12,-18],[-3,-54],[45,-35],[7,7],[45,-44],[33,-66],[30,-104],[-11,-44],[-24,-44],[6,-11],[33,44],[7,30],[27,1],[7,-105],[26,-78],[16,-157],[-19,-44],[-43,-32],[-11,10],[9,47],[-18,16],[-12,-17],[7,-39],[-10,-37],[-43,22],[-11,-23],[5,-60],[-8,-35],[-29,5],[-8,78],[-36,35],[3,15],[-28,74],[-17,19],[-29,-19],[-35,70],[-16,15],[-56,107],[-51,75],[-2,50],[-30,70],[-30,47],[-11,51]],[[22243,69203],[166,0]],[[22409,69203],[3,0],[0,-306]],[[22412,68897],[1,-509]],[[22413,68388],[-63,0]],[[22750,68792],[101,-1]],[[22851,68791],[0,-404]],[[22650,68386],[-1,0]],[[22649,68386],[0,407]],[[25489,58392],[20,51],[11,-27],[25,-18],[33,52]],[[25578,58450],[-3,-87],[9,-41],[9,-9],[3,-68],[-5,-45]],[[25591,58200],[-9,14],[-34,1],[0,-43],[-17,-7],[-2,-19],[-16,0]],[[25513,58146],[-9,44],[-11,7],[0,36],[-20,12]],[[25473,58245],[7,26],[2,49],[9,24],[-2,48]],[[24825,69767],[0,202]],[[24825,69969],[171,0],[1,-102]],[[24997,69867],[0,-405]],[[24997,69462],[-172,1]],[[24825,69463],[-1,256],[1,48]],[[25096,58489],[14,-26],[35,132],[-6,15]],[[25197,58603],[28,-2]],[[25225,58601],[-2,-234]],[[25160,58180],[-66,5]],[[25094,58185],[2,304]],[[28035,61205],[10,50],[10,-12],[-1,-43],[-18,-13],[-1,18]],[[19361,70742],[70,1],[0,315],[4,0],[0,236]],[[19435,71294],[0,68],[106,-1]],[[19541,71361],[0,-151],[6,-50],[23,-1],[0,-102],[12,-44],[0,-102],[9,-16],[-1,-34],[15,-51],[0,-169]],[[19605,70641],[-40,0]],[[19565,70641],[-137,0],[-1,-102]],[[19427,70539],[-52,0],[0,102],[-14,0],[0,101]],[[20358,67570],[16,1]],[[20374,67571],[93,1],[169,3]],[[20636,67575],[50,1]],[[20686,67576],[0,-828],[2,-6],[0,-202]],[[20688,66540],[-110,-4],[1,-203]],[[20579,66333],[-14,0],[-8,-64],[1,-67],[-5,-34],[-42,-1],[-24,18],[0,85],[11,0],[5,62],[-144,3]],[[20359,66335],[-1,0]],[[26876,59349],[5,12],[17,-22],[42,24],[13,-8],[10,-39],[19,-8]],[[26982,59308],[0,-30],[-11,-137]],[[26971,59141],[-8,-48],[-19,-67],[-25,-6],[-19,-62]],[[26900,58958],[-15,59],[5,317],[-20,-10]],[[26870,59324],[6,25]],[[24579,69663],[0,102],[69,-2]],[[24648,69763],[61,-1],[116,5]],[[24825,69463],[-43,0],[0,-101],[-33,0]],[[24749,69362],[-33,-3],[-136,0]],[[24580,69359],[-1,304]],[[18974,69325],[72,1],[22,-12],[85,2],[11,8],[45,-5],[25,8],[87,-2]],[[19321,69325],[194,5],[11,-7],[123,0]],[[19649,69323],[0,-150],[8,0],[0,-408],[5,0],[0,-410],[7,0]],[[19669,68355],[0,-104]],[[19669,68251],[-68,1],[1,-104],[-35,0],[1,-100],[-50,0],[-1,-101],[-61,-5]],[[19456,67942],[-15,34],[-9,48],[-21,75],[-10,-11],[-14,18],[-18,-33],[-13,-65],[2,-24],[-19,-20],[-15,-33],[-18,23],[-1,29],[10,10],[-1,34],[-12,47],[3,32],[-39,-5],[-10,61],[-6,6]],[[19250,68168],[0,119],[-20,37],[5,45],[-11,124],[-15,38]],[[19209,68531],[0,1]],[[19209,68532],[0,0]],[[19209,68532],[-8,65],[-19,64],[6,102],[-5,33],[-24,18],[0,24],[-80,-1],[0,97],[-108,0]],[[18971,68934],[-1,234],[1,156],[3,1]],[[23148,68388],[131,-2]],[[23279,68386],[36,1]],[[23315,67982],[-164,1]],[[23147,67983],[1,405]],[[25245,67223],[33,-2]],[[25278,67221],[99,-3]],[[25377,67218],[-2,-204],[0,-202]],[[25375,66812],[-66,-1]],[[25309,66811],[-66,1]],[[25243,66812],[0,205],[2,206]],[[23039,68388],[104,0]],[[23143,68388],[5,0]],[[23039,67984],[0,404]],[[28379,61581],[13,-20],[22,16],[6,26],[15,0],[12,38],[9,-30],[-6,-74],[10,-39]],[[28460,61498],[-14,-20],[0,-70],[-4,-45]],[[28442,61363],[-15,-14]],[[28427,61349],[-21,29],[-7,26],[-11,-9],[1,47],[7,14],[-28,4]],[[28368,61460],[-5,19],[6,98],[10,4]],[[18166,70122],[9,14],[-1,55],[13,42],[11,-36],[37,108],[8,-10],[21,18],[18,36],[3,67]],[[18285,70416],[6,-3],[18,-123],[-1,-28],[11,-47],[9,-10],[7,65],[17,5],[13,57],[14,21],[22,-4],[4,-24]],[[18405,70325],[27,-61],[17,-8],[7,-25],[22,-7],[18,-30],[7,-72],[9,-12],[4,-60]],[[18516,70050],[0,-64],[-5,-42],[4,-58],[18,-50],[14,-13],[20,16],[11,-58],[2,-355],[35,0],[0,-102],[39,0],[1,-103],[6,0],[0,-100],[28,-1],[0,-49],[80,-3],[0,-84],[83,0]],[[18852,68984],[4,-34],[-16,-98],[15,-64],[-32,26],[-9,-16]],[[18814,68798],[-24,13],[-3,-19],[-30,-40],[-13,63],[-22,-8],[-13,-25],[-10,13],[-21,-30],[-8,22],[-14,-8],[-12,35],[-16,7],[-9,-35],[-9,0],[-2,-61],[-8,-45],[-24,38],[-8,-20],[-11,24],[-33,2],[-17,22],[-17,-23],[-15,-72],[6,-53]],[[18481,68598],[-9,-22],[-11,44],[-18,24],[-15,40],[-6,53],[5,34],[-21,81],[9,48],[-5,50],[-18,109],[-32,58],[-26,-44],[-4,40],[-28,53],[-11,97],[14,13],[2,55],[-4,61],[-19,39],[2,26],[-17,15],[-7,73],[-24,73],[-1,35],[-14,54],[2,70],[-8,19],[-6,57],[6,30],[-1,46],[-19,0],[7,95],[-15,25],[-12,-2],[2,26],[-13,49]],[[19189,71314],[17,-2],[6,20],[17,-8],[4,23],[18,12],[6,-15],[16,19],[42,-69],[21,1]],[[19336,71295],[99,-1]],[[19361,70742],[-175,2]],[[19186,70744],[0,313],[3,0],[0,257]],[[23832,60125],[151,-11]],[[24028,60093],[-2,-305]],[[24026,59788],[-110,9]],[[23916,59797],[-10,1],[1,204],[-76,4]],[[23831,60006],[1,119]],[[23987,62255],[1,51],[31,108]],[[24019,62414],[6,-51],[17,-45],[17,-12],[21,14],[34,-19],[10,3]],[[24124,62304],[17,-56]],[[24141,62248],[-33,-265],[0,-17],[-62,5]],[[24046,61971],[-62,10]],[[23984,61981],[3,274]],[[22627,63100],[157,0]],[[22784,63100],[0,-101]],[[22784,62999],[0,-304]],[[22784,62695],[-156,0]],[[22628,62695],[0,303],[-1,0]],[[22627,62998],[0,102]],[[28476,61264],[17,55],[15,-69],[18,-38],[-2,-36],[31,-22],[6,-18]],[[28561,61136],[22,-41],[2,-73],[11,-35]],[[28596,60987],[-16,-2],[-6,-30],[-15,-22]],[[28559,60933],[-11,39],[-12,12],[-21,103],[-11,11],[-4,45],[-15,30]],[[28485,61173],[-9,91]],[[25020,58708],[18,6],[20,89],[5,43]],[[25096,58489],[-13,7],[-15,43],[-28,22],[-11,21],[-13,52]],[[25016,58634],[4,74]],[[25758,63413],[103,1]],[[25861,63414],[-1,-238],[1,-102]],[[25861,63074],[-39,-2],[0,-34],[-54,1]],[[25768,63039],[5,33],[-13,0],[0,273],[-2,0]],[[25758,63345],[0,68]],[[21982,61987],[26,-1]],[[22008,61986],[155,-1]],[[22163,61985],[4,0]],[[22167,61985],[0,-404]],[[22167,61581],[0,-101]],[[22167,61480],[-179,0]],[[21988,61480],[-5,0]],[[25227,65504],[94,6]],[[25321,65510],[3,-304]],[[25324,65206],[-96,-7]],[[25228,65199],[-2,203]],[[25692,64942],[17,33],[24,24],[12,42],[11,94],[16,35],[33,1]],[[25805,65171],[16,0]],[[25821,65171],[0,-305]],[[25821,64866],[-129,1]],[[25692,64867],[0,75]],[[25965,63082],[0,68]],[[25965,63150],[89,2]],[[26054,63152],[1,-286]],[[26055,62866],[-1,-120],[-15,0]],[[26039,62746],[-74,-3]],[[24041,61053],[66,-4],[6,-60],[14,-47],[13,32],[14,-4],[12,41]],[[24166,61011],[-1,-169],[45,-77],[0,-51]],[[24210,60714],[0,-153]],[[24210,60561],[-122,10]],[[24042,60574],[2,276],[-4,0],[1,203]],[[23789,63456],[111,9]],[[23900,63465],[0,-307],[27,0]],[[23927,63158],[-6,-26],[7,-68],[-4,-9]],[[23924,63055],[-134,-5]],[[23790,63050],[0,202]],[[23790,63252],[-1,204]],[[26270,69459],[34,-2],[0,101]],[[26304,69558],[103,-4]],[[26273,69158],[-3,200],[0,101]],[[21682,63506],[0,405]],[[21682,63911],[152,-2]],[[21834,63909],[6,0]],[[21840,63909],[-1,-203],[1,-201]],[[21840,63505],[-158,1]],[[26271,68347],[-1,320],[2,87]],[[23551,60771],[151,-16]],[[23702,60755],[0,-68]],[[23702,60687],[-2,-270]],[[23700,60417],[-149,17]],[[23551,60434],[0,337]],[[21788,57389],[-1,-507]],[[21787,56882],[-26,0]],[[21761,56882],[-120,0]],[[21641,56882],[0,506]],[[26472,66325],[52,-1],[78,9]],[[26602,66333],[31,4]],[[26633,66337],[3,-201],[1,-206]],[[26637,65930],[-65,-3]],[[26572,65927],[-66,-5],[-34,-8]],[[26472,65914],[0,411]],[[26078,66725],[66,2]],[[26209,66728],[1,-407]],[[26210,66321],[-63,-2]],[[26079,66321],[-1,404]],[[19931,54895],[86,0]],[[20017,54895],[1,-449],[0,-508]],[[20018,53938],[-254,0]],[[19764,53938],[-2,94]],[[19762,54032],[0,251],[-4,0],[0,509],[85,0],[0,102],[88,1]],[[26851,59778],[6,38],[14,-19],[12,33],[6,39],[65,7],[-1,-9]],[[26953,59867],[14,-113],[6,-82]],[[26973,59672],[11,-132]],[[26984,59540],[-88,-2]],[[26896,59538],[-62,0]],[[26834,59538],[-43,0]],[[26791,59538],[11,95],[34,67],[-1,16],[16,62]],[[29917,68632],[16,6],[14,39],[7,45],[16,22],[-6,59],[11,13],[2,73],[-10,38],[-11,102],[15,52],[4,64],[18,75],[-13,89],[11,30]],[[29991,69339],[3,68],[18,64],[-3,15],[11,74],[-13,36],[18,11],[4,26],[22,42],[15,-61],[28,-5],[13,70]],[[30107,69679],[15,-757],[6,-431]],[[30128,68491],[-10,-2],[1,-54],[-59,8],[-14,-124],[-2,-53],[-9,0],[-4,86],[-16,54]],[[30015,68406],[-8,43],[-18,16],[-19,-10],[-3,59],[-31,31],[-19,87]],[[22183,73978],[147,1]],[[22330,73979],[0,-328],[8,0],[0,-202]],[[22338,73449],[0,-203],[-64,1]],[[22274,73247],[-82,0]],[[22192,73247],[0,202]],[[22192,73449],[0,202],[-9,0],[0,327]],[[23550,60009],[0,68]],[[23550,60077],[156,-11]],[[23706,60066],[-1,-135]],[[23705,59931],[-2,-214]],[[23550,59739],[0,270]],[[12766,83305],[62,-7],[30,-74],[14,-82],[3,-56],[9,-23],[23,-11],[16,-48],[5,-46],[33,-52],[9,-64],[15,-34],[-31,-38],[-20,-42],[-26,-24],[-16,16],[-31,4],[-43,24],[5,-48],[-23,-51],[-40,25],[-18,29]],[[12742,82703],[2,30],[-12,61],[7,21],[-4,52],[-10,11],[-8,79],[-20,57],[22,-15],[-6,57],[10,58],[-6,36],[35,19],[32,45],[-18,91]],[[12955,84001],[25,-123],[53,-180],[32,-155],[-33,-140],[89,-52],[-19,-186]],[[12982,82959],[-2,50],[-22,28],[-37,66],[-13,69],[-15,33],[-13,79],[29,43],[-11,58],[-18,-47],[-19,18],[-2,-27],[-23,58],[-31,8],[-11,56],[-27,-28],[-54,76],[-8,75],[15,73],[18,-22],[33,4],[9,48],[-22,3],[-32,36],[2,35],[-18,125],[13,81],[-24,-10],[-15,19],[-16,53],[7,103],[20,2],[16,-36],[33,-24],[63,-89],[5,15],[-25,58],[-20,19],[-64,125]],[[22784,65937],[97,-1]],[[22881,65532],[-65,0]],[[22816,65532],[-32,0]],[[22784,65532],[0,405]],[[22784,66240],[98,0]],[[22882,66240],[0,-101],[54,-1]],[[22936,66138],[0,-202]],[[22784,65937],[0,303]],[[25437,70164],[42,1],[0,204],[22,0],[0,102]],[[25501,70471],[69,-1]],[[25570,70470],[0,-101],[12,0],[0,-404],[17,-1]],[[25599,69964],[-17,-146],[-19,-65],[-20,-112],[-41,-174],[6,-33]],[[22670,50311],[57,170]],[[22727,50481],[43,130],[22,-35],[10,-36]],[[22802,50540],[0,-22],[20,23],[13,-38],[7,-66],[-6,-192],[8,-47],[-2,-20]],[[22842,50178],[-60,-192]],[[22782,49986],[-15,28],[-8,-6],[-6,31],[-20,19],[-2,74],[-18,18],[-6,-10],[-14,24],[-10,102],[-13,45]],[[22599,71221],[98,-1]],[[22809,70816],[-203,0]],[[22599,70816],[0,405]],[[21748,58403],[152,0]],[[21900,58403],[1,-507]],[[21748,57894],[0,509]],[[27623,65237],[12,27],[18,71],[18,33],[0,23],[60,-6],[0,8]],[[27731,65393],[28,1]],[[27759,65394],[0,-186],[-3,-28],[12,-1],[1,-62]],[[27769,65117],[-1,-60],[-17,1],[0,-18],[-18,1],[0,-52],[-13,-27],[1,-42],[-13,-52]],[[27708,64868],[-85,-1]],[[27623,64867],[0,370]],[[21900,57389],[35,-1]],[[21907,56884],[-120,-2]],[[23831,59921],[0,85]],[[23916,59797],[-3,-370]],[[23913,59427],[-75,0]],[[23838,59427],[3,374],[-11,1],[1,119]],[[26494,63329],[31,-8],[0,-18],[32,-7],[-1,-29],[51,-29]],[[26607,63238],[-2,-65]],[[26605,63173],[-4,-194]],[[26601,62979],[-86,22]],[[26515,63001],[-38,10]],[[26477,63011],[0,57],[6,246],[11,15]],[[23662,63662],[126,-5]],[[23788,63657],[1,-201]],[[23790,63252],[-125,5]],[[23665,63257],[1,286],[-4,0]],[[23662,63543],[0,119]],[[24182,64198],[48,4]],[[24230,64202],[66,6]],[[24296,64208],[-2,-355]],[[24294,63853],[-111,2]],[[24183,63855],[-1,51]],[[24182,63906],[0,292]],[[22275,54282],[21,1]],[[22296,54283],[55,-2]],[[22351,54281],[71,-439]],[[22422,53842],[-26,-15],[-5,-90],[-59,-147]],[[22332,53590],[-8,-17],[-6,24],[-14,-34]],[[22304,53563],[-31,7]],[[22273,53570],[2,712]],[[21328,55306],[108,0]],[[21436,55306],[1,-507]],[[21435,54799],[-238,-1]],[[21197,54798],[0,509]],[[22770,53399],[21,-89],[18,42]],[[22867,53010],[-52,-112],[-16,-160]],[[22799,52738],[-86,137],[-57,42]],[[22656,52917],[-23,150]],[[22633,53067],[1,40]],[[17195,73980],[111,-2]],[[17306,73801],[-1,-113],[0,-441],[-2,-379]],[[17303,72868],[-110,2]],[[17193,72870],[0,102],[-18,0],[0,607],[-36,0],[0,101],[19,0],[0,109],[18,0],[0,101],[19,0],[0,90]],[[26606,53687],[0,33],[42,-2]],[[26648,53718],[0,-28],[22,-20],[7,-25],[5,-58],[11,-7]],[[26693,53580],[-9,-13],[0,-74],[-18,-59]],[[26666,53434],[-7,-28],[-15,1]],[[26644,53407],[-39,4]],[[26605,53411],[1,276]],[[21783,52684],[236,5]],[[22019,52689],[0,-489]],[[22019,52200],[-163,-2]],[[21856,52198],[-73,-1]],[[21783,52197],[0,487]],[[27602,60502],[8,24],[10,79],[12,39],[-17,93],[2,27]],[[27617,60764],[29,63],[28,116],[40,-44]],[[27714,60899],[-4,-33],[5,-71],[-4,-14],[31,-77],[-1,-18],[22,-55]],[[27763,60631],[-19,-53],[-6,-44],[-13,8],[-7,33],[-9,-10],[-18,-59],[-16,-26],[10,-25],[-3,-36],[-16,-48]],[[27666,60371],[-6,22],[-54,93],[-4,16]],[[23611,53787],[86,-39],[30,-59]],[[23727,53689],[0,-120],[-17,-66],[6,-53],[-7,-79],[5,-65],[-2,-124]],[[23712,53182],[-1,-18],[-25,-22]],[[23686,53142],[-17,43],[-16,60],[-21,43]],[[23632,53288],[-4,45],[7,48],[-4,64],[1,47],[6,25],[-5,27],[6,95],[-3,73],[-11,21],[-14,54]],[[31524,38134],[13,26]],[[31537,38160],[6,-37],[1,-63]],[[31544,38060],[0,-27]],[[31544,38033],[-2,-31],[-12,1],[-9,-22]],[[31521,37981],[-1,24],[-11,16]],[[31509,38021],[0,4]],[[31426,38459],[10,-13]],[[31436,38446],[4,-59],[-1,-47]],[[31439,38340],[-4,-19]],[[31435,38321],[-10,-8],[-3,-32]],[[31419,38294],[7,165]],[[23984,71379],[212,-2],[2,-118]],[[24198,71259],[0,-286]],[[24198,70973],[-212,2]],[[23986,70975],[0,186],[-3,115],[1,103]],[[26672,51474],[13,-1],[8,110],[5,21],[0,52]],[[26698,51656],[111,1]],[[26809,51657],[0,-34],[-8,-47],[3,-62],[-9,-89],[5,-45],[5,6]],[[26805,51386],[-11,-58],[-2,-82],[-12,-59],[1,-24],[-12,-31],[1,-27],[-16,-38],[-6,8],[-7,-41]],[[26741,51034],[-3,65],[-7,58],[-11,45],[-15,6],[-5,44],[-24,48],[0,111],[-4,63]],[[26598,56049],[48,257]],[[26646,56306],[8,-18],[9,-93],[11,-28]],[[26674,56167],[10,-49],[7,-65],[21,-78],[-3,-58]],[[26709,55917],[-70,-57]],[[26639,55860],[-42,107]],[[26597,55967],[1,82]],[[3834,96137],[247,0],[0,201],[246,0],[249,0],[0,101],[195,0],[0,-101],[130,0],[0,101],[130,0],[0,-101],[259,1],[0,100],[130,0],[0,-100],[206,0],[216,0],[285,0],[0,-101],[256,0],[0,-101],[256,0],[0,-41]],[[6639,96096],[0,-160],[-14,0],[0,-101],[63,0],[0,-101],[63,0],[0,-101],[63,0],[0,-101],[-16,0],[0,-302],[124,0],[0,-101],[43,0],[0,-403],[-17,0],[0,-101],[-182,0],[0,-201],[-181,0],[0,-101],[-12,0],[0,-202],[-119,0],[0,101],[-60,0],[0,101],[-119,0],[0,-202],[-119,0],[0,202],[-238,0],[0,-403],[-297,0],[0,-202],[-176,0],[0,-202],[3,0],[0,-302]],[[5448,93214],[-58,0],[0,-101],[-232,0],[-230,0],[-243,0],[-137,0],[-260,0],[0,202],[-58,0],[0,201],[-78,0],[0,404],[-21,0],[0,403],[-21,0],[0,122]],[[4110,94445],[134,15],[52,-11],[34,-31],[-41,-11],[7,-38],[-10,-71],[-31,-77],[1,-70],[12,-56],[-21,-59],[-49,-33],[-4,-20],[49,7],[42,-151],[40,-3],[36,32],[42,-1],[49,-30],[47,21],[69,15],[32,-58],[50,21],[18,-34],[52,32],[18,26],[84,-65],[18,59],[26,44],[37,150],[18,26],[40,-9],[8,-39],[32,-12],[31,27],[26,0],[-32,110],[-71,55],[-45,24],[-48,-1],[-60,-60],[13,112],[-3,83],[-62,114],[-22,91],[-26,35],[-59,14],[-8,56],[-32,90],[7,50],[27,18],[10,43],[16,-37],[24,28],[27,-89],[36,-91],[24,-10],[-19,-101],[3,-55],[28,-50],[57,-123],[53,-68],[39,18],[30,28],[9,49],[-45,2],[-10,45],[-56,70],[-53,112],[10,52],[0,60],[14,23],[1,57],[33,93],[30,-32],[22,3],[1,28],[-38,55],[-25,-8],[-28,57],[-87,-29],[-32,-37],[-34,0],[-39,-19],[-34,17],[-20,43],[-17,-16],[-21,23],[-4,-51],[-36,39],[-91,42],[-54,31],[-48,15],[-22,30],[1,98],[-22,163],[-52,216],[-20,58],[-36,62],[-91,101],[-145,228],[-21,24],[-51,87],[-20,21]],[[21029,72034],[158,0]],[[21187,72034],[19,0],[0,-406]],[[21206,71628],[-55,0],[0,-408]],[[21045,71220],[0,408],[-16,0],[0,406]],[[23785,71422],[0,264]],[[23785,71686],[201,-4]],[[23986,71682],[-2,-303]],[[23986,70975],[0,-304]],[[23986,70671],[-64,2],[-41,-7]],[[23881,70666],[0,108],[-102,-4]],[[23779,70770],[-4,9],[0,388],[9,6],[1,249]],[[19529,62918],[0,189]],[[19529,63107],[44,0],[0,-11],[95,-1],[0,51],[171,1],[0,152],[68,6],[73,-2],[0,104],[32,-3],[0,204],[78,1]],[[20090,63609],[2,-103],[-1,-98]],[[20091,63408],[-22,0],[0,-643]],[[20069,62765],[-88,0]],[[19981,62765],[-273,0],[-179,0]],[[19529,62765],[0,153]],[[23426,61628],[0,-152],[-3,0],[-1,-258]],[[23422,61218],[-123,1]],[[23299,61219],[1,257],[3,0],[-1,153]],[[22037,56327],[15,0]],[[22052,56327],[1,-510]],[[22053,55817],[-146,0]],[[22225,58628],[207,0]],[[22435,58324],[-1,-101]],[[22434,58223],[-206,1]],[[22228,58275],[-3,50],[0,303]],[[26670,64302],[32,0],[0,18],[54,1]],[[26827,64323],[-1,-68],[-27,-12],[0,-169],[-16,-7],[-2,-59]],[[26781,64008],[-63,11]],[[26718,64019],[0,74],[-47,-2]],[[26671,64091],[-1,211]],[[24715,64741],[0,102]],[[24715,64843],[126,-2]],[[24841,64841],[0,-204]],[[24841,64637],[0,-305]],[[24841,64332],[-128,3]],[[24713,64335],[2,406]],[[26559,56667],[15,-73],[42,-21],[14,-18],[8,-76]],[[26638,56479],[-31,-70]],[[26607,56409],[-8,13],[-24,-26],[-10,41]],[[26565,56437],[-11,63],[-9,23],[14,144]],[[25228,65199],[3,-406]],[[25231,64793],[-96,-3],[0,-207]],[[25135,64583],[-33,-3]],[[25070,64788],[0,240]],[[25070,65028],[-1,320]],[[25069,65348],[0,51],[64,-1]],[[25897,53538],[0,105],[14,9],[0,93]],[[25911,53745],[99,0]],[[26010,53745],[0,-490]],[[26010,53255],[-112,-5]],[[25898,53250],[-1,288]],[[27434,48610],[110,0],[0,67],[24,-1]],[[27568,48676],[10,-82],[6,-94],[7,-46],[10,-119]],[[27601,48335],[-17,1],[0,-17],[-208,3]],[[27376,48322],[58,189],[0,99]],[[23731,66480],[131,0]],[[23862,66480],[0,-101],[10,0],[0,-305]],[[23872,66074],[-65,0]],[[23994,66479],[0,-100],[6,0],[1,-305]],[[23937,66074],[-65,0]],[[17924,69100],[4,-16],[-6,-55],[30,-113],[14,14],[18,-50],[-2,-26],[10,-25],[15,33],[18,9],[4,46],[14,25],[4,43],[-9,35],[14,22],[3,41],[18,34],[4,31],[19,15],[-2,-98],[-4,-37],[23,-19],[14,30],[22,-141],[9,-18],[43,-145],[36,-31],[8,-21],[20,-8],[24,-25],[15,35],[12,-81],[18,-77],[6,-97]],[[18340,68430],[-27,1],[0,-203],[-11,0],[3,-169],[-3,-43],[13,-20],[9,-59],[-18,-1],[-2,-39],[-22,-65],[-65,-112],[-10,-63]],[[18207,67657],[-5,36],[-17,59],[-27,67],[-9,67],[-7,9],[-11,-45],[-13,7],[-7,39],[-37,66],[-5,66],[-19,-16],[-14,25],[-27,4],[-6,-62],[-15,7],[-6,49],[-21,40],[-37,0],[0,76],[-17,0],[-27,-64]],[[17880,68087],[-6,13]],[[17874,68100],[7,38],[-4,34],[-19,31],[14,56],[-13,40],[8,24],[-18,41],[-7,-7],[-17,38],[2,43],[-5,66],[-30,33],[-2,17]],[[17790,68554],[13,55],[6,111],[-4,35],[-12,9],[-6,64],[6,39],[23,19],[9,27],[8,76],[-3,19],[17,47],[37,-57],[13,42],[27,60]],[[26280,53609],[1,139]],[[26281,53748],[45,0],[2,27],[17,-26],[11,0]],[[26356,53749],[27,1]],[[26383,53750],[-2,-41],[13,-151],[-5,-24]],[[26389,53534],[-5,21],[-12,-31],[-41,7]],[[26331,53531],[-42,3],[-2,76],[-7,-1]],[[23237,66484],[99,1]],[[23336,66485],[0,-102],[18,0],[0,-307]],[[23354,66076],[-97,1]],[[23257,66077],[1,306],[-21,1],[0,100]],[[20186,60983],[30,-1],[0,-101],[153,1]],[[20369,60882],[-1,-405]],[[20181,60481],[0,303],[5,0],[0,199]],[[23910,65258],[127,1]],[[24037,64854],[-63,0]],[[23974,64854],[-64,0]],[[23910,65238],[0,20]],[[21053,64112],[32,0],[0,-101]],[[21019,63504],[-124,0]],[[20895,63504],[0,609],[158,-1]],[[24066,65671],[131,0]],[[24197,65671],[-1,-101],[1,-310]],[[24197,65260],[-32,0]],[[24069,65259],[0,108],[-3,0],[0,304]],[[24873,64100],[16,33],[43,30],[0,40],[14,59],[-2,14],[16,42],[1,55]],[[24961,64373],[63,1],[0,-155],[16,1],[1,-26]],[[25041,64194],[1,-313]],[[24948,63875],[-32,-1],[0,136],[-58,0]],[[24858,64010],[15,90]],[[20752,62997],[264,1]],[[21016,62998],[-2,-510],[1,-304],[-94,2]],[[20921,62186],[1,302],[-170,1]],[[20752,62489],[0,508]],[[23807,65672],[97,-1]],[[23904,65671],[0,-305],[6,0],[0,-108]],[[23781,65263],[0,103],[-7,0],[0,306]],[[26388,63915],[0,28],[26,1],[0,119],[94,2]],[[26508,64065],[0,-198],[-3,-46]],[[26505,63821],[-3,-104]],[[26502,63717],[-54,18],[-60,-3]],[[26388,63732],[0,183]],[[23655,65253],[96,-1],[30,11]],[[23781,64855],[-62,-6]],[[27154,64989],[33,1],[-9,85],[57,-3]],[[27235,65072],[0,-419]],[[27235,64653],[-7,0],[-1,-95],[-63,9]],[[27164,64567],[0,86],[-11,0]],[[27051,49122],[137,1]],[[27188,49123],[-1,-357]],[[27050,48764],[1,358]],[[26285,64654],[112,1]],[[26397,64655],[1,-101],[16,0],[0,-51]],[[26414,64503],[0,-50],[-16,-1],[0,-152]],[[26398,64300],[-16,0]],[[26382,64300],[0,50],[-97,0]],[[26285,64350],[0,227]],[[26285,64577],[0,77]],[[26407,63025],[70,-14]],[[26515,63001],[-8,-366]],[[26507,62635],[-71,19]],[[26436,62654],[0,20],[-26,5]],[[26410,62679],[4,140],[2,158],[-9,-5],[0,53]],[[22020,51423],[27,1]],[[22047,51424],[115,4]],[[22162,51428],[53,0]],[[22215,51428],[-1,-624]],[[22020,50798],[0,625]],[[26675,56748],[13,31]],[[26688,56779],[16,47],[7,-18],[28,-12],[17,41]],[[26756,56837],[10,-58]],[[26766,56779],[-7,-59],[9,-22],[9,-64],[17,-65]],[[26794,56569],[-20,-32],[-21,37],[-27,-55],[-11,-2]],[[26687,56565],[-7,12],[8,77],[-2,55],[-11,39]],[[27145,63680],[13,-2],[0,84],[13,-2]],[[27171,63760],[79,-8]],[[27282,63701],[-3,-255]],[[27279,63446],[-42,-1],[0,-34],[-21,3],[-1,-34],[-32,4],[0,-69],[-32,4]],[[27151,63319],[1,103],[-11,1],[4,257]],[[22495,50831],[74,376],[2,5]],[[22571,51212],[3,-73],[79,-2]],[[22653,51137],[-5,-28],[36,-153]],[[22684,50956],[-129,-395]],[[26781,64008],[0,-18],[27,-4],[-1,-66],[51,-10]],[[26857,63825],[-3,-176]],[[26854,63649],[-114,20]],[[26740,63669],[-1,118],[-21,0],[0,232]],[[27236,65330],[26,0],[0,83],[54,0],[0,85],[27,1]],[[27343,65499],[1,-248]],[[27344,65251],[0,-179]],[[27344,65072],[-109,0]],[[27235,65072],[1,258]],[[22216,57816],[11,-31],[1,-33],[10,-21],[-1,-113],[9,-24],[-2,-77],[17,-42]],[[22261,57475],[-1,-11],[-44,1],[1,-52],[-9,1],[4,-51],[-68,-1]],[[22144,57362],[0,34],[-15,17],[0,103],[-3,101],[-44,0],[0,101]],[[23855,68792],[68,0]],[[23923,68792],[0,-84],[67,0]],[[23990,68708],[0,-320]],[[23990,68388],[-2,0]],[[23988,68388],[-100,-1]],[[23888,68387],[-33,0]],[[23855,68387],[0,405]],[[24186,56588],[29,3]],[[24215,56591],[78,2]],[[24293,56593],[0,-101],[-7,0],[0,-216]],[[24286,56276],[1,-102]],[[24287,56174],[-99,4]],[[24188,56178],[-3,41],[2,61]],[[24187,56280],[-1,38],[-16,68],[-2,32],[-15,68],[-6,0],[1,99],[38,3]],[[26501,54389],[17,90],[19,38],[14,12]],[[26551,54529],[65,-3]],[[26616,54526],[2,0],[0,-198]],[[26618,54328],[-1,-105]],[[26617,54223],[-98,3]],[[22019,53128],[0,-439]],[[21783,52684],[0,438]],[[23483,68285],[137,0]],[[23620,68285],[0,-303]],[[23620,67982],[-135,0]],[[23485,67982],[-2,0]],[[22406,64306],[1,10]],[[22407,64316],[122,-1]],[[22529,64315],[2,0]],[[22531,63910],[-125,1]],[[22406,63911],[0,395]],[[27253,58842],[18,34],[20,14],[37,-7],[8,17]],[[27336,58900],[8,-57],[-1,-45],[-10,-117],[-19,-95]],[[27314,58586],[-9,60],[-54,-37]],[[27251,58609],[1,97],[-3,51],[4,85]],[[23702,60755],[0,135],[2,169]],[[23826,60976],[-1,-101],[6,-1],[-1,-197]],[[23830,60677],[-128,10]],[[21494,57389],[103,0]],[[21641,56882],[-26,0]],[[21494,56883],[0,506]],[[18433,72761],[19,-134],[-2,-90],[6,-35],[-2,-45],[15,-72],[21,-37],[15,22],[45,23],[40,-44],[5,-55],[17,-3],[18,-50],[18,-4],[19,15],[27,0]],[[18694,72252],[1,-376],[19,-11],[10,-47],[19,-17],[23,0],[0,-250],[37,-1]],[[18803,71550],[14,-24],[-11,-57],[13,-42],[29,-20],[0,-32]],[[18848,71375],[-30,18],[-10,-47],[0,-181],[2,-15],[-43,0]],[[18767,71150],[-65,-1],[-18,-61],[-14,7],[-20,-26],[9,-51],[-11,-7],[-15,-41],[-12,7]],[[18621,70977],[1,104],[4,24],[-7,51],[7,35],[-8,60],[-25,0],[0,50],[-35,0],[0,157],[-72,-3],[0,402],[-73,3],[0,359],[-16,3],[-8,122]],[[18389,72344],[4,77],[-10,80],[24,23],[4,31],[1,127],[-7,38],[18,10],[10,31]],[[23859,61822],[1,161],[4,225],[-1,47]],[[23863,62255],[0,17]],[[23863,62272],[124,-17]],[[23984,61981],[-2,-190]],[[23982,61791],[-62,7],[0,-34],[-62,7]],[[23858,61771],[1,51]],[[21761,56325],[0,557]],[[18058,71256],[140,0]],[[18198,71256],[7,-36],[-17,-160],[2,-85],[11,-14],[10,-52],[3,-50],[-4,-39],[10,-26],[-8,-42],[-11,-14],[7,-75],[11,-44],[-14,-86],[14,8],[18,-13],[7,-64],[25,-48],[16,1]],[[18285,70417],[0,-1]],[[18166,70122],[-12,21],[-9,-13],[2,-41],[-15,-35],[-19,-82],[-19,-26],[-13,12],[-3,-58],[-24,-42],[-5,36],[-14,22],[-13,60],[-27,5]],[[17995,69981],[6,48],[-8,36],[18,37],[1,48],[-19,74],[18,89],[25,1],[7,44],[-13,54],[6,49],[-19,27],[-4,54],[9,58],[-17,33],[2,49],[19,7],[-1,79],[-6,30],[13,24],[1,116],[13,65],[-7,69],[12,3],[10,123],[-3,58]],[[17129,57476],[10,-1],[0,732],[-1,234],[5,34],[-10,0],[5,34],[0,101]],[[17138,58610],[274,-2],[255,-2],[0,18],[24,1]],[[17691,58625],[66,-215],[70,-234],[147,-492]],[[18112,56871],[1,-49],[-25,-65],[-1,-19],[-17,-21],[-10,-40],[-27,-38],[-4,-28]],[[18029,56611],[-245,-2],[0,-51],[-333,-1],[-117,1],[0,-34],[-79,-1],[-3,17],[-41,1],[-1,17],[-51,-1],[0,-52],[-14,-20],[-1,-54],[-12,-1],[-5,-62]],[[17127,56368],[-31,88]],[[17096,56456],[-5,34],[10,55],[10,-2],[15,169],[9,143],[-2,58],[-4,255],[0,308]],[[26932,56099],[15,13]],[[26947,56112],[-4,-15],[8,-59],[-7,-44],[15,-23],[-5,-16],[5,-57],[13,-55],[-1,-17],[13,-59]],[[26984,55767],[-17,-49]],[[26967,55718],[-8,-1]],[[26959,55717],[-19,34],[-16,1],[-10,38],[-2,48],[-9,40],[-18,185]],[[26885,56063],[9,4],[9,44],[11,-13],[11,24],[7,-23]],[[12202,85643],[15,-71],[0,-46],[-10,29],[-5,88]],[[12100,86471],[95,-444],[97,-5]],[[12292,86022],[18,-76],[73,-38],[5,-66],[32,-73],[24,0],[29,-108],[-6,-69],[20,-15]],[[12487,85577],[-204,4],[21,-108],[-5,-68]],[[12299,85405],[-7,-39],[1,-58],[-35,132],[-8,177],[-8,92],[-21,135],[-32,116],[-36,37],[-5,-16],[28,-38],[4,-41],[17,-39],[20,-131],[-15,11],[-34,140],[-22,36],[-22,10],[41,-92],[13,-85],[17,-29],[-7,-97],[9,-88],[13,-23],[-5,-24],[27,-124],[3,-55],[25,-139],[2,-32],[-14,11],[27,-204],[9,-85],[1,-69],[-12,8],[-1,-61],[12,-64],[-29,23],[-19,32],[-14,-4],[-18,43],[-29,150]],[[11885,85922],[6,29],[-2,209],[30,-19],[18,19],[19,71],[-1,39],[-32,47],[45,48],[68,28],[64,78]],[[24997,69462],[56,-1],[0,-104]],[[25053,69357],[0,-405]],[[25053,68952],[-74,5],[-99,-1]],[[24880,68956],[-131,0]],[[24749,68956],[0,406]],[[5524,80844],[-1,36],[13,24],[20,-25],[-9,-59],[-19,-15],[-4,39]],[[5485,80904],[12,85],[-11,46],[31,-2],[4,-99],[-27,-38],[-9,8]],[[5450,80763],[21,-45],[-1,-34],[-23,-4],[3,83]],[[5429,81185],[17,-21],[5,49],[17,46],[5,-22],[-8,-58],[9,-13],[1,-44],[-10,-61],[13,-30],[-7,-19],[-17,22],[-2,-21],[-20,8],[-3,164]],[[5385,80755],[21,25],[11,-30],[-20,-26],[-12,31]],[[5377,81028],[9,39],[23,41],[5,-36],[-23,-38],[-9,-58],[-5,52]],[[5303,81352],[14,11],[5,-42],[-19,31]],[[5265,80882],[33,98],[15,27],[-5,18],[-22,0],[-4,76],[22,50],[27,-44],[-1,38],[-13,52],[30,-13],[18,114],[12,-23],[-2,-43],[-9,-2],[-5,-75],[12,-18],[0,33],[13,1],[-4,-60],[-11,-37],[-22,12],[-1,-45],[-28,-71],[-18,-24],[-31,-141],[-6,77]],[[5238,81460],[22,42],[36,-14],[-1,-78],[-50,12],[-7,38]],[[5096,81334],[16,74],[25,25],[18,-23],[-2,-46],[10,5],[12,47],[15,-32],[26,-26],[26,25],[7,-66],[-9,-60],[-14,40],[-22,3],[-14,23],[-3,40],[-10,-12],[0,-69],[11,-20],[11,-87],[-11,-60],[-36,35],[-10,59],[-18,-18],[-18,-90],[4,58],[-10,43],[0,104],[-4,28]],[[4937,81216],[27,3],[-4,-71],[-26,47],[3,21]],[[4863,81217],[10,31],[36,8],[-9,-51],[-37,-10],[0,22]],[[4804,81100],[4,51],[17,20],[25,-19],[12,-29],[35,-42],[6,-41],[-30,44],[-23,-57],[-28,74],[-11,-38],[-7,37]],[[4656,80881],[30,66],[26,-27],[0,-83],[-11,-53],[-13,-21],[-27,58],[-5,60]],[[4545,80324],[1,51],[68,-54],[19,-39],[26,0],[18,-28],[-20,-23],[-10,-33],[-22,40],[-17,-9],[-31,37],[-18,-29],[-22,57],[8,30]],[[4451,81463],[14,-1],[-5,-38],[-9,39]],[[3979,80040],[12,22],[16,-18],[-21,-37],[-7,33]],[[5643,83066],[0,-60],[-44,0],[0,-101],[-63,0],[0,-101],[-87,0],[0,-101],[-87,0],[0,-202],[27,0],[0,-404],[-18,0],[0,-101],[86,0],[1,-289]],[[5458,81707],[-17,-50],[-32,-30],[2,52],[24,4],[-1,40],[-10,4],[2,111],[18,72],[-29,39],[-28,12],[-13,-18],[3,-45],[-12,-21],[-13,22],[-25,-13],[-9,-82],[-35,-74],[-26,-20],[-37,28],[-6,-29],[11,-44],[-20,-81],[1,-31],[-21,-37],[-12,105],[-10,13],[-14,-37],[-11,14],[-18,-31],[31,-13],[-2,-68],[-32,-10],[-16,25],[5,39],[-13,24],[-22,-22],[-19,-90],[-61,-85],[-26,2],[-11,29],[-26,-29],[-13,4],[10,156],[29,96],[1,46],[-15,16],[-31,-2],[-24,-29],[-24,-101],[4,-129],[-40,-140],[-7,-12],[-14,-85],[-21,36],[-19,-12],[13,-65],[10,-17],[1,-56],[-25,-38],[-19,33],[0,45],[-16,15],[-13,-60],[10,-49],[-17,-47],[-14,27],[-32,-8],[-16,18],[-14,74],[32,6],[-21,47],[-8,104],[-21,56],[-11,7],[-16,-33],[-10,-65],[7,-27],[14,0],[18,-70],[-11,-46],[14,-95],[0,-52],[-22,30],[-20,-19],[3,-26],[-17,-30],[-18,-7],[-22,28],[-16,59],[4,36],[-13,56],[-21,37],[-31,-25],[-10,-56],[49,-85],[4,-31],[-50,-111],[-24,-21],[-20,-33],[16,-56],[27,2],[9,24],[22,-50],[13,-83],[-26,6],[8,34],[-17,6],[-10,-28],[-16,22],[-17,62],[-25,-39],[2,-69],[-18,-1],[-28,-50],[-23,18],[-37,10],[-45,-5],[-34,-14],[-41,-40],[-29,-71],[-4,-69],[-29,-53],[-51,-33],[-29,3],[-28,28],[-9,30],[-9,74],[-10,30],[-1,55],[8,29],[44,41],[14,25],[23,110],[19,110],[-1,29],[22,54],[14,13],[25,-46],[38,39],[25,49],[25,0],[37,81],[34,20],[36,-14],[31,5],[1,-37],[28,-72],[9,-61],[-5,-50],[27,24],[-8,52],[2,37],[30,-30],[-15,42],[2,77],[-10,109],[32,46],[26,21],[42,-15],[21,14],[10,69],[-16,4],[4,28],[18,10],[7,38],[18,-4],[26,99],[3,-32],[15,-20],[21,48],[-5,83],[-20,-9],[27,68],[64,206],[33,52],[23,62],[19,13],[27,42],[25,68],[27,14],[35,39],[37,20],[89,70],[30,-9],[10,18],[45,5],[10,-10],[-20,-27],[-1,-47],[14,-2],[-3,-49],[-29,-18],[-3,-85],[38,-98],[11,22],[27,-39],[4,19],[-29,53],[-3,85],[-6,32],[26,-28],[57,3],[7,-86],[23,7],[26,-36],[7,22],[-14,40],[27,15],[-56,89],[-32,36],[1,58],[-16,-7],[39,166],[15,123],[11,56],[23,44],[36,96],[18,13],[40,74],[30,81],[82,96],[41,74],[35,39],[68,106],[17,42],[18,-52]],[[3880,79918],[22,34],[33,-11],[24,18],[5,-24],[-9,-45],[-26,-13],[-47,27],[-2,14]],[[3807,79887],[60,24],[9,-35],[-15,-32],[-13,37],[-34,-4],[-7,10]],[[3781,79848],[17,29],[7,-36],[-18,-14],[-6,21]],[[3751,80090],[13,56],[14,-15],[18,18],[12,-21],[-22,-33],[13,-48],[30,0],[1,-41],[-23,3],[-18,-79],[-23,24],[-2,78],[16,35],[-9,20],[-16,-21],[-4,24]],[[3635,79967],[5,36],[28,54],[30,-6],[3,-58],[20,6],[14,-15],[8,-44],[13,13],[-2,-41],[-26,-36],[-12,11],[-18,-45],[-6,28],[-25,1],[-17,-20],[-18,91],[3,25]],[[3608,79782],[7,15],[27,-33],[-32,-11],[-2,29]],[[7594,84711],[8,45],[20,-13],[-8,-73],[-15,-17],[-5,58]],[[7543,85532],[12,28],[21,-40],[-33,-2],[0,14]],[[7464,85521],[14,55],[18,-28],[23,-4],[-33,-33],[-22,10]],[[7168,84530],[29,89],[15,6],[26,-66],[5,20],[-21,65],[6,54],[9,10],[27,-25],[21,19],[-29,54],[16,56],[29,-31],[15,4],[-14,56],[12,17],[20,-20],[14,45],[-18,6],[-13,33],[20,3],[22,67],[34,18],[-12,35],[-3,68],[27,66],[7,-31],[53,51],[7,-7],[-12,-118],[-13,-18],[-26,-103],[5,-84],[36,11],[2,69],[22,-9],[21,-71],[20,48],[12,-33],[-17,-117],[9,-22],[9,72],[27,47],[7,-25],[-3,-115],[-30,-89],[-32,23],[-11,81],[-21,-26],[13,-99],[-22,-20],[-39,13],[-16,-54],[-8,36],[2,74],[-10,2],[-9,-114],[-8,-24],[-31,-17],[2,-37],[-16,-22],[-45,-13],[-86,76],[-21,-13],[-15,29]],[[6962,82933],[31,45],[8,-48],[-37,-9],[-2,12]],[[6905,82759],[20,62],[19,20],[11,-11],[25,17],[5,-40],[19,-37],[36,16],[-2,-37],[-19,-31],[-46,-6],[-32,-13],[-32,25],[-4,35]],[[6789,83718],[20,17],[4,76],[18,75],[25,34],[5,44],[15,-8],[34,70],[33,36],[39,-15],[29,1],[0,-112],[26,-57],[4,45],[17,53],[-18,48],[6,25],[53,-14],[-3,35],[-52,44],[-19,-4],[-1,127],[31,61],[29,29],[20,-12],[22,-56],[6,-133],[15,13],[9,77],[-5,55],[35,-38],[7,47],[-37,36],[-21,58],[7,44],[17,-6],[51,-87],[9,4],[30,-41],[11,10],[-31,75],[-20,34],[-7,44],[17,0],[30,-58],[29,12],[41,-29],[7,49],[36,15],[-8,-63],[-39,-106],[-7,-83],[19,-36],[0,95],[16,43],[16,-49],[5,46],[17,32],[5,41],[14,10],[10,-31],[22,72],[17,8],[-4,-45],[28,-16],[-11,-38],[-11,20],[-18,-15],[19,-36],[-5,-49],[19,22],[11,-51],[27,1],[-24,-53],[-16,33],[-24,2],[-15,-48],[16,-9],[-8,-53],[26,-8],[-26,-89],[23,17],[13,47],[5,-35],[47,-4],[-3,-41],[-36,-78],[-13,-110],[-38,13],[-2,39],[-10,-41],[-23,42],[-17,-6],[-23,49],[-15,-13],[-24,19],[-8,-46],[27,1],[15,-17],[45,-87],[-8,-70],[-23,-52],[-11,36],[-19,-50],[-19,30],[-6,38],[-21,18],[-20,-12],[-17,-37],[29,2],[20,-49],[-38,-53],[-34,12],[-4,-20],[25,-34],[14,13],[35,1],[22,-43],[-11,-28],[-24,-8],[-34,-33],[-8,11],[-19,-29],[3,-49],[-27,-50],[-13,20],[7,34],[-23,50],[7,47],[27,62],[-8,24],[-15,-21],[-34,-105],[-3,-24],[-22,32],[-22,-10],[-5,-35],[26,-6],[10,-63],[-16,-61],[-25,-20],[1,-70],[-25,-41],[-12,13],[-23,-82],[-19,-30],[-18,21],[-31,-20],[22,116],[11,11],[26,71],[24,31],[-2,37],[-33,-23],[3,52],[22,102],[29,52],[-7,30],[-15,-45],[-34,-61],[-26,-112],[-24,-59],[-14,-11],[-5,-44],[-19,-30],[-4,84],[-26,58],[-33,27],[3,100],[-4,106],[-13,83],[-11,32],[-23,20],[-27,5],[14,30],[-15,37],[5,23]],[[6782,82633],[27,101],[51,97],[21,-4],[16,-54],[-12,-23],[-55,-73],[-29,-79],[-19,35]],[[6519,81925],[26,41],[5,38],[13,22],[8,-32],[-6,-43],[5,-68],[-7,-33],[-36,13],[-8,62]],[[6240,82171],[5,47],[14,25],[13,-59],[-13,-63],[-19,50]],[[6921,85216],[136,0],[0,101],[50,0],[0,134],[106,0]],[[7213,85451],[-26,-13],[-14,-118],[-12,-39],[-30,-25],[-11,-55],[-24,-33],[-48,0],[-15,-17],[-4,-94],[-12,-33],[-27,1],[-5,-20],[10,-79],[11,-32],[-27,-36],[-20,15],[-2,-45],[20,-46],[-11,-81],[-21,-30],[-6,-33],[9,-24],[-23,0],[-14,-52],[-26,66],[-9,-7],[5,-57],[-4,-40],[-21,-3],[-12,-43],[-17,16],[0,27],[-20,-1],[-4,-39],[-22,-24],[-23,31],[-28,-17],[-35,-69],[15,-52],[-9,-51],[-40,-44],[-28,-2],[1,-53],[14,-25],[-6,-40],[-20,-16],[-36,59],[-10,30],[-20,-20],[-5,-63],[1,-69],[-26,-27],[-3,-97],[-65,-7],[-21,24],[-2,-74],[8,-71],[-20,0],[-12,37],[-21,3],[-4,-39],[-32,-27],[-39,-92],[-15,-12],[-5,-44],[13,-11],[47,64],[4,-50],[-6,-53],[-15,-7],[0,-31],[18,-38],[-6,-26]],[[6350,83478],[-32,-5],[-78,8],[0,85],[22,-1],[0,68],[14,-1],[1,50],[22,-2],[-4,36],[14,-2],[-2,84],[14,-1],[0,52],[24,17],[1,34],[45,0],[21,-15],[0,34],[17,20],[0,33],[33,16],[0,-52],[9,1],[14,53],[14,0],[-7,34],[-15,-1],[0,46],[37,1],[5,83],[16,-1],[-1,69],[43,2],[1,30],[25,1],[0,52],[33,6],[-1,200],[14,-1],[1,71],[-15,-1],[0,100],[31,0],[0,50],[46,0],[-1,33],[15,0],[-1,30],[39,0],[0,17],[39,-1],[0,33],[44,0],[0,33],[29,0],[10,68],[22,-2],[-1,50],[15,0],[-1,224]],[[6225,82357],[9,35],[3,-82],[-10,-1],[-2,48]],[[6080,82757],[21,48],[48,-3],[25,-54],[-35,23],[-16,-26],[-43,-6],[0,18]],[[5919,82533],[19,25],[11,-57],[-9,-11],[-21,43]],[[5642,81925],[8,64],[19,12],[27,-58],[-8,-18],[-21,37],[-25,-37]],[[5573,81984],[16,-49],[-27,12],[11,37]],[[5506,81836],[8,67],[10,10],[11,-62],[-29,-15]],[[5643,83066],[30,-30],[31,19],[8,59],[-13,47],[-2,46],[15,122],[29,108],[41,130],[24,62],[22,37],[40,41],[21,52],[22,87],[14,15],[26,62],[30,25],[8,-74],[18,-15],[4,41],[-10,105],[-23,-2],[-6,34],[2,95],[9,59],[25,409],[14,42],[38,16],[12,53],[-20,-9],[-34,77],[-3,62],[9,97],[20,106],[27,33],[28,97]],[[6173,85487],[4,64],[13,38],[-20,0],[-11,-32],[-8,-68],[-36,-49]],[[6115,85440],[1,280],[-22,0],[0,202],[47,0],[0,101],[93,0],[0,101],[27,0],[0,101],[47,0],[0,100],[95,0],[0,101],[46,0],[0,1413]],[[6449,87839],[293,0],[192,0],[228,0]],[[7162,87839],[0,-101],[12,0],[0,-404],[-36,0],[0,-403],[-36,0],[0,-404],[-35,0],[0,-101],[-48,0],[0,-201],[-47,0],[0,-101],[-81,0],[0,-202],[-93,0],[0,-202],[15,0],[0,-403],[14,0],[0,-101],[94,0]],[[6350,83478],[-22,-38],[-2,-49],[-26,-44],[-8,-32],[2,-42],[-32,14],[-31,-28],[-4,-70],[-12,-12],[-19,75],[-8,-53],[-27,-42],[-11,-53],[-24,-6],[5,-50],[-17,-27],[-25,43],[-24,67],[-22,-16],[0,-51],[11,-5],[1,-36],[-29,-10],[-13,-67],[6,-32],[18,-6],[5,-52],[-36,-4],[-24,-15],[-17,77],[-51,-38],[-18,-51],[-16,-3],[-9,-49],[19,-1],[27,25],[20,-17],[6,-54],[-16,-47],[-43,44],[-23,11],[-5,-70],[-33,6],[-23,21],[-20,-33],[-27,-88],[2,-44],[47,-20],[32,-36],[-3,-29],[-32,-42],[1,-23],[18,-4],[25,31],[16,-7],[-55,-78],[-23,-63],[1,-52],[-13,50],[-10,-17],[16,-66],[-6,-50],[-7,39],[-10,-2],[-2,-53],[-25,80],[0,95],[-19,-60],[8,-73],[-4,-67],[-24,-6],[3,58],[-35,1],[-16,-80],[-25,-9],[-75,-43],[-29,-22],[-7,-22],[-3,-74],[-17,46],[5,80],[-23,-19],[10,-30],[1,-104],[-16,-71],[6,-46],[-7,-31]],[[9331,87212],[28,-14],[12,-44],[-27,-9],[-13,67]],[[9232,87245],[16,14],[58,-26],[-3,-31],[-21,-10],[-50,53]],[[8867,87809],[26,35],[27,3],[15,-16],[-18,-53],[-50,31]],[[8817,87545],[4,86],[28,16],[21,-89],[-11,-44],[-37,-10],[-5,41]],[[8816,87079],[2,14],[43,47],[1,-36],[-40,-59],[-6,34]],[[8698,86532],[8,21],[3,71],[23,12],[-3,42],[21,54],[16,7],[-3,41],[30,34],[9,30],[43,75],[22,118],[27,44],[-3,40],[10,71],[27,34],[4,-43],[24,2],[-17,-51],[9,-17],[24,28],[8,-22],[-11,-37],[-62,-118],[-49,-129],[-8,-80],[-33,-60],[30,-57],[-19,-42],[-23,-8],[-22,15],[-17,-57],[-9,6],[-45,-47],[-14,23]],[[8692,87068],[44,270],[11,-41],[12,13],[-4,66],[44,84],[0,-54],[-12,-32],[-3,-82],[-20,-37],[20,-42],[-24,-97],[2,-46],[-17,-104],[-24,45],[-3,25],[-25,7],[-1,25]],[[8672,87628],[15,31],[17,-19],[17,-48],[-24,-45],[-25,81]],[[8549,88444],[115,0],[235,0],[0,52],[73,0],[0,403],[-5,0],[0,404],[-5,0],[0,101],[155,0],[-4,302],[0,404],[-3,117],[-13,0],[0,246]],[[9097,90473],[43,25],[56,-7],[8,39],[267,0],[0,-101],[160,0],[0,-17],[143,0],[260,0],[2,-88],[7,-39],[27,-14],[-10,-31],[2,-43],[-18,-61],[-31,-59],[43,-68],[12,-5],[-25,-76],[-4,-42],[-16,-16],[19,-42],[25,0],[19,-23],[5,19],[27,-12],[11,62],[14,4],[6,65],[60,-35],[53,0],[0,-101],[52,0],[0,-101],[42,0],[0,-403],[-11,0],[0,-54],[51,-1],[0,-248],[231,0]],[[10627,89000],[2,-971],[-1,-789]],[[10628,87240],[-59,0],[0,51],[-161,0],[0,100],[-301,0],[-90,0],[-195,-579],[0,-44]],[[9822,86768],[-39,39],[-45,-26],[-64,-120],[-46,-115],[6,65],[36,103],[62,117],[46,2],[-16,66],[-49,48],[-8,25],[-10,-82],[-26,84],[-26,30],[-17,-9],[-16,27],[-71,19],[9,28],[38,23],[-42,33],[-19,-6],[-2,25],[37,156],[-15,15],[-13,-36],[-29,-22],[-1,-57],[-20,-66],[-39,12],[-70,97],[1,31],[-26,36],[-39,26],[-41,-35],[-22,27],[13,29],[31,32],[25,74],[-14,10],[-18,-49],[-79,-93],[-29,-23],[-38,5],[1,-54],[60,27],[11,-24],[2,-53],[-17,2],[-28,-37],[-18,6],[-41,-38],[-41,-77],[-12,2],[-12,48],[47,77],[-37,-12],[-17,11],[-1,54],[23,83],[13,27],[18,2],[20,-31],[24,17],[22,41],[38,13],[57,58],[42,20],[-9,25],[-19,-2],[1,71],[-11,-49],[-19,-20],[1,30],[25,65],[1,21],[-33,-58],[-45,-47],[-19,-3],[-4,30],[63,112],[-6,38],[-29,-60],[-38,-14],[-12,26],[-15,-49],[-20,-14],[-54,13],[-10,58],[27,19],[11,-9],[18,25],[40,16],[29,28],[23,65],[-25,2],[-14,-46],[-23,-19],[-45,-2],[-18,68],[-12,3],[-17,-69],[-21,-8],[-4,59],[16,26],[17,-6],[-11,44],[-3,55],[13,34],[26,114],[96,6],[-7,38],[-91,-5],[-21,-63],[-27,-26],[-21,-77],[-31,-48],[-23,12],[20,36],[-10,113],[-12,53],[18,30],[-22,10],[-14,-23],[-1,-51],[12,-63],[-14,-63],[1,-41],[-13,-15],[-26,48],[-2,-67],[-27,-45],[-21,22],[0,52],[-11,19],[-7,-73],[-9,15],[4,129],[9,62],[-15,11],[-17,-130],[9,-111],[-4,-29],[-19,-9],[1,49],[-27,34],[-7,-46],[16,-65],[-13,-8],[-38,16],[-34,-48],[-28,9],[-5,31],[14,95],[42,151],[1,53],[49,123],[16,81],[-6,18],[-73,-211],[-1,-35],[-18,-58],[-8,8],[-8,69],[-12,-1],[-3,-81],[-11,-54],[-18,-42],[-3,-64],[-16,-68],[-21,27],[-7,-44],[24,-28],[-5,-91],[10,-8],[19,85],[37,6],[11,-22],[4,-91],[-14,-45],[-31,-32],[-22,-76],[1,-63],[21,20],[17,75],[30,44],[30,-89],[0,-44],[10,-43],[-23,-192],[-26,0],[-9,52],[-19,9],[1,-36],[-27,-44],[0,-17],[28,14],[23,-27],[61,-124],[26,-85],[-15,-77],[-13,-26],[-34,-35],[-17,16],[-14,-18],[-29,-6],[9,51],[-26,67],[9,60],[-17,63],[-16,-126],[0,-62],[-12,-41],[-19,69],[-20,-75]],[[8515,86711],[6,220],[0,336],[-28,0],[2,67],[0,303],[-25,0]],[[8470,87637],[2,135],[74,0],[0,370],[3,302]],[[22518,67986],[99,-1]],[[22617,67985],[1,-409]],[[16570,69317],[142,2]],[[16712,69319],[180,-1]],[[16892,69318],[22,-13],[1,-26],[20,33],[18,-34],[15,-3]],[[16968,69275],[5,-22],[0,-85],[-19,-3],[-6,-32],[9,-78],[-3,-27],[-20,1],[-28,-49],[-14,0],[4,-46],[45,-41],[10,-52],[-19,-68],[3,-64],[-16,-25],[-4,-51],[7,-41],[-17,-46],[-8,-72],[5,-18],[69,1]],[[16971,68457],[2,-252]],[[16973,68205],[-101,1],[-64,9],[0,-102],[-234,-2]],[[16574,68111],[1,405]],[[16575,68516],[1,601],[-6,0],[0,200]],[[26717,63148],[2,136]],[[26719,63284],[117,-20]],[[26836,63264],[-5,-272],[31,-8]],[[26862,62984],[-3,-100]],[[26859,62884],[-71,13],[1,31],[-76,12]],[[26713,62940],[4,208]],[[27344,65072],[0,-249]],[[27344,64823],[0,-171],[-24,1]],[[27320,64653],[-85,0]],[[26404,53118],[72,-1]],[[26476,53117],[0,-126],[11,-74],[-2,-268]],[[26485,52649],[-55,11]],[[26430,52660],[-27,5]],[[31239,38121],[12,14],[22,-23]],[[31273,38112],[17,-20]],[[31290,38092],[-5,-37],[-20,14]],[[31265,38069],[-14,-8]],[[31251,38061],[-20,35]],[[31231,38096],[8,25]],[[27523,61437],[2,139],[6,-11],[24,62]],[[27555,61627],[36,99],[24,-17],[46,108],[17,183],[8,35],[12,-33],[-3,-33],[17,-21],[5,29],[10,-29]],[[27727,61948],[2,-51],[-8,-34]],[[27721,61863],[-14,-121],[3,-65],[-12,-60],[-22,-87],[4,-45]],[[27680,61485],[-10,-20],[-25,-81],[-7,-56],[6,-29],[-10,-50]],[[27634,61249],[-41,-9],[-17,-23],[-27,12],[-27,79],[1,129]],[[31178,38330],[16,-72]],[[31194,38258],[-12,-19]],[[31182,38239],[-13,76],[9,15]],[[23087,71221],[30,0],[0,102]],[[23117,71323],[206,-3],[75,2]],[[23398,71322],[3,-102],[0,-304]],[[23401,70916],[2,-100],[0,-205]],[[23230,70612],[-139,1]],[[23091,70613],[1,203],[-5,0],[0,405]],[[26336,57669],[83,0]],[[26419,57669],[54,-1]],[[26473,57668],[-14,-41],[20,-76],[-10,-39],[1,-54],[13,-7],[-3,-86],[-15,-92]],[[26465,57273],[-9,-53]],[[26456,57220],[-2,18]],[[26454,57238],[1,24],[-17,30],[0,62],[-17,104],[-30,58],[-55,-2]],[[26336,57514],[0,155]],[[23026,73018],[144,-3],[109,1]],[[23279,73016],[0,-177],[3,0]],[[23282,72839],[0,-101]],[[25055,63285],[21,-14],[1,-170],[31,-1]],[[25108,63100],[1,-359],[-32,4]],[[25077,62745],[-109,0],[-1,204]],[[24967,62949],[0,136],[15,0],[0,50],[15,-1],[0,92],[8,-24],[12,35],[14,5],[16,58],[8,-15]],[[25967,64717],[72,4]],[[26039,64721],[1,-52],[11,0]],[[26051,64669],[1,-406]],[[26052,64263],[-63,-2]],[[25989,64261],[-21,-1],[-2,406]],[[19527,61757],[189,0],[1,195]],[[19717,61952],[244,1]],[[19961,61953],[0,-427],[-37,0]],[[19924,61526],[0,35],[-139,-1],[8,-20],[5,-68],[21,0],[20,-43],[-2,-77],[-5,0]],[[19832,61352],[-263,3],[-37,-2]],[[24684,53433],[80,1]],[[24764,53434],[1,-407]],[[24765,53027],[-25,-1]],[[24684,53026],[0,407]],[[21756,73450],[0,101],[182,0],[0,-102],[36,0]],[[21974,73449],[0,-202],[11,0],[0,-406],[11,0],[0,-203]],[[21996,72638],[-108,0]],[[21888,72638],[-108,1]],[[21780,72639],[1,202],[-13,1],[0,406],[-12,0],[0,101]],[[24230,64550],[128,2]],[[24358,64552],[0,-102]],[[24358,64450],[1,-251]],[[24359,64199],[-4,18],[-59,-9]],[[24230,64202],[0,348]],[[24670,63258],[32,-1],[0,-41],[32,0],[-1,-102],[10,-1],[0,-33],[10,0],[0,-136]],[[24753,62944],[-78,2]],[[24675,62946],[3,20],[-10,115],[-11,76],[13,101]],[[26539,55178],[50,121]],[[26644,55174],[7,-25],[-25,-100],[-7,4],[-2,-61],[4,-29]],[[26621,54963],[-19,12],[-10,21]],[[26592,54996],[-10,2],[-20,42],[-23,104],[0,34]],[[31463,38060],[24,-12],[10,42]],[[31509,38021],[0,-3]],[[31509,38018],[-14,-3],[-7,-19],[-3,-60],[-8,16]],[[31477,37952],[-10,-5],[-6,57]],[[26462,67956],[0,-299]],[[26462,67657],[-1,-101],[-55,-1],[0,-18]],[[22165,62493],[151,0]],[[22316,62493],[3,1]],[[22319,62494],[0,-323],[-1,-185]],[[22318,61986],[-151,-1]],[[22163,61985],[2,508]],[[21634,73979],[103,-1],[263,0]],[[22000,73978],[0,-326],[10,0],[0,-202]],[[22010,73450],[-36,-1]],[[2682,386],[26,11],[1,-51],[-9,8],[-8,-28],[-10,60]],[[2636,452],[21,8],[-4,-21],[-13,-12],[-4,25]],[[2341,307],[11,-49]],[[2352,258],[-15,-50],[-11,47],[-13,16],[13,35],[15,1]],[[26177,64974],[108,8]],[[26285,64961],[0,-307]],[[26285,64577],[-76,-6]],[[26209,64571],[-73,-1]],[[26136,64570],[1,103]],[[26137,64673],[-1,202],[8,0],[0,99]],[[23155,62998],[69,-1],[0,102]],[[23224,63099],[63,0]],[[23287,63099],[-2,-102],[0,-171]],[[23285,62826],[-5,0],[0,-236]],[[23280,62590],[-125,1]],[[23155,62591],[1,67],[-1,340]],[[24358,64552],[1,304]],[[24359,64856],[64,0]],[[24423,64856],[32,-2],[0,-101]],[[24455,64753],[0,-304],[-11,0]],[[24444,64449],[-86,1]],[[25758,63711],[95,-1],[31,3]],[[25884,63713],[1,-296]],[[25885,63417],[-24,-3]],[[25758,63413],[0,298]],[[16062,64021],[7,-109],[25,-13],[11,-36],[-10,-13],[8,-26],[-5,-74],[-11,-25],[-9,5],[0,-51]],[[16078,63679],[-4,-34],[-16,-25],[-21,0],[-3,-50],[-11,-37],[-3,-51],[-16,2],[-12,-53],[-1,-37],[-15,-26],[-67,-1],[-7,-50],[7,-50]],[[15909,63267],[-249,1]],[[15660,63268],[-6,54],[3,73],[8,11],[-4,71]],[[15661,63477],[-5,24],[-2,118],[-8,53],[5,48],[-2,64],[-20,31],[-4,22]],[[25989,64261],[0,-100]],[[25989,64161],[-84,-3]],[[25905,64158],[-1,404]],[[22074,71224],[130,-2]],[[22204,71222],[115,-1]],[[22319,71221],[0,-404]],[[22319,70817],[-234,-1]],[[22085,70816],[-11,1],[0,407]],[[23386,58933],[25,0],[0,102],[30,0]],[[23441,59035],[59,-1]],[[23500,59034],[0,-303],[-2,0],[0,-305]],[[23498,58426],[-90,0]],[[23408,58426],[1,202],[-39,1]],[[23370,58629],[11,57],[-15,49],[0,70],[15,52],[5,76]],[[22068,68386],[15,-76],[32,7],[32,-40],[16,26],[-10,45],[-17,12],[-4,24],[13,28]],[[22230,68082],[1,-48],[13,-38],[-16,-79],[-13,-20],[1,-81],[-14,-22],[0,-36],[23,1],[9,-47],[1,-41],[16,-58],[-4,-36]],[[22247,67577],[0,-1]],[[22181,67577],[-23,0],[-2,17],[0,264],[-12,27],[-5,-43],[-3,38],[-16,-59],[-13,0],[-19,-40],[-10,27],[-28,-7],[-2,18],[-29,-26],[-21,24],[-6,-23],[-5,32]],[[21987,67826],[-14,-20],[-16,23]],[[21957,67829],[-1,152],[-7,0],[0,374]],[[21949,68355],[0,30],[119,1]],[[23290,72233],[0,-406]],[[23290,71827],[-143,1]],[[23147,71828],[0,404]],[[24749,68956],[0,-303]],[[24749,68653],[-68,-3],[-67,1],[0,101],[-34,0],[0,101]],[[24580,68853],[0,304]],[[24580,69157],[0,202]],[[21737,61990],[86,-1]],[[21823,61989],[36,0]],[[21860,61482],[-116,0]],[[21744,61482],[-7,0]],[[21737,61482],[0,508]],[[23052,73979],[303,-1]],[[23355,73978],[-1,-74],[6,-36],[18,-27],[27,16],[13,30],[1,-242],[-71,0],[1,-201]],[[23349,73444],[-73,-2]],[[23276,73442],[-219,7]],[[23057,73449],[0,201],[-4,0],[-1,329]],[[23955,58531],[60,-5]],[[24015,58526],[39,-3]],[[24054,58523],[-1,-202],[-10,1],[0,-101]],[[24043,58221],[-1,-338],[-12,-2]],[[24030,57881],[-8,6],[-27,-15],[-7,-52],[-10,11],[-1,63],[-12,-2],[-7,64],[-13,43],[-12,6],[-9,47]],[[23924,58052],[-6,11]],[[23918,58063],[1,166],[20,-1],[1,152],[14,-2],[1,153]],[[25989,71075],[0,215]],[[25989,71290],[42,-15],[35,-3],[30,7],[68,88]],[[26164,71367],[0,-594]],[[26164,70773],[-175,-1]],[[25989,70772],[0,303]],[[23982,61791],[-2,-310]],[[23980,61481],[-2,-89],[7,-1],[-2,-144]],[[23983,61247],[-122,13]],[[23855,61416],[4,279],[-1,76]],[[24054,58523],[50,-4],[0,84],[60,-3]],[[24164,58600],[-1,-84],[50,-5]],[[24213,58511],[-1,-202],[-2,-17],[-1,-186]],[[24209,58106],[-63,5]],[[24146,58111],[0,101],[-103,9]],[[28554,60453],[16,-77],[29,-85]],[[28599,60291],[7,-29],[22,11],[-1,-71]],[[28627,60202],[-5,-10],[5,-57]],[[28627,60135],[-11,-14]],[[28616,60121],[-7,9],[-15,88],[-14,49],[-7,-8]],[[28573,60259],[-3,29],[-17,15]],[[28553,60303],[-5,48],[-8,-18],[-5,34]],[[28535,60367],[-8,56],[4,18],[19,-3],[4,15]],[[24089,60088],[121,-8]],[[24210,60080],[45,-4]],[[24255,60076],[-2,-305],[-5,0]],[[24248,59771],[-181,14]],[[24067,59785],[-41,3]],[[17948,73980],[183,-2]],[[18131,73978],[13,-42],[-6,-36],[9,-25],[-12,-26],[18,-42],[-3,-24],[14,-15],[12,34],[32,-3],[10,-34],[-4,-22],[18,-74],[-12,-138],[41,-46],[17,11],[21,-44],[0,-85],[-4,-20],[25,-47],[9,8],[5,-61],[-12,-37],[10,-34]],[[18332,73176],[16,-52],[15,-21],[2,-89],[11,5],[16,-43],[19,14],[4,-34],[10,12]],[[18425,72968],[9,-16],[0,-51],[13,-21],[-3,-29],[11,-1],[8,-63],[-9,-34],[-21,8]],[[18389,72344],[-51,0],[-39,6]],[[18299,72350],[-47,0]],[[18252,72350],[8,73],[1,68],[-17,28],[3,33],[-6,107],[3,20],[-22,78],[-17,35],[-11,-2],[-11,86],[-41,-1],[-13,-33],[11,-70],[-127,-1],[0,-101],[4,0],[0,-99],[-35,0]],[[17982,72571],[0,99],[-107,-3],[0,152],[-6,17]],[[17869,72836],[0,141],[-3,101],[48,0],[0,405],[-11,0],[0,99],[69,0],[-14,23],[3,54],[19,31],[-17,56],[-17,12],[12,37],[-8,113],[10,40],[-12,32]],[[21473,55808],[144,6]],[[21617,55814],[0,-505]],[[21617,55309],[-37,1]],[[21580,55310],[-107,-3]],[[21473,55307],[0,501]],[[24411,60929],[62,-2],[-1,-102],[44,-3]],[[24516,60822],[-1,-127]],[[24515,60695],[-44,6],[0,-103],[29,-3],[-1,-101]],[[24499,60494],[-121,9]],[[24378,60503],[-30,1],[0,203],[-15,1]],[[24333,60708],[1,224],[77,-3]],[[22019,53128],[142,0]],[[22161,53128],[0,-171],[33,0]],[[22194,52957],[1,-268]],[[22195,52689],[-176,0]],[[21985,54286],[-119,4]],[[24376,60067],[2,233],[0,203]],[[24499,60494],[11,-1],[-1,-119],[5,1],[0,-68],[10,0],[-1,-64],[11,4],[5,-47],[10,8],[5,-31],[-1,-55]],[[24553,60122],[-24,-11],[-31,0],[-2,-236]],[[24496,59875],[-121,6]],[[24375,59881],[1,186]],[[21698,53784],[1,508]],[[21699,54292],[22,0]],[[21822,54291],[-1,-455]],[[21698,53674],[0,110]],[[20920,61345],[18,0],[6,-17],[35,-10],[3,-12],[61,0],[0,68],[30,1],[2,108]],[[21075,61483],[29,0]],[[21104,61483],[0,-515],[-2,-208]],[[21102,60760],[-182,0],[-1,106]],[[20919,60866],[1,102],[0,377]],[[21617,55814],[145,3]],[[21762,55817],[0,-497]],[[21762,55320],[-38,-8]],[[21724,55312],[-107,-3]],[[20566,62490],[83,0]],[[20649,62490],[1,-304],[-11,1],[-1,-82],[37,-3],[-1,-171]],[[20674,61931],[-83,-3],[1,58],[-26,0]],[[20566,61986],[0,504]],[[17579,73067],[10,-12],[-1,-43],[17,-23],[6,41],[38,45],[8,42],[17,-14],[10,-60],[-6,-24],[14,-50],[2,-66],[28,-109],[-5,-52],[14,-33],[21,3],[7,28],[7,-36],[16,18],[11,-34],[26,32],[5,66],[10,8],[-3,42],[38,0]],[[17982,72571],[6,-51],[0,-168],[65,0],[6,-52],[-10,-19],[-5,-67],[23,15],[4,-33],[-11,-1],[-8,-90],[18,-40],[24,0],[0,-202],[4,-51]],[[18098,71812],[-18,-20],[-29,43],[3,21],[-22,40],[-8,-3],[-31,54],[-34,23],[-6,-22],[-25,16]],[[17928,71964],[-12,0],[0,34],[-36,17],[-2,96],[-31,37],[-11,-4],[-8,28],[-35,46],[-17,-19],[-16,17],[-12,-23],[-23,35],[-2,-23],[-26,4]],[[17697,72209],[-16,7],[-5,57],[-11,5],[2,34],[13,32],[-12,55],[2,63],[-13,24],[-7,47],[-8,-6],[-8,88],[-15,21],[-39,153]],[[17580,72789],[-1,278]],[[22154,54789],[5,0]],[[22298,54789],[-2,-506]],[[22275,54282],[-121,3]],[[22053,55817],[1,-509]],[[22054,55308],[-43,0]],[[21906,55311],[1,506]],[[22581,58122],[22,0],[18,-37],[2,34],[7,-25],[36,-24],[6,15],[9,-26],[19,14]],[[22700,58073],[0,-556],[1,-3]],[[22701,57514],[0,-203]],[[22701,57311],[-118,0]],[[22582,57513],[0,272],[1,134],[-2,203]],[[23358,55793],[1,1]],[[23359,55794],[14,-12],[36,26]],[[23409,55808],[0,-414]],[[23409,55394],[-7,-24]],[[23402,55370],[-6,-60],[-38,1]],[[23358,55311],[0,482]],[[23144,55166],[40,-1]],[[23184,55165],[3,-26],[16,-44],[19,-2],[24,-35],[14,-40],[7,11]],[[23267,55029],[11,-39]],[[23278,54990],[0,-241],[26,-82],[15,-63]],[[23319,54604],[-175,2]],[[23144,54606],[0,560]],[[22056,64317],[79,0],[15,-17]],[[22151,63911],[-126,1]],[[22025,63912],[-1,101],[32,0],[0,304]],[[22657,64316],[127,0]],[[22784,64316],[0,-405]],[[22784,63911],[-126,0]],[[22658,63911],[-1,0]],[[23083,55333],[0,431]],[[23083,55764],[122,67]],[[23205,55831],[-1,-222]],[[23204,55609],[-1,-255],[1,-24]],[[23204,55330],[-23,1],[-12,-121],[15,-45]],[[23144,55166],[-61,4]],[[23083,55170],[0,163]],[[23098,52995],[20,25],[34,85],[20,28],[59,3]],[[23231,53136],[11,-17],[17,5],[8,-54],[-13,-59],[12,-70],[6,4]],[[23204,52868],[-86,-48]],[[23118,52820],[-2,41],[-10,62],[4,24],[-12,48]],[[22730,56855],[0,253]],[[22730,57108],[59,0]],[[22789,57108],[0,-152],[84,-1],[6,-50],[26,0]],[[22905,56905],[0,-186]],[[22905,56719],[-9,0],[-1,-118]],[[22895,56601],[-164,0]],[[22731,56601],[-1,254]],[[28101,62058],[9,-2],[19,41],[9,72],[6,12]],[[28144,62181],[22,-76],[7,-4],[3,-80],[22,-36]],[[28198,61985],[-43,-115],[-24,-89],[-15,13]],[[28116,61794],[-30,111]],[[28086,61905],[7,64],[-5,23],[3,41],[10,25]],[[25644,57317],[55,-124],[32,-34]],[[25731,57159],[11,6],[8,32],[13,-6],[3,-30],[14,29],[13,-2],[5,-34]],[[25798,57154],[-9,-204],[0,-77]],[[25789,56873],[-147,11]],[[25642,56884],[2,433]],[[28045,61665],[9,63]],[[28054,61728],[5,-30],[-2,-46],[4,-50],[22,-105],[17,-5]],[[28100,61492],[-22,-103]],[[28078,61389],[-82,109]],[[27996,61498],[30,66],[3,35],[16,66]],[[5096,90290],[0,303],[53,0],[0,100],[-7,0],[0,202],[54,0],[0,101],[107,0],[1,101],[49,0],[0,101],[55,0],[0,302],[-59,0],[-4,403],[0,404],[52,0],[0,201],[57,0],[-3,202],[0,202],[57,0],[-2,302],[-58,0]],[[6639,96096],[257,0],[276,0],[245,0],[236,0],[236,0],[231,0],[239,0],[173,0],[215,0],[194,0],[294,0],[0,582],[180,0],[194,0],[262,0],[208,0],[206,0],[342,-1]],[[10627,96677],[0,-3096]],[[10627,93581],[-26,-17],[-68,-139],[0,-28],[-22,-86],[-37,-45],[-25,-54],[-36,-19],[-8,-40],[-55,-35],[-31,31],[-58,-37],[-27,-31],[-16,-40],[-32,17],[-20,-18],[-5,-36],[-26,-30],[10,-16],[0,-70],[-11,-56],[-20,-53],[-24,-4],[-47,-40],[-16,-41],[-16,-3],[-21,-41],[-13,1],[-9,-41],[-40,-58],[10,-47],[-7,-62],[17,-53],[-23,-27],[2,-47],[-25,-36],[-17,-63],[-23,-22],[-89,41]],[[9773,92236],[-11,50],[22,56],[-24,31],[12,82],[0,43],[21,40],[1,38],[-28,44],[51,66],[4,23],[-26,34],[-81,-6],[-30,-40],[-22,-9],[-52,29],[-31,7],[-28,32],[-38,-3],[-67,-66],[-40,15],[-33,-20],[-39,-40],[-8,42],[-26,19],[37,60],[-12,54],[-63,28],[-26,20],[-33,55],[-3,51],[42,87],[-7,22],[-26,-6],[-21,47],[-99,-23],[9,-52],[-16,-41],[-47,-40],[-78,-36],[-79,-1],[-76,-81],[-308,2],[3,-404],[0,-323],[27,37],[35,-50],[7,-50],[36,-46],[27,-106],[36,-67]],[[8665,91840],[-303,0],[0,17],[-236,0],[-209,0],[-61,-168],[-93,-252],[-35,0],[-30,27],[8,28],[-21,29],[-64,0],[-19,-59],[9,-25],[-61,0],[-2,-202],[-48,0],[0,-201],[-180,0],[0,-202],[17,0],[0,-151],[54,0],[0,-51],[53,0],[0,-141],[-70,-234],[-89,-296]],[[7285,89959],[-1,-10],[1,-496]],[[7285,89453],[-20,0],[0,-101],[-90,0],[0,-101],[-102,0],[0,-101],[-181,0],[-182,0],[-224,0],[-333,0],[0,101],[-159,0],[-250,0],[0,-101],[-205,0],[0,-101],[-353,0]],[[27478,63459],[13,-12],[6,25],[16,5],[4,19],[20,13],[37,3],[13,-23],[19,25],[4,-36],[14,5]],[[27624,63483],[-4,-28],[15,-7],[9,-33],[3,-52],[-7,-39],[9,-62],[-8,-14],[9,-44],[-4,-26]],[[27646,63178],[-140,0]],[[27506,63178],[-28,0]],[[27478,63178],[1,198],[-1,83]],[[24286,56276],[87,0],[30,-10]],[[24403,56266],[30,-3],[-1,-253]],[[24432,56010],[-1,-203]],[[24431,55807],[-148,11]],[[24283,55818],[-5,152],[8,1],[1,203]],[[24799,56194],[0,102],[44,1],[15,16],[0,86]],[[24858,56399],[43,0],[0,-35],[73,0]],[[24974,56194],[0,-51]],[[24974,56143],[-78,-1]],[[24896,56142],[-95,0]],[[24801,56142],[-2,52]],[[27475,60166],[-14,-51]],[[27461,60115],[-3,44],[11,22],[6,-15]],[[27478,60164],[0,0]],[[23899,63948],[143,4],[-1,-50]],[[24041,63902],[0,-356]],[[24041,63546],[-141,-5]],[[23900,63541],[-1,272]],[[23899,63813],[0,135]],[[27086,60607],[20,42]],[[27106,60649],[11,-49],[30,-13],[13,31],[10,-4],[7,-30],[20,-20],[19,9],[8,-40],[10,18],[6,-24],[18,-22]],[[27258,60505],[-14,-101]],[[27244,60404],[-8,-21],[-8,-55],[-23,-17],[-2,-30],[-13,-29],[-34,-7],[-17,43]],[[27139,60288],[-2,29],[-12,25],[-18,3],[-7,52],[-14,31],[-2,90],[-15,22],[-1,33],[18,34]],[[28271,57652],[10,12],[38,-17],[38,-71],[10,35],[17,-15],[13,-45],[7,-89],[9,-30]],[[28413,57432],[11,-33],[8,-98],[-3,-37]],[[28429,57264],[-19,-25],[-41,-97],[-39,-75],[-15,-36]],[[28315,57031],[-17,42],[-10,119],[-19,165]],[[28269,57357],[1,75],[8,161],[-7,59]],[[23555,63208],[110,-1]],[[23665,63207],[0,-255]],[[23665,62952],[-1,-84]],[[23664,62868],[-109,2]],[[23555,62870],[0,86]],[[23555,62956],[0,252]],[[25953,52315],[8,25],[23,0],[8,35],[102,-5],[1,153],[14,0]],[[26109,52523],[14,-1]],[[26123,52522],[-2,-426]],[[26121,52096],[1,-322]],[[26122,51774],[-11,30],[-17,13],[-15,40],[-16,71],[-27,47],[-22,69],[-41,95],[-20,36]],[[25953,52175],[0,140]],[[31493,38404],[1,-65],[5,-30],[2,-70]],[[31501,38239],[-7,-22],[-11,2]],[[31483,38219],[1,95],[6,21],[-3,53]],[[31546,38362],[14,7],[0,-36]],[[31560,38333],[0,-98],[9,-21]],[[31569,38214],[-4,-24]],[[31565,38190],[-19,18]],[[31546,38208],[5,58],[-5,96]],[[31435,38321],[11,-44]],[[31446,38277],[-5,-84],[-5,-10]],[[31436,38183],[-10,-9]],[[31426,38174],[-9,40],[1,21]],[[15811,72557],[113,-3],[113,2],[36,4],[94,-1]],[[16167,72559],[15,-77],[-16,-33],[-3,-46],[6,-57]],[[16169,72346],[-29,-32],[-24,-97],[-35,-76],[-3,-57],[-8,-5],[10,-38],[1,-53],[24,-10],[1,-39],[-8,-27],[14,-14],[4,-85],[-26,-7],[4,-53]],[[15805,72024],[26,33],[0,50],[-8,58],[-8,11],[6,35],[-10,40],[-7,71],[22,38],[-24,58],[16,82],[-7,57]],[[15775,72069],[4,105],[10,72],[12,-52],[-2,-58],[19,-32],[-18,-27],[-5,-26],[-18,-12],[-2,30]],[[16200,73160],[-20,25],[8,54],[-6,32],[8,47],[-7,33],[7,41],[24,5],[0,35],[13,-7],[13,28],[11,-33],[15,-13],[17,27]],[[16283,73434],[15,1],[3,-42],[-7,-52],[7,-63],[17,-23],[-1,-69],[21,-19],[11,-37],[32,-74],[-3,-50],[38,-93],[23,-23],[1,-34],[14,-20],[11,-67],[50,0]],[[16515,72769],[3,-21],[-16,-48],[-1,-45],[-11,-19],[-10,-75],[-27,-21],[-11,15],[-17,-20],[-8,-42],[6,-48],[-10,-58],[1,-40],[-17,-69],[-7,-95],[9,-74],[44,-32],[12,-31],[-2,-90]],[[16453,71956],[-83,0],[-35,68],[-15,-12],[-4,33],[-23,6],[-16,33],[-2,25],[-14,7],[-6,27]],[[16255,72143],[0,0]],[[16255,72143],[-11,-12]],[[16244,72131],[0,0]],[[16244,72131],[-5,9]],[[16239,72140],[0,0]],[[16239,72140],[-18,15],[-2,31],[-18,69],[-18,27],[-13,58]],[[16170,72340],[0,1]],[[16170,72341],[-1,5]],[[16167,72559],[12,50],[-13,14],[-15,62],[8,106],[8,23],[-9,44],[9,23],[30,24],[17,46],[-3,34],[14,18],[-3,31],[-25,104],[3,22]],[[27199,51422],[55,4],[16,44],[15,9]],[[27285,51479],[31,-284]],[[27316,51195],[-15,-19],[2,-168],[-75,-6],[-1,161],[-3,-1]],[[27224,51162],[-12,-2],[-3,57],[-10,63],[0,142]],[[16453,71956],[5,-42],[19,-7]],[[16477,71907],[1,-109],[-11,-64],[9,-37],[12,-111],[1,-99],[10,-49],[-13,-93]],[[16486,71345],[-149,1],[0,101],[-35,1],[0,101],[-109,-1],[-18,67],[0,26],[-37,88],[-16,25],[-22,-21],[-6,20]],[[27229,50448],[-2,-56],[-11,-27],[1,-86],[36,-1],[0,-34],[95,3]],[[27348,50247],[10,-9],[5,-75],[15,-43],[2,-37],[-8,-45],[11,-100]],[[27383,49938],[-222,0]],[[27161,49938],[0,489],[3,22],[65,-1]],[[26616,54526],[25,132],[8,0]],[[26691,54507],[-8,-26],[23,-83],[-9,-33],[5,-20],[-9,-32]],[[26693,54313],[-6,21],[-16,11],[-5,-18],[-48,1]],[[24532,53400],[31,32],[98,1]],[[24661,53433],[23,0]],[[24679,53026],[-72,-1]],[[24607,53025],[-65,0]],[[24542,53025],[0,329],[-10,46]],[[22132,70014],[274,-3]],[[22406,70011],[1,-7],[0,-397]],[[22407,69607],[-237,2]],[[22170,69609],[-38,0]],[[22132,69609],[0,405]],[[25324,65206],[2,-305]],[[25326,64901],[1,-101],[-3,0]],[[25324,64800],[-93,-7]],[[22326,60971],[151,-1]],[[22477,60970],[2,-107]],[[22479,60863],[0,-304]],[[22326,60558],[0,306]],[[23863,67292],[131,0]],[[23994,67292],[0,-49]],[[23994,67243],[0,-356]],[[22913,65194],[24,-15],[20,11],[16,-28],[34,9],[18,-43],[9,-4]],[[23034,65124],[14,-33],[4,-58],[16,-58],[-4,-36],[10,-51]],[[23074,64888],[5,-87],[-8,-38],[5,-44]],[[23076,64719],[-8,-35],[-32,1]],[[23036,64685],[0,34],[-124,1]],[[22912,64720],[0,405],[1,69]],[[24074,57512],[24,-2],[0,-102],[28,-3],[0,-84],[14,-19],[16,-1],[0,-53],[26,-1],[1,-51],[29,-2],[-1,-101]],[[24211,57093],[-44,2],[0,-51],[-51,5],[-10,-50],[-13,1]],[[24093,57000],[-4,1],[0,68],[-15,1],[0,34],[-15,0]],[[24059,57104],[0,68],[-4,34],[-20,0],[1,52],[-29,2],[3,157],[-30,0]],[[23980,57417],[1,100],[68,-3],[24,-32],[1,30]],[[24949,68445],[-35,2]],[[24914,68447],[-1,307],[-33,0],[0,202]],[[23419,60796],[131,-2]],[[23550,60794],[1,-23]],[[23551,60434],[0,-30]],[[23551,60404],[-128,2]],[[23423,60406],[-4,51]],[[22590,54841],[125,-4]],[[22715,54837],[0,-276]],[[22715,54561],[-46,-2],[-46,-97]],[[22623,54462],[-34,324]],[[22589,54786],[1,55]],[[23067,61782],[0,253]],[[23067,62035],[113,0]],[[23180,62035],[-1,-51],[0,-304]],[[23179,61680],[0,-203],[-2,-104]],[[20921,67551],[294,-1]],[[21215,67550],[0,-555]],[[21215,66995],[-141,1]],[[21074,66996],[-152,0]],[[20922,66996],[0,345],[-1,210]],[[19735,72330],[31,8],[6,-12],[32,22],[25,-15],[13,-21],[8,-67],[-3,-69]],[[19852,71478],[14,-58],[4,-53]],[[19870,71367],[-121,-2],[-33,-5],[-70,-1]],[[19646,71359],[0,102],[6,0],[0,304],[-35,0],[0,100],[5,0],[0,101],[35,0],[0,42],[71,2],[6,8],[1,312]],[[25758,63752],[0,254]],[[25758,64006],[89,-1]],[[25847,64005],[18,0],[0,-50],[19,-17]],[[25884,63938],[0,-184]],[[25884,63754],[0,-41]],[[25758,63711],[0,41]],[[22619,71931],[71,-1]],[[22599,71221],[-113,1]],[[22486,71222],[0,405],[-8,0],[0,304]],[[29691,69069],[45,-69],[-18,-103],[31,-49],[-1,-9]],[[29748,68839],[-17,-91]],[[29731,68748],[-16,-97],[-29,66],[-16,-95],[-42,63]],[[29628,68685],[-10,8],[10,55],[-8,12],[1,42],[-27,94]],[[29594,68896],[10,28],[11,63],[15,-22],[4,56],[10,53],[37,18],[10,-23]],[[26480,55701],[12,14],[8,60],[19,16],[-3,38],[14,42]],[[26530,55871],[3,-31],[14,-57]],[[26547,55783],[6,-46],[7,-101],[-2,-72]],[[26558,55564],[-10,24],[-51,2]],[[26497,55590],[-23,0]],[[26474,55590],[0,58],[10,39],[-4,14]],[[24914,68447],[-50,2]],[[24864,68449],[-114,-1]],[[24750,68448],[-2,7],[1,198]],[[23730,66581],[1,306]],[[22194,52957],[110,0]],[[22304,52957],[0,-22],[35,0]],[[22339,52935],[1,-493]],[[22245,52444],[-50,0],[0,245]],[[23448,54816],[3,-2],[43,64],[21,89],[12,-18]],[[23527,54949],[0,-268],[17,-27],[17,-4]],[[23561,54650],[-6,-41],[-10,12],[-97,1]],[[23448,54622],[0,194]],[[25091,55975],[0,33],[19,1]],[[25110,56009],[97,3],[0,-69]],[[25207,55943],[1,-255]],[[25208,55688],[-40,0]],[[25168,55688],[-77,-1]],[[25091,55687],[0,288]],[[16478,62857],[-1,-150]],[[16477,62707],[-178,-2],[-23,-31],[-21,-64],[-15,-31],[-3,-30],[-11,-12],[-20,-70],[-3,-39],[-14,-73],[-18,-3],[-9,31],[-14,-29],[-26,25]],[[16122,62379],[0,228],[4,49],[13,11],[4,40],[22,74],[12,17],[17,-4]],[[21215,66995],[58,0]],[[21273,66995],[0,-250],[5,0],[0,-402]],[[21278,66343],[-187,-3]],[[21091,66340],[-10,0],[0,405],[-6,-1],[-1,252]],[[15443,66743],[0,-51],[38,0],[11,-35],[21,-12],[26,47],[28,-9],[12,-34]],[[15579,66649],[0,-814]],[[15579,65835],[-33,-5],[-47,2]],[[15499,65832],[-39,-7],[-46,1]],[[15414,65826],[-7,51],[6,60],[-9,56],[12,33],[5,60],[-14,115],[-12,41],[-39,9],[-2,48],[7,12],[6,104],[28,-1],[10,58],[1,38],[9,34],[0,41],[18,89],[10,69]],[[22911,64315],[0,-203]],[[22911,64112],[-1,-202]],[[22910,63910],[-126,1]],[[22051,58911],[0,-203]],[[22051,58708],[0,-305]],[[22051,58403],[-151,0]],[[21900,58403],[0,509]],[[26440,55574],[6,-11],[28,-1],[0,28]],[[26497,55590],[0,-202],[-3,-114],[-20,1]],[[26474,55275],[1,67],[-42,2]],[[26433,55344],[6,56],[1,174]],[[24844,53913],[61,15]],[[24905,53928],[0,-192],[23,-53],[21,-35],[3,-24],[0,-93]],[[24952,53531],[-19,0]],[[24933,53531],[-47,0],[0,-51],[-38,1]],[[24848,53481],[0,153],[-4,0],[0,279]],[[27011,63781],[4,-1],[-1,-83]],[[27014,63697],[-4,-252],[-9,1],[0,-44]],[[27001,63402],[-52,10],[-12,10]],[[26937,63422],[-3,-7],[-86,17]],[[26848,63432],[6,217]],[[21447,57388],[47,1]],[[21469,56883],[-122,0]],[[21347,56883],[0,505]],[[26122,69565],[46,-3],[0,-102],[102,-1]],[[26273,69158],[-124,2],[-10,-11],[-2,-44]],[[26137,69105],[-11,19],[-2,35],[-17,1]],[[26107,69160],[13,83],[8,160],[-6,162]],[[22155,63505],[125,0]],[[22280,63505],[31,0]],[[22311,63505],[0,-505]],[[22311,63000],[-149,-1]],[[22162,62999],[-7,0]],[[21625,60868],[122,0]],[[21747,60868],[0,-406]],[[21747,60462],[-121,1]],[[21626,60463],[-1,405]],[[18848,71375],[11,-20],[2,-74],[10,-13],[2,-37],[19,-4],[4,-24],[-2,-92],[21,-45],[2,-67],[18,-8],[5,18],[29,-46],[-3,-71],[-13,-41],[-2,-42],[13,-30],[5,-68]],[[18969,70711],[-68,-5],[-11,-41],[-3,-40],[-19,-67],[1,-77],[-10,4],[-3,-50],[-22,-53],[-12,-4],[-20,-85]],[[18802,70293],[0,251],[-34,1],[-1,101],[0,504]],[[22272,64721],[128,0]],[[22407,64721],[0,-405]],[[22406,64306],[-28,-18],[-22,-26],[-58,3],[-18,7]],[[22213,64284],[-2,33],[0,404]],[[17122,61726],[147,-550],[0,-736],[-1,-463]],[[17268,59977],[-185,575]],[[17083,60552],[-62,186],[-104,316]],[[16917,61054],[21,-3],[184,675]],[[27830,59130],[29,-2]],[[27859,59128],[56,-3]],[[27915,59125],[-8,-213],[-10,-225]],[[27897,58687],[-18,-3],[-47,19]],[[27832,58703],[-4,43],[2,384]],[[18514,68126],[0,101],[150,-1]],[[18664,68226],[0,-101],[50,0],[0,-51]],[[18714,68074],[0,-151],[-2,-51],[15,16],[28,-59],[14,-47],[17,-24],[26,0],[0,-34]],[[18812,67724],[-249,0]],[[18563,67724],[-50,-4]],[[18513,67720],[1,406]],[[26046,65550],[103,1]],[[26175,65551],[1,-272]],[[26048,65276],[-2,274]],[[24522,66175],[65,-1]],[[24587,66174],[0,-304]],[[24587,65870],[0,-102]],[[24456,65770],[1,406]],[[23419,66076],[64,-1]],[[23483,66075],[64,0]],[[23547,66075],[0,-404]],[[23547,65671],[-32,0]],[[23515,65671],[-97,1]],[[23418,65672],[1,404]],[[22196,72032],[59,0]],[[22255,72032],[214,-1]],[[22486,71222],[-167,-1]],[[22204,71222],[1,407],[-9,0],[0,403]],[[23547,66075],[65,-1]],[[23677,65672],[-33,-1]],[[23644,65671],[-97,0]],[[25392,52659],[-5,80],[11,68],[12,18],[-10,40],[-1,29],[16,57],[-11,38],[0,47],[7,46],[-10,48],[10,67],[-9,18]],[[25402,53215],[9,1],[-2,35]],[[25409,53251],[9,-7],[13,33],[11,70],[12,8],[-7,28],[13,-11]],[[25460,53372],[13,7],[11,-48],[17,-20]],[[25501,53311],[0,-288],[5,0]],[[25506,53023],[3,-38],[-13,-115],[2,-23],[23,-79],[3,-41],[36,-80],[3,-69],[-15,-102],[3,-55],[20,-51],[-18,-35],[-8,-82],[-9,-15],[7,-24],[-15,-26]],[[25528,52188],[-38,-35],[-40,-24],[-56,-4],[18,41],[12,-26],[35,27],[3,34],[-15,48],[-7,43],[-20,47],[-7,90],[9,74],[-3,76],[-7,48],[-20,32]],[[26308,66321],[33,1]],[[26341,66322],[128,3]],[[26469,66325],[3,0]],[[26472,65914],[-65,2]],[[26407,65916],[-96,-3]],[[26311,65913],[-3,307],[0,101]],[[26656,59542],[54,1],[5,-5],[76,0]],[[26834,59538],[-33,-60],[-17,25],[-30,-58],[-24,-85],[3,-20],[-24,-34]],[[26709,59306],[-20,29],[-10,-8]],[[26679,59327],[5,54],[-8,88],[-20,73]],[[22162,62999],[-1,-506]],[[22161,62493],[-151,-1]],[[22010,62492],[-5,0]],[[22005,62492],[1,507]],[[23422,61218],[0,-253],[-3,-102]],[[23257,57210],[44,0],[0,101]],[[23301,57311],[126,0]],[[23427,57311],[34,0],[0,-203]],[[23461,57108],[-30,1],[0,-307],[-29,0],[-2,-101]],[[23400,56701],[-173,0]],[[23227,56701],[0,407],[30,0],[0,102]],[[21405,53784],[9,0]],[[21414,53784],[142,0]],[[21556,53784],[0,-665]],[[21556,53119],[-146,7]],[[21410,53126],[-2,131],[-3,527]],[[21978,69610],[154,-1]],[[22170,69609],[0,-406]],[[22142,69204],[-204,0]],[[21938,69204],[-5,107],[9,44],[31,-9],[-10,46],[-3,47],[13,69],[5,102]],[[22280,63911],[0,-406]],[[22155,63505],[-1,406]],[[23468,67577],[17,1]],[[23485,67578],[114,0]],[[23599,67578],[0,-286]],[[23599,67292],[-131,0]],[[23468,67292],[0,285]],[[22330,73979],[292,1]],[[22622,73980],[0,-329],[6,0],[0,-204]],[[22628,73447],[-108,1]],[[22520,73448],[-182,1]],[[16473,61679],[38,-90],[23,53],[14,18],[15,-8],[-1,-52],[17,-45]],[[16579,61555],[-2,-51],[12,-54],[-7,-46],[32,-70],[5,20],[14,-67],[5,18],[21,-32],[13,-63],[-4,-72],[5,-28],[25,-53],[-1,-52],[4,-70],[-19,-64]],[[16682,60871],[-11,45]],[[16671,60916],[-19,72],[-14,31],[-18,-4],[-10,35],[-13,3],[-8,-44],[-13,-22],[0,-22],[-27,-52],[-18,-21],[-15,18],[-20,-11],[-24,56],[-16,19],[-13,-54],[-15,16],[-1,-29],[-15,-7],[-6,-35],[-23,-9],[10,-72],[-6,-17],[-17,39],[1,-58]],[[16371,60748],[-74,231]],[[16297,60979],[6,34],[26,75],[6,41],[-7,16],[7,34],[14,11],[3,33],[32,154],[23,130],[14,48],[15,71],[37,53]],[[22161,62493],[4,0]],[[22008,61986],[2,506]],[[22342,48683],[44,-1],[0,100]],[[22490,48118],[-148,2]],[[22342,48120],[0,563]],[[31558,38031],[6,69],[8,27]],[[31572,38127],[9,7],[15,-39]],[[31596,38095],[-10,-51],[-6,-70]],[[31580,37974],[-22,57]],[[25216,69460],[43,-1],[-1,-304]],[[25258,69155],[-69,1],[0,101],[-68,-1],[0,101]],[[25121,69357],[0,103],[95,0]],[[23620,67982],[34,0]],[[23654,67982],[0,-405]],[[23654,67577],[-55,1]],[[23485,67578],[0,404]],[[25724,54587],[5,-38],[7,38],[-1,62],[16,10],[2,-49],[8,-9],[8,52],[10,9],[1,-36],[20,-13],[3,-29],[10,7]],[[25813,54591],[6,-15],[-3,-55],[22,-46],[0,-226]],[[25838,54249],[1,-101],[-12,1]],[[25713,54146],[0,100],[-14,0]],[[25699,54246],[-1,206],[28,0],[-13,37],[-1,32],[9,25],[-6,27],[9,14]],[[26231,61565],[25,46],[10,-21]],[[26266,61590],[22,-21],[14,16]],[[26307,61402],[-39,-63],[0,-28]],[[26268,61311],[-11,-28],[-34,42]],[[26223,61325],[6,37],[1,133],[12,66],[-11,4]],[[24200,63447],[93,-3]],[[24293,63444],[31,-2]],[[24324,63442],[-2,-337]],[[24322,63105],[-94,5],[0,-64],[-32,-3]],[[24196,63043],[4,404]],[[22992,59033],[1,4],[89,-2]],[[23082,59035],[0,-100],[75,-1],[-1,-254]],[[23156,58680],[-44,0],[0,-254]],[[23112,58426],[-120,0]],[[22992,58426],[0,352]],[[22992,58778],[0,255]],[[22847,51429],[75,5]],[[22922,51434],[8,-18],[3,-47],[11,1],[65,-282],[-27,-83]],[[22982,51005],[-78,-233]],[[22904,50772],[-11,47]],[[22893,50819],[-73,326]],[[22820,51145],[10,144],[0,85],[17,55]],[[25147,68139],[0,-102]],[[25147,68037],[0,-305]],[[25147,67732],[-33,0]],[[25114,67732],[-34,-2],[0,14],[-33,-1]],[[25047,67743],[0,136],[22,7],[0,52],[-9,2],[0,75],[9,0],[0,124]],[[22056,64317],[-67,1]],[[21989,64318],[-1,403]],[[26046,65550],[-36,0]],[[26010,65550],[8,47],[-1,314]],[[25075,61422],[0,304]],[[25075,61726],[62,4],[62,-3]],[[25199,61727],[0,-254]],[[25198,61320],[-118,0]],[[25080,61320],[-6,0],[1,102]],[[23994,67576],[132,1]],[[24125,67243],[-131,0]],[[23994,67292],[0,284]],[[8956,91740],[103,2],[44,26],[38,0],[25,33],[8,65],[33,25],[28,-4],[20,41],[59,41],[51,-42],[45,49],[3,29],[68,22],[51,85],[24,-12],[18,16],[64,23],[26,-20],[39,40],[1,32],[35,-5],[33,16],[1,34]],[[10627,93581],[0,-4581]],[[9097,90473],[3,13],[-1,352],[-143,-4]],[[8956,90834],[0,906]],[[24986,64840],[0,99],[30,-1],[6,79],[19,25],[29,-14]],[[23337,64853],[64,-1]],[[23401,64852],[63,-1]],[[23464,64551],[-127,1]],[[23337,64552],[0,301]],[[24125,66887],[132,0]],[[24257,66887],[0,-309]],[[24125,66578],[0,309]],[[25076,61760],[1,272]],[[25201,62136],[-1,-256]],[[25200,61880],[-1,-153]],[[25075,61726],[1,34]],[[27405,58271],[13,0]],[[27418,58271],[123,-3]],[[27541,58268],[-59,-370]],[[27482,57898],[-12,27]],[[27470,57925],[-33,69],[-7,92],[-20,64],[4,14],[-9,107]],[[21414,54291],[21,0]],[[21556,54291],[0,-507]],[[21414,53784],[0,507]],[[22245,52196],[-126,4]],[[22119,52200],[-100,0]],[[24750,67640],[34,1],[-1,-455]],[[24783,67186],[-19,39],[-25,14],[-22,-10]],[[24717,67229],[-32,12],[-34,-46]],[[24651,67195],[0,292]],[[24651,67487],[-1,151],[100,2]],[[21748,58410],[0,-7]],[[25821,60384],[87,17]],[[25908,60401],[30,-140],[-2,-56]],[[25936,60205],[-5,-133],[-11,10]],[[25920,60082],[-22,18],[-7,32],[-18,-28],[-33,104]],[[25840,60208],[-19,176]],[[26147,62950],[73,1]],[[26220,62951],[61,-5]],[[26281,62946],[-1,-252]],[[26280,62694],[-68,2]],[[26212,62696],[-43,2],[-22,-47]],[[26147,62651],[0,215]],[[26147,62866],[0,84]],[[17550,68740],[-8,103],[7,123],[-14,93],[3,104],[10,47],[2,45],[11,41],[-5,37],[12,62],[-14,23],[-1,30]],[[17553,69448],[6,60],[12,-7],[29,77],[0,-28],[272,2],[85,0]],[[17957,69552],[-8,-19],[0,-204],[-3,-94],[3,-39],[-11,-18],[-1,-39],[-13,-39]],[[17790,68554],[-16,10],[0,-50],[-41,-83],[-167,3],[-5,-99],[-27,0]],[[17534,68335],[0,201],[17,1],[-1,203]],[[28095,61182],[15,66],[12,79]],[[28122,61327],[11,-2],[19,27],[15,-19],[13,2],[13,-23]],[[28193,61312],[10,0],[37,-49],[13,-50],[14,-29]],[[28267,61184],[-30,-325]],[[28237,60859],[-10,28],[-16,9],[-16,101],[-12,12],[-7,40],[-13,15]],[[28163,61064],[-47,86],[-21,32]],[[22448,55301],[41,-2],[0,64]],[[22593,55358],[-3,-517]],[[22589,54786],[-113,1]],[[22476,54787],[-28,3]],[[22448,54790],[0,511]],[[21322,56882],[25,1]],[[21322,56315],[0,567]],[[25843,53019],[56,0]],[[25899,53019],[43,-1]],[[25942,53018],[-1,-336],[54,-2]],[[25995,52680],[-7,-46],[-13,-31],[0,-46],[10,-48],[-2,-42],[8,-34],[-12,-54],[-17,-5],[-9,-59]],[[25953,52175],[-27,40],[-58,70],[-27,18]],[[29224,66306],[131,65]],[[29355,66371],[2,-40],[-5,-64],[3,-101],[-5,-40],[-13,-27],[-2,-45],[-10,-28],[-5,-47]],[[29320,65979],[-26,58],[-11,-8],[-9,-86],[-65,21],[-40,64]],[[29169,66028],[-24,37],[30,172],[-4,7]],[[26283,63509],[0,144],[2,211]],[[26285,63913],[103,2]],[[26388,63732],[2,-323]],[[26390,63409],[-17,-1]],[[26373,63408],[-91,-2]],[[23349,73444],[36,0],[0,-203],[218,2]],[[23603,73243],[3,-607]],[[23606,72636],[1,-467]],[[23607,72169],[0,-39],[-71,-1]],[[23536,72129],[-143,3]],[[23393,72132],[-3,303],[0,232],[-15,12],[-8,71],[13,88],[-98,1]],[[23279,73016],[0,225],[-3,0],[0,201]],[[26073,68351],[64,0]],[[26137,68351],[69,-1]],[[23176,60713],[0,-252]],[[23176,60461],[-1,-102]],[[23175,60359],[-156,4]],[[23019,60363],[0,202]],[[23019,60565],[0,152]],[[21481,61480],[133,1]],[[21614,61481],[7,0]],[[21621,61481],[0,-507],[5,0],[-1,-106]],[[21625,60868],[-143,2]],[[21482,60870],[-1,610]],[[23977,73546],[38,3],[6,-27],[56,-79],[26,4],[1,-49],[-19,-7],[-4,-37],[16,-31],[41,13],[15,-54],[-6,-34],[6,-49],[24,-127],[25,27],[-8,84],[13,45],[15,-11],[42,16],[16,-44],[-2,-65],[17,-41],[14,9],[9,-36],[18,-5]],[[24336,73051],[3,-763],[-2,-707]],[[24337,71581],[-13,-17],[-61,-134],[-9,-25],[8,-50],[14,-46]],[[24276,71309],[-21,50],[-14,-11],[-3,-29],[-16,-14],[9,-19],[-11,-43],[-22,16]],[[23986,71682],[-3,96],[-1,332],[2,379],[-6,1],[1,199]],[[23979,72689],[-3,205],[-2,0],[3,652]],[[24295,65261],[32,1]],[[24327,65262],[87,0],[1,-49],[9,-53]],[[24424,65160],[-1,-304]],[[24359,64856],[-64,1]],[[24295,64857],[0,404]],[[22303,54789],[145,1]],[[22476,54787],[0,-249],[-21,-44]],[[22455,54494],[-104,-213]],[[22352,52023],[0,-415]],[[22352,51608],[-72,132],[-28,10],[-90,5]],[[22162,51755],[-25,1],[0,192],[-19,0]],[[22118,51948],[1,252]],[[28094,66437],[76,1]],[[28170,66438],[55,-5],[0,-50],[32,-4]],[[28257,66379],[0,-78],[-5,-246],[-2,-226]],[[28250,65829],[-127,1]],[[28123,65830],[-29,0]],[[28094,65830],[0,607]],[[21615,56321],[2,-507]],[[27617,60369],[-3,-53]],[[27614,60316],[-12,-6],[-12,35],[24,43],[3,-19]],[[28366,60374],[14,1]],[[28380,60375],[8,-23],[-14,-37],[-6,6],[-2,53]],[[24716,65047],[1,151],[15,26],[12,41],[26,13],[13,21],[2,48]],[[24785,65347],[90,0]],[[24875,65347],[2,-77],[0,-330]],[[24877,64940],[-3,0],[0,-100],[-33,1]],[[24715,64843],[1,204]],[[24912,54928],[0,292]],[[24912,55220],[0,53],[115,2]],[[25027,54861],[-1,0]],[[25026,54861],[-114,1],[0,66]],[[20265,57531],[73,0],[0,93],[-27,4],[0,101]],[[20311,57729],[148,2]],[[20459,57731],[118,0]],[[20577,57731],[0,-506],[-6,0],[0,-303]],[[20571,56922],[0,-101],[-171,0]],[[20400,56821],[-137,0],[0,209]],[[20263,57030],[0,96],[-15,-1],[2,101],[-1,127],[1,178],[15,0]],[[21312,64375],[167,0]],[[21479,64375],[0,-60]],[[21479,64015],[-170,-2]],[[21309,64013],[0,311],[3,51]],[[21276,64013],[33,0]],[[21479,63909],[0,-403]],[[21479,63506],[1,-499]],[[21480,63007],[-210,-7]],[[23204,67295],[132,-3]],[[23336,67292],[0,-402]],[[23336,66890],[-131,-1]],[[23205,66889],[-1,102],[0,304]],[[25026,54861],[0,-411]],[[25026,54450],[-114,-1]],[[24912,54449],[0,152],[-15,272]],[[24897,54873],[15,55]],[[22397,65529],[2,0]],[[22399,65529],[0,-404]],[[22399,65125],[-126,0]],[[27336,58900],[15,15],[26,-4]],[[27430,58906],[-4,-231]],[[27426,58675],[-18,-210],[10,-194]],[[27405,58271],[-35,11],[-11,-28]],[[27359,58254],[-3,65]],[[27356,58319],[9,88],[-22,102],[-16,1],[-1,32],[-12,44]],[[25408,56425],[88,-5]],[[25496,56420],[0,-51],[29,-5],[1,-204],[29,-4],[0,-101]],[[25555,56055],[-58,9],[0,-34],[-10,-1],[0,-68],[-48,4]],[[25439,55965],[-30,-1]],[[25409,55964],[-1,461]],[[21845,63505],[152,-1]],[[21997,63504],[4,0]],[[22001,62998],[-151,2]],[[21845,63000],[0,505]],[[16968,69275],[8,56],[15,10],[9,34],[36,-59],[9,2],[17,40],[5,32],[13,1],[14,-38],[4,-39],[59,1],[1,100],[82,2]],[[17240,69417],[135,-3]],[[17375,69414],[-18,-65],[-3,-51],[7,-58],[-9,-68],[-10,-34]],[[17342,69138],[-8,-63],[-32,-49],[-14,-93],[-8,-97],[-10,-66],[-18,-48],[3,-66],[-8,-36],[15,-69],[-9,-41]],[[17253,68510],[-74,-2],[0,102],[-23,33],[-6,33],[-106,0],[-11,-17],[-6,-46],[-11,-21],[-6,-50],[-16,-34],[-1,-34],[-22,-17]],[[25496,56876],[29,-3]],[[25525,56873],[117,-6]],[[25642,56867],[0,-358],[-11,1]],[[25631,56510],[-97,4],[-38,7]],[[25496,56521],[0,355]],[[24532,61412],[88,0]],[[24620,61412],[27,-118],[12,-30]],[[24659,61264],[-2,-398]],[[24657,60866],[-64,-1],[-62,7]],[[24531,60872],[1,152],[0,388]],[[31501,37932],[7,8],[10,-72]],[[31518,37868],[-7,-27],[-7,13]],[[31504,37854],[-3,78]],[[25526,64058],[0,16]],[[25526,64074],[0,286]],[[25526,64360],[72,0]],[[25598,64360],[47,0]],[[25645,64360],[1,-202]],[[25646,64158],[1,-102]],[[25647,64056],[-121,2]],[[16741,55926],[8,7],[1,-41],[-11,7],[2,27]],[[16501,56608],[18,-7],[13,-22],[15,5],[19,-43],[19,-4],[7,39],[20,-20],[-11,-43],[-28,-11],[-17,-31],[-42,24],[-1,61],[-12,52]],[[16410,56520],[22,8],[9,21],[13,-8],[13,19],[0,-48],[18,-13],[1,-48],[-41,-54],[-16,37],[-19,86]],[[16354,56562],[16,17],[6,28],[6,-35],[13,-26],[-21,-6],[-20,22]],[[16298,57653],[7,-13],[34,33],[19,-6],[38,-89],[1,42],[-12,66],[21,26]],[[16406,57712],[0,0]],[[16406,57712],[14,-5],[8,19],[4,44],[11,23]],[[16443,57793],[0,0]],[[16443,57793],[12,21],[32,-66],[12,3],[20,-32],[7,-28],[23,-38],[21,-2],[16,-26],[22,-62],[18,4]],[[16626,57567],[8,0]],[[16634,57567],[0,-509],[-1,-69],[-9,-32]],[[16624,56957],[-22,42],[-32,4],[-16,-24],[-18,25],[-22,-10],[-37,60],[-23,0],[-15,15],[-44,-7],[-48,-22],[-1,31],[-13,66],[-16,30],[-12,-4],[-6,32],[13,143],[-11,60],[8,119],[-17,54],[6,82]],[[15529,64876],[31,-45],[15,-74],[33,-1],[21,-43],[5,-41],[17,9],[10,-23],[10,39],[-6,46],[-13,25],[4,75],[17,60],[26,6],[21,63],[17,34],[4,31],[17,18],[10,33],[18,-44],[-7,-54],[-1,-85],[5,-26]],[[15661,63477],[-170,-1],[0,29]],[[15491,63505],[0,805],[1,47],[-9,143],[-13,82],[16,25],[19,-38],[13,31],[0,28],[11,61],[-5,49],[-8,9],[7,94],[6,35]],[[24794,62944],[64,2]],[[24858,62946],[62,2]],[[24920,62948],[1,-611]],[[24921,62337],[-125,2]],[[24796,62339],[0,304]],[[24796,62643],[-2,301]],[[26462,67657],[33,-2],[-1,-50],[66,-2],[-1,-51],[34,0]],[[26593,67552],[1,-178],[-1,-121]],[[26593,67253],[-65,-2],[0,-102]],[[26528,67149],[-122,-5]],[[22623,54462],[23,-170]],[[22646,54292],[-39,-81]],[[22550,54094],[-12,73],[-21,-45],[-62,372]],[[26877,50038],[118,2],[1,51],[55,0]],[[27051,50091],[-1,-193]],[[27050,49898],[0,-63],[-14,1],[0,-102]],[[27036,49734],[-85,-1],[-67,3]],[[26884,49736],[-42,-2]],[[26842,49734],[11,55],[1,41],[8,44],[0,38],[7,50],[0,39],[8,37]],[[26835,49734],[-9,0]],[[26826,49734],[0,53],[9,1],[0,-54]],[[27500,59487],[41,-7],[67,-2]],[[27608,59478],[7,0]],[[27613,59146],[-116,5]],[[27497,59151],[3,336]],[[17467,68335],[26,0],[5,146],[-2,53],[6,41],[2,74],[6,27]],[[17510,68676],[17,24],[7,54],[16,-14]],[[17534,68335],[-17,0],[-2,-400]],[[17515,67935],[-65,-1]],[[17450,67934],[-55,0]],[[17395,67934],[0,203],[39,-1],[0,34],[11,-1],[0,67],[22,-1],[0,100]],[[27335,62350],[34,42],[21,42],[7,32]],[[27397,62466],[23,-16]],[[27420,62450],[3,-102],[31,-121]],[[27454,62227],[-10,-23],[-8,10],[-87,-204]],[[27349,62010],[-4,34],[-16,54],[15,61],[-3,90],[2,44],[-8,57]],[[22511,60008],[66,0]],[[22577,60008],[1,-469],[1,-2]],[[22579,59537],[0,-152]],[[22579,59385],[-120,1]],[[22459,59386],[1,152],[-2,405],[-2,66]],[[22784,63505],[126,-1]],[[22910,63504],[31,0]],[[22941,63504],[0,-506]],[[22941,62998],[-43,0]],[[22898,62998],[-114,1]],[[22784,63100],[0,405]],[[27074,54503],[22,7],[21,-43],[10,-99]],[[27127,54368],[7,-56],[10,-18]],[[27144,54294],[-12,-48]],[[27132,54246],[-35,3],[-26,36],[-12,230]],[[27059,54515],[15,-12]],[[26070,63439],[0,153]],[[26070,63592],[100,0]],[[26170,63592],[4,-84]],[[26168,63256],[-22,-1]],[[26146,63255],[-82,-1]],[[26064,63254],[0,101],[5,0],[1,84]],[[27211,57475],[162,-1]],[[27373,57474],[10,-146],[-10,-74],[6,-103]],[[27379,57151],[-35,5],[-68,19],[-49,9]],[[27227,57184],[2,72],[-11,48],[-1,57],[-7,24],[8,19],[-7,71]],[[17976,55859],[1,27],[18,87],[9,24],[-4,46],[4,110],[8,12],[-2,74],[-7,64],[1,51],[6,6],[-2,55],[-7,20],[28,116],[0,60]],[[18336,56888],[0,-371]],[[18336,56517],[0,-723]],[[18336,55794],[-174,0],[0,101],[-86,-1],[0,-505],[-69,-3]],[[18007,55386],[-17,11],[-7,-13],[-13,25],[-3,-17],[-14,68],[7,67],[2,142],[-15,41],[9,65],[-8,51],[23,13],[5,20]],[[21976,65931],[28,0]],[[22004,65931],[134,0]],[[22138,65931],[0,-403]],[[21981,65528],[-4,0]],[[17957,69552],[5,43],[20,72],[-18,55],[-14,62],[-21,47],[0,84],[25,-19],[12,-25],[8,56],[21,54]],[[18481,68598],[0,-171],[-51,4]],[[18430,68431],[-90,-1]],[[21988,61176],[0,-102]],[[21991,60564],[-122,-1]],[[21869,60563],[0,305]],[[21869,60868],[0,107],[-3,0],[0,202],[122,-1]],[[24974,56143],[1,-254],[34,1]],[[25009,55890],[-11,-36],[-9,4],[0,-171]],[[24989,55687],[-53,0]],[[24936,55687],[0,136],[-20,-1],[0,17],[-19,0],[-1,303]],[[23402,55241],[120,2]],[[23522,55243],[4,-29]],[[23526,55214],[1,-101]],[[23527,55113],[0,-164]],[[23448,54816],[-7,-25],[-19,46],[-17,-6],[-4,23]],[[23401,54854],[1,387]],[[22443,52444],[51,2],[16,-18]],[[22510,52428],[63,-70]],[[22573,52358],[-13,-81]],[[22560,52277],[-35,-371]],[[22525,51906],[-32,-117]],[[22493,51789],[-49,235]],[[22897,62493],[0,102]],[[22897,62595],[32,-1],[0,-93],[5,0],[-6,-60],[41,4],[0,-21],[57,-1],[0,-34]],[[23026,62389],[0,-202]],[[23026,62187],[-109,0]],[[22917,62187],[-10,1],[0,126],[-10,-16],[0,195]],[[26174,61979],[8,-4],[41,87]],[[26223,62062],[17,-96],[8,-21]],[[26248,61945],[-11,-29],[-28,-47]],[[26209,61869],[-26,-13]],[[26183,61856],[-12,-6],[-5,54],[-29,127]],[[26137,62031],[21,2],[16,-54]],[[25935,65224],[0,-50]],[[25935,65174],[1,-306],[-6,0]],[[25821,65171],[0,50],[114,3]],[[27611,58859],[2,287]],[[27753,59127],[-2,-397]],[[27610,58754],[1,105]],[[28411,62214],[6,-20]],[[28417,62194],[-6,20]],[[27773,60926],[13,2],[-11,-27],[-2,25]],[[26278,65915],[33,-2]],[[26407,65916],[1,-427]],[[26408,65489],[-11,-1]],[[26397,65488],[-113,-11]],[[26284,65477],[0,75],[-5,-1]],[[21637,61990],[100,0]],[[21737,61482],[-116,-1]],[[21614,61481],[0,508]],[[23990,68388],[101,-2]],[[24091,68386],[0,-403],[-3,0]],[[24088,67983],[-100,-1]],[[23988,67982],[1,35],[-1,371]],[[25074,63831],[160,-1]],[[25187,63567],[-112,-8]],[[21414,54291],[-143,-1]],[[21271,54290],[-74,1]],[[21197,54291],[0,507]],[[22516,68388],[133,-2]],[[22650,67984],[-33,1]],[[22516,68086],[0,302]],[[23742,68691],[13,71],[-7,29]],[[23748,68791],[107,1]],[[23855,68387],[-68,0]],[[23787,68387],[0,51],[-68,0]],[[23719,68438],[-3,21],[18,58],[7,42],[-8,25],[9,107]],[[25013,66814],[99,3]],[[25112,66817],[66,-5]],[[25178,66812],[-1,-103],[1,-305]],[[25178,66404],[-46,3]],[[25014,66413],[-1,401]],[[23988,67982],[-1,0]],[[23888,67982],[0,405]],[[27842,64725],[1,33],[0,295]],[[27843,65053],[29,-7],[3,17]],[[27875,65063],[21,12],[14,30],[3,-17],[62,-115],[7,-71]],[[27982,64902],[-15,1],[-11,-82],[0,-264]],[[27956,64557],[-114,6]],[[27842,64563],[0,162]],[[23468,66890],[131,-2]],[[23599,66888],[0,-306]],[[23599,66481],[-131,2]],[[23468,66483],[0,407]],[[23318,67982],[-1,-404]],[[23317,67578],[-113,-1]],[[23204,67577],[-53,0]],[[13624,82241],[40,22],[28,-143],[-3,-90],[-20,-107],[-18,-67]],[[13651,81856],[-40,106],[1,34],[-28,66],[20,30],[8,33],[20,3],[-20,55],[12,58]],[[13234,81005],[16,62],[-2,43],[13,20],[-14,43],[-2,70],[5,39],[11,9],[19,-32],[5,-35],[13,-7],[17,-40],[0,-165],[-9,-34],[-27,-2],[-13,32],[-23,-36],[-9,33]],[[12888,80934],[18,6],[-4,-53],[-14,47]],[[12768,81460],[21,27],[-2,-46],[-16,-11],[-3,30]],[[12700,80811],[9,0],[10,-128],[-15,29],[-4,99]],[[12674,81692],[9,23],[1,61],[20,-30],[1,-32],[-22,-72],[-9,50]],[[12659,81749],[12,9],[-1,-36],[-11,27]],[[12637,81497],[8,92],[8,25],[32,-9],[10,-16],[-2,-35],[-16,-42],[8,-16],[20,40],[5,43],[13,-19],[19,68],[19,-2],[16,-39],[-5,-60],[-15,-35],[-19,15],[-13,-35],[17,-22],[-2,-37],[-22,-21],[-22,-50],[-9,-97],[-23,78],[17,61],[-1,78],[-29,51],[-14,-16]],[[12629,82086],[11,22],[24,102],[28,10],[11,20],[-22,13],[-1,47],[15,-22],[9,34],[-36,62],[14,29],[-10,86],[23,49],[45,-24],[71,-17],[24,-82],[11,-73],[-5,-69],[14,-6],[13,-68],[17,-48],[17,5],[57,-119],[12,-52],[33,-111],[3,-126],[29,-29],[8,-82],[8,-32],[31,-50],[13,-58],[-10,-6],[-19,46],[-75,98],[-3,-31],[-23,-74],[11,-8],[14,47],[8,-19],[23,10],[5,-37],[20,-13],[10,-29],[-38,-14],[8,-36],[32,21],[14,-52],[16,-14],[11,-87],[8,-9],[-12,-49],[-20,9],[2,-32],[22,-22],[11,8],[3,46],[14,36],[9,-21],[5,-91],[-15,-34],[4,-36],[-22,-94],[-29,-40],[18,-23],[27,59],[15,-10],[0,-203],[7,-72],[-20,-105],[-37,-9],[-26,48],[-14,-19],[-17,38],[-1,37],[-38,-2],[17,53],[27,-10],[1,39],[-19,42],[-19,13],[-35,78],[9,38],[10,115],[-15,9],[-11,-58],[7,101],[8,28],[-11,39],[-5,-55],[-27,-21],[14,-103],[-18,-58],[-47,56],[-4,35],[17,58],[-18,100],[-20,-5],[-10,50],[-21,3],[12,-78],[18,-65],[6,-72],[-7,-36],[15,-17],[20,-145],[24,-26],[-4,58],[24,18],[28,-65],[4,-124],[-14,-16],[-18,74],[-7,-7],[23,-170],[-29,0],[-26,32],[-2,60],[-20,40],[-49,177],[-10,22],[-2,84],[-12,10],[-8,61],[29,8],[-27,33],[3,119],[-33,-28],[-10,26],[-18,-19],[-9,42],[6,84],[33,30],[11,-63],[17,20],[-13,29],[6,39],[14,20],[14,-14],[22,44],[-29,96],[14,12],[-16,32],[4,66],[-24,-21],[-49,87],[-4,28],[16,-1],[-9,50],[3,35],[-27,18],[6,-57],[-10,-13],[-32,39],[-16,58],[12,52],[28,14],[37,-54],[28,35],[-17,67],[-18,16],[-12,-20],[-9,17],[8,30],[-2,42],[7,63],[-5,16],[-13,-47],[-27,-65],[-22,-33],[-23,38],[-5,45]],[[12594,82026],[14,28],[11,-6],[4,-52],[-8,-48],[-10,3],[-11,75]],[[12476,82024],[28,22],[1,-43],[31,33],[8,75],[7,-2],[-9,-101],[-22,-24],[-20,-56],[-18,17],[8,30],[-14,49]],[[12742,82703],[-13,-47],[-15,-20],[-25,-2],[-17,15],[-3,87],[-11,32],[-30,-64],[13,-29],[-2,-90],[-23,-3],[-2,-31],[10,-51],[-11,-51],[-2,-62],[-17,-50],[4,-39],[-9,-64],[-10,-11],[-25,15],[-14,-103],[-15,19],[-12,52],[-7,63],[-1,109],[-10,87],[2,75],[14,48],[-3,57],[15,101],[-12,28],[-22,-1],[5,77],[-20,56],[-8,75],[2,43],[-5,91],[17,52],[16,17],[7,33],[33,-1],[1,26],[28,-40],[11,-83],[18,-54],[31,-2],[9,-21],[10,26],[-29,44],[-13,80],[-2,55],[-35,79],[11,53],[34,26],[51,-37],[25,-9],[47,-44],[33,-10]],[[12402,82457],[-9,-131]],[[12393,82326],[0,131],[9,0]],[[21709,67448],[282,1]],[[21991,67449],[0,-305],[5,0],[0,-151]],[[21996,66993],[-192,-1],[-95,0]],[[26748,53515],[51,-3],[0,-17],[33,-1],[6,-44],[53,0]],[[26891,53450],[-1,-104],[-19,4],[0,-64],[8,-46]],[[26879,53240],[-84,0]],[[26795,53240],[-21,0]],[[26774,53240],[-1,56],[5,50],[-7,64],[-15,44],[-8,61]],[[12393,82326],[-11,6],[-28,70],[-10,86],[-21,59],[-40,212],[4,48],[22,23],[-18,30],[-26,-31],[-14,88],[-11,-15],[-17,42],[-12,55],[2,34],[-14,-22],[-10,24],[-30,2],[-19,96],[19,3],[10,-29],[10,13],[-3,105],[19,53],[6,38],[-39,86],[24,63],[-4,22],[14,35],[4,53],[-33,16],[-21,-28],[-14,79],[-20,42],[-4,35],[37,69],[6,28],[-4,68],[36,64],[18,-12],[25,-85],[15,10],[18,-58],[23,-24],[38,4],[22,-14],[12,-79],[-2,-49],[-20,35],[-19,-2],[-1,-22],[21,-25],[11,-46],[29,-278],[-1,-71],[12,-56],[0,-58],[18,-142],[5,-107],[-5,-112],[-11,1],[8,-81],[3,-220]],[[12062,83572],[4,48],[-3,66],[25,9],[34,-62],[15,-74],[12,-19],[17,30],[23,-10],[-16,-82],[-24,-14],[-27,-161],[-12,6],[-40,-30],[-9,8],[3,102],[25,47],[1,50],[-22,4],[2,29],[-13,31],[5,22]],[[12270,84186],[23,-29],[23,24],[7,-95],[14,-69],[12,-143],[-14,-42],[-42,-11],[-17,12],[-44,95],[-65,99],[-27,50],[-22,-26],[-9,29],[-4,-32],[30,-55],[22,-8],[-21,-31],[6,-25],[0,-72],[-9,-50],[-31,-87],[-51,47],[-1,38],[-42,85],[-20,90],[-12,-38],[-19,43],[-10,79],[4,25],[-18,86],[2,24],[-17,61]],[[24936,55687],[-16,-1],[-13,-82]],[[24907,55604],[-119,138]],[[24788,55742],[0,98],[11,-1],[0,50],[10,-1],[-1,235],[-7,19]],[[27434,49020],[100,-1]],[[27534,49019],[7,-67],[11,-140],[16,-136]],[[27434,48610],[0,410]],[[24182,64198],[-80,-8]],[[24102,64190],[0,359]],[[24585,64247],[32,-4]],[[24617,64243],[96,-10]],[[24713,64233],[-1,-409]],[[24712,63824],[-128,10]],[[24584,63834],[1,413]],[[26672,65249],[21,1],[0,-51],[108,1]],[[26801,65200],[-1,-33],[30,1],[1,-164]],[[26831,65004],[1,-40]],[[26832,64964],[-66,2],[-48,-5],[-48,1]],[[26670,64962],[2,287]],[[25200,61880],[37,1],[87,-9]],[[25353,61837],[-1,-364]],[[25352,61473],[-61,-1]],[[20681,52634],[227,515]],[[20908,53149],[144,-395]],[[21052,52754],[41,-117]],[[21093,52637],[-101,-295]],[[20992,52342],[-28,0],[-301,252]],[[20663,52594],[18,40]],[[23584,68994],[0,-102],[68,1],[0,102],[68,-1]],[[23787,68904],[-25,-22],[-12,-39],[-2,-52]],[[23742,68691],[-193,-1]],[[23549,68690],[-2,303],[37,1]],[[22052,56327],[45,0],[1,-22],[21,5],[15,-25],[2,32],[17,-15],[9,-31],[7,18],[15,-39],[8,-3],[5,-39]],[[22198,55819],[-145,-2]],[[24765,61794],[21,92],[0,57]],[[24786,61943],[133,-6]],[[24919,61937],[0,-279]],[[24919,61658],[1,-228]],[[24920,61430],[-55,1]],[[24865,61431],[-7,62],[3,40],[-34,1],[0,17],[-31,103],[1,17],[-33,110]],[[24764,61781],[1,13]],[[26541,68347],[89,2]],[[26630,68349],[-5,-124],[-19,-5],[-8,-19],[0,-49],[-42,-6],[-13,-35],[-9,-56]],[[26534,68055],[-38,0],[0,100],[-34,0]],[[25294,62538],[98,3]],[[25392,62541],[16,1]],[[25408,62542],[1,-378]],[[25322,62161],[-29,5],[0,69]],[[22898,62998],[-1,-403]],[[22897,62493],[-114,-1]],[[22783,62492],[1,203]],[[17372,70320],[18,44],[-8,56],[16,63]],[[17398,70483],[15,-1],[0,41],[11,5],[21,-41],[5,44],[0,106],[9,-9],[8,84],[7,10],[48,-36],[17,-21],[13,67],[26,-1],[11,24],[-22,44],[-21,121]],[[17546,70920],[11,-21],[15,9],[21,-64],[12,-21],[30,-7],[20,-18],[11,61],[4,63],[25,74],[1,42],[289,186]],[[17985,71224],[13,13],[22,-15],[4,21],[26,23],[8,-10]],[[17553,69448],[-45,2],[6,23],[-16,162],[-96,0]],[[17402,69635],[3,54],[24,150],[10,23],[1,55],[24,108],[-7,54],[-13,49],[0,53],[-16,48],[-19,2],[-10,47],[-18,-5],[-9,47]],[[22000,73978],[183,0]],[[22192,73449],[-182,1]],[[22005,62492],[-155,2]],[[22339,52935],[145,0]],[[22484,52935],[-1,-60],[20,-41],[-15,-52],[2,-46],[15,-12],[-12,-42],[3,-33],[-10,-3],[11,-87],[0,-41],[13,-6],[0,-84]],[[20644,61475],[31,0],[-1,304]],[[20674,61779],[105,1],[143,3]],[[20922,61783],[-2,-438]],[[20919,60866],[-80,96]],[[20839,60962],[-83,97],[-102,-23],[-10,40]],[[20644,61076],[0,399]],[[15231,66942],[61,0],[11,-24],[2,-35],[20,-62],[-7,-38],[2,-91],[6,0],[1,-85],[12,22],[26,0],[0,17],[20,46],[0,40],[32,17]],[[15417,66749],[8,12],[18,-18]],[[15414,65826],[-109,3]],[[15305,65829],[-21,55],[-15,55],[-7,69],[2,33],[-14,81],[2,32],[-7,63],[-2,126],[13,147],[-7,107],[-17,87],[-11,2],[-11,123],[21,133]],[[25027,55481],[29,1],[0,102],[29,1],[0,102],[6,0]],[[25168,55688],[0,-420]],[[25168,55268],[-29,1]],[[25027,55275],[0,206]],[[22406,63911],[-126,0]],[[31436,38183],[13,-4]],[[31449,38179],[1,-70],[7,-1]],[[31457,38108],[-1,-5]],[[31436,38070],[-17,25]],[[31419,38095],[7,24],[0,55]],[[27391,63178],[87,0]],[[27506,63178],[4,-4],[3,-94]],[[27513,63080],[-11,3],[-5,-51],[-7,2],[-6,-40],[8,-89],[-7,-20]],[[27485,62885],[-6,-40],[-8,-7]],[[27471,62838],[-20,25]],[[27451,62863],[-10,23],[-16,7],[-8,43],[-29,82],[-12,-4],[-16,31]],[[27360,63045],[18,16],[4,83],[9,34]],[[26330,53328],[29,-4],[-2,-206]],[[26305,53107],[-53,4]],[[26252,53111],[1,213],[77,4]],[[20369,60882],[162,3]],[[20531,60885],[-6,-51],[0,-49],[-7,-79],[5,-23]],[[20523,60683],[-3,-16],[-69,-241]],[[22326,60458],[-148,-4]],[[22178,60454],[-3,0],[0,101]],[[21235,71220],[232,2]],[[21467,71222],[13,-1],[1,-404],[13,0],[0,-91]],[[21494,70726],[-139,1],[0,90],[-119,-2]],[[24091,68386],[35,0]],[[24126,68386],[65,-1],[0,-101],[67,-1]],[[24258,68283],[0,-302]],[[24258,67981],[-103,1],[0,-16]],[[24155,67966],[-67,-1],[0,18]],[[31537,38160],[9,48]],[[31565,38190],[-12,-61],[-9,-69]],[[23354,66076],[65,0]],[[23289,65672],[-32,-1]],[[23257,65671],[0,406]],[[23180,62035],[0,152]],[[23180,62187],[124,0]],[[23304,62187],[0,-152]],[[23302,61680],[-123,0]],[[23994,66479],[131,-1]],[[24131,66176],[-65,0],[0,-101]],[[21480,63000],[177,0]],[[21657,63000],[7,0]],[[21663,62496],[-24,-1]],[[21481,62494],[-1,197],[0,309]],[[31265,38069],[8,-129],[4,-18]],[[31277,37922],[-21,9]],[[31256,37931],[-6,23]],[[31250,37954],[1,107]],[[23515,65671],[0,-303],[12,0],[0,-114]],[[23527,65254],[-94,0]],[[30863,68384],[14,7],[-7,-35],[-7,28]],[[30827,68345],[7,83],[6,-34],[19,-55],[-15,-45],[-5,34],[-12,17]],[[30819,68560],[3,42],[11,-71],[-14,29]],[[30732,68434],[14,2],[3,-41],[-17,39]],[[30739,68955],[20,-27],[15,71],[12,-21],[9,43],[47,26],[-15,254],[35,19],[-6,100],[35,19],[-9,142],[69,36]],[[30978,68642],[-8,-33],[-5,27],[-12,-92],[-16,39],[0,36],[-10,-21],[-11,9],[2,-66],[-16,-71],[11,-33],[-35,-16],[-23,32],[-16,107],[6,29],[22,27],[-9,45],[-13,-35],[2,44],[-10,-3],[1,-68],[-5,0],[0,64],[-24,-56],[5,-35],[-6,-43],[14,-67],[-3,-45],[-23,-77],[9,-11],[-12,-39]],[[30793,68290],[-10,9]],[[30783,68299],[-17,53],[-4,64],[15,51],[-19,40],[6,26],[-10,10],[-18,-21],[1,113],[11,44],[1,50],[-6,41]],[[30743,68770],[-3,56],[-10,54],[9,75]],[[23590,56449],[18,-17],[9,8],[-3,-44],[14,-14],[2,-26],[26,-68],[15,9],[-1,-24],[41,-8],[0,-34],[23,-3]],[[23734,56228],[-2,-91],[10,-10],[22,-58],[7,-5]],[[23771,56064],[-9,2],[-11,-46],[-9,13],[-6,-39],[-4,37],[-6,-56],[-3,36],[-13,-14]],[[23710,55997],[0,-1]],[[23710,55996],[-16,22],[-6,-21],[-5,30],[-12,17],[-11,-46],[-21,27],[-3,-29],[-8,18],[-5,-27],[-10,9],[2,36],[-9,-6],[-11,25],[0,54],[-8,-8]],[[23587,56097],[3,352]],[[23569,58965],[44,-3],[1,50],[15,0],[1,84],[88,-7],[12,-5],[0,28],[24,8]],[[23754,59120],[-16,-168],[-1,-233],[-4,-151]],[[23733,58568],[-45,4],[0,-16],[-103,10]],[[23585,58566],[-16,399]],[[24128,57628],[17,-3],[9,-52],[-3,-57],[6,15],[-3,36],[9,36],[53,-5],[0,101],[30,-2]],[[24246,57697],[14,-1],[-2,-328],[-4,-22],[-6,-103],[24,-2],[-1,-153]],[[24271,57088],[-49,4]],[[24222,57092],[-11,1]],[[24074,57512],[-5,0],[1,67],[29,-1],[0,34],[29,-4],[0,20]],[[24246,57760],[30,11],[17,-36],[21,-24],[21,7]],[[24335,57718],[-1,-127],[31,-2],[-2,-288],[18,-54],[-8,-54],[9,-31],[-10,-40],[-2,-43]],[[24370,57079],[-8,1]],[[24362,57080],[-91,8]],[[24246,57697],[0,63]],[[21194,60759],[91,1]],[[21285,60760],[197,0]],[[21482,60760],[0,-297]],[[21482,60463],[0,-461]],[[21482,60002],[-183,3],[-22,5],[-62,1]],[[21215,60011],[-24,0]],[[21191,60011],[1,444],[2,0],[0,304]],[[18150,66443],[19,11]],[[18169,66454],[12,16],[17,-16],[14,25],[11,-40],[24,16],[22,127],[23,33],[6,-5]],[[18298,66610],[27,21],[19,-68],[19,-4]],[[18363,66559],[17,2],[0,-44],[48,-2],[1,-303]],[[18429,66212],[0,-383]],[[18429,65829],[-229,-12],[-61,6]],[[18139,65823],[-67,1]],[[18072,65824],[-1,493],[60,-1],[1,114],[18,13]],[[25667,55164],[40,0],[-1,248]],[[25706,55412],[0,26],[16,-4],[59,2],[16,-60],[10,2]],[[25807,55378],[1,-106],[10,-64],[8,-12],[-2,-58],[23,-71]],[[25847,55067],[-11,-3],[0,-50]],[[25836,55014],[-84,-2],[1,-52],[-57,3]],[[25696,54963],[-28,-1],[0,77]],[[25668,55039],[-1,125]],[[26617,54223],[0,-203]],[[26617,54020],[0,-58],[-53,-1]],[[26564,53961],[-12,33],[-26,19]],[[26526,54013],[4,72]],[[23139,68893],[137,-1],[2,-102]],[[23278,68790],[1,-404]],[[23143,68388],[0,403],[-4,1],[0,101]],[[28051,60406],[60,344],[2,64]],[[28113,60814],[17,64],[6,4]],[[28136,60882],[16,-38],[-2,-42],[10,-26]],[[28160,60776],[-4,-34],[-13,-202]],[[28143,60540],[-14,-12],[-14,-89]],[[28115,60439],[-24,-69],[-6,12],[-15,-16],[-19,40]],[[23036,63808],[111,0]],[[23147,63808],[16,-1]],[[23163,63807],[-1,-304]],[[23162,63503],[-63,0]],[[23099,63503],[-63,1]],[[23036,63504],[0,304]],[[22051,58403],[0,-229]],[[22051,57895],[-150,1]],[[22641,72434],[114,-1]],[[22755,72433],[0,-404],[6,0],[0,-100]],[[22657,64316],[0,405]],[[26272,68754],[-135,1]],[[26137,68755],[0,350]],[[22311,63000],[6,0]],[[22317,63000],[-1,-507]],[[25263,62589],[0,186]],[[25263,62775],[128,5]],[[25391,62780],[1,-239]],[[27442,61787],[39,139],[15,109]],[[27496,62035],[18,-14]],[[27514,62021],[11,4],[9,-54],[11,12]],[[27545,61983],[27,-197],[-17,-159]],[[27523,61437],[-22,49]],[[27501,61486],[-48,106],[-4,-5],[-10,68],[6,13],[-11,93],[8,26]],[[25111,57676],[54,1]],[[25165,57677],[0,-159],[19,0],[0,-119],[10,0]],[[25194,57399],[0,-186],[-5,0]],[[25189,57213],[-98,2]],[[25091,57215],[0,252],[15,0],[5,51],[0,158]],[[26747,53576],[9,7],[15,101],[0,54],[12,28],[5,44]],[[26788,53810],[0,125]],[[26788,53935],[5,14],[31,-12],[9,39]],[[26833,53976],[0,-168],[58,1]],[[26891,53809],[0,-133],[9,-1],[-1,-103]],[[26899,53572],[-8,0],[0,-122]],[[26748,53515],[-1,61]],[[22628,62189],[0,101]],[[22628,62290],[155,0]],[[22783,62290],[0,-406]],[[22783,61884],[-154,0]],[[22629,61884],[-1,305]],[[24726,57012],[27,0],[-1,99],[30,2]],[[24782,57113],[1,-244],[16,-41],[0,-123]],[[24799,56705],[0,-102],[-88,0]],[[24711,56603],[0,221],[15,-1],[0,189]],[[22329,70816],[-10,1]],[[22473,62188],[155,1]],[[22629,61884],[0,-101]],[[22629,61783],[-155,-1]],[[22474,61782],[-1,204]],[[22473,61986],[0,202]],[[25606,62539],[52,-5]],[[25658,62534],[103,-2]],[[25761,62532],[0,-202]],[[25761,62228],[-61,-1]],[[25700,62227],[-55,0]],[[25645,62227],[-39,4]],[[25606,62231],[0,308]],[[24041,63902],[48,0]],[[24089,63902],[93,4]],[[24183,63855],[1,-309]],[[24184,63546],[-140,0]],[[24044,63546],[-3,0]],[[27031,64280],[132,0]],[[27163,64280],[1,-38]],[[27164,64242],[-6,-3],[0,-220],[-11,1]],[[27147,64020],[-133,14]],[[27005,64164],[-1,116],[27,0]],[[24146,58111],[-1,-102],[-9,-28],[-3,-78],[7,-18],[-5,-69],[-10,-2]],[[24125,57814],[-12,-32],[-13,-11],[6,38],[-14,-35],[-12,-8],[-90,6]],[[23990,57772],[0,37],[17,11],[15,58],[8,3]],[[25821,64562],[-32,1]],[[25789,64563],[-97,2]],[[25692,64565],[0,302]],[[31449,38179],[11,10],[6,26]],[[31466,38215],[4,-20]],[[31470,38195],[6,-41]],[[31476,38154],[-10,-32],[-1,-27],[-8,13]],[[22399,65529],[127,0]],[[22526,65529],[1,-4],[0,-299]],[[22401,65126],[-2,-1]],[[21615,56321],[146,4]],[[25168,59746],[0,203]],[[25168,59949],[31,-5],[60,-1]],[[25259,59943],[0,-223]],[[25259,59720],[-1,-290]],[[25258,59430],[-8,0]],[[25250,59430],[-83,2]],[[25167,59432],[1,314]],[[25958,59688],[47,115],[19,23]],[[26024,59826],[35,-10],[5,-17]],[[26064,59799],[2,-48],[13,-3],[7,-50],[13,2],[-7,-50],[16,-84]],[[26108,59566],[-14,-4],[-84,8]],[[26010,59570],[-52,8]],[[25958,59578],[8,39],[-8,71]],[[24938,62338],[14,0],[0,33],[94,0]],[[25045,62038],[-96,2]],[[24949,62040],[0,153],[-11,-1],[0,146]],[[23742,57293],[15,0],[2,55],[15,-2],[9,25],[20,15]],[[23803,57386],[88,-2]],[[23891,57384],[-2,-68],[-1,-336]],[[23888,56980],[-1,-67]],[[23887,56913],[-19,2]],[[23868,56915],[-127,11]],[[23741,56926],[1,367]],[[25957,59342],[42,-16]],[[25999,59326],[-5,-144],[5,-38],[14,-21]],[[26013,59123],[-8,-123]],[[26005,59000],[-9,-4],[-7,-40],[-13,26],[0,-22],[-13,15],[-8,-27],[-20,-1]],[[25935,58947],[-22,244]],[[25412,63363],[89,2],[17,-15],[6,16]],[[25524,63366],[1,-320]],[[25525,63046],[0,-152]],[[25525,62894],[-44,0],[0,12],[-76,-7]],[[25405,62899],[-1,238]],[[25404,63137],[-1,124],[9,0],[0,102]],[[27909,63964],[32,242],[16,140]],[[27957,64346],[126,0]],[[28083,64346],[-17,-93],[-9,-4],[-1,-58],[-11,-59],[-15,-40],[-6,-79],[-1,-79],[-16,-51]],[[28007,63883],[-10,-98]],[[27997,63785],[-63,2],[-3,32],[-11,15],[-34,0]],[[27886,63834],[23,130]],[[15601,68997],[2,34]],[[15603,69031],[28,-13],[12,-60],[12,40],[6,-7],[37,89],[23,0],[10,-18],[19,15],[32,-45],[51,10],[10,-9],[15,-63],[26,31],[28,-43],[65,-4]],[[15977,68954],[-3,-80],[5,-24],[-4,-90],[-11,-29],[1,-115]],[[15965,68616],[1,-125],[6,-27]],[[15972,68464],[-142,-11],[0,-25],[-16,-16],[-53,12],[-20,45],[-32,28],[-29,-4],[0,-33],[-10,1],[-1,-68],[-72,-1],[4,31],[-8,28],[0,38]],[[15593,68489],[-10,48],[-8,8],[7,33],[-3,84],[7,13],[-2,72],[-13,58],[1,20],[20,18],[3,54],[28,19],[-13,31],[-9,50]],[[23583,69198],[1,-204]],[[23549,68690],[-44,0]],[[23505,68690],[-9,33],[-15,16]],[[23481,68739],[-34,56],[-7,-4],[-48,95],[-16,49],[-13,-6],[-8,37],[-11,6]],[[23344,68972],[-23,52],[-12,11]],[[23309,69035],[0,161],[66,0]],[[23401,70916],[118,0]],[[23519,70916],[3,-20],[19,-3]],[[23541,70893],[2,-669]],[[23543,70224],[-138,-1]],[[15624,69410],[20,49],[-9,28],[8,29],[-11,64],[11,4],[0,43],[9,28],[19,-33],[14,3]],[[15685,69625],[4,17],[27,-17],[-5,-101],[-9,-50],[11,-25],[12,-57],[31,-46],[16,-96],[41,-60],[183,0]],[[15996,69190],[-6,-65]],[[15990,69125],[-15,-18],[-1,-38],[14,-23],[-12,-38],[1,-54]],[[15603,69031],[-1,24],[16,49],[-24,23],[18,115],[19,16],[1,51],[-10,31],[2,70]],[[28536,63642],[7,43],[6,-8],[20,47],[11,8]],[[28695,63870],[78,-208]],[[28773,63662],[-18,-30],[0,-86],[-16,-99],[1,-97],[-21,-127],[-19,-44]],[[28700,63179],[-27,0]],[[28673,63179],[-2,0]],[[28671,63179],[-10,62],[-18,54],[-12,61],[-3,45],[-24,43],[-5,55],[-11,63],[-10,-6],[-25,20],[-17,66]],[[24213,58511],[112,-8]],[[24325,58503],[13,8],[-1,-207]],[[24337,58304],[0,-91],[-15,-23],[-1,-91],[-72,6]],[[24249,58105],[-40,1]],[[26653,54012],[76,-3],[9,4]],[[26738,54013],[11,-39],[15,-3],[15,-39],[9,3]],[[26788,53810],[-50,6],[0,-31],[-25,3],[0,29],[-16,1],[0,89],[-36,1]],[[26661,53908],[-8,104]],[[6254,41293],[5,69],[11,56],[14,6],[13,-33],[10,-78],[10,-50],[24,29],[18,35],[26,-21],[0,-16],[17,-51],[10,-15],[5,-40],[31,-37],[5,-32],[0,-52],[-8,-43],[-13,-40],[-6,3],[-17,-36],[-14,10],[-30,-53],[-21,-9],[-17,26],[-7,210],[-7,20],[-14,-24],[-26,50],[-13,58],[-6,58]],[[6253,40841],[7,29],[28,57],[10,-30],[-4,-44],[5,-17],[-13,-19],[-5,15],[-18,-23],[-10,32]],[[6153,41274],[7,27],[13,5],[26,-19],[17,-60],[8,-51],[-9,-65],[-19,-29],[-17,-5],[-7,60],[-3,73],[-14,32],[-2,32]],[[6166,41601],[21,-29],[6,-36],[6,21],[-6,24]],[[6193,41581],[14,-4],[27,18],[17,-25],[-8,-55],[-18,-51],[-20,-21],[-35,32],[-26,31],[-15,-14],[-29,-5],[-16,17],[6,52],[9,29],[-2,58],[17,-2],[3,-14],[49,-26]],[[24166,61011],[1,188]],[[24167,61199],[61,-5]],[[24228,61194],[46,-7]],[[24274,61187],[-2,-475]],[[24272,60712],[-62,2]],[[22515,50247],[0,-646]],[[24456,65668],[-129,2]],[[24327,65670],[-1,102],[1,407]],[[21748,58913],[151,-1]],[[24197,65260],[98,1]],[[24295,64857],[-65,-1]],[[26862,62984],[0,17],[31,-6],[1,52],[34,-7],[1,69],[33,-8]],[[26962,63101],[-2,-68],[33,-7],[-1,-33],[30,-7]],[[27022,62986],[-3,-105],[-31,8],[-3,-103]],[[26985,62786],[-62,13],[-1,-30],[-33,7],[0,-17],[-32,8]],[[26857,62767],[2,117]],[[26235,54630],[10,-2],[18,40],[32,12],[12,101],[8,13]],[[26315,54794],[16,19]],[[26331,54813],[-5,-47],[-1,-305]],[[26325,54461],[-73,-2]],[[26252,54459],[8,38],[-12,40],[-18,28],[5,65]],[[19541,71361],[105,-2]],[[19870,71367],[1,-61],[9,-27],[-13,-97],[12,0],[0,-118],[4,0]],[[19883,71064],[0,-117],[-41,0],[-28,-102],[0,-51],[-81,0],[-12,-33],[-12,1],[0,-120],[-104,-1]],[[26148,55852],[78,-2]],[[26247,55616],[-41,-62],[-6,27],[-3,-36],[-33,-40]],[[26164,55505],[-16,347]],[[24550,73035],[15,36],[25,30],[14,-13],[0,-67],[17,-17],[-6,-26],[10,-48],[16,-3],[35,29],[6,-29],[25,15],[26,-18],[19,13],[48,8],[29,-28],[9,-66],[34,-53],[15,35],[20,9],[13,-20],[23,6],[11,-18],[25,22],[-27,-56],[-10,20],[-4,-34],[-17,-15],[-26,-58],[-37,-34],[-14,-37],[-52,-44],[-48,-54],[-15,-6],[-42,-45],[-4,-14],[-51,-77],[-37,-79],[-43,-107]],[[24552,72192],[1,493],[-2,17],[-1,333]],[[23336,66485],[132,-2]],[[23468,66483],[0,-100],[16,0],[-1,-308]],[[27863,59477],[95,0]],[[27958,59477],[1,-18],[-2,-338]],[[27957,59121],[-42,4]],[[27859,59128],[4,349]],[[3834,96137],[-84,65],[-51,23],[-29,35],[-19,70],[-54,84],[-45,40],[-81,41],[-42,-6],[37,40],[92,59],[20,46],[3,57],[19,76],[11,236],[-8,117],[179,-31],[68,6],[144,42],[79,28],[77,15],[77,63],[41,65],[29,30],[53,87],[81,192],[21,92],[7,79],[-2,186],[39,233],[84,183],[65,179],[37,77],[129,162],[96,-35],[69,-3],[68,40],[64,53],[93,104],[74,108],[44,86],[114,188],[33,31],[99,63],[7,-47],[55,-44],[82,-12],[68,15],[13,24],[32,-3],[61,17],[73,51],[74,85],[71,121],[36,88],[86,185],[68,76],[12,-68],[47,-38],[39,-2],[39,-20],[16,-82],[27,41],[99,-49],[15,-98],[-54,-71],[-35,-63],[-41,-4],[12,-146],[81,-15],[44,59],[-7,76],[16,8],[31,67],[23,12],[19,-48],[4,63],[-27,43],[35,55],[21,-47],[-3,65],[15,22],[71,-74],[45,-66],[13,-42],[-11,-33],[1,-109],[9,-49],[61,10],[35,-37],[16,-40],[48,62],[30,75],[112,0],[69,42],[53,-11],[40,-34],[84,-2],[61,-32],[45,-35],[9,-34],[-26,-11],[-26,-83],[-26,-30],[14,-93],[25,5],[19,-24],[45,-6],[10,-28],[69,-20],[33,9],[-17,-43],[9,-25],[-53,-26],[-8,-24],[20,-25],[89,6],[72,-41],[14,-33],[28,5],[44,86],[57,15],[24,-18],[10,34],[40,7],[29,-27],[15,-59],[42,27],[38,8],[58,83],[13,-22],[45,20],[21,-15],[34,26],[12,-30],[66,-8],[62,-72],[28,-1],[19,-24],[26,31],[24,-8],[37,-73],[0,-45],[35,-19],[41,51],[1,-63],[26,57],[81,-77],[14,-67],[24,-23],[49,1],[43,-15],[29,36],[23,-73],[48,-10],[29,45],[43,-12],[62,12],[66,-10],[49,-38],[50,-3],[17,28],[65,-95],[28,-8],[32,-54],[45,-16],[20,-30],[45,-12],[17,-26],[27,32],[66,-20],[45,77],[48,6],[9,20],[84,49],[18,24],[86,30],[42,-25],[48,32],[9,-18],[79,-73],[53,-37],[70,-80],[26,-67],[37,-11],[87,-97],[68,-40],[52,-62],[27,-47],[61,-13],[58,-45],[0,-1335]],[[31527,37962],[38,-55]],[[31565,37907],[-17,-36]],[[31548,37871],[-9,14],[-2,35],[-10,42]],[[26051,64669],[86,4]],[[26136,64570],[1,-306],[-32,-1]],[[26105,64263],[-53,0]],[[24516,60822],[2,51],[13,-1]],[[24657,60866],[0,-107],[31,1]],[[24688,60760],[-3,-53],[-1,-327]],[[24684,60380],[0,-52],[-52,-2]],[[24632,60326],[-5,-1],[1,119],[-6,1],[1,267],[-61,1],[-32,-18],[-15,0]],[[21868,55312],[-93,1],[-13,7]],[[27385,60182],[15,38],[54,75]],[[27454,60295],[-2,-39],[7,-32],[17,27],[-10,-38],[9,-47]],[[27461,60115],[11,-48],[-7,-1],[7,-73]],[[27472,59993],[-15,-49],[-11,-13]],[[27446,59931],[-13,-43],[-16,-18]],[[27417,59870],[-34,145],[-9,27],[-5,54]],[[27369,60096],[-5,48],[21,38]],[[23665,63207],[0,50]],[[23790,63050],[0,-101]],[[23790,62949],[-125,3]],[[25598,55951],[23,50],[-5,27],[7,41],[24,16],[0,34],[10,-1],[5,36],[4,100],[15,16],[5,33]],[[25686,56303],[19,33],[35,-3],[31,-87],[19,-1]],[[25790,56245],[10,0],[5,-51],[0,-76],[-7,-42],[0,-69],[9,-17]],[[25807,55990],[0,-26],[-12,-7],[-12,-59],[-18,-1],[-14,-58],[-9,-1],[-7,-57],[-15,-7],[0,-33],[-14,0],[-25,-75],[-3,-25],[-13,0]],[[25665,55641],[-10,1]],[[25655,55642],[0,33],[-27,36],[-10,60],[-10,9],[0,34],[-14,53],[-15,18],[2,42],[12,-7],[5,31]],[[6433,39922],[2,44],[19,76],[12,7],[13,93],[16,52],[3,58],[-17,94],[-4,45],[-1,105],[8,37],[18,-9],[18,-32],[3,-32],[22,-44],[15,-47],[12,6],[25,-32],[39,-77],[13,-19],[22,-61],[16,-57],[17,-76],[-3,-47],[1,-90],[8,-10],[16,12],[7,-57],[-1,-57],[22,-82],[22,-39],[5,-21],[-4,-44],[-13,-51],[-17,-47],[-14,-56],[-23,-38],[-20,-47],[-20,-18],[-16,15],[-9,-9],[-18,-66],[-16,-25],[-13,-48],[-14,-16],[-12,-59],[1,-33],[-8,-37],[-5,-59],[-20,-63],[-15,61],[-22,52],[-22,29],[-10,95],[5,113],[4,151],[-10,106],[1,46],[-9,12],[-5,114],[-7,66],[-9,8],[-8,108]],[[17077,71214],[15,1],[16,81],[26,6],[14,-32],[23,5],[14,26],[10,-49],[10,-4],[1,-33],[15,-51],[23,-42],[7,-97]],[[17251,71025],[0,-59],[-36,1],[1,-17],[-18,-17],[0,-304],[-17,0],[0,-144]],[[17181,70485],[-34,1]],[[17147,70486],[0,142],[-3,0],[0,253],[-17,-1],[0,53],[-12,17],[-6,86],[-35,-1],[3,179]],[[25993,55935],[-5,-26],[24,-8],[5,34],[34,-4]],[[26051,55931],[-2,-199],[-1,-254]],[[26048,55478],[-90,-1],[-9,-18]],[[25949,55459],[0,17],[-46,0]],[[25903,55476],[0,106],[15,-1],[1,118],[38,-2],[1,102],[15,16],[0,68],[5,0],[0,52],[15,0]],[[23026,66484],[178,-1]],[[23204,66483],[33,1]],[[23257,66077],[-191,4]],[[23066,66081],[9,17],[-9,55]],[[23066,66153],[-5,48],[-11,29],[0,76],[9,44],[-4,44],[-14,8]],[[23041,66402],[-13,31],[4,45],[-6,6]],[[23166,65257],[139,-1]],[[23401,65255],[0,-403]],[[23337,64853],[-138,0]],[[23199,64853],[11,17],[-23,19]],[[23187,64889],[3,42],[-5,63],[13,41],[-20,27],[5,60]],[[23183,65122],[1,85],[-20,10],[2,40]],[[18207,67657],[19,25],[8,-7],[8,-98],[10,-3],[0,-151],[76,-1],[0,-96],[99,0]],[[18427,67326],[0,-202]],[[18427,67124],[-66,0],[0,-306],[2,-100],[16,0],[0,-101],[-16,0],[0,-58]],[[18298,66610],[0,209],[16,0],[0,408],[-84,0]],[[18046,67227],[0,68],[-6,0],[1,80],[-39,8],[2,76],[-6,43],[11,49],[-15,25],[-10,37],[3,32],[-27,37],[6,82],[-7,29],[6,61],[-7,14],[-7,75],[-12,-27],[-12,13],[-15,-13],[2,29],[-39,49]],[[17875,67994],[-2,65],[7,28]],[[30697,68452],[13,68],[2,64],[9,25],[6,-26],[-9,-35],[1,-36],[-8,-70],[-10,-29],[-4,39]],[[30556,68965],[16,10],[8,61],[12,-4],[5,-41],[16,8]],[[30613,68999],[18,9],[6,-99],[96,67],[6,-21]],[[30743,68770],[-8,-73],[-14,-40],[-11,33],[-7,-32],[-15,-4],[14,-81],[-3,-48],[-12,-23],[-7,-53]],[[30680,68449],[-26,7],[-41,127],[-22,-65],[-15,40],[-2,-17]],[[30574,68541],[-27,17]],[[30547,68558],[17,141],[13,-8],[7,102],[-12,7],[6,104],[-19,8],[5,30],[-8,23]],[[30077,66160],[8,24]],[[30085,66184],[3,-10],[13,63],[-14,-22]],[[30087,66215],[-5,24],[12,27],[8,-25],[9,18],[12,89]],[[30123,66348],[18,-1]],[[30141,66347],[-8,-42],[11,-74],[-13,10],[2,-46]],[[30133,66195],[-14,-11],[-5,-42],[-15,-10],[-5,-36],[-17,64]],[[29567,66693],[26,-2]],[[29593,66691],[131,-14]],[[29724,66677],[49,-6]],[[29773,66671],[3,-55],[12,-14],[0,-54],[-10,-18],[-1,-78],[7,-24],[-13,-39],[2,-45],[-6,-24],[-3,-89]],[[29764,66231],[-11,-47],[0,73],[-6,64],[-30,-16],[-2,31],[-59,-33],[1,55],[-16,-8],[-5,24],[-27,20],[-1,67],[-28,17]],[[29580,66478],[7,99],[-1,28],[-11,10],[13,36],[-21,-2],[0,44]],[[26534,68055],[-5,-144],[-8,-42],[13,-91],[16,-32],[9,33],[5,-38],[20,-21],[8,-25]],[[26592,67695],[1,-143]],[[23039,68388],[0,404]],[[23039,68792],[1,102]],[[23040,68894],[99,-1]],[[24494,56008],[28,41],[-2,33],[-25,51],[2,28],[17,16],[7,-35],[16,-22],[12,18],[-8,50],[-13,-14],[-10,26],[1,59],[24,2],[8,-18],[10,34],[-16,26],[-7,55],[18,78],[-22,34],[3,29],[16,23],[5,-43],[11,16],[-7,45],[24,6],[8,61],[-3,24],[-11,-3],[-9,29]],[[24571,56657],[0,1]],[[24571,56658],[82,-1],[1,-153]],[[24654,56504],[-1,-432],[-29,-1],[0,-101]],[[24624,55970],[-126,0]],[[24498,55970],[-4,38]],[[26542,69558],[137,6]],[[26679,69564],[8,-51],[11,-30],[14,-133],[-20,21],[-16,34],[-15,-41],[4,-110],[12,-44],[21,-26],[0,-26]],[[26698,69158],[-158,-2]],[[24721,71146],[19,40],[12,3],[39,49],[38,34],[39,106]],[[24868,71378],[7,0],[0,-201],[34,0],[0,-101],[105,0],[0,-201],[104,-1]],[[25118,70874],[0,-274]],[[25118,70600],[-28,48],[-233,188]],[[24857,70836],[-54,43],[1,27],[-28,167],[-27,16],[-10,24]],[[24739,71113],[0,0]],[[24739,71113],[-12,-6],[-6,39]],[[30255,70100],[8,-1],[15,41],[24,38],[-9,71],[21,66],[23,45],[5,56],[-7,28],[-14,0],[0,66],[10,38],[-8,14],[15,51],[5,46],[-15,44],[16,115],[8,18],[-1,37],[17,32],[14,59],[11,8],[10,183]],[[30487,71155],[0,-209],[-3,0],[1,-486],[12,8],[10,-140],[-10,-14],[-4,40],[-11,-3],[9,-34],[-6,-107],[-15,9],[-1,-90],[13,-16],[10,-59],[-8,-71],[-14,-28],[35,-516],[10,-103],[29,16],[4,34],[41,22]],[[30589,69408],[20,-307],[4,-102]],[[30556,68965],[-3,32],[-40,-22],[0,-34],[13,-59],[-7,-51],[-48,36],[-4,-36],[-17,51],[-21,-12]],[[30429,68870],[-9,82],[-10,-4],[-10,217],[-27,-16],[-6,106],[11,7],[-13,210],[-38,-21],[-5,64],[-29,-24],[-28,428],[3,2],[-13,179]],[[24524,54436],[17,9],[7,27],[14,-31],[5,42],[-2,53],[12,-8],[16,79],[-4,18],[-6,-40],[-23,17],[0,58],[8,20],[-8,35],[-10,-20],[-23,49],[3,58],[5,1],[17,-48],[10,7],[-5,26],[-20,39],[2,18]],[[24539,54845],[7,16]],[[24546,54861],[22,-1],[1,-191],[3,38],[25,-1],[0,154],[37,-11],[2,62]],[[24636,54911],[9,-1],[0,-34],[9,1],[1,-51],[18,0],[10,-17],[0,-28]],[[24683,54781],[-14,-33],[5,-39],[-14,-83],[2,-41],[-15,16],[-7,-15],[3,-40],[-9,-94]],[[24634,54452],[-17,-58],[4,-25],[-14,3],[-16,-49],[-7,21],[-3,-60],[-31,39]],[[24550,54323],[0,7]],[[24550,54330],[7,43],[-15,24],[2,-62]],[[24544,54335],[-32,11],[2,79],[10,11]],[[28682,67787],[49,-14],[0,45],[69,-21]],[[28800,67797],[5,-255]],[[28805,67542],[-16,16],[-20,-185],[7,-7],[-6,-190]],[[28770,67176],[-14,24],[-17,8]],[[28739,67208],[-58,103],[2,-63],[-8,-15],[-10,38],[-6,-42],[-7,34],[-48,-3]],[[28604,67260],[-1,34],[-34,1],[-3,188]],[[28566,67483],[26,57],[10,8],[19,54],[14,5],[20,-15],[17,19],[9,53],[1,123]],[[23278,68790],[66,0],[0,182]],[[23481,68739],[0,-251],[-67,-1],[0,-101]],[[26541,65234],[1,271]],[[26542,65505],[33,4]],[[26575,65509],[86,11]],[[26661,65520],[1,-26],[21,-28],[13,17],[26,-65],[19,-26]],[[26741,65392],[-70,-5]],[[26671,65387],[-43,-2],[-11,-54],[-26,-49],[-2,-42],[-10,-31],[-38,-60]],[[26541,65149],[0,85]],[[24456,65159],[0,204]],[[24586,65362],[33,-1],[-1,-167]],[[24618,65194],[-17,3],[-23,-40],[-13,15],[-19,-21],[-8,-96]],[[24538,65055],[-82,3],[0,101]],[[22569,57108],[0,-252]],[[22569,56856],[0,-173]],[[22569,56683],[-8,-32],[-20,22],[-15,0],[-19,28],[-17,-85]],[[22490,56616],[-17,-25],[-24,96],[-11,14]],[[22438,56701],[0,206],[-14,-1],[0,85]],[[23337,64552],[-120,0]],[[23217,64552],[-7,45],[3,44],[-9,20],[-5,68]],[[23199,64729],[4,31],[-4,93]],[[29435,64577],[10,-65],[8,-167],[2,-132]],[[29455,64213],[-37,-33],[-54,9]],[[29364,64189],[-5,40],[12,34],[0,83],[7,33],[-19,55]],[[29359,64434],[15,81],[11,-15],[10,42],[21,27],[19,8]],[[20768,71489],[30,0],[24,50],[29,161],[-3,161],[-19,126],[-18,36],[8,41]],[[20819,72064],[81,-1],[0,51],[24,-1]],[[20924,72113],[0,-78]],[[20924,72035],[0,-801]],[[20924,71234],[-86,0],[0,33],[-18,17],[-53,0]],[[20767,71284],[1,205]],[[24848,59299],[58,-3],[6,48],[15,-31],[18,12],[19,-60],[0,-27]],[[24964,59238],[-19,5],[0,-37],[21,-39],[1,-27],[-15,-15],[-30,16],[-3,-21],[21,-58]],[[24940,59062],[11,-41],[-3,-36],[-22,-40],[-3,-75],[-12,-23]],[[24911,58847],[-63,-2]],[[24848,58845],[0,454]],[[24324,63442],[113,-3]],[[24437,63439],[5,-21],[-8,-66],[5,-38],[15,-34],[3,-58]],[[24457,63222],[-2,-31],[18,-55]],[[24473,63136],[-114,2],[0,-34]],[[24359,63104],[-37,1]],[[19530,55597],[112,1],[55,-10],[125,0]],[[19822,55588],[38,-1],[8,-154],[-5,-13],[-1,-63],[8,-45],[15,-13],[3,-44],[-3,-71],[15,-88],[-1,-136],[-4,-37],[36,-28]],[[19762,54032],[-86,-1],[0,252],[-4,0],[1,222],[-1,286],[-30,0],[0,102],[-58,-1],[0,203],[-54,1]],[[19530,55096],[0,501]],[[28228,62493],[21,175],[9,45]],[[28270,62716],[17,-25],[15,1],[6,-45],[13,-16],[10,-36]],[[28331,62595],[-16,-58],[-1,-58],[10,-13],[6,-39],[37,-21]],[[28367,62406],[-57,-245]],[[28310,62161],[-5,46],[-11,12],[-8,40],[-10,13]],[[28276,62272],[-85,83]],[[28191,62355],[28,78],[9,60]],[[21227,69571],[2,202],[2,403],[0,247]],[[21231,70423],[263,-1]],[[21494,70422],[0,-549]],[[21494,69873],[0,-506]],[[21494,69367],[-267,2]],[[22428,51565],[65,224]],[[22525,51906],[75,-220],[8,-112]],[[22608,51574],[-25,-80],[-61,-104]],[[22522,51390],[-10,29],[0,41],[-10,23],[0,34],[12,21],[-22,29],[-17,-15],[-18,21],[-11,-12],[-18,4]],[[22203,48678],[23,63],[11,-53],[105,-5]],[[22342,48120],[-16,-128],[-44,-121]],[[22282,47871],[-2,57],[-6,42],[-3,79],[-8,25],[-1,49],[-7,64],[-17,43],[2,31],[-13,26],[-7,37],[5,20],[-11,46],[-9,7],[-1,52],[6,31],[-3,66],[4,29],[-8,103]],[[22865,49435],[17,36],[9,45],[18,127],[27,53]],[[22936,49696],[-8,-92]],[[22928,49604],[-27,-104],[-15,-73],[-11,-83]],[[22875,49344],[-10,91]],[[22945,49905],[-2,-54]],[[22943,49851],[-3,-64]],[[22940,49787],[-18,-48],[-17,-61],[-8,-1],[-18,30],[0,42]],[[22879,49749],[-27,80],[0,21],[93,55]],[[22827,49623],[21,-23],[24,57],[8,-74],[-7,-23],[-24,-140]],[[22849,49420],[-35,202]],[[22814,49622],[13,1]],[[23690,52143],[60,1]],[[23750,52144],[55,2]],[[23805,52146],[-5,-40],[9,-79],[-12,-70],[9,-19],[-6,-16]],[[23800,51922],[-5,-35],[-14,-39],[-7,-78],[-11,-65]],[[23763,51705],[4,92],[-5,39],[-39,41],[-9,18],[0,38],[-17,26],[3,51],[-10,39]],[[23690,52049],[7,51],[-7,43]],[[21124,54191],[73,0],[0,100]],[[21271,54290],[0,-505]],[[21271,53785],[-147,-1]],[[21124,53784],[0,407]],[[27938,60641],[12,13]],[[27950,60654],[34,-113],[6,-31],[13,-15],[2,-37],[10,16]],[[28015,60474],[0,-62],[-9,-27],[-16,-85]],[[27990,60300],[-14,-33],[-12,10],[-13,-28]],[[27951,60249],[-9,8],[-2,33],[-16,6],[-2,37],[-26,177]],[[27896,60510],[12,46],[23,52],[7,33]],[[16477,71907],[1,117],[23,51],[0,34],[12,17],[0,34],[96,5],[0,100],[36,99],[23,17],[6,50],[0,68],[12,16],[0,34],[12,34],[0,101],[24,35],[6,52],[34,0]],[[16762,72771],[3,-22]],[[16765,72749],[-2,-793]],[[16655,71346],[0,-70],[-24,2]],[[16631,71278],[-16,56],[-30,-93],[-25,1],[-12,-15],[-34,-9]],[[16514,71218],[-20,56],[-8,71]],[[27375,62681],[17,57],[27,61],[5,40],[16,4],[11,20]],[[27471,62838],[0,-73],[4,-7],[-20,-86],[16,-60],[-6,-16],[11,-30],[-19,-33]],[[27457,62533],[-17,-30],[-12,-59],[-8,6]],[[27397,62466],[-29,190],[7,25]],[[27599,62277],[53,31],[9,115],[11,50]],[[27802,62297],[2,-8]],[[27804,62289],[-7,-43],[-22,11],[3,-36],[-18,-27],[-9,-40],[9,-71],[-33,-135]],[[27545,61983],[12,57],[31,3],[8,110],[-3,65],[6,59]],[[23317,67578],[19,-1]],[[23336,67577],[0,-285]],[[23204,67295],[0,282]],[[26626,60600],[12,-104],[-4,-27],[1,-69]],[[26635,60400],[-1,-55],[6,-34]],[[26640,60311],[-19,40],[-16,76],[-7,-24],[-29,13]],[[26569,60416],[-10,39],[-9,77],[-9,34],[0,47]],[[28053,59478],[37,1]],[[28090,59479],[13,-276],[-8,-47]],[[28042,59050],[-3,9],[-1,317],[4,69],[11,33]],[[19056,56825],[0,-307],[209,0],[0,-492]],[[19265,56026],[0,-103],[-16,-26],[-24,-1],[-20,-32],[-17,3],[-18,-16],[-2,-21],[-19,-12],[-10,-41],[2,-123],[11,-70],[-12,-3]],[[19140,55581],[-16,-10],[-24,-61],[-11,10],[-13,-36],[-4,-40],[-9,-8],[-1,-50],[-15,-50],[-46,309],[-8,107],[-18,145]],[[18975,55897],[-31,246],[-16,-51],[-4,-37],[-11,24],[-19,76],[-2,36],[-13,36],[-1,62],[5,24],[-12,71],[2,41],[-12,0],[1,95],[-14,-2]],[[18848,56518],[1,45],[8,40],[-8,71],[4,20],[-65,0],[5,35],[-2,69],[10,53],[1,117],[30,62],[0,37]],[[24017,58980],[15,-1]],[[24032,58979],[15,0],[0,-51],[118,-9]],[[24165,58919],[-1,-101]],[[24164,58818],[0,-218]],[[24015,58526],[3,309],[-1,145]],[[24456,57581],[20,-1],[1,85],[15,0],[0,22],[25,-2]],[[24517,57685],[-1,-105],[10,0],[0,-52],[5,0]],[[24531,57528],[-1,-154],[15,-1],[-1,-103]],[[24544,57270],[-1,-204],[15,-1],[0,-155],[-15,0]],[[24543,56910],[-11,9],[-10,43],[-12,81],[-9,6],[-3,36],[-13,17],[1,30],[-11,8],[2,32],[-24,2]],[[24453,57174],[0,34],[-19,19],[0,68],[20,-2],[1,185],[8,57],[-7,46]],[[25995,52680],[6,42],[0,61],[20,-2],[4,-50],[33,-3],[-1,31],[6,70]],[[26063,52829],[33,-1],[0,-51],[14,-1],[-1,-253]],[[26496,55966],[32,146],[5,71],[-1,37]],[[26532,56220],[44,-113],[7,-1],[15,-57]],[[26597,55967],[2,-46],[-17,-7],[-10,-33],[-15,-18],[-1,-51],[-9,-29]],[[26530,55871],[-6,44],[-24,19],[-4,32]],[[26979,50652],[100,-1]],[[27079,50651],[0,-475],[-1,-240]],[[27078,49936],[0,-43],[-18,18],[-10,-13]],[[27051,50091],[0,50],[-12,4],[-12,47],[-20,10],[-18,96],[4,13]],[[26993,50311],[3,58],[17,48],[6,40],[-4,33],[-25,88],[-11,74]],[[26055,62866],[92,0]],[[26147,62651],[-40,-85]],[[26039,62491],[0,255]],[[24257,66887],[0,204]],[[24257,67091],[133,-1]],[[24390,67090],[-1,-510]],[[23904,65671],[33,0]],[[26453,60619],[8,40],[22,11]],[[26483,60670],[13,-4],[22,21],[17,-45]],[[26569,60416],[-26,-63],[-7,-47],[-12,-4]],[[26524,60302],[-29,20],[-25,61]],[[26470,60383],[3,44],[-12,32],[3,38],[-12,79],[1,43]],[[24434,54868],[14,32],[-1,97],[15,74],[2,123],[8,32],[0,54],[8,17],[5,63]],[[24485,55360],[27,-1]],[[24512,55359],[-10,-50],[-3,-48],[9,-22],[14,26],[-1,67],[11,4],[9,-72],[-2,-39],[-21,-52],[-5,-37],[-1,-71],[31,-30],[-2,-27],[-16,-33],[-9,-38],[3,-52],[6,-14],[20,26],[6,46],[5,-52],[-10,-30]],[[24539,54845],[-11,0],[-7,-29],[-90,0]],[[24431,54816],[7,27],[-4,25]],[[24200,52034],[23,-6],[21,-31],[11,14],[6,-63],[29,-43]],[[24290,51905],[-8,-61],[6,-176]],[[24288,51668],[-2,-39],[-24,-36],[-14,-34],[-6,32],[-18,-16],[0,-32],[9,-30],[18,-8],[-9,-30],[8,-63],[20,21],[5,-18],[-13,-14],[6,-20],[-32,-6],[-26,-49],[-20,-9],[-82,63]],[[24108,51380],[1,219],[-1,307],[-34,-1]],[[24074,51905],[32,64]],[[24104,52430],[13,92],[-4,20],[0,363]],[[24113,52905],[25,0],[8,26],[0,39],[28,56],[14,-43],[14,2]],[[24202,52985],[0,-33],[11,-51],[1,-52],[7,1]],[[24221,52850],[1,-75],[10,-19],[0,-110],[-11,-70],[0,-53],[-14,0],[0,-34],[-43,0],[-12,-12],[-2,-38],[-8,-18]],[[24104,52422],[0,8]],[[23554,63548],[77,0],[31,-5]],[[23555,63208],[0,85]],[[23555,63293],[-1,255]],[[24568,61812],[20,-8],[33,63],[12,52]],[[24633,61919],[-1,-201]],[[24632,61718],[0,-60],[-8,-139],[-4,-107]],[[24532,61412],[-76,0],[0,7]],[[24456,61419],[0,570]],[[23036,64111],[111,1]],[[23147,64112],[0,-304]],[[23036,63808],[0,303]],[[22396,65934],[128,0]],[[22526,65732],[0,-203]],[[19902,55909],[345,-1],[28,5]],[[20275,55913],[1,-104],[7,0]],[[20283,55809],[1,-393]],[[20284,55416],[-152,-268],[0,-51],[-115,1],[0,-203]],[[19822,55588],[0,323],[17,-5],[63,3]],[[28234,58112],[31,9],[5,-34],[25,30],[31,62]],[[28326,58179],[14,-90],[10,-11]],[[28350,58078],[-11,-12],[-5,-32],[5,-59],[-12,-26]],[[28327,57949],[-15,16],[6,-82],[-27,-118],[-36,-73]],[[28255,57692],[-4,16],[-1,101],[-5,43],[-19,37]],[[28226,57889],[3,194],[5,29]],[[27152,58358],[12,-22],[31,3]],[[27195,58339],[23,-168]],[[27218,58171],[15,-78],[12,-26],[1,-62],[9,-20],[-2,-112]],[[27253,57873],[-11,1]],[[27242,57874],[-112,18]],[[27130,57892],[3,49],[16,157],[3,260]],[[20922,65124],[188,2]],[[21110,65126],[0,-404],[-1,-53]],[[21109,64669],[-54,0]],[[21055,64669],[-133,-1]],[[20922,64668],[0,456]],[[23232,59036],[39,0],[5,-34],[10,-5],[4,-44],[-5,-19],[36,0]],[[23321,58934],[65,-1]],[[23370,58629],[-27,11],[-16,-27],[-16,5],[-24,-19],[-7,-26],[-14,26],[-3,81],[-32,-1]],[[23231,58679],[-15,0]],[[23216,58679],[0,52],[16,0],[0,305]],[[22700,58121],[147,0]],[[22847,58121],[0,-522]],[[22847,57599],[-33,20],[-4,20],[-18,1],[-5,82],[1,50],[-13,11],[-2,60],[-43,112],[1,66],[-16,17],[-15,37]],[[22700,58075],[0,46]],[[22789,57108],[58,0],[-4,52],[-12,83],[16,0],[0,17],[59,0]],[[22906,57260],[0,-51],[29,0],[0,-102]],[[22935,57107],[-15,0],[0,-201],[-15,-1]],[[27582,64288],[127,-6]],[[27709,64282],[1,-31],[-9,-41],[-15,-31],[2,-36],[18,-29],[-1,-106],[-8,-42],[-8,-6],[-12,-186],[7,-6],[-25,-36]],[[27659,63732],[-25,22],[-3,19],[16,24],[-75,93],[-49,169]],[[27107,57210],[8,100],[11,183],[20,88]],[[27146,57581],[18,-15],[2,-22],[15,7],[12,-20],[17,-4],[7,-32]],[[27217,57495],[-6,-20]],[[27227,57184],[0,-90]],[[27227,57094],[-18,-5],[-15,-53],[-4,37],[-25,66]],[[27165,57139],[-9,29],[-11,-5],[-38,47]],[[21904,68796],[237,1]],[[22068,68386],[13,54],[-9,29],[-17,2],[-28,47],[-22,19],[-19,1],[-37,35],[-6,98],[-6,21],[-18,3],[-17,-19],[-13,20],[2,35],[12,28],[1,37]],[[26426,59947],[9,20],[8,-25],[4,22],[11,-24],[16,36],[9,-17]],[[26483,59959],[7,-118],[11,-42],[12,-20],[-1,-49],[8,-37],[23,-47]],[[26543,59646],[-22,-48],[7,-68]],[[26528,59530],[-16,3]],[[26512,59533],[-67,3]],[[26445,59536],[-22,98],[-4,96],[-8,25],[2,66],[8,26],[-2,36],[7,64]],[[26809,58022],[13,27],[12,4],[12,73],[12,49]],[[26858,58175],[38,-157],[5,-144],[5,-24]],[[26853,57762],[-5,20],[-32,-34]],[[26816,57748],[-31,-34]],[[26785,57714],[-14,31],[21,91],[-1,65],[17,58],[1,63]],[[28350,58078],[11,-13],[16,59],[9,-32],[10,56],[10,21]],[[28406,58169],[64,-136],[18,-55]],[[28488,57978],[-19,-65],[-7,-51],[16,-43],[-1,-65],[-7,-16]],[[28470,57738],[-8,-3],[3,-47],[24,-55],[36,-43],[22,49]],[[28547,57639],[9,-29],[-12,-80],[-18,-27],[-35,-1],[-20,-24],[1,-18],[-35,3]],[[28437,57463],[9,29],[-17,-7],[1,217],[-3,65],[-18,-20],[-2,30],[-40,80],[-40,92]],[[22054,55308],[105,-4]],[[26881,59918],[8,37],[10,7],[-4,-62],[-14,18]],[[26976,62371],[4,207],[11,-2]],[[26991,62576],[86,-18],[57,-9]],[[27134,62549],[2,-99]],[[27136,62450],[-18,-16],[3,-43],[10,-29],[-4,-111],[-9,25],[-9,-20],[-3,-42],[-15,-17]],[[27091,62197],[-5,27],[8,28],[-12,79],[-11,1],[-13,40],[-20,-82]],[[27038,62290],[1,52],[-63,12],[0,17]],[[26906,62158],[0,10],[33,-10],[6,221]],[[26945,62379],[31,-8]],[[27038,62290],[-12,-70],[0,-67],[-21,-52],[10,-105],[3,-101],[-13,-32]],[[27005,61863],[-19,-10]],[[26986,61853],[-21,3],[2,105],[-33,8],[2,69],[-5,35],[-27,8],[2,77]],[[27377,61295],[48,-28],[50,139],[26,80]],[[27634,61249],[-14,-91],[-13,-39]],[[27607,61119],[-35,-116],[-21,-112],[2,-36],[-12,-39]],[[27541,60816],[-25,1],[-3,28],[-15,-39],[-16,9],[-44,47]],[[27438,60862],[-1,37],[-23,84],[-16,39]],[[27398,61022],[16,-5],[-17,98],[12,42],[-8,47],[-9,7],[8,37],[-18,-6],[-8,25],[3,28]],[[31846,38320],[0,-19]],[[31846,38301],[6,-44],[-16,-11],[-15,23],[-7,-20],[-12,49],[-24,-14],[7,54],[10,-23],[12,26],[19,-21],[20,0]],[[24548,58507],[121,-5],[29,4],[59,-9]],[[24757,58497],[0,-304]],[[24757,58193],[-60,4]],[[24547,58200],[1,307]],[[16069,60572],[0,-1]],[[16069,60571],[64,212],[27,63],[24,38],[8,-11],[9,22],[21,-26],[-1,396]],[[16221,61265],[14,-57],[62,-229]],[[16371,60748],[-166,-272],[5,-63],[-73,-246]],[[16137,60167],[-15,57],[-13,-20],[-8,21],[-10,-42],[-7,73],[-11,45],[-1,39],[15,32],[-5,56],[4,27],[-13,16],[-4,32],[0,69]],[[15716,62785],[168,2],[0,34],[35,-1],[0,-35],[33,0]],[[15952,62785],[-5,-93]],[[15947,62692],[-11,-74],[6,-48],[-5,-22],[16,-125],[11,-2],[7,-45],[1,-51],[-5,-74]],[[15967,62251],[-140,-1]],[[15827,62250],[-19,45],[-2,67],[-22,40],[-2,78],[7,61],[-11,41],[-16,-6],[-30,40],[-21,54],[-5,31],[10,84]],[[26431,56469],[5,-45],[16,-54],[13,-23],[23,-88],[14,-28]],[[26502,56231],[-9,-31],[-17,-130],[-19,36]],[[26457,56106],[-17,-18],[-10,20]],[[26430,56108],[-19,0]],[[26411,56108],[1,365],[19,-4]],[[26549,57359],[7,9],[1,57],[13,16]],[[26570,57441],[27,9]],[[26597,57450],[15,-43],[2,-36],[-11,-85],[6,-43],[0,-50],[7,-31],[-14,-58]],[[26602,57104],[-50,3]],[[26552,57107],[3,31],[-9,21],[-2,145],[5,55]],[[26101,56852],[21,-1],[15,98],[43,77],[20,176]],[[26200,57202],[11,0]],[[26211,57202],[1,-52],[-7,-1],[0,-91],[-6,-2],[7,-71],[22,-10]],[[26217,56630],[-59,5],[0,-25],[-45,2]],[[26113,56612],[-12,240]],[[17848,67225],[137,1]],[[17985,66821],[-7,0],[1,-234]],[[17979,66587],[-36,28],[-19,-11],[-10,58],[-3,48],[-21,14],[-1,53],[10,54],[-16,65],[-22,-4]],[[17861,66892],[-13,3],[0,330]],[[24924,66063],[81,3]],[[25132,65705],[-117,-5],[0,17],[-31,11],[-2,-11],[-42,-1]],[[24940,65716],[0,33],[-15,1]],[[24925,65750],[-1,313]],[[20593,72571],[0,91],[11,0],[0,231]],[[20604,72893],[6,17],[32,-4],[4,-29],[16,56],[11,-8],[6,49],[12,15],[16,-35],[18,8],[22,-27],[15,11],[4,34],[8,-40],[11,22],[9,-19],[14,11],[5,-28],[23,-31],[3,-26],[17,5],[12,-23],[22,5],[9,24],[11,-35],[-1,-30],[15,-4]],[[20924,72811],[0,-698]],[[20819,72064],[-25,0],[0,203],[-23,0],[0,101],[-107,0],[0,102],[-72,0],[1,101]],[[28264,59025],[15,-18],[4,-26],[25,-23],[3,-66],[16,-2],[20,-38]],[[28347,58852],[16,-116],[-2,-100]],[[28361,58636],[-11,16],[-10,-32],[-13,-5],[-12,-46],[-41,-101]],[[28274,58468],[-15,63],[-9,115],[-22,46]],[[28228,58692],[16,166],[18,123],[2,44]],[[21448,59429],[37,0]],[[21485,59429],[114,-1]],[[21448,58911],[0,518]],[[26065,55479],[100,1]],[[26165,55480],[13,-277]],[[26178,55203],[9,-32],[-4,-36],[13,-45],[-2,-25]],[[26194,55065],[-43,-7],[-3,-17],[-83,-3]],[[26065,55038],[0,441]],[[16505,62261],[89,-256]],[[16594,62005],[-8,-55],[-1,-72],[21,-122],[-5,-103],[-17,-20],[4,-32],[-9,-46]],[[16473,61679],[-14,16],[0,73]],[[15579,65835],[23,7],[28,-8],[115,2],[37,5],[59,-1]],[[15841,65840],[81,-5],[154,-8]],[[16076,65827],[-3,-55],[0,-202],[2,0],[0,-403],[1,-287]],[[15529,64876],[-8,55],[-10,162],[-8,19],[-44,-1]],[[15459,65111],[13,75],[-11,108],[-11,22],[3,40],[-10,3],[9,58],[7,95],[-5,23],[1,59],[-8,33],[15,42],[2,31],[11,-5],[11,25],[13,112]],[[19531,60575],[36,171],[210,4],[53,5]],[[19830,60755],[-14,-56],[-4,-79],[1,-69],[-13,-34],[-7,-58],[-26,-35],[-6,-73],[-8,-49],[-13,-39],[1,-83],[-5,-18],[-7,-88],[-13,-64]],[[19716,60010],[-185,-1]],[[26283,57668],[9,0]],[[26292,57668],[44,1]],[[26336,57514],[10,-35],[-14,-62],[-6,-50],[0,-170]],[[26326,57197],[-14,18],[-3,28],[-24,-17],[-29,9],[-2,21]],[[26254,57256],[-8,53],[15,-1],[-10,44],[17,-10],[3,48],[-3,76],[6,54],[7,19],[-7,48],[9,81]],[[18429,66212],[96,2],[0,101],[44,0],[0,101],[22,0]],[[18591,66416],[10,0],[11,-64],[13,7],[1,-78],[-10,-46],[1,-27],[14,-6],[4,37],[20,0],[9,-65],[9,-11]],[[18673,66163],[15,-55],[0,-80],[-11,1],[0,-201]],[[18677,65828],[-15,-1]],[[18662,65827],[-8,5],[-225,-3]],[[25398,61442],[52,-1],[0,-31],[31,-2],[0,-37]],[[25481,61371],[-2,-51],[-1,-265]],[[25478,61055],[-37,-24],[-11,52],[-15,-23]],[[25415,61060],[-4,-36],[10,-68],[-12,-47],[-23,32]],[[25386,60941],[-11,2],[-4,34],[12,-9],[-14,80]],[[25369,61048],[22,4],[-15,29],[15,67],[1,60],[-8,26],[19,19],[2,38],[-12,-19],[22,73],[-14,60],[-3,37]],[[25875,60701],[34,239]],[[25909,60940],[40,23],[9,67],[-6,144]],[[25952,61174],[15,10]],[[25967,61184],[2,-11]],[[25969,61173],[8,-8],[1,-57],[14,3],[11,-65],[-1,-36],[22,-55]],[[26024,60955],[3,-43],[13,-49]],[[26040,60863],[-15,-91],[-18,-36],[-6,-57],[-15,-35],[-5,-121]],[[25981,60523],[-43,11]],[[25938,60534],[-2,54],[-16,83],[-18,-15],[-15,24],[-4,31],[-8,-10]],[[23800,51922],[165,1],[0,-16],[37,0]],[[24002,51907],[72,-2]],[[24108,51380],[-35,42],[-57,101],[-23,32],[-41,40],[-33,5],[-14,-14],[-36,7],[-58,-25],[-17,-13],[-26,-53]],[[23768,51502],[-17,94],[-9,30],[2,25],[19,54]],[[23428,62034],[125,0]],[[23553,62034],[-1,-304]],[[23552,61730],[0,-103]],[[23552,61627],[-126,1]],[[17874,68100],[-13,10],[-8,-20],[-19,50],[-8,107],[-18,27],[9,-35],[-25,-155],[-22,-13],[-38,-40],[-10,-50],[-3,-63],[-12,6],[-12,-61],[3,-20],[-20,-74],[-21,-17],[-17,-53],[-12,-16],[-28,0]],[[17600,67683],[-18,44],[-67,208]],[[18812,67724],[63,-5]],[[18875,67719],[43,0],[10,-91],[18,3],[25,-31],[3,-22]],[[18974,67578],[0,-216]],[[18974,67362],[0,-345]],[[18974,67017],[-152,1]],[[18822,67018],[0,305],[-65,0],[0,98],[-62,1],[1,50],[-17,0],[0,18],[-116,0],[0,234]],[[30108,65942],[43,72],[3,79],[-4,25],[8,24],[-4,25],[-11,-5]],[[30143,66162],[20,28],[6,-38],[10,-12]],[[30179,66140],[-8,-30],[8,-46],[13,60]],[[30192,66124],[16,-51],[2,-46],[21,-93],[-1,-50],[-7,-39],[-12,-5],[3,-24],[21,-51],[12,8],[8,-24],[8,-83],[-4,-55]],[[30259,65611],[-7,-29],[-19,-27],[-3,-52]],[[30230,65503],[-21,20],[0,-59],[-7,14],[-4,-50],[-14,3],[2,-32],[-12,-1]],[[30174,65398],[-12,154],[-10,36],[-29,-15],[-3,44],[18,52],[-7,80],[-14,39],[-9,154]],[[24349,53048],[18,-1],[8,-28]],[[24375,53019],[-1,-27]],[[24374,52992],[5,-49],[-5,-83],[11,-20],[18,10],[-2,40],[-14,40],[18,-1],[8,-31],[1,-45],[-6,-70],[-15,-29],[11,-41],[29,6],[21,24],[12,-114]],[[24466,52629],[6,-10],[-15,-72],[-9,-23],[-5,-67],[-19,0],[-1,-16]],[[24423,52441],[-20,-17],[-7,17],[-33,0]],[[24363,52441],[-15,0]],[[24348,52441],[6,15],[-6,61],[6,121],[0,43],[-10,95],[-11,30],[-2,43]],[[24331,52849],[3,18],[0,127],[15,54]],[[25362,70396],[0,378]],[[25362,70774],[139,0],[0,-303]],[[25378,70232],[-13,12],[-9,32],[17,52],[-11,68]],[[23700,60417],[-1,-68],[9,-1]],[[23708,60348],[-2,-282]],[[23550,60077],[1,327]],[[21617,60463],[9,0]],[[21747,60462],[6,0]],[[21753,60462],[1,-454]],[[21754,60008],[-136,-3]],[[21618,60005],[-1,458]],[[24658,66423],[60,-2]],[[24718,66421],[139,-1]],[[24857,66420],[2,-360]],[[24859,66060],[-111,-4]],[[24748,66056],[-16,25],[-15,74],[3,60],[-15,60]],[[24705,66275],[-23,40],[-2,26],[-22,35],[0,47]],[[24713,64233],[0,102]],[[24841,64332],[-1,-101],[32,-1],[1,-130]],[[24858,64010],[-16,-50],[-16,-21],[-9,-95],[-13,-68],[-23,-59]],[[24781,63717],[-70,6],[1,101]],[[28182,67420],[55,-30],[23,-19],[15,-47],[23,-46],[12,-10],[9,18],[35,32]],[[28355,67035],[-31,0],[0,-106],[-27,1]],[[28297,66930],[-42,1],[0,50],[-50,0]],[[28205,66981],[2,57],[-13,3],[12,109],[-25,0]],[[24336,73051],[23,-4],[5,-67],[-4,-31],[20,-21],[23,13],[-3,-75],[22,28],[14,-22],[19,24],[34,17],[46,113],[15,9]],[[24552,72192],[-29,-76],[-17,-69],[-55,-178],[-26,-72],[-26,-41],[-26,-88],[-11,-11],[-25,-76]],[[16107,67713],[267,-6],[134,-1]],[[16508,67706],[0,-503],[-10,0],[0,-305],[-3,0],[-1,-198],[162,3],[0,-712],[1,-167]],[[16657,65824],[-147,4],[-31,-3]],[[16479,65825],[0,-1]],[[16479,65825],[-92,-2],[-153,1]],[[16234,65824],[-1,399],[1,170],[-1,304],[-130,3],[0,710],[5,0],[-1,303]],[[30076,65453],[18,-18],[3,-189]],[[30097,65246],[-20,-46],[-6,102],[2,64],[-10,22],[2,-159],[-17,2],[-2,-35],[-10,-7],[-1,55],[16,95],[8,68],[17,46]],[[30029,65436],[5,7],[11,-52],[-5,-7],[-11,52]],[[30019,65203],[6,51],[-4,23],[5,57],[4,-20],[0,-85],[-11,-26]],[[28985,67711],[-16,561]],[[28969,68272],[30,-54],[58,22]],[[29057,68240],[22,-679],[-26,-171],[43,-62]],[[29096,67328],[5,-130],[-9,-57],[-9,-7],[-4,-42],[4,-42]],[[29083,67050],[5,-59],[-6,-155]],[[29082,66836],[-32,40],[-8,-85],[-54,97],[-11,-56],[-20,-4],[0,27]],[[28957,66855],[3,1],[-5,200],[42,203],[-26,37],[4,54],[20,30],[-10,331]],[[20934,60006],[257,5]],[[21215,60011],[0,-463],[-1,-119]],[[21214,59429],[-11,0],[1,-213],[0,-305]],[[21204,58911],[0,-368]],[[21204,58543],[-93,0]],[[21111,58543],[0,302],[2,102],[-119,-1],[0,103],[-60,1],[0,50]],[[20934,59100],[0,906]],[[23449,51727],[150,6]],[[23599,51733],[24,-2],[1,-379]],[[23624,51352],[-5,-7]],[[23619,51345],[0,48],[-13,-9],[-1,-27],[-25,-27]],[[23580,51330],[-10,34],[-54,-54],[-8,26],[17,90],[4,80],[0,74],[-12,5],[-5,23],[-17,-29],[-10,-41],[-4,-50],[-15,-24],[-3,18]],[[23463,51482],[5,28],[-9,22],[9,58],[1,64],[-19,54],[-1,19]],[[16242,73980],[227,-1],[169,0],[165,1]],[[16803,73980],[0,-404],[-9,0],[0,-200],[7,0],[-1,-603],[-1,-7]],[[16799,72766],[-34,-17]],[[16762,72771],[9,66],[-14,28],[-8,82],[-7,28],[-27,10],[-29,-51],[-12,16],[-8,-22],[-4,-55],[-17,1],[-9,30],[-18,7],[-32,-96],[-10,0],[-12,37],[7,42],[-4,30],[-45,-19],[-14,-32],[7,-36],[0,-68]],[[16283,73434],[4,51],[-9,24],[-11,-15],[-8,49],[10,37]],[[16269,73580],[21,91],[-16,60],[0,90],[-9,14],[-7,97],[-12,-23],[-14,41],[10,30]],[[25861,56449],[13,57],[7,-28],[15,27],[9,-27],[0,-45],[7,-32],[8,5],[5,-49],[8,-22]],[[25933,56335],[6,-93],[-28,-62],[0,-35]],[[25911,56145],[-17,12],[9,-35],[-3,-77],[-10,-6],[8,-52],[-12,-57],[-13,19],[-8,-68],[-19,-72]],[[25846,55809],[0,130],[-29,0],[0,51],[-10,0]],[[25790,56245],[1,43],[47,39],[18,59],[5,63]],[[25309,66542],[33,1],[0,67],[106,-2]],[[25448,66608],[-4,-60],[6,-145]],[[25450,66403],[-111,5]],[[25339,66408],[-30,-1]],[[25309,66407],[0,135]],[[31371,38071],[7,-1]],[[31378,38070],[1,-78],[7,16],[18,-19]],[[31404,37989],[1,-46]],[[31398,37874],[-11,8],[-14,-17]],[[31373,37865],[3,32],[-10,159],[4,14]],[[25047,67743],[-98,0]],[[24949,67743],[0,395]],[[24648,70466],[105,-1]],[[24753,70465],[72,1]],[[24825,70466],[0,-99]],[[24825,70367],[0,-398]],[[24648,69763],[0,303]],[[31571,38386],[-11,-53]],[[31546,38362],[-3,30],[-10,5],[-7,29]],[[31526,38426],[24,-8],[21,-32]],[[17697,72209],[-3,-22],[-22,-8],[-12,-36],[11,2],[47,-87],[7,-54],[32,-45],[24,-10],[9,-41],[-2,-38],[11,-7],[5,-37],[12,-13],[17,-54],[19,-82],[6,-60],[13,1],[11,-45]],[[17882,71573],[-241,1],[-140,1]],[[17501,71575],[0,102]],[[17501,72133],[0,555]],[[17501,72688],[0,148],[16,51],[11,8],[20,-55],[12,14],[20,-65]],[[27119,58976],[37,13],[36,-6]],[[27192,58983],[11,-24],[14,-6],[4,-23],[13,-6],[15,-50],[4,-32]],[[27251,58609],[-8,-33]],[[27243,58576],[-10,-11],[-12,30],[-31,-8],[-13,56],[-30,58],[-19,84],[-8,17]],[[27120,58802],[20,123],[-21,51]],[[21701,71959],[17,-18],[3,35],[35,16],[23,-50],[-5,-53],[8,-56]],[[21782,71833],[6,-20],[5,-72],[12,-35],[1,-29],[-16,-46]],[[21790,71631],[-231,-2]],[[21559,71629],[0,303],[141,0],[1,27]],[[23163,63807],[127,1]],[[23290,63808],[19,-17],[2,-77],[24,-76],[-8,-79],[31,-56]],[[23358,63503],[-9,0]],[[23349,63503],[-125,0]],[[23224,63503],[-62,0]],[[21840,63909],[156,1]],[[21996,63910],[1,-406]],[[21845,63505],[-5,0]],[[23518,52432],[55,2],[-2,41]],[[23571,52475],[132,-1]],[[23703,52474],[-14,-116],[10,-98],[-10,-69],[7,-29],[-6,-19]],[[23690,52049],[-17,32],[-16,-26],[-11,5],[-5,-61],[-30,-24],[-12,19]],[[23599,51994],[-43,-2],[-38,440]],[[25398,57689],[106,-2]],[[25504,57687],[106,-5]],[[25614,57681],[-1,-213],[-18,-49],[5,-18]],[[25600,57401],[-10,-9],[-13,53],[-23,5]],[[25554,57450],[-27,37],[-17,-15],[-8,-24],[-26,-30],[-7,-32],[-21,-16],[-8,11],[-24,74],[-8,73],[-25,46],[-16,-17]],[[25367,57557],[-16,35],[-13,85]],[[25338,57677],[0,15],[60,-3]],[[23701,59427],[59,0]],[[23760,59427],[1,-186],[13,-38]],[[23774,59203],[-15,1],[0,-84],[-5,0]],[[23569,58965],[-3,70]],[[23566,59035],[-16,393]],[[24875,65347],[65,1]],[[24940,65348],[129,0]],[[24938,64840],[0,99],[-61,1]],[[26105,64263],[1,-100]],[[26106,64163],[0,-219]],[[26106,63944],[-37,0]],[[26069,63944],[-79,-1]],[[25990,63943],[0,33]],[[25990,63976],[-1,185]],[[26137,68351],[-1,303],[1,101]],[[26143,67133],[0,204],[-70,0]],[[24210,60561],[-1,-254],[1,-227]],[[24272,60712],[61,-4]],[[24376,60067],[-121,9]],[[24688,60760],[108,-3]],[[24796,60757],[0,-51]],[[24796,60706],[2,-66],[-2,-266],[-20,3]],[[24776,60377],[-92,3]],[[24632,53839],[99,2],[34,4],[4,16]],[[24769,53861],[0,-427]],[[24769,53434],[-5,0]],[[24661,53433],[0,305],[-29,-1]],[[24632,53737],[0,102]],[[20688,56922],[0,300],[125,0],[0,101],[29,1],[0,101],[59,0]],[[20901,57425],[0,-202],[50,0]],[[20951,57223],[0,-403],[1,-206]],[[20952,56614],[-59,1],[0,-102],[-45,0],[-130,5],[-1,102],[-29,1]],[[20688,56621],[0,301]],[[28264,58442],[10,26]],[[28361,58636],[27,-38],[-1,-25],[11,-6],[12,-32]],[[28410,58535],[-6,-38],[8,-18],[-1,-53],[24,-100],[-12,1],[-13,-40],[0,-73],[-4,-45]],[[28326,58179],[-10,83],[3,23],[-16,18],[-14,40],[-25,99]],[[21467,71629],[92,0]],[[21790,71631],[8,-40],[1,-60],[24,-103],[-5,-69],[16,-15],[0,-58],[8,7],[6,-43],[24,27],[-5,-51]],[[21867,71226],[26,-48],[-6,-23],[12,-47],[-9,-32],[-6,-64],[3,-27]],[[21887,70985],[-27,-21],[-10,-35],[-13,21],[-13,-15],[-29,12],[-6,-53],[-24,-76]],[[21765,70818],[-6,0],[0,101],[-70,0],[0,302],[-117,1],[0,101],[-105,-1]],[[21467,71322],[0,307]],[[26831,65004],[139,-7]],[[26970,64997],[2,-254]],[[26972,64743],[-28,0],[1,-85]],[[26945,64658],[-81,4]],[[26835,64663],[-3,301]],[[23156,58680],[60,-1]],[[23231,58679],[-1,-152],[15,0],[0,-202]],[[23245,58325],[-30,0],[0,-103],[-15,0],[0,-101],[-29,0]],[[23171,58121],[-30,0],[0,204],[-29,0],[0,101]],[[27603,56618],[75,197],[14,-5],[6,52],[13,-12],[7,24]],[[27718,56874],[7,-9]],[[27725,56865],[9,-9],[15,-69]],[[27749,56787],[-7,-53],[16,-103],[0,-120],[6,-51],[35,-125],[15,-19],[-3,-32]],[[27811,56284],[-7,19],[-25,-36],[-16,-10],[-50,46],[-13,-1],[-5,24],[-16,1],[-10,55],[-11,3]],[[27658,56385],[-20,1],[-8,70]],[[27630,56456],[23,48],[-3,17],[-27,53]],[[27623,56574],[-7,30],[-13,14]],[[27102,56676],[3,51],[21,-15],[15,25],[26,-49],[27,-75],[19,-6]],[[27213,56607],[-28,-232]],[[27185,56375],[-22,-73]],[[27163,56302],[-51,60],[-10,31],[-7,97],[-31,-16]],[[27064,56474],[5,42],[12,48],[5,45],[16,67]],[[25769,60991],[16,29],[2,63],[23,9],[-5,38],[0,77],[10,21]],[[25815,61228],[17,-53],[52,-144],[25,-91]],[[25875,60701],[-22,-7],[2,-29],[-18,5],[-28,66],[-7,-39],[-11,11],[-5,-41]],[[25786,60667],[-13,64],[0,50]],[[25773,60781],[5,-8],[-15,160],[6,58]],[[25415,61060],[31,-162],[16,-39],[1,-69],[5,-36]],[[25468,60754],[-19,-69],[-36,-116]],[[25413,60569],[-18,31],[-5,47],[-13,-48]],[[25377,60599],[-3,27],[-17,53]],[[25357,60679],[-7,105],[11,56],[17,35],[8,66]],[[26212,59846],[29,67],[4,51],[11,-17],[20,61]],[[26276,60008],[18,-47],[18,27],[9,-7],[15,-91],[12,-34]],[[26348,59856],[-1,-74],[-12,-11],[-3,-29],[-11,-9],[0,-26],[-29,-158]],[[26290,59549],[-53,14]],[[26237,59563],[-7,10],[0,61],[-6,48],[5,45],[-6,59],[-11,60]],[[26151,61591],[80,-26]],[[26223,61325],[-6,-66],[-15,-41]],[[26202,61218],[-37,61],[-53,67]],[[26112,61346],[5,136],[-17,25]],[[26100,61507],[22,26],[18,2],[11,56]],[[28437,57463],[-24,-31]],[[28271,57652],[-16,40]],[[26346,58432],[15,31],[5,53],[5,0],[22,70],[7,-9],[3,57],[9,17],[5,71],[13,-21],[5,25]],[[26435,58726],[27,-106]],[[26462,58620],[-3,-43],[7,-13],[-5,-52],[11,-61],[-16,-58]],[[26456,58393],[-18,12],[-10,40],[-19,12],[-11,-29],[-7,36],[-28,-23],[-1,-32]],[[26362,58409],[-16,23]],[[22754,54392],[0,10],[109,97]],[[22863,54499],[40,-248],[13,25]],[[22916,54276],[49,-301]],[[22906,53851],[-30,180],[-66,-137]],[[22810,53894],[-14,50],[12,40],[0,24],[-12,-2],[-16,34],[6,23],[-22,45],[17,50],[-13,65],[-17,-12],[-1,49],[6,31],[-7,48],[10,50],[-5,3]],[[28276,60667],[11,16],[-10,73],[6,76]],[[28283,60832],[20,-28],[18,23],[13,-20],[12,-92],[46,-78]],[[28392,60637],[17,-55]],[[28409,60582],[-12,-98],[-8,-29]],[[28389,60455],[-8,-35],[-9,25],[-21,16],[-9,70]],[[28342,60531],[1,81],[6,-14],[0,53],[-12,56],[-10,-23],[-19,3],[3,-26],[-18,-4]],[[28293,60657],[-17,10]],[[27256,64261],[21,-1],[1,85],[42,5]],[[27320,64350],[48,-1],[-1,-97],[16,-1],[0,-51]],[[27383,64200],[-1,-51],[-15,1],[-2,-103],[-4,-50]],[[27269,64007],[2,153],[-16,2],[1,99]],[[22628,73447],[214,0]],[[22842,73447],[6,-54],[1,-107],[-3,-52],[8,-93],[-7,-53],[0,-47]],[[22847,73041],[-212,1]],[[22527,73042],[0,203],[-8,1],[1,202]],[[24997,69867],[17,3],[89,-6]],[[25103,69864],[34,0],[-1,-100],[69,0]],[[25205,69764],[0,-202],[11,-1],[0,-101]],[[25121,69357],[-68,0]],[[24373,69565],[34,-2],[1,100]],[[24408,69663],[171,0]],[[24580,69157],[-203,-2]],[[24377,69155],[0,309],[-4,0],[0,101]],[[24319,51555],[41,128],[24,115],[43,13]],[[24427,51811],[16,-60],[11,-82],[-3,-59],[9,-20],[38,-18],[10,-26],[13,-5],[10,-29]],[[24531,51512],[-2,-66],[6,-19]],[[24535,51427],[-22,-39],[-4,20],[-9,-22],[-8,-50],[-9,-13],[-1,-67],[10,-48]],[[24492,51208],[-14,-41],[-13,-13],[2,41],[-10,-7],[3,39],[9,28],[-10,40],[-29,-50],[-10,80],[-10,-8],[-6,118],[-26,1],[6,33],[1,85],[-32,16],[-13,-10],[-20,-38],[-1,33]],[[31195,38089],[5,-17]],[[31200,38072],[17,-55]],[[31217,38017],[-2,-58]],[[31215,37959],[1,-95],[-2,-34]],[[31214,37830],[-16,20],[-12,-12],[1,53],[10,31],[-11,12],[3,65],[5,15],[1,75]],[[15542,70657],[23,-1],[19,32]],[[15584,70688],[13,19],[14,-4],[59,-119],[7,-61],[18,-81],[1,-57],[7,-72]],[[15703,70313],[-3,-47],[7,-34],[2,-61]],[[15709,70171],[-6,-9],[-40,1]],[[15663,70163],[-29,35],[0,32],[-92,0]],[[15542,70230],[1,101],[-2,202],[1,124]],[[16508,67706],[-1,102]],[[16507,67808],[34,-1],[0,304],[33,0]],[[16973,68205],[0,-282],[-2,-31],[0,-461],[1,-30],[0,-506],[4,1],[0,-744],[6,0],[-1,-325]],[[16981,65827],[-139,-6],[-175,3]],[[16667,65824],[-10,0]],[[22594,52589],[25,188],[37,140]],[[22799,52738],[12,-20],[33,-324]],[[22844,52394],[-50,-63]],[[22794,52331],[-10,19]],[[22784,52350],[-21,49],[-19,28],[-10,-12],[-13,31],[-50,-83],[-21,49],[-5,86],[-13,40],[-1,28],[-11,27],[-9,-21],[-5,20],[-12,-3]],[[19265,64664],[129,1],[136,2]],[[19530,64667],[0,-393]],[[19530,64274],[-21,0],[-10,25],[-1,119],[-11,-1],[0,85],[-53,0],[0,-79],[-25,-58],[-8,12],[-4,88],[-13,-16],[-17,3],[-12,-24],[-21,9],[-4,-23],[-29,-22],[-30,53]],[[19271,64445],[-6,5]],[[21829,50979],[14,16],[0,85],[10,11],[3,96],[0,237]],[[21856,51424],[164,-1]],[[22020,50798],[-155,-2]],[[21865,50796],[-7,36],[-23,68],[3,14],[-9,65]],[[18869,65087],[10,15],[15,-19],[19,-71],[-5,-83],[16,-12],[-5,-59],[-7,-24]],[[18808,64433],[-7,59],[-21,13]],[[18780,64505],[-8,13],[-13,102],[11,-1],[-17,74],[-4,51],[-1,85]],[[18748,64829],[-6,35],[5,33],[16,23],[15,-4],[8,-31],[17,-2],[13,28],[4,33],[28,-13],[16,73],[-3,30],[8,53]],[[28480,59670],[-1,-8]],[[28479,59662],[0,-1]],[[28479,59661],[1,0]],[[28480,59661],[0,0]],[[28480,59661],[1,0]],[[28481,59661],[0,0]],[[28481,59661],[1,0]],[[28482,59661],[0,1]],[[28482,59662],[0,-7]],[[28482,59655],[0,0]],[[28482,59655],[-2,-14]],[[28480,59641],[0,1]],[[28480,59642],[4,-41]],[[28484,59601],[-15,22],[-1,41],[12,6]],[[20674,63166],[0,0]],[[20643,63062],[0,9]],[[20643,63071],[0,3]],[[20643,63074],[5,25],[17,17],[25,-51],[10,38],[-15,13],[0,29],[10,4],[-5,51]],[[20690,63200],[115,-2],[213,2]],[[21018,62998],[-2,0]],[[20752,62997],[-108,1]],[[20644,62998],[-1,64]],[[26081,57244],[12,54],[0,34],[12,70],[0,84],[8,80],[16,97]],[[26129,57663],[27,2]],[[26156,57665],[0,-152],[18,0],[0,-93],[16,-8]],[[26190,57412],[-7,-55],[33,-1],[0,-113]],[[26216,57243],[-5,-41]],[[26200,57202],[-117,2]],[[26083,57204],[-2,40]],[[25556,63447],[91,1]],[[25647,63448],[0,-100],[23,-1]],[[25670,63347],[-1,-304]],[[25669,63043],[-52,2]],[[25617,63045],[-51,1]],[[25566,63046],[-3,53],[4,48],[1,114],[-3,48],[9,33],[-4,33],[-18,48],[4,24]],[[25983,62029],[13,8],[12,77]],[[26040,62124],[0,-92],[10,-33],[10,-1],[1,-33],[10,-1],[0,-84]],[[26071,61880],[-62,-1],[-15,-51]],[[25994,61828],[-11,16],[0,185]],[[25920,60082],[-15,-148]],[[25905,59934],[-11,-31],[-17,-18],[1,-22],[-40,-113]],[[25838,59750],[2,36],[-51,27],[-8,61]],[[25781,59874],[-17,136]],[[25764,60010],[16,171],[-2,40],[35,11],[8,-44],[19,20]],[[23830,54467],[40,-1]],[[23870,54466],[12,-1]],[[23949,54363],[10,-51],[-4,-13],[8,-43],[-6,-55],[10,-43],[-32,0],[-2,-72],[-10,-27],[-19,13],[-2,39]],[[23902,54111],[-14,65],[-10,2],[-11,49],[0,30],[-17,56],[9,31],[-4,58],[-19,27],[-6,38]],[[23505,68690],[24,-33],[8,-39],[40,-34],[17,-38],[14,-69],[11,-10]],[[23619,68467],[1,-182]],[[24378,61993],[4,414]],[[24382,62407],[1,104],[61,-7]],[[24444,62504],[42,-3]],[[24486,62501],[-1,-171]],[[24442,62001],[-19,4],[-17,-43],[-26,32]],[[24380,61994],[-2,-1]],[[24757,58842],[91,3]],[[24911,58847],[4,-38],[18,-49],[3,-25]],[[24936,58735],[-3,-20],[-24,23],[-9,-49],[20,-36],[-11,-33],[-11,-1],[-9,-52],[-17,-22],[-9,21],[-15,-41],[6,-68],[9,-17],[12,23],[3,-38],[-26,-42],[-3,-24],[13,-50]],[[24862,58309],[-3,-29],[-22,56],[-9,-9],[-5,-58],[9,-42],[-9,-70]],[[24823,58157],[-2,-5]],[[24821,58152],[-8,88],[-15,-50]],[[24798,58190],[-41,3]],[[24757,58497],[0,345]],[[24238,59427],[8,0]],[[24246,59427],[125,1]],[[24371,59428],[62,-2]],[[24433,59426],[-1,-189],[-31,2],[0,-102],[-35,4]],[[24236,59150],[2,277]],[[25935,57072],[15,5],[61,168],[26,140],[9,12],[9,90],[13,33]],[[26068,57520],[13,-276]],[[26083,57204],[4,-76]],[[26087,57128],[-18,-47],[0,-51],[-16,-85],[-11,-27],[-37,-121],[-10,6],[0,-52]],[[25995,56751],[-73,1]],[[25922,56752],[-1,264],[14,56]],[[23598,57605],[11,19],[31,3],[18,19],[1,102],[-6,11],[30,39]],[[23683,57798],[0,-51],[19,-2],[0,-32],[103,-8]],[[23805,57705],[-2,-319]],[[23742,57293],[0,17],[-24,14],[-84,6],[0,34],[-38,3]],[[23596,57367],[2,238]],[[15459,65111],[-31,-1],[0,97],[-82,1]],[[15346,65208],[-4,96],[-15,128],[-8,96],[-9,-4],[-17,54],[10,74],[5,110],[-3,67]],[[24857,66420],[25,-1]],[[24882,66419],[122,-6]],[[24924,66063],[-65,-3]],[[25762,61634],[103,-1],[0,34]],[[25865,61667],[15,0]],[[25880,61667],[3,-86],[-10,2],[8,-69],[-6,-14],[-4,-90],[-12,-25]],[[25859,61385],[-12,15],[1,-34],[13,-12],[-1,-25],[-13,-2],[-8,-29],[-16,18]],[[25823,61316],[0,99],[-31,1],[1,69],[-31,-4]],[[25762,61481],[0,153]],[[25942,61661],[11,0]],[[25953,61661],[8,-17],[44,1],[13,-63],[-10,-20],[2,-52]],[[26010,61510],[-11,-13],[-6,-63],[-14,-50]],[[25979,61384],[-16,7],[1,87],[-10,17],[-12,64],[0,102]],[[27144,54294],[7,-1],[15,-45],[13,-67],[0,-24],[20,-15],[13,18],[3,-28],[17,-15],[7,-103],[9,-29],[4,19],[6,-58],[9,5],[5,-48],[17,-32]],[[27289,53871],[4,-28],[15,-7],[-1,-84],[-11,-79],[-6,14]],[[27290,53687],[0,47],[-18,49],[-29,5],[-19,-16],[-17,68]],[[27207,53840],[-41,77],[-1,24],[-12,27],[-22,76],[6,72],[-1,38],[-13,10],[-8,43]],[[27115,54207],[17,39]],[[18169,66721],[0,-267]],[[18150,66443],[-11,3],[-25,-39],[-14,43],[-18,32],[-24,15],[-12,30],[-25,2],[-21,39],[-21,19]],[[28776,61584],[0,37],[11,117],[18,34],[16,55]],[[28821,61827],[2,-117],[98,-9]],[[28921,61701],[7,-56],[-4,-27],[7,-31],[-19,-75],[-67,-13]],[[28845,61499],[-14,23],[-16,-37],[-8,21]],[[28807,61506],[0,-1]],[[28807,61505],[0,0]],[[28807,61506],[-32,-54]],[[28775,61452],[-10,-7],[-1,76],[12,63]],[[25269,71580],[-10,-125],[6,-52],[-9,-35],[11,3],[20,87],[3,44],[7,-13],[29,80],[28,43],[-12,-55],[-12,-24],[-15,-77],[30,84],[26,18],[11,-9]],[[25382,71549],[0,-171],[15,0],[0,-100],[-35,-1],[0,-301]],[[25362,70976],[-157,0]],[[25205,70976],[0,503],[35,0],[0,101],[29,0]],[[17872,61963],[265,0]],[[18137,61963],[-1,-122]],[[18136,61841],[1,-493]],[[18137,61348],[-1,-174],[1,-272],[-1,-188]],[[18136,60714],[0,-703]],[[18136,59828],[-198,1],[0,11],[-273,-1],[0,-13],[-43,1]],[[17622,59827],[1,22],[0,1384],[249,1],[0,729]],[[28999,63001],[21,-63]],[[29020,62938],[36,-106],[-1,-116]],[[29055,62716],[-6,-18],[-4,-86],[-7,-12],[2,-55]],[[29040,62545],[-31,19],[-6,25],[-18,-3],[-7,-36],[-9,24],[-2,47],[-18,37],[-3,30],[-10,-12],[-15,68],[-7,-8],[-11,47]],[[28903,62783],[-2,83],[13,4],[36,119],[43,-118],[2,101],[4,29]],[[26192,62257],[1,21]],[[26193,62278],[10,-15],[11,16],[17,56],[12,-2],[21,41]],[[26264,62374],[13,-80],[-11,-38],[0,-33]],[[26266,62223],[-75,3],[1,31]],[[29282,64306],[6,22],[4,65],[7,40]],[[29299,64433],[14,96]],[[29313,64529],[8,-10],[-8,-44],[6,-46]],[[29319,64429],[-14,-69]],[[29305,64360],[-3,-32],[-13,-33]],[[29289,64295],[-7,11]],[[29092,69317],[2,-49],[22,0],[5,-160],[27,-750],[-5,-2],[3,-82]],[[29146,68274],[-89,-34]],[[28969,68272],[-77,140]],[[28892,68412],[-116,216]],[[28776,68628],[11,34],[4,46],[12,51],[41,121],[31,100],[56,141],[-1,12],[68,109],[26,62],[18,0],[22,37],[28,-24]],[[24489,54039],[66,-10],[47,-41],[-3,-48],[33,1]],[[24632,53941],[0,-102]],[[24632,53737],[-116,-1]],[[24516,53736],[0,24],[-23,-2],[-18,51],[2,22],[-7,63]],[[24470,53894],[16,18],[-29,11],[7,94],[12,11],[2,-43],[7,-17],[5,28],[-7,30],[6,13]],[[23168,56701],[59,0]],[[23400,56701],[1,-256]],[[23401,56445],[-21,28],[-7,-68],[-15,-26]],[[23358,56379],[-9,-13],[-34,4],[0,15],[-21,-7],[-7,61],[-10,3],[-24,-52],[-20,3],[-1,-23]],[[23232,56370],[-22,2],[-11,48],[-16,30],[0,214],[-15,37]],[[24457,63222],[125,-2],[0,102]],[[24582,63322],[6,-5],[90,-1]],[[24678,63316],[-8,-58]],[[24675,62946],[-8,-75],[-1,-72]],[[24666,62799],[-90,5]],[[24576,62804],[-19,32],[-16,54],[-11,76],[-13,8],[-8,61]],[[24509,63035],[-13,22],[-23,79]],[[24455,64753],[118,-2]],[[24573,64751],[0,-3]],[[24573,64748],[1,-67],[-6,-106],[-11,-19],[-14,-66],[-10,-27],[-6,-150]],[[24527,64313],[-47,66],[-3,23],[-33,47]],[[20434,73471],[231,0]],[[20665,73471],[60,0],[0,-101],[37,0],[0,-102],[161,0]],[[20923,73268],[1,-17],[0,-440]],[[20604,72893],[-10,26],[-25,-12],[-3,16],[-34,-4],[-14,10],[-8,-35],[-10,18],[-23,-7],[2,-30],[-15,2],[-15,-32],[-26,-18]],[[20423,72827],[0,243],[11,0],[0,401]],[[26789,57076],[39,151]],[[26828,57227],[2,12]],[[26830,57239],[2,5]],[[26832,57244],[14,57],[84,171]],[[26978,57082],[-21,-60],[-98,-261]],[[26859,56761],[0,51],[-9,42]],[[26850,56854],[-5,60],[-12,30],[-3,64],[-8,64],[-8,12],[-25,-8]],[[20921,67988],[381,3],[-2,-67],[-12,-33],[-20,-96]],[[21268,67795],[-6,-35],[-20,20],[-8,-65],[-19,-15],[0,-150]],[[20921,67551],[0,30]],[[20921,67581],[0,407]],[[24816,58129],[5,23]],[[24823,58157],[2,-13],[74,-10],[0,20],[21,4],[0,-23],[19,-15]],[[24939,58120],[-3,-443]],[[24936,57677],[-22,0]],[[24914,57677],[-163,0]],[[24751,57677],[3,49],[25,-13],[9,100],[9,26],[12,-21],[10,25],[-15,58],[12,43],[-6,29],[-15,7],[-4,47],[16,10],[0,45],[9,47]],[[28963,64191],[12,43],[11,13],[25,64],[14,19],[22,90]],[[29047,64420],[18,-53],[28,-27]],[[29093,64340],[-1,-101],[7,-13],[-3,-44],[-17,-93],[-7,14],[14,-107]],[[29086,63996],[-17,-8],[2,-37],[-19,-9],[4,-36],[-24,-6]],[[29032,63900],[-7,68],[-25,19],[-4,45],[2,95],[-10,37],[-17,-5],[-8,32]],[[27612,59771],[6,-15],[5,57],[55,-45],[12,-4],[5,22],[20,24],[8,33]],[[27723,59843],[-20,-366]],[[27608,59478],[-1,133],[-10,79],[0,64],[15,17]],[[28627,60135],[26,-4],[4,16]],[[28657,60147],[5,-38],[-9,-97],[-4,15],[-20,-29]],[[28629,59998],[-17,56],[4,67]],[[19756,73979],[222,-1],[73,1]],[[20051,73979],[0,-101],[-8,0],[0,-401],[4,-69],[-16,9],[-2,-42],[-12,0],[0,-101],[11,0],[0,-104],[-30,0],[0,-101],[-10,0],[0,-405],[-3,0],[0,-208]],[[19735,72330],[-6,-18],[-15,28],[-11,-4],[-4,31],[-19,-16],[-4,23],[-13,-13],[-11,17],[-17,-6],[-16,36],[-12,-5],[-3,42],[-11,33],[-19,28]],[[19574,72506],[1,219],[73,-3],[5,83],[10,-12],[38,-5],[0,283],[7,0],[0,266],[18,-30],[0,170],[7,0],[0,202],[17,0],[0,200],[6,0],[0,100]],[[26833,53976],[33,81],[10,41],[10,-2]],[[26886,54096],[28,46]],[[26914,54142],[15,-12],[2,24]],[[26931,54154],[15,-3]],[[26946,54151],[0,-149],[-25,0],[0,-149]],[[26921,53853],[0,-44],[-30,0]],[[18973,66429],[1,243],[0,345]],[[18974,67362],[64,-2],[0,-91],[66,0]],[[19104,67269],[0,-127],[-3,0],[0,-404],[-10,0],[0,-81],[9,0],[0,-304],[14,0],[0,-199],[93,-1],[43,-7]],[[19250,66146],[0,-280],[2,-27],[0,-499]],[[19252,65340],[-149,1],[-129,1]],[[18974,65342],[-1,491]],[[18973,65833],[0,596]],[[25346,55349],[7,50],[29,-7],[5,36],[16,17],[10,41],[26,47]],[[25439,55533],[2,-159],[34,1],[-2,-13]],[[25473,55362],[-6,-81],[-10,-11],[4,-24],[-12,-11],[-8,-66],[3,-54],[-14,-37],[18,-12],[-7,-46],[10,3],[2,-71],[13,-3],[-3,-21],[-17,0],[4,-27],[14,2],[4,-28],[-15,-7],[-7,-67]],[[25446,54801],[-11,9]],[[25435,54810],[-12,70],[10,-2],[1,35],[-13,-7],[-7,20],[-13,-25],[-22,-21],[-7,31],[6,28],[1,62],[-7,-15],[-10,20],[8,10],[-6,72],[9,4],[1,35],[-9,-7],[-8,40],[-12,-5],[6,28],[-7,22],[-8,62],[9,8],[1,74]],[[23741,56926],[-1,-102],[4,0],[-1,-88],[30,-4],[-1,-203]],[[23772,56529],[-2,-304],[-36,3]],[[23734,56228],[-3,65],[-23,93],[-5,61],[4,34],[-9,77],[2,107],[-7,76],[-38,1]],[[23655,56742],[0,90],[-4,0],[1,100],[89,-6]],[[27721,61863],[31,-47],[17,-109],[46,-53]],[[27815,61654],[-4,-36],[-23,-120],[0,-41],[-8,-31],[-12,0],[-9,-41]],[[27759,61385],[-14,21],[-40,26],[-25,53]],[[28363,60929],[27,101],[2,39],[16,-21]],[[28408,61048],[9,-11],[13,-112],[8,-14],[12,-61],[32,-32],[3,-45],[7,2],[29,-119],[-4,-43]],[[28517,60613],[-7,38],[-17,-22],[7,48],[-25,-15],[-7,31],[-4,-24],[-30,61],[-10,10]],[[28424,60740],[4,41],[-21,-5],[1,30],[-16,3],[3,32],[-18,1],[0,30],[-14,57]],[[24563,71635],[15,17],[-1,-44],[-14,27]],[[24405,71367],[11,2],[48,70],[25,27],[6,26],[17,-22],[7,33],[25,10],[22,70],[14,-12],[14,35],[10,-4],[24,-81],[-14,-76],[-24,-78],[9,-73],[-16,-35],[-11,-77],[7,-14]],[[24579,71168],[0,-501]],[[24405,70670],[0,697]],[[24487,67840],[96,-1]],[[24583,67839],[133,1],[34,6]],[[24750,67846],[0,-105]],[[24750,67741],[0,-101]],[[24651,67487],[-150,0]],[[24501,67487],[-8,38],[5,52]],[[24498,67577],[-8,53],[4,44],[-10,37],[-2,71],[5,58]],[[22655,65733],[0,-202]],[[22655,65531],[1,-252]],[[23358,63503],[16,-60],[13,-11],[1,-43],[13,6],[5,-36],[26,-14],[14,39]],[[23446,63384],[18,-11],[-4,-28],[18,-51]],[[23478,63294],[-1,-27],[-12,-9],[3,-36],[12,16],[-1,-49],[-10,-6],[-13,24],[-5,-75],[-15,-19],[-7,-58]],[[23429,63055],[-12,6],[-5,37],[-63,1]],[[23349,63099],[0,404]],[[16714,61657],[69,0],[0,408],[2,101],[-32,-1],[0,108],[24,150],[49,2]],[[16826,62425],[248,-1]],[[17074,62424],[-93,-86],[0,-94],[141,-518]],[[16917,61054],[-120,359],[-63,182],[-20,62]],[[25400,59258],[24,-22],[20,-7],[18,17],[11,29],[35,-1]],[[25508,59274],[1,-30],[21,-8]],[[25530,59236],[-3,-100],[-12,-83]],[[25515,59053],[-5,24],[-22,4],[-26,47],[-22,-11],[-32,12]],[[22943,49851],[3,-26],[-6,-38]],[[22986,50363],[16,15],[2,-22],[42,-3],[8,31],[-1,-65],[22,1]],[[23075,50320],[0,-38],[-15,-294]],[[23060,49988],[-18,-84],[-53,-111],[-24,-68],[-37,-121]],[[22936,49696],[1,34],[8,24],[16,2],[35,105],[23,49],[24,23],[-4,43],[9,29],[-9,16],[-16,-41],[-20,-35],[-11,-40],[-17,-5],[-6,40],[0,60],[-17,12]],[[22952,50012],[-7,42],[-6,-19],[-10,53],[-12,36]],[[22917,50124],[-3,70],[-8,23],[22,56],[36,41],[22,49]],[[26087,57128],[14,-276]],[[26113,56612],[6,-136]],[[26119,56476],[-27,-8],[-10,-18]],[[26082,56450],[1,17],[-59,15]],[[26024,56482],[1,24],[-17,129],[2,29],[-14,-17],[-1,104]],[[19883,71064],[12,-16]],[[19895,71048],[12,-84],[11,-17],[0,-34],[12,-17],[0,-50],[12,-17],[0,-34],[11,-17],[6,-67],[12,-17],[-2,-82],[-11,-74]],[[19958,70538],[-45,0],[0,-68],[-35,0],[0,-33],[-11,0],[0,-34],[-12,0],[0,-33],[-46,0],[0,-135],[-6,0],[0,-308],[-35,0],[0,-34],[-34,0],[0,-34],[-92,4]],[[19642,69863],[-14,0],[-1,68],[-17,1],[0,33],[-11,0],[5,101],[-17,-32]],[[19587,70034],[-11,84],[-6,0],[1,322],[-6,0],[0,201]],[[22528,64721],[1,-207]],[[22529,64514],[0,-199]],[[21996,66816],[18,-45],[21,-26],[14,4],[11,-19],[29,-4],[2,-19],[40,-30],[10,5]],[[22141,66682],[0,-346],[4,1],[0,-406]],[[22145,65931],[-7,0]],[[22004,65931],[0,404],[-4,0],[0,405],[-4,0],[0,76]],[[20082,57632],[12,-101],[84,0],[10,42],[72,-3],[5,-39]],[[20263,57030],[-11,-3],[-13,23],[-74,87],[-32,56],[-89,-1]],[[20044,57192],[0,441],[38,-1]],[[20456,58696],[105,0],[66,-73],[24,-63],[5,20],[71,14],[106,-5]],[[20833,58589],[97,3],[13,24],[71,-442],[24,0],[0,-38]],[[21038,58136],[0,-173],[-62,1],[0,26],[-74,-142]],[[20902,57848],[0,85],[-214,1],[-111,0],[0,-203]],[[20459,57731],[-1,305],[0,408],[-2,252]],[[27497,59127],[0,24]],[[27611,58859],[-30,19],[-17,0],[-1,-35],[-32,-1],[-18,-27]],[[27513,58815],[-6,49],[-13,55],[-9,-18]],[[28162,58364],[2,14],[17,-14],[49,0]],[[28230,58364],[-1,-188],[6,-23],[-1,-41]],[[28226,57889],[-16,-36],[-10,31],[-12,-8],[-3,20],[-17,10],[-9,-20],[-24,17]],[[28135,57903],[0,17],[-23,25],[-17,72]],[[28095,58017],[5,32],[13,6],[7,25],[18,11],[-1,78],[25,195]],[[27929,57491],[29,18],[74,0],[10,6]],[[28042,57515],[13,-50],[16,-97],[13,-46],[9,-55],[2,-47],[11,-22],[3,-35]],[[28109,57163],[-5,-18],[5,-35],[22,-50],[-22,-77]],[[28109,56983],[-22,-37],[-31,12],[-62,107],[-44,-9],[-12,27]],[[27938,57083],[6,17],[-4,74],[5,18],[11,129],[-14,55],[-13,115]],[[18803,71550],[33,0],[0,102],[71,0],[0,13],[35,0],[0,89],[22,-1],[1,-49],[-8,-19],[9,-27],[21,-1],[24,-29],[15,-68],[26,-46],[3,-44],[16,1],[12,-25]],[[19083,71446],[9,-60],[16,-1],[0,-38],[22,-43],[5,-27],[25,17],[13,-23],[16,43]],[[19186,70744],[0,-42]],[[19186,70702],[-35,0],[0,9],[-104,0]],[[19047,70711],[-78,0]],[[26384,60576],[20,-15],[8,77]],[[26412,60638],[12,-2],[10,-26],[19,9]],[[26470,60383],[-3,-20],[-19,-26],[0,-44],[-10,-4],[-13,-81],[3,-21]],[[26428,60187],[-59,206]],[[26369,60393],[15,183]],[[26997,56995],[19,-60],[3,-32],[13,-31],[11,-5],[21,-68],[8,-4],[9,-40]],[[27081,56755],[21,-79]],[[27064,56474],[-11,-10]],[[27053,56464],[0,35],[-29,4],[-14,-10],[-10,41],[-19,-49],[-6,108]],[[26975,56593],[16,51],[8,64],[-2,66],[-17,67],[-1,50],[-6,26],[24,78]],[[25679,61093],[20,15],[14,52],[11,13]],[[25724,61173],[6,-11],[12,-89],[10,-22],[10,25],[10,-10],[-3,-75]],[[25773,60781],[-51,88]],[[25722,60869],[2,63],[-11,57],[-16,-4],[5,52],[-10,32],[-16,-14],[3,38]],[[26209,60492],[9,-2],[1,155]],[[26219,60645],[10,-13],[29,-2],[15,19]],[[26273,60649],[-4,-95],[3,-46],[15,-43],[20,-35],[5,-71],[-5,-15],[1,-56]],[[26308,60288],[-50,-142]],[[26258,60146],[-15,-17],[-25,98]],[[26218,60227],[-4,83],[-30,62]],[[26184,60372],[10,86],[15,34]],[[26311,61014],[14,165]],[[26325,61179],[19,-20],[31,-54],[8,-36],[4,-72]],[[26387,60997],[-14,-8],[7,-43],[-18,-40]],[[26362,60906],[-12,-47],[-21,69],[8,18],[-17,26],[-11,-12]],[[26309,60960],[2,54]],[[26993,58140],[37,4],[20,-69],[17,-78],[8,-15],[-1,-82]],[[27074,57900],[-68,11]],[[26967,57906],[2,102],[24,132]],[[27004,59029],[21,-9],[4,-50],[14,-1]],[[27043,58969],[12,-114],[-6,-24],[7,-52],[15,-36]],[[27071,58743],[0,-30],[-9,0],[-10,-37],[-14,-2],[-9,-33]],[[27029,58641],[-3,99],[-15,51],[0,73],[-21,-14],[-8,49],[-10,-18],[-4,64],[-18,-14]],[[26950,58931],[18,52],[17,21],[12,-5],[7,30]],[[28650,59487],[53,0]],[[28703,59487],[72,0]],[[28775,59487],[2,-58],[17,-245],[7,-68]],[[28801,59116],[-6,-5]],[[28795,59111],[-6,68],[-8,23],[3,39],[-5,89],[-10,30],[-4,48],[-25,13],[-1,40],[-13,-20],[6,-61],[16,-48],[11,10],[0,-67],[15,-135],[9,-61],[-1,-26],[11,-75],[0,-47],[-19,64],[1,37],[-13,61],[-3,38],[-10,13]],[[28749,59144],[3,34],[-13,28],[-6,41],[-10,18],[-17,-2],[-12,47],[-1,31],[-43,146]],[[27454,60295],[36,47],[13,37]],[[27503,60379],[30,61],[17,-32]],[[27550,60408],[1,-38],[19,-88],[3,-140]],[[27573,60142],[-29,-40],[-18,-66],[-18,-22],[-6,16],[-10,-27],[-13,20],[-7,-30]],[[28342,60531],[-24,24],[-6,75],[-19,3],[0,24]],[[16977,71347],[-10,-5],[8,-64],[-3,-26],[8,-38],[-4,-41]],[[16976,71173],[-4,5]],[[16972,71178],[-21,14],[-24,-29],[-22,19],[-22,-48],[-18,-60],[-6,-105],[-19,-63],[-12,0],[-6,-72],[-17,-19],[-10,-35],[-30,-15],[-19,-54]],[[16746,70711],[-23,37],[-22,13],[-18,57],[5,36],[-6,64],[3,76],[-3,97],[-37,110],[-3,46],[-11,31]],[[31446,38277],[21,-16]],[[31467,38261],[-1,-46]],[[22569,56856],[161,-1]],[[22731,56601],[-1,-202]],[[22730,56399],[-10,24],[3,41],[-19,42],[-9,-3],[-12,-58],[-29,-92],[-12,-9],[-28,46]],[[22614,56390],[7,56],[-5,-1],[7,60],[-7,20],[-13,-14],[-19,11],[-10,91],[8,35],[-4,50],[-9,-15]],[[27070,59438],[16,69],[28,54]],[[27114,59561],[50,-2]],[[27164,59559],[-8,-28]],[[27156,59531],[-9,-60],[4,-80],[-6,-12],[-4,-78]],[[27141,59301],[7,-61],[-17,0],[-8,23],[-11,-12],[-23,-70]],[[27089,59181],[-4,-26]],[[27085,59155],[-14,27],[-6,52],[-8,1],[-8,39],[26,111],[5,11],[-10,42]],[[26225,58159],[14,67],[6,-32],[10,4],[4,47],[10,16],[-4,62],[22,3],[-4,34],[8,15],[0,92],[16,18],[0,74]],[[26307,58559],[14,-58],[10,24],[5,-19],[0,-73]],[[26336,58433],[-29,-144],[-7,-12],[-8,-53],[-7,-12],[-16,-122]],[[26269,58090],[-19,-71],[-5,-2]],[[26245,58017],[-9,88],[-15,19],[4,35]],[[22350,68083],[33,0]],[[22387,67576],[-140,1]],[[22863,54830],[13,-1]],[[22876,54829],[142,-4]],[[23018,54825],[7,-21],[-2,-53],[10,-55],[11,-27],[-5,-61]],[[23039,54608],[20,-35]],[[23059,54573],[-4,-6],[-139,-291]],[[22863,54499],[0,331]],[[22614,56390],[0,-492]],[[22491,55898],[-1,429]],[[22490,56327],[0,289]],[[27780,60729],[25,50],[23,157],[9,21],[6,-28],[11,16]],[[27854,60945],[9,13],[8,-34],[11,-8],[1,-67],[23,-29],[24,-176],[8,-3]],[[27896,60510],[-14,-9],[-4,-31]],[[27878,60470],[-10,4],[-18,79]],[[27850,60553],[-11,47],[-20,-6],[-11,16],[-9,42],[-3,46],[-16,31]],[[20101,61123],[9,22],[6,-24],[18,8],[9,-49],[13,-6],[8,-33],[22,-14],[0,-44]],[[20065,60503],[1,293],[-6,1],[2,306],[20,26],[19,-6]],[[26945,55077],[10,18],[-6,39],[16,6],[13,23]],[[26978,55163],[28,-37],[19,10]],[[27025,55136],[18,-174],[23,-65]],[[27066,54897],[-9,-80]],[[27057,54817],[-13,25],[-19,-46],[-10,-54],[-1,-47],[-19,-96],[6,-38]],[[27001,54561],[-13,-28],[-21,-3],[0,25],[-15,47]],[[26952,54602],[7,101],[-29,60],[-45,24]],[[26885,54787],[24,23],[-9,54],[37,80],[-10,43],[13,40],[5,50]],[[24948,63645],[-9,36],[-14,2],[-18,-33],[-42,1],[-20,17],[-7,-39]],[[24838,63629],[-19,-9],[-19,-45],[-18,-11],[-25,3],[-8,71],[-11,9]],[[24738,63647],[24,36],[15,-5],[4,39]],[[23016,66889],[189,0]],[[23205,66889],[-1,-406]],[[23026,66484],[-4,81],[-17,60],[-15,27],[-1,76],[11,26],[3,52],[11,16],[2,67]],[[22662,60865],[30,1],[-1,205]],[[22691,61071],[4,2],[149,0]],[[22844,61073],[0,-509]],[[22844,60564],[-55,2],[-127,-4]],[[22662,60562],[0,303]],[[26143,61748],[9,4],[31,104]],[[26209,61869],[20,-52],[-7,-48],[14,3],[-3,-30],[9,-16],[-2,-42],[23,-25],[-4,-48],[7,-21]],[[26151,61591],[-12,54],[-5,64],[9,39]],[[24765,52052],[-6,-133],[0,-94],[3,-74],[8,-50],[20,-50],[-17,-148]],[[24773,51503],[-32,2],[-5,16],[-3,61],[-16,20],[-13,42],[-1,40],[-14,44]],[[24689,51728],[0,97],[-5,0],[3,53],[17,26],[8,-3],[12,58],[16,43],[6,35],[19,15]],[[25554,57450],[3,-38],[-3,-68],[-7,-15],[2,-41],[-15,-41],[-9,-69]],[[25525,57178],[-170,17]],[[25355,57195],[12,362]],[[18336,54778],[63,0],[252,2]],[[18651,54780],[177,0],[60,-6],[54,0],[0,11],[84,0],[3,3],[110,0]],[[19139,54788],[0,-100]],[[19139,54688],[1,-207],[-1,-604]],[[18884,53522],[-278,367],[-212,269],[-58,77]],[[18336,54235],[0,543]],[[19405,56114],[5,45],[10,25],[25,14],[2,61],[83,1]],[[19530,56260],[0,-663]],[[19530,55096],[0,-410]],[[19530,54686],[-18,0]],[[19512,54686],[-31,120],[4,64],[-1,112],[-9,72],[-20,117],[-4,1],[-46,273],[0,669]],[[24429,57786],[7,33],[-6,44],[11,28],[4,39],[8,3],[-9,58],[-8,121],[23,45],[3,36]],[[24462,58193],[26,8],[0,-102],[59,-4]],[[24547,57855],[-1,-171],[-29,1]],[[24456,57581],[1,162],[-27,0],[-1,43]],[[27601,48335],[13,-202],[-1,-235],[-7,-175],[-4,-144]],[[27602,47579],[-36,8],[-26,32],[0,-24],[-162,-1]],[[27378,47594],[-2,478],[0,250]],[[27141,53410],[11,82],[7,-1],[12,62]],[[27171,53553],[20,-90],[32,-72],[15,4],[31,-26]],[[27269,53369],[-6,-103],[-13,-22],[-8,-59],[-9,-3],[0,-71],[-4,-54],[-8,-12]],[[27221,53045],[-12,21],[-24,73],[4,28],[-21,-15],[-15,17],[-22,54]],[[27131,53223],[0,38],[10,149]],[[23974,64548],[128,1]],[[24102,64190],[-21,-1]],[[24081,64189],[-107,-7]],[[24521,66583],[66,-1],[0,35]],[[24587,66617],[53,-48],[18,-109],[0,-37]],[[24705,66275],[-53,1],[0,-102],[-65,0]],[[26104,59938],[61,-15]],[[26165,59923],[-12,-31],[11,-52],[6,1]],[[26170,59841],[-9,-128],[-13,-138]],[[26148,59575],[-40,-9]],[[26064,59799],[6,23],[-8,40],[12,-25],[15,19],[9,31],[6,51]],[[24290,51905],[3,42]],[[24293,51947],[21,-6],[16,-28],[16,55],[-1,20],[17,15],[12,-13],[14,-49],[3,-40],[26,0],[6,29],[33,0]],[[24456,51930],[27,1],[13,-40]],[[24496,51891],[-10,-29],[1,-33]],[[24487,51829],[-60,-18]],[[24319,51555],[-6,24],[8,41],[8,-3],[-2,46],[-16,8],[-14,-22],[-9,19]],[[24275,51386],[10,27],[12,-5],[3,26],[22,-6],[23,-61],[9,7],[6,-29],[-15,-36],[-1,-40],[-14,-19],[-59,115],[4,21]],[[25420,62164],[104,3]],[[25524,62167],[10,-86],[1,-42],[-14,-76],[-14,-12],[-7,-32],[-9,-83]],[[25491,61836],[-72,2]],[[28550,61756],[5,-40],[13,-47],[30,-61],[8,-56]],[[28606,61552],[5,-36],[14,21],[8,-14],[-7,-47],[4,-48],[18,-92],[-5,-22],[5,-97],[-9,19],[-11,58],[-8,4],[-5,64],[-8,-9],[-2,-57],[-7,38],[-8,-3],[-5,48],[-12,45],[-23,23],[-35,3],[-8,129],[-6,9]],[[28501,61588],[-7,30],[15,62],[13,87],[28,-11]],[[24475,52618],[13,65],[112,16]],[[24600,52699],[-17,-81]],[[24583,52618],[-6,-42],[-15,-33],[4,-26],[-3,-47],[4,-21],[-6,-49],[15,-111],[13,-25]],[[24589,52264],[-27,0],[-9,-28]],[[24553,52236],[-34,2]],[[24519,52238],[-9,25],[-17,0],[0,36],[11,75],[-4,97],[-15,-21],[-6,12],[11,24],[-6,42],[-11,1],[2,89]],[[24009,53851],[98,1],[0,102],[72,-1]],[[24179,53953],[5,-43],[-8,-67],[7,-6],[-5,-56],[4,-28],[-9,-5],[21,-36],[-3,-20],[12,-42],[0,-47],[10,7],[12,-28]],[[24225,53582],[-30,-22],[-91,-79],[-8,-3],[-13,73],[4,24],[-8,54]],[[24079,53629],[-22,92],[-30,31],[1,42],[-17,23],[-2,34]],[[25823,67545],[-22,169],[0,48],[22,102],[8,85]],[[23036,64415],[176,0]],[[23212,64415],[-13,-36],[-2,-37],[15,-58],[13,-16],[10,-56],[-4,-28]],[[23231,64184],[-1,-63],[16,-9]],[[23246,64112],[-99,0]],[[23036,64111],[0,304]],[[25197,66405],[112,2]],[[25339,66408],[0,-398]],[[25339,66010],[-11,0]],[[25328,66010],[-98,0]],[[25198,66010],[-1,395]],[[22311,63505],[95,0]],[[22406,63505],[62,0]],[[22468,63505],[-1,-506]],[[22467,62999],[-150,1]],[[25328,66010],[0,-101],[-7,-1],[0,-93]],[[25321,65815],[0,-305]],[[20283,55809],[172,0],[1,-100],[113,1],[1,-202]],[[20570,55508],[0,-198],[-10,0],[-1,-516],[140,2]],[[20699,54796],[0,-303],[1,-8],[0,-294]],[[20700,54191],[-19,0]],[[20681,54191],[-143,0],[-158,2]],[[20380,54193],[-106,-2]],[[20274,54191],[0,1114],[10,1],[0,110]],[[25724,61173],[12,-1],[-3,59],[5,53],[-11,57],[4,72]],[[25731,61413],[0,51],[31,-1],[0,18]],[[25823,61316],[8,-41],[-6,-42],[-10,-5]],[[25524,62167],[-5,8],[7,56]],[[25526,62231],[1,-6],[79,-1],[0,7]],[[25645,62227],[-9,-22],[-5,-55],[-6,10],[-12,-45],[-7,13],[-1,-80],[-10,-69],[11,-69],[-4,0],[3,-101]],[[25605,61809],[-16,-41],[-15,39],[-16,-20],[-14,9]],[[25544,61796],[-9,-44],[-22,-6],[-7,-47],[-41,-42]],[[25465,61657],[2,71],[24,42],[0,66]],[[27478,65805],[48,61],[45,74],[9,24],[10,60],[13,3],[3,-28],[36,72],[47,74]],[[27689,66145],[0,-314],[42,-1]],[[27731,65830],[0,-174]],[[27731,65656],[-19,2],[-146,-3],[-88,1]],[[27478,65656],[0,149]],[[27511,55189],[28,-7],[40,-39],[-1,65],[18,14],[5,48],[-17,60],[8,7],[-16,20],[5,22]],[[27581,55379],[15,-39],[12,14],[12,-116],[17,12],[-4,-38],[9,-30],[1,-33],[9,8],[0,33],[9,13],[11,58],[17,44],[0,36],[10,30],[23,123],[24,42],[10,-11],[8,52],[13,26]],[[27777,55603],[27,-70],[23,-22],[-6,-29]],[[27821,55482],[-11,-23],[-9,-97],[-17,10],[-17,-16],[-11,39],[-16,-33],[-10,-63],[3,-31],[8,10],[0,-33],[-15,-20],[-18,-45],[-9,-52],[-34,-59],[-10,38],[-11,-7],[-1,-32],[17,-22],[-5,-59],[-25,-52],[-7,-40],[-10,5],[-24,-22],[-17,-59],[-6,18],[-20,-45]],[[27546,54792],[-2,16],[-19,-36],[-18,54],[8,33],[0,91],[-9,20],[-1,52],[-8,29],[5,56],[8,27],[1,55]],[[27253,57873],[80,-17]],[[27333,57856],[2,-53],[-7,-48],[5,-21],[30,73],[8,-36]],[[27371,57771],[-1,-69],[6,-38]],[[27376,57664],[0,0]],[[27376,57664],[1,-20]],[[27377,57644],[0,-1]],[[27377,57643],[0,0]],[[27377,57643],[4,-43],[-3,-78],[4,-17],[-9,-31]],[[27217,57495],[-10,125],[5,42],[-4,52],[10,25],[12,0],[3,102],[9,33]],[[27266,54838],[74,229],[20,-77],[-4,-52],[16,-24],[9,45]],[[27381,54959],[10,-75],[-2,-87],[6,-36],[-8,-72],[2,-51],[-10,-45],[-13,7],[-3,-60],[-20,7],[4,-45],[-6,-37],[5,-46],[13,-34],[2,-35],[11,-30],[-2,-39],[8,2]],[[27378,54283],[-7,-32],[5,-21]],[[27376,54230],[-9,4],[-22,71],[-11,-17],[-21,34],[-5,62],[4,26],[-8,44]],[[27304,54454],[-3,17],[10,50],[-6,76],[-4,-4],[-15,105],[4,34],[-23,81],[-1,25]],[[29192,65355],[29,48],[4,-32],[34,-26],[-2,38],[23,-40],[28,10]],[[29308,65353],[-13,-82],[0,-75],[5,-18]],[[29300,65178],[9,-52],[-9,-81]],[[29300,65045],[-71,-212]],[[29229,64833],[-37,71]],[[29192,64904],[-91,179]],[[29101,65083],[-17,78]],[[29084,65161],[1,80],[77,12],[19,83],[11,19]],[[29624,67292],[37,-38],[38,15],[32,-3]],[[29731,67266],[-5,-83]],[[29726,67183],[5,-91],[-9,-33],[6,-52],[-8,-45],[-13,-10],[-1,-57],[-9,-73],[12,-102],[6,10],[9,-53]],[[29593,66691],[2,219],[-24,3],[3,218],[36,-4],[2,107],[4,66],[8,-8]],[[19764,53938],[0,-524],[-234,-1]],[[19530,53413],[0,1273]],[[19531,57636],[160,-1],[1,404],[204,-2],[0,51],[30,0],[0,-51],[89,1]],[[20015,58038],[19,0],[12,-100]],[[20046,57938],[36,-306]],[[20044,57192],[-136,1],[-9,-2]],[[19899,57191],[-368,2]],[[19531,57193],[0,443]],[[27258,60505],[8,-6],[-7,46],[12,42],[12,18]],[[27283,60605],[6,75],[18,26],[11,-10]],[[27318,60696],[66,-186]],[[27384,60510],[-7,-53],[9,-43],[-19,-47],[-17,-16]],[[27350,60351],[0,11],[-37,-27],[-31,-51]],[[27282,60284],[-27,75],[-11,45]],[[27394,63328],[9,20],[-4,60],[13,-11],[-2,52],[7,20],[2,72]],[[27419,63541],[59,-19]],[[27478,63522],[0,-63]],[[27391,63178],[-10,42],[12,48],[1,60]],[[25837,54667],[3,20],[15,7],[10,-25],[-4,37],[17,68],[14,-31],[6,-45],[18,-3],[23,-32],[6,16]],[[25945,54679],[9,-98],[20,-71]],[[25974,54510],[-19,-3],[-3,-25],[0,-232]],[[25952,54250],[1,-98],[-55,-1]],[[25898,54151],[-31,-2],[0,100],[-29,0]],[[25813,54591],[10,39],[1,33],[13,4]],[[25867,56634],[32,97],[23,4],[0,17]],[[26024,56482],[0,-39],[-30,25],[-15,-16],[0,-43],[-19,10],[-7,-58],[-20,-26]],[[25861,56449],[-13,-1],[11,54],[0,63],[8,69]],[[25351,57057],[4,138]],[[25525,57178],[0,-305]],[[25496,56876],[-76,6],[-74,10]],[[25346,56892],[5,165]],[[7285,89453],[0,-1009]],[[7285,88444],[-135,0],[0,-303],[12,0],[0,-302]],[[6449,87839],[-325,0],[0,101],[-99,0],[0,-101],[-50,0],[0,-101],[-49,0],[0,101],[-297,0],[0,-101],[-20,0],[0,-101],[-49,0],[0,-101],[-49,0],[0,-202],[-19,0],[0,-101],[-48,0],[0,-201],[-49,0],[0,-101],[-17,0],[0,-202],[-48,0],[0,-202],[-65,0],[0,-202],[-47,0],[0,-201],[-16,0],[0,-101],[-47,0],[0,-101],[-47,0],[0,-202],[-14,0],[0,-101],[-47,0],[-1,-187]],[[5046,85432],[-10,-15]],[[5036,85417],[-82,0],[0,-101],[7,0]],[[4961,85316],[-9,-36],[0,-49],[-41,-38],[-8,-26],[-22,-10],[-15,-44],[-20,-15],[-4,55],[-29,45],[-54,-20],[-29,33],[49,47],[15,-39],[18,12],[5,50],[25,77],[3,60],[-8,85],[1,81],[-16,74],[5,21],[-16,20],[-29,97],[-20,139],[29,128],[21,23],[24,79],[24,26],[-15,77],[-18,44],[-15,64],[-10,107],[-50,162],[-3,74],[-25,67],[-10,63],[-30,85],[-10,44],[-22,9],[-11,-37],[-2,-74],[6,-37],[-8,-56],[-12,-21],[-27,-10],[-18,21],[-19,-54],[-36,-29],[-50,-68],[-73,-48],[-88,-28],[-75,10],[-51,38],[-13,32],[-13,99],[23,18],[-18,69],[-54,62],[-32,108],[-5,34],[-33,51],[-18,62],[-42,8],[-31,42],[-47,110],[23,32],[24,55],[-2,36],[-24,6],[-38,-54],[-48,10],[-16,51],[11,32],[32,1],[57,128],[10,-4],[17,45],[-16,34],[-4,41],[32,24],[-27,7],[5,70],[27,78],[-17,3],[-18,-48],[-27,20]],[[3261,87028],[35,25],[57,0],[22,-20],[23,10],[9,-24],[21,10],[10,30],[-8,38],[34,68],[37,-11],[0,37],[25,46],[33,-40],[24,32],[23,9],[15,54],[19,-132],[27,-10],[29,34],[29,-20],[27,-40],[-12,-65],[11,-44],[-11,-40],[13,-11],[4,-65],[-13,-38],[21,-54],[2,-58],[21,10],[-11,-34],[2,-48],[-71,-21],[-6,-34],[-20,19],[-26,-18],[-28,-58],[8,-64],[-26,-8],[-23,71],[-38,47],[-57,-4],[-14,35],[-28,18],[-27,58],[-35,42],[-40,19],[-32,72],[-25,10],[-2,70],[-28,97]],[[1695,87369],[6,69],[25,52],[11,-3],[-4,-58],[12,-54],[33,-70],[48,-63],[22,-14],[25,13],[57,-94],[-21,-19],[-9,37],[-51,8],[-26,-17],[-33,46],[-58,136],[-37,31]],[[1687,87598],[8,-5],[5,-84],[-20,42],[7,47]],[[20921,67988],[0,335]],[[21089,68323],[297,-1],[-5,21],[3,52],[10,32],[-3,38],[8,100],[11,30],[-2,69],[24,21],[16,-29],[14,10],[21,79],[10,9]],[[21493,68754],[-1,-195],[0,-406]],[[21492,68153],[-4,-1],[0,-332],[-4,-23],[-29,14]],[[21455,67811],[-10,-16],[-177,0]],[[22408,69607],[205,-4]],[[22613,69603],[0,-102]],[[22614,68894],[-202,3]],[[22409,69203],[-1,404]],[[22941,67092],[98,0]],[[23039,67092],[-16,-39],[5,-56],[-8,-28],[6,-21],[-10,-59]],[[23041,66402],[-17,-7],[-5,30],[-24,-5],[-6,21]],[[22989,66441],[-1,32],[-21,66],[7,52],[-11,16],[-21,3],[-1,40]],[[22941,66650],[0,442]],[[27381,54959],[12,51]],[[27393,55010],[17,-34],[7,8],[20,-17],[2,-64],[11,-36],[19,-18],[13,-80],[8,-14]],[[27490,54755],[-1,-44],[14,-67],[-7,-74],[-32,-62],[-19,-20],[-2,41],[-19,40],[-11,-22],[-2,-31],[12,-15],[14,-59],[-15,-65],[-25,-59],[-9,0],[-10,-35]],[[26701,58725],[3,7],[6,123],[4,-12],[8,102]],[[26722,58945],[-3,46],[8,30],[11,-26],[-2,57],[5,5]],[[26741,59057],[-2,-28],[20,-42],[57,-205]],[[26816,58782],[-4,-21],[3,-63],[-13,-56],[-4,-38]],[[26798,58604],[-9,-21],[-24,18],[-21,-29],[-8,-40],[-20,-17]],[[26716,58515],[-6,-2],[1,65],[-4,30],[7,29],[-13,60],[0,28]],[[28881,63990],[21,81],[21,57]],[[28923,64128],[38,83]],[[28961,64211],[2,-20]],[[29032,63900],[21,-54],[7,-52],[20,-41],[13,-75]],[[29093,63678],[-16,-35],[-10,8],[-12,-51],[-32,-40]],[[29023,63560],[3,81],[-14,22]],[[29012,63663],[-26,63],[-105,264]],[[22709,67191],[1,-369]],[[22710,66822],[-14,-11],[-25,9],[-20,21],[-8,-11],[-9,-74],[-12,-29],[-19,-9],[-37,89]],[[22566,66807],[10,36],[-2,47],[8,74],[-5,32],[1,101],[9,94]],[[25530,59236],[58,-26],[5,11]],[[25593,59221],[12,2],[25,-21],[-1,-39],[-10,-27],[8,-15],[-7,-28],[11,-41],[-4,-26],[-5,-122]],[[25622,58904],[-6,-105]],[[25616,58799],[-92,39]],[[25524,58838],[-5,169],[-4,46]],[[23225,60010],[73,0]],[[23298,60010],[32,0]],[[23330,60010],[0,-66],[-6,0],[0,-402]],[[23324,59542],[-106,0]],[[23218,59542],[0,401],[7,0],[0,67]],[[23021,55137],[62,1],[0,32]],[[23144,54606],[-105,2]],[[23018,54825],[2,0],[1,312]],[[22052,56779],[62,-152],[7,9],[21,-15],[14,9],[21,-47],[4,21],[12,-10],[4,24]],[[22197,56618],[0,-293]],[[31200,38072],[21,-4]],[[31221,38068],[-4,-51]],[[30408,68304],[30,-20],[12,70],[25,-17],[2,-16]],[[30477,68321],[-9,-113],[-7,-19],[32,-22],[-6,-42],[4,-51],[-10,-39],[12,-80]],[[30493,67955],[-15,-94],[-23,-27],[-5,-19],[-2,63],[-7,21]],[[30441,67899],[3,87],[-6,17],[11,92],[-5,10],[-16,-49],[-13,4],[-15,71]],[[30400,68131],[-5,17],[13,156]],[[22933,55826],[125,-9]],[[23058,55817],[0,-66],[25,13]],[[23083,55333],[-62,1]],[[23021,55334],[-91,6]],[[22930,55340],[3,486]],[[22479,53822],[-8,46],[-49,-26]],[[22128,53697],[20,-57],[-7,-35],[14,-35],[7,29]],[[22162,53599],[-1,-471]],[[21280,53785],[125,-1]],[[21410,53126],[-25,2]],[[21385,53128],[-11,48],[0,75],[-20,70],[-22,21],[-27,68],[-21,-59],[-4,17]],[[21280,53368],[0,417]],[[20699,54796],[3,0],[0,515],[286,3]],[[20988,55314],[0,-516],[26,0],[0,-608]],[[21014,54190],[-72,0]],[[20942,54190],[-12,0]],[[20930,54190],[-142,0],[-88,1]],[[24274,61187],[15,-1],[20,48],[73,0],[1,119]],[[24383,61353],[27,-1]],[[24410,61352],[2,0],[-1,-423]],[[23683,57798],[1,51],[30,-3],[1,85]],[[23715,57931],[0,20],[30,-2],[1,105],[29,-7],[1,136],[17,-76],[10,12]],[[23803,58119],[12,35],[8,-22],[13,-3],[18,29],[9,-14],[17,36],[6,-73],[-2,-43],[24,16],[10,-17]],[[23924,58052],[-1,-122],[-49,3],[-20,-81],[-38,3],[-12,-16],[1,-134]],[[23790,62949],[0,-369]],[[23790,62580],[-23,9],[-16,-36],[-12,-5],[-6,-42],[-7,10],[7,36],[-5,26],[-13,-16],[1,-44],[-11,-23],[-12,11]],[[23693,62506],[-8,32],[-15,14],[5,34],[-12,-6]],[[23663,62580],[1,288]],[[16820,60549],[263,3]],[[17268,59977],[255,-808],[113,-364]],[[17636,58805],[55,-180]],[[17138,58610],[-81,1],[0,-13],[-23,3]],[[17034,58601],[1,86],[6,5],[-3,89],[-7,20],[3,34],[-7,22],[-5,82],[-5,21],[3,71],[-12,58],[-7,108],[7,44],[-16,57],[4,39],[-19,13],[-9,55],[-1,63],[-12,29],[1,52],[-9,28],[-13,75],[9,16],[-7,45]],[[27709,64282],[0,583]],[[27709,64865],[7,-141],[19,-20],[-6,-50],[47,-9],[9,26],[12,-23],[3,20],[22,10],[20,47]],[[27842,64563],[0,-157],[-66,-286]],[[27776,64120],[-13,-6],[-18,45],[-7,74],[-23,61],[-6,-12]],[[27195,58344],[161,-25]],[[27359,58254],[2,-42],[-4,-64]],[[27357,58148],[-139,23]],[[27195,58339],[0,5]],[[26798,58604],[4,-62],[8,7],[5,-69],[5,-8]],[[26820,58472],[10,-75],[9,16],[13,-70],[0,-31],[-9,-81],[5,-37],[10,-19]],[[26809,58022],[-12,27],[-7,61],[-15,31],[0,24],[-26,86],[-14,30]],[[26735,58281],[9,45],[-8,53],[2,34],[-7,26],[6,25],[-21,29]],[[26716,58493],[0,22]],[[26583,59038],[9,50],[-1,76],[10,83]],[[26601,59247],[15,2],[6,25],[21,-12],[6,25],[13,-5],[3,45],[14,0]],[[26709,59306],[7,-123]],[[26716,59183],[-6,-29],[-14,38],[-34,-92],[-5,-50]],[[26657,59050],[-20,8],[-16,-21],[-2,-30],[-9,7],[2,-46],[-13,24],[2,-52]],[[26601,58940],[-9,34],[-9,64]],[[28064,65368],[-1,17],[61,1]],[[28124,65386],[42,-166],[17,-1]],[[28183,65219],[0,-125],[-29,-175]],[[28154,64919],[-40,16]],[[28114,64935],[1,108],[-6,0],[1,95],[-47,0],[1,230]],[[22908,67092],[33,0]],[[22941,66650],[-28,35],[-12,-17],[-8,48],[-11,1]],[[22882,66717],[-32,12],[-8,33]],[[22842,66762],[0,330]],[[28738,64565],[41,69],[33,42],[-10,49],[0,50],[21,45],[12,-11]],[[28835,64809],[20,-64],[23,-93],[-22,-42],[28,-159]],[[28884,64451],[-38,-32]],[[28846,64419],[-23,-20],[-18,-40]],[[28805,64359],[-36,94],[-31,112]],[[27467,57470],[67,-4]],[[27534,57466],[109,-9]],[[27643,57457],[1,-48],[9,-27],[5,-54],[12,-45],[10,-10],[5,-41],[-7,-5],[-8,-90]],[[27670,57137],[-15,-47],[-22,-4],[-5,16],[-18,-11],[-67,-146]],[[27543,56945],[1,32],[-10,38],[-2,83],[-13,57],[-2,43],[-8,36]],[[27509,57234],[-6,52],[-16,52],[-8,68],[-12,64]],[[27403,55565],[80,179],[5,-64],[16,-26],[18,0]],[[27522,55654],[9,-69],[9,-19],[-9,-39],[14,-34],[36,-114]],[[27511,55189],[5,33],[-6,33],[-3,71],[8,66],[-24,37],[-16,6],[-17,-14],[-22,54],[-11,61],[-22,29]],[[23927,63158],[51,3],[63,-8]],[[24041,63153],[47,-2],[-1,-102]],[[24087,63049],[-1,-2],[-3,-334]],[[24083,62713],[-23,26],[-17,-137]],[[24043,62602],[-13,-5],[-17,71],[-1,34],[-23,6],[-17,77]],[[23972,62785],[-3,38],[-27,29],[-4,37],[-10,-14],[-6,68],[5,35],[-3,77]],[[29520,69339],[144,2],[33,-8]],[[29697,69333],[5,-85],[2,-119],[-13,-60]],[[29594,68896],[-31,21],[-53,83]],[[29510,69000],[-9,58],[14,59],[5,100],[-14,47],[14,75]],[[27914,65392],[0,1]],[[27914,65393],[79,1],[53,6],[0,-32],[18,0]],[[28114,64935],[-114,27],[0,-42],[-18,-18]],[[27875,65063],[1,96],[8,35],[24,-1],[5,-18],[1,217]],[[28616,60609],[9,25],[14,-10]],[[28639,60624],[7,-37],[10,25],[8,-41],[5,-110],[-8,-90],[-18,63],[-18,42]],[[28625,60476],[-12,23],[-1,76],[4,34]],[[24106,61676],[36,-3]],[[24142,61673],[25,-3],[-1,-98],[35,-5],[9,-17],[16,15]],[[24226,61565],[-1,-50]],[[24225,61515],[0,-152],[4,-1],[-1,-168]],[[24167,61199],[-31,2],[-20,85],[-5,87],[-10,1],[0,48],[-15,11]],[[24086,61433],[2,147],[15,0],[3,96]],[[20355,71488],[71,1],[0,-34],[60,1],[0,-102],[11,0],[0,-101],[24,0],[0,-67],[12,-1],[0,-33],[58,-1],[0,-34],[71,-1],[0,34],[35,-1],[0,51],[35,0]],[[20732,71200],[0,-152],[-48,0],[0,-196],[6,0],[0,-206]],[[20690,70646],[-15,0],[0,-407],[-12,0]],[[20663,70239],[-189,2],[-148,0]],[[20326,70241],[0,406],[11,0],[-1,403],[10,0],[0,405],[9,17]],[[20663,70239],[-2,-506],[-14,0],[0,-410]],[[20647,69323],[-10,0]],[[20637,69323],[-215,0],[-50,-7]],[[20372,69316],[-66,0]],[[20306,69316],[0,216],[-5,0]],[[20301,69532],[0,200],[13,0],[1,472],[-1,37],[12,0]],[[25446,60419],[61,129],[27,30],[34,96]],[[25590,60467],[-14,-96],[-9,3],[-2,-59],[22,-81],[-7,-41]],[[25580,60193],[-11,-29],[-32,-7],[-9,-24],[-45,51]],[[25483,60184],[-19,70],[-15,37],[-1,61],[-12,33],[10,34]],[[25640,71063],[28,45],[11,-8],[14,-72],[12,-27],[19,-4],[8,46],[16,-7],[9,-38],[4,69],[-7,53],[16,20],[7,-32],[-6,-56],[17,-26],[26,72],[40,62],[59,110],[11,-21],[65,41]],[[25989,71075],[-139,1],[0,-203],[-70,2],[0,-203]],[[25780,70672],[-140,0]],[[25640,70672],[0,391]],[[26790,61133],[11,42],[33,-38],[43,-88],[18,-15]],[[26895,61034],[-16,-32],[7,-34],[-8,-41],[6,-11],[3,-67]],[[26887,60849],[-34,42],[-30,-32],[-8,-30],[-11,15]],[[26804,60844],[-3,92],[-11,27],[-4,48]],[[26786,61011],[12,62],[-8,60]],[[25265,63362],[147,1]],[[25404,63137],[-27,-5],[0,-34],[-114,-1]],[[25263,63097],[-1,163]],[[26802,60596],[6,-19]],[[26808,60577],[26,-23],[-1,-61],[15,17],[7,-18],[-2,-71],[3,-52],[12,-26]],[[26868,60343],[-6,-17]],[[26862,60326],[-24,-3],[-16,-31],[-5,-29],[-24,-52],[-6,27]],[[26787,60238],[-15,24],[-3,33],[-14,-4],[-3,32],[4,74],[-3,85]],[[26753,60482],[-3,61],[20,80],[9,-23],[23,-4]],[[22691,61377],[92,0]],[[22844,61277],[0,-204]],[[22691,61071],[0,306]],[[24791,62074],[-13,-59],[8,-72]],[[24765,61794],[-11,35],[-6,44],[5,65],[14,73],[24,63]],[[28007,63883],[32,-46],[17,-50],[3,68],[41,-71],[9,65]],[[28109,63849],[5,-85],[29,-69]],[[28143,63695],[-7,-50],[-13,-42],[7,-32],[-7,-19],[-4,-57],[-22,-195],[-23,-120]],[[27955,63180],[14,117],[-1,272],[6,15],[23,201]],[[23349,63099],[-62,0]],[[23224,63099],[0,404]],[[23867,55908],[0,102],[3,305],[3,0],[1,153]],[[23874,56468],[23,0]],[[23897,56468],[14,-57],[11,-75]],[[23922,56336],[0,0]],[[23922,56336],[25,-28],[4,-22],[11,17],[10,-44]],[[23972,56259],[-3,-378]],[[23969,55881],[-29,3],[0,-17],[-41,5]],[[23899,55872],[-33,3],[1,33]],[[23868,56915],[-1,-102],[-6,1],[0,-47],[17,-6],[-4,-91],[6,-94],[16,-74],[1,-34]],[[23874,56468],[-20,-16],[-12,21],[-13,-2],[-8,27],[-29,28],[-20,3]],[[28334,60270],[9,12]],[[28343,60282],[3,5]],[[28346,60287],[8,8]],[[28354,60295],[13,-56],[-4,-26],[-15,-4]],[[28348,60209],[-16,20],[2,41]],[[24576,62804],[40,-105],[20,-100]],[[24636,62599],[-129,4],[0,-103],[-21,1]],[[24444,62504],[-8,206]],[[24436,62710],[-6,153],[72,172],[7,0]],[[24796,62339],[-35,-1],[-1,-89]],[[24760,62249],[-9,1],[-27,45],[-13,6]],[[24711,62301],[-23,-11],[-10,41],[-3,84],[-6,60]],[[24669,62475],[8,71],[11,17],[13,-21],[49,-1],[0,60],[31,0],[-1,38],[16,4]],[[27474,56104],[10,35],[6,47],[13,28],[-1,-31],[12,4],[-2,61],[35,21],[5,21],[33,75],[4,1],[41,90]],[[27658,56385],[-11,-78],[-23,-59],[6,-54],[-5,-20],[-30,-241]],[[27595,55933],[-14,-22],[0,-35],[-20,-5]],[[27561,55871],[-15,3],[-22,-19],[-22,55],[-4,55],[-13,39]],[[27485,56004],[-2,39],[-11,43],[2,18]],[[26896,59538],[0,-87],[-5,-28],[-21,-46],[6,-28]],[[26870,59324],[-31,-54],[-7,8],[-21,-49],[-6,7],[-15,-54],[-12,-14],[-14,-40]],[[26764,59128],[-14,63],[-8,57],[-15,-60],[-11,-5]],[[25225,58601],[11,41],[108,-9]],[[25344,58633],[-3,-242],[-14,-93],[0,-123]],[[25327,58175],[-33,-5]],[[27670,57137],[6,-53],[15,23],[10,-21],[-8,-23],[0,-36],[9,-50],[9,6],[-2,-49],[9,-60]],[[27603,56618],[-17,50],[-7,38],[13,42],[-7,101],[-11,49],[0,47],[-19,-50],[-12,47]],[[27543,56942],[0,3]],[[28773,63662],[49,122]],[[28822,63784],[23,-22],[4,18],[7,-50],[5,14],[8,-67],[19,-29],[1,-43],[10,11],[8,-42],[9,5]],[[28916,63579],[-16,-28],[3,-17],[-13,-39],[5,-10],[-25,-47],[-20,-82],[0,-43]],[[28850,63313],[-19,-18],[-15,-34],[-20,-82]],[[28796,63179],[-96,0]],[[27725,56865],[51,376]],[[27776,57241],[26,-88],[31,-116],[49,-170]],[[27882,56867],[-16,-53]],[[27866,56814],[-13,39],[-11,-37],[-25,16],[-20,34],[-29,-12],[-19,-67]],[[27769,65117],[21,0],[0,57],[54,-6],[-1,-115]],[[27709,64865],[-1,3]],[[25204,70504],[5,-25],[14,-5],[3,32],[27,2],[2,-25],[21,-21],[12,15],[24,-47],[14,14],[36,-48]],[[25276,70164],[-70,0],[0,302],[-2,38]],[[27759,65394],[155,-2]],[[27029,53039],[14,0],[6,75],[35,-32]],[[27084,53082],[8,-10],[-2,-74],[6,-18],[-6,-56],[6,-3],[-3,-104]],[[27093,52817],[-13,8],[-9,-59],[-12,8],[4,-24],[-8,-16],[1,-49],[-4,-60],[12,-91],[-3,-119],[-6,-47],[1,-58],[-4,-26]],[[27052,52284],[-15,7],[-19,-11],[-11,76],[3,71],[-7,26],[-2,57],[5,14]],[[27006,52524],[18,251],[-8,8],[-67,5],[1,254],[79,-3]],[[20378,60005],[9,-127],[-3,-163],[5,-172],[3,-27],[4,-128],[-5,-129],[-22,-34],[-6,-33],[56,-77],[34,-152],[57,-101]],[[20510,58862],[-10,-46],[-18,7],[-4,-21],[-20,20]],[[20458,58822],[0,27],[-93,0],[-1,-83],[-53,0]],[[20311,58766],[-1,41]],[[20310,58807],[0,41],[-177,-3],[0,253],[-117,-2],[-89,6]],[[19927,59102],[-1,372],[2,160],[0,141],[5,28],[23,65],[18,28],[2,73],[7,41]],[[23711,54418],[25,0],[26,67],[3,45],[16,56],[10,4],[11,-32],[14,2],[14,-56],[0,-37]],[[23902,54111],[-24,-21],[0,-80]],[[23878,54010],[-122,-1]],[[23756,54009],[-8,57],[-18,31],[-11,72]],[[27957,59121],[-1,-168],[15,-24]],[[27971,58929],[3,-55],[11,-14],[-4,-59],[-13,-49],[-12,10],[-7,-70],[-21,1]],[[27928,58693],[-31,-6]],[[19531,58850],[142,0],[253,-3]],[[19926,58847],[89,-2],[0,-807]],[[19531,57636],[0,415],[-1,30],[1,237],[0,532]],[[28398,63177],[61,0]],[[28459,63177],[59,1]],[[28518,63178],[-22,-256],[-7,-51],[3,-125]],[[28492,62746],[-25,16],[-15,-15],[-21,21],[-19,-17]],[[28412,62751],[6,75],[9,48],[1,44],[-24,90],[-25,34],[-7,41],[10,-8],[4,38],[13,39],[-1,25]],[[28860,63072],[1,-28]],[[28861,63044],[-1,28]],[[28850,63313],[27,-4],[23,-37]],[[28900,63272],[1,-9]],[[28901,63263],[-13,-33],[-5,-61],[-9,-32]],[[28874,63137],[-6,7],[-22,-81],[2,-39],[11,-31],[1,-49],[-8,-28],[0,-41],[14,-52],[7,-59]],[[28873,62764],[-11,-13],[-9,-53],[-22,-21],[-27,7]],[[28804,62684],[-2,94]],[[28802,62778],[-6,315],[0,86]],[[21479,63506],[179,-1]],[[21658,63505],[-1,-505]],[[21480,63000],[0,7]],[[26946,54151],[16,-29],[16,-12],[7,13],[18,-34]],[[27003,54089],[30,-30],[3,-27],[16,-43]],[[27052,53989],[-16,-32],[5,-31],[-12,0],[0,-351]],[[27029,53575],[-6,-1],[-20,70]],[[27003,53644],[-4,28],[-22,46],[-8,31],[-29,47],[-12,57],[-7,0]],[[25847,55067],[102,2]],[[25949,55069],[36,-1],[-9,-89],[7,-35],[-2,-52],[2,-128]],[[25983,54764],[4,-22],[-6,-31],[-22,7],[-14,-39]],[[25837,54667],[-1,347]],[[19532,61036],[61,0],[2,17],[156,-1],[13,-86],[19,13],[8,27],[6,-18],[28,20],[36,-95]],[[19861,60913],[-4,-62],[-26,-30],[-1,-66]],[[22823,73980],[83,-1],[146,0]],[[23057,73449],[-216,-1]],[[22841,73448],[7,80],[9,24],[3,62],[-15,80],[-8,124],[-6,24],[-11,98],[3,40]],[[23595,53065],[91,77]],[[23712,53182],[35,28]],[[23747,53210],[13,-245],[-10,-821]],[[23703,52474],[-6,69],[11,53],[-11,67],[-8,-4],[-7,120],[-10,12],[0,44],[-9,75],[3,41],[-11,32],[-4,65],[-8,24],[-10,-21],[-8,20],[-28,-35],[-2,29]],[[27813,56262],[10,-74],[10,-24],[16,12]],[[27849,56176],[14,-49],[11,-107],[27,0]],[[27901,56020],[-7,-45],[-16,-58],[-14,-93],[-13,-174],[3,-55],[-7,-48],[-14,-47],[-12,-18]],[[27777,55603],[-64,106]],[[27713,55709],[0,37],[12,41],[12,83],[15,63],[11,22],[18,71],[-3,22],[14,135],[21,79]],[[23212,64415],[-4,32],[2,71],[7,34]],[[23337,64552],[0,-201],[4,-1],[-1,-172]],[[23340,64178],[-109,6]],[[24694,63489],[22,38],[2,46],[20,74]],[[24838,63629],[1,-241]],[[24839,63388],[0,-33]],[[24839,63355],[-165,4]],[[24674,63359],[9,29],[12,77],[-1,24]],[[29631,68114],[3,-38],[90,-105],[71,-79]],[[29795,67892],[-19,-43],[-9,-44],[-7,-112]],[[29760,67693],[-14,-30],[-5,-74],[5,-35],[-10,-135],[6,-60],[-11,-93]],[[29624,67292],[-1,51],[-13,2]],[[29610,67345],[4,82],[8,11],[18,-31],[9,133],[-17,31],[5,112],[4,-4],[16,111],[-34,39],[11,102],[-2,23],[-23,18],[-1,22],[-23,-37]],[[29585,67957],[-6,65],[7,-9],[22,33],[3,-48],[20,116]],[[21529,72638],[251,1]],[[21888,72638],[0,-202],[-24,0],[-1,-404]],[[21863,72032],[-21,1],[0,-199],[-60,-1]],[[21701,71959],[-25,32],[-5,88],[-11,40],[-10,66],[5,42],[14,28],[-16,50],[-20,-6],[-39,-33],[-19,12],[-29,-49],[-22,10],[-20,38],[-19,3],[-1,38],[-35,-9],[-12,11]],[[21437,72320],[-17,58],[0,119],[-7,30],[8,34],[-21,23],[-14,-51]],[[21386,72533],[0,105],[143,0]],[[28230,58364],[4,-3],[30,81]],[[25135,60363],[6,38],[55,2]],[[25196,60403],[62,-207],[0,-107]],[[25258,60089],[-21,13]],[[25237,60102],[-18,49],[-35,40],[-14,39],[-34,44]],[[25136,60274],[-1,89]],[[28729,61346],[-5,-31]],[[28724,61315],[-12,-7],[1,91],[11,13],[7,-30],[-2,-36]],[[28729,61841],[11,23],[2,38],[11,57]],[[28819,61914],[2,-87]],[[28776,61584],[-15,-15],[-7,-47],[0,-60],[-8,-1],[-11,77],[11,9],[-1,53],[-8,10],[-4,-49],[-9,-33],[6,-27],[-9,-62],[-4,29],[-17,-23],[-9,12],[-16,83],[-9,13],[2,43],[-24,151],[20,14],[5,39],[-8,-7],[-9,51],[8,40],[12,22],[6,-25],[12,26],[1,-36],[22,-9],[13,-39],[3,18]],[[17303,72789],[114,0],[0,16],[36,0],[0,-118],[48,1]],[[17303,72077],[0,712]],[[29722,65346],[9,-60],[31,3],[5,-114],[-36,-15],[3,-39],[11,-6],[1,-41],[9,-30],[2,-51]],[[29757,64993],[-13,-22],[-3,20],[-15,0],[-24,-27]],[[29702,64964],[-2,29],[-19,58],[0,65],[-11,61],[-26,-18],[3,73],[-5,109]],[[29642,65341],[11,29],[0,27],[58,23],[11,-74]],[[25934,65552],[76,-2]],[[26048,65175],[-113,-1]],[[25935,65224],[-1,328]],[[21481,61891],[0,96]],[[21481,61480],[0,7]],[[21481,61487],[0,404]],[[24678,63316],[-4,43]],[[24839,63355],[2,-181],[17,-185],[0,-43]],[[24794,62944],[-41,0]],[[26483,59959],[17,38],[20,-13],[8,22],[2,47],[15,21]],[[26545,60074],[15,-32],[11,12],[11,-36],[27,-55],[14,-4]],[[26623,59959],[7,-28],[-5,-32],[-28,-58],[-16,-62],[-13,-1],[-6,-61],[-19,-71]],[[23718,64547],[128,1]],[[23846,64178],[-61,-3]],[[23785,64175],[-67,-4]],[[26781,61183],[11,50],[26,73],[-10,72]],[[26808,61378],[12,25],[8,-7],[17,62]],[[26845,61458],[16,-7],[10,28],[24,5],[2,-22]],[[26897,61462],[-1,-88],[-8,0],[0,-38],[15,-37],[10,-45],[9,-80],[15,-22],[-10,-41]],[[26927,61111],[-10,20],[-13,-10],[-9,-87]],[[26790,61133],[-9,50]],[[27577,62621],[40,6],[17,24],[7,34],[11,2]],[[27652,62687],[10,-17],[3,-44],[11,-19]],[[27599,62277],[9,33],[0,72],[-21,1],[-11,58],[-16,29]],[[27560,62470],[0,68],[17,83]],[[29475,66424],[25,275]],[[29500,66699],[67,-6]],[[29580,66478],[2,-19],[-12,-186],[-15,11],[1,-70],[17,-19]],[[29573,66195],[-1,-73],[-8,-124],[-10,5],[-1,-63],[5,-63]],[[29558,65877],[-105,13],[-15,-1]],[[29438,65889],[-3,0]],[[29435,65889],[-3,42],[43,493]],[[24249,62413],[133,-6]],[[24378,61993],[-22,4],[-9,-25],[-17,-6],[-16,-26],[-19,-70],[-18,-31]],[[24277,61839],[-15,-16],[-29,29],[-10,27],[-5,44]],[[24218,61923],[2,83],[14,59],[8,58],[-7,59],[2,91],[7,93],[-1,48],[6,-1]],[[23039,69636],[47,-26],[3,-28],[14,-2],[14,-33],[20,-18]],[[23137,69529],[18,-29]],[[23155,69500],[16,-64],[43,-128],[6,-44],[19,-16]],[[23239,69248],[0,-51],[-31,0],[-1,-101],[-167,1]],[[23040,69097],[-1,200]],[[23039,69297],[0,339]],[[28237,60859],[24,-26],[22,-1]],[[28276,60667],[-29,55],[-17,-3],[-3,29],[-22,65],[-10,-13],[1,-40],[-11,-23],[-25,39]],[[28136,60882],[1,17],[26,165]],[[19104,67269],[0,65],[65,0],[0,101],[80,0],[2,101]],[[19251,67536],[82,-2],[0,-113],[17,0],[-1,-41],[7,-24],[-6,-53],[7,-42],[5,-72],[17,-60],[11,-65],[0,-55],[14,-2],[29,-83],[7,7],[13,-95],[32,-81],[-7,-30],[11,0],[18,-36],[-1,-50],[17,-1],[1,-303],[7,1],[0,-198]],[[19531,66138],[-139,0],[-142,8]],[[18677,65828],[168,2]],[[18845,65830],[10,-83],[-9,-17],[-1,-71],[13,-41],[5,-94],[7,-28],[-2,-42],[6,-20],[-7,-48],[-1,-75],[-13,-58],[-9,-94]],[[18844,65159],[-30,-1],[-10,-17],[-12,11],[-8,-48],[-10,-8],[-10,27],[-20,8],[-4,32]],[[18740,65163],[-9,40],[11,16],[-10,67],[-9,24],[-10,-22],[-7,68],[-3,82],[-10,44],[12,110],[-12,82],[-19,73],[-12,80]],[[17580,73980],[234,-2],[134,2]],[[17579,73067],[1,333]],[[26882,51664],[20,43],[3,56],[13,30]],[[26918,51793],[31,-21]],[[26949,51772],[6,-41],[17,-10],[18,-42],[23,6],[16,-14],[6,-62],[9,-8],[6,-67]],[[27050,51534],[1,-57],[-1,-231]],[[27050,51246],[0,-36],[-22,-6],[-16,-16],[-5,11],[0,62],[-54,2]],[[26953,51263],[-42,-6],[0,67],[-28,-3],[0,34]],[[26883,51355],[0,300],[-1,9]],[[26387,60997],[7,28],[7,-30],[6,15],[-4,50],[12,-11]],[[26415,61049],[18,29],[2,-47],[22,3],[29,-31]],[[26486,61003],[-11,-46],[13,-14],[-6,-77],[2,-78],[-11,-30],[10,-88]],[[26412,60638],[-7,62],[-16,59],[-27,147]],[[22653,51137],[57,317]],[[22710,51454],[10,-22],[78,179]],[[22798,51611],[52,-164],[-3,-18]],[[22820,51145],[-27,-80],[-77,-239]],[[22716,50826],[-32,130]],[[22258,66767],[29,44],[27,24],[20,39],[8,-2],[19,-59],[13,2],[12,-25],[10,4],[14,-28],[15,7],[21,-35],[33,-15],[13,11],[31,-17]],[[22523,66717],[0,-378],[2,0]],[[22268,65933],[-4,0]],[[22264,65933],[0,404],[-3,0],[0,405],[-3,25]],[[27983,58287],[66,212],[60,136]],[[28109,58635],[2,-51],[16,-51]],[[28127,58533],[8,-40],[11,-109],[16,-20]],[[28095,58017],[-29,-38],[-23,10],[-13,62]],[[28030,58051],[3,21],[-37,188],[-13,27]],[[24538,65055],[178,-8]],[[24715,64741],[-97,6]],[[24618,64747],[-45,1]],[[24573,64751],[0,28],[-13,75],[-13,6],[-20,85],[11,110]],[[24258,67578],[97,0]],[[24355,67578],[33,-1]],[[24388,67577],[0,-184],[2,-303]],[[24257,67091],[0,152]],[[25094,58185],[-29,1],[-1,-41]],[[25064,58145],[-80,6]],[[24984,58151],[1,168],[-9,39]],[[24976,58358],[9,17],[1,102],[11,75],[-4,22],[11,66],[12,-6]],[[27769,63178],[23,0]],[[27792,63178],[130,2]],[[27883,62891],[-8,-2],[-13,-75],[-31,-60],[-5,-32]],[[27826,62722],[-5,-35],[-12,1],[-33,-103],[-10,-7]],[[27766,62578],[3,600]],[[27689,63178],[80,0]],[[27766,62578],[0,-13]],[[27652,62687],[0,159]],[[27652,62846],[-1,54],[31,165],[7,113]],[[25134,71689],[8,62],[25,65],[14,16],[30,82],[23,23],[17,47]],[[25251,71984],[60,0],[0,-100],[20,0]],[[25331,71884],[-6,-75],[-7,9],[-7,-52],[-14,-26],[-5,-67],[-12,-48],[-9,-6],[-2,-39]],[[25205,70976],[-87,0]],[[25118,70976],[1,303],[34,-1],[1,100],[-20,-1],[0,312]],[[24862,58309],[11,50],[31,80],[9,-16],[21,14],[33,-53],[9,-26]],[[24984,58151],[-35,-9],[-10,-22]],[[24816,58129],[-15,35],[-2,-43],[-12,6],[3,46],[8,17]],[[26407,66734],[58,1]],[[26465,66735],[4,-312],[0,-98]],[[26341,66322],[0,405]],[[22844,60564],[2,-555]],[[22846,60009],[-88,0]],[[22758,60009],[-95,0]],[[22663,60009],[0,449],[-1,2]],[[22662,60460],[0,102]],[[26713,61894],[36,12],[5,44],[21,46]],[[26775,61996],[6,-26],[-14,-59],[0,-44],[-14,-69],[-12,-37]],[[26741,61761],[-20,-90],[2,-102],[-31,-23]],[[26692,61546],[-20,90],[-11,-17]],[[26661,61619],[-4,20],[-32,38],[-5,82],[-12,27]],[[26608,61786],[5,100],[-6,30]],[[26607,61916],[9,55],[26,22],[15,-32],[28,-20],[11,-24],[5,-43],[12,20]],[[23768,51502],[0,-14],[-46,3],[-37,-40],[-61,-99]],[[23599,51733],[0,261]],[[23041,65462],[90,0]],[[23131,65462],[8,-42],[-7,-39],[11,-39],[-3,-56],[15,-28],[2,37],[9,-1],[0,-37]],[[23183,65122],[-109,2]],[[23074,65124],[0,51],[-11,0],[-5,34],[-11,17],[-5,51],[-1,185]],[[16055,70538],[108,1],[18,-3],[138,-1],[197,0]],[[16516,70535],[0,-239]],[[16516,70296],[-37,-27]],[[16297,70181],[-10,-25],[-47,-51],[-16,-36]],[[16224,70069],[-8,18],[-34,-4],[-19,-50],[-14,-4],[-9,75],[-34,40],[-29,-9]],[[16077,70135],[-23,32]],[[16054,70167],[-4,52],[6,14],[-26,1],[0,304],[25,0]],[[24358,62733],[2,303],[-1,68]],[[24436,62710],[-78,6],[0,17]],[[20579,66333],[3,-399],[-2,-503]],[[20580,65431],[0,-629],[1,-137]],[[20581,64665],[-125,-2],[-130,1]],[[20290,64666],[-1,461],[71,0],[-1,175],[0,614],[-1,16],[1,403]],[[27947,61230],[16,39],[-2,53],[11,93]],[[27972,61415],[10,39],[16,24],[-2,20]],[[28078,61389],[44,-62]],[[28095,61182],[-52,-244]],[[28043,60938],[-2,-41],[-32,-7],[-8,-26]],[[28001,60864],[-12,5],[5,25],[-47,336]],[[23790,62580],[13,-1],[17,49],[18,-10],[7,-25],[19,6],[0,69],[4,11]],[[23868,62679],[-5,-407]],[[23863,62255],[-94,11],[-1,-34],[-77,10]],[[23691,62242],[2,264]],[[24225,61515],[48,-4],[45,5],[61,-6]],[[24379,61510],[0,-157],[4,0]],[[24226,61565],[0,41],[22,36],[-15,72],[14,-7],[21,11],[9,39],[-4,28],[4,54]],[[24380,61994],[-1,-484]],[[23821,67982],[-34,0]],[[23787,67982],[0,405]],[[20923,73553],[324,-1]],[[21247,73552],[0,-101]],[[21247,73451],[0,-202],[16,0],[0,-290]],[[21263,72959],[-10,16],[-12,-18],[-18,19],[-33,-16],[-5,26],[-26,-13],[-14,-50],[5,-34],[-15,-27],[-26,-18],[-13,13],[-20,-35],[-23,60],[9,35],[-16,31],[-19,10],[-19,-34],[9,-41],[-10,-20],[-10,21],[-5,-76],[-15,25],[-4,-50],[-14,-19],[-13,34],[-11,-21],[-11,34]],[[20923,73268],[0,285]],[[28015,60474],[12,-60],[11,-20],[13,12]],[[28115,60439],[1,-84]],[[28116,60355],[-2,-205]],[[28114,60150],[-10,-19],[-24,3],[-23,-31]],[[28057,60103],[-11,7],[-9,55],[-9,21],[-10,-12],[-15,34],[-2,29],[-14,11],[3,52]],[[28737,62777],[32,-18],[18,24],[15,-5]],[[28804,62684],[1,-59]],[[28805,62625],[-14,-5],[-9,19],[-28,-23],[-19,2],[-17,-56],[6,-34],[-19,-65],[-12,-15]],[[28693,62448],[-12,-10],[-3,-52],[4,-31],[-12,17],[3,63],[-6,59],[-7,14],[16,136],[12,42],[-2,24],[14,25],[7,37],[24,-12],[6,17]],[[24583,63727],[1,107]],[[24694,63489],[-26,-8],[1,25],[-21,58],[-5,59],[-61,1]],[[24582,63624],[1,103]],[[28331,62595],[81,155]],[[28412,62750],[-5,-15],[16,-84],[16,-17],[17,-55],[4,-47],[30,-41]],[[28490,62491],[-29,-161],[-3,-32]],[[28458,62298],[-11,34],[-21,-70]],[[28426,62262],[-9,37],[-20,6],[-8,17],[1,48],[-23,36]],[[25293,58126],[-5,-449]],[[25288,57677],[-113,0]],[[25175,57677],[1,294]],[[23856,55376],[9,0]],[[23865,55376],[70,-1]],[[23935,55375],[0,-351],[14,0],[4,-96],[-2,-57]],[[23897,54668],[-19,0],[-1,102],[0,306],[-8,26],[6,45],[-8,122],[-8,10],[-6,47],[3,50]],[[28172,56904],[10,6],[2,41],[7,13],[9,-25],[30,32],[3,-36],[20,-76],[8,5]],[[28261,56864],[-15,-61],[-18,-95],[-14,-111],[-16,-161]],[[28198,56436],[-3,49],[4,66],[-1,110],[-5,36],[-1,94],[-16,68],[-4,45]],[[25362,70976],[0,-202]],[[25204,70504],[-16,15],[-20,-7],[-34,61]],[[25134,70573],[-16,27]],[[25118,70874],[0,102]],[[25258,60089],[8,7],[10,89],[-7,66],[-17,65],[-2,25],[9,65],[2,55],[18,43]],[[25279,60504],[0,1]],[[25279,60505],[15,-23]],[[25294,60482],[12,-8],[6,-73],[21,-73],[6,-62],[-6,-43],[7,-41]],[[25340,60182],[-10,-77],[1,-62],[5,-33],[-9,-21]],[[25327,59989],[-19,78],[-16,18],[-17,-16],[-15,-32]],[[25260,60037],[-13,14],[-10,51]],[[16039,61284],[-2,30],[14,37],[2,49],[13,70],[15,1],[5,-27],[18,-4],[21,28],[13,-9],[14,13],[30,51],[11,1]],[[16201,61437],[16,-160],[4,-12]],[[16069,60571],[-9,52],[-15,19],[0,319]],[[16045,60961],[6,39],[-12,13],[6,83],[-7,60],[7,38],[-8,22],[2,68]],[[25134,60276],[2,-2]],[[25260,60037],[-1,-94]],[[25168,59949],[-1,8]],[[25167,59957],[-33,319]],[[27230,55057],[20,28],[3,23],[19,59],[-5,62],[11,17],[0,39],[44,100]],[[27322,55385],[23,-111],[3,-35],[24,-79],[21,-150]],[[27266,54838],[-11,3],[-19,42]],[[27236,54883],[-8,40],[7,28],[-4,48],[-6,8],[5,50]],[[22913,65531],[0,-333]],[[22913,65198],[-31,-50],[-45,-43],[-21,9]],[[22816,65114],[0,418]],[[31828,37522],[7,36],[-4,40],[7,30],[10,-13],[8,22],[17,3],[6,-29],[39,5],[2,-18],[-32,-48],[-41,-30],[-19,2]],[[18762,70252],[28,-2],[12,43]],[[19047,70711],[-3,-237],[1,-236],[-2,0],[0,-227],[-17,0],[0,-77],[-17,0],[0,-202],[-33,0],[0,-204],[-2,-203]],[[18971,68934],[2,-223]],[[18973,68711],[-21,23],[-6,49],[-24,59],[2,43],[-28,117],[-15,32]],[[18881,69034],[1,697],[7,0],[-1,339],[-51,1],[-17,67],[-12,16],[-6,34],[-17,0],[0,34],[-23,30]],[[25405,58661],[14,-3],[16,-40],[10,38],[28,3]],[[25473,58659],[-7,-204],[23,-63]],[[25473,58245],[-24,2],[-52,-37],[-5,-35]],[[25392,58175],[-10,25],[15,44],[4,37],[-17,125],[5,45],[-4,66],[12,52],[5,63]],[[17519,67126],[80,1],[1,556]],[[17875,67994],[-9,-41],[-6,-90],[9,-35],[-7,-50],[0,-63],[-13,-17],[-1,-473]],[[17861,66892],[0,-167]],[[17861,66725],[-116,0],[0,97],[4,-1],[0,94],[-17,-5],[-8,18],[-21,-6],[-5,21],[-20,-19],[-21,-1],[-6,40],[-15,-4],[-25,38],[-10,-37],[2,-31],[-13,7],[-11,42],[-26,32],[1,25],[-17,17],[3,39],[-21,35]],[[21278,66343],[7,0],[-1,-97],[3,-208],[0,-100],[11,1],[1,-103]],[[21299,65836],[-46,-4],[-139,2]],[[21114,65834],[-11,1]],[[21103,65835],[0,101],[-12,0],[0,404]],[[30024,65813],[5,1],[79,128]],[[30174,65398],[-3,-54],[-4,51],[-12,-7],[-7,-49],[2,-44],[-6,-29],[-25,-23],[-12,17],[-10,-14]],[[30076,65453],[-8,41]],[[30068,65494],[-10,48],[-16,28]],[[30042,65570],[-8,61],[2,81],[-12,-6],[0,107]],[[25465,61657],[-9,-51],[-8,-9],[-13,-102],[-8,33],[-7,-41],[-5,35],[-9,-68],[-8,19]],[[25398,61473],[-1,4]],[[25397,61477],[11,36],[-7,127],[9,65],[-3,133]],[[26651,59889],[22,-6],[3,35],[21,23],[18,33],[8,40],[14,21]],[[26737,60035],[16,-23]],[[26753,60012],[-8,-52],[32,32],[27,37],[20,-49]],[[26824,59980],[3,-54],[-6,-40]],[[26821,59886],[-25,-41],[-29,-4],[-16,-80],[-2,-50],[-16,-4],[-33,-35],[-33,-50],[-8,-2]],[[26659,59620],[0,38],[-11,42],[4,58],[-7,28],[8,49],[-2,54]],[[25578,58450],[30,76],[5,147]],[[25613,58673],[50,-64],[53,-83],[18,-21]],[[25734,58505],[-9,-12],[-4,-133],[-6,-66],[-21,-72],[-9,-14],[-1,-40]],[[25615,58187],[-24,13]],[[23795,52330],[71,1],[0,102],[28,0],[0,-102],[71,0]],[[23965,52331],[0,-27],[28,0],[0,-139],[9,1],[0,-121],[29,-1],[-4,-51],[6,-34],[-31,-1],[0,-51]],[[23805,52146],[-1,52],[-16,52],[2,66],[5,14]],[[27751,58664],[85,1],[-4,38]],[[27928,58693],[-25,-300],[22,-31]],[[27925,58362],[-15,-72]],[[27910,58290],[-13,26],[-10,60],[-18,38],[-9,-11],[-14,-70],[-12,12],[-9,-44],[-3,28],[-18,-44]],[[27804,58285],[-57,-3]],[[22216,50280],[3,0]],[[22220,49772],[-201,-8]],[[22019,49764],[0,524]],[[26804,60844],[-2,-44],[12,-44],[4,-88],[-2,-65],[-8,-26]],[[26802,60596],[-20,54],[2,40],[-8,1],[-14,55],[-12,-29],[-11,41],[-21,32]],[[26718,60790],[-4,50]],[[26714,60840],[6,37],[-8,29],[12,24],[5,34],[27,52],[-5,36],[20,-29],[7,19],[8,-31]],[[18780,64505],[-36,-46],[-21,1],[-7,75],[3,41],[-14,-1],[-39,-87],[-31,-90]],[[18635,64398],[-65,358]],[[18570,64756],[86,89],[60,-1],[16,-20],[16,5]],[[18563,61769],[110,2],[17,-12],[83,0]],[[18773,61759],[-23,-90],[1,-318]],[[18751,61351],[-60,-7],[-107,5]],[[18584,61349],[5,36],[19,51],[-6,23],[8,44],[4,59],[-19,96],[-11,-11],[-3,27],[-18,59],[0,36]],[[26927,61111],[7,-53],[15,-19],[-1,-34]],[[26948,61005],[13,-61],[10,-19],[2,-52]],[[26973,60873],[-12,-2],[-10,-31],[7,-18],[-5,-30],[-14,-3],[-18,30],[-12,-11]],[[26909,60808],[-22,41]],[[24355,67981],[124,0]],[[24479,67981],[11,-86],[-3,-55]],[[24498,67577],[-110,0]],[[24355,67578],[0,403]],[[15703,70313],[18,20],[-5,55],[5,20],[17,-5],[28,30],[7,30],[16,10],[29,-32],[11,5],[1,53],[16,57],[7,-6]],[[15853,70550],[-1,-274],[0,-315]],[[15852,69961],[-23,0],[-13,32],[-17,-14],[-11,19],[-46,35],[-33,54],[0,84]],[[25383,67626],[69,1]],[[25452,67627],[-4,-95],[-20,-107],[-9,-139],[5,-68]],[[25424,67218],[-47,0]],[[25377,67218],[0,204],[6,0],[0,204]],[[18552,70796],[-3,46],[20,43],[12,-15],[14,67],[15,-1],[11,41]],[[18762,70252],[-11,27],[-19,10],[-5,32],[-15,-13],[-11,15],[-23,-21],[-8,-81],[-15,-27]],[[18655,70194],[-7,20],[-56,83],[3,60],[-9,61],[-2,108],[-8,7],[2,62],[-15,51],[4,56],[-20,-7]],[[18547,70695],[-6,68],[11,33]],[[26600,58891],[5,5],[36,-91],[14,-48],[16,12],[30,-44]],[[26716,58493],[-16,-48],[-10,7],[-5,-26],[-22,-32],[-11,-50],[-27,-7],[-6,20],[-16,-12]],[[26603,58345],[0,141],[-12,25],[-25,204]],[[26566,58715],[35,87],[-1,89]],[[31509,38018],[-10,-59],[2,-27]],[[31504,37854],[-24,-43],[-10,9],[-7,-25]],[[31463,37795],[3,113],[11,44]],[[17430,64667],[119,0],[0,-389],[44,-627],[46,0]],[[17639,63651],[3,-87],[-2,-59],[8,-106],[2,-66],[-5,-45],[1,-60],[-6,-42],[5,-163],[-5,-21],[-3,-71],[-7,-43],[-11,-16],[0,-345]],[[17619,62527],[-193,0]],[[17426,62527],[2,274],[-2,788],[2,286],[-1,729],[3,63]],[[24078,55074],[24,0],[19,-12],[7,-36],[7,3],[0,-58],[29,-1],[0,-101]],[[24164,54869],[0,-102]],[[24164,54767],[-58,1],[1,-51],[-44,1]],[[24034,54871],[6,42],[-2,66],[11,43],[0,51],[29,1]],[[24078,55371],[183,-7]],[[24261,55364],[-5,-50],[0,-97],[8,-52],[-2,-133]],[[24262,55032],[-7,-41],[-37,-90],[-1,-24],[-13,-11],[-40,3]],[[24078,55074],[0,297]],[[29982,67881],[77,-221],[26,-38]],[[30085,67622],[-8,-28],[9,-186],[-21,-81]],[[30065,67327],[-88,194],[-14,-20],[-10,66],[-11,10],[-14,74]],[[29928,67651],[-1,31],[12,5],[10,31],[1,74],[35,15],[-3,74]],[[24283,55818],[8,-24],[-8,-43],[3,-45],[-18,-28],[-26,-95],[-1,-39]],[[24241,55544],[-23,54],[-1,51],[-28,11],[-7,42]],[[24182,55702],[-8,19],[1,74],[16,105],[2,39],[-5,133],[3,76],[-3,30]],[[21676,64315],[27,0]],[[21703,64315],[131,3]],[[21834,64318],[-1,-52],[1,-357]],[[21682,63911],[-5,0]],[[28476,64246],[22,85],[0,81],[17,113]],[[28515,64525],[0,4]],[[28515,64529],[-15,36],[-8,65],[6,121],[-8,34],[-2,44]],[[28488,64829],[4,22],[26,20],[15,-4]],[[28533,64867],[0,-93],[-12,-98],[-4,-71],[36,24],[17,-30],[12,-4],[-3,-27],[11,-38]],[[28590,64530],[7,0],[1,-67],[25,10],[9,-68]],[[28632,64405],[-90,-130],[0,-6]],[[28542,64269],[-13,-6],[-47,-58],[-9,29]],[[28473,64234],[3,12]],[[28682,62165],[10,33],[17,4],[-4,36],[7,36],[40,-30]],[[28729,61841],[-15,61],[-17,14],[-8,42],[-7,-3],[-16,77],[-5,-28],[-12,20],[-1,-59],[-7,8],[3,101],[18,92],[14,-45],[8,10],[-2,34]],[[28627,62072],[5,20],[5,-46],[-10,26]],[[23336,67292],[132,0]],[[23468,67292],[0,-402]],[[23468,66890],[-132,0]],[[26313,57963],[10,31],[42,-1],[6,22]],[[26371,58015],[38,-61],[4,-34],[14,3]],[[26427,57923],[-8,-254]],[[26292,57668],[12,109],[-4,5],[14,101],[-1,80]],[[23004,62998],[95,0]],[[23099,62998],[56,0]],[[23155,62591],[-1,-105]],[[23154,62486],[-12,78],[-26,-6],[-15,27],[-11,-38],[-10,21],[-7,-44],[-16,16]],[[23057,62540],[-20,20],[0,-25],[-26,12],[-2,73],[-22,59],[-2,39],[-22,90],[5,68],[11,16],[7,51],[18,55]],[[28590,62619],[-13,27],[3,-46],[9,-21]],[[28589,62579],[-14,1],[-10,35]],[[28565,62615],[-26,47],[0,110],[51,0],[0,-153]],[[30343,68693],[10,22],[20,11]],[[30373,68726],[8,-120],[-9,-15],[16,-85],[0,-107],[23,-30],[-9,-58],[6,-7]],[[30400,68131],[-13,-58],[-11,-21],[-22,44],[-33,106],[-13,-59],[-11,4],[-22,49]],[[30275,68196],[-1,33],[42,175],[3,-3],[16,180],[-2,91],[10,21]],[[25494,62522],[19,71],[-8,48]],[[25505,62641],[101,-1]],[[25606,62640],[0,-101]],[[25526,62231],[4,55],[-18,40],[1,79],[-16,55],[-3,62]],[[25047,57095],[0,102]],[[25047,57197],[0,17],[44,1]],[[25189,57213],[0,-102]],[[25189,57111],[-15,-17],[0,-117],[-10,0],[0,-34]],[[25164,56943],[-28,0],[-1,17],[-88,0]],[[25047,56960],[0,135]],[[23468,67577],[-132,0]],[[18660,64046],[8,4],[8,-36],[21,29],[16,-58],[10,12],[17,55],[13,4],[21,63],[22,2],[13,43],[12,10]],[[18821,64174],[7,-34],[-2,-71],[-13,-43],[19,-97],[20,-5],[12,-47],[-1,-37],[19,8],[17,-12],[14,-51],[-3,-24],[13,-64],[2,-49],[-8,-81],[12,-9],[11,-66],[13,-26],[-3,-25],[13,-4],[0,-51],[53,0]],[[19016,63386],[10,0],[0,-101]],[[19026,63285],[-109,0]],[[18917,63285],[-110,0]],[[18807,63285],[-34,-3],[8,62],[-25,98],[-2,-27],[-21,-35],[-17,-102],[-21,-35],[-12,6],[6,55],[-4,42],[8,33],[-14,41],[-2,52],[-19,44]],[[18658,63516],[-1,56],[9,56],[-7,54],[8,22],[-1,45],[-12,61],[-1,72],[6,12],[-7,54],[-4,84],[12,14]],[[27360,60964],[38,58]],[[27438,60862],[1,-20],[-55,-333]],[[27384,60509],[0,1]],[[27318,60696],[9,26],[-1,36],[33,85],[19,-38],[-5,54],[-7,15],[8,29],[-14,61]],[[18917,63285],[0,-127]],[[18917,63158],[0,-276],[-15,0],[1,-201],[0,-305]],[[18903,62376],[-154,1],[0,15],[-45,0]],[[18704,62392],[-1,313]],[[18703,62705],[0,26],[16,0],[0,34],[10,18],[49,1],[0,90],[10,0],[-2,273],[37,53],[0,51],[-10,0],[-6,34]],[[25147,67732],[135,-3],[1,-101]],[[25283,67628],[-1,-202],[-4,0],[0,-205]],[[25245,67223],[-132,2]],[[25113,67225],[0,101]],[[25113,67326],[1,101],[0,305]],[[22824,69669],[61,0],[4,34],[145,0]],[[23034,69703],[5,-67]],[[23039,69297],[-119,-1]],[[22824,69500],[0,169]],[[28143,63695],[15,-37],[43,-37],[17,-47]],[[28218,63574],[-15,-67],[-23,-206],[-27,-121]],[[24066,69162],[109,1],[67,-6]],[[24242,69157],[0,-201]],[[24242,68956],[0,-169],[-50,2]],[[24192,68789],[-6,15],[-27,13],[-30,2],[-9,44],[-14,16],[1,24],[-31,87]],[[24076,68990],[-20,37]],[[24056,69027],[-1,26],[12,80],[-1,29]],[[19087,72136],[118,0]],[[19205,72136],[0,-67],[24,0],[0,-101],[36,0],[0,-51],[35,1],[1,-51],[32,0],[0,-337],[-12,-34],[0,-42],[-10,0],[1,-33],[21,-26],[3,-100]],[[19083,71446],[5,16],[-3,301],[-35,0],[1,161],[-6,17],[0,68],[6,-12],[0,72],[36,0],[0,67]],[[27371,57771],[18,-87]],[[27389,57684],[16,-76],[-4,-135],[66,-3]],[[27509,57234],[-39,-64],[6,-65],[-6,-13],[-18,8],[-12,-25],[-9,43],[-14,-41],[-1,70],[-38,-96]],[[27378,57051],[-5,34],[6,66]],[[28280,61164],[35,133],[41,165]],[[28356,61462],[12,-2]],[[28427,61349],[2,-28],[-10,-6],[-7,-48],[22,-77],[5,-57]],[[28439,61133],[-22,9],[-9,-26],[0,-68]],[[28363,60929],[-15,-14],[1,30],[-9,31],[1,41],[-6,35],[-11,-13],[-12,43],[-5,-5],[-9,49],[-9,-5],[-9,43]],[[20688,66540],[66,0]],[[20754,66540],[0,-1113]],[[20754,65427],[-174,4]],[[23996,69196],[10,4],[-1,267],[-10,0]],[[23995,69467],[1,202]],[[23996,69669],[76,-2]],[[24072,69667],[-4,-5],[1,-95]],[[24069,69567],[-3,-28],[6,-91],[-16,-58],[11,-34],[-2,-65],[6,-41],[-7,-42],[2,-46]],[[24056,69027],[-14,2],[-8,31],[-13,9],[-21,-12],[-4,139]],[[25029,60021],[12,-18],[3,25],[-15,45],[14,12],[17,-56],[8,-53],[11,14]],[[25079,59990],[9,-45]],[[25088,59945],[-11,-112],[-10,-9],[-1,-38],[15,-26]],[[25081,59760],[-1,-39],[-16,3],[-4,-44],[9,-36],[-2,-40]],[[25067,59604],[-11,-82],[-13,-18],[-19,78]],[[25024,59582],[-13,83],[-15,50],[-15,101],[-10,43]],[[24971,59859],[5,42],[10,0],[0,35],[10,-1],[5,34],[10,1],[0,34],[18,17]],[[28884,64451],[27,21],[26,39],[18,72],[28,47]],[[28983,64630],[6,-52],[13,-62],[-23,-113],[-11,5],[-9,-100],[8,-22],[-7,-30],[1,-45]],[[28923,64128],[-19,51],[7,40],[-15,68],[-14,-21],[-14,94],[-7,-18],[-10,16],[-5,61]],[[23878,54010],[0,-152],[29,0],[0,-206],[28,1],[0,-203]],[[23935,53450],[-43,0],[-14,-102],[-26,0],[-5,-45],[0,-61]],[[23847,53242],[-13,-11]],[[23834,53231],[-6,111],[-6,-2],[-12,47],[6,53],[-3,49],[-8,15],[1,32],[-14,36],[6,27],[-3,35],[-13,6],[-13,68]],[[23769,53708],[5,43],[-3,45],[7,42],[-8,56],[2,34],[-15,55],[-1,26]],[[26023,60208],[16,15]],[[26039,60223],[15,-67],[29,-18]],[[26083,60138],[7,-119],[17,-62],[-3,-19]],[[26024,59826],[-5,312],[-5,33],[9,37]],[[19140,55581],[0,-786],[-1,-7]],[[18651,54780],[0,936],[3,-53],[12,-13],[18,-58],[140,1],[1,303],[150,1]],[[19265,60008],[0,-1554],[48,-1],[0,-168],[-5,0],[1,-404],[-1,-405],[-2,0],[1,-204],[-5,-102],[5,-83],[0,-422],[-3,0],[0,-406],[-9,1],[0,-245]],[[19295,56015],[-30,11]],[[17950,55027],[5,31],[24,-13],[25,26],[-2,40],[18,63],[1,79],[-5,26],[-9,107]],[[18336,55794],[0,-1016]],[[18336,54235],[-44,59],[-368,471],[5,66],[-5,17],[1,60],[8,16],[17,103]],[[23962,70173],[83,0]],[[24045,70173],[-6,-9],[-6,-91]],[[24033,70073],[0,-76],[21,-21],[10,9],[14,-32],[-1,-31],[23,-85],[-1,-50],[-15,-47],[1,-29],[-13,-44]],[[23996,69669],[0,133]],[[24940,59062],[40,3],[1,29]],[[24981,59094],[92,-9]],[[25020,58708],[-18,76],[-23,2],[-7,-23],[-32,-5],[-4,-23]],[[26455,61607],[25,102]],[[26480,61709],[26,-31],[8,8]],[[26514,61686],[9,-19],[9,-73],[12,2],[11,-55],[-4,-21]],[[26551,61520],[-36,-122]],[[26515,61398],[-3,31],[-11,-5],[-10,24],[2,25],[-11,3],[-20,112],[-7,19]],[[23654,67982],[133,0]],[[23821,67576],[-90,0]],[[23731,67576],[-77,1]],[[26635,60400],[27,51],[13,-47],[6,0],[14,48],[17,23],[15,52],[5,-34],[21,-11]],[[26787,60238],[-16,-83],[4,-72],[-8,-23],[5,-29],[-19,-19]],[[26737,60035],[4,95],[-17,40],[7,44],[-15,34],[-19,25],[-8,82],[-13,29],[-17,-32],[-13,-67]],[[26646,60285],[-6,26]],[[23517,56176],[8,-22],[17,1],[1,-23],[16,13],[19,-73],[9,25]],[[23710,55996],[1,-11],[0,-284]],[[23711,55701],[-14,9],[-13,-14],[-8,20],[-14,-16],[-6,-28],[2,-37],[-41,17],[-10,33],[-29,-2],[-3,-18],[-25,-23],[-9,25]],[[23541,55667],[-11,51],[-11,-4],[-5,23]],[[23514,55737],[1,436],[2,3]],[[20647,69323],[158,-2],[115,-1]],[[20921,68369],[-89,1],[-196,-6]],[[20636,68364],[-1,4],[-1,405],[0,302],[3,-1],[0,249]],[[27489,56715],[14,67],[-2,67],[24,22],[-3,43],[10,-1],[11,29]],[[27623,56574],[-7,-46],[-13,-1],[-30,-65],[-2,62],[-18,-15],[-5,50],[-7,5],[-8,48],[-23,1],[-21,36],[0,66]],[[20754,66540],[168,3]],[[20922,66543],[0,-710]],[[20922,65833],[0,-354]],[[20922,65479],[0,-155]],[[20922,65324],[-167,0],[-1,103]],[[30179,66140],[13,-16]],[[30085,66184],[2,31]],[[29997,66013],[14,27],[24,24],[3,57],[8,-1],[-7,76],[16,17],[12,-11],[10,-42]],[[30133,66195],[1,-53],[9,20]],[[30024,65813],[0,40],[-32,-2]],[[29992,65851],[1,96],[4,66]],[[26040,60863],[12,-42],[13,-3],[-2,-63],[7,-1],[-14,-101],[17,-34],[3,36],[9,1]],[[26085,60656],[5,-6],[10,-98]],[[26100,60552],[-9,21],[-8,-34],[-16,18]],[[26067,60557],[-14,3],[-6,-58]],[[26047,60502],[-66,21]],[[18664,68226],[34,0],[0,101],[34,0],[0,50],[15,0],[2,151],[17,0],[0,98],[48,0],[0,172]],[[18852,68984],[19,2],[10,48]],[[18973,68711],[-1,-140],[1,-431]],[[18973,68140],[-18,-18],[-21,-42],[-14,19],[-20,-34],[-12,33],[-13,-29]],[[18875,68069],[-7,-14],[-15,20],[-15,-10],[-7,-42],[-39,0],[0,17],[-39,0],[0,34],[-39,0]],[[26252,56614],[-16,-152],[-20,1],[0,-56]],[[26122,56404],[-3,72]],[[21996,66993],[0,-177]],[[21815,65933],[-161,5]],[[21654,65938],[-162,5]],[[21492,65943],[-9,0],[0,404],[-8,0],[0,398],[-5,0],[1,249]],[[26502,56231],[12,38]],[[26514,56269],[18,-49]],[[26496,55966],[-1,18],[-21,24],[-17,98]],[[17570,55850],[171,1],[8,2],[227,6]],[[17950,55027],[-208,-60],[-178,-57]],[[17564,54910],[0,531],[7,0],[-1,409]],[[17303,72789],[0,79]],[[25560,63651],[-9,43],[5,32],[17,22],[31,114],[32,37],[11,30]],[[25647,63929],[0,-176]],[[25647,63753],[0,-305]],[[25556,63447],[-4,86],[5,38],[3,80]],[[25880,58162],[4,107],[-1,149]],[[25883,58418],[0,66],[11,18]],[[25894,58502],[17,-49],[30,-22],[15,20]],[[25956,58451],[8,-47],[2,-54],[20,-58]],[[25986,58292],[-4,-93],[3,-111],[-7,-21],[-2,-48]],[[25976,58019],[-18,33],[-7,-3],[-10,33],[-34,22],[-28,-33]],[[25879,58071],[4,16],[-10,46],[7,29]],[[25983,58660],[38,12],[19,-22]],[[26040,58650],[22,-42]],[[26062,58608],[-3,-40],[6,-8],[-4,-53],[3,-105],[11,-99]],[[26061,58301],[-27,-3],[-33,-28],[-15,22]],[[25956,58451],[-4,60],[23,129],[8,20]],[[26868,60343],[11,25],[5,52],[-4,21],[13,20],[9,69],[-3,66],[-7,1],[7,161],[-4,33],[14,17]],[[26973,60873],[11,-82],[15,-11],[7,-42],[9,2],[7,-40],[8,-1],[3,-37],[28,-30],[14,4]],[[27075,60636],[-97,-281]],[[26978,60355],[-11,-36],[-37,-39],[-18,-33]],[[26912,60247],[-4,-8]],[[26908,60239],[-17,60],[-12,-24],[-17,51]],[[26518,61094],[24,-30],[18,-6],[13,21]],[[26573,61079],[5,-26],[33,-82]],[[26611,60971],[-21,-127]],[[26586,60844],[-15,47],[-12,-13],[-3,23],[-21,-7],[-16,48],[0,52],[-11,-9]],[[26508,60985],[3,94],[7,15]],[[26010,67234],[0,-203],[2,-136],[0,-170]],[[26012,66725],[-119,-1]],[[25893,66724],[0,107],[-6,182],[-11,120]],[[25794,59584],[16,22],[27,-2]],[[25837,59604],[57,-13]],[[25894,59591],[-6,-177]],[[25873,59251],[-5,-41],[-17,-1],[4,21],[-9,25],[-3,-48],[-17,30],[-18,-43],[-8,26],[-14,-88]],[[25786,59132],[-13,11],[0,39],[-22,63],[-10,73]],[[25741,59318],[2,16],[15,-14],[12,74],[5,74],[19,116]],[[27602,57849],[15,-7],[11,25],[23,4],[14,25],[28,-12],[21,2],[17,-13]],[[27731,57873],[11,-48],[-1,-61],[21,-7],[12,-24]],[[27774,57733],[-32,-60],[-3,-43],[6,-52],[-18,-68],[1,-29],[-19,-26]],[[27709,57455],[-66,2]],[[27643,57457],[7,56],[15,56],[-6,58],[1,35],[-9,25],[6,36],[-9,37],[-4,57],[-6,3],[-13,-38],[-21,30],[-2,37]],[[21093,52637],[243,-714]],[[21336,51923],[68,-202]],[[21404,51721],[-8,-19],[-10,-111],[-34,19],[-9,-37],[-7,11],[-22,-32],[-7,10],[-8,-54],[2,-23],[-13,-40],[0,-50],[-7,0],[-2,-59],[-11,-30],[1,-33],[-7,-58],[2,-52],[-5,-48],[-10,-5],[-3,-72],[-5,-37],[10,-22],[-5,-38],[-18,-38],[-10,8],[-7,-67],[-17,-43],[-7,-36],[-4,-84],[-14,-8],[-17,15],[-15,-11],[-14,46],[-27,24],[-27,111],[-24,33],[-10,-8],[-22,38],[-19,79]],[[20994,51000],[-2,1342]],[[19998,68811],[228,-4],[34,6],[117,2]],[[20377,68815],[-2,-50],[0,-409],[2,-405],[-3,0],[0,-380]],[[20070,67577],[-1,368],[-4,0],[0,407],[-5,0]],[[20060,68352],[0,184],[-12,28],[8,24],[-11,36],[-1,55],[-11,-10],[-17,30],[3,43],[-21,69]],[[24033,70073],[99,-3],[1,101],[104,-3],[0,-100]],[[24237,70068],[-1,-501]],[[24236,69567],[-167,0]],[[24236,69567],[0,-102],[6,-1],[0,-307]],[[21214,59429],[234,0]],[[21448,58911],[-244,0]],[[28379,64310],[38,-19],[11,17],[5,-18],[16,1],[8,-40],[19,-5]],[[28473,64234],[-21,-28],[-44,-26],[4,-26],[-34,-48],[-70,-139],[3,-27],[-10,-10],[-29,-90]],[[28272,63840],[-9,-31]],[[28263,63809],[-14,134]],[[28249,63943],[39,131],[0,27],[32,79],[0,32],[36,68],[23,30]],[[25526,65014],[0,200]],[[25526,65214],[1,277]],[[25527,65491],[15,-41],[12,20],[7,-15],[-6,-40],[27,-23],[29,1]],[[25611,65393],[1,-445]],[[25612,64948],[-16,-27]],[[25596,64921],[-14,-38],[-25,-27],[-7,13],[-24,-9]],[[25526,64860],[0,154]],[[28659,65105],[17,192]],[[28676,65297],[6,124],[23,4]],[[28705,65425],[8,-8],[103,-3]],[[28816,65414],[-16,-79],[-7,-59],[8,-23],[-17,-89]],[[28784,65164],[-48,-50],[-77,-9]],[[23553,62390],[0,81]],[[23553,62471],[24,41],[11,-4],[6,-29],[17,54],[3,31],[6,-35],[22,85],[9,0],[12,-34]],[[23691,62242],[-2,-98]],[[23689,62144],[-103,10],[-33,7]],[[23553,62161],[0,229]],[[27478,64812],[73,4],[0,-13],[31,-4],[14,-51]],[[27596,64748],[-19,-81],[2,-169]],[[27478,64494],[0,57]],[[27478,64551],[0,261]],[[27478,65236],[110,-10],[35,11]],[[27623,64867],[-27,-119]],[[27478,64812],[0,10]],[[27478,64822],[1,88],[-1,326]],[[28651,65028],[8,77]],[[28784,65164],[1,-38],[25,-54],[15,-10],[2,-87],[7,-8],[3,-95],[12,-17]],[[28849,64855],[-14,-46]],[[28738,64565],[-8,-12],[-50,55]],[[28680,64608],[-6,119],[0,101],[-14,-8],[-12,93],[3,115]],[[24456,65159],[-32,1]],[[24327,65262],[1,104],[-1,304]],[[23974,64854],[0,-306]],[[23846,64548],[0,306]],[[22202,60010],[127,0]],[[22459,59386],[1,-77],[-26,-6],[-21,28],[-7,34],[-23,18],[-10,53],[-32,0]],[[22341,59436],[0,108],[-15,48],[-14,87],[-6,7],[-15,72],[-31,2],[-13,40]],[[22247,59800],[-5,43],[-17,27],[-23,140]],[[22161,59536],[86,3],[0,261]],[[22341,59436],[-1,-302],[2,-100]],[[22342,59034],[-119,4]],[[22223,59038],[-60,-1],[1,97],[-3,-1],[0,403]],[[20571,56922],[117,0]],[[20688,56621],[-1,-307],[1,-3],[0,-493],[2,-108],[-5,0],[-1,-194],[-56,-8],[-58,0]],[[20275,55913],[0,210],[30,0],[30,-12],[30,0],[0,204],[35,0],[0,506]],[[21467,71629],[-14,0],[0,34]],[[21453,71663],[0,370],[-17,0],[1,287]],[[19902,55909],[0,390],[-1,16],[0,506],[-2,0],[0,370]],[[25646,64158],[91,-1]],[[25737,64157],[21,0],[0,-151]],[[25758,63752],[-111,1]],[[25647,63929],[0,127]],[[25350,59856],[43,50],[35,58]],[[25428,59964],[6,-11],[26,28],[9,32]],[[25469,60013],[20,-42],[-3,-102],[-1,-143],[-6,-138]],[[25479,59588],[-44,-4],[1,35],[-61,17]],[[25375,59636],[-12,80]],[[25363,59716],[-13,140]],[[27774,57733],[17,-56],[12,-60],[2,-123]],[[27805,57494],[-3,-21],[6,-62],[-35,-159]],[[27773,57252],[-59,203],[-5,0]],[[25197,61015],[-123,-1]],[[25074,61014],[0,103],[-8,0]],[[25066,61117],[9,41],[7,86],[-2,76]],[[25290,61068],[66,-1],[13,-19]],[[25357,60679],[-13,29],[-54,0]],[[24669,62475],[-3,53],[6,42],[-5,71],[2,38],[-5,85],[2,35]],[[26900,56534],[18,68],[13,11],[9,-25],[35,5]],[[27053,56464],[-31,-28],[0,-49],[12,-67],[-16,-74],[-3,-49],[5,-39],[19,-66],[-5,-43]],[[27034,56049],[-10,1],[-13,38],[-6,65]],[[27005,56153],[-8,77],[-29,98],[-29,52],[-19,72],[-11,15]],[[26909,56467],[-9,67]],[[26828,57227],[2,12]],[[26832,57244],[-4,118],[-13,20],[5,58],[-4,13],[-5,197],[-8,19],[13,79]],[[28113,60814],[-50,58],[-12,23],[-8,43]],[[27451,56634],[10,1],[28,80]],[[27474,56104],[-22,79],[-2,36]],[[27450,56219],[7,51],[-10,77],[3,94],[-7,77],[13,46],[-10,51],[5,19]],[[28593,61215],[14,-25],[15,-54],[20,-23],[30,-68],[-5,-65],[-15,-24],[-4,-153]],[[28648,60803],[-15,36],[3,66],[-10,14],[-8,56],[-11,-7],[-11,19]],[[28561,61136],[5,40],[12,30],[15,9]],[[26528,61748],[20,-42],[60,80]],[[26661,61619],[-13,-37],[3,-30],[-5,-64],[-36,-95]],[[26610,61393],[-16,25],[1,29],[-15,59],[-16,-6],[-13,20]],[[26514,61686],[14,62]],[[26405,59099],[20,5],[18,-50],[2,77],[35,-23],[9,7],[11,83],[7,-37]],[[26507,59161],[10,-70],[8,-28]],[[26525,59063],[-42,-131],[9,-43],[-25,-58],[-13,7],[-11,-71],[-10,10],[0,-35]],[[26433,58742],[-14,95],[-6,66]],[[26413,58903],[-10,54],[-11,16],[-9,38],[3,26]],[[18425,72968],[233,-1],[0,-50],[36,-1],[0,-51],[18,0],[0,-68],[160,3]],[[18872,72800],[0,-336]],[[18872,72464],[-71,-1],[0,-100],[-72,0],[0,-124],[-35,13]],[[20458,60006],[138,-1]],[[20596,60005],[-4,-38],[10,-55],[-8,-79],[-2,-66],[2,-78],[-23,-1],[-4,-29],[-12,-20],[5,-51],[-7,-33],[7,-55],[-7,-11],[16,-70],[-10,-46],[8,-55],[-4,-167]],[[20563,59151],[-19,-29],[3,-53],[-7,-25],[1,-44],[-19,-110],[-12,-28]],[[26048,65010],[0,-136],[-9,0],[0,-153]],[[21494,70549],[17,15],[12,-11],[13,19],[2,-51],[24,15],[26,-35],[11,29],[8,-32],[11,-3],[5,28],[11,-9],[31,65],[6,-10],[18,40],[-1,33],[31,18],[-2,41],[27,54],[4,53],[17,10]],[[21887,70985],[8,-54],[3,-61],[-9,-55],[6,-37],[-4,-47],[-15,-74],[4,-86],[15,-74],[15,-49],[-2,-27]],[[21908,70421],[-211,1],[-203,0]],[[21494,70422],[0,127]],[[26148,59575],[5,1]],[[26153,59576],[3,-62],[-5,-49]],[[26151,59465],[-15,-4],[-15,-27],[-15,-8],[-10,-51],[-4,-59]],[[26092,59316],[-22,79],[-34,29],[-2,30],[-18,-6],[-13,-20]],[[26003,59428],[7,142]],[[23711,55701],[0,-324]],[[23711,55377],[0,-161]],[[23711,55216],[-171,-2]],[[23540,55214],[1,453]],[[30177,69643],[15,-299],[-12,-5],[5,-103],[9,-100],[1,-125],[43,74],[29,-196],[-11,-19],[75,-48],[0,-75],[8,-2],[4,-52]],[[30275,68196],[-8,11],[-9,-42],[-15,31],[-3,81],[6,26],[-11,55],[-55,-109],[-10,21],[3,-53],[15,-11],[22,-92],[-12,-64],[4,-24],[-15,-26],[4,-57]],[[30134,67917],[-6,574]],[[30107,69679],[21,15],[0,33],[25,-41],[-1,-38],[7,-43],[11,-15],[7,53]],[[26610,61393],[12,-22],[-8,-23],[27,-35],[-3,-28],[20,-18],[-10,-34]],[[26648,61233],[-21,10],[1,-41],[-11,-19],[-13,24],[-28,-34]],[[26576,61173],[-12,50],[-5,46],[-17,64],[-26,26],[-1,39]],[[27604,58271],[-32,-2]],[[27572,58269],[-7,89],[-34,114],[-1,49],[-11,-4],[-24,30]],[[27495,58547],[3,27],[-11,78],[16,-4],[2,26],[11,3],[-9,30],[13,6],[-2,89],[-5,13]],[[30441,67899],[-12,4],[-15,-42],[-5,-39],[-20,4],[-7,-49],[-20,4],[-10,-49],[-3,-50],[5,-29],[-8,-32],[-13,29],[-22,-32]],[[23619,68467],[23,-29],[21,-45],[28,-23],[19,-31],[12,17],[-6,61],[3,21]],[[28480,59670],[6,58],[10,36],[4,74],[10,33],[0,30],[-12,58],[3,47]],[[28501,60006],[42,73],[7,97]],[[28550,60176],[5,-120],[22,-19],[25,-82],[1,-27]],[[28603,59928],[-13,-15],[-61,-191],[-42,-126]],[[28487,59596],[-3,5]],[[19531,66138],[168,-1],[256,-2]],[[19955,66135],[0,-202],[5,0],[-1,-501],[-117,-4],[0,-297],[3,0],[0,-462]],[[19845,64669],[-73,-2],[-242,0]],[[19251,64664],[1,676]],[[17928,71964],[6,-50],[18,0],[0,-51],[17,-17],[6,-51],[12,0],[6,-65],[23,0],[0,-52],[18,0],[-9,-35],[-21,19],[-11,-54],[0,-151],[5,0],[-1,-100],[-35,0],[0,-12]],[[17962,71345],[-25,-47],[-6,17],[6,55],[-34,58],[-16,59],[4,71],[-9,15]],[[28338,62082],[-7,-8]],[[28331,62074],[-5,10]],[[28326,62084],[12,-2]],[[24897,67741],[52,2]],[[25113,67326],[-99,-4],[0,15],[-99,-1]],[[24915,67336],[0,31],[12,48],[21,23],[1,206],[-37,16],[4,30],[-16,18],[-3,33]],[[31401,38459],[25,0]],[[31400,38325],[1,134]],[[21641,69873],[240,0],[75,0]],[[21956,69873],[3,-33],[16,-73],[-12,-74],[15,-83]],[[21938,69204],[1,-48],[-20,-47],[-19,-64],[-19,10],[-18,62],[-11,-2],[-1,-59]],[[21851,69056],[-23,-8],[-8,23],[-25,-16],[-29,-53],[-9,18],[-23,9]],[[21734,69029],[0,287],[-101,0],[4,52],[0,404],[4,0],[0,101]],[[27173,55464],[20,74],[50,-58],[48,12]],[[27230,55057],[-4,27],[0,85],[-9,15],[-2,49],[-12,64],[5,67],[-15,43]],[[27193,55407],[-20,57]],[[26741,59057],[7,8],[16,63]],[[26900,58958],[5,-20],[-7,-45]],[[26898,58893],[-8,30],[-33,-70],[-20,-98],[-8,31],[-13,-4]],[[26646,60285],[1,-37],[-13,-43],[-1,-102],[12,-88],[0,-76]],[[26645,59939],[-22,20]],[[26545,60074],[2,43],[-6,32],[-12,-7],[-12,65],[8,44],[-1,51]],[[25294,60482],[17,49],[12,11],[48,19],[6,38]],[[25413,60569],[-2,-63],[10,-32],[16,26],[1,-53],[12,5]],[[25450,60452],[-70,-165],[-11,-18],[-1,-49]],[[25368,60220],[-7,-29],[-18,-34],[-3,25]],[[27534,57466],[12,444]],[[27546,57910],[6,18],[8,-64],[15,-10],[17,54],[10,-59]],[[26196,59320],[5,4],[4,104],[14,63],[27,32],[22,-13],[22,-53],[15,0]],[[26313,59278],[-6,6],[-4,-44],[-13,-14],[-4,-34],[-21,-14],[-3,-53],[-8,-36],[2,-61]],[[26256,59028],[-7,-11],[-20,8],[-7,20],[-20,-37]],[[26202,59008],[-5,7]],[[26197,59015],[10,60],[-11,126],[0,119]],[[25067,59604],[8,-2],[33,-66],[24,-1],[10,-17],[20,-86]],[[25162,59432],[-46,-1],[-84,6],[-13,-5]],[[25019,59432],[-20,-5]],[[24999,59427],[13,142],[12,13]],[[24980,59425],[-15,1]],[[24965,59426],[-9,58],[4,30],[21,-2],[5,-49],[-6,-38]],[[26880,61763],[14,-33],[6,-64]],[[26900,61666],[-1,-90],[8,-36],[-1,-58],[-9,-20]],[[26845,61458],[3,119],[3,20],[-13,13]],[[26838,61610],[14,69],[28,84]],[[26978,57082],[0,-16],[19,-71]],[[26900,56534],[0,20],[-14,48],[-8,67],[-12,24],[-7,68]],[[22799,51614],[81,308]],[[22880,51922],[1,-23],[49,98],[14,52]],[[22944,52049],[8,-25],[23,14],[10,-7],[7,-117]],[[22992,51914],[15,-97]],[[23007,51817],[-41,-196],[-44,-187]],[[22798,51611],[1,3]],[[16516,70296],[55,24],[13,57],[14,23],[24,-22],[15,14]],[[16637,70392],[-1,-367],[52,-1],[0,-100],[29,-1],[0,-504],[-5,0],[0,-100]],[[16570,69317],[-33,0],[0,85]],[[28083,64346],[-3,9]],[[28080,64355],[64,13],[4,-5]],[[28148,64363],[-25,-50],[-5,-25],[16,-66],[-9,-69],[14,-20],[-1,-62],[5,-17],[-34,-205]],[[30332,65028],[13,-24],[29,5],[18,17],[12,70],[16,-105],[-1,-30],[-10,-16],[-33,4],[-41,60],[-3,19]],[[27811,56284],[2,-22]],[[27713,55709],[-22,29],[-7,45],[-20,40],[-11,59],[-22,55],[-31,6],[-5,-10]],[[18773,61759],[3,9],[125,0]],[[18901,61768],[0,-11],[212,0],[145,0]],[[19285,61351],[-212,0],[-202,3],[-62,-5],[-58,2]],[[22486,53060],[147,7]],[[22594,52589],[-20,-163],[7,-20],[-8,-48]],[[22484,52935],[9,24],[-9,11],[-4,65],[6,25]],[[18285,70417],[10,0],[11,48],[18,44],[12,-16],[16,47],[1,105],[-3,101],[69,1],[0,51]],[[18419,70798],[133,-2]],[[18547,70695],[-18,-5],[-11,-45],[-27,0],[0,-102],[-21,0],[-9,-58],[-15,-6],[3,-77],[-27,-65],[-17,-12]],[[18655,70194],[-76,-7],[-10,20],[-15,-88],[-38,-69]],[[22842,66762],[-15,15],[-1,38],[-25,25],[-15,-14],[-15,13],[-7,-23],[-12,5]],[[22752,66821],[-42,1]],[[21492,68153],[11,-1],[251,1]],[[21754,68153],[0,-179]],[[21754,67974],[-6,10],[-21,-23],[-18,-48],[0,-465]],[[21463,67449],[0,101],[-8,0],[0,261]],[[26151,59465],[17,-19],[21,-69],[7,-57]],[[26197,59015],[-24,9],[-33,55],[-1,21],[-26,21],[-9,30],[-2,49],[-10,-2]],[[26092,59198],[0,118]],[[18917,63158],[8,-14],[9,-84],[8,-28],[7,21],[5,-72],[9,-35],[2,-61],[161,0],[132,0]],[[19258,62885],[4,-62],[-7,-78],[-12,-85],[7,-56],[-7,-2],[-10,-86],[4,-19],[-13,-68],[-3,-52],[17,-54],[15,8],[11,-51],[-11,0],[-7,34],[-20,-15],[-6,-91],[7,-62],[9,-32],[-3,-29],[8,-36],[-10,-46],[10,-7],[-1,-37],[15,-23],[-5,-57],[15,14],[1,-26],[-14,1],[-2,-21],[18,-14],[-3,-51],[-7,-25]],[[18901,61768],[0,189],[2,0],[0,419]],[[22736,49726],[46,260]],[[22842,50178],[15,2],[4,-24],[13,18],[18,-59],[18,-16],[7,25]],[[22952,50012],[-7,-31],[0,-76]],[[22879,49749],[-35,-60],[-17,-66]],[[22814,49622],[-16,72],[-7,-20],[-23,-3],[-16,59],[-10,-20],[-6,16]],[[21749,59428],[36,0]],[[21785,59428],[114,0]],[[19716,60010],[37,-1],[213,1]],[[19927,59102],[-1,-255]],[[19531,58850],[0,1159]],[[24360,58779],[69,-6],[0,-52],[30,-2]],[[24459,58719],[44,-1]],[[24503,58718],[-3,-47],[-11,-18],[5,-25],[-22,-54],[-13,-82],[9,-68],[-12,3],[-1,-132],[-59,5]],[[24396,58300],[-59,4]],[[24325,58503],[0,51],[-8,26],[-1,46],[6,66]],[[23980,61481],[5,10],[12,-35],[7,-62],[8,46],[8,-9],[-8,-27],[55,-9],[2,27],[17,11]],[[24041,61053],[-60,8]],[[23981,61061],[2,186]],[[22622,73980],[201,0]],[[22841,73448],[1,-1]],[[24503,58718],[46,-5]],[[24549,58713],[-1,-206]],[[24462,58193],[-66,4],[0,103]],[[22999,67577],[5,-22],[-7,-37],[22,-64],[-1,-110],[-14,-5],[7,-42]],[[23011,67297],[-2,-41],[24,-3],[2,-83],[9,-35],[-5,-43]],[[25162,59432],[2,0]],[[25164,59432],[3,-108],[-20,-20],[-17,22],[-3,-220]],[[24981,59094],[15,54],[7,64],[0,44],[12,67],[4,109]],[[27062,55974],[101,328]],[[27185,56375],[17,-74],[14,-19],[13,-76],[16,-10],[22,-31],[25,-51]],[[27292,56114],[-51,-189]],[[27241,55925],[-107,-340]],[[27134,55585],[-7,27],[-7,-12],[-13,42]],[[27107,55642],[4,30],[-28,82],[4,32],[-4,39],[7,43],[-4,24],[-15,26],[-9,56]],[[15475,68998],[126,-1]],[[15593,68489],[-115,-2],[0,-6],[-51,8]],[[15427,68489],[0,38],[-11,-1],[-1,34],[23,1],[6,17],[-2,85],[34,0],[-1,335]],[[15332,68480],[95,9]],[[15972,68464],[9,-34],[5,-153],[-9,-57],[-9,-18],[3,-30],[-10,-54],[-3,-61],[-9,4],[-21,-69],[4,-108],[-7,-119],[6,-40],[-10,-14]],[[15921,67711],[-36,-67],[-5,-43],[6,-28],[-1,-66]],[[15885,67507],[-100,2],[-70,-5],[0,125],[-102,-6],[0,77],[-8,0],[-1,202],[-58,1],[0,34],[-34,1],[0,24],[-16,-1],[0,45],[-15,0],[1,26],[-12,1],[1,34],[-12,1],[-12,26],[-34,1],[-21,-57],[-7,3],[-6,-42],[-59,1]],[[15320,68000],[5,110],[7,249],[0,121]],[[28439,61133],[11,-45],[3,-47],[-6,-19],[11,-38],[16,-10],[1,-52],[10,15],[9,-15],[19,14],[15,-77]],[[28528,60859],[9,-83],[18,-63]],[[28555,60713],[-4,-86],[6,-39],[-5,-47],[-13,-28]],[[28539,60513],[-8,41]],[[28531,60554],[-14,59]],[[24902,60157],[13,17],[9,67],[19,24],[0,17],[36,21]],[[24979,60303],[9,-13],[-1,-47],[13,-87],[11,-46],[-1,-53],[19,-36]],[[24971,59859],[-48,-12]],[[24923,59847],[2,74],[-9,35],[-1,43],[-19,113],[6,45]],[[23075,50320],[4,335]],[[23079,50655],[96,214],[25,96]],[[23200,50965],[10,-64],[-1,-80],[22,-53],[-5,-19],[5,-89],[25,-3],[7,-27],[4,-51],[12,-31],[6,-46],[18,-7]],[[23303,50495],[-43,-87],[-42,-100],[-53,-89],[-61,-112],[-44,-119]],[[22342,55817],[1,-513]],[[22343,55304],[-40,0]],[[22198,55304],[0,515]],[[24266,70670],[139,0]],[[24408,70065],[-137,3]],[[24271,70068],[-1,400],[-4,0],[0,202]],[[18574,61346],[10,3]],[[19085,60640],[-102,-1],[-224,0],[-8,-5],[-89,1],[-55,8],[-90,0]],[[18517,60643],[-1,305],[30,-1],[1,90],[-3,10],[33,0],[1,101],[-4,1],[0,197]],[[23034,65124],[40,0]],[[23187,64889],[-113,-1]],[[26998,59540],[18,36],[18,14],[-9,-51]],[[27025,59539],[-27,1]],[[22755,72433],[162,0]],[[22928,72232],[-3,-99],[8,-91],[-3,-50],[3,-64]],[[24362,57080],[-2,-289],[33,-6],[18,-16],[4,-85],[17,-10],[2,-62]],[[24434,56612],[-16,-8],[-13,38],[-9,-20],[-7,16],[7,26],[-17,15],[-14,38],[-9,4],[0,-127],[-5,34],[-58,-1],[0,-34]],[[24215,56591],[0,196],[5,-1],[2,306]],[[24486,59147],[5,-38],[22,-23],[6,-46],[21,-27],[6,10],[65,-3]],[[24611,59020],[18,0],[-12,-65],[-9,-16],[-8,-130]],[[24600,58809],[-6,-101],[-45,5]],[[24459,58719],[2,396],[5,16],[20,-1],[0,17]],[[28343,60282],[-4,50],[17,26],[-4,-65],[-6,-6]],[[23151,54197],[174,91]],[[23325,54288],[1,-76],[-8,-69],[8,-40],[-7,-95],[10,-9],[5,-57],[-2,-29],[17,-31],[18,-91],[1,-75]],[[23368,53716],[-106,-59],[2,-17],[-26,-27]],[[23238,53613],[-3,56],[9,2],[-3,34],[5,38],[-7,44],[-6,-12],[-3,-53],[-5,24]],[[23225,53746],[-4,65],[-22,29],[1,64],[-30,38],[2,53],[-5,10],[7,40],[-16,-2],[7,46],[-7,51],[-10,25],[3,32]],[[25088,59945],[5,-33],[19,17],[7,-12],[20,26],[28,14]],[[25168,59746],[-71,0],[-10,28],[-6,-14]],[[26462,58620],[6,-11],[3,45],[15,19],[20,-9],[-5,38],[23,0],[10,-34],[16,-6],[16,53]],[[26603,58345],[-31,-8],[-15,-45],[-16,-8],[-8,-48],[-11,-17]],[[26522,58219],[-2,3]],[[26520,58222],[6,28],[-20,33],[4,43],[-24,-14],[-4,40],[-10,1],[-16,40]],[[25201,58919],[11,2],[0,62],[34,-2],[0,42]],[[25246,59023],[89,-7],[0,-30]],[[25345,58667],[-1,-34]],[[25258,59430],[121,-5]],[[25379,59425],[-2,-62],[20,-97]],[[25246,59023],[4,407]],[[29573,66195],[13,36],[19,-13],[2,-78],[-9,-31],[11,-26],[4,28],[18,-5],[3,-43],[27,-19],[-1,35],[9,17],[6,54],[10,-7],[-7,-40],[9,-26],[52,24],[3,-54],[8,25],[40,44]],[[29790,66116],[-12,-71],[18,-26],[18,0],[0,-153]],[[29814,65866],[-104,5]],[[29710,65871],[-27,-4],[-42,6],[-3,-39],[-14,-6],[1,45],[-54,3]],[[29571,65876],[-13,1]],[[23972,62785],[-10,-6],[-7,31],[-10,-4],[3,-42],[-11,-44],[-7,12],[-6,-31],[-15,-2],[-1,-69],[-17,-28],[-4,48],[-19,29]],[[22689,51891],[17,50]],[[22706,51941],[93,-327]],[[22710,51454],[-5,20],[-19,18],[-5,36],[-8,7],[-4,47],[-5,-8],[-5,44],[-7,10],[-2,52],[-7,17]],[[22643,51697],[-5,30],[28,71],[9,49],[14,44]],[[29472,67872],[44,15],[-4,82],[53,11],[4,-48],[16,25]],[[29610,67345],[-108,16]],[[29502,67361],[2,279],[-13,29],[-2,53],[-19,0],[-7,-66],[-10,26],[7,114],[12,76]],[[15990,69125],[8,-5],[177,-3],[200,-2]],[[16375,69115],[-9,-31],[5,-39],[0,-230]],[[16371,68815],[-123,-1],[0,-100],[-45,0],[0,-101],[-33,1]],[[16170,68614],[-205,2]],[[27093,60176],[13,37],[26,32],[7,43]],[[27282,60284],[-17,-22],[6,-50],[-14,-16],[-4,-24],[16,-13],[0,-40],[-24,-41],[-12,0],[-17,-26],[7,-30]],[[27223,60022],[-12,-28],[1,38],[-28,-34],[-30,-66],[-7,52],[-20,-22]],[[27127,59962],[-13,111],[-18,69],[-3,34]],[[28171,62647],[57,-154]],[[28191,62355],[-12,-40]],[[28179,62315],[-15,46],[-11,-7],[-15,27]],[[28138,62381],[22,165],[-1,31],[12,70]],[[31378,38070],[14,30],[8,-1]],[[31400,38099],[7,-37],[-3,-73]],[[26685,52165],[33,0]],[[26718,52165],[0,-89],[6,-82],[12,-22],[7,18],[25,-33],[1,-19],[15,-39],[2,-24],[12,-21],[9,-42],[1,-42],[13,-40]],[[26821,51730],[-4,-70],[-8,-3]],[[26698,51656],[-9,-1],[0,76],[-5,1],[1,433]],[[23298,60457],[-122,4]],[[25397,61477],[-45,-4]],[[22462,72716],[-28,2],[-11,56],[-2,42],[-22,-21],[-9,22],[-6,68],[-31,-65],[-21,-16],[-3,73],[-19,-36],[0,100],[-11,-1],[-8,42],[-17,14],[0,251]],[[23340,64178],[48,-2]],[[23388,64176],[0,-116],[6,0],[0,-253]],[[23394,63807],[-105,3]],[[23289,63810],[1,32],[-18,26],[-12,110],[1,39],[-11,34],[-1,40],[13,42],[-11,18],[-5,-39]],[[27841,59477],[35,605]],[[27876,60082],[25,-36],[9,23],[18,-33]],[[27928,60036],[1,-49],[24,5],[6,-33],[15,53],[4,-74],[-7,-21],[22,-72],[-4,-39],[6,-70],[-7,-26],[12,-51]],[[28000,59659],[-8,-11],[-10,-55],[-1,-70],[-5,-46]],[[27976,59477],[-18,0]],[[27863,59477],[-22,0]],[[28426,62262],[22,-73],[-1,-37]],[[28447,62152],[-19,4]],[[28428,62156],[-11,38]],[[28411,62214],[15,48]],[[15740,73454],[0,40],[20,-41],[-17,-26],[-3,27]],[[15785,73566],[258,-3],[183,-2],[0,19],[43,0]],[[16200,73160],[-269,1],[-115,1]],[[15816,73162],[-8,33],[-28,45],[-13,48],[1,39],[-29,-33],[-7,33],[4,45],[-13,-17],[3,39],[24,28],[13,-15],[9,-49],[19,7],[-10,108],[17,6],[5,34],[-18,53]],[[15715,73495],[8,29],[12,-47],[-15,-33],[-5,51]],[[20732,71200],[0,51],[35,0],[0,33]],[[20924,71234],[0,-117]],[[20924,70813],[-1,-326],[1,-64]],[[20924,70423],[0,-73]],[[20924,70350],[-25,0],[0,101],[-71,2],[0,98],[-35,0],[0,95],[-103,0]],[[28416,60141],[23,84],[17,33],[-1,24],[12,18]],[[28467,60300],[8,-17]],[[28475,60283],[9,-37],[12,8],[18,-13],[15,-55],[9,-2],[8,58],[7,-29],[-3,-37]],[[28501,60006],[-29,-60]],[[28472,59946],[-4,65],[1,63],[-20,18],[-11,-4],[-22,53]],[[16972,71178],[-4,-39],[1,-309],[35,1],[0,-102],[34,0],[-1,-241]],[[17037,70488],[-276,-1]],[[16761,70487],[13,32],[0,44],[-10,86],[-18,62]],[[26327,56999],[19,-1],[0,-36],[91,0]],[[26437,56962],[0,-54]],[[26437,56908],[0,-173]],[[26437,56735],[-27,-11],[-2,-62],[-16,-17],[0,-41]],[[26392,56604],[-67,5]],[[23095,70207],[138,1]],[[23233,70208],[0,-203],[3,0],[0,-202]],[[23236,69803],[-103,0]],[[23133,69803],[-35,0],[0,202],[-3,0]],[[23095,70005],[0,202]],[[23175,60359],[0,-350]],[[23175,60009],[-10,0]],[[23165,60009],[-146,0]],[[23019,60009],[0,354]],[[23554,63649],[2,304]],[[23556,63953],[107,-3]],[[23663,63950],[-1,-288]],[[23554,63548],[0,101]],[[28070,62132],[17,69],[10,72],[-10,7],[6,68]],[[28093,62348],[42,11],[3,22]],[[28179,62315],[-20,-78],[4,-24],[-19,-32]],[[28101,62058],[-2,25],[-29,49]],[[22215,51428],[114,-5],[7,-11],[-2,-57],[16,-3],[33,150]],[[22383,51502],[1,-196],[0,-316]],[[22384,50803],[-170,1]],[[23478,63294],[77,-1]],[[23555,62956],[-140,3]],[[23415,62959],[-1,48],[17,24],[-2,24]],[[20924,70350],[1,-154],[0,-625]],[[26003,69060],[49,1]],[[26052,69061],[11,-11],[19,145],[3,98],[13,20],[-8,-158],[-15,-44],[-6,-67],[14,-14],[8,65],[16,65]],[[26137,68755],[-135,1]],[[26002,68756],[1,304]],[[25293,57677],[45,0]],[[25351,57057],[-48,1]],[[25303,57058],[-1,322],[-10,18]],[[25292,57398],[1,279]],[[19530,56260],[1,113],[-1,145],[1,675]],[[27820,63550],[10,56],[13,35],[7,-11],[7,60],[5,3],[24,141]],[[27792,63178],[-2,40],[12,30],[-2,46],[-15,38],[6,55],[29,163]],[[28552,66556],[58,5],[0,-10],[54,6]],[[28664,66557],[3,-252]],[[28667,66305],[-13,-26],[16,-25],[-2,-78],[-28,25],[-18,0],[0,-64],[-17,1],[0,20],[-17,1]],[[28588,66159],[-23,1]],[[28565,66160],[-20,2],[1,105],[-3,200]],[[28739,67208],[7,-33],[-2,-74],[16,-2],[6,-348]],[[28766,66751],[-105,-22]],[[28661,66729],[-9,49],[-14,42],[-26,-5],[-3,187],[-9,-1],[-1,113],[7,5],[-2,141]],[[27882,56867],[117,-414]],[[27999,56453],[31,-108]],[[28030,56345],[-13,-8],[-36,-51],[-27,-66],[-35,-121],[-18,-79]],[[27849,56176],[-20,127],[-1,90],[-9,10],[-12,81],[11,68],[16,45],[-2,26],[12,50],[4,51],[17,52],[1,38]],[[19058,73978],[159,0],[190,2]],[[19407,73980],[0,-101],[-4,0],[0,-403],[2,-49],[9,0],[0,-85],[-9,0],[0,-67],[-6,0],[0,-118],[-9,0],[0,-84],[5,0],[0,-101]],[[19395,72972],[-54,-2],[0,103],[-33,-3],[0,101],[-217,1],[0,-101],[-37,0]],[[29244,66680],[103,53],[1,4]],[[29348,66737],[11,9],[9,39],[13,-52],[4,10]],[[29385,66743],[-9,-104],[-14,-93],[2,-56],[-9,-119]],[[26348,56220],[30,97],[8,73],[-2,23],[12,40],[8,50],[-7,32],[-5,69]],[[26437,56735],[0,-89],[19,-27],[13,-36],[12,-6]],[[26481,56577],[-19,-26],[-4,-34],[-9,6],[-14,-20],[-4,-34]],[[26411,56108],[-30,1],[0,-113]],[[26381,55996],[-31,-31],[-11,-26]],[[26272,55950],[9,10],[-4,29],[6,33]],[[24242,68956],[135,-1]],[[24377,68955],[0,-102]],[[24377,68853],[-97,0],[-7,-7],[-6,-93],[-11,-120]],[[24256,68633],[-36,36],[-8,19]],[[24212,68688],[-17,57],[-3,44]],[[25555,55208],[29,1],[0,-51],[83,6]],[[25668,55039],[-9,-126],[2,-25],[-11,-34],[0,-39],[-9,-56],[-86,-7],[0,-203],[-14,-1]],[[25541,54548],[-14,0],[0,203]],[[25527,54751],[0,202],[14,1],[0,203],[14,0],[0,51]],[[8956,91740],[-211,0],[-30,35],[-38,69],[-12,-4]],[[26855,55649],[22,24],[9,32],[24,30],[36,-61]],[[26946,55674],[-43,-120],[2,-60],[-24,7]],[[26881,55501],[-21,57],[2,38],[-5,36]],[[26857,55632],[-2,17]],[[21579,54292],[120,0]],[[21698,53784],[-142,0]],[[19250,68168],[1,-225],[0,-407]],[[18974,67578],[-1,210],[0,352]],[[20643,63071],[0,3]],[[20547,62997],[0,211]],[[20547,63208],[0,193]],[[20547,63401],[70,1]],[[20617,63402],[21,-16],[5,17]],[[20643,63403],[0,-144]],[[20643,63259],[0,-109],[-8,-31],[8,-22],[-16,-29],[16,-6]],[[20644,62998],[-10,-83],[-14,-28],[4,-43],[-14,-31],[2,-53],[-19,-134],[-27,-136]],[[20566,62490],[-19,-1],[0,508]],[[19961,62592],[0,-639]],[[19717,61952],[0,188],[66,90],[15,71],[-2,14],[31,93],[21,1],[14,22],[25,-42],[22,51],[14,64],[38,88]],[[26430,56108],[11,-67],[-11,-48],[-3,-132],[-17,1],[0,-97]],[[26410,55765],[-9,-1]],[[26401,55764],[1,59],[-5,26],[5,44],[-10,36],[-6,66],[-5,1]],[[25865,61975],[0,-308]],[[25762,61634],[-1,153]],[[25761,61787],[0,187]],[[29842,64964],[3,18],[27,22],[-21,-43],[-9,3]],[[29812,64781],[5,20],[11,-16],[0,-50],[-6,35],[-10,11]],[[29792,64880],[16,16],[-12,-43],[-4,27]],[[29435,64577],[3,27],[22,-30],[2,41],[9,-28],[20,-8],[18,-23],[23,28],[2,43],[17,8],[10,-12],[75,3],[39,20],[14,18],[30,63],[9,40],[12,13],[13,50],[21,21],[12,-2],[-18,-52],[-9,-6],[15,-31],[5,-44],[17,-12],[11,25],[16,-72],[15,17],[23,48],[2,28],[17,11],[12,-12],[-5,-21],[-67,-94],[-78,-123],[-50,-62],[-81,-93],[-53,-78],[-43,-41],[-27,-12],[-6,15],[-27,-27]],[[28633,68013],[16,50],[-5,-45],[-11,-5]],[[28892,68412],[-28,-133],[17,-34],[-5,-75],[-13,-2],[2,-47],[-17,5],[-43,-108],[-23,6],[-3,-107],[18,-5],[3,-115]],[[28682,67787],[-8,144],[-20,40],[11,50],[14,11],[2,-33],[21,41],[-3,43],[-19,47],[-22,-15],[5,29],[-15,51],[-15,1],[1,80],[16,115],[19,5],[23,42],[0,48],[18,22],[27,55],[9,-5],[30,70]],[[28611,68032],[12,40],[9,-5],[-21,-35]],[[23552,61627],[0,-383]],[[23552,61244],[0,-26]],[[23552,61218],[-130,0]],[[26992,58227],[11,35],[-2,25],[18,10]],[[27019,58297],[5,-12],[31,17],[10,23],[10,-30],[17,18],[18,1],[5,38]],[[27115,58352],[20,45],[17,-39]],[[27130,57892],[-29,5]],[[27101,57897],[-27,3]],[[26993,58140],[-5,58],[4,29]],[[28983,64630],[-4,24],[30,59],[16,64]],[[29025,64777],[55,-214]],[[29080,64563],[-10,-34],[-3,-52],[-20,-57]],[[18136,61841],[280,0],[148,0]],[[18564,61841],[-1,-72]],[[18574,61346],[-216,2],[-221,0]],[[27111,59928],[39,-163],[22,-181],[4,5]],[[27176,59589],[-12,-30]],[[27114,59561],[-27,3],[-3,-26],[-59,1]],[[26998,59540],[-14,0]],[[26973,59672],[30,62],[34,42],[-4,22],[12,45],[26,27],[10,-17],[17,29],[13,46]],[[26082,56450],[0,-61],[-20,1],[-9,-17],[0,-33],[14,-1],[0,-51],[-15,-34],[0,-145],[-5,-25],[-24,-31],[0,-52],[-15,1]],[[26008,56002],[1,34],[-56,1],[-8,17],[-1,53],[-6,31],[-27,7]],[[26674,56167],[32,42],[3,32]],[[26709,56241],[45,-73],[20,19],[14,-25]],[[26788,56162],[13,-38],[-18,-94],[8,-70],[-7,-60]],[[26784,55900],[-42,-133]],[[26742,55767],[-10,47],[-13,5],[1,22],[-11,76]],[[27448,63962],[31,6]],[[27479,63968],[-1,-280]],[[27478,63688],[-21,21],[-24,10]],[[27433,63719],[8,69],[10,23],[5,65],[-2,57],[-6,29]],[[5246,85264],[5,41],[14,-83],[-7,-25],[-12,67]],[[5213,85252],[8,77],[5,-57],[-13,-20]],[[6115,85440],[-43,-32],[-21,-31],[-29,-22],[-5,-21],[-41,-28],[-44,-61],[-79,-73],[-26,5],[-28,53],[-5,73],[-20,49],[-40,38],[2,46],[11,17],[9,167],[-12,-3],[-25,-101],[-41,-54],[-6,-58],[5,-58],[-8,-37],[-14,-12],[-3,-32],[9,-80],[16,-91],[19,-76],[-26,-87],[-28,-21],[-42,32],[-39,161],[-47,208],[-26,73],[-23,42],[-31,13],[16,65],[-16,44],[-25,-9],[-6,-87],[-15,7],[1,-65],[-29,-30],[-24,79],[3,26],[-19,19],[-11,-30],[-16,6],[-1,59],[-22,-18],[-25,61],[18,47],[-17,89],[-44,-52],[-46,-72],[-31,-62],[-20,-95],[-13,57],[-46,-46]],[[5033,85142],[7,131],[39,52],[21,6],[39,76],[5,-2],[-55,-273],[-22,-32],[-32,-4],[-2,46]],[[5036,85417],[-75,-101]],[[18336,56517],[164,1],[131,-137],[9,27],[0,42],[13,39],[9,85],[122,-56],[64,0]],[[25605,61809],[19,-1],[7,-33],[12,25],[10,-26]],[[25653,61774],[-1,-329]],[[25652,61445],[-62,-1],[-5,17]],[[25585,61461],[0,158],[-26,-7],[0,70],[-10,0],[-5,35],[0,79]],[[26212,62696],[-6,-117],[-13,-301]],[[26192,62257],[-18,-2],[-1,-17]],[[26173,62238],[-67,-1]],[[22479,60863],[183,2]],[[22662,60460],[-151,-2]],[[22472,62999],[155,-1]],[[22628,62695],[0,-101]],[[22628,62594],[-156,0]],[[22472,62594],[0,405]],[[22167,61480],[4,0],[0,-204]],[[21988,61176],[0,304]],[[23026,62187],[0,-51],[31,0],[0,-101],[10,0]],[[22906,61884],[1,236],[10,0],[0,67]],[[23881,70666],[0,-201],[-24,1],[1,-288]],[[23859,69973],[-69,1]],[[23788,70280],[-1,187],[-12,0],[0,202]],[[23775,70669],[0,101],[4,0]],[[25189,57111],[54,0],[0,-51]],[[25243,57060],[0,-438]],[[25243,56622],[-49,0],[0,-17]],[[25165,56605],[-1,338]],[[24915,57163],[14,1]],[[24929,57164],[51,-1],[15,-39],[30,6],[22,-35]],[[25047,56960],[0,-254]],[[24974,56707],[0,34],[-59,1]],[[24915,56742],[0,421]],[[24632,53941],[5,68],[0,237]],[[24637,54246],[136,2]],[[24773,54248],[-5,-21],[17,-96],[15,-107],[-7,-16],[2,-51],[11,-12],[-3,-43]],[[24803,53902],[-34,-41]],[[25075,53531],[56,0]],[[25131,53531],[29,0]],[[25160,53531],[0,-507],[2,0]],[[25162,53024],[0,-102],[-14,0]],[[25077,52921],[-2,106],[0,504]],[[22847,73041],[-1,-24]],[[28916,63579],[23,-103]],[[28939,63476],[12,-46],[-8,-71],[14,-13]],[[28957,63346],[-16,-19],[-24,-11],[-17,-44]],[[29911,65511],[91,8],[6,30],[15,-1]],[[30023,65548],[6,-46],[-2,-52],[-22,17],[12,-39]],[[30017,65428],[-17,-23],[-4,-37],[-85,-7]],[[29911,65361],[0,51]],[[29911,65412],[0,99]],[[24197,65671],[130,-1]],[[23011,65530],[31,0],[-1,-68]],[[22913,65194],[0,4]],[[27997,62961],[-20,-83],[-11,-19],[-23,-136],[-9,-2],[-12,-58],[-15,-48]],[[27907,62615],[-43,87],[-38,20]],[[24335,57718],[10,23],[18,15],[16,-24],[1,-18],[15,-2],[1,77],[33,-3]],[[24453,57174],[-60,5],[-1,-101],[-22,1]],[[19295,56015],[16,-38],[6,-60],[18,2],[5,42],[13,26],[6,47],[11,-1],[6,35],[20,11],[9,35]],[[19512,54686],[-32,-2],[-263,2],[-78,2]],[[20420,64069],[13,-14],[-2,-62],[13,-72],[23,-66],[9,-49]],[[20476,63806],[-7,-69],[3,-50],[9,-14],[-1,-117],[-14,-36],[-1,-86],[5,-10]],[[20470,63424],[-7,-48],[3,-46]],[[20466,63330],[-13,-55],[-18,-1],[-6,-21],[-18,13],[1,-70],[-12,-44]],[[20400,63152],[-20,-17],[-17,47],[-7,95],[-13,44],[-20,23],[-14,59],[-40,0],[-11,12]],[[20258,63415],[-53,0]],[[20205,63415],[-3,90],[1,395],[-6,0],[1,121]],[[20100,61346],[1,324],[210,-3]],[[20311,61667],[47,1],[5,38],[13,-12]],[[20376,61694],[34,-123],[9,-49],[17,-39]],[[20436,61483],[2,-24],[32,-99],[5,-78],[8,-29],[7,-68],[12,-67],[14,-14],[10,-51]],[[20526,61053],[12,-51],[-1,-55],[-6,-10],[0,-52]],[[20101,61123],[-1,223]],[[27305,49119],[75,-2]],[[27380,49117],[26,2],[1,-99],[27,0]],[[27360,48615],[-14,47],[-1,51],[-7,8],[-7,45],[4,22],[-13,31],[-5,-8],[-12,38],[1,26],[-19,65],[-2,45],[20,81],[0,53]],[[26454,57238],[-16,-24],[0,-34],[-23,14],[-3,-21]],[[26412,57173],[-7,-16],[-79,0]],[[26326,57157],[0,40]],[[26899,53572],[29,0],[4,-60],[18,0]],[[26950,53512],[7,-61],[0,-63],[9,-55],[12,-44],[9,-2]],[[26987,53287],[0,-37],[21,-25],[0,-100],[21,-86]],[[27006,52524],[-57,15]],[[26949,52539],[-3,36],[-2,242],[-16,-1],[1,167],[-8,0],[-8,44],[-12,21],[-22,192]],[[24193,62743],[62,-8],[103,-2]],[[24249,62413],[2,205],[-59,7]],[[24192,62625],[1,118]],[[20311,58766],[-1,-88]],[[20310,58678],[0,-19]],[[20310,58659],[21,-13],[-10,-58],[-11,-26]],[[20310,58562],[-9,42],[-21,29],[-15,-7],[3,20],[0,154],[23,-9],[5,24],[14,-8]],[[19205,72136],[15,-1],[23,38],[13,36],[8,-4],[25,53],[18,22],[0,76],[5,50],[-2,74],[32,-11],[13,37],[38,5]],[[19393,72511],[8,7],[24,-29],[31,45],[11,40],[40,-14],[18,24],[34,-11],[7,-41],[-7,-32],[15,6]],[[22141,66682],[39,-16],[28,42],[6,22],[22,9],[22,28]],[[22264,65933],[-119,-2]],[[21247,73451],[182,0]],[[21429,73451],[72,1],[0,-204],[14,1],[0,-407],[15,0],[-1,-204]],[[21386,72533],[-8,-7],[-23,33],[-18,0],[-22,51]],[[21315,72610],[-2,91],[23,78],[4,35],[-12,15],[-4,40],[-16,5],[1,30],[-27,22],[-1,40],[-18,-7]],[[25478,61055],[10,-4],[-3,-75],[11,-3],[13,40],[-11,64],[7,66],[8,-6],[6,-49],[14,-19],[14,37]],[[25547,61106],[20,-6],[22,-44]],[[25589,61056],[-6,-92],[14,-43],[-14,-47],[-20,-20],[-4,-48]],[[25535,60764],[-67,-10]],[[29908,65840],[84,11]],[[30042,65570],[-12,-23]],[[30030,65547],[-7,1]],[[29911,65511],[-3,222],[0,107]],[[26436,59535],[9,1]],[[26512,59533],[1,-34],[17,-155],[5,-9]],[[26535,59335],[-4,-37],[-9,15],[-5,-54],[-1,-65],[-9,-33]],[[22782,48693],[8,0]],[[22790,48693],[-7,-145],[-2,-108],[1,-103],[8,-205],[16,-227]],[[22806,47905],[-7,-1]],[[22799,47904],[-12,146],[-9,88],[-3,106],[1,138],[-1,122],[7,189]],[[22612,48613],[10,28],[30,13],[16,46],[16,-21],[25,19]],[[22709,48698],[3,-45],[24,-16],[25,38],[8,2],[-5,-116],[3,-4],[-4,-202],[-6,-207],[-4,-3],[4,-113],[7,-128]],[[22764,47904],[-117,-2],[-27,16]],[[22620,47918],[-8,5],[0,192]],[[28193,66835],[0,50],[12,46],[0,50]],[[28297,66930],[10,-92],[-12,-13],[0,-106],[-7,0],[4,-106],[31,-2],[-1,-108]],[[28322,66503],[-47,3],[0,-52],[-17,0],[-1,-75]],[[28170,66438],[-7,13],[29,157],[1,227]],[[26924,61653],[29,33],[23,11],[5,49],[5,107]],[[27005,61863],[46,-136]],[[27051,61727],[2,-117]],[[27053,61610],[-14,-8],[-6,-27],[-16,-5],[-9,-59],[-9,-21],[-7,-49]],[[26992,61441],[-10,13],[-1,64],[8,10],[-11,32],[-9,-29],[-45,122]],[[16078,63679],[10,0],[-1,-42],[11,-34],[-15,-82],[3,-67],[-1,-101],[15,-19],[2,-34],[19,-52],[21,-94],[11,-17],[9,-67],[17,-36]],[[16179,63034],[-9,-35],[-12,-14],[-2,-42],[-23,9],[0,-16],[-18,7],[-2,-50],[-7,-18],[1,-41],[-11,-71],[-9,-29],[-19,-7],[-3,-19],[-22,-14],[-13,16],[-4,-27]],[[16026,62683],[-1,11],[-78,-2]],[[15952,62785],[6,77],[-2,70],[6,32],[-39,-4],[-2,28],[4,100],[-2,32],[15,31],[-5,45],[-7,-1],[-17,72]],[[20400,63152],[0,-30],[21,-34],[16,-9],[5,-29],[-15,-54]],[[20427,62996],[3,-31],[-14,-25],[4,-14],[-16,-56],[-15,-22],[4,-27],[-12,-15],[-8,-46],[-9,-4],[-22,24]],[[20342,62780],[-20,0]],[[20322,62780],[0,23],[-13,80],[-1,67],[12,7],[0,54],[9,34],[-2,54],[-12,10],[-9,44],[-8,5],[-14,60],[-12,12],[-11,88],[-3,97]],[[26756,56837],[5,85],[-4,-3],[4,84],[12,92]],[[26773,57095],[16,-19]],[[26850,56854],[-39,-47],[-18,-44],[-11,28],[-16,-12]],[[24617,64243],[1,504]],[[25690,62890],[70,-4]],[[25760,62886],[15,0],[1,-144]],[[25776,62742],[-16,-12],[1,-198]],[[25658,62534],[0,203],[31,0],[1,153]],[[25653,61774],[22,-2],[14,-24],[5,15]],[[25694,61763],[13,-12],[11,36],[43,0]],[[25731,61413],[-63,-2]],[[25668,61411],[-16,1],[0,33]],[[22318,61986],[2,0]],[[22320,61986],[1,-406]],[[22321,61580],[-61,3],[-93,-2]],[[24197,65671],[0,506]],[[26409,59963],[2,35],[9,12],[-2,73],[13,46],[-3,58]],[[26426,59947],[-14,-7],[-3,23]],[[22323,61175],[31,0],[0,303]],[[22354,61478],[120,0]],[[22474,61478],[3,0],[-1,-102]],[[22476,61376],[1,-406]],[[23935,53450],[68,-4],[3,-16]],[[24006,53430],[5,-17],[24,-17],[0,-34],[14,-42],[0,-281],[1,-141]],[[24050,52898],[0,-17],[-43,3]],[[24007,52884],[-43,0],[-6,6],[-78,-2],[-12,-26],[-12,24],[-10,-13]],[[23846,52873],[0,50],[9,22],[-12,55],[1,33],[13,21],[-2,54],[-8,31],[6,102],[-6,1]],[[26465,66735],[65,5]],[[26530,66740],[66,3]],[[26596,66743],[6,-410]],[[24155,67966],[0,-389]],[[23994,67576],[-7,0]],[[24952,53531],[38,0]],[[24990,53531],[0,-102],[29,1],[-1,-392]],[[25018,53038],[-21,0],[0,-32],[-14,0],[-7,36],[-14,-14],[-29,1]],[[24933,53029],[0,502]],[[24637,55669],[45,0],[0,68],[29,1]],[[24711,55738],[0,-73],[11,-37],[13,5],[0,42],[10,32]],[[24745,55707],[0,-195],[-8,-48],[-3,36],[-17,-34],[0,-41],[14,-22],[5,-36]],[[24736,55367],[-24,-2],[0,-100],[-58,-1]],[[24654,55264],[0,203],[-13,-1]],[[24641,55466],[6,123],[-14,36],[4,44]],[[22654,66340],[98,1]],[[22752,66341],[32,1],[0,-102]],[[22784,65937],[-130,-2]],[[26611,60971],[12,-8],[18,15],[8,36]],[[26649,61014],[18,-50],[13,-6],[14,-41],[2,-30],[18,-47]],[[26718,60790],[-23,6],[-17,29],[-7,-11],[-12,-70],[-10,-12],[-7,22]],[[25450,60452],[-4,-33]],[[25483,60184],[-8,-148],[-6,-23]],[[25428,59964],[-27,125],[-19,125],[-14,6]],[[21494,69367],[0,-613]],[[21494,68754],[-1,0]],[[26222,60745],[1,56]],[[26223,60801],[78,40]],[[26301,60841],[11,-18],[2,-34],[11,-40]],[[26325,60749],[0,-19],[-25,-37]],[[26300,60693],[0,0]],[[26300,60693],[-27,-44]],[[26219,60645],[3,100]],[[26925,58820],[13,35],[12,76]],[[27029,58641],[-17,-103],[-23,-36]],[[26989,58502],[-2,25],[-14,28],[-8,83],[-13,-3]],[[26952,58635],[-2,48],[-11,47],[-11,11],[4,45],[-7,34]],[[25696,54963],[5,-112],[-2,-36],[13,-100],[10,-30],[-6,-29],[8,-34],[0,-35]],[[25699,54246],[-76,-1],[-3,45],[-12,18],[-8,53],[-5,-3],[-13,64],[-11,-2],[-7,49],[-15,34],[-8,-4]],[[25541,54499],[0,49]],[[26370,55568],[13,29],[16,0],[6,-22],[35,-1]],[[26433,55344],[-61,3],[-10,-27]],[[25756,53636],[0,-102],[7,0],[3,-78],[-10,-28],[0,-178]],[[25756,53250],[-18,-12],[0,92],[-184,-1]],[[25554,53329],[9,47],[10,20],[17,97],[19,62],[6,5],[11,71],[9,142],[22,42],[2,47],[17,0],[23,41]],[[24125,57814],[3,-67],[-15,-70],[15,-49]],[[23980,57417],[-59,1]],[[23921,57418],[0,102],[5,50],[15,34],[31,99],[18,69]],[[26412,57173],[8,-110],[17,-3],[0,-98]],[[26327,56999],[-1,158]],[[26711,55572],[6,84],[30,59],[-5,52]],[[26784,55900],[8,-25],[23,-10],[14,5]],[[26829,55870],[7,-18],[1,-62],[5,-11],[5,-112],[8,-18]],[[26857,55632],[-8,0],[-21,-49],[-13,-79],[-19,-23],[-11,-33],[-12,0]],[[26773,55448],[-14,-35],[-5,38],[6,79],[-27,29],[-22,13]],[[26328,54461],[8,0],[5,-49],[10,-1],[11,-64],[27,-1]],[[26385,54152],[-3,-56],[-40,1]],[[26342,54097],[-16,0]],[[26326,54097],[0,126],[3,1],[1,153],[3,27],[-5,57]],[[25990,63757],[0,186]],[[26069,63944],[1,-352]],[[26070,63439],[-80,-2]],[[25990,63437],[0,320]],[[25694,61763],[0,363],[6,0],[0,101]],[[21869,60868],[-122,0]],[[21747,60868],[0,108],[-4,-1],[1,507]],[[23285,62826],[109,1]],[[23394,62827],[0,-338],[-2,-99]],[[23392,62390],[-31,-2],[-12,-13],[-27,45],[-17,-15]],[[23305,62405],[-27,9],[2,176]],[[25789,64563],[0,-204]],[[25789,64359],[-47,0],[-3,-44],[6,-19],[-9,-20],[1,-119]],[[25645,64360],[0,118],[32,0],[-1,86],[16,1]],[[26308,60288],[46,137],[15,-32]],[[26409,59963],[-16,-14],[-45,-93]],[[26276,60008],[-20,57],[2,81]],[[24582,63322],[0,302]],[[24193,54360],[0,153]],[[24193,54513],[41,-1],[3,-21],[13,0],[0,21],[20,1]],[[24270,54513],[12,-1],[-4,-55],[8,-15],[-1,-58],[24,-3],[0,-14]],[[24309,54367],[8,-70],[-12,-8],[2,-104],[4,-28]],[[24311,54157],[-5,0],[0,-51],[-28,-1]],[[24278,54105],[-85,1]],[[24193,54106],[0,254]],[[23859,61822],[-154,13]],[[23705,61835],[-16,2],[1,101],[-3,0],[2,206]],[[24796,60706],[80,2]],[[24876,60708],[-1,-443],[-1,-108]],[[24874,60157],[-26,2],[0,-85],[-10,-17],[-32,1]],[[24806,60058],[0,52],[-31,1],[1,266]],[[24553,60122],[16,2],[-1,-51],[52,-4]],[[24620,60069],[14,-1],[-1,-57],[10,-35],[5,-51]],[[24648,59925],[5,-51],[-1,-83]],[[24652,59791],[-65,2],[-61,12]],[[24526,59805],[-30,3],[0,67]],[[23036,64685],[0,-270]],[[23036,64111],[-125,1]],[[29093,64340],[47,45],[12,-70],[-3,-57],[17,29]],[[29166,64287],[3,-23],[13,15],[-6,-55],[-10,-24]],[[29166,64200],[-14,-20],[-4,-26],[19,-74],[-20,-64],[-15,-27],[-10,-51]],[[29122,63938],[-9,20],[-19,-19],[-8,57]],[[28051,66841],[109,3],[33,-9]],[[28094,66437],[-43,-2],[0,20]],[[28051,66455],[0,284],[-7,0],[1,102],[6,0]],[[28429,66394],[33,1],[0,-25],[28,0],[-2,91]],[[28565,66160],[-6,-57],[-26,17],[0,53],[-64,-8],[0,-10]],[[28469,66155],[-38,-7],[-2,246]],[[26508,64065],[2,61],[32,4]],[[26542,64130],[0,-8],[100,-27],[0,-6]],[[26642,64089],[-8,-319]],[[26634,63770],[-66,18],[1,17],[-64,16]],[[26642,64089],[29,2]],[[26740,63669],[0,-42],[-10,1]],[[26730,63628],[-83,4]],[[26647,63632],[2,133],[-15,5]],[[27956,64557],[1,-211]],[[27909,63964],[-12,28],[-12,-46],[-17,-12],[1,28],[-11,20],[-47,48],[-19,5],[-10,37],[-5,-10],[-1,58]],[[26047,60502],[2,-30],[-10,-41],[-3,-69],[7,-40],[-4,-99]],[[26023,60208],[-45,-25],[-42,22]],[[25908,60401],[21,19],[2,34],[15,16],[-8,64]],[[25662,60663],[25,81],[6,-8],[31,59],[-14,41],[12,33]],[[25786,60667],[-20,-21],[15,-176]],[[25781,60470],[-41,-106],[-5,26],[-11,3],[2,-43],[-21,-66],[-4,-26]],[[25701,60258],[-23,66],[-1,55],[-19,62],[-10,-12],[-4,-37],[-9,9],[11,47],[-1,47]],[[21931,70015],[199,-1]],[[22130,70014],[2,0]],[[21956,69873],[-14,46],[-15,-3],[-12,31],[16,68]],[[26657,59050],[2,-23],[24,-2],[28,-26],[11,-54]],[[26600,58891],[-10,64],[11,-15]],[[26353,61748],[20,18],[3,40]],[[26376,61806],[8,-15],[13,36],[54,25]],[[26451,61852],[-2,-31],[15,-1]],[[26464,61820],[-7,-66],[15,-17],[8,-28]],[[26455,61607],[-24,-66],[-28,-43],[-18,6]],[[26735,58281],[-14,12],[-20,-53],[-12,-13],[-3,-48],[6,-34],[1,-77]],[[26693,58068],[-26,-7],[-10,-32],[-8,2],[-51,-23]],[[26598,58008],[-1,52],[17,24],[8,37],[2,67],[-7,-9],[-34,24],[-20,-3],[-30,24],[-11,-5]],[[23259,55308],[99,3]],[[23402,55370],[0,-129]],[[23401,54854],[-3,-30],[-11,32],[-9,-13],[-30,56],[-11,-9]],[[23337,54890],[0,0]],[[23337,54890],[-4,5]],[[23333,54895],[0,0]],[[23333,54895],[-1,1]],[[23332,54896],[0,-2]],[[23332,54894],[-1,0]],[[23331,54894],[0,0]],[[23331,54894],[0,1]],[[23331,54895],[0,0]],[[23331,54895],[-1,0]],[[23330,54895],[0,0]],[[23330,54895],[-17,0],[-35,95]],[[23267,55029],[-8,279]],[[28401,59133],[21,218],[3,44],[14,10],[-6,45],[-15,7],[-5,25]],[[28413,59482],[69,-3]],[[28482,59479],[4,-26],[-13,-59],[4,-80],[32,-44],[16,-13],[18,-66]],[[28543,59191],[2,-22]],[[28545,59169],[-8,-39]],[[28537,59130],[-70,-6],[-66,9]],[[23486,52437],[32,-5]],[[23449,51727],[-5,42],[4,61],[-13,25],[-18,202]],[[23417,52057],[-19,207]],[[25863,62395],[66,2]],[[25929,62397],[0,-17],[61,6],[17,32]],[[25983,62029],[-27,40],[-12,-14],[-18,32],[-12,-25],[-14,25],[-25,-23]],[[25863,62328],[0,67]],[[22321,61580],[0,-101],[33,-1]],[[24240,52210],[15,36],[2,36],[9,24],[5,-24],[12,9]],[[24283,52291],[10,-10],[-4,-40],[5,-57],[-8,-19],[10,-28],[-10,-29],[-1,-34],[17,7],[4,-39],[-13,-95]],[[23091,70512],[0,101]],[[23095,70207],[0,204],[-4,0],[0,101]],[[24819,54655],[-1,46],[8,3],[7,45],[15,13],[34,119],[15,-8]],[[24912,54449],[0,-204]],[[24912,54245],[-139,3]],[[24773,54248],[-5,57],[0,64],[15,40],[2,37],[-6,19],[9,63],[18,68],[5,48],[8,11]],[[24683,54781],[24,47],[5,30]],[[24712,54858],[0,-99],[56,-1],[1,-102],[50,-1]],[[24637,54246],[-3,206]],[[27874,57885],[1,21]],[[27875,57906],[27,26],[33,19],[15,34],[28,8],[30,-25]],[[28008,57968],[-3,-86],[-9,-109],[4,-100],[21,-63],[21,-95]],[[27929,57491],[-15,90],[-23,46]],[[27891,57627],[1,12],[-15,92],[-7,98],[4,56]],[[27192,58983],[13,29],[12,68],[-6,46]],[[27211,59126],[18,48],[13,3],[0,87],[13,17],[11,-22],[8,14]],[[27274,59273],[18,38],[7,39],[7,-23],[12,32],[14,-34],[5,-44],[13,4],[4,29]],[[27354,59314],[27,-88],[-1,-105]],[[26398,64300],[49,1],[0,-34],[32,2],[0,-18],[63,2]],[[26542,64253],[0,-123]],[[26388,63915],[-6,5],[0,380]],[[22847,58121],[0,101]],[[22847,58222],[144,-1]],[[22991,58221],[1,-72]],[[22992,58149],[-9,-10],[-20,38],[-14,-23],[0,-588]],[[22949,57566],[-10,52],[-20,-22],[-13,45]],[[22906,57641],[-24,-67],[-17,26],[-18,-1]],[[23171,58020],[0,101]],[[23245,58325],[103,0],[0,-302]],[[23348,58023],[-13,41],[-17,-37]],[[23318,58027],[-13,6],[-4,-41],[-30,-48],[3,29],[-17,-26],[-1,-22],[-23,-36],[-10,23],[-22,-13],[-10,-50],[-21,10]],[[23170,57859],[1,161]],[[15513,69827],[91,1],[7,-34],[23,0],[17,-67],[13,-1],[4,-33],[12,-1]],[[15680,69692],[0,-67],[5,0]],[[15624,69410],[-119,0],[-64,2]],[[15441,69412],[-16,0],[-1,163],[90,0],[-1,252]],[[28881,63990],[-12,33]],[[28869,64023],[-32,82],[-69,186]],[[28768,64291],[37,68]],[[26100,60552],[18,12],[17,-7],[17,-40],[2,-21],[28,56],[12,-14],[15,-46]],[[26184,60372],[-8,-45],[-33,-30],[1,-22],[-12,-41]],[[26132,60234],[-11,53],[-11,79],[-13,68],[-30,79],[0,44]],[[25958,59688],[-7,42],[-19,54],[4,27],[-6,30],[0,45],[-28,25],[3,23]],[[22784,52350],[-35,-247],[-43,-162]],[[22689,51891],[-129,386]],[[23417,52057],[-43,-144],[-12,-19],[-36,102],[-14,-14],[-8,47],[-14,32],[-11,-41],[-8,0],[-14,-40],[-25,-17],[-12,4]],[[23220,51967],[0,181]],[[23220,52148],[0,107],[-7,341]],[[21580,54802],[144,-2]],[[26824,59980],[12,38],[12,2],[16,39],[0,86],[25,45],[19,49]],[[26912,60247],[2,-91],[14,-76],[4,-43],[28,-49],[5,-29],[10,18]],[[26975,59977],[8,-76],[-30,-34]],[[26851,59778],[-18,55],[-12,53]],[[28128,62542],[0,35],[14,-24],[-13,-62],[-1,51]],[[26945,64658],[4,0],[0,-197],[9,-18],[2,-94],[11,0],[1,-200]],[[26892,64143],[-1,185],[-28,3]],[[24912,54245],[19,0],[2,-39],[0,-268],[1,-3]],[[24934,53935],[-29,-7]],[[24844,53913],[-41,-11]],[[24160,62628],[32,-3]],[[24218,61923],[-39,45],[5,27],[-14,40]],[[24170,62035],[-4,29],[8,52],[-18,34],[-15,98]],[[24124,62304],[-2,33],[15,105],[23,186]],[[19395,72972],[-2,-461]],[[19087,72136],[-1,35],[-35,-1],[0,93],[-27,-1],[-7,32],[-13,-6],[-32,60],[21,116],[-121,0]],[[18872,72800],[0,169]],[[22529,64514],[38,134],[16,30],[25,80],[32,42],[16,69]],[[20310,58659],[0,19]],[[20458,58822],[-2,-126]],[[20311,57729],[0,204]],[[20311,57933],[-1,104],[0,525]],[[28008,57968],[10,60],[12,23]],[[28135,57903],[-3,-112],[4,-16],[3,-206],[-14,-187],[18,-37],[6,13]],[[28149,57358],[-12,-49],[-28,-146]],[[22991,58221],[1,205]],[[23171,58020],[-129,0]],[[23042,58020],[0,207],[-8,-5],[-7,-40],[-16,29],[-4,-19],[9,-54],[-14,23],[-10,-12]],[[22579,59537],[179,0]],[[22758,59537],[0,-499]],[[22758,59038],[-59,0]],[[22579,59038],[0,347]],[[26648,61233],[18,-19]],[[26666,61214],[-3,-106],[-14,-61],[0,-33]],[[26573,61079],[-2,82],[5,12]],[[20563,59151],[132,0],[0,-51],[120,1]],[[20815,59101],[-1,-29],[10,-45],[-3,-37],[12,-66],[4,-98],[8,-26],[-7,-23],[3,-33],[-13,-61],[5,-94]],[[22784,65532],[-129,-1]],[[22691,65126],[29,1],[0,-73]],[[16170,68614],[0,-201],[2,-93],[32,-5],[0,-202],[66,-4],[0,-100],[103,1],[0,-101],[34,0],[0,-101],[100,0]],[[16107,67713],[-186,-2]],[[16981,65827],[160,2],[166,2]],[[17307,65831],[3,-1]],[[17310,65830],[0,-1163]],[[17310,64667],[-1,-416],[-63,-1],[-15,-135]],[[17231,64115],[0,175],[-96,9],[0,202],[-221,-2],[-97,0],[0,122],[-146,0]],[[16671,64621],[-5,0],[-1,319],[7,0],[1,209],[-6,0],[-1,205],[1,470]],[[28289,65830],[135,0],[44,2]],[[28468,65832],[11,1]],[[28479,65833],[8,-224],[7,-247]],[[28494,65362],[-24,-53],[-178,-11]],[[28292,65298],[-3,532]],[[25781,60470],[35,-38],[5,-48]],[[25764,60010],[-48,66],[-27,15]],[[25689,60091],[13,22],[-8,64],[1,43],[7,-3],[-1,41]],[[25859,61385],[17,-50],[1,-94],[26,-55],[22,-1],[13,-58],[4,36],[10,11]],[[26325,60749],[11,-48],[41,-115],[7,-10]],[[26645,59939],[6,-50]],[[26659,59620],[-19,2],[-33,-49],[-8,-27]],[[26599,59546],[-4,-21],[-67,5]],[[26248,61945],[18,42],[24,26]],[[26290,62013],[3,-118],[26,-69],[15,-87],[13,-14]],[[28488,57978],[14,-44],[59,22],[6,51],[1,68]],[[28568,58075],[30,-18],[8,-31],[1,-40],[-7,-56],[-13,-54],[1,-28],[-9,-53],[-15,-42],[-50,-112],[-44,97]],[[28501,58520],[9,34],[4,65],[12,70]],[[28526,58689],[19,93]],[[28545,58782],[5,-11],[40,10],[37,47],[9,-46]],[[28636,58782],[-4,-35],[7,-62],[-15,-87],[0,-104]],[[28624,58494],[-64,9]],[[28560,58503],[-58,1],[-1,16]],[[27290,61789],[18,44],[13,54]],[[27321,61887],[15,65]],[[27336,61952],[15,-50],[2,-37],[12,-16],[2,-40],[11,-44]],[[27378,61765],[17,-33],[-26,-75],[-89,-176]],[[27280,61481],[-6,127],[-8,117],[24,64]],[[19847,69324],[216,-1],[14,-4],[229,-3]],[[20372,69316],[3,-159],[0,-175],[2,-167]],[[19998,68811],[-4,39],[-25,23],[-16,62],[-25,36],[-15,-18],[-2,22],[-18,17],[-2,58],[-22,36],[4,18],[-12,65],[3,45],[-9,39],[-1,56],[-7,15]],[[31468,38436],[11,-15]],[[31476,38395],[-8,-19],[1,-30]],[[31469,38346],[-16,6]],[[31453,38352],[-1,71],[16,13]],[[31221,38068],[10,28]],[[31250,37954],[-24,16],[-11,-11]],[[28997,65367],[23,-108],[1,-34],[11,5],[15,-33],[-2,-18],[25,3],[14,-21]],[[29101,65083],[-16,-13],[-22,-69],[-14,-124],[-11,-49],[-20,-54]],[[29018,64774],[-10,-14],[-13,71],[-22,11],[7,118],[-64,-15]],[[28916,64945],[5,18],[8,90],[-11,42],[24,5],[4,47],[18,35],[5,38],[28,147]],[[26287,62172],[38,-93]],[[26325,62079],[-34,-14],[-1,-52]],[[26223,62062],[38,38],[22,-3],[-6,44],[10,31]],[[27804,58285],[4,-23],[-7,-33],[9,-54],[11,-27],[7,-64],[23,-44]],[[27851,58040],[-11,-46],[16,-31],[3,-31],[16,-26]],[[27874,57885],[-7,-9],[-14,31],[-20,23],[-25,-60],[-34,-137]],[[27731,57873],[-12,30],[-5,65],[-9,21],[-1,44],[-15,203],[-1,42]],[[27805,57494],[43,-5],[43,138]],[[27938,57083],[-28,-67],[0,-35],[-11,-19],[-10,-82],[-7,-13]],[[27776,57241],[-3,11]],[[22794,52331],[37,-76],[33,-91],[16,-242]],[[23323,53094],[133,382]],[[23456,53476],[-1,-44],[17,-25],[6,-51],[-6,-30],[11,-26],[-1,-40],[6,-63]],[[23488,53197],[-27,-122],[-73,-253]],[[27372,59500],[18,-3]],[[27390,59497],[37,4],[26,-5]],[[27453,59496],[47,-9]],[[27354,59314],[5,20],[-7,40],[13,56],[7,70]],[[20923,73979],[188,-1],[121,1]],[[21232,73979],[0,-325],[15,0],[0,-102]],[[20923,73553],[0,426]],[[31571,38386],[10,-1],[12,-44]],[[31593,38341],[-5,-21],[4,-29],[-1,-59]],[[31591,38232],[-2,-13]],[[31589,38219],[-13,12],[-3,-20]],[[31573,38211],[-4,3]],[[27401,55560],[2,5]],[[27546,54792],[-16,-45],[-8,21],[-15,-28],[-2,30],[-15,-15]],[[26005,59000],[9,-62],[15,4],[10,-20],[11,-58]],[[26050,58864],[-5,-51],[7,-104],[-9,-30],[10,-3],[-13,-26]],[[25983,58660],[-1,21],[-30,111],[-5,9]],[[25947,58801],[-12,146]],[[22718,53710],[92,184]],[[28547,57639],[14,31],[13,2],[27,30],[4,62],[11,-14],[3,-66],[8,-31],[18,-5],[-9,75],[20,-29],[2,-85],[-17,-75],[-18,-13],[0,-34],[-11,-20],[-14,-84],[-7,-71],[-17,20],[1,80],[-10,19],[1,-82],[-16,-7],[42,-64],[23,123],[33,120],[24,75],[47,176],[8,-21],[-28,-83],[-26,-96],[-22,-62],[-21,-78],[-18,-82],[-21,-115],[-3,-32],[-4,67],[-35,55],[-39,1],[-60,-38],[-21,-24]],[[22162,53599],[18,-10],[7,-69],[5,23],[6,-26],[10,28],[-2,34],[11,-34],[25,-42],[3,27],[18,58],[10,-18]],[[22304,53563],[0,-606]],[[26397,65488],[1,-103],[4,0],[1,-120],[10,0],[0,-33]],[[26413,65232],[0,-68]],[[26285,65163],[-1,121]],[[26284,65284],[0,193]],[[23200,50965],[8,39]],[[23208,51004],[14,52],[12,20],[28,-39],[21,57],[3,58],[5,6],[0,50],[24,1],[11,164]],[[23326,51373],[22,7],[4,15],[19,-7],[2,-45],[11,2]],[[23384,51345],[-5,-105],[49,-306]],[[23428,50934],[-12,-34],[-3,26],[-13,-8],[-2,-88],[6,-26],[11,37]],[[23415,50841],[-4,-52]],[[23411,50789],[-34,-104],[-40,-143],[-15,-8],[-19,-39]],[[27377,63688],[50,-2]],[[27427,63686],[-1,-65],[-9,-30],[2,-50]],[[27394,63328],[-116,21]],[[27278,63349],[1,97]],[[26546,62626],[15,-28],[8,47],[54,134]],[[26623,62779],[60,-1]],[[26683,62778],[-5,-128],[13,-20],[-2,-61]],[[26689,62569],[-9,-166]],[[26680,62403],[-63,-42],[-17,1]],[[26600,62362],[-56,1],[2,263]],[[26671,65387],[1,-138]],[[26670,64962],[0,-101]],[[26542,64862],[-1,287]],[[25282,68443],[59,-2]],[[25341,68441],[41,-2]],[[25383,68033],[-34,0]],[[25349,68033],[0,53],[-67,1]],[[25282,68087],[0,356]],[[28269,64352],[68,110],[20,27]],[[28357,64489],[3,-47]],[[28360,64442],[0,-123],[19,-9]],[[28249,63943],[-2,-11],[-27,-4],[-16,39],[25,109],[-5,67],[15,72],[30,82],[-6,-3],[6,58]],[[22050,59537],[111,-1]],[[22223,59038],[0,-177]],[[22223,58861],[-20,-9],[-12,-30],[-5,-62],[-10,-30],[-2,-40],[-17,-27],[-27,20],[-17,33],[-9,48],[0,82],[-13,5],[-16,-57],[-3,-48],[-21,-38]],[[22050,59428],[0,109]],[[21754,68153],[5,0],[0,202]],[[21759,68355],[190,0]],[[21957,67829],[-10,23],[-27,-17],[-32,55],[-27,-66],[-19,10],[1,18]],[[21843,67852],[0,0]],[[21843,67852],[-9,-14],[-10,49],[-6,-5],[-10,42],[-18,39],[-5,-25],[-12,46],[-19,-10]],[[25479,59588],[15,1]],[[25494,59589],[14,-315]],[[25379,59425],[6,64],[-10,147]],[[21202,56314],[1,141],[0,416]],[[21203,56871],[0,11]],[[21203,56882],[119,0]],[[31330,38045],[7,26]],[[31337,38071],[6,7]],[[31373,37865],[-11,-16],[-14,24],[-12,-19],[-7,13]],[[31329,37867],[6,143],[-5,35]],[[22094,57108],[50,1],[0,253]],[[22261,57475],[9,5],[9,39],[10,-12],[-1,-60],[-7,-50],[7,-61],[27,-1],[2,-29],[-14,-9],[-2,-36]],[[22301,57261],[5,-55],[-22,-3],[-16,-109],[-2,-125],[10,-38],[-5,-21]],[[22271,56910],[-18,56],[4,22],[-16,5],[-18,57],[-4,-92],[-12,-4],[-10,26]],[[22197,56980],[-12,21],[-17,2],[-6,-49],[-30,15],[-24,78],[-14,61]],[[27025,57433],[9,-42],[8,-6],[4,-47],[19,-50],[9,-5],[17,-62],[13,-27],[3,16]],[[27165,57139],[-16,-94],[-6,-3],[-17,-99],[-15,-26],[-15,-46],[-3,-47],[-12,-69]],[[20924,70423],[170,0],[122,0]],[[21216,70423],[15,0]],[[27261,62555],[-8,-41],[18,-51],[4,-84],[19,8],[5,-13]],[[27299,62374],[-31,-110],[-1,-25]],[[27267,62239],[-18,-21],[-29,53],[-16,-28]],[[27204,62243],[-13,57],[5,45],[-14,24]],[[27182,62369],[44,128],[7,2],[28,56]],[[25225,68846],[101,-6]],[[25326,68840],[15,2],[0,-401]],[[25282,68443],[-94,-1]],[[21494,70549],[0,177]],[[21467,71222],[0,100]],[[15490,70789],[21,10],[13,-45],[-1,-55],[19,-42]],[[15542,70230],[-100,-7],[0,12],[-69,0]],[[15373,70235],[0,145],[-7,45],[16,36],[1,109],[-19,193],[27,-79],[14,-14],[-3,38],[23,10],[7,17],[11,-28],[12,31],[15,0],[20,51]],[[28632,64405],[20,31],[6,95],[22,77]],[[28768,64291],[-29,-44],[-5,-72],[-15,2],[-29,-52],[-24,-20],[-23,-2],[-28,-23]],[[28588,64149],[-46,120]],[[28494,65362],[17,-8]],[[28511,65354],[18,-215],[43,-118],[41,-33]],[[28613,64988],[-41,-138],[-13,-2]],[[28559,64848],[-26,19]],[[28488,64829],[-18,11],[-5,-71],[-22,-3],[-24,-19]],[[28419,64747],[-6,0],[-44,175],[-8,1],[-34,110],[-1,27],[-14,24],[-16,96],[-4,44]],[[28292,65224],[0,74]],[[26154,58599],[5,-24]],[[26159,58575],[-5,24]],[[26050,58864],[10,36],[6,-6],[8,38],[15,10],[55,-59],[-1,-45],[13,-16]],[[26156,58822],[6,-77],[9,-3],[-8,-117],[-8,-19]],[[26155,58606],[1,33],[-27,-29],[-24,29],[-20,-35],[-14,17],[-9,-13]],[[24377,68853],[34,0]],[[24411,68853],[0,-407],[-20,-41],[-3,-46],[13,-27],[9,-61],[-11,-68],[4,-15]],[[24403,68188],[-10,7],[-32,85],[-3,29],[-27,41],[-12,34]],[[24319,68384],[-9,44],[-1,51],[-8,15],[0,53],[-14,40],[-31,46]],[[90501,34555],[4,28],[2,101],[9,-12],[20,67],[5,-22],[-14,-80],[4,-63],[-13,7],[0,-73],[-12,18],[-5,29]],[[31256,37931],[0,-48],[-6,-45]],[[31250,37838],[-1,17],[-21,8],[-14,-33]],[[31230,38250],[7,101]],[[31237,38351],[26,-19],[4,19]],[[31267,38351],[6,-32]],[[31273,38319],[2,2]],[[31275,38321],[-5,-75],[1,-58]],[[31271,38188],[-11,18],[-26,14],[0,10]],[[31234,38230],[-4,20]],[[21486,60002],[132,3]],[[21754,60008],[34,0]],[[21788,60008],[0,-174],[-3,0],[0,-406]],[[21485,59429],[0,406],[1,167]],[[28613,64988],[11,38],[27,2]],[[28590,64530],[4,89],[-14,47],[-1,63],[-14,12],[-6,107]],[[21908,70421],[4,0]],[[21912,70421],[31,-86],[3,-62],[19,-126],[-8,-52],[-19,-15],[-7,-65]],[[21641,69873],[-147,0]],[[23368,53716],[18,-26],[11,15],[7,-51],[12,-24],[0,-59],[10,4],[17,-53]],[[23443,53522],[13,-46]],[[23231,53136],[-3,48],[13,33],[-5,21],[6,104],[19,54],[-1,46],[-9,21],[-5,92],[-10,4],[2,54]],[[22332,53590],[7,-39],[11,-19],[16,10],[4,-35],[23,-2],[-2,-38],[8,12],[4,48],[9,-27],[-2,-70],[15,26],[5,-17],[-2,-47],[17,10],[-11,-62],[13,-6],[4,-40]],[[22451,53294],[-1,-37],[16,-50],[-11,-37],[7,-40],[12,35],[7,-48],[-8,-14],[13,-43]],[[28409,60582],[15,-23],[8,-36],[21,-28],[22,-7],[0,-31],[11,24],[0,-31]],[[28486,60450],[-2,-34],[10,20],[0,-122]],[[28494,60314],[-19,-31]],[[28467,60300],[-11,66],[-16,-42],[-5,48],[-11,-9],[-41,21]],[[28383,60384],[6,71]],[[28001,61878],[15,96],[11,51],[11,-6],[32,113]],[[28086,61905],[-13,-52],[1,-25],[-15,-46],[-5,-54]],[[28045,61665],[-17,6],[-3,24],[-18,22],[-3,37],[-16,16],[13,108]],[[22181,66993],[-185,0]],[[21991,67449],[0,101],[-4,1],[0,275]],[[20994,51000],[-12,22],[-39,21],[-17,28],[-19,61],[-11,12],[-19,81],[0,24],[-14,47],[-21,7],[-12,27],[-5,34],[-30,78],[-9,43],[-7,110],[-12,56],[-7,60],[-13,63],[0,59],[-7,57],[6,72],[-3,54],[2,55],[-7,68],[-11,30],[-3,44],[-13,39],[-1,30],[-13,34],[2,33],[-13,177],[-7,40],[-12,4],[-4,24]],[[18517,60643],[-60,0],[0,-51]],[[18457,60592],[-38,0],[0,-29],[-61,9],[0,54],[-61,0],[0,104],[-32,0],[0,-16],[-129,0]],[[23461,54010],[136,-1]],[[23597,54009],[7,-53],[2,-108],[5,-61]],[[23632,53288],[-16,57],[-4,33],[-15,22],[-13,98],[-13,-1],[0,32],[-40,22],[-38,38],[-12,50]],[[23481,53639],[-7,17],[0,43],[-9,2],[-2,49],[-10,88],[0,66],[11,14],[-12,19],[9,73]],[[22944,52049],[15,43],[2,51],[13,17],[13,47]],[[22987,52207],[61,55],[30,47],[4,-6]],[[23082,52303],[9,-23],[19,28],[14,-17],[-2,-45]],[[23122,52246],[19,-48],[-2,-74]],[[23139,52124],[-18,-21],[1,-76],[-10,-4],[13,-79]],[[23125,51944],[-4,-19],[-28,25],[-8,25],[-64,-37],[-19,-1],[-10,-23]],[[18740,65163],[-9,-16],[-16,9],[3,-64],[-20,-34],[-57,0],[-71,-302]],[[18570,64756],[-85,-89],[-112,0],[-234,0]],[[18139,64667],[0,1156]],[[22752,56420],[7,-14],[-1,-63],[5,-30],[20,-5],[11,64],[9,7],[13,-19],[2,42],[10,19],[9,-28],[2,-66],[-10,-30],[12,-94],[11,-14],[11,31],[-3,64],[13,22],[-11,42],[13,-19],[16,57],[-3,73],[14,0]],[[22902,56459],[0,-620]],[[22902,55839],[-122,16]],[[22751,55859],[1,561]],[[22197,56618],[0,362]],[[22271,56910],[5,-140],[18,3],[2,-20],[12,11],[9,-15],[16,27],[10,-10]],[[22343,56766],[0,-441]],[[23099,53507],[126,239]],[[23098,52995],[-5,38],[5,64],[-8,20],[-7,72],[0,48],[-10,83],[3,122]],[[22716,50826],[-40,-120],[51,-225]],[[22670,50311],[-13,3],[-25,58],[-25,-35]],[[22607,50337],[-26,113]],[[27350,60351],[-9,-20],[44,-149]],[[27369,60096],[-34,-31],[-22,-28],[-15,2],[-16,27],[-17,-33],[-26,-78]],[[27239,59955],[-16,67]],[[28286,59868],[62,134]],[[28348,60002],[68,139]],[[28472,59946],[-46,-100],[-63,-124],[-24,-52]],[[28339,59670],[-17,16],[9,165],[-14,-21],[-19,8],[-12,30]],[[28043,59884],[14,219]],[[28114,60150],[2,-27],[17,-46],[24,-47],[22,7]],[[28179,60037],[-6,-285]],[[28173,59752],[-24,24],[-36,11],[-22,48],[-21,17],[-7,-14],[-20,46]],[[27299,62374],[8,17],[9,-27],[19,-14]],[[27349,62010],[-13,-58]],[[27321,61887],[-5,31],[-16,6],[-3,112],[-16,62],[2,59],[-5,43],[-11,39]],[[27075,60636],[11,-29]],[[27093,60176],[-24,-16],[-13,-90],[-32,-11]],[[27024,60059],[4,10],[-6,70],[-22,119],[-4,70],[-12,39],[-6,-12]],[[28000,59659],[43,225]],[[28173,59752],[-6,-272]],[[28167,59480],[-77,-1]],[[28053,59478],[-77,-1]],[[26515,61398],[-29,-89]],[[26486,61309],[-57,-56]],[[26429,61253],[-26,54],[7,75],[-5,35],[-8,-1]],[[27246,59515],[49,-3],[77,-12]],[[27274,59273],[2,18],[-7,76],[-7,21],[-16,94],[0,33]],[[28143,60540],[19,-3],[14,23],[0,23],[32,-19],[10,-22],[3,-45]],[[28221,60497],[-6,-1],[-1,-59],[12,-33],[11,-5],[-3,-34],[13,-41],[16,31],[15,-36]],[[28278,60319],[-27,-84],[-14,0]],[[28237,60235],[-8,11],[-113,109]],[[28555,60713],[17,-18],[26,-60],[18,-26]],[[28625,60476],[-12,-39],[11,-39],[7,-55],[9,-14],[-19,-11],[-22,-27]],[[28554,60453],[-15,60]],[[28029,62404],[25,-33],[1,33],[16,53],[13,-7],[0,-42],[9,-60]],[[28001,61878],[-63,185]],[[27938,62063],[20,130],[23,71],[0,-36],[10,24],[15,66],[7,-21],[14,63],[-6,16],[8,28]],[[27024,60059],[-13,-12],[-18,-49],[-7,11],[-11,-32]],[[31293,38270],[16,2]],[[31309,38272],[10,28],[5,-39],[30,14]],[[31354,38275],[12,-34]],[[31337,38071],[1,26],[-8,49],[-18,10],[-6,29],[-10,-24]],[[31296,38161],[-3,16],[0,93]],[[24237,70068],[34,0]],[[24408,70065],[0,-402]],[[24373,69565],[-137,2]],[[31178,38330],[22,47]],[[31200,38377],[8,-30]],[[31208,38347],[1,-84]],[[31209,38263],[-15,-5]],[[15337,71411],[72,-2],[131,0]],[[15540,71409],[1,-267],[2,-1],[0,-207]],[[15543,70934],[-102,1],[-1,-111]],[[15440,70824],[-9,-17],[-13,10],[-19,-51],[-9,7],[-21,74],[-10,8],[-7,-47],[-10,-10],[6,139],[1,124],[-4,165],[13,-61],[-2,-100],[4,-137],[17,0],[1,37],[-10,40],[0,61],[12,-37],[14,83],[-19,116],[11,42],[25,53],[-17,37],[-6,-27],[-18,-2],[4,-23],[-16,4],[-20,44],[-1,55]],[[27013,61145],[40,47],[32,12]],[[27085,61204],[-14,-45],[20,-14],[14,-31],[22,-16],[6,-56],[-6,-22],[16,-67],[21,25],[11,-49]],[[27175,60929],[-24,-17],[-20,-27],[18,-58],[-28,-48]],[[27121,60779],[-18,22],[-10,-21],[-3,22],[-18,-14],[-4,-24],[-14,63],[-11,0],[-7,57],[0,59],[-11,45],[10,23],[-4,46],[-11,15],[-7,73]],[[16328,60062],[18,61],[69,78],[34,4],[15,19]],[[16464,60224],[81,272],[31,1],[0,50],[10,1],[0,38],[9,0],[0,77],[76,253]],[[16682,60871],[15,-29],[5,26],[21,-3],[16,-58],[9,-63],[3,-52]],[[25460,68909],[8,38]],[[25468,68947],[101,-2]],[[25569,68945],[-18,-82],[-9,-62],[-20,-261]],[[25459,68540],[1,369]],[[24920,62948],[47,1]],[[25077,62745],[0,-153]],[[24938,62338],[-17,-1]],[[19961,62592],[14,15],[6,31],[10,-1]],[[19991,62637],[6,-20],[-1,-48],[6,-29],[16,-23],[4,-40],[60,0],[20,-58],[-2,-31],[27,-59],[12,21],[4,-27],[13,-10],[15,75],[15,15],[11,-13],[15,-54]],[[20212,62336],[11,1],[25,-100],[15,12],[26,-23],[-8,-56],[-19,-51],[1,-102],[-9,-32],[6,-44],[16,-45],[7,-68],[4,-78],[24,-83]],[[20100,61346],[-158,0]],[[19942,61346],[2,13],[-7,106],[-13,61]],[[25845,62734],[36,2]],[[25928,62739],[1,-342]],[[25863,62395],[-15,0],[0,236],[-3,103]],[[26782,52851],[13,23]],[[26795,52874],[35,-40],[4,-62],[10,-46],[27,-9],[27,-24],[6,-21],[-1,-121]],[[26903,52551],[-29,7]],[[26874,52558],[-125,30]],[[26749,52588],[1,193],[8,17],[5,52],[19,1]],[[27851,58040],[59,250]],[[27925,58362],[58,-75]],[[28667,66305],[34,3]],[[28701,66308],[14,-209],[-2,-51],[-8,-1],[3,-218]],[[28708,65829],[-11,0]],[[28697,65829],[-115,2]],[[28582,65831],[5,60],[-6,121],[7,0],[0,147]],[[28582,59255],[29,31]],[[28611,59286],[22,-139],[16,-21],[12,-60]],[[28661,59066],[13,-68],[10,-27],[-7,-14],[-31,45],[-13,5],[-5,29],[-18,24],[23,-73],[21,-23],[-7,-19],[-24,-11]],[[28623,58934],[-22,11],[-23,27],[-5,152],[5,22],[4,109]],[[25524,58838],[0,-27],[-21,-27],[-14,-36],[-13,-11],[-3,-78]],[[20523,60683],[12,40],[11,1],[9,31],[20,22],[17,-44],[14,-1],[-9,-44],[11,-42],[1,-104],[5,1],[8,-53],[-10,-27],[0,-116],[3,5]],[[20615,60352],[0,-347]],[[20615,60005],[-19,0]],[[20664,63541],[0,0]],[[20674,64664],[124,5],[124,-1]],[[21055,64669],[0,-349],[-2,-6],[0,-202]],[[20895,63504],[-95,-1],[-131,0]],[[20669,63503],[0,51],[-11,-21],[3,-21],[-18,-9]],[[20643,63503],[-1,1],[1,303]],[[20643,63807],[-1,102],[31,0],[0,287],[1,101],[0,367]],[[26190,57412],[3,60],[20,0],[0,52],[11,8],[12,136]],[[26236,57668],[47,0]],[[26254,57256],[-3,-21],[-35,8]],[[26444,62138],[5,-26],[45,-40]],[[26494,62072],[21,19],[20,-22]],[[26535,62069],[-24,-203]],[[26511,61866],[-12,-13],[-14,17],[-10,-39],[-11,-11]],[[26451,61852],[-8,280],[1,6]],[[25990,63757],[-106,-3]],[[25884,63938],[0,34],[106,4]],[[26165,59923],[8,84],[11,42],[34,178]],[[26212,59846],[-15,-37],[-32,68],[5,-36]],[[25350,59856],[-9,79],[-14,54]],[[22178,60454],[1,-444]],[[22179,60010],[-129,2]],[[22050,60012],[-24,1]],[[22026,60013],[-1,448],[-4,0],[0,102]],[[28028,58872],[-38,61],[-19,-4]],[[28806,57915],[1,-17]],[[28807,57898],[-54,-93],[-19,-51],[8,68],[8,0],[47,86],[9,7]],[[28624,58494],[38,-8],[-7,-95],[22,-12],[11,66],[2,50],[7,5],[15,-38],[13,-5]],[[28725,58457],[9,4]],[[28734,58461],[31,0],[9,-100]],[[28774,58361],[-13,-52],[-10,-9],[-3,-43],[-7,-11],[-7,-71],[-13,-15],[-3,-46],[-17,-25],[-3,-24],[-26,25],[-29,-4],[-26,18],[-5,25],[-10,-14],[-15,45],[-13,115],[31,3],[2,51]],[[28607,58329],[-10,30],[-10,2],[-17,61],[0,40],[-10,41]],[[24582,55363],[0,105],[59,-2]],[[24654,55264],[-29,-101],[0,-25],[19,1],[-6,-29],[7,-28],[-15,-43],[22,-47],[-6,-29],[-6,31],[-4,-33]],[[24636,54961],[-68,1],[1,204],[13,123],[0,74]],[[31330,38045],[-15,-19],[-6,24]],[[31309,38050],[-8,-1]],[[31301,38049],[-8,44]],[[31293,38093],[-1,67],[4,1]],[[26773,55448],[-5,-62],[6,-49],[-7,-45]],[[26767,55292],[-21,72],[-58,-96]],[[26668,55570],[18,-6],[25,8]],[[22469,66993],[9,-59],[34,-52],[10,-24]],[[22522,66858],[1,-141]],[[22258,66767],[1,226]],[[27870,61354],[6,37],[16,15],[7,-20],[-3,-44],[-8,-25],[-10,5],[-8,32]],[[23076,64719],[10,-27],[22,-30],[17,25],[10,36],[21,21],[13,-16],[30,1]],[[22413,68388],[103,0]],[[19530,53413],[-64,2],[-201,-1],[-128,-1]],[[23594,57109],[2,258]],[[23655,56742],[-63,-3]],[[23592,56739],[2,370]],[[27378,57051],[11,-45],[13,-7],[7,-42],[-16,-126]],[[27393,56831],[-38,-19],[-37,-45],[-24,8],[1,-54],[-28,65],[-11,11]],[[27256,56797],[-14,101],[-15,149],[0,47]],[[16637,56552],[8,-17],[11,14],[0,-30],[-17,-4],[-9,21],[7,16]],[[16634,57567],[17,0],[0,-25],[29,0],[0,-26],[10,1],[0,-51],[74,-2],[0,-25],[26,0]],[[16790,57439],[64,-544],[6,-95],[-10,-6],[0,-80],[-34,0],[-42,-108],[-1,-35]],[[16773,56571],[-40,62],[-12,2],[-24,53],[-17,141],[-10,10],[-17,53],[-4,-3],[-20,65],[-5,3]],[[16596,55679],[14,7],[20,-35],[8,-31],[-13,-15],[-20,21],[-9,53]],[[17004,56219],[6,18],[2,52],[16,82],[15,38],[0,46],[53,1]],[[17127,56368],[26,-118],[12,-14],[1,-55],[16,-8],[18,-52],[-28,-145],[1,-34]],[[17173,55942],[0,-41],[-20,-18],[-4,-78]],[[17149,55805],[-10,50],[-15,37],[-9,-2],[-19,95],[-26,59],[-14,15],[-20,57],[-18,66],[-14,37]],[[26880,50342],[69,1],[0,-34],[44,2]],[[26877,50038],[4,60],[-2,41],[5,83],[-6,66],[2,54]],[[27127,54368],[43,43],[53,60]],[[27223,54471],[12,-169]],[[27235,54302],[7,-56],[18,-57],[10,-103],[18,14],[18,-78],[-11,-46],[1,-61],[5,-44]],[[27301,53871],[-12,0]],[[23731,67576],[0,-284]],[[23731,66887],[-132,1]],[[23599,66888],[0,404]],[[21482,60760],[0,110]],[[21617,60463],[-135,0]],[[20615,60352],[12,6],[31,82],[19,31],[14,-10],[36,23],[16,43],[2,61],[7,-1],[29,86],[4,55],[24,142],[30,92]],[[21102,60760],[92,-1]],[[20934,60006],[-92,-3],[-184,0],[-43,2]],[[24949,62040],[1,-102],[-31,-1]],[[24791,62074],[13,38]],[[24804,62112],[1,51],[-38,82],[-7,4]],[[26961,48307],[34,-1],[0,102],[55,-1]],[[27187,48102],[-138,1]],[[27049,48103],[2,37],[-2,86],[-8,14],[0,40],[8,10],[-4,31],[-12,-4],[-5,-33],[-11,-11],[8,-148],[-20,-24]],[[27005,48101],[-15,24]],[[26990,48125],[-5,44],[-24,138]],[[25585,61461],[0,-52],[-42,0],[0,-42]],[[25543,61367],[-62,4]],[[25398,61442],[0,31]],[[24587,65565],[31,0],[20,-43],[11,31],[27,-3],[11,20],[19,-3],[17,-51],[26,-1]],[[24749,65515],[1,-36],[-9,-59],[1,-66],[-16,-21],[-18,-57],[-26,1],[-10,-13],[-16,-56],[-24,-17],[-14,3]],[[15843,66991],[4,83],[48,0],[8,98],[8,44],[-1,31],[18,51],[-9,33],[-3,82],[-12,55],[-19,39]],[[16234,65824],[-44,-1],[-114,4]],[[15841,65840],[1,327],[1,824]],[[22893,50819],[-91,-279]],[[25262,54067],[12,388]],[[25277,54549],[137,3]],[[25414,54552],[-25,-30],[3,-116],[-8,-47],[-2,-73],[-7,-24],[-14,-10],[1,-42],[12,-31]],[[25374,54179],[1,-37],[-15,-10],[10,-33],[-12,-20],[-3,-47],[-11,-50],[10,-80],[11,10],[5,-72]],[[25370,53840],[-105,-1]],[[25265,53839],[-3,228]],[[25286,54863],[6,197],[5,212]],[[25297,55272],[2,72]],[[25299,55344],[47,5]],[[25435,54810],[0,-20],[-17,3],[-11,-52],[-22,-46],[-4,-66],[21,-38],[12,-39]],[[23760,59427],[78,0]],[[23913,59427],[6,-1]],[[23919,59426],[-1,-372],[-1,-66]],[[23917,58988],[-49,4]],[[23868,58992],[-20,1],[0,34],[-10,1],[0,35],[-10,18],[1,67],[-13,19],[2,32],[-44,4]],[[16425,58601],[183,0]],[[16608,58601],[204,1],[119,0],[86,2],[17,-3]],[[17129,57476],[-184,-4],[-147,-2],[-8,-31]],[[16626,57567],[0,205],[-5,17],[-20,-5],[2,108],[-31,-6],[0,102],[-40,1],[0,102],[-20,0],[0,102],[-32,1],[-10,69],[-15,32],[0,103],[-30,-1],[0,204]],[[27187,48102],[0,-299]],[[27187,47803],[1,-105],[-27,-2],[0,-121],[-45,-1],[-7,16]],[[27109,47590],[-7,57],[-28,113],[-11,9],[-1,52],[-12,23],[0,-64],[-14,-11],[-1,66],[-8,113],[-12,51],[3,24],[13,-3],[9,-39],[9,122]],[[26992,48019],[5,-18],[19,-211],[8,-28],[17,-26],[7,17],[14,-21],[-14,-31],[-9,-1],[-21,50],[-7,28],[-13,115],[-6,76],[0,50]],[[27005,48101],[-9,-7],[-5,-50],[-1,81]],[[20012,64670],[128,0]],[[20205,63415],[-8,-6],[-106,-1]],[[20090,63609],[0,156],[-112,-2]],[[19978,63763],[-1,129],[3,0],[1,242],[16,0],[0,67],[16,0],[-1,469]],[[24970,60670],[0,5]],[[24970,60675],[14,-10],[6,44],[83,0]],[[25073,60709],[31,-4]],[[25104,60705],[-1,-311]],[[25103,60394],[-57,7]],[[25046,60401],[-66,-1]],[[24980,60400],[14,11],[4,62],[-26,161],[-2,36]],[[22202,60010],[-23,0]],[[25589,61056],[9,-23]],[[25598,61033],[13,-34],[18,-13],[8,-62],[11,3],[7,27],[5,97],[19,42]],[[25149,51924],[13,-63],[5,-76],[-3,-101],[-10,-105],[-4,3],[8,90],[4,100],[-1,46],[-12,106]],[[25020,51931],[11,38],[32,81],[2,-14],[-13,-63],[2,-28],[13,-33],[-15,-50],[-3,47],[-10,-10],[-17,10],[-2,22]],[[24877,51859],[3,-49],[8,-25],[12,4],[13,25],[-4,-59],[8,-34],[15,-19],[13,11],[6,29],[5,101],[-2,13],[24,54],[3,44],[18,-34],[13,6],[0,-21],[-17,-34],[0,-34],[15,-17],[3,-61],[15,14],[11,82],[16,-25],[-4,-55],[-13,0],[-12,-44],[22,2],[-3,-29],[-31,-22],[13,-66],[11,22],[-7,-59],[-9,26],[-14,11],[-12,-55],[-1,-99],[-9,-5],[-6,86],[-11,1],[-2,-66]],[[24967,51478],[-10,-6],[-16,18],[-16,41],[-10,49],[-20,4],[-7,47],[-12,-10],[-14,87]],[[24862,51708],[-5,62],[-12,4],[-11,25],[6,51],[10,-10],[16,25],[11,-6]],[[18690,67021],[3,-37],[-10,-20],[2,-27],[-13,-7],[-6,-57],[8,-75],[-7,-47],[2,-46],[9,-60],[14,22],[24,0],[7,-51],[0,-45],[8,-22],[0,-108],[9,-41],[2,-85]],[[18742,66315],[-5,0],[-1,-186],[-24,0],[0,34],[-39,0]],[[18591,66416],[1,76],[8,4],[2,87],[-11,0],[0,34],[-11,25],[0,42],[-11,0],[0,67],[-5,0],[-1,142],[-19,71],[-16,-37],[-16,-7],[-10,-35],[-3,53]],[[18499,66938],[2,44],[10,2],[14,36],[165,1]],[[21658,63505],[24,1]],[[26476,53117],[32,-1]],[[26508,53116],[0,-42],[74,-4]],[[26582,53070],[-2,-442]],[[26580,52628],[-73,16]],[[26507,52644],[-22,5]],[[26205,53385],[-1,63],[8,80],[-2,43],[7,57]],[[26217,53628],[5,-36],[25,20],[33,-3]],[[26331,53531],[-1,-203]],[[26252,53111],[-29,3]],[[26223,53114],[-3,38],[-20,91],[3,54],[-5,51],[7,37]],[[18875,67719],[0,350]],[[28737,62777],[-11,13],[18,70],[-10,6],[12,122],[-30,-17]],[[28716,62971],[-20,89],[-7,47],[-11,31],[-5,41]],[[26926,67191],[4,-77],[18,-110],[2,-48],[-11,-46],[-7,-145],[4,-47],[-12,-113],[-4,-67],[-18,-66],[-15,4],[-12,-42],[1,66],[-9,27],[10,16],[15,62],[-14,26],[-9,-5]],[[26869,66626],[-7,44],[-2,206],[-68,-5]],[[24544,57270],[130,-5]],[[24674,57265],[-1,-30],[12,-61],[-7,-45]],[[24678,57129],[-5,-33],[6,-83],[-25,-57],[0,-63],[-10,1],[3,54],[-19,-1],[-5,-27],[8,-45],[-7,-30],[-19,-15],[-4,-71],[-16,43],[-9,-29],[14,-43],[20,1],[2,-25],[-13,-28],[-16,33],[-12,-53]],[[24571,56657],[-45,0]],[[24526,56657],[10,29],[-4,38],[10,47],[-6,38],[7,101]],[[15847,61244],[23,-7],[12,-26],[23,36],[21,6],[16,-24],[18,22]],[[15960,61251],[8,-40],[12,-15],[15,10],[15,40],[6,40],[23,-2]],[[16045,60961],[-111,-113],[-16,32],[4,19],[-13,41],[-26,7],[-11,14],[-13,72],[-13,32],[-12,-10]],[[15834,61055],[-18,9],[-14,68],[8,-9],[9,26],[0,40],[19,-2],[9,57]],[[29578,65411],[12,6],[2,-43],[-4,-59],[19,7],[10,-21],[12,33],[13,7]],[[29702,64964],[-9,15],[-26,1],[-7,-26],[-18,23],[-40,-27],[-3,60],[-9,-17],[-19,-82],[-12,0],[-16,-48]],[[29543,64863],[-4,12],[4,59],[11,83],[-13,36],[-20,89],[-34,70]],[[29487,65212],[-3,41],[46,14],[-3,48],[20,15],[10,43],[21,38]],[[25668,61411],[0,-99],[-15,0],[-5,-80],[-18,5],[0,-35],[-8,-15],[-24,-100],[0,-54]],[[25547,61106],[0,109],[-6,0],[2,152]],[[25953,61661],[0,82],[10,16],[21,2],[10,67]],[[26071,61880],[21,1],[5,-24],[14,0]],[[26111,61857],[3,-53],[-5,-19]],[[26109,61785],[-11,-21],[-7,-44],[-30,-34],[-9,-69]],[[26052,61617],[-10,-92],[-19,-39],[-13,24]],[[27079,50651],[82,1],[0,102],[6,0],[-1,266]],[[27166,51020],[7,-82],[15,-7],[8,-27],[9,-92],[10,-2],[2,-38],[29,-92],[0,-102],[-4,-21]],[[27242,50557],[-14,-63],[1,-46]],[[27161,49938],[-37,-1],[0,18],[-18,0],[0,-18],[-28,-1]],[[26420,62364],[8,-77],[14,-64],[2,-30]],[[26444,62193],[-43,-73],[-9,-7]],[[26392,62113],[-13,52],[7,66],[-6,44],[3,56],[-11,32],[-4,86]],[[26368,62449],[9,31],[8,-8],[4,-69],[31,-39]],[[24509,53025],[33,0]],[[24607,53025],[-10,-66],[4,-63],[-3,-34],[6,-53],[-4,-110]],[[24475,52618],[-3,5]],[[24472,52623],[-3,53],[8,19],[4,50],[12,43],[0,34],[13,130],[3,73]],[[26718,52165],[11,60],[-1,38],[12,47]],[[26740,52310],[4,38],[20,24],[2,-14],[21,4],[10,-14],[23,-61],[24,-33]],[[26844,52254],[1,-408],[9,-24],[-11,-39]],[[26843,51783],[-18,-25],[-4,-28]],[[24381,53025],[128,0]],[[24472,52623],[-6,6]],[[24374,52992],[7,33]],[[24357,53078],[18,-1],[0,-58]],[[24349,53048],[8,30]],[[30793,68290],[11,-48],[-5,-69],[-16,-10],[-3,85],[3,51]],[[30712,67988],[8,37],[1,-75],[-9,38]],[[30703,68290],[8,41],[25,45],[11,-50],[-9,-8],[14,-78],[-11,-39],[-18,-13],[-12,24],[5,25],[-3,50],[-10,3]],[[30680,68449],[-7,-90],[-13,-78],[19,-30],[-13,-28],[10,-57],[-10,-38],[-27,4],[-13,-72],[-15,-1],[-2,-58],[-11,-9],[0,52],[7,37],[-9,15],[-3,-30],[-12,-13],[2,61]],[[30583,68114],[3,60],[10,-8],[2,32],[11,22],[-8,50],[2,43],[-9,90],[-19,1],[-8,19],[-5,101],[12,17]],[[26633,66337],[131,14]],[[26764,66351],[59,5]],[[26823,66356],[-7,-77],[-17,-53],[-30,-25],[-18,-97],[2,-127],[-3,-44],[-15,-25],[0,-43]],[[26735,65865],[-32,75],[-66,-10]],[[24914,57677],[0,-260]],[[24914,57417],[-53,0],[0,-16],[-32,-58],[-22,29],[-6,32],[-12,-2],[-8,-40]],[[24781,57362],[0,158],[-29,0]],[[24752,57520],[-2,13],[18,44],[0,45],[-17,55]],[[28412,62750],[0,1]],[[28492,62746],[13,-45],[16,-19],[-5,-33],[27,-61]],[[28543,62588],[-13,-40],[-12,-60],[-15,-29]],[[28503,62459],[-13,32]],[[24796,60757],[10,35]],[[24806,60792],[31,175],[17,62]],[[24854,61029],[10,-6],[16,42],[13,-28],[1,-29],[15,-12],[19,-51]],[[24928,60945],[2,-59],[14,-3],[9,-42],[19,-24],[2,-79],[9,-34],[-13,-29]],[[24970,60670],[-19,9],[-3,33],[-7,-17],[-28,14],[-6,-12],[-15,15],[-16,-4]],[[24636,62599],[3,-80],[8,-78],[-9,-36],[11,-85],[3,-58]],[[24652,62262],[-5,-21],[-12,11],[-22,-17],[-1,-39],[-33,12]],[[24579,62208],[0,0]],[[24579,62208],[-2,-2]],[[24577,62206],[0,0]],[[24577,62206],[-2,1]],[[24575,62207],[0,0]],[[24575,62207],[-5,-19]],[[23536,72129],[3,-505],[0,-201],[-36,0]],[[23503,71423],[-104,1]],[[23399,71424],[0,202],[-2,0],[0,203]],[[23397,71829],[0,201],[-4,0],[0,102]],[[23550,60009],[-108,1]],[[23442,60010],[-18,0]],[[23424,60010],[-1,56],[0,340]],[[22933,70005],[162,0]],[[23133,69803],[-1,-201],[5,-73]],[[23034,69703],[-14,57],[-27,38],[-18,4],[-14,55],[-9,73],[-19,75]],[[28873,62764],[21,-61],[10,-68],[3,-58],[-5,-35],[2,-126],[16,-48],[9,-92]],[[28929,62276],[-19,18],[-6,-50],[-23,-17],[-10,-56],[-10,-24],[-46,-6]],[[28808,62505],[-3,120]],[[17343,68337],[124,-2]],[[17395,67934],[-39,-16],[-12,17],[-5,33],[-12,1],[0,50],[-7,0]],[[17320,68019],[0,41],[12,81],[1,43],[-11,32],[-1,42],[12,17],[10,62]],[[26284,65284],[-108,-5]],[[26805,51386],[46,-7],[4,-26],[28,2]],[[26953,51263],[1,-314],[-37,-1],[0,-198]],[[26917,50750],[-17,-17],[-5,-24],[-21,28],[-7,-3],[-13,-44]],[[26854,50690],[0,71],[-16,26],[5,33],[-1,49],[-7,13],[-47,23],[-9,-51],[-7,-4],[-9,100],[3,45],[-14,32],[-11,7]],[[26949,52539],[-11,3]],[[26938,52542],[-35,9]],[[26795,52874],[0,366]],[[25888,65551],[1,363]],[[25889,65914],[128,-3]],[[25934,65552],[-46,-1]],[[24936,57677],[81,-2]],[[25017,57675],[0,-174],[15,0],[1,-304],[14,0]],[[24929,57164],[0,152],[-15,0],[0,101]],[[26078,66725],[-66,0]],[[21479,64671],[224,0]],[[21703,64671],[0,-356]],[[21479,64375],[0,294]],[[21479,64669],[0,2]],[[29286,63620],[-13,-221],[-5,-173],[-40,-241],[-20,-65]],[[29208,62920],[-19,-1],[-11,68]],[[29178,62987],[8,45],[0,207],[-45,356]],[[29141,63595],[40,108],[41,-6],[5,-60],[25,-18],[13,43],[10,-56],[11,14]],[[25525,63046],[41,0]],[[25617,63045],[0,-101],[-11,1],[0,-305]],[[25505,62641],[-2,26],[9,68],[13,9],[0,150]],[[28468,65832],[1,323]],[[28582,65831],[-103,2]],[[26266,62223],[20,-11],[1,-40]],[[26174,61979],[-1,259]],[[23398,71322],[1,102]],[[23503,71423],[3,-477],[13,-30]],[[20686,67576],[235,5]],[[20922,66996],[0,-453]],[[23552,61730],[84,-7],[15,-25],[9,11],[14,-16],[25,12],[5,-10]],[[23704,61695],[-2,-271],[7,0]],[[23706,61217],[-14,1],[-13,23],[-23,-36],[0,29],[-104,10]],[[22532,63506],[0,404]],[[22658,63911],[0,-406]],[[22658,63505],[-31,0]],[[22627,63505],[-95,1]],[[26137,62031],[-21,2],[-12,-33],[7,-143]],[[29236,64822],[85,-158],[3,-1]],[[29324,64663],[-6,-92]],[[29318,64571],[-5,-42]],[[29299,64433],[-9,28],[-23,-55],[-13,12]],[[29254,64418],[4,39]],[[29258,64457],[3,45],[-6,126],[-30,29],[-6,34],[17,131]],[[29300,65041],[122,52]],[[29422,65093],[-2,-82],[19,-97],[-68,-130],[20,-102],[-1,-33]],[[29390,64649],[-7,-42],[-21,-42],[-2,-42]],[[29360,64523],[-42,48]],[[29324,64663],[2,154],[-12,88],[-11,50],[7,50],[-10,36]],[[28051,67145],[0,-47]],[[28051,67098],[-13,11],[-26,-30],[-34,16],[-21,-24],[-11,-54],[-14,3],[-1,26],[-14,27],[-21,-1]],[[27896,67072],[-15,13],[9,77],[-5,125],[-3,13],[28,22],[38,42],[56,47],[40,20],[7,-4]],[[27141,59301],[26,-48],[20,-90],[4,5],[20,-42]],[[27119,58976],[-6,67],[-7,29],[-8,-5],[-7,31],[4,65],[-6,18]],[[23155,69500],[220,0]],[[23309,69035],[-12,21],[8,19],[-32,74],[-16,62],[-11,0],[-7,37]],[[22846,60009],[110,0]],[[22956,60009],[0,-252],[-20,-17],[-3,-28],[-15,9],[-12,-76],[-28,18],[-9,-20],[5,-95],[-3,-11]],[[22871,59537],[-113,0]],[[22758,59537],[0,472]],[[25279,60709],[0,-204]],[[25196,60403],[1,305]],[[28849,64855],[16,72],[10,10]],[[28875,64937],[41,8]],[[29018,64774],[7,3]],[[20311,57933],[-98,3],[-12,-17],[-5,17],[-150,2]],[[18514,68126],[-83,1],[-1,304]],[[26203,69750],[0,-36],[14,-1],[13,-73],[10,22],[65,-2]],[[26305,69660],[-1,-102]],[[26122,69565],[5,73],[17,49],[10,3],[18,48],[31,12]],[[26125,70269],[7,-20],[-12,-20],[5,40]],[[26084,70289],[21,-39],[-4,-36],[-19,38],[2,37]],[[26055,70019],[7,48],[3,69],[6,15],[1,57],[18,-7],[-1,-85],[4,-83],[-19,-44],[-19,30]],[[26035,70180],[13,8],[-5,-54],[-7,1],[-1,45]],[[26572,65927],[3,-418]],[[26542,65505],[-134,-16]],[[24319,68384],[-61,0],[0,-101]],[[24126,68386],[0,202],[34,0],[0,101],[52,-1]],[[23555,62524],[0,346]],[[23553,62471],[2,53]],[[22847,58526],[1,253]],[[22848,58779],[144,-1]],[[22847,58222],[0,304]],[[25175,57677],[-10,0]],[[25111,57676],[-51,0]],[[25060,57676],[1,20],[3,449]],[[23603,73631],[13,13],[33,-15],[11,-58],[61,-7],[48,-21],[8,-66],[-3,-49],[6,-12],[42,2],[5,15],[22,-2],[23,20],[-1,48],[33,46],[39,18],[9,-22],[25,5]],[[23979,72689],[-194,9],[0,-62],[-179,0]],[[23603,73243],[0,388]],[[23147,71828],[-36,-1]],[[23111,71827],[-177,-1]],[[25494,62522],[-4,17],[-25,8],[-57,-5]],[[25391,62780],[-1,118],[15,1]],[[23290,71827],[107,2]],[[23117,71323],[0,302],[-6,0],[0,202]],[[23127,65675],[130,-4]],[[23131,65462],[11,17],[-6,54],[8,20],[3,46],[-12,23],[-8,53]],[[24678,57129],[48,-117]],[[24711,56603],[0,-101]],[[24711,56502],[-57,2]],[[21038,58136],[69,0],[2,8],[0,298],[2,101]],[[21204,58543],[0,-136]],[[21204,58407],[-1,-511]],[[21203,57629],[-67,0],[0,-104],[-29,1],[-1,-102],[-29,1],[0,-102],[-59,1],[0,-101],[-9,-1]],[[21009,57222],[-58,1]],[[20901,57425],[1,423]],[[29166,64200],[44,11],[4,-19],[21,14],[3,-13]],[[29238,64193],[-4,-40],[-9,-16],[-3,-50]],[[29222,64087],[0,-43],[10,-14]],[[29232,64030],[-6,-53],[-30,-96],[-11,-53],[-25,-30]],[[29160,63798],[0,23],[-39,60],[1,57]],[[27804,62289],[60,-168]],[[27864,62121],[22,-60]],[[27886,62061],[-9,-48],[-1,-71],[-8,1],[-29,-212]],[[27839,61731],[-24,-77]],[[24431,55807],[-1,-446]],[[24430,55361],[-169,3]],[[24261,55364],[-11,27],[-6,45],[0,57],[5,44],[-8,7]],[[24711,56502],[0,-203]],[[24711,56299],[0,-561]],[[24637,55669],[-13,0],[0,301]],[[24723,57488],[19,32],[10,0]],[[24781,57362],[-8,-31],[4,-60],[-7,-24],[6,-77],[6,-6]],[[24782,57164],[0,-51]],[[24674,57265],[-1,34],[10,21],[-1,-49],[11,-18],[14,50],[-2,31],[-20,2],[-6,40],[7,14],[-2,35],[10,27],[-2,-57],[5,-34],[14,19],[-6,72],[5,25],[-8,44],[2,29],[11,-2],[8,-60]],[[24081,64189],[8,-34],[-4,-38],[6,-33],[-9,-62],[12,-44],[-5,-16],[0,-60]],[[23899,63948],[-2,230]],[[27261,62555],[-1,19],[12,76],[6,1]],[[27278,62651],[5,46],[28,7],[21,17],[10,26]],[[27342,62747],[13,-13],[8,58],[14,-34],[-2,-77]],[[27334,62967],[26,78]],[[27342,62747],[-5,129],[-10,17],[-16,-22]],[[27311,62871],[5,35],[18,61]],[[27573,60142],[14,12]],[[27587,60154],[6,-53],[-4,-101],[-6,-48],[-8,3],[-7,-59],[-11,-34]],[[27557,59862],[-15,-17],[-15,-52],[-12,-18],[-2,-62],[-14,4],[-5,-46]],[[27494,59671],[-48,260]],[[20593,72571],[-36,0],[0,-303],[-12,-1],[0,-405]],[[20545,71862],[-119,0],[0,-103],[-36,0],[1,103],[-36,0]],[[20263,72766],[-3,70],[8,51],[22,-7],[25,-34],[29,5],[-5,-28],[14,4],[2,29],[20,-33],[3,31],[24,-34],[5,35],[16,-28]],[[23305,62405],[-1,-218]],[[23180,62187],[0,266],[-26,33]],[[22918,68387],[121,1]],[[24679,52619],[-96,-1]],[[24684,71167],[12,6],[25,-27]],[[24857,70836],[0,-370],[-32,0]],[[24753,70465],[0,202],[-35,-1],[0,101],[-35,0],[1,400]],[[21045,53785],[79,-1]],[[21271,53785],[9,0]],[[21280,53368],[-17,-31],[-29,97],[-22,24]],[[21212,53458],[-13,17],[-3,-24],[-31,6],[-18,22],[-5,45],[-19,-18],[-18,22],[-18,-3],[-8,36],[-4,53],[2,53],[-5,37],[1,51],[-6,19],[-12,-11],[-10,22]],[[22343,56766],[9,-36],[17,-24],[13,-3],[13,-26],[21,-4],[12,37],[10,-9]],[[22490,56327],[-147,-2]],[[22806,47905],[18,-220]],[[22824,47685],[-5,0]],[[22819,47685],[-11,152],[-24,16],[18,27],[-3,24]],[[22764,47904],[7,-54],[1,-84],[9,-1],[8,-80]],[[22789,47685],[-11,0],[-16,-101],[-9,13],[-12,-15],[-1,-28],[-93,57]],[[22647,47611],[0,99],[-40,18],[13,190]],[[24304,54779],[7,44],[14,-29],[0,29],[9,32],[16,-16],[12,65],[9,-2],[10,65]],[[24381,54967],[11,0],[0,-99],[42,0]],[[24431,54816],[-8,-50],[3,-103]],[[24426,54663],[-44,-1],[-18,-42],[-7,-42],[-11,2],[-4,-107],[-12,-34],[-3,-38],[-18,-34]],[[24270,54513],[7,100],[7,59],[11,41],[9,66]],[[24359,64199],[9,-53],[18,-14],[-1,-36],[16,-57],[10,-2],[1,-56],[11,-31],[19,-7]],[[24442,63943],[-8,-18],[-13,-99],[-1,-34]],[[24420,63792],[-126,10]],[[24294,63802],[0,51]],[[27513,63080],[13,-29],[54,-2],[52,-171],[8,-13]],[[27640,62865],[-24,-59],[-17,-18],[-10,18],[-21,-10]],[[27568,62796],[-24,49],[-59,40]],[[27134,62549],[8,41]],[[27142,62590],[10,12],[3,55],[31,-7],[3,83],[25,76],[9,5],[18,-77]],[[27241,62737],[13,-51],[18,-7],[6,-28]],[[27182,62369],[-46,81]],[[27568,62796],[-1,-142],[10,-33]],[[27560,62470],[-21,-11]],[[27539,62459],[-82,74]],[[20051,73979],[195,-1],[102,0]],[[20348,73978],[0,-103],[-11,0],[0,-101],[36,0],[0,-303],[61,0]],[[30059,66688],[3,7]],[[30062,66695],[18,-6],[-1,62],[15,36],[19,-18],[9,62],[36,32],[15,-30],[8,13]],[[30181,66846],[2,-72],[9,-136],[25,-47],[12,42],[14,-34],[-16,-90],[-23,-7],[-38,-35],[12,-50],[-18,-50],[-7,9],[-5,-59],[-7,30]],[[30123,66348],[-7,37],[4,56],[-10,8],[5,50],[8,0],[-9,41],[-21,-12],[-34,67],[5,15],[-5,78]],[[26982,59308],[14,27],[17,-23],[42,100],[15,26]],[[27085,59155],[-27,-157],[-15,-29]],[[27004,59029],[-2,39],[-11,23],[3,27],[-17,31],[-6,-8]],[[25656,59595],[83,7]],[[25739,59602],[48,4],[7,-22]],[[25741,59318],[-19,-64],[-20,45],[-5,-7]],[[25697,59292],[-21,-16],[-5,27],[-32,74]],[[25639,59377],[1,110],[-4,15],[5,92]],[[24432,56010],[29,0],[7,-52],[22,-2],[4,52]],[[24498,55970],[9,-25],[-14,-80],[18,16],[-1,51],[14,-27],[-4,-54],[-17,-10],[-3,-19],[10,-24],[17,14],[10,73],[5,-32],[-23,-90],[0,-64],[12,-68],[3,42],[10,13],[2,-23],[-13,-52],[2,-75],[-3,-23],[-14,-8],[-11,14],[-5,-39],[23,-62],[-13,-51]],[[24512,55367],[0,-8]],[[24485,55360],[-48,1]],[[24437,55361],[-7,0]],[[25990,63437],[0,-17],[-21,-2]],[[25969,63418],[-84,-1]],[[25847,64156],[58,2]],[[25847,64005],[0,151]],[[25969,63418],[0,-67],[-5,-16],[1,-185]],[[25882,63076],[-21,-2]],[[25758,63345],[-88,2]],[[24712,54858],[12,1],[23,48],[13,52],[22,4],[43,93],[7,70],[15,88]],[[24847,55214],[65,6]],[[26164,71367],[18,9],[30,-7],[32,14],[-22,-84],[-2,-135],[2,-45],[-8,-19],[9,-51],[16,-8],[9,16],[6,-26],[15,3],[17,-28],[34,49],[13,-4],[11,-46],[-1,-35],[25,28],[7,-7],[10,65],[19,24],[23,-19],[11,9],[8,39],[27,-5],[5,-30],[-10,-100],[7,-120],[1,-95],[-29,-2],[-8,-65],[15,-12],[5,21],[15,-4],[8,-38],[19,-19],[-13,-40],[24,-75],[12,-1],[20,-45],[8,38],[14,-35],[8,26],[-16,100],[14,-15],[41,13],[12,-15],[14,-91],[16,-31],[-10,-64],[-14,-20],[-27,39],[-31,-16],[-31,42],[-11,-12],[-27,1],[-27,23]],[[26477,70462],[-35,7],[0,101],[-35,0],[0,101],[-208,0],[-1,102],[-34,0]],[[26327,70327],[8,17],[9,-60],[65,-63],[-17,-58],[-23,18],[-14,61],[-28,85]],[[26477,70462],[-60,-26],[-13,-28],[-37,69],[-15,48],[-13,-7],[-13,30],[-10,-41],[2,-51],[-15,-32],[1,-45],[9,-63],[-12,-20],[-24,42],[-3,31],[-21,37],[-5,30],[-22,64],[-38,46],[-13,-7],[-33,49],[-18,-5],[-13,23],[-5,-20],[-19,11],[-25,-75],[-17,-73],[-9,-8],[-32,23],[-15,-14]],[[25989,70450],[0,322]],[[27093,52817],[9,-32],[17,-3],[18,-28],[7,-25],[33,-19],[17,-18],[14,15],[13,-19]],[[27221,52688],[4,-13],[-4,-113],[0,-106]],[[27221,52456],[-20,66],[-4,-47],[-13,13],[-2,31],[-8,-12],[2,36],[-18,-28],[-15,13],[-4,-44],[-7,1],[-19,-79],[-61,-226]],[[27052,52180],[0,104]],[[27640,62865],[12,-19]],[[26269,58090],[22,-43],[14,-68],[8,-16]],[[26236,57668],[5,32],[-9,23],[-9,118],[5,55],[17,121]],[[26617,52620],[71,-16]],[[26688,52604],[23,-6]],[[26711,52598],[10,-136],[-2,-49],[8,-20],[-2,-38],[12,-16],[3,-29]],[[26685,52165],[-28,0],[0,51],[-98,-1]],[[26559,52215],[9,33],[-5,25],[3,38],[10,0],[10,57],[-4,85],[18,53],[10,-1],[9,34],[-2,81]],[[24745,55707],[12,11],[2,31],[-12,42],[41,-49]],[[24907,55604],[-13,-64],[0,-34],[-8,-24],[-3,-81],[-11,-46],[-6,-79],[-19,-62]],[[24847,55214],[-104,152],[-7,1]],[[25164,59432],[3,0]],[[23990,68708],[0,51],[24,-10],[10,12],[0,30],[35,0],[0,101],[17,0],[0,98]],[[23828,60508],[122,-12]],[[23950,60496],[31,-2]],[[23832,60125],[1,213],[-6,1]],[[23827,60339],[1,169]],[[26051,55931],[81,-4],[13,-11]],[[26145,55916],[3,-64]],[[26164,55505],[1,-25]],[[26065,55479],[-17,-1]],[[20274,54191],[-67,0],[-1,-101],[-7,-18],[3,-38],[10,-25],[-1,-23],[16,-20],[5,-28]],[[20232,53938],[-214,0]],[[28357,64489],[24,73],[21,96],[17,60]],[[28419,64718],[0,29]],[[28515,64525],[-8,11],[-32,0],[-23,-35],[-8,14],[-75,-61],[-9,-12]],[[21904,68796],[-26,23],[-7,36],[9,127],[-5,35],[-24,39]],[[30141,67625],[-17,-68],[-4,55],[-21,-27],[-4,77],[-10,-40]],[[29982,67881],[-9,154],[57,26],[-6,124],[10,54],[-10,34],[-1,67],[-8,14],[0,52]],[[27617,60369],[13,32],[16,-8],[9,-22],[-4,-61],[-15,-53],[-12,47],[-10,12]],[[23464,64551],[0,-202],[4,0],[0,-177]],[[23468,64172],[-80,4]],[[27451,56634],[-28,-35],[-37,122],[-5,9],[12,101]],[[18427,67124],[0,-289],[53,1],[6,16],[13,86]],[[15303,67706],[96,-3],[0,-108],[16,1],[0,-99],[15,0],[0,-202],[17,0],[0,-199],[-16,-4],[0,-101],[-17,0],[0,-201],[3,-41]],[[15231,66942],[12,136],[0,52],[9,80],[6,99],[-6,42],[17,53],[8,43],[16,132],[10,127]],[[15843,66991],[-33,0],[-17,-66],[-27,-1],[0,-17],[-33,-51],[-17,-67],[-10,7],[-6,-59],[-43,-4],[-17,-27],[-39,5],[-22,-62]],[[15303,67706],[17,294]],[[24651,67195],[-6,1],[-15,-57],[-15,-17],[-14,-37],[-26,-18],[-4,-21],[-30,-60],[-21,8],[-5,-13]],[[24515,66981],[-6,107]],[[24509,67088],[0,60],[9,24],[6,52],[18,60],[-13,76],[-27,41],[-1,86]],[[27607,61119],[15,9],[19,-7],[13,-71],[23,-14],[16,5],[16,-48],[12,35]],[[27721,61028],[12,-14],[-19,-115]],[[27617,60764],[-3,15],[-31,-74],[-21,36]],[[27562,60741],[-17,34],[-4,41]],[[27621,60896],[4,-15],[7,65],[-5,12],[-6,-62]],[[27384,60509],[21,-39],[4,-26],[41,71],[19,47],[12,9],[4,-54],[6,-13]],[[27491,60504],[12,-125]],[[26844,52254],[14,-23],[16,19],[12,72],[-5,68],[-10,25],[-8,98],[11,45]],[[26938,52542],[0,-521]],[[26938,52021],[1,-36],[-18,-35],[-7,-65],[-9,-34],[13,-58]],[[26882,51664],[-21,35],[-9,43],[-1,36],[-8,5]],[[31470,38195],[13,24]],[[31501,38239],[4,7]],[[31491,38138],[-7,-14],[-1,35],[-7,-5]],[[31372,38083],[9,18],[-2,55],[5,36],[13,1]],[[31419,38095],[-11,-12],[-8,16]],[[23996,69196],[-9,33],[-22,0],[-14,-36]],[[23951,69193],[-6,24],[-2,148],[-5,-1]],[[23938,69364],[0,104],[57,-1]],[[19271,63277],[0,1168]],[[19530,64274],[-1,-189],[0,-323]],[[19529,63762],[0,-655]],[[19529,62918],[-10,-6],[-5,-36],[-256,9]],[[19258,62885],[3,26],[-7,87],[15,114],[-2,45],[18,55],[2,42],[10,23],[-26,0]],[[27587,60154],[12,44],[22,13],[12,-41],[33,103]],[[27666,60273],[34,-39],[5,-47],[8,4],[23,-131]],[[27736,60060],[-13,-217]],[[27612,59771],[-7,55],[-48,36]],[[6166,41601],[15,31],[4,-42],[8,-9]],[[23415,62959],[15,-41],[1,-29],[16,-31],[6,-32]],[[23453,62826],[-59,1]],[[29823,65864],[84,-6],[1,-18]],[[29911,65412],[-19,5],[-26,-12],[-56,39],[-2,-12],[-23,66]],[[29785,65498],[23,46],[-2,95],[-15,0],[0,143],[33,1],[-1,81]],[[29722,65346],[16,22]],[[29738,65368],[23,3],[-2,45],[19,39],[7,43]],[[29911,65361],[-3,-209],[-12,-8],[3,-76],[-8,-29]],[[29891,65039],[-7,19],[-17,2],[-21,-24],[-18,3],[-13,-24],[-16,28],[-6,-37],[-36,-13]],[[15680,69692],[6,34],[28,-17],[0,118]],[[15714,69827],[27,0],[2,33],[229,0]],[[15972,69860],[12,-68],[22,-34],[-2,-49],[7,-40],[-5,-46]],[[16006,69623],[4,-33],[-18,-28],[15,-103],[8,3],[2,-62],[-17,-33],[-17,-1],[-7,-30],[5,-77],[20,-46],[-5,-23]],[[23769,53708],[-18,30],[-24,-49]],[[23597,54009],[-8,67],[-9,26],[0,58]],[[27320,64552],[53,-1],[0,34],[21,0],[0,-34],[84,0]],[[27478,64246],[-18,-27],[-14,1],[-9,-39]],[[27437,64181],[-22,1],[0,16],[-32,2]],[[27320,64350],[0,202]],[[16598,59415],[13,0],[-1,-101],[15,-1],[0,-153],[-15,0],[-2,-153],[0,-406]],[[16425,58601],[-6,0]],[[15358,63504],[133,1]],[[15660,63268],[0,-59],[7,0],[6,-45],[2,-150]],[[15675,63014],[-1,-60],[-13,-14],[-25,2],[-11,-17],[-3,-112],[10,-83],[6,-17],[0,-51],[6,-49],[-14,-72],[-9,0],[-4,-119],[8,-8],[2,-51],[8,-28],[12,0],[4,-75],[6,-38],[16,-5],[-1,-17],[21,-36]],[[15693,62164],[-73,3],[-15,-15],[0,-36],[-65,-3],[0,-34],[-36,2],[-10,-12]],[[15494,62069],[-33,100],[-24,116],[14,78],[-1,42],[-14,126],[-16,123],[-7,105],[3,99],[13,132],[-5,52],[0,65],[-14,92],[-4,108],[-16,36],[-6,55],[-26,106]],[[20752,62489],[-103,1]],[[22428,51565],[-15,-9],[-11,-24],[-11,4]],[[22391,51536],[-39,72]],[[23919,59426],[123,0]],[[24042,59426],[0,-39],[-9,31],[-1,-439]],[[24017,58980],[-100,8]],[[22758,59038],[30,-6]],[[22788,59032],[0,-203],[9,30],[8,-6],[5,-38],[15,-10],[5,-23],[18,-3]],[[22847,58526],[-148,1]],[[28805,67542],[62,-59],[118,228]],[[28957,66855],[-10,-10]],[[28947,66845],[-53,-9],[-5,81],[-24,-2],[-3,124],[-12,-3],[-1,30],[-11,22],[-4,40],[-15,27],[-5,29],[-44,-8]],[[26591,57972],[7,36]],[[26693,58068],[6,-77],[10,-42],[16,11],[0,-94],[10,-28],[12,-65],[-1,-28],[11,-62]],[[26757,57683],[-104,-8]],[[26653,57675],[-13,18],[-16,96],[-14,35],[-7,45],[-21,-5]],[[26582,57864],[2,51],[9,30],[-2,27]],[[29216,68299],[53,20],[-14,314],[65,26]],[[29320,68659],[58,19],[9,-5],[27,28],[5,20],[16,4],[9,60],[35,10]],[[29479,68795],[9,-54],[4,-69],[-12,-80],[6,-126]],[[29486,68466],[-22,-87],[-5,-89],[-8,-79],[9,-27],[-1,-103],[10,-67],[-1,-78]],[[29468,67936],[-17,-6]],[[29451,67930],[-172,-69]],[[29279,67861],[3,61],[-16,10],[-13,29],[-18,-22],[-34,133],[22,52],[-7,175]],[[27759,61385],[-4,-34],[13,22],[12,-9],[-16,-78],[3,-11]],[[27767,61275],[-14,-97],[-21,-79],[-11,-71]],[[27085,61204],[-11,29],[5,80],[7,39],[14,-18],[-3,36],[10,6],[5,42]],[[27112,61418],[19,21],[8,-34],[3,27],[23,-1],[-1,-41],[13,-13],[9,-43],[15,-29],[-6,-42],[13,-10],[8,-47],[1,-46]],[[27217,61160],[-14,1],[-9,-20],[-6,-61],[0,-90],[13,-27],[0,-32]],[[27201,60931],[-17,-32],[-9,30]],[[27238,61139],[14,223],[28,119]],[[27280,61481],[22,-43],[5,10],[17,-45],[4,31],[14,-20],[7,20],[11,-34],[-2,-30],[19,-75]],[[27360,60964],[-9,16],[-22,3],[-5,47],[-62,16],[-2,51],[-12,50],[-10,-8]],[[27150,61904],[18,-84],[31,68]],[[27199,61888],[16,-73],[45,-18],[8,-15],[22,7]],[[27238,61139],[-15,-2],[-6,23]],[[27112,61418],[7,13],[2,51],[-4,60],[-28,12]],[[27089,61554],[5,85],[13,27],[35,51],[-8,67],[0,67],[16,53]],[[31591,38232],[1,7]],[[31592,38239],[10,-34],[7,21],[20,3]],[[31629,38229],[13,-45],[-7,-43],[-11,19],[3,-28],[-9,2]],[[31618,38134],[1,18],[-30,67]],[[31354,38275],[5,12]],[[31375,38302],[20,24]],[[19529,63762],[119,-1],[330,2]],[[25845,62734],[-69,1],[0,7]],[[25760,62886],[0,60],[11,51],[-3,42]],[[24179,53953],[14,116],[0,37]],[[24278,54105],[-1,-363],[1,-337]],[[24278,53405],[-5,20],[-17,-9]],[[24256,53416],[1,35],[-19,46],[-3,73],[-10,12]],[[24170,62035],[-28,-362]],[[24106,61676],[-61,193],[1,102]],[[27731,65656],[0,-263]],[[27478,65236],[0,13]],[[27478,65249],[0,407]],[[26692,61546],[9,-78],[2,-49],[16,-21]],[[26719,61398],[11,-19],[-5,-51],[-11,-19]],[[26714,61309],[-20,-36],[-13,-38],[-15,-21]],[[25622,58904],[36,-5]],[[25658,58899],[4,-65],[31,74],[38,-19],[48,-80]],[[25779,58809],[-2,-61],[6,-70],[-2,-76],[-14,1],[-11,-80],[4,-14]],[[25760,58509],[-26,-4]],[[25613,58673],[3,126]],[[22614,70412],[-8,1]],[[31277,37922],[6,-31],[1,-51]],[[31284,37840],[-15,-8],[-4,-24],[-15,30]],[[17490,71031],[17,-63],[31,0],[8,-48]],[[17398,70483],[0,281],[5,6],[-9,96],[63,0],[6,30],[27,-9],[1,85],[-14,60],[13,-1]],[[17304,70983],[0,135]],[[17304,71118],[89,1],[6,52],[21,49],[46,-1]],[[17466,71219],[2,-152],[22,3],[0,-39]],[[17372,70320],[-18,55],[-16,107]],[[17338,70482],[-11,93],[-7,11],[17,93],[-12,40],[0,63],[-8,54],[-17,51],[4,96]],[[22468,63505],[64,1]],[[22627,63505],[0,-405]],[[22472,62999],[-5,0]],[[22941,63504],[95,0]],[[23099,63503],[0,-505]],[[23004,62998],[-63,0]],[[23500,59034],[66,1]],[[23585,58566],[6,-140]],[[23591,58426],[-93,0]],[[26653,57675],[-19,-1]],[[26634,57674],[-19,-7],[-89,1]],[[26526,57668],[-19,0]],[[26507,57668],[14,45],[-3,21],[16,40],[19,76],[7,-6],[22,20]],[[26757,57683],[28,31]],[[26773,57095],[-15,48]],[[26758,57143],[-18,80],[-17,7],[-30,88]],[[26693,57318],[-4,34]],[[26689,57352],[9,50],[-1,36],[26,105],[31,68],[3,72]],[[23733,58568],[14,-1]],[[23747,58567],[0,-34],[-14,2],[-6,-33],[0,-50],[-25,1],[-1,-101],[15,-1],[-5,-36],[2,-49],[-5,-28],[7,-19],[-13,-18]],[[23702,58201],[-19,5],[-5,-17],[7,-42],[-19,-45],[-28,-9],[-11,22],[1,43],[-13,46],[-14,-23]],[[23601,58181],[-10,245]],[[31708,38299],[11,-21],[12,13],[9,-36],[-17,-36],[-12,19],[-3,61]],[[24933,53029],[-20,0]],[[24913,53029],[-30,-1]],[[24883,53028],[0,85],[-24,0],[-5,68],[-19,-1],[0,50],[-7,1],[-2,186]],[[24826,53417],[0,68],[22,-4]],[[24856,56710],[59,-1],[0,33]],[[24858,56399],[0,283],[-2,28]],[[21996,63910],[29,2]],[[15582,70936],[238,2],[34,-2]],[[15854,70936],[1,-3],[-2,-383]],[[15584,70688],[-2,248]],[[25718,57673],[15,0]],[[25733,57673],[0,-221],[-2,-293]],[[25644,57317],[-10,44],[-23,46],[-11,-6]],[[26123,52522],[59,-3],[1,51],[66,-2]],[[26249,52568],[-16,-95],[-3,-80],[5,-17],[-14,-25],[5,-13],[-19,-210],[-9,-33]],[[26198,52095],[-77,1]],[[26917,50750],[21,3],[11,-40],[22,-29],[8,-32]],[[26880,50342],[-13,31],[4,42],[-9,109],[12,64],[-13,79],[-7,23]],[[24512,55367],[70,-4]],[[24636,54961],[8,-30],[-8,-20]],[[25880,61667],[62,-6]],[[25979,61384],[-1,-109],[-5,-70],[-6,-21]],[[21486,60002],[-4,0]],[[27101,57897],[22,-173],[11,-120],[12,-23]],[[22783,62492],[0,-202]],[[22628,62290],[0,304]],[[19895,71048],[157,1],[6,-17],[0,-84],[35,-1],[0,-103],[6,-1],[0,-200],[19,3],[0,-310]],[[20118,70336],[-32,0],[0,50],[-34,0],[0,51],[-70,0],[0,101],[-24,0]],[[22882,66240],[0,477]],[[22989,66441],[-25,0],[-1,-287]],[[22963,66154],[0,-16],[-27,0]],[[24045,70173],[16,40],[20,148],[20,47],[25,23],[8,38],[14,-13],[10,56],[24,-7],[6,59],[10,10],[0,96]],[[24198,70670],[68,0]],[[24882,67235],[9,38],[21,15],[3,48]],[[25113,67225],[-1,-408]],[[25013,66814],[0,14],[-131,1]],[[24882,66829],[0,406]],[[24496,51891],[33,44]],[[24529,51935],[28,19],[12,-15]],[[24569,51939],[1,-103],[9,1],[0,-51],[11,1],[0,-35]],[[24590,51752],[-17,-132],[-16,-90]],[[24557,51530],[-22,-103]],[[24531,51512],[2,119],[-12,42],[-15,13],[-7,68],[-12,75]],[[28887,65414],[-6,416]],[[28881,65830],[23,0]],[[28904,65830],[12,0],[14,-59],[5,4],[8,-100],[15,4],[17,-22]],[[28975,65657],[20,-61],[-8,-32],[14,-21],[3,-150],[-7,-26]],[[28875,64937],[18,31],[-6,446]],[[28934,66697],[12,47],[1,101]],[[29082,66836],[32,-40]],[[29096,66434],[-17,-15],[-19,8],[-35,-51],[-14,-46],[-21,-10],[-29,-72],[-18,10],[-13,-53],[-30,-9]],[[28900,66196],[6,46],[-3,32],[9,41],[-9,73],[11,88],[11,27],[-1,113],[10,81]],[[22701,57514],[205,-1]],[[22906,57513],[0,-253]],[[22730,57108],[0,199],[-29,4]],[[29146,68274],[70,25]],[[29279,67861],[-44,-18],[15,-416]],[[29250,67427],[6,-137]],[[29256,67290],[-24,-6],[1,-31],[-28,-8],[-1,31],[-58,-16],[-50,68]],[[23868,58992],[-1,-51],[10,-1],[-1,-131],[-10,-17],[-6,-84],[-5,1],[2,-138]],[[23857,58571],[-50,6]],[[23807,58577],[-60,7],[0,-17]],[[28708,65829],[101,-1],[72,2]],[[28887,65414],[-71,0]],[[28705,65425],[-1,101],[-7,303]],[[26322,51623],[29,47],[0,-29],[-16,-37],[-11,-6],[-2,25]],[[26223,51829],[5,49],[129,-3]],[[26357,51875],[8,-26],[13,15],[9,-29],[27,-19]],[[26414,51816],[-1,-71],[-10,-7],[-15,15],[-5,26],[-24,-22],[-31,-73],[-65,-132],[-6,2],[7,44],[-10,12],[-7,-39],[-15,-41],[-36,1],[13,-49],[2,-38],[16,-22],[30,53],[29,40],[27,84],[3,-13],[-24,-82],[-28,-43],[-35,-66],[-12,-14],[-10,33],[-16,22],[-24,51]],[[26167,51487],[6,39],[27,76],[19,4],[5,32],[-9,120],[10,47],[-2,24]],[[26430,52660],[-15,-104],[-10,-18],[-5,-60]],[[26400,52478],[0,0]],[[26400,52478],[-2,-53],[-6,-23],[-28,-14],[-35,-74]],[[26329,52314],[-10,0],[0,34],[-9,0],[0,50],[-19,-1],[0,69],[-10,17],[-18,0],[0,84],[-14,1]],[[26249,52568],[7,15],[12,107]],[[26198,52095],[-11,-126],[5,-7],[0,-50],[6,-23],[24,-42],[1,-18]],[[26167,51487],[-18,7],[-17,-28],[-13,94],[-5,119],[8,42],[0,-105],[6,-91],[7,-22],[10,39],[1,97],[-24,135]],[[26488,52181],[0,187],[9,45],[0,57],[18,0],[-8,101],[0,73]],[[26580,52628],[37,-8]],[[26559,52215],[-5,-26],[-22,-41],[-4,-66],[-6,-3],[-11,-119]],[[26511,51960],[-9,22],[-15,-9]],[[26487,51973],[1,208]],[[26835,49734],[4,-128],[9,-7],[-2,112],[-4,23]],[[26884,49736],[1,-178]],[[26885,49558],[-11,8],[1,-65],[-11,-28],[11,-37],[16,-6],[11,-110],[-10,-42],[0,-62],[-4,-27],[-21,-6],[-3,-32],[7,-38],[-9,-30],[-4,40],[2,83],[-14,85],[-9,26],[-8,58],[6,182],[-5,66],[-4,111]],[[22229,57818],[170,0],[4,-17],[24,26],[8,-31]],[[22435,57796],[0,-283]],[[22378,57210],[-49,0],[0,51],[-28,0]],[[23807,58577],[-4,-458]],[[23715,57931],[-15,3],[2,267]],[[22884,59436],[1,-24],[18,-35],[19,18],[10,58],[19,52],[9,-18],[9,-85],[-2,-46],[10,-20],[11,6],[10,-51],[7,-9],[10,30],[5,-40],[-10,-20],[-4,-38],[16,-20],[16,39],[7,-54],[13,-22],[13,-43],[23,-5],[4,-27],[-7,-47]],[[23091,59035],[-9,0]],[[22992,59033],[-55,-2],[0,102],[-29,0]],[[22908,59133],[0,101],[-30,0],[0,203],[6,-1]],[[22935,57107],[87,0]],[[23022,57107],[0,-100],[30,-2]],[[23052,57005],[0,-304]],[[23052,56701],[-13,0],[0,-50],[-37,0]],[[23002,56651],[-9,55],[-14,13],[-74,0]],[[23785,64175],[0,-123],[3,1],[1,-243]],[[23789,63810],[-1,-153]],[[23663,63950],[0,100],[-5,0],[0,118]],[[24934,53935],[70,19]],[[25004,53954],[0,-423]],[[25004,53531],[-14,0]],[[15543,70934],[39,2]],[[15490,70789],[-34,9],[-3,34],[-13,-8]],[[27052,52080],[103,4],[0,-81]],[[27155,52003],[-3,-91],[2,-31],[22,-63],[-1,-54],[8,-88]],[[27183,51676],[-65,-4],[-14,-43],[-13,-7],[-8,-54],[-19,-9],[-12,-24]],[[27052,51535],[1,33],[-1,461]],[[27052,52029],[0,51]],[[25989,70450],[-16,-23],[2,-34],[-23,37],[-21,17],[-24,-14],[-10,11],[-23,-24],[-13,-42],[-2,-63],[-9,-72],[-14,4],[-13,-42]],[[25823,70205],[1,161],[-9,0],[0,305],[-35,1]],[[24276,71309],[20,-30],[34,11],[75,77]],[[24198,70670],[0,303]],[[26508,54807],[-2,-10]],[[26506,54797],[-12,1]],[[26494,54798],[14,9]],[[26438,54623],[0,28],[16,6],[21,122],[19,19]],[[26494,54798],[10,-18]],[[26504,54780],[23,-1],[24,-43]],[[26551,54736],[3,-101],[-3,-106]],[[26458,54458],[-11,1],[1,75],[-11,1],[1,88]],[[23935,55375],[69,-1]],[[24004,55374],[74,-3]],[[15693,62164],[20,-53],[16,-109],[12,-5],[6,-45]],[[15747,61952],[-5,-81],[7,-44],[21,-47],[4,-59],[13,-20],[-4,-33],[14,-52],[-3,-14],[18,-73],[-3,-27],[10,-40],[5,-62],[-6,-42],[-10,-2]],[[15808,61356],[3,-16]],[[15811,61340],[-12,-29],[-14,-9]],[[15785,61302],[-22,90],[-22,-7],[-26,30],[-47,133],[-16,-5],[-10,-24]],[[15642,61519],[-17,7],[-1,67],[-17,106],[-20,51],[-14,19],[-22,64],[-37,176],[-20,60]],[[22906,57641],[0,-128]],[[22700,58073],[0,2]],[[22910,63504],[0,406]],[[23497,55777],[9,-37],[8,-3]],[[23540,55214],[-14,0]],[[23522,55243],[-14,25],[-14,66]],[[23494,55334],[3,443]],[[22700,58121],[-1,406]],[[23204,55609],[21,41],[15,59],[16,-3],[25,66],[23,-13],[28,28],[16,-12],[10,18]],[[23259,55308],[-1,22],[-54,0]],[[29083,67050],[61,-72],[124,-3]],[[29268,66975],[1,-32]],[[29269,66943],[2,-68],[-48,-99],[-2,-18]],[[22956,60009],[63,0]],[[23165,60009],[0,-669]],[[23165,59340],[0,-306],[-74,1]],[[22884,59436],[4,26],[26,26],[4,28],[-9,30],[-23,-21],[-15,12]],[[25627,53025],[106,-2]],[[25729,52312],[-34,-19]],[[25695,52293],[0,19],[-43,-28],[-29,-33],[-15,17],[1,41],[21,25],[8,110],[-9,41],[-15,23],[-13,66],[-4,123],[-8,2],[-3,79],[5,30],[-6,40],[9,48],[-1,43],[9,7],[7,35],[18,44]],[[27242,50557],[3,-36],[10,-16],[27,-2],[2,-28],[11,-31],[11,11],[9,43],[11,-18],[4,-46],[-3,-27],[13,-66],[-1,-22],[9,-72]],[[26389,53534],[61,-1],[19,5]],[[26469,53538],[-3,-30],[-12,-25],[-1,-43],[-32,-39],[-14,-96],[-40,-135],[0,-53]],[[26061,57664],[37,-1]],[[26098,57663],[31,0]],[[26068,57520],[-7,144]],[[26383,53750],[43,0]],[[26426,53750],[71,2],[7,31]],[[26504,53783],[6,-29],[-1,-211]],[[26509,53543],[-40,-5]],[[26509,53543],[0,-127]],[[26509,53416],[-1,-300]],[[26265,52709],[-11,29],[-6,75],[-2,83],[-11,52],[-6,79]],[[26229,53027],[-6,87]],[[22788,59032],[60,0],[-1,101],[61,0]],[[26153,59576],[84,-13]],[[26132,60234],[-8,-28],[-41,-68]],[[23021,55137],[0,197]],[[31858,38286],[13,39],[11,-4],[15,-28],[-13,-4],[1,-49],[-9,20],[-13,-5],[-5,31]],[[31846,38320],[13,6],[-2,-23],[-11,-2]],[[20681,54191],[0,-218],[2,-947],[1,-191],[-3,0],[0,-201]],[[20663,52594],[-7,67],[-15,0],[-14,66],[-12,10],[-3,24],[-15,34],[-12,-4],[-7,28],[-31,39],[0,39],[-44,118],[-13,107],[-12,37],[-18,26],[-9,33],[-9,2],[-2,36],[-24,106],[-20,35],[-4,54],[-12,25]],[[20380,53476],[11,43],[0,64],[-10,0],[-1,610]],[[27199,61888],[-7,69],[7,178],[-1,89],[6,19]],[[25131,53986],[10,2]],[[25141,53988],[41,11],[38,24],[42,44]],[[25265,53839],[4,-306]],[[25269,53533],[-109,-2]],[[25131,53531],[0,455]],[[24717,67229],[1,-452]],[[24718,66777],[0,-356]],[[24587,66617],[-23,27],[-24,61],[-10,154],[-12,25],[-3,97]],[[24407,53901],[40,2],[6,-24]],[[24453,53879],[-5,-25],[-1,-106],[-18,0],[-10,28],[-5,-38],[9,-30],[18,13],[4,-32],[-12,-35],[-20,-18],[1,-74],[13,-75],[0,-29],[-9,-7],[-8,29],[-4,50],[-9,-39],[7,-16],[1,-45],[12,-37],[-2,-43],[-17,-20],[-18,7],[-1,-38],[15,-50]],[[24394,53249],[-10,-67],[1,-28],[16,-50],[-7,-58],[-13,-21]],[[24357,53078],[5,71],[-4,34],[12,62],[-38,57],[-6,34]],[[24326,53336],[3,31],[-11,11],[0,61],[5,25],[16,-2],[-19,57],[0,84],[9,-6],[5,-60],[19,-9],[0,42],[-17,7],[5,67],[-13,48],[3,54],[12,35],[10,-40],[9,33],[-3,39],[5,65],[17,-3],[10,38],[15,-46],[1,34]],[[23448,54622],[0,-271]],[[23448,54351],[-132,-3]],[[23316,54348],[-5,13],[4,64],[-7,39],[11,70],[0,70]],[[29287,69318],[12,-335],[5,1],[6,-156],[3,2],[7,-171]],[[29092,69317],[18,5],[91,-8],[53,-1],[33,5]],[[24398,54053],[18,56],[-5,34],[9,36],[-4,35],[6,80],[-4,66],[3,67]],[[24421,54427],[48,-1],[14,33],[10,-24],[14,41],[14,4],[3,-44]],[[24544,54335],[6,-5]],[[24550,54323],[-14,-41],[-5,-36],[-13,39],[-5,-25],[19,-26],[0,-50],[-19,-14],[-7,-25],[2,-50],[-19,-56]],[[24470,53894],[-17,-15]],[[24407,53901],[-10,51],[3,37],[-2,64]],[[24394,53249],[4,38],[10,17],[3,-28],[12,15],[5,107],[12,-5],[23,29],[10,24],[26,-4],[15,-12]],[[24514,53430],[18,-30]],[[25141,53988],[-1,126],[0,337]],[[22407,69607],[1,0]],[[25504,57687],[5,63],[-1,98],[5,56],[0,242]],[[25004,53531],[71,0]],[[25021,52921],[0,106],[-3,11]],[[15540,71409],[58,2]],[[15598,71411],[0,-34],[152,-3],[115,1]],[[16073,71399],[7,-48],[17,-19],[-2,-46],[-9,-3],[-1,-41],[7,-32],[-7,-73],[-11,-29],[5,-67],[14,-76],[-3,-26],[-35,0]],[[16055,70939],[-201,-3]],[[27736,60060],[15,4],[17,-47],[5,19],[-8,42],[13,-3]],[[27778,60075],[11,10],[0,32],[20,40],[10,-25],[10,31],[22,-72],[15,24],[10,-33]],[[27841,59477],[-35,-1]],[[27771,59476],[-12,0]],[[28050,62940],[34,-59]],[[28084,62881],[-4,-62],[5,-28],[-6,-36],[7,-11],[-23,-106],[6,-15],[-11,-54],[10,-36],[-16,-62],[-13,-29]],[[28039,62442],[-15,50],[-12,10],[-5,-25],[-21,34],[-10,2],[-46,57],[-23,45]],[[16179,63034],[19,49]],[[16122,62379],[-7,21],[-17,-24],[-13,-42]],[[16085,62334],[-21,-5],[-15,-23],[-9,-62],[-10,162],[7,37],[-9,108],[1,54],[-6,38],[3,40]],[[28250,65829],[39,1]],[[28292,65224],[-109,-5]],[[28124,65386],[-1,444]],[[22647,47611],[0,-324],[-2,-15]],[[22645,47272],[-5,11],[-23,-17],[-4,18],[-13,-1],[-3,-29],[-10,31],[-20,-14],[-8,22],[-6,-22],[-14,20],[-8,30],[3,25],[-16,1],[-3,44],[-15,-1],[-21,75],[-9,-11],[-25,48]],[[22445,47502],[26,222],[27,210],[21,183]],[[28755,60650],[28,6],[14,-30],[-7,-64],[27,-28],[11,16]],[[28828,60550],[5,-14],[-18,-91],[-12,-79],[-9,-11],[1,-57],[-11,-86],[-18,-64],[-16,2],[4,-35],[-9,-5],[-1,84],[-10,55],[-4,61],[2,70],[9,59],[3,89],[11,122]],[[26399,54672],[9,16],[-1,-35],[12,0],[-1,-29],[20,-1]],[[26389,54384],[0,76],[5,0],[0,76],[6,0],[-1,136]],[[24390,67090],[119,-2]],[[28543,59191],[16,38],[8,-6],[15,32]],[[28623,58934],[-13,-59],[-16,-22],[-17,1],[-8,31],[-20,12],[-12,121],[0,61],[12,78],[-4,12]],[[25798,57154],[5,-52],[18,-30],[12,5],[9,45],[15,-10],[10,81],[-7,23]],[[25860,57216],[50,0],[0,-91],[14,1],[3,-65],[8,11]],[[25867,56634],[-30,123],[-12,63]],[[25825,56820],[-7,51],[-29,2]],[[28701,66308],[31,-1],[43,8]],[[28775,66315],[6,-182],[7,-12],[50,-1],[1,-62],[61,0]],[[28900,66058],[-1,-178],[5,-50]],[[29269,66943],[24,-26],[14,-42],[14,16],[3,-70],[24,-84]],[[23007,52672],[31,57],[19,139],[14,66],[27,61]],[[23118,52820],[-4,-30],[6,-32],[-4,-70],[4,-59],[-7,-69],[16,-127],[7,-80],[-14,-107]],[[23082,52303],[1,39],[7,4],[-6,33],[-14,35],[-5,79],[-15,-3],[-3,56],[-17,19],[-7,28],[-25,15],[9,64]],[[28198,61985],[8,1],[10,-57],[4,-105],[12,-32],[22,-137],[12,16],[16,-19]],[[28282,61652],[5,-49]],[[28287,61603],[-8,12],[-16,-20]],[[28263,61595],[-19,37],[-3,-33],[-13,20],[-22,0],[-1,-13],[-33,-49],[-2,-19],[-16,-1]],[[28154,61537],[3,19],[-10,48],[6,20],[-6,56],[-31,114]],[[22897,52511],[95,202]],[[22992,52713],[15,-41]],[[22987,52207],[-15,28],[-14,-1],[-13,83],[-23,78],[-13,95],[-12,21]],[[25119,52114],[15,7],[15,31],[-4,-29],[-21,-27],[-5,18]],[[25071,52140],[21,-1],[8,13],[-5,-43],[-10,-7],[-17,26],[3,12]],[[25148,52650],[0,-300],[11,-16],[8,-35]],[[25167,52299],[-1,-17],[-21,38],[-22,-3],[-31,-27],[-28,-42],[-30,-33],[4,54],[-17,27]],[[25021,52296],[-1,320]],[[23205,55831],[0,61]],[[23205,55892],[9,-4],[18,43],[22,-29],[11,19],[21,-11],[11,-37],[10,11],[21,-50],[30,-37]],[[23358,55797],[1,-3]],[[18457,60592],[0,-581]],[[21556,53119],[140,-1]],[[21783,52197],[-12,-1],[-210,1]],[[21561,52197],[6,46],[10,22],[9,-8],[-9,73],[-11,22],[11,43],[6,74],[9,46],[-5,32],[4,37],[-17,40],[-16,-2]],[[21558,52622],[-2,33],[-9,21],[-2,61],[-5,7],[1,51],[-8,84],[-9,20],[5,25],[-22,50],[-11,40],[-6,-12],[-10,28],[-9,-19],[-16,9],[-17,42],[-25,6],[-9,30],[-19,30]],[[27155,51076],[65,64],[4,22]],[[27316,51195],[15,-139],[29,-229],[59,-372]],[[27419,50455],[-66,-1],[1,-207],[-6,0]],[[27166,51020],[-11,56]],[[28322,66503],[35,-1]],[[28357,66502],[62,0],[-2,-89],[12,7],[0,-26]],[[25375,66812],[67,-1]],[[25442,66811],[17,-67],[-4,-89],[-7,-47]],[[25309,66542],[0,269]],[[23888,56980],[128,-9],[0,65],[9,4],[0,67],[34,-3]],[[24093,57000],[-2,-308]],[[24091,56692],[-58,8]],[[24033,56700],[-40,5],[-1,88],[-16,11],[-30,3],[0,34],[-44,4],[0,68],[-15,0]],[[24410,61352],[-1,68],[47,-1]],[[23040,68894],[0,203]],[[26480,55701],[-13,18],[0,26],[-27,0],[-1,20],[-29,0]],[[25974,54510],[11,19],[6,-69],[118,3]],[[26109,54463],[2,-102],[5,0]],[[26116,54361],[-5,-9],[0,-144],[-24,-2],[0,-16],[-22,-7],[-3,-38],[-13,-58],[-2,-36]],[[26047,54051],[-37,0],[0,101],[-26,0],[-3,93],[-29,5]],[[16371,60748],[30,-204],[4,-67],[23,-127],[1,-35],[26,-50],[9,-41]],[[16140,59965],[-8,26],[0,49],[10,50],[-10,25],[5,52]],[[28486,60450],[3,64],[19,21],[15,-18],[8,37]],[[28535,60367],[0,-65],[18,1]],[[28573,60259],[3,-36],[-9,-18]],[[28567,60205],[-11,63],[-22,-9],[-8,-25],[-10,46],[-18,11],[-4,23]],[[24164,54767],[0,-102],[29,-101],[0,-51]],[[24193,54360],[-140,1]],[[28482,59479],[0,10]],[[28482,59489],[105,-2]],[[28587,59487],[14,-46]],[[28601,59441],[0,-49],[10,-106]],[[24440,68141],[29,0],[-5,62],[20,40],[13,-22],[6,40],[13,-9]],[[24516,68252],[0,-10],[50,-1]],[[24566,68241],[17,1],[0,-403]],[[24479,67981],[-28,125],[-11,35]],[[26506,54797],[-2,-17]],[[26385,54844],[10,0],[0,57],[8,25],[4,55],[7,0],[0,48],[15,31]],[[26429,55060],[8,-29],[6,19],[9,-57]],[[26452,54993],[27,-19],[14,-43],[-4,-44],[5,-37],[14,-43]],[[26399,54672],[-4,83],[-7,9],[-6,48],[3,32]],[[28601,59441],[15,-50],[31,-59],[9,-36],[15,-17],[7,-52],[9,-5],[-10,-27],[9,-8]],[[28686,59187],[10,-33],[9,-58],[10,-17],[6,-52],[-9,-23],[-24,-14],[-21,71],[-6,5]],[[28276,62272],[-10,-65],[-5,-74],[50,-311]],[[28311,61822],[-29,-104],[0,-66]],[[28100,61492],[10,-45],[21,24],[-2,15],[16,17],[9,34]],[[28263,61595],[-3,-30],[-67,-253]],[[28768,66673],[129,25],[0,-8],[37,7]],[[28900,66196],[0,-138]],[[28775,66315],[-2,148],[-5,210]],[[27878,60470],[-26,-61],[-10,-11],[-12,27]],[[27830,60425],[7,43],[-10,44],[16,44],[7,-3]],[[23022,57107],[1,203],[29,0],[0,102]],[[23052,57412],[88,0]],[[23140,57412],[0,-102]],[[23140,57310],[0,-203],[-15,0],[0,-101],[-73,-1]],[[23170,57859],[-8,-12],[-21,-107],[-1,-328]],[[23052,57412],[0,190],[-5,-32],[-18,8]],[[23029,57578],[0,239],[13,0],[0,203]],[[22844,52394],[53,117]],[[27778,60075],[52,350]],[[27951,60249],[-23,-213]],[[22949,57566],[6,0],[8,-50],[9,13],[-2,72],[9,-1],[6,-32],[25,14],[4,-39],[9,-6],[6,41]],[[16478,63180],[1,13],[1,393],[0,756],[-1,34],[0,505]],[[16479,64881],[0,943]],[[16671,64621],[-1,-515],[-7,-1],[0,-604],[32,1]],[[16695,63502],[-1,-116],[5,0],[0,-105],[11,-25],[0,-125],[-5,-35]],[[16705,63096],[-20,-2],[-7,-32]],[[16678,63062],[-24,-40],[-27,-3],[-1,-22],[-17,0],[-14,-21],[-11,-42],[-20,6],[-1,-81],[12,0],[-1,-50],[-8,-17],[8,-67],[-5,0],[0,-59],[-10,-35]],[[16559,62631],[-11,-8],[-5,-34],[-16,-8],[-15,-50],[-34,0]],[[16478,62531],[-1,176]],[[28975,65657],[102,193]],[[29077,65850],[91,-164],[-34,-152],[51,-118],[7,-61]],[[28288,63734],[2,-16],[59,138],[10,4],[-17,-60],[27,43],[1,-29],[22,19],[74,31],[17,21]],[[28483,63885],[-3,-45],[18,-74]],[[28498,63766],[-10,-2],[-9,-32],[6,-36],[-20,-2],[-14,-19],[-30,-91]],[[28421,63584],[-14,-47],[-61,-41],[-18,-58]],[[28328,63438],[4,33],[-21,88],[-9,82],[-13,39],[-1,54]],[[27539,62459],[-5,-105],[0,-67],[-8,-18],[-5,-62],[-6,-14],[-6,-124],[5,-48]],[[27496,62035],[3,45],[-11,26],[3,38],[-14,34],[-16,-4],[-7,53]],[[23965,52355],[18,1],[0,17],[81,-2],[0,59],[40,0]],[[23965,52331],[0,24]],[[21981,65125],[-129,0]],[[21852,65125],[1,403]],[[26109,54667],[29,1],[-1,68],[77,5],[-1,40],[16,3]],[[26229,54784],[2,-66],[9,-36],[-5,-52]],[[26252,54459],[-13,-14],[2,-24],[-14,-21],[-13,-52],[2,-85]],[[26216,54263],[-38,-1],[-20,100],[-42,-1]],[[26109,54463],[0,204]],[[24433,59426],[12,-1]],[[24445,59425],[14,-37],[2,-52],[11,0],[0,-36],[10,-18],[4,-50],[0,-85]],[[25958,59578],[-64,13]],[[25837,59604],[1,146]],[[24765,52052],[28,31]],[[24793,52083],[14,-29]],[[24807,52054],[-5,-224],[-4,-63],[9,-12],[11,15],[3,28],[14,-58]],[[24835,51740],[-6,-49],[-11,-28],[0,-105],[15,-75],[3,-59],[5,-7],[-1,-80],[3,-18],[0,-98],[5,-22],[8,-110],[8,-48]],[[24864,51041],[-52,-152]],[[24812,50889],[9,77],[16,79],[-8,39],[-2,43],[4,70],[-8,38],[-24,18],[-14,101],[8,7],[1,126],[-21,16]],[[29300,65178],[13,57],[113,45]],[[29426,65280],[-4,-187]],[[29300,65041],[0,4]],[[29236,64822],[-7,11]],[[29426,65280],[3,163]],[[29429,65443],[6,-33],[14,-135],[1,-36],[16,27],[3,-30],[18,-24]],[[29543,64863],[-6,-25],[-13,23],[-24,-58],[-7,13],[-23,-28],[5,-22],[-10,-32],[-29,-11],[-22,-54],[-9,15],[-15,-35]],[[24246,59427],[2,344]],[[24375,59881],[0,-118],[-4,0],[-2,-189],[2,-146]],[[90204,32599],[5,15],[34,16],[21,137],[6,65],[7,-11],[7,-43],[14,-11],[-10,-88],[-32,-109],[-9,-44],[-2,-111],[-12,-56],[-18,30],[-7,101],[8,50],[-12,59]],[[22992,52713],[3,31],[-10,25],[3,29],[-16,70],[3,49],[-13,-8],[-7,32],[-4,85],[-7,77],[-10,46]],[[16035,61539],[3,22],[17,33],[-3,80],[8,14],[-1,33],[-10,9],[-3,43],[8,6],[4,95],[-12,3],[-3,45],[-8,2],[-11,49],[8,58]],[[16032,62031],[33,-1]],[[16065,62030],[96,-27]],[[15960,61251],[18,-6],[15,31],[9,-2],[7,86],[20,42],[6,137]],[[23348,58023],[9,12],[20,-47],[18,45],[0,57],[15,26],[20,100]],[[23430,58216],[7,-6],[6,-46],[15,-6],[16,-28],[-7,-42],[25,15],[4,-44]],[[23496,58059],[0,-141],[-32,0],[0,-168]],[[23464,57750],[-117,0]],[[23347,57750],[0,119],[-30,0],[1,158]],[[23464,57750],[0,-135],[-19,0],[0,-101],[-18,0],[0,-203]],[[23301,57311],[2,202],[0,203],[44,0],[0,34]],[[27478,64058],[1,-90]],[[27448,63962],[9,80],[-9,84],[-11,55]],[[23800,55915],[67,-7]],[[23899,55872],[-15,-135],[-6,-82],[-11,2],[-2,-281]],[[23856,55376],[-79,1]],[[23777,55377],[-15,83],[1,52],[16,35],[3,-25],[11,43],[12,75],[-7,39],[13,13],[-4,30],[8,22],[-11,22],[9,36],[-7,4],[-13,49],[7,60]],[[29050,63047],[40,141]],[[29090,63188],[21,-71],[0,-44],[11,-5],[25,-66],[15,-21],[16,6]],[[29208,62920],[3,-24],[-10,-55],[-34,-101],[-23,-52]],[[29144,62688],[-13,12],[-8,-20],[-23,-5],[-45,41]],[[29020,62938],[30,109]],[[18072,65824],[-88,0],[-58,9],[-65,-7]],[[17861,65826],[0,899]],[[22533,53511],[1,-7],[-83,-210]],[[27163,64280],[1,287]],[[27320,64653],[0,-101]],[[27256,64261],[-42,5],[-50,-24]],[[25846,55809],[10,-44],[-7,-20],[3,-47],[-10,-23],[-11,8],[1,-38],[-11,-29],[2,-26],[-12,-27],[12,-63],[-8,-26]],[[25815,55474],[-6,-17],[-2,-79]],[[25706,55412],[-15,17],[-10,40],[0,69],[-15,9],[-1,94]],[[15441,69375],[0,37]],[[15475,68998],[-28,0],[-6,21],[0,356]],[[22319,62494],[153,-1]],[[22472,62493],[1,-1],[0,-304]],[[22473,61986],[-153,0]],[[23392,62390],[0,-93],[6,20],[25,-20],[5,21]],[[23428,62318],[0,-284]],[[22658,63505],[126,0]],[[15808,61356],[59,-1],[-5,29],[6,39],[-7,57],[8,11],[-5,51],[40,0],[-7,80],[-11,52],[7,98]],[[15893,61772],[13,5],[12,-34],[20,52],[23,6],[20,-18],[13,17],[13,-12],[0,-247],[28,-2]],[[15847,61244],[-9,53],[-27,43]],[[24132,59427],[106,0]],[[24225,59001],[0,-86],[-30,2],[-1,-101],[-30,2]],[[24165,58919],[1,84],[-20,69],[6,25],[-4,48],[-20,8],[6,41],[-14,9],[11,52],[-12,-10],[-4,19],[16,32],[1,131]],[[28645,59881],[4,-4],[-3,86],[17,6],[23,-39]],[[28686,59930],[-3,-120],[-8,14]],[[28675,59824],[-18,-21]],[[28657,59803],[-12,78]],[[20988,55314],[14,0],[0,500],[12,0],[0,203],[59,1]],[[21073,56018],[127,0]],[[21124,54191],[-110,-1]],[[24421,54427],[-12,0],[4,58],[-1,55],[15,19],[-4,58],[10,2],[-7,44]],[[21045,53785],[-6,25],[2,37],[-10,6],[-9,44],[-9,-10],[-20,36],[-9,137],[-16,-21],[-18,136],[-8,15]],[[20633,63454],[-6,-2]],[[20627,63452],[6,2]],[[20617,63402],[10,50]],[[20627,63452],[6,2]],[[20633,63454],[10,49]],[[20669,63503],[-8,-37],[-7,15],[0,-70],[-11,-8]],[[20635,63455],[0,0]],[[23461,57108],[133,1]],[[23592,56739],[-2,-290]],[[23517,56176],[-10,57],[-15,-16],[-12,5],[-21,78],[-7,58],[-22,2],[-20,78],[-9,7]],[[27427,63686],[6,33]],[[27478,63688],[0,-166]],[[26591,57972],[-19,-4],[-16,12],[-32,-42],[-16,16],[-7,68]],[[26501,58022],[-3,68],[9,25],[-4,44],[17,63]],[[26427,57923],[1,21],[22,48],[3,-26],[28,4],[20,52]],[[26507,57668],[-34,0]],[[23066,66153],[-103,1]],[[29773,66671],[99,-11]],[[29872,66660],[8,-1]],[[29880,66659],[12,-43],[-1,-47],[23,12],[31,-38],[-4,-95],[12,-7],[5,33],[22,-11],[3,-27],[-9,-53],[5,-9],[-4,-64],[-19,-71],[12,-46],[27,22],[-6,-77],[-14,5],[-12,-58],[13,-42],[14,11],[7,-41]],[[29823,65864],[-9,2]],[[29790,66116],[3,77],[-18,-11],[-4,59],[-7,-10]],[[26281,62946],[1,53]],[[26282,62999],[93,2],[0,26]],[[26375,63027],[32,-2]],[[26410,62679],[-77,23],[-3,-8],[-50,0]],[[23774,55377],[3,0]],[[23870,54466],[3,15],[-22,47],[-5,48],[-18,26],[-2,53],[-16,9],[2,31],[-5,70],[-16,50],[4,63],[-8,6],[5,29],[-9,106],[-10,28],[8,27],[-2,56],[3,58],[-10,52],[6,35],[-12,21],[7,30],[1,51]],[[24940,65348],[0,368]],[[15852,69961],[18,34],[23,7],[50,77]],[[15943,70079],[2,-120],[6,-38],[21,-61]],[[15714,69827],[0,97],[-17,54],[-11,17],[-23,76],[0,92]],[[28135,56934],[7,17],[16,-37],[14,-10]],[[28198,56436],[-7,-89],[-13,7],[-3,34],[-21,21],[-23,9],[-28,-2],[-30,-12],[-35,-42],[-8,-17]],[[27999,56453],[7,43],[-4,34],[17,33],[7,33],[-2,29],[6,66],[7,20],[26,-30],[13,76],[33,13],[26,164]],[[26013,59123],[40,-28],[28,34],[11,43],[0,26]],[[26202,59008],[-15,-46],[-26,2],[1,-54],[-6,-88]],[[28178,59082],[18,112],[9,98],[3,141]],[[28208,59433],[23,-4],[12,-22],[36,-2],[4,-34],[21,-38],[2,-51],[-9,-28],[3,-42],[8,-13],[28,25],[9,-71],[8,-16],[-2,-42],[27,-53]],[[28378,59042],[7,-10],[4,-53],[6,-10],[-23,-19],[-4,-21]],[[28368,58929],[-21,-77]],[[28264,59025],[-14,4],[-16,-22],[-22,7],[-9,44],[-14,15],[-2,-23],[-9,32]],[[18513,67720],[0,-97],[-33,-4],[0,-101],[-33,0],[-3,-192],[-17,0]],[[20643,63259],[39,-8],[8,17],[26,0],[0,50],[17,4],[0,63],[14,9],[22,-8],[-5,-30],[0,-60],[-40,1],[8,-63],[-26,5],[-16,-39]],[[24437,55361],[-21,-148],[-15,-27],[-11,-79],[2,-45],[-12,-54],[1,-41]],[[24304,54779],[3,11],[-11,84],[5,67],[-14,77],[-23,-15],[-2,29]],[[28627,60202],[13,7],[4,-31],[13,-31]],[[28624,59891],[6,30],[9,0],[6,-40]],[[28657,59803],[-1,-27],[-23,-15],[-8,33],[6,27],[-11,34]],[[28620,59855],[4,36]],[[20476,63806],[69,-3],[32,6],[66,-2]],[[20547,63401],[0,24],[-77,-1]],[[24807,52054],[19,-11],[38,50],[23,-21],[12,-24],[9,21],[9,-19],[8,16],[17,-27]],[[24942,52039],[-15,-51],[-2,-38],[-12,-15],[3,-40],[-28,17],[-11,-53]],[[24862,51708],[-7,29],[-20,3]],[[25374,54179],[113,1]],[[25487,54180],[0,-132],[13,-9],[0,-50],[33,2]],[[25533,53991],[-5,-17],[1,-136],[-14,0],[0,-168],[-15,-45],[16,-43],[-4,-53],[-13,-25],[-4,17],[-19,-28],[-5,-67],[-8,22],[-9,-39],[6,-37]],[[25409,53251],[1,59],[-12,18],[9,10],[-2,56],[15,8],[3,68],[-13,-7],[9,57],[1,78],[-8,36],[-23,35],[-15,49],[-5,75],[1,47]],[[25446,54801],[24,0],[0,-51],[57,1]],[[25541,54499],[-14,-12],[0,-142],[-28,-1],[0,-147],[-12,-17]],[[25473,55362],[82,-4]],[[25555,55358],[0,-150]],[[25325,56221],[11,365]],[[25336,56586],[62,-7],[0,-34],[10,-1],[0,-119]],[[25409,55964],[-91,12]],[[25318,55976],[7,245]],[[25309,55690],[9,286]],[[25439,55965],[0,-432]],[[25299,55344],[10,346]],[[23289,63810],[1,-2]],[[28221,60497],[13,10],[3,38],[39,122]],[[28383,60384],[-3,-9]],[[28366,60374],[-5,0],[-7,-79]],[[28334,60270],[-20,-7],[-11,10],[-15,53],[-10,-7]],[[23834,53231],[-87,-21]],[[25931,69065],[72,-5]],[[25886,68762],[3,89],[-10,80],[1,33],[27,43],[20,15],[4,43]],[[23553,62034],[0,127]],[[23705,61835],[-1,-140]],[[25815,55474],[88,2]],[[25949,55459],[0,-390]],[[20581,64665],[93,-1]],[[25786,59132],[6,-83],[12,-39],[4,-47]],[[25808,58963],[-3,-50],[-5,34],[-7,-60],[-12,-32],[-2,-46]],[[25658,58899],[4,57],[11,40],[4,113],[22,164],[-2,19]],[[28170,64846],[9,-11],[9,33],[0,36],[9,6],[12,51],[1,-87],[26,4],[16,-86],[34,-19],[16,-39],[-5,-13],[20,-97],[47,28],[55,66]],[[28269,64352],[-24,-12],[-16,28],[-33,-60],[-48,55]],[[28080,64355],[-5,26],[18,63],[7,48],[11,6],[8,67],[18,34],[22,20],[-3,40],[8,12],[-6,32],[-9,97],[12,10],[9,36]],[[23125,51944],[17,-76],[-11,-43],[-1,-81],[9,-26],[-7,-46],[5,-32],[15,-7],[4,-88]],[[23156,51545],[6,-9],[-4,-136],[-17,-2]],[[23141,51398],[-6,25],[-18,13]],[[23117,51436],[-7,26],[-17,15],[-3,55],[-8,24],[-12,108],[-20,-6],[-34,96],[-9,63]],[[29478,69336],[42,3]],[[29510,69000],[-2,-85],[-9,-68],[-26,-32]],[[29473,68815],[-8,84],[4,31],[2,92],[10,55],[-13,57],[4,63],[7,30],[-1,109]],[[28603,59928],[0,-38],[21,1]],[[28620,59855],[-10,-58],[-9,-310]],[[28601,59487],[-14,0]],[[28482,59489],[5,107]],[[20922,61783],[122,0],[31,-7]],[[21075,61776],[-1,-203],[1,-90]],[[20436,61483],[208,-8]],[[20644,61076],[-10,47],[-11,-5],[-6,63],[-13,2],[-13,-52],[-9,-64],[-12,36],[-27,-56],[-17,6]],[[24632,60326],[0,-122],[-12,-33],[0,-102]],[[21212,53458],[-101,-447],[-59,-257]],[[20908,53149],[22,1041]],[[20921,62186],[1,-403]],[[20674,61779],[0,152]],[[27109,62863],[6,51],[32,-16],[1,59],[-5,0],[2,61],[36,4]],[[27181,63022],[32,-4],[0,73],[16,-18],[5,-34],[31,-11],[1,16]],[[27266,63044],[10,-31],[58,-8],[0,-38]],[[27311,62871],[-14,-21],[-11,-54],[-17,-8],[-28,-51]],[[27142,62590],[1,62],[-27,4],[1,34],[-10,19],[2,154]],[[27602,60502],[-20,-46],[-15,-5],[-17,-43]],[[27491,60504],[49,98],[4,29],[-13,4],[1,32],[18,34],[12,40]],[[25631,56510],[11,-39],[8,-62],[-3,-19],[24,-1],[0,-27],[12,-9]],[[25683,56353],[3,-50]],[[25598,55951],[-14,2],[0,85],[-29,17]],[[25496,56420],[0,101]],[[28084,62881],[33,-87]],[[28117,62794],[54,-147]],[[28029,62404],[10,38]],[[19587,70034],[-25,-9],[-11,16],[-27,-39],[-16,5],[0,-75],[-18,0],[0,-68],[-46,-1],[-17,-17],[-6,-33],[-11,0],[-6,-34],[-24,-67],[-6,-34],[0,-51],[-22,0],[0,-109],[-31,0]],[[19321,69518],[0,5],[-74,0]],[[19247,69523],[0,206],[37,0],[0,202],[34,0],[0,51],[35,-1],[0,51],[34,0],[-1,203],[5,0],[0,102],[12,-1],[-1,103],[24,1],[1,99]],[[24765,53027],[118,1]],[[24913,53029],[0,-37],[-7,-22],[1,-45],[-7,-19],[-9,-125],[-7,-25],[4,-36],[-8,-35],[-1,-48]],[[24879,52637],[-42,1],[-71,53]],[[25947,58801],[-19,5],[-19,-13]],[[25909,58793],[-2,11],[-26,-3],[-20,28],[-53,134]],[[17466,71219],[35,-1],[0,357]],[[17962,71345],[15,-35],[-6,-39],[14,-47]],[[24732,50824],[7,27],[13,-65],[-8,-14],[-12,52]],[[24726,51002],[5,-6]],[[24731,50996],[-5,6]],[[24590,51752],[28,2],[0,17],[27,-20],[9,-18]],[[24654,51733],[8,7],[27,-12]],[[24812,50889],[-37,-92],[-7,10],[4,41],[-12,16],[-2,41],[6,3],[-12,100],[-11,27],[-9,-7]],[[24732,51028],[-2,96],[-10,28],[-13,72],[-11,30],[-19,95],[-13,45],[-10,11],[-14,67],[-17,36],[-12,93],[-8,-34],[-12,-1],[1,-34],[-35,-2]],[[26305,70240],[0,-580]],[[26203,69750],[18,-7],[32,38],[-1,33],[-33,17],[-14,47],[-8,114],[16,75],[13,14],[20,69],[-2,31],[-18,27],[60,-15],[7,49],[12,-2]],[[28167,59480],[41,0]],[[28208,59480],[0,-47]],[[90472,34420],[4,45],[13,54],[5,-54],[-4,-24],[7,-40],[-2,-61],[-9,-29],[-14,109]],[[31310,38457],[16,-14],[24,26],[10,-11]],[[31360,38458],[0,-111]],[[31309,38272],[1,185]],[[26735,65865],[-1,-27],[-16,-39],[-6,-39],[-13,-4],[-7,-65],[-11,-11],[-17,-72],[5,-79],[-8,-9]],[[18252,72350],[-87,0],[11,-100],[-12,-45],[13,-33],[9,-65],[-5,-43],[5,-77],[13,-16],[1,-108],[-31,0],[0,-51],[-71,0]],[[18299,72350],[0,-490],[46,0],[0,-404]],[[18345,71456],[-32,0],[0,-35],[-18,0],[0,-67],[-18,0],[-2,-33],[-32,0],[0,-68],[-45,3]],[[20547,63208],[-28,13],[-37,99],[-16,10]],[[26948,61005],[33,104]],[[26981,61109],[32,36]],[[27121,60779],[2,-33],[-17,-97]],[[28174,63060],[-20,-44],[-12,14],[-25,-236]],[[25402,53215],[-5,13],[-10,-34],[-85,-1],[0,-34],[-28,0]],[[25274,53159],[-5,374]],[[25108,63100],[60,-1]],[[25168,63099],[1,-85],[25,-1],[0,-68],[22,0],[15,-85],[32,-1]],[[25263,62859],[0,-84]],[[25525,63675],[11,-24],[24,0]],[[25524,63366],[1,309]],[[29093,63678],[4,36],[24,-45],[10,-5]],[[29131,63664],[10,-69]],[[29090,63188],[-24,68],[-23,3],[-8,111],[-12,61],[-11,10],[1,38],[-14,14]],[[28999,63493],[24,67]],[[24258,67981],[97,0]],[[22776,55344],[102,-2]],[[22878,55342],[-2,-513]],[[22863,54830],[-130,7]],[[22733,54837],[2,510]],[[25339,66010],[122,-2]],[[25461,66008],[22,-89],[3,-54],[13,-139],[4,-75],[14,-93],[8,-20],[2,-47]],[[25526,65214],[-73,0],[-1,103],[-33,-2],[0,101],[-32,-3],[-1,52]],[[25386,65465],[17,1],[15,35],[-2,169],[0,154],[-95,-9]],[[90597,35570],[10,43],[4,-16],[-8,-45],[-6,18]],[[90537,37432],[5,20],[1,-49],[-6,29]],[[90507,37973],[14,53],[0,59],[11,0],[0,-66],[-9,-13],[-10,-55],[-6,22]],[[90487,38800],[6,39],[11,-28],[-1,-51],[-8,-23],[-7,25],[-1,38]],[[90486,35993],[20,2],[3,-36],[-19,-8],[-4,42]],[[28675,59824],[6,-82],[17,-14],[17,-52],[3,-41],[-14,-14],[-1,-134]],[[28650,59487],[-49,0]],[[26528,67149],[2,-409]],[[26592,67695],[15,3],[28,120],[14,0],[6,28]],[[26655,67846],[2,-74],[97,9]],[[26659,67255],[-66,-2]],[[21216,70814],[0,-391]],[[20924,72035],[105,-1]],[[24580,68853],[-68,1]],[[24512,68854],[-101,-1]],[[24377,68955],[0,200]],[[16478,62470],[67,1],[3,-34],[56,1]],[[16604,62438],[67,-2],[0,-108],[-25,-9],[-6,-33],[0,-153],[5,-17],[-1,-88],[16,-5],[1,-94],[5,0],[0,-132]],[[16666,61797],[-72,208]],[[16478,62417],[0,53]],[[26106,64163],[68,0]],[[26169,63944],[-63,0]],[[26209,64571],[2,-407]],[[24117,56288],[70,-8]],[[24182,55702],[-22,-34],[-12,28],[-2,40],[-12,-13],[-3,46],[-9,13]],[[24122,55782],[-5,35],[-16,-2],[-3,44],[-15,-3],[-3,59],[-10,3],[-6,30],[18,94],[-6,29],[2,42],[20,11],[5,37],[14,51],[0,76]],[[25326,64901],[65,5],[-1,101],[136,7]],[[25526,64860],[0,-181]],[[25526,64679],[-169,-15]],[[25325,64660],[-1,140]],[[17375,69414],[2,32],[13,40],[12,149]],[[17510,68676],[-30,0],[-34,55],[0,144],[-21,0],[-6,55],[0,205],[-77,3]],[[29738,65368],[0,33],[-11,48],[-8,164],[-8,-4],[3,60],[-6,-5],[1,103],[6,3],[-5,101]],[[26052,61617],[48,-110]],[[26112,61346],[-1,-34]],[[26111,61312],[-39,-50],[-40,14],[-48,-54],[-15,-49]],[[25020,52616],[-56,1],[0,-153],[-29,-17],[0,-51],[-12,1]],[[24923,52397],[-19,53],[-4,39],[-10,34],[-2,77],[-9,37]],[[24569,51939],[13,55],[76,62]],[[24658,52056],[-3,-82],[-5,-3],[3,-50],[-8,-17],[6,-64],[3,-107]],[[19271,63277],[-150,1],[0,5],[-95,2]],[[19016,63386],[-1,213],[0,406],[-2,0],[1,287]],[[22643,51697],[-35,-123]],[[18137,63393],[223,-1],[252,-1],[1,47],[19,-6],[13,58],[13,26]],[[18703,62705],[-15,17],[-33,0],[-1,187],[-5,74],[-190,-1],[-257,0],[0,-10],[-65,-2]],[[18137,62970],[0,423]],[[28208,59480],[37,1]],[[28245,59481],[131,-1]],[[28376,59480],[37,2]],[[28401,59133],[-6,-34],[-19,-11],[2,-46]],[[25898,54151],[5,-42],[-3,-114],[-4,-49],[14,1],[0,-149],[-9,-54],[10,1]],[[25897,53538],[-19,2],[-4,16],[-1,85],[-16,-48],[-7,0],[-9,-42],[-1,89],[-28,-2]],[[18973,65833],[-128,-3]],[[18845,65830],[-2,81],[-24,35],[4,50],[-6,14],[-5,62],[3,45],[15,36],[-7,13],[-1,44],[10,30],[-13,46],[0,28]],[[18819,66314],[6,17],[-16,163],[10,24],[65,0],[24,-44],[11,59],[5,-36],[-3,-109],[18,-6],[30,32],[4,15]],[[26390,63409],[75,4],[0,-44],[29,-6]],[[26494,63363],[0,-34]],[[26375,63027],[-2,381]],[[26010,53745],[12,1]],[[26022,53746],[92,1]],[[26114,53747],[0,-354]],[[26114,53393],[0,-34],[-19,1],[0,-47],[-33,30],[-17,-4],[-13,-86]],[[26032,53253],[-22,2]],[[15829,60925],[1,-3]],[[15830,60922],[-1,3]],[[15813,60835],[-31,0]],[[15782,60835],[-4,84],[14,28],[16,8],[6,-24],[7,-88],[-8,-8]],[[19942,61346],[1,-56],[15,-45],[-10,-72],[-12,-8],[6,-31]],[[19942,61134],[-20,0],[1,-52],[-16,-33],[-12,15]],[[19895,61064],[2,29],[-18,68],[-15,5],[-14,39],[2,104],[-16,1],[-4,42]],[[25103,60394],[0,-41],[12,20],[20,-10]],[[25134,60276],[-14,1],[-13,-21],[-13,-42],[-9,-65],[-17,-59]],[[25068,60090],[-25,44],[-2,87],[8,105],[10,21],[-1,38],[-12,16]],[[24523,59426],[95,1]],[[24618,59427],[5,-16],[-3,-55],[8,-29],[0,-154],[-16,9],[0,-25]],[[24612,59157],[-1,-137]],[[24445,59425],[78,1]],[[24246,57760],[3,345]],[[26972,64743],[46,-2]],[[27030,64657],[1,-377]],[[23408,58426],[-1,-131],[14,-77],[9,-2]],[[24681,50807],[39,-33],[-19,-8],[-20,41]],[[24628,50763],[25,19],[2,-17],[-26,-20],[-1,18]],[[24732,51028],[-1,-32]],[[24726,51002],[1,44],[-10,56],[-13,-64],[-14,14],[-7,-22],[-7,31],[-6,-27],[10,-63],[-12,4],[-7,-27],[-4,-54],[-8,7],[-5,-57],[-8,12],[-19,-33],[-6,-76],[-16,16],[5,21],[-13,67],[-18,57],[-11,-13],[-26,21],[-10,33],[-25,12],[-16,25],[-16,60],[12,14],[7,58],[8,-12],[12,-52],[7,22],[-1,-68],[15,-17],[-4,104],[-23,64],[0,42],[-6,7]],[[15363,69375],[78,0]],[[15332,68480],[10,193],[-1,69],[7,184],[0,92],[-5,39],[8,91],[12,227]],[[26655,67846],[-6,48],[9,44],[9,87],[4,-50],[19,31],[5,29],[-21,31],[24,-3],[11,24],[5,41],[23,10],[34,28],[9,45],[31,30],[11,-30],[23,-25],[15,-39],[17,-123],[10,-37],[7,-97],[3,-91]],[[23546,64168],[45,-1]],[[23556,63953],[-3,0],[0,100],[-6,0],[-1,115]],[[24087,63049],[109,-6]],[[24196,63043],[-3,-300]],[[24160,62628],[-77,85]],[[5814,42059],[43,9],[13,49],[4,35],[13,48],[14,15],[6,-27],[6,-70],[20,-84],[4,-52],[-4,-15],[3,-47],[18,-55],[3,57],[12,-2],[-4,-64],[8,-24],[-1,-29],[17,-70],[-12,-37],[-11,18],[-21,-29],[-6,26],[-17,31],[-25,11],[-30,-20],[-7,4],[-7,84],[-11,34],[-1,31],[-14,67],[0,61],[-13,45]],[[18137,61963],[0,1007]],[[18704,62392],[-2,-58],[-13,-9],[1,-34],[-20,0],[-4,-61],[-6,-1],[-5,-48],[-10,0],[-1,-117],[3,-43],[-26,-59],[-38,6],[-10,-43],[0,-51],[-9,-33]],[[18137,63639],[1,134],[0,628],[1,266]],[[18635,64398],[15,-62],[3,-101],[6,-29],[1,-160]],[[18137,63393],[0,246]],[[27485,46274],[0,32],[21,11],[7,20],[5,61]],[[27518,46398],[11,-19],[13,34],[6,39]],[[27548,46452],[5,-12]],[[27553,46440],[-21,-138],[-9,-82],[-25,-93],[-34,-139],[-24,-66],[-3,12],[34,122],[14,40],[7,53],[3,81],[5,32],[-6,23],[-9,-11]],[[27414,45876],[14,60],[5,-33],[-14,-44],[-5,17]],[[27386,45813],[9,39],[11,4],[-5,-33],[-15,-10]],[[27310,45701],[52,90],[6,-30],[-45,-80],[-13,20]],[[27214,46977],[166,2]],[[27380,46979],[0,-514],[3,1],[1,-219]],[[27384,46247],[-12,-17],[0,-26],[-27,-18],[-23,-6],[-17,52],[-8,68],[2,79],[6,60],[6,-3],[-2,49],[-12,97],[-11,47],[2,34],[-8,62],[-11,32],[-5,85],[-6,18],[-11,-15],[-9,101],[-24,31]],[[27118,45540],[19,106],[20,46],[25,43],[3,23],[36,66],[38,-67],[4,-52],[14,-43],[-4,-11],[-40,-48],[-3,27],[-27,-5],[-3,-24],[-46,-73],[-36,-15],[0,27]],[[27062,45510],[39,24],[-10,-43],[-17,-14],[-13,8],[1,25]],[[27020,45533],[6,35],[12,-10],[-5,-41],[-13,16]],[[26806,45614],[15,13],[4,-23],[-20,-10],[1,20]],[[26978,55163],[12,119],[-5,145],[7,106],[9,90],[-10,42]],[[26991,55665],[26,35],[21,-76],[11,13],[23,-18],[12,30],[14,10],[9,-17]],[[27134,55585],[-5,-21],[8,-45],[27,-55],[9,0]],[[27193,55407],[-62,-158]],[[27131,55249],[-5,22],[-20,29],[-28,-35],[-35,-8],[-12,-38],[-6,-83]],[[26194,55065],[7,-124],[6,-43]],[[26207,54898],[17,-76],[5,-38]],[[26109,54667],[-1,102],[-14,0],[-48,82],[-10,33]],[[26036,54884],[0,118],[5,18],[19,1],[5,17]],[[22659,49740],[69,-55],[8,41]],[[22849,49420],[-14,-83],[-12,-2],[-6,55],[-21,-10],[-4,18],[-32,-11],[-11,12],[-3,-46]],[[22746,49353],[-23,13],[-12,44],[-2,-33],[-10,20],[-5,41],[-9,-2],[-16,37],[-7,-15],[-3,40],[5,31]],[[22664,49529],[-1,50],[-10,-5],[-12,26]],[[22641,49600],[-5,13],[-1,54],[24,73]],[[23468,64172],[78,-4]],[[23554,63649],[-122,5]],[[23432,63654],[-6,24],[-2,128],[-30,1]],[[13347,81071],[9,23],[10,-28],[-5,-52],[-16,34],[2,23]],[[13279,80906],[61,56],[7,-80],[13,-14],[-20,-68],[-24,-1],[-33,63],[-4,44]],[[13241,80901],[26,65],[8,-25],[-26,-58],[-8,18]],[[13172,81388],[4,66],[6,1],[52,-135],[-12,-28],[-1,-68],[-15,-111],[-23,74],[-9,113],[-2,88]],[[13390,82602],[85,-47],[44,-115],[44,-33],[11,-116],[23,-15],[27,-35]],[[13651,81856],[1,-60],[10,-38],[-5,-118],[12,-104],[11,-46],[6,-133],[12,-63],[-32,-100],[-24,-122],[-1,-33],[-20,-90],[-23,-77],[-37,-97],[-27,-55],[-19,-14],[3,-46],[-19,-23],[-12,40],[-1,56],[-13,24],[-1,-44],[-12,-22],[-18,18],[-13,52],[-4,108],[3,57],[-17,33],[8,103],[-9,6],[-16,56],[-6,64],[30,63],[17,63],[15,-8],[-3,75],[-11,82],[14,122],[-9,190],[-10,67],[-43,164],[-22,55],[-12,48],[-7,-34],[23,-62],[25,-85],[7,-72],[22,-90],[10,-131],[-16,-43],[-2,-79],[7,-92],[11,-62],[-9,-28],[-11,96],[-8,12],[3,-70],[-4,-74],[-36,-102],[-14,-5],[-24,49],[19,73],[11,73],[-3,38],[-25,-10],[10,-72],[-8,-42],[-33,-56],[-7,1],[-23,108],[-11,-45],[-25,54],[-17,18],[-12,50],[-28,68],[0,76],[31,31],[22,51],[-20,47],[7,75],[-9,39],[23,44],[3,24],[-18,1],[-3,74],[7,43],[-41,-17],[6,-45],[11,-16],[-1,-37],[-13,-85],[-1,-60],[-19,-73],[-18,13],[7,-93],[-10,-43],[-24,52],[-25,22],[-14,83]],[[10628,87240],[0,-100],[130,-95],[17,100],[135,-145],[81,180],[170,20],[1,-39],[-33,-272],[47,-112],[66,-76],[26,-22],[11,-116],[29,-80],[266,-580],[30,-299],[-8,-90]],[[11480,85398],[3,69],[-15,48],[-55,121],[-30,47],[-96,89],[-36,71],[-43,66],[-98,104],[-42,49],[-91,144],[-30,39],[5,29],[31,89],[24,-14],[-9,-27],[24,3],[0,43],[21,70],[-22,7],[2,77],[-14,116],[7,35],[22,41],[-5,34],[16,30],[-13,56],[-19,-51],[-2,-59],[-25,-21],[-21,-72],[-1,-49],[-107,-100],[-12,-28],[-28,-28],[-95,22],[-67,36],[-26,32],[-123,125],[-17,56],[18,-10],[34,24],[11,71],[-33,131],[3,42],[-20,-17],[-31,44],[6,-50],[45,-120],[-10,-21],[-54,-51],[-39,0],[-49,55],[-61,24],[-32,23],[-81,40],[-45,11],[-59,-4],[-63,-33],[-77,-12],[-80,-28],[-54,-48]],[[26285,64350],[0,-181]],[[21170,62382],[124,2],[187,9]],[[21481,61891],[-283,-1],[-31,-3]],[[21167,61887],[2,91],[1,404]],[[26535,59335],[12,17],[8,-17],[8,19],[11,-43],[9,-63],[10,24],[8,-25]],[[26583,59038],[-53,6],[-5,19]],[[25412,64068],[114,6]],[[25526,64058],[-1,-383]],[[25412,63363],[-2,402],[4,0],[-1,203]],[[15663,72891],[-6,0],[0,-231],[-155,0],[0,17],[-308,-1]],[[15194,72676],[-16,119],[-8,101],[1,53],[-11,56],[12,58],[9,138],[-19,46],[3,22],[17,1],[40,-55],[32,-64],[10,-1],[25,-39],[6,12],[41,-55],[-1,-20],[35,-41],[56,-11],[21,13],[31,-37],[9,19],[10,-18],[24,7],[12,-32],[41,2],[32,71],[-3,-24],[22,-42],[7,-45],[17,17],[17,-5],[-3,-31]],[[15266,72272],[85,0],[0,-17],[151,-1]],[[15502,72254],[0,-302],[4,0],[1,-205],[80,3]],[[15587,71750],[-1,-102],[13,-2],[-1,-235]],[[15337,71411],[-11,130],[8,8],[6,-52],[11,31],[52,63],[-10,27],[-34,23],[-2,45],[-27,14],[-8,-24],[8,-90],[-16,-21],[3,38],[-4,206],[-14,176],[-24,80],[-9,207]],[[27155,52003],[16,15],[23,-16],[0,-19],[30,2],[-1,171],[16,0]],[[27239,52156],[19,-330],[13,-129],[0,-51],[14,-167]],[[27199,51422],[-1,160],[-11,51],[-4,43]],[[15663,72891],[14,-21],[1,-59],[10,6],[3,53],[-14,34],[0,40],[12,28],[21,10],[3,-31],[-15,-34],[10,-50],[7,6],[2,48],[10,14],[8,-100],[-15,-10],[11,-42],[8,-78],[13,-21],[-8,-25],[-16,2],[2,-42],[-17,-36],[-9,-113],[-14,-9],[11,113],[-6,17],[-19,-101],[-4,-53],[-23,-80]],[[15649,72357],[-108,1],[-39,-3],[0,-101]],[[15266,72272],[-5,77],[-15,162],[-14,36],[-4,55],[-14,23],[-5,31],[-15,20]],[[15785,61302],[2,-44],[-5,-46],[15,-51],[-12,-25],[-4,-44],[19,-56],[-7,-14],[-11,29],[7,-71],[-15,-16],[-9,38],[-26,61],[-13,-12],[-23,67],[-10,53],[-17,33],[-16,8],[-20,-33],[14,127],[3,48],[-12,92],[7,20],[-10,53]],[[28348,60209],[0,-207]],[[28286,59868],[-10,20]],[[28276,59888],[-16,22],[-14,71],[-21,25],[-14,-9]],[[28211,59997],[-3,181],[29,57]],[[24955,63475],[-34,-1],[-1,-68],[-19,-1],[0,-16],[-62,-1]],[[19845,64669],[167,1]],[[18742,66315],[77,-1]],[[16085,62334],[0,-81],[-16,-1],[0,-202],[-4,-20]],[[16032,62031],[3,32],[-26,0],[-10,47],[0,55],[-8,24],[-9,-17],[-9,23],[3,45],[-9,11]],[[21203,57388],[0,-506]],[[21203,56871],[-194,0],[0,351]],[[29355,66371],[120,53]],[[29435,65889],[-7,0],[-2,-84],[-51,32],[-55,86],[-6,-1]],[[29314,65922],[6,57]],[[24711,56299],[75,-3],[-1,-51],[-30,-17],[-2,-61],[9,-1],[8,46],[6,-17],[23,-1]],[[26526,57668],[-2,-20],[8,-51],[18,-32],[9,17],[2,-48],[9,-63],[0,-30]],[[26549,57359],[-23,22],[-13,-29],[-3,-44],[-12,-42],[-24,26],[-9,-19]],[[26591,61919],[0,46],[9,397]],[[26680,62403],[20,-4],[12,-42]],[[26712,62357],[1,-463]],[[26607,61916],[-16,3]],[[29144,62688],[-27,-92],[-21,-118],[-22,-149],[-20,-60],[-19,-14],[-11,14],[6,88],[15,97],[3,69],[-8,22]],[[17636,58805],[0,240],[-14,2],[0,780]],[[23453,62826],[12,-40],[13,-10],[-9,-25],[6,-79],[18,-52],[-3,-28],[17,-20]],[[23507,62572],[-35,3],[-3,-246]],[[23469,62329],[-11,-9],[-20,19],[-10,-21]],[[16799,72766],[11,-44],[23,-23],[11,49],[10,-18],[23,6],[10,-20],[-3,-36],[22,-2],[6,-43],[15,-17],[10,13],[4,61]],[[16941,72692],[26,57],[10,3],[19,-71],[7,-61],[20,-47],[16,49],[15,-13],[15,29],[17,-26]],[[17086,72612],[-1,-658]],[[17085,71954],[-38,0]],[[15649,72357],[-36,-173],[-13,-119],[12,8],[23,-13],[12,27],[21,17],[3,38],[-44,-62],[-17,27],[28,150]],[[15638,72257],[60,0],[0,-136]],[[15698,72062],[-17,-96],[7,-72],[-6,-48]],[[15682,71846],[-12,-12],[-9,38],[-19,-45],[-3,-32],[-17,-20],[0,-25],[-35,0]],[[15649,73739],[11,-4],[34,-53],[-8,-8],[-22,20],[-15,45]],[[15623,73630],[17,26],[2,-33],[-19,7]],[[15586,73509],[7,30],[20,1],[2,-29],[15,-33],[17,-9],[-18,69],[37,108],[12,-2],[37,-58],[-19,-50],[11,-66],[-2,-62],[-11,-25],[4,-69],[-20,-12],[-15,50],[-9,-12],[-22,11],[-31,62],[-6,76],[-9,20]],[[15577,73617],[18,-10],[18,-54],[-30,41],[-6,23]],[[24742,61626],[13,45],[9,110]],[[24865,61431],[-38,3],[0,-102],[-48,-55]],[[24779,61277],[-12,46]],[[24767,61323],[-11,50],[-18,50],[-5,70],[1,78],[8,55]],[[20069,62765],[191,-5]],[[20260,62760],[-1,-53],[-15,-5],[1,-46],[-7,-123],[-15,-13],[1,-41],[-8,-38],[2,-35]],[[20218,62406],[-6,-70]],[[19991,62637],[4,15],[-24,53],[10,60]],[[16108,64881],[127,0],[244,0]],[[16438,63162],[11,101],[0,169],[-16,34],[-10,52],[-3,85],[-10,25],[-26,9],[-19,37],[-13,68],[-8,0],[-7,50],[-19,18],[0,25],[-13,0],[-8,26],[-31,9],[-9,-44],[-21,-42],[0,-49],[-16,-9],[-5,34],[-16,0],[-16,41],[0,221],[-74,-1]],[[21287,61485],[194,2]],[[21285,60760],[0,209],[2,1],[0,515]],[[17304,71118],[0,681]],[[27383,49938],[0,-297],[-2,-9],[0,-305]],[[27381,49327],[-4,0],[3,-210]],[[27305,49119],[-1,78],[-18,129],[-6,24],[-20,23],[-2,70],[-18,66],[-3,29],[-8,-6],[-13,62],[19,-28],[3,-18],[4,58],[6,26],[-31,1],[0,68],[-19,-1],[0,68],[-9,68],[-28,0],[0,102]],[[23650,69653],[1,27],[19,13],[7,-19],[23,76],[9,65]],[[23709,69815],[25,-52],[11,7],[14,-52],[11,-5],[20,-47],[50,-3],[16,-53]],[[23856,69610],[-14,-33],[-19,-10],[0,-51],[-17,-34],[-10,-63],[-7,-1],[-2,-121]],[[23719,69298],[-68,1]],[[26474,55275],[0,-96]],[[26474,55179],[0,-57],[-7,1],[-15,-130]],[[26429,55060],[-29,46],[-9,60],[-10,-10],[-14,61]],[[21324,64925],[154,0]],[[21478,64925],[1,-254]],[[21479,64669],[-158,1]],[[21321,64670],[3,53],[0,202]],[[21204,58407],[244,6]],[[26514,56269],[51,168]],[[26607,56409],[5,-22],[13,-4],[2,-41],[19,-36]],[[26881,55501],[18,-110],[14,-14],[3,-84],[8,-35],[-5,-98],[2,-13]],[[26921,55147],[-11,-2],[-30,-43],[-4,16],[-24,-33],[-10,48],[-40,-59]],[[26802,55074],[-6,87],[-16,26],[-13,105]],[[29219,64547],[39,-90]],[[29254,64418],[-6,-45],[13,-7],[2,-45],[-6,-33]],[[29257,64288],[-21,19],[-3,19],[-18,17],[-11,-6],[-13,27]],[[29191,64364],[1,62],[9,24],[3,110],[15,-13]],[[27052,53989],[10,-6],[12,-38]],[[27074,53945],[17,-46],[16,-96],[11,-3],[6,-36],[26,-65],[0,-28],[10,-18]],[[27160,53653],[1,-33],[13,-48],[-3,-19]],[[27141,53410],[-20,39],[-34,-20],[-33,32]],[[27054,53461],[-4,41],[1,53],[-10,30],[-12,-10]],[[24633,61919],[19,56],[35,-1],[2,52],[11,24],[14,88],[22,0],[9,68],[9,2],[12,-42],[20,-39],[12,13],[6,-28]],[[24742,61626],[1,77],[-21,3],[2,52],[-52,0],[-6,-35],[-13,9],[-5,-38],[-5,29],[-11,-5]],[[24702,52184],[-7,-54],[-12,-40],[-22,30]],[[24661,52120],[-5,12],[-12,-66],[-7,17],[-9,60],[-5,-2],[-16,62],[-1,30],[-17,31]],[[26216,54263],[-3,-84]],[[26213,54179],[-5,-59],[-14,-72],[-3,-45],[4,-69]],[[26195,53934],[0,-20]],[[26195,53914],[-6,12],[-16,-36],[-3,-46],[-56,5],[0,-102]],[[26022,53746],[9,49],[-1,44],[6,58],[9,41],[-4,85],[6,28]],[[25302,52136],[56,31],[1,25],[14,-40],[-9,-28],[-10,16],[-18,-2],[-20,-17],[-14,15]],[[25392,52659],[-15,-46],[2,-38],[-9,-57],[1,-41],[-6,-32],[-1,-144],[-8,-66],[-15,-4],[1,36],[-20,40],[-15,-16],[-5,23],[-18,-22]],[[25284,52292],[-5,426]],[[25279,52718],[-3,306]],[[25276,53024],[-2,135]],[[16981,73980],[214,0]],[[17193,72870],[-27,1],[0,-295],[-19,10],[-16,47],[-2,43],[-35,-80],[-8,16]],[[16941,72692],[-3,94],[-14,63],[13,24],[20,-10],[14,27],[-5,79],[14,10],[3,87],[14,63],[-9,56],[-8,102],[-1,79],[7,49],[8,6],[13,153],[-8,122],[-22,155],[-3,56],[7,73]],[[15720,73667],[6,14],[26,-115],[-18,42],[-14,59]],[[15785,73566],[-8,79],[8,44],[-13,30],[-17,-6],[-11,-41],[9,-44],[-19,40],[8,57],[-10,25],[-9,-14],[-1,65],[-21,54],[11,21],[-5,36],[-13,16],[16,54],[184,0],[97,-6],[145,5],[106,-1]],[[15618,73982],[15,0],[4,-29],[-17,-2],[-2,31]],[[26693,53580],[54,-4]],[[26774,53240],[3,-43],[-36,0],[0,-98],[-9,-1],[0,-42]],[[26732,53056],[-27,2]],[[26705,53058],[4,42],[-12,64],[5,57],[-8,28],[0,62],[-14,16],[-15,67],[1,40]],[[18973,64960],[1,382]],[[28245,59481],[31,196],[0,211]],[[28339,59670],[-20,-43],[11,-21],[13,2],[11,-25],[6,-92],[16,-11]],[[21558,52622],[-103,4],[0,-68],[-57,1],[0,-366],[-62,-1],[0,-269]],[[24749,65515],[20,63]],[[24769,65578],[3,-124],[20,-38],[-1,-54],[-6,-15]],[[26282,62999],[0,185]],[[26397,64655],[16,1],[0,203]],[[26445,64860],[97,2]],[[26542,64574],[-32,-1],[0,-17],[-32,0],[0,-51],[-64,-2]],[[19861,60913],[18,55],[4,53],[12,43]],[[19942,61134],[10,-25],[4,-49],[-5,-32],[6,-56],[13,-19],[3,-32],[-7,-16],[0,-150]],[[19966,60755],[-136,0]],[[22162,51755],[0,-327]],[[22047,51424],[-1,62],[-13,40],[11,14],[-3,65],[6,18],[-5,62],[8,57],[4,150],[4,-1],[2,67],[58,-10]],[[18419,70798],[-1,545],[-21,-26],[-17,21],[1,27],[-16,34],[-10,50],[-10,7]],[[26807,54348],[16,55],[-4,15]],[[26819,54418],[8,-2],[38,134]],[[26865,54550],[18,-13]],[[26883,54537],[2,-62],[7,-45],[-1,-85],[5,-51],[3,-88],[14,-37],[1,-27]],[[26886,54096],[-14,44],[-9,58],[-16,18],[-4,26],[-24,41],[-12,65]],[[17570,55850],[-264,1],[-58,6],[-1,20],[-36,48],[2,17],[-40,0]],[[23550,59624],[-106,3]],[[23444,59627],[0,317],[-10,60],[8,6]],[[31618,38134],[-8,-32],[-8,13],[-6,-20]],[[31572,38127],[1,84]],[[26698,69158],[7,-76],[-1,-55],[7,-37],[-4,-71],[-8,-67],[0,-98]],[[26699,68754],[-159,-3]],[[19669,68355],[231,-1],[160,-2]],[[19952,67578],[-17,0]],[[19935,67578],[0,169],[-34,0],[0,101],[-67,1],[0,99],[-61,0],[-3,34],[-34,-2],[0,66],[-34,0],[1,104],[-17,-1],[0,103],[-17,-1]],[[22878,55342],[52,-2]],[[31286,37841],[14,158],[1,50]],[[31309,38050],[1,-111],[8,4],[1,-29],[-7,-23]],[[31312,37891],[-22,-56],[-4,6]],[[25060,57676],[-43,-1]],[[22472,62594],[0,-101]],[[31209,38263],[21,-13]],[[31234,38230],[0,-20],[-12,-20]],[[31222,38190],[-15,-10],[-2,28],[-12,-4]],[[31193,38204],[-11,35]],[[31222,38190],[7,-11],[10,-58]],[[31195,38089],[7,31],[-9,84]],[[30985,38023],[20,12],[5,-43],[-15,-38],[-12,32],[2,37]],[[2341,307],[20,69],[4,-20],[27,2],[4,-44],[-7,13],[-29,-30],[-8,-39]],[[29497,66929],[5,432]],[[29500,66699],[-8,65],[4,37],[1,128]],[[22875,49344],[-14,-59],[-13,-81],[-23,-163]],[[22825,49041],[-13,-1]],[[22812,49040],[9,68],[14,70],[10,87],[8,35],[-2,47],[14,88]],[[22746,49353],[9,-24],[15,-1],[11,17],[-4,-64],[7,-48],[15,-34],[17,-18],[-12,-97],[1,-23],[-9,-38]],[[22796,49023],[-143,-3],[-10,34],[-4,38],[-15,18]],[[22624,49110],[3,164],[-1,126],[38,129]],[[29697,69333],[69,-6],[114,6]],[[29880,69333],[-8,-118],[15,-36],[-28,-105],[10,-20]],[[29869,69054],[-21,-82],[-28,59],[7,-76],[-16,23],[-32,-188],[-31,49]],[[27907,62615],[-15,-102],[2,-9],[-17,-121],[12,-128],[-25,-134]],[[26947,56112],[4,18],[29,40],[9,-19],[16,2]],[[27034,56049],[24,-60]],[[27058,55989],[-74,-222]],[[28267,61184],[13,-20]],[[28424,60740],[-4,-40],[-9,5],[-19,-68]],[[23497,55777],[-18,36],[-10,-12],[-30,8],[-9,-9],[-12,17],[-9,-9]],[[23358,55797],[-1,576],[1,6]],[[26683,62778],[30,162]],[[26857,62767],[-4,-186]],[[26853,62581],[-6,-46]],[[26847,62535],[-158,34]],[[26749,54683],[41,-321],[29,56]],[[26807,54348],[-77,-274]],[[26730,54074],[-6,42],[-10,18],[-12,115],[3,33],[-12,31]],[[26481,56577],[-5,18],[5,66],[10,53]],[[26491,56714],[54,-81],[14,34]],[[26456,57220],[-1,-70],[24,-89],[35,-56]],[[26514,57005],[0,-70],[7,-28]],[[26521,56907],[-84,1]],[[17042,70488],[105,-2]],[[17181,70485],[157,-3]],[[17240,69417],[1,100],[-59,0],[0,50],[-12,0],[-1,68],[-17,49],[0,33],[-17,-2],[-5,34],[0,73],[-6,0],[0,101],[-12,-1],[0,119],[-5,51],[-12,34],[0,97],[11,0],[0,102],[-62,0]],[[17044,70325],[-2,0],[0,163]],[[26921,55147],[17,-63],[7,-7]],[[26885,54787],[-7,13],[2,103],[-36,56],[3,30],[-22,34],[-26,-8]],[[26799,55015],[3,59]],[[26946,55674],[13,43]],[[26967,55718],[24,-53]],[[26494,63363],[5,186]],[[26499,63549],[144,-35]],[[26643,63514],[2,0],[-22,-281],[-16,5]],[[24732,58841],[16,110],[23,58],[5,52],[8,19]],[[24784,59080],[18,33],[3,43],[9,7],[5,133],[-22,44],[3,15],[-5,71],[-19,0]],[[24776,59426],[8,54],[1,50],[11,50]],[[24796,59580],[52,-1]],[[24848,59579],[2,-97],[-2,-183]],[[24757,58842],[-25,-1]],[[29287,69318],[98,8],[93,10]],[[29473,68815],[6,-20]],[[27767,61275],[83,-200],[8,-27]],[[27858,61048],[3,-41],[-7,-62]],[[27780,60729],[-6,-13],[7,-39],[-18,-46]],[[28473,64234],[-4,-48],[-8,-23],[2,-59],[10,-37],[-1,-26],[-21,-83],[6,-38],[19,-1],[7,-34]],[[28288,63734],[3,34],[-10,-12],[-9,84]],[[24618,59427],[58,0]],[[24676,59427],[100,-1]],[[24784,59080],[-36,0],[0,68],[-42,1],[-68,9],[-26,-1]],[[28171,62647],[18,119],[11,16],[23,76],[6,56]],[[18131,73978],[105,-2],[190,2],[228,0]],[[18654,73978],[1,-99],[0,-404],[1,-104]],[[18656,73371],[-12,7],[-97,0],[0,-202],[-215,0]],[[29628,68685],[-10,-57],[10,-15],[-6,-36],[-8,7],[-16,-97],[4,-7],[-15,-133]],[[29587,68347],[-6,153],[-63,-31],[-32,-3]],[[23011,67297],[127,-3],[66,1]],[[23561,54650],[7,15],[10,-23],[8,7]],[[23461,54010],[-13,1],[0,340]],[[26712,62357],[15,-28],[1,-37],[59,-4],[54,-10]],[[26841,62278],[15,-3],[-2,-105],[31,-7]],[[26885,62163],[-4,-118],[-9,3],[-3,-85],[-16,3],[-1,-41],[8,-55],[-21,-31]],[[26839,61839],[-9,28],[-9,111],[3,44],[-7,33],[-21,-32],[-15,0],[-6,-27]],[[12379,84716],[4,-72],[19,1],[21,38],[11,-23],[20,-2],[21,-29],[54,11]],[[12292,85061],[35,-45],[27,-125],[-10,-5],[-22,115],[-23,19],[-7,41]],[[12487,85577],[0,-51],[22,-71],[114,-152],[32,-119],[46,-120],[50,-110],[-23,-49],[33,-134],[47,-140]],[[12690,84293],[-10,-29]],[[12663,84216],[-4,-1],[-39,166],[-55,147],[-11,140],[9,65],[-2,52],[27,41],[-13,100],[-8,-2],[-9,-85],[-20,-30],[0,-42],[12,-22],[-13,-57],[-10,10],[-22,-20],[-25,11],[-36,34],[-7,-15],[-35,36],[-40,174],[-4,110],[-42,140],[-13,79],[19,1],[-11,174],[-12,-17]],[[24531,57528],[0,52],[41,-6],[151,-3]],[[24723,57571],[0,-83]],[[24697,57850],[28,5],[-2,-284]],[[25424,67218],[-2,-63],[8,-85],[-7,-57],[14,-62],[0,-85],[5,-55]],[[24750,68448],[0,-108]],[[24750,68340],[-34,6],[-128,-3],[-23,-33],[1,-69]],[[24516,68252],[0,195],[-4,0],[0,407]],[[29160,63798],[-17,-43],[-5,-31],[-15,-9],[8,-51]],[[27156,59531],[90,-16]],[[22947,71220],[140,1]],[[23091,70512],[-86,0]],[[22328,70417],[-199,1]],[[22129,70418],[-45,1]],[[22084,70419],[1,397]],[[29731,68748],[59,-95],[1,-16],[-14,-82],[-14,-49],[1,-30],[-15,-80]],[[29749,68396],[-14,20],[-7,-107],[-32,39],[-8,-3],[-27,-171],[-16,19]],[[29645,68193],[-46,50],[-7,106],[-5,-2]],[[23066,66081],[2,-56],[22,-56],[-1,-83]],[[23089,65886],[-10,-1],[0,-37],[-68,1]],[[17231,64115],[-67,-611]],[[17164,63504],[-196,1],[-273,-3]],[[29631,68114],[14,79]],[[29749,68396],[18,-24],[36,11],[38,-40]],[[29841,68343],[-4,-56],[6,-22],[-12,-69],[-12,-44],[0,-85],[-19,-67],[1,-64],[-6,-44]],[[25685,69733],[6,80],[31,-17],[-23,-128],[-14,65]],[[25568,69555],[12,14],[2,-63],[-14,23],[0,26]],[[25468,68947],[4,55],[31,133],[26,36],[11,-7],[11,34],[15,-32],[-6,46],[12,97],[27,109],[7,100],[12,-5],[21,32],[1,59],[17,60],[22,-3],[-2,-87],[-16,-5],[-2,-142],[-12,-40],[-8,4],[-5,-53],[-14,-52],[5,-43],[-13,-39],[4,-26],[-18,-33],[-13,-62],[-16,-138]],[[26756,64659],[-86,-2]],[[27304,54454],[-14,13],[-55,-165]],[[27223,54471],[-1,39],[-14,90],[-5,7],[-10,69],[5,38],[-6,46]],[[27192,54760],[2,23],[42,100]],[[21273,66995],[198,-1]],[[21492,65943],[-1,-102],[-16,0]],[[21475,65841],[-170,-4]],[[21305,65837],[-6,-1]],[[22718,67577],[-1,406]],[[25205,69764],[70,-2]],[[25460,69283],[-21,-40],[3,-47],[-11,-59],[-9,-15],[-11,-83],[-12,-42],[-2,-49]],[[25397,68948],[-67,-6],[-3,8]],[[25327,68950],[-3,101],[1,101],[-67,3]],[[8956,90834],[-32,-2],[-253,0],[0,-168],[-304,0],[-114,0],[-205,-194],[-282,-265],[-173,-164],[0,-84],[-291,0],[-17,2]],[[29282,64306],[-7,-34]],[[29275,64272],[-25,-19]],[[29250,64253],[7,35]],[[19456,67942],[22,-58],[18,-75],[0,-93],[66,0],[0,-17],[33,0],[0,-34],[34,0],[-1,-51],[34,1],[0,-34],[33,0],[0,-34],[33,0],[0,-17],[51,0],[0,13],[156,2],[0,33]],[[19955,66336],[0,-201]],[[26836,63264],[6,33],[6,135]],[[26937,63422],[-3,-109],[21,-5],[-2,-103],[11,-2],[-2,-102]],[[23969,55881],[-1,-84],[39,-4]],[[24007,55793],[-3,-419]],[[24718,66777],[164,1]],[[24882,66778],[0,-359]],[[29305,64360],[10,-12],[9,-51],[7,14],[4,-60],[6,-17],[-4,-46],[-24,-23]],[[29313,64165],[-22,6],[3,25],[-11,39],[6,60]],[[23236,69803],[137,0]],[[24848,59579],[72,-2],[1,131],[-2,139],[4,0]],[[24999,59427],[-8,-40],[-13,7],[2,31]],[[24965,59426],[6,-22],[-7,-64],[10,-59],[-10,-43]],[[24882,66778],[0,51]],[[17310,64667],[120,0]],[[17426,62527],[-204,2],[-123,-82]],[[17099,62447],[-9,61],[24,79],[-1,43],[-11,119],[5,39],[14,0],[6,44],[8,3],[-3,48],[19,41],[-1,17],[29,33],[1,61],[6,40],[-7,14],[6,36],[-8,85],[2,91],[7,70],[-2,41],[-20,92]],[[16678,63062],[-54,-331],[-47,-82],[-18,-18]],[[26782,52851],[-1,62],[-6,52],[-38,3],[0,88],[-5,0]],[[20636,67575],[-1,5],[0,540],[1,244]],[[27885,66457],[20,-19],[9,-57],[20,-40],[62,63],[27,19],[28,32]],[[28094,65830],[-170,-1]],[[27924,65829],[-39,1]],[[27885,65830],[0,627]],[[31513,38417],[2,-26],[11,-28],[-2,-27]],[[31524,38336],[-10,-12],[-2,-67]],[[31488,38443],[25,-26]],[[31524,38336],[16,-101]],[[31540,38235],[-8,19],[-14,-6]],[[23655,65253],[0,113],[-10,1],[-1,304]],[[21561,52197],[-1,-588]],[[21560,51609],[-25,22],[-22,-14],[-12,24],[-17,-7],[-4,-22],[-26,21],[-11,50],[-13,-3],[-26,41]],[[26676,57055],[7,11],[55,8],[20,69]],[[26688,56779],[5,43],[-15,74],[3,122],[-5,37]],[[25197,60708],[-93,-3]],[[25073,60709],[1,305]],[[27344,65251],[134,-2]],[[27478,64822],[-134,1]],[[25135,64583],[0,-203]],[[25135,64380],[-16,-2],[1,-101],[-17,-2],[0,-42],[-16,-3],[-9,-33],[-37,-3]],[[24961,64373],[-2,53],[25,149]],[[19966,60755],[0,-253]],[[27171,63760],[2,171],[-27,3],[1,86]],[[23962,70173],[-1,292],[25,0],[0,206]],[[23972,56259],[12,11],[8,-20],[26,36],[6,25],[7,-14]],[[24031,56297],[86,-9]],[[24122,55782],[-8,7],[-18,-21],[-28,38],[-12,-18],[-49,5]],[[26969,65165],[26,7],[17,35],[51,60],[12,-11]],[[27075,65256],[-1,-180],[26,-1],[0,-88]],[[26970,64997],[-1,168]],[[26820,58472],[9,27],[12,-18],[27,55],[13,6],[42,75],[29,18]],[[26989,58502],[-5,-23],[8,-83],[-7,-25],[11,-37],[23,-37]],[[26992,58227],[-19,38],[-10,-41],[-13,11],[-11,-29],[-46,-17],[-15,28],[-20,-42]],[[24600,58809],[129,-4],[3,36]],[[20952,56614],[29,0],[0,-306],[34,0],[0,-190],[58,1],[0,-101]],[[21103,65835],[-181,-2]],[[24091,56692],[51,-6],[25,-33],[9,-47],[10,-18]],[[24031,56297],[3,53],[-8,50],[5,5],[-12,41],[-4,56],[16,-3],[2,201]],[[27082,58800],[12,46],[8,-27],[18,-17]],[[27243,58576],[-19,-105],[-21,-81],[-8,-46]],[[27115,58352],[-13,168],[-32,102],[17,42],[5,47],[-10,89]],[[27071,58743],[11,57]],[[26738,54013],[-8,61]],[[26887,48823],[109,-4],[-1,-204],[55,-3]],[[26961,48307],[-19,133],[-9,94],[-19,140],[-27,149]],[[26909,56467],[-11,28],[-12,5]],[[26886,56500],[-3,8],[-34,-23]],[[26849,56485],[-24,14],[-22,37],[-9,33]],[[26655,53063],[50,-5]],[[26749,52588],[-38,10]],[[26688,52604],[-2,25],[-21,35],[-13,74],[8,15],[2,61],[7,-3],[20,31],[-5,49],[-19,24],[3,51],[-13,97]],[[26385,54844],[-13,0],[-4,-23],[-17,-2],[-5,-20],[-15,14]],[[26315,54794],[8,53],[-8,23]],[[26315,54870],[1,286],[-3,17]],[[28109,56983],[15,-53],[11,4]],[[26514,57005],[38,102]],[[26602,57104],[14,-83]],[[26616,57021],[-11,-37],[-4,-40],[5,-52],[8,-30]],[[26614,56862],[-55,-195]],[[26491,56714],[9,32],[12,0],[11,51],[4,53],[-6,57]],[[24418,63736],[165,-9]],[[24437,63439],[-16,106],[-6,165],[3,26]],[[26551,54736],[14,-26],[0,58],[14,10],[0,34],[8,-3],[0,120],[5,66]],[[26592,54995],[0,1]],[[26621,54963],[11,-13],[6,-77],[-3,-17],[8,-85],[8,-16],[-2,-38]],[[23566,53095],[29,-30]],[[23571,52475],[-32,565],[27,55]],[[23856,69095],[23,10],[16,-32],[14,7]],[[23909,69080],[4,-86],[-1,-101],[12,0],[-1,-101]],[[24989,55687],[38,0],[0,-206]],[[26847,62535],[-6,-257]],[[27689,66145],[33,53],[53,111],[29,91],[30,50],[26,25],[4,19]],[[27864,66494],[8,0],[13,-37]],[[27885,65830],[-154,0]],[[28287,61603],[24,-69]],[[28311,61534],[5,-34],[18,6]],[[28334,61506],[8,-31],[14,-13]],[[24526,59805],[-3,-379]],[[29232,64030],[25,4],[24,-44],[14,-9],[4,44],[4,-90],[-3,-107],[-14,-182],[0,-26]],[[26885,62163],[21,-5]],[[26924,61653],[-12,-9],[-12,22]],[[26880,61763],[-16,61],[-25,15]],[[25382,71549],[40,-3],[15,-30],[8,8],[17,-35],[8,-39],[15,11],[22,-63],[3,-61],[17,-49],[6,-47],[14,-49],[19,-15],[-2,-79],[11,-28],[26,-15],[39,8]],[[25640,70672],[-34,0],[-1,-202],[-35,0]],[[26950,53512],[20,15],[12,44],[0,29],[9,0],[12,44]],[[27054,53461],[6,-54],[8,-22],[-4,-36],[-30,-8],[-9,-21],[0,-30],[-13,-22],[-25,19]],[[5394,42585],[1,40],[11,38],[4,49],[33,72],[8,26],[23,-18],[3,25],[16,-11],[8,14],[15,-20],[10,-37],[5,-45],[0,-46],[-11,-63],[1,-106],[-4,-28],[-28,-78],[-8,15],[-36,12],[-18,71],[-24,29],[-9,61]],[[5266,42374],[4,43],[12,44],[19,45],[2,38],[11,9],[2,-31],[-5,-57],[2,-36],[-20,-28],[-16,-97],[-12,30],[1,40]],[[28154,64919],[16,-73]],[[26648,53718],[3,118],[10,15],[0,57]],[[23627,70810],[4,14],[-1,398],[-4,0],[1,203],[158,-3]],[[23775,70669],[-157,1],[3,27],[-9,37],[15,76]],[[20301,69532],[-136,0],[0,202],[11,-2],[0,374],[-51,13],[0,121],[10,0],[0,51],[-17,0],[0,45]],[[27378,47594],[0,-86]],[[27378,47508],[-108,-8],[-1,308],[-82,-5]],[[26932,56099],[-26,170],[-6,50],[5,53],[-8,-17],[-11,145]],[[27207,53840],[-20,-143],[-27,-44]],[[27074,53945],[16,113],[9,37],[1,58],[15,54]],[[22904,50772],[30,-49],[11,-120],[14,-29],[8,-49],[-2,-40],[21,-122]],[[26507,62635],[4,0]],[[26511,62635],[-17,-563]],[[26444,62138],[0,55]],[[26420,62364],[5,178],[7,34],[-13,23],[17,55]],[[23008,70412],[-4,-128],[-14,-46],[-12,-63],[-22,-39],[-25,-62],[-5,-46],[7,-23]],[[22824,69669],[-1,304]],[[27378,61765],[26,59],[10,-37],[9,12],[19,-12]],[[31257,38463],[-3,-46],[13,-66]],[[31237,38351],[-8,79]],[[31229,38430],[0,22],[-13,40]],[[31216,38492],[23,-4],[18,-25]],[[31271,38188],[2,-76]],[[31257,38463],[15,-6]],[[31272,38457],[1,-138]],[[31275,38321],[19,-28]],[[31294,38293],[-1,-23]],[[31293,38093],[-3,-1]],[[31593,38341],[23,-25]],[[31616,38316],[-5,-39],[-13,-48],[-6,10]],[[31329,37867],[-17,24]],[[30181,67138],[-12,2],[-4,-52],[-16,12],[-39,-10],[13,65],[-61,160]],[[30062,67315],[3,12]],[[24721,61224],[24,60],[10,-7],[12,46]],[[24779,61277],[22,-30],[11,-54],[8,0],[17,-60],[16,7],[3,-27],[-12,-24],[10,-60]],[[24806,60792],[-12,33],[-13,-35],[-72,244],[38,119],[-26,71]],[[28311,61822],[12,41],[19,-32],[13,-50],[20,-19]],[[28375,61762],[-7,-65],[4,-67],[7,-49]],[[28334,61506],[-5,39],[-10,9],[-8,-20]],[[21206,71628],[141,1],[0,34],[106,0]],[[25976,58019],[11,-77]],[[25987,57942],[3,-3],[-1,-270]],[[25989,57669],[-124,3]],[[25865,57672],[-2,0]],[[25863,57672],[0,158]],[[25863,57830],[4,126],[13,71],[-1,44]],[[21429,73451],[0,203],[22,0],[0,101],[37,0]],[[25987,57942],[14,22],[23,-31],[13,28],[-5,58],[15,19],[27,16]],[[26122,57854],[-1,-31],[8,-39],[-7,-55],[-24,-66]],[[26061,57664],[-72,5]],[[23909,69080],[22,23],[11,33],[9,57]],[[26169,63860],[1,-268]],[[23785,71686],[0,213],[-10,25],[11,82],[-32,16],[-7,-24],[-36,87],[4,42],[-15,69],[-10,15],[-59,-76],[-24,34]],[[26699,68754],[-4,-199],[-12,-15],[-14,-64],[-24,2],[-11,-55],[-4,-74]],[[22629,61783],[1,-406]],[[22630,61377],[-61,0],[0,-17],[-21,-1],[0,17],[-72,0]],[[22474,61478],[0,304]],[[23507,62572],[3,-24],[14,-11],[9,16],[5,-31],[17,2]],[[23553,62390],[-54,-1],[-19,18],[-11,-78]],[[21992,49763],[27,1]],[[22203,48678],[-12,8],[1,37],[-12,11],[9,30],[5,86],[-3,31],[4,60],[-13,10],[5,76],[-12,58],[-7,-14],[-7,46],[-9,-18],[-9,39],[-10,-6],[-18,90],[-9,11],[-3,38],[-8,-9],[-10,38],[0,50],[-7,26],[3,41],[-13,48],[2,47],[-17,16],[-7,81],[-10,23],[-8,70],[-22,28],[-14,33]],[[23141,51398],[8,-15],[5,-56],[-4,-33],[9,-12],[-10,-33],[24,-72],[7,-45],[0,-46],[15,-21],[5,-57],[8,-4]],[[23079,50655],[-92,331]],[[22987,50986],[81,185],[12,126],[37,139]],[[26558,55564],[2,-56]],[[26539,55178],[-65,1]],[[26710,56341],[-8,-42],[7,-58]],[[26508,54807],[66,189],[18,-1]],[[26213,54179],[5,-17],[25,-1],[0,-29],[13,-30]],[[26256,54102],[-1,-172],[-13,2]],[[26242,53932],[-33,-8],[-14,10]],[[27145,63680],[-131,17]],[[26256,54102],[70,-5]],[[26342,54097],[-1,-172],[9,-13],[9,-98],[-3,-65]],[[26281,53748],[-35,-2],[-5,110],[1,76]],[[31558,38031],[-14,2]],[[27129,61967],[7,3],[14,-66]],[[27089,61554],[-22,-69],[-15,27],[1,98]],[[27051,61727],[-3,155],[30,57],[51,28]],[[27201,60931],[16,-8],[38,-217],[3,-52],[25,-49]],[[29192,64904],[-37,-137]],[[29155,64767],[-39,-142],[-3,-50],[-16,-26],[-6,26],[-11,-12]],[[25555,55358],[29,3],[2,103],[8,45],[23,-3],[0,77],[13,42],[14,-13],[11,30]],[[25243,57060],[60,-2]],[[25346,56892],[-9,-273]],[[25337,56619],[-94,3]],[[24420,63792],[-2,-56]],[[24293,63444],[1,358]],[[29760,67693],[34,-17],[39,-48],[37,-18]],[[29870,67610],[-21,-107],[-12,5],[1,-73],[-11,-65],[7,-78],[15,-78]],[[29849,67214],[-8,-69]],[[29841,67145],[-39,3],[6,59],[-61,-29],[1,-29],[-16,4],[-6,30]],[[22192,73247],[-98,0],[-1,-407],[10,0],[0,-203]],[[22103,72637],[-71,0]],[[22032,72637],[-36,1]],[[29319,64429],[35,7]],[[29354,64436],[5,-2]],[[29364,64189],[-23,-14],[-30,-40],[2,30]],[[27830,59130],[-76,7]],[[24868,71378],[27,62],[33,17],[15,-17],[29,27],[22,-3],[52,75],[30,94],[43,15],[15,41]],[[24661,52120],[-3,-64]],[[24529,51935],[0,53],[9,61],[15,187]],[[27188,49123],[117,-4]],[[26643,63514],[4,118]],[[26730,63628],[-2,-69],[-12,0],[2,-91],[6,-44],[-7,-18],[2,-122]],[[26717,63148],[-112,25]],[[27381,49327],[100,0],[5,38],[13,7]],[[27499,49372],[17,-141],[18,-212]],[[23602,58132],[-1,49]],[[23598,57605],[4,527]],[[25526,64679],[0,-319]],[[26325,54461],[3,0]],[[27075,65256],[25,-27],[19,15],[20,-9],[29,61],[29,86],[11,20]],[[27208,65402],[1,-72],[27,0]],[[26639,55860],[-2,-47],[-2,-259]],[[17307,67787],[17,-15],[3,-37],[12,-38],[27,-29],[10,-60],[0,-56],[29,-91],[15,-35],[12,-75],[19,-18]],[[17451,67333],[24,4],[13,-73],[-2,-44],[14,-37],[10,-49],[9,-8]],[[17861,65826],[-77,0],[-293,0],[-181,4]],[[17307,65831],[0,1956]],[[15891,60553],[18,-8]],[[15909,60545],[27,10],[6,-16],[16,34],[111,-1]],[[16038,59893],[0,23],[-18,16],[-31,136],[-29,64],[-8,1],[-28,45],[-11,54],[-16,38],[-18,73]],[[15879,60343],[-11,38],[5,9],[-8,40],[4,83],[7,25],[15,15]],[[24006,53430],[10,0],[21,84],[16,26],[26,89]],[[24256,53416],[-11,-34],[-11,-3],[-8,36],[-11,-15],[0,-239],[7,-179],[-20,3]],[[24113,52905],[-63,-7]],[[25337,56619],[-1,-33]],[[25325,56221],[-21,1],[-2,-31],[-21,-53],[-21,-9],[-9,-18]],[[25251,56111],[5,35],[-62,0],[0,153]],[[28939,63476],[20,40],[-17,50],[12,45],[13,-10],[18,-44],[27,106]],[[28999,63493],[-19,-38],[-3,-82]],[[28977,63373],[-20,-27]],[[30021,67006],[1,37],[40,272]],[[30213,67064],[-30,-174],[-2,-44]],[[30062,66695],[-4,15],[-25,20],[-10,59],[-11,2],[-7,123],[19,9],[-3,83]],[[29385,66743],[5,41],[-6,109],[12,33]],[[29396,66926],[52,4],[5,16],[14,-17],[30,0]],[[27357,58148],[-9,-24],[18,-23],[-17,-23],[-9,-82],[2,-133],[-9,-7]],[[24765,59920],[10,16],[10,67],[10,16],[1,40],[10,-1]],[[24874,60157],[28,0]],[[24796,59580],[2,77],[-18,88],[2,37],[-5,45],[-12,43],[0,50]],[[21475,65841],[0,-310],[23,0]],[[21498,65126],[-20,1],[0,-202]],[[21324,64925],[0,202],[-8,0],[0,51]],[[21316,65178],[0,354],[-8,0],[-3,68],[0,237]],[[27924,65829],[1,-183],[-9,-13],[-2,-240]],[[23424,60010],[-94,0]],[[23298,60010],[2,294],[-1,153]],[[23442,59440],[2,187]],[[23441,59035],[1,102],[0,303]],[[25805,65551],[83,0]],[[25805,65171],[0,101],[6,-1],[5,60],[0,92],[-11,1],[0,127]],[[28636,58782],[13,3],[13,30],[26,24],[32,-1],[14,-41],[0,-43],[-14,-78],[3,-55],[2,-164]],[[22825,49041],[-21,-174],[-14,-174]],[[22782,48693],[4,87],[16,180],[10,80]],[[22796,49023],[-13,-158],[1,-15],[-12,-106],[-20,-27],[-7,-27],[-11,18],[14,21],[3,59],[-8,3],[-6,-31],[-20,-58],[-8,-4]],[[22592,48674],[0,436],[32,0]],[[27494,59671],[-1,-41],[-16,-34],[-20,20],[-7,-50],[3,-70]],[[27390,59497],[-22,106]],[[27363,59628],[-30,157]],[[27333,59785],[53,50],[31,35]],[[17253,68510],[14,-50],[19,25],[16,-59],[20,12],[2,-53],[18,-17],[1,-31]],[[17320,68019],[-11,-24],[-2,-59],[0,-149]],[[28546,62046],[18,22],[0,-48],[26,-15]],[[28590,62005],[-1,-41],[6,-73],[-2,-89],[7,-65],[22,-80],[8,-62],[-9,-45],[-15,2]],[[28550,61756],[-1,42]],[[28549,61798],[1,95],[-8,109],[4,44]],[[23463,51482],[-10,31],[-11,-48],[-2,-35],[9,-32],[-10,-54]],[[23439,51344],[-13,4],[-7,-31]],[[23419,51317],[0,0]],[[23419,51317],[-4,-25],[-17,-15],[-14,68]],[[23326,51373],[-49,94],[-63,149]],[[23214,51616],[-38,436],[14,-41],[10,-7],[13,-47],[7,10]],[[28629,59998],[-11,-23],[-10,68],[-29,61],[-14,45],[2,56]],[[8549,88444],[-200,0],[0,34],[-17,0],[0,33],[-33,0],[-20,-18]],[[8279,88493],[-51,29],[-43,-64],[-11,-49],[-19,-14],[-12,-70],[0,-70],[-18,-31],[-25,19],[-36,7],[-74,-17],[-26,43],[-28,16],[-14,-52],[-73,-69]],[[7849,88171],[0,71],[-100,0],[0,202],[-223,0],[-241,0]],[[23800,55915],[-9,40],[-5,-21],[-8,78],[-7,14],[0,38]],[[24915,57163],[-133,1]],[[29238,64193],[0,44],[12,16]],[[29275,64272],[5,-67],[-9,-39],[-38,-78],[-11,-1]],[[22032,72637],[0,-202],[10,0],[0,-403]],[[22042,72032],[-23,0]],[[22019,72032],[-156,0]],[[29077,65850],[92,178]],[[29314,65922],[-2,-84],[-7,-112],[6,-43],[-3,-119],[3,-18],[-3,-193]],[[27495,58547],[-3,30],[-11,7],[-34,83],[-21,8]],[[22052,57171],[19,19],[23,-82]],[[21759,68355],[-33,0],[0,203],[3,0],[0,404],[5,0],[0,67]],[[23789,63810],[110,3]],[[23900,63541],[0,-76]],[[16478,62531],[0,-61]],[[29571,65876],[-6,-84],[40,7],[-8,-88],[-7,-2],[-4,-48],[2,-56],[-19,-9],[9,-185]],[[29429,65443],[9,446]],[[26032,53253],[63,6],[-1,-236]],[[26094,53023],[-3,-1]],[[26091,53022],[-149,-4]],[[25899,53019],[-1,231]],[[26114,53393],[66,-9],[25,1]],[[26229,53027],[-135,-4]],[[27176,59589],[20,45],[-3,29],[29,18],[15,27],[34,27]],[[27271,59735],[22,-6],[27,11],[1,24],[12,21]],[[21170,62382],[2,106],[0,509]],[[23127,65675],[-7,46],[6,11],[3,66],[-16,6],[1,30],[-15,11],[5,16],[-15,25]],[[23846,52873],[1,-51],[-9,-33],[-9,-63],[-3,-73],[-12,-25],[-2,-68],[-14,-30],[-3,-40],[7,-24],[5,-91],[-12,-45]],[[26788,56162],[13,46]],[[26801,56208],[20,-131],[3,25],[15,16],[20,-52],[14,10],[3,-24]],[[26876,56052],[-7,-14],[-4,-55],[-8,-34],[-18,12],[-15,-64],[5,-27]],[[22051,57387],[0,331]],[[23059,54573],[19,-30],[8,-55],[14,-7],[10,-50],[12,9],[-6,-39],[3,-26],[15,2],[2,-99],[11,12],[3,-85]],[[23150,54205],[-123,-252]],[[26931,54154],[12,290],[1,87],[8,71]],[[27001,54561],[5,-104],[9,-73],[-3,-38],[-9,-257]],[[24659,61264],[8,-8],[-1,-63],[8,-14],[47,45]],[[20815,59101],[119,-1]],[[19247,69523],[-46,0],[0,206],[3,0],[0,373],[-1,135],[-20,0],[0,406],[3,59]],[[26085,60656],[20,153],[13,52]],[[26118,60861],[8,-33],[0,-34],[9,-25],[23,-24],[64,0]],[[25909,58793],[3,-46],[-8,-35],[-5,-141],[-5,-69]],[[25883,58418],[-27,38],[-20,-48],[-3,34],[-19,6],[-6,36],[-34,15],[-1,-18]],[[25773,58481],[-13,28]],[[15809,73109],[7,53]],[[15811,72557],[1,34],[15,46],[9,119],[22,25],[-1,69],[-14,23],[-23,86],[1,74],[-10,48]],[[15811,73081],[-2,28]],[[26368,62449],[-13,5],[-20,-29]],[[26335,62425],[-15,28],[-15,54],[-7,2],[-18,-48]],[[26280,62461],[0,233]],[[22730,56399],[22,21]],[[25266,64221],[-32,-1],[-3,165],[-96,-5]],[[23921,57418],[-30,-1],[0,-33]],[[26269,55206],[0,-5],[-91,2]],[[26911,49121],[140,1]],[[26887,48823],[-14,56],[-4,58],[-10,61],[10,-19],[1,-30],[15,30],[10,72],[12,28],[4,42]],[[28830,61117],[6,-4],[6,55]],[[28842,61168],[107,38]],[[28949,61206],[-16,-79],[-15,-98],[-8,-27],[-5,21],[-15,-7],[-19,-78],[-12,-70],[-11,-126],[1,-64],[-20,-105],[-1,-23]],[[28755,60650],[3,59],[16,79],[18,110],[-4,34],[21,17],[15,65],[1,28],[-20,21],[25,54]],[[28738,60998],[7,-15],[-7,-27],[0,42]],[[28739,61120],[-11,-44],[-3,44]],[[28725,61120],[14,0]],[[26674,55236],[50,-366]],[[28682,62165],[-1,90],[-8,17],[-17,-47],[-12,4],[1,-48],[-12,-17],[4,104],[16,101],[7,-51],[21,-11],[11,31],[-6,54],[7,56]],[[24585,64247],[-33,-5],[-45,3]],[[24507,64245],[18,41],[2,27]],[[23353,59440],[89,0]],[[23321,58934],[0,202],[2,1],[0,303],[30,0]],[[29360,64523],[0,-37],[-13,2],[7,-52]],[[26644,64455],[5,0],[0,-136],[16,1],[5,-18]],[[26542,64253],[0,204]],[[22784,65128],[23,5],[9,-19]],[[19529,62765],[0,-537],[-2,-216],[0,-255]],[[18656,73371],[31,-39],[23,-6],[0,-52],[55,-1],[0,-51],[36,0],[0,-151],[71,0]],[[16559,62631],[8,-49],[10,-16],[24,-1],[-3,-58],[6,-69]],[[26938,52021],[88,8]],[[27026,52029],[-1,-39],[-22,-88],[-10,-7],[-13,-84],[-31,-39]],[[8470,87637],[-81,0],[1,129]],[[8390,87766],[7,13],[-22,63],[-29,36],[-38,-14],[-51,63],[-24,-1],[-40,42],[-25,68],[-39,66],[-29,28],[18,55],[24,9],[31,124],[23,18],[8,60],[46,27],[30,45],[-1,25]],[[8053,88108],[6,38],[18,-11],[-20,-43],[-4,16]],[[25134,70573],[0,-107],[-32,0],[0,-101]],[[25102,70365],[-36,5],[1,-50],[-35,5],[0,47],[-35,-3],[-172,-2]],[[25009,55890],[12,11],[6,31],[16,26],[22,16],[26,1]],[[22784,63911],[0,-406]],[[26303,56611],[0,-154],[4,0],[0,-164]],[[26257,56263],[-38,36]],[[17639,63651],[93,1],[271,-11],[134,-2]],[[17872,61963],[-253,564]],[[23527,55113],[55,-115],[31,0],[28,39],[4,26],[12,-7],[3,-42],[15,-6],[10,44],[12,-11],[-5,-21],[9,-29],[10,6]],[[23711,54997],[0,-350]],[[26401,55764],[-2,-50],[-11,-61],[-18,1]],[[26064,63254],[-10,0],[0,-102]],[[24311,54157],[12,-21],[18,-95],[14,12],[17,50],[6,53],[14,-1],[0,-101],[6,-1]],[[24326,53336],[-21,36],[-10,-29],[3,-39],[-16,-15],[-5,66],[1,50]],[[26360,62096],[32,17]],[[26376,61806],[-16,290]],[[27271,59735],[-2,33],[-16,126],[-14,61]],[[19649,69323],[104,-1]],[[19753,69322],[94,2]],[[21734,69029],[-24,-62],[-36,-7],[-4,-27],[-22,-31],[-15,-66],[-35,-10],[-10,15],[-23,-21],[-17,-46],[-38,6],[-16,-26]],[[30177,65078],[18,0],[19,90],[27,60],[11,-15],[7,-70],[15,-27],[10,40],[-1,-84],[-41,1],[-31,-9],[-18,-47],[-16,61]],[[30216,65279],[7,-15]],[[30223,65264],[-18,-31],[-16,-47],[-21,-28],[-23,-15],[6,26],[35,34],[30,76]],[[26614,56862],[17,-50],[22,11],[22,-75]],[[25596,64921],[0,-357],[2,0],[0,-204]],[[23208,56333],[13,24],[8,-21],[3,34]],[[23205,55892],[1,426],[2,15]],[[23627,70810],[-23,64],[-10,-1],[-20,-34],[-25,28],[-8,26]],[[26146,63255],[1,-305]],[[16298,57653],[5,101],[-1,72],[-18,56],[-14,7],[-3,-21],[-27,55],[-11,48],[10,131],[-2,50],[-11,53],[-27,14],[-27,102],[-18,101],[-24,25],[-17,66],[-1,45],[-8,50]],[[22630,61377],[61,0]],[[21825,62494],[-2,-505]],[[26601,62979],[26,-7],[-4,-193]],[[26546,62626],[-35,9]],[[25327,68950],[-1,-110]],[[23602,58132],[-11,-12],[-6,-54],[4,-23],[-21,0],[-11,21],[-6,-28],[-15,-10],[-6,40],[-18,32],[-16,-39]],[[26256,59028],[10,-22],[11,-62],[7,8],[4,-36],[20,-76],[11,-100]],[[26319,58740],[-13,-58],[-15,-39]],[[26291,58643],[-5,0],[-33,-74]],[[26159,58574],[0,1]],[[26154,58599],[1,7]],[[25993,55935],[15,67]],[[26136,56114],[9,-198]],[[26869,66626],[-25,-34],[-7,-32],[9,-27],[2,-45],[-15,4],[-11,-52],[1,-84]],[[26764,66351],[-5,514]],[[26661,66856],[0,-5],[-66,-6],[1,-102]],[[25178,66404],[19,1]],[[21315,72610],[0,-174],[-128,0],[1,-377],[-1,-25]],[[25068,60090],[-3,-48],[14,-52]],[[24979,60303],[-8,40],[9,57]],[[25162,53024],[114,0]],[[25279,52718],[-131,0]],[[29166,64287],[25,77]],[[24925,65750],[-130,-2]],[[24795,65748],[-4,32],[7,61],[-4,28]],[[24794,65869],[-4,50],[2,48],[-13,41],[-31,48]],[[26617,54020],[36,-8]],[[26606,53687],[-19,63],[-22,1],[-1,210]],[[15813,60835],[10,-108],[-2,-27],[27,-23],[27,-80],[8,5],[8,-49]],[[15879,60343],[0,-82],[-25,0],[0,-29],[-21,-4],[7,-93]],[[15840,60135],[-12,12],[-2,31],[-17,60],[-4,62],[5,129],[-12,89],[-2,52],[-12,14],[-6,33],[-1,64],[7,79],[-2,75]],[[27066,54897],[44,49]],[[27110,54946],[11,-9],[8,-41],[23,-70],[40,-66]],[[27074,54503],[4,20],[11,151],[-17,72],[2,42],[-17,29]],[[24794,65869],[-207,1]],[[22445,47502],[-19,-22],[-13,35],[-15,69],[-10,8],[-2,33],[-8,12],[-18,-15],[-21,47],[-12,-3],[-8,20],[-12,-19],[-9,44],[6,50],[-10,56],[-11,13],[-1,41]],[[29155,64767],[0,-51],[15,14],[16,-49],[25,-15],[6,-30],[2,-89]],[[21834,64318],[155,0]],[[22343,55304],[105,-3]],[[26541,65234],[-128,-2]],[[24125,66887],[0,356]],[[31521,37981],[6,-19]],[[31548,37871],[-18,-15],[-12,12]],[[29880,69333],[111,6]],[[29917,68632],[-8,-8],[-5,-52],[-7,-8]],[[29897,68564],[-26,108],[21,64],[-15,60],[19,74],[-19,42],[20,81],[-28,61]],[[25733,57673],[130,-1]],[[25865,57672],[14,-53],[-10,-1],[-15,-83],[6,-49],[-4,-17],[1,-63],[-5,-32],[-1,-119],[9,-39]],[[16666,61797],[48,-140]],[[17564,54910],[-284,-98],[-3,98],[-9,62],[-8,20],[-14,-23],[-3,66],[1,71],[-8,41],[9,61],[-9,161],[-13,127],[-9,54],[-40,193],[-25,62]],[[21114,65834],[0,-302],[-2,-51]],[[21112,65481],[-190,-2]],[[25327,58175],[12,-51],[20,5],[17,39],[11,-29]],[[25387,58139],[6,-48],[-4,-60],[10,-5],[-1,-337]],[[25293,57677],[-5,0]],[[23711,55216],[0,-219]],[[26634,57674],[1,-54],[-15,-9],[0,-30],[-16,-40],[2,-65]],[[26606,57476],[-9,-26]],[[26335,62425],[7,-227],[-5,-90]],[[26337,62108],[-12,-29]],[[26264,62374],[-3,42],[19,45]],[[25875,66319],[142,1]],[[25889,65914],[0,200],[-39,0]],[[25850,66114],[19,134],[6,71]],[[21856,52198],[0,-774]],[[21829,50979],[-23,47],[-2,30],[-17,46],[-18,25],[-13,84],[0,21],[-26,21],[-6,44],[-23,7],[3,57],[-2,65],[-5,5],[-6,-67],[-6,27],[2,53],[-17,27],[-13,108],[-8,-4],[-9,32],[-13,-25],[-7,44],[-8,-27],[-37,-13],[-15,23]],[[26799,55015],[-75,-145]],[[26526,54013],[-11,-52],[-9,-2],[6,-42],[-12,-57],[4,-77]],[[26426,53750],[0,89],[3,108],[7,0],[0,43],[-9,43],[-13,10]],[[27001,54561],[58,-46]],[[30373,68726],[24,-2],[2,26],[-10,25],[9,69],[24,-16],[7,42]],[[30547,68558],[-5,-73],[-7,-22],[-28,21],[-5,-60],[3,-119],[-28,16]],[[23863,67576],[0,-284]],[[24018,54362],[10,-77],[6,-117],[-7,-152],[-11,8],[2,-32],[-8,-56],[-1,-85]],[[31360,38458],[15,-4]],[[31375,38454],[3,-58],[-6,-31]],[[21654,65938],[0,-406]],[[24440,68141],[-4,20],[-33,27]],[[15747,61952],[45,43],[19,115],[7,16],[-6,55]],[[15812,62181],[12,-34],[17,5],[18,-163],[16,-52],[11,-83],[7,-82]],[[23859,69806],[-1,-197]],[[23858,69609],[-2,1]],[[23709,69815],[-26,82],[-2,77]],[[20380,53476],[-23,14],[-35,78],[-11,88],[-10,24],[-6,68],[-13,89],[-9,41],[-19,38],[-11,-19],[-11,41]],[[25658,60081],[31,10]],[[25781,59874],[-12,-8],[-10,-37],[-17,-136],[-3,-91]],[[26853,62581],[32,-7],[-1,-15],[32,-10],[-1,-42],[33,-8],[-3,-120]],[[27221,53045],[-14,-45],[13,-24],[11,24],[1,-81],[-16,-161],[5,-70]],[[27084,53082],[5,55],[21,3],[6,45],[15,38]],[[99917,77451],[12,-2],[12,35],[26,14],[31,-61],[-9,-68],[-24,-42],[-12,-5],[-25,29],[-11,29],[0,71]],[[99678,77049],[5,24],[26,-29],[19,3],[27,-24],[4,-31],[24,-42],[27,-78],[25,-26],[11,-57],[44,-11],[21,-33],[-18,-19],[-9,14],[-29,-16],[-15,41],[-41,72],[-30,101],[-30,43],[-17,-8],[-22,25],[-22,51]],[[99628,77446],[9,11],[20,-16],[11,-33],[-14,-49],[-10,-4],[-16,91]],[[99570,77271],[19,-7],[21,-67],[-22,15],[-18,59]],[[99530,77510],[7,22],[17,-22],[3,-34],[-17,-20],[-10,54]],[[99282,77351],[24,27],[15,50],[39,26],[6,63],[16,96],[11,18],[20,-52],[-12,-32],[-8,-57],[-20,-53],[21,-18],[0,-35],[-13,-10],[-42,17],[-17,-31],[-4,-70],[-11,2],[-25,40],[0,19]],[[98911,77903],[26,-13],[-18,-27],[-8,40]],[[98408,78327],[22,-8],[3,-26],[-24,15],[-1,19]],[[98376,78346],[14,-8],[0,-29],[-14,37]],[[98352,78374],[20,-27],[-12,-2],[-8,29]],[[98210,77943],[6,31],[19,27],[23,-6],[26,67],[41,5],[-17,-40],[-5,-37],[10,-104],[-21,0],[-17,52],[-35,-19],[-30,24]],[[97960,78551],[47,86],[33,11],[100,-20],[29,-63],[24,-15],[35,-94],[2,-18],[-35,-8],[-21,38],[-17,-71],[-9,-13],[-38,15],[-26,-41],[-27,32],[-12,40],[-3,63],[-32,56],[-35,-24],[-15,26]],[[3147,79003],[17,23],[22,53],[25,5],[37,40],[9,27],[28,-21],[14,19],[8,44],[22,-19],[3,72],[24,-11],[-17,106],[20,32],[8,-16],[15,18],[-18,35],[4,39],[17,23],[29,-1],[9,-68],[15,7],[-7,50],[13,31],[-53,47],[-14,-21],[-32,81],[0,46],[31,92],[42,50],[36,32],[6,-15],[23,13],[16,-63],[-16,-42],[7,-35],[17,-18],[14,53],[6,-33],[15,29],[-1,41],[18,63],[15,-58],[11,26],[20,-62],[-8,-56],[-23,-13],[-24,-70],[-40,-70],[2,-39],[34,54],[58,64],[4,22],[22,22],[7,-19],[-5,-72],[-16,-51],[-26,-34],[-6,-23],[-45,-51],[-30,-20],[12,-46],[-16,-1],[-4,-61],[-16,17],[-7,-70],[-20,25],[-4,-76],[-36,-13],[-22,30],[-10,-31],[-12,23],[-21,-37],[-6,11],[-44,-73],[-3,-31],[-23,4],[-16,-23],[-13,-60],[-28,23],[-9,-45],[-49,40],[-15,36]],[[2812,78476],[27,27],[-1,59],[18,0],[10,36],[0,57],[21,33],[5,57],[-10,16],[11,87],[46,106],[16,-26],[27,16],[28,-3],[-9,65],[-12,5],[9,77],[-6,26],[18,76],[40,67],[54,37],[29,-53],[31,1],[2,-23],[-21,-74],[5,-60],[-55,-95],[-65,-72],[-19,-66],[-1,-36],[-28,-81],[-15,-58],[-25,-10],[-28,-71],[-15,-17],[-4,-51],[-15,21],[-27,-49],[-54,-69],[13,45]],[[2752,78371],[29,49],[-1,-45],[-26,-25],[-2,21]],[[2615,78610],[4,50],[19,16],[4,-44],[-9,-45],[-12,-8],[-6,31]],[[2607,82847],[50,-13],[29,5],[10,-14],[-27,-68],[-23,4],[-9,46],[-20,10],[-10,30]],[[2611,78728],[8,-39],[-15,13],[7,26]],[[2547,78457],[17,17],[23,-3],[-2,19],[27,23],[19,-10],[10,-25],[-17,-105],[-30,50],[-25,-29],[-19,14],[-3,49]],[[2517,78521],[8,26],[23,-16],[1,-31],[-14,-31],[-13,16],[-5,36]],[[2497,78313],[4,72],[33,-18],[-7,-57],[-30,3]],[[2431,83489],[9,43],[22,15],[12,-10],[29,22],[-2,-56],[-32,-62],[-5,31],[-33,17]],[[2316,78170],[5,42],[40,72],[31,-27],[1,-27],[-13,-58],[-19,2],[-17,-26],[-15,-48],[-15,21],[2,49]],[[2228,78152],[9,-32],[-16,2],[7,30]],[[2183,78046],[17,42],[16,-37],[-12,-55],[-19,-1],[-2,51]],[[1818,77819],[15,59],[33,49],[12,-2],[27,-39],[-1,-41],[-28,-51],[-32,-27],[-22,-1],[-4,53]],[[1421,77626],[35,0],[33,-31],[9,30],[14,-2],[33,27],[25,-1],[-6,-28],[10,-29],[8,15],[31,-24],[23,16],[10,-11],[32,11],[5,-12],[41,-7],[-25,-23],[-16,6],[-14,-22],[-44,-1],[-22,-35],[-8,16],[-16,-19],[-19,4],[-18,25],[-52,3],[-9,-15],[-29,19],[-10,49],[-11,-1],[-10,40]],[[1064,77503],[55,37],[11,-28],[25,50],[3,-22],[19,38],[5,29],[18,-29],[27,8],[8,34],[6,-24],[35,37],[1,42],[44,10],[-13,41],[43,-5],[13,34],[-1,36],[-32,7],[-23,29],[5,26],[21,-16],[12,36],[-2,39],[38,46],[33,-32],[22,-76],[1,-31],[-21,-85],[-34,8],[-4,-43],[33,-79],[-3,-24],[-15,21],[-17,-10],[-4,-27],[-16,-4],[-20,23],[-19,-95],[-25,31],[-64,-55],[-13,29],[-29,12],[-23,-6],[-13,-35],[-22,-8],[-33,6],[-32,25]],[[1013,77451],[17,17],[7,-29],[-22,-4],[-2,16]],[[1005,77685],[16,-19],[-11,-12],[-5,31]],[[949,77433],[5,9],[40,-3],[1,-26],[-19,3],[-22,-24],[-5,41]],[[890,77452],[11,14],[28,-1],[15,-90],[-16,5],[-17,49],[-21,23]],[[821,77563],[14,45],[26,-9],[23,-80],[-20,-38],[15,-56],[-13,-34],[-18,-2],[-18,22],[3,57],[-7,2],[-8,77],[3,16]],[[811,77269],[5,56],[12,10],[10,-27],[19,10],[-12,22],[34,30],[10,-23],[-2,-55],[-23,0],[13,-52],[-29,29],[2,-40],[-12,12],[-5,-39],[-7,45],[-15,22]],[[601,77040],[11,67],[15,16],[7,36],[-13,66],[4,27],[32,7],[7,59],[-13,69],[10,45],[15,4],[18,-20],[19,59],[9,-14],[3,-74],[-20,-29],[-2,-50],[13,-20],[19,4],[31,26],[30,5],[7,-64],[-7,-88],[-15,-12],[-36,18],[-13,-52],[-18,-12],[-13,-41],[-23,31],[-6,-25],[6,-48],[-11,17],[-13,-26],[-4,55],[-14,29],[-19,-108],[-14,11],[-2,32]],[[469,77371],[13,9],[2,-26],[-14,-17],[-1,34]],[[402,77131],[18,33],[24,-17],[26,34],[50,39],[21,43],[2,128],[12,16],[16,-10],[15,-44],[-26,-98],[5,-86],[-7,-38],[-33,-31],[-36,61],[-27,-33],[-40,-10],[-1,-43],[-10,5],[-9,51]],[[257,77332],[8,29],[29,17],[39,-5],[11,-42],[-2,-30],[19,-32],[15,17],[18,-17],[33,34],[-10,-40],[-41,-32],[-12,-71],[4,-31],[-12,-31],[-8,16],[-9,-44],[8,-57],[-8,-5],[-9,56],[-14,-24],[-16,48],[-13,8],[4,28],[41,25],[-3,64],[-20,1],[-13,34],[-39,66],[0,18]],[[130,77016],[32,-12],[-3,-18],[-27,7],[-2,23]],[[81,76979],[27,-17],[7,-23],[-25,5],[-9,35]],[[77,77233],[14,52],[20,-35],[0,-61],[-19,-10],[-15,54]],[[43,76751],[8,25],[10,-22],[5,-50],[-12,-2],[-10,-32],[-1,81]],[[3,76640],[12,18],[6,-59],[-18,-25],[0,66]],[[7905,86007],[29,90],[15,-17],[-1,-46],[-28,-74],[-15,19],[0,28]],[[7695,85792],[26,-14],[-3,-36],[-23,50]],[[7642,85774],[22,-17],[-7,-33],[-14,14],[-1,36]],[[7602,85813],[20,-2],[-5,-34],[-15,36]],[[8515,86711],[-14,-25],[-34,50],[-29,-40],[-15,52],[-27,-21],[-22,5],[-9,28],[24,74],[-9,14],[-27,-38],[-29,-175],[-30,-42],[-9,18],[14,55],[13,84],[-15,172],[-16,5],[-5,-28],[1,-81],[13,-53],[-10,-4],[-10,-72],[-17,11],[-8,-20],[-5,-68],[-11,-17],[4,-47],[25,-31],[-6,-74],[-27,32],[-12,127],[8,37],[-11,78],[-17,6],[6,-52],[-8,-49],[5,-196],[-5,-64],[-27,74],[-1,43],[-16,28],[-34,31],[3,-40],[24,-36],[-1,-63],[-69,-158],[-32,-91],[0,-36],[-16,-10],[-9,-86],[-12,2],[-3,70],[34,211],[0,29],[-26,-65],[-19,-111],[-12,11],[-9,142],[-13,-52],[-11,2],[16,-62],[-5,-80],[-39,0],[-8,-61],[-18,-24],[-22,-55],[7,-43],[-15,-41],[-16,-10],[0,54],[-16,36],[-13,-45],[-1,-53],[-22,-17],[-24,31],[-9,-23],[-21,38],[-7,43],[-12,-36],[-21,-27],[6,-35],[-20,0],[-5,-39],[-41,-7],[-6,76],[-22,-14],[-21,22],[3,22],[-21,8],[-3,70],[8,36],[16,18],[5,71],[32,31],[9,-11],[29,51],[33,3],[0,45],[33,21],[34,62],[31,-9],[-11,69],[22,26],[3,32],[37,102],[-13,15],[-24,-22],[-60,-109],[-30,-20],[-18,-39],[-39,16],[-43,67],[-15,40],[-5,46],[18,117],[13,45],[15,133],[27,79],[17,33],[35,99],[11,98],[0,71],[23,32],[5,156],[4,27],[-18,44],[-22,163],[39,35],[5,27],[63,27],[89,164],[92,118],[51,-161],[41,-16],[13,-27],[34,112],[30,8],[36,-45],[19,10],[63,-48],[65,-20],[22,-41]],[[7540,87187],[29,79],[8,112],[31,-29],[-28,-64],[-9,-49],[5,-24],[-36,-25]],[[7385,86976],[17,6],[5,-88],[-22,82]],[[7129,86075],[41,28],[18,-43],[-5,-48],[-13,-16],[-29,-3],[-16,59],[4,23]],[[7849,88171],[-14,-15],[-39,-154],[-36,-12],[-19,-31],[-33,2],[-39,-63],[-48,-109],[-1,-29],[26,-124],[-2,-23],[-38,25],[-19,-18],[-30,-52],[-21,-92],[-27,-29],[-32,-74],[-6,-73],[8,-34],[19,-24],[-40,-56],[-9,-67],[-13,-4],[-28,-70],[-19,-7],[-9,28],[-25,-11],[4,-68],[16,-13],[-3,-30],[25,-42],[8,-35],[-12,-73],[-19,-47],[-7,-62],[-25,-21],[-4,-22],[-39,-2],[-15,12],[-40,-31],[-18,3],[-19,-60],[23,16],[15,-20],[15,30],[19,1],[7,-50],[-16,-116],[-19,-16],[-26,-51],[-28,37],[5,-34],[-13,-18],[-18,18],[7,35],[2,75],[-22,71],[3,-119],[-9,-55],[-18,-15],[-13,25],[-6,-35],[16,-28],[-9,-53],[-49,-10],[17,-93],[-8,-32],[-27,-21],[-10,8],[-24,-45],[-12,13],[-36,-37],[5,-26],[20,-18],[-23,-32],[-7,-43],[2,-61],[-12,-44],[-24,-35],[24,-26],[-6,-59],[10,-60],[27,63],[59,-23],[16,22],[12,-22],[15,25],[22,-78],[19,-27],[19,13],[23,-34],[18,-53],[8,-53],[13,-23]],[[27221,52456],[9,-33],[4,-95],[1,-113],[4,-59]],[[27052,52080],[0,100]],[[29960,64853],[11,80],[5,-14],[1,-76],[-17,10]],[[30017,65428],[1,-75],[-12,-11],[8,-53],[0,-72],[-10,-45],[-8,-73],[-12,6],[-27,-18],[-27,-34],[-38,-30],[-1,16]],[[20547,62997],[-53,3],[-67,-4]],[[24065,59426],[2,359]],[[24132,59427],[-67,-1]],[[21075,61776],[0,8],[92,2],[0,101]],[[21287,61485],[-183,-2]],[[22824,47685],[8,-123],[11,-260],[-7,47],[-5,147],[-12,189]],[[22789,47685],[15,-135],[5,-29],[-9,-47],[4,-34],[-1,-62],[8,-72],[20,-11],[1,-35],[12,18],[2,-127],[-23,7],[-13,-8],[0,-19],[-21,-12],[-6,-99],[-20,11],[-7,40],[-15,3],[-6,55],[-11,4],[-18,98],[-31,12],[-11,33],[-19,-4]],[[24065,59426],[-23,0]],[[22581,58122],[-58,-1],[0,162],[-2,41]],[[23857,58571],[-1,-34],[41,-5],[58,-1]],[[26310,52211],[128,4],[3,-34],[47,0]],[[26487,51973],[-22,-26],[-31,29],[-1,-35],[-26,-69],[7,-56]],[[26357,51875],[-13,21],[-10,39],[-12,76],[0,63],[-8,73],[-11,24],[7,40]],[[26452,70053],[21,-76],[3,-57],[17,-27],[33,4],[8,-9],[29,-77],[23,-7],[34,-71],[29,6],[21,-78],[11,-25],[-9,-27],[7,-45]],[[26440,69554],[-1,97],[-1,401],[14,1]],[[25321,65510],[65,5],[0,-50]],[[31642,38028],[49,54],[35,-32],[-18,-26],[-21,-7],[-11,-24],[-8,12],[-17,-17],[-9,40]],[[17074,62424],[25,23]],[[25147,68037],[135,-3],[0,53]],[[25349,68033],[0,-406]],[[25349,67627],[-66,1]],[[24507,64245],[-18,1],[-31,-43],[-13,-69],[11,-35],[-4,-90],[2,-50],[-12,-16]],[[29250,67427],[77,31],[7,-79],[9,-29],[-2,-65],[9,1],[9,-32],[9,52],[26,43],[14,2]],[[29408,67351],[-2,-44],[6,-69],[-3,-87],[4,-18],[-1,-73],[-16,-134]],[[29268,66975],[-12,315]],[[24221,52850],[110,-1]],[[24348,52441],[21,-120],[-37,0],[-16,27],[-19,-26],[-11,14],[-3,-45]],[[23140,57310],[58,0],[0,-101],[59,1]],[[23168,56701],[-116,0]],[[27022,62986],[31,-6]],[[27053,62980],[-3,-106],[59,-11]],[[26991,62576],[2,104],[-10,2],[2,104]],[[25699,53993],[-86,-3],[-8,4],[-72,-3]],[[27624,63483],[1,30],[11,-16],[21,43],[0,36],[11,33],[-11,41]],[[27657,63650],[37,2],[17,-17],[13,-36],[12,-1],[4,27],[27,45],[36,-81],[3,-35],[14,-4]],[[27689,63178],[-43,0]],[[25683,56353],[12,18],[-1,42],[11,9],[18,47],[8,-6],[25,101],[-1,49],[10,4]],[[25765,56617],[0,0]],[[25765,56617],[4,26],[15,14],[23,155],[18,8]],[[24792,52135],[1,-52]],[[26319,58740],[21,42],[14,7],[3,21],[27,20],[29,73]],[[26433,58742],[2,-16]],[[26346,58432],[-10,1]],[[26307,58559],[-9,1],[5,29],[-14,41],[2,13]],[[31540,38235],[6,-27]],[[21912,70421],[172,-2]],[[22129,70418],[1,-404]],[[31286,37841],[-2,-1]],[[24519,52238],[-47,-1],[-3,25],[-21,76],[-10,52],[-15,51]],[[25690,62890],[-21,0],[0,153]],[[18822,67018],[-132,3]],[[24707,71654],[8,83],[12,4],[-5,-75],[-15,-12]],[[24691,71507],[21,33],[-14,-47],[-7,14]],[[24655,71564],[5,21],[30,29],[5,-13],[-11,-48],[-24,-11],[-5,22]],[[24625,71464],[3,27],[20,41],[1,-19],[-24,-49]],[[24631,71609],[14,-54],[-13,-3],[-8,37],[7,20]],[[24621,71679],[35,36],[11,-55],[14,34],[2,-44],[-16,-9],[-17,-49],[-11,42],[-16,20],[-2,25]],[[24616,71401],[17,18],[32,86],[14,-32],[-30,-33],[5,-35],[-17,-4],[-20,-37],[-1,37]],[[24579,71168],[37,46],[11,25],[5,54],[11,-33],[41,-93]],[[27886,62061],[17,103],[35,-101]],[[27972,61415],[-41,116],[-5,-3],[-87,203]],[[20348,73978],[294,0]],[[20642,73978],[0,-103],[5,0],[0,-303],[18,0],[0,-101]],[[31229,38430],[-12,-28],[-9,-55]],[[31200,38377],[-2,73],[7,32],[11,10]],[[31513,38417],[13,9]],[[31290,38461],[20,-4]],[[31294,38293],[4,50],[-4,30],[-4,88]],[[23139,52124],[2,4],[79,20]],[[23214,51616],[-41,-70],[-17,-1]],[[31580,37974],[-9,-19],[-6,-48]],[[26305,70240],[4,-25],[45,-75],[26,-58],[13,20],[11,-16],[13,10],[35,-43]],[[19321,69518],[0,-193]],[[23965,52355],[0,203],[42,1],[0,325]],[[25140,54451],[-114,-1]],[[24456,51930],[-6,51],[-21,0],[-3,148],[-24,15],[-17,79],[-5,154],[-17,64]],[[24765,59920],[-26,5],[-91,0]],[[28536,67395],[7,1],[23,87]],[[28661,66729],[3,-172]],[[26689,57352],[-22,36],[-13,-27],[-20,30],[-10,82],[-18,3]],[[26063,52829],[1,33],[19,134],[8,26]],[[31467,38261],[2,85]],[[25642,56884],[0,-17]],[[26202,61218],[-8,-48],[-11,2],[0,-30]],[[26183,61142],[-64,-37],[-25,59]],[[26094,61164],[-8,24],[13,99],[12,25]],[[15682,71846],[13,14],[11,-66],[22,-22]],[[22851,68791],[68,1]],[[22919,68792],[120,0]],[[22659,49740],[2,7],[-78,559],[24,31]],[[28423,61914],[-1,45],[13,37]],[[28435,61996],[11,-104],[7,35],[15,17],[29,-3],[32,-47],[2,-69],[18,-27]],[[28501,61588],[-6,-27],[10,-68],[-2,-22],[-22,43],[-2,34],[-13,31],[-12,114],[-20,-44],[-33,-56],[-12,27],[-7,115],[11,82],[15,57],[20,30],[-5,10]],[[28511,65354],[165,-57]],[[23494,55334],[-20,50],[-12,56],[-22,3],[-22,-45],[-9,-4]],[[25805,58095],[10,8],[4,-27],[15,-23],[3,33],[11,1],[32,75]],[[25863,57830],[-14,2],[0,50],[-7,74],[-19,67],[-18,22],[0,50]],[[23001,56396],[-2,57],[6,24],[-14,52],[12,-3],[10,67],[-11,58]],[[23208,56333],[-25,54],[-1,-30],[-30,-29],[-15,13],[1,-20],[-14,8],[-8,-90],[-14,-14],[-19,19],[-7,-81],[-12,-3],[-4,39]],[[23060,56199],[-14,62],[-21,-6],[-8,57],[-11,-4],[-16,30],[11,58]],[[26310,52211],[-1,39],[20,64]],[[25251,56111],[3,-43],[8,-11],[-6,-28],[4,-66],[-12,33],[-5,-29],[-16,-22],[-20,-2]],[[25110,56009],[0,85],[-4,-2],[0,123]],[[23432,63654],[3,-25],[-8,-45],[14,-27],[6,-121],[-1,-52]],[[28051,67098],[0,-257]],[[27864,66494],[7,51],[13,36],[4,52],[36,56],[19,54],[-4,80],[-13,40],[2,43],[-7,37],[-23,35],[2,72],[-4,22]],[[26992,61441],[-6,-98],[7,-43],[19,-72],[-31,-119]],[[20545,71862],[22,0],[0,-237],[36,0],[0,-68],[36,0],[11,-33],[0,-34],[118,-1]],[[25506,53023],[121,2]],[[25695,52293],[-65,-49],[-32,-15],[-7,10],[-63,-51]],[[26885,54787],[1,-51],[-11,-10],[-3,-50],[-15,-103],[8,-23]],[[23994,66887],[131,0]],[[16006,69623],[60,0],[0,305],[11,0],[0,207]],[[16224,70069],[5,-65],[-3,-31],[8,-37],[15,-15],[-9,-62],[-3,-56],[-9,-58],[-10,-18],[-6,-44],[-6,15],[-12,-36],[0,-81],[10,-27],[32,0],[28,-42],[13,-36],[0,-56],[61,0]],[[16341,69402],[5,-102],[-3,-34],[14,-66],[-5,-33],[23,-52]],[[22752,66341],[0,480]],[[29849,67214],[27,22],[16,-107],[52,43],[8,-114],[34,17],[22,-59],[13,-10]],[[30059,66688],[-10,-46],[-169,17]],[[29872,66660],[-5,89],[-8,1],[-9,179],[-15,2],[1,86],[5,128]],[[27110,54946],[-8,28],[29,275]],[[28845,61499],[2,-35],[17,-81],[-9,-41],[10,-63],[-11,-25],[-10,5],[-11,-50],[9,-41]],[[28830,61117],[-13,30],[-19,-4],[-22,-64],[-9,-1],[-1,67],[7,70],[17,28],[-17,2],[2,45],[11,40],[-21,9],[-12,-33],[-4,28],[5,58],[26,27],[-5,33]],[[28725,61120],[-1,72],[8,28],[11,-40],[-4,-60]],[[28729,61346],[7,-82],[-15,21],[3,30]],[[28921,61701],[81,-1]],[[29002,61700],[-1,-43],[-9,-105],[-5,-15],[-20,-211],[-18,-120]],[[21232,73979],[256,-1]],[[25611,65393],[28,25],[53,76]],[[25692,65494],[0,-552]],[[25692,64942],[-10,-20],[-26,58],[-20,20],[-17,-24],[-7,-28]],[[28766,66751],[2,-78]],[[17451,67333],[-1,196],[11,0],[0,204],[-11,0],[0,201]],[[24938,64636],[-97,1]],[[22042,72032],[154,0]],[[22074,71224],[-46,0]],[[22028,71224],[2,405],[-11,1],[0,402]],[[27111,59928],[16,34]],[[26876,56052],[9,11]],[[26511,61866],[6,-8],[3,-63],[8,-47]],[[4587,90956],[19,44],[21,16],[24,-17],[22,6],[9,-37],[-1,-50],[-75,-13],[-18,19],[-1,32]],[[4612,90593],[44,123],[23,89],[23,39],[-9,58],[14,5],[28,-28],[22,-5],[13,-77],[52,0],[45,20],[26,-20],[77,28],[48,38],[9,51],[56,128],[38,135],[0,71],[-12,81],[-23,95],[-17,121],[-1,118],[-5,52],[-71,157],[-9,32],[-41,28],[-27,1],[10,97],[27,33],[14,-25],[35,-20],[51,7],[-10,45],[31,10],[41,81],[2,114],[-42,122],[-47,68],[-25,48],[-1,-32],[-27,-48],[-20,-86],[-42,-30],[-42,42],[-59,-93],[-81,-34],[-18,-71],[-85,-103],[-21,-70],[-5,-99],[-44,-70],[-4,93],[-15,110],[-23,50],[-28,-3],[4,34],[-32,46],[-9,36],[-38,-60],[16,-45],[21,-7],[16,-39],[24,11],[2,-48],[-22,-81],[-19,-11],[-22,82],[-55,76],[-41,33],[-64,13],[-41,-27],[-27,12],[-52,3],[-45,-22],[-108,-112],[-58,-17],[-111,74],[-94,45],[-47,14],[-88,40],[-49,79],[-20,96],[1,74],[20,36],[-6,64],[-28,63],[-45,56],[-1,59],[-46,64],[-10,56],[39,-33],[33,3],[9,27],[24,15],[16,32],[-3,55],[35,61],[-38,63],[-19,9],[-29,-16],[-39,15],[-64,52],[-104,21],[-49,52],[-38,63],[-55,60],[-46,30],[-17,75],[9,52],[34,50],[123,108],[63,74],[48,74],[45,56],[42,64],[84,105],[55,56],[146,167],[172,154],[133,90],[88,45]],[[2036,90914],[2,37],[25,87],[-3,75],[8,18],[-5,57],[21,3],[8,-42],[-4,-48],[12,-34],[64,-57],[77,-48],[55,-20],[58,87],[58,58],[58,-14],[29,-69],[23,-15],[15,-104],[-2,-38],[53,-56],[56,-14],[22,-32],[9,-35],[36,-20],[88,-20],[14,6],[102,-55],[-27,-131],[-22,-43],[-51,35],[-43,-1],[-50,-29],[-44,-89],[-10,-61],[1,-53],[-20,-46],[-30,22],[3,24],[-26,119],[-32,62],[-50,60],[-39,-5],[-11,69],[-17,55],[-54,80],[-86,69],[-65,11],[-47,-44],[-18,-58],[-36,-34],[-28,33],[-49,36],[-24,83],[-7,56],[3,73]],[[21724,54804],[0,508]],[[22543,49601],[98,-1]],[[25847,64156],[0,153],[-42,0],[0,50],[-16,0]],[[21697,65126],[155,-1]],[[21703,64671],[0,51],[-6,0],[0,404]],[[24920,61430],[30,0]],[[24950,61430],[1,-93],[-1,-215]],[[24950,61122],[-17,-112],[-5,-65]],[[25349,67627],[34,-1]],[[28458,62298],[26,-84],[-36,-118]],[[28448,62096],[-1,56]],[[28528,60859],[19,48]],[[28547,60907],[18,-30],[10,-96],[11,-53],[30,-4],[7,-36],[31,-24],[-15,-40]],[[22406,63911],[0,-406]],[[15909,60545],[-6,37],[-12,19],[-10,87],[-7,109],[-21,54],[-2,46],[-21,25]],[[15829,60925],[9,72],[-4,58]],[[28448,62096],[0,-7]],[[28448,62089],[-15,20],[-12,-5],[-2,32],[9,20]],[[24434,56612],[7,-77]],[[24441,56535],[-12,-11],[0,-34],[-23,1],[-3,-225]],[[28149,57358],[28,13],[6,-19],[86,5]],[[28315,57031],[-18,-47],[-36,-120]],[[25450,66403],[-2,-124],[-8,-97],[10,-109],[11,-65]],[[21869,60563],[0,-101]],[[21869,60462],[-116,0]],[[23981,61061],[-31,2],[-1,-118]],[[23949,60945],[-108,12],[0,17]],[[28179,60037],[10,-41],[22,1]],[[28366,62171],[11,18],[7,-36],[-14,-7],[-4,25]],[[21316,65178],[-204,-2]],[[21112,65176],[0,305]],[[25178,66812],[65,0]],[[25186,63261],[-3,-61],[-15,1],[0,-102]],[[25055,63285],[0,121]],[[24919,61658],[25,66],[21,10],[16,-14],[15,35],[24,14],[56,-9]],[[25075,61422],[-125,8]],[[30589,69408],[139,81],[-7,96],[29,18],[-22,334],[-30,-18],[3,81],[-2,94],[37,26],[2,828]],[[24897,67741],[-10,60],[-12,106],[-27,94],[-6,60],[8,10],[-6,83],[-9,15],[-5,94],[13,39],[2,51],[13,-17],[6,46],[-6,25],[6,42]],[[25252,52115],[30,-13],[-14,-20],[-12,9],[-4,24]],[[25179,52148],[16,13],[30,-29],[6,-15],[-24,5],[-28,26]],[[25284,52292],[-4,-32],[-7,15],[-10,-40],[-18,27],[-13,-15],[-5,30],[-18,7],[-18,-23],[-23,49],[-1,-11]],[[26509,53416],[96,-5]],[[26644,53407],[1,-141],[-8,-32],[-10,-117]],[[26627,53117],[0,-52],[-45,5]],[[27659,63732],[6,-26],[-15,-26],[7,-30]],[[28929,62276],[2,-39],[32,-123],[16,-29],[10,24],[4,-36],[5,-129],[4,-244]],[[23026,62389],[30,0],[1,151]],[[25363,59716],[-104,4]],[[26714,61309],[-2,-54],[13,-29],[8,-39],[16,-8],[32,4]],[[25601,60095],[-7,41],[-14,28],[0,29]],[[16976,71173],[14,-40],[20,23],[39,20],[20,0],[8,38]],[[17042,70488],[-5,0]],[[25131,53986],[-104,-26]],[[25027,53960],[-1,101],[0,389]],[[26220,63171],[0,-220]],[[22247,72637],[209,1],[6,-2]],[[22469,72335],[-214,0]],[[22255,72335],[1,99],[-9,0],[0,203]],[[26502,63717],[-3,-168]],[[22733,54837],[-18,0]],[[22342,55817],[149,-2]],[[23488,53197],[29,-50],[33,-21],[16,-31]],[[18869,65087],[-16,27],[-9,45]],[[16514,71218],[0,-481],[2,0],[0,-202]],[[16055,70538],[0,401]],[[26831,65420],[6,90],[11,-35],[-3,-35],[-14,-42],[0,22]],[[26741,65392],[28,-32],[18,-66],[19,-29],[18,23],[2,50],[7,13],[14,-55],[19,2],[6,-56]],[[26872,65242],[-12,-19],[-22,8],[-37,-31]],[[24711,62301],[-6,-10],[-9,-66],[-11,-32],[-11,-7],[-12,26],[-10,50]],[[23443,53522],[38,117]],[[27522,55654],[5,24],[9,-16],[16,41],[9,168]],[[22919,69095],[0,-303]],[[27062,55974],[-4,15]],[[23405,70206],[0,-202],[2,0],[0,-201]],[[27045,63236],[105,-18]],[[27150,63218],[16,-2],[-1,-103],[16,-2],[0,-89]],[[27053,62980],[6,202],[-15,4],[1,50]],[[15943,70079],[16,51],[15,16],[21,-15],[29,12],[30,24]],[[23949,60945],[-1,-85],[5,0],[-3,-364]],[[23828,60508],[2,169]],[[21436,55306],[37,1]],[[21580,55310],[0,-508]],[[20566,61986],[-178,-4]],[[20388,61982],[8,81],[9,51],[-10,53],[5,23],[-14,12],[3,27],[-18,43],[-23,-3],[1,55],[-17,4],[-6,76]],[[20326,62404],[6,35],[-11,21],[10,38],[-3,84],[0,117],[9,13],[5,68]],[[27292,56114],[28,50],[13,13]],[[27333,56177],[21,-95],[6,21],[1,-40],[15,11],[22,-17],[32,-95],[9,-60],[14,0],[-4,33],[10,46],[-6,14],[16,17],[12,-31],[4,23]],[[27282,55866],[-22,48],[-19,11]],[[20260,62760],[8,22],[13,-32],[19,-5],[22,35]],[[20326,62404],[-108,2]],[[26838,61610],[-26,29],[-17,-6],[-22,83],[-32,45]],[[26693,57318],[-7,-14],[-27,-226]],[[26659,57078],[-21,13],[-22,-70]],[[19753,69322],[2,67],[15,51],[16,135],[7,5],[-163,-4],[-3,10],[0,121],[7,126],[8,30]],[[24514,53430],[2,306]],[[28331,62074],[1,-43],[-20,-3],[14,56]],[[28325,62049],[0,0]],[[26362,58409],[23,-188],[2,-47],[8,-28],[2,-79],[-15,-13],[-11,-39]],[[21659,65532],[157,-3]],[[21697,65126],[-38,1]],[[23316,54348],[9,-60]],[[23151,54197],[-1,8]],[[29472,67872],[4,21],[-8,43]],[[21110,65126],[2,50]],[[21321,64670],[-9,-1]],[[21312,64669],[-203,0]],[[25494,59589],[85,4]],[[25639,59377],[-8,-45],[-8,8],[-28,-81],[-2,-38]],[[22646,54292],[65,140],[4,-5]],[[22715,54427],[13,-31],[1,-31],[14,-19],[1,33],[10,13]],[[25387,58139],[13,3],[-8,33]],[[27256,56797],[-6,-49]],[[27250,56748],[-18,-23],[-9,-55],[13,-58],[-22,8],[-1,-13]],[[25194,57399],[98,-1]],[[23336,66890],[0,-405]],[[22026,60013],[-151,-3]],[[21875,60010],[-1,452],[-5,0]],[[27001,63402],[20,-5],[-3,-103],[28,-5],[-1,-53]],[[22715,54561],[0,-134]],[[27548,46452],[19,155],[7,41],[0,-41],[-8,-83],[-13,-84]],[[27380,46979],[0,203]],[[27380,47182],[54,-1],[0,-25],[103,0],[4,15],[49,6]],[[27590,47177],[0,-156],[-3,-80],[-7,-81],[0,-44],[-6,23],[3,51],[-5,20],[-16,-25],[-10,-102],[-6,-17],[-1,-64],[-8,-40],[-2,-78],[5,-33],[-2,-46],[6,-16],[-8,-53],[-12,-38]],[[27485,46274],[-7,26],[-6,-18],[-34,-22],[-14,-41],[-9,-6],[-18,45],[-13,-11]],[[22342,59034],[89,4]],[[22225,58628],[-2,101],[0,132]],[[22895,56601],[0,-68],[10,0],[0,-68]],[[22905,56465],[-3,-6]],[[27208,65402],[13,48],[44,102],[10,1],[38,65],[31,44]],[[27344,65662],[-1,-163]],[[22987,50986],[-5,19]],[[15812,62181],[-8,46],[5,25],[18,-2]],[[27026,52029],[26,0]],[[27052,51535],[-2,-1]],[[27470,57925],[-61,-200],[-20,-41]],[[25266,63967],[0,-136]],[[15513,69827],[7,103],[22,33],[0,34],[12,0],[6,33],[-12,0],[-11,33],[-12,0],[-17,85],[34,0],[0,82]],[[28543,62588],[22,27]],[[28589,62579],[2,-33],[27,-54],[2,-67],[-5,-25],[13,-48],[-23,-45],[7,-37],[-3,-40],[-9,4],[-7,-55],[6,-53],[-17,-58],[8,-63]],[[28546,62046],[-4,46],[3,83],[6,55],[-6,21],[-2,69],[-15,59],[-24,43],[-1,37]],[[24200,63447],[-16,1],[0,98]],[[24041,63153],[3,393]],[[25208,55688],[101,2]],[[25297,55272],[-129,-4]],[[24826,53417],[-12,-8],[-7,25],[-38,0]],[[22663,60009],[-86,-1]],[[23827,60339],[-119,9]],[[24750,67741],[147,0]],[[24882,67235],[-18,-21],[-26,8],[-24,-40],[-31,4]],[[23831,59921],[-126,10]],[[28228,58692],[-4,-35],[-9,14],[-16,-22],[-72,-116]],[[16575,68516],[-68,0],[0,96],[-34,1],[0,57],[-102,-3],[0,148]],[[26808,61378],[-14,-3],[-10,39],[-11,-31],[-9,50],[-21,49],[-17,-32],[-7,-52]],[[26898,58893],[-3,-80],[15,-20],[15,27]],[[28310,62161],[7,-7],[4,-50],[17,-22]],[[28338,62082],[20,-67],[24,-32],[15,-66]],[[28397,61917],[-7,-3],[0,-52],[-15,-100]],[[29050,63047],[-18,105],[-12,9],[-29,126],[2,30],[-16,56]],[[22255,72032],[0,303]],[[25759,70041],[20,-64],[-8,-22],[-4,36],[-14,43],[6,7]],[[25823,70205],[-16,-12],[-6,-46],[-13,-3],[0,-45],[-12,-9],[4,-61],[-20,32],[-9,40],[12,27],[1,34],[11,31],[1,40],[13,-4],[15,87],[-3,43],[-12,10],[-18,-75],[-38,24],[3,-51],[-13,-47],[-5,-56],[-30,-31],[-5,-27],[-6,39],[3,55],[-4,67],[-8,32],[-10,-19],[-5,-120],[3,-12],[-31,-55],[-26,-129]],[[26360,62096],[-23,12]],[[30583,68114],[-15,-5],[1,-52],[-16,-37],[-5,-50],[-12,51],[-2,-47],[-15,-32],[-12,26],[-3,-66],[-11,53]],[[26486,61309],[32,-215]],[[26508,60985],[-15,-2],[-7,20]],[[26415,61049],[-4,7],[8,78],[0,42],[11,21],[-1,56]],[[27541,58268],[31,1]],[[27572,58269],[6,-34],[15,-18],[4,-67],[12,-35],[-9,-58],[-4,-78],[12,-96],[-6,-34]],[[27546,57910],[-22,-36],[-31,2],[-11,22]],[[25805,58095],[-21,12]],[[25784,58107],[-5,2],[-11,80],[-2,66],[7,226]],[[27950,60654],[7,104],[17,-12],[6,35],[22,28],[-1,55]],[[31439,38340],[14,12]],[[16761,70487],[-11,-36],[-28,-42],[-19,-6],[-17,14],[-49,-25]],[[27290,53687],[-18,-23],[0,-22],[17,10],[6,-24],[-23,-131],[-6,-91],[3,-37]],[[29870,67610],[24,96],[9,-78],[16,28],[9,-5]],[[23619,51345],[-62,-102],[-28,-61],[-10,-54],[-15,7],[22,71],[9,47],[13,-1],[9,19],[8,46],[9,-16],[11,8],[-5,21]],[[23415,50841],[28,72],[3,19],[32,99],[15,23],[0,45],[26,-15],[-20,-61],[-62,-153],[-26,-81]],[[23439,51344],[10,-51],[20,-17],[-6,-54],[11,-20],[2,-78],[-2,-67],[-8,-31],[-9,10],[-29,-102]],[[20922,65124],[0,200]],[[28860,63072],[14,65]],[[28901,63263],[10,-79],[14,-42],[35,-27],[39,-114]],[[28903,62783],[-7,11],[-10,56],[-19,25],[6,140],[-12,29]],[[15363,69375],[8,117],[4,157],[-3,66],[3,109],[-4,69],[5,24],[5,176],[-1,76],[-11,41],[4,25]],[[29408,67351],[-10,210],[6,77],[23,97],[9,22],[9,100],[-3,36],[9,37]],[[23355,73978],[46,0],[0,449],[27,-37],[28,20],[29,-53],[8,-35],[14,-202],[7,-25],[18,-251],[-6,-69],[4,-54],[14,-43],[29,-45],[30,-2]],[[15675,63014],[42,1],[1,-152],[-2,-78]],[[26801,56208],[-10,55],[12,79],[6,10],[13,75],[23,33],[4,25]],[[24019,62414],[8,36],[-11,13],[27,139]],[[28869,64023],[-47,-239]],[[25999,59326],[4,102]],[[31375,38454],[18,-15],[8,20]],[[26535,62069],[16,-25],[3,-34],[15,-26],[5,-50],[17,-15]],[[25722,65552],[30,68],[27,87],[37,261],[34,146]],[[25805,65551],[-83,1]],[[27947,61230],[-10,-22],[-9,-96],[-10,-7],[-18,-68],[-11,10],[-5,31],[-26,-30]],[[24526,56657],[-9,-37],[-13,-18],[0,-44],[17,-84],[-5,-28],[-5,24],[-11,-4],[-5,27],[-35,-25],[9,50],[-20,-20],[-8,37]],[[28814,58772],[18,-19],[12,-74],[1,-47],[-15,9],[2,45],[-18,86]],[[28806,57915],[20,38],[12,2],[16,35],[13,10],[5,74],[11,252],[0,54],[-8,95],[-6,105],[3,-2],[11,-106],[5,-95],[-3,-136],[-15,-286],[-24,-8],[-39,-49]],[[28801,59116],[9,-90],[23,-156],[35,-271],[-9,14],[-18,146],[-14,80],[-13,11],[-9,174],[-10,87]],[[28734,58461],[7,116],[3,150],[14,40],[-6,33],[14,20],[25,-21],[16,-94],[7,-65],[-4,-52],[7,-98],[-8,-25],[4,-54],[-13,-54],[-17,-10],[-9,14]],[[26672,51474],[-12,11],[-10,38],[-13,17],[-13,61],[0,42],[-9,35],[-5,51],[-14,44],[-28,62],[-40,72],[-17,53]],[[26156,57665],[80,3]],[[24799,56705],[50,-1],[7,6]],[[22247,72637],[-144,0]],[[27250,56748],[11,-37],[-3,-28],[10,-51],[28,-9],[10,-25],[10,-53],[13,-25],[11,-81],[1,-60]],[[27341,56379],[-7,-11],[-6,-144],[6,-2],[7,42],[13,-5],[11,-24],[-32,-58]],[[28579,63178],[92,1]],[[28716,62971],[-11,-55],[12,-24],[4,-32],[-12,-14],[-34,-97],[-7,31],[7,54],[-8,28],[0,-44],[-9,-51],[8,-34],[-7,-46],[-9,105],[-12,0]],[[28638,62792],[-8,82],[-14,49],[-27,49],[-9,82],[-1,124]],[[25875,66319],[7,71],[7,133],[-1,58],[6,87],[-1,56]],[[23165,59340],[53,-1]],[[23218,59339],[-1,-303],[15,0]],[[22571,51212],[3,42],[-12,0],[-1,21],[-14,33],[-5,37],[-17,6],[-3,39]],[[29897,68564],[-40,-12],[-14,-20],[-10,-61],[6,-34],[-6,-57],[8,-37]],[[28421,63584],[19,-48],[14,-17],[14,-92],[-5,-48],[8,-43],[-12,-30],[0,-129]],[[28398,63177],[-67,0]],[[28331,63177],[-3,261]],[[15811,73081],[-15,5],[3,-24],[-11,-28],[10,-67],[18,-50],[1,-35],[-26,85],[-12,4],[-7,58],[2,77],[18,24],[17,-21]],[[15707,73080],[13,89],[14,59],[2,55],[16,11],[7,-19],[0,-49],[19,-38],[3,-26],[-15,-19],[-17,15],[-1,-29],[-13,-34],[-14,-7],[3,-24],[23,10],[11,-42],[8,-84],[-4,-14],[10,-100],[8,27],[-5,67],[10,-3],[16,-57],[16,-13],[7,-94],[-8,-58],[-14,13],[-12,86],[-21,-25],[2,30],[-19,44],[3,93],[-5,56],[-18,-4],[-3,30],[-22,54]],[[22522,66858],[14,-9],[24,-44],[6,2]],[[16705,63096],[7,5],[24,79],[0,-100],[-3,0],[-1,-138],[-7,0],[-1,-151],[6,-1],[20,-84],[17,-35],[10,-50],[11,-17],[17,-84],[10,-17],[0,-34],[11,0],[0,-44]],[[26301,60841],[11,21],[3,37],[-6,61]],[[26143,61748],[-18,30],[-16,7]],[[27602,47579],[-4,-103],[-8,-299]],[[27380,47182],[-2,326]],[[21875,60010],[-87,-2]],[[22434,58223],[0,-303],[1,-124]],[[25983,54764],[25,1],[0,102],[23,0],[5,17]],[[28448,62089],[-1,-78],[-12,-15]],[[28423,61914],[-20,-21],[-6,24]],[[25102,70365],[1,-501]],[[16892,69318],[0,99],[-9,0],[1,135],[-31,0],[0,71],[-11,0],[0,102],[23,-6],[0,17],[52,0],[0,86],[64,-2],[0,51],[23,0],[-1,254],[15,-1],[0,99],[5,51],[21,0],[0,51]],[[18821,64174],[11,38]],[[25984,69839],[13,-17],[1,-59],[-14,76]],[[25933,69486],[6,23],[19,-25],[-6,-96],[-17,52],[-2,46]],[[25931,69065],[0,124],[10,36],[13,-18],[16,80],[18,-35],[17,13],[8,32],[9,86],[10,16],[15,94],[11,47],[9,-7],[12,35],[3,-39],[-19,-32],[-3,-42],[12,-81],[-23,-81],[13,19],[0,-74],[-6,-7],[-8,-84],[4,-86]],[[25908,69335],[11,44],[6,-47],[-17,3]],[[28460,61498],[9,-25],[0,-49],[35,-59],[25,-2],[7,-28],[6,21],[24,-9],[4,-44],[16,-39],[7,-49]],[[28476,61264],[-18,37],[-8,-20],[-8,82]],[[26655,53063],[-21,26],[-7,28]],[[25251,71984],[15,63],[20,52],[58,85],[56,25],[50,-7],[23,-39],[1,-45],[-11,5],[-17,-24],[-19,13],[-21,-10],[5,-47],[-32,-57],[-30,-95],[-18,-19]],[[25045,72671],[21,69],[95,141],[7,-2],[43,98],[31,42],[6,-11],[28,29],[-1,-28],[-12,-16],[-30,-80],[0,-30],[-25,-55],[-51,-53],[-42,-66],[2,-20],[23,0],[-59,-73],[-18,3],[-18,52]],[[26883,54537],[2,15],[67,50]],[[21312,64669],[0,-294]],[[27151,63319],[-1,-101]],[[27376,54230],[12,-12],[-5,-64],[-14,-29],[-10,15],[-6,-48],[10,-8],[-16,-60],[-21,23],[-3,-56],[11,-11],[-9,-59],[-17,-54],[-7,4]],[[26217,53628],[-3,120],[-19,87],[0,79]],[[27051,49122],[0,304],[-1,23],[0,285],[-14,0]],[[23058,55817],[2,382]],[[26207,54898],[49,-1],[0,-28],[59,1]],[[24769,65578],[18,31],[-1,41],[9,98]],[[27419,50455],[6,-40],[38,-200],[4,-63],[10,-83],[-18,-57],[-4,-54],[-1,-87],[5,-130],[6,-96],[16,-145],[18,-128]],[[25721,57989],[22,-12],[14,49],[27,37],[0,44]],[[27266,63044],[0,118],[-10,0],[1,189],[21,-2]],[[24750,68340],[0,-494]],[[26325,61179],[9,131]],[[26118,60861],[14,31],[-1,31],[13,11],[3,44],[26,17],[1,61],[13,-1]],[[26187,61055],[8,23],[5,-27],[22,-3]],[[26222,61048],[8,-43],[-7,-204]],[[28368,58929],[3,-20],[28,-47],[7,-45],[-3,-37],[29,-18],[14,19],[6,-61],[-5,-36],[11,-1],[17,46],[13,-45],[-2,-44],[9,-8],[11,44],[-1,34],[21,-21]],[[28501,58520],[-38,-71],[-50,94],[-3,-8]],[[25760,53020],[-4,7],[0,223]],[[16868,55911],[16,-5],[28,-53],[21,-22],[1,-25],[16,-61],[-5,-43],[-13,25],[-26,7],[-6,35],[0,74],[-20,16],[-12,52]],[[16867,55390],[9,4],[22,-117],[40,-130],[-10,4],[-11,-22],[-17,44],[-13,72],[-14,119],[-6,26]],[[17004,56219],[-17,24],[-2,-47],[-21,-23],[-18,14],[-10,25],[-15,6],[-4,38],[9,34],[1,43],[-14,116],[-11,64],[-17,50],[-35,1],[-22,-8],[-16,-36],[-14,38],[-25,13]],[[27214,46977],[-1,16],[-21,38],[-21,55],[-11,-13],[-8,-39],[-16,126],[-15,148],[-5,173],[-7,109]],[[23225,60010],[-50,-1]],[[23218,59542],[0,-203]],[[19407,73980],[138,-2],[211,1]],[[28648,60803],[-5,-29],[13,-23],[-19,-30],[-31,64],[-11,-27],[-7,25],[0,41],[-13,81],[-16,28]],[[28485,61173],[0,-30],[28,-89],[20,-114],[14,-33]],[[18654,73978],[120,-2],[137,0]],[[30177,69643],[6,32],[2,86],[-6,28],[12,36],[8,-3],[12,-44],[21,-9],[1,39],[-24,83],[-1,32],[22,107],[14,27],[11,43]],[[26308,66321],[-98,0]],[[30216,65279],[10,20],[5,40],[-1,164]],[[30259,65611],[12,-43],[23,-35],[34,-12],[9,-23],[19,44],[19,8],[27,33],[6,25],[-1,79],[-6,61],[-13,-31],[0,97],[-5,55],[-15,34],[-9,-7],[-5,-39],[-11,59],[13,11],[21,-18],[23,-58],[18,-123],[9,-119],[2,-137],[-15,-129],[-2,-44],[-7,9],[12,112],[-7,23],[-26,-5],[-43,-40],[-30,8],[-7,-28],[-17,-7],[-15,-62],[-33,-10],[-16,-35]],[[20642,73978],[114,0],[167,1]],[[28498,63766],[29,-57],[9,-67]],[[28579,63178],[-61,0]],[[26676,57055],[-17,23]],[[23647,70225],[-104,-1]],[[25554,53329],[-17,0],[-20,-38],[-16,20]],[[28638,62792],[6,-98],[-8,8],[-6,-42],[12,-22],[-21,-44],[-7,-28],[-13,8],[-11,45]],[[26192,58216],[10,-35],[9,10],[14,-32]],[[28328,63177],[3,0]],[[20388,61982],[12,-16],[3,-58],[10,-33],[-7,-63],[-1,-49],[-8,-2],[-21,-67]],[[25263,63097],[0,-238]],[[28263,63809],[-6,-15],[-20,-97],[-19,-123]],[[28537,59130],[-7,-36],[-2,-76],[8,-94],[11,-77],[-2,-65]],[[23001,56396],[-24,16],[-8,-86],[-18,-9],[-4,42],[-13,14],[-6,-33],[-9,25],[-6,95],[-8,5]],[[26311,61014],[-16,-17],[-4,70],[-13,10],[9,24],[0,39]],[[26287,61140],[-15,90],[6,42],[-10,39]],[[22050,59537],[0,475]],[[22613,69603],[1,405]],[[22383,51502],[8,34]],[[27666,60273],[-3,48],[3,50]],[[17303,71953],[-218,1]],[[31272,38457],[18,4]],[[26599,59546],[57,-4]],[[25021,52296],[-7,-24],[9,-17],[1,-40],[-25,-57],[-8,-80],[-9,10],[-13,-16]],[[24969,52072],[-12,0],[-13,50],[-4,66],[0,69],[-15,77],[-2,63]],[[27344,65662],[28,16],[24,34],[65,69],[17,24]],[[23353,59440],[-1,102],[-28,0]],[[22844,60564],[175,1]],[[21867,71226],[161,-2]],[[24652,59791],[10,-1],[0,-153],[10,0],[0,-101],[5,-1],[-1,-108]],[[15974,59837],[-14,94],[-12,43],[-10,11],[-9,-28],[-37,2],[-28,68],[-24,108]],[[15358,63504],[-16,33],[0,43],[-8,43],[-22,32],[-49,151],[4,63],[-4,70],[-13,74],[9,98],[14,109],[42,265],[11,95],[7,119],[-12,37],[-1,97],[4,2],[11,99],[9,169],[2,105]],[[22406,70416],[0,-405]],[[17304,70983],[-13,-10],[-19,15],[-15,-8],[-6,45]],[[16803,73980],[178,0]],[[26861,65369],[16,17],[-2,-36],[-14,19]],[[26872,65242],[22,-77],[16,-33],[22,-21],[37,54]],[[26222,61048],[12,17],[3,34],[10,21],[15,-15],[25,35]],[[23858,69609],[25,-40],[31,-79],[10,-47],[-2,-79],[16,0]],[[25692,65494],[30,58]],[[23552,61218],[-2,-424]],[[28686,59930],[25,-26],[17,27],[11,-11],[8,-128],[12,-140],[9,-71],[7,-94]],[[25397,68948],[-2,-80],[-13,-50],[20,-42],[12,7],[7,53],[26,64],[13,9]],[[25004,53954],[23,6]],[[28749,59144],[1,-67],[14,-39],[-31,25],[-32,118],[-15,6]],[[22902,55839],[31,-13]],[[31452,37982],[-11,-22],[-10,-48]],[[31436,38446],[12,6],[20,-16]],[[12100,86471],[67,80],[62,-115],[28,-88],[11,-2],[24,-70],[0,-104],[-12,-24],[1,-37],[16,-47],[-5,-42]],[[30068,65494],[-3,-45],[-14,-41],[-6,42],[4,35],[-19,62]],[[23711,55377],[63,0]],[[26094,61164],[-13,-30],[-4,-43],[-10,-20],[2,-30],[-29,-82],[-16,-4]],[[26187,61055],[-4,87]],[[27450,56219],[-11,35],[-7,-20],[-21,21],[-19,5],[-14,44],[-10,-3],[-20,41],[-7,37]],[[27155,51076],[7,15],[-4,40],[-20,-1],[0,68],[-9,0],[-1,67],[-18,-1],[0,40],[-25,-5],[-20,-17],[-15,-36]],[[24950,61122],[116,-5]],[[28607,58329],[-4,-20],[-21,-11],[-12,11],[-9,-33],[9,-57],[6,-86],[-7,0],[-29,47],[-14,-10],[-20,34],[-31,30],[-23,48],[-1,-29],[17,-61],[21,-5],[63,-102],[16,-10]],[[28357,66502],[0,106],[15,109],[95,3]],[[21992,49763],[-3,45],[-7,-2],[-13,59],[2,38],[-17,100],[3,47],[-9,39],[9,29],[-12,11],[-9,47],[4,39],[-14,28],[1,33],[-15,28],[-4,51],[2,41],[-8,26],[-4,73],[-6,1],[-9,88],[-8,1],[-10,211]],[[31637,38350],[7,-14],[0,-44],[-7,58]],[[31616,38316],[12,28],[-2,-46],[3,-69]],[[24941,51321],[17,10],[-9,-42],[-8,32]],[[24967,51478],[13,-58],[-13,33],[-14,5],[-8,-17],[-15,6],[18,-39],[0,-32],[-23,49],[0,-25],[12,-32],[-12,-14],[1,-34],[11,-36],[20,-11],[-1,-22],[12,-24],[-1,-34],[7,-46],[9,30],[5,-21],[22,-2],[16,-34],[3,30],[20,-91],[11,44],[24,-111],[0,-59],[6,-13],[18,28],[7,-41],[-24,-15],[-2,-33],[16,-3],[-8,-52],[-11,24],[-12,-96],[2,-44],[-21,36],[-2,55],[-8,16],[-31,-138],[-15,-41],[7,67],[9,29],[5,48],[9,21],[0,54],[9,23],[-1,51],[-10,24],[-4,-62],[-16,-29],[-12,29],[-14,77],[-34,43],[-10,45],[-56,33],[-17,-28]],[[25469,68033],[1,-95],[8,-50],[-2,-102],[-21,-118],[-3,-41]],[[24969,52072],[-17,-35],[-10,2]],[[27129,61967],[-11,40],[6,21],[-33,169]],[[90343,33382],[11,51],[21,35],[15,-9],[-2,-35],[-12,-13],[-8,-39],[-11,-6],[-5,23],[-9,-7]],[[31463,37795],[-7,-2],[-6,36],[-21,37]],[[15638,72257],[14,76],[31,74],[29,28],[3,73],[16,73],[31,68],[-9,97],[22,-40],[14,-187],[-22,0],[3,-40],[11,-14],[-4,-56],[7,-19],[0,-53],[-14,-38],[-1,-38],[15,-16],[-10,-48],[-5,-76]],[[26911,49121],[9,56],[13,34],[-2,23],[14,26],[11,84],[-5,75],[-22,21],[5,-113],[-22,30],[6,34],[-1,65],[-5,39],[-22,37],[-5,26]]]};

/***/ },
/* 562 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _reactRouterDom = __webpack_require__(181);
	
	var _reactDom = __webpack_require__(16);
	
	var _reactDom2 = _interopRequireDefault(_reactDom);
	
	var _App = __webpack_require__(557);
	
	var _App2 = _interopRequireDefault(_App);
	
	__webpack_require__(576);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	_reactDom2.default.render(_react2.default.createElement(
	  _reactRouterDom.BrowserRouter,
	  null,
	  _react2.default.createElement(_App2.default, null)
	), document.getElementById('root'));

/***/ },
/* 563 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	   value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _Treemap = __webpack_require__(182);
	
	var _Treemap2 = _interopRequireDefault(_Treemap);
	
	var _d3Collection = __webpack_require__(97);
	
	var _reactTooltip = __webpack_require__(45);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _ChartMeta = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post1Tree = function (_Component) {
	   _inherits(Post1Tree, _Component);
	
	   function Post1Tree(props) {
	      _classCallCheck(this, Post1Tree);
	
	      var _this = _possibleConstructorReturn(this, (Post1Tree.__proto__ || Object.getPrototypeOf(Post1Tree)).call(this, props));
	
	      _this.onResize = _this.onResize.bind(_this);
	      _this.state = {
	         screenWidth: window.innerWidth,
	         screenHeight: 500,
	         hover: "none",
	         data: [],
	         slice: "total",
	         program: "Title I Grants to Local Education Agencies",
	         x: 0,
	         y: 0,
	         tooltipPos: "top"
	      };
	
	      return _this;
	   }
	
	   _createClass(Post1Tree, [{
	      key: '_onMouseMove',
	      value: function _onMouseMove(e) {
	         var tooltipPos = "top";
	
	         if (e.clientX < this.state.screenWidth * 0.33) {
	            tooltipPos = "right";
	         } else if (e.clientX > this.state.screenWidth * 0.66) {
	            tooltipPos = "left";
	         }
	         this.setState({
	            x: e.clientX,
	            y: e.clientY,
	            tooltipPos: tooltipPos
	         });
	      }
	   }, {
	      key: 'onResize',
	      value: function onResize() {
	         this.setState({ screenWidth: window.innerWidth });
	      }
	   }, {
	      key: 'componentWillMount',
	      value: function componentWillMount() {
	         var _this2 = this;
	
	         (0, _d3Fetch.csv)("datasets/fy2017expendituresbyprogram.csv", function (d) {
	            d.FY2017Expenditures = parseFloat(d.FY2017Expenditures.replace(/\$|,/g, ''));
	            d.CFDA = +d.CFDA;
	            return d;
	         }).then(function (csvdata) {
	            var nestedData = (0, _d3Collection.nest)().key(function (d) {
	               return d.Agency;
	            }).entries(csvdata);
	            _this2.setState({ data: nestedData });
	         });
	      }
	   }, {
	      key: 'componentDidMount',
	      value: function componentDidMount() {
	         window.addEventListener('resize', this.onResize, false);
	         this.onResize();
	      }
	   }, {
	      key: 'componentDidUpdate',
	      value: function componentDidUpdate() {
	         _reactTooltip2.default.rebuild();
	      }
	   }, {
	      key: 'render',
	      value: function render() {
	         return _react2.default.createElement(
	            'div',
	            { className: 'App' },
	            _react2.default.createElement(
	               'div',
	               { onMouseMove: this._onMouseMove.bind(this) },
	               _react2.default.createElement(_ChartMeta.ChartHeader, { title: 'Where $1.5 trillion in census-guided federal assistance goes', subhed: 'Decennial census data is used by over 300 federal programs in two broad ways \u2013 to determine eligibility and to apportion funding. Here\u2019s where that money went in 2017.' }),
	               _react2.default.createElement(_reactTooltip2.default, { className: 'tooltip-width', place: this.state.tooltipPos
	               }),
	               _react2.default.createElement(_Treemap2.default, {
	                  data: this.state.data,
	                  value: 'FY2017Expenditures',
	                  organizer: 'Agency',
	                  size: [this.state.screenWidth, this.state.screenHeight]
	               }),
	               _react2.default.createElement(_ChartMeta.ChartFooter, { downloaddata: [], credit: _react2.default.createElement(
	                     'span',
	                     null,
	                     'Source: ',
	                     _react2.default.createElement(
	                        'a',
	                        { href: 'https://gwipp.gwu.edu/counting-dollars-2020-role-decennial-census-geographic-distribution-federal-funds' },
	                        '\u201CCounting for Dollars 2020: The Role of the Decennial Census in the Geographic Distribution of Federal Funds.\u201D'
	                     )
	                  ) })
	            )
	         );
	      }
	   }]);
	
	   return Post1Tree;
	}(_react.Component);
	
	exports.default = Post1Tree;

/***/ },
/* 564 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Array = __webpack_require__(31);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _Table = __webpack_require__(35);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _StateMap = __webpack_require__(101);
	
	var _StateMap2 = _interopRequireDefault(_StateMap);
	
	var _reactTooltip = __webpack_require__(45);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonGroup = __webpack_require__(42);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _core = __webpack_require__(87);
	
	var _ChartMeta = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post2Map = function (_Component) {
	  _inherits(Post2Map, _Component);
	
	  function Post2Map(props) {
	    _classCallCheck(this, Post2Map);
	
	    var _this = _possibleConstructorReturn(this, (Post2Map.__proto__ || Object.getPrototypeOf(Post2Map)).call(this, props));
	
	    _this.filterData = _this.filterData.bind(_this);
	    _this.onResize = _this.onResize.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.state = {
	      screenWidth: window.innerWidth,
	      screenHeight: 700,
	      slice: "total",
	      data: [],
	      filtereddata: [],
	      program: "",
	      programlist: [],
	      accessor: ""
	    };
	    return _this;
	  }
	
	  _createClass(Post2Map, [{
	    key: 'filterData',
	    value: function filterData(target) {
	      var _this2 = this;
	
	      var slice = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : "total";
	
	      var allowed = ['State', target];
	      var newarray = [];
	
	      var accessor = "";
	      if (slice === "total") {
	        accessor = "Total " + target + " Funding";
	      } else if (slice === "pop") {
	        accessor = target + " Funding Per Capita";
	      } else if (slice === "income") {
	        accessor = target + " Funding as % of State's Income";
	      }
	
	      var _loop = function _loop(i) {
	        var filtered = Object.keys(_this2.state.data[i]).filter(function (key) {
	          return allowed.includes(key);
	        }).reduce(function (obj, key) {
	          if (key === target) {
	            obj[accessor] = _this2.state.data[i][key] / _this2.state.data[i][slice];
	          } else {
	            obj[key] = _this2.state.data[i][key];
	          }
	          return obj;
	        }, {});
	        newarray.push(filtered);
	      };
	
	      for (var i = 0; i < this.state.data.length; i++) {
	        _loop(i);
	      }
	
	      newarray.columns = ['State', accessor];
	
	      this.setState({
	        accessor: accessor,
	        filtereddata: newarray,
	        slice: slice
	      });
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize() {
	      this.setState({ screenWidth: window.innerWidth });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      Promise.all([(0, _d3Fetch.csv)("datasets/2017_income_and_pop.csv"), (0, _d3Fetch.csv)("datasets/fy2017expendituresbyprogram-state.csv")]).then(function (datasets) {
	        var data_states = datasets[0];
	        var data_funding = datasets[1];
	
	        var programarray = [];
	        data_funding.map(function (d, i) {
	          return programarray.push(d.Program);
	        });
	        programarray = programarray.sort();
	
	        data_states.map(function (d, i) {
	          d["income"] = +d["income"];
	          d["pop"] = +d["pop"];
	          d["total"] = 1;
	          data_funding.map(function (f, j) {
	            var program = f["Program"];
	            d[program] = +f[d["State"]];
	          });
	        });
	
	        _this3.setState({
	          data: data_states,
	          programlist: programarray,
	          program: "Medicare"
	        });
	
	        _this3.filterData(_this3.state.program, "total");
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize, false);
	      this.onResize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      _reactTooltip2.default.rebuild();
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var actives = document.getElementsByClassName("active");
	      for (var i = 0; i < actives.length; i++) {
	        actives[i].classList.add("inactive");
	        actives[i].classList.remove("active");
	      }
	      document.getElementById("button_" + e).classList.add("active");
	      this.filterData(this.state.program, e);
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      var target = e.target.value;
	      this.setState({
	        program: target
	      });
	      this.filterData(target, this.state.slice);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var programselectors = this.state.programlist.sort().map(function (d, i) {
	        return _react2.default.createElement(
	          _core.MenuItem,
	          {
	            key: i,
	            value: d
	          },
	          d
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-3' },
	            _react2.default.createElement(_ChartMeta.ChartHeader, { title: "Funding received from 40 of the largest census-guided federal programs in 2017", subhed: this.state.program + " funding" })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-1' },
	            _react2.default.createElement(
	              _core.Select,
	              {
	                labelId: 'state-select-label',
	                id: 'state-select',
	                value: this.state.program,
	                onChange: this.handleChange.bind(this)
	              },
	              programselectors
	            )
	          )
	        ),
	        _react2.default.createElement(
	          _ButtonGroup2.default,
	          { id: 'toggles', 'aria-label': 'outlined button group' },
	          _react2.default.createElement(
	            _Button2.default,
	            { id: "button_" + "total", className: 'active', onClick: this.handleClick.bind(this, "total") },
	            'Total Funding'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { id: "button_" + "pop", className: 'inactive', onClick: this.handleClick.bind(this, "pop") },
	            'Per Capita'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { id: "button_" + "income", className: 'inactive', onClick: this.handleClick.bind(this, "income") },
	            '% of Income'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactTooltip2.default, { className: 'tooltip-width' }),
	          _react2.default.createElement(_StateMap2.default, {
	            data: this.state.filtereddata,
	            size: [this.state.screenWidth, this.state.screenHeight - 175],
	            fill: this.state.accessor,
	            slice: this.state.slice
	          })
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Table2.default, { data: this.state.filtereddata, sort: 'State', sortorder: 'asc' }),
	          _react2.default.createElement(_ChartMeta.ChartFooter, { credit: _react2.default.createElement(
	              'span',
	              null,
	              'Sources: ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://gwipp.gwu.edu/counting-dollars-2020-role-decennial-census-geographic-distribution-federal-funds' },
	                '\u201CCounting for Dollars 2020: The Role of the Decennial Census in the Geographic Distribution of Federal Funds,\u201D'
	              ),
	              ' Federal Funds Information for States.'
	            ), downloaddata: this.state.filtereddata, downloadfilename: this.state.accessor, key: this.state.accessor })
	        )
	      );
	    }
	  }]);
	
	  return Post2Map;
	}(_react.Component);
	
	exports.default = Post2Map;

/***/ },
/* 565 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _Table = __webpack_require__(35);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _ChartMeta = __webpack_require__(25);
	
	var _core = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var usStateNames = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
	
	var Post2Table = function (_Component) {
	  _inherits(Post2Table, _Component);
	
	  function Post2Table(props) {
	    _classCallCheck(this, Post2Table);
	
	    var _this = _possibleConstructorReturn(this, (Post2Table.__proto__ || Object.getPrototypeOf(Post2Table)).call(this, props));
	
	    _this.onResize = _this.onResize.bind(_this);
	    _this.filterData = _this.filterData.bind(_this);
	    _this.state = {
	      screenWidth: window.innerWidth,
	      screenHeight: 700,
	      hover: "none",
	      data: [],
	      slice: "total",
	      program: "Title I Grants to Local Education Agencies",
	      state: "Alabama",
	      filtereddata: []
	    };
	
	    return _this;
	  }
	
	  _createClass(Post2Table, [{
	    key: 'filterData',
	    value: function filterData(state) {
	      var _this2 = this;
	
	      var allowed = ['Program', 'Department', 'URL', 'FY2017 Funding', state];
	      var newarray = [];
	
	      var _loop = function _loop(i) {
	        var filtered = Object.keys(_this2.state.data[i]).filter(function (key) {
	          return allowed.includes(key);
	        }).reduce(function (obj, key) {
	          if (key === state) {
	            obj["FY2017 Funding"] = parseFloat(_this2.state.data[i][key]);
	          } else {
	            obj[key] = _this2.state.data[i][key];
	          }
	          return obj;
	        }, {});
	        newarray.push(filtered);
	      };
	
	      for (var i = 0; i < this.state.data.length; i++) {
	        _loop(i);
	      }
	
	      newarray.columns = allowed.filter(function (key) {
	        return key !== "URL" && key !== state;
	      });
	
	      this.setState({
	        state: state,
	        filtereddata: newarray
	      });
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize() {
	      this.setState({ screenWidth: window.innerWidth });
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      var newstate = e.target.value;
	      this.filterData(newstate);
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      var search = this.props.location.search;
	      var params = new URLSearchParams(search);
	      var urlstate = params.get('state');
	
	      if (urlstate === null) {
	        urlstate = this.state.state;
	      }
	
	      (0, _d3Fetch.csv)("datasets/fy2017expendituresbyprogram-state.csv").then(function (data) {
	        _this3.setState({ data: data, state: urlstate });
	        _this3.filterData(urlstate);
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize, false);
	      this.onResize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // ReactTooltip.rebuild()
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var stateselectors = usStateNames.map(function (d, i) {
	        return _react2.default.createElement(
	          _core.MenuItem,
	          {
	            key: i,
	            value: d
	          },
	          d
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-3' },
	            _react2.default.createElement(_ChartMeta.ChartHeader, { title: "Funding received by " + this.state.state + " from 40 of the largest census-guided federal programs in 2017" })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-1' },
	            _react2.default.createElement(
	              _core.Select,
	              {
	                labelId: 'state-select-label',
	                id: 'state-select',
	                value: this.state.state,
	                onChange: this.handleChange.bind(this)
	              },
	              stateselectors
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Table2.default, { data: this.state.filtereddata, sort: "FY2017 Funding", sortorder: 'desc' }),
	          _react2.default.createElement(_ChartMeta.ChartFooter, { key: this.state.state, credit: _react2.default.createElement(
	              'span',
	              null,
	              'Sources: ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://gwipp.gwu.edu/counting-dollars-2020-role-decennial-census-geographic-distribution-federal-funds' },
	                '\u201CCounting for Dollars 2020: The Role of the Decennial Census in the Geographic Distribution of Federal Funds,\u201D'
	              ),
	              ' Federal Funds Information for States.'
	            ), downloaddata: this.state.filtereddata, downloadfilename: "Funding received by " + this.state.state + " from 40 of the largest census-guided federal programs in 2017" })
	        )
	      );
	    }
	  }]);
	
	  return Post2Table;
	}(_react.Component);
	
	exports.default = Post2Table;

/***/ },
/* 566 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _Treemap = __webpack_require__(182);
	
	var _Treemap2 = _interopRequireDefault(_Treemap);
	
	var _d3Collection = __webpack_require__(97);
	
	var _reactTooltip = __webpack_require__(45);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _ChartMeta = __webpack_require__(25);
	
	var _core = __webpack_require__(87);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var usStateNames = ['Alabama', 'Alaska', 'Arizona', 'Arkansas', 'California', 'Colorado', 'Connecticut', 'Delaware', 'District of Columbia', 'Florida', 'Georgia', 'Hawaii', 'Idaho', 'Illinois', 'Indiana', 'Iowa', 'Kansas', 'Kentucky', 'Louisiana', 'Maine', 'Maryland', 'Massachusetts', 'Michigan', 'Minnesota', 'Mississippi', 'Missouri', 'Montana', 'Nebraska', 'Nevada', 'New Hampshire', 'New Jersey', 'New Mexico', 'New York', 'North Carolina', 'North Dakota', 'Ohio', 'Oklahoma', 'Oregon', 'Pennsylvania', 'Rhode Island', 'South Carolina', 'South Dakota', 'Tennessee', 'Texas', 'Utah', 'Vermont', 'Virginia', 'Washington', 'West Virginia', 'Wisconsin', 'Wyoming'];
	
	var Post2Tree = function (_Component) {
	  _inherits(Post2Tree, _Component);
	
	  function Post2Tree(props) {
	    _classCallCheck(this, Post2Tree);
	
	    var _this = _possibleConstructorReturn(this, (Post2Tree.__proto__ || Object.getPrototypeOf(Post2Tree)).call(this, props));
	
	    _this.onResize = _this.onResize.bind(_this);
	    _this.state = {
	      screenWidth: window.innerWidth,
	      screenHeight: 500,
	      hover: "none",
	      data: [],
	      originaldata: [],
	      slice: "total",
	      program: "Title I Grants to Local Education Agencies",
	      state: "Alabama",
	      x: 0,
	      y: 0,
	      tooltipPos: "top"
	    };
	    return _this;
	  }
	
	  _createClass(Post2Tree, [{
	    key: '_onMouseMove',
	    value: function _onMouseMove(e) {
	      var tooltipPos = "top";
	
	      if (e.clientX < this.state.screenWidth * 0.33) {
	        tooltipPos = "right";
	      } else if (e.clientX > this.state.screenWidth * 0.66) {
	        tooltipPos = "left";
	      }
	      this.setState({
	        x: e.clientX,
	        y: e.clientY,
	        tooltipPos: tooltipPos
	      });
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize() {
	      this.setState({ screenWidth: window.innerWidth });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      var search = this.props.location.search;
	      var params = new URLSearchParams(search);
	      var urlstate = params.get('state');
	
	      if (urlstate === null) {
	        urlstate = this.state.state;
	      }
	
	      (0, _d3Fetch.csv)("datasets/fy2017expendituresbyprogram-state.csv").then(function (csvdata) {
	        var nestedData = (0, _d3Collection.nest)().key(function (d) {
	          return d.Department;
	        }).entries(csvdata);
	        _this2.setState({
	          originaldata: csvdata,
	          data: nestedData,
	          state: urlstate
	        });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	
	      window.addEventListener('resize', this.onResize, false);
	      this.onResize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      _reactTooltip2.default.rebuild();
	    }
	  }, {
	    key: 'handleChange',
	    value: function handleChange(e) {
	      this.setState({
	        state: e.target.value
	      });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      var stateselectors = usStateNames.map(function (d, i) {
	        return _react2.default.createElement(
	          _core.MenuItem,
	          {
	            key: i,
	            value: d
	          },
	          d
	        );
	      });
	
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-3' },
	            _react2.default.createElement(_ChartMeta.ChartHeader, { title: "Funding received by " + this.state.state + " from census-guided federal programs in 2017" })
	          ),
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-1' },
	            _react2.default.createElement(
	              _core.Select,
	              {
	                labelId: 'state-select-label',
	                id: 'state-select',
	                value: this.state.state,
	                onChange: this.handleChange.bind(this)
	              },
	              stateselectors
	            )
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { onMouseMove: this._onMouseMove.bind(this) },
	          _react2.default.createElement(_Treemap2.default, {
	            data: this.state.data,
	            value: this.state.state,
	            organizer: 'Department',
	            omitSBA: true,
	            size: [this.state.screenWidth, this.state.screenHeight]
	          }),
	          _react2.default.createElement(_reactTooltip2.default, { className: 'tooltip-width', place: this.state.tooltipPos }),
	          _react2.default.createElement(_ChartMeta.ChartFooter, { credit: _react2.default.createElement(
	              'span',
	              null,
	              'Sources: ',
	              _react2.default.createElement(
	                'a',
	                { href: 'https://gwipp.gwu.edu/counting-dollars-2020-role-decennial-census-geographic-distribution-federal-funds' },
	                '\u201CCounting for Dollars 2020: The Role of the Decennial Census in the Geographic Distribution of Federal Funds,\u201D'
	              ),
	              ' Federal Funds Information for States.'
	            ), downloaddata: this.state.originaldata })
	        )
	      );
	    }
	  }]);
	
	  return Post2Tree;
	}(_react.Component);
	
	exports.default = Post2Tree;

/***/ },
/* 567 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _Table = __webpack_require__(35);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _StateMap = __webpack_require__(101);
	
	var _StateMap2 = _interopRequireDefault(_StateMap);
	
	var _reactTooltip = __webpack_require__(45);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonGroup = __webpack_require__(42);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _ChartMeta = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post3Map = function (_Component) {
	  _inherits(Post3Map, _Component);
	
	  function Post3Map(props) {
	    _classCallCheck(this, Post3Map);
	
	    var _this = _possibleConstructorReturn(this, (Post3Map.__proto__ || Object.getPrototypeOf(Post3Map)).call(this, props));
	
	    _this.filterData = _this.filterData.bind(_this);
	    _this.onResize = _this.onResize.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.state = {
	      screenWidth: window.innerWidth,
	      screenHeight: 700,
	      slice: "cost_low",
	      data: [],
	      filtereddata: [],
	      program: "",
	      programlist: [],
	      accessor: ""
	    };
	    return _this;
	  }
	
	  _createClass(Post3Map, [{
	    key: 'filterData',
	    value: function filterData() {
	      var _this2 = this;
	
	      var slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "cost_low";
	
	      var allowed = ['State', slice];
	      var newarray = [];
	
	      var accessor = "";
	      if (slice === "cost_low") {
	        accessor = "Low Risk";
	      } else if (slice === "cost_med") {
	        accessor = "Medium Risk";
	      } else if (slice === "cost_high") {
	        accessor = "High Risk";
	      }
	
	      var _loop = function _loop(i) {
	        var filtered = Object.keys(_this2.state.data[i]).filter(function (key) {
	          return allowed.includes(key);
	        }).reduce(function (obj, key) {
	          if (key === slice) {
	            obj[accessor] = _this2.state.data[i][key];
	          } else {
	            obj[key] = _this2.state.data[i][key];
	          }
	          return obj;
	        }, {});
	        newarray.push(filtered);
	      };
	
	      for (var i = 0; i < this.state.data.length; i++) {
	        _loop(i);
	      }
	
	      newarray.columns = ['State', accessor];
	
	      this.setState({
	        accessor: accessor,
	        filtereddata: newarray,
	        slice: slice
	      });
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize() {
	      this.setState({ screenWidth: window.innerWidth });
	    }
	
	    // onHover(d) {
	    //   this.setState({ hover: d.id })
	    // }
	
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      (0, _d3Fetch.csv)("datasets/losses_undercount.csv").then(function (dataset) {
	        dataset.forEach(function (d) {
	          d["cost_low"] = +d["cost_low"];
	          d["cost_med"] = +d["cost_med"];
	          d["cost_high"] = +d["cost_high"];
	        });
	
	        _this3.setState({
	          data: dataset
	        });
	
	        _this3.filterData("cost_low");
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize, false);
	      this.onResize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      _reactTooltip2.default.rebuild();
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      var actives = document.getElementsByClassName("active");
	      for (var i = 0; i < actives.length; i++) {
	        actives[i].classList.add("inactive");
	        actives[i].classList.remove("active");
	      }
	      document.getElementById("button_" + e).classList.add("active");
	      this.filterData(e);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(_ChartMeta.ChartHeader, { title: 'How a miscount in the 2020 census would skew federal funding for Medicaid', subhed: 'Medicaid reimbursements states might gain or lose under 2020 low-, medium- and high-risk miscount scenarios projected by the Urban Institute' }),
	        _react2.default.createElement(
	          _ButtonGroup2.default,
	          { id: 'toggles', 'aria-label': 'outlined button group' },
	          _react2.default.createElement(
	            _Button2.default,
	            { id: "button_" + "cost_low", className: 'active', onClick: this.handleClick.bind(this, "cost_low") },
	            'Low Risk'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { id: "button_" + "cost_med", className: 'inactive', onClick: this.handleClick.bind(this, "cost_med") },
	            'Medium Risk'
	          ),
	          _react2.default.createElement(
	            _Button2.default,
	            { id: "button_" + "cost_high", className: 'inactive', onClick: this.handleClick.bind(this, "cost_high") },
	            'High Risk'
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactTooltip2.default, { className: 'tooltip-width' }),
	          _react2.default.createElement(_StateMap2.default, {
	            data: this.state.filtereddata,
	            size: [this.state.screenWidth, this.state.screenHeight - 175],
	            fill: this.state.accessor,
	            slice: this.state.slice
	          })
	        ),
	        _react2.default.createElement(_ChartMeta.ChartFooter, { credit: _react2.default.createElement(
	            'span',
	            null,
	            'Sources: ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://gwipp.gwu.edu/counting-dollars-2020-role-decennial-census-geographic-distribution-federal-funds' },
	              '\u201CCounting for Dollars 2020: The Role of the Decennial Census in the Geographic Distribution of Federal Funds,\u201D'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.urban.org/research/publication/assessing-miscounts-2020-census' },
	              '\u201CAssessing Miscounts in the 2020 Census.\u201D'
	            )
	          ), downloaddata: this.state.filtereddata, downloadfilename: this.state.accessor, key: this.state.accessor })
	      );
	    }
	  }]);
	
	  return Post3Map;
	}(_react.Component);
	
	exports.default = Post3Map;

/***/ },
/* 568 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _Table = __webpack_require__(35);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _ChartMeta = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post3Table = function (_Component) {
	  _inherits(Post3Table, _Component);
	
	  function Post3Table(props) {
	    _classCallCheck(this, Post3Table);
	
	    var _this = _possibleConstructorReturn(this, (Post3Table.__proto__ || Object.getPrototypeOf(Post3Table)).call(this, props));
	
	    _this.onResize = _this.onResize.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.state = {
	      screenWidth: window.innerWidth,
	      screenHeight: 700,
	      hover: "none",
	      data: [],
	      slice: "total",
	      program: "Title I Grants to Local Education Agencies"
	    };
	
	    return _this;
	  }
	
	  _createClass(Post3Table, [{
	    key: 'onResize',
	    value: function onResize() {
	      this.setState({ screenWidth: window.innerWidth });
	    }
	
	    // onHover(d) {
	    //   this.setState({ hover: d.id })
	    // }
	
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _d3Fetch.csv)("datasets/losses_undercount.csv").then(function (data) {
	        data.map(function (item) {
	          return Object.keys(item).filter(function (d) {
	            return d !== "State";
	          }).map(function (key) {
	            return item[key] = +item[key];
	          });
	        });
	
	        _this2.setState({
	          data: data
	        });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize, false);
	      this.onResize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // ReactTooltip.rebuild()
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      this.setState({ slice: e });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-3' },
	            _react2.default.createElement(_ChartMeta.ChartHeader, { title: "How a miscount in the 2020 census would skew federal funding for Medicaid" })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Table2.default, { data: this.state.data })
	        ),
	        _react2.default.createElement(_ChartMeta.ChartFooter, { credit: _react2.default.createElement(
	            'span',
	            null,
	            'Sources: ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://gwipp.gwu.edu/counting-dollars-2020-role-decennial-census-geographic-distribution-federal-funds' },
	              '\u201CCounting for Dollars 2020: The Role of the Decennial Census in the Geographic Distribution of Federal Funds,\u201D'
	            ),
	            ' ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://www.urban.org/research/publication/assessing-miscounts-2020-census' },
	              '\u201CAssessing Miscounts in the 2020 Census.\u201D'
	            )
	          ), downloaddata: this.state.data, downloadfilename: "How a miscount in the 2020 census would skew federal funding for Medicaid" })
	      );
	    }
	  }]);
	
	  return Post3Table;
	}(_react.Component);
	
	exports.default = Post3Table;

/***/ },
/* 569 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	    value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _mapboxGl = __webpack_require__(538);
	
	var _mapboxGl2 = _interopRequireDefault(_mapboxGl);
	
	var _mapboxGlGeocoder = __webpack_require__(202);
	
	var _mapboxGlGeocoder2 = _interopRequireDefault(_mapboxGlGeocoder);
	
	__webpack_require__(575);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _d3Array = __webpack_require__(31);
	
	var _FormatMoney = __webpack_require__(59);
	
	var _FormatMoney2 = _interopRequireDefault(_FormatMoney);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonGroup = __webpack_require__(42);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _ChartMeta = __webpack_require__(25);
	
	var _ColorSchemes = __webpack_require__(72);
	
	var _queryString = __webpack_require__(545);
	
	var _queryString2 = _interopRequireDefault(_queryString);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	_mapboxGl2.default.accessToken = ("pk.eyJ1IjoidHlsZXJtYWNoYWRvIiwiYSI6ImNpbXY1YmMxMTAybTh1cGtrYmY3bjFiNHMifQ.e7Jn45kHrT5m2SbpSCZq5Q");
	var colorScale = _ColorSchemes.bucketScale;
	var levels = ["fiscal_cost_low_risk", "fiscal_cost_med_risk", "fiscal_cost_high_risk"];
	var avg = 1546.48;
	var width = (0, _d3Array.min)([900, window.innerWidth]);
	
	var Post4DistrictMap = function (_Component) {
	    _inherits(Post4DistrictMap, _Component);
	
	    function Post4DistrictMap(props) {
	        _classCallCheck(this, Post4DistrictMap);
	
	        var _this = _possibleConstructorReturn(this, (Post4DistrictMap.__proto__ || Object.getPrototypeOf(Post4DistrictMap)).call(this, props));
	
	        _this.handleClick = _this.handleClick.bind(_this);
	        _this.state = {
	            slice: "United States of America",
	            statequery: "United States of America",
	            data: [],
	            lng: -98.58,
	            lat: 39.83,
	            zoom: 3,
	            scale: colorScale
	        };
	        return _this;
	    }
	
	    _createClass(Post4DistrictMap, [{
	        key: 'handleClick',
	        value: function handleClick(e) {
	            var actives = document.getElementsByClassName("active");
	            for (var i = 0; i < actives.length; i++) {
	                actives[i].classList.add("inactive");
	                actives[i].classList.remove("active");
	            }
	            for (var ll = 0; ll < levels.length; ll++) {
	                this.state.map.setLayoutProperty('district-data-' + levels[ll], 'visibility', 'none');
	            }
	            document.getElementById("button_" + e).classList.add("active");
	            this.setState({
	                slice: e
	            });
	            this.state.map.setLayoutProperty('district-data-' + e, 'visibility', 'visible');
	        }
	    }, {
	        key: 'componentWillMount',
	        value: function componentWillMount() {
	            // csv("datasets/map-and-table-title-i-grants-per-state-per-child.csv").then(data => {
	            //   this.setState({data: data});
	            // });
	        }
	    }, {
	        key: 'componentDidMount',
	        value: function componentDidMount() {
	            var _this2 = this;
	
	            var statequery = _queryString2.default.parse(this.props.location.search).statequery ? _queryString2.default.parse(this.props.location.search).statequery : this.state.statequery;
	
	            console.log(statequery);
	
	            var map = new _mapboxGl2.default.Map({
	                container: this.mapContainer,
	                style: 'mapbox://styles/mapbox/light-v10',
	                center: [this.state.lng, this.state.lat],
	                zoom: this.state.zoom
	            });
	
	            this.setState({
	                map: map
	            });
	
	            map.on('load', function () {
	
	                map.addSource('districts', {
	                    type: 'vector',
	                    url: 'mapbox://tylermachado.9ifw2bln'
	                });
	
	                map.addSource('statelines', {
	                    type: 'vector',
	                    url: 'mapbox://tylermachado.d9wh29pp'
	                });
	
	                (0, _d3Fetch.csv)("datasets/joined_school_dist_2018_update.csv").then(function (dataset) {
	                    var expression = ['match', ['get', 'GEOID']];
	
	                    colorScale.domain(dataset.map(function (row, i) {
	                        return parseFloat(row["Title I funds per low-income child"]);
	                    }, _this2));
	
	                    dataset.map(function (row, i) {
	                        var id = "";
	
	                        if (row["LEA_id"].length === 6) {
	                            id = "0".concat(row["LEA_id"]);
	                        } else {
	                            id = row["LEA_id"];
	                        }
	
	                        var number = parseFloat(row["Title I funds per low-income child"]);
	                        expression.push(id, isNaN(number) || number == 0 ? 'gainsboro' : colorScale(number));
	                    }, _this2);
	
	                    expression.push('gainsboro');
	
	                    map.addLayer({
	                        'id': 'district-data',
	                        'type': 'fill',
	                        'source': 'districts',
	                        'source-layer': 'edge_04p-37il12',
	                        'paint': {
	                            'fill-color': expression,
	                            'fill-opacity': 0.9,
	                            'fill-outline-color': '#aaa'
	                        },
	                        'layout': {
	                            'visibility': 'none'
	                        }
	                    });
	
	                    map.addLayer({
	                        'id': 'statelines-data',
	                        'type': 'line',
	                        'source': 'statelines',
	                        'source-layer': 'states_21basic-bmxanm',
	                        'paint': {
	                            'line-width': 1,
	                            'line-color': '#222222'
	                        }
	                    });
	
	                    map.on('click', 'district-data', function (e) {
	                        var districtdata = dataset.filter(function (d) {
	                            if (e.features[0].properties.GEOID.substr(0, 1) == 0) {
	                                return d.LEA_id == e.features[0].properties.GEOID.substr(1, 7);
	                            } else {
	                                return d.LEA_id == e.features[0].properties.GEOID;
	                            }
	                        })[0];
	
	                        var anchor = null;
	                        if (e.point.x > width / 2) {
	                            anchor = "right";
	                        }
	
	                        new _mapboxGl2.default.Popup({ anchor: anchor }).setMaxWidth("400px").setLngLat(e.lngLat).setHTML("<h3>" + districtdata["School district"] + ", " + districtdata["State"] + "</h3>" + "<br/>Title I funding to district: <b>" + (0, _FormatMoney2.default)(districtdata["Title I funding in FY2018"]) + "<br/></b>Title I funding per low-income child: <b>" + (0, _FormatMoney2.default)(districtdata["Title I funds per low-income child"]) + "</b>").addTo(map);
	                    });
	
	                    map.setLayoutProperty('district-data', 'visibility', 'visible');
	
	                    var geocoder = new _mapboxGlGeocoder2.default({
	                        accessToken: _mapboxGl2.default.accessToken,
	                        mapboxgl: _mapboxGl2.default,
	                        types: 'region',
	                        countries: 'us',
	                        marker: false,
	                        placeholder: 'Search your state'
	                    });
	
	                    map.addControl(geocoder);
	
	                    geocoder.query(statequery);
	
	                    geocoder.on('result', function (result) {
	                        _this2.setState({
	                            statequery: result.result.place_name
	                        });
	                        console.log(_this2.state);
	                    });
	
	                    map.addControl(new _mapboxGl2.default.NavigationControl({
	                        showCompass: false,
	                        showZoom: true
	                    }));
	
	                    _this2.setState({
	                        data: dataset,
	                        scale: colorScale
	                    });
	                });
	            });
	
	            map.on('move', function () {
	                _this2.setState({
	                    lng: map.getCenter().lng.toFixed(4),
	                    lat: map.getCenter().lat.toFixed(4),
	                    zoom: map.getZoom().toFixed(2)
	                });
	            });
	        }
	    }, {
	        key: 'render',
	        value: function render() {
	            var _this3 = this;
	
	            // console.log(this.state.statequery)
	            var legmargin = {
	                vertical: 0,
	                textoffset: 48,
	                height: 18
	            };
	
	            var domain = [];
	
	            if (this.state.scale.domain()) {
	                domain = this.state.scale.domain();
	            }
	
	            var legend = _react2.default.createElement(
	                'svg',
	                { className: 'districtlegend', width: 350, height: 50, transform: "translate(0,0)" },
	                _react2.default.createElement(
	                    'g',
	                    null,
	                    _react2.default.createElement('text', {
	                        y: legmargin.textoffset,
	                        x: 5, fontSize: '0.65rem', textAnchor: 'middle'
	                    }),
	                    _react2.default.createElement('rect', {
	                        width: 65, height: legmargin.height, x: 0, y: legmargin.height,
	                        style: { fill: this.state.scale.range()[0] }
	                    }),
	                    _react2.default.createElement(
	                        'text',
	                        {
	                            y: legmargin.textoffset,
	                            x: 65, fontSize: '0.65rem', textAnchor: 'middle'
	                        },
	                        (0, _FormatMoney2.default)(domain[Math.round(domain.length * 0.2)], "rounded")
	                    ),
	                    _react2.default.createElement('rect', {
	                        width: 65, height: legmargin.height, x: 70, y: legmargin.height,
	                        style: { fill: this.state.scale.range()[1] }
	                    }),
	                    _react2.default.createElement(
	                        'text',
	                        {
	                            y: legmargin.textoffset,
	                            x: 135, fontSize: '0.65rem', textAnchor: 'middle'
	                        },
	                        (0, _FormatMoney2.default)(domain[Math.round(domain.length * 0.4)], "rounded")
	                    ),
	                    _react2.default.createElement('rect', {
	                        width: 65, height: legmargin.height, x: 140, y: legmargin.height,
	                        style: { fill: this.state.scale.range()[2] }
	                    }),
	                    _react2.default.createElement(
	                        'text',
	                        {
	                            y: legmargin.textoffset,
	                            x: 205, fontSize: '0.65rem', textAnchor: 'middle'
	                        },
	                        (0, _FormatMoney2.default)(domain[Math.round(domain.length * 0.6)], "rounded")
	                    ),
	                    _react2.default.createElement('rect', {
	                        width: 65, height: legmargin.height, x: 210, y: legmargin.height,
	                        style: { fill: this.state.scale.range()[3] }
	                    }),
	                    _react2.default.createElement(
	                        'text',
	                        {
	                            y: legmargin.textoffset,
	                            x: 280, fontSize: '0.65rem', textAnchor: 'middle'
	                        },
	                        (0, _FormatMoney2.default)(domain[Math.round(domain.length * 0.8)], "rounded")
	                    ),
	                    _react2.default.createElement('rect', {
	                        width: 65, height: legmargin.height, x: 280, y: legmargin.height,
	                        style: { fill: this.state.scale.range()[4] }
	                    })
	                )
	            );
	
	            return _react2.default.createElement(
	                'div',
	                { className: 'App' },
	                _react2.default.createElement(_ChartMeta.ChartHeader, {
	                    title: 'Title I funds per low-income child by school district in 2018'
	                }),
	                _react2.default.createElement('div', { ref: function ref(el) {
	                        return _this3.mapContainer = el;
	                    }, className: 'mapContainer' }),
	                domain.length > 0 ? legend : '',
	                _react2.default.createElement(_ChartMeta.ChartFooter, { key: this.state.statequery, credit: _react2.default.createElement(
	                        'span',
	                        null,
	                        'Sources: U.S. Census Bureau\u2019s SAIPE; Dept. of Education; Mapbox'
	                    ), downloaddata: this.state.data, search: "?statequery=" + this.state.statequery, downloadfilename: "Title I funds per low-income child by school district in 2018" })
	            );
	        }
	    }]);
	
	    return Post4DistrictMap;
	}(_react.Component);
	
	exports.default = Post4DistrictMap;

/***/ },
/* 570 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _Table = __webpack_require__(35);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _StateMap = __webpack_require__(101);
	
	var _StateMap2 = _interopRequireDefault(_StateMap);
	
	var _reactTooltip = __webpack_require__(45);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonGroup = __webpack_require__(42);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _ChartMeta = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post4Map = function (_Component) {
	  _inherits(Post4Map, _Component);
	
	  function Post4Map(props) {
	    _classCallCheck(this, Post4Map);
	
	    var _this = _possibleConstructorReturn(this, (Post4Map.__proto__ || Object.getPrototypeOf(Post4Map)).call(this, props));
	
	    _this.filterData = _this.filterData.bind(_this);
	    _this.onResize = _this.onResize.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.state = {
	      screenWidth: window.innerWidth,
	      screenHeight: 700,
	      slice: "Funding Per Child",
	      data: [],
	      filtereddata: [],
	      program: "",
	      programlist: [],
	      accessor: ""
	    };
	    return _this;
	  }
	
	  _createClass(Post4Map, [{
	    key: 'filterData',
	    value: function filterData() {
	      var _this2 = this;
	
	      var slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "Funding Per Child";
	
	      var allowed = ['State', slice];
	      var newarray = [];
	
	      var accessor = slice;
	
	      var _loop = function _loop(i) {
	        var filtered = Object.keys(_this2.state.data[i]).filter(function (key) {
	          return allowed.includes(key);
	        }).reduce(function (obj, key) {
	          if (key === slice) {
	            obj[accessor] = _this2.state.data[i][key];
	          } else {
	            obj[key] = _this2.state.data[i][key];
	          }
	          return obj;
	        }, {});
	        newarray.push(filtered);
	      };
	
	      for (var i = 0; i < this.state.data.length; i++) {
	        _loop(i);
	      }
	
	      newarray.columns = ['State', accessor];
	
	      this.setState({
	        accessor: accessor,
	        filtereddata: newarray,
	        slice: slice
	      });
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize() {
	      this.setState({ screenWidth: window.innerWidth });
	    }
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this3 = this;
	
	      (0, _d3Fetch.csv)("datasets/map-and-table-title-i-grants-per-state-per-child-2017.csv").then(function (dataset) {
	        dataset.map(function (item) {
	          return Object.keys(item).filter(function (d) {
	            return d !== "State";
	          }).map(function (key) {
	            return item[key] = +item[key];
	          });
	        });
	
	        _this3.setState({
	          data: dataset
	        });
	
	        _this3.filterData("Funding Per Child");
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize, false);
	      this.onResize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      _reactTooltip2.default.rebuild();
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      this.setState({ slice: e });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(_ChartMeta.ChartHeader, { title: 'Title I funding per low-income child in 2017 by state', subhed: 'Vermont, Wyoming and North Dakota received substantially more Title I grant money per eligible child in FY2017 than other states.' }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_reactTooltip2.default, { className: 'tooltip-width' }),
	          _react2.default.createElement(_StateMap2.default, {
	            data: this.state.filtereddata,
	            size: [this.state.screenWidth, this.state.screenHeight - 175],
	            fill: this.state.accessor,
	            slice: this.state.slice,
	            reversescale: true
	          })
	        ),
	        _react2.default.createElement(_ChartMeta.ChartFooter, { credit: _react2.default.createElement(
	            'span',
	            null,
	            'Sources: ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://gwipp.gwu.edu/counting-dollars-2020-role-decennial-census-geographic-distribution-federal-funds' },
	              '\u201CCounting for Dollars 2020: The Role of the Decennial Census in the Geographic Distribution of Federal Funds,\u201D'
	            ),
	            ' U.S. Census Bureau\u2019s SAIPE; Dept. of Education'
	          ), downloaddata: this.state.filtereddata, downloadfilename: "Title I Funding Per Child in 2017 by State" })
	      );
	    }
	  }]);
	
	  return Post4Map;
	}(_react.Component);
	
	exports.default = Post4Map;

/***/ },
/* 571 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _ChartMeta = __webpack_require__(25);
	
	var _Table = __webpack_require__(35);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post4Table = function (_Component) {
	  _inherits(Post4Table, _Component);
	
	  function Post4Table(props) {
	    _classCallCheck(this, Post4Table);
	
	    var _this = _possibleConstructorReturn(this, (Post4Table.__proto__ || Object.getPrototypeOf(Post4Table)).call(this, props));
	
	    _this.onResize = _this.onResize.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.state = {
	      screenWidth: window.innerWidth,
	      screenHeight: 700,
	      hover: "none",
	      data: [],
	      slice: "total",
	      program: "Title I Grants to Local Education Agencies"
	    };
	
	    return _this;
	  }
	
	  _createClass(Post4Table, [{
	    key: 'onResize',
	    value: function onResize() {
	      this.setState({ screenWidth: window.innerWidth });
	    }
	
	    // onHover(d) {
	    //   this.setState({ hover: d.id })
	    // }
	
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _d3Fetch.csv)("datasets/map-and-table-title-i-grants-per-state-per-child.csv").then(function (data) {
	        data.map(function (item) {
	          return Object.keys(item).filter(function (d) {
	            return d !== "State";
	          }).map(function (key) {
	            return item[key] = +item[key];
	          });
	        });
	
	        _this2.setState({ data: data });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize, false);
	      this.onResize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // ReactTooltip.rebuild()
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      this.setState({ slice: e });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      console.log(this.state.data);
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(
	          'div',
	          { className: 'header-grid' },
	          _react2.default.createElement(
	            'div',
	            { className: 'grid-3' },
	            _react2.default.createElement(_ChartMeta.ChartHeader, { title: "Title I funding per low-income child in 2016 by state" })
	          )
	        ),
	        _react2.default.createElement(
	          'div',
	          { className: 'App-header' },
	          _react2.default.createElement('h2', null)
	        ),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Table2.default, { data: this.state.data })
	        ),
	        _react2.default.createElement(_ChartMeta.ChartFooter, { credit: "Sources: U.S. Census Bureau’s SAIPE; Dept. of Education", downloaddata: this.state.data, downloadfilename: "Title I funding per low-income child in 2016 by state" })
	      );
	    }
	  }]);
	
	  return Post4Table;
	}(_react.Component);
	
	exports.default = Post4Table;

/***/ },
/* 572 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _Table = __webpack_require__(35);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	var _CountiesMap = __webpack_require__(559);
	
	var _CountiesMap2 = _interopRequireDefault(_CountiesMap);
	
	var _reactTooltip = __webpack_require__(45);
	
	var _reactTooltip2 = _interopRequireDefault(_reactTooltip);
	
	var _Button = __webpack_require__(34);
	
	var _Button2 = _interopRequireDefault(_Button);
	
	var _ButtonGroup = __webpack_require__(42);
	
	var _ButtonGroup2 = _interopRequireDefault(_ButtonGroup);
	
	var _ChartMeta = __webpack_require__(25);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post5Map = function (_Component) {
	  _inherits(Post5Map, _Component);
	
	  function Post5Map(props) {
	    _classCallCheck(this, Post5Map);
	
	    var _this = _possibleConstructorReturn(this, (Post5Map.__proto__ || Object.getPrototypeOf(Post5Map)).call(this, props));
	
	    _this.onResize = _this.onResize.bind(_this);
	    _this.handleClick = _this.handleClick.bind(_this);
	    _this.state = {
	      screenWidth: window.innerWidth,
	      screenHeight: 700,
	      hover: "none",
	      data: [],
	      slice: "pop_change",
	      program: "Title I Grants to Local Education Agencies"
	    };
	
	    return _this;
	  }
	
	  _createClass(Post5Map, [{
	    key: 'onResize',
	    value: function onResize() {
	      this.setState({ screenWidth: window.innerWidth });
	    }
	
	    // onHover(d) {
	    //   this.setState({ hover: d.id })
	    // }
	
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _d3Fetch.csv)("datasets/pop2017_2018_and_change_bycounty.csv").then(function (data) {
	        var newdata = [];
	        data.map(function (item) {
	          Object.keys(item).map(function (key) {
	            return item["County"] = item["NAME.x"], item["pop_2017"] = +item["pop_2017"], item["pop_2018"] = +item["pop_2018"], item["pop_change"] = +item["pop_change"];
	          });
	        });
	        data.columns = ["County", "pop_2017", "pop_2018", "pop_change"];
	        _this2.setState({ data: data });
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize, false);
	      this.onResize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      _reactTooltip2.default.rebuild();
	    }
	  }, {
	    key: 'handleClick',
	    value: function handleClick(e) {
	      this.setState({ slice: e });
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(_ChartMeta.ChartHeader, { title: 'Population change by county 2017-2018' }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_CountiesMap2.default, {
	            data: this.state.data,
	            program: this.state.program,
	            size: [this.state.screenWidth, this.state.screenHeight - 175],
	            slice: this.state.slice
	          }),
	          _react2.default.createElement(_reactTooltip2.default, { className: 'tooltip-width' })
	        ),
	        _react2.default.createElement(_ChartMeta.ChartFooter, { credit: 'Source: U.S. Census Bureau', downloaddata: this.state.data, downloadfilename: "Population change by county 2017-2018" })
	      );
	    }
	  }]);
	
	  return Post5Map;
	}(_react.Component);
	
	exports.default = Post5Map;

/***/ },
/* 573 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	var _createClass = function () { function defineProperties(target, props) { for (var i = 0; i < props.length; i++) { var descriptor = props[i]; descriptor.enumerable = descriptor.enumerable || false; descriptor.configurable = true; if ("value" in descriptor) descriptor.writable = true; Object.defineProperty(target, descriptor.key, descriptor); } } return function (Constructor, protoProps, staticProps) { if (protoProps) defineProperties(Constructor.prototype, protoProps); if (staticProps) defineProperties(Constructor, staticProps); return Constructor; }; }();
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	__webpack_require__(14);
	
	var _d3Fetch = __webpack_require__(21);
	
	var _ChartMeta = __webpack_require__(25);
	
	var _TextField = __webpack_require__(145);
	
	var _TextField2 = _interopRequireDefault(_TextField);
	
	var _Autocomplete = __webpack_require__(455);
	
	var _Autocomplete2 = _interopRequireDefault(_Autocomplete);
	
	var _Table = __webpack_require__(35);
	
	var _Table2 = _interopRequireDefault(_Table);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }
	
	function _possibleConstructorReturn(self, call) { if (!self) { throw new ReferenceError("this hasn't been initialised - super() hasn't been called"); } return call && (typeof call === "object" || typeof call === "function") ? call : self; }
	
	function _inherits(subClass, superClass) { if (typeof superClass !== "function" && superClass !== null) { throw new TypeError("Super expression must either be null or a function, not " + typeof superClass); } subClass.prototype = Object.create(superClass && superClass.prototype, { constructor: { value: subClass, enumerable: false, writable: true, configurable: true } }); if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass; }
	
	var Post5Table = function (_Component) {
	  _inherits(Post5Table, _Component);
	
	  function Post5Table(props) {
	    _classCallCheck(this, Post5Table);
	
	    var _this = _possibleConstructorReturn(this, (Post5Table.__proto__ || Object.getPrototypeOf(Post5Table)).call(this, props));
	
	    _this.onResize = _this.onResize.bind(_this);
	    _this.filterData = _this.filterData.bind(_this);
	    _this.handleChangeFilter = _this.handleChangeFilter.bind(_this);
	    _this.state = {
	      screenWidth: window.innerWidth,
	      screenHeight: 700,
	      origdata: [],
	      data: [],
	      places: [],
	      slice: ""
	    };
	    return _this;
	  }
	
	  _createClass(Post5Table, [{
	    key: 'filterData',
	    value: function filterData() {
	      var slice = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : "";
	
	      var newarray = [];
	      newarray = this.state.origdata.filter(function (d) {
	        return d["State"] === slice;
	      });
	      newarray.sort(function (a, b) {
	        var textA = a["County"].toUpperCase();
	        var textB = b["County"].toUpperCase();
	        return textA < textB ? -1 : textA > textB ? 1 : 0;
	      });
	      newarray.columns = this.state.origdata.columns;
	
	      this.setState({
	        data: newarray,
	        slice: slice
	      });
	    }
	  }, {
	    key: 'onResize',
	    value: function onResize() {
	      this.setState({ screenWidth: window.innerWidth });
	    }
	
	    // onHover(d) {
	    //   this.setState({ hover: d.id })
	    // }
	
	  }, {
	    key: 'componentWillMount',
	    value: function componentWillMount() {
	      var _this2 = this;
	
	      (0, _d3Fetch.csv)("datasets/Medicare-advantage-criteria-county-changes-19to20.csv").then(function (data) {
	        data.sort(function (a, b) {
	          var textA = a["State"].toUpperCase();
	          var textB = b["State"].toUpperCase();
	          return textA < textB ? -1 : textA > textB ? 1 : 0;
	        });
	        var places = [];
	        data.forEach(function (d) {
	          return places.indexOf(d["State"]) === -1 ? places.push(d["State"]) : null;
	        });
	        _this2.setState({
	          origdata: data,
	          places: places
	        });
	        _this2.filterData("CO");
	      });
	    }
	  }, {
	    key: 'componentDidMount',
	    value: function componentDidMount() {
	      window.addEventListener('resize', this.onResize, false);
	      this.onResize();
	    }
	  }, {
	    key: 'componentDidUpdate',
	    value: function componentDidUpdate() {
	      // ReactTooltip.rebuild()
	    }
	  }, {
	    key: 'handleChangeFilter',
	    value: function handleChangeFilter(e, v) {
	      this.filterData(v);
	    }
	  }, {
	    key: 'render',
	    value: function render() {
	      return _react2.default.createElement(
	        'div',
	        { className: 'App' },
	        _react2.default.createElement(_ChartMeta.ChartHeader, { title: "How the census affects access to medical care through programs like Medicare Advantage" }),
	        _react2.default.createElement(
	          'div',
	          null,
	          _react2.default.createElement(_Autocomplete2.default, {
	            id: 'area-select',
	            style: { width: 300 },
	            options: this.state.places,
	            className: "autocomplete",
	            autoHighlight: true,
	            getOptionLabel: function getOptionLabel(option) {
	              return option;
	            },
	            onChange: this.handleChangeFilter,
	            renderOption: function renderOption(option) {
	              return _react2.default.createElement(
	                _react2.default.Fragment,
	                null,
	                option
	              );
	            },
	            renderInput: function renderInput(params) {
	              return _react2.default.createElement(_TextField2.default, _extends({}, params, {
	                label: 'Find a state',
	                variant: 'outlined',
	                inputProps: _extends({}, params.inputProps, {
	                  autoComplete: 'new-password' })
	              }));
	            }
	          }),
	          _react2.default.createElement(_Table2.default, { data: this.state.data })
	        ),
	        _react2.default.createElement(_ChartMeta.ChartFooter, { credit: _react2.default.createElement(
	            'span',
	            null,
	            'Source: ',
	            _react2.default.createElement(
	              'a',
	              { href: 'https://cms.gov' },
	              'CMS.gov'
	            ),
	            '.'
	          ), downloaddata: this.state.origdata, downloadfilename: "How the census affects access to medical care through programs like Medicare Advantage" })
	      );
	    }
	  }]);
	
	  return Post5Table;
	}(_react.Component);
	
	exports.default = Post5Table;

/***/ },
/* 574 */
/***/ function(module, exports) {

	// Copyright Joyent, Inc. and other Node contributors.
	//
	// Permission is hereby granted, free of charge, to any person obtaining a
	// copy of this software and associated documentation files (the
	// "Software"), to deal in the Software without restriction, including
	// without limitation the rights to use, copy, modify, merge, publish,
	// distribute, sublicense, and/or sell copies of the Software, and to permit
	// persons to whom the Software is furnished to do so, subject to the
	// following conditions:
	//
	// The above copyright notice and this permission notice shall be included
	// in all copies or substantial portions of the Software.
	//
	// THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS
	// OR IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF
	// MERCHANTABILITY, FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN
	// NO EVENT SHALL THE AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM,
	// DAMAGES OR OTHER LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR
	// OTHERWISE, ARISING FROM, OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE
	// USE OR OTHER DEALINGS IN THE SOFTWARE.
	
	function EventEmitter() {
	  this._events = this._events || {};
	  this._maxListeners = this._maxListeners || undefined;
	}
	module.exports = EventEmitter;
	
	// Backwards-compat with node 0.10.x
	EventEmitter.EventEmitter = EventEmitter;
	
	EventEmitter.prototype._events = undefined;
	EventEmitter.prototype._maxListeners = undefined;
	
	// By default EventEmitters will print a warning if more than 10 listeners are
	// added to it. This is a useful default which helps finding memory leaks.
	EventEmitter.defaultMaxListeners = 10;
	
	// Obviously not all Emitters should be limited to 10. This function allows
	// that to be increased. Set to zero for unlimited.
	EventEmitter.prototype.setMaxListeners = function(n) {
	  if (!isNumber(n) || n < 0 || isNaN(n))
	    throw TypeError('n must be a positive number');
	  this._maxListeners = n;
	  return this;
	};
	
	EventEmitter.prototype.emit = function(type) {
	  var er, handler, len, args, i, listeners;
	
	  if (!this._events)
	    this._events = {};
	
	  // If there is no 'error' event listener then throw.
	  if (type === 'error') {
	    if (!this._events.error ||
	        (isObject(this._events.error) && !this._events.error.length)) {
	      er = arguments[1];
	      if (er instanceof Error) {
	        throw er; // Unhandled 'error' event
	      } else {
	        // At least give some kind of context to the user
	        var err = new Error('Uncaught, unspecified "error" event. (' + er + ')');
	        err.context = er;
	        throw err;
	      }
	    }
	  }
	
	  handler = this._events[type];
	
	  if (isUndefined(handler))
	    return false;
	
	  if (isFunction(handler)) {
	    switch (arguments.length) {
	      // fast cases
	      case 1:
	        handler.call(this);
	        break;
	      case 2:
	        handler.call(this, arguments[1]);
	        break;
	      case 3:
	        handler.call(this, arguments[1], arguments[2]);
	        break;
	      // slower
	      default:
	        args = Array.prototype.slice.call(arguments, 1);
	        handler.apply(this, args);
	    }
	  } else if (isObject(handler)) {
	    args = Array.prototype.slice.call(arguments, 1);
	    listeners = handler.slice();
	    len = listeners.length;
	    for (i = 0; i < len; i++)
	      listeners[i].apply(this, args);
	  }
	
	  return true;
	};
	
	EventEmitter.prototype.addListener = function(type, listener) {
	  var m;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events)
	    this._events = {};
	
	  // To avoid recursion in the case that type === "newListener"! Before
	  // adding it to the listeners, first emit "newListener".
	  if (this._events.newListener)
	    this.emit('newListener', type,
	              isFunction(listener.listener) ?
	              listener.listener : listener);
	
	  if (!this._events[type])
	    // Optimize the case of one listener. Don't need the extra array object.
	    this._events[type] = listener;
	  else if (isObject(this._events[type]))
	    // If we've already got an array, just append.
	    this._events[type].push(listener);
	  else
	    // Adding the second element, need to change to array.
	    this._events[type] = [this._events[type], listener];
	
	  // Check for listener leak
	  if (isObject(this._events[type]) && !this._events[type].warned) {
	    if (!isUndefined(this._maxListeners)) {
	      m = this._maxListeners;
	    } else {
	      m = EventEmitter.defaultMaxListeners;
	    }
	
	    if (m && m > 0 && this._events[type].length > m) {
	      this._events[type].warned = true;
	      console.error('(node) warning: possible EventEmitter memory ' +
	                    'leak detected. %d listeners added. ' +
	                    'Use emitter.setMaxListeners() to increase limit.',
	                    this._events[type].length);
	      if (typeof console.trace === 'function') {
	        // not supported in IE 10
	        console.trace();
	      }
	    }
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.on = EventEmitter.prototype.addListener;
	
	EventEmitter.prototype.once = function(type, listener) {
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  var fired = false;
	
	  function g() {
	    this.removeListener(type, g);
	
	    if (!fired) {
	      fired = true;
	      listener.apply(this, arguments);
	    }
	  }
	
	  g.listener = listener;
	  this.on(type, g);
	
	  return this;
	};
	
	// emits a 'removeListener' event iff the listener was removed
	EventEmitter.prototype.removeListener = function(type, listener) {
	  var list, position, length, i;
	
	  if (!isFunction(listener))
	    throw TypeError('listener must be a function');
	
	  if (!this._events || !this._events[type])
	    return this;
	
	  list = this._events[type];
	  length = list.length;
	  position = -1;
	
	  if (list === listener ||
	      (isFunction(list.listener) && list.listener === listener)) {
	    delete this._events[type];
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	
	  } else if (isObject(list)) {
	    for (i = length; i-- > 0;) {
	      if (list[i] === listener ||
	          (list[i].listener && list[i].listener === listener)) {
	        position = i;
	        break;
	      }
	    }
	
	    if (position < 0)
	      return this;
	
	    if (list.length === 1) {
	      list.length = 0;
	      delete this._events[type];
	    } else {
	      list.splice(position, 1);
	    }
	
	    if (this._events.removeListener)
	      this.emit('removeListener', type, listener);
	  }
	
	  return this;
	};
	
	EventEmitter.prototype.removeAllListeners = function(type) {
	  var key, listeners;
	
	  if (!this._events)
	    return this;
	
	  // not listening for removeListener, no need to emit
	  if (!this._events.removeListener) {
	    if (arguments.length === 0)
	      this._events = {};
	    else if (this._events[type])
	      delete this._events[type];
	    return this;
	  }
	
	  // emit removeListener for all listeners on all events
	  if (arguments.length === 0) {
	    for (key in this._events) {
	      if (key === 'removeListener') continue;
	      this.removeAllListeners(key);
	    }
	    this.removeAllListeners('removeListener');
	    this._events = {};
	    return this;
	  }
	
	  listeners = this._events[type];
	
	  if (isFunction(listeners)) {
	    this.removeListener(type, listeners);
	  } else if (listeners) {
	    // LIFO order
	    while (listeners.length)
	      this.removeListener(type, listeners[listeners.length - 1]);
	  }
	  delete this._events[type];
	
	  return this;
	};
	
	EventEmitter.prototype.listeners = function(type) {
	  var ret;
	  if (!this._events || !this._events[type])
	    ret = [];
	  else if (isFunction(this._events[type]))
	    ret = [this._events[type]];
	  else
	    ret = this._events[type].slice();
	  return ret;
	};
	
	EventEmitter.prototype.listenerCount = function(type) {
	  if (this._events) {
	    var evlistener = this._events[type];
	
	    if (isFunction(evlistener))
	      return 1;
	    else if (evlistener)
	      return evlistener.length;
	  }
	  return 0;
	};
	
	EventEmitter.listenerCount = function(emitter, type) {
	  return emitter.listenerCount(type);
	};
	
	function isFunction(arg) {
	  return typeof arg === 'function';
	}
	
	function isNumber(arg) {
	  return typeof arg === 'number';
	}
	
	function isObject(arg) {
	  return typeof arg === 'object' && arg !== null;
	}
	
	function isUndefined(arg) {
	  return arg === void 0;
	}


/***/ },
/* 575 */
14,
/* 576 */
14,
/* 577 */
/***/ function(module, exports) {

	'use strict';
	/* eslint-disable no-unused-vars */
	var hasOwnProperty = Object.prototype.hasOwnProperty;
	var propIsEnumerable = Object.prototype.propertyIsEnumerable;
	
	function toObject(val) {
		if (val === null || val === undefined) {
			throw new TypeError('Object.assign cannot be called with null or undefined');
		}
	
		return Object(val);
	}
	
	function shouldUseNative() {
		try {
			if (!Object.assign) {
				return false;
			}
	
			// Detect buggy property enumeration order in older V8 versions.
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=4118
			var test1 = new String('abc');  // eslint-disable-line
			test1[5] = 'de';
			if (Object.getOwnPropertyNames(test1)[0] === '5') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test2 = {};
			for (var i = 0; i < 10; i++) {
				test2['_' + String.fromCharCode(i)] = i;
			}
			var order2 = Object.getOwnPropertyNames(test2).map(function (n) {
				return test2[n];
			});
			if (order2.join('') !== '0123456789') {
				return false;
			}
	
			// https://bugs.chromium.org/p/v8/issues/detail?id=3056
			var test3 = {};
			'abcdefghijklmnopqrst'.split('').forEach(function (letter) {
				test3[letter] = letter;
			});
			if (Object.keys(Object.assign({}, test3)).join('') !==
					'abcdefghijklmnopqrst') {
				return false;
			}
	
			return true;
		} catch (e) {
			// We don't expect any of the above to throw, but better to be safe.
			return false;
		}
	}
	
	module.exports = shouldUseNative() ? Object.assign : function (target, source) {
		var from;
		var to = toObject(target);
		var symbols;
	
		for (var s = 1; s < arguments.length; s++) {
			from = Object(arguments[s]);
	
			for (var key in from) {
				if (hasOwnProperty.call(from, key)) {
					to[key] = from[key];
				}
			}
	
			if (Object.getOwnPropertySymbols) {
				symbols = Object.getOwnPropertySymbols(from);
				for (var i = 0; i < symbols.length; i++) {
					if (propIsEnumerable.call(from, symbols[i])) {
						to[symbols[i]] = from[symbols[i]];
					}
				}
			}
		}
	
		return to;
	};


/***/ },
/* 578 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	//This file contains the ES6 extensions to the core Promises/A+ API
	
	var Promise = __webpack_require__(184);
	
	module.exports = Promise;
	
	/* Static Functions */
	
	var TRUE = valuePromise(true);
	var FALSE = valuePromise(false);
	var NULL = valuePromise(null);
	var UNDEFINED = valuePromise(undefined);
	var ZERO = valuePromise(0);
	var EMPTYSTRING = valuePromise('');
	
	function valuePromise(value) {
	  var p = new Promise(Promise._61);
	  p._81 = 1;
	  p._65 = value;
	  return p;
	}
	Promise.resolve = function (value) {
	  if (value instanceof Promise) return value;
	
	  if (value === null) return NULL;
	  if (value === undefined) return UNDEFINED;
	  if (value === true) return TRUE;
	  if (value === false) return FALSE;
	  if (value === 0) return ZERO;
	  if (value === '') return EMPTYSTRING;
	
	  if (typeof value === 'object' || typeof value === 'function') {
	    try {
	      var then = value.then;
	      if (typeof then === 'function') {
	        return new Promise(then.bind(value));
	      }
	    } catch (ex) {
	      return new Promise(function (resolve, reject) {
	        reject(ex);
	      });
	    }
	  }
	  return valuePromise(value);
	};
	
	Promise.all = function (arr) {
	  var args = Array.prototype.slice.call(arr);
	
	  return new Promise(function (resolve, reject) {
	    if (args.length === 0) return resolve([]);
	    var remaining = args.length;
	    function res(i, val) {
	      if (val && (typeof val === 'object' || typeof val === 'function')) {
	        if (val instanceof Promise && val.then === Promise.prototype.then) {
	          while (val._81 === 3) {
	            val = val._65;
	          }
	          if (val._81 === 1) return res(i, val._65);
	          if (val._81 === 2) reject(val._65);
	          val.then(function (val) {
	            res(i, val);
	          }, reject);
	          return;
	        } else {
	          var then = val.then;
	          if (typeof then === 'function') {
	            var p = new Promise(then.bind(val));
	            p.then(function (val) {
	              res(i, val);
	            }, reject);
	            return;
	          }
	        }
	      }
	      args[i] = val;
	      if (--remaining === 0) {
	        resolve(args);
	      }
	    }
	    for (var i = 0; i < args.length; i++) {
	      res(i, args[i]);
	    }
	  });
	};
	
	Promise.reject = function (value) {
	  return new Promise(function (resolve, reject) {
	    reject(value);
	  });
	};
	
	Promise.race = function (values) {
	  return new Promise(function (resolve, reject) {
	    values.forEach(function(value){
	      Promise.resolve(value).then(resolve, reject);
	    });
	  });
	};
	
	/* Prototype Methods */
	
	Promise.prototype['catch'] = function (onRejected) {
	  return this.then(null, onRejected);
	};


/***/ },
/* 579 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var Promise = __webpack_require__(184);
	
	var DEFAULT_WHITELIST = [
	  ReferenceError,
	  TypeError,
	  RangeError
	];
	
	var enabled = false;
	exports.disable = disable;
	function disable() {
	  enabled = false;
	  Promise._10 = null;
	  Promise._97 = null;
	}
	
	exports.enable = enable;
	function enable(options) {
	  options = options || {};
	  if (enabled) disable();
	  enabled = true;
	  var id = 0;
	  var displayId = 0;
	  var rejections = {};
	  Promise._10 = function (promise) {
	    if (
	      promise._81 === 2 && // IS REJECTED
	      rejections[promise._72]
	    ) {
	      if (rejections[promise._72].logged) {
	        onHandled(promise._72);
	      } else {
	        clearTimeout(rejections[promise._72].timeout);
	      }
	      delete rejections[promise._72];
	    }
	  };
	  Promise._97 = function (promise, err) {
	    if (promise._45 === 0) { // not yet handled
	      promise._72 = id++;
	      rejections[promise._72] = {
	        displayId: null,
	        error: err,
	        timeout: setTimeout(
	          onUnhandled.bind(null, promise._72),
	          // For reference errors and type errors, this almost always
	          // means the programmer made a mistake, so log them after just
	          // 100ms
	          // otherwise, wait 2 seconds to see if they get handled
	          matchWhitelist(err, DEFAULT_WHITELIST)
	            ? 100
	            : 2000
	        ),
	        logged: false
	      };
	    }
	  };
	  function onUnhandled(id) {
	    if (
	      options.allRejections ||
	      matchWhitelist(
	        rejections[id].error,
	        options.whitelist || DEFAULT_WHITELIST
	      )
	    ) {
	      rejections[id].displayId = displayId++;
	      if (options.onUnhandled) {
	        rejections[id].logged = true;
	        options.onUnhandled(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      } else {
	        rejections[id].logged = true;
	        logError(
	          rejections[id].displayId,
	          rejections[id].error
	        );
	      }
	    }
	  }
	  function onHandled(id) {
	    if (rejections[id].logged) {
	      if (options.onHandled) {
	        options.onHandled(rejections[id].displayId, rejections[id].error);
	      } else if (!rejections[id].onUnhandled) {
	        console.warn(
	          'Promise Rejection Handled (id: ' + rejections[id].displayId + '):'
	        );
	        console.warn(
	          '  This means you can ignore any previous messages of the form "Possible Unhandled Promise Rejection" with id ' +
	          rejections[id].displayId + '.'
	        );
	      }
	    }
	  }
	}
	
	function logError(id, error) {
	  console.warn('Possible Unhandled Promise Rejection (id: ' + id + '):');
	  var errStr = (error && (error.stack || error)) + '';
	  errStr.split('\n').forEach(function (line) {
	    console.warn('  ' + line);
	  });
	}
	
	function matchWhitelist(error, list) {
	  return list.some(function (cls) {
	    return error instanceof cls;
	  });
	}

/***/ },
/* 580 */
/***/ function(module, exports) {

	module.exports = function(module) {
		if(!module.webpackPolyfill) {
			module.deprecate = function() {};
			module.paths = [];
			// module.parent = undefined by default
			module.children = [];
			module.webpackPolyfill = 1;
		}
		return module;
	}


/***/ },
/* 581 */
/***/ function(module, exports) {

	(function(self) {
	  'use strict';
	
	  if (self.fetch) {
	    return
	  }
	
	  var support = {
	    searchParams: 'URLSearchParams' in self,
	    iterable: 'Symbol' in self && 'iterator' in Symbol,
	    blob: 'FileReader' in self && 'Blob' in self && (function() {
	      try {
	        new Blob()
	        return true
	      } catch(e) {
	        return false
	      }
	    })(),
	    formData: 'FormData' in self,
	    arrayBuffer: 'ArrayBuffer' in self
	  }
	
	  function normalizeName(name) {
	    if (typeof name !== 'string') {
	      name = String(name)
	    }
	    if (/[^a-z0-9\-#$%&'*+.\^_`|~]/i.test(name)) {
	      throw new TypeError('Invalid character in header field name')
	    }
	    return name.toLowerCase()
	  }
	
	  function normalizeValue(value) {
	    if (typeof value !== 'string') {
	      value = String(value)
	    }
	    return value
	  }
	
	  // Build a destructive iterator for the value list
	  function iteratorFor(items) {
	    var iterator = {
	      next: function() {
	        var value = items.shift()
	        return {done: value === undefined, value: value}
	      }
	    }
	
	    if (support.iterable) {
	      iterator[Symbol.iterator] = function() {
	        return iterator
	      }
	    }
	
	    return iterator
	  }
	
	  function Headers(headers) {
	    this.map = {}
	
	    if (headers instanceof Headers) {
	      headers.forEach(function(value, name) {
	        this.append(name, value)
	      }, this)
	
	    } else if (headers) {
	      Object.getOwnPropertyNames(headers).forEach(function(name) {
	        this.append(name, headers[name])
	      }, this)
	    }
	  }
	
	  Headers.prototype.append = function(name, value) {
	    name = normalizeName(name)
	    value = normalizeValue(value)
	    var list = this.map[name]
	    if (!list) {
	      list = []
	      this.map[name] = list
	    }
	    list.push(value)
	  }
	
	  Headers.prototype['delete'] = function(name) {
	    delete this.map[normalizeName(name)]
	  }
	
	  Headers.prototype.get = function(name) {
	    var values = this.map[normalizeName(name)]
	    return values ? values[0] : null
	  }
	
	  Headers.prototype.getAll = function(name) {
	    return this.map[normalizeName(name)] || []
	  }
	
	  Headers.prototype.has = function(name) {
	    return this.map.hasOwnProperty(normalizeName(name))
	  }
	
	  Headers.prototype.set = function(name, value) {
	    this.map[normalizeName(name)] = [normalizeValue(value)]
	  }
	
	  Headers.prototype.forEach = function(callback, thisArg) {
	    Object.getOwnPropertyNames(this.map).forEach(function(name) {
	      this.map[name].forEach(function(value) {
	        callback.call(thisArg, value, name, this)
	      }, this)
	    }, this)
	  }
	
	  Headers.prototype.keys = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push(name) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.values = function() {
	    var items = []
	    this.forEach(function(value) { items.push(value) })
	    return iteratorFor(items)
	  }
	
	  Headers.prototype.entries = function() {
	    var items = []
	    this.forEach(function(value, name) { items.push([name, value]) })
	    return iteratorFor(items)
	  }
	
	  if (support.iterable) {
	    Headers.prototype[Symbol.iterator] = Headers.prototype.entries
	  }
	
	  function consumed(body) {
	    if (body.bodyUsed) {
	      return Promise.reject(new TypeError('Already read'))
	    }
	    body.bodyUsed = true
	  }
	
	  function fileReaderReady(reader) {
	    return new Promise(function(resolve, reject) {
	      reader.onload = function() {
	        resolve(reader.result)
	      }
	      reader.onerror = function() {
	        reject(reader.error)
	      }
	    })
	  }
	
	  function readBlobAsArrayBuffer(blob) {
	    var reader = new FileReader()
	    reader.readAsArrayBuffer(blob)
	    return fileReaderReady(reader)
	  }
	
	  function readBlobAsText(blob) {
	    var reader = new FileReader()
	    reader.readAsText(blob)
	    return fileReaderReady(reader)
	  }
	
	  function Body() {
	    this.bodyUsed = false
	
	    this._initBody = function(body) {
	      this._bodyInit = body
	      if (typeof body === 'string') {
	        this._bodyText = body
	      } else if (support.blob && Blob.prototype.isPrototypeOf(body)) {
	        this._bodyBlob = body
	      } else if (support.formData && FormData.prototype.isPrototypeOf(body)) {
	        this._bodyFormData = body
	      } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	        this._bodyText = body.toString()
	      } else if (!body) {
	        this._bodyText = ''
	      } else if (support.arrayBuffer && ArrayBuffer.prototype.isPrototypeOf(body)) {
	        // Only support ArrayBuffers for POST method.
	        // Receiving ArrayBuffers happens via Blobs, instead.
	      } else {
	        throw new Error('unsupported BodyInit type')
	      }
	
	      if (!this.headers.get('content-type')) {
	        if (typeof body === 'string') {
	          this.headers.set('content-type', 'text/plain;charset=UTF-8')
	        } else if (this._bodyBlob && this._bodyBlob.type) {
	          this.headers.set('content-type', this._bodyBlob.type)
	        } else if (support.searchParams && URLSearchParams.prototype.isPrototypeOf(body)) {
	          this.headers.set('content-type', 'application/x-www-form-urlencoded;charset=UTF-8')
	        }
	      }
	    }
	
	    if (support.blob) {
	      this.blob = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return Promise.resolve(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as blob')
	        } else {
	          return Promise.resolve(new Blob([this._bodyText]))
	        }
	      }
	
	      this.arrayBuffer = function() {
	        return this.blob().then(readBlobAsArrayBuffer)
	      }
	
	      this.text = function() {
	        var rejected = consumed(this)
	        if (rejected) {
	          return rejected
	        }
	
	        if (this._bodyBlob) {
	          return readBlobAsText(this._bodyBlob)
	        } else if (this._bodyFormData) {
	          throw new Error('could not read FormData body as text')
	        } else {
	          return Promise.resolve(this._bodyText)
	        }
	      }
	    } else {
	      this.text = function() {
	        var rejected = consumed(this)
	        return rejected ? rejected : Promise.resolve(this._bodyText)
	      }
	    }
	
	    if (support.formData) {
	      this.formData = function() {
	        return this.text().then(decode)
	      }
	    }
	
	    this.json = function() {
	      return this.text().then(JSON.parse)
	    }
	
	    return this
	  }
	
	  // HTTP methods whose capitalization should be normalized
	  var methods = ['DELETE', 'GET', 'HEAD', 'OPTIONS', 'POST', 'PUT']
	
	  function normalizeMethod(method) {
	    var upcased = method.toUpperCase()
	    return (methods.indexOf(upcased) > -1) ? upcased : method
	  }
	
	  function Request(input, options) {
	    options = options || {}
	    var body = options.body
	    if (Request.prototype.isPrototypeOf(input)) {
	      if (input.bodyUsed) {
	        throw new TypeError('Already read')
	      }
	      this.url = input.url
	      this.credentials = input.credentials
	      if (!options.headers) {
	        this.headers = new Headers(input.headers)
	      }
	      this.method = input.method
	      this.mode = input.mode
	      if (!body) {
	        body = input._bodyInit
	        input.bodyUsed = true
	      }
	    } else {
	      this.url = input
	    }
	
	    this.credentials = options.credentials || this.credentials || 'omit'
	    if (options.headers || !this.headers) {
	      this.headers = new Headers(options.headers)
	    }
	    this.method = normalizeMethod(options.method || this.method || 'GET')
	    this.mode = options.mode || this.mode || null
	    this.referrer = null
	
	    if ((this.method === 'GET' || this.method === 'HEAD') && body) {
	      throw new TypeError('Body not allowed for GET or HEAD requests')
	    }
	    this._initBody(body)
	  }
	
	  Request.prototype.clone = function() {
	    return new Request(this)
	  }
	
	  function decode(body) {
	    var form = new FormData()
	    body.trim().split('&').forEach(function(bytes) {
	      if (bytes) {
	        var split = bytes.split('=')
	        var name = split.shift().replace(/\+/g, ' ')
	        var value = split.join('=').replace(/\+/g, ' ')
	        form.append(decodeURIComponent(name), decodeURIComponent(value))
	      }
	    })
	    return form
	  }
	
	  function headers(xhr) {
	    var head = new Headers()
	    var pairs = (xhr.getAllResponseHeaders() || '').trim().split('\n')
	    pairs.forEach(function(header) {
	      var split = header.trim().split(':')
	      var key = split.shift().trim()
	      var value = split.join(':').trim()
	      head.append(key, value)
	    })
	    return head
	  }
	
	  Body.call(Request.prototype)
	
	  function Response(bodyInit, options) {
	    if (!options) {
	      options = {}
	    }
	
	    this.type = 'default'
	    this.status = options.status
	    this.ok = this.status >= 200 && this.status < 300
	    this.statusText = options.statusText
	    this.headers = options.headers instanceof Headers ? options.headers : new Headers(options.headers)
	    this.url = options.url || ''
	    this._initBody(bodyInit)
	  }
	
	  Body.call(Response.prototype)
	
	  Response.prototype.clone = function() {
	    return new Response(this._bodyInit, {
	      status: this.status,
	      statusText: this.statusText,
	      headers: new Headers(this.headers),
	      url: this.url
	    })
	  }
	
	  Response.error = function() {
	    var response = new Response(null, {status: 0, statusText: ''})
	    response.type = 'error'
	    return response
	  }
	
	  var redirectStatuses = [301, 302, 303, 307, 308]
	
	  Response.redirect = function(url, status) {
	    if (redirectStatuses.indexOf(status) === -1) {
	      throw new RangeError('Invalid status code')
	    }
	
	    return new Response(null, {status: status, headers: {location: url}})
	  }
	
	  self.Headers = Headers
	  self.Request = Request
	  self.Response = Response
	
	  self.fetch = function(input, init) {
	    return new Promise(function(resolve, reject) {
	      var request
	      if (Request.prototype.isPrototypeOf(input) && !init) {
	        request = input
	      } else {
	        request = new Request(input, init)
	      }
	
	      var xhr = new XMLHttpRequest()
	
	      function responseURL() {
	        if ('responseURL' in xhr) {
	          return xhr.responseURL
	        }
	
	        // Avoid security warnings on getResponseHeader when not allowed by CORS
	        if (/^X-Request-URL:/m.test(xhr.getAllResponseHeaders())) {
	          return xhr.getResponseHeader('X-Request-URL')
	        }
	
	        return
	      }
	
	      xhr.onload = function() {
	        var options = {
	          status: xhr.status,
	          statusText: xhr.statusText,
	          headers: headers(xhr),
	          url: responseURL()
	        }
	        var body = 'response' in xhr ? xhr.response : xhr.responseText
	        resolve(new Response(body, options))
	      }
	
	      xhr.onerror = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.ontimeout = function() {
	        reject(new TypeError('Network request failed'))
	      }
	
	      xhr.open(request.method, request.url, true)
	
	      if (request.credentials === 'include') {
	        xhr.withCredentials = true
	      }
	
	      if ('responseType' in xhr && support.blob) {
	        xhr.responseType = 'blob'
	      }
	
	      request.headers.forEach(function(value, name) {
	        xhr.setRequestHeader(name, value)
	      })
	
	      xhr.send(typeof request._bodyInit === 'undefined' ? null : request._bodyInit)
	    })
	  }
	  self.fetch.polyfill = true
	})(typeof self !== 'undefined' ? self : this);


/***/ },
/* 582 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isBodyMode = function () {
	    return !!this.props.bodyMode;
	  };
	
	  target.prototype.bindBodyListener = function (targetArray) {
	    var _this = this;
	
	    var _state = this.state,
	        event = _state.event,
	        eventOff = _state.eventOff,
	        possibleCustomEvents = _state.possibleCustomEvents,
	        possibleCustomEventsOff = _state.possibleCustomEventsOff;
	
	    var body = getBody();
	
	    var customEvents = findCustomEvents(targetArray, 'data-event');
	    var customEventsOff = findCustomEvents(targetArray, 'data-event-off');
	
	    if (event != null) customEvents[event] = true;
	    if (eventOff != null) customEventsOff[eventOff] = true;
	    possibleCustomEvents.split(' ').forEach(function (event) {
	      return customEvents[event] = true;
	    });
	    possibleCustomEventsOff.split(' ').forEach(function (event) {
	      return customEventsOff[event] = true;
	    });
	
	    this.unbindBodyListener(body);
	
	    var listeners = this.bodyModeListeners = {};
	    if (event == null) {
	      listeners.mouseover = bodyListener.bind(this, this.showTooltip, {});
	      listeners.mousemove = bodyListener.bind(this, this.updateTooltip, { respectEffect: true });
	      listeners.mouseout = bodyListener.bind(this, this.hideTooltip, {});
	    }
	
	    for (var _event in customEvents) {
	      listeners[_event] = bodyListener.bind(this, function (e) {
	        var targetEventOff = e.currentTarget.getAttribute('data-event-off') || eventOff;
	        _customEvent.checkStatus.call(_this, targetEventOff, e);
	      }, { customEvent: true });
	    }
	    for (var _event2 in customEventsOff) {
	      listeners[_event2] = bodyListener.bind(this, this.hideTooltip, { customEvent: true });
	    }
	    for (var _event3 in listeners) {
	      body.addEventListener(_event3, listeners[_event3]);
	    }
	  };
	
	  target.prototype.unbindBodyListener = function (body) {
	    body = body || getBody();
	
	    var listeners = this.bodyModeListeners;
	    for (var event in listeners) {
	      body.removeEventListener(event, listeners[event]);
	    }
	  };
	};
	
	var _customEvent = __webpack_require__(186);
	
	var makeProxy = function makeProxy(e) {
	  var proxy = {};
	  for (var key in e) {
	    if (typeof e[key] === 'function') {
	      proxy[key] = e[key].bind(e);
	    } else {
	      proxy[key] = e[key];
	    }
	  }
	  return proxy;
	}; /**
	    * Util method to get effect
	    */
	
	
	var bodyListener = function bodyListener(callback, options, e) {
	  var _options$respectEffec = options.respectEffect,
	      respectEffect = _options$respectEffec === undefined ? false : _options$respectEffec,
	      _options$customEvent = options.customEvent,
	      customEvent = _options$customEvent === undefined ? false : _options$customEvent;
	  var id = this.props.id;
	
	
	  var tip = e.target.getAttribute('data-tip') || null;
	  var forId = e.target.getAttribute('data-for') || null;
	
	  var target = e.target;
	  if (this.isCustomEvent(target) && !customEvent) {
	    return;
	  }
	
	  var isTargetBelongsToTooltip = id == null && forId == null || forId === id;
	
	  if (tip != null && (!respectEffect || this.getEffect(target) === 'float') && isTargetBelongsToTooltip) {
	    var proxy = makeProxy(e);
	    proxy.currentTarget = target;
	    callback(proxy);
	  }
	};
	
	var findCustomEvents = function findCustomEvents(targetArray, dataAttribute) {
	  var events = {};
	  targetArray.forEach(function (target) {
	    var event = target.getAttribute(dataAttribute);
	    if (event) event.split(' ').forEach(function (event) {
	      return events[event] = true;
	    });
	  });
	
	  return events;
	};
	
	var getBody = function getBody() {
	  return document.getElementsByTagName('body')[0];
	};

/***/ },
/* 583 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.getEffect = function (currentTarget) {
	    var dataEffect = currentTarget.getAttribute('data-effect');
	    return dataEffect || this.props.effect || 'float';
	  };
	};

/***/ },
/* 584 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.isCapture = function (currentTarget) {
	    return currentTarget && currentTarget.getAttribute('data-iscapture') === 'true' || this.props.isCapture || false;
	  };
	};

/***/ },
/* 585 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  /**
	   * Hide all tooltip
	   * @trigger ReactTooltip.hide()
	   */
	  target.hide = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.HIDE, { target: target });
	  };
	
	  /**
	   * Rebuild all tooltip
	   * @trigger ReactTooltip.rebuild()
	   */
	  target.rebuild = function () {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.REBUILD);
	  };
	
	  /**
	   * Show specific tooltip
	   * @trigger ReactTooltip.show()
	   */
	  target.show = function (target) {
	    dispatchGlobalEvent(_constant2.default.GLOBAL.SHOW, { target: target });
	  };
	
	  target.prototype.globalRebuild = function () {
	    if (this.mount) {
	      this.unbindListener();
	      this.bindListener();
	    }
	  };
	
	  target.prototype.globalShow = function (event) {
	    if (this.mount) {
	      // Create a fake event, specific show will limit the type to `solid`
	      // only `float` type cares e.clientX e.clientY
	      var e = { currentTarget: event.detail.target };
	      this.showTooltip(e, true);
	    }
	  };
	
	  target.prototype.globalHide = function (event) {
	    if (this.mount) {
	      var hasTarget = event && event.detail && event.detail.target && true || false;
	      this.hideTooltip({ currentTarget: hasTarget && event.detail.target }, hasTarget);
	    }
	  };
	};
	
	var _constant = __webpack_require__(185);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var dispatchGlobalEvent = function dispatchGlobalEvent(eventName, opts) {
	  // Compatible with IE
	  // @see http://stackoverflow.com/questions/26596123/internet-explorer-9-10-11-event-constructor-doesnt-work
	  var event = void 0;
	
	  if (typeof window.CustomEvent === 'function') {
	    event = new window.CustomEvent(eventName, { detail: opts });
	  } else {
	    event = document.createEvent('Event');
	    event.initEvent(eventName, false, true);
	    event.detail = opts;
	  }
	
	  window.dispatchEvent(event);
	}; /**
	    * Static methods for react-tooltip
	    */

/***/ },
/* 586 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindRemovalTracker = function () {
	    var _this = this;
	
	    var MutationObserver = getMutationObserverClass();
	    if (MutationObserver == null) return;
	
	    var observer = new MutationObserver(function (mutations) {
	      for (var m1 = 0; m1 < mutations.length; m1++) {
	        var mutation = mutations[m1];
	        for (var m2 = 0; m2 < mutation.removedNodes.length; m2++) {
	          var element = mutation.removedNodes[m2];
	          if (element === _this.state.currentTarget) {
	            _this.hideTooltip();
	            return;
	          }
	        }
	      }
	    });
	
	    observer.observe(window.document, { childList: true, subtree: true });
	
	    this.removalTracker = observer;
	  };
	
	  target.prototype.unbindRemovalTracker = function () {
	    if (this.removalTracker) {
	      this.removalTracker.disconnect();
	      this.removalTracker = null;
	    }
	  };
	};
	
	/**
	 * Tracking target removing from DOM.
	 * It's necessary to hide tooltip when it's target disappears.
	 * Otherwise, the tooltip would be shown forever until another target
	 * is triggered.
	 *
	 * If MutationObserver is not available, this feature just doesn't work.
	 */
	
	// https://hacks.mozilla.org/2012/05/dom-mutationobserver-reacting-to-dom-changes-without-killing-browser-performance/
	var getMutationObserverClass = function getMutationObserverClass() {
	  return window.MutationObserver || window.WebKitMutationObserver || window.MozMutationObserver;
	};

/***/ },
/* 587 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (target) {
	  target.prototype.bindWindowEvents = function (resizeHide) {
	    // ReactTooltip.hide
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.addEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide, false);
	
	    // ReactTooltip.rebuild
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.addEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild, false);
	
	    // ReactTooltip.show
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.addEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow, false);
	
	    // Resize
	    if (resizeHide) {
	      window.removeEventListener('resize', this.onWindowResize);
	      window.addEventListener('resize', this.onWindowResize, false);
	    }
	  };
	
	  target.prototype.unbindWindowEvents = function () {
	    window.removeEventListener(_constant2.default.GLOBAL.HIDE, this.globalHide);
	    window.removeEventListener(_constant2.default.GLOBAL.REBUILD, this.globalRebuild);
	    window.removeEventListener(_constant2.default.GLOBAL.SHOW, this.globalShow);
	    window.removeEventListener('resize', this.onWindowResize);
	  };
	
	  /**
	   * invoked by resize event of window
	   */
	  target.prototype.onWindowResize = function () {
	    if (!this.mount) return;
	    this.hideTooltip();
	  };
	};
	
	var _constant = __webpack_require__(185);
	
	var _constant2 = _interopRequireDefault(_constant);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 588 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.default = '.__react_component_tooltip{border-radius:3px;display:inline-block;font-size:13px;left:-999em;opacity:0;padding:8px 21px;position:fixed;pointer-events:none;transition:opacity 0.3s ease-out;top:-999em;visibility:hidden;z-index:999}.__react_component_tooltip.allow_hover,.__react_component_tooltip.allow_click{pointer-events:auto}.__react_component_tooltip:before,.__react_component_tooltip:after{content:"";width:0;height:0;position:absolute}.__react_component_tooltip.show{opacity:0.9;margin-top:0px;margin-left:0px;visibility:visible}.__react_component_tooltip.type-dark{color:#fff;background-color:#222}.__react_component_tooltip.type-dark.place-top:after{border-top-color:#222;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-dark.place-bottom:after{border-bottom-color:#222;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-dark.place-left:after{border-left-color:#222;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-dark.place-right:after{border-right-color:#222;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-dark.border{border:1px solid #fff}.__react_component_tooltip.type-dark.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-dark.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-dark.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-dark.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-success{color:#fff;background-color:#8DC572}.__react_component_tooltip.type-success.place-top:after{border-top-color:#8DC572;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-success.place-bottom:after{border-bottom-color:#8DC572;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-success.place-left:after{border-left-color:#8DC572;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-success.place-right:after{border-right-color:#8DC572;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-success.border{border:1px solid #fff}.__react_component_tooltip.type-success.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-success.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-success.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-success.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-warning{color:#fff;background-color:#F0AD4E}.__react_component_tooltip.type-warning.place-top:after{border-top-color:#F0AD4E;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-warning.place-bottom:after{border-bottom-color:#F0AD4E;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-warning.place-left:after{border-left-color:#F0AD4E;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-warning.place-right:after{border-right-color:#F0AD4E;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-warning.border{border:1px solid #fff}.__react_component_tooltip.type-warning.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-warning.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-warning.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-warning.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-error{color:#fff;background-color:#BE6464}.__react_component_tooltip.type-error.place-top:after{border-top-color:#BE6464;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-error.place-bottom:after{border-bottom-color:#BE6464;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-error.place-left:after{border-left-color:#BE6464;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-error.place-right:after{border-right-color:#BE6464;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-error.border{border:1px solid #fff}.__react_component_tooltip.type-error.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-error.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-error.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-error.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-info{color:#fff;background-color:#337AB7}.__react_component_tooltip.type-info.place-top:after{border-top-color:#337AB7;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-info.place-bottom:after{border-bottom-color:#337AB7;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-info.place-left:after{border-left-color:#337AB7;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-info.place-right:after{border-right-color:#337AB7;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-info.border{border:1px solid #fff}.__react_component_tooltip.type-info.border.place-top:before{border-top:8px solid #fff}.__react_component_tooltip.type-info.border.place-bottom:before{border-bottom:8px solid #fff}.__react_component_tooltip.type-info.border.place-left:before{border-left:8px solid #fff}.__react_component_tooltip.type-info.border.place-right:before{border-right:8px solid #fff}.__react_component_tooltip.type-light{color:#222;background-color:#fff}.__react_component_tooltip.type-light.place-top:after{border-top-color:#fff;border-top-style:solid;border-top-width:6px}.__react_component_tooltip.type-light.place-bottom:after{border-bottom-color:#fff;border-bottom-style:solid;border-bottom-width:6px}.__react_component_tooltip.type-light.place-left:after{border-left-color:#fff;border-left-style:solid;border-left-width:6px}.__react_component_tooltip.type-light.place-right:after{border-right-color:#fff;border-right-style:solid;border-right-width:6px}.__react_component_tooltip.type-light.border{border:1px solid #222}.__react_component_tooltip.type-light.border.place-top:before{border-top:8px solid #222}.__react_component_tooltip.type-light.border.place-bottom:before{border-bottom:8px solid #222}.__react_component_tooltip.type-light.border.place-left:before{border-left:8px solid #222}.__react_component_tooltip.type-light.border.place-right:before{border-right:8px solid #222}.__react_component_tooltip.place-top{margin-top:-10px}.__react_component_tooltip.place-top:before{border-left:10px solid transparent;border-right:10px solid transparent;bottom:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-top:after{border-left:8px solid transparent;border-right:8px solid transparent;bottom:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-bottom{margin-top:10px}.__react_component_tooltip.place-bottom:before{border-left:10px solid transparent;border-right:10px solid transparent;top:-8px;left:50%;margin-left:-10px}.__react_component_tooltip.place-bottom:after{border-left:8px solid transparent;border-right:8px solid transparent;top:-6px;left:50%;margin-left:-8px}.__react_component_tooltip.place-left{margin-left:-10px}.__react_component_tooltip.place-left:before{border-top:6px solid transparent;border-bottom:6px solid transparent;right:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-left:after{border-top:5px solid transparent;border-bottom:5px solid transparent;right:-6px;top:50%;margin-top:-4px}.__react_component_tooltip.place-right{margin-left:10px}.__react_component_tooltip.place-right:before{border-top:6px solid transparent;border-bottom:6px solid transparent;left:-8px;top:50%;margin-top:-5px}.__react_component_tooltip.place-right:after{border-top:5px solid transparent;border-bottom:5px solid transparent;left:-6px;top:50%;margin-top:-4px}.__react_component_tooltip .multi-line{display:block;padding:2px 0px;text-align:center}';

/***/ },
/* 589 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	exports.parseAria = parseAria;
	/**
	 * Support aria- and role in ReactTooltip
	 *
	 * @params props {Object}
	 * @return {Object}
	 */
	function parseAria(props) {
	  var ariaObj = {};
	  Object.keys(props).filter(function (prop) {
	    // aria-xxx and role is acceptable
	    return (/(^aria-\w+$|^role$)/.test(prop)
	    );
	  }).forEach(function (prop) {
	    ariaObj[prop] = props[prop];
	  });
	
	  return ariaObj;
	}

/***/ },
/* 590 */
/***/ function(module, exports) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (e, target, node, place, desiredPlace, effect, offset) {
	  var _getDimensions = getDimensions(node),
	      tipWidth = _getDimensions.width,
	      tipHeight = _getDimensions.height;
	
	  var _getDimensions2 = getDimensions(target),
	      targetWidth = _getDimensions2.width,
	      targetHeight = _getDimensions2.height;
	
	  var _getCurrentOffset = getCurrentOffset(e, target, effect),
	      mouseX = _getCurrentOffset.mouseX,
	      mouseY = _getCurrentOffset.mouseY;
	
	  var defaultOffset = getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight);
	
	  var _calculateOffset = calculateOffset(offset),
	      extraOffset_X = _calculateOffset.extraOffset_X,
	      extraOffset_Y = _calculateOffset.extraOffset_Y;
	
	  var windowWidth = window.innerWidth;
	  var windowHeight = window.innerHeight;
	
	  var _getParent = getParent(node),
	      parentTop = _getParent.parentTop,
	      parentLeft = _getParent.parentLeft;
	
	  // Get the edge offset of the tooltip
	
	
	  var getTipOffsetLeft = function getTipOffsetLeft(place) {
	    var offset_X = defaultOffset[place].l;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetRight = function getTipOffsetRight(place) {
	    var offset_X = defaultOffset[place].r;
	    return mouseX + offset_X + extraOffset_X;
	  };
	  var getTipOffsetTop = function getTipOffsetTop(place) {
	    var offset_Y = defaultOffset[place].t;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	  var getTipOffsetBottom = function getTipOffsetBottom(place) {
	    var offset_Y = defaultOffset[place].b;
	    return mouseY + offset_Y + extraOffset_Y;
	  };
	
	  //
	  // Functions to test whether the tooltip's sides are inside
	  // the client window for a given orientation p
	  //
	  //  _____________
	  // |             | <-- Right side
	  // | p = 'left'  |\
	  // |             |/  |\
	  // |_____________|   |_\  <-- Mouse
	  //      / \           |
	  //       |
	  //       |
	  //  Bottom side
	  //
	  var outsideLeft = function outsideLeft(p) {
	    return getTipOffsetLeft(p) < 0;
	  };
	  var outsideRight = function outsideRight(p) {
	    return getTipOffsetRight(p) > windowWidth;
	  };
	  var outsideTop = function outsideTop(p) {
	    return getTipOffsetTop(p) < 0;
	  };
	  var outsideBottom = function outsideBottom(p) {
	    return getTipOffsetBottom(p) > windowHeight;
	  };
	
	  // Check whether the tooltip with orientation p is completely inside the client window
	  var outside = function outside(p) {
	    return outsideLeft(p) || outsideRight(p) || outsideTop(p) || outsideBottom(p);
	  };
	  var inside = function inside(p) {
	    return !outside(p);
	  };
	
	  var placesList = ['top', 'bottom', 'left', 'right'];
	  var insideList = [];
	  for (var i = 0; i < 4; i++) {
	    var p = placesList[i];
	    if (inside(p)) {
	      insideList.push(p);
	    }
	  }
	
	  var isNewState = false;
	  var newPlace = void 0;
	  var shouldUpdatePlace = desiredPlace !== place;
	  if (inside(desiredPlace) && shouldUpdatePlace) {
	    isNewState = true;
	    newPlace = desiredPlace;
	  } else if (insideList.length > 0 && shouldUpdatePlace && outside(desiredPlace) && outside(place)) {
	    isNewState = true;
	    newPlace = insideList[0];
	  }
	
	  if (isNewState) {
	    return {
	      isNewState: true,
	      newState: { place: newPlace }
	    };
	  }
	
	  return {
	    isNewState: false,
	    position: {
	      left: parseInt(getTipOffsetLeft(place) - parentLeft, 10),
	      top: parseInt(getTipOffsetTop(place) - parentTop, 10)
	    }
	  };
	};
	
	var getDimensions = function getDimensions(node) {
	  var _node$getBoundingClie = node.getBoundingClientRect(),
	      height = _node$getBoundingClie.height,
	      width = _node$getBoundingClie.width;
	
	  return {
	    height: parseInt(height, 10),
	    width: parseInt(width, 10)
	  };
	};
	
	// Get current mouse offset
	/**
	 * Calculate the position of tooltip
	 *
	 * @params
	 * - `e` {Event} the event of current mouse
	 * - `target` {Element} the currentTarget of the event
	 * - `node` {DOM} the react-tooltip object
	 * - `place` {String} top / right / bottom / left
	 * - `effect` {String} float / solid
	 * - `offset` {Object} the offset to default position
	 *
	 * @return {Object}
	 * - `isNewState` {Bool} required
	 * - `newState` {Object}
	 * - `position` {Object} {left: {Number}, top: {Number}}
	 */
	var getCurrentOffset = function getCurrentOffset(e, currentTarget, effect) {
	  var boundingClientRect = currentTarget.getBoundingClientRect();
	  var targetTop = boundingClientRect.top;
	  var targetLeft = boundingClientRect.left;
	
	  var _getDimensions3 = getDimensions(currentTarget),
	      targetWidth = _getDimensions3.width,
	      targetHeight = _getDimensions3.height;
	
	  if (effect === 'float') {
	    return {
	      mouseX: e.clientX,
	      mouseY: e.clientY
	    };
	  }
	  return {
	    mouseX: targetLeft + targetWidth / 2,
	    mouseY: targetTop + targetHeight / 2
	  };
	};
	
	// List all possibility of tooltip final offset
	// This is useful in judging if it is necessary for tooltip to switch position when out of window
	var getDefaultPosition = function getDefaultPosition(effect, targetWidth, targetHeight, tipWidth, tipHeight) {
	  var top = void 0;
	  var right = void 0;
	  var bottom = void 0;
	  var left = void 0;
	  var disToMouse = 3;
	  var triangleHeight = 2;
	  var cursorHeight = 12; // Optimize for float bottom only, cause the cursor will hide the tooltip
	
	  if (effect === 'float') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(tipHeight + disToMouse + triangleHeight),
	      b: -disToMouse
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: disToMouse + cursorHeight,
	      b: tipHeight + disToMouse + triangleHeight + cursorHeight
	    };
	    left = {
	      l: -(tipWidth + disToMouse + triangleHeight),
	      r: -disToMouse,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: disToMouse,
	      r: tipWidth + disToMouse + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  } else if (effect === 'solid') {
	    top = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: -(targetHeight / 2 + tipHeight + triangleHeight),
	      b: -(targetHeight / 2)
	    };
	    bottom = {
	      l: -(tipWidth / 2),
	      r: tipWidth / 2,
	      t: targetHeight / 2,
	      b: targetHeight / 2 + tipHeight + triangleHeight
	    };
	    left = {
	      l: -(tipWidth + targetWidth / 2 + triangleHeight),
	      r: -(targetWidth / 2),
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	    right = {
	      l: targetWidth / 2,
	      r: tipWidth + targetWidth / 2 + triangleHeight,
	      t: -(tipHeight / 2),
	      b: tipHeight / 2
	    };
	  }
	
	  return { top: top, bottom: bottom, left: left, right: right };
	};
	
	// Consider additional offset into position calculation
	var calculateOffset = function calculateOffset(offset) {
	  var extraOffset_X = 0;
	  var extraOffset_Y = 0;
	
	  if (Object.prototype.toString.apply(offset) === '[object String]') {
	    offset = JSON.parse(offset.toString().replace(/\'/g, '\"'));
	  }
	  for (var key in offset) {
	    if (key === 'top') {
	      extraOffset_Y -= parseInt(offset[key], 10);
	    } else if (key === 'bottom') {
	      extraOffset_Y += parseInt(offset[key], 10);
	    } else if (key === 'left') {
	      extraOffset_X -= parseInt(offset[key], 10);
	    } else if (key === 'right') {
	      extraOffset_X += parseInt(offset[key], 10);
	    }
	  }
	
	  return { extraOffset_X: extraOffset_X, extraOffset_Y: extraOffset_Y };
	};
	
	// Get the offset of the parent elements
	var getParent = function getParent(currentTarget) {
	  var currentParent = currentTarget;
	  while (currentParent) {
	    if (window.getComputedStyle(currentParent).getPropertyValue('transform') !== 'none') break;
	    currentParent = currentParent.parentElement;
	  }
	
	  var parentTop = currentParent && currentParent.getBoundingClientRect().top || 0;
	  var parentLeft = currentParent && currentParent.getBoundingClientRect().left || 0;
	
	  return { parentTop: parentTop, parentLeft: parentLeft };
	};

/***/ },
/* 591 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (tip, children, getContent, multiline) {
	  if (children) return children;
	  if (getContent !== undefined && getContent !== null) return getContent; // getContent can be 0, '', etc.
	  if (getContent === null) return null; // Tip not exist and children is null or undefined
	
	  var regexp = /<br\s*\/?>/;
	  if (!multiline || multiline === 'false' || !regexp.test(tip)) {
	    // No trim(), so that user can keep their input
	    return tip;
	  }
	
	  // Multiline tooltip content
	  return tip.split(regexp).map(function (d, i) {
	    return _react2.default.createElement(
	      'span',
	      { key: i, className: 'multi-line' },
	      d
	    );
	  });
	};
	
	var _react = __webpack_require__(2);
	
	var _react2 = _interopRequireDefault(_react);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

/***/ },
/* 592 */
/***/ function(module, exports) {

	"use strict";
	
	Object.defineProperty(exports, "__esModule", {
	  value: true
	});
	
	exports.default = function (nodeList) {
	  var length = nodeList.length;
	  if (nodeList.hasOwnProperty) {
	    return Array.prototype.slice.call(nodeList);
	  }
	  return new Array(length).fill().map(function (index) {
	    return nodeList[index];
	  });
	};

/***/ },
/* 593 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _addClass2 = _interopRequireDefault(__webpack_require__(518));
	
	var _removeClass = _interopRequireDefault(__webpack_require__(520));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _Transition = _interopRequireDefault(__webpack_require__(102));
	
	var _PropTypes = __webpack_require__(189);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	var _addClass = function addClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _addClass2.default)(node, c);
	  });
	};
	
	var removeClass = function removeClass(node, classes) {
	  return node && classes && classes.split(' ').forEach(function (c) {
	    return (0, _removeClass.default)(node, c);
	  });
	};
	/**
	 * A transition component inspired by the excellent
	 * [ng-animate](http://www.nganimate.org/) library, you should use it if you're
	 * using CSS transitions or animations. It's built upon the
	 * [`Transition`](https://reactcommunity.org/react-transition-group/transition)
	 * component, so it inherits all of its props.
	 *
	 * `CSSTransition` applies a pair of class names during the `appear`, `enter`,
	 * and `exit` states of the transition. The first class is applied and then a
	 * second `*-active` class in order to activate the CSS transition. After the
	 * transition, matching `*-done` class names are applied to persist the
	 * transition state.
	 *
	 * ```jsx
	 * function App() {
	 *   const [inProp, setInProp] = useState(false);
	 *   return (
	 *     <div>
	 *       <CSSTransition in={inProp} timeout={200} classNames="my-node">
	 *         <div>
	 *           {"I'll receive my-node-* classes"}
	 *         </div>
	 *       </CSSTransition>
	 *       <button type="button" onClick={() => setInProp(true)}>
	 *         Click to Enter
	 *       </button>
	 *     </div>
	 *   );
	 * }
	 * ```
	 *
	 * When the `in` prop is set to `true`, the child component will first receive
	 * the class `example-enter`, then the `example-enter-active` will be added in
	 * the next tick. `CSSTransition` [forces a
	 * reflow](https://github.com/reactjs/react-transition-group/blob/5007303e729a74be66a21c3e2205e4916821524b/src/CSSTransition.js#L208-L215)
	 * between before adding the `example-enter-active`. This is an important trick
	 * because it allows us to transition between `example-enter` and
	 * `example-enter-active` even though they were added immediately one after
	 * another. Most notably, this is what makes it possible for us to animate
	 * _appearance_.
	 *
	 * ```css
	 * .my-node-enter {
	 *   opacity: 0;
	 * }
	 * .my-node-enter-active {
	 *   opacity: 1;
	 *   transition: opacity 200ms;
	 * }
	 * .my-node-exit {
	 *   opacity: 1;
	 * }
	 * .my-node-exit-active {
	 *   opacity: 0;
	 *   transition: opacity 200ms;
	 * }
	 * ```
	 *
	 * `*-active` classes represent which styles you want to animate **to**.
	 *
	 * **Note**: If you're using the
	 * [`appear`](http://reactcommunity.org/react-transition-group/transition#Transition-prop-appear)
	 * prop, make sure to define styles for `.appear-*` classes as well.
	 */
	
	
	var CSSTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(CSSTransition, _React$Component);
	
	  function CSSTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.appliedClasses = {
	      appear: {},
	      enter: {},
	      exit: {}
	    };
	
	    _this.onEnter = function (node, appearing) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, appearing ? 'appear' : 'enter', 'base');
	
	      if (_this.props.onEnter) {
	        _this.props.onEnter(node, appearing);
	      }
	    };
	
	    _this.onEntering = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.addClass(node, type, 'active');
	
	      if (_this.props.onEntering) {
	        _this.props.onEntering(node, appearing);
	      }
	    };
	
	    _this.onEntered = function (node, appearing) {
	      var type = appearing ? 'appear' : 'enter';
	
	      _this.removeClasses(node, type);
	
	      _this.addClass(node, type, 'done');
	
	      if (_this.props.onEntered) {
	        _this.props.onEntered(node, appearing);
	      }
	    };
	
	    _this.onExit = function (node) {
	      _this.removeClasses(node, 'appear');
	
	      _this.removeClasses(node, 'enter');
	
	      _this.addClass(node, 'exit', 'base');
	
	      if (_this.props.onExit) {
	        _this.props.onExit(node);
	      }
	    };
	
	    _this.onExiting = function (node) {
	      _this.addClass(node, 'exit', 'active');
	
	      if (_this.props.onExiting) {
	        _this.props.onExiting(node);
	      }
	    };
	
	    _this.onExited = function (node) {
	      _this.removeClasses(node, 'exit');
	
	      _this.addClass(node, 'exit', 'done');
	
	      if (_this.props.onExited) {
	        _this.props.onExited(node);
	      }
	    };
	
	    _this.getClassNames = function (type) {
	      var classNames = _this.props.classNames;
	      var isStringClassNames = typeof classNames === 'string';
	      var prefix = isStringClassNames && classNames ? classNames + "-" : '';
	      var baseClassName = isStringClassNames ? "" + prefix + type : classNames[type];
	      var activeClassName = isStringClassNames ? baseClassName + "-active" : classNames[type + "Active"];
	      var doneClassName = isStringClassNames ? baseClassName + "-done" : classNames[type + "Done"];
	      return {
	        baseClassName: baseClassName,
	        activeClassName: activeClassName,
	        doneClassName: doneClassName
	      };
	    };
	
	    return _this;
	  }
	
	  var _proto = CSSTransition.prototype;
	
	  _proto.addClass = function addClass(node, type, phase) {
	    var className = this.getClassNames(type)[phase + "ClassName"];
	
	    if (type === 'appear' && phase === 'done') {
	      className += " " + this.getClassNames('enter').doneClassName;
	    } // This is for to force a repaint,
	    // which is necessary in order to transition styles when adding a class name.
	
	
	    if (phase === 'active') {
	      /* eslint-disable no-unused-expressions */
	      node && node.scrollTop;
	    }
	
	    this.appliedClasses[type][phase] = className;
	
	    _addClass(node, className);
	  };
	
	  _proto.removeClasses = function removeClasses(node, type) {
	    var _this$appliedClasses$ = this.appliedClasses[type],
	        baseClassName = _this$appliedClasses$.base,
	        activeClassName = _this$appliedClasses$.active,
	        doneClassName = _this$appliedClasses$.done;
	    this.appliedClasses[type] = {};
	
	    if (baseClassName) {
	      removeClass(node, baseClassName);
	    }
	
	    if (activeClassName) {
	      removeClass(node, activeClassName);
	    }
	
	    if (doneClassName) {
	      removeClass(node, doneClassName);
	    }
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        _ = _this$props.classNames,
	        props = _objectWithoutPropertiesLoose(_this$props, ["classNames"]);
	
	    return _react.default.createElement(_Transition.default, _extends({}, props, {
	      onEnter: this.onEnter,
	      onEntered: this.onEntered,
	      onEntering: this.onEntering,
	      onExit: this.onExit,
	      onExiting: this.onExiting,
	      onExited: this.onExited
	    }));
	  };
	
	  return CSSTransition;
	}(_react.default.Component);
	
	CSSTransition.defaultProps = {
	  classNames: ''
	};
	CSSTransition.propTypes =  false ? _extends({}, _Transition.default.propTypes, {
	  /**
	   * The animation classNames applied to the component as it appears, enters,
	   * exits or has finished the transition. A single name can be provided and it
	   * will be suffixed for each stage: e.g.
	   *
	   * `classNames="fade"` applies `fade-appear`, `fade-appear-active`,
	   * `fade-appear-done`, `fade-enter`, `fade-enter-active`, `fade-enter-done`,
	   * `fade-exit`, `fade-exit-active`, and `fade-exit-done`.
	   *
	   * **Note**: `fade-appear-done` and `fade-enter-done` will _both_ be applied.
	   * This allows you to define different behavior for when appearing is done and
	   * when regular entering is done, using selectors like
	   * `.fade-enter-done:not(.fade-appear-done)`. For example, you could apply an
	   * epic entrance animation when element first appears in the DOM using
	   * [Animate.css](https://daneden.github.io/animate.css/). Otherwise you can
	   * simply use `fade-enter-done` for defining both cases.
	   *
	   * Each individual classNames can also be specified independently like:
	   *
	   * ```js
	   * classNames={{
	   *  appear: 'my-appear',
	   *  appearActive: 'my-active-appear',
	   *  appearDone: 'my-done-appear',
	   *  enter: 'my-enter',
	   *  enterActive: 'my-active-enter',
	   *  enterDone: 'my-done-enter',
	   *  exit: 'my-exit',
	   *  exitActive: 'my-active-exit',
	   *  exitDone: 'my-done-exit',
	   * }}
	   * ```
	   *
	   * If you want to set these classes using CSS Modules:
	   *
	   * ```js
	   * import styles from './styles.css';
	   * ```
	   *
	   * you might want to use camelCase in your CSS file, that way could simply
	   * spread them instead of listing them one by one:
	   *
	   * ```js
	   * classNames={{ ...styles }}
	   * ```
	   *
	   * @type {string | {
	   *  appear?: string,
	   *  appearActive?: string,
	   *  appearDone?: string,
	   *  enter?: string,
	   *  enterActive?: string,
	   *  enterDone?: string,
	   *  exit?: string,
	   *  exitActive?: string,
	   *  exitDone?: string,
	   * }}
	   */
	  classNames: _PropTypes.classNamesShape,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or 'appear' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEnter: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter-active' or
	   * 'appear-active' class is applied.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntering: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'enter' or
	   * 'appear' classes are **removed** and the `done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement, isAppearing: bool)
	   */
	  onEntered: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' class is
	   * applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExit: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit-active' is applied.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExiting: _propTypes.default.func,
	
	  /**
	   * A `<Transition>` callback fired immediately after the 'exit' classes
	   * are **removed** and the `exit-done` class is added to the DOM node.
	   *
	   * @type Function(node: HtmlElement)
	   */
	  onExited: _propTypes.default.func
	}) : {};
	var _default = CSSTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 594 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = void 0;
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _reactDom = _interopRequireDefault(__webpack_require__(16));
	
	var _TransitionGroup = _interopRequireDefault(__webpack_require__(187));
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	/**
	 * The `<ReplaceTransition>` component is a specialized `Transition` component
	 * that animates between two children.
	 *
	 * ```jsx
	 * <ReplaceTransition in>
	 *   <Fade><div>I appear first</div></Fade>
	 *   <Fade><div>I replace the above</div></Fade>
	 * </ReplaceTransition>
	 * ```
	 */
	var ReplaceTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(ReplaceTransition, _React$Component);
	
	  function ReplaceTransition() {
	    var _this;
	
	    for (var _len = arguments.length, _args = new Array(_len), _key = 0; _key < _len; _key++) {
	      _args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(_args)) || this;
	
	    _this.handleEnter = function () {
	      for (var _len2 = arguments.length, args = new Array(_len2), _key2 = 0; _key2 < _len2; _key2++) {
	        args[_key2] = arguments[_key2];
	      }
	
	      return _this.handleLifecycle('onEnter', 0, args);
	    };
	
	    _this.handleEntering = function () {
	      for (var _len3 = arguments.length, args = new Array(_len3), _key3 = 0; _key3 < _len3; _key3++) {
	        args[_key3] = arguments[_key3];
	      }
	
	      return _this.handleLifecycle('onEntering', 0, args);
	    };
	
	    _this.handleEntered = function () {
	      for (var _len4 = arguments.length, args = new Array(_len4), _key4 = 0; _key4 < _len4; _key4++) {
	        args[_key4] = arguments[_key4];
	      }
	
	      return _this.handleLifecycle('onEntered', 0, args);
	    };
	
	    _this.handleExit = function () {
	      for (var _len5 = arguments.length, args = new Array(_len5), _key5 = 0; _key5 < _len5; _key5++) {
	        args[_key5] = arguments[_key5];
	      }
	
	      return _this.handleLifecycle('onExit', 1, args);
	    };
	
	    _this.handleExiting = function () {
	      for (var _len6 = arguments.length, args = new Array(_len6), _key6 = 0; _key6 < _len6; _key6++) {
	        args[_key6] = arguments[_key6];
	      }
	
	      return _this.handleLifecycle('onExiting', 1, args);
	    };
	
	    _this.handleExited = function () {
	      for (var _len7 = arguments.length, args = new Array(_len7), _key7 = 0; _key7 < _len7; _key7++) {
	        args[_key7] = arguments[_key7];
	      }
	
	      return _this.handleLifecycle('onExited', 1, args);
	    };
	
	    return _this;
	  }
	
	  var _proto = ReplaceTransition.prototype;
	
	  _proto.handleLifecycle = function handleLifecycle(handler, idx, originalArgs) {
	    var _child$props;
	
	    var children = this.props.children;
	
	    var child = _react.default.Children.toArray(children)[idx];
	
	    if (child.props[handler]) (_child$props = child.props)[handler].apply(_child$props, originalArgs);
	    if (this.props[handler]) this.props[handler](_reactDom.default.findDOMNode(this));
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        inProp = _this$props.in,
	        props = _objectWithoutPropertiesLoose(_this$props, ["children", "in"]);
	
	    var _React$Children$toArr = _react.default.Children.toArray(children),
	        first = _React$Children$toArr[0],
	        second = _React$Children$toArr[1];
	
	    delete props.onEnter;
	    delete props.onEntering;
	    delete props.onEntered;
	    delete props.onExit;
	    delete props.onExiting;
	    delete props.onExited;
	    return _react.default.createElement(_TransitionGroup.default, props, inProp ? _react.default.cloneElement(first, {
	      key: 'first',
	      onEnter: this.handleEnter,
	      onEntering: this.handleEntering,
	      onEntered: this.handleEntered
	    }) : _react.default.cloneElement(second, {
	      key: 'second',
	      onEnter: this.handleExit,
	      onEntering: this.handleExiting,
	      onEntered: this.handleExited
	    }));
	  };
	
	  return ReplaceTransition;
	}(_react.default.Component);
	
	ReplaceTransition.propTypes =  false ? {
	  in: _propTypes.default.bool.isRequired,
	  children: function children(props, propName) {
	    if (_react.default.Children.count(props[propName]) !== 2) return new Error("\"" + propName + "\" must be exactly two transition components.");
	    return null;
	  }
	} : {};
	var _default = ReplaceTransition;
	exports.default = _default;
	module.exports = exports["default"];

/***/ },
/* 595 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.default = exports.modes = void 0;
	
	var _react = _interopRequireDefault(__webpack_require__(2));
	
	var _propTypes = _interopRequireDefault(__webpack_require__(4));
	
	var _Transition = __webpack_require__(102);
	
	var _TransitionGroupContext = _interopRequireDefault(__webpack_require__(103));
	
	var _leaveRenders, _enterRenders;
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	function _inheritsLoose(subClass, superClass) { subClass.prototype = Object.create(superClass.prototype); subClass.prototype.constructor = subClass; subClass.__proto__ = superClass; }
	
	function areChildrenDifferent(oldChildren, newChildren) {
	  if (oldChildren === newChildren) return false;
	
	  if (_react.default.isValidElement(oldChildren) && _react.default.isValidElement(newChildren) && oldChildren.key != null && oldChildren.key === newChildren.key) {
	    return false;
	  }
	
	  return true;
	}
	/**
	 * Enum of modes for SwitchTransition component
	 * @enum { string }
	 */
	
	
	var modes = {
	  out: 'out-in',
	  in: 'in-out'
	};
	exports.modes = modes;
	
	var callHook = function callHook(element, name, cb) {
	  return function () {
	    var _element$props;
	
	    element.props[name] && (_element$props = element.props)[name].apply(_element$props, arguments);
	    cb();
	  };
	};
	
	var leaveRenders = (_leaveRenders = {}, _leaveRenders[modes.out] = function (_ref) {
	  var current = _ref.current,
	      changeState = _ref.changeState;
	  return _react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERING, null);
	    })
	  });
	}, _leaveRenders[modes.in] = function (_ref2) {
	  var current = _ref2.current,
	      changeState = _ref2.changeState,
	      children = _ref2.children;
	  return [current, _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERING);
	    })
	  })];
	}, _leaveRenders);
	var enterRenders = (_enterRenders = {}, _enterRenders[modes.out] = function (_ref3) {
	  var children = _ref3.children,
	      changeState = _ref3.changeState;
	  return _react.default.cloneElement(children, {
	    in: true,
	    onEntered: callHook(children, 'onEntered', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  });
	}, _enterRenders[modes.in] = function (_ref4) {
	  var current = _ref4.current,
	      children = _ref4.children,
	      changeState = _ref4.changeState;
	  return [_react.default.cloneElement(current, {
	    in: false,
	    onExited: callHook(current, 'onExited', function () {
	      changeState(_Transition.ENTERED, _react.default.cloneElement(children, {
	        in: true
	      }));
	    })
	  }), _react.default.cloneElement(children, {
	    in: true
	  })];
	}, _enterRenders);
	/**
	 * A transition component inspired by the [vue transition modes](https://vuejs.org/v2/guide/transitions.html#Transition-Modes).
	 * You can use it when you want to control the render between state transitions.
	 * Based on the selected mode and the child's key which is the `Transition` or `CSSTransition` component, the `SwitchTransition` makes a consistent transition between them.
	 *
	 * If the `out-in` mode is selected, the `SwitchTransition` waits until the old child leaves and then inserts a new child.
	 * If the `in-out` mode is selected, the `SwitchTransition` inserts a new child first, waits for the new child to enter and then removes the old child
	 *
	 * ```jsx
	 *
	 * function App() {
	 *  const [state, setState] = useState(false);
	 *  return (
	 *    <SwitchTransition>
	 *      <FadeTransition key={state ? "Goodbye, world!" : "Hello, world!"}
	 *        addEndListener={(node, done) => node.addEventListener("transitionend", done, false)}
	 *        classNames='fade' >
	 *        <button onClick={() => setState(state => !state)}>
	 *          {state ? "Goodbye, world!" : "Hello, world!"}
	 *        </button>
	 *      </FadeTransition>
	 *    </SwitchTransition>
	 *  )
	 * }
	 * ```
	 */
	
	var SwitchTransition =
	/*#__PURE__*/
	function (_React$Component) {
	  _inheritsLoose(SwitchTransition, _React$Component);
	
	  function SwitchTransition() {
	    var _this;
	
	    for (var _len = arguments.length, args = new Array(_len), _key = 0; _key < _len; _key++) {
	      args[_key] = arguments[_key];
	    }
	
	    _this = _React$Component.call.apply(_React$Component, [this].concat(args)) || this;
	    _this.state = {
	      status: _Transition.ENTERED,
	      current: null
	    };
	    _this.appeared = false;
	
	    _this.changeState = function (status, current) {
	      if (current === void 0) {
	        current = _this.state.current;
	      }
	
	      _this.setState({
	        status: status,
	        current: current
	      });
	    };
	
	    return _this;
	  }
	
	  var _proto = SwitchTransition.prototype;
	
	  _proto.componentDidMount = function componentDidMount() {
	    this.appeared = true;
	  };
	
	  SwitchTransition.getDerivedStateFromProps = function getDerivedStateFromProps(props, state) {
	    if (props.children == null) {
	      return {
	        current: null
	      };
	    }
	
	    if (state.status === _Transition.ENTERING && props.mode === modes.in) {
	      return {
	        status: _Transition.ENTERING
	      };
	    }
	
	    if (state.current && areChildrenDifferent(state.current, props.children)) {
	      return {
	        status: _Transition.EXITING
	      };
	    }
	
	    return {
	      current: _react.default.cloneElement(props.children, {
	        in: true
	      })
	    };
	  };
	
	  _proto.render = function render() {
	    var _this$props = this.props,
	        children = _this$props.children,
	        mode = _this$props.mode,
	        _this$state = this.state,
	        status = _this$state.status,
	        current = _this$state.current;
	    var data = {
	      children: children,
	      current: current,
	      changeState: this.changeState,
	      status: status
	    };
	    var component;
	
	    switch (status) {
	      case _Transition.ENTERING:
	        component = enterRenders[mode](data);
	        break;
	
	      case _Transition.EXITING:
	        component = leaveRenders[mode](data);
	        break;
	
	      case _Transition.ENTERED:
	        component = current;
	    }
	
	    return _react.default.createElement(_TransitionGroupContext.default.Provider, {
	      value: {
	        isMounting: !this.appeared
	      }
	    }, component);
	  };
	
	  return SwitchTransition;
	}(_react.default.Component);
	
	SwitchTransition.propTypes =  false ? {
	  /**
	   * Transition modes.
	   * `out-in`: Current element transitions out first, then when complete, the new element transitions in.
	   * `in-out: New element transitions in first, then when complete, the current element transitions out.`
	   *
	   * @type {'out-in'|'in-out'}
	   */
	  mode: _propTypes.default.oneOf([modes.in, modes.out]),
	
	  /**
	   * Any `Transition` or `CSSTransition` component
	   */
	  children: _propTypes.default.oneOfType([_propTypes.default.element.isRequired])
	} : {};
	SwitchTransition.defaultProps = {
	  mode: modes.out
	};
	var _default = SwitchTransition;
	exports.default = _default;

/***/ },
/* 596 */
/***/ function(module, exports, __webpack_require__) {

	"use strict";
	
	exports.__esModule = true;
	exports.getChildMapping = getChildMapping;
	exports.mergeChildMappings = mergeChildMappings;
	exports.getInitialChildMapping = getInitialChildMapping;
	exports.getNextChildMapping = getNextChildMapping;
	
	var _react = __webpack_require__(2);
	
	/**
	 * Given `this.props.children`, return an object mapping key to child.
	 *
	 * @param {*} children `this.props.children`
	 * @return {object} Mapping of key to child
	 */
	function getChildMapping(children, mapFn) {
	  var mapper = function mapper(child) {
	    return mapFn && (0, _react.isValidElement)(child) ? mapFn(child) : child;
	  };
	
	  var result = Object.create(null);
	  if (children) _react.Children.map(children, function (c) {
	    return c;
	  }).forEach(function (child) {
	    // run the map function here instead so that the key is the computed one
	    result[child.key] = mapper(child);
	  });
	  return result;
	}
	/**
	 * When you're adding or removing children some may be added or removed in the
	 * same render pass. We want to show *both* since we want to simultaneously
	 * animate elements in and out. This function takes a previous set of keys
	 * and a new set of keys and merges them with its best guess of the correct
	 * ordering. In the future we may expose some of the utilities in
	 * ReactMultiChild to make this easy, but for now React itself does not
	 * directly have this concept of the union of prevChildren and nextChildren
	 * so we implement it here.
	 *
	 * @param {object} prev prev children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @param {object} next next children as returned from
	 * `ReactTransitionChildMapping.getChildMapping()`.
	 * @return {object} a key set that contains all keys in `prev` and all keys
	 * in `next` in a reasonable order.
	 */
	
	
	function mergeChildMappings(prev, next) {
	  prev = prev || {};
	  next = next || {};
	
	  function getValueForKey(key) {
	    return key in next ? next[key] : prev[key];
	  } // For each key of `next`, the list of keys to insert before that key in
	  // the combined list
	
	
	  var nextKeysPending = Object.create(null);
	  var pendingKeys = [];
	
	  for (var prevKey in prev) {
	    if (prevKey in next) {
	      if (pendingKeys.length) {
	        nextKeysPending[prevKey] = pendingKeys;
	        pendingKeys = [];
	      }
	    } else {
	      pendingKeys.push(prevKey);
	    }
	  }
	
	  var i;
	  var childMapping = {};
	
	  for (var nextKey in next) {
	    if (nextKeysPending[nextKey]) {
	      for (i = 0; i < nextKeysPending[nextKey].length; i++) {
	        var pendingNextKey = nextKeysPending[nextKey][i];
	        childMapping[nextKeysPending[nextKey][i]] = getValueForKey(pendingNextKey);
	      }
	    }
	
	    childMapping[nextKey] = getValueForKey(nextKey);
	  } // Finally, add the keys which didn't appear before any key in `next`
	
	
	  for (i = 0; i < pendingKeys.length; i++) {
	    childMapping[pendingKeys[i]] = getValueForKey(pendingKeys[i]);
	  }
	
	  return childMapping;
	}
	
	function getProp(child, prop, props) {
	  return props[prop] != null ? props[prop] : child.props[prop];
	}
	
	function getInitialChildMapping(props, onExited) {
	  return getChildMapping(props.children, function (child) {
	    return (0, _react.cloneElement)(child, {
	      onExited: onExited.bind(null, child),
	      in: true,
	      appear: getProp(child, 'appear', props),
	      enter: getProp(child, 'enter', props),
	      exit: getProp(child, 'exit', props)
	    });
	  });
	}
	
	function getNextChildMapping(nextProps, prevChildMapping, onExited) {
	  var nextChildMapping = getChildMapping(nextProps.children);
	  var children = mergeChildMappings(prevChildMapping, nextChildMapping);
	  Object.keys(children).forEach(function (key) {
	    var child = children[key];
	    if (!(0, _react.isValidElement)(child)) return;
	    var hasPrev = key in prevChildMapping;
	    var hasNext = key in nextChildMapping;
	    var prevChild = prevChildMapping[key];
	    var isLeaving = (0, _react.isValidElement)(prevChild) && !prevChild.props.in; // item is new (entering)
	
	    if (hasNext && (!hasPrev || isLeaving)) {
	      // console.log('entering', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: true,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    } else if (!hasNext && hasPrev && !isLeaving) {
	      // item is old (exiting)
	      // console.log('leaving', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        in: false
	      });
	    } else if (hasNext && hasPrev && (0, _react.isValidElement)(prevChild)) {
	      // item hasn't changed transition states
	      // copy over the last transition props;
	      // console.log('unchanged', key)
	      children[key] = (0, _react.cloneElement)(child, {
	        onExited: onExited.bind(null, child),
	        in: prevChild.props.in,
	        exit: getProp(child, 'exit', nextProps),
	        enter: getProp(child, 'enter', nextProps)
	      });
	    }
	  });
	  return children;
	}

/***/ },
/* 597 */
/***/ function(module, exports, __webpack_require__) {

	/** @license React v16.8.0
	 * react.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';var k=__webpack_require__(100),n="function"===typeof Symbol&&Symbol.for,p=n?Symbol.for("react.element"):60103,q=n?Symbol.for("react.portal"):60106,r=n?Symbol.for("react.fragment"):60107,t=n?Symbol.for("react.strict_mode"):60108,u=n?Symbol.for("react.profiler"):60114,v=n?Symbol.for("react.provider"):60109,w=n?Symbol.for("react.context"):60110,x=n?Symbol.for("react.concurrent_mode"):60111,y=n?Symbol.for("react.forward_ref"):60112,z=n?Symbol.for("react.suspense"):60113,aa=n?Symbol.for("react.memo"):
	60115,ba=n?Symbol.for("react.lazy"):60116,A="function"===typeof Symbol&&Symbol.iterator;function ca(a,b,d,c,e,g,h,f){if(!a){a=void 0;if(void 0===b)a=Error("Minified exception occurred; use the non-minified dev environment for the full error message and additional helpful warnings.");else{var l=[d,c,e,g,h,f],m=0;a=Error(b.replace(/%s/g,function(){return l[m++]}));a.name="Invariant Violation"}a.framesToPop=1;throw a;}}
	function B(a){for(var b=arguments.length-1,d="https://reactjs.org/docs/error-decoder.html?invariant="+a,c=0;c<b;c++)d+="&args[]="+encodeURIComponent(arguments[c+1]);ca(!1,"Minified React error #"+a+"; visit %s for the full message or use the non-minified dev environment for full errors and additional helpful warnings. ",d)}var C={isMounted:function(){return!1},enqueueForceUpdate:function(){},enqueueReplaceState:function(){},enqueueSetState:function(){}},D={};
	function E(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}E.prototype.isReactComponent={};E.prototype.setState=function(a,b){"object"!==typeof a&&"function"!==typeof a&&null!=a?B("85"):void 0;this.updater.enqueueSetState(this,a,b,"setState")};E.prototype.forceUpdate=function(a){this.updater.enqueueForceUpdate(this,a,"forceUpdate")};function F(){}F.prototype=E.prototype;function G(a,b,d){this.props=a;this.context=b;this.refs=D;this.updater=d||C}var H=G.prototype=new F;
	H.constructor=G;k(H,E.prototype);H.isPureReactComponent=!0;var I={current:null},J={current:null},K=Object.prototype.hasOwnProperty,L={key:!0,ref:!0,__self:!0,__source:!0};
	function M(a,b,d){var c=void 0,e={},g=null,h=null;if(null!=b)for(c in void 0!==b.ref&&(h=b.ref),void 0!==b.key&&(g=""+b.key),b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=b[c]);var f=arguments.length-2;if(1===f)e.children=d;else if(1<f){for(var l=Array(f),m=0;m<f;m++)l[m]=arguments[m+2];e.children=l}if(a&&a.defaultProps)for(c in f=a.defaultProps,f)void 0===e[c]&&(e[c]=f[c]);return{$$typeof:p,type:a,key:g,ref:h,props:e,_owner:J.current}}
	function da(a,b){return{$$typeof:p,type:a.type,key:b,ref:a.ref,props:a.props,_owner:a._owner}}function N(a){return"object"===typeof a&&null!==a&&a.$$typeof===p}function escape(a){var b={"=":"=0",":":"=2"};return"$"+(""+a).replace(/[=:]/g,function(a){return b[a]})}var O=/\/+/g,P=[];function Q(a,b,d,c){if(P.length){var e=P.pop();e.result=a;e.keyPrefix=b;e.func=d;e.context=c;e.count=0;return e}return{result:a,keyPrefix:b,func:d,context:c,count:0}}
	function R(a){a.result=null;a.keyPrefix=null;a.func=null;a.context=null;a.count=0;10>P.length&&P.push(a)}
	function S(a,b,d,c){var e=typeof a;if("undefined"===e||"boolean"===e)a=null;var g=!1;if(null===a)g=!0;else switch(e){case "string":case "number":g=!0;break;case "object":switch(a.$$typeof){case p:case q:g=!0}}if(g)return d(c,a,""===b?"."+T(a,0):b),1;g=0;b=""===b?".":b+":";if(Array.isArray(a))for(var h=0;h<a.length;h++){e=a[h];var f=b+T(e,h);g+=S(e,f,d,c)}else if(null===a||"object"!==typeof a?f=null:(f=A&&a[A]||a["@@iterator"],f="function"===typeof f?f:null),"function"===typeof f)for(a=f.call(a),h=
	0;!(e=a.next()).done;)e=e.value,f=b+T(e,h++),g+=S(e,f,d,c);else"object"===e&&(d=""+a,B("31","[object Object]"===d?"object with keys {"+Object.keys(a).join(", ")+"}":d,""));return g}function U(a,b,d){return null==a?0:S(a,"",b,d)}function T(a,b){return"object"===typeof a&&null!==a&&null!=a.key?escape(a.key):b.toString(36)}function ea(a,b){a.func.call(a.context,b,a.count++)}
	function fa(a,b,d){var c=a.result,e=a.keyPrefix;a=a.func.call(a.context,b,a.count++);Array.isArray(a)?V(a,c,d,function(a){return a}):null!=a&&(N(a)&&(a=da(a,e+(!a.key||b&&b.key===a.key?"":(""+a.key).replace(O,"$&/")+"/")+d)),c.push(a))}function V(a,b,d,c,e){var g="";null!=d&&(g=(""+d).replace(O,"$&/")+"/");b=Q(b,g,c,e);U(a,fa,b);R(b)}function W(){var a=I.current;null===a?B("307"):void 0;return a}
	var X={Children:{map:function(a,b,d){if(null==a)return a;var c=[];V(a,c,null,b,d);return c},forEach:function(a,b,d){if(null==a)return a;b=Q(null,null,b,d);U(a,ea,b);R(b)},count:function(a){return U(a,function(){return null},null)},toArray:function(a){var b=[];V(a,b,null,function(a){return a});return b},only:function(a){N(a)?void 0:B("143");return a}},createRef:function(){return{current:null}},Component:E,PureComponent:G,createContext:function(a,b){void 0===b&&(b=null);a={$$typeof:w,_calculateChangedBits:b,
	_currentValue:a,_currentValue2:a,_threadCount:0,Provider:null,Consumer:null};a.Provider={$$typeof:v,_context:a};return a.Consumer=a},forwardRef:function(a){return{$$typeof:y,render:a}},lazy:function(a){return{$$typeof:ba,_ctor:a,_status:-1,_result:null}},memo:function(a,b){return{$$typeof:aa,type:a,compare:void 0===b?null:b}},useCallback:function(a,b){return W().useCallback(a,b)},useContext:function(a,b){return W().useContext(a,b)},useEffect:function(a,b){return W().useEffect(a,b)},useImperativeHandle:function(a,
	b,d){return W().useImperativeHandle(a,b,d)},useDebugValue:function(){},useLayoutEffect:function(a,b){return W().useLayoutEffect(a,b)},useMemo:function(a,b){return W().useMemo(a,b)},useReducer:function(a,b,d){return W().useReducer(a,b,d)},useRef:function(a){return W().useRef(a)},useState:function(a){return W().useState(a)},Fragment:r,StrictMode:t,Suspense:z,createElement:M,cloneElement:function(a,b,d){null===a||void 0===a?B("267",a):void 0;var c=void 0,e=k({},a.props),g=a.key,h=a.ref,f=a._owner;if(null!=
	b){void 0!==b.ref&&(h=b.ref,f=J.current);void 0!==b.key&&(g=""+b.key);var l=void 0;a.type&&a.type.defaultProps&&(l=a.type.defaultProps);for(c in b)K.call(b,c)&&!L.hasOwnProperty(c)&&(e[c]=void 0===b[c]&&void 0!==l?l[c]:b[c])}c=arguments.length-2;if(1===c)e.children=d;else if(1<c){l=Array(c);for(var m=0;m<c;m++)l[m]=arguments[m+2];e.children=l}return{$$typeof:p,type:a.type,key:g,ref:h,props:e,_owner:f}},createFactory:function(a){var b=M.bind(null,a);b.type=a;return b},isValidElement:N,version:"16.8.0",
	unstable_ConcurrentMode:x,unstable_Profiler:u,__SECRET_INTERNALS_DO_NOT_USE_OR_YOU_WILL_BE_FIRED:{ReactCurrentDispatcher:I,ReactCurrentOwner:J,assign:k}},Y={default:X},Z=Y&&X||Y;module.exports=Z.default||Z;


/***/ },
/* 598 */
/***/ function(module, exports) {

	"use strict";function isAbsolute(e){return"/"===e.charAt(0)}function spliceOne(e,t){for(var s=t,n=s+1,i=e.length;n<i;s+=1,n+=1)e[s]=e[n];e.pop()}function resolvePathname(e,t){void 0===t&&(t="");var s,n=e&&e.split("/")||[],i=t&&t.split("/")||[],l=e&&isAbsolute(e),r=t&&isAbsolute(t),o=l||r;if(e&&isAbsolute(e)?i=n:n.length&&(i.pop(),i=i.concat(n)),!i.length)return"/";if(i.length){var u=i[i.length-1];s="."===u||".."===u||""===u}else s=!1;for(var a=0,c=i.length;0<=c;c--){var f=i[c];"."===f?spliceOne(i,c):".."===f?(spliceOne(i,c),a++):a&&(spliceOne(i,c),a--)}if(!o)for(;a--;a)i.unshift("..");!o||""===i[0]||i[0]&&isAbsolute(i[0])||i.unshift("");var h=i.join("/");return s&&"/"!==h.substr(-1)&&(h+="/"),h}module.exports=resolvePathname;


/***/ },
/* 599 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(598);
	} else {
	  module.exports = require('./cjs/resolve-pathname.js');
	}


/***/ },
/* 600 */
/***/ function(module, exports) {

	/* WEBPACK VAR INJECTION */(function(global) {/** @license React v0.13.6
	 * scheduler.production.min.js
	 *
	 * Copyright (c) Facebook, Inc. and its affiliates.
	 *
	 * This source code is licensed under the MIT license found in the
	 * LICENSE file in the root directory of this source tree.
	 */
	
	'use strict';Object.defineProperty(exports,"__esModule",{value:!0});var d=null,e=!1,g=3,k=-1,l=-1,m=!1,n=!1;function p(){if(!m){var a=d.expirationTime;n?q():n=!0;r(t,a)}}
	function u(){var a=d,b=d.next;if(d===b)d=null;else{var c=d.previous;d=c.next=b;b.previous=c}a.next=a.previous=null;c=a.callback;b=a.expirationTime;a=a.priorityLevel;var f=g,Q=l;g=a;l=b;try{var h=c()}finally{g=f,l=Q}if("function"===typeof h)if(h={callback:h,priorityLevel:a,expirationTime:b,next:null,previous:null},null===d)d=h.next=h.previous=h;else{c=null;a=d;do{if(a.expirationTime>=b){c=a;break}a=a.next}while(a!==d);null===c?c=d:c===d&&(d=h,p());b=c.previous;b.next=c.previous=h;h.next=c;h.previous=
	b}}function v(){if(-1===k&&null!==d&&1===d.priorityLevel){m=!0;try{do u();while(null!==d&&1===d.priorityLevel)}finally{m=!1,null!==d?p():n=!1}}}function t(a){m=!0;var b=e;e=a;try{if(a)for(;null!==d;){var c=exports.unstable_now();if(d.expirationTime<=c){do u();while(null!==d&&d.expirationTime<=c)}else break}else if(null!==d){do u();while(null!==d&&!w())}}finally{m=!1,e=b,null!==d?p():n=!1,v()}}
	var x=Date,y="function"===typeof setTimeout?setTimeout:void 0,z="function"===typeof clearTimeout?clearTimeout:void 0,A="function"===typeof requestAnimationFrame?requestAnimationFrame:void 0,B="function"===typeof cancelAnimationFrame?cancelAnimationFrame:void 0,C,D;function E(a){C=A(function(b){z(D);a(b)});D=y(function(){B(C);a(exports.unstable_now())},100)}
	if("object"===typeof performance&&"function"===typeof performance.now){var F=performance;exports.unstable_now=function(){return F.now()}}else exports.unstable_now=function(){return x.now()};var r,q,w,G=null;"undefined"!==typeof window?G=window:"undefined"!==typeof global&&(G=global);
	if(G&&G._schedMock){var H=G._schedMock;r=H[0];q=H[1];w=H[2];exports.unstable_now=H[3]}else if("undefined"===typeof window||"function"!==typeof MessageChannel){var I=null,J=function(a){if(null!==I)try{I(a)}finally{I=null}};r=function(a){null!==I?setTimeout(r,0,a):(I=a,setTimeout(J,0,!1))};q=function(){I=null};w=function(){return!1}}else{"undefined"!==typeof console&&("function"!==typeof A&&console.error("This browser doesn't support requestAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"),
	"function"!==typeof B&&console.error("This browser doesn't support cancelAnimationFrame. Make sure that you load a polyfill in older browsers. https://fb.me/react-polyfills"));var K=null,L=!1,M=-1,N=!1,O=!1,P=0,R=33,S=33;w=function(){return P<=exports.unstable_now()};var T=new MessageChannel,U=T.port2;T.port1.onmessage=function(){L=!1;var a=K,b=M;K=null;M=-1;var c=exports.unstable_now(),f=!1;if(0>=P-c)if(-1!==b&&b<=c)f=!0;else{N||(N=!0,E(V));K=a;M=b;return}if(null!==a){O=!0;try{a(f)}finally{O=!1}}};
	var V=function(a){if(null!==K){E(V);var b=a-P+S;b<S&&R<S?(8>b&&(b=8),S=b<R?R:b):R=b;P=a+S;L||(L=!0,U.postMessage(void 0))}else N=!1};r=function(a,b){K=a;M=b;O||0>b?U.postMessage(void 0):N||(N=!0,E(V))};q=function(){K=null;L=!1;M=-1}}exports.unstable_ImmediatePriority=1;exports.unstable_UserBlockingPriority=2;exports.unstable_NormalPriority=3;exports.unstable_IdlePriority=5;exports.unstable_LowPriority=4;
	exports.unstable_runWithPriority=function(a,b){switch(a){case 1:case 2:case 3:case 4:case 5:break;default:a=3}var c=g,f=k;g=a;k=exports.unstable_now();try{return b()}finally{g=c,k=f,v()}};exports.unstable_next=function(a){switch(g){case 1:case 2:case 3:var b=3;break;default:b=g}var c=g,f=k;g=b;k=exports.unstable_now();try{return a()}finally{g=c,k=f,v()}};
	exports.unstable_scheduleCallback=function(a,b){var c=-1!==k?k:exports.unstable_now();if("object"===typeof b&&null!==b&&"number"===typeof b.timeout)b=c+b.timeout;else switch(g){case 1:b=c+-1;break;case 2:b=c+250;break;case 5:b=c+1073741823;break;case 4:b=c+1E4;break;default:b=c+5E3}a={callback:a,priorityLevel:g,expirationTime:b,next:null,previous:null};if(null===d)d=a.next=a.previous=a,p();else{c=null;var f=d;do{if(f.expirationTime>b){c=f;break}f=f.next}while(f!==d);null===c?c=d:c===d&&(d=a,p());
	b=c.previous;b.next=c.previous=a;a.next=c;a.previous=b}return a};exports.unstable_cancelCallback=function(a){var b=a.next;if(null!==b){if(b===a)d=null;else{a===d&&(d=b);var c=a.previous;c.next=b;b.previous=c}a.next=a.previous=null}};exports.unstable_wrapCallback=function(a){var b=g;return function(){var c=g,f=k;g=b;k=exports.unstable_now();try{return a.apply(this,arguments)}finally{g=c,k=f,v()}}};exports.unstable_getCurrentPriorityLevel=function(){return g};
	exports.unstable_shouldYield=function(){return!e&&(null!==d&&d.expirationTime<l||w())};exports.unstable_continueExecution=function(){null!==d&&p()};exports.unstable_pauseExecution=function(){};exports.unstable_getFirstCallbackNode=function(){return d};
	
	/* WEBPACK VAR INJECTION */}.call(exports, (function() { return this; }())))

/***/ },
/* 601 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(600);
	} else {
	  module.exports = require('./cjs/scheduler.development.js');
	}


/***/ },
/* 602 */
/***/ function(module, exports) {

	'use strict';
	module.exports = function (str) {
		return encodeURIComponent(str).replace(/[!'()*]/g, function (c) {
			return '%' + c.charCodeAt(0).toString(16).toUpperCase();
		});
	};


/***/ },
/* 603 */
/***/ function(module, exports) {

	!function(root, name, make) {
	  if (typeof module != 'undefined' && module.exports) module.exports = make()
	  else root[name] = make()
	}(this, 'subtag', function() {
	
	  var empty = ''
	  var pattern = /^([a-zA-Z]{2,3})(?:[_-]+([a-zA-Z]{3})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{4})(?=$|[_-]+))?(?:[_-]+([a-zA-Z]{2}|[0-9]{3})(?=$|[_-]+))?/
	
	  function match(tag) {
	    return tag.match(pattern) || []
	  }
	
	  function split(tag) {
	    return match(tag).filter(function(v, i) { return v && i })
	  }
	
	  function api(tag) {
	    tag = match(tag)
	    return {
	      language: tag[1] || empty,
	      extlang: tag[2] || empty,
	      script: tag[3] || empty,
	      region: tag[4] || empty
	    }
	  }
	
	  function expose(target, key, value) {
	    Object.defineProperty(target, key, {
	      value: value,
	      enumerable: true
	    })
	  }
	
	  function part(position, pattern, type) {
	    function method(tag) {
	      return match(tag)[position] || empty
	    }
	    expose(method, 'pattern', pattern)
	    expose(api, type, method)
	  }
	
	  part(1, /^[a-zA-Z]{2,3}$/, 'language')
	  part(2, /^[a-zA-Z]{3}$/, 'extlang')
	  part(3, /^[a-zA-Z]{4}$/, 'script')
	  part(4, /^[a-zA-Z]{2}$|^[0-9]{3}$/, 'region')
	
	  expose(api, 'split', split)
	
	  return api
	});


/***/ },
/* 604 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	/**
	 * A typeahead component for inputs
	 * @class Suggestions
	 *
	 * @param {HTMLInputElement} el A valid HTML input element
	 * @param {Array} data An array of data used for results
	 * @param {Object} options
	 * @param {Number} [options.limit=5] Max number of results to display in the auto suggest list.
	 * @param {Number} [options.minLength=2] Number of characters typed into an input to trigger suggestions.
	 * @param {Boolean} [options.hideOnBlur=true] If `true`, hides the suggestions when focus is lost.
	 * @return {Suggestions} `this`
	 * @example
	 * // in the browser
	 * var input = document.querySelector('input');
	 * var data = [
	 *   'Roy Eldridge',
	 *   'Roy Hargrove',
	 *   'Rex Stewart'
	 * ];
	 *
	 * new Suggestions(input, data);
	 *
	 * // with options
	 * var input = document.querySelector('input');
	 * var data = [{
	 *   name: 'Roy Eldridge',
	 *   year: 1911
	 * }, {
	 *   name: 'Roy Hargrove',
	 *   year: 1969
	 * }, {
	 *   name: 'Rex Stewart',
	 *   year: 1907
	 * }];
	 *
	 * var typeahead = new Suggestions(input, data, {
	 *   filter: false, // Disable filtering
	 *   minLength: 3, // Number of characters typed into an input to trigger suggestions.
	 *   limit: 3, //  Max number of results to display.
	 *   hideOnBlur: false // Don't hide results when input loses focus
	 * });
	 *
	 * // As we're passing an object of an arrays as data, override
	 * // `getItemValue` by specifying the specific property to search on.
	 * typeahead.getItemValue = function(item) { return item.name };
	 *
	 * input.addEventListener('change', function() {
	 *   console.log(typeahead.selected); // Current selected item.
	 * });
	 *
	 * // With browserify
	 * var Suggestions = require('suggestions');
	 *
	 * new Suggestions(input, data);
	 */
	var Suggestions = __webpack_require__(606);
	window.Suggestions = module.exports = Suggestions;


/***/ },
/* 605 */
/***/ function(module, exports) {

	'use strict';
	
	var List = function(component) {
	  this.component = component;
	  this.items = [];
	  this.active = 0;
	  this.wrapper = document.createElement('div');
	  this.wrapper.className = 'suggestions-wrapper';
	  this.element = document.createElement('ul');
	  this.element.className = 'suggestions';
	  this.wrapper.appendChild(this.element);
	
	  // selectingListItem is set to true in the time between the mousedown and mouseup when clicking an item in the list
	  // mousedown on a list item will cause the input to blur which normally hides the list, so this flag is used to keep
	  // the list open until the mouseup
	  this.selectingListItem = false;
	
	  component.el.parentNode.insertBefore(this.wrapper, component.el.nextSibling);
	  return this;
	};
	
	List.prototype.show = function() {
	  this.element.style.display = 'block';
	};
	
	List.prototype.hide = function() {
	  this.element.style.display = 'none';
	};
	
	List.prototype.add = function(item) {
	  this.items.push(item);
	};
	
	List.prototype.clear = function() {
	  this.items = [];
	  this.active = 0;
	};
	
	List.prototype.isEmpty = function() {
	  return !this.items.length;
	};
	
	List.prototype.isVisible = function() {
	  return this.element.style.display === 'block';
	};
	
	List.prototype.draw = function() {
	  this.element.innerHTML = '';
	
	  if (this.items.length === 0) {
	    this.hide();
	    return;
	  }
	
	  for (var i = 0; i < this.items.length; i++) {
	    this.drawItem(this.items[i], this.active === i);
	  }
	
	  this.show();
	};
	
	List.prototype.drawItem = function(item, active) {
	  var li = document.createElement('li'),
	    a = document.createElement('a');
	
	  if (active) li.className += ' active';
	
	  a.innerHTML = item.string;
	
	  li.appendChild(a);
	  this.element.appendChild(li);
	
	  li.addEventListener('mousedown', function() {
	    this.selectingListItem = true;
	  }.bind(this));
	
	  li.addEventListener('mouseup', function() {
	    this.handleMouseUp.call(this, item);
	  }.bind(this));
	};
	
	List.prototype.handleMouseUp = function(item) {
	  this.selectingListItem = false;
	  this.component.value(item.original);
	  this.clear();
	  this.draw();
	};
	
	List.prototype.move = function(index) {
	  this.active = index;
	  this.draw();
	};
	
	List.prototype.previous = function() {
	  this.move(this.active === 0 ? this.items.length - 1 : this.active - 1);
	};
	
	List.prototype.next = function() {
	  this.move(this.active === this.items.length - 1 ? 0 : this.active + 1);
	};
	
	List.prototype.drawError = function(msg){
	  var li = document.createElement('li');
	
	  li.innerHTML = msg;
	
	  this.element.appendChild(li);
	  this.show();
	}
	
	module.exports = List;


/***/ },
/* 606 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	var extend = __webpack_require__(47);
	var fuzzy = __webpack_require__(523);
	var List = __webpack_require__(605);
	
	var Suggestions = function(el, data, options) {
	  options = options || {};
	
	  this.options = extend({
	    minLength: 2,
	    limit: 5,
	    filter: true,
	    hideOnBlur: true
	  }, options);
	
	  this.el = el;
	  this.data = data || [];
	  this.list = new List(this);
	
	  this.query = '';
	  this.selected = null;
	
	  this.list.draw();
	
	  this.el.addEventListener('keyup', function(e) {
	    this.handleKeyUp(e.keyCode);
	  }.bind(this), false);
	
	  this.el.addEventListener('keydown', function(e) {
	    this.handleKeyDown(e);
	  }.bind(this));
	
	  this.el.addEventListener('focus', function() {
	    this.handleFocus();
	  }.bind(this));
	
	  this.el.addEventListener('blur', function() {
	    this.handleBlur();
	  }.bind(this));
	
	  this.el.addEventListener('paste', function(e) {
	    this.handlePaste(e);
	  }.bind(this));
	
	  // use user-provided render function if given, otherwise just use the default
	  this.render = (this.options.render) ? this.options.render.bind(this) : this.render.bind(this)
	
	  this.getItemValue = (this.options.getItemValue) ? this.options.getItemValue.bind(this) : this.getItemValue.bind(this);
	
	  return this;
	};
	
	Suggestions.prototype.handleKeyUp = function(keyCode) {
	  // 40 - DOWN
	  // 38 - UP
	  // 27 - ESC
	  // 13 - ENTER
	  // 9 - TAB
	
	  if (keyCode === 40 ||
	      keyCode === 38 ||
	      keyCode === 27 ||
	      keyCode === 13 ||
	      keyCode === 9) return;
	
	  this.handleInputChange(this.el.value);
	};
	
	Suggestions.prototype.handleKeyDown = function(e) {
	  switch (e.keyCode) {
	    case 13: // ENTER
	    case 9: // TAB
	      if (!this.list.isEmpty()) {
	        if (this.list.isVisible()) {
	          e.preventDefault();
	        }
	        this.value(this.list.items[this.list.active].original);
	        this.list.hide();
	      }
	    break;
	    case 27: // ESC
	      if (!this.list.isEmpty()) this.list.hide();
	    break;
	    case 38: // UP
	      this.list.previous();
	    break;
	    case 40: // DOWN
	      this.list.next();
	    break;
	  }
	};
	
	Suggestions.prototype.handleBlur = function() {
	  if (!this.list.selectingListItem && this.options.hideOnBlur) {
	    this.list.hide();
	  }
	};
	
	Suggestions.prototype.handlePaste = function(e) {
	  if (e.clipboardData) {
	    this.handleInputChange(e.clipboardData.getData('Text'));
	  } else {
	    var self = this;
	    setTimeout(function () {
	      self.handleInputChange(e.target.value);
	    }, 100);
	  }
	};
	
	Suggestions.prototype.handleInputChange = function(query) {
	  this.query = this.normalize(query);
	
	  this.list.clear();
	
	  if (this.query.length < this.options.minLength) {
	    this.list.draw();
	    return;
	  }
	
	  this.getCandidates(function(data) {
	    for (var i = 0; i < data.length; i++) {
	      this.list.add(data[i]);
	      if (i === (this.options.limit - 1)) break;
	    }
	    this.list.draw();
	  }.bind(this));
	};
	
	Suggestions.prototype.handleFocus = function() {
	  if (!this.list.isEmpty()) this.list.show();
	  this.list.selectingListItem = false;
	};
	
	/**
	 * Update data previously passed
	 *
	 * @param {Array} revisedData
	 */
	Suggestions.prototype.update = function(revisedData) {
	  this.data = revisedData;
	  this.handleKeyUp();
	};
	
	/**
	 * Clears data
	 */
	Suggestions.prototype.clear = function() {
	  this.data = [];
	  this.list.clear();
	};
	
	/**
	 * Normalize the results list and input value for matching
	 *
	 * @param {String} value
	 * @return {String}
	 */
	Suggestions.prototype.normalize = function(value) {
	  value = value.toLowerCase();
	  return value;
	};
	
	/**
	 * Evaluates whether an array item qualifies as a match with the current query
	 *
	 * @param {String} candidate a possible item from the array passed
	 * @param {String} query the current query
	 * @return {Boolean}
	 */
	Suggestions.prototype.match = function(candidate, query) {
	  return candidate.indexOf(query) > -1;
	};
	
	Suggestions.prototype.value = function(value) {
	  this.selected = value;
	  this.el.value = this.getItemValue(value);
	
	  if (document.createEvent) {
	    var e = document.createEvent('HTMLEvents');
	    e.initEvent('change', true, false);
	    this.el.dispatchEvent(e);
	  } else {
	    this.el.fireEvent('onchange');
	  }
	};
	
	Suggestions.prototype.getCandidates = function(callback) {
	  var options = {
	    pre: '<strong>',
	    post: '</strong>',
	    extract: function(d) { return this.getItemValue(d); }.bind(this)
	  };
	  var results;
	  if(this.options.filter){
	    results = fuzzy.filter(this.query, this.data, options);
	
	    results = results.map(function(item){
	      return {
	        original: item.original,
	        string: this.render(item.original, item.string)
	      };
	    }.bind(this))
	  }else{
	    results = this.data.map(function(d) {
	      var renderedString = this.render(d);
	      return {
	        original: d,
	        string: renderedString
	      };
	    }.bind(this));
	  }
	  callback(results);
	};
	
	/**
	 * For a given item in the data array, return what should be used as the candidate string
	 *
	 * @param {Object|String} item an item from the data array
	 * @return {String} item
	 */
	Suggestions.prototype.getItemValue = function(item) {
	  return item;
	};
	
	/**
	 * For a given item in the data array, return a string of html that should be rendered in the dropdown
	 * @param {Object|String} item an item from the data array
	 * @param {String} sourceFormatting a string that has pre-formatted html that should be passed directly through the render function 
	 * @return {String} html
	 */
	Suggestions.prototype.render = function(item, sourceFormatting) {
	  if (sourceFormatting){
	    // use existing formatting on the source string
	    return sourceFormatting;
	  }
	  var boldString = (item.original) ? this.getItemValue(item.original) : this.getItemValue(item);
	  var indexString = this.normalize(boldString);
	  var indexOfQuery = indexString.lastIndexOf(this.query);
	  while (indexOfQuery > -1) {
	    var endIndexOfQuery = indexOfQuery + this.query.length;
	    boldString = boldString.slice(0, indexOfQuery) + '<strong>' + boldString.slice(indexOfQuery, endIndexOfQuery) + '</strong>' + boldString.slice(endIndexOfQuery);
	    indexOfQuery = indexString.slice(0, indexOfQuery).lastIndexOf(this.query);
	  }
	  return boldString
	}
	
	/**
	 * Render an custom error message in the suggestions list
	 * @param {String} msg An html string to render as an error message
	 */
	Suggestions.prototype.renderError = function(msg){
	  this.list.drawError(msg);
	}
	
	module.exports = Suggestions;


/***/ },
/* 607 */
/***/ function(module, exports) {

	"use strict";function valueOf(e){return e.valueOf?e.valueOf():Object.prototype.valueOf.call(e)}function valueEqual(u,r){if(u===r)return!0;if(null==u||null==r)return!1;if(Array.isArray(u))return Array.isArray(r)&&u.length===r.length&&u.every(function(e,u){return valueEqual(e,r[u])});if("object"!=typeof u&&"object"!=typeof r)return!1;var e=valueOf(u),t=valueOf(r);return e!==u||t!==r?valueEqual(e,t):Object.keys(Object.assign({},u,r)).every(function(e){return valueEqual(u[e],r[e])})}module.exports=valueEqual;


/***/ },
/* 608 */
/***/ function(module, exports, __webpack_require__) {

	'use strict';
	
	if (true) {
	  module.exports = __webpack_require__(607);
	} else {
	  module.exports = require('./cjs/value-equal.js');
	}


/***/ }
/******/ ])));


/** WEBPACK FOOTER **
 ** static/js/main.4c26302f.js
 **/